
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09c7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09c7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("aRPiL", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;

});
parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});





parcelRegister("7pm8w", function(module, exports) {

!function(e, o) {
    module.exports = o((parcelRequire("gngdn")));
}(module.exports, function(e) {
    "use strict";
    function o(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var s = o(e), d = {
        name: "es",
        monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
        weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split("_"),
        weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split("_"),
        weekdaysMin: "do_lu_ma_mi_ju_vi_s\xe1".split("_"),
        months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
        weekStart: 1,
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "DD/MM/YYYY",
            LL: "D [de] MMMM [de] YYYY",
            LLL: "D [de] MMMM [de] YYYY H:mm",
            LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
        },
        relativeTime: {
            future: "en %s",
            past: "hace %s",
            s: "unos segundos",
            m: "un minuto",
            mm: "%d minutos",
            h: "una hora",
            hh: "%d horas",
            d: "un d\xeda",
            dd: "%d d\xedas",
            M: "un mes",
            MM: "%d meses",
            y: "un a\xf1o",
            yy: "%d a\xf1os"
        },
        ordinal: function(e) {
            return e + "\xba";
        }
    };
    return s.default.locale(d, null, !0), d;
});

});
parcelRegister("gngdn", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});


parcelRegister("crMIh", function(module, exports) {

$parcel$export(module.exports, "ActionIcon", () => $90fdcb146fd59d2e$export$c8e5c1392561c508);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $hQ3KV = parcelRequire("hQ3KV");

var $4P91H = parcelRequire("4P91H");

var $5etRf = parcelRequire("5etRf");
var $90fdcb146fd59d2e$var$__defProp = Object.defineProperty;
var $90fdcb146fd59d2e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $90fdcb146fd59d2e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $90fdcb146fd59d2e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $90fdcb146fd59d2e$var$__defNormalProp = (obj, key, value)=>key in obj ? $90fdcb146fd59d2e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $90fdcb146fd59d2e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($90fdcb146fd59d2e$var$__hasOwnProp.call(b, prop)) $90fdcb146fd59d2e$var$__defNormalProp(a, prop, b[prop]);
    if ($90fdcb146fd59d2e$var$__getOwnPropSymbols) {
        for (var prop of $90fdcb146fd59d2e$var$__getOwnPropSymbols(b))if ($90fdcb146fd59d2e$var$__propIsEnum.call(b, prop)) $90fdcb146fd59d2e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $90fdcb146fd59d2e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($90fdcb146fd59d2e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $90fdcb146fd59d2e$var$__getOwnPropSymbols) {
        for (var prop of $90fdcb146fd59d2e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $90fdcb146fd59d2e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $90fdcb146fd59d2e$var$defaultProps = {
    color: "gray",
    size: "md",
    variant: "subtle"
};
const $90fdcb146fd59d2e$export$65a24a4efcf43be9 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("ActionIcon", $90fdcb146fd59d2e$var$defaultProps, props), { className: className, color: color, children: children, radius: radius, size: size, variant: variant, gradient: gradient, disabled: disabled, loaderProps: loaderProps, loading: loading, unstyled: unstyled, __staticSelector: __staticSelector } = _a, others = $90fdcb146fd59d2e$var$__objRest(_a, [
        "className",
        "color",
        "children",
        "radius",
        "size",
        "variant",
        "gradient",
        "disabled",
        "loaderProps",
        "loading",
        "unstyled",
        "__staticSelector"
    ]);
    const { classes: classes, cx: cx, theme: theme } = (0, $hQ3KV.default)({
        radius: radius,
        color: color,
        gradient: gradient
    }, {
        name: [
            "ActionIcon",
            __staticSelector
        ],
        unstyled: unstyled,
        size: size,
        variant: variant
    });
    const loader = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4P91H.Loader), $90fdcb146fd59d2e$var$__spreadValues({
        color: theme.fn.variant({
            color: color,
            variant: variant
        }).color,
        size: "100%",
        "data-action-icon-loader": true
    }, loaderProps));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $90fdcb146fd59d2e$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref,
        disabled: disabled,
        "data-disabled": disabled || void 0,
        "data-loading": loading || void 0,
        unstyled: unstyled
    }, others), loading ? loader : children);
});
$90fdcb146fd59d2e$export$65a24a4efcf43be9.displayName = "@mantine/core/ActionIcon";
const $90fdcb146fd59d2e$export$c8e5c1392561c508 = (0, $1euea.createPolymorphicComponent)($90fdcb146fd59d2e$export$65a24a4efcf43be9);

});
parcelRegister("64A2P", function(module, exports) {

$parcel$export(module.exports, "useMantineTheme", () => $46bf1383c29fbd71$export$5eb0e84f6418b457);
$parcel$export(module.exports, "useMantineProviderStyles", () => $46bf1383c29fbd71$export$a18852c6a3cd46d3);
$parcel$export(module.exports, "useMantineEmotionCache", () => $46bf1383c29fbd71$export$d47e723e301bc931);
$parcel$export(module.exports, "useComponentDefaultProps", () => $46bf1383c29fbd71$export$7eb0f0123386d23c);
$parcel$export(module.exports, "MantineProvider", () => $46bf1383c29fbd71$export$2ec8a50af9fc9ed7);

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $6lKBZ = parcelRequire("6lKBZ");

var $cbOT3 = parcelRequire("cbOT3");

var $dcLjc = parcelRequire("dcLjc");

var $eRTMZ = parcelRequire("eRTMZ");

var $4oGla = parcelRequire("4oGla");

var $l86pR = parcelRequire("l86pR");
var $46bf1383c29fbd71$var$__defProp = Object.defineProperty;
var $46bf1383c29fbd71$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $46bf1383c29fbd71$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $46bf1383c29fbd71$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $46bf1383c29fbd71$var$__defNormalProp = (obj, key, value)=>key in obj ? $46bf1383c29fbd71$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $46bf1383c29fbd71$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($46bf1383c29fbd71$var$__hasOwnProp.call(b, prop)) $46bf1383c29fbd71$var$__defNormalProp(a, prop, b[prop]);
    if ($46bf1383c29fbd71$var$__getOwnPropSymbols) {
        for (var prop of $46bf1383c29fbd71$var$__getOwnPropSymbols(b))if ($46bf1383c29fbd71$var$__propIsEnum.call(b, prop)) $46bf1383c29fbd71$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
const $46bf1383c29fbd71$var$MantineProviderContext = (0, $acw62.createContext)({
    theme: (0, $6lKBZ.DEFAULT_THEME)
});
function $46bf1383c29fbd71$export$5eb0e84f6418b457() {
    var _a;
    return ((_a = (0, $acw62.useContext)($46bf1383c29fbd71$var$MantineProviderContext)) == null ? void 0 : _a.theme) || (0, $6lKBZ.DEFAULT_THEME);
}
function $46bf1383c29fbd71$export$a18852c6a3cd46d3(component) {
    const theme = $46bf1383c29fbd71$export$5eb0e84f6418b457();
    const getStyles = (name)=>{
        var _a, _b, _c, _d;
        return {
            styles: ((_a = theme.components[name]) == null ? void 0 : _a.styles) || {},
            classNames: ((_b = theme.components[name]) == null ? void 0 : _b.classNames) || {},
            variants: (_c = theme.components[name]) == null ? void 0 : _c.variants,
            sizes: (_d = theme.components[name]) == null ? void 0 : _d.sizes
        };
    };
    if (Array.isArray(component)) return component.map(getStyles);
    return [
        getStyles(component)
    ];
}
function $46bf1383c29fbd71$export$d47e723e301bc931() {
    var _a;
    return (_a = (0, $acw62.useContext)($46bf1383c29fbd71$var$MantineProviderContext)) == null ? void 0 : _a.emotionCache;
}
function $46bf1383c29fbd71$export$7eb0f0123386d23c(component, defaultProps, props) {
    var _a;
    const theme = $46bf1383c29fbd71$export$5eb0e84f6418b457();
    const contextPropsPayload = (_a = theme.components[component]) == null ? void 0 : _a.defaultProps;
    const contextProps = typeof contextPropsPayload === "function" ? contextPropsPayload(theme) : contextPropsPayload;
    return $46bf1383c29fbd71$var$__spreadValues($46bf1383c29fbd71$var$__spreadValues($46bf1383c29fbd71$var$__spreadValues({}, defaultProps), contextProps), (0, $4oGla.filterProps)(props));
}
function $46bf1383c29fbd71$export$2ec8a50af9fc9ed7({ theme: theme, emotionCache: emotionCache, withNormalizeCSS: withNormalizeCSS = false, withGlobalStyles: withGlobalStyles = false, withCSSVariables: withCSSVariables = false, inherit: inherit = false, children: children }) {
    const ctx = (0, $acw62.useContext)($46bf1383c29fbd71$var$MantineProviderContext);
    const mergedTheme = (0, $eRTMZ.mergeThemeWithFunctions)((0, $6lKBZ.DEFAULT_THEME), inherit ? $46bf1383c29fbd71$var$__spreadValues($46bf1383c29fbd71$var$__spreadValues({}, ctx.theme), theme) : theme);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eP9YU.b), {
        theme: mergedTheme
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($46bf1383c29fbd71$var$MantineProviderContext.Provider, {
        value: {
            theme: mergedTheme,
            emotionCache: emotionCache
        }
    }, withNormalizeCSS && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $l86pR.NormalizeCSS), null), withGlobalStyles && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cbOT3.GlobalStyles), {
        theme: mergedTheme
    }), withCSSVariables && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dcLjc.MantineCssVariables), {
        theme: mergedTheme
    }), typeof mergedTheme.globalStyles === "function" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jjlaj.Global), {
        styles: mergedTheme.globalStyles(mergedTheme)
    }), children));
}
$46bf1383c29fbd71$export$2ec8a50af9fc9ed7.displayName = "@mantine/core/MantineProvider";

});
parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "b", () => $acad92301ef10c3f$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9cCWX"));

});
parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
'use strict';
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6lKBZ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_THEME", () => $49f8dc569ddf9345$export$2faeed762aac6741);

var $jI72R = parcelRequire("jI72R");

var $aq0ZL = parcelRequire("aq0ZL");
const $49f8dc569ddf9345$export$9d4e207e6375f48b = Object.keys((0, $jI72R.DEFAULT_COLORS));
const $49f8dc569ddf9345$export$af176d38ab8bea85 = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $49f8dc569ddf9345$export$202d2011536f1f45 = {
    dir: "ltr",
    primaryShade: {
        light: 6,
        dark: 8
    },
    focusRing: "auto",
    loader: "oval",
    colorScheme: "light",
    white: "#fff",
    black: "#000",
    defaultRadius: "sm",
    transitionTimingFunction: "ease",
    colors: (0, $jI72R.DEFAULT_COLORS),
    lineHeight: 1.55,
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
    fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
    primaryColor: "blue",
    respectReducedMotion: true,
    cursorType: "default",
    defaultGradient: {
        from: "indigo",
        to: "cyan",
        deg: 45
    },
    shadows: {
        xs: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.1)",
        sm: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 0.625rem 0.9375rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 0.4375rem 0.4375rem -0.3125rem",
        md: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.25rem 1.5625rem -0.3125rem, rgba(0, 0, 0, 0.04) 0 0.625rem 0.625rem -0.3125rem",
        lg: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 1.75rem 1.4375rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 0.75rem 0.75rem -0.4375rem",
        xl: "0 0.0625rem 0.1875rem rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 2.25rem 1.75rem -0.4375rem, rgba(0, 0, 0, 0.04) 0 1.0625rem 1.0625rem -0.4375rem"
    },
    fontSizes: {
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem"
    },
    radius: {
        xs: "0.125rem",
        sm: "0.25rem",
        md: "0.5rem",
        lg: "1rem",
        xl: "2rem"
    },
    spacing: {
        xs: "0.625rem",
        sm: "0.75rem",
        md: "1rem",
        lg: "1.25rem",
        xl: "1.5rem"
    },
    breakpoints: {
        xs: "36em",
        sm: "48em",
        md: "62em",
        lg: "75em",
        xl: "88em"
    },
    headings: {
        fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji",
        fontWeight: 700,
        sizes: {
            h1: {
                fontSize: "2.125rem",
                lineHeight: 1.3,
                fontWeight: void 0
            },
            h2: {
                fontSize: "1.625rem",
                lineHeight: 1.35,
                fontWeight: void 0
            },
            h3: {
                fontSize: "1.375rem",
                lineHeight: 1.4,
                fontWeight: void 0
            },
            h4: {
                fontSize: "1.125rem",
                lineHeight: 1.45,
                fontWeight: void 0
            },
            h5: {
                fontSize: "1rem",
                lineHeight: 1.5,
                fontWeight: void 0
            },
            h6: {
                fontSize: "0.875rem",
                lineHeight: 1.5,
                fontWeight: void 0
            }
        }
    },
    other: {},
    components: {},
    activeStyles: {
        transform: "translateY(0.0625rem)"
    },
    datesLocale: "en",
    globalStyles: void 0,
    focusRingStyles: {
        styles: (theme)=>({
                outlineOffset: "0.125rem",
                outline: `0.125rem solid ${theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 7 : 5]}`
            }),
        resetStyles: ()=>({
                outline: "none"
            }),
        inputStyles: (theme)=>({
                outline: "none",
                borderColor: theme.colors[theme.primaryColor][typeof theme.primaryShade === "object" ? theme.primaryShade[theme.colorScheme] : theme.primaryShade]
            })
    }
};
const $49f8dc569ddf9345$export$2faeed762aac6741 = (0, $aq0ZL.attachFunctions)($49f8dc569ddf9345$export$202d2011536f1f45);

});
parcelRegister("jI72R", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_COLORS", () => $e5979765dc342117$export$e60cfe038231c681);
const $e5979765dc342117$export$e60cfe038231c681 = {
    dark: [
        "#C1C2C5",
        "#A6A7AB",
        "#909296",
        "#5c5f66",
        "#373A40",
        "#2C2E33",
        "#25262b",
        "#1A1B1E",
        "#141517",
        "#101113"
    ],
    gray: [
        "#f8f9fa",
        "#f1f3f5",
        "#e9ecef",
        "#dee2e6",
        "#ced4da",
        "#adb5bd",
        "#868e96",
        "#495057",
        "#343a40",
        "#212529"
    ],
    red: [
        "#fff5f5",
        "#ffe3e3",
        "#ffc9c9",
        "#ffa8a8",
        "#ff8787",
        "#ff6b6b",
        "#fa5252",
        "#f03e3e",
        "#e03131",
        "#c92a2a"
    ],
    pink: [
        "#fff0f6",
        "#ffdeeb",
        "#fcc2d7",
        "#faa2c1",
        "#f783ac",
        "#f06595",
        "#e64980",
        "#d6336c",
        "#c2255c",
        "#a61e4d"
    ],
    grape: [
        "#f8f0fc",
        "#f3d9fa",
        "#eebefa",
        "#e599f7",
        "#da77f2",
        "#cc5de8",
        "#be4bdb",
        "#ae3ec9",
        "#9c36b5",
        "#862e9c"
    ],
    violet: [
        "#f3f0ff",
        "#e5dbff",
        "#d0bfff",
        "#b197fc",
        "#9775fa",
        "#845ef7",
        "#7950f2",
        "#7048e8",
        "#6741d9",
        "#5f3dc4"
    ],
    indigo: [
        "#edf2ff",
        "#dbe4ff",
        "#bac8ff",
        "#91a7ff",
        "#748ffc",
        "#5c7cfa",
        "#4c6ef5",
        "#4263eb",
        "#3b5bdb",
        "#364fc7"
    ],
    blue: [
        "#e7f5ff",
        "#d0ebff",
        "#a5d8ff",
        "#74c0fc",
        "#4dabf7",
        "#339af0",
        "#228be6",
        "#1c7ed6",
        "#1971c2",
        "#1864ab"
    ],
    cyan: [
        "#e3fafc",
        "#c5f6fa",
        "#99e9f2",
        "#66d9e8",
        "#3bc9db",
        "#22b8cf",
        "#15aabf",
        "#1098ad",
        "#0c8599",
        "#0b7285"
    ],
    teal: [
        "#e6fcf5",
        "#c3fae8",
        "#96f2d7",
        "#63e6be",
        "#38d9a9",
        "#20c997",
        "#12b886",
        "#0ca678",
        "#099268",
        "#087f5b"
    ],
    green: [
        "#ebfbee",
        "#d3f9d8",
        "#b2f2bb",
        "#8ce99a",
        "#69db7c",
        "#51cf66",
        "#40c057",
        "#37b24d",
        "#2f9e44",
        "#2b8a3e"
    ],
    lime: [
        "#f4fce3",
        "#e9fac8",
        "#d8f5a2",
        "#c0eb75",
        "#a9e34b",
        "#94d82d",
        "#82c91e",
        "#74b816",
        "#66a80f",
        "#5c940d"
    ],
    yellow: [
        "#fff9db",
        "#fff3bf",
        "#ffec99",
        "#ffe066",
        "#ffd43b",
        "#fcc419",
        "#fab005",
        "#f59f00",
        "#f08c00",
        "#e67700"
    ],
    orange: [
        "#fff4e6",
        "#ffe8cc",
        "#ffd8a8",
        "#ffc078",
        "#ffa94d",
        "#ff922b",
        "#fd7e14",
        "#f76707",
        "#e8590c",
        "#d9480f"
    ]
};

});

parcelRegister("aq0ZL", function(module, exports) {

$parcel$export(module.exports, "attachFunctions", () => $795d1ab3cb8f8beb$export$77b4cb0e361839f0);

var $gReiS = parcelRequire("gReiS");
var $795d1ab3cb8f8beb$var$__defProp = Object.defineProperty;
var $795d1ab3cb8f8beb$var$__defProps = Object.defineProperties;
var $795d1ab3cb8f8beb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $795d1ab3cb8f8beb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $795d1ab3cb8f8beb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $795d1ab3cb8f8beb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $795d1ab3cb8f8beb$var$__defNormalProp = (obj, key, value)=>key in obj ? $795d1ab3cb8f8beb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $795d1ab3cb8f8beb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($795d1ab3cb8f8beb$var$__hasOwnProp.call(b, prop)) $795d1ab3cb8f8beb$var$__defNormalProp(a, prop, b[prop]);
    if ($795d1ab3cb8f8beb$var$__getOwnPropSymbols) {
        for (var prop of $795d1ab3cb8f8beb$var$__getOwnPropSymbols(b))if ($795d1ab3cb8f8beb$var$__propIsEnum.call(b, prop)) $795d1ab3cb8f8beb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $795d1ab3cb8f8beb$var$__spreadProps = (a, b)=>$795d1ab3cb8f8beb$var$__defProps(a, $795d1ab3cb8f8beb$var$__getOwnPropDescs(b));
function $795d1ab3cb8f8beb$export$77b4cb0e361839f0(themeBase) {
    return $795d1ab3cb8f8beb$var$__spreadProps($795d1ab3cb8f8beb$var$__spreadValues({}, themeBase), {
        fn: {
            fontStyles: (0, $gReiS.fns).fontStyles(themeBase),
            themeColor: (0, $gReiS.fns).themeColor(themeBase),
            focusStyles: (0, $gReiS.fns).focusStyles(themeBase),
            largerThan: (0, $gReiS.fns).largerThan(themeBase),
            smallerThan: (0, $gReiS.fns).smallerThan(themeBase),
            radialGradient: (0, $gReiS.fns).radialGradient,
            linearGradient: (0, $gReiS.fns).linearGradient,
            gradient: (0, $gReiS.fns).gradient(themeBase),
            rgba: (0, $gReiS.fns).rgba,
            cover: (0, $gReiS.fns).cover,
            lighten: (0, $gReiS.fns).lighten,
            darken: (0, $gReiS.fns).darken,
            primaryShade: (0, $gReiS.fns).primaryShade(themeBase),
            radius: (0, $gReiS.fns).radius(themeBase),
            variant: (0, $gReiS.fns).variant(themeBase),
            hover: (0, $gReiS.fns).hover,
            primaryColor: (0, $gReiS.fns).primaryColor(themeBase),
            placeholderStyles: (0, $gReiS.fns).placeholderStyles(themeBase),
            dimmed: (0, $gReiS.fns).dimmed(themeBase)
        }
    });
}

});
parcelRegister("gReiS", function(module, exports) {

$parcel$export(module.exports, "fns", () => $c45cb0f171832a4a$export$77252eb1c5433404);

var $2H1gh = parcelRequire("2H1gh");

var $1jELM = parcelRequire("1jELM");

var $8Il9o = parcelRequire("8Il9o");

var $5Hy85 = parcelRequire("5Hy85");

var $2vpKc = parcelRequire("2vpKc");

var $fYRXt = parcelRequire("fYRXt");

var $2WoLx = parcelRequire("2WoLx");

var $2WXwR = parcelRequire("2WXwR");

var $1g8T5 = parcelRequire("1g8T5");

var $944i3 = parcelRequire("944i3");

var $7DY6Z = parcelRequire("7DY6Z");

var $hw6IJ = parcelRequire("hw6IJ");

var $eMFWp = parcelRequire("eMFWp");

var $52XK0 = parcelRequire("52XK0");

var $ji3cY = parcelRequire("ji3cY");

var $5Yq3g = parcelRequire("5Yq3g");
const $c45cb0f171832a4a$export$77252eb1c5433404 = {
    fontStyles: $2H1gh.fontStyles,
    themeColor: $8Il9o.themeColor,
    focusStyles: $1jELM.focusStyles,
    linearGradient: $5Hy85.linearGradient,
    radialGradient: $5Hy85.radialGradient,
    smallerThan: $2vpKc.smallerThan,
    largerThan: $2vpKc.largerThan,
    rgba: $fYRXt.rgba,
    cover: $2WoLx.cover,
    darken: $2WXwR.darken,
    lighten: $1g8T5.lighten,
    radius: $944i3.radius,
    variant: $7DY6Z.variant,
    primaryShade: $hw6IJ.primaryShade,
    hover: $52XK0.hover,
    gradient: $5Hy85.gradient,
    primaryColor: $eMFWp.primaryColor,
    placeholderStyles: $ji3cY.placeholderStyles,
    dimmed: $5Yq3g.dimmed
};

});
parcelRegister("2H1gh", function(module, exports) {

$parcel$export(module.exports, "fontStyles", () => $1f60936d96843f50$export$65272bfcddf8822d);
function $1f60936d96843f50$export$65272bfcddf8822d(theme) {
    return ()=>({
            fontFamily: theme.fontFamily || "sans-serif"
        });
}

});

parcelRegister("1jELM", function(module, exports) {

$parcel$export(module.exports, "focusStyles", () => $0f5730ce3efc1090$export$8046cac2aef20cd7);
var $0f5730ce3efc1090$var$__defProp = Object.defineProperty;
var $0f5730ce3efc1090$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0f5730ce3efc1090$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0f5730ce3efc1090$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0f5730ce3efc1090$var$__defNormalProp = (obj, key, value)=>key in obj ? $0f5730ce3efc1090$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0f5730ce3efc1090$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0f5730ce3efc1090$var$__hasOwnProp.call(b, prop)) $0f5730ce3efc1090$var$__defNormalProp(a, prop, b[prop]);
    if ($0f5730ce3efc1090$var$__getOwnPropSymbols) {
        for (var prop of $0f5730ce3efc1090$var$__getOwnPropSymbols(b))if ($0f5730ce3efc1090$var$__propIsEnum.call(b, prop)) $0f5730ce3efc1090$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $0f5730ce3efc1090$export$8046cac2aef20cd7(theme) {
    return (selector)=>({
            WebkitTapHighlightColor: "transparent",
            [selector || "&:focus"]: $0f5730ce3efc1090$var$__spreadValues({}, theme.focusRing === "always" || theme.focusRing === "auto" ? theme.focusRingStyles.styles(theme) : theme.focusRingStyles.resetStyles(theme)),
            [selector ? selector.replace(":focus", ":focus:not(:focus-visible)") : "&:focus:not(:focus-visible)"]: $0f5730ce3efc1090$var$__spreadValues({}, theme.focusRing === "auto" || theme.focusRing === "never" ? theme.focusRingStyles.resetStyles(theme) : null)
        });
}

});

parcelRegister("8Il9o", function(module, exports) {

$parcel$export(module.exports, "themeColor", () => $6582d6d0b9751af2$export$4dc1b11d18d63ea);

var $hw6IJ = parcelRequire("hw6IJ");
function $6582d6d0b9751af2$export$4dc1b11d18d63ea(theme) {
    const getPrimaryShade = (0, $hw6IJ.primaryShade)(theme);
    return (color, shade, primaryFallback = true, useSplittedShade = true)=>{
        if (typeof color === "string" && color.includes(".")) {
            const [splitterColor, _splittedShade] = color.split(".");
            const splittedShade = parseInt(_splittedShade, 10);
            if (splitterColor in theme.colors && splittedShade >= 0 && splittedShade < 10) return theme.colors[splitterColor][typeof shade === "number" && !useSplittedShade ? shade : splittedShade];
        }
        const _shade = typeof shade === "number" ? shade : getPrimaryShade();
        return color in theme.colors ? theme.colors[color][_shade] : primaryFallback ? theme.colors[theme.primaryColor][_shade] : color;
    };
}

});
parcelRegister("hw6IJ", function(module, exports) {

$parcel$export(module.exports, "primaryShade", () => $cc0aa3664c56954e$export$e1a6cdb055edb706);
function $cc0aa3664c56954e$export$e1a6cdb055edb706(theme) {
    return (colorScheme)=>{
        if (typeof theme.primaryShade === "number") return theme.primaryShade;
        return theme.primaryShade[colorScheme || theme.colorScheme];
    };
}

});


parcelRegister("5Hy85", function(module, exports) {

$parcel$export(module.exports, "linearGradient", () => $426b714c04ee441c$export$46def8197cf4dd4c);
$parcel$export(module.exports, "radialGradient", () => $426b714c04ee441c$export$3922d1ccb8631cd8);
$parcel$export(module.exports, "gradient", () => $426b714c04ee441c$export$f7d09cddc76f277f);

var $8Il9o = parcelRequire("8Il9o");

var $hw6IJ = parcelRequire("hw6IJ");

var $eTDRI = parcelRequire("eTDRI");
function $426b714c04ee441c$export$46def8197cf4dd4c(deg, ...colors) {
    return `linear-gradient(${deg}deg, ${(0, $eTDRI.getGradientColorStops)(colors)})`;
}
function $426b714c04ee441c$export$3922d1ccb8631cd8(...colors) {
    return `radial-gradient(circle, ${(0, $eTDRI.getGradientColorStops)(colors)})`;
}
function $426b714c04ee441c$export$f7d09cddc76f277f(theme) {
    const getThemeColor = (0, $8Il9o.themeColor)(theme);
    const getPrimaryShade = (0, $hw6IJ.primaryShade)(theme);
    return (payload)=>{
        const merged = {
            from: (payload == null ? void 0 : payload.from) || theme.defaultGradient.from,
            to: (payload == null ? void 0 : payload.to) || theme.defaultGradient.to,
            deg: (payload == null ? void 0 : payload.deg) || theme.defaultGradient.deg
        };
        return `linear-gradient(${merged.deg}deg, ${getThemeColor(merged.from, getPrimaryShade(), false)} 0%, ${getThemeColor(merged.to, getPrimaryShade(), false)} 100%)`;
    };
}

});
parcelRegister("eTDRI", function(module, exports) {

$parcel$export(module.exports, "getGradientColorStops", () => $ad852028e7e53b17$export$6881753f1f548991);
function $ad852028e7e53b17$export$6881753f1f548991(colors) {
    let stops = "";
    for(let i = 1; i < colors.length - 1; i += 1)stops += `${colors[i]} ${i / (colors.length - 1) * 100}%, `;
    return `${colors[0]} 0%, ${stops}${colors[colors.length - 1]} 100%`;
}

});


parcelRegister("2vpKc", function(module, exports) {

$parcel$export(module.exports, "getBreakpointValue", () => $1d327247c1d5b602$export$4adb988360925c51);
$parcel$export(module.exports, "largerThan", () => $1d327247c1d5b602$export$eea80831d0d6a2e);
$parcel$export(module.exports, "smallerThan", () => $1d327247c1d5b602$export$23279bef57b0cc02);

var $2jkdX = parcelRequire("2jkdX");

var $d8Ix8 = parcelRequire("d8Ix8");
function $1d327247c1d5b602$export$4adb988360925c51(value) {
    if (typeof value === "number") return value;
    if (typeof value === "string" && value.includes("rem")) return Number(value.replace("rem", "")) * 16;
    if (typeof value === "string" && value.includes("em")) return Number(value.replace("em", "")) * 16;
    return Number(value);
}
function $1d327247c1d5b602$export$eea80831d0d6a2e(theme) {
    return (breakpoint)=>`@media (min-width: ${(0, $2jkdX.em)($1d327247c1d5b602$export$4adb988360925c51((0, $d8Ix8.getSize)({
            size: breakpoint,
            sizes: theme.breakpoints
        })))})`;
}
function $1d327247c1d5b602$export$23279bef57b0cc02(theme) {
    return (breakpoint)=>`@media (max-width: ${(0, $2jkdX.em)($1d327247c1d5b602$export$4adb988360925c51((0, $d8Ix8.getSize)({
            size: breakpoint,
            sizes: theme.breakpoints
        })) - 1)})`;
}

});
parcelRegister("2jkdX", function(module, exports) {

$parcel$export(module.exports, "rem", () => $1aed0b3acfa11680$export$fb1897a40d146f7f);
$parcel$export(module.exports, "em", () => $1aed0b3acfa11680$export$c63c6f932822f543);
function $1aed0b3acfa11680$var$createConverter(units) {
    return (px)=>{
        if (typeof px === "number") return `${px / 16}${units}`;
        if (typeof px === "string") {
            const replaced = px.replace("px", "");
            if (!Number.isNaN(Number(replaced))) return `${Number(replaced) / 16}${units}`;
        }
        return px;
    };
}
const $1aed0b3acfa11680$export$fb1897a40d146f7f = $1aed0b3acfa11680$var$createConverter("rem");
const $1aed0b3acfa11680$export$c63c6f932822f543 = $1aed0b3acfa11680$var$createConverter("em");

});

parcelRegister("d8Ix8", function(module, exports) {

$parcel$export(module.exports, "getSize", () => $990e912231de29f5$export$31b21d0167753bb4);

var $2jkdX = parcelRequire("2jkdX");
function $990e912231de29f5$export$31b21d0167753bb4({ size: size, sizes: sizes, units: units }) {
    if (size in sizes) return sizes[size];
    if (typeof size === "number") return units === "em" ? (0, $2jkdX.em)(size) : (0, $2jkdX.rem)(size);
    return size || sizes.md;
}

});


parcelRegister("fYRXt", function(module, exports) {

$parcel$export(module.exports, "rgba", () => $ba265093bda6c52e$export$4e46ac54fc82cf3b);

var $gByOW = parcelRequire("gByOW");
function $ba265093bda6c52e$export$4e46ac54fc82cf3b(color, alpha) {
    if (typeof color !== "string" || alpha > 1 || alpha < 0) return "rgba(0, 0, 0, 1)";
    if (color.startsWith("var(--")) return color;
    const { r: r, g: g, b: b } = (0, $gByOW.toRgba)(color);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

});
parcelRegister("gByOW", function(module, exports) {

$parcel$export(module.exports, "toRgba", () => $c16b1cb4d6f408b7$export$5db297beaffffbfc);
function $c16b1cb4d6f408b7$var$isHexColor(hex) {
    const HEX_REGEXP = /^#?([0-9A-F]{3}){1,2}$/i;
    return HEX_REGEXP.test(hex);
}
function $c16b1cb4d6f408b7$var$hexToRgba(color) {
    let hexString = color.replace("#", "");
    if (hexString.length === 3) {
        const shorthandHex = hexString.split("");
        hexString = [
            shorthandHex[0],
            shorthandHex[0],
            shorthandHex[1],
            shorthandHex[1],
            shorthandHex[2],
            shorthandHex[2]
        ].join("");
    }
    const parsed = parseInt(hexString, 16);
    const r = parsed >> 16 & 255;
    const g = parsed >> 8 & 255;
    const b = parsed & 255;
    return {
        r: r,
        g: g,
        b: b,
        a: 1
    };
}
function $c16b1cb4d6f408b7$var$rgbStringToRgba(color) {
    const [r, g, b, a] = color.replace(/[^0-9,.]/g, "").split(",").map(Number);
    return {
        r: r,
        g: g,
        b: b,
        a: a || 1
    };
}
function $c16b1cb4d6f408b7$export$5db297beaffffbfc(color) {
    if ($c16b1cb4d6f408b7$var$isHexColor(color)) return $c16b1cb4d6f408b7$var$hexToRgba(color);
    if (color.startsWith("rgb")) return $c16b1cb4d6f408b7$var$rgbStringToRgba(color);
    return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
}

});


parcelRegister("2WoLx", function(module, exports) {

$parcel$export(module.exports, "cover", () => $2244357d6c63a86b$export$4bdbf921f0c0fd8c);

var $2jkdX = parcelRequire("2jkdX");
function $2244357d6c63a86b$export$4bdbf921f0c0fd8c(offset = 0) {
    return {
        position: "absolute",
        top: (0, $2jkdX.rem)(offset),
        right: (0, $2jkdX.rem)(offset),
        left: (0, $2jkdX.rem)(offset),
        bottom: (0, $2jkdX.rem)(offset)
    };
}

});

parcelRegister("2WXwR", function(module, exports) {

$parcel$export(module.exports, "darken", () => $225f2cc418639297$export$4b073707ff63303);

var $gByOW = parcelRequire("gByOW");
function $225f2cc418639297$export$4b073707ff63303(color, alpha) {
    if (typeof color === "string" && color.startsWith("var(--")) return color;
    const { r: r, g: g, b: b, a: a } = (0, $gByOW.toRgba)(color);
    const f = 1 - alpha;
    const dark = (input)=>Math.round(input * f);
    return `rgba(${dark(r)}, ${dark(g)}, ${dark(b)}, ${a})`;
}

});

parcelRegister("1g8T5", function(module, exports) {

$parcel$export(module.exports, "lighten", () => $0eae2deadd5f2f8b$export$c0816ed86df316af);

var $gByOW = parcelRequire("gByOW");
function $0eae2deadd5f2f8b$export$c0816ed86df316af(color, alpha) {
    if (typeof color === "string" && color.startsWith("var(--")) return color;
    const { r: r, g: g, b: b, a: a } = (0, $gByOW.toRgba)(color);
    const light = (input)=>Math.round(input + (255 - input) * alpha);
    return `rgba(${light(r)}, ${light(g)}, ${light(b)}, ${a})`;
}

});

parcelRegister("944i3", function(module, exports) {

$parcel$export(module.exports, "radius", () => $6997d0b932fc954f$export$872dd985a098dd45);

var $2jkdX = parcelRequire("2jkdX");
function $6997d0b932fc954f$export$872dd985a098dd45(theme) {
    return (size)=>{
        if (typeof size === "number") return (0, $2jkdX.rem)(size);
        const defaultRadius = typeof theme.defaultRadius === "number" ? theme.defaultRadius : theme.radius[theme.defaultRadius] || theme.defaultRadius;
        return theme.radius[size] || size || defaultRadius;
    };
}

});

parcelRegister("7DY6Z", function(module, exports) {

$parcel$export(module.exports, "variant", () => $590acddf21df404d$export$8fdf71db98f19724);

var $fYRXt = parcelRequire("fYRXt");

var $8Il9o = parcelRequire("8Il9o");

var $hw6IJ = parcelRequire("hw6IJ");

var $5Hy85 = parcelRequire("5Hy85");
function $590acddf21df404d$var$getColorIndexInfo(color, theme) {
    if (typeof color === "string" && color.includes(".")) {
        const [splittedColor, _splittedShade] = color.split(".");
        const splittedShade = parseInt(_splittedShade, 10);
        if (splittedColor in theme.colors && splittedShade >= 0 && splittedShade < 10) return {
            isSplittedColor: true,
            key: splittedColor,
            shade: splittedShade
        };
    }
    return {
        isSplittedColor: false
    };
}
function $590acddf21df404d$export$8fdf71db98f19724(theme) {
    const getThemeColor = (0, $8Il9o.themeColor)(theme);
    const getPrimaryShade = (0, $hw6IJ.primaryShade)(theme);
    const getGradient = (0, $5Hy85.gradient)(theme);
    return ({ variant: variant2, color: color, gradient: gradient2, primaryFallback: primaryFallback })=>{
        const colorInfo = $590acddf21df404d$var$getColorIndexInfo(color, theme);
        switch(variant2){
            case "light":
                return {
                    border: "transparent",
                    background: (0, $fYRXt.rgba)(getThemeColor(color, theme.colorScheme === "dark" ? 8 : 0, primaryFallback, false), theme.colorScheme === "dark" ? 0.2 : 1),
                    color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
                    hover: (0, $fYRXt.rgba)(getThemeColor(color, theme.colorScheme === "dark" ? 7 : 1, primaryFallback, false), theme.colorScheme === "dark" ? 0.25 : 0.65)
                };
            case "subtle":
                return {
                    border: "transparent",
                    background: "transparent",
                    color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
                    hover: (0, $fYRXt.rgba)(getThemeColor(color, theme.colorScheme === "dark" ? 8 : 0, primaryFallback, false), theme.colorScheme === "dark" ? 0.2 : 1)
                };
            case "outline":
                return {
                    border: getThemeColor(color, theme.colorScheme === "dark" ? 5 : getPrimaryShade("light")),
                    background: "transparent",
                    color: getThemeColor(color, theme.colorScheme === "dark" ? 5 : getPrimaryShade("light")),
                    hover: theme.colorScheme === "dark" ? (0, $fYRXt.rgba)(getThemeColor(color, 5, primaryFallback, false), 0.05) : (0, $fYRXt.rgba)(getThemeColor(color, 0, primaryFallback, false), 0.35)
                };
            case "default":
                return {
                    border: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
                    background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
                    color: theme.colorScheme === "dark" ? theme.white : theme.black,
                    hover: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
                };
            case "white":
                return {
                    border: "transparent",
                    background: theme.white,
                    color: getThemeColor(color, getPrimaryShade()),
                    hover: null
                };
            case "transparent":
                return {
                    border: "transparent",
                    color: color === "dark" ? theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.dark[9] : getThemeColor(color, theme.colorScheme === "dark" ? 2 : getPrimaryShade("light")),
                    background: "transparent",
                    hover: null
                };
            case "gradient":
                return {
                    background: getGradient(gradient2),
                    color: theme.white,
                    border: "transparent",
                    hover: null
                };
            default:
                {
                    const _primaryShade = getPrimaryShade();
                    const _shade = colorInfo.isSplittedColor ? colorInfo.shade : _primaryShade;
                    const _color = colorInfo.isSplittedColor ? colorInfo.key : color;
                    return {
                        border: "transparent",
                        background: getThemeColor(_color, _shade, primaryFallback),
                        color: theme.white,
                        hover: getThemeColor(_color, _shade === 9 ? 8 : _shade + 1)
                    };
                }
        }
    };
}

});

parcelRegister("eMFWp", function(module, exports) {

$parcel$export(module.exports, "primaryColor", () => $ac36150116c6053f$export$920341819d1fcda9);

var $hw6IJ = parcelRequire("hw6IJ");
function $ac36150116c6053f$export$920341819d1fcda9(theme) {
    return (colorScheme)=>{
        const shade = (0, $hw6IJ.primaryShade)(theme)(colorScheme);
        return theme.colors[theme.primaryColor][shade];
    };
}

});

parcelRegister("52XK0", function(module, exports) {

$parcel$export(module.exports, "hover", () => $3acb7af68fee13ea$export$3f60957f5dbf3876);
function $3acb7af68fee13ea$export$3f60957f5dbf3876(hoverStyle) {
    return {
        "@media (hover: hover)": {
            "&:hover": hoverStyle
        },
        "@media (hover: none)": {
            "&:active": hoverStyle
        }
    };
}

});

parcelRegister("ji3cY", function(module, exports) {

$parcel$export(module.exports, "placeholderStyles", () => $e0b22fda93fd8ab5$export$d3bdc0d52bb6c2c8);
function $e0b22fda93fd8ab5$export$d3bdc0d52bb6c2c8(theme) {
    return ()=>({
            userSelect: "none",
            color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
        });
}

});

parcelRegister("5Yq3g", function(module, exports) {

$parcel$export(module.exports, "dimmed", () => $011f55bc7e2cd63e$export$161ea2445f218213);
function $011f55bc7e2cd63e$export$161ea2445f218213(theme) {
    return ()=>theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6];
}

});




parcelRegister("cbOT3", function(module, exports) {

$parcel$export(module.exports, "GlobalStyles", () => $8dfdfc3214e2b545$export$c507fb1c2e1ac13a);

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");
var $8dfdfc3214e2b545$var$__defProp = Object.defineProperty;
var $8dfdfc3214e2b545$var$__defProps = Object.defineProperties;
var $8dfdfc3214e2b545$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8dfdfc3214e2b545$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8dfdfc3214e2b545$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8dfdfc3214e2b545$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8dfdfc3214e2b545$var$__defNormalProp = (obj, key, value)=>key in obj ? $8dfdfc3214e2b545$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8dfdfc3214e2b545$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8dfdfc3214e2b545$var$__hasOwnProp.call(b, prop)) $8dfdfc3214e2b545$var$__defNormalProp(a, prop, b[prop]);
    if ($8dfdfc3214e2b545$var$__getOwnPropSymbols) {
        for (var prop of $8dfdfc3214e2b545$var$__getOwnPropSymbols(b))if ($8dfdfc3214e2b545$var$__propIsEnum.call(b, prop)) $8dfdfc3214e2b545$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8dfdfc3214e2b545$var$__spreadProps = (a, b)=>$8dfdfc3214e2b545$var$__defProps(a, $8dfdfc3214e2b545$var$__getOwnPropDescs(b));
function $8dfdfc3214e2b545$export$c507fb1c2e1ac13a({ theme: theme }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jjlaj.Global), {
        styles: {
            "*, *::before, *::after": {
                boxSizing: "border-box"
            },
            html: {
                colorScheme: theme.colorScheme === "dark" ? "dark" : "light"
            },
            body: $8dfdfc3214e2b545$var$__spreadProps($8dfdfc3214e2b545$var$__spreadValues({}, theme.fn.fontStyles()), {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
                color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
                lineHeight: theme.lineHeight,
                fontSize: theme.fontSizes.md,
                WebkitFontSmoothing: "antialiased",
                MozOsxFontSmoothing: "grayscale"
            })
        }
    });
}

});

parcelRegister("dcLjc", function(module, exports) {

$parcel$export(module.exports, "MantineCssVariables", () => $99d117d817af9479$export$bfc71f5317840eaf);

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $2jkdX = parcelRequire("2jkdX");
function $99d117d817af9479$var$assignSizeVariables(variables, sizes, name, targetUnitConverter = (0, $2jkdX.rem)) {
    Object.keys(sizes).forEach((size)=>{
        variables[`--mantine-${name}-${size}`] = targetUnitConverter(sizes[size]);
    });
}
function $99d117d817af9479$export$bfc71f5317840eaf({ theme: theme }) {
    const variables = {
        "--mantine-color-white": theme.white,
        "--mantine-color-black": theme.black,
        "--mantine-transition-timing-function": theme.transitionTimingFunction,
        "--mantine-line-height": `${theme.lineHeight}`,
        "--mantine-font-family": theme.fontFamily,
        "--mantine-font-family-monospace": theme.fontFamilyMonospace,
        "--mantine-font-family-headings": theme.headings.fontFamily,
        "--mantine-heading-font-weight": `${theme.headings.fontWeight}`
    };
    $99d117d817af9479$var$assignSizeVariables(variables, theme.shadows, "shadow");
    $99d117d817af9479$var$assignSizeVariables(variables, theme.fontSizes, "font-size");
    $99d117d817af9479$var$assignSizeVariables(variables, theme.radius, "radius");
    $99d117d817af9479$var$assignSizeVariables(variables, theme.spacing, "spacing");
    $99d117d817af9479$var$assignSizeVariables(variables, theme.breakpoints, "breakpoints", (0, $2jkdX.em));
    Object.keys(theme.colors).forEach((color)=>{
        theme.colors[color].forEach((shade, index)=>{
            variables[`--mantine-color-${color}-${index}`] = shade;
        });
    });
    const headings = theme.headings.sizes;
    Object.keys(headings).forEach((heading)=>{
        variables[`--mantine-${heading}-font-size`] = headings[heading].fontSize;
        variables[`--mantine-${heading}-line-height`] = `${headings[heading].lineHeight}`;
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jjlaj.Global), {
        styles: {
            ":root": variables
        }
    });
}

});

parcelRegister("eRTMZ", function(module, exports) {

$parcel$export(module.exports, "mergeThemeWithFunctions", () => $ad314a78f12190ce$export$939c00769a13ddb1);

var $aq0ZL = parcelRequire("aq0ZL");

var $2vpKc = parcelRequire("2vpKc");
var $ad314a78f12190ce$var$__defProp = Object.defineProperty;
var $ad314a78f12190ce$var$__defProps = Object.defineProperties;
var $ad314a78f12190ce$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ad314a78f12190ce$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ad314a78f12190ce$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ad314a78f12190ce$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ad314a78f12190ce$var$__defNormalProp = (obj, key, value)=>key in obj ? $ad314a78f12190ce$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ad314a78f12190ce$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ad314a78f12190ce$var$__hasOwnProp.call(b, prop)) $ad314a78f12190ce$var$__defNormalProp(a, prop, b[prop]);
    if ($ad314a78f12190ce$var$__getOwnPropSymbols) {
        for (var prop of $ad314a78f12190ce$var$__getOwnPropSymbols(b))if ($ad314a78f12190ce$var$__propIsEnum.call(b, prop)) $ad314a78f12190ce$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ad314a78f12190ce$var$__spreadProps = (a, b)=>$ad314a78f12190ce$var$__defProps(a, $ad314a78f12190ce$var$__getOwnPropDescs(b));
function $ad314a78f12190ce$export$254f885134d38452(currentTheme, themeOverride) {
    var _a;
    if (!themeOverride) return currentTheme;
    const result = Object.keys(currentTheme).reduce((acc, key)=>{
        if (key === "headings" && themeOverride.headings) {
            const sizes = themeOverride.headings.sizes ? Object.keys(currentTheme.headings.sizes).reduce((headingsAcc, h)=>{
                headingsAcc[h] = $ad314a78f12190ce$var$__spreadValues($ad314a78f12190ce$var$__spreadValues({}, currentTheme.headings.sizes[h]), themeOverride.headings.sizes[h]);
                return headingsAcc;
            }, {}) : currentTheme.headings.sizes;
            return $ad314a78f12190ce$var$__spreadProps($ad314a78f12190ce$var$__spreadValues({}, acc), {
                headings: $ad314a78f12190ce$var$__spreadProps($ad314a78f12190ce$var$__spreadValues($ad314a78f12190ce$var$__spreadValues({}, currentTheme.headings), themeOverride.headings), {
                    sizes: sizes
                })
            });
        }
        if (key === "breakpoints" && themeOverride.breakpoints) {
            const mergedBreakpoints = $ad314a78f12190ce$var$__spreadValues($ad314a78f12190ce$var$__spreadValues({}, currentTheme.breakpoints), themeOverride.breakpoints);
            return $ad314a78f12190ce$var$__spreadProps($ad314a78f12190ce$var$__spreadValues({}, acc), {
                breakpoints: Object.fromEntries(Object.entries(mergedBreakpoints).sort((a, b)=>(0, $2vpKc.getBreakpointValue)(a[1]) - (0, $2vpKc.getBreakpointValue)(b[1])))
            });
        }
        acc[key] = typeof themeOverride[key] === "object" ? $ad314a78f12190ce$var$__spreadValues($ad314a78f12190ce$var$__spreadValues({}, currentTheme[key]), themeOverride[key]) : typeof themeOverride[key] === "number" || typeof themeOverride[key] === "boolean" || typeof themeOverride[key] === "function" ? themeOverride[key] : themeOverride[key] || currentTheme[key];
        return acc;
    }, {});
    if ((themeOverride == null ? void 0 : themeOverride.fontFamily) && !((_a = themeOverride == null ? void 0 : themeOverride.headings) == null ? void 0 : _a.fontFamily)) result.headings.fontFamily = themeOverride.fontFamily;
    if (!(result.primaryColor in result.colors)) throw new Error("MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more \u2013 https://mantine.dev/theming/colors/#primary-color");
    return result;
}
function $ad314a78f12190ce$export$939c00769a13ddb1(currentTheme, themeOverride) {
    return (0, $aq0ZL.attachFunctions)($ad314a78f12190ce$export$254f885134d38452(currentTheme, themeOverride));
}

});

parcelRegister("4oGla", function(module, exports) {

$parcel$export(module.exports, "filterProps", () => $333a3f39a585ffc1$export$d697c39a2985a4c);
function $333a3f39a585ffc1$export$d697c39a2985a4c(props) {
    return Object.keys(props).reduce((acc, key)=>{
        if (props[key] !== void 0) acc[key] = props[key];
        return acc;
    }, {});
}

});

parcelRegister("l86pR", function(module, exports) {

$parcel$export(module.exports, "NormalizeCSS", () => $f61f52701171b201$export$3e89a4c32ba1d42e);

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $2jkdX = parcelRequire("2jkdX");
const $f61f52701171b201$var$styles = {
    html: {
        fontFamily: "sans-serif",
        lineHeight: "1.15",
        textSizeAdjust: "100%"
    },
    body: {
        margin: 0
    },
    "article, aside, footer, header, nav, section, figcaption, figure, main": {
        display: "block"
    },
    h1: {
        fontSize: "2em"
    },
    hr: {
        boxSizing: "content-box",
        height: 0,
        overflow: "visible"
    },
    pre: {
        fontFamily: "monospace, monospace",
        fontSize: "1em"
    },
    a: {
        background: "transparent",
        textDecorationSkip: "objects"
    },
    "a:active, a:hover": {
        outlineWidth: 0
    },
    "abbr[title]": {
        borderBottom: "none",
        textDecoration: "underline"
    },
    "b, strong": {
        fontWeight: "bolder"
    },
    "code, kbp, samp": {
        fontFamily: "monospace, monospace",
        fontSize: "1em"
    },
    dfn: {
        fontStyle: "italic"
    },
    mark: {
        backgroundColor: "#ff0",
        color: "#000"
    },
    small: {
        fontSize: "80%"
    },
    "sub, sup": {
        fontSize: "75%",
        lineHeight: 0,
        position: "relative",
        verticalAlign: "baseline"
    },
    sup: {
        top: "-0.5em"
    },
    sub: {
        bottom: "-0.25em"
    },
    "audio, video": {
        display: "inline-block"
    },
    "audio:not([controls])": {
        display: "none",
        height: 0
    },
    img: {
        borderStyle: "none",
        verticalAlign: "middle"
    },
    "svg:not(:root)": {
        overflow: "hidden"
    },
    "button, input, optgroup, select, textarea": {
        fontFamily: "sans-serif",
        fontSize: "100%",
        lineHeight: "1.15",
        margin: 0
    },
    "button, input": {
        overflow: "visible"
    },
    "button, select": {
        textTransform: "none"
    },
    "button, [type=reset], [type=submit]": {
        WebkitAppearance: "button"
    },
    "button::-moz-focus-inner, [type=button]::-moz-focus-inner, [type=reset]::-moz-focus-inner, [type=submit]::-moz-focus-inner": {
        borderStyle: "none",
        padding: 0
    },
    "button:-moz-focusring, [type=button]:-moz-focusring, [type=reset]:-moz-focusring, [type=submit]:-moz-focusring": {
        outline: `${(0, $2jkdX.rem)(1)} dotted ButtonText`
    },
    legend: {
        boxSizing: "border-box",
        color: "inherit",
        display: "table",
        maxWidth: "100%",
        padding: 0,
        whiteSpace: "normal"
    },
    progress: {
        display: "inline-block",
        verticalAlign: "baseline"
    },
    textarea: {
        overflow: "auto"
    },
    "[type=checkbox], [type=radio]": {
        boxSizing: "border-box",
        padding: 0
    },
    "[type=number]::-webkit-inner-spin-button, [type=number]::-webkit-outer-spin-button": {
        height: "auto"
    },
    "[type=search]": {
        appearance: "none"
    },
    "[type=search]::-webkit-search-cancel-button, [type=search]::-webkit-search-decoration": {
        appearance: "none"
    },
    "::-webkit-file-upload-button": {
        appearance: "button",
        font: "inherit"
    },
    "details, menu": {
        display: "block"
    },
    summary: {
        display: "list-item"
    },
    canvas: {
        display: "inline-block"
    },
    template: {
        display: "none"
    }
};
function $f61f52701171b201$export$3e89a4c32ba1d42e() {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jjlaj.Global), {
        styles: $f61f52701171b201$var$styles
    });
}

});


parcelRegister("1euea", function(module, exports) {

$parcel$export(module.exports, "createPolymorphicComponent", () => $0e5e8bd1bbb19582$export$639b89ea563ec697);
function $0e5e8bd1bbb19582$export$639b89ea563ec697(component) {
    return component;
}

});

parcelRegister("hQ3KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfca34d268fba5c1$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $cfca34d268fba5c1$var$__defProp = Object.defineProperty;
var $cfca34d268fba5c1$var$__defProps = Object.defineProperties;
var $cfca34d268fba5c1$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cfca34d268fba5c1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cfca34d268fba5c1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cfca34d268fba5c1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cfca34d268fba5c1$var$__defNormalProp = (obj, key, value)=>key in obj ? $cfca34d268fba5c1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cfca34d268fba5c1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cfca34d268fba5c1$var$__hasOwnProp.call(b, prop)) $cfca34d268fba5c1$var$__defNormalProp(a, prop, b[prop]);
    if ($cfca34d268fba5c1$var$__getOwnPropSymbols) {
        for (var prop of $cfca34d268fba5c1$var$__getOwnPropSymbols(b))if ($cfca34d268fba5c1$var$__propIsEnum.call(b, prop)) $cfca34d268fba5c1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cfca34d268fba5c1$var$__spreadProps = (a, b)=>$cfca34d268fba5c1$var$__defProps(a, $cfca34d268fba5c1$var$__getOwnPropDescs(b));
const $cfca34d268fba5c1$export$b0325355fddbe4a0 = [
    "subtle",
    "filled",
    "outline",
    "light",
    "default",
    "transparent",
    "gradient"
];
const $cfca34d268fba5c1$export$c647cb0ee6e282fe = {
    xs: (0, $2jkdX.rem)(18),
    sm: (0, $2jkdX.rem)(22),
    md: (0, $2jkdX.rem)(28),
    lg: (0, $2jkdX.rem)(34),
    xl: (0, $2jkdX.rem)(44)
};
function $cfca34d268fba5c1$var$getVariantStyles({ variant: variant, theme: theme, color: color, gradient: gradient }) {
    const colors = theme.fn.variant({
        color: color,
        variant: variant,
        gradient: gradient
    });
    if (variant === "gradient") return {
        border: 0,
        backgroundImage: colors.background,
        color: colors.color,
        "&:hover": theme.fn.hover({
            backgroundSize: "200%"
        })
    };
    if ($cfca34d268fba5c1$export$b0325355fddbe4a0.includes(variant)) return $cfca34d268fba5c1$var$__spreadValues({
        border: `${(0, $2jkdX.rem)(1)} solid ${colors.border}`,
        backgroundColor: colors.background,
        color: colors.color
    }, theme.fn.hover({
        backgroundColor: colors.hover
    }));
    return null;
}
var $cfca34d268fba5c1$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, color: color, gradient: gradient }, { variant: variant, size: size })=>({
        root: $cfca34d268fba5c1$var$__spreadProps($cfca34d268fba5c1$var$__spreadValues({
            position: "relative",
            borderRadius: theme.fn.radius(radius),
            padding: 0,
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $cfca34d268fba5c1$export$c647cb0ee6e282fe
            }),
            minHeight: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $cfca34d268fba5c1$export$c647cb0ee6e282fe
            }),
            width: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $cfca34d268fba5c1$export$c647cb0ee6e282fe
            }),
            minWidth: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $cfca34d268fba5c1$export$c647cb0ee6e282fe
            })
        }, $cfca34d268fba5c1$var$getVariantStyles({
            variant: variant,
            theme: theme,
            color: color,
            gradient: gradient
        })), {
            "&:active": theme.activeStyles,
            "& [data-action-icon-loader]": {
                maxWidth: "70%"
            },
            "&:disabled, &[data-disabled]": {
                color: theme.colors.gray[theme.colorScheme === "dark" ? 6 : 4],
                cursor: "not-allowed",
                backgroundColor: variant === "transparent" ? void 0 : theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1),
                borderColor: variant === "transparent" ? void 0 : theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1),
                backgroundImage: "none",
                pointerEvents: "none",
                "&:active": {
                    transform: "none"
                }
            },
            "&[data-loading]": {
                pointerEvents: "none",
                "&::before": $cfca34d268fba5c1$var$__spreadProps($cfca34d268fba5c1$var$__spreadValues({
                    content: '""'
                }, theme.fn.cover((0, $2jkdX.rem)(-1))), {
                    backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
                    borderRadius: theme.fn.radius(radius),
                    cursor: "not-allowed"
                })
            }
        })
    }));
var $cfca34d268fba5c1$export$2e2bcd8739ae039 = $cfca34d268fba5c1$var$useStyles;

});
parcelRegister("cQG1Y", function(module, exports) {

$parcel$export(module.exports, "createStyles", () => $95aaf1cb07ed9fb7$export$31f077b88a3c784c);

var $j6Hvv = parcelRequire("j6Hvv");

var $64A2P = parcelRequire("64A2P");

var $jDU85 = parcelRequire("jDU85");
var $95aaf1cb07ed9fb7$var$__defProp = Object.defineProperty;
var $95aaf1cb07ed9fb7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $95aaf1cb07ed9fb7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $95aaf1cb07ed9fb7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $95aaf1cb07ed9fb7$var$__defNormalProp = (obj, key, value)=>key in obj ? $95aaf1cb07ed9fb7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $95aaf1cb07ed9fb7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($95aaf1cb07ed9fb7$var$__hasOwnProp.call(b, prop)) $95aaf1cb07ed9fb7$var$__defNormalProp(a, prop, b[prop]);
    if ($95aaf1cb07ed9fb7$var$__getOwnPropSymbols) {
        for (var prop of $95aaf1cb07ed9fb7$var$__getOwnPropSymbols(b))if ($95aaf1cb07ed9fb7$var$__propIsEnum.call(b, prop)) $95aaf1cb07ed9fb7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $95aaf1cb07ed9fb7$var$assignAccStyles(acc, styles) {
    if (styles) Object.keys(styles).forEach((key)=>{
        if (!acc[key]) acc[key] = $95aaf1cb07ed9fb7$var$__spreadValues({}, styles[key]);
        else acc[key] = $95aaf1cb07ed9fb7$var$__spreadValues($95aaf1cb07ed9fb7$var$__spreadValues({}, acc[key]), styles[key]);
    });
    return acc;
}
function $95aaf1cb07ed9fb7$var$getStyles(styles, theme, params, contextParams) {
    const extractStyles = (stylesPartial)=>typeof stylesPartial === "function" ? stylesPartial(theme, params || {}, contextParams) : stylesPartial || {};
    if (Array.isArray(styles)) return styles.map((item)=>extractStyles(item.styles)).reduce((acc, item)=>$95aaf1cb07ed9fb7$var$assignAccStyles(acc, item), {});
    return extractStyles(styles);
}
function $95aaf1cb07ed9fb7$var$getContextVariation({ ctx: ctx, theme: theme, params: params, variant: variant, size: size }) {
    return ctx.reduce((acc, item)=>{
        if (item.variants && variant in item.variants) $95aaf1cb07ed9fb7$var$assignAccStyles(acc, item.variants[variant](theme, params, {
            variant: variant,
            size: size
        }));
        if (item.sizes && size in item.sizes) $95aaf1cb07ed9fb7$var$assignAccStyles(acc, item.sizes[size](theme, params, {
            variant: variant,
            size: size
        }));
        return acc;
    }, {});
}
function $95aaf1cb07ed9fb7$export$31f077b88a3c784c(input) {
    const getCssObject = typeof input === "function" ? input : ()=>input;
    function useStyles(params, options) {
        const theme = (0, $64A2P.useMantineTheme)();
        const context = (0, $64A2P.useMantineProviderStyles)(options == null ? void 0 : options.name);
        const cache = (0, $64A2P.useMantineEmotionCache)();
        const contextParams = {
            variant: options == null ? void 0 : options.variant,
            size: options == null ? void 0 : options.size
        };
        const { css: css, cx: cx } = (0, $j6Hvv.useCss)();
        const cssObject = getCssObject(theme, params, contextParams);
        const componentStyles = $95aaf1cb07ed9fb7$var$getStyles(options == null ? void 0 : options.styles, theme, params, contextParams);
        const providerStyles = $95aaf1cb07ed9fb7$var$getStyles(context, theme, params, contextParams);
        const contextVariations = $95aaf1cb07ed9fb7$var$getContextVariation({
            ctx: context,
            theme: theme,
            params: params,
            variant: options == null ? void 0 : options.variant,
            size: options == null ? void 0 : options.size
        });
        const classes = Object.fromEntries(Object.keys(cssObject).map((key)=>{
            const mergedStyles = cx({
                [css(cssObject[key])]: !(options == null ? void 0 : options.unstyled)
            }, css(contextVariations[key]), css(providerStyles[key]), css(componentStyles[key]));
            return [
                key,
                mergedStyles
            ];
        }));
        return {
            classes: (0, $jDU85.mergeClassNames)({
                cx: cx,
                classes: classes,
                context: context,
                classNames: options == null ? void 0 : options.classNames,
                name: options == null ? void 0 : options.name,
                cache: cache
            }),
            cx: cx,
            theme: theme
        };
    }
    return useStyles;
}

});
parcelRegister("j6Hvv", function(module, exports) {

$parcel$export(module.exports, "useCss", () => $de9053770994a38b$export$56d8f0b599965014);

var $1SA7b = parcelRequire("1SA7b");

var $8rteH = parcelRequire("8rteH");

var $8ajhZ = parcelRequire("8ajhZ");

var $6ZIBl = parcelRequire("6ZIBl");

var $hFA29 = parcelRequire("hFA29");
var $de9053770994a38b$var$__defProp = Object.defineProperty;
var $de9053770994a38b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $de9053770994a38b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $de9053770994a38b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $de9053770994a38b$var$__defNormalProp = (obj, key, value)=>key in obj ? $de9053770994a38b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $de9053770994a38b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($de9053770994a38b$var$__hasOwnProp.call(b, prop)) $de9053770994a38b$var$__defNormalProp(a, prop, b[prop]);
    if ($de9053770994a38b$var$__getOwnPropSymbols) {
        for (var prop of $de9053770994a38b$var$__getOwnPropSymbols(b))if ($de9053770994a38b$var$__propIsEnum.call(b, prop)) $de9053770994a38b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
const $de9053770994a38b$var$refPropertyName = "ref";
function $de9053770994a38b$var$getRef(args) {
    let ref;
    if (args.length !== 1) return {
        args: args,
        ref: ref
    };
    const [arg] = args;
    if (!(arg instanceof Object)) return {
        args: args,
        ref: ref
    };
    if (!($de9053770994a38b$var$refPropertyName in arg)) return {
        args: args,
        ref: ref
    };
    ref = arg[$de9053770994a38b$var$refPropertyName];
    const argCopy = $de9053770994a38b$var$__spreadValues({}, arg);
    delete argCopy[$de9053770994a38b$var$refPropertyName];
    return {
        args: [
            argCopy
        ],
        ref: ref
    };
}
const { cssFactory: $de9053770994a38b$export$821d155d0f7ebeb8 } = (()=>{
    function merge(registered, css, className) {
        const registeredStyles = [];
        const rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
        if (registeredStyles.length < 2) return className;
        return rawClassName + css(registeredStyles);
    }
    function _cssFactory(params) {
        const { cache: cache } = params;
        const css = (...styles)=>{
            const { ref: ref, args: args } = $de9053770994a38b$var$getRef(styles);
            const serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
            (0, $8ajhZ.insertStyles)(cache, serialized, false);
            return `${cache.key}-${serialized.name}${ref === void 0 ? "" : ` ${ref}`}`;
        };
        const cx = (...args)=>merge(cache.registered, css, (0, $1SA7b.default)(args));
        return {
            css: css,
            cx: cx
        };
    }
    return {
        cssFactory: _cssFactory
    };
})();
function $de9053770994a38b$export$56d8f0b599965014() {
    const cache = (0, $hFA29.useEmotionCache)();
    return (0, $6ZIBl.useGuaranteedMemo)(()=>$de9053770994a38b$export$821d155d0f7ebeb8({
            cache: cache
        }), [
        cache
    ]);
}

});
parcelRegister("1SA7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e6d94060e5d8b6$export$2e2bcd8739ae039);
function $15e6d94060e5d8b6$var$toVal(mix) {
    var k, y, str = '';
    if (typeof mix === 'string' || typeof mix === 'number') str += mix;
    else if (typeof mix === 'object') {
        if (Array.isArray(mix)) for(k = 0; k < mix.length; k++){
            if (mix[k]) {
                if (y = $15e6d94060e5d8b6$var$toVal(mix[k])) {
                    str && (str += ' ');
                    str += y;
                }
            }
        }
        else {
            for(k in mix)if (mix[k]) {
                str && (str += ' ');
                str += k;
            }
        }
    }
    return str;
}
function $15e6d94060e5d8b6$export$2e2bcd8739ae039() {
    var i = 0, tmp, x, str = '';
    while(i < arguments.length){
        if (tmp = arguments[i++]) {
            if (x = $15e6d94060e5d8b6$var$toVal(tmp)) {
                str && (str += ' ');
                str += x;
            }
        }
    }
    return str;
}

});

parcelRegister("6ZIBl", function(module, exports) {

$parcel$export(module.exports, "useGuaranteedMemo", () => $517b097dea604f2b$export$482e5389fe22035d);

var $acw62 = parcelRequire("acw62");
function $517b097dea604f2b$export$482e5389fe22035d(fn, deps) {
    const ref = (0, $acw62.useRef)();
    if (!ref.current || deps.length !== ref.current.prevDeps.length || ref.current.prevDeps.map((v, i)=>v === deps[i]).indexOf(false) >= 0) ref.current = {
        v: fn(),
        prevDeps: [
            ...deps
        ]
    };
    return ref.current.v;
}

});

parcelRegister("hFA29", function(module, exports) {

$parcel$export(module.exports, "useEmotionCache", () => $cdd23789e84cb0c5$export$d1d807aebd232a46);

var $gVDiS = parcelRequire("gVDiS");

var $64A2P = parcelRequire("64A2P");
function $cdd23789e84cb0c5$export$d1d807aebd232a46() {
    const cache = (0, $64A2P.useMantineEmotionCache)();
    return cache || (0, $gVDiS.defaultMantineEmotionCache);
}

});
parcelRegister("gVDiS", function(module, exports) {

$parcel$export(module.exports, "defaultMantineEmotionCache", () => $c530750ad3af7918$export$2ab21874268024e6);

var $a9M6v = parcelRequire("a9M6v");
const $c530750ad3af7918$export$2ab21874268024e6 = (0, $a9M6v.default)({
    key: "mantine",
    prepend: true
});

});



parcelRegister("jDU85", function(module, exports) {

$parcel$export(module.exports, "mergeClassNames", () => $e4cd32f4590d5917$export$8bf64cd1c29a1310);
function $e4cd32f4590d5917$export$8bf64cd1c29a1310({ cx: cx, classes: classes, context: context, classNames: classNames, name: name, cache: cache }) {
    const contextClassNames = context.reduce((acc, item)=>{
        Object.keys(item.classNames).forEach((key)=>{
            if (typeof acc[key] !== "string") acc[key] = `${item.classNames[key]}`;
            else acc[key] = `${acc[key]} ${item.classNames[key]}`;
        });
        return acc;
    }, {});
    return Object.keys(classes).reduce((acc, className)=>{
        acc[className] = cx(classes[className], contextClassNames[className], classNames != null && classNames[className], Array.isArray(name) ? name.filter(Boolean).map((part)=>`${(cache == null ? void 0 : cache.key) || "mantine"}-${part}-${className}`).join(" ") : name ? `${(cache == null ? void 0 : cache.key) || "mantine"}-${name}-${className}` : null);
        return acc;
    }, {});
}

});



parcelRegister("4P91H", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $3832ed4d2caa6a2e$export$3b0d6d7590275603);

var $acw62 = parcelRequire("acw62");

var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $jy2C2 = parcelRequire("jy2C2");

var $hELUf = parcelRequire("hELUf");

var $2LxcD = parcelRequire("2LxcD");

var $hiiR1 = parcelRequire("hiiR1");
var $3832ed4d2caa6a2e$var$__defProp = Object.defineProperty;
var $3832ed4d2caa6a2e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3832ed4d2caa6a2e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3832ed4d2caa6a2e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3832ed4d2caa6a2e$var$__defNormalProp = (obj, key, value)=>key in obj ? $3832ed4d2caa6a2e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3832ed4d2caa6a2e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3832ed4d2caa6a2e$var$__hasOwnProp.call(b, prop)) $3832ed4d2caa6a2e$var$__defNormalProp(a, prop, b[prop]);
    if ($3832ed4d2caa6a2e$var$__getOwnPropSymbols) {
        for (var prop of $3832ed4d2caa6a2e$var$__getOwnPropSymbols(b))if ($3832ed4d2caa6a2e$var$__propIsEnum.call(b, prop)) $3832ed4d2caa6a2e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3832ed4d2caa6a2e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3832ed4d2caa6a2e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3832ed4d2caa6a2e$var$__getOwnPropSymbols) {
        for (var prop of $3832ed4d2caa6a2e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3832ed4d2caa6a2e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3832ed4d2caa6a2e$var$LOADERS = {
    bars: (0, $jy2C2.Bars),
    oval: (0, $hELUf.Oval),
    dots: (0, $2LxcD.Dots)
};
const $3832ed4d2caa6a2e$var$sizes = {
    xs: (0, $2jkdX.rem)(18),
    sm: (0, $2jkdX.rem)(22),
    md: (0, $2jkdX.rem)(36),
    lg: (0, $2jkdX.rem)(44),
    xl: (0, $2jkdX.rem)(58)
};
const $3832ed4d2caa6a2e$var$defaultProps = {
    size: "md"
};
function $3832ed4d2caa6a2e$export$3b0d6d7590275603(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("Loader", $3832ed4d2caa6a2e$var$defaultProps, props), { size: size, color: color, variant: variant } = _a, others = $3832ed4d2caa6a2e$var$__objRest(_a, [
        "size",
        "color",
        "variant"
    ]);
    const theme = (0, $64A2P.useMantineTheme)();
    const defaultLoader = variant in $3832ed4d2caa6a2e$var$LOADERS ? variant : theme.loader;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $3832ed4d2caa6a2e$var$__spreadValues({
        role: "presentation",
        component: $3832ed4d2caa6a2e$var$LOADERS[defaultLoader] || $3832ed4d2caa6a2e$var$LOADERS.bars,
        size: (0, $d8Ix8.getSize)({
            size: size,
            sizes: $3832ed4d2caa6a2e$var$sizes
        }),
        color: theme.fn.variant({
            variant: "filled",
            primaryFallback: false,
            color: color || theme.primaryColor
        }).background
    }, others));
}
$3832ed4d2caa6a2e$export$3b0d6d7590275603.displayName = "@mantine/core/Loader";

});
parcelRegister("jy2C2", function(module, exports) {

$parcel$export(module.exports, "Bars", () => $e3b33816c85ee471$export$fbc7d6f7dd821b47);

var $acw62 = parcelRequire("acw62");
var $e3b33816c85ee471$var$__defProp = Object.defineProperty;
var $e3b33816c85ee471$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e3b33816c85ee471$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e3b33816c85ee471$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e3b33816c85ee471$var$__defNormalProp = (obj, key, value)=>key in obj ? $e3b33816c85ee471$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e3b33816c85ee471$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e3b33816c85ee471$var$__hasOwnProp.call(b, prop)) $e3b33816c85ee471$var$__defNormalProp(a, prop, b[prop]);
    if ($e3b33816c85ee471$var$__getOwnPropSymbols) {
        for (var prop of $e3b33816c85ee471$var$__getOwnPropSymbols(b))if ($e3b33816c85ee471$var$__propIsEnum.call(b, prop)) $e3b33816c85ee471$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e3b33816c85ee471$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e3b33816c85ee471$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e3b33816c85ee471$var$__getOwnPropSymbols) {
        for (var prop of $e3b33816c85ee471$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e3b33816c85ee471$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $e3b33816c85ee471$export$fbc7d6f7dd821b47(_a) {
    var _b = _a, { size: size, color: color } = _b, others = $e3b33816c85ee471$var$__objRest(_b, [
        "size",
        "color"
    ]);
    const _a2 = others, { style: style } = _a2, rest = $e3b33816c85ee471$var$__objRest(_a2, [
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $e3b33816c85ee471$var$__spreadValues({
        viewBox: "0 0 135 140",
        xmlns: "http://www.w3.org/2000/svg",
        fill: color,
        style: $e3b33816c85ee471$var$__spreadValues({
            width: size
        }, style)
    }, rest), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0.5s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0.5s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "30",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0.25s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0.25s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "60",
        width: "15",
        height: "140",
        rx: "6"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "90",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0.25s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0.25s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        x: "120",
        y: "10",
        width: "15",
        height: "120",
        rx: "6"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "height",
        begin: "0.5s",
        dur: "1s",
        values: "120;110;100;90;80;70;60;50;40;140;120",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "y",
        begin: "0.5s",
        dur: "1s",
        values: "10;15;20;25;30;35;40;45;50;0;10",
        calcMode: "linear",
        repeatCount: "indefinite"
    })));
}

});

parcelRegister("hELUf", function(module, exports) {

$parcel$export(module.exports, "Oval", () => $cdab554176fb3b2e$export$67ad50c48ca3ede4);

var $acw62 = parcelRequire("acw62");
var $cdab554176fb3b2e$var$__defProp = Object.defineProperty;
var $cdab554176fb3b2e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cdab554176fb3b2e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cdab554176fb3b2e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cdab554176fb3b2e$var$__defNormalProp = (obj, key, value)=>key in obj ? $cdab554176fb3b2e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cdab554176fb3b2e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cdab554176fb3b2e$var$__hasOwnProp.call(b, prop)) $cdab554176fb3b2e$var$__defNormalProp(a, prop, b[prop]);
    if ($cdab554176fb3b2e$var$__getOwnPropSymbols) {
        for (var prop of $cdab554176fb3b2e$var$__getOwnPropSymbols(b))if ($cdab554176fb3b2e$var$__propIsEnum.call(b, prop)) $cdab554176fb3b2e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cdab554176fb3b2e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($cdab554176fb3b2e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $cdab554176fb3b2e$var$__getOwnPropSymbols) {
        for (var prop of $cdab554176fb3b2e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $cdab554176fb3b2e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $cdab554176fb3b2e$export$67ad50c48ca3ede4(_a) {
    var _b = _a, { size: size, color: color } = _b, others = $cdab554176fb3b2e$var$__objRest(_b, [
        "size",
        "color"
    ]);
    const _a2 = others, { style: style } = _a2, rest = $cdab554176fb3b2e$var$__objRest(_a2, [
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $cdab554176fb3b2e$var$__spreadValues({
        viewBox: "0 0 38 38",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: color,
        style: $cdab554176fb3b2e$var$__spreadValues({
            width: size,
            height: size
        }, style)
    }, rest), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("g", {
        transform: "translate(2.5 2.5)",
        strokeWidth: "5"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        strokeOpacity: ".5",
        cx: "16",
        cy: "16",
        r: "16"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M32 16c0-9.94-8.06-16-16-16"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 16 16",
        to: "360 16 16",
        dur: "1s",
        repeatCount: "indefinite"
    })))));
}

});

parcelRegister("2LxcD", function(module, exports) {

$parcel$export(module.exports, "Dots", () => $2039b9f1f95caea1$export$8da50d3722682be0);

var $acw62 = parcelRequire("acw62");
var $2039b9f1f95caea1$var$__defProp = Object.defineProperty;
var $2039b9f1f95caea1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2039b9f1f95caea1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2039b9f1f95caea1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2039b9f1f95caea1$var$__defNormalProp = (obj, key, value)=>key in obj ? $2039b9f1f95caea1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2039b9f1f95caea1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2039b9f1f95caea1$var$__hasOwnProp.call(b, prop)) $2039b9f1f95caea1$var$__defNormalProp(a, prop, b[prop]);
    if ($2039b9f1f95caea1$var$__getOwnPropSymbols) {
        for (var prop of $2039b9f1f95caea1$var$__getOwnPropSymbols(b))if ($2039b9f1f95caea1$var$__propIsEnum.call(b, prop)) $2039b9f1f95caea1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2039b9f1f95caea1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2039b9f1f95caea1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2039b9f1f95caea1$var$__getOwnPropSymbols) {
        for (var prop of $2039b9f1f95caea1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2039b9f1f95caea1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $2039b9f1f95caea1$export$8da50d3722682be0(_a) {
    var _b = _a, { size: size, color: color } = _b, others = $2039b9f1f95caea1$var$__objRest(_b, [
        "size",
        "color"
    ]);
    const _a2 = others, { style: style } = _a2, rest = $2039b9f1f95caea1$var$__objRest(_a2, [
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $2039b9f1f95caea1$var$__spreadValues({
        viewBox: "0 0 120 30",
        xmlns: "http://www.w3.org/2000/svg",
        fill: color,
        style: $2039b9f1f95caea1$var$__spreadValues({
            width: size
        }, style)
    }, rest), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "15",
        cy: "15",
        r: "15"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        from: "15",
        to: "15",
        begin: "0s",
        dur: "0.8s",
        values: "15;9;15",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "1",
        to: "1",
        begin: "0s",
        dur: "0.8s",
        values: "1;.5;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "60",
        cy: "15",
        r: "9",
        fillOpacity: "0.3"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        from: "9",
        to: "9",
        begin: "0s",
        dur: "0.8s",
        values: "9;15;9",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "0.5",
        to: "0.5",
        begin: "0s",
        dur: "0.8s",
        values: ".5;1;.5",
        calcMode: "linear",
        repeatCount: "indefinite"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", {
        cx: "105",
        cy: "15",
        r: "15"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "r",
        from: "15",
        to: "15",
        begin: "0s",
        dur: "0.8s",
        values: "15;9;15",
        calcMode: "linear",
        repeatCount: "indefinite"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("animate", {
        attributeName: "fill-opacity",
        from: "1",
        to: "1",
        begin: "0s",
        dur: "0.8s",
        values: "1;.5;1",
        calcMode: "linear",
        repeatCount: "indefinite"
    })));
}

});

parcelRegister("hiiR1", function(module, exports) {

$parcel$export(module.exports, "Box", () => $c972be238a01a1b6$export$e71c4d32a2263218);

var $acw62 = parcelRequire("acw62");

var $1euea = parcelRequire("1euea");

var $aEkmw = parcelRequire("aEkmw");

var $ddjj7 = parcelRequire("ddjj7");
var $c972be238a01a1b6$var$__defProp = Object.defineProperty;
var $c972be238a01a1b6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c972be238a01a1b6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c972be238a01a1b6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c972be238a01a1b6$var$__defNormalProp = (obj, key, value)=>key in obj ? $c972be238a01a1b6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c972be238a01a1b6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c972be238a01a1b6$var$__hasOwnProp.call(b, prop)) $c972be238a01a1b6$var$__defNormalProp(a, prop, b[prop]);
    if ($c972be238a01a1b6$var$__getOwnPropSymbols) {
        for (var prop of $c972be238a01a1b6$var$__getOwnPropSymbols(b))if ($c972be238a01a1b6$var$__propIsEnum.call(b, prop)) $c972be238a01a1b6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c972be238a01a1b6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c972be238a01a1b6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c972be238a01a1b6$var$__getOwnPropSymbols) {
        for (var prop of $c972be238a01a1b6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c972be238a01a1b6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c972be238a01a1b6$export$23c260ee8e4dfaad = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { className: className, component: component, style: style, sx: sx } = _b, others = $c972be238a01a1b6$var$__objRest(_b, [
        "className",
        "component",
        "style",
        "sx"
    ]);
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const Element = component || "div";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Element, $c972be238a01a1b6$var$__spreadValues({
        ref: ref,
        className: (0, $ddjj7.useSx)(sx, systemStyles, className),
        style: style
    }, rest));
});
$c972be238a01a1b6$export$23c260ee8e4dfaad.displayName = "@mantine/core/Box";
const $c972be238a01a1b6$export$e71c4d32a2263218 = (0, $1euea.createPolymorphicComponent)($c972be238a01a1b6$export$23c260ee8e4dfaad);

});
parcelRegister("aEkmw", function(module, exports) {

$parcel$export(module.exports, "extractSystemStyles", () => $7c0d6f5137ce6d16$export$ddf531899dcfb144);

var $4oGla = parcelRequire("4oGla");
var $7c0d6f5137ce6d16$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7c0d6f5137ce6d16$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7c0d6f5137ce6d16$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7c0d6f5137ce6d16$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7c0d6f5137ce6d16$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7c0d6f5137ce6d16$var$__getOwnPropSymbols) {
        for (var prop of $7c0d6f5137ce6d16$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7c0d6f5137ce6d16$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $7c0d6f5137ce6d16$export$ddf531899dcfb144(others) {
    const _a = others, { m: m, mx: mx, my: my, mt: mt, mb: mb, ml: ml, mr: mr, p: p, px: px, py: py, pt: pt, pb: pb, pl: pl, pr: pr, bg: bg, c: c, opacity: opacity, ff: ff, fz: fz, fw: fw, lts: lts, ta: ta, lh: lh, fs: fs, tt: tt, td: td, w: w, miw: miw, maw: maw, h: h, mih: mih, mah: mah, bgsz: bgsz, bgp: bgp, bgr: bgr, bga: bga, pos: pos, top: top, left: left, bottom: bottom, right: right, inset: inset, display: display } = _a, rest = $7c0d6f5137ce6d16$var$__objRest(_a, [
        "m",
        "mx",
        "my",
        "mt",
        "mb",
        "ml",
        "mr",
        "p",
        "px",
        "py",
        "pt",
        "pb",
        "pl",
        "pr",
        "bg",
        "c",
        "opacity",
        "ff",
        "fz",
        "fw",
        "lts",
        "ta",
        "lh",
        "fs",
        "tt",
        "td",
        "w",
        "miw",
        "maw",
        "h",
        "mih",
        "mah",
        "bgsz",
        "bgp",
        "bgr",
        "bga",
        "pos",
        "top",
        "left",
        "bottom",
        "right",
        "inset",
        "display"
    ]);
    const systemStyles = (0, $4oGla.filterProps)({
        m: m,
        mx: mx,
        my: my,
        mt: mt,
        mb: mb,
        ml: ml,
        mr: mr,
        p: p,
        px: px,
        py: py,
        pt: pt,
        pb: pb,
        pl: pl,
        pr: pr,
        bg: bg,
        c: c,
        opacity: opacity,
        ff: ff,
        fz: fz,
        fw: fw,
        lts: lts,
        ta: ta,
        lh: lh,
        fs: fs,
        tt: tt,
        td: td,
        w: w,
        miw: miw,
        maw: maw,
        h: h,
        mih: mih,
        mah: mah,
        bgsz: bgsz,
        bgp: bgp,
        bgr: bgr,
        bga: bga,
        pos: pos,
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        inset: inset,
        display: display
    });
    return {
        systemStyles: systemStyles,
        rest: rest
    };
}

});

parcelRegister("ddjj7", function(module, exports) {

$parcel$export(module.exports, "useSx", () => $99eb774f2634ba5f$export$880d9556071d9275);

var $j6Hvv = parcelRequire("j6Hvv");
var $64A2P = parcelRequire("64A2P");

var $fZxvA = parcelRequire("fZxvA");
function $99eb774f2634ba5f$var$extractSx(sx, theme) {
    return typeof sx === "function" ? sx(theme) : sx;
}
function $99eb774f2634ba5f$export$880d9556071d9275(sx, systemProps, className) {
    const theme = (0, $64A2P.useMantineTheme)();
    const { css: css, cx: cx } = (0, $j6Hvv.useCss)();
    if (Array.isArray(sx)) return cx(className, css((0, $fZxvA.getSystemStyles)(systemProps, theme)), sx.map((partial)=>css($99eb774f2634ba5f$var$extractSx(partial, theme))));
    return cx(className, css($99eb774f2634ba5f$var$extractSx(sx, theme)), css((0, $fZxvA.getSystemStyles)(systemProps, theme)));
}

});
parcelRegister("fZxvA", function(module, exports) {

$parcel$export(module.exports, "getSystemStyles", () => $ba468b9dfa3e9914$export$dcd86849a157a2dd);

var $7yYsw = parcelRequire("7yYsw");

var $NBg68 = parcelRequire("NBg68");

var $d0QOa = parcelRequire("d0QOa");
var $ba468b9dfa3e9914$var$__defProp = Object.defineProperty;
var $ba468b9dfa3e9914$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ba468b9dfa3e9914$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ba468b9dfa3e9914$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ba468b9dfa3e9914$var$__defNormalProp = (obj, key, value)=>key in obj ? $ba468b9dfa3e9914$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ba468b9dfa3e9914$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ba468b9dfa3e9914$var$__hasOwnProp.call(b, prop)) $ba468b9dfa3e9914$var$__defNormalProp(a, prop, b[prop]);
    if ($ba468b9dfa3e9914$var$__getOwnPropSymbols) {
        for (var prop of $ba468b9dfa3e9914$var$__getOwnPropSymbols(b))if ($ba468b9dfa3e9914$var$__propIsEnum.call(b, prop)) $ba468b9dfa3e9914$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $ba468b9dfa3e9914$export$dcd86849a157a2dd(systemStyles, theme, systemProps = (0, $d0QOa.SYSTEM_PROPS)) {
    const styles = Object.keys(systemProps).reduce((acc, systemProp)=>{
        if (systemProp in systemStyles && systemStyles[systemProp] !== void 0) acc.push((0, $7yYsw.getResponsiveValue)({
            value: systemStyles[systemProp],
            getValue: (0, $NBg68.valueGetters)[systemProps[systemProp].type],
            property: systemProps[systemProp].property,
            theme: theme
        }));
        return acc;
    }, []);
    return styles.reduce((acc, stylesPartial)=>{
        Object.keys(stylesPartial).forEach((property)=>{
            if (typeof stylesPartial[property] === "object" && stylesPartial[property] !== null) {
                if (!(property in acc)) acc[property] = stylesPartial[property];
                else acc[property] = $ba468b9dfa3e9914$var$__spreadValues($ba468b9dfa3e9914$var$__spreadValues({}, acc[property]), stylesPartial[property]);
            } else acc[property] = stylesPartial[property];
        });
        return acc;
    }, {});
}

});
parcelRegister("7yYsw", function(module, exports) {

$parcel$export(module.exports, "getResponsiveValue", () => $581a9b49e9d712bb$export$fb473bd1d7accbc1);

var $2vpKc = parcelRequire("2vpKc");
var $d8Ix8 = parcelRequire("d8Ix8");
function $581a9b49e9d712bb$var$getSortedKeys(value, theme) {
    const sorted = Object.keys(value).filter((breakpoint)=>breakpoint !== "base").sort((a, b)=>(0, $2vpKc.getBreakpointValue)((0, $d8Ix8.getSize)({
            size: a,
            sizes: theme.breakpoints
        })) - (0, $2vpKc.getBreakpointValue)((0, $d8Ix8.getSize)({
            size: b,
            sizes: theme.breakpoints
        })));
    return "base" in value ? [
        "base",
        ...sorted
    ] : sorted;
}
function $581a9b49e9d712bb$export$fb473bd1d7accbc1({ value: value, theme: theme, getValue: getValue, property: property }) {
    if (value == null) return void 0;
    if (typeof value === "object") {
        const result = $581a9b49e9d712bb$var$getSortedKeys(value, theme).reduce((acc, breakpointKey)=>{
            if (breakpointKey === "base" && value.base !== void 0) {
                const baseValue = getValue(value.base, theme);
                if (Array.isArray(property)) {
                    property.forEach((prop)=>{
                        acc[prop] = baseValue;
                    });
                    return acc;
                }
                acc[property] = baseValue;
                return acc;
            }
            const breakpointValue = getValue(value[breakpointKey], theme);
            if (Array.isArray(property)) {
                acc[theme.fn.largerThan(breakpointKey)] = {};
                property.forEach((prop)=>{
                    acc[theme.fn.largerThan(breakpointKey)][prop] = breakpointValue;
                });
                return acc;
            }
            acc[theme.fn.largerThan(breakpointKey)] = {
                [property]: breakpointValue
            };
            return acc;
        }, {});
        return result;
    }
    const cssValue = getValue(value, theme);
    if (Array.isArray(property)) return property.reduce((acc, prop)=>{
        acc[prop] = cssValue;
        return acc;
    }, {});
    return {
        [property]: cssValue
    };
}

});

parcelRegister("NBg68", function(module, exports) {

$parcel$export(module.exports, "valueGetters", () => $09517a823c9e1a6e$export$357b68f1ebcaec0f);

var $20Xlb = parcelRequire("20Xlb");

var $kUJXa = parcelRequire("kUJXa");

var $9UKfQ = parcelRequire("9UKfQ");

var $izoIE = parcelRequire("izoIE");
const $09517a823c9e1a6e$export$357b68f1ebcaec0f = {
    identity: $kUJXa.identity,
    color: (0, $20Xlb.getColorValue),
    size: (0, $kUJXa.getSizeValue),
    fontSize: (0, $9UKfQ.getFontSizeValue),
    spacing: (0, $izoIE.getSpacingValue)
};

});
parcelRegister("20Xlb", function(module, exports) {

$parcel$export(module.exports, "getColorValue", () => $17799cb21573849a$export$50c120d4d5566287);
function $17799cb21573849a$export$50c120d4d5566287(color, theme) {
    if (color === "dimmed") return theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6];
    return theme.fn.variant({
        variant: "filled",
        color: color,
        primaryFallback: false
    }).background;
}

});

parcelRegister("kUJXa", function(module, exports) {

$parcel$export(module.exports, "getSizeValue", () => $f39caefab2fa18c4$export$41cf1db51dca6f1);
$parcel$export(module.exports, "identity", () => $f39caefab2fa18c4$export$f0954fd7d5368655);

var $2jkdX = parcelRequire("2jkdX");
function $f39caefab2fa18c4$export$41cf1db51dca6f1(value) {
    return (0, $2jkdX.rem)(value);
}
function $f39caefab2fa18c4$export$f0954fd7d5368655(value) {
    return value;
}

});

parcelRegister("9UKfQ", function(module, exports) {

$parcel$export(module.exports, "getFontSizeValue", () => $737d3933899d04aa$export$aea49689ee239e38);

var $d8Ix8 = parcelRequire("d8Ix8");
function $737d3933899d04aa$export$aea49689ee239e38(size, theme) {
    return (0, $d8Ix8.getSize)({
        size: size,
        sizes: theme.fontSizes
    });
}

});

parcelRegister("izoIE", function(module, exports) {

$parcel$export(module.exports, "getSpacingValue", () => $d84eab987a6de5a9$export$e28c23123ddb5110);

var $d8Ix8 = parcelRequire("d8Ix8");
const $d84eab987a6de5a9$var$NEGATIVE_VALUES = [
    "-xs",
    "-sm",
    "-md",
    "-lg",
    "-xl"
];
function $d84eab987a6de5a9$export$e28c23123ddb5110(size, theme) {
    if ($d84eab987a6de5a9$var$NEGATIVE_VALUES.includes(size)) return `calc(${(0, $d8Ix8.getSize)({
        size: size.replace("-", ""),
        sizes: theme.spacing
    })} * -1)`;
    return (0, $d8Ix8.getSize)({
        size: size,
        sizes: theme.spacing
    });
}

});


parcelRegister("d0QOa", function(module, exports) {

$parcel$export(module.exports, "SYSTEM_PROPS", () => $97943d1217decffe$export$f92cb626d6210b91);
const $97943d1217decffe$export$f92cb626d6210b91 = {
    m: {
        type: "spacing",
        property: "margin"
    },
    mt: {
        type: "spacing",
        property: "marginTop"
    },
    mb: {
        type: "spacing",
        property: "marginBottom"
    },
    ml: {
        type: "spacing",
        property: "marginLeft"
    },
    mr: {
        type: "spacing",
        property: "marginRight"
    },
    mx: {
        type: "spacing",
        property: [
            "marginRight",
            "marginLeft"
        ]
    },
    my: {
        type: "spacing",
        property: [
            "marginTop",
            "marginBottom"
        ]
    },
    p: {
        type: "spacing",
        property: "padding"
    },
    pt: {
        type: "spacing",
        property: "paddingTop"
    },
    pb: {
        type: "spacing",
        property: "paddingBottom"
    },
    pl: {
        type: "spacing",
        property: "paddingLeft"
    },
    pr: {
        type: "spacing",
        property: "paddingRight"
    },
    px: {
        type: "spacing",
        property: [
            "paddingRight",
            "paddingLeft"
        ]
    },
    py: {
        type: "spacing",
        property: [
            "paddingTop",
            "paddingBottom"
        ]
    },
    bg: {
        type: "color",
        property: "background"
    },
    c: {
        type: "color",
        property: "color"
    },
    opacity: {
        type: "identity",
        property: "opacity"
    },
    ff: {
        type: "identity",
        property: "fontFamily"
    },
    fz: {
        type: "fontSize",
        property: "fontSize"
    },
    fw: {
        type: "identity",
        property: "fontWeight"
    },
    lts: {
        type: "size",
        property: "letterSpacing"
    },
    ta: {
        type: "identity",
        property: "textAlign"
    },
    lh: {
        type: "identity",
        property: "lineHeight"
    },
    fs: {
        type: "identity",
        property: "fontStyle"
    },
    tt: {
        type: "identity",
        property: "textTransform"
    },
    td: {
        type: "identity",
        property: "textDecoration"
    },
    w: {
        type: "spacing",
        property: "width"
    },
    miw: {
        type: "spacing",
        property: "minWidth"
    },
    maw: {
        type: "spacing",
        property: "maxWidth"
    },
    h: {
        type: "spacing",
        property: "height"
    },
    mih: {
        type: "spacing",
        property: "minHeight"
    },
    mah: {
        type: "spacing",
        property: "maxHeight"
    },
    bgsz: {
        type: "size",
        property: "backgroundSize"
    },
    bgp: {
        type: "identity",
        property: "backgroundPosition"
    },
    bgr: {
        type: "identity",
        property: "backgroundRepeat"
    },
    bga: {
        type: "identity",
        property: "backgroundAttachment"
    },
    pos: {
        type: "identity",
        property: "position"
    },
    top: {
        type: "identity",
        property: "top"
    },
    left: {
        type: "size",
        property: "left"
    },
    bottom: {
        type: "size",
        property: "bottom"
    },
    right: {
        type: "size",
        property: "right"
    },
    inset: {
        type: "size",
        property: "inset"
    },
    display: {
        type: "identity",
        property: "display"
    }
};

});





parcelRegister("5etRf", function(module, exports) {

$parcel$export(module.exports, "UnstyledButton", () => $3cf56bb2500d5030$export$3167f6ecaaaa3457);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $jktAC = parcelRequire("jktAC");

var $hiiR1 = parcelRequire("hiiR1");
var $3cf56bb2500d5030$var$__defProp = Object.defineProperty;
var $3cf56bb2500d5030$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3cf56bb2500d5030$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3cf56bb2500d5030$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3cf56bb2500d5030$var$__defNormalProp = (obj, key, value)=>key in obj ? $3cf56bb2500d5030$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3cf56bb2500d5030$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3cf56bb2500d5030$var$__hasOwnProp.call(b, prop)) $3cf56bb2500d5030$var$__defNormalProp(a, prop, b[prop]);
    if ($3cf56bb2500d5030$var$__getOwnPropSymbols) {
        for (var prop of $3cf56bb2500d5030$var$__getOwnPropSymbols(b))if ($3cf56bb2500d5030$var$__propIsEnum.call(b, prop)) $3cf56bb2500d5030$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3cf56bb2500d5030$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3cf56bb2500d5030$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3cf56bb2500d5030$var$__getOwnPropSymbols) {
        for (var prop of $3cf56bb2500d5030$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3cf56bb2500d5030$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3cf56bb2500d5030$export$43fb032d6aaf43c8 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("UnstyledButton", {}, props), { className: className, component: component = "button", unstyled: unstyled, variant: variant } = _a, others = $3cf56bb2500d5030$var$__objRest(_a, [
        "className",
        "component",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $jktAC.default)(null, {
        name: "UnstyledButton",
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $3cf56bb2500d5030$var$__spreadValues({
        component: component,
        ref: ref,
        className: cx(classes.root, className),
        type: component === "button" ? "button" : void 0
    }, others));
});
$3cf56bb2500d5030$export$43fb032d6aaf43c8.displayName = "@mantine/core/UnstyledButton";
const $3cf56bb2500d5030$export$3167f6ecaaaa3457 = (0, $1euea.createPolymorphicComponent)($3cf56bb2500d5030$export$43fb032d6aaf43c8);

});
parcelRegister("jktAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e126d673c6cffbe3$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $e126d673c6cffbe3$var$__defProp = Object.defineProperty;
var $e126d673c6cffbe3$var$__defProps = Object.defineProperties;
var $e126d673c6cffbe3$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e126d673c6cffbe3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e126d673c6cffbe3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e126d673c6cffbe3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e126d673c6cffbe3$var$__defNormalProp = (obj, key, value)=>key in obj ? $e126d673c6cffbe3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e126d673c6cffbe3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e126d673c6cffbe3$var$__hasOwnProp.call(b, prop)) $e126d673c6cffbe3$var$__defNormalProp(a, prop, b[prop]);
    if ($e126d673c6cffbe3$var$__getOwnPropSymbols) {
        for (var prop of $e126d673c6cffbe3$var$__getOwnPropSymbols(b))if ($e126d673c6cffbe3$var$__propIsEnum.call(b, prop)) $e126d673c6cffbe3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e126d673c6cffbe3$var$__spreadProps = (a, b)=>$e126d673c6cffbe3$var$__defProps(a, $e126d673c6cffbe3$var$__getOwnPropDescs(b));
var $e126d673c6cffbe3$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        root: $e126d673c6cffbe3$var$__spreadProps($e126d673c6cffbe3$var$__spreadValues($e126d673c6cffbe3$var$__spreadValues({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
            cursor: "pointer",
            border: 0,
            padding: 0,
            appearance: "none",
            fontSize: theme.fontSizes.md,
            backgroundColor: "transparent",
            textAlign: "left",
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            textDecoration: "none",
            boxSizing: "border-box"
        })
    }));
var $e126d673c6cffbe3$export$2e2bcd8739ae039 = $e126d673c6cffbe3$var$useStyles;

});



parcelRegister("hxtH1", function(module, exports) {

$parcel$export(module.exports, "AppShellProvider", () => $cc4c8d1e680e0ec7$export$f1c70b06465d541e);
$parcel$export(module.exports, "useAppShellContext", () => $cc4c8d1e680e0ec7$export$6a9abcfe5948d367);

var $acw62 = parcelRequire("acw62");
const $cc4c8d1e680e0ec7$var$AppShellContext = (0, $acw62.createContext)({
    zIndex: 1e3,
    fixed: false,
    layout: "default"
});
const $cc4c8d1e680e0ec7$export$f1c70b06465d541e = $cc4c8d1e680e0ec7$var$AppShellContext.Provider;
function $cc4c8d1e680e0ec7$export$6a9abcfe5948d367() {
    return (0, $acw62.useContext)($cc4c8d1e680e0ec7$var$AppShellContext);
}

});

parcelRegister("9mTYo", function(module, exports) {

$parcel$export(module.exports, "Group", () => $6d21963b5dc80391$export$eb2fcfdbd7ba97d4);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $84lyE = parcelRequire("84lyE");

var $9vT0L = parcelRequire("9vT0L");

var $hiiR1 = parcelRequire("hiiR1");
var $6d21963b5dc80391$var$__defProp = Object.defineProperty;
var $6d21963b5dc80391$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6d21963b5dc80391$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6d21963b5dc80391$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6d21963b5dc80391$var$__defNormalProp = (obj, key, value)=>key in obj ? $6d21963b5dc80391$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6d21963b5dc80391$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6d21963b5dc80391$var$__hasOwnProp.call(b, prop)) $6d21963b5dc80391$var$__defNormalProp(a, prop, b[prop]);
    if ($6d21963b5dc80391$var$__getOwnPropSymbols) {
        for (var prop of $6d21963b5dc80391$var$__getOwnPropSymbols(b))if ($6d21963b5dc80391$var$__propIsEnum.call(b, prop)) $6d21963b5dc80391$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6d21963b5dc80391$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6d21963b5dc80391$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6d21963b5dc80391$var$__getOwnPropSymbols) {
        for (var prop of $6d21963b5dc80391$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6d21963b5dc80391$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $6d21963b5dc80391$var$defaultProps = {
    position: "left",
    spacing: "md"
};
const $6d21963b5dc80391$export$eb2fcfdbd7ba97d4 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Group", $6d21963b5dc80391$var$defaultProps, props), { className: className, position: position, align: align, children: children, noWrap: noWrap, grow: grow, spacing: spacing, unstyled: unstyled, variant: variant } = _a, others = $6d21963b5dc80391$var$__objRest(_a, [
        "className",
        "position",
        "align",
        "children",
        "noWrap",
        "grow",
        "spacing",
        "unstyled",
        "variant"
    ]);
    const filteredChildren = (0, $84lyE.filterFalsyChildren)(children);
    const { classes: classes, cx: cx } = (0, $9vT0L.default)({
        align: align,
        grow: grow,
        noWrap: noWrap,
        spacing: spacing,
        position: position,
        count: filteredChildren.length
    }, {
        unstyled: unstyled,
        name: "Group",
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $6d21963b5dc80391$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), filteredChildren);
});
$6d21963b5dc80391$export$eb2fcfdbd7ba97d4.displayName = "@mantine/core/Group";

});
parcelRegister("84lyE", function(module, exports) {

$parcel$export(module.exports, "filterFalsyChildren", () => $5dff6b6591ee6751$export$21ff29ccd4c87981);

var $acw62 = parcelRequire("acw62");
function $5dff6b6591ee6751$export$21ff29ccd4c87981(children) {
    return (0, $acw62.Children).toArray(children).filter(Boolean);
}

});

parcelRegister("9vT0L", function(module, exports) {

$parcel$export(module.exports, "GROUP_POSITIONS", () => $6ed1ae6c3cf5e947$export$cf5f4f12c0a671bd);
$parcel$export(module.exports, "default", () => $6ed1ae6c3cf5e947$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
const $6ed1ae6c3cf5e947$export$cf5f4f12c0a671bd = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
    apart: "space-between"
};
var $6ed1ae6c3cf5e947$var$useStyles = (0, $cQG1Y.createStyles)((theme, { spacing: spacing, position: position, noWrap: noWrap, grow: grow, align: align, count: count })=>({
        root: {
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row",
            alignItems: align || "center",
            flexWrap: noWrap ? "nowrap" : "wrap",
            justifyContent: $6ed1ae6c3cf5e947$export$cf5f4f12c0a671bd[position],
            gap: (0, $d8Ix8.getSize)({
                size: spacing,
                sizes: theme.spacing
            }),
            "& > *": {
                boxSizing: "border-box",
                maxWidth: grow ? `calc(${100 / count}% - (${(0, $2jkdX.rem)((0, $d8Ix8.getSize)({
                    size: spacing,
                    sizes: theme.spacing
                }))} - ${(0, $d8Ix8.getSize)({
                    size: spacing,
                    sizes: theme.spacing
                })} / ${count}))` : void 0,
                flexGrow: grow ? 1 : 0
            }
        }
    }));
var $6ed1ae6c3cf5e947$export$2e2bcd8739ae039 = $6ed1ae6c3cf5e947$var$useStyles;

});


parcelRegister("5MBWk", function(module, exports) {

$parcel$export(module.exports, "Header", () => $435edd82251afc97$export$8b251419efc915eb);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $2N66l = parcelRequire("2N66l");
var $435edd82251afc97$var$__defProp = Object.defineProperty;
var $435edd82251afc97$var$__defProps = Object.defineProperties;
var $435edd82251afc97$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $435edd82251afc97$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $435edd82251afc97$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $435edd82251afc97$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $435edd82251afc97$var$__defNormalProp = (obj, key, value)=>key in obj ? $435edd82251afc97$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $435edd82251afc97$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($435edd82251afc97$var$__hasOwnProp.call(b, prop)) $435edd82251afc97$var$__defNormalProp(a, prop, b[prop]);
    if ($435edd82251afc97$var$__getOwnPropSymbols) {
        for (var prop of $435edd82251afc97$var$__getOwnPropSymbols(b))if ($435edd82251afc97$var$__propIsEnum.call(b, prop)) $435edd82251afc97$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $435edd82251afc97$var$__spreadProps = (a, b)=>$435edd82251afc97$var$__defProps(a, $435edd82251afc97$var$__getOwnPropDescs(b));
const $435edd82251afc97$var$defaultProps = {
    fixed: false,
    position: {
        top: 0,
        left: 0,
        right: 0
    }
};
const $435edd82251afc97$export$8b251419efc915eb = (0, $acw62.forwardRef)((props, ref)=>{
    const _props = (0, $64A2P.useComponentDefaultProps)("Header", $435edd82251afc97$var$defaultProps, props);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2N66l.VerticalSection), $435edd82251afc97$var$__spreadProps($435edd82251afc97$var$__spreadValues({
        section: "header",
        __staticSelector: "Header"
    }, _props), {
        ref: ref
    }));
});
$435edd82251afc97$export$8b251419efc915eb.displayName = "@mantine/core/Header";

});
parcelRegister("2N66l", function(module, exports) {

$parcel$export(module.exports, "VerticalSection", () => $2084e3f8b3c984f1$export$149ef4614ad2ca5b);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $iu1L3 = parcelRequire("iu1L3");
var $6Koyj = parcelRequire("6Koyj");

var $hxtH1 = parcelRequire("hxtH1");

var $cOigE = parcelRequire("cOigE");

var $aXEws = parcelRequire("aXEws");

var $hiiR1 = parcelRequire("hiiR1");
var $2084e3f8b3c984f1$var$__defProp = Object.defineProperty;
var $2084e3f8b3c984f1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2084e3f8b3c984f1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2084e3f8b3c984f1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2084e3f8b3c984f1$var$__defNormalProp = (obj, key, value)=>key in obj ? $2084e3f8b3c984f1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2084e3f8b3c984f1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2084e3f8b3c984f1$var$__hasOwnProp.call(b, prop)) $2084e3f8b3c984f1$var$__defNormalProp(a, prop, b[prop]);
    if ($2084e3f8b3c984f1$var$__getOwnPropSymbols) {
        for (var prop of $2084e3f8b3c984f1$var$__getOwnPropSymbols(b))if ($2084e3f8b3c984f1$var$__propIsEnum.call(b, prop)) $2084e3f8b3c984f1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2084e3f8b3c984f1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2084e3f8b3c984f1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2084e3f8b3c984f1$var$__getOwnPropSymbols) {
        for (var prop of $2084e3f8b3c984f1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2084e3f8b3c984f1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $2084e3f8b3c984f1$export$149ef4614ad2ca5b = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { children: children, className: className, classNames: classNames, styles: styles, height: height, fixed: fixed = false, withBorder: withBorder = true, position: position, zIndex: zIndex, section: section, unstyled: unstyled, __staticSelector: __staticSelector, variant: variant } = _b, others = $2084e3f8b3c984f1$var$__objRest(_b, [
        "children",
        "className",
        "classNames",
        "styles",
        "height",
        "fixed",
        "withBorder",
        "position",
        "zIndex",
        "section",
        "unstyled",
        "__staticSelector",
        "variant"
    ]);
    const ctx = (0, $hxtH1.useAppShellContext)();
    const _zIndex = zIndex || ctx.zIndex || (0, $iu1L3.getDefaultZIndex)("app");
    const { classes: classes, cx: cx, theme: theme } = (0, $cOigE.default)({
        height: height,
        fixed: ctx.fixed || fixed,
        position: position,
        zIndex: typeof _zIndex === "number" && ctx.layout === "default" ? _zIndex + 1 : _zIndex,
        layout: ctx.layout,
        borderPosition: withBorder ? section === "header" ? "bottom" : "top" : "none"
    }, {
        name: __staticSelector,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    const breakpoints = typeof height === "object" && height !== null ? (0, $aXEws.getSortedBreakpoints)(height, theme).reduce((acc, [breakpoint, breakpointSize])=>{
        acc[`@media (min-width: ${(0, $2jkdX.em)(breakpoint)})`] = {
            [`--mantine-${section}-height`]: (0, $2jkdX.rem)(breakpointSize)
        };
        return acc;
    }, {}) : null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $2084e3f8b3c984f1$var$__spreadValues({
        component: section === "header" ? "header" : "footer",
        className: cx(classes.root, className),
        ref: ref
    }, others), children, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Koyj.Global), {
        styles: ()=>({
                ":root": $2084e3f8b3c984f1$var$__spreadValues({
                    [`--mantine-${section}-height`]: typeof height === "object" ? (0, $2jkdX.rem)(height == null ? void 0 : height.base) || "100%" : (0, $2jkdX.rem)(height)
                }, breakpoints)
            })
    }));
});
$2084e3f8b3c984f1$export$149ef4614ad2ca5b.displayName = "@mantine/core/VerticalSection";

});
parcelRegister("iu1L3", function(module, exports) {

$parcel$export(module.exports, "getDefaultZIndex", () => $d74c6468f94d3d98$export$65573e7d509c92dc);
const $d74c6468f94d3d98$var$elevations = {
    app: 100,
    modal: 200,
    popover: 300,
    overlay: 400,
    max: 9999
};
function $d74c6468f94d3d98$export$65573e7d509c92dc(level) {
    return $d74c6468f94d3d98$var$elevations[level];
}

});

parcelRegister("6Koyj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $4e9a158ef4afd47e$export$98f03c5d19621d70);

var $acw62 = parcelRequire("acw62");

var $jjlaj = parcelRequire("jjlaj");

var $64A2P = parcelRequire("64A2P");
function $4e9a158ef4afd47e$export$98f03c5d19621d70({ styles: styles }) {
    const theme = (0, $64A2P.useMantineTheme)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jjlaj.Global), {
        styles: (0, $jjlaj.css)(typeof styles === "function" ? styles(theme) : styles)
    });
}

});

parcelRegister("cOigE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9538531bded84d80$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");

var $aXEws = parcelRequire("aXEws");
var $9538531bded84d80$var$__defProp = Object.defineProperty;
var $9538531bded84d80$var$__defProps = Object.defineProperties;
var $9538531bded84d80$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $9538531bded84d80$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9538531bded84d80$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9538531bded84d80$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9538531bded84d80$var$__defNormalProp = (obj, key, value)=>key in obj ? $9538531bded84d80$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9538531bded84d80$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9538531bded84d80$var$__hasOwnProp.call(b, prop)) $9538531bded84d80$var$__defNormalProp(a, prop, b[prop]);
    if ($9538531bded84d80$var$__getOwnPropSymbols) {
        for (var prop of $9538531bded84d80$var$__getOwnPropSymbols(b))if ($9538531bded84d80$var$__propIsEnum.call(b, prop)) $9538531bded84d80$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9538531bded84d80$var$__spreadProps = (a, b)=>$9538531bded84d80$var$__defProps(a, $9538531bded84d80$var$__getOwnPropDescs(b));
var $9538531bded84d80$var$useStyles = (0, $cQG1Y.createStyles)((theme, { height: height, fixed: fixed, position: position, zIndex: zIndex, borderPosition: borderPosition, layout: layout })=>{
    const breakpoints = typeof height === "object" && height !== null ? (0, $aXEws.getSortedBreakpoints)(height, theme).reduce((acc, [breakpoint, breakpointSize])=>{
        acc[`@media (min-width: ${(0, $2jkdX.em)(breakpoint)})`] = {
            height: (0, $2jkdX.rem)(breakpointSize),
            minHeight: (0, $2jkdX.rem)(breakpointSize)
        };
        return acc;
    }, {}) : null;
    return {
        root: $9538531bded84d80$var$__spreadProps($9538531bded84d80$var$__spreadValues($9538531bded84d80$var$__spreadProps($9538531bded84d80$var$__spreadValues($9538531bded84d80$var$__spreadValues({}, theme.fn.fontStyles()), position), {
            zIndex: zIndex,
            left: layout === "alt" ? "var(--mantine-navbar-width, 0)" : 0,
            right: layout === "alt" ? "var(--mantine-aside-width, 0)" : 0,
            height: typeof height === "object" ? (0, $2jkdX.rem)(height == null ? void 0 : height.base) || "100%" : (0, $2jkdX.rem)(height),
            maxHeight: typeof height === "object" ? (0, $2jkdX.rem)(height == null ? void 0 : height.base) || "100%" : (0, $2jkdX.rem)(height),
            position: fixed ? "fixed" : "static",
            boxSizing: "border-box",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
        }), breakpoints), {
            borderBottom: borderPosition === "bottom" ? `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]}` : void 0,
            borderTop: borderPosition === "top" ? `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]}` : void 0
        })
    };
});
var $9538531bded84d80$export$2e2bcd8739ae039 = $9538531bded84d80$var$useStyles;

});
parcelRegister("aXEws", function(module, exports) {

$parcel$export(module.exports, "getSortedBreakpoints", () => $7faed8fcd1743052$export$bd80382e31449c0e);

var $2vpKc = parcelRequire("2vpKc");
var $d8Ix8 = parcelRequire("d8Ix8");
function $7faed8fcd1743052$export$bd80382e31449c0e(breakpoints, theme) {
    if (!breakpoints) return [];
    const values = Object.keys(breakpoints).filter((breakpoint)=>breakpoint !== "base").map((breakpoint)=>[
            (0, $d8Ix8.getSize)({
                size: breakpoint,
                sizes: theme.breakpoints,
                units: "em"
            }),
            breakpoints[breakpoint]
        ]);
    values.sort((a, b)=>(0, $2vpKc.getBreakpointValue)(a[0]) - (0, $2vpKc.getBreakpointValue)(b[0]));
    return values;
}

});




parcelRegister("d5Zz2", function(module, exports) {

$parcel$export(module.exports, "Navbar", () => $988b7f5967848ea8$export$42cfbb80f7861e77);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $8OFlG = parcelRequire("8OFlG");

var $8TIda = parcelRequire("8TIda");
var $988b7f5967848ea8$var$__defProp = Object.defineProperty;
var $988b7f5967848ea8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $988b7f5967848ea8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $988b7f5967848ea8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $988b7f5967848ea8$var$__defNormalProp = (obj, key, value)=>key in obj ? $988b7f5967848ea8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $988b7f5967848ea8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($988b7f5967848ea8$var$__hasOwnProp.call(b, prop)) $988b7f5967848ea8$var$__defNormalProp(a, prop, b[prop]);
    if ($988b7f5967848ea8$var$__getOwnPropSymbols) {
        for (var prop of $988b7f5967848ea8$var$__getOwnPropSymbols(b))if ($988b7f5967848ea8$var$__propIsEnum.call(b, prop)) $988b7f5967848ea8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
const $988b7f5967848ea8$var$defaultProps = {
    fixed: false,
    position: {
        top: 0,
        left: 0
    },
    hiddenBreakpoint: "md",
    hidden: false
};
const $988b7f5967848ea8$export$42cfbb80f7861e77 = (0, $acw62.forwardRef)((props, ref)=>{
    const _props = (0, $64A2P.useComponentDefaultProps)("Navbar", $988b7f5967848ea8$var$defaultProps, props);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8OFlG.HorizontalSection), $988b7f5967848ea8$var$__spreadValues({
        section: "navbar",
        __staticSelector: "Navbar",
        ref: ref
    }, _props));
});
$988b7f5967848ea8$export$42cfbb80f7861e77.Section = (0, $8TIda.Section);
$988b7f5967848ea8$export$42cfbb80f7861e77.displayName = "@mantine/core/Navbar";

});
parcelRegister("8OFlG", function(module, exports) {

$parcel$export(module.exports, "HorizontalSection", () => $66b31137aed791a9$export$7dad0d93c31a1baa);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $iu1L3 = parcelRequire("iu1L3");
var $6Koyj = parcelRequire("6Koyj");

var $hxtH1 = parcelRequire("hxtH1");

var $aXEws = parcelRequire("aXEws");

var $3H5sX = parcelRequire("3H5sX");

var $hiiR1 = parcelRequire("hiiR1");
var $66b31137aed791a9$var$__defProp = Object.defineProperty;
var $66b31137aed791a9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $66b31137aed791a9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $66b31137aed791a9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $66b31137aed791a9$var$__defNormalProp = (obj, key, value)=>key in obj ? $66b31137aed791a9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $66b31137aed791a9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($66b31137aed791a9$var$__hasOwnProp.call(b, prop)) $66b31137aed791a9$var$__defNormalProp(a, prop, b[prop]);
    if ($66b31137aed791a9$var$__getOwnPropSymbols) {
        for (var prop of $66b31137aed791a9$var$__getOwnPropSymbols(b))if ($66b31137aed791a9$var$__propIsEnum.call(b, prop)) $66b31137aed791a9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $66b31137aed791a9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($66b31137aed791a9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $66b31137aed791a9$var$__getOwnPropSymbols) {
        for (var prop of $66b31137aed791a9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $66b31137aed791a9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $66b31137aed791a9$export$7dad0d93c31a1baa = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { width: width, height: height, fixed: fixed = false, position: position, zIndex: zIndex, hiddenBreakpoint: hiddenBreakpoint = "md", hidden: hidden = false, withBorder: withBorder = true, className: className, classNames: classNames, styles: styles, children: children, section: section, __staticSelector: __staticSelector, unstyled: unstyled, variant: variant } = _b, others = $66b31137aed791a9$var$__objRest(_b, [
        "width",
        "height",
        "fixed",
        "position",
        "zIndex",
        "hiddenBreakpoint",
        "hidden",
        "withBorder",
        "className",
        "classNames",
        "styles",
        "children",
        "section",
        "__staticSelector",
        "unstyled",
        "variant"
    ]);
    const ctx = (0, $hxtH1.useAppShellContext)();
    const { classes: classes, cx: cx, theme: theme } = (0, $3H5sX.default)({
        width: width,
        height: height,
        fixed: ctx.fixed || fixed,
        position: position,
        hiddenBreakpoint: hiddenBreakpoint,
        zIndex: zIndex || ctx.zIndex || (0, $iu1L3.getDefaultZIndex)("app"),
        section: section,
        withBorder: withBorder,
        layout: ctx.layout
    }, {
        classNames: classNames,
        styles: styles,
        name: __staticSelector,
        unstyled: unstyled,
        variant: variant
    });
    const breakpoints = (0, $aXEws.getSortedBreakpoints)(width, theme).reduce((acc, [breakpoint, breakpointSize])=>{
        acc[`@media (min-width: ${(0, $2jkdX.em)(breakpoint)})`] = {
            [`--mantine-${section}-width`]: (0, $2jkdX.rem)(breakpointSize)
        };
        return acc;
    }, {});
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $66b31137aed791a9$var$__spreadValues({
        component: section === "navbar" ? "nav" : "aside",
        ref: ref,
        "data-hidden": hidden || void 0,
        className: cx(classes.root, className)
    }, others), children, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Koyj.Global), {
        styles: ()=>({
                ":root": $66b31137aed791a9$var$__spreadValues({
                    [`--mantine-${section}-width`]: (width == null ? void 0 : width.base) ? (0, $2jkdX.rem)(width.base) : "0rem"
                }, breakpoints)
            })
    }));
});
$66b31137aed791a9$export$7dad0d93c31a1baa.displayName = "@mantine/core/HorizontalSection";

});
parcelRegister("3H5sX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b09a0b4e6e1eca0$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $2vpKc = parcelRequire("2vpKc");
var $d8Ix8 = parcelRequire("d8Ix8");

var $aXEws = parcelRequire("aXEws");
var $2b09a0b4e6e1eca0$var$__defProp = Object.defineProperty;
var $2b09a0b4e6e1eca0$var$__defProps = Object.defineProperties;
var $2b09a0b4e6e1eca0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2b09a0b4e6e1eca0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2b09a0b4e6e1eca0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2b09a0b4e6e1eca0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2b09a0b4e6e1eca0$var$__defNormalProp = (obj, key, value)=>key in obj ? $2b09a0b4e6e1eca0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2b09a0b4e6e1eca0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2b09a0b4e6e1eca0$var$__hasOwnProp.call(b, prop)) $2b09a0b4e6e1eca0$var$__defNormalProp(a, prop, b[prop]);
    if ($2b09a0b4e6e1eca0$var$__getOwnPropSymbols) {
        for (var prop of $2b09a0b4e6e1eca0$var$__getOwnPropSymbols(b))if ($2b09a0b4e6e1eca0$var$__propIsEnum.call(b, prop)) $2b09a0b4e6e1eca0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2b09a0b4e6e1eca0$var$__spreadProps = (a, b)=>$2b09a0b4e6e1eca0$var$__defProps(a, $2b09a0b4e6e1eca0$var$__getOwnPropDescs(b));
var $2b09a0b4e6e1eca0$var$useStyles = (0, $cQG1Y.createStyles)((theme, { height: height, width: width, fixed: fixed, position: position, hiddenBreakpoint: hiddenBreakpoint, zIndex: zIndex, section: section, withBorder: withBorder, layout: layout })=>{
    const breakpoints = typeof width === "object" && width !== null ? (0, $aXEws.getSortedBreakpoints)(width, theme).reduce((acc, [breakpoint, breakpointSize])=>{
        acc[`@media (min-width: ${(0, $2jkdX.em)(breakpoint)})`] = {
            width: (0, $2jkdX.rem)(breakpointSize),
            minWidth: (0, $2jkdX.rem)(breakpointSize)
        };
        return acc;
    }, {}) : null;
    const borderStyles = withBorder ? {
        [section === "navbar" ? "borderRight" : "borderLeft"]: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2]}`
    } : {};
    return {
        root: $2b09a0b4e6e1eca0$var$__spreadProps($2b09a0b4e6e1eca0$var$__spreadValues($2b09a0b4e6e1eca0$var$__spreadValues($2b09a0b4e6e1eca0$var$__spreadProps($2b09a0b4e6e1eca0$var$__spreadValues($2b09a0b4e6e1eca0$var$__spreadValues({}, theme.fn.fontStyles()), position), {
            top: layout === "alt" ? 0 : (position == null ? void 0 : position.top) || "var(--mantine-header-height)",
            bottom: 0,
            zIndex: zIndex,
            height: height ? (0, $2jkdX.rem)(height) : layout === "alt" ? "auto" : "calc(100vh - var(--mantine-header-height, 0rem) - var(--mantine-footer-height, 0rem))",
            width: (width == null ? void 0 : width.base) ? (0, $2jkdX.rem)(width == null ? void 0 : width.base) : "100%",
            position: fixed ? "fixed" : "static",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
        }), borderStyles), breakpoints), {
            "&[data-hidden]": {
                [`@media (max-width: ${(0, $2jkdX.em)((0, $2vpKc.getBreakpointValue)((0, $d8Ix8.getSize)({
                    size: hiddenBreakpoint,
                    sizes: theme.breakpoints
                })) - 1)})`]: {
                    display: "none"
                }
            }
        })
    };
});
var $2b09a0b4e6e1eca0$export$2e2bcd8739ae039 = $2b09a0b4e6e1eca0$var$useStyles;

});


parcelRegister("8TIda", function(module, exports) {

$parcel$export(module.exports, "Section", () => $67a5c13a6a135135$export$6e2c8f0811a474ce);

var $acw62 = parcelRequire("acw62");

var $1euea = parcelRequire("1euea");
var $g71zw = parcelRequire("g71zw");

var $hiiR1 = parcelRequire("hiiR1");
var $67a5c13a6a135135$var$__defProp = Object.defineProperty;
var $67a5c13a6a135135$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $67a5c13a6a135135$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $67a5c13a6a135135$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $67a5c13a6a135135$var$__defNormalProp = (obj, key, value)=>key in obj ? $67a5c13a6a135135$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $67a5c13a6a135135$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($67a5c13a6a135135$var$__hasOwnProp.call(b, prop)) $67a5c13a6a135135$var$__defNormalProp(a, prop, b[prop]);
    if ($67a5c13a6a135135$var$__getOwnPropSymbols) {
        for (var prop of $67a5c13a6a135135$var$__getOwnPropSymbols(b))if ($67a5c13a6a135135$var$__propIsEnum.call(b, prop)) $67a5c13a6a135135$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $67a5c13a6a135135$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($67a5c13a6a135135$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $67a5c13a6a135135$var$__getOwnPropSymbols) {
        for (var prop of $67a5c13a6a135135$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $67a5c13a6a135135$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $67a5c13a6a135135$export$e6e4d727a4ccb450 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { children: children, grow: grow = false, sx: sx } = _b, others = $67a5c13a6a135135$var$__objRest(_b, [
        "children",
        "grow",
        "sx"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $67a5c13a6a135135$var$__spreadValues({
        ref: ref,
        sx: [
            {
                flex: grow ? 1 : 0,
                boxSizing: "border-box"
            },
            ...(0, $g71zw.packSx)(sx)
        ]
    }, others), children);
});
$67a5c13a6a135135$export$e6e4d727a4ccb450.displayName = "@mantine/core/Section";
const $67a5c13a6a135135$export$6e2c8f0811a474ce = (0, $1euea.createPolymorphicComponent)($67a5c13a6a135135$export$e6e4d727a4ccb450);

});
parcelRegister("g71zw", function(module, exports) {

$parcel$export(module.exports, "packSx", () => $bbae84f2231a90b2$export$164a2904c062536b);
function $bbae84f2231a90b2$export$164a2904c062536b(sx) {
    return Array.isArray(sx) ? sx : [
        sx
    ];
}

});



parcelRegister("cnNDs", function(module, exports) {

$parcel$export(module.exports, "DatesProviderContext", () => $903e229883ccd5fb$export$9401b5fd8bf7e869);
$parcel$export(module.exports, "DatesProvider", () => $903e229883ccd5fb$export$241f86cde8f2a5b8);

var $acw62 = parcelRequire("acw62");
var $903e229883ccd5fb$var$__defProp = Object.defineProperty;
var $903e229883ccd5fb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $903e229883ccd5fb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $903e229883ccd5fb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $903e229883ccd5fb$var$__defNormalProp = (obj, key, value)=>key in obj ? $903e229883ccd5fb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $903e229883ccd5fb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($903e229883ccd5fb$var$__hasOwnProp.call(b, prop)) $903e229883ccd5fb$var$__defNormalProp(a, prop, b[prop]);
    if ($903e229883ccd5fb$var$__getOwnPropSymbols) {
        for (var prop of $903e229883ccd5fb$var$__getOwnPropSymbols(b))if ($903e229883ccd5fb$var$__propIsEnum.call(b, prop)) $903e229883ccd5fb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
const $903e229883ccd5fb$export$ed2fa51fbcc879f1 = {
    locale: "en",
    firstDayOfWeek: 1,
    weekendDays: [
        0,
        6
    ],
    labelSeparator: "\u2013"
};
const $903e229883ccd5fb$export$9401b5fd8bf7e869 = (0, $acw62.createContext)($903e229883ccd5fb$export$ed2fa51fbcc879f1);
function $903e229883ccd5fb$export$241f86cde8f2a5b8({ settings: settings, children: children }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($903e229883ccd5fb$export$9401b5fd8bf7e869.Provider, {
        value: $903e229883ccd5fb$var$__spreadValues($903e229883ccd5fb$var$__spreadValues({}, $903e229883ccd5fb$export$ed2fa51fbcc879f1), settings)
    }, children);
}

});

parcelRegister("agugM", function(module, exports) {

$parcel$export(module.exports, "useColorScheme", () => $7792e0e7d8101e38$export$6343629ee1b29116);

var $kFu1s = parcelRequire("kFu1s");
function $7792e0e7d8101e38$export$6343629ee1b29116(initialValue, options) {
    return (0, $kFu1s.useMediaQuery)("(prefers-color-scheme: dark)", initialValue === "dark", options) ? "dark" : "light";
}

});
parcelRegister("kFu1s", function(module, exports) {

$parcel$export(module.exports, "useMediaQuery", () => $f0beecd236dd6c18$export$32d5543ab307c01);

var $acw62 = parcelRequire("acw62");
function $f0beecd236dd6c18$var$attachMediaListener(query, callback) {
    try {
        query.addEventListener("change", callback);
        return ()=>query.removeEventListener("change", callback);
    } catch (e) {
        query.addListener(callback);
        return ()=>query.removeListener(callback);
    }
}
function $f0beecd236dd6c18$var$getInitialValue(query, initialValue) {
    if (typeof initialValue === "boolean") return initialValue;
    if (typeof window !== "undefined" && "matchMedia" in window) return window.matchMedia(query).matches;
    return false;
}
function $f0beecd236dd6c18$export$32d5543ab307c01(query, initialValue, { getInitialValueInEffect: getInitialValueInEffect } = {
    getInitialValueInEffect: true
}) {
    const [matches, setMatches] = (0, $acw62.useState)(getInitialValueInEffect ? initialValue : $f0beecd236dd6c18$var$getInitialValue(query, initialValue));
    const queryRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        if ("matchMedia" in window) {
            queryRef.current = window.matchMedia(query);
            setMatches(queryRef.current.matches);
            return $f0beecd236dd6c18$var$attachMediaListener(queryRef.current, (event)=>setMatches(event.matches));
        }
        return void 0;
    }, [
        query
    ]);
    return matches;
}

});


parcelRegister("jqu36", function(module, exports) {

$parcel$export(module.exports, "useHotkeys", () => $e247c1267bb876fc$export$1b0c17123b4f3646);

var $acw62 = parcelRequire("acw62");

var $bb0rG = parcelRequire("bb0rG");
function $e247c1267bb876fc$var$shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable = false) {
    if (event.target instanceof HTMLElement) {
        if (triggerOnContentEditable) return !tagsToIgnore.includes(event.target.tagName);
        return !event.target.isContentEditable && !tagsToIgnore.includes(event.target.tagName);
    }
    return true;
}
function $e247c1267bb876fc$export$1b0c17123b4f3646(hotkeys, tagsToIgnore = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
], triggerOnContentEditable = false) {
    (0, $acw62.useEffect)(()=>{
        const keydownListener = (event)=>{
            hotkeys.forEach(([hotkey, handler, options = {
                preventDefault: true
            }])=>{
                if ((0, $bb0rG.getHotkeyMatcher)(hotkey)(event) && $e247c1267bb876fc$var$shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable)) {
                    if (options.preventDefault) event.preventDefault();
                    handler(event);
                }
            });
        };
        document.documentElement.addEventListener("keydown", keydownListener);
        return ()=>document.documentElement.removeEventListener("keydown", keydownListener);
    }, [
        hotkeys
    ]);
}

});
parcelRegister("bb0rG", function(module, exports) {

$parcel$export(module.exports, "getHotkeyMatcher", () => $8231113df4c177e3$export$8524ed87cddba49e);
var $8231113df4c177e3$var$__defProp = Object.defineProperty;
var $8231113df4c177e3$var$__defProps = Object.defineProperties;
var $8231113df4c177e3$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8231113df4c177e3$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8231113df4c177e3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8231113df4c177e3$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8231113df4c177e3$var$__defNormalProp = (obj, key, value)=>key in obj ? $8231113df4c177e3$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8231113df4c177e3$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8231113df4c177e3$var$__hasOwnProp.call(b, prop)) $8231113df4c177e3$var$__defNormalProp(a, prop, b[prop]);
    if ($8231113df4c177e3$var$__getOwnPropSymbols) {
        for (var prop of $8231113df4c177e3$var$__getOwnPropSymbols(b))if ($8231113df4c177e3$var$__propIsEnum.call(b, prop)) $8231113df4c177e3$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8231113df4c177e3$var$__spreadProps = (a, b)=>$8231113df4c177e3$var$__defProps(a, $8231113df4c177e3$var$__getOwnPropDescs(b));
function $8231113df4c177e3$export$a801228aacb1a2ba(hotkey) {
    const keys = hotkey.toLowerCase().split("+").map((part)=>part.trim());
    const modifiers = {
        alt: keys.includes("alt"),
        ctrl: keys.includes("ctrl"),
        meta: keys.includes("meta"),
        mod: keys.includes("mod"),
        shift: keys.includes("shift")
    };
    const reservedKeys = [
        "alt",
        "ctrl",
        "meta",
        "shift",
        "mod"
    ];
    const freeKey = keys.find((key)=>!reservedKeys.includes(key));
    return $8231113df4c177e3$var$__spreadProps($8231113df4c177e3$var$__spreadValues({}, modifiers), {
        key: freeKey
    });
}
function $8231113df4c177e3$var$isExactHotkey(hotkey, event) {
    const { alt: alt, ctrl: ctrl, meta: meta, mod: mod, shift: shift, key: key } = hotkey;
    const { altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey, key: pressedKey } = event;
    if (alt !== altKey) return false;
    if (mod) {
        if (!ctrlKey && !metaKey) return false;
    } else {
        if (ctrl !== ctrlKey) return false;
        if (meta !== metaKey) return false;
    }
    if (shift !== shiftKey) return false;
    if (key && (pressedKey.toLowerCase() === key.toLowerCase() || event.code.replace("Key", "").toLowerCase() === key.toLowerCase())) return true;
    return false;
}
function $8231113df4c177e3$export$8524ed87cddba49e(hotkey) {
    return (event)=>$8231113df4c177e3$var$isExactHotkey($8231113df4c177e3$export$a801228aacb1a2ba(hotkey), event);
}
function $8231113df4c177e3$export$16fa5719b0f13579(hotkeys) {
    return (event)=>{
        const _event = "nativeEvent" in event ? event.nativeEvent : event;
        hotkeys.forEach(([hotkey, handler, options = {
            preventDefault: true
        }])=>{
            if ($8231113df4c177e3$export$8524ed87cddba49e(hotkey)(_event)) {
                if (options.preventDefault) event.preventDefault();
                handler(_event);
            }
        });
    };
}

});


parcelRegister("7jJlY", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => $553d7cfcd5f400d5$export$86e2cef2561044ac);

var $4gZrX = parcelRequire("4gZrX");
function $553d7cfcd5f400d5$export$86e2cef2561044ac(props) {
    return (0, $4gZrX.createStorage)("localStorage", "use-local-storage")(props);
}

});
parcelRegister("4gZrX", function(module, exports) {

$parcel$export(module.exports, "createStorage", () => $31c852bbbddfdd2e$export$d184a47a971dd4b9);

var $acw62 = parcelRequire("acw62");

var $dmiju = parcelRequire("dmiju");
function $31c852bbbddfdd2e$var$serializeJSON(value, hookName) {
    try {
        return JSON.stringify(value);
    } catch (error) {
        throw new Error(`@mantine/hooks ${hookName}: Failed to serialize the value`);
    }
}
function $31c852bbbddfdd2e$var$deserializeJSON(value) {
    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}
function $31c852bbbddfdd2e$export$d184a47a971dd4b9(type, hookName) {
    const eventName = type === "localStorage" ? "mantine-local-storage" : "mantine-session-storage";
    return function useStorage({ key: key, defaultValue: defaultValue, getInitialValueInEffect: getInitialValueInEffect = true, deserialize: deserialize = $31c852bbbddfdd2e$var$deserializeJSON, serialize: serialize = (value)=>$31c852bbbddfdd2e$var$serializeJSON(value, hookName) }) {
        const readStorageValue = (0, $acw62.useCallback)((skipStorage)=>{
            if (typeof window === "undefined" || !(type in window) || window[type] === null || skipStorage) return defaultValue;
            const storageValue = window[type].getItem(key);
            return storageValue !== null ? deserialize(storageValue) : defaultValue;
        }, [
            key,
            defaultValue
        ]);
        const [value, setValue] = (0, $acw62.useState)(readStorageValue(getInitialValueInEffect));
        const setStorageValue = (0, $acw62.useCallback)((val)=>{
            if (val instanceof Function) setValue((current)=>{
                const result = val(current);
                window[type].setItem(key, serialize(result));
                window.dispatchEvent(new CustomEvent(eventName, {
                    detail: {
                        key: key,
                        value: val(current)
                    }
                }));
                return result;
            });
            else {
                window[type].setItem(key, serialize(val));
                window.dispatchEvent(new CustomEvent(eventName, {
                    detail: {
                        key: key,
                        value: val
                    }
                }));
                setValue(val);
            }
        }, [
            key
        ]);
        const removeStorageValue = (0, $acw62.useCallback)(()=>{
            window[type].removeItem(key);
            window.dispatchEvent(new CustomEvent(eventName, {
                detail: {
                    key: key,
                    value: defaultValue
                }
            }));
        }, []);
        (0, $dmiju.useWindowEvent)("storage", (event)=>{
            var _a;
            if (event.storageArea === window[type] && event.key === key) setValue(deserialize((_a = event.newValue) != null ? _a : void 0));
        });
        (0, $dmiju.useWindowEvent)(eventName, (event)=>{
            if (event.detail.key === key) setValue(event.detail.value);
        });
        (0, $acw62.useEffect)(()=>{
            if (defaultValue !== void 0 && value === void 0) setStorageValue(defaultValue);
        }, [
            defaultValue,
            value,
            setStorageValue
        ]);
        (0, $acw62.useEffect)(()=>{
            if (getInitialValueInEffect) setValue(readStorageValue());
        }, [
            key
        ]);
        return [
            value === void 0 ? defaultValue : value,
            setStorageValue,
            removeStorageValue
        ];
    };
}

});
parcelRegister("dmiju", function(module, exports) {

$parcel$export(module.exports, "useWindowEvent", () => $9b9b891c0b2f376d$export$ee579bb285b8d4aa);

var $acw62 = parcelRequire("acw62");
function $9b9b891c0b2f376d$export$ee579bb285b8d4aa(type, listener, options) {
    (0, $acw62.useEffect)(()=>{
        window.addEventListener(type, listener, options);
        return ()=>window.removeEventListener(type, listener, options);
    }, [
        type,
        listener
    ]);
}

});



parcelRegister("6X2G0", function(module, exports) {

$parcel$export(module.exports, "useDisclosure", () => $50fa5443bb30ba53$export$6e3e27031a30522f);

var $acw62 = parcelRequire("acw62");
function $50fa5443bb30ba53$export$6e3e27031a30522f(initialState = false, callbacks) {
    const { onOpen: onOpen, onClose: onClose } = callbacks || {};
    const [opened, setOpened] = (0, $acw62.useState)(initialState);
    const open = (0, $acw62.useCallback)(()=>{
        setOpened((isOpened)=>{
            if (!isOpened) {
                onOpen == null || onOpen();
                return true;
            }
            return isOpened;
        });
    }, [
        onOpen
    ]);
    const close = (0, $acw62.useCallback)(()=>{
        setOpened((isOpened)=>{
            if (isOpened) {
                onClose == null || onClose();
                return false;
            }
            return isOpened;
        });
    }, [
        onClose
    ]);
    const toggle = (0, $acw62.useCallback)(()=>{
        opened ? close() : open();
    }, [
        close,
        open,
        opened
    ]);
    return [
        opened,
        {
            open: open,
            close: close,
            toggle: toggle
        }
    ];
}

});

parcelRegister("ke4gU", function(module, exports) {

$parcel$export(module.exports, "useUncontrolled", () => $eb986db88db7ac7e$export$ec55e9daaf703a7d);

var $acw62 = parcelRequire("acw62");
function $eb986db88db7ac7e$export$ec55e9daaf703a7d({ value: value, defaultValue: defaultValue, finalValue: finalValue, onChange: onChange = ()=>{} }) {
    const [uncontrolledValue, setUncontrolledValue] = (0, $acw62.useState)(defaultValue !== void 0 ? defaultValue : finalValue);
    const handleUncontrolledChange = (val)=>{
        setUncontrolledValue(val);
        onChange == null || onChange(val);
    };
    if (value !== void 0) return [
        value,
        onChange,
        true
    ];
    return [
        uncontrolledValue,
        handleUncontrolledChange,
        false
    ];
}

});

parcelRegister("awfbW", function(module, exports) {

$parcel$export(module.exports, "SpotlightContext", () => $7a88ad44db58aec7$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "useSpotlight", () => $7a88ad44db58aec7$export$cc7026713a353975);

var $acw62 = parcelRequire("acw62");
const $7a88ad44db58aec7$export$7b5aa0f5b37a336d = (0, $acw62.createContext)(null);
function $7a88ad44db58aec7$export$cc7026713a353975() {
    const ctx = (0, $acw62.useContext)($7a88ad44db58aec7$export$7b5aa0f5b37a336d);
    if (!ctx) throw new Error("[@mantine/spotlight] SpotlightProvider was not found in tree");
    return ctx;
}

});

parcelRegister("aCM0s", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $7bc2b1126dd6dcbb$export$2b77a92f1a5ad772);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $a2sPY = parcelRequire("a2sPY");

var $3FUyz = parcelRequire("3FUyz");

var $2k72v = parcelRequire("2k72v");
var $7bc2b1126dd6dcbb$var$__defProp = Object.defineProperty;
var $7bc2b1126dd6dcbb$var$__defProps = Object.defineProperties;
var $7bc2b1126dd6dcbb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7bc2b1126dd6dcbb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7bc2b1126dd6dcbb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7bc2b1126dd6dcbb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7bc2b1126dd6dcbb$var$__defNormalProp = (obj, key, value)=>key in obj ? $7bc2b1126dd6dcbb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7bc2b1126dd6dcbb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7bc2b1126dd6dcbb$var$__hasOwnProp.call(b, prop)) $7bc2b1126dd6dcbb$var$__defNormalProp(a, prop, b[prop]);
    if ($7bc2b1126dd6dcbb$var$__getOwnPropSymbols) {
        for (var prop of $7bc2b1126dd6dcbb$var$__getOwnPropSymbols(b))if ($7bc2b1126dd6dcbb$var$__propIsEnum.call(b, prop)) $7bc2b1126dd6dcbb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7bc2b1126dd6dcbb$var$__spreadProps = (a, b)=>$7bc2b1126dd6dcbb$var$__defProps(a, $7bc2b1126dd6dcbb$var$__getOwnPropDescs(b));
var $7bc2b1126dd6dcbb$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7bc2b1126dd6dcbb$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7bc2b1126dd6dcbb$var$__getOwnPropSymbols) {
        for (var prop of $7bc2b1126dd6dcbb$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7bc2b1126dd6dcbb$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $7bc2b1126dd6dcbb$var$defaultProps = $7bc2b1126dd6dcbb$var$__spreadProps($7bc2b1126dd6dcbb$var$__spreadValues({}, (0, $2k72v.ModalBaseDefaultProps)), {
    transitionProps: {
        duration: 200,
        transition: "pop"
    },
    withOverlay: true,
    withCloseButton: true
});
function $7bc2b1126dd6dcbb$export$2b77a92f1a5ad772(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("Modal", $7bc2b1126dd6dcbb$var$defaultProps, props), { title: title, withOverlay: withOverlay, overlayProps: overlayProps, withCloseButton: withCloseButton, closeButtonProps: closeButtonProps, children: children } = _a, others = $7bc2b1126dd6dcbb$var$__objRest(_a, [
        "title",
        "withOverlay",
        "overlayProps",
        "withCloseButton",
        "closeButtonProps",
        "children"
    ]);
    const hasHeader = !!title || withCloseButton;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a2sPY.ModalRoot), $7bc2b1126dd6dcbb$var$__spreadValues({}, others), withOverlay && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2k72v.ModalBase).Overlay, $7bc2b1126dd6dcbb$var$__spreadValues({}, overlayProps)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3FUyz.ModalContent), null, hasHeader && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2k72v.ModalBase).Header, null, title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2k72v.ModalBase).Title, null, title), withCloseButton && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2k72v.ModalBase).CloseButton, $7bc2b1126dd6dcbb$var$__spreadValues({}, closeButtonProps))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2k72v.ModalBase).Body, null, children)));
}
$7bc2b1126dd6dcbb$export$2b77a92f1a5ad772.Root = (0, $a2sPY.ModalRoot);
$7bc2b1126dd6dcbb$export$2b77a92f1a5ad772.CloseButton = (0, $2k72v.ModalBase).CloseButton;
$7bc2b1126dd6dcbb$export$2b77a92f1a5ad772.Overlay = (0, $2k72v.ModalBase).Overlay;
$7bc2b1126dd6dcbb$export$2b77a92f1a5ad772.Content = (0, $3FUyz.ModalContent);
$7bc2b1126dd6dcbb$export$2b77a92f1a5ad772.Header = (0, $2k72v.ModalBase).Header;
$7bc2b1126dd6dcbb$export$2b77a92f1a5ad772.Title = (0, $2k72v.ModalBase).Title;
$7bc2b1126dd6dcbb$export$2b77a92f1a5ad772.Body = (0, $2k72v.ModalBase).Body;
$7bc2b1126dd6dcbb$export$2b77a92f1a5ad772.NativeScrollArea = (0, $2k72v.ModalBase).NativeScrollArea;

});
parcelRegister("a2sPY", function(module, exports) {

$parcel$export(module.exports, "ModalRoot", () => $74f075bf0d4cf43a$export$76630a3be18d4dc4);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $8CbGk = parcelRequire("8CbGk");

var $7RhMs = parcelRequire("7RhMs");

var $2k72v = parcelRequire("2k72v");
var $74f075bf0d4cf43a$var$__defProp = Object.defineProperty;
var $74f075bf0d4cf43a$var$__defProps = Object.defineProperties;
var $74f075bf0d4cf43a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $74f075bf0d4cf43a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $74f075bf0d4cf43a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $74f075bf0d4cf43a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $74f075bf0d4cf43a$var$__defNormalProp = (obj, key, value)=>key in obj ? $74f075bf0d4cf43a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $74f075bf0d4cf43a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($74f075bf0d4cf43a$var$__hasOwnProp.call(b, prop)) $74f075bf0d4cf43a$var$__defNormalProp(a, prop, b[prop]);
    if ($74f075bf0d4cf43a$var$__getOwnPropSymbols) {
        for (var prop of $74f075bf0d4cf43a$var$__getOwnPropSymbols(b))if ($74f075bf0d4cf43a$var$__propIsEnum.call(b, prop)) $74f075bf0d4cf43a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $74f075bf0d4cf43a$var$__spreadProps = (a, b)=>$74f075bf0d4cf43a$var$__defProps(a, $74f075bf0d4cf43a$var$__getOwnPropDescs(b));
var $74f075bf0d4cf43a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($74f075bf0d4cf43a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $74f075bf0d4cf43a$var$__getOwnPropSymbols) {
        for (var prop of $74f075bf0d4cf43a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $74f075bf0d4cf43a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $74f075bf0d4cf43a$var$defaultProps = $74f075bf0d4cf43a$var$__spreadProps($74f075bf0d4cf43a$var$__spreadValues({}, (0, $2k72v.ModalBaseDefaultProps)), {
    yOffset: "5dvh",
    xOffset: "5vw"
});
function $74f075bf0d4cf43a$export$76630a3be18d4dc4(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("ModalRoot", $74f075bf0d4cf43a$var$defaultProps, props), { classNames: classNames, variant: variant, size: size, yOffset: yOffset, xOffset: xOffset, scrollAreaComponent: scrollAreaComponent, radius: radius, centered: centered, fullScreen: fullScreen } = _a, others = $74f075bf0d4cf43a$var$__objRest(_a, [
        "classNames",
        "variant",
        "size",
        "yOffset",
        "xOffset",
        "scrollAreaComponent",
        "radius",
        "centered",
        "fullScreen"
    ]);
    const { classes: classes, cx: cx } = (0, $7RhMs.default)({
        yOffset: yOffset,
        xOffset: xOffset,
        centered: centered,
        fullScreen: fullScreen
    }, {
        name: "Modal",
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8CbGk.ModalProvider), {
        value: {
            yOffset: yOffset,
            scrollAreaComponent: scrollAreaComponent,
            radius: radius
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2k72v.ModalBase), $74f075bf0d4cf43a$var$__spreadValues({
        __staticSelector: "Modal",
        size: size,
        variant: variant,
        classNames: $74f075bf0d4cf43a$var$__spreadProps($74f075bf0d4cf43a$var$__spreadValues({}, classNames), {
            content: cx(classes.content, classNames == null ? void 0 : classNames.content),
            inner: cx(classes.inner, classNames == null ? void 0 : classNames.inner)
        })
    }, others)));
}

});
parcelRegister("8CbGk", function(module, exports) {

$parcel$export(module.exports, "ModalProvider", () => $645aef17664c8d79$export$178405afcd8c5eb);
$parcel$export(module.exports, "useModalContext", () => $645aef17664c8d79$export$4cc1699d46f42cae);

var $jIWSq = parcelRequire("jIWSq");
const [$645aef17664c8d79$export$178405afcd8c5eb, $645aef17664c8d79$export$4cc1699d46f42cae] = (0, $jIWSq.createSafeContext)("Modal component was not found in tree");

});
parcelRegister("jIWSq", function(module, exports) {

$parcel$export(module.exports, "createSafeContext", () => $e5bfcc17e2dc597f$export$97d0e477aacf9b7d);

var $acw62 = parcelRequire("acw62");
function $e5bfcc17e2dc597f$export$97d0e477aacf9b7d(errorMessage) {
    const Context = (0, $acw62.createContext)(null);
    const useSafeContext = ()=>{
        const ctx = (0, $acw62.useContext)(Context);
        if (ctx === null) throw new Error(errorMessage);
        return ctx;
    };
    const Provider = ({ children: children, value: value })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
            value: value
        }, children);
    return [
        Provider,
        useSafeContext
    ];
}

});


parcelRegister("7RhMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b8b467ab4cb8454$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
const $5b8b467ab4cb8454$var$sizes = {
    xs: (0, $2jkdX.rem)(320),
    sm: (0, $2jkdX.rem)(380),
    md: (0, $2jkdX.rem)(440),
    lg: (0, $2jkdX.rem)(620),
    xl: (0, $2jkdX.rem)(780)
};
var $5b8b467ab4cb8454$var$useStyles = (0, $cQG1Y.createStyles)((theme, { yOffset: yOffset, xOffset: xOffset, centered: centered, fullScreen: fullScreen }, { size: size })=>({
        content: {
            flex: fullScreen ? "0 0 100%" : `0 0 ${(0, $d8Ix8.getSize)({
                size: size,
                sizes: $5b8b467ab4cb8454$var$sizes
            })}`,
            maxWidth: "100%",
            maxHeight: fullScreen ? void 0 : `calc(100dvh - (${(0, $2jkdX.rem)(yOffset)} * 2))`,
            height: fullScreen ? "100vh" : void 0,
            borderRadius: fullScreen ? 0 : void 0,
            overflowY: "auto"
        },
        inner: {
            paddingTop: fullScreen ? 0 : yOffset,
            paddingBottom: fullScreen ? 0 : yOffset,
            paddingLeft: fullScreen ? 0 : xOffset,
            paddingRight: fullScreen ? 0 : xOffset,
            display: "flex",
            justifyContent: "center",
            alignItems: centered ? "center" : "flex-start"
        }
    }));
var $5b8b467ab4cb8454$export$2e2bcd8739ae039 = $5b8b467ab4cb8454$var$useStyles;

});

parcelRegister("2k72v", function(module, exports) {

$parcel$export(module.exports, "ModalBaseDefaultProps", () => $1b12e8e377c4ca06$export$d0d4ddaf8b6ca347);
$parcel$export(module.exports, "ModalBase", () => $1b12e8e377c4ca06$export$acabb5bd2b72d092);

var $acw62 = parcelRequire("acw62");

var $hPyeV = parcelRequire("hPyeV");

var $3EYPD = parcelRequire("3EYPD");
var $8nBd8 = parcelRequire("8nBd8");
var $dmiju = parcelRequire("dmiju");

var $iu1L3 = parcelRequire("iu1L3");
var $64A2P = parcelRequire("64A2P");

var $a9TQj = parcelRequire("a9TQj");

var $kcvGp = parcelRequire("kcvGp");

var $kE8Ru = parcelRequire("kE8Ru");

var $gUfnm = parcelRequire("gUfnm");

var $58ByZ = parcelRequire("58ByZ");

var $elhDj = parcelRequire("elhDj");

var $iOuSR = parcelRequire("iOuSR");

var $03VNK = parcelRequire("03VNK");

var $03Zlp = parcelRequire("03Zlp");

var $lwFVI = parcelRequire("lwFVI");

var $hZi38 = parcelRequire("hZi38");

var $hiiR1 = parcelRequire("hiiR1");
var $1b12e8e377c4ca06$var$__defProp = Object.defineProperty;
var $1b12e8e377c4ca06$var$__defProps = Object.defineProperties;
var $1b12e8e377c4ca06$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1b12e8e377c4ca06$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1b12e8e377c4ca06$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1b12e8e377c4ca06$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1b12e8e377c4ca06$var$__defNormalProp = (obj, key, value)=>key in obj ? $1b12e8e377c4ca06$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1b12e8e377c4ca06$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1b12e8e377c4ca06$var$__hasOwnProp.call(b, prop)) $1b12e8e377c4ca06$var$__defNormalProp(a, prop, b[prop]);
    if ($1b12e8e377c4ca06$var$__getOwnPropSymbols) {
        for (var prop of $1b12e8e377c4ca06$var$__getOwnPropSymbols(b))if ($1b12e8e377c4ca06$var$__propIsEnum.call(b, prop)) $1b12e8e377c4ca06$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1b12e8e377c4ca06$var$__spreadProps = (a, b)=>$1b12e8e377c4ca06$var$__defProps(a, $1b12e8e377c4ca06$var$__getOwnPropDescs(b));
var $1b12e8e377c4ca06$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1b12e8e377c4ca06$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1b12e8e377c4ca06$var$__getOwnPropSymbols) {
        for (var prop of $1b12e8e377c4ca06$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1b12e8e377c4ca06$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $1b12e8e377c4ca06$export$d0d4ddaf8b6ca347 = {
    closeOnClickOutside: true,
    withinPortal: true,
    lockScroll: true,
    trapFocus: true,
    returnFocus: true,
    closeOnEscape: true,
    keepMounted: false,
    zIndex: (0, $iu1L3.getDefaultZIndex)("modal"),
    padding: "md",
    size: "md",
    shadow: "xl"
};
function $1b12e8e377c4ca06$export$acabb5bd2b72d092(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("ModalBase", $1b12e8e377c4ca06$export$d0d4ddaf8b6ca347, props), { opened: opened, onClose: onClose, children: children, closeOnClickOutside: closeOnClickOutside, __staticSelector: __staticSelector, transitionProps: transitionProps, withinPortal: withinPortal, portalProps: portalProps, keepMounted: keepMounted, target: target, zIndex: zIndex, lockScroll: lockScroll, trapFocus: trapFocus, closeOnEscape: closeOnEscape, returnFocus: returnFocus, padding: padding, shadow: shadow, id: id, size: size, variant: variant, classNames: classNames, unstyled: unstyled, styles: styles, className: className } = _a, others = $1b12e8e377c4ca06$var$__objRest(_a, [
        "opened",
        "onClose",
        "children",
        "closeOnClickOutside",
        "__staticSelector",
        "transitionProps",
        "withinPortal",
        "portalProps",
        "keepMounted",
        "target",
        "zIndex",
        "lockScroll",
        "trapFocus",
        "closeOnEscape",
        "returnFocus",
        "padding",
        "shadow",
        "id",
        "size",
        "variant",
        "classNames",
        "unstyled",
        "styles",
        "className"
    ]);
    const { classes: classes, cx: cx } = (0, $lwFVI.default)(null, {
        name: __staticSelector,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const _id = (0, $8nBd8.useId)(id);
    const [titleMounted, setTitleMounted] = (0, $acw62.useState)(false);
    const [bodyMounted, setBodyMounted] = (0, $acw62.useState)(false);
    const transitionDuration = typeof (transitionProps == null ? void 0 : transitionProps.duration) === "number" ? transitionProps == null ? void 0 : transitionProps.duration : 200;
    const shouldLockScroll = (0, $03Zlp.useLockScroll)({
        opened: opened,
        transitionDuration: transitionDuration
    });
    (0, $dmiju.useWindowEvent)("keydown", (event)=>{
        if (!trapFocus && event.key === "Escape" && closeOnEscape) onClose();
    });
    (0, $3EYPD.useFocusReturn)({
        opened: opened,
        shouldReturnFocus: trapFocus && returnFocus
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZi38.OptionalPortal), $1b12e8e377c4ca06$var$__spreadProps($1b12e8e377c4ca06$var$__spreadValues({}, portalProps), {
        withinPortal: withinPortal,
        target: target
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a9TQj.ModalBaseProvider), {
        value: {
            __staticSelector: __staticSelector,
            opened: opened,
            onClose: onClose,
            closeOnClickOutside: closeOnClickOutside,
            transitionProps: $1b12e8e377c4ca06$var$__spreadProps($1b12e8e377c4ca06$var$__spreadValues({}, transitionProps), {
                duration: transitionDuration,
                keepMounted: keepMounted
            }),
            zIndex: zIndex,
            padding: padding,
            id: _id,
            getTitleId: ()=>`${_id}-title`,
            getBodyId: ()=>`${_id}-body`,
            titleMounted: titleMounted,
            bodyMounted: bodyMounted,
            setTitleMounted: setTitleMounted,
            setBodyMounted: setBodyMounted,
            trapFocus: trapFocus,
            closeOnEscape: closeOnEscape,
            shadow: shadow,
            stylesApi: {
                name: __staticSelector,
                size: size,
                variant: variant,
                classNames: classNames,
                styles: styles,
                unstyled: unstyled
            }
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hPyeV.default), {
        enabled: shouldLockScroll && lockScroll
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $1b12e8e377c4ca06$var$__spreadValues({
        className: cx(classes.root, className)
    }, others), children))));
}
$1b12e8e377c4ca06$export$acabb5bd2b72d092.CloseButton = (0, $kcvGp.ModalBaseCloseButton);
$1b12e8e377c4ca06$export$acabb5bd2b72d092.Overlay = (0, $kE8Ru.ModalBaseOverlay);
$1b12e8e377c4ca06$export$acabb5bd2b72d092.Content = (0, $gUfnm.ModalBaseContent);
$1b12e8e377c4ca06$export$acabb5bd2b72d092.Header = (0, $58ByZ.ModalBaseHeader);
$1b12e8e377c4ca06$export$acabb5bd2b72d092.Title = (0, $elhDj.ModalBaseTitle);
$1b12e8e377c4ca06$export$acabb5bd2b72d092.Body = (0, $iOuSR.ModalBaseBody);
$1b12e8e377c4ca06$export$acabb5bd2b72d092.NativeScrollArea = (0, $03VNK.NativeScrollArea);

});
parcelRegister("hPyeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $hphuJ = parcelRequire("hphuJ");

var $1fmze = parcelRequire("1fmze");
var $cfb1c25e3ef3d3bc$var$ReactRemoveScroll = $acw62.forwardRef(function(props, ref) {
    return $acw62.createElement((0, $hphuJ.RemoveScroll), (0, $7WQrb.__assign)({}, props, {
        ref: ref,
        sideCar: (0, $1fmze.default)
    }));
});
$cfb1c25e3ef3d3bc$var$ReactRemoveScroll.classNames = (0, $hphuJ.RemoveScroll).classNames;
var $cfb1c25e3ef3d3bc$export$2e2bcd8739ae039 = $cfb1c25e3ef3d3bc$var$ReactRemoveScroll;

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $5c96a02c592fcff1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArrays", () => $5c96a02c592fcff1$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("hphuJ", function(module, exports) {

$parcel$export(module.exports, "RemoveScroll", () => $cac2578984d345ac$export$22940b497e769dee);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $5shKQ = parcelRequire("5shKQ");

var $2DGpc = parcelRequire("2DGpc");

var $lbTxE = parcelRequire("lbTxE");
var $cac2578984d345ac$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $cac2578984d345ac$export$22940b497e769dee = $acw62.forwardRef(function(props, parentRef) {
    var ref = $acw62.useRef(null);
    var _a = $acw62.useState({
        onScrollCapture: $cac2578984d345ac$var$nothing,
        onWheelCapture: $cac2578984d345ac$var$nothing,
        onTouchMoveCapture: $cac2578984d345ac$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $7WQrb.__rest)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $2DGpc.useMergeRefs)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, rest), callbacks);
    return $acw62.createElement($acw62.Fragment, null, enabled && $acw62.createElement(SideCar, {
        sideCar: (0, $lbTxE.effectCar),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $acw62.cloneElement($acw62.Children.only(children), (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, containerProps), {
        ref: containerRef
    })) : $acw62.createElement(Container, (0, $7WQrb.__assign)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$cac2578984d345ac$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$cac2578984d345ac$export$22940b497e769dee.classNames = {
    fullWidth: (0, $5shKQ.fullWidthClassName),
    zeroRight: (0, $5shKQ.zeroRightClassName)
};

});
parcelRegister("5shKQ", function(module, exports) {

$parcel$export(module.exports, "zeroRightClassName", () => $3f8d56f1a38c65c8$export$1da7500147d4bc3);
$parcel$export(module.exports, "fullWidthClassName", () => $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e);
$parcel$export(module.exports, "noScrollbarsClassName", () => $3f8d56f1a38c65c8$export$bb813dfbbc432abc);
$parcel$export(module.exports, "removedBarSizeVariable", () => $3f8d56f1a38c65c8$export$63d0edf80fea83b1);
var $3f8d56f1a38c65c8$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $3f8d56f1a38c65c8$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $3f8d56f1a38c65c8$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $3f8d56f1a38c65c8$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';

});

parcelRegister("2DGpc", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", () => $1ec01e2201501f3d$export$74665b213cb5c4cf);

var $acw62 = parcelRequire("acw62");

var $dtd3m = parcelRequire("dtd3m");

var $uclLN = parcelRequire("uclLN");
var $1ec01e2201501f3d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $1ec01e2201501f3d$var$currentValues = new WeakMap();
function $1ec01e2201501f3d$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $uclLN.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $dtd3m.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $1ec01e2201501f3d$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $1ec01e2201501f3d$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $dtd3m.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $dtd3m.assignRef)(ref, current_1);
            });
        }
        $1ec01e2201501f3d$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("dtd3m", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $9ce81be4473c2c96$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $9ce81be4473c2c96$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("uclLN", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $05ac61ef45da8ec5$export$25bec8c6f54ee79a);

var $acw62 = parcelRequire("acw62");
function $05ac61ef45da8ec5$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $acw62.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("lbTxE", function(module, exports) {

$parcel$export(module.exports, "effectCar", () => $f6d5b57f3512e73c$export$e27363444bedfeac);

var $iXQwi = parcelRequire("iXQwi");
var $f6d5b57f3512e73c$export$e27363444bedfeac = (0, $iXQwi.createSidecarMedium)();

});
parcelRegister("iXQwi", function(module, exports) {

$parcel$export(module.exports, "createSidecarMedium", () => $dce67a1050af61cf$export$e13ec7dd7a14088d);

var $7WQrb = parcelRequire("7WQrb");
function $dce67a1050af61cf$var$ItoI(a) {
    return a;
}
function $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $dce67a1050af61cf$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $dce67a1050af61cf$var$ItoI;
    return $dce67a1050af61cf$var$innerCreateMedium(defaults, middleware);
}
function $dce67a1050af61cf$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $dce67a1050af61cf$var$innerCreateMedium(null);
    medium.options = (0, $7WQrb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});



parcelRegister("1fmze", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e88b28988758ab2$export$2e2bcd8739ae039);

var $hcGtC = parcelRequire("hcGtC");

var $l793C = parcelRequire("l793C");

var $lbTxE = parcelRequire("lbTxE");
var $0e88b28988758ab2$export$2e2bcd8739ae039 = (0, $hcGtC.exportSidecar)((0, $lbTxE.effectCar), (0, $l793C.RemoveScrollSideCar));

});
parcelRegister("hcGtC", function(module, exports) {

$parcel$export(module.exports, "exportSidecar", () => $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
var $c86481a7b0dfcc68$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $7WQrb.__rest)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $acw62.createElement(Target, (0, $7WQrb.__assign)({}, rest));
};
$c86481a7b0dfcc68$var$SideCar.isSideCarExport = true;
function $c86481a7b0dfcc68$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c86481a7b0dfcc68$var$SideCar;
}

});

parcelRegister("l793C", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollSideCar", () => $f5f147098910888d$export$a09dbff87b5da2d);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");
parcelRequire("bFkre");
var $dFfX5 = parcelRequire("dFfX5");
parcelRequire("i39OQ");
var $kc8mv = parcelRequire("kc8mv");

var $9x4sU = parcelRequire("9x4sU");

var $epYFP = parcelRequire("epYFP");
var $f5f147098910888d$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $f5f147098910888d$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $f5f147098910888d$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $f5f147098910888d$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $f5f147098910888d$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $f5f147098910888d$var$idCounter = 0;
var $f5f147098910888d$var$lockStack = [];
function $f5f147098910888d$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $acw62.useRef([]);
    var touchStartRef = $acw62.useRef([
        0,
        0
    ]);
    var activeAxis = $acw62.useRef();
    var id = $acw62.useState($f5f147098910888d$var$idCounter++)[0];
    var Style = $acw62.useState((0, $kc8mv.styleSingleton))[0];
    var lastProps = $acw62.useRef(props);
    $acw62.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $acw62.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $7WQrb.__spreadArray)([
                props.lockRef.current
            ], (props.shards || []).map($f5f147098910888d$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $acw62.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $f5f147098910888d$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        var canBeScrolledInMainDirection = (0, $epYFP.locationCouldBeScrolled)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $epYFP.locationCouldBeScrolled)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $epYFP.handleScroll)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $acw62.useCallback(function(_event) {
        var event = _event;
        if (!$f5f147098910888d$var$lockStack.length || $f5f147098910888d$var$lockStack[$f5f147098910888d$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $f5f147098910888d$export$39efaa2ca254a28d(event) : $f5f147098910888d$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $f5f147098910888d$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($f5f147098910888d$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $acw62.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $f5f147098910888d$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $acw62.useCallback(function(event) {
        touchStartRef.current = $f5f147098910888d$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $acw62.useCallback(function(event) {
        shouldCancel(event.type, $f5f147098910888d$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $acw62.useEffect(function() {
        $f5f147098910888d$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $9x4sU.nonPassive));
        document.addEventListener('touchmove', shouldPrevent, (0, $9x4sU.nonPassive));
        document.addEventListener('touchstart', scrollTouchStart, (0, $9x4sU.nonPassive));
        return function() {
            $f5f147098910888d$var$lockStack = $f5f147098910888d$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $9x4sU.nonPassive));
            document.removeEventListener('touchmove', shouldPrevent, (0, $9x4sU.nonPassive));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $9x4sU.nonPassive));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $acw62.createElement($acw62.Fragment, null, inert ? $acw62.createElement(Style, {
        styles: $f5f147098910888d$var$generateStyle(id)
    }) : null, removeScrollBar ? $acw62.createElement((0, $dFfX5.RemoveScrollBar), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $f5f147098910888d$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}

});
parcelRegister("bFkre", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => (parcelRequire("dFfX5")).RemoveScrollBar);

var $dFfX5 = parcelRequire("dFfX5");

var $5shKQ = parcelRequire("5shKQ");

var $2ddNe = parcelRequire("2ddNe");

});
parcelRegister("dFfX5", function(module, exports) {

$parcel$export(module.exports, "RemoveScrollBar", () => $9f2b7a700f678519$export$9aa43b459c5ae9b9);

var $acw62 = parcelRequire("acw62");
parcelRequire("i39OQ");
var $kc8mv = parcelRequire("kc8mv");

var $5shKQ = parcelRequire("5shKQ");

var $2ddNe = parcelRequire("2ddNe");
var $9f2b7a700f678519$var$Style = (0, $kc8mv.styleSingleton)();
var $9f2b7a700f678519$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $9f2b7a700f678519$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $5shKQ.noScrollbarsClassName), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $5shKQ.zeroRightClassName), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.fullWidthClassName), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.zeroRightClassName), " .").concat((0, $5shKQ.zeroRightClassName), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $5shKQ.fullWidthClassName), " .").concat((0, $5shKQ.fullWidthClassName), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($9f2b7a700f678519$export$65254d5f26cb9564, "] {\n    ").concat((0, $5shKQ.removedBarSizeVariable), ": ").concat(gap, "px;\n  }\n");
};
var $9f2b7a700f678519$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($9f2b7a700f678519$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $9f2b7a700f678519$export$a1939b1f9f9b02dc = function() {
    $acw62.useEffect(function() {
        document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, ($9f2b7a700f678519$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $9f2b7a700f678519$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($9f2b7a700f678519$export$65254d5f26cb9564);
            else document.body.setAttribute($9f2b7a700f678519$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $9f2b7a700f678519$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $9f2b7a700f678519$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $acw62.useMemo(function() {
        return (0, $2ddNe.getGapWidth)(gapMode);
    }, [
        gapMode
    ]);
    return $acw62.createElement($9f2b7a700f678519$var$Style, {
        styles: $9f2b7a700f678519$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};

});
parcelRegister("i39OQ", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => (parcelRequire("kc8mv")).styleSingleton);

var $kc8mv = parcelRequire("kc8mv");

var $gjYQD = parcelRequire("gjYQD");

var $fCBo2 = parcelRequire("fCBo2");

});
parcelRegister("kc8mv", function(module, exports) {

$parcel$export(module.exports, "styleSingleton", () => $eb3b6a23a33fb1ba$export$c1248ee86ba532c8);

var $fCBo2 = parcelRequire("fCBo2");
var $eb3b6a23a33fb1ba$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $fCBo2.styleHookSingleton)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};

});
parcelRegister("fCBo2", function(module, exports) {

$parcel$export(module.exports, "styleHookSingleton", () => $b5f767dd03f483e5$export$7d7b35c2d250e94c);

var $acw62 = parcelRequire("acw62");

var $gjYQD = parcelRequire("gjYQD");
var $b5f767dd03f483e5$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $gjYQD.stylesheetSingleton)();
    return function(styles, isDynamic) {
        $acw62.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};

});
parcelRegister("gjYQD", function(module, exports) {

$parcel$export(module.exports, "stylesheetSingleton", () => $be1d9ed5bb532264$export$7c74eec858d5d226);

var $1EetQ = parcelRequire("1EetQ");
function $be1d9ed5bb532264$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $1EetQ.getNonce)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $be1d9ed5bb532264$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $be1d9ed5bb532264$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $be1d9ed5bb532264$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $be1d9ed5bb532264$var$makeStyleTag()) {
                    $be1d9ed5bb532264$var$injectStyles(stylesheet, style);
                    $be1d9ed5bb532264$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};

});
parcelRegister("1EetQ", function(module, exports) {

$parcel$export(module.exports, "getNonce", () => $1334c25f36aeceaf$export$2b85b721e524d74b);
var $1334c25f36aeceaf$var$currentNonce;
var $1334c25f36aeceaf$export$c5f670b24c0ae95a = function(nonce) {
    $1334c25f36aeceaf$var$currentNonce = nonce;
};
var $1334c25f36aeceaf$export$2b85b721e524d74b = function() {
    if ($1334c25f36aeceaf$var$currentNonce) return $1334c25f36aeceaf$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};

});





parcelRegister("2ddNe", function(module, exports) {

$parcel$export(module.exports, "getGapWidth", () => $19c77eb414ad2a19$export$75f2ca8f029c77f4);
var $19c77eb414ad2a19$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $19c77eb414ad2a19$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $19c77eb414ad2a19$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $19c77eb414ad2a19$var$parse(left),
        $19c77eb414ad2a19$var$parse(top),
        $19c77eb414ad2a19$var$parse(right)
    ];
};
var $19c77eb414ad2a19$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $19c77eb414ad2a19$export$efed13b5d0ca3386;
    var offsets = $19c77eb414ad2a19$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};

});



parcelRegister("9x4sU", function(module, exports) {

$parcel$export(module.exports, "nonPassive", () => $6f0aa8d921410141$export$10a6e88623fa9454);
var $6f0aa8d921410141$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $6f0aa8d921410141$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $6f0aa8d921410141$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
    // @ts-ignore
    window.removeEventListener('test', $6f0aa8d921410141$var$options, $6f0aa8d921410141$var$options);
} catch (err) {
    $6f0aa8d921410141$var$passiveSupported = false;
}
var $6f0aa8d921410141$export$10a6e88623fa9454 = $6f0aa8d921410141$var$passiveSupported ? {
    passive: false
} : false;

});

parcelRegister("epYFP", function(module, exports) {

$parcel$export(module.exports, "locationCouldBeScrolled", () => $a7f277057d6643d0$export$9ec64480cae49817);
$parcel$export(module.exports, "handleScroll", () => $a7f277057d6643d0$export$dde0441bd4a6ded8);
var $a7f277057d6643d0$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $a7f277057d6643d0$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$a7f277057d6643d0$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $a7f277057d6643d0$var$elementCouldBeVScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowY');
};
var $a7f277057d6643d0$var$elementCouldBeHScrolled = function(node) {
    return $a7f277057d6643d0$var$elementCanBeScrolled(node, 'overflowX');
};
var $a7f277057d6643d0$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $a7f277057d6643d0$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $a7f277057d6643d0$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $a7f277057d6643d0$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $a7f277057d6643d0$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $a7f277057d6643d0$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$elementCouldBeVScrolled(node) : $a7f277057d6643d0$var$elementCouldBeHScrolled(node);
};
var $a7f277057d6643d0$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $a7f277057d6643d0$var$getVScrollVariables(node) : $a7f277057d6643d0$var$getHScrollVariables(node);
};
var $a7f277057d6643d0$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $a7f277057d6643d0$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $a7f277057d6643d0$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $a7f277057d6643d0$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($a7f277057d6643d0$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};

});




parcelRegister("3EYPD", function(module, exports) {

$parcel$export(module.exports, "useFocusReturn", () => $2aa44b7a026693a8$export$275f09232623ff6f);

var $acw62 = parcelRequire("acw62");

var $2qf6h = parcelRequire("2qf6h");
function $2aa44b7a026693a8$export$275f09232623ff6f({ opened: opened, shouldReturnFocus: shouldReturnFocus = true }) {
    const lastActiveElement = (0, $acw62.useRef)();
    const returnFocus = ()=>{
        var _a;
        if (lastActiveElement.current && "focus" in lastActiveElement.current && typeof lastActiveElement.current.focus === "function") (_a = lastActiveElement.current) == null || _a.focus({
            preventScroll: true
        });
    };
    (0, $2qf6h.useDidUpdate)(()=>{
        let timeout = -1;
        const clearFocusTimeout = (event)=>{
            if (event.key === "Tab") window.clearTimeout(timeout);
        };
        document.addEventListener("keydown", clearFocusTimeout);
        if (opened) lastActiveElement.current = document.activeElement;
        else if (shouldReturnFocus) timeout = window.setTimeout(returnFocus, 10);
        return ()=>{
            window.clearTimeout(timeout);
            document.removeEventListener("keydown", clearFocusTimeout);
        };
    }, [
        opened,
        shouldReturnFocus
    ]);
    return returnFocus;
}

});
parcelRegister("2qf6h", function(module, exports) {

$parcel$export(module.exports, "useDidUpdate", () => $1c39b913e04f5c35$export$e34ed88fef4dc107);

var $acw62 = parcelRequire("acw62");
function $1c39b913e04f5c35$export$e34ed88fef4dc107(fn, dependencies) {
    const mounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>()=>{
            mounted.current = false;
        }, []);
    (0, $acw62.useEffect)(()=>{
        if (mounted.current) return fn();
        mounted.current = true;
        return void 0;
    }, dependencies);
}

});


parcelRegister("8nBd8", function(module, exports) {

$parcel$export(module.exports, "useId", () => $619d5607ab884f78$export$f680877a34711e37);

var $acw62 = parcelRequire("acw62");

var $l65IU = parcelRequire("l65IU");

var $w8sVl = parcelRequire("w8sVl");

var $45cdq = parcelRequire("45cdq");
function $619d5607ab884f78$export$f680877a34711e37(staticId) {
    const reactId = (0, $w8sVl.useReactId)();
    const [uuid, setUuid] = (0, $acw62.useState)(reactId);
    (0, $l65IU.useIsomorphicEffect)(()=>{
        setUuid((0, $45cdq.randomId)());
    }, []);
    if (typeof staticId === "string") return staticId;
    if (typeof window === "undefined") return reactId;
    return uuid;
}

});
parcelRegister("l65IU", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicEffect", () => $f5be99063732128e$export$363c9f3eb56bbdbe);

var $acw62 = parcelRequire("acw62");
const $f5be99063732128e$export$363c9f3eb56bbdbe = typeof document !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});

parcelRegister("w8sVl", function(module, exports) {

$parcel$export(module.exports, "useReactId", () => $06098e59304c6dca$export$a64f454050c00176);

var $acw62 = parcelRequire("acw62");
const $06098e59304c6dca$var$__useId = (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId".toString()] || (()=>void 0);
function $06098e59304c6dca$export$a64f454050c00176() {
    const id = $06098e59304c6dca$var$__useId();
    return id ? `mantine-${id.replace(/:/g, "")}` : "";
}

});

parcelRegister("45cdq", function(module, exports) {

$parcel$export(module.exports, "randomId", () => $2f911ad0f0e0c07c$export$5e699d18035b41af);
function $2f911ad0f0e0c07c$export$5e699d18035b41af() {
    return `mantine-${Math.random().toString(36).slice(2, 11)}`;
}

});


parcelRegister("a9TQj", function(module, exports) {

$parcel$export(module.exports, "ModalBaseProvider", () => $76560fd89eec80af$export$695854637ffea3cb);
$parcel$export(module.exports, "useModalBaseContext", () => $76560fd89eec80af$export$48c4ab01c2900d2);

var $jIWSq = parcelRequire("jIWSq");
const [$76560fd89eec80af$export$695854637ffea3cb, $76560fd89eec80af$export$48c4ab01c2900d2] = (0, $jIWSq.createSafeContext)("ModalBase component was not found in tree");

});

parcelRegister("kcvGp", function(module, exports) {

$parcel$export(module.exports, "ModalBaseCloseButton", () => $eb4d813e517075bd$export$cb6429a0eac3477a);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $a9TQj = parcelRequire("a9TQj");

var $8lREu = parcelRequire("8lREu");

var $lUJd1 = parcelRequire("lUJd1");
var $eb4d813e517075bd$var$__defProp = Object.defineProperty;
var $eb4d813e517075bd$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $eb4d813e517075bd$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $eb4d813e517075bd$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $eb4d813e517075bd$var$__defNormalProp = (obj, key, value)=>key in obj ? $eb4d813e517075bd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $eb4d813e517075bd$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($eb4d813e517075bd$var$__hasOwnProp.call(b, prop)) $eb4d813e517075bd$var$__defNormalProp(a, prop, b[prop]);
    if ($eb4d813e517075bd$var$__getOwnPropSymbols) {
        for (var prop of $eb4d813e517075bd$var$__getOwnPropSymbols(b))if ($eb4d813e517075bd$var$__propIsEnum.call(b, prop)) $eb4d813e517075bd$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $eb4d813e517075bd$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($eb4d813e517075bd$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $eb4d813e517075bd$var$__getOwnPropSymbols) {
        for (var prop of $eb4d813e517075bd$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $eb4d813e517075bd$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $eb4d813e517075bd$var$defaultProps = {
    size: "sm"
};
const $eb4d813e517075bd$export$cb6429a0eac3477a = (0, $acw62.forwardRef)((props, ref)=>{
    const ctx = (0, $a9TQj.useModalBaseContext)();
    const _a = (0, $64A2P.useComponentDefaultProps)(`${ctx.__staticSelector}CloseButton`, $eb4d813e517075bd$var$defaultProps, props), { className: className } = _a, others = $eb4d813e517075bd$var$__objRest(_a, [
        "className"
    ]);
    const { classes: classes, cx: cx } = (0, $8lREu.default)(null, ctx.stylesApi);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUJd1.CloseButton), $eb4d813e517075bd$var$__spreadValues({
        className: cx(classes.close, className),
        ref: ref,
        onClick: ctx.onClose
    }, others));
});

});
parcelRegister("8lREu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6149e715ec5df6d4$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $6149e715ec5df6d4$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        close: {
            marginLeft: "auto",
            marginRight: 0
        }
    }));
var $6149e715ec5df6d4$export$2e2bcd8739ae039 = $6149e715ec5df6d4$var$useStyles;

});

parcelRegister("lUJd1", function(module, exports) {

$parcel$export(module.exports, "CloseButton", () => $ff41e57f6567581a$export$de65de8213222d10);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $crMIh = parcelRequire("crMIh");

var $4EYCm = parcelRequire("4EYCm");
var $ff41e57f6567581a$var$__defProp = Object.defineProperty;
var $ff41e57f6567581a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ff41e57f6567581a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ff41e57f6567581a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ff41e57f6567581a$var$__defNormalProp = (obj, key, value)=>key in obj ? $ff41e57f6567581a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ff41e57f6567581a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ff41e57f6567581a$var$__hasOwnProp.call(b, prop)) $ff41e57f6567581a$var$__defNormalProp(a, prop, b[prop]);
    if ($ff41e57f6567581a$var$__getOwnPropSymbols) {
        for (var prop of $ff41e57f6567581a$var$__getOwnPropSymbols(b))if ($ff41e57f6567581a$var$__propIsEnum.call(b, prop)) $ff41e57f6567581a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ff41e57f6567581a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ff41e57f6567581a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ff41e57f6567581a$var$__getOwnPropSymbols) {
        for (var prop of $ff41e57f6567581a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ff41e57f6567581a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $ff41e57f6567581a$var$iconSizes = {
    xs: (0, $2jkdX.rem)(12),
    sm: (0, $2jkdX.rem)(16),
    md: (0, $2jkdX.rem)(20),
    lg: (0, $2jkdX.rem)(28),
    xl: (0, $2jkdX.rem)(34)
};
const $ff41e57f6567581a$var$defaultProps = {
    size: "sm"
};
const $ff41e57f6567581a$export$8e44d7f95c48f03d = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("CloseButton", $ff41e57f6567581a$var$defaultProps, props), { iconSize: iconSize, size: size, children: children } = _a, others = $ff41e57f6567581a$var$__objRest(_a, [
        "iconSize",
        "size",
        "children"
    ]);
    const _iconSize = (0, $2jkdX.rem)(iconSize || $ff41e57f6567581a$var$iconSizes[size]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $crMIh.ActionIcon), $ff41e57f6567581a$var$__spreadValues({
        ref: ref,
        __staticSelector: "CloseButton",
        size: size
    }, others), children || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4EYCm.CloseIcon), {
        width: _iconSize,
        height: _iconSize
    }));
});
$ff41e57f6567581a$export$8e44d7f95c48f03d.displayName = "@mantine/core/CloseButton";
const $ff41e57f6567581a$export$de65de8213222d10 = (0, $1euea.createPolymorphicComponent)($ff41e57f6567581a$export$8e44d7f95c48f03d);

});
parcelRegister("4EYCm", function(module, exports) {

$parcel$export(module.exports, "CloseIcon", () => $3649eb446feaeb47$export$cae179f078f4b4a4);

var $acw62 = parcelRequire("acw62");
var $3649eb446feaeb47$var$__defProp = Object.defineProperty;
var $3649eb446feaeb47$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3649eb446feaeb47$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3649eb446feaeb47$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3649eb446feaeb47$var$__defNormalProp = (obj, key, value)=>key in obj ? $3649eb446feaeb47$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3649eb446feaeb47$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3649eb446feaeb47$var$__hasOwnProp.call(b, prop)) $3649eb446feaeb47$var$__defNormalProp(a, prop, b[prop]);
    if ($3649eb446feaeb47$var$__getOwnPropSymbols) {
        for (var prop of $3649eb446feaeb47$var$__getOwnPropSymbols(b))if ($3649eb446feaeb47$var$__propIsEnum.call(b, prop)) $3649eb446feaeb47$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3649eb446feaeb47$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3649eb446feaeb47$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3649eb446feaeb47$var$__getOwnPropSymbols) {
        for (var prop of $3649eb446feaeb47$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3649eb446feaeb47$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $3649eb446feaeb47$export$cae179f078f4b4a4(props) {
    const _a = props, { width: width, height: height, style: style } = _a, others = $3649eb446feaeb47$var$__objRest(_a, [
        "width",
        "height",
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $3649eb446feaeb47$var$__spreadValues({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: $3649eb446feaeb47$var$__spreadValues({
            width: width,
            height: height
        }, style)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}
$3649eb446feaeb47$export$cae179f078f4b4a4.displayName = "@mantine/core/CloseIcon";

});



parcelRegister("kE8Ru", function(module, exports) {

$parcel$export(module.exports, "ModalBaseOverlay", () => $f07e6ad50100acde$export$dfc81a5f853cf392);

var $64A2P = parcelRequire("64A2P");

var $acw62 = parcelRequire("acw62");

var $a9TQj = parcelRequire("a9TQj");

var $1yHO7 = parcelRequire("1yHO7");

var $1RCXp = parcelRequire("1RCXp");

var $hgiQh = parcelRequire("hgiQh");
var $f07e6ad50100acde$var$__defProp = Object.defineProperty;
var $f07e6ad50100acde$var$__defProps = Object.defineProperties;
var $f07e6ad50100acde$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f07e6ad50100acde$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f07e6ad50100acde$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f07e6ad50100acde$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f07e6ad50100acde$var$__defNormalProp = (obj, key, value)=>key in obj ? $f07e6ad50100acde$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f07e6ad50100acde$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f07e6ad50100acde$var$__hasOwnProp.call(b, prop)) $f07e6ad50100acde$var$__defNormalProp(a, prop, b[prop]);
    if ($f07e6ad50100acde$var$__getOwnPropSymbols) {
        for (var prop of $f07e6ad50100acde$var$__getOwnPropSymbols(b))if ($f07e6ad50100acde$var$__propIsEnum.call(b, prop)) $f07e6ad50100acde$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f07e6ad50100acde$var$__spreadProps = (a, b)=>$f07e6ad50100acde$var$__defProps(a, $f07e6ad50100acde$var$__getOwnPropDescs(b));
var $f07e6ad50100acde$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f07e6ad50100acde$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f07e6ad50100acde$var$__getOwnPropSymbols) {
        for (var prop of $f07e6ad50100acde$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f07e6ad50100acde$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f07e6ad50100acde$var$defaultProps = {};
const $f07e6ad50100acde$export$dfc81a5f853cf392 = (0, $acw62.forwardRef)((props, ref)=>{
    const ctx = (0, $a9TQj.useModalBaseContext)();
    const _a = (0, $64A2P.useComponentDefaultProps)(`${ctx.__staticSelector}Overlay`, $f07e6ad50100acde$var$defaultProps, props), { onClick: onClick, transitionProps: transitionProps, style: style, className: className } = _a, others = $f07e6ad50100acde$var$__objRest(_a, [
        "onClick",
        "transitionProps",
        "style",
        "className"
    ]);
    const { classes: classes, cx: cx } = (0, $1yHO7.default)(null, ctx.stylesApi);
    const handleClick = (event)=>{
        onClick == null || onClick(event);
        ctx.closeOnClickOutside && ctx.onClose();
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1RCXp.Transition), $f07e6ad50100acde$var$__spreadProps($f07e6ad50100acde$var$__spreadValues($f07e6ad50100acde$var$__spreadValues({
        mounted: ctx.opened
    }, ctx.transitionProps), transitionProps), {
        transition: "fade"
    }), (transitionStyles)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hgiQh.Overlay), $f07e6ad50100acde$var$__spreadValues({
            ref: ref,
            onClick: handleClick,
            fixed: true,
            style: $f07e6ad50100acde$var$__spreadValues($f07e6ad50100acde$var$__spreadValues({}, style), transitionStyles),
            className: cx(classes.overlay, className),
            zIndex: ctx.zIndex
        }, others)));
});

});
parcelRegister("1yHO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $122af2aa5a35720b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $122af2aa5a35720b$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        overlay: {}
    }));
var $122af2aa5a35720b$export$2e2bcd8739ae039 = $122af2aa5a35720b$var$useStyles;

});

parcelRegister("1RCXp", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $15b8f5c43466c7ac$export$be58926105124dd4);

var $acw62 = parcelRequire("acw62");

var $lpy5P = parcelRequire("lpy5P");

var $iIkY3 = parcelRequire("iIkY3");
function $15b8f5c43466c7ac$export$be58926105124dd4({ keepMounted: keepMounted, transition: transition, duration: duration = 250, exitDuration: exitDuration = duration, mounted: mounted, children: children, timingFunction: timingFunction, onExit: onExit, onEntered: onEntered, onEnter: onEnter, onExited: onExited }) {
    const { transitionDuration: transitionDuration, transitionStatus: transitionStatus, transitionTimingFunction: transitionTimingFunction } = (0, $iIkY3.useTransition)({
        mounted: mounted,
        exitDuration: exitDuration,
        duration: duration,
        timingFunction: timingFunction,
        onExit: onExit,
        onEntered: onEntered,
        onEnter: onEnter,
        onExited: onExited
    });
    if (transitionDuration === 0) return mounted ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children({})) : keepMounted ? children({
        display: "none"
    }) : null;
    return transitionStatus === "exited" ? keepMounted ? children({
        display: "none"
    }) : null : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children((0, $lpy5P.getTransitionStyles)({
        transition: transition,
        duration: transitionDuration,
        state: transitionStatus,
        timingFunction: transitionTimingFunction
    })));
}
$15b8f5c43466c7ac$export$be58926105124dd4.displayName = "@mantine/core/Transition";

});
parcelRegister("lpy5P", function(module, exports) {

$parcel$export(module.exports, "getTransitionStyles", () => $f96660ee51ca7ffb$export$cfbcd9a4c0ed32ac);

var $hIpzu = parcelRequire("hIpzu");
var $f96660ee51ca7ffb$var$__defProp = Object.defineProperty;
var $f96660ee51ca7ffb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f96660ee51ca7ffb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f96660ee51ca7ffb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f96660ee51ca7ffb$var$__defNormalProp = (obj, key, value)=>key in obj ? $f96660ee51ca7ffb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f96660ee51ca7ffb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f96660ee51ca7ffb$var$__hasOwnProp.call(b, prop)) $f96660ee51ca7ffb$var$__defNormalProp(a, prop, b[prop]);
    if ($f96660ee51ca7ffb$var$__getOwnPropSymbols) {
        for (var prop of $f96660ee51ca7ffb$var$__getOwnPropSymbols(b))if ($f96660ee51ca7ffb$var$__propIsEnum.call(b, prop)) $f96660ee51ca7ffb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
const $f96660ee51ca7ffb$var$transitionStatuses = {
    entering: "in",
    entered: "in",
    exiting: "out",
    exited: "out",
    "pre-exiting": "out",
    "pre-entering": "out"
};
function $f96660ee51ca7ffb$export$cfbcd9a4c0ed32ac({ transition: transition, state: state, duration: duration, timingFunction: timingFunction }) {
    const shared = {
        transitionDuration: `${duration}ms`,
        transitionTimingFunction: timingFunction
    };
    if (typeof transition === "string") {
        if (!(transition in (0, $hIpzu.transitions))) return null;
        return $f96660ee51ca7ffb$var$__spreadValues($f96660ee51ca7ffb$var$__spreadValues($f96660ee51ca7ffb$var$__spreadValues({
            transitionProperty: (0, $hIpzu.transitions)[transition].transitionProperty
        }, shared), (0, $hIpzu.transitions)[transition].common), (0, $hIpzu.transitions)[transition][$f96660ee51ca7ffb$var$transitionStatuses[state]]);
    }
    return $f96660ee51ca7ffb$var$__spreadValues($f96660ee51ca7ffb$var$__spreadValues($f96660ee51ca7ffb$var$__spreadValues({
        transitionProperty: transition.transitionProperty
    }, shared), transition.common), transition[$f96660ee51ca7ffb$var$transitionStatuses[state]]);
}

});
parcelRegister("hIpzu", function(module, exports) {

$parcel$export(module.exports, "transitions", () => $ce5a61b05f74b2fe$export$622eca585e740ed5);

var $2jkdX = parcelRequire("2jkdX");
var $ce5a61b05f74b2fe$var$__defProp = Object.defineProperty;
var $ce5a61b05f74b2fe$var$__defProps = Object.defineProperties;
var $ce5a61b05f74b2fe$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ce5a61b05f74b2fe$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ce5a61b05f74b2fe$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ce5a61b05f74b2fe$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ce5a61b05f74b2fe$var$__defNormalProp = (obj, key, value)=>key in obj ? $ce5a61b05f74b2fe$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ce5a61b05f74b2fe$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ce5a61b05f74b2fe$var$__hasOwnProp.call(b, prop)) $ce5a61b05f74b2fe$var$__defNormalProp(a, prop, b[prop]);
    if ($ce5a61b05f74b2fe$var$__getOwnPropSymbols) {
        for (var prop of $ce5a61b05f74b2fe$var$__getOwnPropSymbols(b))if ($ce5a61b05f74b2fe$var$__propIsEnum.call(b, prop)) $ce5a61b05f74b2fe$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ce5a61b05f74b2fe$var$__spreadProps = (a, b)=>$ce5a61b05f74b2fe$var$__defProps(a, $ce5a61b05f74b2fe$var$__getOwnPropDescs(b));
const $ce5a61b05f74b2fe$var$popIn = {
    in: {
        opacity: 1,
        transform: "scale(1)"
    },
    out: {
        opacity: 0,
        transform: `scale(.9) translateY(${(0, $2jkdX.rem)(10)})`
    },
    transitionProperty: "transform, opacity"
};
const $ce5a61b05f74b2fe$export$622eca585e740ed5 = {
    fade: {
        in: {
            opacity: 1
        },
        out: {
            opacity: 0
        },
        transitionProperty: "opacity"
    },
    scale: {
        in: {
            opacity: 1,
            transform: "scale(1)"
        },
        out: {
            opacity: 0,
            transform: "scale(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-y": {
        in: {
            opacity: 1,
            transform: "scaleY(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleY(0)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "scale-x": {
        in: {
            opacity: 1,
            transform: "scaleX(1)"
        },
        out: {
            opacity: 0,
            transform: "scaleX(0)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-up": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: `translateY(-${(0, $2jkdX.rem)(20)}) skew(-10deg, -5deg)`
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "skew-down": {
        in: {
            opacity: 1,
            transform: "translateY(0) skew(0deg, 0deg)"
        },
        out: {
            opacity: 0,
            transform: `translateY(${(0, $2jkdX.rem)(20)}) skew(-10deg, -5deg)`
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-left": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: `translateY(${(0, $2jkdX.rem)(20)}) rotate(-5deg)`
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "rotate-right": {
        in: {
            opacity: 1,
            transform: "translateY(0) rotate(0deg)"
        },
        out: {
            opacity: 0,
            transform: `translateY(${(0, $2jkdX.rem)(20)}) rotate(5deg)`
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-down": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(-100%)"
        },
        common: {
            transformOrigin: "top"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-up": {
        in: {
            opacity: 1,
            transform: "translateY(0)"
        },
        out: {
            opacity: 0,
            transform: "translateY(100%)"
        },
        common: {
            transformOrigin: "bottom"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-left": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(100%)"
        },
        common: {
            transformOrigin: "left"
        },
        transitionProperty: "transform, opacity"
    },
    "slide-right": {
        in: {
            opacity: 1,
            transform: "translateX(0)"
        },
        out: {
            opacity: 0,
            transform: "translateX(-100%)"
        },
        common: {
            transformOrigin: "right"
        },
        transitionProperty: "transform, opacity"
    },
    pop: $ce5a61b05f74b2fe$var$__spreadProps($ce5a61b05f74b2fe$var$__spreadValues({}, $ce5a61b05f74b2fe$var$popIn), {
        common: {
            transformOrigin: "center center"
        }
    }),
    "pop-bottom-left": $ce5a61b05f74b2fe$var$__spreadProps($ce5a61b05f74b2fe$var$__spreadValues({}, $ce5a61b05f74b2fe$var$popIn), {
        common: {
            transformOrigin: "bottom left"
        }
    }),
    "pop-bottom-right": $ce5a61b05f74b2fe$var$__spreadProps($ce5a61b05f74b2fe$var$__spreadValues({}, $ce5a61b05f74b2fe$var$popIn), {
        common: {
            transformOrigin: "bottom right"
        }
    }),
    "pop-top-left": $ce5a61b05f74b2fe$var$__spreadProps($ce5a61b05f74b2fe$var$__spreadValues({}, $ce5a61b05f74b2fe$var$popIn), {
        common: {
            transformOrigin: "top left"
        }
    }),
    "pop-top-right": $ce5a61b05f74b2fe$var$__spreadProps($ce5a61b05f74b2fe$var$__spreadValues({}, $ce5a61b05f74b2fe$var$popIn), {
        common: {
            transformOrigin: "top right"
        }
    })
};

});


parcelRegister("iIkY3", function(module, exports) {

$parcel$export(module.exports, "useTransition", () => $d9fc99c41eaa8085$export$7b286972b8d8ccbf);

var $acw62 = parcelRequire("acw62");

var $2qf6h = parcelRequire("2qf6h");
var $hG392 = parcelRequire("hG392");

var $64A2P = parcelRequire("64A2P");
function $d9fc99c41eaa8085$export$7b286972b8d8ccbf({ duration: duration, exitDuration: exitDuration, timingFunction: timingFunction, mounted: mounted, onEnter: onEnter, onExit: onExit, onEntered: onEntered, onExited: onExited }) {
    const theme = (0, $64A2P.useMantineTheme)();
    const shouldReduceMotion = (0, $hG392.useReducedMotion)();
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const [transitionDuration, setTransitionDuration] = (0, $acw62.useState)(reduceMotion ? 0 : duration);
    const [transitionStatus, setStatus] = (0, $acw62.useState)(mounted ? "entered" : "exited");
    const timeoutRef = (0, $acw62.useRef)(-1);
    const handleStateChange = (shouldMount)=>{
        const preHandler = shouldMount ? onEnter : onExit;
        const handler = shouldMount ? onEntered : onExited;
        setStatus(shouldMount ? "pre-entering" : "pre-exiting");
        window.clearTimeout(timeoutRef.current);
        const newTransitionDuration = reduceMotion ? 0 : shouldMount ? duration : exitDuration;
        setTransitionDuration(newTransitionDuration);
        if (newTransitionDuration === 0) {
            typeof preHandler === "function" && preHandler();
            typeof handler === "function" && handler();
            setStatus(shouldMount ? "entered" : "exited");
        } else {
            const preStateTimeout = window.setTimeout(()=>{
                typeof preHandler === "function" && preHandler();
                setStatus(shouldMount ? "entering" : "exiting");
            }, 10);
            timeoutRef.current = window.setTimeout(()=>{
                window.clearTimeout(preStateTimeout);
                typeof handler === "function" && handler();
                setStatus(shouldMount ? "entered" : "exited");
            }, newTransitionDuration);
        }
    };
    (0, $2qf6h.useDidUpdate)(()=>{
        handleStateChange(mounted);
    }, [
        mounted
    ]);
    (0, $acw62.useEffect)(()=>()=>window.clearTimeout(timeoutRef.current), []);
    return {
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus,
        transitionTimingFunction: timingFunction || theme.transitionTimingFunction
    };
}

});
parcelRegister("hG392", function(module, exports) {

$parcel$export(module.exports, "useReducedMotion", () => $cde8cc65a1a0241f$export$6a42007cf1e7b6f8);

var $kFu1s = parcelRequire("kFu1s");
function $cde8cc65a1a0241f$export$6a42007cf1e7b6f8(initialValue, options) {
    return (0, $kFu1s.useMediaQuery)("(prefers-reduced-motion: reduce)", initialValue, options);
}

});



parcelRegister("hgiQh", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $c9128bf1d42947dd$export$c6fdb837b070b4ff);

var $acw62 = parcelRequire("acw62");

var $iu1L3 = parcelRequire("iu1L3");
var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $aJ1NU = parcelRequire("aJ1NU");

var $hiiR1 = parcelRequire("hiiR1");
var $c9128bf1d42947dd$var$__defProp = Object.defineProperty;
var $c9128bf1d42947dd$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c9128bf1d42947dd$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c9128bf1d42947dd$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c9128bf1d42947dd$var$__defNormalProp = (obj, key, value)=>key in obj ? $c9128bf1d42947dd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c9128bf1d42947dd$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c9128bf1d42947dd$var$__hasOwnProp.call(b, prop)) $c9128bf1d42947dd$var$__defNormalProp(a, prop, b[prop]);
    if ($c9128bf1d42947dd$var$__getOwnPropSymbols) {
        for (var prop of $c9128bf1d42947dd$var$__getOwnPropSymbols(b))if ($c9128bf1d42947dd$var$__propIsEnum.call(b, prop)) $c9128bf1d42947dd$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c9128bf1d42947dd$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c9128bf1d42947dd$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c9128bf1d42947dd$var$__getOwnPropSymbols) {
        for (var prop of $c9128bf1d42947dd$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c9128bf1d42947dd$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c9128bf1d42947dd$var$defaultProps = {
    opacity: 0.6,
    color: "#000",
    zIndex: (0, $iu1L3.getDefaultZIndex)("modal"),
    radius: 0
};
const $c9128bf1d42947dd$var$_Overlay = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Overlay", $c9128bf1d42947dd$var$defaultProps, props), { variant: variant, opacity: opacity, color: color, blur: blur, gradient: gradient, zIndex: zIndex, radius: radius, children: children, className: className, classNames: classNames, styles: styles, unstyled: unstyled, center: center, fixed: fixed } = _a, others = $c9128bf1d42947dd$var$__objRest(_a, [
        "variant",
        "opacity",
        "color",
        "blur",
        "gradient",
        "zIndex",
        "radius",
        "children",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "center",
        "fixed"
    ]);
    const { classes: classes, cx: cx } = (0, $aJ1NU.default)({
        color: color,
        opacity: opacity,
        blur: blur,
        radius: radius,
        gradient: gradient,
        fixed: fixed,
        zIndex: zIndex
    }, {
        name: "Overlay",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $c9128bf1d42947dd$var$__spreadValues({
        ref: ref,
        className: cx(classes.root, className),
        "data-center": center || void 0
    }, others), children);
});
$c9128bf1d42947dd$var$_Overlay.displayName = "@mantine/core/Overlay";
const $c9128bf1d42947dd$export$c6fdb837b070b4ff = (0, $1euea.createPolymorphicComponent)($c9128bf1d42947dd$var$_Overlay);

});
parcelRegister("aJ1NU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cef81918d677be1$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $7cef81918d677be1$var$__defProp = Object.defineProperty;
var $7cef81918d677be1$var$__defProps = Object.defineProperties;
var $7cef81918d677be1$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7cef81918d677be1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7cef81918d677be1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7cef81918d677be1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7cef81918d677be1$var$__defNormalProp = (obj, key, value)=>key in obj ? $7cef81918d677be1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7cef81918d677be1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7cef81918d677be1$var$__hasOwnProp.call(b, prop)) $7cef81918d677be1$var$__defNormalProp(a, prop, b[prop]);
    if ($7cef81918d677be1$var$__getOwnPropSymbols) {
        for (var prop of $7cef81918d677be1$var$__getOwnPropSymbols(b))if ($7cef81918d677be1$var$__propIsEnum.call(b, prop)) $7cef81918d677be1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7cef81918d677be1$var$__spreadProps = (a, b)=>$7cef81918d677be1$var$__defProps(a, $7cef81918d677be1$var$__getOwnPropDescs(b));
var $7cef81918d677be1$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, opacity: opacity, blur: blur, radius: radius, gradient: gradient, fixed: fixed, zIndex: zIndex })=>({
        root: $7cef81918d677be1$var$__spreadProps($7cef81918d677be1$var$__spreadValues({}, theme.fn.cover(0)), {
            position: fixed ? "fixed" : "absolute",
            backgroundColor: gradient ? void 0 : theme.fn.rgba(color, opacity),
            backgroundImage: gradient,
            backdropFilter: blur ? `blur(${(0, $2jkdX.rem)(blur)})` : void 0,
            borderRadius: theme.fn.radius(radius),
            zIndex: zIndex,
            "&[data-center]": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }
        })
    }));
var $7cef81918d677be1$export$2e2bcd8739ae039 = $7cef81918d677be1$var$useStyles;

});



parcelRegister("gUfnm", function(module, exports) {

$parcel$export(module.exports, "ModalBaseContent", () => $c4edcda3a001334a$export$a0b222e605967853);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $a9TQj = parcelRequire("a9TQj");

var $49JBt = parcelRequire("49JBt");

var $1RCXp = parcelRequire("1RCXp");

var $D7Bq4 = parcelRequire("D7Bq4");

var $9Zs0z = parcelRequire("9Zs0z");
var $c4edcda3a001334a$var$__defProp = Object.defineProperty;
var $c4edcda3a001334a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c4edcda3a001334a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c4edcda3a001334a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c4edcda3a001334a$var$__defNormalProp = (obj, key, value)=>key in obj ? $c4edcda3a001334a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c4edcda3a001334a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c4edcda3a001334a$var$__hasOwnProp.call(b, prop)) $c4edcda3a001334a$var$__defNormalProp(a, prop, b[prop]);
    if ($c4edcda3a001334a$var$__getOwnPropSymbols) {
        for (var prop of $c4edcda3a001334a$var$__getOwnPropSymbols(b))if ($c4edcda3a001334a$var$__propIsEnum.call(b, prop)) $c4edcda3a001334a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c4edcda3a001334a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c4edcda3a001334a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c4edcda3a001334a$var$__getOwnPropSymbols) {
        for (var prop of $c4edcda3a001334a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c4edcda3a001334a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c4edcda3a001334a$var$defaultProps = {};
const $c4edcda3a001334a$export$a0b222e605967853 = (0, $acw62.forwardRef)((props, ref)=>{
    const ctx = (0, $a9TQj.useModalBaseContext)();
    const _a = (0, $64A2P.useComponentDefaultProps)(`${ctx.__staticSelector}Content`, $c4edcda3a001334a$var$defaultProps, props), { className: className, transitionProps: transitionProps, style: style, onKeyDown: onKeyDown } = _a, others = $c4edcda3a001334a$var$__objRest(_a, [
        "className",
        "transitionProps",
        "style",
        "onKeyDown"
    ]);
    const { classes: classes, cx: cx } = (0, $49JBt.default)({
        zIndex: ctx.zIndex
    }, ctx.stylesApi);
    const handleKeyDown = (event)=>{
        var _a2;
        const shouldTrigger = ((_a2 = event.target) == null ? void 0 : _a2.getAttribute("data-mantine-stop-propagation")) !== "true";
        shouldTrigger && event.key === "Escape" && ctx.closeOnEscape && ctx.onClose();
        onKeyDown == null || onKeyDown(event);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1RCXp.Transition), $c4edcda3a001334a$var$__spreadValues($c4edcda3a001334a$var$__spreadValues({
        mounted: ctx.opened,
        transition: "pop"
    }, ctx.transitionProps), transitionProps), (transitionStyles)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: cx(classes.inner)
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $D7Bq4.FocusTrap), {
            active: ctx.opened && ctx.trapFocus
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9Zs0z.Paper), $c4edcda3a001334a$var$__spreadValues({
            component: "section",
            role: "dialog",
            tabIndex: -1,
            "aria-modal": true,
            "aria-describedby": ctx.bodyMounted ? ctx.getBodyId() : void 0,
            "aria-labelledby": ctx.titleMounted ? ctx.getTitleId() : void 0,
            onKeyDown: handleKeyDown,
            ref: ref,
            className: cx(classes.content, className),
            style: $c4edcda3a001334a$var$__spreadValues($c4edcda3a001334a$var$__spreadValues({}, style), transitionStyles),
            shadow: ctx.shadow
        }, others), others.children))));
});

});
parcelRegister("49JBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $306b608e419cd59b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $306b608e419cd59b$var$useStyles = (0, $cQG1Y.createStyles)((_theme, { zIndex: zIndex })=>({
        inner: {
            position: "fixed",
            width: "100%",
            top: 0,
            bottom: 0,
            maxHeight: "100%",
            zIndex: zIndex,
            pointerEvents: "none"
        },
        content: {
            pointerEvents: "all"
        }
    }));
var $306b608e419cd59b$export$2e2bcd8739ae039 = $306b608e419cd59b$var$useStyles;

});

parcelRegister("D7Bq4", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", () => $07598a56baa611d8$export$34eba2437817a67b);

var $acw62 = parcelRequire("acw62");

var $cOXe5 = parcelRequire("cOXe5");

var $7NFjb = parcelRequire("7NFjb");
var $4GmKa = parcelRequire("4GmKa");
function $07598a56baa611d8$export$34eba2437817a67b({ children: children, active: active = true, refProp: refProp = "ref" }) {
    const focusTrapRef = (0, $7NFjb.useFocusTrap)(active);
    const ref = (0, $4GmKa.useMergedRef)(focusTrapRef, children == null ? void 0 : children.ref);
    if (!(0, $cOXe5.isElement)(children)) return children;
    return (0, $acw62.cloneElement)(children, {
        [refProp]: ref
    });
}
$07598a56baa611d8$export$34eba2437817a67b.displayName = "@mantine/core/FocusTrap";

});
parcelRegister("cOXe5", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $955818a2e9f94dcb$export$45a5e7f76e0caa8d);

var $acw62 = parcelRequire("acw62");
function $955818a2e9f94dcb$export$45a5e7f76e0caa8d(value) {
    if (Array.isArray(value) || value === null) return false;
    if (typeof value === "object") {
        if (value.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) return false;
        return true;
    }
    return false;
}

});

parcelRegister("7NFjb", function(module, exports) {

$parcel$export(module.exports, "useFocusTrap", () => $5add270393b3e5ad$export$5562a1f223a0d314);

var $acw62 = parcelRequire("acw62");

var $kmsLb = parcelRequire("kmsLb");

var $hKCzF = parcelRequire("hKCzF");

var $kJKSx = parcelRequire("kJKSx");
function $5add270393b3e5ad$export$5562a1f223a0d314(active = true) {
    const ref = (0, $acw62.useRef)();
    const restoreAria = (0, $acw62.useRef)(null);
    const focusNode = (node)=>{
        let focusElement = node.querySelector("[data-autofocus]");
        if (!focusElement) {
            const children = Array.from(node.querySelectorAll((0, $kmsLb.FOCUS_SELECTOR)));
            focusElement = children.find((0, $kmsLb.tabbable)) || children.find((0, $kmsLb.focusable)) || null;
            if (!focusElement && (0, $kmsLb.focusable)(node)) focusElement = node;
        }
        if (focusElement) focusElement.focus({
            preventScroll: true
        });
    };
    const setRef = (0, $acw62.useCallback)((node)=>{
        if (!active) return;
        if (node === null) {
            if (restoreAria.current) {
                restoreAria.current();
                restoreAria.current = null;
            }
            return;
        }
        restoreAria.current = (0, $kJKSx.createAriaHider)(node);
        if (ref.current === node) return;
        if (node) {
            setTimeout(()=>{
                if (node.getRootNode()) focusNode(node);
            });
            ref.current = node;
        } else ref.current = null;
    }, [
        active
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!active) return void 0;
        ref.current && setTimeout(()=>focusNode(ref.current));
        const handleKeyDown = (event)=>{
            if (event.key === "Tab" && ref.current) (0, $hKCzF.scopeTab)(ref.current, event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            if (restoreAria.current) restoreAria.current();
        };
    }, [
        active
    ]);
    return setRef;
}

});
parcelRegister("kmsLb", function(module, exports) {

$parcel$export(module.exports, "FOCUS_SELECTOR", () => $ed2c2be24d58aae5$export$1402e37c3ad71960);
$parcel$export(module.exports, "focusable", () => $ed2c2be24d58aae5$export$ecc6d1fcdff4f700);
$parcel$export(module.exports, "tabbable", () => $ed2c2be24d58aae5$export$17100aea90429aa7);
$parcel$export(module.exports, "findTabbableDescendants", () => $ed2c2be24d58aae5$export$9add2e4db58062c);
const $ed2c2be24d58aae5$var$TABBABLE_NODES = /input|select|textarea|button|object/;
const $ed2c2be24d58aae5$export$1402e37c3ad71960 = "a, input, select, textarea, button, object, [tabindex]";
function $ed2c2be24d58aae5$var$hidden(element) {
    return element.style.display === "none";
}
function $ed2c2be24d58aae5$var$visible(element) {
    const isHidden = element.getAttribute("aria-hidden") || element.getAttribute("hidden") || element.getAttribute("type") === "hidden";
    if (isHidden) return false;
    let parentElement = element;
    while(parentElement){
        if (parentElement === document.body || parentElement.nodeType === 11) break;
        if ($ed2c2be24d58aae5$var$hidden(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $ed2c2be24d58aae5$var$getElementTabIndex(element) {
    let tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = void 0;
    return parseInt(tabIndex, 10);
}
function $ed2c2be24d58aae5$export$ecc6d1fcdff4f700(element) {
    const nodeName = element.nodeName.toLowerCase();
    const isTabIndexNotNaN = !Number.isNaN($ed2c2be24d58aae5$var$getElementTabIndex(element));
    const res = $ed2c2be24d58aae5$var$TABBABLE_NODES.test(nodeName) && !element.disabled || (element instanceof HTMLAnchorElement ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $ed2c2be24d58aae5$var$visible(element);
}
function $ed2c2be24d58aae5$export$17100aea90429aa7(element) {
    const tabIndex = $ed2c2be24d58aae5$var$getElementTabIndex(element);
    const isTabIndexNaN = Number.isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $ed2c2be24d58aae5$export$ecc6d1fcdff4f700(element);
}
function $ed2c2be24d58aae5$export$9add2e4db58062c(element) {
    return Array.from(element.querySelectorAll($ed2c2be24d58aae5$export$1402e37c3ad71960)).filter($ed2c2be24d58aae5$export$17100aea90429aa7);
}

});

parcelRegister("hKCzF", function(module, exports) {

$parcel$export(module.exports, "scopeTab", () => $cec4a79738dacc21$export$a4ab3f53d4a6be9b);

var $kmsLb = parcelRequire("kmsLb");
function $cec4a79738dacc21$export$a4ab3f53d4a6be9b(node, event) {
    const tabbable = (0, $kmsLb.findTabbableDescendants)(node);
    if (!tabbable.length) {
        event.preventDefault();
        return;
    }
    const finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
    const root = node.getRootNode();
    const leavingFinalTabbable = finalTabbable === root.activeElement || node === root.activeElement;
    if (!leavingFinalTabbable) return;
    event.preventDefault();
    const target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
    if (target) target.focus();
}

});

parcelRegister("kJKSx", function(module, exports) {

$parcel$export(module.exports, "createAriaHider", () => $f18c5fb9c27b6dbb$export$a1d7ca7bc7dc5023);

var $45cdq = parcelRequire("45cdq");
function $f18c5fb9c27b6dbb$export$a1d7ca7bc7dc5023(containerNode, selector = "body > :not(script)") {
    const id = (0, $45cdq.randomId)();
    const rootNodes = Array.from(document.querySelectorAll(selector)).map((node)=>{
        var _a;
        if (((_a = node == null ? void 0 : node.shadowRoot) == null ? void 0 : _a.contains(containerNode)) || node.contains(containerNode)) return void 0;
        const ariaHidden = node.getAttribute("aria-hidden");
        const prevAriaHidden = node.getAttribute("data-hidden");
        const prevFocusId = node.getAttribute("data-focus-id");
        node.setAttribute("data-focus-id", id);
        if (ariaHidden === null || ariaHidden === "false") node.setAttribute("aria-hidden", "true");
        else if (!prevAriaHidden && !prevFocusId) node.setAttribute("data-hidden", ariaHidden);
        return {
            node: node,
            ariaHidden: prevAriaHidden || null
        };
    });
    return ()=>{
        rootNodes.forEach((item)=>{
            if (!item || id !== item.node.getAttribute("data-focus-id")) return;
            if (item.ariaHidden === null) item.node.removeAttribute("aria-hidden");
            else item.node.setAttribute("aria-hidden", item.ariaHidden);
            item.node.removeAttribute("data-focus-id");
            item.node.removeAttribute("data-hidden");
        });
    };
}

});


parcelRegister("4GmKa", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $368cba13308fa890$export$c9058316764c140e);
$parcel$export(module.exports, "useMergedRef", () => $368cba13308fa890$export$36a55fa7500f01f);

var $acw62 = parcelRequire("acw62");

var $69QHb = parcelRequire("69QHb");
function $368cba13308fa890$export$c9058316764c140e(...refs) {
    return (node)=>{
        refs.forEach((ref)=>(0, $69QHb.assignRef)(ref, node));
    };
}
function $368cba13308fa890$export$36a55fa7500f01f(...refs) {
    return (0, $acw62.useCallback)($368cba13308fa890$export$c9058316764c140e(...refs), refs);
}

});
parcelRegister("69QHb", function(module, exports) {

$parcel$export(module.exports, "assignRef", () => $47bc7597d51af2f2$export$d734136a7b018efe);
function $47bc7597d51af2f2$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (typeof ref === "object" && ref !== null && "current" in ref) ref.current = value;
}

});



parcelRegister("9Zs0z", function(module, exports) {

$parcel$export(module.exports, "Paper", () => $745f896b7783cf98$export$e01703dff029898a);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $gEWzl = parcelRequire("gEWzl");

var $hiiR1 = parcelRequire("hiiR1");
var $745f896b7783cf98$var$__defProp = Object.defineProperty;
var $745f896b7783cf98$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $745f896b7783cf98$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $745f896b7783cf98$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $745f896b7783cf98$var$__defNormalProp = (obj, key, value)=>key in obj ? $745f896b7783cf98$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $745f896b7783cf98$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($745f896b7783cf98$var$__hasOwnProp.call(b, prop)) $745f896b7783cf98$var$__defNormalProp(a, prop, b[prop]);
    if ($745f896b7783cf98$var$__getOwnPropSymbols) {
        for (var prop of $745f896b7783cf98$var$__getOwnPropSymbols(b))if ($745f896b7783cf98$var$__propIsEnum.call(b, prop)) $745f896b7783cf98$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $745f896b7783cf98$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($745f896b7783cf98$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $745f896b7783cf98$var$__getOwnPropSymbols) {
        for (var prop of $745f896b7783cf98$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $745f896b7783cf98$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $745f896b7783cf98$var$defaultProps = {};
const $745f896b7783cf98$export$813d2a099a1ad365 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Paper", $745f896b7783cf98$var$defaultProps, props), { className: className, children: children, radius: radius, withBorder: withBorder, shadow: shadow, unstyled: unstyled, variant: variant } = _a, others = $745f896b7783cf98$var$__objRest(_a, [
        "className",
        "children",
        "radius",
        "withBorder",
        "shadow",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $gEWzl.default)({
        radius: radius,
        shadow: shadow
    }, {
        name: "Paper",
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $745f896b7783cf98$var$__spreadValues({
        className: cx(classes.root, className),
        "data-with-border": withBorder || void 0,
        ref: ref
    }, others), children);
});
$745f896b7783cf98$export$813d2a099a1ad365.displayName = "@mantine/core/Paper";
const $745f896b7783cf98$export$e01703dff029898a = (0, $1euea.createPolymorphicComponent)($745f896b7783cf98$export$813d2a099a1ad365);

});
parcelRegister("gEWzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20dd059fcbc1282$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $c20dd059fcbc1282$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, shadow: shadow })=>({
        root: {
            outline: 0,
            WebkitTapHighlightColor: "transparent",
            display: "block",
            textDecoration: "none",
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            boxSizing: "border-box",
            borderRadius: theme.fn.radius(radius),
            boxShadow: theme.shadows[shadow] || shadow || "none",
            "&[data-with-border]": {
                border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`
            }
        }
    }));
var $c20dd059fcbc1282$export$2e2bcd8739ae039 = $c20dd059fcbc1282$var$useStyles;

});



parcelRegister("58ByZ", function(module, exports) {

$parcel$export(module.exports, "ModalBaseHeader", () => $3bdad664930d4918$export$6cdb8b1b385d5e98);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $a9TQj = parcelRequire("a9TQj");

var $8oBmz = parcelRequire("8oBmz");

var $hiiR1 = parcelRequire("hiiR1");
var $3bdad664930d4918$var$__defProp = Object.defineProperty;
var $3bdad664930d4918$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3bdad664930d4918$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3bdad664930d4918$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3bdad664930d4918$var$__defNormalProp = (obj, key, value)=>key in obj ? $3bdad664930d4918$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3bdad664930d4918$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3bdad664930d4918$var$__hasOwnProp.call(b, prop)) $3bdad664930d4918$var$__defNormalProp(a, prop, b[prop]);
    if ($3bdad664930d4918$var$__getOwnPropSymbols) {
        for (var prop of $3bdad664930d4918$var$__getOwnPropSymbols(b))if ($3bdad664930d4918$var$__propIsEnum.call(b, prop)) $3bdad664930d4918$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3bdad664930d4918$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3bdad664930d4918$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3bdad664930d4918$var$__getOwnPropSymbols) {
        for (var prop of $3bdad664930d4918$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3bdad664930d4918$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3bdad664930d4918$var$defaultProps = {};
const $3bdad664930d4918$export$6cdb8b1b385d5e98 = (0, $acw62.forwardRef)((props, ref)=>{
    const ctx = (0, $a9TQj.useModalBaseContext)();
    const _a = (0, $64A2P.useComponentDefaultProps)(`${ctx.__staticSelector}Header`, $3bdad664930d4918$var$defaultProps, props), { className: className } = _a, others = $3bdad664930d4918$var$__objRest(_a, [
        "className"
    ]);
    const { classes: classes, cx: cx } = (0, $8oBmz.default)({
        padding: ctx.padding
    }, ctx.stylesApi);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $3bdad664930d4918$var$__spreadValues({
        ref: ref,
        className: cx(classes.header, className)
    }, others));
});

});
parcelRegister("8oBmz", function(module, exports) {

$parcel$export(module.exports, "default", () => $61cd8c20d02e009b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $61cd8c20d02e009b$var$useStyles = (0, $cQG1Y.createStyles)((theme, { padding: padding })=>{
    const paddingValue = (0, $d8Ix8.getSize)({
        size: padding,
        sizes: theme.spacing
    });
    return {
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: paddingValue,
            paddingRight: `calc(${paddingValue} - ${(0, $2jkdX.rem)(5)})`,
            position: "sticky",
            top: 0,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            zIndex: 1e3
        }
    };
});
var $61cd8c20d02e009b$export$2e2bcd8739ae039 = $61cd8c20d02e009b$var$useStyles;

});


parcelRegister("elhDj", function(module, exports) {

$parcel$export(module.exports, "ModalBaseTitle", () => $a710b4664bc21b6a$export$a1d3732afcf18148);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $a9TQj = parcelRequire("a9TQj");

var $MHoUh = parcelRequire("MHoUh");

var $hiiR1 = parcelRequire("hiiR1");
var $a710b4664bc21b6a$var$__defProp = Object.defineProperty;
var $a710b4664bc21b6a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a710b4664bc21b6a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a710b4664bc21b6a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a710b4664bc21b6a$var$__defNormalProp = (obj, key, value)=>key in obj ? $a710b4664bc21b6a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a710b4664bc21b6a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a710b4664bc21b6a$var$__hasOwnProp.call(b, prop)) $a710b4664bc21b6a$var$__defNormalProp(a, prop, b[prop]);
    if ($a710b4664bc21b6a$var$__getOwnPropSymbols) {
        for (var prop of $a710b4664bc21b6a$var$__getOwnPropSymbols(b))if ($a710b4664bc21b6a$var$__propIsEnum.call(b, prop)) $a710b4664bc21b6a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a710b4664bc21b6a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a710b4664bc21b6a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a710b4664bc21b6a$var$__getOwnPropSymbols) {
        for (var prop of $a710b4664bc21b6a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a710b4664bc21b6a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a710b4664bc21b6a$var$defaultProps = {};
const $a710b4664bc21b6a$export$a1d3732afcf18148 = (0, $acw62.forwardRef)((props, ref)=>{
    const ctx = (0, $a9TQj.useModalBaseContext)();
    const _a = (0, $64A2P.useComponentDefaultProps)(`${ctx.__staticSelector}Title`, $a710b4664bc21b6a$var$defaultProps, props), { className: className } = _a, others = $a710b4664bc21b6a$var$__objRest(_a, [
        "className"
    ]);
    const { classes: classes, cx: cx } = (0, $MHoUh.default)(null, ctx.stylesApi);
    (0, $acw62.useEffect)(()=>{
        ctx.setTitleMounted(true);
        return ()=>ctx.setTitleMounted(false);
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $a710b4664bc21b6a$var$__spreadValues({
        component: "h2",
        id: ctx.getTitleId(),
        className: cx(classes.title, className),
        ref: ref
    }, others));
});

});
parcelRegister("MHoUh", function(module, exports) {

$parcel$export(module.exports, "default", () => $09262649e9d3ce2b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $09262649e9d3ce2b$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        title: {
            lineHeight: 1,
            padding: 0,
            margin: 0,
            fontWeight: 400,
            fontSize: theme.fontSizes.md
        }
    }));
var $09262649e9d3ce2b$export$2e2bcd8739ae039 = $09262649e9d3ce2b$var$useStyles;

});


parcelRegister("iOuSR", function(module, exports) {

$parcel$export(module.exports, "ModalBaseBody", () => $db24da640770a67f$export$d7aef95ad3794d3a);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $a9TQj = parcelRequire("a9TQj");

var $lRmRu = parcelRequire("lRmRu");

var $hiiR1 = parcelRequire("hiiR1");
var $db24da640770a67f$var$__defProp = Object.defineProperty;
var $db24da640770a67f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $db24da640770a67f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $db24da640770a67f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $db24da640770a67f$var$__defNormalProp = (obj, key, value)=>key in obj ? $db24da640770a67f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $db24da640770a67f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($db24da640770a67f$var$__hasOwnProp.call(b, prop)) $db24da640770a67f$var$__defNormalProp(a, prop, b[prop]);
    if ($db24da640770a67f$var$__getOwnPropSymbols) {
        for (var prop of $db24da640770a67f$var$__getOwnPropSymbols(b))if ($db24da640770a67f$var$__propIsEnum.call(b, prop)) $db24da640770a67f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $db24da640770a67f$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($db24da640770a67f$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $db24da640770a67f$var$__getOwnPropSymbols) {
        for (var prop of $db24da640770a67f$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $db24da640770a67f$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $db24da640770a67f$var$defaultProps = {};
const $db24da640770a67f$export$d7aef95ad3794d3a = (0, $acw62.forwardRef)((props, ref)=>{
    const ctx = (0, $a9TQj.useModalBaseContext)();
    const _a = (0, $64A2P.useComponentDefaultProps)(`${ctx.__staticSelector}Body`, $db24da640770a67f$var$defaultProps, props), { className: className } = _a, others = $db24da640770a67f$var$__objRest(_a, [
        "className"
    ]);
    const { classes: classes, cx: cx } = (0, $lRmRu.default)({
        padding: ctx.padding
    }, ctx.stylesApi);
    (0, $acw62.useEffect)(()=>{
        ctx.setBodyMounted(true);
        return ()=>ctx.setBodyMounted(false);
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $db24da640770a67f$var$__spreadValues({
        id: ctx.getBodyId(),
        className: cx(classes.body, className),
        ref: ref
    }, others));
});

});
parcelRegister("lRmRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fea048145572f4eb$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $fea048145572f4eb$var$useStyles = (0, $cQG1Y.createStyles)((theme, { padding: padding })=>({
        body: {
            padding: (0, $d8Ix8.getSize)({
                size: padding,
                sizes: theme.spacing
            }),
            "&:not(:only-child)": {
                paddingTop: 0
            }
        }
    }));
var $fea048145572f4eb$export$2e2bcd8739ae039 = $fea048145572f4eb$var$useStyles;

});


parcelRegister("03VNK", function(module, exports) {

$parcel$export(module.exports, "NativeScrollArea", () => $00bd1e12229a296f$export$db1aa91c77c94e4c);

var $acw62 = parcelRequire("acw62");
function $00bd1e12229a296f$export$db1aa91c77c94e4c({ children: children }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
}

});

parcelRegister("03Zlp", function(module, exports) {

$parcel$export(module.exports, "useLockScroll", () => $00bfdda0b3f8d9d9$export$6be872921498f185);

var $acw62 = parcelRequire("acw62");

var $hG392 = parcelRequire("hG392");
function $00bfdda0b3f8d9d9$export$6be872921498f185({ opened: opened, transitionDuration: transitionDuration }) {
    const [shouldLockScroll, setShouldLockScroll] = (0, $acw62.useState)(opened);
    const timeout = (0, $acw62.useRef)();
    const reduceMotion = (0, $hG392.useReducedMotion)();
    const _transitionDuration = reduceMotion ? 0 : transitionDuration;
    (0, $acw62.useEffect)(()=>{
        if (opened) {
            setShouldLockScroll(true);
            window.clearTimeout(timeout.current);
        } else if (_transitionDuration === 0) setShouldLockScroll(false);
        else timeout.current = window.setTimeout(()=>setShouldLockScroll(false), _transitionDuration);
        return ()=>window.clearTimeout(timeout.current);
    }, [
        opened,
        _transitionDuration
    ]);
    return shouldLockScroll;
}

});

parcelRegister("lwFVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabd1c8a51f2ef6f$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $fabd1c8a51f2ef6f$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        root: {}
    }));
var $fabd1c8a51f2ef6f$export$2e2bcd8739ae039 = $fabd1c8a51f2ef6f$var$useStyles;

});

parcelRegister("hZi38", function(module, exports) {

$parcel$export(module.exports, "OptionalPortal", () => $d186226e67f48b5c$export$425106c5d6e6dc37);

var $acw62 = parcelRequire("acw62");

var $jISpv = parcelRequire("jISpv");
var $d186226e67f48b5c$var$__defProp = Object.defineProperty;
var $d186226e67f48b5c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d186226e67f48b5c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d186226e67f48b5c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d186226e67f48b5c$var$__defNormalProp = (obj, key, value)=>key in obj ? $d186226e67f48b5c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d186226e67f48b5c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d186226e67f48b5c$var$__hasOwnProp.call(b, prop)) $d186226e67f48b5c$var$__defNormalProp(a, prop, b[prop]);
    if ($d186226e67f48b5c$var$__getOwnPropSymbols) {
        for (var prop of $d186226e67f48b5c$var$__getOwnPropSymbols(b))if ($d186226e67f48b5c$var$__propIsEnum.call(b, prop)) $d186226e67f48b5c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d186226e67f48b5c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d186226e67f48b5c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d186226e67f48b5c$var$__getOwnPropSymbols) {
        for (var prop of $d186226e67f48b5c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d186226e67f48b5c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $d186226e67f48b5c$export$425106c5d6e6dc37(_a) {
    var _b = _a, { withinPortal: withinPortal = true, children: children } = _b, others = $d186226e67f48b5c$var$__objRest(_b, [
        "withinPortal",
        "children"
    ]);
    if (withinPortal) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jISpv.Portal), $d186226e67f48b5c$var$__spreadValues({}, others), children);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
}
$d186226e67f48b5c$export$425106c5d6e6dc37.displayName = "@mantine/core/OptionalPortal";

});
parcelRegister("jISpv", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $e5bc552a75bd7c00$export$602eac185826482c);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $l65IU = parcelRequire("l65IU");

var $64A2P = parcelRequire("64A2P");
var $e5bc552a75bd7c00$var$__defProp = Object.defineProperty;
var $e5bc552a75bd7c00$var$__defProps = Object.defineProperties;
var $e5bc552a75bd7c00$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e5bc552a75bd7c00$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e5bc552a75bd7c00$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e5bc552a75bd7c00$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e5bc552a75bd7c00$var$__defNormalProp = (obj, key, value)=>key in obj ? $e5bc552a75bd7c00$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e5bc552a75bd7c00$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e5bc552a75bd7c00$var$__hasOwnProp.call(b, prop)) $e5bc552a75bd7c00$var$__defNormalProp(a, prop, b[prop]);
    if ($e5bc552a75bd7c00$var$__getOwnPropSymbols) {
        for (var prop of $e5bc552a75bd7c00$var$__getOwnPropSymbols(b))if ($e5bc552a75bd7c00$var$__propIsEnum.call(b, prop)) $e5bc552a75bd7c00$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e5bc552a75bd7c00$var$__spreadProps = (a, b)=>$e5bc552a75bd7c00$var$__defProps(a, $e5bc552a75bd7c00$var$__getOwnPropDescs(b));
var $e5bc552a75bd7c00$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e5bc552a75bd7c00$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e5bc552a75bd7c00$var$__getOwnPropSymbols) {
        for (var prop of $e5bc552a75bd7c00$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e5bc552a75bd7c00$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $e5bc552a75bd7c00$export$602eac185826482c(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("Portal", {}, props), { children: children, target: target, className: className, innerRef: innerRef } = _a, others = $e5bc552a75bd7c00$var$__objRest(_a, [
        "children",
        "target",
        "className",
        "innerRef"
    ]);
    const theme = (0, $64A2P.useMantineTheme)();
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    const ref = (0, $acw62.useRef)();
    (0, $l65IU.useIsomorphicEffect)(()=>{
        setMounted(true);
        ref.current = !target ? document.createElement("div") : typeof target === "string" ? document.querySelector(target) : target;
        if (!target) document.body.appendChild(ref.current);
        return ()=>{
            !target && document.body.removeChild(ref.current);
        };
    }, [
        target
    ]);
    if (!mounted) return null;
    return (0, $1u0KT.createPortal)(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $e5bc552a75bd7c00$var$__spreadProps($e5bc552a75bd7c00$var$__spreadValues({
        className: className,
        dir: theme.dir
    }, others), {
        ref: innerRef
    }), children), ref.current);
}
$e5bc552a75bd7c00$export$602eac185826482c.displayName = "@mantine/core/Portal";

});




parcelRegister("3FUyz", function(module, exports) {

$parcel$export(module.exports, "ModalContent", () => $2ad112685b5b4525$export$6da19a24bf249f17);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $8CbGk = parcelRequire("8CbGk");

var $2k72v = parcelRequire("2k72v");
var $2ad112685b5b4525$var$__defProp = Object.defineProperty;
var $2ad112685b5b4525$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2ad112685b5b4525$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2ad112685b5b4525$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2ad112685b5b4525$var$__defNormalProp = (obj, key, value)=>key in obj ? $2ad112685b5b4525$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2ad112685b5b4525$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2ad112685b5b4525$var$__hasOwnProp.call(b, prop)) $2ad112685b5b4525$var$__defNormalProp(a, prop, b[prop]);
    if ($2ad112685b5b4525$var$__getOwnPropSymbols) {
        for (var prop of $2ad112685b5b4525$var$__getOwnPropSymbols(b))if ($2ad112685b5b4525$var$__propIsEnum.call(b, prop)) $2ad112685b5b4525$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2ad112685b5b4525$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2ad112685b5b4525$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2ad112685b5b4525$var$__getOwnPropSymbols) {
        for (var prop of $2ad112685b5b4525$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2ad112685b5b4525$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $2ad112685b5b4525$var$defaultProps = {
    shadow: "xl"
};
const $2ad112685b5b4525$export$6da19a24bf249f17 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("ModalContent", $2ad112685b5b4525$var$defaultProps, props), { children: children, scrollAreaComponent: scrollAreaComponent } = _a, others = $2ad112685b5b4525$var$__objRest(_a, [
        "children",
        "scrollAreaComponent"
    ]);
    const ctx = (0, $8CbGk.useModalContext)();
    const Scroll = scrollAreaComponent || ctx.scrollAreaComponent || (0, $2k72v.ModalBase).NativeScrollArea;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2k72v.ModalBase).Content, $2ad112685b5b4525$var$__spreadValues({
        ref: ref,
        radius: ctx.radius
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Scroll, {
        style: {
            maxHeight: `calc(100dvh - (${(0, $2jkdX.rem)(ctx.yOffset)} * 2))`
        }
    }, children));
});

});


parcelRegister("5Eq0L", function(module, exports) {

$parcel$export(module.exports, "ScrollArea", () => $41d4dd7f221409e8$export$ccf8d8d7bbf3c2cc);

var $acw62 = parcelRequire("acw62");

var $4wmxb = parcelRequire("4wmxb");

var $64A2P = parcelRequire("64A2P");

var $g71zw = parcelRequire("g71zw");

var $fcsWx = parcelRequire("fcsWx");

var $hiiR1 = parcelRequire("hiiR1");
var $41d4dd7f221409e8$var$__defProp = Object.defineProperty;
var $41d4dd7f221409e8$var$__defProps = Object.defineProperties;
var $41d4dd7f221409e8$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $41d4dd7f221409e8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $41d4dd7f221409e8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $41d4dd7f221409e8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $41d4dd7f221409e8$var$__defNormalProp = (obj, key, value)=>key in obj ? $41d4dd7f221409e8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $41d4dd7f221409e8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($41d4dd7f221409e8$var$__hasOwnProp.call(b, prop)) $41d4dd7f221409e8$var$__defNormalProp(a, prop, b[prop]);
    if ($41d4dd7f221409e8$var$__getOwnPropSymbols) {
        for (var prop of $41d4dd7f221409e8$var$__getOwnPropSymbols(b))if ($41d4dd7f221409e8$var$__propIsEnum.call(b, prop)) $41d4dd7f221409e8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $41d4dd7f221409e8$var$__spreadProps = (a, b)=>$41d4dd7f221409e8$var$__defProps(a, $41d4dd7f221409e8$var$__getOwnPropDescs(b));
var $41d4dd7f221409e8$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($41d4dd7f221409e8$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $41d4dd7f221409e8$var$__getOwnPropSymbols) {
        for (var prop of $41d4dd7f221409e8$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $41d4dd7f221409e8$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $41d4dd7f221409e8$var$defaultProps = {
    scrollbarSize: 12,
    scrollHideDelay: 1e3,
    type: "hover",
    offsetScrollbars: false
};
const $41d4dd7f221409e8$export$7927a64ac511cfbb = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("ScrollArea", $41d4dd7f221409e8$var$defaultProps, props), { children: children, className: className, classNames: classNames, styles: styles, scrollbarSize: scrollbarSize, scrollHideDelay: scrollHideDelay, type: type, dir: dir, offsetScrollbars: offsetScrollbars, viewportRef: viewportRef, onScrollPositionChange: onScrollPositionChange, unstyled: unstyled, variant: variant, viewportProps: viewportProps } = _a, others = $41d4dd7f221409e8$var$__objRest(_a, [
        "children",
        "className",
        "classNames",
        "styles",
        "scrollbarSize",
        "scrollHideDelay",
        "type",
        "dir",
        "offsetScrollbars",
        "viewportRef",
        "onScrollPositionChange",
        "unstyled",
        "variant",
        "viewportProps"
    ]);
    const [scrollbarHovered, setScrollbarHovered] = (0, $acw62.useState)(false);
    const theme = (0, $64A2P.useMantineTheme)();
    const { classes: classes, cx: cx } = (0, $fcsWx.default)({
        scrollbarSize: scrollbarSize,
        offsetScrollbars: offsetScrollbars,
        scrollbarHovered: scrollbarHovered,
        hidden: type === "never"
    }, {
        name: "ScrollArea",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4wmxb.Root, {
        type: type === "never" ? "always" : type,
        scrollHideDelay: scrollHideDelay,
        dir: dir || theme.dir,
        ref: ref,
        asChild: true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $41d4dd7f221409e8$var$__spreadValues({
        className: cx(classes.root, className)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4wmxb.Viewport, $41d4dd7f221409e8$var$__spreadProps($41d4dd7f221409e8$var$__spreadValues({}, viewportProps), {
        className: classes.viewport,
        ref: viewportRef,
        onScroll: typeof onScrollPositionChange === "function" ? ({ currentTarget: currentTarget })=>onScrollPositionChange({
                x: currentTarget.scrollLeft,
                y: currentTarget.scrollTop
            }) : void 0
    }), children), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4wmxb.Scrollbar, {
        orientation: "horizontal",
        className: classes.scrollbar,
        forceMount: true,
        onMouseEnter: ()=>setScrollbarHovered(true),
        onMouseLeave: ()=>setScrollbarHovered(false)
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4wmxb.Thumb, {
        className: classes.thumb
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4wmxb.Scrollbar, {
        orientation: "vertical",
        className: classes.scrollbar,
        forceMount: true,
        onMouseEnter: ()=>setScrollbarHovered(true),
        onMouseLeave: ()=>setScrollbarHovered(false)
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4wmxb.Thumb, {
        className: classes.thumb
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4wmxb.Corner, {
        className: classes.corner
    })));
});
const $41d4dd7f221409e8$var$ScrollAreaAutosize = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("ScrollAreaAutosize", $41d4dd7f221409e8$var$defaultProps, props), { children: children, classNames: classNames, styles: styles, scrollbarSize: scrollbarSize, scrollHideDelay: scrollHideDelay, type: type, dir: dir, offsetScrollbars: offsetScrollbars, viewportRef: viewportRef, onScrollPositionChange: onScrollPositionChange, unstyled: unstyled, sx: sx, variant: variant, viewportProps: viewportProps } = _a, others = $41d4dd7f221409e8$var$__objRest(_a, [
        "children",
        "classNames",
        "styles",
        "scrollbarSize",
        "scrollHideDelay",
        "type",
        "dir",
        "offsetScrollbars",
        "viewportRef",
        "onScrollPositionChange",
        "unstyled",
        "sx",
        "variant",
        "viewportProps"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $41d4dd7f221409e8$var$__spreadProps($41d4dd7f221409e8$var$__spreadValues({}, others), {
        ref: ref,
        sx: [
            {
                display: "flex"
            },
            ...(0, $g71zw.packSx)(sx)
        ]
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), {
        sx: {
            display: "flex",
            flexDirection: "column",
            flex: 1
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($41d4dd7f221409e8$export$7927a64ac511cfbb, {
        classNames: classNames,
        styles: styles,
        scrollHideDelay: scrollHideDelay,
        scrollbarSize: scrollbarSize,
        type: type,
        dir: dir,
        offsetScrollbars: offsetScrollbars,
        viewportRef: viewportRef,
        onScrollPositionChange: onScrollPositionChange,
        unstyled: unstyled,
        variant: variant,
        viewportProps: viewportProps
    }, children)));
});
$41d4dd7f221409e8$var$ScrollAreaAutosize.displayName = "@mantine/core/ScrollAreaAutosize";
$41d4dd7f221409e8$export$7927a64ac511cfbb.displayName = "@mantine/core/ScrollArea";
$41d4dd7f221409e8$export$7927a64ac511cfbb.Autosize = $41d4dd7f221409e8$var$ScrollAreaAutosize;
const $41d4dd7f221409e8$export$ccf8d8d7bbf3c2cc = $41d4dd7f221409e8$export$7927a64ac511cfbb;

});
parcelRegister("4wmxb", function(module, exports) {

$parcel$export(module.exports, "Root", () => $34aba166d5bea69b$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Viewport", () => $34aba166d5bea69b$export$d5c6c08dc2d3ca7);
$parcel$export(module.exports, "Scrollbar", () => $34aba166d5bea69b$export$9a4e88b92edfce6b);
$parcel$export(module.exports, "Thumb", () => $34aba166d5bea69b$export$6521433ed15a34db);
$parcel$export(module.exports, "Corner", () => $34aba166d5bea69b$export$ac61190d9fc311a9);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $lWKq8 = parcelRequire("lWKq8");

var $4qUOV = parcelRequire("4qUOV");

var $dWWI0 = parcelRequire("dWWI0");

var $AvAQH = parcelRequire("AvAQH");

var $8AZZw = parcelRequire("8AZZw");

var $dObBR = parcelRequire("dObBR");

var $fptgm = parcelRequire("fptgm");

var $i3zAS = parcelRequire("i3zAS");

var $jjulE = parcelRequire("jjulE");
function $34aba166d5bea69b$var$$6c2e24571c90391f$export$3e6543de14f8614f(initialState, machine) {
    return (0, $acw62.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
/* -------------------------------------------------------------------------------------------------
 * ScrollArea
 * -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLL_AREA_NAME = 'ScrollArea';
const [$34aba166d5bea69b$var$$57acba87d6e25586$var$createScrollAreaContext, $34aba166d5bea69b$export$488468afe3a6f2b1] = (0, $dWWI0.createContextScope)($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLL_AREA_NAME);
const [$34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaProvider, $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext] = $34aba166d5bea69b$var$$57acba87d6e25586$var$createScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLL_AREA_NAME);
const $34aba166d5bea69b$export$ccf8d8d7bbf3c2cc = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, type: type = 'hover', dir: dir, scrollHideDelay: scrollHideDelay = 600, ...scrollAreaProps } = props;
    const [scrollArea, setScrollArea] = (0, $acw62.useState)(null);
    const [viewport, setViewport] = (0, $acw62.useState)(null);
    const [content, setContent] = (0, $acw62.useState)(null);
    const [scrollbarX, setScrollbarX] = (0, $acw62.useState)(null);
    const [scrollbarY, setScrollbarY] = (0, $acw62.useState)(null);
    const [cornerWidth, setCornerWidth] = (0, $acw62.useState)(0);
    const [cornerHeight, setCornerHeight] = (0, $acw62.useState)(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = (0, $acw62.useState)(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = (0, $acw62.useState)(false);
    const composedRefs = (0, $AvAQH.useComposedRefs)(forwardedRef, (node)=>setScrollArea(node));
    const direction = (0, $dObBR.useDirection)(dir);
    return /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaProvider, {
        scope: __scopeScrollArea,
        type: type,
        dir: direction,
        scrollHideDelay: scrollHideDelay,
        scrollArea: scrollArea,
        viewport: viewport,
        onViewportChange: setViewport,
        content: content,
        onContentChange: setContent,
        scrollbarX: scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled: scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY: scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled: scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $lWKq8.Primitive).div, (0, $8nd05.default)({
        dir: direction
    }, scrollAreaProps, {
        ref: composedRefs,
        style: {
            position: 'relative',
            // Pass corner sizes as CSS vars to reduce re-renders of context consumers
            ['--radix-scroll-area-corner-width']: cornerWidth + 'px',
            ['--radix-scroll-area-corner-height']: cornerHeight + 'px',
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($34aba166d5bea69b$export$ccf8d8d7bbf3c2cc, {
    displayName: $34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLL_AREA_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaViewport
 * -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$VIEWPORT_NAME = 'ScrollAreaViewport';
const $34aba166d5bea69b$export$a21cbf9f11fca853 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, children: children, ...viewportProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$VIEWPORT_NAME, __scopeScrollArea);
    const ref = (0, $acw62.useRef)(null);
    const composedRefs = (0, $AvAQH.useComposedRefs)(forwardedRef, ref, context.onViewportChange);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, /*#__PURE__*/ (0, $acw62.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
        }
    }), /*#__PURE__*/ (0, $acw62.createElement)((0, $lWKq8.Primitive).div, (0, $8nd05.default)({
        "data-radix-scroll-area-viewport": ""
    }, viewportProps, {
        ref: composedRefs,
        style: {
            /**
       * We don't support `visible` because the intention is to have at least one scrollbar
       * if this component is used and `visible` will behave like `auto` in that case
       * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
       *
       * We don't handle `auto` because the intention is for the native implementation
       * to be hidden if using this component. We just want to ensure the node is scrollable
       * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
       * the browser from having to work out whether to render native scrollbars or not,
       * we tell it to with the intention of hiding them in CSS.
       */ overflowX: context.scrollbarXEnabled ? 'scroll' : 'hidden',
            overflowY: context.scrollbarYEnabled ? 'scroll' : 'hidden',
            ...props.style
        }
    }), /*#__PURE__*/ (0, $acw62.createElement)("div", {
        ref: context.onContentChange,
        style: {
            minWidth: '100%',
            display: 'table'
        }
    }, children)));
});
/*#__PURE__*/ Object.assign($34aba166d5bea69b$export$a21cbf9f11fca853, {
    displayName: $34aba166d5bea69b$var$$57acba87d6e25586$var$VIEWPORT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaScrollbar
 * -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME = 'ScrollAreaScrollbar';
const $34aba166d5bea69b$export$2fabd85d0eba3c57 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange, onScrollbarYEnabledChange: onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === 'horizontal';
    (0, $acw62.useEffect)(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === 'hover' ? /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarHover, (0, $8nd05.default)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'scroll' ? /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarScroll, (0, $8nd05.default)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'auto' ? /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarAuto, (0, $8nd05.default)({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount: forceMount
    })) : context.type === 'always' ? /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0, $8nd05.default)({}, scrollbarProps, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($34aba166d5bea69b$export$2fabd85d0eba3c57, {
    displayName: $34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarHover = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [visible, setVisible] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const scrollArea = context.scrollArea;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false), context.scrollHideDelay);
            };
            scrollArea.addEventListener('pointerenter', handlePointerEnter);
            scrollArea.addEventListener('pointerleave', handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener('pointerenter', handlePointerEnter);
                scrollArea.removeEventListener('pointerleave', handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $4qUOV.Presence), {
        present: forceMount || visible
    }, /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarAuto, (0, $8nd05.default)({
        "data-state": visible ? 'visible' : 'hidden'
    }, scrollbarProps, {
        ref: forwardedRef
    })));
});
const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarScroll = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const isHorizontal = props.orientation === 'horizontal';
    const debounceScrollEnd = $34aba166d5bea69b$var$$57acba87d6e25586$var$useDebounceCallback(()=>send('SCROLL_END'), 100);
    const [state, send] = $34aba166d5bea69b$var$$6c2e24571c90391f$export$3e6543de14f8614f('hidden', {
        hidden: {
            SCROLL: 'scrolling'
        },
        scrolling: {
            SCROLL_END: 'idle',
            POINTER_ENTER: 'interacting'
        },
        interacting: {
            SCROLL: 'interacting',
            POINTER_LEAVE: 'idle'
        },
        idle: {
            HIDE: 'hidden',
            SCROLL: 'scrolling',
            POINTER_ENTER: 'interacting'
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (state === 'idle') {
            const hideTimer = window.setTimeout(()=>send('HIDE'), context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer);
        }
    }, [
        state,
        context.scrollHideDelay,
        send
    ]);
    (0, $acw62.useEffect)(()=>{
        const viewport = context.viewport;
        const scrollDirection = isHorizontal ? 'scrollLeft' : 'scrollTop';
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    send('SCROLL');
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll);
        }
    }, [
        context.viewport,
        isHorizontal,
        send,
        debounceScrollEnd
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $4qUOV.Presence), {
        present: forceMount || state !== 'hidden'
    }, /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0, $8nd05.default)({
        "data-state": state === 'hidden' ? 'hidden' : 'visible'
    }, scrollbarProps, {
        ref: forwardedRef,
        onPointerEnter: (0, $jjulE.composeEventHandlers)(props.onPointerEnter, ()=>send('POINTER_ENTER')),
        onPointerLeave: (0, $jjulE.composeEventHandlers)(props.onPointerLeave, ()=>send('POINTER_LEAVE'))
    })));
});
const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarAuto = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const [visible, setVisible] = (0, $acw62.useState)(false);
    const isHorizontal = props.orientation === 'horizontal';
    const handleResize = $34aba166d5bea69b$var$$57acba87d6e25586$var$useDebounceCallback(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    $34aba166d5bea69b$var$$57acba87d6e25586$var$useResizeObserver(context.viewport, handleResize);
    $34aba166d5bea69b$var$$57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $4qUOV.Presence), {
        present: forceMount || visible
    }, /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarVisible, (0, $8nd05.default)({
        "data-state": visible ? 'visible' : 'hidden'
    }, scrollbarProps, {
        ref: forwardedRef
    })));
});
/* -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarVisible = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { orientation: orientation = 'vertical', ...scrollbarProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const thumbRef = (0, $acw62.useRef)(null);
    const pointerOffsetRef = (0, $acw62.useRef)(0);
    const [sizes, setSizes] = (0, $acw62.useState)({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>thumbRef.current = thumb,
        onThumbPointerUp: ()=>pointerOffsetRef.current = 0,
        onThumbPointerDown: (pointerPos)=>pointerOffsetRef.current = pointerPos
    };
    function getScrollPosition(pointerPos, dir) {
        return $34aba166d5bea69b$var$$57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
    }
    if (orientation === 'horizontal') return /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarX, (0, $8nd05.default)({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
        }
    }));
    if (orientation === 'vertical') return /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarY, (0, $8nd05.default)({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    }));
    return null;
});
/* -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarX = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, ...scrollbarProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = (0, $acw62.useState)();
    const ref = (0, $acw62.useRef)(null);
    const composeRefs = (0, $AvAQH.useComposedRefs)(forwardedRef, ref, context.onScrollbarXChange);
    (0, $acw62.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarImpl, (0, $8nd05.default)({
        "data-orientation": "horizontal"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes: sizes,
        style: {
            bottom: 0,
            left: context.dir === 'rtl' ? 'var(--radix-scroll-area-corner-width)' : 0,
            right: context.dir === 'ltr' ? 'var(--radix-scroll-area-corner-width)' : 0,
            ['--radix-scroll-area-thumb-width']: $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbSize(sizes) + 'px',
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos); // prevent window scroll when wheeling on scrollbar
                if ($34aba166d5bea69b$var$$57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollWidth,
                viewport: context.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: $34aba166d5bea69b$var$$57acba87d6e25586$var$toInt(computedStyle.paddingLeft),
                    paddingEnd: $34aba166d5bea69b$var$$57acba87d6e25586$var$toInt(computedStyle.paddingRight)
                }
            });
        }
    }));
});
const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarY = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, ...scrollbarProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = (0, $acw62.useState)();
    const ref = (0, $acw62.useRef)(null);
    const composeRefs = (0, $AvAQH.useComposedRefs)(forwardedRef, ref, context.onScrollbarYChange);
    (0, $acw62.useEffect)(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarImpl, (0, $8nd05.default)({
        "data-orientation": "vertical"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes: sizes,
        style: {
            top: 0,
            right: context.dir === 'ltr' ? 0 : undefined,
            left: context.dir === 'rtl' ? 0 : undefined,
            bottom: 'var(--radix-scroll-area-corner-height)',
            ['--radix-scroll-area-thumb-height']: $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbSize(sizes) + 'px',
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos); // prevent window scroll when wheeling on scrollbar
                if ($34aba166d5bea69b$var$$57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: $34aba166d5bea69b$var$$57acba87d6e25586$var$toInt(computedStyle.paddingTop),
                    paddingEnd: $34aba166d5bea69b$var$$57acba87d6e25586$var$toInt(computedStyle.paddingBottom)
                }
            });
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const [$34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollbarProvider, $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollbarContext] = $34aba166d5bea69b$var$$57acba87d6e25586$var$createScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME);
const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaScrollbarImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, sizes: sizes, hasThumb: hasThumb, onThumbChange: onThumbChange, onThumbPointerUp: onThumbPointerUp, onThumbPointerDown: onThumbPointerDown, onThumbPositionChange: onThumbPositionChange, onDragScroll: onDragScroll, onWheelScroll: onWheelScroll, onResize: onResize, ...scrollbarProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$SCROLLBAR_NAME, __scopeScrollArea);
    const [scrollbar, setScrollbar] = (0, $acw62.useState)(null);
    const composeRefs = (0, $AvAQH.useComposedRefs)(forwardedRef, (node)=>setScrollbar(node));
    const rectRef = (0, $acw62.useRef)(null);
    const prevWebkitUserSelectRef = (0, $acw62.useRef)('');
    const viewport = context.viewport;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = (0, $8AZZw.useCallbackRef)(onWheelScroll);
    const handleThumbPositionChange = (0, $8AZZw.useCallbackRef)(onThumbPositionChange);
    const handleResize = $34aba166d5bea69b$var$$57acba87d6e25586$var$useDebounceCallback(onResize, 10);
    function handleDragScroll(event) {
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x: x,
                y: y
            });
        }
    }
    /**
   * We bind wheel event imperatively so we can switch off passive
   * mode for document wheel event to allow it to be prevented
   */ (0, $acw62.useEffect)(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar === null || scrollbar === void 0 ? void 0 : scrollbar.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener('wheel', handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener('wheel', handleWheel, {
                passive: false
            });
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    /**
   * Update thumb position on sizes change
   */ (0, $acw62.useEffect)(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    $34aba166d5bea69b$var$$57acba87d6e25586$var$useResizeObserver(scrollbar, handleResize);
    $34aba166d5bea69b$var$$57acba87d6e25586$var$useResizeObserver(context.content, handleResize);
    return /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollbarProvider, {
        scope: __scopeScrollArea,
        scrollbar: scrollbar,
        hasThumb: hasThumb,
        onThumbChange: (0, $8AZZw.useCallbackRef)(onThumbChange),
        onThumbPointerUp: (0, $8AZZw.useCallbackRef)(onThumbPointerUp),
        onThumbPositionChange: handleThumbPositionChange,
        onThumbPointerDown: (0, $8AZZw.useCallbackRef)(onThumbPointerDown)
    }, /*#__PURE__*/ (0, $acw62.createElement)((0, $lWKq8.Primitive).div, (0, $8nd05.default)({}, scrollbarProps, {
        ref: composeRefs,
        style: {
            position: 'absolute',
            ...scrollbarProps.style
        },
        onPointerDown: (0, $jjulE.composeEventHandlers)(props.onPointerDown, (event)=>{
            const mainPointer = 0;
            if (event.button === mainPointer) {
                const element = event.target;
                element.setPointerCapture(event.pointerId);
                rectRef.current = scrollbar.getBoundingClientRect(); // pointer capture doesn't prevent text selection in Safari
                // so we remove text selection manually when scrolling
                prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                document.body.style.webkitUserSelect = 'none';
                handleDragScroll(event);
            }
        }),
        onPointerMove: (0, $jjulE.composeEventHandlers)(props.onPointerMove, handleDragScroll),
        onPointerUp: (0, $jjulE.composeEventHandlers)(props.onPointerUp, (event)=>{
            const element = event.target;
            if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
            document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
            rectRef.current = null;
        })
    })));
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaThumb
 * -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$THUMB_NAME = 'ScrollAreaThumb';
const $34aba166d5bea69b$export$9fba1154677d7cd2 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, ...thumbProps } = props;
    const scrollbarContext = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollbarContext($34aba166d5bea69b$var$$57acba87d6e25586$var$THUMB_NAME, props.__scopeScrollArea);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $4qUOV.Presence), {
        present: forceMount || scrollbarContext.hasThumb
    }, /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaThumbImpl, (0, $8nd05.default)({
        ref: forwardedRef
    }, thumbProps)));
});
const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaThumbImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, style: style, ...thumbProps } = props;
    const scrollAreaContext = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollbarContext($34aba166d5bea69b$var$$57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange: onThumbPositionChange } = scrollbarContext;
    const composedRef = (0, $AvAQH.useComposedRefs)(forwardedRef, (node)=>scrollbarContext.onThumbChange(node));
    const removeUnlinkedScrollListenerRef = (0, $acw62.useRef)();
    const debounceScrollEnd = $34aba166d5bea69b$var$$57acba87d6e25586$var$useDebounceCallback(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = undefined;
        }
    }, 100);
    (0, $acw62.useEffect)(()=>{
        const viewport = scrollAreaContext.viewport;
        if (viewport) {
            /**
       * We only bind to native scroll event so we know when scroll starts and ends.
       * When scroll starts we start a requestAnimationFrame loop that checks for
       * changes to scroll position. That rAF loop triggers our thumb position change
       * when relevant to avoid scroll-linked effects. We cancel the loop when scroll ends.
       * https://developer.mozilla.org/en-US/docs/Mozilla/Performance/Scroll-linked_effects
       */ const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = $34aba166d5bea69b$var$$57acba87d6e25586$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener('scroll', handleScroll);
            return ()=>viewport.removeEventListener('scroll', handleScroll);
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $lWKq8.Primitive).div, (0, $8nd05.default)({
        "data-state": scrollbarContext.hasThumb ? 'visible' : 'hidden'
    }, thumbProps, {
        ref: composedRef,
        style: {
            width: 'var(--radix-scroll-area-thumb-width)',
            height: 'var(--radix-scroll-area-thumb-height)',
            ...style
        },
        onPointerDownCapture: (0, $jjulE.composeEventHandlers)(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: (0, $jjulE.composeEventHandlers)(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    }));
});
/*#__PURE__*/ Object.assign($34aba166d5bea69b$export$9fba1154677d7cd2, {
    displayName: $34aba166d5bea69b$var$$57acba87d6e25586$var$THUMB_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ScrollAreaCorner
 * -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$CORNER_NAME = 'ScrollAreaCorner';
const $34aba166d5bea69b$export$56969d565df7cc4b = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$CORNER_NAME, props.__scopeScrollArea);
    const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
    const hasCorner = context.type !== 'scroll' && hasBothScrollbarsVisible;
    return hasCorner ? /*#__PURE__*/ (0, $acw62.createElement)($34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaCornerImpl, (0, $8nd05.default)({}, props, {
        ref: forwardedRef
    })) : null;
});
/*#__PURE__*/ Object.assign($34aba166d5bea69b$export$56969d565df7cc4b, {
    displayName: $34aba166d5bea69b$var$$57acba87d6e25586$var$CORNER_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$var$$57acba87d6e25586$var$ScrollAreaCornerImpl = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, ...cornerProps } = props;
    const context = $34aba166d5bea69b$var$$57acba87d6e25586$var$useScrollAreaContext($34aba166d5bea69b$var$$57acba87d6e25586$var$CORNER_NAME, __scopeScrollArea);
    const [width1, setWidth] = (0, $acw62.useState)(0);
    const [height1, setHeight] = (0, $acw62.useState)(0);
    const hasSize = Boolean(width1 && height1);
    $34aba166d5bea69b$var$$57acba87d6e25586$var$useResizeObserver(context.scrollbarX, ()=>{
        var _context$scrollbarX;
        const height = ((_context$scrollbarX = context.scrollbarX) === null || _context$scrollbarX === void 0 ? void 0 : _context$scrollbarX.offsetHeight) || 0;
        context.onCornerHeightChange(height);
        setHeight(height);
    });
    $34aba166d5bea69b$var$$57acba87d6e25586$var$useResizeObserver(context.scrollbarY, ()=>{
        var _context$scrollbarY;
        const width = ((_context$scrollbarY = context.scrollbarY) === null || _context$scrollbarY === void 0 ? void 0 : _context$scrollbarY.offsetWidth) || 0;
        context.onCornerWidthChange(width);
        setWidth(width);
    });
    return hasSize ? /*#__PURE__*/ (0, $acw62.createElement)((0, $lWKq8.Primitive).div, (0, $8nd05.default)({}, cornerProps, {
        ref: forwardedRef,
        style: {
            width: width1,
            height: height1,
            position: 'absolute',
            right: context.dir === 'ltr' ? 0 : undefined,
            left: context.dir === 'rtl' ? 0 : undefined,
            bottom: 0,
            ...props.style
        }
    })) : null;
});
/* -----------------------------------------------------------------------------------------------*/ function $34aba166d5bea69b$var$$57acba87d6e25586$var$toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
function $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbRatio(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return isNaN(ratio) ? 0 : ratio;
}
function $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbSize(sizes) {
    const ratio = $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio; // minimum of 18 matches macOS minimum
    return Math.max(thumbSize, 18);
}
function $34aba166d5bea69b$var$$57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = 'ltr') {
    const thumbSizePx = $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbSize(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === 'ltr' ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = $34aba166d5bea69b$var$$57acba87d6e25586$var$linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}
function $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = 'ltr') {
    const thumbSizePx = $34aba166d5bea69b$var$$57acba87d6e25586$var$getThumbSize(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === 'ltr' ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = (0, $i3zAS.clamp)(scrollPos, scrollClampRange);
    const interpolate = $34aba166d5bea69b$var$$57acba87d6e25586$var$linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
} // https://github.com/tmcw-up-for-adoption/simple-linear-scale/blob/master/index.js
function $34aba166d5bea69b$var$$57acba87d6e25586$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $34aba166d5bea69b$var$$57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
} // Custom scroll handler to avoid scroll-linked effects
// https://developer.mozilla.org/en-US/docs/Mozilla/Performance/Scroll-linked_effects
const $34aba166d5bea69b$var$$57acba87d6e25586$var$addUnlinkedScrollListener = (node, handler = ()=>{})=>{
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF);
};
function $34aba166d5bea69b$var$$57acba87d6e25586$var$useDebounceCallback(callback, delay) {
    const handleCallback = (0, $8AZZw.useCallbackRef)(callback);
    const debounceTimerRef = (0, $acw62.useRef)(0);
    (0, $acw62.useEffect)(()=>()=>window.clearTimeout(debounceTimerRef.current), []);
    return (0, $acw62.useCallback)(()=>{
        window.clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}
function $34aba166d5bea69b$var$$57acba87d6e25586$var$useResizeObserver(element, onResize) {
    const handleResize = (0, $8AZZw.useCallbackRef)(onResize);
    (0, $fptgm.useLayoutEffect)(()=>{
        let rAF = 0;
        if (element) {
            /**
       * Resize Observer will throw an often benign error that says `ResizeObserver loop
       * completed with undelivered notifications`. This means that ResizeObserver was not
       * able to deliver all observations within a single animation frame, so we use
       * `requestAnimationFrame` to ensure we don't deliver unnecessary observations.
       * Further reading: https://github.com/WICG/resize-observer/issues/38
       */ const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
/* -----------------------------------------------------------------------------------------------*/ const $34aba166d5bea69b$export$be92b6f5f03c0fe9 = $34aba166d5bea69b$export$ccf8d8d7bbf3c2cc;
const $34aba166d5bea69b$export$d5c6c08dc2d3ca7 = $34aba166d5bea69b$export$a21cbf9f11fca853;
const $34aba166d5bea69b$export$9a4e88b92edfce6b = $34aba166d5bea69b$export$2fabd85d0eba3c57;
const $34aba166d5bea69b$export$6521433ed15a34db = $34aba166d5bea69b$export$9fba1154677d7cd2;
const $34aba166d5bea69b$export$ac61190d9fc311a9 = $34aba166d5bea69b$export$56969d565df7cc4b;

});
parcelRegister("lWKq8", function(module, exports) {

$parcel$export(module.exports, "Primitive", () => $ffa305e20fe06c82$export$250ffa63cdc0d034);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $45MnV = parcelRequire("45MnV");
const $ffa305e20fe06c82$var$$8927f6f2acc4f386$var$NODES = [
    'a',
    'button',
    'div',
    'h2',
    'h3',
    'img',
    'label',
    'li',
    'nav',
    'ol',
    'p',
    'span',
    'svg',
    'ul'
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $ffa305e20fe06c82$export$250ffa63cdc0d034 = $ffa305e20fe06c82$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $45MnV.Slot) : node;
        (0, $acw62.useEffect)(()=>{
            window[Symbol.for('radix-ui')] = true;
        }, []);
        return /*#__PURE__*/ (0, $acw62.createElement)(Comp, (0, $8nd05.default)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $ffa305e20fe06c82$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $1u0KT.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $ffa305e20fe06c82$export$be92b6f5f03c0fe9 = $ffa305e20fe06c82$export$250ffa63cdc0d034;

});
parcelRegister("45MnV", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $2fad294522b5ed20$export$8c6ed5c666ac1360);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $AvAQH = parcelRequire("AvAQH");
/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $acw62.Children).toArray(children);
    const slottable = childrenArray.find($2fad294522b5ed20$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $acw62.Children).count(newElement) > 1) return (0, $acw62.Children).only(null);
                return /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $acw62.createElement)($2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone, (0, $8nd05.default)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $acw62.isValidElement)(newElement) ? /*#__PURE__*/ (0, $acw62.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $acw62.createElement)($2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone, (0, $8nd05.default)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$2fad294522b5ed20$export$8c6ed5c666ac1360.displayName = 'Slot';
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $acw62.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $acw62.isValidElement)(children)) return /*#__PURE__*/ (0, $acw62.cloneElement)(children, {
        ...$2fad294522b5ed20$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $AvAQH.composeRefs)(forwardedRef, children.ref)
    });
    return (0, $acw62.Children).count(children) > 1 ? (0, $acw62.Children).only(null) : null;
});
$2fad294522b5ed20$var$$5e63c961fc1ce211$var$SlotClone.displayName = 'SlotClone';
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $2fad294522b5ed20$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $2fad294522b5ed20$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $acw62.isValidElement)(child) && child.type === $2fad294522b5ed20$export$d9f1ccf0bdb05d45;
}
function $2fad294522b5ed20$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === 'style') overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === 'className') overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(' ');
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $2fad294522b5ed20$export$be92b6f5f03c0fe9 = $2fad294522b5ed20$export$8c6ed5c666ac1360;

});
parcelRegister("AvAQH", function(module, exports) {

$parcel$export(module.exports, "composeRefs", () => $06dbdeafb212d82f$export$43e446d32b3d21af);
$parcel$export(module.exports, "useComposedRefs", () => $06dbdeafb212d82f$export$c7b2cbe3552a0d05);

var $acw62 = parcelRequire("acw62");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$06dbdeafb212d82f$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $06dbdeafb212d82f$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $acw62.useCallback)($06dbdeafb212d82f$export$43e446d32b3d21af(...refs), refs);
}

});



parcelRegister("4qUOV", function(module, exports) {

$parcel$export(module.exports, "Presence", () => $33a5aa769cc85be3$export$99c2b779aa4e8b8b);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $AvAQH = parcelRequire("AvAQH");

var $fptgm = parcelRequire("fptgm");
function $33a5aa769cc85be3$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $acw62.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $33a5aa769cc85be3$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === 'function' ? children({
        present: presence.isPresent
    }) : (0, $acw62.Children).only(children);
    const ref = (0, $AvAQH.useComposedRefs)(presence.ref, child.ref);
    const forceMount = typeof children === 'function';
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $acw62.cloneElement)(child, {
        ref: ref
    }) : null;
};
$33a5aa769cc85be3$export$99c2b779aa4e8b8b.displayName = 'Presence';
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $33a5aa769cc85be3$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $acw62.useState)();
    const stylesRef = (0, $acw62.useRef)({});
    const prevPresentRef = (0, $acw62.useRef)(present);
    const prevAnimationNameRef = (0, $acw62.useRef)('none');
    const initialState = present ? 'mounted' : 'unmounted';
    const [state, send] = $33a5aa769cc85be3$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: 'unmounted',
            ANIMATION_OUT: 'unmountSuspended'
        },
        unmountSuspended: {
            MOUNT: 'mounted',
            ANIMATION_END: 'unmounted'
        },
        unmounted: {
            MOUNT: 'mounted'
        }
    });
    (0, $acw62.useEffect)(()=>{
        const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === 'mounted' ? currentAnimationName : 'none';
    }, [
        state
    ]);
    (0, $fptgm.useLayoutEffect)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send('MOUNT');
            else if (currentAnimationName === 'none' || (styles === null || styles === void 0 ? void 0 : styles.display) === 'none') // so we unmount instantly
            send('UNMOUNT');
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send('ANIMATION_OUT');
                else send('UNMOUNT');
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $fptgm.useLayoutEffect)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $1u0KT.flushSync)(()=>send('ANIMATION_END'));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener('animationstart', handleAnimationStart);
            node1.addEventListener('animationcancel', handleAnimationEnd);
            node1.addEventListener('animationend', handleAnimationEnd);
            return ()=>{
                node1.removeEventListener('animationstart', handleAnimationStart);
                node1.removeEventListener('animationcancel', handleAnimationEnd);
                node1.removeEventListener('animationend', handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send('ANIMATION_END');
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            'mounted',
            'unmountSuspended'
        ].includes(state),
        ref: (0, $acw62.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $33a5aa769cc85be3$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || 'none';
}

});
parcelRegister("fptgm", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $b37fe3d39d956993$export$e5c5a5f917a5871c);

var $acw62 = parcelRequire("acw62");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $b37fe3d39d956993$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $acw62.useLayoutEffect) : ()=>{};

});


parcelRegister("dWWI0", function(module, exports) {

$parcel$export(module.exports, "createContextScope", () => $a27e3b74a1e4b413$export$50c7b4e9d9f19c1);

var $acw62 = parcelRequire("acw62");
function $a27e3b74a1e4b413$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $acw62.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + 'Provider';
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $a27e3b74a1e4b413$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $acw62.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $acw62.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $acw62.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + 'Provider';
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $acw62.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $a27e3b74a1e4b413$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $a27e3b74a1e4b413$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $acw62.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}

});

parcelRegister("8AZZw", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", () => $6421c5b6e6501f6d$export$25bec8c6f54ee79a);

var $acw62 = parcelRequire("acw62");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $6421c5b6e6501f6d$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $acw62.useRef)(callback);
    (0, $acw62.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $acw62.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}

});

parcelRegister("dObBR", function(module, exports) {

$parcel$export(module.exports, "useDirection", () => $a0d8f34db6c98cd1$export$b39126d51d94e6f3);

var $acw62 = parcelRequire("acw62");
const $a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $a0d8f34db6c98cd1$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $acw62.createElement)($a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $a0d8f34db6c98cd1$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $acw62.useContext)($a0d8f34db6c98cd1$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || 'ltr';
}
const $a0d8f34db6c98cd1$export$2881499e37b75b9a = $a0d8f34db6c98cd1$export$c760c09fdd558351;

});

parcelRegister("i3zAS", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $d2541df9dc0cb3a3$export$7d15b64cf5a3a4c4);
function $d2541df9dc0cb3a3$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}

});

parcelRegister("jjulE", function(module, exports) {

$parcel$export(module.exports, "composeEventHandlers", () => $e0f75533c8da79e2$export$b9ecd428b558ff10);
function $e0f75533c8da79e2$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}

});


parcelRegister("fcsWx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10e6d7dedc4d14b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $3mzq6 = parcelRequire("3mzq6");
var $2jkdX = parcelRequire("2jkdX");
var $b10e6d7dedc4d14b$var$useStyles = (0, $cQG1Y.createStyles)((theme, { scrollbarSize: scrollbarSize, offsetScrollbars: offsetScrollbars, scrollbarHovered: scrollbarHovered, hidden: hidden })=>({
        root: {
            overflow: "hidden"
        },
        viewport: {
            width: "100%",
            height: "100%",
            paddingRight: offsetScrollbars ? (0, $2jkdX.rem)(scrollbarSize) : void 0,
            paddingBottom: offsetScrollbars ? (0, $2jkdX.rem)(scrollbarSize) : void 0
        },
        scrollbar: {
            display: hidden ? "none" : "flex",
            userSelect: "none",
            touchAction: "none",
            boxSizing: "border-box",
            padding: `calc(${(0, $2jkdX.rem)(scrollbarSize)}  / 5)`,
            transition: "background-color 150ms ease, opacity 150ms ease",
            "&:hover": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0],
                [`& .${(0, $3mzq6.getStylesRef)("thumb")}`]: {
                    backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.white, 0.5) : theme.fn.rgba(theme.black, 0.5)
                }
            },
            '&[data-orientation="vertical"]': {
                width: (0, $2jkdX.rem)(scrollbarSize)
            },
            '&[data-orientation="horizontal"]': {
                flexDirection: "column",
                height: (0, $2jkdX.rem)(scrollbarSize)
            },
            '&[data-state="hidden"]': {
                display: "none",
                opacity: 0
            }
        },
        thumb: {
            ref: (0, $3mzq6.getStylesRef)("thumb"),
            flex: 1,
            backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.white, 0.4) : theme.fn.rgba(theme.black, 0.4),
            borderRadius: (0, $2jkdX.rem)(scrollbarSize),
            position: "relative",
            transition: "background-color 150ms ease",
            display: hidden ? "none" : void 0,
            overflow: "hidden",
            "&::before": {
                content: '""',
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                height: "100%",
                minWidth: (0, $2jkdX.rem)(44),
                minHeight: (0, $2jkdX.rem)(44)
            }
        },
        corner: {
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
            transition: "opacity 150ms ease",
            opacity: scrollbarHovered ? 1 : 0,
            display: hidden ? "none" : void 0
        }
    }));
var $b10e6d7dedc4d14b$export$2e2bcd8739ae039 = $b10e6d7dedc4d14b$var$useStyles;

});
parcelRegister("3mzq6", function(module, exports) {

$parcel$export(module.exports, "getStylesRef", () => $272ee6d9a0193ad0$export$9bd1756ef71475d8);
function $272ee6d9a0193ad0$export$9bd1756ef71475d8(refName) {
    return `___ref-${refName || ""}`;
}

});



parcelRegister("8mycu", function(module, exports) {

$parcel$export(module.exports, "TextInput", () => $616ae8477d9ed4ae$export$c86715117507e8e5);

var $acw62 = parcelRequire("acw62");

var $hEdEV = parcelRequire("hEdEV");

var $gw63X = parcelRequire("gw63X");
var $616ae8477d9ed4ae$var$__defProp = Object.defineProperty;
var $616ae8477d9ed4ae$var$__defProps = Object.defineProperties;
var $616ae8477d9ed4ae$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $616ae8477d9ed4ae$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $616ae8477d9ed4ae$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $616ae8477d9ed4ae$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $616ae8477d9ed4ae$var$__defNormalProp = (obj, key, value)=>key in obj ? $616ae8477d9ed4ae$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $616ae8477d9ed4ae$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($616ae8477d9ed4ae$var$__hasOwnProp.call(b, prop)) $616ae8477d9ed4ae$var$__defNormalProp(a, prop, b[prop]);
    if ($616ae8477d9ed4ae$var$__getOwnPropSymbols) {
        for (var prop of $616ae8477d9ed4ae$var$__getOwnPropSymbols(b))if ($616ae8477d9ed4ae$var$__propIsEnum.call(b, prop)) $616ae8477d9ed4ae$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $616ae8477d9ed4ae$var$__spreadProps = (a, b)=>$616ae8477d9ed4ae$var$__defProps(a, $616ae8477d9ed4ae$var$__getOwnPropDescs(b));
var $616ae8477d9ed4ae$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($616ae8477d9ed4ae$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $616ae8477d9ed4ae$var$__getOwnPropSymbols) {
        for (var prop of $616ae8477d9ed4ae$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $616ae8477d9ed4ae$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $616ae8477d9ed4ae$var$defaultProps = {
    type: "text",
    size: "sm",
    __staticSelector: "TextInput"
};
const $616ae8477d9ed4ae$export$c86715117507e8e5 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $hEdEV.useInputProps)("TextInput", $616ae8477d9ed4ae$var$defaultProps, props), { inputProps: inputProps, wrapperProps: wrapperProps } = _a, others = $616ae8477d9ed4ae$var$__objRest(_a, [
        "inputProps",
        "wrapperProps"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $616ae8477d9ed4ae$var$__spreadValues({}, wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), $616ae8477d9ed4ae$var$__spreadProps($616ae8477d9ed4ae$var$__spreadValues($616ae8477d9ed4ae$var$__spreadValues({}, inputProps), others), {
        ref: ref
    })));
});
$616ae8477d9ed4ae$export$c86715117507e8e5.displayName = "@mantine/core/TextInput";

});
parcelRegister("hEdEV", function(module, exports) {

$parcel$export(module.exports, "useInputProps", () => $cd90c47fa2d2d606$export$434ed5c8d5bb7eb5);

var $64A2P = parcelRequire("64A2P");

var $8nBd8 = parcelRequire("8nBd8");

var $aEkmw = parcelRequire("aEkmw");
var $cd90c47fa2d2d606$var$__defProp = Object.defineProperty;
var $cd90c47fa2d2d606$var$__defProps = Object.defineProperties;
var $cd90c47fa2d2d606$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cd90c47fa2d2d606$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cd90c47fa2d2d606$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cd90c47fa2d2d606$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cd90c47fa2d2d606$var$__defNormalProp = (obj, key, value)=>key in obj ? $cd90c47fa2d2d606$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cd90c47fa2d2d606$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cd90c47fa2d2d606$var$__hasOwnProp.call(b, prop)) $cd90c47fa2d2d606$var$__defNormalProp(a, prop, b[prop]);
    if ($cd90c47fa2d2d606$var$__getOwnPropSymbols) {
        for (var prop of $cd90c47fa2d2d606$var$__getOwnPropSymbols(b))if ($cd90c47fa2d2d606$var$__propIsEnum.call(b, prop)) $cd90c47fa2d2d606$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cd90c47fa2d2d606$var$__spreadProps = (a, b)=>$cd90c47fa2d2d606$var$__defProps(a, $cd90c47fa2d2d606$var$__getOwnPropDescs(b));
var $cd90c47fa2d2d606$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($cd90c47fa2d2d606$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $cd90c47fa2d2d606$var$__getOwnPropSymbols) {
        for (var prop of $cd90c47fa2d2d606$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $cd90c47fa2d2d606$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $cd90c47fa2d2d606$export$434ed5c8d5bb7eb5(component, defaultProps, props) {
    const _a = (0, $64A2P.useComponentDefaultProps)(component, defaultProps, props), { label: label, description: description, error: error, required: required, classNames: classNames, styles: styles, className: className, unstyled: unstyled, __staticSelector: __staticSelector, sx: sx, errorProps: errorProps, labelProps: labelProps, descriptionProps: descriptionProps, wrapperProps: _wrapperProps, id: id, size: size, style: style, inputContainer: inputContainer, inputWrapperOrder: inputWrapperOrder, withAsterisk: withAsterisk, variant: variant } = _a, others = $cd90c47fa2d2d606$var$__objRest(_a, [
        "label",
        "description",
        "error",
        "required",
        "classNames",
        "styles",
        "className",
        "unstyled",
        "__staticSelector",
        "sx",
        "errorProps",
        "labelProps",
        "descriptionProps",
        "wrapperProps",
        "id",
        "size",
        "style",
        "inputContainer",
        "inputWrapperOrder",
        "withAsterisk",
        "variant"
    ]);
    const uid = (0, $8nBd8.useId)(id);
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const wrapperProps = $cd90c47fa2d2d606$var$__spreadValues({
        label: label,
        description: description,
        error: error,
        required: required,
        classNames: classNames,
        className: className,
        __staticSelector: __staticSelector,
        sx: sx,
        errorProps: errorProps,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        unstyled: unstyled,
        styles: styles,
        id: uid,
        size: size,
        style: style,
        inputContainer: inputContainer,
        inputWrapperOrder: inputWrapperOrder,
        withAsterisk: withAsterisk,
        variant: variant
    }, _wrapperProps);
    return $cd90c47fa2d2d606$var$__spreadProps($cd90c47fa2d2d606$var$__spreadValues({}, rest), {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        wrapperProps: $cd90c47fa2d2d606$var$__spreadValues($cd90c47fa2d2d606$var$__spreadValues({}, wrapperProps), systemStyles),
        inputProps: {
            required: required,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            id: uid,
            size: size,
            __staticSelector: __staticSelector,
            error: error,
            variant: variant
        }
    });
}

});

parcelRegister("gw63X", function(module, exports) {

$parcel$export(module.exports, "Input", () => $c064566d513eccc9$export$f5b8910cec6cf069);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $ib66y = parcelRequire("ib66y");

var $9UeRK = parcelRequire("9UeRK");

var $aHnmk = parcelRequire("aHnmk");

var $i2FU5 = parcelRequire("i2FU5");

var $9K2fO = parcelRequire("9K2fO");

var $4vZOz = parcelRequire("4vZOz");

var $bqYMI = parcelRequire("bqYMI");

var $aEkmw = parcelRequire("aEkmw");

var $hiiR1 = parcelRequire("hiiR1");
var $c064566d513eccc9$var$__defProp = Object.defineProperty;
var $c064566d513eccc9$var$__defProps = Object.defineProperties;
var $c064566d513eccc9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c064566d513eccc9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c064566d513eccc9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c064566d513eccc9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c064566d513eccc9$var$__defNormalProp = (obj, key, value)=>key in obj ? $c064566d513eccc9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c064566d513eccc9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c064566d513eccc9$var$__hasOwnProp.call(b, prop)) $c064566d513eccc9$var$__defNormalProp(a, prop, b[prop]);
    if ($c064566d513eccc9$var$__getOwnPropSymbols) {
        for (var prop of $c064566d513eccc9$var$__getOwnPropSymbols(b))if ($c064566d513eccc9$var$__propIsEnum.call(b, prop)) $c064566d513eccc9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c064566d513eccc9$var$__spreadProps = (a, b)=>$c064566d513eccc9$var$__defProps(a, $c064566d513eccc9$var$__getOwnPropDescs(b));
var $c064566d513eccc9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c064566d513eccc9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c064566d513eccc9$var$__getOwnPropSymbols) {
        for (var prop of $c064566d513eccc9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c064566d513eccc9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c064566d513eccc9$var$defaultProps = {
    size: "sm",
    variant: "default"
};
const $c064566d513eccc9$export$88fafa62fadb5f38 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Input", $c064566d513eccc9$var$defaultProps, props), { className: className, error: error, required: required, disabled: disabled, variant: variant, icon: icon, style: style, rightSectionWidth: rightSectionWidth, iconWidth: iconWidth, rightSection: rightSection, rightSectionProps: rightSectionProps, radius: radius, size: size, wrapperProps: wrapperProps, classNames: classNames, styles: styles, __staticSelector: __staticSelector, multiline: multiline, sx: sx, unstyled: unstyled, pointer: pointer } = _a, others = $c064566d513eccc9$var$__objRest(_a, [
        "className",
        "error",
        "required",
        "disabled",
        "variant",
        "icon",
        "style",
        "rightSectionWidth",
        "iconWidth",
        "rightSection",
        "rightSectionProps",
        "radius",
        "size",
        "wrapperProps",
        "classNames",
        "styles",
        "__staticSelector",
        "multiline",
        "sx",
        "unstyled",
        "pointer"
    ]);
    const { offsetBottom: offsetBottom, offsetTop: offsetTop, describedBy: describedBy } = (0, $4vZOz.useInputWrapperContext)();
    const { classes: classes, cx: cx } = (0, $bqYMI.default)({
        radius: radius,
        multiline: multiline,
        invalid: !!error,
        rightSectionWidth: rightSectionWidth ? (0, $2jkdX.rem)(rightSectionWidth) : void 0,
        iconWidth: iconWidth,
        withRightSection: !!rightSection,
        offsetBottom: offsetBottom,
        offsetTop: offsetTop,
        pointer: pointer
    }, {
        classNames: classNames,
        styles: styles,
        name: [
            "Input",
            __staticSelector
        ],
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $c064566d513eccc9$var$__spreadValues($c064566d513eccc9$var$__spreadValues({
        className: cx(classes.wrapper, className),
        sx: sx,
        style: style
    }, systemStyles), wrapperProps), icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.icon
    }, icon), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $c064566d513eccc9$var$__spreadProps($c064566d513eccc9$var$__spreadValues({
        component: "input"
    }, rest), {
        ref: ref,
        required: required,
        "aria-invalid": !!error,
        "aria-describedby": describedBy,
        disabled: disabled,
        "data-disabled": disabled || void 0,
        "data-with-icon": !!icon || void 0,
        "data-invalid": !!error || void 0,
        className: classes.input
    })), rightSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $c064566d513eccc9$var$__spreadProps($c064566d513eccc9$var$__spreadValues({}, rightSectionProps), {
        className: classes.rightSection
    }), rightSection));
});
$c064566d513eccc9$export$88fafa62fadb5f38.displayName = "@mantine/core/Input";
$c064566d513eccc9$export$88fafa62fadb5f38.Wrapper = (0, $ib66y.InputWrapper);
$c064566d513eccc9$export$88fafa62fadb5f38.Label = (0, $aHnmk.InputLabel);
$c064566d513eccc9$export$88fafa62fadb5f38.Description = (0, $9UeRK.InputDescription);
$c064566d513eccc9$export$88fafa62fadb5f38.Error = (0, $i2FU5.InputError);
$c064566d513eccc9$export$88fafa62fadb5f38.Placeholder = (0, $9K2fO.InputPlaceholder);
const $c064566d513eccc9$export$f5b8910cec6cf069 = (0, $1euea.createPolymorphicComponent)($c064566d513eccc9$export$88fafa62fadb5f38);

});
parcelRegister("ib66y", function(module, exports) {

$parcel$export(module.exports, "InputWrapper", () => $d3bdfd5ba6cb4811$export$fb9f58ebe9de6283);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $aHnmk = parcelRequire("aHnmk");

var $i2FU5 = parcelRequire("i2FU5");

var $9UeRK = parcelRequire("9UeRK");

var $4vZOz = parcelRequire("4vZOz");

var $7xD0G = parcelRequire("7xD0G");

var $6LnXX = parcelRequire("6LnXX");

var $hiiR1 = parcelRequire("hiiR1");
var $d3bdfd5ba6cb4811$var$__defProp = Object.defineProperty;
var $d3bdfd5ba6cb4811$var$__defProps = Object.defineProperties;
var $d3bdfd5ba6cb4811$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d3bdfd5ba6cb4811$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d3bdfd5ba6cb4811$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d3bdfd5ba6cb4811$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d3bdfd5ba6cb4811$var$__defNormalProp = (obj, key, value)=>key in obj ? $d3bdfd5ba6cb4811$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d3bdfd5ba6cb4811$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d3bdfd5ba6cb4811$var$__hasOwnProp.call(b, prop)) $d3bdfd5ba6cb4811$var$__defNormalProp(a, prop, b[prop]);
    if ($d3bdfd5ba6cb4811$var$__getOwnPropSymbols) {
        for (var prop of $d3bdfd5ba6cb4811$var$__getOwnPropSymbols(b))if ($d3bdfd5ba6cb4811$var$__propIsEnum.call(b, prop)) $d3bdfd5ba6cb4811$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d3bdfd5ba6cb4811$var$__spreadProps = (a, b)=>$d3bdfd5ba6cb4811$var$__defProps(a, $d3bdfd5ba6cb4811$var$__getOwnPropDescs(b));
var $d3bdfd5ba6cb4811$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d3bdfd5ba6cb4811$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d3bdfd5ba6cb4811$var$__getOwnPropSymbols) {
        for (var prop of $d3bdfd5ba6cb4811$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d3bdfd5ba6cb4811$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $d3bdfd5ba6cb4811$var$defaultProps = {
    labelElement: "label",
    size: "sm",
    inputContainer: (children)=>children,
    inputWrapperOrder: [
        "label",
        "description",
        "input",
        "error"
    ]
};
const $d3bdfd5ba6cb4811$export$fb9f58ebe9de6283 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("InputWrapper", $d3bdfd5ba6cb4811$var$defaultProps, props), { className: className, label: label, children: children, required: required, id: id, error: error, description: description, labelElement: labelElement, labelProps: labelProps, descriptionProps: descriptionProps, errorProps: errorProps, classNames: classNames, styles: styles, size: size, inputContainer: inputContainer, __staticSelector: __staticSelector, unstyled: unstyled, inputWrapperOrder: inputWrapperOrder, withAsterisk: withAsterisk, variant: variant } = _a, others = $d3bdfd5ba6cb4811$var$__objRest(_a, [
        "className",
        "label",
        "children",
        "required",
        "id",
        "error",
        "description",
        "labelElement",
        "labelProps",
        "descriptionProps",
        "errorProps",
        "classNames",
        "styles",
        "size",
        "inputContainer",
        "__staticSelector",
        "unstyled",
        "inputWrapperOrder",
        "withAsterisk",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $6LnXX.default)(null, {
        classNames: classNames,
        styles: styles,
        name: [
            "InputWrapper",
            __staticSelector
        ],
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const sharedProps = {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        size: size,
        variant: variant,
        __staticSelector: __staticSelector
    };
    const isRequired = typeof withAsterisk === "boolean" ? withAsterisk : required;
    const errorId = id ? `${id}-error` : errorProps == null ? void 0 : errorProps.id;
    const descriptionId = id ? `${id}-description` : descriptionProps == null ? void 0 : descriptionProps.id;
    const hasError = !!error && typeof error !== "boolean";
    const _describedBy = `${hasError ? errorId : ""} ${description ? descriptionId : ""}`;
    const describedBy = _describedBy.trim().length > 0 ? _describedBy.trim() : void 0;
    const _label = label && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aHnmk.InputLabel), $d3bdfd5ba6cb4811$var$__spreadValues($d3bdfd5ba6cb4811$var$__spreadValues({
        key: "label",
        labelElement: labelElement,
        id: id ? `${id}-label` : void 0,
        htmlFor: id,
        required: isRequired
    }, sharedProps), labelProps), label);
    const _description = description && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9UeRK.InputDescription), $d3bdfd5ba6cb4811$var$__spreadProps($d3bdfd5ba6cb4811$var$__spreadValues($d3bdfd5ba6cb4811$var$__spreadValues({
        key: "description"
    }, descriptionProps), sharedProps), {
        size: (descriptionProps == null ? void 0 : descriptionProps.size) || sharedProps.size,
        id: (descriptionProps == null ? void 0 : descriptionProps.id) || descriptionId
    }), description);
    const _input = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), {
        key: "input"
    }, inputContainer(children));
    const _error = typeof error !== "boolean" && error && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $i2FU5.InputError), $d3bdfd5ba6cb4811$var$__spreadProps($d3bdfd5ba6cb4811$var$__spreadValues($d3bdfd5ba6cb4811$var$__spreadValues({}, errorProps), sharedProps), {
        size: (errorProps == null ? void 0 : errorProps.size) || sharedProps.size,
        key: "error",
        id: (errorProps == null ? void 0 : errorProps.id) || errorId
    }), error);
    const content = inputWrapperOrder.map((part)=>{
        switch(part){
            case "label":
                return _label;
            case "input":
                return _input;
            case "description":
                return _description;
            case "error":
                return _error;
            default:
                return null;
        }
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4vZOz.InputWrapperProvider), {
        value: $d3bdfd5ba6cb4811$var$__spreadValues({
            describedBy: describedBy
        }, (0, $7xD0G.getInputOffsets)(inputWrapperOrder, {
            hasDescription: !!_description,
            hasError: !!_error
        }))
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $d3bdfd5ba6cb4811$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), content));
});
$d3bdfd5ba6cb4811$export$fb9f58ebe9de6283.displayName = "@mantine/core/InputWrapper";

});
parcelRegister("aHnmk", function(module, exports) {

$parcel$export(module.exports, "InputLabel", () => $7ca00a271e5468b6$export$76d3231fec538b73);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $l8XgF = parcelRequire("l8XgF");

var $hiiR1 = parcelRequire("hiiR1");
var $7ca00a271e5468b6$var$__defProp = Object.defineProperty;
var $7ca00a271e5468b6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7ca00a271e5468b6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7ca00a271e5468b6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7ca00a271e5468b6$var$__defNormalProp = (obj, key, value)=>key in obj ? $7ca00a271e5468b6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7ca00a271e5468b6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7ca00a271e5468b6$var$__hasOwnProp.call(b, prop)) $7ca00a271e5468b6$var$__defNormalProp(a, prop, b[prop]);
    if ($7ca00a271e5468b6$var$__getOwnPropSymbols) {
        for (var prop of $7ca00a271e5468b6$var$__getOwnPropSymbols(b))if ($7ca00a271e5468b6$var$__propIsEnum.call(b, prop)) $7ca00a271e5468b6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7ca00a271e5468b6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7ca00a271e5468b6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7ca00a271e5468b6$var$__getOwnPropSymbols) {
        for (var prop of $7ca00a271e5468b6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7ca00a271e5468b6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $7ca00a271e5468b6$var$defaultProps = {
    labelElement: "label",
    size: "sm"
};
const $7ca00a271e5468b6$export$76d3231fec538b73 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("InputLabel", $7ca00a271e5468b6$var$defaultProps, props), { labelElement: labelElement, children: children, required: required, size: size, classNames: classNames, styles: styles, unstyled: unstyled, className: className, htmlFor: htmlFor, __staticSelector: __staticSelector, variant: variant, onMouseDown: onMouseDown } = _a, others = $7ca00a271e5468b6$var$__objRest(_a, [
        "labelElement",
        "children",
        "required",
        "size",
        "classNames",
        "styles",
        "unstyled",
        "className",
        "htmlFor",
        "__staticSelector",
        "variant",
        "onMouseDown"
    ]);
    const { classes: classes, cx: cx } = (0, $l8XgF.default)(null, {
        name: [
            "InputWrapper",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $7ca00a271e5468b6$var$__spreadValues({
        component: labelElement,
        ref: ref,
        className: cx(classes.label, className),
        htmlFor: labelElement === "label" ? htmlFor : void 0,
        onMouseDown: (event)=>{
            onMouseDown == null || onMouseDown(event);
            if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        }
    }, others), children, required && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.required,
        "aria-hidden": true
    }, " *"));
});
$7ca00a271e5468b6$export$76d3231fec538b73.displayName = "@mantine/core/InputLabel";

});
parcelRegister("l8XgF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64851b37e00beff$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $f64851b37e00beff$var$useStyles = (0, $cQG1Y.createStyles)((theme, _params, { size: size })=>({
        label: {
            display: "inline-block",
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            fontWeight: 500,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
            wordBreak: "break-word",
            cursor: "default",
            WebkitTapHighlightColor: "transparent"
        },
        required: {
            color: theme.fn.variant({
                variant: "filled",
                color: "red"
            }).background
        }
    }));
var $f64851b37e00beff$export$2e2bcd8739ae039 = $f64851b37e00beff$var$useStyles;

});


parcelRegister("i2FU5", function(module, exports) {

$parcel$export(module.exports, "InputError", () => $0363c1ba2fcf8055$export$404cd3170eee2e81);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $3iLux = parcelRequire("3iLux");

var $cjohz = parcelRequire("cjohz");
var $0363c1ba2fcf8055$var$__defProp = Object.defineProperty;
var $0363c1ba2fcf8055$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0363c1ba2fcf8055$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0363c1ba2fcf8055$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0363c1ba2fcf8055$var$__defNormalProp = (obj, key, value)=>key in obj ? $0363c1ba2fcf8055$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0363c1ba2fcf8055$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0363c1ba2fcf8055$var$__hasOwnProp.call(b, prop)) $0363c1ba2fcf8055$var$__defNormalProp(a, prop, b[prop]);
    if ($0363c1ba2fcf8055$var$__getOwnPropSymbols) {
        for (var prop of $0363c1ba2fcf8055$var$__getOwnPropSymbols(b))if ($0363c1ba2fcf8055$var$__propIsEnum.call(b, prop)) $0363c1ba2fcf8055$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0363c1ba2fcf8055$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0363c1ba2fcf8055$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0363c1ba2fcf8055$var$__getOwnPropSymbols) {
        for (var prop of $0363c1ba2fcf8055$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0363c1ba2fcf8055$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $0363c1ba2fcf8055$var$defaultProps = {
    size: "sm"
};
const $0363c1ba2fcf8055$export$404cd3170eee2e81 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("InputError", $0363c1ba2fcf8055$var$defaultProps, props), { children: children, className: className, classNames: classNames, styles: styles, unstyled: unstyled, size: size, __staticSelector: __staticSelector, variant: variant } = _a, others = $0363c1ba2fcf8055$var$__objRest(_a, [
        "children",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "size",
        "__staticSelector",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $3iLux.default)(null, {
        name: [
            "InputWrapper",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), $0363c1ba2fcf8055$var$__spreadValues({
        className: cx(classes.error, className),
        ref: ref
    }, others), children);
});
$0363c1ba2fcf8055$export$404cd3170eee2e81.displayName = "@mantine/core/InputError";

});
parcelRegister("3iLux", function(module, exports) {

$parcel$export(module.exports, "default", () => $2677e45ab1a34439$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $2677e45ab1a34439$var$useStyles = (0, $cQG1Y.createStyles)((theme, _params, { size: size })=>({
        error: {
            wordBreak: "break-word",
            color: theme.fn.variant({
                variant: "filled",
                color: "red"
            }).background,
            fontSize: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            })} - ${(0, $2jkdX.rem)(2)})`,
            lineHeight: 1.2,
            display: "block"
        }
    }));
var $2677e45ab1a34439$export$2e2bcd8739ae039 = $2677e45ab1a34439$var$useStyles;

});

parcelRegister("cjohz", function(module, exports) {

$parcel$export(module.exports, "Text", () => $8f6a1859587ff53c$export$5f1af8db9871e1d6);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $hXU1e = parcelRequire("hXU1e");

var $hiiR1 = parcelRequire("hiiR1");
var $8f6a1859587ff53c$var$__defProp = Object.defineProperty;
var $8f6a1859587ff53c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8f6a1859587ff53c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8f6a1859587ff53c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8f6a1859587ff53c$var$__defNormalProp = (obj, key, value)=>key in obj ? $8f6a1859587ff53c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8f6a1859587ff53c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8f6a1859587ff53c$var$__hasOwnProp.call(b, prop)) $8f6a1859587ff53c$var$__defNormalProp(a, prop, b[prop]);
    if ($8f6a1859587ff53c$var$__getOwnPropSymbols) {
        for (var prop of $8f6a1859587ff53c$var$__getOwnPropSymbols(b))if ($8f6a1859587ff53c$var$__propIsEnum.call(b, prop)) $8f6a1859587ff53c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8f6a1859587ff53c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8f6a1859587ff53c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8f6a1859587ff53c$var$__getOwnPropSymbols) {
        for (var prop of $8f6a1859587ff53c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8f6a1859587ff53c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8f6a1859587ff53c$var$defaultProps = {
    variant: "text"
};
const $8f6a1859587ff53c$export$f5a10939c0132d55 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Text", $8f6a1859587ff53c$var$defaultProps, props), { className: className, size: size, weight: weight, transform: transform, color: color, align: align, variant: variant, lineClamp: lineClamp, truncate: truncate, gradient: gradient, inline: inline, inherit: inherit, underline: underline, strikethrough: strikethrough, italic: italic, classNames: classNames, styles: styles, unstyled: unstyled, span: span, __staticSelector: __staticSelector } = _a, others = $8f6a1859587ff53c$var$__objRest(_a, [
        "className",
        "size",
        "weight",
        "transform",
        "color",
        "align",
        "variant",
        "lineClamp",
        "truncate",
        "gradient",
        "inline",
        "inherit",
        "underline",
        "strikethrough",
        "italic",
        "classNames",
        "styles",
        "unstyled",
        "span",
        "__staticSelector"
    ]);
    const { classes: classes, cx: cx } = (0, $hXU1e.default)({
        color: color,
        lineClamp: lineClamp,
        truncate: truncate,
        inline: inline,
        inherit: inherit,
        underline: underline,
        strikethrough: strikethrough,
        italic: italic,
        weight: weight,
        transform: transform,
        align: align,
        gradient: gradient
    }, {
        unstyled: unstyled,
        name: __staticSelector || "Text",
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $8f6a1859587ff53c$var$__spreadValues({
        ref: ref,
        className: cx(classes.root, {
            [classes.gradient]: variant === "gradient"
        }, className),
        component: span ? "span" : "div"
    }, others));
});
$8f6a1859587ff53c$export$f5a10939c0132d55.displayName = "@mantine/core/Text";
const $8f6a1859587ff53c$export$5f1af8db9871e1d6 = (0, $1euea.createPolymorphicComponent)($8f6a1859587ff53c$export$f5a10939c0132d55);

});
parcelRegister("hXU1e", function(module, exports) {

$parcel$export(module.exports, "default", () => $d143668a8db183da$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $d143668a8db183da$var$__defProp = Object.defineProperty;
var $d143668a8db183da$var$__defProps = Object.defineProperties;
var $d143668a8db183da$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d143668a8db183da$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d143668a8db183da$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d143668a8db183da$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d143668a8db183da$var$__defNormalProp = (obj, key, value)=>key in obj ? $d143668a8db183da$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d143668a8db183da$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d143668a8db183da$var$__hasOwnProp.call(b, prop)) $d143668a8db183da$var$__defNormalProp(a, prop, b[prop]);
    if ($d143668a8db183da$var$__getOwnPropSymbols) {
        for (var prop of $d143668a8db183da$var$__getOwnPropSymbols(b))if ($d143668a8db183da$var$__propIsEnum.call(b, prop)) $d143668a8db183da$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d143668a8db183da$var$__spreadProps = (a, b)=>$d143668a8db183da$var$__defProps(a, $d143668a8db183da$var$__getOwnPropDescs(b));
function $d143668a8db183da$var$getTextDecoration({ underline: underline, strikethrough: strikethrough }) {
    const styles = [];
    if (underline) styles.push("underline");
    if (strikethrough) styles.push("line-through");
    return styles.length > 0 ? styles.join(" ") : "none";
}
function $d143668a8db183da$var$getTextColor({ theme: theme, color: color }) {
    if (color === "dimmed") return theme.fn.dimmed();
    return typeof color === "string" && (color in theme.colors || color.split(".")[0] in theme.colors) ? theme.fn.variant({
        variant: "filled",
        color: color
    }).background : color || "inherit";
}
function $d143668a8db183da$var$getLineClamp(lineClamp) {
    if (typeof lineClamp === "number") return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: lineClamp,
        WebkitBoxOrient: "vertical"
    };
    return null;
}
function $d143668a8db183da$var$getTruncate({ theme: theme, truncate: truncate }) {
    if (truncate === "start") return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        direction: theme.dir === "ltr" ? "rtl" : "ltr",
        textAlign: theme.dir === "ltr" ? "right" : "left"
    };
    if (truncate) return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    };
    return null;
}
var $d143668a8db183da$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, lineClamp: lineClamp, truncate: truncate, inline: inline, inherit: inherit, underline: underline, gradient: gradient, weight: weight, transform: transform, align: align, strikethrough: strikethrough, italic: italic }, { size: size })=>{
    const colors = theme.fn.variant({
        variant: "gradient",
        gradient: gradient
    });
    return {
        root: $d143668a8db183da$var$__spreadProps($d143668a8db183da$var$__spreadValues($d143668a8db183da$var$__spreadValues($d143668a8db183da$var$__spreadValues($d143668a8db183da$var$__spreadValues({}, theme.fn.fontStyles()), theme.fn.focusStyles()), $d143668a8db183da$var$getLineClamp(lineClamp)), $d143668a8db183da$var$getTruncate({
            theme: theme,
            truncate: truncate
        })), {
            color: $d143668a8db183da$var$getTextColor({
                color: color,
                theme: theme
            }),
            fontFamily: inherit ? "inherit" : theme.fontFamily,
            fontSize: inherit || size === void 0 ? "inherit" : (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            lineHeight: inherit ? "inherit" : inline ? 1 : theme.lineHeight,
            textDecoration: $d143668a8db183da$var$getTextDecoration({
                underline: underline,
                strikethrough: strikethrough
            }),
            WebkitTapHighlightColor: "transparent",
            fontWeight: inherit ? "inherit" : weight,
            textTransform: transform,
            textAlign: align,
            fontStyle: italic ? "italic" : void 0
        }),
        gradient: {
            backgroundImage: colors.background,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent"
        }
    };
});
var $d143668a8db183da$export$2e2bcd8739ae039 = $d143668a8db183da$var$useStyles;

});



parcelRegister("9UeRK", function(module, exports) {

$parcel$export(module.exports, "InputDescription", () => $7364e01a35f7a01a$export$416ae9045a33afd);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $dEq4Y = parcelRequire("dEq4Y");

var $cjohz = parcelRequire("cjohz");
var $7364e01a35f7a01a$var$__defProp = Object.defineProperty;
var $7364e01a35f7a01a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7364e01a35f7a01a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7364e01a35f7a01a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7364e01a35f7a01a$var$__defNormalProp = (obj, key, value)=>key in obj ? $7364e01a35f7a01a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7364e01a35f7a01a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7364e01a35f7a01a$var$__hasOwnProp.call(b, prop)) $7364e01a35f7a01a$var$__defNormalProp(a, prop, b[prop]);
    if ($7364e01a35f7a01a$var$__getOwnPropSymbols) {
        for (var prop of $7364e01a35f7a01a$var$__getOwnPropSymbols(b))if ($7364e01a35f7a01a$var$__propIsEnum.call(b, prop)) $7364e01a35f7a01a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7364e01a35f7a01a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7364e01a35f7a01a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7364e01a35f7a01a$var$__getOwnPropSymbols) {
        for (var prop of $7364e01a35f7a01a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7364e01a35f7a01a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $7364e01a35f7a01a$var$defaultProps = {
    size: "sm"
};
const $7364e01a35f7a01a$export$416ae9045a33afd = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("InputDescription", $7364e01a35f7a01a$var$defaultProps, props), { children: children, className: className, classNames: classNames, styles: styles, unstyled: unstyled, size: size, __staticSelector: __staticSelector, variant: variant } = _a, others = $7364e01a35f7a01a$var$__objRest(_a, [
        "children",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "size",
        "__staticSelector",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $dEq4Y.default)(null, {
        name: [
            "InputWrapper",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), $7364e01a35f7a01a$var$__spreadValues({
        color: "dimmed",
        className: cx(classes.description, className),
        ref: ref,
        unstyled: unstyled
    }, others), children);
});
$7364e01a35f7a01a$export$416ae9045a33afd.displayName = "@mantine/core/InputDescription";

});
parcelRegister("dEq4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f033d92b54ee91a$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $9f033d92b54ee91a$var$useStyles = (0, $cQG1Y.createStyles)((theme, _params, { size: size })=>({
        description: {
            wordBreak: "break-word",
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
            fontSize: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            })} - ${(0, $2jkdX.rem)(2)})`,
            lineHeight: 1.2,
            display: "block"
        }
    }));
var $9f033d92b54ee91a$export$2e2bcd8739ae039 = $9f033d92b54ee91a$var$useStyles;

});


parcelRegister("4vZOz", function(module, exports) {

$parcel$export(module.exports, "InputWrapperProvider", () => $349a01c5e636f4e8$export$bac4ebff2ddc1fe4);
$parcel$export(module.exports, "useInputWrapperContext", () => $349a01c5e636f4e8$export$40fbe3aaaeb9dc6c);

var $acw62 = parcelRequire("acw62");
const $349a01c5e636f4e8$var$InputWrapperContext = (0, $acw62.createContext)({
    offsetBottom: false,
    offsetTop: false,
    describedBy: void 0
});
const $349a01c5e636f4e8$export$bac4ebff2ddc1fe4 = $349a01c5e636f4e8$var$InputWrapperContext.Provider;
const $349a01c5e636f4e8$export$40fbe3aaaeb9dc6c = ()=>(0, $acw62.useContext)($349a01c5e636f4e8$var$InputWrapperContext);

});

parcelRegister("7xD0G", function(module, exports) {

$parcel$export(module.exports, "getInputOffsets", () => $57d9e010417a6b91$export$25327628fc2f4542);
function $57d9e010417a6b91$export$25327628fc2f4542(inputWrapperOrder, { hasDescription: hasDescription, hasError: hasError }) {
    const inputIndex = inputWrapperOrder.findIndex((part)=>part === "input");
    const aboveInput = inputWrapperOrder[inputIndex - 1];
    const belowInput = inputWrapperOrder[inputIndex + 1];
    const offsetTop = hasDescription && aboveInput === "description" || hasError && aboveInput === "error";
    const offsetBottom = hasDescription && belowInput === "description" || hasError && belowInput === "error";
    return {
        offsetBottom: offsetBottom,
        offsetTop: offsetTop
    };
}

});

parcelRegister("6LnXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ec9b9049ddc21fb$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $4ec9b9049ddc21fb$var$__defProp = Object.defineProperty;
var $4ec9b9049ddc21fb$var$__defProps = Object.defineProperties;
var $4ec9b9049ddc21fb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4ec9b9049ddc21fb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4ec9b9049ddc21fb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4ec9b9049ddc21fb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4ec9b9049ddc21fb$var$__defNormalProp = (obj, key, value)=>key in obj ? $4ec9b9049ddc21fb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4ec9b9049ddc21fb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4ec9b9049ddc21fb$var$__hasOwnProp.call(b, prop)) $4ec9b9049ddc21fb$var$__defNormalProp(a, prop, b[prop]);
    if ($4ec9b9049ddc21fb$var$__getOwnPropSymbols) {
        for (var prop of $4ec9b9049ddc21fb$var$__getOwnPropSymbols(b))if ($4ec9b9049ddc21fb$var$__propIsEnum.call(b, prop)) $4ec9b9049ddc21fb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4ec9b9049ddc21fb$var$__spreadProps = (a, b)=>$4ec9b9049ddc21fb$var$__defProps(a, $4ec9b9049ddc21fb$var$__getOwnPropDescs(b));
var $4ec9b9049ddc21fb$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        root: $4ec9b9049ddc21fb$var$__spreadProps($4ec9b9049ddc21fb$var$__spreadValues({}, theme.fn.fontStyles()), {
            lineHeight: theme.lineHeight
        })
    }));
var $4ec9b9049ddc21fb$export$2e2bcd8739ae039 = $4ec9b9049ddc21fb$var$useStyles;

});


parcelRegister("9K2fO", function(module, exports) {

$parcel$export(module.exports, "InputPlaceholder", () => $717a2886293cfa29$export$1dcf0d4dcfd98808);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $g71zw = parcelRequire("g71zw");

var $hiiR1 = parcelRequire("hiiR1");
var $717a2886293cfa29$var$__defProp = Object.defineProperty;
var $717a2886293cfa29$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $717a2886293cfa29$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $717a2886293cfa29$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $717a2886293cfa29$var$__defNormalProp = (obj, key, value)=>key in obj ? $717a2886293cfa29$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $717a2886293cfa29$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($717a2886293cfa29$var$__hasOwnProp.call(b, prop)) $717a2886293cfa29$var$__defNormalProp(a, prop, b[prop]);
    if ($717a2886293cfa29$var$__getOwnPropSymbols) {
        for (var prop of $717a2886293cfa29$var$__getOwnPropSymbols(b))if ($717a2886293cfa29$var$__propIsEnum.call(b, prop)) $717a2886293cfa29$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $717a2886293cfa29$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($717a2886293cfa29$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $717a2886293cfa29$var$__getOwnPropSymbols) {
        for (var prop of $717a2886293cfa29$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $717a2886293cfa29$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $717a2886293cfa29$var$defaultProps = {};
const $717a2886293cfa29$export$1dcf0d4dcfd98808 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("InputPlaceholder", $717a2886293cfa29$var$defaultProps, props), { sx: sx } = _a, others = $717a2886293cfa29$var$__objRest(_a, [
        "sx"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $717a2886293cfa29$var$__spreadValues({
        component: "span",
        sx: [
            (theme)=>theme.fn.placeholderStyles(),
            ...(0, $g71zw.packSx)(sx)
        ],
        ref: ref
    }, others));
});
$717a2886293cfa29$export$1dcf0d4dcfd98808.displayName = "@mantine/core/InputPlaceholder";

});

parcelRegister("bqYMI", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $8531460643ae7faa$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "default", () => $8531460643ae7faa$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $8531460643ae7faa$var$__defProp = Object.defineProperty;
var $8531460643ae7faa$var$__defProps = Object.defineProperties;
var $8531460643ae7faa$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8531460643ae7faa$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8531460643ae7faa$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8531460643ae7faa$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8531460643ae7faa$var$__defNormalProp = (obj, key, value)=>key in obj ? $8531460643ae7faa$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8531460643ae7faa$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8531460643ae7faa$var$__hasOwnProp.call(b, prop)) $8531460643ae7faa$var$__defNormalProp(a, prop, b[prop]);
    if ($8531460643ae7faa$var$__getOwnPropSymbols) {
        for (var prop of $8531460643ae7faa$var$__getOwnPropSymbols(b))if ($8531460643ae7faa$var$__propIsEnum.call(b, prop)) $8531460643ae7faa$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8531460643ae7faa$var$__spreadProps = (a, b)=>$8531460643ae7faa$var$__defProps(a, $8531460643ae7faa$var$__getOwnPropDescs(b));
const $8531460643ae7faa$export$c647cb0ee6e282fe = {
    xs: (0, $2jkdX.rem)(30),
    sm: (0, $2jkdX.rem)(36),
    md: (0, $2jkdX.rem)(42),
    lg: (0, $2jkdX.rem)(50),
    xl: (0, $2jkdX.rem)(60)
};
const $8531460643ae7faa$var$INPUT_VARIANTS = [
    "default",
    "filled",
    "unstyled"
];
function $8531460643ae7faa$var$getVariantStyles({ theme: theme, variant: variant }) {
    if (!$8531460643ae7faa$var$INPUT_VARIANTS.includes(variant)) return null;
    if (variant === "default") return {
        border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
        transition: "border-color 100ms ease",
        "&:focus, &:focus-within": theme.focusRingStyles.inputStyles(theme)
    };
    if (variant === "filled") return {
        border: `${(0, $2jkdX.rem)(1)} solid transparent`,
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
        "&:focus, &:focus-within": theme.focusRingStyles.inputStyles(theme)
    };
    return {
        borderWidth: 0,
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        backgroundColor: "transparent",
        minHeight: (0, $2jkdX.rem)(28),
        outline: 0,
        "&:focus, &:focus-within": {
            outline: "none",
            borderColor: "transparent"
        },
        "&:disabled": {
            backgroundColor: "transparent",
            "&:focus, &:focus-within": {
                outline: "none",
                borderColor: "transparent"
            }
        }
    };
}
var $8531460643ae7faa$var$useStyles = (0, $cQG1Y.createStyles)((theme, { multiline: multiline, radius: radius, invalid: invalid, rightSectionWidth: rightSectionWidth, withRightSection: withRightSection, iconWidth: iconWidth, offsetBottom: offsetBottom, offsetTop: offsetTop, pointer: pointer }, { variant: variant, size: size })=>{
    const invalidColor = theme.fn.variant({
        variant: "filled",
        color: "red"
    }).background;
    const sizeStyles = variant === "default" || variant === "filled" ? {
        minHeight: (0, $d8Ix8.getSize)({
            size: size,
            sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
        }),
        paddingLeft: `calc(${(0, $d8Ix8.getSize)({
            size: size,
            sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
        })}  / 3)`,
        paddingRight: withRightSection ? rightSectionWidth || (0, $d8Ix8.getSize)({
            size: size,
            sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
        }) : `calc(${(0, $d8Ix8.getSize)({
            size: size,
            sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
        })}  / 3)`,
        borderRadius: theme.fn.radius(radius)
    } : variant === "unstyled" && withRightSection ? {
        paddingRight: rightSectionWidth || (0, $d8Ix8.getSize)({
            size: size,
            sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
        })
    } : null;
    return {
        wrapper: {
            position: "relative",
            marginTop: offsetTop ? `calc(${theme.spacing.xs} / 2)` : void 0,
            marginBottom: offsetBottom ? `calc(${theme.spacing.xs} / 2)` : void 0,
            "&:has(input:disabled)": {
                "& .mantine-Input-rightSection": {
                    display: "none"
                }
            }
        },
        input: $8531460643ae7faa$var$__spreadProps($8531460643ae7faa$var$__spreadValues($8531460643ae7faa$var$__spreadValues($8531460643ae7faa$var$__spreadProps($8531460643ae7faa$var$__spreadValues({}, theme.fn.fontStyles()), {
            height: multiline ? variant === "unstyled" ? void 0 : "auto" : (0, $d8Ix8.getSize)({
                size: size,
                sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
            }),
            WebkitTapHighlightColor: "transparent",
            lineHeight: multiline ? theme.lineHeight : `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
            })} - ${(0, $2jkdX.rem)(2)})`,
            appearance: "none",
            resize: "none",
            boxSizing: "border-box",
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            width: "100%",
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            display: "block",
            textAlign: "left",
            cursor: pointer ? "pointer" : void 0
        }), $8531460643ae7faa$var$getVariantStyles({
            theme: theme,
            variant: variant
        })), sizeStyles), {
            "&:disabled, &[data-disabled]": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
                color: theme.colors.dark[2],
                opacity: 0.6,
                cursor: "not-allowed",
                pointerEvents: "none",
                "&::placeholder": {
                    color: theme.colors.dark[2]
                }
            },
            "&[data-invalid]": {
                color: invalidColor,
                borderColor: invalidColor,
                "&::placeholder": {
                    opacity: 1,
                    color: invalidColor
                }
            },
            "&[data-with-icon]": {
                paddingLeft: typeof iconWidth === "number" ? (0, $2jkdX.rem)(iconWidth) : (0, $d8Ix8.getSize)({
                    size: size,
                    sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
                })
            },
            "&::placeholder": $8531460643ae7faa$var$__spreadProps($8531460643ae7faa$var$__spreadValues({}, theme.fn.placeholderStyles()), {
                opacity: 1
            }),
            "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button, &::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
                appearance: "none"
            },
            "&[type=number]": {
                MozAppearance: "textfield"
            }
        }),
        icon: {
            pointerEvents: "none",
            position: "absolute",
            zIndex: 1,
            left: 0,
            top: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: iconWidth ? (0, $2jkdX.rem)(iconWidth) : (0, $d8Ix8.getSize)({
                size: size,
                sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
            }),
            color: invalid ? theme.colors.red[theme.colorScheme === "dark" ? 6 : 7] : theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[5]
        },
        rightSection: {
            position: "absolute",
            top: 0,
            bottom: 0,
            right: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: rightSectionWidth || (0, $d8Ix8.getSize)({
                size: size,
                sizes: $8531460643ae7faa$export$c647cb0ee6e282fe
            })
        }
    };
});
var $8531460643ae7faa$export$2e2bcd8739ae039 = $8531460643ae7faa$var$useStyles;

});



parcelRegister("6Lcfd", function(module, exports) {

$parcel$export(module.exports, "groupOptions", () => $4ec0a153bdc308f0$export$d175e48d35ace8ba);
$parcel$export(module.exports, "getGroupedOptions", () => $4ec0a153bdc308f0$export$721c3d9226425f9c);
function $4ec0a153bdc308f0$export$d175e48d35ace8ba({ data: data }) {
    const sortedData = [];
    const unGroupedData = [];
    const groupedData = data.reduce((acc, item, index)=>{
        if (item.group) {
            if (acc[item.group]) acc[item.group].push(index);
            else acc[item.group] = [
                index
            ];
        } else unGroupedData.push(index);
        return acc;
    }, {});
    Object.keys(groupedData).forEach((groupName)=>{
        sortedData.push(...groupedData[groupName].map((index)=>data[index]));
    });
    sortedData.push(...unGroupedData.map((itemIndex)=>data[itemIndex]));
    return sortedData;
}
function $4ec0a153bdc308f0$export$721c3d9226425f9c(data) {
    const sorted = $4ec0a153bdc308f0$export$d175e48d35ace8ba({
        data: data
    });
    const unGrouped = [];
    const grouped = [];
    let groupName = null;
    sorted.forEach((item, index)=>{
        if (!item.group) unGrouped.push({
            type: "item",
            item: item,
            index: index
        });
        else {
            if (groupName !== item.group) {
                groupName = item.group;
                grouped.push({
                    type: "label",
                    label: groupName
                });
            }
            grouped.push({
                type: "item",
                item: item,
                index: index
            });
        }
    });
    return {
        grouped: grouped,
        unGrouped: unGrouped,
        items: [
            ...grouped,
            ...unGrouped
        ],
        hasItems: grouped.length > 0 || unGrouped.length > 0
    };
}

});

parcelRegister("4W1M8", function(module, exports) {

$parcel$export(module.exports, "Center", () => $397df4bf7b1215be$export$1f54913ccc4368b1);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $bNzPE = parcelRequire("bNzPE");

var $hiiR1 = parcelRequire("hiiR1");
var $397df4bf7b1215be$var$__defProp = Object.defineProperty;
var $397df4bf7b1215be$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $397df4bf7b1215be$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $397df4bf7b1215be$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $397df4bf7b1215be$var$__defNormalProp = (obj, key, value)=>key in obj ? $397df4bf7b1215be$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $397df4bf7b1215be$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($397df4bf7b1215be$var$__hasOwnProp.call(b, prop)) $397df4bf7b1215be$var$__defNormalProp(a, prop, b[prop]);
    if ($397df4bf7b1215be$var$__getOwnPropSymbols) {
        for (var prop of $397df4bf7b1215be$var$__getOwnPropSymbols(b))if ($397df4bf7b1215be$var$__propIsEnum.call(b, prop)) $397df4bf7b1215be$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $397df4bf7b1215be$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($397df4bf7b1215be$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $397df4bf7b1215be$var$__getOwnPropSymbols) {
        for (var prop of $397df4bf7b1215be$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $397df4bf7b1215be$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $397df4bf7b1215be$export$d5228982fa78c62a = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Center", {}, props), { inline: inline, className: className, unstyled: unstyled, variant: variant } = _a, others = $397df4bf7b1215be$var$__objRest(_a, [
        "inline",
        "className",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $bNzPE.default)({
        inline: inline
    }, {
        name: "Center",
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $397df4bf7b1215be$var$__spreadValues({
        ref: ref,
        className: cx(classes.root, className)
    }, others));
});
$397df4bf7b1215be$export$d5228982fa78c62a.displayName = "@mantine/core/Center";
const $397df4bf7b1215be$export$1f54913ccc4368b1 = (0, $1euea.createPolymorphicComponent)($397df4bf7b1215be$export$d5228982fa78c62a);

});
parcelRegister("bNzPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $897010d61b79d5ed$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $897010d61b79d5ed$var$useStyles = (0, $cQG1Y.createStyles)((theme, { inline: inline })=>({
        root: {
            display: inline ? "inline-flex" : "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }));
var $897010d61b79d5ed$export$2e2bcd8739ae039 = $897010d61b79d5ed$var$useStyles;

});


parcelRegister("8TaxK", function(module, exports) {

$parcel$export(module.exports, "useMantineColorScheme", () => $678ba37d13584c4c$export$b856e50735b44240);
$parcel$export(module.exports, "ColorSchemeProvider", () => $678ba37d13584c4c$export$37d2f89e65318be4);

var $acw62 = parcelRequire("acw62");
const $678ba37d13584c4c$var$ColorSchemeContext = (0, $acw62.createContext)(null);
function $678ba37d13584c4c$export$b856e50735b44240() {
    const ctx = (0, $acw62.useContext)($678ba37d13584c4c$var$ColorSchemeContext);
    if (!ctx) throw new Error("useMantineColorScheme hook was called outside of context, make sure your app is wrapped with ColorSchemeProvider component");
    return ctx;
}
function $678ba37d13584c4c$export$37d2f89e65318be4({ colorScheme: colorScheme, toggleColorScheme: toggleColorScheme, children: children }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($678ba37d13584c4c$var$ColorSchemeContext.Provider, {
        value: {
            colorScheme: colorScheme,
            toggleColorScheme: toggleColorScheme
        }
    }, children);
}
$678ba37d13584c4c$export$37d2f89e65318be4.displayName = "@mantine/core/ColorSchemeProvider";

});

parcelRegister("49qEn", function(module, exports) {


var $ayMG0 = parcelRequire("ayMG0");

var $iLvQN = parcelRequire("iLvQN");
var $crMIh = parcelRequire("crMIh");
var $1St1x = parcelRequire("1St1x");
var $f2S2u = parcelRequire("f2S2u");
var $bFLPF = parcelRequire("bFLPF");
var $436KA = parcelRequire("436KA");
var $iPjI4 = parcelRequire("iPjI4");
var $hiiR1 = parcelRequire("hiiR1");
var $VIBCe = parcelRequire("VIBCe");
var $gU5rH = parcelRequire("gU5rH");
var $kPsAn = parcelRequire("kPsAn");
var $4W1M8 = parcelRequire("4W1M8");
var $4OeIO = parcelRequire("4OeIO");
var $2XzIE = parcelRequire("2XzIE");
var $j2E9L = parcelRequire("j2E9L");
var $fnRsm = parcelRequire("fnRsm");
var $D7Bq4 = parcelRequire("D7Bq4");
var $d8Ix8 = parcelRequire("d8Ix8");
var $6Koyj = parcelRequire("6Koyj");
var $9mTYo = parcelRequire("9mTYo");
var $hiGsa = parcelRequire("hiGsa");
var $dQS1T = parcelRequire("dQS1T");
var $4P91H = parcelRequire("4P91H");
var $aUqRb = parcelRequire("aUqRb");
var $aCM0s = parcelRequire("aCM0s");
var $8LzkP = parcelRequire("8LzkP");
var $d5Zz2 = parcelRequire("d5Zz2");
var $iM1WI = parcelRequire("iM1WI");
var $e2mZf = parcelRequire("e2mZf");
var $hasER = parcelRequire("hasER");
var $9Zs0z = parcelRequire("9Zs0z");
var $ly5N0 = parcelRequire("ly5N0");
var $clUNc = parcelRequire("clUNc");
var $6gwXS = parcelRequire("6gwXS");
var $jMtx3 = parcelRequire("jMtx3");
var $62A7W = parcelRequire("62A7W");
var $jc0Be = parcelRequire("jc0Be");
var $2jkdX = parcelRequire("2jkdX");
var $kC2FX = parcelRequire("kC2FX");
var $5Eq0L = parcelRequire("5Eq0L");
var $3wLgJ = parcelRequire("3wLgJ");
var $AaRVC = parcelRequire("AaRVC");
var $5iXv4 = parcelRequire("5iXv4");
var $9VIWE = parcelRequire("9VIWE");
var $1c0Cg = parcelRequire("1c0Cg");
var $foYg9 = parcelRequire("foYg9");
var $fbXO1 = parcelRequire("fbXO1");
var $hUms8 = parcelRequire("hUms8");
var $cjohz = parcelRequire("cjohz");
var $dSMvY = parcelRequire("dSMvY");
var $8mycu = parcelRequire("8mycu");
var $1Wgks = parcelRequire("1Wgks");
var $ew26C = parcelRequire("ew26C");
var $64A2P = parcelRequire("64A2P");
var $8TaxK = parcelRequire("8TaxK");

var $1Eb18 = parcelRequire("1Eb18");
var $76pRr = parcelRequire("76pRr");
var $aKTxt = parcelRequire("aKTxt");
var $loxEI = parcelRequire("loxEI");
var $8Qw8Z = parcelRequire("8Qw8Z");
var $ajdIG = parcelRequire("ajdIG");

var $acw62 = parcelRequire("acw62");

var $gngdn = parcelRequire("gngdn");

var $j4US1 = parcelRequire("j4US1");

var $fIMaa = parcelRequire("fIMaa");
var $34B0U = parcelRequire("34B0U");
var $dV30q = parcelRequire("dV30q");
var $bb5Hu = parcelRequire("bb5Hu");
var $hlpmP = parcelRequire("hlpmP");
var $g3BkA = parcelRequire("g3BkA");
var $dQNuR = parcelRequire("dQNuR");
var $7xsss = parcelRequire("7xsss");
var $iwBxo = parcelRequire("iwBxo");
var $gxhlI = parcelRequire("gxhlI");
var $gsgdS = parcelRequire("gsgdS");
var $3US3h = parcelRequire("3US3h");
var $4Rwq2 = parcelRequire("4Rwq2");
var $1MBwp = parcelRequire("1MBwp");
var $iHvby = parcelRequire("iHvby");
var $9WB3r = parcelRequire("9WB3r");
var $70jvy = parcelRequire("70jvy");
var $dRw7S = parcelRequire("dRw7S");
var $bPGo2 = parcelRequire("bPGo2");
var $aUMvF = parcelRequire("aUMvF");
var $jKnNH = parcelRequire("jKnNH");
var $ho6bO = parcelRequire("ho6bO");
var $3s7Bt = parcelRequire("3s7Bt");
var $8mEM1 = parcelRequire("8mEM1");
var $hi1Sd = parcelRequire("hi1Sd");
var $vjSkT = parcelRequire("vjSkT");
var $gzKDM = parcelRequire("gzKDM");
var $jni2H = parcelRequire("jni2H");
var $iVS9b = parcelRequire("iVS9b");
var $cYYbE = parcelRequire("cYYbE");
var $1bItm = parcelRequire("1bItm");
var $frYZ1 = parcelRequire("frYZ1");
var $cvMwO = parcelRequire("cvMwO");
var $1a7g8 = parcelRequire("1a7g8");
var $kytQ3 = parcelRequire("kytQ3");
var $hMS14 = parcelRequire("hMS14");
var $bLAHN = parcelRequire("bLAHN");
var $1YbUT = parcelRequire("1YbUT");
var $6HZkq = parcelRequire("6HZkq");
var $anH21 = parcelRequire("anH21");
var $gt7Cd = parcelRequire("gt7Cd");
var $8YQDN = parcelRequire("8YQDN");
var $eae64 = parcelRequire("eae64");
var $jBKnG = parcelRequire("jBKnG");
var $jGUpw = parcelRequire("jGUpw");
var $bfsRj = parcelRequire("bfsRj");
var $e2M7p = parcelRequire("e2M7p");
var $grSkg = parcelRequire("grSkg");
var $li55Z = parcelRequire("li55Z");
var $ab9C8 = parcelRequire("ab9C8");
var $g12Xg = parcelRequire("g12Xg");
var $1rkHh = parcelRequire("1rkHh");
var $3an6L = parcelRequire("3an6L");
var $eyDPb = parcelRequire("eyDPb");
var $9Q2Ky = parcelRequire("9Q2Ky");
var $22CZZ = parcelRequire("22CZZ");
var $54kyq = parcelRequire("54kyq");
var $lLqe7 = parcelRequire("lLqe7");
var $gv5JH = parcelRequire("gv5JH");

var $45cdq = parcelRequire("45cdq");
var $cqdgS = parcelRequire("cqdgS");
var $1YFpC = parcelRequire("1YFpC");
var $6X2G0 = parcelRequire("6X2G0");
var $kFu1s = parcelRequire("kFu1s");
var $eJ0gu = parcelRequire("eJ0gu");

var $eM8d1 = parcelRequire("eM8d1");

var $2cTph = parcelRequire("2cTph");
var $eW7ob = parcelRequire("eW7ob");
var $bXiXt = parcelRequire("bXiXt");

var $lHTSI = parcelRequire("lHTSI");

var $1u0KT = parcelRequire("1u0KT");

var $awfbW = parcelRequire("awfbW");

var $93PFP = parcelRequire("93PFP");

var $2ESFG = parcelRequire("2ESFG");


var $gbPMS = parcelRequire("gbPMS");

var $lF6Ws = parcelRequire("lF6Ws");

var $ehweP = parcelRequire("ehweP");
function $305cacda61daafb0$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $305cacda61daafb0$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $305cacda61daafb0$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $305cacda61daafb0$var$$parcel$global = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : {};
var $305cacda61daafb0$var$$parcel$modules = {};
var $305cacda61daafb0$var$$parcel$inits = {};
var $305cacda61daafb0$var$parcelRequire = $305cacda61daafb0$var$$parcel$global["parcelRequire1bbc"];
if ($305cacda61daafb0$var$parcelRequire == null) {
    $305cacda61daafb0$var$parcelRequire = function(id) {
        if (id in $305cacda61daafb0$var$$parcel$modules) return $305cacda61daafb0$var$$parcel$modules[id].exports;
        if (id in $305cacda61daafb0$var$$parcel$inits) {
            var init = $305cacda61daafb0$var$$parcel$inits[id];
            delete $305cacda61daafb0$var$$parcel$inits[id];
            var module1 = {
                id: id,
                exports: {}
            };
            $305cacda61daafb0$var$$parcel$modules[id] = module1;
            init.call(module1.exports, module1, module1.exports);
            return module1.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    $305cacda61daafb0$var$parcelRequire.register = function register(id, init) {
        $305cacda61daafb0$var$$parcel$inits[id] = init;
    };
    $305cacda61daafb0$var$$parcel$global["parcelRequire1bbc"] = $305cacda61daafb0$var$parcelRequire;
}
var $305cacda61daafb0$var$parcelRegister = $305cacda61daafb0$var$parcelRequire.register;
$305cacda61daafb0$var$parcelRegister("5cUzS", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AutoForm", function() {
        return $6bcc21fcfcabd5ad$export$2dc5b0d03dd97d36;
    });
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    var $bW9pc = $305cacda61daafb0$var$parcelRequire("bW9pc");
    var $adBvK = $305cacda61daafb0$var$parcelRequire("adBvK");
    function $6bcc21fcfcabd5ad$export$2dc5b0d03dd97d36(props) {
        const { entity: entity, getDataOnInit: getDataOnInit, initialFormMode: initialFormMode = 'view', onSaved: onSaved, onCancel: onCancel } = props;
        const entityForm = (0, $bW9pc.useEntityForm)({
            entity: entity,
            initialFormMode: initialFormMode,
            validateInputOnBlur: true,
            getDataOnInit: getDataOnInit,
            onSaved: onSaved,
            onCancel: onCancel
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bHLhd.EntityForm, {
            formAPI: entityForm,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9VIWE.Stack, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($adBvK.AutoFormFields, {
                    entity: entity,
                    entityForm: entityForm
                })
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("dC9fs", function(module1, exports) {
    var $bW9pc = $305cacda61daafb0$var$parcelRequire("bW9pc");
    var $vXZlt = $305cacda61daafb0$var$parcelRequire("vXZlt");
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    var $8xtCs = $305cacda61daafb0$var$parcelRequire("8xtCs");
    var $8kWvc = $305cacda61daafb0$var$parcelRequire("8kWvc");
    var $efs8D = $305cacda61daafb0$var$parcelRequire("efs8D");
    var $dZuNe = $305cacda61daafb0$var$parcelRequire("dZuNe");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bW9pc);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $vXZlt);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bHLhd);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hAMyt);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8xtCs);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8kWvc);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $efs8D);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dZuNe);
});
$305cacda61daafb0$var$parcelRegister("bW9pc", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseEntityFormDefaultProps", function() {
        return $ed5512685e858344$export$659b17aab7c47d60;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useEntityForm", function() {
        return $ed5512685e858344$export$f1f43a62560a15ec;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    var $lTNXP = $305cacda61daafb0$var$parcelRequire("lTNXP");
    var $vXZlt = $305cacda61daafb0$var$parcelRequire("vXZlt");
    const $ed5512685e858344$export$659b17aab7c47d60 = {
        validateInputOnBlur: true,
        initialShowDescriptionInFields: true,
        cancelGetOnUnmount: true,
        cancelSaveOnUnmount: true
    };
    function $ed5512685e858344$export$f1f43a62560a15ec(props) {
        const { entity: entity, initialFormMode: initialFormMode, validateInputOnBlur: validateInputOnBlur, validateInputOnChange: validateInputOnChange, onSaved: onSaved, onCancel: onCancel, getDataOnInit: getDataOnInit, forceDirty: forceDirty, initialShowDescriptionInFields: initialShowDescriptionInFields, saveAndGetOverride: saveAndGetOverride, noSaveOnSubmit: noSaveOnSubmit, bindedColumnNames: bindedColumnNames, saveAndGetOnSubmit: saveAndGetOnSubmit, cancelGetOnUnmount: cancelGetOnUnmount, cancelSaveOnUnmount: cancelSaveOnUnmount, saveBeforeLocalNavigation: saveBeforeLocalNavigation, saveBeforeRemoteNavigation: saveBeforeRemoteNavigation } = (0, $64A2P.useComponentDefaultProps)('', $ed5512685e858344$export$659b17aab7c47d60, props);
        const [status, setStatus] = (0, $acw62.useState)({}); // Initial queryStatus is empty on purpose to not disable fields before data is loaded
        const notifyValidationErrorState = (0, $acw62.useState)(false);
        const [, setNotifyValidationError] = notifyValidationErrorState;
        const showDescriptionState = (0, $acw62.useState)(initialShowDescriptionInFields);
        const [formMode, setFormMode] = (0, $acw62.useState)(initialFormMode);
        const getAbortController = (0, $acw62.useRef)(new AbortController);
        const saveAbortController = (0, $acw62.useRef)(new AbortController);
        const validationObject = (0, $acw62.useRef)({});
        const initialValues = (0, $acw62.useRef)((0, $vXZlt.getMantineInitialValuesObject)(entity.def.columns, bindedColumnNames));
        const initialDirty = (0, $acw62.useRef)({});
        const form = (0, $ajdIG.useForm)({
            initialValues: initialValues.current,
            initialDirty: initialDirty.current,
            validateInputOnBlur: validateInputOnBlur,
            validateInputOnChange: validateInputOnChange,
            validate: validationObject.current
        });
        // Async validation error state handling
        const asyncErrors = (0, $acw62.useRef)({});
        const setAsyncError = (0, $acw62.useCallback)((column_name, error)=>{
            asyncErrors.current[column_name] = error;
            form.setFieldError(column_name, error);
        }, [
            form
        ]);
        const clearAsyncError = (0, $acw62.useCallback)((column_name)=>{
            delete asyncErrors.current[column_name];
            form.clearFieldError(column_name);
        }, [
            form
        ]);
        const clearAllAsyncErrors = (0, $acw62.useCallback)(()=>{
            asyncErrors.current = {};
            form.clearErrors();
        }, [
            form
        ]);
        // Custom form validation (async and sync)
        const isFormValid = (0, $acw62.useCallback)(()=>{
            if (Object.keys(asyncErrors.current).length > 0) return false;
            return form.isValid();
        }, [
            form
        ]);
        const isFormFieldValid = (0, $acw62.useCallback)((column_name)=>{
            return !asyncErrors.current[column_name] && form.isValid(column_name);
        }, [
            form
        ]);
        const lastGetValues = (0, $acw62.useRef)();
        // Form Handlers
        const performGetData = (0, $acw62.useCallback)(async ()=>{
            setStatus({
                loading: true,
                operationType: "get"
            });
            try {
                // MMC: this also sets the underlying entity values...
                const ret = await entity.API.getData(getAbortController.current.signal);
                if (ret) {
                    const new_values = (0, $vXZlt.getMantineValuesObject)(form.values, entity.def.columns, true);
                    form.setValues(new_values);
                    lastGetValues.current = new_values;
                    const new_status = {
                        loading: false,
                        operationType: "get"
                    };
                    setStatus(new_status);
                    form.resetDirty();
                    form.resetTouched();
                }
                return ret;
            } catch (e) {
                if (e.name !== 'AbortError') {
                    const new_status = {
                        loading: false,
                        error: (0, $98ddT.toMicroMError)(e)
                    };
                    setStatus(new_status);
                }
            }
            return false;
        }, [
            entity.API,
            entity.def.columns,
            form
        ]);
        const saveAndGet = (0, $acw62.useCallback)(async (get_data_if_saved = true, override_values)=>{
            (0, $iKzSR.setValues)(entity.def.columns, form.values, null, true);
            if (override_values) (0, $iKzSR.setValues)(entity.def.columns, override_values, null, true);
            if (noSaveOnSubmit) return {
                loading: false,
                data: {
                    Results: [
                        {
                            Status: 0,
                            Message: 'OK'
                        }
                    ]
                }
            };
            setStatus({
                loading: true,
                operationType: "add"
            });
            // MMC: this also sets the underlying entity values if autonum...
            try {
                const data = formMode === 'add' ? await entity.API.addData(saveAbortController.current.signal) : await entity.API.editData(saveAbortController.current.signal);
                const new_status = {
                    loading: false,
                    data: data,
                    operationType: formMode
                };
                setStatus(new_status);
                if (data.Failed !== true) {
                    if (get_data_if_saved) await performGetData();
                    if (formMode === "add") setFormMode('edit');
                }
                return new_status;
            } catch (e) {
                if (e.name !== 'AbortError') {
                    const new_status = {
                        error: e.Errors ? (0, $98ddT.toDBStatusMicroMError)(e.Errors, formMode) : (0, $98ddT.toMicroMError)(e),
                        operationType: formMode
                    };
                    setStatus(new_status);
                    return new_status;
                } else return {
                    loading: false
                };
            }
        }, [
            entity.API,
            entity.def.columns,
            form.values,
            formMode,
            performGetData
        ]);
        const handleCancel = (0, $acw62.useCallback)(async ()=>{
            getAbortController.current.abort();
            saveAbortController.current.abort();
            if (onCancel) await Promise.resolve(onCancel());
        }, [
            onCancel
        ]);
        const handleSubmit = (0, $acw62.useCallback)(async (event1)=>{
            if (event1) event1.preventDefault();
            // Check if there are async errors
            if (Object.keys(asyncErrors.current).length > 0) {
                setNotifyValidationError(true);
                return;
            }
            // Ensure all fields are validated, this will reset async field errors
            const result = form.validate();
            if (result.hasErrors) setNotifyValidationError(true);
            else {
                let save_result;
                if (saveAndGetOverride) try {
                    if (noSaveOnSubmit) save_result = {
                        loading: false,
                        data: {
                            Results: [
                                {
                                    Status: 0,
                                    Message: 'OK'
                                }
                            ]
                        }
                    };
                    else {
                        setStatus({
                            loading: true,
                            operationType: "add"
                        });
                        const get_data_if_saved = saveAndGetOnSubmit || false;
                        save_result = await saveAndGetOverride(get_data_if_saved);
                        setStatus(save_result);
                        if (save_result.data?.Failed !== true) {
                            if (get_data_if_saved) await performGetData();
                            if (formMode === "add") setFormMode('edit');
                        }
                    }
                } catch (e) {
                    if (e.name !== 'AbortError') {
                        const new_status = {
                            error: e.Errors ? (0, $98ddT.toDBStatusMicroMError)(e.Errors, formMode) : (0, $98ddT.toMicroMError)(e),
                            operationType: formMode
                        };
                        setStatus(new_status);
                        save_result = new_status;
                    } else save_result = {
                        loading: false
                    };
                }
                else save_result = await saveAndGet(saveAndGetOnSubmit || false);
                if (save_result.error === undefined && save_result.data?.Failed !== true && onSaved) {
                    // MMC: fix for mantine DateInput bug "invalid date"
                    // check all form values for date columns and set them to null if invalid
                    // The bug happens when closing the form with invalid date values, after save
                    for(const c in entity.def.columns){
                        if ((0, $lTNXP.isIn)(entity.def.columns[c].type, 'date', 'datetime', 'datetime2', 'smalldatetime')) {
                            if (form.values[c]?.toString() === 'Invalid Date' || form.values[c]?.toString() === '') {
                                form.values[c] = null;
                                entity.def.columns[c].value = null;
                            }
                        }
                    }
                    onSaved(save_result);
                }
            }
        }, [
            form,
            onSaved,
            saveAndGet,
            saveAndGetOverride,
            setNotifyValidationError,
            saveAndGetOnSubmit
        ]);
        // Validation, InitialValues, InitialDirty
        const addValidation = (0, $acw62.useCallback)((column, validation)=>{
            if (validation) validationObject.current[column.name] = validation;
            else delete validationObject.current[column.name];
            if (initialFormMode === "add" || forceDirty) initialDirty.current[column.name] = column.value !== '' || column.value !== null || column.value !== undefined ? true : false;
            initialValues.current[column.name] = column.value ?? '';
        }, [
            forceDirty,
            initialFormMode
        ]);
        const removeValidation = (0, $acw62.useCallback)((column)=>{
            delete validationObject.current[column.name];
        }, []);
        const silentSave = (0, $acw62.useCallback)(async ()=>{
            try {
                form.validate();
                if (!(0, $iKzSR.areValuesObjectsEqual)(form.values, lastGetValues.current)) await saveAndGet();
            } catch (ex) {
                console.error('SilentSave', ex);
            }
        }, [
            form,
            saveAndGet
        ]);
        // getDataOnInit
        (0, $acw62.useEffect)(()=>{
            const cancellation = getAbortController.current;
            if (getDataOnInit) {
                async function getData() {
                    await performGetData();
                }
                getData();
            }
            return ()=>{
                if (getDataOnInit && cancelGetOnUnmount) {
                    console.log("useEntityForm performGetData aborted");
                    cancellation.abort("Effect cleanup");
                }
            };
        }, []);
        (0, $acw62.useEffect)(()=>{
            const cancellation = saveAbortController.current;
            return ()=>{
                if (cancelSaveOnUnmount) {
                    console.log("useEntityForm Save aborted");
                    cancellation.abort("Effect cleanup");
                }
            };
        }, []);
        // when the form mode is add, set the initial values
        (0, $acw62.useEffect)(()=>{
            if (initialFormMode === "add") form.setValues(initialValues.current);
        }, [
            initialFormMode
        ]);
        // save before navigation
        (0, $acw62.useEffect)(()=>{
            const handleBeforeUnload = async ()=>{
                if (saveBeforeRemoteNavigation) await silentSave();
            };
            window.addEventListener("beforeunload", handleBeforeUnload);
            return ()=>{
                window.removeEventListener("beforeunload", handleBeforeUnload);
            };
        }, [
            saveBeforeRemoteNavigation,
            silentSave
        ]);
        const prevLocationRef = (0, $acw62.useRef)(window.location.hash);
        // savew before local navigation
        (0, $acw62.useEffect)(()=>{
            const handleLocalNavigation = async ()=>{
                if (saveBeforeLocalNavigation && form.isDirty() && prevLocationRef.current !== window.location.hash) await silentSave();
            };
            window.addEventListener("hashchange", handleLocalNavigation);
            return ()=>{
                window.removeEventListener("hashchange", handleLocalNavigation);
            };
        }, [
            form,
            saveBeforeLocalNavigation,
            silentSave
        ]);
        const result = (0, $acw62.useMemo)(()=>({
                form: form,
                formMode: formMode,
                status: status,
                saveAndGet: saveAndGetOverride ?? saveAndGet,
                performGetData: performGetData,
                handleCancel: handleCancel,
                configureField: addValidation,
                removeValidation: removeValidation,
                handleSubmit: handleSubmit,
                notifyValidationErrorState: notifyValidationErrorState,
                showDescriptionState: showDescriptionState,
                entity: entity,
                asyncErrors: asyncErrors.current,
                setAsyncError: setAsyncError,
                clearAsyncError: clearAsyncError,
                clearAllAsyncErrors: clearAllAsyncErrors,
                isFormValid: isFormValid,
                isFormFieldValid: isFormFieldValid,
                silentSave: silentSave
            }), [
            addValidation,
            clearAllAsyncErrors,
            clearAsyncError,
            entity,
            form,
            formMode,
            handleCancel,
            handleSubmit,
            isFormFieldValid,
            isFormValid,
            notifyValidationErrorState,
            performGetData,
            removeValidation,
            saveAndGet,
            saveAndGetOverride,
            setAsyncError,
            showDescriptionState,
            status,
            silentSave
        ]);
        return result;
    }
});
$305cacda61daafb0$var$parcelRegister("6Rdyz", function(module1, exports) {
    var $8yTUG = $305cacda61daafb0$var$parcelRequire("8yTUG");
    var $dU7Zq = $305cacda61daafb0$var$parcelRequire("dU7Zq");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    var $78KzE = $305cacda61daafb0$var$parcelRequire("78KzE");
    var $lq5EG = $305cacda61daafb0$var$parcelRequire("lq5EG");
    var $2VTPU = $305cacda61daafb0$var$parcelRequire("2VTPU");
    var $fiYMH = $305cacda61daafb0$var$parcelRequire("fiYMH");
    var $eyjUN = $305cacda61daafb0$var$parcelRequire("eyjUN");
    var $hDJ3w = $305cacda61daafb0$var$parcelRequire("hDJ3w");
    var $cfO6r = $305cacda61daafb0$var$parcelRequire("cfO6r");
    var $cjHVl = $305cacda61daafb0$var$parcelRequire("cjHVl");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8yTUG);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dU7Zq);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $98ddT);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $78KzE);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lq5EG);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2VTPU);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fiYMH);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $eyjUN);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hDJ3w);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cfO6r);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cjHVl);
});
$305cacda61daafb0$var$parcelRegister("8yTUG", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DBStatusCodes", function() {
        return $d37167691f82e4c7$export$5130868f0957185d;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isDBStatusResult", function() {
        return $d37167691f82e4c7$export$8f19ddf24bebdeea;
    });
    var $d37167691f82e4c7$export$5130868f0957185d = /*#__PURE__*/ function(DBStatusCodes) {
        DBStatusCodes[DBStatusCodes["OK"] = 0] = "OK";
        DBStatusCodes[DBStatusCodes["AUTONUM"] = 15] = "AUTONUM";
        DBStatusCodes[DBStatusCodes["RECORD_CHANGED"] = 4] = "RECORD_CHANGED";
        DBStatusCodes[DBStatusCodes["ERROR"] = 11] = "ERROR";
        return DBStatusCodes;
    }({});
    function $d37167691f82e4c7$export$8f19ddf24bebdeea(data) {
        return data && typeof data.Failed === "boolean" && typeof data.AutonumReturned === "boolean";
    }
});
$305cacda61daafb0$var$parcelRegister("dU7Zq", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicroMClient", function() {
        return $16abd72d1aa9b62d$export$6118e57c65bf19ee;
    });
    var $lTNXP = $305cacda61daafb0$var$parcelRequire("lTNXP");
    var $cfO6r = $305cacda61daafb0$var$parcelRequire("cfO6r");
    var $hDJ3w = $305cacda61daafb0$var$parcelRequire("hDJ3w");
    var $brSbF = $305cacda61daafb0$var$parcelRequire("brSbF");
    var $78KzE = $305cacda61daafb0$var$parcelRequire("78KzE");
    var $dF8o7 = $305cacda61daafb0$var$parcelRequire("dF8o7");
    var $2VTPU = $305cacda61daafb0$var$parcelRequire("2VTPU");
    const $16abd72d1aa9b62d$var$ENABLED_MENUS_DATA_KEY = 'mm_menus';
    const $16abd72d1aa9b62d$var$REMEMBER_USER_DATA_KEY = 'mm_remember_me';
    const $16abd72d1aa9b62d$var$TIMEZONE_OFFSET_DATA_KEY = 'mm_server_timezone_offset';
    const $16abd72d1aa9b62d$var$LOCAL_DEVICE_ID_KEY = 'mm_ldid';
    class $16abd72d1aa9b62d$export$6118e57c65bf19ee {
        #API_URL;
        #TOKEN_STORAGE;
        #APP_ID;
        #LOGIN_TIMEOUT;
        #REQUEST_MODE;
        #TOKEN;
        #LOCAL_DEVICE_ID;
        #tokenRefreshInProgress;
        #publicEndpoints;
        #DATA_STORAGE;
        #ENABLED_MENUS;
        #RECORD_PATHS;
        #RECORDED_PATHS;
        #REDIRECT_ON_401;
        #TIMEZONE_OFFSET;
        constructor({ api_url: api_url, app_id: app_id, login_timeout: login_timeout, mode: mode, tokenStorage: tokenStorage, publicEndpoints: publicEndpoints, dataStorage: dataStorage, redirect_on_401: redirect_on_401 }){
            this.#TOKEN = null;
            this.#LOCAL_DEVICE_ID = null;
            this.#tokenRefreshInProgress = null;
            this.#publicEndpoints = {};
            this.#ENABLED_MENUS = new Set();
            this.#RECORD_PATHS = false;
            this.#RECORDED_PATHS = {};
            this.#TIMEZONE_OFFSET = 0;
            this.#API_URL = api_url ?? "";
            this.#APP_ID = app_id ?? "";
            this.#TOKEN_STORAGE = tokenStorage ?? new $2VTPU.TokenWebStorage("localStorage");
            this.#LOGIN_TIMEOUT = login_timeout ?? 30000;
            this.#REQUEST_MODE = mode ?? 'cors';
            this.#publicEndpoints = publicEndpoints ?? {};
            this.#DATA_STORAGE = dataStorage ?? new $cfO6r.DataStorage("localStorage");
            this.#REDIRECT_ON_401 = redirect_on_401;
        }
        getAPPID() {
            return this.#APP_ID;
        }
        //*** Record access
        startRecordPaths() {
            this.#RECORD_PATHS = true;
        }
        stopRecordPaths() {
            this.#RECORD_PATHS = false;
        }
        #recordAccess({ entityName: entityName, access: access, views: views, procs: procs, actions: actions, lookups: lookups }) {
            if (this.#RECORD_PATHS) {
                const rec = this.#RECORDED_PATHS[entityName];
                if (rec) {
                    rec.access = rec.access | access;
                    if (views) rec.views = [
                        ...new Set([
                            ...rec.views || [],
                            ...views
                        ])
                    ];
                    if (procs) rec.procs = [
                        ...new Set([
                            ...rec.procs || [],
                            ...procs
                        ])
                    ];
                    if (actions) rec.actions = [
                        ...new Set([
                            ...rec.actions || [],
                            ...actions
                        ])
                    ];
                    if (lookups) rec.lookups = [
                        ...new Set([
                            ...rec.lookups || [],
                            ...lookups
                        ])
                    ];
                } else this.#RECORDED_PATHS[entityName] = {
                    entityName: entityName,
                    access: access,
                    views: views,
                    procs: procs,
                    actions: actions
                };
            }
        }
        async #saveRecordedAccessData(data) {
            await this.#DATA_STORAGE.saveData(this.#APP_ID, $brSbF.RECORDED_ACCESS_DATA_STORAGE_KEY, data);
        }
        async #saveAllRecordedAccess() {
            if (this.#RECORD_PATHS) {
                const result = (0, $brSbF.generateCSharpGetRoutePaths)(this.#RECORDED_PATHS);
                await this.#saveRecordedAccessData(result);
                console.log(result);
            }
        }
        //*** OIDC flows
        async oidcLoginAndRedirect(options) {
            const authorizeUrl = await this.#startOidcLogin(options);
            window.location.href = authorizeUrl;
        }
        async #startOidcLogin(options) {
            const { targetLinkUri: targetLinkUri, extraParams: extraParams } = options;
            const loginTimeout = new $dF8o7.TimeoutSignal(this.#LOGIN_TIMEOUT, 'OIDC PAR request timed out');
            try {
                const localDeviceId = await this.#getLocalDeviceId();
                // Prepare OIDC client PAR request parameters
                // required OIDC parameters are server-managed
                const params = new URLSearchParams();
                if (targetLinkUri) params.set('target_link_uri', targetLinkUri);
                params.set('local_device_id', localDeviceId);
                params.set('client_id', this.#APP_ID);
                if (extraParams) {
                    for (const [k, v] of Object.entries(extraParams))if (v != null) {
                        // Avoid overriding security-related parameters that are server-managed.
                        if ((0, $lTNXP.isIn)(k, 'response_type', 'scope', 'state', 'nonce', 'code_challenge', 'code_challenge_method', 'client_id', 'request_uri', 'redirect_uri')) {
                            console.warn(`Ignoring OIDC extraParam '${k}' because it is server-managed.`);
                            continue;
                        }
                        params.set(k, v);
                    }
                }
                const parUrl = `${this.#API_URL}/${this.#APP_ID}/oidc-client/par`;
                const response = await fetch(parUrl, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    mode: this.#REQUEST_MODE,
                    cache: 'no-store',
                    credentials: 'include',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    signal: loginTimeout.signal,
                    body: params.toString()
                });
                if (!response.ok) {
                    const text = await response.text().catch(()=>'');
                    throw {
                        status: response.status,
                        statusMessage: response.statusText,
                        message: text || response.statusText,
                        url: response.url
                    };
                }
                const data = await response.json();
                if (!data.authorize_url) throw {
                    status: 500,
                    statusMessage: 'invalid_par_response',
                    message: data.error_description || data.error || 'PAR response missing authorize_url',
                    url: parUrl
                };
                return data.authorize_url;
            } finally{
                loginTimeout.clear();
            }
        }
        //*** Local login/logout
        get LOGGED_IN_USER() {
            return this.#TOKEN?.claims;
        }
        async getRememberUser() {
            return await this.#DATA_STORAGE.readData(this.#APP_ID, $16abd72d1aa9b62d$var$REMEMBER_USER_DATA_KEY);
        }
        async isLoggedIn() {
            const loginTimeout = new $dF8o7.TimeoutSignal(this.#LOGIN_TIMEOUT, 'Login request timed out');
            try {
                await this.#checkAndRefreshToken();
                if (this.#TOKEN !== null && this.#TOKEN.access_token !== '') {
                    const response = await fetch(`${this.#API_URL}/${this.#APP_ID}/auth/isloggedin`, {
                        method: 'GET',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "Authorization": `Bearer ${this.#TOKEN.access_token}`
                        },
                        mode: this.#REQUEST_MODE,
                        cache: 'no-store',
                        credentials: 'include',
                        referrerPolicy: 'strict-origin-when-cross-origin',
                        signal: loginTimeout.signal
                    });
                    return response.ok;
                }
            } catch  {
            //console.log(error);
            } finally{
                loginTimeout.clear();
            }
            return false;
        }
        async isLoggedInLocal() {
            try {
                await this.#checkAndRefreshToken();
            } catch  {
            //console.log(error)
            }
            return !!this.#TOKEN?.access_token && new Date() < new Date(this.#TOKEN.expiration);
        }
        async login(username, password, rememberme) {
            //Intentionally not accounting for tokenRefreshInProgress (see refresh logic)
            const loginTimeout = new $dF8o7.TimeoutSignal(this.#LOGIN_TIMEOUT, 'Login request timed out');
            try {
                if (this.#RECORD_PATHS) this.#RECORDED_PATHS = {};
                const localDeviceId = await this.#getLocalDeviceId();
                const response = await fetch(`${this.#API_URL}/${this.#APP_ID}/auth/login`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8"
                    },
                    mode: this.#REQUEST_MODE,
                    cache: 'no-store',
                    credentials: 'include',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    signal: loginTimeout.signal,
                    body: JSON.stringify({
                        username: username,
                        password: password,
                        LocalDeviceId: localDeviceId
                    })
                });
                if (!response.ok) throw {
                    status: response?.status,
                    statusMessage: response?.statusText,
                    message: response?.statusText,
                    url: response?.url
                };
                const data = await response.json();
                if (data && data.access_token) {
                    const token = new $78KzE.MicroMToken(data.access_token, data.expires_in, data['refresh-token'], data.token_type, data);
                    await this.#setToken(token);
                    try {
                        await this.#DATA_STORAGE.saveData(this.#APP_ID, $16abd72d1aa9b62d$var$REMEMBER_USER_DATA_KEY, rememberme ? username : null);
                    } catch (error) {
                        console.warn('Error remembering user', error);
                    }
                    try {
                        await this.#getAPIEnabledMenus(username, loginTimeout.signal);
                    } catch (error) {
                        console.warn('Error getting enabled menus', error);
                    }
                    try {
                        await this.#getTimeZoneOffset(loginTimeout.signal);
                    } catch (error) {
                        console.warn('Error getting server timezone offset', error);
                    }
                    return token;
                } else throw {
                    statusMessage: 'Unexpected result',
                    url: response.url
                };
            } catch (error) {
                console.warn('Login error', error);
                try {
                    await this.logoff();
                } catch  {}
                throw error;
            } finally{
                loginTimeout.clear();
            }
        }
        async localLogoff() {
            await this.#removeToken();
            await this.#deleteEnabledMenus();
        }
        async logoff() {
            const loginTimeout = new $dF8o7.TimeoutSignal(this.#LOGIN_TIMEOUT, 'Login request timed out');
            try {
                await this.#removeToken();
                await this.#deleteEnabledMenus();
                if (this.#RECORD_PATHS) await this.#saveAllRecordedAccess();
                const response = await fetch(`${this.#API_URL}/${this.#APP_ID}/auth/logoff`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": `Bearer ${this.#TOKEN?.access_token || ''}`
                    },
                    mode: this.#REQUEST_MODE,
                    cache: 'no-store',
                    credentials: 'include',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    signal: loginTimeout.signal,
                    body: JSON.stringify({})
                });
                if (!response.ok) throw {
                    status: response.status,
                    statusMessage: response.statusText,
                    message: response.statusText,
                    url: response.url
                };
            } finally{
                loginTimeout.clear();
            }
        }
        async updateClientClaims(claims) {
            if (this.#TOKEN) {
                this.#TOKEN.claims = claims;
                await this.#setToken(this.#TOKEN);
            }
        }
        async recoveryemail(username) {
            const loginTimeout = new $dF8o7.TimeoutSignal(this.#LOGIN_TIMEOUT * 4, 'Login request timed out');
            try {
                const response = await fetch(`${this.#API_URL}/${this.#APP_ID}/auth/recoveryemail`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8"
                    },
                    mode: this.#REQUEST_MODE,
                    cache: 'no-store',
                    credentials: 'include',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    signal: loginTimeout.signal,
                    body: JSON.stringify({
                        username: username
                    })
                });
                if (!response.ok) throw {
                    status: response?.status,
                    statusMessage: response?.statusText,
                    message: response?.statusText,
                    url: response?.url
                };
                return await response.json();
            } catch (error) {
                throw error;
            } finally{
                loginTimeout.clear();
            }
        }
        async recoverpassword(username, password, recoverycode) {
            const loginTimeout = new $dF8o7.TimeoutSignal(this.#LOGIN_TIMEOUT * 4, 'Login request timed out');
            try {
                const response = await fetch(`${this.#API_URL}/${this.#APP_ID}/auth/recoverpassword`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8"
                    },
                    mode: this.#REQUEST_MODE,
                    cache: 'no-store',
                    credentials: 'include',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    signal: loginTimeout.signal,
                    body: JSON.stringify({
                        username: username,
                        password: password,
                        recoverycode: recoverycode
                    })
                });
                if (!response.ok) throw {
                    status: response?.status,
                    statusMessage: response?.statusText,
                    message: response?.statusText,
                    url: response?.url
                };
                return await response.json();
            } catch (error) {
                throw error;
            } finally{
                loginTimeout.clear();
            }
        }
        async #getLocalDeviceId() {
            const local_device = await this.#DATA_STORAGE.readData(this.#APP_ID, $16abd72d1aa9b62d$var$LOCAL_DEVICE_ID_KEY);
            if (local_device !== null) {
                this.#LOCAL_DEVICE_ID = local_device;
                return local_device;
            }
            // Generate a new local device ID if it doesn't exist
            const randomId = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16));
            await this.#DATA_STORAGE.saveData(this.#APP_ID, $16abd72d1aa9b62d$var$LOCAL_DEVICE_ID_KEY, randomId);
            this.#LOCAL_DEVICE_ID = randomId;
            return randomId;
        }
        async #loadToken() {
            if (!this.#TOKEN) this.#TOKEN = await this.#TOKEN_STORAGE.readToken(this.#APP_ID);
        }
        async #setToken(token) {
            await this.#TOKEN_STORAGE.saveToken(this.#APP_ID, token);
            this.#TOKEN = token;
        }
        async #removeToken() {
            await this.#TOKEN_STORAGE.deleteToken(this.#APP_ID);
            this.#TOKEN = null;
        }
        async #checkAndRefreshToken() {
            await this.#loadToken();
            await this.#readTimeZoneOffset();
            if (!this.#TOKEN) return;
            const renewalAheadPeriod = 60000;
            const now = new Date();
            const expiration = new Date(this.#TOKEN.expiration);
            if (now > new Date(expiration.getTime() - renewalAheadPeriod)) await this.#refreshToken();
        }
        async #refreshToken() {
            // Check if a token refresh is already in progress.
            // If so, return that promise instead of starting a new request.
            if (this.#tokenRefreshInProgress) {
                console.warn('Token refresh already in progress');
                return this.#tokenRefreshInProgress;
            }
            const _performTokenRefresh = async ()=>{
                const loginTimeout = new $dF8o7.TimeoutSignal(this.#LOGIN_TIMEOUT, 'Login request timed out');
                try {
                    if (!this.#TOKEN) throw new Error('Token not found');
                    //console.log('Refreshing token');
                    const old_token = this.#TOKEN;
                    const response = await fetch(`${this.#API_URL}/${this.#APP_ID}/auth/refresh`, {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8"
                        },
                        mode: this.#REQUEST_MODE,
                        cache: 'no-store',
                        credentials: 'include',
                        referrerPolicy: 'strict-origin-when-cross-origin',
                        signal: loginTimeout.signal,
                        body: JSON.stringify({
                            Bearer: this.#TOKEN.access_token,
                            RefreshToken: this.#TOKEN.refresh_token
                        })
                    });
                    if (!response.ok) throw {
                        status: response?.status,
                        statusMessage: response?.statusText,
                        message: response?.statusText,
                        url: response?.url
                    };
                    const data = await response.json();
                    if (data && data.access_token) {
                        const new_token = new $78KzE.MicroMToken(data.access_token, data.expires_in, data['refresh-token'], data.token_type, this.#TOKEN.claims);
                        if (old_token !== this.#TOKEN) throw new Error("Current token was changed while refreshing.");
                        await this.#setToken(new_token);
                        //console.log('Token refreshed', new_token);
                        return;
                    } else throw {
                        statusMessage: 'Unexpected result',
                        url: response.url
                    };
                } catch (error) {
                    //console.log('RefreshToken', error);
                    throw error;
                } finally{
                    this.#tokenRefreshInProgress = null; // Clear the ongoing refresh promise once done.
                    loginTimeout.clear();
                }
            };
            this.#tokenRefreshInProgress = _performTokenRefresh();
            return this.#tokenRefreshInProgress;
        }
        //*** Timezone offset
        get TIMEZONE_OFFSET() {
            return this.#TIMEZONE_OFFSET;
        }
        async #saveTimeZoneOffset(data) {
            await this.#DATA_STORAGE.saveData(this.#APP_ID, $16abd72d1aa9b62d$var$TIMEZONE_OFFSET_DATA_KEY, data);
        }
        async #readTimeZoneOffset() {
            const result = await this.#DATA_STORAGE.readData(this.#APP_ID, $16abd72d1aa9b62d$var$TIMEZONE_OFFSET_DATA_KEY);
            if (result === null) {
                console.warn('No timezone offset found, using default 0');
                this.#TIMEZONE_OFFSET = 0;
                return 0;
            }
            this.#TIMEZONE_OFFSET = result;
            return result;
        }
        async #getTimeZoneOffset(abort_signal = null) {
            if (!this.#TOKEN) return;
            const result = await this.#submitToAPI('SystemProcs', null, {}, [], 'proc', abort_signal, 'sys_GetTimeZoneOffset');
            const offset = result[0].records[0][0];
            if (isNaN(offset)) {
                console.warn('No timezone offset found, using default 0');
                return 0;
            }
            await this.#saveTimeZoneOffset(offset);
            return result;
        }
        //*** Enabled menus
        async getMenus() {
            if (this.#ENABLED_MENUS.size === 0) {
                const data = await this.#readEnabledMenus();
                this.#ENABLED_MENUS = data ? new Set(data) : new Set();
            }
            return this.#ENABLED_MENUS;
        }
        async #getAPIEnabledMenus(username, abort_signal = null) {
            if (!this.#TOKEN) return;
            const result = await this.#submitToAPI('MicromUsers', null, {
                vc_username: username
            }, [], 'proc', abort_signal, 'usr_GetEnabledMenus');
            if (result.length === 0 || result[0].records.length === 0) throw {
                status: 403,
                statusMessage: 'No access',
                message: 'No access to this app',
                url: ''
            };
            const menu_items = result[0].records.map((record)=>`${record[0]}_${record[1]}`);
            await this.#saveEnabledMenus(menu_items);
            this.#ENABLED_MENUS = new Set(menu_items);
        }
        async #saveEnabledMenus(data) {
            await this.#DATA_STORAGE.saveData(this.#APP_ID, $16abd72d1aa9b62d$var$ENABLED_MENUS_DATA_KEY, data);
        }
        async #readEnabledMenus() {
            return await this.#DATA_STORAGE.readData(this.#APP_ID, $16abd72d1aa9b62d$var$ENABLED_MENUS_DATA_KEY);
        }
        async #deleteEnabledMenus() {
            await this.#DATA_STORAGE.deleteData(this.#APP_ID, $16abd72d1aa9b62d$var$ENABLED_MENUS_DATA_KEY);
        }
        //*** File upload/download
        getDocumentURL(fileGuid) {
            return fileGuid ? `${this.#API_URL}/${this.#APP_ID}/serve/${fileGuid}` : '';
        }
        getThumbnailURL(fileGuid, max_size = 150, quality = 75) {
            return fileGuid ? `${this.#API_URL}/${this.#APP_ID}/thumbnail/${fileGuid}/${max_size}/${quality}` : '';
        }
        async upload(file, fileprocess_id, abort_signal = null, max_size = 150, quality = 75, onProgress = ()=>{}) {
            return this.#uploadFile(file, fileprocess_id, abort_signal, max_size, quality, onProgress);
        }
        async downloadBlob(fileUrl, abort_signal = null) {
            await this.#checkAndRefreshToken();
            if (!this.#TOKEN) throw {
                status: 401,
                statusMessage: `Can't execute request: Not logged in`
            };
            const response = await fetch(fileUrl, {
                headers: {
                    ...this.#TOKEN ? {
                        "Authorization": `Bearer ${this.#TOKEN.access_token}`
                    } : {}
                },
                mode: this.#REQUEST_MODE,
                cache: 'no-store',
                credentials: 'include',
                referrerPolicy: 'strict-origin-when-cross-origin',
                signal: abort_signal
            });
            if (!response.ok) throw new Error(`Network error: ${response.status} - ${response.statusText}`);
            return await response.blob();
        }
        async #uploadFile(file, fileprocess_id, abort_signal = null, max_size = 150, quality = 75, onProgress = ()=>{}) {
            await this.#checkAndRefreshToken();
            if (!this.#TOKEN) throw {
                status: 401,
                statusMessage: `Can't execute request: Not logged in`
            };
            const url = new URL(`${this.#API_URL}/${this.#APP_ID}/tmpupload`);
            url.searchParams.set("file_name", file.name);
            url.searchParams.set("fileprocess_id", fileprocess_id);
            url.searchParams.set("maxSize", max_size.toFixed(0));
            url.searchParams.set("quality", quality.toFixed(0));
            const totalSize = file.size;
            let uploadedSize = 0;
            return new Promise((resolve, reject)=>{
                const xhr = new XMLHttpRequest();
                xhr.open('POST', url.toString(), true);
                xhr.setRequestHeader("Content-Type", 'application/octet-stream');
                xhr.setRequestHeader("Authorization", `Bearer ${this.#TOKEN.access_token}`);
                xhr.withCredentials = true; // for sending credentials in cross-origin scenarios
                xhr.upload.onprogress = (event1)=>{
                    if (event1.lengthComputable) {
                        uploadedSize = event1.loaded;
                        onProgress(file, Math.ceil(uploadedSize / totalSize * 100));
                    }
                };
                xhr.onload = async ()=>{
                    if (xhr.status >= 200 && xhr.status < 300) {
                        const data = JSON.parse(xhr.responseText);
                        if (!data.ErrorMessage) {
                            data.documentURL = `${this.#API_URL}/${this.#APP_ID}/serve/${data.FileGuid}`;
                            data.thumbnailURL = `${this.#API_URL}/${this.#APP_ID}/thumbnail/${data.FileGuid}/${max_size}/${quality}`;
                        }
                        resolve(data);
                    } else reject({
                        status: xhr.status,
                        statusMessage: xhr.statusText,
                        message: xhr.statusText,
                        url: xhr.responseURL
                    });
                };
                xhr.onerror = ()=>{
                    reject({
                        status: xhr.status,
                        statusMessage: xhr.statusText,
                        message: xhr.statusText,
                        url: xhr.responseURL
                    });
                };
                if (abort_signal) abort_signal.addEventListener('abort', ()=>{
                    xhr.abort();
                    reject({
                        status: 0,
                        statusMessage: 'Aborted',
                        message: 'Request was aborted by user'
                    });
                });
                xhr.send(file);
            });
        }
        //*** Entities API
        async get(entity_name, parent_keys, values, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Get
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "get")) return this.#submitToPublicAPI(entity_name, parent_keys, values, [], "get", abort_signal);
            return this.#submitToAPI(entity_name, parent_keys, values, [], "get", abort_signal);
        }
        async insert(entity_name, parent_keys, values, recordsSelection, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Insert
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "insert")) return this.#submitToPublicAPI(entity_name, parent_keys, values, recordsSelection, "insert", abort_signal);
            return this.#submitToAPI(entity_name, parent_keys, values, recordsSelection, "insert", abort_signal);
        }
        async update(entity_name, parent_keys, values, recordsSelection, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Update
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "update")) return this.#submitToPublicAPI(entity_name, parent_keys, values, recordsSelection, "update", abort_signal);
            return this.#submitToAPI(entity_name, parent_keys, values, recordsSelection, "update", abort_signal);
        }
        async delete(entity_name, parent_keys, values, recordsSelection, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Delete
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "delete")) return this.#submitToPublicAPI(entity_name, parent_keys, values, recordsSelection, "delete", abort_signal);
            return this.#submitToAPI(entity_name, parent_keys, values, recordsSelection, "delete", abort_signal);
        }
        async lookup(entity_name, parent_keys, values, lookup_name = null, abort_signal = null) {
            if (!lookup_name) this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.DefaultLookup
            });
            else this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.CustomLookup,
                views: [
                    lookup_name
                ]
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "lookup")) return this.#submitToPublicAPI(entity_name, parent_keys, values, [], "lookup", abort_signal, lookup_name);
            return this.#submitToAPI(entity_name, parent_keys, values, [], "lookup", abort_signal, lookup_name);
        }
        async viewtoexcel(entity_name, parent_keys, values, view_name, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Views,
                views: [
                    view_name
                ]
            });
            return this.#submitToAPIBlob(entity_name, parent_keys, values, [], "viewtoexcel", abort_signal, view_name);
        }
        async view(entity_name, parent_keys, values, view_name, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Views,
                views: [
                    view_name
                ]
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "viewstream", view_name)) return this.#submitToPublicAPI(entity_name, parent_keys, values, [], "viewstream", abort_signal, view_name);
            return this.#submitToAPI(entity_name, parent_keys, values, [], "viewstream", abort_signal, view_name);
        }
        async proc(entity_name, parent_keys, values, recordsSelection, proc_name, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Procs,
                procs: [
                    proc_name
                ]
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "procstream", proc_name)) return this.#submitToPublicAPI(entity_name, parent_keys, values, recordsSelection, "procstream", abort_signal, proc_name);
            return this.#submitToAPI(entity_name, parent_keys, values, recordsSelection, "procstream", abort_signal, proc_name);
        }
        async proctoexcel(entity_name, parent_keys, values, recordsSelection, proc_name, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Procs,
                procs: [
                    proc_name
                ]
            });
            return this.#submitToAPIBlob(entity_name, parent_keys, values, recordsSelection, "proctoexcel", abort_signal, proc_name);
        }
        async process(entity_name, parent_keys, values, recordsSelection, proc_name, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Procs,
                procs: [
                    proc_name
                ]
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "process", proc_name)) return this.#submitToPublicAPI(entity_name, parent_keys, values, recordsSelection, "process", abort_signal, proc_name);
            return this.#submitToAPI(entity_name, parent_keys, values, recordsSelection, "process", abort_signal, proc_name);
        }
        async action(entity_name, parent_keys, values, action_name, abort_signal = null) {
            this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Actions,
                actions: [
                    action_name
                ]
            });
            if (!this.#TOKEN && this.#isPublicAPI(entity_name, "action", undefined, action_name)) return this.#submitToPublicAPI(entity_name, parent_keys, values, [], "action", abort_signal, action_name);
            return this.#submitToAPI(entity_name, parent_keys, values, [], "action", abort_signal, action_name);
        }
        async import(entity_name, parent_keys, values, import_procname, abort_signal = null) {
            if (!import_procname) this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Import
            });
            else this.#recordAccess({
                entityName: entity_name,
                access: $brSbF.AllowedRouteFlags.Import,
                procs: [
                    import_procname
                ]
            });
            return this.#submitToAPI(entity_name, parent_keys, values, [], "import", abort_signal, import_procname);
        }
        async #submitToAPIBlob(entity_name, parent_keys, values, recordsSelection, action, abort_signal = null, additional_route = null) {
            const extra_route = additional_route !== null ? `/${additional_route}` : '';
            const route = `${this.#API_URL}/${this.#APP_ID}/ent/${entity_name}/${action}${extra_route}`;
            try {
                await this.#checkAndRefreshToken();
                if (!this.#TOKEN) throw {
                    status: 401,
                    statusMessage: `Can't execute request: Not logged in`,
                    url: route
                };
                const body = JSON.stringify({
                    ParentKeys: parent_keys,
                    Values: values,
                    RecordsSelection: recordsSelection
                }, $hDJ3w.JSONDateWithTimezoneReplacer);
                const res = await fetch(route, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": `Bearer ${this.#TOKEN.access_token}`
                    },
                    mode: this.#REQUEST_MODE,
                    cache: 'no-store',
                    credentials: 'include',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    signal: abort_signal,
                    body: body
                });
                if (!res.ok) {
                    let error_body = undefined;
                    try {
                        error_body = await res.text();
                    } catch  {}
                    throw {
                        status: res?.status,
                        statusMessage: res?.statusText,
                        message: res?.statusText,
                        url: res?.url,
                        errorBody: error_body
                    };
                }
                const data = await res.blob();
                return data;
            } catch (error) {
                if (this.#REDIRECT_ON_401 && error.status === 401) {
                    console.warn(`${route} 401, redirecting to login page: ${this.#REDIRECT_ON_401}`);
                    await this.localLogoff();
                    window.location.href = this.#REDIRECT_ON_401;
                // return intentionally omitted
                }
                // MMC: this line should never execute if the redirect happens. 
                // In case the browser, webview or environment for any reason fails to redirect, we still throw the error to the caller.
                throw error;
            }
        }
        async #submitToAPI(entity_name, parent_keys, values, recordsSelection, action, abort_signal = null, additional_route = null) {
            const extra_route = additional_route !== null ? `/${additional_route}` : '';
            const route = `${this.#API_URL}/${this.#APP_ID}/ent/${entity_name}/${action}${extra_route}`;
            try {
                await this.#checkAndRefreshToken();
                if (!this.#TOKEN) throw {
                    status: 401,
                    statusMessage: `Can't execute request: Not logged in`,
                    url: route
                };
                const body = JSON.stringify({
                    ParentKeys: parent_keys,
                    Values: values,
                    RecordsSelection: recordsSelection
                }, $hDJ3w.JSONDateWithTimezoneReplacer);
                const res = await fetch(route, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "Authorization": `Bearer ${this.#TOKEN.access_token}`
                    },
                    mode: this.#REQUEST_MODE,
                    cache: 'no-store',
                    credentials: 'include',
                    referrerPolicy: 'strict-origin-when-cross-origin',
                    signal: abort_signal,
                    body: body
                });
                if (!res.ok) {
                    let error_body = undefined;
                    try {
                        error_body = await res.text();
                    } catch  {}
                    throw {
                        status: res?.status,
                        statusMessage: res?.statusText,
                        message: res?.statusText,
                        url: res?.url,
                        errorBody: error_body
                    };
                }
                const data = await res.json();
                return data;
            } catch (error) {
                if (this.#REDIRECT_ON_401 && error.status === 401) {
                    console.warn(`${route} 401, redirecting to login page: ${this.#REDIRECT_ON_401}`);
                    await this.localLogoff();
                    window.location.href = this.#REDIRECT_ON_401;
                // return intentionally omitted
                }
                // MMC: this line should never execute if the redirect happens. 
                // In case the browser, webview or environment for any reason fails to redirect, we still throw the error to the caller.
                throw error;
            }
        }
        async #submitToPublicAPI(entity_name, parent_keys, values, recordsSelection, action, abort_signal = null, additional_route = null) {
            const extra_route = additional_route !== null ? `/${additional_route}` : '';
            const route = `${this.#API_URL}/${this.#APP_ID}/public/${entity_name}/${action}${extra_route}`;
            const body = JSON.stringify({
                ParentKeys: parent_keys,
                Values: values,
                RecordsSelection: recordsSelection
            }, $hDJ3w.JSONDateWithTimezoneReplacer);
            const res = await fetch(route, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json; charset=utf-8"
                },
                mode: this.#REQUEST_MODE,
                cache: 'no-store',
                credentials: 'include',
                referrerPolicy: 'strict-origin-when-cross-origin',
                signal: abort_signal,
                body: body
            });
            if (!res.ok) {
                let error_body = undefined;
                try {
                    error_body = await res.text();
                } catch  {}
                throw {
                    status: res?.status,
                    statusMessage: res?.statusText,
                    message: res?.statusText,
                    url: res?.url,
                    errorBody: error_body
                };
            }
            const data = await res.json();
            return data;
        }
        #isPublicAPI(entity_name, action, proc_name, action_name) {
            const endpoint = this.#publicEndpoints[entity_name];
            if (endpoint) switch(action){
                case "get":
                    return (endpoint.AllowedAccess & 8) !== 0;
                case "insert":
                    return (endpoint.AllowedAccess & 1) !== 0;
                case "update":
                    return (endpoint.AllowedAccess & 2) !== 0;
                case "delete":
                    return (endpoint.AllowedAccess & 4) !== 0;
                case "lookup":
                    return (endpoint.AllowedAccess & 16) !== 0;
                case "action":
                    return endpoint.AllowedActions && action_name && endpoint.AllowedActions.has(action_name) || false;
                case "view":
                    return endpoint.AllowedProcs && proc_name && endpoint.AllowedProcs.has(proc_name) || false;
                case "proc":
                    return endpoint.AllowedProcs && proc_name && endpoint.AllowedProcs.has(proc_name) || false;
                case "process":
                    return endpoint.AllowedProcs && proc_name && endpoint.AllowedProcs.has(proc_name) || false;
                default:
                    return false;
            }
            return false;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("lTNXP", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isIn", function() {
        return $5ed3bb7179b182a6$export$db8d11291b3bcc3e;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isPromise", function() {
        return $5ed3bb7179b182a6$export$4369c812aac99591;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "createKeysSet", function() {
        return $5ed3bb7179b182a6$export$b26ab034a805040d;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "createKeysArray", function() {
        return $5ed3bb7179b182a6$export$7b2c356fa50d350f;
    });
    function $5ed3bb7179b182a6$export$db8d11291b3bcc3e(value, ...params) {
        if (params == null) return false;
        for (const v of params){
            if (v != null && v != undefined && v === value) return true;
        }
        return false;
    }
    function $5ed3bb7179b182a6$export$4369c812aac99591(obj) {
        return !!obj && typeof obj.then === 'function';
    }
    function $5ed3bb7179b182a6$export$b26ab034a805040d() {
        return new Set();
    }
    function $5ed3bb7179b182a6$export$7b2c356fa50d350f() {
        return new Array();
    }
});
$305cacda61daafb0$var$parcelRegister("cfO6r", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataStorage", function() {
        return $f9aa3a37dfedde5b$export$e95767ffe2e60cec;
    });
    class $f9aa3a37dfedde5b$export$e95767ffe2e60cec {
        #_isAvailable;
        #storage_type;
        #storage_name;
        static #DATA_ARRAY = new Map();
        #checkStorageAvailable() {
            let storage = null;
            try {
                storage = window[this.#storage_type];
                if (storage === null) throw new Error(`Storage ${this.#storage_type} not available`);
                const x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            } catch (e) {
                console.error(`${this.#storage_type} not available!`, e);
                return e instanceof DOMException && // everything except Firefox
                (e.code === 22 || // Firefox
                e.code === 1014 || // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' || // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
                storage && storage.length !== 0;
            }
        }
        constructor(storage_type = 'sessionStorage', storage_name = 'microm_data'){
            this.#storage_type = storage_type;
            this.#storage_name = storage_name;
            this.#_isAvailable = this.#checkStorageAvailable();
        }
        async saveData(app_id, key, data) {
            const storage_key = `${this.#storage_name}_${app_id}_${key}`;
            const data_string = JSON.stringify(data);
            $f9aa3a37dfedde5b$export$e95767ffe2e60cec.#DATA_ARRAY.set(storage_key, data_string);
            const available = this.#_isAvailable;
            if (!available || !app_id || !key) {
                console.warn('DataStorage: saveData, data not saved', app_id, key, available);
                return;
            }
            const storage = window[this.#storage_type];
            storage.setItem(storage_key, data_string);
        }
        async readData(app_id, key) {
            try {
                const storage_key = `${this.#storage_name}_${app_id}_${key}`;
                if (!this.#_isAvailable) {
                    console.warn('DataStorage: readData, storage not available', app_id, key);
                    return JSON.parse($f9aa3a37dfedde5b$export$e95767ffe2e60cec.#DATA_ARRAY.get(storage_key));
                }
                const storage = window[this.#storage_type];
                const json_obj = storage.getItem(storage_key);
                return json_obj === null ? null : JSON.parse(json_obj);
            } catch (e) {
                console.error(`DataStorage: Failed to read data from DataStorage ${e}`);
                return null;
            }
        }
        async deleteData(app_id, key) {
            const storage_key = `${this.#storage_name}_${app_id}_${key}`;
            $f9aa3a37dfedde5b$export$e95767ffe2e60cec.#DATA_ARRAY.delete(storage_key);
            if (!this.#_isAvailable) {
                console.warn('DataStorage: delete data, storage not available', app_id, key);
                return;
            }
            const storage = window[this.#storage_type];
            storage.removeItem(storage_key);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("hDJ3w", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "JSONDateWithTimezoneReplacer", function() {
        return $baf63557e40a8851$export$9b8e1f84022ba02f;
    });
    function $baf63557e40a8851$export$9b8e1f84022ba02f(key, value) {
        if (this[key] instanceof Date) {
            const date = this[key];
            // Obtener componentes de la fecha en la zona horaria local
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
            // Obtener el offset de la zona horaria local
            const timezoneOffset = -date.getTimezoneOffset();
            const sign = timezoneOffset >= 0 ? '+' : '-';
            const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
            const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
            const offset = `${sign}${offsetHours}:${offsetMinutes}`;
            // Formatear la fecha con la información de la zona horaria
            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}${offset}`;
        }
        return value;
    }
});
$305cacda61daafb0$var$parcelRegister("brSbF", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RECORDED_ACCESS_DATA_STORAGE_KEY", function() {
        return $0a3389f342163505$export$b181f816b5984a3;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AllowedRouteFlags", function() {
        return $0a3389f342163505$export$d15d4be57acabaf3;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "generateCSharpGetRoutePaths", function() {
        return $0a3389f342163505$export$e20d75ff0e484480;
    });
    const $0a3389f342163505$export$b181f816b5984a3 = 'mm_menu_paths';
    var $0a3389f342163505$export$d15d4be57acabaf3 = /*#__PURE__*/ function(AllowedRouteFlags) {
        AllowedRouteFlags[AllowedRouteFlags["None"] = 0] = "None";
        AllowedRouteFlags[AllowedRouteFlags["Insert"] = 1] = "Insert";
        AllowedRouteFlags[AllowedRouteFlags["Update"] = 2] = "Update";
        AllowedRouteFlags[AllowedRouteFlags["Delete"] = 4] = "Delete";
        AllowedRouteFlags[AllowedRouteFlags["Get"] = 8] = "Get";
        AllowedRouteFlags[AllowedRouteFlags["DefaultLookup"] = 16] = "DefaultLookup";
        AllowedRouteFlags[AllowedRouteFlags["Edit"] = 15] = "Edit";
        AllowedRouteFlags[AllowedRouteFlags["CustomLookup"] = 32] = "CustomLookup";
        AllowedRouteFlags[AllowedRouteFlags["Views"] = 64] = "Views";
        AllowedRouteFlags[AllowedRouteFlags["Procs"] = 128] = "Procs";
        AllowedRouteFlags[AllowedRouteFlags["Actions"] = 256] = "Actions";
        AllowedRouteFlags[AllowedRouteFlags["Import"] = 512] = "Import";
        AllowedRouteFlags[AllowedRouteFlags["All"] = 1023] = "All";
        return AllowedRouteFlags;
    }({});
    const $0a3389f342163505$var$CsharpAllowedRouteFlags = [
        {
            name: "All",
            value: 511
        },
        {
            name: "Actions",
            value: 256
        },
        {
            name: "Procs",
            value: 128
        },
        {
            name: "Views",
            value: 64
        },
        {
            name: "CustomLookup",
            value: 32
        },
        {
            name: "DefaultLookup",
            value: 16
        },
        {
            name: "Get",
            value: 8
        },
        {
            name: "Delete",
            value: 4
        },
        {
            name: "Update",
            value: 2
        },
        {
            name: "Insert",
            value: 1
        },
        {
            name: "None",
            value: 0
        }
    ];
    function $0a3389f342163505$var$mapAccessToFlags(access) {
        if (access === 0) return "AllowedRouteFlags.None";
        const flags = [];
        if ((access & 15) === 15) {
            flags.push("AllowedRouteFlags.Edit");
            access &= -16;
        }
        $0a3389f342163505$var$CsharpAllowedRouteFlags.forEach((flag)=>{
            if (flag.name === "None") return;
            if ((access & flag.value) === flag.value) flags.push(`AllowedRouteFlags.${flag.name}`);
        });
        return flags.join(" | ");
    }
    function $0a3389f342163505$export$e20d75ff0e484480(dataRecord) {
        const csharpLines = [];
        Object.values(dataRecord).forEach((data)=>{
            const { entityName: entityName, access: access, views: views, procs: procs, actions: actions, lookups: lookups } = data;
            let flags = $0a3389f342163505$var$mapAccessToFlags(access);
            const combinedProcs = [
                ...new Set([
                    ...procs || [],
                    ...lookups || []
                ])
            ];
            if (lookups && lookups.length > 0) {
                if (!flags.includes("AllowedRouteFlags.CustomLookup")) flags = flags ? `${flags} | AllowedRouteFlags.CustomLookup` : "AllowedRouteFlags.CustomLookup";
                if (!flags.includes("AllowedRouteFlags.Procs")) flags = flags ? `${flags} | AllowedRouteFlags.Procs` : "AllowedRouteFlags.Procs";
            }
            const params = [
                `${flags}`
            ];
            if (views && views.length > 0) {
                const viewsParam = `[${views.map((v)=>`"${v}"`).join(", ")}]`;
                params.push(`views: ${viewsParam}`);
            }
            if (combinedProcs.length > 0) {
                const procsParam = `[${combinedProcs.map((p)=>`"${p}"`).join(", ")}]`;
                params.push(`procs: ${procsParam}`);
            }
            if (actions && actions.length > 0) {
                const actionsParam = `[${actions.map((a)=>`"${a}"`).join(", ")}]`;
                params.push(`actions: ${actionsParam}`);
            }
            const csharpLine = `..typeof(${entityName}).GetRoutePaths(${params.join(", ")})`;
            csharpLines.push(csharpLine + ",");
        });
        return csharpLines.join("\n");
    }
});
$305cacda61daafb0$var$parcelRegister("78KzE", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicroMToken", function() {
        return $d740366d7ee0748e$export$63afd07a6b828dcd;
    });
    class $d740366d7ee0748e$export$63afd07a6b828dcd {
        constructor(access_token = '', expires_in = 0, refresh_token = '', token_type = '', claims = {}){
            this.expires_in = expires_in;
            const d = new Date();
            d.setTime(d.getTime() + expires_in * 1000);
            this.expiration = d.toISOString();
            this.access_token = access_token;
            this.expires_in = expires_in;
            this.refresh_token = refresh_token;
            this.token_type = token_type;
            this.claims = Object.fromEntries(Object.entries(claims).filter(([key])=>{
                const exclude = [
                    'access_token',
                    'expires_in',
                    'refresh-token',
                    'token_type'
                ];
                return !exclude.includes(key);
            }));
        }
        className() {
            return $d740366d7ee0748e$export$63afd07a6b828dcd.name;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("dF8o7", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "TimeoutSignal", function() {
        return $2f210757edfb27a1$export$c9297bdae1627606;
    });
    class $2f210757edfb27a1$export$c9297bdae1627606 {
        constructor(timeoutMs, errorMessage = 'Request timed out'){
            this.controller = new AbortController();
            this.signal = this.controller.signal;
            this.timeoutId = setTimeout(()=>{
                this.controller.abort(new DOMException(errorMessage, 'TimeoutError'));
            }, timeoutMs);
        }
        clear() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
                this.timeoutId = undefined;
            }
        }
        get aborted() {
            return this.signal.aborted;
        }
        get abortReason() {
            return this.signal.reason;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("2VTPU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "TokenWebStorage", function() {
        return $b2461b615fb5ccd4$export$1f670b0f74ee9970;
    });
    class $b2461b615fb5ccd4$export$1f670b0f74ee9970 {
        #_isAvailable;
        #storage_type;
        #storage_name;
        static #TOKEN_ARRAY = new Map();
        #checkStorageAvailable() {
            let storage = null;
            try {
                storage = window[this.#storage_type];
                if (storage === null) throw new Error(`Storage ${this.#storage_type} not available`);
                const x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            } catch (e) {
                console.log('LocalStorage not available!');
                console.log(e);
                return e instanceof DOMException && // everything except Firefox
                (e.code === 22 || // Firefox
                e.code === 1014 || // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' || // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
                storage && storage.length !== 0;
            }
        }
        constructor(storage_type = 'sessionStorage', storage_name = 'microm_bk'){
            this.#storage_type = storage_type;
            this.#storage_name = storage_name;
            this.#_isAvailable = this.#checkStorageAvailable();
        }
        async saveToken(app_id, token) {
            const key = `${this.#storage_name}_${app_id}`;
            const token_string = JSON.stringify(token);
            $b2461b615fb5ccd4$export$1f670b0f74ee9970.#TOKEN_ARRAY.set(key, token_string);
            if (!this.#_isAvailable || !app_id) return;
            const storage = window[this.#storage_type];
            storage.setItem(key, token_string);
        }
        async readToken(app_id) {
            try {
                const key = `${this.#storage_name}_${app_id}`;
                if (!this.#_isAvailable) return JSON.parse($b2461b615fb5ccd4$export$1f670b0f74ee9970.#TOKEN_ARRAY.get(key));
                const storage = window[this.#storage_type];
                const json_obj = storage.getItem(key);
                return json_obj === null ? null : JSON.parse(json_obj);
            } catch (e) {
                console.log(`MicromClient: Failed to read token from localStorage ${e}`);
                return null;
            }
        }
        async deleteToken(app_id) {
            const key = `${this.#storage_name}_${app_id}`;
            $b2461b615fb5ccd4$export$1f670b0f74ee9970.#TOKEN_ARRAY.delete(key);
            if (!this.#_isAvailable) return;
            const storage = window[this.#storage_type];
            storage.removeItem(key);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("98ddT", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "toMicroMError", function() {
        return $bd8fcf7d101f1db4$export$ed9c51ff84075a64;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "toDBStatusMicroMError", function() {
        return $bd8fcf7d101f1db4$export$696a74ebe30e5cda;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isMicroMError", function() {
        return $bd8fcf7d101f1db4$export$22ad9388388847b;
    });
    var $8yTUG = $305cacda61daafb0$var$parcelRequire("8yTUG");
    const $bd8fcf7d101f1db4$export$ed9c51ff84075a64 = (e)=>{
        return {
            status: e.status,
            statusMessage: e.statusMessage ?? e.cause,
            message: e.message,
            url: e.url,
            errorBody: e.errorBody
        };
    };
    const $bd8fcf7d101f1db4$export$696a74ebe30e5cda = (dbstat, form_mode = 'edit')=>{
        const result = dbstat.map((stat)=>stat.Status == $8yTUG.DBStatusCodes.RECORD_CHANGED ? form_mode == 'add' ? `The record you are trying to add already exists in the database` : `The record you are trying to update has been updated by another user ${stat.Message ?? ''}` : `${stat.Message ?? ''}`).join('\n');
        return {
            status: dbstat[0].Status,
            statusMessage: result
        };
    };
    function $bd8fcf7d101f1db4$export$22ad9388388847b(e) {
        return e;
    }
});
$305cacda61daafb0$var$parcelRegister("lq5EG", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("fiYMH", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RecordReader", function() {
        return $ca1d4db2dcf1b69b$export$be603574995f503f;
    });
    class $ca1d4db2dcf1b69b$export$be603574995f503f {
        constructor(dataResult){
            this.dataResult = dataResult;
            this.headerIndexCache = this.createHeaderIndexCache();
        }
        createHeaderIndexCache() {
            const cache = {};
            this.dataResult.Header.forEach((header, index)=>{
                cache[header] = index;
            });
            return cache;
        }
        getValue(recordIndex, headerName) {
            const headerIndex = this.headerIndexCache[headerName];
            if (headerIndex === undefined || recordIndex >= this.dataResult.records.length) return undefined;
            const record = this.dataResult.records[recordIndex];
            return record[headerIndex];
        }
    }
});
$305cacda61daafb0$var$parcelRegister("eyjUN", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EndpointAccess", function() {
        return $7cd24ca28b8b49af$export$9aed2b3988bdb4f3;
    });
    var $7cd24ca28b8b49af$export$9aed2b3988bdb4f3 = /*#__PURE__*/ function(EndpointAccess) {
        EndpointAccess[EndpointAccess["None"] = 0] = "None";
        EndpointAccess[EndpointAccess["Create"] = 1] = "Create";
        EndpointAccess[EndpointAccess["Update"] = 2] = "Update";
        EndpointAccess[EndpointAccess["Delete"] = 4] = "Delete";
        EndpointAccess[EndpointAccess["Get"] = 8] = "Get";
        EndpointAccess[EndpointAccess["Lookup"] = 16] = "Lookup";
        EndpointAccess[EndpointAccess["Execute"] = 32] = "Execute";
        return EndpointAccess;
    }({});
});
$305cacda61daafb0$var$parcelRegister("cjHVl", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("2eyXi", function(module1, exports) {
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $dR9Si = $305cacda61daafb0$var$parcelRequire("dR9Si");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $eRkDL = $305cacda61daafb0$var$parcelRequire("eRkDL");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    var $5vYDZ = $305cacda61daafb0$var$parcelRequire("5vYDZ");
    var $9M0Li = $305cacda61daafb0$var$parcelRequire("9M0Li");
    var $h4O7Z = $305cacda61daafb0$var$parcelRequire("h4O7Z");
    var $e12RS = $305cacda61daafb0$var$parcelRequire("e12RS");
    var $kY0Yt = $305cacda61daafb0$var$parcelRequire("kY0Yt");
    var $lTNXP = $305cacda61daafb0$var$parcelRequire("lTNXP");
    var $kalnk = $305cacda61daafb0$var$parcelRequire("kalnk");
    var $7T941 = $305cacda61daafb0$var$parcelRequire("7T941");
    var $9dFnv = $305cacda61daafb0$var$parcelRequire("9dFnv");
    var $TaFFV = $305cacda61daafb0$var$parcelRequire("TaFFV");
    var $5vnOT = $305cacda61daafb0$var$parcelRequire("5vnOT");
    var $hkmnY = $305cacda61daafb0$var$parcelRequire("hkmnY");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iKzSR);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bmxG4);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bFPBM);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dR9Si);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ZmuZ6);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $4H7ea);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $eRkDL);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5Sq1V);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5vYDZ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9M0Li);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $h4O7Z);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $e12RS);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kY0Yt);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lTNXP);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kalnk);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7T941);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9dFnv);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $TaFFV);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5vnOT);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hkmnY);
});
$305cacda61daafb0$var$parcelRegister("iKzSR", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "areArraysContentsEqual", function() {
        return $866943331939ce6d$export$eea84df50b6d9bf9;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "arrayToObject", function() {
        return $866943331939ce6d$export$d224121420685233;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "cloneColumns", function() {
        return $866943331939ce6d$export$239980f6be23ced9;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "areValuesEqual", function() {
        return $866943331939ce6d$export$34a9576836432edc;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "areValuesObjectsEqual", function() {
        return $866943331939ce6d$export$94c4148e47ea5c0b;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getColumns", function() {
        return $866943331939ce6d$export$978e30a0fb8610d8;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "filterColumns", function() {
        return $866943331939ce6d$export$d65e188677517fa1;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getValuesObject", function() {
        return $866943331939ce6d$export$4bfc7b2978a41dfe;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getValues", function() {
        return $866943331939ce6d$export$a5c4301012ad6f07;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getValuesArray", function() {
        return $866943331939ce6d$export$e21f4b7d8cce903e;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getColumnsObject", function() {
        return $866943331939ce6d$export$7cb4e9c0f9f530db;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "toColumnsObject", function() {
        return $866943331939ce6d$export$735ae1376e2929d1;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getColumnsNamesArray", function() {
        return $866943331939ce6d$export$9e890812e2dcb58b;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "setSourceValue", function() {
        return $866943331939ce6d$export$f901ae239e30212a;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "setValues", function() {
        return $866943331939ce6d$export$b7771d60d308862f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "clearValues", function() {
        return $866943331939ce6d$export$29cb59574ad24863;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "fillParentKeys", function() {
        return $866943331939ce6d$export$6b8874fd6ee6d024;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "namesOf", function() {
        return $866943331939ce6d$export$91a919136f15ad80;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "copyValuesObject", function() {
        return $866943331939ce6d$export$48bc9efe0fd9cb51;
    });
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $eRkDL = $305cacda61daafb0$var$parcelRequire("eRkDL");
    var $lTNXP = $305cacda61daafb0$var$parcelRequire("lTNXP");
    function $866943331939ce6d$export$eea84df50b6d9bf9(a, b) {
        if (a === b) return true;
        if (a === undefined && b === undefined) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;
        const sortedA = [
            ...a
        ].sort();
        const sortedB = [
            ...b
        ].sort();
        for(let i = 0; i < sortedA.length; i++){
            if (sortedA[i] !== sortedB[i]) return false;
        }
        return true;
    }
    function $866943331939ce6d$export$d224121420685233(values, onGetKey, onGetValue) {
        return values.reduce((result, item)=>{
            result[onGetKey(item)] = typeof onGetValue === 'function' ? onGetValue(item) : item;
            return result;
        }, {});
    }
    function $866943331939ce6d$export$239980f6be23ced9(source_columns) {
        const cloned = {};
        for(const colname in source_columns){
            const source = source_columns[colname];
            cloned[colname] = (0, $ZmuZ6.EntityColumn).clone(source);
        }
        return cloned;
    }
    function $866943331939ce6d$export$34a9576836432edc(values1, values2) {
        //TODO: check if are object instances
        if (values1 === values2) return true;
        if (!values1 && !values2) return true;
        if (!values1 && values2 || values1 && !values2) return false;
        const keys1 = Object.keys(values1);
        const keys2 = Object.keys(values2);
        if (keys1.length !== keys2.length) return false;
        for (const key1 of keys1)if (Object.hasOwnProperty.call(values1, key1)) {
            const value1 = values1[key1];
            let foundKey2 = false;
            for (const key2 of keys2){
                if (Object.hasOwnProperty.call(values2, key2)) {
                    if (key2 === key1) {
                        const value2 = values2[key2];
                        foundKey2 = true;
                        if (value2 !== value1) return false;
                        break;
                    }
                }
            }
            if (!foundKey2) return false;
        }
        return true;
    }
    function $866943331939ce6d$export$94c4148e47ea5c0b(objA, objB) {
        if (objA === undefined && objB === undefined) return true;
        if (objA === undefined || objB === undefined) return false;
        const keysA = Object.keys(objA);
        const keysB = Object.keys(objB);
        // Check if both objects have the same number of keys
        if (keysA.length !== keysB.length) return false;
        for (const key of keysA){
            if (!keysB.includes(key)) return false;
            const valueA = objA[key];
            const valueB = objB[key];
            // If both values are Date objects, compare their timestamps
            if (valueA instanceof Date && valueB instanceof Date) {
                if (valueA.getTime() !== valueB.getTime()) return false;
            } else if (Array.isArray(valueA) && Array.isArray(valueB)) {
                if (valueA.length !== valueB.length || !valueA.every((val, index)=>val === valueB[index])) return false;
            } else if (valueA !== valueB) return false;
        }
        return true;
    }
    function $866943331939ce6d$export$978e30a0fb8610d8(columns, filter) {
        const result = [];
        for(const c in columns){
            const column = columns[c];
            if (result.includes(column)) continue;
            if (filter === null) result.push(column);
            else {
                if (filter.ignoreDefaults) {
                    if (column.value === column.defaultValue) continue;
                }
                if (filter.flags === undefined) result.push(column);
                else {
                    const matched = filter.matchAllFlags ? column.hasFlag(filter.flags) : column.hasAnyFlag(filter.flags);
                    if (matched) result.push(column);
                }
            }
        }
        return result;
    }
    function $866943331939ce6d$export$d65e188677517fa1(columns, filter) {
        const result = [];
        for(let x = 0; x++; columns.length){
            const column = columns[x];
            if (result.includes(column)) continue;
            if (filter === null) result.push(column);
            else {
                if (filter.ignoreDefaults) {
                    if (column.value === column.defaultValue) continue;
                }
                if (filter.flags === undefined) result.push(column);
                else {
                    const matched = filter.matchAllFlags ? column.hasFlag(filter.flags) : column.hasAnyFlag(filter.flags);
                    if (matched) result.push(column);
                }
            }
        }
        return result;
    }
    function $866943331939ce6d$export$4bfc7b2978a41dfe(columns, filters) {
        return $866943331939ce6d$export$a5c4301012ad6f07(columns, filters);
    //return arrayToObject(getColumns(columns, filters), column => column.name, column => column.value);
    }
    function $866943331939ce6d$export$e21f4b7d8cce903e(columns, filters) {
        return $866943331939ce6d$export$978e30a0fb8610d8(columns, filters).map((column)=>column.value);
    }
    function $866943331939ce6d$export$7cb4e9c0f9f530db(columns, filters) {
        return $866943331939ce6d$export$d224121420685233($866943331939ce6d$export$978e30a0fb8610d8(columns, filters), (column)=>column.name);
    }
    function $866943331939ce6d$export$735ae1376e2929d1(columns) {
        return $866943331939ce6d$export$d224121420685233(columns, (column)=>column.name);
    }
    function $866943331939ce6d$export$9e890812e2dcb58b(columns, filters) {
        return $866943331939ce6d$export$978e30a0fb8610d8(columns, filters).map((column)=>column.name);
    }
    function $866943331939ce6d$export$a5c4301012ad6f07(columns, filter) {
        const result = {};
        for(const c in columns){
            const column = columns[c];
            if (filter === null) result[column.name] = column.value;
            else {
                if (filter.ignoreSystemColumns) {
                    if ((0, $bmxG4.SYSTEM_COLUMNS_NAMES).includes(c)) continue;
                }
                if (filter.ignoreDefaults) {
                    if (column.value === column.defaultValue) continue;
                }
                if (filter.flags === undefined) result[column.name] = column.value;
                else {
                    const matched = filter.matchAllFlags ? column.hasFlag(filter.flags) : column.hasAnyFlag(filter.flags);
                    if (matched) result[column.name] = column.value;
                }
            }
        }
        return result;
    }
    function $866943331939ce6d$export$f901ae239e30212a(columnName, sourceValue, columns, ignoreInexistentColumns, ignoreEmptySourceValues, convertStringArray) {
        const column = columns[columnName];
        if (!column) {
            if (!ignoreInexistentColumns) throw new Error(`Column '${columnName}' not found.`);
            return;
        }
        let valueToSet;
        let valueDescriptionToSet;
        if (sourceValue instanceof $ZmuZ6.EntityColumn) {
            valueToSet = sourceValue.value;
            valueDescriptionToSet = sourceValue.valueDescription;
        } else valueToSet = sourceValue;
        // Convert string to Date if necessary
        if (typeof valueToSet === 'string' && (0, $lTNXP.isIn)(column.type, 'date', 'datetime', 'datetime2', 'smalldatetime') && !(0, $lTNXP.isIn)(columnName, 'dt_lu')) try {
            // FIX to handle dayjs issue parsing string ISO 8601 with trimmed zeroes at the end of the milliseconds
            // 2025-07-02T16:58:45.57 57 here means 570 milliseconds but dayJS has a bug and parses it as 57 milliseconds.
            // The fix should complete with trailing zeroes, if it ends with one or two digits after the dot.
            if (valueToSet.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{1,2}$/)) valueToSet = valueToSet + '0'.repeat(3 - valueToSet.split('.')[1].length);
            // dayjs is used here for compatibility with mantine calendar component which formats the date with dayjs
            valueToSet = $305cacda61daafb0$var$$parcel$interopDefault($gngdn)(valueToSet).toDate();
        } catch (e) {
            console.log(`Error converting string to Date: ${e}`, e);
        }
        if (!(0, $eRkDL.hasValue)(valueToSet) && ignoreEmptySourceValues) return;
        // MMC: specific for entityAPI getData method, where the json array comes as an escaped string
        if (convertStringArray && column.isArray && typeof valueToSet === "string") column.value = JSON.parse(valueToSet);
        else column.value = valueToSet;
        if (valueDescriptionToSet) column.valueDescription = valueDescriptionToSet;
    }
    function $866943331939ce6d$export$b7771d60d308862f(columns, sourceValues, filters, ignoreInexistentColumns = false, ignoreEmptySourceValues = false, convertStringArray = false) {
        if (!sourceValues) return;
        if (filters === undefined) filters = null;
        const matchedColumns = $866943331939ce6d$export$7cb4e9c0f9f530db(columns, filters);
        if (Array.isArray(sourceValues)) for(let sourceIndex = 0; sourceIndex < sourceValues.length; sourceIndex++){
            const sourceColumn = sourceValues[sourceIndex];
            $866943331939ce6d$export$f901ae239e30212a(sourceColumn.name, sourceColumn.value, matchedColumns, ignoreInexistentColumns, ignoreEmptySourceValues, convertStringArray);
        }
        else for(const columnName in sourceValues){
            if (!Object.hasOwnProperty.call(sourceValues, columnName)) continue;
            const sourceValue = sourceValues[columnName];
            $866943331939ce6d$export$f901ae239e30212a(columnName, sourceValue, matchedColumns, ignoreInexistentColumns, ignoreEmptySourceValues, convertStringArray);
        }
    }
    function $866943331939ce6d$export$29cb59574ad24863(columns, useColumnDefaultValue = true, filters = null) {
        $866943331939ce6d$export$978e30a0fb8610d8(columns, filters).forEach((column)=>column.value = useColumnDefaultValue ? column.defaultValue : '');
    }
    function $866943331939ce6d$export$6b8874fd6ee6d024(columns, parentKeys, ignoreEmptyParentKeys = true, filters = null) {
        if (filters === null) filters = {
            flags: $4H7ea.EntityColumnFlags.pk | $4H7ea.EntityColumnFlags.fk,
            ignoreDefaults: false
        };
        $866943331939ce6d$export$b7771d60d308862f(columns, parentKeys, filters, true, ignoreEmptyParentKeys);
    }
    function $866943331939ce6d$export$91a919136f15ad80() {
        return new Proxy({}, {
            get: function(_target, prop, _receiver) {
                return prop;
            }
        });
    }
    function $866943331939ce6d$export$48bc9efe0fd9cb51(obj) {
        const copiedObject = {};
        for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            // Handle Date object separately
            if (value instanceof Date) copiedObject[key] = new Date(value.getTime());
            else copiedObject[key] = value;
        }
        return copiedObject;
    }
});
$305cacda61daafb0$var$parcelRegister("bmxG4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "SYSTEM_COLUMNS_NAMES", function() {
        return $4bbf2ac0ba722279$export$126a7000f0a215a5;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DefaultColumnsNames", function() {
        return $4bbf2ac0ba722279$export$713e6b0eb94102b0;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DefaultColumns", function() {
        return $4bbf2ac0ba722279$export$e2598544ac550573;
    });
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    const $4bbf2ac0ba722279$export$126a7000f0a215a5 = [
        'dt_inserttime',
        'dt_lu',
        'vc_webinsuser',
        'vc_webluuser',
        'vc_insuser',
        'vc_luuser'
    ];
    const $4bbf2ac0ba722279$export$713e6b0eb94102b0 = [
        'dt_inserttime',
        'dt_lu',
        'vc_webinsuser',
        'vc_webluuser',
        'vc_insuser',
        'vc_luuser'
    ];
    const $4bbf2ac0ba722279$export$e2598544ac550573 = ()=>({
            dt_inserttime: new $ZmuZ6.EntityColumn({
                name: 'dt_inserttime',
                type: 'datetime',
                flags: $4H7ea.EntityColumnFlags.None
            }),
            dt_lu: new $ZmuZ6.EntityColumn({
                name: 'dt_lu',
                type: 'datetime',
                flags: $4H7ea.CommonFlags.Edit
            }),
            vc_webinsuser: new $ZmuZ6.EntityColumn({
                name: 'vc_webinsuser',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit
            }),
            vc_webluuser: new $ZmuZ6.EntityColumn({
                name: 'vc_webluuser',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.EntityColumnFlags.None
            }),
            vc_insuser: new $ZmuZ6.EntityColumn({
                name: 'vc_insuser',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.EntityColumnFlags.None
            }),
            vc_luuser: new $ZmuZ6.EntityColumn({
                name: 'vc_luuser',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.EntityColumnFlags.None
            })
        });
});
$305cacda61daafb0$var$parcelRegister("ZmuZ6", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "checkAdmittedValue", function() {
        return $01c33eeee71c7f0e$export$e61018c670503e50;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityColumn", function() {
        return $01c33eeee71c7f0e$export$d1c14f85c69b6bb1;
    });
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    function $01c33eeee71c7f0e$export$e61018c670503e50(col, value, throwException = false) {
        let ret = false;
        if ([
            'char',
            'nchar',
            'varchar',
            'nvarchar',
            'text',
            'ntext'
        ].includes(col.type)) {
            if (typeof value !== "string" || !col.hasFlag($4H7ea.EntityColumnFlags.nullable) && value === null) ret = false;
            else ret = true;
        }
        if ([
            'int',
            'bigint',
            'float',
            'decimal',
            'real',
            'money'
        ].includes(col.type)) {
            if (typeof value !== "number" || !col.hasFlag($4H7ea.EntityColumnFlags.nullable) && value === null) ret = false;
            else ret = true;
        }
        if ([
            'datetime',
            'date'
        ].includes(col.type)) {
            if (typeof value !== typeof Date || !col.hasFlag($4H7ea.EntityColumnFlags.nullable) && value === null) ret = false;
            else ret = true;
        }
        if (col.type === "bit") {
            if (typeof value !== typeof Boolean || !col.hasFlag($4H7ea.EntityColumnFlags.nullable) && value === null) ret = false;
            else ret = true;
        }
        if (throwException) throw new Error(`Invalid value for ${col.name}. Column type is ${col.type} and nullable is ${col.hasFlag($4H7ea.EntityColumnFlags.nullable)} and value is ${value}`);
        return ret;
    }
    class $01c33eeee71c7f0e$export$d1c14f85c69b6bb1 {
        constructor({ name: name, type: type, length: length, scale: scale, value: value, defaultValue: defaultValue, flags: flags, prompt: prompt, placeholder: placeholder, description: description, isArray: isArray, excludeInAutoForm: excludeInAutoForm, valueDescription: valueDescription }){
            this._value = null;
            this._defaultValue = null;
            this.name = name;
            this.type = type;
            this.length = length ? parseInt(length.toFixed()) : 0;
            this.scale = scale ? parseInt(scale.toFixed()) : 0;
            this.defaultValue = defaultValue ? defaultValue : null;
            this.value = value ? value : this.defaultValue;
            this.flags = flags;
            this.prompt = prompt ? prompt : '';
            this.placeholder = placeholder ?? '';
            this.description = description ?? '';
            this.isArray = isArray ?? false;
            this.excludeInAutoForm = excludeInAutoForm ?? false;
            this._valueDescription = valueDescription;
        }
        get value() {
            return this._value;
        }
        set value(newValue) {
            $01c33eeee71c7f0e$export$e61018c670503e50(this, newValue);
            const oldValue = this._value;
            if (newValue !== oldValue) this._value = newValue;
        }
        get defaultValue() {
            return this._defaultValue;
        }
        set defaultValue(newValue) {
            $01c33eeee71c7f0e$export$e61018c670503e50(this, newValue);
            this._defaultValue = newValue;
        }
        get valueDescription() {
            return this._valueDescription;
        }
        set valueDescription(newValue) {
            this._valueDescription = newValue;
        }
        hasFlag(flagOption) {
            return (this.flags & flagOption) === flagOption;
        }
        hasAnyFlag(combinedFlags) {
            return (this.flags & combinedFlags) !== 0;
        }
        static clone(source) {
            return new $01c33eeee71c7f0e$export$d1c14f85c69b6bb1({
                name: source.name,
                type: source.type,
                length: source.length,
                scale: source.scale,
                value: source.value,
                defaultValue: source.defaultValue,
                flags: source.flags,
                prompt: source.prompt,
                placeholder: source.placeholder,
                description: source.description,
                isArray: source.isArray,
                excludeInAutoForm: source.excludeInAutoForm,
                valueDescription: source.valueDescription
            });
        }
    }
});
$305cacda61daafb0$var$parcelRegister("4H7ea", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityColumnFlags", function() {
        return $b643b9c87f6cecfe$export$8844bfa172cebd97;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CommonFlags", function() {
        return $b643b9c87f6cecfe$export$7d52489126ff5018;
    });
    var $b643b9c87f6cecfe$export$8844bfa172cebd97 = /*#__PURE__*/ function(EntityColumnFlags) {
        /** This flag indicates that this column is NOT sent as parameter to any API endpoint */ EntityColumnFlags[EntityColumnFlags["None"] = 0] = "None";
        /**Flag: get. This column will be sent as parameter for the GET API endpoint */ EntityColumnFlags[EntityColumnFlags["get"] = 1] = "get";
        /**Flag: add. This column will be sent as parameter for the ADD API endpoint */ EntityColumnFlags[EntityColumnFlags["add"] = 2] = "add";
        /**Flag: edit. This column will be sent as parameter for the EDIT API endpoint */ EntityColumnFlags[EntityColumnFlags["edit"] = 4] = "edit";
        /**Flag: delete. This column will be sent as parameter for the DELETE API endpoint */ EntityColumnFlags[EntityColumnFlags["delete"] = 8] = "delete";
        /**Flag: pk. This column is part of the PRIMARY KEY and will be sent as parameter for any API endpoint that requires a key */ EntityColumnFlags[EntityColumnFlags["pk"] = 16] = "pk";
        /**Flag: fk. This column is part of a FOREIGN KEY and will be sent as parameter for any API endpoint that requires a PARENT KEYS */ EntityColumnFlags[EntityColumnFlags["fk"] = 32] = "fk";
        /**Flag: autoNum. This column will have an incremental number assigned to it as result of calling the ADD API */ EntityColumnFlags[EntityColumnFlags["autoNum"] = 64] = "autoNum";
        /**Flag: nullable. This column accpets NULL values at the SQL table level */ EntityColumnFlags[EntityColumnFlags["nullable"] = 128] = "nullable";
        /**Flag: nullable. This column is not part of the physical entity, it may be used as a calculated value or embedded value from other entity */ EntityColumnFlags[EntityColumnFlags["fake"] = 256] = "fake";
        return EntityColumnFlags;
    }({});
    const $b643b9c87f6cecfe$export$7d52489126ff5018 = {
        PK: 31,
        PKAutonum: 95,
        FK: 47,
        Edit: 15
    };
});
$305cacda61daafb0$var$parcelRegister("eRkDL", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "hasValue", function() {
        return $0f9c05d28d910e58$export$96bdbc84526f3739;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "convertValueFromString", function() {
        return $0f9c05d28d910e58$export$fa0058c4f1acdbdf;
    });
    function $0f9c05d28d910e58$export$96bdbc84526f3739(value) {
        return value !== '' && value !== null && typeof value !== 'undefined';
    }
    function $0f9c05d28d910e58$export$fa0058c4f1acdbdf(col, value) {
        if ([
            'float',
            'decimal',
            'real',
            'money',
            'smallmoney'
        ].includes(col.type)) return parseFloat(value);
        if ([
            'datetime',
            'date'
        ].includes(col.type)) return new Date(value);
        if (col.type === "bit") return value === 'true';
        if ([
            'int',
            'bigint'
        ].includes(col.type)) return parseInt(value);
        if ([
            'char',
            'nchar',
            'varchar',
            'nvarchar',
            'text',
            'ntext'
        ].includes(col.type) && col.isArray) return JSON.parse(value);
        return value;
    }
});
$305cacda61daafb0$var$parcelRegister("bFPBM", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "Entity", function() {
        return $25d98cad8f492c11$export$bc644a473284d944;
    });
    var $dR9Si = $305cacda61daafb0$var$parcelRequire("dR9Si");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    class $25d98cad8f492c11$export$bc644a473284d944 {
        #def;
        get name() {
            return this.#def.name;
        }
        get def() {
            return this.#def;
        }
        constructor(client, def, parentKeys = {}){
            this.#def = def;
            this.parentKeys = parentKeys;
            this.API = new $dR9Si.EntityAPI(client, this.#def.name, this.#def.columns);
            this.Form = null;
            this.Title = this.def.name;
        }
        static clone(entity) {
            const new_def = (0, $5Sq1V.EntityDefinition).clone(entity.def);
            const new_parentkeys = {};
            for(const key in entity.parentKeys){
                const source = entity.parentKeys[key];
                // MMC: you may have a null value as column in parentKeys, so we need to check for it.
                if (source) new_parentkeys[key] = source;
            }
            const new_entity = new $25d98cad8f492c11$export$bc644a473284d944(entity.API.client, new_def, new_parentkeys);
            new_entity.Form = entity.Form;
            new_entity.Title = entity.Title;
            new_entity.HelpText = entity.HelpText;
            new_entity.Icon = entity.Icon;
            return new_entity;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("dR9Si", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityAPI", function() {
        return $c7b536641e108181$export$c4faa8385b1edb2;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $dU7Zq = $305cacda61daafb0$var$parcelRequire("dU7Zq");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    class $c7b536641e108181$export$c4faa8385b1edb2 {
        #name;
        #columns;
        constructor(client, name, columns){
            if (!(client instanceof $dU7Zq.MicroMClient)) throw new Error('Invalid API client.');
            this.client = client;
            this.#columns = columns;
            this.#name = name;
        }
        /**
     * Get the data for the current row and fill the columns values with it.
     */ async getData(abort_signal = null) {
            const values = $iKzSR.getValues(this.#columns, {
                flags: $4H7ea.EntityColumnFlags.get,
                ignoreDefaults: false
            });
            const result = await this.client.get(this.#name, null, values, abort_signal);
            if (result === null) return false;
            $iKzSR.setValues(this.#columns, result, undefined, undefined, undefined, true);
            return true;
        }
        /**
     * Add the data for the current row and fill the key columns values with the returned auto-numeric (if any).
     */ async addData(abort_signal = null, recordsSelection, ignoreRecordExists) {
            const values = $iKzSR.getValues(this.#columns, {
                flags: $4H7ea.EntityColumnFlags.add,
                ignoreDefaults: false
            });
            const result = await this.client.insert(this.#name, null, values, recordsSelection ?? [], abort_signal);
            if (result.Failed) {
                if (!ignoreRecordExists) throw {
                    Errors: result.Results
                };
                else {
                    // check to see in results if all errors are record exists (status 4). If not, throw the error.
                    if (result.Results.some((r)=>r.Status !== 4 && r.Status !== 0 && r.Status !== 15)) throw {
                        Errors: result.Results
                    };
                    //ignore the error and return the result.
                    result.Failed = false;
                }
            }
            if (result.AutonumReturned) {
                if (result.Results[0].Status !== 15) throw {
                    Errors: result.Results,
                    message: "Unexpected Autonum Status"
                };
                const autoNumCol = $iKzSR.getColumns(this.#columns, {
                    flags: $4H7ea.EntityColumnFlags.autoNum,
                    ignoreDefaults: false
                })[0];
                autoNumCol.value = result.Results[0].Message;
            }
            return result;
        }
        /**
     * Edits the data for the current row.
     */ async editData(abort_signal = null, recordsSelection) {
            const values = $iKzSR.getValues(this.#columns, {
                flags: $4H7ea.EntityColumnFlags.edit,
                ignoreDefaults: false
            });
            const result = await this.client.update(this.#name, null, values, recordsSelection ?? [], abort_signal);
            if (result.Failed) throw {
                Errors: result.Results
            };
            return result;
        }
        /**
     * Deletes the data for the current row.
     */ async deleteData(recordsSelection, abort_signal = null, parentKeys = null) {
            let result;
            if (!recordsSelection) {
                const values = $iKzSR.getValues(this.#columns, {
                    flags: $4H7ea.EntityColumnFlags.delete,
                    ignoreDefaults: false
                });
                result = await this.client.delete(this.#name, parentKeys, values, [], abort_signal);
            } else result = await this.client.delete(this.#name, parentKeys, {}, recordsSelection, abort_signal);
            if (result.Failed) throw {
                Errors: result.Results
            };
            return result;
        }
        /**
     * Lookup the description for an entity.
     */ async lookupData(abort_signal = null) {
            const values = $iKzSR.getValues(this.#columns, {
                flags: $4H7ea.EntityColumnFlags.pk | $4H7ea.EntityColumnFlags.fk,
                ignoreDefaults: false
            });
            const result = await this.client.lookup(this.#name, null, values, null, abort_signal);
            return result.Description;
        }
        /**
     * Import data
     */ async importData(abort_signal = null, import_procname = null, parentKeys = null, fileprocess_id) {
            const values = {
                c_fileprocess_id: fileprocess_id
            };
            const result = await this.client.import(this.#name, parentKeys, values, import_procname, abort_signal);
            return result;
        }
        async executeView(view, view_parms, limit, search, abort_signal = null) {
            if (search) search = search.map((s)=>s.indexOf('%') >= 0 ? s : `%${s}%`);
            if (!limit) limit = "";
            $iKzSR.setValues(this.#columns, view_parms, null, true);
            let values = $iKzSR.getValues(this.#columns, null);
            values['@row_limit'] = limit;
            values.like = search ? search : null;
            if (view_parms) values = {
                ...view_parms,
                ...values
            };
            const result = await this.client.view(this.#name, null, values, view.name, abort_signal);
            return result;
        }
        downloadBlobFile(blob, filename) {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
        async exportView(view, view_parms, limit, search, abort_signal = null) {
            if (search) search = search.map((s)=>s.indexOf('%') >= 0 ? s : `%${s}%`);
            if (!limit) limit = "";
            $iKzSR.setValues(this.#columns, view_parms, null, true);
            let values = $iKzSR.getValues(this.#columns, null);
            values['@row_limit'] = limit;
            values.like = search ? search : null;
            if (view_parms) values = {
                ...view_parms,
                ...values
            };
            const result = await this.client.viewtoexcel(this.#name, null, values, view.name, abort_signal);
            return result;
        }
        async exportProc(proc, proc_parms, abort_signal = null, recordsSelection) {
            $iKzSR.setValues(this.#columns, proc_parms, null, true);
            const values = {
                ...proc_parms,
                ...$iKzSR.getValues(this.#columns, null)
            };
            const result = await this.client.proctoexcel(this.#name, null, values, recordsSelection ?? [], proc.name, abort_signal);
            return result;
        }
        async executeProc(proc, proc_parms, abort_signal = null, recordsSelection) {
            $iKzSR.setValues(this.#columns, proc_parms, null, true);
            const values = {
                ...proc_parms,
                ...$iKzSR.getValues(this.#columns, null)
            };
            const result = await this.client.proc(this.#name, null, values, recordsSelection ?? [], proc.name, abort_signal);
            return result;
        }
        async executeProcess(proc, proc_parms, abort_signal = null, recordsSelection) {
            $iKzSR.setValues(this.#columns, proc_parms, null, true);
            const values = {
                ...proc_parms,
                ...$iKzSR.getValues(this.#columns, null)
            };
            const result = await this.client.process(this.#name, null, values, recordsSelection ?? [], proc.name, abort_signal);
            return result;
        }
        async executeServerAction(action, action_parms, abort_signal = null) {
            $iKzSR.setValues(this.#columns, action_parms);
            const values = $iKzSR.getValues(this.#columns, null);
            const result = await this.client.action(this.#name, null, values, action.name, abort_signal);
            return result;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("5Sq1V", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityDefinition", function() {
        return $9bb641eb263a1f07$export$3f1f0ed417cc9c63;
    });
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    class $9bb641eb263a1f07$export$3f1f0ed417cc9c63 {
        standardView() {
            let result = null;
            for(const v in this.views)if (v.toLowerCase().endsWith('brwstandard')) result = v;
            return result;
        }
        constructor(name){
            this.columns = {};
            this.procs = {};
            this.views = {};
            this.lookups = {};
            this.serverActions = {};
            this.clientActions = {};
            this.importColumns = null;
            if (typeof name !== 'string' || name.length === 0) throw new Error('Invalid entity name.');
            this.name = name;
        }
        addCol({ name: name, type: type, length: length, scale: scale, value: value, defaultValue: defaultValue, flags: flags, prompt: prompt }) {
            const col = new $ZmuZ6.EntityColumn({
                name: name,
                type: type,
                length: length,
                scale: scale,
                value: value,
                defaultValue: defaultValue,
                flags: flags,
                prompt: prompt
            });
            this.columns[col.name] = col;
            return col;
        }
        addView(view) {
            this.views[view.name] = view;
            return view;
        }
        addProc(proc) {
            this.procs[proc.name] = proc;
            return proc;
        }
        addLookup(lookup) {
            this.lookups[lookup.name] = lookup;
            return lookup;
        }
        addServerAction(action) {
            this.serverActions[action.name] = action;
            return action;
        }
        addClientAction(action) {
            this.clientActions[action.name] = action;
            return action;
        }
        static clone(entity_def) {
            const columns = {};
            for(const colname in entity_def.columns){
                const source = entity_def.columns[colname];
                columns[colname] = (0, $ZmuZ6.EntityColumn).clone(source);
            }
            const processes = {};
            for(const proc in entity_def.procs){
                const source = entity_def.procs[proc];
                processes[proc] = {
                    name: source.name
                };
            }
            const views = {};
            for(const view in entity_def.views){
                const source = entity_def.views[view];
                views[view] = {
                    ...source
                };
            }
            const lookups = {};
            for(const lkp in entity_def.lookups){
                const source = entity_def.lookups[lkp];
                lookups[lkp] = {
                    ...source
                };
            }
            const serverActions = {};
            for(const act in entity_def.serverActions){
                const source = entity_def.serverActions[act];
                serverActions[act] = {
                    ...source
                };
            }
            const clientActions = {};
            for(const act in entity_def.clientActions){
                const source = entity_def.clientActions[act];
                clientActions[act] = source;
            }
            const new_def = new $9bb641eb263a1f07$export$3f1f0ed417cc9c63(entity_def.name);
            new_def.columns = columns;
            new_def.procs = processes;
            new_def.views = views;
            new_def.lookups = lookups;
            new_def.serverActions = serverActions;
            new_def.clientActions = clientActions;
            new_def.importColumns = entity_def.importColumns ? [
                ...entity_def.importColumns
            ] : null;
            return new_def;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("5vYDZ", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("9M0Li", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("h4O7Z", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("e12RS", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("kY0Yt", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("kalnk", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("7T941", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "toCamelCase", function() {
        return $a29e5ad2821bc34e$export$86f54f62aa7a7514;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "convertRecordToValuesObject", function() {
        return $a29e5ad2821bc34e$export$5caa474abdb62a99;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "convertRecordsToArrayOfValuesObject", function() {
        return $a29e5ad2821bc34e$export$bd5f152ac46f6376;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "mapRecordToType", function() {
        return $a29e5ad2821bc34e$export$c7f39facb44b7cd1;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "mapDataResultToType", function() {
        return $a29e5ad2821bc34e$export$713b0df7740fcd37;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "exportToCSV", function() {
        return $a29e5ad2821bc34e$export$60d51d3f7c4f92d8;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "exportToExcel", function() {
        return $a29e5ad2821bc34e$export$a04f965200623e61;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "extractArrayFromSelectedRecords", function() {
        return $a29e5ad2821bc34e$export$80885f6f0cd6803f;
    });
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    function $a29e5ad2821bc34e$export$86f54f62aa7a7514(str) {
        return str // Replace spaces, accents, or '.' followed by any character with the uppercase version of the character
        .replace(/[\s.\u00C0-\u00FF]+(.)/g, (m, chr)=>chr.toUpperCase()) // Ensure the first character is lowercase
        .replace(/^./, (m)=>m.toLowerCase());
    }
    function $a29e5ad2821bc34e$export$5caa474abdb62a99(record, headers, typeInfo, formatToString) {
        const recordObject = {};
        headers.forEach((header, index)=>{
            recordObject[header] = formatToString ? formatToString(record[index], typeInfo[index]) : record[index];
        });
        return recordObject;
    }
    function $a29e5ad2821bc34e$export$bd5f152ac46f6376(dataResult, nameTransformFunction = $a29e5ad2821bc34e$export$86f54f62aa7a7514, formatToString) {
        const headers = nameTransformFunction ? dataResult.Header.map(nameTransformFunction) : dataResult.Header; // transform header names
        return dataResult.records.map((record)=>$a29e5ad2821bc34e$export$5caa474abdb62a99(record, headers, dataResult.typeInfo, formatToString));
    }
    function $a29e5ad2821bc34e$export$c7f39facb44b7cd1(record, headers, enforceObjectKeys, mapping_behavior, map_properties = null, skipUndefinedOrNull = false) {
        const mappedRecord = {};
        headers.forEach((header, index)=>{
            const valueExists = index < record.length;
            const mappedKey = map_properties ? map_properties[header] : header;
            if ((valueExists || mapping_behavior === 'lax') && mappedKey !== undefined) {
                const value = valueExists ? record[index] : undefined;
                if (skipUndefinedOrNull && (value === undefined || value === null)) return;
                mappedRecord[mappedKey] = value;
            } else if (mapping_behavior === 'enforceObject' && !enforceObjectKeys.has(header)) throw new Error(`Key ${header} from record is missing in object T`);
        });
        return mappedRecord;
    }
    function $a29e5ad2821bc34e$export$713b0df7740fcd37(dataResult, mapping_behavior, nameTransformFunction = $a29e5ad2821bc34e$export$86f54f62aa7a7514, map_properties = null, skipUndefinedOrNull = false) {
        const headers = nameTransformFunction ? dataResult.Header.map(nameTransformFunction) : dataResult.Header; // transform header names
        const headersSet = new Set(headers);
        const objectKeys = (0, $iKzSR.namesOf)();
        const enforceObjectKeysSet = new Set(Object.keys(objectKeys));
        // Perform checks before mapping
        if (mapping_behavior === 'enforceDataResult' || mapping_behavior === 'exactMatch') {
            const missingInT = headers.filter((header)=>!enforceObjectKeysSet.has(header));
            if (missingInT.length > 0) throw new Error(`Some DataResult headers are not present in object T. Missing headers: ${missingInT.join(', ')}`);
        }
        if (mapping_behavior === 'exactMatch') {
            const missingInHeaders = Array.from(enforceObjectKeysSet).filter((key)=>!headersSet.has(key));
            if (missingInHeaders.length > 0) throw new Error(`Some object T keys are not present in DataResult headers. Missing keys: ${missingInHeaders.join(', ')}`);
        }
        // Map each record
        return dataResult.records.map((record)=>$a29e5ad2821bc34e$export$c7f39facb44b7cd1(record, headers, enforceObjectKeysSet, mapping_behavior, map_properties, skipUndefinedOrNull));
    }
    function $a29e5ad2821bc34e$export$60d51d3f7c4f92d8(viewResult, notExportableColumns) {
        if (!viewResult.Header.length) return;
        const columns = viewResult.Header;
        const rows = viewResult.records;
        const fechaActual = new Date();
        const filename = `export-${fechaActual.getFullYear()}${(fechaActual.getDate() + '').padStart(2, '0')}${(fechaActual.getMonth() + 1 + '').padStart(2, '0')}_${(fechaActual.getHours() + '').padStart(2, '0')}${(fechaActual.getMinutes() + '').padStart(2, '0')}${(fechaActual.getSeconds() + '').padStart(2, '0')}.csv`;
        const row_sep = '\r\n';
        const col_sep = ';';
        let csv_data = '';
        // MMC: csv headers
        for(let r = 0; r < columns.length; r++){
            // MMC: check if notExportableColumns is defined and if the column is not exportable
            if (notExportableColumns && notExportableColumns.includes(r)) continue;
            csv_data += '"' + columns[r].replace(/"/g, '""') + '"' + col_sep;
        }
        csv_data += row_sep;
        for(let r = 0; r < rows.length; r++){
            for(let c = 0; c < columns.length; c++){
                if (notExportableColumns && notExportableColumns.includes(c)) continue;
                const col_data = rows[r][c];
                if (typeof col_data === 'string' || col_data instanceof String) col_data.replace(/"/g, '""');
                csv_data += '"' + col_data + '"' + col_sep;
            }
            csv_data += row_sep;
        }
        // MMC: \ufeff = BOM for utf8. Without this excel won't open the file correctly
        csv_data = '\ufeff' + csv_data;
        // MMC: some security checks can cause an exception
        try {
            if (window.Blob && window.URL) {
                const blob = new Blob([
                    csv_data
                ], {
                    type: 'text/csv;charset=utf-8'
                });
                const csv_url = URL.createObjectURL(blob);
                const linkElement = document.createElement('a');
                linkElement.setAttribute('download', filename);
                linkElement.setAttribute('href', csv_url);
                linkElement.click();
                // MMC: cleanup
                document.body.removeChild(linkElement);
                URL.revokeObjectURL(csv_url);
            } else console.error("Your browser does not support exporting data.");
        } catch (ex) {
            console.error("exportToCSV", ex);
        }
    }
    async function $a29e5ad2821bc34e$export$a04f965200623e61(data, notExportableColumns, sheetNames) {
        // MMC: some security checks can cause an exception
        try {
            if (window.Blob && window.URL) {
                const currentDate = new Date();
                const filename = `export-${currentDate.getFullYear()}${(currentDate.getDate() + '').padStart(2, '0')}${(currentDate.getMonth() + 1 + '').padStart(2, '0')}_${(currentDate.getHours() + '').padStart(2, '0')}${(currentDate.getMinutes() + '').padStart(2, '0')}${(currentDate.getSeconds() + '').padStart(2, '0')}.xlsx`;
                const workbook = new ($305cacda61daafb0$var$$parcel$interopDefault($j4US1)).Workbook();
                data.forEach((result, index)=>{
                    const worksheet = workbook.addWorksheet(sheetNames ? sheetNames[index] : `Data ${index + 1}`);
                    const exportableColumnsConfig = [];
                    result.Header.forEach((header, colIndex)=>{
                        if (!notExportableColumns?.includes(colIndex)) exportableColumnsConfig.push({
                            header: header,
                            key: header,
                            originalIndex: colIndex
                        });
                    });
                    worksheet.columns = exportableColumnsConfig.map((col)=>({
                            header: col.header,
                            key: col.key
                        }));
                    exportableColumnsConfig.forEach((colInfo)=>{
                        const originalColIndex = colInfo.originalIndex;
                        const columnType = result.typeInfo[originalColIndex];
                        const column = worksheet.getColumn(colInfo.key);
                        if (column) switch(columnType){
                            case 'tinyint':
                            case 'smallint':
                            case 'int':
                            case 'bigint':
                                column.numFmt = '0';
                                break;
                            case 'float':
                            case 'decimal':
                            case 'real':
                                column.numFmt = '#,##0.00';
                                break;
                            case 'money':
                                column.numFmt = '$#,##0.00';
                                break;
                            case 'bit':
                                column.numFmt = '0';
                                break;
                            case 'date':
                                column.numFmt = 'yyyy-mm-dd';
                                break;
                            case 'datetime':
                            case 'datetime2':
                            case 'smalldatetime':
                                column.numFmt = 'yyyy-mm-dd hh:mm:ss';
                                break;
                            case 'time':
                                column.numFmt = 'hh:mm:ss';
                                break;
                        }
                    });
                    result.records.forEach((row)=>{
                        const rowForExcel = {};
                        exportableColumnsConfig.forEach((colInfo)=>{
                            const originalValue = row[colInfo.originalIndex];
                            let processedValue = originalValue;
                            const columnType = result.typeInfo[colInfo.originalIndex];
                            if (processedValue !== null) switch(columnType){
                                case 'date':
                                case 'datetime':
                                case 'datetime2':
                                case 'smalldatetime':
                                case 'time':
                                    if (typeof processedValue === 'string') try {
                                        const dateObj = new Date(processedValue);
                                        if (!isNaN(dateObj.getTime())) processedValue = dateObj;
                                        else console.warn(`Invalid date string "${processedValue}" for column "${colInfo.header}". Keeping as string.`);
                                    } catch (e) {
                                        console.error(`Error parsing date string "${processedValue}" for column "${colInfo.header}":`, e);
                                    }
                                    break;
                                case 'bit':
                                    if (processedValue === 0) processedValue = false;
                                    else if (processedValue === 1) processedValue = true;
                                    break;
                            }
                            rowForExcel[colInfo.key] = processedValue;
                        });
                        worksheet.addRow(rowForExcel);
                    });
                });
                const buffer = await workbook.xlsx.writeBuffer({
                    useStyles: true
                });
                const blob = new Blob([
                    buffer
                ], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            } else console.error("Your browser does not support exporting data.");
        } catch (ex) {
            console.error("exportToExcel", ex);
        }
    }
    function $a29e5ad2821bc34e$export$80885f6f0cd6803f(selectedKeys, property) {
        return selectedKeys.map((item)=>item[property]);
    }
});
$305cacda61daafb0$var$parcelRegister("9dFnv", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isInstanceOfEntityColumn", function() {
        return $ff0229238bff77e7$export$aa8be7a0fce06f9d;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isViewMapping", function() {
        return $ff0229238bff77e7$export$6c0c5d5a180781be;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isEntityLookup", function() {
        return $ff0229238bff77e7$export$1e992583465cbafe;
    });
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    function $ff0229238bff77e7$export$aa8be7a0fce06f9d(obj) {
        return obj instanceof $ZmuZ6.EntityColumn;
    }
    function $ff0229238bff77e7$export$6c0c5d5a180781be(obj) {
        return typeof obj === "object" && obj !== null && typeof obj.keyIndex === "number" && typeof obj.descriptionIndex === "number";
    }
    function $ff0229238bff77e7$export$1e992583465cbafe(obj) {
        // Basic checks for required properties
        const hasBasicProps = typeof obj === "object" && obj !== null && typeof obj.name === "string" && typeof obj.entityConstructor === "function";
        // Optional properties
        const hasView = !obj || typeof obj.view === "string";
        const hasProc = !obj || typeof obj.proc === "string";
        const hasBindingColumnKey = !obj || typeof obj.bindingColumnKey === "string";
        const hasViewMapping = !obj || $ff0229238bff77e7$export$6c0c5d5a180781be(obj.viewMapping);
        return hasBasicProps && hasView && hasProc && hasBindingColumnKey && hasViewMapping;
    }
});
$305cacda61daafb0$var$parcelRegister("TaFFV", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getRequiredColumns", function() {
        return $87ad5576b75db60e$export$7e6426929f227679;
    });
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    function $87ad5576b75db60e$export$7e6426929f227679(entity) {
        if (!entity) return [];
        return Object.values(entity.def.columns).filter((col)=>!col.hasFlag($4H7ea.EntityColumnFlags.nullable) && !col.hasFlag($4H7ea.EntityColumnFlags.autoNum) && !(0, $bmxG4.DefaultColumnsNames).includes(col.name)).map((col)=>col.name);
    }
});
$305cacda61daafb0$var$parcelRegister("5vnOT", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getDictionaryByColumnName", function() {
        return $3486445f405aa87a$export$9874c99f514b35cf;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getDictionaryByPropertyName", function() {
        return $3486445f405aa87a$export$51488c9e58f7a431;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "mapToRecordSelection", function() {
        return $3486445f405aa87a$export$f458d0b1192fccba;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ColumnsMapper", function() {
        return $3486445f405aa87a$export$a333b91d5f4a5e74;
    });
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    function $3486445f405aa87a$export$9874c99f514b35cf(map) {
        const dictionary = {};
        map.forEach((record)=>{
            dictionary[record.columnName] = record.propertyName;
        });
        return dictionary;
    }
    function $3486445f405aa87a$export$51488c9e58f7a431(map) {
        const dictionary = {};
        map.forEach((record)=>{
            dictionary[record.propertyName] = record.columnName;
        });
        return dictionary;
    }
    function $3486445f405aa87a$export$f458d0b1192fccba(values, propertiesMapDictionary) {
        const result = [];
        const valueNames = Object.keys(propertiesMapDictionary);
        const columnNames = valueNames.map((valueName)=>propertiesMapDictionary[valueName]);
        const valuesLength = values.length;
        const valueNamesLength = valueNames.length;
        for(let i = 0; i < valuesLength; i++){
            const value = values[i];
            const selectedRecord = {};
            for(let j = 0; j < valueNamesLength; j++)selectedRecord[columnNames[j]] = value[valueNames[j]];
            result.push(selectedRecord);
        }
        return result;
    }
    class $3486445f405aa87a$export$a333b91d5f4a5e74 {
        #records;
        #columnsDictionary;
        #propertiesDictionary;
        #columnKeys;
        #valueKeys;
        constructor(entity, values, records){
            this.#columnsDictionary = {};
            this.#propertiesDictionary = {};
            this.columnsDictionary = this.#columnsDictionary ??= this.#getDictionaryByColumnName();
            this.valuesDictionary = this.#propertiesDictionary ??= this.#getDictionaryByPropertyName();
            // check if columnNames exists in entity.def.columns
            records.forEach((record)=>{
                if (!entity.def.columns[record.columnName]) throw new Error(`Invalid column map (col: '${record.columnName}'): Column '${record.columnName}' in  not found.`);
            });
            // check if propertyNames exists in values
            records.forEach((record)=>{
                if (!values[record.propertyName]) throw new Error(`Invalid value map (value: '${record.propertyName}'): Value '${record.propertyName}' in  not found.`);
            });
            this.#records = records;
            this.#columnKeys = new Set(Object.keys(entity.def.columns));
            this.#valueKeys = new Set(Object.keys(values));
        }
        #getDictionaryByColumnName() {
            const dictionary = {};
            this.#records.forEach((record)=>{
                dictionary[record.columnName] = record.propertyName;
            });
            return dictionary;
        }
        #getDictionaryByPropertyName() {
            const dictionary = {};
            this.#records.forEach((record)=>{
                dictionary[record.propertyName] = record.columnName;
            });
            return dictionary;
        }
        mapValuesToColumns(columns, values, ignoreInvalidMappings = false, ignoreInexistentValues = true) {
            for(const valueName in values){
                const columnName = this.valuesDictionary[valueName];
                if (!columnName) {
                    if (!ignoreInexistentValues) throw new Error(`Invalid value map (value: '${valueName}'): is not mapped.`);
                    continue;
                }
                const column = columns[columnName];
                if (!column && !ignoreInvalidMappings) throw new Error(`Invalid value map (value: '${valueName}', col: '${columnName}'): Column '${columnName}' in  not found.`);
                (0, $iKzSR.setSourceValue)(columnName, values[valueName], columns, ignoreInvalidMappings, true, false);
            }
        }
        mapColumnsToValues(columns, ignoreInvalidMappings = false, ignoreInexistentValues = true) {
            const values = {};
            for(const columnName in columns){
                const valueName = this.columnsDictionary[columnName];
                if (!valueName) {
                    if (!ignoreInexistentValues) throw new Error(`Invalid column map (col: '${columnName}'): is not mapped.`);
                    continue;
                }
                const value = values[valueName];
                if (!value && !ignoreInvalidMappings) throw new Error(`Invalid value map (col: '${columnName}', value: '${valueName}'): Value '${valueName}' in  not found.`);
                values[valueName] = columns[columnName].value;
            }
            return values;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("hkmnY", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("vXZlt", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getMantineInitialDirty", function() {
        return $311a427246b4e118$export$620d51b2ff53d7d9;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getMantineValuesObject", function() {
        return $311a427246b4e118$export$641e158efcd6f8e0;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getMantineInitialValuesObject", function() {
        return $311a427246b4e118$export$b8b825ad46c26a3d;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    function $311a427246b4e118$export$620d51b2ff53d7d9(columns, exclude_system_columns) {
        const i = {};
        Object.entries(columns).forEach(([key, column])=>{
            if (exclude_system_columns && (0, $bmxG4.DefaultColumnsNames).includes(key)) return;
            i[key] = column.value !== '' || column.value !== null || column.value !== undefined ? true : false;
        });
        return i;
    }
    function $311a427246b4e118$export$641e158efcd6f8e0(formValues, columns, exclude_system_columns) {
        const i = {};
        const formColumnNames = Object.keys(formValues);
        Object.entries(columns).forEach(([key, column])=>{
            if (exclude_system_columns && (0, $bmxG4.DefaultColumnsNames).includes(key)) return;
            // MMC: just set the values for the binded columns
            if (formColumnNames.includes(key)) i[key] = column.value ?? '';
        });
        return i;
    }
    function $311a427246b4e118$export$b8b825ad46c26a3d(columns, columnNames) {
        const i = {};
        if (!columnNames || columnNames.length === 0) return i;
        Object.entries(columns).forEach(([key, column])=>{
            if (columnNames.includes(key)) i[key] = column.value ?? '';
        });
        return i;
    }
});
$305cacda61daafb0$var$parcelRegister("bHLhd", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityFormDefaultProps", function() {
        return $6d150b07756690a5$export$1c1b666b210bfb32;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityForm", function() {
        return $6d150b07756690a5$export$6d892edbc3527d79;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $lTSno = $305cacda61daafb0$var$parcelRequire("lTSno");
    const $6d150b07756690a5$export$1c1b666b210bfb32 = {
        showOK: true,
        showCancel: true,
        showFormValidationNotification: true,
        showLoadingProgress: true,
        showErrors: true,
        OKText: "Save",
        CancelText: "Cancel",
        CloseText: "Close",
        invalidFieldsLabel: "Some fields are invalid, please review the form",
        showHelpButton: false,
        preventEnterSubmission: true,
        isDirtyColor: 'green',
        cancelButtonVariant: 'light',
        okButtonVariant: 'filled'
    };
    function $6d150b07756690a5$export$6d892edbc3527d79(props) {
        const { formAPI: formAPI, children: children, showOK: showOK, showCancel: showCancel, showErrors: showErrors, showFormValidationNotification: showFormValidationNotification, showLoadingProgress: showLoadingProgress, OKText: OKText, CancelText: CancelText, invalidFieldsLabel: invalidFieldsLabel, showHelpButton: showHelpButton, preventEnterSubmission: preventEnterSubmission, CloseText: CloseText, buttons: buttons, isDirtyColor: isDirtyColor, cancelButtonVariant: cancelButtonVariant, okButtonVariant: okButtonVariant } = (0, $64A2P.useComponentDefaultProps)('EntityForm', $6d150b07756690a5$export$1c1b666b210bfb32, props);
        const { entity: entity } = formAPI;
        const theme = (0, $64A2P.useMantineTheme)();
        const { handleCancel: handleCancel, handleSubmit: handleSubmit, notifyValidationErrorState: notifyValidationErrorState, status: status, form: form, formMode: formMode, showDescriptionState: showDescriptionState, isFormValid: isFormValid, asyncErrors: asyncErrors } = formAPI;
        const [notifyValidationError, setNotifyValidationError] = notifyValidationErrorState;
        const [showDescription, setShowDescription] = showDescriptionState;
        // Closes the error notification when the form becomes valid
        (0, $acw62.useEffect)(()=>{
            if (isFormValid()) setNotifyValidationError(false);
        }, [
            isFormValid,
            setNotifyValidationError
        ]);
        const handleKeyDown = (0, $lTSno.usePreventEnterSubmission)();
        // MMC: FocusTrap is present here because the FocusTrap that uses breaks with children when is an array
        // and because when we edit/view the form, when performing get the fields are denied and can't be focused
        // be ware of queryStatus.loading === false as the initial queryStatus is {}, this is on purpose to avoid disabling the fields before loading data
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                showHelpButton && /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    mb: "xs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                        color: theme.primaryColor,
                        radius: "xl",
                        variant: "light",
                        onClick: ()=>setShowDescription((prev)=>!prev),
                        children: showDescription ? /*#__PURE__*/ (0, $ayMG0.jsx)($hMS14.default, {
                            size: "1.2rem"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($kytQ3.default, {
                            size: "1.2rem"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($D7Bq4.FocusTrap, {
                    active: status.loading === false,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        onSubmit: handleSubmit,
                        onKeyDown: preventEnterSubmission ? handleKeyDown : undefined,
                        onInvalid: ()=>setNotifyValidationError(true),
                        children: [
                            showLoadingProgress && status.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {
                                size: "xs"
                            }),
                            showLoadingProgress && !status.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($5iXv4.Space, {
                                h: "0.1875rem"
                            }),
                            showFormValidationNotification && notifyValidationError && /*#__PURE__*/ (0, $ayMG0.jsx)($e2mZf.Notification, {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                                    size: "1.1rem"
                                }),
                                color: "red",
                                onClose: ()=>setNotifyValidationError(false),
                                children: `${invalidFieldsLabel}: ${Object.keys({
                                    ...form.errors,
                                    ...asyncErrors
                                }).map((formKey)=>`[${entity.def.columns[formKey].prompt}]`).join(', ')}`
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("fieldset", {
                                disabled: status.loading,
                                style: {
                                    borderWidth: 0,
                                    margin: 0,
                                    padding: 0,
                                    minInlineSize: 'unset'
                                },
                                children: children
                            }),
                            showErrors && status.error && /*#__PURE__*/ (0, $ayMG0.jsxs)($d50o9.AlertError, {
                                mt: "md",
                                iconTooltip: `Code #${status.error.status}`,
                                children: [
                                    status.error.message,
                                    " ",
                                    status.error.statusMessage ?? ''
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                mt: "md",
                                children: [
                                    buttons,
                                    (showOK || showCancel) && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                        position: "right",
                                        style: {
                                            flex: 'auto'
                                        },
                                        children: [
                                            showCancel && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                                variant: cancelButtonVariant,
                                                leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($dRw7S.default, {
                                                    size: "1.125rem"
                                                }),
                                                onClick: handleCancel,
                                                children: formMode === 'view' ? CloseText : CancelText
                                            }),
                                            showOK && formMode != "view" && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                                variant: okButtonVariant,
                                                type: "submit",
                                                color: form.isDirty() ? isDirtyColor : theme.primaryColor,
                                                loading: status?.loading,
                                                leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($4Rwq2.default, {
                                                    size: "1.125rem"
                                                }),
                                                children: OKText
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("7xGLy", function(module1, exports) {
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $i6yJ4 = $305cacda61daafb0$var$parcelRequire("i6yJ4");
    var $gLcPf = $305cacda61daafb0$var$parcelRequire("gLcPf");
    var $3CwxR = $305cacda61daafb0$var$parcelRequire("3CwxR");
    var $2bGyU = $305cacda61daafb0$var$parcelRequire("2bGyU");
    var $iBHdb = $305cacda61daafb0$var$parcelRequire("iBHdb");
    var $d8SEg = $305cacda61daafb0$var$parcelRequire("d8SEg");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    var $hP010 = $305cacda61daafb0$var$parcelRequire("hP010");
    var $bFL3N = $305cacda61daafb0$var$parcelRequire("bFL3N");
    var $ciiuv = $305cacda61daafb0$var$parcelRequire("ciiuv");
    var $lB8CV = $305cacda61daafb0$var$parcelRequire("lB8CV");
    var $9DEaD = $305cacda61daafb0$var$parcelRequire("9DEaD");
    var $6TOP6 = $305cacda61daafb0$var$parcelRequire("6TOP6");
    var $bJhnF = $305cacda61daafb0$var$parcelRequire("bJhnF");
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    var $hv0CN = $305cacda61daafb0$var$parcelRequire("hv0CN");
    var $hxOxo = $305cacda61daafb0$var$parcelRequire("hxOxo");
    var $01mqs = $305cacda61daafb0$var$parcelRequire("01mqs");
    var $lULWw = $305cacda61daafb0$var$parcelRequire("lULWw");
    var $3HRFn = $305cacda61daafb0$var$parcelRequire("3HRFn");
    var $3Zdna = $305cacda61daafb0$var$parcelRequire("3Zdna");
    var $aOnQQ = $305cacda61daafb0$var$parcelRequire("aOnQQ");
    var $cnfVv = $305cacda61daafb0$var$parcelRequire("cnfVv");
    var $j7Y9b = $305cacda61daafb0$var$parcelRequire("j7Y9b");
    var $abmo4 = $305cacda61daafb0$var$parcelRequire("abmo4");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $fL9cC = $305cacda61daafb0$var$parcelRequire("fL9cC");
    var $4vdkC = $305cacda61daafb0$var$parcelRequire("4vdkC");
    var $g22qX = $305cacda61daafb0$var$parcelRequire("g22qX");
    var $khunK = $305cacda61daafb0$var$parcelRequire("khunK");
    var $jom6Y = $305cacda61daafb0$var$parcelRequire("jom6Y");
    var $jAbjP = $305cacda61daafb0$var$parcelRequire("jAbjP");
    var $6pUmH = $305cacda61daafb0$var$parcelRequire("6pUmH");
    var $9GCyf = $305cacda61daafb0$var$parcelRequire("9GCyf");
    var $k4b2f = $305cacda61daafb0$var$parcelRequire("k4b2f");
    var $fFu0M = $305cacda61daafb0$var$parcelRequire("fFu0M");
    var $6Tg0K = $305cacda61daafb0$var$parcelRequire("6Tg0K");
    var $1trwm = $305cacda61daafb0$var$parcelRequire("1trwm");
    var $1cuD1 = $305cacda61daafb0$var$parcelRequire("1cuD1");
    var $lTSno = $305cacda61daafb0$var$parcelRequire("lTSno");
    var $7ttm6 = $305cacda61daafb0$var$parcelRequire("7ttm6");
    var $a2vzY = $305cacda61daafb0$var$parcelRequire("a2vzY");
    var $1uAlg = $305cacda61daafb0$var$parcelRequire("1uAlg");
    var $4SevU = $305cacda61daafb0$var$parcelRequire("4SevU");
    var $gYKfx = $305cacda61daafb0$var$parcelRequire("gYKfx");
    var $iqamJ = $305cacda61daafb0$var$parcelRequire("iqamJ");
    var $OciKL = $305cacda61daafb0$var$parcelRequire("OciKL");
    var $lJoOP = $305cacda61daafb0$var$parcelRequire("lJoOP");
    var $i27OQ = $305cacda61daafb0$var$parcelRequire("i27OQ");
    var $9maeT = $305cacda61daafb0$var$parcelRequire("9maeT");
    var $7B1hX = $305cacda61daafb0$var$parcelRequire("7B1hX");
    var $ivqW2 = $305cacda61daafb0$var$parcelRequire("ivqW2");
    var $jckhB = $305cacda61daafb0$var$parcelRequire("jckhB");
    var $382l3 = $305cacda61daafb0$var$parcelRequire("382l3");
    var $izUR3 = $305cacda61daafb0$var$parcelRequire("izUR3");
    var $9HOzJ = $305cacda61daafb0$var$parcelRequire("9HOzJ");
    var $j7hNv = $305cacda61daafb0$var$parcelRequire("j7hNv");
    var $19BCV = $305cacda61daafb0$var$parcelRequire("19BCV");
    var $2hjBw = $305cacda61daafb0$var$parcelRequire("2hjBw");
    var $6J9V6 = $305cacda61daafb0$var$parcelRequire("6J9V6");
    var $g8F24 = $305cacda61daafb0$var$parcelRequire("g8F24");
    var $4ftBh = $305cacda61daafb0$var$parcelRequire("4ftBh");
    var $rMdN2 = $305cacda61daafb0$var$parcelRequire("rMdN2");
    var $cSyOF = $305cacda61daafb0$var$parcelRequire("cSyOF");
    var $jNUqj = $305cacda61daafb0$var$parcelRequire("jNUqj");
    var $8tnwL = $305cacda61daafb0$var$parcelRequire("8tnwL");
    var $8SZSR = $305cacda61daafb0$var$parcelRequire("8SZSR");
    var $lwxCY = $305cacda61daafb0$var$parcelRequire("lwxCY");
    var $4Hta3 = $305cacda61daafb0$var$parcelRequire("4Hta3");
    var $5Qlvf = $305cacda61daafb0$var$parcelRequire("5Qlvf");
    var $e6gIh = $305cacda61daafb0$var$parcelRequire("e6gIh");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $d50o9);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $i6yJ4);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $gLcPf);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $3CwxR);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2bGyU);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iBHdb);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $d8SEg);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $k7qj2);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hP010);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bFL3N);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ciiuv);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lB8CV);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9DEaD);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $6TOP6);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bJhnF);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $RUzV3);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hv0CN);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hxOxo);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $01mqs);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lULWw);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $3HRFn);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $3Zdna);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $aOnQQ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cnfVv);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $j7Y9b);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $abmo4);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lFsp3);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fL9cC);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $4vdkC);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $g22qX);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $khunK);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jom6Y);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jAbjP);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $6pUmH);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9GCyf);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $k4b2f);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fFu0M);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $6Tg0K);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $1trwm);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $1cuD1);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lTSno);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7ttm6);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $a2vzY);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $1uAlg);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $4SevU);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $gYKfx);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iqamJ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $OciKL);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lJoOP);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $i27OQ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9maeT);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7B1hX);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ivqW2);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jckhB);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $382l3);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $izUR3);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9HOzJ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $j7hNv);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $19BCV);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2hjBw);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $6J9V6);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $g8F24);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $4ftBh);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $rMdN2);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cSyOF);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jNUqj);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8tnwL);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8SZSR);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lwxCY);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $4Hta3);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5Qlvf);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $e6gIh);
});
$305cacda61daafb0$var$parcelRegister("d50o9", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AlertErrorDefaultProps", function() {
        return $1b52620b67bfba9b$export$99c52b840747c5f7;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AlertError", function() {
        return $1b52620b67bfba9b$export$50d48eeda63f0543;
    });
    const $1b52620b67bfba9b$export$99c52b840747c5f7 = {
        title: "Error",
        color: "red"
    };
    function $1b52620b67bfba9b$export$50d48eeda63f0543(props) {
        const { title: title, color: color, iconTooltip: iconTooltip, ...rest } = (0, $64A2P.useComponentDefaultProps)('AlertError', $1b52620b67bfba9b$export$99c52b840747c5f7, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($1St1x.Alert, {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($fIMaa.default, {
                size: "2rem",
                title: iconTooltip
            }),
            title: title,
            color: color,
            ...rest,
            children: props.children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("i6yJ4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AlertInfoDefaultProps", function() {
        return $e5f829fbc82220e4$export$f92dd328e9ea7e55;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AlertInfo", function() {
        return $e5f829fbc82220e4$export$5d8aade385ee5870;
    });
    const $e5f829fbc82220e4$export$f92dd328e9ea7e55 = {
        title: "Info"
    };
    function $e5f829fbc82220e4$export$5d8aade385ee5870(props) {
        const { title: title } = (0, $64A2P.useComponentDefaultProps)('AlertInfo', $e5f829fbc82220e4$export$f92dd328e9ea7e55, props);
        const theme = (0, $64A2P.useMantineTheme)();
        return /*#__PURE__*/ (0, $ayMG0.jsx)($1St1x.Alert, {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($1YbUT.default, {
                size: "2rem"
            }),
            title: title,
            color: theme.colors.blue[5],
            ...props,
            children: props.children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("gLcPf", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AlertSuccessDefaultProps", function() {
        return $e8955b4591f42ed6$export$92243a4617fb780e;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AlertSuccess", function() {
        return $e8955b4591f42ed6$export$e0d1aecda8283185;
    });
    const $e8955b4591f42ed6$export$92243a4617fb780e = {
        title: "Success",
        color: "green"
    };
    function $e8955b4591f42ed6$export$e0d1aecda8283185(props) {
        const { title: title, color: color } = (0, $64A2P.useComponentDefaultProps)('AlertSuccess', $e8955b4591f42ed6$export$92243a4617fb780e, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($1St1x.Alert, {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($4Rwq2.default, {
                size: "2rem"
            }),
            title: title,
            color: color,
            ...props,
            children: props.children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("3CwxR", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ColorConfiguration", function() {
        return $8eec16077c70d818$export$49194b94881f13d;
    });
    function $8eec16077c70d818$export$49194b94881f13d({ onChange: onChange, value: value }) {
        const [opened, setOpened] = (0, $acw62.useState)(false);
        const theme = (0, $64A2P.useMantineTheme)();
        const colorArray = Object.entries(theme.colors).flatMap(([colorKey, colorValues])=>colorValues.map((colorValue, colorIndex)=>({
                    colorKey: colorKey,
                    colorIndex: colorIndex,
                    colorValue: colorValue
                })));
        const swatches = colorArray.map(({ colorKey: colorKey, colorIndex: colorIndex, colorValue: colorValue })=>/*#__PURE__*/ (0, $ayMG0.jsx)($j2E9L.ColorSwatch, {
                component: "button",
                type: "button",
                onClick: ()=>onChange({
                        colorKey: colorKey,
                        colorShade: colorIndex
                    }),
                color: colorValue,
                size: 22,
                style: {
                    color: theme.white,
                    cursor: 'pointer'
                },
                title: `${colorKey}.${colorIndex}`,
                children: value.colorKey === colorKey && value.colorShade === colorIndex && /*#__PURE__*/ (0, $ayMG0.jsx)($2XzIE.CheckIcon, {
                    width: (0, $2jkdX.rem)(10)
                })
            }, `${colorKey}${colorIndex}`));
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($6gwXS.Popover, {
            opened: opened,
            onClose: ()=>setOpened(false),
            transitionProps: {
                duration: 0
            },
            width: 350,
            position: "bottom-end",
            withinPortal: true,
            withArrow: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($6gwXS.Popover.Target, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($j2E9L.ColorSwatch, {
                        component: "button",
                        type: "button",
                        color: theme.colors[value.colorKey][value.colorShade] ? theme.colors[value.colorKey][value.colorShade] : theme.colors[theme.primaryColor][6],
                        onClick: ()=>setOpened((o)=>!o),
                        size: 22,
                        style: {
                            display: 'block',
                            cursor: 'pointer'
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ho6bO.default, {
                            size: "0.9rem",
                            color: "#fff"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($6gwXS.Popover.Dropdown, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                        spacing: "xs",
                        children: swatches
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("2bGyU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LoginDefaultProps", function() {
        return $a8704b86039e0c33$export$c2c75fd58793f69;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "Login", function() {
        return $a8704b86039e0c33$export$21a94553ffa41578;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $rMdN2 = $305cacda61daafb0$var$parcelRequire("rMdN2");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    const $a8704b86039e0c33$export$c2c75fd58793f69 = {
        userLabel: "User",
        userPlaceholder: "your@email.com",
        passwordLabel: "Password",
        passwordPlaceholder: "Your password",
        rememberLabel: "Remember me",
        forgotLabel: "Forgot password?",
        signInButtonLabel: "Sign in",
        loginErrorMessage: "Unknown user name or bad password",
        confirmRecoveryEmailTitle: "Recovery email"
    };
    function $a8704b86039e0c33$export$21a94553ffa41578(props) {
        const { client: client, onStatusCompleted: onStatusCompleted, userLabel: userLabel, userPlaceholder: userPlaceholder, passwordLabel: passwordLabel, passwordPlaceholder: passwordPlaceholder, rememberLabel: rememberLabel, forgotLabel: forgotLabel, signInButtonLabel: signInButtonLabel, loginErrorMessage: loginErrorMessage, confirmRecoveryEmailTitle: confirmRecoveryEmailTitle } = (0, $64A2P.useComponentDefaultProps)('Login', $a8704b86039e0c33$export$c2c75fd58793f69, props);
        const modal = (0, $k7qj2.useModal)();
        const form = (0, $ajdIG.useForm)({
            initialValues: {
                user: '',
                password: '',
                server: '',
                rememberme: false
            }
        });
        const [status, setStatus] = (0, $acw62.useState)();
        const handleClick = (0, $acw62.useCallback)(async (values)=>{
            setStatus({
                loading: true
            });
            try {
                const data = await client.login(values.user, values.password, values.rememberme);
                const new_status = {
                    data: data
                };
                setStatus(new_status);
                onStatusCompleted(new_status);
            } catch (e) {
                const new_status = {
                    error: (0, $98ddT.toMicroMError)(e)
                };
                setStatus(new_status);
                onStatusCompleted(new_status);
            }
        }, [
            client,
            onStatusCompleted
        ]);
        const handleForgotPasswordClick = (0, $acw62.useCallback)(async ()=>{
            await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($anH21.default, {
                                size: "1.5rem",
                                stroke: "1.5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                fw: "700",
                                children: confirmRecoveryEmailTitle
                            })
                        ]
                    })
                },
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($rMdN2.RecoverPasswordEmail, {
                    client: client
                })
            });
        }, [
            client,
            confirmRecoveryEmailTitle,
            modal
        ]);
        (0, $acw62.useEffect)(()=>{
            const getRememberUser = async ()=>{
                const result = await client.getRememberUser();
                form.setFieldValue('user', result ?? '');
                if (result) form.setFieldValue('rememberme', true);
            };
            getRememberUser();
        }, [
            client
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: form.onSubmit((values)=>handleClick(values)),
                    children: [
                        status?.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($8mycu.TextInput, {
                            label: userLabel,
                            placeholder: userPlaceholder,
                            required: true,
                            "data-autofocus": true,
                            disabled: status?.loading,
                            ...form.getInputProps('user')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($ly5N0.PasswordInput, {
                            label: passwordLabel,
                            placeholder: passwordPlaceholder,
                            required: true,
                            mt: "md",
                            disabled: status?.loading,
                            ...form.getInputProps('password')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                            position: "apart",
                            mt: "lg",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($4OeIO.Checkbox, {
                                    label: rememberLabel,
                                    ...form.getInputProps('rememberme', {
                                        type: 'checkbox'
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($f2S2u.Anchor, {
                                    component: "button",
                                    size: "sm",
                                    onClick: handleForgotPasswordClick,
                                    children: forgotLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            fullWidth: true,
                            mt: "xl",
                            disabled: status?.loading,
                            type: "submit",
                            children: signInButtonLabel
                        }, "login")
                    ]
                }, "loginForm"),
                /*#__PURE__*/ (0, $ayMG0.jsx)($d50o9.AlertError, {
                    mt: "xs",
                    hidden: status?.error === undefined,
                    children: status?.error !== undefined && status.error.name === 'validation' ? status.error.message : loginErrorMessage
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("iBHdb", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LoginModalDefaultProps", function() {
        return $e618e7386572db7d$export$1e0d8a58055c4b22;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LoginModal", function() {
        return $e618e7386572db7d$export$b4d7a44be6f5e733;
    });
    var $2bGyU = $305cacda61daafb0$var$parcelRequire("2bGyU");
    const $e618e7386572db7d$export$1e0d8a58055c4b22 = {
        title: "Sign in",
        checkOnInit: true
    };
    function $e618e7386572db7d$export$b4d7a44be6f5e733(props) {
        const { client: client, title: title, onClose: onClose, onLoggedIn: onLoggedIn, checkOnInit: checkOnInit } = (0, $64A2P.useComponentDefaultProps)('LoginModal', $e618e7386572db7d$export$1e0d8a58055c4b22, props);
        const [opened, { open: open, close: close }] = (0, $6X2G0.useDisclosure)(false);
        const statusCompletedHandler = (status)=>{
            if (!status.error && !status.loading) {
                onLoggedIn(status.data?.claims);
                close();
            }
        };
        const closeHandler = ()=>{
            close();
            if (onClose) onClose();
        };
        (0, $acw62.useEffect)(()=>{
            if (checkOnInit) {
                async function check() {
                    const result = await client.isLoggedInLocal();
                    if (!result) open();
                    else onLoggedIn(client.LOGGED_IN_USER);
                }
                check();
            } else open();
        }, []);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($aCM0s.Modal, {
            trapFocus: true,
            opened: opened,
            onClose: closeHandler,
            title: title,
            centered: true,
            withCloseButton: false,
            closeOnClickOutside: false,
            closeOnEscape: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2bGyU.Login, {
                client: client,
                onStatusCompleted: statusCompletedHandler
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("d8SEg", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ModalForm", function() {
        return $e30966c9dbb7eab6$export$15c9a37039d15c3e;
    });
    function $e30966c9dbb7eab6$export$15c9a37039d15c3e({ entity: entity, onSaved: onSaved, onCancel: onCancel }) {
        const [opened, setOpened] = (0, $acw62.useState)(true);
        const [DynamicForm, setDynamicForm] = (0, $acw62.useState)(null);
        (0, $acw62.useEffect)(()=>{
            let mounted = true;
            if (entity.Form !== null && entity.Form !== 'AutoForm' && entity.Form !== 'AutoFiltersForm') entity.Form.then((Form)=>{
                if (mounted) setDynamicForm(()=>Form);
            });
            else Promise.resolve($305cacda61daafb0$var$parcelRequire("5cUzS")).then((module1)=>{
                if (mounted) setDynamicForm(()=>module1.AutoForm);
            });
            return ()=>{
                mounted = false;
            };
        }, [
            entity.Form
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($aCM0s.Modal, {
            opened: opened,
            onClose: ()=>null,
            children: [
                !DynamicForm && /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {}),
                DynamicForm && /*#__PURE__*/ (0, $ayMG0.jsx)(DynamicForm, {
                    entity: entity,
                    onSaved: ()=>{
                        if (onSaved) onSaved(entity);
                        setOpened(false);
                    },
                    onCancel: ()=>{
                        if (onCancel) onCancel(entity);
                        setOpened(false);
                    }
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("k7qj2", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ModalsManagerDefaultProps", function() {
        return $5cdab1be66fbf6ab$export$6ccb6e1de3749d56;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ModalsManager", function() {
        return $5cdab1be66fbf6ab$export$4a25ee9b30a3b11c;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useModal", function() {
        return $5cdab1be66fbf6ab$export$33ffd74ebf07f060;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $lTNXP = $305cacda61daafb0$var$parcelRequire("lTNXP");
    const $5cdab1be66fbf6ab$export$6ccb6e1de3749d56 = {
        closeLabel: 'Close',
        fullscreenLabel: 'Fullscreen',
        minimizeLabel: 'Minimize',
        toggleLabel: 'Toggle',
        FullScreenIcon: $hlpmP.default,
        RestoreScreeSizeIcon: $g3BkA.default,
        withCloseButton: true,
        withFullscreenButton: true
    };
    const $5cdab1be66fbf6ab$var$NEW_SIZES = {
        xs: '20%',
        sm: '30%',
        md: '40%',
        lg: '60%',
        xl: '80%',
        fullscreen: '100%'
    };
    const $5cdab1be66fbf6ab$var$ModalContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
    const $5cdab1be66fbf6ab$export$4a25ee9b30a3b11c = ({ modalProps: modalProps, animationDuration: animationDuration, children: children })=>{
        const [modals, setModals] = (0, $acw62.useState)([]);
        const [isClosing, setIsClosing] = (0, $acw62.useState)(false);
        const { width: viewportWidth } = (0, $eJ0gu.useViewportSize)();
        const transparentOverlay = {
            ...modalProps.overlayProps,
            opacity: 0,
            blur: 0
        };
        const open = (0, $acw62.useCallback)(async ({ content: content, modalProps: modalProps, onClosed: onClosed, focusOnClosed: focusOnClosed })=>{
            if (isClosing) await new Promise((resolve)=>{
                const checkInterval = setInterval(()=>{
                    if (!isClosing) {
                        clearInterval(checkInterval);
                        resolve(null);
                    }
                }, 100);
            });
            const modal_id = (0, $45cdq.randomId)(); // Generate ID upfront
            // try to get the last focused event if none specified
            if (!focusOnClosed) focusOnClosed = document.activeElement;
            // Default for closeButton
            if (modalProps.withCloseButton === undefined) modalProps.withCloseButton = $5cdab1be66fbf6ab$export$6ccb6e1de3749d56.withCloseButton;
            // Default full screen button
            if (modalProps.withFullscreenButton === undefined) modalProps.withFullscreenButton = $5cdab1be66fbf6ab$export$6ccb6e1de3749d56.withFullscreenButton;
            // If content is a Promise
            if ((0, $lTNXP.isPromise)(content)) {
                content.then((resolvedContent)=>{
                    setModals((prev)=>{
                        return prev.map((m)=>m.id === modal_id ? {
                                ...m,
                                resolvedContent: resolvedContent
                            } : m);
                    });
                });
                setModals((prevModals)=>[
                        ...prevModals,
                        {
                            originalContent: content,
                            opened: true,
                            id: modal_id,
                            props: modalProps,
                            onClosed: onClosed,
                            focusOnClosed: focusOnClosed,
                            initialSize: modalProps.size,
                            withFullscreenButton: modalProps.withFullscreenButton
                        }
                    ]);
            } else setModals((prevModals)=>[
                    ...prevModals,
                    {
                        originalContent: content,
                        resolvedContent: content,
                        opened: true,
                        id: modal_id,
                        props: modalProps,
                        onClosed: onClosed,
                        focusOnClosed: focusOnClosed,
                        initialSize: modalProps.size,
                        withFullscreenButton: modalProps.withFullscreenButton
                    }
                ]);
        }, [
            isClosing
        ]);
        const getModalSize = (0, $acw62.useCallback)((size)=>{
            if (size === 'fullscreen' || size === '100%' || viewportWidth < 768 && [
                'md',
                'lg',
                'xl',
                'fullscreen'
            ].includes(size ?? '')) return {
                fullscreen: true,
                size: undefined
            };
            let new_size = size;
            if (size && $5cdab1be66fbf6ab$var$NEW_SIZES[size]) new_size = $5cdab1be66fbf6ab$var$NEW_SIZES[size];
            return {
                size: new_size,
                fullscreen: undefined
            };
        }, [
            viewportWidth
        ]);
        const close = (0, $acw62.useCallback)(()=>{
            let timer = null;
            return new Promise((resolve)=>{
                setModals((prevModals)=>{
                    if (prevModals.length > 0) {
                        const newModals = [
                            ...prevModals
                        ];
                        newModals[newModals.length - 1].opened = false; // Close the last modal
                        setIsClosing(true);
                        // After a delay, remove the modal completely
                        if (!timer) timer = setTimeout(()=>{
                            const closedModal = newModals.pop();
                            setModals(newModals);
                            if (closedModal?.onClosed) closedModal.onClosed();
                            setIsClosing(false);
                            if (closedModal?.focusOnClosed) closedModal.focusOnClosed.focus();
                            resolve();
                        }, animationDuration); // Adjust this delay to match the closing animation duration
                        return newModals;
                    }
                    return [];
                });
            });
        }, [
            animationDuration
        ]);
        const IconFullscreen = $5cdab1be66fbf6ab$export$6ccb6e1de3749d56.FullScreenIcon;
        const IconRestore = $5cdab1be66fbf6ab$export$6ccb6e1de3749d56.RestoreScreeSizeIcon;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($5cdab1be66fbf6ab$var$ModalContext.Provider, {
            value: {
                open: open,
                close: close
            },
            children: [
                children,
                modals.map((modal, index)=>{
                    const computedSizes = getModalSize(modal.props.size);
                    const mobileSize = viewportWidth < 768 && [
                        'md',
                        'lg',
                        'xl',
                        'fullscreen'
                    ].includes(modal.initialSize ?? '');
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)($aCM0s.Modal.Root, {
                        opened: modal.opened,
                        onClose: async ()=>{
                            await close();
                        },
                        size: computedSizes.size,
                        fullScreen: computedSizes.fullscreen,
                        zIndex: (index + 1) * 5000,
                        returnFocus: false,
                        trapFocus: true,
                        closeOnClickOutside: modal.props.closeOnClickOutside ?? false,
                        closeOnEscape: modal.props.closeOnEscape ?? true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($aCM0s.Modal.Overlay, {
                                ...index === modals.length - 1 ? modalProps.overlayProps : transparentOverlay
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($aCM0s.Modal.Content, {
                                sx: {
                                    height: computedSizes.fullscreen ? '100dvh' : undefined
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($aCM0s.Modal.Header, {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($aCM0s.Modal.Title, {
                                                children: modal.props.title
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                                position: "right",
                                                children: [
                                                    modal.withFullscreenButton && mobileSize === false && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            setModals((prev)=>prev.map((m, i)=>{
                                                                    if (i !== index) return m;
                                                                    const original = m.initialSize ?? 'lg';
                                                                    const currentSize = m.props.size;
                                                                    const newSize = currentSize === 'fullscreen' || currentSize === '100%' ? original === 'fullscreen' || original === '100%' ? 'lg' : original : 'fullscreen';
                                                                    return {
                                                                        ...m,
                                                                        props: {
                                                                            ...m.props,
                                                                            size: newSize
                                                                        }
                                                                    };
                                                                }));
                                                        },
                                                        variant: "subtle",
                                                        size: "sm",
                                                        title: `${$5cdab1be66fbf6ab$export$6ccb6e1de3749d56.toggleLabel} ${$5cdab1be66fbf6ab$export$6ccb6e1de3749d56.fullscreenLabel}`,
                                                        children: modal.props.size === 'fullscreen' ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconRestore, {
                                                            size: "1rem"
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)(IconFullscreen, {
                                                            size: "1rem"
                                                        })
                                                    }),
                                                    modal.props.withCloseButton && /*#__PURE__*/ (0, $ayMG0.jsx)($aCM0s.Modal.CloseButton, {
                                                        title: $5cdab1be66fbf6ab$export$6ccb6e1de3749d56.closeLabel
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($aCM0s.Modal.Body, {
                                        style: {
                                            paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 1rem)'
                                        },
                                        children: modal.resolvedContent ? modal.resolvedContent : (0, $lTNXP.isPromise)(modal.originalContent) ? /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {}) : modal.originalContent
                                    })
                                ]
                            })
                        ]
                    }, modal.id);
                })
            ]
        });
    };
    const $5cdab1be66fbf6ab$export$33ffd74ebf07f060 = ()=>{
        const context = (0, $acw62.useContext)($5cdab1be66fbf6ab$var$ModalContext);
        if (context === null) throw new Error("useModal must be used within a ModalProvider");
        return context;
    };
});
$305cacda61daafb0$var$parcelRegister("hP010", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "SearchInputDefaultProps", function() {
        return $cef4a0d1fbbb8d9d$export$8c9109e488ef140d;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "SearchInput", function() {
        return $cef4a0d1fbbb8d9d$export$55d7609a8f1eccd2;
    });
    const $cef4a0d1fbbb8d9d$export$8c9109e488ef140d = {
        iconVariant: "light",
        placeholder: "Enter text to search"
    };
    function $cef4a0d1fbbb8d9d$export$55d7609a8f1eccd2(props) {
        const { onSearchClick: onSearchClick, size: size, iconsSize: iconsSize, value: value, onChange: onChange, placeholder: placeholder, autoFocus: autoFocus, iconVariant: iconVariant, ...rest } = (0, $64A2P.useComponentDefaultProps)('SearchInput', $cef4a0d1fbbb8d9d$export$8c9109e488ef140d, props);
        const theme = (0, $64A2P.useMantineTheme)();
        return /*#__PURE__*/ (0, $ayMG0.jsx)($8mycu.TextInput, {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($li55Z.default, {
                size: "1.1rem",
                stroke: 1.5
            }),
            radius: "xl",
            size: size,
            rightSection: /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                size: size,
                radius: "xl",
                color: theme.primaryColor,
                variant: iconVariant,
                onClick: (e)=>onSearchClick(e),
                children: theme.dir === 'ltr' ? /*#__PURE__*/ (0, $ayMG0.jsx)($bb5Hu.default, {
                    size: iconsSize,
                    stroke: 1.5
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($dV30q.default, {
                    size: iconsSize,
                    stroke: 1.5
                })
            }),
            rightSectionWidth: 42,
            value: value,
            onChange: onChange,
            placeholder: placeholder,
            "data-autofocus": autoFocus,
            ...rest
        });
    }
});
$305cacda61daafb0$var$parcelRegister("bFL3N", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ToggleActionIcon", function() {
        return $8e15e4c9620388cf$export$6145f918ac46fa45;
    });
    const $8e15e4c9620388cf$var$defaultProps = {
        onVariant: 'light',
        offVariant: 'light',
        initialStatus: 'off',
        radius: 'xl'
    };
    const $8e15e4c9620388cf$export$6145f918ac46fa45 = /*#__PURE__*/ (0, $acw62.forwardRef)(function ToggleActionIcon(props, ref) {
        const { hidden: hidden, size: size, onColor: onColor, offColor: offColor, onVariant: onVariant, offVariant: offVariant, onIcon: onIcon, offIcon: offIcon, initialStatus: initialStatus, onClick: onClick, radius: radius, title: title } = (0, $64A2P.useComponentDefaultProps)('ToggleActionIcon', $8e15e4c9620388cf$var$defaultProps, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const [onOff, setOnOff] = (0, $acw62.useState)(initialStatus === "on");
        const visibility = hidden ? {
            visibility: "hidden",
            ":focus": {
                outlineColor: theme.fn.themeColor(onOff ? onColor : offColor)
            }
        } : {
            ":focus": {
                outlineColor: theme.fn.themeColor(onOff ? onColor : offColor)
            }
        };
        const onClickHandler = ()=>{
            setOnOff((prev)=>!prev);
            if (onClick) onClick();
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
            title: title,
            ref: ref,
            sx: visibility,
            onClick: ()=>onClickHandler(),
            size: size,
            radius: radius,
            color: onOff ? onColor : offColor,
            variant: onOff ? onVariant : offVariant,
            children: onOff ? onIcon : offIcon
        });
    });
});
$305cacda61daafb0$var$parcelRegister("ciiuv", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("lB8CV", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useExecuteView", function() {
        return $d21e389682864538$export$3a28c6c0ce3f961d;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    function $d21e389682864538$export$3a28c6c0ce3f961d(entity, values, viewName, search, limit, refresh, filters) {
        const [status, setStatus] = (0, $acw62.useState)({
            loading: true,
            operationType: 'view'
        });
        const cancellation = (0, $acw62.useRef)(new AbortController());
        const done = (0, $acw62.useRef)();
        const prevValues = (0, $acw62.useRef)(values);
        const prevSearch = (0, $acw62.useRef)(search);
        const prevLimit = (0, $acw62.useRef)(limit);
        const prevRefresh = (0, $acw62.useRef)(undefined);
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (done.current === false) {
                    console.log("useExecuteView aborted");
                    cancellation.current?.abort("ExecuteView Effect cleanup");
                }
            };
        }, []);
        (0, $acw62.useEffect)(()=>{
            if (!entity || !viewName) return;
            const mergedValues = {
                ...values,
                ...filters ?? {}
            };
            // Check if values, search, limit or refresh have changed from their previous values
            if (!(0, $iKzSR.areValuesObjectsEqual)(mergedValues, prevValues.current) || !(0, $iKzSR.areArraysContentsEqual)(search, prevSearch.current) || limit !== prevLimit.current || refresh !== prevRefresh.current) {
                cancellation.current.abort("ExecuteView, aborting previous request.");
                cancellation.current = new AbortController();
                done.current = false;
                async function getData() {
                    setStatus({
                        loading: true,
                        operationType: 'view'
                    });
                    try {
                        if (entity && viewName) {
                            const data = await entity.API.executeView(entity.def.views[viewName], mergedValues, limit, search, cancellation.current.signal);
                            done.current = true;
                            setStatus({
                                data: data,
                                operationType: 'view'
                            });
                        }
                    } catch (e) {
                        if (e.name !== 'AbortError' && e !== "ExecuteView, aborting previous request.") setStatus({
                            error: (0, $98ddT.toMicroMError)(e),
                            operationType: 'view'
                        });
                    }
                }
                getData();
            }
            // Update previous values
            prevValues.current = mergedValues;
            prevSearch.current = search;
            prevLimit.current = limit;
            prevRefresh.current = refresh;
        }, [
            entity,
            filters,
            limit,
            refresh,
            search,
            values,
            viewName
        ]);
        return status;
    }
});
$305cacda61daafb0$var$parcelRegister("9DEaD", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useDebugProps", function() {
        return $d72605cd9f6f0f19$export$3d1e468930fcd1bc;
    });
    function $d72605cd9f6f0f19$export$3d1e468930fcd1bc(propsObject, dependencies, componentName) {
        const prevProps = (0, $acw62.useRef)(propsObject);
        const memoizedProps = (0, $acw62.useMemo)(()=>propsObject, dependencies);
        (0, $acw62.useEffect)(()=>{
            const changedProps = [];
            const props = propsObject;
            for(const prop in props)if (prevProps.current[prop] !== props[prop]) {
                const changedValue = {
                    [prop]: {
                        prev: prevProps.current[prop],
                        actual: props[prop]
                    }
                };
                changedProps.push(changedValue);
            }
            console.log(`${componentName} Changed props:`, changedProps);
            prevProps.current = props;
        }, [
            memoizedProps,
            componentName
        ]);
    }
});
$305cacda61daafb0$var$parcelRegister("6TOP6", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useEnterAsTab", function() {
        return $3ac7c6452cdaeb99$export$6e78fbbc6d30e918;
    });
    function $3ac7c6452cdaeb99$export$6e78fbbc6d30e918() {
        const ref = (0, $acw62.useRef)(null);
        (0, $acw62.useEffect)(()=>{
            const handleKeyDown = (event1)=>{
                const activeElement = document.activeElement;
                const validInputTypes = [
                    'date',
                    'datetime-local',
                    'email',
                    'month',
                    'number',
                    'password',
                    'search',
                    'tel',
                    'text',
                    'time',
                    'url',
                    'week'
                ];
                if (event1.key === 'Enter' && activeElement && validInputTypes.includes(activeElement.type)) {
                    event1.preventDefault();
                    const focusableElements = Array.from(ref.current?.querySelectorAll('a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select') || []);
                    //console.log(`EnterAsTAB: focusableElements: ${focusableElements}`);
                    const currentTabIndex = focusableElements.indexOf(activeElement);
                    const nextElement = focusableElements[currentTabIndex + 1] || focusableElements[0];
                    //console.log(`EnterAsTAB: nextElement: ${nextElement}`);
                    nextElement?.focus();
                }
            };
            const currentRef = ref.current;
            if (currentRef) currentRef.addEventListener('keydown', handleKeyDown);
            // Cleanup function
            return ()=>{
                if (currentRef) currentRef.removeEventListener('keydown', handleKeyDown);
            };
        }, []);
        return ref;
    }
});
$305cacda61daafb0$var$parcelRegister("bJhnF", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseLoginDefaultProps", function() {
        return $3560b7df2e098f57$export$3ca20c806f247be9;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useLogin", function() {
        return $3560b7df2e098f57$export$d4e22f05f73ea56b;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $2bGyU = $305cacda61daafb0$var$parcelRequire("2bGyU");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    const $3560b7df2e098f57$export$3ca20c806f247be9 = {
        title: "Sign-in"
    };
    function $3560b7df2e098f57$export$d4e22f05f73ea56b(props) {
        const { client: client, modalProps: modalProps, title: title, onClose: onClose } = (0, $64A2P.useComponentDefaultProps)('useLogin', $3560b7df2e098f57$export$3ca20c806f247be9, props);
        const modals = (0, $k7qj2.useModal)();
        const statusCompletedHandler = async (status)=>{
            if (!status.error && !status.loading) await modals.close();
        };
        const login = async ()=>{
            await modals.open({
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($2bGyU.Login, {
                    client: client,
                    onStatusCompleted: statusCompletedHandler
                }),
                modalProps: {
                    ...modalProps,
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        fw: "700",
                        children: title
                    })
                },
                onClosed: ()=>{
                    if (onClose) onClose();
                }
            });
        };
        return login;
    }
});
$305cacda61daafb0$var$parcelRegister("RUzV3", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "TextField", function() {
        return $95e2e1bafd0c20d6$export$2c73285ae9390cec;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    var $OciKL = $305cacda61daafb0$var$parcelRequire("OciKL");
    const $95e2e1bafd0c20d6$var$defaultProps = {
        validationContainer: $9mTYo.Group,
        autoTrim: true
    };
    const $95e2e1bafd0c20d6$export$2c73285ae9390cec = /*#__PURE__*/ (0, $acw62.forwardRef)(function TextField(props, ref) {
        const { column: column, entityForm: entityForm, validate: validate, validationContainer: validationContainer, maw: maw, required: required, requiredMessage: requiredMessage, maxLength: maxLength, readOnly: readOnly, label: label, placeholder: placeholder, description: description, withAsterisk: withAsterisk, autoFocus: autoFocus, onBlur: onBlur, onChange: onChange, onFocus: onFocus, transform: transform, autoTrim: autoTrim, iconWidth: iconWidth, ...others } = (0, $64A2P.useComponentDefaultProps)('TextField', $95e2e1bafd0c20d6$var$defaultProps, props);
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const [showDescription] = entityForm.showDescriptionState;
        // MMC: disabled when loading is done at the form level in EntityForm and fieldset
        //data-autofocus={autoFocus}  disabled={(disableOnLoading) ? loading : disabled}
        const { onBlur: mantineOnBlur, onChange: mantineOnChange, onFocus: mantineOnFocus, ...mantineProps } = entityForm.form.getInputProps(column.name);
        const textTransform = (0, $OciKL.useTextTransform)({
            entityForm: entityForm,
            column: column,
            transform: transform,
            autoTrim: autoTrim
        });
        const handleOnBlur = (0, $acw62.useCallback)((event1)=>{
            textTransform(event1.target.value);
            if (onBlur) onBlur(event1);
            mantineOnBlur(event1);
        }, [
            mantineOnBlur,
            onBlur,
            textTransform
        ]);
        const handleOnChange = (0, $acw62.useCallback)((event1)=>{
            if (onChange) onChange(event1);
            mantineOnChange(event1);
        }, [
            mantineOnChange,
            onChange
        ]);
        const handleOnFocus = (0, $acw62.useCallback)((event1)=>{
            if (onFocus) onFocus(event1);
            mantineOnFocus(event1);
        }, [
            mantineOnFocus,
            onFocus
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($8mycu.TextInput, {
            ...others,
            ...mantineProps,
            withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            label: label ?? column.prompt,
            placeholder: placeholder ?? column.placeholder,
            description: showDescription ? description ?? column.description : '',
            maw: maw ?? (column.length <= 20 ? {
                maxWidth: '10rem'
            } : undefined),
            maxLength: maxLength ?? (column.length || undefined),
            readOnly: entityForm.formMode === 'view' ? true : readOnly,
            "data-autofocus": autoFocus,
            autoFocus: autoFocus,
            onBlur: handleOnBlur,
            onChange: handleOnChange,
            onFocus: handleOnFocus,
            iconWidth: iconWidth && typeof iconWidth === 'string' ? (0, $62A7W.px)(iconWidth) : iconWidth,
            ref: ref
        });
    });
});
$305cacda61daafb0$var$parcelRegister("OciKL", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useTextTransform", function() {
        return $635458b9b7c13141$export$c3d8b10793bbfe83;
    });
    function $635458b9b7c13141$export$c3d8b10793bbfe83(props) {
        const { entityForm: entityForm, column: column, autoTrim: autoTrim, transform: transform } = props;
        const handleTransform = (0, $acw62.useCallback)((text)=>{
            if (autoTrim || transform) {
                const value = autoTrim ? text.trim() : text;
                let transformedValue = value;
                if (transform) switch(transform){
                    case "uppercase":
                        transformedValue = value.toUpperCase();
                        break;
                    case "lowercase":
                        transformedValue = value.toLowerCase();
                        break;
                    case "capitalize":
                        transformedValue = value.charAt(0).toUpperCase() + value.slice(1);
                        break;
                    case "titlecase":
                        transformedValue = value.split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                }
                entityForm.form.setFieldValue(column.name, transformedValue);
            }
        }, [
            autoTrim,
            column.name,
            entityForm.form,
            transform
        ]);
        return handleTransform;
    }
});
$305cacda61daafb0$var$parcelRegister("hv0CN", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "TextAreaField", function() {
        return $74d6f71b0f274d9c$export$301bf6213f61d17f;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    var $OciKL = $305cacda61daafb0$var$parcelRequire("OciKL");
    const $74d6f71b0f274d9c$var$defaultProps = {
        validationContainer: $9mTYo.Group
    };
    const $74d6f71b0f274d9c$export$301bf6213f61d17f = /*#__PURE__*/ (0, $acw62.forwardRef)(function TextAreaField(props, ref) {
        const { column: column, entityForm: entityForm, required: required, label: label, validate: validate, requiredMessage: requiredMessage, validationContainer: validationContainer, maxLength: maxLength, placeholder: placeholder, description: description, readOnly: readOnly, withAsterisk: withAsterisk, autofocus: autofocus, transform: transform, autoTrim: autoTrim, onBlur: onBlur, onChange: onChange, onFocus: onFocus, ...others } = (0, $64A2P.useComponentDefaultProps)('TextAreaField', $74d6f71b0f274d9c$var$defaultProps, props);
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage
        });
        const { onBlur: mantineOnBlur, onChange: mantineOnChange, onFocus: mantineOnFocus, ...mantineProps } = entityForm.form.getInputProps(column.name);
        const textTransform = (0, $OciKL.useTextTransform)({
            entityForm: entityForm,
            column: column,
            transform: transform,
            autoTrim: autoTrim
        });
        const handleOnBlur = (0, $acw62.useCallback)((event1)=>{
            textTransform(event1.target.value);
            if (onBlur) onBlur(event1);
            mantineOnBlur(event1);
        }, [
            mantineOnBlur,
            onBlur,
            textTransform
        ]);
        const handleOnChange = (0, $acw62.useCallback)((event1)=>{
            if (onChange) onChange(event1);
            mantineOnChange(event1);
        }, [
            mantineOnChange,
            onChange
        ]);
        const handleOnFocus = (0, $acw62.useCallback)((event1)=>{
            if (onFocus) onFocus(event1);
            mantineOnFocus(event1);
        }, [
            mantineOnFocus,
            onFocus
        ]);
        const [showDescription] = entityForm.showDescriptionState;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($dSMvY.Textarea, {
            ...others,
            ...mantineProps,
            withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            label: label ?? column.prompt,
            placeholder: placeholder ?? column.placeholder,
            description: showDescription ? description ?? column.description : '',
            readOnly: entityForm.formMode === 'view' ? true : readOnly,
            onBlur: handleOnBlur,
            onChange: handleOnChange,
            onFocus: handleOnFocus,
            ref: ref,
            "data-autofocus": autofocus,
            maxLength: maxLength ?? (column.length || undefined)
        });
    });
});
$305cacda61daafb0$var$parcelRegister("hxOxo", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "PasswordField", function() {
        return $9dfe1d3e4dcf7b26$export$65ed9482db2257fa;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    const $9dfe1d3e4dcf7b26$var$defaultProps = {
        validationContainer: $9mTYo.Group
    };
    function $9dfe1d3e4dcf7b26$export$65ed9482db2257fa(props) {
        const { column: column, loading: loading, entityForm: entityForm, maw: maw, required: required, maxLength: maxLength, disabled: disabled, disableOnLoading: disableOnLoading, label: label, validationContainer: validationContainer, validate: validate, requiredMessage: requiredMessage, description: description, readOnly: readOnly, withAsterisk: withAsterisk, ...others } = (0, $64A2P.useComponentDefaultProps)('PasswordField', $9dfe1d3e4dcf7b26$var$defaultProps, props);
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const [showDescription] = entityForm.showDescriptionState;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ly5N0.PasswordInput, {
            ...others,
            withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            label: label ?? column.prompt,
            description: showDescription ? description ?? column.description : '',
            maw: maw ?? (column.length <= 20 ? '10rem' : undefined),
            maxLength: maxLength ?? column.length,
            readOnly: entityForm.formMode === 'view' ? true : readOnly,
            disabled: disableOnLoading ? loading : disabled,
            ...entityForm.form.getInputProps(column.name)
        });
    }
});
$305cacda61daafb0$var$parcelRegister("01mqs", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useExecuteServerAction", function() {
        return $b401857d6bbb5b85$export$5e89f28b2f6c2d01;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    function $b401857d6bbb5b85$export$5e89f28b2f6c2d01(entity, actionName) {
        const [status, setStatus] = (0, $acw62.useState)({
            loading: false
        });
        const cancellation = (0, $acw62.useRef)(new AbortController());
        const done = (0, $acw62.useRef)(false);
        const prevValues = (0, $acw62.useRef)();
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (!done.current) {
                    console.log("useExecuteServerAction aborted on unmount");
                    cancellation.current.abort("Component unmounted");
                }
            };
        }, []);
        const execute = (0, $acw62.useCallback)(async (values)=>{
            if (status.loading) return status;
            if (!(0, $iKzSR.areValuesObjectsEqual)(values, prevValues.current)) {
                // Abort the previous request before starting a new one
                cancellation.current.abort("ExecuteServerAction, aborting previous request.");
                cancellation.current = new AbortController();
                done.current = false;
                try {
                    const action = entity.def.serverActions[actionName];
                    if (!action) throw new Error('Action or valuesMapper missing.');
                    setStatus({
                        loading: true,
                        operationType: 'action'
                    });
                    const data = await entity.API.executeServerAction(action, values, cancellation.current.signal);
                    done.current = true;
                    setStatus({
                        data: data,
                        operationType: 'action'
                    });
                    // Update previous values
                    prevValues.current = values;
                } catch (e) {
                    if (e.name !== 'AbortError' && e !== "ExecuteServerAction, aborting previous request.") {
                        const errorResult = {
                            error: (0, $98ddT.toMicroMError)(e),
                            operationType: 'action'
                        };
                        setStatus(errorResult);
                    }
                }
            }
        }, [
            entity,
            actionName,
            status
        ]);
        const abort = (0, $acw62.useCallback)(()=>{
            cancellation.current.abort();
        }, []);
        return {
            status: status,
            execute: execute,
            abort: abort
        };
    }
});
$305cacda61daafb0$var$parcelRegister("lULWw", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "NotifySuccessDefaultProps", function() {
        return $659a9ea5ffb2398a$export$f9a13d073ef5aa29;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "NotifySuccess", function() {
        return $659a9ea5ffb2398a$export$2034d935a358f0d;
    });
    const $659a9ea5ffb2398a$export$f9a13d073ef5aa29 = {
        title: "Success",
        color: "green"
    };
    function $659a9ea5ffb2398a$export$2034d935a358f0d(props) {
        const { title: title, color: color } = (0, $64A2P.useComponentDefaultProps)('NotifySuccess', $659a9ea5ffb2398a$export$f9a13d073ef5aa29, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($e2mZf.Notification, {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3US3h.default, {
                size: "1.1rem"
            }),
            title: title,
            color: color,
            withCloseButton: props.withCloseButton ?? false,
            ...props,
            children: props.children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("3HRFn", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "NotifyError", function() {
        return $27e2245473e164a4$export$2b677cfa6519f8ab;
    });
    function $27e2245473e164a4$export$2b677cfa6519f8ab(props) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)($e2mZf.Notification, {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                size: "1.1rem"
            }),
            title: props.title ?? 'Error',
            color: props.color ?? 'red',
            withCloseButton: props.withCloseButton ?? false,
            ...props,
            children: props.children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("3Zdna", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "NotifyInfoDefaultProps", function() {
        return $6625a5f80de80234$export$d4d25ef691fefb66;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "NotifyInfo", function() {
        return $6625a5f80de80234$export$c9970252bf07425a;
    });
    const $6625a5f80de80234$export$d4d25ef691fefb66 = {
        title: "Info"
    };
    function $6625a5f80de80234$export$c9970252bf07425a(props) {
        const { title: title } = (0, $64A2P.useComponentDefaultProps)('NotifyInfo', $6625a5f80de80234$export$d4d25ef691fefb66, props);
        const theme = (0, $64A2P.useMantineTheme)();
        return /*#__PURE__*/ (0, $ayMG0.jsx)($e2mZf.Notification, {
            icon: "\uD835\uDC8A",
            title: title,
            color: props.color ?? theme.colors.blue[5],
            withCloseButton: props.withCloseButton ?? false,
            ...props,
            children: props.children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("aOnQQ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "NotifyBitFieldDefaultProps", function() {
        return $acf29accca02aaca$export$eb427cf71c39a5f2;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "NotifyBitField", function() {
        return $acf29accca02aaca$export$c2e251c3c88f72a9;
    });
    const $acf29accca02aaca$export$eb427cf71c39a5f2 = {
        trueIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($3US3h.default, {
            size: "1.1rem"
        }),
        falseIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
            size: "1.1rem"
        }),
        trueColor: "green",
        falseColor: "red"
    };
    function $acf29accca02aaca$export$c2e251c3c88f72a9(props) {
        const { trueIcon: trueIcon, falseIcon: falseIcon, trueMessage: trueMessage, falseMessage: falseMessage, column: column, trueColor: trueColor, falseColor: falseColor, ...others } = (0, $64A2P.useComponentDefaultProps)('NotifyBitField', $acf29accca02aaca$export$eb427cf71c39a5f2, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($e2mZf.Notification, {
            ...others,
            icon: column.value ? trueIcon : falseIcon,
            color: column.value ? trueColor : falseColor,
            withCloseButton: props.withCloseButton ?? false,
            children: column.value ? trueMessage : falseMessage
        });
    }
});
$305cacda61daafb0$var$parcelRegister("cnfVv", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CheckboxField", function() {
        return $e376e2988f185d5e$export$94195a47b94ed396;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    function $e376e2988f185d5e$export$94195a47b94ed396(props) {
        const { column: column, required: required, entityForm: entityForm, loading: loading, disableOnLoading: disableOnLoading, label: label, readOnly: readOnly, disabled: disabled, requiredMessage: requiredMessage, description: description, ...others } = props;
        const effectiveRequired = !readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable));
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            required: effectiveRequired,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const [showDescription] = entityForm.showDescriptionState;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($4OeIO.Checkbox, {
            ...others,
            label: label ?? column.prompt,
            description: showDescription ? description ?? column.description : '',
            disabled: disabled ?? (entityForm.formMode === 'view' || disableOnLoading && loading || readOnly),
            ...entityForm.form.getInputProps(column.name, {
                type: 'checkbox'
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("j7Y9b", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ConfirmAndExecutePanelDefaultProps", function() {
        return $09bbe0598d47f4d4$export$15dfcf35178dfa07;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ConfirmAndExecutePanel", function() {
        return $09bbe0598d47f4d4$export$4f7e43363cbfcc5e;
    });
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $abmo4 = $305cacda61daafb0$var$parcelRequire("abmo4");
    const $09bbe0598d47f4d4$export$15dfcf35178dfa07 = {
        cancelButtonText: "Cancel",
        okButtonText: "OK",
        loadingContent: /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {}),
        okButtonProps: {
            color: "red"
        }
    };
    function $09bbe0598d47f4d4$export$4f7e43363cbfcc5e(props) {
        const { content: content, onOK: onOK, onCancel: onCancel, operation: operation, okButtonText: okButtonText, cancelButtonText: cancelButtonText, loadingContent: loadingContent, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, runOnOpen: runOnOpen } = (0, $64A2P.useComponentDefaultProps)('ConfirmAndExecutePanel', $09bbe0598d47f4d4$export$15dfcf35178dfa07, props);
        const { operationCallback: operationCallback, status: status } = (0, $abmo4.useOperationStatusCallback)({
            callback: async ()=>await onOK(),
            operation: operation,
            deps: []
        });
        (0, $acw62.useEffect)(()=>{
            const runAsync = async ()=>{
                await operationCallback();
            };
            if (runOnOpen) runAsync();
        }, []);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                status.loading && loadingContent,
                !status.loading && !status.error && content,
                status.error && /*#__PURE__*/ (0, $ayMG0.jsx)($d50o9.AlertError, {
                    mt: "sm",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                        children: [
                            status.error.status,
                            " ",
                            status.error.message,
                            " ",
                            status.error.statusMessage
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    mt: "xs",
                    position: "right",
                    children: [
                        cancelButtonText && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            ...cancelButtonProps,
                            variant: "light",
                            leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($dRw7S.default, {
                                size: "1.5rem"
                            }),
                            onClick: async ()=>await Promise.resolve(onCancel()),
                            children: cancelButtonText
                        }),
                        okButtonText && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            ...okButtonProps,
                            onClick: async ()=>await operationCallback(),
                            disabled: !!status.error,
                            loading: status?.loading,
                            leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($4Rwq2.default, {
                                size: "1.5rem"
                            }),
                            children: okButtonText
                        })
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("lFsp3", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FakeProgressBar", function() {
        return $3266db6b02200edc$export$9df718b15505ba95;
    });
    function $3266db6b02200edc$export$9df718b15505ba95(props) {
        const [value, setValue] = (0, $acw62.useState)(0);
        const initialDelay = 10;
        const maxWait = 360000; // 1 hour
        const delayRef = (0, $acw62.useRef)(initialDelay);
        (0, $acw62.useEffect)(()=>{
            const interval = setInterval(()=>{
                setValue((v)=>{
                    if (v >= 60) {
                        delayRef.current = initialDelay + Math.pow((maxWait / 10) ** (1 / 40), v - 60);
                        clearInterval(interval);
                    }
                    return Math.min(v + (v >= 60 ? 0.5 : 1), 100);
                });
            }, delayRef.current);
            return ()=>clearInterval(interval);
        }, [
            value
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($jMtx3.Progress, {
            value: value,
            ...props
        });
    }
});
$305cacda61daafb0$var$parcelRegister("abmo4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useOperationStatusCallback", function() {
        return $3da154aa48a5edaf$export$aeb2fb6ba7f2e1af;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $8yTUG = $305cacda61daafb0$var$parcelRequire("8yTUG");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    function $3da154aa48a5edaf$export$aeb2fb6ba7f2e1af(props) {
        const { callback: callback, deps: deps, operation: operation } = props;
        const [status, setStatus] = (0, $acw62.useState)({});
        const result = (0, $acw62.useCallback)(async (...args)=>{
            setStatus({
                loading: true,
                operationType: operation
            });
            try {
                const data = await callback(...args);
                const new_status = {
                    loading: false,
                    data: data,
                    operationType: operation
                };
                if ((0, $8yTUG.isDBStatusResult)(data) && data.Failed) new_status.error = (0, $98ddT.toDBStatusMicroMError)(data.Results);
                if ((0, $98ddT.isMicroMError)(data)) new_status.error = data;
                setStatus(new_status);
                return new_status;
            } catch (e) {
                if (e.name !== 'AbortError') {
                    const new_status = {
                        error: e.Errors ? (0, $98ddT.toDBStatusMicroMError)(e.Errors, operation) : (0, $98ddT.toMicroMError)(e),
                        operationType: operation
                    };
                    setStatus(new_status);
                    return new_status;
                } else return {
                    loading: false,
                    operationType: operation
                };
            }
        }, [
            callback,
            operation,
            ...deps
        ]);
        return {
            operationCallback: result,
            status: status
        };
    }
});
$305cacda61daafb0$var$parcelRegister("fL9cC", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailFieldDefaultProps", function() {
        return $5783e2898020a483$export$fd661e07366da84f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailField", function() {
        return $5783e2898020a483$export$e78a688765264a0;
    });
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    const $5783e2898020a483$export$fd661e07366da84f = {
        invalidMessage: "Enter a valid Email"
    };
    function $5783e2898020a483$export$e78a688765264a0(props) {
        const { invalidMessage: invalidMessage } = (0, $64A2P.useComponentDefaultProps)('EmailField', $5783e2898020a483$export$fd661e07366da84f, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
            ...props,
            validate: {
                email: {
                    message: invalidMessage
                }
            },
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($dQNuR.default, {
                size: "1rem"
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("4vdkC", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UrlFieldDefaultProps", function() {
        return $aa4c9ab34188d604$export$b956574de565796a;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UrlField", function() {
        return $aa4c9ab34188d604$export$39403b659adc9685;
    });
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    const $aa4c9ab34188d604$export$b956574de565796a = {
        invalidMessage: "Invalid URL",
        requiredMessage: "A value is required"
    };
    function $aa4c9ab34188d604$export$39403b659adc9685(props) {
        const { invalidMessage: invalidMessage } = (0, $64A2P.useComponentDefaultProps)('UrlField', $aa4c9ab34188d604$export$b956574de565796a, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
            ...props,
            validate: {
                url: {
                    message: invalidMessage
                }
            },
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($lLqe7.default, {
                size: "1rem"
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("g22qX", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useDynamicContent", function() {
        return $ea4f22a2a6349652$export$b26bde0904735e6;
    });
    const $ea4f22a2a6349652$var$defaultProps = {
        loading: /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {})
    };
    function $ea4f22a2a6349652$export$b26bde0904735e6(props) {
        const { dynamicContent: dynamicContent, loading: loading, contentState: contentState } = {
            ...$ea4f22a2a6349652$var$defaultProps,
            ...props
        };
        const [, setContent] = contentState;
        (0, $acw62.useEffect)(()=>{
            let mounted = true;
            setContent(loading);
            dynamicContent.then((ImportedContent)=>{
                if (mounted) setContent(ImportedContent);
            });
            return ()=>{
                mounted = false;
            };
        }, [
            dynamicContent,
            loading,
            setContent
        ]);
    }
});
$305cacda61daafb0$var$parcelRegister("khunK", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CopyToClipboard", function() {
        return $eca6cf9f0e2e456b$export$2e6ef246283472d6;
    });
    const $eca6cf9f0e2e456b$var$defaultProps = {
        timeout: 500,
        copiedColor: 'green',
        variant: 'filled',
        iconSize: '1.1rem'
    };
    function $eca6cf9f0e2e456b$export$2e6ef246283472d6(props) {
        const { valueToCopy: valueToCopy, timeout: timeout, copiedColor: copiedColor, iconSize: iconSize } = (0, $64A2P.useComponentDefaultProps)('CopyToClipboard', $eca6cf9f0e2e456b$var$defaultProps, props);
        const { copied: copied, copy: copy } = (0, $cqdgS.useClipboard)({
            timeout: timeout
        });
        const originalColor = (0, $acw62.useRef)(props.color);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
            color: copied ? copiedColor : originalColor.current,
            onClick: ()=>copy(valueToCopy),
            ...props,
            children: copied ? /*#__PURE__*/ (0, $ayMG0.jsx)($3US3h.default, {
                size: iconSize
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($8mEM1.default, {
                size: iconSize
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("jom6Y", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CodeBlock", function() {
        return $8a08e1458b35a59c$export$6c415d1fdae3dfdb;
    });
    const $8a08e1458b35a59c$var$defaultProps = {};
    function $8a08e1458b35a59c$export$6c415d1fdae3dfdb(props) {
        const { codeText: codeText, language: language } = (0, $64A2P.useComponentDefaultProps)('CodeBlock', $8a08e1458b35a59c$var$defaultProps, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($eM8d1.Prism, {
            styles: {
                scrollArea: {
                    flexGrow: 1,
                    minHeight: '60vh'
                }
            },
            mih: "60vh",
            mah: "60vh",
            sx: {
                display: "flex"
            },
            language: language,
            children: codeText ?? ''
        });
    }
});
$305cacda61daafb0$var$parcelRegister("jAbjP", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DateInputFieldDefaultProps", function() {
        return $0a26fe4e8fff9c9b$export$ee4b96d029210384;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DateInputField", function() {
        return $0a26fe4e8fff9c9b$export$ff16118c7dead423;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    $305cacda61daafb0$var$$parcel$interopDefault($gngdn).extend($305cacda61daafb0$var$$parcel$interopDefault($lHTSI));
    const $0a26fe4e8fff9c9b$export$ee4b96d029210384 = {
        validationContainer: $9mTYo.Group,
        maw: '20rem',
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($gsgdS.default, {
            size: "1rem"
        }),
        allowDeselect: true,
        valueFormat: 'YYYY-MM-DD',
        popoverProps: {
            withinPortal: true,
            zIndex: 10000
        }
    };
    const $0a26fe4e8fff9c9b$export$ff16118c7dead423 = /*#__PURE__*/ (0, $acw62.forwardRef)(function DateInputField(props, ref) {
        const { column: column, entityForm: entityForm, validate: validate, validationContainer: validationContainer, required: required, requiredMessage: requiredMessage, readOnly: readOnly, label: label, placeholder: placeholder, description: description, withAsterisk: withAsterisk, autoFocus: autoFocus, clearable: clearable, valueFormat: valueFormat, ...others } = (0, $64A2P.useComponentDefaultProps)('DateInputField', $0a26fe4e8fff9c9b$export$ee4b96d029210384, props);
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const [showDescription] = entityForm.showDescriptionState;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($eW7ob.DateInput, {
            ...others,
            valueFormat: valueFormat,
            required: required ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            label: label ?? column.prompt,
            placeholder: placeholder ?? column.placeholder,
            description: showDescription ? description ?? column.description : '',
            clearable: clearable ?? (!readOnly && !(entityForm.formMode === 'view')),
            "data-autofocus": autoFocus,
            readOnly: readOnly || entityForm.formMode === 'view',
            ...entityForm.form.getInputProps(column.name),
            ref: ref
        });
    });
});
$305cacda61daafb0$var$parcelRegister("6pUmH", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "NumberField", function() {
        return $d1bc0d6cc2473c1a$export$63c5fa0b2fdccd2e;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    const $d1bc0d6cc2473c1a$var$defaultProps = {
        validationContainer: $9mTYo.Group
    };
    const $d1bc0d6cc2473c1a$export$63c5fa0b2fdccd2e = /*#__PURE__*/ (0, $acw62.forwardRef)(function NumberField(props, ref) {
        const { column: column, entityForm: entityForm, validate: validate, validationContainer: validationContainer, required: required, requiredMessage: requiredMessage, readOnly: readOnly, label: label, placeholder: placeholder, description: description, withAsterisk: withAsterisk, autoFocus: autoFocus, ...others } = (0, $64A2P.useComponentDefaultProps)('NumberField', $d1bc0d6cc2473c1a$var$defaultProps, props);
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const [showDescription] = entityForm.showDescriptionState;
        // MMC: disabled when loading is done at the form level in EntityForm and fieldset
        //data-autofocus={autoFocus}  disabled={(disableOnLoading) ? loading : disabled}
        return /*#__PURE__*/ (0, $ayMG0.jsx)($hasER.NumberInput, {
            ...others,
            withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            label: label ?? column.prompt,
            placeholder: placeholder ?? column.placeholder,
            description: showDescription ? description ?? column.description : '',
            readOnly: entityForm.formMode === 'view' ? true : readOnly,
            "data-autofocus": autoFocus,
            precision: column.scale,
            ...entityForm.form.getInputProps(column.name),
            // FIX for maintine NumberInput not supporting null
            value: entityForm.form.values[column.name] === null ? '' : entityForm.form.values[column.name],
            ref: ref
        });
    });
});
$305cacda61daafb0$var$parcelRegister("9GCyf", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useHierarchyKeys", function() {
        return $7f5304fd68d04ed6$export$1dc6a021c60990b5;
    });
    const $7f5304fd68d04ed6$var$generateInitialParentKeysArray = (hierarchy)=>{
        const initialArray = [];
        for(let i = 0; i < hierarchy.length; i++){
            const parentKeys = {};
            for(let j = 0; j < i; j++)parentKeys[hierarchy[j]] = '';
            initialArray.push(parentKeys);
        }
        return initialArray;
    };
    function $7f5304fd68d04ed6$export$1dc6a021c60990b5(props) {
        const { formAPI: formAPI, hierarchy: hierarchy, mappedHierarchy: mappedHierarchy } = props;
        const [parentKeysArray, setParentKeysArray] = (0, $acw62.useState)(()=>$7f5304fd68d04ed6$var$generateInitialParentKeysArray(mappedHierarchy || hierarchy));
        const parentKeysArrayRef = (0, $acw62.useRef)(parentKeysArray);
        // Previous values are handled in an array, not affected by mapping
        // Need to make a copy here cause mantine do shallow merge and retain the same reference
        const previousHierarchyValues = (0, $acw62.useRef)(JSON.parse(JSON.stringify(formAPI.form.values)));
        (0, $acw62.useEffect)(()=>{
            // Check if hierarchy values had changed
            let hasHierarchyValueChanged = false;
            let changedIndex = -1;
            hierarchy.forEach((h, index)=>{
                if (previousHierarchyValues.current[index] !== formAPI.form.values[h]) {
                    hasHierarchyValueChanged = true;
                    changedIndex = index;
                }
            });
            // If no hierarchy value has changed, exit the effect
            if (!hasHierarchyValueChanged) return;
            const newParentKeysArray = [];
            hierarchy.forEach((name, index)=>{
                const parentKeys = {};
                for(let i = 0; i <= index; i++){
                    const formValueName = hierarchy[i];
                    const mappedName = mappedHierarchy?.[i] || formValueName;
                    // If we are looking at a level subsequent to the changed level, reset its value.
                    if (i > changedIndex) parentKeys[mappedName] = '';
                    else if (formValueName in formAPI.form.values) parentKeys[mappedName] = formAPI.form.values[formValueName];
                }
                newParentKeysArray.push(parentKeys);
            });
            const hasChanged = newParentKeysArray.some((item, index)=>{
                const oldKeys = parentKeysArrayRef.current[index];
                const newKeys = item;
                return Object.keys(newKeys).some((key)=>newKeys[key] !== oldKeys[key]);
            });
            if (hasChanged) {
                //console.log('Parent keys array', newParentKeysArray);
                setParentKeysArray(newParentKeysArray);
                parentKeysArrayRef.current = newParentKeysArray;
                // MMC: as we are changing related values due to a parent change we need to call setFieldValue
                // changing the binded value is taken care by default
                hierarchy.slice(changedIndex + 1).forEach((name)=>{
                    formAPI.form.setFieldValue(name, '');
                });
            }
            previousHierarchyValues.current = hierarchy.map((h)=>formAPI.form.values[h]);
        }, [
            formAPI.form,
            formAPI.form.values,
            hierarchy,
            mappedHierarchy
        ]);
        return parentKeysArray;
    }
});
$305cacda61daafb0$var$parcelRegister("k4b2f", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "PhoneFieldDefaultProps", function() {
        return $5d98ff7addebc137$export$245b4f05f842329f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "PhoneField", function() {
        return $5d98ff7addebc137$export$a2638f6c2fc66a45;
    });
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    const $5d98ff7addebc137$export$245b4f05f842329f = {
        invalidMessage: "Enter a valid Phone number. Only an optional + sign and numbers allowed.",
        placeholder: "+82113214576",
        showCallIcon: true,
        showWhatsappIcon: true
    };
    function $5d98ff7addebc137$export$a2638f6c2fc66a45(props) {
        const { invalidMessage: invalidMessage, entityForm: entityForm, column: column, showWhatsappIcon: showWhatsappIcon, showCallIcon: showCallIcon, ...others } = (0, $64A2P.useComponentDefaultProps)('PhoneField', $5d98ff7addebc137$export$245b4f05f842329f, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const { form: form } = entityForm;
        const callHref = (0, $acw62.useRef)({});
        const whatsappHref = (0, $acw62.useRef)({});
        const lastValidValue = (0, $acw62.useRef)(null);
        (0, $acw62.useEffect)(()=>{
            if (lastValidValue.current !== null && form.values[column.name] === lastValidValue.current) return;
            if (form.isValid(column.name)) {
                callHref.current = {
                    href: `tel:${entityForm.form.values[column.name]}`,
                    target: '_blank'
                };
                whatsappHref.current = {
                    href: `whatsapp://send?phone=${entityForm.form.values[column.name]}`,
                    target: '_blank'
                };
                lastValidValue.current = entityForm.form.values[column.name];
            } else {
                callHref.current = {};
                whatsappHref.current = {};
            }
        }, [
            column.name,
            entityForm.form.values,
            form
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
            ...others,
            entityForm: entityForm,
            column: column,
            validate: {
                phone: {
                    message: invalidMessage
                }
            },
            rightSection: (showCallIcon || showWhatsappIcon) && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                spacing: "xs",
                children: [
                    showCallIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                        component: "a",
                        ...callHref.current,
                        rel: "noopener noreferrer",
                        color: theme.primaryColor,
                        variant: "light",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($jGUpw.default, {
                            size: "1rem"
                        })
                    }),
                    showWhatsappIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                        component: "a",
                        ...whatsappHref.current,
                        rel: "noopener noreferrer",
                        color: theme.primaryColor,
                        variant: "light",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($iwBxo.default, {
                            size: "1rem"
                        })
                    })
                ]
            }),
            rightSectionWidth: showCallIcon && showWhatsappIcon ? "5rem" : "2.5rem"
        });
    }
});
$305cacda61daafb0$var$parcelRegister("fFu0M", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CUITFieldDefaultProps", function() {
        return $d23a08d7ed52111e$export$c76675cb788eac91;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CUITField", function() {
        return $d23a08d7ed52111e$export$a37ff23e144c8c46;
    });
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    const $d23a08d7ed52111e$export$c76675cb788eac91 = {
        invalidMessage: "Enter a valid CUIT/CUIL nummber"
    };
    function $d23a08d7ed52111e$export$a37ff23e144c8c46(props) {
        const { invalidMessage: invalidMessage } = (0, $64A2P.useComponentDefaultProps)('CUITField', $d23a08d7ed52111e$export$c76675cb788eac91, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
            ...props,
            validate: {
                cuit: {
                    message: invalidMessage
                }
            },
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($bLAHN.default, {
                size: "1rem"
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("6Tg0K", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useParentKeys", function() {
        return $feb3b896c48c1f2a$export$63173dda48cd7d28;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    const $feb3b896c48c1f2a$var$createParentKeysObject = (columnNames, values, entity)=>{
        const parentKeys = {};
        const formKeys = Object.keys(values);
        const entityKeys = Object.keys(entity.def.columns);
        const entityParentKeysNames = entity.parentKeys ? Object.keys(entity.parentKeys) : [];
        for(let i = 0; i < columnNames.length; i++){
            const colName = columnNames[i];
            // MMC: if the column is in the form, use the value from the form
            if (formKeys.includes(colName)) parentKeys[colName] = values[colName];
            else if (entityKeys.includes(colName)) parentKeys[colName] = entity.def.columns[colName].value;
            else if (entityParentKeysNames.includes(colName)) parentKeys[colName] = entity.parentKeys[colName];
            else parentKeys[colName] = '';
        }
        return parentKeys;
    };
    function $feb3b896c48c1f2a$export$63173dda48cd7d28(props) {
        const { formAPI: formAPI, columnNames: columnNames, entity: entity } = props;
        const [parentKeys, setParentKeys] = (0, $acw62.useState)($feb3b896c48c1f2a$var$createParentKeysObject(columnNames, formAPI.form.values, entity));
        const previousParentKeys = (0, $acw62.useRef)({});
        (0, $acw62.useEffect)(()=>{
            const newParentKeys = $feb3b896c48c1f2a$var$createParentKeysObject(columnNames, formAPI.form.values, entity);
            if ((0, $iKzSR.areValuesObjectsEqual)(previousParentKeys.current, newParentKeys)) return;
            setParentKeys(newParentKeys);
            previousParentKeys.current = (0, $iKzSR.copyValuesObject)(newParentKeys);
        }, [
            formAPI.form,
            formAPI.form.values,
            columnNames,
            entity,
            entity.parentKeys
        ]);
        return parentKeys;
    }
});
$305cacda61daafb0$var$parcelRegister("1trwm", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "TimeFieldDefaultProps", function() {
        return $4d7c21d6728b5e66$export$255c7f542dff84;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "TimeField", function() {
        return $4d7c21d6728b5e66$export$5eaee2322dd727eb;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    const $4d7c21d6728b5e66$export$255c7f542dff84 = {
        showTimePicker: true,
        maw: '20rem'
    };
    const $4d7c21d6728b5e66$export$5eaee2322dd727eb = /*#__PURE__*/ (0, $acw62.forwardRef)(function TimeField(props, ref) {
        const { entityForm: entityForm, column: column, validationContainer: validationContainer, validate: validate, required: required, requiredMessage: requiredMessage, readOnly: readOnly, showTimePicker: showTimePicker, label: label, placeholder: placeholder, description: description, withAsterisk: withAsterisk, autoFocus: autoFocus, ...others } = (0, $64A2P.useComponentDefaultProps)('TimeField', $4d7c21d6728b5e66$export$255c7f542dff84, props);
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const [showDescription] = entityForm.showDescriptionState;
        const clockRef = (0, $acw62.useRef)(null);
        // Expose the showPicker method to the parent using the ref
        (0, $acw62.useImperativeHandle)(ref, ()=>({
                showPicker: ()=>{
                    clockRef.current?.showPicker?.();
                }
            }), []);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bXiXt.TimeInput, {
            ...others,
            withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            label: label ?? column.prompt,
            placeholder: placeholder ?? column.placeholder,
            description: showDescription ? description ?? column.description : '',
            "data-autofocus": autoFocus,
            ref: clockRef,
            rightSection: showTimePicker && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                disabled: readOnly,
                onClick: ()=>clockRef.current?.showPicker?.(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($bPGo2.default, {
                    size: "1rem",
                    stroke: 1.5
                })
            }),
            rightSectionWidth: showTimePicker ? "2.5rem" : undefined,
            ...entityForm.form.getInputProps(column.name)
        });
    });
});
$305cacda61daafb0$var$parcelRegister("1cuD1", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useIsLoggedIn", function() {
        return $3bfcddb14bcddf39$export$79c3258edc7d1573;
    });
    var $j7hNv = $305cacda61daafb0$var$parcelRequire("j7hNv");
    function $3bfcddb14bcddf39$export$79c3258edc7d1573({ client: client, useLocalLoggedInCheck: useLocalLoggedInCheck, userInitialsClientClaimsNames: userInitialsClientClaimsNames }) {
        const [isLoggedIn, setIsLoggedIn] = (0, $acw62.useState)(undefined);
        const [loggedInInfo, setLoggedInInfo] = (0, $acw62.useState)({});
        const checkIsLoggedIn = (0, $acw62.useCallback)(async ()=>{
            try {
                const result = useLocalLoggedInCheck ? await client.isLoggedInLocal() : await client.isLoggedIn();
                setIsLoggedIn(result);
            } catch (e) {
                setIsLoggedIn(false);
            }
        }, [
            client,
            useLocalLoggedInCheck
        ]);
        (0, $acw62.useEffect)(()=>{
            async function check() {
                await checkIsLoggedIn();
            }
            check();
        }, [
            checkIsLoggedIn
        ]);
        (0, $acw62.useEffect)(()=>{
            async function getInfo() {
                if (isLoggedIn) {
                    const info = client.LOGGED_IN_USER;
                    // get intials from the client claims using userInitialsClientClaimsNames. Take the properties values from the client claims it those exist,
                    // join them in a string separated with ' ' and use that as the input for the getInitials function
                    // if not use the default client.userInitialsInput
                    const userInitialsClientClaims = info ? userInitialsClientClaimsNames?.map((name)=>info[name]).filter((value)=>value).join(' ') || info.username || '' : '';
                    if (info?.username) info.userinitials = (0, $j7hNv.getInitials)(userInitialsClientClaims);
                    setLoggedInInfo(info ?? {});
                } else setLoggedInInfo({});
            }
            getInfo();
        }, [
            isLoggedIn
        ]);
        return {
            isLoggedIn: isLoggedIn,
            setIsLoggedIn: setIsLoggedIn,
            checkIsLoggedIn: checkIsLoggedIn,
            loggedInInfo: loggedInInfo
        };
    }
});
$305cacda61daafb0$var$parcelRegister("j7hNv", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getInitials", function() {
        return $17922fe056f875c1$export$de9bdbce6502b027;
    });
    function $17922fe056f875c1$export$de9bdbce6502b027(input) {
        const cleanedInput = input.trim().toLowerCase();
        const username = cleanedInput.includes('@') ? cleanedInput.split('@')[0] : cleanedInput;
        const nameParts = username.split(/[\s._-]+/); // split by space, . _ or -
        if (nameParts.length === 1) return nameParts[0].substring(0, 2).toUpperCase();
        const firstInitial = nameParts[0].substring(0, 1).toUpperCase();
        const lastInitial = nameParts[nameParts.length - 1].substring(0, 1).toUpperCase();
        return `${firstInitial}${lastInitial}`;
    }
});
$305cacda61daafb0$var$parcelRegister("lTSno", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "usePreventEnterSubmission", function() {
        return $d938a09a234aa66c$export$cb5794c664eb8630;
    });
    const $d938a09a234aa66c$export$cb5794c664eb8630 = ()=>{
        const handleKeyDown = (event1)=>{
            const target = event1.target;
            const isTargetedKey = [
                'Enter',
                'Return',
                'NumpadEnter'
            ].includes(event1.key);
            // Check for elements that either add new lines or do not submit the form by default on "Enter"
            const nonSubmittingElements = [
                'TEXTAREA',
                'SELECT',
                'BUTTON',
                'A'
            ];
            // For input, we want to prevent default behavior for types other than 'submit'
            const isInputNotSubmit = target.tagName === 'INPUT' && event1.target.type !== 'submit';
            if (isTargetedKey && !event1.shiftKey && !event1.altKey && !event1.ctrlKey && (nonSubmittingElements.includes(target.tagName) === false || isInputNotSubmit)) event1.preventDefault();
        };
        return handleKeyDown;
    };
});
$305cacda61daafb0$var$parcelRegister("7ttm6", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "formatDate", function() {
        return $81cc59454e3f39b5$export$3ae94a2503e890a1;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "formatTime", function() {
        return $81cc59454e3f39b5$export$3203edd9e5edd663;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "formatNumber", function() {
        return $81cc59454e3f39b5$export$f5dd818bff069720;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "convertDateToNative", function() {
        return $81cc59454e3f39b5$export$5dd6539d90141996;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "formatSQLValue", function() {
        return $81cc59454e3f39b5$export$62c5cbf81b90da20;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "convertToNativeValue", function() {
        return $81cc59454e3f39b5$export$e41af95719431a64;
    });
    function $81cc59454e3f39b5$export$3ae94a2503e890a1(value, locale, dateOptions) {
        const date = new Date(String(value));
        return new Intl.DateTimeFormat(locale, dateOptions).format(date);
    }
    function $81cc59454e3f39b5$export$3203edd9e5edd663(value, locale, dateOptions) {
        const timeString = String(value);
        const [hours, minutes, seconds] = timeString.split(':');
        const [mainSeconds, milliseconds] = seconds?.split('.') || [];
        const date = new Date(2000, 0, 1, Number(hours), Number(minutes), Number(mainSeconds));
        return new Intl.DateTimeFormat(locale, dateOptions).format(date);
    }
    function $81cc59454e3f39b5$export$f5dd818bff069720(value, locale) {
        return new Intl.NumberFormat(locale).format(Number(value));
    }
    function $81cc59454e3f39b5$export$5dd6539d90141996(value, serverTimeZoneOffset) {
        // If the value already includes an explicit timezone indicator, parse as is.
        if (value.endsWith('Z') || value.includes('GMT') || value.includes('GMT+') || value.includes('GMT-')) return new Date(value);
        if (serverTimeZoneOffset === undefined) serverTimeZoneOffset = 0;
        // Otherwise, add server timezone offset to the date string.
        const date = new Date(value);
        const localTimeZoneOffset = date.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
        const adjustedTime = date.getTime() + localTimeZoneOffset + serverTimeZoneOffset * 3600000; // Convert hours to milliseconds
        return new Date(adjustedTime);
    }
    function $81cc59454e3f39b5$export$62c5cbf81b90da20(value, sqlType, locale) {
        if (value === null) return 'null';
        switch(sqlType){
            case 'date':
                return $81cc59454e3f39b5$export$3ae94a2503e890a1(value, locale, {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                });
            case 'datetime':
            case 'datetime2':
                return $81cc59454e3f39b5$export$3ae94a2503e890a1(value, locale, {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour12: false,
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
                });
            case 'smalldatetime':
                return $81cc59454e3f39b5$export$3ae94a2503e890a1(value, locale, {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour12: false,
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit"
                });
            case 'time':
                return $81cc59454e3f39b5$export$3203edd9e5edd663(value, locale, {
                    hour12: false,
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit"
                });
            case 'float':
            case 'decimal':
            case 'real':
            case 'money':
                return $81cc59454e3f39b5$export$f5dd818bff069720(value, locale);
            // For text-based SQL types and others, we'll return the value as a string for now.
            case 'char':
            case 'nchar':
            case 'varchar':
            case 'nvarchar':
            case 'text':
            case 'ntext':
            case 'int':
            case 'bigint':
            case 'bit':
            case 'binary':
            case 'varbinary':
            case 'image':
            default:
                return String(value);
        }
    }
    function $81cc59454e3f39b5$export$e41af95719431a64(value, sqlType, serverTimezoneOffset) {
        if (typeof value !== 'string') return value;
        switch(sqlType){
            case 'char':
            case 'nchar':
            case 'varchar':
            case 'nvarchar':
            case 'text':
            case 'ntext':
            case 'binary':
            case 'varbinary':
            case 'image':
            case 'time':
                return value;
            case 'smallint':
            case 'int':
            case 'bigint':
            case 'float':
            case 'real':
            case 'decimal':
            case 'money':
                return Number(value);
            case 'datetime2':
            case 'datetime':
            case 'smalldatetime':
            case 'date':
                return $81cc59454e3f39b5$export$5dd6539d90141996(value, serverTimezoneOffset);
            default:
                return value;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("a2vzY", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseLocaleFormatDefaultProps", function() {
        return $7445133e95ae8089$export$da03655abff5c59b;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useLocaleFormat", function() {
        return $7445133e95ae8089$export$6f2f7bc6c278ece1;
    });
    var $7ttm6 = $305cacda61daafb0$var$parcelRequire("7ttm6");
    const $7445133e95ae8089$export$da03655abff5c59b = {
        initialLocale: navigator.language
    };
    function $7445133e95ae8089$export$6f2f7bc6c278ece1(props) {
        const { initialLocale: initialLocale, timeZoneOffset: timeZoneOffset } = (0, $64A2P.useComponentDefaultProps)('useLocaleFormat', $7445133e95ae8089$export$da03655abff5c59b, props);
        const [locale, setLocale] = (0, $acw62.useState)(initialLocale);
        const formatValue = (0, $acw62.useCallback)(function(value, sqlType) {
            const result = (0, $7ttm6.formatSQLValue)(value, sqlType, locale);
            return result;
        }, [
            locale,
            timeZoneOffset
        ]);
        const getNativeValue = (0, $acw62.useCallback)(function(value, sqlType) {
            const result = (0, $7ttm6.convertToNativeValue)(value, sqlType, timeZoneOffset);
            return result;
        }, [
            locale,
            timeZoneOffset
        ]); // locale is here so the values captured here are in sync with formatValue
        const formatColumnValue = (0, $acw62.useCallback)((col)=>{
            const result = (0, $7ttm6.formatSQLValue)(col.value, col.type, locale);
            return result === 'null' ? '' : result;
        }, [
            locale,
            timeZoneOffset
        ]);
        return {
            locale: locale,
            setLocale: setLocale,
            formatValue: formatValue,
            getNativeValue: getNativeValue,
            formatColumnValue: formatColumnValue
        };
    }
});
$305cacda61daafb0$var$parcelRegister("1uAlg", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useEntityUI", function() {
        return $44e7b7cb2565e4b7$export$c7c6b9c457b10b8a;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    $305cacda61daafb0$var$parcelRequire("zzexY");
    var $99l4z = $305cacda61daafb0$var$parcelRequire("99l4z");
    var $j7Y9b = $305cacda61daafb0$var$parcelRequire("j7Y9b");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    var $ivqW2 = $305cacda61daafb0$var$parcelRequire("ivqW2");
    function $44e7b7cb2565e4b7$export$c7c6b9c457b10b8a(props) {
        const { entity: entity, onModalCancelled: onModalCancelled, onModalSaved: onModalSaved, modalFormSize: modalFormSize, parentFormAPI: parentFormAPI, saveFormBeforeAdd: saveFormBeforeAdd, onModalClosed: onModalClosed, parentKeys: parentKeys, labels: labels, onRecordsDeleted: onRecordsDeleted, onActionRefreshOnClose: onActionRefreshOnClose, onAddClick: onAddClick, onEditClick: onEditClick, onDeleteClick: onDeleteClick, onActionExecuted: onActionExecuted, withModalFullscreenButton: withModalFullscreenButton } = props;
        const modals = (0, $k7qj2.useModal)();
        const cancelled = (0, $acw62.useRef)();
        const handleModalSaved = (0, $acw62.useCallback)(async (new_status)=>{
            await modals.close();
            if (onModalSaved) await onModalSaved(new_status);
        }, [
            modals,
            onModalSaved
        ]);
        const handleModalCancel = (0, $acw62.useCallback)(async ()=>{
            cancelled.current = true;
            await modals.close();
            if (onModalCancelled) await onModalCancelled();
        }, [
            modals,
            onModalCancelled
        ]);
        const handleModalClosed = (0, $acw62.useCallback)(async ()=>{
            if (onModalClosed) await onModalClosed(cancelled.current);
        }, [
            onModalClosed
        ]);
        const openForm = (0, $acw62.useCallback)(async (entity, initialFormMode, title, element, getDataOnInit, onClosed)=>{
            await (0, $ivqW2.openEntityForm)({
                modals: modals,
                title: title,
                element: element,
                handleModalSaved: handleModalSaved,
                handleModalCancel: handleModalCancel,
                modalFormSize: modalFormSize,
                withModalFullscreenButton: withModalFullscreenButton,
                handleModalClosed: async ()=>{
                    await handleModalClosed();
                    if (onClosed) await onClosed();
                },
                formProps: {
                    entity: entity,
                    initialFormMode: initialFormMode,
                    getDataOnInit: getDataOnInit
                }
            });
        }, [
            modals,
            handleModalSaved,
            handleModalCancel,
            modalFormSize,
            withModalFullscreenButton,
            handleModalClosed
        ]);
        const importData = (0, $99l4z.useImportDataForm)({
            initialFormMode: 'add',
            modalFormSize: 'xl',
            handleModalCancel: handleModalCancel,
            handleModalSaved: handleModalSaved
        });
        const handleSaveBeforeAdd = (0, $acw62.useCallback)(async ()=>{
            //if (entity?.Form === null) return "notsaved";
            if (parentFormAPI && saveFormBeforeAdd && parentFormAPI?.formMode === "add") {
                const result = parentFormAPI.form.validate();
                if (!result.hasErrors) {
                    const result = await parentFormAPI.saveAndGet(true);
                    if (!result.error) return "saved";
                    else return "error";
                } else {
                    const [, setNotifyValidationError] = parentFormAPI.notifyValidationErrorState;
                    setNotifyValidationError(true);
                    return "error";
                }
            }
            return "notsaved";
        }, [
            parentFormAPI,
            saveFormBeforeAdd
        ]);
        const handleImportDataClick = (0, $acw62.useCallback)(async ()=>{
            if (!entity) return;
            const saveResult = await handleSaveBeforeAdd();
            if (saveResult !== 'error') {
                const importEntity = (0, $bFPBM.Entity).clone(entity);
                // Set parentKeys
                const local_parentkeys = parentKeys ? parentKeys : {};
                const mergedParentKeys = {
                    ...$iKzSR.getValues(importEntity.def.columns, {
                        flags: $4H7ea.EntityColumnFlags.pk,
                        ignoreDefaults: false
                    }),
                    ...Object.fromEntries(Object.entries(local_parentkeys).filter(([key, value])=>value != null && value !== ""))
                };
                importEntity.parentKeys = mergedParentKeys;
                await importData.openImportDataForm(importEntity);
            }
        }, [
            entity,
            handleSaveBeforeAdd,
            importData,
            parentKeys
        ]);
        const internalAddClick = (0, $acw62.useCallback)(async (element, onClosed)=>{
            if (entity?.Form === null) return;
            const addEntity = (0, $bFPBM.Entity).clone(entity);
            // Set parentKeys
            $iKzSR.setValues(addEntity.def.columns, parentKeys, null, true, true);
            if (parentFormAPI) $iKzSR.setValues(addEntity.def.columns, parentFormAPI.entity.def.columns, {
                flags: $4H7ea.EntityColumnFlags.pk | $4H7ea.EntityColumnFlags.fk,
                ignoreDefaults: false
            }, true, true);
            await openForm(addEntity, "add", labels?.addLabel, element, undefined, async ()=>{
                if (onClosed) await onClosed(cancelled.current);
            });
        }, [
            entity,
            labels?.addLabel,
            openForm,
            parentFormAPI,
            parentKeys
        ]);
        const handleAddClick = (0, $acw62.useCallback)(async (element, onClosed)=>{
            if (!onAddClick && (entity?.Form === null || entity === undefined)) return;
            const resultSaveBeforeAdd = await handleSaveBeforeAdd();
            if (resultSaveBeforeAdd === "error") return;
            if (onAddClick) await onAddClick(internalAddClick, element);
            else await internalAddClick(element, onClosed);
        }, [
            onAddClick,
            entity,
            handleSaveBeforeAdd,
            internalAddClick
        ]);
        const handleEditClick = (0, $acw62.useCallback)(async (keys, element, onClosed)=>{
            if (entity?.Form === null) return;
            if (keys) {
                // MMC: handleSaveBeforeAdd special case, if the parentform is in add mode and the form is not saved, we save it before editing
                const resultSaveBeforeAdd = await handleSaveBeforeAdd();
                if (resultSaveBeforeAdd === "error") return;
                const editEntity = (0, $bFPBM.Entity).clone(entity);
                // Set parentKeys
                $iKzSR.setValues(editEntity.def.columns, parentKeys, null, true, true);
                if (resultSaveBeforeAdd === "saved") $iKzSR.setValues(editEntity.def.columns, parentFormAPI.entity.def.columns, {
                    flags: $4H7ea.EntityColumnFlags.pk | $4H7ea.EntityColumnFlags.fk,
                    ignoreDefaults: false
                }, true, true);
                (0, $iKzSR.setValues)(editEntity.def.columns, keys, null, true);
                await openForm(editEntity, "edit", labels?.editLabel, element, true, async ()=>{
                    if (onClosed) await onClosed(cancelled.current);
                });
            }
        }, [
            entity,
            handleSaveBeforeAdd,
            parentKeys,
            openForm,
            labels?.editLabel,
            parentFormAPI
        ]);
        const handleViewClick = (0, $acw62.useCallback)(async (keys, element, onClosed)=>{
            if (entity?.Form === null) return;
            if (keys) {
                const viewEntity = (0, $bFPBM.Entity).clone(entity);
                // Set parentKeys
                $iKzSR.setValues(viewEntity.def.columns, parentKeys, null, true, true);
                (0, $iKzSR.setValues)(viewEntity.def.columns, keys, null, true);
                await openForm(viewEntity, "view", labels?.viewLabel, element, true, async ()=>{
                    if (onClosed) await onClosed(cancelled.current);
                });
            }
        }, [
            entity,
            parentKeys,
            openForm,
            labels?.viewLabel
        ]);
        const handleDeleteClick = (0, $acw62.useCallback)(async (keys, element)=>{
            if (!entity) return;
            if (keys.length) {
                const abort_controller = new AbortController();
                await modals.open({
                    modalProps: {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($34B0U.default, {
                                    size: "1.5rem",
                                    stroke: "1.5"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                    fw: "700",
                                    children: labels?.warningLabel
                                })
                            ]
                        })
                    },
                    focusOnClosed: element,
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)($j7Y9b.ConfirmAndExecutePanel, {
                        onOK: async ()=>{
                            const deleteEntity = (0, $bFPBM.Entity).clone(entity);
                            // Merge parentKeys with deleteEntity.parentKeys and remove keys named in keys
                            const mergedParentKeys = {
                                ...$iKzSR.getValues(deleteEntity.def.columns, {
                                    flags: $4H7ea.EntityColumnFlags.pk,
                                    ignoreDefaults: false
                                }),
                                ...parentKeys
                            };
                            if (keys.length === 1) {
                                (0, $iKzSR.setValues)(deleteEntity.def.columns, keys[0], null, true);
                                // Delete selected keys from mergedParentKeys
                                Object.keys(keys[0]).forEach((key)=>{
                                    delete mergedParentKeys[key];
                                });
                                const result = await deleteEntity.API.deleteData(undefined, abort_controller.signal, mergedParentKeys);
                                if (onRecordsDeleted) onRecordsDeleted();
                                await modals.close();
                                return result;
                            } else {
                                // Delete selected keys from mergedParentKeys. We use the first key to get the keys names
                                Object.keys(keys[0]).forEach((key)=>{
                                    delete mergedParentKeys[key];
                                });
                                const result = await deleteEntity.API.deleteData(keys, abort_controller.signal, mergedParentKeys);
                                if (onRecordsDeleted) onRecordsDeleted();
                                await modals.close();
                                return result;
                            }
                        },
                        onCancel: async ()=>{
                            await abort_controller.abort();
                            await modals.close();
                        },
                        content: /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                            size: "sm",
                            mb: "xs",
                            children: [
                                labels?.YouWillDeleteLabel,
                                " ",
                                keys.length,
                                " ",
                                labels?.recordsLabel,
                                ". ",
                                labels?.AreYouSureLabel
                            ]
                        }),
                        operation: "delete",
                        okButtonText: labels?.deleteLabel
                    })
                });
            } else modals.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($fIMaa.default, {
                                size: "1.5rem",
                                stroke: "1.5"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                fw: "700",
                                children: labels?.warningLabel
                            })
                        ]
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: "sm",
                            mb: "xs",
                            children: labels?.YouMustSelectOneOrMoreRecordsToDelete
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                            mt: "xs",
                            position: "right",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                onClick: async ()=>await modals.close(),
                                children: labels?.closeLabel
                            })
                        })
                    ]
                })
            });
        }, [
            entity,
            modals,
            labels,
            parentKeys
        ]);
        const handleDeleteRecord = (0, $acw62.useCallback)(async (keys, element)=>{
            await handleDeleteClick([
                keys
            ], element);
        }, [
            handleDeleteClick
        ]);
        const handleExecuteAction = (0, $acw62.useCallback)(async (action, keys, element)=>{
            if (!entity) return;
            if (action.dontRequireSelection || keys.length && (action.minSelectedRecords === undefined || keys.length >= action.minSelectedRecords) && (action.maxSelectedRecords === undefined || keys.length <= action.maxSelectedRecords)) {
                // MMC: if the action requires a form to be saved before executing, we do it here
                const resultSaveBeforeAdd = await handleSaveBeforeAdd();
                if (resultSaveBeforeAdd === "error") return;
                const execEntity = (0, $bFPBM.Entity).clone(entity);
                // Merge parentKeys with execEntity.parentKeys and remove keys named in keys
                const mergedParentKeys = {
                    ...$iKzSR.getValues(execEntity.def.columns, {
                        flags: $4H7ea.EntityColumnFlags.pk,
                        ignoreDefaults: false
                    }),
                    ...parentKeys
                };
                if (keys.length > 0) Object.keys(keys[0]).forEach((key)=>{
                    delete mergedParentKeys[key];
                });
                execEntity.parentKeys = mergedParentKeys;
                if (resultSaveBeforeAdd === "saved") $iKzSR.setValues(execEntity.def.columns, parentFormAPI.entity.def.columns, {
                    flags: $4H7ea.EntityColumnFlags.pk | $4H7ea.EntityColumnFlags.fk,
                    ignoreDefaults: false
                }, true);
                return await action.onClick({
                    entity: execEntity,
                    modal: modals,
                    selectedKeys: keys,
                    element: element,
                    onClose: async (result)=>{
                        if (onActionExecuted) await onActionExecuted(action.name, result);
                        if (action.refreshOnClose && onActionRefreshOnClose) await onActionRefreshOnClose();
                        return Promise.resolve(result ?? false);
                    }
                });
            } else {
                let message = labels?.YouMustSelectOneOrMoreRecordsToExecuteAction;
                if (action.minSelectedRecords !== undefined && action.maxSelectedRecords !== undefined) {
                    if (action.minSelectedRecords === action.maxSelectedRecords) message = `${labels?.YouMustSelect} ${action.minSelectedRecords} ${action.minSelectedRecords === 1 ? labels?.recordLabel : labels?.recordsLabel}`;
                    else message = `${labels?.YouMustSelectBetween} ${action.minSelectedRecords} and ${action.maxSelectedRecords} ${labels?.recordsLabel}`;
                } else if (action.minSelectedRecords !== undefined) message = `${labels?.YouMustSelectAtLeast} ${action.minSelectedRecords} ${action.minSelectedRecords === 1 ? labels?.recordLabel : labels?.recordsLabel}`;
                else if (action.maxSelectedRecords !== undefined) message = `${labels?.YouMustSelectMaximum} ${action.maxSelectedRecords} ${action.maxSelectedRecords === 1 ? labels?.recordLabel : labels?.recordsLabel}`;
                await modals.open({
                    modalProps: {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($fIMaa.default, {
                                    size: "1.5rem",
                                    stroke: "1.5"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                    fw: "700",
                                    children: labels?.warningLabel
                                })
                            ]
                        })
                    },
                    focusOnClosed: element,
                    content: /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                size: "sm",
                                mb: "xs",
                                children: message
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                                mt: "xs",
                                position: "right",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                    onClick: async ()=>{
                                        await modals.close();
                                    },
                                    children: labels?.closeLabel
                                })
                            })
                        ]
                    })
                });
            }
        }, [
            entity,
            parentFormAPI,
            handleSaveBeforeAdd,
            modals,
            labels
        ]);
        return {
            handleAddClick: handleAddClick,
            handleEditClick: handleEditClick,
            handleViewClick: handleViewClick,
            handleDeleteClick: handleDeleteClick,
            handleExecuteAction: handleExecuteAction,
            handleDeleteRecord: handleDeleteRecord,
            handleImportDataClick: handleImportDataClick
        };
    }
});
$305cacda61daafb0$var$parcelRegister("zzexY", function(module1, exports) {
    var $lV8up = $305cacda61daafb0$var$parcelRequire("lV8up");
    var $cjHVl = $305cacda61daafb0$var$parcelRequire("cjHVl");
    var $6vsCT = $305cacda61daafb0$var$parcelRequire("6vsCT");
    var $kJPQt = $305cacda61daafb0$var$parcelRequire("kJPQt");
    var $99l4z = $305cacda61daafb0$var$parcelRequire("99l4z");
    var $ixSh0 = $305cacda61daafb0$var$parcelRequire("ixSh0");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lV8up);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cjHVl);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $6vsCT);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kJPQt);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $99l4z);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ixSh0);
});
$305cacda61daafb0$var$parcelRegister("lV8up", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseImportDataDefaultProps", function() {
        return $70cba0b8724b19bc$export$53ff6b940e564d87;
    });
    const $70cba0b8724b19bc$export$53ff6b940e564d87 = {
        noFileProcessLabel: 'No file process id returned',
        errorImportingDataLabel: 'Error importing data'
    };
});
$305cacda61daafb0$var$parcelRegister("6vsCT", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useEntityCSVImportValidation", function() {
        return $85993f4d80bc1b53$export$5f5eb8e5721cbcd3;
    });
    function $85993f4d80bc1b53$export$5f5eb8e5721cbcd3({ errorReadingFileLabel: errorReadingFileLabel, emptyCSVFileLabel: emptyCSVFileLabel, missingColumnsLabel: missingColumnsLabel }) {
        const validateEntityImportCSVFile = async (props)=>{
            const { file: file, requiredColumns: requiredColumns } = props;
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = (event1)=>{
                    const text = event1.target?.result;
                    const result = validateCSV({
                        text: text,
                        requiredColumns: requiredColumns
                    });
                    resolve(result);
                };
                reader.onerror = ()=>{
                    reject({
                        error: true,
                        message: errorReadingFileLabel
                    });
                };
                reader.readAsText(file);
            });
        };
        const validateCSV = (props)=>{
            const { text: text, requiredColumns: requiredColumns } = props;
            const lines = text.split('\n').filter((line)=>line.trim() !== '');
            if (lines.length === 0) return {
                error: true,
                message: emptyCSVFileLabel
            };
            const headers = lines[0].split(',').map((header)=>header.trim());
            const missingColumns = requiredColumns.filter((col)=>!headers.includes(col));
            if (missingColumns.length > 0) return {
                error: true,
                message: `${missingColumnsLabel} ${missingColumns.join(', ')}`
            };
            return {
                error: false
            };
        };
        return {
            validateEntityImportCSVFile: validateEntityImportCSVFile
        };
    }
});
$305cacda61daafb0$var$parcelRegister("kJPQt", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useImportData", function() {
        return $b8a929c6d1bc1f98$export$5e9493f03f1664e8;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    function $b8a929c6d1bc1f98$export$5e9493f03f1664e8(importEntity) {
        const cancellation = (0, $acw62.useRef)(new AbortController());
        const done = (0, $acw62.useRef)(false);
        const [importStatus, setImportStatus] = (0, $acw62.useState)({
            loading: false,
            operationType: 'import'
        });
        (0, $acw62.useEffect)(()=>{
            cancellation.current = new AbortController();
            done.current = false;
            return ()=>{
                if (!done.current) cancellation.current?.abort("ImportData Effect cleanup");
            };
        }, [
            importEntity
        ]);
        const execute = (0, $acw62.useCallback)(async (fileprocess_id)=>{
            if (!importEntity || !fileprocess_id) return;
            try {
                setImportStatus({
                    loading: true
                });
                done.current = false;
                const result = await importEntity.API.importData(cancellation.current.signal, null, importEntity.parentKeys, fileprocess_id);
                done.current = true;
                const result_status = {
                    data: result,
                    operationType: 'import'
                };
                setImportStatus(result_status);
                return result_status;
            } catch (error) {
                if (error.name !== 'AbortError') {
                    const new_status = {
                        error: error.Errors ? (0, $98ddT.toDBStatusMicroMError)(error.Errors, 'add') : (0, $98ddT.toMicroMError)(error),
                        operationType: 'import'
                    };
                    setImportStatus(new_status);
                    return new_status;
                } else {
                    const new_status = {
                        loading: false,
                        operationType: 'import'
                    };
                    setImportStatus(new_status);
                    return new_status;
                }
            }
        }, [
            importEntity
        ]);
        return {
            execute: execute,
            importStatus: importStatus,
            cancellation: cancellation.current
        };
    }
});
$305cacda61daafb0$var$parcelRegister("99l4z", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useImportDataForm", function() {
        return $69c615d903a81adf$export$13afcfd822f79812;
    });
    var $dOSKU = $305cacda61daafb0$var$parcelRequire("dOSKU");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $ivqW2 = $305cacda61daafb0$var$parcelRequire("ivqW2");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    function $69c615d903a81adf$export$13afcfd822f79812({ initialFormMode: initialFormMode, title: title, element: element, getDataOnInit: getDataOnInit, modalFormSize: modalFormSize, handleModalCancel: handleModalCancel, handleModalClosed: handleModalClosed, handleModalSaved: handleModalSaved }) {
        const modals = (0, $k7qj2.useModal)();
        const openImportDataForm = (0, $acw62.useCallback)(async (importEntity)=>{
            if (!importEntity) return;
            const importData = new $dOSKU.ImportEntityData(importEntity.API.client);
            await (0, $ivqW2.openEntityForm)({
                modals: modals,
                title: title,
                element: element,
                handleModalCancel: handleModalCancel,
                handleModalSaved: handleModalSaved,
                handleModalClosed: handleModalClosed,
                modalFormSize: modalFormSize,
                formProps: {
                    entity: importData,
                    initialFormMode: initialFormMode,
                    getDataOnInit: getDataOnInit,
                    importEntity: importEntity
                }
            });
        }, [
            element,
            getDataOnInit,
            handleModalCancel,
            handleModalClosed,
            handleModalSaved,
            initialFormMode,
            modalFormSize,
            modals,
            title
        ]);
        return {
            openImportDataForm: openImportDataForm
        };
    }
});
$305cacda61daafb0$var$parcelRegister("dOSKU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ImportEntityDataLabels", function() {
        return $de0a99ae8f497891$export$a648d62d17c3844e;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ImportEntityData", function() {
        return $de0a99ae8f497891$export$76107fb94dd5997e;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $3rYji = $305cacda61daafb0$var$parcelRequire("3rYji");
    const $de0a99ae8f497891$export$a648d62d17c3844e = {
        Icon: $aUMvF.default,
        Title: 'Import Data',
        HelpText: 'Import a CSV file with data for this entity.'
    };
    class $de0a99ae8f497891$export$76107fb94dd5997e extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $3rYji.ImportEntityDataDef(), parentKeys);
            this.Form = Promise.resolve($305cacda61daafb0$var$parcelRequire("fyjOM")).then((module1)=>module1.ImportEntityDataForm);
            this.Title = $de0a99ae8f497891$export$a648d62d17c3844e.Title;
            this.HelpText = $de0a99ae8f497891$export$a648d62d17c3844e.HelpText;
            this.Icon = $de0a99ae8f497891$export$a648d62d17c3844e.Icon;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("3rYji", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ImportEntityDataDef", function() {
        return $de6140efa2afea5c$export$70b44821f698eb49;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    $305cacda61daafb0$var$parcelRequire("9KGub");
    var $effl8 = $305cacda61daafb0$var$parcelRequire("effl8");
    const $de6140efa2afea5c$var$columns = ()=>({
            c_fileprocess_id: new $ZmuZ6.EntityColumn({
                name: 'c_fileprocess_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.FK,
                prompt: 'Fileprocess Id'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $de6140efa2afea5c$var$views = ()=>({
            ipr_brwStandard: {
                name: 'ipd_brwStandard',
                keyMappings: {
                    c_import_process: 0
                }
            }
        });
    const $de6140efa2afea5c$var$lookups = ()=>({
            'FileStoreProcess': {
                name: 'FileStoreProcess',
                viewMapping: {
                    keyIndex: 0,
                    descriptionIndex: 1
                },
                entityConstructor: (client, parentKeys)=>new $effl8.FileStoreProcess(client, parentKeys)
            }
        });
    class $de6140efa2afea5c$export$70b44821f698eb49 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('ImportEntityData'), this.columns = $de6140efa2afea5c$var$columns(), this.views = $de6140efa2afea5c$var$views(), this.lookups = $de6140efa2afea5c$var$lookups();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("9KGub", function(module1, exports) {
    var $6KUbX = $305cacda61daafb0$var$parcelRequire("6KUbX");
    var $effl8 = $305cacda61daafb0$var$parcelRequire("effl8");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $6KUbX);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $effl8);
});
$305cacda61daafb0$var$parcelRegister("6KUbX", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FileStoreProcessDef", function() {
        return $6cbb0c44555df2da$export$ee3ac854e7c37a58;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    const $6cbb0c44555df2da$var$columns = ()=>({
            c_fileprocess_id: new $ZmuZ6.EntityColumn({
                name: 'c_fileprocess_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PKAutonum,
                prompt: 'Fileprocess Id'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $6cbb0c44555df2da$var$views = ()=>({
            fsp_brwStandard: {
                name: 'fsp_brwStandard',
                keyMappings: {
                    c_fileprocess_id: 0
                }
            }
        });
    class $6cbb0c44555df2da$export$ee3ac854e7c37a58 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('FileStoreProcess'), this.columns = $6cbb0c44555df2da$var$columns(), this.views = $6cbb0c44555df2da$var$views();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("effl8", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FileStoreProcess", function() {
        return $035a05b49d7a858f$export$1ba2830b423b72c4;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $6KUbX = $305cacda61daafb0$var$parcelRequire("6KUbX");
    class $035a05b49d7a858f$export$1ba2830b423b72c4 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $6KUbX.FileStoreProcessDef(), parentKeys);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("fyjOM", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ImportEntityDataFormDefaultProps", function() {
        return $7eab77bb42152518$export$a50a4787aa02211c;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ImportEntityDataForm", function() {
        return $7eab77bb42152518$export$df2835e2ad4c9d37;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $TaFFV = $305cacda61daafb0$var$parcelRequire("TaFFV");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $4SevU = $305cacda61daafb0$var$parcelRequire("4SevU");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    $305cacda61daafb0$var$parcelRequire("6i1ou");
    var $cWSrD = $305cacda61daafb0$var$parcelRequire("cWSrD");
    var $lTrOu = $305cacda61daafb0$var$parcelRequire("lTrOu");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    var $bW9pc = $305cacda61daafb0$var$parcelRequire("bW9pc");
    $305cacda61daafb0$var$parcelRequire("zzexY");
    var $6vsCT = $305cacda61daafb0$var$parcelRequire("6vsCT");
    var $kJPQt = $305cacda61daafb0$var$parcelRequire("kJPQt");
    const $7eab77bb42152518$export$a50a4787aa02211c = {
        initialFormMode: "view",
        importInfoLabel: "Import a CSV file with data for",
        csvInstructionsLabel: "The CSV file must contain a header with these column names:",
        columnHeaderLabel: "Column Header",
        dataNameLabel: "Data Name",
        contentLabel: "Content",
        dataTypeLabel: "Data Type",
        errorReadingFileLabel: "Error reading file",
        emptyCSVFileLabel: "The CSV file is empty",
        missingColumnsLabel: "Missing columns:",
        dateFormatLabel: "* Dates should have the format YYYY-MM-DD",
        numberFormatLabel: "* Numbers with decimal places need to use '.' as separator",
        downloadSampleLabel: "Download a sample CSV",
        importButtonLabel: "Import",
        importHelpAndInstructionsLabel: "Help and Instructions",
        recordsImportedSusccessfullyLabel: "Records imported successfully",
        recordsNotImportedDueToErrorsLabel: "Records not imported due to errors",
        importTheCSVFileLabel: "Import the CSV file, clicking or dragging the file, then click",
        importedFileLabel: "Imported file",
        errorColumnTitle: "Error",
        rowColumnTitle: "Row"
    };
    function $7eab77bb42152518$export$df2835e2ad4c9d37(props) {
        const { entity: entity, initialFormMode: initialFormMode, getDataOnInit: getDataOnInit, onSaved: onSaved, onCancel: onCancel, csvInstructionsLabel: csvInstructionsLabel, columnHeaderLabel: columnHeaderLabel, dataNameLabel: dataNameLabel, contentLabel: contentLabel, dataTypeLabel: dataTypeLabel, errorReadingFileLabel: errorReadingFileLabel, emptyCSVFileLabel: emptyCSVFileLabel, missingColumnsLabel: missingColumnsLabel, importEntity: importEntity, dateFormatLabel: dateFormatLabel, numberFormatLabel: numberFormatLabel, downloadSampleLabel: downloadSampleLabel, importButtonLabel: importButtonLabel, CancelText: CancelText, importHelpAndInstructionsLabel: importHelpAndInstructionsLabel, recordsImportedSusccessfullyLabel: recordsImportedSusccessfullyLabel, recordsNotImportedDueToErrorsLabel: recordsNotImportedDueToErrorsLabel, CloseText: CloseText, importTheCSVFileLabel: importTheCSVFileLabel, importedFileLabel: importedFileLabel, errorColumnTitle: errorColumnTitle, rowColumnTitle: rowColumnTitle } = (0, $64A2P.useComponentDefaultProps)('ImportEntityDataForm', $7eab77bb42152518$export$a50a4787aa02211c, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const formAPI = (0, $bW9pc.useEntityForm)({
            entity: entity,
            initialFormMode: initialFormMode,
            getDataOnInit: getDataOnInit,
            onSaved: onSaved,
            onCancel: onCancel,
            noSaveOnSubmit: true
        });
        const validation = (0, $6vsCT.useEntityCSVImportValidation)({
            emptyCSVFileLabel: emptyCSVFileLabel,
            errorReadingFileLabel: errorReadingFileLabel,
            missingColumnsLabel: missingColumnsLabel
        });
        const importData = (0, $kJPQt.useImportData)(importEntity);
        const required = (0, $acw62.useMemo)(()=>importEntity?.def.importColumns || (0, $TaFFV.getRequiredColumns)(importEntity), [
            importEntity
        ]);
        const [lastProcessedFile, setLastProcessedFile] = (0, $acw62.useState)(null);
        const handleValidateFile = (0, $acw62.useCallback)(async (file)=>{
            const result = await validation.validateEntityImportCSVFile({
                file: file,
                requiredColumns: required
            });
            if (!result.error) setLastProcessedFile(file.name);
            return result;
        }, [
            required,
            validation
        ]);
        const [toggleAccordion, setToggleAccordion] = (0, $acw62.useState)(null);
        const generateSampleCSV = (0, $acw62.useCallback)(()=>{
            if (!importEntity) return;
            const headers = required.join(',');
            const csvContent = `data:text/csv;charset=utf-8,${headers}\n`;
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", `${importEntity.name}_sample.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }, [
            importEntity,
            required
        ]);
        const RequiredColumns = (0, $acw62.useMemo)(()=>{
            return importEntity ? /*#__PURE__*/ (0, $ayMG0.jsxs)($fbXO1.Table, {
                striped: true,
                withBorder: true,
                withColumnBorders: true,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    children: columnHeaderLabel
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    children: dataNameLabel
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    children: dataTypeLabel
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    children: contentLabel
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: required.map((col_name)=>{
                            const col = importEntity.def.columns[col_name];
                            const record = /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: col.name
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: col.prompt
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: col.type
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                        children: col.description
                                    })
                                ]
                            }, col.name);
                            return record;
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {});
        }, [
            columnHeaderLabel,
            contentLabel,
            dataNameLabel,
            dataTypeLabel,
            importEntity,
            required
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bHLhd.EntityForm, {
            formAPI: formAPI,
            showCancel: false,
            showOK: false,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                children: [
                    !importData.importStatus.loading && !importData.importStatus.data && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                                variant: "separated",
                                value: toggleAccordion,
                                onChange: setToggleAccordion,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                                    value: "help",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                                size: "sm",
                                                children: importHelpAndInstructionsLabel
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9VIWE.Stack, {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($dQS1T.List, {
                                                    spacing: "xs",
                                                    size: "sm",
                                                    styles: {
                                                        itemWrapper: {
                                                            width: '100%'
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($dQS1T.List.Item, {
                                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($9WB3r.default, {
                                                                size: "1.75rem"
                                                            }),
                                                            children: `${importTheCSVFileLabel} ${importButtonLabel?.toUpperCase()}`
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)($dQS1T.List.Item, {
                                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($70jvy.default, {
                                                                size: "1.75rem"
                                                            }),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                                                        children: csvInstructionsLabel
                                                                    }),
                                                                    RequiredColumns,
                                                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                                                                        spacing: "0",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                                                                size: "xs",
                                                                                color: "dimmed",
                                                                                children: dateFormatLabel
                                                                            }),
                                                                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                                                                size: "xs",
                                                                                color: "dimmed",
                                                                                children: numberFormatLabel
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                                                        maw: "12rem",
                                                                        size: "sm",
                                                                        variant: "outline",
                                                                        onClick: generateSampleCSV,
                                                                        children: downloadSampleLabel
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cWSrD.FilesUploadForm, {
                                fileProcessColumn: entity.def.columns.c_fileprocess_id,
                                client: entity.API.client,
                                maxFilesCount: 1,
                                uploaderProps: {
                                    ...$lTrOu.FileUploaderDefaultProps,
                                    disabled: importData.importStatus.loading || importData.importStatus.data !== undefined,
                                    accept: [
                                        'text/csv'
                                    ]
                                },
                                onValidateFile: handleValidateFile
                            })
                        ]
                    }),
                    importData.importStatus.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {}),
                    importData.importStatus.error && /*#__PURE__*/ (0, $ayMG0.jsx)($d50o9.AlertError, {
                        mt: "md",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                            children: [
                                "Error: ",
                                importData.importStatus.error.status,
                                " ",
                                importData.importStatus.error.message,
                                " ",
                                importData.importStatus.error.statusMessage ?? ''
                            ]
                        })
                    }),
                    importData.importStatus.data && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card, {
                        withBorder: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)($ew26C.Title, {
                                    order: 6,
                                    children: [
                                        importedFileLabel,
                                        " ",
                                        lastProcessedFile
                                    ]
                                }),
                                importData.importStatus.data.SuccessCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                    spacing: 0,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($4SevU.CircleFilledIcon, {
                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3US3h.default, {
                                                size: "0.75rem"
                                            }),
                                            backColor: theme.colors.green[8]
                                        }),
                                        importData.importStatus.data.SuccessCount,
                                        " ",
                                        recordsImportedSusccessfullyLabel
                                    ]
                                }),
                                importData.importStatus.data.ErrorCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                    spacing: 0,
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($4SevU.CircleFilledIcon, {
                                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                                                size: "0.75rem"
                                            }),
                                            backColor: theme.colors.red[8]
                                        }),
                                        importData.importStatus.data.ErrorCount,
                                        " ",
                                        recordsNotImportedDueToErrorsLabel
                                    ]
                                }),
                                importData.importStatus.data.ErrorCount > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($fbXO1.Table, {
                                    withBorder: true,
                                    striped: true,
                                    width: "100%",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        children: rowColumnTitle
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                                        children: errorColumnTitle
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                                            children: Object.entries(importData.importStatus.data.Errors).slice(0, 10).map(([key, value], index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            children: key
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                                                            children: value
                                                        })
                                                    ]
                                                }, key))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        mt: "xs",
                        position: "right",
                        children: [
                            !importData.importStatus.loading && !importData.importStatus.data && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                        variant: "light",
                                        leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($dRw7S.default, {
                                            size: "1.5rem"
                                        }),
                                        onClick: async ()=>{
                                            if (onCancel) await onCancel();
                                        },
                                        children: CloseText || $bHLhd.EntityFormDefaultProps.CloseText
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                        onClick: async ()=>{
                                            if (!entity.def.columns.c_fileprocess_id.value) setToggleAccordion('help');
                                            await importData.execute(entity.def.columns.c_fileprocess_id.value);
                                        },
                                        loading: importData.importStatus.loading,
                                        leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($4Rwq2.default, {
                                            size: "1.5rem"
                                        }),
                                        disabled: importData.importStatus.data !== undefined,
                                        children: importButtonLabel
                                    })
                                ]
                            }),
                            importData.importStatus.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                variant: "light",
                                leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($dRw7S.default, {
                                    size: "1.5rem"
                                }),
                                onClick: ()=>importData.cancellation.abort(),
                                children: CancelText || $bHLhd.EntityFormDefaultProps.CancelText
                            }),
                            importData.importStatus.data && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                variant: "light",
                                leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($dRw7S.default, {
                                    size: "1.5rem"
                                }),
                                onClick: async ()=>{
                                    if (onCancel) await onCancel();
                                },
                                children: CloseText || $bHLhd.EntityFormDefaultProps.CloseText
                            })
                        ]
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("4SevU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CircleFilledIconDefaultProps", function() {
        return $668f11abf87847cd$export$88bb538ac25bd6d2;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CircleFilledIcon", function() {
        return $668f11abf87847cd$export$ba3020ddd81a17c8;
    });
    const $668f11abf87847cd$export$88bb538ac25bd6d2 = {
        backColor: "green",
        width: "1.75rem",
        mr: "md"
    };
    const $668f11abf87847cd$export$ba3020ddd81a17c8 = /*#__PURE__*/ (0, $acw62.forwardRef)(function CircleFilledIcon(props, ref) {
        const { backColor: backColor, color: color, width: width, icon: icon, mr: mr, minWidth: minWidth } = (0, $64A2P.useComponentDefaultProps)('CircleFilledIcon', $668f11abf87847cd$export$88bb538ac25bd6d2, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const iconColor = color ?? theme.white;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ref: ref,
            style: {
                boxSizing: 'border-box',
                marginRight: theme.spacing[mr ?? "md"],
                width: width,
                height: width,
                borderRadius: width,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: backColor,
                color: iconColor,
                minWidth: minWidth ?? width
            },
            children: icon
        });
    });
});
$305cacda61daafb0$var$parcelRegister("6i1ou", function(module1, exports) {
    var $4eryA = $305cacda61daafb0$var$parcelRequire("4eryA");
    var $lTrOu = $305cacda61daafb0$var$parcelRequire("lTrOu");
    var $cWSrD = $305cacda61daafb0$var$parcelRequire("cWSrD");
    var $3Utni = $305cacda61daafb0$var$parcelRequire("3Utni");
    var $iSj3y = $305cacda61daafb0$var$parcelRequire("iSj3y");
    var $j2uWU = $305cacda61daafb0$var$parcelRequire("j2uWU");
    var $iOCNL = $305cacda61daafb0$var$parcelRequire("iOCNL");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $4eryA);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lTrOu);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cWSrD);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $3Utni);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iSj3y);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $j2uWU);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iOCNL);
});
$305cacda61daafb0$var$parcelRegister("4eryA", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseFileUploadDefaultProps", function() {
        return $ad822dbf504c78b4$export$b54531e9f4f81a9;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useFileUpload", function() {
        return $ad822dbf504c78b4$export$5c1c888d0d490e03;
    });
    $305cacda61daafb0$var$parcelRequire("faRXj");
    var $lUT2t = $305cacda61daafb0$var$parcelRequire("lUT2t");
    var $effl8 = $305cacda61daafb0$var$parcelRequire("effl8");
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $7T941 = $305cacda61daafb0$var$parcelRequire("7T941");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    var $1F7Wv = $305cacda61daafb0$var$parcelRequire("1F7Wv");
    const $ad822dbf504c78b4$export$b54531e9f4f81a9 = {
        maxIndividualFileSize: 2 * 1024 ** 2,
        maxTotalFilesSize: 10 * 1024 ** 2,
        maxFilesCount: 5,
        youCanUploadAMaximumOfText: 'You can upload a maximum of',
        filesText: 'files',
        exceedMaximumIndividualSizeText: 'exceeds maximum individual size of',
        unspecifiedErrorWhenUploadingFileText: 'Unspecified error when uploading file',
        totalUploadExceedsMaximumSizeText: 'Total upload exceeds maximum size of',
        thumbnailMaxSize: 150,
        thumbnailQuality: 75
    };
    function $ad822dbf504c78b4$export$5c1c888d0d490e03(props) {
        const { client: client, maxIndividualFileSize: maxIndividualFileSize, maxTotalFilesSize: maxTotalFilesSize, maxFilesCount: maxFilesCount, youCanUploadAMaximumOfText: youCanUploadAMaximumOfText, filesText: filesText, exceedMaximumIndividualSizeText: exceedMaximumIndividualSizeText, unspecifiedErrorWhenUploadingFileText: unspecifiedErrorWhenUploadingFileText, totalUploadExceedsMaximumSizeText: totalUploadExceedsMaximumSizeText, fileProcessColumn: fileProcessColumn, onCancel: onCancel, editor: editor, onValidateFile: onValidateFile, thumbnailMaxSize: thumbnailMaxSize, thumbnailQuality: thumbnailQuality } = (0, $64A2P.useComponentDefaultProps)('useFileUpload', $ad822dbf504c78b4$export$b54531e9f4f81a9, props);
        const [uploadProgress, setUploadProgress] = (0, $acw62.useState)({});
        const [fileProcessID, setFileProcessID] = (0, $acw62.useState)(fileProcessColumn.value);
        const uploadedSize = (0, $acw62.useRef)(0);
        const [loadingNotification, setLoadingNotification] = (0, $acw62.useState)();
        const [errorNotification, setErrorNotification] = (0, $acw62.useState)();
        const [cancelledNotification, setCancelledNotification] = (0, $acw62.useState)();
        const [uploadingNotification, setUploadingNotification] = (0, $acw62.useState)();
        const abortController = new AbortController();
        const abort_signal = abortController.signal;
        const modals = (0, $k7qj2.useModal)();
        // MMC: get existing uploaded files for the process
        (0, $acw62.useEffect)(()=>{
            const refreshFiles = async ()=>{
                setLoadingNotification(true);
                try {
                    const fileStore = new $lUT2t.FileStore(client);
                    fileStore.def.columns.c_fileprocess_id.value = fileProcessColumn.value;
                    const data = await fileStore.API.executeView(fileStore.def.views.fst_brwFiles);
                    setLoadingNotification(false);
                    if (data && data.length > 0) setUploadProgress((prev)=>{
                        const updatedState = {
                            ...prev
                        };
                        const file_records = (0, $7T941.mapDataResultToType)(data[0], "enforceObject", null, null);
                        file_records.forEach((file)=>{
                            updatedState[file.c_file_id] = {
                                file_id: file.c_file_id,
                                status_id: file.c_file_id,
                                file_name: file.vc_filename,
                                file_size: file.bi_filesize,
                                progress: 100,
                                done: true,
                                documentURL: client.getDocumentURL(file.vc_fileguid),
                                thumbnailURL: client.getThumbnailURL(file.vc_fileguid, thumbnailMaxSize, thumbnailQuality),
                                vc_fileguid: file.vc_fileguid
                            };
                        });
                        return updatedState;
                    });
                } catch (e) {
                    setLoadingNotification(false);
                    if (e instanceof Error) {
                        if (e.name !== 'AbortError') setErrorNotification(e.message);
                    } else setErrorNotification(String(e));
                }
            };
            if (fileProcessColumn.value) refreshFiles();
        }, [
            client,
            fileProcessColumn.value
        ]);
        const uploadFiles = async (selectedFiles)=>{
            // Check against maxFilesCount.
            if (Object.keys(uploadProgress).length + selectedFiles.length > maxFilesCount) {
                setErrorNotification(`${youCanUploadAMaximumOfText} ${maxFilesCount} ${filesText}.`);
                return;
            }
            setErrorNotification('');
            setCancelledNotification(false);
            setUploadingNotification(true);
            for (let file of selectedFiles){
                // Check against maxIndividualFileSize.
                if (file.size > maxIndividualFileSize) {
                    setErrorNotification(`"${file.name}" ${exceedMaximumIndividualSizeText} ${maxIndividualFileSize / 1024 ** 2}MB`);
                    continue;
                }
                // Check against maxTotalFilesSize.
                if (uploadedSize.current + file.size > maxTotalFilesSize) {
                    setErrorNotification(`${totalUploadExceedsMaximumSizeText} ${maxTotalFilesSize / 1024 ** 2}MB`);
                    break;
                }
                // Client-side validation
                if (onValidateFile) {
                    const validation = await onValidateFile(file);
                    if (validation.error) {
                        setErrorNotification(validation.message || '');
                        continue;
                    }
                }
                if (editor === 'image') file = await new Promise(async (resolveEditor)=>{
                    const imageDataURL = await new Promise((resolveImageDataURL, rejectImageDataURL)=>{
                        const fileReader = new FileReader();
                        fileReader.onloadend = ()=>{
                            resolveImageDataURL(fileReader.result);
                        };
                        fileReader.onerror = ()=>{
                            rejectImageDataURL();
                        };
                        fileReader.readAsDataURL(file);
                    });
                    let closeHandled = false;
                    async function handleImageEditorOk(imageBlob) {
                        closeHandled = true;
                        resolveEditor(new File([
                            imageBlob
                        ], file.name, {
                            type: file.type
                        }));
                        await modals.close();
                    }
                    await modals.open({
                        content: /*#__PURE__*/ (0, $ayMG0.jsx)($1F7Wv.ImageEditor, {
                            src: imageDataURL,
                            onOk: handleImageEditorOk
                        }),
                        modalProps: {
                            //...modalProps,
                            trapFocus: true,
                            returnFocus: true,
                            title: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                fw: "700",
                                children: "Editor"
                            })
                        },
                        onClosed: ()=>{
                            if (!closeHandled) resolveEditor(file); //TODO: should cancel the upload?
                        }
                    });
                });
                const result = await uploadFile(file);
                if (result.errorMessage && !result.cancelled) {
                    setErrorNotification(result.errorMessage);
                    break;
                }
                if (result.cancelled) {
                    setCancelledNotification(true);
                    break;
                }
                // MMC: update total uploaded size
                uploadedSize.current += file.size;
            }
            setUploadingNotification(false);
        };
        const clearNotifications = ()=>{
            setErrorNotification('');
            setCancelledNotification(false);
        };
        const updateProgress = (statusId, newStatus)=>{
            setUploadProgress((prev)=>{
                if (newStatus.file_id) {
                    const updatedState = {
                        ...prev
                    };
                    // MMC: delete previous status
                    delete updatedState[newStatus.status_id];
                    // MMC: change status_id to file_id (this will allow to upload the same file several times)
                    newStatus.status_id = newStatus.file_id;
                    // MMC: add new status
                    updatedState[newStatus.file_id] = newStatus;
                    return updatedState;
                } else return {
                    ...prev,
                    [statusId]: newStatus
                };
            });
        };
        const uploadFile = async (file)=>{
            if (abort_signal.aborted) return {
                cancelled: true
            };
            const status_id = `${file.name}-${file.size}-${file.lastModified}`;
            try {
                let currentProcessID = fileProcessColumn.value;
                // MMC: create process_id (file group) if not already created
                if (!currentProcessID) {
                    setLoadingNotification(true);
                    const fileProcess = new $effl8.FileStoreProcess(client);
                    await fileProcess.API.addData(abort_signal);
                    currentProcessID = fileProcess.def.columns.c_fileprocess_id.value;
                    setFileProcessID(currentProcessID);
                    fileProcessColumn.value = currentProcessID;
                    setLoadingNotification(false);
                }
                // MMC: the upload endpoint will update the file_store data
                const result = await client.upload(file, currentProcessID, abort_signal, thumbnailMaxSize, thumbnailQuality, (file, progress)=>{
                    updateProgress(status_id, {
                        status_id: status_id,
                        file_name: file.name,
                        file_size: file.size,
                        progress: progress
                    });
                });
                // MMC: update finished status
                if (result) {
                    // Update the total uploaded size and check against maxTotalFilesSize.
                    uploadedSize.current += file.size;
                    const finalResult = {
                        file_id: result.FileId,
                        file_name: file.name,
                        file_size: file.size,
                        status_id: status_id,
                        progress: result.ErrorMessage ? 0 : 100,
                        done: true,
                        errorMessage: result.ErrorMessage,
                        documentURL: result.documentURL,
                        thumbnailURL: result.thumbnailURL,
                        vc_fileguid: result.FileGuid
                    };
                    updateProgress(status_id, finalResult);
                    return finalResult;
                }
            } catch (error) {
                setLoadingNotification(false);
                const errorResult = {
                    file_name: file.name,
                    file_size: file.size,
                    status_id: status_id,
                    done: true,
                    progress: 0,
                    errorMessage: error instanceof Error ? error.message : String(error)
                };
                updateProgress(status_id, errorResult);
                return errorResult;
            }
            return {
                status_id: status_id,
                progress: 0,
                done: true,
                errorMessage: unspecifiedErrorWhenUploadingFileText
            };
        };
        const deleteFile = async (file_id, fileGUID)=>{
            try {
                setLoadingNotification(true);
                const fileStore = new $lUT2t.FileStore(client);
                fileStore.def.columns.c_file_id.value = file_id;
                fileStore.def.columns.vc_fileguid.value = fileGUID;
                const result = await fileStore.API.deleteData(undefined, abort_signal);
                setLoadingNotification(false);
                if (!result.Failed) setUploadProgress((prev)=>{
                    const updatedState = {
                        ...prev
                    };
                    delete updatedState[file_id];
                    return updatedState;
                });
                return result;
            } catch (e) {
                setLoadingNotification(false);
                if (e instanceof Error) {
                    if (e.name !== 'AbortError') setErrorNotification(e.message);
                } else setErrorNotification(String(e));
                return {
                    Failed: true
                };
            }
        };
        const downloadFile = async (fileUrl, fileName)=>{
            const now = new Date();
            const datePart = now.toISOString().split('T')[0]; // "2023-11-02"
            const fileExtension = fileUrl.split('?')[0].split('.').pop() || 'file';
            const defaultFilename = `download-${datePart}.${fileExtension}`;
            const filename = fileName || defaultFilename;
            try {
                const blob = await client.downloadBlob(fileUrl);
                if (window.Blob && window.URL) {
                    const blobUrl = URL.createObjectURL(blob);
                    const linkElement = document.createElement('a');
                    linkElement.setAttribute('download', filename);
                    linkElement.setAttribute('href', blobUrl);
                    linkElement.click();
                    setTimeout(()=>URL.revokeObjectURL(blobUrl), 100);
                } else alert("Your browser does not support downloading this file.");
            } catch (error) {
                console.error("There was an error downloading the file", error);
            }
        };
        const cancelUpload = async ()=>{
            abortController.abort();
            if (onCancel) onCancel();
        };
        return {
            uploadFiles: uploadFiles,
            deleteFile: deleteFile,
            downloadFile: downloadFile,
            uploadProgress: uploadProgress,
            fileProcessID: fileProcessID,
            maxFilesCount: maxFilesCount,
            maxIndividualFileSize: maxIndividualFileSize,
            maxTotalFilesSize: maxTotalFilesSize,
            errorNotification: errorNotification,
            cancelledNotification: cancelledNotification,
            uploadingNotification: uploadingNotification,
            clearNotifications: clearNotifications,
            cancelUpload: cancelUpload,
            loadingNotification: loadingNotification
        };
    }
});
$305cacda61daafb0$var$parcelRegister("faRXj", function(module1, exports) {
    var $cVppo = $305cacda61daafb0$var$parcelRequire("cVppo");
    var $b6vlE = $305cacda61daafb0$var$parcelRequire("b6vlE");
    var $20cAu = $305cacda61daafb0$var$parcelRequire("20cAu");
    var $9KGub = $305cacda61daafb0$var$parcelRequire("9KGub");
    var $8l0hO = $305cacda61daafb0$var$parcelRequire("8l0hO");
    var $8SEtB = $305cacda61daafb0$var$parcelRequire("8SEtB");
    var $2QSEc = $305cacda61daafb0$var$parcelRequire("2QSEc");
    var $d699b = $305cacda61daafb0$var$parcelRequire("d699b");
    var $7bBKi = $305cacda61daafb0$var$parcelRequire("7bBKi");
    var $gFZgU = $305cacda61daafb0$var$parcelRequire("gFZgU");
    var $ayEmx = $305cacda61daafb0$var$parcelRequire("ayEmx");
    var $kPemU = $305cacda61daafb0$var$parcelRequire("kPemU");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cVppo);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $b6vlE);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $20cAu);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9KGub);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8l0hO);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8SEtB);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2QSEc);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $d699b);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7bBKi);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $gFZgU);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ayEmx);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kPemU);
});
$305cacda61daafb0$var$parcelRegister("cVppo", function(module1, exports) {
    var $7ApT5 = $305cacda61daafb0$var$parcelRequire("7ApT5");
    var $aKfhr = $305cacda61daafb0$var$parcelRequire("aKfhr");
    var $2eiTU = $305cacda61daafb0$var$parcelRequire("2eiTU");
    var $dHfNt = $305cacda61daafb0$var$parcelRequire("dHfNt");
    var $aAjUZ = $305cacda61daafb0$var$parcelRequire("aAjUZ");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7ApT5);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $aKfhr);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2eiTU);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dHfNt);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $aAjUZ);
});
$305cacda61daafb0$var$parcelRegister("7ApT5", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "Categories", function() {
        return $b5f3a850d6022079$export$e1e795cef0e670e6;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $aKfhr = $305cacda61daafb0$var$parcelRequire("aKfhr");
    class $b5f3a850d6022079$export$e1e795cef0e670e6 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $aKfhr.CategoriesDef(), parentKeys);
            this.Form = Promise.resolve($305cacda61daafb0$var$parcelRequire("aAjUZ")).then((module1)=>module1.CategoriesForm);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("aKfhr", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CategoriesDef", function() {
        return $813bfee6daa3f6c2$export$3cc1324c5cc2655f;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    const $813bfee6daa3f6c2$var$columns = ()=>({
            c_category_id: new $ZmuZ6.EntityColumn({
                name: 'c_category_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: "Categor\xeda"
            }),
            vc_description: new $ZmuZ6.EntityColumn({
                name: 'vc_description',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: "Descripci\xf3n"
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $813bfee6daa3f6c2$var$views = ()=>({
            cat_brwStandard: {
                name: 'cat_brwStandard',
                keyMappings: {
                    c_category_id: 0
                }
            }
        });
    class $813bfee6daa3f6c2$export$3cc1324c5cc2655f extends $5Sq1V.EntityDefinition {
        constructor(){
            super('Categories'), this.columns = $813bfee6daa3f6c2$var$columns(), this.views = $813bfee6daa3f6c2$var$views();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("aAjUZ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CategoriesFormDefaultProps", function() {
        return $4ddd8d79e4fc3102$export$cc71bffd94f335d5;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CategoriesForm", function() {
        return $4ddd8d79e4fc3102$export$d023b915cb6ddcf1;
    });
    $305cacda61daafb0$var$parcelRequire("kMllr");
    var $kjFvY = $305cacda61daafb0$var$parcelRequire("kjFvY");
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    var $d1Ssg = $305cacda61daafb0$var$parcelRequire("d1Ssg");
    var $6TOP6 = $305cacda61daafb0$var$parcelRequire("6TOP6");
    var $bW9pc = $305cacda61daafb0$var$parcelRequire("bW9pc");
    var $2eiTU = $305cacda61daafb0$var$parcelRequire("2eiTU");
    const $4ddd8d79e4fc3102$export$cc71bffd94f335d5 = {
        initialFormMode: 'view'
    };
    function $4ddd8d79e4fc3102$export$d023b915cb6ddcf1(props) {
        const { entity: entity, initialFormMode: initialFormMode, getDataOnInit: getDataOnInit } = (0, $64A2P.useComponentDefaultProps)('CategoriesValuesForm', $4ddd8d79e4fc3102$export$cc71bffd94f335d5, props);
        const useEnterAsTabRef = (0, $6TOP6.useEnterAsTab)();
        const theme = (0, $64A2P.useMantineTheme)();
        const formAPI = (0, $bW9pc.useEntityForm)({
            entity: entity,
            initialFormMode: initialFormMode,
            validateInputOnBlur: true,
            getDataOnInit: getDataOnInit
        });
        const cav = new $2eiTU.CategoriesValues(entity.API.client);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bHLhd.EntityForm, {
            formAPI: formAPI,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                ref: useEnterAsTabRef,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($d1Ssg.Lookup, {
                            entityForm: formAPI,
                            entity: entity,
                            lookupDefName: entity.def.lookups.Categories.name,
                            autoFocus: true,
                            column: entity.def.columns.c_category_id,
                            parentKeys: {},
                            required: false
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
                        shadow: "sm",
                        withBorder: theme.colorScheme === 'dark' ? false : true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                                p: "xs",
                                bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                                mb: "1rem",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                    weight: "500",
                                    children: entity.Title
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($kjFvY.DataGrid, {
                                entity: cav,
                                parentKeys: {},
                                viewName: cav.def.views.cav_brwStandard.name,
                                refreshOnInit: true,
                                limit: "10000",
                                selectionMode: "multi"
                            }, "datagrid")
                        ]
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("kMllr", function(module1, exports) {
    var $7xGLy = $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $2Qb3Q = $305cacda61daafb0$var$parcelRequire("2Qb3Q");
    var $dC9fs = $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $h79wh = $305cacda61daafb0$var$parcelRequire("h79wh");
    var $17D0Z = $305cacda61daafb0$var$parcelRequire("17D0Z");
    var $fcjYw = $305cacda61daafb0$var$parcelRequire("fcjYw");
    var $iFgaY = $305cacda61daafb0$var$parcelRequire("iFgaY");
    var $hMHMl = $305cacda61daafb0$var$parcelRequire("hMHMl");
    var $iTpjT = $305cacda61daafb0$var$parcelRequire("iTpjT");
    var $gdPjD = $305cacda61daafb0$var$parcelRequire("gdPjD");
    var $6i1ou = $305cacda61daafb0$var$parcelRequire("6i1ou");
    var $jg7sD = $305cacda61daafb0$var$parcelRequire("jg7sD");
    var $lB56X = $305cacda61daafb0$var$parcelRequire("lB56X");
    var $ccjva = $305cacda61daafb0$var$parcelRequire("ccjva");
    var $gnnRW = $305cacda61daafb0$var$parcelRequire("gnnRW");
    var $kFsxs = $305cacda61daafb0$var$parcelRequire("kFsxs");
    var $fP7wi = $305cacda61daafb0$var$parcelRequire("fP7wi");
    var $jtOZC = $305cacda61daafb0$var$parcelRequire("jtOZC");
    var $jddMY = $305cacda61daafb0$var$parcelRequire("jddMY");
    var $5QcDe = $305cacda61daafb0$var$parcelRequire("5QcDe");
    var $1ms8C = $305cacda61daafb0$var$parcelRequire("1ms8C");
    var $3xufQ = $305cacda61daafb0$var$parcelRequire("3xufQ");
    var $zzexY = $305cacda61daafb0$var$parcelRequire("zzexY");
    var $jq5ab = $305cacda61daafb0$var$parcelRequire("jq5ab");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7xGLy);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2Qb3Q);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dC9fs);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $h79wh);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $17D0Z);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fcjYw);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iFgaY);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hMHMl);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iTpjT);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $gdPjD);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $6i1ou);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jg7sD);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lB56X);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ccjva);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $gnnRW);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kFsxs);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fP7wi);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jtOZC);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jddMY);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5QcDe);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $1ms8C);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $3xufQ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $zzexY);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jq5ab);
});
$305cacda61daafb0$var$parcelRegister("2Qb3Q", function(module1, exports) {
    var $kjFvY = $305cacda61daafb0$var$parcelRequire("kjFvY");
    var $jLHxW = $305cacda61daafb0$var$parcelRequire("jLHxW");
    var $3vFhj = $305cacda61daafb0$var$parcelRequire("3vFhj");
    var $azLoD = $305cacda61daafb0$var$parcelRequire("azLoD");
    var $8vapl = $305cacda61daafb0$var$parcelRequire("8vapl");
    var $jCh09 = $305cacda61daafb0$var$parcelRequire("jCh09");
    var $dzlic = $305cacda61daafb0$var$parcelRequire("dzlic");
    var $aIp3n = $305cacda61daafb0$var$parcelRequire("aIp3n");
    var $5Buf1 = $305cacda61daafb0$var$parcelRequire("5Buf1");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kjFvY);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jLHxW);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $3vFhj);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $azLoD);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8vapl);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jCh09);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dzlic);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $aIp3n);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5Buf1);
});
$305cacda61daafb0$var$parcelRegister("kjFvY", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridDefaultProps", function() {
        return $3ea298384e41b05b$export$7a235056ace2c138;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGrid", function() {
        return $3ea298384e41b05b$export$c8dd51eb24f71762;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $lB8CV = $305cacda61daafb0$var$parcelRequire("lB8CV");
    var $i27OQ = $305cacda61daafb0$var$parcelRequire("i27OQ");
    var $7B1hX = $305cacda61daafb0$var$parcelRequire("7B1hX");
    var $43s6t = $305cacda61daafb0$var$parcelRequire("43s6t");
    $305cacda61daafb0$var$parcelRequire("h79wh");
    var $5rexx = $305cacda61daafb0$var$parcelRequire("5rexx");
    var $j8hoz = $305cacda61daafb0$var$parcelRequire("j8hoz");
    var $5Buf1 = $305cacda61daafb0$var$parcelRequire("5Buf1");
    var $3vFhj = $305cacda61daafb0$var$parcelRequire("3vFhj");
    var $5JIrZ = $305cacda61daafb0$var$parcelRequire("5JIrZ");
    const $3ea298384e41b05b$export$7a235056ace2c138 = {
        search: [],
        limit: "10000",
        refreshOnInit: false,
        selectionMode: "multi",
        gridHeight: "auto",
        preserveSelection: true,
        autoSelectFirstRow: true,
        toolbarIconVariant: "light",
        actionsButtonVariant: "light",
        modalFormSize: "lg",
        enableAdd: true,
        enableEdit: true,
        enableDelete: true,
        enableExport: true,
        columnBorders: true,
        rowBorders: false,
        withBorder: true,
        autoSizeColumnsOnLoad: true,
        showActions: true,
        labels: {
            addLabel: "Add",
            editLabel: "Edit",
            deleteLabel: "Delete",
            viewLabel: "View",
            rowsReturnedLabel: "Rows returned:",
            selectedRowsLabel: "rows selected.",
            limitLabel: "Limit",
            rowsLabel: "rows",
            unlimitedLabel: "Unlimited",
            recordsLabel: "records",
            recordLabel: "record",
            AreYouSureLabel: "Are you sure?",
            YouWillDeleteLabel: "You will delete",
            warningLabel: "Warning",
            YouMustSelectOneOrMoreRecordsToDelete: "You must select one or more records to delete",
            closeLabel: "Close",
            YouMustSelectOneOrMoreRecordsToExecuteAction: "You must select one or more records to execute this action",
            YouMustSelectAtLeast: "You must select at least",
            YouMustSelectBetween: "You must select between",
            YouMustSelect: "You must select",
            YouMustSelectMaximum: "You must select a maximum of"
        },
        renderOnlyWhenVisible: true,
        filtersFormSize: "md",
        showToolbar: true,
        showActionsToolbar: true,
        doubleClickAction: "edit",
        showColumnsConfigMenu: true,
        withModalFullscreenButton: true,
        showSelectRowsButton: true
    };
    function $3ea298384e41b05b$export$c8dd51eb24f71762(props) {
        props = (0, $64A2P.useComponentDefaultProps)('DataGrid', $3ea298384e41b05b$export$7a235056ace2c138, props);
        const { entity: entity, selectionMode: selectionMode, gridHeight: gridHeight, preserveSelection: preserveSelection, autoSelectFirstRow: autoSelectFirstRow, autoFocus: autoFocus, toolbarIconVariant: toolbarIconVariant, actionsButtonVariant: actionsButtonVariant, enableAdd: enableAdd, enableEdit: enableEdit, enableDelete: enableDelete, enableView: enableView, enableExport: enableExport, columnBorders: columnBorders, autoSizeColumnsOnLoad: autoSizeColumnsOnLoad, rowBorders: rowBorders, withBorder: withBorder, labels: labels, columnsOverrides: columnsOverrides, toolbarSize: toolbarSize, viewName: viewName, showActions: showActions, renderOnlyWhenVisible: renderOnlyWhenVisible, filtersFormSize: filtersFormSize, parentKeys: parentKeys, search: search, limit: limit, parentFormAPI: parentFormAPI, showToolbar: showToolbar, showActionsToolbar: showActionsToolbar, enableImport: enableImport, setInitialFiltersFromColumns: setInitialFiltersFromColumns, visibleFilters: visibleFilters, formMode: formMode, showColumnsConfigMenu: showColumnsConfigMenu, showSelectRowsButton: showSelectRowsButton } = props;
        const theme = (0, $64A2P.useMantineTheme)();
        const visibilityDivRef = (0, $acw62.useRef)(null);
        const isFirstVisible = (0, $i27OQ.useFirstVisible)(visibilityDivRef);
        const [searchData, setSearchData] = (0, $acw62.useState)(search?.map((s)=>{
            return {
                value: s,
                label: s
            };
        }));
        const viewState = (0, $7B1hX.useViewState)(search, limit);
        const executeViewState = (0, $lB8CV.useExecuteView)(entity, parentKeys, viewName, viewState.searchText, viewState.limitRows, viewState.refresh, viewState.filterValues);
        const dataGridAPI = (0, $5JIrZ.useDataGrid)(props, {
            executeViewState: executeViewState,
            setRefresh: viewState.setRefresh,
            setSearchText: viewState.setSearchText
        });
        const { isLoading: isLoading, rows: rows, columns: columns, setColumns: setColumns } = dataGridAPI;
        const effectiveColumnOverrides = (0, $acw62.useMemo)(()=>{
            if (!entity || !viewName) return columnsOverrides;
            return columnsOverrides ? columnsOverrides : entity?.def.views[viewName]?.gridColumnsOverrides?.(theme) ?? columnsOverrides;
        }, [
            columnsOverrides,
            entity,
            theme,
            viewName
        ]);
        const [openColumnsConfigMenu, setOpenColumnsConfigMenu] = (0, $acw62.useState)(false);
        const ConfigMenuDropDown = (0, $acw62.useMemo)(()=>/*#__PURE__*/ (0, $ayMG0.jsx)($5Buf1.DataGridColumnsMenu, {
                setOpened: setOpenColumnsConfigMenu,
                columns: columns,
                setColumns: setColumns
            }), [
            columns,
            setColumns
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: renderOnlyWhenVisible && isFirstVisible === false ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: visibilityDivRef,
                style: {
                    height: props.gridHeight
                }
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                children: [
                    showToolbar && /*#__PURE__*/ (0, $ayMG0.jsx)($3vFhj.DataGridToolbar, {
                        ...labels,
                        enableExport: enableExport,
                        onExportClick: dataGridAPI.handleExport,
                        onRefreshClick: dataGridAPI.handleRefresh,
                        onCheckboxToggle: dataGridAPI.handleToggleSelectable,
                        autoFocus: autoFocus,
                        toolbarIconVariant: toolbarIconVariant,
                        size: toolbarSize,
                        searchText: viewState.searchText,
                        setSearchText: viewState.setSearchText,
                        searchData: searchData,
                        setSearchData: setSearchData,
                        client: entity?.API.client,
                        FiltersEntity: entity && viewName ? entity?.def.views[viewName].FiltersEntity : undefined,
                        filterValues: viewState.filterValues,
                        setFilterValues: viewState.setFilterValues,
                        filtersDescription: viewState.filtersDescription,
                        setFiltersDescription: viewState.setFiltersDescription,
                        filtersFormSize: filtersFormSize,
                        onImportClick: dataGridAPI.handleImportDataClick,
                        enableImport: enableImport,
                        visibleFilters: visibleFilters,
                        initialColumnFilters: setInitialFiltersFromColumns && entity ? entity.def.columns : undefined,
                        showColumnsConfig: showColumnsConfigMenu,
                        configMenuOpened: openColumnsConfigMenu,
                        setConfigMenuOpened: setOpenColumnsConfigMenu,
                        configMenuDropdown: ConfigMenuDropDown,
                        showSelectRowsButton: showSelectRowsButton
                    }),
                    showActionsToolbar && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($5iXv4.Space, {
                                h: "xs"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($j8hoz.DataGridActionsToolbar, {
                                ...labels,
                                size: toolbarSize,
                                viewName: viewName,
                                onAddClick: dataGridAPI.handleAddClick,
                                onEditClick: dataGridAPI.handleEditClick,
                                onDeleteClick: dataGridAPI.handleDeleteClick,
                                onViewClick: dataGridAPI.handleViewClick,
                                enableAdd: enableAdd,
                                enableEdit: enableEdit,
                                enableDelete: enableDelete,
                                enableView: enableView,
                                actionsButtonVariant: actionsButtonVariant,
                                clientActions: entity?.def.clientActions ?? {},
                                handleExecuteAction: dataGridAPI.handleExecuteAction,
                                showActions: showActions,
                                parentFormMode: formMode || parentFormAPI?.formMode
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($hiiR1.Box, {
                        pos: "relative",
                        mt: "sm",
                        mb: "sm",
                        children: [
                            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {
                                pos: "absolute",
                                style: {
                                    top: 0,
                                    width: "100%",
                                    zIndex: 999
                                },
                                size: "xs"
                            }),
                            !isLoading && executeViewState.error && /*#__PURE__*/ (0, $ayMG0.jsxs)($d50o9.AlertError, {
                                mb: "xs",
                                children: [
                                    "Error: ",
                                    executeViewState.error.status,
                                    " ",
                                    executeViewState.error.message,
                                    " ",
                                    executeViewState.error.statusMessage
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($5rexx.Grid, {
                                columns: columns,
                                rows: rows,
                                onDoubleClick: dataGridAPI.handleDoubleClick,
                                gridHeight: gridHeight === 'auto' ? '50vh' : gridHeight,
                                preserveSelection: preserveSelection,
                                onSelectionChanged: dataGridAPI.handleSelectionChanged,
                                showSelectCheckbox: dataGridAPI.showSelectCheckbox,
                                autoSelectFirstRow: autoSelectFirstRow,
                                selectionMode: selectionMode,
                                columnBorders: columnBorders,
                                autoSizeColumnsOnLoad: autoSizeColumnsOnLoad,
                                rowBorders: rowBorders,
                                withBorder: withBorder,
                                columnsOverrides: effectiveColumnOverrides,
                                timeZoneOffset: entity?.API.client.TIMEZONE_OFFSET
                            })
                        ]
                    }),
                    showToolbar && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        children: [
                            executeViewState && !executeViewState.error && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        fz: "sm",
                                        children: labels?.limitLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($3wLgJ.Select, {
                                        size: "xs",
                                        sx: {
                                            maxWidth: '7rem'
                                        },
                                        data: (0, $43s6t.DataViewLimitData)(labels.rowsLabel, labels.unlimitedLabel),
                                        value: viewState.limitRows,
                                        onChange: viewState.setLimitRows
                                    })
                                ]
                            }),
                            rows && /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                fz: "xs",
                                c: "dimmed",
                                children: [
                                    labels?.rowsReturnedLabel,
                                    " ",
                                    rows.length,
                                    dataGridAPI.selectedRowsCount ? /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                        children: [
                                            ", ",
                                            dataGridAPI.selectedRowsCount,
                                            " ",
                                            labels?.selectedRowsLabel
                                        ]
                                    }) : ""
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("43s6t", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataViewLimitData", function() {
        return $6725510083b2a8c5$export$7fb1c91d4ded628d;
    });
    const $6725510083b2a8c5$export$7fb1c91d4ded628d = (rowsLabel, unlimitedLabel)=>{
        return [
            {
                value: "50",
                label: `50 ${rowsLabel}`
            },
            {
                value: "100",
                label: `100 ${rowsLabel}`
            },
            {
                value: "500",
                label: `500 ${rowsLabel}`
            },
            {
                value: "1000",
                label: `1000 ${rowsLabel}`
            },
            {
                value: "10000",
                label: `10000 ${rowsLabel}`
            },
            {
                value: "0",
                label: unlimitedLabel
            }
        ];
    };
});
$305cacda61daafb0$var$parcelRegister("h79wh", function(module1, exports) {
    var $5rexx = $305cacda61daafb0$var$parcelRequire("5rexx");
    var $c7niU = $305cacda61daafb0$var$parcelRequire("c7niU");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5rexx);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $c7niU);
});
$305cacda61daafb0$var$parcelRegister("5rexx", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DefaultGridProps", function() {
        return $7df4688f2cefba32$export$1b084dcdd4ea1dfc;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DefaultGridColumnProps", function() {
        return $7df4688f2cefba32$export$4f493e33ccf1ebfd;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "Grid", function() {
        return $7df4688f2cefba32$export$ef2184bd89960b14;
    });
    var $hllZ1 = $305cacda61daafb0$var$parcelRequire("hllZ1");
    const $7df4688f2cefba32$export$1b084dcdd4ea1dfc = {
        gridHeight: "50vh",
        selectionMode: "multi",
        autoSelectFirstRow: true,
        preserveSelection: true,
        showSelectCheckbox: false,
        rowHeight: undefined,
        stripped: true,
        highlightOnHover: true,
        columnBorders: true,
        rowBorders: false,
        withBorder: true,
        autoSizeColumnsOnLoad: true
    };
    const $7df4688f2cefba32$export$4f493e33ccf1ebfd = {
        hidden: false,
        format: "string",
        autoSizeMax: 20 * parseFloat(getComputedStyle(document.documentElement).fontSize)
    };
    const $7df4688f2cefba32$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $acw62.forwardRef)(function Grid(props, ref) {
        props = (0, $64A2P.useComponentDefaultProps)('Grid', $7df4688f2cefba32$export$1b084dcdd4ea1dfc, props);
        const gridAPI = (0, $hllZ1.useGrid)(props);
        (0, $acw62.useImperativeHandle)(ref, ()=>gridAPI.imperative, [
            gridAPI.imperative
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9Zs0z.Paper, {
            style: {
                borderRadius: "unset"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ref: gridAPI.boxRef,
                    style: {
                        height: props.gridHeight
                    }
                }),
                gridAPI.cellsPortals
            ]
        });
    });
});
$305cacda61daafb0$var$parcelRegister("hllZ1", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGrid", function() {
        return $7ddafabe221e98e8$export$f6b86a04e5d66d90;
    });
    $305cacda61daafb0$var$parcelRequire("h79wh");
    var $5rexx = $305cacda61daafb0$var$parcelRequire("5rexx");
    var $avgU4 = $305cacda61daafb0$var$parcelRequire("avgU4");
    var $htj3o = $305cacda61daafb0$var$parcelRequire("htj3o");
    function $7ddafabe221e98e8$export$f6b86a04e5d66d90({ columns: columns, rows: rows, selectionMode: selectionMode, onDoubleClick: onDoubleClick, preserveSelection: preserveSelection, onSelectionChanged: onSelectionChanged, showSelectCheckbox: showSelectCheckbox, rowHeight: rowHeight, stripped: stripped, highlightOnHover: highlightOnHover, columnBorders: columnBorders, rowBorders: rowBorders, withBorder: withBorder, autoSizeColumnsOnLoad: autoSizeColumnsOnLoad, autoSelectFirstRow: autoSelectFirstRow, columnsOverrides: columnsOverrides, selectedRows: selectedRows, setSelectedRows: setSelectedRows, timeZoneOffset: timeZoneOffset }) {
        const gridRef = (0, $acw62.useRef)(undefined);
        const boxRef = (0, $acw62.useRef)(null); //TODO: support different elements
        const gridName = (0, $acw62.useId)().replace(/:/g, '_'); //fix conflict with ":" in CSS
        const preservedSelection = (0, $acw62.useRef)(null);
        const { colorScheme: colorScheme } = (0, $8TaxK.useMantineColorScheme)();
        const columnAutoResizeSource = (0, $acw62.useRef)("user"); //flag to determine if the autoResize triggered on the column is due to a user or system action, since w2ui has not considered it.
        const { w2columnRender: w2columnRender, cellsPortals: cellsPortals, clearCellPortals: clearCellPortals, isFirstVisible: isFirstVisible, performAutosize: performAutosize } = (0, $avgU4.useW2ColumnRender)({
            columns: columns,
            rows: rows,
            columnsOverrides: columnsOverrides,
            columnAutoResizeSource: columnAutoResizeSource,
            gridRef: gridRef,
            autoSizeColumnsOnLoad: autoSizeColumnsOnLoad,
            boxRef: boxRef,
            timeZoneOffset: timeZoneOffset
        });
        //if (isFirstVisible) console.log('grid is visible');
        (0, $acw62.useEffect)(()=>{
            //console.log("useGrid effect, gridName, new ref", gridName, showSelectCheckbox);
            gridRef.current = new $htj3o.w2grid({
                name: gridName,
                box: boxRef.current,
                reorderColumns: true,
                show: {
                    columnMenu: false,
                    //initial values
                    selectColumn: showSelectCheckbox
                },
                onDelete: function(event1) {
                    event1.preventDefault();
                },
                onRefresh: function() {
                //console.debug("Grid refresh.");
                },
                onColumnAutoResize: async function(event1) {
                    const source = columnAutoResizeSource.current; //save source
                    //console.debug("onColumnAutoResize", source, event.detail);
                    //when doing autosize, the user's preference is taken into account if the user has manually set a size for the column, in which case the column cannot be made smaller but it can grow (keeping the preference but updating it to the new size so as not to complicate the logic)
                    //!: There should always be a size set here
                    if (source === "system" && event1.detail.column._microm_userSize_cache && Math.min(Math.abs(event1.detail.maxWidth), event1.detail.column._microm_autoSizeMax || Infinity, event1.detail.column.max || Infinity) < parseInt(event1.detail.column.size)) {
                        event1.preventDefault();
                        return;
                    }
                    //we simulate a maximum autoSize limit since w2ui does not contemplate it
                    const w2max_original = event1.detail.column.max;
                    if (event1.detail.column._microm_autoSizeMax) {
                        // we check if it is the last column and in that case we try to fill the last space
                        const columns = gridRef.current.columns;
                        if (columns[columns.length - 1].field === event1.detail.column.field) {
                            if (boxRef.current && boxRef.current.offsetWidth > 0) {
                                let columnsWidth = undefined;
                                // we take the container of the rows to be able to calculate the width of the last column, it can have vertical scroll
                                const container = boxRef.current.querySelector('.w2ui-grid-records');
                                if (container !== null) {
                                    // we take the width of all columns except the last one
                                    columnsWidth = container.clientWidth - columns.slice(0, -1).reduce((acc, col)=>acc + (col.sizeCalculated ? parseInt(col.sizeCalculated.replace(/\D/g, '')) : 0), 0);
                                    columnsWidth = event1.detail.column.min && columnsWidth < event1.detail.column.min ? event1.detail.column.min : columnsWidth;
                                    // here we subtract 1 px since sizeCalculated is rounded up
                                    event1.detail.column.max = columnsWidth && columnsWidth > 0 ? columnsWidth - (columns.length - 1) : undefined;
                                }
                            } else event1.detail.column.max = undefined;
                        } else event1.detail.column.max = event1.detail.column._microm_autoSizeMax;
                    }
                    await event1.complete;
                    event1.detail.column._microm_autoSize_cache = true;
                    if (source === "user") event1.detail.column._microm_userSize_cache = true;
                    event1.detail.column.max = w2max_original;
                },
                onColumnResize: async function(event1) {
                    await event1.complete;
                    //console.debug("column resize.", event.detail);
                    gridRef.current.columns[event1.detail.column]._microm_autoSize_cache = false;
                    gridRef.current.columns[event1.detail.column]._microm_userSize_cache = true;
                },
                onResize: async function(event1) {
                    await event1.complete;
                    setTimeout(()=>gridRef.current.resizeRecords()); //workaround to the problem of using the grid inside "Tabs" components, in some cases it does not paint the empty rows (with 2 columns the problem appears, with 3 or more it does not)
                }
            });
            if (!$5rexx.DefaultGridProps.rowHeight) $5rexx.DefaultGridProps.rowHeight = gridRef.current.recordHeight; //we get the default from w2ui (only if a default has not been specified)
            return ()=>{
                gridRef.current.destroy();
            };
        }, [
            gridName
        ]); //do not add dependencies, use another useEffect
        (0, $acw62.useEffect)(()=>{
            gridRef.current.onDblClick = async (event1)=>{
                await event1.complete;
                if (onDoubleClick) onDoubleClick(gridRef.current.getSelection()[0]);
            };
        }, [
            onDoubleClick
        ]);
        // Managed selection state
        const selectionOrderRef = (0, $acw62.useRef)(new Map());
        const isInternalUpdate = (0, $acw62.useRef)(false);
        // To keep selection order, w2ui makes an itnernal sort and breaks it
        (0, $acw62.useEffect)(()=>{
            selectionOrderRef.current.clear();
            selectedRows?.forEach((row, index)=>{
                selectionOrderRef.current.set(row.recid, index);
            });
        }, [
            selectedRows
        ]);
        (0, $acw62.useEffect)(()=>{
            gridRef.current.onSelect = async (event1)=>{
                await event1.complete;
                if (onSelectionChanged || setSelectedRows) {
                    const gridSelection = gridRef.current.getSelection(true);
                    const unorderedSelection = gridSelection.map((selectedIndex)=>gridRef.current.records[selectedIndex]);
                    // keep order
                    const orderedSelection = unorderedSelection.sort((a, b)=>(selectionOrderRef.current.get(a.recid) || 0) - (selectionOrderRef.current.get(b.recid) || 0));
                    if (setSelectedRows) {
                        isInternalUpdate.current = true;
                        setSelectedRows(orderedSelection);
                    }
                    if (onSelectionChanged) onSelectionChanged(orderedSelection);
                }
            };
        }, [
            onSelectionChanged,
            setSelectedRows
        ]);
        (0, $acw62.useEffect)(()=>{
            if (!isInternalUpdate.current) {
                if (selectedRows && selectedRows.length > 0) {
                    gridRef.current.selectNone();
                    const selectedRecids = selectedRows.map((selectedRow)=>selectedRow.recid);
                    gridRef.current.select(selectedRecids);
                } else gridRef.current.selectNone();
            } else isInternalUpdate.current = false;
        }, [
            selectedRows
        ]);
        //
        (0, $acw62.useEffect)(()=>{
            switch(selectionMode){
                case "multi":
                    gridRef.current.multiSelect = true;
                    break;
                case "single":
                    if (gridRef.current.multiSelect !== false) {
                        gridRef.current.multiSelect = false;
                        const sel = gridRef.current.getSelection();
                        if (sel.length > 1) gridRef.current.select(sel[0]);
                    }
                    break;
            }
        }, [
            selectionMode
        ]);
        (0, $acw62.useEffect)(()=>{
            if (gridRef.current.show.selectColumn !== showSelectCheckbox) {
                gridRef.current.show.selectColumn = showSelectCheckbox;
                gridRef.current.refresh();
            }
        }, [
            showSelectCheckbox
        ]);
        (0, $acw62.useEffect)(()=>{
            if (rowHeight === undefined) return;
            //console.log("useGrid effect, rowHeight", rowHeight);
            if (gridRef.current.recordHeight != rowHeight) {
                gridRef.current.recordHeight = rowHeight;
                gridRef.current.refresh();
            }
        }, [
            rowHeight
        ]);
        // MMC: save selection in preservedSelection
        (0, $acw62.useEffect)(()=>{
            //console.log("useGrid effect, preserveSelection", preserveSelection);
            if (preserveSelection) {
                if (gridRef.current.records.length) preservedSelection.current = gridRef.current.getSelection();
            } else preservedSelection.current = null;
        }, [
            rows,
            preserveSelection
        ]);
        // MMC: columns
        (0, $acw62.useEffect)(()=>{
            //console.log("useGrid effect, columns, columnsOverrides", columns, columnsOverrides);
            //the idea of this is to do an efficient merge when there are changes in columns, since it was inefficient to remove and recreate the columns for each change
            if (!columns?.length) {
                if (gridRef.current.columns.length) gridRef.current.removeColumn(...gridRef.current.columns.map((c)=>c.field)); //calls refresh()
                return;
            }
            const w2colsUpdated = [];
            const w2colsAdded = [];
            const w2colsRemoved = [];
            for(let colIndex = 0; colIndex < columns.length; colIndex++){
                const column = columns[colIndex];
                let w2column = gridRef.current.getColumn(column.field);
                if (w2column) {
                    let updated = false;
                    if (applyW2ColumnProps(w2column, $5rexx.DefaultGridColumnProps, column, columnsOverrides?.[column.field])) {
                        updated = true;
                        w2column._microm_autoSize_cache = false;
                    }
                    w2column.render = w2columnRender;
                    if (updated) w2colsUpdated.push(w2column);
                } else {
                    w2column = {
                        sortable: true,
                        autoResize: true,
                        size: "0",
                        render: w2columnRender,
                        //workaround to the problem of column autosize, for some reason it does not affect the last columns in some cases and they remain at the minimum size, with this at least they look a little better.
                        min: 5 * parseFloat(getComputedStyle(document.documentElement).fontSize)
                    };
                    applyW2ColumnProps(w2column, $5rexx.DefaultGridColumnProps, column, columnsOverrides?.[column.field]);
                    w2colsAdded.push({
                        before: Math.min(colIndex + 1, columns.length),
                        w2column: w2column
                    });
                }
            }
            for(let w2colIndex = 0; w2colIndex < gridRef.current.columns.length; w2colIndex++){
                const w2column = gridRef.current.columns[w2colIndex];
                const column = columns.find((c)=>c.field === w2column.field);
                if (!column) w2colsRemoved.push(w2column);
            }
            //avoid refresh until doing the whole merge
            const _w2refresh = gridRef.current.refresh;
            gridRef.current.refresh = ()=>undefined;
            try {
                if (w2colsRemoved.length) gridRef.current.removeColumn(...w2colsRemoved.map((c)=>c.field)); //calls refresh()
                if (w2colsAdded.length) for(let i = 0; i < w2colsAdded.length; i++){
                    const w2colToAdd = w2colsAdded[i];
                    gridRef.current.addColumn(w2colToAdd.w2column, w2colToAdd.before); //do not assign to .columns directly! as that skips important logic. calls refresh
                }
            } finally{
                gridRef.current.refresh = _w2refresh;
            }
            gridRef.current.refresh();
        //console.debug("useGrid effect columns updated, added, removed", w2colsUpdated.length, w2colsAdded.length, w2colsRemoved.length);
        }, [
            columns,
            columnsOverrides
        ]); // MMC: intentionally leaves out the render function dependency
        //the idea of this is to apply values to the properties of a w2ui column by merging GridColumn and overrides: w2column(mutates) <- column <- columnOverrides
        function applyW2ColumnProps(w2column, ...columns) {
            let effected = false;
            function _apply(w2prop, prop) {
                const decidedValueSource = columns.findLast((c)=>c && Object.prototype.hasOwnProperty.call(c, prop));
                if (decidedValueSource) {
                    if (w2column[w2prop] !== decidedValueSource[prop]) {
                        w2column[w2prop] = decidedValueSource[prop];
                        effected = true;
                    }
                }
            }
            _apply("field", "field");
            _apply("text", "text");
            _apply("hidden", "hidden"); //in case of undefined, the default of w2ui is used
            //these properties do not exist in w2ui, but we use them for change detection
            _apply("_microm_format", "format");
            _apply("_microm_render", "render");
            _apply("_microm_autoSizeMax", "autoSizeMax");
            return effected;
        }
        // MMC: rows
        (0, $acw62.useEffect)(()=>{
            if (!rows?.length) {
                gridRef.current.clear(); //only affects records, calls refresh
                return;
            }
            gridRef.current.clear(true); //only affects records
            // MMC: It is necessary to clear the cache even though the grid's autosize is very slow
            // the column autosize if the grid is not visible does not work, it is necessary to clear the cache if I do refresh manually
            // TODO: change the grid's autosize to one with better performance, keep in mind to update the autosize
            // when records are added to a grid with visible empty rows
            for(let w2colIndex = 0; w2colIndex < gridRef.current.columns.length; w2colIndex++)gridRef.current.columns[w2colIndex]._microm_autoSize_cache = false;
            const w2colFields = gridRef.current.columns.filter((w2col)=>w2col.field).map((w2col)=>w2col.field);
            const w2records = rows.map((row, index)=>{
                const w2record = {
                    recid: index + 1 //w2ui has problems when recid is 0
                };
                for(let i = 0; i < w2colFields.length; i++)w2record[w2colFields[i]] = row[w2colFields[i]];
                return w2record;
            });
            gridRef.current.add(w2records); //calls refresh
        //console.debug("useGrid effect records added rows.length", rows.length);
        }, [
            rows
        ]);
        // MMC: clear cell portals when the rows change
        (0, $acw62.useEffect)(()=>{
            //console.debug("useGrid effect clear portals, emptyCellsPortals");
            clearCellPortals();
        }, [
            clearCellPortals,
            rows
        ]);
        // MMC: workaround for tabs or when the grid is not visible
        (0, $acw62.useEffect)(()=>{
            if (isFirstVisible && autoSizeColumnsOnLoad && rows?.length) performAutosize();
        }, [
            rows,
            autoSizeColumnsOnLoad,
            isFirstVisible,
            performAutosize
        ]);
        // MMC: set preserved selection
        (0, $acw62.useEffect)(()=>{
            if (rows?.length && preservedSelection.current?.length) {
                //console.debug("useGrid effect rows.length, preservedSeletion", rows?.length, preservedSelection.current?.length);
                gridRef.current.select(preservedSelection.current);
                preservedSelection.current = null;
                gridRef.current.scrollIntoView();
            }
        }, [
            rows
        ]);
        // MMC: autoSelectFirstRow
        (0, $acw62.useEffect)(()=>{
            if (autoSelectFirstRow && rows?.length && !gridRef.current.getSelection().length) gridRef.current.select(1);
        }, [
            columns,
            rows,
            autoSelectFirstRow
        ]);
        // MMC: change theme
        (0, $acw62.useEffect)(()=>{
            if (boxRef.current) {
                boxRef.current.classList.remove(colorScheme === "dark" ? "w2grid-light" : "w2grid-dark");
                boxRef.current.classList.add(colorScheme === "dark" ? "w2grid-dark" : "w2grid-light");
            }
        }, [
            colorScheme
        ]);
        (0, $acw62.useEffect)(()=>{
            if (boxRef.current) {
                if (stripped) boxRef.current.classList.add("w2grid-stripped");
                else boxRef.current.classList.remove("w2grid-stripped");
            }
        }, [
            stripped
        ]);
        (0, $acw62.useEffect)(()=>{
            if (boxRef.current) {
                if (highlightOnHover) boxRef.current.classList.add("w2grid-highlight-hover");
                else boxRef.current.classList.remove("w2grid-highlight-hover");
            }
        }, [
            highlightOnHover
        ]);
        (0, $acw62.useEffect)(()=>{
            if (boxRef.current) {
                if (columnBorders) boxRef.current.classList.add("w2grid-column-borders");
                else boxRef.current.classList.remove("w2grid-column-borders");
            }
        }, [
            columnBorders
        ]);
        (0, $acw62.useEffect)(()=>{
            if (boxRef.current) {
                if (rowBorders) boxRef.current.classList.add("w2grid-row-borders");
                else boxRef.current.classList.remove("w2grid-row-borders");
            }
        }, [
            rowBorders
        ]);
        (0, $acw62.useEffect)(()=>{
            if (boxRef.current) {
                if (withBorder) boxRef.current.classList.add("w2grid-border");
                else boxRef.current.classList.remove("w2grid-border");
            }
        }, [
            withBorder
        ]);
        return {
            w2grid: gridRef.current,
            boxRef: boxRef,
            cellsPortals: Object.values(cellsPortals),
            imperative: (0, $acw62.useMemo)(()=>({}), [])
        };
    }
});
$305cacda61daafb0$var$parcelRegister("avgU4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useW2ColumnRender", function() {
        return $1d4696ce5d9ec058$export$98063caad9d01a0;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $i27OQ = $305cacda61daafb0$var$parcelRequire("i27OQ");
    var $a2vzY = $305cacda61daafb0$var$parcelRequire("a2vzY");
    function $1d4696ce5d9ec058$var$escapeHTML(text) {
        if (!text) return text;
        return text.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
    }
    const $1d4696ce5d9ec058$var$emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const $1d4696ce5d9ec058$var$emptyCellsPortals = {}; //optimization, avoids unnecessary rerenders on multiple portal state cleanups
    function $1d4696ce5d9ec058$export$98063caad9d01a0(props) {
        const { columns: columns, rows: rows, columnsOverrides: columnsOverrides, columnAutoResizeSource: columnAutoResizeSource, gridRef: gridRef, autoSizeColumnsOnLoad: autoSizeColumnsOnLoad, boxRef: boxRef, timeZoneOffset: timeZoneOffset } = props;
        const isFirstVisible = (0, $i27OQ.useFirstVisible)(boxRef);
        const emptyLocaleProps = (0, $acw62.useRef)({
            timeZoneOffset: timeZoneOffset || 0
        });
        const localeFormat = (0, $a2vzY.useLocaleFormat)(emptyLocaleProps.current);
        const [cellsPortals, setCellsPortals] = (0, $acw62.useState)($1d4696ce5d9ec058$var$emptyCellsPortals);
        const renderedCellsCountRef = (0, $acw62.useRef)(0);
        const renderFirstTime = (0, $acw62.useRef)(false);
        const renderEffectedW2Columns = (0, $acw62.useRef)([]);
        const isFirstVisibleRef = (0, $acw62.useRef)(false);
        const autoResizeColumn = (0, $acw62.useCallback)((w2colIndex)=>{
            if (gridRef.current.columns[w2colIndex]._microm_autoSize_cache) return false;
            columnAutoResizeSource.current = "system";
            try {
                //console.debug("autoResizeColumn resizing", w2colIndex);
                gridRef.current.columnAutoSize(w2colIndex);
            } finally{
                columnAutoResizeSource.current = "user";
            }
            gridRef.current.columns[w2colIndex]._microm_autoSize_cache = true;
            return true;
        }, [
            columnAutoResizeSource,
            gridRef
        ]);
        const performAutosize = (0, $acw62.useCallback)((include_render_columns = false)=>{
            const _w2refresh = gridRef.current.refresh;
            gridRef.current.refresh = ()=>undefined;
            let needRefresh = false;
            try {
                gridRef.current.columns.forEach((c, i)=>{
                    if (include_render_columns === false) {
                        if (!c._microm_render && autoResizeColumn(i)) needRefresh = true;
                    } else if (autoResizeColumn(i)) needRefresh = true;
                });
            } finally{
                gridRef.current.refresh = _w2refresh;
            }
            if (needRefresh) gridRef.current.refresh();
        }, [
            autoResizeColumn,
            gridRef
        ]);
        const clearCellPortals = (0, $acw62.useCallback)(()=>{
            setCellsPortals($1d4696ce5d9ec058$var$emptyCellsPortals);
        }, []);
        // MMC: reset the flag as to render the first time because we need to resize html columns again (workaround)
        (0, $acw62.useEffect)(()=>{
            if (isFirstVisible) {
                isFirstVisibleRef.current = true;
                renderFirstTime.current = true;
            }
        //console.debug('useEffect reset the renderFirstTime.current to true');
        }, [
            columns,
            rows,
            columnsOverrides,
            isFirstVisible
        ]);
        const w2columnRender = (0, $acw62.useCallback)(function(record, options) {
            const w2col = options.self.columns[options.colIndex];
            if (!w2col.field) return "";
            const sqlType = columns?.[parseInt(w2col.field)].sqlType;
            let format = w2col._microm_format;
            let value = options.value;
            if (sqlType) {
                if (value === null) value = '';
                else {
                    const nativeValue = localeFormat.getNativeValue(value, sqlType);
                    const rawValue = localeFormat.formatValue(nativeValue, sqlType);
                    value = rawValue === 'null' ? '' : rawValue;
                }
            }
            //
            switch(format){
                case "check":
                    value = value ? "\u2713" : "";
                    format = "html";
                    break;
                case "image":
                    value = value && typeof value === "string" ? `<img class="" src="${encodeURI(value)}" loading="lazy">` : "";
                    format = "html";
                    break;
                case "url":
                    if (value && typeof value === "string") {
                        const encodedValue = encodeURI(value);
                        value = `<a href="${encodedValue}">${$1d4696ce5d9ec058$var$escapeHTML(encodedValue)}</a>`;
                        format = "html";
                    } else format = "string";
                    break;
                case "email":
                    if (value && typeof value === "string" && $1d4696ce5d9ec058$var$emailRegex.test(value)) {
                        const encodedValue = encodeURI(value);
                        value = `<a href="mailto:${encodedValue}">${$1d4696ce5d9ec058$var$escapeHTML(encodedValue)}</a>`;
                        format = "html";
                    } else format = "string";
                    break;
                default:
                    break;
            }
            //
            switch(format){
                case "html":
                    break;
                case "string":
                    value = typeof value === "string" ? $1d4696ce5d9ec058$var$escapeHTML(value) : $1d4696ce5d9ec058$var$escapeHTML(String(value));
                    break;
                default:
                    value = "";
            }
            if (w2col._microm_render && isFirstVisibleRef.current) {
                //TODO: This will create more instances of portals than those on the screen. 
                //Instead of using the recid, a fixed ID from the table containing the virtual scroll should be used (this way there would be a maximum of as many portals as rendered records).
                //As of today, W2UI does not provide the ability to do this(how do we obtain the virtual scroll row index from the recid ?).
                const renderElementID = `microm_grid_column_render_${this.name}_${w2col.field}_${record.recid}`;
                const renderValue = value;
                const recordValue = record;
                // MMC: this reference is trigger autosize after all the cells are rendered
                renderedCellsCountRef.current += 1;
                if (renderEffectedW2Columns.current.indexOf(options.colIndex) === -1) renderEffectedW2Columns.current.push(options.colIndex);
                // MMC: this is to render react elements in the grid, using the render function passed to the column in _microm_render
                // the render for react elements requires two steps, first create a div element with an id, then render the react element in that div (renderElementID)
                setTimeout(function() {
                    // MMC: get the div element to render the react element
                    const cellElement_current = document.getElementById(renderElementID);
                    if (cellElement_current) {
                        // MMC: to avoid flicker, we render the new element in a hidden div, then we replace the old element with the new one
                        cellElement_current.id = `${renderElementID}_old`; // change ID for the old element
                        const cellElement = document.createElement('div'); // new element with the same ID
                        cellElement.id = renderElementID;
                        cellElement.hidden = true;
                        cellElement_current.insertAdjacentElement('afterend', cellElement);
                        // MMC: render the react element in the new div, the render function can return any valid react node, including just text
                        const renderResult = w2col._microm_render(renderValue, cellElement, recordValue, w2col.field); //!: ambos ya fueron comprobados
                        if (renderResult !== undefined) {
                            const portalId = `${record.recid}_${w2col.field}`;
                            if ((0, $acw62.isValidElement)(renderResult)) {
                                const portal = (0, $1u0KT.createPortal)(renderResult, cellElement, portalId);
                                setCellsPortals((prevPortals)=>({
                                        ...prevPortals,
                                        [portalId]: portal
                                    }));
                            } else {
                                // MMC: we need to clean the portal if the render function returned text
                                setCellsPortals((prevPortals)=>{
                                    delete prevPortals[portalId];
                                    return prevPortals;
                                });
                                cellElement.replaceChildren(renderResult);
                            }
                        } else cellElement.innerHTML = '';
                        // MMC: remove the old element when everything is rendered (hopefully as there can be complex react components)
                        setTimeout(()=>{
                            const cellElement = document.getElementById(renderElementID);
                            if (cellElement) cellElement.hidden = false;
                            const cellOldElement = document.getElementById(`${renderElementID}_old`);
                            if (cellOldElement) cellOldElement.remove();
                        });
                    }
                    renderedCellsCountRef.current -= 1;
                    if (renderedCellsCountRef.current === 0) {
                        if (autoSizeColumnsOnLoad) {
                            if (renderFirstTime.current) {
                                renderFirstTime.current = false;
                                //console.debug('w2columnRender clear cache', renderEffectedW2Columns.current);
                                renderEffectedW2Columns.current.forEach((col_index)=>{
                                    options.self.columns[col_index]._microm_autoSize_cache = false;
                                });
                                renderEffectedW2Columns.current = [];
                            }
                            setTimeout(()=>{
                                performAutosize(true);
                            });
                        }
                    }
                //console.debug(
                //    'w2columnRender rendering HTML, renderElementID, renderedCellsRef.current, totalCellsRef.current',
                //    renderElementID, renderedCellsRef.current, totalCellsRef.current);
                });
                // MMC: the idea here is to render the previous element content if it exists, to avoid flicker as the grid detects the string value change and triggers a refresh
                const previousElement = document.getElementById(renderElementID);
                value = previousElement ? previousElement.outerHTML : `<div id="${renderElementID}"></div>`;
            }
            return String(value);
        }, [
            autoSizeColumnsOnLoad,
            columns,
            isFirstVisibleRef,
            localeFormat,
            performAutosize
        ]);
        return {
            w2columnRender: w2columnRender,
            cellsPortals: cellsPortals,
            clearCellPortals: clearCellPortals,
            isFirstVisible: isFirstVisible,
            performAutosize: performAutosize
        };
    }
});
$305cacda61daafb0$var$parcelRegister("htj3o", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "w2grid", function() {
        return $2020029f8d0ed580$export$b4cb041b06327cfa;
    });
    var $eBOHd = $305cacda61daafb0$var$parcelRequire("eBOHd");
    class $2020029f8d0ed580$export$b4cb041b06327cfa extends $eBOHd.w2grid {
        //getColumn(field:w2columnField): w2column|undefined
        getColumn(field) {
            return super.getColumn(field, false);
        }
        getColumnIndex(field) {
            return super.getColumn(field, true);
        }
        addColumn(columns, before) {
            return super.addColumn(before, columns);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("eBOHd", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "w2grid", function() {
        return $aa2bd8933167d9cb$export$b4cb041b06327cfa;
    });
    /* w2ui 2.0.x (nightly) (8/29/2023, 6:36:15 PM) (c) http://w2ui.com, vitmalina@gmail.com */ /**
 * Part of w2ui 2.0 library
 *  - Dependencies: w2utils
 *  - on/off/trigger methods id not showing in help
 *  - refactored with event object
 *
 * Chanes in 2.0.+
 * - added unmount that cleans up the box
 *
 */ class $aa2bd8933167d9cb$export$cf99df5e00c5b470 {
        constructor(owner, edata){
            Object.assign(this, {
                type: edata.type ?? null,
                detail: edata,
                owner: owner,
                target: edata.target ?? null,
                phase: edata.phase ?? 'before',
                object: edata.object ?? null,
                execute: null,
                isStopped: false,
                isCancelled: false,
                onComplete: null,
                listeners: []
            });
            delete edata.type;
            delete edata.target;
            delete edata.object;
            this.complete = new Promise((resolve, reject)=>{
                this._resolve = resolve;
                this._reject = reject;
            });
            // needed empty catch function so that promise will not show error in the console
            this.complete.catch(()=>{});
        }
        finish(detail) {
            if (detail) $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.detail, detail);
            this.phase = 'after';
            this.owner.trigger.call(this.owner, this);
        }
        done(func) {
            this.listeners.push(func);
        }
        preventDefault() {
            this._reject();
            this.isCancelled = true;
        }
        stopPropagation() {
            this.isStopped = true;
        }
    }
    class $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        /**
     * Initializes base object for w2ui, registers it with w2ui object
     *
     * @param {string} name  - name of the object
     * @returns
     */ constructor(name){
            this.activeEvents = [] // events that are currently processing
            ;
            this.listeners = [] // event listeners
            ;
            // register globally
            if (typeof name !== 'undefined') {
                if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.checkName(name)) return;
                $aa2bd8933167d9cb$export$dca4c93ccda43b77[name] = this;
            }
            this.debug = false // if true, will trigger all events
            ;
        }
        /**
     * Adds event listener, supports event phase and event scoping
     *
     * @param {*} edata - an object or string, if string "eventName:phase.scope"
     * @param {*} handler
     * @returns itself
     */ on(events, handler) {
            if (typeof events == 'string') events = events.split(/[,\s]+/) // separate by comma or space
            ;
            else events = [
                events
            ];
            events.forEach((edata)=>{
                let name = typeof edata == 'string' ? edata : edata.type + ':' + edata.execute + '.' + edata.scope;
                if (typeof edata == 'string') {
                    let [eventName, scope] = edata.split('.');
                    let [type, execute] = eventName.replace(':complete', ':after').replace(':done', ':after').split(':');
                    edata = {
                        type: type,
                        execute: execute ?? 'before',
                        scope: scope
                    };
                }
                edata = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                    type: null,
                    execute: 'before',
                    onComplete: null
                }, edata);
                // errors
                if (!edata.type) {
                    console.log('ERROR: You must specify event type when calling .on() method of ' + this.name);
                    return;
                }
                if (!handler) {
                    console.log('ERROR: You must specify event handler function when calling .on() method of ' + this.name);
                    return;
                }
                if (!Array.isArray(this.listeners)) this.listeners = [];
                this.listeners.push({
                    name: name,
                    edata: edata,
                    handler: handler
                });
                if (this.debug) console.log('w2base: add event', {
                    name: name,
                    edata: edata,
                    handler: handler
                });
            });
            return this;
        }
        /**
     * Removes event listener, supports event phase and event scoping
     *
     * @param {*} edata - an object or string, if string "eventName:phase.scope"
     * @param {*} handler
     * @returns itself
     */ off(events, handler) {
            if (typeof events == 'string') events = events.split(/[,\s]+/) // separate by comma or space
            ;
            else events = [
                events
            ];
            events.forEach((edata)=>{
                let name = typeof edata == 'string' ? edata : edata.type + ':' + edata.execute + '.' + edata.scope;
                if (typeof edata == 'string') {
                    let [eventName, scope] = edata.split('.');
                    let [type, execute] = eventName.replace(':complete', ':after').replace(':done', ':after').split(':');
                    edata = {
                        type: type || '*',
                        execute: execute || '',
                        scope: scope || ''
                    };
                }
                edata = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                    type: null,
                    execute: null,
                    onComplete: null
                }, edata);
                // errors
                if (!edata.type && !edata.scope) {
                    console.log('ERROR: You must specify event type when calling .off() method of ' + this.name);
                    return;
                }
                if (!handler) handler = null;
                let count = 0;
                // remove listener
                this.listeners = this.listeners.filter((curr)=>{
                    if ((edata.type === '*' || edata.type === curr.edata.type) && (edata.execute === '' || edata.execute === curr.edata.execute) && (edata.scope === '' || edata.scope === curr.edata.scope) && (edata.handler == null || edata.handler === curr.edata.handler)) {
                        count++ // how many listeners removed
                        ;
                        return false;
                    } else return true;
                });
                if (this.debug) console.log(`w2base: remove event (${count})`, {
                    name: name,
                    edata: edata,
                    handler: handler
                });
            });
            return this // needed for chaining
            ;
        }
        /**
     * Triggers even listeners for a specific event, loops through this.listeners
     *
     * @param {Object} edata - Object
     * @returns modified edata
     */ trigger(eventName, edata) {
            if (arguments.length == 1) edata = eventName;
            else {
                edata.type = eventName;
                edata.target = edata.target ?? this;
            }
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(edata) && edata.phase == 'after') {
                // find event
                edata = this.activeEvents.find((event1)=>{
                    if (event1.type == edata.type && event1.target == edata.target) return true;
                    return false;
                });
                if (!edata) {
                    console.log(`ERROR: Cannot find even handler for "${edata.type}" on "${edata.target}".`);
                    return;
                }
                console.log('NOTICE: This syntax "edata.trigger({ phase: \'after\' })" is outdated. Use edata.finish() instead.');
            } else if (!(edata instanceof $aa2bd8933167d9cb$export$cf99df5e00c5b470)) {
                edata = new $aa2bd8933167d9cb$export$cf99df5e00c5b470(this, edata);
                this.activeEvents.push(edata);
            }
            let args, fun, tmp;
            if (!Array.isArray(this.listeners)) this.listeners = [];
            if (this.debug) console.log(`w2base: trigger "${edata.type}:${edata.phase}"`, edata);
            // process events in REVERSE order
            for(let h = this.listeners.length - 1; h >= 0; h--){
                let item = this.listeners[h];
                if (item != null && (item.edata.type === edata.type || item.edata.type === '*') && (item.edata.target === edata.target || item.edata.target == null) && (item.edata.execute === edata.phase || item.edata.execute === '*' || item.edata.phase === '*')) {
                    // add extra params if there
                    Object.keys(item.edata).forEach((key)=>{
                        if (edata[key] == null && item.edata[key] != null) edata[key] = item.edata[key];
                    });
                    // check handler arguments
                    args = [];
                    tmp = new RegExp(/\((.*?)\)/).exec(String(item.handler).split('=>')[0]);
                    if (tmp) args = tmp[1].split(/\s*,\s*/);
                    if (args.length === 2) {
                        item.handler.call(this, edata.target, edata) // old way for back compatibility
                        ;
                        if (this.debug) console.log(' - call (old)', item.handler);
                    } else {
                        item.handler.call(this, edata) // new way
                        ;
                        if (this.debug) console.log(' - call', item.handler);
                    }
                    if (edata.isStopped === true || edata.stop === true) return edata // back compatibility edata.stop === true
                    ;
                }
            }
            // main object events
            let funName = 'on' + edata.type.substr(0, 1).toUpperCase() + edata.type.substr(1);
            if (edata.phase === 'before' && typeof this[funName] === 'function') {
                fun = this[funName];
                // check handler arguments
                args = [];
                tmp = new RegExp(/\((.*?)\)/).exec(String(fun).split('=>')[0]);
                if (tmp) args = tmp[1].split(/\s*,\s*/);
                if (args.length === 2) {
                    fun.call(this, edata.target, edata) // old way for back compatibility
                    ;
                    if (this.debug) console.log(' - call: on[Event] (old)', fun);
                } else {
                    fun.call(this, edata) // new way
                    ;
                    if (this.debug) console.log(' - call: on[Event]', fun);
                }
                if (edata.isStopped === true || edata.stop === true) return edata // back compatibility edata.stop === true
                ;
            }
            // item object events
            if (edata.object != null && edata.phase === 'before' && typeof edata.object[funName] === 'function') {
                fun = edata.object[funName];
                // check handler arguments
                args = [];
                tmp = new RegExp(/\((.*?)\)/).exec(String(fun).split('=>')[0]);
                if (tmp) args = tmp[1].split(/\s*,\s*/);
                if (args.length === 2) {
                    fun.call(this, edata.target, edata) // old way for back compatibility
                    ;
                    if (this.debug) console.log(' - call: edata.object (old)', fun);
                } else {
                    fun.call(this, edata) // new way
                    ;
                    if (this.debug) console.log(' - call: edata.object', fun);
                }
                if (edata.isStopped === true || edata.stop === true) return edata;
            }
            // execute onComplete
            if (edata.phase === 'after') {
                if (typeof edata.onComplete === 'function') edata.onComplete.call(this, edata);
                for(let i = 0; i < edata.listeners.length; i++)if (typeof edata.listeners[i] === 'function') {
                    edata.listeners[i].call(this, edata);
                    if (this.debug) console.log(' - call: done', fun);
                }
                edata._resolve(edata);
                if (this.debug) console.log(`w2base: trigger "${edata.type}:${edata.phase}"`, edata);
                // clean up activeEvents
                let ind = this.activeEvents.indexOf(edata);
                if (ind !== -1) this.activeEvents.splice(ind, 1);
            }
            return edata;
        }
        /**
     * This method renders component into the box. It is overwritten in descendents and in this base
     * component it is empty.
     */ render(box) {
        // intentionally left blank
        }
        /**
     * Removes all classes that start with w2ui-* and sets box to null. It is needed so that control will
     * release the box to be used for other widgets
     */ unmount() {
            let edata = this.trigger('unmount', {
                target: this.name
            });
            if (edata.isCancelled) return;
            let remove = [];
            // find classes that start with "w2ui-*"
            if (this.box instanceof HTMLElement) this.box.classList.forEach((cl)=>{
                if (cl.startsWith('w2ui-')) remove.push(cl);
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).off() // removes all events attached to this box previously
            .removeClass(remove).removeAttr('name').html('');
            this.box = null;
            // event after
            edata.finish();
        }
    }
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: none
 *
 * These are the master locale settings that will be used by w2utils
 *
 * "locale" should be the IETF language tag in the form xx-YY,
 * where xx is the ISO 639-1 language code ( see https://en.wikipedia.org/wiki/ISO_639-1 ) and
 * YY is the ISO 3166-1 alpha-2 country code ( see https://en.wikipedia.org/wiki/ISO_3166-2 )
 */ const $aa2bd8933167d9cb$export$b4da1e96fca83d89 = {
        'locale': 'en-US',
        'dateFormat': 'm/d/yyyy',
        'timeFormat': 'hh:mi pm',
        'datetimeFormat': 'm/d/yyyy|hh:mi pm',
        'currencyPrefix': '$',
        'currencySuffix': '',
        'currencyPrecision': 2,
        'groupSymbol': ',',
        'decimalSymbol': '.',
        'shortmonths': [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        'fullmonths': [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        'shortdays': [
            'M',
            'T',
            'W',
            'T',
            'F',
            'S',
            'S'
        ],
        'fulldays': [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'
        ],
        'weekStarts': 'S',
        // phrases used in w2ui, should be empty for original language
        // keep these up-to-date and in sorted order
        // value = "---" to easier see what to translate
        'phrases': {
            '${count} letters or more...': '---',
            'Add new record': '---',
            'Add New': '---',
            'Advanced Search': '---',
            'after': '---',
            'AJAX error. See console for more details.': '---',
            'All Fields': '---',
            'All': '---',
            'Any': '---',
            'Are you sure you want to delete ${count} ${records}?': '---',
            'Attach files by dragging and dropping or Click to Select': '---',
            'before': '---',
            'begins with': '---',
            'begins': '---',
            'between': '---',
            'buffered': '---',
            'Cancel': '---',
            'Close': '---',
            'Column': '---',
            'Confirmation': '---',
            'contains': '---',
            'Copied': '---',
            'Copy to clipboard': '---',
            'Current Date & Time': '---',
            'Delete selected records': '---',
            'Delete': '---',
            'Do you want to delete search item "${item}"?': '---',
            'Edit selected record': '---',
            'Edit': '---',
            'Empty list': '---',
            'ends with': '---',
            'ends': '---',
            'Field should be at least ${count} characters.': '---',
            'Hide': '---',
            'in': '---',
            'is not': '---',
            'is': '---',
            'less than': '---',
            'Line #': '---',
            'Load ${count} more...': '---',
            'Loading...': '---',
            'Maximum number of files is ${count}': '---',
            'Maximum total size is ${count}': '---',
            'Modified': '---',
            'more than': '---',
            'Multiple Fields': '---',
            'Name': '---',
            'No items found': '---',
            'No matches': '---',
            'No': '---',
            'none': '---',
            'Not a float': '---',
            'Not a hex number': '---',
            'Not a valid date': '---',
            'Not a valid email': '---',
            'Not alpha-numeric': '---',
            'Not an integer': '---',
            'Not in money format': '---',
            'not in': '---',
            'Notification': '---',
            'of': '---',
            'Ok': '---',
            'Opacity': '---',
            'Record ID': '---',
            'record': '---',
            'records': '---',
            'Refreshing...': '---',
            'Reload data in the list': '---',
            'Remove': '---',
            'Remove This Field': '---',
            'Request aborted.': '---',
            'Required field': '---',
            'Reset': '---',
            'Restore Default State': '---',
            'Returned data is not in valid JSON format.': '---',
            'Save changed records': '---',
            'Save Grid State': '---',
            'Save': '---',
            'Saved Searches': '---',
            'Saving...': '---',
            'Search took ${count} seconds': '---',
            'Search': '---',
            'Select Hour': '---',
            'Select Minute': '---',
            'selected': '---',
            'Server Response ${count} seconds': '---',
            'Show/hide columns': '---',
            'Show': '---',
            'Size': '---',
            'Skip': '---',
            'Sorting took ${count} seconds': '---',
            'Type to search...': '---',
            'Type': '---',
            'Yes': '---',
            'Yesterday': '---',
            'Your remote data source record count has changed, reloading from the first record.': '---'
        }
    };
    /* mQuery 0.7 (nightly) (8/15/2023, 11:44:12 AM), vitmalina@gmail.com */ class $aa2bd8933167d9cb$var$Query {
        static version = 0.8;
        constructor(selector, context){
            this.context = context ?? document;
            let nodes = [];
            if (Array.isArray(selector)) nodes = selector;
            else if (selector instanceof Node || selector instanceof Window) nodes = [
                selector
            ];
            else if (selector instanceof $aa2bd8933167d9cb$var$Query) nodes = selector.nodes;
            else if (typeof selector == 'string') {
                if (typeof this.context.querySelector != 'function') throw new Error('Invalid context');
                nodes = Array.from(this.context.querySelectorAll(selector));
            } else if (selector == null) nodes = [];
            else {
                // if selector is itterable, then try to create nodes from it, also supports jQuery
                let arr = Array.from(selector ?? []);
                if (typeof selector == 'object' && Array.isArray(arr)) nodes = arr;
                else throw new Error(`Invalid selector "${selector}"`);
            }
            this.nodes = nodes;
            this.length = nodes.length;
            // map_ctx nodes to object propoerties
            this.each((node1, ind)=>{
                this[ind] = node1;
            });
        }
        static _fragment(html) {
            let tmpl = document.createElement('template');
            tmpl.innerHTML = html;
            tmpl.content.childNodes.forEach((node1)=>{
                let newNode = $aa2bd8933167d9cb$var$Query._scriptConvert(node1);
                if (newNode != node1) tmpl.content.replaceChild(newNode, node1);
            });
            return tmpl.content;
        }
        // innerHTML, append, etc. script tags will not be executed unless they are proper script tags
        static _scriptConvert(node1) {
            let convert = (txtNode)=>{
                let doc = txtNode.ownerDocument;
                let scNode = doc.createElement('script');
                scNode.text = txtNode.text;
                let attrs = txtNode.attributes;
                for(let i = 0; i < attrs.length; i++)scNode.setAttribute(attrs[i].name, attrs[i].value);
                return scNode;
            };
            if (node1.tagName == 'SCRIPT') node1 = convert(node1);
            if (node1.querySelectorAll) node1.querySelectorAll('script').forEach((textNode)=>{
                textNode.parentNode.replaceChild(convert(textNode), textNode);
            });
            return node1;
        }
        static _fixProp(name) {
            let fixes = {
                cellpadding: 'cellPadding',
                cellspacing: 'cellSpacing',
                class: 'className',
                colspan: 'colSpan',
                contenteditable: 'contentEditable',
                for: 'htmlFor',
                frameborder: 'frameBorder',
                maxlength: 'maxLength',
                readonly: 'readOnly',
                rowspan: 'rowSpan',
                tabindex: 'tabIndex',
                usemap: 'useMap'
            };
            return fixes[name] ? fixes[name] : name;
        }
        _insert(method, html) {
            let nodes = [];
            let len = this.length;
            if (len < 1) return;
            let self1 = this;
            // TODO: need good unit test coverage for this function
            if (typeof html == 'string') this.each((node1)=>{
                let clone = $aa2bd8933167d9cb$var$Query._fragment(html);
                nodes.push(...clone.childNodes);
                node1[method](clone);
            });
            else if (html instanceof $aa2bd8933167d9cb$var$Query) {
                let single = len == 1 // if inserting into a single container, then move it there
                ;
                html.each((el)=>{
                    this.each((node1)=>{
                        // if insert before a single node, just move new one, else clone and move it
                        let clone = single ? el : el.cloneNode(true);
                        nodes.push(clone);
                        node1[method](clone);
                        $aa2bd8933167d9cb$var$Query._scriptConvert(clone);
                    });
                });
                if (!single) html.remove();
            } else if (html instanceof Node) {
                this.each((node1)=>{
                    // if insert before a single node, just move new one, else clone and move it
                    let clone = len === 1 ? html : $aa2bd8933167d9cb$var$Query._fragment(html.outerHTML);
                    nodes.push(...len === 1 ? [
                        html
                    ] : clone.childNodes);
                    node1[method](clone);
                });
                if (len > 1) html.remove();
            } else throw new Error(`Incorrect argument for "${method}(html)". It expects one string argument.`);
            if (method == 'replaceWith') self1 = new $aa2bd8933167d9cb$var$Query(nodes, this.context) // must return a new collection
            ;
            return self1;
        }
        _save(node1, name, value) {
            node1._mQuery = node1._mQuery ?? {};
            if (Array.isArray(value)) {
                node1._mQuery[name] = node1._mQuery[name] ?? [];
                node1._mQuery[name].push(...value);
            } else if (value != null) node1._mQuery[name] = value;
            else delete node1._mQuery[name];
        }
        get(index) {
            if (index < 0) index = this.length + index;
            let node1 = this[index];
            if (node1) return node1;
            if (index != null) return null;
            return this.nodes;
        }
        eq(index) {
            if (index < 0) index = this.length + index;
            let nodes = [
                this[index]
            ];
            if (nodes[0] == null) nodes = [];
            return new $aa2bd8933167d9cb$var$Query(nodes, this.context) // must return a new collection
            ;
        }
        then(fun) {
            let ret = fun(this);
            return ret != null ? ret : this;
        }
        find(selector) {
            let nodes = [];
            this.each((node1)=>{
                let nn = Array.from(node1.querySelectorAll(selector));
                if (nn.length > 0) nodes.push(...nn);
            });
            return new $aa2bd8933167d9cb$var$Query(nodes, this.context) // must return a new collection
            ;
        }
        filter(selector) {
            let nodes = [];
            this.each((node1)=>{
                if (node1 === selector || typeof selector == 'string' && node1.matches && node1.matches(selector) || typeof selector == 'function' && selector(node1)) nodes.push(node1);
            });
            return new $aa2bd8933167d9cb$var$Query(nodes, this.context) // must return a new collection
            ;
        }
        next() {
            let nodes = [];
            this.each((node1)=>{
                let nn = node1.nextElementSibling;
                if (nn) nodes.push(nn);
            });
            return new $aa2bd8933167d9cb$var$Query(nodes, this.context) // must return a new collection
            ;
        }
        prev() {
            let nodes = [];
            this.each((node1)=>{
                let nn = node1.previousElementSibling;
                if (nn) nodes.push(nn);
            });
            return new $aa2bd8933167d9cb$var$Query(nodes, this.context) // must return a new collection
            ;
        }
        shadow(selector) {
            let nodes = [];
            this.each((node1)=>{
                // select shadow root if available
                if (node1.shadowRoot) nodes.push(node1.shadowRoot);
            });
            let col = new $aa2bd8933167d9cb$var$Query(nodes, this.context);
            return selector ? col.find(selector) : col;
        }
        closest(selector) {
            let nodes = [];
            this.each((node1)=>{
                let nn = node1.closest(selector);
                if (nn) nodes.push(nn);
            });
            return new $aa2bd8933167d9cb$var$Query(nodes, this.context) // must return a new collection
            ;
        }
        host(all) {
            let nodes = [];
            // find shadow root or body
            let top = (node1)=>{
                if (node1.parentNode) return top(node1.parentNode);
                else return node1;
            };
            let fun = (node1)=>{
                let nn = top(node1);
                nodes.push(nn.host ? nn.host : nn);
                if (nn.host && all) fun(nn.host);
            };
            this.each((node1)=>{
                fun(node1);
            });
            return new $aa2bd8933167d9cb$var$Query(nodes, this.context) // must return a new collection
            ;
        }
        parent(selector) {
            return this.parents(selector, true);
        }
        parents(selector, firstOnly) {
            let nodes = [];
            let add = (node1)=>{
                if (nodes.indexOf(node1) == -1) nodes.push(node1);
                if (!firstOnly && node1.parentNode) return add(node1.parentNode);
            };
            this.each((node1)=>{
                if (node1.parentNode) add(node1.parentNode);
            });
            let col = new $aa2bd8933167d9cb$var$Query(nodes, this.context);
            return selector ? col.filter(selector) : col;
        }
        add(more) {
            let nodes = more instanceof $aa2bd8933167d9cb$var$Query ? more.nodes : Array.isArray(more) ? more : [
                more
            ];
            return new $aa2bd8933167d9cb$var$Query(this.nodes.concat(nodes), this.context) // must return a new collection
            ;
        }
        each(func) {
            this.nodes.forEach((node1, ind)=>{
                func(node1, ind, this);
            });
            return this;
        }
        append(html) {
            return this._insert('append', html);
        }
        prepend(html) {
            return this._insert('prepend', html);
        }
        after(html) {
            return this._insert('after', html);
        }
        before(html) {
            return this._insert('before', html);
        }
        replace(html) {
            return this._insert('replaceWith', html);
        }
        remove() {
            // remove from dom, but keep in current query
            this.each((node1)=>{
                node1.remove();
            });
            return this;
        }
        css(key, value) {
            let css = key;
            let len = arguments.length;
            if (len === 0 || len === 1 && typeof key == 'string') {
                if (this[0]) {
                    let st = this[0].style;
                    // do not do computedStyleMap as it is not what on immediate element
                    if (typeof key == 'string') {
                        let pri = st.getPropertyPriority(key);
                        return st.getPropertyValue(key) + (pri ? '!' + pri : '');
                    } else return Object.fromEntries(this[0].style.cssText.split(';').filter((a)=>!!a) // filter non-empty
                    .map((a)=>{
                        return a.split(':').map((a)=>a.trim()) // trim strings
                        ;
                    }));
                } else return undefined;
            } else {
                if (typeof key != 'object') {
                    css = {};
                    css[key] = value;
                }
                this.each((el, ind)=>{
                    Object.keys(css).forEach((key)=>{
                        let imp = String(css[key]).toLowerCase().includes('!important') ? 'important' : '';
                        el.style.setProperty(key, String(css[key]).replace(/\!important/i, ''), imp);
                    });
                });
                return this;
            }
        }
        addClass(classes) {
            this.toggleClass(classes, true);
            return this;
        }
        removeClass(classes) {
            this.toggleClass(classes, false);
            return this;
        }
        toggleClass(classes, force) {
            // split by comma or space
            if (typeof classes == 'string') classes = classes.split(/[,\s]+/);
            this.each((node1)=>{
                let classes2 = classes;
                // if not defined, remove all classes
                if (classes2 == null && force === false) classes2 = Array.from(node1.classList);
                classes2.forEach((className)=>{
                    if (className !== '') {
                        let act = 'toggle';
                        if (force != null) act = force ? 'add' : 'remove';
                        node1.classList[act](className);
                    }
                });
            });
            return this;
        }
        hasClass(classes) {
            // split by comma or space
            if (typeof classes == 'string') classes = classes.split(/[,\s]+/);
            if (classes == null && this.length > 0) return Array.from(this[0].classList);
            let ret = false;
            this.each((node1)=>{
                ret = ret || classes.every((className)=>{
                    return Array.from(node1.classList ?? []).includes(className);
                });
            });
            return ret;
        }
        on(events, options, callback) {
            if (typeof options == 'function') {
                callback = options;
                options = undefined;
            }
            let delegate;
            if (options?.delegate) {
                delegate = options.delegate;
                delete options.delegate // not to pass to addEventListener
                ;
            }
            events = events.split(/[,\s]+/) // separate by comma or space
            ;
            events.forEach((eventName)=>{
                let [event1, scope] = String(eventName).toLowerCase().split('.');
                if (delegate) {
                    let fun = callback;
                    callback = (event1)=>{
                        // event.target or any ancestors match delegate selector
                        let parent = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents(delegate);
                        if (parent.length > 0) event1.delegate = parent[0];
                        else event1.delegate = event1.target;
                        if (event1.target.matches(delegate) || parent.length > 0) fun(event1);
                    };
                }
                this.each((node1)=>{
                    this._save(node1, 'events', [
                        {
                            event: event1,
                            scope: scope,
                            callback: callback,
                            options: options
                        }
                    ]);
                    node1.addEventListener(event1, callback, options);
                });
            });
            return this;
        }
        off(events, options, callback) {
            if (typeof options == 'function') {
                callback = options;
                options = undefined;
            }
            events = (events ?? '').split(/[,\s]+/) // separate by comma or space
            ;
            events.forEach((eventName)=>{
                let [event1, scope] = String(eventName).toLowerCase().split('.');
                this.each((node1)=>{
                    if (Array.isArray(node1._mQuery?.events)) for(let i = node1._mQuery.events.length - 1; i >= 0; i--){
                        let evt = node1._mQuery.events[i];
                        if (scope == null || scope === '') {
                            if ((evt.event == event1 || event1 === '') && (evt.callback == callback || callback == null)) {
                                node1.removeEventListener(evt.event, evt.callback, evt.options);
                                node1._mQuery.events.splice(i, 1);
                            }
                        } else if ((evt.event == event1 || event1 === '') && evt.scope == scope) {
                            node1.removeEventListener(evt.event, evt.callback, evt.options);
                            node1._mQuery.events.splice(i, 1);
                        }
                    }
                });
            });
            return this;
        }
        trigger(name, options) {
            let event1, mevent = [
                'click',
                'dblclick',
                'mousedown',
                'mouseup',
                'mousemove'
            ], kevent = [
                'keydown',
                'keyup',
                'keypress'
            ];
            if (name instanceof Event || name instanceof CustomEvent) event1 = name;
            else if (mevent.includes(name)) event1 = new MouseEvent(name, options);
            else if (kevent.includes(name)) event1 = new KeyboardEvent(name, options);
            else event1 = new Event(name, options);
            this.each((node1)=>{
                node1.dispatchEvent(event1);
            });
            return this;
        }
        attr(name, value) {
            if (value === undefined && typeof name == 'string') return this[0] ? this[0].getAttribute(name) : undefined;
            else {
                let obj = {};
                if (typeof name == 'object') obj = name;
                else obj[name] = value;
                this.each((node1)=>{
                    Object.entries(obj).forEach(([nm, val])=>{
                        node1.setAttribute(nm, val);
                    });
                });
                return this;
            }
        }
        removeAttr() {
            this.each((node1)=>{
                Array.from(arguments).forEach((attr)=>{
                    node1.removeAttribute(attr);
                });
            });
            return this;
        }
        prop(name, value) {
            if (value === undefined && typeof name == 'string') return this[0] ? this[0][name] : undefined;
            else {
                let obj = {};
                if (typeof name == 'object') obj = name;
                else obj[name] = value;
                this.each((node1)=>{
                    Object.entries(obj).forEach(([nm, val])=>{
                        let prop = $aa2bd8933167d9cb$var$Query._fixProp(nm);
                        node1[prop] = val;
                        if (prop == 'innerHTML') $aa2bd8933167d9cb$var$Query._scriptConvert(node1);
                    });
                });
                return this;
            }
        }
        removeProp() {
            this.each((node1)=>{
                Array.from(arguments).forEach((prop)=>{
                    delete node1[$aa2bd8933167d9cb$var$Query._fixProp(prop)];
                });
            });
            return this;
        }
        data(key, value) {
            if (key instanceof Object) {
                Object.entries(key).forEach((item)=>{
                    this.data(item[0], item[1]);
                });
                return;
            }
            if (key && key.indexOf('-') != -1) console.error(`Key "${key}" contains "-" (dash). Dashes are not allowed in property names. Use camelCase instead.`);
            if (arguments.length < 2) {
                if (this[0]) {
                    let data = Object.assign({}, this[0].dataset);
                    Object.keys(data).forEach((key)=>{
                        if (data[key].startsWith('[') || data[key].startsWith('{')) try {
                            data[key] = JSON.parse(data[key]);
                        } catch (e) {}
                    });
                    return key ? data[key] : data;
                } else return undefined;
            } else {
                this.each((node1)=>{
                    if (value != null) node1.dataset[key] = value instanceof Object ? JSON.stringify(value) : value;
                    else delete node1.dataset[key];
                });
                return this;
            }
        }
        removeData(key) {
            if (typeof key == 'string') key = key.split(/[,\s]+/);
            this.each((node1)=>{
                key.forEach((k)=>{
                    delete node1.dataset[k];
                });
            });
            return this;
        }
        show() {
            return this.toggle(true);
        }
        hide() {
            return this.toggle(false);
        }
        toggle(force) {
            return this.each((node1)=>{
                let prev = node1.style.display;
                let dsp = getComputedStyle(node1).display;
                let isHidden = prev == 'none' || dsp == 'none';
                if (isHidden && (force == null || force === true)) {
                    let def = node1 instanceof HTMLTableRowElement ? 'table-row' : node1 instanceof HTMLTableCellElement ? 'table-cell' : 'block';
                    node1.style.display = node1._mQuery?.prevDisplay ?? (prev == dsp && dsp != 'none' ? '' : def);
                    this._save(node1, 'prevDisplay', null);
                }
                if (!isHidden && (force == null || force === false)) {
                    if (dsp != 'none') this._save(node1, 'prevDisplay', dsp);
                    node1.style.setProperty('display', 'none');
                }
            });
        }
        empty() {
            return this.html('');
        }
        html(html) {
            if (html instanceof HTMLElement) return this.empty().append(html);
            else return this.prop('innerHTML', html);
        }
        text(text) {
            return this.prop('textContent', text);
        }
        val(value) {
            return this.prop('value', value) // must be prop
            ;
        }
        change() {
            return this.trigger('change');
        }
        click() {
            return this.trigger('click');
        }
    }
    // create a new object each time
    let $aa2bd8933167d9cb$export$2fa187e846a241c4 = function(selector, context) {
        // if a function, use as onload event
        if (typeof selector == 'function') {
            if (document.readyState == 'complete') selector();
            else window.addEventListener('load', selector);
        } else return new $aa2bd8933167d9cb$var$Query(selector, context);
    };
    // str -> doc-fragment
    $aa2bd8933167d9cb$export$2fa187e846a241c4.html = (str)=>{
        let frag = $aa2bd8933167d9cb$var$Query._fragment(str);
        return $aa2bd8933167d9cb$export$2fa187e846a241c4(frag.children, frag);
    };
    $aa2bd8933167d9cb$export$2fa187e846a241c4.version = $aa2bd8933167d9cb$var$Query.version;
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: mQuery, w2utils, w2base, w2locale
 *
 * == TODO ==
 *  - add w2utils.lang wrap for all captions in all buttons.
 *  - check transition (also with layout)
 *  - deprecate w2utils.tooltip
 *
 * == 2.0 changes
 *  - CSP - fixed inline events (w2utils.tooltip still has it)
 *  - transition returns a promise
 *  - removed jQuery
 *  - refactores w2utils.message()
 *  - added w2utils.confirm()
 *  - added isPlainObject
 *  - added stripSpaces
 *  - implemented marker
 *  - cssPrefix - deprecated
 *  - w2utils.debounce
 *  - w2utils.prepareParams
 */ // variable that holds all w2ui objects
    let $aa2bd8933167d9cb$export$dca4c93ccda43b77 = {};
    class $aa2bd8933167d9cb$var$Utils {
        constructor(){
            this.version = '2.0.x';
            this.tmp = {};
            this.settings = this.extend({}, {
                'dataType': 'HTTPJSON',
                'dateStartYear': 1950,
                'dateEndYear': 2030,
                'macButtonOrder': false,
                'warnNoPhrase': false
            }, $aa2bd8933167d9cb$export$b4da1e96fca83d89, {
                phrases: null
            }), this.i18nCompare = Intl.Collator().compare;
            this.hasLocalStorage = testLocalStorage();
            // some internal variables
            this.isMac = /Mac/i.test(navigator.platform);
            this.isMobile = /(iphone|ipod|ipad|mobile|android)/i.test(navigator.userAgent);
            this.isIOS = /(iphone|ipod|ipad)/i.test(navigator.platform);
            this.isAndroid = /(android)/i.test(navigator.userAgent);
            this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            // Formatters: Primarily used in grid
            this.formatters = {
                'number' (value, params) {
                    if (parseInt(params) > 20) params = 20;
                    if (parseInt(params) < 0) params = 0;
                    if (value == null || value === '') return '';
                    return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(parseFloat(value), params, true);
                },
                'float' (value, params) {
                    return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatters.number(value, params);
                },
                'int' (value, params) {
                    return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatters.number(value, 0);
                },
                'money' (value, params) {
                    if (value == null || value === '') return '';
                    let data = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(Number(value), $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.currencyPrecision);
                    return ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.currencyPrefix || '') + data + ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.currencySuffix || '');
                },
                'currency' (value, params) {
                    return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatters.money(value, params);
                },
                'percent' (value, params) {
                    if (value == null || value === '') return '';
                    return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(value, params || 1) + '%';
                },
                'size' (value, params) {
                    if (value == null || value === '') return '';
                    return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatSize(parseInt(value));
                },
                'date' (value, params) {
                    if (params === '') params = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat;
                    if (value == null || value === 0 || value === '') return '';
                    let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value, params, true);
                    if (dt === false) dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(value, params, true);
                    return '<span title="' + dt + '">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dt, params) + '</span>';
                },
                'datetime' (value, params) {
                    if (params === '') params = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.datetimeFormat;
                    if (value == null || value === 0 || value === '') return '';
                    let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value, params, true);
                    if (dt === false) dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(value, params, true);
                    return '<span title="' + dt + '">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime(dt, params) + '</span>';
                },
                'time' (value, params) {
                    if (params === '') params = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.timeFormat;
                    if (params === 'h12') params = 'hh:mi pm';
                    if (params === 'h24') params = 'h24:mi';
                    if (value == null || value === 0 || value === '') return '';
                    let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value, params, true);
                    if (dt === false) dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(value, params, true);
                    return '<span title="' + dt + '">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(value, params) + '</span>';
                },
                'timestamp' (value, params) {
                    if (params === '') params = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.datetimeFormat;
                    if (value == null || value === 0 || value === '') return '';
                    let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value, params, true);
                    if (dt === false) dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(value, params, true);
                    return dt.toString ? dt.toString() : '';
                },
                'gmt' (value, params) {
                    if (params === '') params = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.datetimeFormat;
                    if (value == null || value === 0 || value === '') return '';
                    let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value, params, true);
                    if (dt === false) dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(value, params, true);
                    return dt.toUTCString ? dt.toUTCString() : '';
                },
                'age' (value, params) {
                    if (value == null || value === 0 || value === '') return '';
                    let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value, null, true);
                    if (dt === false) dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(value, null, true);
                    return '<span title="' + dt + '">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.age(value) + (params ? ' ' + params : '') + '</span>';
                },
                'interval' (value, params) {
                    if (value == null || value === 0 || value === '') return '';
                    return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.interval(value) + (params ? ' ' + params : '');
                },
                'toggle' (value, params) {
                    return value ? 'Yes' : '';
                },
                'password' (value, params) {
                    let ret = '';
                    for(let i = 0; i < value.length; i++)ret += '*';
                    return ret;
                }
            };
            return;
            function testLocalStorage() {
                // test if localStorage is available, see issue #1282
                let str = 'w2ui_test';
                try {
                    localStorage.setItem(str, str);
                    localStorage.removeItem(str);
                    return true;
                } catch (e) {
                    return false;
                }
            }
        }
        isBin(val) {
            let re = /^[0-1]+$/;
            return re.test(val);
        }
        isInt(val) {
            let re = /^[-+]?[0-9]+$/;
            return re.test(val);
        }
        isFloat(val) {
            if (typeof val === 'string') val = val.replace(this.settings.groupSymbol, '').replace(this.settings.decimalSymbol, '.');
            return (typeof val === 'number' || typeof val === 'string' && val !== '') && !isNaN(Number(val));
        }
        isMoney(val) {
            if (typeof val === 'object' || val === '') return false;
            if (this.isFloat(val)) return true;
            let se = this.settings;
            let re = new RegExp('^' + (se.currencyPrefix ? '\\' + se.currencyPrefix + '?' : '') + '[-+]?' + (se.currencyPrefix ? '\\' + se.currencyPrefix + '?' : '') + '[0-9]*[\\' + se.decimalSymbol + ']?[0-9]+' + (se.currencySuffix ? '\\' + se.currencySuffix + '?' : '') + '$', 'i');
            if (typeof val === 'string') val = val.replace(new RegExp(se.groupSymbol, 'g'), '');
            return re.test(val);
        }
        isHex(val) {
            let re = /^(0x)?[0-9a-fA-F]+$/;
            return re.test(val);
        }
        isAlphaNumeric(val) {
            let re = /^[a-zA-Z0-9_-]+$/;
            return re.test(val);
        }
        isEmail(val) {
            let email = /^[a-zA-Z0-9._%\-+]+@[а-яА-Яa-zA-Z0-9.-]+\.[а-яА-Яa-zA-Z]+$/;
            return email.test(val);
        }
        isIpAddress(val) {
            let re = new RegExp("^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$");
            return re.test(val);
        }
        isDate(val, format, retDate) {
            if (!val) return false;
            let dt = 'Invalid Date';
            let month, day, year;
            if (format == null) format = this.settings.dateFormat;
            if (typeof val.getFullYear === 'function') {
                year = val.getFullYear();
                month = val.getMonth() + 1;
                day = val.getDate();
            } else if (parseInt(val) == val && parseInt(val) > 0) {
                val = new Date(parseInt(val));
                year = val.getFullYear();
                month = val.getMonth() + 1;
                day = val.getDate();
            } else {
                val = String(val);
                // convert month formats
                if (new RegExp('mon', 'ig').test(format)) {
                    format = format.replace(/month/ig, 'm').replace(/mon/ig, 'm').replace(/dd/ig, 'd').replace(/[, ]/ig, '/').replace(/\/\//g, '/').toLowerCase();
                    val = val.replace(/[, ]/ig, '/').replace(/\/\//g, '/').toLowerCase();
                    for(let m = 0, len = this.settings.fullmonths.length; m < len; m++){
                        let t = this.settings.fullmonths[m];
                        val = val.replace(new RegExp(t, 'ig'), parseInt(m) + 1).replace(new RegExp(t.substr(0, 3), 'ig'), parseInt(m) + 1);
                    }
                }
                // format date
                let tmp = val.replace(/-/g, '/').replace(/\./g, '/').toLowerCase().split('/');
                let tmp2 = format.replace(/-/g, '/').replace(/\./g, '/').toLowerCase();
                if (tmp2 === 'mm/dd/yyyy') {
                    month = tmp[0];
                    day = tmp[1];
                    year = tmp[2];
                }
                if (tmp2 === 'm/d/yyyy') {
                    month = tmp[0];
                    day = tmp[1];
                    year = tmp[2];
                }
                if (tmp2 === 'dd/mm/yyyy') {
                    month = tmp[1];
                    day = tmp[0];
                    year = tmp[2];
                }
                if (tmp2 === 'd/m/yyyy') {
                    month = tmp[1];
                    day = tmp[0];
                    year = tmp[2];
                }
                if (tmp2 === 'yyyy/dd/mm') {
                    month = tmp[2];
                    day = tmp[1];
                    year = tmp[0];
                }
                if (tmp2 === 'yyyy/d/m') {
                    month = tmp[2];
                    day = tmp[1];
                    year = tmp[0];
                }
                if (tmp2 === 'yyyy/mm/dd') {
                    month = tmp[1];
                    day = tmp[2];
                    year = tmp[0];
                }
                if (tmp2 === 'yyyy/m/d') {
                    month = tmp[1];
                    day = tmp[2];
                    year = tmp[0];
                }
                if (tmp2 === 'mm/dd/yy') {
                    month = tmp[0];
                    day = tmp[1];
                    year = tmp[2];
                }
                if (tmp2 === 'm/d/yy') {
                    month = tmp[0];
                    day = tmp[1];
                    year = parseInt(tmp[2]) + 1900;
                }
                if (tmp2 === 'dd/mm/yy') {
                    month = tmp[1];
                    day = tmp[0];
                    year = parseInt(tmp[2]) + 1900;
                }
                if (tmp2 === 'd/m/yy') {
                    month = tmp[1];
                    day = tmp[0];
                    year = parseInt(tmp[2]) + 1900;
                }
                if (tmp2 === 'yy/dd/mm') {
                    month = tmp[2];
                    day = tmp[1];
                    year = parseInt(tmp[0]) + 1900;
                }
                if (tmp2 === 'yy/d/m') {
                    month = tmp[2];
                    day = tmp[1];
                    year = parseInt(tmp[0]) + 1900;
                }
                if (tmp2 === 'yy/mm/dd') {
                    month = tmp[1];
                    day = tmp[2];
                    year = parseInt(tmp[0]) + 1900;
                }
                if (tmp2 === 'yy/m/d') {
                    month = tmp[1];
                    day = tmp[2];
                    year = parseInt(tmp[0]) + 1900;
                }
            }
            if (!this.isInt(year)) return false;
            if (!this.isInt(month)) return false;
            if (!this.isInt(day)) return false;
            year = +year;
            month = +month;
            day = +day;
            dt = new Date(year, month - 1, day);
            dt.setFullYear(year);
            // do checks
            if (month == null) return false;
            if (String(dt) === 'Invalid Date') return false;
            if (dt.getMonth() + 1 !== month || dt.getDate() !== day || dt.getFullYear() !== year) return false;
            if (retDate === true) return dt;
            else return true;
        }
        isTime(val, retTime) {
            // Both formats 10:20pm and 22:20
            if (val == null) return false;
            let max, am, pm;
            // -- process american format
            val = String(val);
            val = val.toUpperCase();
            am = val.indexOf('AM') >= 0;
            pm = val.indexOf('PM') >= 0;
            let ampm = pm || am;
            if (ampm) max = 12;
            else max = 24;
            val = val.replace('AM', '').replace('PM', '').trim();
            // ---
            let tmp = val.split(':');
            let h = parseInt(tmp[0] || 0), m = parseInt(tmp[1] || 0), s = parseInt(tmp[2] || 0);
            // accept edge case: 3PM is a good timestamp, but 3 (without AM or PM) is NOT:
            if ((!ampm || tmp.length !== 1) && tmp.length !== 2 && tmp.length !== 3) return false;
            if (tmp[0] === '' || h < 0 || h > max || !this.isInt(tmp[0]) || tmp[0].length > 2) return false;
            if (tmp.length > 1 && (tmp[1] === '' || m < 0 || m > 59 || !this.isInt(tmp[1]) || tmp[1].length !== 2)) return false;
            if (tmp.length > 2 && (tmp[2] === '' || s < 0 || s > 59 || !this.isInt(tmp[2]) || tmp[2].length !== 2)) return false;
            // check the edge cases: 12:01AM is ok, as is 12:01PM, but 24:01 is NOT ok while 24:00 is (midnight; equivalent to 00:00).
            // meanwhile, there is 00:00 which is ok, but 0AM nor 0PM are okay, while 0:01AM and 0:00AM are.
            if (!ampm && max === h && (m !== 0 || s !== 0)) return false;
            if (ampm && tmp.length === 1 && h === 0) return false;
            if (retTime === true) {
                if (pm && h !== 12) h += 12 // 12:00pm - is noon
                ;
                if (am && h === 12) h += 12 // 12:00am - is midnight
                ;
                return {
                    hours: h,
                    minutes: m,
                    seconds: s
                };
            }
            return true;
        }
        isDateTime(val, format, retDate) {
            if (typeof val.getFullYear === 'function') {
                if (retDate !== true) return true;
                return val;
            }
            let intVal = parseInt(val);
            if (intVal === val) {
                if (intVal < 0) return false;
                else if (retDate !== true) return true;
                else return new Date(intVal);
            }
            let tmp = String(val).indexOf(' ');
            if (tmp < 0) {
                if (String(val).indexOf('T') < 0 || String(new Date(val)) == 'Invalid Date') return false;
                else if (retDate !== true) return true;
                else return new Date(val);
            } else {
                if (format == null) format = this.settings.datetimeFormat;
                let formats = format.split('|');
                let values = [
                    val.substr(0, tmp),
                    val.substr(tmp).trim()
                ];
                formats[0] = formats[0].trim();
                if (formats[1]) formats[1] = formats[1].trim();
                // check
                let tmp1 = this.isDate(values[0], formats[0], true);
                let tmp2 = this.isTime(values[1], true);
                if (tmp1 !== false && tmp2 !== false) {
                    if (retDate !== true) return true;
                    tmp1.setHours(tmp2.hours);
                    tmp1.setMinutes(tmp2.minutes);
                    tmp1.setSeconds(tmp2.seconds);
                    return tmp1;
                } else return false;
            }
        }
        age(dateStr) {
            let d1;
            if (dateStr === '' || dateStr == null) return '';
            if (typeof dateStr.getFullYear === 'function') d1 = dateStr;
            else if (parseInt(dateStr) == dateStr && parseInt(dateStr) > 0) d1 = new Date(parseInt(dateStr));
            else d1 = new Date(dateStr);
            if (String(d1) === 'Invalid Date') return '';
            let d2 = new Date();
            let sec = (d2.getTime() - d1.getTime()) / 1000;
            let amount = '';
            let type = '';
            if (sec < 0) {
                amount = 0;
                type = 'sec';
            } else if (sec < 60) {
                amount = Math.floor(sec);
                type = 'sec';
                if (sec < 0) {
                    amount = 0;
                    type = 'sec';
                }
            } else if (sec < 3600) {
                amount = Math.floor(sec / 60);
                type = 'min';
            } else if (sec < 86400) {
                amount = Math.floor(sec / 60 / 60);
                type = 'hour';
            } else if (sec < 2592000) {
                amount = Math.floor(sec / 24 / 60 / 60);
                type = 'day';
            } else if (sec < 31536000) {
                amount = Math.floor(sec / 30 / 24 / 60 / 60 * 10) / 10;
                type = 'month';
            } else if (sec < 126144000) {
                amount = Math.floor(sec / 365 / 24 / 60 / 60 * 10) / 10;
                type = 'year';
            } else if (sec >= 126144000) {
                // factor in leap year shift (only older then 4 years)
                amount = Math.floor(sec / 365.25 / 24 / 60 / 60 * 10) / 10;
                type = 'year';
            }
            return amount + ' ' + type + (amount > 1 ? 's' : '');
        }
        interval(value) {
            let ret = '';
            if (value < 100) ret = '< 0.01 sec';
            else if (value < 1000) ret = Math.floor(value / 10) / 100 + ' sec';
            else if (value < 10000) ret = Math.floor(value / 100) / 10 + ' sec';
            else if (value < 60000) ret = Math.floor(value / 1000) + ' secs';
            else if (value < 3600000) ret = Math.floor(value / 60000) + ' mins';
            else if (value < 86400000) ret = Math.floor(value / 3600000 * 10) / 10 + ' hours';
            else if (value < 2628000000) ret = Math.floor(value / 86400000 * 10) / 10 + ' days';
            else if (value < 3.1536e+10) ret = Math.floor(value / 2628000000 * 10) / 10 + ' months';
            else ret = Math.floor(value / 3.1536e+9) / 10 + ' years';
            return ret;
        }
        date(dateStr) {
            if (dateStr === '' || dateStr == null || typeof dateStr === 'object' && !dateStr.getMonth) return '';
            let d1 = new Date(dateStr);
            if (this.isInt(dateStr)) d1 = new Date(Number(dateStr)) // for unix timestamps
            ;
            if (String(d1) === 'Invalid Date') return '';
            let months = this.settings.shortmonths;
            let d2 = new Date() // today
            ;
            let d3 = new Date();
            d3.setTime(d3.getTime() - 86400000) // yesterday
            ;
            let dd1 = months[d1.getMonth()] + ' ' + d1.getDate() + ', ' + d1.getFullYear();
            let dd2 = months[d2.getMonth()] + ' ' + d2.getDate() + ', ' + d2.getFullYear();
            let dd3 = months[d3.getMonth()] + ' ' + d3.getDate() + ', ' + d3.getFullYear();
            let time = d1.getHours() - (d1.getHours() > 12 ? 12 : 0) + ':' + (d1.getMinutes() < 10 ? '0' : '') + d1.getMinutes() + ' ' + (d1.getHours() >= 12 ? 'pm' : 'am');
            let time2 = d1.getHours() - (d1.getHours() > 12 ? 12 : 0) + ':' + (d1.getMinutes() < 10 ? '0' : '') + d1.getMinutes() + ':' + (d1.getSeconds() < 10 ? '0' : '') + d1.getSeconds() + ' ' + (d1.getHours() >= 12 ? 'pm' : 'am');
            let dsp = dd1;
            if (dd1 === dd2) dsp = time;
            if (dd1 === dd3) dsp = this.lang('Yesterday');
            return '<span title="' + dd1 + ' ' + time2 + '">' + dsp + '</span>';
        }
        formatSize(sizeStr) {
            if (!this.isFloat(sizeStr) || sizeStr === '') return '';
            sizeStr = parseFloat(sizeStr);
            if (sizeStr === 0) return 0;
            let sizes = [
                'Bt',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB'
            ];
            let i = parseInt(Math.floor(Math.log(sizeStr) / Math.log(1024)));
            return (Math.floor(sizeStr / Math.pow(1024, i) * 10) / 10).toFixed(i === 0 ? 0 : 1) + ' ' + (sizes[i] || '??');
        }
        formatNumber(val, fraction, useGrouping) {
            if (val == null || val === '' || typeof val === 'object') return '';
            let options = {
                minimumFractionDigits: parseInt(fraction),
                maximumFractionDigits: parseInt(fraction),
                useGrouping: !!useGrouping
            };
            if (fraction == null || fraction < 0) {
                options.minimumFractionDigits = 0;
                options.maximumFractionDigits = 20;
            }
            return parseFloat(val).toLocaleString(this.settings.locale, options);
        }
        formatDate(dateStr, format) {
            if (!format) format = this.settings.dateFormat;
            if (dateStr === '' || dateStr == null || typeof dateStr === 'object' && !dateStr.getMonth) return '';
            let dt = new Date(dateStr);
            if (this.isInt(dateStr)) dt = new Date(Number(dateStr)) // for unix timestamps
            ;
            if (String(dt) === 'Invalid Date') return '';
            let year = dt.getFullYear();
            let month = dt.getMonth();
            let date = dt.getDate();
            return format.toLowerCase().replace('month', this.settings.fullmonths[month]).replace('mon', this.settings.shortmonths[month]).replace(/yyyy/g, ('000' + year).slice(-4)).replace(/yyy/g, ('000' + year).slice(-4)).replace(/yy/g, ('0' + year).slice(-2)).replace(/(^|[^a-z$])y/g, '$1' + year) // only y's that are not preceded by a letter
            .replace(/mm/g, ('0' + (month + 1)).slice(-2)).replace(/dd/g, ('0' + date).slice(-2)).replace(/th/g, date == 1 ? 'st' : 'th').replace(/th/g, date == 2 ? 'nd' : 'th').replace(/th/g, date == 3 ? 'rd' : 'th').replace(/(^|[^a-z$])m/g, '$1' + (month + 1)) // only y's that are not preceded by a letter
            .replace(/(^|[^a-z$])d/g, '$1' + date) // only y's that are not preceded by a letter
            ;
        }
        formatTime(dateStr, format) {
            if (!format) format = this.settings.timeFormat;
            if (dateStr === '' || dateStr == null || typeof dateStr === 'object' && !dateStr.getMonth) return '';
            let dt = new Date(dateStr);
            if (this.isInt(dateStr)) dt = new Date(Number(dateStr)) // for unix timestamps
            ;
            if (this.isTime(dateStr)) {
                let tmp = this.isTime(dateStr, true);
                dt = new Date();
                dt.setHours(tmp.hours);
                dt.setMinutes(tmp.minutes);
            }
            if (String(dt) === 'Invalid Date') return '';
            if (format == 'h12') format = 'hh:mi pm';
            let type = 'am';
            let hour = dt.getHours();
            let h24 = dt.getHours();
            let min = dt.getMinutes();
            let sec = dt.getSeconds();
            if (min < 10) min = '0' + min;
            if (sec < 10) sec = '0' + sec;
            if (format.indexOf('am') !== -1 || format.indexOf('pm') !== -1) {
                if (hour >= 12) type = 'pm';
                if (hour > 12) hour = hour - 12;
                if (hour === 0) hour = 12;
            }
            return format.toLowerCase().replace('am', type).replace('pm', type).replace('hhh', hour < 10 ? '0' + hour : hour).replace('hh24', h24 < 10 ? '0' + h24 : h24).replace('h24', h24).replace('hh', hour).replace('mm', min).replace('mi', min).replace('ss', sec).replace(/(^|[^a-z$])h/g, '$1' + hour) // only y's that are not preceded by a letter
            .replace(/(^|[^a-z$])m/g, '$1' + min) // only y's that are not preceded by a letter
            .replace(/(^|[^a-z$])s/g, '$1' + sec) // only y's that are not preceded by a letter
            ;
        }
        formatDateTime(dateStr, format) {
            let fmt;
            if (dateStr === '' || dateStr == null || typeof dateStr === 'object' && !dateStr.getMonth) return '';
            if (typeof format !== 'string') fmt = [
                this.settings.dateFormat,
                this.settings.timeFormat
            ];
            else {
                fmt = format.split('|');
                fmt[0] = fmt[0].trim();
                fmt[1] = fmt.length > 1 ? fmt[1].trim() : this.settings.timeFormat;
            }
            // older formats support
            if (fmt[1] === 'h12') fmt[1] = 'h:m pm';
            if (fmt[1] === 'h24') fmt[1] = 'h24:m';
            return this.formatDate(dateStr, fmt[0]) + ' ' + this.formatTime(dateStr, fmt[1]);
        }
        stripSpaces(html) {
            if (html == null) return html;
            switch(typeof html){
                case 'number':
                    break;
                case 'string':
                    html = String(html).replace(/(?:\r\n|\r|\n)/g, ' ').replace(/\s\s+/g, ' ').trim();
                    break;
                case 'object':
                    // does not modify original object, but creates a copy
                    if (Array.isArray(html)) {
                        html = this.extend([], html);
                        html.forEach((key, ind)=>{
                            html[ind] = this.stripSpaces(key);
                        });
                    } else {
                        html = this.extend({}, html);
                        Object.keys(html).forEach((key)=>{
                            html[key] = this.stripSpaces(html[key]);
                        });
                    }
                    break;
            }
            return html;
        }
        stripTags(html) {
            if (html == null) return html;
            switch(typeof html){
                case 'number':
                    break;
                case 'string':
                    html = String(html).replace(/<(?:[^>=]|='[^']*'|="[^"]*"|=[^'"][^\s>]*)*>/ig, '');
                    break;
                case 'object':
                    // does not modify original object, but creates a copy
                    if (Array.isArray(html)) {
                        html = this.extend([], html);
                        html.forEach((key, ind)=>{
                            html[ind] = this.stripTags(key);
                        });
                    } else {
                        html = this.extend({}, html);
                        Object.keys(html).forEach((key)=>{
                            html[key] = this.stripTags(html[key]);
                        });
                    }
                    break;
            }
            return html;
        }
        encodeTags(html) {
            if (html == null) return html;
            switch(typeof html){
                case 'number':
                    break;
                case 'string':
                    html = String(html).replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
                    break;
                case 'object':
                    // does not modify original object, but creates a copy
                    if (Array.isArray(html)) {
                        html = this.extend([], html);
                        html.forEach((key, ind)=>{
                            html[ind] = this.encodeTags(key);
                        });
                    } else {
                        html = this.extend({}, html);
                        Object.keys(html).forEach((key)=>{
                            html[key] = this.encodeTags(html[key]);
                        });
                    }
                    break;
            }
            return html;
        }
        decodeTags(html) {
            if (html == null) return html;
            switch(typeof html){
                case 'number':
                    break;
                case 'string':
                    html = String(html).replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
                    break;
                case 'object':
                    // does not modify original object, but creates a copy
                    if (Array.isArray(html)) {
                        html = this.extend([], html);
                        html.forEach((key, ind)=>{
                            html[ind] = this.decodeTags(key);
                        });
                    } else {
                        html = this.extend({}, html);
                        Object.keys(html).forEach((key)=>{
                            html[key] = this.decodeTags(html[key]);
                        });
                    }
                    break;
            }
            return html;
        }
        escapeId(id) {
            // This logic is borrowed from jQuery
            if (id === '' || id == null) return '';
            let re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g;
            return (id + '').replace(re, (ch, asCodePoint)=>{
                if (asCodePoint) {
                    if (ch === '\0') return '\uFFFD';
                    return ch.slice(0, -1) + '\\' + ch.charCodeAt(ch.length - 1).toString(16) + ' ';
                }
                return '\\' + ch;
            });
        }
        unescapeId(id) {
            // This logic is borrowed from jQuery
            if (id === '' || id == null) return '';
            let re = /\\[\da-fA-F]{1,6}[\x20\t\r\n\f]?|\\([^\r\n\f])/g;
            return id.replace(re, (escape, nonHex)=>{
                let high = '0x' + escape.slice(1) - 0x10000;
                return nonHex ? nonHex : high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
            });
        }
        base64encode(input) {
            // Fast Native support in Chrome since 2010
            return btoa(input) // binary to ascii
            ;
        }
        base64decode(input) {
            // Fast Native support in Chrome since 2010
            return atob(input) // ascii to binary
            ;
        }
        async sha256(str) {
            const utf8 = new TextEncoder().encode(str);
            return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer)=>{
                const hashArray = Array.from(new Uint8Array(hashBuffer));
                return hashArray.map((bytes)=>bytes.toString(16).padStart(2, '0')).join('');
            });
        }
        transition(div_old, div_new, type, callBack) {
            return new Promise((resolve, reject)=>{
                let styles = getComputedStyle(div_old);
                let width = parseInt(styles.width);
                let height = parseInt(styles.height);
                let time = 0.5;
                if (!div_old || !div_new) {
                    console.log('ERROR: Cannot do transition when one of the divs is null');
                    return;
                }
                div_old.parentNode.style.cssText += 'perspective: 900px; overflow: hidden;';
                div_old.style.cssText += '; position: absolute; z-index: 1019; backface-visibility: hidden';
                div_new.style.cssText += '; position: absolute; z-index: 1020; backface-visibility: hidden';
                switch(type){
                    case 'slide-left':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: translate3d(0, 0, 0)';
                        div_new.style.cssText += 'overflow: hidden; transform: translate3d(' + width + 'px, 0, 0)';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: translate3d(0, 0, 0)';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: translate3d(-' + width + 'px, 0, 0)';
                        }, 1);
                        break;
                    case 'slide-right':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: translate3d(0, 0, 0)';
                        div_new.style.cssText += 'overflow: hidden; transform: translate3d(-' + width + 'px, 0, 0)';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: translate3d(0px, 0, 0)';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: translate3d(' + width + 'px, 0, 0)';
                        }, 1);
                        break;
                    case 'slide-down':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; z-index: 1; transform: translate3d(0, 0, 0)';
                        div_new.style.cssText += 'overflow: hidden; z-index: 0; transform: translate3d(0, 0, 0)';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: translate3d(0, 0, 0)';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: translate3d(0, ' + height + 'px, 0)';
                        }, 1);
                        break;
                    case 'slide-up':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: translate3d(0, 0, 0)';
                        div_new.style.cssText += 'overflow: hidden; transform: translate3d(0, ' + height + 'px, 0)';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: translate3d(0, 0, 0)';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: translate3d(0, 0, 0)';
                        }, 1);
                        break;
                    case 'flip-left':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: rotateY(0deg)';
                        div_new.style.cssText += 'overflow: hidden; transform: rotateY(-180deg)';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: rotateY(0deg)';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: rotateY(180deg)';
                        }, 1);
                        break;
                    case 'flip-right':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: rotateY(0deg)';
                        div_new.style.cssText += 'overflow: hidden; transform: rotateY(180deg)';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: rotateY(0deg)';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: rotateY(-180deg)';
                        }, 1);
                        break;
                    case 'flip-down':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: rotateX(0deg)';
                        div_new.style.cssText += 'overflow: hidden; transform: rotateX(180deg)';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: rotateX(0deg)';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: rotateX(-180deg)';
                        }, 1);
                        break;
                    case 'flip-up':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: rotateX(0deg)';
                        div_new.style.cssText += 'overflow: hidden; transform: rotateX(-180deg)';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: rotateX(0deg)';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: rotateX(180deg)';
                        }, 1);
                        break;
                    case 'pop-in':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: translate3d(0, 0, 0)';
                        div_new.style.cssText += 'overflow: hidden; transform: translate3d(0, 0, 0); transform: scale(.8); opacity: 0;';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; transform: scale(1); opacity: 1;';
                            div_old.style.cssText += 'transition: ' + time + 's;';
                        }, 1);
                        break;
                    case 'pop-out':
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: translate3d(0, 0, 0); transform: scale(1); opacity: 1;';
                        div_new.style.cssText += 'overflow: hidden; transform: translate3d(0, 0, 0); opacity: 0;';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; opacity: 1;';
                            div_old.style.cssText += 'transition: ' + time + 's; transform: scale(1.7); opacity: 0;';
                        }, 1);
                        break;
                    default:
                        // init divs
                        div_old.style.cssText += 'overflow: hidden; transform: translate3d(0, 0, 0)';
                        div_new.style.cssText += 'overflow: hidden; translate3d(0, 0, 0); opacity: 0;';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).show();
                        // -- need a timing function because otherwise not working
                        setTimeout(()=>{
                            div_new.style.cssText += 'transition: ' + time + 's; opacity: 1;';
                            div_old.style.cssText += 'transition: ' + time + 's';
                        }, 1);
                        break;
                }
                setTimeout(()=>{
                    if (type === 'slide-down') {
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_old).css('z-index', '1019');
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).css('z-index', '1020');
                    }
                    if (div_new) $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).css({
                        'opacity': '1'
                    }).css({
                        'transition': '',
                        'transform': ''
                    });
                    if (div_old) $aa2bd8933167d9cb$export$2fa187e846a241c4(div_old).css({
                        'opacity': '1'
                    }).css({
                        'transition': '',
                        'transform': ''
                    });
                    if (typeof callBack === 'function') callBack();
                    resolve();
                }, time * 1000);
            });
        }
        lock(box, options = {}) {
            if (box == null) return;
            if (typeof options == 'string') options = {
                msg: options
            };
            if (arguments[2]) options.spinner = arguments[2];
            options = this.extend({
                spinner: false
            }, options);
            // for backward compatibility
            if (box?.[0] instanceof Node) box = Array.isArray(box) ? box : box.get();
            if (!options.msg && options.msg !== 0) options.msg = '';
            this.unlock(box);
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).get(0);
            let pWidth = el.scrollWidth;
            let pHeight = el.scrollHeight;
            // if it is body and only has absolute elements, its height will be 0, need to lock entire window
            if (el.tagName == 'BODY') {
                if (pWidth < innerWidth) pWidth = innerWidth;
                if (pHeight < innerHeight) pHeight = innerHeight;
            }
            $aa2bd8933167d9cb$export$2fa187e846a241c4(box).prepend(`<div class="w2ui-lock" style="height: ${pHeight}px; width: ${pWidth}px"></div>` + '<div class="w2ui-lock-msg"></div>');
            let $lock = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('.w2ui-lock');
            let $mess = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('.w2ui-lock-msg');
            if (!options.msg) $mess.css({
                'background-color': 'transparent',
                'background-image': 'none',
                'border': '0px',
                'box-shadow': 'none'
            });
            if (options.spinner === true) options.msg = `<div class="w2ui-spinner" ${!options.msg ? 'style="width: 35px; height: 35px"' : ''}></div>` + options.msg;
            if (options.msg) $mess.html(options.msg).css('display', 'block');
            else $mess.remove();
            if (options.opacity != null) $lock.css('opacity', options.opacity);
            $lock.css({
                display: 'block'
            });
            if (options.bgColor) $lock.css({
                'background-color': options.bgColor
            });
            let styles = getComputedStyle($lock.get(0));
            let opacity = styles.opacity ?? 0.15;
            $lock.on('mousedown', function() {
                if (typeof options.onClick == 'function') options.onClick();
                else $lock.css({
                    'transition': '.2s',
                    'opacity': opacity * 1.5
                });
            }).on('mouseup', function() {
                if (typeof options.onClick !== 'function') $lock.css({
                    'transition': '.2s',
                    'opacity': opacity
                });
            }).on('mousewheel', function(event1) {
                if (event1) {
                    event1.stopPropagation();
                    event1.preventDefault();
                }
            });
        }
        unlock(box, speed) {
            if (box == null) return;
            clearTimeout(box._prevUnlock);
            // for backward compatibility
            if (box?.[0] instanceof Node) box = Array.isArray(box) ? box : box.get();
            if (this.isInt(speed) && speed > 0) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('.w2ui-lock').css({
                    transition: speed / 1000 + 's',
                    opacity: 0
                });
                let _box = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).get(0);
                clearTimeout(_box._prevUnlock);
                _box._prevUnlock = setTimeout(()=>{
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('.w2ui-lock').remove();
                }, speed);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('.w2ui-lock-msg').remove();
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('.w2ui-lock').remove();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('.w2ui-lock-msg').remove();
            }
        }
        /**
     * Opens a context message, similar in parameters as w2popup.open()
     *
     * Sample Calls
     * w2utils.message({ box: '#div' }, 'message').ok(() => {})
     * w2utils.message({ box: '#div' }, { text: 'message', width: 300 }).ok(() => {})
     * w2utils.message({ box: '#div' }, { text: 'message', actions: ['Save'] }).Save(() => {})
     *
     * Used in w2grid, w2form, w2layout (should be in w2popup too)
     * should be called with .call(...) method
     *
     * @param where = {
     *      box,     // where to open
     *      after,   // enableAccess if any, adds enableAccess heights
     *      param    // additional parameters, used in layouts for panel
     * }
     * @param options {
     *      width,      // (int), width in px, if negative, then it is maxWidth - width
     *      height,     // (int), height in px, if negative, then it is maxHeight - height
     *      text,       // centered text
     *      body,       // body of the message
     *      buttons,    // buttons of the message
     *      html,       // if body & buttons are not defined, then html is the entire message
     *      focus,      // int or id with a selector, default is 0
     *      hideOn,     // ['esc', 'click'], default is ['esc']
     *      actions,    // array of actions (only if buttons is not defined)
     *      onOpen,     // event when opened
     *      onClose,    // event when closed
     *      onAction,   // event on action
     * }
     */ message(where, options) {
            let closeTimer, openTimer, edata;
            let removeLast = ()=>{
                let msgs = $aa2bd8933167d9cb$export$2fa187e846a241c4(where?.box).find('.w2ui-message');
                if (msgs.length == 0) return; // no messages already
                options = msgs.get(0)._msg_options || {};
                if (typeof options?.close == 'function') options.close();
            };
            let closeComplete = (options)=>{
                let focus = options.box._msg_prevFocus;
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find('.w2ui-message').length <= 1) {
                    if (where.owner) where.owner.unlock(where.param, 150);
                    else this.unlock(where.box, 150);
                } else $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find(`#w2ui-message-${where.owner?.name}-${options.msgIndex - 1}`).css('z-index', 1500);
                if (focus) {
                    let msg = $aa2bd8933167d9cb$export$2fa187e846a241c4(focus).closest('.w2ui-message');
                    if (msg.length > 0) {
                        let opt = msg.get(0)._msg_options;
                        opt.setFocus(focus);
                    } else focus.focus();
                } else if (typeof where.owner?.focus == 'function') where.owner.focus();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(options.box).remove();
                if (options.msgIndex === 0) {
                    head.css('z-index', options.tmp.zIndex);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).css('overflow', options.tmp.overflow);
                }
                // event after
                if (options.trigger) edata.finish();
            };
            if (typeof options == 'string' || typeof options == 'number') options = {
                width: String(options).length < 300 ? 350 : 550,
                height: String(options).length < 300 ? 170 : 250,
                text: String(options)
            };
            if (typeof options != 'object') {
                removeLast();
                return;
            }
            if (options.text != null) options.body = `<div class="w2ui-centered w2ui-msg-text">${options.text}</div>`;
            if (options.width == null) options.width = 350;
            if (options.height == null) options.height = 170;
            if (options.hideOn == null) options.hideOn = [
                'esc'
            ];
            // mix in events
            if (options.on == null) {
                let opts = options;
                options = new $aa2bd8933167d9cb$export$3bc12ae4e0bb7487();
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(options, opts) // needs to be w2utils
                ;
            }
            options.on('open', (event1)=>{
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(options.box).find('.w2ui-eaction'), options) // options is w2base object
                ;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find('button, input, textarea, [name=hidden-first]').off('.message').on('keydown.message', function(evt) {
                    if (evt.keyCode == 27 && options.hideOn.includes('esc')) {
                        if (options.cancelAction) options.action(options.cancelAction);
                        else options.close();
                    }
                });
                // timeout is needed because messages opens over 0.3 seconds
                setTimeout(()=>options.setFocus(options.focus), 300);
            });
            options.off('.prom');
            let prom = {
                self: options,
                action (callBack) {
                    options.on('action.prom', callBack);
                    return prom;
                },
                close (callBack) {
                    options.on('close.prom', callBack);
                    return prom;
                },
                open (callBack) {
                    options.on('open.prom', callBack);
                    return prom;
                },
                then (callBack) {
                    options.on('open:after.prom', callBack);
                    return prom;
                }
            };
            if (options.actions == null && options.buttons == null && options.html == null) options.actions = {
                Ok (event1) {
                    event1.detail.self.close();
                }
            };
            options.off('.buttons');
            if (options.actions != null) {
                options.buttons = '';
                Object.keys(options.actions).forEach((action)=>{
                    let handler = options.actions[action];
                    let btnAction = action;
                    if (typeof handler == 'function') options.buttons += `<button class="w2ui-btn w2ui-eaction" data-click='["action","${action}","event"]' name="${action}">${action}</button>`;
                    if (typeof handler == 'object') {
                        options.buttons += `<button class="w2ui-btn w2ui-eaction ${handler.class || ''}" name="${action}" data-click='["action","${action}","event"]'
                        style="${handler.style ?? ''}" ${handler.attrs ?? ''}>${handler.text || action}</button>`;
                        btnAction = Array.isArray(options.actions) ? handler.text : action;
                    }
                    if (typeof handler == 'string') {
                        options.buttons += `<button class="w2ui-btn w2ui-eaction" name="${handler}" data-click='["action","${handler}","event"]'>${handler}</button>`;
                        btnAction = handler;
                    }
                    if (typeof btnAction == 'string') btnAction = btnAction[0].toLowerCase() + btnAction.substr(1).replace(/\s+/g, '');
                    prom[btnAction] = function(callBack) {
                        options.on('action.buttons', (event1)=>{
                            let target = event1.detail.action[0].toLowerCase() + event1.detail.action.substr(1).replace(/\s+/g, '');
                            if (target == btnAction) callBack(event1);
                        });
                        return prom;
                    };
                });
            }
            // trim if any
            Array('html', 'body', 'buttons').forEach((param)=>{
                options[param] = String(options[param] ?? '').trim();
            });
            if (options.body !== '' || options.buttons !== '') options.html = `
                <div class="w2ui-message-body">${options.body || ''}</div>
                <div class="w2ui-message-buttons">${options.buttons || ''}</div>
            `;
            let styles = getComputedStyle($aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).get(0));
            let pWidth = parseFloat(styles.width);
            let pHeight = parseFloat(styles.height);
            let titleHeight = 0;
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(where.after).length > 0) {
                styles = getComputedStyle($aa2bd8933167d9cb$export$2fa187e846a241c4(where.after).get(0));
                titleHeight = parseInt(styles.display != 'none' ? parseInt(styles.height) : 0);
            }
            if (options.width > pWidth) options.width = pWidth - 10;
            if (options.height > pHeight - titleHeight) options.height = pHeight - 10 - titleHeight;
            options.originalWidth = options.width;
            options.originalHeight = options.height;
            if (parseInt(options.width) < 0) options.width = pWidth + options.width;
            if (parseInt(options.width) < 10) options.width = 10;
            if (parseInt(options.height) < 0) options.height = pHeight + options.height - titleHeight;
            if (parseInt(options.height) < 10) options.height = 10;
            // negative value means margin
            if (options.originalHeight < 0) options.height = pHeight + options.originalHeight - titleHeight;
            if (options.originalWidth < 0) options.width = pWidth + options.originalWidth * 2 // x 2 because there is left and right margin
            ;
            let head = $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find(where.after) // needed for z-index manipulations
            ;
            if (!options.tmp) options.tmp = {
                zIndex: head.css('z-index'),
                overflow: styles.overflow
            };
            // remove message
            if (options.html === '' && options.body === '' && options.buttons === '') removeLast();
            else {
                options.msgIndex = $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find('.w2ui-message').length;
                if (options.msgIndex === 0 && typeof this.lock == 'function') {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).css('overflow', 'hidden');
                    if (where.owner) where.owner.lock(where.param);
                    else this.lock(where.box);
                }
                // send back previous messages
                $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find('.w2ui-message').css('z-index', 1390);
                head.css('z-index', 1501);
                // add message
                let content = `
                <div id="w2ui-message-${where.owner?.name}-${options.msgIndex}" class="w2ui-message" data-mousedown="stop"
                    style="z-index: 1500; left: ${(pWidth - options.width) / 2}px; top: ${titleHeight}px;
                        width: ${options.width}px; height: ${options.height}px; transform: translateY(-${options.height}px)"
                    ${options.hideOn.includes('click') ? where.param ? `data-click='["message", "${where.param}"]` : 'data-click="message"' : ''}>
                    <span name="hidden-first" tabindex="0" style="position: absolute; top: 0; outline: none"></span>
                    ${options.html}
                    <span name="hidden-last" tabindex="0" style="position: absolute; top: 0; outline: none"></span>
                </div>`;
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(where.after).length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find(where.after).after(content);
                else $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).prepend(content);
                options.box = $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find(`#w2ui-message-${where.owner?.name}-${options.msgIndex}`)[0];
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(options.box, this);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(options.box).addClass('animating');
                // remember options and prev focus
                options.box._msg_options = options;
                options.box._msg_prevFocus = document.activeElement;
                // timeout is needs so that callBacks are setup
                setTimeout(()=>{
                    // before event
                    edata = options.trigger('open', {
                        target: this.name,
                        box: options.box,
                        self: options
                    });
                    if (edata.isCancelled === true) {
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find(`#w2ui-message-${where.owner?.name}-${options.msgIndex}`).remove();
                        if (options.msgIndex === 0) {
                            head.css('z-index', options.tmp.zIndex);
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).css('overflow', options.tmp.overflow);
                        }
                        return;
                    }
                    // slide down
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(options.box).css({
                        transition: '0.3s',
                        transform: 'translateY(0px)'
                    });
                }, 0);
                // timeout is needed so that animation can finish
                openTimer = setTimeout(()=>{
                    // has to be on top of lock
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find(`#w2ui-message-${where.owner?.name}-${options.msgIndex}`).removeClass('animating').css({
                        'transition': '0s'
                    });
                    // event after
                    edata.finish();
                }, 300);
            }
            // action handler
            options.action = (action, event1)=>{
                let click = options.actions[action];
                if (click instanceof Object && click.onClick) click = click.onClick;
                // event before
                let edata = options.trigger('action', {
                    target: this.name,
                    action: action,
                    self: options,
                    originalEvent: event1,
                    value: options.input ? options.input.value : null
                });
                if (edata.isCancelled === true) return;
                // default actions
                if (typeof click === 'function') click(edata);
                // event after
                edata.finish();
            };
            options.close = ()=>{
                edata = options.trigger('close', {
                    target: 'self',
                    box: options.box,
                    self: options
                });
                if (edata.isCancelled === true) return;
                clearTimeout(openTimer);
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(options.box).hasClass('animating')) {
                    clearTimeout(closeTimer);
                    closeComplete(options);
                    return;
                }
                // default behavior
                $aa2bd8933167d9cb$export$2fa187e846a241c4(options.box).addClass('w2ui-closing animating').css({
                    'transition': '0.15s',
                    'transform': 'translateY(-' + options.height + 'px)'
                });
                if (options.msgIndex !== 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find(`#w2ui-message-${where.owner?.name}-${options.msgIndex - 1}`).css('z-index', 1499);
                closeTimer = setTimeout(()=>{
                    closeComplete(options);
                }, 150);
            };
            options.setFocus = (focus)=>{
                // in message or popup
                let cnt = $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find('.w2ui-message').length - 1;
                let box = $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find(`#w2ui-message-${where.owner?.name}-${cnt}`);
                let sel = 'input, button, select, textarea, [contentEditable], .w2ui-input';
                if (focus != null) {
                    let el = isNaN(focus) ? box.find(sel).filter(focus).get(0) : box.find(sel).get(focus);
                    el?.focus();
                } else box.find('[name=hidden-first]').get(0)?.focus();
                // clear focus if there are other messages
                $aa2bd8933167d9cb$export$2fa187e846a241c4(where.box).find('.w2ui-message').find(sel + ',[name=hidden-first],[name=hidden-last]').off('.keep-focus');
                // keep focus/blur inside popup
                $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel + ',[name=hidden-first],[name=hidden-last]').on('blur.keep-focus', function(event1) {
                    setTimeout(()=>{
                        let focus = document.activeElement;
                        let inside = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel).filter(focus).length > 0;
                        let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(focus).attr('name');
                        if (!inside && focus && focus !== document.body) $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel).get(0)?.focus();
                        if (name == 'hidden-last') $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel).get(0)?.focus();
                        if (name == 'hidden-first') $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel).get(-1)?.focus();
                    }, 1);
                });
            };
            return prom;
        }
        /**
     * Shows small notification message at the bottom of the page, or containter that you specify
     * in options.where (could be element or a selector)
     *
     * w2utils.notify('Document saved')
     * w2utils.notify('Mesage sent ${udon}', { actions: { undo: function () {...} }})
     *
     * @param {String/Object} options can be {
     *      text: string,       // message, can be html
     *      where: el/selector, // element or selector where to show, default is document.body
     *      timeout: int,       // timeout when to hide, if 0 - indefinite
     *      error: boolean,     // add error clases
     *      class: string,      // additional class strings
     *      actions: object     // object with action functions, it should correspot to templated text: '... ${action} ...'
     *  }
     * @returns promise
     */ notify(text, options) {
            return new Promise((resolve)=>{
                if (typeof text == 'object') {
                    options = text;
                    text = options.text;
                }
                options = options || {};
                options.where = options.where ?? document.body;
                options.timeout = options.timeout ?? 15000 // 15 secodns or will be hidden on route change
                ;
                if (typeof this.tmp.notify_resolve == 'function') {
                    this.tmp.notify_resolve();
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.tmp.notify_where).find('#w2ui-notify').remove();
                }
                this.tmp.notify_resolve = resolve;
                this.tmp.notify_where = options.where;
                clearTimeout(this.tmp.notify_timer);
                if (text) {
                    if (typeof options.actions == 'object') {
                        let actions = {};
                        Object.keys(options.actions).forEach((action)=>{
                            actions[action] = `<a class="w2ui-notify-link" value="${action}">${action}</a>`;
                        });
                        text = this.execTemplate(text, actions);
                    }
                    let html = `
                    <div id="w2ui-notify">
                        <div class="${options.class} ${options.error ? 'w2ui-notify-error' : ''}">
                            ${text}
                            <span class="w2ui-notify-close w2ui-icon-cross"></span>
                        </div>
                    </div>`;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(options.where).append(html);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(options.where).find('#w2ui-notify').find('.w2ui-notify-close').on('click', (event1)=>{
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(options.where).find('#w2ui-notify').remove();
                        resolve();
                    });
                    if (options.actions) $aa2bd8933167d9cb$export$2fa187e846a241c4(options.where).find('#w2ui-notify .w2ui-notify-link').on('click', (event1)=>{
                        let value = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('value');
                        options.actions[value]();
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(options.where).find('#w2ui-notify').remove();
                        resolve();
                    });
                    if (options.timeout > 0) this.tmp.notify_timer = setTimeout(()=>{
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(options.where).find('#w2ui-notify').remove();
                        resolve();
                    }, options.timeout);
                }
            });
        }
        confirm(where, options) {
            if (typeof options == 'string') options = {
                text: options
            };
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normButtons(options, {
                yes: 'Yes',
                no: 'No'
            });
            let prom = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.message(where, options);
            if (prom) prom.action((event1)=>{
                event1.detail.self.close();
            });
            return prom;
        }
        /**
     * Normalizes yes, no buttons for confirmation dialog
     *
     * @param {*} options
     * @returns  options
     */ normButtons(options, btn) {
            options.actions = options.actions ?? {};
            let btns = Object.keys(btn);
            btns.forEach((name)=>{
                let action = options['btn_' + name];
                if (action) {
                    btn[name] = {
                        text: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(action.text ?? btn[name] ?? ''),
                        class: action.class ?? '',
                        style: action.style ?? '',
                        attrs: action.attrs ?? ''
                    };
                    delete options['btn_' + name];
                }
                Array('text', 'class', 'style', 'attrs').forEach((suffix)=>{
                    if (options[name + '_' + suffix]) {
                        if (typeof btn[name] == 'string') btn[name] = {
                            text: btn[name]
                        };
                        btn[name][suffix] = options[name + '_' + suffix];
                        delete options[name + '_' + suffix];
                    }
                });
            });
            if (btns.includes('yes') && btns.includes('no')) {
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.macButtonOrder) $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(options.actions, {
                    no: btn.no,
                    yes: btn.yes
                });
                else $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(options.actions, {
                    yes: btn.yes,
                    no: btn.no
                });
            }
            if (btns.includes('ok') && btns.includes('cancel')) {
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.macButtonOrder) $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(options.actions, {
                    cancel: btn.cancel,
                    ok: btn.ok
                });
                else $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(options.actions, {
                    ok: btn.ok,
                    cancel: btn.cancel
                });
            }
            return options;
        }
        getSize(el, type) {
            el = $aa2bd8933167d9cb$export$2fa187e846a241c4(el) // for backward compatibility
            ;
            let ret = 0;
            if (el.length > 0) {
                el = el[0];
                let styles = getComputedStyle(el);
                switch(type){
                    case 'width':
                        ret = parseFloat(styles.width);
                        if (styles.width === 'auto') ret = 0;
                        break;
                    case 'height':
                        ret = parseFloat(styles.height);
                        if (styles.height === 'auto') ret = 0;
                        break;
                    default:
                        ret = parseFloat(styles[type] ?? 0) || 0;
                        break;
                }
            }
            return ret;
        }
        getStrWidth(str, styles, raw) {
            $aa2bd8933167d9cb$export$2fa187e846a241c4('body').append(`
            <div id="_tmp_width" style="position: absolute; top: -9000px; ${styles || ''}">
                ${raw ? str : this.encodeTags(str)}
            </div>`);
            let width = $aa2bd8933167d9cb$export$2fa187e846a241c4('#_tmp_width')[0].clientWidth;
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#_tmp_width').remove();
            return width;
        }
        execTemplate(str, replace_obj) {
            if (typeof str !== 'string' || !replace_obj || typeof replace_obj !== 'object') return str;
            return str.replace(/\${([^}]+)?}/g, function($1, $2) {
                return replace_obj[$2] || $2;
            });
        }
        marker(el, items, options = {
            onlyFirst: false,
            wholeWord: false
        }) {
            if (!Array.isArray(items)) {
                if (items != null && items !== '') items = [
                    items
                ];
                else items = [];
            }
            let ww = options.wholeWord;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(el).each((el)=>{
                clearMerkers(el);
                items.forEach((str)=>{
                    if (typeof str !== 'string') str = String(str);
                    let replaceValue = (matched)=>{
                        return '<span class="w2ui-marker">' + matched + '</span>';
                    };
                    // escape regex special chars
                    str = str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&').replace(/&/g, '&amp;').replace(/</g, '&gt;').replace(/>/g, '&lt;');
                    let regex = new RegExp((ww ? '\\b' : '') + str + (ww ? '\\b' : '') + '(?!([^<]+)?>)', 'i' + (!options.onlyFirst ? 'g' : '')) // only outside tags
                    ;
                    el.innerHTML = el.innerHTML.replace(regex, replaceValue);
                });
            });
            function clearMerkers(el) {
                let markerRE = /\<span class=\"w2ui\-marker\"\>((.|\n|\r)*)\<\/span\>/ig;
                while(el.innerHTML.indexOf('<span class="w2ui-marker"') !== -1)el.innerHTML = el.innerHTML.replace(markerRE, '$1') // unmark
                ;
            }
        }
        lang(phrase, params) {
            if (!phrase || this.settings.phrases == null // if no phrases at all
             || typeof phrase !== 'string' || '<=>='.includes(phrase)) return this.execTemplate(phrase, params);
            let translation = this.settings.phrases[phrase];
            if (translation == null) {
                translation = phrase;
                if (this.settings.warnNoPhrase) {
                    if (!this.settings.missing) this.settings.missing = {};
                    this.settings.missing[phrase] = '---' // collect phrases for translation, warn once
                    ;
                    this.settings.phrases[phrase] = '---';
                    console.log(`Missing translation for "%c${phrase}%c", see %c w2utils.settings.phrases %c with value "---"`, 'color: orange', '', 'color: #999', '');
                }
            } else if (translation === '---' && !this.settings.warnNoPhrase) translation = phrase;
            if (translation === '---') translation = `<span ${this.tooltip(phrase)}>---</span>`;
            return this.execTemplate(translation, params);
        }
        locale(locale, keepPhrases, noMerge) {
            return new Promise((resolve, reject)=>{
                // if locale is an array we call this function recursively and merge the results
                if (Array.isArray(locale)) {
                    this.settings.phrases = {};
                    let proms = [];
                    let files = {};
                    locale.forEach((file, ind)=>{
                        if (file.length === 5) {
                            file = 'locale/' + file.toLowerCase() + '.json';
                            locale[ind] = file;
                        }
                        proms.push(this.locale(file, true, false));
                    });
                    Promise.allSettled(proms).then((res)=>{
                        // order of files is important to merge
                        res.forEach((r)=>{
                            if (r.value) files[r.value.file] = r.value.data;
                        });
                        locale.forEach((file)=>{
                            this.settings = this.extend({}, this.settings, files[file]);
                        });
                        resolve();
                    });
                    return;
                }
                if (!locale) locale = 'en-us';
                // if locale is an object, then merge it with w2utils.settings
                if (locale instanceof Object) {
                    this.settings = this.extend({}, this.settings, $aa2bd8933167d9cb$export$b4da1e96fca83d89, locale);
                    return;
                }
                if (locale.length === 5) locale = 'locale/' + locale.toLowerCase() + '.json';
                // load from the file
                fetch(locale, {
                    method: 'GET'
                }).then((res)=>res.json()).then((data)=>{
                    if (noMerge !== true) {
                        if (keepPhrases) this.settings = this.extend({}, this.settings, data);
                        else this.settings = this.extend({}, this.settings, $aa2bd8933167d9cb$export$b4da1e96fca83d89, {
                            phrases: {}
                        }, data);
                    }
                    resolve({
                        file: locale,
                        data: data
                    });
                }).catch((err)=>{
                    console.log('ERROR: Cannot load locale ' + locale);
                    reject(err);
                });
            });
        }
        scrollBarSize() {
            if (this.tmp.scrollBarSize) return this.tmp.scrollBarSize;
            let html = `
            <div id="_scrollbar_width" style="position: absolute; top: -300px; width: 100px; height: 100px; overflow-y: scroll;">
                <div style="height: 120px">1</div>
            </div>
        `;
            $aa2bd8933167d9cb$export$2fa187e846a241c4('body').append(html);
            this.tmp.scrollBarSize = 100 - $aa2bd8933167d9cb$export$2fa187e846a241c4('#_scrollbar_width > div')[0].clientWidth;
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#_scrollbar_width').remove();
            return this.tmp.scrollBarSize;
        }
        checkName(name) {
            if (name == null) {
                console.log('ERROR: Property "name" is required but not supplied.');
                return false;
            }
            if ($aa2bd8933167d9cb$export$dca4c93ccda43b77[name] != null) {
                console.log(`ERROR: Object named "${name}" is already registered as w2ui.${name}.`);
                return false;
            }
            if (!this.isAlphaNumeric(name)) {
                console.log('ERROR: Property "name" has to be alpha-numeric (a-z, 0-9, dash and underscore).');
                return false;
            }
            return true;
        }
        checkUniqueId(id, items, desc, obj) {
            if (!Array.isArray(items)) items = [
                items
            ];
            let isUnique = true;
            items.forEach((item)=>{
                if (item.id === id) {
                    console.log(`ERROR: The item id="${id}" is not unique within the ${desc} "${obj}".`, items);
                    isUnique = false;
                }
            });
            return isUnique;
        }
        /**
     * Takes an object and encodes it into params string to be passed as a url
     * { a: 1, b: 'str'}                => "a=1&b=str"
     * { a: 1, b: { c: 2 }}             => "a=1&b[c]=2"
     * { a: 1, b: {c: { k: 'dfdf' } } } => "a=1&b[c][k]=dfdf"
     */ encodeParams(obj, prefix = '') {
            let str = '';
            Object.keys(obj).forEach((key)=>{
                if (str != '') str += '&';
                if (typeof obj[key] == 'object') str += this.encodeParams(obj[key], prefix + key + (prefix ? ']' : '') + '[');
                else str += `${prefix}${key}${prefix ? ']' : ''}=${obj[key]}`;
            });
            return str;
        }
        parseRoute(route) {
            let keys = [];
            let path = route.replace(/\/\(/g, '(?:/').replace(/\+/g, '__plus__').replace(/(\/)?(\.)?:(\w+)(?:(\(.*?\)))?(\?)?/g, (_, slash, format, key, capture, optional)=>{
                keys.push({
                    name: key,
                    optional: !!optional
                });
                slash = slash || '';
                return '' + (optional ? '' : slash) + '(?:' + (optional ? slash : '') + (format || '') + (capture || format && '([^/.]+?)' || '([^/]+?)') + ')' + (optional || '');
            }).replace(/([\/.])/g, '\\$1').replace(/__plus__/g, '(.+)').replace(/\*/g, '(.*)');
            return {
                path: new RegExp('^' + path + '$', 'i'),
                keys: keys
            };
        }
        getCursorPosition(input) {
            if (input == null) return null;
            let caretOffset = 0;
            let doc = input.ownerDocument || input.document;
            let win = doc.defaultView || doc.parentWindow;
            let sel;
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(input.tagName)) caretOffset = input.selectionStart;
            else {
                if (win.getSelection) {
                    sel = win.getSelection();
                    if (sel.rangeCount > 0) {
                        let range = sel.getRangeAt(0);
                        let preCaretRange = range.cloneRange();
                        preCaretRange.selectNodeContents(input);
                        preCaretRange.setEnd(range.endContainer, range.endOffset);
                        caretOffset = preCaretRange.toString().length;
                    }
                } else if ((sel = doc.selection) && sel.type !== 'Control') {
                    let textRange = sel.createRange();
                    let preCaretTextRange = doc.body.createTextRange();
                    preCaretTextRange.moveToElementText(input);
                    preCaretTextRange.setEndPoint('EndToEnd', textRange);
                    caretOffset = preCaretTextRange.text.length;
                }
            }
            return caretOffset;
        }
        setCursorPosition(input, pos, posEnd) {
            if (input == null) return;
            let range = document.createRange();
            let el, sel = window.getSelection();
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(input.tagName)) input.setSelectionRange(pos, posEnd ?? pos);
            else {
                for(let i = 0; i < input.childNodes.length; i++){
                    let tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(input.childNodes[i]).text();
                    if (input.childNodes[i].tagName) {
                        tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(input.childNodes[i]).html();
                        tmp = tmp.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&nbsp;/g, ' ');
                    }
                    if (pos <= tmp.length) {
                        el = input.childNodes[i];
                        if (el.childNodes && el.childNodes.length > 0) el = el.childNodes[0];
                        if (el.childNodes && el.childNodes.length > 0) el = el.childNodes[0];
                        break;
                    } else pos -= tmp.length;
                }
                if (el == null) return;
                if (pos > el.length) pos = el.length;
                range.setStart(el, pos);
                if (posEnd) range.setEnd(el, posEnd);
                else range.collapse(true);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
        parseColor(str) {
            if (typeof str !== 'string') return null;
            else str = str.trim().toUpperCase();
            if (str[0] === '#') str = str.substr(1);
            let color = {};
            if (str.length === 3) color = {
                r: parseInt(str[0] + str[0], 16),
                g: parseInt(str[1] + str[1], 16),
                b: parseInt(str[2] + str[2], 16),
                a: 1
            };
            else if (str.length === 6) color = {
                r: parseInt(str.substr(0, 2), 16),
                g: parseInt(str.substr(2, 2), 16),
                b: parseInt(str.substr(4, 2), 16),
                a: 1
            };
            else if (str.length === 8) color = {
                r: parseInt(str.substr(0, 2), 16),
                g: parseInt(str.substr(2, 2), 16),
                b: parseInt(str.substr(4, 2), 16),
                a: Math.round(parseInt(str.substr(6, 2), 16) / 255 * 100) / 100 // alpha channel 0-1
            };
            else if (str.length > 4 && str.substr(0, 4) === 'RGB(') {
                let tmp = str.replace('RGB', '').replace(/\(/g, '').replace(/\)/g, '').split(',');
                color = {
                    r: parseInt(tmp[0], 10),
                    g: parseInt(tmp[1], 10),
                    b: parseInt(tmp[2], 10),
                    a: 1
                };
            } else if (str.length > 5 && str.substr(0, 5) === 'RGBA(') {
                let tmp = str.replace('RGBA', '').replace(/\(/g, '').replace(/\)/g, '').split(',');
                color = {
                    r: parseInt(tmp[0], 10),
                    g: parseInt(tmp[1], 10),
                    b: parseInt(tmp[2], 10),
                    a: parseFloat(tmp[3])
                };
            } else return null;
            return color;
        }
        colorContrast(color1, color2) {
            let lum1 = calcLumens(color1);
            let lum2 = calcLumens(color2);
            let ratio = (Math.max(lum1, lum2) + 0.05) / (Math.min(lum1, lum2) + 0.05);
            return ratio.toFixed(2);
            function calcLumens(color) {
                let { r: r, g: g, b: b } = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseColor(color) ?? {
                    r: 0,
                    g: 0,
                    b: 0
                };
                let gamma = 2.2;
                let normR = r / 255;
                let normG = g / 255;
                let normB = b / 255;
                let sR = normR <= 0.03928 ? normR / 12.92 : Math.pow((normR + 0.055) / 1.055, gamma);
                let sG = normG <= 0.03928 ? normG / 12.92 : Math.pow((normG + 0.055) / 1.055, gamma);
                let sB = normB <= 0.03928 ? normB / 12.92 : Math.pow((normB + 0.055) / 1.055, gamma);
                return 0.2126 * sR + 0.7152 * sG + 0.0722 * sB;
            }
        }
        // h=0..360, s=0..100, v=0..100
        hsv2rgb(h, s, v, a) {
            let r, g, b, i, f, p, q, t;
            if (arguments.length === 1) {
                s = h.s;
                v = h.v;
                a = h.a;
                h = h.h;
            }
            h = h / 360;
            s = s / 100;
            v = v / 100;
            i = Math.floor(h * 6);
            f = h * 6 - i;
            p = v * (1 - s);
            q = v * (1 - f * s);
            t = v * (1 - (1 - f) * s);
            switch(i % 6){
                case 0:
                    r = v, g = t, b = p;
                    break;
                case 1:
                    r = q, g = v, b = p;
                    break;
                case 2:
                    r = p, g = v, b = t;
                    break;
                case 3:
                    r = p, g = q, b = v;
                    break;
                case 4:
                    r = t, g = p, b = v;
                    break;
                case 5:
                    r = v, g = p, b = q;
                    break;
            }
            return {
                r: Math.round(r * 255),
                g: Math.round(g * 255),
                b: Math.round(b * 255),
                a: a != null ? a : 1
            };
        }
        // r=0..255, g=0..255, b=0..255
        rgb2hsv(r, g, b, a) {
            if (arguments.length === 1) {
                g = r.g;
                b = r.b;
                a = r.a;
                r = r.r;
            }
            let max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min, h, s = max === 0 ? 0 : d / max, v = max / 255;
            switch(max){
                case min:
                    h = 0;
                    break;
                case r:
                    h = g - b + d * (g < b ? 6 : 0);
                    h /= 6 * d;
                    break;
                case g:
                    h = b - r + d * 2;
                    h /= 6 * d;
                    break;
                case b:
                    h = r - g + d * 4;
                    h /= 6 * d;
                    break;
            }
            return {
                h: Math.round(h * 360),
                s: Math.round(s * 100),
                v: Math.round(v * 100),
                a: a != null ? a : 1
            };
        }
        tooltip(html, options) {
            let actions;
            let showOn = 'mouseenter';
            let hideOn = 'mouseleave';
            if (typeof html == 'object') options = html;
            options = options || {};
            if (typeof html == 'string') options.html = html;
            if (options.showOn) {
                showOn = options.showOn;
                delete options.showOn;
            }
            if (options.hideOn) {
                hideOn = options.hideOn;
                delete options.hideOn;
            }
            if (!options.name) options.name = 'no-name';
            // base64 is needed to avoid '"<> and other special chars conflicts
            actions = ` on${showOn}="w2tooltip.show(this, ` + `JSON.parse(w2utils.base64decode('${this.base64encode(JSON.stringify(options))}')))" ` + `on${hideOn}="w2tooltip.hide('${options.name}')"`;
            return actions;
        }
        // determins if it is plain Object, not DOM element, nor a function, event, etc.
        isPlainObject(value) {
            if (value == null) return false;
            if (Object.prototype.toString.call(value) !== '[object Object]') return false;
            if (value.constructor === undefined) return true;
            let proto = Object.getPrototypeOf(value);
            return proto === null || proto === Object.prototype;
        }
        /**
     * Deep copy of an object or an array. Function, events and HTML elements will not be cloned,
     * you can choose to include them or not, by default they are included.
     * You can also exclude certain elements from final object if used with options: { exclude }
     */ clone(obj, options) {
            let ret;
            options = Object.assign({
                functions: true,
                elements: true,
                events: true,
                exclude: []
            }, options ?? {});
            if (Array.isArray(obj)) {
                ret = Array.from(obj);
                ret.forEach((value, ind)=>{
                    ret[ind] = this.clone(value, options);
                });
            } else if (this.isPlainObject(obj)) {
                ret = {};
                Object.assign(ret, obj);
                if (options.exclude) options.exclude.forEach((key)=>{
                    delete ret[key];
                }) // delete excluded keys
                ;
                Object.keys(ret).forEach((key)=>{
                    ret[key] = this.clone(ret[key], options);
                    if (ret[key] === undefined) delete ret[key] // do not include undefined elements
                    ;
                });
            } else {
                if (obj instanceof Function && !options.functions || obj instanceof Node && !options.elements || obj instanceof Event && !options.events) ;
                else ret = obj;
            }
            return ret;
        }
        /**
     * Deep extend an object, if an array, it overwrrites it, cloning objects in the process
     * target, source1, source2, ...
     */ extend(target, source) {
            if (Array.isArray(target)) {
                if (Array.isArray(source)) {
                    target.splice(0, target.length) // empty array but keep the reference
                    ;
                    source.forEach((s)=>{
                        target.push(this.clone(s));
                    });
                } else throw new Error('Arrays can be extended with arrays only');
            } else if (target instanceof Node || target instanceof Event) throw new Error('HTML elmenents and events cannot be extended');
            else if (target && typeof target == 'object' && source != null) {
                if (typeof source != 'object') throw new Error('Object can be extended with other objects only.');
                Object.keys(source).forEach((key)=>{
                    if (target[key] != null && typeof target[key] == 'object' && source[key] != null && typeof source[key] == 'object') {
                        let src = this.clone(source[key]);
                        // do not extend HTML elements and events, but overwrite them
                        if (target[key] instanceof Node || target[key] instanceof Event) target[key] = src;
                        else {
                            // if an array needs to be extended with an object, then convert it to empty object
                            if (Array.isArray(target[key]) && this.isPlainObject(src)) target[key] = {};
                            this.extend(target[key], src);
                        }
                    } else target[key] = this.clone(source[key]);
                });
            } else if (source != null) throw new Error('Object is not extendable, only {} or [] can be extended.');
            // other arguments
            if (arguments.length > 2) for(let i = 2; i < arguments.length; i++)this.extend(target, arguments[i]);
            return target;
        }
        /*
     * @author     Lauri Rooden (https://github.com/litejs/natural-compare-lite)
     * @license    MIT License
     */ naturalCompare(a, b) {
            let i, codeA, codeB = 1, posA = 0, posB = 0, alphabet = String.alphabet;
            function getCode(str, pos, code) {
                if (code) {
                    for(i = pos; code = getCode(str, i), code < 76 && code > 65;)++i;
                    return +str.slice(pos - 1, i);
                }
                code = alphabet && alphabet.indexOf(str.charAt(pos));
                return code > -1 ? code + 76 : (code = str.charCodeAt(pos) || 0, code < 45 || code > 127) ? code : code < 46 ? 65 // -
                 : code < 48 ? code - 1 : code < 58 ? code + 18 // 0-9
                 : code < 65 ? code - 11 : code < 91 ? code + 11 // A-Z
                 : code < 97 ? code - 37 : code < 123 ? code + 5 // a-z
                 : code - 63;
            }
            if ((a += '') != (b += '')) for(; codeB;){
                codeA = getCode(a, posA++);
                codeB = getCode(b, posB++);
                if (codeA < 76 && codeB < 76 && codeA > 66 && codeB > 66) {
                    codeA = getCode(a, posA, posA);
                    codeB = getCode(b, posB, posA = i);
                    posB = i;
                }
                if (codeA != codeB) return codeA < codeB ? -1 : 1;
            }
            return 0;
        }
        normMenu(menu, el) {
            if (Array.isArray(menu)) {
                menu.forEach((it, m)=>{
                    if (typeof it === 'string' || typeof it === 'number') menu[m] = {
                        id: it,
                        text: String(it)
                    };
                    else if (it != null) {
                        if (it.caption != null && it.text == null) it.text = it.caption;
                        if (it.text != null && it.id == null) it.id = it.text;
                        if (it.text == null && it.id != null) it.text = it.id;
                    } else menu[m] = {
                        id: null,
                        text: 'null'
                    };
                });
                return menu;
            } else if (typeof menu === 'function') {
                let newMenu = menu.call(this, menu, el);
                return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, newMenu);
            } else if (typeof menu === 'object') return Object.keys(menu).map((key)=>{
                return {
                    id: key,
                    text: menu[key]
                };
            });
        }
        /**
     * Takes Url object and fetchOptions and changes it in place applying selected user dataType. Since
     * dataType is in w2utils. This method is used in grid, form and tooltip to prepare fetch parameters
     */ prepareParams(url, fetchOptions, defDataType) {
            let dataType = defDataType ?? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dataType;
            let postParams = fetchOptions.body;
            switch(dataType){
                case 'HTTPJSON':
                    postParams = {
                        request: postParams
                    };
                    if ([
                        'PUT',
                        'DELETE'
                    ].includes(fetchOptions.method)) fetchOptions.method = 'POST';
                    body2params();
                    break;
                case 'HTTP':
                    if ([
                        'PUT',
                        'DELETE'
                    ].includes(fetchOptions.method)) fetchOptions.method = 'POST';
                    body2params();
                    break;
                case 'RESTFULL':
                    if ([
                        'PUT',
                        'DELETE'
                    ].includes(fetchOptions.method)) fetchOptions.headers['Content-Type'] = 'application/json';
                    else body2params();
                    break;
                case 'JSON':
                    if (fetchOptions.method == 'GET') {
                        postParams = {
                            request: postParams
                        };
                        body2params();
                    } else {
                        fetchOptions.headers['Content-Type'] = 'application/json';
                        fetchOptions.method = 'POST';
                    }
                    break;
            }
            fetchOptions.body = typeof fetchOptions.body == 'string' ? fetchOptions.body : JSON.stringify(fetchOptions.body);
            return fetchOptions;
            function body2params() {
                Object.keys(postParams).forEach((key)=>{
                    let param = postParams[key];
                    if (typeof param == 'object') param = JSON.stringify(param);
                    url.searchParams.append(key, param);
                });
                delete fetchOptions.body;
            }
        }
        bindEvents(selector, subject) {
            // format is
            // <div ... data-<event>='["<method>","param1","param2",...]'> -- should be valid JSON (no undefined)
            // <div ... data-<event>="<method>|param1|param2">
            // -- can have "event", "this", "stop", "stopPrevent", "alert" - as predefined objects
            if (selector.length == 0) return;
            // for backward compatibility
            if (selector?.[0] instanceof Node) selector = Array.isArray(selector) ? selector : selector.get();
            $aa2bd8933167d9cb$export$2fa187e846a241c4(selector).each((el)=>{
                let actions = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).data();
                Object.keys(actions).forEach((name)=>{
                    let events = [
                        'click',
                        'dblclick',
                        'mouseenter',
                        'mouseleave',
                        'mouseover',
                        'mouseout',
                        'mousedown',
                        'mousemove',
                        'mouseup',
                        'contextmenu',
                        'focus',
                        'focusin',
                        'focusout',
                        'blur',
                        'input',
                        'change',
                        'keydown',
                        'keyup',
                        'keypress'
                    ];
                    if (events.indexOf(String(name).toLowerCase()) == -1) return;
                    let params = actions[name];
                    if (typeof params == 'string') params = params.split('|').map((key)=>{
                        if (key === 'true') key = true;
                        if (key === 'false') key = false;
                        if (key === 'undefined') key = undefined;
                        if (key === 'null') key = null;
                        if (parseFloat(key) == key) key = parseFloat(key);
                        let quotes = [
                            '\'',
                            '"',
                            '`'
                        ];
                        if (typeof key == 'string' && quotes.includes(key[0]) && quotes.includes(key[key.length - 1])) key = key.substring(1, key.length - 1);
                        return key;
                    });
                    let method = params[0];
                    params = params.slice(1) // should be new array
                    ;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(el).off(name + '.w2utils-bind').on(name + '.w2utils-bind', function(event1) {
                        switch(method){
                            case 'alert':
                                alert(params[0]) // for testing purposes
                                ;
                                break;
                            case 'stop':
                                event1.stopPropagation();
                                break;
                            case 'prevent':
                                event1.preventDefault();
                                break;
                            case 'stopPrevent':
                                event1.stopPropagation();
                                event1.preventDefault();
                                return false;
                            default:
                                if (subject[method] == null) throw new Error(`Cannot dispatch event as the method "${method}" does not exist.`);
                                subject[method].apply(subject, params.map((key, ind)=>{
                                    switch(String(key).toLowerCase()){
                                        case 'event':
                                            return event1;
                                        case 'this':
                                            return this;
                                        default:
                                            return key;
                                    }
                                }));
                        }
                    });
                });
            });
        }
        debounce(func, wait = 250) {
            let timeout;
            return (...args)=>{
                clearTimeout(timeout);
                timeout = setTimeout(()=>{
                    func(...args);
                }, wait);
            };
        }
    }
    var $aa2bd8933167d9cb$export$fe3767bc112f7a2a = new $aa2bd8933167d9cb$var$Utils() // eslint-disable-line -- needs to be functional/module scope variable
    ;
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: mQuery, w2utils, w2base
 *
 * == 2.0 changes
 *  - CSP - fixed inline events
 *  - removed jQuery dependency
 *  - popup.open - returns promise like object
 *  - popup.confirm - refactored
 *  - popup.message - refactored
 *  - removed popup.options.mutliple
 *  - refactores w2alert, w2confirm, w2prompt
 *  - add w2popup.open().on('')
 *  - removed w2popup.restoreTemplate
 *  - deprecated onMsgOpen and onMsgClose
 *  - deprecated options.bgColor
 *  - rename focus -> setFocus
 *  - added center() // will auto center on window resize
 *  - close(immediate), also refactored if popup is closed when opening
 */ class $aa2bd8933167d9cb$export$3ddf2d174ce01153 extends $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        constructor(){
            super();
            this.defaults = {
                title: '',
                text: '',
                body: '',
                buttons: '',
                width: 450,
                height: 250,
                focus: null,
                actions: null,
                style: '',
                speed: 0.3,
                modal: false,
                maximized: false,
                keyboard: true,
                showClose: true,
                showMax: false,
                transition: null,
                openMaximized: false,
                moved: false
            };
            this.name = 'popup';
            this.status = 'closed' // string that describes current queryStatus
            ;
            this.onOpen = null;
            this.onClose = null;
            this.onMax = null;
            this.onMin = null;
            this.onToggle = null;
            this.onKeydown = null;
            this.onAction = null;
            this.onMove = null;
            this.tmp = {};
            // event handler for resize
            this.handleResize = (event1)=>{
                // if it was moved by the user, do not auto resize
                if (!this.options.moved) this.center(undefined, undefined, true);
            };
        }
        /**
     * Sample calls
     * - w2popup.open('ddd').ok(() => { w2popup.close() })
     * - w2popup.open('ddd', { height: 120 }).ok(() => { w2popup.close() })
     * - w2popup.open({ body: 'text', enableAccess: 'caption', actions: ["Close"] }).close(() => { w2popup.close() })
     * - w2popup.open({ body: 'text', enableAccess: 'caption', actions: { Close() { w2popup.close() }} })
     */ open(options) {
            let self1 = this;
            if (this.status == 'closing' || $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').hasClass('animating')) this.close(true);
            // get old options and merge them
            let old_options = this.options;
            if ([
                'string',
                'number'
            ].includes(typeof options)) options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                title: 'Notification',
                body: `<div class="w2ui-centered">${options}</div>`,
                actions: {
                    Ok () {
                        self1.close();
                    }
                },
                cancelAction: 'ok'
            }, arguments[1] ?? {});
            if (options.text != null) options.body = `<div class="w2ui-centered w2ui-msg-text">${options.text}</div>`;
            options = Object.assign({}, this.defaults, old_options, {
                title: '',
                body: ''
            }, options, {
                maximized: false
            });
            this.options = options;
            // if new - reset event handlers
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').length === 0) {
                this.off('*');
                Object.keys(this).forEach((key)=>{
                    if (key.startsWith('on') && key != 'on') this[key] = null;
                });
            }
            // reassign events
            Object.keys(options).forEach((key)=>{
                if (key.startsWith('on') && key != 'on' && options[key]) this[key] = options[key];
            });
            options.width = parseInt(options.width);
            options.height = parseInt(options.height);
            let edata, msg, tmp;
            let { top: top, left: left } = this.center();
            let prom = {
                self: this,
                action (callBack) {
                    self1.on('action.prom', callBack);
                    return prom;
                },
                close (callBack) {
                    self1.on('close.prom', callBack);
                    return prom;
                },
                then (callBack) {
                    self1.on('open:after.prom', callBack);
                    return prom;
                }
            };
            // convert action arrays into buttons
            if (options.actions != null && !options.buttons) {
                options.buttons = '';
                Object.keys(options.actions).forEach((action)=>{
                    let handler = options.actions[action];
                    let btnAction = action;
                    if (typeof handler == 'function') options.buttons += `<button class="w2ui-btn w2ui-eaction" name="${action}" data-click='["action","${action}","event"]'>${action}</button>`;
                    if (typeof handler == 'object') {
                        options.buttons += `<button class="w2ui-btn w2ui-eaction ${handler.class || ''}" name="${action}" data-click='["action","${action}","event"]'
                        style="${handler.style}" ${handler.attrs}>${handler.text || action}</button>`;
                        btnAction = Array.isArray(options.actions) ? handler.text : action;
                    }
                    if (typeof handler == 'string') {
                        options.buttons += `<button class="w2ui-btn w2ui-eaction" name="${action}" data-click='["action","${action}","event"]'>${handler}</button>`;
                        btnAction = handler;
                    }
                    if (typeof btnAction == 'string') btnAction = btnAction[0].toLowerCase() + btnAction.substr(1).replace(/\s+/g, '');
                    prom[btnAction] = function(callBack) {
                        self1.on('action.buttons', (event1)=>{
                            let target = event1.detail.action[0].toLowerCase() + event1.detail.action.substr(1).replace(/\s+/g, '');
                            if (target == btnAction) callBack(event1);
                        });
                        return prom;
                    };
                });
            }
            // check if message is already displayed
            let titleBtns = '';
            if (options.showClose) titleBtns += `<div class="w2ui-popup-button w2ui-popup-close">
                        <span class="w2ui-icon w2ui-icon-cross w2ui-eaction" data-mousedown="stop" data-click="close"></span>
                    </div>`;
            if (options.showMax) titleBtns += `<div class="w2ui-popup-button w2ui-popup-max">
                        <span class="w2ui-icon w2ui-icon-box w2ui-eaction" data-mousedown="stop" data-click="toggle"></span>
                    </div>`;
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').length === 0) {
                // trigger event
                edata = this.trigger('open', {
                    target: 'popup',
                    present: false
                });
                if (edata.isCancelled === true) return;
                this.status = 'opening';
                // output message
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lock(document.body, {
                    opacity: 0.3,
                    onClick: options.modal ? null : ()=>{
                        this.close();
                    }
                });
                // first insert just body
                let styles = `
                left: ${left}px;
                top: ${top}px;
                width: ${parseInt(options.width)}px;
                height: ${parseInt(options.height)}px;
                transition: ${options.speed}s
            `;
                msg = `<div id="w2ui-popup" class="w2ui-popup w2ui-anim-open animating" style="${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripSpaces(styles)}"></div>`;
                $aa2bd8933167d9cb$export$2fa187e846a241c4('body').append(msg);
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup')[0]._w2popup = {
                    self: this,
                    created: new Promise((resolve)=>{
                        this._promCreated = resolve;
                    }),
                    opened: new Promise((resolve)=>{
                        this._promOpened = resolve;
                    }),
                    closing: new Promise((resolve)=>{
                        this._promClosing = resolve;
                    }),
                    closed: new Promise((resolve)=>{
                        this._promClosed = resolve;
                    })
                };
                // then content
                styles = `${!options.title ? 'top: 0px !important;' : ''} ${!options.buttons ? 'bottom: 0px !important;' : ''}`;
                msg = `
                <span name="hidden-first" tabindex="0" style="position: absolute; top: -100px"></span>
                <div class="w2ui-popup-title-btns">${titleBtns}</div>
                <div class="w2ui-popup-title" style="${!options.title ? 'display: none' : ''}"></div>
                <div class="w2ui-box" style="${styles}">
                    <div class="w2ui-popup-body ${!options.title || ' w2ui-popup-no-title'}
                        ${!options.buttons || ' w2ui-popup-no-buttons'}" style="${options.style}">
                    </div>
                </div>
                <div class="w2ui-popup-buttons" style="${!options.buttons ? 'display: none' : ''}"></div>
                <span name="hidden-last" tabindex="0" style="position: absolute; top: -100px"></span>
            `;
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').html(msg);
                if (options.title) $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-title').append($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(options.title));
                if (options.buttons) $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-buttons').append(options.buttons);
                if (options.body) $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-body').append(options.body);
                // allow element to render
                setTimeout(()=>{
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').css('transition', options.speed + 's').removeClass('w2ui-anim-open');
                    $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents('#w2ui-popup .w2ui-eaction', this);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').find('.w2ui-popup-body').show();
                    this._promCreated();
                }, 1);
                // clean transform
                clearTimeout(this._timer);
                this._timer = setTimeout(()=>{
                    this.status = 'open';
                    self1.setFocus(options.focus);
                    // event after
                    edata.finish();
                    this._promOpened();
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').removeClass('animating');
                }, options.speed * 1000);
            } else {
                // trigger event
                edata = this.trigger('open', {
                    target: 'popup',
                    present: true
                });
                if (edata.isCancelled === true) return;
                // check if size changed
                this.status = 'opening';
                if (old_options != null) {
                    if (!old_options.maximized && (old_options.width != options.width || old_options.height != options.height)) this.resize(options.width, options.height);
                    options.prevSize = options.width + 'px:' + options.height + 'px';
                    options.maximized = old_options.maximized;
                }
                // show new items
                let cloned = $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-box').get(0).cloneNode(true);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(cloned).removeClass('w2ui-box').addClass('w2ui-box-temp').find('.w2ui-popup-body').empty().append(options.body);
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-box').after(cloned);
                if (options.buttons) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-buttons').show().html('').append(options.buttons);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-body').removeClass('w2ui-popup-no-buttons');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-box, #w2ui-popup .w2ui-box-temp').css('bottom', '');
                } else {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-buttons').hide().html('');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-body').addClass('w2ui-popup-no-buttons');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-box, #w2ui-popup .w2ui-box-temp').css('bottom', '0px');
                }
                if (options.title) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-title').show().html($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(options.title));
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-body').removeClass('w2ui-popup-no-title');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-box, #w2ui-popup .w2ui-box-temp').css('top', '');
                } else {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-title').hide().html('');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-body').addClass('w2ui-popup-no-title');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-box, #w2ui-popup .w2ui-box-temp').css('top', '0px');
                }
                if (titleBtns) $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-title-btns').show().html(titleBtns);
                else $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-title-btns').hide();
                // transition
                let div_old = $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-box')[0];
                let div_new = $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-box-temp')[0];
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').addClass('animating');
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.transition(div_old, div_new, options.transition, ()=>{
                    // clean up
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(div_old).remove();
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).removeClass('w2ui-box-temp').addClass('w2ui-box');
                    let $body = $aa2bd8933167d9cb$export$2fa187e846a241c4(div_new).find('.w2ui-popup-body');
                    if ($body.length == 1) {
                        $body[0].style.cssText = options.style;
                        $body.show();
                    }
                    // focus on first button
                    self1.setFocus(options.focus);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').removeClass('animating');
                });
                // call event onOpen
                this.status = 'open';
                edata.finish();
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents('#w2ui-popup .w2ui-eaction', this);
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').find('.w2ui-popup-body').show();
            }
            if (options.openMaximized) this.max();
            // save new options
            options._last_focus = document.activeElement;
            // keyboard events
            if (options.keyboard) $aa2bd8933167d9cb$export$2fa187e846a241c4(document.body).off('.w2popup').on('keydown.w2popup', (event1)=>{
                this.keydown(event1);
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(window).on('resize', this.handleResize);
            // initialize move
            tmp = {
                resizing: false,
                mvMove: mvMove,
                mvStop: mvStop
            };
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-title').on('mousedown', function(event1) {
                if (!self1.options.maximized) mvStart(event1);
            });
            return prom;
            // handlers
            function mvStart(evt) {
                if (!evt) evt = window.event;
                self1.status = 'moving';
                let rect = $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').get(0).getBoundingClientRect();
                Object.assign(tmp, {
                    resizing: true,
                    isLocked: $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup > .w2ui-lock').length == 1 ? true : false,
                    x: evt.screenX,
                    y: evt.screenY,
                    pos_x: rect.x,
                    pos_y: rect.y
                });
                if (!tmp.isLocked) self1.lock({
                    opacity: 0
                });
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document.body).on('mousemove.w2ui-popup', tmp.mvMove).on('mouseup.w2ui-popup', tmp.mvStop);
                if (evt.stopPropagation) evt.stopPropagation();
                else evt.cancelBubble = true;
                if (evt.preventDefault) evt.preventDefault();
                else return false;
            }
            function mvMove(evt) {
                if (tmp.resizing != true) return;
                if (!evt) evt = window.event;
                tmp.div_x = evt.screenX - tmp.x;
                tmp.div_y = evt.screenY - tmp.y;
                // trigger event
                let edata = self1.trigger('move', {
                    target: 'popup',
                    div_x: tmp.div_x,
                    div_y: tmp.div_y,
                    originalEvent: evt
                });
                if (edata.isCancelled === true) return;
                // default behavior
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').css({
                    'transition': 'none',
                    'transform': 'translate3d(' + tmp.div_x + 'px, ' + tmp.div_y + 'px, 0px)'
                });
                self1.options.moved = true;
                // event after
                edata.finish();
            }
            function mvStop(evt) {
                if (tmp.resizing != true) return;
                if (!evt) evt = window.event;
                self1.status = 'open';
                tmp.div_x = evt.screenX - tmp.x;
                tmp.div_y = evt.screenY - tmp.y;
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').css({
                    'left': tmp.pos_x + tmp.div_x + 'px',
                    'top': tmp.pos_y + tmp.div_y + 'px'
                }).css({
                    'transition': 'none',
                    'transform': 'translate3d(0px, 0px, 0px)'
                });
                tmp.resizing = false;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document.body).off('.w2ui-popup');
                if (!tmp.isLocked) self1.unlock();
            }
        }
        load(options) {
            return new Promise((resolve, reject)=>{
                if (typeof options == 'string') options = {
                    url: options
                };
                if (options.url == null) {
                    console.log('ERROR: The url is not defined.');
                    reject('The url is not defined');
                    return;
                }
                this.status = 'loading';
                let [url, selector] = String(options.url).split('#');
                if (url) fetch(url).then((res)=>res.text()).then((html)=>{
                    resolve(this.template(html, selector, options));
                });
            });
        }
        template(data, id, options = {}) {
            let html;
            try {
                html = $aa2bd8933167d9cb$export$2fa187e846a241c4(data);
            } catch (e) {
                html = $aa2bd8933167d9cb$export$2fa187e846a241c4.html(data);
            }
            if (id) html = html.filter('#' + id);
            Object.assign(options, {
                width: parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(html).css('width')),
                height: parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(html).css('height')),
                title: $aa2bd8933167d9cb$export$2fa187e846a241c4(html).find('[rel=title]').html(),
                body: $aa2bd8933167d9cb$export$2fa187e846a241c4(html).find('[rel=body]').html(),
                buttons: $aa2bd8933167d9cb$export$2fa187e846a241c4(html).find('[rel=buttons]').html(),
                style: $aa2bd8933167d9cb$export$2fa187e846a241c4(html).find('[rel=body]').get(0).style.cssText
            });
            return this.open(options);
        }
        action(action, event1) {
            let click = this.options.actions[action];
            if (click instanceof Object && click.onClick) click = click.onClick;
            // event before
            let edata = this.trigger('action', {
                action: action,
                target: 'popup',
                self: this,
                originalEvent: event1,
                value: this.input ? this.input.value : null
            });
            if (edata.isCancelled === true) return;
            // default actions
            if (typeof click === 'function') click.call(this, event1);
            // event after
            edata.finish();
        }
        keydown(event1) {
            if (this.options && !this.options.keyboard) return;
            // trigger event
            let edata = this.trigger('keydown', {
                target: 'popup',
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // default behavior
            switch(event1.keyCode){
                case 27:
                    event1.preventDefault();
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-message').length == 0) {
                        if (this.options.cancelAction) this.action(this.options.cancelAction);
                        else this.close();
                    }
                    break;
            }
            // event after
            edata.finish();
        }
        close(immediate) {
            // trigger event
            let edata = this.trigger('close', {
                target: 'popup'
            });
            if (edata.isCancelled === true) return;
            let cleanUp = ()=>{
                // return template
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').remove();
                // restore activeID
                if (this.options._last_focus && this.options._last_focus.length > 0) this.options._last_focus.focus();
                this.status = 'closed';
                this.options = {};
                // event after
                edata.finish();
                this._promClosed();
            };
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').length === 0 || this.status == 'closed') return;
            if (this.status == 'opening') immediate = true;
            if (this.status == 'closing' && immediate === true) {
                cleanUp();
                clearTimeout(this.tmp.closingTimer);
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.unlock(document.body, 0);
                return;
            }
            // default behavior
            this.status = 'closing';
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').css('transition', this.options.speed + 's').addClass('w2ui-anim-close animating');
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.unlock(document.body, 300);
            this._promClosing();
            if (immediate) cleanUp();
            else this.tmp.closingTimer = setTimeout(cleanUp, this.options.speed * 1000);
            // remove keyboard events
            if (this.options.keyboard) $aa2bd8933167d9cb$export$2fa187e846a241c4(document.body).off('keydown', this.keydown);
            $aa2bd8933167d9cb$export$2fa187e846a241c4(window).off('resize', this.handleResize);
        }
        toggle() {
            let edata = this.trigger('toggle', {
                target: 'popup'
            });
            if (edata.isCancelled === true) return;
            // default action
            if (this.options.maximized === true) this.min();
            else this.max();
            // event after
            setTimeout(()=>{
                edata.finish();
            }, this.options.speed * 1000 + 50);
        }
        max() {
            if (this.options.maximized === true) return;
            // trigger event
            let edata = this.trigger('max', {
                target: 'popup'
            });
            if (edata.isCancelled === true) return;
            // default behavior
            this.status = 'resizing';
            let rect = $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').get(0).getBoundingClientRect();
            this.options.prevSize = rect.width + ':' + rect.height;
            // do resize
            this.resize(10000, 10000, ()=>{
                this.status = 'open';
                this.options.maximized = true;
                edata.finish();
            });
        }
        min() {
            if (this.options.maximized !== true) return;
            let size = this.options.prevSize.split(':');
            // trigger event
            let edata = this.trigger('min', {
                target: 'popup'
            });
            if (edata.isCancelled === true) return;
            // default behavior
            this.status = 'resizing';
            // do resize
            this.options.maximized = false;
            this.resize(parseInt(size[0]), parseInt(size[1]), ()=>{
                this.status = 'open';
                this.options.prevSize = null;
                edata.finish();
            });
        }
        clear() {
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-title').html('');
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-body').html('');
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-buttons').html('');
        }
        reset() {
            this.open(this.defaults);
        }
        message(options) {
            return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.message({
                owner: this,
                box: $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').get(0),
                after: '.w2ui-popup-title'
            }, options);
        }
        confirm(options) {
            return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.confirm({
                owner: this,
                box: $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup'),
                after: '.w2ui-popup-title'
            }, options);
        }
        setFocus(focus) {
            let box = $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup');
            let sel = 'input, button, select, textarea, [contentEditable], .w2ui-input';
            if (focus != null) {
                let el = isNaN(focus) ? box.find(sel).filter(focus).get(0) : box.find(sel).get(focus);
                el?.focus();
            } else {
                let el = box.find('[name=hidden-first]').get(0);
                if (el) el.focus();
            }
            // keep focus/blur inside popup
            $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel + ',[name=hidden-first],[name=hidden-last]').off('.keep-focus').on('blur.keep-focus', function(event1) {
                setTimeout(()=>{
                    let focus = document.activeElement;
                    let inside = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel).filter(focus).length > 0;
                    let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(focus).attr('name');
                    if (!inside && focus && focus !== document.body) $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel).get(0)?.focus();
                    if (name == 'hidden-last') $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel).get(0)?.focus();
                    if (name == 'hidden-first') $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find(sel).get(-1)?.focus();
                }, 1);
            });
        }
        lock(msg, showSpinner) {
            let args = Array.from(arguments);
            args.unshift($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup'));
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lock(...args);
        }
        unlock(speed) {
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.unlock($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup'), speed);
        }
        center(width, height, force) {
            let maxW, maxH;
            if (window.innerHeight == undefined) {
                maxW = parseInt(document.documentElement.offsetWidth);
                maxH = parseInt(document.documentElement.offsetHeight);
            } else {
                maxW = parseInt(window.innerWidth);
                maxH = parseInt(window.innerHeight);
            }
            width = parseInt(width ?? this.options.width);
            height = parseInt(height ?? this.options.height);
            if (this.options.maximized === true) {
                width = maxW;
                height = maxH;
            }
            if (maxW - 10 < width) width = maxW - 10;
            if (maxH - 10 < height) height = maxH - 10;
            let top = (maxH - height) / 2;
            let left = (maxW - width) / 2;
            if (force) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').css({
                    'transition': 'none',
                    'top': top + 'px',
                    'left': left + 'px',
                    'width': width + 'px',
                    'height': height + 'px'
                });
                this.resizeMessages() // then messages resize nicely
                ;
            }
            return {
                top: top,
                left: left,
                width: width,
                height: height
            };
        }
        resize(newWidth, newHeight, callBack) {
            let self1 = this;
            if (this.options.speed == null) this.options.speed = 0;
            // calculate new position
            let { top: top, left: left, width: width, height: height } = this.center(newWidth, newHeight);
            let speed = this.options.speed;
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').css({
                'transition': `${speed}s width, ${speed}s height, ${speed}s left, ${speed}s top`,
                'top': top + 'px',
                'left': left + 'px',
                'width': width + 'px',
                'height': height + 'px'
            });
            let tmp_int = setInterval(()=>{
                self1.resizeMessages();
            }, 10) // then messages resize nicely
            ;
            setTimeout(()=>{
                clearInterval(tmp_int);
                self1.resizeMessages();
                if (typeof callBack == 'function') callBack();
            }, this.options.speed * 1000 + 50) // give extra 50 ms
            ;
        }
        // internal function
        resizeMessages() {
            // see if there are messages and resize them
            $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-message').each((msg)=>{
                let mopt = msg._msg_options;
                let popup = $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup');
                if (parseInt(mopt.width) < 10) mopt.width = 10;
                if (parseInt(mopt.height) < 10) mopt.height = 10;
                let rect = popup[0].getBoundingClientRect();
                let titleHeight = parseInt(popup.find('.w2ui-popup-title')[0].clientHeight);
                let pWidth = parseInt(rect.width);
                let pHeight = parseInt(rect.height);
                // re-calc width
                mopt.width = mopt.originalWidth;
                if (mopt.width > pWidth - 10) mopt.width = pWidth - 10;
                // re-calc height
                mopt.height = mopt.originalHeight;
                if (mopt.height > pHeight - titleHeight - 5) mopt.height = pHeight - titleHeight - 5;
                if (mopt.originalHeight < 0) mopt.height = pHeight + mopt.originalHeight - titleHeight;
                if (mopt.originalWidth < 0) mopt.width = pWidth + mopt.originalWidth * 2 // x 2 because there is left and right margin
                ;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(msg).css({
                    left: (pWidth - mopt.width) / 2 + 'px',
                    width: mopt.width + 'px',
                    height: mopt.height + 'px'
                });
            });
        }
    }
    function $aa2bd8933167d9cb$export$62a58f5b0650231d(msg, title, callBack) {
        let prom;
        let options = {
            title: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(title ?? 'Notification'),
            body: `<div class="w2ui-centered w2ui-msg-text">${msg}</div>`,
            showClose: false,
            actions: {
                ok: 'Ok'
            },
            cancelAction: 'ok'
        };
        if ($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').length > 0 && $aa2bd8933167d9cb$export$232ed90add9c10b.status != 'closing') prom = $aa2bd8933167d9cb$export$232ed90add9c10b.message(options);
        else prom = $aa2bd8933167d9cb$export$232ed90add9c10b.open(options);
        prom.ok((event1)=>{
            if (typeof event1.detail.self?.close == 'function') event1.detail.self.close();
            if (typeof callBack == 'function') callBack();
        });
        return prom;
    }
    function $aa2bd8933167d9cb$export$af6c47fc44deb3fc(msg, title, callBack) {
        let prom;
        let options = msg;
        if ([
            'string',
            'number'
        ].includes(typeof options)) options = {
            msg: options
        };
        if (options.msg) options.body = `<div class="w2ui-centered w2ui-msg-text">${options.msg}</div>`, delete options.msg;
        if (typeof title == 'function' && callBack == null) {
            callBack = title;
            title = undefined;
        }
        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(options, {
            title: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(title ?? options.title ?? 'Confirmation'),
            showClose: false,
            modal: true,
            cancelAction: 'no'
        });
        if (callBack == null && options.callBack != null) callBack = options.callBack;
        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normButtons(options, {
            yes: 'Yes',
            no: 'No'
        });
        if ($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').length > 0 && $aa2bd8933167d9cb$export$232ed90add9c10b.status != 'closing') prom = $aa2bd8933167d9cb$export$232ed90add9c10b.message(options);
        else prom = $aa2bd8933167d9cb$export$232ed90add9c10b.open(options);
        prom.self.off('.confirm').on('action:after.confirm', (event1)=>{
            if (typeof event1.detail.self?.close == 'function') event1.detail.self.close();
            if (typeof callBack == 'function') callBack(event1.detail.action);
        });
        return prom;
    }
    function $aa2bd8933167d9cb$export$c1ade7615ef1f637(label, title, callBack) {
        let prom;
        let options = label;
        if ([
            'string',
            'number'
        ].includes(typeof options)) options = {
            label: options
        };
        if (options.label) {
            options.focus = 0;
            options.body = options.textarea ? `<div class="w2ui-prompt textarea">
                 <div>${options.label}</div>
                 <textarea id="w2prompt" class="w2ui-input" ${options.attrs ?? ''}
                    data-keydown="keydown|event" data-keyup="change|event">${options.value ?? ''}</textarea>
               </div>` : `<div class="w2ui-prompt w2ui-centered">
                 <label>${options.label}</label>
                 <input id="w2prompt" class="w2ui-input" ${options.attrs ?? ''}
                    data-keydown="keydown|event" data-keyup="change|event" value="${options.value ?? ''}">
               </div>`;
        }
        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(options, {
            title: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(title ?? options.title ?? 'Notification'),
            showClose: false,
            modal: true,
            cancelAction: 'cancel'
        });
        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normButtons(options, {
            ok: 'Ok',
            cancel: 'Cancel'
        });
        if ($aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup').length > 0 && $aa2bd8933167d9cb$export$232ed90add9c10b.status != 'closing') prom = $aa2bd8933167d9cb$export$232ed90add9c10b.message(options);
        else prom = $aa2bd8933167d9cb$export$232ed90add9c10b.open(options);
        if (prom.self.box) prom.self.input = $aa2bd8933167d9cb$export$2fa187e846a241c4(prom.self.box).find('#w2prompt').get(0);
        else prom.self.input = $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-body #w2prompt').get(0);
        if (options.value !== null) prom.self.input.select();
        prom.change = function(callback) {
            prom.self.on('change', callback);
            return this;
        };
        prom.self.off('.prompt').on('open:after.prompt', (event1)=>{
            let box = event1.detail.box ? event1.detail.box : $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2ui-popup .w2ui-popup-body').get(0);
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('#w2prompt'), {
                keydown (evt) {
                    if (evt.keyCode == 27) evt.stopPropagation();
                },
                change (evt) {
                    let edata = prom.self.trigger('change', {
                        target: 'prompt',
                        originalEvent: evt
                    });
                    if (edata.isCancelled === true) return;
                    if (evt.keyCode == 13 && (evt.ctrlKey || evt.metaKey || evt.target.tagName != 'TEXTAREA')) prom.self.action('Ok', evt);
                    if (evt.keyCode == 27) prom.self.action('Cancel', evt);
                    edata.finish();
                }
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(box).find('.w2ui-eaction').trigger('keyup');
        }).on('action:after.prompt', (event1)=>{
            if (typeof event1.detail.self?.close == 'function') event1.detail.self.close();
            if (typeof callBack == 'function') callBack(event1.detail.action);
        });
        return prom;
    }
    let $aa2bd8933167d9cb$export$232ed90add9c10b = new $aa2bd8933167d9cb$export$3ddf2d174ce01153();
    /**
 * Part of w2ui 2.0 library
 * - Dependencies: mQuery, w2utils, w2base
 *
 * TODO:
 * - need help pages
 *
 * 2.0 Changes
 * - multiple tooltips to the same anchor
 * - options.contextMenu
 * - options.prefilter - if true, it will show prefiltered items for w2menu, otherwise all
 * - menu.item.help, menu.item.hotkey
 */ class $aa2bd8933167d9cb$export$28c660c63b792dea {
        // no need to extend w2base, as each individual tooltip extends it
        static active = {} // all defined tooltips
        ;
        constructor(){
            this.defaults = {
                name: null,
                html: '',
                style: '',
                class: '',
                position: 'top|bottom',
                align: '',
                anchor: null,
                contextMenu: false,
                anchorClass: '',
                anchorStyle: '',
                autoShow: false,
                autoShowOn: null,
                autoHideOn: null,
                arrowSize: 8,
                screenMargin: 2,
                autoResize: true,
                margin: 1,
                offsetX: 0,
                offsetY: 0,
                maxWidth: null,
                maxHeight: null,
                watchScroll: null,
                watchResize: null,
                hideOn: null,
                onThen: null,
                onShow: null,
                onHide: null,
                onUpdate: null,
                onMove: null // callback when tooltip is moved
            };
        }
        static observeRemove = new MutationObserver((mutations)=>{
            let cnt = 0;
            Object.keys($aa2bd8933167d9cb$export$28c660c63b792dea.active).forEach((name)=>{
                let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name];
                if (overlay.displayed) {
                    if (!overlay.anchor || !overlay.anchor.isConnected) overlay.hide();
                    else cnt++;
                }
            });
            // remove observer, as there is no activeID tooltips
            if (cnt === 0) $aa2bd8933167d9cb$export$28c660c63b792dea.observeRemove.disconnect();
        });
        trigger(event1, data) {
            if (arguments.length == 2) {
                let type = event1;
                event1 = data;
                data.type = type;
            }
            if (event1.overlay) return event1.overlay.trigger(event1);
            else console.log('ERROR: cannot find overlay where to trigger events');
        }
        get(name) {
            if (arguments.length == 0) return Object.keys($aa2bd8933167d9cb$export$28c660c63b792dea.active);
            else if (name === true) return $aa2bd8933167d9cb$export$28c660c63b792dea.active;
            else return $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
        }
        attach(anchor, text) {
            let options, overlay;
            let self1 = this;
            if (arguments.length == 0) return;
            else if (arguments.length == 1 && anchor instanceof Object) {
                options = anchor;
                anchor = options.anchor;
            } else if (arguments.length === 2 && typeof text === 'string') {
                options = {
                    anchor: anchor,
                    html: text
                };
                text = options.html;
            } else if (arguments.length === 2 && text != null && typeof text === 'object') {
                options = text;
                text = options.html;
            }
            options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.defaults, options || {});
            if (!text && options.text) text = options.text;
            if (!text && options.html) text = options.html;
            // anchor is func var
            delete options.anchor;
            // define tooltip
            let name = options.name ? options.name : anchor?.id;
            if (anchor == document || anchor == document.body || options.contextMenu) {
                anchor = document.body;
                name = 'context-menu';
            }
            if (!name) {
                name = 'noname-' + Object.keys($aa2bd8933167d9cb$export$28c660c63b792dea.active).length;
                console.log('NOTICE: name property is not defined for tooltip, could lead to too many instances');
            }
            // clean name as it is used as id and css selector
            name = name.replace(/[\s\.#]/g, '_');
            if ($aa2bd8933167d9cb$export$28c660c63b792dea.active[name]) {
                overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name];
                overlay.prevOptions = overlay.options;
                overlay.options = options // do not merge or extend, otherwiser menu items get merged too
                ;
                // overlay.options = w2utils.extend({}, overlay.options, options)
                overlay.anchor = anchor // as HTML elements are not copied
                ;
                if (overlay.prevOptions.html != overlay.options.html || overlay.prevOptions.class != overlay.options.class || overlay.prevOptions.style != overlay.options.style) overlay.needsUpdate = true;
                options = overlay.options // it was recreated
                ;
                // clear all previous overlay events
                Object.keys(overlay).forEach((key)=>{
                    let val = overlay[key];
                    if (key.startsWith('on') && typeof val == 'function') delete overlay[key];
                });
            } else {
                overlay = new $aa2bd8933167d9cb$export$3bc12ae4e0bb7487();
                Object.assign(overlay, {
                    id: 'w2overlay-' + name,
                    name: name,
                    options: options,
                    anchor: anchor,
                    self: self1,
                    displayed: false,
                    tmp: {
                        observeResize: new ResizeObserver(()=>{
                            this.resize(overlay.name);
                        })
                    },
                    hide () {
                        self1.hide(name);
                    }
                });
                $aa2bd8933167d9cb$export$28c660c63b792dea.active[name] = overlay;
            }
            // move events on to overlay layer
            Object.keys(overlay.options).forEach((key)=>{
                let val = overlay.options[key];
                if (key.startsWith('on') && typeof val == 'function') {
                    overlay[key] = val;
                    delete overlay.options[key];
                }
            });
            // add event for auto show/hide
            if (options.autoShow === true) {
                options.autoShowOn = options.autoShowOn ?? 'mouseenter';
                options.autoHideOn = options.autoHideOn ?? 'mouseleave';
                options.autoShow = false;
                options._keep = true;
            }
            if (options.autoShowOn) {
                let scope = 'autoShow-' + overlay.name;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(anchor).off(`.${scope}`).on(`${options.autoShowOn}.${scope}`, (event1)=>{
                    self1.show(overlay.name);
                    event1.stopPropagation();
                });
                delete options.autoShowOn;
                options._keep = true;
            }
            if (options.autoHideOn) {
                let scope = 'autoHide-' + overlay.name;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(anchor).off(`.${scope}`).on(`${options.autoHideOn}.${scope}`, (event1)=>{
                    self1.hide(overlay.name);
                    event1.stopPropagation();
                });
                delete options.autoHideOn;
                options._keep = true;
            }
            overlay.off('.attach');
            let ret = {
                overlay: overlay,
                then: (callback)=>{
                    overlay.on('show:after.attach', (event1)=>{
                        callback(event1);
                    });
                    return ret;
                },
                show: (callback)=>{
                    overlay.on('show.attach', (event1)=>{
                        callback(event1);
                    });
                    return ret;
                },
                hide: (callback)=>{
                    overlay.on('hide.attach', (event1)=>{
                        callback(event1);
                    });
                    return ret;
                },
                update: (callback)=>{
                    overlay.on('update.attach', (event1)=>{
                        callback(event1);
                    });
                    return ret;
                },
                move: (callback)=>{
                    overlay.on('move.attach', (event1)=>{
                        callback(event1);
                    });
                    return ret;
                }
            };
            return ret;
        }
        update(name, html) {
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name];
            if (overlay) {
                overlay.needsUpdate = true;
                overlay.options.html = html;
                this.show(name);
            } else console.log(`Tooltip "${name}" is not displayed. Cannot update it.`);
        }
        show(name) {
            if (name instanceof HTMLElement || name instanceof Object) {
                let options = name;
                if (name instanceof HTMLElement) {
                    options = arguments[1] || {};
                    options.anchor = name;
                }
                let ret = this.attach(options);
                ret.overlay.tmp.hidden = false;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(ret.overlay.anchor).off('.autoShow-' + ret.overlay.name).off('.autoHide-' + ret.overlay.name);
                /**
             * Need a timer, so that events in the 'return ret` would be preperty set as it is using chaning mechanism
             * to set listeners: w2tooltip.show({}).then(...).show(...). Since it could be hidden before timer kick in
             * to show it, need the check in the timeout.
             */ setTimeout(()=>{
                    if (!ret.overlay.tmp.hidden) {
                        this.show(ret.overlay.name);
                        if (this.initControls) this.initControls(ret.overlay);
                    }
                }, 1);
                return ret;
            }
            let edata;
            let self1 = this;
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
            if (!overlay) return;
            let options = overlay.options;
            if (!overlay || overlay.displayed && !overlay.needsUpdate) {
                this.resize(overlay?.name);
                return;
            }
            let position = options.position.split('|');
            let isVertical = [
                'top',
                'bottom'
            ].includes(position[0]);
            // enforce nowrap only when align=both and vertical
            let overlayStyles = options.align == 'both' && isVertical ? '' : 'white-space: nowrap;';
            if (options.maxWidth && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getStrWidth(options.html, '') > options.maxWidth) overlayStyles = 'width: ' + options.maxWidth + 'px; white-space: inherit; overflow: auto;';
            overlayStyles += ' max-height: ' + (options.maxHeight ? options.maxHeight : window.innerHeight - 4) + 'px;';
            // if empty content - then hide it
            if (options.html === '' || options.html == null) {
                self1.hide(name);
                return;
            } else if (overlay.box) {
                // if already present, update it
                edata = this.trigger('update', {
                    target: name,
                    overlay: overlay
                });
                if (edata.isCancelled === true) {
                    // restore previous options
                    if (overlay.prevOptions) {
                        overlay.options = overlay.prevOptions;
                        delete overlay.prevOptions;
                    }
                    return;
                }
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-overlay-body').attr('style', (options.style || '') + '; ' + overlayStyles).removeClass() // removes all classes
                .addClass('w2ui-overlay-body ' + options.class).html(options.html);
                this.resize(overlay.name);
            } else {
                // event before
                edata = this.trigger('show', {
                    target: name,
                    overlay: overlay
                });
                if (edata.isCancelled === true) return;
                // normal processing
                $aa2bd8933167d9cb$export$2fa187e846a241c4('body').append(`<div id="${overlay.id}" name="${name}" style="display: none; pointer-events: none" class="w2ui-overlay"
                        data-click="stop" data-focusin="stop">
                    <style></style>
                    <div class="w2ui-overlay-body ${options.class}" style="${options.style || ''}; ${overlayStyles}">
                        ${options.html}
                    </div>
                </div>`);
                overlay.box = $aa2bd8933167d9cb$export$2fa187e846a241c4('#' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(overlay.id))[0];
                overlay.displayed = true;
                let names = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).data('tooltipName') ?? [];
                names.push(name);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).data('tooltipName', names) // make available to element overlay attached to
                ;
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(overlay.box, {});
                // remember anchor's original styles
                overlay.tmp.originalCSS = '';
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).length > 0) overlay.tmp.originalCSS = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor)[0].style.cssText;
                this.resize(overlay.name);
            }
            if (options.anchorStyle) overlay.anchor.style.cssText += ';' + options.anchorStyle;
            if (options.anchorClass) {
                if (!(options.anchorClass == 'w2ui-focus' && overlay.anchor == document.body)) $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).addClass(options.anchorClass);
            }
            // add on hide events
            if (typeof options.hideOn == 'string') options.hideOn = [
                options.hideOn
            ];
            if (!Array.isArray(options.hideOn)) options.hideOn = [];
            // initial scroll
            Object.assign(overlay.tmp, {
                scrollLeft: document.body.scrollLeft,
                scrollTop: document.body.scrollTop
            });
            addHideEvents();
            addWatchEvents(document.body);
            // first show empty tooltip, so it will popup up in the right position
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).show();
            overlay.tmp.observeResize.observe(overlay.box);
            // observer element removal from DOM
            $aa2bd8933167d9cb$export$28c660c63b792dea.observeRemove.observe(document.body, {
                subtree: true,
                childList: true
            });
            // then insert html and it will adjust
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).css('opacity', 1).find('.w2ui-overlay-body').html(options.html);
            /**
         * pointer-events: none is needed to avoid cases when popup is shown right under the cursor
         * or it will trigger onmouseout, onmouseleave and other events.
         */ setTimeout(()=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).css({
                    'pointer-events': 'auto'
                }).data('ready', 'yes');
            }, 100);
            delete overlay.needsUpdate;
            // expose overlay to DOM element
            overlay.box.overlay = overlay;
            // event after
            if (edata) edata.finish();
            return {
                overlay: overlay
            };
            function addWatchEvents(el) {
                let scope = 'tooltip-' + overlay.name;
                let queryEl = el;
                if (el.tagName == 'BODY') queryEl = el.ownerDocument;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(queryEl).off(`.${scope}`).on(`scroll.${scope}`, (event1)=>{
                    Object.assign(overlay.tmp, {
                        scrollLeft: el.scrollLeft,
                        scrollTop: el.scrollTop
                    });
                    self1.resize(overlay.name);
                });
            }
            function addHideEvents() {
                let hide = (event1)=>{
                    self1.hide(overlay.name);
                };
                let $anchor = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor);
                let scope = 'tooltip-' + overlay.name;
                // document click
                $aa2bd8933167d9cb$export$2fa187e846a241c4('body').off(`.${scope}`);
                if (options.hideOn.includes('doc-click')) {
                    if ([
                        'INPUT',
                        'TEXTAREA'
                    ].includes(overlay.anchor.tagName)) $anchor.off(`.${scope}-doc`).on(`click.${scope}-doc`, (event1)=>{
                        event1.stopPropagation();
                    });
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('body').on(`click.${scope}`, hide);
                }
                if (options.hideOn.includes('focus-change')) $aa2bd8933167d9cb$export$2fa187e846a241c4('body').on(`focusin.${scope}`, (e)=>{
                    if (document.activeElement != overlay.anchor) self1.hide(overlay.name);
                });
                if ([
                    'INPUT',
                    'TEXTAREA'
                ].includes(overlay.anchor.tagName)) {
                    $anchor.off(`.${scope}`);
                    options.hideOn.forEach((event1)=>{
                        if ([
                            'doc-click',
                            'focus-change'
                        ].indexOf(event1) == -1) $anchor.on(`${event1}.${scope}`, {
                            once: true
                        }, hide);
                    });
                }
            }
        }
        hide(name) {
            let overlay;
            if (arguments.length == 0) {
                // hide all tooltips
                Object.keys($aa2bd8933167d9cb$export$28c660c63b792dea.active).forEach((name)=>{
                    this.hide(name);
                });
                return;
            }
            if (name instanceof HTMLElement) {
                let names = $aa2bd8933167d9cb$export$2fa187e846a241c4(name).data('tooltipName') ?? [];
                names.forEach((name)=>{
                    this.hide(name);
                });
                return;
            }
            if (typeof name == 'string') {
                name = name.replace(/[\s\.#]/g, '_');
                overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name];
            }
            if (overlay?.tmp) overlay.tmp.hidden = true // it could be hidden before it is actually shown
            ;
            if (!overlay || !overlay.box) return;
            // event before
            let edata = this.trigger('hide', {
                target: name,
                overlay: overlay
            });
            if (edata.isCancelled === true) return;
            // normal processing
            if (!overlay.options._keep) delete $aa2bd8933167d9cb$export$28c660c63b792dea.active[name];
            let scope = 'tooltip-' + overlay.name;
            overlay.tmp.observeResize?.disconnect();
            if (overlay.options.watchScroll) $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.options.watchScroll).off('.w2scroll-' + overlay.name);
            // if no activeID tooltip then disable observeRemove
            let cnt = 0;
            Object.keys($aa2bd8933167d9cb$export$28c660c63b792dea.active).forEach((key)=>{
                let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[key];
                if (overlay.displayed) cnt++;
            });
            if (cnt == 0) $aa2bd8933167d9cb$export$28c660c63b792dea.observeRemove.disconnect();
            $aa2bd8933167d9cb$export$2fa187e846a241c4('body').off(`.${scope}`) // hide to click event here
            ;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off(`.${scope}`) // scroll event here
            ;
            // remove element
            overlay.box.remove();
            overlay.box = null;
            overlay.displayed = false;
            // remove name from anchor properties
            let names = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).data('tooltipName') ?? [];
            let ind = names.indexOf(overlay.name);
            if (ind != -1) names.splice(names.indexOf(overlay.name), 1);
            if (names.length == 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).removeData('tooltipName');
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).data('tooltipName', names);
            // restore original CSS, only if anchor styles where extended
            if (overlay.options.anchorStyle) overlay.anchor.style.cssText = overlay.tmp.originalCSS;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).off(`.${scope}`).removeClass(overlay.options.anchorClass);
            // event after
            edata.finish();
        }
        resize(name) {
            if (arguments.length == 0) {
                Object.keys($aa2bd8933167d9cb$export$28c660c63b792dea.active).forEach((key)=>{
                    let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[key];
                    if (overlay.displayed) this.resize(overlay.name);
                });
                return;
            }
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
            let pos = this.getPosition(overlay.name);
            let newPos = pos.left + 'x' + pos.top;
            let edata;
            if (overlay.tmp.lastPos != newPos) edata = this.trigger('move', {
                target: name,
                overlay: overlay,
                pos: pos
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).css({
                left: pos.left + 'px',
                top: pos.top + 'px'
            }).then((query)=>{
                if (pos.width != null) query.css('width', pos.width + 'px').find('.w2ui-overlay-body').css('width', '100%');
                if (pos.height != null) query.css('height', pos.height + 'px').find('.w2ui-overlay-body').css('height', '100%');
            }).find('.w2ui-overlay-body').removeClass('w2ui-arrow-right w2ui-arrow-left w2ui-arrow-top w2ui-arrow-bottom').addClass(pos.arrow.class).closest('.w2ui-overlay').find('style').text(pos.arrow.style);
            if (overlay.tmp.lastPos != newPos && edata) {
                overlay.tmp.lastPos = newPos;
                edata.finish();
            }
        }
        getPosition(name) {
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
            if (!overlay || !overlay.box) return;
            let options = overlay.options;
            if (overlay.tmp.resizedY || overlay.tmp.resizedX) $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).css({
                width: '',
                height: '',
                scroll: 'auto'
            });
            let scrollSize = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize();
            let hasScrollBarX = !(document.body.scrollWidth == document.body.clientWidth);
            let hasScrollBarY = !(document.body.scrollHeight == document.body.clientHeight);
            let max = {
                width: window.innerWidth - (hasScrollBarY ? scrollSize : 0),
                height: window.innerHeight - (hasScrollBarX ? scrollSize : 0)
            };
            let position = options.position == 'auto' ? 'top|bottom|right|left'.split('|') : Array.isArray(options.position) ? options.position : options.position.split('|');
            let isVertical = [
                'top',
                'bottom'
            ].includes(position[0]);
            let content = overlay.box.getBoundingClientRect();
            let anchor = overlay.anchor.getBoundingClientRect();
            if (overlay.anchor == document.body) {
                // context menu
                let evt = options.originalEvent;
                while(evt.originalEvent)evt = evt.originalEvent;
                let { x: x, y: y, width: width, height: height } = evt;
                anchor = {
                    left: x - 2,
                    top: y - 4,
                    width: width,
                    height: height,
                    arrow: 'none'
                };
            }
            let arrowSize = options.arrowSize;
            if (anchor.arrow == 'none') arrowSize = 0;
            // space available
            let available = {
                top: anchor.top - arrowSize,
                bottom: max.height - arrowSize - (anchor.top + anchor.height) - (hasScrollBarX ? scrollSize : 0) - 2,
                left: anchor.left,
                right: max.width - (anchor.left + anchor.width) + (hasScrollBarY ? scrollSize : 0)
            };
            // size of empty tooltip
            if (content.width < 22) content.width = 22;
            if (content.height < 14) content.height = 14;
            let left, top, width, height // tooltip position
            ;
            let found = '';
            let arrow = {
                offset: 0,
                class: '',
                style: `#${overlay.id} { --tip-size: ${arrowSize}px; }`
            };
            let adjust = {
                left: 0,
                top: 0
            };
            let bestFit = {
                posX: '',
                x: 0,
                posY: '',
                y: 0
            };
            // find best position
            position.forEach((pos)=>{
                if ([
                    'top',
                    'bottom'
                ].includes(pos)) {
                    if (!found && content.height + arrowSize / 1.893 < available[pos]) found = pos;
                    if (available[pos] > bestFit.y) Object.assign(bestFit, {
                        posY: pos,
                        y: available[pos]
                    });
                }
                if ([
                    'left',
                    'right'
                ].includes(pos)) {
                    if (!found && content.width + arrowSize / 1.893 < available[pos]) found = pos;
                    if (available[pos] > bestFit.x) Object.assign(bestFit, {
                        posX: pos,
                        x: available[pos]
                    });
                }
            });
            // if not found, use best (greatest available space) position
            if (!found) {
                if (isVertical) found = bestFit.posY;
                else found = bestFit.posX;
            }
            if (options.autoResize) {
                if ([
                    'top',
                    'bottom'
                ].includes(found)) {
                    if (content.height > available[found]) {
                        height = available[found];
                        overlay.tmp.resizedY = true;
                    } else overlay.tmp.resizedY = false;
                }
                if ([
                    'left',
                    'right'
                ].includes(found)) {
                    if (content.width > available[found]) {
                        width = available[found];
                        overlay.tmp.resizedX = true;
                    } else overlay.tmp.resizedX = false;
                }
            }
            usePosition(found);
            if (isVertical) anchorAlignment();
            // user offset
            top += parseFloat(options.offsetY);
            left += parseFloat(options.offsetX);
            // make sure it is inside visible screen area
            screenAdjust();
            // adjust for scrollbar
            let extraTop = found == 'top' ? -options.margin : found == 'bottom' ? options.margin : 0;
            let extraLeft = found == 'left' ? -options.margin : found == 'right' ? options.margin : 0;
            top = Math.floor((top + parseFloat(extraTop)) * 100) / 100;
            left = Math.floor((left + parseFloat(extraLeft)) * 100) / 100;
            return {
                left: left,
                top: top,
                arrow: arrow,
                adjust: adjust,
                width: width,
                height: height,
                pos: found
            };
            function usePosition(pos) {
                arrow.class = anchor.arrow ? anchor.arrow : `w2ui-arrow-${pos}`;
                switch(pos){
                    case 'top':
                        left = anchor.left + (anchor.width - (width ?? content.width)) / 2;
                        top = anchor.top - (height ?? content.height) - arrowSize / 1.5 + 1;
                        break;
                    case 'bottom':
                        left = anchor.left + (anchor.width - (width ?? content.width)) / 2;
                        top = anchor.top + anchor.height + arrowSize / 1.25 + 1;
                        break;
                    case 'left':
                        left = anchor.left - (width ?? content.width) - arrowSize / 1.2 - 1;
                        top = anchor.top + (anchor.height - (height ?? content.height)) / 2;
                        break;
                    case 'right':
                        left = anchor.left + anchor.width + arrowSize / 1.2 + 1;
                        top = anchor.top + (anchor.height - (height ?? content.height)) / 2;
                        break;
                }
            }
            function anchorAlignment() {
                // top/bottom alignments
                if (options.align == 'left') {
                    adjust.left = anchor.left - left;
                    left = anchor.left;
                }
                if (options.align == 'right') {
                    adjust.left = anchor.left + anchor.width - (width ?? content.width) - left;
                    left = anchor.left + anchor.width - (width ?? content.width);
                }
                if ([
                    'top',
                    'bottom'
                ].includes(found) && options.align.startsWith('both')) {
                    let minWidth = options.align.split(':')[1] ?? 50;
                    if (anchor.width >= minWidth) {
                        left = anchor.left;
                        width = anchor.width;
                    }
                }
                // left/right alignments
                if (options.align == 'top') {
                    adjust.top = anchor.top - top;
                    top = anchor.top;
                }
                if (options.align == 'bottom') {
                    adjust.top = anchor.top + anchor.height - (height ?? content.height) - top;
                    top = anchor.top + anchor.height - (height ?? content.height);
                }
                if ([
                    'left',
                    'right'
                ].includes(found) && options.align.startsWith('both')) {
                    let minHeight = options.align.split(':')[1] ?? 50;
                    if (anchor.height >= minHeight) {
                        top = anchor.top;
                        height = anchor.height;
                    }
                }
            }
            function screenAdjust() {
                let adjustArrow;
                // adjust tip if needed after alignment
                if ([
                    'left',
                    'right'
                ].includes(options.align) && anchor.width < (width ?? content.width) || [
                    'top',
                    'bottom'
                ].includes(options.align) && anchor.height < (height ?? content.height)) adjustArrow = true;
                // if off screen then adjust
                let minLeft = found == 'right' ? arrowSize : options.screenMargin;
                let minTop = found == 'bottom' ? arrowSize : options.screenMargin;
                let maxLeft = max.width - (width ?? content.width) - (found == 'left' ? arrowSize : options.screenMargin);
                let maxTop = max.height - (height ?? content.height) - (found == 'top' ? arrowSize : options.screenMargin) + 3;
                // adjust X
                if ([
                    'top',
                    'bottom'
                ].includes(found) || options.autoResize) {
                    if (left < minLeft) {
                        adjustArrow = true;
                        adjust.left -= left;
                        left = minLeft;
                    }
                    if (left > maxLeft) {
                        adjustArrow = true;
                        adjust.left -= left - maxLeft;
                        left += maxLeft - left;
                    }
                }
                // adjust Y
                if ([
                    'left',
                    'right'
                ].includes(found) || options.autoResize) {
                    if (top < minTop) {
                        adjustArrow = true;
                        adjust.top -= top;
                        top = minTop;
                    }
                    if (top > maxTop) {
                        adjustArrow = true;
                        adjust.top -= top - maxTop;
                        top += maxTop - top;
                    }
                }
                // moves carret to adjust it with element width
                if (adjustArrow) {
                    let aType = isVertical ? 'left' : 'top';
                    let sType = isVertical ? 'width' : 'height';
                    arrow.offset = -adjust[aType];
                    let maxOffset = content[sType] / 2 - arrowSize;
                    if (Math.abs(arrow.offset) > maxOffset + arrowSize) arrow.class = '' // no arrow
                    ;
                    if (Math.abs(arrow.offset) > maxOffset) arrow.offset = arrow.offset < 0 ? -maxOffset : maxOffset;
                    arrow.style = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripSpaces(`#${overlay.id} .w2ui-overlay-body:after,
                            #${overlay.id} .w2ui-overlay-body:before {
                                --tip-size: ${arrowSize}px;
                                margin-${aType}: ${arrow.offset}px;
                            }`);
                }
            }
        }
    }
    class $aa2bd8933167d9cb$var$ColorTooltip extends $aa2bd8933167d9cb$export$28c660c63b792dea {
        constructor(){
            super();
            this.palette = [
                [
                    '000000',
                    '333333',
                    '555555',
                    '777777',
                    '888888',
                    '999999',
                    'AAAAAA',
                    'CCCCCC',
                    'DDDDDD',
                    'EEEEEE',
                    'F7F7F7',
                    'FFFFFF'
                ],
                [
                    'FF011B',
                    'FF9838',
                    'FFC300',
                    'FFFD59',
                    '86FF14',
                    '14FF7A',
                    '2EFFFC',
                    '2693FF',
                    '006CE7',
                    '9B24F4',
                    'FF21F5',
                    'FF0099'
                ],
                [
                    'FFEAEA',
                    'FCEFE1',
                    'FCF4DC',
                    'FFFECF',
                    'EBFFD9',
                    'D9FFE9',
                    'E0FFFF',
                    'E8F4FF',
                    'ECF4FC',
                    'EAE6F4',
                    'FFF5FE',
                    'FCF0F7'
                ],
                [
                    'F4CCCC',
                    'FCE5CD',
                    'FFF1C2',
                    'FFFDA1',
                    'D5FCB1',
                    'B5F7D0',
                    'BFFFFF',
                    'D6ECFF',
                    'CFE2F3',
                    'D9D1E9',
                    'FFE3FD',
                    'FFD9F0'
                ],
                [
                    'EA9899',
                    'F9CB9C',
                    'FFE48C',
                    'F7F56F',
                    'B9F77E',
                    '84F0B1',
                    '83F7F7',
                    'B5DAFF',
                    '9FC5E8',
                    'B4A7D6',
                    'FAB9F6',
                    'FFADDE'
                ],
                [
                    'E06666',
                    'F6B26B',
                    'DEB737',
                    'E0DE51',
                    '8FDB48',
                    '52D189',
                    '4EDEDB',
                    '76ACE3',
                    '6FA8DC',
                    '8E7CC3',
                    'E07EDA',
                    'F26DBD'
                ],
                [
                    'CC0814',
                    'E69138',
                    'AB8816',
                    'B5B20E',
                    '6BAB30',
                    '27A85F',
                    '1BA8A6',
                    '3C81C7',
                    '3D85C6',
                    '674EA7',
                    'A14F9D',
                    'BF4990'
                ],
                [
                    '99050C',
                    'B45F17',
                    '80650E',
                    '737103',
                    '395E14',
                    '10783D',
                    '13615E',
                    '094785',
                    '0A5394',
                    '351C75',
                    '780172',
                    '782C5A'
                ]
            ];
            this.defaults = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.defaults, {
                advanced: false,
                transparent: true,
                position: 'top|bottom',
                class: 'w2ui-white',
                color: '',
                updateInput: true,
                arrowSize: 12,
                autoResize: false,
                anchorClass: 'w2ui-focus',
                autoShowOn: 'focus',
                hideOn: [
                    'doc-click',
                    'focus-change'
                ],
                onSelect: null,
                onLiveUpdate: null
            });
        }
        attach(anchor, text) {
            let options;
            if (arguments.length == 1 && anchor instanceof Object) {
                options = anchor;
                anchor = options.anchor;
            } else if (arguments.length === 2 && text != null && typeof text === 'object') {
                options = text;
                options.anchor = anchor;
            }
            let prevHideOn = options.hideOn;
            options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.defaults, options || {});
            if (prevHideOn) options.hideOn = prevHideOn;
            options.style += '; padding: 0;';
            // add remove transparent color
            if (options.transparent && this.palette[0][1] == '333333') {
                this.palette[0].splice(1, 1);
                this.palette[0].push('TRANSPARENT');
            }
            if (!options.transparent && this.palette[0][1] != '333333') {
                this.palette[0].splice(1, 0, '333333');
                this.palette[0].pop();
            }
            if (options.color) options.color = String(options.color).toUpperCase();
            if (typeof options.color === 'string' && options.color.substr(0, 1) === '#') options.color = options.color.substr(1);
            // needed for keyboard navigation
            this.index = [
                -1,
                -1
            ];
            let ret = super.attach(options);
            let overlay = ret.overlay;
            overlay.options.html = this.getColorHTML(overlay.name, options);
            overlay.on('show.attach', (event1)=>{
                let overlay = event1.detail.overlay;
                let anchor = overlay.anchor;
                let options = overlay.options;
                if ([
                    'INPUT',
                    'TEXTAREA'
                ].includes(anchor.tagName) && !options.color && anchor.value) overlay.tmp.initColor = anchor.value;
                delete overlay.newColor;
            });
            overlay.on('show:after.attach', (event1)=>{
                if (ret.overlay?.box) {
                    let actions = $aa2bd8933167d9cb$export$2fa187e846a241c4(ret.overlay.box).find('.w2ui-eaction');
                    $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(actions, this);
                    this.initControls(ret.overlay);
                }
            });
            overlay.on('update:after.attach', (event1)=>{
                if (ret.overlay?.box) {
                    let actions = $aa2bd8933167d9cb$export$2fa187e846a241c4(ret.overlay.box).find('.w2ui-eaction');
                    $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(actions, this);
                    this.initControls(ret.overlay);
                }
            });
            overlay.on('hide.attach', (event1)=>{
                let overlay = event1.detail.overlay;
                let anchor = overlay.anchor;
                let color = overlay.newColor ?? overlay.options.color ?? '';
                // color has been selected
                if (color !== '') {
                    if ([
                        'INPUT',
                        'TEXTAREA'
                    ].includes(anchor.tagName) && anchor.value != color && overlay.options.updateInput) anchor.value = color;
                    let edata = this.trigger('select', {
                        color: color,
                        target: overlay.name,
                        overlay: overlay
                    });
                    if (edata.isCancelled === true) return;
                    // event after
                    edata.finish();
                }
            });
            ret.liveUpdate = (callback)=>{
                overlay.on('liveUpdate.attach', (event1)=>{
                    callback(event1);
                });
                return ret;
            };
            ret.select = (callback)=>{
                overlay.on('select.attach', (event1)=>{
                    callback(event1);
                });
                return ret;
            };
            return ret;
        }
        // regular panel handler, adds selection class
        select(color, name) {
            let target;
            this.index = [
                -1,
                -1
            ];
            if (typeof name != 'string') {
                target = name.target;
                this.index = $aa2bd8933167d9cb$export$2fa187e846a241c4(target).attr('index').split(':');
                name = $aa2bd8933167d9cb$export$2fa187e846a241c4(target).closest('.w2ui-overlay').attr('name');
            }
            let overlay = this.get(name);
            // event before
            let edata = this.trigger('liveUpdate', {
                color: color,
                target: name,
                overlay: overlay,
                param: arguments[1]
            });
            if (edata.isCancelled === true) return;
            // if anchor is input - live update
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(overlay.anchor.tagName) && overlay.options.updateInput) $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).val(color);
            overlay.newColor = color;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-color.w2ui-selected').removeClass('w2ui-selected');
            if (target) $aa2bd8933167d9cb$export$2fa187e846a241c4(target).addClass('w2ui-selected');
            // event after
            edata.finish();
        }
        // used for keyboard navigation, if any
        nextColor(direction) {
            let pal = this.palette;
            switch(direction){
                case 'up':
                    this.index[0]--;
                    break;
                case 'down':
                    this.index[0]++;
                    break;
                case 'right':
                    this.index[1]++;
                    break;
                case 'left':
                    this.index[1]--;
                    break;
            }
            if (this.index[0] < 0) this.index[0] = 0;
            if (this.index[0] > pal.length - 2) this.index[0] = pal.length - 2;
            if (this.index[1] < 0) this.index[1] = 0;
            if (this.index[1] > pal[0].length - 1) this.index[1] = pal[0].length - 1;
            return pal[this.index[0]][this.index[1]];
        }
        tabClick(index, name) {
            if (typeof name != 'string') name = $aa2bd8933167d9cb$export$2fa187e846a241c4(name.target).closest('.w2ui-overlay').attr('name');
            let overlay = this.get(name);
            let tab = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find(`.w2ui-color-tab:nth-child(${index})`);
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-color-tab').removeClass('w2ui-selected');
            $aa2bd8933167d9cb$export$2fa187e846a241c4(tab).addClass('w2ui-selected');
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-tab-content').hide().closest('.w2ui-colors').find('.tab-' + index).show();
        }
        // generate HTML with color pallent and controls
        getColorHTML(name, options) {
            let html = `
            <div class="w2ui-colors">
                <div class="w2ui-tab-content tab-1">`;
            for(let i = 0; i < this.palette.length; i++){
                html += '<div class="w2ui-color-row">';
                for(let j = 0; j < this.palette[i].length; j++){
                    let color = this.palette[i][j];
                    let border = '';
                    if (color === 'FFFFFF') border = '; border: 1px solid #efefef';
                    html += `
                    <div class="w2ui-color w2ui-eaction ${color === 'TRANSPARENT' ? 'w2ui-no-color' : ''} ${options.color == color ? 'w2ui-selected' : ''}"
                        style="background-color: #${color + border};" name="${color}" index="${i}:${j}"
                        data-mousedown="select|'${color}'|event" data-mouseup="hide|${name}">&nbsp;
                    </div>`;
                }
                html += '</div>';
                if (i < 2) html += '<div style="height: 8px"></div>';
            }
            html += '</div>';
            // advanced tab
            html += `
            <div class="w2ui-tab-content tab-2" style="display: none">
                <div class="color-info">
                    <div class="color-preview-bg"><div class="color-preview"></div><div class="color-original"></div></div>
                    <div class="color-part">
                        <span>H</span> <input class="w2ui-input" name="h" maxlength="3" max="360" tabindex="101">
                        <span>R</span> <input class="w2ui-input" name="r" maxlength="3" max="255" tabindex="104">
                    </div>
                    <div class="color-part">
                        <span>S</span> <input class="w2ui-input" name="s" maxlength="3" max="100" tabindex="102">
                        <span>G</span> <input class="w2ui-input" name="g" maxlength="3" max="255" tabindex="105">
                    </div>
                    <div class="color-part">
                        <span>V</span> <input class="w2ui-input" name="v" maxlength="3" max="100" tabindex="103">
                        <span>B</span> <input class="w2ui-input" name="b" maxlength="3" max="255" tabindex="106">
                    </div>
                    <div class="color-part opacity">
                        <span>${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Opacity')}</span>
                        <input class="w2ui-input" name="a" maxlength="5" max="1" tabindex="107">
                    </div>
                </div>
                <div class="palette" name="palette">
                    <div class="palette-bg"></div>
                    <div class="value1 move-x move-y"></div>
                </div>
                <div class="rainbow" name="rainbow">
                    <div class="value2 move-x"></div>
                </div>
                <div class="alpha" name="alpha">
                    <div class="alpha-bg"></div>
                    <div class="value2 move-x"></div>
                </div>
            </div>`;
            // color tabs on the bottom
            html += `
            <div class="w2ui-color-tabs">
                <div class="w2ui-color-tab w2ui-selected w2ui-eaction" data-click="tabClick|1|event|this"><span class="w2ui-icon w2ui-icon-colors"></span></div>
                <div class="w2ui-color-tab w2ui-eaction" data-click="tabClick|2|event|this"><span class="w2ui-icon w2ui-icon-settings"></span></div>
                <div style="padding: 5px; width: 100%; text-align: right;">
                    ${typeof options.html == 'string' ? options.html : ''}
                </div>
            </div>`;
            return html;
        }
        // bind advanced tab controls
        initControls(overlay) {
            let initial // used for mouse events
            ;
            let self1 = this;
            let options = overlay.options;
            let color = options.color || overlay.tmp.initColor;
            let rgb = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseColor(color);
            if (rgb == null) rgb = {
                r: 140,
                g: 150,
                b: 160,
                a: 1
            };
            let hsv = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.rgb2hsv(rgb);
            if (options.advanced === true) this.tabClick(2, overlay.name);
            setColor(hsv, true, color ?? '') // should not be null or undefined
            ;
            // even for rgb, hsv inputs
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).off('.w2color').on('contextmenu.w2color', (event1)=>{
                event1.preventDefault() // prevent browser context menu
                ;
            }).find('input').off('.w2color').on('change.w2color', (event1)=>{
                let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target);
                let val = parseFloat(el.val());
                let max = parseFloat(el.attr('max'));
                if (isNaN(val)) {
                    val = 0;
                    el.val(0);
                }
                if (max > 1) val = parseInt(val) // trancate fractions
                ;
                if (max > 0 && val > max) {
                    el.val(max);
                    val = max;
                }
                if (val < 0) {
                    el.val(0);
                    val = 0;
                }
                let name = el.attr('name');
                let color = {};
                if ([
                    'r',
                    'g',
                    'b',
                    'a'
                ].indexOf(name) !== -1) {
                    rgb[name] = val;
                    hsv = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.rgb2hsv(rgb);
                } else if ([
                    'h',
                    's',
                    'v'
                ].indexOf(name) !== -1) color[name] = val;
                setColor(color, true);
            });
            // click on original color resets it
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.color-original').off('.w2color').on('click.w2color', (event1)=>{
                let tmp = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseColor($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).css('background-color'));
                if (tmp != null) {
                    rgb = tmp;
                    hsv = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.rgb2hsv(rgb);
                    setColor(hsv, true);
                }
            });
            // color sliders events
            let mDown = `${!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isIOS ? 'mousedown' : 'touchstart'}.w2color`;
            let mUp = `${!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isIOS ? 'mouseup' : 'touchend'}.w2color`;
            let mMove = `${!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isIOS ? 'mousemove' : 'touchmove'}.w2color`;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.palette, .rainbow, .alpha').off('.w2color').on(`${mDown}.w2color`, mouseDown);
            return;
            function setColor(color, fullUpdate, initial) {
                if (color.h != null) hsv.h = color.h;
                if (color.s != null) hsv.s = color.s;
                if (color.v != null) hsv.v = color.v;
                if (color.a != null) {
                    rgb.a = color.a;
                    hsv.a = color.a;
                }
                rgb = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.hsv2rgb(hsv);
                let newColor = 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')';
                let cl = [
                    Number(rgb.r).toString(16).toUpperCase(),
                    Number(rgb.g).toString(16).toUpperCase(),
                    Number(rgb.b).toString(16).toUpperCase(),
                    Math.round(Number(rgb.a) * 255).toString(16).toUpperCase()
                ];
                cl.forEach((item, ind)=>{
                    if (item.length === 1) cl[ind] = '0' + item;
                });
                newColor = cl[0] + cl[1] + cl[2] + cl[3];
                if (rgb.a === 1) newColor = cl[0] + cl[1] + cl[2];
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.color-preview').css('background-color', '#' + newColor);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('input').each((el)=>{
                    if (el.name) {
                        if (rgb[el.name] != null) el.value = rgb[el.name];
                        if (hsv[el.name] != null) el.value = hsv[el.name];
                        if (el.name === 'a') el.value = rgb.a;
                    }
                });
                // if it is in pallette
                if (initial != null) {
                    let color = overlay.tmp.initColor || newColor;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.color-original').css('background-color', '#' + color);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-color.w2ui-selected').removeClass('w2ui-selected');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find(`.w2ui-colors [name="${color}"], .w2ui-colors [name="${initial}"]`) // color conversion might be slightly off
                    .addClass('w2ui-selected');
                    // if has transparent color, open advanced tab
                    if (newColor.length == 8) self1.tabClick(2, overlay.name);
                } else self1.select(newColor, overlay.name);
                if (fullUpdate) {
                    updateSliders();
                    refreshPalette();
                }
            }
            function updateSliders() {
                let el1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.palette .value1');
                let el2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.rainbow .value2');
                let el3 = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.alpha .value2');
                if (!el1[0] || !el2[0] || !el3[0]) return;
                let offset1 = parseInt(el1[0].clientWidth) / 2;
                let offset2 = parseInt(el2[0].clientWidth) / 2;
                el1.css({
                    'left': hsv.s * 150 / 100 - offset1 + 'px',
                    'top': (100 - hsv.v) * 125 / 100 - offset1 + 'px'
                });
                el2.css('left', hsv.h / 2.4 - offset2 + 'px');
                el3.css('left', rgb.a * 150 - offset2 + 'px');
            }
            function refreshPalette() {
                let cl = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.hsv2rgb(hsv.h, 100, 100);
                let rgb = `${cl.r},${cl.g},${cl.b}`;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.palette').css('background-image', `linear-gradient(90deg, rgba(${rgb},0) 0%, rgba(${rgb},1) 100%)`);
            }
            function mouseDown(event1) {
                let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this).find('.value1, .value2');
                let offset = parseInt(el.prop('clientWidth')) / 2;
                if (el.hasClass('move-x')) el.css({
                    left: event1.offsetX - offset + 'px'
                });
                if (el.hasClass('move-y')) el.css({
                    top: event1.offsetY - offset + 'px'
                });
                initial = {
                    el: el,
                    x: event1.pageX,
                    y: event1.pageY,
                    width: el.prop('parentNode').clientWidth,
                    height: el.prop('parentNode').clientHeight,
                    left: parseInt(el.css('left')),
                    top: parseInt(el.css('top'))
                };
                mouseMove(event1);
                $aa2bd8933167d9cb$export$2fa187e846a241c4('body').off('.w2color').on(mMove, mouseMove).on(mUp, mouseUp);
            }
            function mouseUp(event1) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4('body').off('.w2color');
            }
            function mouseMove(event1) {
                let el = initial.el;
                let divX = event1.pageX - initial.x;
                let divY = event1.pageY - initial.y;
                let newX = initial.left + divX;
                let newY = initial.top + divY;
                let offset = parseInt(el.prop('clientWidth')) / 2;
                if (newX < -offset) newX = -offset;
                if (newY < -offset) newY = -offset;
                if (newX > initial.width - offset) newX = initial.width - offset;
                if (newY > initial.height - offset) newY = initial.height - offset;
                if (el.hasClass('move-x')) el.css({
                    left: newX + 'px'
                });
                if (el.hasClass('move-y')) el.css({
                    top: newY + 'px'
                });
                // move
                let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(el.get(0).parentNode).attr('name');
                let x = parseInt(el.css('left')) + offset;
                let y = parseInt(el.css('top')) + offset;
                if (name === 'palette') setColor({
                    s: Math.round(x / initial.width * 100),
                    v: Math.round(100 - y / initial.height * 100)
                });
                if (name === 'rainbow') {
                    let h = Math.round(2.4 * x);
                    setColor({
                        h: h
                    });
                    refreshPalette();
                }
                if (name === 'alpha') setColor({
                    a: parseFloat(Number(x / 150).toFixed(2))
                });
            }
        }
    }
    class $aa2bd8933167d9cb$var$MenuTooltip extends $aa2bd8933167d9cb$export$28c660c63b792dea {
        constructor(){
            super();
            // ITEM STRUCTURE
            // item : {
            //   id       : null,
            //   text     : '',
            //   style    : '',
            //   icon     : '',
            //   count    : '',
            //   tooltip  : '',
            //   hotkey   : '',
            //   removable: false,
            //   help     : '',      // text for help tooltip
            //   hotkey   ; '',      // hotkey text for the items
            //   items    : []
            //   indent   : 0,
            //   type     : null,    // check/radio
            //   group    : false,   // groupping for checks
            //   expanded : false,
            //   hidden   : false,
            //   checked  : null,
            //   denied : false
            //   ...
            // }
            this.defaults = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.defaults, {
                type: 'normal',
                items: [],
                index: null,
                render: null,
                spinner: false,
                msgNoItems: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('No items found'),
                topHTML: '',
                menuStyle: '',
                filter: false,
                markSearch: false,
                prefilter: false,
                match: 'contains',
                search: false,
                altRows: false,
                arrowSize: 10,
                align: 'left',
                position: 'bottom|top',
                class: 'w2ui-white',
                anchorClass: 'w2ui-focus',
                autoShowOn: 'focus',
                hideOn: [
                    'doc-click',
                    'focus-change',
                    'select'
                ],
                onSelect: null,
                onSubMenu: null,
                onRemove: null
            });
        }
        attach(anchor, text) {
            let options;
            if (arguments.length == 1 && anchor instanceof Object) {
                options = anchor;
                anchor = options.anchor;
            } else if (arguments.length === 2 && text != null && typeof text === 'object') {
                options = text;
                options.anchor = anchor;
            }
            let prevHideOn = options.hideOn;
            options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.defaults, options || {});
            if (prevHideOn) options.hideOn = prevHideOn;
            options.style += '; padding: 0;';
            if (options.items == null) options.items = [];
            options.items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu(options.items);
            options.html = this.getMenuHTML(options);
            let ret = super.attach(options);
            let overlay = ret.overlay;
            overlay.on('show:after.attach, update:after.attach', (event1)=>{
                if (ret.overlay?.box) {
                    let search = '';
                    // reset selected and activeID chain
                    overlay.selected = null;
                    if ([
                        'INPUT',
                        'TEXTAREA'
                    ].includes(overlay.anchor.tagName)) {
                        search = overlay.anchor.value;
                        overlay.selected = overlay.anchor.dataset.selectedIndex;
                    }
                    let actions = $aa2bd8933167d9cb$export$2fa187e846a241c4(ret.overlay.box).find('.w2ui-eaction');
                    $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(actions, this);
                    this.applyFilter(overlay.name, null, search).then((data)=>{
                        if (!$aa2bd8933167d9cb$export$28c660c63b792dea.active[overlay.name].displayed) return;
                        overlay.tmp.searchCount = data.count;
                        overlay.tmp.search = data.search;
                        if (options.prefilter) this.refreshSearch(overlay.name);
                        this.initControls(ret.overlay);
                        this.refreshIndex(overlay.name, true);
                    });
                }
            });
            overlay.next = ()=>{
                let chain = this.getActiveChain(overlay.name);
                if (overlay.selected == null || overlay.selected?.length == 0) overlay.selected = chain[0];
                else {
                    let ind = chain.indexOf(overlay.selected);
                    // selected not in chain of items
                    if (ind == -1) overlay.selected = chain[0];
                    // not the last item
                    if (ind < chain.length - 1) overlay.selected = chain[ind + 1];
                }
                this.refreshIndex(overlay.name);
            };
            overlay.prev = ()=>{
                let chain = this.getActiveChain(overlay.name);
                if (overlay.selected == null || overlay.selected?.length == 0) overlay.selected = chain[chain.length - 1];
                else {
                    let ind = chain.indexOf(overlay.selected);
                    // selected not in chain of items
                    if (ind == -1) overlay.selected = chain[chain.length - 1];
                    // not first item
                    if (ind > 0) overlay.selected = chain[ind - 1];
                }
                this.refreshIndex(overlay.name);
            };
            overlay.click = ()=>{
                $(overlay.box).find('.w2ui-selected').click();
            };
            overlay.on('hide:after.attach', (event1)=>{
                $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(overlay.name + '-tooltip');
            });
            ret.select = (callback)=>{
                overlay.on('select.attach', (event1)=>{
                    callback(event1);
                });
                return ret;
            };
            ret.remove = (callback)=>{
                overlay.on('remove.attach', (event1)=>{
                    callback(event1);
                });
                return ret;
            };
            ret.subMenu = (callback)=>{
                overlay.on('subMenu.attach', (event1)=>{
                    callback(event1);
                });
                return ret;
            };
            return ret;
        }
        update(name, items) {
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name];
            if (overlay) {
                let options = overlay.options;
                if (options.items != items) options.items = items;
                let menuHTML = this.getMenuHTML(options);
                if (options.html != menuHTML) {
                    options.html = menuHTML;
                    overlay.needsUpdate = true;
                    this.show(name);
                }
            } else console.log(`Tooltip "${name}" is not displayed. Cannot update it.`);
        }
        initControls(overlay) {
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-menu:not(.w2ui-sub-menu)').off('.w2menu').on('contextmenu.w2menu', (event1)=>{
                event1.preventDefault() // prevent browser context menu
                ;
            }).on('mouseDown.w2menu', {
                delegate: '.w2ui-menu-item'
            }, (event1)=>{
                let dt = event1.delegate.dataset;
                this.menuDown(overlay, event1, dt.index, dt.parents);
            }).on(($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isIOS ? 'touchStart' : 'click') + '.w2menu', {
                delegate: '.w2ui-menu-item'
            }, (event1)=>{
                let dt = event1.delegate.dataset;
                this.menuClick(overlay, event1, parseInt(dt.index), dt.parents);
            }).find('.w2ui-menu-item').off('.w2menu').on('mouseEnter.w2menu', (event1)=>{
                let dt = event1.target.dataset;
                let tooltip = overlay.options.items[dt.index]?.tooltip;
                if (tooltip) $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                    name: overlay.name + '-tooltip',
                    anchor: event1.target,
                    html: tooltip,
                    position: 'right|left',
                    hideOn: [
                        'doc-click'
                    ]
                });
            }).on('mouseLeave.w2menu', (event1)=>{
                $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(overlay.name + '-tooltip');
            }).find('.menu-help').off('.w2menu').on('mouseEnter.w2menu', (event1)=>{
                let dt = event1.target.parentNode.parentNode.dataset;
                let tooltip = overlay.options.items[dt.index]?.help;
                if (tooltip) $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                    name: overlay.name + '-help-tp',
                    anchor: event1.target,
                    html: tooltip,
                    position: 'right|left',
                    hideOn: [
                        'doc-click'
                    ]
                });
            }).on('mouseLeave.w2menu', (event1)=>{
                $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(overlay.name + '-help-tp');
            });
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(overlay.anchor.tagName)) $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.anchor).off('.w2menu').on('input.w2menu', (event1)=>{
            // if user types, clear selection
            // let dt = event.target.dataset
            // delete dt.selected
            // delete dt.selectedIndex
            }).on('keyup.w2menu', (event1)=>{
                event1._searchType = 'filter';
                this.keyUp(overlay, event1);
            });
            if (overlay.options.search) $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('#menu-search').off('.w2menu').on('keyup.w2menu', (event1)=>{
                event1._searchType = 'search';
                this.keyUp(overlay, event1);
            });
        }
        getCurrent(name, id) {
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
            let options = overlay.options;
            let selected = (id ? id : overlay.selected ?? '').split('-');
            let last = selected.length - 1;
            let index = selected[last];
            let parents = selected.slice(0, selected.length - 1).join('-');
            index = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(index) ? parseInt(index) : 0;
            // items
            let items = options.items;
            selected.forEach((id, ind)=>{
                // do not go to the last one
                if (ind < selected.length - 1) items = items[id].items;
            });
            return {
                last: last,
                index: index,
                items: items,
                item: items[index],
                parents: parents
            };
        }
        getMenuHTML(options, items, subMenu, parentIndex) {
            if (options.spinner) return `
            <div class="w2ui-menu">
                <div class="w2ui-no-items">
                    <div class="w2ui-spinner"></div>
                    ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Loading...')}
                </div>
            </div>`;
            if (!parentIndex) parentIndex = [];
            if (items == null) items = options.items;
            if (!Array.isArray(items)) items = [];
            let count = 0;
            let icon = null;
            let topHTML = '';
            if (!subMenu && options.search) {
                topHTML += `
                <div class="w2ui-menu-search">
                    <span class="w2ui-icon w2ui-icon-search"></span>
                    <input id="menu-search" class="w2ui-input" type="text"/>
                </div>`;
                items.forEach((item)=>item.hidden = false);
            }
            if (!subMenu && options.topHTML) topHTML += `<div class="w2ui-menu-top">${options.topHTML}</div>`;
            let menu_html = `
            ${topHTML}
            <div class="w2ui-menu ${subMenu ? 'w2ui-sub-menu' : ''}" ${!subMenu ? `style="${options.menuStyle}"` : ''}
                data-parent="${parentIndex}">
        `;
            items.forEach((mitem, f)=>{
                icon = mitem.icon;
                let index = (parentIndex.length > 0 ? parentIndex.join('-') + '-' : '') + f;
                if (icon == null) icon = null // icon might be undefined
                ;
                if ([
                    'radio',
                    'check'
                ].indexOf(options.type) != -1 && !Array.isArray(mitem.items) && mitem.group !== false) {
                    if (mitem.checked === true) icon = 'w2ui-icon-check';
                    else icon = 'w2ui-icon-empty';
                }
                if (mitem.hidden !== true) {
                    let txt = mitem.text;
                    let icon_dsp = '';
                    let subMenu_dsp = '';
                    if (typeof options.render === 'function') txt = options.render(mitem, options);
                    if (typeof txt == 'function') txt = txt(mitem, options);
                    if (icon) {
                        if (String(icon).slice(0, 1) !== '<') icon = `<span class="w2ui-icon ${icon}"></span>`;
                        icon_dsp = `<div class="menu-icon">${icon}</span></div>`;
                    }
                    // for backward compatibility
                    if (mitem.removable == null && mitem.remove != null) mitem.rmovable = mitem.remove;
                    // render only if non-empty
                    if (mitem.type !== 'break' && txt != null && txt !== '' && String(txt).substr(0, 2) != '--') {
                        let classes = [
                            'w2ui-menu-item'
                        ];
                        if (options.altRows == true) classes.push(count % 2 === 0 ? 'w2ui-even' : 'w2ui-odd');
                        let colspan = 1;
                        if (icon_dsp === '') colspan++;
                        if (mitem.count == null && mitem.hotkey == null && mitem.removable !== true && mitem.items == null) colspan++;
                        if (mitem.tooltip == null && mitem.hint != null) mitem.tooltip = mitem.hint // for backward compatibility
                        ;
                        let count_dsp = '';
                        if (mitem.removable === true) count_dsp = '<span class="menu-remove">x</span>';
                        else if (mitem.items != null) {
                            let _items = [];
                            if (typeof mitem.items == 'function') _items = mitem.items(mitem);
                            else if (Array.isArray(mitem.items)) _items = mitem.items;
                            count_dsp = '<span style="background-color: transparent; border: transparent; box-shadow: none;"></span>' // used as drop arrow
                            ;
                            subMenu_dsp = `
                            <div class="w2ui-sub-menu-box" style="${mitem.expanded ? '' : 'display: none'}">
                                ${this.getMenuHTML(options, _items, true, parentIndex.concat(f))}
                            </div>`;
                        } else {
                            if (mitem.count != null) count_dsp += '<span>' + mitem.count + '</span>';
                            if (mitem.hotkey != null) count_dsp += '<span class="menu-hotkey">' + mitem.hotkey + '</span>';
                            if (mitem.help != null) count_dsp += '<span class="menu-help">?</span>';
                        }
                        if (mitem.disabled === true) classes.push('w2ui-disabled');
                        if (mitem._noSearchInside === true) classes.push('w2ui-no-search-inside');
                        if (subMenu_dsp !== '') {
                            classes.push('has-sub-menu');
                            if (mitem.expanded) classes.push('expanded');
                            else classes.push('collapsed');
                        }
                        menu_html += `
                        <div index="${index}" class="${classes.join(' ')}" style="${mitem.style ? mitem.style : ''}"
                            data-index="${f}" data-parents="${parentIndex.join('-')}">
                                <div style="width: ${(subMenu ? 20 : 0) + parseInt(mitem.indent ?? 0)}px"></div>
                                ${icon_dsp}
                                <div class="menu-text" colspan="${colspan}">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(txt)}</div>
                                <div class="menu-extra">${count_dsp}</div>
                        </div>
                        ${subMenu_dsp}`;
                        count++;
                    } else {
                        // horizontal line
                        let divText = (txt ?? '').replace(/^-+/g, '');
                        menu_html += `
                        <div index="${index}" class="w2ui-menu-divider ${divText != '' ? 'has-text' : ''}">
                            <div class="line"></div>
                            ${divText ? `<div class="text">${divText}</div>` : ''}
                        </div>`;
                    }
                }
                items[f] = mitem;
            });
            if (count === 0 && options.msgNoItems) menu_html += `
                <div class="w2ui-no-items">
                    ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(options.msgNoItems)}
                </div>`;
            menu_html += '</div>';
            return menu_html;
        }
        // Refreshed only selected item highligh, used in keyboard navigation
        refreshIndex(name, instant) {
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
            if (!overlay) return;
            if (!overlay.displayed) this.show(overlay.name);
            let view = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-overlay-body').get(0);
            let search = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-menu-search, .w2ui-menu-top').get(0);
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-menu-item.w2ui-selected').removeClass('w2ui-selected');
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find(`.w2ui-menu-item[index="${overlay.selected}"]`).addClass('w2ui-selected').get(0);
            if (el) {
                if (el.offsetTop + el.clientHeight > view.clientHeight + view.scrollTop) el.scrollIntoView({
                    behavior: instant ? 'instant' : 'smooth',
                    block: instant ? 'center' : 'start',
                    inline: instant ? 'center' : 'start'
                });
                if (el.offsetTop < view.scrollTop + (search ? search.clientHeight : 0)) el.scrollIntoView({
                    behavior: instant ? 'instant' : 'smooth',
                    block: instant ? 'center' : 'end',
                    inline: instant ? 'center' : 'end'
                });
            }
        }
        // show/hide searched items
        refreshSearch(name) {
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
            if (!overlay) return;
            if (!overlay.displayed) this.show(overlay.name);
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-no-items').hide();
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-menu-item, .w2ui-menu-divider').each((el)=>{
                let cur = this.getCurrent(name, el.getAttribute('index'));
                if (cur.item?.hidden) $aa2bd8933167d9cb$export$2fa187e846a241c4(el).hide();
                else {
                    let search = overlay.tmp?.search;
                    if (overlay.options.markSearch) $aa2bd8933167d9cb$export$fe3767bc112f7a2a.marker(el, search, {
                        onlyFirst: overlay.options.match == 'begins'
                    });
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(el).show();
                }
            });
            // hide empty menus
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-sub-menu').each((sub)=>{
                let hasItems = $aa2bd8933167d9cb$export$2fa187e846a241c4(sub).find('.w2ui-menu-item').get().some((el)=>{
                    return el.style.display != 'none' ? true : false;
                });
                let parent = this.getCurrent(name, sub.dataset.parent);
                // only if parent is expaneded
                if (parent.item.expanded) {
                    if (!hasItems) $aa2bd8933167d9cb$export$2fa187e846a241c4(sub).parent().hide();
                    else $aa2bd8933167d9cb$export$2fa187e846a241c4(sub).parent().show();
                }
            });
            // show empty message
            if (overlay.tmp.searchCount == 0 || overlay.options?.items?.length == 0) {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-no-items').length == 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-menu:not(.w2ui-sub-menu)').append(`
                    <div class="w2ui-no-items">
                        ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(overlay.options.msgNoItems)}
                    </div>`);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-no-items').show();
            }
        }
        /**
     * Loops through the items and markes item.hidden = true for those that need to be hidden, and item.hidden = false
     * for those that are visible. Return a promise (since items can be on the server) with the number of visible items.
     */ applyFilter(name, items, search, debounce) {
            let count = 0;
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
            let options = overlay.options;
            let resolve, reject;
            let prom = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            if (search == null) {
                if ([
                    'INPUT',
                    'TEXTAREA'
                ].includes(overlay.anchor.tagName)) search = overlay.anchor.value;
                else search = '';
            }
            let selectedIds = [];
            if (options.selected) {
                if (Array.isArray(options.selected)) selectedIds = options.selected.map((item)=>{
                    return item?.id ?? item;
                });
                else if (options.selected?.id) selectedIds = [
                    options.selected.id
                ];
            }
            overlay.tmp.activeChain = null;
            // if url is defined, get items from it
            let remote = overlay.tmp.remote ?? {
                hasMore: true,
                emtpySet: false,
                search: null,
                total: -1
            };
            if (items == null && options.url && remote.hasMore && remote.search !== search) {
                let proceed = true;
                // only when items == null because it is case of nested items
                let msg = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Loading...');
                if (search.length < options.minLength && remote.emptySet !== true) {
                    msg = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('${count} letters or more...', {
                        count: options.minLength
                    });
                    proceed = false;
                    if (search === '') msg = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(options.msgSearch);
                }
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-no-items').html(msg);
                remote.search = search;
                options.items = [];
                overlay.tmp.remote = remote;
                if (proceed) this.request(overlay, search, debounce).then((remoteItems)=>{
                    this.update(name, remoteItems);
                    this.applyFilter(name, null, search).then((data)=>{
                        resolve(data);
                    });
                }).catch((error)=>{
                    console.log('Server Request error', error);
                });
                return prom;
            }
            let edata;
            // only trigger search event when data is present and for the top level
            if (items == null) {
                edata = this.trigger('search', {
                    search: search,
                    overlay: overlay,
                    prom: prom,
                    resolve: resolve,
                    reject: reject
                });
                if (edata.isCancelled === true) return prom;
            }
            if (items == null) items = overlay.options.items;
            if (options.filter === false) {
                resolve({
                    count: -1,
                    search: search
                });
                return prom;
            }
            items.forEach((item)=>{
                let prefix = '';
                let suffix = '';
                if ([
                    'is',
                    'begins',
                    'begins with'
                ].indexOf(options.match) !== -1) prefix = '^';
                if ([
                    'is',
                    'ends',
                    'ends with'
                ].indexOf(options.match) !== -1) suffix = '$';
                try {
                    let re = new RegExp(prefix + search + suffix, 'i');
                    if (re.test(item.text) || item.text === '...') item.hidden = false;
                    else item.hidden = true;
                } catch (e) {}
                // do not show selected items
                if (options.hideSelected && selectedIds.includes(item.id)) item.hidden = true;
                // search nested items
                if (Array.isArray(item.items) && item.items.length > 0) {
                    delete item._noSearchInside;
                    this.applyFilter(name, item.items, search).then((data)=>{
                        let subCount = data.count;
                        if (subCount > 0) {
                            count += subCount;
                            if (item.hidden) item._noSearchInside = true;
                            // only expand items if search is not empty
                            if (search) item.expanded = true;
                            item.hidden = false;
                        }
                    });
                }
                if (item.hidden !== true) count++;
            });
            resolve({
                count: count,
                search: search
            });
            edata?.finish();
            return prom;
        }
        request(overlay, search, debounce) {
            let options = overlay.options;
            let remote = overlay.tmp.remote;
            let resolve, reject // promise functions
            ;
            if (options.items.length === 0 && remote.total !== 0 || remote.total == options.cacheMax && search.length > remote.search.length || search.length >= remote.search.length && search.substr(0, remote.search.length) !== remote.search || search.length < remote.search.length) {
                // Aabort previous request if any
                if (remote.controller) remote.controller.abort();
                remote.loading = true;
                clearTimeout(remote.timeout);
                remote.timeout = setTimeout(()=>{
                    let url = options.url;
                    let postData = {
                        search: search,
                        max: options.cacheMax
                    };
                    Object.assign(postData, options.postData);
                    // trigger event
                    let edata = this.trigger('request', {
                        search: search,
                        overlay: overlay,
                        url: url,
                        postData: postData,
                        httpMethod: options.method ?? 'GET',
                        httpHeaders: {}
                    });
                    if (edata.isCancelled === true) return;
                    // if event updated url and postData, use it
                    url = new URL(edata.detail.url, location);
                    let fetchOptions = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.prepareParams(url, {
                        method: edata.detail.httpMethod,
                        headers: edata.detail.httpHeaders,
                        body: edata.detail.postData
                    });
                    // Create new abort controller
                    remote.controller = new AbortController();
                    fetchOptions.signal = remote.controller.signal;
                    // send request
                    fetch(url, fetchOptions).then((resp)=>resp.json()).then((data)=>{
                        remote.controller = null;
                        // trigger event
                        let edata = overlay.trigger('load', {
                            search: postData.search,
                            overlay: overlay,
                            data: data
                        });
                        if (edata.isCancelled === true) return;
                        // default behavior
                        data = edata.detail.data;
                        if (typeof data === 'string') data = JSON.parse(data);
                        // if server just returns array
                        if (Array.isArray(data)) data = {
                            records: data
                        };
                        // needed for backward compatibility
                        if (data.records == null && data.items != null) {
                            data.records = data.items;
                            delete data.items;
                        }
                        // handles Golang marshal of empty arrays to null
                        if (!data.error && data.records == null) data.records = [];
                        if (!Array.isArray(data.records)) {
                            console.error('ERROR: server did not return proper data structure', '\n', ' - it should return', {
                                records: [
                                    {
                                        id: 1,
                                        text: 'item'
                                    }
                                ]
                            }, '\n', ' - or just an array ', [
                                {
                                    id: 1,
                                    text: 'item'
                                }
                            ], '\n', ' - or if errorr ', {
                                error: true,
                                message: 'error message'
                            });
                            return;
                        }
                        // remove all extra items if more then needed for cache
                        if (data.records.length >= options.cacheMax) {
                            data.records.splice(options.cacheMax, data.records.length);
                            remote.hasMore = true;
                        } else remote.hasMore = false;
                        // map_ctx id and text
                        if (options.recId == null && options.recid != null) options.recId = options.recid // since lower-case recid is used in grid
                        ;
                        if (options.recId || options.recText) data.records.forEach((item)=>{
                            if (typeof options.recId === 'string') item.id = item[options.recId];
                            if (typeof options.recId === 'function') item.id = options.recId(item);
                            if (typeof options.recText === 'string') item.text = item[options.recText];
                            if (typeof options.recText === 'function') item.text = options.recText(item);
                        });
                        // remember stats
                        remote.loading = false;
                        remote.search = search;
                        remote.total = data.records.length;
                        remote.lastError = '';
                        remote.emptySet = search === '' && data.records.length === 0 ? true : false;
                        // event after
                        edata.finish();
                        resolve($aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu(data.records));
                    }).catch((error)=>{
                        let edata = this.trigger('error', {
                            overlay: overlay,
                            search: search,
                            error: error
                        });
                        if (edata.isCancelled === true) return;
                        // default behavior
                        if (error?.name !== 'AbortError') console.error('ERROR: Server communication failed.', '\n', ' - it should return', {
                            records: [
                                {
                                    id: 1,
                                    text: 'item'
                                }
                            ]
                        }, '\n', ' - or just an array ', [
                            {
                                id: 1,
                                text: 'item'
                            }
                        ], '\n', ' - or if errorr ', {
                            error: true,
                            message: 'error message'
                        });
                        // reset stats
                        remote.loading = false;
                        remote.search = '';
                        remote.total = -1;
                        remote.emptySet = true;
                        remote.lastError = edata.detail.error || 'Server communication failed';
                        options.items = [];
                        // event after
                        edata.finish();
                        reject();
                    });
                    // event after
                    edata.finish();
                }, debounce ? options.debounce ?? 350 : 0);
            }
            return new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
        }
        /**
     * Builds an array of item ids that sequencial in navigation with up/down keys.
     * Skips hidden and denied items and goes into nested structures.
     */ getActiveChain(name, items, parents = [], res = [], noSave) {
            let overlay = $aa2bd8933167d9cb$export$28c660c63b792dea.active[name.replace(/[\s\.#]/g, '_')];
            if (overlay.tmp.activeChain != null) return overlay.tmp.activeChain;
            if (items == null) items = overlay.options.items;
            items.forEach((item, ind)=>{
                if (!item.hidden && !item.disabled && !item?.text?.startsWith('--')) {
                    res.push(parents.concat([
                        ind
                    ]).join('-'));
                    if (Array.isArray(item.items) && item.items.length > 0 && item.expanded) {
                        parents.push(ind);
                        this.getActiveChain(name, item.items, parents, res, true);
                        parents.pop();
                    }
                }
            });
            if (noSave == null) overlay.tmp.activeChain = res;
            return res;
        }
        menuDown(overlay, event1, index, parentIndex) {
            let options = overlay.options;
            let items = options.items;
            let icon = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).find('.w2ui-icon');
            let menu = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.w2ui-menu:not(.w2ui-sub-menu)');
            if (typeof parentIndex == 'string' && parentIndex !== '') {
                let ids = parentIndex.split('-');
                ids.forEach((id)=>{
                    items = items[id].items;
                });
            }
            if (typeof items == 'function') items = items({
                overlay: overlay,
                index: index,
                parentIndex: parentIndex,
                event: event1
            });
            let item = items[index];
            if (item.disabled) return;
            let uncheck = (items, parent)=>{
                items.forEach((other, ind)=>{
                    if (other.id == item.id) return;
                    if (other.group === item.group && other.checked) {
                        menu.find(`.w2ui-menu-item[index="${(parent ? parent + '-' : '') + ind}"] .w2ui-icon`).removeClass('w2ui-icon-check').addClass('w2ui-icon-empty');
                        items[ind].checked = false;
                    }
                    if (Array.isArray(other.items)) uncheck(other.items, ind);
                });
            };
            if ((options.type === 'check' || options.type === 'radio') && item.group !== false && !$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('menu-remove') && !$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('menu-help') && !$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.w2ui-menu-item').hasClass('has-sub-menu')) {
                item.checked = options.type == 'radio' ? true : !item.checked;
                if (item.checked) {
                    if (options.type === 'radio') $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.w2ui-menu').find('.w2ui-icon').removeClass('w2ui-icon-check').addClass('w2ui-icon-empty');
                    if (options.type === 'check' && item.group != null) uncheck(options.items);
                    icon.removeClass('w2ui-icon-empty').addClass('w2ui-icon-check');
                } else if (options.type === 'check') icon.removeClass('w2ui-icon-check').addClass('w2ui-icon-empty');
            }
            // highlight record
            if (!$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('menu-remove') && !$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('menu-help')) {
                menu.find('.w2ui-menu-item').removeClass('w2ui-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).addClass('w2ui-selected');
            }
        }
        menuClick(overlay, event1, index, parentIndex) {
            let options = overlay.options;
            let items = options.items;
            let $item = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).closest('.w2ui-menu-item');
            let keepOpen = options.hideOn.includes('select') ? false : true;
            if (event1.shiftKey || event1.metaKey || event1.ctrlKey) keepOpen = true;
            if (typeof parentIndex == 'string' && parentIndex !== '') {
                let ids = parentIndex.split('-');
                ids.forEach((id)=>{
                    items = items[id].items;
                });
            } else parentIndex = null;
            if (typeof items == 'function') items = items({
                overlay: overlay,
                index: index,
                parentIndex: parentIndex,
                event: event1
            });
            let item = items[index];
            if (!item || item.disabled && !$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('menu-remove')) return;
            let edata;
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('menu-remove')) {
                edata = this.trigger('remove', {
                    originalEvent: event1,
                    target: overlay.name,
                    overlay: overlay,
                    item: item,
                    index: index,
                    parentIndex: parentIndex,
                    el: $item[0]
                });
                if (edata.isCancelled === true) return;
                keepOpen = !options.hideOn.includes('item-remove');
                $item.remove();
            } else if ($item.hasClass('has-sub-menu')) {
                edata = this.trigger('subMenu', {
                    originalEvent: event1,
                    target: overlay.name,
                    overlay: overlay,
                    item: item,
                    index: index,
                    parentIndex: parentIndex,
                    el: $item[0]
                });
                if (edata.isCancelled === true) return;
                keepOpen = true;
                if ($item.hasClass('expanded')) {
                    item.expanded = false;
                    $item.removeClass('expanded').addClass('collapsed');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4($item.get(0).nextElementSibling).hide();
                    overlay.selected = parseInt($item.attr('index'));
                } else {
                    item.expanded = true;
                    $item.addClass('expanded').removeClass('collapsed');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4($item.get(0).nextElementSibling).show();
                    overlay.selected = parseInt($item.attr('index'));
                }
            } else {
                // find items that are selected
                let selected = this.findChecked(options.items);
                overlay.selected = parseInt($item.attr('index'));
                edata = this.trigger('select', {
                    originalEvent: event1,
                    target: overlay.name,
                    overlay: overlay,
                    item: item,
                    index: index,
                    parentIndex: parentIndex,
                    selected: selected,
                    keepOpen: keepOpen,
                    el: $item[0]
                });
                if (edata.isCancelled === true) return;
                if (item.keepOpen != null) keepOpen = item.keepOpen;
                if ([
                    'INPUT',
                    'TEXTAREA'
                ].includes(overlay.anchor.tagName)) {
                    overlay.anchor.dataset.selected = item.id;
                    overlay.anchor.dataset.selectedIndex = overlay.selected;
                }
            }
            if (!keepOpen) this.hide(overlay.name);
            // if (['INPUT', 'TEXTAREA'].includes(overlay.anchor.tagName)) {
            //     overlay.anchor.focus()
            // }
            // event after
            edata.finish();
        }
        findChecked(items) {
            let found = [];
            items.forEach((item)=>{
                if (item.checked) found.push(item);
                if (Array.isArray(item.items)) found = found.concat(this.findChecked(item.items));
            });
            return found;
        }
        keyUp(overlay, event1) {
            let options = overlay.options;
            let search = event1.target.value;
            let filter = true;
            let refreshIndex = false;
            switch(event1.keyCode){
                case 46:
                case 8:
                    // if search empty and delete is clicked, do not filter nor show overlay
                    if (search === '' && !overlay.displayed) filter = false;
                    break;
                case 13:
                    {
                        if (!overlay.displayed || !overlay.selected) return;
                        let { index: index, parents: parents } = this.getCurrent(overlay.name);
                        event1.delegate = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-selected').get(0);
                        // reset activeID chain for folders
                        this.menuClick(overlay, event1, parseInt(index), parents);
                        filter = false;
                        break;
                    }
                case 27:
                    filter = false;
                    if (overlay.displayed) this.hide(overlay.name);
                    else {
                        // clear selected
                        let el = overlay.anchor;
                        if ([
                            'INPUT',
                            'TEXTAREA'
                        ].includes(el.tagName)) {
                            el.value = '';
                            delete el.dataset.selected;
                            delete el.dataset.selectedIndex;
                        }
                    }
                    break;
                case 37:
                    {
                        if (!overlay.displayed) return;
                        let { item: item, index: index, parents: parents } = this.getCurrent(overlay.name);
                        // collapse parent if any
                        if (parents) {
                            item = options.items[parents];
                            index = parseInt(parents);
                            parents = '';
                            refreshIndex = true;
                        }
                        if (Array.isArray(item?.items) && item.items.length > 0 && item.expanded) {
                            event1.delegate = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find(`.w2ui-menu-item[index="${index}"]`).get(0);
                            overlay.selected = index;
                            this.menuClick(overlay, event1, parseInt(index), parents);
                        }
                        filter = false;
                        break;
                    }
                case 39:
                    {
                        if (!overlay.displayed) return;
                        let { item: item, index: index, parents: parents } = this.getCurrent(overlay.name);
                        if (Array.isArray(item?.items) && item.items.length > 0 && !item.expanded) {
                            event1.delegate = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-selected').get(0);
                            this.menuClick(overlay, event1, parseInt(index), parents);
                        }
                        filter = false;
                        break;
                    }
                case 38:
                    if (!overlay.displayed) break;
                    overlay.prev();
                    filter = false;
                    event1.preventDefault();
                    break;
                case 40:
                    if (!overlay.displayed) break;
                    overlay.next();
                    filter = false;
                    event1.preventDefault();
                    break;
            }
            // filter
            if (filter && overlay.displayed && (options.filter && event1._searchType == 'filter' || options.search && event1._searchType == 'search')) this.applyFilter(overlay.name, null, search, true).then((data)=>{
                overlay.tmp.searchCount = data.count;
                overlay.tmp.search = data.search;
                // if selected is not in searched items
                if (data.count === 0 || !this.getActiveChain(overlay.name).includes(overlay.selected)) overlay.selected = null;
                this.refreshSearch(overlay.name);
            });
            if (refreshIndex) this.refreshIndex(overlay.name);
        }
    }
    class $aa2bd8933167d9cb$var$DateTooltip extends $aa2bd8933167d9cb$export$28c660c63b792dea {
        constructor(){
            super();
            let td = new Date();
            this.daysCount = [
                31,
                28,
                31,
                30,
                31,
                30,
                31,
                31,
                30,
                31,
                30,
                31
            ];
            this.today = td.getFullYear() + '/' + (Number(td.getMonth()) + 1) + '/' + td.getDate();
            this.defaults = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.defaults, {
                position: 'top|bottom',
                class: 'w2ui-calendar',
                type: 'date',
                value: '',
                format: '',
                start: null,
                end: null,
                btnNow: false,
                blockDates: [],
                blockWeekdays: [],
                colored: {},
                arrowSize: 12,
                autoResize: false,
                anchorClass: 'w2ui-focus',
                autoShowOn: 'focus',
                hideOn: [
                    'doc-click',
                    'focus-change'
                ],
                onSelect: null
            });
        }
        attach(anchor, text) {
            let options;
            if (arguments.length == 1 && anchor instanceof Object) {
                options = anchor;
                anchor = options.anchor;
            } else if (arguments.length === 2 && text != null && typeof text === 'object') {
                options = text;
                options.anchor = anchor;
            }
            let prevHideOn = options.hideOn;
            options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.defaults, options || {});
            if (prevHideOn) options.hideOn = prevHideOn;
            if (!options.format) {
                let df = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat;
                let tf = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.timeFormat;
                if (options.type == 'date') options.format = df;
                else if (options.type == 'time') options.format = tf;
                else options.format = df + '|' + tf;
            }
            let cal = options.type == 'time' ? this.getHourHTML(options) : this.getMonthHTML(options);
            options.style += '; padding: 0;';
            options.html = cal.html;
            let ret = super.attach(options);
            let overlay = ret.overlay;
            Object.assign(overlay.tmp, cal);
            overlay.on('show.attach', (event1)=>{
                let overlay = event1.detail.overlay;
                let anchor = overlay.anchor;
                let options = overlay.options;
                if ([
                    'INPUT',
                    'TEXTAREA'
                ].includes(anchor.tagName) && !options.value && anchor.value) overlay.tmp.initValue = anchor.value;
                delete overlay.newValue;
                delete overlay.newDate;
            });
            overlay.on('show:after.attach', (event1)=>{
                if (ret.overlay?.box) this.initControls(ret.overlay);
            });
            overlay.on('update:after.attach', (event1)=>{
                if (ret.overlay?.box) this.initControls(ret.overlay);
            });
            overlay.on('hide.attach', (event1)=>{
                let overlay = event1.detail.overlay;
                let anchor = overlay.anchor;
                if (overlay.newValue != null) {
                    if (overlay.newDate) overlay.newValue = overlay.newDate + ' ' + overlay.newValue;
                    if ([
                        'INPUT',
                        'TEXTAREA'
                    ].includes(anchor.tagName) && anchor.value != overlay.newValue) anchor.value = overlay.newValue;
                    let edata = this.trigger('select', {
                        date: overlay.newValue,
                        target: overlay.name,
                        overlay: overlay
                    });
                    if (edata.isCancelled === true) return;
                    // event after
                    edata.finish();
                }
            });
            ret.select = (callback)=>{
                overlay.on('select.attach', (event1)=>{
                    callback(event1);
                });
                return ret;
            };
            return ret;
        }
        initControls(overlay) {
            let options = overlay.options;
            let moveMonth = (inc)=>{
                let { month: month, year: year } = overlay.tmp;
                month += inc;
                if (month > 12) {
                    month = 1;
                    year++;
                }
                if (month < 1) {
                    month = 12;
                    year--;
                }
                let cal = this.getMonthHTML(options, month, year);
                Object.assign(overlay.tmp, cal);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-overlay-body').html(cal.html);
                this.initControls(overlay);
            };
            let checkJump = (event1, dblclick)=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parent().find('.w2ui-jump-month, .w2ui-jump-year').removeClass('w2ui-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).addClass('w2ui-selected');
                let dt = new Date();
                let { jumpMonth: jumpMonth, jumpYear: jumpYear } = overlay.tmp;
                if (dblclick) {
                    if (jumpYear == null) jumpYear = dt.getFullYear();
                    if (jumpMonth == null) jumpMonth = dt.getMonth() + 1;
                }
                if (jumpMonth && jumpYear) {
                    let cal = this.getMonthHTML(options, jumpMonth, jumpYear);
                    Object.assign(overlay.tmp, cal);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-overlay-body').html(cal.html);
                    overlay.tmp.jump = false;
                    this.initControls(overlay);
                }
            };
            // events for next/prev buttons and enableAccess
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-cal-title').off('.calendar') // click on enableAccess
            .on('click.calendar', (event1)=>{
                Object.assign(overlay.tmp, {
                    jumpYear: null,
                    jumpMonth: null
                });
                if (overlay.tmp.jump) {
                    let { month: month, year: year } = overlay.tmp;
                    let cal = this.getMonthHTML(options, month, year);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-overlay-body').html(cal.html);
                    overlay.tmp.jump = false;
                } else {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-overlay-body .w2ui-cal-days').replace(this.getYearHTML());
                    let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find(`[name="${overlay.tmp.year}"]`).get(0);
                    if (el) el.scrollIntoView(true);
                    overlay.tmp.jump = true;
                }
                this.initControls(overlay);
                event1.stopPropagation();
            }) // prev button
            .find('.w2ui-cal-previous').off('.calendar').on('click.calendar', (event1)=>{
                moveMonth(-1);
                event1.stopPropagation();
            }).parent() // next button
            .find('.w2ui-cal-next').off('.calendar').on('click.calendar', (event1)=>{
                moveMonth(1);
                event1.stopPropagation();
            });
            // now button
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-cal-now').off('.calendar').on('click.calendar', (event1)=>{
                if (options.type == 'datetime') {
                    if (overlay.newDate) overlay.newValue = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(new Date(), options.format.split('|')[1]);
                    else overlay.newValue = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime(new Date(), options.format);
                } else if (options.type == 'date') overlay.newValue = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(new Date(), options.format);
                else if (options.type == 'time') overlay.newValue = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(new Date(), options.format);
                this.hide(overlay.name);
            });
            // events for dates
            $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).off('.calendar').on('contextmenu.calendar', (event1)=>{
                event1.preventDefault() // prevent browser context menu
                ;
            }).on('click.calendar', {
                delegate: '.w2ui-day.w2ui-date'
            }, (event1)=>{
                if (options.type == 'datetime') {
                    overlay.newDate = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('date');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-overlay-body').html(this.getHourHTML(overlay.options).html);
                    this.initControls(overlay);
                } else {
                    overlay.newValue = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('date');
                    this.hide(overlay.name);
                }
            }) // click on month
            .on('click.calendar', {
                delegate: '.w2ui-jump-month'
            }, (event1)=>{
                overlay.tmp.jumpMonth = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('name'));
                checkJump(event1);
            }) // double click on month
            .on('dblclick.calendar', {
                delegate: '.w2ui-jump-month'
            }, (event1)=>{
                overlay.tmp.jumpMonth = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('name'));
                checkJump(event1, true);
            }) // click on year
            .on('click.calendar', {
                delegate: '.w2ui-jump-year'
            }, (event1)=>{
                overlay.tmp.jumpYear = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('name'));
                checkJump(event1);
            }) // dbl click on year
            .on('dblclick.calendar', {
                delegate: '.w2ui-jump-year'
            }, (event1)=>{
                overlay.tmp.jumpYear = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('name'));
                checkJump(event1, true);
            }) // click on hour
            .on('click.calendar', {
                delegate: '.w2ui-time.hour'
            }, (event1)=>{
                let hour = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('hour');
                let min = this.str2min(options.value) % 60;
                if (overlay.tmp.initValue && !options.value) min = this.str2min(overlay.tmp.initValue) % 60;
                if (options.noMinutes) {
                    overlay.newValue = this.min2str(hour * 60, options.format);
                    this.hide(overlay.name);
                } else {
                    overlay.newValue = hour + ':' + min;
                    let html = this.getMinHTML(hour, options).html;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(overlay.box).find('.w2ui-overlay-body').html(html);
                    this.initControls(overlay);
                }
            }) // click on minute
            .on('click.calendar', {
                delegate: '.w2ui-time.min'
            }, (event1)=>{
                let hour = Math.floor(this.str2min(overlay.newValue) / 60);
                let time = hour * 60 + parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('min'));
                overlay.newValue = this.min2str(time, options.format);
                this.hide(overlay.name);
            });
        }
        getMonthHTML(options, month, year) {
            let days = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.fulldays.slice() // creates copy of the array
            ;
            let sdays = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.shortdays.slice() // creates copy of the array
            ;
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.weekStarts !== 'M') {
                days.unshift(days.pop());
                sdays.unshift(sdays.pop());
            }
            let td = new Date();
            let dayLengthMil = 86400000;
            let selected = options.type === 'datetime' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(options.value, options.format, true) : $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(options.value, options.format, true);
            let selected_dsp = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(selected);
            // normalize date
            if (month == null || year == null) {
                year = selected ? selected.getFullYear() : td.getFullYear();
                month = selected ? selected.getMonth() + 1 : td.getMonth() + 1;
            }
            if (month > 12) {
                month -= 12;
                year++;
            }
            if (month < 1 || month === 0) {
                month += 12;
                year--;
            }
            if (year / 4 == Math.floor(year / 4)) this.daysCount[1] = 29;
            else this.daysCount[1] = 28;
            options.current = month + '/' + year;
            // start with the required date
            td = new Date(year, month - 1, 1);
            let weekDay = td.getDay();
            let weekDays = '';
            let st = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.weekStarts;
            for(let i = 0; i < sdays.length; i++){
                let isSat = st == 'M' && i == 5 || st != 'M' && i == 6 ? true : false;
                let isSun = st == 'M' && i == 6 || st != 'M' && i == 0 ? true : false;
                weekDays += `<div class="w2ui-day w2ui-weekday ${isSat ? 'w2ui-sunday' : ''} ${isSun ? 'w2ui-saturday' : ''}">${sdays[i]}</div>`;
            }
            let html = `
            <div class="w2ui-cal-title">
                <div class="w2ui-cal-previous">
                    <div></div>
                </div>
                <div class="w2ui-cal-next">
                    <div></div>
                </div>
                ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.fullmonths[month - 1]}, ${year}
                <span class="arrow-down"></span>
            </div>
            <div class="w2ui-cal-days">
                ${weekDays}
        `;
            let DT = new Date(`${year}/${month}/1`) // first of month
            ;
            /**
         * Move to noon, instead of midnight. If not, then the date when time saving happens
         * will be duplicated in the calendar
         */ DT = new Date(DT.getTime() + dayLengthMil * 0.5);
            let weekday = DT.getDay();
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.weekStarts == 'M') weekDay--;
            if (weekday > 0) DT = new Date(DT.getTime() - weekDay * dayLengthMil);
            for(let ci = 0; ci < 42; ci++){
                let className = [];
                let dt = `${DT.getFullYear()}/${DT.getMonth() + 1}/${DT.getDate()}`;
                if (DT.getDay() === 6) className.push('w2ui-saturday');
                if (DT.getDay() === 0) className.push('w2ui-sunday');
                if (DT.getMonth() + 1 !== month) className.push('outside');
                if (dt == this.today) className.push('w2ui-today');
                let dspDay = DT.getDate();
                let col = '';
                let bgcol = '';
                let tmp_dt, tmp_dt_fmt;
                if (options.type === 'datetime') {
                    tmp_dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime(dt, options.format);
                    tmp_dt_fmt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dt, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat);
                } else {
                    tmp_dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dt, options.format);
                    tmp_dt_fmt = tmp_dt;
                }
                if (options.colored && options.colored[tmp_dt_fmt] !== undefined) {
                    let tmp = options.colored[tmp_dt_fmt].split('|');
                    bgcol = 'background-color: ' + tmp[0] + ';';
                    col = 'color: ' + tmp[1] + ';';
                }
                html += `<div class="w2ui-day ${this.inRange(tmp_dt, options, true) ? 'w2ui-date ' + (tmp_dt_fmt == selected_dsp ? 'w2ui-selected' : '') : 'w2ui-blocked'} ${className.join(' ')}"
                       style="${col + bgcol}" date="${tmp_dt_fmt}" data-date="${DT.getTime()}">
                            ${dspDay}
                    </div>`;
                DT = new Date(DT.getTime() + dayLengthMil);
            }
            html += '</div>';
            if (options.btnNow) {
                let label = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Today' + (options.type == 'datetime' ? ' & Now' : ''));
                html += `<div class="w2ui-cal-now">${label}</div>`;
            }
            return {
                html: html,
                month: month,
                year: year
            };
        }
        getYearHTML() {
            let mhtml = '';
            let yhtml = '';
            for(let m = 0; m < $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.fullmonths.length; m++)mhtml += `<div class="w2ui-jump-month" name="${m + 1}">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.shortmonths[m]}</div>`;
            for(let y = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateStartYear; y <= $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateEndYear; y++)yhtml += `<div class="w2ui-jump-year" name="${y}">${y}</div>`;
            return `<div class="w2ui-cal-jump">
            <div id="w2ui-jump-month">${mhtml}</div>
            <div id="w2ui-jump-year">${yhtml}</div>
        </div>`;
        }
        getHourHTML(options) {
            options = options ?? {};
            if (!options.format) options.format = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.timeFormat;
            let h24 = options.format.indexOf('h24') > -1;
            let value = options.value ? options.value : options.anchor ? options.anchor.value : '';
            let tmp = [];
            for(let a = 0; a < 24; a++){
                let time = (a >= 12 && !h24 ? a - 12 : a) + ':00' + (!h24 ? a < 12 ? ' am' : ' pm' : '');
                if (a == 12 && !h24) time = '12:00 pm';
                if (!tmp[Math.floor(a / 8)]) tmp[Math.floor(a / 8)] = '';
                let tm1 = this.min2str(this.str2min(time));
                let tm2 = this.min2str(this.str2min(time) + 59);
                if (options.type === 'datetime') {
                    let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value, options.format, true);
                    let fm = options.format.split('|')[0].trim();
                    tm1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dt, fm) + ' ' + tm1;
                    tm2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dt, fm) + ' ' + tm2;
                }
                let valid = this.inRange(tm1, options) || this.inRange(tm2, options);
                tmp[Math.floor(a / 8)] += `<span hour="${a}"
                class="hour ${valid ? 'w2ui-time ' : 'w2ui-blocked'}">${time}</span>`;
            }
            let html = `<div class="w2ui-calendar">
            <div class="w2ui-time-title">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Select Hour')}</div>
            <div class="w2ui-cal-time">
                <div class="w2ui-cal-column">${tmp[0]}</div>
                <div class="w2ui-cal-column">${tmp[1]}</div>
                <div class="w2ui-cal-column">${tmp[2]}</div>
            </div>
            ${options.btnNow ? `<div class="w2ui-cal-now">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Now')}</div>` : ''}
        </div>`;
            return {
                html: html
            };
        }
        getMinHTML(hour, options) {
            if (hour == null) hour = 0;
            options = options ?? {};
            if (!options.format) options.format = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.timeFormat;
            let h24 = options.format.indexOf('h24') > -1;
            let value = options.value ? options.value : options.anchor ? options.anchor.value : '';
            let tmp = [];
            for(let a = 0; a < 60; a += 5){
                let time = (hour > 12 && !h24 ? hour - 12 : hour) + ':' + (a < 10 ? 0 : '') + a + ' ' + (!h24 ? hour < 12 ? 'am' : 'pm' : '');
                let tm = time;
                let ind = a < 20 ? 0 : a < 40 ? 1 : 2;
                if (!tmp[ind]) tmp[ind] = '';
                if (options.type === 'datetime') {
                    let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value, options.format, true);
                    let fm = options.format.split('|')[0].trim();
                    tm = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dt, fm) + ' ' + tm;
                }
                tmp[ind] += `<span min="${a}" class="min ${this.inRange(tm, options) ? 'w2ui-time ' : 'w2ui-blocked'}">${time}</span>`;
            }
            let html = `<div class="w2ui-calendar">
            <div class="w2ui-time-title">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Select Minute')}</div>
            <div class="w2ui-cal-time">
                <div class="w2ui-cal-column">${tmp[0]}</div>
                <div class="w2ui-cal-column">${tmp[1]}</div>
                <div class="w2ui-cal-column">${tmp[2]}</div>
            </div>
            ${options.btnNow ? `<div class="w2ui-cal-now">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Now')}</div>` : ''}
        </div>`;
            return {
                html: html
            };
        }
        // checks if date is in range (loost at start, end, blockDates, blockWeekdays)
        inRange(str, options, dateOnly) {
            let inRange = false;
            if (options.type === 'date') {
                let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(str, options.format, true);
                if (dt) {
                    // enable range
                    if (options.start || options.end) {
                        let st = typeof options.start === 'string' ? options.start : $aa2bd8933167d9cb$export$2fa187e846a241c4(options.start).val();
                        let en = typeof options.end === 'string' ? options.end : $aa2bd8933167d9cb$export$2fa187e846a241c4(options.end).val();
                        let start = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(st, options.format, true);
                        let end = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(en, options.format, true);
                        let current = new Date(dt);
                        if (!start) start = current;
                        if (!end) end = current;
                        if (current >= start && current <= end) inRange = true;
                    } else inRange = true;
                    // block predefined dates
                    if (Array.isArray(options.blockDates) && options.blockDates.includes(str)) inRange = false;
                    // block weekdays
                    if (Array.isArray(options.blockWeekdays) && options.blockWeekdays.includes(dt.getDay())) inRange = false;
                }
            } else if (options.type === 'time') {
                if (options.start || options.end) {
                    let tm = this.str2min(str);
                    let tm1 = this.str2min(options.start);
                    let tm2 = this.str2min(options.end);
                    if (!tm1) tm1 = tm;
                    if (!tm2) tm2 = tm;
                    if (tm >= tm1 && tm <= tm2) inRange = true;
                } else inRange = true;
            } else if (options.type === 'datetime') {
                let dt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(str, options.format, true);
                if (dt) {
                    let format = options.format.split('|').map((format)=>format.trim());
                    if (dateOnly) {
                        let date = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dt, format[0]);
                        let opts = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, options, {
                            type: 'date',
                            format: format[0]
                        });
                        if (this.inRange(date, opts)) inRange = true;
                    } else {
                        let time = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(dt, format[1]);
                        let opts = {
                            type: 'time',
                            format: format[1],
                            start: options.startTime,
                            end: options.endTime
                        };
                        if (this.inRange(time, opts)) inRange = true;
                    }
                }
            }
            return inRange;
        }
        // converts time into number of minutes since midnight -- '11:50am' => 710
        str2min(str) {
            if (typeof str !== 'string') return null;
            let tmp = str.split(':');
            if (tmp.length === 2) {
                tmp[0] = parseInt(tmp[0]);
                tmp[1] = parseInt(tmp[1]);
                if (str.indexOf('pm') !== -1 && tmp[0] !== 12) tmp[0] += 12;
                if (str.includes('am') && tmp[0] == 12) tmp[0] = 0 // 12:00am - is midnight
                ;
            } else return null;
            return tmp[0] * 60 + tmp[1];
        }
        // converts minutes since midnight into time str -- 710 => '11:50am'
        min2str(time, format) {
            let ret = '';
            if (time >= 1440) time = time % 1440;
            if (time < 0) time = 1440 + time;
            let hour = Math.floor(time / 60);
            let min = (time % 60 < 10 ? '0' : '') + time % 60;
            if (!format) format = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.timeFormat;
            if (format.indexOf('h24') !== -1) ret = hour + ':' + min;
            else ret = (hour <= 12 ? hour : hour - 12) + ':' + min + ' ' + (hour >= 12 ? 'pm' : 'am');
            return ret;
        }
    }
    let $aa2bd8933167d9cb$export$b876f801a4afd38f = new $aa2bd8933167d9cb$export$28c660c63b792dea();
    let $aa2bd8933167d9cb$export$3842f79f22e98342 = new $aa2bd8933167d9cb$var$MenuTooltip();
    let $aa2bd8933167d9cb$export$550f94414263c7a1 = new $aa2bd8933167d9cb$var$ColorTooltip();
    let $aa2bd8933167d9cb$export$888613f6d1a8fc97 = new $aa2bd8933167d9cb$var$DateTooltip();
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: mQuery, w2utils, w2base, w2tooltip, w2color, w2menu
 *
 * == TODO ==
 *  - tab navigation (index state)
 *  - vertical toolbar
 *  - w2menu on second click of tb button should hide
 *  - button display groups for each show/hide, possibly add state: { single: t/f, multiple: t/f, type: 'font' }
 *  - item.count - should just support html, so a custom block can be created, such as a colored line
 *
 * == 2.0 changes
 *  - CSP - fixed inline events
 *  - removed jQuery dependency
 *  - item.icon - can be class or <custom-icon-component> or <svg>
 *  - new w2tooltips and w2menu
 *  - scroll returns promise
 *  - added onMouseEntter, onMouseLeave, onMouseDown, onMouseUp events
 *  - add(..., skipRefresh), insert(..., skipRefresh)
 *  - item.items can be a function
 *  - item.icon_style - style for the icon
 *  - item.icon - can be a function
 *  - item.type = 'label', item.type = 'input'
 *  - item.placeholder
 *  - item.spinner: { style, min, max, step, precision, suffix }
 *  - item.backColor
 */ class $aa2bd8933167d9cb$export$d1962123e55f7d10 extends $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        constructor(options){
            super(options.name);
            this.box = null // DOM Element that holds the element
            ;
            this.name = null // unique name for w2ui
            ;
            this.routeData = {} // data for dynamic routes
            ;
            this.items = [];
            this.right = '' // HTML text on the right of toolbar
            ;
            this.tooltip = 'top|left' // can be top, bottom, left, right
            ;
            this.onClick = null;
            this.onChange = null;
            this.onMouseDown = null;
            this.onMouseUp = null;
            this.onMouseEnter = null // mouse enter the button event
            ;
            this.onMouseLeave = null;
            this.onRender = null;
            this.onRefresh = null;
            this.onResize = null;
            this.onDestroy = null;
            this.item_template = {
                id: null,
                type: 'button',
                text: null,
                html: '',
                tooltip: null,
                count: null,
                hidden: false,
                disabled: false,
                checked: false,
                icon: null,
                route: null,
                arrow: null,
                style: null,
                group: null,
                items: null,
                selected: null,
                color: null,
                backColor: null,
                overlay: {
                    anchorClass: ''
                },
                onClick: null,
                onRefresh: null
            };
            this.last = {
                badge: {},
                pendingRefresh: {} // what should be refreshed with a debounce
            };
            /**
         * This _refresh function is needed for speed. It will store what should be refreshed in this.last.refesh
         * obect and then call _refreshDebounced(), which will do it withing 15 ms. However, if new items are added
         * they will not cause multiple unnecessary refreshes
         */ this._refresh = ({ effected: effected, resize: resize, refreshTooltip: refreshTooltip })=>{
                let options = this.last.pendingRefresh;
                options.ids ??= [];
                options.ids.push(...effected);
                Object.assign(options, {
                    resize: resize,
                    refreshTooltip: refreshTooltip
                });
                this._refreshDebounced();
            };
            this._refreshDebounced = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.debounce(()=>{
                let options = this.last.pendingRefresh;
                // new Set will make array unique
                new Set(options.ids).forEach((id)=>{
                    this.refresh(id);
                    if (options.hideTooltip) this.tooltipHide(id);
                });
                if (options.resize) this.resize();
                // once refresh is complete, then clear refresh object
                this.last.pendingRefresh = {};
            }, 15);
            // mix in options, w/o items
            let items = options.items;
            delete options.items;
            Object.assign(this, options);
            // add item via method to makes sure item_template is applied
            if (Array.isArray(items)) this.add(items, true);
            // need to reassign back to keep it in config
            options.items = items;
            // render if box specified
            if (typeof this.box == 'string') this.box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0);
            if (this.box) this.render(this.box);
        }
        add(items, skipRefresh) {
            this.insert(null, items, skipRefresh);
        }
        insert(id, items, skipRefresh) {
            if (!Array.isArray(items)) items = [
                items
            ];
            items.forEach((item, idx, arr)=>{
                if (typeof item === 'string') item = arr[idx] = {
                    id: item,
                    text: item
                };
                // checks
                let valid = [
                    'button',
                    'check',
                    'radio',
                    'drop',
                    'menu',
                    'menu-radio',
                    'menu-check',
                    'color',
                    'text-color',
                    'html',
                    'label',
                    'input',
                    'group',
                    'break',
                    'spacer',
                    'new-line'
                ];
                if (!valid.includes(String(item.type))) {
                    console.log('ERROR: The parameter "type" should be one of the following:', valid, `, but ${item.type} is supplied.`, item);
                    return;
                }
                if (item.id == null && ![
                    'break',
                    'spacer',
                    'new-line'
                ].includes(item.type)) {
                    console.log('ERROR: The parameter "id" is required but not supplied.', item);
                    return;
                }
                if (item.type == null) {
                    console.log('ERROR: The parameter "type" is required but not supplied.', item);
                    return;
                }
                if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.checkUniqueId(item.id, this.items, 'toolbar', this.name)) return;
                // add item
                let newItem = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.item_template, item);
                if (newItem.type == 'menu-check') {
                    if (!Array.isArray(newItem.selected)) newItem.selected = [];
                    if (Array.isArray(newItem.items)) newItem.items.forEach((it)=>{
                        if (typeof it === 'string') it = arr[idx] = {
                            id: it,
                            text: it
                        };
                        if (it.checked && !newItem.selected.includes(it.id)) newItem.selected.push(it.id);
                        if (!it.checked && newItem.selected.includes(it.id)) it.checked = true;
                        if (it.checked == null) it.checked = false;
                    });
                } else if (newItem.type == 'menu-radio') {
                    if (Array.isArray(newItem.items)) newItem.items.forEach((it, idx, arr)=>{
                        if (typeof it === 'string') it = arr[idx] = {
                            id: it,
                            text: it
                        };
                        if (it.checked && newItem.selected == null) newItem.selected = it.id;
                        else it.checked = false;
                        if (!it.checked && newItem.selected == it.id) it.checked = true;
                        if (it.checked == null) it.checked = false;
                    });
                }
                if (id == null) this.items.push(newItem);
                else {
                    let middle = this.get(id, true);
                    this.items = this.items.slice(0, middle).concat([
                        newItem
                    ], this.items.slice(middle));
                }
                newItem.line = newItem.line ?? 1;
                if (skipRefresh !== true) this.refresh(newItem.id);
            });
            if (skipRefresh !== true) this.resize();
        }
        remove() {
            let effected = 0;
            Array.from(arguments).forEach((item)=>{
                let it = this.get(item);
                if (!it || String(item).indexOf(':') != -1) return;
                effected++;
                // remove from screen
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tb_' + this.name + '_item_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(it.id)).remove();
                // remove from array
                let ind = this.get(it.id, true);
                if (ind != null) this.items.splice(ind, 1);
            });
            this.resize();
            return effected;
        }
        set(id, newOptions) {
            let item = this.get(id);
            if (item == null) return false;
            Object.assign(item, newOptions);
            this.refresh(String(id).split(':')[0]);
            return true;
        }
        get(id, returnIndex, items) {
            if (arguments.length === 0) {
                let all = [];
                for(let i1 = 0; i1 < this.items.length; i1++){
                    let it = this.items[i1];
                    if (it.id != null) all.push(it.id);
                    if (it.type == 'group') {
                        for(let i2 = 0; i2 < it.items.length; i2++)if (it.items[i2].id != null) all.push(it.items[i2].id);
                    }
                }
                return all;
            }
            let tmp = String(id).split(':');
            if (items == null) items = this.items;
            for(let i1 = 0; i1 < items.length; i1++){
                let it = items[i1];
                // find a menu item
                if ([
                    'menu',
                    'menu-radio',
                    'menu-check'
                ].includes(it.type) && tmp.length == 2 && it.id == tmp[0]) {
                    let subItems = it.items;
                    if (typeof subItems == 'function') subItems = subItems(this);
                    for(let i = 0; i < subItems.length; i++){
                        let item = subItems[i];
                        if (item.id == tmp[1] || item.id == null && item.text == tmp[1]) {
                            if (returnIndex == true) return i;
                            else return item;
                        }
                        if (Array.isArray(item.items)) {
                            for(let j = 0; j < item.items.length; j++)if (item.items[j].id == tmp[1] || item.items[j].id == null && item.items[j].text == tmp[1]) {
                                if (returnIndex == true) return i;
                                else return item.items[j];
                            }
                        }
                    }
                } else if (it.id == tmp[0]) {
                    if (returnIndex == true) return i1;
                    else return it;
                } else if (it.type == 'group') {
                    let sub = this.get(id, returnIndex, it.items);
                    if (sub != null) return sub;
                }
            }
            return null;
        }
        setCount(id, count, className, style) {
            let btn = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#tb_${this.name}_item_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)} .w2ui-tb-count > span`);
            if (btn.length > 0) {
                btn.removeClass().addClass(className ?? '').text(count).get(0).style.cssText = style ?? '';
                this.last.badge[id] = {
                    className: className ?? '',
                    style: style ?? ''
                };
                let item = this.get(id);
                item.count = count;
            } else {
                this.set(id, {
                    count: count
                });
                this.setCount(...arguments) // to update styles
                ;
            }
        }
        show() {
            let effected = [];
            Array.from(arguments).forEach((item)=>{
                let it = this.get(item);
                if (!it) return;
                // since group can have style, it should still be shown
                it.hidden = false;
                effected.push(String(item).split(':')[0]);
                if (it.type == 'group') it.items.forEach((itm)=>this.show(itm.id));
            });
            this._refresh({
                effected: effected,
                resize: true
            }) // debounced, needed for speed
            ;
            return effected;
        }
        hide() {
            let effected = [];
            Array.from(arguments).forEach((item)=>{
                let it = this.get(item);
                if (!it) return;
                // since group can have style, it should still be hidden
                it.hidden = true;
                effected.push(String(item).split(':')[0]);
                if (it.type == 'group') it.items.forEach((itm)=>this.hide(itm.id));
            });
            this._refresh({
                effected: effected,
                hideTooltip: true,
                resize: true
            }) // debounced, needed for speed
            ;
            return effected;
        }
        enable() {
            let effected = [];
            Array.from(arguments).forEach((item)=>{
                let it = this.get(item);
                if (!it) return;
                if (it.type == 'group') it.items.forEach((itm)=>this.enable(itm.id));
                else {
                    it.disabled = false;
                    effected.push(String(item).split(':')[0]);
                }
            });
            this._refresh({
                effected: effected
            }) // debounced, needed for speed
            ;
            return effected;
        }
        disable() {
            let effected = [];
            Array.from(arguments).forEach((item)=>{
                let it = this.get(item);
                if (!it) return;
                if (it.type == 'group') it.items.forEach((itm)=>this.disable(itm.id));
                else {
                    it.disabled = true;
                    effected.push(String(item).split(':')[0]);
                }
            });
            this._refresh({
                effected: effected,
                hideTooltip: true
            }) // debounced, needed for speed
            ;
            return effected;
        }
        check() {
            let effected = [];
            Array.from(arguments).forEach((item)=>{
                let it = this.get(item);
                if (!it || String(item).indexOf(':') != -1) return;
                if (it.type == 'group') it.items.forEach((itm)=>this.check(itm.id));
                else {
                    it.checked = true;
                    effected.push(String(item).split(':')[0]);
                }
            });
            this._refresh({
                effected: effected
            }) // debounced, needed for speed
            ;
            return effected;
        }
        uncheck() {
            let effected = [];
            Array.from(arguments).forEach((item)=>{
                let it = this.get(item);
                if (!it || String(item).indexOf(':') != -1) return;
                // remove overlay
                if ([
                    'menu',
                    'menu-radio',
                    'menu-check',
                    'drop',
                    'color',
                    'text-color'
                ].includes(it.type) && it.checked) $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-drop');
                if (it.type == 'group') it.items.forEach((itm)=>this.uncheck(itm.id));
                else {
                    it.checked = false;
                    effected.push(String(item).split(':')[0]);
                }
            });
            this._refresh({
                effected: effected
            }) // debounced, needed for speed
            ;
            return effected;
        }
        click(id, event1) {
            // click on menu items
            let tmp = String(id).split(':');
            let it = this.get(tmp[0]);
            let items = it && it.items ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, it.items, it) : [];
            if (tmp.length > 1) {
                let subItem = this.get(id);
                if (subItem && !subItem.disabled) this.menuClick({
                    name: this.name,
                    item: it,
                    subItem: subItem,
                    originalEvent: event1
                });
                return;
            }
            if (it && !it.disabled) {
                // event before
                let edata = this.trigger('click', {
                    target: id != null ? id : this.name,
                    item: it,
                    object: it,
                    originalEvent: event1
                });
                if (edata.isCancelled === true) return;
                // read items again, they might have been changed in the click event handler
                items = it && it.items ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, it.items, it) : [];
                let btn = '#tb_' + this.name + '_item_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(it.id);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(btn).removeClass('down') // need to re-query at the moment -- as well as elsewhere in this function
                ;
                if (it.type == 'radio') {
                    for(let i = 0; i < this.items.length; i++){
                        let itt = this.items[i];
                        if (itt.type == 'group') for(let i1 = 0; i1 < itt.items.length; i1++){
                            let itt1 = itt.items[i1];
                            if (itt1 == null || itt1.id == it.id || itt1.type !== 'radio') continue;
                            if (itt1.group == it.group && itt1.checked) {
                                itt1.checked = false;
                                this.refresh(itt1.id);
                            }
                        }
                        if (itt == null || itt.id == it.id || itt.type !== 'radio') continue;
                        if (itt.group == it.group && itt.checked) {
                            itt.checked = false;
                            this.refresh(itt.id);
                        }
                    }
                    it.checked = true;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(btn).addClass('checked');
                }
                if ([
                    'menu',
                    'menu-radio',
                    'menu-check',
                    'drop',
                    'color',
                    'text-color'
                ].includes(it.type)) {
                    this.tooltipHide(id);
                    if (it.checked) {
                        $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-drop');
                        return;
                    } else setTimeout(()=>{
                        let hideDrop = (id, btn)=>{
                            // need a closure to capture id variable
                            let self1 = this;
                            return function() {
                                self1.set(id, {
                                    checked: false
                                });
                            };
                        };
                        let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tb_' + this.name + '_item_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(it.id));
                        if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(it.overlay)) it.overlay = {};
                        if (it.type == 'drop') $aa2bd8933167d9cb$export$b876f801a4afd38f.show($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                            html: it.html,
                            class: 'w2ui-white',
                            hideOn: [
                                'doc-click'
                            ]
                        }, it.overlay, {
                            anchor: el[0],
                            name: this.name + '-drop',
                            data: {
                                item: it,
                                btn: btn
                            }
                        })).hide(hideDrop(it.id, btn));
                        if ([
                            'menu',
                            'menu-radio',
                            'menu-check'
                        ].includes(it.type)) {
                            let menuType = 'normal';
                            if (it.type == 'menu-radio') {
                                menuType = 'radio';
                                items.forEach((item)=>{
                                    if (it.selected == item.id) item.checked = true;
                                    else item.checked = false;
                                });
                            }
                            if (it.type == 'menu-check') {
                                menuType = 'check';
                                items.forEach((item)=>{
                                    if (Array.isArray(it.selected) && it.selected.includes(item.id)) item.checked = true;
                                    else item.checked = false;
                                });
                            }
                            $aa2bd8933167d9cb$export$3842f79f22e98342.show($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                                items: items,
                                align: it.text ? 'left' : 'none'
                            }, it.overlay, {
                                type: menuType,
                                name: this.name + '-drop',
                                anchor: el[0],
                                data: {
                                    item: it,
                                    btn: btn
                                }
                            })).hide(hideDrop(it.id, btn)).remove((event1)=>{
                                this.menuClick({
                                    name: this.name,
                                    remove: true,
                                    item: it,
                                    subItem: event1.detail.item,
                                    originalEvent: event1
                                });
                            }).select((event1)=>{
                                this.menuClick({
                                    name: this.name,
                                    item: it,
                                    subItem: event1.detail.item,
                                    originalEvent: event1
                                });
                            });
                        }
                        if ([
                            'color',
                            'text-color'
                        ].includes(it.type)) $aa2bd8933167d9cb$export$550f94414263c7a1.show($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                            color: it.color
                        }, it.overlay, {
                            anchor: el[0],
                            name: this.name + '-drop',
                            data: {
                                item: it,
                                btn: btn
                            }
                        })).hide(hideDrop(it.id, btn)).select((event1)=>{
                            if (event1.detail.color != null) this.colorClick({
                                name: this.name,
                                item: it,
                                color: event1.detail.color
                            });
                        });
                    }, 0);
                }
                if ([
                    'check',
                    'menu',
                    'menu-radio',
                    'menu-check',
                    'drop',
                    'color',
                    'text-color'
                ].includes(it.type)) {
                    it.checked = !it.checked;
                    if (it.checked) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(btn).addClass('checked');
                    else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(btn).removeClass('checked');
                }
                // route processing
                if (it.route) {
                    let route = String('/' + it.route).replace(/\/{2,}/g, '/');
                    let info = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseRoute(route);
                    if (info.keys.length > 0) for(let k = 0; k < info.keys.length; k++)route = route.replace(new RegExp(':' + info.keys[k].name, 'g'), this.routeData[info.keys[k].name]);
                    setTimeout(()=>{
                        window.location.hash = route;
                    }, 1);
                }
                // need to refresh toolbar as it might be dynamic
                this.tooltipShow(id);
                // event after
                edata.finish();
            }
        }
        scroll(direction, line, instant) {
            return new Promise((resolve, reject)=>{
                let scrollBox = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`.w2ui-tb-line:nth-child(${line}) .w2ui-scroll-wrapper`);
                let scrollLeft = scrollBox.get(0).scrollLeft;
                let right = scrollBox.find('.w2ui-tb-right').get(0);
                let width1 = scrollBox.parent().get(0).getBoundingClientRect().width;
                let width2 = scrollLeft + parseInt(right.offsetLeft) + parseInt(right.clientWidth);
                switch(direction){
                    case 'left':
                        scroll = scrollLeft - width1 + 50 // 35 is width of both button
                        ;
                        if (scroll <= 0) scroll = 0;
                        scrollBox.get(0).scrollTo({
                            top: 0,
                            left: scroll,
                            behavior: instant ? 'atuo' : 'smooth'
                        });
                        break;
                    case 'right':
                        scroll = scrollLeft + width1 - 50 // 35 is width of both button
                        ;
                        if (scroll >= width2 - width1) scroll = width2 - width1;
                        scrollBox.get(0).scrollTo({
                            top: 0,
                            left: scroll,
                            behavior: instant ? 'atuo' : 'smooth'
                        });
                        break;
                }
                /**
             * Timeout is needed because browser animates scroll. Also, I found that 500ms is not enough
             * as it could take longer then that, but animation seems to be around 500ms
             */ setTimeout(()=>{
                    this.resize();
                    resolve();
                }, instant ? 0 : 600);
            });
        }
        render(box) {
            let time = Date.now();
            if (typeof box == 'string') box = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).get(0);
            // event before
            let edata = this.trigger('render', {
                target: this.name,
                box: box ?? this.box
            });
            if (edata.isCancelled === true) return;
            // defaul action
            if (box != null) {
                this.unmount() // clean previous control
                ;
                this.box = box;
            }
            if (!this.box) return;
            if (!Array.isArray(this.right)) this.right = [
                this.right
            ];
            // render all buttons
            let html = '';
            let line = 0;
            for(let i = 0; i < this.items.length; i++){
                let it = this.items[i];
                if (it == null) continue;
                if (it.id == null) it.id = 'item_' + i;
                if (it.caption != null) console.log('NOTICE: toolbar item.caption property is deprecated, please use item.text. Item -> ', it);
                if (it.hint != null) console.log('NOTICE: toolbar item.hint property is deprecated, please use item.tooltip. Item -> ', it);
                if (i === 0 || it.type == 'new-line') {
                    line++;
                    html += `
                    <div class="w2ui-tb-line">
                        <div class="w2ui-scroll-wrapper w2ui-eaction" data-mousedown="resize">
                            <div class="w2ui-tb-right">${this.right[line - 1] ?? ''}</div>
                        </div>
                        <div class="w2ui-scroll-left w2ui-eaction" data-click='["scroll", "left", "${line}"]'></div>
                        <div class="w2ui-scroll-right w2ui-eaction" data-click='["scroll", "right", "${line}"]'></div>
                    </div>
                `;
                }
                it.line = line;
            }
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).attr('name', this.name).addClass('w2ui-reset w2ui-toolbar').html(html);
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box)[0].style.cssText += this.style;
            // overflow buttons
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-tb-line .w2ui-eaction'), this);
            // observe div resize
            this.last.observeResize = new ResizeObserver(()=>{
                this.resize();
            });
            this.last.observeResize.observe(this.box);
            // refresh all
            this.refresh();
            this.resize();
            // event after
            edata.finish();
            return Date.now() - time;
        }
        refresh(id) {
            let time = Date.now();
            // event before
            let edata = this.trigger('refresh', {
                target: id != null ? id : this.name,
                item: this.get(id)
            });
            if (edata.isCancelled === true) return;
            let edata2;
            // refresh all
            if (id == null) {
                for(let i = 0; i < this.items.length; i++){
                    let it1 = this.items[i];
                    if (it1.id == null) it1.id = 'item_' + i;
                    this.refresh(it1.id);
                }
                return;
            }
            // create or refresh only one item
            let it = this.get(id);
            if (it == null) return false;
            if (typeof it.onRefresh == 'function') {
                edata2 = this.trigger('refresh', {
                    target: id,
                    item: it,
                    object: it
                });
                if (edata2.isCancelled === true) return;
            }
            let selector = `#tb_${this.name}_item_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(it.id)}`;
            let btn = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(selector);
            let html = this.getItemHTML(it);
            // hide tooltip
            this.tooltipHide(id);
            // if there is a spacer, then right HTML is not 100%
            if (it.type == 'spacer') $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`.w2ui-tb-line:nth-child(${it.line}`).find('.w2ui-tb-right').css('width', 'auto');
            if (btn.length === 0) {
                let next = parseInt(this.get(id, true)) + 1;
                let $next = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#tb_${this.name}_item_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(this.items[next] ? this.items[next].id : '')}`);
                if ($next.length == 0) $next = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`.w2ui-tb-line:nth-child(${it.line}`).find('.w2ui-tb-right').before(html);
                else $next.after(html);
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`${selector}, ${selector} .w2ui-eaction`), this);
            } else {
                // refresh
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(selector).replace($aa2bd8933167d9cb$export$2fa187e846a241c4.html(html));
                let newBtn = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(selector);
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(newBtn, this);
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(newBtn.find('.w2ui-eaction'), this);
                // update overlay's anchor if changed
                let overlays = $aa2bd8933167d9cb$export$b876f801a4afd38f.get(true);
                Object.keys(overlays).forEach((key)=>{
                    if (overlays[key].anchor == btn.get(0)) overlays[key].anchor = newBtn.get(0);
                });
            }
            if ([
                'menu',
                'menu-radio',
                'menu-check'
            ].includes(it.type) && it.checked) {
                // check selected items
                let selected = Array.isArray(it.selected) ? it.selected : [
                    it.selected
                ];
                let items = typeof it.items == 'function' ? it.items(it) : [
                    ...it.items
                ];
                items.forEach((item)=>{
                    if (selected.includes(item.id)) item.checked = true;
                    else item.checked = false;
                });
                $aa2bd8933167d9cb$export$3842f79f22e98342.update(this.name + '-drop', items);
            }
            // event after
            if (typeof it.onRefresh == 'function') edata2.finish();
            edata.finish();
            return Date.now() - time;
        }
        resize() {
            let time = Date.now();
            // event before
            let edata = this.trigger('resize', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-tb-line').each((el)=>{
                // show hide overflow buttons
                let box = $aa2bd8933167d9cb$export$2fa187e846a241c4(el);
                box.find('.w2ui-scroll-left, .w2ui-scroll-right').hide();
                let scrollBox = box.find('.w2ui-scroll-wrapper').get(0);
                let $right = box.find('.w2ui-tb-right');
                let boxWidth = box.get(0).getBoundingClientRect().width;
                // Do not use $right[0].getBoundingClientRect(). right box is the most left div
                let itemsWidth = $right.length > 0 ? $right[0].offsetLeft + $right[0].clientWidth : 0;
                if (boxWidth < itemsWidth) {
                    // we have overflown content
                    if (scrollBox.scrollLeft > 0) box.find('.w2ui-scroll-left').show();
                    if (boxWidth < itemsWidth - scrollBox.scrollLeft) box.find('.w2ui-scroll-right').show();
                }
            });
            // event after
            edata.finish();
            return Date.now() - time;
        }
        destroy() {
            // event before
            let edata = this.trigger('destroy', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // clean up
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-scroll-wrapper').length > 0) this.unmount();
            delete $aa2bd8933167d9cb$export$dca4c93ccda43b77[this.name];
            // event after
            edata.finish();
        }
        unmount() {
            super.unmount();
            this.last.observeResize?.disconnect();
        }
        // ========================================
        // --- Internal Functions
        getItemHTML(item) {
            let html = '';
            if (item.caption != null && item.text == null) item.text = item.caption // for backward compatibility
            ;
            if (item.text == null) item.text = '';
            if (item.tooltip == null && item.hint != null) item.tooltip = item.hint // for backward compatibility
            ;
            if (item.tooltip == null) item.tooltip = '';
            if (typeof item.get !== 'function' && (Array.isArray(item.items) || typeof item.items == 'function')) item.get = function get(id) {
                let tmp = item.items;
                if (typeof tmp == 'function') tmp = item.items(item);
                return tmp.find((it)=>it.id == id ? true : false);
            };
            let icon = '';
            let text = typeof item.text == 'function' ? item.text.call(this, item) : item.text;
            if (item.icon) {
                icon = item.icon;
                if (typeof item.icon == 'function') icon = item.icon.call(this, item);
                if (String(icon).slice(0, 1) !== '<') icon = `<span class="${icon}" ${item.icon_style ? `style="${item.icon_style}"` : ''}></span>`;
                icon = `<div class="w2ui-tb-icon">${icon}</div>`;
            }
            let classes = [
                'w2ui-tb-button',
                'w2ui-eaction'
            ];
            if (item.checked) classes.push('checked');
            if (item.disabled) classes.push('disabled');
            if (item.hidden) classes.push('hidden');
            if (!icon) classes.push('no-icon');
            switch(item.type){
                case 'color':
                case 'text-color':
                    if (typeof item.color == 'string') {
                        if (item.color.slice(0, 1) == '#') item.color = item.color.slice(1);
                        if ([
                            3,
                            6,
                            8
                        ].includes(item.color.length)) item.color = '#' + item.color;
                    }
                    if (item.type == 'color') text = `<span class="w2ui-tb-color-box" style="background-color: ${item.color != null ? item.color : '#fff'}"></span>
                           ${item.text ? `<div style="margin-left: 17px;">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(item.text)}</div>` : ''}`;
                    if (item.type == 'text-color') {
                        let color = item.color != null ? item.color : '#444';
                        let bcolor = item.backColor;
                        if (item.backColor === true) {
                            bcolor = '#fff';
                            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.colorContrast('#fff', color) < 2) bcolor = '#555';
                        }
                        text = `<span style="color: ${color}">${item.text ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(item.text) : item.backColor ? `<b style="background-color: ${bcolor ?? 'transparent'}; padding: 2px 5px; border-radius: 3px;">Ab</b>` : '<b>Ab</b>'}</span>`;
                    }
                case 'menu':
                case 'menu-check':
                case 'menu-radio':
                case 'button':
                case 'check':
                case 'radio':
                case 'label':
                case 'drop':
                    {
                        let arrow = item.arrow === true || item.arrow !== false && [
                            'menu',
                            'menu-radio',
                            'menu-check',
                            'drop',
                            'color',
                            'text-color'
                        ].includes(item.type);
                        html = `
                    <div id="tb_${this.name}_item_${item.id}" class="${classes.join(' ')} ${item.class ? item.class : ''}"
                        style="${item.hidden ? 'display: none' : ''} ${item.type == 'label' ? item.style ?? '' : ''}"
                        ${!item.disabled ? `data-click='["click","${item.id}"]'
                               data-mouseenter='["mouseAction", "event", "this", "Enter", "${item.id}"]'
                               data-mouseleave='["mouseAction", "event", "this", "Leave", "${item.id}"]'
                               data-mousedown='["mouseAction", "event", "this", "Down", "${item.id}"]'
                               data-mouseup='["mouseAction", "event", "this", "Up", "${item.id}"]'` : ''}
                    >
                        ${icon}
                        ${text != '' && text != null || item.count != null || arrow ? `<div class="w2ui-tb-text" style="${item.type != 'label' ? item.style ?? '' : ''}; ${!text ? 'padding-left: 0; margin-left: 23px;' : ''}">
                                    ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(text)}
                                    ${item.count != null ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripSpaces(`
                                            <span class="w2ui-tb-count">
                                                <span class="${this.last.badge[item.id] ? this.last.badge[item.id].className ?? '' : ''}"
                                                        style="${this.last.badge[item.id] ? this.last.badge[item.id].style ?? '' : ''}">${item.count}</span>
                                            </span>`) : ''}
                                    ${arrow ? `<span class="w2ui-tb-down" ${!text && !item.count ? 'style="margin-left: -3px"' : ''}><span></span></span>` : ''}
                                </div>` : ''}
                    </div>
                `;
                        break;
                    }
                case 'break':
                    html = `<div id="tb_${this.name}_item_${item.id}" class="w2ui-tb-break"
                            style="${item.hidden ? 'display: none' : ''}; ${item.style ? item.style : ''}">
                            &#160;
                        </div>`;
                    break;
                case 'spacer':
                    html = `<div id="tb_${this.name}_item_${item.id}" class="w2ui-tb-spacer"
                            style="${item.hidden ? 'display: none' : ''}; ${item.style ? item.style : ''}">
                        </div>`;
                    break;
                case 'html':
                    html = `<div id="tb_${this.name}_item_${item.id}" class="w2ui-tb-html ${classes.join(' ')}"
                            style="${item.hidden ? 'display: none' : ''}; ${item.style ? item.style : ''}">
                            ${typeof item.html == 'function' ? item.html.call(this, item) : item.html}
                        </div>`;
                    break;
                case 'input':
                    {
                        let ph = item.placeholder;
                        let val = item.value;
                        // round to step
                        if (val != null && String(val).trim() !== '' && item.spinner) {
                            let step = item.spinner?.step ?? 1;
                            let prec = item.spinner.precision ?? String(step).split('.')[1]?.length ?? 0;
                            val = val.toFixed(prec);
                        }
                        html = `<div id="tb_${this.name}_item_${item.id}" class="w2ui-tb-input w2ui-eaction ${classes.join(' ')}"
                            style="${item.hidden ? 'display: none' : ''}; ${item.style ? item.style : ''}"
                        >
                            <span class="w2ui-input-label">${item.text ?? ''}</span>
                            ${item.spinner ? `<span class="w2ui-spinner-dec w2ui-eaction" data-click='["spinner", "${item.id}", "dec", "event"]'> \u{2013} </span>` : ''}
                            <input class="w2ui-toolbar-input w2ui-eaction ${item.spinner ? 'w2ui-has-spinner' : ''}"
                                ${ph ? `placeholder="${ph}"` : ''} style="${item.spinner?.style ?? ''}" value="${val ?? ''}${item.spinner?.suffix ?? ''}"
                                data-change='["change", "${item.id}", "this"]'
                                data-keydown='["spinner", "${item.id}", "key", "event"]'
                                data-mouseenter='["mouseAction", "event", "this", "Enter", "${item.id}"]'
                                data-mouseleave='["mouseAction", "event", "this", "Leave", "${item.id}"]'
                            >
                            ${item.spinner ? `<span class="w2ui-spinner-inc w2ui-eaction" data-click='["spinner", "${item.id}", "inc", "event"]'> + </span>` : ''}
                        </div>`;
                        break;
                    }
                case 'group':
                    html = `<div id="tb_${this.name}_item_${item.id}" class="w2ui-tb-group"
                    style="display: flex; ${item.hidden ? 'display: none' : ''}; ${item.style ? item.style : ''}">`;
                    if (Array.isArray(item.items)) item.items.forEach((it)=>{
                        html += this.getItemHTML(it);
                    });
                    else console.log('ERROR: toolbar group is empty');
                    html += '</div>';
            }
            return html;
        }
        spinner(id, action, event1) {
            let it = this.get(id);
            let inc = 0;
            switch(action){
                case 'inc':
                    inc = it.spinner?.step ?? 1;
                    break;
                case 'dec':
                    inc = -(it.spinner?.step ?? 1);
                    break;
                case 'key':
                    if (it.spinner) {
                        let mult = 1;
                        if (event1.shiftKey || event1.metaKey) mult = 10;
                        if (event1.altKey) mult = 0.1;
                        switch(event1.key){
                            case 'ArrowUp':
                                inc = (it.spinner?.step ?? 1) * mult;
                                event1.preventDefault();
                                break;
                            case 'ArrowDown':
                                inc = -(it.spinner?.step ?? 1) * mult;
                                event1.preventDefault();
                                break;
                        }
                    }
                    break;
            }
            if (inc !== 0) this.change(id, (it.value ?? 0) + inc);
        }
        change(id, value) {
            let it = this.get(id);
            let input = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tb_' + this.name + '_item_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)).find('input.w2ui-toolbar-input');
            if (value instanceof HTMLInputElement) value = value.value;
            if (value == null) value = input.val();
            if (it.spinner) value = parseFloat(value);
            // min/max
            if (it.spinner?.min != null && it.spinner.min > value) value = it.spinner.min;
            if (it.spinner?.max != null && it.spinner.max < value) value = it.spinner.max;
            // round to step
            if (it.spinner) {
                if (isNaN(value)) value = it.spinner.min ?? 0;
                let step = it.spinner?.step ?? 1;
                let prec = it.spinner.precision ?? String(step).split('.')[1]?.length ?? 0;
                value = value.toFixed(prec);
            }
            // event beofre
            let edata = this.trigger('change', {
                target: id,
                id: id,
                value: value,
                item: it
            });
            if (edata.isCancelled) return;
            it.value = it.spinner ? parseFloat(value) : value;
            input.val(value + (it.spinner?.suffix ?? ''));
            // event after
            edata.finish();
        }
        tooltipShow(id) {
            if (this.tooltip == null) return;
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tb_' + this.name + '_item_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)).get(0);
            let item = this.get(id);
            let overlay = typeof this.tooltip == 'string' ? {
                position: this.tooltip
            } : this.tooltip;
            let txt = item.tooltip;
            if (typeof txt == 'function') txt = txt.call(this, item);
            // not for opened drop downs
            if ([
                'menu',
                'menu-radio',
                'menu-check',
                'drop',
                'color',
                'text-color'
            ].includes(item.type) && item.checked == true) return;
            $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                anchor: el,
                name: this.name + '-tooltip',
                html: txt,
                ...overlay
            });
            return;
        }
        tooltipHide(id) {
            if (this.tooltip == null) return;
            $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-tooltip');
        }
        menuClick(event1) {
            if (event1.item && !event1.item.disabled) {
                // event before
                let edata = this.trigger(event1.remove !== true ? 'click' : 'remove', {
                    target: event1.item.id + ':' + event1.subItem.id,
                    item: event1.item,
                    subItem: event1.subItem,
                    originalEvent: event1.originalEvent
                });
                if (edata.isCancelled === true) return;
                // route processing
                let it = event1.subItem;
                let item = this.get(event1.item.id);
                let items = item.items;
                if (typeof items == 'function') items = item.items();
                if (item.type == 'menu') item.selected = it.id;
                if (item.type == 'menu-radio') {
                    item.selected = it.id;
                    if (Array.isArray(items)) items.forEach((item)=>{
                        if (item.checked === true) delete item.checked;
                        if (Array.isArray(item.items)) item.items.forEach((item)=>{
                            if (item.checked === true) delete item.checked;
                        });
                    });
                    it.checked = true;
                }
                if (item.type == 'menu-check') {
                    if (!Array.isArray(item.selected)) item.selected = [];
                    if (it.group == null) {
                        let ind = item.selected.indexOf(it.id);
                        if (ind == -1) {
                            item.selected.push(it.id);
                            it.checked = true;
                        } else {
                            item.selected.splice(ind, 1);
                            it.checked = false;
                        }
                    } else if (it.group === false) ;
                    else {
                        let unchecked = [];
                        let ind = item.selected.indexOf(it.id);
                        let checkNested = (items)=>{
                            items.forEach((sub)=>{
                                if (sub.group === it.group) {
                                    let ind = item.selected.indexOf(sub.id);
                                    if (ind != -1) {
                                        if (sub.id != it.id) unchecked.push(sub.id);
                                        item.selected.splice(ind, 1);
                                    }
                                }
                                if (Array.isArray(sub.items)) checkNested(sub.items);
                            });
                        };
                        checkNested(items);
                        if (ind == -1) {
                            item.selected.push(it.id);
                            it.checked = true;
                        }
                    }
                }
                if (typeof it.route == 'string') {
                    let route = it.route !== '' ? String('/' + it.route).replace(/\/{2,}/g, '/') : '';
                    let info = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseRoute(route);
                    if (info.keys.length > 0) for(let k = 0; k < info.keys.length; k++){
                        if (this.routeData[info.keys[k].name] == null) continue;
                        route = route.replace(new RegExp(':' + info.keys[k].name, 'g'), this.routeData[info.keys[k].name]);
                    }
                    setTimeout(()=>{
                        window.location.hash = route;
                    }, 1);
                }
                this.refresh(event1.item.id);
                // event after
                edata.finish();
            }
        }
        colorClick(event1) {
            let obj = this;
            if (event1.item && !event1.item.disabled) {
                // event before
                let edata = this.trigger('click', {
                    target: event1.item.id,
                    item: event1.item,
                    color: event1.color,
                    final: true
                });
                if (edata.isCancelled === true) return;
                // default behavior
                event1.item.color = event1.color;
                obj.refresh(event1.item.id);
                // event after
                edata.finish();
            }
        }
        mouseAction(event1, target, action, id) {
            let btn = this.get(id);
            let edata = this.trigger('mouse' + action, {
                target: id,
                item: btn,
                object: btn,
                originalEvent: event1
            });
            if (edata.isCancelled === true || btn.disabled || btn.hidden) return;
            switch(action){
                case 'Enter':
                    if (![
                        'label',
                        'input'
                    ].includes(btn.type)) $aa2bd8933167d9cb$export$2fa187e846a241c4(target).addClass('over');
                    this.tooltipShow(id);
                    break;
                case 'Leave':
                    if (![
                        'label',
                        'input'
                    ].includes(btn.type)) $aa2bd8933167d9cb$export$2fa187e846a241c4(target).removeClass('over down');
                    this.tooltipHide(id);
                    break;
                case 'Down':
                    if (![
                        'label',
                        'input'
                    ].includes(btn.type)) $aa2bd8933167d9cb$export$2fa187e846a241c4(target).addClass('down');
                    break;
                case 'Up':
                    if (![
                        'label',
                        'input'
                    ].includes(btn.type)) $aa2bd8933167d9cb$export$2fa187e846a241c4(target).removeClass('down');
                    break;
            }
            edata.finish();
        }
    }
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: mQuery, w2utils, w2base, w2tooltip, w2menu
 *
 * == TODO ==
 *  - dbl click should be like it is in grid (with timer not HTML dbl click event)
 *  - node.style is misleading - should be there to apply color for example
 *  - node.plus - is not working
 *
 * == 2.0 changes
 *  - remove jQuery dependency
 *  - deprecarted obj.img, node.img
 *  - CSP - fixed inline events
 *  - observeResize for the box
 *  - search(..., compare) - comparison function
 *  - editable = true
 *  - edit(id) - new method
 *  - onEdit, onRename - new events
 *  - reorder = true - to allow reorder
 *  - mouseDown - for reorder
 *  - onReorder, onDragStart, onDragOver - events
 *  - this.mutlti - for multi select
 *  - onSelect, onUnselect - new events
 *  - prev(), next()
 */ class $aa2bd8933167d9cb$export$1d3b0f2412473663 extends $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        constructor(options){
            super(options.name);
            this.name = null;
            this.box = null;
            this.sidebar = null;
            this.parent = null;
            this.nodes = [] // Sidebar child nodes
            ;
            this.menu = [];
            this.routeData = {} // data for dynamic routes
            ;
            this.selected = null // current selected node (readonly)
            ;
            this.icon = null;
            this.style = '';
            this.topHTML = '';
            this.bottomHTML = '';
            this.multi = false;
            this.editable = false;
            this.reorder = false;
            this.flatButton = false;
            this.keyboard = true;
            this.flat = false;
            this.hasFocus = false;
            this.levelPadding = 12;
            this.toggleAlign = 'right' // can be left or right
            ;
            this.skipRefresh = false;
            this.tabIndex = null // will only be set if > 0 and not null
            ;
            this.handle = {
                width: 0,
                style: '',
                text: '',
                tooltip: ''
            }, this.badge = null;
            this.onClick = null // Fire when user click on Node Text
            ;
            this.onSelect = null;
            this.onUnselect = null;
            this.onDblClick = null // Fire when user dbl clicks
            ;
            this.onMouseEnter = null // mouse enter/leave over an item
            ;
            this.onMouseLeave = null;
            this.onContextMenu = null;
            this.onMenuClick = null // when context menu item selected
            ;
            this.onExpand = null // Fire when node expands
            ;
            this.onCollapse = null // Fire when node collapses
            ;
            this.onKeydown = null;
            this.onRender = null;
            this.onRefresh = null;
            this.onResize = null;
            this.onDestroy = null;
            this.onFocus = null;
            this.onBlur = null;
            this.onFlat = null;
            this.onEdit = null;
            this.onRename = null;
            this.onReorder = null;
            this.onDragStart = null;
            this.onDragOver = null;
            this.node_template = {
                id: null,
                text: '',
                order: null,
                count: null,
                icon: null,
                nodes: [],
                style: '',
                route: null,
                selected: false,
                expanded: false,
                hidden: false,
                disabled: false,
                group: false,
                groupShowHide: true,
                collapsible: false,
                plus: false,
                childOffset: 0,
                // events
                onClick: null,
                onDblClick: null,
                onContextMenu: null,
                onExpand: null,
                onCollapse: null,
                // internal
                parent: null,
                sidebar: null
            };
            this.last = {
                badge: {},
                renaming: false,
                move: null
            };
            let nodes = options.nodes;
            delete options.nodes;
            // mix in options
            Object.assign(this, options);
            // add item via method to makes sure item_template is applied
            if (Array.isArray(nodes)) this.add(nodes);
            // need to reassign back to keep it in config
            options.nodes = nodes;
            // render if box specified
            if (typeof this.box == 'string') this.box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0);
            if (this.box) this.render(this.box);
        }
        add(parent, nodes) {
            if (arguments.length == 1) {
                // need to be in reverse order
                nodes = arguments[0];
                parent = this;
            }
            if (typeof parent == 'string') parent = this.get(parent);
            if (parent == null || parent == '') parent = this;
            return this.insert(parent, null, nodes);
        }
        insert(parent, before, nodes) {
            let txt, ind, tmp, node1, nd;
            if (arguments.length == 2 && typeof parent == 'string') {
                // need to be in reverse order
                nodes = arguments[1];
                before = arguments[0];
                if (before != null) {
                    ind = this.get(before);
                    if (ind == null) {
                        if (!Array.isArray(nodes)) nodes = [
                            nodes
                        ];
                        if (nodes[0].caption != null && nodes[0].text == null) {
                            console.log('NOTICE: sidebar node.caption property is deprecated, please use node.text. Node -> ', nodes[0]);
                            nodes[0].text = nodes[0].caption;
                        }
                        txt = nodes[0].text;
                        console.log('ERROR: Cannot insert node "' + txt + '" because cannot find node "' + before + '" to insert before.');
                        return null;
                    }
                    parent = this.get(before).parent;
                } else parent = this;
            }
            if (typeof parent == 'string') parent = this.get(parent);
            if (parent == null || parent == '') parent = this;
            if (!Array.isArray(nodes)) nodes = [
                nodes
            ];
            for(let o = 0; o < nodes.length; o++){
                node1 = nodes[o];
                if (node1.caption != null && node1.text == null) {
                    console.log('NOTICE: sidebar node.caption property is deprecated, please use node.text');
                    node1.text = node1.caption;
                }
                node1.id;
                if (this.get(this, node1.id) != null) {
                    console.log('ERROR: Cannot insert node with id=' + node1.id + ' (text: ' + node1.text + ') because another node with the same id already exists.');
                    continue;
                }
                tmp = Object.assign({}, this.node_template, node1);
                tmp.sidebar = this;
                tmp.parent = parent;
                nd = tmp.nodes || [];
                tmp.nodes = [] // very important to re-init empty nodes array
                ;
                if (before == null) parent.nodes.push(tmp);
                else {
                    ind = this.get(parent, before, true);
                    if (ind == null) {
                        console.log('ERROR: Cannot insert node "' + node1.text + '" because cannot find node "' + before + '" to insert before.');
                        return null;
                    }
                    parent.nodes.splice(ind, 0, tmp);
                }
                if (nd.length > 0) this.insert(tmp, null, nd);
            }
            if (!this.skipRefresh) this.refresh(parent.id);
            return tmp;
        }
        remove() {
            let effected = 0;
            let node1;
            Array.from(arguments).forEach((arg)=>{
                node1 = this.get(arg);
                if (node1 == null) return;
                if (this.selected != null) {
                    if (Array.isArray(this.selected)) this.selected.splice(this.selected.indexOf(node1.id), 1);
                    else if (this.selected === node1.id) this.selected = null;
                }
                let ind = this.get(node1.parent, arg, true);
                if (ind == null) return;
                if (node1.parent.nodes[ind].selected) node1.sidebar.unselect(node1.id);
                node1.parent.nodes.splice(ind, 1);
                node1.parent.collapsible = node1.parent.nodes.length > 0;
                effected++;
            });
            if (!this.skipRefresh) {
                if (effected > 0 && arguments.length == 1) this.refresh(node1.parent.id);
                else this.refresh();
            }
            return effected;
        }
        set(parent, id, node1) {
            if (arguments.length == 2) {
                // need to be in reverse order
                node1 = id;
                id = parent;
                parent = this;
            }
            // searches all nested nodes
            if (typeof parent == 'string') parent = this.get(parent);
            if (parent.nodes == null) return null;
            for(let i = 0; i < parent.nodes.length; i++)if (parent.nodes[i].id === id) {
                // see if quick update is possible
                let res = this.update(id, node1);
                if (Object.keys(res).length != 0) {
                    // make sure nodes inserted correctly
                    let nodes = node1.nodes;
                    $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(parent.nodes[i], node1, nodes != null ? {
                        nodes: []
                    } : {});
                    if (nodes != null) this.add(parent.nodes[i], nodes);
                    if (!this.skipRefresh) this.refresh(id);
                }
                return true;
            } else {
                let rv = this.set(parent.nodes[i], id, node1);
                if (rv) return true;
            }
            return false;
        }
        get(parent, id, returnIndex) {
            if (arguments.length === 0) {
                let all = [];
                let tmp = this.find({});
                for(let t = 0; t < tmp.length; t++)if (tmp[t].id != null) all.push(tmp[t].id);
                return all;
            } else {
                if (arguments.length == 1 || arguments.length == 2 && id === true) {
                    // need to be in reverse order
                    returnIndex = id;
                    id = parent;
                    parent = this;
                }
                // searches all nested nodes
                if (typeof parent == 'string') parent = this.get(parent);
                if (parent.nodes == null) return null;
                for(let i = 0; i < parent.nodes.length; i++)if (parent.nodes[i].id == id) {
                    if (returnIndex === true) return i;
                    else return parent.nodes[i];
                } else {
                    let rv = this.get(parent.nodes[i], id, returnIndex);
                    if (rv || rv === 0) return rv;
                }
                return null;
            }
        }
        setCount(id, count, options = {}) {
            let btn = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#node_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)} .w2ui-node-badge`);
            if (btn.length > 0) {
                btn.removeClass().addClass(`w2ui-node-badge ${options.className ?? 'w2ui-node-count'}`).text(count).get(0).style.cssText = options.style || '';
                this.last.badge[id] = {
                    className: options.className ?? '',
                    style: options.style ?? ''
                };
                let item = this.get(id);
                item.count = count;
            } else {
                this.set(id, {
                    count: count
                });
                this.setCount(...arguments) // to update styles
                ;
            }
        }
        find(parent, params, results) {
            // TODO: rewrite with this.each()
            if (arguments.length == 1) {
                // need to be in reverse order
                params = parent;
                parent = this;
            }
            if (!results) results = [];
            // searches all nested nodes
            if (typeof parent == 'string') parent = this.get(parent);
            if (parent.nodes == null) return results;
            for(let i = 0; i < parent.nodes.length; i++){
                let match = true;
                for(let prop in params)if (parent.nodes[i][prop] != params[prop]) match = false;
                if (match) results.push(parent.nodes[i]);
                if (parent.nodes[i].nodes.length > 0) results = this.find(parent.nodes[i], params, results);
            }
            return results;
        }
        sort(options, nodes) {
            // default options
            if (!options || typeof options != 'object') options = {};
            if (options.foldersFirst == null) options.foldersFirst = true;
            if (options.caseSensitive == null) options.caseSensitive = false;
            if (options.reverse == null) options.reverse = false;
            if (nodes == null) nodes = this.nodes;
            nodes.sort((a, b)=>{
                // folders first
                let isAfolder = a.nodes && a.nodes.length > 0;
                let isBfolder = b.nodes && b.nodes.length > 0;
                // both folder or both not folders
                if (options.foldersFirst === false || !isAfolder && !isBfolder || isAfolder && isBfolder) {
                    let aText = a.text;
                    let bText = b.text;
                    if (!options.caseSensitive) {
                        aText = aText.toLowerCase();
                        bText = bText.toLowerCase();
                    }
                    if (a.order != null) aText = a.order;
                    if (b.order != null) bText = b.order;
                    let cmp = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.naturalCompare(aText, bText);
                    return (cmp === 1 || cmp === -1) & options.reverse ? -cmp : cmp;
                }
                if (isAfolder && !isBfolder) return !options.reverse ? -1 : 1;
                if (!isAfolder && isBfolder) return !options.reverse ? 1 : -1;
            });
            nodes.forEach((node1)=>{
                if (node1.nodes && node1.nodes.length > 0) this.sort(options, node1.nodes);
            });
        }
        each(fn, nodes) {
            if (nodes == null) nodes = this.nodes;
            nodes.forEach((node1)=>{
                fn.call(this, node1);
                if (node1.nodes && node1.nodes.length > 0) this.each(fn, node1.nodes);
            });
        }
        search(str, compare = null) {
            let count = 0;
            let str2 = str.toLowerCase();
            this.each((node1)=>{
                let match = false;
                if (typeof compare == 'function') match = compare(str, node1);
                else match = !(node1.text.toLowerCase().indexOf(str2) === -1);
                if (match) {
                    count++;
                    showParents(node1);
                    node1.hidden = false;
                } else node1.hidden = true;
            });
            this.refresh();
            return count;
            function showParents(node1) {
                if (node1.parent) {
                    node1.parent.hidden = false;
                    showParents(node1.parent);
                }
            }
        }
        show() {
            let effected = [];
            Array.from(arguments).forEach((it)=>{
                let node1 = this.get(it);
                if (node1 == null || node1.hidden === false) return;
                node1.hidden = false;
                effected.push(node1.id);
            });
            if (effected.length > 0) {
                if (arguments.length == 1) this.refresh(arguments[0]);
                else this.refresh();
            }
            return effected;
        }
        hide() {
            let effected = [];
            Array.from(arguments).forEach((it)=>{
                let node1 = this.get(it);
                if (node1 == null || node1.hidden === true) return;
                node1.hidden = true;
                effected.push(node1.id);
            });
            if (effected.length > 0) {
                if (arguments.length == 1) this.refresh(arguments[0]);
                else this.refresh();
            }
            return effected;
        }
        enable() {
            let effected = [];
            Array.from(arguments).forEach((it)=>{
                let node1 = this.get(it);
                if (node1 == null || node1.disabled === false) return;
                node1.disabled = false;
                effected.push(node1.id);
            });
            if (effected.length > 0) {
                if (arguments.length == 1) this.refresh(arguments[0]);
                else this.refresh();
            }
            return effected;
        }
        disable() {
            let effected = [];
            Array.from(arguments).forEach((it)=>{
                let node1 = this.get(it);
                if (node1 == null || node1.disabled === true) return;
                node1.disabled = true;
                if (node1.selected) this.unselect(node1.id);
                effected.push(node1.id);
            });
            if (effected.length > 0) {
                if (arguments.length == 1) this.refresh(arguments[0]);
                else this.refresh();
            }
            return effected;
        }
        select(id) {
            if (Array.isArray(id)) {
                [
                    ...id
                ].forEach((id)=>this.select(id));
                return;
            }
            let new_node = this.get(id);
            if (!new_node) return false;
            // event before
            let edata = this.trigger('select', {
                target: id,
                id: id,
                node: new_node
            });
            if (edata.isCancelled === true) return true;
            // if already selected
            if (!this.multi && this.selected == id && new_node.selected) return false;
            let $el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id));
            $el.addClass('w2ui-selected').find('.w2ui-icon').addClass('w2ui-icon-selected');
            if ($el.length > 0) {
                if (!this.inView(id)) this.scrollIntoView(id);
            }
            new_node.selected = true;
            if (this.multi) {
                if (!Array.isArray(this.selected)) this.selected = this.selected ? [
                    this.selected
                ] : [];
                this.selected.push(id);
            } else this.selected = this.multi ? [
                id
            ] : id;
            edata.finish();
            return true;
        }
        unselect(id) {
            // if no arguments provided, unselect selected node
            if (arguments.length === 0) id = this.selected;
            if (Array.isArray(id)) {
                [
                    ...id
                ].forEach((id)=>this.unselect(id));
                return;
            }
            let current = this.get(id);
            if (!current) return false;
            // event before
            let edata = this.trigger('unselect', {
                target: id,
                id: id,
                node: current
            });
            if (edata.isCancelled === true) return true;
            current.selected = false;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)).removeClass('w2ui-selected').find('.w2ui-icon').removeClass('w2ui-icon-selected');
            if (typeof this.selected == 'string' && this.selected == id) this.selected = null;
            if (this.multi && Array.isArray(this.selected)) {
                let ind = this.selected.indexOf(id);
                if (ind != -1) this.selected.splice(ind, 1);
            }
            edata.finish();
            return true;
        }
        toggle(id) {
            let nd = this.get(id);
            if (nd == null) return false;
            if (nd.plus) {
                this.set(id, {
                    plus: false
                });
                this.expand(id);
                this.refresh(id);
                return;
            }
            if (nd.nodes.length === 0) return false;
            if (!nd.collapsible) return false;
            if (this.get(id).expanded) return this.collapse(id);
            else return this.expand(id);
        }
        collapse(id) {
            let nd = this.get(id);
            if (nd == null) return false;
            // event before
            let edata = this.trigger('collapse', {
                target: id,
                object: nd,
                node: nd
            });
            if (edata.isCancelled === true) return;
            // default action
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id) + '_sub').hide();
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id) + ' .w2ui-expanded').removeClass('w2ui-expanded').addClass('w2ui-collapsed');
            nd.expanded = false;
            // event after
            edata.finish();
            this.refresh(id);
            return true;
        }
        expand(id) {
            let nd = this.get(id);
            // event before
            let edata = this.trigger('expand', {
                target: id,
                object: nd,
                node: nd
            });
            if (edata.isCancelled === true) return;
            // default action
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id) + '_sub').show();
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id) + ' .w2ui-collapsed').removeClass('w2ui-collapsed').addClass('w2ui-expanded');
            nd.expanded = true;
            // event after
            edata.finish();
            this.refresh(id);
            return true;
        }
        collapseAll(parent) {
            if (parent == null) parent = this;
            if (typeof parent == 'string') parent = this.get(parent);
            if (parent.nodes == null) return false;
            for(let i = 0; i < parent.nodes.length; i++){
                if (parent.nodes[i].expanded === true) parent.nodes[i].expanded = false;
                if (parent.nodes[i].nodes && parent.nodes[i].nodes.length > 0) this.collapseAll(parent.nodes[i]);
            }
            this.refresh(parent.id);
            return true;
        }
        expandAll(parent) {
            if (parent == null) parent = this;
            if (typeof parent == 'string') parent = this.get(parent);
            if (parent.nodes == null) return false;
            for(let i = 0; i < parent.nodes.length; i++){
                if (parent.nodes[i].expanded === false) parent.nodes[i].expanded = true;
                if (parent.nodes[i].nodes && parent.nodes[i].nodes.length > 0) this.expandAll(parent.nodes[i]);
            }
            this.refresh(parent.id);
        }
        expandParents(id) {
            let node1 = this.get(id);
            if (node1 == null) return false;
            if (node1.parent) {
                if (!node1.parent.expanded) {
                    node1.parent.expanded = true;
                    this.refresh(node1.parent.id);
                }
                this.expandParents(node1.parent.id);
            }
            return true;
        }
        click(id, event1) {
            let obj = this;
            let nd = this.get(id);
            if (nd == null) return;
            if (nd.disabled || nd.group) return; // should click event if already selected
            // select new one
            let newNode = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id));
            newNode.addClass('w2ui-selected').find('.w2ui-icon').addClass('w2ui-icon-selected');
            // need timeout to allow rendering
            setTimeout(()=>{
                // event before
                let edata = obj.trigger('click', {
                    target: id,
                    originalEvent: event1,
                    node: nd,
                    object: nd
                });
                if (edata.isCancelled === true) {
                    // restore selection
                    newNode.removeClass('w2ui-selected').find('.w2ui-icon').removeClass('w2ui-icon-selected');
                    return;
                }
                // default action
                if (this.multi) {
                    let isShift = event1?.shiftKey || event1?.ctrlKey || event1?.metaKey;
                    if (typeof this.selected == 'string') this.selected = [
                        this.selected
                    ];
                    if (!isShift) {
                        let ids = this.selected?.filter((sid)=>sid != id);
                        this.unselect(ids);
                    } else if (this.selected?.includes(id)) {
                        this.unselect(id);
                        return;
                    }
                    if (!this.selected?.includes(id)) this.select(id);
                } else if (this.selected !== id) {
                    if (this.selected) this.unselect(this.selected);
                    this.select(id);
                }
                // route processing
                if (typeof nd.route == 'string') {
                    let route = nd.route !== '' ? String('/' + nd.route).replace(/\/{2,}/g, '/') : '';
                    let info = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseRoute(route);
                    if (info.keys.length > 0) for(let k = 0; k < info.keys.length; k++){
                        if (obj.routeData[info.keys[k].name] == null) continue;
                        route = route.replace(new RegExp(':' + info.keys[k].name, 'g'), obj.routeData[info.keys[k].name]);
                    }
                    setTimeout(()=>{
                        window.location.hash = route;
                    }, 1);
                }
                // event after
                edata.finish();
            }, 1);
        }
        focus(event1) {
            let self1 = this;
            // event before
            let edata = this.trigger('focus', {
                target: this.name,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return false;
            // default behaviour
            this.hasFocus = true;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-body').addClass('w2ui-focus');
            setTimeout(()=>{
                let input = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('#sidebar_' + self1.name + '_focus').get(0);
                if (document.activeElement != input) input.focus();
            }, 10);
            // event after
            edata.finish();
        }
        blur(event1) {
            // event before
            let edata = this.trigger('blur', {
                target: this.name,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return false;
            // default behaviour
            this.hasFocus = false;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-body').removeClass('w2ui-focus');
            // event after
            edata.finish();
        }
        next(node1, noSubs) {
            if (node1 == null) return null;
            let parent = node1.parent;
            let ind = this.get(node1.id, true);
            let nextNode = null;
            // jump inside
            if (node1.expanded && node1.nodes.length > 0 && noSubs !== true) {
                let nd = node1.nodes[0];
                if (nd.hidden || nd.disabled || nd.group) nextNode = this.next(nd);
                else nextNode = nd;
            } else if (parent && ind + 1 < parent.nodes.length) nextNode = parent.nodes[ind + 1];
            else nextNode = this.next(parent, true) // jump to the parent
            ;
            if (nextNode != null && (nextNode.hidden || nextNode.disabled || nextNode.group)) nextNode = this.next(nextNode);
            return nextNode;
        }
        prev(node1) {
            if (node1 == null) return null;
            let parent = node1.parent;
            let ind = this.get(node1.id, true);
            let lastChild = (node1)=>{
                if (node1.expanded && node1.nodes.length > 0) {
                    let nd = node1.nodes[node1.nodes.length - 1];
                    if (nd.hidden || nd.disabled || nd.group) return this.prev(nd);
                    else return lastChild(nd);
                }
                return node1;
            };
            let prevNode = ind > 0 ? lastChild(parent.nodes[ind - 1]) : parent;
            if (prevNode != null && (prevNode.hidden || prevNode.disabled || prevNode.group)) prevNode = this.prev(prevNode);
            return prevNode;
        }
        keydown(event1) {
            let self1 = this;
            let first = Array.isArray(this.selected) ? this.selected[0] : this.selected;
            let nd = self1.get(first);
            if (this.keyboard !== true) return;
            if (!nd) nd = this.nodes[0];
            // if user hits esc and there is active move
            if (event1.keyCode == 27) {
                let mv = this.last.move;
                if (mv?.reorder && mv?.moved) {
                    mv.restore();
                    return;
                }
            }
            // trigger event
            let edata = this.trigger('keydown', {
                target: this.name,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // default behaviour
            if (event1.keyCode == 13 || event1.keyCode == 32) {
                if (event1.keyCode == 13 && this.editable && !event1.ctrlKey && !event1.metaKey) this.edit(first);
                else if (nd.nodes.length > 0) this.toggle(first);
            }
            if (event1.keyCode == 37) {
                if (nd.nodes.length > 0 && nd.expanded) this.collapse(first);
                else {
                    selectNode(nd.parent);
                    if (!nd.parent.group) this.collapse(nd.parent.id);
                }
            }
            if (event1.keyCode == 39) {
                if ((nd.nodes.length > 0 || nd.plus) && !nd.expanded) this.expand(first);
            }
            if (event1.keyCode == 38) {
                if (this.get(first) == null) selectNode(this.nodes[0] || null);
                else selectNode(neighbor(nd, this.prev));
            }
            if (event1.keyCode == 40) {
                if (this.get(first) == null) selectNode(this.nodes[0] || null);
                else selectNode(neighbor(nd, this.next));
            }
            // cancel event if needed
            if ([
                13,
                32,
                37,
                38,
                39,
                40
            ].includes(event1.keyCode)) {
                if (event1.preventDefault) event1.preventDefault();
                if (event1.stopPropagation) event1.stopPropagation();
            }
            // event after
            edata.finish();
            function selectNode(node1, event1) {
                if (node1 != null && !node1.hidden && !node1.disabled && !node1.group) {
                    self1.click(node1.id, event1);
                    if (!self1.inView(node1.id)) self1.scrollIntoView(node1.id);
                }
            }
            function neighbor(node1, neighborFunc) {
                node1 = neighborFunc.call(self1, node1);
                while(node1 != null && (node1.hidden || node1.disabled)){
                    if (node1.group) break;
                    else node1 = neighborFunc(node1);
                }
                return node1;
            }
        }
        inView(id) {
            let item = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)).get(0);
            if (!item) return false;
            let div = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-body').get(0);
            if (item.offsetTop < div.scrollTop || item.offsetTop + item.clientHeight > div.clientHeight + div.scrollTop) return false;
            return true;
        }
        scrollIntoView(id, instant) {
            return new Promise((resolve, reject)=>{
                if (id == null) id = Array.isArray(this.selected) ? this.selected[0] : this.selected;
                let nd = this.get(id);
                if (nd == null) return;
                let item = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)).get(0);
                item.scrollIntoView({
                    block: 'center',
                    inline: 'center',
                    behavior: instant ? 'atuo' : 'smooth'
                });
                setTimeout(()=>{
                    this.resize();
                    resolve();
                }, instant ? 0 : 500);
            });
        }
        dblClick(id, event1) {
            let nd = this.get(id);
            // event before
            let edata = this.trigger('dblClick', {
                target: id,
                originalEvent: event1,
                object: nd
            });
            if (edata.isCancelled === true) return;
            // default action
            if (this.editable) this.edit(id);
            else this.toggle(id);
            // event after
            edata.finish();
        }
        /**
     * This is needed for not reorder
     */ mouseDown(id, event1) {
            let self1 = this;
            if (this.reorder) {
                this.last.move = {
                    x: event1.screenX,
                    y: event1.screenY,
                    divX: 0,
                    divY: 0,
                    reorder: true,
                    moved: false
                };
                // display empty record and ghost record
                let mv = this.last.move;
                let body = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-body');
                if (!mv.ghost) {
                    let node1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#node_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)}`);
                    mv.offsetY = event1.offsetY;
                    mv.target = id;
                    mv.pos = {
                        top: node1.get(0).offsetTop - 1,
                        left: node1.get(0).offsetLeft
                    };
                    // ghost content
                    let clone = $aa2bd8933167d9cb$export$2fa187e846a241c4(node1.find('.w2ui-node-data').get(0).cloneNode(true));
                    mv.node = node1;
                    mv.nodeSub = node1.next();
                    body.append('<div id="sidebar_' + this.name + '_ghost" class="w2ui-node w2ui-ghost"></div>');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#sidebar_' + this.name + '_ghost').append(clone);
                    mv.ghost = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#sidebar_' + this.name + '_ghost');
                    mv.ghost.css({
                        display: 'none'
                    });
                    mv.restore = ()=>{
                        mv.resetReorder();
                        this.refresh();
                    };
                    mv.resetReorder = ()=>{
                        this.last.move = null;
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#sidebar_${this.name}_ghost`).remove();
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off(`.w2ui-${this.name}-reorder`);
                    };
                }
                // add mouse move and stop events
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).on(`mousemove.w2ui-${this.name}-reorder`, _mouseMove).on(`mouseup.w2ui-${this.name}-reorder`, _mouseStop);
            }
            function _mouseMove(event1) {
                if (!event1.target.tagName) // this can happen is you click+drag and move the mouse out of the DOM area,
                // e.g. into the browser's toolbar area
                return;
                let mv = self1.last.move;
                mv.divX = event1.screenX - mv.x;
                mv.divY = event1.screenY - mv.y;
                if (Math.abs(mv.divX) <= 1 && Math.abs(mv.divY) <= 1) return; // only if moved more then 1px
                if (self1.reorder == true && mv.reorder && !mv.moved) {
                    let edata = self1.trigger('dragStart', {
                        target: mv.target,
                        moved: true,
                        node: self1.get(mv.target),
                        mv: mv,
                        originalEvent: event1
                    });
                    if (edata.isCancelled === true) {
                        mv.restore();
                        return;
                    }
                    let rect = mv.node.get(0).getBoundingClientRect();
                    mv.moved = true;
                    mv.node.html('').removeAttr('id', 'data-id').addClass('w2ui-reorder-empty').css({
                        height: rect.height + 'px'
                    });
                    // if there are children
                    if (mv.node.next().css('display') !== 'none') {
                        let rect = mv.node.next().get(0).getBoundingClientRect();
                        mv.node.next().html('<div class="w2ui-reorder-empty-sub"></div>').css({
                            height: rect.height + 'px'
                        });
                    }
                    mv.ghost.css({
                        display: 'block'
                    });
                    // event after
                    edata.finish();
                }
                // move ghost mode
                mv.ghost.css({
                    top: mv.pos.top + mv.divY + 'px',
                    left: 0
                });
                let over = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.w2ui-node, .w2ui-node-group');
                let id = over.attr('data-id');
                // append to the end
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('w2ui-sidebar-body') && event1.layerY > 5 && !mv.append) {
                    let edata = self1.trigger('dragOver', {
                        target: mv.target,
                        append: true,
                        mv: mv,
                        originalEvent: event1
                    });
                    if (edata.isCancelled === true) return;
                    mv.ghost.before(mv.node);
                    mv.ghost.before(mv.nodeSub);
                    mv.append = true;
                    mv.moveBefore = null;
                    // event after
                    edata.finish();
                } else if (id != null && id != mv.moveBefore) {
                    mv.append = false;
                    mv.moveBefore = id;
                    // reorder nodes
                    let edata = self1.trigger('dragOver', {
                        target: mv.target,
                        moveBefore: id,
                        mv: mv,
                        originalEvent: event1
                    });
                    if (edata.isCancelled === true) return;
                    let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(`#node_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)}`);
                    el.before(mv.node);
                    el.before(mv.nodeSub);
                    // event after
                    edata.finish();
                }
            }
            function _mouseStop(event1) {
                let mv = self1.last.move;
                mv.resetReorder();
                if (mv.moved) {
                    if (mv.moveBefore != null && mv.target != mv.moveBefore || mv.append) {
                        let edata = self1.trigger('reorder', {
                            target: mv.target,
                            moveBefore: mv.moveBefore,
                            append: mv.append,
                            originalEvent: event1
                        });
                        if (edata.isCancelled === true) {
                            self1.refresh();
                            return;
                        }
                        // remove
                        let target = self1.get(mv.target);
                        let targetInd = target.parent.nodes.indexOf(target);
                        let cut = target.parent.nodes.splice(targetInd, 1);
                        // insert
                        if (mv.append) {
                            self1.nodes.push(...cut);
                            cut.forEach((nd)=>nd.parent = self1);
                        } else {
                            let before = self1.get(mv.moveBefore);
                            let beforeInd = before.parent.nodes.indexOf(before);
                            cut.forEach((nd)=>nd.parent = before.parent);
                            before.parent.nodes.splice(beforeInd, 0, ...cut);
                        }
                        // refresh
                        self1.refresh();
                        // event after
                        edata.finish();
                    } else self1.refresh();
                }
            }
        }
        edit(id) {
            let self1 = this;
            let node1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id));
            let text = node1.find('.w2ui-node-text');
            // event before
            let edata = this.trigger('edit', {
                target: id,
                el: node1,
                textEl: text
            });
            if (edata.isCancelled === true) return;
            this.last.renaming = true;
            node1.addClass('w2ui-editing');
            text.addClass('w2ui-focus').css('pointer-events', 'all').attr('contenteditable', 'plaintext-only').on('blur.node-editing', (event1)=>{
                // timeout is needed to add to the end of the event loop
                setTimeout(_rename, 0);
            }).on('keydown.node-editing', (event1)=>{
                if (event1.keyCode == 13) _rename(event1);
                if (event1.keyCode == 27) _rename(event1, true);
            }).get(0).focus();
            let original = text.text();
            // select everything inside
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.setCursorPosition(text[0], 0, text.text().length);
            // event after
            edata.finish();
            return text.get(0) // return editable input
            ;
            function _rename(event1, cancel) {
                let renameTo = text.text();
                node1.removeClass('w2ui-editing');
                text.removeClass('w2ui-focus').css('pointer-events', 'none').removeAttr('contenteditable').off('.node-editing');
                // send event if it was not cancelled
                if (!cancel && self1.last.renaming && original !== renameTo) {
                    let edata = self1.trigger('rename', {
                        target: id,
                        text_previous: original,
                        text_new: renameTo,
                        originalEvent: event1
                    });
                    if (edata.isCancelled === true) {
                        text.text(original);
                        self1.last.renaming = false;
                        self1.focus();
                        return;
                    }
                    self1.set(id, {
                        text: renameTo
                    });
                    edata.finish();
                }
                if (cancel) self1.set(id, {
                    text: original
                });
                self1.last.renaming = false;
                self1.focus();
            }
        }
        contextMenu(id, event1) {
            let nd = this.get(id);
            if (Array.isArray(this.selected)) {
                if (!this.selected.includes(id)) this.click(id);
            } else if (id != this.selected) this.click(id);
            // event before
            let edata = this.trigger('contextMenu', {
                target: id,
                originalEvent: event1,
                object: nd,
                allowOnDisabled: false
            });
            if (edata.isCancelled === true) return;
            // default action
            if (nd.disabled && !edata.allowOnDisabled) return;
            if (this.menu.length > 0) $aa2bd8933167d9cb$export$3842f79f22e98342.show({
                name: this.name + '_menu',
                anchor: document.body,
                items: this.menu,
                originalEvent: event1
            }).select((evt)=>{
                this.menuClick(id, parseInt(evt.detail.index), event1);
            });
            // prevent default context menu
            if (event1.preventDefault) event1.preventDefault();
            // event after
            edata.finish();
        }
        menuClick(itemId, index, event1) {
            // event before
            let edata = this.trigger('menuClick', {
                target: itemId,
                originalEvent: event1,
                menuIndex: index,
                menuItem: this.menu[index]
            });
            if (edata.isCancelled === true) return;
            // default action
            // -- empty
            // event after
            edata.finish();
        }
        goFlat() {
            // event before
            let edata = this.trigger('flat', {
                goFlat: !this.flat
            });
            if (edata.isCancelled === true) return;
            // default action
            this.flat = !this.flat;
            this.refresh();
            // event after
            edata.finish();
        }
        render(box) {
            let time = Date.now();
            let obj = this;
            if (typeof box == 'string') box = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).get(0);
            // event before
            let edata = this.trigger('render', {
                target: this.name,
                box: box ?? this.box
            });
            if (edata.isCancelled === true) return;
            // default action
            if (box != null) {
                this.unmount() // clean previous control
                ;
                this.box = box;
            }
            if (!this.box) return;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).attr('name', this.name).addClass('w2ui-reset w2ui-sidebar').html(`<div>
                <div class="w2ui-sidebar-top"></div>
                <input id="sidebar_${this.name}_focus" ${this.tabIndex ? 'tabindex="' + this.tabIndex + '"' : ''}
                    style="position: absolute; top: 0; right: 0; width: 1px; z-index: -1; opacity: 0"
                    ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isIOS ? 'readonly' : ''}/>
                <div class="w2ui-sidebar-body"></div>
                <div class="w2ui-sidebar-bottom"></div>
            </div>`);
            let rect = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0).getBoundingClientRect();
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div').css({
                width: rect.width + 'px',
                height: rect.height + 'px'
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0).style.cssText += this.style;
            // focus
            let kbd_timer;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#sidebar_' + this.name + '_focus').on('focus', function(event1) {
                clearTimeout(kbd_timer);
                if (!obj.hasFocus) obj.focus(event1);
            }).on('blur', function(event1) {
                kbd_timer = setTimeout(()=>{
                    if (obj.hasFocus) obj.blur(event1);
                }, 100);
            }).on('keydown', function(event1) {
                // do not cancel tab key (keyCode=9) so that event is dispatched to self
                $aa2bd8933167d9cb$export$dca4c93ccda43b77[obj.name].keydown.call($aa2bd8933167d9cb$export$dca4c93ccda43b77[obj.name], event1);
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).off('mousedown').on('mousedown', function(event1) {
                // set focus to sidebar
                setTimeout(()=>{
                    // if input then do not focus
                    if ([
                        'INPUT',
                        'TEXTAREA',
                        'SELECT'
                    ].indexOf(event1.target.tagName.toUpperCase()) == -1) {
                        let $input = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#sidebar_' + obj.name + '_focus');
                        if (document.activeElement != $input.get(0) && $input.length > 0) $input.get(0).focus();
                    }
                }, 1);
            });
            /**
         * FlatHTML is always present and in .refresh() it is just refreshed. However topHTML and buttomHTML should be here
         * because it should never be refreshed, as it could create recursive refresh loop
         */ let flatHTML = `<div class="w2ui-flat w2ui-flat-${this.flat ? 'right' : 'left'}" ${this.flatButton == false ? 'style="display: none"' : ''}></div>`;
            if (this.topHTML !== '' || flatHTML !== '') {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-top').html(this.topHTML + flatHTML);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-body').css('top', $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-top').get(0)?.clientHeight + 'px');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-flat').off('click').on('click', (event1)=>{
                    this.goFlat();
                });
            }
            if (this.bottomHTML !== '') {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-bottom').html(this.bottomHTML);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-body').css('bottom', $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-bottom').get(0)?.clientHeight + 'px');
            }
            // observe div resize
            this.last.observeResize = new ResizeObserver(()=>{
                this.resize();
            });
            this.last.observeResize.observe(this.box);
            // event after
            edata.finish();
            // ---
            this.refresh();
            return Date.now() - time;
        }
        update(id, options = {}) {
            // quick function to refresh just this item (not sub nodes)
            //  - icon, class, style, text, count
            let nd = this.get(id);
            let level;
            if (nd) {
                let $el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(nd.id));
                if (nd.group) {
                    if (options.text) {
                        nd.text = options.text;
                        $el.find('.w2ui-group-text').replace(typeof nd.text == 'function' ? nd.text.call(this, nd) : '<span class="w2ui-group-text">' + nd.text + '</span>');
                        delete options.text;
                    }
                    if (options.class) {
                        nd.class = options.class;
                        level = $el.data('level');
                        $el.get(0).className = 'w2ui-node-group w2ui-level-' + level + (nd.class ? ' ' + nd.class : '');
                        delete options.class;
                    }
                    if (options.style) {
                        nd.style = options.style;
                        $el.get(0).nextElementSibling.style = nd.style + ';' + (!nd.hidden && nd.expanded ? '' : 'display: none;');
                        delete options.style;
                    }
                } else {
                    if (options.icon) {
                        let $icon = $el.find('.w2ui-node-image > span');
                        if ($icon.length > 0) {
                            nd.icon = options.icon;
                            $icon[0].className = typeof nd.icon == 'function' ? nd.icon.call(this, nd) : nd.icon;
                            delete options.icon;
                        }
                    }
                    if (options.count) {
                        nd.count = options.count;
                        // update counts
                        let txt = nd.count ?? this.badge.text;
                        let style = this.badge.style;
                        let last = this.last.badge[nd.id];
                        if (typeof txt == 'function') txt = txt.call(this, node, level);
                        $el.find('.w2ui-node-badge').html(txt).attr('style', `${style}; ${last?.style ?? ''}`);
                        if ($el.find('.w2ui-node-badge').length > 0) delete options.count;
                    }
                    if (options.class && $el.length > 0) {
                        nd.class = options.class;
                        level = $el.data('level');
                        $el[0].className = 'w2ui-node w2ui-level-' + level + (nd.selected ? ' w2ui-selected' : '') + (nd.disabled ? ' w2ui-disabled' : '') + (nd.class ? ' ' + nd.class : '');
                        delete options.class;
                    }
                    if (options.text) {
                        nd.text = options.text;
                        $el.find('.w2ui-node-text').html(typeof nd.text == 'function' ? nd.text.call(this, nd) : nd.text);
                        delete options.text;
                    }
                    if (options.style && $el.length > 0) {
                        let $txt = $el.find('.w2ui-node-text');
                        nd.style = options.style;
                        $txt[0].style = nd.style;
                        delete options.style;
                    }
                }
            }
            // return what was not set
            return options;
        }
        refresh(id, noBinding) {
            if (this.box == null) return;
            let time = Date.now();
            let self1 = this;
            // event before
            let edata = this.trigger('refresh', {
                target: id != null ? id : this.name,
                nodeId: id != null ? id : null,
                fullRefresh: id != null ? false : true
            });
            if (edata.isCancelled === true) return;
            if (this.flatButton == true) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-top .w2ui-flat').show().removeClass('w2ui-flat-left w2ui-flat-right').addClass(` w2ui-flat-${this.flat ? 'right' : 'left'}`);
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-top .w2ui-flat').hide();
            // default action
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div').removeClass('w2ui-sidebar-flat').addClass(this.flat ? 'w2ui-sidebar-flat' : '').css({
                width: $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0)?.clientWidth + 'px',
                height: $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0)?.clientHeight + 'px'
            });
            // if no parent - reset nodes
            if (this.nodes.length > 0 && this.nodes[0].parent == null) {
                let tmp = this.nodes;
                this.nodes = [];
                this.add(this, tmp);
            }
            let obj = this;
            let node1;
            let nodeSubId;
            if (id == null) {
                node1 = this;
                nodeSubId = '.w2ui-sidebar-body';
            } else {
                node1 = this.get(id);
                if (node1 == null) return;
                nodeSubId = '#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(node1.id) + '_sub';
            }
            let nodeId = '#node_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(node1.id);
            let nodeHTML;
            if (node1 !== this) {
                nodeHTML = getNodeHTML(node1);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(nodeId).before('<div id="sidebar_' + this.name + '_tmp"></div>');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(nodeId).remove();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(nodeSubId).remove();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#sidebar_' + this.name + '_tmp').before(nodeHTML);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#sidebar_' + this.name + '_tmp').remove();
            }
            // remember scroll position
            let div = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div').get(0);
            let scroll1 = {
                top: div?.scrollTop,
                left: div?.scrollLeft
            };
            // refresh sub nodes
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(nodeSubId).html('');
            for(let i = 0; i < node1.nodes.length; i++){
                let subNode = node1.nodes[i];
                nodeHTML = getNodeHTML(subNode);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(nodeSubId).append(nodeHTML);
                if (subNode.nodes.length !== 0) this.refresh(subNode.id, true);
                else {
                    // trigger event
                    let edata2 = this.trigger('refresh', {
                        target: subNode.id
                    });
                    if (edata2.isCancelled === true) return;
                    // event after
                    edata2.finish();
                }
            }
            // reset scroll
            if (div) {
                div.scrollTop = scroll1.top;
                div.scrollLeft = scroll1.left;
            }
            // bind events
            if (!noBinding) {
                let els = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`${nodeId}, ${nodeId} .w2ui-eaction, ${nodeSubId} .w2ui-eaction`);
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(els, this);
            }
            // event after
            edata.finish();
            return Date.now() - time;
            function getNodeHTML(nd) {
                let html = '';
                let icon = nd.icon;
                if (icon == null) icon = obj.icon;
                // -- find out level
                let tmp = nd.parent;
                let level = 0;
                while(tmp && tmp.parent != null){
                    // if (tmp.group) level--;
                    tmp = tmp.parent;
                    level++;
                }
                if (nd.caption != null && nd.text == null) nd.text = nd.caption;
                if (nd.caption != null) {
                    console.log('NOTICE: sidebar node.caption property is deprecated, please use node.text. Node -> ', nd);
                    nd.text = nd.caption;
                }
                if (Array.isArray(nd.nodes) && nd.nodes.length > 0) nd.collapsible = true;
                if (nd.group) {
                    let text = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(typeof nd.text == 'function' ? nd.text.call(obj, nd, level) : nd.text);
                    if (String(text).substr(0, 5) != '<span') text = `<span class="w2ui-group-text">${text}</span>`;
                    html = `
                    <div id="node_${nd.id}" data-id="${nd.id}" data-level="${level}" style="${nd.hidden ? 'display: none' : ''}"
                        class="w2ui-node-group w2ui-level-${level} ${nd.class ? nd.class : ''} w2ui-eaction"
                        data-click="toggle|${nd.id}"
                        data-contextmenu="contextMenu|${nd.id}|event"
                        data-mouseenter="showPlus|this|inherit"
                        data-mouseleave="showPlus|this|transparent">
                        ${nd.groupShowHide && nd.collapsible ? `<span>${!nd.hidden && nd.expanded ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Hide') : $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Show')}</span>` : '<span></span>'} ${text}
                    </div>
                    <div class="w2ui-node-sub" id="node_${nd.id}_sub" style="${nd.style}; ${!nd.hidden && nd.expanded ? '' : 'display: none;'}">
                </div>`;
                    if (obj.flat) html = `
                        <div class="w2ui-node-group" id="node_${nd.id}" data-id="${nd.id}"><span>&#160;</span></div>
                        <div id="node_${nd.id}_sub" style="${nd.style}; ${!nd.hidden && nd.expanded ? '' : 'display: none;'}"></div>`;
                } else {
                    if (nd.selected && !nd.disabled) obj.selected = nd.id;
                    // icon or image
                    let image = '';
                    if (icon) {
                        if (icon instanceof Object) {
                            let text = typeof icon.text == 'function' ? icon.text.call(obj, nd, level) ?? '' : icon.text;
                            image = `
                            <div class="w2ui-node-image w2ui-eaction" style="${obj.icon.style ?? ''}; pointer-events: all"
                                data-mouseEnter="mouseAction|Enter|this|${nd.id}|event|icon"
                                data-mouseLeave="mouseAction|Leave|this|${nd.id}|event|icon"
                                data-click="mouseAction|click|this|${nd.id}|event|icon">
                                    ${text}
                            </div>
                        `;
                        } else image = `
                            <div class="w2ui-node-image">
                                <span class="${typeof icon == 'function' ? icon.call(obj, nd, level) : icon}"></span>
                            </div>`;
                    }
                    let expand = '';
                    let counts = '';
                    if (self1.badge != null || nd.count != null) {
                        let txt = nd.count ?? self1.badge?.text;
                        let style = self1.badge?.style;
                        let last = obj.last.badge[nd.id];
                        if (typeof txt == 'function') txt = txt.call(self1, nd, level);
                        if (txt) counts = `
                            <div class="w2ui-node-badge w2ui-eaction ${nd.count != null ? 'w2ui-node-count' : ''} ${last?.className ?? ''}"
                                style="${style ?? ''};${last?.style ?? ''}"
                                data-mouseEnter="mouseAction|Enter|this|${nd.id}|event|badge"
                                data-mouseLeave="mouseAction|Leave|this|${nd.id}|event|badge"
                                data-click="mouseAction|click|this|${nd.id}|event|badge"
                            >
                                ${txt}
                            </div>`;
                    }
                    // array with classes
                    let classes = [
                        'w2ui-node',
                        `w2ui-level-${level}`,
                        'w2ui-eaction'
                    ];
                    if (nd.selected) classes.push('w2ui-selected');
                    if (nd.disabled) classes.push('w2ui-disabled');
                    if (nd.class) classes.push(nd.class);
                    // collapsible
                    if (nd.collapsible === true) {
                        let toggleClasses = [
                            'w2ui-sb-toggle',
                            'w2ui-eaction',
                            nd.expanded ? 'w2ui-expanded' : 'w2ui-collapsed'
                        ];
                        if (self1.toggleAlign == 'left') toggleClasses.push('w2ui-left-toggle');
                        expand = `<div class="${toggleClasses.join(' ')}" data-click="toggle|${nd.id}"><span></span></div>`;
                        classes.push('w2ui-has-children');
                    }
                    let text = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(typeof nd.text == 'function' ? nd.text.call(obj, nd, level) : nd.text);
                    let nodeOffset = nd.parent?.childOffset ?? 0;
                    if (level === 0 && nd.collapsible === true && self1.toggleAlign == 'left') nodeOffset += 12;
                    html = `
                    <div id="node_${nd.id}" class="${classes.join(' ')}" data-id="${nd.id}" data-level="${level}"
                        style="${nd.hidden ? 'display: none;' : ''}"
                        data-click="click|${nd.id}|event"
                        data-dblclick="dblClick|${nd.id}|event"
                        data-mouseDown="mouseDown|${nd.id}|event"
                        data-contextmenu="contextMenu|${nd.id}|event"
                        data-mouseEnter="mouseAction|Enter|this|${nd.id}|event"
                        data-mouseLeave="mouseAction|Leave|this|${nd.id}|event"
                    >
                        ${obj.handle.text ? `<div class="w2ui-node-handle w2ui-eaction" style="width: ${obj.handle.width}px; ${obj.handle.style}"
                                    data-mouseEnter="mouseAction|Enter|this|${nd.id}|event|handle"
                                    data-mouseLeave="mouseAction|Leave|this|${nd.id}|event|handle"
                                    data-click="mouseAction|click|this|${nd.id}|event|handle"
                                >
                                   ${typeof obj.handle.text == 'function' ? obj.handle.text.call(obj, nd, level) ?? '' : obj.handle.text}
                              </div>` : ''}
                      <div class="w2ui-node-data" style="margin-left: ${level * obj.levelPadding + nodeOffset + obj.handle.width}px">
                            ${expand} ${image} ${counts}
                            <div class="w2ui-node-text ${!image ? 'no-icon' : ''}" style="${nd.style || ''}">${text}</div>
                       </div>
                    </div>
                    <div class="w2ui-node-sub" id="node_${nd.id}_sub" style="${nd.style}; ${!nd.hidden && nd.expanded ? '' : 'display: none;'}"></div>`;
                    if (obj.flat) html = `
                        <div id="node_${nd.id}" class="${classes.join(' ')}" data-id="${nd.id}" style="${nd.hidden ? 'display: none;' : ''}"
                            data-click="click|${nd.id}|event"
                            data-dblclick="dblClick|${nd.id}|event"
                            data-contextmenu="contextMenu|${nd.id}|event"
                            data-mouseEnter="mouseAction|Enter|this|${nd.id}|event|tooltip"
                            data-mouseLeave="mouseAction|Leave|this|${nd.id}|event|tooltip"
                        >
                            <div class="w2ui-node-data w2ui-node-flat">${image}</div>
                        </div>
                        <div class="w2ui-node-sub" id="node_${nd.id}_sub" style="${nd.style}; ${!nd.hidden && nd.expanded ? '' : 'display: none;'}"></div>`;
                }
                return html;
            }
        }
        mouseAction(action, anchor, nodeId, event1, type) {
            let edata;
            let node1 = this.get(nodeId);
            if (type == null) edata = this.trigger('mouse' + action, {
                target: node1.id,
                node: node1,
                originalEvent: event1
            });
            if (type == 'tooltip') {
                // this tooltip shows for flat sidebars
                let text = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(typeof node1.text == 'function' ? node1.text.call(this, node1) : node1.text);
                let tooltip = text + (node1.count || node1.count === 0 ? ' - <span class="w2ui-node-badge w2ui-node-count">' + node1.count + '</span>' : '');
                if (action == 'Leave') tooltip = '';
                this.tooltip(anchor, tooltip);
            }
            if (type == 'handle') {
                if (action == 'click') {
                    let onClick = this.handle.onClick;
                    if (typeof onClick == 'function') onClick.call(this, node1, event1);
                } else {
                    let tooltip = this.handle.tooltip;
                    if (typeof tooltip == 'function') tooltip = tooltip.call(this, node1, event1);
                    if (action == 'Leave') tooltip = '';
                    this.otherTooltip(anchor, tooltip);
                }
            }
            if (type == 'icon') {
                if (action == 'click') {
                    let onClick = this.icon.onClick;
                    if (typeof onClick == 'function') onClick.call(this, node1, event1);
                } else {
                    let tooltip = this.icon.tooltip;
                    if (typeof tooltip == 'function') tooltip = tooltip.call(this, node1, event1);
                    if (action == 'Leave') tooltip = '';
                    this.otherTooltip(anchor, tooltip);
                }
            }
            if (type == 'badge') {
                if (action == 'click') {
                    let onClick = this.badge?.onClick;
                    if (typeof onClick == 'function') onClick.call(this, node1, event1);
                } else {
                    let tooltip = this.badge?.tooltip;
                    if (typeof tooltip == 'function') tooltip = tooltip.call(this, node1, event1);
                    if (action == 'Leave') tooltip = '';
                    this.otherTooltip(anchor, tooltip);
                }
            }
            edata?.finish();
        }
        tooltip(el, text) {
            let $el = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).find('.w2ui-node-data');
            if (text !== '') $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                anchor: $el.get(0),
                name: this.name + '_tooltip',
                html: text,
                position: 'right|left'
            });
            else $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '_tooltip');
        }
        otherTooltip(el, text) {
            if (text !== '') $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                anchor: el,
                name: this.name + '_tooltip',
                html: text,
                position: 'top|bottom'
            });
            else $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '_tooltip');
        }
        showPlus(el, color) {
            $aa2bd8933167d9cb$export$2fa187e846a241c4(el).find('span:nth-child(1)').css('color', color);
        }
        resize() {
            let time = Date.now();
            // event before
            let edata = this.trigger('resize', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // default action
            if (this.box != null) {
                let rect = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0).getBoundingClientRect();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).css('overflow', 'hidden') // container should have no overflow
                ;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div').css({
                    width: rect.width + 'px',
                    height: rect.height + 'px'
                });
            }
            // event after
            edata.finish();
            return Date.now() - time;
        }
        destroy() {
            // event before
            let edata = this.trigger('destroy', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // clean up
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-sidebar-body').length > 0) this.unmount();
            delete $aa2bd8933167d9cb$export$dca4c93ccda43b77[this.name];
            // event after
            edata.finish();
        }
        unmount() {
            super.unmount();
            this.last.observeResize?.disconnect();
        }
        lock(msg, showSpinner) {
            let args = Array.from(arguments);
            args.unshift(this.box);
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lock(...args);
        }
        unlock(speed) {
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.unlock(this.box, speed);
        }
    }
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: mQuery, w2utils, w2base, w2tooltip
 *
 * == 2.0 changes
 *  - CSP - fixed inline events
 *  - removed jQuery dependency
 *  - observeResize for the box
 *  - refactored w2events
 *  - scrollIntoView - removed callback
 *  - scroll, scrollIntoView return promise
 *  - animateInsert, animateClose - returns a promise
 *  - add, insert return a promise
 *  - onMouseEnter, onMouseLeave, onMouseDown, onMouseUp
 */ class $aa2bd8933167d9cb$export$7d72bb041567afb5 extends $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        constructor(options){
            super(options.name);
            this.box = null // DOM Element that holds the element
            ;
            this.name = null // unique name for w2ui
            ;
            this.active = null;
            this.reorder = false;
            this.flow = 'down' // can be down or up
            ;
            this.tooltip = 'top|left' // can be top, bottom, left, right
            ;
            this.tabs = [];
            this.routeData = {} // data for dynamic routes
            ;
            this.last = {} // placeholder for internal variables
            ;
            this.right = '';
            this.style = '';
            this.onClick = null;
            this.onMouseEnter = null // mouse enter and lease
            ;
            this.onMouseLeave = null;
            this.onMouseDown = null;
            this.onMouseUp = null;
            this.onClose = null;
            this.onRender = null;
            this.onRefresh = null;
            this.onResize = null;
            this.onDestroy = null;
            this.tab_template = {
                id: null,
                text: null,
                route: null,
                hidden: false,
                disabled: false,
                closable: false,
                tooltip: null,
                style: '',
                onClick: null,
                onRefresh: null,
                onClose: null
            };
            let tabs = options.tabs;
            delete options.tabs;
            // mix in options
            Object.assign(this, options);
            // add item via method to makes sure item_template is applied
            if (Array.isArray(tabs)) this.add(tabs);
            // need to reassign back to keep it in config
            options.tabs = tabs;
            // render if box specified
            if (typeof this.box == 'string') this.box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0);
            if (this.box) this.render(this.box);
        }
        add(tab) {
            return this.insert(null, tab);
        }
        insert(id, tabs) {
            if (!Array.isArray(tabs)) tabs = [
                tabs
            ];
            // assume it is array
            let proms = [];
            tabs.forEach((tab)=>{
                // checks
                if (tab.id == null) {
                    console.log(`ERROR: The parameter "id" is required but not supplied. (obj: ${this.name})`);
                    return;
                }
                if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.checkUniqueId(tab.id, this.tabs, 'tabs', this.name)) return;
                // add tab
                let it = Object.assign({}, this.tab_template, tab);
                if (id == null) {
                    this.tabs.push(it);
                    proms.push(this.animateInsert(null, it));
                } else {
                    let middle = this.get(id, true);
                    let before = this.tabs[middle].id;
                    this.tabs.splice(middle, 0, it);
                    proms.push(this.animateInsert(before, it));
                }
            });
            return Promise.all(proms);
        }
        remove() {
            let effected = 0;
            Array.from(arguments).forEach((it)=>{
                let tab = this.get(it);
                if (!tab) return;
                effected++;
                // remove from array
                this.tabs.splice(this.get(tab.id, true), 1);
                // remove from screen
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#tabs_${this.name}_tab_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(tab.id)}`).remove();
            });
            this.resize();
            return effected;
        }
        select(id) {
            if (this.active == id || this.get(id) == null) return false;
            this.active = id;
            this.refresh();
            return true;
        }
        set(id, tab) {
            let index = this.get(id, true);
            if (index == null) return false;
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.tabs[index], tab);
            this.refresh(id);
            return true;
        }
        get(id, returnIndex) {
            if (arguments.length === 0) {
                let all = [];
                for(let i1 = 0; i1 < this.tabs.length; i1++)if (this.tabs[i1].id != null) all.push(this.tabs[i1].id);
                return all;
            } else for(let i2 = 0; i2 < this.tabs.length; i2++){
                if (this.tabs[i2].id == id) return returnIndex === true ? i2 : this.tabs[i2];
            }
            return null;
        }
        show() {
            let effected = [];
            Array.from(arguments).forEach((it)=>{
                let tab = this.get(it);
                if (!tab || tab.hidden === false) return;
                tab.hidden = false;
                effected.push(tab.id);
            });
            setTimeout(()=>{
                effected.forEach((it)=>{
                    this.refresh(it);
                    this.resize();
                });
            }, 15) // needs timeout
            ;
            return effected;
        }
        hide() {
            let effected = [];
            Array.from(arguments).forEach((it)=>{
                let tab = this.get(it);
                if (!tab || tab.hidden === true) return;
                tab.hidden = true;
                effected.push(tab.id);
            });
            setTimeout(()=>{
                effected.forEach((it)=>{
                    this.refresh(it);
                    this.resize();
                });
            }, 15) // needs timeout
            ;
            return effected;
        }
        enable() {
            let effected = [];
            Array.from(arguments).forEach((it)=>{
                let tab = this.get(it);
                if (!tab || tab.disabled === false) return;
                tab.disabled = false;
                effected.push(tab.id);
            });
            setTimeout(()=>{
                effected.forEach((it)=>{
                    this.refresh(it);
                });
            }, 15) // needs timeout
            ;
            return effected;
        }
        disable() {
            let effected = [];
            Array.from(arguments).forEach((it)=>{
                let tab = this.get(it);
                if (!tab || tab.disabled === true) return;
                tab.disabled = true;
                effected.push(tab.id);
            });
            setTimeout(()=>{
                effected.forEach((it)=>{
                    this.refresh(it);
                });
            }, 15) // needs timeout
            ;
            return effected;
        }
        dragMove(event1) {
            if (!this.last.reordering) return;
            let self1 = this;
            let info = this.last.moving;
            let tab = this.tabs[info.index];
            let next = _find(info.index, 1);
            let prev = _find(info.index, -1);
            let $el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(tab.id));
            if (info.divX > 0 && next) {
                let $nextEl = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(next.id));
                let width1 = parseInt($el.get(0).clientWidth);
                let width2 = parseInt($nextEl.get(0).clientWidth);
                if (width1 < width2) {
                    width1 = Math.floor(width1 / 3);
                    width2 = width2 - width1;
                } else {
                    width1 = Math.floor(width2 / 3);
                    width2 = width2 - width1;
                }
                if (info.divX > width2) {
                    let index = this.tabs.indexOf(next);
                    this.tabs.splice(info.index, 0, this.tabs.splice(index, 1)[0]) // reorder in the array
                    ;
                    info.$tab.before($nextEl.get(0));
                    info.$tab.css('opacity', 0);
                    Object.assign(this.last.moving, {
                        index: index,
                        divX: -width1,
                        x: event1.pageX + width1,
                        left: info.left + info.divX + width1
                    });
                    return;
                }
            }
            if (info.divX < 0 && prev) {
                let $prevEl = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(prev.id));
                let width1 = parseInt($el.get(0).clientWidth);
                let width2 = parseInt($prevEl.get(0).clientWidth);
                if (width1 < width2) {
                    width1 = Math.floor(width1 / 3);
                    width2 = width2 - width1;
                } else {
                    width1 = Math.floor(width2 / 3);
                    width2 = width2 - width1;
                }
                if (Math.abs(info.divX) > width2) {
                    let index = this.tabs.indexOf(prev);
                    this.tabs.splice(info.index, 0, this.tabs.splice(index, 1)[0]) // reorder in the array
                    ;
                    $prevEl.before(info.$tab);
                    info.$tab.css('opacity', 0);
                    Object.assign(info, {
                        index: index,
                        divX: width1,
                        x: event1.pageX - width1,
                        left: info.left + info.divX - width1
                    });
                    return;
                }
            }
            function _find(ind, inc) {
                ind += inc;
                let tab = self1.tabs[ind];
                if (tab && tab.hidden) tab = _find(ind, inc);
                return tab;
            }
        }
        mouseAction(action, id, event1) {
            let tab = this.get(id);
            let edata = this.trigger('mouse' + action, {
                target: id,
                tab: tab,
                object: tab,
                originalEvent: event1
            });
            if (edata.isCancelled === true || tab?.disabled || tab?.hidden) return;
            switch(action){
                case 'Enter':
                    this.tooltipShow(id);
                    break;
                case 'Leave':
                    this.tooltipHide(id);
                    break;
                case 'Down':
                    this.initReorder(id, event1);
                    break;
                case 'Up':
                    break;
            }
            edata.finish();
        }
        tooltipShow(id) {
            let tab = this.get(id);
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)).get(0);
            if (this.tooltip == null || tab?.disabled || this.last.reordering) return;
            let pos = this.tooltip;
            let txt = tab?.tooltip;
            if (typeof txt == 'function') txt = txt.call(this, tab);
            $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                anchor: el,
                name: this.name + '_tooltip',
                html: txt,
                position: pos
            });
        }
        tooltipHide(id) {
            if (this.tooltip == null) return;
            $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '_tooltip');
        }
        getTabHTML(id) {
            let index = this.get(id, true);
            let tab = this.tabs[index];
            if (tab == null) return false;
            if (tab.text == null && tab.caption != null) tab.text = tab.caption;
            if (tab.tooltip == null && tab.hint != null) tab.tooltip = tab.hint // for backward compatibility
            ;
            if (tab.caption != null) console.log('NOTICE: tabs tab.caption property is deprecated, please use tab.text. Tab -> ', tab);
            if (tab.hint != null) console.log('NOTICE: tabs tab.hint property is deprecated, please use tab.tooltip. Tab -> ', tab);
            let text = tab.text;
            if (typeof text == 'function') text = text.call(this, tab);
            if (text == null) text = '';
            let closable = '';
            let addStyle = '';
            if (tab.hidden) addStyle += 'display: none;';
            if (tab.disabled) addStyle += 'opacity: 0.2;';
            if (tab.closable && !tab.disabled) closable = `<div class="w2ui-tab-close w2ui-eaction ${this.active === tab.id ? 'active' : ''}"
                data-mousedown="stop" data-mouseup="clickClose|${tab.id}|event">
            </div>`;
            return `
            <div id="tabs_${this.name}_tab_${tab.id}" style="${addStyle} ${tab.style}"
                class="w2ui-tab w2ui-eaction ${this.active === tab.id ? 'active' : ''} ${tab.closable ? 'closable' : ''} ${tab.class ? tab.class : ''}"
                data-mouseenter="mouseAction|Enter|${tab.id}|event]"
                data-mouseleave="mouseAction|Leave|${tab.id}|event]"
                data-mousedown="mouseAction|Down|${tab.id}|event"
                data-mouseup="mouseAction|Up|${tab.id}|event"
                data-click="click|${tab.id}|event"
               >
                    ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(text) + closable}
            </div>`;
        }
        refresh(id) {
            let time = Date.now();
            if (this.flow == 'up') $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).addClass('w2ui-tabs-up');
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).removeClass('w2ui-tabs-up');
            // event before
            let edata = this.trigger('refresh', {
                target: id != null ? id : this.name,
                object: this.get(id)
            });
            if (edata.isCancelled === true) return;
            if (id == null) for(let i = 0; i < this.tabs.length; i++)this.refresh(this.tabs[i].id);
            else {
                // create or refresh only one item
                let selector = '#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id);
                let $tab = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(selector);
                let tabHTML = this.getTabHTML(id);
                if ($tab.length === 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_right').before(tabHTML);
                else if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.tab-animate-insert').length == 0) $tab.replace(tabHTML);
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`${selector}, ${selector} .w2ui-eaction`), this);
            }
            // right html
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_right').html(this.right);
            // event after
            edata.finish();
            // this.resize();
            return Date.now() - time;
        }
        render(box) {
            let time = Date.now();
            if (typeof box == 'string') box = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).get(0);
            // event before
            let edata = this.trigger('render', {
                target: this.name,
                box: box ?? this.box
            });
            if (edata.isCancelled === true) return;
            // default action
            if (box != null) {
                this.unmount() // clean previous control
                ;
                this.box = box;
            }
            if (!this.box) return false;
            // render all buttons
            let html = `
            <div class="w2ui-tabs-line"></div>
            <div class="w2ui-scroll-wrapper w2ui-eaction" data-mousedown="resize">
                <div id="tabs_${this.name}_right" class="w2ui-tabs-right">${this.right}</div>
            </div>
            <div class="w2ui-scroll-left w2ui-eaction" data-click='["scroll","left"]'></div>
            <div class="w2ui-scroll-right w2ui-eaction" data-click='["scroll","right"]'></div>`;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).attr('name', this.name).addClass('w2ui-reset w2ui-tabs').html(html);
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box)[0].style.cssText += this.style;
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-eaction'), this);
            // observe div resize
            this.last.observeResize = new ResizeObserver(()=>{
                this.resize();
            });
            this.last.observeResize.observe(this.box);
            // event after
            edata.finish();
            this.refresh();
            this.resize();
            return Date.now() - time;
        }
        initReorder(id, event1) {
            if (!this.reorder) return;
            let self1 = this;
            let $tab = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id));
            let tabIndex = this.get(id, true);
            let $ghost = $aa2bd8933167d9cb$export$2fa187e846a241c4($tab.get(0).cloneNode(true));
            let edata;
            $ghost.attr('id', '#tabs_' + this.name + '_tab_ghost');
            this.last.moving = {
                index: tabIndex,
                indexFrom: tabIndex,
                $tab: $tab,
                $ghost: $ghost,
                divX: 0,
                left: $tab.get(0).getBoundingClientRect().left,
                parentX: $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0).getBoundingClientRect().left,
                x: event1.pageX,
                opacity: $tab.css('opacity')
            };
            $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('.w2uiTabReorder').on('mousemove.w2uiTabReorder', function(event1) {
                if (!self1.last.reordering) {
                    // event before
                    edata = self1.trigger('reorder', {
                        target: self1.tabs[tabIndex].id,
                        indexFrom: tabIndex,
                        tab: self1.tabs[tabIndex]
                    });
                    if (edata.isCancelled === true) return;
                    $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '_tooltip');
                    self1.last.reordering = true;
                    $ghost.addClass('moving');
                    $ghost.css({
                        'pointer-events': 'none',
                        'position': 'absolute',
                        'left': $tab.get(0).getBoundingClientRect().left
                    });
                    $tab.css('opacity', 0);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('.w2ui-scroll-wrapper').append($ghost.get(0));
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('.w2ui-tab-close').hide();
                }
                self1.last.moving.divX = event1.pageX - self1.last.moving.x;
                $ghost.css('left', self1.last.moving.left - self1.last.moving.parentX + self1.last.moving.divX + 'px');
                self1.dragMove(event1);
            }).on('mouseup.w2uiTabReorder', function() {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('.w2uiTabReorder');
                $ghost.css({
                    'transition': '0.1s',
                    'left': self1.last.moving.$tab.get(0).getBoundingClientRect().left - self1.last.moving.parentX
                });
                $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('.w2ui-tab-close').show();
                setTimeout(()=>{
                    $ghost.remove();
                    $tab.css({
                        opacity: self1.last.moving.opacity
                    });
                    // self.render()
                    if (self1.last.reordering) edata.finish({
                        indexTo: self1.last.moving.index
                    });
                    self1.last.reordering = false;
                }, 100);
            });
        }
        scroll(direction, instant) {
            return new Promise((resolve, reject)=>{
                let scrollBox = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-scroll-wrapper');
                let scrollLeft = scrollBox.get(0).scrollLeft;
                let right = scrollBox.find('.w2ui-tabs-right').get(0);
                let width1 = scrollBox.parent().get(0).getBoundingClientRect().width;
                let width2 = scrollLeft + parseInt(right.offsetLeft) + parseInt(right.clientWidth);
                switch(direction){
                    case 'left':
                        {
                            let scroll1 = scrollLeft - width1 + 50 // 35 is width of both button
                            ;
                            if (scroll1 <= 0) scroll1 = 0;
                            scrollBox.get(0).scrollTo({
                                top: 0,
                                left: scroll1,
                                behavior: instant ? 'atuo' : 'smooth'
                            });
                            break;
                        }
                    case 'right':
                        {
                            let scroll1 = scrollLeft + width1 - 50 // 35 is width of both button
                            ;
                            if (scroll1 >= width2 - width1) scroll1 = width2 - width1;
                            scrollBox.get(0).scrollTo({
                                top: 0,
                                left: scroll1,
                                behavior: instant ? 'atuo' : 'smooth'
                            });
                            break;
                        }
                }
                setTimeout(()=>{
                    this.resize();
                    resolve();
                }, instant ? 0 : 350);
            });
        }
        scrollIntoView(id, instant) {
            return new Promise((resolve, reject)=>{
                if (id == null) id = this.active;
                let tab = this.get(id);
                if (tab == null) return;
                let tabEl = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id)).get(0);
                tabEl.scrollIntoView({
                    block: 'start',
                    inline: 'center',
                    behavior: instant ? 'atuo' : 'smooth'
                });
                setTimeout(()=>{
                    this.resize();
                    resolve();
                }, instant ? 0 : 500);
            });
        }
        resize() {
            let time = Date.now();
            if (this.box == null) return;
            // event before
            let edata = this.trigger('resize', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // show hide overflow buttons
            if (this.box != null) {
                let box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box);
                box.find('.w2ui-scroll-left, .w2ui-scroll-right').hide();
                let scrollBox = box.find('.w2ui-scroll-wrapper').get(0);
                let $right = box.find('.w2ui-tabs-right');
                let boxWidth = box.get(0).getBoundingClientRect().width;
                let itemsWidth = $right.length > 0 ? $right[0].offsetLeft + $right[0].clientWidth : 0;
                if (boxWidth < itemsWidth) {
                    // we have overflown content
                    if (scrollBox.scrollLeft > 0) box.find('.w2ui-scroll-left').show();
                    if (boxWidth < itemsWidth - scrollBox.scrollLeft) box.find('.w2ui-scroll-right').show();
                }
            }
            // event after
            edata.finish();
            return Date.now() - time;
        }
        destroy() {
            // event before
            let edata = this.trigger('destroy', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // clean up
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_right').length > 0) this.unmount();
            delete $aa2bd8933167d9cb$export$dca4c93ccda43b77[this.name];
            // event after
            edata.finish();
        }
        unmount() {
            super.unmount();
            this.last.observeResize?.disconnect();
        }
        // ===================================================
        // -- Internal Event Handlers
        click(id, event1) {
            let tab = this.get(id);
            if (tab == null || tab.disabled || this.last.reordering) return false;
            // event before
            let edata = this.trigger('click', {
                target: id,
                tab: tab,
                object: tab,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // default action
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(this.active)).removeClass('active');
            this.active = tab.id;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(this.active)).addClass('active');
            // route processing
            if (typeof tab.route == 'string') {
                let route = tab.route !== '' ? String('/' + tab.route).replace(/\/{2,}/g, '/') : '';
                let info = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseRoute(route);
                if (info.keys.length > 0) for(let k = 0; k < info.keys.length; k++){
                    if (this.routeData[info.keys[k].name] == null) continue;
                    route = route.replace(new RegExp(':' + info.keys[k].name, 'g'), this.routeData[info.keys[k].name]);
                }
                setTimeout(()=>{
                    window.location.hash = route;
                }, 1);
            }
            // event after
            edata.finish();
        }
        clickClose(id, event1) {
            let tab = this.get(id);
            if (tab == null || tab.disabled) return false;
            // event before
            let edata = this.trigger('close', {
                target: id,
                object: tab,
                tab: tab,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            this.animateClose(id).then(()=>{
                this.remove(id);
                edata.finish();
                this.refresh();
            });
            if (event1) event1.stopPropagation();
        }
        animateClose(id) {
            return new Promise((resolve, reject)=>{
                let $tab = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id));
                let width = parseInt($tab.get(0).clientWidth || 0);
                let anim = `<div class="tab-animate-close" style="display: inline-block; flex-shrink: 0; width: ${width}px; transition: width 0.25s"></div>`;
                let $anim = $tab.replace(anim);
                setTimeout(()=>{
                    $anim.css({
                        width: '0px'
                    });
                }, 1);
                setTimeout(()=>{
                    $anim.remove();
                    this.resize();
                    resolve();
                }, 500);
            });
        }
        animateInsert(id, tab) {
            return new Promise((resolve, reject)=>{
                let $before = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_' + this.name + '_tab_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(id));
                let $tab = $aa2bd8933167d9cb$export$2fa187e846a241c4.html(this.getTabHTML(tab.id));
                if ($before.length == 0) {
                    $before = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_tabs_right');
                    $before.before($tab);
                    this.resize();
                } else {
                    $tab.css({
                        opacity: 0
                    });
                    // first insert tab on the right to get its proper dimentions
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#tabs_tabs_right').before($tab.get(0));
                    let $tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#' + $tab.attr('id'));
                    let width = $tmp.get(0)?.clientWidth ?? 0;
                    // insert animation div
                    let $anim = $aa2bd8933167d9cb$export$2fa187e846a241c4.html('<div class="tab-animate-insert" style="flex-shrink: 0; width: 0; transition: width 0.25s"></div>');
                    $before.before($anim);
                    // hide tab and move it in the right position
                    $tab.hide();
                    $anim.before($tab[0]);
                    setTimeout(()=>{
                        $anim.css({
                            width: width + 'px'
                        });
                    }, 1);
                    setTimeout(()=>{
                        $anim.remove();
                        $tab.css({
                            opacity: 1
                        }).show();
                        this.refresh(tab.id);
                        this.resize();
                        resolve();
                    }, 500);
                }
            });
        }
    }
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: mQuery, w2utils, w2base, w2tabs, w2toolbar
 *
 * == 2.0 changes
 *  - CSP - fixed inline events
 *  - remove jQuery dependency
 *  - layout.confirm - refactored
 *  - layout.message - refactored
 *  - panel.removed
 */ let $aa2bd8933167d9cb$var$w2panels = [
        'top',
        'left',
        'main',
        'preview',
        'right',
        'bottom'
    ];
    class $aa2bd8933167d9cb$export$dac8796a64ad454e extends $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        constructor(options){
            super(options.name);
            this.box = null // DOM Element that holds the element
            ;
            this.name = null // unique name for w2ui
            ;
            this.panels = [];
            this.last = {};
            this.padding = 1 // panel padding
            ;
            this.resizer = 4 // resizer width or height
            ;
            this.style = '';
            this.onShow = null;
            this.onHide = null;
            this.onResizing = null;
            this.onResizerClick = null;
            this.onRender = null;
            this.onRefresh = null;
            this.onChange = null;
            this.onResize = null;
            this.onDestroy = null;
            this.panel_template = {
                type: null,
                title: '',
                size: 100,
                minSize: 20,
                maxSize: false,
                hidden: false,
                resizable: false,
                overflow: 'auto',
                style: '',
                html: '',
                tabs: null,
                toolbar: null,
                width: null,
                height: null,
                show: {
                    toolbar: false,
                    tabs: false
                },
                removed: null,
                onRefresh: null,
                onShow: null,
                onHide: null
            };
            // mix in options
            Object.assign(this, options);
            if (!Array.isArray(this.panels)) this.panels = [];
            // add defined panels
            this.panels.forEach((panel, ind)=>{
                this.panels[ind] = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.panel_template, panel);
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(panel.tabs) || Array.isArray(panel.tabs)) initTabs(this, panel.type);
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(panel.toolbar) || Array.isArray(panel.toolbar)) initToolbar(this, panel.type);
            });
            // add all other panels
            $aa2bd8933167d9cb$var$w2panels.forEach((tab)=>{
                if (this.get(tab) != null) return;
                this.panels.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.panel_template, {
                    type: tab,
                    hidden: tab !== 'main',
                    size: 50
                }));
            });
            // render if box specified
            if (typeof this.box == 'string') this.box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0);
            if (this.box) this.render(this.box);
            function initTabs(object, panel, tabs) {
                let pan = object.get(panel);
                if (pan != null && tabs == null) tabs = pan.tabs;
                if (pan == null || tabs == null) return false;
                // instantiate tabs
                if (Array.isArray(tabs)) tabs = {
                    tabs: tabs
                };
                let name = object.name + '_' + panel + '_tabs';
                if ($aa2bd8933167d9cb$export$dca4c93ccda43b77[name]) $aa2bd8933167d9cb$export$dca4c93ccda43b77[name].destroy() // destroy if existed
                ;
                pan.tabs = new $aa2bd8933167d9cb$export$7d72bb041567afb5($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, tabs, {
                    owner: object,
                    name: object.name + '_' + panel + '_tabs'
                }));
                pan.show.tabs = true;
                return true;
            }
            function initToolbar(object, panel, toolbar) {
                let pan = object.get(panel);
                if (pan != null && toolbar == null) toolbar = pan.toolbar;
                if (pan == null || toolbar == null) return false;
                // instantiate toolbar
                if (Array.isArray(toolbar)) toolbar = {
                    items: toolbar
                };
                let name = object.name + '_' + panel + '_toolbar';
                if ($aa2bd8933167d9cb$export$dca4c93ccda43b77[name]) $aa2bd8933167d9cb$export$dca4c93ccda43b77[name].destroy() // destroy if existed
                ;
                pan.toolbar = new $aa2bd8933167d9cb$export$d1962123e55f7d10($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, toolbar, {
                    owner: object,
                    name: object.name + '_' + panel + '_toolbar'
                }));
                pan.show.toolbar = true;
                return true;
            }
        }
        html(panel, data, transition) {
            let p = this.get(panel);
            let promise = {
                panel: panel,
                html: p.html,
                error: false,
                cancelled: false,
                removed (cb) {
                    if (typeof cb == 'function') p.removed = cb;
                }
            };
            if (typeof p.removed == 'function') {
                p.removed({
                    panel: panel,
                    html: p.html,
                    html_new: data,
                    transition: transition || 'none'
                });
                p.removed = null // this is one time call back only
                ;
            }
            // if it is CSS panel
            if (panel == 'css') {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_css').html('<style>' + data + '</style>');
                promise.status = true;
                return promise;
            }
            if (p == null) {
                console.log('ERROR: incorrect panel name. Panel name can be main, left, right, top, bottom, preview or css');
                promise.error = true;
                return promise;
            }
            if (data == null) return promise;
            // event before
            let edata = this.trigger('change', {
                target: panel,
                panel: p,
                html_new: data,
                transition: transition
            });
            if (edata.isCancelled === true) {
                promise.cancelled = true;
                return promise;
            }
            let pname = '#layout_' + this.name + '_panel_' + p.type;
            let current = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(pname + '> [data-role="panel-content"]');
            let panelTop = 0;
            if (current.length > 0) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(pname).get(0).scrollTop = 0;
                panelTop = $aa2bd8933167d9cb$export$2fa187e846a241c4(current).css('top');
            }
            // clean up previous content
            if (typeof p.html.unmount == 'function') p.html.unmount();
            current.addClass('w2ui-panel-content');
            current.removeAttr('style') // styles could have added manually, but all necessary will be added by resizeBoxes
            ;
            this.resizeBoxes(panel);
            if (p.html === '') {
                p.html = data;
                this.refresh(panel);
            } else {
                p.html = data;
                if (!p.hidden) {
                    if (transition != null && transition !== '') {
                        // apply transition
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).addClass('animating');
                        let div1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(pname + '> [data-role="panel-content"]');
                        div1.after('<div class="w2ui-panel-content new-panel" data-role="panel-content" style="' + div1[0].style.cssText + '"></div>');
                        let div2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(pname + '> [data-role="panel-content"].new-panel');
                        div1.css('top', panelTop);
                        div2.css('top', panelTop);
                        if (typeof data == 'object') {
                            data.box = div2[0] // do not do .render(box);
                            ;
                            data.render();
                        } else div2.hide().html(data);
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.transition(div1[0], div2[0], transition, ()=>{
                            div1.remove();
                            div2.removeClass('new-panel');
                            div2.css('overflow', p.overflow);
                            // make sure only one content left
                            $aa2bd8933167d9cb$export$2fa187e846a241c4($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(pname + '> [data-role="panel-content"]').get(1)).remove();
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).removeClass('animating');
                            this.refresh(panel);
                        });
                    } else this.refresh(panel);
                }
            }
            // event after
            edata.finish();
            return promise;
        }
        message(panel, options) {
            let p = this.get(panel);
            let box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + p.type);
            let oldOverflow = box.css('overflow');
            box.css('overflow', 'hidden');
            let prom = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.message({
                owner: this,
                box: box.get(0),
                after: '.w2ui-panel-title',
                param: panel
            }, options);
            if (prom) prom.self.on('close:after', ()=>{
                box.css('overflow', oldOverflow);
            });
            return prom;
        }
        confirm(panel, options) {
            let p = this.get(panel);
            let box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + p.type);
            let oldOverflow = box.css('overflow');
            box.css('overflow', 'hidden');
            let prom = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.confirm({
                owner: this,
                box: box.get(0),
                after: '.w2ui-panel-title',
                param: panel
            }, options);
            if (prom) prom.self.on('close:after', ()=>{
                box.css('overflow', oldOverflow);
            });
            return prom;
        }
        load(panel, url, transition) {
            return new Promise((resolve, reject)=>{
                if ((panel == 'css' || this.get(panel) != null) && url != null) fetch(url).then((resp)=>resp.text()).then((text)=>{
                    this.resize();
                    resolve(this.html(panel, text, transition));
                });
                else reject();
            });
        }
        sizeTo(panel, size, instant) {
            let pan = this.get(panel);
            if (pan == null) return false;
            // resize
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div > .w2ui-panel').css('transition', instant !== true ? '.2s' : '0s');
            setTimeout(()=>{
                this.set(panel, {
                    size: size
                });
            }, 1);
            // clean
            setTimeout(()=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div > .w2ui-panel').css('transition', '0s');
                this.resize();
            }, 300);
            return true;
        }
        show(panel, immediate) {
            // event before
            let edata = this.trigger('show', {
                target: panel,
                thisect: this.get(panel),
                immediate: immediate
            });
            if (edata.isCancelled === true) return;
            let p = this.get(panel);
            if (p == null) return false;
            p.hidden = false;
            if (immediate === true) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + panel).css({
                    'opacity': '1'
                });
                edata.finish();
                this.resize();
            } else {
                // resize
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).addClass('animating');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + panel).css({
                    'opacity': '0'
                });
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div > .w2ui-panel').css('transition', '.2s');
                setTimeout(()=>{
                    this.resize();
                }, 1);
                // show
                setTimeout(()=>{
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + panel).css({
                        'opacity': '1'
                    });
                }, 250);
                // clean
                setTimeout(()=>{
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div > .w2ui-panel').css('transition', '0s');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).removeClass('animating');
                    edata.finish();
                    this.resize();
                }, 300);
            }
            return true;
        }
        hide(panel, immediate) {
            // event before
            let edata = this.trigger('hide', {
                target: panel,
                object: this.get(panel),
                immediate: immediate
            });
            if (edata.isCancelled === true) return;
            let p = this.get(panel);
            if (p == null) return false;
            p.hidden = true;
            if (immediate === true) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + panel).css({
                    'opacity': '0'
                });
                edata.finish();
                this.resize();
            } else {
                // hide
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).addClass('animating');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div > .w2ui-panel').css('transition', '.2s');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + panel).css({
                    'opacity': '0'
                });
                setTimeout(()=>{
                    this.resize();
                }, 1);
                // clean
                setTimeout(()=>{
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div > .w2ui-panel').css('transition', '0s');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).removeClass('animating');
                    edata.finish();
                    this.resize();
                }, 300);
            }
            return true;
        }
        toggle(panel, immediate) {
            let p = this.get(panel);
            if (p == null) return false;
            if (p.hidden) return this.show(panel, immediate);
            else return this.hide(panel, immediate);
        }
        set(panel, options) {
            let ind = this.get(panel, true);
            if (ind == null) return false;
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.panels[ind], options);
            // refresh only when content changed
            if (options.html != null || options.resizable != null) this.refresh(panel);
            // show/hide resizer
            this.resize() // resize is needed when panel size is changed
            ;
            return true;
        }
        get(panel, returnIndex) {
            for(let p = 0; p < this.panels.length; p++)if (this.panels[p].type == panel) {
                if (returnIndex === true) return p;
                else return this.panels[p];
            }
            return null;
        }
        el(panel) {
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + panel + '> [data-role="panel-content"]');
            if (el.length != 1) return null;
            return el[0];
        }
        hideToolbar(panel) {
            let pan = this.get(panel);
            if (!pan) return;
            pan.show.toolbar = false;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#layout_${this.name}_panel_${panel} > [data-role="panel-toolbar"]`).hide();
            this.resize();
        }
        showToolbar(panel) {
            let pan = this.get(panel);
            if (!pan) return;
            pan.show.toolbar = true;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#layout_${this.name}_panel_${panel} > [data-role="panel-toolbar"]`).show();
            this.resize();
        }
        toggleToolbar(panel) {
            let pan = this.get(panel);
            if (!pan) return;
            if (pan.show.toolbar) this.hideToolbar(panel);
            else this.showToolbar(panel);
        }
        assignToolbar(panel, toolbar) {
            if (typeof toolbar == 'string' && $aa2bd8933167d9cb$export$dca4c93ccda43b77[toolbar] != null) toolbar = $aa2bd8933167d9cb$export$dca4c93ccda43b77[toolbar];
            let pan = this.get(panel);
            pan.toolbar = toolbar;
            let tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(panel + '> [data-role="panel-toolbar"]');
            if (pan.toolbar != null) {
                if (tmp.attr('name') != pan.toolbar.name) pan.toolbar.render(tmp.get(0));
                else if (pan.toolbar != null) pan.toolbar.refresh();
                toolbar.owner = this;
                this.showToolbar(panel);
                this.refresh(panel);
            } else {
                tmp.html('');
                this.hideToolbar(panel);
            }
        }
        hideTabs(panel) {
            let pan = this.get(panel);
            if (!pan) return;
            pan.show.tabs = false;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + panel + '> [data-role="panel-tabs"]').hide();
            this.resize();
        }
        showTabs(panel) {
            let pan = this.get(panel);
            if (!pan) return;
            pan.show.tabs = true;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_' + panel + '> [data-role="panel-tabs"]').show();
            this.resize();
        }
        toggleTabs(panel) {
            let pan = this.get(panel);
            if (!pan) return;
            if (pan.show.tabs) this.hideTabs(panel);
            else this.showTabs(panel);
        }
        render(box) {
            let time = Date.now();
            let self1 = this;
            if (typeof box == 'string') box = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).get(0);
            // if (window.getSelection) window.getSelection().removeAllRanges(); // clear selection
            // event before
            let edata = this.trigger('render', {
                target: this.name,
                box: box ?? this.box
            });
            if (edata.isCancelled === true) return;
            // default action
            if (box != null) {
                this.unmount() // clean previous control
                ;
                this.box = box;
            }
            if (!this.box) return false;
            // render layout
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).attr('name', this.name).addClass('w2ui-layout').html('<div></div>');
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box)[0].style.cssText += this.style;
            // create all panels
            for(let p1 = 0; p1 < $aa2bd8933167d9cb$var$w2panels.length; p1++){
                let html = '<div id="layout_' + this.name + '_panel_' + $aa2bd8933167d9cb$var$w2panels[p1] + '" class="w2ui-panel">' + '    <div class="w2ui-panel-title"></div>' + '    <div class="w2ui-panel-tabs" data-role="panel-tabs"></div>' + '    <div class="w2ui-panel-toolbar" data-role="panel-toolbar"></div>' + '    <div class="w2ui-panel-content" data-role="panel-content"></div>' + '</div>' + '<div id="layout_' + this.name + '_resizer_' + $aa2bd8933167d9cb$var$w2panels[p1] + '" class="w2ui-resizer"></div>';
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div').append(html);
            }
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div').append('<div id="layout_' + this.name + '_panel_css" style="position: absolute; top: 10000px;"></div>');
            this.refresh() // if refresh is not called here, the layout will not be available right after initialization
            ;
            // observe div resize
            this.last.observeResize = new ResizeObserver(()=>{
                this.resize();
            });
            this.last.observeResize.observe(this.box);
            // process event
            edata.finish();
            // re-init events
            setTimeout(()=>{
                self1.last.events = {
                    resizeStart: resizeStart,
                    mouseMove: mouseMove,
                    mouseUp: mouseUp
                };
                this.resize();
            }, 0);
            return Date.now() - time;
            function resizeStart(type, evnt) {
                if (!self1.box) return;
                if (!evnt) evnt = window.event;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('mousemove', self1.last.events.mouseMove).on('mousemove', self1.last.events.mouseMove);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('mouseup', self1.last.events.mouseUp).on('mouseup', self1.last.events.mouseUp);
                self1.last.resize = {
                    type: type,
                    x: evnt.screenX,
                    y: evnt.screenY,
                    diff_x: 0,
                    diff_y: 0,
                    value: 0
                };
                // lock all panels
                $aa2bd8933167d9cb$var$w2panels.forEach((panel)=>{
                    let $tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.el(panel)).find('.w2ui-lock');
                    if ($tmp.length > 0) $tmp.data('locked', 'yes');
                    else self1.lock(panel, {
                        opacity: 0
                    });
                });
                let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('#layout_' + self1.name + '_resizer_' + type).get(0);
                if (type == 'left' || type == 'right') self1.last.resize.value = parseInt(el.style.left);
                if (type == 'top' || type == 'preview' || type == 'bottom') self1.last.resize.value = parseInt(el.style.top);
            }
            function mouseUp(evnt) {
                if (!self1.box) return;
                if (!evnt) evnt = window.event;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('mousemove', self1.last.events.mouseMove);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('mouseup', self1.last.events.mouseUp);
                if (self1.last.resize == null) return;
                // unlock all panels
                $aa2bd8933167d9cb$var$w2panels.forEach((panel)=>{
                    let $tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.el(panel)).find('.w2ui-lock');
                    if ($tmp.data('locked') == 'yes') $tmp.removeData('locked');
                    else self1.unlock(panel);
                });
                // set new size
                if (self1.last.diff_x !== 0 || self1.last.resize.diff_y !== 0) {
                    let ptop = self1.get('top');
                    let pbottom = self1.get('bottom');
                    let panel = self1.get(self1.last.resize.type);
                    let width = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize($aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box), 'width');
                    let height = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize($aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box), 'height');
                    let str = String(panel.size);
                    let ns, nd;
                    switch(self1.last.resize.type){
                        case 'top':
                            ns = parseInt(panel.sizeCalculated) + self1.last.resize.diff_y;
                            nd = 0;
                            break;
                        case 'bottom':
                            ns = parseInt(panel.sizeCalculated) - self1.last.resize.diff_y;
                            nd = 0;
                            break;
                        case 'preview':
                            ns = parseInt(panel.sizeCalculated) - self1.last.resize.diff_y;
                            nd = (ptop && !ptop.hidden ? ptop.sizeCalculated : 0) + (pbottom && !pbottom.hidden ? pbottom.sizeCalculated : 0);
                            break;
                        case 'left':
                            ns = parseInt(panel.sizeCalculated) + self1.last.resize.diff_x;
                            nd = 0;
                            break;
                        case 'right':
                            ns = parseInt(panel.sizeCalculated) - self1.last.resize.diff_x;
                            nd = 0;
                            break;
                    }
                    // set size
                    if (str.substr(str.length - 1) == '%') panel.size = Math.floor(ns * 100 / (panel.type == 'left' || panel.type == 'right' ? width : height - nd) * 100) / 100 + '%';
                    else if (String(panel.size).substr(0, 1) == '-') panel.size = parseInt(panel.size) - panel.sizeCalculated + ns;
                    else panel.size = ns;
                    self1.resize();
                }
                $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('#layout_' + self1.name + '_resizer_' + self1.last.resize.type).removeClass('active');
                delete self1.last.resize;
            }
            function mouseMove(evnt) {
                if (!self1.box) return;
                if (!evnt) evnt = window.event;
                if (self1.last.resize == null) return;
                let panel = self1.get(self1.last.resize.type);
                // event before
                let tmp = self1.last.resize;
                let edata = self1.trigger('resizing', {
                    target: self1.name,
                    object: panel,
                    originalEvent: evnt,
                    panel: tmp ? tmp.type : 'all',
                    diff_x: tmp ? tmp.diff_x : 0,
                    diff_y: tmp ? tmp.diff_y : 0
                });
                if (edata.isCancelled === true) return;
                let p = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('#layout_' + self1.name + '_resizer_' + tmp.type);
                let resize_x = evnt.screenX - tmp.x;
                let resize_y = evnt.screenY - tmp.y;
                let mainPanel = self1.get('main');
                if (!p.hasClass('active')) p.addClass('active');
                switch(tmp.type){
                    case 'left':
                        if (panel.minSize - resize_x > panel.width) resize_x = panel.minSize - panel.width;
                        if (panel.maxSize && panel.width + resize_x > panel.maxSize) resize_x = panel.maxSize - panel.width;
                        if (mainPanel.minSize + resize_x > mainPanel.width) resize_x = mainPanel.width - mainPanel.minSize;
                        break;
                    case 'right':
                        if (panel.minSize + resize_x > panel.width) resize_x = panel.width - panel.minSize;
                        if (panel.maxSize && panel.width - resize_x > panel.maxSize) resize_x = panel.width - panel.maxSize;
                        if (mainPanel.minSize - resize_x > mainPanel.width) resize_x = mainPanel.minSize - mainPanel.width;
                        break;
                    case 'top':
                        if (panel.minSize - resize_y > panel.height) resize_y = panel.minSize - panel.height;
                        if (panel.maxSize && panel.height + resize_y > panel.maxSize) resize_y = panel.maxSize - panel.height;
                        if (mainPanel.minSize + resize_y > mainPanel.height) resize_y = mainPanel.height - mainPanel.minSize;
                        break;
                    case 'preview':
                    case 'bottom':
                        if (panel.minSize + resize_y > panel.height) resize_y = panel.height - panel.minSize;
                        if (panel.maxSize && panel.height - resize_y > panel.maxSize) resize_y = panel.height - panel.maxSize;
                        if (mainPanel.minSize - resize_y > mainPanel.height) resize_y = mainPanel.minSize - mainPanel.height;
                        break;
                }
                tmp.diff_x = resize_x;
                tmp.diff_y = resize_y;
                switch(tmp.type){
                    case 'top':
                    case 'preview':
                    case 'bottom':
                        tmp.diff_x = 0;
                        if (p.length > 0) p[0].style.top = tmp.value + tmp.diff_y + 'px';
                        break;
                    case 'left':
                    case 'right':
                        tmp.diff_y = 0;
                        if (p.length > 0) p[0].style.left = tmp.value + tmp.diff_x + 'px';
                        break;
                }
                // event after
                edata.finish();
            }
        }
        unmount() {
            super.unmount();
            this.panels.forEach((panel)=>{
                panel.tabs?.unmount?.();
                panel.toolbar?.unmount?.();
            });
            this.last.observeResize?.disconnect();
        }
        destroy() {
            // event before
            let edata = this.trigger('destroy', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            if ($aa2bd8933167d9cb$export$dca4c93ccda43b77[this.name] == null) return false;
            // clean up
            this.panels.forEach((panel)=>{
                panel.tabs?.destroy?.();
                panel.toolbar?.destroy?.();
            });
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_main').length > 0) this.unmount();
            delete $aa2bd8933167d9cb$export$dca4c93ccda43b77[this.name];
            // event after
            edata.finish();
            if (this.last.events && this.last.events.resize) $aa2bd8933167d9cb$export$2fa187e846a241c4(window).off('resize', this.last.events.resize);
            return true;
        }
        refresh(panel) {
            let self1 = this;
            // if (window.getSelection) window.getSelection().removeAllRanges(); // clear selection
            if (panel == null) panel = null;
            let time = Date.now();
            // event before
            let edata = self1.trigger('refresh', {
                target: panel != null ? panel : self1.name,
                object: self1.get(panel)
            });
            if (edata.isCancelled === true) return;
            // self.unlock(panel);
            if (typeof panel == 'string') {
                let p = self1.get(panel);
                if (p == null) return;
                let pname = '#layout_' + self1.name + '_panel_' + p.type;
                let rname = '#layout_' + self1.name + '_resizer_' + p.type;
                // apply properties to the panel
                $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname).css({
                    display: p.hidden ? 'none' : 'block'
                });
                if (p.resizable) $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(rname).show();
                else $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(rname).hide();
                // insert content
                if (typeof p.html == 'object' && typeof p.html.render === 'function') {
                    p.html.box = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname + '> [data-role="panel-content"]')[0];
                    setTimeout(()=>{
                        // need to remove unnecessary classes
                        if ($aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname + '> [data-role="panel-content"]').length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname + '> [data-role="panel-content"]').removeClass().removeAttr('name').addClass('w2ui-panel-content').css('overflow', p.overflow)[0].style.cssText += ';' + p.style;
                        if (p.html && typeof p.html.render == 'function') p.html.render() // do not do .render(box);
                        ;
                    }, 1);
                } else if ($aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname + '> [data-role="panel-content"]').length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname + '> [data-role="panel-content"]').removeClass().removeAttr('name').addClass('w2ui-panel-content').html(p.html).css('overflow', p.overflow)[0].style.cssText += ';' + p.style;
                // if there are tabs and/or toolbar - render it
                let tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname + '> [data-role="panel-tabs"]');
                if (p.show.tabs) {
                    if (tmp.attr('name') != p.tabs.name && p.tabs != null) p.tabs.render(tmp.get(0));
                    else p.tabs.refresh();
                    tmp.addClass('w2ui-panel-tabs');
                } else tmp.html('').removeAttr('name').removeClass('w2ui-tabs').hide();
                tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname + '> [data-role="panel-toolbar"]');
                if (p.show.toolbar) {
                    if (tmp.attr('name') != p.toolbar.name && p.toolbar != null) p.toolbar.render(tmp.get(0));
                    else p.toolbar.refresh();
                    tmp.addClass('w2ui-panel-toolbar');
                } else tmp.html('').removeAttr('name').removeClass('w2ui-toolbar').hide();
                // show enableAccess
                tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(pname + '> .w2ui-panel-title');
                if (p.title) tmp.html(p.title).show();
                else tmp.html('').hide();
            } else {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('#layout_' + self1.name + '_panel_main').length === 0) {
                    self1.render();
                    return;
                }
                self1.resize();
                // refresh all of them
                for(let p1 = 0; p1 < this.panels.length; p1++)self1.refresh(this.panels[p1].type);
            }
            edata.finish();
            return Date.now() - time;
        }
        resize() {
            // if (window.getSelection) window.getSelection().removeAllRanges();    // clear selection
            if (!this.box) return false;
            let time = Date.now();
            // event before
            let tmp = this.last.resize;
            let edata = this.trigger('resize', {
                target: this.name,
                panel: tmp ? tmp.type : 'all',
                diff_x: tmp ? tmp.diff_x : 0,
                diff_y: tmp ? tmp.diff_y : 0
            });
            if (edata.isCancelled === true) return;
            if (this.padding < 0) this.padding = 0;
            // layout itself
            // width includes border and padding, we need to exclude that so panels
            // are sized correctly
            let width = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box), 'width');
            let height = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box), 'height');
            let self1 = this;
            // panels
            let pmain = this.get('main');
            let pprev = this.get('preview');
            let pleft = this.get('left');
            let pright = this.get('right');
            let ptop = this.get('top');
            let pbottom = this.get('bottom');
            let sprev = pprev != null && pprev.hidden !== true ? true : false;
            let sleft = pleft != null && pleft.hidden !== true ? true : false;
            let sright = pright != null && pright.hidden !== true ? true : false;
            let stop = ptop != null && ptop.hidden !== true ? true : false;
            let sbottom = pbottom != null && pbottom.hidden !== true ? true : false;
            let l, t, w, h;
            // calculate %
            for(let p = 0; p < $aa2bd8933167d9cb$var$w2panels.length; p++){
                if ($aa2bd8933167d9cb$var$w2panels[p] === 'main') continue;
                tmp = this.get($aa2bd8933167d9cb$var$w2panels[p]);
                if (!tmp) continue;
                let str = String(tmp.size || 0);
                if (str.substr(str.length - 1) == '%') {
                    let tmph = height;
                    if (tmp.type == 'preview') tmph = tmph - (ptop && !ptop.hidden ? ptop.sizeCalculated : 0) - (pbottom && !pbottom.hidden ? pbottom.sizeCalculated : 0);
                    tmp.sizeCalculated = parseInt((tmp.type == 'left' || tmp.type == 'right' ? width : tmph) * parseFloat(tmp.size) / 100);
                } else tmp.sizeCalculated = parseInt(tmp.size);
                tmp.sizeCalculated = Math.max(tmp.sizeCalculated, parseInt(tmp.minSize));
            }
            // negative size
            if (String(pright.size).substr(0, 1) == '-') {
                if (sleft && String(pleft.size).substr(0, 1) == '-') console.log('ERROR: you cannot have both left panel.size and right panel.size be negative.');
                else pright.sizeCalculated = width - (sleft ? pleft.sizeCalculated : 0) + parseInt(pright.size);
            }
            if (String(pleft.size).substr(0, 1) == '-') {
                if (sright && String(pright.size).substr(0, 1) == '-') console.log('ERROR: you cannot have both left panel.size and right panel.size be negative.');
                else pleft.sizeCalculated = width - (sright ? pright.sizeCalculated : 0) + parseInt(pleft.size);
            }
            // top if any
            if (ptop != null && ptop.hidden !== true) {
                l = 0;
                t = 0;
                w = width;
                h = ptop.sizeCalculated;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_top').css({
                    'display': 'block',
                    'left': l + 'px',
                    'top': t + 'px',
                    'width': w + 'px',
                    'height': h + 'px'
                });
                ptop.width = w;
                ptop.height = h;
                // resizer
                if (ptop.resizable) {
                    t = ptop.sizeCalculated - (this.padding === 0 ? this.resizer : 0);
                    h = this.resizer > this.padding ? this.resizer : this.padding;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_top').css({
                        'display': 'block',
                        'left': l + 'px',
                        'top': t + 'px',
                        'width': w + 'px',
                        'height': h + 'px',
                        'cursor': 'ns-resize'
                    }).off('mousedown').on('mousedown', function(event1) {
                        event1.preventDefault();
                        // event before
                        let edata = self1.trigger('resizerClick', {
                            target: 'top',
                            originalEvent: event1
                        });
                        if (edata.isCancelled === true) return;
                        // default action
                        $aa2bd8933167d9cb$export$dca4c93ccda43b77[self1.name].last.events.resizeStart('top', event1);
                        // event after
                        edata.finish();
                        return false;
                    });
                }
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_top').hide();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_top').hide();
            }
            // left if any
            if (pleft != null && pleft.hidden !== true) {
                l = 0;
                t = 0 + (stop ? ptop.sizeCalculated + this.padding : 0);
                w = pleft.sizeCalculated;
                h = height - (stop ? ptop.sizeCalculated + this.padding : 0) - (sbottom ? pbottom.sizeCalculated + this.padding : 0);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_left').css({
                    'display': 'block',
                    'left': l + 'px',
                    'top': t + 'px',
                    'width': w + 'px',
                    'height': h + 'px'
                });
                pleft.width = w;
                pleft.height = h;
                // resizer
                if (pleft.resizable) {
                    l = pleft.sizeCalculated - (this.padding === 0 ? this.resizer : 0);
                    w = this.resizer > this.padding ? this.resizer : this.padding;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_left').css({
                        'display': 'block',
                        'left': l + 'px',
                        'top': t + 'px',
                        'width': w + 'px',
                        'height': h + 'px',
                        'cursor': 'ew-resize'
                    }).off('mousedown').on('mousedown', function(event1) {
                        event1.preventDefault();
                        // event before
                        let edata = self1.trigger('resizerClick', {
                            target: 'left',
                            originalEvent: event1
                        });
                        if (edata.isCancelled === true) return;
                        // default action
                        $aa2bd8933167d9cb$export$dca4c93ccda43b77[self1.name].last.events.resizeStart('left', event1);
                        // event after
                        edata.finish();
                        return false;
                    });
                }
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_left').hide();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_left').hide();
            }
            // right if any
            if (pright != null && pright.hidden !== true) {
                l = width - pright.sizeCalculated;
                t = 0 + (stop ? ptop.sizeCalculated + this.padding : 0);
                w = pright.sizeCalculated;
                h = height - (stop ? ptop.sizeCalculated + this.padding : 0) - (sbottom ? pbottom.sizeCalculated + this.padding : 0);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_right').css({
                    'display': 'block',
                    'left': l + 'px',
                    'top': t + 'px',
                    'width': w + 'px',
                    'height': h + 'px'
                });
                pright.width = w;
                pright.height = h;
                // resizer
                if (pright.resizable) {
                    l = l - this.padding;
                    w = this.resizer > this.padding ? this.resizer : this.padding;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_right').css({
                        'display': 'block',
                        'left': l + 'px',
                        'top': t + 'px',
                        'width': w + 'px',
                        'height': h + 'px',
                        'cursor': 'ew-resize'
                    }).off('mousedown').on('mousedown', function(event1) {
                        event1.preventDefault();
                        // event before
                        let edata = self1.trigger('resizerClick', {
                            target: 'right',
                            originalEvent: event1
                        });
                        if (edata.isCancelled === true) return;
                        // default action
                        $aa2bd8933167d9cb$export$dca4c93ccda43b77[self1.name].last.events.resizeStart('right', event1);
                        // event after
                        edata.finish();
                        return false;
                    });
                }
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_right').hide();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_right').hide();
            }
            // bottom if any
            if (pbottom != null && pbottom.hidden !== true) {
                l = 0;
                t = height - pbottom.sizeCalculated;
                w = width;
                h = pbottom.sizeCalculated;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_bottom').css({
                    'display': 'block',
                    'left': l + 'px',
                    'top': t + 'px',
                    'width': w + 'px',
                    'height': h + 'px'
                });
                pbottom.width = w;
                pbottom.height = h;
                // resizer
                if (pbottom.resizable) {
                    t = t - (this.padding === 0 ? 0 : this.padding);
                    h = this.resizer > this.padding ? this.resizer : this.padding;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_bottom').css({
                        'display': 'block',
                        'left': l + 'px',
                        'top': t + 'px',
                        'width': w + 'px',
                        'height': h + 'px',
                        'cursor': 'ns-resize'
                    }).off('mousedown').on('mousedown', function(event1) {
                        event1.preventDefault();
                        // event before
                        let edata = self1.trigger('resizerClick', {
                            target: 'bottom',
                            originalEvent: event1
                        });
                        if (edata.isCancelled === true) return;
                        // default action
                        $aa2bd8933167d9cb$export$dca4c93ccda43b77[self1.name].last.events.resizeStart('bottom', event1);
                        // event after
                        edata.finish();
                        return false;
                    });
                }
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_bottom').hide();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_bottom').hide();
            }
            // main - always there
            l = 0 + (sleft ? pleft.sizeCalculated + this.padding : 0);
            t = 0 + (stop ? ptop.sizeCalculated + this.padding : 0);
            w = width - (sleft ? pleft.sizeCalculated + this.padding : 0) - (sright ? pright.sizeCalculated + this.padding : 0);
            h = height - (stop ? ptop.sizeCalculated + this.padding : 0) - (sbottom ? pbottom.sizeCalculated + this.padding : 0) - (sprev ? pprev.sizeCalculated + this.padding : 0);
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_main').css({
                'display': 'block',
                'left': l + 'px',
                'top': t + 'px',
                'width': w + 'px',
                'height': h + 'px'
            });
            pmain.width = w;
            pmain.height = h;
            // preview if any
            if (pprev != null && pprev.hidden !== true) {
                l = 0 + (sleft ? pleft.sizeCalculated + this.padding : 0);
                t = height - (sbottom ? pbottom.sizeCalculated + this.padding : 0) - pprev.sizeCalculated;
                w = width - (sleft ? pleft.sizeCalculated + this.padding : 0) - (sright ? pright.sizeCalculated + this.padding : 0);
                h = pprev.sizeCalculated;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_preview').css({
                    'display': 'block',
                    'left': l + 'px',
                    'top': t + 'px',
                    'width': w + 'px',
                    'height': h + 'px'
                });
                pprev.width = w;
                pprev.height = h;
                // resizer
                if (pprev.resizable) {
                    t = t - (this.padding === 0 ? 0 : this.padding);
                    h = this.resizer > this.padding ? this.resizer : this.padding;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_preview').css({
                        'display': 'block',
                        'left': l + 'px',
                        'top': t + 'px',
                        'width': w + 'px',
                        'height': h + 'px',
                        'cursor': 'ns-resize'
                    }).off('mousedown').on('mousedown', function(event1) {
                        event1.preventDefault();
                        // event before
                        let edata = self1.trigger('resizerClick', {
                            target: 'preview',
                            originalEvent: event1
                        });
                        if (edata.isCancelled === true) return;
                        // default action
                        $aa2bd8933167d9cb$export$dca4c93ccda43b77[self1.name].last.events.resizeStart('preview', event1);
                        // event after
                        edata.finish();
                        return false;
                    });
                }
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_panel_preview').hide();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#layout_' + this.name + '_resizer_preview').hide();
            }
            // resizes boxes for header, tabs, toolbar inside the panel
            this.resizeBoxes();
            edata.finish();
            return Date.now() - time;
        }
        resizeBoxes(panel) {
            let panels = $aa2bd8933167d9cb$var$w2panels;
            if (!panel && typeof panel == 'string') panels = [
                panel
            ];
            // display tabs and toolbar if needed
            panels.forEach((pname, ind)=>{
                let pan = this.get($aa2bd8933167d9cb$var$w2panels[ind]);
                let tmp2 = `#layout_${this.name}_panel_${pname} > `;
                let topHeight = 0;
                if (pan) {
                    if (pan.title) {
                        let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(tmp2 + '.w2ui-panel-title').css({
                            top: topHeight + 'px',
                            display: 'block'
                        });
                        topHeight += $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(el, 'height');
                    }
                    if (pan.show.tabs) {
                        let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(tmp2 + '[data-role="panel-tabs"]').css({
                            top: topHeight + 'px',
                            display: 'block'
                        });
                        topHeight += $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(el, 'height');
                    }
                    if (pan.show.toolbar) {
                        let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(tmp2 + '[data-role="panel-toolbar"]').css({
                            top: topHeight + 'px',
                            display: 'block'
                        });
                        topHeight += $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(el, 'height');
                    }
                }
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(tmp2 + '[data-role="panel-content"]').css({
                    display: 'block',
                    top: topHeight + 'px'
                });
            });
        }
        lock(panel, msg, showSpinner) {
            if ($aa2bd8933167d9cb$var$w2panels.indexOf(panel) == -1) {
                console.log('ERROR: First parameter needs to be the a valid panel name.');
                return;
            }
            let args = Array.from(arguments);
            args[0] = '#layout_' + this.name + '_panel_' + panel;
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lock(...args);
        }
        unlock(panel, speed) {
            if ($aa2bd8933167d9cb$var$w2panels.indexOf(panel) == -1) {
                console.log('ERROR: First parameter needs to be the a valid panel name.');
                return;
            }
            let nm = '#layout_' + this.name + '_panel_' + panel;
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.unlock(nm, speed);
        }
    }
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: jQuery, w2utils, w2base, w2toolbar, w2field
 *
 * == TODO ==
 *  - problem with .set() and arrays, array get extended too, but should be replaced
 *  - allow functions in routeData (also add routeData to list/enum)
 *  - send parsed URL to the event if there is routeData
 *  - add selectType: 'none' so that no selection can be make but with mouse
 *  - focus/blur for selectType = cell not display grayed out selection
 *  - allow enum in inline edit (see https://github.com/vitmalina/w2ui/issues/911#issuecomment-107341193)
 *  - remote source, but localSort/localSearch
 *  - promise for request, load, save, etc.
 *  - onloadmore event (so it will be easy to implement remote data source with local sort)
 *  - queryStatus() - clears on next select, etc. Should not if it is off
 *
 * == DEMOS To create ==
 *  - batch for denied buttons
 *  - natural sort
 *
 * == 2.0 changes
 *  - toolbarInput - deprecated, toolbarSearch stays
 *  - searchSuggest
 *  - searchSave, searchSelected, savedSearches, defaultSearches, useLocalStorage, searchFieldTooltip
 *  - cache, cacheSave
 *  - onSearchSave, onSearchRemove, onSearchSelect
 *  - show.searchLogic
 *  - show.searchSave
 *  - refreshSearch
 *  - initAllFields -> searchInitInput
 *  - textSearch - deprecated in favor of defaultOperator
 *  - grid.confirm - refactored
 *  - grid.message - refactored
 *  - search.type == 'text' can have 'in' and 'not in' operators, then it will switch to enum
 *  - grid.find(..., displayedOnly)
 *  - column.render(..., this) - added
 *  - observeResize for the box
 *  - remove edit.type == 'select'
 *  - editDone(...)
 *  - liveSearch
 *  - deprecated onUnselect event
 *  - requestComplete(data, action, callBack, resolve, reject) - new argument list
 *  - msgAJAXError -> msgHTTPError
 *  - aded msgServerError
 *  - deleted grid.method
 *  - added mouseEnter/mouseLeave
 *  - grid.show.columnReorder -> grid.reorderRows
 *  - updagte docs search.label (not search.text)
 *  - added columnAutoSize - which resizes column based on text in it
 *  - added grid.replace()
 */ class $aa2bd8933167d9cb$export$b4cb041b06327cfa extends $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        constructor(options){
            super(options.name);
            this.name = null;
            this.box = null // HTML element that hold this element
            ;
            this.columns = [] // { field, text, size, attr, render, hidden, gridMinWidth, editable }
            ;
            this.columnGroups = [] // { span: int, text: 'string', main: true/false, style: 'string' }
            ;
            this.records = [] // { recid: int(required), field1: 'value1', ... fieldN: 'valueN', style: 'string',  changes: object }
            ;
            this.summary = [] // array of summary records, same structure as records array
            ;
            this.searches = [] // { type, label, field, attr, text, hidden }
            ;
            this.toolbar = {} // if not empty object; then it is toolbar object
            ;
            this.ranges = [];
            this.contextMenu = [];
            this.searchMap = {} // re-map_ctx search fields
            ;
            this.searchData = [];
            this.sortMap = {} // re-map_ctx sort fields
            ;
            this.sortData = [];
            this.savedSearches = [];
            this.defaultSearches = [];
            this.total = 0 // server total
            ;
            this.recid = null // field from records to be used as recid
            ;
            // internal
            this.last = {
                field: '',
                label: '',
                logic: 'AND',
                search: '',
                searchIds: [],
                selection: {
                    indexes: [],
                    columns: {}
                },
                saved_sel: null,
                multi: false,
                fetch: {
                    action: '',
                    offset: null,
                    start: 0,
                    response: 0,
                    options: null,
                    controller: null,
                    loaded: false,
                    hasMore: false // flag to indicate if there are more items to pull from the server
                },
                vscroll: {
                    scrollTop: 0,
                    scrollLeft: 0,
                    recIndStart: null,
                    recIndEnd: null,
                    colIndStart: 0,
                    colIndEnd: 0,
                    pull_more: false,
                    pull_refresh: true,
                    show_extra: 0
                },
                sel_ind: null,
                sel_col: null,
                sel_type: null,
                sel_recid: null,
                idCache: {},
                move: null,
                cancelClick: null,
                inEditMode: false,
                _edit: null,
                kbd_timer: null,
                marker_timer: null,
                click_time: null,
                click_recid: null,
                bubbleEl: null,
                colResizing: false,
                tmp: null,
                copy_event: null,
                userSelect: '',
                columnDrag: false,
                state: null,
                toolbar_height: 0
            };
            this.header = '';
            this.url = '';
            this.limit = 100;
            this.offset = 0 // how many records to skip (for infinite scroll) when pulling from server
            ;
            this.postData = {};
            this.routeData = {};
            this.httpHeaders = {};
            this.show = {
                header: false,
                toolbar: false,
                footer: false,
                columnMenu: true,
                columnHeaders: true,
                lineNumbers: false,
                expandColumn: false,
                selectColumn: false,
                emptyRecords: true,
                toolbarReload: true,
                toolbarColumns: false,
                toolbarSearch: true,
                toolbarAdd: false,
                toolbarEdit: false,
                toolbarDelete: false,
                toolbarSave: false,
                searchAll: true,
                searchLogic: true,
                searchHiddenMsg: false,
                searchSave: true,
                statusRange: true,
                statusBuffered: false,
                statusRecordID: true,
                statusSelection: true,
                statusResponse: true,
                statusSort: false,
                statusSearch: false,
                recordTitles: false,
                selectionBorder: true,
                selectionResizer: true,
                skipRecords: true,
                saveRestoreState: true
            };
            this.stateId = null // Custom state name for stateSave, stateRestore and stateReset
            ;
            this.hasFocus = false;
            this.autoLoad = true // for infinite scroll
            ;
            this.fixedBody = true // if false; then grid grows with data
            ;
            this.recordHeight = 32;
            this.lineNumberWidth = 34;
            this.keyboard = true;
            this.selectType = 'row' // can be row|cell
            ;
            this.liveSearch = false // if true, it will auto search if typed in search_all
            ;
            this.multiSearch = true;
            this.multiSelect = true;
            this.multiSort = true;
            this.reorderColumns = false;
            this.reorderRows = false;
            this.showExtraOnSearch = 0 // show extra records before and after on search
            ;
            this.markSearch = true;
            this.columnTooltip = 'top|bottom' // can be top, bottom, left, right
            ;
            this.disableCVS = false // disable Column Virtual Scroll
            ;
            this.nestedFields = true // use field name containing dots as separator to look into object
            ;
            this.vs_start = 150;
            this.vs_extra = 5;
            this.style = '';
            this.tabIndex = null;
            this.dataType = null // if defined, then overwrites w2utils.settings.dataType
            ;
            this.parser = null;
            this.advanceOnEdit = true // automatically begin editing the next cell after submitting an inline edit?
            ;
            this.useLocalStorage = true;
            // default values for the column
            this.colTemplate = {
                text: '',
                field: '',
                size: null,
                min: 20,
                max: null,
                gridMinWidth: null,
                sizeCorrected: null,
                sizeCalculated: null,
                sizeOriginal: null,
                sizeType: null,
                hidden: false,
                sortable: false,
                sortMode: null,
                searchable: false,
                resizable: true,
                hideable: true,
                autoResize: null,
                attr: '',
                style: '',
                render: null,
                title: null,
                tooltip: null,
                editable: {},
                frozen: false,
                info: null,
                clipboardCopy: false
            };
            // these column properties will be saved in stateSave()
            this.stateColProps = {
                text: false,
                field: true,
                size: true,
                min: false,
                max: false,
                gridMinWidth: false,
                sizeCorrected: false,
                sizeCalculated: true,
                sizeOriginal: true,
                sizeType: true,
                hidden: true,
                sortable: false,
                sortMode: true,
                searchable: false,
                resizable: false,
                hideable: false,
                autoResize: false,
                attr: false,
                style: false,
                render: false,
                title: false,
                tooltip: false,
                editable: false,
                frozen: true,
                info: false,
                clipboardCopy: false
            };
            this.msgDelete = 'Are you sure you want to delete ${count} ${records}?';
            this.msgNotJSON = 'Returned data is not in valid JSON format.';
            this.msgHTTPError = 'HTTP error. See console for more details.';
            this.msgServerError = 'Server error';
            this.msgRefresh = 'Refreshing...';
            this.msgNeedReload = 'Your remote data source record count has changed, reloading from the first record.';
            this.msgEmpty = '' // if not blank, then it is message when server returns no records
            ;
            this.buttons = {
                'reload': {
                    type: 'button',
                    id: 'w2ui-reload',
                    icon: 'w2ui-icon-reload',
                    tooltip: 'Reload data in the list'
                },
                'columns': {
                    type: 'menu-check',
                    id: 'w2ui-column-on-off',
                    icon: 'w2ui-icon-columns',
                    tooltip: 'Show/hide columns',
                    overlay: {
                        align: 'none'
                    }
                },
                'search': {
                    type: 'html',
                    id: 'w2ui-search',
                    html: '<div class="w2ui-icon w2ui-icon-search w2ui-search-down w2ui-action" data-click="searchShowFields"></div>'
                },
                'add': {
                    type: 'button',
                    id: 'w2ui-add',
                    text: 'Add New',
                    tooltip: 'Add new record',
                    icon: 'w2ui-icon-plus'
                },
                'edit': {
                    type: 'button',
                    id: 'w2ui-edit',
                    text: 'Edit',
                    tooltip: 'Edit selected record',
                    icon: 'w2ui-icon-pencil',
                    batch: 1,
                    disabled: true
                },
                'delete': {
                    type: 'button',
                    id: 'w2ui-delete',
                    text: 'Delete',
                    tooltip: 'Delete selected records',
                    icon: 'w2ui-icon-cross',
                    batch: true,
                    disabled: true
                },
                'save': {
                    type: 'button',
                    id: 'w2ui-save',
                    text: 'Save',
                    tooltip: 'Save changed records',
                    icon: 'w2ui-icon-check'
                }
            };
            this.operators = {
                'text': [
                    'is',
                    'begins',
                    'contains',
                    'ends'
                ],
                'number': [
                    '=',
                    'between',
                    '>',
                    '<',
                    '>=',
                    '<='
                ],
                'date': [
                    'is',
                    {
                        oper: 'less',
                        text: 'before'
                    },
                    {
                        oper: 'more',
                        text: 'since'
                    },
                    'between'
                ],
                'list': [
                    'is'
                ],
                'hex': [
                    'is',
                    'between'
                ],
                'color': [
                    'is',
                    'begins',
                    'contains',
                    'ends'
                ],
                'enum': [
                    'in',
                    'not in'
                ]
            };
            this.defaultOperator = {
                'text': 'begins',
                'number': '=',
                'date': 'is',
                'list': 'is',
                'enum': 'in',
                'hex': 'begins',
                'color': 'begins'
            };
            // map_ctx search field type to operator
            this.operatorsMap = {
                'text': 'text',
                'int': 'number',
                'float': 'number',
                'money': 'number',
                'currency': 'number',
                'percent': 'number',
                'hex': 'hex',
                'alphanumeric': 'text',
                'color': 'color',
                'date': 'date',
                'time': 'date',
                'datetime': 'date',
                'list': 'list',
                'combo': 'text',
                'enum': 'enum',
                'file': 'enum',
                'select': 'list',
                'radio': 'list',
                'checkbox': 'list',
                'toggle': 'list'
            };
            // events
            this.onAdd = null;
            this.onEdit = null;
            this.onRequest = null // called on any server event
            ;
            this.onLoad = null;
            this.onDelete = null;
            this.onSave = null;
            this.onSelect = null;
            this.onClick = null;
            this.onDblClick = null;
            this.onContextMenu = null;
            this.onContextMenuClick = null // when context menu item selected
            ;
            this.onColumnClick = null;
            this.onColumnDblClick = null;
            this.onColumnContextMenu = null;
            this.onColumnResize = null;
            this.onColumnAutoResize = null;
            this.onSort = null;
            this.onSearch = null;
            this.onSearchOpen = null;
            this.onChange = null // called when editable record is changed
            ;
            this.onRestore = null // called when editable record is restored
            ;
            this.onExpand = null;
            this.onCollapse = null;
            this.onError = null;
            this.onKeydown = null;
            this.onToolbar = null // all events from toolbar
            ;
            this.onColumnOnOff = null;
            this.onCopy = null;
            this.onPaste = null;
            this.onSelectionExtend = null;
            this.onEditField = null;
            this.onRender = null;
            this.onRefresh = null;
            this.onReload = null;
            this.onResize = null;
            this.onDestroy = null;
            this.onStateSave = null;
            this.onStateRestore = null;
            this.onFocus = null;
            this.onBlur = null;
            this.onReorderRow = null;
            this.onSearchSave = null;
            this.onSearchRemove = null;
            this.onSearchSelect = null;
            this.onColumnSelect = null;
            this.onColumnDragStart = null;
            this.onColumnDragEnd = null;
            this.onResizerDblClick = null;
            this.onMouseEnter = null // mouse enter over record event
            ;
            this.onMouseLeave = null;
            // need deep merge, should be extend, not objectAssign
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this, options);
            // check if there are records without recid
            if (Array.isArray(this.records)) {
                let remove = [] // remove from records as they are summary
                ;
                this.records.forEach((rec, ind)=>{
                    if (rec[this.recid] != null) rec.recid = rec[this.recid];
                    if (rec.recid == null) console.log('ERROR: Cannot add records without recid. (obj: ' + this.name + ')');
                    if (rec.w2ui?.summary === true) {
                        this.summary.push(rec);
                        remove.push(ind) // cannot remove here as it will mess up array walk thru
                        ;
                    }
                });
                remove.sort();
                for(let t = remove.length - 1; t >= 0; t--)this.records.splice(remove[t], 1);
            }
            // add searches
            if (Array.isArray(this.columns)) this.columns.forEach((col, ind)=>{
                col = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.colTemplate, col);
                this.columns[ind] = col;
                let search = col.searchable;
                if (search == null || search === false || this.getSearch(col.field) != null) return;
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(search)) this.addSearch($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                    field: col.field,
                    label: col.text,
                    type: 'text'
                }, search));
                else {
                    let stype = col.searchable;
                    let attr = '';
                    if (col.searchable === true) {
                        stype = 'text';
                        attr = 'size="20"';
                    }
                    this.addSearch({
                        field: col.field,
                        label: col.text,
                        type: stype,
                        attr: attr
                    });
                }
            });
            // add icon to default searches if not defined
            if (Array.isArray(this.defaultSearches)) this.defaultSearches.forEach((search, ind)=>{
                search.id = 'default-' + ind;
                search.icon ??= 'w2ui-icon-search';
            });
            // check if there are saved searches in localStorage
            let data = this.cache('searches');
            if (Array.isArray(data)) data.forEach((search)=>{
                this.savedSearches.push({
                    id: search.id ?? 'none',
                    text: search.text ?? 'none',
                    icon: 'w2ui-icon-search',
                    remove: true,
                    logic: search.logic ?? 'AND',
                    data: search.data ?? []
                });
            });
            // init toolbar
            this.initToolbar();
            // render if box specified
            if (typeof this.box == 'string') this.box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0);
            if (this.box) this.render(this.box);
        }
        add(record, first) {
            if (!Array.isArray(record)) record = [
                record
            ];
            let added = 0;
            for(let i = 0; i < record.length; i++){
                let rec = record[i];
                if (rec[this.recid] != null) rec.recid = rec[this.recid];
                if (rec.recid == null) {
                    console.log('ERROR: Cannot add record without recid. (obj: ' + this.name + ')');
                    continue;
                }
                if (rec.w2ui?.summary === true) {
                    if (first) this.summary.unshift(rec);
                    else this.summary.push(rec);
                } else if (first) this.records.unshift(rec);
                else this.records.push(rec);
                added++;
            }
            let url = this.url?.get ?? this.url;
            if (!url) {
                this.total = this.records.length;
                this.localSort(false, true);
                this.localSearch();
                // only refresh if it is in virtual view
                let indStart = this.records.length - record.length;
                let indEnd = indStart + record.length;
                if (this.last.vscroll.recIndStart <= indEnd && this.last.vscroll.recIndEnd >= indStart) this.refresh();
                else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_footer .w2ui-footer-right .w2ui-total').html($aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(this.total));
            } else this.refresh();
            return added;
        }
        find(obj, returnIndex, displayedOnly) {
            if (obj == null) obj = {};
            let recs = [];
            let hasDots = false;
            // check if property is nested - needed for speed
            for(let o in obj)if (String(o).indexOf('.') != -1) hasDots = true;
            // look for an item
            let start = displayedOnly ? this.last.vscroll.recIndStart : 0;
            let end = displayedOnly ? this.last.vscroll.recIndEnd + 1 : this.records.length;
            if (end > this.records.length) end = this.records.length;
            for(let i = start; i < end; i++){
                let match = true;
                for(let o in obj){
                    let val = this.records[i][o];
                    if (hasDots && String(o).indexOf('.') != -1) val = this.parseField(this.records[i], o);
                    if (obj[o] == 'not-null') {
                        if (val == null || val === '') match = false;
                    } else if (obj[o] != val) match = false;
                }
                if (match && returnIndex !== true) recs.push(this.records[i].recid);
                if (match && returnIndex === true) recs.push(i);
            }
            return recs;
        }
        // does not delete existing, but overrides on top of it
        set(recid, record, noRefresh) {
            if (typeof recid == 'object' && recid !== null) {
                noRefresh = record;
                record = recid;
                recid = null;
            }
            // update all records
            if (recid == null) {
                for(let i = 0; i < this.records.length; i++)$aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.records[i], record) // recid is the whole record
                ;
                if (noRefresh !== true) this.refresh();
            } else {
                let ind = this.get(recid, true);
                if (ind == null) return false;
                let isSummary = this.records[ind]?.recid == recid ? false : true;
                if (isSummary) $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.summary[ind], record);
                else $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.records[ind], record);
                if (noRefresh !== true) this.refreshRow(recid, ind) // refresh only that record
                ;
            }
            return true;
        }
        // replaces existing record
        replace(recid, record, noRefresh) {
            let ind = this.get(recid, true);
            if (ind == null) return false;
            let isSummary = this.records[ind]?.recid == recid ? false : true;
            if (isSummary) this.summary[ind] = record;
            else this.records[ind] = record;
            if (noRefresh !== true) this.refreshRow(recid, ind) // refresh only that record
            ;
            return true;
        }
        get(recid, returnIndex) {
            // search records
            if (Array.isArray(recid)) {
                let recs = [];
                for(let i = 0; i < recid.length; i++){
                    let v = this.get(recid[i], returnIndex);
                    if (v !== null) recs.push(v);
                }
                return recs;
            } else {
                // get() must be fast, implements a cache to bypass loop over all records
                // most of the time.
                let idCache = this.last.idCache;
                if (!idCache) this.last.idCache = idCache = {};
                let i = idCache[recid];
                if (typeof i === 'number') {
                    if (i >= 0 && i < this.records.length && this.records[i].recid == recid) {
                        if (returnIndex === true) return i;
                        else return this.records[i];
                    }
                    // summary indexes are stored as negative numbers, try them now.
                    i = ~i;
                    if (i >= 0 && i < this.summary.length && this.summary[i].recid == recid) {
                        if (returnIndex === true) return i;
                        else return this.summary[i];
                    }
                    // wrong index returned, clear cache
                    this.last.idCache = idCache = {};
                }
                for(let i = 0; i < this.records.length; i++)if (this.records[i].recid == recid) {
                    idCache[recid] = i;
                    if (returnIndex === true) return i;
                    else return this.records[i];
                }
                // search summary
                for(let i = 0; i < this.summary.length; i++)if (this.summary[i].recid == recid) {
                    idCache[recid] = ~i;
                    if (returnIndex === true) return i;
                    else return this.summary[i];
                }
                return null;
            }
        }
        getFirst(offset) {
            if (this.records.length == 0) return null;
            let rec = this.records[0];
            let tmp = this.last.searchIds;
            if (this.searchData.length > 0) {
                if (Array.isArray(tmp) && tmp.length > 0) rec = this.records[tmp[offset || 0]];
                else rec = null;
            }
            return rec;
        }
        remove() {
            let removed = 0;
            for(let a = 0; a < arguments.length; a++){
                for(let r = this.records.length - 1; r >= 0; r--)if (this.records[r].recid == arguments[a]) {
                    this.records.splice(r, 1);
                    removed++;
                }
                for(let r = this.summary.length - 1; r >= 0; r--)if (this.summary[r].recid == arguments[a]) {
                    this.summary.splice(r, 1);
                    removed++;
                }
            }
            let url = this.url?.get ?? this.url;
            if (!url) {
                this.localSort(false, true);
                this.localSearch();
                this.total = this.records.length;
            }
            this.refresh();
            return removed;
        }
        addColumn(before, columns) {
            let added = 0;
            if (arguments.length == 1) {
                columns = before;
                before = this.columns.length;
            } else {
                if (typeof before == 'string') before = this.getColumn(before, true);
                if (before == null) before = this.columns.length;
            }
            if (!Array.isArray(columns)) columns = [
                columns
            ];
            for(let i = 0; i < columns.length; i++){
                let col = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.colTemplate, columns[i]);
                this.columns.splice(before, 0, col);
                // if column is searchable, add search field
                if (columns[i].searchable) {
                    let stype = columns[i].searchable;
                    let attr = '';
                    if (columns[i].searchable === true) {
                        stype = 'text';
                        attr = 'size="20"';
                    }
                    this.addSearch({
                        field: columns[i].field,
                        label: columns[i].text,
                        type: stype,
                        attr: attr
                    });
                }
                before++;
                added++;
            }
            this.refresh();
            return added;
        }
        removeColumn() {
            let removed = 0;
            for(let a = 0; a < arguments.length; a++){
                for(let r = this.columns.length - 1; r >= 0; r--)if (this.columns[r].field == arguments[a]) {
                    if (this.columns[r].searchable) this.removeSearch(arguments[a]);
                    this.columns.splice(r, 1);
                    removed++;
                }
            }
            this.refresh();
            return removed;
        }
        getColumn(field, returnIndex) {
            // no arguments - return fields of all columns
            if (arguments.length === 0) {
                let ret = [];
                for(let i = 0; i < this.columns.length; i++)ret.push(this.columns[i].field);
                return ret;
            }
            // find column
            for(let i = 0; i < this.columns.length; i++)if (this.columns[i].field == field) {
                if (returnIndex === true) return i;
                else return this.columns[i];
            }
            return null;
        }
        updateColumn(fields, updates) {
            let effected = 0;
            fields = Array.isArray(fields) ? fields : [
                fields
            ];
            fields.forEach((colName)=>{
                this.columns.forEach((col)=>{
                    if (col.field == colName) {
                        let _updates = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(updates);
                        Object.keys(_updates).forEach((key)=>{
                            // if it is a function
                            if (typeof _updates[key] == 'function') _updates[key] = _updates[key](col);
                            if (col[key] != _updates[key]) effected++;
                        });
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(col, _updates);
                    }
                });
            });
            if (effected > 0) this.refresh() // need full refresh due to colgroups not reassigning properly
            ;
            return effected;
        }
        toggleColumn() {
            return this.updateColumn(Array.from(arguments), {
                hidden (col) {
                    return !col.hidden;
                }
            });
        }
        showColumn() {
            return this.updateColumn(Array.from(arguments), {
                hidden: false
            });
        }
        hideColumn() {
            return this.updateColumn(Array.from(arguments), {
                hidden: true
            });
        }
        addSearch(before, search) {
            let added = 0;
            if (arguments.length == 1) {
                search = before;
                before = this.searches.length;
            } else {
                if (typeof before == 'string') before = this.getSearch(before, true);
                if (before == null) before = this.searches.length;
            }
            if (!Array.isArray(search)) search = [
                search
            ];
            for(let i = 0; i < search.length; i++){
                this.searches.splice(before, 0, search[i]);
                before++;
                added++;
            }
            this.searchClose();
            return added;
        }
        removeSearch() {
            let removed = 0;
            for(let a = 0; a < arguments.length; a++){
                for(let r = this.searches.length - 1; r >= 0; r--)if (this.searches[r].field == arguments[a]) {
                    this.searches.splice(r, 1);
                    removed++;
                }
            }
            this.searchClose();
            return removed;
        }
        getSearch(field, returnIndex) {
            // no arguments - return fields of all searches
            if (arguments.length === 0) {
                let ret = [];
                for(let i = 0; i < this.searches.length; i++)ret.push(this.searches[i].field);
                return ret;
            }
            // find search
            for(let i = 0; i < this.searches.length; i++)if (this.searches[i].field == field) {
                if (returnIndex === true) return i;
                else return this.searches[i];
            }
            return null;
        }
        toggleSearch() {
            let effected = 0;
            for(let a = 0; a < arguments.length; a++){
                for(let r = this.searches.length - 1; r >= 0; r--)if (this.searches[r].field == arguments[a]) {
                    this.searches[r].hidden = !this.searches[r].hidden;
                    effected++;
                }
            }
            this.searchClose();
            return effected;
        }
        showSearch() {
            let shown = 0;
            for(let a = 0; a < arguments.length; a++){
                for(let r = this.searches.length - 1; r >= 0; r--)if (this.searches[r].field == arguments[a] && this.searches[r].hidden !== false) {
                    this.searches[r].hidden = false;
                    shown++;
                }
            }
            this.searchClose();
            return shown;
        }
        hideSearch() {
            let hidden = 0;
            for(let a = 0; a < arguments.length; a++){
                for(let r = this.searches.length - 1; r >= 0; r--)if (this.searches[r].field == arguments[a] && this.searches[r].hidden !== true) {
                    this.searches[r].hidden = true;
                    hidden++;
                }
            }
            this.searchClose();
            return hidden;
        }
        getSearchData(field) {
            for(let i = 0; i < this.searchData.length; i++){
                if (this.searchData[i].field == field) return this.searchData[i];
            }
            return null;
        }
        localSort(silent, noResetRefresh) {
            let obj = this;
            let url = this.url?.get ?? this.url;
            if (url) {
                console.log('ERROR: grid.localSort can only be used on local data source, grid.url should be empty.');
                return 0 // time it took
                ;
            }
            if (Object.keys(this.sortData).length === 0) {
                // restore original sorting
                let os = this.last.originalSort;
                if (os) this.records.sort((a, b)=>{
                    let aInd = os.indexOf(a.recid);
                    let bInd = os.indexOf(b.recid);
                    // order cann be equal, so, no need to return 0
                    return aInd > bInd ? 1 : -1;
                });
                return 0 // time it took
                ;
            }
            let time = Date.now();
            // process date fields
            this.selectionSave();
            this.prepareData();
            if (!noResetRefresh) this.reset();
            // process sortData
            for(let i = 0; i < this.sortData.length; i++){
                let column = this.getColumn(this.sortData[i].field);
                if (!column) return; // TODO: ability to sort columns when they are not part of colums array
                if (typeof column.render == 'string') {
                    if ([
                        'date',
                        'age'
                    ].indexOf(column.render.split(':')[0]) != -1) this.sortData[i].field_ = column.field + '_';
                    if ([
                        'time'
                    ].indexOf(column.render.split(':')[0]) != -1) this.sortData[i].field_ = column.field + '_';
                }
            }
            // prepare paths and process sort
            preparePaths();
            this.records.sort((a, b)=>{
                return compareRecordPaths(a, b);
            });
            cleanupPaths();
            this.selectionRestore(noResetRefresh);
            time = Date.now() - time;
            if (silent !== true && this.show.statusSort) setTimeout(()=>{
                this.status($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Sorting took ${count} seconds', {
                    count: time / 1000
                }));
            }, 10);
            return time;
            // grab paths before sorting for efficiency and because calling obj.get()
            // while sorting 'obj.records' is unsafe, at least on webkit
            function preparePaths() {
                for(let i = 0; i < obj.records.length; i++){
                    let rec = obj.records[i];
                    if (rec.w2ui?.parent_recid != null) rec.w2ui._path = getRecordPath(rec);
                }
            }
            // cleanup and release memory allocated by preparePaths()
            function cleanupPaths() {
                for(let i = 0; i < obj.records.length; i++){
                    let rec = obj.records[i];
                    if (rec.w2ui?.parent_recid != null) rec.w2ui._path = null;
                }
            }
            // compare two paths, from root of tree to given records
            function compareRecordPaths(a, b) {
                if ((!a.w2ui || a.w2ui.parent_recid == null) && (!b.w2ui || b.w2ui.parent_recid == null)) return compareRecords(a, b) // no tree, fast path
                ;
                let pa = getRecordPath(a);
                let pb = getRecordPath(b);
                for(let i = 0; i < Math.min(pa.length, pb.length); i++){
                    let diff = compareRecords(pa[i], pb[i]);
                    if (diff !== 0) return diff // different subpath
                    ;
                }
                if (pa.length > pb.length) return 1;
                if (pa.length < pb.length) return -1;
                console.log('ERROR: two paths should not be equal.');
                return 0;
            }
            // return an array of all records from root to and including 'rec'
            function getRecordPath(rec) {
                if (!rec.w2ui || rec.w2ui.parent_recid == null) return [
                    rec
                ];
                if (rec.w2ui._path) return rec.w2ui._path;
                // during actual sort, we should never reach this point
                let subrec = obj.get(rec.w2ui.parent_recid);
                if (!subrec) {
                    console.log('ERROR: no parent record: ' + rec.w2ui.parent_recid);
                    return [
                        rec
                    ];
                }
                return getRecordPath(subrec).concat(rec);
            }
            // compare two records according to sortData and finally recid
            function compareRecords(a, b) {
                if (a === b) return 0 // optimize, same object
                ;
                for(let i = 0; i < obj.sortData.length; i++){
                    let fld = obj.sortData[i].field;
                    let sortFld = obj.sortData[i].field_ ? obj.sortData[i].field_ : fld;
                    let aa = a[sortFld];
                    let bb = b[sortFld];
                    if (String(fld).indexOf('.') != -1) {
                        aa = obj.parseField(a, sortFld);
                        bb = obj.parseField(b, sortFld);
                    }
                    let col = obj.getColumn(fld);
                    if (col && Object.keys(col.editable).length > 0) {
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(aa) && aa.text) aa = aa.text;
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(bb) && bb.text) bb = bb.text;
                    }
                    let ret = compareCells(aa, bb, i, obj.sortData[i].direction, col.sortMode || 'default');
                    if (ret !== 0) return ret;
                }
                // break tie for similar records,
                // required to have consistent ordering for tree paths
                let ret = compareCells(a.recid, b.recid, -1, 'asc');
                return ret;
            }
            // compare two values, aa and bb, producing consistent ordering
            function compareCells(aa, bb, i, direction, sortMode) {
                // if both objects are strictly equal, we're done
                if (aa === bb) return 0;
                // all nulls, empty and undefined on bottom
                if ((aa == null || aa === '') && bb != null && bb !== '') return 1;
                if (aa != null && aa !== '' && (bb == null || bb === '')) return -1;
                let dir = direction.toLowerCase() === 'asc' ? 1 : -1;
                // for different kind of objects, sort by object type
                if (typeof aa != typeof bb) return typeof aa > typeof bb ? dir : -dir;
                // for different kind of classes, sort by classes
                if (aa.constructor.name != bb.constructor.name) return aa.constructor.name > bb.constructor.name ? dir : -dir;
                // if we're dealing with non-null objects, call valueOf().
                // this mean that Date() or custom objects will compare properly.
                if (aa && typeof aa == 'object') aa = aa.valueOf();
                if (bb && typeof bb == 'object') bb = bb.valueOf();
                // if we're still dealing with non-null objects that have
                // a useful Object => String conversion, convert to string.
                let defaultToString = {}.toString;
                if (aa && typeof aa == 'object' && aa.toString != defaultToString) aa = String(aa);
                if (bb && typeof bb == 'object' && bb.toString != defaultToString) bb = String(bb);
                // do case-insensitive string comparison
                if (typeof aa == 'string') aa = aa.toLowerCase().trim();
                if (typeof bb == 'string') bb = bb.toLowerCase().trim();
                switch(sortMode){
                    case 'natural':
                        sortMode = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.naturalCompare;
                        break;
                    case 'i18n':
                        sortMode = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.i18nCompare;
                        break;
                }
                if (typeof sortMode == 'function') return sortMode(aa, bb) * dir;
                // compare both objects
                if (aa > bb) return dir;
                if (aa < bb) return -dir;
                return 0;
            }
        }
        localSearch(silent) {
            let obj = this;
            let url = this.url?.get ?? this.url;
            if (url) {
                console.log('ERROR: grid.localSearch can only be used on local data source, grid.url should be empty.');
                return;
            }
            let time = Date.now();
            let defaultToString = {}.toString;
            let duplicateMap = {};
            this.total = this.records.length;
            // mark all records as shown
            this.last.searchIds = [];
            // prepare date/time fields
            this.prepareData();
            // hide records that did not match
            if (this.searchData.length > 0 && !url) {
                this.total = 0;
                for(let i = 0; i < this.records.length; i++){
                    let rec = this.records[i];
                    let match = searchRecord(rec);
                    if (match) {
                        if (rec?.w2ui) addParent(rec.w2ui.parent_recid);
                        if (this.showExtraOnSearch > 0) {
                            let before = this.showExtraOnSearch;
                            let after = this.showExtraOnSearch;
                            if (i < before) before = i;
                            if (i + after > this.records.length) after = this.records.length - i;
                            if (before > 0) {
                                for(let j = i - before; j < i; j++)if (this.last.searchIds.indexOf(j) < 0) this.last.searchIds.push(j);
                            }
                            if (this.last.searchIds.indexOf(i) < 0) this.last.searchIds.push(i);
                            if (after > 0) {
                                for(let j = i + 1; j <= i + after; j++)if (this.last.searchIds.indexOf(j) < 0) this.last.searchIds.push(j);
                            }
                        } else this.last.searchIds.push(i);
                    }
                }
                this.total = this.last.searchIds.length;
            }
            time = Date.now() - time;
            if (silent !== true && this.show.statusSearch) setTimeout(()=>{
                this.status($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Search took ${count} seconds', {
                    count: time / 1000
                }));
            }, 10);
            return time;
            // check if a record (or one of its closed children) matches the search data
            function searchRecord(rec) {
                let fl = 0, val1, val2, val3, tmp;
                let orEqual = false;
                for(let j = 0; j < obj.searchData.length; j++){
                    let sdata = obj.searchData[j];
                    let search = obj.getSearch(sdata.field);
                    if (sdata == null) continue;
                    if (search == null) search = {
                        field: sdata.field,
                        type: sdata.type
                    };
                    let val1b = obj.parseField(rec, search.field);
                    val1 = val1b != null && (typeof val1b != 'object' || val1b.toString != defaultToString) ? String(val1b).toLowerCase() : '' // do not match a bogus string
                    ;
                    if (sdata.value != null) {
                        if (!Array.isArray(sdata.value)) val2 = String(sdata.value).toLowerCase();
                        else {
                            val2 = sdata.value[0];
                            val3 = sdata.value[1];
                        }
                    }
                    switch(sdata.operator){
                        case '=':
                        case 'is':
                            if (obj.parseField(rec, search.field) == sdata.value) fl++ // do not hide record
                            ;
                            else if (search.type == 'date') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(tmp, 'yyyy-mm-dd');
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(val2, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat, true), 'yyyy-mm-dd');
                                if (val1 == val2) fl++;
                            } else if (search.type == 'time') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(tmp, 'hh24:mi');
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(val2, 'hh24:mi');
                                if (val1 == val2) fl++;
                            } else if (search.type == 'datetime') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime(tmp, 'yyyy-mm-dd|hh24:mm:ss');
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(val2, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.datetimeFormat, true), 'yyyy-mm-dd|hh24:mm:ss');
                                if (val1 == val2) fl++;
                            }
                            break;
                        case 'between':
                            if ([
                                'int',
                                'float',
                                'money',
                                'currency',
                                'percent'
                            ].indexOf(search.type) != -1) {
                                if (parseFloat(obj.parseField(rec, search.field)) >= parseFloat(val2) && parseFloat(obj.parseField(rec, search.field)) <= parseFloat(val3)) fl++;
                            } else if (search.type == 'date') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(tmp, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat, true);
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(val2, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat, true);
                                val3 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(val3, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat, true);
                                if (val3 != null) val3 = new Date(val3.getTime() + 86400000) // 1 day
                                ;
                                if (val1 >= val2 && val1 < val3) fl++;
                            } else if (search.type == 'time') {
                                val1 = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isTime(val2, true);
                                val3 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isTime(val3, true);
                                val2 = new Date().setHours(val2.hours, val2.minutes, val2.seconds ? val2.seconds : 0, 0);
                                val3 = new Date().setHours(val3.hours, val3.minutes, val3.seconds ? val3.seconds : 0, 0);
                                if (val1 >= val2 && val1 < val3) fl++;
                            } else if (search.type == 'datetime') {
                                val1 = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(val2, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.datetimeFormat, true);
                                val3 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(val3, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.datetimeFormat, true);
                                if (val3) val3 = new Date(val3.getTime() + 86400000) // 1 day
                                ;
                                if (val1 >= val2 && val1 < val3) fl++;
                            }
                            break;
                        case '<=':
                            orEqual = true;
                        case '<':
                        case 'less':
                            if ([
                                'int',
                                'float',
                                'money',
                                'currency',
                                'percent'
                            ].indexOf(search.type) != -1) {
                                val1 = parseFloat(obj.parseField(rec, search.field));
                                val2 = parseFloat(sdata.value);
                                if (val1 < val2 || orEqual && val1 === val2) fl++;
                            } else if (search.type == 'date') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(tmp, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat, true);
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(val2, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat, true);
                                if (val1 < val2 || orEqual && val1 === val2) fl++;
                            } else if (search.type == 'time') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(tmp, 'hh24:mi');
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(val2, 'hh24:mi');
                                if (val1 < val2 || orEqual && val1 === val2) fl++;
                            } else if (search.type == 'datetime') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime(tmp, 'yyyy-mm-dd|hh24:mm:ss');
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(val2, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.datetimeFormat, true), 'yyyy-mm-dd|hh24:mm:ss');
                                if (val1.length == val2.length && (val1 < val2 || orEqual && val1 === val2)) fl++;
                            }
                            break;
                        case '>=':
                            orEqual = true;
                        case '>':
                        case 'more':
                            if ([
                                'int',
                                'float',
                                'money',
                                'currency',
                                'percent'
                            ].indexOf(search.type) != -1) {
                                val1 = parseFloat(obj.parseField(rec, search.field));
                                val2 = parseFloat(sdata.value);
                                if (val1 > val2 || orEqual && val1 === val2) fl++;
                            } else if (search.type == 'date') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(tmp, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat, true);
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(val2, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat, true);
                                if (val1 > val2 || orEqual && val1 === val2) fl++;
                            } else if (search.type == 'time') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(tmp, 'hh24:mi');
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(val2, 'hh24:mi');
                                if (val1 > val2 || orEqual && val1 === val2) fl++;
                            } else if (search.type == 'datetime') {
                                tmp = obj.parseField(rec, search.field + '_') instanceof Date ? obj.parseField(rec, search.field + '_') : obj.parseField(rec, search.field);
                                val1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime(tmp, 'yyyy-mm-dd|hh24:mm:ss');
                                val2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(val2, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.datetimeFormat, true), 'yyyy-mm-dd|hh24:mm:ss');
                                if (val1.length == val2.length && (val1 > val2 || orEqual && val1 === val2)) fl++;
                            }
                            break;
                        case 'in':
                            tmp = sdata.value;
                            if (sdata.svalue) tmp = sdata.svalue;
                            if (tmp.indexOf($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(val1b) ? parseFloat(val1b) : val1b) !== -1 || tmp.indexOf(val1) !== -1 && val1 !== '') fl++;
                            break;
                        case 'not in':
                            tmp = sdata.value;
                            if (sdata.svalue) tmp = sdata.svalue;
                            if (!(tmp.indexOf($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(val1b) ? parseFloat(val1b) : val1b) !== -1 || tmp.indexOf(val1) !== -1 && val1 !== '')) fl++;
                            break;
                        case 'begins':
                        case 'begins with':
                            if (val1.indexOf(val2) === 0) fl++ // do not hide record
                            ;
                            break;
                        case 'contains':
                            if (val1.indexOf(val2) >= 0) fl++ // do not hide record
                            ;
                            break;
                        case 'null':
                            if (obj.parseField(rec, search.field) == null) fl++ // do not hide record
                            ;
                            break;
                        case 'not null':
                            if (obj.parseField(rec, search.field) != null) fl++ // do not hide record
                            ;
                            break;
                        case 'ends':
                        case 'ends with':
                            let lastIndex = val1.lastIndexOf(val2);
                            if (lastIndex !== -1 && lastIndex == val1.length - val2.length) fl++ // do not hide record
                            ;
                            break;
                    }
                }
                if (obj.last.logic == 'OR' && fl !== 0 || obj.last.logic == 'AND' && fl == obj.searchData.length) return true;
                if (rec.w2ui?.children && rec.w2ui?.expanded !== true) for(let r = 0; r < rec.w2ui.children.length; r++){
                    let subRec = rec.w2ui.children[r];
                    if (searchRecord(subRec)) return true;
                }
                return false;
            }
            // add parents nodes recursively
            function addParent(recid) {
                let i = obj.get(recid, true);
                if (i == null || recid == null || duplicateMap[recid] || obj.last.searchIds.includes(i)) return;
                duplicateMap[recid] = true;
                let rec = obj.records[i];
                if (rec?.w2ui) addParent(rec.w2ui.parent_recid);
                obj.last.searchIds.push(i);
            }
        }
        getRangeData(range, extra) {
            let rec1 = this.get(range[0].recid, true);
            let rec2 = this.get(range[1].recid, true);
            let col1 = range[0].column;
            let col2 = range[1].column;
            let res = [];
            if (col1 == col2) for(let r = rec1; r <= rec2; r++){
                let record = this.records[r];
                let dt = record[this.columns[col1].field] || null;
                if (extra !== true) res.push(dt);
                else res.push({
                    data: dt,
                    column: col1,
                    index: r,
                    record: record
                });
            }
            else if (rec1 == rec2) {
                let record = this.records[rec1];
                for(let i = col1; i <= col2; i++){
                    let dt = record[this.columns[i].field] || null;
                    if (extra !== true) res.push(dt);
                    else res.push({
                        data: dt,
                        column: i,
                        index: rec1,
                        record: record
                    });
                }
            } else for(let r = rec1; r <= rec2; r++){
                let record = this.records[r];
                res.push([]);
                for(let i = col1; i <= col2; i++){
                    let dt = record[this.columns[i].field];
                    if (extra !== true) res[res.length - 1].push(dt);
                    else res[res.length - 1].push({
                        data: dt,
                        column: i,
                        index: r,
                        record: record
                    });
                }
            }
            return res;
        }
        addRange(ranges) {
            let added = 0, first, last;
            if (this.selectType == 'row') return added;
            if (!Array.isArray(ranges)) ranges = [
                ranges
            ];
            // if it is selection
            for(let i = 0; i < ranges.length; i++){
                if (typeof ranges[i] != 'object') ranges[i] = {
                    name: 'selection'
                };
                if (ranges[i].name == 'selection') {
                    if (this.show.selectionBorder === false) continue;
                    let sel = this.getSelection();
                    if (sel.length === 0) {
                        this.removeRange('selection');
                        continue;
                    } else {
                        first = sel[0];
                        last = sel[sel.length - 1];
                    }
                } else {
                    first = ranges[i].range[0];
                    last = ranges[i].range[1];
                }
                if (first) {
                    let rg = {
                        name: ranges[i].name,
                        range: [
                            {
                                recid: first.recid,
                                column: first.column
                            },
                            {
                                recid: last.recid,
                                column: last.column
                            }
                        ],
                        style: ranges[i].style || ''
                    };
                    // add range
                    let ind = false;
                    for(let j = 0; j < this.ranges.length; j++)if (this.ranges[j].name == ranges[i].name) {
                        ind = j;
                        break;
                    }
                    if (ind !== false) this.ranges[ind] = rg;
                    else this.ranges.push(rg);
                    added++;
                }
            }
            this.refreshRanges();
            return added;
        }
        removeRange() {
            let removed = 0;
            for(let a = 0; a < arguments.length; a++){
                let name = arguments[a];
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_' + name).remove();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_f' + name).remove();
                for(let r = this.ranges.length - 1; r >= 0; r--)if (this.ranges[r].name == name) {
                    this.ranges.splice(r, 1);
                    removed++;
                }
            }
            return removed;
        }
        refreshRanges() {
            if (this.ranges.length === 0) return;
            let self1 = this;
            let range;
            let time = Date.now();
            let rec1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_frecords`);
            let rec2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_records`);
            for(let i = 0; i < this.ranges.length; i++){
                let rg = this.ranges[i];
                let first = rg.range[0];
                let last = rg.range[1];
                if (first.index == null) first.index = this.get(first.recid, true);
                if (last.index == null) last.index = this.get(last.recid, true);
                let td1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(first.recid) + ' td[col="' + first.column + '"]');
                let td2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(last.recid) + ' td[col="' + last.column + '"]');
                let td1f = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(first.recid) + ' td[col="' + first.column + '"]');
                let td2f = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(last.recid) + ' td[col="' + last.column + '"]');
                let _lastColumn = last.column;
                // adjustment due to column virtual scroll
                if (first.column < this.last.vscroll.colIndStart && last.column > this.last.vscroll.colIndStart) td1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(first.recid) + ' td[col="start"]');
                if (first.column < this.last.vscroll.colIndEnd && last.column > this.last.vscroll.colIndEnd) {
                    td2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(last.recid) + ' td[col="end"]');
                    _lastColumn = '"end"';
                }
                // if virtual scrolling kicked in
                let index_top = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_top').next().attr('index'));
                let index_bottom = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_bottom').prev().attr('index'));
                let index_ftop = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_top').next().attr('index'));
                let index_fbottom = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_bottom').prev().attr('index'));
                if (td1.length === 0 && first.index < index_top && last.index > index_top) td1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_top').next().find('td[col="' + first.column + '"]');
                if (td2.length === 0 && last.index > index_bottom && first.index < index_bottom) td2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_bottom').prev().find('td[col="' + _lastColumn + '"]');
                if (td1f.length === 0 && first.index < index_ftop && last.index > index_ftop) td1f = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_top').next().find('td[col="' + first.column + '"]');
                if (td2f.length === 0 && last.index > index_fbottom && first.index < index_fbottom) td2f = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_bottom').prev().find('td[col="' + last.column + '"]');
                // do not show selection cell if it is editable
                let edit = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_editable');
                let tmp = edit.find('.w2ui-input');
                let tmp_ind = tmp.attr('index');
                let tmp1 = this.records[tmp_ind]?.recid;
                let tmp2 = tmp.attr('column');
                if (rg.name == 'selection' && rg.range[0].recid == tmp1 && rg.range[0].column == tmp2) continue;
                // frozen regular columns range
                range = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_f' + rg.name);
                if (td1f.length > 0 || td2f.length > 0) {
                    if (range.length === 0) {
                        rec1.append('<div id="grid_' + this.name + '_f' + rg.name + '" class="w2ui-selection" style="' + rg.style + '">' + (rg.name == 'selection' && this.show.selectionResizer ? '<div id="grid_' + this.name + '_resizer" class="w2ui-selection-resizer"></div>' : '') + '</div>');
                        range = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_f' + rg.name);
                    } else {
                        range.attr('style', rg.style);
                        range.find('.w2ui-selection-resizer').show();
                    }
                    if (td2f.length === 0) {
                        td2f = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(last.recid) + ' td:last-child');
                        if (td2f.length === 0) td2f = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_bottom td:first-child');
                        range.css('border-right', '0px');
                        range.find('.w2ui-selection-resizer').hide();
                    }
                    if (first.recid != null && last.recid != null && td1f.length > 0 && td2f.length > 0) {
                        let style = getComputedStyle(td2f[0]);
                        let top1 = td1f.prop('offsetTop') - td1f.prop('scrollTop');
                        let left1 = td1f.prop('offsetLeft') + td1f.prop('scrollLeft');
                        let top2 = td2f.prop('offsetTop') - td2f.prop('scrollTop');
                        let left2 = td2f.prop('offsetLeft') + td2f.prop('scrollLeft');
                        range.show().css({
                            top: (top1 > 0 ? top1 : 0) + 'px',
                            left: (left1 > 0 ? left1 : 0) + 'px',
                            width: left2 - left1 + parseFloat(style.width) - 1 + 'px',
                            height: top2 - top1 + parseFloat(style.height) - 1 + 'px'
                        });
                    } else range.hide();
                } else range.hide();
                // regular columns range
                range = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_' + rg.name);
                if (td1.length > 0 || td2.length > 0) {
                    if (range.length === 0) {
                        rec2.append('<div id="grid_' + this.name + '_' + rg.name + '" class="w2ui-selection" style="' + rg.style + '">' + (rg.name == 'selection' && this.show.selectionResizer ? '<div id="grid_' + this.name + '_resizer" class="w2ui-selection-resizer"></div>' : '') + '</div>');
                        range = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_' + rg.name);
                    } else range.attr('style', rg.style);
                    if (td1.length === 0) {
                        td1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(first.recid) + ' td:first-child');
                        if (td1.length === 0) td1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_top td:first-child');
                    }
                    if (td2f.length !== 0) range.css('border-left', '0px');
                    if (first.recid != null && last.recid != null && td1.length > 0 && td2.length > 0) {
                        let style = getComputedStyle(td2[0]);
                        let top1 = td1.prop('offsetTop') - td1.prop('scrollTop');
                        let left1 = td1.prop('offsetLeft') + td1.prop('scrollLeft');
                        let top2 = td2.prop('offsetTop') - td2.prop('scrollTop');
                        let left2 = td2.prop('offsetLeft') + td2.prop('scrollLeft');
                        range.show().css({
                            top: (top1 > 0 ? top1 : 0) + 'px',
                            left: (left1 > 0 ? left1 : 0) + 'px',
                            width: left2 - left1 + parseFloat(style.width) - 1 + 'px',
                            height: top2 - top1 + parseFloat(style.height) - 1 + 'px'
                        });
                    } else range.hide();
                } else range.hide();
            }
            // add resizer events
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-selection-resizer').off('.resizer').on('mousedown.resizer', mouseStart).on('dblclick.resizer', (event1)=>{
                let edata = this.trigger('resizerDblClick', {
                    target: this.name,
                    originalEvent: event1
                });
                if (edata.isCancelled === true) return;
                edata.finish();
            });
            // this variables are needed for selection expantion
            let edata;
            let detail = {
                target: this.name,
                originalRange: null,
                newRange: null
            };
            let letters = 'abcdefghijklmnopqrstuvwxyz';
            return Date.now() - time;
            function mouseStart(event1) {
                let sel = self1.getSelection();
                let first = sel[0];
                let last = sel[sel.length - 1];
                self1.last.move = {
                    type: 'expand',
                    x: event1.screenX,
                    y: event1.screenY,
                    divX: 0,
                    divY: 0,
                    index: first.index,
                    recid: first.recid,
                    column: first.column,
                    name: letters[first.column] + (first.index + 1) + ':' + letters[last.column] + (last.index + 1),
                    originalRange: [
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(first),
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(last)
                    ],
                    newRange: [
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(first),
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(last)
                    ]
                };
                detail.originalName = self1.last.move.name;
                detail.originalRange = self1.last.move.originalRange;
                $aa2bd8933167d9cb$export$2fa187e846a241c4('body').off('.w2ui-' + self1.name).on('mousemove.w2ui-' + self1.name, mouseMove).on('mouseup.w2ui-' + self1.name, mouseStop);
                // do not blur grid
                event1.preventDefault();
            }
            function mouseMove(event1) {
                let mv = self1.last.move;
                if (!mv || mv.type != 'expand') return;
                mv.divX = event1.screenX - mv.x;
                mv.divY = event1.screenY - mv.y;
                // find new cell
                let recid, index, column;
                let tmp = event1.target;
                if (tmp.tagName.toUpperCase() != 'TD') tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).closest('td')[0];
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).attr('col') != null) column = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).attr('col'));
                if (column == null) return;
                tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).closest('tr')[0];
                index = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).attr('index'));
                recid = self1.records[index]?.recid;
                // new range
                if (mv.newRange[1].recid == recid && mv.newRange[1].column == column) return;
                let prevNewRange = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(mv.newRange);
                mv.newRange = [
                    {
                        recid: mv.recid,
                        index: mv.index,
                        column: mv.column
                    },
                    {
                        recid: recid,
                        index: index,
                        column: column
                    }
                ];
                // remember update ranges
                detail.newName = letters[mv.column] + (mv.index + 1) + ':' + letters[column] + (index + 1);
                detail.newRange = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(mv.newRange);
                // event before
                edata = self1.trigger('selectionExtend', detail);
                if (edata.isCancelled === true) {
                    mv.newRange = prevNewRange;
                    detail.newRange = prevNewRange;
                    return;
                } else {
                    // default behavior
                    self1.removeRange('grid-selection-expand');
                    self1.addRange({
                        name: 'grid-selection-expand',
                        range: mv.newRange,
                        style: 'background-color: rgba(100,100,100,0.1); border: 2px dotted rgba(100,100,100,0.5);'
                    });
                }
            }
            function mouseStop(event1) {
                // default behavior
                self1.removeRange('grid-selection-expand');
                delete self1.last.move;
                $aa2bd8933167d9cb$export$2fa187e846a241c4('body').off('.w2ui-' + self1.name);
                // event after
                if (edata.finish) edata.finish();
            }
        }
        select() {
            if (arguments.length === 0) return 0;
            let selected = 0;
            let sel = this.last.selection;
            if (!this.multiSelect) this.selectNone(true);
            // if too many arguments > 150k, then it errors off
            let args = Array.from(arguments);
            if (Array.isArray(args[0])) args = args[0];
            // event before
            let tmp = {
                target: this.name
            };
            if (args.length == 1) {
                tmp.multiple = false;
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(args[0])) tmp.clicked = {
                    recid: args[0].recid,
                    column: args[0].column
                };
                else tmp.recid = args[0];
            } else {
                tmp.multiple = true;
                tmp.clicked = {
                    recids: args
                };
            }
            let edata = this.trigger('select', tmp);
            if (edata.isCancelled === true) return 0;
            // default action
            if (this.selectType == 'row') for(let a = 0; a < args.length; a++){
                let recid = typeof args[a] == 'object' ? args[a].recid : args[a];
                let index = this.get(recid, true);
                if (index == null) continue;
                let recEl1 = null;
                let recEl2 = null;
                if (this.searchData.length !== 0 || index + 1 >= this.last.vscroll.recIndStart && index + 1 <= this.last.vscroll.recIndEnd) {
                    recEl1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
                    recEl2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
                }
                if (this.selectType == 'row') {
                    if (sel.indexes.indexOf(index) != -1) continue;
                    sel.indexes.push(index);
                    if (recEl1 && recEl2) {
                        recEl1.addClass('w2ui-selected').find('.w2ui-col-number').addClass('w2ui-row-selected');
                        recEl2.addClass('w2ui-selected').find('.w2ui-col-number').addClass('w2ui-row-selected');
                        recEl1.find('.w2ui-grid-select-check').prop('checked', true);
                    }
                    selected++;
                }
            }
            else {
                // normalize for performance
                let new_sel = {};
                for(let a = 0; a < args.length; a++){
                    let recid = typeof args[a] == 'object' ? args[a].recid : args[a];
                    let column = typeof args[a] == 'object' ? args[a].column : null;
                    new_sel[recid] = new_sel[recid] || [];
                    if (Array.isArray(column)) new_sel[recid] = column;
                    else if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(column)) new_sel[recid].push(column);
                    else for(let i = 0; i < this.columns.length; i++){
                        if (this.columns[i].hidden) continue;
                        new_sel[recid].push(parseInt(i));
                    }
                }
                // add all
                let col_sel = [];
                for(let recid in new_sel){
                    let index = this.get(recid, true);
                    if (index == null) continue;
                    let recEl1 = null;
                    let recEl2 = null;
                    if (index + 1 >= this.last.vscroll.recIndStart && index + 1 <= this.last.vscroll.recIndEnd) {
                        recEl1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
                        recEl2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
                    }
                    let s = sel.columns[index] || [];
                    // default action
                    if (sel.indexes.indexOf(index) == -1) sel.indexes.push(index);
                    // only only those that are new
                    for(let t = 0; t < new_sel[recid].length; t++)if (s.indexOf(new_sel[recid][t]) == -1) s.push(new_sel[recid][t]);
                    s.sort((a, b)=>{
                        return a - b;
                    }) // sort function must be for numerical sort
                    ;
                    for(let t = 0; t < new_sel[recid].length; t++){
                        let col = new_sel[recid][t];
                        if (col_sel.indexOf(col) == -1) col_sel.push(col);
                        if (recEl1) {
                            recEl1.find('#grid_' + this.name + '_data_' + index + '_' + col).addClass('w2ui-selected');
                            recEl1.find('.w2ui-col-number').addClass('w2ui-row-selected');
                            recEl1.find('.w2ui-grid-select-check').prop('checked', true);
                        }
                        if (recEl2) {
                            recEl2.find('#grid_' + this.name + '_data_' + index + '_' + col).addClass('w2ui-selected');
                            recEl2.find('.w2ui-col-number').addClass('w2ui-row-selected');
                            recEl2.find('.w2ui-grid-select-check').prop('checked', true);
                        }
                        selected++;
                    }
                    // save back to selection object
                    sel.columns[index] = s;
                }
                // select columns (need here for speed)
                for(let c = 0; c < col_sel.length; c++)$aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_column_' + col_sel[c] + ' .w2ui-col-header').addClass('w2ui-col-selected');
            }
            // need to sort new selection for speed
            sel.indexes.sort((a, b)=>{
                return a - b;
            });
            // all selected?
            let areAllSelected = this.records.length > 0 && sel.indexes.length == this.records.length, areAllSearchedSelected = sel.indexes.length > 0 && this.searchData.length !== 0 && sel.indexes.length == this.last.searchIds.length;
            if (areAllSelected || areAllSearchedSelected) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', true);
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', false);
            this.status();
            this.addRange('selection');
            this.updateToolbar(sel, areAllSelected);
            // event after
            edata.finish();
            return selected;
        }
        unselect() {
            let unselected = 0;
            let sel = this.last.selection;
            // if too many arguments > 150k, then it errors off
            let args = Array.from(arguments);
            if (Array.isArray(args[0])) args = args[0];
            // event before
            let tmp = {
                target: this.name
            };
            if (args.length == 1) {
                tmp.multiple = false;
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(args[0])) tmp.clicked = {
                    recid: args[0].recid,
                    column: args[0].column
                };
                else tmp.clicked = {
                    recid: args[0]
                };
            } else {
                tmp.multiple = true;
                tmp.recids = args;
            }
            let edata = this.trigger('select', tmp);
            if (edata.isCancelled === true) return 0;
            for(let a = 0; a < args.length; a++){
                let recid = typeof args[a] == 'object' ? args[a].recid : args[a];
                let record = this.get(recid);
                if (record == null) continue;
                let index = this.get(record.recid, true);
                let recEl1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
                let recEl2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
                if (this.selectType == 'row') {
                    if (sel.indexes.indexOf(index) == -1) continue;
                    // default action
                    sel.indexes.splice(sel.indexes.indexOf(index), 1);
                    recEl1.removeClass('w2ui-selected w2ui-inactive').find('.w2ui-col-number').removeClass('w2ui-row-selected');
                    recEl2.removeClass('w2ui-selected w2ui-inactive').find('.w2ui-col-number').removeClass('w2ui-row-selected');
                    if (recEl1.length != 0) {
                        recEl1[0].style.cssText = 'height: ' + this.recordHeight + 'px; ' + recEl1.attr('custom_style');
                        recEl2[0].style.cssText = 'height: ' + this.recordHeight + 'px; ' + recEl2.attr('custom_style');
                    }
                    recEl1.find('.w2ui-grid-select-check').prop('checked', false);
                    unselected++;
                } else {
                    let col = args[a].column;
                    if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(col)) {
                        let cols = [];
                        for(let i = 0; i < this.columns.length; i++){
                            if (this.columns[i].hidden) continue;
                            cols.push({
                                recid: recid,
                                column: i
                            });
                        }
                        return this.unselect(cols);
                    }
                    let s = sel.columns[index];
                    if (!Array.isArray(s) || s.indexOf(col) == -1) continue;
                    // default action
                    s.splice(s.indexOf(col), 1);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_rec_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid)} > td[col="${col}"]`).removeClass('w2ui-selected w2ui-inactive');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_frec_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid)} > td[col="${col}"]`).removeClass('w2ui-selected w2ui-inactive');
                    // check if any row/column still selected
                    let isColSelected = false;
                    let isRowSelected = false;
                    let tmp = this.getSelection();
                    for(let i = 0; i < tmp.length; i++){
                        if (tmp[i].column == col) isColSelected = true;
                        if (tmp[i].recid == recid) isRowSelected = true;
                    }
                    if (!isColSelected) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`.w2ui-grid-columns td[col="${col}"] .w2ui-col-header, .w2ui-grid-fcolumns td[col="${col}"] .w2ui-col-header`).removeClass('w2ui-col-selected');
                    if (!isRowSelected) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid)).find('.w2ui-col-number').removeClass('w2ui-row-selected');
                    unselected++;
                    if (s.length === 0) {
                        delete sel.columns[index];
                        sel.indexes.splice(sel.indexes.indexOf(index), 1);
                        recEl1.find('.w2ui-grid-select-check').prop('checked', false);
                    }
                }
            }
            // all selected?
            let areAllSelected = this.records.length > 0 && sel.indexes.length == this.records.length, areAllSearchedSelected = sel.indexes.length > 0 && this.searchData.length !== 0 && sel.indexes.length == this.last.searchIds.length;
            if (areAllSelected || areAllSearchedSelected) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', true);
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', false);
            // show number of selected
            this.status();
            this.addRange('selection');
            this.updateToolbar(sel, areAllSelected);
            // event after
            edata.finish();
            return unselected;
        }
        selectAll() {
            let time = Date.now();
            if (this.multiSelect === false) return;
            // default action
            let url = this.url?.get ?? this.url;
            let sel = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(this.last.selection);
            let cols = [];
            for(let i = 0; i < this.columns.length; i++)cols.push(i);
            // if local data source and searched
            sel.indexes = [];
            if (!url && this.searchData.length !== 0) for(let i = 0; i < this.last.searchIds.length; i++){
                sel.indexes.push(this.last.searchIds[i]);
                if (this.selectType != 'row') sel.columns[this.last.searchIds[i]] = cols.slice() // .slice makes copy of the array
                ;
            }
            else {
                let buffered = this.records.length;
                if (this.searchData.length != 0 && !url) buffered = this.last.searchIds.length;
                for(let i = 0; i < buffered; i++){
                    sel.indexes.push(i);
                    if (this.selectType != 'row') sel.columns[i] = cols.slice() // .slice makes copy of the array
                    ;
                }
            }
            // event before
            let edata = this.trigger('select', {
                target: this.name,
                multiple: true,
                all: true,
                clicked: sel
            });
            if (edata.isCancelled === true) return;
            this.last.selection = sel;
            // add selected class
            if (this.selectType == 'row') {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-records tr:not(.w2ui-empty-record)').addClass('w2ui-selected').find('.w2ui-col-number').addClass('w2ui-row-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-frecords tr:not(.w2ui-empty-record)').addClass('w2ui-selected').find('.w2ui-col-number').addClass('w2ui-row-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('input.w2ui-grid-select-check').prop('checked', true);
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-columns td .w2ui-col-header, .w2ui-grid-fcolumns td .w2ui-col-header').addClass('w2ui-col-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-records tr .w2ui-col-number').addClass('w2ui-row-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-records tr:not(.w2ui-empty-record)').find('.w2ui-grid-data:not(.w2ui-col-select)').addClass('w2ui-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-frecords tr .w2ui-col-number').addClass('w2ui-row-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-frecords tr:not(.w2ui-empty-record)').find('.w2ui-grid-data:not(.w2ui-col-select)').addClass('w2ui-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('input.w2ui-grid-select-check').prop('checked', true);
            }
            // enable/disable toolbar buttons
            sel = this.getSelection(true);
            this.addRange('selection');
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', true);
            this.status();
            this.updateToolbar({
                indexes: sel
            }, true);
            // event after
            edata.finish();
            return Date.now() - time;
        }
        selectNone(skipEvent) {
            let time = Date.now();
            // event before
            let edata;
            if (!skipEvent) {
                edata = this.trigger('select', {
                    target: this.name,
                    clicked: []
                });
                if (edata.isCancelled === true) return;
            }
            // default action
            let sel = this.last.selection;
            // remove selected class
            if (this.selectType == 'row') {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-records tr.w2ui-selected').removeClass('w2ui-selected w2ui-inactive').find('.w2ui-col-number').removeClass('w2ui-row-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-frecords tr.w2ui-selected').removeClass('w2ui-selected w2ui-inactive').find('.w2ui-col-number').removeClass('w2ui-row-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('input.w2ui-grid-select-check').prop('checked', false);
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-columns td .w2ui-col-header, .w2ui-grid-fcolumns td .w2ui-col-header').removeClass('w2ui-col-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-records tr .w2ui-col-number').removeClass('w2ui-row-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-frecords tr .w2ui-col-number').removeClass('w2ui-row-selected');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-data.w2ui-selected').removeClass('w2ui-selected w2ui-inactive');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('input.w2ui-grid-select-check').prop('checked', false);
            }
            sel.indexes = [];
            sel.columns = {};
            this.removeRange('selection');
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', false);
            this.status();
            this.updateToolbar(sel, false);
            // event after
            if (!skipEvent) edata.finish();
            return Date.now() - time;
        }
        updateToolbar(sel) {
            let obj = this;
            let cnt = sel && sel.indexes ? sel.indexes.length : 0;
            // if there is no toolbar
            if (!this.toolbar.render) return;
            this.toolbar.items.forEach((item)=>{
                _checkItem(item, '');
                if (Array.isArray(item.items)) item.items.forEach((it)=>{
                    _checkItem(it, item.id + ':');
                });
            });
            // enable/disable toolbar search button
            if (this.show.toolbarSave) {
                if (this.getChanges().length > 0) this.toolbar.enable('w2ui-save');
                else this.toolbar.disable('w2ui-save');
            }
            function _checkItem(item, prefix) {
                if (item.batch != null) {
                    let enabled = false;
                    if (item.batch === true) {
                        if (cnt > 0) enabled = true;
                    } else if (typeof item.batch == 'number') {
                        if (cnt === item.batch) enabled = true;
                    } else if (typeof item.batch == 'function') enabled = item.batch({
                        cnt: cnt,
                        sel: sel
                    });
                    if (enabled) obj.toolbar.enable(prefix + item.id);
                    else obj.toolbar.disable(prefix + item.id);
                }
            }
        }
        getSelection(returnIndex) {
            let ret = [];
            let sel = this.last.selection;
            if (this.selectType == 'row') {
                for(let i = 0; i < sel.indexes.length; i++){
                    if (!this.records[sel.indexes[i]]) continue;
                    if (returnIndex === true) ret.push(sel.indexes[i]);
                    else ret.push(this.records[sel.indexes[i]].recid);
                }
                return ret;
            } else {
                for(let i = 0; i < sel.indexes.length; i++){
                    let cols = sel.columns[sel.indexes[i]];
                    if (!this.records[sel.indexes[i]]) continue;
                    for(let j = 0; j < cols.length; j++)ret.push({
                        recid: this.records[sel.indexes[i]].recid,
                        index: parseInt(sel.indexes[i]),
                        column: cols[j]
                    });
                }
                return ret;
            }
        }
        search(field, value) {
            let url = this.url?.get ?? this.url;
            let searchData = [];
            let last_multi = this.last.multi;
            let last_logic = this.last.logic;
            let last_field = this.last.field;
            let last_search = this.last.search;
            let hasHiddenSearches = false;
            let overlay = $aa2bd8933167d9cb$export$2fa187e846a241c4(`#w2overlay-${this.name}-search-overlay`);
            // add hidden searches
            for(let i = 0; i < this.searches.length; i++){
                if (!this.searches[i].hidden || this.searches[i].value == null) continue;
                searchData.push({
                    field: this.searches[i].field,
                    operator: this.searches[i].operator || 'is',
                    type: this.searches[i].type,
                    value: this.searches[i].value || ''
                });
                hasHiddenSearches = true;
            }
            if (arguments.length === 0 && overlay.length === 0) {
                if (this.multiSearch) {
                    field = this.searchData;
                    value = this.last.logic;
                } else {
                    field = this.last.field;
                    value = this.last.search;
                }
            }
            // 1: search() - advanced search (reads from popup)
            if (arguments.length === 0 && overlay.length !== 0) {
                this.focus() // otherwise search drop down covers searches
                ;
                last_logic = overlay.find(`#grid_${this.name}_logic`).val();
                last_search = '';
                // advanced search
                for(let i = 0; i < this.searches.length; i++){
                    let search = this.searches[i];
                    let operator = overlay.find('#grid_' + this.name + '_operator_' + i).val();
                    let field1 = overlay.find('#grid_' + this.name + '_field_' + i);
                    let field2 = overlay.find('#grid_' + this.name + '_field2_' + i);
                    let value1 = field1.val();
                    let value2 = field2.val();
                    let svalue = null;
                    let text = null;
                    if ([
                        'int',
                        'float',
                        'money',
                        'currency',
                        'percent'
                    ].indexOf(search.type) != -1) {
                        let fld1 = field1[0]._w2field;
                        let fld2 = field2[0]._w2field;
                        if (fld1) value1 = fld1.clean(value1);
                        if (fld2) value2 = fld2.clean(value2);
                    }
                    if ([
                        'list',
                        'enum'
                    ].indexOf(search.type) != -1 || [
                        'in',
                        'not in'
                    ].indexOf(operator) != -1) {
                        value1 = field1[0]._w2field.selected || {};
                        if (Array.isArray(value1)) {
                            svalue = [];
                            for(let j = 0; j < value1.length; j++){
                                svalue.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(value1[j].id) ? parseFloat(value1[j].id) : String(value1[j].id).toLowerCase());
                                delete value1[j].hidden;
                            }
                            if (Object.keys(value1).length === 0) value1 = '';
                        } else {
                            text = value1.text || '';
                            value1 = value1.id || '';
                        }
                    }
                    if (value1 !== '' && value1 != null || value2 != null && value2 !== '') {
                        let tmp = {
                            field: search.field,
                            type: search.type,
                            operator: operator
                        };
                        if (operator == 'between') $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(tmp, {
                            value: [
                                value1,
                                value2
                            ]
                        });
                        else if (operator == 'in' && typeof value1 == 'string') $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(tmp, {
                            value: value1.split(',')
                        });
                        else if (operator == 'not in' && typeof value1 == 'string') $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(tmp, {
                            value: value1.split(',')
                        });
                        else $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(tmp, {
                            value: value1
                        });
                        if (svalue) $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(tmp, {
                            svalue: svalue
                        });
                        if (text) $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(tmp, {
                            text: text
                        });
                        // convert date to unix time
                        try {
                            if (search.type == 'date' && operator == 'between') {
                                tmp.value[0] = value1 // w2utils.isDate(value1, w2utils.settings.dateFormat, true).getTime();
                                ;
                                tmp.value[1] = value2 // w2utils.isDate(value2, w2utils.settings.dateFormat, true).getTime();
                                ;
                            }
                            if (search.type == 'date' && operator == 'is') tmp.value = value1 // w2utils.isDate(value1, w2utils.settings.dateFormat, true).getTime();
                            ;
                        } catch (e) {}
                        searchData.push(tmp);
                        last_multi = true // if only hidden searches, then do not set
                        ;
                    }
                }
            }
            // 2: search(field, value) - regular search
            if (typeof field == 'string') {
                // if only one argument - search all
                if (arguments.length == 1) {
                    value = field;
                    field = 'all';
                }
                last_field = field;
                last_search = value;
                last_multi = false;
                last_logic = hasHiddenSearches ? 'AND' : 'OR';
                // loop through all searches and see if it applies
                if (value != null) {
                    if (field.toLowerCase() == 'all') {
                        // if there are search fields loop thru them
                        if (this.searches.length > 0) for(let i = 0; i < this.searches.length; i++){
                            let search = this.searches[i];
                            if (search.type == 'text' || search.type == 'alphanumeric' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isAlphaNumeric(value) || search.type == 'int' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(value) || search.type == 'float' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(value) || search.type == 'percent' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(value) || (search.type == 'hex' || search.type == 'color') && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isHex(value) || search.type == 'currency' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isMoney(value) || search.type == 'money' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isMoney(value) || search.type == 'date' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(value) || search.type == 'time' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isTime(value) || search.type == 'datetime' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime(value) || search.type == 'datetime' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(value) || search.type == 'enum' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isAlphaNumeric(value) || search.type == 'list' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isAlphaNumeric(value)) {
                                let def = this.defaultOperator[this.operatorsMap[search.type]];
                                let tmp = {
                                    field: search.field,
                                    type: search.type,
                                    operator: search.operator != null ? search.operator : def,
                                    value: value
                                };
                                if (String(value).trim() != '') searchData.push(tmp);
                            }
                            // range in global search box
                            if ([
                                'int',
                                'float',
                                'money',
                                'currency',
                                'percent'
                            ].indexOf(search.type) != -1 && String(value).trim().split('-').length == 2) {
                                let t = String(value).trim().split('-');
                                let tmp = {
                                    field: search.field,
                                    type: search.type,
                                    operator: search.operator != null ? search.operator : 'between',
                                    value: [
                                        t[0],
                                        t[1]
                                    ]
                                };
                                searchData.push(tmp);
                            }
                            // lists fields
                            if ([
                                'list',
                                'enum'
                            ].indexOf(search.type) != -1) {
                                let new_values = [];
                                if (search.options == null) search.options = {};
                                if (!Array.isArray(search.options.items)) search.options.items = [];
                                for(let j = 0; j < search.options.items; j++){
                                    let tmp = search.options.items[j];
                                    try {
                                        let re = new RegExp(value, 'i');
                                        if (re.test(tmp)) new_values.push(j);
                                        if (tmp.text && re.test(tmp.text)) new_values.push(tmp.id);
                                    } catch (e) {}
                                }
                                if (new_values.length > 0) {
                                    let tmp = {
                                        field: search.field,
                                        type: search.type,
                                        operator: search.operator != null ? search.operator : 'in',
                                        value: new_values
                                    };
                                    searchData.push(tmp);
                                }
                            }
                        }
                        else for(let i = 0; i < this.columns.length; i++){
                            let tmp = {
                                field: this.columns[i].field,
                                type: 'text',
                                operator: this.defaultOperator.text,
                                value: value
                            };
                            searchData.push(tmp);
                        }
                        /**
                     * If user searched ALL field and there was no matching searches then add a bogus field, so that no result will be
                     * shown. Otherwise search string is not empty, but no fields is actually applied and all fields are shown
                     */ if (searchData.length == 0) {
                            let tmp = {
                                field: 'All',
                                type: 'text',
                                operator: this.defaultOperator.text,
                                value: value
                            };
                            searchData.push(tmp);
                        }
                    } else {
                        let el = overlay.find('#grid_' + this.name + '_search_all');
                        let search = this.getSearch(field);
                        if (search == null) search = {
                            field: field,
                            type: 'text'
                        };
                        if (search.field == field) this.last.label = search.label;
                        if (value !== '') {
                            let op = this.defaultOperator[this.operatorsMap[search.type]];
                            let val = value;
                            if ([
                                'date',
                                'time',
                                'datetime'
                            ].indexOf(search.type) != -1) op = 'is';
                            if ([
                                'list',
                                'enum'
                            ].indexOf(search.type) != -1) {
                                op = 'is';
                                let tmp = el._w2field.get();
                                if (tmp && Object.keys(tmp).length > 0) val = tmp.id;
                                else val = '';
                            }
                            if (search.type == 'int' && value !== '') {
                                op = 'is';
                                if (String(value).indexOf('-') != -1) {
                                    let tmp = value.split('-');
                                    if (tmp.length == 2) {
                                        op = 'between';
                                        val = [
                                            parseInt(tmp[0]),
                                            parseInt(tmp[1])
                                        ];
                                    }
                                }
                                if (String(value).indexOf(',') != -1) {
                                    let tmp = value.split(',');
                                    op = 'in';
                                    val = [];
                                    for(let i = 0; i < tmp.length; i++)val.push(tmp[i]);
                                }
                            }
                            if (search.operator != null) op = search.operator;
                            let tmp = {
                                field: search.field,
                                type: search.type,
                                operator: op,
                                value: val
                            };
                            searchData.push(tmp);
                        }
                    }
                }
            }
            // 3: search([{ field, value, [operator,] [type] }, { field, value, [operator,] [type] } ], logic) - submit whole structure
            if (Array.isArray(field)) {
                let logic = 'AND';
                if (typeof value == 'string') {
                    logic = value.toUpperCase();
                    if (logic != 'OR' && logic != 'AND') logic = 'AND';
                }
                last_search = '';
                last_multi = true;
                last_logic = logic;
                for(let i = 0; i < field.length; i++){
                    let data = field[i];
                    if (typeof data.value == 'number' && data.operator == null) data.operator = this.defaultOperator.number;
                    if (typeof data.value == 'string' && data.operator == null) data.operator = this.defaultOperator.text;
                    if (Array.isArray(data.value) && data.operator == null) data.operator = this.defaultOperator.enum;
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(data.value) && data.operator == null) data.operator = this.defaultOperator.date;
                    // merge current field and search if any
                    searchData.push(data);
                }
            }
            // event before
            let edata = this.trigger('search', {
                target: this.name,
                multi: arguments.length === 0 ? true : false,
                searchField: field ? field : 'multi',
                searchValue: field ? value : 'multi',
                searchData: searchData,
                searchLogic: last_logic
            });
            if (edata.isCancelled === true) return;
            // default action
            this.searchData = edata.detail.searchData;
            this.last.field = last_field;
            this.last.search = last_search;
            this.last.multi = last_multi;
            this.last.logic = edata.detail.searchLogic;
            this.last.vscroll.scrollTop = 0;
            this.last.vscroll.scrollLeft = 0;
            this.last.selection.indexes = [];
            this.last.selection.columns = {};
            // -- clear all search field
            this.searchClose();
            // apply search
            if (url) {
                this.last.fetch.offset = 0;
                this.reload();
            } else {
                // local search
                this.localSearch();
                this.refresh();
            }
            // event after
            edata.finish();
        }
        // open advanced search popover
        searchOpen() {
            if (!this.box) return;
            if (this.searches.length === 0) return;
            // event before
            let edata = this.trigger('searchOpen', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            let $btn = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.toolbar.box).find('.w2ui-grid-search-input .w2ui-search-drop');
            $btn.addClass('checked');
            // show search
            $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                name: this.name + '-search-overlay',
                anchor: $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_search_all').get(0),
                position: 'bottom|top',
                html: this.getSearchesHTML(),
                align: 'left',
                arrowSize: 12,
                class: 'w2ui-grid-search-advanced',
                hideOn: [
                    'doc-click'
                ]
            }).then((event1)=>{
                this.initSearches();
                this.last.search_opened = true;
                let overlay = $aa2bd8933167d9cb$export$2fa187e846a241c4(`#w2overlay-${this.name}-search-overlay`);
                overlay.data('gridName', this.name).off('.grid-search').on('click.grid-search', ()=>{
                    // hide any tooltip opened by searches
                    overlay.find('input, select').each((el)=>{
                        let names = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).data('tooltipName');
                        if (names) names.forEach((name)=>{
                            $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(name);
                        });
                    });
                });
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents(overlay.find('select, input, button'), this);
                // init first field
                let sfields = $aa2bd8933167d9cb$export$2fa187e846a241c4(`#w2overlay-${this.name}-search-overlay *[rel=search]`);
                if (sfields.length > 0) sfields[0].focus();
                // event after
                edata.finish();
            }).hide((event1)=>{
                $btn.removeClass('checked');
                this.last.search_opened = false;
            });
        }
        searchClose() {
            $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-search-overlay');
        }
        // if clicked on a field in the search strip
        searchFieldTooltip(ind, sd_ind, el) {
            let sf = this.searches[ind];
            let sd = this.searchData[sd_ind];
            let oper = sd.operator;
            if (oper == 'more' && sd.type == 'date') oper = 'since';
            if (oper == 'less' && sd.type == 'date') oper = 'before';
            let options = '';
            let val = sd.value;
            if (Array.isArray(sd.value)) {
                sd.value.forEach((opt)=>{
                    options += `<span class="value">${opt.text || opt}</span>`;
                });
                if (sd.type == 'date') {
                    options = '';
                    sd.value.forEach((opt)=>{
                        options += `<span class="value">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(opt)}</span>`;
                    });
                }
            } else if (sd.type == 'date') val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime(val);
            $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-search-props');
            $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                name: this.name + '-search-props',
                anchor: el,
                class: 'w2ui-white',
                hideOn: 'doc-click',
                html: `
                <div class="w2ui-grid-search-single">
                    <span class="field">${sf.label}</span>
                    <span class="operator">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(oper)}</span>
                    ${Array.isArray(sd.value) ? `${options}` : `<span class="value">${val}</span>`}
                    <div class="buttons">
                        <button id="remove" class="w2ui-btn">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Remove This Field')}</button>
                    </div>
                </div>`
            }).then((event1)=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.overlay.box).find('#remove').on('click', ()=>{
                    this.searchData.splice(`${sd_ind}`, 1);
                    this.reload();
                    this.localSearch();
                    $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-search-props');
                });
            });
        }
        // drop down with save searches
        searchSuggest(imediate, forceHide, input) {
            clearTimeout(this.last.kbd_timer);
            clearTimeout(this.last.overlay_timer);
            this.searchShowFields(true);
            this.searchClose();
            if (forceHide === true) {
                $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-search-suggest');
                return;
            }
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(`#w2overlay-${this.name}-search-suggest`).length > 0) return;
            if (!imediate) {
                this.last.overlay_timer = setTimeout(()=>{
                    this.searchSuggest(true);
                }, 100);
                return;
            }
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_all`).get(0);
            let searches = [
                ...this.defaultSearches ?? [],
                ...this.defaultSearches?.length > 0 && this.savedSearches?.length > 0 ? [
                    '--'
                ] : [],
                ...this.savedSearches ?? []
            ];
            if (Array.isArray(searches) && searches.length > 0) $aa2bd8933167d9cb$export$3842f79f22e98342.show({
                name: this.name + '-search-suggest',
                anchor: el,
                align: 'both',
                items: searches,
                hideOn: [
                    'doc-click',
                    'sleect',
                    'remove'
                ],
                render (item) {
                    let ret = item.text;
                    if (item.isDefault) ret = `<b>${ret}</b>`;
                    return ret;
                }
            }).select((event1)=>{
                let edata = this.trigger('searchSelect', {
                    target: this.name,
                    index: event1.detail.index,
                    item: event1.detail.item
                });
                if (edata.isCancelled === true) {
                    event1.preventDefault();
                    return;
                }
                event1.detail.overlay.hide();
                this.last.logic = event1.detail.item.logic || 'AND';
                this.last.search = '';
                this.last.label = '[Multiple Fields]';
                this.searchData = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(event1.detail.item.data);
                this.searchSelected = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(event1.detail.item, {
                    exclude: [
                        'icon',
                        'remove'
                    ]
                });
                this.reload();
                edata.finish();
            }).remove((event1)=>{
                let item = event1.detail.item;
                let edata = this.trigger('searchRemove', {
                    target: this.name,
                    index: event1.detail.index,
                    item: item
                });
                if (edata.isCancelled === true) {
                    event1.preventDefault();
                    return;
                }
                event1.detail.overlay.hide();
                this.confirm($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Do you want to delete search "${item}"?', {
                    item: item.text
                })).yes((evt)=>{
                    // remove from searches
                    let search = this.savedSearches.findIndex((s)=>s.id == item.id ? true : false);
                    if (search !== -1) this.savedSearches.splice(search, 1);
                    this.cacheSave('searches', this.savedSearches.map((s)=>$aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(s, {
                            exclude: [
                                'remove',
                                'icon'
                            ]
                        })));
                    evt.detail.self.close();
                    // evt after
                    edata.finish();
                }).no((evt)=>{
                    evt.detail.self.close();
                });
            });
        }
        searchSave() {
            let value = '';
            if (this.searchSelected) value = this.searchSelected.text;
            let ind = this.savedSearches.findIndex((s)=>{
                return s.id == this.searchSelected?.id ? true : false;
            });
            // event before
            let edata = this.trigger('searchSave', {
                target: this.name,
                saveLocalStorage: true
            });
            if (edata.isCancelled === true) return;
            this.message({
                width: 350,
                height: 150,
                body: `<div class="w2ui-grid-save-search">
                        <span>${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(ind != -1 ? 'Update Search' : 'Save New Search')}</span>
                        <input class="search-name w2ui-input" placeholder="${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Search name')}">
                   </div>`,
                buttons: `
                <button id="grid-search-cancel" class="w2ui-btn">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Cancel')}</button>
                <button id="grid-search-save" class="w2ui-btn w2ui-btn-blue" ${String(value).trim() == '' ? 'disabled' : ''}>${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Save')}</button>
            `
            }).open(async (event1)=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find('input, button').eq(0).val(value);
                await event1.complete;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find('#grid-search-cancel').on('click', ()=>{
                    this.message();
                });
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find('#grid-search-save').on('click', ()=>{
                    let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find('.w2ui-message .search-name').val();
                    // save in savedSearches
                    if (this.searchSelected && ind != -1) Object.assign(this.savedSearches[ind], {
                        id: name,
                        text: name,
                        logic: this.last.logic,
                        data: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(this.searchData)
                    });
                    else this.savedSearches.push({
                        id: name,
                        text: name,
                        icon: 'w2ui-icon-search',
                        remove: true,
                        logic: this.last.logic,
                        data: this.searchData
                    });
                    // save local storage
                    this.cacheSave('searches', this.savedSearches.map((s)=>$aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(s, {
                            exclude: [
                                'remove',
                                'icon'
                            ]
                        })));
                    this.message();
                    // update on screen
                    if (this.searchSelected) {
                        this.searchSelected.text = name;
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_name .name-text`).html(name);
                    } else {
                        this.searchSelected = {
                            text: name,
                            logic: this.last.logic,
                            data: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(this.searchData)
                        };
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find(`#grid_${this.name}_search_all`).val(' ').prop('readOnly', true);
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find(`#grid_${this.name}_search_name`).show().find('.name-text').html(name);
                    }
                    edata.finish({
                        name: name
                    });
                });
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find('input, button').off('.message').on('keydown.message', (evt)=>{
                    let val = String($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find('.w2ui-message-body input').val()).trim();
                    if (evt.keyCode == 13 && val != '') $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).find('#grid-search-save').trigger('click') // enter
                    ;
                    if (evt.keyCode == 27) this.message();
                }).eq(0).on('input.message', (evt)=>{
                    let $save = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).closest('.w2ui-message').find('#grid-search-save');
                    if (String($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.detail.box).val()).trim() === '') $save.prop('disabled', true);
                    else $save.prop('disabled', false);
                }).get(0).focus();
            });
        }
        cache(type) {
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.hasLocalStorage && this.useLocalStorage) try {
                let data = JSON.parse(localStorage.w2ui || '{}');
                data[this.stateId || this.name] ??= {};
                return data[this.stateId || this.name][type];
            } catch (e) {}
            return null;
        }
        cacheSave(type, value) {
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.hasLocalStorage && this.useLocalStorage) try {
                let data = JSON.parse(localStorage.w2ui || '{}');
                data[this.stateId || this.name] ??= {};
                data[this.stateId || this.name][type] = value;
                localStorage.w2ui = JSON.stringify(data);
                return true;
            } catch (e) {
                delete localStorage.w2ui;
            }
            return false;
        }
        searchReset(noReload) {
            let searchData = [];
            let hasHiddenSearches = false;
            // add hidden searches
            for(let i = 0; i < this.searches.length; i++){
                if (!this.searches[i].hidden || this.searches[i].value == null) continue;
                searchData.push({
                    field: this.searches[i].field,
                    operator: this.searches[i].operator || 'is',
                    type: this.searches[i].type,
                    value: this.searches[i].value || ''
                });
                hasHiddenSearches = true;
            }
            // event before
            let edata = this.trigger('search', {
                reset: true,
                target: this.name,
                searchData: searchData
            });
            if (edata.isCancelled === true) return;
            // default action
            let input = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_search_all');
            this.searchData = edata.detail.searchData;
            this.searchSelected = null;
            this.last.search = '';
            this.last.logic = hasHiddenSearches ? 'AND' : 'OR';
            // --- do not reset to All Fields (I think)
            input.next().hide() // advanced search button
            ;
            if (this.searches.length > 0) {
                if (!this.multiSearch || !this.show.searchAll) {
                    let tmp = 0;
                    while(tmp < this.searches.length && (this.searches[tmp].hidden || this.searches[tmp].simple === false))tmp++;
                    if (tmp >= this.searches.length) {
                        // all searches are hidden
                        this.last.field = '';
                        this.last.label = '';
                    } else {
                        this.last.field = this.searches[tmp].field;
                        this.last.label = this.searches[tmp].label;
                    }
                } else {
                    this.last.field = 'all';
                    this.last.label = 'All Fields';
                    input.next().show() // advanced search button
                    ;
                }
            }
            this.last.multi = false;
            this.last.fetch.offset = 0;
            // reset scrolling position
            this.last.vscroll.scrollTop = 0;
            this.last.vscroll.scrollLeft = 0;
            this.last.selection.indexes = [];
            this.last.selection.columns = {};
            // -- clear all search field
            this.searchClose();
            let all = input.val('').get(0);
            if (all?._w2field) all._w2field.reset();
            // apply search
            if (!noReload) this.reload();
            // event after
            edata.finish();
        }
        searchShowFields(forceHide) {
            if (forceHide === true) {
                $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-search-fields');
                return;
            }
            let items = [];
            for(let s = -1; s < this.searches.length; s++){
                let search = this.searches[s];
                let sField = search ? search.field : null;
                let column = this.getColumn(sField);
                let disabled = false;
                let tooltip = null;
                if (this.show.searchHiddenMsg == true && s != -1 && (column == null || column.hidden === true && column.hideable !== false)) {
                    disabled = true;
                    tooltip = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(`This column ${column == null ? 'does not exist' : 'is hidden'}`);
                }
                if (s == -1) {
                    if (!this.multiSearch || !this.show.searchAll) continue;
                    search = {
                        field: 'all',
                        label: 'All Fields'
                    };
                } else {
                    if (column != null && column.hideable === false) continue;
                    if (search.hidden === true) {
                        tooltip = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('This column is hidden');
                        // don't show hidden (not simple) searches
                        if (search.simple === false) continue;
                    }
                }
                if (search.label == null && search.caption != null) {
                    console.log('NOTICE: grid search.caption property is deprecated, please use search.label. Search ->', search);
                    search.label = search.caption;
                }
                items.push({
                    id: search.field,
                    text: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(search.label),
                    search: search,
                    tooltip: tooltip,
                    disabled: disabled,
                    checked: search.field == this.last.field
                });
            }
            $aa2bd8933167d9cb$export$3842f79f22e98342.show({
                type: 'radio',
                name: this.name + '-search-fields',
                anchor: $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_search_name').parent().find('.w2ui-search-down').get(0),
                items: items,
                align: 'none',
                hideOn: [
                    'doc-click',
                    'select'
                ]
            }).select((event1)=>{
                this.searchInitInput(event1.detail.item.search.field);
            });
        }
        searchInitInput(field, value) {
            let search;
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_search_all');
            if (field == 'all') search = {
                field: 'all',
                label: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('All Fields')
            };
            else {
                search = this.getSearch(field);
                if (search == null) return;
            }
            // update field
            if (this.last.search != '') {
                this.last.label = search.label;
                this.search(search.field, this.last.search);
            } else {
                this.last.field = search.field;
                this.last.label = search.label;
            }
            el.attr('placeholder', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Search') + ' ' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(search.label || search.caption || search.field, true));
        }
        // clears records and related params
        clear(noRefresh) {
            this.total = 0;
            this.records = [];
            this.summary = [];
            this.last.fetch.offset = 0 // need this for reload button to work on remote data set
            ;
            this.last.idCache = {} // optimization to free memory
            ;
            this.last.selection = {
                indexes: [],
                columns: {}
            };
            this.reset(true);
            // refresh
            if (!noRefresh) this.refresh();
        }
        // clears scroll position, selection, ranges
        reset(noRefresh) {
            // position
            this.last.vscroll.scrollTop = 0;
            this.last.vscroll.scrollLeft = 0;
            this.last.vscroll.recIndStart = null;
            this.last.vscroll.recIndEnd = null;
            // additional
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_records`).prop('scrollTop', 0);
            // refresh
            if (!noRefresh) this.refresh();
        }
        skip(offset, callBack) {
            let url = this.url?.get ?? this.url;
            if (url) {
                this.offset = parseInt(offset);
                if (this.offset > this.total) this.offset = this.total - this.limit;
                if (this.offset < 0 || !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(this.offset)) this.offset = 0;
                this.clear(true);
                this.reload(callBack);
            } else console.log('ERROR: grid.skip() can only be called when you have remote data source.');
        }
        load(url, callBack) {
            if (url == null) {
                console.log('ERROR: You need to provide url argument when calling .load() method of "' + this.name + '" object.');
                return new Promise((resolve, reject)=>{
                    reject();
                });
            }
            // default action
            this.clear(true);
            return this.request('load', {}, url, callBack);
        }
        reload(callBack) {
            let grid = this;
            let url = this.url?.get ?? this.url;
            grid.selectionSave();
            if (url) return this.load(url, ()=>{
                grid.selectionRestore();
                if (typeof callBack == 'function') callBack();
            });
            else {
                this.reset(true);
                this.localSearch();
                this.selectionRestore();
                if (typeof callBack == 'function') callBack({
                    status: 'success'
                });
                return new Promise((resolve)=>{
                    resolve();
                });
            }
        }
        request(action, postData, url, callBack) {
            let self1 = this;
            let resolve, reject;
            let requestProm = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            if (postData == null) postData = {};
            if (!url) url = this.url;
            if (!url) return new Promise((resolve, reject)=>{
                reject();
            });
            // build parameters list
            if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(this.offset)) this.offset = 0;
            if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(this.last.fetch.offset)) this.last.fetch.offset = 0;
            // add list params
            let edata;
            let params = {
                limit: this.limit,
                offset: parseInt(this.offset) + parseInt(this.last.fetch.offset),
                searchLogic: this.last.logic,
                search: this.searchData.map((search)=>{
                    let _search = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(search);
                    if (this.searchMap && this.searchMap[_search.field]) _search.field = this.searchMap[_search.field];
                    return _search;
                }),
                sort: this.sortData.map((sort)=>{
                    let _sort = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(sort);
                    if (this.sortMap && this.sortMap[_sort.field]) _sort.field = this.sortMap[_sort.field];
                    return _sort;
                })
            };
            if (this.searchData.length === 0) {
                delete params.search;
                delete params.searchLogic;
            }
            if (this.sortData.length === 0) delete params.sort;
            // append other params
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(params, this.postData);
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(params, postData);
            // other actions
            if (action == 'delete' || action == 'save') {
                delete params.limit;
                delete params.offset;
                params.action = action;
                if (action == 'delete') params[this.recid || 'recid'] = this.getSelection();
            }
            // event before
            if (action == 'load') {
                edata = this.trigger('request', {
                    target: this.name,
                    url: url,
                    postData: params,
                    httpMethod: 'GET',
                    httpHeaders: this.httpHeaders
                });
                if (edata.isCancelled === true) return new Promise((resolve, reject)=>{
                    reject();
                });
            } else edata = {
                detail: {
                    url: url,
                    postData: params,
                    httpMethod: action == 'save' ? 'PUT' : 'DELETE',
                    httpHeaders: this.httpHeaders
                }
            };
            // call server to get data
            if (this.last.fetch.offset === 0) this.lock($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.msgRefresh), true);
            if (this.last.fetch.controller) try {
                this.last.fetch.controller.abort();
            } catch (e) {}
            // URL
            url = edata.detail.url;
            switch(action){
                case 'save':
                    if (url?.save) url = url.save;
                    break;
                case 'delete':
                    if (url?.remove) url = url.remove;
                    break;
                default:
                    url = url?.get ?? url;
            }
            // process url with routeData
            if (Object.keys(this.routeData).length > 0) {
                let info = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseRoute(url);
                if (info.keys.length > 0) for(let k = 0; k < info.keys.length; k++){
                    if (this.routeData[info.keys[k].name] == null) continue;
                    url = url.replace(new RegExp(':' + info.keys[k].name, 'g'), this.routeData[info.keys[k].name]);
                }
            }
            url = new URL(url, location);
            // ajax options
            let fetchOptions = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.prepareParams(url, {
                method: edata.detail.httpMethod,
                headers: edata.detail.httpHeaders,
                body: edata.detail.postData
            }, this.dataType);
            Object.assign(this.last.fetch, {
                action: action,
                options: fetchOptions,
                controller: new AbortController(),
                start: Date.now(),
                loaded: false
            });
            fetchOptions.signal = this.last.fetch.controller.signal;
            fetch(url, fetchOptions).catch(processError).then((resp)=>{
                if (resp == null) return; // request aborted
                if (resp?.status != 200) {
                    processError(resp ?? {});
                    return;
                }
                self1.unlock();
                resp.json().catch(processError).then((data)=>{
                    this.requestComplete(data, action, callBack, resolve, reject);
                });
            });
            if (action == 'load') edata.finish();
            return requestProm;
            function processError(response) {
                if (response?.name === 'AbortError') return;
                self1.unlock();
                // trigger event
                let edata2 = self1.trigger('error', {
                    response: response,
                    lastFetch: self1.last.fetch
                });
                if (edata2.isCancelled === true) return;
                // default behavior
                if (response.status && response.status != 200) self1.error(response.status + ': ' + response.statusText);
                else {
                    console.log('ERROR: Server communication failed.', '\n   EXPECTED:', {
                        total: 5,
                        records: [
                            {
                                recid: 1,
                                field: 'value'
                            }
                        ]
                    }, '\n         OR:', {
                        error: true,
                        message: 'error message'
                    });
                    self1.requestComplete({
                        error: true,
                        message: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.msgHTTPError),
                        response: response
                    }, action, callBack, resolve, reject);
                }
                // event after
                edata2.finish();
            }
        }
        requestComplete(data, action, callBack, resolve, reject) {
            let error = data.error ?? false;
            if (data.error == null && data.status === 'error') error = true;
            this.last.fetch.response = (Date.now() - this.last.fetch.start) / 1000;
            setTimeout(()=>{
                if (this.show.statusResponse) this.status($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Server Response ${count} seconds', {
                    count: this.last.fetch.response
                }));
            }, 10);
            this.last.vscroll.pull_more = false;
            this.last.vscroll.pull_refresh = true;
            // event before
            let event_name = 'load';
            if (this.last.fetch.action == 'save') event_name = 'save';
            if (this.last.fetch.action == 'delete') event_name = 'delete';
            let edata = this.trigger(event_name, {
                target: this.name,
                error: error,
                data: data,
                lastFetch: this.last.fetch
            });
            if (edata.isCancelled === true) {
                reject();
                return;
            }
            // parse server response
            if (!error) {
                // default action
                if (typeof this.parser == 'function') {
                    data = this.parser(data);
                    if (typeof data != 'object') console.log('ERROR: Your parser did not return proper object');
                } else {
                    if (data == null) data = {
                        error: true,
                        message: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.msgNotJSON)
                    };
                    else if (Array.isArray(data)) data = {
                        error: error,
                        records: data,
                        total: data.length
                    };
                }
                if (action == 'load') {
                    if (data.total == null) data.total = -1;
                    if (data.records == null) data.records = [];
                    if (data.records.length == this.limit) {
                        let loaded = this.records.length + data.records.length;
                        this.last.fetch.hasMore = loaded == this.total ? false : true;
                    } else {
                        this.last.fetch.hasMore = false;
                        this.total = this.offset + this.last.fetch.offset + data.records.length;
                    }
                    if (!this.last.fetch.hasMore) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_more, #grid_' + this.name + '_frec_more').hide();
                    if (this.last.fetch.offset === 0) {
                        this.records = [];
                        this.summary = [];
                    } else if (data.total != -1 && parseInt(data.total) != parseInt(this.total)) {
                        let grid = this;
                        this.message($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.msgNeedReload)).ok(()=>{
                            delete grid.last.fetch.offset;
                            grid.reload();
                        });
                        return new Promise((resolve)=>{
                            resolve();
                        });
                    }
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(data.total)) this.total = parseInt(data.total);
                    // records
                    if (data.records) data.records.forEach((rec)=>{
                        if (this.recid) rec.recid = this.parseField(rec, this.recid);
                        if (rec.recid == null) rec.recid = 'recid-' + this.records.length;
                        if (rec.w2ui?.summary === true) this.summary.push(rec);
                        else this.records.push(rec);
                    });
                    // summary records (if any)
                    if (data.summary) {
                        this.summary = [] // reset summary with each call
                        ;
                        data.summary.forEach((rec)=>{
                            if (this.recid) rec.recid = this.parseField(rec, this.recid);
                            if (rec.recid == null) rec.recid = 'recid-' + this.summary.length;
                            this.summary.push(rec);
                        });
                    }
                } else if (action == 'delete') {
                    this.reset() // unselect old selections
                    ;
                    return this.reload();
                }
            } else {
                this.error($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(data.message ?? this.msgServerError));
                reject(data);
            }
            // event after
            let url = this.url?.get ?? this.url;
            if (!url) {
                this.localSort();
                this.localSearch();
            }
            this.total = parseInt(this.total);
            // do not refresh if loading on infinite scroll
            if (this.last.fetch.offset === 0) this.refresh();
            else {
                this.scroll();
                this.resize();
            }
            // call back
            if (typeof callBack == 'function') callBack(data) // need to be before event:after
            ;
            resolve(data);
            // after event
            edata.finish();
            this.last.fetch.loaded = true;
        }
        error(msg) {
            // let the management of the error outside of the grid
            let edata = this.trigger('error', {
                target: this.name,
                message: msg
            });
            if (edata.isCancelled === true) return;
            this.message(msg);
            // event after
            edata.finish();
        }
        getChanges(recordsBase) {
            let changes = [];
            if (typeof recordsBase == 'undefined') recordsBase = this.records;
            for(let r = 0; r < recordsBase.length; r++){
                let rec = recordsBase[r];
                if (rec?.w2ui) {
                    if (rec.w2ui.changes != null) {
                        let obj = {};
                        obj[this.recid || 'recid'] = rec.recid;
                        changes.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(obj, rec.w2ui.changes));
                    }
                    // recursively look for changes in non-expanded children
                    if (rec.w2ui.expanded !== true && rec.w2ui.children && rec.w2ui.children.length) changes.push(...this.getChanges(rec.w2ui.children));
                }
            }
            return changes;
        }
        mergeChanges() {
            let changes = this.getChanges();
            for(let c = 0; c < changes.length; c++){
                let record = this.get(changes[c][this.recid || 'recid']);
                for(let s in changes[c]){
                    if (s == 'recid' || this.recid && s == this.recid) continue; // do not allow to change recid
                    if (typeof changes[c][s] === 'object') changes[c][s] = changes[c][s].text;
                    try {
                        _setValue(record, s, changes[c][s]);
                    } catch (e) {
                        console.log('ERROR: Cannot merge. ', e.message || '', e);
                    }
                    if (record.w2ui) delete record.w2ui.changes;
                }
            }
            this.refresh();
            function _setValue(obj, field, value) {
                let fld = field.split('.');
                if (fld.length == 1) obj[field] = value;
                else {
                    obj = obj[fld[0]];
                    fld.shift();
                    _setValue(obj, fld.join('.'), value);
                }
            }
        }
        save(callBack) {
            let changes = this.getChanges();
            let url = this.url?.save ?? this.url;
            // event before
            let edata = this.trigger('save', {
                target: this.name,
                changes: changes
            });
            if (edata.isCancelled === true) return;
            if (url) this.request('save', {
                'changes': edata.detail.changes
            }, null, (data)=>{
                if (!data.error) this.mergeChanges();
                // event after
                edata.finish();
                // call back
                if (typeof callBack == 'function') callBack(data);
            });
            else {
                this.mergeChanges();
                // event after
                edata.finish();
            }
        }
        editField(recid, column, value, event1) {
            let self1 = this;
            if (this.last.inEditMode === true) {
                // This is triggerign when user types fast
                if (event1 && event1.keyCode == 13) {
                    let { index: index, column: column, value: value } = this.last._edit;
                    this.editChange({
                        type: 'custom',
                        value: value
                    }, index, column, event1);
                    this.editDone(index, column, event1);
                } else {
                    // when 2 chars entered fast (spreadsheet)
                    let input = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('div.w2ui-edit-box .w2ui-input');
                    if (input.length > 0) {
                        if (input.get(0).tagName == 'DIV') {
                            input.text(input.text() + value);
                            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.setCursorPosition(input.get(0), input.text().length);
                        } else {
                            input.val(input.val() + value);
                            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.setCursorPosition(input.get(0), input.val().length);
                        }
                    }
                }
                return;
            }
            let index = this.get(recid, true);
            let edit = this.getCellEditable(index, column);
            if (!edit || [
                'checkbox',
                'check'
            ].includes(edit.type)) return;
            let rec = this.records[index];
            let col = this.columns[column];
            let prefix = col.frozen === true ? '_f' : '_';
            if ([
                'enum',
                'file'
            ].indexOf(edit.type) != -1) {
                console.log('ERROR: input types "enum" and "file" are not supported in inline editing.');
                return;
            }
            // event before
            let edata = this.trigger('editField', {
                target: this.name,
                recid: recid,
                column: column,
                value: value,
                index: index,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            value = edata.detail.value;
            // default behaviour
            this.last.inEditMode = true;
            this.last.editColumn = column;
            this.last._edit = {
                value: value,
                index: index,
                column: column,
                recid: recid
            };
            this.selectNone(true) // no need to trigger select event
            ;
            this.select({
                recid: recid,
                column: column
            });
            // create input element
            let tr = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + prefix + 'rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
            let div = tr.find('[col="' + column + '"] > div') // TD -> DIV
            ;
            this.last._edit.tr = tr;
            this.last._edit.div = div;
            // clear previous if any (spreadsheet)
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('div.w2ui-edit-box').remove();
            // for spreadsheet - insert into selection
            if (this.selectType != 'row') {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + prefix + 'selection').attr('id', 'grid_' + this.name + '_editable').removeClass('w2ui-selection').addClass('w2ui-edit-box').prepend('<div style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px;"></div>').find('.w2ui-selection-resizer').remove();
                div = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_editable > div:first-child');
            }
            edit.attr = edit.attr ?? '';
            edit.text = edit.text ?? '';
            edit.style = edit.style ?? '';
            edit.items = edit.items ?? [];
            let val = rec.w2ui?.changes?.[col.field] != null ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripTags(rec.w2ui.changes[col.field]) : $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripTags(self1.parseField(rec, col.field));
            if (val == null) val = '';
            let prevValue = typeof val != 'object' ? val : '';
            if (edata.detail.prevValue != null) prevValue = edata.detail.prevValue;
            if (value != null) val = value;
            let addStyle = col.style != null ? col.style + ';' : '';
            if (typeof col.render == 'string' && [
                'number',
                'int',
                'float',
                'money',
                'percent',
                'size'
            ].includes(col.render.split(':')[0])) addStyle += 'text-align: right;';
            // normalize items, if not yet normlized
            if (edit.items.length > 0 && !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(edit.items[0])) edit.items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu(edit.items);
            let input;
            let dropTypes = [
                'date',
                'time',
                'datetime',
                'color',
                'list',
                'combo'
            ];
            let styles = getComputedStyle(tr.find('[col="' + column + '"] > div').get(0));
            let font = `font-family: ${styles['font-family']}; font-size: ${styles['font-size']};`;
            switch(edit.type){
                case 'div':
                    div.addClass('w2ui-editable').html($aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripSpaces(`<div id="grid_${this.name}_edit_${recid}_${column}" class="w2ui-input w2ui-focus"
                        contenteditable autocorrect="off" autocomplete="off" spellcheck="false"
                        style="${font + addStyle + edit.style}"
                        field="${col.field}" recid="${recid}" column="${column}" ${edit.attr}>
                    </div>${edit.text}`));
                    input = div.find('div.w2ui-input').get(0);
                    input.innerText = typeof val != 'object' ? val : '';
                    if (value != null) $aa2bd8933167d9cb$export$fe3767bc112f7a2a.setCursorPosition(input, input.innerText.length);
                    else $aa2bd8933167d9cb$export$fe3767bc112f7a2a.setCursorPosition(input, 0, input.innerText.length);
                    break;
                default:
                    {
                        div.addClass('w2ui-editable').html($aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripSpaces(`<input id="grid_${this.name}_edit_${recid}_${column}" class="w2ui-input"
                        autocorrect="off" autocomplete="off" spellcheck="false" type="text"
                        style="${font + addStyle + edit.style}"
                        field="${col.field}" recid="${recid}" column="${column}" ${edit.attr}>${edit.text}`));
                        input = div.find('input').get(0);
                        // issue #499
                        if (edit.type == 'number') val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(val);
                        if (edit.type == 'date') val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(val, edit.format, true) || new Date(), edit.format);
                        input.value = typeof val != 'object' ? val : '';
                        // init w2field, attached to input._w2field
                        let doHide = (event1)=>{
                            let escKey = this.last._edit?.escKey;
                            // check if any element is selected in drop down
                            let selected = false;
                            let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(input).data('tooltipName');
                            if (name && $aa2bd8933167d9cb$export$b876f801a4afd38f.get(name[0])?.selected != null) selected = true;
                            // trigger change on new value if selected from overlay
                            if (this.last.inEditMode && !escKey && dropTypes.includes(edit.type) // drop down types
                             && (event1.detail.overlay.anchor?.id == this.last._edit.input?.id || edit.type == 'list')) {
                                this.editChange();
                                this.editDone(undefined, undefined, {
                                    keyCode: selected ? 13 : 0
                                }) // advance on select
                                ;
                            }
                        };
                        new $aa2bd8933167d9cb$export$b011ec2f2c6bab8b($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, edit, {
                            el: input,
                            selected: val,
                            onSelect: doHide,
                            onHide: doHide
                        }));
                        if (value == null && input) input.select();
                    }
            }
            Object.assign(this.last._edit, {
                input: input,
                edit: edit
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(input).off('.w2ui-editable').on('blur.w2ui-editable', (event1)=>{
                if (this.last.inEditMode) {
                    let type = this.last._edit.edit.type;
                    let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(input).data('tooltipName') // if popup is open
                    ;
                    if (name && dropTypes.includes(type) || event1.target._keepOpen === true) {
                        delete event1.target._keepOpen;
                        // drop downs finish edit when popover is closed
                        return;
                    }
                    this.editChange(input, index, column, event1);
                    this.editDone();
                }
            }).on('mousedown.w2ui-editable', (event1)=>{
                event1.stopPropagation();
            }).on('click.w2ui-editable', (event1)=>{
                expand.call(input, event1);
            }).on('paste.w2ui-editable', (event1)=>{
                // clean paste to be plain text
                event1.preventDefault();
                let text = event1.clipboardData.getData('text/plain');
                document.execCommand('insertHTML', false, text);
            }).on('keyup.w2ui-editable', (event1)=>{
                expand.call(input, event1);
            }).on('keydown.w2ui-editable', (event1)=>{
                switch(event1.keyCode){
                    case 8:
                        if (edit.type == 'list' && !input._w2field) event1.preventDefault();
                        break;
                    case 9:
                    case 13:
                        event1.preventDefault();
                        break;
                    case 27:
                        // if tooltip is open - hide it
                        let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(input).data('tooltipName');
                        if (name && name.length > 0) {
                            this.last._edit.escKey = true;
                            $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(name[0]);
                            event1.preventDefault();
                            return; // keep input editable just close tooltip
                        }
                        event1.stopPropagation();
                        break;
                }
                // need timeout so, this handler is executed after key is processed by browser
                setTimeout(()=>{
                    switch(event1.keyCode){
                        case 9:
                            {
                                let next = event1.shiftKey ? self1.prevCell(index, column, true) : self1.nextCell(index, column, true);
                                if (next != null) {
                                    let recid = self1.records[next.index].recid;
                                    this.editChange(input, index, column, event1);
                                    this.editDone(index, column, event1);
                                    if (self1.selectType != 'row') {
                                        self1.selectNone(true) // no need to trigger select event
                                        ;
                                        self1.select({
                                            recid: recid,
                                            column: next.colIndex
                                        });
                                    } else self1.editField(recid, next.colIndex, null, event1);
                                    if (event1.preventDefault) event1.preventDefault();
                                }
                                break;
                            }
                        case 13:
                            {
                                // check if any element is selected in drop down
                                let selected = false;
                                let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(input).data('tooltipName');
                                if (name && $aa2bd8933167d9cb$export$b876f801a4afd38f.get(name[0]).selected != null) selected = true;
                                // if tooltip is not open or no element is selected
                                if ((!name || !selected) && input._keepOpen !== true) {
                                    this.editChange(input, index, column, event1);
                                    this.editDone(index, column, event1);
                                } else delete input._keepOpen;
                                break;
                            }
                        case 27:
                            {
                                this.last._edit.escKey = false;
                                let old = self1.parseField(rec, col.field);
                                if (rec.w2ui?.changes?.[col.field] != null) old = rec.w2ui.changes[col.field];
                                if (input._prevValue != null) old = input._prevValue;
                                if (input.tagName == 'DIV') input.innerText = old != null ? old : '';
                                else input.value = old != null ? old : '';
                                this.editDone(index, column, event1);
                                setTimeout(()=>{
                                    self1.select({
                                        recid: recid,
                                        column: column
                                    });
                                }, 1);
                                break;
                            }
                    }
                    // if input too small - expand
                    expand(input);
                }, 1);
            });
            // save previous value
            if (input) input._prevValue = prevValue;
            // focus and select
            if (edit.type != 'list') setTimeout(()=>{
                if (!this.last.inEditMode) return;
                if (input) {
                    input.focus();
                    clearTimeout(this.last.kbd_timer) // keep focus
                    ;
                    input.resize = expand;
                    expand(input);
                }
            }, 50);
            // event after
            edata.finish({
                input: input
            });
            return;
            function expand(input) {
                try {
                    let styles = getComputedStyle(input);
                    let val = input.tagName.toUpperCase() == 'DIV' ? input.innerText : input.value;
                    let editBox = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('#grid_' + self1.name + '_editable').get(0);
                    let style = `font-family: ${styles['font-family']}; font-size: ${styles['font-size']}; white-space: no-wrap;`;
                    let width = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getStrWidth(val, style);
                    if (width + 20 > editBox.clientWidth) $aa2bd8933167d9cb$export$2fa187e846a241c4(editBox).css('width', width + 20 + 'px');
                } catch (e) {}
            }
        }
        editChange(input, index, column, event1) {
            // if params are not specified
            input = input ?? this.last._edit.input;
            index = index ?? this.last._edit.index;
            column = column ?? this.last._edit.column;
            event1 = event1 ?? {};
            // all other fields
            let summary = index < 0;
            index = index < 0 ? -index - 1 : index;
            let records = summary ? this.summary : this.records;
            let rec = records[index];
            let col = this.columns[column];
            let new_val = input?.tagName == 'DIV' ? input.innerText : input.value;
            let fld = input._w2field;
            if (fld) {
                if (fld.type == 'list') new_val = fld.selected;
                if (Object.keys(new_val).length === 0 || new_val == null) new_val = '';
                if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(new_val)) new_val = fld.clean(new_val);
            }
            if (input.type == 'checkbox') {
                if (rec.w2ui?.editable === false) input.checked = !input.checked;
                new_val = input.checked;
            }
            let old_val = this.parseField(rec, col.field);
            let prev_val = rec.w2ui?.changes && rec.w2ui.changes.hasOwnProperty(col.field) ? rec.w2ui.changes[col.field] : old_val;
            // change/restore event
            let edata = {
                target: this.name,
                input: input,
                recid: rec.recid,
                index: index,
                column: column,
                originalEvent: event1,
                value: {
                    new: new_val,
                    previous: prev_val,
                    original: old_val
                }
            };
            if (event1.target?._prevValue != null) edata.value.previous = event1.target._prevValue;
            let count = 0 // just in case to avoid infinite loop
            ;
            while(count < 20){
                count++;
                new_val = edata.value.new;
                if (typeof new_val != 'object' && String(old_val) != String(new_val) || typeof new_val == 'object' && new_val && new_val.id != old_val && (typeof old_val != 'object' || old_val == null || new_val.id != old_val.id)) {
                    // change event
                    edata = this.trigger('change', edata);
                    if (edata.isCancelled !== true) {
                        if (new_val !== edata.detail.value.new) continue;
                        // default action
                        if ((edata.detail.value.new === '' || edata.detail.value.new == null) && (prev_val === '' || prev_val == null)) ;
                        else {
                            rec.w2ui = rec.w2ui ?? {};
                            rec.w2ui.changes = rec.w2ui.changes ?? {};
                            rec.w2ui.changes[col.field] = edata.detail.value.new;
                        }
                        // event after
                        edata.finish();
                    }
                } else {
                    // restore event
                    edata = this.trigger('restore', edata);
                    if (edata.isCancelled !== true) {
                        if (new_val !== edata.detail.value.new) continue;
                        // default action
                        if (rec.w2ui?.changes) {
                            delete rec.w2ui.changes[col.field];
                            if (Object.keys(rec.w2ui.changes).length === 0) delete rec.w2ui.changes;
                        }
                        // event after
                        edata.finish();
                    }
                }
                break;
            }
        }
        editDone(index, column, event1) {
            // if params are not specified
            index = index ?? this.last._edit.index;
            column = column ?? this.last._edit.column;
            event1 = event1 ?? {};
            // removal of input happens when TR is redrawn
            if (this.advanceOnEdit && event1.keyCode == 13) {
                let next = event1.shiftKey ? this.prevRow(index, column, 1) : this.nextRow(index, column, 1);
                if (next == null) next = index // keep the same
                ;
                setTimeout(()=>{
                    if (this.selectType != 'row') {
                        this.selectNone(true) // no need to trigger select event
                        ;
                        this.select({
                            recid: this.records[next].recid,
                            column: column
                        });
                    } else this.editField(this.records[next].recid, column, null, event1);
                }, 1);
            }
            let summary = index < 0;
            let cell = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.last._edit?.tr).find('[col="' + column + '"]');
            let rec = this.records[index];
            let col = this.columns[column];
            // need to set before remove, as remove will trigger blur
            this.last.inEditMode = false;
            this.last._edit = null;
            // remove - by updating cell data
            if (!summary) {
                if (rec.w2ui?.changes?.[col.field] != null) cell.addClass('w2ui-changed');
                else cell.removeClass('w2ui-changed');
                cell.replace(this.getCellHTML(index, column, summary));
            }
            // remove - spreadsheet
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('div.w2ui-edit-box').remove();
            // update toolbar buttons
            this.updateToolbar();
            // keep grid in focus if needed
            setTimeout(()=>{
                let input = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_focus`).get(0);
                if (document.activeElement !== input && !this.last.inEditMode) input.focus();
            }, 10);
        }
        'delete'(force) {
            // event before
            let edata = this.trigger('delete', {
                target: this.name,
                force: force
            });
            if (force) this.message() // close message
            ;
            if (edata.isCancelled === true) return;
            force = edata.detail.force;
            // default action
            let recs = this.getSelection();
            if (recs.length === 0) return;
            if (this.msgDelete != '' && !force) {
                this.confirm({
                    text: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.msgDelete, {
                        count: recs.length,
                        records: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(recs.length == 1 ? 'record' : 'records')
                    }),
                    width: 380,
                    height: 170,
                    yes_text: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Delete'),
                    yes_class: 'w2ui-btn-red',
                    no_text: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Cancel')
                }).yes((event1)=>{
                    event1.detail.self.close();
                    this.delete(true);
                }).no((event1)=>{
                    event1.detail.self.close();
                });
                return;
            }
            // call delete script
            let url = typeof this.url != 'object' ? this.url : this.url.remove;
            if (url) this.request('delete');
            else if (typeof recs[0] != 'object') {
                this.selectNone();
                this.remove.apply(this, recs);
            } else {
                // clear cells
                for(let r = 0; r < recs.length; r++){
                    let fld = this.columns[recs[r].column].field;
                    let ind = this.get(recs[r].recid, true);
                    let rec = this.records[ind];
                    if (ind != null && fld != 'recid') {
                        this.records[ind][fld] = '';
                        if (rec.w2ui?.changes) delete rec.w2ui.changes[fld];
                    // -- style should not be deleted
                    // if (rec.style != null && w2utils.isPlainObject(rec.style) && rec.style[recs[r].column]) {
                    //     delete rec.style[recs[r].column];
                    // }
                    }
                }
                this.update();
            }
            // event after
            edata.finish();
        }
        click(recid, event1) {
            let time = Date.now();
            let column = null;
            if (this.last.cancelClick == true || event1 && event1.altKey) return;
            if (typeof recid == 'object' && recid !== null) {
                column = recid.column;
                recid = recid.recid;
            }
            if (event1 == null) event1 = {};
            // check for double click
            if (time - parseInt(this.last.click_time) < 350 && this.last.click_recid == recid && event1.type == 'click') {
                this.dblClick(recid, event1);
                return;
            }
            // hide bubble
            if (this.last.bubbleEl) this.last.bubbleEl = null;
            this.last.click_time = time;
            let last_recid = this.last.click_recid;
            this.last.click_recid = recid;
            // column user clicked on
            if (column == null && event1.target) {
                let trg = event1.target;
                if (trg.tagName != 'TD') trg = $aa2bd8933167d9cb$export$2fa187e846a241c4(trg).closest('td')[0];
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(trg).attr('col') != null) column = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(trg).attr('col'));
            }
            // event before
            let edata = this.trigger('click', {
                target: this.name,
                recid: recid,
                column: column,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // default action
            let sel = this.getSelection();
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', false);
            let ind = this.get(recid, true);
            let selectColumns = [];
            this.last.sel_ind = ind;
            this.last.sel_col = column;
            this.last.sel_recid = recid;
            this.last.sel_type = 'click';
            // multi select with shift key
            let start, end, t1, t2;
            if (event1.shiftKey && sel.length > 0 && this.multiSelect) {
                if (sel[0].recid) {
                    start = this.get(sel[0].recid, true);
                    end = this.get(recid, true);
                    if (column > sel[0].column) {
                        t1 = sel[0].column;
                        t2 = column;
                    } else {
                        t1 = column;
                        t2 = sel[0].column;
                    }
                    for(let c = t1; c <= t2; c++)selectColumns.push(c);
                } else {
                    start = this.get(last_recid, true);
                    end = this.get(recid, true);
                }
                let sel_add = [];
                if (start > end) {
                    let tmp = start;
                    start = end;
                    end = tmp;
                }
                let url = this.url?.get ? this.url.get : this.url;
                // MMC: fix shift select when first record selected
                if (!start) start = 0;
                // MMC: end fix
                for(let i = start; i <= end; i++){
                    if (this.searchData.length > 0 && !url && !this.last.searchIds.includes(i)) continue;
                    if (this.selectType == 'row') sel_add.push(this.records[i].recid);
                    else for(let sc = 0; sc < selectColumns.length; sc++)sel_add.push({
                        recid: this.records[i].recid,
                        column: selectColumns[sc]
                    });
                //sel.push(this.records[i].recid);
                }
                this.select(sel_add);
            } else {
                let last = this.last.selection;
                let flag = last.indexes.indexOf(ind) != -1 ? true : false;
                let fselect = false;
                // if clicked on the checkbox
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('td').hasClass('w2ui-col-select')) fselect = true;
                // clear other if necessary
                if ((!event1.ctrlKey && !event1.shiftKey && !event1.metaKey && !fselect || !this.multiSelect) && !this.showSelectColumn) {
                    if (this.selectType != 'row' && !last.columns[ind]?.includes(column)) flag = false;
                    this.selectNone(true) // no need to trigger select event
                    ;
                    if (flag === true && sel.length == 1) this.unselect({
                        recid: recid,
                        column: column
                    });
                    else this.select({
                        recid: recid,
                        column: column
                    });
                } else {
                    if (this.selectType != 'row' && !last.columns[ind]?.includes(column)) flag = false;
                    if (flag === true) this.unselect({
                        recid: recid,
                        column: column
                    });
                    else this.select({
                        recid: recid,
                        column: column
                    });
                }
            }
            this.status();
            this.initResize();
            // event after
            edata.finish();
        }
        columnClick(field, event1) {
            // ignore click if column was resized
            if (this.last.colResizing === true) return;
            // event before
            let edata = this.trigger('columnClick', {
                target: this.name,
                field: field,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // default behaviour
            if (this.selectType == 'row') {
                let column = this.getColumn(field);
                if (column && column.sortable) this.sort(field, null, event1 && (event1.ctrlKey || event1.metaKey || event1.shiftKey) ? true : false);
                if (edata.detail.field == 'line-number') {
                    if (this.getSelection().length >= this.records.length) this.selectNone();
                    else this.selectAll();
                }
            } else {
                if (event1.altKey) {
                    let column = this.getColumn(field);
                    if (column && column.sortable) this.sort(field, null, event1 && (event1.ctrlKey || event1.metaKey || event1.shiftKey) ? true : false);
                }
                // select entire column
                if (edata.detail.field == 'line-number') {
                    if (this.getSelection().length >= this.records.length) this.selectNone();
                    else this.selectAll();
                } else {
                    if (!event1.shiftKey && !event1.metaKey && !event1.ctrlKey) this.selectNone(true);
                    let tmp = this.getSelection();
                    let column = this.getColumn(edata.detail.field, true);
                    let sel = [];
                    let cols = [];
                    // check if there was a selection before
                    if (tmp.length != 0 && event1.shiftKey) {
                        let start = column;
                        let end = tmp[0].column;
                        if (start > end) {
                            start = tmp[0].column;
                            end = column;
                        }
                        for(let i = start; i <= end; i++)cols.push(i);
                    } else cols.push(column);
                    edata = this.trigger('columnSelect', {
                        target: this.name,
                        columns: cols
                    });
                    if (edata.isCancelled !== true) {
                        for(let i = 0; i < this.records.length; i++)sel.push({
                            recid: this.records[i].recid,
                            column: cols
                        });
                        this.select(sel);
                    }
                    edata.finish();
                }
            }
            // event after
            edata.finish();
        }
        columnDblClick(field, event1) {
            // event before
            let edata = this.trigger('columnDblClick', {
                target: this.name,
                field: field,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // event after
            edata.finish();
        }
        columnContextMenu(field, event1) {
            let edata = this.trigger('columnContextMenu', {
                target: this.name,
                field: field,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            if (this.show.columnMenu) {
                $aa2bd8933167d9cb$export$3842f79f22e98342.show({
                    type: 'check',
                    anchor: document.body,
                    originalEvent: event1,
                    items: this.initColumnOnOff()
                }).then(()=>{
                    $aa2bd8933167d9cb$export$2fa187e846a241c4('#w2overlay-context-menu .w2ui-grid-skip').off('.w2ui-grid').on('click.w2ui-grid', (evt)=>{
                        evt.stopPropagation();
                    }).on('keypress', (evt)=>{
                        if (evt.keyCode == 13) {
                            this.skip(evt.target.value);
                            this.toolbar.click('w2ui-column-on-off') // close menu
                            ;
                        }
                    });
                }).select((event1)=>{
                    let id = event1.detail.item.id;
                    if ([
                        'w2ui-stateSave',
                        'w2ui-stateReset'
                    ].includes(id)) this[id.substring(5)]();
                    else if (id == 'w2ui-skip') ;
                    else this.columnOnOff(event1, event1.detail.item.id);
                    clearTimeout(this.last.kbd_timer) // keep grid in focus
                    ;
                });
                clearTimeout(this.last.kbd_timer) // keep grid in focus
                ;
            }
            event1.preventDefault();
            edata.finish();
        }
        // if called w/o arguments, then will resize all columns
        columnAutoSize(colIndex) {
            if (arguments.length == 0) {
                // autoSize all columns
                this.columns.forEach((col, i)=>this.columnAutoSize(i));
                return;
            }
            let col = this.columns[colIndex];
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(`#grid_${this.name}_column_${colIndex} .w2ui-col-header`)[0];
            if (col.autoResize === false || col.hidden === true || !el) return true;
            let style = getComputedStyle(el);
            let maxWidth = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getStrWidth(el.innerHTML, `font-family: ${style.fontFamily}; font-size: ${style.fontSize}`, true) + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + 4;
            // MMC: fix performance, limit the number of elements to check
            let counter = 0;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`.w2ui-grid-records td[col="${colIndex}"] > div`, this.box).each((el)=>{
                if (counter >= 10) return; // Detiene la iteración después de 10 elementos
                let style = getComputedStyle(el);
                let width = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getStrWidth(el.innerHTML, `font-family: ${style.fontFamily}; font-size: ${style.fontSize}`, true) + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + 4; // add some extra because of the border
                if (maxWidth < width) maxWidth = width;
                counter++; // Incrementa el contador con cada iteración
            });
            // MMC: end fix
            // event before
            let edata = this.trigger('columnAutoResize', {
                maxWidth: maxWidth,
                originalEvent: event,
                target: this.name,
                column: col
            });
            if (edata.isCancelled === true) return;
            if (maxWidth > 0) {
                if (col.sizeOriginal == null) col.sizeOriginal = col.size;
                col.size = Math.min(Math.abs(maxWidth), col.max || Infinity) + 'px';
                this.resizeRecords();
                this.resizeRecords() // Why do we have to call it twice in order to show the scrollbar?
                ;
                this.scroll();
            }
            // event after
            edata.finish();
        }
        columnAutoSizeAll() {
            this.columns.forEach((col, ind)=>this.columnAutoSize(ind));
        }
        focus(event1) {
            // event before
            let edata = this.trigger('focus', {
                target: this.name,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return false;
            // default behaviour
            this.hasFocus = true;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).removeClass('w2ui-inactive').find('.w2ui-inactive').removeClass('w2ui-inactive');
            setTimeout(()=>{
                let txt = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_focus`).get(0);
                if (txt && document.activeElement != txt) txt.focus();
            }, 10);
            // event after
            edata.finish();
        }
        blur(event1) {
            // event before
            let edata = this.trigger('blur', {
                target: this.name,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return false;
            // default behaviour
            this.hasFocus = false;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).addClass('w2ui-inactive').find('.w2ui-selected').addClass('w2ui-inactive');
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-selection').addClass('w2ui-inactive');
            // event after
            edata.finish();
        }
        keydown(event1) {
            // this method is called from w2utils
            let obj = this;
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            if (obj.keyboard !== true) return;
            // trigger event
            let edata = obj.trigger('keydown', {
                target: obj.name,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // default behavior
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-message').length > 0) {
                // if there are messages
                if (event1.keyCode == 27) this.message();
                return;
            }
            let empty = false;
            let records = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_records');
            let sel = obj.getSelection();
            if (sel.length === 0) empty = true;
            let recid = sel[0] || null;
            let columns = [];
            let recid2 = sel[sel.length - 1];
            if (typeof recid == 'object' && recid != null) {
                recid = sel[0].recid;
                columns = [];
                let ii = 0;
                while(true){
                    if (!sel[ii] || sel[ii].recid != recid) break;
                    columns.push(sel[ii].column);
                    ii++;
                }
                recid2 = sel[sel.length - 1].recid;
            }
            let ind = obj.get(recid, true);
            let ind2 = obj.get(recid2, true);
            let recEL = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find(`#grid_${obj.name}_rec_${ind != null ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(obj.records[ind].recid) : 'none'}`);
            let pageSize = Math.floor(records[0].clientHeight / obj.recordHeight);
            let cancel = false;
            let key = event1.keyCode;
            let shiftKey = event1.shiftKey;
            switch(key){
                case 8:
                case 46:
                    // delete if button is visible
                    obj.delete();
                    cancel = true;
                    event1.stopPropagation();
                    break;
                case 27:
                    obj.selectNone();
                    cancel = true;
                    break;
                case 65:
                    if (!event1.metaKey && !event1.ctrlKey) break;
                    obj.selectAll();
                    cancel = true;
                    break;
                case 13:
                    // if expandable columns - expand it
                    if (this.selectType == 'row' && obj.show.expandColumn === true) {
                        if (recEL.length <= 0) break;
                        obj.toggle(recid, event1);
                        cancel = true;
                    } else {
                        for(let c = 0; c < this.columns.length; c++){
                            let edit = this.getCellEditable(ind, c);
                            if (edit) {
                                columns.push(parseInt(c));
                                break;
                            }
                        }
                        // edit last column that was edited
                        if (this.selectType == 'row' && this.last._edit && this.last._edit.column) columns = [
                            this.last._edit.column
                        ];
                        if (columns.length > 0) {
                            obj.editField(recid, columns[0] ?? this.last.editColumn, null, event1);
                            cancel = true;
                        }
                    }
                    break;
                case 37:
                    moveLeft();
                    break;
                case 39:
                    moveRight();
                    break;
                case 33:
                    moveUp(pageSize);
                    break;
                case 34:
                    moveDown(pageSize);
                    break;
                case 35:
                    moveDown(-1);
                    break;
                case 36:
                    moveUp(-1);
                    break;
                case 38:
                    // ctrl (or cmd) + up -> same as home
                    moveUp(event1.metaKey || event1.ctrlKey ? -1 : 1);
                    break;
                case 40:
                    // ctrl (or cmd) + up -> same as end
                    moveDown(event1.metaKey || event1.ctrlKey ? -1 : 1);
                    break;
                // copy & paste
                case 17:
                case 91:
                    // SLOW: 10k records take 7.0
                    if (empty) break;
                    // in Safari need to copy to buffer on cmd or ctrl key (otherwise does not work)
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isSafari) {
                        obj.last.copy_event = obj.copy(false, event1);
                        let focus = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_focus');
                        focus.val(obj.last.copy_event.detail.text);
                        focus[0].select();
                    }
                    break;
                case 67:
                    // this fill trigger event.onComplete
                    if (event1.metaKey || event1.ctrlKey) {
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isSafari) obj.copy(obj.last.copy_event, event1);
                        else {
                            obj.last.copy_event = obj.copy(false, event1);
                            let focus = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_focus');
                            focus.val(obj.last.copy_event.detail.text);
                            focus[0].select();
                            obj.copy(obj.last.copy_event, event1);
                        }
                    }
                    break;
                case 88:
                    if (empty) break;
                    if (event1.ctrlKey || event1.metaKey) {
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isSafari) obj.copy(obj.last.copy_event, event1);
                        else {
                            obj.last.copy_event = obj.copy(false, event1);
                            let focus = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_focus');
                            focus.val(obj.last.copy_event.detail.text);
                            focus[0].select();
                            obj.copy(obj.last.copy_event, event1);
                        }
                    }
                    break;
            }
            let tmp = [
                32,
                187,
                189,
                192,
                219,
                220,
                221,
                186,
                222,
                188,
                190,
                191
            ] // other typeable chars
            ;
            for(let i = 48; i <= 111; i++)tmp.push(i) // 0-9,a-z,A-Z,numpad
            ;
            if (tmp.indexOf(key) != -1 && !event1.ctrlKey && !event1.metaKey && !cancel) {
                if (columns.length === 0) columns.push(0);
                cancel = false;
                // move typed key into edit
                setTimeout(()=>{
                    let focus = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_focus');
                    let key = focus.val();
                    focus.val('');
                    obj.editField(recid, columns[0], key, event1);
                }, 1);
            }
            if (cancel) {
                if (event1.preventDefault) event1.preventDefault();
            }
            // event after
            edata.finish();
            function moveLeft() {
                if (empty) {
                    selectTopRecord();
                    return;
                }
                if (obj.selectType == 'row') {
                    if (recEL.length <= 0) return;
                    let tmp = obj.records[ind].w2ui || {};
                    if (tmp && tmp.parent_recid != null && (!Array.isArray(tmp.children) || tmp.children.length === 0 || !tmp.expanded)) {
                        obj.unselect(recid);
                        obj.collapse(tmp.parent_recid, event1);
                        obj.select(tmp.parent_recid);
                    } else obj.collapse(recid, event1);
                } else {
                    let prev = obj.prevCell(ind, columns[0]);
                    if (prev?.index != ind) prev = null;
                    else prev = prev?.colIndex;
                    if (!shiftKey && prev == null) {
                        obj.selectNone(true);
                        prev = 0;
                    }
                    if (prev != null) {
                        if (shiftKey && obj.multiSelect) {
                            if (tmpUnselect()) return;
                            let tmp = [];
                            let newSel = [];
                            let unSel = [];
                            if (columns.indexOf(obj.last.sel_col) === 0 && columns.length > 1) {
                                for(let i = 0; i < sel.length; i++){
                                    if (tmp.indexOf(sel[i].recid) == -1) tmp.push(sel[i].recid);
                                    unSel.push({
                                        recid: sel[i].recid,
                                        column: columns[columns.length - 1]
                                    });
                                }
                                obj.unselect(unSel);
                                obj.scrollIntoView(ind, columns[columns.length - 1], true);
                            } else {
                                for(let i = 0; i < sel.length; i++){
                                    if (tmp.indexOf(sel[i].recid) == -1) tmp.push(sel[i].recid);
                                    newSel.push({
                                        recid: sel[i].recid,
                                        column: prev
                                    });
                                }
                                obj.select(newSel);
                                obj.scrollIntoView(ind, prev, true);
                            }
                        } else {
                            obj.click({
                                recid: recid,
                                column: prev
                            }, event1);
                            obj.scrollIntoView(ind, prev, true);
                        }
                    } else if (!shiftKey) obj.selectNone(true);
                }
                cancel = true;
            }
            function moveRight() {
                if (empty) {
                    selectTopRecord();
                    return;
                }
                if (obj.selectType == 'row') {
                    if (recEL.length <= 0) return;
                    obj.expand(recid, event1);
                } else {
                    let next = obj.nextCell(ind, columns[columns.length - 1]) // columns is an array of selected columns
                    ;
                    if (next.index != ind) next = null;
                    else next = next.colIndex;
                    if (!shiftKey && next == null) {
                        obj.selectNone(true);
                        next = obj.columns.length - 1;
                    }
                    if (next != null) {
                        if (shiftKey && key == 39 && obj.multiSelect) {
                            if (tmpUnselect()) return;
                            let tmp = [];
                            let newSel = [];
                            let unSel = [];
                            if (columns.indexOf(obj.last.sel_col) == columns.length - 1 && columns.length > 1) {
                                for(let i = 0; i < sel.length; i++){
                                    if (tmp.indexOf(sel[i].recid) == -1) tmp.push(sel[i].recid);
                                    unSel.push({
                                        recid: sel[i].recid,
                                        column: columns[0]
                                    });
                                }
                                obj.unselect(unSel);
                                obj.scrollIntoView(ind, columns[0], true);
                            } else {
                                for(let i = 0; i < sel.length; i++){
                                    if (tmp.indexOf(sel[i].recid) == -1) tmp.push(sel[i].recid);
                                    newSel.push({
                                        recid: sel[i].recid,
                                        column: next
                                    });
                                }
                                obj.select(newSel);
                                obj.scrollIntoView(ind, next, true);
                            }
                        } else {
                            obj.click({
                                recid: recid,
                                column: next
                            }, event1);
                            obj.scrollIntoView(ind, next, true);
                        }
                    } else if (!shiftKey) obj.selectNone(true);
                }
                cancel = true;
            }
            function moveUp(numRows) {
                if (empty) selectTopRecord();
                if (recEL.length <= 0) return;
                // move to the previous record
                let prev = obj.prevRow(ind, obj.selectType == 'row' ? 0 : sel[0].column, numRows);
                if (!shiftKey && prev == null) {
                    if (obj.searchData.length != 0 && !url) prev = obj.last.searchIds[0];
                    else prev = 0;
                }
                if (prev != null) {
                    if (shiftKey && obj.multiSelect) {
                        if (tmpUnselect()) return;
                        if (obj.selectType == 'row') {
                            if (obj.last.sel_ind > prev && obj.last.sel_ind != ind2) obj.unselect(obj.records[ind2].recid);
                            else obj.select(obj.records[prev].recid);
                        } else if (obj.last.sel_ind > prev && obj.last.sel_ind != ind2) {
                            prev = ind2;
                            let tmp = [];
                            for(let c = 0; c < columns.length; c++)tmp.push({
                                recid: obj.records[prev].recid,
                                column: columns[c]
                            });
                            obj.unselect(tmp);
                        } else {
                            let tmp = [];
                            for(let c = 0; c < columns.length; c++)tmp.push({
                                recid: obj.records[prev].recid,
                                column: columns[c]
                            });
                            obj.select(tmp);
                        }
                    } else {
                        obj.selectNone(true) // no need to trigger select event
                        ;
                        obj.click({
                            recid: obj.records[prev].recid,
                            column: columns[0]
                        }, event1);
                    }
                    obj.scrollIntoView(prev, null, true, numRows != 1) // top align record
                    ;
                    if (event1.preventDefault) event1.preventDefault();
                } else if (!shiftKey) obj.selectNone(true);
            }
            function moveDown(numRows) {
                if (empty) selectTopRecord();
                if (recEL.length <= 0) return;
                // move to the next record
                let next = obj.nextRow(ind2, obj.selectType == 'row' ? 0 : sel[0].column, numRows);
                if (!shiftKey && next == null) {
                    if (obj.searchData.length != 0 && !url) next = obj.last.searchIds[obj.last.searchIds.length - 1];
                    else next = obj.records.length - 1;
                }
                if (next != null) {
                    if (shiftKey && obj.multiSelect) {
                        if (tmpUnselect()) return;
                        if (obj.selectType == 'row') {
                            if (obj.last.sel_ind < next && obj.last.sel_ind != ind) obj.unselect(obj.records[ind].recid);
                            else obj.select(obj.records[next].recid);
                        } else if (obj.last.sel_ind < next && obj.last.sel_ind != ind) {
                            next = ind;
                            let tmp = [];
                            for(let c = 0; c < columns.length; c++)tmp.push({
                                recid: obj.records[next].recid,
                                column: columns[c]
                            });
                            obj.unselect(tmp);
                        } else {
                            let tmp = [];
                            for(let c = 0; c < columns.length; c++)tmp.push({
                                recid: obj.records[next].recid,
                                column: columns[c]
                            });
                            obj.select(tmp);
                        }
                    } else {
                        obj.selectNone(true) // no need to trigger select event
                        ;
                        obj.click({
                            recid: obj.records[next].recid,
                            column: columns[0]
                        }, event1);
                    }
                    obj.scrollIntoView(next, null, true, numRows != 1) // top align record
                    ;
                    cancel = true;
                } else if (!shiftKey) obj.selectNone(true) // no need to trigger select event
                ;
            }
            function selectTopRecord() {
                if (!obj.records || obj.records.length === 0) return;
                let ind = Math.floor(records[0].scrollTop / obj.recordHeight) + 1;
                if (!obj.records[ind] || ind < 2) ind = 0;
                if (typeof obj.records[ind] === 'undefined') return;
                obj.select({
                    recid: obj.records[ind].recid,
                    column: 0
                });
            }
            function tmpUnselect() {
                if (obj.last.sel_type != 'click') return false;
                if (obj.selectType != 'row') {
                    obj.last.sel_type = 'key';
                    if (sel.length > 1) {
                        for(let s = 0; s < sel.length; s++)if (sel[s].recid == obj.last.sel_recid && sel[s].column == obj.last.sel_col) {
                            sel.splice(s, 1);
                            break;
                        }
                        obj.unselect(sel);
                        return true;
                    }
                    return false;
                } else {
                    obj.last.sel_type = 'key';
                    if (sel.length > 1) {
                        sel.splice(sel.indexOf(obj.records[obj.last.sel_ind].recid), 1);
                        obj.unselect(sel);
                        return true;
                    }
                    return false;
                }
            }
        }
        scrollIntoView(ind, column, instant, recTop) {
            let buffered = this.records.length;
            if (this.searchData.length != 0 && !this.url) buffered = this.last.searchIds.length;
            if (buffered === 0) return;
            if (ind == null) {
                let sel = this.getSelection();
                if (sel.length === 0) return;
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(sel[0])) {
                    ind = sel[0].index;
                    column = sel[0].column;
                } else ind = this.get(sel[0], true);
            }
            let records = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_records`);
            let recWidth = records[0].clientWidth;
            let recHeight = records[0].clientHeight;
            let recSTop = records[0].scrollTop;
            let recSLeft = records[0].scrollLeft;
            // if all records in view
            let len = this.last.searchIds.length;
            if (len > 0) ind = this.last.searchIds.indexOf(ind) // if search is applied
            ;
            // smooth or instant
            records.css({
                'scroll-behavior': instant ? 'auto' : 'smooth'
            });
            // vertical
            if (recHeight < this.recordHeight * (len > 0 ? len : buffered) && records.length > 0) {
                // scroll to correct one
                let t1 = Math.floor(recSTop / this.recordHeight);
                let t2 = t1 + Math.floor(recHeight / this.recordHeight);
                if (ind == t1) records.prop('scrollTop', recSTop - recHeight / 1.3);
                if (ind == t2) records.prop('scrollTop', recSTop + recHeight / 1.3);
                if (ind < t1 || ind > t2) records.prop('scrollTop', (ind - 1) * this.recordHeight);
                if (recTop === true) records.prop('scrollTop', ind * this.recordHeight);
            }
            // horizontal
            if (column != null) {
                let x1 = 0;
                let x2 = 0;
                let sb = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize();
                for(let i = 0; i <= column; i++){
                    let col = this.columns[i];
                    if (col.frozen || col.hidden) continue;
                    x1 = x2;
                    x2 += parseInt(col.sizeCalculated);
                }
                if (recWidth < x2 - recSLeft) records.prop('scrollLeft', x1 - sb);
                else if (x1 < recSLeft) records.prop('scrollLeft', x2 - recWidth + sb * 2);
            }
        }
        scrollToColumn(field) {
            if (field == null) return;
            let sWidth = 0;
            let found = false;
            for(let i = 0; i < this.columns.length; i++){
                let col = this.columns[i];
                if (col.field == field) {
                    found = true;
                    break;
                }
                if (col.frozen || col.hidden) continue;
                let cSize = parseInt(col.sizeCalculated ? col.sizeCalculated : col.size);
                sWidth += cSize;
            }
            if (!found) return;
            this.last.vscroll.scrollLeft = sWidth + 1;
            this.scroll();
        }
        dblClick(recid, event1) {
            // find columns
            let column = null;
            if (typeof recid == 'object' && recid !== null) {
                column = recid.column;
                recid = recid.recid;
            }
            if (event1 == null) event1 = {};
            // column user clicked on
            if (column == null && event1.target) {
                let tmp = event1.target;
                if (tmp.tagName.toUpperCase() != 'TD') tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).closest('td')[0];
                column = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).attr('col'));
            }
            let index = this.get(recid, true);
            let rec = this.records[index];
            // event before
            let edata = this.trigger('dblClick', {
                target: this.name,
                recid: recid,
                column: column,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // default action
            this.selectNone(true) // no need to trigger select event
            ;
            let edit = this.getCellEditable(index, column);
            if (edit) this.editField(recid, column, null, event1);
            else {
                this.select({
                    recid: recid,
                    column: column
                });
                if (this.show.expandColumn || rec && rec.w2ui && Array.isArray(rec.w2ui.children)) this.toggle(recid);
            }
            // event after
            edata.finish();
        }
        showContextMenu(recid, column, event1) {
            if (this.last.userSelect == 'text') return;
            if (event1 == null) event1 = {
                offsetX: 0,
                offsetY: 0,
                target: $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_rec_${recid}`)[0]
            };
            if (event1.offsetX == null) {
                event1.offsetX = event1.layerX - event1.target.offsetLeft;
                event1.offsetY = event1.layerY - event1.target.offsetTop;
            }
            // if (w2utils.isFloat(recid)) recid = parseFloat(recid)
            let sel = this.getSelection();
            if (this.selectType == 'row') {
                if (sel.indexOf(recid) == -1) this.click(recid);
            } else {
                let selected = false;
                // check if any selected sel in the right row/column
                for(let i = 0; i < sel.length; i++)if (sel[i].recid == recid || sel[i].column == column) selected = true;
                if (!selected && recid != null) this.click({
                    recid: recid,
                    column: column
                });
                if (!selected && column != null) this.columnClick(this.columns[column].field, event1);
            }
            // event before
            let edata = this.trigger('contextMenu', {
                target: this.name,
                originalEvent: event1,
                recid: recid,
                column: column
            });
            if (edata.isCancelled === true) return;
            // default action
            if (this.contextMenu?.length > 0) $aa2bd8933167d9cb$export$3842f79f22e98342.show({
                anchor: document.body,
                originalEvent: event1,
                items: this.contextMenu
            }).select((event1)=>{
                clearTimeout(this.last.kbd_timer) // keep grid in focus
                ;
                this.contextMenuClick(recid, column, event1);
            });
            // cancel browser context menu
            event1.preventDefault();
            clearTimeout(this.last.kbd_timer) // keep grid in focus
            ;
            // event after
            edata.finish();
        }
        contextMenuClick(recid, column, event1) {
            // event before
            let edata = this.trigger('contextMenuClick', {
                target: this.name,
                recid: recid,
                column: column,
                originalEvent: event1.detail.originalEvent,
                menuEvent: event1,
                menuIndex: event1.detail.index,
                menuItem: event1.detail.item
            });
            if (edata.isCancelled === true) return;
            // no default action
            edata.finish();
        }
        toggle(recid) {
            let rec = this.get(recid);
            if (rec == null) return;
            rec.w2ui = rec.w2ui ?? {};
            if (rec.w2ui.expanded === true) return this.collapse(recid);
            else return this.expand(recid);
        }
        expand(recid, noRefresh) {
            let ind = this.get(recid, true);
            let rec = this.records[ind];
            rec.w2ui = rec.w2ui ?? {};
            let id = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid);
            let children = rec.w2ui.children;
            let edata;
            if (Array.isArray(children)) {
                if (rec.w2ui.expanded === true || children.length === 0) return false // already shown
                ;
                edata = this.trigger('expand', {
                    target: this.name,
                    recid: recid
                });
                if (edata.isCancelled === true) return false;
                rec.w2ui.expanded = true;
                children.forEach((child)=>{
                    child.w2ui = child.w2ui ?? {};
                    child.w2ui.parent_recid = rec.recid;
                    if (child.w2ui.children == null) child.w2ui.children = [];
                });
                this.records.splice.apply(this.records, [
                    ind + 1,
                    0
                ].concat(children));
                if (this.total !== -1) this.total += children.length;
                let url = typeof this.url != 'object' ? this.url : this.url.get;
                if (!url) {
                    this.localSort(true, true);
                    if (this.searchData.length > 0) this.localSearch(true);
                }
                if (noRefresh !== true) this.refresh();
                edata.finish();
            } else {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + id + '_expanded_row').length > 0 || this.show.expandColumn !== true) return false;
                if (rec.w2ui.expanded == 'none') return false;
                // insert expand row
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + id).after(`<tr id="grid_${this.name}_rec_${recid}_expanded_row" class="w2ui-expanded-row">
                    <td colspan="100" class="w2ui-expanded2">
                        <div id="grid_${this.name}_rec_${recid}_expanded"></div>
                    </td>
                    <td class="w2ui-grid-data-last"></td>
                </tr>`);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + id).after(`<tr id="grid_${this.name}_frec_${recid}_expanded_row" class="w2ui-expanded-row">
                    ${this.show.lineNumbers ? '<td class="w2ui-col-number"></td>' : ''}
                    <td class="w2ui-grid-data w2ui-expanded1" colspan="100">
                       <div id="grid_${this.name}_frec_${recid}_expanded"></div>
                    </td>
                </tr>`);
                // event before
                edata = this.trigger('expand', {
                    target: this.name,
                    recid: recid,
                    box_id: 'grid_' + this.name + '_rec_' + recid + '_expanded',
                    fbox_id: 'grid_' + this.name + '_frec_' + recid + '_expanded'
                });
                if (edata.isCancelled === true) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + id + '_expanded_row').remove();
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + id + '_expanded_row').remove();
                    return false;
                }
                // expand column
                let row1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + recid + '_expanded');
                let row2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + recid + '_expanded');
                let innerHeight1 = row1.find(':scope div:first-child')[0]?.clientHeight ?? 50;
                if (row1[0].clientHeight < innerHeight1) row1.css({
                    height: innerHeight1 + 'px'
                });
                if (row2[0].clientHeight < innerHeight1) row2.css({
                    height: innerHeight1 + 'px'
                });
                // default action
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + id).attr('expanded', 'yes').addClass('w2ui-expanded');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + id).attr('expanded', 'yes').addClass('w2ui-expanded');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_cell_' + this.get(recid, true) + '_expand div').html('-');
                rec.w2ui.expanded = true;
                // event after
                edata.finish();
                this.resizeRecords();
            }
            return true;
        }
        collapse(recid, noRefresh) {
            let ind = this.get(recid, true);
            let rec = this.records[ind];
            rec.w2ui = rec.w2ui || {};
            let id = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid);
            let children = rec.w2ui.children;
            let edata;
            if (Array.isArray(children)) {
                if (rec.w2ui.expanded !== true) return false // already hidden
                ;
                edata = this.trigger('collapse', {
                    target: this.name,
                    recid: recid
                });
                if (edata.isCancelled === true) return false;
                clearExpanded(rec);
                let stops = [];
                for(let r = rec; r != null; r = this.get(r.w2ui.parent_recid))stops.push(r.w2ui.parent_recid);
                // stops contains 'undefined' plus the ID of all nodes in the path from 'rec' to the tree root
                let start = ind + 1;
                let end = start;
                while(true){
                    if (this.records.length <= end + 1 || this.records[end + 1].w2ui == null || stops.indexOf(this.records[end + 1].w2ui.parent_recid) >= 0) break;
                    end++;
                }
                this.records.splice(start, end - start + 1);
                if (this.total !== -1) this.total -= end - start + 1;
                let url = typeof this.url != 'object' ? this.url : this.url.get;
                if (!url) {
                    if (this.searchData.length > 0) this.localSearch(true);
                }
                if (noRefresh !== true) this.refresh();
                edata.finish();
            } else {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + id + '_expanded_row').length === 0 || this.show.expandColumn !== true) return false;
                // event before
                edata = this.trigger('collapse', {
                    target: this.name,
                    recid: recid,
                    box_id: 'grid_' + this.name + '_rec_' + recid + '_expanded',
                    fbox_id: 'grid_' + this.name + '_frec_' + recid + '_expanded'
                });
                if (edata.isCancelled === true) return false;
                // default action
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + id).removeAttr('expanded').removeClass('w2ui-expanded');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + id).removeAttr('expanded').removeClass('w2ui-expanded');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_cell_' + this.get(recid, true) + '_expand div').html('+');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + id + '_expanded').css('height', '0px');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + id + '_expanded').css('height', '0px');
                setTimeout(()=>{
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + id + '_expanded_row').remove();
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + id + '_expanded_row').remove();
                    rec.w2ui.expanded = false;
                    // event after
                    edata.finish();
                    this.resizeRecords();
                }, 300);
            }
            return true;
            function clearExpanded(rec) {
                rec.w2ui.expanded = false;
                for(let i = 0; i < rec.w2ui.children.length; i++){
                    let subRec = rec.w2ui.children[i];
                    if (subRec.w2ui.expanded) clearExpanded(subRec);
                }
            }
        }
        sort(field, direction, multiField) {
            // event before
            let edata = this.trigger('sort', {
                target: this.name,
                field: field,
                direction: direction,
                multiField: multiField
            });
            if (edata.isCancelled === true) return;
            // check if needed to quit
            if (field != null) {
                // default action
                let sortIndex = this.sortData.length;
                for(let s = 0; s < this.sortData.length; s++)if (this.sortData[s].field == field) {
                    sortIndex = s;
                    break;
                }
                if (direction == null) {
                    direction = this.sortData[sortIndex]?.direction;
                    if (direction == null) {
                        // save original sort, so it can be restored
                        if (this.last.originalSort == null) this.last.originalSort = this.records.map((rec)=>rec.recid);
                        direction = 'asc';
                    } else switch(direction.toLowerCase()){
                        case 'asc':
                            direction = 'desc';
                            break;
                        case 'desc':
                            direction = '';
                            break;
                        default:
                            direction = 'asc';
                            break;
                    }
                }
                if (multiField != true) {
                    this.sortData = [];
                    sortIndex = 0;
                }
                if (direction === '') this.sortData.splice(sortIndex, 1);
                else {
                    // set new sort
                    this.sortData[sortIndex] ??= {};
                    Object.assign(this.sortData[sortIndex], {
                        field: field,
                        direction: direction
                    });
                }
            } else this.sortData = [];
            // if local
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            if (!url) {
                this.localSort(false, true);
                if (this.searchData.length > 0) this.localSearch(true);
                // reset vertical scroll
                this.last.vscroll.scrollTop = 0;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_records`).prop('scrollTop', 0);
                // event after
                edata.finish({
                    direction: direction
                });
                this.refresh();
            } else {
                // event after
                edata.finish({
                    direction: direction
                });
                this.last.fetch.offset = 0;
                this.reload();
            }
        }
        copy(flag, oEvent) {
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(flag)) {
                // event after
                flag.finish();
                return flag.text;
            }
            // generate text to copy
            let sel = this.getSelection();
            if (sel.length === 0) return '';
            let text = '';
            if (typeof sel[0] == 'object') {
                // find min/max column
                let minCol = sel[0].column;
                let maxCol = sel[0].column;
                let recs = [];
                for(let s = 0; s < sel.length; s++){
                    if (sel[s].column < minCol) minCol = sel[s].column;
                    if (sel[s].column > maxCol) maxCol = sel[s].column;
                    if (recs.indexOf(sel[s].index) == -1) recs.push(sel[s].index);
                }
                recs.sort((a, b)=>{
                    return a - b;
                }) // sort function must be for numerical sort
                ;
                for(let r = 0; r < recs.length; r++){
                    let ind = recs[r];
                    for(let c = minCol; c <= maxCol; c++){
                        let col = this.columns[c];
                        if (col.hidden === true) continue;
                        text += this.getCellCopy(ind, c) + '\t';
                    }
                    text = text.substr(0, text.length - 1) // remove last \t
                    ;
                    text += '\n';
                }
            } else {
                // copy headers
                for(let c = 0; c < this.columns.length; c++){
                    let col = this.columns[c];
                    if (col.hidden === true) continue;
                    let colName = col.text ? col.text : col.field;
                    if (col.text && col.text.length < 3 && col.tooltip) colName = col.tooltip // if column name is less then 3 char and there is tooltip - use it
                    ;
                    text += '"' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripTags(colName) + '"\t';
                }
                text = text.substr(0, text.length - 1) // remove last \t
                ;
                text += '\n';
                // copy selected text
                for(let s = 0; s < sel.length; s++){
                    let ind = this.get(sel[s], true);
                    for(let c = 0; c < this.columns.length; c++){
                        let col = this.columns[c];
                        if (col.hidden === true) continue;
                        text += '"' + this.getCellCopy(ind, c) + '"\t';
                    }
                    text = text.substr(0, text.length - 1) // remove last \t
                    ;
                    text += '\n';
                }
            }
            text = text.substr(0, text.length - 1);
            // if called without params
            let edata;
            if (flag == null) {
                // before event
                edata = this.trigger('copy', {
                    target: this.name,
                    text: text,
                    cut: oEvent.keyCode == 88 ? true : false,
                    originalEvent: oEvent
                });
                if (edata.isCancelled === true) return '';
                text = edata.detail.text;
                // event after
                edata.finish();
                return text;
            } else if (flag === false) {
                // before event
                edata = this.trigger('copy', {
                    target: this.name,
                    text: text,
                    cut: oEvent.keyCode == 88 ? true : false,
                    originalEvent: oEvent
                });
                if (edata.isCancelled === true) return '';
                text = edata.detail.text;
                return edata;
            }
        }
        /**
     * Gets value to be copied to the clipboard
     * @param ind index of the record
     * @param col_ind index of the column
     * @returns the displayed value of the field's record associated with the cell
     */ getCellCopy(ind, col_ind) {
            return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripTags(this.getCellHTML(ind, col_ind));
        }
        paste(text, event1) {
            let sel = this.getSelection();
            let ind = this.get(sel[0].recid, true);
            let col = sel[0].column;
            // before event
            let edata = this.trigger('paste', {
                target: this.name,
                text: text,
                index: ind,
                column: col,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            text = edata.detail.text;
            // default action
            if (this.selectType == 'row' || sel.length === 0) {
                console.log('ERROR: You can paste only if grid.selectType = \'cell\' and when at least one cell selected.');
                // event after
                edata.finish();
                return;
            }
            if (typeof text !== 'object') {
                let newSel = [];
                text = text.split('\n');
                for(let t = 0; t < text.length; t++){
                    let tmp = text[t].split('\t');
                    let cnt = 0;
                    let rec = this.records[ind];
                    let cols = [];
                    if (rec == null) continue;
                    for(let dt = 0; dt < tmp.length; dt++){
                        if (!this.columns[col + cnt]) continue;
                        setCellPaste(rec, this.columns[col + cnt].field, tmp[dt]);
                        cols.push(col + cnt);
                        cnt++;
                    }
                    for(let c = 0; c < cols.length; c++)newSel.push({
                        recid: rec.recid,
                        column: cols[c]
                    });
                    ind++;
                }
                this.selectNone(true) // no need to trigger select event
                ;
                this.select(newSel);
            } else {
                this.selectNone(true) // no need to trigger select event
                ;
                this.select([
                    {
                        recid: this.records[ind],
                        column: col
                    }
                ]);
            }
            this.refresh();
            // event after
            edata.finish();
            function setCellPaste(rec, field, paste) {
                rec.w2ui = rec.w2ui ?? {};
                rec.w2ui.changes = rec.w2ui.changes || {};
                rec.w2ui.changes[field] = paste;
            }
        }
        // ==================================================
        // --- Common functions
        resize() {
            let time = Date.now();
            // make sure the box is right
            if (!this.box || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).attr('name') != this.name) return;
            // event before
            let edata = this.trigger('resize', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // resize
            if (this.box != null) {
                this.resizeBoxes();
                this.resizeRecords();
            }
            // event after
            edata.finish();
            return Date.now() - time;
        }
        update({ cells: cells, fullCellRefresh: fullCellRefresh, ignoreColumns: ignoreColumns } = {}) {
            let time = Date.now();
            let self1 = this;
            if (this.box == null) return 0;
            if (Array.isArray(cells)) for(let i = 0; i < cells.length; i++){
                let index = cells[i].index;
                let column = cells[i].column;
                if (index < 0) continue;
                if (index == null || column == null) {
                    console.log('ERROR: Wrong argument for grid.update({ cells }), cells should be [{ index: X, column: Y }, ...]');
                    continue;
                }
                let rec = this.records[index] ?? {};
                rec.w2ui = rec.w2ui ?? {};
                rec.w2ui._update = rec.w2ui._update ?? {
                    cells: []
                };
                let row1 = rec.w2ui._update.row1;
                let row2 = rec.w2ui._update.row2;
                if (row1 == null || !row1.isConnected || row2 == null || !row2.isColSelected) {
                    row1 = this.box.querySelector(`#grid_${this.name}_rec_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(rec.recid)}`);
                    row2 = this.box.querySelector(`#grid_${this.name}_frec_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(rec.recid)}`);
                    rec.w2ui._update.row1 = row1;
                    rec.w2ui._update.row2 = row2;
                }
                _update(rec, row1, row2, index, column);
            }
            else for(let i = this.last.vscroll.recIndStart - 1; i <= this.last.vscroll.recIndEnd; i++){
                let index = i;
                if (this.last.searchIds.length > 0) index = this.last.searchIds[i];
                else index = i;
                let rec = this.records[index];
                if (index < 0 || rec == null) continue;
                rec.w2ui = rec.w2ui ?? {};
                rec.w2ui._update = rec.w2ui._update ?? {
                    cells: []
                };
                let row1 = rec.w2ui._update.row1;
                let row2 = rec.w2ui._update.row2;
                if (row1 == null || !row1.isConnected || row2 == null || !row2.isColSelected) {
                    row1 = this.box.querySelector(`#grid_${this.name}_rec_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(rec.recid)}`);
                    row2 = this.box.querySelector(`#grid_${this.name}_frec_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(rec.recid)}`);
                    rec.w2ui._update.row1 = row1;
                    rec.w2ui._update.row2 = row2;
                }
                for(let column = 0; column < this.columns.length; column++)_update(rec, row1, row2, index, column);
            }
            return Date.now() - time;
            function _update(rec, row1, row2, index, column) {
                let pcol = self1.columns[column];
                if (Array.isArray(ignoreColumns) && (ignoreColumns.includes(column) || ignoreColumns.includes(pcol.field))) return;
                let cell = rec.w2ui._update.cells[column];
                if (cell == null || !cell.isConnected) {
                    cell = self1.box.querySelector(`#grid_${self1.name}_data_${index}_${column}`);
                    rec.w2ui._update.cells[column] = cell;
                }
                if (cell == null) return;
                if (fullCellRefresh) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(cell).replace(self1.getCellHTML(index, column, false));
                    // need to reselect as it was replaced
                    cell = self1.box.querySelector(`#grid_${self1.name}_data_${index}_${column}`);
                    rec.w2ui._update.cells[column] = cell;
                } else {
                    let div = cell.children[0] // there is always a div inside a cell
                    ;
                    // value, attr, style, className, divAttr -- all on TD level except divAttr
                    let { value: value, style: style, className: className } = self1.getCellValue(index, column, false, true);
                    if (div.innerHTML != value) div.innerHTML = value;
                    if (style != '' && cell.style.cssText != style) cell.style.cssText = style;
                    if (className != '') {
                        let ignore = [
                            'w2ui-grid-data'
                        ];
                        let remove = [];
                        let add = className.split(' ').filter((cl)=>!!cl) // remove empty
                        ;
                        cell.classList.forEach((cl)=>{
                            if (!ignore.includes(cl)) remove.push(cl);
                        });
                        cell.classList.remove(...remove);
                        cell.classList.add(...add);
                    }
                }
                // column styles if any (lower priority)
                if (self1.columns[column].style && self1.columns[column].style != cell.style.cssText) cell.style.cssText = self1.columns[column].style ?? '';
                // record class if any
                if (rec.w2ui.class != null) {
                    if (typeof rec.w2ui.class == 'string') {
                        let ignore = [
                            'w2ui-odd',
                            'w2ui-even',
                            'w2ui-record'
                        ];
                        let remove = [];
                        let add = rec.w2ui.class.split(' ').filter((cl)=>!!cl) // remove empty
                        ;
                        if (row1 && row2) {
                            row1.classList.forEach((cl)=>{
                                if (!ignore.includes(cl)) remove.push(cl);
                            });
                            row1.classList.remove(...remove);
                            row1.classList.add(...add);
                            row2.classList.remove(...remove);
                            row2.classList.add(...add);
                        }
                    }
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(rec.w2ui.class) && typeof rec.w2ui.class[pcol.field] == 'string') {
                        let ignore = [
                            'w2ui-grid-data'
                        ];
                        let remove = [];
                        let add = rec.w2ui.class[pcol.field].split(' ').filter((cl)=>!!cl);
                        cell.classList.forEach((cl)=>{
                            if (!ignore.includes(cl)) remove.push(cl);
                        });
                        cell.classList.remove(...remove);
                        cell.classList.add(...add);
                    }
                }
                // record styles if any
                if (rec.w2ui.style != null) {
                    if (row1 && row2 && typeof rec.w2ui.style == 'string' && row1.style.cssText !== rec.w2ui.style) {
                        row1.style.cssText = 'height: ' + self1.recordHeight + 'px;' + rec.w2ui.style;
                        row1.setAttribute('custom_style', rec.w2ui.style);
                        row2.style.cssText = 'height: ' + self1.recordHeight + 'px;' + rec.w2ui.style;
                        row2.setAttribute('custom_style', rec.w2ui.style);
                    }
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(rec.w2ui.style) && typeof rec.w2ui.style[pcol.field] == 'string' && cell.style.cssText !== rec.w2ui.style[pcol.field]) cell.style.cssText = rec.w2ui.style[pcol.field];
                }
            }
        }
        refreshCell(recid, field) {
            let index = this.get(recid, true);
            let col_ind = this.getColumn(field, true);
            let isSummary = this.records[index] && this.records[index].recid == recid ? false : true;
            let cell = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`${isSummary ? '.w2ui-grid-summary ' : ''}#grid_${this.name}_data_${index}_${col_ind}`);
            if (cell.length == 0) return false;
            // set cell html and changed flag
            cell.replace(this.getCellHTML(index, col_ind, isSummary));
            return true;
        }
        refreshRow(recid, ind = null) {
            let tr1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
            let tr2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
            if (tr1.length > 0) {
                if (ind == null) ind = this.get(recid, true);
                let line = tr1.attr('line');
                let isSummary = this.records[ind] && this.records[ind].recid == recid ? false : true;
                // if it is searched, find index in search array
                let url = typeof this.url != 'object' ? this.url : this.url.get;
                if (this.searchData.length > 0 && !url) {
                    for(let s = 0; s < this.last.searchIds.length; s++)if (this.last.searchIds[s] == ind) ind = s;
                }
                let rec_html = this.getRecordHTML(ind, line, isSummary);
                tr1.replace(rec_html[0]);
                tr2.replace(rec_html[1]);
                // apply style to row if it was changed in render functions
                let st = this.records[ind].w2ui ? this.records[ind].w2ui.style : '';
                if (typeof st == 'string') {
                    tr1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_frec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
                    tr2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid));
                    tr1.attr('custom_style', st);
                    tr2.attr('custom_style', st);
                    if (tr1.hasClass('w2ui-selected')) st = st.replace('background-color', 'none');
                    tr1[0].style.cssText = 'height: ' + this.recordHeight + 'px;' + st;
                    tr2[0].style.cssText = 'height: ' + this.recordHeight + 'px;' + st;
                }
                if (isSummary) this.resize();
                return true;
            }
            return false;
        }
        refresh() {
            let time = Date.now();
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            if (this.total <= 0 && !url && this.searchData.length === 0) this.total = this.records.length;
            if (!this.box) return;
            // event before
            let edata = this.trigger('refresh', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // -- header
            if (this.show.header) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_header`).html($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.header) + '&#160;').show();
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_header`).hide();
            // -- toolbar
            if (this.show.toolbar) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_toolbar').show();
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_toolbar').hide();
            // -- make sure search is closed
            this.searchClose();
            // search placeholder
            let sInput = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_search_all');
            if (!this.multiSearch && this.last.field == 'all' && this.searches.length > 0) {
                this.last.field = this.searches[0].field;
                this.last.label = this.searches[0].label;
            }
            for(let s = 0; s < this.searches.length; s++)if (this.searches[s].field == this.last.field) this.last.label = this.searches[s].label;
            if (this.last.multi) sInput.attr('placeholder', '[' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Multiple Fields') + ']');
            else sInput.attr('placeholder', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Search') + ' ' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.last.label, true));
            if (sInput.val() != this.last.search) {
                let val = this.last.search;
                let tmp = sInput._w2field;
                if (tmp) val = tmp.format(val);
                sInput.val(val);
            }
            this.refreshSearch();
            this.refreshBody();
            // -- footer
            if (this.show.footer) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_footer`).html(this.getFooterHTML()).show();
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_footer`).hide();
            // all selected?
            let sel = this.last.selection, areAllSelected = this.records.length > 0 && sel.indexes.length == this.records.length, areAllSearchedSelected = sel.indexes.length > 0 && this.searchData.length !== 0 && sel.indexes.length == this.last.searchIds.length;
            if (areAllSelected || areAllSearchedSelected) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', true);
            else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_check_all').prop('checked', false);
            // show number of selected
            this.status();
            // collapse all records
            let rows = this.find({
                'w2ui.expanded': true
            }, true, true);
            for(let r = 0; r < rows.length; r++){
                let tmp = this.records[rows[r]].w2ui;
                if (tmp && !Array.isArray(tmp.children)) tmp.expanded = false;
            }
            // mark selection
            if (this.markSearch) setTimeout(()=>{
                // mark all search strings
                let search = [];
                for(let s = 0; s < this.searchData.length; s++){
                    let sdata = this.searchData[s];
                    let fld = this.getSearch(sdata.field);
                    if (!fld || fld.hidden) continue;
                    let ind = this.getColumn(sdata.field, true);
                    search.push({
                        field: sdata.field,
                        search: sdata.value,
                        col: ind
                    });
                }
                if (search.length > 0) search.forEach((item)=>{
                    let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('td[col="' + item.col + '"]:not(.w2ui-head)');
                    $aa2bd8933167d9cb$export$fe3767bc112f7a2a.marker(el, item.search);
                });
            }, 50);
            this.updateToolbar(this.last.selection);
            // event after
            edata.finish();
            this.resize();
            this.addRange('selection');
            setTimeout(()=>{
                this.resize() // needed for horizontal scroll to show (do not remove)
                ;
                this.scroll();
            }, 1);
            if (this.reorderColumns && !this.last.columnDrag) this.last.columnDrag = this.initColumnDrag();
            else if (!this.reorderColumns && this.last.columnDrag) this.last.columnDrag.remove();
            return Date.now() - time;
        }
        refreshSearch() {
            if (this.multiSearch && this.searchData.length > 0) {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-searches').length == 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-toolbar').css('height', this.last.toolbar_height + 35 + 'px').append(`<div id="grid_${this.name}_searches" class="w2ui-grid-searches"></div>`);
                let searches = `
                <span id="grid_${this.name}_search_logic" class="w2ui-grid-search-logic"></span>
                <div class="grid-search-line"></div>`;
                this.searchData.forEach((sd, sd_ind)=>{
                    let ind = this.getSearch(sd.field, true);
                    let sf = this.searches[ind];
                    let display;
                    if (Array.isArray(sd.value)) display = `<span class="grid-search-count">${sd.value.length}</span>`;
                    else if (sf && sf.type == 'list') display = !!sd.text && sd.text !== sd.value ? `: ${sd.text}` : `: ${sd.value}`;
                    else display = `: ${sd.value}`;
                    if (sf && sf.type == 'date') {
                        if (sd.operator == 'between') {
                            let dsp1 = sd.value[0];
                            let dsp2 = sd.value[1];
                            if (Number(dsp1) === dsp1) dsp1 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dsp1);
                            if (Number(dsp2) === dsp2) dsp2 = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dsp2);
                            display = `: ${dsp1} - ${dsp2}`;
                        } else {
                            let dsp = sd.value;
                            if (Number(dsp) == dsp) dsp = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(dsp);
                            let oper = sd.operator;
                            if (oper == 'more') oper = 'since';
                            if (oper == 'less') oper = 'before';
                            if (oper.substr(0, 5) == 'more:') oper = 'since';
                            display = `: ${oper} ${dsp}`;
                        }
                    }
                    searches += `<span class="w2ui-action" data-click="searchFieldTooltip|${ind}|${sd_ind}|this">
                    ${sf ? sf.label ?? sf.field : sd.field}
                    ${display}
                    <span class="icon-chevron-down"></span>
                </span>`;
                });
                // clear and save
                searches += `
                ${this.show.searchSave ? `<div class="grid-search-line"></div>
                       <button class="w2ui-btn grid-search-btn" data-click="searchSave">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Save')}</button>
                      ` : ''}
                <button class="w2ui-btn grid-search-btn btn-remove"
                    data-click="searchReset">X</button>
            `;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_searches`).html(searches);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_logic`).html($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.last.logic == 'AND' ? 'All' : 'Any'));
            } else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-toolbar').css('height', this.last.toolbar_height + 'px').find('.w2ui-grid-searches').remove();
            if (this.searchSelected) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_all`).val(' ').prop('readOnly', true);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_name`).show().find('.name-text').html(this.searchSelected.text);
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_all`).prop('readOnly', false);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_name`).hide().find('.name-text').html('');
            }
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_searches .w2ui-action, #grid_${this.name}_searches button`), this);
        }
        refreshBody() {
            this.scroll() // need to calculate virtual scrolling for columns
            ;
            let recHTML = this.getRecordsHTML();
            let colHTML = this.getColumnsHTML();
            let bodyHTML = '<div id="grid_' + this.name + '_frecords" class="w2ui-grid-frecords" style="margin-bottom: ' + ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() - 1) + 'px;">' + recHTML[0] + '</div>' + '<div id="grid_' + this.name + '_records" class="w2ui-grid-records">' + recHTML[1] + '</div>' + '<div id="grid_' + this.name + '_scroll1" class="w2ui-grid-scroll1" style="height: ' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() + 'px"></div>' + // Columns need to be after to be able to overlap
            '<div id="grid_' + this.name + '_fcolumns" class="w2ui-grid-fcolumns">' + '    <table><tbody>' + colHTML[0] + '</tbody></table>' + '</div>' + '<div id="grid_' + this.name + '_columns" class="w2ui-grid-columns">' + '    <table><tbody>' + colHTML[1] + '</tbody></table>' + '</div>' + `<div class="w2ui-intersection-marker" style="display: none; height: ${this.recordHeight - 5}px">
               <div class="top-marker"></div>
               <div class="bottom-marker"></div>
            </div>`;
            let gridBody = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_body`, this.box).html(bodyHTML);
            let records = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_records`, this.box);
            let frecords = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_frecords`, this.box);
            if (this.selectType == 'row') {
                records.on('mouseover mouseout', {
                    delegate: 'tr'
                }, (event1)=>{
                    let ind = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).attr('index') // don't read recid directly as it could be a number or a string
                    ;
                    let recid = this.records[ind]?.recid;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_frec_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid)}`).toggleClass('w2ui-record-hover', event1.type == 'mouseover');
                });
                frecords.on('mouseover mouseout', {
                    delegate: 'tr'
                }, (event1)=>{
                    let ind = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).attr('index') // don't read recid directly as it could be a number or a string
                    ;
                    let recid = this.records[ind]?.recid;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_rec_${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.escapeId(recid)}`).toggleClass('w2ui-record-hover', event1.type == 'mouseover');
                });
            }
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isIOS) records.append(frecords).on('click', {
                delegate: 'tr'
            }, (event1)=>{
                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).attr('index') // don't read recid directly as it could be a number or a string
                ;
                let recid = this.records[index]?.recid;
                this.dblClick(recid, event1);
            });
            else records.add(frecords).on('click', {
                delegate: 'tr'
            }, (event1)=>{
                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).attr('index') // don't read recid directly as it could be a number or a string
                ;
                let recid = this.records[index]?.recid;
                // do not generate click if empty record is clicked
                if (recid != '-none-') this.click(recid, event1);
            }).on('contextmenu', {
                delegate: 'tr'
            }, (event1)=>{
                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).attr('index') // don't read recid directly as it could be a number or a string
                ;
                let recid = this.records[index]?.recid;
                let td = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('td');
                let column = parseInt(td.attr('col') ?? -1);
                this.showContextMenu(recid, column, event1);
            }).on('mouseover', {
                delegate: 'tr'
            }, (event1)=>{
                this.last.rec_out = false;
                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).attr('index') // don't read recid directly as it could be a number or a string
                ;
                let recid = this.records[index]?.recid;
                if (index !== this.last.rec_over) {
                    this.last.rec_over = index;
                    // setTimeout is needed for correct event order enter/leave
                    setTimeout(()=>{
                        delete this.last.rec_out;
                        let edata = this.trigger('mouseEnter', {
                            target: this.name,
                            originalEvent: event1,
                            index: index,
                            recid: recid
                        });
                        edata.finish();
                    });
                }
            }).on('mouseout', {
                delegate: 'tr'
            }, (event1)=>{
                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).attr('index') // don't read recid directly as it could be a number or a string
                ;
                let recid = this.records[index]?.recid;
                this.last.rec_out = true;
                // setTimeouts are needed for correct event order enter/leave
                setTimeout(()=>{
                    let recLeave = ()=>{
                        let edata = this.trigger('mouseLeave', {
                            target: this.name,
                            originalEvent: event1,
                            index: index,
                            recid: recid
                        });
                        edata.finish();
                    };
                    if (index !== this.last.rec_over) recLeave();
                    setTimeout(()=>{
                        if (this.last.rec_out) {
                            delete this.last.rec_out;
                            delete this.last.rec_over;
                            recLeave();
                        }
                    });
                });
            });
            // enable scrolling on frozen records,
            gridBody.data('scroll', {
                lastDelta: 0,
                lastTime: 0
            }).find('.w2ui-grid-frecords').on('mousewheel DOMMouseScroll ', (event1)=>{
                event1.preventDefault();
                // TODO: improve, scroll is not smooth, if scrolled to the end, it takes a while to return
                let scroll1 = gridBody.data('scroll');
                let container = gridBody.find('.w2ui-grid-records');
                let amount = (event1.wheelDelta, -event1.wheelDelta);
                let newScrollTop = container.prop('scrollTop');
                scroll1.lastDelta += amount;
                amount = Math.round(scroll1.lastDelta);
                gridBody.data('scroll', scroll1);
                // make scroll amount dependent on visible rows
                // amount *= (Math.round(records.prop('clientHeight') / self.recordHeight) - 1) * self.recordHeight / 4
                container.get(0).scroll({
                    top: newScrollTop + amount,
                    behavior: 'smooth'
                });
            });
            // scroll on records (and frozen records)
            records.off('.body-global').on('scroll.body-global', {
                delegate: '.w2ui-grid-records'
            }, (event1)=>{
                this.scroll(event1);
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-grid-body') // gridBody
            .off('.body-global') // header column click
            .on('click.body-global dblclick.body-global contextmenu.body-global', {
                delegate: 'td.w2ui-head'
            }, (event1)=>{
                let col_ind = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).attr('col');
                let col = this.columns[col_ind] ?? {
                    field: col_ind
                } // it could be line number
                ;
                switch(event1.type){
                    case 'click':
                        this.columnClick(col.field, event1);
                        break;
                    case 'dblclick':
                        this.columnDblClick(col.field, event1);
                        break;
                    case 'contextmenu':
                        this.columnContextMenu(col.field, event1);
                        break;
                }
            }).on('mouseover.body-global', {
                delegate: '.w2ui-col-header'
            }, (event1)=>{
                let col = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).parent().attr('col');
                this.columnTooltipShow(col, event1);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).off('.tooltip').on('mouseleave.tooltip', ()=>{
                    this.columnTooltipHide(col, event1);
                });
            }) // select all
            .on('click.body-global', {
                delegate: 'input.w2ui-select-all'
            }, (event1)=>{
                if (event1.delegate.checked) this.selectAll();
                else this.selectNone();
                event1.stopPropagation();
                clearTimeout(this.last.kbd_timer) // keep grid in focus
                ;
            }) // tree-like grid (or expandable column) expand/collapse
            .on('click.body-global', {
                delegate: '.w2ui-show-children, .w2ui-col-expand'
            }, (event1)=>{
                event1.stopPropagation();
                let ind = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents('tr').attr('index');
                this.toggle(this.records[ind].recid);
            }) // info bubbles
            .on('click.body-global mouseover.body-global', {
                delegate: '.w2ui-info'
            }, (event1)=>{
                let td = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).closest('td');
                let tr = td.parent();
                let col = this.columns[td.attr('col')];
                let isSummary = tr.parents('.w2ui-grid-body').hasClass('w2ui-grid-summary');
                if ([
                    'mouseenter',
                    'mouseover'
                ].includes(col.info?.showOn?.toLowerCase()) && event1.type == 'mouseover') this.showBubble(tr.attr('index'), td.attr('col'), isSummary).then(()=>{
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).off('.tooltip').on('mouseleave.tooltip', ()=>{
                        $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-bubble');
                    });
                });
                else if (event1.type == 'click') {
                    $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-bubble');
                    this.showBubble(tr.attr('index'), td.attr('col'), isSummary);
                }
            }) // clipborad copy icon
            .on('mouseover.body-global', {
                delegate: '.w2ui-clipboard-copy'
            }, (event1)=>{
                if (event1.delegate._tooltipShow) return;
                let td = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).parent();
                let tr = td.parent();
                let col = this.columns[td.attr('col')];
                let isSummary = tr.parents('.w2ui-grid-body').hasClass('w2ui-grid-summary');
                $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                    name: this.name + '-bubble',
                    anchor: event1.delegate,
                    html: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(typeof col.clipboardCopy == 'string' ? col.clipboardCopy : 'Copy to clipboard'),
                    position: 'top|bottom',
                    offsetY: -2
                }).hide((evt)=>{
                    event1.delegate._tooltipShow = false;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).off('.tooltip');
                });
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).off('.tooltip').on('mouseleave.tooltip', (evt)=>{
                    $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-bubble');
                }).on('click.tooltip', (evt)=>{
                    evt.stopPropagation();
                    $aa2bd8933167d9cb$export$b876f801a4afd38f.update(this.name + '-bubble', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Copied'));
                    this.clipboardCopy(tr.attr('index'), td.attr('col'), isSummary);
                });
                event1.delegate._tooltipShow = true;
            }).on('click.body-global', {
                delegate: '.w2ui-editable-checkbox'
            }, (event1)=>{
                let dt = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.delegate).data();
                this.editChange.call(this, event1.delegate, dt.changeind, dt.colind, event1);
                this.updateToolbar();
            });
            // show empty message
            if (this.records.length === 0 && this.msgEmpty) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_body`).append(`<div id="grid_${this.name}_empty_msg" class="w2ui-grid-empty-msg"><div>${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.msgEmpty)}</div></div>`);
            else if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_empty_msg`).length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_empty_msg`).remove();
            // show summary records
            if (this.summary.length > 0) {
                let sumHTML = this.getSummaryHTML();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_fsummary`).html(sumHTML[0]).show();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_summary`).html(sumHTML[1]).show();
            } else {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_fsummary`).hide();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_summary`).hide();
            }
        }
        render(box) {
            let time = Date.now();
            let obj = this;
            if (typeof box == 'string') box = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).get(0);
            // event before
            let edata = this.trigger('render', {
                target: this.name,
                box: box ?? this.box
            });
            if (edata.isCancelled === true) return;
            // default action
            if (box != null) {
                this.unmount() // clean previous control
                ;
                this.box = box;
            }
            if (!this.box) return;
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            // reset needed if grid existed
            this.reset(true);
            // --- default search field
            if (!this.last.field) {
                if (!this.multiSearch || !this.show.searchAll) {
                    let tmp = 0;
                    while(tmp < this.searches.length && (this.searches[tmp].hidden || this.searches[tmp].simple === false))tmp++;
                    if (tmp >= this.searches.length) {
                        // all searches are hidden
                        this.last.field = '';
                        this.last.label = '';
                    } else {
                        this.last.field = this.searches[tmp].field;
                        this.last.label = this.searches[tmp].label;
                    }
                } else {
                    this.last.field = 'all';
                    this.last.label = 'All Fields';
                }
            }
            // insert elements
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).attr('name', this.name).addClass('w2ui-reset w2ui-grid w2ui-inactive').html('<div class="w2ui-grid-box">    <div id="grid_' + this.name + '_header" class="w2ui-grid-header"></div>' + '    <div id="grid_' + this.name + '_toolbar" class="w2ui-grid-toolbar"></div>' + '    <div id="grid_' + this.name + '_body" class="w2ui-grid-body"></div>' + '    <div id="grid_' + this.name + '_fsummary" class="w2ui-grid-body w2ui-grid-summary"></div>' + '    <div id="grid_' + this.name + '_summary" class="w2ui-grid-body w2ui-grid-summary"></div>' + '    <div id="grid_' + this.name + '_footer" class="w2ui-grid-footer"></div>' + '    <textarea id="grid_' + this.name + '_focus" class="w2ui-grid-focus-input" ' + (this.tabIndex ? 'tabindex="' + this.tabIndex + '"' : '') + ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isIOS ? 'readonly' : '') + '></textarea>' + // readonly needed on android not to open keyboard
            '</div>');
            if (this.selectType != 'row') $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).addClass('w2ui-ss');
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box)[0].style.cssText += this.style;
            // render toolbar
            if (this.toolbar != null) this.toolbar.render($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_toolbar')[0]);
            this.last.toolbar_height = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_toolbar`).prop('offsetHeight');
            // re-init search_all
            if (this.last.field && this.last.field != 'all') {
                let sd = this.searchData;
                setTimeout(()=>{
                    this.searchInitInput(this.last.field, sd.length == 1 ? sd[0].value : null);
                }, 1);
            }
            // init footer
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_footer`).html(this.getFooterHTML());
            // refresh
            if (!this.last.state) this.last.state = this.stateSave(true) // initial default state
            ;
            this.stateRestore();
            if (url) {
                this.clear();
                this.refresh();
            } // show empty grid (need it) - should it be only for remote data source
            // if hidden searches - apply it
            let hasHiddenSearches = false;
            for(let i = 0; i < this.searches.length; i++)if (this.searches[i].hidden) {
                hasHiddenSearches = true;
                break;
            }
            if (hasHiddenSearches) {
                this.searchReset(false) // will call reload
                ;
                if (!url) setTimeout(()=>{
                    this.searchReset();
                }, 1);
            } else this.reload();
            // focus
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_focus`).on('focus', (event1)=>{
                clearTimeout(this.last.kbd_timer);
                if (!this.hasFocus) this.focus();
            }).on('blur', (event1)=>{
                clearTimeout(this.last.kbd_timer);
                this.last.kbd_timer = setTimeout(()=>{
                    if (this.hasFocus) this.blur();
                }, 100) // need this timer to be 100 ms
                ;
            }).on('paste', (event1)=>{
                let cd = event1.clipboardData ? event1.clipboardData : null;
                if (cd) {
                    let items = cd.items;
                    if (items.length == 2) {
                        if (items.length == 2 && items[1].kind == 'file') items = [
                            items[1]
                        ];
                        if (items.length == 2 && items[0].type == 'text/plain' && items[1].type == 'text/html') items = [
                            items[1]
                        ];
                    }
                    let items2send = [];
                    // might contain data in different formats, but it is a single paste
                    for(let index in items){
                        let item = items[index];
                        if (item.kind === 'file') {
                            let file = item.getAsFile();
                            items2send.push({
                                kind: 'file',
                                data: file
                            });
                        } else if (item.kind === 'string' && (item.type === 'text/plain' || item.type === 'text/html')) {
                            event1.preventDefault();
                            let text = cd.getData('text/plain');
                            if (text.indexOf('\r') != -1 && text.indexOf('\n') == -1) text = text.replace(/\r/g, '\n');
                            items2send.push({
                                kind: item.type == 'text/html' ? 'html' : 'text',
                                data: text
                            });
                        }
                    }
                    if (items2send.length === 1 && items2send[0].kind != 'file') items2send = items2send[0].data;
                    $aa2bd8933167d9cb$export$dca4c93ccda43b77[this.name].paste(items2send, event1);
                    event1.preventDefault();
                }
            }).on('keydown', function(event1) {
                $aa2bd8933167d9cb$export$dca4c93ccda43b77[obj.name].keydown.call($aa2bd8933167d9cb$export$dca4c93ccda43b77[obj.name], event1);
            });
            // init mouse events for mouse selection
            let edataCol // event for column select
            ;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).off('mousedown.mouseStart').on('mousedown.mouseStart', mouseStart);
            this.updateToolbar();
            // event after
            edata.finish();
            // observe div resize
            this.last.observeResize = new ResizeObserver(()=>{
                this.resize();
                this.scroll();
            });
            this.last.observeResize.observe(this.box);
            return Date.now() - time;
            function mouseStart(event1) {
                if (event1.which != 1) return; // if not left mouse button
                // restore css user-select
                if (obj.last.userSelect == 'text') {
                    obj.last.userSelect = '';
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-grid-body').css('user-select', 'none');
                }
                // regular record select
                if (obj.selectType == 'row' && ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents().hasClass('w2ui-head') || $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('w2ui-head'))) return;
                if (obj.last.move && obj.last.move.type == 'expand') return;
                // if altKey - alow text selection
                if (event1.altKey) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-grid-body').css('user-select', 'text');
                    obj.selectNone();
                    obj.last.move = {
                        type: 'text-select'
                    };
                    obj.last.userSelect = 'text';
                } else {
                    let tmp = event1.target;
                    let pos = {
                        x: event1.offsetX - 10,
                        y: event1.offsetY - 10
                    };
                    let tmps = false;
                    while(tmp){
                        if (tmp.classList && tmp.classList.contains('w2ui-grid')) break;
                        if (tmp.tagName && tmp.tagName.toUpperCase() == 'TD') tmps = true;
                        if (tmp.tagName && tmp.tagName.toUpperCase() != 'TR' && tmps == true) {
                            pos.x += tmp.offsetLeft;
                            pos.y += tmp.offsetTop;
                        }
                        tmp = tmp.parentNode;
                    }
                    let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents('tr').attr('index');
                    let recid = obj.records[index]?.recid;
                    obj.last.move = {
                        x: event1.screenX,
                        y: event1.screenY,
                        divX: 0,
                        divY: 0,
                        focusX: pos.x,
                        focusY: pos.y,
                        recid: recid,
                        column: parseInt(event1.target.tagName.toUpperCase() == 'TD' ? $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('col') : $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents('td').attr('col')),
                        type: 'select',
                        ghost: false,
                        start: true
                    };
                    if (obj.last.move.recid == null) obj.last.move.type = 'select-column';
                    // set focus to grid
                    let target = event1.target;
                    let $input = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_focus');
                    // move input next to cursor so screen does not jump
                    if (obj.last.move) {
                        let sLeft = obj.last.move.focusX;
                        let sTop = obj.last.move.focusY;
                        let $owner = $aa2bd8933167d9cb$export$2fa187e846a241c4(target).parents('table').parent();
                        if ($owner.hasClass('w2ui-grid-records') || $owner.hasClass('w2ui-grid-frecords') || $owner.hasClass('w2ui-grid-columns') || $owner.hasClass('w2ui-grid-fcolumns') || $owner.hasClass('w2ui-grid-summary')) {
                            sLeft = obj.last.move.focusX - $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_records').prop('scrollLeft');
                            sTop = obj.last.move.focusY - $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_records').prop('scrollTop');
                        }
                        if ($aa2bd8933167d9cb$export$2fa187e846a241c4(target).hasClass('w2ui-grid-footer') || $aa2bd8933167d9cb$export$2fa187e846a241c4(target).parents('div.w2ui-grid-footer').length > 0) sTop = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_footer').get(0).offsetTop;
                        // if clicked on toolbar
                        if ($owner.hasClass('w2ui-scroll-wrapper') && $owner.parent().hasClass('w2ui-toolbar')) sLeft = obj.last.move.focusX - $owner.prop('scrollLeft');
                        $input.css({
                            left: sLeft - 10,
                            top: sTop
                        });
                    }
                    // if toolbar input is clicked
                    setTimeout(()=>{
                        if (!obj.last.inEditMode) {
                            if ([
                                'INPUT',
                                'TEXTAREA',
                                'SELECT'
                            ].includes(target.tagName)) target.focus();
                            else if ($input.get(0) !== document.active) $input.get(0)?.focus({
                                preventScroll: true
                            });
                        }
                    }, 50);
                    // disable click select for this condition
                    if (!obj.multiSelect && !obj.reorderRows && obj.last.move.type == 'drag') delete obj.last.move;
                }
                if (obj.reorderRows == true) {
                    let el = event1.target;
                    if (el.tagName.toUpperCase() != 'TD') el = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).parents('td')[0];
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(el).hasClass('w2ui-col-number') || $aa2bd8933167d9cb$export$2fa187e846a241c4(el).hasClass('w2ui-col-order')) {
                        obj.selectNone();
                        obj.last.move.reorder = true;
                        // suppress hover
                        let eColor = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-even.w2ui-empty-record').css('background-color');
                        let oColor = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-odd.w2ui-empty-record').css('background-color');
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-even td').filter(':not(.w2ui-col-number)').css('background-color', eColor);
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-odd td').filter(':not(.w2ui-col-number)').css('background-color', oColor);
                        // display empty record and ghost record
                        let mv = obj.last.move;
                        let recs = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-grid-records');
                        if (!mv.ghost) {
                            let row = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find(`#grid_${obj.name}_rec_${mv.recid}`);
                            let tmp = row.parents('table').find('tr:first-child').get(0).cloneNode(true);
                            mv.offsetY = event1.offsetY;
                            mv.from = mv.recid;
                            mv.pos = {
                                top: row.get(0).offsetTop - 1,
                                left: row.get(0).offsetLeft
                            };
                            mv.ghost = $aa2bd8933167d9cb$export$2fa187e846a241c4(row.get(0).cloneNode(true));
                            mv.ghost.removeAttr('id');
                            mv.ghost.find('td').css({
                                'border-top': '1px solid silver',
                                'border-bottom': '1px solid silver'
                            });
                            row.find('td').remove();
                            row.append(`<td colspan="1000"><div class="w2ui-reorder-empty" style="height: ${obj.recordHeight - 2}px"></div></td>`);
                            recs.append('<div id="grid_' + obj.name + '_ghost_line" style="position: absolute; z-index: 999999; pointer-events: none; width: 100%;"></div>');
                            recs.append('<table id="grid_' + obj.name + '_ghost" style="position: absolute; z-index: 999998; opacity: 0.9; pointer-events: none;"></table>');
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_ghost').append(tmp).append(mv.ghost);
                        }
                        let ghost = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_ghost');
                        ghost.css({
                            top: mv.pos.top + 'px',
                            left: mv.pos.left + 'px'
                        });
                    } else obj.last.move.reorder = false;
                }
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).on('mousemove.w2ui-' + obj.name, mouseMove).on('mouseup.w2ui-' + obj.name, mouseStop);
                // needed when grid grids are nested, see issue #1275
                event1.stopPropagation();
            }
            function mouseMove(event1) {
                if (!event1.target.tagName) // this can happen is you click+drag and move the mouse out of the DOM area,
                // e.g. into the browser's toolbar area
                return;
                let mv = obj.last.move;
                if (!mv || [
                    'select',
                    'select-column'
                ].indexOf(mv.type) == -1) return;
                mv.divX = event1.screenX - mv.x;
                mv.divY = event1.screenY - mv.y;
                if (Math.abs(mv.divX) <= 1 && Math.abs(mv.divY) <= 1) return; // only if moved more then 1px
                obj.last.cancelClick = true;
                if (obj.reorderRows == true && obj.last.move.reorder) {
                    let tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents('tr');
                    let ind = tmp.attr('index');
                    let recid = obj.records[ind]?.recid;
                    if (recid == '-none-') recid = 'bottom';
                    if (recid != mv.from) {
                        // let row1 = query(obj.box).find('#grid_'+ obj.name + '_rec_'+ mv.recid)
                        let row2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_rec_' + recid);
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.insert-before');
                        row2.addClass('insert-before');
                        // MOVABLE GHOST
                        // if (event.screenY - mv.lastY < 0) row1.after(row2); else row2.after(row1);
                        mv.lastY = event1.screenY;
                        mv.to = recid;
                        // line to insert before
                        let pos = {
                            top: row2.get(0)?.offsetTop,
                            left: row2.get(0)?.offsetLeft
                        };
                        let ghost_line = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_ghost_line');
                        if (pos) ghost_line.css({
                            top: pos.top + 'px',
                            left: mv.pos.left + 'px',
                            'border-top': '2px solid #769EFC'
                        });
                        else ghost_line.css({
                            'border-top': '2px solid transparent'
                        });
                    }
                    let ghost = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_ghost');
                    ghost.css({
                        top: mv.pos.top + mv.divY + 'px',
                        left: mv.pos.left + 'px'
                    });
                    return;
                }
                if (mv.start && mv.recid) {
                    obj.selectNone();
                    mv.start = false;
                }
                let newSel = [];
                let ind = event1.target.tagName.toUpperCase() == 'TR' ? $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('index') : $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents('tr').attr('index');
                let recid = obj.records[ind]?.recid;
                if (recid == null) {
                    // select by dragging columns
                    if (obj.selectType == 'row') return;
                    if (obj.last.move && obj.last.move.type == 'select') return;
                    let col = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents('td').attr('col'));
                    if (isNaN(col)) {
                        obj.removeRange('column-selection');
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-grid-columns .w2ui-col-header, .w2ui-grid-fcolumns .w2ui-col-header').removeClass('w2ui-col-selected');
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-col-number').removeClass('w2ui-row-selected');
                        delete mv.colRange;
                    } else {
                        // add all columns in between
                        let newRange = col + '-' + col;
                        if (mv.column < col) newRange = mv.column + '-' + col;
                        if (mv.column > col) newRange = col + '-' + mv.column;
                        // array of selected columns
                        let cols = [];
                        let tmp = newRange.split('-');
                        for(let ii = parseInt(tmp[0]); ii <= parseInt(tmp[1]); ii++)cols.push(ii);
                        if (mv.colRange != newRange) {
                            edataCol = obj.trigger('columnSelect', {
                                target: obj.name,
                                columns: cols
                            });
                            if (edataCol.isCancelled !== true) {
                                if (mv.colRange == null) obj.selectNone();
                                // highlight columns
                                let tmp = newRange.split('-');
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-grid-columns .w2ui-col-header, .w2ui-grid-fcolumns .w2ui-col-header').removeClass('w2ui-col-selected');
                                for(let j = parseInt(tmp[0]); j <= parseInt(tmp[1]); j++)$aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_column_' + j + ' .w2ui-col-header').addClass('w2ui-col-selected');
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('.w2ui-col-number:not(.w2ui-head)').addClass('w2ui-row-selected');
                                // show new range
                                mv.colRange = newRange;
                                obj.removeRange('column-selection');
                                obj.addRange({
                                    name: 'column-selection',
                                    range: [
                                        {
                                            recid: obj.records[0].recid,
                                            column: tmp[0]
                                        },
                                        {
                                            recid: obj.records[obj.records.length - 1].recid,
                                            column: tmp[1]
                                        }
                                    ],
                                    style: 'background-color: rgba(90, 145, 234, 0.1)'
                                });
                            }
                        }
                    }
                } else {
                    let ind1 = obj.get(mv.recid, true);
                    // this happens when selection is started on summary row
                    if (ind1 == null || obj.records[ind1] && obj.records[ind1].recid != mv.recid) return;
                    let ind2 = obj.get(recid, true);
                    // this happens when selection is extended into summary row (a good place to implement scrolling)
                    if (ind2 == null) return;
                    let col1 = parseInt(mv.column);
                    let col2 = parseInt(event1.target.tagName.toUpperCase() == 'TD' ? $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('col') : $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents('td').attr('col'));
                    if (isNaN(col1) && isNaN(col2)) {
                        col1 = 0;
                        col2 = obj.columns.length - 1;
                    }
                    if (ind1 > ind2) {
                        let tmp = ind1;
                        ind1 = ind2;
                        ind2 = tmp;
                    }
                    // check if need to refresh
                    let tmp = 'ind1:' + ind1 + ',ind2;' + ind2 + ',col1:' + col1 + ',col2:' + col2;
                    if (mv.range == tmp) return;
                    mv.range = tmp;
                    for(let i = ind1; i <= ind2; i++){
                        if (obj.last.searchIds.length > 0 && obj.last.searchIds.indexOf(i) == -1) continue;
                        if (obj.selectType != 'row') {
                            if (col1 > col2) {
                                let tmp = col1;
                                col1 = col2;
                                col2 = tmp;
                            }
                            for(let c = col1; c <= col2; c++){
                                if (obj.columns[c].hidden) continue;
                                newSel.push({
                                    recid: obj.records[i].recid,
                                    column: parseInt(c)
                                });
                            }
                        } else newSel.push(obj.records[i].recid);
                    }
                    if (obj.selectType != 'row') {
                        let sel = obj.getSelection();
                        // add more items
                        let tmp = [];
                        for(let ns = 0; ns < newSel.length; ns++){
                            let flag = false;
                            for(let s = 0; s < sel.length; s++)if (newSel[ns].recid == sel[s].recid && newSel[ns].column == sel[s].column) flag = true;
                            if (!flag) tmp.push({
                                recid: newSel[ns].recid,
                                column: newSel[ns].column
                            });
                        }
                        obj.select(tmp);
                        // remove items
                        tmp = [];
                        for(let s = 0; s < sel.length; s++){
                            let flag = false;
                            for(let ns = 0; ns < newSel.length; ns++)if (newSel[ns].recid == sel[s].recid && newSel[ns].column == sel[s].column) flag = true;
                            if (!flag) tmp.push({
                                recid: sel[s].recid,
                                column: sel[s].column
                            });
                        }
                        obj.unselect(tmp);
                    } else if (obj.multiSelect) {
                        let sel = obj.getSelection();
                        for(let ns = 0; ns < newSel.length; ns++)if (sel.indexOf(newSel[ns]) == -1) obj.select(newSel[ns]) // add more items
                        ;
                        for(let s = 0; s < sel.length; s++)if (newSel.indexOf(sel[s]) == -1) obj.unselect(sel[s]) // remove items
                        ;
                    }
                }
            }
            function mouseStop(event1) {
                let mv = obj.last.move;
                setTimeout(()=>{
                    delete obj.last.cancelClick;
                }, 1);
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents().hasClass('.w2ui-head') || $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('.w2ui-head')) return;
                if (mv && [
                    'select',
                    'select-column'
                ].indexOf(mv.type) != -1) {
                    if (mv.colRange != null && edataCol.isCancelled !== true) {
                        let tmp = mv.colRange.split('-');
                        let sel = [];
                        for(let i = 0; i < obj.records.length; i++){
                            let cols = [];
                            for(let j = parseInt(tmp[0]); j <= parseInt(tmp[1]); j++)cols.push(j);
                            sel.push({
                                recid: obj.records[i].recid,
                                column: cols
                            });
                        }
                        obj.removeRange('column-selection');
                        edataCol.finish();
                        obj.select(sel);
                    }
                    if (obj.reorderRows == true && obj.last.move.reorder) {
                        if (mv.to != null) {
                            // event
                            let edata = obj.trigger('reorderRow', {
                                target: obj.name,
                                recid: mv.from,
                                moveBefore: mv.to
                            });
                            if (edata.isCancelled === true) {
                                resetRowReorder();
                                delete obj.last.move;
                                return;
                            }
                            // default behavior
                            let ind1 = obj.get(mv.from, true);
                            let ind2 = obj.get(mv.to, true);
                            if (mv.to == 'bottom') ind2 = obj.records.length // end of list
                            ;
                            let tmp = obj.records[ind1];
                            // swap records
                            if (ind1 != null && ind2 != null) {
                                obj.records.splice(ind1, 1);
                                if (ind1 > ind2) obj.records.splice(ind2, 0, tmp);
                                else obj.records.splice(ind2 - 1, 0, tmp);
                            }
                            // clear sortData
                            obj.sortData = [];
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find(`#grid_${obj.name}_columns .w2ui-col-header`).removeClass('w2ui-col-sorted');
                            resetRowReorder();
                            // event after
                            edata.finish();
                        } else resetRowReorder();
                    }
                }
                delete obj.last.move;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('.w2ui-' + obj.name);
            }
            function resetRowReorder() {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find(`#grid_${obj.name}_ghost`).remove();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find(`#grid_${obj.name}_ghost_line`).remove();
                obj.refresh();
                delete obj.last.move;
            }
        }
        unmount() {
            super.unmount();
            this.toolbar?.unmount();
            this.last.observeResize?.disconnect();
        }
        destroy() {
            // event before
            let edata = this.trigger('destroy', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // clean up
            this.toolbar?.destroy?.();
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_body`).length > 0) this.unmount();
            delete $aa2bd8933167d9cb$export$dca4c93ccda43b77[this.name];
            // event after
            edata.finish();
        }
        // ===========================================
        // --- Internal Functions
        initColumnOnOff() {
            let items = [
                {
                    id: 'line-numbers',
                    text: 'Line #',
                    checked: this.show.lineNumbers
                }
            ];
            // columns
            for(let c = 0; c < this.columns.length; c++){
                let col = this.columns[c];
                let text = this.columns[c].text;
                if (col.hideable === false) continue;
                if (!text && this.columns[c].tooltip) text = this.columns[c].tooltip;
                if (!text) text = '- column ' + (parseInt(c) + 1) + ' -';
                items.push({
                    id: col.field,
                    text: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripTags(text),
                    checked: !col.hidden
                });
            }
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            if (url && this.show.skipRecords || this.show.saveRestoreState) items.push({
                text: '--'
            });
            // skip records
            if (this.show.skipRecords) {
                let skip = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Skip') + `<input id="${this.name}_skip" type="text" class="w2ui-input w2ui-grid-skip" value="${this.offset}">` + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('records');
                items.push({
                    id: 'w2ui-skip',
                    text: skip,
                    group: false,
                    icon: 'w2ui-icon-empty'
                });
            }
            // save/restore state
            if (this.show.saveRestoreState) items.push({
                id: 'w2ui-stateSave',
                text: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Save Grid State'),
                icon: 'w2ui-icon-empty',
                group: false
            }, {
                id: 'w2ui-stateReset',
                text: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Restore Default State'),
                icon: 'w2ui-icon-empty',
                group: false
            });
            let selected = [];
            items.forEach((item)=>{
                item.text = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(item.text) // translate
                ;
                if (item.checked) selected.push(item.id);
            });
            this.toolbar.set('w2ui-column-on-off', {
                selected: selected,
                items: items
            });
            return items;
        }
        initColumnDrag(box) {
            // throw error if using column groups
            if (this.columnGroups && this.columnGroups.length) throw 'Draggable columns are not currently supported with column groups.';
            let self1 = this;
            let dragData = {
                pressed: false,
                targetPos: null,
                columnHead: null
            };
            let hasInvalidClass = (target, lastColumn)=>{
                let iClass = [
                    'w2ui-col-number',
                    'w2ui-col-expand',
                    'w2ui-col-select'
                ];
                if (lastColumn !== true) iClass.push('w2ui-head-last');
                for(let i = 0; i < iClass.length; i++){
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(target).closest('.w2ui-head').hasClass(iClass[i])) return true;
                }
                return false;
            };
            // attach original event listener
            $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).off('.colDrag').on('mousedown.colDrag', dragColStart);
            function dragColStart(event1) {
                if (dragData.pressed || dragData.numberPreColumnsPresent === 0 || event1.button !== 0) return;
                let edata, columns, origColumn, origColumnNumber;
                let preColHeadersSelector = '.w2ui-head.w2ui-col-number, .w2ui-head.w2ui-col-expand, .w2ui-head.w2ui-col-select';
                // do nothing if it is not a header
                if (!$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parents().hasClass('w2ui-head') || hasInvalidClass(event1.target)) return;
                dragData.pressed = true;
                dragData.initialX = event1.pageX;
                dragData.initialY = event1.pageY;
                dragData.numberPreColumnsPresent = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find(preColHeadersSelector).length;
                // start event for drag start
                dragData.columnHead = origColumn = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.w2ui-head');
                dragData.originalPos = origColumnNumber = parseInt(origColumn.attr('col'), 10);
                edata = self1.trigger('columnDragStart', {
                    originalEvent: event1,
                    origColumnNumber: origColumnNumber,
                    target: origColumn[0]
                });
                if (edata.isCancelled === true) return false;
                columns = dragData.columns = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('.w2ui-head:not(.w2ui-head-last)');
                // add events
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).on('mouseup.colDrag', dragColEnd);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).on('mousemove.colDrag', dragColOver);
                let col = self1.columns[dragData.originalPos];
                let colText = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(typeof col.text == 'function' ? col.text(col) : col.text);
                dragData.ghost = $aa2bd8933167d9cb$export$2fa187e846a241c4.html(`<span col="${dragData.originalPos}">${colText}</span>`)[0];
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document.body).append(dragData.ghost);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(dragData.ghost).css({
                    display: 'none',
                    left: event1.pageX,
                    top: event1.pageY,
                    opacity: 1,
                    margin: '3px 0 0 20px',
                    padding: '3px',
                    'background-color': 'white',
                    position: 'fixed',
                    'z-index': 999999
                }).addClass('.w2ui-grid-ghost');
                // establish current offsets
                dragData.offsets = [];
                for(let i = 0, l = columns.length; i < l; i++){
                    let rect = columns[i].getBoundingClientRect();
                    dragData.offsets.push(rect.left);
                }
                // conclude event
                edata.finish();
            }
            function dragColOver(event1) {
                if (!dragData.pressed || !dragData.columnHead) return;
                let cursorX = event1.pageX;
                let cursorY = event1.pageY;
                if (!hasInvalidClass(event1.target, true)) markIntersection(event1);
                trackGhost(cursorX, cursorY);
            }
            function dragColEnd(event1) {
                if (!dragData.pressed || !dragData.columnHead) return;
                dragData.pressed = false;
                let edata, target, selected, columnConfig;
                let finish = ()=>{
                    let ghosts = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('.w2ui-grid-ghost');
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('.w2ui-intersection-marker').hide();
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(dragData.ghost).remove();
                    ghosts.remove();
                    // dragData.columns.css({ overflow: '' }).children('div').css({ overflow: '' });
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('.colDrag');
                    dragData = {};
                };
                // if no move, then click event for sorting
                if (event1.pageX == dragData.initialX && event1.pageY == dragData.initialY) {
                    self1.columnClick(self1.columns[dragData.originalPos].field, event1);
                    finish();
                    return;
                }
                // start event for drag start
                edata = self1.trigger('columnDragEnd', {
                    originalEvent: event1,
                    target: dragData.columnHead[0],
                    dragData: dragData
                });
                if (edata.isCancelled === true) return false;
                selected = self1.columns[dragData.originalPos];
                columnConfig = self1.columns;
                if (dragData.originalPos != dragData.targetPos && dragData.targetPos != null) {
                    columnConfig.splice(dragData.targetPos, 0, $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(selected));
                    columnConfig.splice(columnConfig.indexOf(selected), 1);
                }
                finish();
                self1.refresh();
                edata.finish({
                    targetColumn: target - 1
                });
            }
            function markIntersection(event1) {
                // if mouse over is not over table
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('td').length == 0) return;
                let td = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('td');
                let newPos = td.hasClass('w2ui-head-last') ? self1.columns.length : parseInt(td.attr('col'));
                if (dragData.targetPos != newPos) {
                    // if mouse over invalid column
                    let rect1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('.w2ui-grid-body').get(0).getBoundingClientRect();
                    let rect2 = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('td').get(0).getBoundingClientRect();
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('.w2ui-intersection-marker').show().css({
                        left: rect2.left - rect1.left + 'px',
                        height: rect2.height + 'px'
                    });
                    dragData.targetPos = newPos;
                }
                return;
            }
            function trackGhost(cursorX, cursorY) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(dragData.ghost).css({
                    left: cursorX - 10 + 'px',
                    top: cursorY - 10 + 'px'
                }).show();
            }
            // return an object to remove drag if it has ever been enabled
            return {
                remove () {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).off('.colDrag');
                    self1.last.columnDrag = false;
                }
            };
        }
        columnOnOff(event1, field) {
            // event before
            let edata = this.trigger('columnOnOff', {
                target: this.name,
                field: field,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // collapse expanded rows
            let rows = this.find({
                'w2ui.expanded': true
            }, true);
            for(let r = 0; r < rows.length; r++){
                let tmp = this.records[r].w2ui;
                if (tmp && !Array.isArray(tmp.children)) this.records[r].w2ui.expanded = false;
            }
            // show/hide
            if (field == 'line-numbers') {
                this.show.lineNumbers = !this.show.lineNumbers;
                this.refresh();
            } else {
                let col = this.getColumn(field);
                if (col.hidden) this.showColumn(col.field);
                else this.hideColumn(col.field);
            }
            // event after
            edata.finish();
        }
        initToolbar() {
            // if it is already initiazlied
            if (this.toolbar.render != null) return;
            let tb_items = this.toolbar.items || [];
            this.toolbar.items = [];
            this.toolbar = new $aa2bd8933167d9cb$export$d1962123e55f7d10($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.toolbar, {
                name: this.name + '_toolbar',
                owner: this
            }));
            if (this.show.toolbarReload) this.toolbar.items.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.buttons.reload));
            if (this.show.toolbarColumns) this.toolbar.items.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.buttons.columns));
            if (this.show.toolbarSearch) {
                let html = `
                <div class="w2ui-grid-search-input">
                    ${this.buttons.search.html}
                    <div id="grid_${this.name}_search_name" class="w2ui-grid-search-name">
                        <span class="name-icon w2ui-icon-search"></span>
                        <span class="name-text"></span>
                        <span class="name-cross w2ui-action" data-click="searchReset">x</span>
                    </div>
                    <input type="text" id="grid_${this.name}_search_all" class="w2ui-search-all" tabindex="-1"
                        autocapitalize="off" autocomplete="off" autocorrect="off" spellcheck="false"
                        placeholder="${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.last.label, true)}" value="${this.last.search}"
                        data-focus="searchSuggest" data-click="stop"
                    >
                    <div class="w2ui-search-drop w2ui-action" data-click="searchOpen"
                            style="${this.multiSearch ? '' : 'display: none'}">
                        <span class="w2ui-icon-drop"></span>
                    </div>
                </div>`;
                this.toolbar.items.push({
                    id: 'w2ui-search',
                    type: 'html',
                    html: html,
                    onRefresh: async (event1)=>{
                        await event1.complete;
                        let input = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_all`);
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_search_all, .w2ui-action`), this);
                        // slow down live search calls
                        let slowSearch = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.debounce((event1)=>{
                            let val = event1.target.value;
                            if (this.liveSearch && this.last.liveText != val) {
                                this.last.liveText = val;
                                this.search(this.last.field, val);
                            }
                            if (event1.keyCode == 40) this.searchSuggest(true);
                        }, 250);
                        input.on('change', (event1)=>{
                            if (!this.liveSearch) {
                                this.search(this.last.field, event1.target.value);
                                this.searchSuggest(true, true, this);
                            }
                        }).on('blur', ()=>{
                            this.last.liveText = '';
                        }).on('keyup', (event1)=>{
                            switch(event1.keyCode){
                                case 40:
                                    this.searchSuggest(true);
                                    break;
                                case 13:
                                    this.search(this.last.field, event1.target.value);
                                    event1.preventDefault();
                                    break;
                                default:
                                    slowSearch(event1);
                            }
                        });
                    }
                });
            }
            if (Array.isArray(tb_items)) {
                let ids = tb_items.map((item)=>item.id);
                if (this.show.toolbarAdd && !ids.includes(this.buttons.add.id)) this.toolbar.items.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.buttons.add));
                if (this.show.toolbarEdit && !ids.includes(this.buttons.edit.id)) this.toolbar.items.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.buttons.edit));
                if (this.show.toolbarDelete && !ids.includes(this.buttons.delete.id)) this.toolbar.items.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.buttons.delete));
                if (this.show.toolbarSave && !ids.includes(this.buttons.save.id)) {
                    if (this.show.toolbarAdd || this.show.toolbarDelete || this.show.toolbarEdit) this.toolbar.items.push({
                        type: 'break',
                        id: 'w2ui-break2'
                    });
                    this.toolbar.items.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.buttons.save));
                }
                // fill in overwritten items with default buttons
                // ids are w2ui-* but in this.buttons the map_ctx is just [add, edit, delete]
                // must specify at least {id, name} in this.toolbar.items if you want to keep order
                tb_items = tb_items.map((item)=>this.buttons[item.name] ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.buttons[item.name], item) : item);
            }
            // add original buttons
            this.toolbar.items.push(...tb_items);
            // =============================================
            // ------ Toolbar onClick processing
            this.toolbar.on('click', (event1)=>{
                let edata = this.trigger('toolbar', {
                    target: event1.target,
                    originalEvent: event1
                });
                if (edata.isCancelled === true) return;
                let edata2;
                switch(event1.detail.item.id){
                    case 'w2ui-reload':
                        edata2 = this.trigger('reload', {
                            target: this.name
                        });
                        if (edata2.isCancelled === true) return false;
                        this.reload();
                        edata2.finish();
                        break;
                    case 'w2ui-column-on-off':
                        // TODO: tap on columns will hide menu before opening, only in grid not in toolbar
                        if (event1.detail.subItem) {
                            let id = event1.detail.subItem.id;
                            if ([
                                'w2ui-stateSave',
                                'w2ui-stateReset'
                            ].includes(id)) this[id.substring(5)]();
                            else if (id == 'w2ui-skip') ;
                            else this.columnOnOff(event1, event1.detail.subItem.id);
                        } else {
                            this.initColumnOnOff();
                            // init input control with records to skip
                            setTimeout(()=>{
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(`#w2overlay-${this.name}_toolbar-drop .w2ui-grid-skip`).off('.w2ui-grid').on('click.w2ui-grid', (evt)=>{
                                    evt.stopPropagation();
                                }).on('keypress', (evt)=>{
                                    if (evt.keyCode == 13) {
                                        this.skip(evt.target.value);
                                        this.toolbar.click('w2ui-column-on-off') // close menu
                                        ;
                                    }
                                });
                            }, 100);
                        }
                        break;
                    case 'w2ui-add':
                        // events
                        edata2 = this.trigger('add', {
                            target: this.name,
                            recid: null
                        });
                        if (edata2.isCancelled === true) return false;
                        edata2.finish();
                        break;
                    case 'w2ui-edit':
                        {
                            let sel = this.getSelection();
                            let recid = null;
                            if (sel.length == 1) recid = sel[0];
                            // events
                            edata2 = this.trigger('edit', {
                                target: this.name,
                                recid: recid
                            });
                            if (edata2.isCancelled === true) return false;
                            edata2.finish();
                            break;
                        }
                    case 'w2ui-delete':
                        this.delete();
                        break;
                    case 'w2ui-save':
                        this.save();
                        break;
                }
                // no default action
                edata.finish();
            });
            this.toolbar.on('refresh', (event1)=>{
                if (event1.target == 'w2ui-search') {
                    let sd = this.searchData;
                    setTimeout(()=>{
                        this.searchInitInput(this.last.field, sd.length == 1 ? sd[0].value : null);
                    }, 1);
                }
            });
        }
        initResize() {
            let obj = this;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-resizer').off('.grid-col-resize').on('click.grid-col-resize', function(event1) {
                event1.stopPropagation();
                event1.preventDefault();
            }).on('mousedown.grid-col-resize', function(event1) {
                if (!event1) event1 = window.event;
                obj.last.colResizing = true;
                obj.last.tmp = {
                    x: event1.screenX,
                    y: event1.screenY,
                    gx: event1.screenX,
                    gy: event1.screenY,
                    col: parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(this).attr('name'))
                };
                // find tds that will be resized
                obj.last.tmp.tds = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('#grid_' + obj.name + '_body table tr:first-child td[col="' + obj.last.tmp.col + '"]');
                event1.stopPropagation();
                event1.preventDefault();
                // fix sizes
                for(let c = 0; c < obj.columns.length; c++){
                    if (obj.columns[c].hidden) continue;
                    if (obj.columns[c].sizeOriginal == null) obj.columns[c].sizeOriginal = obj.columns[c].size;
                    obj.columns[c].size = obj.columns[c].sizeCalculated;
                }
                let edata = obj.trigger('columnResize', {
                    target: obj.name,
                    resizeBy: 0,
                    originalEvent: event1,
                    column: obj.last.tmp.col,
                    field: obj.columns[obj.last.tmp.col].field
                });
                // set move event
                let timer;
                let mouseMove = function(event1) {
                    if (obj.last.colResizing != true) return;
                    if (!event1) event1 = window.event;
                    // event before
                    let edata2 = obj.trigger('columnResizeMove', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(edata.detail, {
                        resizeBy: event1.screenX - obj.last.tmp.gx,
                        originalEvent: event1
                    }));
                    if (edata2.isCancelled === true) return;
                    // default action
                    obj.last.tmp.x = event1.screenX - obj.last.tmp.x;
                    obj.last.tmp.y = event1.screenY - obj.last.tmp.y;
                    let newWidth = parseInt(obj.columns[obj.last.tmp.col].size) + obj.last.tmp.x + 'px';
                    obj.columns[obj.last.tmp.col].size = newWidth;
                    if (timer) clearTimeout(timer);
                    timer = setTimeout(()=>{
                        obj.resizeRecords();
                        obj.scroll();
                    }, 100);
                    // quick resize
                    obj.last.tmp.tds.css({
                        width: newWidth
                    });
                    // reset
                    obj.last.tmp.x = event1.screenX;
                    obj.last.tmp.y = event1.screenY;
                    // event after
                    edata2.finish();
                };
                let mouseUp = function(event1) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('.grid-col-resize');
                    obj.resizeRecords();
                    obj.scroll();
                    // event after
                    edata.finish({
                        originalEvent: event1
                    });
                    // need timeout to finish processing events
                    setTimeout(()=>{
                        obj.last.colResizing = false;
                    }, 1);
                };
                $aa2bd8933167d9cb$export$2fa187e846a241c4(document).off('.grid-col-resize').on('mousemove.grid-col-resize', mouseMove).on('mouseup.grid-col-resize', mouseUp);
            }).on('dblclick.grid-col-resize', function(event1) {
                let ind = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(this).attr('name'));
                obj.columnAutoSize(ind);
                // prevent default
                event1.stopPropagation();
                event1.preventDefault();
            }).each((el)=>{
                let td = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).get(0).parentNode;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css({
                    'height': td.clientHeight + 'px',
                    'margin-left': td.clientWidth - 3 + 'px'
                });
            });
        }
        resizeBoxes() {
            // elements
            let header = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_header`);
            let toolbar = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_toolbar`);
            let fsummary = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_fsummary`);
            let summary = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_summary`);
            let footer = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_footer`);
            let body = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_body`);
            if (this.show.header) header.css({
                top: '0px',
                left: '0px',
                right: '0px'
            });
            if (this.show.toolbar) toolbar.css({
                top: 0 + (this.show.header ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(header, 'height') : 0) + 'px',
                left: '0px',
                right: '0px'
            });
            if (this.summary.length > 0) {
                fsummary.css({
                    bottom: 0 + (this.show.footer ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(footer, 'height') : 0) + 'px'
                });
                summary.css({
                    bottom: 0 + (this.show.footer ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(footer, 'height') : 0) + 'px',
                    right: '0px'
                });
            }
            if (this.show.footer) footer.css({
                bottom: '0px',
                left: '0px',
                right: '0px'
            });
            body.css({
                top: 0 + (this.show.header ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(header, 'height') : 0) + (this.show.toolbar ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(toolbar, 'height') : 0) + 'px',
                bottom: 0 + (this.show.footer ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(footer, 'height') : 0) + (this.summary.length > 0 ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(summary, 'height') : 0) + 'px',
                left: '0px',
                right: '0px'
            });
        }
        resizeRecords() {
            let obj = this;
            // remove empty records
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-empty-record').remove();
            // -- Calculate Column size in PX
            let box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box);
            let grid = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div.w2ui-grid-box');
            let header = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_header`);
            let toolbar = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_toolbar`);
            let summary = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_summary`);
            let fsummary = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_fsummary`);
            let footer = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_footer`);
            let body = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_body`);
            let columns = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_columns`);
            let fcolumns = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_fcolumns`);
            let records = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_records`);
            let frecords = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_frecords`);
            let scroll1 = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_scroll1`);
            let lineNumberWidth = String(this.total).length * 8 + 10;
            if (lineNumberWidth < 34) lineNumberWidth = 34 // 3 digit width
            ;
            if (this.lineNumberWidth != null) lineNumberWidth = this.lineNumberWidth;
            let bodyOverflowX = false;
            let bodyOverflowY = false;
            let sWidth = 0;
            for(let i = 0; i < this.columns.length; i++){
                if (this.columns[i].frozen || this.columns[i].hidden) continue;
                let cSize = parseInt(this.columns[i].sizeCalculated ? this.columns[i].sizeCalculated : this.columns[i].size);
                sWidth += cSize;
            }
            if (records[0]?.clientWidth < sWidth) bodyOverflowX = true;
            if (body[0]?.clientHeight - (columns[0]?.clientHeight ?? 0) < ($aa2bd8933167d9cb$export$2fa187e846a241c4(records).find(':scope > table')[0]?.clientHeight ?? 0) + (bodyOverflowX ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() : 0)) bodyOverflowY = true;
            // body might be expanded by data
            if (!this.fixedBody) {
                // allow it to render records, then resize
                let bodyHeight = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(columns, 'height') + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_records table'), 'height') + (bodyOverflowX ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() : 0);
                let calculatedHeight = bodyHeight + (this.show.header ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(header, 'height') : 0) + (this.show.toolbar ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(toolbar, 'height') : 0) + (summary.css('display') != 'none' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(summary, 'height') : 0) + (this.show.footer ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(footer, 'height') : 0);
                grid.css('height', calculatedHeight + 'px');
                body.css('height', bodyHeight + 'px');
                box.css('height', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(grid, 'height') + 'px');
            } else {
                // fixed body height
                let calculatedHeight = grid[0]?.clientHeight - (this.show.header ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(header, 'height') : 0) - (this.show.toolbar ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(toolbar, 'height') : 0) - (summary.css('display') != 'none' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(summary, 'height') : 0) - (this.show.footer ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(footer, 'height') : 0);
                body.css('height', calculatedHeight + 'px');
            }
            let buffered = this.records.length;
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            if (this.searchData.length != 0 && !url) buffered = this.last.searchIds.length;
            // apply overflow
            if (!this.fixedBody) bodyOverflowY = false;
            if (bodyOverflowX || bodyOverflowY) {
                columns.find(':scope > table > tbody > tr:nth-child(1) td.w2ui-head-last').css('width', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() + 'px').show();
                records.css({
                    top: (this.columnGroups.length > 0 && this.show.columns ? 1 : 0) + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(columns, 'height') + 'px',
                    '-webkit-overflow-scrolling': 'touch',
                    'overflow-x': bodyOverflowX ? 'auto' : 'hidden',
                    'overflow-y': bodyOverflowY ? 'auto' : 'hidden'
                });
            } else {
                columns.find(':scope > table > tbody > tr:nth-child(1) td.w2ui-head-last').hide();
                records.css({
                    top: (this.columnGroups.length > 0 && this.show.columns ? 1 : 0) + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(columns, 'height') + 'px',
                    overflow: 'hidden'
                });
                if (records.length > 0) {
                    this.last.vscroll.scrollTop = 0;
                    this.last.vscroll.scrollLeft = 0;
                } // if no scrollbars, always show top
            }
            if (bodyOverflowX) {
                frecords.css('margin-bottom', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() + 'px');
                scroll1.show();
            } else {
                frecords.css('margin-bottom', 0);
                scroll1.hide();
            }
            frecords.css({
                overflow: 'hidden',
                top: records.css('top')
            });
            if (this.show.emptyRecords && !bodyOverflowY) {
                let max = Math.floor((records[0]?.clientHeight ?? 0) / this.recordHeight) - 1;
                let leftover = 0;
                if (records[0]) leftover = records[0].scrollHeight - max * this.recordHeight;
                if (leftover >= this.recordHeight) {
                    leftover -= this.recordHeight;
                    max++;
                }
                if (this.fixedBody) {
                    for(let di = buffered; di < max; di++)addEmptyRow(di, this.recordHeight, this);
                    addEmptyRow(max, leftover, this);
                }
            }
            function addEmptyRow(row, height, grid) {
                let html1 = '';
                let html2 = '';
                let htmlp = '';
                html1 += '<tr class="' + (row % 2 ? 'w2ui-even' : 'w2ui-odd') + ' w2ui-empty-record" recid="-none-" style="height: ' + height + 'px">';
                html2 += '<tr class="' + (row % 2 ? 'w2ui-even' : 'w2ui-odd') + ' w2ui-empty-record" recid="-none-" style="height: ' + height + 'px">';
                if (grid.show.lineNumbers) html1 += '<td class="w2ui-col-number"></td>';
                if (grid.show.selectColumn) html1 += '<td class="w2ui-grid-data w2ui-col-select"></td>';
                if (grid.show.expandColumn) html1 += '<td class="w2ui-grid-data w2ui-col-expand"></td>';
                html2 += '<td class="w2ui-grid-data-spacer" col="start" style="border-right: 0"></td>';
                if (grid.reorderRows) html2 += '<td class="w2ui-grid-data w2ui-col-order" col="order"></td>';
                for(let j = 0; j < grid.columns.length; j++){
                    let col = grid.columns[j];
                    if ((col.hidden || j < grid.last.vscroll.colIndStart || j > grid.last.vscroll.colIndEnd) && !col.frozen) continue;
                    htmlp = '<td class="w2ui-grid-data" ' + (col.attr != null ? col.attr : '') + ' col="' + j + '"></td>';
                    if (col.frozen) html1 += htmlp;
                    else html2 += htmlp;
                }
                html1 += '<td class="w2ui-grid-data-last"></td> </tr>';
                html2 += '<td class="w2ui-grid-data-last" col="end"></td> </tr>';
                $aa2bd8933167d9cb$export$2fa187e846a241c4(grid.box).find('#grid_' + grid.name + '_frecords > table').append(html1);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(grid.box).find('#grid_' + grid.name + '_records > table').append(html2);
            }
            let width_box, percent;
            if (body.length > 0) {
                let width_max = parseInt(body[0].clientWidth) - (bodyOverflowY ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() : 0) - (this.show.lineNumbers ? lineNumberWidth : 0) - (this.reorderRows ? 26 : 0) - (this.show.selectColumn ? 26 : 0) - (this.show.expandColumn ? 26 : 0) - 1 // left is 1px due to border width
                ;
                width_box = width_max;
                percent = 0;
                // gridMinWidth processing
                let restart = false;
                for(let i = 0; i < this.columns.length; i++){
                    let col = this.columns[i];
                    if (col.gridMinWidth > 0) {
                        if (col.gridMinWidth > width_box && col.hidden !== true) {
                            col.hidden = true;
                            restart = true;
                        }
                        if (col.gridMinWidth < width_box && col.hidden === true) {
                            col.hidden = false;
                            restart = true;
                        }
                    }
                }
                if (restart === true) {
                    this.refresh();
                    return;
                }
                // assign PX column s
                for(let i = 0; i < this.columns.length; i++){
                    let col = this.columns[i];
                    if (col.hidden) continue;
                    if (String(col.size).substr(String(col.size).length - 2).toLowerCase() == 'px') {
                        width_max -= parseFloat(col.size);
                        this.columns[i].sizeCalculated = col.size;
                        this.columns[i].sizeType = 'px';
                    } else {
                        percent += parseFloat(col.size);
                        this.columns[i].sizeType = '%';
                        delete col.sizeCorrected;
                    }
                }
                // if sum != 100% -- reassign proportionally
                if (percent != 100 && percent > 0) for(let i = 0; i < this.columns.length; i++){
                    let col = this.columns[i];
                    if (col.hidden) continue;
                    if (col.sizeType == '%') col.sizeCorrected = Math.round(parseFloat(col.size) * 10000 / percent) / 100 + '%';
                }
                // calculate % columns
                for(let i = 0; i < this.columns.length; i++){
                    let col = this.columns[i];
                    if (col.hidden) continue;
                    if (col.sizeType == '%') {
                        if (this.columns[i].sizeCorrected != null) this.columns[i].sizeCalculated = Math.floor(width_max * parseFloat(col.sizeCorrected) / 100) - 1 + 'px';
                        else this.columns[i].sizeCalculated = Math.floor(width_max * parseFloat(col.size) / 100) - 1 + 'px';
                    }
                }
            }
            // fix margin of error that is due percentage calculations
            let width_cols = 0;
            for(let i = 0; i < this.columns.length; i++){
                let col = this.columns[i];
                if (col.hidden) continue;
                if (col.min == null) col.min = 20;
                if (parseInt(col.sizeCalculated) < parseInt(col.min)) col.sizeCalculated = col.min + 'px';
                if (parseInt(col.sizeCalculated) > parseInt(col.max)) col.sizeCalculated = col.max + 'px';
                width_cols += parseInt(col.sizeCalculated);
            }
            let width_diff = parseInt(width_box) - parseInt(width_cols);
            if (width_diff > 0 && percent > 0) {
                let i = 0;
                while(true){
                    let col = this.columns[i];
                    if (col == null) {
                        i = 0;
                        continue;
                    }
                    if (col.hidden || col.sizeType == 'px') {
                        i++;
                        continue;
                    }
                    col.sizeCalculated = parseInt(col.sizeCalculated) + 1 + 'px';
                    width_diff--;
                    if (width_diff === 0) break;
                    i++;
                }
            } else if (width_diff > 0) columns.find(':scope > table > tbody > tr:nth-child(1) td.w2ui-head-last').css('width', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() + 'px').show();
            // find width of frozen columns
            let fwidth = 1;
            if (this.show.lineNumbers) fwidth += lineNumberWidth;
            if (this.show.selectColumn) fwidth += 26;
            // if (this.reorderRows) fwidth += 26;
            if (this.show.expandColumn) fwidth += 26;
            for(let i = 0; i < this.columns.length; i++){
                if (this.columns[i].hidden) continue;
                if (this.columns[i].frozen) fwidth += parseInt(this.columns[i].sizeCalculated);
            }
            fcolumns.css('width', fwidth + 'px');
            frecords.css('width', fwidth + 'px');
            fsummary.css('width', fwidth + 'px');
            scroll1.css('width', fwidth + 'px');
            /**
         * 0.5 is needed due to imperfection of table layout. There was a very small shift between right border of the column headers
         * and records. I checked it had exact same offset, but still felt like 1px off. This adjustment fixes it.
         */ columns.css('left', fwidth + 0.5 + 'px');
            records.css('left', fwidth + 'px');
            summary.css('left', fwidth + 'px');
            // resize columns
            columns.find(':scope > table > tbody > tr:nth-child(1) td').add(fcolumns.find(':scope > table > tbody > tr:nth-child(1) td')).each((el)=>{
                // line numbers
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(el).hasClass('w2ui-col-number')) $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', lineNumberWidth + 'px');
                // records
                let ind = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).attr('col');
                if (ind != null) {
                    if (ind == 'start') {
                        let width = 0;
                        for(let i = 0; i < obj.last.vscroll.colIndStart; i++){
                            if (!obj.columns[i] || obj.columns[i].frozen || obj.columns[i].hidden) continue;
                            width += parseInt(obj.columns[i].sizeCalculated);
                        }
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', width + 'px');
                    }
                    if (obj.columns[ind]) $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', obj.columns[ind].sizeCalculated) // already has px
                    ;
                }
                // last column
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(el).hasClass('w2ui-head-last')) {
                    if (obj.last.vscroll.colIndEnd + 1 < obj.columns.length) {
                        let width = 0;
                        for(let i = obj.last.vscroll.colIndEnd + 1; i < obj.columns.length; i++){
                            if (!obj.columns[i] || obj.columns[i].frozen || obj.columns[i].hidden) continue;
                            width += parseInt(obj.columns[i].sizeCalculated);
                        }
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', width + 'px');
                    } else $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() + (width_diff > 0 && percent === 0 ? width_diff : 0) + 'px');
                }
            });
            // if there are column groups - hide first row (needed for sizing)
            if (columns.find(':scope > table > tbody > tr').length == 3) columns.find(':scope > table > tbody > tr:nth-child(1) td').add(fcolumns.find(':scope > table > tbody > tr:nth-child(1) td')).html('').css({
                'height': '0',
                'border': '0',
                'padding': '0',
                'margin': '0'
            });
            // resize records
            records.find(':scope > table > tbody > tr:nth-child(1) td').add(frecords.find(':scope > table > tbody > tr:nth-child(1) td')).each((el)=>{
                // line numbers
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(el).hasClass('w2ui-col-number')) $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', lineNumberWidth + 'px');
                // records
                let ind = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).attr('col');
                if (ind != null) {
                    if (ind == 'start') {
                        let width = 0;
                        for(let i = 0; i < obj.last.vscroll.colIndStart; i++){
                            if (!obj.columns[i] || obj.columns[i].frozen || obj.columns[i].hidden) continue;
                            width += parseInt(obj.columns[i].sizeCalculated);
                        }
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', width + 'px');
                    }
                    if (obj.columns[ind]) $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', obj.columns[ind].sizeCalculated);
                }
                // last column
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(el).hasClass('w2ui-grid-data-last') && $aa2bd8933167d9cb$export$2fa187e846a241c4(el).parents('.w2ui-grid-frecords').length === 0) {
                    if (obj.last.vscroll.colIndEnd + 1 < obj.columns.length) {
                        let width = 0;
                        for(let i = obj.last.vscroll.colIndEnd + 1; i < obj.columns.length; i++){
                            if (!obj.columns[i] || obj.columns[i].frozen || obj.columns[i].hidden) continue;
                            width += parseInt(obj.columns[i].sizeCalculated);
                        }
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', width + 'px');
                    } else $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', (width_diff > 0 && percent === 0 ? width_diff : 0) + 'px');
                }
            });
            // resize summary
            summary.find(':scope > table > tbody > tr:nth-child(1) td').add(fsummary.find(':scope > table > tbody > tr:nth-child(1) td')).each((el)=>{
                // line numbers
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(el).hasClass('w2ui-col-number')) $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', lineNumberWidth + 'px');
                // records
                let ind = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).attr('col');
                if (ind != null) {
                    if (ind == 'start') {
                        let width = 0;
                        for(let i = 0; i < obj.last.vscroll.colIndStart; i++){
                            if (!obj.columns[i] || obj.columns[i].frozen || obj.columns[i].hidden) continue;
                            width += parseInt(obj.columns[i].sizeCalculated);
                        }
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', width + 'px');
                    }
                    if (obj.columns[ind]) $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', obj.columns[ind].sizeCalculated);
                }
                // last column
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(el).hasClass('w2ui-grid-data-last') && $aa2bd8933167d9cb$export$2fa187e846a241c4(el).parents('.w2ui-grid-frecords').length === 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(el).css('width', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.scrollBarSize() + (width_diff > 0 && percent === 0 ? width_diff : 0) + 'px');
            });
            this.initResize();
            this.refreshRanges();
            // apply last scroll if any
            if ((this.last.vscroll.scrollTop || this.last.vscroll.scrollLeft) && records.length > 0) {
                columns.prop('scrollLeft', this.last.vscroll.scrollLeft);
                records.prop('scrollTop', this.last.vscroll.scrollTop);
                records.prop('scrollLeft', this.last.vscroll.scrollLeft);
            }
            // Improved performance when scrolling through tables
            columns.css('will-change', 'scroll-position');
        }
        getSearchesHTML() {
            let html = `
            <div class="search-title">
                ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Advanced Search')}
                <span class="search-logic" style="${this.show.searchLogic ? '' : 'display: none'}">
                    <select id="grid_${this.name}_logic" class="w2ui-input">
                        <option value="AND" ${this.last.logic == 'AND' ? 'selected' : ''}>${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('All')}</option>
                        <option value="OR" ${this.last.logic == 'OR' ? 'selected' : ''}>${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Any')}</option>
                    </select>
                </span>
            </div>
            <table cellspacing="0"><tbody>
        `;
            for(let i = 0; i < this.searches.length; i++){
                let s = this.searches[i];
                s.type = String(s.type).toLowerCase();
                if (s.hidden) continue;
                if (s.attr == null) s.attr = '';
                if (s.text == null) s.text = '';
                if (s.style == null) s.style = '';
                if (s.type == null) s.type = 'text';
                if (s.label == null && s.caption != null) {
                    console.log('NOTICE: grid search.caption property is deprecated, please use search.label. Search ->', s);
                    s.label = s.caption;
                }
                let operator = `<select id="grid_${this.name}_operator_${i}" class="w2ui-input" data-change="initOperator|${i}">
                    ${this.getOperators(s.type, s.operators)}
                </select>`;
                html += `<tr>
                        <td class="caption">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(s.label ?? s.field) || ''}</td>
                        <td class="operator">${operator}</td>
                        <td class="value">`;
                let tmpStyle;
                switch(s.type){
                    case 'text':
                    case 'alphanumeric':
                    case 'hex':
                    case 'color':
                    case 'list':
                    case 'combo':
                    case 'enum':
                        tmpStyle = 'width: 250px;';
                        if ([
                            'hex',
                            'color'
                        ].indexOf(s.type) != -1) tmpStyle = 'width: 90px;';
                        html += `<input rel="search" type="text" id="grid_${this.name}_field_${i}" name="${s.field}"
                               class="w2ui-input" style="${tmpStyle + s.style}" ${s.attr}>`;
                        break;
                    case 'int':
                    case 'float':
                    case 'money':
                    case 'currency':
                    case 'percent':
                    case 'date':
                    case 'time':
                    case 'datetime':
                        tmpStyle = 'width: 90px;';
                        if (s.type == 'datetime') tmpStyle = 'width: 140px;';
                        html += `<input id="grid_${this.name}_field_${i}" name="${s.field}" ${s.attr} rel="search" type="text"
                                class="w2ui-input" style="${tmpStyle + s.style}">
                            <span id="grid_${this.name}_range_${i}" style="display: none">&#160;-&#160;&#160;
                                <input rel="search" type="text" class="w2ui-input" style="${tmpStyle + s.style}" id="grid_${this.name}_field2_${i}" name="${s.field}" ${s.attr}>
                            </span>`;
                        break;
                    case 'select':
                        html += `<select rel="search" class="w2ui-input" style="${s.style}" id="grid_${this.name}_field_${i}"
                                name="${s.field}" ${s.attr}></select>`;
                        break;
                }
                html += s.text + '    </td>' + '</tr>';
            }
            html += `<tr>
            <td colspan="2" class="actions">
                <button type="button" class="w2ui-btn close-btn" data-click="searchClose">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Close')}</button>
            </td>
            <td class="actions">
                <button type="button" class="w2ui-btn" data-click="searchReset">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Reset')}</button>
                <button type="button" class="w2ui-btn w2ui-btn-blue" data-click="search">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Search')}</button>
            </td>
        </tr></tbody></table>`;
            return html;
        }
        getOperators(type, opers) {
            let operators = this.operators[this.operatorsMap[type]] || [];
            if (opers != null && Array.isArray(opers)) operators = opers;
            let html = '';
            operators.forEach((oper)=>{
                let displayText = oper;
                let operValue = oper;
                if (Array.isArray(oper)) {
                    displayText = oper[1];
                    operValue = oper[0];
                } else if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(oper)) {
                    displayText = oper.text;
                    operValue = oper.oper;
                }
                if (displayText == null) displayText = oper;
                html += `<option name="11" value="${operValue}">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(displayText)}</option>\n`;
            });
            return html;
        }
        initOperator(ind) {
            let options;
            let search = this.searches[ind];
            let sdata = this.getSearchData(search.field);
            let overlay = $aa2bd8933167d9cb$export$2fa187e846a241c4(`#w2overlay-${this.name}-search-overlay`);
            let $rng = overlay.find(`#grid_${this.name}_range_${ind}`);
            let $fld1 = overlay.find(`#grid_${this.name}_field_${ind}`);
            let $fld2 = overlay.find(`#grid_${this.name}_field2_${ind}`);
            let $oper = overlay.find(`#grid_${this.name}_operator_${ind}`);
            let oper = $oper.val();
            $fld1.show();
            $rng.hide();
            // init based on operator value
            switch(oper){
                case 'between':
                    $rng.css('display', 'inline');
                    break;
                case 'null':
                case 'not null':
                    $fld1.hide();
                    $fld1.val(oper) // need to insert something for search to activate
                    ;
                    $fld1.trigger('change');
                    break;
            }
            // init based on search type
            switch(search.type){
                case 'text':
                case 'alphanumeric':
                    let fld = $fld1[0]._w2field;
                    if (fld) fld.reset();
                    break;
                case 'int':
                case 'float':
                case 'hex':
                case 'color':
                case 'money':
                case 'currency':
                case 'percent':
                case 'date':
                case 'time':
                case 'datetime':
                    if (!$fld1[0]._w2field) {
                        // init fields
                        new $aa2bd8933167d9cb$export$b011ec2f2c6bab8b(search.type, {
                            el: $fld1[0],
                            ...search.options
                        });
                        new $aa2bd8933167d9cb$export$b011ec2f2c6bab8b(search.type, {
                            el: $fld2[0],
                            ...search.options
                        });
                        setTimeout(()=>{
                            $fld1.trigger('keydown');
                            $fld2.trigger('keydown');
                        }, 1);
                    }
                    break;
                case 'list':
                case 'combo':
                case 'enum':
                    options = search.options;
                    if (search.type == 'list') options.selected = {};
                    if (search.type == 'enum') options.selected = [];
                    if (sdata) options.selected = sdata.value;
                    if (!$fld1[0]._w2field) {
                        let fld = new $aa2bd8933167d9cb$export$b011ec2f2c6bab8b(search.type, {
                            el: $fld1[0],
                            ...options
                        });
                        if (sdata && sdata.text != null) fld.set({
                            id: sdata.value,
                            text: sdata.text
                        });
                    }
                    break;
                case 'select':
                    // build options
                    options = '<option value="">--</option>';
                    for(let i = 0; i < search.options.items.length; i++){
                        let si = search.options.items[i];
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(search.options.items[i])) {
                            let val = si.id;
                            let txt = si.text;
                            if (val == null && si.value != null) val = si.value;
                            if (txt == null && si.text != null) txt = si.text;
                            if (val == null) val = '';
                            options += '<option value="' + val + '">' + txt + '</option>';
                        } else options += '<option value="' + si + '">' + si + '</option>';
                    }
                    $fld1.html(options);
                    break;
            }
        }
        initSearches() {
            let overlay = $aa2bd8933167d9cb$export$2fa187e846a241c4(`#w2overlay-${this.name}-search-overlay`);
            // init searches
            for(let ind = 0; ind < this.searches.length; ind++){
                let search = this.searches[ind];
                let sdata = this.getSearchData(search.field);
                search.type = String(search.type).toLowerCase();
                if (typeof search.options != 'object') search.options = {};
                // operators
                let operator = search.operator;
                let operators = [
                    ...this.operators[this.operatorsMap[search.type]]
                ] // need a copy
                ;
                if (search.operators) operators = search.operators;
                // normalize
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(operator)) operator = operator.oper;
                operators.forEach((oper, ind)=>{
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(oper)) operators[ind] = oper.oper;
                });
                if (sdata && sdata.operator) operator = sdata.operator;
                // default operator
                let def = this.defaultOperator[this.operatorsMap[search.type]];
                if (operators.indexOf(operator) == -1) operator = def;
                overlay.find(`#grid_${this.name}_operator_${ind}`).val(operator);
                this.initOperator(ind);
                // populate field value
                let $fld1 = overlay.find(`#grid_${this.name}_field_${ind}`);
                let $fld2 = overlay.find(`#grid_${this.name}_field2_${ind}`);
                if (sdata != null) {
                    if (!Array.isArray(sdata.value)) {
                        if (sdata.value != null) $fld1.val(sdata.value).trigger('change');
                    } else if ([
                        'in',
                        'not in'
                    ].includes(sdata.operator)) $fld1[0]._w2field.set(sdata.value);
                    else {
                        $fld1.val(sdata.value[0]).trigger('change');
                        $fld2.val(sdata.value[1]).trigger('change');
                    }
                }
            }
            // add on change event
            overlay.find('.w2ui-grid-search-advanced *[rel=search]').on('keypress', (evnt)=>{
                if (evnt.keyCode == 13) {
                    this.search();
                    $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-search-overlay');
                }
            });
        }
        getColumnsHTML() {
            let self1 = this;
            let html1 = '';
            let html2 = '';
            if (this.show.columnHeaders) {
                if (this.columnGroups.length > 0) {
                    let tmp1 = getColumns(true);
                    let tmp2 = getGroups();
                    let tmp3 = getColumns(false);
                    html1 = tmp1[0] + tmp2[0] + tmp3[0];
                    html2 = tmp1[1] + tmp2[1] + tmp3[1];
                } else {
                    let tmp = getColumns(true);
                    html1 = tmp[0];
                    html2 = tmp[1];
                }
            }
            return [
                html1,
                html2
            ];
            function getGroups() {
                let html1 = '<tr>';
                let html2 = '<tr>';
                let tmpf = '';
                // add empty group at the end
                let tmp = self1.columnGroups.length - 1;
                if (self1.columnGroups[tmp].text == null && self1.columnGroups[tmp].caption != null) {
                    console.log('NOTICE: grid columnGroup.caption property is deprecated, please use columnGroup.text. Group -> ', self1.columnGroups[tmp]);
                    self1.columnGroups[tmp].text = self1.columnGroups[tmp].caption;
                }
                if (self1.columnGroups[self1.columnGroups.length - 1].text != '') self1.columnGroups.push({
                    text: ''
                });
                if (self1.show.lineNumbers) html1 += '<td class="w2ui-head w2ui-col-number" col="line-number">    <div>&#160;</div></td>';
                if (self1.show.selectColumn) html1 += '<td class="w2ui-head w2ui-col-select" col="select">    <div style="height: 25px">&#160;</div></td>';
                if (self1.show.expandColumn) html1 += '<td class="w2ui-head w2ui-col-expand" col="expand">    <div style="height: 25px">&#160;</div></td>';
                let ii = 0;
                html2 += `<td id="grid_${self1.name}_column_start" class="w2ui-head" col="start" style="border-right: 0"></td>`;
                if (self1.reorderRows) html2 += '<td class="w2ui-head w2ui-col-order" col="order">    <div style="height: 25px">&#160;</div></td>';
                for(let i = 0; i < self1.columnGroups.length; i++){
                    let colg = self1.columnGroups[i];
                    let col = self1.columns[ii] || {};
                    if (colg.colspan != null) colg.span = colg.colspan;
                    if (colg.span == null || colg.span != parseInt(colg.span)) colg.span = 1;
                    if (col.text == null && col.caption != null) {
                        console.log('NOTICE: grid column.caption property is deprecated, please use column.text. Column ->', col);
                        col.text = col.caption;
                    }
                    let colspan = 0;
                    for(let jj = ii; jj < ii + colg.span; jj++)if (self1.columns[jj] && !self1.columns[jj].hidden) colspan++;
                    if (i == self1.columnGroups.length - 1) colspan = 100 // last column
                    ;
                    if (colspan <= 0) ;
                    else if (colg.main === true) {
                        let sortStyle = '';
                        for(let si = 0; si < self1.sortData.length; si++)if (self1.sortData[si].field == col.field) {
                            if ((self1.sortData[si].direction || '').toLowerCase() === 'asc') sortStyle = 'w2ui-sort-up';
                            if ((self1.sortData[si].direction || '').toLowerCase() === 'desc') sortStyle = 'w2ui-sort-down';
                        }
                        let resizer = '';
                        if (col.resizable !== false) resizer = `<div class="w2ui-resizer" name="${ii}"></div>`;
                        let text = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(typeof col.text == 'function' ? col.text(col) : col.text);
                        tmpf = `<td id="grid_${self1.name}_column_${ii}" class="w2ui-head ${sortStyle}" col="${ii}" ` + `    rowspan="2" colspan="${colspan}">` + resizer + `    <div class="w2ui-col-group w2ui-col-header ${sortStyle ? 'w2ui-col-sorted' : ''}">` + `        <div class="${sortStyle}"></div>` + (!text ? '&#160;' : text) + '    </div>' + '</td>';
                        if (col && col.frozen) html1 += tmpf;
                        else html2 += tmpf;
                    } else {
                        let gText = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(typeof colg.text == 'function' ? colg.text(colg) : colg.text);
                        tmpf = `<td id="grid_${self1.name}_column_${ii}" class="w2ui-head" col="${ii}" colspan="${colspan}">` + `    <div class="w2ui-col-group" style="${colg.style ?? ''}">${!gText ? '&#160;' : gText}</div>` + '</td>';
                        if (col && col.frozen) html1 += tmpf;
                        else html2 += tmpf;
                    }
                    ii += colg.span;
                }
                html1 += '<td></td></tr>' // need empty column for border-right
                ;
                html2 += `<td id="grid_${self1.name}_column_end" class="w2ui-head" col="end"></td></tr>`;
                return [
                    html1,
                    html2
                ];
            }
            function getColumns(main) {
                let html1 = '<tr>';
                let html2 = '<tr>';
                if (self1.show.lineNumbers) html1 += '<td class="w2ui-head w2ui-col-number" col="line-number">    <div>#</div></td>';
                if (self1.show.selectColumn) html1 += '<td class="w2ui-head w2ui-col-select" col="select">    <div>' + `        <input type="checkbox" id="grid_${self1.name}_check_all" class="w2ui-select-all" tabindex="-1"` + `            style="${self1.multiSelect == false ? 'display: none;' : ''}"` + '        >' + '    </div>' + '</td>';
                if (self1.show.expandColumn) html1 += '<td class="w2ui-head w2ui-col-expand" col="expand">    <div>&#160;</div></td>';
                let ii = 0;
                let id = 0;
                let colg;
                html2 += `<td id="grid_${self1.name}_column_start" class="w2ui-head" col="start" style="border-right: 0"></td>`;
                if (self1.reorderRows) html2 += '<td class="w2ui-head w2ui-col-order" col="order">    <div>&#160;</div></td>';
                for(let i = 0; i < self1.columns.length; i++){
                    let col = self1.columns[i];
                    if (col.text == null && col.caption != null) {
                        console.log('NOTICE: grid column.caption property is deprecated, please use column.text. Column -> ', col);
                        col.text = col.caption;
                    }
                    if (col.size == null) col.size = '100%';
                    if (i == id) {
                        colg = self1.columnGroups[ii++] || {};
                        id = id + colg.span;
                    }
                    if ((i < self1.last.vscroll.colIndStart || i > self1.last.vscroll.colIndEnd) && !col.frozen) continue;
                    if (col.hidden) continue;
                    if (colg.main !== true || main) {
                        let colCellHTML = self1.getColumnCellHTML(i);
                        if (col && col.frozen) html1 += colCellHTML;
                        else html2 += colCellHTML;
                    }
                }
                html1 += '<td class="w2ui-head w2ui-head-last"><div>&#160;</div></td>';
                html2 += '<td class="w2ui-head w2ui-head-last" col="end"><div>&#160;</div></td>';
                html1 += '</tr>';
                html2 += '</tr>';
                return [
                    html1,
                    html2
                ];
            }
        }
        getColumnCellHTML(i) {
            let col = this.columns[i];
            if (col == null) return '';
            // reorder style
            let reorderCols = this.reorderColumns && (!this.columnGroups || !this.columnGroups.length) ? ' w2ui-col-reorderable ' : '';
            // sort style
            let sortStyle = '';
            for(let si = 0; si < this.sortData.length; si++)if (this.sortData[si].field == col.field) {
                if ((this.sortData[si].direction || '').toLowerCase() === 'asc') sortStyle = 'w2ui-sort-up';
                if ((this.sortData[si].direction || '').toLowerCase() === 'desc') sortStyle = 'w2ui-sort-down';
            }
            // col selected
            let tmp = this.last.selection.columns;
            let selected = false;
            for(let t in tmp){
                for(let si = 0; si < tmp[t].length; si++)if (tmp[t][si] == i) selected = true;
            }
            let text = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(typeof col.text == 'function' ? col.text(col) : col.text);
            let html = '<td id="grid_' + this.name + '_column_' + i + '" col="' + i + '" class="w2ui-head ' + sortStyle + reorderCols + '">' + (col.resizable !== false ? '<div class="w2ui-resizer" name="' + i + '"></div>' : '') + '    <div class="w2ui-col-header ' + (sortStyle ? 'w2ui-col-sorted' : '') + ' ' + (selected ? 'w2ui-col-selected' : '') + '">' + '        <div class="' + sortStyle + '"></div>' + (!text ? '&#160;' : text) + '    </div>' + '</td>';
            return html;
        }
        columnTooltipShow(ind, event1) {
            let $el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_column_' + ind);
            let item = this.columns[ind];
            let pos = this.columnTooltip;
            $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                name: this.name + '-column-tooltip',
                anchor: $el.get(0),
                html: item?.tooltip,
                position: pos
            });
        }
        columnTooltipHide(ind, event1) {
            $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-column-tooltip');
        }
        getRecordsHTML() {
            let buffered = this.records.length;
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            if (this.searchData.length != 0 && !url) buffered = this.last.searchIds.length;
            // larger number works better with chrome, smaller with FF.
            if (buffered > this.vs_start) this.last.vscroll.show_extra = this.vs_extra;
            else this.last.vscroll.show_extra = this.vs_start;
            let records = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_records`);
            let limit = Math.floor((records.get(0)?.clientHeight || 0) / this.recordHeight) + this.last.vscroll.show_extra + 1;
            if (limit < this.vs_start) limit = this.vs_start;
            if (!this.fixedBody || limit > buffered) limit = buffered;
            // always need first record for resizing purposes
            let rec_html = this.getRecordHTML(-1, 0);
            let html1 = '<table><tbody>' + rec_html[0];
            let html2 = '<table><tbody>' + rec_html[1];
            // first empty row with height
            html1 += '<tr id="grid_' + this.name + '_frec_top" line="top" style="height: ' + 0 + 'px">' + '    <td colspan="2000"></td>' + '</tr>';
            html2 += '<tr id="grid_' + this.name + '_rec_top" line="top" style="height: ' + 0 + 'px">' + '    <td colspan="2000"></td>' + '</tr>';
            for(let i = 0; i < limit; i++){
                rec_html = this.getRecordHTML(i, i + 1);
                html1 += rec_html[0];
                html2 += rec_html[1];
            }
            let h2 = (buffered - limit) * this.recordHeight;
            html1 += '<tr id="grid_' + this.name + '_frec_bottom" rec="bottom" line="bottom" style="height: ' + h2 + 'px; vertical-align: top">' + '    <td colspan="2000" style="border: 0"></td>' + '</tr>' + '<tr id="grid_' + this.name + '_frec_more" style="display: none; ">' + '    <td colspan="2000" class="w2ui-load-more"></td>' + '</tr>' + '</tbody></table>';
            html2 += '<tr id="grid_' + this.name + '_rec_bottom" rec="bottom" line="bottom" style="height: ' + h2 + 'px; vertical-align: top">' + '    <td colspan="2000" style="border: 0"></td>' + '</tr>' + '<tr id="grid_' + this.name + '_rec_more" style="display: none">' + '    <td colspan="2000" class="w2ui-load-more"></td>' + '</tr>' + '</tbody></table>';
            this.last.vscroll.recIndStart = 0;
            this.last.vscroll.recIndEnd = limit;
            return [
                html1,
                html2
            ];
        }
        getSummaryHTML() {
            if (this.summary.length === 0) return;
            let rec_html = this.getRecordHTML(-1, 0) // need this in summary too for colspan to work properly
            ;
            let html1 = '<table><tbody>' + rec_html[0];
            let html2 = '<table><tbody>' + rec_html[1];
            for(let i = 0; i < this.summary.length; i++){
                rec_html = this.getRecordHTML(i, i + 1, true);
                html1 += rec_html[0];
                html2 += rec_html[1];
            }
            html1 += '</tbody></table>';
            html2 += '</tbody></table>';
            return [
                html1,
                html2
            ];
        }
        scroll(event1) {
            let obj = this;
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            let records = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_records`);
            let frecords = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_frecords`);
            // sync scroll positions
            if (event1) {
                let sTop = event1.target.scrollTop;
                let sLeft = event1.target.scrollLeft;
                this.last.vscroll.scrollTop = sTop;
                this.last.vscroll.scrollLeft = sLeft;
                let cols = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_columns`)[0];
                let summary = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_summary`)[0];
                if (cols) cols.scrollLeft = sLeft;
                if (summary) summary.scrollLeft = sLeft;
                if (frecords[0]) frecords[0].scrollTop = sTop;
            }
            // hide bubble
            if (this.last.bubbleEl) {
                $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-bubble');
                this.last.bubbleEl = null;
            }
            // column virtual scroll
            let colStart = null;
            let colEnd = null;
            if (this.disableCVS || this.columnGroups.length > 0) {
                // disable virtual scroll
                colStart = 0;
                colEnd = this.columns.length - 1;
            } else {
                let sWidth = records.prop('clientWidth');
                let cLeft = 0;
                for(let i = 0; i < this.columns.length; i++){
                    if (this.columns[i].frozen || this.columns[i].hidden) continue;
                    let cSize = parseInt(this.columns[i].sizeCalculated ? this.columns[i].sizeCalculated : this.columns[i].size);
                    if (cLeft + cSize + 30 > this.last.vscroll.scrollLeft && colStart == null) colStart = i;
                    if (cLeft + cSize - 30 > this.last.vscroll.scrollLeft + sWidth && colEnd == null) colEnd = i;
                    cLeft += cSize;
                }
                if (colEnd == null) colEnd = this.columns.length - 1;
            }
            if (colStart != null) {
                if (colStart < 0) colStart = 0;
                if (colEnd < 0) colEnd = 0;
                if (colStart == colEnd) {
                    if (colStart > 0) colStart--;
                    else colEnd++ // show at least one column
                    ;
                }
                // ---------
                if (colStart != this.last.vscroll.colIndStart || colEnd != this.last.vscroll.colIndEnd) {
                    let $box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box);
                    let deltaStart = Math.abs(colStart - this.last.vscroll.colIndStart);
                    let deltaEnd = Math.abs(colEnd - this.last.vscroll.colIndEnd);
                    // add/remove columns for small jumps
                    if (deltaStart < 5 && deltaEnd < 5) {
                        let $cfirst = $box.find(`.w2ui-grid-columns #grid_${this.name}_column_start`);
                        let $clast = $box.find('.w2ui-grid-columns .w2ui-head-last');
                        let $rfirst = $box.find(`#grid_${this.name}_records .w2ui-grid-data-spacer`);
                        let $rlast = $box.find(`#grid_${this.name}_records .w2ui-grid-data-last`);
                        let $sfirst = $box.find(`#grid_${this.name}_summary .w2ui-grid-data-spacer`);
                        let $slast = $box.find(`#grid_${this.name}_summary .w2ui-grid-data-last`);
                        // remove on left
                        if (colStart > this.last.vscroll.colIndStart) for(let i = this.last.vscroll.colIndStart; i < colStart; i++){
                            $box.find('#grid_' + this.name + '_columns #grid_' + this.name + '_column_' + i).remove() // column
                            ;
                            $box.find('#grid_' + this.name + '_records td[col="' + i + '"]').remove() // record
                            ;
                            $box.find('#grid_' + this.name + '_summary td[col="' + i + '"]').remove() // summary
                            ;
                        }
                        // remove on right
                        if (colEnd < this.last.vscroll.colIndEnd) for(let i = this.last.vscroll.colIndEnd; i > colEnd; i--){
                            $box.find('#grid_' + this.name + '_columns #grid_' + this.name + '_column_' + i).remove() // column
                            ;
                            $box.find('#grid_' + this.name + '_records td[col="' + i + '"]').remove() // record
                            ;
                            $box.find('#grid_' + this.name + '_summary td[col="' + i + '"]').remove() // summary
                            ;
                        }
                        // add on left
                        if (colStart < this.last.vscroll.colIndStart) for(let i = this.last.vscroll.colIndStart - 1; i >= colStart; i--){
                            if (this.columns[i] && (this.columns[i].frozen || this.columns[i].hidden)) continue;
                            $cfirst.after(this.getColumnCellHTML(i)) // column
                            ;
                            // record
                            $rfirst.each((el)=>{
                                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).parent().attr('index');
                                let td = '<td class="w2ui-grid-data" col="' + i + '" style="height: 0px"></td>' // width column
                                ;
                                if (index != null) td = this.getCellHTML(parseInt(index), i, false);
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(el).after(td);
                            });
                            // summary
                            $sfirst.each((el)=>{
                                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).parent().attr('index');
                                let td = '<td class="w2ui-grid-data" col="' + i + '" style="height: 0px"></td>' // width column
                                ;
                                if (index != null) td = this.getCellHTML(parseInt(index), i, true);
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(el).after(td);
                            });
                        }
                        // add on right
                        if (colEnd > this.last.vscroll.colIndEnd) for(let i = this.last.vscroll.colIndEnd + 1; i <= colEnd; i++){
                            if (this.columns[i] && (this.columns[i].frozen || this.columns[i].hidden)) continue;
                            $clast.before(this.getColumnCellHTML(i)) // column
                            ;
                            // record
                            $rlast.each((el)=>{
                                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).parent().attr('index');
                                let td = '<td class="w2ui-grid-data" col="' + i + '" style="height: 0px"></td>' // width column
                                ;
                                if (index != null) td = this.getCellHTML(parseInt(index), i, false);
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(el).before(td);
                            });
                            // summary
                            $slast.each((el)=>{
                                let index = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).parent().attr('index') || -1;
                                let td = this.getCellHTML(parseInt(index), i, true);
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(el).before(td);
                            });
                        }
                        this.last.vscroll.colIndStart = colStart;
                        this.last.vscroll.colIndEnd = colEnd;
                        this.resizeRecords();
                    } else {
                        this.last.vscroll.colIndStart = colStart;
                        this.last.vscroll.colIndEnd = colEnd;
                        // dot not just call this.refresh();
                        let colHTML = this.getColumnsHTML();
                        let recHTML = this.getRecordsHTML();
                        let sumHTML = this.getSummaryHTML();
                        let $columns = $box.find(`#grid_${this.name}_columns`);
                        let $records = $box.find(`#grid_${this.name}_records`);
                        let $frecords = $box.find(`#grid_${this.name}_frecords`);
                        let $summary = $box.find(`#grid_${this.name}_summary`);
                        $columns.find('tbody').html(colHTML[1]);
                        $frecords.html(recHTML[0]);
                        $records.prepend(recHTML[1]);
                        if (sumHTML != null) $summary.html(sumHTML[1]);
                        // need timeout to clean up (otherwise scroll problem)
                        setTimeout(()=>{
                            $records.find(':scope > table').filter(':not(table:first-child)').remove();
                            if ($summary[0]) $summary[0].scrollLeft = this.last.vscroll.scrollLeft;
                        }, 1);
                        this.resizeRecords();
                    }
                }
            }
            // perform virtual scroll
            let buffered = this.records.length;
            if (buffered > this.total && this.total !== -1) buffered = this.total;
            if (this.searchData.length != 0 && !url) buffered = this.last.searchIds.length;
            if (buffered === 0 || records.length === 0 || records.prop('clientHeight') === 0) return;
            if (buffered > this.vs_start) this.last.vscroll.show_extra = this.vs_extra;
            else this.last.vscroll.show_extra = this.vs_start;
            // update footer
            let t1 = Math.round(records.prop('scrollTop') / this.recordHeight + 1);
            let t2 = t1 + (Math.round(records.prop('clientHeight') / this.recordHeight) - 1);
            if (t1 > buffered) t1 = buffered;
            if (t2 >= buffered - 1) t2 = buffered;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_footer .w2ui-footer-right').html((this.show.statusRange ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(this.offset + t1) + '-' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(this.offset + t2) + (this.total != -1 ? ' ' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('of') + ' <span class="w2ui-total">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(this.total) + '</span>' : '') : '') + (url && this.show.statusBuffered ? ' (' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('buffered') + ' <span class="w2ui-buffered">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(buffered) + '</span>' + (this.offset > 0 ? ', skip <span class="w2ui-skip">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(this.offset) : '') + '</span>)' : ''));
            // only for local data source, else no extra records loaded
            if (!url && (!this.fixedBody || this.total != -1 && this.total <= this.vs_start)) return;
            // regular processing
            let start = Math.floor(records.prop('scrollTop') / this.recordHeight) - this.last.vscroll.show_extra;
            let end = start + Math.floor(records.prop('clientHeight') / this.recordHeight) + this.last.vscroll.show_extra * 2 + 1;
            // let div  = start - this.last.vscroll.recIndStart;
            if (start < 1) start = 1;
            if (end > this.total && this.total != -1) end = this.total;
            let tr1 = records.find('#grid_' + this.name + '_rec_top');
            let tr2 = records.find('#grid_' + this.name + '_rec_bottom');
            let tr1f = frecords.find('#grid_' + this.name + '_frec_top');
            let tr2f = frecords.find('#grid_' + this.name + '_frec_bottom');
            // if row is expanded
            if (String(tr1.next().prop('id')).indexOf('_expanded_row') != -1) {
                tr1.next().remove();
                tr1f.next().remove();
            }
            if (this.total > end && String(tr2.prev().prop('id')).indexOf('_expanded_row') != -1) {
                tr2.prev().remove();
                tr2f.prev().remove();
            }
            let first = parseInt(tr1.next().attr('line'));
            let last = parseInt(tr2.prev().attr('line'));
            let tmp, tmp1, tmp2, rec_start, rec_html;
            if (first <= start || first == 1 || this.last.vscroll.pull_refresh) {
                if (end <= last + this.last.vscroll.show_extra - 2 && end != this.total) return;
                this.last.vscroll.pull_refresh = false;
                // remove from top
                while(true){
                    tmp1 = frecords.find('#grid_' + this.name + '_frec_top').next();
                    tmp2 = records.find('#grid_' + this.name + '_rec_top').next();
                    if (tmp2.attr('line') == 'bottom') break;
                    if (parseInt(tmp2.attr('line')) < start) {
                        tmp1.remove();
                        tmp2.remove();
                    } else break;
                }
                // add at bottom
                tmp = records.find('#grid_' + this.name + '_rec_bottom').prev();
                rec_start = tmp.attr('line');
                if (rec_start == 'top') rec_start = start;
                for(let i = parseInt(rec_start) + 1; i <= end; i++){
                    if (!this.records[i - 1]) continue;
                    tmp2 = this.records[i - 1].w2ui;
                    if (tmp2 && !Array.isArray(tmp2.children)) tmp2.expanded = false;
                    rec_html = this.getRecordHTML(i - 1, i);
                    tr2.before(rec_html[1]);
                    tr2f.before(rec_html[0]);
                }
                markSearch();
                setTimeout(()=>{
                    this.refreshRanges();
                }, 0);
            } else {
                if (start >= first - this.last.vscroll.show_extra + 2 && start > 1) return;
                // remove from bottom
                while(true){
                    tmp1 = frecords.find('#grid_' + this.name + '_frec_bottom').prev();
                    tmp2 = records.find('#grid_' + this.name + '_rec_bottom').prev();
                    if (tmp2.attr('line') == 'top') break;
                    if (parseInt(tmp2.attr('line')) > end) {
                        tmp1.remove();
                        tmp2.remove();
                    } else break;
                }
                // add at top
                tmp = records.find('#grid_' + this.name + '_rec_top').next();
                rec_start = tmp.attr('line');
                if (rec_start == 'bottom') rec_start = end;
                for(let i = parseInt(rec_start) - 1; i >= start; i--){
                    if (!this.records[i - 1]) continue;
                    tmp2 = this.records[i - 1].w2ui;
                    if (tmp2 && !Array.isArray(tmp2.children)) tmp2.expanded = false;
                    rec_html = this.getRecordHTML(i - 1, i);
                    tr1.after(rec_html[1]);
                    tr1f.after(rec_html[0]);
                }
                markSearch();
                setTimeout(()=>{
                    this.refreshRanges();
                }, 0);
            }
            // first/last row size
            let h1 = (start - 1) * this.recordHeight;
            let h2 = (buffered - end) * this.recordHeight;
            if (h2 < 0) h2 = 0;
            tr1.css('height', h1 + 'px');
            tr1f.css('height', h1 + 'px');
            tr2.css('height', h2 + 'px');
            tr2f.css('height', h2 + 'px');
            this.last.vscroll.recIndStart = start;
            this.last.vscroll.recIndEnd = end;
            // load more if needed
            let s = Math.floor(records.prop('scrollTop') / this.recordHeight);
            let e = s + Math.floor(records.prop('clientHeight') / this.recordHeight);
            if (e + 10 > buffered && this.last.vscroll.pull_more !== true && (buffered < this.total - this.offset || this.total == -1 && this.last.fetch.hasMore)) {
                if (this.autoLoad === true) {
                    this.last.vscroll.pull_more = true;
                    this.last.fetch.offset += this.limit;
                    this.request('load');
                }
                // scroll function
                let more = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_rec_more, #grid_' + this.name + '_frec_more');
                more.show().eq(1) // only main table
                .off('.load-more').on('click.load-more', function() {
                    // show spinner
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this).find('td').html('<div><div style="width: 20px; height: 20px;" class="w2ui-spinner"></div></div>');
                    // load more
                    obj.last.vscroll.pull_more = true;
                    obj.last.fetch.offset += obj.limit;
                    obj.request('load');
                }).find('td').html(obj.autoLoad ? '<div><div style="width: 20px; height: 20px;" class="w2ui-spinner"></div></div>' : '<div style="padding-top: 15px">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Load ${count} more...', {
                    count: obj.limit
                }) + '</div>');
            }
            function markSearch() {
                // mark search
                if (!obj.markSearch) return;
                clearTimeout(obj.last.marker_timer);
                obj.last.marker_timer = setTimeout(()=>{
                    // mark all search strings
                    let search = [];
                    for(let s = 0; s < obj.searchData.length; s++){
                        let sdata = obj.searchData[s];
                        let fld = obj.getSearch(sdata.field);
                        if (!fld || fld.hidden) continue;
                        let ind = obj.getColumn(sdata.field, true);
                        search.push({
                            field: sdata.field,
                            search: sdata.value,
                            col: ind
                        });
                    }
                    if (search.length > 0) search.forEach((item)=>{
                        let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(obj.box).find('td[col="' + item.col + '"]:not(.w2ui-head)');
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.marker(el, item.search);
                    });
                }, 50);
            }
        }
        getRecordHTML(ind, lineNum, summary) {
            let tmph = '';
            let rec_html1 = '';
            let rec_html2 = '';
            let sel = this.last.selection;
            let record;
            // first record needs for resize purposes
            if (ind == -1) {
                rec_html1 += '<tr line="0">';
                rec_html2 += '<tr line="0">';
                if (this.show.lineNumbers) rec_html1 += '<td class="w2ui-col-number" style="height: 0px"></td>';
                if (this.show.selectColumn) rec_html1 += '<td class="w2ui-col-select" style="height: 0px"></td>';
                if (this.show.expandColumn) rec_html1 += '<td class="w2ui-col-expand" style="height: 0px"></td>';
                rec_html2 += '<td class="w2ui-grid-data w2ui-grid-data-spacer" col="start" style="height: 0px; width: 0px"></td>';
                if (this.reorderRows) rec_html2 += '<td class="w2ui-col-order" style="height: 0px"></td>';
                for(let i = 0; i < this.columns.length; i++){
                    let col = this.columns[i];
                    tmph = '<td class="w2ui-grid-data" col="' + i + '" style="height: 0px;"></td>';
                    if (col.frozen && !col.hidden) rec_html1 += tmph;
                    else {
                        if (col.hidden || i < this.last.vscroll.colIndStart || i > this.last.vscroll.colIndEnd) continue;
                        rec_html2 += tmph;
                    }
                }
                rec_html1 += '<td class="w2ui-grid-data-last" style="height: 0px"></td>';
                rec_html2 += '<td class="w2ui-grid-data-last" col="end" style="height: 0px"></td>';
                rec_html1 += '</tr>';
                rec_html2 += '</tr>';
                return [
                    rec_html1,
                    rec_html2
                ];
            }
            // regular record
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            if (summary !== true) {
                if (this.searchData.length > 0 && !url) {
                    if (ind >= this.last.searchIds.length) return '';
                    ind = this.last.searchIds[ind];
                    record = this.records[ind];
                } else {
                    if (ind >= this.records.length) return '';
                    record = this.records[ind];
                }
            } else {
                if (ind >= this.summary.length) return '';
                record = this.summary[ind];
            }
            if (!record) return '';
            if (record.recid == null && this.recid != null) {
                let rid = this.parseField(record, this.recid);
                if (rid != null) record.recid = rid;
            }
            let isRowSelected = false;
            if (sel.indexes.indexOf(ind) != -1) isRowSelected = true;
            let rec_style = record.w2ui ? record.w2ui.style : '';
            if (rec_style == null || typeof rec_style != 'string') rec_style = '';
            let rec_class = record.w2ui ? record.w2ui.class : '';
            if (rec_class == null || typeof rec_class != 'string') rec_class = '';
            // render TR
            rec_html1 += '<tr id="grid_' + this.name + '_frec_' + record.recid + '" recid="' + record.recid + '" line="' + lineNum + '" index="' + ind + '" ' + ' class="' + (lineNum % 2 === 0 ? 'w2ui-even' : 'w2ui-odd') + ' w2ui-record ' + rec_class + (isRowSelected && this.selectType == 'row' ? ' w2ui-selected' : '') + (record.w2ui && record.w2ui.editable === false ? ' w2ui-no-edit' : '') + (record.w2ui && record.w2ui.expanded === true ? ' w2ui-expanded' : '') + '" ' + ' style="height: ' + this.recordHeight + 'px; ' + (!isRowSelected && rec_style != '' ? rec_style : rec_style.replace('background-color', 'none')) + '" ' + (rec_style != '' ? 'custom_style="' + rec_style + '"' : '') + '>';
            rec_html2 += '<tr id="grid_' + this.name + '_rec_' + record.recid + '" recid="' + record.recid + '" line="' + lineNum + '" index="' + ind + '" ' + ' class="' + (lineNum % 2 === 0 ? 'w2ui-even' : 'w2ui-odd') + ' w2ui-record ' + rec_class + (isRowSelected && this.selectType == 'row' ? ' w2ui-selected' : '') + (record.w2ui && record.w2ui.editable === false ? ' w2ui-no-edit' : '') + (record.w2ui && record.w2ui.expanded === true ? ' w2ui-expanded' : '') + '" ' + ' style="height: ' + this.recordHeight + 'px; ' + (!isRowSelected && rec_style != '' ? rec_style : rec_style.replace('background-color', 'none')) + '" ' + (rec_style != '' ? 'custom_style="' + rec_style + '"' : '') + '>';
            if (this.show.lineNumbers) rec_html1 += '<td id="grid_' + this.name + '_cell_' + ind + '_number' + (summary ? '_s' : '') + '" ' + '   class="w2ui-col-number ' + (isRowSelected ? ' w2ui-row-selected' : '') + '"' + (this.reorderRows ? ' style="cursor: move"' : '') + '>' + (summary !== true ? this.getLineHTML(lineNum, record) : '') + '</td>';
            if (this.show.selectColumn) rec_html1 += '<td id="grid_' + this.name + '_cell_' + ind + '_select' + (summary ? '_s' : '') + '" class="w2ui-grid-data w2ui-col-select">' + (summary !== true && !(record.w2ui && record.w2ui.hideCheckBox === true) ? '    <div>        <input class="w2ui-grid-select-check" type="checkbox" tabindex="-1" ' + (isRowSelected ? 'checked="checked"' : '') + ' style="pointer-events: none"/>' + '    </div>' : '') + '</td>';
            if (this.show.expandColumn) {
                let tmp_img = '';
                if (record.w2ui?.expanded === true) tmp_img = '-';
                else tmp_img = '+';
                if (record.w2ui?.expanded == 'none' || !Array.isArray(record.w2ui?.children) || !record.w2ui?.children.length) tmp_img = '+';
                if (record.w2ui?.expanded == 'spinner') tmp_img = '<div class="w2ui-spinner" style="width: 16px; margin: -2px 2px;"></div>';
                rec_html1 += '<td id="grid_' + this.name + '_cell_' + ind + '_expand' + (summary ? '_s' : '') + '" class="w2ui-grid-data w2ui-col-expand">' + (summary !== true ? `<div>${tmp_img}</div>` : '') + '</td>';
            }
            // insert empty first column
            rec_html2 += '<td class="w2ui-grid-data-spacer" col="start" style="border-right: 0"></td>';
            if (this.reorderRows) rec_html2 += '<td id="grid_' + this.name + '_cell_' + ind + '_order' + (summary ? '_s' : '') + '" class="w2ui-grid-data w2ui-col-order" col="order">' + (summary !== true ? '<div title="Drag to reorder">&nbsp;</div>' : '') + '</td>';
            let col_ind = 0;
            let col_skip = 0;
            while(true){
                let col_span = 1;
                let col = this.columns[col_ind];
                if (col == null) break;
                if (col.hidden) {
                    col_ind++;
                    if (col_skip > 0) col_skip--;
                    continue;
                }
                if (col_skip > 0) {
                    col_ind++;
                    if (this.columns[col_ind] == null) break;
                    record.w2ui.colspan[this.columns[col_ind - 1].field] = 0 // need it for other methods
                    ;
                    col_skip--;
                    continue;
                } else if (record.w2ui) {
                    let tmp1 = record.w2ui.colspan;
                    let tmp2 = this.columns[col_ind].field;
                    if (tmp1 && tmp1[tmp2] === 0) delete tmp1[tmp2] // if no longer colspan then remove 0
                    ;
                }
                // column virtual scroll
                if ((col_ind < this.last.vscroll.colIndStart || col_ind > this.last.vscroll.colIndEnd) && !col.frozen) {
                    col_ind++;
                    continue;
                }
                if (record.w2ui) {
                    if (typeof record.w2ui.colspan == 'object') {
                        let span = parseInt(record.w2ui.colspan[col.field]) || null;
                        if (span > 1) {
                            // if there are hidden columns, then no colspan on them
                            let hcnt = 0;
                            for(let i = col_ind; i < col_ind + span; i++){
                                if (i >= this.columns.length) break;
                                if (this.columns[i].hidden) hcnt++;
                            }
                            col_span = span - hcnt;
                            col_skip = span - 1;
                        }
                    }
                }
                let rec_cell = this.getCellHTML(ind, col_ind, summary, col_span);
                if (col.frozen) rec_html1 += rec_cell;
                else rec_html2 += rec_cell;
                col_ind++;
            }
            rec_html1 += '<td class="w2ui-grid-data-last"></td>';
            rec_html2 += '<td class="w2ui-grid-data-last" col="end"></td>';
            rec_html1 += '</tr>';
            rec_html2 += '</tr>';
            return [
                rec_html1,
                rec_html2
            ];
        }
        getLineHTML(lineNum) {
            return '<div>' + lineNum + '</div>';
        }
        getCellHTML(ind, col_ind, summary, col_span) {
            let obj = this;
            let col = this.columns[col_ind];
            if (col == null) return '';
            let record = summary !== true ? this.records[ind] : this.summary[ind];
            // value, attr, style, className, divAttr
            let { value: value, style: style, className: className, attr: attr, divAttr: divAttr } = this.getCellValue(ind, col_ind, summary, true);
            let edit = ind !== -1 ? this.getCellEditable(ind, col_ind) : '';
            let divStyle = 'max-height: ' + parseInt(this.recordHeight) + 'px;' + (col.clipboardCopy ? 'margin-right: 20px' : '');
            let isChanged = !summary && record?.w2ui?.changes && record.w2ui.changes[col.field] != null;
            let sel = this.last.selection;
            let isRowSelected = false;
            let infoBubble = '';
            if (sel.indexes.indexOf(ind) != -1) isRowSelected = true;
            if (col_span == null) {
                if (record?.w2ui?.colspan && record.w2ui.colspan[col.field]) col_span = record.w2ui.colspan[col.field];
                else col_span = 1;
            }
            // expand icon
            if (col_ind === 0 && Array.isArray(record?.w2ui?.children)) {
                let level = 0;
                let subrec = this.get(record.w2ui.parent_recid, true);
                while(true){
                    if (subrec != null) {
                        level++;
                        let tmp = this.records[subrec].w2ui;
                        if (tmp != null && tmp.parent_recid != null) subrec = this.get(tmp.parent_recid, true);
                        else break;
                    } else break;
                }
                if (record.w2ui.parent_recid) for(let i = 0; i < level; i++)infoBubble += '<span class="w2ui-show-children w2ui-icon-empty"></span>';
                let className = record.w2ui.children.length > 0 ? record.w2ui.expanded ? 'w2ui-icon-collapse' : 'w2ui-icon-expand' : 'w2ui-icon-empty';
                infoBubble += `<span class="w2ui-show-children ${className}"></span>`;
            }
            // info bubble
            if (col.info === true) col.info = {};
            if (col.info != null) {
                let infoIcon = 'w2ui-icon-info';
                if (typeof col.info.icon == 'function') infoIcon = col.info.icon(record, {
                    self: this,
                    index: ind,
                    colIndex: col_ind,
                    summary: !!summary
                });
                else if (typeof col.info.icon == 'object') infoIcon = col.info.icon[this.parseField(record, col.field)] || '';
                else if (typeof col.info.icon == 'string') infoIcon = col.info.icon;
                let infoStyle = col.info.style || '';
                if (typeof col.info.style == 'function') infoStyle = col.info.style(record, {
                    self: this,
                    index: ind,
                    colIndex: col_ind,
                    summary: !!summary
                });
                else if (typeof col.info.style == 'object') infoStyle = col.info.style[this.parseField(record, col.field)] || '';
                else if (typeof col.info.style == 'string') infoStyle = col.info.style;
                infoBubble += `<span class="w2ui-info ${infoIcon}" style="${infoStyle}"></span>`;
            }
            let data = value;
            // if editable checkbox
            if (edit && [
                'checkbox',
                'check'
            ].indexOf(edit.type) != -1) {
                let changeInd = summary ? -(ind + 1) : ind;
                divStyle += 'text-align: center;';
                data = `<input tabindex="-1" type="checkbox" class="w2ui-editable-checkbox"
                            data-changeInd="${changeInd}" data-colInd="${col_ind}" ${data ? 'checked="checked"' : ''}>`;
                infoBubble = '';
            }
            data = `<div style="${divStyle}" ${getTitle(data)} ${divAttr}>${infoBubble}${String(data)}</div>`;
            if (data == null) data = '';
            // --> cell TD
            if (typeof col.render == 'string') {
                let tmp = col.render.toLowerCase().split(':');
                if ([
                    'number',
                    'int',
                    'float',
                    'money',
                    'currency',
                    'percent',
                    'size'
                ].indexOf(tmp[0]) != -1) style += 'text-align: right;';
            }
            if (record?.w2ui) {
                if (typeof record.w2ui.style == 'object') {
                    if (typeof record.w2ui.style[col_ind] == 'string') style += record.w2ui.style[col_ind] + ';';
                    if (typeof record.w2ui.style[col.field] == 'string') style += record.w2ui.style[col.field] + ';';
                }
                if (typeof record.w2ui.class == 'object') {
                    if (typeof record.w2ui.class[col_ind] == 'string') className += record.w2ui.class[col_ind] + ' ';
                    if (typeof record.w2ui.class[col.field] == 'string') className += record.w2ui.class[col.field] + ' ';
                }
            }
            let isCellSelected = false;
            if (isRowSelected && sel.columns[ind]?.includes(col_ind)) isCellSelected = true;
            // clipboardCopy
            let clipboardIcon;
            if (col.clipboardCopy) clipboardIcon = '<span class="w2ui-clipboard-copy w2ui-icon-paste"></span>';
            // data
            data = '<td class="w2ui-grid-data' + (isCellSelected ? ' w2ui-selected' : '') + ' ' + className + (isChanged ? ' w2ui-changed' : '') + '" ' + '   id="grid_' + this.name + '_data_' + ind + '_' + col_ind + '" col="' + col_ind + '" ' + '   style="' + style + (col.style != null ? col.style : '') + '" ' + (col.attr != null ? col.attr : '') + attr + (col_span > 1 ? 'colspan="' + col_span + '"' : '') + '>' + data + (clipboardIcon && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripTags(data) ? clipboardIcon : '') + '</td>';
            // summary top row
            if (ind === -1 && summary === true) data = '<td class="w2ui-grid-data" col="' + col_ind + '" style="height: 0px; ' + style + '" ' + (col_span > 1 ? 'colspan="' + col_span + '"' : '') + '></td>';
            return data;
            function getTitle(cellData) {
                let title;
                if (obj.show.recordTitles) {
                    if (col.title != null) {
                        if (typeof col.title == 'function') title = col.title.call(obj, record, {
                            self: this,
                            index: ind,
                            colIndex: col_ind,
                            summary: !!summary
                        });
                        if (typeof col.title == 'string') title = col.title;
                    } else title = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripTags(String(cellData).replace(/"/g, '\'\''));
                }
                return title != null ? 'title="' + String(title) + '"' : '';
            }
        }
        clipboardCopy(ind, col_ind, summary) {
            let rec = summary ? this.summary[ind] : this.records[ind];
            let col = this.columns[col_ind];
            let txt = col ? this.parseField(rec, col.field) : '';
            if (typeof col.clipboardCopy == 'function') txt = col.clipboardCopy(rec, {
                self: this,
                index: ind,
                colIndex: col_ind,
                summary: !!summary
            });
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_focus').text(txt).get(0).select();
            document.execCommand('copy');
        }
        showBubble(ind, col_ind, summary) {
            let info = this.columns[col_ind].info;
            if (!info) return;
            let html = '';
            let rec = this.records[ind];
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`${summary ? '.w2ui-grid-summary' : ''} #grid_${this.name}_data_${ind}_${col_ind} .w2ui-info`);
            if (this.last.bubbleEl) $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.name + '-bubble');
            this.last.bubbleEl = el;
            // if no fields defined - show all
            if (info.fields == null) {
                info.fields = [];
                for(let i = 0; i < this.columns.length; i++){
                    let col = this.columns[i];
                    info.fields.push(col.field + (typeof col.render == 'string' ? ':' + col.render : ''));
                }
            }
            let fields = info.fields;
            if (typeof fields == 'function') fields = fields(rec, {
                self: this,
                index: ind,
                colIndex: col_ind,
                summary: !!summary
            }) // custom renderer
            ;
            // generate html
            if (typeof info.render == 'function') html = info.render(rec, {
                self: this,
                index: ind,
                colIndex: col_ind,
                summary: !!summary
            });
            else if (Array.isArray(fields)) {
                // display mentioned fields
                html = '<table cellpadding="0" cellspacing="0">';
                for(let i = 0; i < fields.length; i++){
                    let tmp = String(fields[i]).split(':');
                    if (tmp[0] == '' || tmp[0] == '-' || tmp[0] == '--' || tmp[0] == '---') {
                        html += '<tr><td colspan=2><div style="border-top: ' + (tmp[0] == '' ? '0' : '1') + 'px solid #C1BEBE; margin: 6px 0px;"></div></td></tr>';
                        continue;
                    }
                    let col = this.getColumn(tmp[0]);
                    if (col == null) col = {
                        field: tmp[0],
                        caption: tmp[0]
                    } // if not found in columns
                    ;
                    let val = col ? this.parseField(rec, col.field) : '';
                    if (tmp.length > 1) {
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatters[tmp[1]]) val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatters[tmp[1]](val, tmp[2] || null, rec);
                        else console.log('ERROR: w2utils.formatters["' + tmp[1] + '"] does not exists.');
                    }
                    if (info.showEmpty !== true && (val == null || val == '')) continue;
                    if (info.maxLength != null && typeof val == 'string' && val.length > info.maxLength) val = val.substr(0, info.maxLength) + '...';
                    html += '<tr><td>' + col.text + '</td><td>' + ((val === 0 ? '0' : val) || '') + '</td></tr>';
                }
                html += '</table>';
            } else if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(fields)) {
                // display some fields
                html = '<table cellpadding="0" cellspacing="0">';
                for(let caption in fields){
                    let fld = fields[caption];
                    if (fld == '' || fld == '-' || fld == '--' || fld == '---') {
                        html += '<tr><td colspan=2><div style="border-top: ' + (fld == '' ? '0' : '1') + 'px solid #C1BEBE; margin: 6px 0px;"></div></td></tr>';
                        continue;
                    }
                    let tmp = String(fld).split(':');
                    let col = this.getColumn(tmp[0]);
                    if (col == null) col = {
                        field: tmp[0],
                        caption: tmp[0]
                    } // if not found in columns
                    ;
                    let val = col ? this.parseField(rec, col.field) : '';
                    if (tmp.length > 1) {
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatters[tmp[1]]) val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatters[tmp[1]](val, tmp[2] || null, rec);
                        else console.log('ERROR: w2utils.formatters["' + tmp[1] + '"] does not exists.');
                    }
                    if (typeof fld == 'function') val = fld(rec, {
                        self: this,
                        index: ind,
                        colIndex: col_ind,
                        summary: !!summary
                    });
                    if (info.showEmpty !== true && (val == null || val == '')) continue;
                    if (info.maxLength != null && typeof val == 'string' && val.length > info.maxLength) val = val.substr(0, info.maxLength) + '...';
                    html += '<tr><td>' + caption + '</td><td>' + ((val === 0 ? '0' : val) || '') + '</td></tr>';
                }
                html += '</table>';
            }
            return $aa2bd8933167d9cb$export$b876f801a4afd38f.show($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                name: this.name + '-bubble',
                html: html,
                anchor: el.get(0),
                position: 'top|bottom',
                class: 'w2ui-info-bubble',
                style: '',
                hideOn: [
                    'doc-click'
                ]
            }, info.options ?? {})).hide(()=>[
                    this.last.bubbleEl = null
                ]);
        }
        // return null or the editable object if the given cell is editable
        getCellEditable(ind, col_ind) {
            let col = this.columns[col_ind];
            let rec = this.records[ind];
            if (!rec || !col) return null;
            let edit = rec.w2ui ? rec.w2ui.editable : null;
            if (edit === false) return null;
            if (edit == null || edit === true) {
                edit = Object.keys(col.editable ?? {}).length > 0 ? col.editable : null;
                if (typeof edit === 'function') {
                    let value = this.getCellValue(ind, col_ind, false);
                    // same arguments as col.render()
                    edit = edit.call(this, rec, {
                        self: this,
                        value: value,
                        index: ind,
                        colIndex: col_ind
                    });
                }
            }
            return edit;
        }
        getCellValue(ind, col_ind, summary, extra) {
            let col = this.columns[col_ind];
            let record = summary !== true ? this.records[ind] : this.summary[ind];
            let value = this.parseField(record, col.field);
            let className = '', style = '', attr = '', divAttr = '';
            // if change by inline editing
            if (record?.w2ui?.changes?.[col.field] != null) value = record.w2ui.changes[col.field];
            // if there is a cell renderer
            if (col.render != null && ind !== -1) {
                if (typeof col.render == 'function' && record != null) {
                    let html;
                    try {
                        html = col.render.call(this, record, {
                            self: this,
                            value: value,
                            index: ind,
                            colIndex: col_ind,
                            summary: !!summary
                        });
                    } catch (e) {
                        throw new Error(`Render function for column "${col.field}" in grid "${this.name}": -- ` + e.message);
                    }
                    if (html != null && typeof html == 'object' && typeof html != 'function') {
                        if (html.id != null && html.text != null) value = html.text;
                        else if (typeof html.html == 'string') value = (html.html || '').trim();
                        else {
                            value = '';
                            console.log('ERROR: render function should return a primitive or an object of the following structure.', {
                                html: '',
                                attr: '',
                                style: '',
                                class: '',
                                divAttr: ''
                            });
                        }
                        attr = html.attr ?? '';
                        style = html.style ?? '';
                        className = html.class ?? '';
                        divAttr = html.divAttr ?? '';
                    } else value = String(html || '').trim();
                }
                // if it is an object
                if (typeof col.render == 'object') {
                    let tmp = col.render[value];
                    if (tmp != null && tmp !== '') value = tmp;
                }
                // formatters
                if (typeof col.render == 'string') {
                    let strInd = col.render.toLowerCase().indexOf(':');
                    let tmp = [];
                    if (strInd == -1) {
                        tmp[0] = col.render.toLowerCase();
                        tmp[1] = '';
                    } else {
                        tmp[0] = col.render.toLowerCase().substr(0, strInd);
                        tmp[1] = col.render.toLowerCase().substr(strInd + 1);
                    }
                    // formatters
                    let func = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatters[tmp[0]];
                    if (col.options && col.options.autoFormat === false) func = null;
                    value = typeof func == 'function' ? func(value, tmp[1], record) : '';
                }
            }
            if (value == null) value = '';
            return !extra ? value : {
                value: value,
                attr: attr,
                style: style,
                className: className,
                divAttr: divAttr
            };
        }
        getFooterHTML() {
            return '<div>    <div class="w2ui-footer-left"></div>    <div class="w2ui-footer-right"></div>    <div class="w2ui-footer-center"></div></div>';
        }
        status(msg) {
            if (msg != null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`#grid_${this.name}_footer`).find('.w2ui-footer-left').html(msg);
            else {
                // show number of selected
                let msgLeft = '';
                let sel = this.getSelection();
                if (sel.length > 0) {
                    if (this.show.statusSelection && sel.length > 1) msgLeft = String(sel.length).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.groupSymbol) + ' ' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('selected');
                    if (this.show.statusRecordID && sel.length == 1) {
                        let tmp = sel[0];
                        if (typeof tmp == 'object') tmp = tmp.recid + ', ' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Column') + ': ' + tmp.column;
                        msgLeft = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Record ID') + ': ' + tmp + ' ';
                    }
                }
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_footer .w2ui-footer-left').html(msgLeft);
            }
        }
        lock(msg, showSpinner) {
            let args = Array.from(arguments);
            args.unshift(this.box);
            setTimeout(()=>{
                // hide empty msg if any
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#grid_' + this.name + '_empty_msg').remove();
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lock(...args);
            }, 10);
        }
        unlock(speed) {
            setTimeout(()=>{
                // do not unlock if there is a message
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-message').hasClass('w2ui-closing')) return;
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.unlock(this.box, speed);
            }, 25) // needed timer so if server fast, it will not flash
            ;
        }
        stateSave(returnOnly) {
            let state = {
                columns: [],
                show: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(this.show),
                last: {
                    search: this.last.search,
                    multi: this.last.multi,
                    logic: this.last.logic,
                    label: this.last.label,
                    field: this.last.field,
                    scrollTop: this.last.vscroll.scrollTop,
                    scrollLeft: this.last.vscroll.scrollLeft
                },
                sortData: [],
                searchData: []
            };
            let prop_val;
            for(let i = 0; i < this.columns.length; i++){
                let col = this.columns[i];
                let col_save_obj = {};
                // iterate properties to save
                Object.keys(this.stateColProps).forEach((prop, idx)=>{
                    if (this.stateColProps[prop]) {
                        // check if the property is defined on the column
                        if (col[prop] !== undefined) prop_val = col[prop];
                        else prop_val = this.colTemplate[prop] || null;
                        col_save_obj[prop] = prop_val;
                    }
                });
                state.columns.push(col_save_obj);
            }
            for(let i = 0; i < this.sortData.length; i++)state.sortData.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(this.sortData[i]));
            for(let i = 0; i < this.searchData.length; i++)state.searchData.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(this.searchData[i]));
            // event before
            let edata = this.trigger('stateSave', {
                target: this.name,
                state: state
            });
            if (edata.isCancelled === true) return;
            // save into local storage
            if (returnOnly !== true) this.cacheSave('state', state);
            // event after
            edata.finish();
            return state;
        }
        stateRestore(newState) {
            let url = typeof this.url != 'object' ? this.url : this.url.get;
            if (!newState) newState = this.cache('state');
            // event before
            let edata = this.trigger('stateRestore', {
                target: this.name,
                state: newState
            });
            if (edata.isCancelled === true) return;
            // default behavior
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(newState)) {
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.show, newState.show ?? {});
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.last, newState.last ?? {});
                let sTop = this.last.vscroll.scrollTop;
                let sLeft = this.last.vscroll.scrollLeft;
                for(let c = 0; c < newState.columns?.length; c++){
                    let tmp = newState.columns[c];
                    let col_index = this.getColumn(tmp.field, true);
                    if (col_index !== null) {
                        $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.columns[col_index], tmp);
                        // restore column order from saved state
                        if (c !== col_index) this.columns.splice(c, 0, this.columns.splice(col_index, 1)[0]);
                    }
                }
                this.sortData.splice(0, this.sortData.length);
                for(let c = 0; c < newState.sortData?.length; c++)this.sortData.push(newState.sortData[c]);
                this.searchData.splice(0, this.searchData.length);
                for(let c = 0; c < newState.searchData?.length; c++)this.searchData.push(newState.searchData[c]);
                // apply sort and search
                setTimeout(()=>{
                    // needs timeout as records need to be populated
                    // ez 10.09.2014 this -->
                    if (!url) {
                        if (this.sortData.length > 0) this.localSort();
                        if (this.searchData.length > 0) this.localSearch();
                    }
                    this.last.vscroll.scrollTop = sTop;
                    this.last.vscroll.scrollLeft = sLeft;
                    this.refresh();
                }, 1);
                console.log(`INFO (w2ui): state restored for "${this.name}"`);
            }
            // event after
            edata.finish();
            return true;
        }
        stateReset() {
            this.stateRestore(this.last.state);
            this.cacheSave('state', null);
        }
        parseField(obj, field) {
            if (this.nestedFields) {
                let val = '';
                try {
                    val = obj;
                    let tmp = String(field).split('.');
                    for(let i = 0; i < tmp.length; i++)val = val[tmp[i]];
                } catch (event1) {
                    val = '';
                }
                return val;
            } else return obj ? obj[field] : '';
        }
        prepareData() {
            let obj = this;
            // loops thru records and prepares date and time objects
            for(let r = 0; r < this.records.length; r++){
                let rec = this.records[r];
                prepareRecord(rec);
            }
            // prepare date and time objects for the 'rec' record and its closed children
            function prepareRecord(rec) {
                for(let c = 0; c < obj.columns.length; c++){
                    let column = obj.columns[c];
                    if (rec[column.field] == null || typeof column.render != 'string') continue;
                    // number
                    if ([
                        'number',
                        'int',
                        'float',
                        'money',
                        'currency',
                        'percent'
                    ].indexOf(column.render.split(':')[0]) != -1) {
                        if (typeof rec[column.field] != 'number') rec[column.field] = parseFloat(rec[column.field]);
                    }
                    // date
                    if ([
                        'date',
                        'age'
                    ].indexOf(column.render.split(':')[0]) != -1) {
                        if (!rec[column.field + '_']) {
                            let dt = rec[column.field];
                            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(dt)) dt = parseInt(dt);
                            rec[column.field + '_'] = new Date(dt);
                        }
                    }
                    // time
                    if ([
                        'time'
                    ].indexOf(column.render) != -1) {
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isTime(rec[column.field])) {
                            let tmp = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isTime(rec[column.field], true);
                            let dt = new Date();
                            dt.setHours(tmp.hours, tmp.minutes, tmp.seconds ? tmp.seconds : 0, 0) // sets hours, min, sec, mills
                            ;
                            if (!rec[column.field + '_']) rec[column.field + '_'] = dt;
                        } else {
                            let tmp = rec[column.field];
                            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(tmp)) tmp = parseInt(tmp);
                            tmp = tmp != null ? new Date(tmp) : new Date();
                            let dt = new Date();
                            dt.setHours(tmp.getHours(), tmp.getMinutes(), tmp.getSeconds(), 0) // sets hours, min, sec, mills
                            ;
                            if (!rec[column.field + '_']) rec[column.field + '_'] = dt;
                        }
                    }
                }
                if (rec.w2ui?.children && rec.w2ui?.expanded !== true) for(let r = 0; r < rec.w2ui.children.length; r++){
                    let subRec = rec.w2ui.children[r];
                    prepareRecord(subRec);
                }
            }
        }
        nextCell(index, col_ind, editable) {
            let check = col_ind + 1;
            if (check >= this.columns.length) {
                index = this.nextRow(index);
                return index == null ? index : this.nextCell(index, -1, editable);
            }
            let tmp = this.records[index].w2ui;
            let col = this.columns[check];
            let span = tmp && tmp.colspan && !isNaN(tmp.colspan[col.field]) ? parseInt(tmp.colspan[col.field]) : 1;
            if (col == null) return null;
            if (col && col.hidden || span === 0) return this.nextCell(index, check, editable);
            if (editable) {
                let edit = this.getCellEditable(index, check);
                if (edit == null || [
                    'checkbox',
                    'check'
                ].indexOf(edit.type) != -1) return this.nextCell(index, check, editable);
            }
            return {
                index: index,
                colIndex: check
            };
        }
        prevCell(index, col_ind, editable) {
            let check = col_ind - 1;
            if (check < 0) {
                index = this.prevRow(index);
                return index == null ? index : this.prevCell(index, this.columns.length, editable);
            }
            if (check < 0) return null;
            let tmp = this.records[index].w2ui;
            let col = this.columns[check];
            let span = tmp && tmp.colspan && !isNaN(tmp.colspan[col.field]) ? parseInt(tmp.colspan[col.field]) : 1;
            if (col == null) return null;
            if (col && col.hidden || span === 0) return this.prevCell(index, check, editable);
            if (editable) {
                let edit = this.getCellEditable(index, check);
                if (edit == null || [
                    'checkbox',
                    'check'
                ].indexOf(edit.type) != -1) return this.prevCell(index, check, editable);
            }
            return {
                index: index,
                colIndex: check
            };
        }
        nextRow(ind, col_ind, numRows) {
            let sids = this.last.searchIds;
            let ret = null;
            if (numRows == null) numRows = 1;
            if (numRows == -1) return this.records.length - 1;
            if (ind + numRows < this.records.length && sids.length === 0 // if there are more records
             || sids.length > 0 && ind < sids[sids.length - numRows]) {
                ind += numRows;
                if (sids.length > 0) while(true){
                    if (sids.includes(ind) || ind > this.records.length) break;
                    ind += numRows;
                }
                // colspan
                let tmp = this.records[ind].w2ui;
                let col = this.columns[col_ind];
                let span = tmp && tmp.colspan && col != null && !isNaN(tmp.colspan[col.field]) ? parseInt(tmp.colspan[col.field]) : 1;
                if (span === 0) ret = this.nextRow(ind, col_ind, numRows);
                else ret = ind;
            }
            return ret;
        }
        prevRow(ind, col_ind, numRows) {
            let sids = this.last.searchIds;
            let ret = null;
            if (numRows == null) numRows = 1;
            if (numRows == -1) return 0;
            if (ind - numRows >= 0 && sids.length === 0 // if there are more records
             || sids.length > 0 && ind > sids[0]) {
                ind -= numRows;
                if (sids.length > 0) while(true){
                    if (sids.includes(ind) || ind < 0) break;
                    ind -= numRows;
                }
                // colspan
                let tmp = this.records[ind].w2ui;
                let col = this.columns[col_ind];
                let span = tmp && tmp.colspan && col != null && !isNaN(tmp.colspan[col.field]) ? parseInt(tmp.colspan[col.field]) : 1;
                if (span === 0) ret = this.prevRow(ind, col_ind, numRows);
                else ret = ind;
            }
            return ret;
        }
        selectionSave() {
            this.last.saved_sel = this.getSelection();
            return this.last.saved_sel;
        }
        selectionRestore(noRefresh) {
            let time = Date.now();
            this.last.selection = {
                indexes: [],
                columns: {}
            };
            let sel = this.last.selection;
            let lst = this.last.saved_sel;
            if (lst) for(let i = 0; i < lst.length; i++)if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(lst[i])) {
                // selectType: cell
                let tmp = this.get(lst[i].recid, true);
                if (tmp != null) {
                    if (sel.indexes.indexOf(tmp) == -1) sel.indexes.push(tmp);
                    if (!sel.columns[tmp]) sel.columns[tmp] = [];
                    sel.columns[tmp].push(lst[i].column);
                }
            } else {
                // selectType: row
                let tmp = this.get(lst[i], true);
                if (tmp != null) sel.indexes.push(tmp);
            }
            delete this.last.saved_sel;
            if (noRefresh !== true) this.refresh();
            return Date.now() - time;
        }
        message(options) {
            return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.message({
                owner: this,
                box: this.box,
                after: '.w2ui-grid-header'
            }, options);
        }
        confirm(options) {
            return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.confirm({
                owner: this,
                box: this.box,
                after: '.w2ui-grid-header'
            }, options);
        }
    }
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: mQuery, w2utils, w2base, w2tabs, w2toolbar, w2tooltip, w2field
 *
 * == TODO ==
 *  - include delta on save
 *  - tabs below some fields (could already be implemented)
 *  - form with toolbar & tabs
 *  - promise for load, save, etc.
 *
 * == 2.0 changes
 *  - CSP - fixed inline events
 *  - removed jQuery dependency
 *  - better groups support tabs now
 *  - form.confirm - refactored
 *  - form.message - refactored
 *  - observeResize for the box
 *  - removed msgNotJSON, msgAJAXerror
 *  - applyFocus -> setFocus
 *  - getFieldValue(fieldName) = returns { curent, previous, original }
 *  - setFieldVallue(fieldName, value)
 *  - getValue(..., original) -- return original if any
 *  - added .hideErrors()
 *  - reuqest, save, submit - return promises
 *  - this.recid = null if no record needs to be pulled
 *  - remove form.multiplart
 *  - this.method - for saving only
 *  - added field.html.class
 *  - setValue(..., noRefresh)
 */ class $aa2bd8933167d9cb$export$40a7047ac34ef882 extends $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        constructor(options){
            super(options.name);
            this.name = null;
            this.header = '';
            this.box = null // HTML element that hold this element
            ;
            this.url = '';
            this.method = null // if defined, it will be http method when saving
            ;
            this.routeData = {} // data for dynamic routes
            ;
            this.formURL = '' // url where to get form HTML
            ;
            this.formHTML = '' // form HTML (might be loaded from the url)
            ;
            this.page = 0 // current page
            ;
            this.pageStyle = '';
            this.recid = null // if not null, then load record
            ;
            this.fields = [];
            this.actions = {};
            this.record = {};
            this.original = null;
            this.dataType = null // only used when not null, otherwise from w2utils.settings.dataType
            ;
            this.postData = {};
            this.httpHeaders = {};
            this.toolbar = {} // if not empty, then it is toolbar
            ;
            this.tabs = {} // if not empty, then it is tabs object
            ;
            this.style = '';
            this.focus = 0 // focus first or other element
            ;
            this.autosize = true // autosize, if false the container must have a height set
            ;
            this.nestedFields = true // use field name containing dots as separator to look into object
            ;
            this.tabindexBase = 0 // this will be added to the auto numbering
            ;
            this.isGenerated = false;
            this.last = {
                fetchCtrl: null,
                fetchOptions: null,
                errors: []
            };
            this.onRequest = null;
            this.onLoad = null;
            this.onValidate = null;
            this.onSubmit = null;
            this.onProgress = null;
            this.onSave = null;
            this.onChange = null;
            this.onInput = null;
            this.onRender = null;
            this.onRefresh = null;
            this.onResize = null;
            this.onDestroy = null;
            this.onAction = null;
            this.onToolbar = null;
            this.onError = null;
            this.msgRefresh = 'Loading...';
            this.msgSaving = 'Saving...';
            this.msgServerError = 'Server error';
            this.ALL_TYPES = [
                'text',
                'textarea',
                'email',
                'pass',
                'password',
                'int',
                'float',
                'money',
                'currency',
                'percent',
                'hex',
                'alphanumeric',
                'color',
                'date',
                'time',
                'datetime',
                'toggle',
                'checkbox',
                'radio',
                'check',
                'checks',
                'list',
                'combo',
                'enum',
                'file',
                'select',
                'map',
                'array',
                'div',
                'custom',
                'html',
                'empty'
            ];
            this.LIST_TYPES = [
                'select',
                'radio',
                'check',
                'checks',
                'list',
                'combo',
                'enum'
            ];
            this.W2FIELD_TYPES = [
                'int',
                'float',
                'money',
                'currency',
                'percent',
                'hex',
                'alphanumeric',
                'color',
                'date',
                'time',
                'datetime',
                'list',
                'combo',
                'enum',
                'file'
            ];
            // mix in options
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this, options);
            // remember items
            let record = options.record;
            let original = options.original;
            let fields = options.fields;
            let toolbar = options.toolbar;
            let tabs = options.tabs;
            // extend items
            Object.assign(this, {
                record: {},
                original: null,
                fields: [],
                tabs: {},
                toolbar: {},
                handlers: []
            });
            // preprocess fields
            if (fields) {
                let sub = _processFields(fields);
                this.fields = sub.fields;
                if (!tabs && sub.tabs.length > 0) tabs = sub.tabs;
            }
            // prepare tabs
            if (Array.isArray(tabs)) {
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.tabs, {
                    tabs: []
                });
                for(let t = 0; t < tabs.length; t++){
                    let tmp = tabs[t];
                    if (typeof tmp === 'object') {
                        this.tabs.tabs.push(tmp);
                        if (tmp.active === true) this.tabs.active = tmp.id;
                    } else this.tabs.tabs.push({
                        id: tmp,
                        text: tmp
                    });
                }
            } else $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.tabs, tabs);
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.toolbar, toolbar);
            for(let p in record)if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(record[p])) this.record[p] = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(record[p]);
            else this.record[p] = record[p];
            for(let p in original)if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(original[p])) this.original[p] = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(original[p]);
            else this.original[p] = original[p];
            // generate html if necessary
            if (this.formURL !== '') fetch(this.formURL).then((resp)=>resp.text()).then((text)=>{
                this.formHTML = text;
                this.isGenerated = true;
                if (this.box) this.render(this.box);
            });
            else if (!this.formURL && !this.formHTML) {
                this.formHTML = this.generateHTML();
                this.isGenerated = true;
            } else if (this.formHTML) this.isGenerated = true;
            // render if box specified
            if (typeof this.box == 'string') this.box = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0);
            if (this.box) this.render(this.box);
            function _processFields(fields) {
                let newFields = [];
                let tabs = [];
                // if it is an object
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(fields)) {
                    let tmp = fields;
                    fields = [];
                    Object.keys(tmp).forEach((key)=>{
                        let fld = tmp[key];
                        if (fld.type == 'group') {
                            fld.text = key;
                            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(fld.fields)) {
                                let tmp2 = fld.fields;
                                fld.fields = [];
                                Object.keys(tmp2).forEach((key2)=>{
                                    let fld2 = tmp2[key2];
                                    fld2.field = key2;
                                    fld.fields.push(_process(fld2));
                                });
                            }
                            fields.push(fld);
                        } else if (fld.type == 'tab') {
                            // add tab
                            let tab = {
                                id: key,
                                text: key
                            };
                            if (fld.style) tab.style = fld.style;
                            tabs.push(tab);
                            // add page to fields
                            let sub = _processFields(fld.fields).fields;
                            sub.forEach((fld2)=>{
                                fld2.html = fld2.html || {};
                                fld2.html.page = tabs.length - 1;
                                _process2(fld, fld2);
                            });
                            fields.push(...sub);
                        } else {
                            fld.field = key;
                            fields.push(_process(fld));
                        }
                    });
                    function _process(fld) {
                        let ignore = [
                            'html'
                        ];
                        if (fld.html == null) fld.html = {};
                        Object.keys(fld).forEach((key)=>{
                            if (ignore.indexOf(key) != -1) return;
                            if ([
                                'label',
                                'attr',
                                'style',
                                'text',
                                'span',
                                'page',
                                'column',
                                'anchor',
                                'group',
                                'groupStyle',
                                'groupTitleStyle',
                                'groupCollapsible'
                            ].indexOf(key) != -1) {
                                fld.html[key] = fld[key];
                                delete fld[key];
                            }
                        });
                        return fld;
                    }
                    function _process2(fld, fld2) {
                        let ignore = [
                            'style',
                            'html'
                        ];
                        Object.keys(fld).forEach((key)=>{
                            if (ignore.indexOf(key) != -1) return;
                            if ([
                                'span',
                                'column',
                                'attr',
                                'text',
                                'label'
                            ].indexOf(key) != -1) {
                                if (fld[key] && !fld2.html[key]) fld2.html[key] = fld[key];
                            }
                        });
                    }
                }
                // process groups
                fields.forEach((field)=>{
                    if (field.type == 'group') {
                        // group properties
                        let group = {
                            group: field.text || '',
                            groupStyle: field.style || '',
                            groupTitleStyle: field.titleStyle || '',
                            groupCollapsible: field.collapsible === true ? true : false
                        };
                        // loop through fields
                        if (Array.isArray(field.fields)) field.fields.forEach((gfield)=>{
                            let fld = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(gfield);
                            if (fld.html == null) fld.html = {};
                            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(fld.html, group);
                            Array('span', 'column', 'attr', 'label', 'page').forEach((key)=>{
                                if (fld.html[key] == null && field[key] != null) fld.html[key] = field[key];
                            });
                            if (fld.field == null && fld.name != null) {
                                console.log('NOTICE: form field.name property is deprecated, please use field.field. Field ->', field);
                                fld.field = fld.name;
                            }
                            newFields.push(fld);
                        });
                    } else {
                        let fld = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(field);
                        if (fld.field == null && fld.name != null) {
                            console.log('NOTICE: form field.name property is deprecated, please use field.field. Field ->', field);
                            fld.field = fld.name;
                        }
                        newFields.push(fld);
                    }
                });
                return {
                    fields: newFields,
                    tabs: tabs
                };
            }
        }
        get(field, returnIndex) {
            if (arguments.length === 0) {
                let all = [];
                for(let f1 = 0; f1 < this.fields.length; f1++)if (this.fields[f1].field != null) all.push(this.fields[f1].field);
                return all;
            } else {
                for(let f2 = 0; f2 < this.fields.length; f2++)if (this.fields[f2].field == field) {
                    if (returnIndex === true) return f2;
                    else return this.fields[f2];
                }
                return null;
            }
        }
        set(field, obj) {
            for(let f = 0; f < this.fields.length; f++)if (this.fields[f].field == field) {
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(this.fields[f], obj);
                this.refresh(field);
                return true;
            }
            return false;
        }
        getValue(field, original) {
            if (this.nestedFields) {
                let val = undefined;
                try {
                    let rec = original === true ? this.original : this.record;
                    val = String(field).split('.').reduce((rec, i)=>{
                        return rec[i];
                    }, rec);
                } catch (event1) {}
                return val;
            } else return this.record[field];
        }
        setValue(field, value, noRefresh) {
            // will not refresh the form!
            if (value === '' || value == null || Array.isArray(value) && value.length === 0 || $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(value) && Object.keys(value).length == 0) value = null;
            if (this.nestedFields) try {
                let rec = this.record;
                String(field).split('.').map((fld, i, arr)=>{
                    if (arr.length - 1 !== i) {
                        if (rec[fld]) rec = rec[fld];
                        else {
                            rec[fld] = {};
                            rec = rec[fld];
                        }
                    } else rec[fld] = value;
                });
                if (!noRefresh) this.setFieldValue(field, value);
                return true;
            } catch (event1) {
                return false;
            }
            else {
                this.record[field] = value;
                if (!noRefresh) this.setFieldValue(field, value);
                return true;
            }
        }
        getFieldValue(name) {
            let field = this.get(name);
            if (field == null) return;
            let el = field.el;
            let previous = this.getValue(name);
            let original = this.getValue(name, true);
            // orginary input control
            let current = el.value;
            // should not be set to '', incosistent logic
            // if (previous == null) previous = ''
            // clean extra chars
            if ([
                'int',
                'float',
                'percent',
                'money',
                'currency'
            ].includes(field.type)) current = field.w2field.clean(current);
            // radio list
            if ([
                'radio'
            ].includes(field.type)) {
                let selected = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).closest('div').find('input:checked').get(0);
                if (selected) {
                    let item = field.options.items[$aa2bd8933167d9cb$export$2fa187e846a241c4(selected).data('index')];
                    current = item.id;
                } else current = null;
            }
            // single checkbox
            if ([
                'toggle',
                'checkbox'
            ].includes(field.type)) current = el.checked;
            // check list
            if ([
                'check',
                'checks'
            ].indexOf(field.type) !== -1) {
                current = [];
                let selected = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).closest('div').find('input:checked');
                if (selected.length > 0) selected.each((el)=>{
                    let item = field.options.items[$aa2bd8933167d9cb$export$2fa187e846a241c4(el).data('index')];
                    current.push(item.id);
                });
                if (!Array.isArray(previous)) previous = [];
            }
            // lists
            let selected = el._w2field?.selected // drop downs and other w2field objects
            ;
            if ([
                'list',
                'enum',
                'file'
            ].includes(field.type) && selected) {
                // TODO: check when w2field is refactored
                let nv = selected;
                let cv = previous;
                if (Array.isArray(nv)) {
                    current = [];
                    for(let i = 0; i < nv.length; i++)current[i] = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(nv[i]) // clone array
                    ;
                }
                if (Array.isArray(cv)) {
                    previous = [];
                    for(let i = 0; i < cv.length; i++)previous[i] = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(cv[i]) // clone array
                    ;
                }
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(nv)) current = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(nv) // clone object
                ;
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(cv)) previous = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(cv) // clone object
                ;
            }
            // map_ctx, array
            if ([
                'map',
                'array'
            ].includes(field.type)) {
                current = field.type == 'map' ? {} : [];
                field.$el.parent().find('.w2ui-map-field').each((div)=>{
                    let key = $aa2bd8933167d9cb$export$2fa187e846a241c4(div).find('.w2ui-map.key').val();
                    let value = $aa2bd8933167d9cb$export$2fa187e846a241c4(div).find('.w2ui-map.value').val();
                    if (field.type == 'map') current[key] = value;
                    else current.push(value);
                });
            }
            return {
                current: current,
                previous: previous,
                original: original
            } // current - in input, previous - in form.record, original - before form change
            ;
        }
        setFieldValue(name, value) {
            let field = this.get(name);
            if (field == null) return;
            let el = field.el;
            switch(field.type){
                case 'toggle':
                case 'checkbox':
                    el.checked = value ? true : false;
                    break;
                case 'radio':
                    {
                        value = value?.id ?? value;
                        let inputs = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).closest('div').find('input');
                        let items = field.options.items;
                        items.forEach((it, ind)=>{
                            if (it.id === value) inputs.filter(`[data-index="${ind}"]`).prop('checked', true);
                        });
                        break;
                    }
                case 'check':
                case 'checks':
                    {
                        if (!Array.isArray(value)) {
                            if (value != null) value = [
                                value
                            ];
                            else value = [];
                        }
                        value = value.map((val)=>val?.id ?? val) // convert if array of objects
                        ;
                        let inputs = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).closest('div').find('input');
                        let items = field.options.items;
                        items.forEach((it, ind)=>{
                            inputs.filter(`[data-index="${ind}"]`).prop('checked', value.includes(it.id) ? true : false);
                        });
                        break;
                    }
                case 'list':
                case 'combo':
                    let item = value;
                    // find item in options.items, if any
                    if (item?.id == null && Array.isArray(field.options?.items)) field.options.items.forEach((it)=>{
                        if (it.id === value) item = it;
                    });
                    // if item is found in field.options, update it in the this.records
                    if (item != value) this.setValue(field.name, item, true);
                    if (field.type == 'list') {
                        field.w2field.selected = item;
                        field.w2field.refresh();
                    } else field.el.value = item?.text ?? value;
                    break;
                case 'enum':
                case 'file':
                    {
                        if (!Array.isArray(value)) value = value != null ? [
                            value
                        ] : [];
                        let items = [
                            ...value
                        ];
                        // find item in options.items, if any
                        let updated = false;
                        items.forEach((item, ind)=>{
                            if (item?.id == null && Array.isArray(field.options.items)) field.options.items.forEach((it)=>{
                                if (it.id == item) {
                                    items[ind] = it;
                                    updated = true;
                                }
                            });
                        });
                        if (updated) this.setValue(field.name, items, true);
                        field.w2field.selected = items;
                        field.w2field.refresh();
                        break;
                    }
                case 'map':
                case 'array':
                    {
                        // init map_ctx
                        if (field.type == 'map' && (value == null || !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(value))) {
                            this.setValue(field.field, {}, true);
                            value = this.getValue(field.field);
                        }
                        if (field.type == 'array' && (value == null || !Array.isArray(value))) {
                            this.setValue(field.field, [], true);
                            value = this.getValue(field.field);
                        }
                        let container = $aa2bd8933167d9cb$export$2fa187e846a241c4(field.el).parent().find('.w2ui-map-container');
                        field.el.mapRefresh(value, container);
                        break;
                    }
                case 'div':
                case 'custom':
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(el).html(value);
                    break;
                case 'html':
                case 'empty':
                    break;
                default:
                    // regular text fields
                    el.value = value ?? '';
                    break;
            }
        }
        show() {
            let effected = [];
            for(let a = 0; a < arguments.length; a++){
                let fld = this.get(arguments[a]);
                if (fld && fld.hidden) {
                    fld.hidden = false;
                    effected.push(fld.field);
                }
            }
            if (effected.length > 0) this.refresh.apply(this, effected);
            this.updateEmptyGroups();
            return effected;
        }
        hide() {
            let effected = [];
            for(let a = 0; a < arguments.length; a++){
                let fld = this.get(arguments[a]);
                if (fld && !fld.hidden) {
                    fld.hidden = true;
                    effected.push(fld.field);
                }
            }
            if (effected.length > 0) this.refresh.apply(this, effected);
            this.updateEmptyGroups();
            return effected;
        }
        enable() {
            let effected = [];
            for(let a = 0; a < arguments.length; a++){
                let fld = this.get(arguments[a]);
                if (fld && fld.disabled) {
                    fld.disabled = false;
                    effected.push(fld.field);
                }
            }
            if (effected.length > 0) this.refresh.apply(this, effected);
            return effected;
        }
        disable() {
            let effected = [];
            for(let a = 0; a < arguments.length; a++){
                let fld = this.get(arguments[a]);
                if (fld && !fld.disabled) {
                    fld.disabled = true;
                    effected.push(fld.field);
                }
            }
            if (effected.length > 0) this.refresh.apply(this, effected);
            return effected;
        }
        updateEmptyGroups() {
            // hide empty groups
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-group').each((group)=>{
                if (isHidden($aa2bd8933167d9cb$export$2fa187e846a241c4(group).find('.w2ui-field'))) $aa2bd8933167d9cb$export$2fa187e846a241c4(group).hide();
                else $aa2bd8933167d9cb$export$2fa187e846a241c4(group).show();
            });
            function isHidden($els) {
                let flag = true;
                $els.each((el)=>{
                    if (el.style.display != 'none') flag = false;
                });
                return flag;
            }
        }
        change() {
            Array.from(arguments).forEach((field)=>{
                let tmp = this.get(field);
                if (tmp.$el) tmp.$el.change();
            });
        }
        reload(callBack) {
            let url = typeof this.url !== 'object' ? this.url : this.url.get;
            if (url && this.recid != null) return this.request(callBack) // returns promise
            ;
            else {
                // this.refresh(); // no need to refresh
                if (typeof callBack === 'function') callBack();
                return new Promise((resolve)=>{
                    resolve();
                }) // resolved promise
                ;
            }
        }
        clear() {
            if (arguments.length != 0) Array.from(arguments).forEach((field)=>{
                let rec = this.record;
                String(field).split('.').map((fld, i, arr)=>{
                    if (arr.length - 1 !== i) rec = rec[fld];
                    else delete rec[fld];
                });
                this.refresh(field);
            });
            else {
                this.recid = null;
                this.record = {};
                this.original = null;
                this.refresh();
                this.hideErrors();
            }
        }
        error(msg) {
            // let the management of the error outside of the form
            let edata = this.trigger('error', {
                target: this.name,
                message: msg,
                fetchCtrl: this.last.fetchCtrl,
                fetchOptions: this.last.fetchOptions
            });
            if (edata.isCancelled === true) return;
            // need a time out because message might be already up)
            setTimeout(()=>{
                this.message(msg);
            }, 1);
            // event after
            edata.finish();
        }
        message(options) {
            return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.message({
                owner: this,
                box: this.box,
                after: '.w2ui-form-header'
            }, options);
        }
        confirm(options) {
            return $aa2bd8933167d9cb$export$fe3767bc112f7a2a.confirm({
                owner: this,
                box: this.box,
                after: '.w2ui-form-header'
            }, options);
        }
        validate(showErrors) {
            if (showErrors == null) showErrors = true;
            // validate before saving
            let errors = [];
            for(let f = 0; f < this.fields.length; f++){
                let field = this.fields[f];
                if (this.getValue(field.field) == null) this.setValue(field.field, '');
                if ([
                    'int',
                    'float',
                    'currency',
                    'money'
                ].indexOf(field.type) != -1) {
                    let val = this.getValue(field.field);
                    let min = field.options.min;
                    let max = field.options.max;
                    if (min != null && val < min) errors.push({
                        field: field,
                        error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Should be more than ${min}', {
                            min: min
                        })
                    });
                    if (max != null && val > max) errors.push({
                        field: field,
                        error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Should be less than ${max}', {
                            max: max
                        })
                    });
                }
                switch(field.type){
                    case 'alphanumeric':
                        if (this.getValue(field.field) && !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isAlphaNumeric(this.getValue(field.field))) errors.push({
                            field: field,
                            error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Not alpha-numeric')
                        });
                        break;
                    case 'int':
                        if (this.getValue(field.field) && !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(this.getValue(field.field))) errors.push({
                            field: field,
                            error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Not an integer')
                        });
                        break;
                    case 'percent':
                    case 'float':
                        if (this.getValue(field.field) && !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(this.getValue(field.field))) errors.push({
                            field: field,
                            error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Not a float')
                        });
                        break;
                    case 'currency':
                    case 'money':
                        if (this.getValue(field.field) && !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isMoney(this.getValue(field.field))) errors.push({
                            field: field,
                            error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Not in money format')
                        });
                        break;
                    case 'color':
                    case 'hex':
                        if (this.getValue(field.field) && !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isHex(this.getValue(field.field))) errors.push({
                            field: field,
                            error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Not a hex number')
                        });
                        break;
                    case 'email':
                        if (this.getValue(field.field) && !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isEmail(this.getValue(field.field))) errors.push({
                            field: field,
                            error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Not a valid email')
                        });
                        break;
                    case 'checkbox':
                        // convert true/false
                        if (this.getValue(field.field) == true) this.setValue(field.field, true);
                        else this.setValue(field.field, false);
                        break;
                    case 'date':
                        // format date before submit
                        if (!field.options.format) field.options.format = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat;
                        if (this.getValue(field.field) && !$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate(this.getValue(field.field), field.options.format)) errors.push({
                            field: field,
                            error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Not a valid date') + ': ' + field.options.format
                        });
                        break;
                    case 'list':
                    case 'combo':
                        break;
                    case 'enum':
                        break;
                }
                // === check required - if field is '0' it should be considered not empty
                let val = this.getValue(field.field);
                if (field.hidden !== true && field.required && ![
                    'div',
                    'custom',
                    'html',
                    'empty'
                ].includes(field.type) && (val == null || val === '' || Array.isArray(val) && val.length === 0 || $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(val) && Object.keys(val).length == 0)) errors.push({
                    field: field,
                    error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Required field')
                });
                if (field.hidden !== true && field.options?.minLength > 0 && ![
                    'enum',
                    'list',
                    'combo'
                ].includes(field.type) // since minLength is used there for other purpose
                 && (val == null || val.length < field.options.minLength)) errors.push({
                    field: field,
                    error: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Field should be at least ${count} characters.', {
                        count: field.options.minLength
                    })
                });
            }
            // event before
            let edata = this.trigger('validate', {
                target: this.name,
                errors: errors
            });
            if (edata.isCancelled === true) return;
            // show error
            this.last.errors = errors;
            if (showErrors) this.showErrors();
            // event after
            edata.finish();
            return errors;
        }
        showErrors() {
            // TODO: check edge cases
            // -- scroll
            // -- invisible pages
            // -- form refresh
            let errors = this.last.errors;
            if (errors.length <= 0) return;
            // show errors
            this.goto(errors[0].field.page);
            $aa2bd8933167d9cb$export$2fa187e846a241c4(errors[0].field.$el).parents('.w2ui-field')[0].scrollIntoView({
                block: 'nearest',
                inline: 'nearest'
            });
            // show errors
            // show only for visible controls
            errors.forEach((error)=>{
                let opt = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                    anchorClass: 'w2ui-error',
                    class: 'w2ui-light',
                    position: 'right|left',
                    hideOn: [
                        'input'
                    ]
                }, error.options);
                if (error.field == null) return;
                let anchor = error.field.el;
                if (error.field.type === 'radio') anchor = $aa2bd8933167d9cb$export$2fa187e846a241c4(error.field.el).closest('div').get(0);
                else [
                    'enum',
                    'file'
                ].includes(error.field.type);
                $aa2bd8933167d9cb$export$b876f801a4afd38f.show($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                    anchor: anchor,
                    name: `${this.name}-${error.field.field}-error`,
                    html: error.error
                }, opt));
            });
            // hide errors on scroll
            $aa2bd8933167d9cb$export$2fa187e846a241c4(errors[0].field.$el).parents('.w2ui-page').off('.hideErrors').on('scroll.hideErrors', (evt)=>{
                this.hideErrors();
            });
        }
        hideErrors() {
            this.fields.forEach((field)=>{
                $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(`${this.name}-${field.field}-error`);
            });
        }
        getChanges() {
            // TODO: not working on nested structures
            let diff = {};
            if (this.original != null && typeof this.original == 'object' && Object.keys(this.record).length !== 0) diff = doDiff(this.record, this.original, {});
            return diff;
            function doDiff(record, original, result) {
                if (Array.isArray(record) && Array.isArray(original)) while(record.length < original.length)record.push(null);
                for(let i in record){
                    if (record[i] != null && typeof record[i] === 'object') {
                        result[i] = doDiff(record[i], original[i] || {}, {});
                        if (!result[i] || Object.keys(result[i]).length == 0 && Object.keys(original[i].length == 0)) delete result[i];
                    } else if (record[i] != original[i] || record[i] == null && original[i] != null) result[i] = record[i];
                }
                return Object.keys(result).length != 0 ? result : null;
            }
        }
        getCleanRecord(strict) {
            let data = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(this.record);
            this.fields.forEach((fld)=>{
                if ([
                    'list',
                    'combo',
                    'enum'
                ].indexOf(fld.type) != -1) {
                    let tmp = {
                        nestedFields: true,
                        record: data
                    };
                    let val = this.getValue.call(tmp, fld.field);
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(val) && val.id != null) this.setValue.call(tmp, fld.field, val.id);
                    if (Array.isArray(val)) val.forEach((item, ind)=>{
                        if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(item) && item.id) val[ind] = item.id;
                    });
                }
                if (fld.type == 'map') {
                    let tmp = {
                        nestedFields: true,
                        record: data
                    };
                    let val = this.getValue.call(tmp, fld.field);
                    if (val._order) delete val._order;
                }
                if (fld.type == 'file') {
                    let tmp = {
                        nestedFields: true,
                        record: data
                    };
                    let val = this.getValue.call(tmp, fld.field) ?? [];
                    val.forEach((v)=>{
                        delete v.file;
                        delete v.modified;
                    });
                    this.setValue.call(tmp, fld.field, val);
                }
            });
            // return only records present in description
            if (strict === true) Object.keys(data).forEach((key)=>{
                if (!this.get(key)) delete data[key];
            });
            return data;
        }
        request(postData, callBack) {
            let self1 = this;
            let resolve, reject;
            let responseProm = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            // check for multiple params
            if (typeof postData === 'function') {
                callBack = postData;
                postData = null;
            }
            if (postData == null) postData = {};
            if (!this.url || typeof this.url === 'object' && !this.url.get) return;
            // build parameters list
            let params = {};
            // add list params
            params.action = 'get';
            params.recid = this.recid;
            params.name = this.name;
            // append other params
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(params, this.postData);
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(params, postData);
            // event before
            let edata = this.trigger('request', {
                target: this.name,
                url: this.url,
                httpMethod: 'GET',
                postData: params,
                httpHeaders: this.httpHeaders
            });
            if (edata.isCancelled === true) return;
            // default action
            this.record = {};
            this.original = null;
            // call server to get data
            this.lock($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.msgRefresh));
            let url = edata.detail.url;
            if (typeof url === 'object' && url.get) url = url.get;
            if (this.last.fetchCtrl) try {
                this.last.fetchCtrl.abort();
            } catch (e) {}
            // process url with routeData
            if (Object.keys(this.routeData).length != 0) {
                let info = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseRoute(url);
                if (info.keys.length > 0) for(let k = 0; k < info.keys.length; k++){
                    if (this.routeData[info.keys[k].name] == null) continue;
                    url = url.replace(new RegExp(':' + info.keys[k].name, 'g'), this.routeData[info.keys[k].name]);
                }
            }
            url = new URL(url, location);
            let fetchOptions = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.prepareParams(url, {
                method: edata.detail.httpMethod,
                headers: edata.detail.httpHeaders,
                body: edata.detail.postData
            }, this.dataType);
            this.last.fetchCtrl = new AbortController();
            fetchOptions.signal = this.last.fetchCtrl.signal;
            this.last.fetchOptions = fetchOptions;
            fetch(url, fetchOptions).catch(processError).then((resp)=>{
                if (resp?.status != 200) {
                    // if resp is undefined, it means request was aborted
                    if (resp) processError(resp);
                    return;
                }
                resp.json().catch(processError).then((data)=>{
                    // event before
                    let edata = self1.trigger('load', {
                        target: self1.name,
                        fetchCtrl: this.last.fetchCtrl,
                        fetchOptions: this.last.fetchOptions,
                        data: data
                    });
                    if (edata.isCancelled === true) return;
                    // for backward compatibility
                    if (data.error == null && data.status === 'error') data.error = true;
                    // if data.record is not present, then assume that entire response is the record
                    if (!data.record) Object.assign(data, {
                        record: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(data)
                    });
                    // server response error, not due to network issues
                    if (data.error === true) self1.error($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(data.message ?? this.msgServerError));
                    else self1.record = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(data.record);
                    // event after
                    self1.unlock();
                    edata.finish();
                    self1.refresh();
                    self1.setFocus();
                    // call back
                    if (typeof callBack === 'function') callBack(data);
                    resolve(data);
                });
            });
            // event after
            edata.finish();
            return responseProm;
            function processError(response) {
                if (response.name === 'AbortError') return;
                self1.unlock();
                // trigger event
                let edata2 = self1.trigger('error', {
                    response: response,
                    fetchCtrl: self1.last.fetchCtrl,
                    fetchOptions: self1.last.fetchOptions
                });
                if (edata2.isCancelled === true) return;
                // default behavior
                if (response.status && response.status != 200) self1.error(response.status + ': ' + response.statusText);
                else {
                    console.log('ERROR: Server request failed.', response, '. ', 'Expected Response:', {
                        error: false,
                        record: {
                            field1: 1,
                            field2: 'item'
                        }
                    }, 'OR:', {
                        error: true,
                        message: 'Error description'
                    });
                    self1.error(String(response));
                }
                // event after
                edata2.finish();
                reject(response);
            }
        }
        submit(postData, callBack) {
            return this.save(postData, callBack);
        }
        save(postData, callBack) {
            let self1 = this;
            let resolve, reject;
            let saveProm = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            // check for multiple params
            if (typeof postData === 'function') {
                callBack = postData;
                postData = null;
            }
            // validation
            let errors = self1.validate(true);
            if (errors.length !== 0) return;
            // submit save
            if (postData == null) postData = {};
            if (!self1.url || typeof self1.url === 'object' && !self1.url.save) {
                console.log('ERROR: Form cannot be saved because no url is defined.');
                return;
            }
            self1.lock($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(self1.msgSaving) + ' <span id="' + self1.name + '_progress"></span>');
            // build parameters list
            let params = {};
            // add list params
            params.action = 'save';
            params.recid = self1.recid;
            params.name = self1.name;
            // append other params
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(params, self1.postData);
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend(params, postData);
            params.record = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(self1.record);
            // event before
            let edata = self1.trigger('submit', {
                target: self1.name,
                url: self1.url,
                httpMethod: this.method ?? 'POST',
                postData: params,
                httpHeaders: self1.httpHeaders
            });
            if (edata.isCancelled === true) return;
            // default action
            let url = edata.detail.url;
            if (typeof url === 'object' && url.save) url = url.save;
            if (self1.last.fetchCtrl) self1.last.fetchCtrl.abort();
            // process url with routeData
            if (Object.keys(self1.routeData).length > 0) {
                let info = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.parseRoute(url);
                if (info.keys.length > 0) for(let k = 0; k < info.keys.length; k++){
                    if (self1.routeData[info.keys[k].name] == null) continue;
                    url = url.replace(new RegExp(':' + info.keys[k].name, 'g'), self1.routeData[info.keys[k].name]);
                }
            }
            url = new URL(url, location);
            let fetchOptions = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.prepareParams(url, {
                method: edata.detail.httpMethod,
                headers: edata.detail.httpHeaders,
                body: edata.detail.postData
            }, this.dataType);
            this.last.fetchCtrl = new AbortController();
            fetchOptions.signal = this.last.fetchCtrl.signal;
            this.last.fetchOptions = fetchOptions;
            fetch(url, fetchOptions).catch(processError).then((resp)=>{
                self1.unlock();
                if (resp?.status != 200) {
                    processError(resp ?? {});
                    return;
                }
                // parse server response
                resp.json().catch(processError).then((data)=>{
                    // event before
                    let edata = self1.trigger('save', {
                        target: self1.name,
                        fetchCtrl: this.last.fetchCtrl,
                        fetchOptions: this.last.fetchOptions,
                        data: data
                    });
                    if (edata.isCancelled === true) return;
                    // server error, not due to network issues
                    if (data.error === true) self1.error($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(data.message ?? this.msgServerError));
                    else self1.original = null;
                    // event after
                    edata.finish();
                    self1.refresh();
                    // call back
                    if (typeof callBack === 'function') callBack(data);
                    resolve(data);
                });
            });
            // event after
            edata.finish();
            return saveProm;
            function processError(response) {
                if (response?.name === 'AbortError') return;
                self1.unlock();
                // trigger event
                let edata2 = self1.trigger('error', {
                    response: response,
                    fetchCtrl: self1.last.fetchCtrl,
                    fetchOptions: self1.last.fetchOptions
                });
                if (edata2.isCancelled === true) return;
                // default behavior
                if (response.status && response.status != 200) self1.error(response.status + ': ' + response.statusText);
                else {
                    console.log('ERROR: Server request failed.', response, '. ', 'Expected Response:', {
                        error: false,
                        record: {
                            field1: 1,
                            field2: 'item'
                        }
                    }, 'OR:', {
                        error: true,
                        message: 'Error description'
                    });
                    self1.error(String(response));
                }
                // event after
                edata2.finish();
                reject();
            }
        }
        lock(msg, showSpinner) {
            let args = Array.from(arguments);
            args.unshift(this.box);
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lock(...args);
        }
        unlock(speed) {
            let box = this.box;
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.unlock(box, speed);
        }
        lockPage(page, msg, spinner) {
            let $page = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.page-' + page);
            if ($page.length) {
                // page found
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lock($page, msg, spinner);
                return true;
            }
            // page with this id not found!
            return false;
        }
        unlockPage(page, speed) {
            let $page = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.page-' + page);
            if ($page.length) {
                // page found
                $aa2bd8933167d9cb$export$fe3767bc112f7a2a.unlock($page, speed);
                return true;
            }
            // page with this id not found!
            return false;
        }
        goto(page) {
            if (this.page === page) return; // already on this page
            if (page != null) this.page = page;
            // if it was auto size, resize it
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).data('autoSize') === true) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0).clientHeight = 0;
            this.refresh();
        }
        generateHTML() {
            let pages = [] // array for each page
            ;
            let group = '';
            let page;
            let column;
            let html;
            let tabindex;
            let tabindex_str;
            for(let f = 0; f < this.fields.length; f++){
                html = '';
                tabindex = this.tabindexBase + f + 1;
                tabindex_str = ' tabindex="' + tabindex + '"';
                let field = this.fields[f];
                if (field.html == null) field.html = {};
                if (field.options == null) field.options = {};
                if (field.html.caption != null && field.html.label == null) {
                    console.log('NOTICE: form field.html.caption property is deprecated, please use field.html.label. Field ->', field);
                    field.html.label = field.html.caption;
                }
                if (field.html.label == null) field.html.label = field.field;
                field.html = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                    label: '',
                    span: 6,
                    attr: '',
                    text: '',
                    style: '',
                    page: 0,
                    column: 0
                }, field.html);
                if (page == null) page = field.html.page;
                if (column == null) column = field.html.column;
                // input control
                let input = `<input id="${field.field}" name="${field.field}" class="w2ui-input ${field.html.class ?? ''}" type="text" ${field.html.attr + tabindex_str}>`;
                switch(field.type){
                    case 'pass':
                    case 'password':
                        input = input.replace('type="text"', 'type="password"');
                        break;
                    case 'checkbox':
                        input = `
                        <label class="w2ui-box-label">
                            <input id="${field.field}" name="${field.field}" class="w2ui-input ${field.html.class ?? ''}" type="checkbox" ${field.html.attr + tabindex_str}>
                            <span>${field.html.label}</span>
                        </label>`;
                        break;
                    case 'check':
                    case 'checks':
                        {
                            if (field.options.items == null && field.html.items != null) field.options.items = field.html.items;
                            let items = field.options.items;
                            input = '';
                            // normalized options
                            if (!Array.isArray(items)) items = [];
                            if (items.length > 0) items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, items, field);
                            // generate
                            for(let i = 0; i < items.length; i++)input += `
                            <label class="w2ui-box-label">
                                <input id="${field.field + i}" name="${field.field}" class="w2ui-input ${field.html.class ?? ''}" type="checkbox"
                                    ${field.html.attr + tabindex_str} data-value="${items[i].id}" data-index="${i}">
                                <span>&#160;${items[i].text}</span>
                            </label>
                            <br>`;
                            break;
                        }
                    case 'radio':
                        {
                            input = '';
                            // normalized options
                            if (field.options.items == null && field.html.items != null) field.options.items = field.html.items;
                            let items = field.options.items;
                            if (!Array.isArray(items)) items = [];
                            if (items.length > 0) items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, items, field);
                            // generate
                            for(let i = 0; i < items.length; i++)input += `
                            <label class="w2ui-box-label">
                                <input id="${field.field + i}" name="${field.field}" class="w2ui-input ${field.html.class ?? ''}" type="radio"
                                    ${field.html.attr + (i === 0 ? tabindex_str : '')}
                                    data-value="${items[i].id}" data-index="${i}">
                                <span>&#160;${items[i].text}</span>
                            </label>
                            <br>`;
                            break;
                        }
                    case 'select':
                        {
                            input = `<select id="${field.field}" name="${field.field}" class="w2ui-input ${field.html.class ?? ''}" ${field.html.attr + tabindex_str}>`;
                            // normalized options
                            if (field.options.items == null && field.html.items != null) field.options.items = field.html.items;
                            let items = field.options.items;
                            if (!Array.isArray(items)) items = [];
                            if (items.length > 0) items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, items, field);
                            // generate
                            for(let i = 0; i < items.length; i++)input += `<option value="${items[i].id}">${items[i].text}</option>`;
                            input += '</select>';
                            break;
                        }
                    case 'textarea':
                        input = `<textarea id="${field.field}" name="${field.field}" class="w2ui-input ${field.html.class ?? ''}" ${field.html.attr + tabindex_str}></textarea>`;
                        break;
                    case 'toggle':
                        input = `<input id="${field.field}" name="${field.field}" class="w2ui-input w2ui-toggle  ${field.html.class ?? ''}"
                                type="checkbox" ${field.html.attr + tabindex_str}>
                            <div><div></div></div>`;
                        break;
                    case 'map':
                    case 'array':
                        field.html.key = field.html.key || {};
                        field.html.value = field.html.value || {};
                        field.html.tabindex_str = tabindex_str;
                        input = '<span style="float: right">' + (field.html.text || '') + '</span>' + '<input id="' + field.field + '" name="' + field.field + '" type="hidden" ' + field.html.attr + tabindex_str + '>' + '<div class="w2ui-map-container"></div>';
                        break;
                    case 'div':
                    case 'custom':
                        input = `<div id="${field.field}" name="${field.field}" ${field.html.attr + tabindex_str} class="w2ui-input ${field.html.class ?? ''}">` + (field && field.html && field.html.html ? field.html.html : '') + '</div>';
                        break;
                    case 'html':
                    case 'empty':
                        input = field && field.html ? (field.html.html || '') + (field.html.text || '') : '';
                        break;
                }
                if (group !== '') {
                    if (page != field.html.page || column != field.html.column || field.html.group && group != field.html.group) {
                        pages[page][column] += '\n   </div>\n  </div>';
                        group = '';
                    }
                }
                if (field.html.group && group != field.html.group) {
                    let collapsible = '';
                    if (field.html.groupCollapsible) collapsible = '<span class="w2ui-icon-collapse" style="width: 15px; display: inline-block; position: relative; top: -2px;"></span>';
                    html += '\n <div class="w2ui-group">\n   <div class="w2ui-group-title w2ui-eaction" style="' + (field.html.groupTitleStyle || '') + '; ' + (collapsible != '' ? 'cursor: pointer; user-select: none' : '') + '"' + (collapsible != '' ? 'data-group="' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.base64encode(field.html.group) + '"' : '') + (collapsible != '' ? 'data-click="toggleGroup|' + field.html.group + '"' : '') + '>' + collapsible + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(field.html.group) + '</div>\n' + '   <div class="w2ui-group-fields" style="' + (field.html.groupStyle || '') + '">';
                    group = field.html.group;
                }
                if (field.html.anchor == null) {
                    let span = field.html.span != null ? 'w2ui-span' + field.html.span : '';
                    if (field.html.span == -1) span = 'w2ui-span-none';
                    let label = '<label' + (span == 'none' ? ' style="display: none"' : '') + '>' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(field.type != 'checkbox' ? field.html.label : field.html.text) + '</label>';
                    if (!field.html.label) label = '';
                    html += '\n      <div class="w2ui-field ' + span + '" style="' + (field.hidden ? 'display: none;' : '') + field.html.style + '">' + '\n         ' + label + (field.type === 'empty' ? input : '\n         <div>' + input + (field.type != 'array' && field.type != 'map' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(field.type != 'checkbox' ? field.html.text : '') : '') + '</div>') + '\n      </div>';
                } else {
                    pages[field.html.page].anchors = pages[field.html.page].anchors || {};
                    pages[field.html.page].anchors[field.html.anchor] = '<div class="w2ui-field w2ui-field-inline" style="' + (field.hidden ? 'display: none;' : '') + field.html.style + '">' + (field.type === 'empty' ? input : '<div>' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(field.type != 'checkbox' ? field.html.label : field.html.text, true) + input + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(field.type != 'checkbox' ? field.html.text : '') + '</div>') + '</div>';
                }
                if (pages[field.html.page] == null) pages[field.html.page] = {};
                if (pages[field.html.page][field.html.column] == null) pages[field.html.page][field.html.column] = '';
                pages[field.html.page][field.html.column] += html;
                page = field.html.page;
                column = field.html.column;
            }
            if (group !== '') pages[page][column] += '\n   </div>\n  </div>';
            if (this.tabs.tabs) {
                for(let i = 0; i < this.tabs.tabs.length; i++)if (pages[i] == null) pages[i] = [];
            }
            // buttons if any
            let buttons = '';
            if (Object.keys(this.actions).length > 0) {
                buttons += '\n<div class="w2ui-buttons">';
                tabindex = this.tabindexBase + this.fields.length + 1;
                for(let a in this.actions){
                    let act = this.actions[a];
                    let info = {
                        text: '',
                        style: '',
                        'class': ''
                    };
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(act)) {
                        if (act.text == null && act.caption != null) {
                            console.log('NOTICE: form action.caption property is deprecated, please use action.text. Action ->', act);
                            act.text = act.caption;
                        }
                        if (act.text) info.text = act.text;
                        if (act.style) info.style = act.style;
                        if (act.class) info.class = act.class;
                    } else {
                        info.text = a;
                        if ([
                            'save',
                            'update',
                            'create'
                        ].indexOf(a.toLowerCase()) !== -1) info.class = 'w2ui-btn-blue';
                        else info.class = '';
                    }
                    buttons += '\n    <button name="' + a + '" class="w2ui-btn ' + info.class + '" style="' + info.style + '" tabindex="' + tabindex + '">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(info.text) + '</button>';
                    tabindex++;
                }
                buttons += '\n</div>';
            }
            html = '';
            for(let p = 0; p < pages.length; p++){
                html += '<div class="w2ui-page page-' + p + '" style="' + (p !== 0 ? 'display: none;' : '') + this.pageStyle + '">';
                if (!pages[p]) {
                    console.log(`ERROR: Page ${p} does not exist`);
                    return false;
                }
                if (pages[p].before) html += pages[p].before;
                html += '<div class="w2ui-column-container">';
                Object.keys(pages[p]).sort().forEach((c, ind)=>{
                    if (c == parseInt(c)) html += '<div class="w2ui-column col-' + c + '">' + (pages[p][c] || '') + '\n</div>';
                });
                html += '\n</div>';
                if (pages[p].after) html += pages[p].after;
                html += '\n</div>';
                // process page anchors
                if (pages[p].anchors) Object.keys(pages[p].anchors).forEach((key, ind)=>{
                    html = html.replace(key, pages[p].anchors[key]);
                });
            }
            html += buttons;
            return html;
        }
        toggleGroup(groupName, show) {
            let el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-group-title[data-group="' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.base64encode(groupName) + '"]');
            if (el.length === 0) return;
            let el_next = $aa2bd8933167d9cb$export$2fa187e846a241c4(el.prop('nextElementSibling'));
            if (typeof show === 'undefined') show = el_next.css('display') == 'none';
            if (show) {
                el_next.show();
                el.find('span').addClass('w2ui-icon-collapse').removeClass('w2ui-icon-expand');
            } else {
                el_next.hide();
                el.find('span').addClass('w2ui-icon-expand').removeClass('w2ui-icon-collapse');
            }
        }
        action(action, event1) {
            let act = this.actions[action];
            let click = act;
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(act) && act.onClick) click = act.onClick;
            // event before
            let edata = this.trigger('action', {
                target: action,
                action: act,
                originalEvent: event1
            });
            if (edata.isCancelled === true) return;
            // default actions
            if (typeof click === 'function') click.call(this, event1);
            // event after
            edata.finish();
        }
        resize() {
            let self1 = this;
            // event before
            let edata = this.trigger('resize', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // default behaviour
            if (this.box != null) {
                let header = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div .w2ui-form-header');
                let toolbar = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div .w2ui-form-toolbar');
                let tabs = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div .w2ui-form-tabs');
                let page = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div .w2ui-page');
                let dpage = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div .w2ui-page.page-' + this.page + ' > div');
                let buttons = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(':scope > div .w2ui-buttons');
                // if no height, calculate it
                let { headerHeight: headerHeight, tbHeight: tbHeight, tabsHeight: tabsHeight } = resizeElements();
                if (this.autosize) {
                    let cHeight = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).get(0).clientHeight;
                    if (cHeight === 0 || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).data('autosize') == 'yes') {
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).css({
                            height: headerHeight + tbHeight + tabsHeight + 15 // 15 is extra height
                             + (page.length > 0 ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(dpage, 'height') : 0) + (buttons.length > 0 ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(buttons, 'height') : 0) + 'px'
                        });
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).data('autosize', 'yes');
                    }
                    resizeElements();
                }
                function resizeElements() {
                    let headerHeight = self1.header !== '' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(header, 'height') : 0;
                    let tbHeight = Array.isArray(self1.toolbar?.items) && self1.toolbar?.items?.length > 0 ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(toolbar, 'height') : 0;
                    let tabsHeight = Array.isArray(self1.tabs?.tabs) && self1.tabs?.tabs?.length > 0 ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(tabs, 'height') : 0;
                    // resize elements
                    toolbar.css({
                        top: headerHeight + 'px'
                    });
                    tabs.css({
                        top: headerHeight + tbHeight + 'px'
                    });
                    page.css({
                        top: headerHeight + tbHeight + tabsHeight + 'px',
                        bottom: (buttons.length > 0 ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(buttons, 'height') : 0) + 'px'
                    });
                    // return some params
                    return {
                        headerHeight: headerHeight,
                        tbHeight: tbHeight,
                        tabsHeight: tabsHeight
                    };
                }
            }
            // event after
            edata.finish();
        }
        refresh() {
            let time = Date.now();
            let self1 = this;
            if (!this.box) return;
            if (!this.isGenerated || !$aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).html()) return;
            // event before
            let edata = this.trigger('refresh', {
                target: this.name,
                page: this.page,
                field: arguments[0],
                fields: arguments
            });
            if (edata.isCancelled === true) return;
            let fields = Array.from(this.fields.keys());
            if (arguments.length > 0) fields = Array.from(arguments).map((fld, ind)=>{
                if (typeof fld != 'string') console.log('ERROR: Arguments in refresh functions should be field names');
                return this.get(fld, true) // get index of field
                ;
            }).filter((fld, ind)=>{
                if (fld != null) return true;
                else return false;
            });
            else {
                // update field.page with page it belongs too
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('input, textarea, select').each((el)=>{
                    let name = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).attr('name') != null ? $aa2bd8933167d9cb$export$2fa187e846a241c4(el).attr('name') : $aa2bd8933167d9cb$export$2fa187e846a241c4(el).attr('id');
                    let field = this.get(name);
                    if (field) {
                        // find page
                        let div = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).closest('.w2ui-page');
                        if (div.length > 0) {
                            for(let i = 0; i < 100; i++)if (div.hasClass('page-' + i)) {
                                field.page = i;
                                break;
                            }
                        }
                    }
                });
                // default action
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-page').hide();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-page.page-' + this.page).show();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-form-header').html($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.header));
                // refresh tabs if needed
                if (typeof this.tabs === 'object' && Array.isArray(this.tabs.tabs) && this.tabs.tabs.length > 0) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#form_' + this.name + '_tabs').show();
                    this.tabs.active = this.tabs.tabs[this.page].id;
                    this.tabs.refresh();
                } else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#form_' + this.name + '_tabs').hide();
                // refresh tabs if needed
                if (typeof this.toolbar === 'object' && Array.isArray(this.toolbar.items) && this.toolbar.items.length > 0) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#form_' + this.name + '_toolbar').show();
                    this.toolbar.refresh();
                } else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#form_' + this.name + '_toolbar').hide();
            }
            // refresh values of fields
            for(let f = 0; f < fields.length; f++){
                let field = this.fields[fields[f]];
                if (field.name == null && field.field != null) field.name = field.field;
                if (field.field == null && field.name != null) field.field = field.name;
                field.$el = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`[name='${String(field.name).replace(/\\/g, '\\\\')}']`);
                field.el = field.$el.get(0);
                if (field.el) field.el.id = field.name;
                // TODO: check
                if (field.w2field) field.w2field.reset();
                field.$el.off('.w2form').on('change.w2form', function(event1) {
                    let value = self1.getFieldValue(field.field);
                    // clear error class
                    if ([
                        'enum',
                        'file'
                    ].includes(field.type)) {
                        let helper = field.el._w2field?.helpers?.multi;
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(helper).removeClass('w2ui-error');
                    }
                    if (this._previous != null) {
                        value.previous = this._previous;
                        delete this._previous;
                    }
                    // event before
                    let edata2 = self1.trigger('change', {
                        target: this.name,
                        field: this.name,
                        value: value,
                        originalEvent: event1
                    });
                    if (edata2.isCancelled === true) return;
                    // default behavior
                    self1.setValue(this.name, value.current);
                    // event after
                    edata2.finish();
                }).on('input.w2form', function(event1) {
                    // remember original
                    if (self1.original == null) {
                        if (Object.keys(self1.record).length > 0) self1.original = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(self1.record);
                        else self1.original = {};
                    }
                    let value = self1.getFieldValue(field.field);
                    // save previous for change event
                    if (this._previous == null) this._previous = value.previous;
                    // event before
                    let edata2 = self1.trigger('input', {
                        target: self1.name,
                        field: field,
                        value: value,
                        originalEvent: event1
                    });
                    if (edata2.isCancelled === true) return;
                    // default action
                    self1.setValue(this.name, value.current);
                    // event after
                    edata2.finish();
                });
                // required
                if (field.required) field.$el.closest('.w2ui-field').addClass('w2ui-required');
                else field.$el.closest('.w2ui-field').removeClass('w2ui-required');
                // denied
                if (field.disabled != null) {
                    if (field.disabled) {
                        if (field.$el.data('tabIndex') == null) field.$el.data('tabIndex', field.$el.prop('tabIndex'));
                        field.$el.prop('readOnly', true).prop('disabled', true).prop('tabIndex', -1).closest('.w2ui-field').addClass('w2ui-disabled');
                    } else field.$el.prop('readOnly', false).prop('disabled', false).prop('tabIndex', field.$el.data('tabIndex') ?? field.$el.prop('tabIndex') ?? 0).closest('.w2ui-field').removeClass('w2ui-disabled');
                }
                // hidden
                let tmp = field.el;
                if (!tmp) tmp = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#' + field.field);
                if (field.hidden) $aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).closest('.w2ui-field').hide();
                else $aa2bd8933167d9cb$export$2fa187e846a241c4(tmp).closest('.w2ui-field').show();
            }
            // attach actions on buttons
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('button, input[type=button]').each((el)=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(el).off('click').on('click', function(event1) {
                    let action = this.value;
                    if (this.id) action = this.id;
                    if (this.name) action = this.name;
                    self1.action(action, event1);
                });
            });
            // init controls with record
            for(let f = 0; f < fields.length; f++){
                let field = this.fields[fields[f]];
                if (!field.el) continue;
                if (!field.$el.hasClass('w2ui-input')) field.$el.addClass('w2ui-input');
                field.type = String(field.type).toLowerCase();
                if (!field.options) field.options = {};
                // list type
                if (this.LIST_TYPES.includes(field.type)) {
                    let items = field.options.items;
                    if (items == null) field.options.items = [];
                    field.options.items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, items, field);
                }
                // HTML select
                if (field.type == 'select') {
                    // generate options
                    let items = field.options.items;
                    let options = '';
                    items.forEach((item)=>{
                        options += `<option value="${item.id}">${item.text}</option>`;
                    });
                    field.$el.html(options);
                }
                // w2fields
                if (this.W2FIELD_TYPES.includes(field.type)) {
                    field.w2field = field.w2field ?? new $aa2bd8933167d9cb$export$b011ec2f2c6bab8b($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, field.options, {
                        type: field.type
                    }));
                    field.w2field.render(field.el);
                }
                // map_ctx and arrays
                if ([
                    'map',
                    'array'
                ].includes(field.type)) (function(obj, field) {
                    let keepFocus;
                    field.el.mapAdd = function(field, div, cnt) {
                        let attr = (field.disabled ? ' readOnly ' : '') + (field.html.tabindex_str || '');
                        let html = `
                            <div class="w2ui-map-field" style="margin-bottom: 5px" data-index="${cnt}">
                            ${field.type == 'map' ? `<input type="text" ${(field.html.key.attr ?? '') + attr} class="w2ui-input ${field.html.class ?? ''} w2ui-map key">
                                    ${field.html.key.text || ''}
                                ` : ''}
                            <input type="text" ${(field.html.value.attr ?? '') + attr} class="w2ui-input ${field.html.class ?? ''} w2ui-map value">
                                ${field.html.value.text || ''}
                            </div>`;
                        div.append(html);
                    };
                    field.el.mapRefresh = function(map, div) {
                        // generate options
                        let keys, $k, $v;
                        if (field.type == 'map') {
                            if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(map)) map = {};
                            if (map._order == null) map._order = Object.keys(map);
                            keys = map._order;
                        }
                        if (field.type == 'array') {
                            if (!Array.isArray(map)) map = [];
                            keys = map.map((item, ind)=>{
                                return ind;
                            });
                        }
                        // delete extra fields (including empty one)
                        let all = div.find('.w2ui-map-field');
                        for(let i = all.length - 1; i >= keys.length; i--)div.find(`div[data-index='${i}']`).remove();
                        for(let ind = 0; ind < keys.length; ind++){
                            let key = keys[ind];
                            let fld = div.find(`div[data-index='${ind}']`);
                            // add if does not exists
                            if (fld.length == 0) {
                                field.el.mapAdd(field, div, ind);
                                fld = div.find(`div[data-index='${ind}']`);
                            }
                            fld.attr('data-key', key);
                            $k = fld.find('.w2ui-map.key');
                            $v = fld.find('.w2ui-map.value');
                            let val = map[key];
                            if (field.type == 'array') {
                                let tmp = map.filter((it)=>{
                                    return it.key == key ? true : false;
                                });
                                if (tmp.length > 0) val = tmp[0].value;
                            }
                            $k.val(key);
                            $v.val(val);
                            if (field.disabled === true || field.disabled === false) {
                                $k.prop('readOnly', field.disabled ? true : false);
                                $v.prop('readOnly', field.disabled ? true : false);
                            }
                        }
                        let cnt = keys.length;
                        let curr = div.find(`div[data-index='${cnt}']`);
                        // if not denied - add next if needed
                        if (curr.length === 0 && (!$k || $k.val() != '' || $v.val() != '') && !($k && ($k.prop('readOnly') === true || $k.prop('disabled') === true))) field.el.mapAdd(field, div, cnt);
                        if (field.disabled === true || field.disabled === false) {
                            curr.find('.key').prop('readOnly', field.disabled ? true : false);
                            curr.find('.value').prop('readOnly', field.disabled ? true : false);
                        }
                        // attach events
                        let container = $aa2bd8933167d9cb$export$2fa187e846a241c4(field.el).get(0)?.nextSibling // should be div
                        ;
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(container).find('input.w2ui-map').off('.mapChange').on('keyup.mapChange', function(event1) {
                            let $div = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.w2ui-map-field');
                            let next = $div.get(0).nextElementSibling;
                            let prev = $div.get(0).previousElementSibling;
                            if (event1.keyCode == 13) {
                                let el = keepFocus ?? next;
                                if (el instanceof HTMLElement) {
                                    let inp = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).find('input');
                                    if (inp.length > 0) inp.get(0).focus();
                                }
                                keepFocus = undefined;
                            }
                            let className = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('key') ? 'key' : 'value';
                            if (event1.keyCode == 38 && prev) {
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(prev).find(`input.${className}`).get(0).select();
                                event1.preventDefault();
                            }
                            if (event1.keyCode == 40 && next) {
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(next).find(`input.${className}`).get(0).select();
                                event1.preventDefault();
                            }
                        }).on('keydown.mapChange', function(event1) {
                            if (event1.keyCode == 38 || event1.keyCode == 40) event1.preventDefault();
                        }).on('input.mapChange', function(event1) {
                            let fld = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('div');
                            let cnt = fld.data('index');
                            let next = fld.get(0).nextElementSibling;
                            // if last one, add new empty
                            if (fld.find('input').val() != '' && !next) field.el.mapAdd(field, div, parseInt(cnt) + 1);
                            else if (fld.find('input').val() == '' && next) {
                                let isEmpty = true;
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(next).find('input').each((el)=>{
                                    if (el.value != '') isEmpty = false;
                                });
                                if (isEmpty) $aa2bd8933167d9cb$export$2fa187e846a241c4(next).remove();
                            }
                        }).on('change.mapChange', function(event1) {
                            // remember original
                            if (self1.original == null) {
                                if (Object.keys(self1.record).length > 0) self1.original = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(self1.record);
                                else self1.original = {};
                            }
                            // event before
                            let { current: current, previous: previous, original: original } = self1.getFieldValue(field.field);
                            let $cnt = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.w2ui-map-container');
                            if (field.type == 'map') current._order = [];
                            $cnt.find('.w2ui-map.key').each((el)=>{
                                current._order.push(el.value);
                            });
                            let edata = self1.trigger('change', {
                                target: field.field,
                                field: field.field,
                                originalEvent: event1,
                                value: {
                                    current: current,
                                    previous: previous,
                                    original: original
                                }
                            });
                            if (edata.isCancelled === true) return;
                            // delete empty
                            if (field.type == 'map') {
                                current._order = current._order.filter((k)=>k !== '');
                                delete current[''];
                            }
                            if (field.type == 'array') current = current.filter((k)=>k !== '');
                            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).parent().find('input').val() == '') keepFocus = event1.target;
                            self1.setValue(field.field, current);
                            field.el.mapRefresh(current, div);
                            // event after
                            edata.finish();
                        });
                    };
                })(this, field);
                // set value to HTML input field
                this.setFieldValue(field.field, this.getValue(field.name));
            }
            // event after
            edata.finish();
            this.resize();
            return Date.now() - time;
        }
        render(box) {
            let time = Date.now();
            let self1 = this;
            if (typeof box == 'string') box = $aa2bd8933167d9cb$export$2fa187e846a241c4(box).get(0);
            // event before
            let edata = this.trigger('render', {
                target: this.name,
                box: box ?? this.box
            });
            if (edata.isCancelled === true) return;
            // default action
            if (box != null) {
                this.unmount() // clean previous control
                ;
                this.box = box;
            }
            if (!this.isGenerated && !this.formHTML) return;
            if (!this.box) return;
            // render form
            let html = '<div class="w2ui-form-box">' + (this.header !== '' ? '<div class="w2ui-form-header">' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(this.header) + '</div>' : '') + '    <div id="form_' + this.name + '_toolbar" class="w2ui-form-toolbar" style="display: none"></div>' + '    <div id="form_' + this.name + '_tabs" class="w2ui-form-tabs" style="display: none"></div>' + this.formHTML + '</div>';
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).attr('name', this.name).addClass('w2ui-reset w2ui-form').html(html);
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box)[0].style.cssText += this.style;
            $aa2bd8933167d9cb$export$fe3767bc112f7a2a.bindEvents($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('.w2ui-eaction'), this);
            // init toolbar regardless it is defined or not
            if (typeof this.toolbar.render !== 'function') {
                this.toolbar = new $aa2bd8933167d9cb$export$d1962123e55f7d10($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.toolbar, {
                    name: this.name + '_toolbar',
                    owner: this
                }));
                this.toolbar.on('click', function(event1) {
                    let edata = self1.trigger('toolbar', {
                        target: event1.target,
                        originalEvent: event1
                    });
                    if (edata.isCancelled === true) return;
                    // no default action
                    edata.finish();
                });
            }
            if (typeof this.toolbar === 'object' && typeof this.toolbar.render === 'function') this.toolbar.render($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#form_' + this.name + '_toolbar')[0]);
            // init tabs regardless it is defined or not
            if (typeof this.tabs.render !== 'function') {
                this.tabs = new $aa2bd8933167d9cb$export$7d72bb041567afb5($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, this.tabs, {
                    name: this.name + '_tabs',
                    owner: this,
                    active: this.tabs.active
                }));
                this.tabs.on('click', function(event1) {
                    self1.goto(this.get(event1.target, true));
                });
            }
            if (typeof this.tabs === 'object' && typeof this.tabs.render === 'function') {
                this.tabs.render($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#form_' + this.name + '_tabs')[0]);
                if (this.tabs.active) this.tabs.click(this.tabs.active);
            }
            // event after
            edata.finish();
            // after render actions
            this.resize();
            let url = typeof this.url !== 'object' ? this.url : this.url.get;
            if (url && this.recid != null) this.request().catch((error)=>this.refresh()) // even if there was error, still need refresh
            ;
            else this.refresh();
            // observe div resize
            this.last.observeResize = new ResizeObserver(()=>{
                this.resize();
            });
            this.last.observeResize.observe(this.box);
            // focus on load
            if (this.focus != -1) {
                let setCount = 0;
                let setFocus = ()=>{
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(self1.box).find('input, select, textarea').length > 0) self1.setFocus();
                    else {
                        setCount++;
                        if (setCount < 20) setTimeout(setFocus, 50) // 1 sec max
                        ;
                    }
                };
                setFocus();
            }
            return Date.now() - time;
        }
        unmount() {
            super.unmount();
            this.tabs?.unmount?.();
            this.toolbar?.unmount?.();
            this.last.observeResize?.disconnect();
        }
        destroy() {
            // event before
            let edata = this.trigger('destroy', {
                target: this.name
            });
            if (edata.isCancelled === true) return;
            // clean up
            this.tabs?.destroy?.();
            this.toolbar?.destroy?.();
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('#form_' + this.name + '_tabs').length > 0) this.unmount();
            this.last.observeResize?.disconnect();
            delete $aa2bd8933167d9cb$export$dca4c93ccda43b77[this.name];
            // event after
            edata.finish();
        }
        setFocus(focus) {
            if (typeof focus === 'undefined') focus = this.focus;
            let $input;
            // focus field by index
            if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(focus)) {
                if (focus < 0) return;
                let inputs = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find('div:not(.w2ui-field-helper) > input, select, textarea, div > label:nth-child(1) > [type=radio]').filter(':not(.file-input)');
                // find visible (offsetParent == null for any element is not visible)
                while(inputs[focus].offsetParent == null && inputs.length >= focus)focus++;
                if (inputs[focus]) $input = $aa2bd8933167d9cb$export$2fa187e846a241c4(inputs[focus]);
            } else if (typeof focus === 'string') $input = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.box).find(`[name='${focus}']`);
            if ($input.length > 0) $input.get(0).focus();
            return $input;
        }
    }
    /**
 * Part of w2ui 2.0 library
 *  - Dependencies: mQuery, w2utils, w2base, w2tooltip, w2color, w2menu, w2date
 *
 * == TODO ==
 *  - upload (regular files)
 *  - BUG with prefix/postfix and arrows (test in different contexts)
 *  - multiple date selection
 *  - month selection, year selections
 *  - MultiSelect - Allow Copy/Paste for single and multi values
 *  - add routeData to list/enum
 *  - ENUM, LIST: should have same as grid (limit, offset, search, sort)
 *  - ENUM, LIST: should support wild chars
 *  - add selection of predefined times (used for appointments)
 *  - options.items - can be an array
 *  - options.msgNoItems - can be a function
 *  - REMOTE fields
 *
 * == 2.0 changes
 *  - removed jQuery dependency
 *  - enum options.autoAdd
 *  - [numeric, date] - options.autoCorrect to enforce range and validity
 *  - silent only left for files, removed form the rest
 *  - remote source response items => records or just an array
 *  - deprecated "success" field for remote source response
 *  - CSP - fixed inline events
 *  - remove clear, use reset instead
 *  - options.msgSearch
 *  - options.msgNoItems
 */ class $aa2bd8933167d9cb$export$b011ec2f2c6bab8b extends $aa2bd8933167d9cb$export$3bc12ae4e0bb7487 {
        constructor(type, options){
            super();
            // sanitization
            if (typeof type == 'string' && options == null) options = {
                type: type
            };
            if (typeof type == 'object' && options == null) options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(type);
            if (typeof type == 'string' && typeof options == 'object') options.type = type;
            options.type = String(options.type).toLowerCase();
            this.el = options.el ?? null;
            this.selected = null;
            this.helpers = {} // object or helper elements
            ;
            this.type = options.type ?? 'text';
            this.options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(options);
            this.onClick = options.onClick ?? null;
            this.onAdd = options.onAdd ?? null;
            this.onNew = options.onNew ?? null;
            this.onRemove = options.onRemove ?? null;
            this.onMouseEnter = options.onMouseEnter ?? null;
            this.onMouseLeave = options.onMouseLeave ?? null;
            this.onScroll = options.onScroll ?? null;
            this.tmp = {} // temp object
            ;
            // clean up some options
            delete this.options.type;
            delete this.options.onClick;
            delete this.options.onMouseEnter;
            delete this.options.onMouseLeave;
            delete this.options.onScroll;
            if (this.el) this.render(this.el);
        }
        render(el) {
            if (!(el instanceof HTMLElement)) {
                console.log('ERROR: Cannot init w2field on empty subject');
                return;
            }
            if (el._w2field) el._w2field.reset() // will remove all previous events
            ;
            else el._w2field = this;
            this.el = el;
            this.init();
        }
        init() {
            let options = this.options;
            let defaults;
            // only for INPUT or TEXTAREA
            if (![
                'INPUT',
                'TEXTAREA'
            ].includes(this.el.tagName.toUpperCase())) {
                console.log('ERROR: w2field could only be applied to INPUT or TEXTAREA.', this.el);
                return;
            }
            switch(this.type){
                case 'text':
                case 'int':
                case 'float':
                case 'money':
                case 'currency':
                case 'percent':
                case 'alphanumeric':
                case 'bin':
                case 'hex':
                    defaults = {
                        min: null,
                        max: null,
                        step: 1,
                        autoFormat: true,
                        autoCorrect: true,
                        currencyPrefix: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.currencyPrefix,
                        currencySuffix: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.currencySuffix,
                        currencyPrecision: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.currencyPrecision,
                        decimalSymbol: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.decimalSymbol,
                        groupSymbol: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.groupSymbol,
                        arrow: false,
                        keyboard: true,
                        precision: null,
                        prefix: '',
                        suffix: ''
                    };
                    this.options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, defaults, options);
                    options = this.options // since object is re-created, need to re-assign
                    ;
                    options.numberRE = new RegExp('[' + options.groupSymbol + ']', 'g');
                    options.moneyRE = new RegExp('[' + options.currencyPrefix + options.currencySuffix + options.groupSymbol + ']', 'g');
                    options.percentRE = new RegExp('[' + options.groupSymbol + '%]', 'g');
                    // no keyboard support needed
                    if ([
                        'text',
                        'alphanumeric',
                        'hex',
                        'bin'
                    ].includes(this.type)) {
                        options.arrow = false;
                        options.keyboard = false;
                    }
                    break;
                case 'color':
                    defaults = {
                        prefix: '#',
                        suffix: `<div style="width: ${parseInt(getComputedStyle(this.el)['font-size']) || 12}px">&#160;</div>`,
                        arrow: false,
                        advanced: null,
                        transparent: true
                    };
                    this.options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, defaults, options);
                    options = this.options // since object is re-created, need to re-assign
                    ;
                    break;
                case 'date':
                    defaults = {
                        format: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat,
                        keyboard: true,
                        autoCorrect: true,
                        start: null,
                        end: null,
                        blockDates: [],
                        blockWeekdays: [],
                        colored: {},
                        btnNow: true
                    };
                    this.options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                        type: 'date'
                    }, defaults, options);
                    options = this.options // since object is re-created, need to re-assign
                    ;
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder') == null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder', options.format);
                    break;
                case 'time':
                    defaults = {
                        format: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.timeFormat,
                        keyboard: true,
                        autoCorrect: true,
                        start: null,
                        end: null,
                        btnNow: true,
                        noMinutes: false
                    };
                    this.options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                        type: 'time'
                    }, defaults, options);
                    options = this.options // since object is re-created, need to re-assign
                    ;
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder') == null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder', options.format);
                    break;
                case 'datetime':
                    defaults = {
                        format: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.dateFormat + '|' + $aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.timeFormat,
                        keyboard: true,
                        autoCorrect: true,
                        start: null,
                        end: null,
                        startTime: null,
                        endTime: null,
                        blockDates: [],
                        blockWeekdays: [],
                        colored: {},
                        btnNow: true,
                        noMinutes: false
                    };
                    this.options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                        type: 'datetime'
                    }, defaults, options);
                    options = this.options // since object is re-created, need to re-assign
                    ;
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder') == null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder', options.placeholder || options.format);
                    break;
                case 'list':
                case 'combo':
                    {
                        defaults = {
                            items: [],
                            selected: {},
                            url: null,
                            recId: null,
                            recText: null,
                            method: null,
                            debounce: 250,
                            postData: {},
                            minLength: 1,
                            cacheMax: 250,
                            maxDropHeight: 350,
                            maxDropWidth: null,
                            minDropWidth: null,
                            match: 'begins',
                            icon: null,
                            iconStyle: '',
                            align: 'both',
                            altRows: true,
                            renderDrop: null,
                            compare: null,
                            filter: true,
                            hideSelected: false,
                            prefix: '',
                            suffix: '',
                            msgNoItems: 'No matches',
                            msgSearch: 'Type to search...',
                            openOnFocus: false,
                            markSearch: false,
                            onSearch: null,
                            onRequest: null,
                            onLoad: null,
                            onError: null // when data fails to load due to server error or other failure modes
                        };
                        if (typeof options.items == 'function') options._items_fun = options.items;
                        // need to be first
                        options.items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, options.items);
                        if (this.type === 'list') {
                            // defaults.search = (options.items && options.items.length >= 10 ? true : false);
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).addClass('w2ui-select');
                            // if simple value - look it up
                            if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(options.selected) && Array.isArray(options.items)) options.items.forEach((item)=>{
                                if (item && item.id === options.selected) options.selected = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.clone(item);
                            });
                        }
                        options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, defaults, options);
                        // validate match
                        let valid = [
                            'is',
                            'begins',
                            'contains',
                            'ends'
                        ];
                        if (!valid.includes(options.match)) console.log(`ERROR: invalid value "${options.match}" for option.match. It should be one of following: ${valid.join(', ')}.`);
                        this.options = options;
                        if (!$aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(options.selected)) options.selected = {};
                        this.selected = options.selected;
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('autocapitalize', 'off').attr('autocomplete', 'off').attr('autocorrect', 'off').attr('spellcheck', 'false');
                        if (options.selected.text != null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(options.selected.text);
                        break;
                    }
                case 'enum':
                    {
                        defaults = {
                            items: [],
                            selected: [],
                            max: 0,
                            url: null,
                            recId: null,
                            recText: null,
                            debounce: 250,
                            method: null,
                            postData: {},
                            minLength: 1,
                            cacheMax: 250,
                            maxItemWidth: 250,
                            maxDropHeight: 350,
                            maxDropWidth: null,
                            match: 'begins',
                            align: '',
                            altRows: true,
                            openOnFocus: false,
                            markSearch: false,
                            renderDrop: null,
                            renderItem: null,
                            compare: null,
                            filter: true,
                            hideSelected: true,
                            style: '',
                            msgNoItems: 'No matches',
                            msgSearch: 'Type to search...',
                            onSearch: null,
                            onRequest: null,
                            onLoad: null,
                            onError: null,
                            onClick: null,
                            onAdd: null,
                            onNew: null,
                            onRemove: null,
                            onMouseEnter: null,
                            onMouseLeave: null,
                            onScroll: null // when div with selected items is scrolled
                        };
                        options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, defaults, options, {
                            suffix: ''
                        });
                        if (typeof options.items == 'function') options._items_fun = options.items;
                        // validate match
                        let valid = [
                            'is',
                            'begins',
                            'contains',
                            'ends'
                        ];
                        if (!valid.includes(options.match)) console.log(`ERROR: invalid value "${option.match}" for option.match. It should be one of following: ${valid.join(', ')}.`);
                        options.items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, options.items);
                        options.selected = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, options.selected);
                        this.options = options;
                        if (!Array.isArray(options.selected)) options.selected = [];
                        this.selected = options.selected;
                        break;
                    }
                case 'file':
                    defaults = {
                        selected: [],
                        max: 0,
                        maxSize: 0,
                        maxFileSize: 0,
                        maxItemWidth: 250,
                        maxDropHeight: 350,
                        maxDropWidth: null,
                        readContent: true,
                        silent: true,
                        align: 'both',
                        altRows: true,
                        renderItem: null,
                        style: '',
                        onClick: null,
                        onAdd: null,
                        onRemove: null,
                        onMouseEnter: null,
                        onMouseLeave: null // when an item is mouse out
                    };
                    options = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, defaults, options);
                    this.options = options;
                    if (!Array.isArray(options.selected)) options.selected = [];
                    this.selected = options.selected;
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder') == null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder', $aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Attach files by dragging and dropping or Click to Select'));
                    break;
                default:
                    console.log(`ERROR: field type "${this.type}" is not supported.`);
                    break;
            }
            // attach events
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css('box-sizing', 'border-box').addClass('w2field w2ui-input').off('.w2field').on('change.w2field', (event1)=>{
                this.change(event1);
            }).on('click.w2field', (event1)=>{
                this.click(event1);
            }).on('focus.w2field', (event1)=>{
                this.focus(event1);
            }).on('blur.w2field', (event1)=>{
                if (this.type !== 'list') this.blur(event1);
            }).on('keydown.w2field', (event1)=>{
                this.keyDown(event1);
            }).on('keyup.w2field', (event1)=>{
                this.keyUp(event1);
            });
            // suffix and prefix need to be after styles
            this.addPrefix() // only will add if needed
            ;
            this.addSuffix() // only will add if needed
            ;
            this.addSearch();
            this.addMultiSearch();
            // this.refresh() // do not call refresh, on change will trigger refresh (for list at list)
            // format initial value
            this.change(new Event('change'));
        }
        get() {
            let ret;
            if ([
                'list',
                'enum',
                'file'
            ].indexOf(this.type) !== -1) ret = this.selected;
            else ret = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val();
            return ret;
        }
        set(val, append) {
            if ([
                'list',
                'enum',
                'file'
            ].indexOf(this.type) !== -1) {
                if (this.type !== 'list' && append) {
                    if (!Array.isArray(this.selected)) this.selected = [];
                    this.selected.push(val);
                    // update selected array in overlay
                    let overlay = $aa2bd8933167d9cb$export$3842f79f22e98342.get(this.el.id + '_menu');
                    if (overlay) overlay.options.selected = this.selected;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).trigger('input').trigger('change');
                } else {
                    if (val == null) val = [];
                    let it = this.type === 'enum' && !Array.isArray(val) ? [
                        val
                    ] : val;
                    this.selected = it;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).trigger('input').trigger('change');
                }
                this.refresh();
            } else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(val);
        }
        setIndex(ind, append) {
            if ([
                'list',
                'enum'
            ].indexOf(this.type) !== -1) {
                let items = this.options.items;
                if (items && items[ind]) {
                    if (this.type == 'list') this.selected = items[ind];
                    if (this.type == 'enum') {
                        if (!append) this.selected = [];
                        this.selected.push(items[ind]);
                    }
                    let overlay = $aa2bd8933167d9cb$export$3842f79f22e98342.get(this.el.id + '_menu');
                    if (overlay) overlay.options.selected = this.selected;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).trigger('input').trigger('change');
                    this.refresh();
                    return true;
                }
            }
            return false;
        }
        refresh() {
            let options = this.options;
            let time = Date.now();
            let styles = getComputedStyle(this.el);
            // enum
            if (this.type == 'list') {
                // next line will not work in a form with span: -1
                // query(this.el).parent().css('white-space', 'nowrap') // needs this for arrow always to appear on the right side
                // hide focus and show text
                if (this.helpers.prefix) this.helpers.prefix.hide();
                if (!this.helpers.search) return;
                // if empty show no icon
                if (this.selected == null && options.icon) {
                    options.prefix = `
                    <span class="w2ui-icon ${options.icon} "style="cursor: pointer; font-size: 14px;
                        display: inline-block; margin-top: -1px; color: #7F98AD; ${options.iconStyle}">
                    </span>`;
                    this.addPrefix();
                } else {
                    options.prefix = '';
                    this.addPrefix();
                }
                // focus helper
                let focus = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.search_focus);
                let icon = $aa2bd8933167d9cb$export$2fa187e846a241c4(focus[0].previousElementSibling);
                focus.css({
                    outline: 'none'
                });
                if (focus.val() === '') {
                    focus.css('opacity', 0);
                    icon.css('opacity', 0);
                    if (this.selected?.id) {
                        let text = this.selected.text;
                        let ind = this.findItemIndex(options.items, this.selected.id);
                        if (text != null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang(text)).data({
                            selected: text,
                            selectedIndex: ind[0]
                        });
                    } else {
                        this.el.value = '';
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).removeData('selected selectedIndex');
                    }
                } else {
                    focus.css('opacity', 1);
                    icon.css('opacity', 1);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val('');
                    setTimeout(()=>{
                        if (this.helpers.prefix) this.helpers.prefix.hide();
                        if (options.icon) {
                            focus.css('margin-left', '17px');
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.search).find('.w2ui-icon-search').addClass('show-search');
                        } else {
                            focus.css('margin-left', '0px');
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.search).find('.w2ui-icon-search').removeClass('show-search');
                        }
                    }, 1);
                }
                // if readonly or denied
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) setTimeout(()=>{
                    if (this.helpers.prefix) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.prefix).css('opacity', '0.6');
                    if (this.helpers.suffix) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.suffix).css('opacity', '0.6');
                }, 1);
                else setTimeout(()=>{
                    if (this.helpers.prefix) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.prefix).css('opacity', '1');
                    if (this.helpers.suffix) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.suffix).css('opacity', '1');
                }, 1);
            }
            let div = this.helpers.multi;
            if ([
                'enum',
                'file'
            ].includes(this.type) && div) {
                let html = '';
                if (Array.isArray(this.selected)) this.selected.forEach((it, ind)=>{
                    if (it == null) return;
                    html += `
                        <div class="li-item" index="${ind}" style="max-width: ${parseInt(options.maxItemWidth)}px; ${it.style ? it.style : ''}">
                        ${typeof options.renderItem === 'function' ? options.renderItem(it, ind, `<div class="w2ui-list-remove" index="${ind}">&#160;&#160;</div>`) : `
                               ${it.icon ? `<span class="w2ui-icon ${it.icon}"></span>` : ''}
                               <div class="w2ui-list-remove" index="${ind}">&#160;&#160;</div>
                               ${(this.type === 'enum' ? it.text : it.name) ?? it.id ?? it}
                               ${it.size ? `<span class="file-size"> - ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatSize(it.size)}</span>` : ''}
                            `}
                        </div>`;
                });
                let ul = div.find('.w2ui-multi-items');
                if (options.style) div.attr('style', div.attr('style') + ';' + options.style);
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css('z-index', '-1');
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) setTimeout(()=>{
                    div[0].scrollTop = 0 // scroll to the top
                    ;
                    div.addClass('w2ui-readonly').find('.li-item').css('opacity', '0.9').parent().find('.li-search').hide().find('input').prop('readOnly', true).closest('.w2ui-multi-items').find('.w2ui-list-remove').hide();
                }, 1);
                else setTimeout(()=>{
                    div.removeClass('w2ui-readonly').find('.li-item').css('opacity', '1').parent().find('.li-search').show().find('input').prop('readOnly', false).closest('.w2ui-multi-items').find('.w2ui-list-remove').show();
                }, 1);
                // clean
                if (this.selected?.length > 0) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder', '');
                div.find('.w2ui-enum-placeholder').remove();
                ul.find('.li-item').remove();
                // add new list
                if (html !== '') ul.prepend(html);
                else if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder') != null && div.find('input').val() === '') {
                    let style = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripSpaces(`
                    padding-top: ${styles['padding-top']};
                    padding-left: ${styles['padding-left']};
                    box-sizing: ${styles['box-sizing']};
                    line-height: ${styles['line-height']};
                    font-size: ${styles['font-size']};
                    font-family: ${styles['font-family']};
                `);
                    div.prepend(`<div class="w2ui-enum-placeholder" style="${style}">${$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder')}</div>`);
                }
                // ITEMS events
                div.off('.w2item').on('scroll.w2item', (event1)=>{
                    let edata = this.trigger('scroll', {
                        target: this.el,
                        originalEvent: event1
                    });
                    if (edata.isCancelled === true) return;
                    // hide tooltip if any
                    $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.el.id + '_preview');
                    // event after
                    edata.finish();
                }).find('.li-item').on('click.w2item', (event1)=>{
                    let target = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.li-item');
                    let index = target.attr('index');
                    let item = this.selected[index];
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(target).hasClass('li-search')) return;
                    event1.stopPropagation();
                    let edata;
                    // default behavior
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('w2ui-list-remove')) {
                        if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                        // trigger event
                        edata = this.trigger('remove', {
                            target: this.el,
                            originalEvent: event1,
                            item: item
                        });
                        if (edata.isCancelled === true) return;
                        // default behavior
                        this.selected.splice(index, 1);
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).trigger('input').trigger('change');
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).remove();
                    } else {
                        // trigger event
                        edata = this.trigger('click', {
                            target: this.el,
                            originalEvent: event1.originalEvent,
                            item: item
                        });
                        if (edata.isCancelled === true) return;
                        // if file - show image preview
                        let preview = item.tooltip;
                        if (this.type === 'file') {
                            if (/image/i.test(item.type)) preview = `
                                    <div class="w2ui-file-preview">
                                        <img src="${item.content ? 'data:' + item.type + ';base64,' + item.content : ''}"
                                            style="max-width: 300px">
                                    </div>`;
                            preview += `
                                <div class="w2ui-file-info">
                                    <div class="file-caption">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Name')}:</div>
                                    <div class="file-value">${item.name}</div>
                                    <div class="file-caption">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Size')}:</div>
                                    <div class="file-value">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatSize(item.size)}</div>
                                    <div class="file-caption">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Type')}:</div>
                                    <div class="file-value file-type">${item.type}</div>
                                    <div class="file-caption">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Modified')}:</div>
                                    <div class="file-value">${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.date(item.modified)}</div>
                                </div>`;
                        }
                        if (preview) {
                            let name = this.el.id + '_preview';
                            $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                                name: name,
                                anchor: target.get(0),
                                html: preview,
                                hideOn: [
                                    'doc-click'
                                ],
                                class: ''
                            }).show((event1)=>{
                                let $img = $aa2bd8933167d9cb$export$2fa187e846a241c4(`#w2overlay-${name} img`);
                                $img.on('load', function(event1) {
                                    let w = this.clientWidth;
                                    let h = this.clientHeight;
                                    if (w < 300 & h < 300) return;
                                    if (w >= h && w > 300) $aa2bd8933167d9cb$export$2fa187e846a241c4(this).css('width', '300px');
                                    if (w < h && h > 300) $aa2bd8933167d9cb$export$2fa187e846a241c4(this).css('height', '300px');
                                }).on('error', function(event1) {
                                    this.style.display = 'none';
                                });
                            });
                        }
                        edata.finish();
                    }
                }).on('mouseenter.w2item', (event1)=>{
                    let target = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.li-item');
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(target).hasClass('li-search')) return;
                    let item = this.selected[$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('index')];
                    // trigger event
                    let edata = this.trigger('mouseEnter', {
                        target: this.el,
                        originalEvent: event1,
                        item: item
                    });
                    if (edata.isCancelled === true) return;
                    // event after
                    edata.finish();
                }).on('mouseleave.w2item', (event1)=>{
                    let target = $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).closest('.li-item');
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(target).hasClass('li-search')) return;
                    let item = this.selected[$aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).attr('index')];
                    // trigger event
                    let edata = this.trigger('mouseLeave', {
                        target: this.el,
                        originalEvent: event1,
                        item: item
                    });
                    if (edata.isCancelled === true) return;
                    // event after
                    edata.finish();
                });
                // update size for enum, hide for file
                if (this.type === 'enum') {
                    let search = this.helpers.multi.find('input');
                    search.css({
                        width: '15px'
                    });
                } else this.helpers.multi.find('.li-search').hide();
                this.resize();
            }
            return Date.now() - time;
        }
        // resizing width of list, enum, file controls
        resize() {
            let width = this.el.clientWidth;
            // let height = this.el.clientHeight
            // if (this.tmp.current_width == width && height > 0) return
            let styles = getComputedStyle(this.el);
            let focus = this.helpers.search;
            let multi = this.helpers.multi;
            let suffix = this.helpers.suffix;
            let prefix = this.helpers.prefix;
            // resize helpers
            if (focus) $aa2bd8933167d9cb$export$2fa187e846a241c4(focus).css('width', width);
            if (multi) $aa2bd8933167d9cb$export$2fa187e846a241c4(multi).css('width', width - parseInt(styles['margin-left'], 10) - parseInt(styles['margin-right'], 10));
            if (suffix) this.addSuffix();
            if (prefix) this.addPrefix();
            // enum or file
            let div = this.helpers.multi;
            if ([
                'enum',
                'file'
            ].includes(this.type) && div) {
                // adjust height
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css('height', '');
                let cntHeight = $aa2bd8933167d9cb$export$2fa187e846a241c4(div).find(':scope div.w2ui-multi-items').get(0).clientHeight + 5;
                if (cntHeight < 20) cntHeight = 20;
                // max height
                if (cntHeight > this.tmp['max-height']) cntHeight = this.tmp['max-height'];
                // min height
                if (cntHeight < this.tmp['min-height']) cntHeight = this.tmp['min-height'];
                let inpHeight = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(this.el, 'height') - 2;
                if (inpHeight > cntHeight) cntHeight = inpHeight;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(div).css({
                    'height': cntHeight + 'px',
                    overflow: cntHeight == this.tmp['max-height'] ? 'auto' : 'hidden'
                });
                $aa2bd8933167d9cb$export$2fa187e846a241c4(div).css('height', cntHeight + 'px');
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css({
                    'height': cntHeight + 'px'
                });
            }
            // remember width
            this.tmp.current_width = width;
        }
        reset() {
            // restore paddings
            if (this.tmp != null) {
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css('height', '');
                Array('padding-left', 'padding-right', 'background-color', 'border-color').forEach((prop)=>{
                    if (this.tmp && this.tmp['old-' + prop] != null) {
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css(prop, this.tmp['old-' + prop]);
                        delete this.tmp['old-' + prop];
                    }
                });
                // remove resize watcher
                clearInterval(this.tmp.sizeTimer);
            }
            // remove events and (data)
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(this.clean($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val())).removeClass('w2field w2ui-input').removeData('selected selectedIndex').off('.w2field') // remove only events added by w2field
            ;
            // remove helpers
            Object.keys(this.helpers).forEach((key)=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers[key]).remove();
            });
            this.helpers = {};
        }
        clean(val) {
            // issue #499
            if (typeof val === 'number') return val;
            let options = this.options;
            val = String(val).trim();
            // clean
            if ([
                'int',
                'float',
                'money',
                'currency',
                'percent'
            ].includes(this.type)) {
                if (typeof val === 'string') {
                    if (options.autoFormat) {
                        if ([
                            'money',
                            'currency'
                        ].includes(this.type)) val = String(val).replace(options.moneyRE, '');
                        if (this.type === 'percent') val = String(val).replace(options.percentRE, '');
                        if ([
                            'int',
                            'float'
                        ].includes(this.type)) val = String(val).replace(options.numberRE, '');
                    }
                    val = val.replace(/\s+/g, '').replace(new RegExp(options.groupSymbol, 'g'), '').replace(options.decimalSymbol, '.');
                }
                if (val !== '' && $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(val)) val = Number(val);
                else val = '';
            }
            return val;
        }
        format(val) {
            let options = this.options;
            // auto format numbers or money
            if (options.autoFormat && val !== '') {
                switch(this.type){
                    case 'money':
                    case 'currency':
                        val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(val, options.currencyPrecision, true);
                        if (val !== '') val = options.currencyPrefix + val + options.currencySuffix;
                        break;
                    case 'percent':
                        val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(val, options.precision, true);
                        if (val !== '') val += '%';
                        break;
                    case 'float':
                        val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(val, options.precision, true);
                        break;
                    case 'int':
                        val = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatNumber(val, 0, true);
                        break;
                }
                // if default group symbol does not match - replase it
                let group = parseInt(1000).toLocaleString($aa2bd8933167d9cb$export$fe3767bc112f7a2a.settings.locale, {
                    useGrouping: true
                }).slice(1, 2);
                if (group !== this.options.groupSymbol) val = val.replaceAll(group, this.options.groupSymbol);
            }
            return val;
        }
        change(event1) {
            // numeric
            if ([
                'int',
                'float',
                'money',
                'currency',
                'percent'
            ].indexOf(this.type) !== -1) {
                // check max/min
                let val = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val();
                let new_val = this.format(this.clean($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val()));
                // if was modified
                if (val !== '' && val != new_val) {
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(new_val);
                    // cancel event
                    event1.stopPropagation();
                    event1.preventDefault();
                    return false;
                }
            }
            // color
            if (this.type === 'color') {
                let color = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val();
                if (color.substr(0, 3).toLowerCase() !== 'rgb') {
                    color = '#' + color;
                    let len = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val().length;
                    if (len !== 8 && len !== 6 && len !== 3) color = '';
                }
                let next = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).get(0).nextElementSibling;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(next).find('div').css('background-color', color);
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).hasClass('has-focus')) this.updateOverlay();
            }
            // list, enum
            if ([
                'list',
                'enum',
                'file'
            ].indexOf(this.type) !== -1) this.refresh();
            // date, time
            if ([
                'date',
                'time',
                'datetime'
            ].indexOf(this.type) !== -1) {
                // convert linux timestamps
                let tmp = parseInt(this.el.value);
                if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(this.el.value) && tmp > 3000) {
                    if (this.type === 'time') tmp = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatTime(new Date(tmp), this.options.format);
                    if (this.type === 'date') tmp = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate(new Date(tmp), this.options.format);
                    if (this.type === 'datetime') tmp = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime(new Date(tmp), this.options.format);
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(tmp).trigger('input').trigger('change');
                }
            }
        }
        click(event1) {
            // lists
            if ([
                'list',
                'combo',
                'enum'
            ].includes(this.type)) {
                if (!$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).hasClass('has-focus')) this.focus(event1);
                if (this.type == 'list' || this.type == 'combo') {
                    // if overlay is already open (and not just opened on focus event) then hide it
                    if (!this.tmp.openedOnFocus) {
                        let name = this.el.id + '_menu';
                        let overlay = $aa2bd8933167d9cb$export$3842f79f22e98342.get(name);
                        if (overlay?.displayed) $aa2bd8933167d9cb$export$3842f79f22e98342.hide(name);
                        else this.updateOverlay();
                    }
                    delete this.tmp.openedOnFocus;
                    if (this.type == 'list') event1.stopPropagation();
                }
            }
            // other fields with drops
            if ([
                'date',
                'time',
                'datetime',
                'color'
            ].includes(this.type)) this.updateOverlay();
        }
        focus(event1) {
            if (this.type == 'list' && document.activeElement == this.el) {
                this.helpers.search_focus.focus();
                return;
            }
            // color, date, time
            if ([
                'color',
                'date',
                'time',
                'datetime'
            ].indexOf(this.type) !== -1) {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                this.updateOverlay();
            }
            // menu
            if ([
                'list',
                'combo',
                'enum'
            ].indexOf(this.type) !== -1) {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) {
                    // still add focus
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).addClass('has-focus');
                    return;
                }
                // regenerate items
                if (typeof this.options._items_fun == 'function') this.options.items = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.normMenu.call(this, this.options._items_fun);
                if (this.helpers.search) {
                    let search = this.helpers.search_focus;
                    search.value = '';
                    search.select();
                }
                if (this.type == 'enum') {
                    // file control in particular need to receive focus after file select
                    let search = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el.previousElementSibling).find('.li-search input').get(0);
                    if (document.activeElement !== search) search.focus();
                }
                this.resize();
                // update overlay if needed
                if (event1.showMenu !== false && (this.options.openOnFocus !== false || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).hasClass('has-focus')) && !this.tmp.overlay?.overlay?.displayed) setTimeout(()=>{
                    this.tmp.openedOnFocus = true;
                    this.updateOverlay();
                }, 0) // execute at the end of event loop
                ;
            }
            if (this.type == 'file') {
                let prev = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).get(0).previousElementSibling;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(prev).addClass('has-focus');
            }
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).addClass('has-focus');
        }
        blur(event1) {
            let val = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val().trim();
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).removeClass('has-focus');
            if ([
                'int',
                'float',
                'money',
                'currency',
                'percent'
            ].includes(this.type)) {
                if (val !== '') {
                    let newVal = val;
                    let error = '';
                    if (!this.isStrValid(val)) newVal = '';
                    else {
                        let rVal = this.clean(val);
                        if (this.options.min != null && rVal < this.options.min) {
                            newVal = this.options.min;
                            error = `Should be >= ${this.options.min}`;
                        }
                        if (this.options.max != null && rVal > this.options.max) {
                            newVal = this.options.max;
                            error = `Should be <= ${this.options.max}`;
                        }
                    }
                    if (this.options.autoCorrect) {
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(newVal).trigger('input').trigger('change');
                        if (error) {
                            $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                                name: this.el.id + '_error',
                                anchor: this.el,
                                html: error
                            });
                            setTimeout(()=>{
                                $aa2bd8933167d9cb$export$b876f801a4afd38f.hide(this.el.id + '_error');
                            }, 3000);
                        }
                    }
                }
            }
            // date or time
            if ([
                'date',
                'time',
                'datetime'
            ].includes(this.type) && this.options.autoCorrect) {
                if (val !== '') {
                    let check = this.type == 'date' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate : this.type == 'time' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isTime : $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime;
                    if (!$aa2bd8933167d9cb$export$888613f6d1a8fc97.inRange(this.el.value, this.options) || !check.bind($aa2bd8933167d9cb$export$fe3767bc112f7a2a)(this.el.value, this.options.format)) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val('').trigger('input').trigger('change');
                }
            }
            // clear search input
            if (this.type === 'enum') $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.multi).find('input').val('').css('width', '15px');
            if (this.type == 'file') {
                let prev = this.el.previousElementSibling;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(prev).removeClass('has-focus');
            }
            if (this.type === 'list') this.el.value = this.selected?.text ?? '';
        }
        keyDown(event1, extra) {
            let options = this.options;
            let key = event1.keyCode || extra && extra.keyCode;
            let cancel = false;
            let val, inc, daymil, dt, newValue, newDT;
            // ignore wrong pressed key
            if ([
                'int',
                'float',
                'money',
                'currency',
                'percent',
                'hex',
                'bin',
                'color',
                'alphanumeric'
            ].includes(this.type)) {
                if (!event1.metaKey && !event1.ctrlKey && !event1.altKey) {
                    if (!this.isStrValid(event1.key ?? '1', true) && // valid & is not arrows, dot, comma, etc keys
                    ![
                        9,
                        8,
                        13,
                        27,
                        37,
                        38,
                        39,
                        40,
                        46
                    ].includes(event1.keyCode)) {
                        event1.preventDefault();
                        if (event1.stopPropagation) event1.stopPropagation();
                        else event1.cancelBubble = true;
                        return false;
                    }
                }
            }
            // numeric
            if ([
                'int',
                'float',
                'money',
                'currency',
                'percent'
            ].includes(this.type)) {
                if (!options.keyboard || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                val = parseFloat($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val().replace(options.moneyRE, '')) || 0;
                inc = options.step;
                if (event1.ctrlKey || event1.metaKey) inc = options.step * 10;
                switch(key){
                    case 38:
                        if (event1.shiftKey) break; // no action if shift key is pressed
                        newValue = val + inc <= options.max || options.max == null ? Number((val + inc).toFixed(12)) : options.max;
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(newValue).trigger('input').trigger('change');
                        cancel = true;
                        break;
                    case 40:
                        if (event1.shiftKey) break; // no action if shift key is pressed
                        newValue = val - inc >= options.min || options.min == null ? Number((val - inc).toFixed(12)) : options.min;
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(newValue).trigger('input').trigger('change');
                        cancel = true;
                        break;
                }
                if (cancel) {
                    event1.preventDefault();
                    this.moveCaret2end();
                }
            }
            // date/datetime
            if ([
                'date',
                'datetime'
            ].includes(this.type)) {
                if (!options.keyboard || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                let is = (this.type == 'date' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDate : $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isDateTime).bind($aa2bd8933167d9cb$export$fe3767bc112f7a2a);
                let format = (this.type == 'date' ? $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDate : $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatDateTime).bind($aa2bd8933167d9cb$export$fe3767bc112f7a2a);
                daymil = 86400000;
                inc = 1;
                if (event1.ctrlKey || event1.metaKey) inc = 10 // by month
                ;
                dt = is($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(), options.format, true);
                if (!dt) {
                    dt = new Date();
                    daymil = 0;
                }
                switch(key){
                    case 38:
                        if (event1.shiftKey) break; // no action if shift key is pressed
                        if (inc == 10) dt.setMonth(dt.getMonth() + 1);
                        else dt.setTime(dt.getTime() + daymil);
                        newDT = format(dt.getTime(), options.format);
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(newDT).trigger('input').trigger('change');
                        cancel = true;
                        break;
                    case 40:
                        if (event1.shiftKey) break; // no action if shift key is pressed
                        if (inc == 10) dt.setMonth(dt.getMonth() - 1);
                        else dt.setTime(dt.getTime() - daymil);
                        newDT = format(dt.getTime(), options.format);
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(newDT).trigger('input').trigger('change');
                        cancel = true;
                        break;
                }
                if (cancel) {
                    event1.preventDefault();
                    this.moveCaret2end();
                    this.updateOverlay();
                }
            }
            // time
            if (this.type === 'time') {
                if (!options.keyboard || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                inc = event1.ctrlKey || event1.metaKey ? 60 : 1;
                val = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val();
                let time = $aa2bd8933167d9cb$export$888613f6d1a8fc97.str2min(val) || $aa2bd8933167d9cb$export$888613f6d1a8fc97.str2min(new Date().getHours() + ':' + (new Date().getMinutes() - 1));
                switch(key){
                    case 38:
                        if (event1.shiftKey) break; // no action if shift key is pressed
                        time += inc;
                        cancel = true;
                        break;
                    case 40:
                        if (event1.shiftKey) break; // no action if shift key is pressed
                        time -= inc;
                        cancel = true;
                        break;
                }
                if (cancel) {
                    event1.preventDefault();
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val($aa2bd8933167d9cb$export$888613f6d1a8fc97.min2str(time)).trigger('input').trigger('change');
                    this.moveCaret2end();
                }
            }
            // list/enum
            if ([
                'list',
                'enum'
            ].includes(this.type)) switch(key){
                case 8:
                case 46:
                    if (this.type == 'list') {
                        let search = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.search_focus);
                        if (search.val() == '') {
                            this.selected = null;
                            $aa2bd8933167d9cb$export$3842f79f22e98342.hide(this.el.id + '_menu');
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val('').trigger('input').trigger('change');
                        }
                    } else {
                        let search = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.multi).find('input');
                        if (search.val() == '') {
                            $aa2bd8933167d9cb$export$3842f79f22e98342.hide(this.el.id + '_menu');
                            this.selected.pop();
                            // update selected array in overlay
                            let overlay = $aa2bd8933167d9cb$export$3842f79f22e98342.get(this.el.id + '_menu');
                            if (overlay) overlay.options.selected = this.selected;
                            this.refresh();
                        }
                    }
                    break;
                case 9:
                case 16:
                    break;
                case 27:
                    $aa2bd8933167d9cb$export$3842f79f22e98342.hide(this.el.id + '_menu');
                    this.refresh();
                    break;
                default:
            }
        }
        keyUp(event1) {
            if (this.type == 'list') {
                let search = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.search_focus);
                if (search.val() !== '') $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder', '');
                else $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder', this.tmp.pholder);
                if (event1.keyCode == 13) setTimeout(()=>{
                    search.val('');
                    $aa2bd8933167d9cb$export$3842f79f22e98342.hide(this.el.id + '_menu');
                    this.refresh();
                }, 1);
                // if arrows are clicked, it will show overlay
                if ([
                    38,
                    40
                ].includes(event1.keyCode) && !this.tmp.overlay?.overlay?.displayed) this.updateOverlay();
                this.refresh();
            }
            if (this.type == 'combo') {
                if (![
                    9,
                    16,
                    27
                ].includes(event1.keyCode) && this.options.openOnFocus !== true) this.updateOverlay();
                // if arrows are clicked, it will show overlay
                if ([
                    38,
                    40
                ].includes(event1.keyCode) && !this.tmp.overlay?.overlay?.displayed) this.updateOverlay();
            }
            if (this.type == 'enum') {
                let search = this.helpers.multi.find('input');
                let styles = getComputedStyle(search.get(0));
                let width = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.getStrWidth(search.val(), `font-family: ${styles['font-family']}; font-size: ${styles['font-size']};`);
                search.css({
                    width: width + 15 + 'px'
                });
                this.resize();
                // if arrows are clicked, it will show overlay
                if ([
                    38,
                    40
                ].includes(event1.keyCode) && !this.tmp.overlay?.overlay?.displayed) this.updateOverlay();
            }
        }
        findItemIndex(items, id, parents) {
            let inds = [];
            if (!parents) parents = [];
            if ([
                'list',
                'combo',
                'enum'
            ].includes(this.type) && this.options.url) {
                // remove source, so get it from overlay
                let overlay = $aa2bd8933167d9cb$export$3842f79f22e98342.get(this.el.id + '_menu');
                if (overlay) {
                    items = overlay.options.items;
                    this.options.items = items;
                }
            }
            items.forEach((item, ind)=>{
                if (item.id === id) {
                    inds = parents.concat([
                        ind
                    ]);
                    this.options.index = [
                        ind
                    ];
                }
                if (inds.length == 0 && item.items && item.items.length > 0) {
                    parents.push(ind);
                    inds = this.findItemIndex(item.items, id, parents);
                    parents.pop();
                }
            });
            return inds;
        }
        updateOverlay(indexOnly) {
            let options = this.options;
            let params;
            // color
            if (this.type === 'color') {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                $aa2bd8933167d9cb$export$550f94414263c7a1.show($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                    name: this.el.id + '_color',
                    anchor: this.el,
                    transparent: options.transparent,
                    advanced: options.advanced,
                    color: this.el.value,
                    liveUpdate: true
                }, this.options)).select((event1)=>{
                    let color = event1.detail.color;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(color).trigger('input').trigger('change');
                }).liveUpdate((event1)=>{
                    let color = event1.detail.color;
                    $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.suffix).find(':scope > div').css('background-color', '#' + color);
                });
            }
            // list
            if ([
                'list',
                'combo',
                'enum'
            ].includes(this.type)) {
                let el = this.el;
                let input = this.el;
                if (this.type === 'enum') {
                    el = this.helpers.multi.get(0);
                    input = $aa2bd8933167d9cb$export$2fa187e846a241c4(el).find('input').get(0);
                }
                if (this.type === 'list') {
                    let sel = this.selected;
                    if ($aa2bd8933167d9cb$export$fe3767bc112f7a2a.isPlainObject(sel) && Object.keys(sel).length > 0) {
                        let ind = this.findItemIndex(options.items, sel.id);
                        if (ind.length > 0) options.index = ind;
                    }
                    input = this.helpers.search_focus;
                }
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).hasClass('has-focus') && !this.el.readOnly && !this.el.disabled) {
                    params = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({}, options, {
                        name: this.el.id + '_menu',
                        anchor: input,
                        selected: this.selected,
                        search: false,
                        render: options.renderDrop,
                        anchorClass: '',
                        offsetY: 5,
                        maxHeight: options.maxDropHeight,
                        maxWidth: options.maxDropWidth,
                        minWidth: options.minDropWidth // TODO: check
                    });
                    this.tmp.overlay = $aa2bd8933167d9cb$export$3842f79f22e98342.show(params).select((event1)=>{
                        if ([
                            'list',
                            'combo'
                        ].includes(this.type)) {
                            this.selected = event1.detail.item;
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(input).val('');
                            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(this.selected.text).trigger('input').trigger('change');
                            this.focus({
                                showMenu: false
                            });
                        } else {
                            let selected = this.selected;
                            let newItem = event1.detail?.item;
                            if (newItem) {
                                // trigger event
                                let edata = this.trigger('add', {
                                    target: this.el,
                                    item: newItem,
                                    originalEvent: event1
                                });
                                if (edata.isCancelled === true) return;
                                // default behavior
                                if (selected.length >= options.max && options.max > 0) selected.pop();
                                delete newItem.hidden;
                                selected.push(newItem);
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).trigger('input').trigger('change');
                                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.multi).find('input').val('');
                                // updaet selected array in overlays
                                let overlay = $aa2bd8933167d9cb$export$3842f79f22e98342.get(this.el.id + '_menu');
                                if (overlay) overlay.options.selected = this.selected;
                                // event after
                                edata.finish();
                            }
                        }
                    });
                }
            }
            // date
            if ([
                'date',
                'time',
                'datetime'
            ].includes(this.type)) {
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                $aa2bd8933167d9cb$export$888613f6d1a8fc97.show($aa2bd8933167d9cb$export$fe3767bc112f7a2a.extend({
                    name: this.el.id + '_date',
                    anchor: this.el,
                    value: this.el.value
                }, this.options)).select((event1)=>{
                    let date = event1.detail.date;
                    if (date != null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).val(date).trigger('input').trigger('change');
                });
            }
        }
        /*
    *  INTERNAL FUNCTIONS
    */ isStrValid(ch, loose) {
            let isValid = true;
            switch(this.type){
                case 'int':
                    if (loose && [
                        '-',
                        this.options.groupSymbol
                    ].includes(ch)) isValid = true;
                    else isValid = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isInt(ch.replace(this.options.numberRE, ''));
                    break;
                case 'percent':
                    ch = ch.replace(/%/g, '');
                case 'float':
                    if (loose && [
                        '-',
                        '',
                        this.options.decimalSymbol,
                        this.options.groupSymbol
                    ].includes(ch)) isValid = true;
                    else isValid = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(ch.replace(this.options.numberRE, ''));
                    break;
                case 'money':
                case 'currency':
                    if (loose && [
                        '-',
                        this.options.decimalSymbol,
                        this.options.groupSymbol,
                        this.options.currencyPrefix,
                        this.options.currencySuffix
                    ].includes(ch)) isValid = true;
                    else isValid = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isFloat(ch.replace(this.options.moneyRE, ''));
                    break;
                case 'bin':
                    isValid = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isBin(ch);
                    break;
                case 'color':
                case 'hex':
                    isValid = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isHex(ch);
                    break;
                case 'alphanumeric':
                    isValid = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.isAlphaNumeric(ch);
                    break;
            }
            return isValid;
        }
        addPrefix() {
            if (!this.options.prefix) return;
            let helper;
            let styles = getComputedStyle(this.el);
            if (this.tmp['old-padding-left'] == null) this.tmp['old-padding-left'] = styles['padding-left'];
            // remove if already displayed
            if (this.helpers.prefix) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.prefix).remove();
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).before(`<div class="w2ui-field-helper">${this.options.prefix}</div>`);
            helper = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).get(0).previousElementSibling;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(helper).css({
                'color': styles.color,
                'font-family': styles['font-family'],
                'font-size': styles['font-size'],
                'height': this.el.clientHeight + 'px',
                'padding-top': styles['padding-top'],
                'padding-bottom': styles['padding-bottom'],
                'padding-left': this.tmp['old-padding-left'],
                'padding-right': 0,
                'margin-top': parseInt(styles['margin-top'], 10) + 2 + 'px',
                'margin-bottom': parseInt(styles['margin-bottom'], 10) + 1 + 'px',
                'margin-left': styles['margin-left'],
                'margin-right': 0,
                'z-index': 1
            });
            // only if visible
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css('padding-left', helper.clientWidth + 'px !important');
            // remember helper
            this.helpers.prefix = helper;
        }
        addSuffix() {
            if (!this.options.suffix && !this.options.arrow) return;
            let helper;
            let self1 = this;
            let styles = getComputedStyle(this.el);
            if (this.tmp['old-padding-right'] == null) this.tmp['old-padding-right'] = styles['padding-right'];
            let pr = parseInt(styles['padding-right'] || 0);
            if (this.options.arrow) {
                // remove if already displayed
                if (this.helpers.arrow) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.arrow).remove();
                // add fresh
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).after('<div class="w2ui-field-helper" style="border: 1px solid transparent">&#160;    <div class="w2ui-field-up" type="up">        <div class="arrow-up" type="up"></div>    </div>    <div class="w2ui-field-down" type="down">        <div class="arrow-down" type="down"></div>    </div></div>');
                helper = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).get(0).nextElementSibling;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(helper).css({
                    'color': styles.color,
                    'font-family': styles['font-family'],
                    'font-size': styles['font-size'],
                    'height': this.el.clientHeight + 'px',
                    'padding': 0,
                    'margin-top': parseInt(styles['margin-top'], 10) + 1 + 'px',
                    'margin-bottom': 0,
                    'border-left': '1px solid silver',
                    'width': '16px',
                    'transform': 'translateX(-100%)'
                }).on('mousedown', function(event1) {
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('arrow-up')) self1.keyDown(event1, {
                        keyCode: 38
                    });
                    if ($aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).hasClass('arrow-down')) self1.keyDown(event1, {
                        keyCode: 40
                    });
                });
                pr += helper.clientWidth // width of the control
                ;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css('padding-right', pr + 'px !important');
                this.helpers.arrow = helper;
            }
            if (this.options.suffix !== '') {
                // remove if already displayed
                if (this.helpers.suffix) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.suffix).remove();
                // add fresh
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).after(`<div class="w2ui-field-helper">${this.options.suffix}</div>`);
                helper = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).get(0).nextElementSibling;
                $aa2bd8933167d9cb$export$2fa187e846a241c4(helper).css({
                    'color': styles.color,
                    'font-family': styles['font-family'],
                    'font-size': styles['font-size'],
                    'height': this.el.clientHeight + 'px',
                    'padding-top': styles['padding-top'],
                    'padding-bottom': styles['padding-bottom'],
                    'padding-left': 0,
                    'padding-right': styles['padding-right'],
                    'margin-top': parseInt(styles['margin-top'], 10) + 2 + 'px',
                    'margin-bottom': parseInt(styles['margin-bottom'], 10) + 1 + 'px',
                    'transform': 'translateX(-100%)'
                });
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).css('padding-right', helper.clientWidth + 'px !important');
                this.helpers.suffix = helper;
            }
        }
        // Only used for list
        addSearch() {
            if (this.type !== 'list') return;
            // clean up & init
            if (this.helpers.search) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.search).remove();
            // remember original tabindex
            let tabIndex = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('tabIndex'));
            if (!isNaN(tabIndex) && tabIndex !== -1) this.tmp['old-tabIndex'] = tabIndex;
            if (this.tmp['old-tabIndex']) tabIndex = this.tmp['old-tabIndex'];
            if (tabIndex == null || isNaN(tabIndex)) tabIndex = 0;
            // if there is id, add to search with "_search"
            let searchId = '';
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('id') != null) searchId = 'id="' + $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('id') + '_search"';
            // build helper
            let html = `
            <div class="w2ui-field-helper">
                <span class="w2ui-icon w2ui-icon-search"></span>
                <input ${searchId} type="text" tabIndex="${tabIndex}" autocapitalize="off" autocomplete="off" autocorrect="off" spellcheck="false"/>
            </div>`;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('tabindex', -1).before(html);
            let helper = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).get(0).previousElementSibling;
            this.helpers.search = helper;
            this.helpers.search_focus = $aa2bd8933167d9cb$export$2fa187e846a241c4(helper).find('input').get(0);
            let styles = getComputedStyle(this.el);
            $aa2bd8933167d9cb$export$2fa187e846a241c4(helper).css({
                width: this.el.clientWidth + 'px',
                'margin-top': styles['margin-top'],
                'margin-left': styles['margin-left'],
                'margin-bottom': styles['margin-bottom'],
                'margin-right': styles['margin-right']
            }).find('input').css({
                cursor: 'default',
                width: '100%',
                opacity: 1,
                padding: styles.padding,
                margin: styles.margin,
                border: '1px solid transparent',
                'background-color': 'transparent'
            });
            // INPUT events
            $aa2bd8933167d9cb$export$2fa187e846a241c4(helper).find('input').off('.helper').on('focus.helper', (event1)=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).val('');
                this.tmp.pholder = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder') ?? '';
                this.focus(event1);
                event1.stopPropagation();
            }).on('blur.helper', (event1)=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).val('');
                if (this.tmp.pholder != null) $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('placeholder', this.tmp.pholder);
                this.blur(event1);
                event1.stopPropagation();
            }).on('keydown.helper', (event1)=>{
                this.keyDown(event1);
            }).on('keyup.helper', (event1)=>{
                this.keyUp(event1);
            });
            // MAIN div
            $aa2bd8933167d9cb$export$2fa187e846a241c4(helper).on('click', (event1)=>{
                $aa2bd8933167d9cb$export$2fa187e846a241c4(event1.target).find('input').focus();
            });
        }
        // Used in enum/file
        addMultiSearch() {
            if (![
                'enum',
                'file'
            ].includes(this.type)) return;
            // clean up & init
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.helpers.multi).remove();
            // build helper
            let html = '';
            let styles = getComputedStyle(this.el);
            let margin = $aa2bd8933167d9cb$export$fe3767bc112f7a2a.stripSpaces(`
            margin-top: 0px;
            margin-bottom: 0px;
            margin-left: ${styles['margin-left']};
            margin-right: ${styles['margin-right']};
            width: ${$aa2bd8933167d9cb$export$fe3767bc112f7a2a.getSize(this.el, 'width') - parseInt(styles['margin-left'], 10) - parseInt(styles['margin-right'], 10)}px;
        `);
            if (this.tmp['min-height'] == null) {
                let min = this.tmp['min-height'] = parseInt((styles['min-height'] != 'none' ? styles['min-height'] : 0) || 0);
                let current = parseInt(styles.height);
                this.tmp['min-height'] = Math.max(min, current);
            }
            if (this.tmp['max-height'] == null && styles['max-height'] != 'none') this.tmp['max-height'] = parseInt(styles['max-height']);
            // if there is id, add to search with "_search"
            let searchId = '';
            if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('id') != null) searchId = `id="${$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('id')}_search"`;
            // remember original tabindex
            let tabIndex = parseInt($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('tabIndex'));
            if (!isNaN(tabIndex) && tabIndex !== -1) this.tmp['old-tabIndex'] = tabIndex;
            if (this.tmp['old-tabIndex']) tabIndex = this.tmp['old-tabIndex'];
            if (tabIndex == null || isNaN(tabIndex)) tabIndex = 0;
            if (this.type === 'enum') html = `
            <div class="w2ui-field-helper w2ui-list" style="${margin}">
                <div class="w2ui-multi-items">
                    <div class="li-search">
                        <input ${searchId} type="text" autocapitalize="off" autocomplete="off" autocorrect="off" spellcheck="false"
                            tabindex="${tabIndex}"
                            ${$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') ? 'readonly' : ''}
                            ${$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled') ? 'disabled' : ''}>
                    </div>
                </div>
            </div>`;
            if (this.type === 'file') html = `
            <div class="w2ui-field-helper w2ui-list" style="${margin}">
                <div class="w2ui-multi-file">
                    <input name="attachment" class="file-input" type="file" tabindex="-1"'
                        style="width: 100%; height: 100%; opacity: 0" title=""
                        ${this.options.max !== 1 ? 'multiple' : ''}
                        ${$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled') ? 'disabled' : ''}
                        ${$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('accept') ? ' accept="' + $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('accept') + '"' : ''}>
                </div>
                <div class="w2ui-multi-items">
                    <div class="li-search" style="display: none">
                        <input ${searchId} type="text" autocapitalize="off" autocomplete="off" autocorrect="off" spellcheck="false"
                            tabindex="${tabIndex}"
                            ${$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') ? 'readonly' : ''}
                            ${$aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled') ? 'disabled' : ''}>
                    </div>
                </div>
            </div>`;
            // old bg and border
            this.tmp['old-background-color'] = styles['background-color'];
            this.tmp['old-border-color'] = styles['border-color'];
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).before(html).css({
                'border-color': 'transparent',
                'background-color': 'transparent'
            });
            let div = $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el.previousElementSibling);
            this.helpers.multi = div;
            $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).attr('tabindex', -1);
            // click anywhere on the field
            div.on('click', (event1)=>{
                this.focus(event1);
            });
            // search field
            div.find('input:not(.file-input)').on('click', (event1)=>{
                this.click(event1);
            }).on('focus', (event1)=>{
                this.focus(event1);
            }).on('blur', (event1)=>{
                this.blur(event1);
            }).on('keydown', (event1)=>{
                this.keyDown(event1);
            }).on('keyup', (event1)=>{
                this.keyUp(event1);
            });
            // file input
            if (this.type === 'file') div.find('input.file-input').off('.drag').on('click.drag', (event1)=>{
                event1.stopPropagation();
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                this.focus(event1);
            }).on('dragenter.drag', (event1)=>{
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                div.addClass('w2ui-file-dragover');
            }).on('dragleave.drag', (event1)=>{
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                div.removeClass('w2ui-file-dragover');
            }).on('drop.drag', (event1)=>{
                if ($aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('readOnly') || $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).prop('disabled')) return;
                div.removeClass('w2ui-file-dragover');
                let files = Array.from(event1.dataTransfer.files);
                files.forEach((file)=>{
                    this.addFile(file);
                });
                this.focus(event1);
                // cancel to stop browser behaviour
                event1.preventDefault();
                event1.stopPropagation();
            }).on('dragover.drag', (event1)=>{
                // cancel to stop browser behaviour
                event1.preventDefault();
                event1.stopPropagation();
            }).on('change.drag', (event1)=>{
                if (typeof event1.target.files !== 'undefined') Array.from(event1.target.files).forEach((file)=>{
                    this.addFile(file);
                });
                this.focus(event1);
            });
            this.refresh();
        }
        addFile(file) {
            let options = this.options;
            let selected = this.selected;
            let newItem = {
                name: file.name,
                type: file.type,
                modified: file.lastModifiedDate,
                size: file.size,
                content: null,
                file: file
            };
            let size = 0;
            let cnt = 0;
            let errors = [];
            if (Array.isArray(selected)) selected.forEach((item)=>{
                if (item.name == file.name && item.size == file.size) errors.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('The file "${name}" (${size}) is already added.', {
                    name: file.name,
                    size: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatSize(file.size)
                }));
                size += item.size;
                cnt++;
            });
            if (options.maxFileSize !== 0 && newItem.size > options.maxFileSize) errors.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Maximum file size is ${size}', {
                size: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatSize(options.maxFileSize)
            }));
            if (options.maxSize !== 0 && size + newItem.size > options.maxSize) errors.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Maximum total size is ${size}', {
                size: $aa2bd8933167d9cb$export$fe3767bc112f7a2a.formatSize(options.maxSize)
            }));
            if (options.max !== 0 && cnt >= options.max) errors.push($aa2bd8933167d9cb$export$fe3767bc112f7a2a.lang('Maximum number of files is ${count}', {
                count: options.max
            }));
            // trigger event
            let edata = this.trigger('add', {
                target: this.el,
                file: newItem,
                total: cnt,
                totalSize: size,
                errors: errors
            });
            if (edata.isCancelled === true) return;
            // if errors and not silent
            if (options.silent !== true && errors.length > 0) {
                $aa2bd8933167d9cb$export$b876f801a4afd38f.show({
                    anchor: this.el,
                    html: 'Errors: ' + errors.join('<br>')
                });
                console.log('ERRORS (while adding files): ', errors);
                return;
            }
            // check params
            selected.push(newItem);
            // read file as base64
            if (typeof FileReader !== 'undefined' && options.readContent === true) {
                let reader = new FileReader();
                let self1 = this;
                // need a closure
                reader.onload = function onload() {
                    return function closure(event1) {
                        let fl = event1.target.result;
                        let ind = fl.indexOf(',');
                        newItem.content = fl.substr(ind + 1);
                        self1.refresh();
                        $aa2bd8933167d9cb$export$2fa187e846a241c4(self1.el).trigger('input').trigger('change');
                        // event after
                        edata.finish();
                    };
                }();
                reader.readAsDataURL(file);
            } else {
                this.refresh();
                $aa2bd8933167d9cb$export$2fa187e846a241c4(this.el).trigger('input').trigger('change');
                edata.finish();
            }
        }
        // move cursror to end
        moveCaret2end() {
            setTimeout(()=>{
                this.el.setSelectionRange(this.el.value.length, this.el.value.length);
            }, 0);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("c7niU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GridGlobalStyles", function() {
        return $1e7b89d6eb0ac811$export$ce65ac8f5f0d0ccc;
    });
    function $1e7b89d6eb0ac811$export$ce65ac8f5f0d0ccc() {
        const theme = (0, $64A2P.useMantineTheme)();
        const colors = theme.fn.variant({
            variant: 'light',
            color: theme.primaryColor
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($6Koyj.Global, {
            styles: ()=>({
                    '.w2ui-grid-records': {
                        overscrollBehavior: 'contain'
                    },
                    '.w2ui-grid': {
                        border: 'unset',
                        borderRadius: 'unset'
                    },
                    '.w2ui-grid .w2ui-grid-body table .w2ui-head': {
                        color: 'unset',
                        backgroundImage: 'unset',
                        fontWeight: 'bold',
                        borderRight: 'unset',
                        borderBottom: 'unset'
                    },
                    '.w2ui-reset, .w2ui-reset table tr th, .w2ui-reset table tr td': {
                        fontFamily: 'unset',
                        fontSize: '0.875rem'
                    },
                    '.w2ui-grid .w2ui-grid-body': {
                        backgroundColor: 'unset'
                    },
                    '.w2ui-grid .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd, .w2ui-grid .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd, .w2ui-grid .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even, .w2ui-grid .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even': {
                        backgroundColor: 'unset',
                        borderBottom: 'unset',
                        borderTop: 'unset'
                    },
                    '.w2ui-grid .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd:hover, .w2ui-grid .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd:hover, .w2ui-grid .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd.w2ui-record-hover, .w2ui-grid .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd.w2ui-record-hover, .w2ui-grid .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even:hover, .w2ui-grid .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even:hover, .w2ui-grid .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even.w2ui-record-hover, .w2ui-grid .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even.w2ui-record-hover': {
                        backgroundColor: 'unset'
                    },
                    '.w2ui-grid .w2ui-grid-body .w2ui-grid-columns, .w2ui-grid .w2ui-grid-body .w2ui-grid-fcolumns': {
                        boxShadow: 'unset'
                    },
                    '.w2ui-grid .w2ui-grid-body table td': {
                        borderRight: 'unset'
                    },
                    '.w2ui-grid .w2ui-grid-body .w2ui-grid-scroll1': {
                        backgroundColor: 'unset',
                        borderTop: 'unset',
                        borderRight: 'unset'
                    },
                    '.w2ui-grid .w2ui-grid-body div.w2ui-col-header > div.w2ui-sort-down': {
                        marginTop: '0.3rem'
                    },
                    '.w2ui-grid .w2ui-grid-body div.w2ui-col-header > div.w2ui-sort-up': {
                        marginTop: 0
                    },
                    '.w2ui-grid.w2grid-light.w2grid-column-borders .w2ui-grid-body table td:not(.w2ui-head):not(:last-child), .w2ui-grid.w2grid-light.w2grid-column-borders .w2ui-grid-body table td.w2ui-head:not(:nth-last-child(2)), .w2ui-grid.w2grid-light.w2grid-column-borders .w2ui-grid-body table td.w2ui-head.w2ui-col-select': {
                        borderRight: '0.0625rem solid rgb(222, 226, 230)'
                    },
                    '.w2ui-grid.w2grid-dark.w2grid-column-borders .w2ui-grid-body table td:not(.w2ui-head):not(:last-child), .w2ui-grid.w2grid-dark.w2grid-column-borders .w2ui-grid-body table td.w2ui-head:not(:nth-last-child(2)), .w2ui-grid.w2grid-dark.w2grid-column-borders .w2ui-grid-body table td.w2ui-head.w2ui-col-select': {
                        borderRight: '0.0625rem solid rgb(55, 58, 64)'
                    },
                    '.w2ui-grid.w2grid-light.w2grid-border': {
                        border: '0.0625rem solid rgb(222, 226, 230)'
                    },
                    '.w2ui-grid.w2grid-dark.w2grid-border': {
                        border: '0.0625rem solid rgb(55, 58, 64)'
                    },
                    '.w2ui-grid.w2grid-light.w2grid-row-borders .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd, .w2ui-grid.w2grid-light.w2grid-row-borders .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd, .w2ui-grid.w2grid-light.w2grid-row-borders .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even, .w2ui-grid.w2grid-light.w2grid-row-borders .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even': {
                        borderTop: '0.0625rem solid #dee2e6'
                    },
                    '.w2ui-grid.w2grid-dark.w2grid-row-borders .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd, .w2ui-grid.w2grid-dark.w2grid-row-borders .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd, .w2ui-grid.w2grid-dark.w2grid-row-borders .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even, .w2ui-grid.w2grid-dark.w2grid-row-borders .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even': {
                        borderTop: '0.0625rem solid rgb(55, 58, 64)'
                    },
                    '.w2ui-grid.w2grid-light.w2grid-stripped .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd, .w2ui-grid.w2grid-light.w2grid-stripped .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd': {
                        backgroundColor: '#f8f9fa'
                    },
                    '.w2ui-grid.w2grid-dark.w2grid-stripped .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd, .w2ui-grid.w2grid-dark.w2grid-stripped .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd': {
                        backgroundColor: 'rgb(37, 38, 43)'
                    },
                    '.w2ui-grid.w2grid-light.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd:hover, .w2ui-grid.w2grid-light.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd:hover, .w2ui-grid.w2grid-light.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd.w2ui-record-hover, .w2ui-grid.w2grid-light.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd.w2ui-record-hover, .w2ui-grid.w2grid-light.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even:hover, .w2ui-grid.w2grid-light.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even:hover, .w2ui-grid.w2grid-light.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even.w2ui-record-hover, .w2ui-grid.w2grid-light.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even.w2ui-record-hover': {
                        backgroundColor: '#f1f3f5'
                    },
                    '.w2ui-grid.w2grid-dark.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd:hover, .w2ui-grid.w2grid-dark.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd:hover, .w2ui-grid.w2grid-dark.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-records table tr.w2ui-odd.w2ui-record-hover, .w2ui-grid.w2grid-dark.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-odd.w2ui-record-hover, .w2ui-grid.w2grid-dark.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even:hover, .w2ui-grid.w2grid-dark.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even:hover, .w2ui-grid.w2grid-dark.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-records table tr.w2ui-even.w2ui-record-hover, .w2ui-grid.w2grid-dark.w2grid-highlight-hover .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-even.w2ui-record-hover': {
                        backgroundColor: 'rgb(44, 46, 51)'
                    },
                    '.w2ui-grid.w2grid-light .w2ui-grid-body .w2ui-grid-records table tr.w2ui-selected, .w2ui-grid.w2grid-light .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-selected, .w2ui-grid.w2grid-light .w2ui-grid-body .w2ui-grid-records table tr td.w2ui-selected, .w2ui-grid.w2grid-light .w2ui-grid-body .w2ui-grid-frecords table tr td.w2ui-selected': {
                        color: `${colors.color} !important`,
                        backgroundColor: `${colors.background} !important`
                    },
                    '.w2ui-grid.w2grid-dark .w2ui-grid-body .w2ui-grid-records table tr.w2ui-selected, .w2ui-grid.w2grid-dark .w2ui-grid-body .w2ui-grid-frecords table tr.w2ui-selected, .w2ui-grid.w2grid-dark .w2ui-grid-body .w2ui-grid-records table tr td.w2ui-selected, .w2ui-grid.w2grid-dark .w2ui-grid-body .w2ui-grid-frecords table tr td.w2ui-selected': {
                        color: `${colors.color} !important`,
                        backgroundColor: `${colors.background} !important`
                    }
                })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("j8hoz", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridActionsToolbar", function() {
        return $ef8211f14083e2b5$export$ee9dff5c41556888;
    });
    var $TMsro = $305cacda61daafb0$var$parcelRequire("TMsro");
    const $ef8211f14083e2b5$export$bf9dc57276885897 = {
        size: "sm",
        actionsButtonVariant: "light",
        showActions: true
    };
    function $ef8211f14083e2b5$export$ee9dff5c41556888(props) {
        const { size: size, viewName: viewName, addLabel: addLabel, editLabel: editLabel, deleteLabel: deleteLabel, viewLabel: viewLabel, enableAdd: enableAdd, enableEdit: enableEdit, enableDelete: enableDelete, enableView: enableView, showActions: showActions, clientActions: clientActions, actionsButtonVariant: actionsButtonVariant, handleExecuteAction: handleExecuteAction, onAddClick: onAddClick, onEditClick: onEditClick, onDeleteClick: onDeleteClick, onViewClick: onViewClick, parentFormMode: parentFormMode } = (0, $64A2P.useComponentDefaultProps)('DataGridActionsToolbar', $ef8211f14083e2b5$export$bf9dc57276885897, props);
        const addElement = (0, $acw62.useRef)(null);
        const editElement = (0, $acw62.useRef)(null);
        const deleteElement = (0, $acw62.useRef)(null);
        const viewElement = (0, $acw62.useRef)(null);
        const actionElements = (0, $acw62.useRef)([]);
        const { buttonsSize: buttonsSize } = (0, $TMsro.getToolbarSizes)(size);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($hiiR1.Box, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                children: [
                    enableAdd && onAddClick && parentFormMode !== 'view' && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        size: buttonsSize,
                        ref: addElement,
                        variant: actionsButtonVariant,
                        onClick: async ()=>await onAddClick(addElement.current),
                        children: addLabel
                    }),
                    enableEdit && onEditClick && parentFormMode !== 'view' && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        size: buttonsSize,
                        ref: editElement,
                        variant: actionsButtonVariant,
                        onClick: async ()=>await onEditClick(editElement.current),
                        children: editLabel
                    }),
                    enableDelete && onDeleteClick && parentFormMode !== 'view' && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        size: buttonsSize,
                        ref: deleteElement,
                        variant: actionsButtonVariant,
                        onClick: async ()=>await onDeleteClick(deleteElement.current),
                        children: deleteLabel
                    }),
                    enableView && onViewClick && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        size: buttonsSize,
                        ref: viewElement,
                        variant: actionsButtonVariant,
                        onClick: async ()=>await onViewClick(viewElement.current),
                        children: viewLabel
                    }),
                    showActions && Object.values(clientActions).map((action, index)=>{
                        if (parentFormMode === undefined) return null;
                        if (parentFormMode === 'view' && !action.showActionInViewMode) return null;
                        if (viewName && action.views && !action.views.includes(viewName)) return null;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            leftIcon: action.icon,
                            ref: (el)=>actionElements.current[index] = el,
                            size: buttonsSize,
                            variant: actionsButtonVariant,
                            onClick: ()=>handleExecuteAction(action, undefined, actionElements.current[index] ?? undefined),
                            children: action.label
                        }, action.name);
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("TMsro", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getToolbarSizes", function() {
        return $0cdec814a9f371f7$export$654303af7d36ee24;
    });
    function $0cdec814a9f371f7$export$654303af7d36ee24(size) {
        let buttonsSize;
        let iconsSize = '';
        let actionIconSize;
        let badgeSize;
        switch(size){
            case "xs":
                iconsSize = "1rem";
                buttonsSize = "xs";
                actionIconSize = "sm";
                badgeSize = "sm";
                break;
            case "sm":
                iconsSize = "1.1rem";
                buttonsSize = "xs";
                actionIconSize = "md";
                badgeSize = "lg";
                break;
            case "md":
                iconsSize = "1.1rem";
                buttonsSize = "sm";
                actionIconSize = "md";
                badgeSize = "xl";
                break;
            case "lg":
                iconsSize = "1.5rem";
                buttonsSize = "md";
                actionIconSize = "md";
                badgeSize = "xl";
                break;
            case "xl":
                iconsSize = "1.7rem";
                buttonsSize = "lg";
                actionIconSize = "md";
                badgeSize = "xl";
                break;
            default:
                iconsSize = "1.1rem";
                buttonsSize = "sm";
                actionIconSize = "md";
                badgeSize = "lg";
                break;
        }
        return {
            buttonsSize: buttonsSize,
            iconsSize: iconsSize,
            actionIconSize: actionIconSize,
            badgeSize: badgeSize
        };
    }
});
$305cacda61daafb0$var$parcelRegister("5Buf1", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridColumnsMenu", function() {
        return $33ccde82279912ee$export$72c73377cef8aa5;
    });
    function $33ccde82279912ee$export$72c73377cef8aa5(props) {
        const { columns: columns, setOpened: setOpened, setColumns: setColumns } = props;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($aUqRb.Menu.Dropdown, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($5Eq0L.ScrollArea, {
                h: "20rem",
                children: columns?.map((column, index)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aUqRb.Menu).Item, {
                        icon: column.hidden ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $iHvby.default), {
                            size: "1rem"
                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4Rwq2.default), {
                            size: "1rem"
                        }),
                        onClick: (e)=>{
                            column.hidden = !column.hidden;
                            setColumns([
                                ...columns
                            ]);
                        //setOpened(false);
                        },
                        children: column.text
                    }, `gridColumnsMenu-${index}`);
                })
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("3vFhj", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridToolbarDefaultProps", function() {
        return $9632d8b297fc0c94$export$d7af4a7378986147;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridToolbar", function() {
        return $9632d8b297fc0c94$export$b45b457b2c4e92a;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $lJoOP = $305cacda61daafb0$var$parcelRequire("lJoOP");
    var $bFL3N = $305cacda61daafb0$var$parcelRequire("bFL3N");
    var $TMsro = $305cacda61daafb0$var$parcelRequire("TMsro");
    var $dzlic = $305cacda61daafb0$var$parcelRequire("dzlic");
    const $9632d8b297fc0c94$export$d7af4a7378986147 = {
        size: "sm",
        hideCheckboxToggle: false,
        toolbarIconVariant: "light",
        enableExport: true,
        searchPlaceholder: "Enter search text",
        refreshTooltip: "Refresh",
        exportTooltip: "Export",
        selectRowsTooltip: "Select items",
        filterTooltip: "Filter items",
        clearFiltersTooltip: "Clear filters",
        importTooltip: "Import data from .CSV file",
        //toolbarOnColor: "green",
        //toolbarOnShade: 8,
        filtersBadgeSize: "lg",
        showAppliedFilters: true,
        showRefreshButton: true,
        showFiltersButton: true,
        showSearchInput: true,
        showSelectRowsButton: true,
        filtersTitle: "Applied filters",
        filtersAccordionVariant: "contained",
        filtersBadgeVariant: "outline",
        editFitersLabel: "Edit filters",
        clearFiltersLabel: "Clear filters"
    };
    function $9632d8b297fc0c94$export$b45b457b2c4e92a(props) {
        const { size: size, hideCheckboxToggle: hideCheckboxToggle, onCheckboxToggle: onCheckboxToggle, onSearchTextChange: onSearchTextChange, onRefreshClick: onRefreshClick, autoFocus: autoFocus, toolbarIconVariant: toolbarIconVariant, onExportClick: onExportClick, enableExport: enableExport, searchPlaceholder: searchPlaceholder, refreshTooltip: refreshTooltip, exportTooltip: exportTooltip, selectRowsTooltip: selectRowsTooltip, searchData: searchData, setSearchData: setSearchData, searchText: searchText, setSearchText: setSearchText, filterTooltip: filterTooltip, parentKeys: parentKeys, setFilterValues: setFilterValues, filterValues: filterValues, clearFiltersTooltip: clearFiltersTooltip, filtersFormSize: filtersFormSize, FiltersEntity: FiltersEntity, client: client, enableImport: enableImport, importTooltip: importTooltip, onImportClick: onImportClick, filtersBadgeSize: filtersBadgeSize, showAppliedFilters: showAppliedFilters, showRefreshButton: showRefreshButton, showFiltersButton: showFiltersButton, visibleFilters: visibleFilters, filtersDescription: filtersDescription, setFiltersDescription: setFiltersDescription, initialColumnFilters: initialColumnFilters, filtersTitle: filtersTitle, editFitersLabel: editFitersLabel, clearFiltersLabel: clearFiltersLabel, filtersAccordionVariant: filtersAccordionVariant, filtersBadgeVariant: filtersBadgeVariant, showSearchInput: showSearchInput, showSelectRowsButton: showSelectRowsButton, showColumnsConfig: showColumnsConfig, configMenuOpened: configMenuOpened, setConfigMenuOpened: setConfigMenuOpened, configMenuDropdown: configMenuDropdown } = (0, $64A2P.useComponentDefaultProps)('DataGridToolbar', $9632d8b297fc0c94$export$d7af4a7378986147, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const { buttonsSize: buttonsSize, actionIconSize: actionIconSize, iconsSize: iconsSize, badgeSize: badgeSize } = (0, $TMsro.getToolbarSizes)(size);
        const filterInputRef = (0, $acw62.useRef)(null);
        const filtersAPI = (0, $dzlic.useDataGridToolbarFilters)({
            filterValues: filterValues,
            setFilterValues: setFilterValues,
            filtersDescription: filtersDescription,
            setFiltersDescription: setFiltersDescription,
            client: client,
            parentKeys: parentKeys,
            FiltersEntity: FiltersEntity,
            setSearchData: setSearchData,
            setSearchText: setSearchText,
            onRefreshClick: onRefreshClick,
            searchData: searchData,
            onSearchTextChange: onSearchTextChange,
            filtersFormSize: filtersFormSize,
            visibleFilters: visibleFilters,
            initialColumnFilters: initialColumnFilters,
            filterInputRef: filterInputRef
        });
        const appliedFiltersCount = filtersAPI.filtersDescription ? Object.values(filtersAPI.filtersDescription).filter((value)=>value?.toString() !== '').length : 0;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    children: [
                        showRefreshButton && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                            title: refreshTooltip,
                            onClick: ()=>{
                                if (onRefreshClick) onRefreshClick(searchText);
                            },
                            size: actionIconSize,
                            radius: "xl",
                            color: theme.primaryColor,
                            variant: toolbarIconVariant,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($e2M7p.default, {
                                size: iconsSize,
                                stroke: "1.5"
                            })
                        }),
                        showSearchInput && /*#__PURE__*/ (0, $ayMG0.jsx)($lJoOP.SearchFilterInput, {
                            placeholder: searchPlaceholder,
                            onKeyDown: (e)=>filtersAPI.handleSearchFilterInputEnter(e),
                            data: searchData,
                            value: searchText,
                            searchValue: filtersAPI.queryText,
                            onSearchClick: ()=>onRefreshClick(searchText),
                            onChange: filtersAPI.handleSearchFilterInputOnChange,
                            onSearchChange: (text)=>filtersAPI.setQueryText(text),
                            onCreate: filtersAPI.createSearchPhrase,
                            clearSearchOnChange: true,
                            size: buttonsSize,
                            iconsSize: iconsSize,
                            autoFocus: autoFocus,
                            iconVariant: toolbarIconVariant,
                            sx: {
                                flexGrow: 1
                            },
                            ref: filterInputRef
                        }),
                        showFiltersButton && FiltersEntity && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                            children: [
                                filtersAPI.filtersDescription && Object.keys(filtersAPI.filtersDescription).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($iPjI4.Badge, {
                                    title: filterTooltip,
                                    pl: 0,
                                    radius: "xl",
                                    size: badgeSize,
                                    maw: "20rem",
                                    fz: "xs",
                                    styles: {
                                        root: {
                                            textTransform: 'unset',
                                            fontWeight: 400
                                        }
                                    },
                                    leftSection: /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                        onClick: filtersAPI.handleFilterButtonClick,
                                        size: actionIconSize,
                                        radius: "xl",
                                        variant: toolbarIconVariant,
                                        color: theme.primaryColor,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($frYZ1.default, {
                                            size: iconsSize,
                                            stroke: "1.5"
                                        })
                                    }),
                                    rightSection: /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                        size: "xs",
                                        color: theme.primaryColor,
                                        title: clearFiltersTooltip,
                                        radius: "xl",
                                        variant: "transparent",
                                        onClick: filtersAPI.handleClearFiltersClick,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                                            size: (0, $2jkdX.rem)(10)
                                        })
                                    }),
                                    children: [
                                        "(",
                                        appliedFiltersCount,
                                        ")"
                                    ]
                                }),
                                (!filtersAPI.filtersDescription || filtersAPI.filtersDescription && Object.keys(filtersAPI.filtersDescription).length === 0) && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                    title: filterTooltip,
                                    onClick: filtersAPI.handleFilterButtonClick,
                                    size: actionIconSize,
                                    radius: "xl",
                                    color: theme.primaryColor,
                                    variant: toolbarIconVariant,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($frYZ1.default, {
                                        size: iconsSize,
                                        stroke: "1.5"
                                    })
                                })
                            ]
                        }),
                        showSelectRowsButton && /*#__PURE__*/ (0, $ayMG0.jsx)($bFL3N.ToggleActionIcon, {
                            title: selectRowsTooltip,
                            hidden: hideCheckboxToggle ? true : false,
                            onClick: onCheckboxToggle,
                            size: actionIconSize,
                            offColor: theme.primaryColor,
                            onColor: theme.primaryColor,
                            offVariant: toolbarIconVariant,
                            onVariant: toolbarIconVariant,
                            onIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($3an6L.default, {
                                size: iconsSize,
                                stroke: "1.5"
                            }),
                            offIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($1rkHh.default, {
                                size: iconsSize,
                                stroke: "1.5"
                            })
                        }),
                        enableExport && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                            title: exportTooltip,
                            onClick: ()=>{
                                if (onExportClick) onExportClick();
                            },
                            size: actionIconSize,
                            radius: "xl",
                            color: theme.primaryColor,
                            variant: toolbarIconVariant,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($vjSkT.default, {
                                size: iconsSize,
                                stroke: "1.5"
                            })
                        }),
                        enableImport && onImportClick && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                            title: importTooltip,
                            onClick: ()=>{
                                if (onImportClick) onImportClick();
                            },
                            size: actionIconSize,
                            radius: "xl",
                            color: theme.primaryColor,
                            variant: toolbarIconVariant,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($aUMvF.default, {
                                size: iconsSize,
                                stroke: "1.5"
                            })
                        }),
                        showColumnsConfig && setConfigMenuOpened && configMenuDropdown && /*#__PURE__*/ (0, $ayMG0.jsxs)($aUqRb.Menu, {
                            opened: configMenuOpened,
                            onChange: setConfigMenuOpened,
                            withinPortal: true,
                            closeOnItemClick: false,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($aUqRb.Menu.Target, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                        title: "Configure columns",
                                        size: actionIconSize,
                                        radius: "xl",
                                        color: theme.primaryColor,
                                        variant: toolbarIconVariant,
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($iVS9b.default, {
                                            size: iconsSize,
                                            stroke: "1.5"
                                        })
                                    })
                                }),
                                configMenuDropdown
                            ]
                        })
                    ]
                }),
                showAppliedFilters && FiltersEntity && filtersAPI.filtersDescription && Object.keys(filtersAPI.filtersDescription).length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                        defaultValue: "filters",
                        mt: "sm",
                        variant: filtersAccordionVariant,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                            value: "filters",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                        position: "apart",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                                size: "xs",
                                                weight: 500,
                                                children: [
                                                    appliedFiltersCount > 0 ? `(${appliedFiltersCount}) ` : '',
                                                    filtersTitle
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                                position: "right",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                                        component: "a",
                                                        size: actionIconSize,
                                                        radius: "xl",
                                                        variant: "default",
                                                        title: clearFiltersLabel,
                                                        onClick: filtersAPI.handleClearFiltersClick,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cvMwO.default, {
                                                            size: iconsSize,
                                                            stroke: "1.5"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                                        component: "a",
                                                        size: actionIconSize,
                                                        radius: "xl",
                                                        color: theme.primaryColor,
                                                        variant: toolbarIconVariant,
                                                        title: editFitersLabel,
                                                        onClick: filtersAPI.handleFilterButtonClick,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($jBKnG.default, {
                                                            size: iconsSize,
                                                            stroke: "1.5"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9VIWE.Stack, {
                                        spacing: "xs",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                                            spacing: "xs",
                                            style: {
                                                gap: '0.5rem'
                                            },
                                            children: Object.keys(filtersAPI.filtersDescription).map((filter, index)=>filtersAPI.filtersDescription?.[filter]?.toString() ? /*#__PURE__*/ (0, $ayMG0.jsxs)($iPjI4.Badge, {
                                                    component: "a",
                                                    radius: "sm",
                                                    size: filtersBadgeSize,
                                                    maw: "20rem",
                                                    styles: {
                                                        root: {
                                                            textTransform: 'unset',
                                                            cursor: 'pointer'
                                                        }
                                                    },
                                                    onClick: filtersAPI.handleFilterButtonClick,
                                                    variant: filtersBadgeVariant,
                                                    children: [
                                                        filter,
                                                        filtersAPI.filtersDescription?.[filter] ? `: ${filtersAPI.filtersDescription?.[filter]?.toString()}` : ''
                                                    ]
                                                }, filter) : null)
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("dzlic", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useDataGridToolbarFilters", function() {
        return $c97e66dd63db62ab$export$4a22575e2f542f1f;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $9maeT = $305cacda61daafb0$var$parcelRequire("9maeT");
    function $c97e66dd63db62ab$export$4a22575e2f542f1f(props) {
        const { filterValues: filterValues, setFilterValues: setFilterValues, client: client, parentKeys: parentKeys, FiltersEntity: FiltersEntity, setSearchData: setSearchData, setSearchText: setSearchText, onRefreshClick: onRefreshClick, onSearchTextChange: onSearchTextChange, searchData: searchData, filtersFormSize: filtersFormSize, visibleFilters: visibleFilters, filtersDescription: filtersDescription, setFiltersDescription: setFiltersDescription, initialColumnFilters: initialColumnFilters, filterInputRef: filterInputRef } = props;
        const openFilters = (0, $9maeT.useOpenForm)();
        const updateFilterValuesAndDescription = (0, $acw62.useCallback)((columns)=>{
            const values = {};
            const filter_description = {};
            for(const col_name in columns)if (!(0, $bmxG4.SYSTEM_COLUMNS_NAMES).includes(col_name)) {
                const value = columns[col_name].value;
                const col = columns[col_name];
                values[col_name] = value;
                if (visibleFilters === undefined || visibleFilters && visibleFilters.includes(col_name)) {
                    if (value && value !== col.defaultValue) filter_description[col.prompt] = columns[col_name].valueDescription || value;
                    else delete filter_description[col.prompt];
                }
            }
            setFilterValues(values);
            setFiltersDescription(filter_description);
        }, [
            setFilterValues,
            setFiltersDescription,
            visibleFilters
        ]);
        const handleFilterButtonClick = (0, $acw62.useCallback)(async (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (!client || !FiltersEntity) return;
            const filter_entity = FiltersEntity(client, parentKeys);
            (0, $iKzSR.setValues)(filter_entity.def.columns, filterValues);
            Object.values(filter_entity.def.columns).forEach((col)=>{
                if (filtersDescription && filtersDescription[col.prompt]) {
                    const description = filtersDescription[col.prompt];
                    if (description && typeof description === 'string') col.valueDescription = description;
                }
            });
            if (!filter_entity.Form) {
                console.error(`FiltersEntity ${FiltersEntity.name} does not have a Form component`);
                return;
            }
            await openFilters({
                entity: filter_entity,
                initialFormMode: 'add',
                OKText: 'Apply',
                modalFormSize: filtersFormSize,
                onModalSaved: async ()=>{
                    updateFilterValuesAndDescription(filter_entity.def.columns);
                }
            });
        }, [
            FiltersEntity,
            client,
            filterValues,
            filtersDescription,
            filtersFormSize,
            openFilters,
            parentKeys,
            updateFilterValuesAndDescription
        ]);
        // Search
        const [queryText, setQueryText] = (0, $acw62.useState)('');
        const createSearchPhrase = (0, $acw62.useCallback)((filter)=>{
            const item = {
                value: filter.indexOf('%') >= 0 ? filter.toLowerCase() : `%${filter.toLowerCase()}%`,
                label: filter
            };
            setSearchData((current)=>{
                const isDuplicate = current.some((x)=>x.value === item.value);
                return isDuplicate ? current : [
                    ...current,
                    item
                ];
            });
            return item;
        }, [
            setSearchData
        ]);
        const handleSearchFilterInputEnter = (0, $acw62.useCallback)((e)=>{
            const key_code = e.code;
            if (key_code !== "Enter" && key_code !== "NumpadEnter") return;
            // Ensure queryText is not empty
            if (!queryText.trim()) return;
            // Create the search item and add to searchData if not already included
            const newItem = createSearchPhrase(queryText); // This will add only if it's not a duplicate
            // Add queryText to searchText array if not already selected
            setSearchText((prevText)=>{
                const updatedText = prevText.includes(newItem.value) ? prevText : [
                    ...prevText,
                    newItem.value
                ];
                // Trigger onRefreshClick with the updated searchText array
                if (onRefreshClick) onRefreshClick(updatedText);
                return updatedText;
            });
            // Clear the queryText
            setQueryText('');
        }, [
            createSearchPhrase,
            onRefreshClick,
            queryText,
            setSearchText
        ]);
        const handleSearchFilterInputOnChange = (0, $acw62.useCallback)((searchFilter)=>{
            setSearchText(searchFilter);
            // FIX: when creating an item clicking create filter in the list, the searchData state is not upated yet and doesn't include the new item
            // we need to update searchData only when an item is deleted from the searchFilter
            if (searchFilter.length < searchData.length) {
                const updatedSearchData = searchData.filter((item)=>searchFilter.includes(item.value));
                setSearchData(updatedSearchData);
            }
            if (onSearchTextChange) onSearchTextChange(searchFilter);
        }, [
            onSearchTextChange,
            searchData,
            setSearchData,
            setSearchText
        ]);
        const handleClearFiltersClick = (0, $acw62.useCallback)((e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (!client || !FiltersEntity) return;
            const filter_entity = FiltersEntity(client, parentKeys);
            updateFilterValuesAndDescription(filter_entity.def.columns);
        }, [
            FiltersEntity,
            client,
            parentKeys,
            updateFilterValuesAndDescription
        ]);
        (0, $acw62.useEffect)(()=>{
            if (!client || !FiltersEntity) return;
            const filter_entity = FiltersEntity(client, parentKeys);
            (0, $iKzSR.setValues)(filter_entity.def.columns, initialColumnFilters, null, true);
            updateFilterValuesAndDescription(filter_entity.def.columns);
        }, []);
        return {
            handleFilterButtonClick: handleFilterButtonClick,
            handleSearchFilterInputEnter: handleSearchFilterInputEnter,
            handleClearFiltersClick: handleClearFiltersClick,
            createSearchPhrase: createSearchPhrase,
            queryText: queryText,
            filtersDescription: filtersDescription,
            setFiltersDescription: setFiltersDescription,
            setQueryText: setQueryText,
            handleSearchFilterInputOnChange: handleSearchFilterInputOnChange,
            updateFilterValuesAndDescription: updateFilterValuesAndDescription
        };
    }
});
$305cacda61daafb0$var$parcelRegister("5JIrZ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useDataGrid", function() {
        return $8e67432a124f4bfb$export$f77741f33c48605;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $1uAlg = $305cacda61daafb0$var$parcelRequire("1uAlg");
    function $8e67432a124f4bfb$export$f77741f33c48605(props, stateProps) {
        const { entity: entity, parentKeys: parentKeys, viewName: viewName, onSelectionChanged: onSelectionChanged, modalFormSize: modalFormSize, labels: labels, saveFormBeforeAdd: saveFormBeforeAdd, parentFormAPI: parentFormAPI, allwaysRefreshOnEntityClose: allwaysRefreshOnEntityClose, onAddClick: onAddClick, onModalSaved: onModalSaved, onDataRefresh: onDataRefresh, onActionExecuted: onActionExecuted, formMode: formMode, doubleClickAction: doubleClickAction, notExportableColumns: notExportableColumns, withModalFullscreenButton: withModalFullscreenButton, initialHiddenColumns: initialHiddenColumns, enableEdit: enableEdit, enableView: enableView } = props;
        const { setRefresh: setRefresh, setSearchText: setSearchText, executeViewState: executeViewState } = stateProps;
        const selection = (0, $acw62.useRef)([]);
        const selectionKeys = (0, $acw62.useRef)([]);
        const [selectedRowsCount, setSelectedRowsCount] = (0, $acw62.useState)(0);
        const [toggleSelectable, setToggleSelectable] = (0, $acw62.useState)(false);
        const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
        const [columns, setColumns] = (0, $acw62.useState)();
        const [rows, setRows] = (0, $acw62.useState)();
        const internalRefresh = (0, $acw62.useCallback)(()=>{
            setRefresh((prev)=>!prev);
        }, [
            setRefresh
        ]);
        const handleRefresh = (0, $acw62.useCallback)((search_text)=>{
            setSearchText(search_text);
            setRefresh((prev)=>!prev);
        }, [
            setRefresh,
            setSearchText
        ]);
        const handleModalSaved = (0, $acw62.useCallback)(async (new_status)=>{
            if (!new_status.error && !new_status.loading && new_status.data && !allwaysRefreshOnEntityClose) internalRefresh();
            if (onModalSaved) await onModalSaved(new_status);
        }, [
            internalRefresh,
            onModalSaved
        ]);
        const handleAlwaysRefreshOnClose = (0, $acw62.useCallback)(async ()=>{
            if (allwaysRefreshOnEntityClose) await internalRefresh();
        }, [
            allwaysRefreshOnEntityClose,
            internalRefresh
        ]);
        const UIAPI = (0, $1uAlg.useEntityUI)({
            entity: entity,
            parentKeys: parentKeys,
            modalFormSize: modalFormSize,
            parentFormAPI: parentFormAPI,
            saveFormBeforeAdd: saveFormBeforeAdd,
            onModalSaved: handleModalSaved,
            onModalClosed: handleAlwaysRefreshOnClose,
            onRecordsDeleted: internalRefresh,
            onActionRefreshOnClose: internalRefresh,
            labels: labels,
            onAddClick: onAddClick,
            onActionExecuted: onActionExecuted,
            withModalFullscreenButton: withModalFullscreenButton
        });
        const getSelectionKeys = (0, $acw62.useCallback)((selection)=>{
            const result = [];
            if (entity && viewName) for(let i = 0; i < selection.length; i++){
                const record = selection[i];
                const keys = {};
                const record_properties = Object.keys(record);
                const key_mappings = entity.def.views[viewName].keyMappings;
                for(const columnName in key_mappings){
                    const idx = key_mappings[columnName];
                    if (idx >= record_properties.length) continue;
                    keys[columnName] = record[record_properties[idx]];
                }
                if (keys) result.push(keys);
            }
            return result;
        }, [
            entity,
            viewName
        ]);
        const handleToggleSelectable = (0, $acw62.useCallback)(()=>{
            setToggleSelectable((prev)=>!prev);
        }, []);
        const handleSelectionChanged = (0, $acw62.useCallback)(async (newSelection)=>{
            selection.current = newSelection;
            selectionKeys.current = getSelectionKeys(newSelection);
            setSelectedRowsCount(newSelection.length);
            if (onSelectionChanged) onSelectionChanged(newSelection, selectionKeys.current);
        }, [
            onSelectionChanged,
            getSelectionKeys
        ]);
        const handleEditClick = (0, $acw62.useCallback)(async (element)=>{
            if (entity?.Form === null) return;
            const keys = selectionKeys.current;
            if (keys.length) await UIAPI.handleEditClick(keys[0], element);
        }, [
            entity?.Form,
            UIAPI
        ]);
        const handleViewClick = (0, $acw62.useCallback)(async (element)=>{
            if (entity?.Form === null) return;
            const keys = selectionKeys.current;
            if (keys.length) await UIAPI.handleViewClick(keys[0], element);
        }, [
            entity?.Form,
            UIAPI
        ]);
        const handleDeleteClick = (0, $acw62.useCallback)(async (element)=>{
            const keys = selectionKeys.current;
            await UIAPI.handleDeleteClick(keys, element);
        }, [
            UIAPI
        ]);
        const handleExecuteAction = (0, $acw62.useCallback)(async (action, recordIndex, element)=>{
            const keys = selectionKeys.current;
            await UIAPI.handleExecuteAction(action, keys, element);
        }, [
            UIAPI
        ]);
        const handleDoubleClick = (0, $acw62.useCallback)(async (record)=>{
            if (doubleClickAction === 'none' || doubleClickAction === undefined) return;
            const form_mode = formMode || parentFormAPI?.formMode;
            if (!form_mode) {
                console.warn('DataGrid double click: Form mode not defined or parent form api not set ');
                return;
            }
            if (doubleClickAction === 'edit') {
                if ((form_mode === 'edit' || formMode === 'add') && enableEdit) {
                    await handleEditClick();
                    return;
                }
                if (form_mode === 'view' && enableView) {
                    await handleViewClick();
                    return;
                }
                return;
            } else if (doubleClickAction === 'view') {
                if (form_mode === 'view' && enableView) {
                    await handleViewClick();
                    return;
                }
            } else {
                await doubleClickAction(record);
                return;
            }
        //await handleEditClick();
        }, [
            doubleClickAction,
            formMode,
            handleEditClick,
            handleViewClick,
            parentFormAPI?.formMode
        ]);
        const handleImportDataClick = (0, $acw62.useCallback)(async ()=>{
            await UIAPI.handleImportDataClick();
        }, [
            UIAPI
        ]);
        // MMC: this is special here for the Grid component as it uses columns and records
        const handleExport = (0, $acw62.useCallback)(async ()=>{
            if (!rows?.length || !columns?.length) return;
            const currentDate = new Date();
            const filename = `export-${currentDate.getFullYear()}${(currentDate.getDate() + '').padStart(2, '0')}${(currentDate.getMonth() + 1 + '').padStart(2, '0')}_${(currentDate.getHours() + '').padStart(2, '0')}${(currentDate.getMinutes() + '').padStart(2, '0')}${(currentDate.getSeconds() + '').padStart(2, '0')}.xlsx`;
            const workbook = new ($305cacda61daafb0$var$$parcel$interopDefault($j4US1)).Workbook();
            const worksheet = workbook.addWorksheet('Data');
            // filter columns to exclude not exportable columns in notExportableColumns
            const exportableColumns = columns.filter((col, index)=>{
                return !notExportableColumns?.includes(index);
            });
            // headers
            worksheet.addRow(exportableColumns.map((col)=>col.text));
            // Rows
            for(let r = 0; r < rows.length; r++){
                const excel_row = [];
                for(let c = 0; c < columns.length; c++){
                    if (notExportableColumns?.includes(c)) continue;
                    excel_row[c] = rows[r][c];
                }
                worksheet.addRow(excel_row);
            }
            try {
                if (window.Blob && window.URL) {
                    const buffer = await workbook.xlsx.writeBuffer();
                    const blob = new Blob([
                        buffer
                    ], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                    URL.revokeObjectURL(link.href);
                }
            } catch (ex) {
                console.error("Your browser does not support exporting data.");
            }
        }, [
            columns,
            notExportableColumns,
            rows
        ]);
        (0, $acw62.useEffect)(()=>{
            if (executeViewState.loading) setIsLoading(true);
            else if (executeViewState.error) setIsLoading(false);
            else if (!executeViewState.error && executeViewState.data?.length) {
                setColumns(executeViewState.data[0].Header.map((columnText, index)=>({
                        field: index.toString(),
                        text: columnText,
                        sqlType: executeViewState.data[0].typeInfo[index],
                        hidden: initialHiddenColumns ? initialHiddenColumns.includes(index) : false
                    })));
                setRows(executeViewState.data[0].records);
                setIsLoading(false);
                if (onDataRefresh) onDataRefresh(executeViewState);
            }
        }, [
            executeViewState.data,
            executeViewState.error,
            executeViewState.loading,
            onDataRefresh,
            initialHiddenColumns
        ]);
        return {
            handleSelectionChanged: handleSelectionChanged,
            handleDoubleClick: handleDoubleClick,
            handleDeleteClick: handleDeleteClick,
            handleEditClick: handleEditClick,
            handleAddClick: UIAPI.handleAddClick,
            handleViewClick: handleViewClick,
            handleToggleSelectable: handleToggleSelectable,
            handleRefresh: handleRefresh,
            handleExecuteAction: handleExecuteAction,
            handleExport: handleExport,
            selectedRowsCount: selectedRowsCount,
            showSelectCheckbox: toggleSelectable,
            UIAPI: UIAPI,
            columns: columns,
            rows: rows,
            isLoading: isLoading,
            handleImportDataClick: handleImportDataClick,
            setColumns: setColumns
        };
    }
});
$305cacda61daafb0$var$parcelRegister("jLHxW", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridFormDefaultProps", function() {
        return $313bb798f411269f$export$a3893c58ea92262f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridForm", function() {
        return $313bb798f411269f$export$f5fffb98a6b25aa0;
    });
    var $kjFvY = $305cacda61daafb0$var$parcelRequire("kjFvY");
    const $313bb798f411269f$export$a3893c58ea92262f = {
        showTitle: true
    };
    function $313bb798f411269f$export$f5fffb98a6b25aa0(props) {
        const { title: title, icon: icon, helpText: helpText, formMode: formMode, showTitle: showTitle, entity: entity, enableAdd: enableAdd, enableDelete: enableDelete, enableEdit: enableEdit, customTitle: customTitle, enableView: enableView, ...gridProps } = (0, $64A2P.useComponentDefaultProps)('DataGridForm', props, $313bb798f411269f$export$a3893c58ea92262f);
        const theme = (0, $64A2P.useMantineTheme)();
        //const gridRef = useRef(null);
        const EntityIcon = entity?.Icon;
        const IconNode = icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
            children: icon
        }) : EntityIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(EntityIcon, {
                size: "1rem"
            })
        }) : undefined;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
            shadow: "sm",
            withBorder: theme.colorScheme === 'dark' ? false : true,
            children: [
                showTitle && customTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                    p: "xs",
                    bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                    mb: "1rem",
                    children: customTitle
                }),
                showTitle && !customTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                    p: "xs",
                    bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                    mb: "1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                        variant: "filled",
                        chevron: /*#__PURE__*/ (0, $ayMG0.jsx)($kytQ3.default, {
                            size: "1rem"
                        }),
                        styles: {
                            item: {
                                '&[data-active]': {
                                    backgroundColor: "unset"
                                }
                            },
                            label: {
                                paddingBottom: 0,
                                paddingTop: 0
                            },
                            control: {
                                padding: 0
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                            value: entity?.name ?? 'dgfEntity',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                    icon: IconNode,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        size: "sm",
                                        children: title ?? entity?.Title
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        size: "xs",
                                        children: helpText ?? entity?.HelpText
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($kjFvY.DataGrid, {
                    entity: entity,
                    enableAdd: formMode === 'view' ? false : enableAdd,
                    enableEdit: formMode === 'view' ? false : enableEdit,
                    enableDelete: formMode === 'view' ? false : enableDelete,
                    enableView: formMode === 'view' || enableView,
                    formMode: formMode,
                    ...gridProps
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("azLoD", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useDataGridForm", function() {
        return $1d50954a6112cbe9$export$b10b817c6afb61d4;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    $305cacda61daafb0$var$parcelRequire("2Qb3Q");
    var $jLHxW = $305cacda61daafb0$var$parcelRequire("jLHxW");
    const $1d50954a6112cbe9$var$defaultProps = {
        modalProps: {
            size: 'xl'
        }
    };
    function $1d50954a6112cbe9$export$b10b817c6afb61d4() {
        const modals = (0, $k7qj2.useModal)();
        const open = async (props)=>{
            const { entity: entity, viewName: viewName, onClosed: onClosed, modalProps: modalProps, selectionMode: selectionMode, search: search, modalTitle: modalTitle, gridTitle: gridTitle, formMode: formMode } = {
                ...$1d50954a6112cbe9$var$defaultProps,
                ...props
            };
            const handleClosed = async ()=>{
                if (onClosed) onClosed();
            };
            await modals.open({
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($jLHxW.DataGridForm, {
                    entity: entity,
                    viewName: viewName,
                    formMode: formMode,
                    refreshOnInit: true,
                    selectionMode: selectionMode ?? 'single',
                    customTitle: gridTitle,
                    search: search
                }),
                modalProps: {
                    ...modalProps,
                    trapFocus: true,
                    returnFocus: true,
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        fw: "700",
                        children: modalTitle
                    })
                },
                onClosed: async ()=>{
                    await handleClosed();
                }
            });
        };
        return open;
    }
});
$305cacda61daafb0$var$parcelRegister("8vapl", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridPageDefaultProps", function() {
        return $f0d535a36532a6bb$export$a64fdec463ffd453;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataGridPage", function() {
        return $f0d535a36532a6bb$export$1ab3b8ae3c4d41d3;
    });
    var $kjFvY = $305cacda61daafb0$var$parcelRequire("kjFvY");
    const $f0d535a36532a6bb$export$a64fdec463ffd453 = {
        showTitle: true
    };
    function $f0d535a36532a6bb$export$1ab3b8ae3c4d41d3(props) {
        const { title: title, icon: icon, formMode: formMode, helpText: helpText, showTitle: showTitle, client: client, enableAdd: enableAdd, enableDelete: enableDelete, enableEdit: enableEdit, entityConstructor: entityConstructor, ...others } = (0, $64A2P.useComponentDefaultProps)('DataGridPage', props, $f0d535a36532a6bb$export$a64fdec463ffd453);
        const theme = (0, $64A2P.useMantineTheme)();
        //const gridRef = useRef(null);
        const entity = (0, $acw62.useRef)(entityConstructor(client));
        const EntityIcon = entity.current.Icon;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                showTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                    variant: "filled",
                    chevron: /*#__PURE__*/ (0, $ayMG0.jsx)($kytQ3.default, {
                        size: "1.5rem"
                    }),
                    styles: {
                        item: {
                            '&[data-active]': {
                                backgroundColor: "unset"
                            }
                        },
                        label: {
                            paddingBottom: 0,
                            paddingTop: 0
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                        value: entity.current.name,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                icon: icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
                                    children: icon
                                }) : EntityIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(EntityIcon, {
                                        size: "1.3rem"
                                    })
                                }) : undefined,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ew26C.Title, {
                                    order: 2,
                                    children: title ?? entity.current.Title
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                    size: "sm",
                                    children: helpText ?? entity.current.HelpText
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card, {
                    shadow: "sm",
                    withBorder: theme.colorScheme === 'dark' ? false : true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($kjFvY.DataGrid, {
                        entity: entity.current,
                        enableAdd: formMode === 'view' ? false : enableAdd,
                        enableEdit: formMode === 'view' ? false : enableEdit,
                        enableDelete: formMode === 'view' ? false : enableDelete,
                        formMode: formMode,
                        ...others
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("jCh09", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useViewFiltersForm", function() {
        return $1c07bc1af56c0202$export$40610f984521a076;
    });
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $bW9pc = $305cacda61daafb0$var$parcelRequire("bW9pc");
    function $1c07bc1af56c0202$export$40610f984521a076(props) {
        const formAPI = (0, $bW9pc.useEntityForm)({
            noSaveOnSubmit: true,
            ...props
        });
        return formAPI;
    }
});
$305cacda61daafb0$var$parcelRegister("aIp3n", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("17D0Z", function(module1, exports) {
    var $d1Ssg = $305cacda61daafb0$var$parcelRequire("d1Ssg");
    var $726hz = $305cacda61daafb0$var$parcelRequire("726hz");
    var $2Zki2 = $305cacda61daafb0$var$parcelRequire("2Zki2");
    var $iuZkb = $305cacda61daafb0$var$parcelRequire("iuZkb");
    var $42GxC = $305cacda61daafb0$var$parcelRequire("42GxC");
    var $hiss3 = $305cacda61daafb0$var$parcelRequire("hiss3");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $d1Ssg);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $726hz);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2Zki2);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iuZkb);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $42GxC);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hiss3);
});
$305cacda61daafb0$var$parcelRegister("d1Ssg", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupDefaultProps", function() {
        return $3c9a6257599b90ac$export$9c2b2ccf03658905;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "Lookup", function() {
        return $3c9a6257599b90ac$export$710993ff54d9590c;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("17D0Z");
    var $2Zki2 = $305cacda61daafb0$var$parcelRequire("2Zki2");
    const $3c9a6257599b90ac$export$9c2b2ccf03658905 = {
        idMaxWidth: "15rem",
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($li55Z.default, {
            size: "1rem",
            stroke: "1.5"
        }),
        iconVariant: "light",
        requiredLabel: "A value is required",
        size: "sm",
        enableAdd: false,
        enableEdit: false,
        enableDelete: false,
        enableView: true
    };
    function $3c9a6257599b90ac$export$710993ff54d9590c(props) {
        const { entityForm: entityForm, entity: entity, lookupDefName: lookupDefName, autoFocus: autoFocus, label: label, parentKeys: parentKeys, column: column, required: required, readonly: readonly, disabled: disabled, idMaxWidth: idMaxWidth, icon: icon, iconVariant: iconVariant, requiredLabel: requiredLabel, description: description, size: size, onLookupPerformed: onLookupPerformed, enableAdd: enableAdd, enableEdit: enableEdit, enableDelete: enableDelete, enableView: enableView } = (0, $64A2P.useComponentDefaultProps)('Lookup', $3c9a6257599b90ac$export$9c2b2ccf03658905, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const HTMLDescriptionRef = (0, $acw62.useRef)(null);
        const lookupAPI = (0, $2Zki2.useLookup)({
            entityForm: entityForm,
            entity: entity,
            lookupDefName: lookupDefName,
            column: column.name,
            parentKeys: parentKeys,
            required: required,
            HTMLDescriptionRef: HTMLDescriptionRef,
            enableAdd: enableAdd,
            enableEdit: enableEdit,
            enableDelete: enableDelete,
            enableView: enableView
        });
        (0, $acw62.useEffect)(()=>{
            if (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable)) entityForm.configureField(column, (0, $aKTxt.isNotEmpty)(requiredLabel));
            else entityForm.removeValidation(column);
        }, [
            column,
            entityForm,
            required,
            requiredLabel
        ]);
        const controlSize = (0, $d8Ix8.getSize)({
            size: size ?? "sm",
            sizes: theme.fontSizes
        });
        const descriptionSize = (0, $d8Ix8.getSize)({
            size: size ?? "sm",
            sizes: theme.fontSizes
        });
        const labelColor = theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[9];
        const descriptionColor = theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6];
        // MMC: set the binding column description value
        (0, $acw62.useEffect)(()=>{
            column.valueDescription = lookupAPI.lookupResult?.description;
        }, [
            column,
            lookupAPI.lookupResult?.description
        ]);
        (0, $acw62.useEffect)(()=>{
            if (onLookupPerformed && lookupAPI.lookupResult) onLookupPerformed(lookupAPI.lookupResult);
        }, [
            lookupAPI.lookupResult,
            onLookupPerformed
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            style: {
                gap: "0.1rem",
                flexGrow: "1"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    style: {
                        gap: "0.2rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: controlSize,
                            weight: "500",
                            color: labelColor,
                            children: label ?? column.prompt
                        }),
                        (required ?? (!readonly && !(entityForm.formMode === 'view') && !column.hasFlag($4H7ea.EntityColumnFlags.nullable))) && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: controlSize,
                            weight: "500",
                            color: theme.colors.red[5],
                            children: "*"
                        })
                    ]
                }),
                (description ?? column.description) && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                    style: {
                        fontSize: `calc(${descriptionSize} - ${(0, $2jkdX.rem)(2)})`,
                        lineHeight: 1.2
                    },
                    color: descriptionColor,
                    children: description ?? column.description
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    style: {
                        marginTop: `calc(${theme.spacing.xs} / 2)`
                    },
                    align: "flex-start",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($8mycu.TextInput, {
                            size: size,
                            maw: idMaxWidth,
                            readOnly: readonly || entityForm.formMode === 'view' || lookupAPI.status.loading || entityForm.status.loading ? true : false,
                            "data-autofocus": autoFocus,
                            disabled: disabled,
                            rightSection: /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                color: theme.primaryColor,
                                disabled: readonly || entityForm.formMode === 'view' || lookupAPI.status.loading || entityForm.status.loading,
                                onClick: async ()=>{
                                    // readonly, no lookup
                                    if (readonly || entityForm.formMode === 'view' || lookupAPI.status.loading || entityForm.status.loading) return;
                                    await lookupAPI.onBlur(column.name, true);
                                },
                                variant: iconVariant,
                                size: "md",
                                children: icon
                            }),
                            ...lookupAPI.lookupInputProps,
                            onBlur: async (e)=>{
                                await lookupAPI.onBlur(column.name, false, e);
                            }
                        }, `${entity.name}${column.name}`),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                            style: {
                                flexGrow: 1
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($8mycu.TextInput, {
                                size: size,
                                readOnly: true,
                                value: lookupAPI.lookupResult?.description,
                                rightSection: lookupAPI.status.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($4P91H.Loader, {
                                    size: "xs",
                                    variant: "bars"
                                }),
                                ref: HTMLDescriptionRef,
                                sx: {
                                    flexGrow: 1
                                }
                            }, `${entity.name}${column.name}description`)
                        })
                    ]
                }),
                lookupAPI.lookupResult?.error && /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        size: "xs",
                        color: "red",
                        children: lookupAPI.lookupResult.errorDescription
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("726hz", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupFormDefaultProps", function() {
        return $b5f5c79046a37f01$export$661ffebdb61ba44e;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupForm", function() {
        return $b5f5c79046a37f01$export$31fe10f004166bd6;
    });
    $305cacda61daafb0$var$parcelRequire("2Qb3Q");
    var $kjFvY = $305cacda61daafb0$var$parcelRequire("kjFvY");
    const $b5f5c79046a37f01$export$661ffebdb61ba44e = {
        helpMessage: "Select the records that you need and click OK",
        okLabel: "OK",
        cancelLabel: "Cancel"
    };
    function $b5f5c79046a37f01$export$31fe10f004166bd6(props) {
        const { dataGridProps: dataGridProps, onOK: onOK, onCancel: onCancel, okLabel: okLabel, cancelLabel: cancelLabel, helpMessage: helpMessage, breadCrumbs: breadCrumbs } = (0, $64A2P.useComponentDefaultProps)('LookupForm', $b5f5c79046a37f01$export$661ffebdb61ba44e, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const selectionKeys = (0, $acw62.useRef)([]);
        const handleSelectionChanged = (0, $acw62.useCallback)((selection, keys)=>{
            selectionKeys.current = keys;
        }, []);
        const handleOK = (0, $acw62.useCallback)(()=>{
            onOK(selectionKeys.current);
        }, [
            onOK
        ]);
        const { parentKeys: parentKeys } = dataGridProps;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                breadCrumbs && /*#__PURE__*/ (0, $ayMG0.jsx)($VIBCe.Breadcrumbs, {
                    children: breadCrumbs
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
                    shadow: "sm",
                    withBorder: theme.colorScheme === 'dark' ? false : true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                            p: "xs",
                            bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                            mb: "1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                sx: {
                                    gap: "0.25rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($1YbUT.default, {
                                        size: "1.1rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        fz: "xs",
                                        c: "dimmed",
                                        children: helpMessage
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($kjFvY.DataGrid, {
                            ...dataGridProps,
                            onSelectionChanged: handleSelectionChanged,
                            autoFocus: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    mt: "md",
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            variant: "light",
                            leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($dRw7S.default, {
                                size: "1.5rem"
                            }),
                            onClick: ()=>onCancel ? onCancel() : null,
                            children: cancelLabel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            onClick: handleOK,
                            color: theme.colors.green[5],
                            leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($4Rwq2.default, {
                                size: "1.5rem"
                            }),
                            children: okLabel
                        })
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("2Zki2", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useLookup", function() {
        return $d296e9f4d3930bfd$export$4db9dd7eda56bf7b;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    $305cacda61daafb0$var$parcelRequire("17D0Z");
    var $42GxC = $305cacda61daafb0$var$parcelRequire("42GxC");
    const $d296e9f4d3930bfd$export$4db9dd7eda56bf7b = ({ entityForm: entityForm, entity: entity, lookupDefName: lookupDefName, column: column, parentKeys: parentKeys, required: required, HTMLDescriptionRef: HTMLDescriptionRef, enableAdd: enableAdd, enableEdit: enableEdit, enableDelete: enableDelete, enableView: enableView })=>{
        const [status, setStatus] = (0, $acw62.useState)({});
        const [previousLookupResult, setPreviousLookupResult] = (0, $acw62.useState)();
        const [lookupResult, setLookupResult] = (0, $acw62.useState)();
        const lookupForm = (0, $42GxC.useLookupForm)();
        const lookupEntity = (0, $acw62.useRef)();
        const viewName = (0, $acw62.useRef)('');
        const lookupDef = (0, $acw62.useRef)();
        const isLooking = (0, $acw62.useRef)(false);
        const lastFocusedElement = (0, $acw62.useRef)();
        const performLookup = (0, $acw62.useCallback)((bindingColumn, keyValue, force = false)=>{
            if (!lookupEntity.current) return Promise.resolve({
                columnName: bindingColumn,
                key: '',
                description: '',
                cancel: false,
                error: false,
                updateParentKeys: true
            });
            const mappedKeyColumnName = lookupDef.current.bindingColumnKey ?? bindingColumn;
            lookupEntity.current.def.columns[mappedKeyColumnName].value = keyValue;
            if (parentKeys) lookupEntity.current.parentKeys = parentKeys;
            return new Promise(async (resolve, reject)=>{
                const doLookup = async ()=>{
                    try {
                        setStatus({
                            loading: true
                        });
                        // Set parentKeys
                        $iKzSR.setValues(lookupEntity.current.def.columns, parentKeys, null, true);
                        const result = await lookupEntity.current.API.lookupData();
                        const new_status = {
                            data: {
                                key: keyValue,
                                description: result
                            }
                        };
                        setStatus(new_status);
                        return {
                            description: result,
                            status: new_status,
                            errorDescription: ''
                        };
                    } catch (e) {
                        const new_status = {
                            error: (0, $98ddT.toMicroMError)(e)
                        };
                        setStatus(new_status);
                        const errorDescription = `${new_status.data?.status ? new_status.data?.status : ''} ${new_status.data?.message ? new_status.data?.message : ''} ${new_status.data?.statusMessage ? new_status.data.statusMessage : ''}`;
                        return {
                            description: '',
                            status: new_status,
                            errorDescription: errorDescription
                        };
                    }
                };
                const doBrowse = async (search)=>{
                    const onOK = async (selectedKeys)=>{
                        //console.log(`OnOK force: ${force} isLooking ${isLooking.current}`);
                        if (selectedKeys.length > 0) {
                            // MMC: map the binding column using binding column key or the column name
                            const selectedKeyValue = selectedKeys[0][mappedKeyColumnName];
                            lookupEntity.current.def.columns[mappedKeyColumnName].value = selectedKeyValue;
                            entityForm.form.setFieldValue(column, selectedKeyValue);
                            //lookupEntity.current!.def.columns[bindingColumn].value = selectedKeys[0][bindingColumn];
                            const result = await doLookup();
                            if (result.status.error) resolve({
                                columnName: bindingColumn,
                                key: keyValue,
                                description: '',
                                cancel: false,
                                error: true,
                                updateParentKeys: true,
                                errorDescription: result.errorDescription
                            });
                            else resolve({
                                columnName: bindingColumn,
                                key: selectedKeyValue,
                                description: result.description,
                                cancel: false,
                                error: false,
                                updateParentKeys: true
                            });
                        } else resolve({
                            columnName: bindingColumn,
                            key: keyValue,
                            description: '',
                            cancel: true,
                            error: false,
                            updateParentKeys: true
                        });
                    };
                    const onCancel = async ()=>{
                        //console.log(`OnCancel force: ${force} isLooking ${isLooking.current}`);
                        resolve({
                            columnName: bindingColumn,
                            key: keyValue,
                            description: '',
                            cancel: true,
                            error: false,
                            updateParentKeys: false
                        });
                    };
                    await lookupForm({
                        entity: lookupEntity.current,
                        parentKeys: parentKeys,
                        selectionMode: "single",
                        search: search,
                        viewName: viewName.current,
                        onOK: onOK,
                        onCancel: onCancel,
                        modalProps: {
                            size: "xl",
                            trapFocus: true
                        },
                        enableAdd: enableAdd,
                        enableEdit: enableEdit,
                        enableDelete: enableDelete,
                        enableView: enableView
                    });
                };
                if (force) await doBrowse([]);
                else {
                    const result = await doLookup();
                    if (result.status.error) resolve({
                        columnName: bindingColumn,
                        key: keyValue,
                        description: '',
                        cancel: false,
                        error: true,
                        updateParentKeys: true,
                        errorDescription: result.errorDescription
                    });
                    else if (result.description) resolve({
                        columnName: bindingColumn,
                        key: keyValue,
                        description: result.description,
                        cancel: false,
                        error: false,
                        updateParentKeys: true
                    });
                    else await doBrowse(keyValue ? [
                        keyValue?.toString()
                    ] : []);
                }
            });
        }, [
            column,
            entityForm.form,
            lookupForm,
            parentKeys,
            enableAdd,
            enableEdit,
            enableDelete,
            enableView
        ]);
        const updateLookupType = (0, $acw62.useCallback)((result)=>{
            if (!result.error && !result.cancel) {
                entityForm.form.setFieldError(result.columnName, null);
                entityForm.form.setFieldValue(result.columnName, result.key);
                setLookupResult(result);
                setPreviousLookupResult(result);
            } else if (result.cancel) {
                if (result.key !== previousLookupResult?.key) {
                    setLookupResult(result);
                    entityForm.form.setFieldError(result.columnName, true);
                    setPreviousLookupResult(undefined);
                }
            } else {
                console.log(`Error`);
                entityForm.form.setFieldError(result.columnName, true);
                result.description = '';
                setLookupResult(result);
                if (result.updateParentKeys) setPreviousLookupResult(result);
            }
        }, [
            entityForm.form,
            previousLookupResult?.key
        ]);
        const lookupInputProps = entityForm.form.getInputProps(column);
        const mantine_onblur = lookupInputProps.onBlur;
        const onBlur = (0, $acw62.useCallback)(async (bindingColumn, force = false, event1 = null, new_value)=>{
            if (isLooking.current === true) return;
            isLooking.current = true;
            if (event1) lastFocusedElement.current = event1.target;
            else lastFocusedElement.current = document.activeElement;
            const keyValue = new_value ?? entityForm.form.values[bindingColumn];
            if (!keyValue) updateLookupType({
                columnName: bindingColumn,
                key: '',
                description: '',
                error: required,
                cancel: false,
                updateParentKeys: previousLookupResult?.key !== keyValue && keyValue !== null
            });
            if (force === false && (previousLookupResult?.key === keyValue && previousLookupResult?.error === false || !keyValue)) {
                isLooking.current = false;
                return;
            }
            mantine_onblur();
            const result = await performLookup(bindingColumn, keyValue, force);
            //console.log(`OnBlur isLooking after: force: ${force} isLooking ${isLooking.current}`);
            isLooking.current = false;
            updateLookupType(result);
            if (lastFocusedElement.current) {
                if (HTMLDescriptionRef.current) HTMLDescriptionRef.current.focus({
                    preventScroll: false
                });
            }
        }, [
            HTMLDescriptionRef,
            entityForm.form.values,
            mantine_onblur,
            performLookup,
            previousLookupResult?.error,
            previousLookupResult?.key,
            required,
            updateLookupType
        ]);
        (0, $acw62.useEffect)(()=>{
            // MMC: create the lookup entity 
            lookupDef.current = entity.def.lookups[lookupDefName];
            lookupEntity.current = lookupDef.current.entityConstructor(entity.API.client, parentKeys);
            const stdview = lookupEntity.current.def.standardView() ?? '';
            viewName.current = lookupDef.current.view ? lookupDef.current.view : stdview;
        }, [
            entity,
            lookupDefName,
            parentKeys
        ]);
        // MMC: perform the lookup after getting the entity data
        (0, $acw62.useEffect)(()=>{
            const initialLookup = async ()=>{
                if ((entityForm.formMode === 'edit' || entityForm.formMode === 'view') && entityForm.status.operationType === 'get' && !entityForm.status.loading && entity.def.columns[column].value) {
                    const result = await performLookup(column, entity.def.columns[column].value, false);
                    updateLookupType(result);
                }
            };
            initialLookup();
        }, [
            column,
            entity.def.columns,
            entityForm.formMode,
            entityForm.status.loading,
            entityForm.status.operationType,
            parentKeys
        ]);
        // MMC: perform initial lookup when add
        const initialAddLookup = (0, $acw62.useRef)(true);
        (0, $acw62.useEffect)(()=>{
            const initialLookup = async ()=>{
                if (entityForm.formMode === 'add' && initialAddLookup.current && entity.def.columns[column].value) {
                    const result = await performLookup(column, entity.def.columns[column].value, false);
                    updateLookupType(result);
                    initialAddLookup.current = false;
                }
            };
            initialLookup();
        }, [
            entity.def.columns[column].value,
            entityForm.formMode
        ]);
        return {
            status: status,
            lookupResult: lookupResult,
            lookupInputProps: lookupInputProps,
            onBlur: onBlur
        };
    };
});
$305cacda61daafb0$var$parcelRegister("iuZkb", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useLookupEntity", function() {
        return $6899d2333cf49324$export$983248af60bcb386;
    });
    function $6899d2333cf49324$export$983248af60bcb386({ entity: entity, lookupDefName: lookupDefName, parentKeys: parentKeys }) {
        const lookupEntity = (0, $acw62.useRef)();
        const lookupDef = (0, $acw62.useRef)();
        const viewName = (0, $acw62.useRef)('');
        (0, $acw62.useMemo)(()=>{
            // MMC: create the lookup entity 
            lookupDef.current = entity.def.lookups[lookupDefName];
            lookupEntity.current = lookupDef.current.entityConstructor(entity.API.client, parentKeys);
            const stdview = lookupEntity.current.def.standardView() ?? '';
            viewName.current = lookupDef.current.view ? lookupDef.current.view : stdview;
        }, [
            entity,
            lookupDefName,
            parentKeys
        ]);
        return {
            lookupEntity: lookupEntity.current,
            lookupDef: lookupDef.current,
            lookupViewName: viewName.current
        };
    }
});
$305cacda61daafb0$var$parcelRegister("42GxC", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseLookupFormDefaultProps", function() {
        return $bead45746c9b4701$export$7c798c3f2245eb6;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useLookupForm", function() {
        return $bead45746c9b4701$export$5ff8a4fe1be12a7c;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    $305cacda61daafb0$var$parcelRequire("17D0Z");
    var $726hz = $305cacda61daafb0$var$parcelRequire("726hz");
    const $bead45746c9b4701$export$7c798c3f2245eb6 = {
        modalProps: {
            size: 'xl'
        },
        selectLabel: "Select",
        showActions: false,
        enableAdd: false,
        enableEdit: false,
        enableDelete: false,
        enableView: true
    };
    function $bead45746c9b4701$export$5ff8a4fe1be12a7c() {
        const modals = (0, $k7qj2.useModal)();
        const buttonResult = (0, $acw62.useRef)('Quit');
        const open = async (props)=>{
            const { entity: entity, viewName: viewName, onOK: onOK, onCancel: onCancel, modalProps: modalProps, selectionMode: selectionMode, search: search, selectLabel: selectLabel, onClosed: onClosed, parentKeys: parentKeys, showActions: showActions, enableAdd: enableAdd, enableEdit: enableEdit, enableDelete: enableDelete, enableView: enableView, breadCrumbs: breadCrumbs } = {
                ...$bead45746c9b4701$export$7c798c3f2245eb6,
                ...props
            };
            buttonResult.current = 'Quit';
            const handleOK = async (selectedKeys)=>{
                buttonResult.current = 'OK';
                await modals.close();
                if (onOK) await onOK(selectedKeys);
            };
            const handleCancel = async ()=>{
                buttonResult.current = 'Cancel';
                await modals.close();
                if (onCancel) onCancel();
            };
            const handleClosed = async ()=>{
                if (buttonResult.current === 'Quit') {
                    if (onCancel) onCancel();
                }
                if (onClosed) onClosed();
            };
            await modals.open({
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($726hz.LookupForm, {
                    dataGridProps: {
                        entity: entity,
                        parentKeys: parentKeys,
                        viewName: viewName,
                        limit: "10000",
                        refreshOnInit: true,
                        selectionMode: selectionMode ? selectionMode : 'multi',
                        search: search,
                        showActions: showActions,
                        enableAdd: enableAdd,
                        enableEdit: enableEdit,
                        enableDelete: enableDelete,
                        enableView: enableView
                    },
                    onOK: async (selectedKeys)=>await handleOK(selectedKeys),
                    onCancel: ()=>handleCancel(),
                    breadCrumbs: breadCrumbs
                }),
                modalProps: {
                    ...modalProps,
                    trapFocus: true,
                    returnFocus: true,
                    withFullscreenButton: true,
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                        fw: "700",
                        children: [
                            selectLabel,
                            " ",
                            entity.Title
                        ]
                    })
                },
                onClosed: async ()=>{
                    await handleClosed();
                }
            });
        };
        return open;
    }
});
$305cacda61daafb0$var$parcelRegister("hiss3", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupFormActionDefaultProps", function() {
        return $9987aca4488b336f$export$cfa3d1bdbe24a61;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupFormAction", function() {
        return $9987aca4488b336f$export$deb93aade685e98;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $j7Y9b = $305cacda61daafb0$var$parcelRequire("j7Y9b");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    $305cacda61daafb0$var$parcelRequire("2Qb3Q");
    var $kjFvY = $305cacda61daafb0$var$parcelRequire("kjFvY");
    var $726hz = $305cacda61daafb0$var$parcelRequire("726hz");
    const $9987aca4488b336f$export$cfa3d1bdbe24a61 = {
        addingRecords: "Adding records...",
        confirmContent: "Do you wish to add the selected records?",
        showActions: false,
        enableAdd: false,
        enableEdit: false,
        enableDelete: false,
        enableView: false,
        enableExport: false
    };
    function $9987aca4488b336f$export$deb93aade685e98(props) {
        const { lookupEntity: lookupEntity, viewName: viewName, onOK: onOK, addingRecords: addingRecords, title: title, onCancel: onCancel, onActionFinished: onActionFinished, runOnOpen: runOnOpen, confirmContent: confirmContent, showActions: showActions, enableAdd: enableAdd, enableEdit: enableEdit, enableDelete: enableDelete, enableView: enableView, enableExport: enableExport, modalFormSize: modalFormSize } = (0, $64A2P.useComponentDefaultProps)('LookupFormAction', $9987aca4488b336f$export$cfa3d1bdbe24a61, props);
        const modal = (0, $k7qj2.useModal)();
        const LookpIcon = lookupEntity.Icon ?? $7xsss.default;
        const labels = $kjFvY.DataGridDefaultProps.labels;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($726hz.LookupForm, {
            dataGridProps: {
                entity: lookupEntity,
                viewName: lookupEntity.def.views[viewName].name,
                limit: "10000",
                refreshOnInit: true,
                selectionMode: 'multi',
                enableAdd: enableAdd,
                enableEdit: enableEdit,
                enableDelete: enableDelete,
                enableView: enableView,
                enableExport: enableExport,
                enableImport: false,
                parentKeys: lookupEntity.parentKeys,
                showActions: showActions,
                modalFormSize: modalFormSize
            },
            onOK: async (keys)=>{
                const abort_controller = new AbortController();
                if (keys.length > 0) await modal?.open({
                    modalProps: {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9mTYo.Group), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)(LookpIcon, {
                                    size: "1.5rem",
                                    stroke: "1.5"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                    fw: "700",
                                    children: title
                                })
                            ]
                        })
                    },
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $j7Y9b.ConfirmAndExecutePanel), {
                        loadingContent: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9VIWE.Stack), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lFsp3.FakeProgressBar), {}),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cjohz.Text), {
                                    size: "sm",
                                    mb: "xs",
                                    children: addingRecords
                                })
                            ]
                        }),
                        onOK: async ()=>{
                            const result = await onOK(keys, abort_controller.signal);
                            if (!result.Failed) {
                                // close this modal
                                await modal.close();
                                // close selection modal
                                await modal.close();
                                if (onActionFinished) await onActionFinished();
                            }
                            return result;
                        },
                        onCancel: async ()=>{
                            await abort_controller.abort();
                            // close this modal
                            await modal.close();
                            // close selection modal
                            await modal.close();
                            if (onActionFinished) await onActionFinished();
                        },
                        content: confirmContent,
                        runOnOpen: runOnOpen,
                        operation: "add"
                    })
                });
                else modal.open({
                    modalProps: {
                        title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($fIMaa.default, {
                                    size: "1.5rem",
                                    stroke: "1.5"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                    fw: "700",
                                    children: labels?.warningLabel
                                })
                            ]
                        })
                    },
                    content: /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                size: "sm",
                                mb: "xs",
                                children: labels?.YouMustSelectOneOrMoreRecordsToExecuteAction
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                                mt: "xs",
                                position: "right",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                    onClick: async ()=>await modal.close(),
                                    children: labels?.closeLabel
                                })
                            })
                        ]
                    })
                });
            },
            onCancel: async ()=>{
                await modal.close();
                if (onCancel) onCancel();
            }
        });
    }
});
$305cacda61daafb0$var$parcelRegister("fcjYw", function(module1, exports) {
    var $lMHpE = $305cacda61daafb0$var$parcelRequire("lMHpE");
    var $eVqjP = $305cacda61daafb0$var$parcelRequire("eVqjP");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lMHpE);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $eVqjP);
});
$305cacda61daafb0$var$parcelRegister("lMHpE", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupSelectDefaultProps", function() {
        return $900fa559ce35569a$export$c02cdf743c1f7188;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupSelect", function() {
        return $900fa559ce35569a$export$4003d000af5d7585;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    var $eVqjP = $305cacda61daafb0$var$parcelRequire("eVqjP");
    const $900fa559ce35569a$export$c02cdf743c1f7188 = {
        enableEdit: false,
        maxItems: 0,
        requiredLabel: "A value from the list is required",
        editLabel: "Edit",
        includeKeyInDescription: false,
        withinPortal: true,
        zIndex: 100000,
        editButtonVariant: "light",
        editIconVariant: "light",
        selectProps: {
            searchable: true,
            maxDropdownHeight: 260,
            clearable: true
        }
    };
    const $900fa559ce35569a$export$4003d000af5d7585 = /*#__PURE__*/ (0, $acw62.forwardRef)(function LookupSelect(props, ref) {
        const { parentKeys: parentKeys, column: column, formStatus: formStatus, entityForm: entityForm, entity: entity, lookupDefName: lookupDefName, enableEdit: enableEdit, editIcon: editIcon, editIconVariant: editIconVariant, selectProps: selectProps, maxItems: maxItems, requiredLabel: requiredLabel, editLabel: editLabel, includeKeyInDescription: includeKeyInDescription, withinPortal: withinPortal, zIndex: zIndex, breadCrumbs: breadCrumbs } = (0, $64A2P.useComponentDefaultProps)('LookupSelect', $900fa559ce35569a$export$c02cdf743c1f7188, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const triggerRefreshState = (0, $acw62.useState)(true);
        const selectDataState = (0, $acw62.useState)([]);
        const [selectData] = selectDataState;
        const lookupSelectAPI = (0, $eVqjP.useLookupSelect)({
            parentKeys: parentKeys,
            selectDataState: selectDataState,
            triggerRefreshState: triggerRefreshState,
            column: column,
            entityForm: entityForm,
            entity: entity,
            lookupDefName: lookupDefName,
            maxItems: maxItems,
            includeKeyInDescription: includeKeyInDescription,
            breadCrumbs: breadCrumbs
        });
        const [showDescription] = entityForm.showDescriptionState;
        selectProps.label = selectProps?.label ?? column.prompt;
        selectProps.description = showDescription ? selectProps?.description ?? column.description : '';
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            required: selectProps?.required,
            requiredMessage: requiredLabel
        });
        // MMC: Effect for setting the column valueDescription
        (0, $acw62.useEffect)(()=>{
            const value = entityForm.form.values[column.name];
            if (value) {
                const index = selectData.findIndex((item)=>item.value === value);
                if (index >= 0) column.valueDescription = selectData[index].label;
                else column.valueDescription = '';
            } else column.valueDescription = '';
        }, [
            column,
            entityForm.form.values,
            selectData
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($3wLgJ.Select, {
            ...selectProps,
            withAsterisk: selectProps.withAsterisk ?? (!selectProps.readOnly && !(entityForm.formMode === 'view') && (selectProps.required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            withinPortal: withinPortal,
            zIndex: zIndex,
            icon: lookupSelectAPI.status.loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($4P91H.Loader, {
                size: "xs"
            }) : selectProps?.icon,
            data: selectData,
            readOnly: selectProps?.readOnly || entityForm.formMode === 'view' || lookupSelectAPI.status.loading || formStatus?.loading ? true : false,
            error: lookupSelectAPI.status.error ? lookupSelectAPI.status.error.message : null,
            // MMC: this is how we hack the styles let the chevron work showing the list and the edit button be clickable
            styles: ()=>({
                    rightSection: {
                        pointerEvents: editIcon ? "none" : "all"
                    }
                }),
            rightSection: enableEdit && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                spacing: "xs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($ab9C8.default, {
                        size: "1rem"
                    }),
                    editIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                        style: {
                            pointerEvents: 'all'
                        },
                        size: "md",
                        color: theme.primaryColor,
                        variant: editIconVariant,
                        onClick: lookupSelectAPI.onEditClick,
                        children: editIcon
                    }),
                    !editIcon && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        size: "xs",
                        mr: "xs",
                        variant: "light",
                        onClick: lookupSelectAPI.onEditClick,
                        children: editLabel
                    })
                ]
            }),
            rightSectionWidth: enableEdit ? "auto" : undefined,
            ...lookupSelectAPI.inputProps,
            ref: ref
        });
    });
});
$305cacda61daafb0$var$parcelRegister("eVqjP", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useLookupSelect", function() {
        return $99e085fae992050d$export$528929806c03169f;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $lB8CV = $305cacda61daafb0$var$parcelRequire("lB8CV");
    var $a2vzY = $305cacda61daafb0$var$parcelRequire("a2vzY");
    $305cacda61daafb0$var$parcelRequire("17D0Z");
    var $iuZkb = $305cacda61daafb0$var$parcelRequire("iuZkb");
    var $42GxC = $305cacda61daafb0$var$parcelRequire("42GxC");
    const $99e085fae992050d$export$528929806c03169f = (props)=>{
        const { parentKeys: parentKeys, selectDataState: selectDataState, triggerRefreshState: triggerRefreshState, column: column, entityForm: entityForm, entity: entity, lookupDefName: lookupDefName, maxItems: maxItems, includeKeyInDescription: includeKeyInDescription, breadCrumbs: breadCrumbs } = props;
        const [triggerRefresh, setTriggerRefresh] = triggerRefreshState;
        const localeFormat = (0, $a2vzY.useLocaleFormat)({
            timeZoneOffset: entity.API.client.TIMEZONE_OFFSET
        });
        const { lookupEntity: lookupEntity, lookupDef: lookupDef, lookupViewName: lookupViewName } = (0, $iuZkb.useLookupEntity)({
            entity: entity,
            lookupDefName: lookupDefName,
            parentKeys: parentKeys
        });
        const [selectData, setSelectData] = selectDataState;
        const openEditModal = (0, $42GxC.useLookupForm)();
        const handleEditOnClosed = ()=>{
            setTriggerRefresh((prev)=>!prev);
        };
        const handleOnOK = (selectedKeys)=>{
            if (selectedKeys.length > 0) {
                const keys = selectedKeys[0];
                const key_index = lookupDef?.viewMapping?.keyIndex ?? 0;
                const value = keys[Object.keys(keys)[key_index]];
                entityForm.form.setFieldValue(column.name, value);
            }
        };
        const handleEditClick = ()=>{
            openEditModal({
                entity: lookupEntity,
                enableAdd: true,
                enableEdit: true,
                enableDelete: true,
                enableView: true,
                parentKeys: parentKeys,
                viewName: lookupViewName,
                onClosed: handleEditOnClosed,
                onOK: handleOnOK,
                selectionMode: 'single',
                breadCrumbs: breadCrumbs
            });
        };
        const status = (0, $lB8CV.useExecuteView)(lookupEntity, parentKeys, lookupViewName, undefined, maxItems?.toString(), triggerRefresh);
        // MMC: Effect for setting the select data
        (0, $acw62.useEffect)(()=>{
            if (status.loading) return;
            if (status.data && status.data[0].records) {
                const keyIndex = lookupDef?.viewMapping?.keyIndex ?? 0;
                const descIndex = lookupDef?.viewMapping?.descriptionIndex ?? 1;
                // MMC: for working with objects as expected data format
                const tableData = status.data[0].records.map((record)=>{
                    const formatedDescription = localeFormat.formatValue(record[descIndex], status.data[0].typeInfo[descIndex]);
                    const formatedKey = localeFormat.formatValue(record[keyIndex], status.data[0].typeInfo[descIndex]);
                    return {
                        value: record[keyIndex]?.toString(),
                        label: includeKeyInDescription === true ? `${formatedKey} - ${formatedDescription}` : formatedDescription
                    };
                });
                setSelectData(tableData);
            } else setSelectData([]);
        }, [
            includeKeyInDescription,
            localeFormat.locale,
            status.loading,
            status.data
        ]);
        return {
            onEditClick: handleEditClick,
            inputProps: entityForm.form.getInputProps(column.name),
            status: status
        };
    };
});
$305cacda61daafb0$var$parcelRegister("iFgaY", function(module1, exports) {
    var $7VnE4 = $305cacda61daafb0$var$parcelRequire("7VnE4");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7VnE4);
});
$305cacda61daafb0$var$parcelRegister("7VnE4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityActionButton", function() {
        return $22c09537022114f4$export$c9e6dc182280167f;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    function $22c09537022114f4$export$c9e6dc182280167f(props) {
        const modal = (0, $k7qj2.useModal)();
        const { entity: entity, action: action, selectedKeys: selectedKeys, label: label, onClose: onClose, ...rest } = props;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
            leftIcon: action.icon,
            onClick: async ()=>{
                await action.onClick({
                    entity: entity,
                    modal: modal,
                    selectedKeys: selectedKeys,
                    onClose: onClose
                });
            },
            ...rest,
            children: label || action.label
        });
    }
});
$305cacda61daafb0$var$parcelRegister("hMHMl", function(module1, exports) {
    var $jPtkB = $305cacda61daafb0$var$parcelRequire("jPtkB");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jPtkB);
});
$305cacda61daafb0$var$parcelRegister("jPtkB", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RingProgressFieldDefaultProps", function() {
        return $f03b0887d5119613$export$7b05a98ebf07d77f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RingProgressField", function() {
        return $f03b0887d5119613$export$c2e8caf4ce46a535;
    });
    const $f03b0887d5119613$export$7b05a98ebf07d77f = {
        maxValue: 100,
        ringSize: 65,
        thickness: 7,
        iconSize: "1.1rem",
        displayPercent: 'none',
        color: 'blue',
        p: "xs",
        withBorder: true
    };
    function $f03b0887d5119613$export$c2e8caf4ce46a535(props) {
        const { centerIcon: centerIcon, column: column, title: title, description: description, color: color, maxValue: maxValue, ringSize: ringSize, thickness: thickness, iconSize: iconSize, displayPercent: displayPercent, centerLabel: centerLabel, showPercentAsCenterLabel: showPercentAsCenterLabel, iconColor: iconColor, ...others } = (0, $64A2P.useComponentDefaultProps)('RingProgressField', $f03b0887d5119613$export$7b05a98ebf07d77f, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const Icon = centerIcon;
        const progress = isNaN((column.value ?? 0) / maxValue * 100) ? 0 : (column.value ?? 0) / maxValue * 100;
        const percentIconLabel = showPercentAsCenterLabel ? /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
            weight: "bolder",
            align: "center",
            color: iconColor,
            size: "xs",
            children: [
                progress.toFixed(0),
                "%"
            ]
        }) : undefined;
        const iconLabel = centerIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($4W1M8.Center, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(Icon, {
                size: iconSize,
                stroke: 1.5,
                color: iconColor
            })
        }) : undefined;
        const percent = displayPercent === 'none' || undefined ? '' : displayPercent === 'percent' ? ` ${progress.toFixed(2)}` : ` ${column.value}/${maxValue}`;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card, {
            ...others,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($kC2FX.RingProgress, {
                        size: ringSize,
                        roundCaps: true,
                        thickness: thickness,
                        sections: [
                            {
                                value: progress,
                                color: color
                            }
                        ],
                        label: iconLabel || percentIconLabel || centerLabel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        style: {
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                weight: 500,
                                color: theme.colorScheme === 'dark' ? theme.white : theme.colors.gray[9],
                                size: "sm",
                                children: [
                                    title ?? column.prompt,
                                    percent
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                size: "sm",
                                color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6],
                                children: description ?? column.description
                            })
                        ]
                    })
                ]
            })
        }, column.name);
    }
});
$305cacda61daafb0$var$parcelRegister("iTpjT", function(module1, exports) {
    var $5cUzS = $305cacda61daafb0$var$parcelRequire("5cUzS");
    var $adBvK = $305cacda61daafb0$var$parcelRequire("adBvK");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5cUzS);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $adBvK);
});
$305cacda61daafb0$var$parcelRegister("adBvK", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AutoFormFields", function() {
        return $6e0224148e872eb0$export$acbbb7557b8c7fc8;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $cnfVv = $305cacda61daafb0$var$parcelRequire("cnfVv");
    var $jAbjP = $305cacda61daafb0$var$parcelRequire("jAbjP");
    var $6pUmH = $305cacda61daafb0$var$parcelRequire("6pUmH");
    var $hv0CN = $305cacda61daafb0$var$parcelRequire("hv0CN");
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    function $6e0224148e872eb0$export$acbbb7557b8c7fc8(props) {
        const { entity: entity, entityForm: entityForm } = props;
        let first_focus = true;
        return Object.entries(entity.def.columns).map(([key, column])=>{
            if (!(0, $bmxG4.SYSTEM_COLUMNS_NAMES).includes(key) && !column.excludeInAutoForm) {
                let element = undefined;
                switch(column.type){
                    case 'nvarchar':
                    case 'varchar':
                    case 'nchar':
                    case 'char':
                        if (entityForm.formMode === 'add' && column.hasFlag($4H7ea.EntityColumnFlags.autoNum)) break;
                        if (column.length > 0 && column.length <= 255) {
                            element = /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                                column: column,
                                entityForm: entityForm,
                                readOnly: column.hasFlag($4H7ea.EntityColumnFlags.autoNum) || entityForm.formMode !== 'add' && column.hasFlag($4H7ea.EntityColumnFlags.pk),
                                autoFocus: !(column.hasFlag($4H7ea.EntityColumnFlags.autoNum) || entityForm.formMode !== 'add' && column.hasFlag($4H7ea.EntityColumnFlags.pk)) ? first_focus : undefined,
                                description: column.description,
                                placeholder: column.placeholder,
                                maw: column.length === 20 ? "20rem" : undefined
                            }, `${entity.name}${column.name}`);
                            if (!(column.hasFlag($4H7ea.EntityColumnFlags.autoNum) || entityForm.formMode !== 'add' && column.hasFlag($4H7ea.EntityColumnFlags.pk)) && first_focus) first_focus = undefined;
                        } else {
                            element = /*#__PURE__*/ (0, $ayMG0.jsx)($hv0CN.TextAreaField, {
                                column: column,
                                entityForm: entityForm,
                                label: column.prompt,
                                maxRows: 4,
                                minRows: 4,
                                autoFocus: first_focus,
                                description: column.description,
                                placeholder: column.placeholder
                            }, `${entity.name}${column.name}`);
                            if (first_focus) first_focus = undefined;
                        }
                        break;
                    case 'date':
                    case 'datetime':
                    case 'datetime2':
                        element = /*#__PURE__*/ (0, $ayMG0.jsx)($jAbjP.DateInputField, {
                            column: column,
                            entityForm: entityForm,
                            label: column.prompt,
                            autoFocus: first_focus,
                            description: column.description,
                            placeholder: column.placeholder
                        }, `${entity.name}${column.name}`);
                        if (first_focus) first_focus = undefined;
                        break;
                    case 'bigint':
                    case 'int':
                    case 'tinyint':
                    case 'smallint':
                        element = /*#__PURE__*/ (0, $ayMG0.jsx)($6pUmH.NumberField, {
                            column: column,
                            entityForm: entityForm,
                            readOnly: column.hasFlag($4H7ea.EntityColumnFlags.autoNum),
                            autoFocus: !column.hasFlag($4H7ea.EntityColumnFlags.autoNum) ? first_focus : undefined,
                            description: column.description,
                            placeholder: column.placeholder,
                            maw: "20rem"
                        }, `${entity.name}${column.name}`);
                        break;
                    case 'decimal':
                    case 'float':
                    case 'money':
                    case 'real':
                        element = /*#__PURE__*/ (0, $ayMG0.jsx)($6pUmH.NumberField, {
                            column: column,
                            entityForm: entityForm,
                            readOnly: column.hasFlag($4H7ea.EntityColumnFlags.autoNum),
                            autoFocus: !column.hasFlag($4H7ea.EntityColumnFlags.autoNum) ? first_focus : undefined,
                            description: column.description,
                            placeholder: column.placeholder,
                            maw: "20rem",
                            precision: column.scale
                        }, `${entity.name}${column.name}`);
                        break;
                    case 'bit':
                        element = /*#__PURE__*/ (0, $ayMG0.jsx)($cnfVv.CheckboxField, {
                            column: column,
                            entityForm: entityForm,
                            label: column.prompt,
                            autoFocus: first_focus,
                            description: column.description
                        }, `${entity.name}${column.name}`);
                        break;
                }
                return element;
            }
            return undefined;
        });
    }
});
$305cacda61daafb0$var$parcelRegister("gdPjD", function(module1, exports) {
    var $jyGs4 = $305cacda61daafb0$var$parcelRequire("jyGs4");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jyGs4);
});
$305cacda61daafb0$var$parcelRegister("jyGs4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupMultiSelectDefaultProps", function() {
        return $9ca27a2e31f89510$export$ff957505f423908a;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LookupMultiSelect", function() {
        return $9ca27a2e31f89510$export$b15a2ce0522175f2;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    $305cacda61daafb0$var$parcelRequire("fcjYw");
    var $eVqjP = $305cacda61daafb0$var$parcelRequire("eVqjP");
    const $9ca27a2e31f89510$export$ff957505f423908a = {
        requiredLabel: "A value from the list is required",
        includeKeyInDescription: true,
        searchable: true,
        maxDropdownHeight: 260,
        clearable: true,
        createLabel: "+ Create",
        withinPortal: true,
        zIndex: 100000
    };
    function $9ca27a2e31f89510$export$b15a2ce0522175f2(props) {
        const { parentKeys: parentKeys, column: column, formStatus: formStatus, entityForm: entityForm, entity: entity, lookupDefName: lookupDefName, requiredLabel: requiredLabel, includeKeyInDescription: includeKeyInDescription, label: label, description: description, required: required, icon: icon, readOnly: readOnly, searchable: searchable, maxDropdownHeight: maxDropdownHeight, clearable: clearable, containerProps: containerProps, creatable: creatable, createLabel: createLabel, withAsterisk: withAsterisk, grow: grow, ...rest } = (0, $64A2P.useComponentDefaultProps)('LookupMultiSelect', $9ca27a2e31f89510$export$ff957505f423908a, props);
        const containerPropsMemo = (0, $acw62.useMemo)(()=>{
            if (grow) return {
                ...containerProps,
                style: {
                    ...containerProps?.style,
                    flex: 'auto'
                }
            };
            return containerProps;
        }, [
            containerProps,
            grow
        ]);
        const theme = (0, $64A2P.useMantineTheme)();
        const triggerRefreshState = (0, $acw62.useState)(true);
        const selectDataState = (0, $acw62.useState)([]);
        const [selectData, setSelectData] = selectDataState;
        const lookupSelectAPI = (0, $eVqjP.useLookupSelect)({
            parentKeys: parentKeys,
            selectDataState: selectDataState,
            triggerRefreshState: triggerRefreshState,
            column: column,
            entityForm: entityForm,
            entity: entity,
            lookupDefName: lookupDefName,
            maxItems: 0,
            includeKeyInDescription: includeKeyInDescription
        });
        const [showDescription] = entityForm.showDescriptionState;
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            required: required,
            requiredMessage: requiredLabel
        });
        const onCreate = (newValue)=>{
            const item = {
                value: newValue,
                label: newValue
            };
            setSelectData((current)=>[
                    ...current,
                    item
                ]);
            return item;
        };
        const updateDescription = (0, $acw62.useCallback)((value)=>{
            // Get the seted values description. Value is an array of values
            if (column.isArray) {
                // MMC: in rare cases the column can have a value but there is no selectData
                //  in that case skip updating column description 
                //(I found this placing a lookupMultiSelect inside an accordion item, where it mounts and unmounts the component before the data is fetched)
                if (column.value && selectData.length === 0) return;
                const values = value === null || value === undefined || value === '' ? [] : value;
                const descriptions = values.map((value)=>{
                    const index = selectData.findIndex((item)=>item.value === value);
                    return index >= 0 ? selectData[index].label : '';
                });
                column.valueDescription = descriptions.join(', ');
            }
        }, [
            column,
            selectData
        ]);
        // MMC: Effect for setting the column valueDescription
        const selectedValue = entityForm.form.values[column.name];
        (0, $acw62.useEffect)(()=>{
            updateDescription(selectedValue);
        }, [
            selectedValue,
            updateDescription
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
            ...containerPropsMemo,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($8LzkP.MultiSelect, {
                ...rest,
                withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
                styles: {
                    dropdown: {
                        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]
                    },
                    root: {
                        flexGrow: 1
                    }
                },
                searchable: searchable,
                maxDropdownHeight: maxDropdownHeight,
                clearable: clearable,
                label: label ?? column.prompt,
                description: showDescription ? description ?? column.description : '',
                icon: lookupSelectAPI.status.loading ? /*#__PURE__*/ (0, $ayMG0.jsx)($4P91H.Loader, {
                    size: "xs"
                }) : icon,
                data: selectData,
                readOnly: readOnly || entityForm.formMode === 'view' || lookupSelectAPI.status.loading || formStatus?.loading ? true : false,
                error: lookupSelectAPI.status.error ? lookupSelectAPI.status.error.message : null,
                creatable: creatable,
                onCreate: creatable ? onCreate : undefined,
                getCreateLabel: (newValue)=>`${createLabel} ${newValue}`,
                ...lookupSelectAPI.inputProps
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("jg7sD", function(module1, exports) {
    var $b6N7y = $305cacda61daafb0$var$parcelRequire("b6N7y");
    var $kcPpG = $305cacda61daafb0$var$parcelRequire("kcPpG");
    var $iGPzt = $305cacda61daafb0$var$parcelRequire("iGPzt");
    var $4jQJd = $305cacda61daafb0$var$parcelRequire("4jQJd");
    var $dZWTZ = $305cacda61daafb0$var$parcelRequire("dZWTZ");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $b6N7y);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kcPpG);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iGPzt);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $4jQJd);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dZWTZ);
});
$305cacda61daafb0$var$parcelRegister("b6N7y", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MenuDefaultProps", function() {
        return $5b01c2656a9b60e0$export$648b9c3a648993c8;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MenuNavBar", function() {
        return $5b01c2656a9b60e0$export$a25991d1e92b3392;
    });
    var $kcPpG = $305cacda61daafb0$var$parcelRequire("kcPpG");
    const $5b01c2656a9b60e0$export$648b9c3a648993c8 = {
        showSearch: true,
        searchLabel: "Search",
        searchIcon: $li55Z.default,
        autoCloseOnItemClickWhenSmallScreen: true
    };
    function $5b01c2656a9b60e0$export$a25991d1e92b3392(props) {
        const { items: items, setContent: setContent, clearContent: clearContent, activeIDState: activeIDState, subitemActiveIDState: subitemActiveIDState, showSearch: showSearch, searchLabel: searchLabel, searchIcon: searchIcon, setOpened: setOpened, autoCloseOnItemClickWhenSmallScreen: autoCloseOnItemClickWhenSmallScreen } = (0, $64A2P.useComponentDefaultProps)('MenuNavBar', $5b01c2656a9b60e0$export$648b9c3a648993c8, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const matches = (0, $kFu1s.useMediaQuery)(`(max-width: ${theme.breakpoints.sm})`);
        const [activeID, setActiveID] = activeIDState;
        const [subitemActiveID, setSubitemActiveID] = subitemActiveIDState;
        const header_section = (0, $acw62.useMemo)(()=>items.filter((item)=>item.section === 'header'), [
            items
        ]);
        const items_section = (0, $acw62.useMemo)(()=>items.filter((item)=>item.section === 'items'), [
            items
        ]);
        const footer_section = (0, $acw62.useMemo)(()=>items.filter((item)=>item.section === 'footer'), [
            items
        ]);
        const SearchIcon = searchIcon;
        const search = (0, $awfbW.useSpotlight)();
        const autoHideNavBarOnClick = autoCloseOnItemClickWhenSmallScreen && matches;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($d5Zz2.Navbar.Section, {
                    children: [
                        showSearch && /*#__PURE__*/ (0, $ayMG0.jsx)($iM1WI.NavLink, {
                            label: searchLabel,
                            icon: /*#__PURE__*/ (0, $ayMG0.jsx)(SearchIcon, {
                                size: "1.2rem"
                            }),
                            onClick: ()=>{
                                search.openSpotlight();
                            },
                            mb: "xs"
                        }, "menu-Search"),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($kcPpG.MenuNavLinks, {
                            AllItems: items,
                            sectionItems: header_section,
                            autoHideNavBarOnClick: autoHideNavBarOnClick,
                            setOpened: setOpened,
                            setContent: setContent,
                            clearContent: clearContent,
                            activeID: activeID,
                            onActiveChange: setActiveID,
                            subitemActiveID: subitemActiveID,
                            onSubitemActiveChange: setSubitemActiveID
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($d5Zz2.Navbar.Section, {
                    grow: true,
                    component: $5Eq0L.ScrollArea,
                    mx: "-xs",
                    px: "xs",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($kcPpG.MenuNavLinks, {
                        AllItems: items,
                        sectionItems: items_section,
                        autoHideNavBarOnClick: autoHideNavBarOnClick,
                        setOpened: setOpened,
                        setContent: setContent,
                        clearContent: clearContent,
                        activeID: activeID,
                        onActiveChange: setActiveID,
                        subitemActiveID: subitemActiveID,
                        onSubitemActiveChange: setSubitemActiveID
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($d5Zz2.Navbar.Section, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($kcPpG.MenuNavLinks, {
                        AllItems: items,
                        sectionItems: footer_section,
                        autoHideNavBarOnClick: autoHideNavBarOnClick,
                        setOpened: setOpened,
                        setContent: setContent,
                        clearContent: clearContent,
                        activeID: activeID,
                        onActiveChange: setActiveID,
                        subitemActiveID: subitemActiveID,
                        onSubitemActiveChange: setSubitemActiveID
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("kcPpG", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MenuItemsPropsDefaultProps", function() {
        return $8004c5e6672b13d6$export$b2896d53243c29db;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MenuNavLinks", function() {
        return $8004c5e6672b13d6$export$d3c31298c8ea0ef2;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $lTNXP = $305cacda61daafb0$var$parcelRequire("lTNXP");
    var $hPSwj = $305cacda61daafb0$var$parcelRequire("hPSwj");
    const $8004c5e6672b13d6$export$b2896d53243c29db = {
        defaultLoadingComponent: /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {})
    };
    function $8004c5e6672b13d6$export$d3c31298c8ea0ef2(props) {
        const { AllItems: AllItems, sectionItems: sectionItems, setContent: setContent, clearContent: clearContent, activeID: activeID, subitemActiveID: subitemActiveID, defaultLoadingComponent: defaultLoadingComponent, onActiveChange: onActiveChange, onSubitemActiveChange: onSubitemActiveChange, showSubitemIcons: showSubitemIcons, showItemDescription: showItemDescription, setOpened: setOpened, autoHideNavBarOnClick: autoHideNavBarOnClick } = (0, $64A2P.useComponentDefaultProps)('MenuItems', $8004c5e6672b13d6$export$b2896d53243c29db, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const { navigate: navigate, path: path } = (0, $hPSwj.useMicroMRouter)();
        const setActiveContent = (0, $acw62.useCallback)(async (menuItem)=>{
            if (menuItem.content) {
                if ((0, $lTNXP.isPromise)(menuItem.content)) {
                    setContent(defaultLoadingComponent);
                    const content = await menuItem.content;
                    setContent(content);
                } else setContent(menuItem.content);
            } else if (clearContent) setContent(/*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {}));
            if (menuItem.onClick) menuItem.onClick();
        }, [
            clearContent,
            defaultLoadingComponent,
            setContent
        ]);
        // Handler to process navigation based on the current path. This renders the content for navigated item
        (0, $acw62.useEffect)(()=>{
            const pathParts = path.split('/').filter((part)=>part.trim() !== '');
            const [itemId, subitemId] = pathParts;
            const item = AllItems.find((it)=>it.ID === itemId);
            if (item) {
                if (!item.noActive) onActiveChange(item.ID);
                if (subitemId && item.subitems) {
                    const subitem = item.subitems.find((si)=>si.ID === subitemId);
                    if (subitem) {
                        onSubitemActiveChange(subitem.ID);
                        setActiveContent(subitem);
                    } else onSubitemActiveChange('');
                } else {
                    // setContent only on las level, if we have subitems just expand the menu
                    if (!item.subitems) setActiveContent(item);
                    onSubitemActiveChange(''); // Ensure subitemActiveID is cleared
                }
            } else if (clearContent) {
                // Path does not match any item
                setContent(/*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {}));
                onActiveChange('');
                onSubitemActiveChange('');
            }
        }, [
            clearContent,
            AllItems,
            onActiveChange,
            onSubitemActiveChange,
            path,
            setActiveContent,
            setContent
        ]);
        // Route for navigation
        const handleItemClick = (item, subitem)=>{
            const route = subitem ? `/${item.ID}/${subitem.ID}` : `/${item.ID}`;
            navigate(`${route}`);
            if (autoHideNavBarOnClick && !item.subitems) setOpened(false);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: sectionItems.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($iM1WI.NavLink, {
                    label: item.notifications && (item.subitems || item.rightSection) ? /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                                sx: {
                                    flex: 1
                                },
                                children: item.labelComponent ?? item.label
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iPjI4.Badge, {
                                sx: {
                                    justifySelf: "flex-end"
                                },
                                variant: "filled",
                                size: "xs",
                                children: item.notifications
                            })
                        ]
                    }) : item.labelComponent ?? item.label,
                    icon: item.icon,
                    rightSection: item.notifications && !item.subitems && !item.rightSection ? /*#__PURE__*/ (0, $ayMG0.jsx)($iPjI4.Badge, {
                        variant: "filled",
                        size: "xs",
                        children: item.notifications
                    }) : item.rightSection,
                    description: showItemDescription && item.description,
                    onClick: ()=>handleItemClick(item),
                    active: item.noActive !== true && item.ID === activeID,
                    opened: item.noActive !== true && item.ID === activeID && item.subitems && item.subitems.some((subitem)=>subitem.noActive !== true && subitem.ID === subitemActiveID) || undefined,
                    children: item.subitems && item.subitems.map((subitem)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($iM1WI.NavLink, {
                            sx: {
                                borderLeft: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`
                            },
                            pl: "1.8rem",
                            label: subitem.label,
                            icon: showSubitemIcons && subitem.icon,
                            rightSection: subitem.notifications && /*#__PURE__*/ (0, $ayMG0.jsx)($iPjI4.Badge, {
                                variant: "filled",
                                size: "xs",
                                children: subitem.notifications
                            }),
                            description: showItemDescription && subitem.description,
                            onClick: ()=>handleItemClick(item, subitem),
                            active: subitem.noActive !== true && subitem.ID === subitemActiveID
                        }, item.ID + subitem.ID);
                    })
                }, item.ID))
        });
    }
});
$305cacda61daafb0$var$parcelRegister("hPSwj", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicroMRouterContext", function() {
        return $feadadb6fe65ee76$export$d9f8b508d4753fc7;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useMicroMRouter", function() {
        return $feadadb6fe65ee76$export$124cab9faba23e99;
    });
    const $feadadb6fe65ee76$export$d9f8b508d4753fc7 = (0, $acw62.createContext)(undefined);
    const $feadadb6fe65ee76$export$124cab9faba23e99 = ()=>{
        const context = (0, $acw62.useContext)($feadadb6fe65ee76$export$d9f8b508d4753fc7);
        if (context === undefined) throw new Error('useMicroMRouter must be used within a RouterProvider');
        return context;
    };
});
$305cacda61daafb0$var$parcelRegister("iGPzt", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MenuPanelDefaultProps", function() {
        return $85ebd7a43eb2f762$export$269f2011c8be9b63;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MenuNavBarPanel", function() {
        return $85ebd7a43eb2f762$export$3c1a5eed89d78dce;
    });
    var $b6N7y = $305cacda61daafb0$var$parcelRequire("b6N7y");
    const $85ebd7a43eb2f762$export$269f2011c8be9b63 = {
        showSearch: true,
        searchLabel: "Search",
        searchIcon: $li55Z.default,
        autoCloseOnItemClickWhenSmallScreen: true
    };
    function $85ebd7a43eb2f762$export$3c1a5eed89d78dce(props) {
        const { setContent: setContent, menuItems: menuItems, activeIDState: activeIDState, subitemActiveIDState: subitemActiveIDState, showSearch: showSearch, searchLabel: searchLabel, searchIcon: searchIcon, setOpened: setOpened, autoCloseOnItemClickWhenSmallScreen: autoCloseOnItemClickWhenSmallScreen } = (0, $64A2P.useComponentDefaultProps)('MenuNavBarPanel', $85ebd7a43eb2f762$export$269f2011c8be9b63, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($b6N7y.MenuNavBar, {
            showSearch: showSearch,
            searchLabel: searchLabel,
            searchIcon: searchIcon,
            items: menuItems,
            setContent: setContent,
            setOpened: setOpened,
            clearContent: true,
            activeIDState: activeIDState,
            subitemActiveIDState: subitemActiveIDState,
            autoCloseOnItemClickWhenSmallScreen: autoCloseOnItemClickWhenSmallScreen
        });
    }
});
$305cacda61daafb0$var$parcelRegister("4jQJd", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("dZWTZ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseMenuContentDefaultProps", function() {
        return $468dbc1019a115f1$export$5920af2d37d82a1b;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useMenuContent", function() {
        return $468dbc1019a115f1$export$48c6e824f65803ea;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $lTNXP = $305cacda61daafb0$var$parcelRequire("lTNXP");
    const $468dbc1019a115f1$export$5920af2d37d82a1b = {
        enableMenuSecurity: true,
        defaultLoadingComponent: /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {})
    };
    const $468dbc1019a115f1$var$triggerItemAction = async (props)=>{
        const { item: item, setContent: setContent, setOpened: setOpened, clearContent: clearContent, onActiveChange: onActiveChange, onSubitemActiveChange: onSubitemActiveChange, defaultLoadingComponent: defaultLoadingComponent, autoHideNavBarOnClick: autoHideNavBarOnClick } = props;
        if (!item.noActive) {
            // MMC: TODO, change the activeIDState to a single state
            onActiveChange(item.ID);
            onSubitemActiveChange(item.ID);
        } else {
            onActiveChange('');
            onSubitemActiveChange('');
        }
        if (item.content) {
            if ((0, $lTNXP.isPromise)(item.content)) {
                setContent(item.loadingComponent ?? defaultLoadingComponent);
                const menuContent = await item.content;
                setContent(menuContent);
            } else setContent(item.content);
        } else if (clearContent) setContent(/*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {}));
        if (item.onClick) item.onClick();
        if (autoHideNavBarOnClick && !item.subitems) setOpened(false);
    };
    function $468dbc1019a115f1$export$48c6e824f65803ea(props) {
        const { client: client, setContent: setContent, isLoggedIn: isLoggedIn, setIsLoggedIn: setIsLoggedIn, menuContent: menuContent, defaultLoadingComponent: defaultLoadingComponent, setOpened: setOpened, loggedInInfo: loggedInInfo, menuId: menuId, enableMenuSecurity: enableMenuSecurity } = (0, $64A2P.useComponentDefaultProps)('useMenuContent', $468dbc1019a115f1$export$5920af2d37d82a1b, props);
        const activeIDState = (0, $acw62.useState)('');
        const [, setActiveID] = activeIDState;
        const subitemActiveIDState = (0, $acw62.useState)('');
        const [, setSubitemActiveID] = subitemActiveIDState;
        const [items, setItems] = (0, $acw62.useState)([]);
        const [actions, setActions] = (0, $acw62.useState)([]);
        const filterEnabledItems = (0, $acw62.useCallback)((items, menuId, enabled)=>{
            return items.filter((item)=>enabled.has(`${menuId}_${item.ID}`)).map((item)=>{
                if (item.subitems) {
                    const filteredSubitems = filterEnabledItems(item.subitems, menuId, enabled);
                    return {
                        ...item,
                        subitems: filteredSubitems.length > 0 ? filteredSubitems : undefined
                    };
                }
                return item;
            });
        // MMC: leave the items without subitems as can be valid options
        //.filter(item => !(item.subitems && item.subitems.length === 0));
        }, []);
        const internal_items = (0, $acw62.useMemo)(()=>{
            return menuContent({
                client: client,
                setContent: setContent,
                setOpened: setOpened,
                isLoggedIn: isLoggedIn,
                setIsLoggedIn: setIsLoggedIn,
                loggedInInfo: loggedInInfo,
                menuId: menuId
            });
        }, [
            menuContent,
            client,
            setContent,
            setOpened,
            isLoggedIn,
            setIsLoggedIn,
            loggedInInfo,
            menuId
        ]);
        // MMC: defines a function called getSpotlightActions that returns an array of mantine SpotLightAction from items
        const internal_actions = (0, $acw62.useMemo)(()=>internal_items.flatMap((item)=>{
                const baseActionProps = {
                    setContent: setContent,
                    setOpened: setOpened,
                    clearContent: true,
                    defaultLoadingComponent: defaultLoadingComponent,
                    onActiveChange: setActiveID,
                    onSubitemActiveChange: setSubitemActiveID
                };
                let actionList = [];
                if (item.section === 'items' && !item.subitems) actionList.push({
                    id: item.ID,
                    target: `#${item.ID}`,
                    title: item.label,
                    description: item.description,
                    icon: item.icon,
                    onTrigger: ()=>$468dbc1019a115f1$var$triggerItemAction({
                            ...baseActionProps,
                            item: item
                        })
                });
                if (item.subitems) actionList = actionList.concat(item.subitems.map((subitem)=>({
                        id: subitem.ID,
                        target: `#${subitem.ID}`,
                        title: subitem.label,
                        description: subitem.description,
                        icon: subitem.icon,
                        onTrigger: ()=>$468dbc1019a115f1$var$triggerItemAction({
                                ...baseActionProps,
                                item: subitem
                            })
                    })));
                return actionList;
            }), [
            internal_items,
            setContent,
            setOpened,
            defaultLoadingComponent,
            setActiveID,
            setSubitemActiveID
        ]);
        (0, $acw62.useEffect)(()=>{
            const get = async ()=>{
                if (isLoggedIn) {
                    if (enableMenuSecurity) {
                        const enabled = await client.getMenus();
                        const enabled_items = filterEnabledItems(internal_items, menuId, enabled);
                        const enabled_actions = internal_actions.filter((item)=>enabled.has(`${menuId}_${item.id}`));
                        setItems(enabled_items);
                        setActions(enabled_actions);
                    } else {
                        setItems(internal_items);
                        setActions(internal_actions);
                    }
                } else {
                    setItems([]);
                    setActions([]);
                }
            };
            get();
        }, [
            client,
            isLoggedIn,
            menuId,
            enableMenuSecurity
        ]);
        const result = (0, $acw62.useMemo)(()=>({
                activeIDState: activeIDState,
                subitemActiveIDState: subitemActiveIDState,
                items: items,
                actions: actions
            }), [
            activeIDState,
            subitemActiveIDState,
            items,
            actions
        ]);
        return result;
    }
});
$305cacda61daafb0$var$parcelRegister("lB56X", function(module1, exports) {
    var $6sKy8 = $305cacda61daafb0$var$parcelRequire("6sKy8");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $6sKy8);
});
$305cacda61daafb0$var$parcelRegister("6sKy8", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("ccjva", function(module1, exports) {
    var $5yF9X = $305cacda61daafb0$var$parcelRequire("5yF9X");
    var $7n39P = $305cacda61daafb0$var$parcelRequire("7n39P");
    var $43s6t = $305cacda61daafb0$var$parcelRequire("43s6t");
    var $kBmms = $305cacda61daafb0$var$parcelRequire("kBmms");
    var $2iAx4 = $305cacda61daafb0$var$parcelRequire("2iAx4");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5yF9X);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7n39P);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $43s6t);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kBmms);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2iAx4);
});
$305cacda61daafb0$var$parcelRegister("5yF9X", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useDataView", function() {
        return $28349dd4d40e362f$export$2d2c672e82add59e;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $7T941 = $305cacda61daafb0$var$parcelRequire("7T941");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $1uAlg = $305cacda61daafb0$var$parcelRequire("1uAlg");
    var $a2vzY = $305cacda61daafb0$var$parcelRequire("a2vzY");
    function $28349dd4d40e362f$export$2d2c672e82add59e(props, stateProps) {
        const { entity: entity, parentKeys: parentKeys, viewName: viewName, limit: limit, onSelectionChanged: onSelectionChanged, modalFormSize: modalFormSize, onModalSaved: onModalSaved, labels: labels, saveFormBeforeAdd: saveFormBeforeAdd, parentFormAPI: parentFormAPI, allwaysRefreshOnEntityClose: allwaysRefreshOnEntityClose, notExportableColumns: notExportableColumns, itemsPerPage: itemsPerPage, onActionExecuted: onActionExecuted, convertResultToLocaleString: convertResultToLocaleString, withModalFullscreenButton: withModalFullscreenButton, onDataRefresh: onDataRefresh } = props;
        const localeFormat = (0, $a2vzY.useLocaleFormat)({
            timeZoneOffset: entity?.API.client.TIMEZONE_OFFSET || 0
        });
        const { setRefresh: setRefresh, setSearchText: setSearchText, executeViewState: executeViewState } = stateProps;
        const selectedRecords = (0, $acw62.useRef)([]);
        const [selectedRowsCount, setSelectedRowsCount] = (0, $acw62.useState)(0);
        const [toggleSelectable, setToggleSelectable] = (0, $acw62.useState)(false);
        const [limitRows, setLimitRows] = (0, $acw62.useState)(limit ? limit : null);
        const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
        const data = (0, $acw62.useRef)([]);
        const [displayedItemsCount, setDisplayedItemsCount] = (0, $acw62.useState)(itemsPerPage);
        const [viewResult, setViewResult] = (0, $acw62.useState)(null);
        // MMC: we can't use callbacks here because we need to use the latest values of the state variables
        const internalRefresh = (0, $acw62.useCallback)(()=>{
            setRefresh((prev)=>!prev);
        }, [
            setRefresh
        ]);
        const handleRefresh = (0, $acw62.useCallback)((search_text)=>{
            setSearchText(search_text);
            setRefresh((prev)=>!prev);
        }, [
            setRefresh,
            setSearchText
        ]);
        const handleModalSaved = (0, $acw62.useCallback)(async (new_status)=>{
            if (!new_status.error && !new_status.loading && new_status.data && !allwaysRefreshOnEntityClose) internalRefresh();
            if (onModalSaved) await onModalSaved(new_status);
        }, [
            allwaysRefreshOnEntityClose,
            internalRefresh,
            onModalSaved
        ]);
        const handleAllwaysRefreshOnClose = (0, $acw62.useCallback)(()=>{
            if (allwaysRefreshOnEntityClose) internalRefresh();
        }, [
            allwaysRefreshOnEntityClose,
            internalRefresh
        ]);
        const UIAPI = (0, $1uAlg.useEntityUI)({
            entity: entity,
            parentKeys: parentKeys,
            modalFormSize: modalFormSize,
            parentFormAPI: parentFormAPI,
            saveFormBeforeAdd: saveFormBeforeAdd,
            withModalFullscreenButton: withModalFullscreenButton,
            onModalSaved: handleModalSaved,
            onModalClosed: handleAllwaysRefreshOnClose,
            onRecordsDeleted: internalRefresh,
            onActionRefreshOnClose: internalRefresh,
            labels: labels,
            onActionExecuted: onActionExecuted
        });
        const getRecordKeys = (0, $acw62.useCallback)((record)=>{
            if (!entity || !record) return {}; // MMC: this should never happen
            const keys = {};
            // MMC: keyMappings is an object with the column names as keys and the index of the column in the viewResult as value
            const key_mappings = entity.def.views[viewName].keyMappings;
            for(const columnName in key_mappings){
                const idx = key_mappings[columnName]; // MMC: index of the column in the record
                if (idx >= record.length) continue;
                keys[columnName] = record[idx];
            }
            return keys;
        }, [
            entity,
            viewName
        ]);
        const getSelectionKeys = (0, $acw62.useCallback)(()=>{
            // MMC: if viewResult is null, it means that the view has not been executed yet
            if (!data) return [];
            if (selectedRecords.current.length === 0) return [];
            const selection = selectedRecords.current;
            const result = [];
            // MMC: dataViewSelection is an array of indexes of the selected records in the viewResult
            for(let i = 0; i < selection.length; i++){
                const keys = data.current[selection[i]].keys;
                if (keys) result.push(keys);
            }
            return result;
        }, []);
        const handleSelectRecord = (0, $acw62.useCallback)(async (record_index)=>{
            if (selectedRecords.current.includes(record_index)) return;
            selectedRecords.current.push(record_index);
            setSelectedRowsCount(selectedRecords.current.length);
            if (onSelectionChanged) onSelectionChanged(selectedRecords.current, getSelectionKeys());
        }, [
            getSelectionKeys,
            onSelectionChanged
        ]);
        const handleDeselectRecord = (0, $acw62.useCallback)(async (record_index)=>{
            const index_to_remove = selectedRecords.current.indexOf(record_index);
            if (index_to_remove === -1) return;
            selectedRecords.current.splice(index_to_remove, 1);
            setSelectedRowsCount(selectedRecords.current.length);
            if (onSelectionChanged) onSelectionChanged(selectedRecords.current, getSelectionKeys());
        }, [
            getSelectionKeys,
            onSelectionChanged
        ]);
        const handleSelectAllRecords = (0, $acw62.useCallback)(async ()=>{
            selectedRecords.current = data.current.map((_, index)=>index) ?? [];
            setSelectedRowsCount(selectedRecords.current.length);
            if (onSelectionChanged) onSelectionChanged(selectedRecords.current, getSelectionKeys());
        }, [
            getSelectionKeys,
            onSelectionChanged
        ]);
        const handleDeselectAllRecords = (0, $acw62.useCallback)(async ()=>{
            selectedRecords.current = [];
            setSelectedRowsCount(selectedRecords.current.length);
            if (onSelectionChanged) onSelectionChanged(selectedRecords.current, getSelectionKeys());
        }, [
            getSelectionKeys,
            onSelectionChanged
        ]);
        const handleSelectionChanged = (0, $acw62.useCallback)(async (newSelection)=>{
            selectedRecords.current = newSelection.filter((index)=>index >= 0 && index < selectedRecords.current.length);
            setSelectedRowsCount(selectedRecords.current.length);
            if (onSelectionChanged) onSelectionChanged(selectedRecords.current, getSelectionKeys());
        }, [
            onSelectionChanged,
            getSelectionKeys
        ]);
        const handleToggleSelectable = (0, $acw62.useCallback)(()=>{
            setToggleSelectable((prev)=>!prev);
        }, []);
        const handleEditClick = (0, $acw62.useCallback)(async (keys, element)=>{
            if (!entity || entity.Form === null) return;
            if (!keys) return;
            await UIAPI.handleEditClick(keys, element);
        }, [
            UIAPI,
            entity
        ]);
        const handleViewClick = (0, $acw62.useCallback)(async (keys, element)=>{
            if (!entity || entity.Form === null) return;
            if (!keys) return;
            await UIAPI.handleViewClick(keys, element);
        }, [
            entity,
            UIAPI
        ]);
        const handleDeleteClick = (0, $acw62.useCallback)(async (element)=>{
            const keys = getSelectionKeys();
            await UIAPI.handleDeleteClick(keys, element);
        }, [
            UIAPI,
            getSelectionKeys
        ]);
        const handleDeleteRecord = (0, $acw62.useCallback)(async (keys, element)=>{
            if (!keys) return;
            await UIAPI.handleDeleteRecord(keys, element);
        }, [
            UIAPI
        ]);
        const handleExecuteAction = (0, $acw62.useCallback)(async (action, recordIndex, element)=>{
            if (recordIndex !== undefined) selectedRecords.current = [
                recordIndex
            ];
            const keys = getSelectionKeys();
            return await UIAPI.handleExecuteAction(action, keys, element);
        }, [
            UIAPI,
            getSelectionKeys
        ]);
        const handleExport = (0, $acw62.useCallback)(()=>{
            if (!viewResult) return;
            (0, $7T941.exportToExcel)([
                viewResult
            ], notExportableColumns);
        }, [
            notExportableColumns,
            viewResult
        ]);
        const formatValue = (0, $acw62.useCallback)((value, sqlType)=>{
            const rawValue = localeFormat.formatValue(localeFormat.getNativeValue(value, sqlType), sqlType);
            return rawValue === 'null' ? '' : rawValue;
        }, [
            localeFormat
        ]);
        const handleLoadMore = ()=>{
            setDisplayedItemsCount((currentCount)=>Math.min(currentCount + itemsPerPage, data.current.length));
        };
        (0, $acw62.useEffect)(()=>{
            if (executeViewState.loading) {
                setIsLoading(true);
                setDisplayedItemsCount(itemsPerPage);
            } else if (executeViewState.error) setIsLoading(false);
            else if (!executeViewState.error && executeViewState.data?.length) {
                const data_result = executeViewState.data[0];
                const headers = data_result.Header.map($7T941.toCamelCase); // transform header names
                const new_data = data_result.records.map((record)=>{
                    return {
                        keys: getRecordKeys(record),
                        data: (0, $7T941.convertRecordToValuesObject)(record, headers, data_result.typeInfo, convertResultToLocaleString ? formatValue : undefined)
                    };
                });
                data.current = new_data;
                setViewResult(data_result);
                setIsLoading(false);
                if (onDataRefresh) onDataRefresh(executeViewState);
            } else if (!executeViewState.error && executeViewState.data?.length === 0) {
                data.current = [];
                setViewResult(null);
                setIsLoading(false);
            }
        }, [
            executeViewState,
            formatValue,
            getRecordKeys,
            convertResultToLocaleString,
            onDataRefresh
        ]);
        return {
            handleSelectionChanged: handleSelectionChanged,
            handleDeleteRecord: handleDeleteRecord,
            handleDeleteClick: handleDeleteClick,
            handleEditClick: handleEditClick,
            handleAddClick: UIAPI.handleAddClick,
            handleViewClick: handleViewClick,
            handleToggleSelectable: handleToggleSelectable,
            handleRefresh: handleRefresh,
            handleExecuteAction: handleExecuteAction,
            handleExport: handleExport,
            selectedRowsCount: selectedRowsCount,
            limitRows: limitRows,
            setLimitRows: setLimitRows,
            showSelectCheckbox: toggleSelectable,
            isLoading: isLoading,
            executeViewState: executeViewState,
            data: data.current.slice(0, displayedItemsCount),
            handleDeselectAllRecords: handleDeselectAllRecords,
            handleDeselectRecord: handleDeselectRecord,
            handleSelectRecord: handleSelectRecord,
            handleSelectAllRecords: handleSelectAllRecords,
            selectedRecords: selectedRecords.current,
            toggleSelectable: toggleSelectable,
            handleLoadMore: handleLoadMore,
            displayedItemsCount: displayedItemsCount,
            recordsCount: data.current.length
        };
    }
});
$305cacda61daafb0$var$parcelRegister("7n39P", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataViewDefaultProps", function() {
        return $2a573abad3e0e83e$export$8d0177ff9f5686ad;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataView", function() {
        return $2a573abad3e0e83e$export$5e15d737b33a1c27;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $lB8CV = $305cacda61daafb0$var$parcelRequire("lB8CV");
    var $7B1hX = $305cacda61daafb0$var$parcelRequire("7B1hX");
    $305cacda61daafb0$var$parcelRequire("2Qb3Q");
    var $3vFhj = $305cacda61daafb0$var$parcelRequire("3vFhj");
    var $j8hoz = $305cacda61daafb0$var$parcelRequire("j8hoz");
    var $2iAx4 = $305cacda61daafb0$var$parcelRequire("2iAx4");
    var $5yF9X = $305cacda61daafb0$var$parcelRequire("5yF9X");
    const $2a573abad3e0e83e$export$8d0177ff9f5686ad = {
        search: [],
        limit: "1000",
        toolbarIconVariant: "light",
        actionsButtonVariant: "light",
        modalFormSize: "lg",
        enableAdd: true,
        enableEdit: true,
        enableDelete: true,
        enableExport: true,
        CardContainer: $2iAx4.DataViewCardContainer,
        itemsPerPage: 50,
        labels: {
            addLabel: "Add",
            editLabel: "Edit",
            deleteLabel: "Delete",
            viewLabel: "View",
            rowsReturnedLabel: "Rows returned:",
            selectedRowsLabel: "rows selected.",
            limitLabel: "Limit",
            rowsLabel: "rows",
            unlimitedLabel: "Unlimited",
            recordsLabel: "records",
            recordLabel: "record",
            AreYouSureLabel: "Are you sure?",
            YouWillDeleteLabel: "You will delete",
            warningLabel: "Warning",
            YouMustSelectOneOrMoreRecordsToDelete: "You must select one or more records to delete",
            closeLabel: "Close",
            YouMustSelectOneOrMoreRecordsToExecuteAction: "You must select one or more records to execute this action",
            resultLimitLabel: "Results are limited to %s records.",
            loadMoreLabel: "Load More",
            fetchingDataLabel: "Fetching data...",
            noRecordsFoundLabel: "No records found",
            YouMustSelectAtLeast: "You must select at least",
            YouMustSelectBetween: "You must select between",
            YouMustSelect: "You must select",
            YouMustSelectMaximum: "You must select a maximum of"
        },
        filtersFormSize: "md",
        convertResultToLocaleString: true,
        showActions: true,
        showToolbar: true,
        showDeleteOnlyWhenMultiselect: true,
        withModalFullscreenButton: true,
        CardRowAlign: "flex-start",
        RowsContainer: $9mTYo.Group
    };
    const $2a573abad3e0e83e$export$5e15d737b33a1c27 = /*#__PURE__*/ (0, $acw62.forwardRef)(function DataView(props, ref) {
        props = (0, $64A2P.useComponentDefaultProps)('DataView', $2a573abad3e0e83e$export$8d0177ff9f5686ad, props);
        const { entity: entity, autoFocus: autoFocus, toolbarIconVariant: toolbarIconVariant, actionsButtonVariant: actionsButtonVariant, enableAdd: enableAdd, enableEdit: enableEdit, enableDelete: enableDelete, enableView: enableView, enableExport: enableExport, labels: labels, Card: Card, CardContainer: CardContainer, limit: limit, search: search, viewName: viewName, filtersFormSize: filtersFormSize, toolbarSize: toolbarSize, showAppliedFilters: showAppliedFilters, showRefreshButton: showRefreshButton, hideCheckboxToggle: hideCheckboxToggle, showFiltersButton: showFiltersButton, searchPlaceholder: searchPlaceholder, showActions: showActions, parentKeys: parentKeys, visibleFilters: visibleFilters, setInitialFiltersFromColumns: setInitialFiltersFromColumns, cardHrefRootURL: cardHrefRootURL, cardHrefTarget: cardHrefTarget, showSearchInput: showSearchInput, showSelectRowsButton: showSelectRowsButton, showToolbar: showToolbar, showDeleteOnlyWhenMultiselect: showDeleteOnlyWhenMultiselect, parentFormAPI: parentFormAPI, formMode: formMode, CardRowAlign: CardRowAlign, RowsContainer: RowsContainer } = props;
        const [searchData, setSearchData] = (0, $acw62.useState)(search?.map((s)=>{
            return {
                value: s,
                label: s
            };
        }));
        const viewState = (0, $7B1hX.useViewState)(search, limit);
        const executeViewState = (0, $lB8CV.useExecuteView)(entity, parentKeys, viewName, viewState.searchText, viewState.limitRows, viewState.refresh, viewState.filterValues);
        const dataViewAPI = (0, $5yF9X.useDataView)(props, {
            executeViewState: executeViewState,
            setRefresh: viewState.setRefresh,
            setSearchText: viewState.setSearchText
        });
        const { handleLoadMore: handleLoadMore } = dataViewAPI;
        const limit_number = parseInt(limit || '0');
        const effectiveFormMode = formMode || parentFormAPI?.formMode || 'add';
        if (entity?.def.views[viewName] === undefined) console.warn(`DataView: View ${viewName} not found in entity ${entity?.def.name}`);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
            ref: ref,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                spacing: "sm",
                children: [
                    showToolbar && /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($3vFhj.DataGridToolbar, {
                            ...labels,
                            enableExport: enableExport,
                            onExportClick: dataViewAPI.handleExport,
                            onRefreshClick: dataViewAPI.handleRefresh,
                            onCheckboxToggle: dataViewAPI.handleToggleSelectable,
                            autoFocus: autoFocus,
                            toolbarIconVariant: toolbarIconVariant,
                            searchText: viewState.searchText,
                            setSearchText: viewState.setSearchText,
                            searchData: searchData,
                            setSearchData: setSearchData,
                            client: entity?.API.client,
                            FiltersEntity: entity && viewName && entity?.def.views[viewName] ? entity?.def.views[viewName].FiltersEntity : undefined,
                            filterValues: viewState.filterValues,
                            setFilterValues: viewState.setFilterValues,
                            filtersDescription: viewState.filtersDescription,
                            setFiltersDescription: viewState.setFiltersDescription,
                            filtersFormSize: filtersFormSize,
                            size: toolbarSize,
                            showAppliedFilters: showAppliedFilters,
                            showRefreshButton: showRefreshButton,
                            showFiltersButton: showFiltersButton,
                            showSearchInput: showSearchInput,
                            showSelectRowsButton: showSelectRowsButton,
                            hideCheckboxToggle: hideCheckboxToggle,
                            searchPlaceholder: searchPlaceholder,
                            visibleFilters: visibleFilters,
                            initialColumnFilters: setInitialFiltersFromColumns && entity ? entity.def.columns : undefined
                        })
                    }),
                    showActions && /*#__PURE__*/ (0, $ayMG0.jsx)($j8hoz.DataGridActionsToolbar, {
                        ...labels,
                        viewName: viewName,
                        onAddClick: dataViewAPI.handleAddClick,
                        onDeleteClick: dataViewAPI.handleDeleteClick,
                        enableAdd: enableAdd,
                        enableEdit: false,
                        enableDelete: enableDelete && (showDeleteOnlyWhenMultiselect ? dataViewAPI.showSelectCheckbox : true),
                        enableView: false,
                        actionsButtonVariant: actionsButtonVariant,
                        clientActions: entity ? entity.def.clientActions : {},
                        handleExecuteAction: dataViewAPI.handleExecuteAction,
                        parentFormMode: effectiveFormMode
                    }),
                    !showActions && /*#__PURE__*/ (0, $ayMG0.jsx)($5iXv4.Space, {
                        h: "xs"
                    }),
                    dataViewAPI.isLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($4P91H.Loader, {
                                size: "sm"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                fz: "sm",
                                c: "dimmed",
                                children: labels?.fetchingDataLabel
                            })
                        ]
                    }),
                    !dataViewAPI.isLoading && dataViewAPI.executeViewState.error && /*#__PURE__*/ (0, $ayMG0.jsxs)($d50o9.AlertError, {
                        mb: "xs",
                        children: [
                            "Error: ",
                            dataViewAPI.executeViewState.error.status,
                            " ",
                            dataViewAPI.executeViewState.error.message,
                            " ",
                            dataViewAPI.executeViewState.error.statusMessage
                        ]
                    }),
                    !dataViewAPI.isLoading && !dataViewAPI.executeViewState.error && dataViewAPI.data.length > 0 && dataViewAPI.recordsCount === limit_number && limit_number !== 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        fz: "sm",
                        align: "center",
                        fw: 500,
                        c: "dimmed",
                        children: labels?.resultLimitLabel?.replace('%s', limit || '')
                    }),
                    !dataViewAPI.isLoading && !dataViewAPI.executeViewState.error && dataViewAPI.data.length === 0 && search && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        fz: "sm",
                        align: "center",
                        fw: 500,
                        c: "dimmed",
                        children: labels?.noRecordsFoundLabel
                    }),
                    dataViewAPI.data.length > 0 && RowsContainer && /*#__PURE__*/ (0, $ayMG0.jsx)(RowsContainer, {
                        ...CardRowAlign ? {
                            align: CardRowAlign
                        } : null,
                        children: CardContainer && entity && dataViewAPI.data.map((record, index)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsx)(CardContainer, {
                                record: record,
                                EntityCard: Card,
                                recordIndex: index,
                                entity: entity,
                                enableDelete: effectiveFormMode !== 'view' && enableDelete,
                                enableEdit: effectiveFormMode !== 'view' && enableEdit,
                                enableView: enableView !== undefined ? enableView : effectiveFormMode === 'view',
                                handleSelectRecord: dataViewAPI.handleSelectRecord,
                                handleDeselectRecord: dataViewAPI.handleDeselectRecord,
                                handleDeleteClick: dataViewAPI.handleDeleteRecord,
                                handleEditClick: dataViewAPI.handleEditClick,
                                handleViewClick: dataViewAPI.handleViewClick,
                                handleExecuteAction: dataViewAPI.handleExecuteAction,
                                selected: dataViewAPI.selectedRecords.includes(index),
                                toggleSelectable: dataViewAPI.toggleSelectable,
                                refreshView: ()=>viewState.setRefresh((prev)=>!prev),
                                cardHrefRootURL: cardHrefRootURL,
                                cardHrefTarget: cardHrefTarget
                            }, `CC_${entity.def.name}-${index}`);
                        })
                    }),
                    !dataViewAPI.isLoading && !dataViewAPI.executeViewState.error && dataViewAPI.data.length > 0 && (dataViewAPI.recordsCount || 0) > dataViewAPI.displayedItemsCount && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        size: "xs",
                        variant: "light",
                        onClick: handleLoadMore,
                        children: labels?.loadMoreLabel
                    })
                ]
            })
        });
    });
});
$305cacda61daafb0$var$parcelRegister("2iAx4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataViewCardContainerDefaultProps", function() {
        return $38b7113580d9a1a1$export$d13f8a6d57c9f999;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataViewCardContainer", function() {
        return $38b7113580d9a1a1$export$a1905d17a14ce215;
    });
    var $7n39P = $305cacda61daafb0$var$parcelRequire("7n39P");
    const $38b7113580d9a1a1$export$d13f8a6d57c9f999 = {
        CardProps: {
            shadow: "sm",
            withBorder: true
        }
    };
    function $38b7113580d9a1a1$export$a1905d17a14ce215(props) {
        const { recordIndex: recordIndex, selected: selected, handleDeleteClick: handleDeleteClick, handleDeselectRecord: handleDeselectRecord, handleEditClick: handleEditClick, handleSelectRecord: handleSelectRecord, handleViewClick: handleViewClick, enableDelete: enableDelete, enableEdit: enableEdit, enableView: enableView, entity: entity, record: record, toggleSelectable: toggleSelectable, EntityCard: EntityCard, CardProps: CardProps, refreshView: refreshView, handleCardClick: handleCardClick, cardHrefRootURL: cardHrefRootURL, cardHrefTarget: cardHrefTarget, handleExecuteAction: handleExecuteAction } = (0, $64A2P.useComponentDefaultProps)('DataViewCardContainer', $38b7113580d9a1a1$export$d13f8a6d57c9f999, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const editElement = (0, $acw62.useRef)(null);
        const deleteElement = (0, $acw62.useRef)(null);
        const viewElement = (0, $acw62.useRef)(null);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
            bg: theme.colorScheme === 'dark' ? theme.colors.dark[9] : undefined,
            ...CardProps,
            children: [
                toggleSelectable && handleDeselectRecord && handleSelectRecord && /*#__PURE__*/ (0, $ayMG0.jsx)($4OeIO.Checkbox, {
                    size: "xs",
                    variant: "light",
                    mb: "xs",
                    checked: selected,
                    onClick: ()=>{
                        selected ? handleDeselectRecord(recordIndex) : handleSelectRecord(recordIndex);
                    }
                }, `chk-${entity.def.name}-${recordIndex}`),
                EntityCard && /*#__PURE__*/ (0, $ayMG0.jsx)(EntityCard, {
                    record: record,
                    recordIndex: recordIndex,
                    entity: entity,
                    enableDelete: enableDelete,
                    enableEdit: enableEdit,
                    enableView: enableView,
                    handleSelectRecord: handleSelectRecord,
                    handleDeselectRecord: handleDeselectRecord,
                    handleDeleteClick: handleDeleteClick,
                    handleEditClick: handleEditClick,
                    handleViewClick: handleViewClick,
                    handleCardClick: handleCardClick,
                    handleExecuteAction: handleExecuteAction,
                    selected: selected,
                    toggleSelectable: toggleSelectable,
                    refreshView: refreshView,
                    cardHrefRootURL: cardHrefRootURL,
                    cardHrefTarget: cardHrefTarget
                }, `card-${entity.def.name}-${recordIndex}`),
                (enableDelete || enableEdit || enableView) && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                    mt: "xs",
                    p: "xs",
                    withBorder: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        position: "right",
                        children: [
                            enableView && !enableEdit && handleViewClick && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                size: "xs",
                                ref: viewElement,
                                onClick: async ()=>await handleViewClick(record.keys, viewElement.current),
                                children: (0, $7n39P.DataViewDefaultProps).labels?.viewLabel
                            }),
                            enableEdit && handleEditClick && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                size: "xs",
                                ref: editElement,
                                onClick: async ()=>await handleEditClick(record.keys, editElement.current),
                                children: (0, $7n39P.DataViewDefaultProps).labels?.editLabel
                            }),
                            enableDelete && handleDeleteClick && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                size: "xs",
                                ref: deleteElement,
                                color: "red",
                                onClick: async ()=>await handleDeleteClick(record.keys, deleteElement.current),
                                children: (0, $7n39P.DataViewDefaultProps).labels?.deleteLabel
                            })
                        ]
                    })
                })
            ]
        }, `${entity.def.name}-${recordIndex}`);
    }
});
$305cacda61daafb0$var$parcelRegister("kBmms", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataViewPage", function() {
        return $a71700208c86f4e4$export$8c2d6ef29d88f39b;
    });
    var $7n39P = $305cacda61daafb0$var$parcelRequire("7n39P");
    function $a71700208c86f4e4$export$8c2d6ef29d88f39b(props) {
        const { client: client, entityConstructor: entityConstructor } = props;
        const entity = (0, $acw62.useRef)(entityConstructor(client));
        return /*#__PURE__*/ (0, $ayMG0.jsx)($7n39P.DataView, {
            entity: entity.current,
            ...props
        });
    }
});
$305cacda61daafb0$var$parcelRegister("gnnRW", function(module1, exports) {
    var $gKHfF = $305cacda61daafb0$var$parcelRequire("gKHfF");
    var $14cMx = $305cacda61daafb0$var$parcelRequire("14cMx");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $gKHfF);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $14cMx);
});
$305cacda61daafb0$var$parcelRegister("gKHfF", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AvatarUploader", function() {
        return $bf851542c46e0f0d$export$d90a5eec5b09d8ed;
    });
    function $bf851542c46e0f0d$export$d90a5eec5b09d8ed(props) {
        const theme = (0, $64A2P.useMantineTheme)();
        const { API: API, PlaceHolderIcon: PlaceHolderIcon, readOnlyMode: readOnlyMode, ...others } = props;
        const { imageURL: imageURL, fileID: fileID, fileGUID: fileGUID, handleOpenFileUpload: handleOpenFileUpload, handleDeleteFile: handleDeleteFile, parentFormAPI: parentFormAPI } = API;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($436KA.Avatar, {
                    ...others,
                    src: imageURL ?? undefined,
                    onClick: async ()=>{
                        if (!readOnlyMode && parentFormAPI?.formMode !== 'view') await handleOpenFileUpload();
                    },
                    children: PlaceHolderIcon
                }),
                !readOnlyMode && parentFormAPI?.formMode !== 'view' && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                            color: theme.primaryColor,
                            variant: "light",
                            onClick: async ()=>await handleOpenFileUpload(),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9Q2Ky.default, {
                                size: "1rem"
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                            color: theme.primaryColor,
                            variant: "light",
                            onClick: async ()=>await handleDeleteFile(fileID ?? '', fileGUID ?? ''),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($eyDPb.default, {
                                size: "1rem"
                            })
                        })
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("14cMx", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AvatarUploaderDefaultProps", function() {
        return $8cba51256aebea2d$export$9e8d6341d22c7058;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useAvatarUploader", function() {
        return $8cba51256aebea2d$export$a2bc9feb52ac7227;
    });
    $305cacda61daafb0$var$parcelRequire("6i1ou");
    var $3Utni = $305cacda61daafb0$var$parcelRequire("3Utni");
    var $4eryA = $305cacda61daafb0$var$parcelRequire("4eryA");
    const $8cba51256aebea2d$export$9e8d6341d22c7058 = {
        labels: {
            modalTitle: 'Upload Image'
        }
    };
    function $8cba51256aebea2d$export$a2bc9feb52ac7227(props) {
        const { client: client, fileProcessColumn: fileProcessColumn, labels: labels, initialImageURL: initialImageURL, parentFormAPI: parentFormAPI, fileGUIDColumn: fileGUIDColumn } = (0, $64A2P.useComponentDefaultProps)('AvatarUploader', $8cba51256aebea2d$export$9e8d6341d22c7058, props);
        const imageFileUploadOpen = (0, $3Utni.useFilesUploadForm)();
        const { deleteFile: deleteFile } = (0, $4eryA.useFileUpload)({
            client: client,
            fileProcessColumn: fileProcessColumn
        });
        const [imageURL, setImageURL] = (0, $acw62.useState)(initialImageURL);
        const [fileID, setFileID] = (0, $acw62.useState)(undefined);
        const [fileProcessID, setFileProcessID] = (0, $acw62.useState)(undefined);
        const [fileGUID, setFileGUID] = (0, $acw62.useState)(undefined);
        const handleOpenFileUpload = (0, $acw62.useCallback)(async ()=>{
            await imageFileUploadOpen({
                fileProcessColumn: fileProcessColumn,
                client: client,
                modalTitle: labels?.modalTitle,
                onOK: (fileprocess_id, uploadProgress)=>{
                    fileProcessColumn.value = fileprocess_id;
                    const keys = Object.keys(uploadProgress);
                    if (keys.length > 0 && uploadProgress[keys[0]].vc_fileguid) {
                        fileGUIDColumn.value = uploadProgress[keys[0]].vc_fileguid;
                        setFileGUID(fileGUIDColumn.value);
                        setImageURL(client.getDocumentURL(fileGUIDColumn.value));
                        setFileID(uploadProgress[keys[0]].file_id);
                        setFileProcessID(fileprocess_id);
                    } else {
                        // MMC: if no file was uploaded, clear the file column
                        fileGUIDColumn.value = '';
                        setFileGUID(undefined);
                        setImageURL(undefined);
                        setFileID(undefined);
                    }
                },
                modalProps: {
                    closeOnClickOutside: false,
                    closeOnEscape: false,
                    withCloseButton: false,
                    size: "lg"
                },
                uploaderProps: {
                    accept: [
                        "image/*"
                    ]
                },
                filesUploadFormProps: {
                    maxFilesCount: 1
                }
            });
        }, [
            client,
            fileGUIDColumn,
            fileProcessColumn,
            imageFileUploadOpen,
            labels?.modalTitle
        ]);
        const handleDeleteFile = async (file_id, fileGUID)=>{
            await deleteFile(file_id, fileGUID);
            fileGUIDColumn.value = '';
            fileProcessColumn.value = '';
            setFileID(undefined);
            setImageURL(undefined);
            setFileGUID(undefined);
        };
        // MMC: set the loaded URL when finishing the entity get
        (0, $acw62.useEffect)(()=>{
            if (parentFormAPI) {
                if (parentFormAPI.status.loading === false && parentFormAPI.status.operationType === 'get') {
                    if (fileProcessColumn.value) {
                        setFileProcessID(fileProcessColumn.value);
                        setImageURL(client.getDocumentURL(fileGUIDColumn.value));
                        setFileGUID(fileGUIDColumn.value);
                    }
                }
            }
        }, [
            client,
            parentFormAPI
        ]);
        return {
            imageURL: imageURL,
            fileID: fileID,
            fileProcessID: fileProcessID,
            fileGUID: fileGUID,
            handleOpenFileUpload: handleOpenFileUpload,
            handleDeleteFile: handleDeleteFile,
            parentFormAPI: parentFormAPI
        };
    }
});
$305cacda61daafb0$var$parcelRegister("kFsxs", function(module1, exports) {
    var $5RMgr = $305cacda61daafb0$var$parcelRequire("5RMgr");
    var $eH50b = $305cacda61daafb0$var$parcelRequire("eH50b");
    var $e8sJv = $305cacda61daafb0$var$parcelRequire("e8sJv");
    var $7laKR = $305cacda61daafb0$var$parcelRequire("7laKR");
    var $hPSwj = $305cacda61daafb0$var$parcelRequire("hPSwj");
    var $hHiqg = $305cacda61daafb0$var$parcelRequire("hHiqg");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5RMgr);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $eH50b);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $e8sJv);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7laKR);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hPSwj);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hHiqg);
});
$305cacda61daafb0$var$parcelRegister("5RMgr", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "Link", function() {
        return $404ec2751816fed2$export$a6c7ac8248d6e38a;
    });
    var $hPSwj = $305cacda61daafb0$var$parcelRequire("hPSwj");
    function $404ec2751816fed2$export$a6c7ac8248d6e38a(props) {
        const { navigate: navigate } = (0, $hPSwj.useMicroMRouter)();
        const { to: to, children: children } = props;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($f2S2u.Anchor, {
            href: to,
            onClick: (e)=>{
                e.preventDefault();
                navigate(to);
            },
            children: children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("eH50b", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicroMRouter", function() {
        return $86f292810bf32cea$export$c8dc77422c23e5dd;
    });
    var $hPSwj = $305cacda61daafb0$var$parcelRequire("hPSwj");
    var $hHiqg = $305cacda61daafb0$var$parcelRequire("hHiqg");
    function $86f292810bf32cea$export$c8dc77422c23e5dd(props) {
        const router = (0, $hHiqg.useNavigation)();
        const { children: children } = props;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($hPSwj.MicroMRouterContext.Provider, {
            value: router,
            children: children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("hHiqg", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useNavigation", function() {
        return $691dfdf81fca67bf$export$d0fd4b7106de2769;
    });
    // MMC: normalize the path to always start with '/#/', the recieved path can start with '/#/', with '/' or without any of them
    const $691dfdf81fca67bf$var$normalizePath = (path)=>{
        if (path.startsWith('#/')) return path.slice(1);
        return path;
    };
    function $691dfdf81fca67bf$export$d0fd4b7106de2769() {
        // Adjust initial path setup to check for '/#/' prefix
        const initialPath = window.location.hash.startsWith('#/') ? window.location.hash.slice(1) : '/';
        const [path, setPath] = (0, $acw62.useState)(initialPath);
        // Initialize navigated to false to indicate initial load
        const [navigationState, setNavigationState] = (0, $acw62.useState)({
            navigated: false,
            route: path
        });
        // Unified navigation handling
        const handleNavigation = (0, $acw62.useCallback)((newPath)=>{
            const formattedPath = $691dfdf81fca67bf$var$normalizePath(newPath);
            if (formattedPath !== path) {
                setPath(formattedPath);
                setNavigationState({
                    navigated: true,
                    route: formattedPath
                });
            }
        }, [
            path
        ]);
        (0, $acw62.useEffect)(()=>{
            // Update path and navigationState based on direct hash changes
            const handleHashChange = ()=>{
                const newPath = window.location.hash.slice(1);
                handleNavigation(newPath);
            };
            window.addEventListener('hashchange', handleHashChange);
            return ()=>window.removeEventListener('hashchange', handleHashChange);
        }, [
            handleNavigation
        ]);
        const navigate = (0, $acw62.useCallback)((newPath)=>{
            // Values set up here will include the #. If newpath has no / it will be added (.hash works like that)
            window.location.hash = $691dfdf81fca67bf$var$normalizePath(newPath);
        }, []);
        return {
            path: path,
            navigate: navigate,
            navigationState: navigationState
        };
    }
});
$305cacda61daafb0$var$parcelRegister("e8sJv", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("7laKR", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "Route", function() {
        return $4e3765b7678ddbfb$export$e7b0ac011bb776c6;
    });
    var $hPSwj = $305cacda61daafb0$var$parcelRequire("hPSwj");
    function $4e3765b7678ddbfb$export$e7b0ac011bb776c6(props) {
        const { path: currentPath } = (0, $hPSwj.useMicroMRouter)();
        const { path: path, children: children } = props;
        return currentPath === path ? /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: children
        }) : null;
    }
});
$305cacda61daafb0$var$parcelRegister("fP7wi", function(module1, exports) {
    var $fwOUq = $305cacda61daafb0$var$parcelRequire("fwOUq");
    var $if1g8 = $305cacda61daafb0$var$parcelRequire("if1g8");
    var $lRkkN = $305cacda61daafb0$var$parcelRequire("lRkkN");
    var $fSX48 = $305cacda61daafb0$var$parcelRequire("fSX48");
    var $ihm2f = $305cacda61daafb0$var$parcelRequire("ihm2f");
    var $lIzIs = $305cacda61daafb0$var$parcelRequire("lIzIs");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fwOUq);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $if1g8);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lRkkN);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fSX48);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ihm2f);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lIzIs);
});
$305cacda61daafb0$var$parcelRegister("fwOUq", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressAutocomplete", function() {
        return $9155424f44c113de$export$6c178f1eacc8aa12;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    $305cacda61daafb0$var$parcelRequire("jtOZC");
    var $gNp1h = $305cacda61daafb0$var$parcelRequire("gNp1h");
    function $9155424f44c113de$export$6c178f1eacc8aa12(props) {
        //const { } = useComponentDefaultProps('AddressAutocomplete', {}, props);
        const { column: column, entityForm: entityForm, validate: validate, requiredMessage: requiredMessage, validationContainer: validationContainer, countries: countries, required: required, readOnly: readOnly, onAddressFound: onAddressFound, withAsterisk: withAsterisk, label: label, placeholder: placeholder, description: description, maxLength: maxLength, autoFocus: autoFocus, ...rest } = props;
        const { status: status, form: form } = entityForm;
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const [showDescription] = entityForm.showDescriptionState;
        const restrictions = {
            country: countries
        };
        const handleOnAddressFound = (0, $acw62.useCallback)((result)=>{
            form.setFieldValue(column.name, result.suggestionDescription || result?.place.formatted_address || '');
            if (onAddressFound) {
                const found = {
                    address: result.address,
                    position: result.position,
                    utcOffsetMinutes: result.place.utc_offset_minutes,
                    formattedAddress: result.suggestionDescription || result.place.formatted_address
                };
                onAddressFound(found);
            }
        }, [
            column.name,
            form,
            onAddressFound
        ]);
        (0, $acw62.useEffect)(()=>{
            form.setFieldValue(column.name, column.value || '');
        }, []);
        //useEffect(() => {
        //    if (!status.loading && status.operationType === 'get') {
        //        form.setFieldValue(column.name, column.value);
        //    }
        //}, [status.loading, status.operationType]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($gNp1h.GoogleAddressAutocomplete, {
            ...rest,
            restrictions: restrictions,
            onAddressFound: handleOnAddressFound,
            withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            label: label ?? column.prompt,
            placeholder: placeholder ?? column.placeholder,
            description: showDescription ? description ?? column.description : '',
            maxLength: maxLength ?? column.length,
            readOnly: entityForm.formMode === 'view' ? true : readOnly,
            autoFocus: autoFocus,
            "data-autofocus": autoFocus,
            ...entityForm.form.getInputProps(column.name)
        });
    }
});
$305cacda61daafb0$var$parcelRegister("jtOZC", function(module1, exports) {
    var $gNp1h = $305cacda61daafb0$var$parcelRequire("gNp1h");
    var $bwtho = $305cacda61daafb0$var$parcelRequire("bwtho");
    var $f1AFh = $305cacda61daafb0$var$parcelRequire("f1AFh");
    var $2u0zQ = $305cacda61daafb0$var$parcelRequire("2u0zQ");
    var $9WZwH = $305cacda61daafb0$var$parcelRequire("9WZwH");
    var $2FrzH = $305cacda61daafb0$var$parcelRequire("2FrzH");
    var $jQiQb = $305cacda61daafb0$var$parcelRequire("jQiQb");
    var $b6Qua = $305cacda61daafb0$var$parcelRequire("b6Qua");
    var $eooHg = $305cacda61daafb0$var$parcelRequire("eooHg");
    var $cBazH = $305cacda61daafb0$var$parcelRequire("cBazH");
    var $4Z5zv = $305cacda61daafb0$var$parcelRequire("4Z5zv");
    var $jsiDH = $305cacda61daafb0$var$parcelRequire("jsiDH");
    var $9UpIY = $305cacda61daafb0$var$parcelRequire("9UpIY");
    var $bwuk4 = $305cacda61daafb0$var$parcelRequire("bwuk4");
    var $9oW8i = $305cacda61daafb0$var$parcelRequire("9oW8i");
    var $32aKS = $305cacda61daafb0$var$parcelRequire("32aKS");
    var $hejF0 = $305cacda61daafb0$var$parcelRequire("hejF0");
    var $ciKLf = $305cacda61daafb0$var$parcelRequire("ciKLf");
    var $3qg63 = $305cacda61daafb0$var$parcelRequire("3qg63");
    var $bjRVa = $305cacda61daafb0$var$parcelRequire("bjRVa");
    var $81q9V = $305cacda61daafb0$var$parcelRequire("81q9V");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $gNp1h);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bwtho);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $f1AFh);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2u0zQ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9WZwH);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2FrzH);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jQiQb);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $b6Qua);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $eooHg);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cBazH);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $4Z5zv);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jsiDH);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9UpIY);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bwuk4);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9oW8i);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $32aKS);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hejF0);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ciKLf);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $3qg63);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bjRVa);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $81q9V);
});
$305cacda61daafb0$var$parcelRegister("gNp1h", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DefaultGoogleAddressAutocompleteProps", function() {
        return $feaefb692895afee$export$73e50970d97b700a;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleAddressAutocomplete", function() {
        return $feaefb692895afee$export$76c7fad35fa88498;
    });
    var $9WZwH = $305cacda61daafb0$var$parcelRequire("9WZwH");
    const $feaefb692895afee$export$73e50970d97b700a = {
        label: "Address:",
        placeholder: "Start typing an address to see suggestions",
        mappingRules: []
    };
    function $feaefb692895afee$export$76c7fad35fa88498(props) {
        props = (0, $64A2P.useComponentDefaultProps)('GoogleAddressAutocomplete', $feaefb692895afee$export$73e50970d97b700a, props);
        const { onAddressFound: onAddressFound, restrictions: restrictions, onChange: onChange, value: value, onAPIError: onAPIError, mappingRules: mappingRules, iconColor: iconColor, ...rest } = props;
        const googleAddressAutocompleteAPI = (0, $9WZwH.useGoogleAddressAutocomplete)({
            onAddressFound: onAddressFound,
            restrictions: restrictions,
            onChange: onChange,
            value: value,
            onAPIError: onAPIError,
            mappingRules: mappingRules,
            iconColor: iconColor
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($hiiR1.Box, {
                pos: "relative",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($bFLPF.Autocomplete, {
                        ...rest,
                        ref: googleAddressAutocompleteAPI.userInputRef,
                        onChange: googleAddressAutocompleteAPI.handleOnUserInputChange,
                        onItemSubmit: googleAddressAutocompleteAPI.handleOnItemSubmit,
                        itemComponent: $feaefb692895afee$var$AddressSuggestionItem,
                        data: googleAddressAutocompleteAPI.suggestions,
                        disabled: googleAddressAutocompleteAPI.isLoading,
                        value: googleAddressAutocompleteAPI.value,
                        // MMC: show all google prediction results
                        filter: ()=>true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        ref: googleAddressAutocompleteAPI.attributionsRef
                    })
                ]
            })
        });
    }
    const $feaefb692895afee$var$AddressSuggestionItem = /*#__PURE__*/ (0, $acw62.forwardRef)(function AddressSuggestionItem({ structuredFormatting: structuredFormatting, icon: icon, ...rest }, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ref: ref,
            ...rest,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                noWrap: true,
                children: [
                    icon,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                children: structuredFormatting.main_text
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                size: "xs",
                                color: "dimmed",
                                children: structuredFormatting.secondary_text
                            })
                        ]
                    })
                ]
            })
        });
    });
});
$305cacda61daafb0$var$parcelRegister("9WZwH", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleAddressAutocomplete", function() {
        return $91f6267fc243aa1a$export$bec899c3c0ce43ba;
    });
    var $8ahcP = $305cacda61daafb0$var$parcelRequire("8ahcP");
    var $eooHg = $305cacda61daafb0$var$parcelRequire("eooHg");
    function $91f6267fc243aa1a$export$bec899c3c0ce43ba({ onAddressFound: onAddressFound, restrictions: restrictions, onChange: onChange, value: value, onAPIError: onAPIError, mappingRules: mappingRules, iconColor: iconColor }) {
        const userInputRef = (0, $acw62.useRef)(null);
        const lastPlaceIdRef = (0, $acw62.useRef)('');
        const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
        const [suggestions, setSuggestions] = (0, $acw62.useState)([]);
        const [query, setQuery] = (0, $1YFpC.useDebouncedState)('', 700, {
            leading: true
        });
        const [inputValue, setInputValue] = (0, $acw62.useState)();
        const [apiError, setApiError] = (0, $acw62.useState)();
        const { refreshSessionToken: refreshSessionToken, getAutocompletePredictions: getAutocompletePredictions, getAutocompleteDetails: getAutocompleteDetails, attributionsRef: attributionsRef } = (0, $8ahcP.useGoogleMapsAPI)();
        const { mapGoogleAddressComponents: mapGoogleAddressComponents } = (0, $eooHg.useGoogleAddressMapping)();
        const theme = (0, $64A2P.useMantineTheme)();
        const icon = (0, $acw62.useMemo)(()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: theme.colors[iconColor || theme.primaryColor][theme.fn.primaryShade(theme.colorScheme)],
                className: "icon icon-tabler icons-tabler-filled icon-tabler-map-pin",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        stroke: "none",
                        d: "M0 0h24v24H0z",
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                        d: "M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z"
                    })
                ]
            }), [
            iconColor,
            theme.colorScheme,
            theme.colors,
            theme.fn,
            theme.primaryColor
        ]);
        //workaround for firing an event from the effect
        const onChangeRef = (0, $acw62.useRef)(onChange);
        onChangeRef.current = onChange;
        function handleOnUserInputChange(value) {
            setQuery(value);
            setInputValue(value);
        }
        const mapPlaceToAddress = (0, $acw62.useCallback)((found)=>{
            return found.address_components ? mapGoogleAddressComponents(found.address_components, mappingRules) : {};
        }, [
            mapGoogleAddressComponents,
            mappingRules
        ]);
        const handleItemSelected = (0, $acw62.useCallback)((item)=>{
            if (lastPlaceIdRef.current === item.place_id) return;
            lastPlaceIdRef.current = "";
            setIsLoading(true);
            getAutocompleteDetails({
                placeId: item.place_id,
                fields: [
                    "address_components",
                    "formatted_address",
                    "geometry.location",
                    "utc_offset_minutes"
                ],
                callback: (place, status)=>{
                    lastPlaceIdRef.current = item.place_id;
                    setIsLoading(false);
                    setSuggestions([]); //to not show the list every time it receives focus
                    if (status === google.maps.places.PlacesServiceStatus.OK && place) {
                        if (onAddressFound) onAddressFound({
                            place: place,
                            address: mapPlaceToAddress(place),
                            suggestionDescription: item.value,
                            position: place.geometry?.location ? {
                                lat: place.geometry.location.lat(),
                                lng: place.geometry.location.lng()
                            } : undefined
                        });
                    } else {
                        refreshSessionToken();
                        setApiError(status);
                        if (onAPIError) onAPIError(status);
                    }
                }
            });
        }, [
            getAutocompleteDetails,
            mapPlaceToAddress,
            onAPIError,
            onAddressFound,
            refreshSessionToken
        ]);
        const handleOnItemSubmit = (0, $acw62.useCallback)((item)=>{
            handleItemSelected(item);
        }, [
            handleItemSelected
        ]);
        // MMC: Query if there is an initla value
        (0, $acw62.useEffect)(()=>{
            if (value) setQuery(value);
        }, []);
        //this makes the effect depends of debounce if not causes race conditions where sometimes the predictions are not updated when the user enters characters
        (0, $acw62.useEffect)(()=>{
            if (onChangeRef.current) onChangeRef.current(query);
        }, [
            query
        ]);
        // MMC: update inputValue when value changes (sync)
        (0, $acw62.useEffect)(()=>{
            setInputValue(value || '');
        }, [
            value
        ]);
        //TODO: Loading?
        (0, $acw62.useEffect)(()=>{
            if (!query) return;
            if (!query) {
                setSuggestions([]);
                return;
            }
            getAutocompletePredictions({
                searchText: query,
                restrictions: restrictions,
                callback: (predictions, status)=>{
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        if (predictions?.length) setSuggestions(predictions.map((p)=>({
                                place_id: p.place_id,
                                structuredFormatting: p.structured_formatting,
                                value: p.description,
                                icon: icon
                            })));
                    } else if (status !== google.maps.places.PlacesServiceStatus.NOT_FOUND && status !== google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                        setApiError(status);
                        if (onAPIError) onAPIError(status);
                    }
                }
            });
        }, [
            getAutocompletePredictions,
            onAPIError,
            query,
            restrictions,
            icon
        ]);
        return {
            userInputRef: userInputRef,
            attributionsRef: attributionsRef,
            isLoading: isLoading,
            handleOnUserInputChange: handleOnUserInputChange,
            handleOnItemSubmit: handleOnItemSubmit,
            suggestions: suggestions,
            value: inputValue,
            apiError: apiError
        };
    }
});
$305cacda61daafb0$var$parcelRegister("8ahcP", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleMapsAPI", function() {
        return $261462c7bce1f9d5$export$d20ca82b928f17cf;
    });
    var $dC5GO = $305cacda61daafb0$var$parcelRequire("dC5GO");
    function $261462c7bce1f9d5$export$d20ca82b928f17cf() {
        const [mapReady] = (0, $dC5GO.useGoogleMapsAPILoader)();
        const [placesReady] = (0, $dC5GO.useGooglePlacesAPIloader)();
        const [geocoderReady] = (0, $dC5GO.useGoogleGeocoderAPIloader)();
        const [geometryReady] = (0, $dC5GO.useGoogleGeometryAPILoader)();
        const placesServiceRef = (0, $acw62.useRef)();
        const autocompleteServiceRef = (0, $acw62.useRef)();
        const geocoderServiceRef = (0, $acw62.useRef)();
        const sessionTokenRef = (0, $acw62.useRef)();
        const attributionsRef = (0, $acw62.useRef)(null);
        const refreshSessionToken = (0, $acw62.useCallback)(()=>{
            sessionTokenRef.current = new google.maps.places.AutocompleteSessionToken();
        }, []);
        (0, $acw62.useEffect)(()=>{
            if (!mapReady || !placesReady || !geocoderReady || !geometryReady) return;
            if (!autocompleteServiceRef.current) {
                autocompleteServiceRef.current = new google.maps.places.AutocompleteService();
                refreshSessionToken();
            }
            if (!placesServiceRef.current && attributionsRef.current) placesServiceRef.current = new google.maps.places.PlacesService(attributionsRef.current);
            if (!geocoderServiceRef.current) geocoderServiceRef.current = new google.maps.Geocoder();
        }, [
            geocoderReady,
            geometryReady,
            mapReady,
            placesReady,
            refreshSessionToken
        ]);
        const getAutocompletePredictions = (0, $acw62.useCallback)((props)=>{
            autocompleteServiceRef.current.getPlacePredictions({
                input: props.searchText,
                componentRestrictions: props.restrictions,
                // MMC: we return all types of PLACES that google considers, this is not the type of returned parts for a place.
                //types: ["address"],
                sessionToken: sessionTokenRef.current
            }, props.callback);
        }, []);
        const getAutocompleteDetails = (0, $acw62.useCallback)((props)=>{
            const request = {
                placeId: props.placeId,
                fields: props.fields,
                sessionToken: sessionTokenRef.current
            };
            placesServiceRef.current.getDetails(request, props.callback);
        }, []);
        const geocode = (0, $acw62.useCallback)((request, callback)=>{
            geocoderServiceRef.current.geocode(request, callback);
        }, []);
        const getPlaceDetails = (0, $acw62.useCallback)(async (props)=>{
            return new Promise((resolve, reject)=>{
                const service = placesServiceRef.current;
                if (!service) {
                    reject(new Error("Places service not ready"));
                    return;
                }
                const request = {
                    placeId: props.placeId,
                    fields: props.fields,
                    sessionToken: sessionTokenRef.current
                };
                service.getDetails(request, (place, status)=>{
                    if (status === google.maps.places.PlacesServiceStatus.OK && place) resolve(place);
                    else reject(new Error(`Error: ${status}`));
                });
            });
        }, []);
        return {
            mapReady: mapReady,
            placesReady: placesReady,
            geocoderReady: geocoderReady,
            getAutocompletePredictions: getAutocompletePredictions,
            getAutocompleteDetails: getAutocompleteDetails,
            geocode: geocode,
            attributionsRef: attributionsRef,
            refreshSessionToken: refreshSessionToken,
            geometryReady: geometryReady,
            getPlaceDetails: getPlaceDetails
        };
    }
});
$305cacda61daafb0$var$parcelRegister("dC5GO", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapsAPILoaderConfig", function() {
        return $6a5c492990269e6c$export$bcdd733a405fc475;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GetGoogleMapsAPILoader", function() {
        return $6a5c492990269e6c$export$a20fe18abb596293;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGooglePlacesAPIloader", function() {
        return $6a5c492990269e6c$export$26cc5a3beaaaa5da;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleGeocoderAPIloader", function() {
        return $6a5c492990269e6c$export$cd69e35cf7990515;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleMapsAPILoader", function() {
        return $6a5c492990269e6c$export$d8fc13929aa3839f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleGeometryAPILoader", function() {
        return $6a5c492990269e6c$export$82e435f07812b3fb;
    });
    const $6a5c492990269e6c$export$bcdd733a405fc475 = {
        apiKey: ""
    };
    let $6a5c492990269e6c$var$googleAPILoaderInstance;
    function $6a5c492990269e6c$export$a20fe18abb596293() {
        return $6a5c492990269e6c$var$googleAPILoaderInstance ?? ($6a5c492990269e6c$var$googleAPILoaderInstance = new $93PFP.Loader($6a5c492990269e6c$export$bcdd733a405fc475));
    }
    function $6a5c492990269e6c$export$26cc5a3beaaaa5da() {
        const [isReady, setIsReady] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            if (!window.google?.maps.places) $6a5c492990269e6c$export$a20fe18abb596293().importLibrary("places").then(_callback);
            else _callback();
        }, []);
        function _callback() {
            setIsReady(true);
        }
        return [
            isReady
        ];
    }
    function $6a5c492990269e6c$export$cd69e35cf7990515() {
        const [isReady, setIsReady] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            if (!window.google?.maps.Geocoder) $6a5c492990269e6c$export$a20fe18abb596293().importLibrary("geocoding").then(_callback);
            else _callback();
        }, []);
        function _callback() {
            setIsReady(true);
        }
        return [
            isReady
        ];
    }
    function $6a5c492990269e6c$export$d8fc13929aa3839f() {
        const [isReady, setIsReady] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            if (!window.google?.maps.Map) $6a5c492990269e6c$export$a20fe18abb596293().importLibrary("maps").then(_callback);
            else _callback();
        }, []);
        function _callback() {
            setIsReady(true);
        }
        return [
            isReady
        ];
    }
    function $6a5c492990269e6c$export$82e435f07812b3fb() {
        const [isReady, setIsReady] = (0, $acw62.useState)(false);
        (0, $acw62.useEffect)(()=>{
            if (!window.google?.maps.Map) $6a5c492990269e6c$export$a20fe18abb596293().importLibrary("geometry").then(_callback);
            else _callback();
        }, []);
        function _callback() {
            setIsReady(true);
        }
        return [
            isReady
        ];
    }
});
$305cacda61daafb0$var$parcelRegister("eooHg", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleAddressMapping", function() {
        return $689623d2d61c6227$export$114f2f817a4f75ef;
    });
    var $b6Qua = $305cacda61daafb0$var$parcelRequire("b6Qua");
    function $689623d2d61c6227$var$convertAddressComponentsToAddressComponentResult(addressComponents) {
        const result = {};
        for(let i = 0; i < addressComponents.length; i++){
            const component = addressComponents[i];
            // MMC: we only take the first type of the component as is the last level of the hierearchy
            const type = component.types[0];
            if (!result[type]) result[type] = {
                long_name: component.long_name,
                short_name: component.short_name
            };
        }
        return result;
    }
    function $689623d2d61c6227$var$doesRuleMatch(conditions, addressComponentResult) {
        return Object.entries(conditions).every(([key, value])=>{
            const tkey = key;
            return addressComponentResult[tkey]?.long_name === value.long_name || addressComponentResult[tkey]?.short_name === value.short_name;
        });
    }
    function $689623d2d61c6227$var$applyRuleMappings(target, source, ruleMappings) {
        for (const [mappedKey, mappings] of Object.entries(ruleMappings)){
            for (const mapping of mappings)for (const [sourceKey, valueKey] of Object.entries(mapping)){
                const skey = sourceKey;
                if (source[skey]) {
                    target[mappedKey] = source[skey][valueKey];
                    break; // Apply the first mapping found for this key
                }
            }
        }
    }
    function $689623d2d61c6227$var$applyDefaultMappings(target, source, defaultMappings) {
        for (const [targetKey, mappings] of Object.entries(defaultMappings)){
            const tkey = targetKey;
            // If the key has already been set by a specific rule, skip applying the default mapping
            if (target[tkey] !== undefined) continue;
            for (const mapping of mappings)for (const [sourceKey, valueKey] of Object.entries(mapping)){
                const skey = sourceKey;
                if (source[skey]) {
                    target[targetKey] = source[skey][valueKey];
                    break; // Apply the first default mapping found for this key
                }
            }
        }
    }
    function $689623d2d61c6227$var$mapAddressComponentResultToMappedAddress(addressComponentResult, rules) {
        const mappedAddress = {};
        // Determine the mapped address type
        if (addressComponentResult.street_number || addressComponentResult.route) mappedAddress.mappedAddressType = 'address';
        else if (addressComponentResult.postal_code) mappedAddress.mappedAddressType = 'postal_code';
        else if (addressComponentResult.administrative_area_level_2) mappedAddress.mappedAddressType = 'county';
        else if (addressComponentResult.locality) mappedAddress.mappedAddressType = 'city';
        else if (addressComponentResult.administrative_area_level_1) mappedAddress.mappedAddressType = 'state_province';
        else if (addressComponentResult.country) mappedAddress.mappedAddressType = 'country';
        else mappedAddress.mappedAddressType = 'unknown';
        if (!rules) return mappedAddress;
        // Check each rule to find the first that matches the conditions
        let apply_default_mappings = true;
        for (const rule of rules)if ($689623d2d61c6227$var$doesRuleMatch(rule.conditions, addressComponentResult)) {
            if (rule.dontApplyDefaultMappings) apply_default_mappings = false;
            // Apply specific rule mappings
            $689623d2d61c6227$var$applyRuleMappings(mappedAddress, addressComponentResult, rule.mapping);
            break;
        }
        // Apply default mappings for any keys not set by the specific rule
        if (apply_default_mappings) $689623d2d61c6227$var$applyDefaultMappings(mappedAddress, addressComponentResult, $b6Qua.DefaultAddressMapping);
        return mappedAddress;
    }
    function $689623d2d61c6227$export$114f2f817a4f75ef() {
        const mapGoogleAddressComponents = (0, $acw62.useCallback)((addressComponents, mappingRules)=>{
            const addressComponentResult = $689623d2d61c6227$var$convertAddressComponentsToAddressComponentResult(addressComponents);
            return $689623d2d61c6227$var$mapAddressComponentResultToMappedAddress(addressComponentResult, mappingRules);
        }, []);
        return {
            mapGoogleAddressComponents: mapGoogleAddressComponents
        };
    }
});
$305cacda61daafb0$var$parcelRegister("b6Qua", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DefaultAddressMapping", function() {
        return $7b04f71cca021754$export$bbccd1dc75c6dacc;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ARMappingRules", function() {
        return $7b04f71cca021754$export$1f730b3b9c9a4c0;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UYMappingRules", function() {
        return $7b04f71cca021754$export$166767871078d915;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "USMappingRules", function() {
        return $7b04f71cca021754$export$4dcd2b3470d1acef;
    });
    const $7b04f71cca021754$export$bbccd1dc75c6dacc = {
        country: [
            {
                country: 'long_name'
            }
        ],
        countryCode: [
            {
                country: 'short_name'
            }
        ],
        province: [
            {
                administrative_area_level_1: 'long_name'
            }
        ],
        provinceCode: [
            {
                administrative_area_level_1: 'short_name'
            }
        ],
        department: [
            {
                locality: 'long_name'
            }
        ],
        departmentCode: [
            {
                locality: 'short_name'
            }
        ],
        city: [
            {
                administrative_area_level_2: 'long_name'
            }
        ],
        cityCode: [
            {
                administrative_area_level_2: 'short_name'
            }
        ],
        street: [
            {
                route: 'long_name'
            }
        ],
        streetNumber: [
            {
                street_number: 'long_name'
            }
        ],
        apartment: [
            {
                room: 'long_name'
            }
        ],
        floor: [
            {
                floor: 'long_name'
            }
        ],
        postalCode: [
            {
                postal_code: 'long_name'
            }
        ]
    };
    const $7b04f71cca021754$export$1f730b3b9c9a4c0 = {
        conditions: {
            country: {
                short_name: 'AR'
            },
            locality: {
                short_name: 'CABA'
            }
        },
        mapping: {
            city: [
                {
                    administrative_area_level_1: 'long_name'
                }
            ],
            cityCode: [
                {
                    administrative_area_level_1: 'short_name'
                }
            ],
            department: [
                {
                    sublocality_level_1: 'long_name'
                }
            ],
            departmentCode: [
                {
                    sublocality_level_1: 'short_name'
                }
            ]
        }
    };
    const $7b04f71cca021754$export$166767871078d915 = {
        conditions: {
            country: {
                short_name: 'UY'
            }
        },
        mapping: {
            city: [
                {
                    locality: 'long_name'
                }
            ],
            cityCode: [
                {
                    locality: 'short_name'
                }
            ],
            department: [
                {
                    neighborhood: 'long_name',
                    locality: 'long_name'
                }
            ],
            departmentCode: [
                {
                    neighborhood: 'short_name',
                    locality: 'short_name'
                }
            ]
        }
    };
    const $7b04f71cca021754$export$4dcd2b3470d1acef = {
        conditions: {
            country: {
                short_name: 'US'
            }
        },
        dontApplyDefaultMappings: true,
        mapping: {
            country: [
                {
                    country: 'long_name'
                }
            ],
            countryCode: [
                {
                    country: 'short_name'
                }
            ],
            province: [
                {
                    administrative_area_level_1: 'long_name'
                }
            ],
            provinceCode: [
                {
                    administrative_area_level_1: 'short_name'
                }
            ],
            // county
            department: [
                {
                    administrative_area_level_2: 'long_name'
                }
            ],
            departmentCode: [
                {
                    administrative_area_level_2: 'short_name'
                }
            ],
            city: [
                {
                    locality: 'long_name'
                }
            ],
            cityCode: [
                {
                    locality: 'short_name'
                }
            ],
            street: [
                {
                    route: 'long_name'
                }
            ],
            streetNumber: [
                {
                    street_number: 'long_name'
                }
            ],
            apartment: [
                {
                    subpremise: 'long_name'
                }
            ],
            floor: [
                {
                    floor: 'long_name'
                }
            ],
            postalCode: [
                {
                    postal_code: 'long_name'
                }
            ]
        }
    };
});
$305cacda61daafb0$var$parcelRegister("bwtho", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DefaultMapProps", function() {
        return $4e2ef1d6e2267a13$export$9ddc053667616b7;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMap", function() {
        return $4e2ef1d6e2267a13$export$4ad1bae46276c5ce;
    });
    var $2u0zQ = $305cacda61daafb0$var$parcelRequire("2u0zQ");
    var $2FrzH = $305cacda61daafb0$var$parcelRequire("2FrzH");
    const $4e2ef1d6e2267a13$export$9ddc053667616b7 = {};
    function $4e2ef1d6e2267a13$export$4ad1bae46276c5ce(props) {
        props = (0, $64A2P.useComponentDefaultProps)('GoogleMap', $4e2ef1d6e2267a13$export$9ddc053667616b7, props);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { mapOptions: mapOptions, children: children, infoWindowContentRef: infoWindowContentRef, setInfoWindowContent: setInfoWindowContent, ...rest } = props;
        const { containerRef: containerRef, mapContext: mapContext } = (0, $2u0zQ.useCreateGoogleMap)(props);
        const { renderMarkers: renderMarkers } = mapContext;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9Zs0z.Paper, {
                style: {
                    borderRadius: "unset"
                },
                ref: containerRef,
                ...rest,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2FrzH.GoogleMapContext.Provider, {
                    value: mapContext,
                    children: renderMarkers()
                })
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("2u0zQ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useCreateGoogleMap", function() {
        return $b737d4021abcf81e$export$bdaabecc63f2fdb2;
    });
    var $32aKS = $305cacda61daafb0$var$parcelRequire("32aKS");
    var $f1AFh = $305cacda61daafb0$var$parcelRequire("f1AFh");
    function $b737d4021abcf81e$export$bdaabecc63f2fdb2({ mapOptions: mapOptions, children: children, setInfoWindowContent: setInfoWindowContent, infoWindowContentRef: infoWindowContentRef }) {
        const containerRef = (0, $acw62.useRef)(null);
        const [map, setMap] = (0, $acw62.useState)(null);
        const infoWindowRef = (0, $acw62.useRef)(new google.maps.InfoWindow());
        (0, $acw62.useEffect)(()=>{
            if (map === null) {
                if (!containerRef.current) throw new Error("Container required.");
                if (mapOptions && mapOptions.center && (!mapOptions.center.lat || !mapOptions.center.lng)) mapOptions.center = undefined;
                const initMap = new google.maps.Map(containerRef.current, mapOptions);
                setMap(initMap);
            }
        }, [
            map,
            mapOptions
        ]);
        (0, $acw62.useEffect)(()=>{
            if (mapOptions && mapOptions.center && (!mapOptions.center.lat || !mapOptions.center.lng)) mapOptions.center = undefined;
            if (map) map.setOptions(mapOptions);
        }, [
            map,
            mapOptions
        ]);
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (map !== null) {
                    google.maps.event.clearInstanceListeners(map);
                    map.unbindAll();
                }
            };
        }, [
            map
        ]);
        const renderMarkers = (0, $acw62.useCallback)(()=>{
            if (map === null) return null;
            (0, $acw62.Children).forEach(children, (child)=>{
                if (!/*#__PURE__*/ (0, $acw62.isValidElement)(child) || child.type !== $f1AFh.GoogleMarker && child.type !== $32aKS.GoogleMapRegionSelector) throw new Error("Invalid children component.");
            });
            return children;
        }, [
            children,
            map
        ]);
        const mapContext = (0, $acw62.useMemo)(()=>({
                map: map,
                renderMarkers: renderMarkers,
                infoWindowRef: infoWindowRef,
                infoWindowContentRef: infoWindowContentRef,
                setInfoWindowContent: setInfoWindowContent
            }), [
            infoWindowContentRef,
            map,
            renderMarkers,
            setInfoWindowContent
        ]);
        const returnObject = (0, $acw62.useMemo)(()=>({
                containerRef: containerRef,
                mapContext: mapContext
            }), [
            containerRef,
            mapContext
        ]);
        return returnObject;
    }
});
$305cacda61daafb0$var$parcelRegister("32aKS", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapRegionSelector", function() {
        return $9b796ab06bc2ea5b$export$824323cb9a0f8c5d;
    });
    var $3qg63 = $305cacda61daafb0$var$parcelRequire("3qg63");
    var $ciKLf = $305cacda61daafb0$var$parcelRequire("ciKLf");
    function $9b796ab06bc2ea5b$export$824323cb9a0f8c5d(props) {
        const mergedProps = (0, $64A2P.useComponentDefaultProps)("GoogleMapRegionSelector", $3qg63.GoogleMapRegionSelectorDefaultProps, props);
        (0, $ciKLf.useGoogleMapRegionSelector)(mergedProps);
        return null; // Not a visual React component
    }
});
$305cacda61daafb0$var$parcelRegister("3qg63", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapRegionSelectorDefaultProps", function() {
        return $a9c053d8e7f99c36$export$c72ae71393d7fa2e;
    });
    var $bjRVa = $305cacda61daafb0$var$parcelRequire("bjRVa");
    const $a9c053d8e7f99c36$export$c72ae71393d7fa2e = {
        featureTypeMap: {
            // We use string constants here because we are using the Google Maps API and it will not be available until loaded
            low: {
                featureType: "ADMINISTRATIVE_AREA_LEVEL_1",
                zoom: 6,
                styles: $bjRVa.GoogleMapLowZoomStyleDefaultProps,
                zoomLevel: 'low'
            },
            medium: {
                featureType: "ADMINISTRATIVE_AREA_LEVEL_2",
                zoom: 8,
                styles: $bjRVa.GoogleMapMediumZoomStyleDefaultProps,
                zoomLevel: 'medium'
            },
            high: {
                featureType: "POSTAL_CODE",
                zoom: 11,
                styles: $bjRVa.GoogleMapHighZoomStyleDefaultProps,
                zoomLevel: 'high'
            }
        }
    };
});
$305cacda61daafb0$var$parcelRegister("bjRVa", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapLowZoomStyleDefaultProps", function() {
        return $a886ef3ed4350fc1$export$170025c0c689122c;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapMediumZoomStyleDefaultProps", function() {
        return $a886ef3ed4350fc1$export$2f62f1246f1509fe;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapHighZoomStyleDefaultProps", function() {
        return $a886ef3ed4350fc1$export$db9e2781cae98c53;
    });
    const $a886ef3ed4350fc1$export$170025c0c689122c = {
        styleDefault: {
            strokeColor: "#73383e",
            strokeOpacity: 0.1,
            strokeWeight: 2.0,
            fillColor: "white",
            fillOpacity: 0.1
        },
        styleClicked: {
            strokeColor: "#73383e",
            strokeOpacity: 1.0,
            strokeWeight: 4.0,
            fillColor: "#73383e",
            fillOpacity: 0.5
        },
        styleMouseMove: {
            strokeColor: "#73383e",
            strokeOpacity: 1.0,
            strokeWeight: 4.0,
            fillColor: "white",
            fillOpacity: 0.1
        }
    };
    const $a886ef3ed4350fc1$export$2f62f1246f1509fe = {
        styleDefault: {
            strokeColor: "#5d503f",
            strokeOpacity: 0.1,
            strokeWeight: 2.0,
            fillColor: "white",
            fillOpacity: 0.1
        },
        styleClicked: {
            strokeColor: "#5d503f",
            strokeOpacity: 1.0,
            strokeWeight: 4.0,
            fillColor: "#5d503f",
            fillOpacity: 0.5
        },
        styleMouseMove: {
            strokeColor: "#5d503f",
            strokeOpacity: 1.0,
            strokeWeight: 4.0,
            fillColor: "white",
            fillOpacity: 0.1
        }
    };
    const $a886ef3ed4350fc1$export$db9e2781cae98c53 = {
        styleDefault: {
            strokeColor: "#22333b",
            strokeOpacity: 0.1,
            strokeWeight: 2.0,
            fillColor: "white",
            fillOpacity: 0.1
        },
        styleClicked: {
            strokeColor: "#22333b",
            strokeOpacity: 1.0,
            strokeWeight: 4.0,
            fillColor: "#22333b",
            fillOpacity: 0.5
        },
        styleMouseMove: {
            strokeColor: "#22333b",
            strokeOpacity: 1.0,
            strokeWeight: 4.0,
            fillColor: "white",
            fillOpacity: 0.1
        }
    };
});
$305cacda61daafb0$var$parcelRegister("ciKLf", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleMapRegionSelector", function() {
        return $cd549365a73ff24c$export$69db0098ba220f7b;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $cSyOF = $305cacda61daafb0$var$parcelRequire("cSyOF");
    var $81q9V = $305cacda61daafb0$var$parcelRequire("81q9V");
    var $3qg63 = $305cacda61daafb0$var$parcelRequire("3qg63");
    var $2FrzH = $305cacda61daafb0$var$parcelRequire("2FrzH");
    function $cd549365a73ff24c$export$69db0098ba220f7b(props) {
        const { featureTypeMap: featureTypeMap, onSelectionChanged: onSelectionChanged, onRegionClicked: onRegionClicked, onRegionMouseMove: onRegionMouseMove, onAPIError: onAPIError, selectedRegions: selectedRegions, setSelectedRegions: setSelectedRegions, googleMapsAPI: googleMapsAPI, countries: countries, showOnlyCurrentLayerFeatures: showOnlyCurrentLayerFeatures, clickedRegions: clickedRegions, setClickedRegions: setClickedRegions, mapRestrictions: mapRestrictions, mapCenter: mapCenter, maxRegions: maxRegions, onMaxRegionsReached: onMaxRegionsReached, highlightOnMouseOver: highlightOnMouseOver } = (0, $64A2P.useComponentDefaultProps)("GoogleMapRegionSelector", $3qg63.GoogleMapRegionSelectorDefaultProps, props);
        const { getPlaceDetails: getPlaceDetails, placesReady: placesReady } = googleMapsAPI;
        const { map: map } = (0, $2FrzH.useGoogleMap)();
        const lastInteractedFeatureIdsRef = (0, $acw62.useRef)([]);
        const placeDetailsCache = (0, $acw62.useRef)({});
        const [currentZoomFeature, setCurrentZoomFeature] = (0, $acw62.useState)(featureTypeMap.low);
        const [activeZoomFeatures, setActiveZoomFeatures] = (0, $acw62.useState)([
            featureTypeMap.low
        ]);
        const stylesByZoomLevel = (0, $acw62.useMemo)(()=>({
                low: featureTypeMap.low.styles,
                medium: featureTypeMap.medium.styles,
                high: featureTypeMap.high.styles
            }), [
            featureTypeMap
        ]);
        const emptyStyle = (0, $acw62.useRef)({});
        const applyStyle = (0, $cSyOF.useEvent)((params)=>{
            const feature = params.feature;
            const place_id = feature.placeId;
            const featureType = feature.featureType;
            const currentLevel = currentZoomFeature.zoomLevel;
            // Determine if the feature should be styled based on its featureType and the zoom level
            let styles;
            if (currentLevel === 'low') {
                if (featureType === featureTypeMap.low.featureType) styles = stylesByZoomLevel['low'];
            } else if (currentLevel === 'medium') {
                if (featureType === featureTypeMap.low.featureType) styles = stylesByZoomLevel['low'];
                else if (featureType === featureTypeMap.medium.featureType) styles = stylesByZoomLevel['medium'];
            } else if (currentLevel === 'high') {
                if (featureType === featureTypeMap.low.featureType) styles = stylesByZoomLevel['low'];
                else if (featureType === featureTypeMap.medium.featureType) styles = stylesByZoomLevel['medium'];
                else if (featureType === featureTypeMap.high.featureType) styles = stylesByZoomLevel['high'];
            }
            // If no styles are found for the feature, return an empty style
            if (!styles) return emptyStyle.current;
            // Apply the appropriate style based on the feature's state
            if (!place_id) return styles.styleDefault;
            if (clickedRegions[place_id]) return styles.styleClicked;
            if (lastInteractedFeatureIdsRef.current.includes(place_id)) return styles.styleMouseMove;
            return styles.styleDefault;
        });
        const refreshStyles = (0, $cSyOF.useEvent)(()=>{
            if (!map || !featureTypeMap) return;
            if (!showOnlyCurrentLayerFeatures) {
                //console.log('refreshStyles showOnlyCurrentLayerFeatures false');
                const currentLevel = currentZoomFeature.zoomLevel;
                const lowLayer = map.getFeatureLayer(featureTypeMap.low.featureType);
                const mediumLayer = map.getFeatureLayer(featureTypeMap.medium.featureType);
                const highLayer = map.getFeatureLayer(featureTypeMap.high.featureType);
                // Disable levels below the current one
                if (currentLevel === "low") {
                    if (mediumLayer !== null) mediumLayer.style = null;
                    if (highLayer !== null) highLayer.style = null;
                } else if (currentLevel === "medium") {
                    if (highLayer !== null) highLayer.style = null;
                }
                if (lowLayer) lowLayer.style = applyStyle;
                if (mediumLayer) mediumLayer.style = applyStyle;
                if (highLayer) highLayer.style = applyStyle;
            } else {
                //console.log('refreshStyles showOnlyCurrentLayerFeatures true');
                // Only show current layer
                const currentLayer = map.getFeatureLayer(currentZoomFeature.featureType);
                if (currentLayer) currentLayer.style = applyStyle;
            }
        });
        const selectFeature = (0, $cSyOF.useEvent)((features)=>{
            if (!map) return;
            if (!placesReady) {
                if (onAPIError) {
                    const errorStatus = {
                        status: 'PLACES_API_NOT_READY',
                        origin: "Places"
                    };
                    onAPIError(errorStatus);
                }
                return;
            }
            // Copy the current selection, we will use it to add the place_id or delete it from the selection
            const internal_clicked_places = {
                ...clickedRegions
            };
            // Current number of selected regions
            let currentSelectedCount = Object.keys(internal_clicked_places).length;
            // Track if maxRegions is exceeded
            let maxRegionsExceeded = false;
            for (const feature of features)if (internal_clicked_places[feature.placeId]) {
                delete internal_clicked_places[feature.placeId];
                currentSelectedCount--;
            } else {
                if (currentSelectedCount >= maxRegions) {
                    maxRegionsExceeded = true;
                    continue;
                }
                const clickedData = {
                    placeId: feature.placeId,
                    featureType: feature.featureType
                };
                internal_clicked_places[feature.placeId] = clickedData;
                currentSelectedCount++;
            }
            lastInteractedFeatureIdsRef.current = [];
            setClickedRegions(internal_clicked_places);
            if (onSelectionChanged) onSelectionChanged(internal_clicked_places);
            if (maxRegionsExceeded && onMaxRegionsReached) onMaxRegionsReached();
        });
        const handleClick = (0, $cSyOF.useEvent)((e)=>{
            if (!map) return;
            if (!e.features || e.features.length === 0) return;
            selectFeature(e.features);
            if (onRegionClicked) {
                const placeId = e.features[0].placeId;
                onRegionClicked(placeId);
            }
        });
        const highLightFeature = (0, $cSyOF.useEvent)((placeIds)=>{
            if (!map) return;
            lastInteractedFeatureIdsRef.current = placeIds;
            const featureType = currentZoomFeature?.featureType;
            const featureLayer = map.getFeatureLayer(featureType);
            if (featureLayer) {
                featureLayer.style = null;
                featureLayer.style = applyStyle;
            }
        });
        // Mouse move over region
        const handleMouseMove = (0, $cSyOF.useEvent)((e)=>{
            if (!map) return;
            if (!e.features || e.features.length === 0) return;
            const placeIds = e.features.map((f)=>f.placeId);
            const allPlaceIdsInLastInteracted = placeIds.every((id)=>lastInteractedFeatureIdsRef.current.includes(id));
            if (allPlaceIdsInLastInteracted) return;
            //console.log("Mouse move over placeIds:", placeIds)
            highLightFeature(placeIds);
            if (onRegionMouseMove) onRegionMouseMove(placeIds[0]);
        });
        // replace infowindow click event
        (0, $acw62.useEffect)(()=>{
            if (!map) return;
            const clickListener = map.addListener("click", (e)=>{
                if (e.placeId) e.stop();
            });
            return ()=>{
                clickListener.remove();
            };
        }, [
            map
        ]);
        // Layers
        (0, $acw62.useEffect)(()=>{
            if (!map) return;
            const featureType = currentZoomFeature.featureType;
            if (showOnlyCurrentLayerFeatures) {
                // Disable all layers except the current one
                const allFeatureTypes = Object.values(featureTypeMap);
                allFeatureTypes.forEach((ft)=>{
                    if (ft.featureType === currentZoomFeature?.featureType) return;
                    const layer = map.getFeatureLayer(ft.featureType);
                    if (layer) layer.style = null;
                });
            } else {
                const currentLevel = currentZoomFeature.zoomLevel;
                const mediumLayer = map.getFeatureLayer(featureTypeMap.medium.featureType);
                const highLayer = map.getFeatureLayer(featureTypeMap.high.featureType);
                // Disable levels below the current one
                if (currentLevel === "low") {
                    mediumLayer.style = null;
                    highLayer.style = null;
                } else if (currentLevel === "medium") highLayer.style = null;
            }
            const featureLayer = map.getFeatureLayer(featureType);
            if (featureLayer) {
                //console.log('useEffect layers apply style');
                featureLayer.style = applyStyle;
                const clickListener = featureLayer.addListener("click", handleClick);
                const moveListener = highlightOnMouseOver ? featureLayer.addListener("mousemove", handleMouseMove) : undefined;
                return ()=>{
                    clickListener.remove();
                    if (moveListener) moveListener.remove();
                };
            } else console.warn(`Feature layer '${featureType}' not found.`);
        }, [
            applyStyle,
            currentZoomFeature.featureType,
            currentZoomFeature.zoomLevel,
            featureTypeMap,
            handleClick,
            handleMouseMove,
            highlightOnMouseOver,
            map,
            showOnlyCurrentLayerFeatures
        ]);
        // fit to bounds
        (0, $acw62.useEffect)(()=>{
            if (!map || !mapRestrictions) return;
            const dragListener = map.addListener('dragend', ()=>{
                (0, $81q9V.panIfRestricted)(map, mapRestrictions, mapCenter);
            });
            const zoomListener = map.addListener('zoom_changed', ()=>{
                (0, $81q9V.panIfRestricted)(map, mapRestrictions, mapCenter);
            });
            return ()=>{
                dragListener.remove();
                zoomListener.remove();
            };
        }, [
            map,
            mapCenter,
            mapRestrictions
        ]);
        // Zoom
        (0, $acw62.useEffect)(()=>{
            if (!map) return;
            const handleZoomChange = ()=>{
                const zoom = map.getZoom();
                if (zoom === undefined || featureTypeMap === undefined) return;
                let newFeatureType;
                if (zoom <= featureTypeMap.low.zoom) {
                    newFeatureType = featureTypeMap.low;
                    setActiveZoomFeatures([
                        featureTypeMap.low
                    ]);
                } else if (zoom > featureTypeMap.low.zoom && zoom <= featureTypeMap.medium.zoom) {
                    newFeatureType = featureTypeMap.medium;
                    if (showOnlyCurrentLayerFeatures) setActiveZoomFeatures([
                        featureTypeMap.medium
                    ]);
                    else setActiveZoomFeatures([
                        featureTypeMap.low,
                        featureTypeMap.medium
                    ]);
                } else {
                    newFeatureType = featureTypeMap.high;
                    if (showOnlyCurrentLayerFeatures) setActiveZoomFeatures([
                        featureTypeMap.high
                    ]);
                    else setActiveZoomFeatures([
                        featureTypeMap.low,
                        featureTypeMap.medium,
                        featureTypeMap.high
                    ]);
                }
                setCurrentZoomFeature(newFeatureType);
            };
            const zoomListener = map.addListener("zoom_changed", handleZoomChange);
            // Initialize zoom level
            handleZoomChange();
            return ()=>{
                zoomListener.remove();
            //google.maps.event.removeListener(zoomListener);
            };
        }, [
            featureTypeMap,
            map,
            setActiveZoomFeatures,
            setCurrentZoomFeature,
            showOnlyCurrentLayerFeatures
        ]);
        // Get place details
        const updateSequence = (0, $acw62.useRef)(0);
        (0, $acw62.useEffect)(()=>{
            const currentPlaceEntries = Object.entries(clickedRegions);
            const existingPlaceData = Object.entries(selectedRegions);
            const existingPlaceMap = new Map(existingPlaceData);
            const newPlaceEntries = currentPlaceEntries.filter(([id, regionData])=>!existingPlaceMap.has(id));
            const currentPlaceMap = new Map(currentPlaceEntries);
            const removedPlaceEntries = existingPlaceData.filter(([id, selectedData])=>!currentPlaceMap.has(id));
            if (removedPlaceEntries.length > 0) setSelectedRegions((prevDetails)=>{
                const updatedDetails = {
                    ...prevDetails
                };
                removedPlaceEntries.forEach(([id])=>{
                    delete updatedDetails[id];
                });
                return updatedDetails;
            });
            const sequence = ++updateSequence.current;
            newPlaceEntries.forEach(([placeId, clickedData])=>{
                const cachedDetails = placeDetailsCache.current[placeId];
                if (cachedDetails) setSelectedRegions((prev)=>{
                    const updated_selection = {
                        ...prev
                    };
                    updated_selection[placeId] = cachedDetails;
                    return updated_selection;
                });
                else getPlaceDetails({
                    placeId: placeId,
                    fields: [
                        'address_components'
                    ]
                }).then((place)=>{
                    if (sequence === updateSequence.current) {
                        const addressComponents = place.address_components || [];
                        const countryComponent = addressComponents.find((comp)=>comp.types.includes('country'));
                        const adminLevel1Component = addressComponents.find((comp)=>comp.types.includes('administrative_area_level_1'));
                        const adminLevel2Component = addressComponents.find((comp)=>comp.types.includes('administrative_area_level_2'));
                        const postalCodeComponent = addressComponents.find((comp)=>comp.types.includes('postal_code'));
                        const localityComponent = addressComponents.find((comp)=>comp.types.includes('locality'));
                        if (countries && countryComponent && !countries.includes(countryComponent.short_name)) {
                            //console.log("Country not in list of allowed countries:", countryComponent.short_name);
                            setSelectedRegions((prev)=>{
                                const updated_selection = {
                                    ...prev
                                };
                                delete updated_selection[placeId];
                                return updated_selection;
                            });
                            setClickedRegions((prev)=>{
                                const updated_selection = {
                                    ...prev
                                };
                                delete updated_selection[placeId];
                                return updated_selection;
                            });
                        } else {
                            //console.log("Place details fetched for place_id:", place_id);
                            placeDetailsCache.current[placeId] = {
                                placeId: placeId,
                                featureType: clickedData.featureType,
                                countryId: countryComponent?.short_name,
                                countryName: countryComponent?.long_name,
                                administrativeAreaLevel1Name: adminLevel1Component?.long_name,
                                administrativeAreaLevel1Id: adminLevel1Component?.short_name,
                                administrativeAreaLevel2Name: adminLevel2Component?.long_name,
                                administrativeAreaLevel2Id: adminLevel2Component?.short_name,
                                localityId: localityComponent?.short_name,
                                localityName: localityComponent?.long_name,
                                postalCode: postalCodeComponent?.short_name
                            };
                            setSelectedRegions((prev)=>{
                                // Update the selected region with addressComponents.
                                const updated_selection = {
                                    ...prev
                                };
                                const new_region_data = {
                                    placeId: placeId,
                                    featureType: clickedData.featureType,
                                    countryId: countryComponent?.short_name,
                                    countryName: countryComponent?.long_name,
                                    administrativeAreaLevel1Name: adminLevel1Component?.long_name,
                                    administrativeAreaLevel1Id: adminLevel1Component?.short_name,
                                    administrativeAreaLevel2Name: adminLevel2Component?.long_name,
                                    administrativeAreaLevel2Id: adminLevel2Component?.short_name,
                                    localityId: localityComponent?.short_name,
                                    localityName: localityComponent?.long_name,
                                    postalCode: postalCodeComponent?.short_name
                                };
                                updated_selection[placeId] = new_region_data;
                                return updated_selection;
                            });
                        }
                    }
                }).catch((error)=>{
                    console.error("Error fetching place details:", error);
                    if (onAPIError) {
                        const errorStatus = {
                            status: 'APIERROR',
                            origin: "Places"
                        };
                        if (onAPIError) onAPIError(errorStatus);
                    }
                });
            });
        }, [
            clickedRegions,
            countries,
            getPlaceDetails,
            onAPIError,
            selectedRegions,
            setClickedRegions,
            setSelectedRegions
        ]);
        // apply styles on state change
        (0, $acw62.useEffect)(()=>{
            if (!map) return;
            const featureType = currentZoomFeature?.featureType;
            const featureLayer = map.getFeatureLayer(featureType);
            if (featureLayer) {
                featureLayer.style = null;
                featureLayer.style = applyStyle;
            }
        }, [
            clickedRegions
        ]);
        return {
            applyStyle: applyStyle,
            selectFeature: selectFeature,
            highLightFeature: highLightFeature,
            currentZoomFeature: currentZoomFeature,
            setCurrentZoomFeature: setCurrentZoomFeature,
            map: map,
            handleClick: handleClick,
            handleMouseMove: handleMouseMove,
            activeZoomFeatures: activeZoomFeatures,
            setActiveZoomFeatures: setActiveZoomFeatures,
            refreshStyles: refreshStyles
        };
    }
});
$305cacda61daafb0$var$parcelRegister("81q9V", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isWithinRestrictions", function() {
        return $99a29576f6c9a932$export$351d77caf1917064;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "findClosestCenter", function() {
        return $99a29576f6c9a932$export$e8df5906c5232a50;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "panIfRestricted", function() {
        return $99a29576f6c9a932$export$e506c9c8aa6fd;
    });
    const $99a29576f6c9a932$export$351d77caf1917064 = (latLng, boundsRestrictions)=>{
        return boundsRestrictions.some((boundsLiteral)=>{
            const bounds = new google.maps.LatLngBounds(new google.maps.LatLng(boundsLiteral.south, boundsLiteral.west), new google.maps.LatLng(boundsLiteral.north, boundsLiteral.east));
            return bounds.contains(latLng);
        });
    };
    const $99a29576f6c9a932$export$e8df5906c5232a50 = (latLng, boundsRestrictions, defaultCenter)=>{
        let closestDistance = Infinity;
        let closestPoint = defaultCenter;
        boundsRestrictions.forEach((boundsLiteral)=>{
            const bounds = new google.maps.LatLngBounds(new google.maps.LatLng(boundsLiteral.south, boundsLiteral.west), new google.maps.LatLng(boundsLiteral.north, boundsLiteral.east));
            if (bounds.contains(latLng)) {
                closestPoint = latLng;
                return;
            }
            const ne = bounds.getNorthEast();
            const sw = bounds.getSouthWest();
            // Clamping latitude y longitude a los límites
            const lat = Math.max(sw.lat(), Math.min(latLng.lat, ne.lat()));
            const lng = Math.max(sw.lng(), Math.min(latLng.lng, ne.lng()));
            const clampedLatLng = new google.maps.LatLng(lat, lng);
            const distance = google.maps.geometry.spherical.computeDistanceBetween(latLng, clampedLatLng);
            if (distance < closestDistance) {
                closestDistance = distance;
                closestPoint = clampedLatLng.toJSON();
            }
        });
        return closestPoint;
    };
    const $99a29576f6c9a932$export$e506c9c8aa6fd = (map, boundsRestrictions, defaultCenter)=>{
        const center = map.getCenter()?.toJSON() || defaultCenter;
        if (!center) return;
        if (!$99a29576f6c9a932$export$351d77caf1917064(center, boundsRestrictions)) {
            const newCenter = $99a29576f6c9a932$export$e8df5906c5232a50(center, boundsRestrictions, defaultCenter);
            map.panTo(newCenter);
        }
    };
});
$305cacda61daafb0$var$parcelRegister("2FrzH", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapContext", function() {
        return $23a62216edb5c0b6$export$f422af65c628ab37;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleMap", function() {
        return $23a62216edb5c0b6$export$7105827ad5b8fcc3;
    });
    const $23a62216edb5c0b6$export$f422af65c628ab37 = (0, $acw62.createContext)(null);
    function $23a62216edb5c0b6$export$7105827ad5b8fcc3() {
        const context = (0, $acw62.useContext)($23a62216edb5c0b6$export$f422af65c628ab37);
        if (context === null) throw new Error('useGoogleMap must be used within a GoogleMapContext provider');
        return context;
    }
});
$305cacda61daafb0$var$parcelRegister("f1AFh", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MarkerPropsDefault", function() {
        return $477f8ab014db96d9$export$5b1266d7652361a4;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMarker", function() {
        return $477f8ab014db96d9$export$2328eff9e1bf84ef;
    });
    var $2FrzH = $305cacda61daafb0$var$parcelRequire("2FrzH");
    const $477f8ab014db96d9$export$5b1266d7652361a4 = {
        dataSetId: "default"
    };
    function $477f8ab014db96d9$export$2328eff9e1bf84ef(props) {
        const { markerOptions: markerOptions, onDragEnd: onDragEnd, onMarkerClick: onMarkerClick } = (0, $64A2P.useComponentDefaultProps)('GoogleMarker', $477f8ab014db96d9$export$5b1266d7652361a4, props);
        const { map: map, infoWindowContentRef: infoWindowContentRef, infoWindowRef: infoWindowRef, setInfoWindowContent: setInfoWindowContent } = (0, $2FrzH.useGoogleMap)();
        const markerRef = (0, $acw62.useRef)(null);
        (0, $acw62.useEffect)(()=>{
            if (map && !markerRef.current) markerRef.current = new google.maps.Marker({
                ...markerOptions,
                map: map
            });
        }, [
            map,
            markerOptions
        ]);
        (0, $acw62.useEffect)(()=>{
            if (markerRef.current) markerRef.current.setOptions(markerOptions);
        }, [
            markerOptions
        ]);
        (0, $acw62.useEffect)(()=>{
            if (!map) return;
            const listener = onDragEnd && markerRef.current?.addListener("dragend", ()=>{
                const pos = markerRef.current.getPosition();
                if (pos) onDragEnd(pos);
            });
            return ()=>{
                if (listener) google.maps.event.removeListener(listener);
            };
        }, [
            map,
            onDragEnd
        ]);
        // InfoWindow
        (0, $acw62.useEffect)(()=>{
            if (!map || !infoWindowContentRef?.current || !setInfoWindowContent) return;
            const listener = onMarkerClick && markerRef.current?.addListener("click", ()=>{
                const content = onMarkerClick(infoWindowRef.current);
                if (content) {
                    setInfoWindowContent(content);
                    infoWindowRef.current.setContent(infoWindowContentRef.current);
                    infoWindowRef.current.open(map, markerRef.current);
                }
            });
            return ()=>{
                if (listener) google.maps.event.removeListener(listener);
            };
        }, [
            infoWindowContentRef,
            infoWindowRef,
            map,
            onMarkerClick,
            setInfoWindowContent
        ]);
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (markerRef.current) {
                    google.maps.event.clearInstanceListeners(markerRef.current);
                    markerRef.current.setMap(null);
                    markerRef.current.unbindAll();
                    markerRef.current = null;
                }
            };
        }, []);
        return undefined;
    }
});
$305cacda61daafb0$var$parcelRegister("jQiQb", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DEFAULT_MAP_CENTER", function() {
        return $fcb291f733171619$export$8cd0ab387c59a110;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressSearchDefaultZoomLevels", function() {
        return $fcb291f733171619$export$67a59ec0222ad436;
    });
    const $fcb291f733171619$export$8cd0ab387c59a110 = {
        lat: -34.603683,
        lng: -58.381557
    };
    const $fcb291f733171619$export$67a59ec0222ad436 = {
        address: 17,
        postal_code: 14,
        city: 12,
        state_province: 6,
        country: 4,
        county: 12,
        unknown: 12
    };
});
$305cacda61daafb0$var$parcelRegister("cBazH", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleAddressMappingRules", function() {
        return $d69768ae288c9561$export$fa48517122fad011;
    });
    function $d69768ae288c9561$export$fa48517122fad011() {
        const mappingRules = (0, $acw62.useRef)([]);
        const addMappingRule = (0, $acw62.useCallback)((rules)=>{
            for (const newRule of rules)mappingRules.current.push(newRule);
            // Sorting could potentially be optimized if performance becomes an issue
            mappingRules.current.sort((a, b)=>Object.keys(b.conditions).length - Object.keys(a.conditions).length);
        }, []);
        const clearMappingRules = (0, $acw62.useCallback)(()=>{
            mappingRules.current = [];
        }, []);
        return {
            mappingRules: mappingRules.current,
            addMappingRule: addMappingRule,
            clearMappingRules: clearMappingRules
        };
    }
});
$305cacda61daafb0$var$parcelRegister("4Z5zv", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "InfoWindowPortal", function() {
        return $5c3a5a425dbfe68d$export$f1a8c9d4113b00f3;
    });
    function $5c3a5a425dbfe68d$export$f1a8c9d4113b00f3({ children: children, container: container }) {
        return /*#__PURE__*/ (0, $1u0KT.createPortal)(children, container);
    }
});
$305cacda61daafb0$var$parcelRegister("jsiDH", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapsInfoWindow", function() {
        return $10c21d832badb540$export$6234e950f5ab233f;
    });
    var $4Z5zv = $305cacda61daafb0$var$parcelRequire("4Z5zv");
    function $10c21d832badb540$export$6234e950f5ab233f({ container: container, infoWindowContent: infoWindowContent }) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)($4Z5zv.InfoWindowPortal, {
            container: container,
            children: infoWindowContent
        });
    }
});
$305cacda61daafb0$var$parcelRegister("9UpIY", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DefaultMapClusterProps", function() {
        return $8fb9a4d8c15854a3$export$78f11373091d6d9d;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapCluster", function() {
        return $8fb9a4d8c15854a3$export$e832664790e73f5a;
    });
    var $bwuk4 = $305cacda61daafb0$var$parcelRequire("bwuk4");
    var $2FrzH = $305cacda61daafb0$var$parcelRequire("2FrzH");
    const $8fb9a4d8c15854a3$export$78f11373091d6d9d = {
        labels: {
            groupOfLabel: 'Group of',
            locationsLabel: 'locations'
        }
    };
    function $8fb9a4d8c15854a3$export$e832664790e73f5a(props) {
        props = (0, $64A2P.useComponentDefaultProps)('GoogleMapCluster', $8fb9a4d8c15854a3$export$78f11373091d6d9d, props);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { mapOptions: mapOptions, InitialMarkerClustererOptions: InitialMarkerClustererOptions, children: children, infoWindowContentRef: infoWindowContentRef, setInfoWindowContent: setInfoWindowContent, markers: markers, labels: labels, selectedMarkers: selectedMarkers, ...rest } = props;
        const { containerRef: containerRef, mapContext: mapContext } = (0, $bwuk4.useCreateGoogleMapCluster)(props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9Zs0z.Paper, {
                style: {
                    borderRadius: "unset"
                },
                ref: containerRef,
                ...rest,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2FrzH.GoogleMapContext.Provider, {
                    value: mapContext
                })
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("bwuk4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useCreateGoogleMapCluster", function() {
        return $f45cc5d831dfee4e$export$f8311e03dfc5ec83;
    });
    var $1nclZ = $305cacda61daafb0$var$parcelRequire("1nclZ");
    function $f45cc5d831dfee4e$export$f8311e03dfc5ec83({ mapOptions: mapOptions, InitialMarkerClustererOptions: InitialMarkerClustererOptions, setInfoWindowContent: setInfoWindowContent, infoWindowContentRef: infoWindowContentRef, labels: labels, markers: markers, selectedMarkers: selectedMarkers }) {
        const containerRef = (0, $acw62.useRef)(null);
        // Autopan in false is beacuse the infowindow when clicked moves the map_ctx and the markerProps gets re-rendered and closes it
        const infoWindowRef = (0, $acw62.useRef)(new google.maps.InfoWindow({
            disableAutoPan: false,
            headerDisabled: true
        }));
        const [map, setMap] = (0, $acw62.useState)(null);
        const [markerClusterer, setMarkerClusterer] = (0, $acw62.useState)(null);
        const markersRef = (0, $acw62.useRef)([]);
        const currentMarkersRef = (0, $acw62.useRef)([]);
        // Default Cluster Renderer
        const defaultRenderer = (0, $1nclZ.useDefaultClusterRenderer)(labels?.groupOfLabel, labels?.locationsLabel);
        const currentMarkerClustererOptions = (0, $acw62.useMemo)(()=>{
            const defaultOptions = {
                algorithmOptions: {
                    maxZoom: 15
                },
                renderer: defaultRenderer
            };
            return {
                ...defaultOptions,
                ...InitialMarkerClustererOptions
            };
        }, [
            defaultRenderer
        ]);
        // Map creation
        (0, $acw62.useEffect)(()=>{
            if (map === null && containerRef.current) {
                if (mapOptions && mapOptions.center && (!mapOptions.center.lat || !mapOptions.center.lng)) mapOptions.center = undefined;
                const initMap = new google.maps.Map(containerRef.current, mapOptions);
                setMap(initMap);
            }
        }, [
            map,
            containerRef
        ]);
        // Map options update
        (0, $acw62.useEffect)(()=>{
            if (mapOptions && mapOptions.center && (!mapOptions.center.lat || !mapOptions.center.lng)) mapOptions.center = undefined;
            if (map) map.setOptions(mapOptions);
        }, [
            map,
            mapOptions
        ]);
        // MarkerClusterer creation
        (0, $acw62.useEffect)(()=>{
            if (map !== null && markerClusterer === null) {
                //console.log("Creating MarkerClusterer")
                const clusterer = new $2ESFG.MarkerClusterer({
                    map: map,
                    ...currentMarkerClustererOptions
                });
                setMarkerClusterer(clusterer);
                return ()=>{
                    if (clusterer) clusterer.clearMarkers(true);
                };
            }
        }, [
            currentMarkerClustererOptions,
            map,
            markerClusterer
        ]);
        // Refresh markers
        const refreshMarkers = (0, $acw62.useCallback)(()=>{
            if (markerClusterer !== null && map !== null) {
                // get current markers that are visible in the map_ctx
                const bounds = map.getBounds();
                //console.log("DataMap Bounds", bounds);
                // Filter markers that are visible in the map_ctx
                currentMarkersRef.current = markersRef.current.filter((currentMarker)=>{
                    const pos = currentMarker.getPosition();
                    return bounds && pos && bounds.contains(pos);
                });
                //console.log("DataMap Visible Markers", currentMarkersRef.current.length);
                // Clear and add markers to cluster
                markerClusterer.clearMarkers(true);
                markerClusterer.addMarkers(currentMarkersRef.current);
            }
        }, [
            map,
            markerClusterer
        ]);
        // Create markers
        (0, $acw62.useEffect)(()=>{
            if (!markers) return;
            markersRef.current = [];
            for(let i = 0; i < markers.length; i++){
                const markerProps = markers[i];
                let marker;
                const selectedMarker = markerProps.recordIndex !== undefined ? selectedMarkers[markerProps.dataSetId || '']?.[markerProps.recordIndex] : undefined;
                if (markerProps.recordIndex !== undefined && selectedMarker && selectedMarker.dataSetId === markerProps.dataSetId && markerProps.selectedMarkerOptions) marker = new google.maps.Marker({
                    ...selectedMarker.selectedMarkerOptions
                });
                else marker = new google.maps.Marker({
                    ...markerProps.markerOptions
                });
                if (infoWindowContentRef?.current && setInfoWindowContent && markerProps.onMarkerClick) marker.addListener("click", ()=>{
                    const content = markerProps.onMarkerClick(infoWindowRef.current);
                    if (content) {
                        setInfoWindowContent(content);
                        setTimeout(()=>{
                            infoWindowRef.current.setContent(infoWindowContentRef.current);
                            infoWindowRef.current.open({
                                anchor: marker,
                                map: map
                            });
                        });
                    }
                });
                markersRef.current.push(marker);
            }
            infoWindowRef.current.close();
            refreshMarkers();
        }, [
            infoWindowContentRef,
            map,
            markers,
            refreshMarkers,
            selectedMarkers,
            setInfoWindowContent
        ]);
        // Map tilesLoaded event, render in cluster manager
        (0, $acw62.useEffect)(()=>{
            if (map !== null && markerClusterer !== null) {
                const listener = map.addListener("idle", ()=>{
                    refreshMarkers();
                });
                return ()=>{
                    google.maps.event.removeListener(listener);
                };
            }
        }, [
            map,
            markerClusterer,
            refreshMarkers
        ]);
        const mapContext = (0, $acw62.useMemo)(()=>({
                map: map,
                renderMarkers: ()=>{
                    throw new Error("Map cluster doesn't support renderMarkers.");
                },
                infoWindowRef: infoWindowRef,
                infoWindowContentRef: infoWindowContentRef,
                setInfoWindowContent: setInfoWindowContent
            }), [
            infoWindowContentRef,
            map,
            setInfoWindowContent
        ]);
        const returnObject = (0, $acw62.useMemo)(()=>({
                containerRef: containerRef,
                mapContext: mapContext
            }), [
            containerRef,
            mapContext
        ]);
        return returnObject;
    }
});
$305cacda61daafb0$var$parcelRegister("1nclZ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useDefaultClusterRenderer", function() {
        return $24fb6843a524ec33$export$9e9bc0d7172d2b0e;
    });
    function $24fb6843a524ec33$export$9e9bc0d7172d2b0e(groupOfLabel, locationsLabel) {
        //const { interpolateColor } = useColorTools();
        const defalutRenderer = (0, $acw62.useCallback)((cluster, stats, map)=>{
            const { count: count, position: position } = cluster;
            const color = "#000080";
            // create svg literal with fill color
            const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
            const title = `${groupOfLabel ? `${groupOfLabel} ` : ''}${count}${locationsLabel ? ` ${locationsLabel}` : ''}`, zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
            const clusterOptions = {
                position: position,
                zIndex: zIndex,
                title: title,
                icon: {
                    url: `data:image/svg+xml;base64,${btoa(svg)}`,
                    anchor: new google.maps.Point(25, 25)
                }
            };
            return new google.maps.Marker(clusterOptions);
        }, [
            groupOfLabel,
            locationsLabel
        ]);
        return {
            render: defalutRenderer
        };
    }
});
$305cacda61daafb0$var$parcelRegister("9oW8i", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getGoogleMapsStreetViewImage", function() {
        return $339ade7233da6815$export$aa4fb558a6fc1000;
    });
    $305cacda61daafb0$var$parcelRequire("hZjV3");
    var $dC5GO = $305cacda61daafb0$var$parcelRequire("dC5GO");
    function $339ade7233da6815$export$aa4fb558a6fc1000(location1, width = 350, height = 200, fov = 90) {
        const streetViewUrl = `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&location=${location1.lat},${location1.lng}&fov=${fov}&key=${$dC5GO.GoogleMapsAPILoaderConfig.apiKey}`;
        return streetViewUrl;
    }
});
$305cacda61daafb0$var$parcelRegister("hZjV3", function(module1, exports) {
    var $dC5GO = $305cacda61daafb0$var$parcelRequire("dC5GO");
    var $8ahcP = $305cacda61daafb0$var$parcelRequire("8ahcP");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dC5GO);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8ahcP);
});
$305cacda61daafb0$var$parcelRegister("hejF0", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "GoogleMapRegionSelectorMap", function() {
        return $68b0fb11add6b763$export$abe1805571500b66;
    });
    $305cacda61daafb0$var$parcelRequire("hZjV3");
    var $8ahcP = $305cacda61daafb0$var$parcelRequire("8ahcP");
    var $bwtho = $305cacda61daafb0$var$parcelRequire("bwtho");
    var $32aKS = $305cacda61daafb0$var$parcelRequire("32aKS");
    function $68b0fb11add6b763$export$abe1805571500b66(props) {
        const { regionSelectorProps: regionSelectorProps, children: children, ...map_props } = props;
        const API = (0, $8ahcP.useGoogleMapsAPI)();
        const { mapReady: mapReady, placesReady: placesReady, geocoderReady: geocoderReady } = API;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: mapReady && placesReady && geocoderReady ? /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($bwtho.GoogleMap, {
                        ...map_props,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($32aKS.GoogleMapRegionSelector, {
                                ...regionSelectorProps,
                                googleMapsAPI: API
                            }),
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        style: {
                            display: "none"
                        },
                        ref: API.attributionsRef
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {
                height: "50vh"
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("if1g8", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressLookupDefaultProps", function() {
        return $25126e10126a8fde$export$7115f2b4c3637f5a;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressLookup", function() {
        return $25126e10126a8fde$export$932b4fa0068b2c0e;
    });
    var $fwOUq = $305cacda61daafb0$var$parcelRequire("fwOUq");
    var $ihm2f = $305cacda61daafb0$var$parcelRequire("ihm2f");
    const $25126e10126a8fde$export$7115f2b4c3637f5a = {
        icon: /*#__PURE__*/ (0, $ayMG0.jsx)($eae64.default, {
            size: "1rem",
            stroke: "1.5"
        }),
        iconVariant: "light",
        iconLabel: "Map",
        rightSectionWidth: "5.2rem"
    };
    function $25126e10126a8fde$export$932b4fa0068b2c0e(props) {
        const { countries: countries, icon: icon, iconVariant: iconVariant, column: column, entityForm: entityForm, currentPosition: currentPosition, onAddressFound: onAddressFound, mappingRules: mappingRules, iconLabel: iconLabel, rightSectionWidth: rightSectionWidth, ...rest } = (0, $64A2P.useComponentDefaultProps)('AddressLookup', $25126e10126a8fde$export$7115f2b4c3637f5a, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const search = (0, $ihm2f.useAddressSearchForm)();
        const handleOKSearch = (0, $acw62.useCallback)((result, position)=>{
            const description = result?.suggestionDescription || result?.place.formatted_address;
            if (description) entityForm.form.values[column.name] = description;
            const found = {
                address: result?.address,
                position: position,
                utcOffsetMinutes: result?.place.utc_offset_minutes,
                formattedAddress: description
            };
            if (onAddressFound) onAddressFound(found);
        }, [
            column.name,
            entityForm.form,
            onAddressFound
        ]);
        const handleSearch = (0, $acw62.useCallback)(()=>{
            search({
                countries: countries,
                search: entityForm.form.values[column.name],
                currentPosition: currentPosition,
                mappingRules: mappingRules,
                onOK: handleOKSearch
            });
        }, [
            column.name,
            countries,
            currentPosition,
            entityForm.form.values,
            handleOKSearch,
            mappingRules,
            search
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($fwOUq.AddressAutocomplete, {
                ...rest,
                column: column,
                entityForm: entityForm,
                countries: countries,
                onAddressFound: onAddressFound,
                rightSection: /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                    color: theme.primaryColor,
                    onClick: handleSearch,
                    variant: iconVariant,
                    size: "xs",
                    leftIcon: icon,
                    children: iconLabel
                }),
                rightSectionWidth: rightSectionWidth
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("ihm2f", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseAddressSearchFormDefaultProps", function() {
        return $62d1af54df8963b9$export$2a9812f64650e13e;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useAddressSearchForm", function() {
        return $62d1af54df8963b9$export$c2c978213a6d5708;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    var $fSX48 = $305cacda61daafb0$var$parcelRequire("fSX48");
    const $62d1af54df8963b9$export$2a9812f64650e13e = {
        modalProps: {
            size: 'xl'
        },
        title: 'Address Search',
        helpMessage: 'Enter the address to search for. You can move the Marker to another position. Click OK when ready',
        mappingRules: []
    };
    function $62d1af54df8963b9$export$c2c978213a6d5708() {
        const modals = (0, $k7qj2.useModal)();
        const buttonResult = (0, $acw62.useRef)('Quit');
        const open = async (props)=>{
            const { onOK: onOK, onCancel: onCancel, modalProps: modalProps, search: search, helpMessage: helpMessage, onClosed: onClosed, countries: countries, title: title, currentPosition: currentPosition, mappingRules: mappingRules } = {
                ...$62d1af54df8963b9$export$2a9812f64650e13e,
                ...props
            };
            buttonResult.current = 'Quit';
            const handleOK = async (address, position)=>{
                buttonResult.current = 'OK';
                await modals.close();
                if (onOK) await onOK(address, position);
            };
            const handleCancel = async ()=>{
                buttonResult.current = 'Cancel';
                await modals.close();
                if (onCancel) onCancel();
            };
            const handleClosed = async ()=>{
                if (buttonResult.current === 'Quit') {
                    if (onCancel) onCancel();
                }
                if (onClosed) onClosed();
            };
            await modals.open({
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($fSX48.AddressSearchForm, {
                    countries: countries,
                    initialSearchAddress: search,
                    currentPosition: currentPosition,
                    helpMessage: helpMessage,
                    onOK: (address, position)=>handleOK(address, position),
                    onCancel: ()=>handleCancel(),
                    mappingRules: mappingRules
                }),
                modalProps: {
                    ...modalProps,
                    trapFocus: true,
                    returnFocus: true,
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        fw: "700",
                        children: title
                    })
                },
                onClosed: async ()=>{
                    await handleClosed();
                }
            });
        };
        return open;
    }
});
$305cacda61daafb0$var$parcelRegister("fSX48", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressSearchFormDefaultProps", function() {
        return $e4d6e05056a3b2d0$export$158c7bb191dcffb8;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressSearchForm", function() {
        return $e4d6e05056a3b2d0$export$c7ec7cf48c8c1b16;
    });
    var $lRkkN = $305cacda61daafb0$var$parcelRequire("lRkkN");
    const $e4d6e05056a3b2d0$export$158c7bb191dcffb8 = {
        helpMessage: "Enter the address to search for. You can move the Marker to another position. Click OK when ready",
        okLabel: "OK",
        cancelLabel: "Cancel",
        mappingRules: []
    };
    function $e4d6e05056a3b2d0$export$c7ec7cf48c8c1b16(props) {
        const theme = (0, $64A2P.useMantineTheme)();
        const { helpMessage: helpMessage, okLabel: okLabel, onOK: onOK, onCancel: onCancel, cancelLabel: cancelLabel, countries: countries, initialSearchAddress: initialSearchAddress, currentPosition: currentPosition, mappingRules: mappingRules, draggable: draggable } = (0, $64A2P.useComponentDefaultProps)('AddressSearchForm', $e4d6e05056a3b2d0$export$158c7bb191dcffb8, props);
        const [address, setAddress] = (0, $acw62.useState)();
        const [position, setPosition] = (0, $acw62.useState)();
        const handleOnAddressFound = (0, $acw62.useCallback)((result)=>{
            setAddress(result);
            if (result.place.geometry && result.place.geometry.location) setPosition({
                lat: result.place.geometry.location.lat(),
                lng: result.place.geometry.location.lng()
            });
        }, []);
        const handleOnMarkerChanged = (0, $acw62.useCallback)((position)=>{
            if (position) setPosition(position);
        }, []);
        const handleOK = (0, $acw62.useCallback)(()=>{
            onOK(address, position);
        }, [
            address,
            onOK,
            position
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
                    shadow: "sm",
                    withBorder: theme.colorScheme === 'dark' ? false : true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                            p: "xs",
                            bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                            mb: "1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                sx: {
                                    gap: "0.25rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($1YbUT.default, {
                                        size: "1.1rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        fz: "xs",
                                        c: "dimmed",
                                        children: helpMessage
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($lRkkN.AddressSearch, {
                            countries: countries,
                            initialSearchAddress: initialSearchAddress,
                            onAddressFound: handleOnAddressFound,
                            onMarkerChanged: handleOnMarkerChanged,
                            markerPosition: currentPosition,
                            mappingRules: mappingRules,
                            draggable: draggable
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    mt: "md",
                    position: "right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            variant: "light",
                            leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($dRw7S.default, {
                                size: "1.5rem"
                            }),
                            onClick: ()=>onCancel ? onCancel() : null,
                            children: cancelLabel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            onClick: handleOK,
                            color: theme.colors.green[5],
                            leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($4Rwq2.default, {
                                size: "1.5rem"
                            }),
                            children: okLabel
                        })
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("lRkkN", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressSearchDefaultProps", function() {
        return $d9ffc9b850afd5aa$export$bf9f4811295f6de1;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressSearch", function() {
        return $d9ffc9b850afd5aa$export$a5807dd44c15712a;
    });
    $305cacda61daafb0$var$parcelRequire("hZjV3");
    var $8ahcP = $305cacda61daafb0$var$parcelRequire("8ahcP");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    $305cacda61daafb0$var$parcelRequire("jtOZC");
    var $gNp1h = $305cacda61daafb0$var$parcelRequire("gNp1h");
    var $lIzIs = $305cacda61daafb0$var$parcelRequire("lIzIs");
    const $d9ffc9b850afd5aa$export$bf9f4811295f6de1 = {
        addressLabel: "Address",
        mappingRules: [],
        draggable: true
    };
    function $d9ffc9b850afd5aa$export$a5807dd44c15712a(props) {
        const googleMapsAPI = (0, $8ahcP.useGoogleMapsAPI)();
        const { mapReady: mapReady, placesReady: placesReady, geocoderReady: geocoderReady } = googleMapsAPI;
        const addressProps = (0, $64A2P.useComponentDefaultProps)('AddressSearch', $d9ffc9b850afd5aa$export$bf9f4811295f6de1, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: mapReady && placesReady && geocoderReady ? /*#__PURE__*/ (0, $ayMG0.jsx)($d9ffc9b850afd5aa$var$AddressSearchInternal, {
                ...addressProps,
                ...googleMapsAPI
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {
                height: "50vh"
            })
        });
    }
    function $d9ffc9b850afd5aa$var$AddressSearchInternal(props) {
        const { addressLabel: addressLabel, onMarkerChanged: onMarkerChanged, defaultMapCenter: defaultMapCenter, markerPosition: markerPosition, errorMessage: errorMessage, errorTitle: errorTitle, onAPIError: onAPIError, readOnly: readOnly, countries: countries, initialSearchAddress: initialSearchAddress, onAddressFound: onAddressFound, mappingRules: mappingRules, draggable: draggable, ...rest } = props;
        const [errorStatus, setErrorStatus] = (0, $acw62.useState)();
        const [lastFormattedAddress, setLastFormattedAddress] = (0, $acw62.useState)(initialSearchAddress);
        const [markerActualPos, setMarkerActualPos] = (0, $acw62.useState)(markerPosition);
        const autocompleteRestrictions = (0, $acw62.useMemo)(()=>({
                country: countries
            }), [
            countries
        ]);
        const handleAddressFound = (0, $acw62.useCallback)((found)=>{
            // MMC: when address changes, the marker gets reset to the same position as the address
            if (found.place.geometry?.location) {
                const currentPos = {
                    lat: found.place.geometry.location.lat(),
                    lng: found.place.geometry.location.lng()
                };
                setMarkerActualPos({
                    position: currentPos,
                    mappedAddressType: found.address?.mappedAddressType
                });
                setLastFormattedAddress(found.suggestionDescription || found.place.formatted_address);
            } else {
                setMarkerActualPos(undefined);
                setLastFormattedAddress(undefined);
            }
            if (onAddressFound) onAddressFound(found);
        }, [
            onAddressFound
        ]);
        const handleAutocompleteError = (0, $acw62.useCallback)((status)=>{
            const apiError = {
                status: status,
                origin: "Places"
            };
            setErrorStatus(apiError);
            if (onAPIError) onAPIError(apiError);
        }, [
            onAPIError
        ]);
        const handleMarkerError = (0, $acw62.useCallback)((status)=>{
            setErrorStatus(status);
            if (onAPIError) onAPIError(status);
        }, [
            onAPIError
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($gNp1h.GoogleAddressAutocomplete, {
                    label: addressLabel,
                    restrictions: autocompleteRestrictions,
                    onAddressFound: handleAddressFound,
                    readOnly: readOnly,
                    value: initialSearchAddress,
                    onAPIError: handleAutocompleteError,
                    mappingRules: mappingRules
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($lIzIs.AddressMapMarker, {
                    ...rest,
                    initialSearchAddress: lastFormattedAddress,
                    markerPosition: markerActualPos,
                    defaultMapCenter: defaultMapCenter,
                    onMarkerChanged: onMarkerChanged,
                    onAPIError: handleMarkerError,
                    readOnly: readOnly,
                    showErrors: false,
                    draggable: draggable
                }),
                errorStatus && /*#__PURE__*/ (0, $ayMG0.jsxs)($d50o9.AlertError, {
                    title: errorTitle,
                    children: [
                        errorMessage,
                        " ",
                        errorStatus.status,
                        " (",
                        errorStatus.origin,
                        ")"
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("lIzIs", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressMapMarkerDefaultProps", function() {
        return $de914619f238de31$export$456750ac01ef2c2c;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AddressMapMarker", function() {
        return $de914619f238de31$export$397649f5727f26be;
    });
    $305cacda61daafb0$var$parcelRequire("hZjV3");
    var $8ahcP = $305cacda61daafb0$var$parcelRequire("8ahcP");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $i6yJ4 = $305cacda61daafb0$var$parcelRequire("i6yJ4");
    $305cacda61daafb0$var$parcelRequire("jtOZC");
    var $jQiQb = $305cacda61daafb0$var$parcelRequire("jQiQb");
    var $bwtho = $305cacda61daafb0$var$parcelRequire("bwtho");
    var $f1AFh = $305cacda61daafb0$var$parcelRequire("f1AFh");
    const $de914619f238de31$export$456750ac01ef2c2c = {
        defaultMapCenter: $jQiQb.DEFAULT_MAP_CENTER,
        mapHeight: "50vh",
        errorTitle: "google maps error",
        errorMessage: "An error occurred with google maps API:",
        markerInfoTitle: "Marker location changed",
        markerInfoMessage: "The marker has been moved to a new location. Result for marker location:",
        draggable: true,
        initialMapZoomLevel: $jQiQb.AddressSearchDefaultZoomLevels.address,
        fullScreenControl: false
    };
    function $de914619f238de31$export$397649f5727f26be(props) {
        const googleMapsAPI = (0, $8ahcP.useGoogleMapsAPI)();
        const { mapReady: mapReady, placesReady: placesReady, geocoderReady: geocoderReady } = googleMapsAPI;
        const addressProps = (0, $64A2P.useComponentDefaultProps)('AddressMapMarker', $de914619f238de31$export$456750ac01ef2c2c, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: mapReady && placesReady && geocoderReady ? /*#__PURE__*/ (0, $ayMG0.jsx)($de914619f238de31$var$AddressMapMarkerInternal, {
                ...addressProps,
                ...googleMapsAPI
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {
                height: props.mapHeight
            })
        });
    }
    function $de914619f238de31$var$AddressMapMarkerInternal(props) {
        const { markerPosition: markerPosition, defaultMapCenter: defaultMapCenter, readOnly: readOnly, errorMessage: errorMessage, errorTitle: errorTitle, initialSearchAddress: initialSearchAddress, markerInfoTitle: markerInfoTitle, markerInfoMessage: markerInfoMessage, onAPIError: onAPIError, onMarkerChanged: onMarkerChanged, geocode: geocode, mapHeight: mapHeight, showErrors: showErrors, draggable: draggable, initialMapZoomLevel: initialMapZoomLevel, fullScreenControl: fullScreenControl } = props;
        const [errorStatus, setErrorStatus] = (0, $acw62.useState)();
        const [draggedFormattedAddress, setDraggedFormattedAddress] = (0, $acw62.useState)(undefined);
        const [markerActualPos, setMarkerActualPos] = (0, $acw62.useState)(markerPosition?.position);
        const [markerPanZoom, setMarkerPanZoom] = (0, $acw62.useState)($jQiQb.AddressSearchDefaultZoomLevels.address);
        const mapOptions = (0, $acw62.useMemo)(()=>({
                zoom: markerActualPos ? markerPanZoom : initialMapZoomLevel,
                fullscreenControl: fullScreenControl,
                gestureHandling: 'greedy',
                clickableIcons: false,
                center: markerActualPos && markerActualPos.lat !== null && markerActualPos.lng !== null ? markerActualPos : defaultMapCenter
            }), [
            defaultMapCenter,
            initialMapZoomLevel,
            markerActualPos,
            markerPanZoom,
            fullScreenControl
        ]);
        const addressMarkerOptions = (0, $acw62.useMemo)(()=>({
                position: markerActualPos && markerActualPos.lat !== null && markerActualPos.lng !== null ? markerActualPos : defaultMapCenter,
                visible: !!markerActualPos,
                animation: google.maps.Animation.DROP,
                draggable: readOnly ? false : draggable
            }), [
            defaultMapCenter,
            markerActualPos,
            readOnly,
            draggable
        ]);
        (0, $acw62.useEffect)(()=>{
            setMarkerActualPos(markerPosition?.position);
            setMarkerPanZoom(markerPosition?.mappedAddressType ? $jQiQb.AddressSearchDefaultZoomLevels[markerPosition.mappedAddressType || 'unknown'] : initialMapZoomLevel);
        }, [
            initialMapZoomLevel,
            markerPosition
        ]);
        const handleDragEnd = (0, $acw62.useCallback)((position)=>{
            const latLng = {
                lat: position.lat(),
                lng: position.lng()
            };
            setMarkerActualPos(latLng);
            geocode({
                location: position
            }, (results, status)=>{
                const operationResult = {};
                operationResult.status = status || 'UNKNOWN';
                if (status === google.maps.GeocoderStatus.OK) {
                    const filteredResults = results?.filter((result)=>result.types.includes('route'));
                    operationResult.result = filteredResults && filteredResults.length > 0 ? filteredResults[0] : results ? results[0] : undefined;
                    setDraggedFormattedAddress(operationResult.result?.formatted_address);
                } else if (status === google.maps.GeocoderStatus.ZERO_RESULTS) operationResult.status = "OK";
                else {
                    const errorStatus = {
                        status: status || 'UNKNOWN',
                        origin: "Geocoder"
                    };
                    setErrorStatus(errorStatus);
                    if (onAPIError) onAPIError(errorStatus);
                }
                if (onMarkerChanged) onMarkerChanged(latLng, operationResult.result);
            });
        }, [
            geocode,
            onAPIError,
            onMarkerChanged
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($bwtho.GoogleMap, {
                    style: {
                        height: mapHeight,
                        resize: "vertical"
                    },
                    mapOptions: mapOptions,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($f1AFh.GoogleMarker, {
                        markerOptions: addressMarkerOptions,
                        onDragEnd: handleDragEnd
                    }, "address-marker")
                }),
                draggedFormattedAddress && draggedFormattedAddress !== initialSearchAddress && /*#__PURE__*/ (0, $ayMG0.jsx)($i6yJ4.AlertInfo, {
                    title: markerInfoTitle,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                        children: [
                            markerInfoMessage,
                            " ",
                            draggedFormattedAddress
                        ]
                    })
                }),
                showErrors && errorStatus && /*#__PURE__*/ (0, $ayMG0.jsxs)($d50o9.AlertError, {
                    title: errorTitle,
                    children: [
                        errorMessage,
                        " ",
                        errorStatus.status,
                        " (",
                        errorStatus.origin,
                        ")"
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("jddMY", function(module1, exports) {
    var $bB3Sz = $305cacda61daafb0$var$parcelRequire("bB3Sz");
    var $1nclZ = $305cacda61daafb0$var$parcelRequire("1nclZ");
    var $efRWI = $305cacda61daafb0$var$parcelRequire("efRWI");
    var $g7KlS = $305cacda61daafb0$var$parcelRequire("g7KlS");
    var $5BXjy = $305cacda61daafb0$var$parcelRequire("5BXjy");
    var $issJt = $305cacda61daafb0$var$parcelRequire("issJt");
    var $cfuDa = $305cacda61daafb0$var$parcelRequire("cfuDa");
    var $eaiZF = $305cacda61daafb0$var$parcelRequire("eaiZF");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $bB3Sz);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $1nclZ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $efRWI);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $g7KlS);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5BXjy);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $issJt);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cfuDa);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $eaiZF);
});
$305cacda61daafb0$var$parcelRegister("bB3Sz", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataMapDefaultProps", function() {
        return $1effbe930a22182b$export$cfd57fa90af0131d;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataMapDefaultDataGridProps", function() {
        return $1effbe930a22182b$export$be3dab73335f38e5;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataMap", function() {
        return $1effbe930a22182b$export$4f44abf55772883f;
    });
    $305cacda61daafb0$var$parcelRequire("hZjV3");
    var $8ahcP = $305cacda61daafb0$var$parcelRequire("8ahcP");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $lB8CV = $305cacda61daafb0$var$parcelRequire("lB8CV");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    var $7B1hX = $305cacda61daafb0$var$parcelRequire("7B1hX");
    $305cacda61daafb0$var$parcelRequire("2Qb3Q");
    var $kjFvY = $305cacda61daafb0$var$parcelRequire("kjFvY");
    var $3vFhj = $305cacda61daafb0$var$parcelRequire("3vFhj");
    var $j8hoz = $305cacda61daafb0$var$parcelRequire("j8hoz");
    var $5JIrZ = $305cacda61daafb0$var$parcelRequire("5JIrZ");
    $305cacda61daafb0$var$parcelRequire("ccjva");
    var $43s6t = $305cacda61daafb0$var$parcelRequire("43s6t");
    $305cacda61daafb0$var$parcelRequire("jtOZC");
    var $jQiQb = $305cacda61daafb0$var$parcelRequire("jQiQb");
    var $9UpIY = $305cacda61daafb0$var$parcelRequire("9UpIY");
    var $jsiDH = $305cacda61daafb0$var$parcelRequire("jsiDH");
    var $d4aSM = $305cacda61daafb0$var$parcelRequire("d4aSM");
    var $5BXjy = $305cacda61daafb0$var$parcelRequire("5BXjy");
    var $issJt = $305cacda61daafb0$var$parcelRequire("issJt");
    const $1effbe930a22182b$export$cfd57fa90af0131d = {
        labels: {
            gridTabLabel: 'Data',
            mapTabLabel: 'Map'
        },
        mapStyle: [
            {
                featureType: 'poi',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'transit',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            }
        ],
        mapOptions: {
            zoom: 10,
            fullscreenControl: true,
            center: $jQiQb.DEFAULT_MAP_CENTER,
            gestureHandling: 'greedy'
        },
        mapHeight: 'auto'
    };
    const $1effbe930a22182b$export$be3dab73335f38e5 = {
        ...$kjFvY.DataGridDefaultProps,
        autoSelectFirstRow: false,
        renderOnlyWhenVisible: false
    };
    function $1effbe930a22182b$export$4f44abf55772883f(props) {
        const { dataGridProps: dataGridProps, labels: dataMapLabels, mapOptions: mapOptions, mapStyle: mapStyle, mapHeight: mapHeight, markerRenderer: markerRenderer, InfoWindowRenderer: InfoWindowRenderer, latitudRecordIndex: latitudRecordIndex, longitudRecordIndex: longitudRecordIndex, groupMarkerRenderer: groupMarkerRenderer, selectRecordsRenderer: selectRecordsRenderer, centerMarker: centerMarker } = (0, $64A2P.useComponentDefaultProps)('DataMap', $1effbe930a22182b$export$cfd57fa90af0131d, props);
        const effectiveDatagridProps = (0, $64A2P.useComponentDefaultProps)('DataGrid', $1effbe930a22182b$export$be3dab73335f38e5, dataGridProps);
        const { search: search, limit: limit, entity: entity, parentKeys: parentKeys, viewName: viewName, labels: labels, enableAdd: enableAdd, enableEdit: enableEdit, enableDelete: enableDelete, enableView: enableView, enableExport: enableExport, autoFocus: autoFocus, actionsButtonVariant: actionsButtonVariant, toolbarIconVariant: toolbarIconVariant, toolbarSize: toolbarSize, showActions: showActions, filtersFormSize: filtersFormSize, renderOnlyWhenVisible: renderOnlyWhenVisible, columnsOverrides: columnsOverrides, setInitialFiltersFromColumns: setInitialFiltersFromColumns, visibleFilters: visibleFilters } = effectiveDatagridProps;
        const theme = (0, $64A2P.useMantineTheme)();
        const modal = (0, $k7qj2.useModal)();
        // infoWindow
        const infoWindowContentRef = (0, $acw62.useRef)(document.createElement('div'));
        const [infoWindowContent, setInfoWindowContent] = (0, $acw62.useState)(null);
        // Map
        const googleMapsAPI = (0, $8ahcP.useGoogleMapsAPI)();
        const { mapReady: mapReady, placesReady: placesReady, geocoderReady: geocoderReady } = googleMapsAPI;
        const currentMapOptions = (0, $acw62.useMemo)(()=>({
                ...mapOptions,
                styles: mapStyle
            }), [
            mapOptions,
            mapStyle
        ]);
        const [selectedMarkers, setSelectedMarkers] = (0, $acw62.useState)({});
        // Grid
        //toolbar
        const [searchData, setSearchData] = (0, $acw62.useState)(search?.map((s)=>{
            return {
                value: s,
                label: s
            };
        }));
        const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
        const viewState = (0, $7B1hX.useViewState)(search, limit);
        const executeViewState = (0, $lB8CV.useExecuteView)(entity, parentKeys, viewName, viewState.searchText, viewState.limitRows, viewState.refresh, viewState.filterValues);
        const dataGridAPI = (0, $5JIrZ.useDataGrid)(effectiveDatagridProps, {
            executeViewState: executeViewState,
            setRefresh: viewState.setRefresh,
            setSearchText: viewState.setSearchText
        });
        const { isLoading: isLoading, rows: rows } = dataGridAPI;
        const { UIAPI: UIAPI } = dataGridAPI;
        const getMarkerOptions = (0, $5BXjy.useCreateMarkerOptions)();
        const groupManager = (0, $issJt.useRecordGroupManager)();
        const TN = {
            grid: 'gridTab',
            gridIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($1a7g8.default, {
                size: "1rem"
            }),
            map: 'mapTab',
            mapIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($8YQDN.default, {
                size: "1rem"
            })
        };
        const effectiveColumnOverrides = (0, $acw62.useMemo)(()=>{
            if (!entity || !viewName) return undefined;
            return columnsOverrides ? columnsOverrides : entity.def.views[viewName].gridColumnsOverrides?.(theme);
        }, [
            columnsOverrides,
            entity,
            theme,
            viewName
        ]);
        //
        // Markers handling
        // Default select records renderer
        const DefaultSelectRecordsRenderer = (0, $acw62.useCallback)((record, recordIndex, position, groupManager, infoWindow, UIAPI, theme)=>{
            if (recordIndex === undefined || recordIndex === null) return;
            setSelectedRows((prevSelectedRows)=>{
                const recid = recordIndex + 1;
                const isAlreadySelected = prevSelectedRows.some((row)=>row.recid === recid);
                if (isAlreadySelected) return prevSelectedRows.filter((row)=>row.recid !== recid);
                else return [
                    ...prevSelectedRows,
                    {
                        ...record,
                        recid: recid
                    }
                ];
            });
            return null;
        }, []);
        // Click handler for selection and Infowindow
        const effectiveInfoWindowRenderer = (0, $acw62.useMemo)(()=>entity && viewName ? entity.def.views[viewName].mapInfoWindowRenderer : InfoWindowRenderer, [
            InfoWindowRenderer,
            entity,
            viewName
        ]);
        const effectiveSelectionClickHandler = (0, $acw62.useMemo)(()=>(entity && viewName ? entity.def.views[viewName].mapSelectRecordsRenderer : selectRecordsRenderer) ?? DefaultSelectRecordsRenderer, [
            DefaultSelectRecordsRenderer,
            entity,
            selectRecordsRenderer,
            viewName
        ]);
        const getInfoWindowClickHandler = (0, $acw62.useCallback)((record, recordIndex)=>{
            if (!latitudRecordIndex || !longitudRecordIndex) return null;
            if (!record || recordIndex === undefined || recordIndex === null) return null;
            const position = {
                lat: record[latitudRecordIndex],
                lng: record[longitudRecordIndex]
            };
            if (dataGridAPI.showSelectCheckbox) {
                if (!effectiveSelectionClickHandler) return null;
                const clickHandler = (infoWindow)=>{
                    return effectiveSelectionClickHandler(record, recordIndex, position, groupManager, infoWindow, UIAPI, theme, entity);
                };
                return clickHandler;
            } else {
                if (!effectiveInfoWindowRenderer) return null;
                const clickHandler = (infoWindow)=>{
                    return effectiveInfoWindowRenderer(record, position, groupManager, infoWindow, UIAPI, theme, entity, modal);
                };
                return clickHandler;
            }
        }, [
            UIAPI,
            dataGridAPI.showSelectCheckbox,
            effectiveInfoWindowRenderer,
            effectiveSelectionClickHandler,
            groupManager,
            latitudRecordIndex,
            longitudRecordIndex,
            theme
        ]);
        // Group Markers
        const defaultGroupMarkerRenderer = (0, $acw62.useCallback)((group, markerOptions, theme)=>{
            const markerCreateOptions = markerOptions;
            markerCreateOptions.svgIcon = $5BXjy.MapMarkerGroupDefaultSVGIcon;
            markerCreateOptions.fillColor = $5BXjy.MapMarkerGroupDefaultFillColor;
            markerCreateOptions.assignColorByValue = undefined;
            markerCreateOptions.title = `${group.records.length} ${(0, $9UpIY.DefaultMapClusterProps).labels?.locationsLabel}`;
            markerCreateOptions.label = {
                text: group.records.length.toString(),
                color: 'white',
                fontSize: '0.7rem',
                fontWeight: '500'
            };
            markerCreateOptions.labelOrigin = new google.maps.Point($5BXjy.MapMarkerGroupDefaultLabelOrigin.x, $5BXjy.MapMarkerGroupDefaultLabelOrigin.y);
            return markerCreateOptions;
        }, []);
        const effectiveGroupMarkerRenderer = (0, $acw62.useMemo)(()=>(entity && viewName ? entity.def.views[viewName].mapGroupMarkerRenderer : groupMarkerRenderer) ?? defaultGroupMarkerRenderer, [
            defaultGroupMarkerRenderer,
            entity,
            groupMarkerRenderer,
            viewName
        ]);
        // newMarkers
        const effectiveMarkerRenderer = (0, $acw62.useMemo)(()=>{
            if (!entity || !viewName) return undefined;
            return entity.def.views[viewName].mapMarkerRenderer ?? markerRenderer;
        }, [
            entity,
            markerRenderer,
            viewName
        ]);
        const [markers, setMarkers] = (0, $acw62.useState)([]);
        (0, $acw62.useEffect)(()=>{
            if (!mapReady || !placesReady || !geocoderReady) return;
            if (!executeViewState.data || executeViewState.data.length === 0 || !executeViewState.data[0].records || executeViewState.data[0].records.length === 0) return;
            if (!effectiveGroupMarkerRenderer) return;
            if (!latitudRecordIndex || !longitudRecordIndex) {
                console.warn(`DataMap: latitudRecordIndex or longitudRecordIndex not specified in ${entity?.name} view: ${viewName}`);
                return;
            }
            const records = executeViewState.data[0].records;
            groupManager.clearAllGroups();
            // Get the groups and marker options
            const processedMarkerCreateOptions = [];
            // To spiderify newMarkers with the same location. Number is the of marker rendered so far to multiply by the offset
            //const processedLocations: Record<string, DataMapMarkerProps & { markersCount: number }> = {};
            if (centerMarker) processedMarkerCreateOptions.push(centerMarker);
            for(let i = 0; i < records.length; i++){
                const record = records[i];
                if (latitudRecordIndex === -1 || longitudRecordIndex === -1) continue;
                if (!record[latitudRecordIndex] || !record[longitudRecordIndex]) continue; // skip records that have no location
                const position = {
                    lat: record[latitudRecordIndex],
                    lng: record[longitudRecordIndex]
                };
                // Ignore invalid newMarkers
                if (!position.lat || !position.lng) continue;
                const markerCreateOptions = effectiveMarkerRenderer ? effectiveMarkerRenderer(record, position, theme) : {
                    position: position,
                    title: `${record[0]}`,
                    fillColor: 'red'
                };
                if (markerCreateOptions === null) continue;
                markerCreateOptions.recordIndex = i;
                groupManager.addRecordToGroup(markerCreateOptions.position, i, record);
                processedMarkerCreateOptions.push(markerCreateOptions);
            }
            // delete groups with only one record
            groupManager.clearOneRecordGroups();
            // Create the newMarkers
            const renderedGroups = {};
            const newMarkers = [];
            for(let i = 0; i < processedMarkerCreateOptions.length; i++){
                const createMarkerRecord = processedMarkerCreateOptions[i];
                const group = groupManager.getGroupByLocation(createMarkerRecord.position);
                let markerOptions;
                let selectedMarkerOptions;
                if (group) {
                    // Check if the group was already rendered
                    if (renderedGroups[group.locationKey]) continue;
                    renderedGroups[group.locationKey] = true;
                    const markerCreateOptions = effectiveGroupMarkerRenderer(group, createMarkerRecord, theme);
                    if (markerCreateOptions === null) continue;
                    const optionsResult = getMarkerOptions(markerCreateOptions);
                    markerOptions = optionsResult.markerOptions;
                    selectedMarkerOptions = optionsResult.selectedMarkerOptions;
                } else {
                    const optionsResult = getMarkerOptions(createMarkerRecord);
                    markerOptions = optionsResult.markerOptions;
                    selectedMarkerOptions = optionsResult.selectedMarkerOptions;
                }
                const clickHandler = getInfoWindowClickHandler(records[createMarkerRecord.recordIndex], createMarkerRecord.recordIndex);
                if (clickHandler) markerOptions.clickable = true;
                newMarkers.push({
                    markerOptions: markerOptions,
                    selectedMarkerOptions: selectedMarkerOptions,
                    onMarkerClick: clickHandler ?? undefined,
                    recordIndex: group ? undefined : createMarkerRecord.recordIndex,
                    dataSetId: 'default'
                });
            }
            setMarkers(newMarkers);
        }, [
            executeViewState.data,
            latitudRecordIndex,
            longitudRecordIndex,
            dataGridAPI.showSelectCheckbox,
            centerMarker
        ]);
        // intentionally left out mapReady, placesReady and geocoderReady dependencies to avoid re-rendering the map when the map is not ready yet
        // newMarkers selection
        (0, $acw62.useEffect)(()=>{
            if (selectedRows.length === 0) {
                setSelectedMarkers({});
                return;
            }
            const selectedRowsMap = {};
            selectedRows.forEach((row, index)=>{
                selectedRowsMap[row.recid] = index;
            });
            // Filtrar y mapear los newMarkers seleccionados
            const currentSelection = markers.reduce((acc, marker)=>{
                if (marker.recordIndex !== undefined && selectedRowsMap[marker.recordIndex + 1] !== undefined) {
                    const dataSetId = marker.dataSetId;
                    if (!acc[dataSetId]) acc[dataSetId] = {};
                    marker.selectedMarkerOptions.label = selectedRowsMap[marker.recordIndex + 1].toString();
                    marker.selectedOrder = selectedRowsMap[marker.recordIndex + 1];
                    acc[dataSetId][marker.recordIndex] = marker;
                }
                return acc;
            }, {});
            setSelectedMarkers(currentSelection);
        }, [
            selectedRows
        ]); // intentionally left out markers dependencies to avoid re-rendering the map when the markers are not ready yet
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($3vFhj.DataGridToolbar, {
                    ...labels,
                    enableExport: enableExport,
                    onExportClick: dataGridAPI.handleExport,
                    onRefreshClick: dataGridAPI.handleRefresh,
                    onCheckboxToggle: dataGridAPI.handleToggleSelectable,
                    autoFocus: autoFocus,
                    toolbarIconVariant: toolbarIconVariant,
                    size: toolbarSize,
                    searchText: viewState.searchText,
                    setSearchText: viewState.setSearchText,
                    searchData: searchData,
                    setSearchData: setSearchData,
                    client: entity?.API.client,
                    FiltersEntity: entity && viewName ? entity?.def.views[viewName].FiltersEntity : undefined,
                    filterValues: viewState.filterValues,
                    setFilterValues: viewState.setFilterValues,
                    filtersDescription: viewState.filtersDescription,
                    setFiltersDescription: viewState.setFiltersDescription,
                    filtersFormSize: filtersFormSize,
                    initialColumnFilters: setInitialFiltersFromColumns && entity ? entity.def.columns : undefined
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($hUms8.Tabs, {
                    pt: "xs",
                    defaultValue: TN.map,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($hUms8.Tabs.List, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                    value: TN.map,
                                    icon: TN.mapIcon,
                                    children: dataMapLabels?.mapTabLabel
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                    value: TN.grid,
                                    icon: TN.gridIcon,
                                    children: dataMapLabels?.gridTabLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                            value: TN.grid,
                            pt: "xs",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($d4aSM.DataMapGrid, {
                                ...effectiveDatagridProps,
                                columnsOverrides: effectiveColumnOverrides,
                                selectedRows: selectedRows,
                                setSelectedRows: setSelectedRows,
                                executeViewState: executeViewState,
                                dataGridAPI: dataGridAPI,
                                viewState: viewState,
                                renderOnlyWhenVisible: renderOnlyWhenVisible,
                                gridHeight: mapHeight,
                                formMode: effectiveDatagridProps.parentFormAPI?.formMode
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                            value: TN.map,
                            pt: "xs",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                                spacing: "sm",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($j8hoz.DataGridActionsToolbar, {
                                        ...labels,
                                        size: toolbarSize,
                                        viewName: viewName,
                                        onAddClick: dataGridAPI.handleAddClick,
                                        onEditClick: dataGridAPI.handleEditClick,
                                        onDeleteClick: dataGridAPI.handleDeleteClick,
                                        onViewClick: dataGridAPI.handleViewClick,
                                        enableAdd: enableAdd,
                                        enableEdit: enableEdit,
                                        enableDelete: enableDelete,
                                        enableView: enableView,
                                        actionsButtonVariant: actionsButtonVariant,
                                        clientActions: entity ? entity.def.clientActions : {},
                                        handleExecuteAction: dataGridAPI.handleExecuteAction,
                                        showActions: showActions,
                                        parentFormMode: effectiveDatagridProps.parentFormAPI?.formMode
                                    }),
                                    mapReady && placesReady && geocoderReady && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                        children: [
                                            (isLoading || executeViewState.loading) && markers.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {
                                                size: "xs"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($jsiDH.GoogleMapsInfoWindow, {
                                                container: infoWindowContentRef.current,
                                                infoWindowContent: infoWindowContent
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($9UpIY.GoogleMapCluster, {
                                                style: {
                                                    height: mapHeight === 'auto' ? '50vh' : mapHeight
                                                },
                                                mapOptions: currentMapOptions,
                                                infoWindowContentRef: infoWindowContentRef,
                                                setInfoWindowContent: setInfoWindowContent,
                                                markers: markers,
                                                selectedMarkers: selectedMarkers
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                        children: [
                                            executeViewState && !executeViewState.error && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                                        fz: "sm",
                                                        children: labels?.limitLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($3wLgJ.Select, {
                                                        size: "xs",
                                                        sx: {
                                                            maxWidth: '7rem'
                                                        },
                                                        data: (0, $43s6t.DataViewLimitData)(labels.rowsLabel, labels.unlimitedLabel),
                                                        value: viewState.limitRows,
                                                        onChange: viewState.setLimitRows
                                                    })
                                                ]
                                            }),
                                            rows && /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                                fz: "xs",
                                                c: "dimmed",
                                                children: [
                                                    labels?.rowsReturnedLabel,
                                                    " ",
                                                    rows.length,
                                                    dataGridAPI.selectedRowsCount ? /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                                        children: [
                                                            ", ",
                                                            dataGridAPI.selectedRowsCount,
                                                            " ",
                                                            labels?.selectedRowsLabel
                                                        ]
                                                    }) : ""
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("d4aSM", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataMapGrid", function() {
        return $d0b5696b25174a70$export$c945886e1972f43d;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $i27OQ = $305cacda61daafb0$var$parcelRequire("i27OQ");
    $305cacda61daafb0$var$parcelRequire("2Qb3Q");
    var $kjFvY = $305cacda61daafb0$var$parcelRequire("kjFvY");
    var $j8hoz = $305cacda61daafb0$var$parcelRequire("j8hoz");
    $305cacda61daafb0$var$parcelRequire("ccjva");
    var $43s6t = $305cacda61daafb0$var$parcelRequire("43s6t");
    $305cacda61daafb0$var$parcelRequire("h79wh");
    var $5rexx = $305cacda61daafb0$var$parcelRequire("5rexx");
    const $d0b5696b25174a70$export$aca62a96e1bbe4fa = $kjFvY.DataGridDefaultProps;
    function $d0b5696b25174a70$export$c945886e1972f43d(props) {
        const { labels: labels, toolbarSize: toolbarSize, viewName: viewName, preserveSelection: preserveSelection, autoSelectFirstRow: autoSelectFirstRow, selectionMode: selectionMode, columnBorders: columnBorders, autoSizeColumnsOnLoad: autoSizeColumnsOnLoad, rowBorders: rowBorders, withBorder: withBorder, columnsOverrides: columnsOverrides, selectedRows: selectedRows, setSelectedRows: setSelectedRows, enableAdd: enableAdd, enableDelete: enableDelete, enableEdit: enableEdit, enableView: enableView, actionsButtonVariant: actionsButtonVariant, showActions: showActions, entity: entity, renderOnlyWhenVisible: renderOnlyWhenVisible, gridHeight: gridHeight, executeViewState: executeViewState, dataGridAPI: dataGridAPI, viewState: viewState, formMode: formMode } = (0, $64A2P.useComponentDefaultProps)('DataMapGrid', $d0b5696b25174a70$export$aca62a96e1bbe4fa, props);
        const visibilityDivRef = (0, $acw62.useRef)(null);
        const isFirstVisible = (0, $i27OQ.useFirstVisible)(visibilityDivRef);
        const { columns: columns, rows: rows, isLoading: isLoading } = dataGridAPI;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: renderOnlyWhenVisible && isFirstVisible === false ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                ref: visibilityDivRef,
                style: {
                    height: gridHeight
                }
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($j8hoz.DataGridActionsToolbar, {
                        ...labels,
                        size: toolbarSize,
                        viewName: viewName,
                        onAddClick: dataGridAPI.handleAddClick,
                        onEditClick: dataGridAPI.handleEditClick,
                        onDeleteClick: dataGridAPI.handleDeleteClick,
                        onViewClick: dataGridAPI.handleViewClick,
                        enableAdd: enableAdd,
                        enableEdit: enableEdit,
                        enableDelete: enableDelete,
                        enableView: enableView,
                        actionsButtonVariant: actionsButtonVariant,
                        clientActions: entity?.def.clientActions ?? {},
                        handleExecuteAction: dataGridAPI.handleExecuteAction,
                        showActions: showActions,
                        parentFormMode: formMode
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($hiiR1.Box, {
                        pos: "relative",
                        mt: "sm",
                        mb: "sm",
                        children: [
                            (isLoading || executeViewState.loading) && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {
                                pos: "absolute",
                                style: {
                                    top: 0,
                                    width: "100%"
                                },
                                size: "xs"
                            }),
                            !isLoading && !executeViewState.loading && executeViewState.error && /*#__PURE__*/ (0, $ayMG0.jsxs)($d50o9.AlertError, {
                                mb: "xs",
                                children: [
                                    "Error: ",
                                    executeViewState.error.status,
                                    " ",
                                    executeViewState.error.message,
                                    " ",
                                    executeViewState.error.statusMessage
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($5rexx.Grid, {
                                columns: columns,
                                rows: rows,
                                onDoubleClick: dataGridAPI.handleDoubleClick,
                                gridHeight: gridHeight === 'auto' ? '50vh' : gridHeight,
                                preserveSelection: preserveSelection,
                                onSelectionChanged: dataGridAPI.handleSelectionChanged,
                                showSelectCheckbox: dataGridAPI.showSelectCheckbox,
                                autoSelectFirstRow: autoSelectFirstRow,
                                selectionMode: selectionMode,
                                columnBorders: columnBorders,
                                autoSizeColumnsOnLoad: autoSizeColumnsOnLoad,
                                rowBorders: rowBorders,
                                withBorder: withBorder,
                                columnsOverrides: columnsOverrides,
                                selectedRows: selectedRows,
                                setSelectedRows: setSelectedRows,
                                timeZoneOffset: entity?.API.client.TIMEZONE_OFFSET
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        children: [
                            executeViewState && !executeViewState.error && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        fz: "sm",
                                        children: labels?.limitLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($3wLgJ.Select, {
                                        size: "xs",
                                        sx: {
                                            maxWidth: '7rem'
                                        },
                                        data: (0, $43s6t.DataViewLimitData)(labels.rowsLabel, labels.unlimitedLabel),
                                        value: viewState.limitRows,
                                        onChange: viewState.setLimitRows
                                    })
                                ]
                            }),
                            rows && /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                fz: "xs",
                                c: "dimmed",
                                children: [
                                    labels?.rowsReturnedLabel,
                                    " ",
                                    rows.length,
                                    dataGridAPI.selectedRowsCount ? /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                        children: [
                                            ", ",
                                            dataGridAPI.selectedRowsCount,
                                            " ",
                                            labels?.selectedRowsLabel
                                        ]
                                    }) : ""
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("5BXjy", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerDefaultShadowStyle", function() {
        return $7889a2bf0e3cae53$export$8db94a67a117b87;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerDefaultSelectedStyle", function() {
        return $7889a2bf0e3cae53$export$9b4762da4d41bf41;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerCircleFilledSVGIcon", function() {
        return $7889a2bf0e3cae53$export$527cf847784b8db6;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerCircleCheckedSVGIcon", function() {
        return $7889a2bf0e3cae53$export$594817257100c72f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerDefaultSelectedSVGIcon", function() {
        return $7889a2bf0e3cae53$export$a728ccd4b021c10a;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerDefaultSVGIcon", function() {
        return $7889a2bf0e3cae53$export$d57c3b94b71bbc0f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerDefaultFillColor", function() {
        return $7889a2bf0e3cae53$export$83fbaf0b74e05935;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerDefaultFillOpacity", function() {
        return $7889a2bf0e3cae53$export$4ab1c49dddfbdfbd;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerGroupDefaultSVGIcon", function() {
        return $7889a2bf0e3cae53$export$a72910ff7085fc09;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerGroupDefaultFillColor", function() {
        return $7889a2bf0e3cae53$export$7ac0c12b8154b835;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MapMarkerGroupDefaultLabelOrigin", function() {
        return $7889a2bf0e3cae53$export$bbdac0b11e8cc3c8;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useCreateMarkerOptions", function() {
        return $7889a2bf0e3cae53$export$4db74f6ff89223a6;
    });
    var $efRWI = $305cacda61daafb0$var$parcelRequire("efRWI");
    var $g7KlS = $305cacda61daafb0$var$parcelRequire("g7KlS");
    const $7889a2bf0e3cae53$export$8db94a67a117b87 = "-webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7)); filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));";
    const $7889a2bf0e3cae53$export$9b4762da4d41bf41 = "-webkit-filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, .8)); filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, .8));";
    const $7889a2bf0e3cae53$export$527cf847784b8db6 = `<svg  xmlns="http://www.w3.org/2000/svg" style="${$g7KlS.MarkerSVGConverterStyleTAG}${$g7KlS.MarkerSVGConverterSelectedStyleTAG}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${$g7KlS.MarkerSVGConverterFillColorTAG}"  class="icon icon-tabler icons-tabler-filled icon-tabler-circle"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z" /></svg>`;
    const $7889a2bf0e3cae53$export$594817257100c72f = `<svg  xmlns="http://www.w3.org/2000/svg" style="${$g7KlS.MarkerSVGConverterStyleTAG}${$g7KlS.MarkerSVGConverterSelectedStyleTAG}" width="24"  height="24"  viewBox="0 0 24 24"  fill="${$g7KlS.MarkerSVGConverterFillColorTAG}"  class="icon icon-tabler icons-tabler-filled icon-tabler-circle-check"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z" /></svg>`;
    const $7889a2bf0e3cae53$export$a728ccd4b021c10a = $7889a2bf0e3cae53$export$527cf847784b8db6;
    const $7889a2bf0e3cae53$export$d57c3b94b71bbc0f = `<svg xmlns="http://www.w3.org/2000/svg" style="${$g7KlS.MarkerSVGConverterStyleTAG}${$g7KlS.MarkerSVGConverterSelectedStyleTAG}" width="24" height="24" viewBox="0 0 24 24" fill="${$g7KlS.MarkerSVGConverterFillColorTAG}" fill-opacity="${$g7KlS.MarkerSVGConverterFillOpacityTAG}" class="icon icon-tabler icons-tabler-filled icon-tabler-map-pin"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z" /></svg>`;
    const $7889a2bf0e3cae53$export$83fbaf0b74e05935 = '#1e72c1';
    const $7889a2bf0e3cae53$export$4ab1c49dddfbdfbd = .7;
    const $7889a2bf0e3cae53$export$a72910ff7085fc09 = `<svg  xmlns="http://www.w3.org/2000/svg" style="${$g7KlS.MarkerSVGConverterStyleTAG}${$g7KlS.MarkerSVGConverterSelectedStyleTAG}" width="24"  height="24"  viewBox="0 0 24 24" fill="${$g7KlS.MarkerSVGConverterFillColorTAG}" fill-opacity="${$g7KlS.MarkerSVGConverterFillOpacityTAG}" class="icon icon-tabler icons-tabler-filled icon-tabler-hexagon"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10.425 1.414l-6.775 3.996a3.21 3.21 0 0 0 -1.65 2.807v7.285a3.226 3.226 0 0 0 1.678 2.826l6.695 4.237c1.034 .57 2.22 .57 3.2 .032l6.804 -4.302c.98 -.537 1.623 -1.618 1.623 -2.793v-7.284l-.005 -.204a3.223 3.223 0 0 0 -1.284 -2.39l-.107 -.075l-.007 -.007a1.074 1.074 0 0 0 -.181 -.133l-6.776 -3.995a3.33 3.33 0 0 0 -3.216 0z" /></svg>`;
    const $7889a2bf0e3cae53$export$7ac0c12b8154b835 = 'red';
    const $7889a2bf0e3cae53$export$bbdac0b11e8cc3c8 = {
        x: 20,
        y: 19
    };
    function $7889a2bf0e3cae53$export$4db74f6ff89223a6() {
        const svgConverter = (0, $g7KlS.useGoogleMarkerSVGConvertToURL)();
        const createMarkerOptions = (0, $acw62.useCallback)((props)=>{
            const { svgIcon: svgIcon, fillColor: fillColor, strokeColor: strokeColor, fillOpacity: fillOpacity, position: position, assignColorByValue: assignColorByValue, title: title, label: label, labelOrigin: labelOrigin, styles: styles, selectedSvgIcon: selectedSvgIcon, selectedFillColor: selectedFillColor, selectedStrokeColor: selectedStrokeColor, selectedFillOpacity: selectedFillOpacity, selectedStyles: selectedStyles, selectedLabel: selectedLabel, selectedLabelOrigin: selectedLabelOrigin, isMapCenter: isMapCenter } = props;
            const markerOptions = {
                position: position,
                title: title
            };
            let newFillColor = fillColor ?? $7889a2bf0e3cae53$export$83fbaf0b74e05935;
            if (assignColorByValue) newFillColor = (0, $efRWI.stringToColor)(assignColorByValue);
            const icon = svgConverter(svgIcon ? svgIcon : $7889a2bf0e3cae53$export$d57c3b94b71bbc0f, newFillColor, strokeColor, fillOpacity ? fillOpacity : $7889a2bf0e3cae53$export$4ab1c49dddfbdfbd, styles ?? $7889a2bf0e3cae53$export$8db94a67a117b87, '');
            // This is to render correctly svg icons with styles
            markerOptions.optimized = false;
            markerOptions.icon = {
                url: icon.url,
                scaledSize: new google.maps.Size(40, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(20, 40)
            };
            if (label) {
                if (assignColorByValue) label.color = (0, $efRWI.stringToColorLabel)(assignColorByValue);
                markerOptions.label = label;
            }
            if (labelOrigin) markerOptions.icon.labelOrigin = labelOrigin;
            const selectedMarkerOptions = {
                ...markerOptions
            };
            delete selectedMarkerOptions.label;
            const selectedIcon = svgConverter(selectedSvgIcon ?? $7889a2bf0e3cae53$export$a728ccd4b021c10a ?? svgIcon ?? $7889a2bf0e3cae53$export$d57c3b94b71bbc0f, selectedFillColor ?? newFillColor, selectedStrokeColor ?? strokeColor, selectedFillOpacity ?? fillOpacity ?? $7889a2bf0e3cae53$export$4ab1c49dddfbdfbd, '', selectedStyles ?? $7889a2bf0e3cae53$export$9b4762da4d41bf41);
            selectedMarkerOptions.icon = {
                url: selectedIcon.url,
                scaledSize: new google.maps.Size(40, 40),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(20, 40)
            };
            if (selectedLabel) selectedMarkerOptions.label = label;
            if (selectedLabelOrigin) selectedMarkerOptions.icon.labelOrigin = labelOrigin;
            return {
                markerOptions: markerOptions,
                selectedMarkerOptions: selectedMarkerOptions,
                isMapCenter: isMapCenter
            };
        }, [
            svgConverter
        ]);
        return createMarkerOptions;
    }
});
$305cacda61daafb0$var$parcelRegister("efRWI", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "hexToRgb", function() {
        return $69b47501534cd200$export$5a544e13ad4e1fa5;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "rgbToHex", function() {
        return $69b47501534cd200$export$34d09c4a771c46ef;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "interpolateColor", function() {
        return $69b47501534cd200$export$5931e35698b46017;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "stringToColor", function() {
        return $69b47501534cd200$export$bdfef6425db7c64;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "stringToColorLabel", function() {
        return $69b47501534cd200$export$d0957ea2c7ee4e27;
    });
    /**
 * Converts a hexadecimal color string to an RGB array.
 * @param hex - The hexadecimal color string.
 * @returns The RGB array.
 */ function $69b47501534cd200$export$5a544e13ad4e1fa5(hex) {
        const bigint = parseInt(hex.slice(1), 16);
        const r = bigint >> 16 & 255;
        const g = bigint >> 8 & 255;
        const b = bigint & 255;
        return [
            r,
            g,
            b
        ];
    }
    function $69b47501534cd200$export$34d09c4a771c46ef(r, g, b) {
        return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    function $69b47501534cd200$export$5931e35698b46017(color1, color2, factor) {
        const [r1, g1, b1] = $69b47501534cd200$export$5a544e13ad4e1fa5(color1);
        const [r2, g2, b2] = $69b47501534cd200$export$5a544e13ad4e1fa5(color2);
        const r = Math.round(r1 + factor * (r2 - r1));
        const g = Math.round(g1 + factor * (g2 - g1));
        const b = Math.round(b1 + factor * (b2 - b1));
        return $69b47501534cd200$export$34d09c4a771c46ef(r, g, b);
    }
    function $69b47501534cd200$export$bdfef6425db7c64(str) {
        // (DJB2)
        let hash = 5381;
        for(let i = 0; i < str.length; i++)hash = hash * 33 ^ str.charCodeAt(i);
        let color = '#';
        for(let i = 0; i < 3; i++){
            const value = hash >> i * 8 & 0xFF;
            color += ('00' + value.toString(16)).slice(-2);
        }
        return color;
    }
    function $69b47501534cd200$export$d0957ea2c7ee4e27(str) {
        // Generate background color from string
        const bgColor = $69b47501534cd200$export$bdfef6425db7c64(str);
        // Convert hex background color to RGB
        const [r, g, b] = $69b47501534cd200$export$5a544e13ad4e1fa5(bgColor);
        // Calculate brightness using the YIQ formula
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        // Return white or black label color based on brightness
        return brightness > 128 ? '#000000' : '#FFFFFF';
    }
});
$305cacda61daafb0$var$parcelRegister("g7KlS", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MarkerSVGConverterFillColorTAG", function() {
        return $9e371710802d527b$export$6cc3417e79cea034;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MarkerSVGConverterStrokeColorTAG", function() {
        return $9e371710802d527b$export$9fdcc128e6ecfd40;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MarkerSVGConverterFillOpacityTAG", function() {
        return $9e371710802d527b$export$705080996831b295;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MarkerSVGConverterStyleTAG", function() {
        return $9e371710802d527b$export$bf94ffca64b29c41;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MarkerSVGConverterSelectedStyleTAG", function() {
        return $9e371710802d527b$export$130a010ec4fb72b4;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useGoogleMarkerSVGConvertToURL", function() {
        return $9e371710802d527b$export$8fdcc68c74d15ecc;
    });
    const $9e371710802d527b$export$6cc3417e79cea034 = '{FILL_COLOR}';
    const $9e371710802d527b$export$9fdcc128e6ecfd40 = '{STROKE_COLOR}';
    const $9e371710802d527b$export$705080996831b295 = '{FILL_OPACITY}';
    const $9e371710802d527b$export$bf94ffca64b29c41 = '{STYLES}';
    const $9e371710802d527b$export$130a010ec4fb72b4 = '{SELECTED_STYLE}';
    function $9e371710802d527b$export$8fdcc68c74d15ecc() {
        const colorsRegex = (0, $acw62.useMemo)(()=>{
            const fillRegex = new RegExp($9e371710802d527b$export$6cc3417e79cea034, 'g');
            const strokeRegex = new RegExp($9e371710802d527b$export$9fdcc128e6ecfd40, 'g');
            const fillOpacityRegex = new RegExp($9e371710802d527b$export$705080996831b295, 'g');
            const styleRegex = new RegExp($9e371710802d527b$export$bf94ffca64b29c41, 'g');
            const selectedStyleRegex = new RegExp($9e371710802d527b$export$130a010ec4fb72b4, 'g');
            return {
                fillRegex: fillRegex,
                strokeRegex: strokeRegex,
                fillOpacityRegex: fillOpacityRegex,
                styleRegex: styleRegex,
                selectedStyleRegex: selectedStyleRegex
            };
        }, []);
        const convertToURL = (0, $acw62.useCallback)((svgImage, fillColor, strokeColor, fillOpacity, styles, selectedStyle)=>{
            if (!svgImage) return {
                icon: svgImage
            };
            // replace image tags
            let icon = svgImage;
            icon = icon.replace(colorsRegex.fillRegex, fillColor ?? '');
            icon = icon.replace(colorsRegex.strokeRegex, strokeColor ?? '');
            icon = icon.replace(colorsRegex.fillOpacityRegex, (fillOpacity ?? 1).toString());
            icon = icon.replace(colorsRegex.styleRegex, styles ?? '');
            icon = icon.replace(colorsRegex.selectedStyleRegex, selectedStyle ?? '');
            const url = `data:image/svg+xml;base64,${btoa(icon)}`;
            return {
                icon: icon,
                url: url
            };
        }, [
            colorsRegex
        ]);
        return convertToURL;
    }
});
$305cacda61daafb0$var$parcelRegister("issJt", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useRecordGroupManager", function() {
        return $df77bca2956c5aa1$export$362fc4abc102b456;
    });
    function $df77bca2956c5aa1$export$362fc4abc102b456() {
        const locationGroups = (0, $acw62.useRef)([]);
        const locationMap = (0, $acw62.useRef)(new Map());
        const addRecordToGroup = (0, $acw62.useCallback)((location1, recordIndex, recordValue)=>{
            const locationKey = `${location1.lat}_${location1.lng}`;
            let group = locationMap.current.get(locationKey);
            if (!group) {
                group = {
                    locationKey: locationKey,
                    location: location1,
                    records: []
                };
                locationGroups.current.push(group);
                locationMap.current.set(locationKey, group);
            }
            group.records.push({
                recordIndex: recordIndex,
                recordValue: recordValue
            });
            return group;
        }, []);
        const getGroupByLocation = (0, $acw62.useCallback)((location1)=>{
            const locationKey = `${location1.lat}_${location1.lng}`;
            return locationMap.current.get(locationKey);
        }, []);
        const clearAllGroups = (0, $acw62.useCallback)(()=>{
            locationGroups.current = [];
            locationMap.current.clear();
        }, []);
        const clearOneRecordGroups = (0, $acw62.useCallback)(()=>{
            locationGroups.current.forEach((group)=>{
                if (group.records.length === 1) locationMap.current.delete(group.locationKey);
            });
            locationGroups.current = locationGroups.current.filter((group)=>group.records.length > 1);
        }, []);
        const manager = (0, $acw62.useMemo)(()=>({
                locationGroups: locationGroups,
                getGroupByLocation: getGroupByLocation,
                addRecordToGroup: addRecordToGroup,
                clearAllGroups: clearAllGroups,
                clearOneRecordGroups: clearOneRecordGroups
            }), [
            addRecordToGroup,
            clearAllGroups,
            clearOneRecordGroups,
            getGroupByLocation
        ]);
        return manager;
    }
});
$305cacda61daafb0$var$parcelRegister("cfuDa", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataMapPageDefaultProps", function() {
        return $58d47859002d4c11$export$3e582d634f0fa746;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataMapPage", function() {
        return $58d47859002d4c11$export$14e208d9c1a41751;
    });
    var $bB3Sz = $305cacda61daafb0$var$parcelRequire("bB3Sz");
    const $58d47859002d4c11$export$3e582d634f0fa746 = {
        showTitle: true
    };
    function $58d47859002d4c11$export$14e208d9c1a41751(props) {
        const { showTitle: showTitle, entityConstructor: entityConstructor, client: client, formMode: formMode, title: title, icon: icon, helpText: helpText, dataGridProps: dataGridProps, ...others } = (0, $64A2P.useComponentDefaultProps)('DataMapPage', props, $58d47859002d4c11$export$3e582d634f0fa746);
        const theme = (0, $64A2P.useMantineTheme)();
        const entity = (0, $acw62.useRef)(entityConstructor(client));
        const EntityIcon = entity.current.Icon;
        const dgProps = (0, $acw62.useMemo)(()=>{
            const enableAdd = formMode === 'view' ? false : dataGridProps.enableAdd;
            const enableEdit = formMode === 'view' ? false : dataGridProps.enableEdit;
            const enableDelete = formMode === 'view' ? false : dataGridProps.enableDelete;
            return {
                ...dataGridProps,
                entity: entity.current,
                enableAdd: enableAdd,
                enableEdit: enableEdit,
                enableDelete: enableDelete
            };
        }, [
            dataGridProps,
            formMode
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                showTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                    variant: "filled",
                    chevron: /*#__PURE__*/ (0, $ayMG0.jsx)($kytQ3.default, {
                        size: "1.5rem"
                    }),
                    styles: {
                        item: {
                            '&[data-active]': {
                                backgroundColor: "unset"
                            }
                        },
                        label: {
                            paddingBottom: 0,
                            paddingTop: 0
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                        value: entity.current.name,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                icon: icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
                                    children: icon
                                }) : EntityIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(EntityIcon, {
                                        size: "1.3rem"
                                    })
                                }) : undefined,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ew26C.Title, {
                                    order: 2,
                                    children: title ?? entity.current.Title
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                    size: "sm",
                                    children: helpText ?? entity.current.HelpText
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card, {
                    shadow: "sm",
                    withBorder: theme.colorScheme === 'dark' ? false : true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($bB3Sz.DataMap, {
                        dataGridProps: dgProps,
                        ...others
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("eaiZF", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataMapFormDefaultProps", function() {
        return $6d16151700528617$export$c2101af6bc00958e;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataMapForm", function() {
        return $6d16151700528617$export$9f6817a6ef4fa2f5;
    });
    var $bB3Sz = $305cacda61daafb0$var$parcelRequire("bB3Sz");
    const $6d16151700528617$export$c2101af6bc00958e = {
        showTitle: true
    };
    function $6d16151700528617$export$9f6817a6ef4fa2f5(props) {
        const { showTitle: showTitle, formMode: formMode, title: title, icon: icon, helpText: helpText, customTitle: customTitle, dataGridProps: dataGridProps, ...others } = (0, $64A2P.useComponentDefaultProps)('DataMapForm', props, $6d16151700528617$export$c2101af6bc00958e);
        const theme = (0, $64A2P.useMantineTheme)();
        const dgProps = (0, $acw62.useMemo)(()=>{
            const enableAdd = formMode === 'view' ? false : dataGridProps.enableAdd;
            const enableEdit = formMode === 'view' ? false : dataGridProps.enableEdit;
            const enableDelete = formMode === 'view' ? false : dataGridProps.enableDelete;
            return {
                ...dataGridProps,
                enableAdd: enableAdd,
                enableEdit: enableEdit,
                enableDelete: enableDelete
            };
        }, [
            dataGridProps,
            formMode
        ]);
        const { entity: entity } = dgProps;
        const EntityIcon = entity?.Icon;
        const IconNode = icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
            children: icon
        }) : EntityIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(EntityIcon, {
                size: "1rem"
            })
        }) : undefined;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
            shadow: "sm",
            withBorder: theme.colorScheme === 'dark' ? false : true,
            children: [
                showTitle && customTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                    p: "xs",
                    bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                    mb: "1rem",
                    children: customTitle
                }),
                showTitle && !customTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                    p: "xs",
                    bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                    mb: "1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                        variant: "filled",
                        chevron: /*#__PURE__*/ (0, $ayMG0.jsx)($kytQ3.default, {
                            size: "1rem"
                        }),
                        styles: {
                            item: {
                                '&[data-active]': {
                                    backgroundColor: "unset"
                                }
                            },
                            label: {
                                paddingBottom: 0,
                                paddingTop: 0
                            },
                            control: {
                                padding: 0
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                            value: entity?.name ?? 'dmfEntity',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                    icon: IconNode,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        size: "sm",
                                        children: title ?? entity?.Title
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        size: "xs",
                                        children: helpText ?? entity?.HelpText
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($bB3Sz.DataMap, {
                    dataGridProps: dgProps,
                    ...others
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("5QcDe", function(module1, exports) {
    var $iuZPr = $305cacda61daafb0$var$parcelRequire("iuZPr");
    var $ikuyV = $305cacda61daafb0$var$parcelRequire("ikuyV");
    var $aO9ns = $305cacda61daafb0$var$parcelRequire("aO9ns");
    var $9LUPA = $305cacda61daafb0$var$parcelRequire("9LUPA");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $iuZPr);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ikuyV);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $aO9ns);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9LUPA);
});
$305cacda61daafb0$var$parcelRegister("iuZPr", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MultiDataMapDefaultProps", function() {
        return $774fcffcde61c8c8$export$9f3930d9c50fa60;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MultiDataMap", function() {
        return $774fcffcde61c8c8$export$3286bfb3cad90681;
    });
    $305cacda61daafb0$var$parcelRequire("hZjV3");
    var $8ahcP = $305cacda61daafb0$var$parcelRequire("8ahcP");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    var $7B1hX = $305cacda61daafb0$var$parcelRequire("7B1hX");
    $305cacda61daafb0$var$parcelRequire("2Qb3Q");
    var $3vFhj = $305cacda61daafb0$var$parcelRequire("3vFhj");
    $305cacda61daafb0$var$parcelRequire("jddMY");
    var $5BXjy = $305cacda61daafb0$var$parcelRequire("5BXjy");
    var $bB3Sz = $305cacda61daafb0$var$parcelRequire("bB3Sz");
    var $d4aSM = $305cacda61daafb0$var$parcelRequire("d4aSM");
    $305cacda61daafb0$var$parcelRequire("jtOZC");
    var $jQiQb = $305cacda61daafb0$var$parcelRequire("jQiQb");
    var $9UpIY = $305cacda61daafb0$var$parcelRequire("9UpIY");
    var $jsiDH = $305cacda61daafb0$var$parcelRequire("jsiDH");
    var $kf2K3 = $305cacda61daafb0$var$parcelRequire("kf2K3");
    var $ikuyV = $305cacda61daafb0$var$parcelRequire("ikuyV");
    const $774fcffcde61c8c8$export$9f3930d9c50fa60 = {
        dataMapView2: $bB3Sz.DataMapDefaultDataGridProps,
        dataMapView3: $bB3Sz.DataMapDefaultDataGridProps,
        dataMapView4: $bB3Sz.DataMapDefaultDataGridProps,
        dataMapView5: $bB3Sz.DataMapDefaultDataGridProps,
        labels: {
            mapTabLabel: 'Map'
        },
        mapStyle: [
            {
                featureType: 'poi',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            },
            {
                featureType: 'transit',
                stylers: [
                    {
                        visibility: 'off'
                    }
                ]
            }
        ],
        mapOptions: {
            zoom: 10,
            fullscreenControl: true,
            center: $jQiQb.DEFAULT_MAP_CENTER,
            gestureHandling: 'greedy'
        },
        mapHeight: 'auto',
        enableExport: true,
        selectionMode: 'multi',
        search: [],
        limit: "10000",
        toolbarIconVariant: "light",
        filtersFormSize: "md",
        clearSelectionOnActionExecuted: true
    };
    function $774fcffcde61c8c8$export$3286bfb3cad90681(props) {
        const { dataMapView1: dataMapView1, dataMapView2: dataMapView2, dataMapView3: dataMapView3, dataMapView4: dataMapView4, dataMapView5: dataMapView5, labels: dataMapLabels, search: search, limit: limit, enableExport: enableExport, autoFocus: autoFocus, toolbarIconVariant: toolbarIconVariant, toolbarSize: toolbarSize, filtersFormSize: filtersFormSize, selectionMode: selectionMode, mapOptions: mapOptions, mapStyle: mapStyle, mapHeight: mapHeight, centerMarker: centerMarker, clearSelectionOnActionExecuted: clearSelectionOnActionExecuted, formMode: formMode } = (0, $64A2P.useComponentDefaultProps)('MultiDataMap', $774fcffcde61c8c8$export$9f3930d9c50fa60, props);
        const theme = (0, $64A2P.useMantineTheme)();
        // Map
        const googleMapsAPI = (0, $8ahcP.useGoogleMapsAPI)();
        // infoWindow
        const infoWindowContentRef = (0, $acw62.useRef)(document.createElement('div'));
        const [infoWindowContent, setInfoWindowContent] = (0, $acw62.useState)(null);
        const { mapReady: mapReady, placesReady: placesReady, geocoderReady: geocoderReady } = googleMapsAPI;
        const currentMapOptionsRef = (0, $acw62.useRef)({
            ...mapOptions,
            styles: mapStyle
        });
        // Multidatamap selected markers
        const [selectedMarkers, setSelectedMarkers] = (0, $acw62.useState)({});
        // Common grid properties
        //toolbar
        const [searchData, setSearchData] = (0, $acw62.useState)(search?.map((s)=>{
            return {
                value: s,
                label: s
            };
        }));
        // TODO: add support for setInitialFiltersFromColumns
        const viewState = (0, $7B1hX.useViewState)(search, limit);
        // Grids
        // 
        const data1 = (0, $ikuyV.useMultiDataMapGrid)({
            dataMapView: dataMapView1,
            viewState: viewState,
            mapReady: mapReady,
            geocoderReady: geocoderReady,
            placesReady: placesReady,
            clearSelectionOnActionExecuted: clearSelectionOnActionExecuted
        });
        const data2 = (0, $ikuyV.useMultiDataMapGrid)({
            dataMapView: dataMapView2,
            viewState: viewState,
            mapReady: mapReady,
            geocoderReady: geocoderReady,
            placesReady: placesReady,
            clearSelectionOnActionExecuted: clearSelectionOnActionExecuted
        });
        const data3 = (0, $ikuyV.useMultiDataMapGrid)({
            dataMapView: dataMapView3,
            viewState: viewState,
            mapReady: mapReady,
            geocoderReady: geocoderReady,
            placesReady: placesReady,
            clearSelectionOnActionExecuted: clearSelectionOnActionExecuted
        });
        const data4 = (0, $ikuyV.useMultiDataMapGrid)({
            dataMapView: dataMapView4,
            viewState: viewState,
            mapReady: mapReady,
            geocoderReady: geocoderReady,
            placesReady: placesReady,
            clearSelectionOnActionExecuted: clearSelectionOnActionExecuted
        });
        const data5 = (0, $ikuyV.useMultiDataMapGrid)({
            dataMapView: dataMapView5,
            viewState: viewState,
            mapReady: mapReady,
            geocoderReady: geocoderReady,
            placesReady: placesReady,
            clearSelectionOnActionExecuted: clearSelectionOnActionExecuted
        });
        const IconData1 = data1.dgProps.tabIcon ?? data1.dgProps.entity?.Icon;
        const IconData2 = data2.dgProps.tabIcon ?? data2.dgProps.entity?.Icon;
        const IconData3 = data3.dgProps.tabIcon ?? data3.dgProps.entity?.Icon;
        const IconData4 = data4.dgProps.tabIcon ?? data4.dgProps.entity?.Icon;
        const IconData5 = data5.dgProps.tabIcon ?? data5.dgProps.entity?.Icon;
        const TN = {
            map: 'mapTab',
            mapIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($8YQDN.default, {
                size: "1rem"
            }),
            tab1: 'mapTab1',
            tab1Icon: IconData1 ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconData1, {
                size: "1rem"
            }) : null,
            tab2: 'mapTab2',
            tab2Icon: IconData2 ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconData2, {
                size: "1rem"
            }) : null,
            tab3: 'mapTab3',
            tab3Icon: IconData3 ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconData3, {
                size: "1rem"
            }) : null,
            tab4: 'mapTab4',
            tab4Icon: IconData4 ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconData4, {
                size: "1rem"
            }) : null,
            tab5: 'mapTab5',
            tab5Icon: IconData5 ? /*#__PURE__*/ (0, $ayMG0.jsx)(IconData5, {
                size: "1rem"
            }) : null
        };
        //
        const handleExport = (0, $acw62.useCallback)(()=>{
            if (data1.dgProps.entity) data1.dataGridAPI.handleExport();
            if (data2.dgProps.entity) data2.dataGridAPI.handleExport();
            if (data3.dgProps.entity) data3.dataGridAPI.handleExport();
            if (data4.dgProps.entity) data4.dataGridAPI.handleExport();
            if (data5.dgProps.entity) data5.dataGridAPI.handleExport();
        }, [
            data1.dataGridAPI,
            data1.dgProps.entity,
            data2.dataGridAPI,
            data2.dgProps.entity,
            data3.dataGridAPI,
            data3.dgProps.entity,
            data4.dataGridAPI,
            data4.dgProps.entity,
            data5.dataGridAPI,
            data5.dgProps.entity
        ]);
        const handleRefresh = (0, $acw62.useCallback)(()=>{
            viewState.setRefresh((prev)=>!prev);
        }, [
            viewState
        ]);
        const handleToggleSelectable = (0, $acw62.useCallback)(()=>{
            if (data1.dgProps.entity) data1.dataGridAPI.handleToggleSelectable();
            if (data2.dgProps.entity) data2.dataGridAPI.handleToggleSelectable();
            if (data3.dgProps.entity) data3.dataGridAPI.handleToggleSelectable();
            if (data4.dgProps.entity) data4.dataGridAPI.handleToggleSelectable();
            if (data5.dgProps.entity) data5.dataGridAPI.handleToggleSelectable();
        }, [
            data1.dataGridAPI,
            data1.dgProps.entity,
            data2.dataGridAPI,
            data2.dgProps.entity,
            data3.dataGridAPI,
            data3.dgProps.entity,
            data4.dataGridAPI,
            data4.dgProps.entity,
            data5.dataGridAPI,
            data5.dgProps.entity
        ]);
        // Effect for currentMapOptions
        (0, $acw62.useEffect)(()=>{
            currentMapOptionsRef.current = {
                ...mapOptions,
                styles: mapStyle
            };
        }, [
            mapOptions,
            mapStyle,
            centerMarker
        ]);
        const getMarkerOptions = (0, $5BXjy.useCreateMarkerOptions)();
        // Join Map Makers from Data1, 2, 3, 4, 5
        const [markers, setMarkers] = (0, $acw62.useState)([]);
        (0, $acw62.useEffect)(()=>{
            const markers1 = data1.markers;
            const markers2 = data2.markers;
            const markers3 = data3.markers;
            const markers4 = data4.markers;
            const markers5 = data5.markers;
            const centerMarkerMarker = [];
            if (centerMarker) {
                const optionsResult = getMarkerOptions(centerMarker);
                const markerOptions = optionsResult.markerOptions;
                const selectedMarkerOptions = optionsResult.selectedMarkerOptions;
                centerMarkerMarker.push({
                    markerOptions: markerOptions,
                    selectedMarkerOptions: selectedMarkerOptions
                });
                currentMapOptionsRef.current.center = markerOptions.position;
            } else if (data1.centerMarker) currentMapOptionsRef.current.center = data1.centerMarker.markerOptions.position;
            else if (data2.centerMarker) currentMapOptionsRef.current.center = data2.centerMarker.markerOptions.position;
            else if (data3.centerMarker) currentMapOptionsRef.current.center = data3.centerMarker.markerOptions.position;
            else if (data4.centerMarker) currentMapOptionsRef.current.center = data4.centerMarker.markerOptions.position;
            else if (data5.centerMarker) currentMapOptionsRef.current.center = data5.centerMarker.markerOptions.position;
            if (!currentMapOptionsRef.current.center) currentMapOptionsRef.current.center = $jQiQb.DEFAULT_MAP_CENTER;
            setMarkers([
                ...markers1,
                ...markers2,
                ...markers3,
                ...markers4,
                ...markers5,
                ...centerMarkerMarker
            ]);
        }, [
            centerMarker,
            data1.markers,
            data2.markers,
            data3.markers,
            data4.markers,
            data5.markers
        ]);
        (0, $acw62.useEffect)(()=>{
            const selectedMarkers1 = data1.selectedMarkers;
            const selectedMarkers2 = data2.selectedMarkers;
            const selectedMarkers3 = data3.selectedMarkers;
            const selectedMarkers4 = data4.selectedMarkers;
            const selectedMarkers5 = data5.selectedMarkers;
            setSelectedMarkers({
                ...selectedMarkers1,
                ...selectedMarkers2,
                ...selectedMarkers3,
                ...selectedMarkers4,
                ...selectedMarkers5
            });
        }, [
            data1.selectedMarkers,
            data2.selectedMarkers,
            data3.selectedMarkers,
            data4.selectedMarkers,
            data5.selectedMarkers
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($3vFhj.DataGridToolbar, {
                    enableExport: enableExport,
                    onExportClick: handleExport,
                    onRefreshClick: handleRefresh,
                    onCheckboxToggle: handleToggleSelectable,
                    autoFocus: autoFocus,
                    toolbarIconVariant: toolbarIconVariant,
                    size: toolbarSize,
                    searchText: viewState.searchText,
                    setSearchText: viewState.setSearchText,
                    searchData: searchData,
                    setSearchData: setSearchData,
                    client: dataMapView1?.entity?.API.client,
                    FiltersEntity: dataMapView1?.entity && dataMapView1?.viewName ? dataMapView1.entity.def.views[dataMapView1.viewName].FiltersEntity : undefined,
                    filterValues: viewState.filterValues,
                    setFilterValues: viewState.setFilterValues,
                    filtersDescription: viewState.filtersDescription,
                    setFiltersDescription: viewState.setFiltersDescription,
                    filtersFormSize: filtersFormSize
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($hUms8.Tabs, {
                    pt: "xs",
                    defaultValue: TN.map,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)($hUms8.Tabs.List, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                    value: TN.map,
                                    icon: TN.mapIcon,
                                    children: dataMapLabels?.mapTabLabel
                                }),
                                data1.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                    value: TN.tab1,
                                    icon: TN.tab1Icon,
                                    children: data1.dgProps.tabLabel ?? data1.dgProps.entity.Title
                                }),
                                data2.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                    value: TN.tab2,
                                    icon: TN.tab2Icon,
                                    children: data2.dgProps.tabLabel ?? data2.dgProps.entity.Title
                                }),
                                data3.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                    value: TN.tab3,
                                    icon: TN.tab3Icon,
                                    children: data3.dgProps.tabLabel ?? data3.dgProps.entity.Title
                                }),
                                data4.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                    value: TN.tab4,
                                    icon: TN.tab4Icon,
                                    children: data4.dgProps.tabLabel ?? data4.dgProps.entity.Title
                                }),
                                data5.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                    value: TN.tab5,
                                    icon: TN.tab5Icon,
                                    children: data5.dgProps.tabLabel ?? data5.dgProps.entity.Title
                                })
                            ]
                        }),
                        data1.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                            value: TN.tab1,
                            pt: "xs",
                            children: /*#__PURE__*/ (0, $acw62.createElement)($d4aSM.DataMapGrid, {
                                ...data1.dgProps,
                                columnsOverrides: data1.actualColumnsOverrides,
                                selectedRows: data1.selectedRows,
                                setSelectedRows: data1.setSelectedRows,
                                executeViewState: data1.executeViewState,
                                dataGridAPI: data1.dataGridAPI,
                                viewState: data1.viewState,
                                gridHeight: mapHeight,
                                selectionMode: selectionMode,
                                key: `dmg${TN.tab1}`,
                                renderOnlyWhenVisible: false,
                                formMode: formMode
                            })
                        }),
                        data2.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                            value: TN.tab2,
                            pt: "xs",
                            children: /*#__PURE__*/ (0, $acw62.createElement)($d4aSM.DataMapGrid, {
                                ...data2.dgProps,
                                columnsOverrides: data2.actualColumnsOverrides,
                                selectedRows: data2.selectedRows,
                                setSelectedRows: data2.setSelectedRows,
                                executeViewState: data2.executeViewState,
                                dataGridAPI: data2.dataGridAPI,
                                viewState: data2.viewState,
                                gridHeight: mapHeight,
                                selectionMode: selectionMode,
                                key: `dmg${TN.tab2}`,
                                renderOnlyWhenVisible: false,
                                formMode: formMode
                            })
                        }),
                        data3.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                            value: TN.tab3,
                            pt: "xs",
                            children: /*#__PURE__*/ (0, $acw62.createElement)($d4aSM.DataMapGrid, {
                                ...data3.dgProps,
                                columnsOverrides: data3.actualColumnsOverrides,
                                selectedRows: data3.selectedRows,
                                setSelectedRows: data3.setSelectedRows,
                                executeViewState: data3.executeViewState,
                                dataGridAPI: data3.dataGridAPI,
                                viewState: data3.viewState,
                                gridHeight: mapHeight,
                                selectionMode: selectionMode,
                                key: `dmg${TN.tab3}`,
                                renderOnlyWhenVisible: false,
                                formMode: formMode
                            })
                        }),
                        data4.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                            value: TN.tab4,
                            pt: "xs",
                            children: /*#__PURE__*/ (0, $acw62.createElement)($d4aSM.DataMapGrid, {
                                ...data4.dgProps,
                                columnsOverrides: data4.actualColumnsOverrides,
                                selectedRows: data4.selectedRows,
                                setSelectedRows: data4.setSelectedRows,
                                executeViewState: data4.executeViewState,
                                dataGridAPI: data4.dataGridAPI,
                                viewState: data4.viewState,
                                gridHeight: mapHeight,
                                selectionMode: selectionMode,
                                key: `dmg${TN.tab4}`,
                                renderOnlyWhenVisible: false,
                                formMode: formMode
                            })
                        }),
                        data5.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                            value: TN.tab5,
                            pt: "xs",
                            children: /*#__PURE__*/ (0, $acw62.createElement)($d4aSM.DataMapGrid, {
                                ...data5.dgProps,
                                columnsOverrides: data5.actualColumnsOverrides,
                                selectedRows: data5.selectedRows,
                                setSelectedRows: data5.setSelectedRows,
                                executeViewState: data5.executeViewState,
                                dataGridAPI: data5.dataGridAPI,
                                viewState: data5.viewState,
                                gridHeight: mapHeight,
                                selectionMode: selectionMode,
                                key: `dmg${TN.tab5}`,
                                renderOnlyWhenVisible: false,
                                formMode: formMode
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                            value: TN.map,
                            pt: "xs",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                                spacing: "sm",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($kf2K3.MultiDataMapActionsToolbar, {
                                        data1: data1,
                                        data2: data2,
                                        data3: data3,
                                        data4: data4,
                                        data5: data5,
                                        parentFormMode: formMode
                                    }),
                                    mapReady && placesReady && geocoderReady && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                                        children: [
                                            (data1.dataGridAPI.isLoading || data1.executeViewState.loading) && markers.length === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {
                                                size: "xs"
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($jsiDH.GoogleMapsInfoWindow, {
                                                container: infoWindowContentRef.current,
                                                infoWindowContent: infoWindowContent
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)($9UpIY.GoogleMapCluster, {
                                                style: {
                                                    height: mapHeight === 'auto' ? '50vh' : mapHeight
                                                },
                                                mapOptions: currentMapOptionsRef.current,
                                                infoWindowContentRef: infoWindowContentRef,
                                                setInfoWindowContent: setInfoWindowContent,
                                                markers: markers,
                                                selectedMarkers: selectedMarkers
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("kf2K3", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MultiDataMapActionsToolbar", function() {
        return $88a65fc4edf1c7fa$export$5e3b704eab811f8f;
    });
    var $TMsro = $305cacda61daafb0$var$parcelRequire("TMsro");
    const $88a65fc4edf1c7fa$export$6de953dc5228f78f = {
        showMapConfig: true,
        configMenuTitle: 'Map Config',
        size: "sm",
        toolbarIconVariant: "light",
        actionsButtonVariant: "light"
    };
    function $88a65fc4edf1c7fa$export$5e3b704eab811f8f(props) {
        const { showMapConfig: showMapConfig, data1: data1, data2: data2, data3: data3, data4: data4, data5: data5, configMenuTitle: configMenuTitle, size: size, toolbarIconVariant: toolbarIconVariant, parentFormMode: parentFormMode, actionsButtonVariant: actionsButtonVariant } = (0, $64A2P.useComponentDefaultProps)('MultiDataMapActionsToolbar', $88a65fc4edf1c7fa$export$6de953dc5228f78f, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const { buttonsSize: buttonsSize, actionIconSize: actionIconSize, iconsSize: iconsSize } = (0, $TMsro.getToolbarSizes)(size);
        const actionElements = (0, $acw62.useRef)([]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($hiiR1.Box, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                children: [
                    data1?.showOnMap && data1.dgProps.entity && data1.dgProps.showActions && data1.dgProps.entity.def.clientActions && Object.values(data1.dgProps.entity.def.clientActions).map((action, index)=>{
                        if (parentFormMode === 'view' && !action.showActionInViewMode) return null;
                        if (data1.dgProps.viewName && action.views && !action.views.includes(data1.dgProps.viewName)) return null;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            leftIcon: action.icon,
                            ref: (el)=>actionElements.current[index] = el,
                            size: buttonsSize,
                            variant: actionsButtonVariant,
                            onClick: ()=>data1.dataGridAPI.handleExecuteAction(action, undefined, actionElements.current[index] ?? undefined),
                            children: action.label
                        }, action.name);
                    }),
                    data2?.showOnMap && data2.dgProps.entity && data2.dgProps.showActions && data2.dgProps.entity.def.clientActions && Object.values(data2.dgProps.entity.def.clientActions).map((action, index)=>{
                        if (parentFormMode === 'view' && !action.showActionInViewMode) return null;
                        if (data2.dgProps.viewName && action.views && !action.views.includes(data2.dgProps.viewName)) return null;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            leftIcon: action.icon,
                            ref: (el)=>actionElements.current[index] = el,
                            size: buttonsSize,
                            variant: actionsButtonVariant,
                            onClick: ()=>data2.dataGridAPI.handleExecuteAction(action, undefined, actionElements.current[index] ?? undefined),
                            children: action.label
                        }, action.name);
                    }),
                    data3?.showOnMap && data3.dgProps.entity && data3.dgProps.showActions && data3.dgProps.entity.def.clientActions && Object.values(data3.dgProps.entity.def.clientActions).map((action, index)=>{
                        if (parentFormMode === 'view' && !action.showActionInViewMode) return null;
                        if (data3.dgProps.viewName && action.views && !action.views.includes(data3.dgProps.viewName)) return null;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            leftIcon: action.icon,
                            ref: (el)=>actionElements.current[index] = el,
                            size: buttonsSize,
                            variant: actionsButtonVariant,
                            onClick: ()=>data3.dataGridAPI.handleExecuteAction(action, undefined, actionElements.current[index] ?? undefined),
                            children: action.label
                        }, action.name);
                    }),
                    data4?.showOnMap && data4.dgProps.entity && data4.dgProps.showActions && data4.dgProps.entity.def.clientActions && Object.values(data4.dgProps.entity.def.clientActions).map((action, index)=>{
                        if (parentFormMode === 'view' && !action.showActionInViewMode) return null;
                        if (data4.dgProps.viewName && action.views && !action.views.includes(data4.dgProps.viewName)) return null;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            leftIcon: action.icon,
                            ref: (el)=>actionElements.current[index] = el,
                            size: buttonsSize,
                            variant: actionsButtonVariant,
                            onClick: ()=>data4.dataGridAPI.handleExecuteAction(action, undefined, actionElements.current[index] ?? undefined),
                            children: action.label
                        }, action.name);
                    }),
                    data5?.showOnMap && data5.dgProps.entity && data5.dgProps.showActions && data5.dgProps.entity.def.clientActions && Object.values(data5.dgProps.entity.def.clientActions).map((action, index)=>{
                        if (parentFormMode === 'view' && !action.showActionInViewMode) return null;
                        if (data5.dgProps.viewName && action.views && !action.views.includes(data5.dgProps.viewName)) return null;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                            leftIcon: action.icon,
                            ref: (el)=>actionElements.current[index] = el,
                            size: buttonsSize,
                            variant: actionsButtonVariant,
                            onClick: ()=>data5.dataGridAPI.handleExecuteAction(action, undefined, actionElements.current[index] ?? undefined),
                            children: action.label
                        }, action.name);
                    }),
                    showMapConfig && /*#__PURE__*/ (0, $ayMG0.jsxs)($aUqRb.Menu, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($aUqRb.Menu.Target, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                    title: configMenuTitle,
                                    ml: "auto",
                                    size: actionIconSize,
                                    radius: "xl",
                                    color: theme.primaryColor,
                                    variant: toolbarIconVariant,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($g12Xg.default, {
                                        size: iconsSize,
                                        stroke: "1.5"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($aUqRb.Menu.Dropdown, {
                                children: [
                                    data1?.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($aUqRb.Menu.Item, {
                                        icon: data1.showOnMap ? /*#__PURE__*/ (0, $ayMG0.jsx)($jni2H.default, {
                                            size: "1rem"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($cYYbE.default, {
                                            size: "1rem"
                                        }),
                                        onClick: ()=>data1.setShowOnMap((prev)=>prev = !prev),
                                        children: data1.dgProps.tabLabel
                                    }),
                                    data2?.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($aUqRb.Menu.Item, {
                                        icon: data2.showOnMap ? /*#__PURE__*/ (0, $ayMG0.jsx)($jni2H.default, {
                                            size: "1rem"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($cYYbE.default, {
                                            size: "1rem"
                                        }),
                                        onClick: ()=>data2.setShowOnMap((prev)=>prev = !prev),
                                        children: data2.dgProps.tabLabel
                                    }),
                                    data3?.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($aUqRb.Menu.Item, {
                                        icon: data3.showOnMap ? /*#__PURE__*/ (0, $ayMG0.jsx)($jni2H.default, {
                                            size: "1rem"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($cYYbE.default, {
                                            size: "1rem"
                                        }),
                                        onClick: ()=>data3.setShowOnMap((prev)=>prev = !prev),
                                        children: data3.dgProps.tabLabel
                                    }),
                                    data4?.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($aUqRb.Menu.Item, {
                                        icon: data4.showOnMap ? /*#__PURE__*/ (0, $ayMG0.jsx)($jni2H.default, {
                                            size: "1rem"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($cYYbE.default, {
                                            size: "1rem"
                                        }),
                                        onClick: ()=>data4.setShowOnMap((prev)=>prev = !prev),
                                        children: data4.dgProps.tabLabel
                                    }),
                                    data5?.dgProps.entity && /*#__PURE__*/ (0, $ayMG0.jsx)($aUqRb.Menu.Item, {
                                        icon: data5.showOnMap ? /*#__PURE__*/ (0, $ayMG0.jsx)($jni2H.default, {
                                            size: "1rem"
                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($cYYbE.default, {
                                            size: "1rem"
                                        }),
                                        onClick: ()=>data5.setShowOnMap((prev)=>prev = !prev),
                                        children: data5.dgProps.tabLabel
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("ikuyV", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useMultiDataMapGrid", function() {
        return $bfa5f5ff8cf7cd35$export$6c81732667566494;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $lB8CV = $305cacda61daafb0$var$parcelRequire("lB8CV");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    var $5JIrZ = $305cacda61daafb0$var$parcelRequire("5JIrZ");
    var $bB3Sz = $305cacda61daafb0$var$parcelRequire("bB3Sz");
    var $5BXjy = $305cacda61daafb0$var$parcelRequire("5BXjy");
    var $issJt = $305cacda61daafb0$var$parcelRequire("issJt");
    $305cacda61daafb0$var$parcelRequire("jtOZC");
    var $9UpIY = $305cacda61daafb0$var$parcelRequire("9UpIY");
    function $bfa5f5ff8cf7cd35$export$6c81732667566494({ dataMapView: dataMapView, viewState: viewState, selectionMode: selectionMode, mapReady: mapReady, placesReady: placesReady, geocoderReady: geocoderReady, clearSelectionOnActionExecuted: clearSelectionOnActionExecuted }) {
        const theme = (0, $64A2P.useMantineTheme)();
        const modal = (0, $k7qj2.useModal)();
        const [selectedRows, setSelectedRows] = (0, $acw62.useState)([]);
        const [selectedMarkers, setSelectedMarkers] = (0, $acw62.useState)({});
        const [showOnMap, setShowOnMap] = (0, $acw62.useState)(true);
        const defaultProps = (0, $64A2P.useComponentDefaultProps)('MultiDataMapView', $bB3Sz.DataMapDefaultDataGridProps, dataMapView);
        // Handler for clearingSelection after executing an action
        const handleActionExecuted = (0, $acw62.useCallback)((actionName, result)=>{
            if (defaultProps.onActionExecuted) defaultProps.onActionExecuted(actionName, result);
            if (clearSelectionOnActionExecuted) {
                if (result) setSelectedRows([]);
            }
        }, [
            clearSelectionOnActionExecuted,
            defaultProps
        ]);
        const dgProps = (0, $acw62.useMemo)(()=>({
                ...defaultProps,
                onActionExecuted: handleActionExecuted,
                selectionMode: selectionMode || 'multi'
            }), [
            defaultProps,
            handleActionExecuted,
            selectionMode
        ]);
        const { entity: entity, viewName: viewName, columnsOverrides: columnsOverrides, latitudRecordIndex: latitudRecordIndex, longitudRecordIndex: longitudRecordIndex, markerRenderer: markerRenderer, InfoWindowRenderer: InfoWindowRenderer, groupMarkerRenderer: groupMarkerRenderer, selectRecordsRenderer: selectRecordsRenderer, parentKeys: parentKeys, centerMarkerColumnIndex: centerMarkerColumnIndex } = dgProps;
        const groupManager = (0, $issJt.useRecordGroupManager)();
        const { searchText: searchText, limitRows: limitRows, refresh: refresh, filterValues: filterValues } = viewState;
        const executeViewState = (0, $lB8CV.useExecuteView)(entity, parentKeys, viewName, searchText, limitRows, refresh, filterValues);
        const dataGridAPI = (0, $5JIrZ.useDataGrid)(dgProps, {
            executeViewState: executeViewState,
            setRefresh: viewState.setRefresh,
            setSearchText: viewState.setSearchText
        });
        const actualColumnsOverrides = (0, $acw62.useMemo)(()=>{
            if (!entity || !viewName) {
                if (!viewName && entity) console.warn(`MultiDataMapView: viewName not specified for ${entity?.name}`);
                return undefined;
            }
            return columnsOverrides ? columnsOverrides : entity.def.views[viewName].gridColumnsOverrides?.(theme);
        }, [
            columnsOverrides,
            entity,
            theme,
            viewName
        ]);
        const getMarkerOptions = (0, $5BXjy.useCreateMarkerOptions)();
        // Default selected records renderer
        const DefaultSelectRecordsRenderer = (0, $acw62.useCallback)((record, recordIndex, position, groupManager, infoWindow, UIAPI, theme)=>{
            if (recordIndex === undefined || recordIndex === null) return;
            setSelectedRows((prevSelectedRows)=>{
                const recid = recordIndex + 1;
                const isAlreadySelected = prevSelectedRows.some((row)=>row.recid === recid);
                if (isAlreadySelected) return prevSelectedRows.filter((row)=>row.recid !== recid);
                else return [
                    ...prevSelectedRows,
                    {
                        ...record,
                        recid: recid
                    }
                ];
            });
            return null;
        }, [
            setSelectedRows
        ]);
        // Click handler for selection and Infowindow
        const actualInfoWindowRenderer = (0, $acw62.useMemo)(()=>entity && viewName ? entity.def.views[viewName].mapInfoWindowRenderer : InfoWindowRenderer, [
            InfoWindowRenderer,
            entity,
            viewName
        ]);
        const actualSelectionClickHandler = (0, $acw62.useMemo)(()=>(entity && viewName ? entity.def.views[viewName].mapSelectRecordsRenderer : selectRecordsRenderer) ?? DefaultSelectRecordsRenderer, [
            entity,
            viewName,
            selectRecordsRenderer,
            DefaultSelectRecordsRenderer
        ]);
        // InfoWindow Click handler
        const getInfoWindowClickHandler = (0, $acw62.useCallback)((dataSetId, record, recordIndex)=>{
            if (!latitudRecordIndex || !longitudRecordIndex) return null;
            const position = {
                lat: record[latitudRecordIndex],
                lng: record[longitudRecordIndex]
            };
            if (dataGridAPI.showSelectCheckbox) {
                if (!actualSelectionClickHandler) return null;
                const clickHandler = (infoWindow)=>{
                    return actualSelectionClickHandler(record, recordIndex, position, groupManager, infoWindow, dataGridAPI.UIAPI, theme, entity);
                };
                return clickHandler;
            } else {
                if (!actualInfoWindowRenderer) return null;
                const clickHandler = (infoWindow)=>{
                    return actualInfoWindowRenderer(record, position, groupManager, infoWindow, dataGridAPI.UIAPI, theme, entity, modal);
                };
                return clickHandler;
            }
        }, [
            actualInfoWindowRenderer,
            actualSelectionClickHandler,
            dataGridAPI.UIAPI,
            dataGridAPI.showSelectCheckbox,
            groupManager,
            latitudRecordIndex,
            longitudRecordIndex,
            theme,
            modal
        ]);
        // Group Markers
        const defaultGroupMarkerRenderer = (0, $acw62.useCallback)((group, markerOptions, theme)=>{
            const markerCreateOptions = markerOptions;
            markerCreateOptions.svgIcon = $5BXjy.MapMarkerGroupDefaultSVGIcon;
            markerCreateOptions.fillColor = $5BXjy.MapMarkerGroupDefaultFillColor;
            markerCreateOptions.assignColorByValue = undefined;
            markerCreateOptions.title = `${group.records.length} ${(0, $9UpIY.DefaultMapClusterProps).labels?.locationsLabel}`;
            markerCreateOptions.label = {
                text: group.records.length.toString(),
                color: 'white',
                fontSize: '0.7rem',
                fontWeight: '500'
            };
            markerCreateOptions.labelOrigin = new google.maps.Point($5BXjy.MapMarkerGroupDefaultLabelOrigin.x, $5BXjy.MapMarkerGroupDefaultLabelOrigin.y);
            return markerCreateOptions;
        }, []);
        const actualGroupMarkerRenderer = (0, $acw62.useMemo)(()=>{
            if (entity && viewName) return entity.def.views[viewName]?.mapGroupMarkerRenderer ?? groupMarkerRenderer ?? defaultGroupMarkerRenderer;
            return groupMarkerRenderer ?? defaultGroupMarkerRenderer;
        }, [
            defaultGroupMarkerRenderer,
            entity,
            groupMarkerRenderer,
            viewName
        ]);
        // Marker renderer
        const actualMarkerRenderer = (0, $acw62.useMemo)(()=>{
            if (!entity || !viewName) return undefined;
            return entity.def.views[viewName].mapMarkerRenderer ?? markerRenderer;
        }, [
            entity,
            markerRenderer,
            viewName
        ]);
        const [centerMarker, setCenterMarker] = (0, $acw62.useState)(undefined);
        const [markers, setMarkers] = (0, $acw62.useState)([]);
        (0, $acw62.useEffect)(()=>{
            if (!viewName) return;
            if (!showOnMap) {
                setMarkers([]);
                return;
            }
            if (!mapReady || !placesReady || !geocoderReady) return;
            if (!actualGroupMarkerRenderer) return;
            if (!latitudRecordIndex || !longitudRecordIndex) {
                console.warn(`MultiDataMapView: latitudRecordIndex or longitudRecordIndex not specified in ${entity?.name} view: ${viewName}`);
                return;
            }
            if (!executeViewState.data || executeViewState.data.length === 0 || !executeViewState.data[0].records || executeViewState.data[0].records.length === 0) {
                groupManager.clearAllGroups();
                setMarkers([]);
                return;
            }
            const records = executeViewState.data[0].records;
            groupManager.clearAllGroups();
            // Get the groups and marker options
            const processedMarkerCreateOptions = [];
            for(let i = 0; i < records.length; i++){
                const record = records[i];
                if (!record[latitudRecordIndex] || !record[longitudRecordIndex]) continue; // skip records that have no location
                const position = {
                    lat: record[latitudRecordIndex],
                    lng: record[longitudRecordIndex]
                };
                const markerCreateOptions = actualMarkerRenderer ? actualMarkerRenderer(record, position, theme) : {
                    position: position,
                    title: `${record[0]}`,
                    fillColor: 'red'
                };
                if (markerCreateOptions === null) continue;
                markerCreateOptions.dataSetId = dataMapView.dataSetId;
                markerCreateOptions.recordIndex = i;
                markerCreateOptions.isMapCenter = centerMarkerColumnIndex && record[centerMarkerColumnIndex] ? true : undefined;
                groupManager.addRecordToGroup(markerCreateOptions.position, i, record);
                processedMarkerCreateOptions.push(markerCreateOptions);
            }
            // delete groups with only one record
            groupManager.clearOneRecordGroups();
            // Create the newMarkers
            const renderedGroups = {};
            const newMarkers = [];
            for(let i = 0; i < processedMarkerCreateOptions.length; i++){
                const createMarkerRecord = processedMarkerCreateOptions[i];
                const group = groupManager.getGroupByLocation(createMarkerRecord.position);
                let markerOptions;
                let selectedMarkerOptions;
                if (group) {
                    // Check if the group was already rendered
                    if (renderedGroups[group.locationKey]) continue;
                    renderedGroups[group.locationKey] = true;
                    const markerCreateOptions = actualGroupMarkerRenderer(group, createMarkerRecord, theme);
                    if (markerCreateOptions === null) continue;
                    const optionsResult = getMarkerOptions(markerCreateOptions);
                    markerOptions = optionsResult.markerOptions;
                    selectedMarkerOptions = optionsResult.selectedMarkerOptions;
                } else {
                    const optionsResult = getMarkerOptions(createMarkerRecord);
                    markerOptions = optionsResult.markerOptions;
                    selectedMarkerOptions = optionsResult.selectedMarkerOptions;
                }
                const clickHandler = getInfoWindowClickHandler(dataMapView.dataSetId, records[createMarkerRecord.recordIndex], createMarkerRecord.recordIndex);
                if (clickHandler) markerOptions.clickable = true;
                if (createMarkerRecord.isMapCenter) setCenterMarker({
                    markerOptions: markerOptions,
                    selectedMarkerOptions: selectedMarkerOptions
                });
                newMarkers.push({
                    markerOptions: markerOptions,
                    selectedMarkerOptions: selectedMarkerOptions,
                    onMarkerClick: clickHandler ?? undefined,
                    recordIndex: group ? undefined : createMarkerRecord.recordIndex,
                    dataSetId: dataMapView.dataSetId ?? dataMapView.tabLabel ?? dataMapView.viewName,
                    isMapCenter: createMarkerRecord.isMapCenter
                });
            }
            setMarkers(newMarkers);
        }, [
            executeViewState.data,
            latitudRecordIndex,
            longitudRecordIndex,
            dataGridAPI.showSelectCheckbox,
            showOnMap,
            mapReady,
            placesReady,
            geocoderReady,
            centerMarkerColumnIndex,
            viewName
        ]);
        // newMarkers selection
        (0, $acw62.useEffect)(()=>{
            if (selectedRows.length === 0) {
                setSelectedMarkers({});
                return;
            }
            const selectedRowsMap = {};
            selectedRows.forEach((row, index)=>{
                selectedRowsMap[row.recid] = index;
            });
            // Filtrar y mapear los newMarkers seleccionados
            const currentSelection = markers.reduce((acc, marker)=>{
                if (marker.recordIndex !== undefined && selectedRowsMap[marker.recordIndex + 1] !== undefined) {
                    const dataSetId = marker.dataSetId;
                    if (!acc[dataSetId]) acc[dataSetId] = {};
                    marker.selectedMarkerOptions.label = selectedRowsMap[marker.recordIndex + 1].toString();
                    marker.selectedOrder = selectedRowsMap[marker.recordIndex + 1];
                    acc[dataSetId][marker.recordIndex] = marker;
                }
                return acc;
            }, {});
            setSelectedMarkers(currentSelection);
        }, [
            selectedRows
        ]); // el resto de las dependencias está intencionalmente dejado fuera
        return {
            dgProps: dgProps,
            viewState: viewState,
            executeViewState: executeViewState,
            dataGridAPI: dataGridAPI,
            actualColumnsOverrides: actualColumnsOverrides,
            actualSelectionClickHandler: actualSelectionClickHandler,
            selectedRows: selectedRows,
            setSelectedRows: setSelectedRows,
            getInfoWindowClickHandler: getInfoWindowClickHandler,
            //actualGroupMarkerRenderer,
            //actualMarkerRenderer,
            markers: markers,
            selectedMarkers: selectedMarkers,
            showOnMap: showOnMap,
            setShowOnMap: setShowOnMap,
            centerMarker: centerMarker
        };
    }
});
$305cacda61daafb0$var$parcelRegister("aO9ns", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MultiDataMapPageDefaultProps", function() {
        return $7ad14e3c7b55d1f9$export$7f67d945c63681b5;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MultiDataMapPage", function() {
        return $7ad14e3c7b55d1f9$export$20e3f53645ebea6;
    });
    var $iuZPr = $305cacda61daafb0$var$parcelRequire("iuZPr");
    const $7ad14e3c7b55d1f9$export$7f67d945c63681b5 = {
        showTitle: true
    };
    function $7ad14e3c7b55d1f9$export$20e3f53645ebea6(props) {
        const { showTitle: showTitle, client: client, formMode: formMode, title: title, icon: icon, helpText: helpText, dataMapView1: dataMapView1, dataMapView2: dataMapView2, dataMapView3: dataMapView3, dataMapView4: dataMapView4, dataMapView5: dataMapView5, ...others } = (0, $64A2P.useComponentDefaultProps)('MultiDataMapPage', props, $7ad14e3c7b55d1f9$export$7f67d945c63681b5);
        const theme = (0, $64A2P.useMantineTheme)();
        const entity1 = (0, $acw62.useRef)(dataMapView1.entityConstructor(client));
        const entity2 = (0, $acw62.useRef)(dataMapView2?.entityConstructor(client));
        const entity3 = (0, $acw62.useRef)(dataMapView3?.entityConstructor(client));
        const entity4 = (0, $acw62.useRef)(dataMapView4?.entityConstructor(client));
        const entity5 = (0, $acw62.useRef)(dataMapView5?.entityConstructor(client));
        const dataMapViews = (0, $acw62.useMemo)(()=>{
            const updateDataMapView = (dataMapView, entity)=>{
                if (!dataMapView) return dataMapView;
                const updatedDataMapView = {
                    ...dataMapView,
                    entity: entity,
                    enableAdd: formMode === 'view' ? false : dataMapView.enableAdd,
                    enableEdit: formMode === 'view' ? false : dataMapView.enableEdit,
                    enableDelete: formMode === 'view' ? false : dataMapView.enableDelete,
                    enableView: dataMapView.enableView
                };
                // Only return a new object if any of the properties changed
                if (updatedDataMapView.enableAdd !== dataMapView.enableAdd || updatedDataMapView.enableEdit !== dataMapView.enableEdit || updatedDataMapView.enableDelete !== dataMapView.enableDelete || updatedDataMapView.enableView !== dataMapView.enableView || updatedDataMapView.entity && !dataMapView.entity) return updatedDataMapView;
                return dataMapView;
            };
            return {
                newDataMapView1: updateDataMapView(dataMapView1, entity1.current),
                newDataMapView2: updateDataMapView(dataMapView2, entity2.current),
                newDataMapView3: updateDataMapView(dataMapView3, entity3.current),
                newDataMapView4: updateDataMapView(dataMapView4, entity4.current),
                newDataMapView5: updateDataMapView(dataMapView5, entity5.current)
            };
        }, [
            dataMapView1,
            dataMapView2,
            dataMapView3,
            dataMapView4,
            dataMapView5,
            formMode
        ]);
        const { newDataMapView1: newDataMapView1, newDataMapView2: newDataMapView2, newDataMapView3: newDataMapView3, newDataMapView4: newDataMapView4, newDataMapView5: newDataMapView5 } = dataMapViews;
        const EntityIcon = entity1.current.Icon;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                showTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                    variant: "filled",
                    chevron: /*#__PURE__*/ (0, $ayMG0.jsx)($kytQ3.default, {
                        size: "1.5rem"
                    }),
                    styles: {
                        item: {
                            '&[data-active]': {
                                backgroundColor: "unset"
                            }
                        },
                        label: {
                            paddingBottom: 0,
                            paddingTop: 0
                        }
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                        value: entity1.current.name,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                icon: icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
                                    children: icon
                                }) : EntityIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(EntityIcon, {
                                        size: "1.3rem"
                                    })
                                }) : undefined,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ew26C.Title, {
                                    order: 2,
                                    children: title ?? entity1.current.Title
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                    size: "sm",
                                    children: helpText ?? entity1.current.HelpText
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card, {
                    shadow: "sm",
                    withBorder: theme.colorScheme === 'dark' ? false : true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($iuZPr.MultiDataMap, {
                        dataMapView1: newDataMapView1,
                        dataMapView2: newDataMapView2,
                        dataMapView3: newDataMapView3,
                        dataMapView4: newDataMapView4,
                        dataMapView5: newDataMapView5,
                        formMode: formMode,
                        ...others
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("9LUPA", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MultiDataMapFormDefaultProps", function() {
        return $0ceec37da16af9c2$export$8d44fcb326c4ac59;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MultiDataMapForm", function() {
        return $0ceec37da16af9c2$export$a2abe8f30aacaab4;
    });
    var $iuZPr = $305cacda61daafb0$var$parcelRequire("iuZPr");
    const $0ceec37da16af9c2$export$8d44fcb326c4ac59 = {
        showTitle: true
    };
    function $0ceec37da16af9c2$export$a2abe8f30aacaab4(props) {
        const { showTitle: showTitle, formMode: formMode, title: title, icon: icon, helpText: helpText, customTitle: customTitle, dataMapView1: dataMapView1, dataMapView2: dataMapView2, dataMapView3: dataMapView3, dataMapView4: dataMapView4, dataMapView5: dataMapView5, ...others } = (0, $64A2P.useComponentDefaultProps)('MultiDataMapForm', props, $0ceec37da16af9c2$export$8d44fcb326c4ac59);
        const theme = (0, $64A2P.useMantineTheme)();
        const { entity: entity } = dataMapView1;
        const EntityIcon = dataMapView1.entity?.Icon;
        const IconNode = icon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
            children: icon
        }) : EntityIcon ? /*#__PURE__*/ (0, $ayMG0.jsx)($1Wgks.ThemeIcon, {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(EntityIcon, {
                size: "1rem"
            })
        }) : undefined;
        const dataMapViews = (0, $acw62.useMemo)(()=>{
            const updateDataMapView = (dataMapView)=>{
                if (!dataMapView) return dataMapView;
                const updatedDataMapView = {
                    ...dataMapView,
                    enableAdd: formMode === 'view' ? false : dataMapView.enableAdd,
                    enableEdit: formMode === 'view' ? false : dataMapView.enableEdit,
                    enableDelete: formMode === 'view' ? false : dataMapView.enableDelete,
                    enableView: dataMapView.enableView
                };
                // Only return a new object if any of the properties changed
                if (updatedDataMapView.enableAdd !== dataMapView.enableAdd || updatedDataMapView.enableEdit !== dataMapView.enableEdit || updatedDataMapView.enableDelete !== dataMapView.enableDelete || updatedDataMapView.enableView !== dataMapView.enableView) return updatedDataMapView;
                return dataMapView;
            };
            return {
                newDataMapView1: updateDataMapView(dataMapView1),
                newDataMapView2: updateDataMapView(dataMapView2),
                newDataMapView3: updateDataMapView(dataMapView3),
                newDataMapView4: updateDataMapView(dataMapView4),
                newDataMapView5: updateDataMapView(dataMapView5)
            };
        }, [
            dataMapView1,
            dataMapView2,
            dataMapView3,
            dataMapView4,
            dataMapView5,
            formMode
        ]);
        const { newDataMapView1: newDataMapView1, newDataMapView2: newDataMapView2, newDataMapView3: newDataMapView3, newDataMapView4: newDataMapView4, newDataMapView5: newDataMapView5 } = dataMapViews;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
            shadow: "sm",
            withBorder: theme.colorScheme === 'dark' ? false : true,
            children: [
                showTitle && customTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                    p: "xs",
                    bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                    mb: "1rem",
                    children: customTitle
                }),
                showTitle && !customTitle && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                    p: "xs",
                    bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                    mb: "1rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                        variant: "filled",
                        chevron: /*#__PURE__*/ (0, $ayMG0.jsx)($kytQ3.default, {
                            size: "1rem"
                        }),
                        styles: {
                            item: {
                                '&[data-active]': {
                                    backgroundColor: "unset"
                                }
                            },
                            label: {
                                paddingBottom: 0,
                                paddingTop: 0
                            },
                            control: {
                                padding: 0
                            }
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                            value: entity?.name ?? 'dmfEntity',
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                    icon: IconNode,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        size: "sm",
                                        children: title ?? entity?.Title
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        size: "xs",
                                        children: helpText ?? entity?.HelpText
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($iuZPr.MultiDataMap, {
                    dataMapView1: newDataMapView1,
                    dataMapView2: newDataMapView2,
                    dataMapView3: newDataMapView3,
                    dataMapView4: newDataMapView4,
                    dataMapView5: newDataMapView5,
                    formMode: formMode,
                    ...others
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("1ms8C", function(module1, exports) {
    var $38HqD = $305cacda61daafb0$var$parcelRequire("38HqD");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $38HqD);
});
$305cacda61daafb0$var$parcelRegister("38HqD", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ApplyFiltersDefaultLabel", function() {
        return $707110191f5551d7$export$fdcbf67d2ec63d1b;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "AutoFiltersForm", function() {
        return $707110191f5551d7$export$6f9073d2223e7bc;
    });
    $305cacda61daafb0$var$parcelRequire("iTpjT");
    var $adBvK = $305cacda61daafb0$var$parcelRequire("adBvK");
    var $jCh09 = $305cacda61daafb0$var$parcelRequire("jCh09");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    const $707110191f5551d7$export$fdcbf67d2ec63d1b = 'Apply Filters';
    function $707110191f5551d7$export$6f9073d2223e7bc(props) {
        const { entity: entity, getDataOnInit: getDataOnInit, initialFormMode: initialFormMode = 'edit', onSaved: onSaved, onCancel: onCancel } = props;
        const formAPI = (0, $jCh09.useViewFiltersForm)({
            entity: entity,
            initialFormMode: initialFormMode,
            getDataOnInit: getDataOnInit,
            onSaved: onSaved,
            onCancel: onCancel
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bHLhd.EntityForm, {
            formAPI: formAPI,
            OKText: $707110191f5551d7$export$fdcbf67d2ec63d1b,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9VIWE.Stack, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($adBvK.AutoFormFields, {
                    entity: entity,
                    entityForm: formAPI
                })
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("3xufQ", function(module1, exports) {
    var $02ufq = $305cacda61daafb0$var$parcelRequire("02ufq");
    var $jTCMz = $305cacda61daafb0$var$parcelRequire("jTCMz");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $02ufq);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jTCMz);
});
$305cacda61daafb0$var$parcelRegister("02ufq", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RegionSelectorDefaultProps", function() {
        return $4935d6bd11c8fcbf$export$75c216d80445d508;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RegionSelector", function() {
        return $4935d6bd11c8fcbf$export$9e9fd67a148d4951;
    });
    $305cacda61daafb0$var$parcelRequire("hZjV3");
    var $8ahcP = $305cacda61daafb0$var$parcelRequire("8ahcP");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $gNp1h = $305cacda61daafb0$var$parcelRequire("gNp1h");
    var $hejF0 = $305cacda61daafb0$var$parcelRequire("hejF0");
    var $f1AFh = $305cacda61daafb0$var$parcelRequire("f1AFh");
    var $jQiQb = $305cacda61daafb0$var$parcelRequire("jQiQb");
    var $jTCMz = $305cacda61daafb0$var$parcelRequire("jTCMz");
    const $4935d6bd11c8fcbf$export$75c216d80445d508 = {
        defaultMapCenter: $jQiQb.DEFAULT_MAP_CENTER,
        mapHeight: "50vh",
        errorTitle: "Google maps error",
        errorMessage: "An error occurred with google maps API:",
        mapCenter: $jQiQb.DEFAULT_MAP_CENTER,
        searchLabel: "Search",
        loadingLabel: "Loading",
        unknownStateLabel: "Unknown state",
        regionListMode: 'names',
        suppressCountyString: 'county',
        searchDescriptionLabel: "Search for a region, place or address and click on the map to select regions",
        mapHelpLabel: "* Use the zoom to select States, Counties or Zip codes. Click over the region to select/deselect",
        selectedRegionsLabel: "Selected Regions",
        maxRegions: Infinity
    };
    function $4935d6bd11c8fcbf$export$9e9fd67a148d4951(props) {
        const { mapReady: mapReady, placesReady: placesReady, geocoderReady: geocoderReady } = (0, $8ahcP.useGoogleMapsAPI)();
        const selectorProps = (0, $64A2P.useComponentDefaultProps)('RegionSelector', $4935d6bd11c8fcbf$export$75c216d80445d508, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: mapReady && placesReady && geocoderReady ? /*#__PURE__*/ (0, $ayMG0.jsx)($4935d6bd11c8fcbf$var$RegionSelectorInternal, {
                ...selectorProps
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {
                height: "50vh"
            })
        });
    }
    function $4935d6bd11c8fcbf$var$RegionSelectorInternal(props) {
        const { mapHeight: mapHeight, mapCenter: mapCenter, mapId: mapId, readOnly: readOnly, showErrors: showErrors, errorTitle: errorTitle, errorMessage: errorMessage, countries: countries, searchLabel: searchLabel, onAPIError: onAPIError, onRegionClicked: onRegionClicked, onSelectionChanged: onSelectionChanged, selectedRegions: selectedRegions, setSelectedRegions: setSelectedRegions, loadingLabel: loadingLabel, unknownStateLabel: unknownStateLabel, regionListMode: regionListMode, suppressCountyString: suppressCountyString, searchDescriptionLabel: searchDescriptionLabel, mapHelpLabel: mapHelpLabel, clickedRegions: clickedRegions, setClickedRegions: setClickedRegions, selectedRegionsLabel: selectedRegionsLabel, autoFocus: autoFocus, ...regionSelectorProps } = props;
        const [markerActualPos, setMarkerActualPos] = (0, $acw62.useState)();
        const [errorStatus, setErrorStatus] = (0, $acw62.useState)();
        const [internalMapCenter, setInternalMapCenter] = (0, $acw62.useState)(mapCenter || $jQiQb.DEFAULT_MAP_CENTER);
        const [internalMapZoom, setInternalMapZoom] = (0, $acw62.useState)(5);
        const mapOptions = (0, $acw62.useMemo)(()=>({
                zoom: internalMapZoom,
                center: internalMapCenter,
                mapId: mapId,
                streetViewControl: false,
                fullscreenControl: false,
                mapTypeControl: false,
                gestureHandling: 'greedy'
            }), [
            internalMapCenter,
            internalMapZoom,
            mapId
        ]);
        const addressMarkerOptions = (0, $acw62.useMemo)(()=>({
                position: markerActualPos,
                visible: !!markerActualPos,
                animation: google.maps.Animation.DROP,
                draggable: false
            }), [
            markerActualPos
        ]);
        // Autocomplete
        const autocompleteRestrictions = (0, $acw62.useMemo)(()=>({
                country: countries || []
            }), [
            countries
        ]);
        const handleAddressFound = (0, $acw62.useCallback)((found)=>{
            if (found.place.geometry?.location) {
                const currentPos = {
                    lat: found.place.geometry.location.lat(),
                    lng: found.place.geometry.location.lng()
                };
                setMarkerActualPos(currentPos);
                setInternalMapCenter(currentPos);
                setInternalMapZoom(11);
            } else setMarkerActualPos(undefined);
        }, []);
        const handleAutocompleteError = (0, $acw62.useCallback)((status)=>{
            const apiError = {
                status: status,
                origin: "Places"
            };
            setErrorStatus(apiError);
            if (onAPIError) onAPIError(apiError);
        }, [
            onAPIError
        ]);
        // Region selector
        const handleRegionClicked = (0, $acw62.useCallback)((place_id)=>{
            setMarkerActualPos(undefined);
        }, []);
        const selectorProps = (0, $acw62.useMemo)(()=>({
                ...regionSelectorProps,
                countries: countries,
                selectedRegions: selectedRegions,
                setSelectedRegions: setSelectedRegions,
                clickedRegions: clickedRegions,
                setClickedRegions: setClickedRegions,
                onSelectionChanged: (selected)=>{
                    if (onSelectionChanged) onSelectionChanged(selected);
                },
                onRegionClicked: (place_id)=>{
                    handleRegionClicked(place_id);
                    if (onRegionClicked) onRegionClicked(place_id);
                }
            }), [
            clickedRegions,
            countries,
            handleRegionClicked,
            onRegionClicked,
            onSelectionChanged,
            regionSelectorProps,
            selectedRegions,
            setClickedRegions,
            setSelectedRegions
        ]);
        // Grouped regions
        const groupedRegions = (0, $acw62.useMemo)(()=>{
            const groups = new Map();
            Object.values(selectedRegions).forEach((region)=>{
                const stateId = region.administrativeAreaLevel1Id || 'UNKNOWN_STATE';
                const group_key = `${region.countryId}-${stateId}`;
                let group = groups.get(group_key);
                if (!group) {
                    group = {
                        countryId: region.countryId,
                        stateId: stateId,
                        stateName: region.administrativeAreaLevel1Name,
                        counties: new Set(),
                        postalCodes: new Set(),
                        regions: []
                    };
                    groups.set(group_key, group);
                }
                if (region.featureType === google.maps.FeatureType.ADMINISTRATIVE_AREA_LEVEL_2) group.counties.add(region.administrativeAreaLevel2Id || 'UNKNOWN_COUNTY');
                if (region.featureType === google.maps.FeatureType.POSTAL_CODE) group.postalCodes.add(region.postalCode || 'UNKNOWN_POSTAL_CODE');
                group.regions.push(region);
            });
            return Array.from(groups.values());
        }, [
            selectedRegions
        ]);
        // Delete group
        const handleDeleteGroup = (0, $acw62.useCallback)((groupRegions)=>{
            setClickedRegions((prev)=>{
                const updated = {
                    ...prev
                };
                groupRegions.forEach((region)=>{
                    delete updated[region.placeId];
                });
                return updated;
            });
        }, [
            setClickedRegions
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            spacing: "md",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($gNp1h.GoogleAddressAutocomplete, {
                    label: searchLabel,
                    restrictions: autocompleteRestrictions,
                    onAddressFound: handleAddressFound,
                    readOnly: readOnly,
                    onAPIError: handleAutocompleteError,
                    description: searchDescriptionLabel,
                    "data-autofocus": autoFocus,
                    autoFocus: autoFocus
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                    spacing: "0.2rem",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: "xs",
                            weight: 600,
                            color: "dimmed",
                            children: mapHelpLabel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($hejF0.GoogleMapRegionSelectorMap, {
                            style: {
                                height: mapHeight,
                                resize: "vertical",
                                flexGrow: 1
                            },
                            mapOptions: mapOptions,
                            regionSelectorProps: selectorProps,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($f1AFh.GoogleMarker, {
                                markerOptions: addressMarkerOptions
                            }, "address-marker")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card, {
                    withBorder: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                children: [
                                    Object.keys(clickedRegions).length !== Object.keys(selectedRegions).length && /*#__PURE__*/ (0, $ayMG0.jsx)($4P91H.Loader, {
                                        size: "xs"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        size: "sm",
                                        children: selectedRegionsLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                        size: "xs",
                                        radius: "xl",
                                        variant: "transparent",
                                        onClick: ()=>{
                                            setClickedRegions({});
                                            setSelectedRegions({});
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                                            size: "0.75rem"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                                spacing: "xs",
                                children: groupedRegions.map((group)=>/*#__PURE__*/ (0, $ayMG0.jsx)($jTCMz.RegionSelectorItem, {
                                        onCloseClick: ()=>handleDeleteGroup(group.regions),
                                        children: [
                                            group.stateName === undefined ? loadingLabel : group.stateName || unknownStateLabel,
                                            group.counties.size > 0 ? regionListMode === 'names' ? `counties: [${Array.from(group.counties).map((county)=>county.replace(new RegExp(`\\s*${suppressCountyString}\\s*`, 'i'), '')).join(', ')}]` : `counties: ${group.counties.size}` : null,
                                            group.postalCodes.size > 0 ? regionListMode === 'names' ? `zipcodes: [${Array.from(group.postalCodes).join(', ')}]` : `zipcodes: ${group.postalCodes.size}` : null,
                                            group.countryId
                                        ].filter(Boolean).join(', ')
                                    }, `group-${group.countryId}-${group.stateId}`))
                            })
                        ]
                    })
                }),
                showErrors && errorStatus && /*#__PURE__*/ (0, $ayMG0.jsxs)($d50o9.AlertError, {
                    title: errorTitle,
                    children: [
                        errorMessage,
                        " ",
                        errorStatus.status,
                        " (",
                        errorStatus.origin,
                        ")"
                    ]
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("jTCMz", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RegionSelectorItem", function() {
        return $e7001d37eff8be8f$export$fd5bbd3671beaaad;
    });
    function $e7001d37eff8be8f$export$fd5bbd3671beaaad({ onCloseClick: onCloseClick, children: children, ...rest }) {
        const removeButton = /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
            size: "xs",
            radius: "xl",
            variant: "transparent",
            onClick: ()=>{
                if (onCloseClick) onCloseClick();
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                size: "0.75rem"
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($iPjI4.Badge, {
            size: "md",
            ...rest,
            rightSection: onCloseClick && removeButton,
            styles: {
                root: {
                    width: 'fit-content'
                }
            },
            children: children
        });
    }
});
$305cacda61daafb0$var$parcelRegister("jq5ab", function(module1, exports) {
    var $8Gezt = $305cacda61daafb0$var$parcelRequire("8Gezt");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $8Gezt);
});
$305cacda61daafb0$var$parcelRegister("8Gezt", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "DataRegion", function() {
        return $39c678b112569293$export$6bcea45d5449884;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $iqamJ = $305cacda61daafb0$var$parcelRequire("iqamJ");
    $305cacda61daafb0$var$parcelRequire("3xufQ");
    var $02ufq = $305cacda61daafb0$var$parcelRequire("02ufq");
    function $39c678b112569293$export$6bcea45d5449884(props) {
        const { entity: entity, queryName: queryName, parentKeys: parentKeys, mapId: mapId, countries: countries, mapCenter: mapCenter, mapHeight: mapHeight, mapDataResult: mapDataResult, selectedRegions: selectedRegions, setSelectedRegions: setSelectedRegions, clickedRegions: clickedRegions, setClickedRegions: setClickedRegions, mapRestrictions: mapRestrictions, maxRegions: maxRegions, onMaxRegionsReached: onMaxRegionsReached } = props;
        const query = (0, $iqamJ.useExecuteProc)(entity, entity.def.procs[queryName]);
        (0, $acw62.useEffect)(()=>{
            const refresh = async ()=>{
                const proc = entity.def.procs[queryName];
                if (!proc) {
                    console.error(`Proc ${queryName} not found in entity ${entity.def.name}`);
                    return;
                }
                const result = await query.execute(parentKeys || {});
                if (result?.data) {
                    const regions = mapDataResult(result.data[0]);
                    setSelectedRegions(regions);
                    const clickedRegionsData = Object.entries(regions).reduce((acc, [key, value])=>{
                        acc[key] = {
                            featuretype: value.featuretype,
                            placeId: value.placeId
                        };
                        return acc;
                    }, {});
                    setClickedRegions(clickedRegionsData);
                }
            };
            refresh();
        }, [
            entity.def.name,
            entity.def.procs,
            mapDataResult,
            parentKeys,
            query,
            queryName,
            setClickedRegions,
            setSelectedRegions
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                query.status.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {
                    height: mapHeight
                }),
                query.status.error && /*#__PURE__*/ (0, $ayMG0.jsxs)($d50o9.AlertError, {
                    mb: "xs",
                    children: [
                        query.status.error.status,
                        " ",
                        query.status.error.message,
                        " ",
                        query.status.error.statusMessage
                    ]
                }),
                !query.status.loading && !query.status.error && /*#__PURE__*/ (0, $ayMG0.jsx)($02ufq.RegionSelector, {
                    mapId: mapId,
                    mapHeight: mapHeight,
                    countries: countries,
                    mapCenter: mapCenter,
                    selectedRegions: selectedRegions,
                    setSelectedRegions: setSelectedRegions,
                    clickedRegions: clickedRegions,
                    setClickedRegions: setClickedRegions,
                    mapRestrictions: mapRestrictions,
                    maxRegions: maxRegions,
                    onMaxRegionsReached: onMaxRegionsReached
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("2eiTU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CategoriesValues", function() {
        return $aed8cee1012dd86e$export$455eebe5015c28c1;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $dHfNt = $305cacda61daafb0$var$parcelRequire("dHfNt");
    class $aed8cee1012dd86e$export$455eebe5015c28c1 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $dHfNt.CategoriesValuesDef(), parentKeys);
            this.Form = Promise.resolve($305cacda61daafb0$var$parcelRequire("5cUzS")).then((module1)=>module1.AutoForm);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("dHfNt", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CategoriesValuesDef", function() {
        return $1ab13205dafe1611$export$5cea035f36a1cebe;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    var $7ApT5 = $305cacda61daafb0$var$parcelRequire("7ApT5");
    const $1ab13205dafe1611$var$columns = ()=>({
            c_category_id: new $ZmuZ6.EntityColumn({
                name: 'c_category_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: "Categor\xeda",
                excludeInAutoForm: true
            }),
            c_categoryvalue_id: new $ZmuZ6.EntityColumn({
                name: 'c_categoryvalue_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'ID'
            }),
            vc_description: new $ZmuZ6.EntityColumn({
                name: 'vc_description',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: "Descripci\xf3n"
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $1ab13205dafe1611$var$lookups = ()=>({
            Categories: {
                name: 'Categories',
                entityConstructor: (client, parentKeys)=>new $7ApT5.Categories(client, parentKeys)
            }
        });
    const $1ab13205dafe1611$var$views = ()=>({
            cav_brwStandard: {
                name: 'cav_brwStandard',
                keyMappings: {
                    c_categoryvalue_id: 0
                }
            }
        });
    class $1ab13205dafe1611$export$5cea035f36a1cebe extends $5Sq1V.EntityDefinition {
        constructor(){
            super('CategoriesValues'), this.columns = $1ab13205dafe1611$var$columns(), this.views = $1ab13205dafe1611$var$views(), this.lookups = $1ab13205dafe1611$var$lookups();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("b6vlE", function(module1, exports) {
    var $g1od8 = $305cacda61daafb0$var$parcelRequire("g1od8");
    var $kRRLT = $305cacda61daafb0$var$parcelRequire("kRRLT");
    var $a59jU = $305cacda61daafb0$var$parcelRequire("a59jU");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $g1od8);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kRRLT);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $a59jU);
});
$305cacda61daafb0$var$parcelRegister("g1od8", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "catAuthenticationTypes", function() {
        return $79ffb49cbb912ac8$export$81802a62c8288c55;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    $305cacda61daafb0$var$parcelRequire("cVppo");
    var $dHfNt = $305cacda61daafb0$var$parcelRequire("dHfNt");
    class $79ffb49cbb912ac8$export$81802a62c8288c55 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $dHfNt.CategoriesValuesDef(), parentKeys);
            this.def.columns.c_category_id.value = "AuthenticationTypes";
            this.def.columns.c_category_id.defaultValue = "AuthenticationTypes";
            this.Title = "Authentication Types";
        }
    }
});
$305cacda61daafb0$var$parcelRegister("kRRLT", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "catUserTypes", function() {
        return $af68dc5023364721$export$cb9d45d3d0f86341;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    $305cacda61daafb0$var$parcelRequire("cVppo");
    var $dHfNt = $305cacda61daafb0$var$parcelRequire("dHfNt");
    class $af68dc5023364721$export$cb9d45d3d0f86341 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $dHfNt.CategoriesValuesDef(), parentKeys);
            this.def.columns.c_category_id.value = "UserTypes";
            this.def.columns.c_category_id.defaultValue = "UserTypes";
            this.Title = "User Types";
        }
    }
});
$305cacda61daafb0$var$parcelRegister("a59jU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "catIdentityProviderRoles", function() {
        return $65a40cbf7d9b589d$export$3ac97a9fa7384365;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    $305cacda61daafb0$var$parcelRequire("cVppo");
    var $dHfNt = $305cacda61daafb0$var$parcelRequire("dHfNt");
    class $65a40cbf7d9b589d$export$3ac97a9fa7384365 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $dHfNt.CategoriesValuesDef(), parentKeys);
            this.def.columns.c_category_id.value = "IdentityProviderRoles";
            this.def.columns.c_category_id.defaultValue = "IdentityProviderRoles";
            this.Title = "Identity Provider Roles";
        }
    }
});
$305cacda61daafb0$var$parcelRegister("20cAu", function(module1, exports) {
    var $l9s7h = $305cacda61daafb0$var$parcelRequire("l9s7h");
    var $i1pIT = $305cacda61daafb0$var$parcelRequire("i1pIT");
    var $2uTFr = $305cacda61daafb0$var$parcelRequire("2uTFr");
    var $dsFjw = $305cacda61daafb0$var$parcelRequire("dsFjw");
    var $gzfVx = $305cacda61daafb0$var$parcelRequire("gzfVx");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $l9s7h);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $i1pIT);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2uTFr);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dsFjw);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $gzfVx);
});
$305cacda61daafb0$var$parcelRegister("l9s7h", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersDef", function() {
        return $7cd3d360cc78f6d8$export$27f9d3139d5e0650;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    var $kRRLT = $305cacda61daafb0$var$parcelRequire("kRRLT");
    $305cacda61daafb0$var$parcelRequire("d699b");
    var $amyT1 = $305cacda61daafb0$var$parcelRequire("amyT1");
    const $7cd3d360cc78f6d8$var$columns = ()=>({
            c_user_id: new $ZmuZ6.EntityColumn({
                name: 'c_user_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PKAutonum,
                prompt: 'User Id'
            }),
            vc_username: new $ZmuZ6.EntityColumn({
                name: 'vc_username',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Username'
            }),
            vc_email: new $ZmuZ6.EntityColumn({
                name: 'vc_email',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Email'
            }),
            vc_pwhash: new $ZmuZ6.EntityColumn({
                name: 'vc_pwhash',
                type: 'varchar',
                length: 2048,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Pwhash'
            }),
            vb_sid: new $ZmuZ6.EntityColumn({
                name: 'vb_sid',
                type: 'varchar',
                length: 85,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Sid'
            }),
            vc_refreshtoken: new $ZmuZ6.EntityColumn({
                name: 'vc_refreshtoken',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Refreshtoken'
            }),
            dt_refresh_expiration: new $ZmuZ6.EntityColumn({
                name: 'dt_refresh_expiration',
                type: 'datetime',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Refresh Expiration'
            }),
            i_badlogonattempts: new $ZmuZ6.EntityColumn({
                name: 'i_badlogonattempts',
                type: 'int',
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Badlogonattempts'
            }),
            i_refreshcount: new $ZmuZ6.EntityColumn({
                name: 'i_refreshcount',
                type: 'int',
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Refreshcount'
            }),
            bt_disabled: new $ZmuZ6.EntityColumn({
                name: 'bt_disabled',
                type: 'bit',
                length: 1,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Disable user'
            }),
            dt_locked: new $ZmuZ6.EntityColumn({
                name: 'dt_locked',
                type: 'datetime',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Date Locked'
            }),
            dt_last_login: new $ZmuZ6.EntityColumn({
                name: 'dt_last_login',
                type: 'datetime',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Last Login'
            }),
            dt_last_refresh: new $ZmuZ6.EntityColumn({
                name: 'dt_last_refresh',
                type: 'datetime',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Last Refresh'
            }),
            vc_recovery_code: new $ZmuZ6.EntityColumn({
                name: 'vc_recovery_code',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Recovery Code'
            }),
            dt_last_recovery: new $ZmuZ6.EntityColumn({
                name: 'dt_last_recovery',
                type: 'datetime',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Last Recovery'
            }),
            c_usertype_id: new $ZmuZ6.EntityColumn({
                name: 'c_usertype_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Usertype Id'
            }),
            vc_user_groups: new $ZmuZ6.EntityColumn({
                name: 'vc_user_groups',
                type: 'varchar',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'User Groups',
                isArray: true
            }),
            bt_islocked: new $ZmuZ6.EntityColumn({
                name: 'bt_islocked',
                type: 'bit',
                length: 1,
                flags: $4H7ea.EntityColumnFlags.fake,
                prompt: 'Locked'
            }),
            i_locked_minutes_remaining: new $ZmuZ6.EntityColumn({
                name: 'i_locked_minutes_remaining',
                type: 'int',
                flags: $4H7ea.EntityColumnFlags.fake,
                prompt: 'Locked minutes remaining'
            }),
            vc_password: new $ZmuZ6.EntityColumn({
                name: 'vc_password',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Password'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $7cd3d360cc78f6d8$var$views = ()=>({
            usr_brwStandard: {
                name: 'usr_brwStandard',
                keyMappings: {
                    c_user_id: 0
                }
            }
        });
    const $7cd3d360cc78f6d8$var$lookups = ()=>({
            'UserTypes': {
                name: 'UserTypes',
                viewMapping: {
                    keyIndex: 0,
                    descriptionIndex: 1
                },
                entityConstructor: (client, parentKeys)=>new $kRRLT.catUserTypes(client, parentKeys)
            },
            'MicromUsersGroups': {
                name: 'MicromUsersGroups',
                viewMapping: {
                    keyIndex: 0,
                    descriptionIndex: 1
                },
                entityConstructor: (client, parentKeys)=>new $amyT1.MicromUsersGroups(client, parentKeys)
            }
        });
    class $7cd3d360cc78f6d8$export$27f9d3139d5e0650 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('MicromUsers'), this.columns = $7cd3d360cc78f6d8$var$columns(), this.views = $7cd3d360cc78f6d8$var$views(), this.lookups = $7cd3d360cc78f6d8$var$lookups();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("d699b", function(module1, exports) {
    var $33jdo = $305cacda61daafb0$var$parcelRequire("33jdo");
    var $amyT1 = $305cacda61daafb0$var$parcelRequire("amyT1");
    var $kC9K4 = $305cacda61daafb0$var$parcelRequire("kC9K4");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $33jdo);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $amyT1);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kC9K4);
});
$305cacda61daafb0$var$parcelRegister("33jdo", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsDef", function() {
        return $5ff6230ff51ef7c6$export$1debebb40a896b33;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    $305cacda61daafb0$var$parcelRequire("20cAu");
    var $i1pIT = $305cacda61daafb0$var$parcelRequire("i1pIT");
    const $5ff6230ff51ef7c6$var$columns = ()=>({
            c_user_group_id: new $ZmuZ6.EntityColumn({
                name: 'c_user_group_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PKAutonum,
                prompt: 'User Group Id'
            }),
            vc_user_group_name: new $ZmuZ6.EntityColumn({
                name: 'vc_user_group_name',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'User Group Name',
                description: 'The name of the user group'
            }),
            vc_group_members: new $ZmuZ6.EntityColumn({
                name: 'vc_group_members',
                type: 'varchar',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.fake | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Members',
                description: 'The users members of the user group',
                isArray: true
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $5ff6230ff51ef7c6$var$views = ()=>({
            mug_brwStandard: {
                name: 'mug_brwStandard',
                keyMappings: {
                    c_user_group_id: 0
                }
            }
        });
    const $5ff6230ff51ef7c6$var$lookups = ()=>({
            'MicromUsers': {
                name: 'MicromUsers',
                viewMapping: {
                    keyIndex: 0,
                    descriptionIndex: 1
                },
                entityConstructor: (client, parentKeys)=>new $i1pIT.MicromUsers(client, parentKeys)
            }
        });
    class $5ff6230ff51ef7c6$export$1debebb40a896b33 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('MicromUsersGroups'), this.columns = $5ff6230ff51ef7c6$var$columns(), this.views = $5ff6230ff51ef7c6$var$views(), this.lookups = $5ff6230ff51ef7c6$var$lookups();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("amyT1", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroups", function() {
        return $37a3a7c9c90b9c6f$export$78b5894ed2a777cb;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $33jdo = $305cacda61daafb0$var$parcelRequire("33jdo");
    class $37a3a7c9c90b9c6f$export$78b5894ed2a777cb extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $33jdo.MicromUsersGroupsDef(), parentKeys);
            this.Form = Promise.resolve($305cacda61daafb0$var$parcelRequire("kC9K4")).then((module1)=>module1.MicromUsersGroupsForm);
            this.Title = "Microm Users Groups";
        }
    }
});
$305cacda61daafb0$var$parcelRegister("kC9K4", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsFormDefaultProps", function() {
        return $1b130d6aee6e8d2d$export$170978648b295af5;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsForm", function() {
        return $1b130d6aee6e8d2d$export$89806ebb093886d2;
    });
    $305cacda61daafb0$var$parcelRequire("kMllr");
    var $jLHxW = $305cacda61daafb0$var$parcelRequire("jLHxW");
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    var $jyGs4 = $305cacda61daafb0$var$parcelRequire("jyGs4");
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    var $bW9pc = $305cacda61daafb0$var$parcelRequire("bW9pc");
    var $6Tg0K = $305cacda61daafb0$var$parcelRequire("6Tg0K");
    $305cacda61daafb0$var$parcelRequire("gFZgU");
    var $9FGm1 = $305cacda61daafb0$var$parcelRequire("9FGm1");
    const $1b130d6aee6e8d2d$export$170978648b295af5 = {
        initialFormMode: "view",
        groupTabLabel: "Group",
        menusTabLabel: "Menu access",
        membersTabLabel: "Members"
    };
    const $1b130d6aee6e8d2d$var$TN = {
        group: 'group',
        groupIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($54kyq.default, {
            size: "1rem"
        }),
        menus: 'menus',
        menusIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($6HZkq.default, {
            size: "1rem"
        }),
        members: 'members',
        membersIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($22CZZ.default, {
            size: "1rem"
        })
    };
    const $1b130d6aee6e8d2d$var$gridHeight = "39vh";
    function $1b130d6aee6e8d2d$export$89806ebb093886d2(props) {
        const { entity: entity, initialFormMode: initialFormMode, getDataOnInit: getDataOnInit, onSaved: onSaved, onCancel: onCancel, groupTabLabel: groupTabLabel, menusTabLabel: menusTabLabel, membersTabLabel: membersTabLabel } = (0, $64A2P.useComponentDefaultProps)('MicromUsersGroups', $1b130d6aee6e8d2d$export$170978648b295af5, props);
        const formAPI = (0, $bW9pc.useEntityForm)({
            entity: entity,
            initialFormMode: initialFormMode,
            getDataOnInit: getDataOnInit,
            onSaved: onSaved,
            onCancel: onCancel
        });
        const { formMode: formMode, status: status } = formAPI;
        const groupMenusRef = (0, $acw62.useRef)(new $9FGm1.MicromUsersGroupsMenus(entity.API.client));
        const groupMenus = groupMenusRef.current;
        const groupParentkeys = (0, $6Tg0K.useParentKeys)({
            formAPI: formAPI,
            columnNames: [
                entity.def.columns.c_user_group_id.name,
                groupMenus.def.columns.c_menu_id.name
            ],
            entity: entity
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bHLhd.EntityForm, {
            formAPI: formAPI,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($hUms8.Tabs, {
                pt: "xs",
                defaultValue: $1b130d6aee6e8d2d$var$TN.group,
                mih: "60vh",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($hUms8.Tabs.List, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                value: $1b130d6aee6e8d2d$var$TN.group,
                                icon: $1b130d6aee6e8d2d$var$TN.groupIcon,
                                children: groupTabLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                value: $1b130d6aee6e8d2d$var$TN.menus,
                                icon: $1b130d6aee6e8d2d$var$TN.menusIcon,
                                children: menusTabLabel
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                value: $1b130d6aee6e8d2d$var$TN.members,
                                icon: $1b130d6aee6e8d2d$var$TN.membersIcon,
                                children: membersTabLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                        value: $1b130d6aee6e8d2d$var$TN.group,
                        pt: "xs",
                        mih: $1b130d6aee6e8d2d$var$gridHeight,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                            children: [
                                formMode != "add" && /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                                    entityForm: formAPI,
                                    column: entity.def.columns.c_user_group_id,
                                    readOnly: true,
                                    required: false,
                                    maw: "20rem"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                                    entityForm: formAPI,
                                    column: entity.def.columns.vc_user_group_name,
                                    autoFocus: true,
                                    transform: "capitalize"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                        value: $1b130d6aee6e8d2d$var$TN.menus,
                        pt: "xs",
                        mih: $1b130d6aee6e8d2d$var$gridHeight,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9VIWE.Stack, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($jLHxW.DataGridForm, {
                                gridHeight: $1b130d6aee6e8d2d$var$gridHeight,
                                parentKeys: groupParentkeys,
                                entity: groupMenus,
                                formMode: formMode,
                                viewName: groupMenus.def.views.mmn_brwMenuItems.name,
                                selectionMode: "multi",
                                parentFormAPI: formAPI,
                                enableAdd: false,
                                enableEdit: false,
                                enableView: false,
                                enableDelete: false,
                                saveFormBeforeAdd: true,
                                autoSelectFirstRow: false
                            }, `grid-menus-${entity.def.name}`)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                        value: $1b130d6aee6e8d2d$var$TN.members,
                        pt: "xs",
                        mih: $1b130d6aee6e8d2d$var$gridHeight,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9VIWE.Stack, {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($jyGs4.LookupMultiSelect, {
                                entityForm: formAPI,
                                column: entity.def.columns.vc_group_members,
                                entity: entity,
                                lookupDefName: entity.def.lookups.MicromUsers.name,
                                formStatus: status,
                                required: false,
                                searchable: true,
                                includeKeyInDescription: false,
                                creatable: false,
                                maw: "35rem"
                            })
                        })
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("gFZgU", function(module1, exports) {
    var $9FGm1 = $305cacda61daafb0$var$parcelRequire("9FGm1");
    var $fH0r7 = $305cacda61daafb0$var$parcelRequire("fH0r7");
    var $kWWCK = $305cacda61daafb0$var$parcelRequire("kWWCK");
    var $dzCWi = $305cacda61daafb0$var$parcelRequire("dzCWi");
    var $jCcgQ = $305cacda61daafb0$var$parcelRequire("jCcgQ");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9FGm1);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fH0r7);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kWWCK);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dzCWi);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jCcgQ);
});
$305cacda61daafb0$var$parcelRegister("9FGm1", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMenusEntityDefaultProps", function() {
        return $2a5b50255fda7d50$export$bb5a78bc40e8094;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMenus", function() {
        return $2a5b50255fda7d50$export$5d4bc95078b515d9;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $dzCWi = $305cacda61daafb0$var$parcelRequire("dzCWi");
    var $kWWCK = $305cacda61daafb0$var$parcelRequire("kWWCK");
    var $fH0r7 = $305cacda61daafb0$var$parcelRequire("fH0r7");
    const $2a5b50255fda7d50$export$bb5a78bc40e8094 = {
        icon: undefined,
        helpText: '* The list of available menu items to be allowed or denied access',
        title: 'Menu access'
    };
    class $2a5b50255fda7d50$export$5d4bc95078b515d9 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $fH0r7.MicromUsersGroupsMenusDef(), parentKeys);
            this.Title = $2a5b50255fda7d50$export$bb5a78bc40e8094.title;
            this.Icon = $2a5b50255fda7d50$export$bb5a78bc40e8094.icon;
            this.HelpText = $2a5b50255fda7d50$export$bb5a78bc40e8094.helpText;
            this.def.clientActions.ACTEnableMenus.label = $kWWCK.MicromUsersGroupsMenusEnableMenusLabels.buttonLabel;
            this.def.clientActions.ACTDisableMenus.label = $dzCWi.MicromUsersGroupsMenusDisableMenusLabels.buttonLabel;
        }
    }
});
$305cacda61daafb0$var$parcelRegister("dzCWi", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMenusDisableMenusLabels", function() {
        return $aaeee432e61d408d$export$d401c604a54f42c5;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ACTDisableMenus", function() {
        return $aaeee432e61d408d$export$909422e0be99a7a2;
    });
    $305cacda61daafb0$var$parcelRequire("kMllr");
    var $4SevU = $305cacda61daafb0$var$parcelRequire("4SevU");
    var $j7Y9b = $305cacda61daafb0$var$parcelRequire("j7Y9b");
    const $aaeee432e61d408d$export$d401c604a54f42c5 = {
        denyAccessToSelectedMenuItems: 'Deny access to selected menu items',
        buttonLabel: 'Deny access',
        title: 'Deny access',
        areYouSure: 'You are denying access to the selected menu items. Are you sure?'
    };
    const $aaeee432e61d408d$var$l = $aaeee432e61d408d$export$d401c604a54f42c5;
    const $aaeee432e61d408d$export$909422e0be99a7a2 = {
        name: 'ACTDisableMenus',
        label: $aaeee432e61d408d$var$l.buttonLabel,
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
            spacing: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($4SevU.CircleFilledIcon, {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                        size: "0.75rem"
                    }),
                    backColor: "red"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                    fw: 700,
                    children: $aaeee432e61d408d$var$l.title
                })
            ]
        }),
        refreshOnClose: true,
        dontRequireSelection: true,
        onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
            // cast entity
            const parent = entity;
            const abort_controller = new AbortController();
            if (modal) await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($4SevU.CircleFilledIcon, {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                                    size: "0.75rem"
                                }),
                                backColor: "red"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                fw: 700,
                                children: $aaeee432e61d408d$var$l.denyAccessToSelectedMenuItems
                            })
                        ]
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($j7Y9b.ConfirmAndExecutePanel, {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        size: "sm",
                        mb: "xs",
                        children: $aaeee432e61d408d$var$l.areYouSure
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        abort_controller.abort();
                        await modal.close();
                        if (onClose) await onClose(false);
                    },
                    onOK: async ()=>{
                        const result = await parent.API.deleteData(selectedKeys, abort_controller.signal, parent.parentKeys);
                        const success = result.Failed === false;
                        if (success) {
                            await modal.close();
                            if (onClose) await onClose(success);
                        }
                        return result;
                    }
                })
            });
            else console.log('modal context not found');
            return Promise.resolve(false);
        }
    };
});
$305cacda61daafb0$var$parcelRegister("kWWCK", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMenusEnableMenusLabels", function() {
        return $edb5a30f55a5d552$export$6e6c77cc60214b2f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ACTEnableMenus", function() {
        return $edb5a30f55a5d552$export$b54c1ee818d50779;
    });
    $305cacda61daafb0$var$parcelRequire("kMllr");
    var $4SevU = $305cacda61daafb0$var$parcelRequire("4SevU");
    var $j7Y9b = $305cacda61daafb0$var$parcelRequire("j7Y9b");
    const $edb5a30f55a5d552$export$6e6c77cc60214b2f = {
        allowAccessToSelectedMenuItems: 'Allow access to selected menu items',
        buttonLabel: 'Allow access',
        title: 'Enable access',
        areYouSure: 'You are allowing access to the selected menu items. Are you sure?'
    };
    const $edb5a30f55a5d552$export$b54c1ee818d50779 = {
        name: 'ACTEnableMenus',
        label: $edb5a30f55a5d552$export$6e6c77cc60214b2f.buttonLabel,
        title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
            spacing: "xs",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($4SevU.CircleFilledIcon, {
                    icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3US3h.default, {
                        size: "0.75rem"
                    }),
                    backColor: "green"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                    fw: 700,
                    children: $edb5a30f55a5d552$export$6e6c77cc60214b2f.title
                })
            ]
        }),
        refreshOnClose: true,
        dontRequireSelection: true,
        onClick: async ({ entity: entity, modal: modal, selectedKeys: selectedKeys, element: element, onClose: onClose })=>{
            // cast entity
            const parent = entity;
            const abort_controller = new AbortController();
            if (modal) await modal.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        spacing: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($4SevU.CircleFilledIcon, {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3US3h.default, {
                                    size: "0.75rem"
                                }),
                                backColor: "green"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                fw: 700,
                                children: $edb5a30f55a5d552$export$6e6c77cc60214b2f.allowAccessToSelectedMenuItems
                            })
                        ]
                    })
                },
                focusOnClosed: element,
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($j7Y9b.ConfirmAndExecutePanel, {
                    content: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        size: "sm",
                        mb: "xs",
                        children: $edb5a30f55a5d552$export$6e6c77cc60214b2f.areYouSure
                    }),
                    operation: "proc",
                    onCancel: async ()=>{
                        abort_controller.abort();
                        await modal.close();
                        if (onClose) await onClose(false);
                    },
                    onOK: async ()=>{
                        const result = await parent.API.addData(abort_controller.signal, selectedKeys, true);
                        const success = result.Failed === false;
                        if (success) {
                            await modal.close();
                            if (onClose) await onClose(success);
                        }
                        return result;
                    }
                })
            });
            else console.log('modal context not found');
            return Promise.resolve(false);
        }
    };
});
$305cacda61daafb0$var$parcelRegister("fH0r7", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMenusDef", function() {
        return $4476f7eb0b0c9166$export$1dbde5f2bdb12218;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    $305cacda61daafb0$var$parcelRequire("d699b");
    var $amyT1 = $305cacda61daafb0$var$parcelRequire("amyT1");
    var $dzCWi = $305cacda61daafb0$var$parcelRequire("dzCWi");
    var $kWWCK = $305cacda61daafb0$var$parcelRequire("kWWCK");
    var $jCcgQ = $305cacda61daafb0$var$parcelRequire("jCcgQ");
    const $4476f7eb0b0c9166$var$columns = ()=>({
            c_user_group_id: new $ZmuZ6.EntityColumn({
                name: 'c_user_group_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'User Group Id'
            }),
            c_menu_id: new $ZmuZ6.EntityColumn({
                name: 'c_menu_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'Menu Id'
            }),
            c_menu_item_id: new $ZmuZ6.EntityColumn({
                name: 'c_menu_item_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'Menu Item Id'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $4476f7eb0b0c9166$var$views = ()=>({
            mmn_brwStandard: {
                name: 'mmn_brwStandard',
                keyMappings: {
                    c_user_group_id: 0
                }
            },
            mmn_brwMenuItems: {
                name: 'mmn_brwMenuItems',
                keyMappings: {
                    c_menu_id: 0,
                    c_menu_item_id: 1
                },
                gridColumnsOverrides: $jCcgQ.MicromUsersGroupsMenusColumnsOverrides
            }
        });
    const $4476f7eb0b0c9166$var$lookups = ()=>({
            'MicromUsersGroups': {
                name: 'MicromUsersGroups',
                viewMapping: {
                    keyIndex: 0,
                    descriptionIndex: 1
                },
                entityConstructor: (client, parentKeys)=>new $amyT1.MicromUsersGroups(client, parentKeys)
            }
        });
    const $4476f7eb0b0c9166$var$clientActions = ()=>({
            ACTEnableMenus: $kWWCK.ACTEnableMenus,
            ACTDisableMenus: $dzCWi.ACTDisableMenus
        });
    class $4476f7eb0b0c9166$export$1dbde5f2bdb12218 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('MicromUsersGroupsMenus'), this.columns = $4476f7eb0b0c9166$var$columns(), this.views = $4476f7eb0b0c9166$var$views(), this.lookups = $4476f7eb0b0c9166$var$lookups(), this.clientActions = $4476f7eb0b0c9166$var$clientActions();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("jCcgQ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMenusColumnsOverridesLabelsDefaultProps", function() {
        return $b24bfc5ba97f664c$export$cefa9a7d2b79e852;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMenusColumnsOverrides", function() {
        return $b24bfc5ba97f664c$export$5c35389b5bbac063;
    });
    $305cacda61daafb0$var$parcelRequire("kMllr");
    var $4SevU = $305cacda61daafb0$var$parcelRequire("4SevU");
    const $b24bfc5ba97f664c$export$cefa9a7d2b79e852 = {
        granted: "Granted",
        denied: "Denied"
    };
    function $b24bfc5ba97f664c$export$5c35389b5bbac063(theme) {
        const l = $b24bfc5ba97f664c$export$cefa9a7d2b79e852;
        return {
            // Access
            4: {
                render: (value)=>value === "true" ? /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        style: {
                            gap: '0rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($4SevU.CircleFilledIcon, {
                                mr: "xs",
                                backColor: theme.colors.green[8],
                                width: "1.3rem",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($3US3h.default, {
                                    size: "0.9rem"
                                })
                            }),
                            l.granted
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        style: {
                            gap: '0rem'
                        },
                        noWrap: true,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($4SevU.CircleFilledIcon, {
                                mr: "xs",
                                backColor: theme.colors.red[8],
                                width: "1.3rem",
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                                    size: "0.9rem"
                                })
                            }),
                            l.denied
                        ]
                    })
            }
        };
    }
});
$305cacda61daafb0$var$parcelRegister("i1pIT", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsers", function() {
        return $5e07f7f42215ff3f$export$85a1c3f4199160b3;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $l9s7h = $305cacda61daafb0$var$parcelRequire("l9s7h");
    class $5e07f7f42215ff3f$export$85a1c3f4199160b3 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $l9s7h.MicromUsersDef(), parentKeys);
            this.Form = Promise.resolve($305cacda61daafb0$var$parcelRequire("2uTFr")).then((module1)=>module1.MicromUsersForm);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("2uTFr", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersFormDefaultProps", function() {
        return $74b4ad43bb829977$export$e0b12d06f12bb2af;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersForm", function() {
        return $74b4ad43bb829977$export$d02b502c2d0f2ad7;
    });
    $305cacda61daafb0$var$parcelRequire("kMllr");
    var $cnfVv = $305cacda61daafb0$var$parcelRequire("cnfVv");
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    var $lMHpE = $305cacda61daafb0$var$parcelRequire("lMHpE");
    var $aOnQQ = $305cacda61daafb0$var$parcelRequire("aOnQQ");
    var $hxOxo = $305cacda61daafb0$var$parcelRequire("hxOxo");
    var $jPtkB = $305cacda61daafb0$var$parcelRequire("jPtkB");
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    var $bW9pc = $305cacda61daafb0$var$parcelRequire("bW9pc");
    const $74b4ad43bb829977$export$e0b12d06f12bb2af = {
        initialFormMode: 'view',
        disabledFalseLabel: 'The account is enabled',
        disabledTrueLabel: 'The account is disabled',
        lockedRemainingLabel: 'The account is locked. It will unlock automatically in',
        lockedTitleLabel: 'The account is locked',
        userEnabledLabel: 'The user is enabled',
        userDisabledLabel: 'The user is disabled',
        logonAttemptsStatusTitle: 'Bad login attemps',
        logonAttemptsStatusDescription: 'The account registers failed login attempts',
        minutesLabel: 'minutes',
        willUnlockInNextLogonLabel: 'Account automatic lock period has finished. It will be unlocked in the next successful logon.'
    };
    function $74b4ad43bb829977$export$d02b502c2d0f2ad7(props) {
        const { entity: entity, initialFormMode: initialFormMode, getDataOnInit: getDataOnInit, onSaved: onSaved, onCancel: onCancel, disabledFalseLabel: disabledFalseLabel, disabledTrueLabel: disabledTrueLabel, lockedRemainingLabel: lockedRemainingLabel, userDisabledLabel: userDisabledLabel, userEnabledLabel: userEnabledLabel, logonAttemptsStatusDescription: logonAttemptsStatusDescription, logonAttemptsStatusTitle: logonAttemptsStatusTitle, lockedTitleLabel: lockedTitleLabel, minutesLabel: minutesLabel, willUnlockInNextLogonLabel: willUnlockInNextLogonLabel } = (0, $64A2P.useComponentDefaultProps)('MicromUsersForm', $74b4ad43bb829977$export$e0b12d06f12bb2af, props);
        const entityForm = (0, $bW9pc.useEntityForm)({
            entity: entity,
            initialFormMode: initialFormMode,
            validateInputOnBlur: true,
            getDataOnInit: getDataOnInit,
            onSaved: onSaved,
            onCancel: onCancel
        });
        const { formMode: formMode, status: status } = entityForm;
        const MAXBADLOGON_ATTEMPTS = 10;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bHLhd.EntityForm, {
            formAPI: entityForm,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                children: [
                    formMode !== 'add' && /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                        entityForm: entityForm,
                        column: entity.def.columns.c_user_id,
                        maw: "20rem",
                        readOnly: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($lMHpE.LookupSelect, {
                        entityForm: entityForm,
                        formStatus: status,
                        entity: entity,
                        parentKeys: {},
                        column: entity.def.columns.c_usertype_id,
                        lookupDefName: entity.def.lookups.UserTypes.name,
                        selectProps: {
                            searchable: false,
                            allowDeselect: true,
                            w: "30rem",
                            required: true,
                            withAsterisk: true
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                        entityForm: entityForm,
                        column: entity.def.columns.vc_username,
                        maw: "25rem"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                        entityForm: entityForm,
                        column: entity.def.columns.vc_email,
                        required: false
                    }),
                    formMode == 'add' && /*#__PURE__*/ (0, $ayMG0.jsx)($hxOxo.PasswordField, {
                        entityForm: entityForm,
                        column: entity.def.columns.vc_password
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($cnfVv.CheckboxField, {
                        entityForm: entityForm,
                        column: entity.def.columns.bt_disabled,
                        required: false
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                        children: [
                            (!entity.def.columns.bt_islocked.value || entity.def.columns.bt_disabled.value) && /*#__PURE__*/ (0, $ayMG0.jsx)($aOnQQ.NotifyBitField, {
                                column: entity.def.columns.bt_disabled,
                                title: entity.def.columns.bt_disabled.value ? userDisabledLabel : userEnabledLabel,
                                trueMessage: disabledTrueLabel,
                                falseMessage: disabledFalseLabel,
                                withBorder: true,
                                trueColor: $aOnQQ.NotifyBitFieldDefaultProps.falseColor,
                                trueIcon: $aOnQQ.NotifyBitFieldDefaultProps.falseIcon,
                                falseColor: $aOnQQ.NotifyBitFieldDefaultProps.trueColor,
                                falseIcon: $aOnQQ.NotifyBitFieldDefaultProps.trueIcon
                            }),
                            entity.def.columns.i_badlogonattempts.value > 0 && !entity.def.columns.bt_islocked.value && entity.def.columns.i_locked_minutes_remaining.value === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($jPtkB.RingProgressField, {
                                column: entity.def.columns.i_badlogonattempts,
                                maxValue: MAXBADLOGON_ATTEMPTS,
                                color: "red",
                                title: logonAttemptsStatusTitle ?? entity.def.columns.i_badlogonattempts.prompt,
                                description: logonAttemptsStatusDescription ?? entity.def.columns.i_badlogonattempts.description,
                                maw: "25rem",
                                displayPercent: "fraction"
                            }),
                            entity.def.columns.bt_islocked.value && /*#__PURE__*/ (0, $ayMG0.jsx)($aOnQQ.NotifyBitField, {
                                column: entity.def.columns.bt_islocked,
                                title: lockedTitleLabel,
                                trueMessage: entity.def.columns.i_locked_minutes_remaining.value > 0 ? `${lockedRemainingLabel} ${entity.def.columns.i_locked_minutes_remaining.value} ${minutesLabel}` : willUnlockInNextLogonLabel,
                                falseMessage: disabledFalseLabel,
                                withBorder: true,
                                trueColor: $aOnQQ.NotifyBitFieldDefaultProps.falseColor,
                                trueIcon: $aOnQQ.NotifyBitFieldDefaultProps.falseIcon,
                                falseColor: $aOnQQ.NotifyBitFieldDefaultProps.trueColor,
                                falseIcon: $aOnQQ.NotifyBitFieldDefaultProps.trueIcon
                            })
                        ]
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("dsFjw", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUserStatusPanelColumsKeys", function() {
        return $69c73cccdfb5f6ee$export$d18493191cb5ed6f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUserStatusPanelColumns", function() {
        return $69c73cccdfb5f6ee$export$297c4f921f0d0d93;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersStatusPanelLookups", function() {
        return $69c73cccdfb5f6ee$export$c3d36a35eeba39ec;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    $305cacda61daafb0$var$parcelRequire("d699b");
    var $amyT1 = $305cacda61daafb0$var$parcelRequire("amyT1");
    const $69c73cccdfb5f6ee$export$d18493191cb5ed6f = [
        'vc_username',
        'vc_password',
        'bt_islocked',
        'bt_disabled',
        'i_bad_logon_attempts',
        'i_locked_minutes_remaining',
        'dt_locked',
        'dt_last_login',
        'dt_last_refresh',
        'vc_user_groups'
    ];
    const $69c73cccdfb5f6ee$export$297c4f921f0d0d93 = (default_groups)=>({
            vc_username: new $ZmuZ6.EntityColumn({
                name: 'vc_username',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.fake,
                prompt: 'Username'
            }),
            vc_password: new $ZmuZ6.EntityColumn({
                name: 'vc_password',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.fake | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Password'
            }),
            bt_disabled: new $ZmuZ6.EntityColumn({
                name: 'bt_disabled',
                type: 'bit',
                length: 1,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.fake,
                prompt: 'Disable user'
            }),
            bt_islocked: new $ZmuZ6.EntityColumn({
                name: 'bt_islocked',
                type: 'bit',
                length: 1,
                flags: $4H7ea.EntityColumnFlags.fake,
                prompt: 'Locked'
            }),
            i_badlogonattempts: new $ZmuZ6.EntityColumn({
                name: 'i_badlogonattempts',
                type: 'int',
                flags: $4H7ea.EntityColumnFlags.fake,
                prompt: 'Badlogonattempts'
            }),
            i_locked_minutes_remaining: new $ZmuZ6.EntityColumn({
                name: 'i_locked_minutes_remaining',
                type: 'int',
                flags: $4H7ea.EntityColumnFlags.fake,
                prompt: 'Locked minutes remaining'
            }),
            dt_locked: new $ZmuZ6.EntityColumn({
                name: 'dt_locked',
                type: 'datetime',
                flags: $4H7ea.EntityColumnFlags.fake,
                prompt: 'Date Locked'
            }),
            dt_last_login: new $ZmuZ6.EntityColumn({
                name: 'dt_last_login',
                type: 'datetime',
                flags: $4H7ea.EntityColumnFlags.fake,
                prompt: 'Last Login',
                description: 'The user last login date'
            }),
            dt_last_refresh: new $ZmuZ6.EntityColumn({
                name: 'dt_last_refresh',
                type: 'datetime',
                flags: $4H7ea.EntityColumnFlags.fake,
                prompt: 'Last Refresh',
                description: 'The user last session refresh'
            }),
            vc_user_groups: new $ZmuZ6.EntityColumn({
                name: 'vc_user_groups',
                type: 'varchar',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.fake | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'User Groups',
                isArray: true,
                defaultValue: default_groups
            })
        });
    const $69c73cccdfb5f6ee$export$c3d36a35eeba39ec = ()=>({
            'MicromUsersGroups': {
                name: 'MicromUsersGroups',
                viewMapping: {
                    keyIndex: 0,
                    descriptionIndex: 1
                },
                entityConstructor: (client, parentKeys)=>new $amyT1.MicromUsersGroups(client, parentKeys)
            }
        });
});
$305cacda61daafb0$var$parcelRegister("gzfVx", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersStatusPanelDefaultProps", function() {
        return $833d873230a657fd$export$93061ab69ef83149;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromMUsersStatusPanel", function() {
        return $833d873230a657fd$export$87fbdd8e5ef200d6;
    });
    $305cacda61daafb0$var$parcelRequire("kMllr");
    var $aOnQQ = $305cacda61daafb0$var$parcelRequire("aOnQQ");
    var $3Zdna = $305cacda61daafb0$var$parcelRequire("3Zdna");
    var $jPtkB = $305cacda61daafb0$var$parcelRequire("jPtkB");
    const $833d873230a657fd$export$93061ab69ef83149 = {
        disabledFalseLabel: 'The account is enabled',
        disabledTrueLabel: 'The account is disabled',
        lockedRemainingLabel: 'The account is locked. It will unlock automatically in',
        lockedTitleLabel: 'The account is locked',
        userEnabledLabel: 'The user is enabled',
        userDisabledLabel: 'The user is disabled',
        logonAttemptsStatusTitle: 'Bad login attemps',
        logonAttemptsStatusDescription: 'The account registers failed login attempts',
        minutesLabel: 'minutes',
        willUnlockInNextLogonLabel: 'Account automatic lock period has finished. It will be unlocked in the next successful logon.',
        loginInfoTitle: 'Login information'
    };
    function $833d873230a657fd$export$87fbdd8e5ef200d6(props) {
        const { columns: columns, userDisabledLabel: userDisabledLabel, userEnabledLabel: userEnabledLabel, disabledTrueLabel: disabledTrueLabel, disabledFalseLabel: disabledFalseLabel, entityForm: entityForm, maxBadLogonAttemps: maxBadLogonAttemps, logonAttemptsStatusTitle: logonAttemptsStatusTitle, logonAttemptsStatusDescription: logonAttemptsStatusDescription, lockedTitleLabel: lockedTitleLabel, minutesLabel: minutesLabel, willUnlockInNextLogonLabel: willUnlockInNextLogonLabel, lockedRemainingLabel: lockedRemainingLabel, loginInfoTitle: loginInfoTitle } = (0, $64A2P.useComponentDefaultProps)('MicromMUsersStatusPanel', $833d873230a657fd$export$93061ab69ef83149, props);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($9VIWE.Stack, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($3Zdna.NotifyInfo, {
                        title: loginInfoTitle,
                        withBorder: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                            size: "xs",
                            color: "dimmed",
                            children: [
                                columns.dt_last_login.value ? `Last login: ${columns.dt_last_login.value.toLocaleString()}` : 'No login registered',
                                columns.dt_last_refresh.value ? `, Last refresh: ${columns.dt_last_refresh.value.toLocaleString()}` : ', No refresh registered'
                            ]
                        })
                    }),
                    (!columns.bt_islocked.value || columns.bt_disabled.value) && /*#__PURE__*/ (0, $ayMG0.jsx)($aOnQQ.NotifyBitField, {
                        column: columns.bt_disabled,
                        title: columns.bt_disabled.value ? userDisabledLabel : userEnabledLabel,
                        trueMessage: disabledTrueLabel,
                        falseMessage: disabledFalseLabel,
                        withBorder: true,
                        trueColor: $aOnQQ.NotifyBitFieldDefaultProps.falseColor,
                        trueIcon: $aOnQQ.NotifyBitFieldDefaultProps.falseIcon,
                        falseColor: $aOnQQ.NotifyBitFieldDefaultProps.trueColor,
                        falseIcon: $aOnQQ.NotifyBitFieldDefaultProps.trueIcon
                    }),
                    columns.i_badlogonattempts.value > 0 && !columns.bt_islocked.value && columns.i_locked_minutes_remaining.value === 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($jPtkB.RingProgressField, {
                        column: columns.i_badlogonattempts,
                        maxValue: maxBadLogonAttemps,
                        color: "red",
                        title: logonAttemptsStatusTitle ?? columns.i_badlogonattempts.prompt,
                        description: logonAttemptsStatusDescription ?? columns.i_badlogonattempts.description,
                        maw: "25rem",
                        displayPercent: "fraction"
                    }),
                    columns.bt_islocked.value && /*#__PURE__*/ (0, $ayMG0.jsx)($aOnQQ.NotifyBitField, {
                        column: columns.bt_islocked,
                        title: lockedTitleLabel,
                        trueMessage: columns.i_locked_minutes_remaining.value > 0 ? `${lockedRemainingLabel} ${columns.i_locked_minutes_remaining.value} ${minutesLabel}` : willUnlockInNextLogonLabel,
                        falseMessage: disabledFalseLabel,
                        withBorder: true,
                        trueColor: $aOnQQ.NotifyBitFieldDefaultProps.falseColor,
                        trueIcon: $aOnQQ.NotifyBitFieldDefaultProps.falseIcon,
                        falseColor: $aOnQQ.NotifyBitFieldDefaultProps.trueColor,
                        falseIcon: $aOnQQ.NotifyBitFieldDefaultProps.trueIcon
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("8l0hO", function(module1, exports) {
    var $dTo8S = $305cacda61daafb0$var$parcelRequire("dTo8S");
    var $lUT2t = $305cacda61daafb0$var$parcelRequire("lUT2t");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dTo8S);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $lUT2t);
});
$305cacda61daafb0$var$parcelRegister("dTo8S", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FileStoreDef", function() {
        return $5005ed132f7dfb6e$export$f6578314396ca2a8;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    const $5005ed132f7dfb6e$var$columns = ()=>({
            c_file_id: new $ZmuZ6.EntityColumn({
                name: 'c_file_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PKAutonum,
                prompt: 'File Id'
            }),
            c_fileprocess_id: new $ZmuZ6.EntityColumn({
                name: 'c_fileprocess_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.FK,
                prompt: 'Fileprocess Id'
            }),
            vc_filename: new $ZmuZ6.EntityColumn({
                name: 'vc_filename',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Filename'
            }),
            vc_filefolder: new $ZmuZ6.EntityColumn({
                name: 'vc_filefolder',
                type: 'char',
                length: 6,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Filefolder'
            }),
            vc_fileguid: new $ZmuZ6.EntityColumn({
                name: 'vc_fileguid',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Fileguid'
            }),
            bi_filesize: new $ZmuZ6.EntityColumn({
                name: 'i_filesize',
                type: 'bigint',
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Size'
            }),
            c_fileuploadstatus_id: new $ZmuZ6.EntityColumn({
                name: 'c_fileuploadstatus_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Fileuploadstatus Id'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $5005ed132f7dfb6e$var$views = ()=>({
            fst_brwStandard: {
                name: 'fst_brwStandard',
                keyMappings: {
                    c_file_id: 0
                }
            },
            fst_brwFiles: {
                name: 'fst_brwFiles',
                keyMappings: {
                    c_file_id: 0,
                    c_fileprocess_id: -1
                }
            }
        });
    class $5005ed132f7dfb6e$export$f6578314396ca2a8 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('FileStore'), this.columns = $5005ed132f7dfb6e$var$columns(), this.views = $5005ed132f7dfb6e$var$views();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("lUT2t", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FileStore", function() {
        return $ddaee59ee346377b$export$421c297c95d1c870;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $dTo8S = $305cacda61daafb0$var$parcelRequire("dTo8S");
    class $ddaee59ee346377b$export$421c297c95d1c870 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $dTo8S.FileStoreDef(), parentKeys);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("8SEtB", function(module1, exports) {
    var $g0hVw = $305cacda61daafb0$var$parcelRequire("g0hVw");
    var $90Aj1 = $305cacda61daafb0$var$parcelRequire("90Aj1");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $g0hVw);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $90Aj1);
});
$305cacda61daafb0$var$parcelRegister("g0hVw", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FileStoreStatusDef", function() {
        return $6248fb85755d9ccc$export$3c917aa293bc31f5;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    const $6248fb85755d9ccc$var$columns = ()=>({
            c_file_id: new $ZmuZ6.EntityColumn({
                name: 'c_file_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'File Id'
            }),
            c_status_id: new $ZmuZ6.EntityColumn({
                name: 'c_status_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'Status Id'
            }),
            c_statusvalue_id: new $ZmuZ6.EntityColumn({
                name: 'c_statusvalue_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.FK,
                prompt: 'Statusvalue Id'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $6248fb85755d9ccc$var$views = ()=>({
            fsts_brwStandard: {
                name: 'fsts_brwStandard',
                keyMappings: {
                    c_status_id: 0
                }
            }
        });
    class $6248fb85755d9ccc$export$3c917aa293bc31f5 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('FileStoreStatus'), this.columns = $6248fb85755d9ccc$var$columns(), this.views = $6248fb85755d9ccc$var$views();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("90Aj1", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FileStoreStatus", function() {
        return $93955a0fa42b98bc$export$7acf86032b0a34fb;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $g0hVw = $305cacda61daafb0$var$parcelRequire("g0hVw");
    class $93955a0fa42b98bc$export$7acf86032b0a34fb extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $g0hVw.FileStoreStatusDef(), parentKeys);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("2QSEc", function(module1, exports) {
    var $kSODp = $305cacda61daafb0$var$parcelRequire("kSODp");
    var $cqnlV = $305cacda61daafb0$var$parcelRequire("cqnlV");
    var $kOwgX = $305cacda61daafb0$var$parcelRequire("kOwgX");
    var $kmfQe = $305cacda61daafb0$var$parcelRequire("kmfQe");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kSODp);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cqnlV);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kOwgX);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $kmfQe);
});
$305cacda61daafb0$var$parcelRegister("kSODp", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "StatusDef", function() {
        return $42aae91fc9f84000$export$1e1a5459a1915f78;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    const $42aae91fc9f84000$var$columns = ()=>({
            c_status_id: new $ZmuZ6.EntityColumn({
                name: 'c_status_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'Status Id'
            }),
            vc_description: new $ZmuZ6.EntityColumn({
                name: 'vc_description',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Description'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $42aae91fc9f84000$var$views = ()=>({
            sta_brwStandard: {
                name: 'sta_brwStandard',
                keyMappings: {
                    c_status_id: 0
                }
            }
        });
    class $42aae91fc9f84000$export$1e1a5459a1915f78 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('Status'), this.columns = $42aae91fc9f84000$var$columns(), this.views = $42aae91fc9f84000$var$views();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("cqnlV", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "Status", function() {
        return $02730700f379a05b$export$96e9906d6d93a972;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $kSODp = $305cacda61daafb0$var$parcelRequire("kSODp");
    class $02730700f379a05b$export$96e9906d6d93a972 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $kSODp.StatusDef(), parentKeys);
        //this.Form = import('./StatusForm').then((module) => module.StatusForm);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("kOwgX", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "StatusValuesDef", function() {
        return $b629929dbb61a358$export$3082ec53e07a2416;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    const $b629929dbb61a358$var$columns = ()=>({
            c_status_id: new $ZmuZ6.EntityColumn({
                name: 'c_status_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'Status Id'
            }),
            c_statusvalue_id: new $ZmuZ6.EntityColumn({
                name: 'c_statusvalue_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'Statusvalue Id'
            }),
            vc_description: new $ZmuZ6.EntityColumn({
                name: 'vc_description',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Description'
            }),
            bt_initial_value: new $ZmuZ6.EntityColumn({
                name: 'bt_initial_value',
                type: 'bit',
                flags: $4H7ea.CommonFlags.Edit,
                prompt: 'Initial Value'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $b629929dbb61a358$var$views = ()=>({
            stv_brwStandard: {
                name: 'stv_brwStandard',
                keyMappings: {
                    c_statusvalue_id: 0
                }
            }
        });
    class $b629929dbb61a358$export$3082ec53e07a2416 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('StatusValues'), this.columns = $b629929dbb61a358$var$columns(), this.views = $b629929dbb61a358$var$views();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("kmfQe", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "StatusValues", function() {
        return $61918f06a0145182$export$ba7d7833b136ad81;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $kOwgX = $305cacda61daafb0$var$parcelRequire("kOwgX");
    class $61918f06a0145182$export$ba7d7833b136ad81 extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $kOwgX.StatusValuesDef(), parentKeys);
            this.Form = Promise.resolve($305cacda61daafb0$var$parcelRequire("5cUzS")).then((module1)=>module1.AutoForm);
        }
    }
});
$305cacda61daafb0$var$parcelRegister("7bBKi", function(module1, exports) {
    var $2J0Qx = $305cacda61daafb0$var$parcelRequire("2J0Qx");
    var $cQWqk = $305cacda61daafb0$var$parcelRequire("cQWqk");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2J0Qx);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cQWqk);
});
$305cacda61daafb0$var$parcelRegister("2J0Qx", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMembersDef", function() {
        return $d7255c33079f8d47$export$ea80a5bcd9eb1259;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    var $i1pIT = $305cacda61daafb0$var$parcelRequire("i1pIT");
    var $amyT1 = $305cacda61daafb0$var$parcelRequire("amyT1");
    const $d7255c33079f8d47$var$columns = ()=>({
            c_user_group_id: new $ZmuZ6.EntityColumn({
                name: 'c_user_group_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'User Group Id'
            }),
            c_user_id: new $ZmuZ6.EntityColumn({
                name: 'c_user_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'User Id'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $d7255c33079f8d47$var$views = ()=>({
            mgm_brwStandard: {
                name: 'mgm_brwStandard',
                keyMappings: {
                    c_user_id: 0
                }
            }
        });
    const $d7255c33079f8d47$var$lookups = ()=>({
            'MicromUsers': {
                name: 'MicromUsers',
                viewMapping: {
                    keyIndex: 0,
                    descriptionIndex: 1
                },
                entityConstructor: (client, parentKeys)=>new $i1pIT.MicromUsers(client, parentKeys)
            },
            'MicromUsersGroups': {
                name: 'MicromUsersGroups',
                viewMapping: {
                    keyIndex: 0,
                    descriptionIndex: 1
                },
                entityConstructor: (client, parentKeys)=>new $amyT1.MicromUsersGroups(client, parentKeys)
            }
        });
    class $d7255c33079f8d47$export$ea80a5bcd9eb1259 extends $5Sq1V.EntityDefinition {
        constructor(){
            super('MicromUsersGroupsMembers'), this.columns = $d7255c33079f8d47$var$columns(), this.views = $d7255c33079f8d47$var$views(), this.lookups = $d7255c33079f8d47$var$lookups();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("cQWqk", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MicromUsersGroupsMembers", function() {
        return $9da358f0c9a47086$export$36f2c749f9ebb4fa;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $2J0Qx = $305cacda61daafb0$var$parcelRequire("2J0Qx");
    class $9da358f0c9a47086$export$36f2c749f9ebb4fa extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $2J0Qx.MicromUsersGroupsMembersDef(), parentKeys);
            this.Form = 'AutoForm';
            this.Title = "Microm Users Groups Members";
        }
    }
});
$305cacda61daafb0$var$parcelRegister("ayEmx", function(module1, exports) {
    var $3rYji = $305cacda61daafb0$var$parcelRequire("3rYji");
    var $fyjOM = $305cacda61daafb0$var$parcelRequire("fyjOM");
    var $dOSKU = $305cacda61daafb0$var$parcelRequire("dOSKU");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $3rYji);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $fyjOM);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $dOSKU);
});
$305cacda61daafb0$var$parcelRegister("kPemU", function(module1, exports) {
    var $cXOWq = $305cacda61daafb0$var$parcelRequire("cXOWq");
    var $7ru9a = $305cacda61daafb0$var$parcelRequire("7ru9a");
    var $jZWka = $305cacda61daafb0$var$parcelRequire("jZWka");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $cXOWq);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $7ru9a);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $jZWka);
});
$305cacda61daafb0$var$parcelRegister("cXOWq", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailServiceConfigurationDef", function() {
        return $1237fda62aa33d1c$export$7a2647576e47534b;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $bmxG4 = $305cacda61daafb0$var$parcelRequire("bmxG4");
    var $ZmuZ6 = $305cacda61daafb0$var$parcelRequire("ZmuZ6");
    var $5Sq1V = $305cacda61daafb0$var$parcelRequire("5Sq1V");
    const $1237fda62aa33d1c$var$columns = ()=>({
            c_email_configuration_id: new $ZmuZ6.EntityColumn({
                name: 'c_email_configuration_id',
                type: 'char',
                length: 20,
                flags: $4H7ea.CommonFlags.PK,
                prompt: 'Email Configuration Id'
            }),
            vc_smtp_host: new $ZmuZ6.EntityColumn({
                name: 'vc_smtp_host',
                type: 'varchar',
                length: 2048,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Smtp Host',
                description: 'The host of the smtp server',
                placeholder: 'smtp.gmail.com'
            }),
            i_smtp_port: new $ZmuZ6.EntityColumn({
                name: 'i_smtp_port',
                type: 'int',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Smtp Port',
                description: 'The port of the smtp server',
                placeholder: '465'
            }),
            vc_user_name: new $ZmuZ6.EntityColumn({
                name: 'vc_user_name',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Smtp Username',
                description: 'The username for the smtp server'
            }),
            vc_password: new $ZmuZ6.EntityColumn({
                name: 'vc_password',
                type: 'varchar',
                length: 2048,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Smtp Password',
                description: 'The password for the smtp server'
            }),
            bt_use_ssl: new $ZmuZ6.EntityColumn({
                name: 'bt_use_ssl',
                type: 'bit',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Use Ssl',
                description: 'Use ssl for the smtp server'
            }),
            vc_default_sender_email: new $ZmuZ6.EntityColumn({
                name: 'vc_default_sender_email',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Default Sender Email',
                description: 'The default sender email address'
            }),
            vc_default_sender_name: new $ZmuZ6.EntityColumn({
                name: 'vc_default_sender_name',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Default Sender Name',
                description: 'The default sender name'
            }),
            vc_template_subject: new $ZmuZ6.EntityColumn({
                name: 'vc_template_subject',
                type: 'varchar',
                length: 255,
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Subject',
                description: 'The subject for the recovery email',
                defaultValue: 'Password recovery',
                placeholder: 'Password recovery'
            }),
            vc_template_body: new $ZmuZ6.EntityColumn({
                name: 'vc_template_body',
                type: 'varchar',
                flags: $4H7ea.CommonFlags.Edit | $4H7ea.EntityColumnFlags.nullable,
                prompt: 'Message',
                description: 'The message body for the recovery email',
                defaultValue: 'You have requested an email to recover your password.\n\nPlease follow this link to set your new password: https://<YOUR_SITE>/recover/?code={RECOVERY_CODE}\n\nThe support team.',
                placeholder: 'You have requested an email to recover your password.\n\nPlease follow this link to set your new password: https://<YOUR_SITE>/recover/?code={RECOVERY_CODE}\n\nThe support team.'
            }),
            ...(0, $bmxG4.DefaultColumns)()
        });
    const $1237fda62aa33d1c$var$views = ()=>({
            eqc_brwStandard: {
                name: 'eqc_brwStandard',
                keyMappings: {
                    c_email_configuration_id: 0
                }
            }
        });
    class $1237fda62aa33d1c$export$7a2647576e47534b extends $5Sq1V.EntityDefinition {
        constructor(){
            super('EmailServiceConfiguration'), this.columns = $1237fda62aa33d1c$var$columns(), this.views = $1237fda62aa33d1c$var$views();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("7ru9a", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailServiceConfigurationIcon", function() {
        return $9ceaecd36aa6a467$export$4e6d3dfc9604c036;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailServiceConfigurationHelpText", function() {
        return $9ceaecd36aa6a467$export$7554523e2cf45510;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailServiceConfigurationTitle", function() {
        return $9ceaecd36aa6a467$export$c781d554dde14084;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailServiceConfiguration", function() {
        return $9ceaecd36aa6a467$export$50886e6f4e86442d;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $bFPBM = $305cacda61daafb0$var$parcelRequire("bFPBM");
    var $cXOWq = $305cacda61daafb0$var$parcelRequire("cXOWq");
    const $9ceaecd36aa6a467$export$4e6d3dfc9604c036 = $gt7Cd.default;
    const $9ceaecd36aa6a467$export$7554523e2cf45510 = '* Configure your email server settings.';
    const $9ceaecd36aa6a467$export$c781d554dde14084 = 'Email Service Configuration';
    class $9ceaecd36aa6a467$export$50886e6f4e86442d extends $bFPBM.Entity {
        constructor(client, parentKeys = {}){
            super(client, new $cXOWq.EmailServiceConfigurationDef(), parentKeys);
            this.Form = Promise.resolve($305cacda61daafb0$var$parcelRequire("jZWka")).then((module1)=>module1.EmailServiceConfigurationForm);
            this.Title = $9ceaecd36aa6a467$export$c781d554dde14084;
            this.HelpText = $9ceaecd36aa6a467$export$7554523e2cf45510;
            this.Icon = $9ceaecd36aa6a467$export$4e6d3dfc9604c036;
            this.def.columns.c_email_configuration_id.value = client.getAPPID();
        }
    }
});
$305cacda61daafb0$var$parcelRegister("jZWka", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailServiceConfigurationFormDefaultProps", function() {
        return $1dd8971e124a55dc$export$f8647476785d8581;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EmailServiceConfigurationForm", function() {
        return $1dd8971e124a55dc$export$adb90ec1642c2b9e;
    });
    $305cacda61daafb0$var$parcelRequire("kMllr");
    var $cnfVv = $305cacda61daafb0$var$parcelRequire("cnfVv");
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    var $6pUmH = $305cacda61daafb0$var$parcelRequire("6pUmH");
    var $hxOxo = $305cacda61daafb0$var$parcelRequire("hxOxo");
    var $hv0CN = $305cacda61daafb0$var$parcelRequire("hv0CN");
    var $RUzV3 = $305cacda61daafb0$var$parcelRequire("RUzV3");
    var $bW9pc = $305cacda61daafb0$var$parcelRequire("bW9pc");
    const $1dd8971e124a55dc$export$f8647476785d8581 = {
        initialFormMode: "view",
        settingsTABIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($gt7Cd.default, {
            size: "1rem"
        }),
        settingsTABLabel: 'Settings',
        recoveryTABIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($anH21.default, {
            size: "1rem"
        }),
        recoveryTABLabel: 'Recovery template',
        setDefaultMessageButtonLabel: 'Set default message'
    };
    const $1dd8971e124a55dc$var$TN = {
        settings: 'settings',
        recovery: 'recovery'
    };
    function $1dd8971e124a55dc$export$adb90ec1642c2b9e(props) {
        const { entity: entity, initialFormMode: initialFormMode, getDataOnInit: getDataOnInit, onSaved: onSaved, onCancel: onCancel, settingsTABLabel: settingsTABLabel, settingsTABIcon: settingsTABIcon, recoveryTABLabel: recoveryTABLabel, recoveryTABIcon: recoveryTABIcon, setDefaultMessageButtonLabel: setDefaultMessageButtonLabel } = (0, $64A2P.useComponentDefaultProps)('EmailServiceConfiguration', $1dd8971e124a55dc$export$f8647476785d8581, props);
        const formAPI = (0, $bW9pc.useEntityForm)({
            entity: entity,
            initialFormMode: initialFormMode,
            getDataOnInit: getDataOnInit,
            onSaved: onSaved,
            onCancel: onCancel
        });
        const { formMode: formMode, status: status, form: form } = formAPI;
        const theme = (0, $64A2P.useMantineTheme)();
        const minFormHeight = '75vh';
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bHLhd.EntityForm, {
            formAPI: formAPI,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9VIWE.Stack, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card, {
                    bg: theme.colorScheme === 'dark' ? theme.colors.dark[9] : undefined,
                    withBorder: theme.colorScheme === 'dark' ? false : true,
                    mih: "65vh",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($hUms8.Tabs, {
                        defaultValue: $1dd8971e124a55dc$var$TN.settings,
                        mih: minFormHeight,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($hUms8.Tabs.List, {
                                mb: "xs",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                        value: $1dd8971e124a55dc$var$TN.settings,
                                        icon: settingsTABIcon,
                                        children: settingsTABLabel
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Tab, {
                                        value: $1dd8971e124a55dc$var$TN.recovery,
                                        icon: recoveryTABIcon,
                                        children: recoveryTABLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                                value: $1dd8971e124a55dc$var$TN.settings,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.vc_smtp_host
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($6pUmH.NumberField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.i_smtp_port,
                                            maw: "20rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.vc_user_name,
                                            maw: "20rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($hxOxo.PasswordField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.vc_password,
                                            maw: "20rem"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($cnfVv.CheckboxField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.bt_use_ssl
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($fnRsm.Divider, {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.vc_default_sender_email
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.vc_default_sender_name
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($hUms8.Tabs.Panel, {
                                value: $1dd8971e124a55dc$var$TN.recovery,
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($RUzV3.TextField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.vc_template_subject
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($hv0CN.TextAreaField, {
                                            entityForm: formAPI,
                                            column: entity.def.columns.vc_template_body,
                                            minRows: 10,
                                            maxRows: 10
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                                variant: "outline",
                                                onClick: ()=>{
                                                    form.setFieldValue(entity.def.columns.vc_template_subject.name, entity.def.columns.vc_template_subject.defaultValue);
                                                    form.setFieldValue(entity.def.columns.vc_template_body.name, entity.def.columns.vc_template_body.defaultValue);
                                                },
                                                children: setDefaultMessageButtonLabel
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("1F7Wv", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ImageEditor", function() {
        return $35745da8be2e2bdc$export$d0486c7a5136628;
    });
    const $35745da8be2e2bdc$export$d0486c7a5136628 = ({ src: src, onOk: onOk })=>{
        const cropperRef = (0, $acw62.useRef)(null);
        const previewRef = (0, $acw62.useRef)(null);
        const { colorScheme: colorScheme } = (0, $8TaxK.useMantineColorScheme)();
        //const [src, setSrc] = useState(require("./photo.jpeg"));
        const [mode, setMode] = (0, $acw62.useState)("crop");
        const [adjustments, setAdjustments] = (0, $acw62.useState)({
            brightness: 0,
            hue: 0,
            saturation: 0,
            contrast: 0
        });
        const onChangeValue = (value)=>{
            if (mode in adjustments) setAdjustments((previousValue)=>({
                    ...previousValue,
                    [mode]: value
                }));
        };
        const onReset = ()=>{
            setMode("crop");
            setAdjustments({
                brightness: 0,
                hue: 0,
                saturation: 0,
                contrast: 0
            });
        };
        // const onUpload = (blob: string) => {
        //   onReset();
        //   setMode("crop");
        //   setSrc(blob);
        // };
        const onNavigationOk = ()=>{
            if (cropperRef.current) // if (newTab) {
            //   newTab.document.body.innerHTML = `<img src="${cropperRef.current
            //     .getCanvas()
            //     ?.toDataURL()}"/>`;
            // }
            //TODO: loading
            cropperRef.current.getCanvas()?.toBlob((imageBlob)=>{
                if (imageBlob) onOk(imageBlob);
            });
        };
        const onUpdate = ()=>{
            previewRef.current?.refresh();
        };
        const changed = Object.values(adjustments).some((el)=>Math.floor(el * 100));
        const cropperEnabled = mode === "crop";
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "image-editor",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "image-editor__cropper",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($gbPMS.Cropper, {
                            src: src,
                            ref: cropperRef,
                            stencilProps: {
                                movable: cropperEnabled,
                                resizable: cropperEnabled,
                                lines: cropperEnabled,
                                handlers: cropperEnabled,
                                overlayClassName: $35745da8be2e2bdc$var$cn("image-editor__cropper-overlay", !cropperEnabled && "image-editor__cropper-overlay--faded")
                            },
                            backgroundWrapperProps: {
                                scaleImage: cropperEnabled,
                                moveImage: cropperEnabled
                            },
                            backgroundComponent: $35745da8be2e2bdc$export$7a5d730e49a567e2,
                            backgroundProps: adjustments,
                            onUpdate: onUpdate
                        }),
                        mode !== "crop" && /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$472062a354075cee, {
                            className: "image-editor__slider",
                            value: adjustments[mode],
                            onChange: onChangeValue
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($gbPMS.CropperPreview, {
                            className: "image-editor__preview",
                            ref: previewRef,
                            cropper: cropperRef,
                            backgroundComponent: $35745da8be2e2bdc$export$c3779be38ba2f899,
                            backgroundProps: adjustments
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$353f5b6fc5456de1, {
                            className: $35745da8be2e2bdc$var$cn("image-editor__reset-button", !changed && "image-editor__reset-button--hidden"),
                            onClick: onReset,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($grSkg.default, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$b8a61e5c71402559, {
                    mode: mode,
                    onChange: setMode,
                    //onUpload={onUpload}
                    onOk: onNavigationOk
                })
            ]
        });
    };
    function $35745da8be2e2bdc$export$472062a354075cee(props) {
        const { colorScheme: colorScheme } = (0, $8TaxK.useMantineColorScheme)();
        return /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$var$SliderInternal, {
            colorScheme: colorScheme,
            ...props
        });
    }
    class $35745da8be2e2bdc$var$SliderInternal extends $acw62.PureComponent {
        componentDidMount() {
            window.addEventListener("resize", this.recalculateWidth);
            window.addEventListener("orientationchange", this.recalculateWidth);
            window.addEventListener("mouseup", this.onStop, {
                passive: false
            });
            window.addEventListener("mousemove", this.onDrag, {
                passive: false
            });
            window.addEventListener("touchmove", this.onDrag, {
                passive: false
            });
            window.addEventListener("touchend", this.onStop, {
                passive: false
            });
            const line = this.line.current;
            if (line) {
                line.addEventListener("mousedown", this.onStart);
                line.addEventListener("touchstart", this.onStart);
            }
            this.recalculateWidth();
        }
        componentWillUnmount() {
            window.removeEventListener("mouseup", this.onStop);
            window.removeEventListener("mousemove", this.onDrag);
            window.removeEventListener("touchmove", this.onDrag);
            window.removeEventListener("touchend", this.onStop);
            window.removeEventListener("resize", this.recalculateWidth);
            window.removeEventListener("orientationchange", this.recalculateWidth);
            const line = this.line.current;
            if (line) {
                line.removeEventListener("mousedown", this.onStart);
                line.removeEventListener("touchstart", this.onStart);
            }
        }
        render() {
            const { value: value = 0, className: className } = this.props;
            const handleInsideDot = this.state.width ? Math.abs(value) <= 16 / this.state.width : true;
            const fillWidth = `${Math.abs(value) * 50}%`;
            const fillLeft = `${50 * (1 - Math.abs(Math.min(0, value)))}%`;
            const formattedValue = `${value > 0 ? "+" : ""}${Math.round(100 * value)}`;
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: $35745da8be2e2bdc$var$cn("image-editor-slider", className),
                ref: this.line,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "image-editor-slider__line",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "image-editor-slider__fill",
                            style: {
                                width: fillWidth,
                                left: fillLeft
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "image-editor-slider__dot"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: $35745da8be2e2bdc$var$cn("image-editor-slider__value", handleInsideDot && "image-editor-slider__value--hidden"),
                            style: {
                                left: `${Math.abs(value * 50 + 50)}%`
                            },
                            children: formattedValue
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: $35745da8be2e2bdc$var$cn("image-editor-slider__handler", this.state.focus && "image-editor-slider__handler--focus", handleInsideDot && "image-editor-slider__handler--hidden"),
                            style: {
                                left: `${value * 50 + 50}%`
                            }
                        })
                    ]
                })
            });
        }
        constructor(...args){
            super(...args), this.line = $305cacda61daafb0$var$$parcel$interopDefault($acw62).createRef(), this.state = {
                focus: false,
                width: 0
            }, this.onDrag = (e)=>{
                const { onChange: onChange } = this.props;
                if (this.state.focus) {
                    const position = "touches" in e ? e.touches[0].clientX : e.clientX;
                    const line = this.line.current;
                    if (line) {
                        const { left: left, width: width } = line.getBoundingClientRect();
                        if (onChange) onChange(Math.max(-1, Math.min(1, 2 * (position - left - width / 2) / width)));
                    }
                    if (e.preventDefault) e.preventDefault();
                }
            }, this.onStop = ()=>{
                this.setState({
                    focus: false
                });
            }, this.onStart = (e)=>{
                this.setState({
                    focus: true
                });
                this.onDrag(e);
            }, this.recalculateWidth = ()=>{
                const line = this.line.current;
                if (line) this.setState({
                    width: line.clientWidth
                });
            };
        }
    }
    const $35745da8be2e2bdc$export$b8a61e5c71402559 = ({ className: className, onChange: onChange, onOk: onOk, mode: mode })=>{
        const { colorScheme: colorScheme } = (0, $8TaxK.useMantineColorScheme)();
        const setMode = (mode)=>()=>{
                onChange?.(mode);
            };
        //const inputRef = useRef<HTMLInputElement>(null);
        // const onUploadButtonClick = () => {
        //   inputRef.current?.click();
        // };
        // const onLoadImage = (event: ChangeEvent<HTMLInputElement>) => {
        //   // Reference to the DOM input element
        //   const { files } = event.target;
        //   // Ensure that you have a file before attempting to read it
        //   if (files && files[0]) {
        //     if (onUpload) {
        //       onUpload(URL.createObjectURL(files[0]));
        //     }
        //   }
        //   // Clear the event target value to give the possibility to upload the same image:
        //   event.target.value = "";
        // };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: $35745da8be2e2bdc$var$cn("image-editor-navigation", className),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "image-editor-navigation__buttons",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$353f5b6fc5456de1, {
                            className: "image-editor-navigation__button",
                            active: mode === "crop",
                            onClick: setMode("crop"),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($hi1Sd.default, {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$353f5b6fc5456de1, {
                            className: "image-editor-navigation__button",
                            active: mode === "saturation",
                            onClick: setMode("saturation"),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($gzKDM.default, {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$353f5b6fc5456de1, {
                            className: "image-editor-navigation__button",
                            active: mode === "brightness",
                            onClick: setMode("brightness"),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($gxhlI.default, {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$353f5b6fc5456de1, {
                            className: "image-editor-navigation__button",
                            active: mode === "contrast",
                            onClick: setMode("contrast"),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($3s7Bt.default, {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$353f5b6fc5456de1, {
                            className: "image-editor-navigation__button",
                            active: mode === "hue",
                            onClick: setMode("hue"),
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($jKnNH.default, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$353f5b6fc5456de1, {
                    className: "image-editor-navigation__button__ok",
                    onClick: onOk,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1MBwp.default, {})
                })
            ]
        });
    };
    const $35745da8be2e2bdc$export$353f5b6fc5456de1 = ({ className: className, active: active, children: children, ...props })=>{
        const { colorScheme: colorScheme } = (0, $8TaxK.useMantineColorScheme)();
        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
            className: $35745da8be2e2bdc$var$cn('image-editor-button', active && 'image-editor-button--active', className),
            ...props,
            children: children
        });
    };
    const $35745da8be2e2bdc$export$c3779be38ba2f899 = ({ className: className, cropper: cropper, crossOrigin: crossOrigin, brightness: brightness = 0, saturation: saturation = 0, hue: hue = 0, contrast: contrast = 0, size: size })=>{
        const state = cropper.getState();
        const transitions = cropper.getTransitions();
        const image = cropper.getImage();
        const style = image && state && size ? (0, $gbPMS.getPreviewStyle)(image, state, size, transitions) : {};
        return /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$505b54ea2a0b980b, {
            src: image?.src,
            crossOrigin: crossOrigin,
            brightness: brightness,
            saturation: saturation,
            hue: hue,
            contrast: contrast,
            className: className,
            style: style
        });
    };
    const $35745da8be2e2bdc$export$505b54ea2a0b980b = /*#__PURE__*/ (0, $acw62.forwardRef)(({ src: src, className: className, crossOrigin: crossOrigin, brightness: brightness = 0, saturation: saturation = 0, hue: hue = 0, contrast: contrast = 0, style: style }, ref)=>{
        const imageRef = (0, $acw62.useRef)(null);
        const canvasRef = (0, $acw62.useRef)(null);
        const drawImage = ()=>{
            const image = imageRef.current;
            const canvas = canvasRef.current;
            if (canvas && image && image.complete) {
                const ctx = canvas.getContext('2d');
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;
                if (ctx) {
                    ctx.filter = [
                        `brightness(${100 + brightness * 100}%)`,
                        `contrast(${100 + contrast * 100}%)`,
                        `saturate(${100 + saturation * 100}%)`,
                        `hue-rotate(${hue * 360}deg)`
                    ].join(' ');
                    ctx.drawImage(image, 0, 0, image.naturalWidth, image.naturalHeight);
                }
            }
        };
        (0, $acw62.useLayoutEffect)(()=>{
            drawImage();
        }, [
            src,
            brightness,
            saturation,
            hue,
            contrast
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("canvas", {
                    ref: (0, $gbPMS.mergeRefs)([
                        ref,
                        canvasRef
                    ]),
                    className: $35745da8be2e2bdc$var$cn('adjustable-image-element', className),
                    style: style
                }, `${src}-canvas`),
                src ? /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    ref: imageRef,
                    className: 'adjustable-image-source',
                    src: src,
                    crossOrigin: crossOrigin === true ? 'anonymous' : crossOrigin || undefined,
                    onLoad: drawImage
                }, `${src}-img`) : null
            ]
        });
    });
    $35745da8be2e2bdc$export$505b54ea2a0b980b.displayName = 'AdjustableImage';
    const $35745da8be2e2bdc$export$7a5d730e49a567e2 = /*#__PURE__*/ (0, $acw62.forwardRef)(({ className: className, cropper: cropper, crossOrigin: crossOrigin, brightness: brightness = 0, saturation: saturation = 0, hue: hue = 0, contrast: contrast = 0 }, ref)=>{
        const state = cropper.getState();
        const transitions = cropper.getTransitions();
        const image = cropper.getImage();
        const style = image && state ? (0, $gbPMS.getBackgroundStyle)(image, state, transitions) : {};
        return /*#__PURE__*/ (0, $ayMG0.jsx)($35745da8be2e2bdc$export$505b54ea2a0b980b, {
            src: image?.src,
            crossOrigin: crossOrigin,
            brightness: brightness,
            saturation: saturation,
            hue: hue,
            contrast: contrast,
            ref: ref,
            className: className,
            style: style
        });
    });
    $35745da8be2e2bdc$export$7a5d730e49a567e2.displayName = 'AdjustableCropperBackground';
    const $35745da8be2e2bdc$var$hasOwn = {}.hasOwnProperty;
    function $35745da8be2e2bdc$var$classNames(...args) {
        let classes = '';
        for(let i = 0; i < args.length; i++){
            const arg = args[i];
            if (arg) classes = $35745da8be2e2bdc$var$appendClass(classes, $35745da8be2e2bdc$var$parseValue(arg));
        }
        return classes;
    }
    const $35745da8be2e2bdc$var$cn = $35745da8be2e2bdc$var$classNames;
    function $35745da8be2e2bdc$var$parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg.toString();
        if (typeof arg !== 'object' || arg === null) return '';
        if (Array.isArray(arg)) return $35745da8be2e2bdc$var$classNames(...arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        let classes = '';
        for(const key in arg)if (Object.prototype.hasOwnProperty.call(arg, key) && arg[key]) classes = $35745da8be2e2bdc$var$appendClass(classes, key);
        return classes;
    }
    function $35745da8be2e2bdc$var$appendClass(value, newClass) {
        if (!newClass) return value;
        return value ? `${value} ${newClass}` : newClass;
    }
});
$305cacda61daafb0$var$parcelRegister("lTrOu", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FileUploaderDefaultProps", function() {
        return $fee2cc872d564b4b$export$6ff6b9827853730f;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FileUploader", function() {
        return $fee2cc872d564b4b$export$1a5cb5295a7d2749;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $3HRFn = $305cacda61daafb0$var$parcelRequire("3HRFn");
    var $3Zdna = $305cacda61daafb0$var$parcelRequire("3Zdna");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    var $iOCNL = $305cacda61daafb0$var$parcelRequire("iOCNL");
    var $iSj3y = $305cacda61daafb0$var$parcelRequire("iSj3y");
    var $j2uWU = $305cacda61daafb0$var$parcelRequire("j2uWU");
    const $fee2cc872d564b4b$export$6ff6b9827853730f = {
        IdleIcon: $bfsRj.default,
        UploadText: 'Drag files here or click to select',
        EachFileShouldNotExceedText: 'each file should not exceed',
        AttachUpToText: 'Attach up to',
        FilesText: 'files',
        closeText: 'Close',
        cancelledText: 'Cancelled',
        operationCancelledText: 'Operation cancelled',
        pdfCannotBeViewedText: 'PDF cannot be displayed, download the file to view it.',
        accept: [
            'image/*'
        ],
        imageProps: {
            width: "7rem",
            height: "3.94rem",
            fit: "contain",
            withPlaceholder: true,
            mah: "3.94rem"
        },
        showCancelButton: true,
        cancelLabel: 'Cancel'
    };
    function $fee2cc872d564b4b$export$1a5cb5295a7d2749(props) {
        const { IdleIcon: IdleIcon, UploadText: UploadText, uploadAPI: uploadAPI, EachFileShouldNotExceedText: EachFileShouldNotExceedText, AttachUpToText: AttachUpToText, FilesText: FilesText, imageProps: imageProps, onDelete: onDelete, closeText: closeText, cancelledText: cancelledText, operationCancelledText: operationCancelledText, pdfCannotBeViewedText: pdfCannotBeViewedText, showCancelButton: showCancelButton, cancelLabel: cancelLabel, parentFormAPI: parentFormAPI, ...dropzoneProps } = (0, $64A2P.useComponentDefaultProps)('FileUploader', $fee2cc872d564b4b$export$6ff6b9827853730f, props);
        const { uploadFiles: uploadFiles, uploadProgress: uploadProgress, errorNotification: errorNotification, cancelledNotification: cancelledNotification, clearNotifications: clearNotifications, uploadingNotification: uploadingNotification, deleteFile: deleteFile, downloadFile: downloadFile, cancelUpload: cancelUpload, loadingNotification: loadingNotification } = uploadAPI;
        const theme = (0, $64A2P.useMantineTheme)();
        const modals = (0, $k7qj2.useModal)();
        dropzoneProps.disabled = dropzoneProps.disabled || parentFormAPI?.formMode === 'view';
        const handleUpload = async (selectedFiles)=>{
            await uploadFiles(selectedFiles);
        };
        const handleDeleteFile = async (file_id)=>{
            let result = true;
            if (onDelete) result = await onDelete(file_id);
            if (result) await deleteFile(file_id, '');
        };
        const handlePreviewImage = async (documentURL, fileName)=>{
            await modals.open({
                modalProps: {
                    size: "xl",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        fw: "700",
                        children: fileName
                    })
                },
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($iSj3y.ImagePreview, {
                    documentURL: documentURL,
                    closeText: closeText,
                    onClose: async ()=>await modals.close()
                })
            });
        };
        const handlePreviewPdf = async (documentURL, fileName)=>{
            await modals.open({
                modalProps: {
                    size: "xl",
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        fw: "700",
                        children: fileName
                    })
                },
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($j2uWU.PDFPreview, {
                    documentURL: documentURL,
                    closeText: closeText,
                    onClose: async ()=>await modals.close(),
                    filePreviewError: pdfCannotBeViewedText
                })
            });
        };
        const progressElements = Object.values(uploadProgress).map((report)=>{
            const fileType = (0, $iOCNL.getFileType)(report.file_name);
            return /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
                bg: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[3],
                w: "15rem",
                children: [
                    report.done && !report.errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                        p: "xs",
                        mb: "1rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                            position: "right",
                            children: [
                                (fileType === 'image' || fileType === 'pdf') && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                    color: theme.primaryColor,
                                    variant: "light",
                                    onClick: async ()=>fileType === 'image' ? await handlePreviewImage(report.documentURL, report.file_name) : await handlePreviewPdf(report.documentURL, report.file_name),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($jni2H.default, {
                                        size: "1rem"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                    color: theme.primaryColor,
                                    variant: "light",
                                    onClick: async ()=>await downloadFile(report.documentURL),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($vjSkT.default, {
                                        size: "1rem"
                                    })
                                }),
                                parentFormAPI?.formMode !== 'view' && /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                                    disabled: dropzoneProps.disabled,
                                    color: theme.primaryColor,
                                    variant: "light",
                                    onClick: async ()=>await handleDeleteFile(report.file_id),
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($eyDPb.default, {
                                        size: "1rem"
                                    })
                                })
                            ]
                        })
                    }),
                    !report.done && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                size: "sm",
                                color: "dimmed",
                                children: [
                                    report.file_name,
                                    " - ",
                                    report.progress,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($jMtx3.Progress, {
                                value: report.progress,
                                striped: true,
                                animate: true
                            })
                        ]
                    }),
                    report.cancelled && /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                        size: "sm",
                        color: "dimmed",
                        children: [
                            cancelledText,
                            ": ",
                            report.file_name
                        ]
                    }),
                    report.done && !report.errorMessage && fileType === 'image' && /*#__PURE__*/ (0, $ayMG0.jsx)($hiGsa.Image, {
                        ...imageProps,
                        src: report.thumbnailURL
                    }),
                    report.done && !report.errorMessage && fileType === 'pdf' && /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                        grow: true,
                        h: "9.375rem",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1bItm.default, {
                            size: "3.2rem",
                            stroke: 1.5
                        })
                    }),
                    report.done && !report.errorMessage && /*#__PURE__*/ (0, $ayMG0.jsxs)($hiiR1.Box, {
                        mt: "xs",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                size: "xs",
                                color: "dimmed",
                                truncate: true,
                                children: report.file_name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                size: "xs",
                                color: "dimmed",
                                children: [
                                    (report.file_size / 1024 ** 2).toFixed(2),
                                    "MB"
                                ]
                            })
                        ]
                    })
                ]
            }, report.status_id);
        });
        const ImageIcon = IdleIcon;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    grow: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($lF6Ws.Dropzone, {
                        ...dropzoneProps,
                        loading: uploadingNotification || loadingNotification,
                        onDrop: handleUpload,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                            position: "center",
                            spacing: "xl",
                            style: {
                                pointerEvents: 'none'
                            },
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($lF6Ws.Dropzone.Accept, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($9Q2Ky.default, {
                                        size: "3.2rem",
                                        stroke: 1.5,
                                        color: theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($lF6Ws.Dropzone.Reject, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($gv5JH.default, {
                                        size: "3.2rem",
                                        stroke: 1.5,
                                        color: theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($lF6Ws.Dropzone.Idle, {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)(ImageIcon, {
                                        size: "3.2rem",
                                        stroke: 1.5
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                            size: "xl",
                                            inline: true,
                                            children: UploadText
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                            size: "sm",
                                            color: "dimmed",
                                            inline: true,
                                            mt: 7,
                                            children: [
                                                AttachUpToText,
                                                " ",
                                                uploadAPI.maxFilesCount,
                                                " ",
                                                FilesText,
                                                ", ",
                                                EachFileShouldNotExceedText,
                                                " ",
                                                Math.round(uploadAPI.maxIndividualFileSize / 1024 ** 2),
                                                " MB"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                showCancelButton && uploadingNotification && /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        color: "red",
                        size: "sm",
                        leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($dRw7S.default, {
                            size: "1.5rem"
                        }),
                        onClick: cancelUpload,
                        children: cancelLabel
                    })
                }, "cancel"),
                (errorNotification || cancelledNotification) && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    grow: true,
                    children: [
                        errorNotification && !cancelledNotification && /*#__PURE__*/ (0, $ayMG0.jsx)($3HRFn.NotifyError, {
                            withCloseButton: true,
                            title: "",
                            onClose: clearNotifications,
                            bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                            children: errorNotification
                        }, "error"),
                        cancelledNotification && /*#__PURE__*/ (0, $ayMG0.jsx)($3Zdna.NotifyInfo, {
                            withCloseButton: true,
                            title: "",
                            onClose: clearNotifications,
                            bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                            children: operationCancelledText
                        }, "info")
                    ]
                }, "notifications"),
                progressElements.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    spacing: "xs",
                    children: progressElements
                }, "progresselements")
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("iOCNL", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getFileType", function() {
        return $c187ed0d526f8731$export$284e6e76ba5e79b9;
    });
    const $c187ed0d526f8731$export$284e6e76ba5e79b9 = (file_name)=>{
        const file_type = $305cacda61daafb0$var$$parcel$interopDefault($ehweP).getType(file_name);
        if (file_type && file_type.match('image.*')) return 'image';
        else if (file_type === 'application/pdf') return 'pdf';
        return 'other';
    };
});
$305cacda61daafb0$var$parcelRegister("iSj3y", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "ImagePreview", function() {
        return $603e714f57b4cb36$export$4a96334d5925dbf2;
    });
    function $603e714f57b4cb36$export$4a96334d5925dbf2({ documentURL: documentURL, onClose: onClose, closeText: closeText }) {
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($hiGsa.Image, {
                    height: "70vh",
                    fit: "contain",
                    src: documentURL
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        onClick: onClose,
                        children: closeText
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("j2uWU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "PDFPreviewDefaultProps", function() {
        return $4ef7141c1ad3b3da$export$c21dc030e4b1e5e7;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "PDFPreview", function() {
        return $4ef7141c1ad3b3da$export$7ebecfb0cc414db0;
    });
    const $4ef7141c1ad3b3da$export$c21dc030e4b1e5e7 = {
        filePreviewError: 'PDF cannot be displayed, download the file to view it.'
    };
    function $4ef7141c1ad3b3da$export$7ebecfb0cc414db0(props) {
        const { documentURL: documentURL, onClose: onClose, closeText: closeText, filePreviewError: filePreviewError } = (0, $64A2P.useComponentDefaultProps)('PDFPreview', $4ef7141c1ad3b3da$export$c21dc030e4b1e5e7, props);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        width: '100%',
                        height: '70vh'
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("object", {
                        data: documentURL,
                        type: "application/pdf",
                        width: "100%",
                        height: "100%",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: "sm",
                            color: "dimmed",
                            children: filePreviewError
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    position: "right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        onClick: onClose,
                        children: closeText
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("cWSrD", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FilesUploadFormDefaultProps", function() {
        return $5f012337a51d6c2c$export$aedbc77784ab0a6a;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "FilesUploadForm", function() {
        return $5f012337a51d6c2c$export$727468cb06f6a763;
    });
    var $lTrOu = $305cacda61daafb0$var$parcelRequire("lTrOu");
    var $4eryA = $305cacda61daafb0$var$parcelRequire("4eryA");
    const $5f012337a51d6c2c$export$aedbc77784ab0a6a = {
        helpMessage: "Select the files that you need and click OK",
        okLabel: "Close",
        maxIndividualFileSize: 2 * 1024 ** 2,
        maxTotalFilesSize: 10 * 1024 ** 2,
        maxFilesCount: 5
    };
    function $5f012337a51d6c2c$export$727468cb06f6a763(props) {
        const { helpMessage: helpMessage, client: client, uploaderProps: uploaderProps, okLabel: okLabel, onCancel: onCancel, maxFilesCount: maxFilesCount, maxIndividualFileSize: maxIndividualFileSize, maxTotalFilesSize: maxTotalFilesSize, onOK: onOK, fileProcessColumn: fileProcessColumn, showOKButton: showOKButton, editor: editor, onValidateFile: onValidateFile } = (0, $64A2P.useComponentDefaultProps)('FilesUploadForm', $5f012337a51d6c2c$export$aedbc77784ab0a6a, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const uploadAPI = (0, $4eryA.useFileUpload)({
            client: client,
            fileProcessColumn: fileProcessColumn,
            maxFilesCount: maxFilesCount,
            maxIndividualFileSize: maxIndividualFileSize,
            maxTotalFilesSize: maxTotalFilesSize,
            onCancel: onCancel,
            editor: editor,
            onValidateFile: onValidateFile
        });
        const { uploadingNotification: uploadingNotification } = uploadAPI;
        const handleOK = ()=>{
            if (onOK) onOK(uploadAPI.fileProcessID, uploadAPI.uploadProgress);
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($kPsAn.Card, {
                    shadow: "sm",
                    withBorder: theme.colorScheme === 'dark' ? false : true,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($kPsAn.Card.Section, {
                            p: "xs",
                            bg: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors[theme.primaryColor][3],
                            mb: "1rem",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                                sx: {
                                    gap: "0.25rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($1YbUT.default, {
                                        size: "1.1rem"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                        fz: "xs",
                                        c: "dimmed",
                                        children: helpMessage
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($lTrOu.FileUploader, {
                            ...uploaderProps,
                            uploadAPI: uploadAPI
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    mt: "md",
                    position: "right",
                    children: showOKButton && /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        loading: uploadingNotification,
                        disabled: uploadingNotification,
                        onClick: handleOK,
                        color: theme.colors.green[5],
                        leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($4Rwq2.default, {
                            size: "1.5rem"
                        }),
                        children: okLabel
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("3Utni", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseFileUploadFormOpenDefaultProps", function() {
        return $892d39cbb4228264$export$762803443c1f5f93;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useFilesUploadForm", function() {
        return $892d39cbb4228264$export$9c6ff20038615530;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    var $cWSrD = $305cacda61daafb0$var$parcelRequire("cWSrD");
    const $892d39cbb4228264$export$762803443c1f5f93 = {
        modalProps: {
            size: 'xl'
        },
        modalTitle: 'Upload Files'
    };
    function $892d39cbb4228264$export$9c6ff20038615530() {
        const modals = (0, $k7qj2.useModal)();
        const buttonResult = (0, $acw62.useRef)('Quit');
        const open = (0, $acw62.useCallback)(async (props)=>{
            const { client: client, onOK: onOK, onCancel: onCancel, modalProps: modalProps, onClosed: onClosed, modalTitle: modalTitle, uploaderProps: uploaderProps, fileProcessColumn: fileProcessColumn, filesUploadFormProps: filesUploadFormProps } = {
                ...$892d39cbb4228264$export$762803443c1f5f93,
                ...props
            };
            buttonResult.current = 'Quit';
            const handleOK = async (fileprocess_id, uploadProgress)=>{
                buttonResult.current = 'OK';
                await modals.close();
                if (onOK) await onOK(fileprocess_id, uploadProgress);
            };
            const handleCancel = async ()=>{
                buttonResult.current = 'Cancel';
                await modals.close();
                if (onCancel) onCancel();
            };
            const handleClosed = async ()=>{
                if (buttonResult.current === 'Quit') {
                    if (onCancel) onCancel();
                }
                if (onClosed) onClosed();
            };
            await modals.open({
                content: /*#__PURE__*/ (0, $ayMG0.jsx)($cWSrD.FilesUploadForm, {
                    fileProcessColumn: fileProcessColumn,
                    uploaderProps: uploaderProps,
                    client: client,
                    onOK: async (fileprocess_id, uploadProgress)=>await handleOK(fileprocess_id, uploadProgress),
                    onCancel: ()=>handleCancel(),
                    showOKButton: true,
                    ...filesUploadFormProps
                }),
                modalProps: {
                    ...modalProps,
                    trapFocus: true,
                    returnFocus: true,
                    title: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        fw: "700",
                        children: modalTitle
                    })
                },
                onClosed: async ()=>{
                    await handleClosed();
                }
            });
        }, [
            modals
        ]);
        return open;
    }
});
$305cacda61daafb0$var$parcelRegister("ixSh0", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useExportToExcel", function() {
        return $4baf29ecd19937a5$export$c319aff9ea4ad6e;
    });
    var $7T941 = $305cacda61daafb0$var$parcelRequire("7T941");
    function $4baf29ecd19937a5$export$c319aff9ea4ad6e(props) {
        const { data: data, dataResultNames: dataResultNames, notExportableColumns: notExportableColumns } = props;
        const exportToExcelWrapper = async ()=>{
            await (0, $7T941.exportToExcel)(data, notExportableColumns, dataResultNames);
        };
        return {
            exportToExcel: exportToExcelWrapper
        };
    }
});
$305cacda61daafb0$var$parcelRegister("ivqW2", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "openEntityForm", function() {
        return $ac82dadeef9a6215$export$66b3c1a9709bd8fc;
    });
    var $gYKfx = $305cacda61daafb0$var$parcelRequire("gYKfx");
    async function $ac82dadeef9a6215$export$66b3c1a9709bd8fc({ modals: modals, title: title, element: element, handleModalCancel: handleModalCancel, handleModalSaved: handleModalSaved, modalFormSize: modalFormSize, formProps: formProps, handleModalClosed: handleModalClosed, withModalFullscreenButton: withModalFullscreenButton }) {
        withModalFullscreenButton = withModalFullscreenButton === undefined ? true : withModalFullscreenButton;
        const showOK = formProps.initialFormMode !== 'view';
        const onSaved = formProps.initialFormMode !== 'view' ? (new_status)=>handleModalSaved(new_status) : ()=>Promise.resolve();
        const onCancel = ()=>handleModalCancel();
        const entity_form = await (0, $gYKfx.createEntityForm)({
            showOK: showOK,
            onSaved: onSaved,
            onCancel: onCancel,
            ...formProps
        });
        await modals.open({
            modalProps: {
                title: /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                    fw: "700",
                    children: [
                        title,
                        " ",
                        formProps.entity.Title
                    ]
                }),
                size: modalFormSize,
                withFullscreenButton: withModalFullscreenButton,
                closeOnClickOutside: false,
                closeOnEscape: true
            },
            onClosed: handleModalClosed,
            focusOnClosed: element,
            content: entity_form
        });
    }
});
$305cacda61daafb0$var$parcelRegister("gYKfx", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "createEntityForm", function() {
        return $a6812e14c3e91133$export$fbad52440685f436;
    });
    $305cacda61daafb0$var$parcelRequire("1ms8C");
    var $38HqD = $305cacda61daafb0$var$parcelRequire("38HqD");
    $305cacda61daafb0$var$parcelRequire("iTpjT");
    var $5cUzS = $305cacda61daafb0$var$parcelRequire("5cUzS");
    async function $a6812e14c3e91133$export$fbad52440685f436(props) {
        const { entity: entity } = props;
        if (!entity.Form) throw new Error("Entity does not have a form");
        let entity_form;
        if (entity.Form === "AutoForm") entity_form = /*#__PURE__*/ (0, $ayMG0.jsx)($5cUzS.AutoForm, {
            ...props
        });
        else if (entity.Form === "AutoFiltersForm") entity_form = /*#__PURE__*/ (0, $ayMG0.jsx)($38HqD.AutoFiltersForm, {
            ...props
        });
        else entity_form = await entity.Form.then((DynamicForm)=>/*#__PURE__*/ (0, $ayMG0.jsx)(DynamicForm, {
                ...props
            }));
        return entity_form;
    }
});
$305cacda61daafb0$var$parcelRegister("iqamJ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useExecuteProc", function() {
        return $2fcad708d17652da$export$8dcbab0699f0db0c;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    function $2fcad708d17652da$export$8dcbab0699f0db0c(entity, proc) {
        const [status, setStatus] = (0, $acw62.useState)({
            loading: false,
            operationType: 'proc'
        });
        const cancellation = (0, $acw62.useRef)(new AbortController());
        const done = (0, $acw62.useRef)(false);
        const prevValues = (0, $acw62.useRef)();
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (!done.current) {
                    console.log("useExecuteProc aborted on unmount");
                    cancellation.current.abort("Component unmounted");
                }
            };
        }, []);
        const execute = (0, $acw62.useCallback)(async (values)=>{
            if (status.loading) return status;
            if (!(0, $iKzSR.areValuesObjectsEqual)(values, prevValues.current)) {
                // Abort the previous request before starting a new one
                cancellation.current.abort("ExecuteProc, aborting previous request.");
                cancellation.current = new AbortController();
                done.current = false;
                try {
                    // Update previous values
                    prevValues.current = values;
                    if (entity && proc) {
                        setStatus({
                            loading: true,
                            operationType: 'proc'
                        });
                        const data = await entity.API.executeProc(proc, values, cancellation.current.signal);
                        done.current = true;
                        const new_status = {
                            data: data,
                            operationType: 'proc'
                        };
                        setStatus(new_status);
                        return new_status;
                    }
                } catch (e) {
                    if (e.name !== 'AbortError' && e !== "ExecuteProc, aborting previous request.") {
                        const new_status = {
                            error: (0, $98ddT.toMicroMError)(e),
                            operationType: 'proc'
                        };
                        setStatus(new_status);
                        return new_status;
                    }
                }
            }
        }, [
            entity,
            proc,
            status
        ]);
        const abort = (0, $acw62.useCallback)(()=>{
            cancellation.current.abort();
        }, []);
        return {
            execute: execute,
            status: status,
            abort: abort
        };
    }
});
$305cacda61daafb0$var$parcelRegister("lJoOP", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "SearchFilterInputDefaultProps", function() {
        return $b56b22fbdce7e92f$export$3faed4232677411d;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "SearchFilterInput", function() {
        return $b56b22fbdce7e92f$export$4fef1edbf0f012ef;
    });
    const $b56b22fbdce7e92f$export$3faed4232677411d = {
        iconVariant: "light",
        placeholder: "Enter text to search",
        addFilterLabel: "+ Filter:"
    };
    const $b56b22fbdce7e92f$export$4fef1edbf0f012ef = /*#__PURE__*/ (0, $acw62.forwardRef)(function SearchFilterInput(props, ref) {
        const { onSearchClick: onSearchClick, size: size, iconsSize: iconsSize, value: value, onChange: onChange, placeholder: placeholder, autoFocus: autoFocus, iconVariant: iconVariant, addFilterLabel: addFilterLabel, onSearchChange: onSearchChange, onCreate: onCreate, ...rest } = (0, $64A2P.useComponentDefaultProps)('SearchFilterInput', $b56b22fbdce7e92f$export$3faed4232677411d, props);
        const theme = (0, $64A2P.useMantineTheme)();
        // Mantine has a bug in thsi component:
        // When all the items are selected and the multiselect is in a modal and it has autofocus
        // you will need to press escape two time to close the modal
        // this is because it uses a popover with closeOnEscape and it traps escape even if the list is not shown
        return /*#__PURE__*/ (0, $ayMG0.jsx)($8LzkP.MultiSelect, {
            icon: /*#__PURE__*/ (0, $ayMG0.jsx)($li55Z.default, {
                size: "1.1rem",
                stroke: 1.5
            }),
            radius: "xl",
            size: size,
            styles: ()=>theme.focusRing === 'never' ? {
                    searchInput: {
                        lineHeight: 'unset'
                    },
                    value: {
                        minHeight: '1.4rem'
                    },
                    defaultValue: {
                        paddingBottom: '0.1rem'
                    },
                    input: {
                        '&:focus-within': {
                            outline: 'unset'
                        } // fix focus ring bug
                    }
                } : {
                    searchInput: {
                        lineHeight: 'unset'
                    },
                    value: {
                        minHeight: '1.4rem'
                    },
                    defaultValue: {
                        paddingBottom: '0.1rem'
                    }
                },
            rightSection: /*#__PURE__*/ (0, $ayMG0.jsx)($crMIh.ActionIcon, {
                size: size,
                radius: "xl",
                color: theme.primaryColor,
                variant: iconVariant,
                onClick: (e)=>onSearchClick(e),
                children: theme.dir === 'ltr' ? /*#__PURE__*/ (0, $ayMG0.jsx)($bb5Hu.default, {
                    size: iconsSize,
                    stroke: 1.5
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($dV30q.default, {
                    size: iconsSize,
                    stroke: 1.5
                })
            }),
            rightSectionWidth: 42,
            value: value,
            onChange: onChange,
            onSearchChange: onSearchChange,
            onCreate: onCreate,
            placeholder: placeholder,
            creatable: true,
            searchable: true,
            getCreateLabel: (newValue)=>`${addFilterLabel} ${newValue}`,
            "data-autofocus": autoFocus,
            autoFocus: autoFocus,
            ref: ref,
            ...rest
        });
    });
});
$305cacda61daafb0$var$parcelRegister("i27OQ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useFirstVisible", function() {
        return $20a06645424f77f8$export$e5477689b5965fba;
    });
    function $20a06645424f77f8$export$e5477689b5965fba(ref, options) {
        const [isFirstVisible, setIsFirstVisible] = (0, $acw62.useState)(false);
        const hasBeenVisible = (0, $acw62.useRef)(false);
        (0, $acw62.useEffect)(()=>{
            const currentElement = ref.current;
            if (!currentElement) return;
            const observer = new IntersectionObserver(([entry])=>{
                if (entry.isIntersecting && !hasBeenVisible.current) {
                    setIsFirstVisible(true);
                    hasBeenVisible.current = true;
                    observer.disconnect();
                }
            }, options);
            observer.observe(currentElement);
            return ()=>observer.disconnect();
        }, [
            ref,
            options
        ]);
        return isFirstVisible;
    }
});
$305cacda61daafb0$var$parcelRegister("9maeT", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useOpenForm", function() {
        return $2d0bb0e8253bc1ff$export$cf62245ee3811550;
    });
    var $gYKfx = $305cacda61daafb0$var$parcelRequire("gYKfx");
    var $k7qj2 = $305cacda61daafb0$var$parcelRequire("k7qj2");
    function $2d0bb0e8253bc1ff$export$cf62245ee3811550() {
        const modals = (0, $k7qj2.useModal)();
        const openForm = (0, $acw62.useCallback)(async (props)=>{
            const { entity: entity, initialFormMode: initialFormMode, getDataOnInit: getDataOnInit, modalFormSize: modalFormSize, title: title, element: element, onModalSaved: onModalSaved, onModalCancelled: onModalCancelled, OKText: OKText, CancelText: CancelText, showCancel: showCancel, onModalClosed: onModalClosed, otherFormProps: otherFormProps, dontAddEntityTitle: dontAddEntityTitle, withFullscreenButton: withFullscreenButton, closeOnEscape: closeOnEscape, closeOnClickOutside: closeOnClickOutside } = props;
            const showOK = initialFormMode !== 'view';
            const onSaved = initialFormMode !== 'view' ? async (new_status)=>{
                await modals.close();
                if (onModalSaved) await onModalSaved(new_status);
            } : ()=>Promise.resolve();
            const onCancel = async ()=>{
                await modals.close();
                if (onModalCancelled) await onModalCancelled();
            };
            const onClosed = async ()=>{
                if (onModalClosed) await onModalClosed();
            };
            const entity_form = (0, $gYKfx.createEntityForm)({
                entity: entity,
                initialFormMode: initialFormMode,
                getDataOnInit: getDataOnInit,
                showOK: showOK,
                onSaved: onSaved,
                onCancel: onCancel,
                OKText: OKText,
                CancelText: CancelText,
                showCancel: showCancel,
                ...otherFormProps
            });
            await modals.open({
                modalProps: {
                    title: /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                        fw: "700",
                        children: [
                            title && title,
                            !dontAddEntityTitle && ` ${entity.Title}`
                        ]
                    }),
                    size: modalFormSize,
                    withFullscreenButton: withFullscreenButton,
                    closeOnEscape: closeOnEscape,
                    closeOnClickOutside: closeOnClickOutside
                },
                focusOnClosed: element,
                content: entity_form,
                onClosed: onClosed
            });
        }, [
            modals
        ]);
        return openForm;
    }
});
$305cacda61daafb0$var$parcelRegister("7B1hX", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useViewState", function() {
        return $2c5d17e58b167f3e$export$a4e336d1ff7e9e51;
    });
    function $2c5d17e58b167f3e$export$a4e336d1ff7e9e51(search, limit) {
        const [searchText, setSearchText] = (0, $acw62.useState)(search);
        const [limitRows, setLimitRows] = (0, $acw62.useState)(limit ? limit : null);
        const [refresh, setRefresh] = (0, $acw62.useState)(false);
        const [filterValues, setFilterValues] = (0, $acw62.useState)();
        const [filtersDescription, setFiltersDescription] = (0, $acw62.useState)();
        return {
            searchText: searchText,
            setSearchText: setSearchText,
            limitRows: limitRows,
            setLimitRows: setLimitRows,
            refresh: refresh,
            setRefresh: setRefresh,
            filterValues: filterValues,
            setFilterValues: setFilterValues,
            filtersDescription: filtersDescription,
            setFiltersDescription: setFiltersDescription
        };
    }
});
$305cacda61daafb0$var$parcelRegister("jckhB", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useExecuteLookup", function() {
        return $8878bcaa5bd370ad$export$3d283503a38975d1;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    $305cacda61daafb0$var$parcelRequire("17D0Z");
    var $iuZkb = $305cacda61daafb0$var$parcelRequire("iuZkb");
    function $8878bcaa5bd370ad$export$3d283503a38975d1({ entity: entity, lookupDefName: lookupDefName, parentKeys: parentKeys }) {
        const { lookupEntity: lookupEntity } = (0, $iuZkb.useLookupEntity)({
            entity: entity,
            lookupDefName: lookupDefName,
            parentKeys: parentKeys
        });
        const [status, setStatus] = (0, $acw62.useState)({
            loading: true,
            operationType: 'lookup'
        });
        const cancellation = (0, $acw62.useRef)(new AbortController());
        const done = (0, $acw62.useRef)(false);
        const prevValues = (0, $acw62.useRef)();
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (!done.current) {
                    console.log("useExecuteLookup aborted on unmount");
                    cancellation.current.abort("Component unmounted");
                }
            };
        }, []);
        const execute = async ()=>{
            if (!entity || !lookupEntity) return;
            // Abort the previous request before starting a new one
            cancellation.current.abort("ExecuteLookup, aborting previous request.");
            cancellation.current = new AbortController();
            done.current = false;
            // Set parentKeys
            $iKzSR.setValues(lookupEntity.def.columns, parentKeys, null, true);
            const current_values = $iKzSR.getValuesObject(lookupEntity.def.columns, {
                flags: $4H7ea.EntityColumnFlags.pk | $4H7ea.EntityColumnFlags.fk,
                ignoreDefaults: false
            });
            if (!(0, $iKzSR.areValuesObjectsEqual)(current_values, prevValues.current)) try {
                if (entity && lookupEntity) {
                    setStatus({
                        loading: true,
                        operationType: 'lookup'
                    });
                    const data = await lookupEntity.API.lookupData(cancellation.current.signal);
                    done.current = true;
                    const status_result = {
                        data: data,
                        operationType: 'lookup'
                    };
                    setStatus(status_result);
                    return status_result;
                }
                // Update previous values
                prevValues.current = $iKzSR.getValuesObject(lookupEntity.def.columns, {
                    flags: $4H7ea.EntityColumnFlags.pk | $4H7ea.EntityColumnFlags.fk,
                    ignoreDefaults: false
                });
            } catch (e) {
                if (e.name !== 'AbortError' && e !== "ExecuteLookup, aborting previous request.") {
                    const error_result = {
                        error: (0, $98ddT.toMicroMError)(e),
                        operationType: 'lookup'
                    };
                    setStatus(error_result);
                    return error_result;
                }
            }
        };
        const abort = (0, $acw62.useCallback)(()=>{
            cancellation.current.abort();
        }, []);
        return {
            execute: execute,
            status: status,
            abort: abort
        };
    }
});
$305cacda61daafb0$var$parcelRegister("382l3", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LoginModalFormDefaultProps", function() {
        return $9a4a231d2265ecd4$export$cb4f37c94e0044f1;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "LoginModalForm", function() {
        return $9a4a231d2265ecd4$export$1dfef97d6d6bf90e;
    });
    var $2bGyU = $305cacda61daafb0$var$parcelRequire("2bGyU");
    const $9a4a231d2265ecd4$export$cb4f37c94e0044f1 = {
        title: "Sign in",
        withCloseButton: true,
        closeOnEscape: true
    };
    function $9a4a231d2265ecd4$export$1dfef97d6d6bf90e(props) {
        const { client: client, title: title, onClose: onClose, onLoggedIn: onLoggedIn, openState: openState, withCloseButton: withCloseButton, closeOnClickOutside: closeOnClickOutside, closeOnEscape: closeOnEscape, overlayProps: overlayProps, transitionProps: transitionProps, centered: centered } = (0, $64A2P.useComponentDefaultProps)('LoginModalForm', $9a4a231d2265ecd4$export$cb4f37c94e0044f1, props);
        const [opened, { open: open, close: close }] = (0, $6X2G0.useDisclosure)(false);
        const statusCompletedHandler = (status)=>{
            if (!status.error && !status.loading) {
                onLoggedIn(status.data?.claims);
                close();
            }
        };
        const closeHandler = ()=>{
            close();
            if (onClose) onClose();
        };
        (0, $acw62.useEffect)(()=>{
            if (openState) open();
            else close();
        }, [
            close,
            open,
            openState
        ]);
        const matchesTouchDevice = (0, $kFu1s.useMediaQuery)('(hover: none)');
        return /*#__PURE__*/ (0, $ayMG0.jsx)($aCM0s.Modal, {
            trapFocus: true,
            opened: opened,
            onClose: closeHandler,
            title: title,
            centered: centered === undefined ? matchesTouchDevice ? false : true : centered,
            withCloseButton: withCloseButton,
            closeOnClickOutside: closeOnClickOutside,
            closeOnEscape: closeOnEscape,
            overlayProps: overlayProps,
            transitionProps: transitionProps,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2bGyU.Login, {
                client: client,
                onStatusCompleted: statusCompletedHandler
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("izUR3", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "WeekPicker", function() {
        return $72abce3b2de8d8b8$export$4cbb752f776fc58d;
    });
    function $72abce3b2de8d8b8$var$getDay(date) {
        const day = date.getDay();
        return day === 0 ? 6 : day - 1;
    }
    function $72abce3b2de8d8b8$var$startOfWeek(date) {
        return $305cacda61daafb0$var$$parcel$interopDefault($gngdn)(new Date(date.getFullYear(), date.getMonth(), date.getDate() - $72abce3b2de8d8b8$var$getDay(date))).startOf('day').toDate();
    }
    function $72abce3b2de8d8b8$var$endOfWeek(date) {
        return $305cacda61daafb0$var$$parcel$interopDefault($gngdn)(new Date(date.getFullYear(), date.getMonth(), date.getDate() + (6 - $72abce3b2de8d8b8$var$getDay(date)))).endOf('day').toDate();
    }
    function $72abce3b2de8d8b8$var$isInWeekRange(date, value) {
        if (!value) return false;
        const start = $72abce3b2de8d8b8$var$startOfWeek(value);
        const end = $72abce3b2de8d8b8$var$endOfWeek(value);
        return $305cacda61daafb0$var$$parcel$interopDefault($gngdn)(date).isSame(start, 'day') || $305cacda61daafb0$var$$parcel$interopDefault($gngdn)(date).isSame(end, 'day') || $305cacda61daafb0$var$$parcel$interopDefault($gngdn)(date).isAfter(start) && $305cacda61daafb0$var$$parcel$interopDefault($gngdn)(date).isBefore(end);
    }
    function $72abce3b2de8d8b8$export$4cbb752f776fc58d(props) {
        const { weekStartDatevalue: weekStartDatevalue, setWeekStartValue: setWeekStartValue, setWeekEndValue: setWeekEndValue, allowDeselect: allowDeselect, ...others } = props;
        const [hovered, setHovered] = (0, $acw62.useState)(null);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
            position: "center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2cTph.Calendar, {
                placeholder: undefined,
                onPointerEnterCapture: undefined,
                onPointerLeaveCapture: undefined,
                ...others,
                withCellSpacing: false,
                getDayProps: (date)=>{
                    const isHovered = $72abce3b2de8d8b8$var$isInWeekRange(date, hovered);
                    const isSelected = $72abce3b2de8d8b8$var$isInWeekRange(date, weekStartDatevalue);
                    const isInRange = isHovered || isSelected;
                    return {
                        onMouseEnter: ()=>setHovered(date),
                        onMouseLeave: ()=>setHovered(null),
                        inRange: isInRange,
                        firstInRange: isInRange && date.getDay() === 1,
                        lastInRange: isInRange && date.getDay() === 0,
                        selected: isSelected,
                        onClick: ()=>{
                            if (allowDeselect && isSelected) {
                                setWeekStartValue(null);
                                if (setWeekEndValue) setWeekEndValue(null);
                            } else {
                                setWeekStartValue($72abce3b2de8d8b8$var$startOfWeek(date));
                                if (setWeekEndValue) setWeekEndValue($72abce3b2de8d8b8$var$endOfWeek(date));
                            }
                        }
                    };
                }
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("9HOzJ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "WeekPickerFieldDefaultProps", function() {
        return $429107a4db037dcc$export$136db37b57dccbfe;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "WeekPickerField", function() {
        return $429107a4db037dcc$export$1df7c3fdc0006409;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $a2vzY = $305cacda61daafb0$var$parcelRequire("a2vzY");
    var $izUR3 = $305cacda61daafb0$var$parcelRequire("izUR3");
    const $429107a4db037dcc$export$136db37b57dccbfe = {
        placeholder: 'Select a week',
        accordionVariant: 'separated',
        allowDeselect: true,
        size: 'sm',
        requiredMessage: 'A value is required'
    };
    function $429107a4db037dcc$export$1df7c3fdc0006409(props) {
        const { weekStartDateColumn: weekStartDateColumn, weekEndDateColumn: weekEndDateColumn, entityForm: entityForm, validate: validate, validationContainer: validationContainer, requiredMessage: requiredMessage, accordionVariant: accordionVariant, accordionExpanded: accordionExpanded, placeholder: placeholder, size: size, required: required, readonly: readonly, disabled: disabled, label: label, description: description, ...others } = (0, $64A2P.useComponentDefaultProps)('WeekPickerField', $429107a4db037dcc$export$136db37b57dccbfe, props);
        const theme = (0, $64A2P.useMantineTheme)();
        const localeFormat = (0, $a2vzY.useLocaleFormat)({
            timeZoneOffset: entityForm.entity.API.client.TIMEZONE_OFFSET
        });
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: weekStartDateColumn,
            validationContainer: validationContainer,
            validate: validate,
            required: false,
            requiredMessage: requiredMessage,
            readOnly: false
        });
        const controlSize = (0, $d8Ix8.getSize)({
            size: size ?? "sm",
            sizes: theme.fontSizes
        });
        const descriptionSize = (0, $d8Ix8.getSize)({
            size: size ?? "sm",
            sizes: theme.fontSizes
        });
        const labelColor = theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[9];
        const descriptionColor = theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6];
        const [weekEndValue, setWeekEndValue] = (0, $acw62.useState)(weekEndDateColumn?.value || weekEndDateColumn?.defaultValue || null);
        const weekStartDisplayValue = localeFormat.formatValue(weekStartDateColumn.value, 'date');
        const weekEndDisplayValue = weekEndValue ? localeFormat.formatValue(weekEndValue, 'date') : '';
        const is_required = required ?? (!readonly && !(entityForm.formMode === 'view') && !weekStartDateColumn.hasFlag($4H7ea.EntityColumnFlags.nullable));
        const error_color = theme.fn.variant({
            variant: 'filled',
            color: 'red'
        }).background;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            style: {
                gap: "0.1rem"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    style: {
                        gap: "0.2rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: controlSize,
                            weight: "500",
                            color: labelColor,
                            children: label ?? weekStartDateColumn.prompt
                        }),
                        is_required && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: controlSize,
                            weight: "500",
                            color: theme.colors.red[5],
                            children: "*"
                        })
                    ]
                }),
                (description ?? weekStartDateColumn.description) && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                    style: {
                        fontSize: `calc(${descriptionSize} - ${(0, $2jkdX.rem)(2)})`,
                        lineHeight: 1.2
                    },
                    color: descriptionColor,
                    children: description ?? weekStartDateColumn.description
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion, {
                    style: {
                        marginTop: `calc(${theme.spacing.xs} / 2)`,
                        border: `${(0, $2jkdX.rem)(1)} solid ${is_required && !weekStartDateColumn.value ? error_color : theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[4]}`,
                        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
                        transition: 'border-color 100ms ease',
                        borderRadius: theme.radius.sm
                    },
                    variant: accordionVariant,
                    defaultValue: accordionExpanded ? `weekPicker-${weekStartDateColumn.name}` : undefined,
                    styles: {
                        label: {
                            paddingLeft: "0",
                            paddingTop: "0.447rem",
                            paddingBottom: "0.447rem",
                            paddingRight: "0.625rem"
                        },
                        control: {
                            paddingLeft: "0.75rem",
                            paddingRight: "0.625rem"
                        }
                    },
                    maw: "20rem",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)($iLvQN.Accordion.Item, {
                        value: `weekPicker-${weekStartDateColumn.name}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Control, {
                                icon: /*#__PURE__*/ (0, $ayMG0.jsx)($gsgdS.default, {
                                    size: "1rem"
                                }),
                                children: weekStartDisplayValue && weekStartDisplayValue !== 'null' ? /*#__PURE__*/ (0, $ayMG0.jsxs)($cjohz.Text, {
                                    size: controlSize,
                                    children: [
                                        weekStartDisplayValue,
                                        weekEndDisplayValue ? ` - ${weekEndDisplayValue}` : ''
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                                    color: "dimmed",
                                    size: controlSize,
                                    children: placeholder
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($iLvQN.Accordion.Panel, {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($izUR3.WeekPicker, {
                                    ...others,
                                    static: readonly || disabled,
                                    weekStartDatevalue: entityForm.form.values[weekStartDateColumn.name],
                                    setWeekStartValue: (value)=>{
                                        entityForm.form.setFieldValue(weekStartDateColumn.name, value);
                                        weekStartDateColumn.value = value;
                                    },
                                    setWeekEndValue: (value)=>{
                                        if (weekEndDateColumn) {
                                            entityForm.form.setFieldValue(weekEndDateColumn.name, value);
                                            weekEndDateColumn.value = value;
                                        }
                                        setWeekEndValue(value);
                                    }
                                })
                            })
                        ]
                    })
                }),
                is_required && !weekStartDateColumn.value && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                    size: "xs",
                    color: error_color,
                    children: requiredMessage
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("19BCV", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "PinFieldDefaultProps", function() {
        return $6a4ac115979fa22d$export$d6bffe4440700f77;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "PinField", function() {
        return $6a4ac115979fa22d$export$1883e1f91f577085;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    var $OciKL = $305cacda61daafb0$var$parcelRequire("OciKL");
    const $6a4ac115979fa22d$export$d6bffe4440700f77 = {
        transform: 'uppercase',
        requiredMessage: "A value is required",
        size: "sm"
    };
    function $6a4ac115979fa22d$var$isArrayOfStrings(value) {
        return Array.isArray(value) && value.every((item)=>typeof item === 'string');
    }
    function $6a4ac115979fa22d$export$1883e1f91f577085(props) {
        const { entityForm: entityForm, column: column, validationContainer: validationContainer, validate: validate, required: required, requiredMessage: requiredMessage, readOnly: readOnly, placeholder: placeholder, autoFocus: autoFocus, transform: transform, autoTrim: autoTrim, size: size, description: description, label: label, ...others } = (0, $64A2P.useComponentDefaultProps)('PinField', $6a4ac115979fa22d$export$d6bffe4440700f77, props);
        const theme = (0, $64A2P.useMantineTheme)();
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const textTransform = (0, $OciKL.useTextTransform)({
            entityForm: entityForm,
            column: column,
            transform: transform,
            autoTrim: autoTrim
        });
        const handleOnComplete = (value)=>{
            textTransform(value);
        };
        const controlSize = (0, $d8Ix8.getSize)({
            size: size ?? "sm",
            sizes: theme.fontSizes
        });
        const descriptionSize = (0, $d8Ix8.getSize)({
            size: size ?? "sm",
            sizes: theme.fontSizes
        });
        const labelColor = theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.gray[9];
        const descriptionColor = theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6];
        const { form: form } = entityForm;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($9VIWE.Stack, {
            style: {
                gap: "0.1rem"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                    style: {
                        gap: "0.2rem"
                    },
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: controlSize,
                            weight: "500",
                            color: labelColor,
                            children: label ?? column.prompt
                        }),
                        (required ?? (!readOnly && !(entityForm.formMode === 'view') && !column.hasFlag($4H7ea.EntityColumnFlags.nullable))) && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                            size: controlSize,
                            weight: "500",
                            color: theme.colors.red[5],
                            children: "*"
                        })
                    ]
                }),
                (description ?? column.description) && /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                    style: {
                        fontSize: `calc(${descriptionSize} - ${(0, $2jkdX.rem)(2)})`,
                        lineHeight: 1.2
                    },
                    color: descriptionColor,
                    children: description ?? column.description
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($clUNc.PinInput, {
                    ...others,
                    ...entityForm.form.getInputProps(column.name),
                    placeholder: placeholder ?? column.placeholder,
                    autoFocus: autoFocus,
                    onComplete: handleOnComplete,
                    required: required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable),
                    mt: "xs"
                }),
                form.errors[column.name] && /*#__PURE__*/ (0, $ayMG0.jsx)($9mTYo.Group, {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($cjohz.Text, {
                        size: "xs",
                        color: "red",
                        children: (()=>{
                            const errorValue = form.errors[column.name];
                            if ($6a4ac115979fa22d$var$isArrayOfStrings(errorValue)) return errorValue.join(', ');
                            else if (errorValue !== null && errorValue !== undefined) return errorValue;
                            else return '';
                        })()
                    })
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("2hjBw", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useExecuteProcess", function() {
        return $d2fd61b2edecbadb$export$7aab186fc1fe6b0;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    function $d2fd61b2edecbadb$export$7aab186fc1fe6b0(entity, proc) {
        const [status, setStatus] = (0, $acw62.useState)({
            loading: false,
            operationType: 'proc'
        });
        const cancellation = (0, $acw62.useRef)(new AbortController());
        const done = (0, $acw62.useRef)(false);
        const prevValues = (0, $acw62.useRef)();
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (!done.current) {
                    console.log("useExecuteProcess aborted on unmount");
                    cancellation.current.abort("Component unmounted");
                }
            };
        }, [
            entity,
            proc
        ]);
        const execute = (0, $acw62.useCallback)(async (values)=>{
            if (status.loading) return status;
            if (!(0, $iKzSR.areValuesObjectsEqual)(values, prevValues.current)) {
                // Abort the previous request before starting a new one
                cancellation.current.abort("ExecuteProcess, aborting previous request.");
                cancellation.current = new AbortController();
                done.current = false;
                try {
                    if (entity && proc) {
                        setStatus({
                            loading: true,
                            operationType: 'proc'
                        });
                        const data = await entity.API.executeProcess(proc, values, cancellation.current.signal);
                        done.current = true;
                        const new_status = {
                            data: data,
                            operationType: 'proc'
                        };
                        setStatus(new_status);
                        // Update previous values
                        prevValues.current = values;
                        return new_status;
                    }
                } catch (e) {
                    if (e.name !== 'AbortError' && e !== "ExecuteProcess, aborting previous request.") {
                        const new_status = {
                            error: e.Errors ? (0, $98ddT.toDBStatusMicroMError)(e.Errors, 'add') : (0, $98ddT.toMicroMError)(e),
                            operationType: 'proc'
                        };
                        setStatus(new_status);
                        return new_status;
                    }
                }
            }
        }, [
            entity,
            proc,
            status
        ]);
        const abort = (0, $acw62.useCallback)(()=>{
            cancellation.current.abort();
        }, []);
        return {
            execute: execute,
            status: status,
            abort: abort
        };
    }
});
$305cacda61daafb0$var$parcelRegister("6J9V6", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useCompleteFieldFromOther", function() {
        return $e2b1ee22255b2ea9$export$fb824f9d9773df75;
    });
    function $e2b1ee22255b2ea9$export$fb824f9d9773df75({ form: form, originalColumn: originalColumn, targetColumn: targetColumn, onlyIfEmpty: onlyIfEmpty, transformValue: transformValue }) {
        const [previousValue, setPreviousValue] = (0, $acw62.useState)(form.values[originalColumn.name]);
        (0, $acw62.useEffect)(()=>{
            if (originalColumn.type !== targetColumn.type) {
                console.error(`useCompleteFieldFromOther: originalColumn.type !== targetColumn.type`);
                return;
            }
            if (form.values[originalColumn.name] !== previousValue) {
                // skip if onlyIfEmpty is true and targetColumn is not empty
                if (onlyIfEmpty && form.values[targetColumn.name]) return;
                setPreviousValue(form.values[originalColumn.name]);
                if (transformValue) form.setFieldValue(targetColumn.name, transformValue(form.values[originalColumn.name]));
                else form.setFieldValue(targetColumn.name, form.values[originalColumn.name]);
            }
        }, [
            form.values[originalColumn.name],
            form.values[targetColumn.name],
            previousValue
        ]);
    }
});
$305cacda61daafb0$var$parcelRegister("g8F24", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "SwitchField", function() {
        return $b5f08bd464db7a3a$export$208c2e617baf9fc3;
    });
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    function $b5f08bd464db7a3a$export$208c2e617baf9fc3(props) {
        const { column: column, required: required, entityForm: entityForm, loading: loading, disableOnLoading: disableOnLoading, label: label, readOnly: readOnly, disabled: disabled, requiredMessage: requiredMessage, description: description, ...others } = props;
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const [showDescription] = entityForm.showDescriptionState;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($foYg9.Switch, {
            ...others,
            label: label ?? column.prompt,
            description: showDescription ? description ?? column.description : '',
            disabled: disabled ?? (entityForm.formMode === 'view' || disableOnLoading && loading || readOnly),
            ...entityForm.form.getInputProps(column.name, {
                type: 'checkbox'
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("4ftBh", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RecoverPasswordDefaultProps", function() {
        return $01584662a3289e05$export$76372d216c16c928;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RecoverPassword", function() {
        return $01584662a3289e05$export$6630bff6ccf72719;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $gLcPf = $305cacda61daafb0$var$parcelRequire("gLcPf");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    $305cacda61daafb0$var$parcelRequire("dC9fs");
    var $efs8D = $305cacda61daafb0$var$parcelRequire("efs8D");
    const $01584662a3289e05$export$76372d216c16c928 = {
        userLabel: "User",
        userPlaceholder: "you@email.com",
        passwordLabel: "New Password",
        passwordPlaceholder: "Your new password",
        changePasswordLabel: "Change password",
        changeErrorMessage: "Is not possible to change your password, request a new recovery email",
        changedSuccessfullyMessage: "Your password has been changed successfully",
        changedSuccessfullyURL: "/",
        signInButtonLabel: "Sign in",
        passwordMinLength: 8,
        passwordMaxLength: 255
    };
    function $01584662a3289e05$export$6630bff6ccf72719(props) {
        const { client: client, onStatusCompleted: onStatusCompleted, userLabel: userLabel, userPlaceholder: userPlaceholder, passwordLabel: passwordLabel, passwordPlaceholder: passwordPlaceholder, changePasswordLabel: changePasswordLabel, changeErrorMessage: changeErrorMessage, changedSuccessfullyMessage: changedSuccessfullyMessage, changedSuccessfullyURL: changedSuccessfullyURL, signInButtonLabel: signInButtonLabel, passwordMaxLength: passwordMaxLength, passwordMinLength: passwordMinLength } = (0, $64A2P.useComponentDefaultProps)('Login', $01584662a3289e05$export$76372d216c16c928, props);
        const form = (0, $ajdIG.useForm)({
            initialValues: {
                username: '',
                password: '',
                recovery_code: ''
            }
        });
        const [status, setStatus] = (0, $acw62.useState)();
        const handleClick = (0, $acw62.useCallback)(async (values)=>{
            setStatus({
                loading: true
            });
            try {
                const data = await client.recoverpassword(values.username, values.password, values.recovery_code);
                const new_status = {
                    data: data
                };
                setStatus(new_status);
                if (onStatusCompleted) onStatusCompleted(new_status);
            } catch (e) {
                const new_status = {
                    error: (0, $98ddT.toMicroMError)(e)
                };
                setStatus(new_status);
                if (onStatusCompleted) onStatusCompleted(new_status);
            }
        }, [
            client,
            onStatusCompleted
        ]);
        (0, $acw62.useEffect)(()=>{
            const params = (0, $efs8D.getWindowLocationQueryStringAsObject)();
            if (params.code) form.values['recovery_code'] = params.code;
        }, []);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: form.onSubmit((values)=>handleClick(values)),
                    children: [
                        status?.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {}),
                        !(status?.data?.Results[0].Status === 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($8mycu.TextInput, {
                                    label: userLabel,
                                    placeholder: userPlaceholder,
                                    required: true,
                                    "data-autofocus": true,
                                    disabled: status?.loading,
                                    ...form.getInputProps('username')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($ly5N0.PasswordInput, {
                                    label: passwordLabel,
                                    placeholder: passwordPlaceholder,
                                    required: true,
                                    mt: "md",
                                    disabled: status?.loading,
                                    minLength: passwordMinLength,
                                    maxLength: passwordMaxLength,
                                    ...form.getInputProps('password')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                    fullWidth: true,
                                    mt: "xl",
                                    disabled: status?.loading || status?.data?.Failed || status?.error !== undefined,
                                    type: "submit",
                                    children: changePasswordLabel
                                })
                            ]
                        }),
                        status?.data?.Results[0].Status === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($gLcPf.AlertSuccess, {
                                    children: changedSuccessfullyMessage
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                    fullWidth: true,
                                    mt: "xl",
                                    onClick: ()=>window.location.href = changedSuccessfullyURL,
                                    children: signInButtonLabel
                                })
                            ]
                        })
                    ]
                }),
                status?.error && /*#__PURE__*/ (0, $ayMG0.jsx)($d50o9.AlertError, {
                    mt: "xs",
                    children: changeErrorMessage
                }),
                status?.data?.Failed && /*#__PURE__*/ (0, $ayMG0.jsx)($d50o9.AlertError, {
                    mt: "xs",
                    children: status.data.Results[0].Message
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("rMdN2", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RecoverPasswordEmailDefaultProps", function() {
        return $564cf9c9d9ac674e$export$d215453ae99c0ab5;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RecoverPasswordEmail", function() {
        return $564cf9c9d9ac674e$export$4efd634c1edabbf8;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $d50o9 = $305cacda61daafb0$var$parcelRequire("d50o9");
    var $gLcPf = $305cacda61daafb0$var$parcelRequire("gLcPf");
    var $lFsp3 = $305cacda61daafb0$var$parcelRequire("lFsp3");
    const $564cf9c9d9ac674e$export$d215453ae99c0ab5 = {
        userLabel: "User",
        userPlaceholder: "you@email.com",
        sendRecoveryEmailLabel: "Send recovery email",
        emailSentSuccessfullyMessage: "Recovery email sent successfully",
        emailSendErrorMessage: "Is not possible to send the recovery email",
        goBackToHomePageLabel: "Go back to home page"
    };
    function $564cf9c9d9ac674e$export$4efd634c1edabbf8(props) {
        const { client: client, onStatusCompleted: onStatusCompleted, userLabel: userLabel, userPlaceholder: userPlaceholder, emailSentSuccessfullyMessage: emailSentSuccessfullyMessage, sendRecoveryEmailLabel: sendRecoveryEmailLabel, emailSendErrorMessage: emailSendErrorMessage, goBackToHomePageLabel: goBackToHomePageLabel } = (0, $64A2P.useComponentDefaultProps)('Login', $564cf9c9d9ac674e$export$d215453ae99c0ab5, props);
        const form = (0, $ajdIG.useForm)({
            initialValues: {
                username: ''
            }
        });
        const [status, setStatus] = (0, $acw62.useState)();
        const handleClick = (0, $acw62.useCallback)(async (values)=>{
            setStatus({
                loading: true
            });
            try {
                const data = await client.recoveryemail(values.username);
                const new_status = {
                    data: data
                };
                setStatus(new_status);
                if (onStatusCompleted) onStatusCompleted(new_status);
            } catch (e) {
                const new_status = {
                    error: (0, $98ddT.toMicroMError)(e)
                };
                setStatus(new_status);
                if (onStatusCompleted) onStatusCompleted(new_status);
            }
        }, [
            client,
            onStatusCompleted
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                    onSubmit: form.onSubmit((values)=>handleClick(values)),
                    children: [
                        status?.loading && /*#__PURE__*/ (0, $ayMG0.jsx)($lFsp3.FakeProgressBar, {}),
                        !(status?.data?.Results[0].Status === 0) && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($8mycu.TextInput, {
                                    label: userLabel,
                                    placeholder: userPlaceholder,
                                    required: true,
                                    "data-autofocus": true,
                                    disabled: status?.loading,
                                    ...form.getInputProps('username')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                    fullWidth: true,
                                    mt: "xl",
                                    disabled: status?.loading || status?.data?.Failed || status?.error !== undefined,
                                    type: "submit",
                                    children: sendRecoveryEmailLabel
                                })
                            ]
                        }),
                        status?.data?.Results[0].Status === 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)($ayMG0.Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($gLcPf.AlertSuccess, {
                                    children: emailSentSuccessfullyMessage
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                                    fullWidth: true,
                                    mt: "xl",
                                    onClick: ()=>window.location.href = '/',
                                    children: goBackToHomePageLabel
                                })
                            ]
                        })
                    ]
                }),
                status?.error && /*#__PURE__*/ (0, $ayMG0.jsx)($d50o9.AlertError, {
                    mt: "xs",
                    children: emailSendErrorMessage
                }),
                status?.data?.Failed && /*#__PURE__*/ (0, $ayMG0.jsx)($d50o9.AlertError, {
                    mt: "xs",
                    children: status.data.Results[0].Message
                })
            ]
        });
    }
});
$305cacda61daafb0$var$parcelRegister("cSyOF", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useEvent", function() {
        return $05c22ac8e02093e6$export$90fc3a17d93f704c;
    });
    function $05c22ac8e02093e6$export$90fc3a17d93f704c(callback) {
        const callbackRef = (0, $acw62.useRef)(callback);
        (0, $acw62.useLayoutEffect)(()=>{
            callbackRef.current = callback;
        }, [
            callback
        ]);
        return (0, $acw62.useCallback)((...args)=>{
            return callbackRef.current(...args);
        }, []);
    }
});
$305cacda61daafb0$var$parcelRegister("jNUqj", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "moneyFormatter", function() {
        return $5a581ff83fbc6515$export$78a4376af2fcf213;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "moneyParser", function() {
        return $5a581ff83fbc6515$export$b287540975433c0;
    });
    function $5a581ff83fbc6515$export$78a4376af2fcf213(value, currencySymbol) {
        const numericValue = parseFloat(value.replace(/[^\d.-]/g, ''));
        if (Number.isNaN(numericValue)) return currencySymbol;
        const currency = currencySymbol ? `${currencySymbol} ` : '';
        if (numericValue >= 1000000) return `${currency}${numericValue / 1000000} M`;
        if (numericValue >= 1000) return `${currency}${numericValue / 1000} K`;
        return `${currency}${numericValue.toLocaleString()}`;
    }
    function $5a581ff83fbc6515$export$b287540975433c0(value) {
        if (value.toUpperCase().endsWith('K')) return (parseFloat(value.replace(/[^\d.-]/g, '')) * 1000).toString();
        if (value.toUpperCase().endsWith('M')) return (parseFloat(value.replace(/[^\d.-]/g, '')) * 1000000).toString();
        return value.replace(/[^\d.-]/g, '');
    }
});
$305cacda61daafb0$var$parcelRegister("8tnwL", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MoneyRangeFieldDefaultProps", function() {
        return $4f557e2fa4f7c372$export$7f79cb9c8120cf58;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "MoneyRangeField", function() {
        return $4f557e2fa4f7c372$export$35626b90bc912862;
    });
    var $6pUmH = $305cacda61daafb0$var$parcelRequire("6pUmH");
    var $jNUqj = $305cacda61daafb0$var$parcelRequire("jNUqj");
    const $4f557e2fa4f7c372$export$7f79cb9c8120cf58 = {
        currencySymbol: '$',
        millionsStep: 50000,
        thousandsStep: 1000,
        step: 100
    };
    function $4f557e2fa4f7c372$export$35626b90bc912862(props) {
        const { currencySymbol: currencySymbol, entityForm: entityForm, column: column, millionsStep: millionsStep, thousandsStep: thousandsStep, step: step, ...rest } = (0, $64A2P.useComponentDefaultProps)('MoneyRangeField', $4f557e2fa4f7c372$export$7f79cb9c8120cf58, props);
        const formatter = (0, $acw62.useCallback)((value)=>{
            const formattedValue = (0, $jNUqj.moneyFormatter)(value, '');
            column.valueDescription = `${currencySymbol} ${formattedValue}`;
            return formattedValue;
        }, [
            currencySymbol
        ]);
        const variable_step = (0, $acw62.useMemo)(()=>{
            const value = entityForm.form.values[column.name];
            return value >= 1000000 ? millionsStep : value >= 1000 ? thousandsStep : step || 1;
        }, [
            column.name,
            entityForm.form.values,
            millionsStep,
            step,
            thousandsStep
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($6pUmH.NumberField, {
            ...rest,
            column: column,
            entityForm: entityForm,
            parser: $jNUqj.moneyParser,
            formatter: formatter,
            step: variable_step,
            stepHoldDelay: 500,
            stepHoldInterval: (t)=>Math.max(1000 / t ** 2, 25),
            icon: currencySymbol
        });
    }
});
$305cacda61daafb0$var$parcelRegister("8SZSR", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RadioGroupFieldDefaultProps", function() {
        return $766562f408bdbccb$export$417b39d2bb3d30c0;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "RadioGroupField", function() {
        return $766562f408bdbccb$export$a314277471067e8a;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    var $hAMyt = $305cacda61daafb0$var$parcelRequire("hAMyt");
    const $766562f408bdbccb$export$417b39d2bb3d30c0 = {
        showDescription: true
    };
    const $766562f408bdbccb$export$a314277471067e8a = /*#__PURE__*/ (0, $acw62.forwardRef)(function RadioGroupField(props, ref) {
        const { entityForm: entityForm, column: column, validationContainer: validationContainer, validate: validate, required: required, requiredMessage: requiredMessage, readOnly: readOnly, onChange: onChange, onBlur: onBlur, onFocus: onFocus, children: children, withAsterisk: withAsterisk, label: label, description: description, showDescription: showDescription, ...others } = (0, $64A2P.useComponentDefaultProps)('RadioGroupField', $766562f408bdbccb$export$417b39d2bb3d30c0, props);
        (0, $hAMyt.useFieldConfiguration)({
            entityForm: entityForm,
            column: column,
            validationContainer: validationContainer,
            validate: validate,
            required: required,
            requiredMessage: requiredMessage,
            readOnly: readOnly
        });
        const { onBlur: mantineOnBlur, onChange: mantineOnChange, onFocus: mantineOnFocus, ...mantineProps } = entityForm.form.getInputProps(column.name);
        const handleOnBlur = (0, $acw62.useCallback)((event1)=>{
            if (onBlur) onBlur(event1);
            mantineOnBlur(event1);
        }, [
            mantineOnBlur,
            onBlur
        ]);
        const handleOnChange = (0, $acw62.useCallback)((value)=>{
            if (onChange) onChange(value);
            mantineOnChange(value);
        }, [
            mantineOnChange,
            onChange
        ]);
        const handleOnFocus = (0, $acw62.useCallback)((event1)=>{
            if (onFocus) onFocus(event1);
            mantineOnFocus(event1);
        }, [
            mantineOnFocus,
            onFocus
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($jc0Be.Radio.Group, {
            ...others,
            ...mantineProps,
            withAsterisk: withAsterisk ?? (!readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))),
            label: label ?? column.prompt,
            description: showDescription ? description ?? column.description : '',
            onBlur: handleOnBlur,
            onChange: handleOnChange,
            onFocus: handleOnFocus,
            ref: ref,
            children: children
        });
    });
});
$305cacda61daafb0$var$parcelRegister("hAMyt", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "UseFieldConfigurationDefaultProps", function() {
        return $9795e88dd51f3af8$export$97903a06be652eb4;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useFieldConfiguration", function() {
        return $9795e88dd51f3af8$export$efee03e3da4c5eaa;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $4H7ea = $305cacda61daafb0$var$parcelRequire("4H7ea");
    $305cacda61daafb0$var$parcelRequire("nwtiK");
    var $2iEGY = $305cacda61daafb0$var$parcelRequire("2iEGY");
    var $2lcmZ = $305cacda61daafb0$var$parcelRequire("2lcmZ");
    const $9795e88dd51f3af8$export$97903a06be652eb4 = {
        requiredMessage: "A value is required"
    };
    const $9795e88dd51f3af8$export$efee03e3da4c5eaa = (props)=>{
        const { validationContainer: validationContainer, validate: validate, entityForm: entityForm, column: column, required: required, requiredMessage: requiredMessage, readOnly: readOnly } = (0, $64A2P.useComponentDefaultProps)('UseFieldConfigurationProps', $9795e88dd51f3af8$export$97903a06be652eb4, props);
        (0, $acw62.useEffect)(()=>{
            const config = validate ?? {};
            // MMC: Add required if not added in validators
            if (!config.required && !readOnly && !(entityForm.formMode === 'view') && (required ?? !column.hasFlag($4H7ea.EntityColumnFlags.nullable))) config['required'] = {
                message: requiredMessage
            };
            const validators = Object.entries(config).map(([key, config])=>{
                const validatorFunction = $2lcmZ.CommonValidators[key];
                if (validatorFunction) return config.data ? validatorFunction(config.data, config.message) : validatorFunction(config.message);
                return ()=>null;
            });
            if (validators.length > 0) {
                const combinedValidator = (0, $2iEGY.combineValidators)(validationContainer, ...validators);
                entityForm.configureField(column, combinedValidator);
            } else entityForm.configureField(column);
            // MMC: ensure that the field is present in form.values
            // This is important when conditionally rendering fields
            if (!Object.keys(entityForm.form.values).includes(column.name)) {
                const date_types = [
                    'date',
                    'datetime',
                    'datetime2',
                    'smalldatetime'
                ];
                if (date_types.includes(column.type)) entityForm.form.setFieldValue(column.name, column.value);
                else entityForm.form.setFieldValue(column.name, column.value ?? '');
            }
        }, [
            validate,
            entityForm,
            column,
            validationContainer,
            required,
            requiredMessage,
            readOnly
        ]);
    };
});
$305cacda61daafb0$var$parcelRegister("nwtiK", function(module1, exports) {
    var $5yJog = $305cacda61daafb0$var$parcelRequire("5yJog");
    var $ff8ov = $305cacda61daafb0$var$parcelRequire("ff8ov");
    var $2iEGY = $305cacda61daafb0$var$parcelRequire("2iEGY");
    var $2lcmZ = $305cacda61daafb0$var$parcelRequire("2lcmZ");
    var $f8cx6 = $305cacda61daafb0$var$parcelRequire("f8cx6");
    var $hJpqZ = $305cacda61daafb0$var$parcelRequire("hJpqZ");
    var $9WxFU = $305cacda61daafb0$var$parcelRequire("9WxFU");
    var $1ctLw = $305cacda61daafb0$var$parcelRequire("1ctLw");
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $5yJog);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $ff8ov);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2iEGY);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $2lcmZ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $f8cx6);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $hJpqZ);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $9WxFU);
    $305cacda61daafb0$var$$parcel$exportWildcard(module1.exports, $1ctLw);
});
$305cacda61daafb0$var$parcelRegister("5yJog", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isURL", function() {
        return $57f976857bcaa3e2$export$bab98af026af71ac;
    });
    const $57f976857bcaa3e2$export$bab98af026af71ac = (error)=>{
        const _error = error || true;
        return (value)=>{
            // Allways allow empty values. The required validation should be used for that.
            if (!value) return null;
            if (typeof value !== 'string') return _error;
            const pattern = new RegExp('^https?://[^\\s]+[^\\s]$', 'i');
            return pattern.test(value) ? null : _error;
        };
    };
});
$305cacda61daafb0$var$parcelRegister("ff8ov", function(module1, exports) {});
$305cacda61daafb0$var$parcelRegister("2iEGY", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "combineValidators", function() {
        return $29c15c8b70d4aab5$export$45c5cc3efab3761b;
    });
    /* eslint-disable react/display-name */ const $29c15c8b70d4aab5$export$45c5cc3efab3761b = (Container, ...validators)=>{
        return (value, values)=>{
            const errorMessages = [];
            let hasTrueError = false;
            validators.forEach((validator)=>{
                const result = validator(value, values);
                if (result && result !== true) errorMessages.push(result);
                else if (result === true) hasTrueError = true;
            });
            if (errorMessages.length === 0) return hasTrueError ? true : null;
            if (!Container) return errorMessages;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(Container, {
                children: errorMessages
            });
        };
    };
});
$305cacda61daafb0$var$parcelRegister("2lcmZ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CommonValidators", function() {
        return $bdf3da2f6c2791ab$export$ff81ceee04f7085f;
    });
    var $hJpqZ = $305cacda61daafb0$var$parcelRequire("hJpqZ");
    var $1ctLw = $305cacda61daafb0$var$parcelRequire("1ctLw");
    var $9WxFU = $305cacda61daafb0$var$parcelRequire("9WxFU");
    var $f8cx6 = $305cacda61daafb0$var$parcelRequire("f8cx6");
    var $5yJog = $305cacda61daafb0$var$parcelRequire("5yJog");
    const $bdf3da2f6c2791ab$export$ff81ceee04f7085f = {
        // Custom Regex
        url: $5yJog.isURL,
        phone: $f8cx6.isPhone,
        cuit: $hJpqZ.isValidCUIT,
        email: $9WxFU.isValidEmail,
        // From mantine
        length: $1Eb18.hasLength,
        required: $aKTxt.isNotEmpty,
        regex: $loxEI.matches,
        range: $76pRr.isInRange,
        field: $8Qw8Z.matchesField,
        custom: $1ctLw.CustomValidator
    };
});
$305cacda61daafb0$var$parcelRegister("hJpqZ", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isValidCUIT", function() {
        return $08fbab20a4a5c333$export$c88f848005e367d2;
    });
    const $08fbab20a4a5c333$export$c88f848005e367d2 = (error)=>{
        const _error = error || true;
        return (value)=>{
            // Allways allow empty values. The required validation should be used for that.
            if (!value) return null;
            if (typeof value !== 'string') return _error;
            const validPrefixes = [
                '20',
                '23',
                '24',
                '27',
                '30',
                '33',
                '34',
                '37',
                '80',
                '83',
                '84',
                '87'
            ];
            // Convert string to array of digits
            const cuitNumbers = value.replace(/-/g, '').split('').map(Number);
            if (cuitNumbers.length !== 11) return _error;
            const prefix = cuitNumbers.slice(0, 2).join('');
            if (!validPrefixes.includes(prefix)) return _error;
            const verifierDigit = cuitNumbers.pop();
            // Compute verifier digit
            const weights = [
                5,
                4,
                3,
                2,
                7,
                6,
                5,
                4,
                3,
                2
            ];
            const multiplied = cuitNumbers.map((digit, i)=>{
                return digit * weights[i];
            });
            const suma = multiplied.reduce((sum, multiplier)=>{
                return sum + multiplier;
            });
            const modulo = suma % 11;
            const computedVerifier = (11 - modulo) % 11;
            return computedVerifier === verifierDigit ? null : _error;
        };
    };
});
$305cacda61daafb0$var$parcelRegister("1ctLw", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "CustomValidator", function() {
        return $593cf89ea1005eb2$export$523d4cd6cd71a35c;
    });
    const $593cf89ea1005eb2$export$523d4cd6cd71a35c = (validationFunction)=>{
        return validationFunction;
    };
});
$305cacda61daafb0$var$parcelRegister("9WxFU", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isValidEmail", function() {
        return $16787d69a479b63a$export$371e338370561054;
    });
    const $16787d69a479b63a$export$371e338370561054 = (error)=>{
        const _error = error || true;
        return (value)=>{
            // Allways allow empty values. The required validation should be used for that.
            if (!value) return null;
            if (typeof value !== 'string') return _error;
            const pattern = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
            return pattern.test(value) ? null : _error;
        };
    };
});
$305cacda61daafb0$var$parcelRegister("f8cx6", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "isPhone", function() {
        return $3c914f97a1f36fc4$export$3dc8fb2aae1f259d;
    });
    const $3c914f97a1f36fc4$export$3dc8fb2aae1f259d = (error)=>{
        const _error = error || true;
        return (value)=>{
            // Allways allow empty values. The required validation should be used for that.
            if (!value) return null;
            if (typeof value !== 'string') return _error;
            const pattern = new RegExp('^\\+?\\d+$');
            return pattern.test(value) ? null : _error;
        };
    };
});
$305cacda61daafb0$var$parcelRegister("lwxCY", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useAncestorResize", function() {
        return $7db09a3cea4e6136$export$d994cf386c6f1d98;
    });
    function $7db09a3cea4e6136$var$parseUnit(value, ancestorWidth, ancestorHeight, baseFontSize) {
        if (value.endsWith('px')) return parseFloat(value);
        if (value.endsWith('vw')) return window.innerWidth * parseFloat(value) / 100;
        if (value.endsWith('vh')) return window.innerHeight * parseFloat(value) / 100;
        if (value.endsWith('rem')) return parseFloat(value) * baseFontSize;
        if (value.endsWith('em')) return parseFloat(value) * baseFontSize;
        if (value.endsWith('%')) return parseFloat(value) / 100 * (ancestorWidth || ancestorHeight);
        return parseFloat(value);
    }
    function $7db09a3cea4e6136$export$d994cf386c6f1d98(minSize = {
        width: '300px',
        height: '400px'
    }) {
        const ref = (0, $acw62.useRef)(null);
        const [size, setSize] = (0, $acw62.useState)({
            width: 0,
            height: 0
        });
        (0, $acw62.useEffect)(()=>{
            if (!ref.current) return;
            const findFirstScrollableAncestor = (el)=>{
                while(el){
                    const overflowY = getComputedStyle(el).overflowY;
                    if (overflowY === 'auto' || overflowY === 'scroll') return el;
                    el = el.parentElement;
                }
                return null;
            };
            const ancestor = findFirstScrollableAncestor(ref.current.parentElement) ?? ref.current.parentElement;
            if (!ancestor) {
                console.warn('cant resize, noancestor');
                return;
            }
            const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const minWidth = $7db09a3cea4e6136$var$parseUnit(minSize.width, ancestor.clientWidth, ancestor.clientHeight, baseFontSize);
            const minHeight = $7db09a3cea4e6136$var$parseUnit(minSize.height, ancestor.clientWidth, ancestor.clientHeight, baseFontSize);
            const resize = ()=>{
                const width = ancestor.clientWidth;
                const height = ancestor.clientHeight;
                setSize({
                    width: Math.max(minWidth, width),
                    height: Math.max(minHeight, height)
                });
            };
            const observer = new ResizeObserver(resize);
            observer.observe(ancestor);
            window.addEventListener('resize', resize);
            resize();
            return ()=>{
                observer.disconnect();
                window.removeEventListener('resize', resize);
            };
        }, [
            minSize.width,
            minSize.height
        ]);
        return {
            ref: ref,
            size: size
        };
    }
});
$305cacda61daafb0$var$parcelRegister("4Hta3", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useResponsiveWidth", function() {
        return $4aacbb5e33f0363a$export$7dfb35d99dc3ea4e;
    });
    function $4aacbb5e33f0363a$export$7dfb35d99dc3ea4e(maxWidthRem, paddingRem) {
        const viewportSize = (0, $eJ0gu.useViewportSize)();
        const [width, setWidth] = (0, $acw62.useState)(maxWidthRem);
        (0, $acw62.useEffect)(()=>{
            const desiredWidth = (0, $62A7W.px)(maxWidthRem);
            const totalPadding = (0, $62A7W.px)(paddingRem) * 2;
            const availableWidth = viewportSize.width - totalPadding;
            if (availableWidth < desiredWidth) setWidth((0, $2jkdX.rem)(availableWidth));
            else setWidth(maxWidthRem);
        }, [
            maxWidthRem,
            paddingRem,
            viewportSize.width
        ]);
        return width;
    }
});
$305cacda61daafb0$var$parcelRegister("5Qlvf", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useViewportDynamicVariables", function() {
        return $98ff122907b73b17$export$ab1a26042f34b9b;
    });
    function $98ff122907b73b17$export$ab1a26042f34b9b() {
        (0, $acw62.useEffect)(()=>{
            const setDynVariables = ()=>{
                // window.innerHeight excludes address bar
                const dynVH = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--dynVH', `${dynVH}px`);
                // set width
                const dynVW = window.innerWidth * 0.01;
                document.documentElement.style.setProperty('--dynVW', `${dynVW}px`);
            };
            setDynVariables();
            window.addEventListener('resize', setDynVariables);
            window.addEventListener('orientationchange', setDynVariables);
            return ()=>{
                window.removeEventListener('resize', setDynVariables);
                window.removeEventListener('orientationchange', setDynVariables);
            };
        }, []);
    }
});
$305cacda61daafb0$var$parcelRegister("e6gIh", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "useExecuteExportProc", function() {
        return $a486f11e2b6179fb$export$6718376188b647af;
    });
    $305cacda61daafb0$var$parcelRequire("6Rdyz");
    var $98ddT = $305cacda61daafb0$var$parcelRequire("98ddT");
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $iKzSR = $305cacda61daafb0$var$parcelRequire("iKzSR");
    function $a486f11e2b6179fb$export$6718376188b647af(entity, proc) {
        const [status, setStatus] = (0, $acw62.useState)({
            loading: false,
            operationType: 'export'
        });
        const cancellation = (0, $acw62.useRef)(new AbortController());
        const done = (0, $acw62.useRef)(false);
        const prevValues = (0, $acw62.useRef)();
        (0, $acw62.useEffect)(()=>{
            return ()=>{
                if (!done.current) {
                    console.log("useExecuteExportProc aborted on unmount");
                    cancellation.current.abort("Component unmounted");
                }
            };
        }, []);
        const execute = (0, $acw62.useCallback)(async (values)=>{
            if (status.loading) return status;
            if (!(0, $iKzSR.areValuesObjectsEqual)(values, prevValues.current)) {
                // Abort the previous request before starting a new one
                cancellation.current.abort("ExecuteExportProc, aborting previous request.");
                cancellation.current = new AbortController();
                done.current = false;
                try {
                    // Update previous values
                    prevValues.current = values;
                    if (entity && proc) {
                        setStatus({
                            loading: true,
                            operationType: 'export'
                        });
                        const data = await entity.API.exportProc(proc, values, cancellation.current.signal);
                        done.current = true;
                        const new_status = {
                            data: data,
                            operationType: 'export'
                        };
                        setStatus(new_status);
                        return new_status;
                    }
                } catch (e) {
                    if (e.name !== 'AbortError' && e !== "ExecuteExportProc, aborting previous request.") {
                        const new_status = {
                            error: (0, $98ddT.toMicroMError)(e),
                            operationType: 'export'
                        };
                        setStatus(new_status);
                        return new_status;
                    }
                }
            }
        }, [
            entity,
            proc,
            status
        ]);
        const abort = (0, $acw62.useCallback)(()=>{
            cancellation.current.abort();
        }, []);
        return {
            execute: execute,
            status: status,
            abort: abort
        };
    }
});
$305cacda61daafb0$var$parcelRegister("8xtCs", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityFormPagePropsDefaultProps", function() {
        return $c833ee01870e60df$export$e73f1d9fe021a92b;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityFormPage", function() {
        return $c833ee01870e60df$export$bf63b1212bff1393;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $gYKfx = $305cacda61daafb0$var$parcelRequire("gYKfx");
    const $c833ee01870e60df$export$e73f1d9fe021a92b = {
        saveAndGetOnSubmit: true,
        defaultLoadingComponent: /*#__PURE__*/ (0, $ayMG0.jsx)($AaRVC.Skeleton, {})
    };
    function $c833ee01870e60df$export$bf63b1212bff1393(props) {
        const { entityConstructor: entityConstructor, client: client, defaultLoadingComponent: defaultLoadingComponent, ...rest } = (0, $64A2P.useComponentDefaultProps)('EntityFormPage', $c833ee01870e60df$export$e73f1d9fe021a92b, props);
        const [entityForm, setEntityForm] = (0, $acw62.useState)(null);
        const entityRef = (0, $acw62.useRef)(null);
        // MMC: note that rest properties are not used in the useEffect dependency array as using ...rest will create a new object on every render
        (0, $acw62.useEffect)(()=>{
            if (!entityRef.current) entityRef.current = entityConstructor(client);
            if (!entityRef.current.Form) {
                setEntityForm(/*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {}));
                return;
            }
            const maybePromiseForm = (0, $gYKfx.createEntityForm)({
                entity: entityRef.current,
                ...rest
            });
            Promise.resolve(maybePromiseForm).then((resolvedForm)=>{
                setEntityForm(resolvedForm);
            });
        }, [
            client,
            entityConstructor
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ayMG0.Fragment, {
            children: entityForm || defaultLoadingComponent
        });
    }
});
$305cacda61daafb0$var$parcelRegister("8kWvc", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "StepperFormDefaultProps", function() {
        return $27c8401694ba9957$export$8e1e02696f0ce175;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "StepperForm", function() {
        return $27c8401694ba9957$export$166f000a4c5cc84a;
    });
    var $bHLhd = $305cacda61daafb0$var$parcelRequire("bHLhd");
    const $27c8401694ba9957$export$8e1e02696f0ce175 = {
        nextStepLabel: "Next step",
        prevStepLabel: "Back",
        showOK: false,
        showCancel: false,
        showFormValidationNotification: true,
        showLoadingProgress: true,
        showErrors: true,
        OKText: "Save",
        CancelText: "Cancel",
        CloseText: "Close",
        invalidFieldsLabel: "Some fields are invalid, please review the form",
        showHelpButton: false,
        preventEnterSubmission: true,
        allowStepClickForward: false,
        hideNextAndBackWhenCompleted: true
    };
    function $27c8401694ba9957$export$166f000a4c5cc84a(props) {
        const { formAPI: formAPI, onNextStep: onNextStep, onPrevStep: onPrevStep, initialStep: initialStep, nextStepLabel: nextStepLabel, prevStepLabel: prevStepLabel, allowStepClickForward: allowStepClickForward, steps: steps, OKText: OKText, completedContent: completedContent, hideNextAndBackWhenCompleted: hideNextAndBackWhenCompleted, stepperProps: stepperProps, onCompleted: onCompleted, ...rest } = (0, $64A2P.useComponentDefaultProps)('StepperForm', $27c8401694ba9957$export$8e1e02696f0ce175, props);
        const { status: status, formMode: formMode } = formAPI;
        const [activeStep, setActiveStep] = (0, $acw62.useState)(initialStep);
        const [stepValidating, setStepValidating] = (0, $acw62.useState)(false);
        const [stepValid, setStepValid] = (0, $acw62.useState)(Array(steps.length).fill(false));
        const activeStepItem = steps[activeStep];
        const validateCurrentStepFields = (0, $acw62.useCallback)(()=>{
            const currentStep = steps[activeStep];
            if (currentStep.validateFields) {
                const validationResults = currentStep.validateFields.map((field)=>formAPI.form.validateField(field));
                return validationResults.every((result)=>result.hasError === false);
            }
            return true;
        }, [
            activeStep,
            formAPI.form,
            steps
        ]);
        const nextStep = (0, $acw62.useCallback)(async (event1)=>{
            event1.preventDefault();
            const currentStep = steps[activeStep];
            let isValid = validateCurrentStepFields();
            if (!isValid) return;
            const hasAsyncValidation = currentStep.nextStepValidation || onNextStep;
            if (hasAsyncValidation && !stepValid[activeStep]) {
                setStepValidating(true);
                try {
                    if (currentStep.nextStepValidation) isValid = await currentStep.nextStepValidation();
                    if (isValid && onNextStep) isValid = await onNextStep(steps[activeStep + 1]);
                } catch (e) {
                    throw e;
                } finally{
                    setStepValidating(false);
                }
                if (isValid) {
                    setStepValid((prev)=>{
                        const newStepValid = [
                            ...prev
                        ];
                        newStepValid[activeStep] = true;
                        return newStepValid;
                    });
                    if (activeStep < steps.length - 1) setActiveStep((current)=>current + 1);
                    else if (formMode === 'view') setActiveStep(steps.length); // Completed step
                } else setStepValid((prev)=>{
                    const newStepValid = [
                        ...prev
                    ];
                    newStepValid[activeStep] = false;
                    return newStepValid;
                });
            } else {
                if (activeStep < steps.length - 1) setActiveStep((current)=>current + 1);
                else if (formMode === 'view') setActiveStep(steps.length); // Completed step
            }
        }, [
            activeStep,
            formMode,
            onNextStep,
            stepValid,
            steps,
            validateCurrentStepFields
        ]);
        const prevStep = (0, $acw62.useCallback)(async (event1)=>{
            event1.preventDefault();
            let isValid = true;
            if (activeStep > 0) {
                try {
                    if (onPrevStep) {
                        setStepValidating(true);
                        isValid = await onPrevStep(steps[activeStep - 1]);
                    }
                } catch (e) {
                    throw e;
                } finally{
                    setStepValidating(false);
                }
                if (isValid) setActiveStep((current)=>current - 1);
            }
        }, [
            activeStep,
            onPrevStep,
            steps
        ]);
        const handleStepClick = (0, $acw62.useCallback)(async (stepIndex)=>{
            if (stepIndex < activeStep) setActiveStep(stepIndex);
            else if (allowStepClickForward) {
                const isValid = validateCurrentStepFields();
                if (isValid) setActiveStep(stepIndex);
            }
        }, [
            activeStep,
            allowStepClickForward,
            validateCurrentStepFields
        ]);
        const buttons = (0, $acw62.useMemo)(()=>!(hideNextAndBackWhenCompleted && activeStep === steps.length) && /*#__PURE__*/ (0, $ayMG0.jsxs)($9mTYo.Group, {
                position: activeStep > 0 ? 'apart' : 'right',
                style: {
                    flex: 'auto'
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        loading: stepValidating,
                        variant: "default",
                        type: "button",
                        onClick: prevStep,
                        display: activeStep > 0 ? 'inline-block' : 'none',
                        children: prevStepLabel
                    }, "stepper-back"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        type: "submit",
                        loading: status?.loading,
                        leftIcon: /*#__PURE__*/ (0, $ayMG0.jsx)($4Rwq2.default, {
                            size: "1.125rem"
                        }),
                        display: formMode !== "view" && activeStep === steps.length - 1 ? 'inline-block' : 'none',
                        children: activeStepItem.nextStepLabel || nextStepLabel
                    }, "stepper-submit"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($gU5rH.Button, {
                        loading: stepValidating,
                        onClick: nextStep,
                        type: "button",
                        display: activeStep < steps.length - 1 ? 'inline-block' : 'none',
                        children: (stepValid[activeStep] ? activeStepItem.nextStepValidLabel : activeStepItem.nextStepLabel) || nextStepLabel
                    }, "stepper-next")
                ]
            }), [
            activeStep,
            activeStepItem,
            formMode,
            hideNextAndBackWhenCompleted,
            nextStep,
            nextStepLabel,
            prevStep,
            prevStepLabel,
            status?.loading,
            stepValid,
            stepValidating,
            steps.length
        ]);
        (0, $acw62.useEffect)(()=>{
            setStepValid((prev)=>{
                const newStepValid = [
                    ...prev
                ];
                newStepValid[activeStep] = false;
                return newStepValid;
            });
        }, [
            activeStep
        ]);
        (0, $acw62.useEffect)(()=>{
            if (!status.error && !status.loading && status.data) {
                const dbstat = status.data;
                if (!dbstat?.Failed) setActiveStep(steps.length); // Completed step
            }
        }, [
            status.data,
            status.error,
            status.loading,
            steps.length
        ]);
        (0, $acw62.useEffect)(()=>{
            if (activeStep === steps.length && onCompleted) onCompleted();
        }, [
            activeStep,
            onCompleted,
            steps.length
        ]);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($bHLhd.EntityForm, {
            ...rest,
            buttons: buttons,
            formAPI: formAPI,
            showCancel: false,
            showOK: false,
            OKText: OKText,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)($1c0Cg.Stepper, {
                active: activeStep,
                onStepClick: handleStepClick,
                ...stepperProps,
                children: [
                    steps.map((step)=>/*#__PURE__*/ (0, $ayMG0.jsx)($1c0Cg.Stepper.Step, {
                            label: step.label,
                            description: step.description,
                            icon: step.icon,
                            children: step.content
                        }, step.name)),
                    completedContent && /*#__PURE__*/ (0, $ayMG0.jsx)($1c0Cg.Stepper.Completed, {
                        children: completedContent
                    })
                ]
            })
        });
    }
});
$305cacda61daafb0$var$parcelRegister("efs8D", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getWindowLocationQueryStringAsObject", function() {
        return $f00da75f7970b183$export$306c190a115776e;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "buildURLQueryString", function() {
        return $f00da75f7970b183$export$ab139067d9005d6;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "getWindowLocationQueryStringAsValueObject", function() {
        return $f00da75f7970b183$export$1fa3be3e4f582a2d;
    });
    $305cacda61daafb0$var$parcelRequire("2eyXi");
    var $eRkDL = $305cacda61daafb0$var$parcelRequire("eRkDL");
    function $f00da75f7970b183$export$306c190a115776e() {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};
        for (const [key, value] of searchParams)params[key] = value;
        return params;
    }
    function $f00da75f7970b183$export$ab139067d9005d6(params) {
        const searchParams = new URLSearchParams();
        for(const key in params){
            const val = params[key];
            // check if val is a string[] and convert to json string array
            if (Array.isArray(val)) {
                searchParams.set(key, JSON.stringify(val));
                continue;
            }
            const queryValue = params[key]?.toString() || '';
            searchParams.set(key, queryValue);
        }
        return searchParams.toString();
    }
    function $f00da75f7970b183$export$1fa3be3e4f582a2d(columns) {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};
        for (const [key, value] of searchParams){
            const col = columns[key];
            if (col) params[key] = (0, $eRkDL.convertValueFromString)(col, value);
        }
        return params;
    }
});
$305cacda61daafb0$var$parcelRegister("dZuNe", function(module1, exports) {
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityFormModalDefaultProps", function() {
        return $70a21e070d5119f8$export$55c300775114d1d7;
    });
    $305cacda61daafb0$var$$parcel$export(module1.exports, "EntityFormModal", function() {
        return $70a21e070d5119f8$export$82ae7c22f1133bd2;
    });
    $305cacda61daafb0$var$parcelRequire("7xGLy");
    var $9maeT = $305cacda61daafb0$var$parcelRequire("9maeT");
    const $70a21e070d5119f8$export$55c300775114d1d7 = {
        initialFormMode: 'add',
        modalFormSize: 'xl',
        withFullscreenButton: true,
        closeOnEscape: true,
        closeOnClickOutside: false
    };
    function $70a21e070d5119f8$export$82ae7c22f1133bd2(props) {
        const { client: client, entityConstructor: entityConstructor, openState: openState, setOpenState: setOpenState, initialFormMode: initialFormMode, getDataOnInit: getDataOnInit, onModalClosed: onModalClosed, onModalSaved: onModalSaved, modalFormSize: modalFormSize, withFullscreenButton: withFullscreenButton, closeOnClickOutside: closeOnClickOutside, closeOnEscape: closeOnEscape } = (0, $64A2P.useComponentDefaultProps)('EntityFormModal', $70a21e070d5119f8$export$55c300775114d1d7, props);
        const openForm = (0, $9maeT.useOpenForm)();
        const hasOpened = (0, $acw62.useRef)(false);
        (0, $acw62.useEffect)(()=>{
            const open = async ()=>{
                const entity = entityConstructor(client);
                await openForm({
                    modalFormSize: modalFormSize,
                    entity: entity,
                    initialFormMode: initialFormMode,
                    getDataOnInit: getDataOnInit,
                    withFullscreenButton: withFullscreenButton,
                    closeOnClickOutside: closeOnClickOutside,
                    closeOnEscape: closeOnEscape,
                    onModalClosed: ()=>{
                        setOpenState(false);
                        hasOpened.current = false;
                        if (onModalClosed) onModalClosed();
                    },
                    onModalSaved: async (status)=>{
                        if (onModalSaved) await onModalSaved(status);
                    }
                });
            };
            if (openState && !hasOpened.current) {
                hasOpened.current = true;
                open();
            }
        }, [
            client,
            entityConstructor,
            getDataOnInit,
            initialFormMode,
            onModalClosed,
            onModalSaved,
            openForm,
            openState,
            setOpenState,
            modalFormSize,
            withFullscreenButton,
            closeOnEscape,
            closeOnClickOutside
        ]);
        return null;
    }
});
var $305cacda61daafb0$var$$6Rdyz = $305cacda61daafb0$var$parcelRequire("6Rdyz");
var $305cacda61daafb0$var$$2eyXi = $305cacda61daafb0$var$parcelRequire("2eyXi");
var $305cacda61daafb0$var$$kMllr = $305cacda61daafb0$var$parcelRequire("kMllr");
var $305cacda61daafb0$var$$faRXj = $305cacda61daafb0$var$parcelRequire("faRXj");
var $305cacda61daafb0$var$$nwtiK = $305cacda61daafb0$var$parcelRequire("nwtiK");
var $305cacda61daafb0$var$$hZjV3 = $305cacda61daafb0$var$parcelRequire("hZjV3");
$305cacda61daafb0$var$$parcel$exportWildcard(module.exports, $305cacda61daafb0$var$$6Rdyz);
$305cacda61daafb0$var$$parcel$exportWildcard(module.exports, $305cacda61daafb0$var$$2eyXi);
$305cacda61daafb0$var$$parcel$exportWildcard(module.exports, $305cacda61daafb0$var$$kMllr);
$305cacda61daafb0$var$$parcel$exportWildcard(module.exports, $305cacda61daafb0$var$$faRXj);
$305cacda61daafb0$var$$parcel$exportWildcard(module.exports, $305cacda61daafb0$var$$nwtiK);
$305cacda61daafb0$var$$parcel$exportWildcard(module.exports, $305cacda61daafb0$var$$hZjV3);

});
parcelRegister("iLvQN", function(module, exports) {

$parcel$export(module.exports, "Accordion", () => $038689975415d97a$export$a766cd26d0d69044);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $kq8z9 = parcelRequire("kq8z9");

var $2MZrX = parcelRequire("2MZrX");

var $9m6qg = parcelRequire("9m6qg");

var $gXuzC = parcelRequire("gXuzC");

var $1cBiA = parcelRequire("1cBiA");

var $hiiR1 = parcelRequire("hiiR1");
var $038689975415d97a$var$__defProp = Object.defineProperty;
var $038689975415d97a$var$__defProps = Object.defineProperties;
var $038689975415d97a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $038689975415d97a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $038689975415d97a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $038689975415d97a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $038689975415d97a$var$__defNormalProp = (obj, key, value)=>key in obj ? $038689975415d97a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $038689975415d97a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($038689975415d97a$var$__hasOwnProp.call(b, prop)) $038689975415d97a$var$__defNormalProp(a, prop, b[prop]);
    if ($038689975415d97a$var$__getOwnPropSymbols) {
        for (var prop of $038689975415d97a$var$__getOwnPropSymbols(b))if ($038689975415d97a$var$__propIsEnum.call(b, prop)) $038689975415d97a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $038689975415d97a$var$__spreadProps = (a, b)=>$038689975415d97a$var$__defProps(a, $038689975415d97a$var$__getOwnPropDescs(b));
var $038689975415d97a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($038689975415d97a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $038689975415d97a$var$__getOwnPropSymbols) {
        for (var prop of $038689975415d97a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $038689975415d97a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $038689975415d97a$var$defaultProps = {
    multiple: false,
    disableChevronRotation: false,
    transitionDuration: 200,
    chevronPosition: "right",
    variant: "default",
    chevronSize: 24,
    chevron: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1cBiA.ChevronIcon), null)
};
function $038689975415d97a$export$a766cd26d0d69044(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("Accordion", $038689975415d97a$var$defaultProps, props), { id: id, loop: loop, children: children, multiple: multiple, value: value, defaultValue: defaultValue, onChange: onChange, transitionDuration: transitionDuration, disableChevronRotation: disableChevronRotation, chevronPosition: chevronPosition, chevronSize: chevronSize, order: order, chevron: chevron, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant, radius: radius } = _a, others = $038689975415d97a$var$__objRest(_a, [
        "id",
        "loop",
        "children",
        "multiple",
        "value",
        "defaultValue",
        "onChange",
        "transitionDuration",
        "disableChevronRotation",
        "chevronPosition",
        "chevronSize",
        "order",
        "chevron",
        "classNames",
        "styles",
        "unstyled",
        "variant",
        "radius"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kq8z9.AccordionProvider), {
        id: id,
        multiple: multiple,
        value: value,
        defaultValue: defaultValue,
        onChange: onChange,
        loop: loop,
        transitionDuration: transitionDuration,
        disableChevronRotation: disableChevronRotation,
        chevronPosition: chevronPosition,
        chevronSize: chevronSize,
        order: order,
        chevron: chevron,
        variant: variant,
        radius: radius,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $038689975415d97a$var$__spreadProps($038689975415d97a$var$__spreadValues({}, others), {
        "data-accordion": true
    }), children));
}
$038689975415d97a$export$a766cd26d0d69044.Item = (0, $2MZrX.AccordionItem);
$038689975415d97a$export$a766cd26d0d69044.Control = (0, $9m6qg.AccordionControl);
$038689975415d97a$export$a766cd26d0d69044.Panel = (0, $gXuzC.AccordionPanel);
$038689975415d97a$export$a766cd26d0d69044.displayName = "@mantine/core/Accordion";

});
parcelRegister("kq8z9", function(module, exports) {

$parcel$export(module.exports, "AccordionProvider", () => $eddce163a7b28836$export$a7339cf504e447d7);

var $acw62 = parcelRequire("acw62");

var $b8Evx = parcelRequire("b8Evx");

var $8nBd8 = parcelRequire("8nBd8");
var $ke4gU = parcelRequire("ke4gU");

var $771VU = parcelRequire("771VU");

var $2HNI6 = parcelRequire("2HNI6");
function $eddce163a7b28836$export$a7339cf504e447d7({ children: children, multiple: multiple, value: value, defaultValue: defaultValue, onChange: onChange, id: id, loop: loop, transitionDuration: transitionDuration, disableChevronRotation: disableChevronRotation, chevronPosition: chevronPosition, chevronSize: chevronSize, order: order, chevron: chevron, variant: variant, radius: radius, classNames: classNames, styles: styles, unstyled: unstyled }) {
    const uid = (0, $8nBd8.useId)(id);
    const [_value, handleChange] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: multiple ? [] : null,
        onChange: onChange
    });
    const isItemActive = (itemValue)=>Array.isArray(_value) ? _value.includes(itemValue) : itemValue === _value;
    const handleItemChange = (itemValue)=>{
        const nextValue = Array.isArray(_value) ? _value.includes(itemValue) ? _value.filter((selectedValue)=>selectedValue !== itemValue) : [
            ..._value,
            itemValue
        ] : itemValue === _value ? null : itemValue;
        handleChange(nextValue);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $771VU.AccordionContextProvider), {
        value: {
            isItemActive: isItemActive,
            onChange: handleItemChange,
            getControlId: (0, $b8Evx.getSafeId)(`${uid}-control`, (0, $2HNI6.ACCORDION_ERRORS).value),
            getRegionId: (0, $b8Evx.getSafeId)(`${uid}-panel`, (0, $2HNI6.ACCORDION_ERRORS).value),
            transitionDuration: transitionDuration,
            disableChevronRotation: disableChevronRotation,
            chevronPosition: chevronPosition,
            chevronSize: chevronSize,
            order: order,
            chevron: chevron,
            loop: loop,
            variant: variant,
            radius: radius,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled
        }
    }, children);
}

});
parcelRegister("b8Evx", function(module, exports) {

$parcel$export(module.exports, "getSafeId", () => $81bfdd0af9b69fa9$export$d1aa29729505dfb6);
function $81bfdd0af9b69fa9$export$d1aa29729505dfb6(uid, errorMessage) {
    return (value)=>{
        if (typeof value !== "string" || value.trim().length === 0) throw new Error(errorMessage);
        return `${uid}-${value}`;
    };
}

});

parcelRegister("771VU", function(module, exports) {

$parcel$export(module.exports, "AccordionContextProvider", () => $52daafb31966733d$export$f9ca43ac79772cff);
$parcel$export(module.exports, "useAccordionContext", () => $52daafb31966733d$export$33b38874135ce337);

var $jIWSq = parcelRequire("jIWSq");

var $2HNI6 = parcelRequire("2HNI6");
const [$52daafb31966733d$export$f9ca43ac79772cff, $52daafb31966733d$export$33b38874135ce337] = (0, $jIWSq.createSafeContext)((0, $2HNI6.ACCORDION_ERRORS).context);

});
parcelRegister("2HNI6", function(module, exports) {

$parcel$export(module.exports, "ACCORDION_ERRORS", () => $1f86285c3a051226$export$296af1a2506eda00);
const $1f86285c3a051226$export$296af1a2506eda00 = {
    context: "Accordion component was not found in the tree",
    itemContext: "Accordion.Item component was not found in the tree",
    value: "Accordion.Item component was rendered with invalid value or without value"
};

});



parcelRegister("2MZrX", function(module, exports) {

$parcel$export(module.exports, "AccordionItem", () => $207fbb2a5041ceec$export$d99097c13d4dac9f);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $dVqc3 = parcelRequire("dVqc3");

var $jZD5X = parcelRequire("jZD5X");

var $771VU = parcelRequire("771VU");

var $hiiR1 = parcelRequire("hiiR1");
var $207fbb2a5041ceec$var$__defProp = Object.defineProperty;
var $207fbb2a5041ceec$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $207fbb2a5041ceec$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $207fbb2a5041ceec$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $207fbb2a5041ceec$var$__defNormalProp = (obj, key, value)=>key in obj ? $207fbb2a5041ceec$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $207fbb2a5041ceec$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($207fbb2a5041ceec$var$__hasOwnProp.call(b, prop)) $207fbb2a5041ceec$var$__defNormalProp(a, prop, b[prop]);
    if ($207fbb2a5041ceec$var$__getOwnPropSymbols) {
        for (var prop of $207fbb2a5041ceec$var$__getOwnPropSymbols(b))if ($207fbb2a5041ceec$var$__propIsEnum.call(b, prop)) $207fbb2a5041ceec$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $207fbb2a5041ceec$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($207fbb2a5041ceec$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $207fbb2a5041ceec$var$__getOwnPropSymbols) {
        for (var prop of $207fbb2a5041ceec$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $207fbb2a5041ceec$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $207fbb2a5041ceec$var$defaultProps = {};
const $207fbb2a5041ceec$export$d99097c13d4dac9f = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("AccordionItem", $207fbb2a5041ceec$var$defaultProps, props), { children: children, className: className, value: value } = _a, others = $207fbb2a5041ceec$var$__objRest(_a, [
        "children",
        "className",
        "value"
    ]);
    const ctx = (0, $771VU.useAccordionContext)();
    const { classes: classes, cx: cx } = (0, $jZD5X.default)({
        radius: ctx.radius
    }, {
        name: "Accordion",
        classNames: ctx.classNames,
        styles: ctx.styles,
        unstyled: ctx.unstyled,
        variant: ctx.variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dVqc3.AccordionItemContextProvider), {
        value: {
            value: value
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $207fbb2a5041ceec$var$__spreadValues({
        ref: ref,
        className: cx(classes.item, className),
        "data-active": ctx.isItemActive(value) || void 0
    }, others), children));
});
$207fbb2a5041ceec$export$d99097c13d4dac9f.displayName = "@mantine/core/AccordionItem";

});
parcelRegister("dVqc3", function(module, exports) {

$parcel$export(module.exports, "AccordionItemContextProvider", () => $a234eab88dc937b2$export$f46aed319951be62);
$parcel$export(module.exports, "useAccordionItemContext", () => $a234eab88dc937b2$export$26f4eabe9fa88f4f);

var $jIWSq = parcelRequire("jIWSq");

var $2HNI6 = parcelRequire("2HNI6");
const [$a234eab88dc937b2$export$f46aed319951be62, $a234eab88dc937b2$export$26f4eabe9fa88f4f] = (0, $jIWSq.createSafeContext)((0, $2HNI6.ACCORDION_ERRORS).itemContext);

});

parcelRegister("jZD5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8e20a5062f239ca$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
function $e8e20a5062f239ca$var$getVariantStyles(theme, variant, { radius: radius }) {
    const borderColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
    const filledColor = theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0];
    const borderRadius = theme.fn.radius(radius);
    if (variant === "default") return {
        color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        borderBottom: `${(0, $2jkdX.rem)(1)} solid ${borderColor}`
    };
    if (variant === "contained") return {
        border: `${(0, $2jkdX.rem)(1)} solid ${borderColor}`,
        transition: "background-color 150ms ease",
        "&[data-active]": {
            backgroundColor: filledColor
        },
        "&:first-of-type": {
            borderTopRightRadius: borderRadius,
            borderTopLeftRadius: borderRadius,
            "& > [data-accordion-control]": {
                borderTopRightRadius: borderRadius,
                borderTopLeftRadius: borderRadius
            }
        },
        "&:last-of-type": {
            borderBottomRightRadius: borderRadius,
            borderBottomLeftRadius: borderRadius,
            "& > [data-accordion-control]": {
                borderBottomRightRadius: borderRadius,
                borderBottomLeftRadius: borderRadius
            }
        },
        "& + &": {
            borderTop: 0
        }
    };
    if (variant === "filled") return {
        borderRadius: borderRadius,
        "&[data-active]": {
            backgroundColor: filledColor
        }
    };
    if (variant === "separated") return {
        borderRadius: borderRadius,
        backgroundColor: filledColor,
        border: `${(0, $2jkdX.rem)(1)} solid transparent`,
        transition: "background-color 150ms ease",
        "& + &": {
            marginTop: theme.spacing.md
        },
        "&[data-active]": {
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            borderColor: borderColor
        }
    };
    return {};
}
var $e8e20a5062f239ca$var$useStyles = (0, $cQG1Y.createStyles)((theme, params, { variant: variant })=>({
        item: $e8e20a5062f239ca$var$getVariantStyles(theme, variant, params)
    }));
var $e8e20a5062f239ca$export$2e2bcd8739ae039 = $e8e20a5062f239ca$var$useStyles;

});


parcelRegister("9m6qg", function(module, exports) {

$parcel$export(module.exports, "AccordionControl", () => $6cfb268990e05ce6$export$165fb10d16cf13d3);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $j7bHu = parcelRequire("j7bHu");

var $771VU = parcelRequire("771VU");

var $dVqc3 = parcelRequire("dVqc3");

var $6wqtx = parcelRequire("6wqtx");

var $5etRf = parcelRequire("5etRf");
var $6cfb268990e05ce6$var$__defProp = Object.defineProperty;
var $6cfb268990e05ce6$var$__defProps = Object.defineProperties;
var $6cfb268990e05ce6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6cfb268990e05ce6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6cfb268990e05ce6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6cfb268990e05ce6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6cfb268990e05ce6$var$__defNormalProp = (obj, key, value)=>key in obj ? $6cfb268990e05ce6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6cfb268990e05ce6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6cfb268990e05ce6$var$__hasOwnProp.call(b, prop)) $6cfb268990e05ce6$var$__defNormalProp(a, prop, b[prop]);
    if ($6cfb268990e05ce6$var$__getOwnPropSymbols) {
        for (var prop of $6cfb268990e05ce6$var$__getOwnPropSymbols(b))if ($6cfb268990e05ce6$var$__propIsEnum.call(b, prop)) $6cfb268990e05ce6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6cfb268990e05ce6$var$__spreadProps = (a, b)=>$6cfb268990e05ce6$var$__defProps(a, $6cfb268990e05ce6$var$__getOwnPropDescs(b));
var $6cfb268990e05ce6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6cfb268990e05ce6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6cfb268990e05ce6$var$__getOwnPropSymbols) {
        for (var prop of $6cfb268990e05ce6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6cfb268990e05ce6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $6cfb268990e05ce6$var$defaultProps = {};
const $6cfb268990e05ce6$export$165fb10d16cf13d3 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("AccordionControl", $6cfb268990e05ce6$var$defaultProps, props), { disabled: disabled, onKeyDown: onKeyDown, onClick: onClick, chevron: chevron, children: children, className: className, icon: icon } = _a, others = $6cfb268990e05ce6$var$__objRest(_a, [
        "disabled",
        "onKeyDown",
        "onClick",
        "chevron",
        "children",
        "className",
        "icon"
    ]);
    const ctx = (0, $771VU.useAccordionContext)();
    const { value: value } = (0, $dVqc3.useAccordionItemContext)();
    const { classes: classes, cx: cx } = (0, $6wqtx.default)({
        transitionDuration: ctx.transitionDuration,
        chevronPosition: ctx.chevronPosition,
        chevronSize: ctx.chevronSize,
        radius: ctx.radius
    }, {
        name: "Accordion",
        classNames: ctx.classNames,
        styles: ctx.styles,
        unstyled: ctx.unstyled,
        variant: ctx.variant
    });
    const isActive = ctx.isItemActive(value);
    const shouldWrapWithHeading = typeof ctx.order === "number";
    const Heading = `h${ctx.order}`;
    const content = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $6cfb268990e05ce6$var$__spreadProps($6cfb268990e05ce6$var$__spreadValues({}, others), {
        ref: ref,
        "data-accordion-control": true,
        disabled: disabled,
        className: cx(classes.control, className),
        onClick: (event)=>{
            onClick == null || onClick(event);
            ctx.onChange(value);
        },
        type: "button",
        "data-active": isActive || void 0,
        "aria-expanded": isActive,
        "aria-controls": ctx.getRegionId(value),
        id: ctx.getControlId(value),
        unstyled: ctx.unstyled,
        onKeyDown: (0, $j7bHu.createScopedKeydownHandler)({
            siblingSelector: "[data-accordion-control]",
            parentSelector: "[data-accordion]",
            activateOnFocus: false,
            loop: ctx.loop,
            orientation: "vertical",
            onKeyDown: onKeyDown
        })
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.chevron,
        "data-rotate": !ctx.disableChevronRotation && isActive || void 0
    }, chevron || ctx.chevron), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.label
    }, children), icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.icon
    }, icon));
    return shouldWrapWithHeading ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Heading, {
        className: classes.itemTitle
    }, content) : content;
});
$6cfb268990e05ce6$export$165fb10d16cf13d3.displayName = "@mantine/core/AccordionControl";

});
parcelRegister("j7bHu", function(module, exports) {

$parcel$export(module.exports, "createScopedKeydownHandler", () => $dea7bf3e81d18358$export$5b1acc7188190893);

var $77Fno = parcelRequire("77Fno");
function $dea7bf3e81d18358$var$getPreviousIndex(current, elements, loop) {
    for(let i = current - 1; i >= 0; i -= 1){
        if (!elements[i].disabled) return i;
    }
    if (loop) for(let i = elements.length - 1; i > -1; i -= 1){
        if (!elements[i].disabled) return i;
    }
    return current;
}
function $dea7bf3e81d18358$var$getNextIndex(current, elements, loop) {
    for(let i = current + 1; i < elements.length; i += 1){
        if (!elements[i].disabled) return i;
    }
    if (loop) for(let i = 0; i < elements.length; i += 1){
        if (!elements[i].disabled) return i;
    }
    return current;
}
function $dea7bf3e81d18358$var$onSameLevel(target, sibling, parentSelector) {
    return (0, $77Fno.findElementAncestor)(target, parentSelector) === (0, $77Fno.findElementAncestor)(sibling, parentSelector);
}
function $dea7bf3e81d18358$export$5b1acc7188190893({ parentSelector: parentSelector, siblingSelector: siblingSelector, onKeyDown: onKeyDown, loop: loop = true, activateOnFocus: activateOnFocus = false, dir: dir = "rtl", orientation: orientation }) {
    return (event)=>{
        var _a;
        onKeyDown == null || onKeyDown(event);
        const elements = Array.from(((_a = (0, $77Fno.findElementAncestor)(event.currentTarget, parentSelector)) == null ? void 0 : _a.querySelectorAll(siblingSelector)) || []).filter((node)=>$dea7bf3e81d18358$var$onSameLevel(event.currentTarget, node, parentSelector));
        const current = elements.findIndex((el)=>event.currentTarget === el);
        const _nextIndex = $dea7bf3e81d18358$var$getNextIndex(current, elements, loop);
        const _previousIndex = $dea7bf3e81d18358$var$getPreviousIndex(current, elements, loop);
        const nextIndex = dir === "rtl" ? _previousIndex : _nextIndex;
        const previousIndex = dir === "rtl" ? _nextIndex : _previousIndex;
        switch(event.key){
            case "ArrowRight":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[nextIndex].focus();
                    activateOnFocus && elements[nextIndex].click();
                }
                break;
            case "ArrowLeft":
                if (orientation === "horizontal") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[previousIndex].focus();
                    activateOnFocus && elements[previousIndex].click();
                }
                break;
            case "ArrowUp":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_previousIndex].focus();
                    activateOnFocus && elements[_previousIndex].click();
                }
                break;
            case "ArrowDown":
                if (orientation === "vertical") {
                    event.stopPropagation();
                    event.preventDefault();
                    elements[_nextIndex].focus();
                    activateOnFocus && elements[_nextIndex].click();
                }
                break;
            case "Home":
                event.stopPropagation();
                event.preventDefault();
                !elements[0].disabled && elements[0].focus();
                break;
            case "End":
                {
                    event.stopPropagation();
                    event.preventDefault();
                    const last = elements.length - 1;
                    !elements[last].disabled && elements[last].focus();
                    break;
                }
        }
    };
}

});
parcelRegister("77Fno", function(module, exports) {

$parcel$export(module.exports, "findElementAncestor", () => $52f9484dfed9b5d5$export$3d0f3f5781bcdc48);
function $52f9484dfed9b5d5$export$3d0f3f5781bcdc48(element, selector) {
    let _element = element;
    while((_element = _element.parentElement) && !_element.matches(selector));
    return _element;
}

});


parcelRegister("6wqtx", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bfa44af9a0b06e1$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $4bfa44af9a0b06e1$var$__defProp = Object.defineProperty;
var $4bfa44af9a0b06e1$var$__defProps = Object.defineProperties;
var $4bfa44af9a0b06e1$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4bfa44af9a0b06e1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4bfa44af9a0b06e1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4bfa44af9a0b06e1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4bfa44af9a0b06e1$var$__defNormalProp = (obj, key, value)=>key in obj ? $4bfa44af9a0b06e1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4bfa44af9a0b06e1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4bfa44af9a0b06e1$var$__hasOwnProp.call(b, prop)) $4bfa44af9a0b06e1$var$__defNormalProp(a, prop, b[prop]);
    if ($4bfa44af9a0b06e1$var$__getOwnPropSymbols) {
        for (var prop of $4bfa44af9a0b06e1$var$__getOwnPropSymbols(b))if ($4bfa44af9a0b06e1$var$__propIsEnum.call(b, prop)) $4bfa44af9a0b06e1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4bfa44af9a0b06e1$var$__spreadProps = (a, b)=>$4bfa44af9a0b06e1$var$__defProps(a, $4bfa44af9a0b06e1$var$__getOwnPropDescs(b));
function $4bfa44af9a0b06e1$var$getVariantStyles(theme, variant) {
    if (variant === "default" || variant === "contained") return theme.fn.hover({
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
    });
    return {};
}
var $4bfa44af9a0b06e1$var$useStyles = (0, $cQG1Y.createStyles)((theme, { transitionDuration: transitionDuration, chevronPosition: chevronPosition, chevronSize: chevronSize }, { variant: variant })=>({
        icon: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: chevronPosition === "left" ? 0 : theme.spacing.sm,
            marginLeft: chevronPosition === "left" ? theme.spacing.lg : 0
        },
        chevron: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: `transform ${transitionDuration}ms ease`,
            marginRight: chevronPosition === "right" ? 0 : theme.spacing.sm,
            marginLeft: chevronPosition === "right" ? theme.spacing.lg : 0,
            width: (0, $2jkdX.rem)(chevronSize),
            minWidth: (0, $2jkdX.rem)(chevronSize),
            "&[data-rotate]": {
                transform: "rotate(180deg)"
            }
        },
        label: {
            color: "inherit",
            fontWeight: 400,
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            paddingTop: theme.spacing.md,
            paddingBottom: theme.spacing.md
        },
        itemTitle: {
            margin: 0,
            padding: 0
        },
        control: $4bfa44af9a0b06e1$var$__spreadProps($4bfa44af9a0b06e1$var$__spreadValues($4bfa44af9a0b06e1$var$__spreadValues($4bfa44af9a0b06e1$var$__spreadValues({}, theme.fn.focusStyles()), theme.fn.fontStyles()), $4bfa44af9a0b06e1$var$getVariantStyles(theme, variant)), {
            width: "100%",
            display: "flex",
            alignItems: "center",
            flexDirection: chevronPosition === "right" ? "row-reverse" : "row",
            paddingRight: theme.spacing.md,
            paddingLeft: chevronPosition === "right" ? `calc(${theme.spacing.md} + ${(0, $2jkdX.rem)(4)})` : theme.spacing.xs,
            textAlign: "left",
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            "&:disabled": $4bfa44af9a0b06e1$var$__spreadValues({
                opacity: 0.4,
                cursor: "not-allowed"
            }, theme.fn.hover({
                backgroundColor: "transparent"
            }))
        })
    }));
var $4bfa44af9a0b06e1$export$2e2bcd8739ae039 = $4bfa44af9a0b06e1$var$useStyles;

});


parcelRegister("gXuzC", function(module, exports) {

$parcel$export(module.exports, "AccordionPanel", () => $c589df4b8824a259$export$7cad6f17fd6e117b);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $771VU = parcelRequire("771VU");

var $dVqc3 = parcelRequire("dVqc3");

var $VvdnK = parcelRequire("VvdnK");

var $kqKdq = parcelRequire("kqKdq");
var $c589df4b8824a259$var$__defProp = Object.defineProperty;
var $c589df4b8824a259$var$__defProps = Object.defineProperties;
var $c589df4b8824a259$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c589df4b8824a259$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c589df4b8824a259$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c589df4b8824a259$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c589df4b8824a259$var$__defNormalProp = (obj, key, value)=>key in obj ? $c589df4b8824a259$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c589df4b8824a259$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c589df4b8824a259$var$__hasOwnProp.call(b, prop)) $c589df4b8824a259$var$__defNormalProp(a, prop, b[prop]);
    if ($c589df4b8824a259$var$__getOwnPropSymbols) {
        for (var prop of $c589df4b8824a259$var$__getOwnPropSymbols(b))if ($c589df4b8824a259$var$__propIsEnum.call(b, prop)) $c589df4b8824a259$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c589df4b8824a259$var$__spreadProps = (a, b)=>$c589df4b8824a259$var$__defProps(a, $c589df4b8824a259$var$__getOwnPropDescs(b));
var $c589df4b8824a259$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c589df4b8824a259$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c589df4b8824a259$var$__getOwnPropSymbols) {
        for (var prop of $c589df4b8824a259$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c589df4b8824a259$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c589df4b8824a259$var$defaultProps = {};
function $c589df4b8824a259$export$7cad6f17fd6e117b(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("AccordionPanel", $c589df4b8824a259$var$defaultProps, props), { children: children, className: className } = _a, others = $c589df4b8824a259$var$__objRest(_a, [
        "children",
        "className"
    ]);
    const ctx = (0, $771VU.useAccordionContext)();
    const { value: value } = (0, $dVqc3.useAccordionItemContext)();
    const { classNames: classNames, styles: styles, unstyled: unstyled } = (0, $771VU.useAccordionContext)();
    const { classes: classes, cx: cx } = (0, $VvdnK.default)({
        radius: ctx.radius
    }, {
        name: "Accordion",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: ctx.variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kqKdq.Collapse), $c589df4b8824a259$var$__spreadProps($c589df4b8824a259$var$__spreadValues({}, others), {
        className: cx(classes.panel, className),
        in: ctx.isItemActive(value),
        transitionDuration: ctx.transitionDuration,
        role: "region",
        id: ctx.getRegionId(value),
        "aria-labelledby": ctx.getControlId(value)
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.content
    }, children));
}
$c589df4b8824a259$export$7cad6f17fd6e117b.displayName = "@mantine/core/AccordionPanel";

});
parcelRegister("VvdnK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0acd899a5a146b6b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $0acd899a5a146b6b$var$__defProp = Object.defineProperty;
var $0acd899a5a146b6b$var$__defProps = Object.defineProperties;
var $0acd899a5a146b6b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0acd899a5a146b6b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0acd899a5a146b6b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0acd899a5a146b6b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0acd899a5a146b6b$var$__defNormalProp = (obj, key, value)=>key in obj ? $0acd899a5a146b6b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0acd899a5a146b6b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0acd899a5a146b6b$var$__hasOwnProp.call(b, prop)) $0acd899a5a146b6b$var$__defNormalProp(a, prop, b[prop]);
    if ($0acd899a5a146b6b$var$__getOwnPropSymbols) {
        for (var prop of $0acd899a5a146b6b$var$__getOwnPropSymbols(b))if ($0acd899a5a146b6b$var$__propIsEnum.call(b, prop)) $0acd899a5a146b6b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0acd899a5a146b6b$var$__spreadProps = (a, b)=>$0acd899a5a146b6b$var$__defProps(a, $0acd899a5a146b6b$var$__getOwnPropDescs(b));
var $0acd899a5a146b6b$var$useStyles = (0, $cQG1Y.createStyles)((theme, _params)=>({
        panel: $0acd899a5a146b6b$var$__spreadProps($0acd899a5a146b6b$var$__spreadValues({}, theme.fn.fontStyles()), {
            wordBreak: "break-word",
            lineHeight: theme.lineHeight
        }),
        content: {
            padding: theme.spacing.md,
            paddingTop: `calc(${theme.spacing.xs} / 2)`
        }
    }));
var $0acd899a5a146b6b$export$2e2bcd8739ae039 = $0acd899a5a146b6b$var$useStyles;

});

parcelRegister("kqKdq", function(module, exports) {

$parcel$export(module.exports, "Collapse", () => $edfa15c69262331f$export$78768a9af065a7b);

var $acw62 = parcelRequire("acw62");

var $hG392 = parcelRequire("hG392");

var $64A2P = parcelRequire("64A2P");

var $8mTEH = parcelRequire("8mTEH");

var $aEkmw = parcelRequire("aEkmw");

var $hiiR1 = parcelRequire("hiiR1");
var $edfa15c69262331f$var$__defProp = Object.defineProperty;
var $edfa15c69262331f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $edfa15c69262331f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $edfa15c69262331f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $edfa15c69262331f$var$__defNormalProp = (obj, key, value)=>key in obj ? $edfa15c69262331f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $edfa15c69262331f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($edfa15c69262331f$var$__hasOwnProp.call(b, prop)) $edfa15c69262331f$var$__defNormalProp(a, prop, b[prop]);
    if ($edfa15c69262331f$var$__getOwnPropSymbols) {
        for (var prop of $edfa15c69262331f$var$__getOwnPropSymbols(b))if ($edfa15c69262331f$var$__propIsEnum.call(b, prop)) $edfa15c69262331f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $edfa15c69262331f$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($edfa15c69262331f$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $edfa15c69262331f$var$__getOwnPropSymbols) {
        for (var prop of $edfa15c69262331f$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $edfa15c69262331f$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $edfa15c69262331f$var$defaultProps = {
    transitionDuration: 200,
    transitionTimingFunction: "ease",
    animateOpacity: true
};
const $edfa15c69262331f$export$78768a9af065a7b = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Collapse", $edfa15c69262331f$var$defaultProps, props), { children: children, in: opened, transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction, style: style, onTransitionEnd: onTransitionEnd, animateOpacity: animateOpacity } = _a, others = $edfa15c69262331f$var$__objRest(_a, [
        "children",
        "in",
        "transitionDuration",
        "transitionTimingFunction",
        "style",
        "onTransitionEnd",
        "animateOpacity"
    ]);
    const theme = (0, $64A2P.useMantineTheme)();
    const shouldReduceMotion = (0, $hG392.useReducedMotion)();
    const reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
    const duration = reduceMotion ? 0 : transitionDuration;
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const getCollapseProps = (0, $8mTEH.useCollapse)({
        opened: opened,
        transitionDuration: duration,
        transitionTimingFunction: transitionTimingFunction,
        onTransitionEnd: onTransitionEnd
    });
    if (duration === 0) return opened ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $edfa15c69262331f$var$__spreadValues({}, rest), children) : null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $edfa15c69262331f$var$__spreadValues({}, getCollapseProps($edfa15c69262331f$var$__spreadValues($edfa15c69262331f$var$__spreadValues({
        style: style,
        ref: ref
    }, rest), systemStyles))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            opacity: opened || !animateOpacity ? 1 : 0,
            transition: animateOpacity ? `opacity ${duration}ms ${transitionTimingFunction}` : "none"
        }
    }, children));
});
$edfa15c69262331f$export$78768a9af065a7b.displayName = "@mantine/core/Collapse";

});
parcelRegister("8mTEH", function(module, exports) {

$parcel$export(module.exports, "useCollapse", () => $617b8cd1de66f28b$export$e8be2fc690e5dac2);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $4GmKa = parcelRequire("4GmKa");
var $2qf6h = parcelRequire("2qf6h");
var $617b8cd1de66f28b$var$__defProp = Object.defineProperty;
var $617b8cd1de66f28b$var$__defProps = Object.defineProperties;
var $617b8cd1de66f28b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $617b8cd1de66f28b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $617b8cd1de66f28b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $617b8cd1de66f28b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $617b8cd1de66f28b$var$__defNormalProp = (obj, key, value)=>key in obj ? $617b8cd1de66f28b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $617b8cd1de66f28b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($617b8cd1de66f28b$var$__hasOwnProp.call(b, prop)) $617b8cd1de66f28b$var$__defNormalProp(a, prop, b[prop]);
    if ($617b8cd1de66f28b$var$__getOwnPropSymbols) {
        for (var prop of $617b8cd1de66f28b$var$__getOwnPropSymbols(b))if ($617b8cd1de66f28b$var$__propIsEnum.call(b, prop)) $617b8cd1de66f28b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $617b8cd1de66f28b$var$__spreadProps = (a, b)=>$617b8cd1de66f28b$var$__defProps(a, $617b8cd1de66f28b$var$__getOwnPropDescs(b));
var $617b8cd1de66f28b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($617b8cd1de66f28b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $617b8cd1de66f28b$var$__getOwnPropSymbols) {
        for (var prop of $617b8cd1de66f28b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $617b8cd1de66f28b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $617b8cd1de66f28b$var$getAutoHeightDuration(height) {
    if (!height || typeof height === "string") return 0;
    const constant = height / 36;
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $617b8cd1de66f28b$export$8e0f1520ce23a388(el) {
    return (el == null ? void 0 : el.current) ? el.current.scrollHeight : "auto";
}
const $617b8cd1de66f28b$var$raf = typeof window !== "undefined" && window.requestAnimationFrame;
function $617b8cd1de66f28b$export$e8be2fc690e5dac2({ transitionDuration: transitionDuration, transitionTimingFunction: transitionTimingFunction = "ease", onTransitionEnd: onTransitionEnd = ()=>{}, opened: opened }) {
    const el = (0, $acw62.useRef)(null);
    const collapsedHeight = 0;
    const collapsedStyles = {
        display: "none",
        height: 0,
        overflow: "hidden"
    };
    const [styles, setStylesRaw] = (0, $acw62.useState)(opened ? {} : collapsedStyles);
    const setStyles = (newStyles)=>{
        (0, $1u0KT.flushSync)(()=>setStylesRaw(newStyles));
    };
    const mergeStyles = (newStyles)=>{
        setStyles((oldStyles)=>$617b8cd1de66f28b$var$__spreadValues($617b8cd1de66f28b$var$__spreadValues({}, oldStyles), newStyles));
    };
    function getTransitionStyles(height) {
        const _duration = transitionDuration || $617b8cd1de66f28b$var$getAutoHeightDuration(height);
        return {
            transition: `height ${_duration}ms ${transitionTimingFunction}`
        };
    }
    (0, $2qf6h.useDidUpdate)(()=>{
        if (opened) $617b8cd1de66f28b$var$raf(()=>{
            mergeStyles({
                willChange: "height",
                display: "block",
                overflow: "hidden"
            });
            $617b8cd1de66f28b$var$raf(()=>{
                const height = $617b8cd1de66f28b$export$8e0f1520ce23a388(el);
                mergeStyles($617b8cd1de66f28b$var$__spreadProps($617b8cd1de66f28b$var$__spreadValues({}, getTransitionStyles(height)), {
                    height: height
                }));
            });
        });
        else $617b8cd1de66f28b$var$raf(()=>{
            const height = $617b8cd1de66f28b$export$8e0f1520ce23a388(el);
            mergeStyles($617b8cd1de66f28b$var$__spreadProps($617b8cd1de66f28b$var$__spreadValues({}, getTransitionStyles(height)), {
                willChange: "height",
                height: height
            }));
            $617b8cd1de66f28b$var$raf(()=>mergeStyles({
                    height: collapsedHeight,
                    overflow: "hidden"
                }));
        });
    }, [
        opened
    ]);
    const handleTransitionEnd = (e)=>{
        if (e.target !== el.current || e.propertyName !== "height") return;
        if (opened) {
            const height = $617b8cd1de66f28b$export$8e0f1520ce23a388(el);
            if (height === styles.height) setStyles({});
            else mergeStyles({
                height: height
            });
            onTransitionEnd();
        } else if (styles.height === collapsedHeight) {
            setStyles(collapsedStyles);
            onTransitionEnd();
        }
    };
    function getCollapseProps(_a = {}) {
        var _b = _a, { style: style = {}, refKey: refKey = "ref" } = _b, rest = $617b8cd1de66f28b$var$__objRest(_b, [
            "style",
            "refKey"
        ]);
        const theirRef = rest[refKey];
        return $617b8cd1de66f28b$var$__spreadProps($617b8cd1de66f28b$var$__spreadValues({
            "aria-hidden": !opened
        }, rest), {
            [refKey]: (0, $4GmKa.mergeRefs)(el, theirRef),
            onTransitionEnd: handleTransitionEnd,
            style: $617b8cd1de66f28b$var$__spreadValues($617b8cd1de66f28b$var$__spreadValues({
                boxSizing: "border-box"
            }, style), styles)
        });
    }
    return getCollapseProps;
}

});



parcelRegister("1cBiA", function(module, exports) {

$parcel$export(module.exports, "ChevronIcon", () => $0e03d82f931e7d2c$export$ae15c545ca677b81);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $0e03d82f931e7d2c$var$__defProp = Object.defineProperty;
var $0e03d82f931e7d2c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0e03d82f931e7d2c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0e03d82f931e7d2c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0e03d82f931e7d2c$var$__defNormalProp = (obj, key, value)=>key in obj ? $0e03d82f931e7d2c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0e03d82f931e7d2c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0e03d82f931e7d2c$var$__hasOwnProp.call(b, prop)) $0e03d82f931e7d2c$var$__defNormalProp(a, prop, b[prop]);
    if ($0e03d82f931e7d2c$var$__getOwnPropSymbols) {
        for (var prop of $0e03d82f931e7d2c$var$__getOwnPropSymbols(b))if ($0e03d82f931e7d2c$var$__propIsEnum.call(b, prop)) $0e03d82f931e7d2c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0e03d82f931e7d2c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0e03d82f931e7d2c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0e03d82f931e7d2c$var$__getOwnPropSymbols) {
        for (var prop of $0e03d82f931e7d2c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0e03d82f931e7d2c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $0e03d82f931e7d2c$export$ae15c545ca677b81(props) {
    const _a = props, { style: style } = _a, others = $0e03d82f931e7d2c$var$__objRest(_a, [
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $0e03d82f931e7d2c$var$__spreadValues({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: $0e03d82f931e7d2c$var$__spreadValues({
            width: (0, $2jkdX.rem)(16),
            height: (0, $2jkdX.rem)(16)
        }, style)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}

});


parcelRegister("1St1x", function(module, exports) {

$parcel$export(module.exports, "Alert", () => $15e1591c80de73cb$export$caec2af78bcc877f);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $8nBd8 = parcelRequire("8nBd8");

var $2G5U8 = parcelRequire("2G5U8");

var $hiiR1 = parcelRequire("hiiR1");

var $lUJd1 = parcelRequire("lUJd1");
var $15e1591c80de73cb$var$__defProp = Object.defineProperty;
var $15e1591c80de73cb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $15e1591c80de73cb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $15e1591c80de73cb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $15e1591c80de73cb$var$__defNormalProp = (obj, key, value)=>key in obj ? $15e1591c80de73cb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $15e1591c80de73cb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($15e1591c80de73cb$var$__hasOwnProp.call(b, prop)) $15e1591c80de73cb$var$__defNormalProp(a, prop, b[prop]);
    if ($15e1591c80de73cb$var$__getOwnPropSymbols) {
        for (var prop of $15e1591c80de73cb$var$__getOwnPropSymbols(b))if ($15e1591c80de73cb$var$__propIsEnum.call(b, prop)) $15e1591c80de73cb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $15e1591c80de73cb$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($15e1591c80de73cb$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $15e1591c80de73cb$var$__getOwnPropSymbols) {
        for (var prop of $15e1591c80de73cb$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $15e1591c80de73cb$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $15e1591c80de73cb$var$defaultProps = {
    variant: "light"
};
const $15e1591c80de73cb$export$caec2af78bcc877f = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Alert", $15e1591c80de73cb$var$defaultProps, props), { id: id, className: className, title: title, variant: variant, children: children, color: color, classNames: classNames, icon: icon, styles: styles, onClose: onClose, radius: radius, withCloseButton: withCloseButton, closeButtonLabel: closeButtonLabel, unstyled: unstyled } = _a, others = $15e1591c80de73cb$var$__objRest(_a, [
        "id",
        "className",
        "title",
        "variant",
        "children",
        "color",
        "classNames",
        "icon",
        "styles",
        "onClose",
        "radius",
        "withCloseButton",
        "closeButtonLabel",
        "unstyled"
    ]);
    const { classes: classes, cx: cx } = (0, $2G5U8.default)({
        color: color,
        radius: radius
    }, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        name: "Alert"
    });
    const rootId = (0, $8nBd8.useId)(id);
    const titleId = title && `${rootId}-title`;
    const bodyId = `${rootId}-body`;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $15e1591c80de73cb$var$__spreadValues({
        id: rootId,
        role: "alert",
        "aria-labelledby": titleId,
        "aria-describedby": bodyId,
        className: cx(classes.root, classes[variant], className),
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.wrapper
    }, icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.icon
    }, icon), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.body
    }, title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.title,
        "data-with-close-button": withCloseButton || void 0
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: titleId,
        className: classes.label
    }, title)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: bodyId,
        className: classes.message
    }, children)), withCloseButton && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUJd1.CloseButton), {
        className: classes.closeButton,
        onClick: onClose,
        variant: "transparent",
        size: 16,
        iconSize: 16,
        "aria-label": closeButtonLabel
    })));
});
$15e1591c80de73cb$export$caec2af78bcc877f.displayName = "@mantine/core/Alert";

});
parcelRegister("2G5U8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f34158325815c08$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $1f34158325815c08$var$__defProp = Object.defineProperty;
var $1f34158325815c08$var$__defProps = Object.defineProperties;
var $1f34158325815c08$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1f34158325815c08$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1f34158325815c08$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1f34158325815c08$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1f34158325815c08$var$__defNormalProp = (obj, key, value)=>key in obj ? $1f34158325815c08$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1f34158325815c08$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1f34158325815c08$var$__hasOwnProp.call(b, prop)) $1f34158325815c08$var$__defNormalProp(a, prop, b[prop]);
    if ($1f34158325815c08$var$__getOwnPropSymbols) {
        for (var prop of $1f34158325815c08$var$__getOwnPropSymbols(b))if ($1f34158325815c08$var$__propIsEnum.call(b, prop)) $1f34158325815c08$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1f34158325815c08$var$__spreadProps = (a, b)=>$1f34158325815c08$var$__defProps(a, $1f34158325815c08$var$__getOwnPropDescs(b));
function $1f34158325815c08$var$getVariantStyles({ variant: variant, color: color, theme: theme }) {
    if (variant === "filled") {
        const colors = theme.fn.variant({
            variant: "filled",
            color: color
        });
        return {
            backgroundColor: colors.background,
            color: theme.white
        };
    }
    if (variant === "outline") {
        const colors = theme.fn.variant({
            variant: "outline",
            color: color
        });
        return {
            color: colors.color,
            borderColor: colors.border,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        };
    }
    if (variant === "light") {
        const colors = theme.fn.variant({
            variant: "light",
            color: color
        });
        return {
            backgroundColor: colors.background,
            color: colors.color
        };
    }
    return null;
}
var $1f34158325815c08$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, color: color }, { variant: variant })=>({
        root: $1f34158325815c08$var$__spreadValues($1f34158325815c08$var$__spreadProps($1f34158325815c08$var$__spreadValues({}, theme.fn.fontStyles()), {
            position: "relative",
            overflow: "hidden",
            paddingTop: theme.spacing.sm,
            paddingBottom: theme.spacing.sm,
            paddingLeft: theme.spacing.md,
            paddingRight: theme.spacing.sm,
            borderRadius: theme.fn.radius(radius),
            border: `${(0, $2jkdX.rem)(1)} solid transparent`
        }), $1f34158325815c08$var$getVariantStyles({
            variant: variant,
            color: color,
            theme: theme
        })),
        wrapper: {
            display: "flex"
        },
        body: {
            flex: 1
        },
        title: {
            boxSizing: "border-box",
            margin: 0,
            marginBottom: theme.spacing.xs,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            lineHeight: theme.lineHeight,
            fontSize: theme.fontSizes.sm,
            fontWeight: 700,
            "&[data-with-close-button]": {
                paddingRight: theme.spacing.md
            }
        },
        label: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        icon: {
            lineHeight: 1,
            width: (0, $2jkdX.rem)(20),
            height: (0, $2jkdX.rem)(20),
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginRight: theme.spacing.md,
            marginTop: 1
        },
        message: $1f34158325815c08$var$__spreadProps($1f34158325815c08$var$__spreadValues({}, theme.fn.fontStyles()), {
            lineHeight: theme.lineHeight,
            textOverflow: "ellipsis",
            overflow: "hidden",
            fontSize: theme.fontSizes.sm,
            color: variant === "filled" ? theme.white : theme.colorScheme === "dark" ? variant === "light" ? theme.white : theme.colors.dark[0] : theme.black
        }),
        closeButton: {
            width: (0, $2jkdX.rem)(10),
            height: (0, $2jkdX.rem)(10),
            color: variant === "filled" ? theme.white : theme.colorScheme === "dark" ? variant === "light" ? theme.white : theme.colors.dark[0] : theme.black
        }
    }));
var $1f34158325815c08$export$2e2bcd8739ae039 = $1f34158325815c08$var$useStyles;

});


parcelRegister("f2S2u", function(module, exports) {

$parcel$export(module.exports, "Anchor", () => $af40f5f72ad9216b$export$b688253958b8dfe7);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $cjohz = parcelRequire("cjohz");

var $9oTsK = parcelRequire("9oTsK");
var $af40f5f72ad9216b$var$__defProp = Object.defineProperty;
var $af40f5f72ad9216b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $af40f5f72ad9216b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $af40f5f72ad9216b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $af40f5f72ad9216b$var$__defNormalProp = (obj, key, value)=>key in obj ? $af40f5f72ad9216b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $af40f5f72ad9216b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($af40f5f72ad9216b$var$__hasOwnProp.call(b, prop)) $af40f5f72ad9216b$var$__defNormalProp(a, prop, b[prop]);
    if ($af40f5f72ad9216b$var$__getOwnPropSymbols) {
        for (var prop of $af40f5f72ad9216b$var$__getOwnPropSymbols(b))if ($af40f5f72ad9216b$var$__propIsEnum.call(b, prop)) $af40f5f72ad9216b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $af40f5f72ad9216b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($af40f5f72ad9216b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $af40f5f72ad9216b$var$__getOwnPropSymbols) {
        for (var prop of $af40f5f72ad9216b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $af40f5f72ad9216b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $af40f5f72ad9216b$var$defaultProps = {
    underline: true
};
const $af40f5f72ad9216b$export$a2f8f0d14145d612 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Anchor", $af40f5f72ad9216b$var$defaultProps, props), { component: component, className: className, unstyled: unstyled, variant: variant, size: size, color: color, underline: underline } = _a, others = $af40f5f72ad9216b$var$__objRest(_a, [
        "component",
        "className",
        "unstyled",
        "variant",
        "size",
        "color",
        "underline"
    ]);
    const { classes: classes, cx: cx } = (0, $9oTsK.default)({
        color: color,
        underline: underline
    }, {
        name: "Anchor",
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const buttonProps = component === "button" ? {
        type: "button"
    } : null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), $af40f5f72ad9216b$var$__spreadValues($af40f5f72ad9216b$var$__spreadValues({
        component: component || "a",
        ref: ref,
        className: cx(classes.root, className),
        size: size
    }, buttonProps), others));
});
$af40f5f72ad9216b$export$a2f8f0d14145d612.displayName = "@mantine/core/Anchor";
const $af40f5f72ad9216b$export$b688253958b8dfe7 = (0, $1euea.createPolymorphicComponent)($af40f5f72ad9216b$export$a2f8f0d14145d612);

});
parcelRegister("9oTsK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d8160adf675bb93$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $6d8160adf675bb93$var$__defProp = Object.defineProperty;
var $6d8160adf675bb93$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6d8160adf675bb93$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6d8160adf675bb93$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6d8160adf675bb93$var$__defNormalProp = (obj, key, value)=>key in obj ? $6d8160adf675bb93$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6d8160adf675bb93$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6d8160adf675bb93$var$__hasOwnProp.call(b, prop)) $6d8160adf675bb93$var$__defNormalProp(a, prop, b[prop]);
    if ($6d8160adf675bb93$var$__getOwnPropSymbols) {
        for (var prop of $6d8160adf675bb93$var$__getOwnPropSymbols(b))if ($6d8160adf675bb93$var$__propIsEnum.call(b, prop)) $6d8160adf675bb93$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $6d8160adf675bb93$var$getAnchorColor({ theme: theme, color: color }) {
    if (color === "dimmed") return theme.fn.dimmed();
    return theme.fn.themeColor(color || theme.primaryColor, theme.colorScheme === "dark" ? 4 : 7, false, true);
}
var $6d8160adf675bb93$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, underline: underline })=>({
        root: $6d8160adf675bb93$var$__spreadValues({
            backgroundColor: "transparent",
            cursor: "pointer",
            padding: 0,
            border: 0,
            color: $6d8160adf675bb93$var$getAnchorColor({
                theme: theme,
                color: color
            })
        }, theme.fn.hover({
            textDecoration: underline ? "underline" : "none"
        }))
    }));
var $6d8160adf675bb93$export$2e2bcd8739ae039 = $6d8160adf675bb93$var$useStyles;

});


parcelRegister("bFLPF", function(module, exports) {

$parcel$export(module.exports, "Autocomplete", () => $87f8a088871018fd$export$2f2b9559550c7bbc);

var $acw62 = parcelRequire("acw62");

var $2qf6h = parcelRequire("2qf6h");
var $4GmKa = parcelRequire("4GmKa");
var $ke4gU = parcelRequire("ke4gU");

var $iu1L3 = parcelRequire("iu1L3");

var $6Lcfd = parcelRequire("6Lcfd");

var $g41PE = parcelRequire("g41PE");

var $5dIV6 = parcelRequire("5dIV6");

var $cojj3 = parcelRequire("cojj3");

var $1egdU = parcelRequire("1egdU");

var $cAf07 = parcelRequire("cAf07");

var $hw4dK = parcelRequire("hw4dK");

var $hEdEV = parcelRequire("hEdEV");

var $gw63X = parcelRequire("gw63X");
var $87f8a088871018fd$var$__defProp = Object.defineProperty;
var $87f8a088871018fd$var$__defProps = Object.defineProperties;
var $87f8a088871018fd$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $87f8a088871018fd$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $87f8a088871018fd$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $87f8a088871018fd$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $87f8a088871018fd$var$__defNormalProp = (obj, key, value)=>key in obj ? $87f8a088871018fd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $87f8a088871018fd$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($87f8a088871018fd$var$__hasOwnProp.call(b, prop)) $87f8a088871018fd$var$__defNormalProp(a, prop, b[prop]);
    if ($87f8a088871018fd$var$__getOwnPropSymbols) {
        for (var prop of $87f8a088871018fd$var$__getOwnPropSymbols(b))if ($87f8a088871018fd$var$__propIsEnum.call(b, prop)) $87f8a088871018fd$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $87f8a088871018fd$var$__spreadProps = (a, b)=>$87f8a088871018fd$var$__defProps(a, $87f8a088871018fd$var$__getOwnPropDescs(b));
var $87f8a088871018fd$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($87f8a088871018fd$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $87f8a088871018fd$var$__getOwnPropSymbols) {
        for (var prop of $87f8a088871018fd$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $87f8a088871018fd$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $87f8a088871018fd$export$3f6f640afaf1ec43(value, item) {
    return item.value.toLowerCase().trim().includes(value.toLowerCase().trim());
}
const $87f8a088871018fd$var$defaultProps = {
    required: false,
    size: "sm",
    shadow: "sm",
    limit: 5,
    itemComponent: (0, $5dIV6.DefaultItem),
    transitionProps: {
        transition: "fade",
        duration: 0
    },
    initiallyOpened: false,
    filter: $87f8a088871018fd$export$3f6f640afaf1ec43,
    switchDirectionOnFlip: false,
    zIndex: (0, $iu1L3.getDefaultZIndex)("popover"),
    dropdownPosition: "flip",
    maxDropdownHeight: "auto",
    positionDependencies: []
};
const $87f8a088871018fd$export$2f2b9559550c7bbc = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $hEdEV.useInputProps)("Autocomplete", $87f8a088871018fd$var$defaultProps, props), { inputProps: inputProps, wrapperProps: wrapperProps, shadow: shadow, data: data, limit: limit, value: value, defaultValue: defaultValue, onChange: onChange, unstyled: unstyled, itemComponent: itemComponent, onItemSubmit: onItemSubmit, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onClick: onClick, transitionProps: transitionProps, initiallyOpened: initiallyOpened, classNames: classNames, styles: styles, filter: filter, nothingFound: nothingFound, onDropdownClose: onDropdownClose, onDropdownOpen: onDropdownOpen, withinPortal: withinPortal, switchDirectionOnFlip: switchDirectionOnFlip, zIndex: zIndex, dropdownPosition: dropdownPosition, maxDropdownHeight: maxDropdownHeight, dropdownComponent: dropdownComponent, positionDependencies: positionDependencies, readOnly: readOnly, hoverOnSearchChange: hoverOnSearchChange } = _a, others = $87f8a088871018fd$var$__objRest(_a, [
        "inputProps",
        "wrapperProps",
        "shadow",
        "data",
        "limit",
        "value",
        "defaultValue",
        "onChange",
        "unstyled",
        "itemComponent",
        "onItemSubmit",
        "onKeyDown",
        "onFocus",
        "onBlur",
        "onClick",
        "transitionProps",
        "initiallyOpened",
        "classNames",
        "styles",
        "filter",
        "nothingFound",
        "onDropdownClose",
        "onDropdownOpen",
        "withinPortal",
        "switchDirectionOnFlip",
        "zIndex",
        "dropdownPosition",
        "maxDropdownHeight",
        "dropdownComponent",
        "positionDependencies",
        "readOnly",
        "hoverOnSearchChange"
    ]);
    const { classes: classes } = (0, $hw4dK.default)(null, {
        classNames: classNames,
        styles: styles,
        name: "Autocomplete",
        unstyled: unstyled
    });
    const [dropdownOpened, _setDropdownOpened] = (0, $acw62.useState)(initiallyOpened);
    const [hovered, setHovered] = (0, $acw62.useState)(-1);
    const [direction, setDirection] = (0, $acw62.useState)("column");
    const inputRef = (0, $acw62.useRef)(null);
    const [IMEOpen, setIMEOpen] = (0, $acw62.useState)(false);
    const [_value, handleChange] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: "",
        onChange: onChange
    });
    const setDropdownOpened = (opened)=>{
        _setDropdownOpened(opened);
        const handler = opened ? onDropdownOpen : onDropdownClose;
        typeof handler === "function" && handler();
    };
    (0, $2qf6h.useDidUpdate)(()=>{
        if (hoverOnSearchChange && _value) setHovered(0);
        else setHovered(-1);
    }, [
        _value,
        hoverOnSearchChange
    ]);
    const handleItemClick = (item)=>{
        handleChange(item.value);
        typeof onItemSubmit === "function" && onItemSubmit(item);
        setDropdownOpened(false);
    };
    const formattedData = data.map((item)=>typeof item === "string" ? {
            value: item
        } : item);
    const filteredData = (0, $6Lcfd.groupOptions)({
        data: (0, $cAf07.filterData)({
            data: formattedData,
            value: _value,
            limit: limit,
            filter: filter
        })
    });
    const handleInputKeydown = (event)=>{
        if (IMEOpen) return;
        typeof onKeyDown === "function" && onKeyDown(event);
        const isColumn = direction === "column";
        const handleNext = ()=>{
            setHovered((current)=>current < filteredData.length - 1 ? current + 1 : current);
        };
        const handlePrevious = ()=>{
            setHovered((current)=>current > 0 ? current - 1 : current);
        };
        switch(event.key){
            case "ArrowUp":
                event.preventDefault();
                isColumn ? handlePrevious() : handleNext();
                break;
            case "ArrowDown":
                event.preventDefault();
                isColumn ? handleNext() : handlePrevious();
                break;
            case "Enter":
                if (filteredData[hovered] && dropdownOpened) {
                    event.preventDefault();
                    handleChange(filteredData[hovered].value);
                    typeof onItemSubmit === "function" && onItemSubmit(filteredData[hovered]);
                    setDropdownOpened(false);
                }
                break;
            case "Escape":
                if (dropdownOpened) {
                    event.preventDefault();
                    setDropdownOpened(false);
                }
        }
    };
    const handleInputFocus = (event)=>{
        typeof onFocus === "function" && onFocus(event);
        setDropdownOpened(true);
    };
    const handleInputBlur = (event)=>{
        typeof onBlur === "function" && onBlur(event);
        setDropdownOpened(false);
    };
    const handleInputClick = (event)=>{
        typeof onClick === "function" && onClick(event);
        setDropdownOpened(true);
    };
    const shouldRenderDropdown = dropdownOpened && (filteredData.length > 0 || filteredData.length === 0 && !!nothingFound);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $87f8a088871018fd$var$__spreadProps($87f8a088871018fd$var$__spreadValues({}, wrapperProps), {
        __staticSelector: "Autocomplete"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover), {
        opened: shouldRenderDropdown,
        transitionProps: transitionProps,
        shadow: "sm",
        withinPortal: withinPortal,
        __staticSelector: "Autocomplete",
        onDirectionChange: setDirection,
        switchDirectionOnFlip: switchDirectionOnFlip,
        zIndex: zIndex,
        dropdownPosition: dropdownPosition,
        positionDependencies: positionDependencies,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        readOnly: readOnly,
        variant: inputProps.variant
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover).Target, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.wrapper,
        "aria-controls": inputProps.id,
        onMouseLeave: ()=>setHovered(-1),
        tabIndex: -1
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), $87f8a088871018fd$var$__spreadProps($87f8a088871018fd$var$__spreadValues($87f8a088871018fd$var$__spreadValues({
        type: "search",
        autoComplete: "off"
    }, inputProps), others), {
        readOnly: readOnly,
        "data-mantine-stop-propagation": dropdownOpened,
        ref: (0, $4GmKa.useMergedRef)(ref, inputRef),
        onKeyDown: handleInputKeydown,
        classNames: classNames,
        styles: styles,
        __staticSelector: "Autocomplete",
        value: _value,
        onChange: (event)=>{
            handleChange(event.currentTarget.value);
            setDropdownOpened(true);
        },
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        onClick: handleInputClick,
        onCompositionStart: ()=>setIMEOpen(true),
        onCompositionEnd: ()=>setIMEOpen(false),
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-owns": shouldRenderDropdown ? `${inputProps.id}-items` : null,
        "aria-expanded": shouldRenderDropdown,
        "aria-autocomplete": "list",
        "aria-controls": shouldRenderDropdown ? `${inputProps.id}-items` : null,
        "aria-activedescendant": hovered >= 0 ? `${inputProps.id}-${hovered}` : null
    })))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover).Dropdown, {
        component: dropdownComponent || (0, $1egdU.SelectScrollArea),
        maxHeight: maxDropdownHeight,
        direction: direction,
        id: inputProps.id,
        __staticSelector: "Autocomplete",
        classNames: classNames,
        styles: styles
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g41PE.SelectItems), {
        data: filteredData,
        hovered: hovered,
        classNames: classNames,
        styles: styles,
        uuid: inputProps.id,
        __staticSelector: "Autocomplete",
        onItemHover: setHovered,
        onItemSelect: handleItemClick,
        itemComponent: itemComponent,
        size: inputProps.size,
        nothingFound: nothingFound,
        variant: inputProps.variant
    }))));
});
$87f8a088871018fd$export$2f2b9559550c7bbc.displayName = "@mantine/core/Autocomplete";

});
parcelRegister("g41PE", function(module, exports) {

$parcel$export(module.exports, "SelectItems", () => $bb1e70e4ef0e45c5$export$2f9dde4ea329d319);

var $acw62 = parcelRequire("acw62");

var $45cdq = parcelRequire("45cdq");

var $cjohz = parcelRequire("cjohz");

var $fnRsm = parcelRequire("fnRsm");

var $7IveH = parcelRequire("7IveH");
var $bb1e70e4ef0e45c5$var$__defProp = Object.defineProperty;
var $bb1e70e4ef0e45c5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $bb1e70e4ef0e45c5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bb1e70e4ef0e45c5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $bb1e70e4ef0e45c5$var$__defNormalProp = (obj, key, value)=>key in obj ? $bb1e70e4ef0e45c5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $bb1e70e4ef0e45c5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($bb1e70e4ef0e45c5$var$__hasOwnProp.call(b, prop)) $bb1e70e4ef0e45c5$var$__defNormalProp(a, prop, b[prop]);
    if ($bb1e70e4ef0e45c5$var$__getOwnPropSymbols) {
        for (var prop of $bb1e70e4ef0e45c5$var$__getOwnPropSymbols(b))if ($bb1e70e4ef0e45c5$var$__propIsEnum.call(b, prop)) $bb1e70e4ef0e45c5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $bb1e70e4ef0e45c5$export$2f9dde4ea329d319({ data: data, hovered: hovered, classNames: classNames, styles: styles, isItemSelected: isItemSelected, uuid: uuid, __staticSelector: __staticSelector, onItemHover: onItemHover, onItemSelect: onItemSelect, itemsRefs: itemsRefs, itemComponent: Item, size: size, nothingFound: nothingFound, creatable: creatable, createLabel: createLabel, unstyled: unstyled, variant: variant }) {
    const { classes: classes } = (0, $7IveH.default)(null, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        name: __staticSelector,
        variant: variant,
        size: size
    });
    const unGroupedItems = [];
    const groupedItems = [];
    let creatableDataIndex = null;
    const constructItemComponent = (item, index)=>{
        const selected = typeof isItemSelected === "function" ? isItemSelected(item.value) : false;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Item, $bb1e70e4ef0e45c5$var$__spreadValues({
            key: item.value,
            className: classes.item,
            "data-disabled": item.disabled || void 0,
            "data-hovered": !item.disabled && hovered === index || void 0,
            "data-selected": !item.disabled && selected || void 0,
            selected: selected,
            onMouseEnter: ()=>onItemHover(index),
            id: `${uuid}-${index}`,
            role: "option",
            tabIndex: -1,
            "aria-selected": hovered === index,
            ref: (node)=>{
                if (itemsRefs && itemsRefs.current) itemsRefs.current[item.value] = node;
            },
            onMouseDown: !item.disabled ? (event)=>{
                event.preventDefault();
                onItemSelect(item);
            } : null,
            disabled: item.disabled,
            variant: variant
        }, item));
    };
    let groupName = null;
    data.forEach((item, index)=>{
        if (item.creatable) creatableDataIndex = index;
        else if (!item.group) unGroupedItems.push(constructItemComponent(item, index));
        else {
            if (groupName !== item.group) {
                groupName = item.group;
                groupedItems.push(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: classes.separator,
                    key: `__mantine-divider-${index}`
                }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fnRsm.Divider), {
                    classNames: {
                        label: classes.separatorLabel
                    },
                    label: item.group
                })));
            }
            groupedItems.push(constructItemComponent(item, index));
        }
    });
    if (creatable) {
        const creatableDataItem = data[creatableDataIndex];
        unGroupedItems.push(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: (0, $45cdq.randomId)(),
            className: classes.item,
            "data-hovered": hovered === creatableDataIndex || void 0,
            onMouseEnter: ()=>onItemHover(creatableDataIndex),
            onMouseDown: (event)=>{
                event.preventDefault();
                onItemSelect(creatableDataItem);
            },
            tabIndex: -1,
            ref: (node)=>{
                if (itemsRefs && itemsRefs.current) itemsRefs.current[creatableDataItem.value] = node;
            }
        }, createLabel));
    }
    if (groupedItems.length > 0 && unGroupedItems.length > 0) unGroupedItems.unshift(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.separator,
        key: "empty-group-separator"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fnRsm.Divider), null)));
    return groupedItems.length > 0 || unGroupedItems.length > 0 ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, groupedItems, unGroupedItems) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        size: size,
        unstyled: unstyled,
        className: classes.nothingFound
    }, nothingFound);
}
$bb1e70e4ef0e45c5$export$2f9dde4ea329d319.displayName = "@mantine/core/SelectItems";

});
parcelRegister("fnRsm", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $b3327851e6820fe2$export$2e0a83ec2e27ecbb);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $ayqVu = parcelRequire("ayqVu");

var $hiiR1 = parcelRequire("hiiR1");

var $cjohz = parcelRequire("cjohz");
var $b3327851e6820fe2$var$__defProp = Object.defineProperty;
var $b3327851e6820fe2$var$__defProps = Object.defineProperties;
var $b3327851e6820fe2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b3327851e6820fe2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b3327851e6820fe2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b3327851e6820fe2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b3327851e6820fe2$var$__defNormalProp = (obj, key, value)=>key in obj ? $b3327851e6820fe2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b3327851e6820fe2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b3327851e6820fe2$var$__hasOwnProp.call(b, prop)) $b3327851e6820fe2$var$__defNormalProp(a, prop, b[prop]);
    if ($b3327851e6820fe2$var$__getOwnPropSymbols) {
        for (var prop of $b3327851e6820fe2$var$__getOwnPropSymbols(b))if ($b3327851e6820fe2$var$__propIsEnum.call(b, prop)) $b3327851e6820fe2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b3327851e6820fe2$var$__spreadProps = (a, b)=>$b3327851e6820fe2$var$__defProps(a, $b3327851e6820fe2$var$__getOwnPropDescs(b));
var $b3327851e6820fe2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b3327851e6820fe2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b3327851e6820fe2$var$__getOwnPropSymbols) {
        for (var prop of $b3327851e6820fe2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b3327851e6820fe2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b3327851e6820fe2$var$defaultProps = {
    orientation: "horizontal",
    size: "xs",
    labelPosition: "left",
    variant: "solid"
};
const $b3327851e6820fe2$export$2e0a83ec2e27ecbb = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Divider", $b3327851e6820fe2$var$defaultProps, props), { className: className, color: color, orientation: orientation, size: size, label: label, labelPosition: labelPosition, labelProps: labelProps, variant: variant, styles: styles, classNames: classNames, unstyled: unstyled } = _a, others = $b3327851e6820fe2$var$__objRest(_a, [
        "className",
        "color",
        "orientation",
        "size",
        "label",
        "labelPosition",
        "labelProps",
        "variant",
        "styles",
        "classNames",
        "unstyled"
    ]);
    const { classes: classes, cx: cx } = (0, $ayqVu.default)({
        color: color
    }, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        name: "Divider",
        variant: variant,
        size: size
    });
    const vertical = orientation === "vertical";
    const horizontal = orientation === "horizontal";
    const withLabel = !!label && horizontal;
    const useLabelDefaultStyles = !(labelProps == null ? void 0 : labelProps.color);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $b3327851e6820fe2$var$__spreadValues({
        ref: ref,
        className: cx(classes.root, {
            [classes.vertical]: vertical,
            [classes.horizontal]: horizontal,
            [classes.withLabel]: withLabel
        }, className),
        role: "separator"
    }, others), withLabel && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), $b3327851e6820fe2$var$__spreadProps($b3327851e6820fe2$var$__spreadValues({}, labelProps), {
        size: (labelProps == null ? void 0 : labelProps.size) || "xs",
        mt: (0, $2jkdX.rem)(2),
        className: cx(classes.label, classes[labelPosition], {
            [classes.labelDefaultStyles]: useLabelDefaultStyles
        })
    }), label));
});
$b3327851e6820fe2$export$2e0a83ec2e27ecbb.displayName = "@mantine/core/Divider";

});
parcelRegister("ayqVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7af1f759c77b3c76$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
const $7af1f759c77b3c76$var$sizes = {
    xs: (0, $2jkdX.rem)(1),
    sm: (0, $2jkdX.rem)(2),
    md: (0, $2jkdX.rem)(3),
    lg: (0, $2jkdX.rem)(4),
    xl: (0, $2jkdX.rem)(5)
};
function $7af1f759c77b3c76$var$getColor(theme, color) {
    const themeColor = theme.fn.variant({
        variant: "outline",
        color: color
    }).border;
    return typeof color === "string" && (color in theme.colors || color.split(".")[0] in theme.colors) ? themeColor : color === void 0 ? theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4] : color;
}
var $7af1f759c77b3c76$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color }, { size: size, variant: variant })=>({
        root: {},
        withLabel: {
            borderTop: "0 !important"
        },
        left: {
            "&::before": {
                display: "none"
            }
        },
        right: {
            "&::after": {
                display: "none"
            }
        },
        label: {
            display: "flex",
            alignItems: "center",
            "&::before": {
                content: '""',
                flex: 1,
                height: (0, $2jkdX.rem)(1),
                borderTop: `${(0, $d8Ix8.getSize)({
                    size: size,
                    sizes: $7af1f759c77b3c76$var$sizes
                })} ${variant} ${$7af1f759c77b3c76$var$getColor(theme, color)}`,
                marginRight: theme.spacing.xs
            },
            "&::after": {
                content: '""',
                flex: 1,
                borderTop: `${(0, $d8Ix8.getSize)({
                    size: size,
                    sizes: $7af1f759c77b3c76$var$sizes
                })} ${variant} ${$7af1f759c77b3c76$var$getColor(theme, color)}`,
                marginLeft: theme.spacing.xs
            }
        },
        labelDefaultStyles: {
            color: color === "dark" ? theme.colors.dark[1] : theme.fn.themeColor(color, theme.colorScheme === "dark" ? 5 : theme.fn.primaryShade(), false)
        },
        horizontal: {
            border: 0,
            borderTopWidth: (0, $2jkdX.rem)((0, $d8Ix8.getSize)({
                size: size,
                sizes: $7af1f759c77b3c76$var$sizes
            })),
            borderTopColor: $7af1f759c77b3c76$var$getColor(theme, color),
            borderTopStyle: variant,
            margin: 0
        },
        vertical: {
            border: 0,
            alignSelf: "stretch",
            height: "auto",
            borderLeftWidth: (0, $2jkdX.rem)((0, $d8Ix8.getSize)({
                size: size,
                sizes: $7af1f759c77b3c76$var$sizes
            })),
            borderLeftColor: $7af1f759c77b3c76$var$getColor(theme, color),
            borderLeftStyle: variant
        }
    }));
var $7af1f759c77b3c76$export$2e2bcd8739ae039 = $7af1f759c77b3c76$var$useStyles;

});


parcelRegister("7IveH", function(module, exports) {

$parcel$export(module.exports, "default", () => $59e4df50474d0dbf$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $59e4df50474d0dbf$var$__defProp = Object.defineProperty;
var $59e4df50474d0dbf$var$__defProps = Object.defineProperties;
var $59e4df50474d0dbf$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $59e4df50474d0dbf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $59e4df50474d0dbf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $59e4df50474d0dbf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $59e4df50474d0dbf$var$__defNormalProp = (obj, key, value)=>key in obj ? $59e4df50474d0dbf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $59e4df50474d0dbf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($59e4df50474d0dbf$var$__hasOwnProp.call(b, prop)) $59e4df50474d0dbf$var$__defNormalProp(a, prop, b[prop]);
    if ($59e4df50474d0dbf$var$__getOwnPropSymbols) {
        for (var prop of $59e4df50474d0dbf$var$__getOwnPropSymbols(b))if ($59e4df50474d0dbf$var$__propIsEnum.call(b, prop)) $59e4df50474d0dbf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $59e4df50474d0dbf$var$__spreadProps = (a, b)=>$59e4df50474d0dbf$var$__defProps(a, $59e4df50474d0dbf$var$__getOwnPropDescs(b));
var $59e4df50474d0dbf$var$useStyles = (0, $cQG1Y.createStyles)((theme, _params, { size: size })=>({
        item: $59e4df50474d0dbf$var$__spreadProps($59e4df50474d0dbf$var$__spreadValues({}, theme.fn.fontStyles()), {
            boxSizing: "border-box",
            wordBreak: "break-all",
            textAlign: "left",
            width: "100%",
            padding: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 1.5) ${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })}`,
            cursor: "pointer",
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            borderRadius: theme.fn.radius(),
            "&[data-hovered]": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[1]
            },
            "&[data-selected]": $59e4df50474d0dbf$var$__spreadValues({
                backgroundColor: theme.fn.variant({
                    variant: "filled"
                }).background,
                color: theme.fn.variant({
                    variant: "filled"
                }).color
            }, theme.fn.hover({
                backgroundColor: theme.fn.variant({
                    variant: "filled"
                }).hover
            })),
            "&[data-disabled]": {
                cursor: "default",
                color: theme.colors.dark[2]
            }
        }),
        nothingFound: {
            boxSizing: "border-box",
            color: theme.colors.gray[6],
            paddingTop: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 2)`,
            paddingBottom: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 2)`,
            textAlign: "center"
        },
        separator: {
            boxSizing: "border-box",
            textAlign: "left",
            width: "100%",
            padding: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 1.5) ${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })}`
        },
        separatorLabel: {
            color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
        }
    }));
var $59e4df50474d0dbf$export$2e2bcd8739ae039 = $59e4df50474d0dbf$var$useStyles;

});


parcelRegister("5dIV6", function(module, exports) {

$parcel$export(module.exports, "DefaultItem", () => $3cd102d9bdf4998a$export$ef8cfb0390832b6a);

var $acw62 = parcelRequire("acw62");
var $3cd102d9bdf4998a$var$__defProp = Object.defineProperty;
var $3cd102d9bdf4998a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3cd102d9bdf4998a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3cd102d9bdf4998a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3cd102d9bdf4998a$var$__defNormalProp = (obj, key, value)=>key in obj ? $3cd102d9bdf4998a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3cd102d9bdf4998a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3cd102d9bdf4998a$var$__hasOwnProp.call(b, prop)) $3cd102d9bdf4998a$var$__defNormalProp(a, prop, b[prop]);
    if ($3cd102d9bdf4998a$var$__getOwnPropSymbols) {
        for (var prop of $3cd102d9bdf4998a$var$__getOwnPropSymbols(b))if ($3cd102d9bdf4998a$var$__propIsEnum.call(b, prop)) $3cd102d9bdf4998a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3cd102d9bdf4998a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3cd102d9bdf4998a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3cd102d9bdf4998a$var$__getOwnPropSymbols) {
        for (var prop of $3cd102d9bdf4998a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3cd102d9bdf4998a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3cd102d9bdf4998a$export$ef8cfb0390832b6a = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { label: label, value: value } = _b, others = $3cd102d9bdf4998a$var$__objRest(_b, [
        "label",
        "value"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $3cd102d9bdf4998a$var$__spreadValues({
        ref: ref
    }, others), label || value);
});
$3cd102d9bdf4998a$export$ef8cfb0390832b6a.displayName = "@mantine/core/DefaultItem";

});

parcelRegister("cojj3", function(module, exports) {

$parcel$export(module.exports, "SelectPopover", () => $9056b3bd860751ee$export$c27282bbfd113869);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");

var $1egdU = parcelRequire("1egdU");

var $2Ke05 = parcelRequire("2Ke05");

var $6gwXS = parcelRequire("6gwXS");

var $hiiR1 = parcelRequire("hiiR1");
var $9056b3bd860751ee$var$__defProp = Object.defineProperty;
var $9056b3bd860751ee$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $9056b3bd860751ee$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $9056b3bd860751ee$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $9056b3bd860751ee$var$__defNormalProp = (obj, key, value)=>key in obj ? $9056b3bd860751ee$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9056b3bd860751ee$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($9056b3bd860751ee$var$__hasOwnProp.call(b, prop)) $9056b3bd860751ee$var$__defNormalProp(a, prop, b[prop]);
    if ($9056b3bd860751ee$var$__getOwnPropSymbols) {
        for (var prop of $9056b3bd860751ee$var$__getOwnPropSymbols(b))if ($9056b3bd860751ee$var$__propIsEnum.call(b, prop)) $9056b3bd860751ee$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $9056b3bd860751ee$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($9056b3bd860751ee$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $9056b3bd860751ee$var$__getOwnPropSymbols) {
        for (var prop of $9056b3bd860751ee$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $9056b3bd860751ee$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $9056b3bd860751ee$var$SelectPopoverDropdown(_a) {
    var _b = _a, { children: children, component: component = "div", maxHeight: maxHeight = 220, direction: direction = "column", id: id, innerRef: innerRef, __staticSelector: __staticSelector, styles: styles, classNames: classNames, unstyled: unstyled } = _b, others = $9056b3bd860751ee$var$__objRest(_b, [
        "children",
        "component",
        "maxHeight",
        "direction",
        "id",
        "innerRef",
        "__staticSelector",
        "styles",
        "classNames",
        "unstyled"
    ]);
    const { classes: classes } = (0, $2Ke05.default)(null, {
        name: __staticSelector,
        styles: styles,
        classNames: classNames,
        unstyled: unstyled
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6gwXS.Popover).Dropdown, $9056b3bd860751ee$var$__spreadValues({
        p: 0,
        onMouseDown: (event)=>event.preventDefault()
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            maxHeight: (0, $2jkdX.rem)(maxHeight),
            display: "flex"
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), {
        component: component || "div",
        id: `${id}-items`,
        "aria-labelledby": `${id}-label`,
        role: "listbox",
        onMouseDown: (event)=>event.preventDefault(),
        style: {
            flex: 1,
            overflowY: component !== (0, $1egdU.SelectScrollArea) ? "auto" : void 0
        },
        "data-combobox-popover": true,
        tabIndex: -1,
        ref: innerRef
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.itemsWrapper,
        style: {
            flexDirection: direction
        }
    }, children))));
}
function $9056b3bd860751ee$export$c27282bbfd113869({ opened: opened, transitionProps: transitionProps = {
    transition: "fade",
    duration: 0
}, shadow: shadow, withinPortal: withinPortal, portalProps: portalProps, children: children, __staticSelector: __staticSelector, onDirectionChange: onDirectionChange, switchDirectionOnFlip: switchDirectionOnFlip, zIndex: zIndex, dropdownPosition: dropdownPosition, positionDependencies: positionDependencies = [], classNames: classNames, styles: styles, unstyled: unstyled, readOnly: readOnly, variant: variant }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6gwXS.Popover), {
        unstyled: unstyled,
        classNames: classNames,
        styles: styles,
        width: "target",
        withRoles: false,
        opened: opened,
        middlewares: {
            flip: dropdownPosition === "flip",
            shift: false
        },
        position: dropdownPosition === "flip" ? "bottom" : dropdownPosition,
        positionDependencies: positionDependencies,
        zIndex: zIndex,
        __staticSelector: __staticSelector,
        withinPortal: withinPortal,
        portalProps: portalProps,
        transitionProps: transitionProps,
        shadow: shadow,
        disabled: readOnly,
        onPositionChange: (nextPosition)=>switchDirectionOnFlip && (onDirectionChange == null ? void 0 : onDirectionChange(nextPosition === "top" ? "column-reverse" : "column")),
        variant: variant
    }, children);
}
$9056b3bd860751ee$export$c27282bbfd113869.Target = (0, $6gwXS.Popover).Target;
$9056b3bd860751ee$export$c27282bbfd113869.Dropdown = $9056b3bd860751ee$var$SelectPopoverDropdown;

});
parcelRegister("1egdU", function(module, exports) {

$parcel$export(module.exports, "SelectScrollArea", () => $0e53aed8f127d816$export$77beea37c2e156f4);

var $acw62 = parcelRequire("acw62");

var $5Eq0L = parcelRequire("5Eq0L");
var $0e53aed8f127d816$var$__defProp = Object.defineProperty;
var $0e53aed8f127d816$var$__defProps = Object.defineProperties;
var $0e53aed8f127d816$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0e53aed8f127d816$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0e53aed8f127d816$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0e53aed8f127d816$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0e53aed8f127d816$var$__defNormalProp = (obj, key, value)=>key in obj ? $0e53aed8f127d816$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0e53aed8f127d816$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0e53aed8f127d816$var$__hasOwnProp.call(b, prop)) $0e53aed8f127d816$var$__defNormalProp(a, prop, b[prop]);
    if ($0e53aed8f127d816$var$__getOwnPropSymbols) {
        for (var prop of $0e53aed8f127d816$var$__getOwnPropSymbols(b))if ($0e53aed8f127d816$var$__propIsEnum.call(b, prop)) $0e53aed8f127d816$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0e53aed8f127d816$var$__spreadProps = (a, b)=>$0e53aed8f127d816$var$__defProps(a, $0e53aed8f127d816$var$__getOwnPropDescs(b));
var $0e53aed8f127d816$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0e53aed8f127d816$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0e53aed8f127d816$var$__getOwnPropSymbols) {
        for (var prop of $0e53aed8f127d816$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0e53aed8f127d816$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $0e53aed8f127d816$export$77beea37c2e156f4 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { style: style } = _b, others = $0e53aed8f127d816$var$__objRest(_b, [
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5Eq0L.ScrollArea), $0e53aed8f127d816$var$__spreadProps($0e53aed8f127d816$var$__spreadValues({}, others), {
        style: $0e53aed8f127d816$var$__spreadValues({
            width: "100%"
        }, style),
        viewportProps: {
            tabIndex: -1
        },
        viewportRef: ref
    }), others.children);
});
$0e53aed8f127d816$export$77beea37c2e156f4.displayName = "@mantine/core/SelectScrollArea";

});

parcelRegister("2Ke05", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ffabcd8f43206f9$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $1ffabcd8f43206f9$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        dropdown: {},
        itemsWrapper: {
            padding: (0, $2jkdX.rem)(4),
            display: "flex",
            width: "100%",
            boxSizing: "border-box"
        }
    }));
var $1ffabcd8f43206f9$export$2e2bcd8739ae039 = $1ffabcd8f43206f9$var$useStyles;

});

parcelRegister("6gwXS", function(module, exports) {

$parcel$export(module.exports, "Popover", () => $48fdced15cb169ce$export$5b6b19405a83ff9d);

var $acw62 = parcelRequire("acw62");

var $ez0uD = parcelRequire("ez0uD");
var $8nBd8 = parcelRequire("8nBd8");

var $iu1L3 = parcelRequire("iu1L3");
var $64A2P = parcelRequire("64A2P");

var $bD9Sm = parcelRequire("bD9Sm");

var $1BKGV = parcelRequire("1BKGV");

var $7wIYL = parcelRequire("7wIYL");

var $jAS2v = parcelRequire("jAS2v");

var $hxIdR = parcelRequire("hxIdR");
var $48fdced15cb169ce$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $48fdced15cb169ce$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $48fdced15cb169ce$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $48fdced15cb169ce$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($48fdced15cb169ce$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $48fdced15cb169ce$var$__getOwnPropSymbols) {
        for (var prop of $48fdced15cb169ce$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $48fdced15cb169ce$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $48fdced15cb169ce$var$defaultProps = {
    position: "bottom",
    offset: 8,
    positionDependencies: [],
    transitionProps: {
        transition: "fade",
        duration: 150
    },
    middlewares: {
        flip: true,
        shift: true,
        inline: false
    },
    arrowSize: 7,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: "side",
    closeOnClickOutside: true,
    withinPortal: false,
    closeOnEscape: true,
    trapFocus: false,
    withRoles: true,
    returnFocus: false,
    clickOutsideEvents: [
        "mousedown",
        "touchstart"
    ],
    zIndex: (0, $iu1L3.getDefaultZIndex)("popover"),
    __staticSelector: "Popover",
    width: "max-content"
};
function $48fdced15cb169ce$export$5b6b19405a83ff9d(props) {
    var _b, _c, _d, _e, _f, _g;
    const arrowRef = (0, $acw62.useRef)(null);
    const _a = (0, $64A2P.useComponentDefaultProps)("Popover", $48fdced15cb169ce$var$defaultProps, props), { children: children, position: position, offset: offset, onPositionChange: onPositionChange, positionDependencies: positionDependencies, opened: opened, transitionProps: transitionProps, width: width, middlewares: middlewares, withArrow: withArrow, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, unstyled: unstyled, classNames: classNames, styles: styles, closeOnClickOutside: closeOnClickOutside, withinPortal: withinPortal, portalProps: portalProps, closeOnEscape: closeOnEscape, clickOutsideEvents: clickOutsideEvents, trapFocus: trapFocus, onClose: onClose, onOpen: onOpen, onChange: onChange, zIndex: zIndex, radius: radius, shadow: shadow, id: id, defaultOpened: defaultOpened, __staticSelector: __staticSelector, withRoles: withRoles, disabled: disabled, returnFocus: returnFocus, variant: variant, keepMounted: keepMounted } = _a, others = $48fdced15cb169ce$var$__objRest(_a, [
        "children",
        "position",
        "offset",
        "onPositionChange",
        "positionDependencies",
        "opened",
        "transitionProps",
        "width",
        "middlewares",
        "withArrow",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "unstyled",
        "classNames",
        "styles",
        "closeOnClickOutside",
        "withinPortal",
        "portalProps",
        "closeOnEscape",
        "clickOutsideEvents",
        "trapFocus",
        "onClose",
        "onOpen",
        "onChange",
        "zIndex",
        "radius",
        "shadow",
        "id",
        "defaultOpened",
        "__staticSelector",
        "withRoles",
        "disabled",
        "returnFocus",
        "variant",
        "keepMounted"
    ]);
    const [targetNode, setTargetNode] = (0, $acw62.useState)(null);
    const [dropdownNode, setDropdownNode] = (0, $acw62.useState)(null);
    const uid = (0, $8nBd8.useId)(id);
    const theme = (0, $64A2P.useMantineTheme)();
    const popover = (0, $bD9Sm.usePopover)({
        middlewares: middlewares,
        width: width,
        position: (0, $hxIdR.getFloatingPosition)(theme.dir, position),
        offset: typeof offset === "number" ? offset + (withArrow ? arrowSize / 2 : 0) : offset,
        arrowRef: arrowRef,
        arrowOffset: arrowOffset,
        onPositionChange: onPositionChange,
        positionDependencies: positionDependencies,
        opened: opened,
        defaultOpened: defaultOpened,
        onChange: onChange,
        onOpen: onOpen,
        onClose: onClose
    });
    (0, $ez0uD.useClickOutside)(()=>popover.opened && closeOnClickOutside && popover.onClose(), clickOutsideEvents, [
        targetNode,
        dropdownNode
    ]);
    const reference = (0, $acw62.useCallback)((node)=>{
        setTargetNode(node);
        popover.floating.reference(node);
    }, [
        popover.floating.reference
    ]);
    const floating = (0, $acw62.useCallback)((node)=>{
        setDropdownNode(node);
        popover.floating.floating(node);
    }, [
        popover.floating.floating
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1BKGV.PopoverContextProvider), {
        value: {
            returnFocus: returnFocus,
            disabled: disabled,
            controlled: popover.controlled,
            reference: reference,
            floating: floating,
            x: popover.floating.x,
            y: popover.floating.y,
            arrowX: (_d = (_c = (_b = popover.floating) == null ? void 0 : _b.middlewareData) == null ? void 0 : _c.arrow) == null ? void 0 : _d.x,
            arrowY: (_g = (_f = (_e = popover.floating) == null ? void 0 : _e.middlewareData) == null ? void 0 : _f.arrow) == null ? void 0 : _g.y,
            opened: popover.opened,
            arrowRef: arrowRef,
            transitionProps: transitionProps,
            width: width,
            withArrow: withArrow,
            arrowSize: arrowSize,
            arrowOffset: arrowOffset,
            arrowRadius: arrowRadius,
            arrowPosition: arrowPosition,
            placement: popover.floating.placement,
            trapFocus: trapFocus,
            withinPortal: withinPortal,
            portalProps: portalProps,
            zIndex: zIndex,
            radius: radius,
            shadow: shadow,
            closeOnEscape: closeOnEscape,
            onClose: popover.onClose,
            onToggle: popover.onToggle,
            getTargetId: ()=>`${uid}-target`,
            getDropdownId: ()=>`${uid}-dropdown`,
            withRoles: withRoles,
            targetProps: others,
            __staticSelector: __staticSelector,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            variant: variant,
            keepMounted: keepMounted
        }
    }, children);
}
$48fdced15cb169ce$export$5b6b19405a83ff9d.Target = (0, $7wIYL.PopoverTarget);
$48fdced15cb169ce$export$5b6b19405a83ff9d.Dropdown = (0, $jAS2v.PopoverDropdown);
$48fdced15cb169ce$export$5b6b19405a83ff9d.displayName = "@mantine/core/Popover";

});
parcelRegister("ez0uD", function(module, exports) {

$parcel$export(module.exports, "useClickOutside", () => $a9a4b781a1c7053f$export$1896bab46732d207);

var $acw62 = parcelRequire("acw62");
const $a9a4b781a1c7053f$var$DEFAULT_EVENTS = [
    "mousedown",
    "touchstart"
];
function $a9a4b781a1c7053f$export$1896bab46732d207(handler, events, nodes) {
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        const listener = (event)=>{
            const { target: target } = event != null ? event : {};
            if (Array.isArray(nodes)) {
                const shouldIgnore = (target == null ? void 0 : target.hasAttribute("data-ignore-outside-clicks")) || !document.body.contains(target) && target.tagName !== "HTML";
                const shouldTrigger = nodes.every((node)=>!!node && !event.composedPath().includes(node));
                shouldTrigger && !shouldIgnore && handler();
            } else if (ref.current && !ref.current.contains(target)) handler();
        };
        (events || $a9a4b781a1c7053f$var$DEFAULT_EVENTS).forEach((fn)=>document.addEventListener(fn, listener));
        return ()=>{
            (events || $a9a4b781a1c7053f$var$DEFAULT_EVENTS).forEach((fn)=>document.removeEventListener(fn, listener));
        };
    }, [
        ref,
        handler,
        nodes
    ]);
    return ref;
}

});

parcelRegister("bD9Sm", function(module, exports) {

$parcel$export(module.exports, "usePopover", () => $877aff5e4cde3ca8$export$542a6fd13ac93354);

var $2qf6h = parcelRequire("2qf6h");
var $ke4gU = parcelRequire("ke4gU");

var $33OG6 = parcelRequire("33OG6");
var $618j3 = parcelRequire("618j3");parcelRequire("5rxG7");
var $618j3 = parcelRequire("618j3");
var $5rxG7 = parcelRequire("5rxG7");

var $8nNfC = parcelRequire("8nNfC");
function $877aff5e4cde3ca8$var$getPopoverMiddlewares(options, getFloating) {
    const middlewares = [
        (0, $618j3.offset)(options.offset)
    ];
    if (options.middlewares.shift) middlewares.push((0, $618j3.shift)({
        limiter: (0, $618j3.limitShift)()
    }));
    if (options.middlewares.flip) middlewares.push((0, $618j3.flip)());
    if (options.middlewares.inline) middlewares.push((0, $618j3.inline)());
    middlewares.push((0, $33OG6.arrow)({
        element: options.arrowRef,
        padding: options.arrowOffset
    }));
    if (options.middlewares.size || options.width === "target") middlewares.push((0, $618j3.size)({
        apply ({ rects: rects, availableWidth: availableWidth, availableHeight: availableHeight }) {
            var _a, _b;
            const floating = getFloating();
            const styles = (_b = (_a = floating.refs.floating.current) == null ? void 0 : _a.style) != null ? _b : {};
            if (options.middlewares.size) Object.assign(styles, {
                maxWidth: `${availableWidth}px`,
                maxHeight: `${availableHeight}px`
            });
            if (options.width === "target") Object.assign(styles, {
                width: `${rects.reference.width}px`
            });
        }
    }));
    return middlewares;
}
function $877aff5e4cde3ca8$export$542a6fd13ac93354(options) {
    const [_opened, setOpened] = (0, $ke4gU.useUncontrolled)({
        value: options.opened,
        defaultValue: options.defaultOpened,
        finalValue: false,
        onChange: options.onChange
    });
    const onClose = ()=>{
        var _a;
        (_a = options.onClose) == null || _a.call(options);
        setOpened(false);
    };
    const onToggle = ()=>{
        var _a, _b;
        if (_opened) {
            (_a = options.onClose) == null || _a.call(options);
            setOpened(false);
        } else {
            (_b = options.onOpen) == null || _b.call(options);
            setOpened(true);
        }
    };
    const floating = (0, $5rxG7.useFloating)({
        placement: options.position,
        middleware: $877aff5e4cde3ca8$var$getPopoverMiddlewares(options, ()=>floating)
    });
    (0, $8nNfC.useFloatingAutoUpdate)({
        opened: options.opened,
        position: options.position,
        positionDependencies: options.positionDependencies,
        floating: floating
    });
    (0, $2qf6h.useDidUpdate)(()=>{
        var _a;
        (_a = options.onPositionChange) == null || _a.call(options, floating.placement);
    }, [
        floating.placement
    ]);
    (0, $2qf6h.useDidUpdate)(()=>{
        var _a, _b;
        if (!options.opened) (_a = options.onClose) == null || _a.call(options);
        else (_b = options.onOpen) == null || _b.call(options);
    }, [
        options.opened
    ]);
    return {
        floating: floating,
        controlled: typeof options.opened === "boolean",
        opened: _opened,
        onClose: onClose,
        onToggle: onToggle
    };
}

});
parcelRegister("33OG6", function(module, exports) {

$parcel$export(module.exports, "arrow", () => $23a8f689f1d4c3be$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "useFloating", () => $23a8f689f1d4c3be$export$4e02a5c1d08bac65);

var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * A data provider that provides data to position an inner element of the
 * floating element (usually a triangle or caret) so that it is centered to the
 * reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $23a8f689f1d4c3be$export$f2120bbfa5450bd2 = (options)=>{
    const { element: element, padding: padding } = options;
    function isRef(value) {
        return Object.prototype.hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (args) {
            if (isRef(element)) {
                if (element.current != null) return (0, $618j3.arrow)({
                    element: element.current,
                    padding: padding
                }).fn(args);
                return {};
            } else if (element) return (0, $618j3.arrow)({
                element: element,
                padding: padding
            }).fn(args);
            return {};
        }
    };
};
var $23a8f689f1d4c3be$var$index = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $23a8f689f1d4c3be$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$23a8f689f1d4c3be$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$23a8f689f1d4c3be$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $23a8f689f1d4c3be$var$useLatestRef(value) {
    const ref = $acw62.useRef(value);
    $23a8f689f1d4c3be$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */ function $23a8f689f1d4c3be$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $acw62.useState({
        x: null,
        y: null,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $acw62.useState(middleware);
    if (!$23a8f689f1d4c3be$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const referenceRef = $acw62.useRef(null);
    const floatingRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef(data);
    const whileElementsMountedRef = $23a8f689f1d4c3be$var$useLatestRef(whileElementsMounted);
    const platformRef = $23a8f689f1d4c3be$var$useLatestRef(platform);
    const [reference, _setReference] = $acw62.useState(null);
    const [floating, _setFloating] = $acw62.useState(null);
    const setReference = $acw62.useCallback((node)=>{
        if (referenceRef.current !== node) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $acw62.useCallback((node)=>{
        if (floatingRef.current !== node) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const update = $acw62.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $618j3.computePosition)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$23a8f689f1d4c3be$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $1u0KT.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $23a8f689f1d4c3be$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $acw62.useRef(false);
    $23a8f689f1d4c3be$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $23a8f689f1d4c3be$var$index(()=>{
        if (reference && floating) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(reference, floating, update);
            else update();
        }
    }, [
        reference,
        floating,
        update,
        whileElementsMountedRef
    ]);
    const refs = $acw62.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $acw62.useMemo(()=>({
            reference: reference,
            floating: floating
        }), [
        reference,
        floating
    ]);
    return $acw62.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            reference: setReference,
            floating: setFloating
        }), [
        data,
        update,
        refs,
        elements,
        setReference,
        setFloating
    ]);
}

});
parcelRegister("618j3", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $461947879dcdbcd4$export$deee3a793edee05f);
$parcel$export(module.exports, "detectOverflow", () => $461947879dcdbcd4$export$37b6bde19b108ecc);
$parcel$export(module.exports, "offset", () => $461947879dcdbcd4$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $461947879dcdbcd4$export$fba63a578e423eb);
$parcel$export(module.exports, "flip", () => $461947879dcdbcd4$export$8a83211c878a3f1f);
$parcel$export(module.exports, "size", () => $461947879dcdbcd4$export$346677f925de839c);
$parcel$export(module.exports, "arrow", () => $461947879dcdbcd4$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "inline", () => $461947879dcdbcd4$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "limitShift", () => $461947879dcdbcd4$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "computePosition", () => $461947879dcdbcd4$export$48a53dcb22e581d0);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("33bLr")).getOverflowAncestors);

var $cZ41y = parcelRequire("cZ41y");
var $1obCQ = parcelRequire("1obCQ");

var $1obCQ = parcelRequire("1obCQ");

var $33bLr = parcelRequire("33bLr");
function $461947879dcdbcd4$var$getCssDimensions(element) {
    const css = (0, $33bLr.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $33bLr.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $1obCQ.round)(width) !== offsetWidth || (0, $1obCQ.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $461947879dcdbcd4$var$unwrapElement(element) {
    return !(0, $33bLr.isElement)(element) ? element.contextElement : element;
}
function $461947879dcdbcd4$var$getScale(element) {
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    if (!(0, $33bLr.isHTMLElement)(domElement)) return (0, $1obCQ.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $461947879dcdbcd4$var$getCssDimensions(domElement);
    let x = ($ ? (0, $1obCQ.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $1obCQ.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$noOffsets = /*#__PURE__*/ (0, $1obCQ.createCoords)(0);
function $461947879dcdbcd4$var$getVisualOffsets(element) {
    const win = (0, $33bLr.getWindow)(element);
    if (!(0, $33bLr.isWebKit)() || !win.visualViewport) return $461947879dcdbcd4$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $461947879dcdbcd4$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $33bLr.getWindow)(element)) return false;
    return isFixed;
}
function $461947879dcdbcd4$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $461947879dcdbcd4$var$unwrapElement(element);
    let scale = (0, $1obCQ.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $33bLr.isElement)(offsetParent)) scale = $461947879dcdbcd4$var$getScale(offsetParent);
        } else scale = $461947879dcdbcd4$var$getScale(element);
    }
    const visualOffsets = $461947879dcdbcd4$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $461947879dcdbcd4$var$getVisualOffsets(domElement) : (0, $1obCQ.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $33bLr.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $33bLr.isElement)(offsetParent) ? (0, $33bLr.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $461947879dcdbcd4$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $33bLr.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $33bLr.getWindow)(currentIFrame);
            currentIFrame = (0, $33bLr.getFrameElement)(currentWin);
        }
    }
    return (0, $1obCQ.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $461947879dcdbcd4$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $33bLr.getNodeScroll)(element).scrollLeft;
    if (!rect) return $461947879dcdbcd4$var$getBoundingClientRect((0, $33bLr.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $461947879dcdbcd4$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $33bLr.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $1obCQ.createCoords)(1);
    const offsets = (0, $1obCQ.createCoords)(0);
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== 'body' || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if ((0, $33bLr.isHTMLElement)(offsetParent)) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent);
            scale = $461947879dcdbcd4$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $1obCQ.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $461947879dcdbcd4$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $461947879dcdbcd4$var$getDocumentRect(element) {
    const html = (0, $33bLr.getDocumentElement)(element);
    const scroll = (0, $33bLr.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $1obCQ.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $1obCQ.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $461947879dcdbcd4$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $33bLr.getComputedStyle)(body).direction === 'rtl') x += (0, $1obCQ.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $461947879dcdbcd4$var$SCROLLBAR_MAX = 25;
function $461947879dcdbcd4$var$getViewportRect(element, strategy) {
    const win = (0, $33bLr.getWindow)(element);
    const html = (0, $33bLr.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $33bLr.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $461947879dcdbcd4$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $461947879dcdbcd4$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $461947879dcdbcd4$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $461947879dcdbcd4$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $461947879dcdbcd4$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $33bLr.isHTMLElement)(element) ? $461947879dcdbcd4$var$getScale(element) : (0, $1obCQ.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $461947879dcdbcd4$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $461947879dcdbcd4$var$getDocumentRect((0, $33bLr.getDocumentElement)(element));
    else if ((0, $33bLr.isElement)(clippingAncestor)) rect = $461947879dcdbcd4$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $461947879dcdbcd4$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $1obCQ.rectToClientRect)(rect);
}
function $461947879dcdbcd4$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $33bLr.getParentNode)(element);
    if (parentNode === stopNode || !(0, $33bLr.isElement)(parentNode) || (0, $33bLr.isLastTraversableNode)(parentNode)) return false;
    return (0, $33bLr.getComputedStyle)(parentNode).position === 'fixed' || $461947879dcdbcd4$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $461947879dcdbcd4$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $33bLr.getOverflowAncestors)(element, [], false).filter((el)=>(0, $33bLr.isElement)(el) && (0, $33bLr.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $33bLr.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $33bLr.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $33bLr.isElement)(currentNode) && !(0, $33bLr.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $33bLr.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $33bLr.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $461947879dcdbcd4$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $33bLr.isOverflowElement)(currentNode) && !currentNodeIsContaining && $461947879dcdbcd4$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $33bLr.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $461947879dcdbcd4$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $33bLr.isTopLayer)(element) ? [] : $461947879dcdbcd4$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $1obCQ.max)(rect.top, accRect.top);
        accRect.right = (0, $1obCQ.min)(rect.right, accRect.right);
        accRect.bottom = (0, $1obCQ.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $1obCQ.max)(rect.left, accRect.left);
        return accRect;
    }, $461947879dcdbcd4$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $461947879dcdbcd4$var$getDimensions(element) {
    const { width: width, height: height } = $461947879dcdbcd4$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $461947879dcdbcd4$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $33bLr.isHTMLElement)(offsetParent);
    const documentElement = (0, $33bLr.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $461947879dcdbcd4$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $1obCQ.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $461947879dcdbcd4$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $33bLr.getNodeName)(offsetParent) !== 'body' || (0, $33bLr.isOverflowElement)(documentElement)) scroll = (0, $33bLr.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $461947879dcdbcd4$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $461947879dcdbcd4$var$getHTMLOffset(documentElement, scroll) : (0, $1obCQ.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $461947879dcdbcd4$var$isStaticPositioned(element) {
    return (0, $33bLr.getComputedStyle)(element).position === 'static';
}
function $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $33bLr.isHTMLElement)(element) || (0, $33bLr.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $33bLr.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $461947879dcdbcd4$var$getOffsetParent(element, polyfill) {
    const win = (0, $33bLr.getWindow)(element);
    if ((0, $33bLr.isTopLayer)(element)) return win;
    if (!(0, $33bLr.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $33bLr.getParentNode)(element);
        while(svgOffsetParent && !(0, $33bLr.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $33bLr.isElement)(svgOffsetParent) && !$461947879dcdbcd4$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $33bLr.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $33bLr.isTableElement)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent))offsetParent = $461947879dcdbcd4$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $33bLr.isLastTraversableNode)(offsetParent) && $461947879dcdbcd4$var$isStaticPositioned(offsetParent) && !(0, $33bLr.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $33bLr.getContainingBlock)(element) || win;
}
const $461947879dcdbcd4$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $461947879dcdbcd4$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $461947879dcdbcd4$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $461947879dcdbcd4$var$isRTL(element) {
    return (0, $33bLr.getComputedStyle)(element).direction === 'rtl';
}
const $461947879dcdbcd4$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $461947879dcdbcd4$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $33bLr.getDocumentElement,
    getClippingRect: $461947879dcdbcd4$var$getClippingRect,
    getOffsetParent: $461947879dcdbcd4$var$getOffsetParent,
    getElementRects: $461947879dcdbcd4$var$getElementRects,
    getClientRects: $461947879dcdbcd4$var$getClientRects,
    getDimensions: $461947879dcdbcd4$var$getDimensions,
    getScale: $461947879dcdbcd4$var$getScale,
    isElement: $33bLr.isElement,
    isRTL: $461947879dcdbcd4$var$isRTL
};
function $461947879dcdbcd4$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $461947879dcdbcd4$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $33bLr.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $1obCQ.floor)(top);
        const insetRight = (0, $1obCQ.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $1obCQ.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $1obCQ.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $1obCQ.max)(0, (0, $1obCQ.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$461947879dcdbcd4$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $461947879dcdbcd4$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $461947879dcdbcd4$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $33bLr.getOverflowAncestors)(referenceEl) : [],
        ...(0, $33bLr.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $461947879dcdbcd4$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $461947879dcdbcd4$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $461947879dcdbcd4$var$getBoundingClientRect(reference);
        if (prevRefRect && !$461947879dcdbcd4$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $461947879dcdbcd4$export$37b6bde19b108ecc = (0, $cZ41y.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $461947879dcdbcd4$export$cc800923e997bb8 = (0, $cZ41y.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $461947879dcdbcd4$export$91fb6ecbd551914 = (0, $cZ41y.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $461947879dcdbcd4$export$fba63a578e423eb = (0, $cZ41y.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $461947879dcdbcd4$export$8a83211c878a3f1f = (0, $cZ41y.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $461947879dcdbcd4$export$346677f925de839c = (0, $cZ41y.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $461947879dcdbcd4$export$fe8985bb6374093c = (0, $cZ41y.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $461947879dcdbcd4$export$f2120bbfa5450bd2 = (0, $cZ41y.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $461947879dcdbcd4$export$18c8ad048e32c7d5 = (0, $cZ41y.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $461947879dcdbcd4$export$7bf07e38f3dc4b69 = (0, $cZ41y.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $461947879dcdbcd4$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $461947879dcdbcd4$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $cZ41y.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("cZ41y", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $973e4da43f2a375d$export$48a53dcb22e581d0);
$parcel$export(module.exports, "detectOverflow", () => $973e4da43f2a375d$export$37b6bde19b108ecc);
$parcel$export(module.exports, "arrow", () => $973e4da43f2a375d$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $973e4da43f2a375d$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $973e4da43f2a375d$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $973e4da43f2a375d$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $973e4da43f2a375d$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $973e4da43f2a375d$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $973e4da43f2a375d$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $973e4da43f2a375d$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $973e4da43f2a375d$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("1obCQ")).rectToClientRect);

var $1obCQ = parcelRequire("1obCQ");
function $973e4da43f2a375d$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $1obCQ.getSideAxis)(placement);
    const alignmentAxis = (0, $1obCQ.getAlignmentAxis)(placement);
    const alignLength = (0, $1obCQ.getAxisLength)(alignmentAxis);
    const side = (0, $1obCQ.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $1obCQ.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $973e4da43f2a375d$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $973e4da43f2a375d$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $973e4da43f2a375d$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state);
    const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $1obCQ.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $1obCQ.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $973e4da43f2a375d$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $1obCQ.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $1obCQ.getAlignmentAxis)(placement);
            const length = (0, $1obCQ.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $1obCQ.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $1obCQ.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $1obCQ.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $1obCQ.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $973e4da43f2a375d$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $1obCQ.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $1obCQ.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $1obCQ.getAlignment)(placement) === alignment || (autoAlignment ? (0, $1obCQ.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $973e4da43f2a375d$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $1obCQ.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $1obCQ.placements) ? $973e4da43f2a375d$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $1obCQ.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $1obCQ.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $1obCQ.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $1obCQ.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $973e4da43f2a375d$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $1obCQ.getSide)(placement);
            const initialSideAxis = (0, $1obCQ.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $1obCQ.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $1obCQ.getOppositePlacement)(initialPlacement)
            ] : (0, $1obCQ.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $1obCQ.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $1obCQ.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $1obCQ.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $1obCQ.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $1obCQ.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $973e4da43f2a375d$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $973e4da43f2a375d$var$isAnySideFullyClipped(overflow) {
    return (0, $1obCQ.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $973e4da43f2a375d$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $973e4da43f2a375d$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $973e4da43f2a375d$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $973e4da43f2a375d$var$getBoundingRect(rects) {
    const minX = (0, $1obCQ.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $1obCQ.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $1obCQ.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $1obCQ.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $973e4da43f2a375d$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $973e4da43f2a375d$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $1obCQ.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $973e4da43f2a375d$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $1obCQ.rectToClientRect)($973e4da43f2a375d$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $1obCQ.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $1obCQ.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $1obCQ.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $1obCQ.getSide)(placement) === 'left';
                    const maxRight = (0, $1obCQ.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $1obCQ.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $973e4da43f2a375d$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $973e4da43f2a375d$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $1obCQ.getSide)(placement);
    const alignment = (0, $1obCQ.getAlignment)(placement);
    const isVertical = (0, $1obCQ.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $973e4da43f2a375d$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $1obCQ.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $973e4da43f2a375d$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $973e4da43f2a375d$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $973e4da43f2a375d$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $1obCQ.getSideAxis)((0, $1obCQ.getSide)(placement));
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $1obCQ.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $1obCQ.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $973e4da43f2a375d$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $1obCQ.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $1obCQ.getSideAxis)(placement);
            const mainAxis = (0, $1obCQ.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $1obCQ.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $973e4da43f2a375d$var$originSides.has((0, $1obCQ.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $973e4da43f2a375d$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $1obCQ.evaluate)(options, state);
            const overflow = await $973e4da43f2a375d$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $1obCQ.getSide)(placement);
            const alignment = (0, $1obCQ.getAlignment)(placement);
            const isYAxis = (0, $1obCQ.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $1obCQ.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $1obCQ.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $1obCQ.max)(overflow.left, 0);
                const xMax = (0, $1obCQ.max)(overflow.right, 0);
                const yMin = (0, $1obCQ.max)(overflow.top, 0);
                const yMax = (0, $1obCQ.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $1obCQ.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $1obCQ.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("1obCQ", function(module, exports) {

$parcel$export(module.exports, "sides", () => $10310cf078d13212$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $10310cf078d13212$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $10310cf078d13212$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $10310cf078d13212$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $10310cf078d13212$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $10310cf078d13212$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $10310cf078d13212$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $10310cf078d13212$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $10310cf078d13212$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $10310cf078d13212$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $10310cf078d13212$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $10310cf078d13212$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $10310cf078d13212$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $10310cf078d13212$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $10310cf078d13212$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $10310cf078d13212$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $10310cf078d13212$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $10310cf078d13212$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $10310cf078d13212$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $10310cf078d13212$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $10310cf078d13212$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $10310cf078d13212$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $10310cf078d13212$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $10310cf078d13212$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $10310cf078d13212$export$803cd8101b6c182b = /*#__PURE__*/ $10310cf078d13212$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[0], side + "-" + $10310cf078d13212$export$27b07d8a310ed8b5[1]), []);
const $10310cf078d13212$export$96ec731ed4dcb222 = Math.min;
const $10310cf078d13212$export$8960430cfd85939f = Math.max;
const $10310cf078d13212$export$2077e0241d6afd3c = Math.round;
const $10310cf078d13212$export$a3fe094919f356fd = Math.floor;
const $10310cf078d13212$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $10310cf078d13212$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $10310cf078d13212$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $10310cf078d13212$export$7d15b64cf5a3a4c4(start, value, end) {
    return $10310cf078d13212$export$8960430cfd85939f(start, $10310cf078d13212$export$96ec731ed4dcb222(value, end));
}
function $10310cf078d13212$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $10310cf078d13212$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $10310cf078d13212$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $10310cf078d13212$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $10310cf078d13212$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $10310cf078d13212$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $10310cf078d13212$export$f28e8f882010718a(placement) {
    return $10310cf078d13212$var$yAxisSides.has($10310cf078d13212$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $10310cf078d13212$export$2b57e0052a6d6d4c(placement) {
    return $10310cf078d13212$export$8a000a963141ac32($10310cf078d13212$export$f28e8f882010718a(placement));
}
function $10310cf078d13212$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    const alignmentAxis = $10310cf078d13212$export$2b57e0052a6d6d4c(placement);
    const length = $10310cf078d13212$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $10310cf078d13212$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $10310cf078d13212$export$496432a3699e50b1(placement) {
    const oppositePlacement = $10310cf078d13212$export$9c5e28bad23365fa(placement);
    return [
        $10310cf078d13212$export$2b182c584985588b(placement),
        oppositePlacement,
        $10310cf078d13212$export$2b182c584985588b(oppositePlacement)
    ];
}
function $10310cf078d13212$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$10310cf078d13212$var$oppositeAlignmentMap[alignment]);
}
const $10310cf078d13212$var$lrPlacement = [
    'left',
    'right'
];
const $10310cf078d13212$var$rlPlacement = [
    'right',
    'left'
];
const $10310cf078d13212$var$tbPlacement = [
    'top',
    'bottom'
];
const $10310cf078d13212$var$btPlacement = [
    'bottom',
    'top'
];
function $10310cf078d13212$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $10310cf078d13212$var$rlPlacement : $10310cf078d13212$var$lrPlacement;
            return isStart ? $10310cf078d13212$var$lrPlacement : $10310cf078d13212$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $10310cf078d13212$var$tbPlacement : $10310cf078d13212$var$btPlacement;
        default:
            return [];
    }
}
function $10310cf078d13212$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $10310cf078d13212$export$f0989780f32bfcda(placement);
    let list = $10310cf078d13212$var$getSideList($10310cf078d13212$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($10310cf078d13212$export$2b182c584985588b));
    }
    return list;
}
function $10310cf078d13212$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$10310cf078d13212$var$oppositeSideMap[side]);
}
function $10310cf078d13212$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $10310cf078d13212$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $10310cf078d13212$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $10310cf078d13212$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("33bLr", function(module, exports) {

$parcel$export(module.exports, "getNodeName", () => $238ac70369f38756$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $238ac70369f38756$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $238ac70369f38756$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $238ac70369f38756$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $238ac70369f38756$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $238ac70369f38756$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $238ac70369f38756$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $238ac70369f38756$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $238ac70369f38756$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $238ac70369f38756$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $238ac70369f38756$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $238ac70369f38756$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $238ac70369f38756$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $238ac70369f38756$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $238ac70369f38756$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $238ac70369f38756$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $238ac70369f38756$export$7bf1f8740e3e34af);
function $238ac70369f38756$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $238ac70369f38756$export$651544f548703224(node) {
    if ($238ac70369f38756$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $238ac70369f38756$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $238ac70369f38756$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($238ac70369f38756$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $238ac70369f38756$export$8ee0fc9ee280b4ee(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Node;
}
function $238ac70369f38756$export$45a5e7f76e0caa8d(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).Element;
}
function $238ac70369f38756$export$1b3bfaa9684536aa(value) {
    if (!$238ac70369f38756$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).HTMLElement;
}
function $238ac70369f38756$export$af51f0f06c0f328a(value) {
    if (!$238ac70369f38756$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $238ac70369f38756$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $238ac70369f38756$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $238ac70369f38756$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $238ac70369f38756$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$238ac70369f38756$var$invalidOverflowDisplayValues.has(display);
}
const $238ac70369f38756$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $238ac70369f38756$export$71535ffaa902797f(element) {
    return $238ac70369f38756$var$tableElements.has($238ac70369f38756$export$651544f548703224(element));
}
const $238ac70369f38756$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $238ac70369f38756$export$89e651af02346cd4(element) {
    return $238ac70369f38756$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $238ac70369f38756$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $238ac70369f38756$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $238ac70369f38756$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $238ac70369f38756$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $238ac70369f38756$export$78551043582a6a98();
    const css = $238ac70369f38756$export$45a5e7f76e0caa8d(elementOrCss) ? $238ac70369f38756$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $238ac70369f38756$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $238ac70369f38756$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $238ac70369f38756$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $238ac70369f38756$export$940d8225183e1404(element) {
    let currentNode = $238ac70369f38756$export$4e12058fc4d51d56(element);
    while($238ac70369f38756$export$1b3bfaa9684536aa(currentNode) && !$238ac70369f38756$export$d1162fb0b6d4cd51(currentNode)){
        if ($238ac70369f38756$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($238ac70369f38756$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $238ac70369f38756$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $238ac70369f38756$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $238ac70369f38756$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $238ac70369f38756$export$d1162fb0b6d4cd51(node) {
    return $238ac70369f38756$var$lastTraversableNodeNames.has($238ac70369f38756$export$651544f548703224(node));
}
function $238ac70369f38756$export$3735103072e4a80(element) {
    return $238ac70369f38756$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $238ac70369f38756$export$dc8fc79fa2800137(element) {
    if ($238ac70369f38756$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $238ac70369f38756$export$4e12058fc4d51d56(node) {
    if ($238ac70369f38756$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $238ac70369f38756$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $238ac70369f38756$export$e495491855dc5418(node);
    return $238ac70369f38756$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $238ac70369f38756$export$7cd01a57c8ca906c(node) {
    const parentNode = $238ac70369f38756$export$4e12058fc4d51d56(node);
    if ($238ac70369f38756$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($238ac70369f38756$export$1b3bfaa9684536aa(parentNode) && $238ac70369f38756$export$989e911fa9af580a(parentNode)) return parentNode;
    return $238ac70369f38756$export$7cd01a57c8ca906c(parentNode);
}
function $238ac70369f38756$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $238ac70369f38756$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $238ac70369f38756$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $238ac70369f38756$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $238ac70369f38756$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $238ac70369f38756$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $238ac70369f38756$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $238ac70369f38756$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});



parcelRegister("5rxG7", function(module, exports) {

$parcel$export(module.exports, "useHover", () => $3f69993268aa5b7a$export$ae780daf29e6d456);
$parcel$export(module.exports, "useDelayGroupContext", () => $3f69993268aa5b7a$export$e2411914b150383d);
$parcel$export(module.exports, "FloatingDelayGroup", () => $3f69993268aa5b7a$export$718279509ff1e241);
$parcel$export(module.exports, "useDelayGroup", () => $3f69993268aa5b7a$export$560fc8be89c8b4a8);
$parcel$export(module.exports, "useDismiss", () => $3f69993268aa5b7a$export$fcdf1ba5fafc089b);
$parcel$export(module.exports, "useFocus", () => $3f69993268aa5b7a$export$f8168d8dd8fd66e6);
$parcel$export(module.exports, "useRole", () => $3f69993268aa5b7a$export$f66572793fa256a1);
$parcel$export(module.exports, "useFloating", () => $3f69993268aa5b7a$export$4e02a5c1d08bac65);
$parcel$export(module.exports, "useInteractions", () => $3f69993268aa5b7a$export$a519f7794e446ddd);
$parcel$export(module.exports, "getOverflowAncestors", () => (parcelRequire("33bLr")).getOverflowAncestors);
$parcel$export(module.exports, "offset", () => (parcelRequire("618j3")).offset);

var $acw62 = parcelRequire("acw62");

var $6okVC = parcelRequire("6okVC");

var $e8HHX = parcelRequire("e8HHX");

var $1u0KT = parcelRequire("1u0KT");

var $33OG6 = parcelRequire("33OG6");
var $618j3 = parcelRequire("618j3");
var $33bLr = parcelRequire("33bLr");
var $3f69993268aa5b7a$var$index = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
let $3f69993268aa5b7a$var$serverHandoffComplete = false;
let $3f69993268aa5b7a$var$count = 0;
const $3f69993268aa5b7a$var$genId = ()=>"floating-ui-" + $3f69993268aa5b7a$var$count++;
function $3f69993268aa5b7a$var$useFloatingId() {
    const [id, setId] = $acw62.useState(()=>$3f69993268aa5b7a$var$serverHandoffComplete ? $3f69993268aa5b7a$var$genId() : undefined);
    $3f69993268aa5b7a$var$index(()=>{
        if (id == null) setId($3f69993268aa5b7a$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(()=>{
        if (!$3f69993268aa5b7a$var$serverHandoffComplete) $3f69993268aa5b7a$var$serverHandoffComplete = true;
    }, []);
    return id;
}
// `toString()` prevents bundlers from trying to `import { useId } from 'react'`
const $3f69993268aa5b7a$var$useReactId = $acw62[/*#__PURE__*/ 'useId'.toString()];
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/useId
 */ const $3f69993268aa5b7a$export$f680877a34711e37 = $3f69993268aa5b7a$var$useReactId || $3f69993268aa5b7a$var$useFloatingId;
function $3f69993268aa5b7a$var$createPubSub() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((handler)=>handler(data));
        },
        on (event, listener) {
            map.set(event, [
                ...map.get(event) || [],
                listener
            ]);
        },
        off (event, listener) {
            map.set(event, (map.get(event) || []).filter((l)=>l !== listener));
        }
    };
}
const $3f69993268aa5b7a$var$FloatingNodeContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$var$FloatingTreeContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $acw62.useContext($3f69993268aa5b7a$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const $3f69993268aa5b7a$export$db0c2a7c7a2a4f69 = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingTreeContext);
/**
 * Registers a node into the floating tree, returning its id.
 */ const $3f69993268aa5b7a$export$9b136e0e758a42f4 = (customParentId)=>{
    const id = $3f69993268aa5b7a$export$f680877a34711e37();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const reactParentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    $3f69993268aa5b7a$var$index(()=>{
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
};
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ const $3f69993268aa5b7a$export$ca00a83b5b253862 = (_ref)=>{
    let { children: children, id: id } = _ref;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingNodeContext.Provider, {
        value: $acw62.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ])
    }, children);
};
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM (i.e. portalled to a common node, rather than their
 * respective parent).
 * @see https://floating-ui.com/docs/FloatingTree
 */ const $3f69993268aa5b7a$export$587b60129641c4c8 = (_ref2)=>{
    let { children: children } = _ref2;
    const nodesRef = $acw62.useRef([]);
    const addNode = $acw62.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $acw62.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const events = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub())[0];
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingTreeContext.Provider, {
        value: $acw62.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            nodesRef,
            addNode,
            removeNode,
            events
        ])
    }, children);
};
function $3f69993268aa5b7a$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Avoid Chrome DevTools blue warning.
function $3f69993268aa5b7a$var$getPlatform() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $3f69993268aa5b7a$var$getUserAgent() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $3f69993268aa5b7a$var$getWindow(value) {
    return $3f69993268aa5b7a$var$getDocument(value).defaultView || window;
}
function $3f69993268aa5b7a$var$isElement(value) {
    return value ? value instanceof $3f69993268aa5b7a$var$getWindow(value).Element : false;
}
function $3f69993268aa5b7a$var$isHTMLElement(value) {
    return value ? value instanceof $3f69993268aa5b7a$var$getWindow(value).HTMLElement : false;
}
function $3f69993268aa5b7a$var$isShadowRoot(node) {
    // Browsers without `ShadowRoot` support
    if (typeof ShadowRoot === 'undefined') return false;
    const OwnElement = $3f69993268aa5b7a$var$getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $3f69993268aa5b7a$var$isVirtualClick(event) {
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    const androidRe = /Android/i;
    if ((androidRe.test($3f69993268aa5b7a$var$getPlatform()) || androidRe.test($3f69993268aa5b7a$var$getUserAgent())) && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $3f69993268aa5b7a$var$isVirtualPointerEvent(event) {
    return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function $3f69993268aa5b7a$var$isSafari() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $3f69993268aa5b7a$var$isMac() {
    return $3f69993268aa5b7a$var$getPlatform().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $3f69993268aa5b7a$var$isMouseLikePointerType(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
function $3f69993268aa5b7a$var$useLatestRef(value) {
    const ref = (0, $acw62.useRef)(value);
    $3f69993268aa5b7a$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
const $3f69993268aa5b7a$var$safePolygonIdentifier = 'data-floating-ui-safe-polygon';
function $3f69993268aa5b7a$var$getDelay(value, prop, pointerType) {
    if (pointerType && !$3f69993268aa5b7a$var$isMouseLikePointerType(pointerType)) return 0;
    if (typeof value === 'number') return value;
    return value == null ? void 0 : value[prop];
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ const $3f69993268aa5b7a$export$ae780daf29e6d456 = function(context, _temp) {
    let { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = _temp === void 0 ? {} : _temp;
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: { domReference: domReference, floating: floating }, refs: refs } = context;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const handleCloseRef = $3f69993268aa5b7a$var$useLatestRef(handleClose);
    const delayRef = $3f69993268aa5b7a$var$useLatestRef(delay);
    const pointerTypeRef = $acw62.useRef();
    const timeoutRef = $acw62.useRef();
    const handlerRef = $acw62.useRef();
    const restTimeoutRef = $acw62.useRef();
    const blockMouseMoveRef = $acw62.useRef(true);
    const performedPointerEventsMutationRef = $acw62.useRef(false);
    const unbindMouseMoveRef = $acw62.useRef(()=>{});
    const isHoverOpen = $acw62.useCallback(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    }, [
        dataRef
    ]);
    // When dismissing before opening, clear the delay timeouts to cancel it
    // from showing.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onDismiss() {
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            blockMouseMoveRef.current = true;
        }
        events.on('dismiss', onDismiss);
        return ()=>{
            events.off('dismiss', onDismiss);
        };
    }, [
        enabled,
        events
    ]);
    $acw62.useEffect(()=>{
        if (!enabled || !handleCloseRef.current || !open) return;
        function onLeave() {
            if (isHoverOpen()) onOpenChange(false);
        }
        const html = $3f69993268aa5b7a$var$getDocument(floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        dataRef,
        isHoverOpen
    ]);
    const closeWithDelay = $acw62.useCallback(function(runElseBranch) {
        if (runElseBranch === void 0) runElseBranch = true;
        const closeDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(()=>onOpenChange(false), closeDelay);
        } else if (runElseBranch) {
            clearTimeout(timeoutRef.current);
            onOpenChange(false);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = $acw62.useCallback(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    }, []);
    const clearPointerEvents = $acw62.useCallback(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = $3f69993268aa5b7a$var$getDocument(refs.floating.current).body;
            body.style.pointerEvents = '';
            body.removeAttribute($3f69993268aa5b7a$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    }, [
        refs
    ]);
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function isClickLikeOpenEvent() {
            return dataRef.current.openEvent ? [
                'click',
                'mousedown'
            ].includes(dataRef.current.openEvent.type) : false;
        }
        function onMouseEnter(event) {
            clearTimeout(timeoutRef.current);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !$3f69993268aa5b7a$var$isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && $3f69993268aa5b7a$var$getDelay(delayRef.current, 'open') === 0) return;
            dataRef.current.openEvent = event;
            const openDelay = $3f69993268aa5b7a$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = setTimeout(()=>{
                onOpenChange(true);
            }, openDelay);
            else onOpenChange(true);
        }
        function onMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            unbindMouseMoveRef.current();
            const doc = $3f69993268aa5b7a$var$getDocument(floating);
            clearTimeout(restTimeoutRef.current);
            if (handleCloseRef.current) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) clearTimeout(timeoutRef.current);
                handlerRef.current = handleCloseRef.current({
                    ...context,
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        closeWithDelay();
                    }
                });
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            closeWithDelay();
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            handleCloseRef.current == null || handleCloseRef.current({
                ...context,
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    closeWithDelay();
                }
            })(event);
        }
        if ($3f69993268aa5b7a$var$isElement(domReference)) {
            const ref = domReference;
            open && ref.addEventListener('mouseleave', onScrollMouseLeave);
            floating == null || floating.addEventListener('mouseleave', onScrollMouseLeave);
            move && ref.addEventListener('mousemove', onMouseEnter, {
                once: true
            });
            ref.addEventListener('mouseenter', onMouseEnter);
            ref.addEventListener('mouseleave', onMouseLeave);
            return ()=>{
                open && ref.removeEventListener('mouseleave', onScrollMouseLeave);
                floating == null || floating.removeEventListener('mouseleave', onScrollMouseLeave);
                move && ref.removeEventListener('mousemove', onMouseEnter);
                ref.removeEventListener('mouseenter', onMouseEnter);
                ref.removeEventListener('mouseleave', onMouseLeave);
            };
        }
    }, [
        domReference,
        floating,
        enabled,
        context,
        mouseOnly,
        restMs,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        tree,
        delayRef,
        handleCloseRef,
        dataRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    $3f69993268aa5b7a$var$index(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
            const body = $3f69993268aa5b7a$var$getDocument(floating).body;
            body.setAttribute($3f69993268aa5b7a$var$safePolygonIdentifier, '');
            body.style.pointerEvents = 'none';
            performedPointerEventsMutationRef.current = true;
            if ($3f69993268aa5b7a$var$isElement(domReference) && floating) {
                var _tree$nodesRef$curren, _tree$nodesRef$curren2;
                const ref = domReference;
                const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                ref.style.pointerEvents = 'auto';
                floating.style.pointerEvents = 'auto';
                return ()=>{
                    ref.style.pointerEvents = '';
                    floating.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        floating,
        domReference,
        tree,
        handleCloseRef,
        dataRef,
        isHoverOpen
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            clearTimeout(timeoutRef.current);
            clearTimeout(restTimeoutRef.current);
            clearPointerEvents();
        };
    }, [
        enabled,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            reference: {
                onPointerDown: setPointerRef,
                onPointerEnter: setPointerRef,
                onMouseMove () {
                    if (open || restMs === 0) return;
                    clearTimeout(restTimeoutRef.current);
                    restTimeoutRef.current = setTimeout(()=>{
                        if (!blockMouseMoveRef.current) onOpenChange(true);
                    }, restMs);
                }
            },
            floating: {
                onMouseEnter () {
                    clearTimeout(timeoutRef.current);
                },
                onMouseLeave () {
                    events.emit('dismiss', {
                        type: 'mouseLeave',
                        data: {
                            returnFocus: false
                        }
                    });
                    closeWithDelay(false);
                }
            }
        };
    }, [
        events,
        enabled,
        restMs,
        open,
        onOpenChange,
        closeWithDelay
    ]);
};
const $3f69993268aa5b7a$var$FloatingDelayGroupContext = /*#__PURE__*/ $acw62.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: ()=>{},
    setState: ()=>{},
    isInstantPhase: false
});
const $3f69993268aa5b7a$export$e2411914b150383d = ()=>$acw62.useContext($3f69993268aa5b7a$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ const $3f69993268aa5b7a$export$718279509ff1e241 = (_ref)=>{
    let { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = _ref;
    const [state, setState] = $acw62.useReducer((prev, next)=>({
            ...prev,
            ...next
        }), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $acw62.useRef(null);
    const setCurrentId = $acw62.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    $3f69993268aa5b7a$var$index(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else setState({
                isInstantPhase: true
            });
        } else {
            setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FloatingDelayGroupContext.Provider, {
        value: $acw62.useMemo(()=>({
                ...state,
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setState,
            setCurrentId
        ])
    }, children);
};
const $3f69993268aa5b7a$export$560fc8be89c8b4a8 = (_ref2, _ref3)=>{
    let { open: open, onOpenChange: onOpenChange } = _ref2;
    let { id: id } = _ref3;
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = $3f69993268aa5b7a$export$e2411914b150383d();
    $acw62.useEffect(()=>{
        if (currentId) {
            setState({
                delay: {
                    open: 1,
                    close: $3f69993268aa5b7a$var$getDelay(initialDelay, 'close')
                }
            });
            if (currentId !== id) onOpenChange(false);
        }
    }, [
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    $acw62.useEffect(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            } else unset();
        }
    }, [
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    $acw62.useEffect(()=>{
        if (open) setCurrentId(id);
    }, [
        open,
        setCurrentId,
        id
    ]);
};
function $3f69993268aa5b7a$var$_extends() {
    $3f69993268aa5b7a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f69993268aa5b7a$var$_extends.apply(this, arguments);
}
/**
 * Find the real active element. Traverses into shadowRoots.
 */ function $3f69993268aa5b7a$var$activeElement$1(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null){
        var _activeElement, _activeElement$shadow;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $3f69993268aa5b7a$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode && child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && $3f69993268aa5b7a$var$isShadowRoot(rootNode)) {
        let next = child;
        do {
            if (next && parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }while (next);
    }
    // Give up, the result is false
    return false;
}
let $3f69993268aa5b7a$var$rafId = 0;
function $3f69993268aa5b7a$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($3f69993268aa5b7a$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $3f69993268aa5b7a$var$rafId = requestAnimationFrame(exec);
}
function $3f69993268aa5b7a$var$getAncestors(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $3f69993268aa5b7a$var$getChildren(nodes, id) {
    let allChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
    }) || [];
    let currentChildren = allChildren;
    while(currentChildren.length){
        currentChildren = nodes.filter((node)=>{
            var _currentChildren;
            return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n)=>{
                var _node$context2;
                return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
            });
        }) || [];
        allChildren = allChildren.concat(currentChildren);
    }
    return allChildren;
}
function $3f69993268aa5b7a$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
const $3f69993268aa5b7a$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function $3f69993268aa5b7a$var$isTypeableElement(element) {
    return $3f69993268aa5b7a$var$isHTMLElement(element) && element.matches($3f69993268aa5b7a$var$TYPEABLE_SELECTOR);
}
function $3f69993268aa5b7a$var$stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $3f69993268aa5b7a$var$getTabbableOptions = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $3f69993268aa5b7a$var$getTabbableIn(container, direction) {
    const allTabbable = (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    if (direction === 'prev') allTabbable.reverse();
    const activeIndex = allTabbable.indexOf($3f69993268aa5b7a$var$activeElement$1($3f69993268aa5b7a$var$getDocument(container)));
    const nextTabbableElements = allTabbable.slice(activeIndex + 1);
    return nextTabbableElements[0];
}
function $3f69993268aa5b7a$var$getNextTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, 'next');
}
function $3f69993268aa5b7a$var$getPreviousTabbable() {
    return $3f69993268aa5b7a$var$getTabbableIn(document.body, 'prev');
}
function $3f69993268aa5b7a$var$isOutsideEvent(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$3f69993268aa5b7a$var$contains(containerElement, relatedTarget);
}
function $3f69993268aa5b7a$var$disableFocusInside(container) {
    const tabbableElements = (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $3f69993268aa5b7a$var$enableFocusInside(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}
// `toString()` prevents bundlers from trying to `import { useInsertionEffect } from 'react'`
const $3f69993268aa5b7a$var$useInsertionEffect = $acw62[/*#__PURE__*/ 'useInsertionEffect'.toString()];
const $3f69993268aa5b7a$var$useSafeInsertionEffect = $3f69993268aa5b7a$var$useInsertionEffect || ((fn)=>fn());
function $3f69993268aa5b7a$var$useEvent(callback) {
    const ref = $acw62.useRef(()=>{});
    $3f69993268aa5b7a$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
// See Diego Haz's Sandbox for making this logic work well on Safari/iOS:
// https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/FocusTrap.tsx
const $3f69993268aa5b7a$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
let $3f69993268aa5b7a$var$activeElement;
let $3f69993268aa5b7a$var$timeoutId;
function $3f69993268aa5b7a$var$setActiveElementOnTab(event) {
    if (event.key === 'Tab') {
        $3f69993268aa5b7a$var$activeElement = event.target;
        clearTimeout($3f69993268aa5b7a$var$timeoutId);
    }
}
function $3f69993268aa5b7a$var$isTabFocus(event) {
    const result = $3f69993268aa5b7a$var$activeElement === event.relatedTarget;
    $3f69993268aa5b7a$var$activeElement = event.relatedTarget;
    clearTimeout($3f69993268aa5b7a$var$timeoutId);
    return result;
}
const $3f69993268aa5b7a$var$FocusGuard = /*#__PURE__*/ $acw62.forwardRef(function FocusGuard(props, ref) {
    const onFocus = $3f69993268aa5b7a$var$useEvent(props.onFocus);
    const [role, setRole] = $acw62.useState();
    $3f69993268aa5b7a$var$index(()=>{
        if ($3f69993268aa5b7a$var$isSafari()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
        document.addEventListener('keydown', $3f69993268aa5b7a$var$setActiveElementOnTab);
        return ()=>{
            document.removeEventListener('keydown', $3f69993268aa5b7a$var$setActiveElementOnTab);
        };
    }, []);
    return /*#__PURE__*/ $acw62.createElement("span", $3f69993268aa5b7a$var$_extends({}, props, {
        ref: ref,
        tabIndex: 0,
        role: role,
        "aria-hidden": role ? undefined : true,
        "data-floating-ui-focus-guard": "",
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isSafari() && $3f69993268aa5b7a$var$isMac() && !$3f69993268aa5b7a$var$isTabFocus(event)) {
                // On macOS we need to wait a little bit before moving
                // focus again.
                event.persist();
                $3f69993268aa5b7a$var$timeoutId = window.setTimeout(()=>{
                    onFocus(event);
                }, 50);
            } else onFocus(event);
        }
    }));
});
const $3f69993268aa5b7a$var$PortalContext = /*#__PURE__*/ $acw62.createContext(null);
const $3f69993268aa5b7a$export$ac107512f3c5cca6 = function(_temp) {
    let { id: id, enabled: enabled = true } = _temp === void 0 ? {} : _temp;
    const [portalEl, setPortalEl] = $acw62.useState(null);
    const uniqueId = $3f69993268aa5b7a$export$f680877a34711e37();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        const rootNode = id ? document.getElementById(id) : null;
        if (rootNode) {
            rootNode.setAttribute('data-floating-ui-portal', '');
            setPortalEl(rootNode);
        } else {
            const newPortalEl = document.createElement('div');
            if (id !== '') newPortalEl.id = id || uniqueId;
            newPortalEl.setAttribute('data-floating-ui-portal', '');
            setPortalEl(newPortalEl);
            const container = (portalContext == null ? void 0 : portalContext.portalNode) || document.body;
            container.appendChild(newPortalEl);
            return ()=>{
                container.removeChild(newPortalEl);
            };
        }
    }, [
        id,
        portalContext,
        uniqueId,
        enabled
    ]);
    return portalEl;
};
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ const $3f69993268aa5b7a$export$31fa5d718fa2ac09 = (_ref)=>{
    let { children: children, id: id, root: root = null, preserveTabOrder: preserveTabOrder = true } = _ref;
    const portalNode = $3f69993268aa5b7a$export$ac107512f3c5cca6({
        id: id,
        enabled: !root
    });
    const [focusManagerState, setFocusManagerState] = $acw62.useState(null);
    const beforeOutsideRef = $acw62.useRef(null);
    const afterOutsideRef = $acw62.useRef(null);
    const beforeInsideRef = $acw62.useRef(null);
    const afterInsideRef = $acw62.useRef(null);
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && !!(root || portalNode) && preserveTabOrder;
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $acw62.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && $3f69993268aa5b7a$var$isOutsideEvent(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? $3f69993268aa5b7a$var$enableFocusInside : $3f69993268aa5b7a$var$disableFocusInside;
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        focusManagerState == null ? void 0 : focusManagerState.modal
    ]);
    return /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$PortalContext.Provider, {
        value: $acw62.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ])
    }, shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _beforeInsideRef$curr;
                (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
            } else {
                const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                prevTabbable == null || prevTabbable.focus();
            }
        }
    }), shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement("span", {
        "aria-owns": portalNode.id,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }), root ? /*#__PURE__*/ (0, $1u0KT.createPortal)(children, root) : portalNode ? /*#__PURE__*/ (0, $1u0KT.createPortal)(children, portalNode) : null, shouldRenderGuards && portalNode && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event)=>{
            if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalNode)) {
                var _afterInsideRef$curre;
                (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
            } else {
                const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
                nextTabbable == null || nextTabbable.focus();
                (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false));
            }
        }
    }));
};
const $3f69993268aa5b7a$var$usePortalContext = ()=>$acw62.useContext($3f69993268aa5b7a$var$PortalContext);
const $3f69993268aa5b7a$var$VisuallyHiddenDismiss = /*#__PURE__*/ $acw62.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ $acw62.createElement("button", $3f69993268aa5b7a$var$_extends({}, props, {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $3f69993268aa5b7a$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $3f69993268aa5b7a$export$8aeee49171ded61a(_ref) {
    let { context: context, children: children, order: order = [
        'content'
    ], guards: guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true } = _ref;
    const { refs: refs, nodeId: nodeId, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const orderRef = $3f69993268aa5b7a$var$useLatestRef(order);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const portalContext = $3f69993268aa5b7a$var$usePortalContext();
    const [tabbableContentLength, setTabbableContentLength] = $acw62.useState(null);
    // Controlled by `useListNavigation`.
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    const startDismissButtonRef = $acw62.useRef(null);
    const endDismissButtonRef = $acw62.useRef(null);
    const preventReturnFocusRef = $acw62.useRef(false);
    const previouslyFocusedElementRef = $acw62.useRef(null);
    const isPointerDownRef = $acw62.useRef(false);
    const isInsidePortal = portalContext != null;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isTypeableCombobox = domReference && domReference.getAttribute('role') === 'combobox' && $3f69993268aa5b7a$var$isTypeableElement(domReference);
    const getTabbableContent = $acw62.useCallback(function(container) {
        if (container === void 0) container = floating;
        return container ? (0, $e8HHX.tabbable)(container, $3f69993268aa5b7a$var$getTabbableOptions()) : [];
    }, [
        floating
    ]);
    const getTabbableElements = $acw62.useCallback((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floating && type === 'floating') return floating;
            return content;
        }).filter(Boolean).flat();
    }, [
        domReference,
        floating,
        orderRef,
        getTabbableContent
    ]);
    $acw62.useEffect(()=>{
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if (getTabbableContent().length === 0 && !isTypeableCombobox) $3f69993268aa5b7a$var$stopEvent(event);
                const els = getTabbableElements();
                const target = $3f69993268aa5b7a$var$getTarget(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    $3f69993268aa5b7a$var$stopEvent(event);
                    if (event.shiftKey) $3f69993268aa5b7a$var$enqueueFocus(els[els.length - 1]);
                    else $3f69993268aa5b7a$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floating && event.shiftKey) {
                    $3f69993268aa5b7a$var$stopEvent(event);
                    $3f69993268aa5b7a$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        domReference,
        floating,
        modal,
        orderRef,
        refs,
        isTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $acw62.useEffect(()=>{
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const movedToUnrelatedNode = !($3f69993268aa5b7a$var$contains(domReference, relatedTarget) || $3f69993268aa5b7a$var$contains(floating, relatedTarget) || $3f69993268aa5b7a$var$contains(relatedTarget, floating) || $3f69993268aa5b7a$var$contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute('data-floating-ui-focus-guard') || tree && ($3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).find((node)=>{
                var _node$context, _node$context2;
                return $3f69993268aa5b7a$var$contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || $3f69993268aa5b7a$var$contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
            }) || $3f69993268aa5b7a$var$getAncestors(tree.nodesRef.current, nodeId).find((node)=>{
                var _node$context3, _node$context4;
                return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
            })));
            // Focus did not move inside the floating tree, and there are no tabbable
            // portal guards to handle closing.
            if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
            relatedTarget !== previouslyFocusedElementRef.current) {
                preventReturnFocusRef.current = true;
                // On iOS VoiceOver, dismissing the nested submenu will cause the
                // first item of the list to receive focus. Delaying it appears to fix
                // the issue.
                setTimeout(()=>onOpenChange(false));
            }
        }
        if (floating && $3f69993268aa5b7a$var$isHTMLElement(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            !modal && floating.addEventListener('focusout', handleFocusOutside);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                !modal && floating.removeEventListener('focusout', handleFocusOutside);
            };
        }
    }, [
        domReference,
        floating,
        modal,
        nodeId,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut
    ]);
    $acw62.useEffect(()=>{
        var _portalContext$portal;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null ? void 0 : (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll('[data-floating-ui-portal]')) || []);
        function getDismissButtons() {
            return [
                startDismissButtonRef.current,
                endDismissButtonRef.current
            ].filter(Boolean);
        }
        if (floating && modal) {
            const insideNodes = [
                floating,
                ...portalNodes,
                ...getDismissButtons()
            ];
            const cleanup = (0, $6okVC.hideOthers)(orderRef.current.includes('reference') || isTypeableCombobox ? insideNodes.concat(domReference || []) : insideNodes);
            return ()=>{
                cleanup();
            };
        }
    }, [
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isTypeableCombobox
    ]);
    $acw62.useEffect(()=>{
        if (modal && !guards && floating) {
            const tabIndexValues = [];
            const options = $3f69993268aa5b7a$var$getTabbableOptions();
            const allTabbable = (0, $e8HHX.tabbable)($3f69993268aa5b7a$var$getDocument(floating).body, options);
            const floatingTabbable = getTabbableElements();
            // Exclude all tabbable elements that are part of the order
            const elements = allTabbable.filter((el)=>!floatingTabbable.includes(el));
            elements.forEach((el, i)=>{
                tabIndexValues[i] = el.getAttribute('tabindex');
                el.setAttribute('tabindex', '-1');
            });
            return ()=>{
                elements.forEach((el, i)=>{
                    const value = tabIndexValues[i];
                    if (value == null) el.removeAttribute('tabindex');
                    else el.setAttribute('tabindex', value);
                });
            };
        }
    }, [
        floating,
        modal,
        guards,
        getTabbableElements
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        let returnFocusValue = returnFocus;
        let preventReturnFocusScroll = false;
        const previouslyFocusedElement = $3f69993268aa5b7a$var$activeElement$1(doc);
        const contextData = dataRef.current;
        previouslyFocusedElementRef.current = previouslyFocusedElement;
        const focusableElements = getTabbableElements(floating);
        const elToFocus = (typeof initialFocus === 'number' ? focusableElements[initialFocus] : initialFocus.current) || floating;
        // If the `useListNavigation` hook is active, always ignore `initialFocus`
        // because it has its own handling of the initial focus.
        !ignoreInitialFocus && $3f69993268aa5b7a$var$enqueueFocus(elToFocus, {
            preventScroll: elToFocus === floating
        });
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onDismiss(payload) {
            if (payload.type === 'escapeKey' && refs.domReference.current) previouslyFocusedElementRef.current = refs.domReference.current;
            if ([
                'referencePress',
                'escapeKey'
            ].includes(payload.type)) return;
            const returnFocus = payload.data.returnFocus;
            if (typeof returnFocus === 'object') {
                returnFocusValue = true;
                preventReturnFocusScroll = returnFocus.preventScroll;
            } else returnFocusValue = returnFocus;
        }
        events.on('dismiss', onDismiss);
        return ()=>{
            events.off('dismiss', onDismiss);
            if ($3f69993268aa5b7a$var$contains(floating, $3f69993268aa5b7a$var$activeElement$1(doc)) && refs.domReference.current) previouslyFocusedElementRef.current = refs.domReference.current;
            if (returnFocusValue && $3f69993268aa5b7a$var$isHTMLElement(previouslyFocusedElementRef.current) && !preventReturnFocusRef.current) {
                // `isPointerDownRef.current` to avoid the focus ring from appearing on
                // the reference element when click-toggling it.
                if (!refs.domReference.current || isPointerDownRef.current) $3f69993268aa5b7a$var$enqueueFocus(previouslyFocusedElementRef.current, {
                    // When dismissing nested floating elements, by the time the rAF has
                    // executed, the menus will all have been unmounted. When they try
                    // to get focused, the calls get ignored — leaving the root
                    // reference focused as desired.
                    cancelPrevious: false,
                    preventScroll: preventReturnFocusScroll
                });
                else {
                    var _previouslyFocusedEle;
                    // If the user has specified a `keydown` listener that calls
                    // setOpen(false) (e.g. selecting an item and closing the floating
                    // element), then sync return focus causes `useClick` to immediately
                    // re-open it, unless they call `event.preventDefault()` in the
                    // `keydown` listener. This helps keep backwards compatibility with
                    // older examples.
                    contextData.__syncReturnFocus = true;
                    // In Safari, `useListNavigation` moves focus sync, so making this
                    // sync ensures the initial item remains focused despite this being
                    // invoked in Strict Mode due to double-invoked useEffects. This also
                    // has the positive side effect of closing a modally focus-managed
                    // <Menu> on `Tab` keydown to move naturally to the next focusable
                    // element.
                    (_previouslyFocusedEle = previouslyFocusedElementRef.current) == null || _previouslyFocusedEle.focus({
                        preventScroll: preventReturnFocusScroll
                    });
                    setTimeout(()=>{
                        // This isn't an actual property the user should access, make sure
                        // it doesn't persist.
                        delete contextData.__syncReturnFocus;
                    });
                }
            }
        };
    }, [
        floating,
        getTabbableElements,
        initialFocus,
        returnFocus,
        dataRef,
        refs,
        events,
        ignoreInitialFocus
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    $3f69993268aa5b7a$var$index(()=>{
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            ...context,
            modal: modal,
            closeOnFocusOut: closeOnFocusOut
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        portalContext,
        modal,
        closeOnFocusOut,
        context
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (ignoreInitialFocus || !floating) return;
        function setState() {
            setTabbableContentLength(getTabbableContent().length);
        }
        setState();
        if (typeof MutationObserver === 'function') {
            const observer = new MutationObserver(setState);
            observer.observe(floating, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        floating,
        getTabbableContent,
        ignoreInitialFocus,
        refs
    ]);
    const shouldRenderGuards = guards && (isInsidePortal || modal) && !isTypeableCombobox;
    function renderDismissButton(location) {
        return visuallyHiddenDismiss && modal ? /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: ()=>onOpenChange(false)
        }, typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss') : null;
    }
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
        onFocus: (event)=>{
            if (modal) {
                const els = getTabbableElements();
                $3f69993268aa5b7a$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
            } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = false;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const nextTabbable = $3f69993268aa5b7a$var$getNextTabbable() || domReference;
                    nextTabbable == null || nextTabbable.focus();
                } else {
                    var _portalContext$before;
                    (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                }
            }
        }
    }), isTypeableCombobox ? null : renderDismissButton('start'), /*#__PURE__*/ $acw62.cloneElement(children, tabbableContentLength === 0 || order.includes('floating') ? {
        tabIndex: 0
    } : {}), renderDismissButton('end'), shouldRenderGuards && /*#__PURE__*/ $acw62.createElement($3f69993268aa5b7a$var$FocusGuard, {
        "data-type": "inside",
        ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
        onFocus: (event)=>{
            if (modal) $3f69993268aa5b7a$var$enqueueFocus(getTabbableElements()[0]);
            else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                preventReturnFocusRef.current = true;
                if ($3f69993268aa5b7a$var$isOutsideEvent(event, portalContext.portalNode)) {
                    const prevTabbable = $3f69993268aa5b7a$var$getPreviousTabbable() || domReference;
                    prevTabbable == null || prevTabbable.focus();
                } else {
                    var _portalContext$afterO;
                    (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                }
            }
        }
    }));
}
const $3f69993268aa5b7a$var$identifier = 'data-floating-ui-scroll-lock';
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $3f69993268aa5b7a$export$a35954495955337b = /*#__PURE__*/ $acw62.forwardRef(function FloatingOverlay(_ref, ref) {
    let { lockScroll: lockScroll = false, ...rest } = _ref;
    $3f69993268aa5b7a$var$index(()=>{
        var _window$visualViewpor, _window$visualViewpor2;
        if (!lockScroll) return;
        const alreadyLocked = document.body.hasAttribute($3f69993268aa5b7a$var$identifier);
        if (alreadyLocked) return;
        document.body.setAttribute($3f69993268aa5b7a$var$identifier, '');
        // RTL <body> scrollbar
        const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
        const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        // Only iOS doesn't respect `overflow: hidden` on document.body, and this
        // technique has fewer side effects.
        if (!/iP(hone|ad|od)|iOS/.test($3f69993268aa5b7a$var$getPlatform())) {
            Object.assign(document.body.style, {
                overflow: 'hidden',
                [paddingProp]: scrollbarWidth + "px"
            });
            return ()=>{
                document.body.removeAttribute($3f69993268aa5b7a$var$identifier);
                Object.assign(document.body.style, {
                    overflow: '',
                    [paddingProp]: ''
                });
            };
        }
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        const scrollX = window.pageXOffset;
        const scrollY = window.pageYOffset;
        Object.assign(document.body.style, {
            position: 'fixed',
            overflow: 'hidden',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0',
            [paddingProp]: scrollbarWidth + "px"
        });
        return ()=>{
            Object.assign(document.body.style, {
                position: '',
                overflow: '',
                top: '',
                left: '',
                right: '',
                [paddingProp]: ''
            });
            document.body.removeAttribute($3f69993268aa5b7a$var$identifier);
            window.scrollTo(scrollX, scrollY);
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ $acw62.createElement("div", $3f69993268aa5b7a$var$_extends({
        ref: ref
    }, rest, {
        style: {
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...rest.style
        }
    }));
});
function $3f69993268aa5b7a$var$isButtonTarget(event) {
    return $3f69993268aa5b7a$var$isHTMLElement(event.target) && event.target.tagName === 'BUTTON';
}
function $3f69993268aa5b7a$var$isSpaceIgnored(element) {
    return $3f69993268aa5b7a$var$isTypeableElement(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ const $3f69993268aa5b7a$export$98524f11226063fc = function(_ref, _temp) {
    let { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = _ref;
    let { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true } = _temp === void 0 ? {} : _temp;
    const pointerTypeRef = $acw62.useRef();
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (event) {
                    pointerTypeRef.current = event.pointerType;
                },
                onMouseDown (event) {
                    // Ignore all buttons except for the "main" button.
                    // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                    if (event.button !== 0) return;
                    if ($3f69993268aa5b7a$var$isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (eventOption === 'click') return;
                    if (open) {
                        if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false);
                    } else {
                        // Prevent stealing focus from the floating element
                        event.preventDefault();
                        onOpenChange(true);
                    }
                    dataRef.current.openEvent = event.nativeEvent;
                },
                onClick (event) {
                    if (dataRef.current.__syncReturnFocus) return;
                    if (eventOption === 'mousedown' && pointerTypeRef.current) {
                        pointerTypeRef.current = undefined;
                        return;
                    }
                    if ($3f69993268aa5b7a$var$isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) return;
                    if (open) {
                        if (toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false);
                    } else onOpenChange(true);
                    dataRef.current.openEvent = event.nativeEvent;
                },
                onKeyDown (event) {
                    pointerTypeRef.current = undefined;
                    if (!keyboardHandlers) return;
                    if ($3f69993268aa5b7a$var$isButtonTarget(event)) return;
                    if (event.key === ' ' && !$3f69993268aa5b7a$var$isSpaceIgnored(domReference)) // Prevent scrolling
                    event.preventDefault();
                    if (event.key === 'Enter') {
                        if (open) {
                            if (toggle) onOpenChange(false);
                        } else onOpenChange(true);
                    }
                },
                onKeyUp (event) {
                    if (!keyboardHandlers) return;
                    if ($3f69993268aa5b7a$var$isButtonTarget(event) || $3f69993268aa5b7a$var$isSpaceIgnored(domReference)) return;
                    if (event.key === ' ') {
                        if (open) {
                            if (toggle) onOpenChange(false);
                        } else onOpenChange(true);
                    }
                }
            }
        };
    }, [
        enabled,
        dataRef,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        domReference,
        toggle,
        open,
        onOpenChange
    ]);
};
/**
 * Check whether the event.target is within the provided node. Uses event.composedPath if available for custom element support.
 *
 * @param event The event whose target/composedPath to check
 * @param node The node to check against
 * @returns Whether the event.target/composedPath is within the node.
 */ function $3f69993268aa5b7a$var$isEventTargetWithin(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
const $3f69993268aa5b7a$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $3f69993268aa5b7a$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $3f69993268aa5b7a$var$normalizeBubblesProp = function(bubbles) {
    var _bubbles$escapeKey, _bubbles$outsidePress;
    if (bubbles === void 0) bubbles = true;
    return {
        escapeKeyBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$escapeKey = bubbles.escapeKey) != null ? _bubbles$escapeKey : true,
        outsidePressBubbles: typeof bubbles === 'boolean' ? bubbles : (_bubbles$outsidePress = bubbles.outsidePress) != null ? _bubbles$outsidePress : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ const $3f69993268aa5b7a$export$fcdf1ba5fafc089b = function(_ref, _temp) {
    let { open: open, onOpenChange: onOpenChange, events: events, nodeId: nodeId, elements: { reference: reference, domReference: domReference, floating: floating }, dataRef: dataRef } = _ref;
    let { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles = true } = _temp === void 0 ? {} : _temp;
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const nested = $3f69993268aa5b7a$export$165209eae06d3488() != null;
    const outsidePressFn = $3f69993268aa5b7a$var$useEvent(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const insideReactTreeRef = $acw62.useRef(false);
    const { escapeKeyBubbles: escapeKeyBubbles, outsidePressBubbles: outsidePressBubbles } = $3f69993268aa5b7a$var$normalizeBubblesProp(bubbles);
    $acw62.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        function onKeyDown(event) {
            if (event.key === 'Escape') {
                const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
                if (children.length > 0) {
                    let shouldDismiss = true;
                    children.forEach((child)=>{
                        var _child$context;
                        if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                            shouldDismiss = false;
                            return;
                        }
                    });
                    if (!shouldDismiss) return;
                }
                events.emit('dismiss', {
                    type: 'escapeKey',
                    data: {
                        returnFocus: {
                            preventScroll: false
                        }
                    }
                });
                onOpenChange(false);
            }
        }
        function onOutsidePress(event) {
            // Given developers can stop the propagation of the synthetic event,
            // we can only be confident with a positive value.
            const insideReactTree = insideReactTreeRef.current;
            insideReactTreeRef.current = false;
            if (insideReactTree) return;
            if (typeof outsidePress === 'function' && !outsidePress(event)) return;
            const target = $3f69993268aa5b7a$var$getTarget(event);
            // Check if the click occurred on the scrollbar
            if ($3f69993268aa5b7a$var$isHTMLElement(target) && floating) {
                const win = floating.ownerDocument.defaultView || window;
                const canScrollX = target.scrollWidth > target.clientWidth;
                const canScrollY = target.scrollHeight > target.clientHeight;
                let xCond = canScrollY && event.offsetX > target.clientWidth;
                // In some browsers it is possible to change the <body> (or window)
                // scrollbar to the left side, but is very rare and is difficult to
                // check for. Plus, for modal dialogs with backdrops, it is more
                // important that the backdrop is checked but not so much the window.
                if (canScrollY) {
                    const isRTL = win.getComputedStyle(target).direction === 'rtl';
                    if (isRTL) xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
                }
                if (xCond || canScrollX && event.offsetY > target.clientHeight) return;
            }
            const targetIsInsideChildren = tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((node)=>{
                var _node$context;
                return $3f69993268aa5b7a$var$isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
            });
            if ($3f69993268aa5b7a$var$isEventTargetWithin(event, floating) || $3f69993268aa5b7a$var$isEventTargetWithin(event, domReference) || targetIsInsideChildren) return;
            const children = tree ? $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId) : [];
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context2;
                    if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
            events.emit('dismiss', {
                type: 'outsidePress',
                data: {
                    returnFocus: nested ? {
                        preventScroll: true
                    } : $3f69993268aa5b7a$var$isVirtualClick(event) || $3f69993268aa5b7a$var$isVirtualPointerEvent(event)
                }
            });
            onOpenChange(false);
        }
        function onScroll() {
            onOpenChange(false);
        }
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        escapeKey && doc.addEventListener('keydown', onKeyDown);
        outsidePress && doc.addEventListener(outsidePressEvent, onOutsidePress);
        let ancestors = [];
        if (ancestorScroll) {
            if ($3f69993268aa5b7a$var$isElement(domReference)) ancestors = (0, $33bLr.getOverflowAncestors)(domReference);
            if ($3f69993268aa5b7a$var$isElement(floating)) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(floating));
            if (!$3f69993268aa5b7a$var$isElement(reference) && reference && reference.contextElement) ancestors = ancestors.concat((0, $33bLr.getOverflowAncestors)(reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            escapeKey && doc.removeEventListener('keydown', onKeyDown);
            outsidePress && doc.removeEventListener(outsidePressEvent, onOutsidePress);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
        };
    }, [
        dataRef,
        floating,
        domReference,
        reference,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        events,
        tree,
        nodeId,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        nested
    ]);
    $acw62.useEffect(()=>{
        insideReactTreeRef.current = false;
    }, [
        outsidePress,
        outsidePressEvent
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                [$3f69993268aa5b7a$var$bubbleHandlerKeys[referencePressEvent]]: ()=>{
                    if (referencePress) {
                        events.emit('dismiss', {
                            type: 'referencePress',
                            data: {
                                returnFocus: false
                            }
                        });
                        onOpenChange(false);
                    }
                }
            },
            floating: {
                [$3f69993268aa5b7a$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                    insideReactTreeRef.current = true;
                }
            }
        };
    }, [
        enabled,
        events,
        referencePress,
        outsidePressEvent,
        referencePressEvent,
        onOpenChange
    ]);
};
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ const $3f69993268aa5b7a$export$f8168d8dd8fd66e6 = function(_ref, _temp) {
    let { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, refs: refs, elements: { floating: floating, domReference: domReference } } = _ref;
    let { enabled: enabled = true, keyboardOnly: keyboardOnly = true } = _temp === void 0 ? {} : _temp;
    const pointerTypeRef = $acw62.useRef('');
    const blockFocusRef = $acw62.useRef(false);
    const timeoutRef = $acw62.useRef();
    $acw62.useEffect(()=>{
        if (!enabled) return;
        const doc = $3f69993268aa5b7a$var$getDocument(floating);
        const win = doc.defaultView || window;
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && $3f69993268aa5b7a$var$isHTMLElement(domReference) && domReference === $3f69993268aa5b7a$var$activeElement$1($3f69993268aa5b7a$var$getDocument(domReference))) blockFocusRef.current = true;
        }
        win.addEventListener('blur', onBlur);
        return ()=>{
            win.removeEventListener('blur', onBlur);
        };
    }, [
        floating,
        domReference,
        open,
        enabled
    ]);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onDismiss(payload) {
            if (payload.type === 'referencePress' || payload.type === 'escapeKey') blockFocusRef.current = true;
        }
        events.on('dismiss', onDismiss);
        return ()=>{
            events.off('dismiss', onDismiss);
        };
    }, [
        events,
        enabled
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(timeoutRef.current);
        };
    }, []);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            reference: {
                onPointerDown (_ref2) {
                    let { pointerType: pointerType } = _ref2;
                    pointerTypeRef.current = pointerType;
                    blockFocusRef.current = !!(pointerType && keyboardOnly);
                },
                onMouseLeave () {
                    blockFocusRef.current = false;
                },
                onFocus (event) {
                    var _dataRef$current$open;
                    if (blockFocusRef.current) return;
                    // Dismiss with click should ignore the subsequent `focus` trigger,
                    // but only if the click originated inside the reference element.
                    if (event.type === 'focus' && ((_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type) === 'mousedown' && dataRef.current.openEvent && $3f69993268aa5b7a$var$isEventTargetWithin(dataRef.current.openEvent, domReference)) return;
                    dataRef.current.openEvent = event.nativeEvent;
                    onOpenChange(true);
                },
                onBlur (event) {
                    blockFocusRef.current = false;
                    const relatedTarget = event.relatedTarget;
                    // Hit the non-modal focus management portal guard. Focus will be
                    // moved into the floating element immediately after.
                    const movedToFocusGuard = $3f69993268aa5b7a$var$isElement(relatedTarget) && relatedTarget.hasAttribute('data-floating-ui-focus-guard') && relatedTarget.getAttribute('data-type') === 'outside';
                    // Wait for the window blur listener to fire.
                    timeoutRef.current = setTimeout(()=>{
                        // When focusing the reference element (e.g. regular click), then
                        // clicking into the floating element, prevent it from hiding.
                        // Note: it must be focusable, e.g. `tabindex="-1"`.
                        if ($3f69993268aa5b7a$var$contains(refs.floating.current, relatedTarget) || $3f69993268aa5b7a$var$contains(domReference, relatedTarget) || movedToFocusGuard) return;
                        onOpenChange(false);
                    });
                }
            }
        };
    }, [
        enabled,
        keyboardOnly,
        domReference,
        refs,
        dataRef,
        onOpenChange
    ]);
};
let $3f69993268aa5b7a$var$isPreventScrollSupported = false;
const $3f69993268aa5b7a$var$ARROW_UP = 'ArrowUp';
const $3f69993268aa5b7a$var$ARROW_DOWN = 'ArrowDown';
const $3f69993268aa5b7a$var$ARROW_LEFT = 'ArrowLeft';
const $3f69993268aa5b7a$var$ARROW_RIGHT = 'ArrowRight';
function $3f69993268aa5b7a$var$isDifferentRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    const list = listRef.current;
    let index = startingIndex;
    do {
        var _list$index, _list$index2;
        index = index + (decrement ? -amount : amount);
    }while (index >= 0 && index <= list.length - 1 && (disabledIndices ? disabledIndices.includes(index) : list[index] == null || ((_list$index = list[index]) == null ? void 0 : _list$index.hasAttribute('disabled')) || ((_list$index2 = list[index]) == null ? void 0 : _list$index2.getAttribute('aria-disabled')) === 'true'));
    return index;
}
function $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $3f69993268aa5b7a$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_UP || key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_LEFT || key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    const horizontal = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key == ' ' || key === '';
}
function $3f69993268aa5b7a$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_LEFT : key === $3f69993268aa5b7a$var$ARROW_RIGHT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_DOWN;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$isCrossOrientationCloseKey(key, orientation, rtl) {
    const vertical = rtl ? key === $3f69993268aa5b7a$var$ARROW_RIGHT : key === $3f69993268aa5b7a$var$ARROW_LEFT;
    const horizontal = key === $3f69993268aa5b7a$var$ARROW_UP;
    return $3f69993268aa5b7a$var$doSwitch(orientation, vertical, horizontal);
}
function $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        disabledIndices: disabledIndices
    });
}
function $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices) {
    return $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ const $3f69993268aa5b7a$export$b5d22cac4ad33f40 = function(_ref, _temp2) {
    let { open: open, onOpenChange: onOpenChange, refs: refs, elements: { domReference: domReference } } = _ref;
    let { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true } = _temp2 === void 0 ? {
        listRef: {
            current: []
        },
        activeIndex: null,
        onNavigate: ()=>{}
    } : _temp2;
    const parentId = $3f69993268aa5b7a$export$165209eae06d3488();
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const onNavigate = $3f69993268aa5b7a$var$useEvent(unstable_onNavigate);
    const focusItemOnOpenRef = $acw62.useRef(focusItemOnOpen);
    const indexRef = $acw62.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $acw62.useRef(null);
    const isPointerModalityRef = $acw62.useRef(true);
    const previousOnNavigateRef = $acw62.useRef(onNavigate);
    const previousOpenRef = $acw62.useRef(open);
    const forceSyncFocus = $acw62.useRef(false);
    const forceScrollIntoViewRef = $acw62.useRef(false);
    const disabledIndicesRef = $3f69993268aa5b7a$var$useLatestRef(disabledIndices);
    const latestOpenRef = $3f69993268aa5b7a$var$useLatestRef(open);
    const scrollItemIntoViewRef = $3f69993268aa5b7a$var$useLatestRef(scrollItemIntoView);
    const [activeId, setActiveId] = $acw62.useState();
    const focusItem = $acw62.useCallback(function(listRef, indexRef, forceScrollIntoView) {
        if (forceScrollIntoView === void 0) forceScrollIntoView = false;
        const item = listRef.current[indexRef.current];
        if (virtual) setActiveId(item == null ? void 0 : item.id);
        else $3f69993268aa5b7a$var$enqueueFocus(item, {
            preventScroll: true,
            // Mac Safari does not move the virtual cursor unless the focus call
            // is sync. However, for the very first focus call, we need to wait
            // for the position to be ready in order to prevent unwanted
            // scrolling. This means the virtual cursor will not move to the first
            // item when first opening the floating element, but will on
            // subsequent calls. `preventScroll` is supported in modern Safari,
            // so we can use that instead.
            // iOS Safari must be async or the first item will not be focused.
            sync: $3f69993268aa5b7a$var$isMac() && $3f69993268aa5b7a$var$isSafari() ? $3f69993268aa5b7a$var$isPreventScrollSupported || forceSyncFocus.current : false
        });
        requestAnimationFrame(()=>{
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            item.scrollIntoView == null || item.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    }, [
        virtual,
        scrollItemIntoViewRef
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        document.createElement('div').focus({
            get preventScroll () {
                $3f69993268aa5b7a$var$isPreventScrollSupported = true;
                return false;
            }
        });
    }, []);
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                onNavigate(selectedIndex);
            }
        } else if (previousOpenRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current(null);
        }
    }, [
        enabled,
        open,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (open) {
            if (activeIndex == null) {
                forceSyncFocus.current = false;
                if (selectedIndex != null) return;
                // Reset while the floating element was open (e.g. the list changed).
                if (previousOpenRef.current) {
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                }
                // Initial sync.
                if (!previousOpenRef.current && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                    indexRef.current = keyRef.current == null || $3f69993268aa5b7a$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndicesRef.current) : $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndicesRef.current);
                    onNavigate(indexRef.current);
                }
            } else if (!$3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, activeIndex)) {
                indexRef.current = activeIndex;
                focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
                forceScrollIntoViewRef.current = false;
            }
        }
    }, [
        enabled,
        open,
        activeIndex,
        selectedIndex,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    $3f69993268aa5b7a$var$index(()=>{
        if (!enabled) return;
        if (previousOpenRef.current && !open) {
            var _tree$nodesRef$curren, _tree$nodesRef$curren2;
            const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
            if (parentFloating && !$3f69993268aa5b7a$var$contains(parentFloating, $3f69993268aa5b7a$var$activeElement$1($3f69993268aa5b7a$var$getDocument(parentFloating)))) parentFloating.focus({
                preventScroll: true
            });
        }
    }, [
        enabled,
        open,
        tree,
        parentId
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        keyRef.current = null;
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
    });
    const hasActiveIndex = activeIndex != null;
    const item = $acw62.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!open) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1) onNavigate(index);
        }
        const props = {
            onFocus (_ref2) {
                let { currentTarget: currentTarget } = _ref2;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref3)=>{
                let { currentTarget: currentTarget } = _ref3;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            ...focusItemOnHover && {
                onMouseMove (_ref4) {
                    let { currentTarget: currentTarget } = _ref4;
                    syncCurrentTarget(currentTarget);
                },
                onPointerLeave () {
                    if (!isPointerModalityRef.current) return;
                    indexRef.current = -1;
                    focusItem(listRef, indexRef);
                    // Virtual cursor with VoiceOver on iOS needs this to be flushed
                    // synchronously or there is a glitch that prevents nested
                    // submenus from being accessible.
                    (0, $1u0KT.flushSync)(()=>onNavigate(null));
                    if (!virtual) {
                        var _refs$floating$curren;
                        // This also needs to be sync to prevent fast mouse movements
                        // from leaving behind a stale active item when landing on a
                        // disabled button item.
                        (_refs$floating$curren = refs.floating.current) == null || _refs$floating$curren.focus({
                            preventScroll: true
                        });
                    }
                }
            }
        };
        return props;
    }, [
        open,
        refs,
        focusItem,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        const disabledIndices = disabledIndicesRef.current;
        function onKeyDown(event) {
            isPointerModalityRef.current = false;
            forceSyncFocus.current = true;
            // If the floating element is animating out, ignore navigation. Otherwise,
            // the `activeIndex` gets set to 0 despite not being open so the next time
            // the user ArrowDowns, the first item won't be focused.
            if (!latestOpenRef.current && event.currentTarget === refs.floating.current) return;
            if (nested && $3f69993268aa5b7a$var$isCrossOrientationCloseKey(event.key, orientation, rtl)) {
                $3f69993268aa5b7a$var$stopEvent(event);
                onOpenChange(false);
                if ($3f69993268aa5b7a$var$isHTMLElement(domReference)) domReference.focus();
                return;
            }
            const currentIndex = indexRef.current;
            const minIndex = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
            const maxIndex = $3f69993268aa5b7a$var$getMaxIndex(listRef, disabledIndices);
            if (event.key === 'Home') {
                indexRef.current = minIndex;
                onNavigate(indexRef.current);
            }
            if (event.key === 'End') {
                indexRef.current = maxIndex;
                onNavigate(indexRef.current);
            }
            // Grid navigation.
            if (cols > 1) {
                const prevIndex = indexRef.current;
                if (event.key === $3f69993268aa5b7a$var$ARROW_UP) {
                    $3f69993268aa5b7a$var$stopEvent(event);
                    if (prevIndex === -1) indexRef.current = maxIndex;
                    else {
                        indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex,
                            amount: cols,
                            decrement: true,
                            disabledIndices: disabledIndices
                        });
                        if (loop && (prevIndex - cols < minIndex || indexRef.current < 0)) {
                            const col = prevIndex % cols;
                            const maxCol = maxIndex % cols;
                            const offset = maxIndex - (maxCol - col);
                            if (maxCol === col) indexRef.current = maxIndex;
                            else indexRef.current = maxCol > col ? offset : offset - cols;
                        }
                    }
                    if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = prevIndex;
                    onNavigate(indexRef.current);
                }
                if (event.key === $3f69993268aa5b7a$var$ARROW_DOWN) {
                    $3f69993268aa5b7a$var$stopEvent(event);
                    if (prevIndex === -1) indexRef.current = minIndex;
                    else {
                        indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex,
                            amount: cols,
                            disabledIndices: disabledIndices
                        });
                        if (loop && prevIndex + cols > maxIndex) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex % cols - cols,
                            amount: cols,
                            disabledIndices: disabledIndices
                        });
                    }
                    if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) indexRef.current = prevIndex;
                    onNavigate(indexRef.current);
                }
                // Remains on the same row/column.
                if (orientation === 'both') {
                    const prevRow = Math.floor(prevIndex / cols);
                    if (event.key === $3f69993268aa5b7a$var$ARROW_RIGHT) {
                        $3f69993268aa5b7a$var$stopEvent(event);
                        if (prevIndex % cols !== cols - 1) {
                            indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex,
                                disabledIndices: disabledIndices
                            });
                            if (loop && $3f69993268aa5b7a$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex - prevIndex % cols - 1,
                                disabledIndices: disabledIndices
                            });
                        } else if (loop) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex - prevIndex % cols - 1,
                            disabledIndices: disabledIndices
                        });
                        if ($3f69993268aa5b7a$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = prevIndex;
                    }
                    if (event.key === $3f69993268aa5b7a$var$ARROW_LEFT) {
                        $3f69993268aa5b7a$var$stopEvent(event);
                        if (prevIndex % cols !== 0) {
                            indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex,
                                disabledIndices: disabledIndices,
                                decrement: true
                            });
                            if (loop && $3f69993268aa5b7a$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                                startingIndex: prevIndex + (cols - prevIndex % cols),
                                decrement: true,
                                disabledIndices: disabledIndices
                            });
                        } else if (loop) indexRef.current = $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex + (cols - prevIndex % cols),
                            decrement: true,
                            disabledIndices: disabledIndices
                        });
                        if ($3f69993268aa5b7a$var$isDifferentRow(indexRef.current, cols, prevRow)) indexRef.current = prevIndex;
                    }
                    const lastRow = Math.floor(maxIndex / cols) === prevRow;
                    if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) {
                        if (loop && lastRow) indexRef.current = event.key === $3f69993268aa5b7a$var$ARROW_LEFT ? maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                            startingIndex: prevIndex - prevIndex % cols - 1,
                            disabledIndices: disabledIndices
                        });
                        else indexRef.current = prevIndex;
                    }
                    onNavigate(indexRef.current);
                    return;
                }
            }
            if ($3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation)) {
                $3f69993268aa5b7a$var$stopEvent(event);
                // Reset the index if no item is focused.
                if (open && !virtual && $3f69993268aa5b7a$var$activeElement$1(event.currentTarget.ownerDocument) === event.currentTarget) {
                    indexRef.current = $3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                    onNavigate(indexRef.current);
                    return;
                }
                if ($3f69993268aa5b7a$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                    if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    });
                    else indexRef.current = Math.min(maxIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                        startingIndex: currentIndex,
                        disabledIndices: disabledIndices
                    }));
                } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.max(minIndex, $3f69993268aa5b7a$var$findNonDisabledIndex(listRef, {
                    startingIndex: currentIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                }));
                if ($3f69993268aa5b7a$var$isIndexOutOfBounds(listRef, indexRef.current)) onNavigate(null);
                else onNavigate(indexRef.current);
            }
        }
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && $3f69993268aa5b7a$var$isVirtualClick(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && $3f69993268aa5b7a$var$isVirtualPointerEvent(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        const ariaActiveDescendantProp = virtual && open && hasActiveIndex && {
            'aria-activedescendant': activeId
        };
        return {
            reference: {
                ...ariaActiveDescendantProp,
                onKeyDown (event) {
                    isPointerModalityRef.current = false;
                    const isArrowKey = event.key.indexOf('Arrow') === 0;
                    if (virtual && open) return onKeyDown(event);
                    // If a floating element should not open on arrow key down, avoid
                    // setting `activeIndex` while it's closed.
                    if (!open && !openOnArrowKeyDown && isArrowKey) return;
                    const isNavigationKey = isArrowKey || event.key === 'Enter' || event.key === ' ' || event.key === '';
                    if (isNavigationKey) keyRef.current = event.key;
                    if (nested) {
                        if ($3f69993268aa5b7a$var$isCrossOrientationOpenKey(event.key, orientation, rtl)) {
                            $3f69993268aa5b7a$var$stopEvent(event);
                            if (open) {
                                indexRef.current = $3f69993268aa5b7a$var$getMinIndex(listRef, disabledIndices);
                                onNavigate(indexRef.current);
                            } else onOpenChange(true);
                        }
                        return;
                    }
                    if ($3f69993268aa5b7a$var$isMainOrientationKey(event.key, orientation)) {
                        if (selectedIndex != null) indexRef.current = selectedIndex;
                        $3f69993268aa5b7a$var$stopEvent(event);
                        if (!open && openOnArrowKeyDown) onOpenChange(true);
                        else onKeyDown(event);
                        if (open) onNavigate(indexRef.current);
                    }
                },
                onFocus () {
                    if (open) onNavigate(null);
                },
                onPointerDown: checkVirtualPointer,
                onMouseDown: checkVirtualMouse,
                onClick: checkVirtualMouse
            },
            floating: {
                'aria-orientation': orientation === 'both' ? undefined : orientation,
                ...ariaActiveDescendantProp,
                onKeyDown: onKeyDown,
                onPointerMove () {
                    isPointerModalityRef.current = true;
                }
            },
            item: item
        };
    }, [
        domReference,
        refs,
        activeId,
        disabledIndicesRef,
        latestOpenRef,
        listRef,
        enabled,
        orientation,
        rtl,
        virtual,
        open,
        hasActiveIndex,
        nested,
        selectedIndex,
        openOnArrowKeyDown,
        allowEscape,
        cols,
        loop,
        focusItemOnOpen,
        onNavigate,
        onOpenChange,
        item
    ]);
};
/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/useMergeRefs
 */ function $3f69993268aa5b7a$export$74665b213cb5c4cf(refs) {
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ const $3f69993268aa5b7a$export$f66572793fa256a1 = function(_ref, _temp) {
    let { open: open } = _ref;
    let { enabled: enabled = true, role: role = 'dialog' } = _temp === void 0 ? {} : _temp;
    const rootId = $3f69993268aa5b7a$export$f680877a34711e37();
    const referenceId = $3f69993268aa5b7a$export$f680877a34711e37();
    return $acw62.useMemo(()=>{
        const floatingProps = {
            id: rootId,
            role: role
        };
        if (!enabled) return {};
        if (role === 'tooltip') return {
            reference: {
                'aria-describedby': open ? rootId : undefined
            },
            floating: floatingProps
        };
        return {
            reference: {
                'aria-expanded': open ? 'true' : 'false',
                'aria-haspopup': role === 'alertdialog' ? 'dialog' : role,
                'aria-controls': open ? rootId : undefined,
                ...role === 'listbox' && {
                    role: 'combobox'
                },
                ...role === 'menu' && {
                    id: referenceId
                }
            },
            floating: {
                ...floatingProps,
                ...role === 'menu' && {
                    'aria-labelledby': referenceId
                }
            }
        };
    }, [
        enabled,
        role,
        open,
        rootId,
        referenceId
    ]);
};
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $3f69993268aa5b7a$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $3f69993268aa5b7a$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $acw62.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $acw62.useEffect(()=>{
        if (!open) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $3f69993268aa5b7a$export$b2ef21706733f7e5(_ref, _temp) {
    let { open: open, elements: { floating: floating } } = _ref;
    let { duration: duration = 250 } = _temp === void 0 ? {} : _temp;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [initiated, setInitiated] = $acw62.useState(false);
    const [status, setStatus] = $acw62.useState('unmounted');
    const isMounted = $3f69993268aa5b7a$var$useDelayUnmount(open, closeDuration);
    // `initiated` check prevents this `setState` call from breaking
    // <FloatingPortal />. This call is necessary to ensure subsequent opens
    // after the initial one allows the correct side animation to play when the
    // placement has changed.
    $3f69993268aa5b7a$var$index(()=>{
        if (initiated && !isMounted) setStatus('unmounted');
    }, [
        initiated,
        isMounted
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                setStatus('open');
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        } else {
            setInitiated(true);
            setStatus('close');
        }
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $3f69993268aa5b7a$export$769fba13884bc2f4(context, _temp2) {
    let { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = _temp2 === void 0 ? {} : _temp2;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const [styles, setStyles] = $acw62.useState({});
    const { isMounted: isMounted, status: status } = $3f69993268aa5b7a$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = $3f69993268aa5b7a$var$useLatestRef(unstable_initial);
    const openRef = $3f69993268aa5b7a$var$useLatestRef(unstable_open);
    const closeRef = $3f69993268aa5b7a$var$useLatestRef(unstable_close);
    const commonRef = $3f69993268aa5b7a$var$useLatestRef(unstable_common);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    $3f69993268aa5b7a$var$index(()=>{
        const fnArgs = {
            side: side,
            placement: placement
        };
        const initial = initialRef.current;
        const close = closeRef.current;
        const open = openRef.current;
        const common = commonRef.current;
        const initialStyles = typeof initial === 'function' ? initial(fnArgs) : initial;
        const closeStyles = typeof close === 'function' ? close(fnArgs) : close;
        const commonStyles = typeof common === 'function' ? common(fnArgs) : common;
        const openStyles = (typeof open === 'function' ? open(fnArgs) : open) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial' || status === 'unmounted') setStyles((styles)=>({
                transitionProperty: styles.transitionProperty,
                ...commonStyles,
                ...initialStyles
            }));
        if (status === 'open') setStyles({
            transitionProperty: Object.keys(openStyles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms",
            ...commonStyles,
            ...openStyles
        });
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles({
                transitionProperty: Object.keys(styles).map($3f69993268aa5b7a$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms",
                ...commonStyles,
                ...styles
            });
        }
    }, [
        side,
        placement,
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ const $3f69993268aa5b7a$export$d8d674d50b73ba93 = function(_ref, _temp) {
    var _ref2;
    let { open: open, dataRef: dataRef, refs: refs } = _ref;
    let { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch = ()=>{}, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 1000, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = _temp === void 0 ? {
        listRef: {
            current: []
        },
        activeIndex: null
    } : _temp;
    const timeoutIdRef = $acw62.useRef();
    const stringRef = $acw62.useRef('');
    const prevIndexRef = $acw62.useRef((_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1);
    const matchIndexRef = $acw62.useRef(null);
    const onMatch = $3f69993268aa5b7a$var$useEvent(unstable_onMatch);
    const findMatchRef = $3f69993268aa5b7a$var$useLatestRef(findMatch);
    const ignoreKeysRef = $3f69993268aa5b7a$var$useLatestRef(ignoreKeys);
    $3f69993268aa5b7a$var$index(()=>{
        if (open) {
            clearTimeout(timeoutIdRef.current);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref3;
            prevIndexRef.current = (_ref3 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref3 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        function onKeyDown(event) {
            var _refs$floating$curren;
            // Correctly scope nested non-portalled floating elements. Since the nested
            // floating element is inside of the another, we find the closest role
            // that indicates the floating element scope.
            const target = $3f69993268aa5b7a$var$getTarget(event.nativeEvent);
            if ($3f69993268aa5b7a$var$isElement(target) && ($3f69993268aa5b7a$var$activeElement$1($3f69993268aa5b7a$var$getDocument(target)) !== event.currentTarget ? (_refs$floating$curren = refs.floating.current) != null && _refs$floating$curren.contains(target) ? target.closest('[role="dialog"],[role="menu"],[role="listbox"],[role="tree"],[role="grid"]') !== event.currentTarget : false : !event.currentTarget.contains(target))) return;
            if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
                dataRef.current.typing = true;
                if (event.key === ' ') $3f69993268aa5b7a$var$stopEvent(event);
            }
            const listContent = listRef.current;
            if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
            event.key.length !== 1 || // Modifier key.
            event.ctrlKey || event.metaKey || event.altKey) return;
            // Bail out if the list contains a word like "llama" or "aaron". TODO:
            // allow it in this case, too.
            const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
                var _text$, _text$2;
                return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
            });
            // Allows the user to cycle through items that start with the same letter
            // in rapid succession.
            if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
                stringRef.current = '';
                prevIndexRef.current = matchIndexRef.current;
            }
            stringRef.current += event.key;
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = setTimeout(()=>{
                stringRef.current = '';
                prevIndexRef.current = matchIndexRef.current;
                dataRef.current.typing = false;
            }, resetMs);
            const prevIndex = prevIndexRef.current;
            const orderedList = [
                ...listContent.slice((prevIndex || 0) + 1),
                ...listContent.slice(0, (prevIndex || 0) + 1)
            ];
            const str = findMatchRef.current ? findMatchRef.current(orderedList, stringRef.current) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(stringRef.current.toLocaleLowerCase())) === 0);
            const index = str ? listContent.indexOf(str) : -1;
            if (index !== -1) {
                onMatch(index);
                matchIndexRef.current = index;
            }
        }
        return {
            reference: {
                onKeyDown: onKeyDown
            },
            floating: {
                onKeyDown: onKeyDown
            }
        };
    }, [
        enabled,
        dataRef,
        listRef,
        resetMs,
        ignoreKeysRef,
        findMatchRef,
        onMatch,
        refs
    ]);
};
function $3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(state, height) {
    return {
        ...state,
        rects: {
            ...state.rects,
            floating: {
                ...state.rects.floating,
                height: height
            }
        }
    };
}
/**
 * Positions the floating element such that an inner element inside
 * of it is anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 */ const $3f69993268aa5b7a$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef, ...detectOverflowOptions } = props;
            const { rects: rects, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            if (!item) return {};
            const nextArgs = {
                ...state,
                ...await (0, $618j3.offset)(-item.offsetTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state)
            };
            const el = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            const overflow = await (0, $618j3.detectOverflow)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight(nextArgs, el.scrollHeight), detectOverflowOptions);
            const refOverflow = await (0, $618j3.detectOverflow)(nextArgs, {
                ...detectOverflowOptions,
                elementContext: 'reference'
            });
            const diffY = Math.max(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const maxHeight = Math.max(0, el.scrollHeight - diffY - Math.max(0, overflow.bottom));
            el.style.maxHeight = maxHeight + "px";
            el.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                if (el.offsetHeight < item.offsetHeight * Math.min(minItemsVisible, listRef.current.length - 1) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold) (0, $1u0KT.flushSync)(()=>onFallbackChange(true));
                else (0, $1u0KT.flushSync)(()=>onFallbackChange(false));
            }
            if (overflowRef) overflowRef.current = await (0, $618j3.detectOverflow)($3f69993268aa5b7a$var$getArgsWithCustomFloatingHeight({
                ...nextArgs,
                y: nextY
            }, el.offsetHeight), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 */ const $3f69993268aa5b7a$export$3d74b0dda7cc82ff = (_ref, _ref2)=>{
    let { open: open, elements: elements } = _ref;
    let { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = _ref2;
    const onChange = $3f69993268aa5b7a$var$useEvent(unstable_onChange);
    const controlledScrollingRef = $acw62.useRef(false);
    const prevScrollTopRef = $acw62.useRef(null);
    const initialOverflowRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                (0, $1u0KT.flushSync)(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test($3f69993268aa5b7a$var$getUserAgent())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = {
                    ...overflowRef.current
                };
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    return $acw62.useMemo(()=>{
        if (!enabled) return {};
        return {
            floating: {
                onKeyDown () {
                    controlledScrollingRef.current = true;
                },
                onWheel () {
                    controlledScrollingRef.current = false;
                },
                onPointerMove () {
                    controlledScrollingRef.current = false;
                },
                onScroll () {
                    const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                    if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                    if (prevScrollTopRef.current !== null) {
                        const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                        if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) (0, $1u0KT.flushSync)(()=>onChange((d)=>d + scrollDiff));
                    }
                    // [Firefox] Wait for the height change to have been applied.
                    requestAnimationFrame(()=>{
                        prevScrollTopRef.current = el.scrollTop;
                    });
                }
            }
        };
    }, [
        enabled,
        overflowRef,
        elements.floating,
        scrollRef,
        onChange
    ]);
};
function $3f69993268aa5b7a$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $3f69993268aa5b7a$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
function $3f69993268aa5b7a$export$7484214ab62358d2(_temp) {
    let { restMs: restMs = 0, buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false } = _temp === void 0 ? {} : _temp;
    let timeoutId;
    let isInsideRect = false;
    let hasLanded = false;
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                clearTimeout(timeoutId);
                onClose();
            }
            clearTimeout(timeoutId);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $3f69993268aa5b7a$var$getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = $3f69993268aa5b7a$var$contains(elements.floating, target);
            const isOverReferenceEl = $3f69993268aa5b7a$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $3f69993268aa5b7a$var$isInside(clientPoint, refRect);
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && $3f69993268aa5b7a$var$isElement(event.relatedTarget) && $3f69993268aa5b7a$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $3f69993268aa5b7a$var$getChildren(tree.nodesRef.current, nodeId).some((_ref2)=>{
                let { context: context } = _ref2;
                return context == null ? void 0 : context.open;
            })) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            rect.left,
                            refRect.top + 1
                        ],
                        [
                            rect.left,
                            rect.bottom - 1
                        ],
                        [
                            rect.right,
                            rect.bottom - 1
                        ],
                        [
                            rect.right,
                            refRect.top + 1
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= refRect.top + 1;
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            rect.left,
                            rect.top + 1
                        ],
                        [
                            rect.left,
                            refRect.bottom - 1
                        ],
                        [
                            rect.right,
                            refRect.bottom - 1
                        ],
                        [
                            rect.right,
                            rect.top + 1
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= rect.right && clientY >= refRect.bottom - 1 && clientY <= rect.bottom;
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            rect.bottom
                        ],
                        [
                            rect.right - 1,
                            rect.top
                        ],
                        [
                            refRect.left + 1,
                            rect.top
                        ],
                        [
                            refRect.left + 1,
                            rect.bottom
                        ]
                    ];
                    isInsideRect = clientX >= rect.left && clientX <= refRect.left + 1 && clientY >= rect.top && clientY <= rect.bottom;
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            rect.bottom
                        ],
                        [
                            refRect.right - 1,
                            rect.top
                        ],
                        [
                            rect.left + 1,
                            rect.top
                        ],
                        [
                            rect.left + 1,
                            rect.bottom
                        ]
                    ];
                    isInsideRect = clientX >= refRect.right - 1 && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
                    break;
            }
            function getPolygon(_ref3) {
                let [x, y] = _ref3;
                const isFloatingWider = rect.width > refRect.width;
                const isFloatingTaller = rect.height > refRect.height;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            const poly = isInsideRect ? rectPoly : getPolygon([
                x,
                y
            ]);
            if (isInsideRect) return;
            else if (hasLanded && !isOverReferenceRect) return close();
            if (!$3f69993268aa5b7a$var$isPointInPolygon([
                clientX,
                clientY
            ], poly)) close();
            else if (restMs && !hasLanded) timeoutId = setTimeout(close, restMs);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/react
 */ function $3f69993268aa5b7a$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { open: open = false, onOpenChange: unstable_onOpenChange, nodeId: nodeId } = options;
    const position = (0, $33OG6.useFloating)(options);
    const tree = $3f69993268aa5b7a$export$db0c2a7c7a2a4f69();
    const domReferenceRef = $acw62.useRef(null);
    const dataRef = $acw62.useRef({});
    const events = $acw62.useState(()=>$3f69993268aa5b7a$var$createPubSub())[0];
    const [domReference, setDomReference] = $acw62.useState(null);
    const setPositionReference = $acw62.useCallback((node)=>{
        const positionReference = $3f69993268aa5b7a$var$isElement(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            contextElement: node
        } : node;
        position.refs.setReference(positionReference);
    }, [
        position.refs
    ]);
    const setReference = $acw62.useCallback((node)=>{
        if ($3f69993268aa5b7a$var$isElement(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ($3f69993268aa5b7a$var$isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !$3f69993268aa5b7a$var$isElement(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $acw62.useMemo(()=>({
            ...position.refs,
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $acw62.useMemo(()=>({
            ...position.elements,
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const onOpenChange = $3f69993268aa5b7a$var$useEvent(unstable_onOpenChange);
    const context = $acw62.useMemo(()=>({
            ...position,
            refs: refs,
            elements: elements,
            dataRef: dataRef,
            nodeId: nodeId,
            events: events,
            open: open,
            onOpenChange: onOpenChange
        }), [
        position,
        nodeId,
        events,
        open,
        onOpenChange,
        refs,
        elements
    ]);
    $3f69993268aa5b7a$var$index(()=>{
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $acw62.useMemo(()=>({
            ...position,
            context: context,
            refs: refs,
            reference: setReference,
            positionReference: setPositionReference
        }), [
        position,
        refs,
        context,
        setReference,
        setPositionReference
    ]);
}
function $3f69993268aa5b7a$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    return {
        ...elementKey === 'floating' && {
            tabIndex: -1
        },
        ...userProps,
        ...propsList.map((value)=>value ? value[elementKey] : null).concat(userProps).reduce((acc, props)=>{
            if (!props) return acc;
            Object.entries(props).forEach((_ref)=>{
                let [key, value] = _ref;
                if (key.indexOf('on') === 0) {
                    if (!map.has(key)) map.set(key, []);
                    if (typeof value === 'function') {
                        var _map$get;
                        (_map$get = map.get(key)) == null || _map$get.push(value);
                        acc[key] = function() {
                            var _map$get2;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            (_map$get2 = map.get(key)) == null || _map$get2.forEach((fn)=>fn(...args));
                        };
                    }
                } else acc[key] = value;
            });
            return acc;
        }, {})
    };
}
const $3f69993268aa5b7a$export$a519f7794e446ddd = function(propsList) {
    if (propsList === void 0) propsList = [];
    // The dependencies are a dynamic array, so we can't use the linter's
    // suggestion to add it to the deps array.
    const deps = propsList;
    const getReferenceProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getFloatingProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const getItemProps = $acw62.useCallback((userProps)=>$3f69993268aa5b7a$var$mergeProps(userProps, propsList, 'item'), // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    propsList.map((key)=>key == null ? void 0 : key.item));
    return $acw62.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
};

});
parcelRegister("6okVC", function(module, exports) {

$parcel$export(module.exports, "hideOthers", () => $4a7537e072260c10$export$6e33d16126ed003c);
var $4a7537e072260c10$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4a7537e072260c10$var$counterMap = new WeakMap();
var $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
var $4a7537e072260c10$var$markerMap = {};
var $4a7537e072260c10$var$lockCount = 0;
var $4a7537e072260c10$var$unwrapHost = function(node) {
    return node && (node.host || $4a7537e072260c10$var$unwrapHost(node.parentNode));
};
var $4a7537e072260c10$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4a7537e072260c10$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4a7537e072260c10$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4a7537e072260c10$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4a7537e072260c10$var$markerMap[markerName]) $4a7537e072260c10$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4a7537e072260c10$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($4a7537e072260c10$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4a7537e072260c10$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4a7537e072260c10$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4a7537e072260c10$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4a7537e072260c10$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4a7537e072260c10$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4a7537e072260c10$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4a7537e072260c10$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4a7537e072260c10$var$lockCount--;
        if (!$4a7537e072260c10$var$lockCount) {
            // clear
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$counterMap = new WeakMap();
            $4a7537e072260c10$var$uncontrolledNodes = new WeakMap();
            $4a7537e072260c10$var$markerMap = {};
        }
    };
};
var $4a7537e072260c10$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $4a7537e072260c10$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $4a7537e072260c10$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $4a7537e072260c10$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4a7537e072260c10$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $4a7537e072260c10$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $4a7537e072260c10$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($4a7537e072260c10$export$cc95fea82d705fca() ? $4a7537e072260c10$export$59151cc8db999a24 : $4a7537e072260c10$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};

});

parcelRegister("e8HHX", function(module, exports) {

$parcel$export(module.exports, "tabbable", () => $a4b3b7902c9a987d$export$17100aea90429aa7);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
// CAREFUL: JSDom does not support `:not([inert] *)` as a selector; using it causes
//  the entire query to fail, resulting in no nodes found, which will break a lot
//  of things... so we have to rely on JS to identify nodes inside an inert container
var $a4b3b7902c9a987d$var$candidateSelectors = [
    'input:not([inert])',
    'select:not([inert])',
    'textarea:not([inert])',
    'a[href]:not([inert])',
    'button:not([inert])',
    '[tabindex]:not(slot):not([inert])',
    'audio[controls]:not([inert])',
    'video[controls]:not([inert])',
    '[contenteditable]:not([contenteditable="false"]):not([inert])',
    'details>summary:first-of-type:not([inert])',
    'details:not([inert])'
];
var $a4b3b7902c9a987d$var$candidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.join(',');
var $a4b3b7902c9a987d$var$NoElement = typeof Element === 'undefined';
var $a4b3b7902c9a987d$var$matches = $a4b3b7902c9a987d$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $a4b3b7902c9a987d$var$getRootNode = !$a4b3b7902c9a987d$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Element} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    // CAREFUL: JSDom does not appear to support certain selectors like `:not([inert] *)`
    //  so it likely would not support `:is([inert] *)` either...
    var result = inert || lookUp && node && isInert(node.parentNode); // recursive
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $a4b3b7902c9a987d$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $a4b3b7902c9a987d$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert, all its children are inert
    if ($a4b3b7902c9a987d$var$isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($a4b3b7902c9a987d$var$candidateSelector));
    if (includeContainer && $a4b3b7902c9a987d$var$matches.call(el, $a4b3b7902c9a987d$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $a4b3b7902c9a987d$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($a4b3b7902c9a987d$var$isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $a4b3b7902c9a987d$var$matches.call(element, $a4b3b7902c9a987d$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$a4b3b7902c9a987d$var$isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $a4b3b7902c9a987d$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $a4b3b7902c9a987d$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $a4b3b7902c9a987d$var$isContentEditable(node)) && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $a4b3b7902c9a987d$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $a4b3b7902c9a987d$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$a4b3b7902c9a987d$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $a4b3b7902c9a987d$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $a4b3b7902c9a987d$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $a4b3b7902c9a987d$var$isHiddenInput = function isHiddenInput(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === 'hidden';
};
var $a4b3b7902c9a987d$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $a4b3b7902c9a987d$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $a4b3b7902c9a987d$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $a4b3b7902c9a987d$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $a4b3b7902c9a987d$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $a4b3b7902c9a987d$var$isRadio = function isRadio(node) {
    return $a4b3b7902c9a987d$var$isInput(node) && node.type === 'radio';
};
var $a4b3b7902c9a987d$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $a4b3b7902c9a987d$var$isRadio(node) && !$a4b3b7902c9a987d$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $a4b3b7902c9a987d$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $a4b3b7902c9a987d$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $a4b3b7902c9a987d$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $a4b3b7902c9a987d$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $a4b3b7902c9a987d$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $a4b3b7902c9a987d$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($a4b3b7902c9a987d$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $a4b3b7902c9a987d$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $a4b3b7902c9a987d$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($a4b3b7902c9a987d$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $a4b3b7902c9a987d$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $a4b3b7902c9a987d$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $a4b3b7902c9a987d$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
    //  because we're limited in the type of selectors we can use in JSDom (see related
    //  note related to `candidateSelectors`)
    $a4b3b7902c9a987d$var$isInert(node) || $a4b3b7902c9a987d$var$isHiddenInput(node) || $a4b3b7902c9a987d$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $a4b3b7902c9a987d$var$isDetailsWithSummary(node) || $a4b3b7902c9a987d$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($a4b3b7902c9a987d$var$isNonTabbableRadio(node) || $a4b3b7902c9a987d$export$a4672efddb4181b8(node) < 0 || !$a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $a4b3b7902c9a987d$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $a4b3b7902c9a987d$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $a4b3b7902c9a987d$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($a4b3b7902c9a987d$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $a4b3b7902c9a987d$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $a4b3b7902c9a987d$var$isValidShadowRootTabbable
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $a4b3b7902c9a987d$var$sortByOrder(candidates);
};
var $a4b3b7902c9a987d$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $a4b3b7902c9a987d$var$getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $a4b3b7902c9a987d$var$getCandidates(container, options.includeContainer, $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $a4b3b7902c9a987d$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$candidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorTabbable(options, node);
};
var $a4b3b7902c9a987d$var$focusableCandidateSelector = /* #__PURE__ */ $a4b3b7902c9a987d$var$candidateSelectors.concat('iframe').join(',');
var $a4b3b7902c9a987d$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($a4b3b7902c9a987d$var$matches.call(node, $a4b3b7902c9a987d$var$focusableCandidateSelector) === false) return false;
    return $a4b3b7902c9a987d$var$isNodeMatchingSelectorFocusable(options, node);
};

});


parcelRegister("8nNfC", function(module, exports) {

$parcel$export(module.exports, "useFloatingAutoUpdate", () => $61a6aceaf5e542e8$export$221e6d278ea24455);

var $acw62 = parcelRequire("acw62");

var $618j3 = parcelRequire("618j3");

var $2qf6h = parcelRequire("2qf6h");
function $61a6aceaf5e542e8$export$221e6d278ea24455({ opened: opened, floating: floating, position: position, positionDependencies: positionDependencies }) {
    const [delayedUpdate, setDelayedUpdate] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        if (floating.refs.reference.current && floating.refs.floating.current) return (0, $618j3.autoUpdate)(floating.refs.reference.current, floating.refs.floating.current, floating.update);
        return void 0;
    }, [
        floating.refs.reference.current,
        floating.refs.floating.current,
        opened,
        delayedUpdate,
        position
    ]);
    (0, $2qf6h.useDidUpdate)(()=>{
        floating.update();
    }, positionDependencies);
    (0, $2qf6h.useDidUpdate)(()=>{
        setDelayedUpdate((c)=>c + 1);
    }, [
        opened
    ]);
}

});


parcelRegister("1BKGV", function(module, exports) {

$parcel$export(module.exports, "PopoverContextProvider", () => $12bd770edbb084be$export$f5300fbf692a63ec);
$parcel$export(module.exports, "usePopoverContext", () => $12bd770edbb084be$export$1468d0761b26e6c8);

var $jIWSq = parcelRequire("jIWSq");

var $dWZ4a = parcelRequire("dWZ4a");
const [$12bd770edbb084be$export$f5300fbf692a63ec, $12bd770edbb084be$export$1468d0761b26e6c8] = (0, $jIWSq.createSafeContext)((0, $dWZ4a.POPOVER_ERRORS).context);

});
parcelRegister("dWZ4a", function(module, exports) {

$parcel$export(module.exports, "POPOVER_ERRORS", () => $a2800fa179c1d75c$export$8edbd39c178c3bd8);
const $a2800fa179c1d75c$export$8edbd39c178c3bd8 = {
    context: "Popover component was not found in the tree",
    children: "Popover.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
};

});


parcelRegister("7wIYL", function(module, exports) {

$parcel$export(module.exports, "PopoverTarget", () => $57ae697800f23e53$export$5ad0c0856b469f13);

var $acw62 = parcelRequire("acw62");

var $4GmKa = parcelRequire("4GmKa");

var $cOXe5 = parcelRequire("cOXe5");

var $1SA7b = parcelRequire("1SA7b");
var $64A2P = parcelRequire("64A2P");

var $1BKGV = parcelRequire("1BKGV");

var $dWZ4a = parcelRequire("dWZ4a");
var $57ae697800f23e53$var$__defProp = Object.defineProperty;
var $57ae697800f23e53$var$__defProps = Object.defineProperties;
var $57ae697800f23e53$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $57ae697800f23e53$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $57ae697800f23e53$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $57ae697800f23e53$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $57ae697800f23e53$var$__defNormalProp = (obj, key, value)=>key in obj ? $57ae697800f23e53$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $57ae697800f23e53$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($57ae697800f23e53$var$__hasOwnProp.call(b, prop)) $57ae697800f23e53$var$__defNormalProp(a, prop, b[prop]);
    if ($57ae697800f23e53$var$__getOwnPropSymbols) {
        for (var prop of $57ae697800f23e53$var$__getOwnPropSymbols(b))if ($57ae697800f23e53$var$__propIsEnum.call(b, prop)) $57ae697800f23e53$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $57ae697800f23e53$var$__spreadProps = (a, b)=>$57ae697800f23e53$var$__defProps(a, $57ae697800f23e53$var$__getOwnPropDescs(b));
var $57ae697800f23e53$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($57ae697800f23e53$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $57ae697800f23e53$var$__getOwnPropSymbols) {
        for (var prop of $57ae697800f23e53$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $57ae697800f23e53$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $57ae697800f23e53$var$defaultProps = {
    refProp: "ref",
    popupType: "dialog",
    shouldOverrideDefaultTargetId: true
};
const $57ae697800f23e53$export$5ad0c0856b469f13 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("PopoverTarget", $57ae697800f23e53$var$defaultProps, props), { children: children, refProp: refProp, popupType: popupType, shouldOverrideDefaultTargetId: shouldOverrideDefaultTargetId } = _a, others = $57ae697800f23e53$var$__objRest(_a, [
        "children",
        "refProp",
        "popupType",
        "shouldOverrideDefaultTargetId"
    ]);
    if (!(0, $cOXe5.isElement)(children)) throw new Error((0, $dWZ4a.POPOVER_ERRORS).children);
    const forwardedProps = others;
    const ctx = (0, $1BKGV.usePopoverContext)();
    const targetRef = (0, $4GmKa.useMergedRef)(ctx.reference, children.ref, ref);
    const accessibleProps = ctx.withRoles ? {
        "aria-haspopup": popupType,
        "aria-expanded": ctx.opened,
        "aria-controls": ctx.getDropdownId(),
        id: shouldOverrideDefaultTargetId ? ctx.getTargetId() : children.props.id
    } : {};
    return (0, $acw62.cloneElement)(children, $57ae697800f23e53$var$__spreadValues($57ae697800f23e53$var$__spreadProps($57ae697800f23e53$var$__spreadValues($57ae697800f23e53$var$__spreadValues($57ae697800f23e53$var$__spreadValues({}, forwardedProps), accessibleProps), ctx.targetProps), {
        className: (0, $1SA7b.default)(ctx.targetProps.className, forwardedProps.className, children.props.className),
        [refProp]: targetRef
    }), !ctx.controlled ? {
        onClick: ctx.onToggle
    } : null));
});
$57ae697800f23e53$export$5ad0c0856b469f13.displayName = "@mantine/core/PopoverTarget";

});

parcelRegister("jAS2v", function(module, exports) {

$parcel$export(module.exports, "PopoverDropdown", () => $e43b4c35d4730620$export$bc4cee0d3f11c45d);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $bEVvY = parcelRequire("bEVvY");

var $3EYPD = parcelRequire("3EYPD");

var $1BKGV = parcelRequire("1BKGV");

var $d2HOj = parcelRequire("d2HOj");

var $hZi38 = parcelRequire("hZi38");

var $1RCXp = parcelRequire("1RCXp");

var $D7Bq4 = parcelRequire("D7Bq4");

var $hiiR1 = parcelRequire("hiiR1");

var $4NFGZ = parcelRequire("4NFGZ");
var $e43b4c35d4730620$var$__defProp = Object.defineProperty;
var $e43b4c35d4730620$var$__defProps = Object.defineProperties;
var $e43b4c35d4730620$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e43b4c35d4730620$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e43b4c35d4730620$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e43b4c35d4730620$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e43b4c35d4730620$var$__defNormalProp = (obj, key, value)=>key in obj ? $e43b4c35d4730620$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e43b4c35d4730620$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e43b4c35d4730620$var$__hasOwnProp.call(b, prop)) $e43b4c35d4730620$var$__defNormalProp(a, prop, b[prop]);
    if ($e43b4c35d4730620$var$__getOwnPropSymbols) {
        for (var prop of $e43b4c35d4730620$var$__getOwnPropSymbols(b))if ($e43b4c35d4730620$var$__propIsEnum.call(b, prop)) $e43b4c35d4730620$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e43b4c35d4730620$var$__spreadProps = (a, b)=>$e43b4c35d4730620$var$__defProps(a, $e43b4c35d4730620$var$__getOwnPropDescs(b));
var $e43b4c35d4730620$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e43b4c35d4730620$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e43b4c35d4730620$var$__getOwnPropSymbols) {
        for (var prop of $e43b4c35d4730620$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e43b4c35d4730620$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $e43b4c35d4730620$var$defaultProps = {};
function $e43b4c35d4730620$export$bc4cee0d3f11c45d(props) {
    var _b;
    const _a = (0, $64A2P.useComponentDefaultProps)("PopoverDropdown", $e43b4c35d4730620$var$defaultProps, props), { style: style, className: className, children: children, onKeyDownCapture: onKeyDownCapture } = _a, others = $e43b4c35d4730620$var$__objRest(_a, [
        "style",
        "className",
        "children",
        "onKeyDownCapture"
    ]);
    const ctx = (0, $1BKGV.usePopoverContext)();
    const { classes: classes, cx: cx } = (0, $d2HOj.default)({
        radius: ctx.radius,
        shadow: ctx.shadow
    }, {
        name: ctx.__staticSelector,
        classNames: ctx.classNames,
        styles: ctx.styles,
        unstyled: ctx.unstyled,
        variant: ctx.variant
    });
    const returnFocus = (0, $3EYPD.useFocusReturn)({
        opened: ctx.opened,
        shouldReturnFocus: ctx.returnFocus
    });
    const accessibleProps = ctx.withRoles ? {
        "aria-labelledby": ctx.getTargetId(),
        id: ctx.getDropdownId(),
        role: "dialog"
    } : {};
    if (ctx.disabled) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZi38.OptionalPortal), $e43b4c35d4730620$var$__spreadProps($e43b4c35d4730620$var$__spreadValues({}, ctx.portalProps), {
        withinPortal: ctx.withinPortal
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1RCXp.Transition), $e43b4c35d4730620$var$__spreadProps($e43b4c35d4730620$var$__spreadValues({
        mounted: ctx.opened
    }, ctx.transitionProps), {
        transition: ctx.transitionProps.transition || "fade",
        duration: (_b = ctx.transitionProps.duration) != null ? _b : 150,
        keepMounted: ctx.keepMounted,
        exitDuration: typeof ctx.transitionProps.exitDuration === "number" ? ctx.transitionProps.exitDuration : ctx.transitionProps.duration
    }), (transitionStyles)=>{
        var _a2, _b2;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $D7Bq4.FocusTrap), {
            active: ctx.trapFocus
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $e43b4c35d4730620$var$__spreadValues($e43b4c35d4730620$var$__spreadProps($e43b4c35d4730620$var$__spreadValues({}, accessibleProps), {
            tabIndex: -1,
            ref: ctx.floating,
            style: $e43b4c35d4730620$var$__spreadProps($e43b4c35d4730620$var$__spreadValues($e43b4c35d4730620$var$__spreadValues({}, style), transitionStyles), {
                zIndex: ctx.zIndex,
                top: (_a2 = ctx.y) != null ? _a2 : 0,
                left: (_b2 = ctx.x) != null ? _b2 : 0,
                width: ctx.width === "target" ? void 0 : (0, $2jkdX.rem)(ctx.width)
            }),
            className: cx(classes.dropdown, className),
            onKeyDownCapture: (0, $bEVvY.closeOnEscape)(ctx.onClose, {
                active: ctx.closeOnEscape,
                onTrigger: returnFocus,
                onKeyDown: onKeyDownCapture
            }),
            "data-position": ctx.placement
        }), others), children, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4NFGZ.FloatingArrow), {
            ref: ctx.arrowRef,
            arrowX: ctx.arrowX,
            arrowY: ctx.arrowY,
            visible: ctx.withArrow,
            position: ctx.placement,
            arrowSize: ctx.arrowSize,
            arrowRadius: ctx.arrowRadius,
            arrowOffset: ctx.arrowOffset,
            arrowPosition: ctx.arrowPosition,
            className: classes.arrow
        })));
    }));
}
$e43b4c35d4730620$export$bc4cee0d3f11c45d.displayName = "@mantine/core/PopoverDropdown";

});
parcelRegister("bEVvY", function(module, exports) {

$parcel$export(module.exports, "closeOnEscape", () => $87d00b5a09a4ed3e$export$902efad8ff1933eb);

var $fsgQZ = parcelRequire("fsgQZ");
function $87d00b5a09a4ed3e$export$902efad8ff1933eb(callback, options = {
    active: true
}) {
    if (typeof callback !== "function" || !options.active) return options.onKeyDown || (0, $fsgQZ.noop);
    return (event)=>{
        var _a;
        if (event.key === "Escape") {
            callback(event);
            (_a = options.onTrigger) == null || _a.call(options);
        }
    };
}

});
parcelRegister("fsgQZ", function(module, exports) {

$parcel$export(module.exports, "noop", () => $b4068b4f8bfae73a$export$8793edee2d425525);
const $b4068b4f8bfae73a$export$8793edee2d425525 = ()=>{};

});


parcelRegister("d2HOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ed72201ad2f7f7$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $97ed72201ad2f7f7$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, shadow: shadow })=>({
        dropdown: {
            position: "absolute",
            backgroundColor: theme.white,
            background: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]}`,
            padding: `${theme.spacing.sm} ${theme.spacing.md}`,
            boxShadow: theme.shadows[shadow] || shadow || "none",
            borderRadius: theme.fn.radius(radius),
            "&:focus": {
                outline: 0
            }
        },
        arrow: {
            backgroundColor: "inherit",
            border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]}`,
            zIndex: 1
        }
    }));
var $97ed72201ad2f7f7$export$2e2bcd8739ae039 = $97ed72201ad2f7f7$var$useStyles;

});

parcelRegister("4NFGZ", function(module, exports) {

$parcel$export(module.exports, "FloatingArrow", () => $37ec1448baf57d00$export$33511391554732bc);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $6mQPQ = parcelRequire("6mQPQ");
var $37ec1448baf57d00$var$__defProp = Object.defineProperty;
var $37ec1448baf57d00$var$__defProps = Object.defineProperties;
var $37ec1448baf57d00$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $37ec1448baf57d00$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $37ec1448baf57d00$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $37ec1448baf57d00$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $37ec1448baf57d00$var$__defNormalProp = (obj, key, value)=>key in obj ? $37ec1448baf57d00$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $37ec1448baf57d00$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($37ec1448baf57d00$var$__hasOwnProp.call(b, prop)) $37ec1448baf57d00$var$__defNormalProp(a, prop, b[prop]);
    if ($37ec1448baf57d00$var$__getOwnPropSymbols) {
        for (var prop of $37ec1448baf57d00$var$__getOwnPropSymbols(b))if ($37ec1448baf57d00$var$__propIsEnum.call(b, prop)) $37ec1448baf57d00$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $37ec1448baf57d00$var$__spreadProps = (a, b)=>$37ec1448baf57d00$var$__defProps(a, $37ec1448baf57d00$var$__getOwnPropDescs(b));
var $37ec1448baf57d00$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($37ec1448baf57d00$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $37ec1448baf57d00$var$__getOwnPropSymbols) {
        for (var prop of $37ec1448baf57d00$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $37ec1448baf57d00$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $37ec1448baf57d00$export$33511391554732bc = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { position: position, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, visible: visible, arrowX: arrowX, arrowY: arrowY } = _b, others = $37ec1448baf57d00$var$__objRest(_b, [
        "position",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "visible",
        "arrowX",
        "arrowY"
    ]);
    const theme = (0, $64A2P.useMantineTheme)();
    if (!visible) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $37ec1448baf57d00$var$__spreadProps($37ec1448baf57d00$var$__spreadValues({}, others), {
        ref: ref,
        style: (0, $6mQPQ.getArrowPositionStyles)({
            position: position,
            arrowSize: arrowSize,
            arrowOffset: arrowOffset,
            arrowRadius: arrowRadius,
            arrowPosition: arrowPosition,
            dir: theme.dir,
            arrowX: arrowX,
            arrowY: arrowY
        })
    }));
});
$37ec1448baf57d00$export$33511391554732bc.displayName = "@mantine/core/FloatingArrow";

});
parcelRegister("6mQPQ", function(module, exports) {

$parcel$export(module.exports, "getArrowPositionStyles", () => $4a2dc81be46d9b7a$export$1b8d75826ae84e20);

var $2jkdX = parcelRequire("2jkdX");
var $4a2dc81be46d9b7a$var$__defProp = Object.defineProperty;
var $4a2dc81be46d9b7a$var$__defProps = Object.defineProperties;
var $4a2dc81be46d9b7a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4a2dc81be46d9b7a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4a2dc81be46d9b7a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4a2dc81be46d9b7a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4a2dc81be46d9b7a$var$__defNormalProp = (obj, key, value)=>key in obj ? $4a2dc81be46d9b7a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4a2dc81be46d9b7a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4a2dc81be46d9b7a$var$__hasOwnProp.call(b, prop)) $4a2dc81be46d9b7a$var$__defNormalProp(a, prop, b[prop]);
    if ($4a2dc81be46d9b7a$var$__getOwnPropSymbols) {
        for (var prop of $4a2dc81be46d9b7a$var$__getOwnPropSymbols(b))if ($4a2dc81be46d9b7a$var$__propIsEnum.call(b, prop)) $4a2dc81be46d9b7a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4a2dc81be46d9b7a$var$__spreadProps = (a, b)=>$4a2dc81be46d9b7a$var$__defProps(a, $4a2dc81be46d9b7a$var$__getOwnPropDescs(b));
function $4a2dc81be46d9b7a$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === "center" || arrowPosition === "center") return {
        top: arrowY
    };
    if (placement === "end") return {
        bottom: arrowOffset
    };
    if (placement === "start") return {
        top: arrowOffset
    };
    return {};
}
function $4a2dc81be46d9b7a$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === "center" || arrowPosition === "center") return {
        left: arrowX
    };
    if (placement === "end") return {
        [dir === "ltr" ? "right" : "left"]: arrowOffset
    };
    if (placement === "start") return {
        [dir === "ltr" ? "left" : "right"]: arrowOffset
    };
    return {};
}
const $4a2dc81be46d9b7a$var$radiusByFloatingSide = {
    bottom: "borderTopLeftRadius",
    left: "borderTopRightRadius",
    right: "borderBottomLeftRadius",
    top: "borderBottomRightRadius"
};
function $4a2dc81be46d9b7a$export$1b8d75826ae84e20({ position: position, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, arrowX: arrowX, arrowY: arrowY, dir: dir }) {
    const [side, placement = "center"] = position.split("-");
    const baseStyles = {
        width: (0, $2jkdX.rem)(arrowSize),
        height: (0, $2jkdX.rem)(arrowSize),
        transform: "rotate(45deg)",
        position: "absolute",
        [$4a2dc81be46d9b7a$var$radiusByFloatingSide[side]]: (0, $2jkdX.rem)(arrowRadius)
    };
    const arrowPlacement = (0, $2jkdX.rem)(-arrowSize / 2);
    if (side === "left") return $4a2dc81be46d9b7a$var$__spreadProps($4a2dc81be46d9b7a$var$__spreadValues($4a2dc81be46d9b7a$var$__spreadValues({}, baseStyles), $4a2dc81be46d9b7a$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {
        right: arrowPlacement,
        borderLeftColor: "transparent",
        borderBottomColor: "transparent"
    });
    if (side === "right") return $4a2dc81be46d9b7a$var$__spreadProps($4a2dc81be46d9b7a$var$__spreadValues($4a2dc81be46d9b7a$var$__spreadValues({}, baseStyles), $4a2dc81be46d9b7a$var$horizontalSide(placement, arrowY, arrowOffset, arrowPosition)), {
        left: arrowPlacement,
        borderRightColor: "transparent",
        borderTopColor: "transparent"
    });
    if (side === "top") return $4a2dc81be46d9b7a$var$__spreadProps($4a2dc81be46d9b7a$var$__spreadValues($4a2dc81be46d9b7a$var$__spreadValues({}, baseStyles), $4a2dc81be46d9b7a$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {
        bottom: arrowPlacement,
        borderTopColor: "transparent",
        borderLeftColor: "transparent"
    });
    if (side === "bottom") return $4a2dc81be46d9b7a$var$__spreadProps($4a2dc81be46d9b7a$var$__spreadValues($4a2dc81be46d9b7a$var$__spreadValues({}, baseStyles), $4a2dc81be46d9b7a$var$verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir)), {
        top: arrowPlacement,
        borderBottomColor: "transparent",
        borderRightColor: "transparent"
    });
    return {};
}

});



parcelRegister("hxIdR", function(module, exports) {

$parcel$export(module.exports, "getFloatingPosition", () => $cc57d26f666156d2$export$950b4922bb2f6bc6);
function $cc57d26f666156d2$export$950b4922bb2f6bc6(dir, position) {
    if (dir === "rtl" && (position.includes("right") || position.includes("left"))) {
        const [side, placement] = position.split("-");
        const flippedPosition = side === "right" ? "left" : "right";
        return placement === void 0 ? flippedPosition : `${flippedPosition}-${placement}`;
    }
    return position;
}

});



parcelRegister("cAf07", function(module, exports) {

$parcel$export(module.exports, "filterData", () => $92947bacb932b695$export$d6ad891437e8c72c);
function $92947bacb932b695$export$d6ad891437e8c72c({ data: data, limit: limit, value: value, filter: filter }) {
    const result = [];
    for(let i = 0; i < data.length; i += 1){
        if (filter(value, data[i])) result.push(data[i]);
        if (result.length >= limit) break;
    }
    return result;
}

});

parcelRegister("hw4dK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc08b2fc53f45209$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $cc08b2fc53f45209$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        wrapper: {
            position: "relative"
        }
    }));
var $cc08b2fc53f45209$export$2e2bcd8739ae039 = $cc08b2fc53f45209$var$useStyles;

});


parcelRegister("436KA", function(module, exports) {

$parcel$export(module.exports, "Avatar", () => $2f2cadb4135fb75e$export$e2255cf6045e8d47);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $7N3Fr = parcelRequire("7N3Fr");

var $3cXGg = parcelRequire("3cXGg");

var $iwPbZ = parcelRequire("iwPbZ");

var $alZPS = parcelRequire("alZPS");

var $hiiR1 = parcelRequire("hiiR1");
var $2f2cadb4135fb75e$var$__defProp = Object.defineProperty;
var $2f2cadb4135fb75e$var$__defProps = Object.defineProperties;
var $2f2cadb4135fb75e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2f2cadb4135fb75e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2f2cadb4135fb75e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2f2cadb4135fb75e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2f2cadb4135fb75e$var$__defNormalProp = (obj, key, value)=>key in obj ? $2f2cadb4135fb75e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2f2cadb4135fb75e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2f2cadb4135fb75e$var$__hasOwnProp.call(b, prop)) $2f2cadb4135fb75e$var$__defNormalProp(a, prop, b[prop]);
    if ($2f2cadb4135fb75e$var$__getOwnPropSymbols) {
        for (var prop of $2f2cadb4135fb75e$var$__getOwnPropSymbols(b))if ($2f2cadb4135fb75e$var$__propIsEnum.call(b, prop)) $2f2cadb4135fb75e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2f2cadb4135fb75e$var$__spreadProps = (a, b)=>$2f2cadb4135fb75e$var$__defProps(a, $2f2cadb4135fb75e$var$__getOwnPropDescs(b));
var $2f2cadb4135fb75e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2f2cadb4135fb75e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2f2cadb4135fb75e$var$__getOwnPropSymbols) {
        for (var prop of $2f2cadb4135fb75e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2f2cadb4135fb75e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $2f2cadb4135fb75e$var$defaultProps = {
    size: "md",
    color: "gray",
    variant: "light"
};
const $2f2cadb4135fb75e$export$ddd811db03b0fa30 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Avatar", $2f2cadb4135fb75e$var$defaultProps, props), { className: className, size: size, src: src, alt: alt, radius: radius, children: children, color: color, variant: variant, gradient: gradient, classNames: classNames, styles: styles, imageProps: imageProps, unstyled: unstyled } = _a, others = $2f2cadb4135fb75e$var$__objRest(_a, [
        "className",
        "size",
        "src",
        "alt",
        "radius",
        "children",
        "color",
        "variant",
        "gradient",
        "classNames",
        "styles",
        "imageProps",
        "unstyled"
    ]);
    const ctx = (0, $iwPbZ.useAvatarGroupContext)();
    const [error, setError] = (0, $acw62.useState)(!src);
    const { classes: classes, cx: cx } = (0, $alZPS.default)({
        color: color,
        radius: radius,
        withinGroup: ctx.withinGroup,
        spacing: ctx.spacing,
        gradient: gradient
    }, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        name: "Avatar",
        variant: variant,
        size: size
    });
    (0, $acw62.useEffect)(()=>{
        !src ? setError(true) : setError(false);
    }, [
        src
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $2f2cadb4135fb75e$var$__spreadValues({
        component: "div",
        className: cx(classes.root, className),
        ref: ref
    }, others), error ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.placeholder,
        title: alt
    }, children || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7N3Fr.AvatarPlaceholderIcon), {
        className: classes.placeholderIcon
    })) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", $2f2cadb4135fb75e$var$__spreadProps($2f2cadb4135fb75e$var$__spreadValues({}, imageProps), {
        className: classes.image,
        src: src,
        alt: alt,
        onError: ()=>setError(true)
    })));
});
$2f2cadb4135fb75e$export$ddd811db03b0fa30.displayName = "@mantine/core/Avatar";
$2f2cadb4135fb75e$export$ddd811db03b0fa30.Group = (0, $3cXGg.AvatarGroup);
const $2f2cadb4135fb75e$export$e2255cf6045e8d47 = (0, $1euea.createPolymorphicComponent)($2f2cadb4135fb75e$export$ddd811db03b0fa30);

});
parcelRegister("7N3Fr", function(module, exports) {

$parcel$export(module.exports, "AvatarPlaceholderIcon", () => $5abff4471842affb$export$4f8c9e9a340d2335);

var $acw62 = parcelRequire("acw62");
var $5abff4471842affb$var$__defProp = Object.defineProperty;
var $5abff4471842affb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5abff4471842affb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5abff4471842affb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5abff4471842affb$var$__defNormalProp = (obj, key, value)=>key in obj ? $5abff4471842affb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5abff4471842affb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5abff4471842affb$var$__hasOwnProp.call(b, prop)) $5abff4471842affb$var$__defNormalProp(a, prop, b[prop]);
    if ($5abff4471842affb$var$__getOwnPropSymbols) {
        for (var prop of $5abff4471842affb$var$__getOwnPropSymbols(b))if ($5abff4471842affb$var$__propIsEnum.call(b, prop)) $5abff4471842affb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5abff4471842affb$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5abff4471842affb$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5abff4471842affb$var$__getOwnPropSymbols) {
        for (var prop of $5abff4471842affb$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $5abff4471842affb$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $5abff4471842affb$export$4f8c9e9a340d2335(props) {
    const _a = props, { style: style } = _a, others = $5abff4471842affb$var$__objRest(_a, [
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $5abff4471842affb$var$__spreadValues({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: style
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}

});

parcelRegister("3cXGg", function(module, exports) {

$parcel$export(module.exports, "AvatarGroup", () => $2560c96b28b1e674$export$5b26ebaf2b105908);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $iwPbZ = parcelRequire("iwPbZ");

var $9hLrB = parcelRequire("9hLrB");

var $hiiR1 = parcelRequire("hiiR1");
var $2560c96b28b1e674$var$__defProp = Object.defineProperty;
var $2560c96b28b1e674$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2560c96b28b1e674$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2560c96b28b1e674$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2560c96b28b1e674$var$__defNormalProp = (obj, key, value)=>key in obj ? $2560c96b28b1e674$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2560c96b28b1e674$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2560c96b28b1e674$var$__hasOwnProp.call(b, prop)) $2560c96b28b1e674$var$__defNormalProp(a, prop, b[prop]);
    if ($2560c96b28b1e674$var$__getOwnPropSymbols) {
        for (var prop of $2560c96b28b1e674$var$__getOwnPropSymbols(b))if ($2560c96b28b1e674$var$__propIsEnum.call(b, prop)) $2560c96b28b1e674$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2560c96b28b1e674$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2560c96b28b1e674$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2560c96b28b1e674$var$__getOwnPropSymbols) {
        for (var prop of $2560c96b28b1e674$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2560c96b28b1e674$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $2560c96b28b1e674$var$defaultProps = {};
const $2560c96b28b1e674$export$5b26ebaf2b105908 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("AvatarGroup", $2560c96b28b1e674$var$defaultProps, props), { children: children, spacing: spacing = "sm", unstyled: unstyled, className: className, variant: variant } = _a, others = $2560c96b28b1e674$var$__objRest(_a, [
        "children",
        "spacing",
        "unstyled",
        "className",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $9hLrB.default)({
        spacing: spacing
    }, {
        name: "AvatarGroup",
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iwPbZ.AvatarGroupProvider), {
        spacing: spacing
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $2560c96b28b1e674$var$__spreadValues({
        ref: ref,
        className: cx(classes.root, className)
    }, others), children));
});
$2560c96b28b1e674$export$5b26ebaf2b105908.displayName = "@mantine/core/AvatarGroup";

});
parcelRegister("iwPbZ", function(module, exports) {

$parcel$export(module.exports, "AvatarGroupProvider", () => $d7d2ece40f9439f5$export$d4d383acb7146194);
$parcel$export(module.exports, "useAvatarGroupContext", () => $d7d2ece40f9439f5$export$df4312aa52e73e7b);

var $acw62 = parcelRequire("acw62");
var $d7d2ece40f9439f5$var$__defProp = Object.defineProperty;
var $d7d2ece40f9439f5$var$__defProps = Object.defineProperties;
var $d7d2ece40f9439f5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d7d2ece40f9439f5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d7d2ece40f9439f5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d7d2ece40f9439f5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d7d2ece40f9439f5$var$__defNormalProp = (obj, key, value)=>key in obj ? $d7d2ece40f9439f5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d7d2ece40f9439f5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d7d2ece40f9439f5$var$__hasOwnProp.call(b, prop)) $d7d2ece40f9439f5$var$__defNormalProp(a, prop, b[prop]);
    if ($d7d2ece40f9439f5$var$__getOwnPropSymbols) {
        for (var prop of $d7d2ece40f9439f5$var$__getOwnPropSymbols(b))if ($d7d2ece40f9439f5$var$__propIsEnum.call(b, prop)) $d7d2ece40f9439f5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d7d2ece40f9439f5$var$__spreadProps = (a, b)=>$d7d2ece40f9439f5$var$__defProps(a, $d7d2ece40f9439f5$var$__getOwnPropDescs(b));
const $d7d2ece40f9439f5$var$AvatarGroupContext = (0, $acw62.createContext)(null);
function $d7d2ece40f9439f5$export$d4d383acb7146194({ spacing: spacing, children: children }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d7d2ece40f9439f5$var$AvatarGroupContext.Provider, {
        value: {
            spacing: spacing
        }
    }, children);
}
function $d7d2ece40f9439f5$export$df4312aa52e73e7b() {
    const ctx = (0, $acw62.useContext)($d7d2ece40f9439f5$var$AvatarGroupContext);
    if (ctx) return $d7d2ece40f9439f5$var$__spreadProps($d7d2ece40f9439f5$var$__spreadValues({}, ctx), {
        withinGroup: true
    });
    return {
        spacing: null,
        withinGroup: false
    };
}

});

parcelRegister("9hLrB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c2a8101e5b730bc$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $6c2a8101e5b730bc$var$useStyles = (0, $cQG1Y.createStyles)((theme, { spacing: spacing })=>({
        root: {
            display: "flex",
            paddingLeft: (0, $d8Ix8.getSize)({
                size: spacing,
                sizes: theme.spacing
            })
        }
    }));
var $6c2a8101e5b730bc$export$2e2bcd8739ae039 = $6c2a8101e5b730bc$var$useStyles;

});


parcelRegister("alZPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $789bd4d8e2d5e803$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $789bd4d8e2d5e803$var$__defProp = Object.defineProperty;
var $789bd4d8e2d5e803$var$__defProps = Object.defineProperties;
var $789bd4d8e2d5e803$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $789bd4d8e2d5e803$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $789bd4d8e2d5e803$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $789bd4d8e2d5e803$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $789bd4d8e2d5e803$var$__defNormalProp = (obj, key, value)=>key in obj ? $789bd4d8e2d5e803$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $789bd4d8e2d5e803$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($789bd4d8e2d5e803$var$__hasOwnProp.call(b, prop)) $789bd4d8e2d5e803$var$__defNormalProp(a, prop, b[prop]);
    if ($789bd4d8e2d5e803$var$__getOwnPropSymbols) {
        for (var prop of $789bd4d8e2d5e803$var$__getOwnPropSymbols(b))if ($789bd4d8e2d5e803$var$__propIsEnum.call(b, prop)) $789bd4d8e2d5e803$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $789bd4d8e2d5e803$var$__spreadProps = (a, b)=>$789bd4d8e2d5e803$var$__defProps(a, $789bd4d8e2d5e803$var$__getOwnPropDescs(b));
const $789bd4d8e2d5e803$export$85459c7a2957517b = [
    "filled",
    "light",
    "gradient",
    "outline"
];
const $789bd4d8e2d5e803$export$c647cb0ee6e282fe = {
    xs: (0, $2jkdX.rem)(16),
    sm: (0, $2jkdX.rem)(26),
    md: (0, $2jkdX.rem)(38),
    lg: (0, $2jkdX.rem)(56),
    xl: (0, $2jkdX.rem)(84)
};
function $789bd4d8e2d5e803$var$getGroupStyles({ withinGroup: withinGroup, spacing: spacing, theme: theme }) {
    if (!withinGroup) return null;
    return {
        marginLeft: `calc(${(0, $d8Ix8.getSize)({
            size: spacing,
            sizes: theme.spacing
        })} * -1)`,
        backgroundColor: `${theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white}`,
        border: `${(0, $2jkdX.rem)(2)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white}`
    };
}
function $789bd4d8e2d5e803$var$getVariantStyles({ theme: theme, variant: variant, color: color, gradient: gradient }) {
    const colors = theme.fn.variant({
        variant: variant,
        color: color,
        gradient: gradient
    });
    if ($789bd4d8e2d5e803$export$85459c7a2957517b.includes(variant)) return {
        placeholder: {
            color: colors.color,
            backgroundColor: colors.background,
            backgroundImage: variant === "gradient" ? colors.background : void 0,
            border: `${(0, $2jkdX.rem)(variant === "gradient" ? 0 : 1)} solid ${colors.border}`
        },
        placeholderIcon: {
            color: colors.color
        }
    };
    return {};
}
var $789bd4d8e2d5e803$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, withinGroup: withinGroup, spacing: spacing, color: color, gradient: gradient }, { variant: variant, size: size })=>{
    const variantStyles = $789bd4d8e2d5e803$var$getVariantStyles({
        theme: theme,
        color: color,
        gradient: gradient,
        variant: variant
    });
    return {
        root: $789bd4d8e2d5e803$var$__spreadValues($789bd4d8e2d5e803$var$__spreadProps($789bd4d8e2d5e803$var$__spreadValues({}, theme.fn.focusStyles()), {
            WebkitTapHighlightColor: "transparent",
            boxSizing: "border-box",
            position: "relative",
            display: "block",
            userSelect: "none",
            overflow: "hidden",
            borderRadius: theme.fn.radius(radius),
            textDecoration: "none",
            border: 0,
            backgroundColor: "transparent",
            padding: 0,
            width: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $789bd4d8e2d5e803$export$c647cb0ee6e282fe
            }),
            minWidth: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $789bd4d8e2d5e803$export$c647cb0ee6e282fe
            }),
            height: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $789bd4d8e2d5e803$export$c647cb0ee6e282fe
            })
        }), $789bd4d8e2d5e803$var$getGroupStyles({
            withinGroup: withinGroup,
            spacing: spacing,
            theme: theme
        })),
        image: {
            objectFit: "cover",
            width: "100%",
            height: "100%",
            display: "block"
        },
        placeholder: $789bd4d8e2d5e803$var$__spreadValues($789bd4d8e2d5e803$var$__spreadProps($789bd4d8e2d5e803$var$__spreadValues({}, theme.fn.fontStyles()), {
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            userSelect: "none",
            borderRadius: theme.fn.radius(radius),
            fontSize: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: $789bd4d8e2d5e803$export$c647cb0ee6e282fe
            })} / 2.5)`
        }), variantStyles.placeholder),
        placeholderIcon: $789bd4d8e2d5e803$var$__spreadValues({
            width: "70%",
            height: "70%"
        }, variantStyles.placeholderIcon)
    };
});
var $789bd4d8e2d5e803$export$2e2bcd8739ae039 = $789bd4d8e2d5e803$var$useStyles;

});


parcelRegister("iPjI4", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $db4c47661ddba80f$export$37acb3580601e69a);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $hIobd = parcelRequire("hIobd");

var $hiiR1 = parcelRequire("hiiR1");
var $db4c47661ddba80f$var$__defProp = Object.defineProperty;
var $db4c47661ddba80f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $db4c47661ddba80f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $db4c47661ddba80f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $db4c47661ddba80f$var$__defNormalProp = (obj, key, value)=>key in obj ? $db4c47661ddba80f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $db4c47661ddba80f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($db4c47661ddba80f$var$__hasOwnProp.call(b, prop)) $db4c47661ddba80f$var$__defNormalProp(a, prop, b[prop]);
    if ($db4c47661ddba80f$var$__getOwnPropSymbols) {
        for (var prop of $db4c47661ddba80f$var$__getOwnPropSymbols(b))if ($db4c47661ddba80f$var$__propIsEnum.call(b, prop)) $db4c47661ddba80f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $db4c47661ddba80f$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($db4c47661ddba80f$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $db4c47661ddba80f$var$__getOwnPropSymbols) {
        for (var prop of $db4c47661ddba80f$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $db4c47661ddba80f$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $db4c47661ddba80f$var$defaultProps = {
    variant: "light",
    size: "md",
    radius: "xl"
};
const $db4c47661ddba80f$export$2e7694a78aa98b8c = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Badge", $db4c47661ddba80f$var$defaultProps, props), { className: className, color: color, variant: variant, fullWidth: fullWidth, children: children, size: size, leftSection: leftSection, rightSection: rightSection, radius: radius, gradient: gradient, classNames: classNames, styles: styles, unstyled: unstyled } = _a, others = $db4c47661ddba80f$var$__objRest(_a, [
        "className",
        "color",
        "variant",
        "fullWidth",
        "children",
        "size",
        "leftSection",
        "rightSection",
        "radius",
        "gradient",
        "classNames",
        "styles",
        "unstyled"
    ]);
    const { classes: classes, cx: cx } = (0, $hIobd.default)({
        fullWidth: fullWidth,
        color: color,
        radius: radius,
        gradient: gradient
    }, {
        classNames: classNames,
        styles: styles,
        name: "Badge",
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $db4c47661ddba80f$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), leftSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.leftSection
    }, leftSection), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.inner
    }, children), rightSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.rightSection
    }, rightSection));
});
$db4c47661ddba80f$export$2e7694a78aa98b8c.displayName = "@mantine/core/Badge";
const $db4c47661ddba80f$export$37acb3580601e69a = (0, $1euea.createPolymorphicComponent)($db4c47661ddba80f$export$2e7694a78aa98b8c);

});
parcelRegister("hIobd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce594d6082e3eb1f$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $ce594d6082e3eb1f$var$__defProp = Object.defineProperty;
var $ce594d6082e3eb1f$var$__defProps = Object.defineProperties;
var $ce594d6082e3eb1f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ce594d6082e3eb1f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ce594d6082e3eb1f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ce594d6082e3eb1f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ce594d6082e3eb1f$var$__defNormalProp = (obj, key, value)=>key in obj ? $ce594d6082e3eb1f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ce594d6082e3eb1f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ce594d6082e3eb1f$var$__hasOwnProp.call(b, prop)) $ce594d6082e3eb1f$var$__defNormalProp(a, prop, b[prop]);
    if ($ce594d6082e3eb1f$var$__getOwnPropSymbols) {
        for (var prop of $ce594d6082e3eb1f$var$__getOwnPropSymbols(b))if ($ce594d6082e3eb1f$var$__propIsEnum.call(b, prop)) $ce594d6082e3eb1f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ce594d6082e3eb1f$var$__spreadProps = (a, b)=>$ce594d6082e3eb1f$var$__defProps(a, $ce594d6082e3eb1f$var$__getOwnPropDescs(b));
const $ce594d6082e3eb1f$var$BADGE_VARIANTS = [
    "light",
    "filled",
    "outline",
    "dot",
    "gradient"
];
const $ce594d6082e3eb1f$var$sizes = {
    xs: {
        fontSize: (0, $2jkdX.rem)(9),
        height: (0, $2jkdX.rem)(16)
    },
    sm: {
        fontSize: (0, $2jkdX.rem)(10),
        height: (0, $2jkdX.rem)(18)
    },
    md: {
        fontSize: (0, $2jkdX.rem)(11),
        height: (0, $2jkdX.rem)(20)
    },
    lg: {
        fontSize: (0, $2jkdX.rem)(13),
        height: (0, $2jkdX.rem)(26)
    },
    xl: {
        fontSize: (0, $2jkdX.rem)(16),
        height: (0, $2jkdX.rem)(32)
    }
};
const $ce594d6082e3eb1f$var$dotSizes = {
    xs: (0, $2jkdX.rem)(4),
    sm: (0, $2jkdX.rem)(4),
    md: (0, $2jkdX.rem)(6),
    lg: (0, $2jkdX.rem)(8),
    xl: (0, $2jkdX.rem)(10)
};
function $ce594d6082e3eb1f$var$getVariantStyles({ theme: theme, variant: variant, color: color, size: size, gradient: gradient }) {
    if (!$ce594d6082e3eb1f$var$BADGE_VARIANTS.includes(variant)) return null;
    if (variant === "dot") {
        const dotSize = (0, $d8Ix8.getSize)({
            size: size,
            sizes: $ce594d6082e3eb1f$var$dotSizes
        });
        return {
            backgroundColor: "transparent",
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
            border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[3]}`,
            paddingLeft: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 1.5 - ${dotSize} / 2)`,
            "&::before": {
                content: '""',
                display: "block",
                width: dotSize,
                height: dotSize,
                borderRadius: dotSize,
                backgroundColor: theme.fn.themeColor(color, theme.colorScheme === "dark" ? 4 : theme.fn.primaryShade("light"), true),
                marginRight: dotSize
            }
        };
    }
    const colors = theme.fn.variant({
        color: color,
        variant: variant,
        gradient: gradient
    });
    return {
        background: colors.background,
        color: colors.color,
        border: `${(0, $2jkdX.rem)(variant === "gradient" ? 0 : 1)} solid ${colors.border}`
    };
}
var $ce594d6082e3eb1f$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, radius: radius, gradient: gradient, fullWidth: fullWidth }, { variant: variant, size: size })=>{
    const { fontSize: fontSize, height: height } = size in $ce594d6082e3eb1f$var$sizes ? $ce594d6082e3eb1f$var$sizes[size] : $ce594d6082e3eb1f$var$sizes.md;
    return {
        leftSection: {
            marginRight: `calc(${theme.spacing.xs} / 2)`
        },
        rightSection: {
            marginLeft: `calc(${theme.spacing.xs} / 2)`
        },
        inner: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        },
        root: $ce594d6082e3eb1f$var$__spreadValues($ce594d6082e3eb1f$var$__spreadProps($ce594d6082e3eb1f$var$__spreadValues($ce594d6082e3eb1f$var$__spreadValues({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
            fontSize: fontSize,
            height: height,
            WebkitTapHighlightColor: "transparent",
            lineHeight: `calc(${height} - ${(0, $2jkdX.rem)(2)})`,
            textDecoration: "none",
            padding: `0 calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 1.5)`,
            boxSizing: "border-box",
            display: fullWidth ? "flex" : "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: fullWidth ? "100%" : "auto",
            textTransform: "uppercase",
            borderRadius: theme.fn.radius(radius),
            fontWeight: 700,
            letterSpacing: (0, $2jkdX.rem)(0.25),
            cursor: "inherit",
            textOverflow: "ellipsis",
            overflow: "hidden"
        }), $ce594d6082e3eb1f$var$getVariantStyles({
            theme: theme,
            variant: variant,
            color: color,
            size: size,
            gradient: gradient
        }))
    };
});
var $ce594d6082e3eb1f$export$2e2bcd8739ae039 = $ce594d6082e3eb1f$var$useStyles;

});


parcelRegister("VIBCe", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $0ad7ecbfd441c520$export$2dc68d50d56fbbd);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $cOXe5 = parcelRequire("cOXe5");

var $5Wb8U = parcelRequire("5Wb8U");

var $cjohz = parcelRequire("cjohz");

var $hiiR1 = parcelRequire("hiiR1");
var $0ad7ecbfd441c520$var$__defProp = Object.defineProperty;
var $0ad7ecbfd441c520$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0ad7ecbfd441c520$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0ad7ecbfd441c520$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0ad7ecbfd441c520$var$__defNormalProp = (obj, key, value)=>key in obj ? $0ad7ecbfd441c520$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0ad7ecbfd441c520$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0ad7ecbfd441c520$var$__hasOwnProp.call(b, prop)) $0ad7ecbfd441c520$var$__defNormalProp(a, prop, b[prop]);
    if ($0ad7ecbfd441c520$var$__getOwnPropSymbols) {
        for (var prop of $0ad7ecbfd441c520$var$__getOwnPropSymbols(b))if ($0ad7ecbfd441c520$var$__propIsEnum.call(b, prop)) $0ad7ecbfd441c520$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0ad7ecbfd441c520$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0ad7ecbfd441c520$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0ad7ecbfd441c520$var$__getOwnPropSymbols) {
        for (var prop of $0ad7ecbfd441c520$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0ad7ecbfd441c520$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $0ad7ecbfd441c520$var$defaultProps = {
    separator: "/"
};
const $0ad7ecbfd441c520$export$2dc68d50d56fbbd = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Breadcrumbs", $0ad7ecbfd441c520$var$defaultProps, props), { className: className, children: children, separator: separator, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant } = _a, others = $0ad7ecbfd441c520$var$__objRest(_a, [
        "className",
        "children",
        "separator",
        "classNames",
        "styles",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $5Wb8U.default)(null, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        name: "Breadcrumbs",
        variant: variant
    });
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children).reduce((acc, child, index, array)=>{
        var _a2;
        const item = (0, $cOXe5.isElement)(child) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
            className: cx(classes.breadcrumb, (_a2 = child.props) == null ? void 0 : _a2.className),
            key: index
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: classes.breadcrumb,
            key: index
        }, child);
        acc.push(item);
        if (index !== array.length - 1) acc.push(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
            size: "sm",
            className: classes.separator,
            key: `separator-${index}`
        }, separator));
        return acc;
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $0ad7ecbfd441c520$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), items);
});
$0ad7ecbfd441c520$export$2dc68d50d56fbbd.displayName = "@mantine/core/Breadcrumbs";

});
parcelRegister("5Wb8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $452b033822b825b4$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $452b033822b825b4$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        root: {
            display: "flex",
            alignItems: "center"
        },
        breadcrumb: {
            lineHeight: 1,
            whiteSpace: "nowrap",
            WebkitTapHighlightColor: "transparent"
        },
        separator: {
            marginLeft: theme.spacing.xs,
            marginRight: theme.spacing.xs,
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }));
var $452b033822b825b4$export$2e2bcd8739ae039 = $452b033822b825b4$var$useStyles;

});


parcelRegister("gU5rH", function(module, exports) {

$parcel$export(module.exports, "Button", () => $c4e619b38eb8a8c2$export$353f5b6fc5456de1);

var $acw62 = parcelRequire("acw62");

var $d8Ix8 = parcelRequire("d8Ix8");
var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $d5kqG = parcelRequire("d5kqG");

var $6hfEk = parcelRequire("6hfEk");

var $4P91H = parcelRequire("4P91H");

var $5etRf = parcelRequire("5etRf");
var $c4e619b38eb8a8c2$var$__defProp = Object.defineProperty;
var $c4e619b38eb8a8c2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c4e619b38eb8a8c2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c4e619b38eb8a8c2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c4e619b38eb8a8c2$var$__defNormalProp = (obj, key, value)=>key in obj ? $c4e619b38eb8a8c2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c4e619b38eb8a8c2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c4e619b38eb8a8c2$var$__hasOwnProp.call(b, prop)) $c4e619b38eb8a8c2$var$__defNormalProp(a, prop, b[prop]);
    if ($c4e619b38eb8a8c2$var$__getOwnPropSymbols) {
        for (var prop of $c4e619b38eb8a8c2$var$__getOwnPropSymbols(b))if ($c4e619b38eb8a8c2$var$__propIsEnum.call(b, prop)) $c4e619b38eb8a8c2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c4e619b38eb8a8c2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c4e619b38eb8a8c2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c4e619b38eb8a8c2$var$__getOwnPropSymbols) {
        for (var prop of $c4e619b38eb8a8c2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c4e619b38eb8a8c2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c4e619b38eb8a8c2$var$defaultProps = {
    size: "sm",
    type: "button",
    variant: "filled",
    loaderPosition: "left"
};
const $c4e619b38eb8a8c2$export$e0d3b6de43bd2aff = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Button", $c4e619b38eb8a8c2$var$defaultProps, props), { className: className, size: size, color: color, type: type, disabled: disabled, children: children, leftIcon: leftIcon, rightIcon: rightIcon, fullWidth: fullWidth, variant: variant, radius: radius, uppercase: uppercase, compact: compact, loading: loading, loaderPosition: loaderPosition, loaderProps: loaderProps, gradient: gradient, classNames: classNames, styles: styles, unstyled: unstyled } = _a, others = $c4e619b38eb8a8c2$var$__objRest(_a, [
        "className",
        "size",
        "color",
        "type",
        "disabled",
        "children",
        "leftIcon",
        "rightIcon",
        "fullWidth",
        "variant",
        "radius",
        "uppercase",
        "compact",
        "loading",
        "loaderPosition",
        "loaderProps",
        "gradient",
        "classNames",
        "styles",
        "unstyled"
    ]);
    const { classes: classes, cx: cx, theme: theme } = (0, $6hfEk.default)({
        radius: radius,
        color: color,
        fullWidth: fullWidth,
        compact: compact,
        gradient: gradient,
        withLeftIcon: !!leftIcon,
        withRightIcon: !!rightIcon
    }, {
        name: "Button",
        unstyled: unstyled,
        classNames: classNames,
        styles: styles,
        variant: variant,
        size: size
    });
    const colors = theme.fn.variant({
        color: color,
        variant: variant
    });
    const loader = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4P91H.Loader), $c4e619b38eb8a8c2$var$__spreadValues({
        color: colors.color,
        size: `calc(${(0, $d8Ix8.getSize)({
            size: size,
            sizes: $6hfEk.sizes
        }).height} / 2)`
    }, loaderProps));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $c4e619b38eb8a8c2$var$__spreadValues({
        className: cx(classes.root, className),
        type: type,
        disabled: disabled,
        "data-button": true,
        "data-disabled": disabled || void 0,
        "data-loading": loading || void 0,
        ref: ref,
        unstyled: unstyled
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.inner
    }, (leftIcon || loading && loaderPosition === "left") && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: cx(classes.icon, classes.leftIcon)
    }, loading && loaderPosition === "left" ? loader : leftIcon), loading && loaderPosition === "center" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.centerLoader
    }, loader), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.label,
        style: {
            textTransform: uppercase ? "uppercase" : void 0
        }
    }, children), (rightIcon || loading && loaderPosition === "right") && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: cx(classes.icon, classes.rightIcon)
    }, loading && loaderPosition === "right" ? loader : rightIcon)));
});
$c4e619b38eb8a8c2$export$e0d3b6de43bd2aff.displayName = "@mantine/core/Button";
$c4e619b38eb8a8c2$export$e0d3b6de43bd2aff.Group = (0, $d5kqG.ButtonGroup);
const $c4e619b38eb8a8c2$export$353f5b6fc5456de1 = (0, $1euea.createPolymorphicComponent)($c4e619b38eb8a8c2$export$e0d3b6de43bd2aff);

});
parcelRegister("d5kqG", function(module, exports) {

$parcel$export(module.exports, "ButtonGroup", () => $986b96dd08e4013d$export$69b1032f2ecdf404);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $fHD7L = parcelRequire("fHD7L");

var $hiiR1 = parcelRequire("hiiR1");
var $986b96dd08e4013d$var$__defProp = Object.defineProperty;
var $986b96dd08e4013d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $986b96dd08e4013d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $986b96dd08e4013d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $986b96dd08e4013d$var$__defNormalProp = (obj, key, value)=>key in obj ? $986b96dd08e4013d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $986b96dd08e4013d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($986b96dd08e4013d$var$__hasOwnProp.call(b, prop)) $986b96dd08e4013d$var$__defNormalProp(a, prop, b[prop]);
    if ($986b96dd08e4013d$var$__getOwnPropSymbols) {
        for (var prop of $986b96dd08e4013d$var$__getOwnPropSymbols(b))if ($986b96dd08e4013d$var$__propIsEnum.call(b, prop)) $986b96dd08e4013d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $986b96dd08e4013d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($986b96dd08e4013d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $986b96dd08e4013d$var$__getOwnPropSymbols) {
        for (var prop of $986b96dd08e4013d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $986b96dd08e4013d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $986b96dd08e4013d$var$defaultProps = {
    orientation: "horizontal",
    buttonBorderWidth: 1
};
const $986b96dd08e4013d$export$69b1032f2ecdf404 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("ButtonGroup", $986b96dd08e4013d$var$defaultProps, props), { className: className, orientation: orientation, buttonBorderWidth: buttonBorderWidth, unstyled: unstyled } = _a, others = $986b96dd08e4013d$var$__objRest(_a, [
        "className",
        "orientation",
        "buttonBorderWidth",
        "unstyled"
    ]);
    const { classes: classes, cx: cx } = (0, $fHD7L.default)({
        orientation: orientation,
        buttonBorderWidth: buttonBorderWidth
    }, {
        name: "ButtonGroup",
        unstyled: unstyled
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $986b96dd08e4013d$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others));
});
$986b96dd08e4013d$export$69b1032f2ecdf404.displayName = "@mantine/core/ButtonGroup";

});
parcelRegister("fHD7L", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6e9386d724edbc4$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $b6e9386d724edbc4$var$useStyles = (0, $cQG1Y.createStyles)((_theme, { orientation: orientation, buttonBorderWidth: buttonBorderWidth })=>({
        root: {
            display: "flex",
            flexDirection: orientation === "vertical" ? "column" : "row",
            "& [data-button]": {
                "&:first-of-type:not(:last-of-type)": {
                    borderBottomRightRadius: 0,
                    [orientation === "vertical" ? "borderBottomLeftRadius" : "borderTopRightRadius"]: 0,
                    [orientation === "vertical" ? "borderBottomWidth" : "borderRightWidth"]: `calc(${(0, $2jkdX.rem)(buttonBorderWidth)} / 2)`
                },
                "&:last-of-type:not(:first-of-type)": {
                    borderTopLeftRadius: 0,
                    [orientation === "vertical" ? "borderTopRightRadius" : "borderBottomLeftRadius"]: 0,
                    [orientation === "vertical" ? "borderTopWidth" : "borderLeftWidth"]: `calc(${(0, $2jkdX.rem)(buttonBorderWidth)} / 2)`
                },
                "&:not(:first-of-type):not(:last-of-type)": {
                    borderRadius: 0,
                    [orientation === "vertical" ? "borderTopWidth" : "borderLeftWidth"]: `calc(${(0, $2jkdX.rem)(buttonBorderWidth)} / 2)`,
                    [orientation === "vertical" ? "borderBottomWidth" : "borderRightWidth"]: `calc(${(0, $2jkdX.rem)(buttonBorderWidth)} / 2)`
                },
                "& + [data-button]": {
                    [orientation === "vertical" ? "marginTop" : "marginLeft"]: `calc(${buttonBorderWidth} * -1)`,
                    "@media (min-resolution: 192dpi)": {
                        [orientation === "vertical" ? "marginTop" : "marginLeft"]: 0
                    }
                }
            }
        }
    }));
var $b6e9386d724edbc4$export$2e2bcd8739ae039 = $b6e9386d724edbc4$var$useStyles;

});


parcelRegister("6hfEk", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $49207843cb736f46$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "default", () => $49207843cb736f46$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");

var $bqYMI = parcelRequire("bqYMI");
var $49207843cb736f46$var$__defProp = Object.defineProperty;
var $49207843cb736f46$var$__defProps = Object.defineProperties;
var $49207843cb736f46$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $49207843cb736f46$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $49207843cb736f46$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $49207843cb736f46$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $49207843cb736f46$var$__defNormalProp = (obj, key, value)=>key in obj ? $49207843cb736f46$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $49207843cb736f46$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($49207843cb736f46$var$__hasOwnProp.call(b, prop)) $49207843cb736f46$var$__defNormalProp(a, prop, b[prop]);
    if ($49207843cb736f46$var$__getOwnPropSymbols) {
        for (var prop of $49207843cb736f46$var$__getOwnPropSymbols(b))if ($49207843cb736f46$var$__propIsEnum.call(b, prop)) $49207843cb736f46$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $49207843cb736f46$var$__spreadProps = (a, b)=>$49207843cb736f46$var$__defProps(a, $49207843cb736f46$var$__getOwnPropDescs(b));
const $49207843cb736f46$export$6afdbe521451f575 = [
    "filled",
    "outline",
    "light",
    "white",
    "default",
    "subtle",
    "gradient"
];
const $49207843cb736f46$export$c647cb0ee6e282fe = {
    xs: {
        height: (0, $bqYMI.sizes).xs,
        paddingLeft: (0, $2jkdX.rem)(14),
        paddingRight: (0, $2jkdX.rem)(14)
    },
    sm: {
        height: (0, $bqYMI.sizes).sm,
        paddingLeft: (0, $2jkdX.rem)(18),
        paddingRight: (0, $2jkdX.rem)(18)
    },
    md: {
        height: (0, $bqYMI.sizes).md,
        paddingLeft: (0, $2jkdX.rem)(22),
        paddingRight: (0, $2jkdX.rem)(22)
    },
    lg: {
        height: (0, $bqYMI.sizes).lg,
        paddingLeft: (0, $2jkdX.rem)(26),
        paddingRight: (0, $2jkdX.rem)(26)
    },
    xl: {
        height: (0, $bqYMI.sizes).xl,
        paddingLeft: (0, $2jkdX.rem)(32),
        paddingRight: (0, $2jkdX.rem)(32)
    },
    "compact-xs": {
        height: (0, $2jkdX.rem)(22),
        paddingLeft: (0, $2jkdX.rem)(7),
        paddingRight: (0, $2jkdX.rem)(7)
    },
    "compact-sm": {
        height: (0, $2jkdX.rem)(26),
        paddingLeft: (0, $2jkdX.rem)(8),
        paddingRight: (0, $2jkdX.rem)(8)
    },
    "compact-md": {
        height: (0, $2jkdX.rem)(30),
        paddingLeft: (0, $2jkdX.rem)(10),
        paddingRight: (0, $2jkdX.rem)(10)
    },
    "compact-lg": {
        height: (0, $2jkdX.rem)(34),
        paddingLeft: (0, $2jkdX.rem)(12),
        paddingRight: (0, $2jkdX.rem)(12)
    },
    "compact-xl": {
        height: (0, $2jkdX.rem)(40),
        paddingLeft: (0, $2jkdX.rem)(14),
        paddingRight: (0, $2jkdX.rem)(14)
    }
};
function $49207843cb736f46$var$getSizeStyles({ compact: compact, size: size, withLeftIcon: withLeftIcon, withRightIcon: withRightIcon }) {
    if (compact) return $49207843cb736f46$export$c647cb0ee6e282fe[`compact-${size}`];
    const _sizes = $49207843cb736f46$export$c647cb0ee6e282fe[size];
    if (!_sizes) return {};
    return $49207843cb736f46$var$__spreadProps($49207843cb736f46$var$__spreadValues({}, _sizes), {
        paddingLeft: withLeftIcon ? `calc(${_sizes.paddingLeft}  / 1.5)` : _sizes.paddingLeft,
        paddingRight: withRightIcon ? `calc(${_sizes.paddingRight}  / 1.5)` : _sizes.paddingRight
    });
}
const $49207843cb736f46$var$getWidthStyles = (fullWidth)=>({
        display: fullWidth ? "block" : "inline-block",
        width: fullWidth ? "100%" : "auto"
    });
function $49207843cb736f46$var$getVariantStyles({ variant: variant, theme: theme, color: color, gradient: gradient }) {
    if (!$49207843cb736f46$export$6afdbe521451f575.includes(variant)) return null;
    const colors = theme.fn.variant({
        color: color,
        variant: variant,
        gradient: gradient
    });
    if (variant === "gradient") return $49207843cb736f46$var$__spreadValues({
        border: 0,
        backgroundImage: colors.background,
        color: colors.color
    }, theme.fn.hover({
        backgroundSize: "200%"
    }));
    return $49207843cb736f46$var$__spreadValues({
        border: `${(0, $2jkdX.rem)(1)} solid ${colors.border}`,
        backgroundColor: colors.background,
        color: colors.color
    }, theme.fn.hover({
        backgroundColor: colors.hover
    }));
}
var $49207843cb736f46$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, fullWidth: fullWidth, compact: compact, withLeftIcon: withLeftIcon, withRightIcon: withRightIcon, color: color, gradient: gradient }, { variant: variant, size: size })=>({
        root: $49207843cb736f46$var$__spreadProps($49207843cb736f46$var$__spreadValues($49207843cb736f46$var$__spreadProps($49207843cb736f46$var$__spreadValues($49207843cb736f46$var$__spreadValues($49207843cb736f46$var$__spreadValues($49207843cb736f46$var$__spreadValues({}, $49207843cb736f46$var$getSizeStyles({
            compact: compact,
            size: size,
            withLeftIcon: withLeftIcon,
            withRightIcon: withRightIcon
        })), theme.fn.fontStyles()), theme.fn.focusStyles()), $49207843cb736f46$var$getWidthStyles(fullWidth)), {
            borderRadius: theme.fn.radius(radius),
            fontWeight: 600,
            position: "relative",
            lineHeight: 1,
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            userSelect: "none",
            cursor: "pointer"
        }), $49207843cb736f46$var$getVariantStyles({
            variant: variant,
            theme: theme,
            color: color,
            gradient: gradient
        })), {
            "&:active": theme.activeStyles,
            "&:disabled, &[data-disabled]": {
                borderColor: "transparent",
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
                color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[5],
                cursor: "not-allowed",
                backgroundImage: "none",
                pointerEvents: "none",
                "&:active": {
                    transform: "none"
                }
            },
            "&[data-loading]": {
                pointerEvents: "none",
                "&::before": $49207843cb736f46$var$__spreadProps($49207843cb736f46$var$__spreadValues({
                    content: '""'
                }, theme.fn.cover((0, $2jkdX.rem)(-1))), {
                    backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
                    borderRadius: theme.fn.radius(radius),
                    cursor: "not-allowed"
                })
            }
        }),
        icon: {
            display: "flex",
            alignItems: "center"
        },
        leftIcon: {
            marginRight: theme.spacing.xs
        },
        rightIcon: {
            marginLeft: theme.spacing.xs
        },
        centerLoader: {
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            opacity: 0.5
        },
        inner: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            overflow: "visible"
        },
        label: {
            whiteSpace: "nowrap",
            height: "100%",
            overflow: "hidden",
            display: "flex",
            alignItems: "center"
        }
    }));
var $49207843cb736f46$export$2e2bcd8739ae039 = $49207843cb736f46$var$useStyles;

});


parcelRegister("kPsAn", function(module, exports) {

$parcel$export(module.exports, "Card", () => $f29ebe9d921a98e5$export$60332b2344f7fe41);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $9Zs0z = parcelRequire("9Zs0z");

var $2L9dB = parcelRequire("2L9dB");

var $97nLJ = parcelRequire("97nLJ");

var $bOCXs = parcelRequire("bOCXs");
var $f29ebe9d921a98e5$var$__defProp = Object.defineProperty;
var $f29ebe9d921a98e5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f29ebe9d921a98e5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f29ebe9d921a98e5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f29ebe9d921a98e5$var$__defNormalProp = (obj, key, value)=>key in obj ? $f29ebe9d921a98e5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f29ebe9d921a98e5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f29ebe9d921a98e5$var$__hasOwnProp.call(b, prop)) $f29ebe9d921a98e5$var$__defNormalProp(a, prop, b[prop]);
    if ($f29ebe9d921a98e5$var$__getOwnPropSymbols) {
        for (var prop of $f29ebe9d921a98e5$var$__getOwnPropSymbols(b))if ($f29ebe9d921a98e5$var$__propIsEnum.call(b, prop)) $f29ebe9d921a98e5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f29ebe9d921a98e5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f29ebe9d921a98e5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f29ebe9d921a98e5$var$__getOwnPropSymbols) {
        for (var prop of $f29ebe9d921a98e5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f29ebe9d921a98e5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f29ebe9d921a98e5$var$defaultProps = {
    padding: "md"
};
const $f29ebe9d921a98e5$export$31b646acab127150 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Card", $f29ebe9d921a98e5$var$defaultProps, props), { className: className, padding: padding, radius: radius, children: children, unstyled: unstyled, variant: variant } = _a, others = $f29ebe9d921a98e5$var$__objRest(_a, [
        "className",
        "padding",
        "radius",
        "children",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $97nLJ.default)(null, {
        name: "Card",
        unstyled: unstyled,
        variant: variant
    });
    const _children = (0, $acw62.Children).toArray(children);
    const content = _children.map((child, index)=>{
        if (typeof child === "object" && child && "type" in child && child.type === (0, $2L9dB.CardSection)) return (0, $acw62.cloneElement)(child, {
            variant: variant,
            padding: padding,
            "data-first": index === 0 || void 0,
            "data-last": index === _children.length - 1 || void 0
        });
        return child;
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bOCXs.CardProvider), {
        value: {
            padding: padding
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9Zs0z.Paper), $f29ebe9d921a98e5$var$__spreadValues({
        className: cx(classes.root, className),
        radius: radius,
        p: padding,
        ref: ref
    }, others), content));
});
$f29ebe9d921a98e5$export$31b646acab127150.Section = (0, $2L9dB.CardSection);
$f29ebe9d921a98e5$export$31b646acab127150.displayName = "@mantine/core/Card";
const $f29ebe9d921a98e5$export$60332b2344f7fe41 = (0, $1euea.createPolymorphicComponent)($f29ebe9d921a98e5$export$31b646acab127150);

});
parcelRegister("2L9dB", function(module, exports) {

$parcel$export(module.exports, "CardSection", () => $20271f218f73a57c$export$408776bb88ffa78b);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $bOCXs = parcelRequire("bOCXs");

var $5FORJ = parcelRequire("5FORJ");

var $hiiR1 = parcelRequire("hiiR1");
var $20271f218f73a57c$var$__defProp = Object.defineProperty;
var $20271f218f73a57c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $20271f218f73a57c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $20271f218f73a57c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $20271f218f73a57c$var$__defNormalProp = (obj, key, value)=>key in obj ? $20271f218f73a57c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $20271f218f73a57c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($20271f218f73a57c$var$__hasOwnProp.call(b, prop)) $20271f218f73a57c$var$__defNormalProp(a, prop, b[prop]);
    if ($20271f218f73a57c$var$__getOwnPropSymbols) {
        for (var prop of $20271f218f73a57c$var$__getOwnPropSymbols(b))if ($20271f218f73a57c$var$__propIsEnum.call(b, prop)) $20271f218f73a57c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $20271f218f73a57c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($20271f218f73a57c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $20271f218f73a57c$var$__getOwnPropSymbols) {
        for (var prop of $20271f218f73a57c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $20271f218f73a57c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $20271f218f73a57c$var$defaultProps = {
    withBorder: false,
    inheritPadding: false
};
const $20271f218f73a57c$export$977367f9d33e92dc = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("CardSection", $20271f218f73a57c$var$defaultProps, props), { className: className, withBorder: withBorder, inheritPadding: inheritPadding, unstyled: unstyled, variant: variant } = _a, others = $20271f218f73a57c$var$__objRest(_a, [
        "className",
        "withBorder",
        "inheritPadding",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $5FORJ.default)({
        padding: (0, $bOCXs.useCardPadding)(),
        withBorder: withBorder,
        inheritPadding: inheritPadding
    }, {
        name: "Card",
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $20271f218f73a57c$var$__spreadValues({
        className: cx(classes.cardSection, className),
        ref: ref
    }, others));
});
$20271f218f73a57c$export$977367f9d33e92dc.displayName = "@mantine/core/CardSection";
const $20271f218f73a57c$export$408776bb88ffa78b = (0, $1euea.createPolymorphicComponent)($20271f218f73a57c$export$977367f9d33e92dc);

});
parcelRegister("bOCXs", function(module, exports) {

$parcel$export(module.exports, "CardProvider", () => $89a2957d4382623e$export$4aacc92b34f48449);
$parcel$export(module.exports, "useCardPadding", () => $89a2957d4382623e$export$5dda13bd6d7cbb1a);

var $acw62 = parcelRequire("acw62");
const $89a2957d4382623e$var$CardContext = (0, $acw62.createContext)({
    padding: 0
});
const $89a2957d4382623e$export$4aacc92b34f48449 = $89a2957d4382623e$var$CardContext.Provider;
const $89a2957d4382623e$export$5dda13bd6d7cbb1a = ()=>(0, $acw62.useContext)($89a2957d4382623e$var$CardContext).padding;

});

parcelRegister("5FORJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42183cf483d4304d$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $42183cf483d4304d$var$useStyles = (0, $cQG1Y.createStyles)((theme, { padding: padding, withBorder: withBorder, inheritPadding: inheritPadding })=>{
    const spacing = (0, $d8Ix8.getSize)({
        size: padding,
        sizes: theme.spacing
    });
    const offset = `calc(-1 * ${spacing})`;
    const borderColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
    return {
        cardSection: {
            display: "block",
            marginLeft: offset,
            marginRight: offset,
            paddingLeft: inheritPadding ? spacing : void 0,
            paddingRight: inheritPadding ? spacing : void 0,
            borderTop: withBorder ? `${(0, $2jkdX.rem)(1)} solid ${borderColor}` : void 0,
            borderBottom: withBorder ? `${(0, $2jkdX.rem)(1)} solid ${borderColor}` : void 0,
            "& + &": {
                borderTop: 0
            },
            "&[data-first]": {
                marginTop: offset,
                borderTop: 0,
                borderBottom: withBorder ? `${(0, $2jkdX.rem)(1)} solid ${borderColor}` : void 0
            },
            "&[data-last]": {
                marginBottom: offset,
                borderBottom: 0
            }
        }
    };
});
var $42183cf483d4304d$export$2e2bcd8739ae039 = $42183cf483d4304d$var$useStyles;

});


parcelRegister("97nLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a37347fac04a9e7$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $6a37347fac04a9e7$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        root: {
            position: "relative",
            overflow: "hidden",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
        }
    }));
var $6a37347fac04a9e7$export$2e2bcd8739ae039 = $6a37347fac04a9e7$var$useStyles;

});


parcelRegister("4OeIO", function(module, exports) {

$parcel$export(module.exports, "Checkbox", () => $38074063ab9c0447$export$48513f6b9f8ce62d);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $8nBd8 = parcelRequire("8nBd8");

var $b74uq = parcelRequire("b74uq");

var $ca7ad = parcelRequire("ca7ad");

var $2XzIE = parcelRequire("2XzIE");

var $aYuU2 = parcelRequire("aYuU2");

var $aEkmw = parcelRequire("aEkmw");

var $im7xW = parcelRequire("im7xW");
var $38074063ab9c0447$var$__defProp = Object.defineProperty;
var $38074063ab9c0447$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $38074063ab9c0447$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $38074063ab9c0447$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $38074063ab9c0447$var$__defNormalProp = (obj, key, value)=>key in obj ? $38074063ab9c0447$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $38074063ab9c0447$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($38074063ab9c0447$var$__hasOwnProp.call(b, prop)) $38074063ab9c0447$var$__defNormalProp(a, prop, b[prop]);
    if ($38074063ab9c0447$var$__getOwnPropSymbols) {
        for (var prop of $38074063ab9c0447$var$__getOwnPropSymbols(b))if ($38074063ab9c0447$var$__propIsEnum.call(b, prop)) $38074063ab9c0447$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $38074063ab9c0447$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($38074063ab9c0447$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $38074063ab9c0447$var$__getOwnPropSymbols) {
        for (var prop of $38074063ab9c0447$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $38074063ab9c0447$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $38074063ab9c0447$var$defaultProps = {
    size: "sm",
    transitionDuration: 100,
    icon: (0, $2XzIE.CheckboxIcon),
    labelPosition: "right"
};
const $38074063ab9c0447$export$48513f6b9f8ce62d = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Checkbox", $38074063ab9c0447$var$defaultProps, props), { className: className, style: style, sx: sx, checked: checked, disabled: disabled, color: color, label: label, indeterminate: indeterminate, id: id, size: size, radius: radius, wrapperProps: wrapperProps, children: children, classNames: classNames, styles: styles, transitionDuration: transitionDuration, icon: Icon, unstyled: unstyled, labelPosition: labelPosition, description: description, error: error, variant: variant } = _a, others = $38074063ab9c0447$var$__objRest(_a, [
        "className",
        "style",
        "sx",
        "checked",
        "disabled",
        "color",
        "label",
        "indeterminate",
        "id",
        "size",
        "radius",
        "wrapperProps",
        "children",
        "classNames",
        "styles",
        "transitionDuration",
        "icon",
        "unstyled",
        "labelPosition",
        "description",
        "error",
        "variant"
    ]);
    const ctx = (0, $b74uq.useCheckboxGroupContext)();
    const uuid = (0, $8nBd8.useId)(id);
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const { classes: classes } = (0, $aYuU2.default)({
        radius: radius,
        color: color,
        transitionDuration: transitionDuration,
        labelPosition: labelPosition,
        error: !!error,
        indeterminate: indeterminate
    }, {
        name: "Checkbox",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: (ctx == null ? void 0 : ctx.size) || size
    });
    const contextProps = ctx ? {
        checked: ctx.value.includes(rest.value),
        onChange: ctx.onChange
    } : {};
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $im7xW.InlineInput), $38074063ab9c0447$var$__spreadValues($38074063ab9c0447$var$__spreadValues({
        className: className,
        sx: sx,
        style: style,
        id: uuid,
        size: (ctx == null ? void 0 : ctx.size) || size,
        labelPosition: labelPosition,
        label: label,
        description: description,
        error: error,
        disabled: disabled,
        __staticSelector: "Checkbox",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        "data-checked": contextProps.checked || void 0,
        variant: variant
    }, systemStyles), wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.inner
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $38074063ab9c0447$var$__spreadValues($38074063ab9c0447$var$__spreadValues({
        id: uuid,
        ref: ref,
        type: "checkbox",
        className: classes.input,
        checked: checked,
        disabled: disabled
    }, rest), contextProps)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        indeterminate: indeterminate,
        className: classes.icon
    })));
});
$38074063ab9c0447$export$48513f6b9f8ce62d.displayName = "@mantine/core/Checkbox";
$38074063ab9c0447$export$48513f6b9f8ce62d.Group = (0, $ca7ad.CheckboxGroup);

});
parcelRegister("b74uq", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupProvider", () => $8173d4b4e76cd38f$export$95a3c27e07a551c3);
$parcel$export(module.exports, "useCheckboxGroupContext", () => $8173d4b4e76cd38f$export$5575526870d5c2ae);

var $acw62 = parcelRequire("acw62");
const $8173d4b4e76cd38f$var$CheckboxGroupContext = (0, $acw62.createContext)(null);
const $8173d4b4e76cd38f$export$95a3c27e07a551c3 = $8173d4b4e76cd38f$var$CheckboxGroupContext.Provider;
const $8173d4b4e76cd38f$export$5575526870d5c2ae = ()=>(0, $acw62.useContext)($8173d4b4e76cd38f$var$CheckboxGroupContext);

});

parcelRegister("ca7ad", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroup", () => $8dabf9c980c4a3de$export$4aa08d5625cb8ead);

var $acw62 = parcelRequire("acw62");

var $ke4gU = parcelRequire("ke4gU");

var $64A2P = parcelRequire("64A2P");

var $b74uq = parcelRequire("b74uq");

var $gw63X = parcelRequire("gw63X");
var $8dabf9c980c4a3de$var$__defProp = Object.defineProperty;
var $8dabf9c980c4a3de$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8dabf9c980c4a3de$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8dabf9c980c4a3de$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8dabf9c980c4a3de$var$__defNormalProp = (obj, key, value)=>key in obj ? $8dabf9c980c4a3de$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8dabf9c980c4a3de$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8dabf9c980c4a3de$var$__hasOwnProp.call(b, prop)) $8dabf9c980c4a3de$var$__defNormalProp(a, prop, b[prop]);
    if ($8dabf9c980c4a3de$var$__getOwnPropSymbols) {
        for (var prop of $8dabf9c980c4a3de$var$__getOwnPropSymbols(b))if ($8dabf9c980c4a3de$var$__propIsEnum.call(b, prop)) $8dabf9c980c4a3de$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8dabf9c980c4a3de$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8dabf9c980c4a3de$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8dabf9c980c4a3de$var$__getOwnPropSymbols) {
        for (var prop of $8dabf9c980c4a3de$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8dabf9c980c4a3de$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8dabf9c980c4a3de$var$defaultProps = {
    size: "sm"
};
const $8dabf9c980c4a3de$export$4aa08d5625cb8ead = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("CheckboxGroup", $8dabf9c980c4a3de$var$defaultProps, props), { children: children, value: value, defaultValue: defaultValue, onChange: onChange, size: size, wrapperProps: wrapperProps } = _a, others = $8dabf9c980c4a3de$var$__objRest(_a, [
        "children",
        "value",
        "defaultValue",
        "onChange",
        "size",
        "wrapperProps"
    ]);
    const [_value, setValue] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: [],
        onChange: onChange
    });
    const handleChange = (event)=>{
        const itemValue = event.currentTarget.value;
        setValue(_value.includes(itemValue) ? _value.filter((item)=>item !== itemValue) : [
            ..._value,
            itemValue
        ]);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $b74uq.CheckboxGroupProvider), {
        value: {
            value: _value,
            onChange: handleChange,
            size: size
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $8dabf9c980c4a3de$var$__spreadValues($8dabf9c980c4a3de$var$__spreadValues({
        labelElement: "div",
        size: size,
        __staticSelector: "CheckboxGroup",
        ref: ref
    }, wrapperProps), others), children));
});
$8dabf9c980c4a3de$export$4aa08d5625cb8ead.displayName = "@mantine/core/CheckboxGroup";

});

parcelRegister("2XzIE", function(module, exports) {

$parcel$export(module.exports, "CheckIcon", () => $227ccc85eb3fea30$export$7dd004358974b05d);
$parcel$export(module.exports, "CheckboxIcon", () => $227ccc85eb3fea30$export$c0a1936901b0e55);

var $acw62 = parcelRequire("acw62");
var $227ccc85eb3fea30$var$__defProp = Object.defineProperty;
var $227ccc85eb3fea30$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $227ccc85eb3fea30$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $227ccc85eb3fea30$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $227ccc85eb3fea30$var$__defNormalProp = (obj, key, value)=>key in obj ? $227ccc85eb3fea30$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $227ccc85eb3fea30$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($227ccc85eb3fea30$var$__hasOwnProp.call(b, prop)) $227ccc85eb3fea30$var$__defNormalProp(a, prop, b[prop]);
    if ($227ccc85eb3fea30$var$__getOwnPropSymbols) {
        for (var prop of $227ccc85eb3fea30$var$__getOwnPropSymbols(b))if ($227ccc85eb3fea30$var$__propIsEnum.call(b, prop)) $227ccc85eb3fea30$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $227ccc85eb3fea30$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($227ccc85eb3fea30$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $227ccc85eb3fea30$var$__getOwnPropSymbols) {
        for (var prop of $227ccc85eb3fea30$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $227ccc85eb3fea30$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $227ccc85eb3fea30$export$7dd004358974b05d(props) {
    const _a = props, { width: width, height: height, style: style } = _a, others = $227ccc85eb3fea30$var$__objRest(_a, [
        "width",
        "height",
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $227ccc85eb3fea30$var$__spreadValues({
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: $227ccc85eb3fea30$var$__spreadValues({
            width: width,
            height: height
        }, style)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}
function $227ccc85eb3fea30$export$c0a1936901b0e55(_a) {
    var _b = _a, { indeterminate: indeterminate } = _b, others = $227ccc85eb3fea30$var$__objRest(_b, [
        "indeterminate"
    ]);
    if (indeterminate) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $227ccc85eb3fea30$var$__spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 32 6"
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("rect", {
        width: "32",
        height: "6",
        fill: "currentColor",
        rx: "3"
    }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($227ccc85eb3fea30$export$7dd004358974b05d, $227ccc85eb3fea30$var$__spreadValues({}, others));
}

});

parcelRegister("aYuU2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fd77aa79a9e5ff6$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $3mzq6 = parcelRequire("3mzq6");
var $2jkdX = parcelRequire("2jkdX");
var $7fd77aa79a9e5ff6$var$__defProp = Object.defineProperty;
var $7fd77aa79a9e5ff6$var$__defProps = Object.defineProperties;
var $7fd77aa79a9e5ff6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7fd77aa79a9e5ff6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7fd77aa79a9e5ff6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7fd77aa79a9e5ff6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7fd77aa79a9e5ff6$var$__defNormalProp = (obj, key, value)=>key in obj ? $7fd77aa79a9e5ff6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7fd77aa79a9e5ff6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7fd77aa79a9e5ff6$var$__hasOwnProp.call(b, prop)) $7fd77aa79a9e5ff6$var$__defNormalProp(a, prop, b[prop]);
    if ($7fd77aa79a9e5ff6$var$__getOwnPropSymbols) {
        for (var prop of $7fd77aa79a9e5ff6$var$__getOwnPropSymbols(b))if ($7fd77aa79a9e5ff6$var$__propIsEnum.call(b, prop)) $7fd77aa79a9e5ff6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7fd77aa79a9e5ff6$var$__spreadProps = (a, b)=>$7fd77aa79a9e5ff6$var$__defProps(a, $7fd77aa79a9e5ff6$var$__getOwnPropDescs(b));
const $7fd77aa79a9e5ff6$var$sizes = {
    xs: (0, $2jkdX.rem)(16),
    sm: (0, $2jkdX.rem)(20),
    md: (0, $2jkdX.rem)(24),
    lg: (0, $2jkdX.rem)(30),
    xl: (0, $2jkdX.rem)(36)
};
var $7fd77aa79a9e5ff6$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, color: color, transitionDuration: transitionDuration, labelPosition: labelPosition, error: error, indeterminate: indeterminate }, { size: size })=>{
    const _size = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $7fd77aa79a9e5ff6$var$sizes
    });
    const colors = theme.fn.variant({
        variant: "filled",
        color: color
    });
    return {
        icon: $7fd77aa79a9e5ff6$var$__spreadProps($7fd77aa79a9e5ff6$var$__spreadValues({}, theme.fn.cover()), {
            ref: (0, $3mzq6.getStylesRef)("icon"),
            color: indeterminate ? "inherit" : theme.white,
            transform: indeterminate ? "none" : `translateY(${(0, $2jkdX.rem)(5)}) scale(0.5)`,
            opacity: indeterminate ? 1 : 0,
            transitionProperty: "opacity, transform",
            transitionTimingFunction: "ease",
            transitionDuration: `${transitionDuration}ms`,
            pointerEvents: "none",
            width: "60%",
            position: "absolute",
            zIndex: 1,
            margin: "auto",
            "@media (prefers-reduced-motion)": {
                transitionDuration: theme.respectReducedMotion ? "0ms" : void 0
            }
        }),
        inner: {
            position: "relative",
            width: _size,
            height: _size,
            order: labelPosition === "left" ? 2 : 1
        },
        input: $7fd77aa79a9e5ff6$var$__spreadProps($7fd77aa79a9e5ff6$var$__spreadValues({}, theme.fn.focusStyles()), {
            appearance: "none",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            border: `${(0, $2jkdX.rem)(1)} solid ${error ? theme.fn.variant({
                variant: "filled",
                color: "red"
            }).background : theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
            width: _size,
            height: _size,
            borderRadius: theme.fn.radius(radius),
            padding: 0,
            display: "block",
            margin: 0,
            transition: `border-color ${transitionDuration}ms ease, background-color ${transitionDuration}ms ease`,
            cursor: theme.cursorType,
            "&:checked": {
                backgroundColor: colors.background,
                borderColor: colors.background,
                [`& + .${(0, $3mzq6.getStylesRef)("icon")}`]: {
                    opacity: 1,
                    color: theme.white,
                    transform: "translateY(0) scale(1)"
                }
            },
            "&:disabled": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
                borderColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[3],
                cursor: "not-allowed",
                pointerEvents: "none",
                [`& + .${(0, $3mzq6.getStylesRef)("icon")}`]: {
                    color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[5]
                }
            }
        })
    };
});
var $7fd77aa79a9e5ff6$export$2e2bcd8739ae039 = $7fd77aa79a9e5ff6$var$useStyles;

});

parcelRegister("im7xW", function(module, exports) {

$parcel$export(module.exports, "InlineInput", () => $d5d022a027179d56$export$36d3e0619bb09209);

var $acw62 = parcelRequire("acw62");

var $5o8Du = parcelRequire("5o8Du");

var $hiiR1 = parcelRequire("hiiR1");

var $gw63X = parcelRequire("gw63X");
var $d5d022a027179d56$var$__defProp = Object.defineProperty;
var $d5d022a027179d56$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d5d022a027179d56$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d5d022a027179d56$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d5d022a027179d56$var$__defNormalProp = (obj, key, value)=>key in obj ? $d5d022a027179d56$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d5d022a027179d56$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d5d022a027179d56$var$__hasOwnProp.call(b, prop)) $d5d022a027179d56$var$__defNormalProp(a, prop, b[prop]);
    if ($d5d022a027179d56$var$__getOwnPropSymbols) {
        for (var prop of $d5d022a027179d56$var$__getOwnPropSymbols(b))if ($d5d022a027179d56$var$__propIsEnum.call(b, prop)) $d5d022a027179d56$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d5d022a027179d56$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d5d022a027179d56$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d5d022a027179d56$var$__getOwnPropSymbols) {
        for (var prop of $d5d022a027179d56$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d5d022a027179d56$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $d5d022a027179d56$export$36d3e0619bb09209 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b = _a, { __staticSelector: __staticSelector, className: className, classNames: classNames, styles: styles, unstyled: unstyled, children: children, label: label, description: description, id: id, disabled: disabled, error: error, size: size, labelPosition: labelPosition, bodyElement: bodyElement = "div", labelElement: labelElement = "label", variant: variant } = _b, others = $d5d022a027179d56$var$__objRest(_b, [
        "__staticSelector",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "children",
        "label",
        "description",
        "id",
        "disabled",
        "error",
        "size",
        "labelPosition",
        "bodyElement",
        "labelElement",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $5o8Du.default)({
        labelPosition: labelPosition
    }, {
        name: __staticSelector,
        styles: styles,
        classNames: classNames,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $d5d022a027179d56$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), {
        component: bodyElement,
        htmlFor: bodyElement === "label" ? id : void 0,
        className: cx(classes.body)
    }, children, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.labelWrapper
    }, label != null && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), {
        component: labelElement,
        htmlFor: labelElement === "label" ? id : void 0,
        className: classes.label,
        "data-disabled": disabled || void 0
    }, label), description && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Description, {
        className: classes.description
    }, description), error && error !== "boolean" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Error, {
        className: classes.error
    }, error))));
});
$d5d022a027179d56$export$36d3e0619bb09209.displayName = "@mantine/core/InlineInput";

});
parcelRegister("5o8Du", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ec5e48c3afed930$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $3ec5e48c3afed930$var$__defProp = Object.defineProperty;
var $3ec5e48c3afed930$var$__defProps = Object.defineProperties;
var $3ec5e48c3afed930$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3ec5e48c3afed930$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3ec5e48c3afed930$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3ec5e48c3afed930$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3ec5e48c3afed930$var$__defNormalProp = (obj, key, value)=>key in obj ? $3ec5e48c3afed930$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3ec5e48c3afed930$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3ec5e48c3afed930$var$__hasOwnProp.call(b, prop)) $3ec5e48c3afed930$var$__defNormalProp(a, prop, b[prop]);
    if ($3ec5e48c3afed930$var$__getOwnPropSymbols) {
        for (var prop of $3ec5e48c3afed930$var$__getOwnPropSymbols(b))if ($3ec5e48c3afed930$var$__propIsEnum.call(b, prop)) $3ec5e48c3afed930$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3ec5e48c3afed930$var$__spreadProps = (a, b)=>$3ec5e48c3afed930$var$__defProps(a, $3ec5e48c3afed930$var$__getOwnPropDescs(b));
const $3ec5e48c3afed930$var$sizes = {
    xs: (0, $2jkdX.rem)(16),
    sm: (0, $2jkdX.rem)(20),
    md: (0, $2jkdX.rem)(24),
    lg: (0, $2jkdX.rem)(30),
    xl: (0, $2jkdX.rem)(36)
};
var $3ec5e48c3afed930$var$useStyles = (0, $cQG1Y.createStyles)((theme, { labelPosition: labelPosition }, { size: size })=>({
        root: {},
        body: {
            display: "flex",
            "&:has(input:disabled) label": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
            }
        },
        labelWrapper: $3ec5e48c3afed930$var$__spreadProps($3ec5e48c3afed930$var$__spreadValues({}, theme.fn.fontStyles()), {
            display: "inline-flex",
            flexDirection: "column",
            WebkitTapHighlightColor: "transparent",
            fontSize: size in $3ec5e48c3afed930$var$sizes ? (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }) : void 0,
            lineHeight: size in $3ec5e48c3afed930$var$sizes ? (0, $d8Ix8.getSize)({
                size: size,
                sizes: $3ec5e48c3afed930$var$sizes
            }) : void 0,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            cursor: theme.cursorType,
            order: labelPosition === "left" ? 1 : 2
        }),
        description: {
            marginTop: `calc(${theme.spacing.xs} / 2)`,
            [labelPosition === "left" ? "paddingRight" : "paddingLeft"]: theme.spacing.sm
        },
        error: {
            marginTop: `calc(${theme.spacing.xs} / 2)`,
            [labelPosition === "left" ? "paddingRight" : "paddingLeft"]: theme.spacing.sm
        },
        label: {
            cursor: theme.cursorType,
            [labelPosition === "left" ? "paddingRight" : "paddingLeft"]: theme.spacing.sm,
            "&:disabled, &[data-disabled]": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
            }
        }
    }));
var $3ec5e48c3afed930$export$2e2bcd8739ae039 = $3ec5e48c3afed930$var$useStyles;

});



parcelRegister("j2E9L", function(module, exports) {

$parcel$export(module.exports, "ColorSwatch", () => $ddcd5a73484cadc7$export$cae13e90592f246a);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $6rEMD = parcelRequire("6rEMD");

var $hiiR1 = parcelRequire("hiiR1");
var $ddcd5a73484cadc7$var$__defProp = Object.defineProperty;
var $ddcd5a73484cadc7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ddcd5a73484cadc7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ddcd5a73484cadc7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ddcd5a73484cadc7$var$__defNormalProp = (obj, key, value)=>key in obj ? $ddcd5a73484cadc7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ddcd5a73484cadc7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ddcd5a73484cadc7$var$__hasOwnProp.call(b, prop)) $ddcd5a73484cadc7$var$__defNormalProp(a, prop, b[prop]);
    if ($ddcd5a73484cadc7$var$__getOwnPropSymbols) {
        for (var prop of $ddcd5a73484cadc7$var$__getOwnPropSymbols(b))if ($ddcd5a73484cadc7$var$__propIsEnum.call(b, prop)) $ddcd5a73484cadc7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ddcd5a73484cadc7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ddcd5a73484cadc7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ddcd5a73484cadc7$var$__getOwnPropSymbols) {
        for (var prop of $ddcd5a73484cadc7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ddcd5a73484cadc7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $ddcd5a73484cadc7$var$defaultProps = {
    size: (0, $2jkdX.rem)(25),
    radius: (0, $2jkdX.rem)(25),
    withShadow: true
};
const $ddcd5a73484cadc7$export$ef966450f3141f99 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("ColorSwatch", $ddcd5a73484cadc7$var$defaultProps, props), { color: color, size: size, radius: radius, className: className, children: children, classNames: classNames, styles: styles, unstyled: unstyled, withShadow: withShadow, variant: variant } = _a, others = $ddcd5a73484cadc7$var$__objRest(_a, [
        "color",
        "size",
        "radius",
        "className",
        "children",
        "classNames",
        "styles",
        "unstyled",
        "withShadow",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $6rEMD.default)({
        radius: radius
    }, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        name: "ColorSwatch",
        size: size,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $ddcd5a73484cadc7$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: cx(classes.alphaOverlay, classes.overlay)
    }), withShadow && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: cx(classes.shadowOverlay, classes.overlay)
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.overlay,
        style: {
            backgroundColor: color
        }
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: cx(classes.children, classes.overlay)
    }, children));
});
$ddcd5a73484cadc7$export$ef966450f3141f99.displayName = "@mantine/core/ColorSwatch";
const $ddcd5a73484cadc7$export$cae13e90592f246a = (0, $1euea.createPolymorphicComponent)($ddcd5a73484cadc7$export$ef966450f3141f99);

});
parcelRegister("6rEMD", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b14e66d7b7aa8a9$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $4b14e66d7b7aa8a9$var$__defProp = Object.defineProperty;
var $4b14e66d7b7aa8a9$var$__defProps = Object.defineProperties;
var $4b14e66d7b7aa8a9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4b14e66d7b7aa8a9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4b14e66d7b7aa8a9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4b14e66d7b7aa8a9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4b14e66d7b7aa8a9$var$__defNormalProp = (obj, key, value)=>key in obj ? $4b14e66d7b7aa8a9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4b14e66d7b7aa8a9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4b14e66d7b7aa8a9$var$__hasOwnProp.call(b, prop)) $4b14e66d7b7aa8a9$var$__defNormalProp(a, prop, b[prop]);
    if ($4b14e66d7b7aa8a9$var$__getOwnPropSymbols) {
        for (var prop of $4b14e66d7b7aa8a9$var$__getOwnPropSymbols(b))if ($4b14e66d7b7aa8a9$var$__propIsEnum.call(b, prop)) $4b14e66d7b7aa8a9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4b14e66d7b7aa8a9$var$__spreadProps = (a, b)=>$4b14e66d7b7aa8a9$var$__defProps(a, $4b14e66d7b7aa8a9$var$__getOwnPropDescs(b));
var $4b14e66d7b7aa8a9$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius }, { size: size })=>{
    const overlayColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
    return {
        root: $4b14e66d7b7aa8a9$var$__spreadProps($4b14e66d7b7aa8a9$var$__spreadValues({}, theme.fn.focusStyles()), {
            width: (0, $2jkdX.rem)(size),
            height: (0, $2jkdX.rem)(size),
            WebkitTapHighlightColor: "transparent",
            border: 0,
            borderRadius: theme.fn.radius(radius),
            appearance: "none",
            WebkitAppearance: "none",
            padding: 0,
            position: "relative",
            overflow: "hidden"
        }),
        overlay: $4b14e66d7b7aa8a9$var$__spreadProps($4b14e66d7b7aa8a9$var$__spreadValues({}, theme.fn.cover()), {
            position: "absolute",
            borderRadius: theme.fn.radius(radius)
        }),
        children: {
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center"
        },
        shadowOverlay: {
            boxShadow: `rgba(0, 0, 0, .1) 0 0 0 ${(0, $2jkdX.rem)(1)} inset, rgb(0, 0, 0, .15) 0 0 ${(0, $2jkdX.rem)(4)} inset`,
            zIndex: 1
        },
        alphaOverlay: {
            backgroundImage: `linear-gradient(45deg, ${overlayColor} 25%, transparent 25%), linear-gradient(-45deg, ${overlayColor} 25%, transparent 25%), linear-gradient(45deg, transparent 75%, ${overlayColor} 75%), linear-gradient(-45deg, ${theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white} 75%, ${overlayColor} 75%)`,
            backgroundSize: `${(0, $2jkdX.rem)(8)} ${(0, $2jkdX.rem)(8)}`,
            backgroundPosition: `0 0, 0 ${(0, $2jkdX.rem)(4)}, ${(0, $2jkdX.rem)(4)} -${(0, $2jkdX.rem)(4)}, -${(0, $2jkdX.rem)(4)} 0`
        }
    };
});
var $4b14e66d7b7aa8a9$export$2e2bcd8739ae039 = $4b14e66d7b7aa8a9$var$useStyles;

});


parcelRegister("hiGsa", function(module, exports) {

$parcel$export(module.exports, "Image", () => $c9850c765d0a00f2$export$3e431a229df88919);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $2qf6h = parcelRequire("2qf6h");

var $47ojp = parcelRequire("47ojp");

var $iGWY8 = parcelRequire("iGWY8");

var $hiiR1 = parcelRequire("hiiR1");

var $cjohz = parcelRequire("cjohz");
var $c9850c765d0a00f2$var$__defProp = Object.defineProperty;
var $c9850c765d0a00f2$var$__defProps = Object.defineProperties;
var $c9850c765d0a00f2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c9850c765d0a00f2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c9850c765d0a00f2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c9850c765d0a00f2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c9850c765d0a00f2$var$__defNormalProp = (obj, key, value)=>key in obj ? $c9850c765d0a00f2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c9850c765d0a00f2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c9850c765d0a00f2$var$__hasOwnProp.call(b, prop)) $c9850c765d0a00f2$var$__defNormalProp(a, prop, b[prop]);
    if ($c9850c765d0a00f2$var$__getOwnPropSymbols) {
        for (var prop of $c9850c765d0a00f2$var$__getOwnPropSymbols(b))if ($c9850c765d0a00f2$var$__propIsEnum.call(b, prop)) $c9850c765d0a00f2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c9850c765d0a00f2$var$__spreadProps = (a, b)=>$c9850c765d0a00f2$var$__defProps(a, $c9850c765d0a00f2$var$__getOwnPropDescs(b));
var $c9850c765d0a00f2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c9850c765d0a00f2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c9850c765d0a00f2$var$__getOwnPropSymbols) {
        for (var prop of $c9850c765d0a00f2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c9850c765d0a00f2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c9850c765d0a00f2$var$defaultProps = {
    fit: "cover",
    width: "100%",
    height: "auto",
    radius: 0
};
const $c9850c765d0a00f2$export$3e431a229df88919 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Image", $c9850c765d0a00f2$var$defaultProps, props), { className: className, alt: alt, src: src, fit: fit, width: width, height: height, radius: radius, imageProps: imageProps, withPlaceholder: withPlaceholder, placeholder: placeholder, imageRef: imageRef, classNames: classNames, styles: styles, caption: caption, unstyled: unstyled, style: style, variant: variant } = _a, others = $c9850c765d0a00f2$var$__objRest(_a, [
        "className",
        "alt",
        "src",
        "fit",
        "width",
        "height",
        "radius",
        "imageProps",
        "withPlaceholder",
        "placeholder",
        "imageRef",
        "classNames",
        "styles",
        "caption",
        "unstyled",
        "style",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $iGWY8.default)({
        radius: radius
    }, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        name: "Image",
        variant: variant
    });
    const [error, setError] = (0, $acw62.useState)(!src);
    const isPlaceholder = withPlaceholder && error;
    (0, $2qf6h.useDidUpdate)(()=>{
        setError(!src);
    }, [
        src
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $c9850c765d0a00f2$var$__spreadValues({
        className: cx(classes.root, className),
        style: $c9850c765d0a00f2$var$__spreadValues({
            width: (0, $2jkdX.rem)(width)
        }, style),
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("figure", {
        className: classes.figure
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.imageWrapper
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", $c9850c765d0a00f2$var$__spreadProps($c9850c765d0a00f2$var$__spreadValues({
        src: src,
        alt: alt,
        ref: imageRef
    }, imageProps), {
        className: cx(classes.image, imageProps == null ? void 0 : imageProps.className),
        onError: (event)=>{
            setError(true);
            typeof (imageProps == null ? void 0 : imageProps.onError) === "function" && imageProps.onError(event);
        },
        style: $c9850c765d0a00f2$var$__spreadValues($c9850c765d0a00f2$var$__spreadValues({
            objectFit: fit,
            width: (0, $2jkdX.rem)(width),
            height: (0, $2jkdX.rem)(height)
        }, isPlaceholder && {
            overflow: "hidden"
        }), imageProps == null ? void 0 : imageProps.style)
    })), isPlaceholder && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.placeholder,
        title: alt
    }, placeholder || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $47ojp.ImageIcon), {
        width: (0, $2jkdX.rem)(40),
        height: (0, $2jkdX.rem)(40)
    })))), !!caption && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        component: "figcaption",
        size: "sm",
        align: "center",
        className: classes.caption
    }, caption)));
});
$c9850c765d0a00f2$export$3e431a229df88919.displayName = "@mantine/core/Image";

});
parcelRegister("47ojp", function(module, exports) {

$parcel$export(module.exports, "ImageIcon", () => $2ffaacb9a1d2e71d$export$4a122bafaa48b23d);

var $acw62 = parcelRequire("acw62");
var $2ffaacb9a1d2e71d$var$__defProp = Object.defineProperty;
var $2ffaacb9a1d2e71d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2ffaacb9a1d2e71d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2ffaacb9a1d2e71d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2ffaacb9a1d2e71d$var$__defNormalProp = (obj, key, value)=>key in obj ? $2ffaacb9a1d2e71d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2ffaacb9a1d2e71d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2ffaacb9a1d2e71d$var$__hasOwnProp.call(b, prop)) $2ffaacb9a1d2e71d$var$__defNormalProp(a, prop, b[prop]);
    if ($2ffaacb9a1d2e71d$var$__getOwnPropSymbols) {
        for (var prop of $2ffaacb9a1d2e71d$var$__getOwnPropSymbols(b))if ($2ffaacb9a1d2e71d$var$__propIsEnum.call(b, prop)) $2ffaacb9a1d2e71d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2ffaacb9a1d2e71d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2ffaacb9a1d2e71d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2ffaacb9a1d2e71d$var$__getOwnPropSymbols) {
        for (var prop of $2ffaacb9a1d2e71d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2ffaacb9a1d2e71d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $2ffaacb9a1d2e71d$export$4a122bafaa48b23d(props) {
    const _a = props, { width: width, height: height, style: style } = _a, others = $2ffaacb9a1d2e71d$var$__objRest(_a, [
        "width",
        "height",
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $2ffaacb9a1d2e71d$var$__spreadValues({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: $2ffaacb9a1d2e71d$var$__spreadValues({
            width: width,
            height: height
        }, style)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}

});

parcelRegister("iGWY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b9e4378258ec74$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d9b9e4378258ec74$var$__defProp = Object.defineProperty;
var $d9b9e4378258ec74$var$__defProps = Object.defineProperties;
var $d9b9e4378258ec74$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d9b9e4378258ec74$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d9b9e4378258ec74$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d9b9e4378258ec74$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d9b9e4378258ec74$var$__defNormalProp = (obj, key, value)=>key in obj ? $d9b9e4378258ec74$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d9b9e4378258ec74$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d9b9e4378258ec74$var$__hasOwnProp.call(b, prop)) $d9b9e4378258ec74$var$__defNormalProp(a, prop, b[prop]);
    if ($d9b9e4378258ec74$var$__getOwnPropSymbols) {
        for (var prop of $d9b9e4378258ec74$var$__getOwnPropSymbols(b))if ($d9b9e4378258ec74$var$__propIsEnum.call(b, prop)) $d9b9e4378258ec74$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d9b9e4378258ec74$var$__spreadProps = (a, b)=>$d9b9e4378258ec74$var$__defProps(a, $d9b9e4378258ec74$var$__getOwnPropDescs(b));
var $d9b9e4378258ec74$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius })=>({
        root: {},
        imageWrapper: {
            position: "relative"
        },
        figure: {
            margin: 0
        },
        image: $d9b9e4378258ec74$var$__spreadProps($d9b9e4378258ec74$var$__spreadValues({}, theme.fn.fontStyles()), {
            display: "block",
            width: "100%",
            height: "100%",
            border: 0,
            borderRadius: theme.fn.radius(radius)
        }),
        caption: {
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
            marginTop: theme.spacing.xs
        },
        placeholder: $d9b9e4378258ec74$var$__spreadProps($d9b9e4378258ec74$var$__spreadValues({}, theme.fn.cover()), {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0],
            borderRadius: theme.fn.radius(radius)
        })
    }));
var $d9b9e4378258ec74$export$2e2bcd8739ae039 = $d9b9e4378258ec74$var$useStyles;

});


parcelRegister("dQS1T", function(module, exports) {

$parcel$export(module.exports, "List", () => $a15a0ada5884081a$export$54c2e3dc7acea9f5);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $4zgRX = parcelRequire("4zgRX");

var $10yGc = parcelRequire("10yGc");

var $b8jBd = parcelRequire("b8jBd");

var $hiiR1 = parcelRequire("hiiR1");
var $a15a0ada5884081a$var$__defProp = Object.defineProperty;
var $a15a0ada5884081a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a15a0ada5884081a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a15a0ada5884081a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a15a0ada5884081a$var$__defNormalProp = (obj, key, value)=>key in obj ? $a15a0ada5884081a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a15a0ada5884081a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a15a0ada5884081a$var$__hasOwnProp.call(b, prop)) $a15a0ada5884081a$var$__defNormalProp(a, prop, b[prop]);
    if ($a15a0ada5884081a$var$__getOwnPropSymbols) {
        for (var prop of $a15a0ada5884081a$var$__getOwnPropSymbols(b))if ($a15a0ada5884081a$var$__propIsEnum.call(b, prop)) $a15a0ada5884081a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a15a0ada5884081a$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a15a0ada5884081a$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a15a0ada5884081a$var$__getOwnPropSymbols) {
        for (var prop of $a15a0ada5884081a$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a15a0ada5884081a$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a15a0ada5884081a$var$defaultProps = {
    type: "unordered",
    size: "md",
    spacing: 0
};
const $a15a0ada5884081a$export$54c2e3dc7acea9f5 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("List", $a15a0ada5884081a$var$defaultProps, props), { children: children, type: type, size: size, listStyleType: listStyleType, withPadding: withPadding, center: center, spacing: spacing, icon: icon, className: className, styles: styles, classNames: classNames, unstyled: unstyled, variant: variant } = _a, others = $a15a0ada5884081a$var$__objRest(_a, [
        "children",
        "type",
        "size",
        "listStyleType",
        "withPadding",
        "center",
        "spacing",
        "icon",
        "className",
        "styles",
        "classNames",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $b8jBd.default)({
        withPadding: withPadding,
        listStyleType: listStyleType,
        center: center,
        spacing: spacing
    }, {
        classNames: classNames,
        styles: styles,
        name: "List",
        unstyled: unstyled,
        size: size,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $10yGc.ListProvider), {
        value: {
            spacing: spacing,
            center: center,
            icon: icon,
            listStyleType: listStyleType,
            size: size,
            withPadding: withPadding,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            variant: variant
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $a15a0ada5884081a$var$__spreadValues({
        component: type === "unordered" ? "ul" : "ol",
        className: cx(classes.root, className),
        ref: ref
    }, others), children));
});
$a15a0ada5884081a$export$54c2e3dc7acea9f5.Item = (0, $4zgRX.ListItem);
$a15a0ada5884081a$export$54c2e3dc7acea9f5.displayName = "@mantine/core/List";

});
parcelRegister("4zgRX", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $353784357461f7d0$export$a7b06bfba60a8a78);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $10yGc = parcelRequire("10yGc");

var $a59WZ = parcelRequire("a59WZ");

var $hiiR1 = parcelRequire("hiiR1");
var $353784357461f7d0$var$__defProp = Object.defineProperty;
var $353784357461f7d0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $353784357461f7d0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $353784357461f7d0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $353784357461f7d0$var$__defNormalProp = (obj, key, value)=>key in obj ? $353784357461f7d0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $353784357461f7d0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($353784357461f7d0$var$__hasOwnProp.call(b, prop)) $353784357461f7d0$var$__defNormalProp(a, prop, b[prop]);
    if ($353784357461f7d0$var$__getOwnPropSymbols) {
        for (var prop of $353784357461f7d0$var$__getOwnPropSymbols(b))if ($353784357461f7d0$var$__propIsEnum.call(b, prop)) $353784357461f7d0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $353784357461f7d0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($353784357461f7d0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $353784357461f7d0$var$__getOwnPropSymbols) {
        for (var prop of $353784357461f7d0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $353784357461f7d0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $353784357461f7d0$var$defaultProps = {};
const $353784357461f7d0$export$a7b06bfba60a8a78 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("ListItem", $353784357461f7d0$var$defaultProps, props), { className: className, children: children, icon: icon } = _a, others = $353784357461f7d0$var$__objRest(_a, [
        "className",
        "children",
        "icon"
    ]);
    const { icon: ctxIcon, spacing: spacing, center: center, listStyleType: listStyleType, size: size, withPadding: withPadding, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant } = (0, $10yGc.useListContext)();
    const _icon = icon || ctxIcon;
    const { classes: classes, cx: cx } = (0, $a59WZ.default)({
        withPadding: withPadding,
        listStyleType: listStyleType,
        center: center,
        spacing: spacing
    }, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        name: "List",
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $353784357461f7d0$var$__spreadValues({
        component: "li",
        className: cx(classes.item, className),
        "data-with-icon": !!_icon || void 0,
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.itemWrapper
    }, _icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.itemIcon
    }, _icon), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, children)));
});
$353784357461f7d0$export$a7b06bfba60a8a78.displayName = "@mantine/core/ListItem";

});
parcelRegister("10yGc", function(module, exports) {

$parcel$export(module.exports, "ListProvider", () => $0bc0b12a2e0f1102$export$9b0a72e5d41d62ec);
$parcel$export(module.exports, "useListContext", () => $0bc0b12a2e0f1102$export$b11084dc21db9fa4);

var $jIWSq = parcelRequire("jIWSq");
const [$0bc0b12a2e0f1102$export$9b0a72e5d41d62ec, $0bc0b12a2e0f1102$export$b11084dc21db9fa4] = (0, $jIWSq.createSafeContext)("List component was not found in tree");

});

parcelRegister("a59WZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $757216f4a7e5d295$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $3mzq6 = parcelRequire("3mzq6");
var $757216f4a7e5d295$var$useStyles = (0, $cQG1Y.createStyles)((theme, { spacing: spacing, center: center })=>({
        itemWrapper: {
            ref: (0, $3mzq6.getStylesRef)("itemWrapper"),
            display: "inline-flex",
            flexDirection: "column",
            whiteSpace: "normal"
        },
        item: {
            whiteSpace: "nowrap",
            lineHeight: center ? 1 : theme.lineHeight,
            "&:not(:first-of-type)": {
                marginTop: (0, $d8Ix8.getSize)({
                    size: spacing,
                    sizes: theme.spacing
                })
            },
            "&[data-with-icon]": {
                listStyle: "none",
                [`& .${(0, $3mzq6.getStylesRef)("itemWrapper")}`]: {
                    display: "inline-flex",
                    alignItems: center ? "center" : "flex-start",
                    flexDirection: "row"
                }
            }
        },
        itemIcon: {
            display: "inline-block",
            verticalAlign: "middle",
            marginRight: theme.spacing.sm
        }
    }));
var $757216f4a7e5d295$export$2e2bcd8739ae039 = $757216f4a7e5d295$var$useStyles;

});


parcelRegister("b8jBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $81afa511c3877142$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $81afa511c3877142$var$__defProp = Object.defineProperty;
var $81afa511c3877142$var$__defProps = Object.defineProperties;
var $81afa511c3877142$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $81afa511c3877142$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $81afa511c3877142$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $81afa511c3877142$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $81afa511c3877142$var$__defNormalProp = (obj, key, value)=>key in obj ? $81afa511c3877142$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $81afa511c3877142$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($81afa511c3877142$var$__hasOwnProp.call(b, prop)) $81afa511c3877142$var$__defNormalProp(a, prop, b[prop]);
    if ($81afa511c3877142$var$__getOwnPropSymbols) {
        for (var prop of $81afa511c3877142$var$__getOwnPropSymbols(b))if ($81afa511c3877142$var$__propIsEnum.call(b, prop)) $81afa511c3877142$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $81afa511c3877142$var$__spreadProps = (a, b)=>$81afa511c3877142$var$__defProps(a, $81afa511c3877142$var$__getOwnPropDescs(b));
var $81afa511c3877142$var$useStyles = (0, $cQG1Y.createStyles)((theme, { withPadding: withPadding, listStyleType: listStyleType }, { size: size })=>({
        root: $81afa511c3877142$var$__spreadProps($81afa511c3877142$var$__spreadValues({}, theme.fn.fontStyles()), {
            listStyleType: listStyleType,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            lineHeight: theme.lineHeight,
            margin: 0,
            paddingLeft: withPadding ? theme.spacing.xl : 0,
            listStylePosition: "inside"
        })
    }));
var $81afa511c3877142$export$2e2bcd8739ae039 = $81afa511c3877142$var$useStyles;

});


parcelRegister("aUqRb", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $7f13f78605e62d1c$export$d9b273488cd8ce6f);

var $acw62 = parcelRequire("acw62");

var $5Us8l = parcelRequire("5Us8l");
var $iLyVF = parcelRequire("iLyVF");

var $2qf6h = parcelRequire("2qf6h");
var $ke4gU = parcelRequire("ke4gU");

var $64A2P = parcelRequire("64A2P");

var $49F13 = parcelRequire("49F13");

var $h8up3 = parcelRequire("h8up3");

var $k8Ds0 = parcelRequire("k8Ds0");

var $lSx9N = parcelRequire("lSx9N");

var $hEWmf = parcelRequire("hEWmf");

var $9ODxx = parcelRequire("9ODxx");

var $e3vfm = parcelRequire("e3vfm");

var $5DA2R = parcelRequire("5DA2R");

var $6gwXS = parcelRequire("6gwXS");
var $7f13f78605e62d1c$var$__defProp = Object.defineProperty;
var $7f13f78605e62d1c$var$__defProps = Object.defineProperties;
var $7f13f78605e62d1c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7f13f78605e62d1c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7f13f78605e62d1c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7f13f78605e62d1c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7f13f78605e62d1c$var$__defNormalProp = (obj, key, value)=>key in obj ? $7f13f78605e62d1c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7f13f78605e62d1c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7f13f78605e62d1c$var$__hasOwnProp.call(b, prop)) $7f13f78605e62d1c$var$__defNormalProp(a, prop, b[prop]);
    if ($7f13f78605e62d1c$var$__getOwnPropSymbols) {
        for (var prop of $7f13f78605e62d1c$var$__getOwnPropSymbols(b))if ($7f13f78605e62d1c$var$__propIsEnum.call(b, prop)) $7f13f78605e62d1c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7f13f78605e62d1c$var$__spreadProps = (a, b)=>$7f13f78605e62d1c$var$__defProps(a, $7f13f78605e62d1c$var$__getOwnPropDescs(b));
var $7f13f78605e62d1c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($7f13f78605e62d1c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $7f13f78605e62d1c$var$__getOwnPropSymbols) {
        for (var prop of $7f13f78605e62d1c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $7f13f78605e62d1c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $7f13f78605e62d1c$var$defaultProps = {
    closeOnItemClick: true,
    loop: true,
    trigger: "click",
    openDelay: 0,
    closeDelay: 100
};
function $7f13f78605e62d1c$export$d9b273488cd8ce6f(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("Menu", $7f13f78605e62d1c$var$defaultProps, props), { children: children, onOpen: onOpen, onClose: onClose, opened: opened, defaultOpened: defaultOpened, onChange: onChange, closeOnItemClick: closeOnItemClick, loop: loop, closeOnEscape: closeOnEscape, trigger: trigger, openDelay: openDelay, closeDelay: closeDelay, classNames: classNames, styles: styles, unstyled: unstyled, radius: radius, variant: variant } = _a, others = $7f13f78605e62d1c$var$__objRest(_a, [
        "children",
        "onOpen",
        "onClose",
        "opened",
        "defaultOpened",
        "onChange",
        "closeOnItemClick",
        "loop",
        "closeOnEscape",
        "trigger",
        "openDelay",
        "closeDelay",
        "classNames",
        "styles",
        "unstyled",
        "radius",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $e3vfm.default)();
    const [hovered, { setHovered: setHovered, resetHovered: resetHovered }] = (0, $iLyVF.useHovered)();
    const [_opened, setOpened] = (0, $ke4gU.useUncontrolled)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onChange
    });
    const close = ()=>{
        setOpened(false);
        _opened && (onClose == null || onClose());
    };
    const open = ()=>{
        setOpened(true);
        !_opened && (onOpen == null || onOpen());
    };
    const toggleDropdown = ()=>_opened ? close() : open();
    const { openDropdown: openDropdown, closeDropdown: closeDropdown } = (0, $5DA2R.useDelayedHover)({
        open: open,
        close: close,
        closeDelay: closeDelay,
        openDelay: openDelay
    });
    const getItemIndex = (node)=>(0, $5Us8l.getContextItemIndex)("[data-menu-item]", "[data-menu-dropdown]", node);
    (0, $2qf6h.useDidUpdate)(()=>{
        resetHovered();
    }, [
        _opened
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ODxx.MenuContextProvider), {
        value: {
            opened: _opened,
            toggleDropdown: toggleDropdown,
            getItemIndex: getItemIndex,
            hovered: hovered,
            setHovered: setHovered,
            closeOnItemClick: closeOnItemClick,
            closeDropdown: trigger === "click" ? close : closeDropdown,
            openDropdown: trigger === "click" ? open : openDropdown,
            closeDropdownImmediately: close,
            loop: loop,
            trigger: trigger,
            radius: radius,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            variant: variant
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6gwXS.Popover), $7f13f78605e62d1c$var$__spreadProps($7f13f78605e62d1c$var$__spreadValues({}, others), {
        radius: radius,
        opened: _opened,
        onChange: toggleDropdown,
        defaultOpened: defaultOpened,
        trapFocus: trigger === "click" && _opened,
        closeOnEscape: closeOnEscape && trigger === "click",
        __staticSelector: "Menu",
        classNames: $7f13f78605e62d1c$var$__spreadProps($7f13f78605e62d1c$var$__spreadValues({}, classNames), {
            dropdown: cx(classes.dropdown, classNames == null ? void 0 : classNames.dropdown)
        }),
        styles: styles,
        unstyled: unstyled,
        variant: variant
    }), children));
}
$7f13f78605e62d1c$export$d9b273488cd8ce6f.displayName = "@mantine/core/Menu";
$7f13f78605e62d1c$export$d9b273488cd8ce6f.Item = (0, $k8Ds0.MenuItem);
$7f13f78605e62d1c$export$d9b273488cd8ce6f.Label = (0, $lSx9N.MenuLabel);
$7f13f78605e62d1c$export$d9b273488cd8ce6f.Dropdown = (0, $h8up3.MenuDropdown);
$7f13f78605e62d1c$export$d9b273488cd8ce6f.Target = (0, $hEWmf.MenuTarget);
$7f13f78605e62d1c$export$d9b273488cd8ce6f.Divider = (0, $49F13.MenuDivider);

});
parcelRegister("5Us8l", function(module, exports) {

$parcel$export(module.exports, "getContextItemIndex", () => $44d80171ac8bc2b6$export$b6cd2ea9779a9a9a);

var $77Fno = parcelRequire("77Fno");
function $44d80171ac8bc2b6$export$b6cd2ea9779a9a9a(elementSelector, parentSelector, node) {
    var _a;
    if (!node) return null;
    return Array.from(((_a = (0, $77Fno.findElementAncestor)(node, parentSelector)) == null ? void 0 : _a.querySelectorAll(elementSelector)) || []).findIndex((element)=>element === node);
}

});

parcelRegister("iLyVF", function(module, exports) {

$parcel$export(module.exports, "useHovered", () => $da97b5f66cd50c57$export$727aed1917ab7924);

var $acw62 = parcelRequire("acw62");
function $da97b5f66cd50c57$export$727aed1917ab7924() {
    const [hovered, setHovered] = (0, $acw62.useState)(-1);
    const resetHovered = ()=>setHovered(-1);
    return [
        hovered,
        {
            setHovered: setHovered,
            resetHovered: resetHovered
        }
    ];
}

});

parcelRegister("49F13", function(module, exports) {

$parcel$export(module.exports, "MenuDivider", () => $3067d1a2526a3a58$export$acb07b4664ac227c);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $9ODxx = parcelRequire("9ODxx");

var $axDbs = parcelRequire("axDbs");

var $hiiR1 = parcelRequire("hiiR1");
var $3067d1a2526a3a58$var$__defProp = Object.defineProperty;
var $3067d1a2526a3a58$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3067d1a2526a3a58$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3067d1a2526a3a58$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3067d1a2526a3a58$var$__defNormalProp = (obj, key, value)=>key in obj ? $3067d1a2526a3a58$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3067d1a2526a3a58$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3067d1a2526a3a58$var$__hasOwnProp.call(b, prop)) $3067d1a2526a3a58$var$__defNormalProp(a, prop, b[prop]);
    if ($3067d1a2526a3a58$var$__getOwnPropSymbols) {
        for (var prop of $3067d1a2526a3a58$var$__getOwnPropSymbols(b))if ($3067d1a2526a3a58$var$__propIsEnum.call(b, prop)) $3067d1a2526a3a58$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3067d1a2526a3a58$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3067d1a2526a3a58$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3067d1a2526a3a58$var$__getOwnPropSymbols) {
        for (var prop of $3067d1a2526a3a58$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3067d1a2526a3a58$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3067d1a2526a3a58$var$defaultProps = {};
const $3067d1a2526a3a58$export$acb07b4664ac227c = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("MenuDivider", $3067d1a2526a3a58$var$defaultProps, props), { children: children, className: className } = _a, others = $3067d1a2526a3a58$var$__objRest(_a, [
        "children",
        "className"
    ]);
    const { classNames: classNames, styles: styles, unstyled: unstyled, variant: variant } = (0, $9ODxx.useMenuContext)();
    const { classes: classes, cx: cx } = (0, $axDbs.default)(null, {
        name: "Menu",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $3067d1a2526a3a58$var$__spreadValues({
        className: cx(classes.divider, className),
        ref: ref
    }, others));
});
$3067d1a2526a3a58$export$acb07b4664ac227c.displayName = "@mantine/core/MenuDivider";

});
parcelRegister("9ODxx", function(module, exports) {

$parcel$export(module.exports, "MenuContextProvider", () => $7257745f55e21fa5$export$2cad3fd48ac06579);
$parcel$export(module.exports, "useMenuContext", () => $7257745f55e21fa5$export$21c7ab35b39f78ec);

var $jIWSq = parcelRequire("jIWSq");

var $k1FTT = parcelRequire("k1FTT");
const [$7257745f55e21fa5$export$2cad3fd48ac06579, $7257745f55e21fa5$export$21c7ab35b39f78ec] = (0, $jIWSq.createSafeContext)((0, $k1FTT.MENU_ERRORS).context);

});
parcelRegister("k1FTT", function(module, exports) {

$parcel$export(module.exports, "MENU_ERRORS", () => $e944673335dd97d7$export$b2044285a4dad098);
const $e944673335dd97d7$export$b2044285a4dad098 = {
    context: "Menu component was not found in the tree",
    children: "Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
};

});


parcelRegister("axDbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7acb618cbf758e25$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $7acb618cbf758e25$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        divider: {
            marginTop: (0, $2jkdX.rem)(4),
            marginBottom: (0, $2jkdX.rem)(4),
            borderTop: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2]}`
        }
    }));
var $7acb618cbf758e25$export$2e2bcd8739ae039 = $7acb618cbf758e25$var$useStyles;

});


parcelRegister("h8up3", function(module, exports) {

$parcel$export(module.exports, "MenuDropdown", () => $c79ac473c07773bb$export$c7794ca2de686af4);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $6X419 = parcelRequire("6X419");

var $9ODxx = parcelRequire("9ODxx");

var $6gwXS = parcelRequire("6gwXS");
var $c79ac473c07773bb$var$__defProp = Object.defineProperty;
var $c79ac473c07773bb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c79ac473c07773bb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c79ac473c07773bb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c79ac473c07773bb$var$__defNormalProp = (obj, key, value)=>key in obj ? $c79ac473c07773bb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c79ac473c07773bb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c79ac473c07773bb$var$__hasOwnProp.call(b, prop)) $c79ac473c07773bb$var$__defNormalProp(a, prop, b[prop]);
    if ($c79ac473c07773bb$var$__getOwnPropSymbols) {
        for (var prop of $c79ac473c07773bb$var$__getOwnPropSymbols(b))if ($c79ac473c07773bb$var$__propIsEnum.call(b, prop)) $c79ac473c07773bb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c79ac473c07773bb$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c79ac473c07773bb$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c79ac473c07773bb$var$__getOwnPropSymbols) {
        for (var prop of $c79ac473c07773bb$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c79ac473c07773bb$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c79ac473c07773bb$var$defaultProps = {};
function $c79ac473c07773bb$export$c7794ca2de686af4(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("MenuDropdown", $c79ac473c07773bb$var$defaultProps, props), { children: children, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = _a, others = $c79ac473c07773bb$var$__objRest(_a, [
        "children",
        "onMouseEnter",
        "onMouseLeave"
    ]);
    const wrapperRef = (0, $acw62.useRef)();
    const ctx = (0, $9ODxx.useMenuContext)();
    const handleKeyDown = (event)=>{
        var _a2;
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            (_a2 = wrapperRef.current.querySelectorAll("[data-menu-item]:not(:disabled)")[0]) == null || _a2.focus();
        }
    };
    const handleMouseEnter = (0, $6X419.createEventHandler)(onMouseEnter, ()=>ctx.trigger === "hover" && ctx.openDropdown());
    const handleMouseLeave = (0, $6X419.createEventHandler)(onMouseLeave, ()=>ctx.trigger === "hover" && ctx.closeDropdown());
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6gwXS.Popover).Dropdown, $c79ac473c07773bb$var$__spreadValues({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        role: "menu",
        "aria-orientation": "vertical"
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        tabIndex: -1,
        "data-menu-dropdown": true,
        "data-autofocus": true,
        onKeyDown: handleKeyDown,
        ref: wrapperRef,
        style: {
            outline: 0
        }
    }, children));
}
$c79ac473c07773bb$export$c7794ca2de686af4.displayName = "@mantine/core/MenuDropdown";

});
parcelRegister("6X419", function(module, exports) {

$parcel$export(module.exports, "createEventHandler", () => $50fb5e8f3fb86b10$export$48d1ea6320830260);
function $50fb5e8f3fb86b10$export$48d1ea6320830260(parentEventHandler, eventHandler) {
    return (event)=>{
        parentEventHandler == null || parentEventHandler(event);
        eventHandler == null || eventHandler(event);
    };
}

});


parcelRegister("k8Ds0", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $ea932817e7cfc3ad$export$2ce376c2cc3355c8);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $6X419 = parcelRequire("6X419");
var $1euea = parcelRequire("1euea");
var $j7bHu = parcelRequire("j7bHu");

var $4GmKa = parcelRequire("4GmKa");

var $9ODxx = parcelRequire("9ODxx");

var $9tZ0a = parcelRequire("9tZ0a");

var $hiiR1 = parcelRequire("hiiR1");
var $ea932817e7cfc3ad$var$__defProp = Object.defineProperty;
var $ea932817e7cfc3ad$var$__defProps = Object.defineProperties;
var $ea932817e7cfc3ad$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ea932817e7cfc3ad$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ea932817e7cfc3ad$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ea932817e7cfc3ad$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ea932817e7cfc3ad$var$__defNormalProp = (obj, key, value)=>key in obj ? $ea932817e7cfc3ad$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ea932817e7cfc3ad$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ea932817e7cfc3ad$var$__hasOwnProp.call(b, prop)) $ea932817e7cfc3ad$var$__defNormalProp(a, prop, b[prop]);
    if ($ea932817e7cfc3ad$var$__getOwnPropSymbols) {
        for (var prop of $ea932817e7cfc3ad$var$__getOwnPropSymbols(b))if ($ea932817e7cfc3ad$var$__propIsEnum.call(b, prop)) $ea932817e7cfc3ad$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ea932817e7cfc3ad$var$__spreadProps = (a, b)=>$ea932817e7cfc3ad$var$__defProps(a, $ea932817e7cfc3ad$var$__getOwnPropDescs(b));
var $ea932817e7cfc3ad$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ea932817e7cfc3ad$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ea932817e7cfc3ad$var$__getOwnPropSymbols) {
        for (var prop of $ea932817e7cfc3ad$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ea932817e7cfc3ad$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $ea932817e7cfc3ad$var$defaultProps = {};
const $ea932817e7cfc3ad$export$d7c6a5534d3f2c82 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("MenuItem", $ea932817e7cfc3ad$var$defaultProps, props), { children: children, className: className, color: color, closeMenuOnClick: closeMenuOnClick, icon: icon, rightSection: rightSection } = _a, others = $ea932817e7cfc3ad$var$__objRest(_a, [
        "children",
        "className",
        "color",
        "closeMenuOnClick",
        "icon",
        "rightSection"
    ]);
    const ctx = (0, $9ODxx.useMenuContext)();
    const { classes: classes, cx: cx, theme: theme } = (0, $9tZ0a.default)({
        radius: ctx.radius,
        color: color
    }, {
        name: "Menu",
        classNames: ctx.classNames,
        styles: ctx.styles,
        unstyled: ctx.unstyled,
        variant: ctx.variant
    });
    const itemRef = (0, $acw62.useRef)();
    const itemIndex = ctx.getItemIndex(itemRef.current);
    const _others = others;
    const handleMouseLeave = (0, $6X419.createEventHandler)(_others.onMouseLeave, ()=>ctx.setHovered(-1));
    const handleMouseEnter = (0, $6X419.createEventHandler)(_others.onMouseEnter, ()=>ctx.setHovered(ctx.getItemIndex(itemRef.current)));
    const handleClick = (0, $6X419.createEventHandler)(_others.onClick, ()=>{
        if (typeof closeMenuOnClick === "boolean") closeMenuOnClick && ctx.closeDropdownImmediately();
        else ctx.closeOnItemClick && ctx.closeDropdownImmediately();
    });
    const handleFocus = (0, $6X419.createEventHandler)(_others.onFocus, ()=>ctx.setHovered(ctx.getItemIndex(itemRef.current)));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $ea932817e7cfc3ad$var$__spreadProps($ea932817e7cfc3ad$var$__spreadValues({
        component: "button",
        type: "button"
    }, others), {
        tabIndex: -1,
        onFocus: handleFocus,
        className: cx(classes.item, className),
        ref: (0, $4GmKa.useMergedRef)(itemRef, ref),
        role: "menuitem",
        "data-menu-item": true,
        "data-hovered": ctx.hovered === itemIndex ? true : void 0,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick,
        onKeyDown: (0, $j7bHu.createScopedKeydownHandler)({
            siblingSelector: "[data-menu-item]",
            parentSelector: "[data-menu-dropdown]",
            activateOnFocus: false,
            loop: ctx.loop,
            dir: theme.dir,
            orientation: "vertical",
            onKeyDown: _others.onKeydown
        })
    }), icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.itemIcon
    }, icon), children && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.itemLabel
    }, children), rightSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.itemRightSection
    }, rightSection));
});
$ea932817e7cfc3ad$export$d7c6a5534d3f2c82.displayName = "@mantine/core/MenuItem";
const $ea932817e7cfc3ad$export$2ce376c2cc3355c8 = (0, $1euea.createPolymorphicComponent)($ea932817e7cfc3ad$export$d7c6a5534d3f2c82);

});
parcelRegister("9tZ0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7624255cdbabc7$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $6e7624255cdbabc7$var$__defProp = Object.defineProperty;
var $6e7624255cdbabc7$var$__defProps = Object.defineProperties;
var $6e7624255cdbabc7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6e7624255cdbabc7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6e7624255cdbabc7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6e7624255cdbabc7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6e7624255cdbabc7$var$__defNormalProp = (obj, key, value)=>key in obj ? $6e7624255cdbabc7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6e7624255cdbabc7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6e7624255cdbabc7$var$__hasOwnProp.call(b, prop)) $6e7624255cdbabc7$var$__defNormalProp(a, prop, b[prop]);
    if ($6e7624255cdbabc7$var$__getOwnPropSymbols) {
        for (var prop of $6e7624255cdbabc7$var$__getOwnPropSymbols(b))if ($6e7624255cdbabc7$var$__propIsEnum.call(b, prop)) $6e7624255cdbabc7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6e7624255cdbabc7$var$__spreadProps = (a, b)=>$6e7624255cdbabc7$var$__defProps(a, $6e7624255cdbabc7$var$__getOwnPropDescs(b));
var $6e7624255cdbabc7$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, radius: radius })=>({
        item: $6e7624255cdbabc7$var$__spreadProps($6e7624255cdbabc7$var$__spreadValues({}, theme.fn.fontStyles()), {
            WebkitTapHighlightColor: "transparent",
            fontSize: theme.fontSizes.sm,
            border: 0,
            backgroundColor: "transparent",
            outline: 0,
            width: "100%",
            textAlign: "left",
            textDecoration: "none",
            boxSizing: "border-box",
            padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
            cursor: "pointer",
            borderRadius: theme.fn.radius(radius),
            color: color ? theme.fn.variant({
                variant: "filled",
                primaryFallback: false,
                color: color
            }).background : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            display: "flex",
            alignItems: "center",
            "&:disabled": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5],
                pointerEvents: "none",
                userSelect: "none"
            },
            "&[data-hovered]": {
                backgroundColor: color ? theme.fn.variant({
                    variant: "light",
                    color: color
                }).background : theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[3], 0.35) : theme.colors.gray[1]
            }
        }),
        itemLabel: {
            flex: 1
        },
        itemIcon: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: theme.spacing.xs
        },
        itemRightSection: {}
    }));
var $6e7624255cdbabc7$export$2e2bcd8739ae039 = $6e7624255cdbabc7$var$useStyles;

});


parcelRegister("lSx9N", function(module, exports) {

$parcel$export(module.exports, "MenuLabel", () => $fed85c68996dcc90$export$dd37bec0e8a99143);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $9ODxx = parcelRequire("9ODxx");

var $cffJ1 = parcelRequire("cffJ1");

var $cjohz = parcelRequire("cjohz");
var $fed85c68996dcc90$var$__defProp = Object.defineProperty;
var $fed85c68996dcc90$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $fed85c68996dcc90$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fed85c68996dcc90$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $fed85c68996dcc90$var$__defNormalProp = (obj, key, value)=>key in obj ? $fed85c68996dcc90$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fed85c68996dcc90$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($fed85c68996dcc90$var$__hasOwnProp.call(b, prop)) $fed85c68996dcc90$var$__defNormalProp(a, prop, b[prop]);
    if ($fed85c68996dcc90$var$__getOwnPropSymbols) {
        for (var prop of $fed85c68996dcc90$var$__getOwnPropSymbols(b))if ($fed85c68996dcc90$var$__propIsEnum.call(b, prop)) $fed85c68996dcc90$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $fed85c68996dcc90$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($fed85c68996dcc90$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $fed85c68996dcc90$var$__getOwnPropSymbols) {
        for (var prop of $fed85c68996dcc90$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $fed85c68996dcc90$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $fed85c68996dcc90$var$defaultProps = {};
const $fed85c68996dcc90$export$dd37bec0e8a99143 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("MenuLabel", $fed85c68996dcc90$var$defaultProps, props), { children: children, className: className } = _a, others = $fed85c68996dcc90$var$__objRest(_a, [
        "children",
        "className"
    ]);
    const { classNames: classNames, styles: styles, unstyled: unstyled, variant: variant } = (0, $9ODxx.useMenuContext)();
    const { classes: classes, cx: cx } = (0, $cffJ1.default)(null, {
        name: "Menu",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), $fed85c68996dcc90$var$__spreadValues({
        className: cx(classes.label, className),
        ref: ref
    }, others), children);
});
$fed85c68996dcc90$export$dd37bec0e8a99143.displayName = "@mantine/core/MenuLabel";

});
parcelRegister("cffJ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ea3156bf0c27103$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $8ea3156bf0c27103$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        label: {
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
            fontWeight: 500,
            fontSize: theme.fontSizes.xs,
            padding: `calc(${theme.spacing.xs} / 2) ${theme.spacing.sm}`,
            cursor: "default"
        }
    }));
var $8ea3156bf0c27103$export$2e2bcd8739ae039 = $8ea3156bf0c27103$var$useStyles;

});


parcelRegister("hEWmf", function(module, exports) {

$parcel$export(module.exports, "MenuTarget", () => $cdb370bd4987c228$export$4907565bcbceec95);

var $acw62 = parcelRequire("acw62");

var $6X419 = parcelRequire("6X419");
var $cOXe5 = parcelRequire("cOXe5");

var $64A2P = parcelRequire("64A2P");

var $9ODxx = parcelRequire("9ODxx");

var $k1FTT = parcelRequire("k1FTT");

var $6gwXS = parcelRequire("6gwXS");
var $cdb370bd4987c228$var$__defProp = Object.defineProperty;
var $cdb370bd4987c228$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cdb370bd4987c228$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cdb370bd4987c228$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cdb370bd4987c228$var$__defNormalProp = (obj, key, value)=>key in obj ? $cdb370bd4987c228$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cdb370bd4987c228$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cdb370bd4987c228$var$__hasOwnProp.call(b, prop)) $cdb370bd4987c228$var$__defNormalProp(a, prop, b[prop]);
    if ($cdb370bd4987c228$var$__getOwnPropSymbols) {
        for (var prop of $cdb370bd4987c228$var$__getOwnPropSymbols(b))if ($cdb370bd4987c228$var$__propIsEnum.call(b, prop)) $cdb370bd4987c228$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cdb370bd4987c228$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($cdb370bd4987c228$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $cdb370bd4987c228$var$__getOwnPropSymbols) {
        for (var prop of $cdb370bd4987c228$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $cdb370bd4987c228$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $cdb370bd4987c228$var$defaultProps = {
    refProp: "ref"
};
const $cdb370bd4987c228$export$4907565bcbceec95 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("MenuTarget", $cdb370bd4987c228$var$defaultProps, props), { children: children, refProp: refProp } = _a, others = $cdb370bd4987c228$var$__objRest(_a, [
        "children",
        "refProp"
    ]);
    if (!(0, $cOXe5.isElement)(children)) throw new Error((0, $k1FTT.MENU_ERRORS).children);
    const ctx = (0, $9ODxx.useMenuContext)();
    const onClick = (0, $6X419.createEventHandler)(children.props.onClick, ()=>ctx.trigger === "click" && ctx.toggleDropdown());
    const onMouseEnter = (0, $6X419.createEventHandler)(children.props.onMouseEnter, ()=>ctx.trigger === "hover" && ctx.openDropdown());
    const onMouseLeave = (0, $6X419.createEventHandler)(children.props.onMouseLeave, ()=>ctx.trigger === "hover" && ctx.closeDropdown());
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6gwXS.Popover).Target, $cdb370bd4987c228$var$__spreadValues({
        refProp: refProp,
        popupType: "menu",
        ref: ref
    }, others), (0, $acw62.cloneElement)(children, {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-expanded": ctx.opened ? true : void 0
    }));
});
$cdb370bd4987c228$export$4907565bcbceec95.displayName = "@mantine/core/MenuTarget";

});

parcelRegister("e3vfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b9957474bc7357$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $a3b9957474bc7357$var$useStyles = (0, $cQG1Y.createStyles)({
    dropdown: {
        padding: (0, $2jkdX.rem)(4)
    }
});
var $a3b9957474bc7357$export$2e2bcd8739ae039 = $a3b9957474bc7357$var$useStyles;

});

parcelRegister("5DA2R", function(module, exports) {

$parcel$export(module.exports, "useDelayedHover", () => $41ac8e13228ed481$export$7771a820816ce7f1);

var $acw62 = parcelRequire("acw62");
function $41ac8e13228ed481$export$7771a820816ce7f1({ open: open, close: close, openDelay: openDelay, closeDelay: closeDelay }) {
    const openTimeout = (0, $acw62.useRef)(-1);
    const closeTimeout = (0, $acw62.useRef)(-1);
    const clearTimeouts = ()=>{
        window.clearTimeout(openTimeout.current);
        window.clearTimeout(closeTimeout.current);
    };
    const openDropdown = ()=>{
        clearTimeouts();
        if (openDelay === 0) open();
        else openTimeout.current = window.setTimeout(open, openDelay);
    };
    const closeDropdown = ()=>{
        clearTimeouts();
        if (closeDelay === 0) close();
        else closeTimeout.current = window.setTimeout(close, closeDelay);
    };
    (0, $acw62.useEffect)(()=>clearTimeouts, []);
    return {
        openDropdown: openDropdown,
        closeDropdown: closeDropdown
    };
}

});


parcelRegister("8LzkP", function(module, exports) {

$parcel$export(module.exports, "MultiSelect", () => $661e1f4c4264f19c$export$1e7dfd31545b5809);

var $acw62 = parcelRequire("acw62");

var $2qf6h = parcelRequire("2qf6h");
var $8nBd8 = parcelRequire("8nBd8");
var $4GmKa = parcelRequire("4GmKa");
var $7DS5l = parcelRequire("7DS5l");
var $ke4gU = parcelRequire("ke4gU");

var $iu1L3 = parcelRequire("iu1L3");
var $64A2P = parcelRequire("64A2P");

var $6Lcfd = parcelRequire("6Lcfd");

var $e4375 = parcelRequire("e4375");

var $5dIV6 = parcelRequire("5dIV6");

var $4BPQI = parcelRequire("4BPQI");

var $j3D7l = parcelRequire("j3D7l");

var $1egdU = parcelRequire("1egdU");

var $cojj3 = parcelRequire("cojj3");

var $g41PE = parcelRequire("g41PE");

var $5aOK5 = parcelRequire("5aOK5");

var $aEkmw = parcelRequire("aEkmw");

var $gw63X = parcelRequire("gw63X");
var $661e1f4c4264f19c$var$__defProp = Object.defineProperty;
var $661e1f4c4264f19c$var$__defProps = Object.defineProperties;
var $661e1f4c4264f19c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $661e1f4c4264f19c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $661e1f4c4264f19c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $661e1f4c4264f19c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $661e1f4c4264f19c$var$__defNormalProp = (obj, key, value)=>key in obj ? $661e1f4c4264f19c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $661e1f4c4264f19c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($661e1f4c4264f19c$var$__hasOwnProp.call(b, prop)) $661e1f4c4264f19c$var$__defNormalProp(a, prop, b[prop]);
    if ($661e1f4c4264f19c$var$__getOwnPropSymbols) {
        for (var prop of $661e1f4c4264f19c$var$__getOwnPropSymbols(b))if ($661e1f4c4264f19c$var$__propIsEnum.call(b, prop)) $661e1f4c4264f19c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $661e1f4c4264f19c$var$__spreadProps = (a, b)=>$661e1f4c4264f19c$var$__defProps(a, $661e1f4c4264f19c$var$__getOwnPropDescs(b));
var $661e1f4c4264f19c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($661e1f4c4264f19c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $661e1f4c4264f19c$var$__getOwnPropSymbols) {
        for (var prop of $661e1f4c4264f19c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $661e1f4c4264f19c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $661e1f4c4264f19c$export$3f6f640afaf1ec43(value, selected, item) {
    if (selected) return false;
    return item.label.toLowerCase().trim().includes(value.toLowerCase().trim());
}
function $661e1f4c4264f19c$export$3b1016ee7f09c57(query, data) {
    return !!query && !data.some((item)=>item.value.toLowerCase() === query.toLowerCase());
}
function $661e1f4c4264f19c$var$filterValue(value, data) {
    if (!Array.isArray(value)) return void 0;
    if (data.length === 0) return [];
    const flatData = data.map((item)=>{
        if (typeof item === "object") return item.value;
        return item;
    });
    return value.filter((val)=>flatData.includes(val));
}
const $661e1f4c4264f19c$var$defaultProps = {
    size: "sm",
    valueComponent: (0, $e4375.DefaultValue),
    itemComponent: (0, $5dIV6.DefaultItem),
    transitionProps: {
        transition: "fade",
        duration: 0
    },
    maxDropdownHeight: 220,
    shadow: "sm",
    searchable: false,
    filter: $661e1f4c4264f19c$export$3f6f640afaf1ec43,
    limit: Infinity,
    clearSearchOnChange: true,
    clearable: false,
    clearSearchOnBlur: false,
    disabled: false,
    initiallyOpened: false,
    creatable: false,
    shouldCreate: $661e1f4c4264f19c$export$3b1016ee7f09c57,
    switchDirectionOnFlip: false,
    zIndex: (0, $iu1L3.getDefaultZIndex)("popover"),
    selectOnBlur: false,
    positionDependencies: [],
    dropdownPosition: "flip"
};
const $661e1f4c4264f19c$export$1e7dfd31545b5809 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("MultiSelect", $661e1f4c4264f19c$var$defaultProps, props), { className: className, style: style, required: required, label: label, description: description, size: size, error: error, classNames: classNames, styles: styles, wrapperProps: wrapperProps, value: value, defaultValue: defaultValue, data: data, onChange: onChange, valueComponent: Value, itemComponent: itemComponent, id: id, transitionProps: transitionProps, maxDropdownHeight: maxDropdownHeight, shadow: shadow, nothingFound: nothingFound, onFocus: onFocus, onBlur: onBlur, searchable: searchable, placeholder: placeholder, filter: filter, limit: limit, clearSearchOnChange: clearSearchOnChange, clearable: clearable, clearSearchOnBlur: clearSearchOnBlur, variant: variant, onSearchChange: onSearchChange, searchValue: searchValue, disabled: disabled, initiallyOpened: initiallyOpened, radius: radius, icon: icon, rightSection: rightSection, rightSectionWidth: rightSectionWidth, creatable: creatable, getCreateLabel: getCreateLabel, shouldCreate: shouldCreate, onCreate: onCreate, sx: sx, dropdownComponent: dropdownComponent, onDropdownClose: onDropdownClose, onDropdownOpen: onDropdownOpen, maxSelectedValues: maxSelectedValues, withinPortal: withinPortal, portalProps: portalProps, switchDirectionOnFlip: switchDirectionOnFlip, zIndex: zIndex, selectOnBlur: selectOnBlur, name: name, dropdownPosition: dropdownPosition, errorProps: errorProps, labelProps: labelProps, descriptionProps: descriptionProps, form: form, positionDependencies: positionDependencies, onKeyDown: onKeyDown, unstyled: unstyled, inputContainer: inputContainer, inputWrapperOrder: inputWrapperOrder, readOnly: readOnly, withAsterisk: withAsterisk, clearButtonProps: clearButtonProps, hoverOnSearchChange: hoverOnSearchChange, disableSelectedItemFiltering: disableSelectedItemFiltering } = _a, others = $661e1f4c4264f19c$var$__objRest(_a, [
        "className",
        "style",
        "required",
        "label",
        "description",
        "size",
        "error",
        "classNames",
        "styles",
        "wrapperProps",
        "value",
        "defaultValue",
        "data",
        "onChange",
        "valueComponent",
        "itemComponent",
        "id",
        "transitionProps",
        "maxDropdownHeight",
        "shadow",
        "nothingFound",
        "onFocus",
        "onBlur",
        "searchable",
        "placeholder",
        "filter",
        "limit",
        "clearSearchOnChange",
        "clearable",
        "clearSearchOnBlur",
        "variant",
        "onSearchChange",
        "searchValue",
        "disabled",
        "initiallyOpened",
        "radius",
        "icon",
        "rightSection",
        "rightSectionWidth",
        "creatable",
        "getCreateLabel",
        "shouldCreate",
        "onCreate",
        "sx",
        "dropdownComponent",
        "onDropdownClose",
        "onDropdownOpen",
        "maxSelectedValues",
        "withinPortal",
        "portalProps",
        "switchDirectionOnFlip",
        "zIndex",
        "selectOnBlur",
        "name",
        "dropdownPosition",
        "errorProps",
        "labelProps",
        "descriptionProps",
        "form",
        "positionDependencies",
        "onKeyDown",
        "unstyled",
        "inputContainer",
        "inputWrapperOrder",
        "readOnly",
        "withAsterisk",
        "clearButtonProps",
        "hoverOnSearchChange",
        "disableSelectedItemFiltering"
    ]);
    const { classes: classes, cx: cx, theme: theme } = (0, $5aOK5.default)({
        invalid: !!error
    }, {
        name: "MultiSelect",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        size: size,
        variant: variant
    });
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const inputRef = (0, $acw62.useRef)();
    const itemsRefs = (0, $acw62.useRef)({});
    const uuid = (0, $8nBd8.useId)(id);
    const [dropdownOpened, setDropdownOpened] = (0, $acw62.useState)(initiallyOpened);
    const [_hovered, setHovered] = (0, $acw62.useState)(-1);
    const [direction, setDirection] = (0, $acw62.useState)("column");
    const [_searchValue, handleSearchChange] = (0, $ke4gU.useUncontrolled)({
        value: searchValue,
        defaultValue: "",
        finalValue: void 0,
        onChange: onSearchChange
    });
    const [IMEOpen, setIMEOpen] = (0, $acw62.useState)(false);
    const { scrollIntoView: scrollIntoView, targetRef: targetRef, scrollableRef: scrollableRef } = (0, $7DS5l.useScrollIntoView)({
        duration: 0,
        offset: 5,
        cancelable: false,
        isList: true
    });
    const isCreatable = creatable && typeof getCreateLabel === "function";
    let createLabel = null;
    const formattedData = data.map((item)=>typeof item === "string" ? {
            label: item,
            value: item
        } : item);
    const sortedData = (0, $6Lcfd.groupOptions)({
        data: formattedData
    });
    const [_value, setValue] = (0, $ke4gU.useUncontrolled)({
        value: $661e1f4c4264f19c$var$filterValue(value, data),
        defaultValue: $661e1f4c4264f19c$var$filterValue(defaultValue, data),
        finalValue: [],
        onChange: onChange
    });
    const valuesOverflow = (0, $acw62.useRef)(!!maxSelectedValues && maxSelectedValues < _value.length);
    const handleValueRemove = (_val)=>{
        if (!readOnly) {
            const newValue = _value.filter((val)=>val !== _val);
            setValue(newValue);
            if (!!maxSelectedValues && newValue.length < maxSelectedValues) valuesOverflow.current = false;
        }
    };
    const handleInputChange = (event)=>{
        handleSearchChange(event.currentTarget.value);
        !disabled && !valuesOverflow.current && searchable && setDropdownOpened(true);
    };
    const handleInputFocus = (event)=>{
        typeof onFocus === "function" && onFocus(event);
        !disabled && !valuesOverflow.current && searchable && setDropdownOpened(true);
    };
    const filteredData = (0, $4BPQI.filterData)({
        data: sortedData,
        searchable: searchable,
        searchValue: _searchValue,
        limit: limit,
        filter: filter,
        value: _value,
        disableSelectedItemFiltering: disableSelectedItemFiltering
    });
    if (isCreatable && shouldCreate(_searchValue, sortedData)) {
        createLabel = getCreateLabel(_searchValue);
        filteredData.push({
            label: _searchValue,
            value: _searchValue,
            creatable: true
        });
    }
    const hovered = Math.min(_hovered, filteredData.length - 1);
    const getNextIndex = (index, nextItem, compareFn)=>{
        let i = index;
        while(compareFn(i)){
            i = nextItem(i);
            if (!filteredData[i].disabled) return i;
        }
        return index;
    };
    (0, $2qf6h.useDidUpdate)(()=>{
        if (hoverOnSearchChange && _searchValue) setHovered(0);
        else setHovered(-1);
    }, [
        _searchValue,
        hoverOnSearchChange
    ]);
    (0, $2qf6h.useDidUpdate)(()=>{
        if (!disabled && _value.length > data.length) setDropdownOpened(false);
        if (!!maxSelectedValues && _value.length < maxSelectedValues) valuesOverflow.current = false;
        if (!!maxSelectedValues && _value.length >= maxSelectedValues) {
            valuesOverflow.current = true;
            setDropdownOpened(false);
        }
    }, [
        _value
    ]);
    const handleItemSelect = (item)=>{
        if (!readOnly) {
            clearSearchOnChange && handleSearchChange("");
            if (_value.includes(item.value)) handleValueRemove(item.value);
            else {
                if (item.creatable && typeof onCreate === "function") {
                    const createdItem = onCreate(item.value);
                    if (typeof createdItem !== "undefined" && createdItem !== null) {
                        if (typeof createdItem === "string") setValue([
                            ..._value,
                            createdItem
                        ]);
                        else setValue([
                            ..._value,
                            createdItem.value
                        ]);
                    }
                } else setValue([
                    ..._value,
                    item.value
                ]);
                if (_value.length === maxSelectedValues - 1) {
                    valuesOverflow.current = true;
                    setDropdownOpened(false);
                }
                if (filteredData.length === 1) setDropdownOpened(false);
            }
        }
    };
    const handleInputBlur = (event)=>{
        typeof onBlur === "function" && onBlur(event);
        if (selectOnBlur && filteredData[hovered] && dropdownOpened) handleItemSelect(filteredData[hovered]);
        clearSearchOnBlur && handleSearchChange("");
        setDropdownOpened(false);
    };
    const handleInputKeydown = (event)=>{
        if (IMEOpen) return;
        onKeyDown == null || onKeyDown(event);
        if (readOnly) return;
        if (event.key !== "Backspace" && !!maxSelectedValues && valuesOverflow.current) return;
        const isColumn = direction === "column";
        const handleNext = ()=>{
            setHovered((current)=>{
                var _a2;
                const nextIndex = getNextIndex(current, (index)=>index + 1, (index)=>index < filteredData.length - 1);
                if (dropdownOpened) {
                    targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
                    scrollIntoView({
                        alignment: isColumn ? "end" : "start"
                    });
                }
                return nextIndex;
            });
        };
        const handlePrevious = ()=>{
            setHovered((current)=>{
                var _a2;
                const nextIndex = getNextIndex(current, (index)=>index - 1, (index)=>index > 0);
                if (dropdownOpened) {
                    targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
                    scrollIntoView({
                        alignment: isColumn ? "start" : "end"
                    });
                }
                return nextIndex;
            });
        };
        switch(event.key){
            case "ArrowUp":
                event.preventDefault();
                setDropdownOpened(true);
                isColumn ? handlePrevious() : handleNext();
                break;
            case "ArrowDown":
                event.preventDefault();
                setDropdownOpened(true);
                isColumn ? handleNext() : handlePrevious();
                break;
            case "Enter":
                event.preventDefault();
                if (filteredData[hovered] && dropdownOpened) handleItemSelect(filteredData[hovered]);
                else setDropdownOpened(true);
                break;
            case " ":
                if (!searchable) {
                    event.preventDefault();
                    if (filteredData[hovered] && dropdownOpened) handleItemSelect(filteredData[hovered]);
                    else setDropdownOpened(true);
                }
                break;
            case "Backspace":
                if (_value.length > 0 && _searchValue.length === 0) {
                    setValue(_value.slice(0, -1));
                    setDropdownOpened(true);
                    if (maxSelectedValues) valuesOverflow.current = false;
                }
                break;
            case "Home":
                if (!searchable) {
                    event.preventDefault();
                    if (!dropdownOpened) setDropdownOpened(true);
                    const firstItemIndex = filteredData.findIndex((item)=>!item.disabled);
                    setHovered(firstItemIndex);
                    scrollIntoView({
                        alignment: isColumn ? "end" : "start"
                    });
                }
                break;
            case "End":
                if (!searchable) {
                    event.preventDefault();
                    if (!dropdownOpened) setDropdownOpened(true);
                    const lastItemIndex = filteredData.map((item)=>!!item.disabled).lastIndexOf(false);
                    setHovered(lastItemIndex);
                    scrollIntoView({
                        alignment: isColumn ? "end" : "start"
                    });
                }
                break;
            case "Escape":
                setDropdownOpened(false);
        }
    };
    const selectedItems = _value.map((val)=>{
        let selectedItem = sortedData.find((item)=>item.value === val && !item.disabled);
        if (!selectedItem && isCreatable) selectedItem = {
            value: val,
            label: val
        };
        return selectedItem;
    }).filter((val)=>!!val).map((item, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Value, $661e1f4c4264f19c$var$__spreadProps($661e1f4c4264f19c$var$__spreadValues({}, item), {
            variant: variant,
            disabled: disabled,
            className: classes.value,
            readOnly: readOnly,
            onRemove: (event)=>{
                event.preventDefault();
                event.stopPropagation();
                handleValueRemove(item.value);
            },
            key: item.value,
            size: size,
            styles: styles,
            classNames: classNames,
            radius: radius,
            index: index
        })));
    const isItemSelected = (itemValue)=>_value.includes(itemValue);
    const handleClear = ()=>{
        var _a2;
        handleSearchChange("");
        setValue([]);
        (_a2 = inputRef.current) == null || _a2.focus();
        if (maxSelectedValues) valuesOverflow.current = false;
    };
    const shouldRenderDropdown = !readOnly && (filteredData.length > 0 ? dropdownOpened : dropdownOpened && !!nothingFound);
    (0, $2qf6h.useDidUpdate)(()=>{
        const handler = shouldRenderDropdown ? onDropdownOpen : onDropdownClose;
        typeof handler === "function" && handler();
    }, [
        shouldRenderDropdown
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $661e1f4c4264f19c$var$__spreadValues($661e1f4c4264f19c$var$__spreadValues({
        required: required,
        id: uuid,
        label: label,
        error: error,
        description: description,
        size: size,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        __staticSelector: "MultiSelect",
        sx: sx,
        errorProps: errorProps,
        descriptionProps: descriptionProps,
        labelProps: labelProps,
        inputContainer: inputContainer,
        inputWrapperOrder: inputWrapperOrder,
        unstyled: unstyled,
        withAsterisk: withAsterisk,
        variant: variant
    }, systemStyles), wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover), {
        opened: shouldRenderDropdown,
        transitionProps: transitionProps,
        shadow: "sm",
        withinPortal: withinPortal,
        portalProps: portalProps,
        __staticSelector: "MultiSelect",
        onDirectionChange: setDirection,
        switchDirectionOnFlip: switchDirectionOnFlip,
        zIndex: zIndex,
        dropdownPosition: dropdownPosition,
        positionDependencies: [
            ...positionDependencies,
            _searchValue
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover).Target, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.wrapper,
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-owns": dropdownOpened && shouldRenderDropdown ? `${uuid}-items` : null,
        "aria-controls": uuid,
        "aria-expanded": dropdownOpened,
        onMouseLeave: ()=>setHovered(-1),
        tabIndex: -1
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "hidden",
        name: name,
        value: _value.join(","),
        form: form,
        disabled: disabled
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), $661e1f4c4264f19c$var$__spreadValues({
        __staticSelector: "MultiSelect",
        style: {
            overflow: "hidden"
        },
        component: "div",
        multiline: true,
        size: size,
        variant: variant,
        disabled: disabled,
        error: error,
        required: required,
        radius: radius,
        icon: icon,
        unstyled: unstyled,
        onMouseDown: (event)=>{
            var _a2;
            event.preventDefault();
            !disabled && !valuesOverflow.current && setDropdownOpened(!dropdownOpened);
            (_a2 = inputRef.current) == null || _a2.focus();
        },
        classNames: $661e1f4c4264f19c$var$__spreadProps($661e1f4c4264f19c$var$__spreadValues({}, classNames), {
            input: cx({
                [classes.input]: !searchable
            }, classNames == null ? void 0 : classNames.input)
        })
    }, (0, $j3D7l.getSelectRightSectionProps)({
        theme: theme,
        rightSection: rightSection,
        rightSectionWidth: rightSectionWidth,
        styles: styles,
        size: size,
        shouldClear: clearable && _value.length > 0,
        onClear: handleClear,
        error: error,
        disabled: disabled,
        clearButtonProps: clearButtonProps,
        readOnly: readOnly
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.values,
        "data-clearable": clearable || void 0
    }, selectedItems, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $661e1f4c4264f19c$var$__spreadValues({
        ref: (0, $4GmKa.useMergedRef)(ref, inputRef),
        type: "search",
        id: uuid,
        className: cx(classes.searchInput, {
            [classes.searchInputPointer]: !searchable,
            [classes.searchInputInputHidden]: !dropdownOpened && _value.length > 0 || !searchable && _value.length > 0,
            [classes.searchInputEmpty]: _value.length === 0
        }),
        onKeyDown: handleInputKeydown,
        value: _searchValue,
        onChange: handleInputChange,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        readOnly: !searchable || valuesOverflow.current || readOnly,
        placeholder: _value.length === 0 ? placeholder : void 0,
        disabled: disabled,
        "data-mantine-stop-propagation": dropdownOpened,
        autoComplete: "off",
        onCompositionStart: ()=>setIMEOpen(true),
        onCompositionEnd: ()=>setIMEOpen(false)
    }, rest)))))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover).Dropdown, {
        component: dropdownComponent || (0, $1egdU.SelectScrollArea),
        maxHeight: maxDropdownHeight,
        direction: direction,
        id: uuid,
        innerRef: scrollableRef,
        __staticSelector: "MultiSelect",
        classNames: classNames,
        styles: styles
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g41PE.SelectItems), {
        data: filteredData,
        hovered: hovered,
        classNames: classNames,
        styles: styles,
        uuid: uuid,
        __staticSelector: "MultiSelect",
        onItemHover: setHovered,
        onItemSelect: handleItemSelect,
        itemsRefs: itemsRefs,
        itemComponent: itemComponent,
        size: size,
        nothingFound: nothingFound,
        isItemSelected: isItemSelected,
        creatable: creatable && !!createLabel,
        createLabel: createLabel,
        unstyled: unstyled,
        variant: variant
    }))));
});
$661e1f4c4264f19c$export$1e7dfd31545b5809.displayName = "@mantine/core/MultiSelect";

});
parcelRegister("7DS5l", function(module, exports) {

$parcel$export(module.exports, "useScrollIntoView", () => $016f952dfd64a56d$export$c05432b4b8843105);

var $acw62 = parcelRequire("acw62");

var $hG392 = parcelRequire("hG392");

var $dmiju = parcelRequire("dmiju");

var $jMDKX = parcelRequire("jMDKX");

var $87wFj = parcelRequire("87wFj");

var $6PtMK = parcelRequire("6PtMK");

var $ljSup = parcelRequire("ljSup");
function $016f952dfd64a56d$export$c05432b4b8843105({ duration: duration = 1250, axis: axis = "y", onScrollFinish: onScrollFinish, easing: easing = (0, $jMDKX.easeInOutQuad), offset: offset = 0, cancelable: cancelable = true, isList: isList = false } = {}) {
    const frameID = (0, $acw62.useRef)(0);
    const startTime = (0, $acw62.useRef)(0);
    const shouldStop = (0, $acw62.useRef)(false);
    const scrollableRef = (0, $acw62.useRef)(null);
    const targetRef = (0, $acw62.useRef)(null);
    const reducedMotion = (0, $hG392.useReducedMotion)();
    const cancel = ()=>{
        if (frameID.current) cancelAnimationFrame(frameID.current);
    };
    const scrollIntoView = (0, $acw62.useCallback)(({ alignment: alignment = "start" } = {})=>{
        var _a;
        shouldStop.current = false;
        if (frameID.current) cancel();
        const start = (_a = (0, $6PtMK.getScrollStart)({
            parent: scrollableRef.current,
            axis: axis
        })) != null ? _a : 0;
        const change = (0, $87wFj.getRelativePosition)({
            parent: scrollableRef.current,
            target: targetRef.current,
            axis: axis,
            alignment: alignment,
            offset: offset,
            isList: isList
        }) - (scrollableRef.current ? 0 : start);
        function animateScroll() {
            if (startTime.current === 0) startTime.current = performance.now();
            const now = performance.now();
            const elapsed = now - startTime.current;
            const t = reducedMotion || duration === 0 ? 1 : elapsed / duration;
            const distance = start + change * easing(t);
            (0, $ljSup.setScrollParam)({
                parent: scrollableRef.current,
                axis: axis,
                distance: distance
            });
            if (!shouldStop.current && t < 1) frameID.current = requestAnimationFrame(animateScroll);
            else {
                typeof onScrollFinish === "function" && onScrollFinish();
                startTime.current = 0;
                frameID.current = 0;
                cancel();
            }
        }
        animateScroll();
    }, [
        axis,
        duration,
        easing,
        isList,
        offset,
        onScrollFinish,
        reducedMotion
    ]);
    const handleStop = ()=>{
        if (cancelable) shouldStop.current = true;
    };
    (0, $dmiju.useWindowEvent)("wheel", handleStop, {
        passive: true
    });
    (0, $dmiju.useWindowEvent)("touchmove", handleStop, {
        passive: true
    });
    (0, $acw62.useEffect)(()=>cancel, []);
    return {
        scrollableRef: scrollableRef,
        targetRef: targetRef,
        scrollIntoView: scrollIntoView,
        cancel: cancel
    };
}

});
parcelRegister("jMDKX", function(module, exports) {

$parcel$export(module.exports, "easeInOutQuad", () => $e67156ceee7f3050$export$42add3d9cb3645a2);
const $e67156ceee7f3050$export$42add3d9cb3645a2 = (t)=>t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

});

parcelRegister("87wFj", function(module, exports) {

$parcel$export(module.exports, "getRelativePosition", () => $5e9850d2d81f6cd4$export$fbbc9f98d1d2faa5);
const $5e9850d2d81f6cd4$export$fbbc9f98d1d2faa5 = ({ axis: axis, target: target, parent: parent, alignment: alignment, offset: offset, isList: isList })=>{
    if (!target || !parent && typeof document === "undefined") return 0;
    const isCustomParent = !!parent;
    const parentElement = parent || document.body;
    const parentPosition = parentElement.getBoundingClientRect();
    const targetPosition = target.getBoundingClientRect();
    const getDiff = (property)=>targetPosition[property] - parentPosition[property];
    if (axis === "y") {
        const diff = getDiff("top");
        if (diff === 0) return 0;
        if (alignment === "start") {
            const distance = diff - offset;
            const shouldScroll = distance <= targetPosition.height * (isList ? 0 : 1) || !isList;
            return shouldScroll ? distance : 0;
        }
        const parentHeight = isCustomParent ? parentPosition.height : window.innerHeight;
        if (alignment === "end") {
            const distance = diff + offset - parentHeight + targetPosition.height;
            const shouldScroll = distance >= -targetPosition.height * (isList ? 0 : 1) || !isList;
            return shouldScroll ? distance : 0;
        }
        if (alignment === "center") return diff - parentHeight / 2 + targetPosition.height / 2;
        return 0;
    }
    if (axis === "x") {
        const diff = getDiff("left");
        if (diff === 0) return 0;
        if (alignment === "start") {
            const distance = diff - offset;
            const shouldScroll = distance <= targetPosition.width || !isList;
            return shouldScroll ? distance : 0;
        }
        const parentWidth = isCustomParent ? parentPosition.width : window.innerWidth;
        if (alignment === "end") {
            const distance = diff + offset - parentWidth + targetPosition.width;
            const shouldScroll = distance >= -targetPosition.width || !isList;
            return shouldScroll ? distance : 0;
        }
        if (alignment === "center") return diff - parentWidth / 2 + targetPosition.width / 2;
        return 0;
    }
    return 0;
};

});

parcelRegister("6PtMK", function(module, exports) {

$parcel$export(module.exports, "getScrollStart", () => $4f8e9c3d904129a7$export$5ef71913efcb54d0);
const $4f8e9c3d904129a7$export$5ef71913efcb54d0 = ({ axis: axis, parent: parent })=>{
    if (!parent && typeof document === "undefined") return 0;
    const method = axis === "y" ? "scrollTop" : "scrollLeft";
    if (parent) return parent[method];
    const { body: body, documentElement: documentElement } = document;
    return body[method] + documentElement[method];
};

});

parcelRegister("ljSup", function(module, exports) {

$parcel$export(module.exports, "setScrollParam", () => $f855a3d14e8bba4d$export$6fa0ca14813d3e8c);
const $f855a3d14e8bba4d$export$6fa0ca14813d3e8c = ({ axis: axis, parent: parent, distance: distance })=>{
    if (!parent && typeof document === "undefined") return;
    const method = axis === "y" ? "scrollTop" : "scrollLeft";
    if (parent) parent[method] = distance;
    else {
        const { body: body, documentElement: documentElement } = document;
        body[method] = distance;
        documentElement[method] = distance;
    }
};

});


parcelRegister("e4375", function(module, exports) {

$parcel$export(module.exports, "DefaultValue", () => $a3d3daa1012e8b4d$export$a4e369a19907695d);

var $acw62 = parcelRequire("acw62");

var $j3Ptu = parcelRequire("j3Ptu");

var $lUJd1 = parcelRequire("lUJd1");
var $a3d3daa1012e8b4d$var$__defProp = Object.defineProperty;
var $a3d3daa1012e8b4d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a3d3daa1012e8b4d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a3d3daa1012e8b4d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a3d3daa1012e8b4d$var$__defNormalProp = (obj, key, value)=>key in obj ? $a3d3daa1012e8b4d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a3d3daa1012e8b4d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a3d3daa1012e8b4d$var$__hasOwnProp.call(b, prop)) $a3d3daa1012e8b4d$var$__defNormalProp(a, prop, b[prop]);
    if ($a3d3daa1012e8b4d$var$__getOwnPropSymbols) {
        for (var prop of $a3d3daa1012e8b4d$var$__getOwnPropSymbols(b))if ($a3d3daa1012e8b4d$var$__propIsEnum.call(b, prop)) $a3d3daa1012e8b4d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a3d3daa1012e8b4d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a3d3daa1012e8b4d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a3d3daa1012e8b4d$var$__getOwnPropSymbols) {
        for (var prop of $a3d3daa1012e8b4d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a3d3daa1012e8b4d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a3d3daa1012e8b4d$var$buttonSizes = {
    xs: 16,
    sm: 22,
    md: 24,
    lg: 26,
    xl: 30
};
function $a3d3daa1012e8b4d$export$a4e369a19907695d(_a) {
    var _b = _a, { label: label, classNames: classNames, styles: styles, className: className, onRemove: onRemove, disabled: disabled, readOnly: readOnly, size: size, radius: radius = "sm", variant: variant, unstyled: unstyled } = _b, others = $a3d3daa1012e8b4d$var$__objRest(_b, [
        "label",
        "classNames",
        "styles",
        "className",
        "onRemove",
        "disabled",
        "readOnly",
        "size",
        "radius",
        "variant",
        "unstyled"
    ]);
    const { classes: classes, cx: cx } = (0, $j3Ptu.default)({
        disabled: disabled,
        readOnly: readOnly,
        radius: radius
    }, {
        name: "MultiSelect",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        size: size,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $a3d3daa1012e8b4d$var$__spreadValues({
        className: cx(classes.defaultValue, className)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.defaultValueLabel
    }, label), !disabled && !readOnly && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUJd1.CloseButton), {
        "aria-hidden": true,
        onMouseDown: onRemove,
        size: $a3d3daa1012e8b4d$var$buttonSizes[size],
        radius: 2,
        color: "blue",
        variant: "transparent",
        iconSize: "70%",
        className: classes.defaultValueRemove,
        tabIndex: -1,
        unstyled: unstyled
    }));
}
$a3d3daa1012e8b4d$export$a4e369a19907695d.displayName = "@mantine/core/MultiSelect/DefaultValue";

});
parcelRegister("j3Ptu", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $0394bedebb8f234c$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "default", () => $0394bedebb8f234c$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
const $0394bedebb8f234c$export$c647cb0ee6e282fe = {
    xs: (0, $2jkdX.rem)(16),
    sm: (0, $2jkdX.rem)(22),
    md: (0, $2jkdX.rem)(26),
    lg: (0, $2jkdX.rem)(30),
    xl: (0, $2jkdX.rem)(36)
};
const $0394bedebb8f234c$var$fontSizes = {
    xs: (0, $2jkdX.rem)(10),
    sm: (0, $2jkdX.rem)(12),
    md: (0, $2jkdX.rem)(14),
    lg: (0, $2jkdX.rem)(16),
    xl: (0, $2jkdX.rem)(18)
};
var $0394bedebb8f234c$var$useStyles = (0, $cQG1Y.createStyles)((theme, { disabled: disabled, radius: radius, readOnly: readOnly }, { size: size, variant: variant })=>({
        defaultValue: {
            display: "flex",
            alignItems: "center",
            backgroundColor: disabled ? theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[3] : theme.colorScheme === "dark" ? theme.colors.dark[7] : variant === "filled" ? theme.white : theme.colors.gray[1],
            color: disabled ? theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7] : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
            height: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $0394bedebb8f234c$export$c647cb0ee6e282fe
            }),
            paddingLeft: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 1.5)`,
            paddingRight: disabled || readOnly ? (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            }) : 0,
            fontWeight: 500,
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $0394bedebb8f234c$var$fontSizes
            }),
            borderRadius: (0, $d8Ix8.getSize)({
                size: radius,
                sizes: theme.radius
            }),
            cursor: disabled ? "not-allowed" : "default",
            userSelect: "none",
            maxWidth: `calc(100% - ${(0, $2jkdX.rem)(10)})`
        },
        defaultValueRemove: {
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
            marginLeft: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 6)`
        },
        defaultValueLabel: {
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        }
    }));
var $0394bedebb8f234c$export$2e2bcd8739ae039 = $0394bedebb8f234c$var$useStyles;

});


parcelRegister("4BPQI", function(module, exports) {

$parcel$export(module.exports, "filterData", () => $35b2d653ac4fca5b$export$d6ad891437e8c72c);
function $35b2d653ac4fca5b$export$d6ad891437e8c72c({ data: data, searchable: searchable, limit: limit, searchValue: searchValue, filter: filter, value: value, disableSelectedItemFiltering: disableSelectedItemFiltering }) {
    if (!searchable && value.length === 0) return data;
    if (!searchable) {
        const result2 = [];
        for(let i = 0; i < data.length; i += 1)if (!!disableSelectedItemFiltering || !value.some((val)=>val === data[i].value && !data[i].disabled)) result2.push(data[i]);
        return result2;
    }
    const result = [];
    for(let i = 0; i < data.length; i += 1){
        if (filter(searchValue, !disableSelectedItemFiltering && value.some((val)=>val === data[i].value && !data[i].disabled), data[i])) result.push(data[i]);
        if (result.length >= limit) break;
    }
    return result;
}

});

parcelRegister("j3D7l", function(module, exports) {

$parcel$export(module.exports, "getSelectRightSectionProps", () => $ddfca40845830ebe$export$66a134e579a95d69);

var $acw62 = parcelRequire("acw62");

var $GRGAZ = parcelRequire("GRGAZ");
var $ddfca40845830ebe$var$__defProp = Object.defineProperty;
var $ddfca40845830ebe$var$__defProps = Object.defineProperties;
var $ddfca40845830ebe$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ddfca40845830ebe$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ddfca40845830ebe$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ddfca40845830ebe$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ddfca40845830ebe$var$__defNormalProp = (obj, key, value)=>key in obj ? $ddfca40845830ebe$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ddfca40845830ebe$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ddfca40845830ebe$var$__hasOwnProp.call(b, prop)) $ddfca40845830ebe$var$__defNormalProp(a, prop, b[prop]);
    if ($ddfca40845830ebe$var$__getOwnPropSymbols) {
        for (var prop of $ddfca40845830ebe$var$__getOwnPropSymbols(b))if ($ddfca40845830ebe$var$__propIsEnum.call(b, prop)) $ddfca40845830ebe$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ddfca40845830ebe$var$__spreadProps = (a, b)=>$ddfca40845830ebe$var$__defProps(a, $ddfca40845830ebe$var$__getOwnPropDescs(b));
var $ddfca40845830ebe$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ddfca40845830ebe$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ddfca40845830ebe$var$__getOwnPropSymbols) {
        for (var prop of $ddfca40845830ebe$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ddfca40845830ebe$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $ddfca40845830ebe$export$66a134e579a95d69(_a) {
    var _b = _a, { styles: styles, rightSection: rightSection, rightSectionWidth: rightSectionWidth, theme: theme } = _b, props = $ddfca40845830ebe$var$__objRest(_b, [
        "styles",
        "rightSection",
        "rightSectionWidth",
        "theme"
    ]);
    if (rightSection) return {
        rightSection: rightSection,
        rightSectionWidth: rightSectionWidth,
        styles: styles
    };
    const _styles = typeof styles === "function" ? styles(theme) : styles;
    return {
        rightSection: !props.readOnly && !(props.disabled && props.shouldClear) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $GRGAZ.SelectRightSection), $ddfca40845830ebe$var$__spreadValues({}, props)),
        styles: $ddfca40845830ebe$var$__spreadProps($ddfca40845830ebe$var$__spreadValues({}, _styles), {
            rightSection: $ddfca40845830ebe$var$__spreadProps($ddfca40845830ebe$var$__spreadValues({}, _styles == null ? void 0 : _styles.rightSection), {
                pointerEvents: props.shouldClear ? void 0 : "none"
            })
        })
    };
}

});
parcelRegister("GRGAZ", function(module, exports) {

$parcel$export(module.exports, "SelectRightSection", () => $080d914907cba3d0$export$faf70f6042e6d3bf);

var $acw62 = parcelRequire("acw62");

var $iMW6Q = parcelRequire("iMW6Q");

var $lUJd1 = parcelRequire("lUJd1");
var $080d914907cba3d0$var$__defProp = Object.defineProperty;
var $080d914907cba3d0$var$__defProps = Object.defineProperties;
var $080d914907cba3d0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $080d914907cba3d0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $080d914907cba3d0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $080d914907cba3d0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $080d914907cba3d0$var$__defNormalProp = (obj, key, value)=>key in obj ? $080d914907cba3d0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $080d914907cba3d0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($080d914907cba3d0$var$__hasOwnProp.call(b, prop)) $080d914907cba3d0$var$__defNormalProp(a, prop, b[prop]);
    if ($080d914907cba3d0$var$__getOwnPropSymbols) {
        for (var prop of $080d914907cba3d0$var$__getOwnPropSymbols(b))if ($080d914907cba3d0$var$__propIsEnum.call(b, prop)) $080d914907cba3d0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $080d914907cba3d0$var$__spreadProps = (a, b)=>$080d914907cba3d0$var$__defProps(a, $080d914907cba3d0$var$__getOwnPropDescs(b));
function $080d914907cba3d0$export$faf70f6042e6d3bf({ shouldClear: shouldClear, clearButtonProps: clearButtonProps, onClear: onClear, size: size, error: error }) {
    return shouldClear ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUJd1.CloseButton), $080d914907cba3d0$var$__spreadProps($080d914907cba3d0$var$__spreadValues({}, clearButtonProps), {
        variant: "transparent",
        onClick: onClear,
        size: size,
        onMouseDown: (event)=>event.preventDefault()
    })) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iMW6Q.ChevronIcon), {
        error: error,
        size: size
    });
}
$080d914907cba3d0$export$faf70f6042e6d3bf.displayName = "@mantine/core/SelectRightSection";

});
parcelRegister("iMW6Q", function(module, exports) {

$parcel$export(module.exports, "ChevronIcon", () => $dad9c9005dac6fcc$export$ae15c545ca677b81);

var $acw62 = parcelRequire("acw62");

var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");
var $dad9c9005dac6fcc$var$__defProp = Object.defineProperty;
var $dad9c9005dac6fcc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $dad9c9005dac6fcc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $dad9c9005dac6fcc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $dad9c9005dac6fcc$var$__defNormalProp = (obj, key, value)=>key in obj ? $dad9c9005dac6fcc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $dad9c9005dac6fcc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($dad9c9005dac6fcc$var$__hasOwnProp.call(b, prop)) $dad9c9005dac6fcc$var$__defNormalProp(a, prop, b[prop]);
    if ($dad9c9005dac6fcc$var$__getOwnPropSymbols) {
        for (var prop of $dad9c9005dac6fcc$var$__getOwnPropSymbols(b))if ($dad9c9005dac6fcc$var$__propIsEnum.call(b, prop)) $dad9c9005dac6fcc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $dad9c9005dac6fcc$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($dad9c9005dac6fcc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $dad9c9005dac6fcc$var$__getOwnPropSymbols) {
        for (var prop of $dad9c9005dac6fcc$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $dad9c9005dac6fcc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $dad9c9005dac6fcc$var$iconSizes = {
    xs: (0, $2jkdX.rem)(14),
    sm: (0, $2jkdX.rem)(18),
    md: (0, $2jkdX.rem)(20),
    lg: (0, $2jkdX.rem)(24),
    xl: (0, $2jkdX.rem)(28)
};
function $dad9c9005dac6fcc$export$ae15c545ca677b81(_a) {
    var _b = _a, { size: size, error: error, style: style } = _b, others = $dad9c9005dac6fcc$var$__objRest(_b, [
        "size",
        "error",
        "style"
    ]);
    const theme = (0, $64A2P.useMantineTheme)();
    const _size = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $dad9c9005dac6fcc$var$iconSizes
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $dad9c9005dac6fcc$var$__spreadValues({
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: $dad9c9005dac6fcc$var$__spreadValues({
            color: error ? theme.colors.red[6] : theme.colors.gray[6],
            width: _size,
            height: _size
        }, style),
        "data-chevron": true
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}

});



parcelRegister("5aOK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c453f4c82227ee1$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");

var $j3Ptu = parcelRequire("j3Ptu");

var $bqYMI = parcelRequire("bqYMI");
var $3c453f4c82227ee1$var$__defProp = Object.defineProperty;
var $3c453f4c82227ee1$var$__defProps = Object.defineProperties;
var $3c453f4c82227ee1$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $3c453f4c82227ee1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3c453f4c82227ee1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3c453f4c82227ee1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3c453f4c82227ee1$var$__defNormalProp = (obj, key, value)=>key in obj ? $3c453f4c82227ee1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3c453f4c82227ee1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3c453f4c82227ee1$var$__hasOwnProp.call(b, prop)) $3c453f4c82227ee1$var$__defNormalProp(a, prop, b[prop]);
    if ($3c453f4c82227ee1$var$__getOwnPropSymbols) {
        for (var prop of $3c453f4c82227ee1$var$__getOwnPropSymbols(b))if ($3c453f4c82227ee1$var$__propIsEnum.call(b, prop)) $3c453f4c82227ee1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3c453f4c82227ee1$var$__spreadProps = (a, b)=>$3c453f4c82227ee1$var$__defProps(a, $3c453f4c82227ee1$var$__getOwnPropDescs(b));
var $3c453f4c82227ee1$var$useStyles = (0, $cQG1Y.createStyles)((theme, { invalid: invalid }, { size: size })=>({
        wrapper: {
            position: "relative",
            "&:has(input:disabled)": {
                cursor: "not-allowed",
                pointerEvents: "none",
                "& .mantine-MultiSelect-input": {
                    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
                    color: theme.colors.dark[2],
                    opacity: 0.6,
                    "&::placeholder": {
                        color: theme.colors.dark[2]
                    }
                },
                "& .mantine-MultiSelect-defaultValue": {
                    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[3],
                    color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7]
                }
            }
        },
        values: {
            minHeight: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: (0, $bqYMI.sizes)
            })} - ${(0, $2jkdX.rem)(2)})`,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            marginLeft: `calc(-${theme.spacing.xs} / 2)`,
            boxSizing: "border-box",
            "&[data-clearable]": {
                marginRight: (0, $d8Ix8.getSize)({
                    size: size,
                    sizes: (0, $bqYMI.sizes)
                })
            }
        },
        value: {
            margin: `calc(${theme.spacing.xs} / 2 - ${(0, $2jkdX.rem)(2)}) calc(${theme.spacing.xs} / 2)`
        },
        searchInput: $3c453f4c82227ee1$var$__spreadProps($3c453f4c82227ee1$var$__spreadValues({}, theme.fn.fontStyles()), {
            flex: 1,
            minWidth: (0, $2jkdX.rem)(60),
            backgroundColor: "transparent",
            border: 0,
            outline: 0,
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            padding: 0,
            marginLeft: `calc(${theme.spacing.xs} / 2)`,
            appearance: "none",
            color: "inherit",
            maxHeight: (0, $d8Ix8.getSize)({
                size: size,
                sizes: (0, $j3Ptu.sizes)
            }),
            "&::placeholder": {
                opacity: 1,
                color: invalid ? theme.colors.red[theme.fn.primaryShade()] : theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5]
            },
            "&:disabled": {
                cursor: "not-allowed",
                pointerEvents: "none"
            }
        }),
        searchInputEmpty: {
            width: "100%"
        },
        searchInputInputHidden: {
            flex: 0,
            width: 0,
            minWidth: 0,
            margin: 0,
            overflow: "hidden"
        },
        searchInputPointer: {
            cursor: "pointer",
            "&:disabled": {
                cursor: "not-allowed",
                pointerEvents: "none"
            }
        },
        input: {
            cursor: "pointer",
            "&:disabled": {
                cursor: "not-allowed",
                pointerEvents: "none"
            }
        }
    }));
var $3c453f4c82227ee1$export$2e2bcd8739ae039 = $3c453f4c82227ee1$var$useStyles;

});


parcelRegister("iM1WI", function(module, exports) {

$parcel$export(module.exports, "NavLink", () => $daae3824ad0ef8dc$export$b0d92dbee9b5b60d);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $1euea = parcelRequire("1euea");

var $ke4gU = parcelRequire("ke4gU");

var $MQnwD = parcelRequire("MQnwD");

var $5etRf = parcelRequire("5etRf");

var $cjohz = parcelRequire("cjohz");

var $1cBiA = parcelRequire("1cBiA");

var $kqKdq = parcelRequire("kqKdq");
var $daae3824ad0ef8dc$var$__defProp = Object.defineProperty;
var $daae3824ad0ef8dc$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $daae3824ad0ef8dc$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $daae3824ad0ef8dc$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $daae3824ad0ef8dc$var$__defNormalProp = (obj, key, value)=>key in obj ? $daae3824ad0ef8dc$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $daae3824ad0ef8dc$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($daae3824ad0ef8dc$var$__hasOwnProp.call(b, prop)) $daae3824ad0ef8dc$var$__defNormalProp(a, prop, b[prop]);
    if ($daae3824ad0ef8dc$var$__getOwnPropSymbols) {
        for (var prop of $daae3824ad0ef8dc$var$__getOwnPropSymbols(b))if ($daae3824ad0ef8dc$var$__propIsEnum.call(b, prop)) $daae3824ad0ef8dc$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $daae3824ad0ef8dc$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($daae3824ad0ef8dc$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $daae3824ad0ef8dc$var$__getOwnPropSymbols) {
        for (var prop of $daae3824ad0ef8dc$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $daae3824ad0ef8dc$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $daae3824ad0ef8dc$var$defaultProps = {
    variant: "light",
    childrenOffset: "lg"
};
const $daae3824ad0ef8dc$export$e3641cad30ca38c5 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("NavLink", $daae3824ad0ef8dc$var$defaultProps, props), { label: label, description: description, icon: icon, rightSection: rightSection, className: className, classNames: classNames, styles: styles, unstyled: unstyled, active: active, color: color, variant: variant, noWrap: noWrap, children: children, opened: opened, defaultOpened: defaultOpened, onChange: onChange, disableRightSectionRotation: disableRightSectionRotation, childrenOffset: childrenOffset, disabled: disabled, onClick: onClick } = _a, others = $daae3824ad0ef8dc$var$__objRest(_a, [
        "label",
        "description",
        "icon",
        "rightSection",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "active",
        "color",
        "variant",
        "noWrap",
        "children",
        "opened",
        "defaultOpened",
        "onChange",
        "disableRightSectionRotation",
        "childrenOffset",
        "disabled",
        "onClick"
    ]);
    const { classes: classes, cx: cx } = (0, $MQnwD.default)({
        color: color,
        noWrap: noWrap,
        childrenOffset: childrenOffset,
        alignIcon: description ? "top" : "center"
    }, {
        name: "NavLink",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    const [_opened, setOpened] = (0, $ke4gU.useUncontrolled)({
        value: opened,
        defaultValue: defaultOpened,
        finalValue: false,
        onChange: onChange
    });
    const withChildren = !!children;
    const handleClick = (event)=>{
        if (withChildren) {
            event.preventDefault();
            onClick == null || onClick(event);
            setOpened(!_opened);
        } else onClick == null || onClick(event);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $daae3824ad0ef8dc$var$__spreadValues({
        ref: ref,
        className: cx(classes.root, className),
        "data-active": active || void 0,
        onClick: handleClick,
        unstyled: unstyled,
        "data-expanded": _opened || void 0,
        "data-disabled": disabled || void 0,
        disabled: disabled
    }, others), icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.icon
    }, icon), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.body
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        component: "span",
        size: "sm",
        className: classes.label
    }, label), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        component: "span",
        color: "dimmed",
        size: "xs",
        "data-active": active || void 0,
        className: classes.description
    }, description)), (withChildren || rightSection) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.rightSection,
        "data-rotate": _opened && !disableRightSectionRotation || void 0
    }, withChildren ? rightSection || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1cBiA.ChevronIcon), {
        width: (0, $2jkdX.rem)(14),
        height: (0, $2jkdX.rem)(14),
        style: {
            transform: "rotate(-90deg)"
        }
    }) : rightSection)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kqKdq.Collapse), {
        in: _opened
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.children
    }, children)));
});
$daae3824ad0ef8dc$export$e3641cad30ca38c5.displayName = "@mantine/core/NavLink";
const $daae3824ad0ef8dc$export$b0d92dbee9b5b60d = (0, $1euea.createPolymorphicComponent)($daae3824ad0ef8dc$export$e3641cad30ca38c5);

});
parcelRegister("MQnwD", function(module, exports) {

$parcel$export(module.exports, "default", () => $092d1d13adedb530$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $092d1d13adedb530$var$__defProp = Object.defineProperty;
var $092d1d13adedb530$var$__defProps = Object.defineProperties;
var $092d1d13adedb530$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $092d1d13adedb530$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $092d1d13adedb530$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $092d1d13adedb530$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $092d1d13adedb530$var$__defNormalProp = (obj, key, value)=>key in obj ? $092d1d13adedb530$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $092d1d13adedb530$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($092d1d13adedb530$var$__hasOwnProp.call(b, prop)) $092d1d13adedb530$var$__defNormalProp(a, prop, b[prop]);
    if ($092d1d13adedb530$var$__getOwnPropSymbols) {
        for (var prop of $092d1d13adedb530$var$__getOwnPropSymbols(b))if ($092d1d13adedb530$var$__propIsEnum.call(b, prop)) $092d1d13adedb530$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $092d1d13adedb530$var$__spreadProps = (a, b)=>$092d1d13adedb530$var$__defProps(a, $092d1d13adedb530$var$__getOwnPropDescs(b));
const $092d1d13adedb530$var$NAV_LINK_VARIANTS = [
    "filled",
    "light",
    "subtle"
];
function $092d1d13adedb530$var$getVariantStyles({ theme: theme, variant: variant, color: color }) {
    if (!$092d1d13adedb530$var$NAV_LINK_VARIANTS.includes(variant)) return null;
    const colors = theme.fn.variant({
        variant: variant,
        color: color
    });
    return {
        "&[data-active]": $092d1d13adedb530$var$__spreadValues({
            backgroundColor: colors.background,
            color: colors.color
        }, theme.fn.hover({
            backgroundColor: colors.hover
        }))
    };
}
var $092d1d13adedb530$var$useStyles = (0, $cQG1Y.createStyles)((theme, { noWrap: noWrap, childrenOffset: childrenOffset, alignIcon: alignIcon, color: color }, { variant: variant })=>({
        root: $092d1d13adedb530$var$__spreadProps($092d1d13adedb530$var$__spreadValues($092d1d13adedb530$var$__spreadValues({
            display: "flex",
            alignItems: "center",
            width: "100%",
            padding: `${(0, $2jkdX.rem)(8)} ${theme.spacing.sm}`,
            userSelect: "none"
        }, $092d1d13adedb530$var$getVariantStyles({
            theme: theme,
            variant: variant,
            color: color
        })), theme.fn.hover({
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
        })), {
            "&[data-disabled]": {
                opacity: 0.4,
                pointerEvents: "none"
            }
        }),
        icon: {
            marginRight: theme.spacing.sm,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignSelf: alignIcon === "center" ? "center" : "flex-start",
            paddingTop: alignIcon === "center" ? void 0 : (0, $2jkdX.rem)(4)
        },
        rightSection: {
            marginLeft: theme.spacing.sm,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: `transform 150ms ${theme.transitionTimingFunction}`,
            "&[data-rotate]": {
                transform: "rotate(90deg)"
            }
        },
        body: {
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: noWrap ? "nowrap" : void 0
        },
        label: {},
        description: {
            display: "block",
            "&[data-active]": {
                color: "inherit"
            }
        },
        children: {
            paddingLeft: (0, $d8Ix8.getSize)({
                size: childrenOffset,
                sizes: theme.spacing
            })
        }
    }));
var $092d1d13adedb530$export$2e2bcd8739ae039 = $092d1d13adedb530$var$useStyles;

});


parcelRegister("e2mZf", function(module, exports) {

$parcel$export(module.exports, "Notification", () => $a383154f0339d7e0$export$14834abbfce3b8cd);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $jJcC1 = parcelRequire("jJcC1");

var $hiiR1 = parcelRequire("hiiR1");

var $4P91H = parcelRequire("4P91H");

var $cjohz = parcelRequire("cjohz");

var $lUJd1 = parcelRequire("lUJd1");
var $a383154f0339d7e0$var$__defProp = Object.defineProperty;
var $a383154f0339d7e0$var$__defProps = Object.defineProperties;
var $a383154f0339d7e0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a383154f0339d7e0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a383154f0339d7e0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a383154f0339d7e0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a383154f0339d7e0$var$__defNormalProp = (obj, key, value)=>key in obj ? $a383154f0339d7e0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a383154f0339d7e0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a383154f0339d7e0$var$__hasOwnProp.call(b, prop)) $a383154f0339d7e0$var$__defNormalProp(a, prop, b[prop]);
    if ($a383154f0339d7e0$var$__getOwnPropSymbols) {
        for (var prop of $a383154f0339d7e0$var$__getOwnPropSymbols(b))if ($a383154f0339d7e0$var$__propIsEnum.call(b, prop)) $a383154f0339d7e0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a383154f0339d7e0$var$__spreadProps = (a, b)=>$a383154f0339d7e0$var$__defProps(a, $a383154f0339d7e0$var$__getOwnPropDescs(b));
var $a383154f0339d7e0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a383154f0339d7e0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a383154f0339d7e0$var$__getOwnPropSymbols) {
        for (var prop of $a383154f0339d7e0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a383154f0339d7e0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a383154f0339d7e0$var$defaultProps = {
    withCloseButton: true
};
const $a383154f0339d7e0$export$14834abbfce3b8cd = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Notification", $a383154f0339d7e0$var$defaultProps, props), { className: className, color: color, radius: radius, loading: loading, withCloseButton: withCloseButton, withBorder: withBorder, title: title, icon: icon, children: children, onClose: onClose, closeButtonProps: closeButtonProps, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant } = _a, others = $a383154f0339d7e0$var$__objRest(_a, [
        "className",
        "color",
        "radius",
        "loading",
        "withCloseButton",
        "withBorder",
        "title",
        "icon",
        "children",
        "onClose",
        "closeButtonProps",
        "classNames",
        "styles",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $jJcC1.default)({
        color: color,
        radius: radius,
        withTitle: !!title
    }, {
        name: "Notification",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $a383154f0339d7e0$var$__spreadValues({
        className: cx(classes.root, className),
        "data-with-icon": !!icon || loading || void 0,
        "data-with-border": withBorder || void 0,
        role: "alert",
        ref: ref
    }, others), icon && !loading && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.icon
    }, icon), loading && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4P91H.Loader), {
        size: 28,
        color: color,
        className: classes.loader
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.body
    }, title && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        className: classes.title,
        size: "sm",
        weight: 500
    }, title), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        color: "dimmed",
        className: classes.description,
        size: "sm"
    }, children)), withCloseButton && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUJd1.CloseButton), $a383154f0339d7e0$var$__spreadProps($a383154f0339d7e0$var$__spreadValues({
        iconSize: 16,
        color: "gray"
    }, closeButtonProps), {
        onClick: onClose,
        className: classes.closeButton
    })));
});
$a383154f0339d7e0$export$14834abbfce3b8cd.displayName = "@mantine/core/Notification";

});
parcelRegister("jJcC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5cc00d7c5eb2d1b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $e5cc00d7c5eb2d1b$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, radius: radius, withTitle: withTitle })=>{
    const _radius = theme.fn.radius(radius);
    const colors = theme.fn.variant({
        variant: "filled",
        color: color
    });
    return {
        closeButton: theme.fn.hover({
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
        }),
        icon: {
            boxSizing: "border-box",
            marginRight: theme.spacing.md,
            width: (0, $2jkdX.rem)(28),
            height: (0, $2jkdX.rem)(28),
            borderRadius: (0, $2jkdX.rem)(28),
            display: "flex",
            flex: "none",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: colors.background,
            color: theme.white
        },
        root: {
            overflow: "hidden",
            boxSizing: "border-box",
            position: "relative",
            display: "flex",
            alignItems: "center",
            paddingLeft: (0, $2jkdX.rem)(22),
            paddingRight: theme.spacing.xs,
            paddingTop: theme.spacing.xs,
            paddingBottom: theme.spacing.xs,
            borderRadius: _radius,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            boxShadow: theme.shadows.lg,
            "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                width: (0, $2jkdX.rem)(6),
                top: _radius,
                bottom: _radius,
                left: (0, $2jkdX.rem)(4),
                borderRadius: _radius,
                backgroundColor: colors.background
            },
            "&[data-with-icon]": {
                paddingLeft: theme.spacing.xs,
                "&::before": {
                    display: "none"
                }
            },
            "&[data-with-border]": {
                border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`
            }
        },
        body: {
            flex: 1,
            overflow: "hidden",
            marginRight: theme.spacing.xs
        },
        loader: {
            marginRight: theme.spacing.md
        },
        title: {
            lineHeight: 1.4,
            marginBottom: (0, $2jkdX.rem)(2),
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: theme.colorScheme === "dark" ? theme.white : theme.colors.gray[9]
        },
        description: {
            color: withTitle ? theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6] : theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            lineHeight: 1.4,
            overflow: "hidden",
            textOverflow: "ellipsis"
        }
    };
});
var $e5cc00d7c5eb2d1b$export$2e2bcd8739ae039 = $e5cc00d7c5eb2d1b$var$useStyles;

});


parcelRegister("hasER", function(module, exports) {

$parcel$export(module.exports, "NumberInput", () => $c7f999b984bc2ae7$export$6bf0cd3a219bbade);

var $acw62 = parcelRequire("acw62");

var $69QHb = parcelRequire("69QHb");
var $cVOeO = parcelRequire("cVOeO");
var $4GmKa = parcelRequire("4GmKa");
var $7ZCE5 = parcelRequire("7ZCE5");

var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $3RpwU = parcelRequire("3RpwU");

var $h4PYZ = parcelRequire("h4PYZ");

var $3sBnO = parcelRequire("3sBnO");

var $8mycu = parcelRequire("8mycu");
var $c7f999b984bc2ae7$var$__defProp = Object.defineProperty;
var $c7f999b984bc2ae7$var$__defProps = Object.defineProperties;
var $c7f999b984bc2ae7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c7f999b984bc2ae7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c7f999b984bc2ae7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c7f999b984bc2ae7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c7f999b984bc2ae7$var$__defNormalProp = (obj, key, value)=>key in obj ? $c7f999b984bc2ae7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c7f999b984bc2ae7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c7f999b984bc2ae7$var$__hasOwnProp.call(b, prop)) $c7f999b984bc2ae7$var$__defNormalProp(a, prop, b[prop]);
    if ($c7f999b984bc2ae7$var$__getOwnPropSymbols) {
        for (var prop of $c7f999b984bc2ae7$var$__getOwnPropSymbols(b))if ($c7f999b984bc2ae7$var$__propIsEnum.call(b, prop)) $c7f999b984bc2ae7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c7f999b984bc2ae7$var$__spreadProps = (a, b)=>$c7f999b984bc2ae7$var$__defProps(a, $c7f999b984bc2ae7$var$__getOwnPropDescs(b));
var $c7f999b984bc2ae7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c7f999b984bc2ae7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c7f999b984bc2ae7$var$__getOwnPropSymbols) {
        for (var prop of $c7f999b984bc2ae7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c7f999b984bc2ae7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c7f999b984bc2ae7$var$defaultFormatter = (value)=>value || "";
const $c7f999b984bc2ae7$var$defaultParser = (num)=>{
    if (num === "-") return num;
    let tempNum = num;
    if (tempNum[0] === ".") tempNum = `0${num}`;
    const parsedNum = parseFloat(tempNum);
    if (Number.isNaN(parsedNum)) return "";
    return num;
};
const $c7f999b984bc2ae7$var$CHEVRON_SIZES = {
    xs: (0, $2jkdX.rem)(10),
    sm: (0, $2jkdX.rem)(14),
    md: (0, $2jkdX.rem)(16),
    lg: (0, $2jkdX.rem)(18),
    xl: (0, $2jkdX.rem)(20)
};
const $c7f999b984bc2ae7$var$defaultProps = {
    step: 1,
    hideControls: false,
    size: "sm",
    precision: 0,
    noClampOnBlur: false,
    removeTrailingZeros: false,
    decimalSeparator: ".",
    formatter: $c7f999b984bc2ae7$var$defaultFormatter,
    parser: $c7f999b984bc2ae7$var$defaultParser,
    type: "text"
};
const $c7f999b984bc2ae7$export$6bf0cd3a219bbade = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("NumberInput", $c7f999b984bc2ae7$var$defaultProps, props), { readOnly: readOnly, disabled: disabled, value: value, onChange: onChange, decimalSeparator: decimalSeparator, thousandsSeparator: thousandsSeparator, min: min, max: max, startValue: startValue, step: step, stepHoldInterval: stepHoldInterval, stepHoldDelay: stepHoldDelay, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onKeyUp: onKeyUp, hideControls: hideControls, radius: radius, variant: variant, precision: precision, removeTrailingZeros: removeTrailingZeros, defaultValue: defaultValue, noClampOnBlur: noClampOnBlur, handlersRef: handlersRef, classNames: classNames, styles: styles, size: size, rightSection: rightSection, rightSectionWidth: rightSectionWidth, formatter: formatter, parser: parser, inputMode: inputMode, unstyled: unstyled, type: type } = _a, others = $c7f999b984bc2ae7$var$__objRest(_a, [
        "readOnly",
        "disabled",
        "value",
        "onChange",
        "decimalSeparator",
        "thousandsSeparator",
        "min",
        "max",
        "startValue",
        "step",
        "stepHoldInterval",
        "stepHoldDelay",
        "onFocus",
        "onBlur",
        "onKeyDown",
        "onKeyUp",
        "hideControls",
        "radius",
        "variant",
        "precision",
        "removeTrailingZeros",
        "defaultValue",
        "noClampOnBlur",
        "handlersRef",
        "classNames",
        "styles",
        "size",
        "rightSection",
        "rightSectionWidth",
        "formatter",
        "parser",
        "inputMode",
        "unstyled",
        "type"
    ]);
    const { classes: classes, cx: cx } = (0, $3sBnO.default)({
        radius: radius
    }, {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        name: "NumberInput",
        variant: variant,
        size: size
    });
    const parsePrecision = (val)=>{
        if (val === "") return "";
        let result = val.toFixed(precision);
        if (removeTrailingZeros && precision > 0) {
            result = result.replace(new RegExp(`[0]{0,${precision}}$`), "");
            if (result.endsWith(".")) result = result.slice(0, -1);
        }
        return result;
    };
    const formatNum = (val)=>{
        let parsedStr = val;
        if (decimalSeparator) parsedStr = parsedStr.replace(".", decimalSeparator);
        return formatter(parsedStr);
    };
    const parseNum = (val)=>{
        let num = val;
        if (decimalSeparator) num = num.replaceAll(thousandsSeparator, "").replace(decimalSeparator, ".");
        return parser(num);
    };
    const formatInternalValue = (val)=>formatNum(parsePrecision(val));
    const [internalValue, _setInternalValue] = (0, $acw62.useState)(typeof value === "number" ? value : typeof defaultValue === "number" ? defaultValue : "");
    const [inputValue, setInputValue] = (0, $acw62.useState)(()=>formatInternalValue(internalValue));
    const inputRef = (0, $acw62.useRef)();
    const [isFocussed, setIsFocussed] = (0, $acw62.useState)(false);
    const setInternalValue = (val, forceInputValueUpdate)=>{
        if (!isFocussed || forceInputValueUpdate) {
            const newInputValue = formatInternalValue(val);
            if (newInputValue !== inputValue) setInputValue(newInputValue);
        }
        if (val !== internalValue) _setInternalValue(val);
    };
    const _min = typeof min === "number" ? min : -Infinity;
    const _max = typeof max === "number" ? max : Infinity;
    const incrementRef = (0, $acw62.useRef)();
    incrementRef.current = ()=>{
        var _a2;
        let newInternalValue;
        if (internalValue === "") newInternalValue = (_a2 = startValue != null ? startValue : min) != null ? _a2 : 0;
        else newInternalValue = parseFloat(parsePrecision((0, $cVOeO.clamp)(internalValue + step, _min, _max)));
        setInternalValue(newInternalValue, true);
        onChange == null || onChange(newInternalValue);
    };
    const decrementRef = (0, $acw62.useRef)();
    decrementRef.current = ()=>{
        var _a2;
        let newInternalValue;
        if (internalValue === "") newInternalValue = (_a2 = startValue != null ? startValue : min) != null ? _a2 : 0;
        else newInternalValue = parseFloat(parsePrecision((0, $cVOeO.clamp)(internalValue - step, _min, _max)));
        setInternalValue(newInternalValue, true);
        onChange == null || onChange(newInternalValue);
    };
    (0, $69QHb.assignRef)(handlersRef, {
        increment: incrementRef.current,
        decrement: decrementRef.current
    });
    (0, $acw62.useEffect)(()=>{
        if (isFocussed) return;
        if (value === void 0) setInternalValue(internalValue, true);
        else setInternalValue(value, true);
    }, [
        value,
        isFocussed
    ]);
    const shouldUseStepInterval = stepHoldDelay !== void 0 && stepHoldInterval !== void 0;
    const onStepTimeoutRef = (0, $acw62.useRef)(null);
    const stepCountRef = (0, $acw62.useRef)(0);
    const onStepDone = ()=>{
        if (onStepTimeoutRef.current) window.clearTimeout(onStepTimeoutRef.current);
        onStepTimeoutRef.current = null;
        stepCountRef.current = 0;
    };
    const onStepHandleChange = (isIncrement)=>{
        if (isIncrement) incrementRef.current();
        else decrementRef.current();
        stepCountRef.current += 1;
    };
    const onStepLoop = (isIncrement)=>{
        onStepHandleChange(isIncrement);
        if (shouldUseStepInterval) {
            const interval = typeof stepHoldInterval === "number" ? stepHoldInterval : stepHoldInterval(stepCountRef.current);
            onStepTimeoutRef.current = window.setTimeout(()=>onStepLoop(isIncrement), interval);
        }
    };
    const onStep = (event, isIncrement)=>{
        event.preventDefault();
        inputRef.current.focus();
        onStepHandleChange(isIncrement);
        if (shouldUseStepInterval) onStepTimeoutRef.current = window.setTimeout(()=>onStepLoop(isIncrement), stepHoldDelay);
    };
    (0, $acw62.useEffect)(()=>{
        onStepDone();
        return onStepDone;
    }, []);
    const controls = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.rightSection
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        tabIndex: -1,
        "aria-hidden": true,
        disabled: internalValue >= max,
        className: cx(classes.control, classes.controlUp),
        onPointerDown: (event)=>{
            onStep(event, true);
        },
        onPointerUp: onStepDone,
        onPointerLeave: onStepDone
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4PYZ.Chevron), {
        size: (0, $d8Ix8.getSize)({
            size: size,
            sizes: $c7f999b984bc2ae7$var$CHEVRON_SIZES
        }),
        direction: "up"
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        tabIndex: -1,
        "aria-hidden": true,
        disabled: internalValue <= min,
        className: cx(classes.control, classes.controlDown),
        onPointerDown: (event)=>{
            onStep(event, false);
        },
        onPointerUp: onStepDone,
        onPointerLeave: onStepDone
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4PYZ.Chevron), {
        size: (0, $d8Ix8.getSize)({
            size: size,
            sizes: $c7f999b984bc2ae7$var$CHEVRON_SIZES
        }),
        direction: "down"
    })));
    const processInputValue = (newInputValue)=>{
        let normalizedInputValue = newInputValue;
        if (normalizedInputValue[0] === `${decimalSeparator}` || normalizedInputValue[0] === ".") normalizedInputValue = `0${normalizedInputValue}`;
        const parsedValue = parseFloat(parsePrecision(parseFloat(parseNum(normalizedInputValue))));
        const clampedValue = !noClampOnBlur ? (0, $cVOeO.clamp)(parsedValue, _min, _max) : parsedValue;
        const finalValue = Number.isNaN(clampedValue) ? "" : clampedValue;
        const internalValueChanged = internalValue !== finalValue;
        setInputValue(newInputValue);
        setInternalValue(finalValue);
        if (internalValueChanged) onChange == null || onChange(finalValue);
    };
    const handleChange = (event)=>{
        const evt = event.nativeEvent;
        if (evt.isComposing) return;
        processInputValue(event.target.value);
    };
    const handleFocus = (event)=>{
        setIsFocussed(true);
        onFocus == null || onFocus(event);
    };
    const handleBlur = (event)=>{
        setIsFocussed(false);
        onBlur == null || onBlur(event);
    };
    const handleKeyDown = (event)=>{
        typeof onKeyDown === "function" && onKeyDown(event);
        if (event.repeat && shouldUseStepInterval && (event.key === "ArrowUp" || event.key === "ArrowDown")) {
            event.preventDefault();
            return;
        }
        if (!readOnly) {
            if (event.key === "ArrowUp") onStep(event, true);
            else if (event.key === "ArrowDown") onStep(event, false);
        }
    };
    const handleKeyUp = (event)=>{
        typeof onKeyUp === "function" && onKeyUp(event);
        if (event.key === "ArrowUp" || event.key === "ArrowDown") onStepDone();
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8mycu.TextInput), $c7f999b984bc2ae7$var$__spreadProps($c7f999b984bc2ae7$var$__spreadValues({}, others), {
        type: type,
        variant: variant,
        value: inputValue,
        disabled: disabled,
        readOnly: readOnly,
        ref: (0, $4GmKa.useMergedRef)(inputRef, ref),
        onChange: handleChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        rightSection: rightSection || (disabled || readOnly || hideControls || variant === "unstyled" ? null : controls),
        rightSectionWidth: rightSectionWidth != null ? rightSectionWidth : `calc(${(0, $d8Ix8.getSize)({
            size: size,
            sizes: (0, $3sBnO.CONTROL_SIZES)
        })} + ${(0, $2jkdX.rem)(1)})`,
        radius: radius,
        max: max,
        min: min,
        step: step,
        size: size,
        styles: styles,
        classNames: classNames,
        inputMode: inputMode || (0, $3RpwU.getInputMode)(step, precision, (0, $7ZCE5.useOs)()),
        __staticSelector: "NumberInput",
        unstyled: unstyled
    }));
});
$c7f999b984bc2ae7$export$6bf0cd3a219bbade.displayName = "@mantine/core/NumberInput";

});
parcelRegister("cVOeO", function(module, exports) {

$parcel$export(module.exports, "clamp", () => $96a1c71717cbe770$export$7d15b64cf5a3a4c4);
function $96a1c71717cbe770$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

});

parcelRegister("7ZCE5", function(module, exports) {

$parcel$export(module.exports, "useOs", () => $5d1c3521c7e757be$export$c42e994c8dc34334);

var $acw62 = parcelRequire("acw62");

var $l65IU = parcelRequire("l65IU");
function $5d1c3521c7e757be$var$getOS() {
    if (typeof window === "undefined") return "undetermined";
    const { userAgent: userAgent } = window.navigator;
    const macosPlatforms = /(Macintosh)|(MacIntel)|(MacPPC)|(Mac68K)/i;
    const windowsPlatforms = /(Win32)|(Win64)|(Windows)|(WinCE)/i;
    const iosPlatforms = /(iPhone)|(iPad)|(iPod)/i;
    if (macosPlatforms.test(userAgent)) return "macos";
    if (iosPlatforms.test(userAgent)) return "ios";
    if (windowsPlatforms.test(userAgent)) return "windows";
    if (/Android/i.test(userAgent)) return "android";
    if (/Linux/i.test(userAgent)) return "linux";
    return "undetermined";
}
function $5d1c3521c7e757be$export$c42e994c8dc34334(options = {
    getValueInEffect: true
}) {
    const [value, setValue] = (0, $acw62.useState)(options.getValueInEffect ? "undetermined" : $5d1c3521c7e757be$var$getOS());
    (0, $l65IU.useIsomorphicEffect)(()=>{
        if (options.getValueInEffect) setValue($5d1c3521c7e757be$var$getOS);
    }, []);
    return value;
}

});

parcelRegister("3RpwU", function(module, exports) {

$parcel$export(module.exports, "getInputMode", () => $2cfa1fffbad43090$export$e5d24297753776ea);
const $2cfa1fffbad43090$export$e5d24297753776ea = (step, precision, os)=>{
    if (Number.isInteger(step) && step >= 0 && precision === 0) return "numeric";
    if (!Number.isInteger(step) && step >= 0 && precision !== 0) return "decimal";
    if (Number.isInteger(step) && step < 0 && precision === 0) {
        if (os === "ios") return "text";
        return "decimal";
    }
    if (!Number.isInteger(step) && step < 0 && precision !== 0) {
        if (os === "ios") return "text";
        return "decimal";
    }
    return "numeric";
};

});

parcelRegister("h4PYZ", function(module, exports) {

$parcel$export(module.exports, "Chevron", () => $c6eb22123c2e6625$export$65be7b63f510f362);

var $acw62 = parcelRequire("acw62");

var $2jkdX = parcelRequire("2jkdX");
function $c6eb22123c2e6625$export$65be7b63f510f362({ direction: direction, size: size }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        style: {
            width: (0, $2jkdX.rem)(size),
            height: (0, $2jkdX.rem)(size),
            transform: direction === "up" ? "rotate(180deg)" : void 0
        },
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}

});

parcelRegister("3sBnO", function(module, exports) {

$parcel$export(module.exports, "CONTROL_SIZES", () => $2850fc2411e72aac$export$30c61559b3ab987d);
$parcel$export(module.exports, "default", () => $2850fc2411e72aac$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
const $2850fc2411e72aac$export$30c61559b3ab987d = {
    xs: (0, $2jkdX.rem)(20),
    sm: (0, $2jkdX.rem)(24),
    md: (0, $2jkdX.rem)(30),
    lg: (0, $2jkdX.rem)(34),
    xl: (0, $2jkdX.rem)(36)
};
var $2850fc2411e72aac$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius }, { size: size })=>({
        rightSection: {
            display: "flex",
            flexDirection: "column",
            height: `calc(100% - ${(0, $2jkdX.rem)(2)})`,
            margin: (0, $2jkdX.rem)(1),
            overflow: "hidden",
            borderTopRightRadius: theme.fn.radius(radius),
            borderBottomRightRadius: theme.fn.radius(radius)
        },
        control: {
            margin: 0,
            position: "relative",
            flex: "0 0 50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            width: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $2850fc2411e72aac$export$30c61559b3ab987d
            }),
            padding: 0,
            WebkitTapHighlightColor: "transparent",
            borderBottom: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
            borderLeft: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
            borderTop: 0,
            borderRight: 0,
            backgroundColor: "transparent",
            marginRight: (0, $2jkdX.rem)(1),
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            "&:not(:disabled):hover": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
            },
            "&:disabled": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4]
            }
        },
        controlUp: {},
        controlDown: {
            borderBottom: 0
        }
    }));
var $2850fc2411e72aac$export$2e2bcd8739ae039 = $2850fc2411e72aac$var$useStyles;

});


parcelRegister("ly5N0", function(module, exports) {

$parcel$export(module.exports, "PasswordInput", () => $fb01439cc4866a76$export$b28585a458fee016);

var $acw62 = parcelRequire("acw62");

var $8nBd8 = parcelRequire("8nBd8");
var $ke4gU = parcelRequire("ke4gU");

var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $64A2P = parcelRequire("64A2P");

var $7TPTS = parcelRequire("7TPTS");

var $5uUER = parcelRequire("5uUER");

var $aEkmw = parcelRequire("aEkmw");

var $crMIh = parcelRequire("crMIh");

var $gw63X = parcelRequire("gw63X");
var $fb01439cc4866a76$var$__defProp = Object.defineProperty;
var $fb01439cc4866a76$var$__defProps = Object.defineProperties;
var $fb01439cc4866a76$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $fb01439cc4866a76$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $fb01439cc4866a76$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fb01439cc4866a76$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $fb01439cc4866a76$var$__defNormalProp = (obj, key, value)=>key in obj ? $fb01439cc4866a76$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fb01439cc4866a76$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($fb01439cc4866a76$var$__hasOwnProp.call(b, prop)) $fb01439cc4866a76$var$__defNormalProp(a, prop, b[prop]);
    if ($fb01439cc4866a76$var$__getOwnPropSymbols) {
        for (var prop of $fb01439cc4866a76$var$__getOwnPropSymbols(b))if ($fb01439cc4866a76$var$__propIsEnum.call(b, prop)) $fb01439cc4866a76$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $fb01439cc4866a76$var$__spreadProps = (a, b)=>$fb01439cc4866a76$var$__defProps(a, $fb01439cc4866a76$var$__getOwnPropDescs(b));
var $fb01439cc4866a76$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($fb01439cc4866a76$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $fb01439cc4866a76$var$__getOwnPropSymbols) {
        for (var prop of $fb01439cc4866a76$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $fb01439cc4866a76$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $fb01439cc4866a76$var$buttonSizes = {
    xs: (0, $2jkdX.rem)(22),
    sm: (0, $2jkdX.rem)(26),
    md: (0, $2jkdX.rem)(28),
    lg: (0, $2jkdX.rem)(32),
    xl: (0, $2jkdX.rem)(40)
};
const $fb01439cc4866a76$var$iconSizes = {
    xs: (0, $2jkdX.rem)(12),
    sm: (0, $2jkdX.rem)(15),
    md: (0, $2jkdX.rem)(17),
    lg: (0, $2jkdX.rem)(19),
    xl: (0, $2jkdX.rem)(21)
};
const $fb01439cc4866a76$var$rightSectionSizes = {
    xs: (0, $2jkdX.rem)(28),
    sm: (0, $2jkdX.rem)(32),
    md: (0, $2jkdX.rem)(34),
    lg: (0, $2jkdX.rem)(44),
    xl: (0, $2jkdX.rem)(54)
};
const $fb01439cc4866a76$var$defaultProps = {
    size: "sm",
    toggleTabIndex: -1,
    visibilityToggleIcon: (0, $7TPTS.PasswordToggleIcon),
    __staticSelector: "PasswordInput"
};
const $fb01439cc4866a76$export$b28585a458fee016 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("PasswordInput", $fb01439cc4866a76$var$defaultProps, props), { radius: radius, disabled: disabled, size: size, toggleTabIndex: toggleTabIndex, className: className, id: id, label: label, error: error, required: required, style: style, icon: icon, description: description, wrapperProps: wrapperProps, classNames: classNames, styles: styles, variant: variant, visibilityToggleIcon: VisibilityToggleIcon, __staticSelector: __staticSelector, sx: sx, labelProps: labelProps, descriptionProps: descriptionProps, errorProps: errorProps, unstyled: unstyled, visibilityToggleLabel: visibilityToggleLabel, withAsterisk: withAsterisk, inputContainer: inputContainer, iconWidth: iconWidth, inputWrapperOrder: inputWrapperOrder, visible: visible, defaultVisible: defaultVisible, onVisibilityChange: onVisibilityChange } = _a, others = $fb01439cc4866a76$var$__objRest(_a, [
        "radius",
        "disabled",
        "size",
        "toggleTabIndex",
        "className",
        "id",
        "label",
        "error",
        "required",
        "style",
        "icon",
        "description",
        "wrapperProps",
        "classNames",
        "styles",
        "variant",
        "visibilityToggleIcon",
        "__staticSelector",
        "sx",
        "labelProps",
        "descriptionProps",
        "errorProps",
        "unstyled",
        "visibilityToggleLabel",
        "withAsterisk",
        "inputContainer",
        "iconWidth",
        "inputWrapperOrder",
        "visible",
        "defaultVisible",
        "onVisibilityChange"
    ]);
    const rightSectionWidth = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $fb01439cc4866a76$var$rightSectionSizes
    });
    const { classes: classes } = (0, $5uUER.default)({
        rightSectionWidth: rightSectionWidth
    }, {
        name: "PasswordInput",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        size: size,
        variant: variant
    });
    const uuid = (0, $8nBd8.useId)(id);
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const [_visible, setVisibility] = (0, $ke4gU.useUncontrolled)({
        value: visible,
        defaultValue: defaultVisible,
        finalValue: false,
        onChange: onVisibilityChange
    });
    const toggleVisibility = ()=>setVisibility(!_visible);
    const rightSection = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $crMIh.ActionIcon), {
        className: classes.visibilityToggle,
        tabIndex: toggleTabIndex,
        radius: radius,
        size: (0, $d8Ix8.getSize)({
            size: size,
            sizes: $fb01439cc4866a76$var$buttonSizes
        }),
        "aria-hidden": !visibilityToggleLabel,
        "aria-label": visibilityToggleLabel,
        unstyled: unstyled,
        onMouseDown: (event)=>{
            event.preventDefault();
            toggleVisibility();
        },
        onKeyDown: (event)=>{
            if (event.key === " ") {
                event.preventDefault();
                toggleVisibility();
            }
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(VisibilityToggleIcon, {
        reveal: _visible,
        size: (0, $d8Ix8.getSize)({
            size: size,
            sizes: $fb01439cc4866a76$var$iconSizes
        })
    }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $fb01439cc4866a76$var$__spreadValues($fb01439cc4866a76$var$__spreadValues({
        required: required,
        id: uuid,
        label: label,
        error: error,
        description: description,
        size: size,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        __staticSelector: __staticSelector,
        sx: sx,
        errorProps: errorProps,
        descriptionProps: descriptionProps,
        labelProps: labelProps,
        unstyled: unstyled,
        withAsterisk: withAsterisk,
        inputWrapperOrder: inputWrapperOrder,
        inputContainer: inputContainer,
        variant: variant
    }, systemStyles), wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), {
        component: "div",
        error: error,
        icon: icon,
        size: size,
        classNames: $fb01439cc4866a76$var$__spreadProps($fb01439cc4866a76$var$__spreadValues({}, classNames), {
            input: classes.input
        }),
        styles: styles,
        radius: radius,
        disabled: disabled,
        __staticSelector: __staticSelector,
        rightSectionWidth: rightSectionWidth,
        rightSection: !disabled && rightSection,
        variant: variant,
        unstyled: unstyled,
        iconWidth: iconWidth
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $fb01439cc4866a76$var$__spreadValues({
        type: _visible ? "text" : "password",
        required: required,
        "data-invalid": !!error || void 0,
        "data-with-icon": !!icon || void 0,
        className: classes.innerInput,
        disabled: disabled,
        id: uuid,
        ref: ref,
        autoComplete: "off"
    }, rest))));
});
$fb01439cc4866a76$export$b28585a458fee016.displayName = "@mantine/core/PasswordInput";

});
parcelRegister("7TPTS", function(module, exports) {

$parcel$export(module.exports, "PasswordToggleIcon", () => $5c05edca23cbd679$export$f33d260505b4b38f);

var $acw62 = parcelRequire("acw62");
const $5c05edca23cbd679$export$f33d260505b4b38f = ({ reveal: reveal, size: size })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            width: size,
            height: size
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: reveal ? "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z" : "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));

});

parcelRegister("5uUER", function(module, exports) {

$parcel$export(module.exports, "default", () => $400bb4369dbadef0$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");

var $bqYMI = parcelRequire("bqYMI");
var $400bb4369dbadef0$var$__defProp = Object.defineProperty;
var $400bb4369dbadef0$var$__defProps = Object.defineProperties;
var $400bb4369dbadef0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $400bb4369dbadef0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $400bb4369dbadef0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $400bb4369dbadef0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $400bb4369dbadef0$var$__defNormalProp = (obj, key, value)=>key in obj ? $400bb4369dbadef0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $400bb4369dbadef0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($400bb4369dbadef0$var$__hasOwnProp.call(b, prop)) $400bb4369dbadef0$var$__defNormalProp(a, prop, b[prop]);
    if ($400bb4369dbadef0$var$__getOwnPropSymbols) {
        for (var prop of $400bb4369dbadef0$var$__getOwnPropSymbols(b))if ($400bb4369dbadef0$var$__propIsEnum.call(b, prop)) $400bb4369dbadef0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $400bb4369dbadef0$var$__spreadProps = (a, b)=>$400bb4369dbadef0$var$__defProps(a, $400bb4369dbadef0$var$__getOwnPropDescs(b));
var $400bb4369dbadef0$var$useStyles = (0, $cQG1Y.createStyles)((theme, { rightSectionWidth: rightSectionWidth }, { size: size })=>({
        visibilityToggle: {},
        input: {
            position: "relative",
            overflow: "hidden"
        },
        innerInput: $400bb4369dbadef0$var$__spreadProps($400bb4369dbadef0$var$__spreadValues($400bb4369dbadef0$var$__spreadValues({}, theme.fn.fontStyles()), theme.fn.cover(0)), {
            backgroundColor: "transparent",
            border: `${(0, $2jkdX.rem)(1)} solid transparent`,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            boxSizing: "border-box",
            display: "block",
            width: `calc(100% - ${(0, $2jkdX.rem)(rightSectionWidth)})`,
            paddingLeft: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: (0, $bqYMI.sizes)
            })}  / 3)`,
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            height: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: (0, $bqYMI.sizes)
            })} - ${(0, $2jkdX.rem)(2)})`,
            lineHeight: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: (0, $bqYMI.sizes)
            })} - ${(0, $2jkdX.rem)(4)})`,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            "&::-ms-reveal, &::-ms-clear": {
                display: "none"
            },
            "&:focus": {
                outline: 0
            },
            "&:disabled": {
                cursor: "not-allowed",
                pointerEvents: "none",
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[1],
                color: theme.colors.dark[2],
                opacity: 0.6,
                "&::placeholder": {
                    color: theme.colors.dark[2]
                }
            },
            "&::placeholder": $400bb4369dbadef0$var$__spreadProps($400bb4369dbadef0$var$__spreadValues({}, theme.fn.placeholderStyles()), {
                opacity: 1
            }),
            "&[data-invalid]": {
                color: theme.fn.variant({
                    variant: "filled",
                    color: "red"
                }).background,
                "&::placeholder": {
                    opacity: 1,
                    color: theme.fn.variant({
                        variant: "filled",
                        color: "red"
                    }).background
                }
            },
            "&[data-with-icon]": {
                paddingLeft: (0, $d8Ix8.getSize)({
                    size: size,
                    sizes: (0, $bqYMI.sizes)
                })
            }
        })
    }));
var $400bb4369dbadef0$export$2e2bcd8739ae039 = $400bb4369dbadef0$var$useStyles;

});


parcelRegister("clUNc", function(module, exports) {

$parcel$export(module.exports, "PinInput", () => $8fe3800a10d9fecd$export$75ee337032588709);

var $acw62 = parcelRequire("acw62");

var $8nBd8 = parcelRequire("8nBd8");
var $ke4gU = parcelRequire("ke4gU");

var $64A2P = parcelRequire("64A2P");

var $3wqIf = parcelRequire("3wqIf");

var $6tUAL = parcelRequire("6tUAL");

var $9mTYo = parcelRequire("9mTYo");

var $gw63X = parcelRequire("gw63X");
var $8fe3800a10d9fecd$var$__defProp = Object.defineProperty;
var $8fe3800a10d9fecd$var$__defProps = Object.defineProperties;
var $8fe3800a10d9fecd$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8fe3800a10d9fecd$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8fe3800a10d9fecd$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8fe3800a10d9fecd$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8fe3800a10d9fecd$var$__defNormalProp = (obj, key, value)=>key in obj ? $8fe3800a10d9fecd$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8fe3800a10d9fecd$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8fe3800a10d9fecd$var$__hasOwnProp.call(b, prop)) $8fe3800a10d9fecd$var$__defNormalProp(a, prop, b[prop]);
    if ($8fe3800a10d9fecd$var$__getOwnPropSymbols) {
        for (var prop of $8fe3800a10d9fecd$var$__getOwnPropSymbols(b))if ($8fe3800a10d9fecd$var$__propIsEnum.call(b, prop)) $8fe3800a10d9fecd$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8fe3800a10d9fecd$var$__spreadProps = (a, b)=>$8fe3800a10d9fecd$var$__defProps(a, $8fe3800a10d9fecd$var$__getOwnPropDescs(b));
var $8fe3800a10d9fecd$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8fe3800a10d9fecd$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8fe3800a10d9fecd$var$__getOwnPropSymbols) {
        for (var prop of $8fe3800a10d9fecd$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8fe3800a10d9fecd$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8fe3800a10d9fecd$var$regex = {
    number: /^[0-9]+$/,
    alphanumeric: /^[a-zA-Z0-9]+$/i
};
const $8fe3800a10d9fecd$var$defaultProps = {
    spacing: "sm",
    size: "sm",
    length: 4,
    manageFocus: true,
    placeholder: "\u25CB",
    type: "alphanumeric"
};
const $8fe3800a10d9fecd$export$75ee337032588709 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("PinInput", $8fe3800a10d9fecd$var$defaultProps, props), { name: name, form: form, className: className, value: value, defaultValue: defaultValue, variant: variant, spacing: spacing, size: size, classNames: classNames, styles: styles, unstyled: unstyled, sx: sx, length: length, onChange: onChange, onComplete: onComplete, manageFocus: manageFocus, autoFocus: autoFocus, error: error, radius: radius, disabled: disabled, oneTimeCode: oneTimeCode, placeholder: placeholder, type: type, mask: mask, "aria-label": ariaLabel, readOnly: readOnly, inputType: inputType, inputMode: inputMode } = _a, others = $8fe3800a10d9fecd$var$__objRest(_a, [
        "name",
        "form",
        "className",
        "value",
        "defaultValue",
        "variant",
        "spacing",
        "size",
        "classNames",
        "styles",
        "unstyled",
        "sx",
        "length",
        "onChange",
        "onComplete",
        "manageFocus",
        "autoFocus",
        "error",
        "radius",
        "disabled",
        "oneTimeCode",
        "placeholder",
        "type",
        "mask",
        "aria-label",
        "readOnly",
        "inputType",
        "inputMode"
    ]);
    const uuid = (0, $8nBd8.useId)(name);
    const { classes: classes, cx: cx } = (0, $6tUAL.default)(null, {
        name: "PinInput",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const [focusedIndex, setFocusedIndex] = (0, $acw62.useState)(-1);
    const [_value, setValues] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: "",
        onChange: onChange
    });
    const inputsRef = (0, $acw62.useRef)([]);
    const validate = (code)=>{
        const re = type instanceof RegExp ? type : type in $8fe3800a10d9fecd$var$regex ? $8fe3800a10d9fecd$var$regex[type] : null;
        return re == null ? void 0 : re.test(code);
    };
    const focusInputField = (dir, index)=>{
        if (!manageFocus) return;
        if (dir === "next") {
            const nextIndex = index + 1;
            inputsRef.current[nextIndex < length ? nextIndex : index].focus();
        }
        if (dir === "prev") {
            const nextIndex = index - 1;
            inputsRef.current[nextIndex > -1 ? nextIndex : index].focus();
        }
    };
    const setFieldValue = (val, index)=>{
        const values = [
            ...(0, $3wqIf.createPinArray)(length, _value)
        ];
        values[index] = val;
        setValues(values.join(""));
    };
    const handleChange = (event, index)=>{
        const inputValue = event.target.value;
        const nextCharOrValue = inputValue.length === 2 ? inputValue.split("")[inputValue.length - 1] : inputValue;
        const isValid = validate(nextCharOrValue);
        if (nextCharOrValue.length < 2) {
            if (isValid) {
                setFieldValue(nextCharOrValue, index);
                focusInputField("next", index);
            } else setFieldValue("", index);
        } else if (isValid) setValues(inputValue);
    };
    const handleKeyDown = (event, index)=>{
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            focusInputField("prev", index);
        } else if (event.key === "ArrowRight") {
            event.preventDefault();
            focusInputField("next", index);
        } else if (event.key === "Delete") {
            event.preventDefault();
            setFieldValue("", index);
        } else if (event.key === "Backspace") {
            event.preventDefault();
            setFieldValue("", index);
            if (length === index + 1) {
                if (event.target.value === "") focusInputField("prev", index);
            } else focusInputField("prev", index);
        }
    };
    const handleFocus = (event, index)=>{
        event.target.select();
        setFocusedIndex(index);
    };
    const handleBlur = ()=>{
        setFocusedIndex(-1);
    };
    const handlePaste = (event)=>{
        event.preventDefault();
        const copyValue = event.clipboardData.getData("Text");
        const isValid = validate(copyValue);
        if (isValid) setValues(copyValue);
    };
    (0, $acw62.useEffect)(()=>{
        if (_value.length !== length) return;
        onComplete == null || onComplete(_value);
    }, [
        _value
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9mTYo.Group), $8fe3800a10d9fecd$var$__spreadValues({
        role: "group",
        spacing: spacing,
        ref: ref,
        className: cx(classes.root, className),
        sx: sx,
        unstyled: unstyled,
        id: uuid,
        noWrap: true
    }, others), (0, $3wqIf.createPinArray)(length, _value).map((char, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), {
            __staticSelector: "PinInput",
            id: `${uuid}-${index + 1}`,
            key: `${uuid}-${index}`,
            inputMode: inputMode || (type === "number" ? "numeric" : "text"),
            onChange: (event)=>handleChange(event, index),
            onKeyDown: (event)=>handleKeyDown(event, index),
            onFocus: (event)=>handleFocus(event, index),
            onBlur: handleBlur,
            onPaste: handlePaste,
            type: inputType || (mask ? "password" : type === "number" ? "tel" : "text"),
            radius: radius,
            error: error,
            variant: variant,
            size: size,
            disabled: disabled,
            ref: (node)=>{
                inputsRef.current[index] = node;
            },
            autoComplete: oneTimeCode ? "one-time-code" : "off",
            placeholder: focusedIndex === index ? "" : placeholder,
            value: char,
            autoFocus: autoFocus && index === 0,
            classNames: $8fe3800a10d9fecd$var$__spreadProps($8fe3800a10d9fecd$var$__spreadValues({}, classNames), {
                input: cx(classes.input, classNames == null ? void 0 : classNames.input)
            }),
            styles: styles,
            unstyled: unstyled,
            "aria-label": ariaLabel,
            readOnly: readOnly
        }))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "hidden",
        name: name,
        form: form,
        value: _value
    }));
});
$8fe3800a10d9fecd$export$75ee337032588709.displayName = "@mantine/core/PinInput";

});
parcelRegister("3wqIf", function(module, exports) {

$parcel$export(module.exports, "createPinArray", () => $290914d75c9a4f59$export$29eae2d805250793);
function $290914d75c9a4f59$export$29eae2d805250793(length, value) {
    if (length < 1) return [];
    const values = new Array(length).fill("");
    if (value) {
        const splitted = value.trim().split("");
        for(let i = 0; i < Math.min(length, splitted.length); i += 1)values[i] = splitted[i];
    }
    return values;
}

});

parcelRegister("6tUAL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b81597a2a9e586d$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
const $4b81597a2a9e586d$var$sizes = {
    xs: (0, $2jkdX.rem)(28),
    sm: (0, $2jkdX.rem)(32),
    md: (0, $2jkdX.rem)(36),
    lg: (0, $2jkdX.rem)(40),
    xl: (0, $2jkdX.rem)(48)
};
var $4b81597a2a9e586d$var$useStyles = (0, $cQG1Y.createStyles)((_theme, _params, { size: size })=>({
        root: {},
        input: {
            width: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $4b81597a2a9e586d$var$sizes
            }),
            height: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $4b81597a2a9e586d$var$sizes
            }),
            textAlign: "center",
            minHeight: "auto",
            padding: 0,
            lineHeight: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $4b81597a2a9e586d$var$sizes
            }),
            "&::selection": {
                background: "transparent"
            }
        }
    }));
var $4b81597a2a9e586d$export$2e2bcd8739ae039 = $4b81597a2a9e586d$var$useStyles;

});


parcelRegister("jMtx3", function(module, exports) {

$parcel$export(module.exports, "Progress", () => $e6696874e15df142$export$b25a304ec7d746bb);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $6js1q = parcelRequire("6js1q");

var $60Ffz = parcelRequire("60Ffz");

var $hiiR1 = parcelRequire("hiiR1");

var $cjohz = parcelRequire("cjohz");
var $e6696874e15df142$var$__defProp = Object.defineProperty;
var $e6696874e15df142$var$__defProps = Object.defineProperties;
var $e6696874e15df142$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e6696874e15df142$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e6696874e15df142$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e6696874e15df142$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e6696874e15df142$var$__defNormalProp = (obj, key, value)=>key in obj ? $e6696874e15df142$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e6696874e15df142$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e6696874e15df142$var$__hasOwnProp.call(b, prop)) $e6696874e15df142$var$__defNormalProp(a, prop, b[prop]);
    if ($e6696874e15df142$var$__getOwnPropSymbols) {
        for (var prop of $e6696874e15df142$var$__getOwnPropSymbols(b))if ($e6696874e15df142$var$__propIsEnum.call(b, prop)) $e6696874e15df142$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e6696874e15df142$var$__spreadProps = (a, b)=>$e6696874e15df142$var$__defProps(a, $e6696874e15df142$var$__getOwnPropDescs(b));
var $e6696874e15df142$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($e6696874e15df142$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $e6696874e15df142$var$__getOwnPropSymbols) {
        for (var prop of $e6696874e15df142$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $e6696874e15df142$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $e6696874e15df142$var$getCumulativeSections(sections) {
    return sections.reduce((acc, section)=>{
        acc.sections.push($e6696874e15df142$var$__spreadProps($e6696874e15df142$var$__spreadValues({}, section), {
            accumulated: acc.accumulated
        }));
        acc.accumulated += section.value;
        return acc;
    }, {
        accumulated: 0,
        sections: []
    }).sections;
}
const $e6696874e15df142$var$defaultProps = {
    size: "md",
    radius: "sm",
    striped: false,
    animate: false,
    label: ""
};
const $e6696874e15df142$export$b25a304ec7d746bb = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Progress", $e6696874e15df142$var$defaultProps, props), { className: className, value: value, color: color, size: size, radius: radius, striped: striped, animate: animate, label: label, "aria-label": ariaLabel, classNames: classNames, styles: styles, sections: sections, unstyled: unstyled, variant: variant } = _a, others = $e6696874e15df142$var$__objRest(_a, [
        "className",
        "value",
        "color",
        "size",
        "radius",
        "striped",
        "animate",
        "label",
        "aria-label",
        "classNames",
        "styles",
        "sections",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx, theme: theme } = (0, $6js1q.default)({
        color: color,
        radius: radius
    }, {
        name: "Progress",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const segments = Array.isArray(sections) ? $e6696874e15df142$var$getCumulativeSections(sections).map((_b, index)=>{
        var _c = _b, { tooltip: tooltip, accumulated: accumulated, value: sectionValue, label: sectionLabel, color: sectionColor } = _c, sectionProps = $e6696874e15df142$var$__objRest(_c, [
            "tooltip",
            "accumulated",
            "value",
            "label",
            "color"
        ]);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $60Ffz.Tooltip).Floating, {
            label: tooltip,
            disabled: !tooltip,
            key: index
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $e6696874e15df142$var$__spreadProps($e6696874e15df142$var$__spreadValues({}, sectionProps), {
            className: cx(classes.bar, sectionProps.className),
            "data-striped": striped || animate || void 0,
            "data-animate": animate || void 0,
            sx: {
                width: `${sectionValue}%`,
                left: `${accumulated}%`,
                backgroundColor: theme.fn.variant({
                    variant: "filled",
                    primaryFallback: false,
                    color: sectionColor || theme.primaryColor
                }).background
            }
        }), sectionLabel && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
            className: classes.label
        }, sectionLabel)));
    }) : null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $e6696874e15df142$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), segments || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "progressbar",
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuenow": value,
        "aria-label": ariaLabel,
        className: classes.bar,
        style: {
            width: `${value}%`
        },
        "data-striped": striped || animate || void 0,
        "data-animate": animate || void 0
    }, label ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        className: classes.label
    }, label) : ""));
});
$e6696874e15df142$export$b25a304ec7d746bb.displayName = "@mantine/core/Progress";

});
parcelRegister("6js1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $498a4106ade5e663$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $jjlaj = parcelRequire("jjlaj");
var $2jkdX = parcelRequire("2jkdX");
const $498a4106ade5e663$var$sizes = {
    xs: (0, $2jkdX.rem)(3),
    sm: (0, $2jkdX.rem)(5),
    md: (0, $2jkdX.rem)(8),
    lg: (0, $2jkdX.rem)(12),
    xl: (0, $2jkdX.rem)(16)
};
const $498a4106ade5e663$var$stripesAnimation = (0, $jjlaj.keyframes)({
    from: {
        backgroundPosition: "0 0"
    },
    to: {
        backgroundPosition: `${(0, $2jkdX.rem)(40)} 0`
    }
});
var $498a4106ade5e663$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, radius: radius }, { size: size })=>({
        root: {
            position: "relative",
            height: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $498a4106ade5e663$var$sizes
            }),
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
            borderRadius: theme.fn.radius(radius),
            overflow: "hidden"
        },
        bar: {
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: theme.fn.variant({
                variant: "filled",
                primaryFallback: false,
                color: color || theme.primaryColor
            }).background,
            transition: "width 100ms linear",
            "&[data-animate]": {
                animation: `${$498a4106ade5e663$var$stripesAnimation} 1000ms linear infinite`
            },
            "&[data-striped]": {
                backgroundSize: `${(0, $2jkdX.rem)(20)} ${(0, $2jkdX.rem)(20)}`,
                backgroundImage: "linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)"
            },
            "&:last-of-type": {
                borderTopRightRadius: theme.fn.radius(radius),
                borderBottomRightRadius: theme.fn.radius(radius)
            },
            "&:first-of-type": {
                borderTopLeftRadius: theme.fn.radius(radius),
                borderBottomLeftRadius: theme.fn.radius(radius)
            },
            "@media (prefers-reduced-motion)": {
                transitionDuration: theme.respectReducedMotion ? "0ms" : void 0
            }
        },
        label: {
            color: theme.white,
            fontSize: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: $498a4106ade5e663$var$sizes
            })} * 0.65)`,
            fontWeight: 700,
            userSelect: "none",
            overflow: "hidden",
            whiteSpace: "nowrap"
        }
    }));
var $498a4106ade5e663$export$2e2bcd8739ae039 = $498a4106ade5e663$var$useStyles;

});

parcelRegister("60Ffz", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $4602bd931d9db495$export$28c660c63b792dea);

var $acw62 = parcelRequire("acw62");

var $cOXe5 = parcelRequire("cOXe5");

var $4GmKa = parcelRequire("4GmKa");

var $iu1L3 = parcelRequire("iu1L3");
var $64A2P = parcelRequire("64A2P");

var $4OlJX = parcelRequire("4OlJX");

var $8sg9w = parcelRequire("8sg9w");

var $jDgGn = parcelRequire("jDgGn");

var $atlXu = parcelRequire("atlXu");

var $bcytu = parcelRequire("bcytu");

var $hxIdR = parcelRequire("hxIdR");

var $hZi38 = parcelRequire("hZi38");

var $1RCXp = parcelRequire("1RCXp");

var $hiiR1 = parcelRequire("hiiR1");

var $4NFGZ = parcelRequire("4NFGZ");
var $4602bd931d9db495$var$__defProp = Object.defineProperty;
var $4602bd931d9db495$var$__defProps = Object.defineProperties;
var $4602bd931d9db495$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4602bd931d9db495$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4602bd931d9db495$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4602bd931d9db495$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4602bd931d9db495$var$__defNormalProp = (obj, key, value)=>key in obj ? $4602bd931d9db495$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4602bd931d9db495$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4602bd931d9db495$var$__hasOwnProp.call(b, prop)) $4602bd931d9db495$var$__defNormalProp(a, prop, b[prop]);
    if ($4602bd931d9db495$var$__getOwnPropSymbols) {
        for (var prop of $4602bd931d9db495$var$__getOwnPropSymbols(b))if ($4602bd931d9db495$var$__propIsEnum.call(b, prop)) $4602bd931d9db495$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4602bd931d9db495$var$__spreadProps = (a, b)=>$4602bd931d9db495$var$__defProps(a, $4602bd931d9db495$var$__getOwnPropDescs(b));
var $4602bd931d9db495$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4602bd931d9db495$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4602bd931d9db495$var$__getOwnPropSymbols) {
        for (var prop of $4602bd931d9db495$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4602bd931d9db495$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $4602bd931d9db495$var$defaultProps = {
    position: "top",
    refProp: "ref",
    withinPortal: false,
    inline: false,
    arrowSize: 4,
    arrowOffset: 5,
    arrowRadius: 0,
    arrowPosition: "side",
    offset: 5,
    transitionProps: {
        duration: 100,
        transition: "fade"
    },
    width: "auto",
    events: {
        hover: true,
        focus: false,
        touch: false
    },
    zIndex: (0, $iu1L3.getDefaultZIndex)("popover"),
    positionDependencies: []
};
const $4602bd931d9db495$var$_Tooltip = (0, $acw62.forwardRef)((props, ref)=>{
    var _b;
    const arrowRef = (0, $acw62.useRef)(null);
    const _a = (0, $64A2P.useComponentDefaultProps)("Tooltip", $4602bd931d9db495$var$defaultProps, props), { children: children, position: position, refProp: refProp, label: label, openDelay: openDelay, closeDelay: closeDelay, onPositionChange: onPositionChange, opened: opened, withinPortal: withinPortal, portalProps: portalProps, radius: radius, color: color, classNames: classNames, styles: styles, unstyled: unstyled, style: style, className: className, withArrow: withArrow, arrowSize: arrowSize, arrowOffset: arrowOffset, arrowRadius: arrowRadius, arrowPosition: arrowPosition, offset: offset, transitionProps: transitionProps, multiline: multiline, width: width, events: events, zIndex: zIndex, disabled: disabled, positionDependencies: positionDependencies, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, inline: inline, variant: variant, keepMounted: keepMounted } = _a, others = $4602bd931d9db495$var$__objRest(_a, [
        "children",
        "position",
        "refProp",
        "label",
        "openDelay",
        "closeDelay",
        "onPositionChange",
        "opened",
        "withinPortal",
        "portalProps",
        "radius",
        "color",
        "classNames",
        "styles",
        "unstyled",
        "style",
        "className",
        "withArrow",
        "arrowSize",
        "arrowOffset",
        "arrowRadius",
        "arrowPosition",
        "offset",
        "transitionProps",
        "multiline",
        "width",
        "events",
        "zIndex",
        "disabled",
        "positionDependencies",
        "onClick",
        "onMouseEnter",
        "onMouseLeave",
        "inline",
        "variant",
        "keepMounted"
    ]);
    const { classes: classes, cx: cx, theme: theme } = (0, $bcytu.default)({
        radius: radius,
        color: color,
        width: width,
        multiline: multiline
    }, {
        name: "Tooltip",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    const tooltip = (0, $jDgGn.useTooltip)({
        position: (0, $hxIdR.getFloatingPosition)(theme.dir, position),
        closeDelay: closeDelay,
        openDelay: openDelay,
        onPositionChange: onPositionChange,
        opened: opened,
        events: events,
        arrowRef: arrowRef,
        arrowOffset: arrowOffset,
        offset: offset + (withArrow ? arrowSize / 2 : 0),
        positionDependencies: [
            ...positionDependencies,
            children
        ],
        inline: inline
    });
    if (!(0, $cOXe5.isElement)(children)) throw new Error((0, $atlXu.TOOLTIP_ERRORS).children);
    const targetRef = (0, $4GmKa.useMergedRef)(tooltip.reference, children.ref, ref);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZi38.OptionalPortal), $4602bd931d9db495$var$__spreadProps($4602bd931d9db495$var$__spreadValues({}, portalProps), {
        withinPortal: withinPortal
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1RCXp.Transition), $4602bd931d9db495$var$__spreadProps($4602bd931d9db495$var$__spreadValues({
        keepMounted: keepMounted,
        mounted: !disabled && tooltip.opened
    }, transitionProps), {
        transition: transitionProps.transition || "fade",
        duration: tooltip.isGroupPhase ? 10 : (_b = transitionProps.duration) != null ? _b : 100
    }), (transitionStyles)=>{
        var _a2, _b2;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $4602bd931d9db495$var$__spreadValues($4602bd931d9db495$var$__spreadValues({}, others), tooltip.getFloatingProps({
            ref: tooltip.floating,
            className: classes.tooltip,
            style: $4602bd931d9db495$var$__spreadProps($4602bd931d9db495$var$__spreadValues($4602bd931d9db495$var$__spreadValues({}, style), transitionStyles), {
                zIndex: zIndex,
                top: (_a2 = tooltip.y) != null ? _a2 : 0,
                left: (_b2 = tooltip.x) != null ? _b2 : 0
            })
        })), label, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4NFGZ.FloatingArrow), {
            ref: arrowRef,
            arrowX: tooltip.arrowX,
            arrowY: tooltip.arrowY,
            visible: withArrow,
            position: tooltip.placement,
            arrowSize: arrowSize,
            arrowOffset: arrowOffset,
            arrowRadius: arrowRadius,
            arrowPosition: arrowPosition,
            className: classes.arrow
        }));
    })), (0, $acw62.cloneElement)(children, tooltip.getReferenceProps($4602bd931d9db495$var$__spreadValues({
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseMove: props.onMouseMove,
        onPointerDown: props.onPointerDown,
        onPointerEnter: props.onPointerEnter,
        [refProp]: targetRef,
        className: cx(className, children.props.className)
    }, children.props))));
});
$4602bd931d9db495$var$_Tooltip.Group = (0, $4OlJX.TooltipGroup);
$4602bd931d9db495$var$_Tooltip.Floating = (0, $8sg9w.TooltipFloating);
$4602bd931d9db495$var$_Tooltip.displayName = "@mantine/core/Tooltip";
const $4602bd931d9db495$export$28c660c63b792dea = $4602bd931d9db495$var$_Tooltip;

});
parcelRegister("4OlJX", function(module, exports) {

$parcel$export(module.exports, "TooltipGroup", () => $380cb215a173b9d1$export$9631df88d081a134);

var $acw62 = parcelRequire("acw62");

var $5rxG7 = parcelRequire("5rxG7");

var $94Ic5 = parcelRequire("94Ic5");
function $380cb215a173b9d1$export$9631df88d081a134({ children: children, openDelay: openDelay = 0, closeDelay: closeDelay = 0 }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $94Ic5.TooltipGroupProvider), {
        value: true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5rxG7.FloatingDelayGroup), {
        delay: {
            open: openDelay,
            close: closeDelay
        }
    }, children));
}
$380cb215a173b9d1$export$9631df88d081a134.displayName = "@mantine/core/TooltipGroup";

});
parcelRegister("94Ic5", function(module, exports) {

$parcel$export(module.exports, "TooltipGroupProvider", () => $69b6c4c97d77733a$export$dd3b019c59d83d0a);
$parcel$export(module.exports, "useTooltipGroupContext", () => $69b6c4c97d77733a$export$19f482f27420c02c);

var $acw62 = parcelRequire("acw62");
const $69b6c4c97d77733a$var$TooltipGroupContext = (0, $acw62.createContext)(false);
const $69b6c4c97d77733a$export$dd3b019c59d83d0a = $69b6c4c97d77733a$var$TooltipGroupContext.Provider;
const $69b6c4c97d77733a$export$19f482f27420c02c = ()=>(0, $acw62.useContext)($69b6c4c97d77733a$var$TooltipGroupContext);

});


parcelRegister("8sg9w", function(module, exports) {

$parcel$export(module.exports, "TooltipFloating", () => $627d77d67529094e$export$bed1d4fd3f4254a5);

var $acw62 = parcelRequire("acw62");

var $cOXe5 = parcelRequire("cOXe5");

var $4GmKa = parcelRequire("4GmKa");

var $iu1L3 = parcelRequire("iu1L3");
var $64A2P = parcelRequire("64A2P");

var $bcytu = parcelRequire("bcytu");

var $atlXu = parcelRequire("atlXu");

var $jYWZ4 = parcelRequire("jYWZ4");

var $hZi38 = parcelRequire("hZi38");

var $hiiR1 = parcelRequire("hiiR1");
var $627d77d67529094e$var$__defProp = Object.defineProperty;
var $627d77d67529094e$var$__defProps = Object.defineProperties;
var $627d77d67529094e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $627d77d67529094e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $627d77d67529094e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $627d77d67529094e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $627d77d67529094e$var$__defNormalProp = (obj, key, value)=>key in obj ? $627d77d67529094e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $627d77d67529094e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($627d77d67529094e$var$__hasOwnProp.call(b, prop)) $627d77d67529094e$var$__defNormalProp(a, prop, b[prop]);
    if ($627d77d67529094e$var$__getOwnPropSymbols) {
        for (var prop of $627d77d67529094e$var$__getOwnPropSymbols(b))if ($627d77d67529094e$var$__propIsEnum.call(b, prop)) $627d77d67529094e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $627d77d67529094e$var$__spreadProps = (a, b)=>$627d77d67529094e$var$__defProps(a, $627d77d67529094e$var$__getOwnPropDescs(b));
var $627d77d67529094e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($627d77d67529094e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $627d77d67529094e$var$__getOwnPropSymbols) {
        for (var prop of $627d77d67529094e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $627d77d67529094e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $627d77d67529094e$var$defaultProps = {
    refProp: "ref",
    withinPortal: true,
    offset: 10,
    position: "right",
    zIndex: (0, $iu1L3.getDefaultZIndex)("popover")
};
function $627d77d67529094e$export$bed1d4fd3f4254a5(props) {
    var _b;
    const _a = (0, $64A2P.useComponentDefaultProps)("TooltipFloating", $627d77d67529094e$var$defaultProps, props), { children: children, refProp: refProp, withinPortal: withinPortal, portalProps: portalProps, style: style, className: className, classNames: classNames, styles: styles, unstyled: unstyled, radius: radius, color: color, label: label, offset: offset, position: position, multiline: multiline, width: width, zIndex: zIndex, disabled: disabled, variant: variant } = _a, others = $627d77d67529094e$var$__objRest(_a, [
        "children",
        "refProp",
        "withinPortal",
        "portalProps",
        "style",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "radius",
        "color",
        "label",
        "offset",
        "position",
        "multiline",
        "width",
        "zIndex",
        "disabled",
        "variant"
    ]);
    const { handleMouseMove: handleMouseMove, x: x, y: y, opened: opened, boundaryRef: boundaryRef, floating: floating, setOpened: setOpened } = (0, $jYWZ4.useFloatingTooltip)({
        offset: offset,
        position: position
    });
    const { classes: classes, cx: cx } = (0, $bcytu.default)({
        radius: radius,
        color: color,
        multiline: multiline,
        width: width
    }, {
        name: "TooltipFloating",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    if (!(0, $cOXe5.isElement)(children)) throw new Error((0, $atlXu.TOOLTIP_ERRORS).children);
    const targetRef = (0, $4GmKa.useMergedRef)(boundaryRef, children.ref);
    const onMouseEnter = (event)=>{
        var _a2, _b2;
        (_b2 = (_a2 = children.props).onMouseEnter) == null || _b2.call(_a2, event);
        handleMouseMove(event);
        setOpened(true);
    };
    const onMouseLeave = (event)=>{
        var _a2, _b2;
        (_b2 = (_a2 = children.props).onMouseLeave) == null || _b2.call(_a2, event);
        setOpened(false);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZi38.OptionalPortal), $627d77d67529094e$var$__spreadProps($627d77d67529094e$var$__spreadValues({}, portalProps), {
        withinPortal: withinPortal
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $627d77d67529094e$var$__spreadProps($627d77d67529094e$var$__spreadValues({}, others), {
        ref: floating,
        className: cx(classes.tooltip, className),
        style: $627d77d67529094e$var$__spreadProps($627d77d67529094e$var$__spreadValues({}, style), {
            zIndex: zIndex,
            display: !disabled && opened ? "block" : "none",
            top: y != null ? y : "",
            left: (_b = Math.round(x)) != null ? _b : ""
        })
    }), label)), (0, $acw62.cloneElement)(children, $627d77d67529094e$var$__spreadProps($627d77d67529094e$var$__spreadValues({}, children.props), {
        [refProp]: targetRef,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    })));
}
$627d77d67529094e$export$bed1d4fd3f4254a5.displayName = "@mantine/core/TooltipFloating";

});
parcelRegister("bcytu", function(module, exports) {

$parcel$export(module.exports, "default", () => $827b8e9f9d10561f$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $827b8e9f9d10561f$var$__defProp = Object.defineProperty;
var $827b8e9f9d10561f$var$__defProps = Object.defineProperties;
var $827b8e9f9d10561f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $827b8e9f9d10561f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $827b8e9f9d10561f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $827b8e9f9d10561f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $827b8e9f9d10561f$var$__defNormalProp = (obj, key, value)=>key in obj ? $827b8e9f9d10561f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $827b8e9f9d10561f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($827b8e9f9d10561f$var$__hasOwnProp.call(b, prop)) $827b8e9f9d10561f$var$__defNormalProp(a, prop, b[prop]);
    if ($827b8e9f9d10561f$var$__getOwnPropSymbols) {
        for (var prop of $827b8e9f9d10561f$var$__getOwnPropSymbols(b))if ($827b8e9f9d10561f$var$__propIsEnum.call(b, prop)) $827b8e9f9d10561f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $827b8e9f9d10561f$var$__spreadProps = (a, b)=>$827b8e9f9d10561f$var$__defProps(a, $827b8e9f9d10561f$var$__getOwnPropDescs(b));
function $827b8e9f9d10561f$var$getColors(theme, color) {
    if (!color) return {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.gray[2] : theme.colors.gray[9],
        color: theme.colorScheme === "dark" ? theme.black : theme.white
    };
    const colors = theme.fn.variant({
        variant: "filled",
        color: color,
        primaryFallback: false
    });
    return {
        backgroundColor: colors.background,
        color: colors.color
    };
}
var $827b8e9f9d10561f$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, radius: radius, width: width, multiline: multiline })=>({
        tooltip: $827b8e9f9d10561f$var$__spreadProps($827b8e9f9d10561f$var$__spreadValues($827b8e9f9d10561f$var$__spreadValues({}, theme.fn.fontStyles()), $827b8e9f9d10561f$var$getColors(theme, color)), {
            lineHeight: theme.lineHeight,
            fontSize: theme.fontSizes.sm,
            borderRadius: theme.fn.radius(radius),
            padding: `calc(${theme.spacing.xs} / 2) ${theme.spacing.xs}`,
            position: "absolute",
            whiteSpace: multiline ? "unset" : "nowrap",
            pointerEvents: "none",
            width: width
        }),
        arrow: {
            backgroundColor: "inherit",
            border: 0,
            zIndex: 1
        }
    }));
var $827b8e9f9d10561f$export$2e2bcd8739ae039 = $827b8e9f9d10561f$var$useStyles;

});

parcelRegister("atlXu", function(module, exports) {

$parcel$export(module.exports, "TOOLTIP_ERRORS", () => $79fda5563c51fb95$export$425c554f14feeb46);
const $79fda5563c51fb95$export$425c554f14feeb46 = {
    children: "Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
};

});

parcelRegister("jYWZ4", function(module, exports) {

$parcel$export(module.exports, "useFloatingTooltip", () => $e8c15fe31ca46186$export$a27b7d58f66fa6f7);

var $acw62 = parcelRequire("acw62");
parcelRequire("5rxG7");
var $33bLr = parcelRequire("33bLr");
var $5rxG7 = parcelRequire("5rxG7");
var $618j3 = parcelRequire("618j3");
function $e8c15fe31ca46186$export$a27b7d58f66fa6f7({ offset: offset, position: position }) {
    const [opened, setOpened] = (0, $acw62.useState)(false);
    const boundaryRef = (0, $acw62.useRef)();
    const { x: x, y: y, reference: reference, floating: floating, refs: refs, update: update, placement: placement } = (0, $5rxG7.useFloating)({
        placement: position,
        middleware: [
            (0, $618j3.shift)({
                crossAxis: true,
                padding: 5,
                rootBoundary: "document"
            })
        ]
    });
    const horizontalOffset = placement.includes("right") ? offset : position.includes("left") ? offset * -1 : 0;
    const verticalOffset = placement.includes("bottom") ? offset : position.includes("top") ? offset * -1 : 0;
    const handleMouseMove = (0, $acw62.useCallback)(({ clientX: clientX, clientY: clientY })=>{
        reference({
            getBoundingClientRect () {
                return {
                    width: 0,
                    height: 0,
                    x: clientX,
                    y: clientY,
                    left: clientX + horizontalOffset,
                    top: clientY + verticalOffset,
                    right: clientX,
                    bottom: clientY
                };
            }
        });
    }, [
        reference
    ]);
    (0, $acw62.useEffect)(()=>{
        if (refs.floating.current) {
            const boundary = boundaryRef.current;
            boundary.addEventListener("mousemove", handleMouseMove);
            const parents = (0, $33bLr.getOverflowAncestors)(refs.floating.current);
            parents.forEach((parent)=>{
                parent.addEventListener("scroll", update);
            });
            return ()=>{
                boundary.removeEventListener("mousemove", handleMouseMove);
                parents.forEach((parent)=>{
                    parent.removeEventListener("scroll", update);
                });
            };
        }
        return void 0;
    }, [
        reference,
        refs.floating.current,
        update,
        handleMouseMove,
        opened
    ]);
    return {
        handleMouseMove: handleMouseMove,
        x: x,
        y: y,
        opened: opened,
        setOpened: setOpened,
        boundaryRef: boundaryRef,
        floating: floating
    };
}

});


parcelRegister("jDgGn", function(module, exports) {

$parcel$export(module.exports, "useTooltip", () => $e4ae999e0682a860$export$1c4b08e0eca38426);

var $acw62 = parcelRequire("acw62");

var $33OG6 = parcelRequire("33OG6");
var $618j3 = parcelRequire("618j3");parcelRequire("5rxG7");
var $618j3 = parcelRequire("618j3");
var $5rxG7 = parcelRequire("5rxG7");

var $2qf6h = parcelRequire("2qf6h");
var $8nBd8 = parcelRequire("8nBd8");

var $94Ic5 = parcelRequire("94Ic5");

var $8nNfC = parcelRequire("8nNfC");
function $e4ae999e0682a860$export$1c4b08e0eca38426(settings) {
    const [uncontrolledOpened, setUncontrolledOpened] = (0, $acw62.useState)(false);
    const controlled = typeof settings.opened === "boolean";
    const opened = controlled ? settings.opened : uncontrolledOpened;
    const withinGroup = (0, $94Ic5.useTooltipGroupContext)();
    const uid = (0, $8nBd8.useId)();
    const { delay: groupDelay, currentId: currentId, setCurrentId: setCurrentId } = (0, $5rxG7.useDelayGroupContext)();
    const onChange = (0, $acw62.useCallback)((_opened)=>{
        setUncontrolledOpened(_opened);
        if (_opened) setCurrentId(uid);
    }, [
        setCurrentId,
        uid
    ]);
    const { x: x, y: y, reference: reference, floating: floating, context: context, refs: refs, update: update, placement: placement, middlewareData: { arrow: { x: arrowX, y: arrowY } = {} } } = (0, $5rxG7.useFloating)({
        placement: settings.position,
        open: opened,
        onOpenChange: onChange,
        middleware: [
            (0, $618j3.offset)(settings.offset),
            (0, $618j3.shift)({
                padding: 8
            }),
            (0, $618j3.flip)(),
            (0, $33OG6.arrow)({
                element: settings.arrowRef,
                padding: settings.arrowOffset
            }),
            ...settings.inline ? [
                (0, $618j3.inline)()
            ] : []
        ]
    });
    const { getReferenceProps: getReferenceProps, getFloatingProps: getFloatingProps } = (0, $5rxG7.useInteractions)([
        (0, $5rxG7.useHover)(context, {
            enabled: settings.events.hover,
            delay: withinGroup ? groupDelay : {
                open: settings.openDelay,
                close: settings.closeDelay
            },
            mouseOnly: !settings.events.touch
        }),
        (0, $5rxG7.useFocus)(context, {
            enabled: settings.events.focus,
            keyboardOnly: true
        }),
        (0, $5rxG7.useRole)(context, {
            role: "tooltip"
        }),
        (0, $5rxG7.useDismiss)(context, {
            enabled: (settings.opened, false)
        }),
        (0, $5rxG7.useDelayGroup)(context, {
            id: uid
        })
    ]);
    (0, $8nNfC.useFloatingAutoUpdate)({
        opened: opened,
        position: settings.position,
        positionDependencies: settings.positionDependencies,
        floating: {
            refs: refs,
            update: update
        }
    });
    (0, $2qf6h.useDidUpdate)(()=>{
        var _a;
        (_a = settings.onPositionChange) == null || _a.call(settings, placement);
    }, [
        placement
    ]);
    const isGroupPhase = opened && currentId && currentId !== uid;
    return {
        x: x,
        y: y,
        arrowX: arrowX,
        arrowY: arrowY,
        reference: reference,
        floating: floating,
        getFloatingProps: getFloatingProps,
        getReferenceProps: getReferenceProps,
        isGroupPhase: isGroupPhase,
        opened: opened,
        placement: placement
    };
}

});



parcelRegister("62A7W", function(module, exports) {

$parcel$export(module.exports, "px", () => $465ef414ca23020d$export$91c0eda1d06bf008);
function $465ef414ca23020d$export$91c0eda1d06bf008(value) {
    if (typeof value === "number") return value;
    if (typeof value === "string") {
        if (value.includes("px")) return Number(value.replace("px", ""));
        if (value.includes("rem")) return Number(value.replace("rem", "")) * 16;
        return Number(value);
    }
    return NaN;
}

});

parcelRegister("jc0Be", function(module, exports) {

$parcel$export(module.exports, "Radio", () => $df8f9a5bfba7687e$export$d7b12c4107be0d61);

var $acw62 = parcelRequire("acw62");

var $8nBd8 = parcelRequire("8nBd8");

var $64A2P = parcelRequire("64A2P");

var $6nQtF = parcelRequire("6nQtF");

var $1dFVN = parcelRequire("1dFVN");

var $gR5Dh = parcelRequire("gR5Dh");

var $sW8BC = parcelRequire("sW8BC");

var $aEkmw = parcelRequire("aEkmw");

var $im7xW = parcelRequire("im7xW");
var $df8f9a5bfba7687e$var$__defProp = Object.defineProperty;
var $df8f9a5bfba7687e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $df8f9a5bfba7687e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $df8f9a5bfba7687e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $df8f9a5bfba7687e$var$__defNormalProp = (obj, key, value)=>key in obj ? $df8f9a5bfba7687e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $df8f9a5bfba7687e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($df8f9a5bfba7687e$var$__hasOwnProp.call(b, prop)) $df8f9a5bfba7687e$var$__defNormalProp(a, prop, b[prop]);
    if ($df8f9a5bfba7687e$var$__getOwnPropSymbols) {
        for (var prop of $df8f9a5bfba7687e$var$__getOwnPropSymbols(b))if ($df8f9a5bfba7687e$var$__propIsEnum.call(b, prop)) $df8f9a5bfba7687e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $df8f9a5bfba7687e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($df8f9a5bfba7687e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $df8f9a5bfba7687e$var$__getOwnPropSymbols) {
        for (var prop of $df8f9a5bfba7687e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $df8f9a5bfba7687e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $df8f9a5bfba7687e$var$defaultProps = {
    icon: (0, $6nQtF.RadioIcon),
    transitionDuration: 100,
    size: "sm",
    labelPosition: "right"
};
const $df8f9a5bfba7687e$export$d7b12c4107be0d61 = (0, $acw62.forwardRef)((props, ref)=>{
    var _b, _c;
    const _a = (0, $64A2P.useComponentDefaultProps)("Radio", $df8f9a5bfba7687e$var$defaultProps, props), { className: className, style: style, id: id, label: label, size: size, title: title, disabled: disabled, color: color, classNames: classNames, styles: styles, sx: sx, icon: Icon, transitionDuration: transitionDuration, wrapperProps: wrapperProps, unstyled: unstyled, labelPosition: labelPosition, description: description, error: error, variant: variant } = _a, others = $df8f9a5bfba7687e$var$__objRest(_a, [
        "className",
        "style",
        "id",
        "label",
        "size",
        "title",
        "disabled",
        "color",
        "classNames",
        "styles",
        "sx",
        "icon",
        "transitionDuration",
        "wrapperProps",
        "unstyled",
        "labelPosition",
        "description",
        "error",
        "variant"
    ]);
    const ctx = (0, $1dFVN.useRadioGroupContext)();
    const contextSize = (_b = ctx == null ? void 0 : ctx.size) != null ? _b : size;
    const componentSize = props.size ? size : contextSize;
    const { classes: classes } = (0, $sW8BC.default)({
        color: color,
        transitionDuration: transitionDuration,
        labelPosition: labelPosition,
        error: !!error
    }, {
        name: "Radio",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: componentSize
    });
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const uuid = (0, $8nBd8.useId)(id);
    const contextProps = ctx ? {
        checked: ctx.value === rest.value,
        name: (_c = rest.name) != null ? _c : ctx.name,
        onChange: ctx.onChange
    } : {};
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $im7xW.InlineInput), $df8f9a5bfba7687e$var$__spreadValues($df8f9a5bfba7687e$var$__spreadValues({
        className: className,
        sx: sx,
        style: style,
        id: uuid,
        size: componentSize,
        labelPosition: labelPosition,
        label: label,
        description: description,
        error: error,
        disabled: disabled,
        __staticSelector: "Radio",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        "data-checked": contextProps.checked || void 0,
        variant: variant
    }, systemStyles), wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.inner
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $df8f9a5bfba7687e$var$__spreadValues($df8f9a5bfba7687e$var$__spreadValues({
        ref: ref,
        className: classes.radio,
        type: "radio",
        id: uuid,
        disabled: disabled
    }, rest), contextProps)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Icon, {
        className: classes.icon,
        "aria-hidden": true
    })));
});
$df8f9a5bfba7687e$export$d7b12c4107be0d61.displayName = "@mantine/core/Radio";
$df8f9a5bfba7687e$export$d7b12c4107be0d61.Group = (0, $gR5Dh.RadioGroup);

});
parcelRegister("6nQtF", function(module, exports) {

$parcel$export(module.exports, "RadioIcon", () => $4a5d9905f4c237ae$export$dc5561ae0d840124);

var $acw62 = parcelRequire("acw62");
var $4a5d9905f4c237ae$var$__defProp = Object.defineProperty;
var $4a5d9905f4c237ae$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4a5d9905f4c237ae$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4a5d9905f4c237ae$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4a5d9905f4c237ae$var$__defNormalProp = (obj, key, value)=>key in obj ? $4a5d9905f4c237ae$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4a5d9905f4c237ae$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4a5d9905f4c237ae$var$__hasOwnProp.call(b, prop)) $4a5d9905f4c237ae$var$__defNormalProp(a, prop, b[prop]);
    if ($4a5d9905f4c237ae$var$__getOwnPropSymbols) {
        for (var prop of $4a5d9905f4c237ae$var$__getOwnPropSymbols(b))if ($4a5d9905f4c237ae$var$__propIsEnum.call(b, prop)) $4a5d9905f4c237ae$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4a5d9905f4c237ae$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4a5d9905f4c237ae$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4a5d9905f4c237ae$var$__getOwnPropSymbols) {
        for (var prop of $4a5d9905f4c237ae$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4a5d9905f4c237ae$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $4a5d9905f4c237ae$export$dc5561ae0d840124(props) {
    const _a = props, { width: width, height: height, style: style } = _a, others = $4a5d9905f4c237ae$var$__objRest(_a, [
        "width",
        "height",
        "style"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $4a5d9905f4c237ae$var$__spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 5 5",
        style: $4a5d9905f4c237ae$var$__spreadValues({
            width: width,
            height: height
        }, style)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "currentColor",
        d: "M0 2.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z"
    }));
}

});

parcelRegister("1dFVN", function(module, exports) {

$parcel$export(module.exports, "RadioGroupProvider", () => $0e3787fd83a616f6$export$59b7462f266cd53f);
$parcel$export(module.exports, "useRadioGroupContext", () => $0e3787fd83a616f6$export$7bea016dc7ad2ddf);

var $acw62 = parcelRequire("acw62");
const $0e3787fd83a616f6$var$RadioGroupContext = (0, $acw62.createContext)(null);
const $0e3787fd83a616f6$export$59b7462f266cd53f = $0e3787fd83a616f6$var$RadioGroupContext.Provider;
const $0e3787fd83a616f6$export$7bea016dc7ad2ddf = ()=>(0, $acw62.useContext)($0e3787fd83a616f6$var$RadioGroupContext);

});

parcelRegister("gR5Dh", function(module, exports) {

$parcel$export(module.exports, "RadioGroup", () => $c455f7167c1d5cf5$export$a98f0dcb43a68a25);

var $acw62 = parcelRequire("acw62");

var $8nBd8 = parcelRequire("8nBd8");
var $ke4gU = parcelRequire("ke4gU");

var $64A2P = parcelRequire("64A2P");

var $1dFVN = parcelRequire("1dFVN");

var $gw63X = parcelRequire("gw63X");
var $c455f7167c1d5cf5$var$__defProp = Object.defineProperty;
var $c455f7167c1d5cf5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c455f7167c1d5cf5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c455f7167c1d5cf5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c455f7167c1d5cf5$var$__defNormalProp = (obj, key, value)=>key in obj ? $c455f7167c1d5cf5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c455f7167c1d5cf5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c455f7167c1d5cf5$var$__hasOwnProp.call(b, prop)) $c455f7167c1d5cf5$var$__defNormalProp(a, prop, b[prop]);
    if ($c455f7167c1d5cf5$var$__getOwnPropSymbols) {
        for (var prop of $c455f7167c1d5cf5$var$__getOwnPropSymbols(b))if ($c455f7167c1d5cf5$var$__propIsEnum.call(b, prop)) $c455f7167c1d5cf5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c455f7167c1d5cf5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c455f7167c1d5cf5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c455f7167c1d5cf5$var$__getOwnPropSymbols) {
        for (var prop of $c455f7167c1d5cf5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c455f7167c1d5cf5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c455f7167c1d5cf5$var$defaultProps = {
    size: "sm"
};
const $c455f7167c1d5cf5$export$a98f0dcb43a68a25 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("RadioGroup", $c455f7167c1d5cf5$var$defaultProps, props), { children: children, value: value, defaultValue: defaultValue, onChange: onChange, size: size, wrapperProps: wrapperProps, unstyled: unstyled, name: name } = _a, others = $c455f7167c1d5cf5$var$__objRest(_a, [
        "children",
        "value",
        "defaultValue",
        "onChange",
        "size",
        "wrapperProps",
        "unstyled",
        "name"
    ]);
    const _name = (0, $8nBd8.useId)(name);
    const [_value, setValue] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: "",
        onChange: onChange
    });
    const handleChange = (event)=>setValue(event.currentTarget.value);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1dFVN.RadioGroupProvider), {
        value: {
            value: _value,
            onChange: handleChange,
            size: size,
            name: _name
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $c455f7167c1d5cf5$var$__spreadValues($c455f7167c1d5cf5$var$__spreadValues({
        labelElement: "div",
        size: size,
        __staticSelector: "RadioGroup",
        ref: ref,
        unstyled: unstyled
    }, wrapperProps), others), children));
});
$c455f7167c1d5cf5$export$a98f0dcb43a68a25.displayName = "@mantine/core/RadioGroup";

});

parcelRegister("sW8BC", function(module, exports) {

$parcel$export(module.exports, "default", () => $056fb698880773ac$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $3mzq6 = parcelRequire("3mzq6");
var $2jkdX = parcelRequire("2jkdX");
var $056fb698880773ac$var$__defProp = Object.defineProperty;
var $056fb698880773ac$var$__defProps = Object.defineProperties;
var $056fb698880773ac$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $056fb698880773ac$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $056fb698880773ac$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $056fb698880773ac$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $056fb698880773ac$var$__defNormalProp = (obj, key, value)=>key in obj ? $056fb698880773ac$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $056fb698880773ac$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($056fb698880773ac$var$__hasOwnProp.call(b, prop)) $056fb698880773ac$var$__defNormalProp(a, prop, b[prop]);
    if ($056fb698880773ac$var$__getOwnPropSymbols) {
        for (var prop of $056fb698880773ac$var$__getOwnPropSymbols(b))if ($056fb698880773ac$var$__propIsEnum.call(b, prop)) $056fb698880773ac$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $056fb698880773ac$var$__spreadProps = (a, b)=>$056fb698880773ac$var$__defProps(a, $056fb698880773ac$var$__getOwnPropDescs(b));
const $056fb698880773ac$var$sizes = {
    xs: (0, $2jkdX.rem)(16),
    sm: (0, $2jkdX.rem)(20),
    md: (0, $2jkdX.rem)(24),
    lg: (0, $2jkdX.rem)(30),
    xl: (0, $2jkdX.rem)(36)
};
const $056fb698880773ac$var$iconSizes = {
    xs: (0, $2jkdX.rem)(6),
    sm: (0, $2jkdX.rem)(8),
    md: (0, $2jkdX.rem)(10),
    lg: (0, $2jkdX.rem)(14),
    xl: (0, $2jkdX.rem)(16)
};
var $056fb698880773ac$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, transitionDuration: transitionDuration, labelPosition: labelPosition, error: error }, { size: size })=>{
    const colors = theme.fn.variant({
        variant: "filled",
        color: color
    });
    const errorColor = theme.fn.variant({
        variant: "filled",
        color: "red"
    }).background;
    return {
        inner: {
            order: labelPosition === "left" ? 2 : 1,
            position: "relative",
            alignSelf: "flex-start"
        },
        icon: {
            ref: (0, $3mzq6.getStylesRef)("icon"),
            color: theme.white,
            opacity: 0,
            transform: `scale(0.75) translateY(${(0, $2jkdX.rem)(2)})`,
            transition: `opacity ${transitionDuration}ms ${theme.transitionTimingFunction}`,
            pointerEvents: "none",
            width: (0, $d8Ix8.getSize)({
                sizes: $056fb698880773ac$var$iconSizes,
                size: size
            }),
            height: (0, $d8Ix8.getSize)({
                sizes: $056fb698880773ac$var$iconSizes,
                size: size
            }),
            position: "absolute",
            top: `calc(50% - ${(0, $d8Ix8.getSize)({
                sizes: $056fb698880773ac$var$iconSizes,
                size: size
            })} / 2)`,
            left: `calc(50% - ${(0, $d8Ix8.getSize)({
                sizes: $056fb698880773ac$var$iconSizes,
                size: size
            })} / 2)`
        },
        radio: $056fb698880773ac$var$__spreadProps($056fb698880773ac$var$__spreadValues({}, theme.fn.focusStyles()), {
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            border: `${(0, $2jkdX.rem)(1)} solid ${error ? errorColor : theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
            position: "relative",
            appearance: "none",
            width: (0, $d8Ix8.getSize)({
                sizes: $056fb698880773ac$var$sizes,
                size: size
            }),
            height: (0, $d8Ix8.getSize)({
                sizes: $056fb698880773ac$var$sizes,
                size: size
            }),
            borderRadius: (0, $d8Ix8.getSize)({
                sizes: $056fb698880773ac$var$sizes,
                size: size
            }),
            margin: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transitionProperty: "background-color, border-color",
            transitionTimingFunction: theme.transitionTimingFunction,
            transitionDuration: `${transitionDuration}ms`,
            cursor: theme.cursorType,
            "&:checked": {
                background: colors.background,
                borderColor: colors.background,
                [`& + .${(0, $3mzq6.getStylesRef)("icon")}`]: {
                    opacity: 1,
                    transform: "scale(1)"
                }
            },
            "&:disabled": {
                borderColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[4],
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
                [`& + .${(0, $3mzq6.getStylesRef)("icon")}`]: {
                    color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[4]
                }
            }
        })
    };
});
var $056fb698880773ac$export$2e2bcd8739ae039 = $056fb698880773ac$var$useStyles;

});


parcelRegister("kC2FX", function(module, exports) {

$parcel$export(module.exports, "RingProgress", () => $f0196e985b0b53c0$export$faa54471d187506);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $1BU7Y = parcelRequire("1BU7Y");

var $7Tp7P = parcelRequire("7Tp7P");

var $7BseP = parcelRequire("7BseP");

var $hiiR1 = parcelRequire("hiiR1");
var $f0196e985b0b53c0$var$__defProp = Object.defineProperty;
var $f0196e985b0b53c0$var$__defProps = Object.defineProperties;
var $f0196e985b0b53c0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f0196e985b0b53c0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f0196e985b0b53c0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f0196e985b0b53c0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f0196e985b0b53c0$var$__defNormalProp = (obj, key, value)=>key in obj ? $f0196e985b0b53c0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f0196e985b0b53c0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f0196e985b0b53c0$var$__hasOwnProp.call(b, prop)) $f0196e985b0b53c0$var$__defNormalProp(a, prop, b[prop]);
    if ($f0196e985b0b53c0$var$__getOwnPropSymbols) {
        for (var prop of $f0196e985b0b53c0$var$__getOwnPropSymbols(b))if ($f0196e985b0b53c0$var$__propIsEnum.call(b, prop)) $f0196e985b0b53c0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f0196e985b0b53c0$var$__spreadProps = (a, b)=>$f0196e985b0b53c0$var$__defProps(a, $f0196e985b0b53c0$var$__getOwnPropDescs(b));
var $f0196e985b0b53c0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f0196e985b0b53c0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f0196e985b0b53c0$var$__getOwnPropSymbols) {
        for (var prop of $f0196e985b0b53c0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f0196e985b0b53c0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f0196e985b0b53c0$var$defaultProps = {
    size: 120,
    thickness: 12
};
const $f0196e985b0b53c0$export$faa54471d187506 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("RingProgress", $f0196e985b0b53c0$var$defaultProps, props), { className: className, style: style, label: label, sections: sections, size: size, thickness: thickness, classNames: classNames, styles: styles, roundCaps: roundCaps, rootColor: rootColor, unstyled: unstyled, variant: variant } = _a, others = $f0196e985b0b53c0$var$__objRest(_a, [
        "className",
        "style",
        "label",
        "sections",
        "size",
        "thickness",
        "classNames",
        "styles",
        "roundCaps",
        "rootColor",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $7BseP.default)(null, {
        name: "RingProgress",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    const curves = (0, $7Tp7P.getCurves)({
        size: size,
        thickness: thickness,
        sections: sections,
        renderRoundedLineCaps: roundCaps,
        rootColor: rootColor
    }).map(({ data: data, sum: sum, root: root, lineRoundCaps: lineRoundCaps, offset: offset }, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1BU7Y.Curve), $f0196e985b0b53c0$var$__spreadProps($f0196e985b0b53c0$var$__spreadValues({}, data), {
            key: index,
            size: size,
            thickness: thickness,
            sum: sum,
            offset: offset,
            color: data == null ? void 0 : data.color,
            root: root,
            lineRoundCaps: lineRoundCaps
        })));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $f0196e985b0b53c0$var$__spreadValues({
        style: $f0196e985b0b53c0$var$__spreadValues({
            width: size,
            height: size
        }, style),
        className: cx(classes.root, className),
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        style: {
            width: size,
            height: size,
            transform: "rotate(-90deg)"
        }
    }, curves), label && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.label,
        style: {
            right: thickness * 2,
            left: thickness * 2
        }
    }, label));
});
$f0196e985b0b53c0$export$faa54471d187506.displayName = "@mantine/core/RingProgress";

});
parcelRegister("1BU7Y", function(module, exports) {

$parcel$export(module.exports, "Curve", () => $12c4c8ef25847799$export$b0e83c3ef8d2db1);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $gaZSN = parcelRequire("gaZSN");

var $60Ffz = parcelRequire("60Ffz");
var $12c4c8ef25847799$var$__defProp = Object.defineProperty;
var $12c4c8ef25847799$var$__defProps = Object.defineProperties;
var $12c4c8ef25847799$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $12c4c8ef25847799$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $12c4c8ef25847799$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $12c4c8ef25847799$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $12c4c8ef25847799$var$__defNormalProp = (obj, key, value)=>key in obj ? $12c4c8ef25847799$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $12c4c8ef25847799$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($12c4c8ef25847799$var$__hasOwnProp.call(b, prop)) $12c4c8ef25847799$var$__defNormalProp(a, prop, b[prop]);
    if ($12c4c8ef25847799$var$__getOwnPropSymbols) {
        for (var prop of $12c4c8ef25847799$var$__getOwnPropSymbols(b))if ($12c4c8ef25847799$var$__propIsEnum.call(b, prop)) $12c4c8ef25847799$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $12c4c8ef25847799$var$__spreadProps = (a, b)=>$12c4c8ef25847799$var$__defProps(a, $12c4c8ef25847799$var$__getOwnPropDescs(b));
var $12c4c8ef25847799$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($12c4c8ef25847799$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $12c4c8ef25847799$var$__getOwnPropSymbols) {
        for (var prop of $12c4c8ef25847799$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $12c4c8ef25847799$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $12c4c8ef25847799$export$b0e83c3ef8d2db1(_a) {
    var _b = _a, { size: size, value: value, offset: offset, sum: sum, thickness: thickness, root: root, color: color, lineRoundCaps: lineRoundCaps, tooltip: tooltip } = _b, others = $12c4c8ef25847799$var$__objRest(_b, [
        "size",
        "value",
        "offset",
        "sum",
        "thickness",
        "root",
        "color",
        "lineRoundCaps",
        "tooltip"
    ]);
    const theme = (0, $64A2P.useMantineTheme)();
    const stroke = theme.fn.themeColor(color || (theme.colorScheme === "dark" ? "dark" : "gray"), color ? theme.fn.primaryShade() : theme.colorScheme === "dark" ? 4 : 1, false);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $60Ffz.Tooltip).Floating, {
        disabled: !tooltip,
        label: tooltip
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("circle", $12c4c8ef25847799$var$__spreadValues($12c4c8ef25847799$var$__spreadProps($12c4c8ef25847799$var$__spreadValues({}, others), {
        fill: "none",
        strokeLinecap: lineRoundCaps ? "round" : "butt",
        stroke: stroke
    }), (0, $gaZSN.getCurveProps)({
        sum: sum,
        size: size,
        thickness: thickness,
        value: value,
        offset: offset,
        root: root
    }))));
}
$12c4c8ef25847799$export$b0e83c3ef8d2db1.displayName = "@mantine/core/Curve";

});
parcelRegister("gaZSN", function(module, exports) {

$parcel$export(module.exports, "getCurveProps", () => $bc6d952804f203d5$export$2086489df0d99a6d);
function $bc6d952804f203d5$export$2086489df0d99a6d({ size: size, thickness: thickness, sum: sum, value: value, root: root, offset: offset }) {
    const radius = (size * 0.9 - thickness * 2) / 2;
    const deg = Math.PI * radius * 2 / 100;
    const strokeDasharray = root ? `${(100 - sum) * deg}, ${sum * deg}` : `${value * deg}, ${(100 - value) * deg}`;
    return {
        strokeWidth: thickness,
        cx: size / 2,
        cy: size / 2,
        r: radius,
        transform: root ? `scale(1, -1) translate(0, -${size})` : null,
        strokeDasharray: strokeDasharray,
        strokeDashoffset: root ? 0 : offset
    };
}

});


parcelRegister("7Tp7P", function(module, exports) {

$parcel$export(module.exports, "getCurves", () => $5bf128d37aca3ffe$export$37a03829ccd4cdb4);
var $5bf128d37aca3ffe$var$__defProp = Object.defineProperty;
var $5bf128d37aca3ffe$var$__defProps = Object.defineProperties;
var $5bf128d37aca3ffe$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5bf128d37aca3ffe$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5bf128d37aca3ffe$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5bf128d37aca3ffe$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5bf128d37aca3ffe$var$__defNormalProp = (obj, key, value)=>key in obj ? $5bf128d37aca3ffe$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5bf128d37aca3ffe$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5bf128d37aca3ffe$var$__hasOwnProp.call(b, prop)) $5bf128d37aca3ffe$var$__defNormalProp(a, prop, b[prop]);
    if ($5bf128d37aca3ffe$var$__getOwnPropSymbols) {
        for (var prop of $5bf128d37aca3ffe$var$__getOwnPropSymbols(b))if ($5bf128d37aca3ffe$var$__propIsEnum.call(b, prop)) $5bf128d37aca3ffe$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5bf128d37aca3ffe$var$__spreadProps = (a, b)=>$5bf128d37aca3ffe$var$__defProps(a, $5bf128d37aca3ffe$var$__getOwnPropDescs(b));
function $5bf128d37aca3ffe$export$37a03829ccd4cdb4({ size: size, thickness: thickness, sections: sections, renderRoundedLineCaps: renderRoundedLineCaps, rootColor: rootColor }) {
    const sum = sections.reduce((acc, current)=>acc + current.value, 0);
    const accumulated = Math.PI * ((size * 0.9 - thickness * 2) / 2) * 2;
    let offset = accumulated;
    const curves = [];
    const curvesInOrder = [];
    for(let i = 0; i < sections.length; i += 1){
        curves.push({
            sum: sum,
            offset: offset,
            data: sections[i],
            root: false
        });
        offset -= sections[i].value / 100 * accumulated;
    }
    curves.push({
        sum: sum,
        offset: offset,
        data: {
            color: rootColor
        },
        root: true
    });
    curvesInOrder.push($5bf128d37aca3ffe$var$__spreadProps($5bf128d37aca3ffe$var$__spreadValues({}, curves[curves.length - 1]), {
        lineRoundCaps: false
    }));
    if (curves.length > 2) {
        curvesInOrder.push($5bf128d37aca3ffe$var$__spreadProps($5bf128d37aca3ffe$var$__spreadValues({}, curves[0]), {
            lineRoundCaps: renderRoundedLineCaps
        }));
        curvesInOrder.push($5bf128d37aca3ffe$var$__spreadProps($5bf128d37aca3ffe$var$__spreadValues({}, curves[curves.length - 2]), {
            lineRoundCaps: renderRoundedLineCaps
        }));
        for(let i = 1; i <= curves.length - 3; i += 1)curvesInOrder.push($5bf128d37aca3ffe$var$__spreadProps($5bf128d37aca3ffe$var$__spreadValues({}, curves[i]), {
            lineRoundCaps: false
        }));
    } else curvesInOrder.push($5bf128d37aca3ffe$var$__spreadProps($5bf128d37aca3ffe$var$__spreadValues({}, curves[0]), {
        lineRoundCaps: renderRoundedLineCaps
    }));
    return curvesInOrder;
}

});

parcelRegister("7BseP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5891e49e53c54c5a$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $5891e49e53c54c5a$var$useStyles = (0, $cQG1Y.createStyles)({
    root: {
        position: "relative"
    },
    label: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)"
    }
});
var $5891e49e53c54c5a$export$2e2bcd8739ae039 = $5891e49e53c54c5a$var$useStyles;

});


parcelRegister("3wLgJ", function(module, exports) {

$parcel$export(module.exports, "Select", () => $291906df7b04cdf6$export$ef9b1a59e592288f);

var $acw62 = parcelRequire("acw62");

var $2qf6h = parcelRequire("2qf6h");
var $4GmKa = parcelRequire("4GmKa");
var $7DS5l = parcelRequire("7DS5l");
var $ke4gU = parcelRequire("ke4gU");

var $iu1L3 = parcelRequire("iu1L3");

var $6Lcfd = parcelRequire("6Lcfd");

var $1egdU = parcelRequire("1egdU");

var $5dIV6 = parcelRequire("5dIV6");

var $j3D7l = parcelRequire("j3D7l");

var $g41PE = parcelRequire("g41PE");

var $cojj3 = parcelRequire("cojj3");

var $krBPS = parcelRequire("krBPS");

var $2TfFz = parcelRequire("2TfFz");

var $hEdEV = parcelRequire("hEdEV");

var $gw63X = parcelRequire("gw63X");
var $291906df7b04cdf6$var$__defProp = Object.defineProperty;
var $291906df7b04cdf6$var$__defProps = Object.defineProperties;
var $291906df7b04cdf6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $291906df7b04cdf6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $291906df7b04cdf6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $291906df7b04cdf6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $291906df7b04cdf6$var$__defNormalProp = (obj, key, value)=>key in obj ? $291906df7b04cdf6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $291906df7b04cdf6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($291906df7b04cdf6$var$__hasOwnProp.call(b, prop)) $291906df7b04cdf6$var$__defNormalProp(a, prop, b[prop]);
    if ($291906df7b04cdf6$var$__getOwnPropSymbols) {
        for (var prop of $291906df7b04cdf6$var$__getOwnPropSymbols(b))if ($291906df7b04cdf6$var$__propIsEnum.call(b, prop)) $291906df7b04cdf6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $291906df7b04cdf6$var$__spreadProps = (a, b)=>$291906df7b04cdf6$var$__defProps(a, $291906df7b04cdf6$var$__getOwnPropDescs(b));
var $291906df7b04cdf6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($291906df7b04cdf6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $291906df7b04cdf6$var$__getOwnPropSymbols) {
        for (var prop of $291906df7b04cdf6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $291906df7b04cdf6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $291906df7b04cdf6$export$3f6f640afaf1ec43(value, item) {
    return item.label.toLowerCase().trim().includes(value.toLowerCase().trim());
}
function $291906df7b04cdf6$export$3b1016ee7f09c57(query, data) {
    return !!query && !data.some((item)=>item.label.toLowerCase() === query.toLowerCase());
}
const $291906df7b04cdf6$var$defaultProps = {
    required: false,
    size: "sm",
    shadow: "sm",
    itemComponent: (0, $5dIV6.DefaultItem),
    transitionProps: {
        transition: "fade",
        duration: 0
    },
    initiallyOpened: false,
    filter: $291906df7b04cdf6$export$3f6f640afaf1ec43,
    maxDropdownHeight: 220,
    searchable: false,
    clearable: false,
    limit: Infinity,
    disabled: false,
    creatable: false,
    shouldCreate: $291906df7b04cdf6$export$3b1016ee7f09c57,
    selectOnBlur: false,
    switchDirectionOnFlip: false,
    filterDataOnExactSearchMatch: false,
    zIndex: (0, $iu1L3.getDefaultZIndex)("popover"),
    positionDependencies: [],
    dropdownPosition: "flip"
};
const $291906df7b04cdf6$export$ef9b1a59e592288f = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $hEdEV.useInputProps)("Select", $291906df7b04cdf6$var$defaultProps, props), { inputProps: inputProps, wrapperProps: wrapperProps, shadow: shadow, data: data, value: value, defaultValue: defaultValue, onChange: onChange, itemComponent: itemComponent, onKeyDown: onKeyDown, onBlur: onBlur, onFocus: onFocus, transitionProps: transitionProps, initiallyOpened: initiallyOpened, unstyled: unstyled, classNames: classNames, styles: styles, filter: filter, maxDropdownHeight: maxDropdownHeight, searchable: searchable, clearable: clearable, nothingFound: nothingFound, limit: limit, disabled: disabled, onSearchChange: onSearchChange, searchValue: searchValue, rightSection: rightSection, rightSectionWidth: rightSectionWidth, creatable: creatable, getCreateLabel: getCreateLabel, shouldCreate: shouldCreate, selectOnBlur: selectOnBlur, onCreate: onCreate, dropdownComponent: dropdownComponent, onDropdownClose: onDropdownClose, onDropdownOpen: onDropdownOpen, withinPortal: withinPortal, portalProps: portalProps, switchDirectionOnFlip: switchDirectionOnFlip, zIndex: zIndex, name: name, dropdownPosition: dropdownPosition, allowDeselect: allowDeselect, placeholder: placeholder, filterDataOnExactSearchMatch: filterDataOnExactSearchMatch, form: form, positionDependencies: positionDependencies, readOnly: readOnly, clearButtonProps: clearButtonProps, hoverOnSearchChange: hoverOnSearchChange } = _a, others = $291906df7b04cdf6$var$__objRest(_a, [
        "inputProps",
        "wrapperProps",
        "shadow",
        "data",
        "value",
        "defaultValue",
        "onChange",
        "itemComponent",
        "onKeyDown",
        "onBlur",
        "onFocus",
        "transitionProps",
        "initiallyOpened",
        "unstyled",
        "classNames",
        "styles",
        "filter",
        "maxDropdownHeight",
        "searchable",
        "clearable",
        "nothingFound",
        "limit",
        "disabled",
        "onSearchChange",
        "searchValue",
        "rightSection",
        "rightSectionWidth",
        "creatable",
        "getCreateLabel",
        "shouldCreate",
        "selectOnBlur",
        "onCreate",
        "dropdownComponent",
        "onDropdownClose",
        "onDropdownOpen",
        "withinPortal",
        "portalProps",
        "switchDirectionOnFlip",
        "zIndex",
        "name",
        "dropdownPosition",
        "allowDeselect",
        "placeholder",
        "filterDataOnExactSearchMatch",
        "form",
        "positionDependencies",
        "readOnly",
        "clearButtonProps",
        "hoverOnSearchChange"
    ]);
    const { classes: classes, cx: cx, theme: theme } = (0, $2TfFz.default)();
    const [dropdownOpened, _setDropdownOpened] = (0, $acw62.useState)(initiallyOpened);
    const [hovered, setHovered] = (0, $acw62.useState)(-1);
    const inputRef = (0, $acw62.useRef)();
    const itemsRefs = (0, $acw62.useRef)({});
    const [direction, setDirection] = (0, $acw62.useState)("column");
    const isColumn = direction === "column";
    const { scrollIntoView: scrollIntoView, targetRef: targetRef, scrollableRef: scrollableRef } = (0, $7DS5l.useScrollIntoView)({
        duration: 0,
        offset: 5,
        cancelable: false,
        isList: true
    });
    const isDeselectable = allowDeselect === void 0 ? clearable : allowDeselect;
    const setDropdownOpened = (opened)=>{
        if (dropdownOpened !== opened) {
            _setDropdownOpened(opened);
            const handler = opened ? onDropdownOpen : onDropdownClose;
            typeof handler === "function" && handler();
        }
    };
    const isCreatable = creatable && typeof getCreateLabel === "function";
    let createLabel = null;
    const formattedData = data.map((item)=>typeof item === "string" ? {
            label: item,
            value: item
        } : item);
    const sortedData = (0, $6Lcfd.groupOptions)({
        data: formattedData
    });
    const [_value, handleChange, controlled] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onChange
    });
    const selectedValue = sortedData.find((item)=>item.value === _value);
    const [inputValue, setInputValue] = (0, $ke4gU.useUncontrolled)({
        value: searchValue,
        defaultValue: (selectedValue == null ? void 0 : selectedValue.label) || "",
        finalValue: void 0,
        onChange: onSearchChange
    });
    const handleSearchChange = (val)=>{
        setInputValue(val);
        if (searchable && typeof onSearchChange === "function") onSearchChange(val);
    };
    const handleClear = ()=>{
        var _a2;
        if (!readOnly) {
            handleChange(null);
            if (!controlled) handleSearchChange("");
            (_a2 = inputRef.current) == null || _a2.focus();
        }
    };
    (0, $acw62.useEffect)(()=>{
        const newSelectedValue = sortedData.find((item)=>item.value === _value);
        if (newSelectedValue) handleSearchChange(newSelectedValue.label);
        else if (!isCreatable || !_value) handleSearchChange("");
    }, [
        _value
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedValue && (!searchable || !dropdownOpened)) handleSearchChange(selectedValue.label);
    }, [
        selectedValue == null ? void 0 : selectedValue.label
    ]);
    const handleItemSelect = (item)=>{
        if (!readOnly) {
            if (isDeselectable && (selectedValue == null ? void 0 : selectedValue.value) === item.value) {
                handleChange(null);
                setDropdownOpened(false);
            } else {
                if (item.creatable && typeof onCreate === "function") {
                    const createdItem = onCreate(item.value);
                    if (typeof createdItem !== "undefined" && createdItem !== null) {
                        if (typeof createdItem === "string") handleChange(createdItem);
                        else handleChange(createdItem.value);
                    }
                } else handleChange(item.value);
                if (!controlled) handleSearchChange(item.label);
                setHovered(-1);
                setDropdownOpened(false);
                inputRef.current.focus();
            }
        }
    };
    const filteredData = (0, $krBPS.filterData)({
        data: sortedData,
        searchable: searchable,
        limit: limit,
        searchValue: inputValue,
        filter: filter,
        filterDataOnExactSearchMatch: filterDataOnExactSearchMatch,
        value: _value
    });
    if (isCreatable && shouldCreate(inputValue, filteredData)) {
        createLabel = getCreateLabel(inputValue);
        filteredData.push({
            label: inputValue,
            value: inputValue,
            creatable: true
        });
    }
    const getNextIndex = (index, nextItem, compareFn)=>{
        let i = index;
        while(compareFn(i)){
            i = nextItem(i);
            if (!filteredData[i].disabled) return i;
        }
        return index;
    };
    (0, $2qf6h.useDidUpdate)(()=>{
        if (hoverOnSearchChange && inputValue) setHovered(0);
        else setHovered(-1);
    }, [
        inputValue,
        hoverOnSearchChange
    ]);
    const selectedItemIndex = _value ? filteredData.findIndex((el)=>el.value === _value) : 0;
    const shouldShowDropdown = !readOnly && (filteredData.length > 0 ? dropdownOpened : dropdownOpened && !!nothingFound);
    const handlePrevious = ()=>{
        setHovered((current)=>{
            var _a2;
            const nextIndex = getNextIndex(current, (index)=>index - 1, (index)=>index > 0);
            targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
            shouldShowDropdown && scrollIntoView({
                alignment: isColumn ? "start" : "end"
            });
            return nextIndex;
        });
    };
    const handleNext = ()=>{
        setHovered((current)=>{
            var _a2;
            const nextIndex = getNextIndex(current, (index)=>index + 1, (index)=>index < filteredData.length - 1);
            targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
            shouldShowDropdown && scrollIntoView({
                alignment: isColumn ? "end" : "start"
            });
            return nextIndex;
        });
    };
    const scrollSelectedItemIntoView = ()=>window.setTimeout(()=>{
            var _a2;
            targetRef.current = itemsRefs.current[(_a2 = filteredData[selectedItemIndex]) == null ? void 0 : _a2.value];
            scrollIntoView({
                alignment: isColumn ? "end" : "start"
            });
        }, 50);
    (0, $2qf6h.useDidUpdate)(()=>{
        if (shouldShowDropdown) scrollSelectedItemIntoView();
    }, [
        shouldShowDropdown
    ]);
    const handleInputKeydown = (event)=>{
        typeof onKeyDown === "function" && onKeyDown(event);
        switch(event.key){
            case "ArrowUp":
                event.preventDefault();
                if (!dropdownOpened) {
                    setHovered(selectedItemIndex);
                    setDropdownOpened(true);
                    scrollSelectedItemIntoView();
                } else isColumn ? handlePrevious() : handleNext();
                break;
            case "ArrowDown":
                event.preventDefault();
                if (!dropdownOpened) {
                    setHovered(selectedItemIndex);
                    setDropdownOpened(true);
                    scrollSelectedItemIntoView();
                } else isColumn ? handleNext() : handlePrevious();
                break;
            case "Home":
                if (!searchable) {
                    event.preventDefault();
                    if (!dropdownOpened) setDropdownOpened(true);
                    const firstItemIndex = filteredData.findIndex((item)=>!item.disabled);
                    setHovered(firstItemIndex);
                    shouldShowDropdown && scrollIntoView({
                        alignment: isColumn ? "end" : "start"
                    });
                }
                break;
            case "End":
                if (!searchable) {
                    event.preventDefault();
                    if (!dropdownOpened) setDropdownOpened(true);
                    const lastItemIndex = filteredData.map((item)=>!!item.disabled).lastIndexOf(false);
                    setHovered(lastItemIndex);
                    shouldShowDropdown && scrollIntoView({
                        alignment: isColumn ? "end" : "start"
                    });
                }
                break;
            case "Escape":
                event.preventDefault();
                setDropdownOpened(false);
                setHovered(-1);
                break;
            case " ":
                if (!searchable) {
                    event.preventDefault();
                    if (filteredData[hovered] && dropdownOpened) handleItemSelect(filteredData[hovered]);
                    else {
                        setDropdownOpened(true);
                        setHovered(selectedItemIndex);
                        scrollSelectedItemIntoView();
                    }
                }
                break;
            case "Enter":
                if (!searchable) event.preventDefault();
                if (filteredData[hovered] && dropdownOpened) {
                    event.preventDefault();
                    handleItemSelect(filteredData[hovered]);
                }
        }
    };
    const handleInputBlur = (event)=>{
        typeof onBlur === "function" && onBlur(event);
        const selected = sortedData.find((item)=>item.value === _value);
        if (selectOnBlur && filteredData[hovered] && dropdownOpened) handleItemSelect(filteredData[hovered]);
        handleSearchChange((selected == null ? void 0 : selected.label) || "");
        setDropdownOpened(false);
    };
    const handleInputFocus = (event)=>{
        typeof onFocus === "function" && onFocus(event);
        if (searchable) setDropdownOpened(true);
    };
    const handleInputChange = (event)=>{
        if (!readOnly) {
            handleSearchChange(event.currentTarget.value);
            if (clearable && event.currentTarget.value === "") handleChange(null);
            setHovered(-1);
            setDropdownOpened(true);
        }
    };
    const handleInputClick = ()=>{
        if (!readOnly) {
            setDropdownOpened(!dropdownOpened);
            if (_value && !dropdownOpened) setHovered(selectedItemIndex);
        }
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $291906df7b04cdf6$var$__spreadProps($291906df7b04cdf6$var$__spreadValues({}, wrapperProps), {
        __staticSelector: "Select"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover), {
        opened: shouldShowDropdown,
        transitionProps: transitionProps,
        shadow: shadow,
        withinPortal: withinPortal,
        portalProps: portalProps,
        __staticSelector: "Select",
        onDirectionChange: setDirection,
        switchDirectionOnFlip: switchDirectionOnFlip,
        zIndex: zIndex,
        dropdownPosition: dropdownPosition,
        positionDependencies: [
            ...positionDependencies,
            inputValue
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: inputProps.variant
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover).Target, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-owns": shouldShowDropdown ? `${inputProps.id}-items` : null,
        "aria-controls": inputProps.id,
        "aria-expanded": shouldShowDropdown,
        onMouseLeave: ()=>setHovered(-1),
        tabIndex: -1
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "hidden",
        name: name,
        value: _value || "",
        form: form,
        disabled: disabled
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), $291906df7b04cdf6$var$__spreadValues($291906df7b04cdf6$var$__spreadProps($291906df7b04cdf6$var$__spreadValues($291906df7b04cdf6$var$__spreadValues({
        autoComplete: "off",
        type: "search"
    }, inputProps), others), {
        ref: (0, $4GmKa.useMergedRef)(ref, inputRef),
        onKeyDown: handleInputKeydown,
        __staticSelector: "Select",
        value: inputValue,
        placeholder: placeholder,
        onChange: handleInputChange,
        "aria-autocomplete": "list",
        "aria-controls": shouldShowDropdown ? `${inputProps.id}-items` : null,
        "aria-activedescendant": hovered >= 0 ? `${inputProps.id}-${hovered}` : null,
        onMouseDown: handleInputClick,
        onBlur: handleInputBlur,
        onFocus: handleInputFocus,
        readOnly: !searchable || readOnly,
        disabled: disabled,
        "data-mantine-stop-propagation": shouldShowDropdown,
        name: null,
        classNames: $291906df7b04cdf6$var$__spreadProps($291906df7b04cdf6$var$__spreadValues({}, classNames), {
            input: cx({
                [classes.input]: !searchable
            }, classNames == null ? void 0 : classNames.input)
        })
    }), (0, $j3D7l.getSelectRightSectionProps)({
        theme: theme,
        rightSection: rightSection,
        rightSectionWidth: rightSectionWidth,
        styles: styles,
        size: inputProps.size,
        shouldClear: clearable && !!selectedValue,
        onClear: handleClear,
        error: wrapperProps.error,
        clearButtonProps: clearButtonProps,
        disabled: disabled,
        readOnly: readOnly
    }))))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cojj3.SelectPopover).Dropdown, {
        component: dropdownComponent || (0, $1egdU.SelectScrollArea),
        maxHeight: maxDropdownHeight,
        direction: direction,
        id: inputProps.id,
        innerRef: scrollableRef,
        __staticSelector: "Select",
        classNames: classNames,
        styles: styles
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g41PE.SelectItems), {
        data: filteredData,
        hovered: hovered,
        classNames: classNames,
        styles: styles,
        isItemSelected: (val)=>val === _value,
        uuid: inputProps.id,
        __staticSelector: "Select",
        onItemHover: setHovered,
        onItemSelect: handleItemSelect,
        itemsRefs: itemsRefs,
        itemComponent: itemComponent,
        size: inputProps.size,
        nothingFound: nothingFound,
        creatable: isCreatable && !!createLabel,
        createLabel: createLabel,
        "aria-label": wrapperProps.label,
        unstyled: unstyled,
        variant: inputProps.variant
    }))));
});
$291906df7b04cdf6$export$ef9b1a59e592288f.displayName = "@mantine/core/Select";

});
parcelRegister("krBPS", function(module, exports) {

$parcel$export(module.exports, "filterData", () => $ee23ada8f17dccf3$export$d6ad891437e8c72c);
function $ee23ada8f17dccf3$export$d6ad891437e8c72c({ data: data, searchable: searchable, limit: limit, searchValue: searchValue, filter: filter, value: value, filterDataOnExactSearchMatch: filterDataOnExactSearchMatch }) {
    if (!searchable) return data;
    const selected = value != null ? data.find((item)=>item.value === value) || null : null;
    if (selected && !filterDataOnExactSearchMatch && (selected == null ? void 0 : selected.label) === searchValue) {
        if (limit) {
            if (limit >= data.length) return data;
            const firstIndex = data.indexOf(selected);
            const lastIndex = firstIndex + limit;
            const firstIndexOffset = lastIndex - data.length;
            if (firstIndexOffset > 0) return data.slice(firstIndex - firstIndexOffset);
            return data.slice(firstIndex, lastIndex);
        }
        return data;
    }
    const result = [];
    for(let i = 0; i < data.length; i += 1){
        if (filter(searchValue, data[i])) result.push(data[i]);
        if (result.length >= limit) break;
    }
    return result;
}

});

parcelRegister("2TfFz", function(module, exports) {

$parcel$export(module.exports, "default", () => $21acdf7462c2023d$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $21acdf7462c2023d$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        input: {
            "&:not(:disabled)": {
                cursor: "pointer",
                "&::selection": {
                    backgroundColor: "transparent"
                }
            }
        }
    }));
var $21acdf7462c2023d$export$2e2bcd8739ae039 = $21acdf7462c2023d$var$useStyles;

});


parcelRegister("AaRVC", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $06cbcb3a2a3705e5$export$8f31e4c4a37b8e9c);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $kFd4S = parcelRequire("kFd4S");

var $hiiR1 = parcelRequire("hiiR1");
var $06cbcb3a2a3705e5$var$__defProp = Object.defineProperty;
var $06cbcb3a2a3705e5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $06cbcb3a2a3705e5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $06cbcb3a2a3705e5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $06cbcb3a2a3705e5$var$__defNormalProp = (obj, key, value)=>key in obj ? $06cbcb3a2a3705e5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $06cbcb3a2a3705e5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($06cbcb3a2a3705e5$var$__hasOwnProp.call(b, prop)) $06cbcb3a2a3705e5$var$__defNormalProp(a, prop, b[prop]);
    if ($06cbcb3a2a3705e5$var$__getOwnPropSymbols) {
        for (var prop of $06cbcb3a2a3705e5$var$__getOwnPropSymbols(b))if ($06cbcb3a2a3705e5$var$__propIsEnum.call(b, prop)) $06cbcb3a2a3705e5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $06cbcb3a2a3705e5$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($06cbcb3a2a3705e5$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $06cbcb3a2a3705e5$var$__getOwnPropSymbols) {
        for (var prop of $06cbcb3a2a3705e5$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $06cbcb3a2a3705e5$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $06cbcb3a2a3705e5$var$defaultProps = {
    height: "auto",
    width: "100%",
    visible: true,
    animate: true
};
const $06cbcb3a2a3705e5$export$8f31e4c4a37b8e9c = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Skeleton", $06cbcb3a2a3705e5$var$defaultProps, props), { height: height, width: width, visible: visible, animate: animate, className: className, circle: circle, radius: radius, unstyled: unstyled, variant: variant } = _a, others = $06cbcb3a2a3705e5$var$__objRest(_a, [
        "height",
        "width",
        "visible",
        "animate",
        "className",
        "circle",
        "radius",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $kFd4S.default)({
        height: height,
        width: width,
        circle: circle,
        radius: radius,
        animate: animate
    }, {
        name: "Skeleton",
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $06cbcb3a2a3705e5$var$__spreadValues({
        className: cx(classes.root, {
            [classes.visible]: visible
        }, className),
        ref: ref
    }, others));
});
$06cbcb3a2a3705e5$export$8f31e4c4a37b8e9c.displayName = "@mantine/core/Skeleton";

});
parcelRegister("kFd4S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0b1c7e9f15b16bb$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $jjlaj = parcelRequire("jjlaj");
var $2jkdX = parcelRequire("2jkdX");
var $f0b1c7e9f15b16bb$var$__defProp = Object.defineProperty;
var $f0b1c7e9f15b16bb$var$__defProps = Object.defineProperties;
var $f0b1c7e9f15b16bb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $f0b1c7e9f15b16bb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f0b1c7e9f15b16bb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f0b1c7e9f15b16bb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f0b1c7e9f15b16bb$var$__defNormalProp = (obj, key, value)=>key in obj ? $f0b1c7e9f15b16bb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f0b1c7e9f15b16bb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f0b1c7e9f15b16bb$var$__hasOwnProp.call(b, prop)) $f0b1c7e9f15b16bb$var$__defNormalProp(a, prop, b[prop]);
    if ($f0b1c7e9f15b16bb$var$__getOwnPropSymbols) {
        for (var prop of $f0b1c7e9f15b16bb$var$__getOwnPropSymbols(b))if ($f0b1c7e9f15b16bb$var$__propIsEnum.call(b, prop)) $f0b1c7e9f15b16bb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f0b1c7e9f15b16bb$var$__spreadProps = (a, b)=>$f0b1c7e9f15b16bb$var$__defProps(a, $f0b1c7e9f15b16bb$var$__getOwnPropDescs(b));
const $f0b1c7e9f15b16bb$export$cbea29d068a2e18f = (0, $jjlaj.keyframes)({
    "from, to": {
        opacity: 0.4
    },
    "50%": {
        opacity: 1
    }
});
var $f0b1c7e9f15b16bb$var$useStyles = (0, $cQG1Y.createStyles)((theme, { height: height, width: width, radius: radius, circle: circle, animate: animate })=>({
        root: {
            height: (0, $2jkdX.rem)(height),
            width: circle ? (0, $2jkdX.rem)(height) : (0, $2jkdX.rem)(width),
            borderRadius: circle ? (0, $2jkdX.rem)(height) : theme.fn.radius(radius),
            position: "relative",
            WebkitTransform: "translateZ(0)"
        },
        visible: {
            overflow: "hidden",
            "&::before": $f0b1c7e9f15b16bb$var$__spreadProps($f0b1c7e9f15b16bb$var$__spreadValues({}, theme.fn.cover(0)), {
                content: '""',
                background: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
                zIndex: 10
            }),
            "&::after": $f0b1c7e9f15b16bb$var$__spreadProps($f0b1c7e9f15b16bb$var$__spreadValues({}, theme.fn.cover(0)), {
                content: '""',
                background: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
                animation: animate ? `${$f0b1c7e9f15b16bb$export$cbea29d068a2e18f} 1500ms linear infinite` : "none",
                zIndex: 11
            })
        }
    }));
var $f0b1c7e9f15b16bb$export$2e2bcd8739ae039 = $f0b1c7e9f15b16bb$var$useStyles;

});


parcelRegister("5iXv4", function(module, exports) {

$parcel$export(module.exports, "Space", () => $3dccc9a92157e485$export$eef1e68107c58ef2);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $hiiR1 = parcelRequire("hiiR1");
var $3dccc9a92157e485$var$__defProp = Object.defineProperty;
var $3dccc9a92157e485$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $3dccc9a92157e485$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3dccc9a92157e485$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $3dccc9a92157e485$var$__defNormalProp = (obj, key, value)=>key in obj ? $3dccc9a92157e485$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3dccc9a92157e485$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($3dccc9a92157e485$var$__hasOwnProp.call(b, prop)) $3dccc9a92157e485$var$__defNormalProp(a, prop, b[prop]);
    if ($3dccc9a92157e485$var$__getOwnPropSymbols) {
        for (var prop of $3dccc9a92157e485$var$__getOwnPropSymbols(b))if ($3dccc9a92157e485$var$__propIsEnum.call(b, prop)) $3dccc9a92157e485$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $3dccc9a92157e485$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($3dccc9a92157e485$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $3dccc9a92157e485$var$__getOwnPropSymbols) {
        for (var prop of $3dccc9a92157e485$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $3dccc9a92157e485$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $3dccc9a92157e485$var$defaultProps = {
    w: 0,
    h: 0
};
const $3dccc9a92157e485$export$eef1e68107c58ef2 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Space", $3dccc9a92157e485$var$defaultProps, props), { w: w, h: h } = _a, others = $3dccc9a92157e485$var$__objRest(_a, [
        "w",
        "h"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $3dccc9a92157e485$var$__spreadValues({
        ref: ref,
        w: w,
        miw: w,
        h: h,
        mih: h
    }, others));
});
$3dccc9a92157e485$export$eef1e68107c58ef2.displayName = "@mantine/core/Space";

});

parcelRegister("9VIWE", function(module, exports) {

$parcel$export(module.exports, "Stack", () => $73ac4d0cd9c4d592$export$694e0d28c7ffc90c);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $9qOg3 = parcelRequire("9qOg3");

var $hiiR1 = parcelRequire("hiiR1");
var $73ac4d0cd9c4d592$var$__defProp = Object.defineProperty;
var $73ac4d0cd9c4d592$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $73ac4d0cd9c4d592$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $73ac4d0cd9c4d592$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $73ac4d0cd9c4d592$var$__defNormalProp = (obj, key, value)=>key in obj ? $73ac4d0cd9c4d592$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $73ac4d0cd9c4d592$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($73ac4d0cd9c4d592$var$__hasOwnProp.call(b, prop)) $73ac4d0cd9c4d592$var$__defNormalProp(a, prop, b[prop]);
    if ($73ac4d0cd9c4d592$var$__getOwnPropSymbols) {
        for (var prop of $73ac4d0cd9c4d592$var$__getOwnPropSymbols(b))if ($73ac4d0cd9c4d592$var$__propIsEnum.call(b, prop)) $73ac4d0cd9c4d592$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $73ac4d0cd9c4d592$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($73ac4d0cd9c4d592$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $73ac4d0cd9c4d592$var$__getOwnPropSymbols) {
        for (var prop of $73ac4d0cd9c4d592$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $73ac4d0cd9c4d592$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $73ac4d0cd9c4d592$var$defaultProps = {
    spacing: "md",
    align: "stretch",
    justify: "flex-start"
};
const $73ac4d0cd9c4d592$export$694e0d28c7ffc90c = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Stack", $73ac4d0cd9c4d592$var$defaultProps, props), { spacing: spacing, className: className, align: align, justify: justify, unstyled: unstyled, variant: variant } = _a, others = $73ac4d0cd9c4d592$var$__objRest(_a, [
        "spacing",
        "className",
        "align",
        "justify",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $9qOg3.default)({
        spacing: spacing,
        align: align,
        justify: justify
    }, {
        name: "Stack",
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $73ac4d0cd9c4d592$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others));
});
$73ac4d0cd9c4d592$export$694e0d28c7ffc90c.displayName = "@mantine/core/Stack";

});
parcelRegister("9qOg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ddd86ed80a58966$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $6ddd86ed80a58966$var$useStyles = (0, $cQG1Y.createStyles)((theme, { spacing: spacing, align: align, justify: justify })=>({
        root: {
            display: "flex",
            flexDirection: "column",
            alignItems: align,
            justifyContent: justify,
            gap: (0, $d8Ix8.getSize)({
                size: spacing,
                sizes: theme.spacing
            })
        }
    }));
var $6ddd86ed80a58966$export$2e2bcd8739ae039 = $6ddd86ed80a58966$var$useStyles;

});


parcelRegister("1c0Cg", function(module, exports) {

$parcel$export(module.exports, "Stepper", () => $0de763c5d1efd8f1$export$ed8ca599049e8881);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $2a6gc = parcelRequire("2a6gc");

var $kDH1x = parcelRequire("kDH1x");

var $d7rc9 = parcelRequire("d7rc9");

var $hiiR1 = parcelRequire("hiiR1");
var $0de763c5d1efd8f1$var$__defProp = Object.defineProperty;
var $0de763c5d1efd8f1$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0de763c5d1efd8f1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0de763c5d1efd8f1$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0de763c5d1efd8f1$var$__defNormalProp = (obj, key, value)=>key in obj ? $0de763c5d1efd8f1$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0de763c5d1efd8f1$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0de763c5d1efd8f1$var$__hasOwnProp.call(b, prop)) $0de763c5d1efd8f1$var$__defNormalProp(a, prop, b[prop]);
    if ($0de763c5d1efd8f1$var$__getOwnPropSymbols) {
        for (var prop of $0de763c5d1efd8f1$var$__getOwnPropSymbols(b))if ($0de763c5d1efd8f1$var$__propIsEnum.call(b, prop)) $0de763c5d1efd8f1$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0de763c5d1efd8f1$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0de763c5d1efd8f1$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0de763c5d1efd8f1$var$__getOwnPropSymbols) {
        for (var prop of $0de763c5d1efd8f1$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0de763c5d1efd8f1$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $0de763c5d1efd8f1$var$defaultProps = {
    contentPadding: "md",
    size: "md",
    radius: "xl",
    orientation: "horizontal",
    iconPosition: "left",
    allowNextStepsSelect: true
};
const $0de763c5d1efd8f1$export$ed8ca599049e8881 = (0, $acw62.forwardRef)((props, ref)=>{
    var _b, _c, _d;
    const _a = (0, $64A2P.useComponentDefaultProps)("Stepper", $0de763c5d1efd8f1$var$defaultProps, props), { className: className, children: children, onStepClick: onStepClick, active: active, icon: icon, completedIcon: completedIcon, progressIcon: progressIcon, color: color, iconSize: iconSize, contentPadding: contentPadding, size: size, radius: radius, orientation: orientation, breakpoint: breakpoint, iconPosition: iconPosition, allowNextStepsSelect: allowNextStepsSelect, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant } = _a, others = $0de763c5d1efd8f1$var$__objRest(_a, [
        "className",
        "children",
        "onStepClick",
        "active",
        "icon",
        "completedIcon",
        "progressIcon",
        "color",
        "iconSize",
        "contentPadding",
        "size",
        "radius",
        "orientation",
        "breakpoint",
        "iconPosition",
        "allowNextStepsSelect",
        "classNames",
        "styles",
        "unstyled",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $d7rc9.default)({
        contentPadding: contentPadding,
        color: color,
        orientation: orientation,
        iconPosition: iconPosition,
        iconSize: iconSize,
        breakpoint: breakpoint
    }, {
        name: "Stepper",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const convertedChildren = (0, $acw62.Children).toArray(children);
    const _children = convertedChildren.filter((child)=>child.type !== (0, $kDH1x.StepCompleted));
    const completedStep = convertedChildren.find((item)=>item.type === (0, $kDH1x.StepCompleted));
    const items = _children.reduce((acc, item, index)=>{
        const state = active === index ? "stepProgress" : active > index ? "stepCompleted" : "stepInactive";
        const shouldAllowSelect = ()=>{
            if (typeof onStepClick !== "function") return false;
            if (typeof item.props.allowStepSelect === "boolean") return item.props.allowStepSelect;
            return state === "stepCompleted" || allowNextStepsSelect;
        };
        const isStepSelectionEnabled = shouldAllowSelect();
        acc.push((0, $acw62.cloneElement)(item, {
            __staticSelector: "Stepper",
            icon: item.props.icon || icon || index + 1,
            key: index,
            step: index,
            variant: variant,
            state: state,
            onClick: ()=>isStepSelectionEnabled && onStepClick(index),
            allowStepClick: isStepSelectionEnabled,
            completedIcon: item.props.completedIcon || completedIcon,
            progressIcon: item.props.progressIcon || progressIcon,
            color: item.props.color || color,
            iconSize: iconSize,
            size: size,
            radius: radius,
            classNames: classNames,
            styles: styles,
            iconPosition: item.props.iconPosition || iconPosition,
            orientation: orientation,
            unstyled: unstyled
        }));
        if (orientation === "horizontal" && index !== _children.length - 1) acc.push(/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: cx(classes.separator, {
                [classes.separatorActive]: index < active
            }),
            key: `separator-${index}`
        }));
        return acc;
    }, []);
    const stepContent = (_c = (_b = _children[active]) == null ? void 0 : _b.props) == null ? void 0 : _c.children;
    const completedContent = (_d = completedStep == null ? void 0 : completedStep.props) == null ? void 0 : _d.children;
    const content = active > _children.length - 1 ? completedContent : stepContent;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $0de763c5d1efd8f1$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.steps
    }, items), content && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.content
    }, content));
});
$0de763c5d1efd8f1$export$ed8ca599049e8881.Step = (0, $2a6gc.Step);
$0de763c5d1efd8f1$export$ed8ca599049e8881.Completed = (0, $kDH1x.StepCompleted);
$0de763c5d1efd8f1$export$ed8ca599049e8881.displayName = "@mantine/core/Stepper";

});
parcelRegister("2a6gc", function(module, exports) {

$parcel$export(module.exports, "Step", () => $19315f1bb650a4da$export$fd55ce593607084a);

var $acw62 = parcelRequire("acw62");

var $d8Ix8 = parcelRequire("d8Ix8");
var $64A2P = parcelRequire("64A2P");

var $icTCe = parcelRequire("icTCe");

var $5etRf = parcelRequire("5etRf");

var $1RCXp = parcelRequire("1RCXp");

var $4P91H = parcelRequire("4P91H");

var $2XzIE = parcelRequire("2XzIE");

var $cjohz = parcelRequire("cjohz");
var $19315f1bb650a4da$var$__defProp = Object.defineProperty;
var $19315f1bb650a4da$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $19315f1bb650a4da$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $19315f1bb650a4da$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $19315f1bb650a4da$var$__defNormalProp = (obj, key, value)=>key in obj ? $19315f1bb650a4da$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $19315f1bb650a4da$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($19315f1bb650a4da$var$__hasOwnProp.call(b, prop)) $19315f1bb650a4da$var$__defNormalProp(a, prop, b[prop]);
    if ($19315f1bb650a4da$var$__getOwnPropSymbols) {
        for (var prop of $19315f1bb650a4da$var$__getOwnPropSymbols(b))if ($19315f1bb650a4da$var$__propIsEnum.call(b, prop)) $19315f1bb650a4da$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $19315f1bb650a4da$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($19315f1bb650a4da$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $19315f1bb650a4da$var$__getOwnPropSymbols) {
        for (var prop of $19315f1bb650a4da$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $19315f1bb650a4da$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $19315f1bb650a4da$var$defaultIconSizes = {
    xs: 16,
    sm: 18,
    md: 20,
    lg: 22,
    xl: 24
};
const $19315f1bb650a4da$var$defaultProps = {
    withIcon: true,
    size: "md",
    radius: "xl",
    allowStepClick: true,
    iconPosition: "left",
    __staticSelector: "Step"
};
const $19315f1bb650a4da$var$getStepFragment = (Fragment, step)=>{
    if (typeof Fragment === "function") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Fragment, {
        step: step
    });
    return Fragment;
};
const $19315f1bb650a4da$export$fd55ce593607084a = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("StepperStep", $19315f1bb650a4da$var$defaultProps, props), { className: className, step: step, state: state, color: color, icon: icon, completedIcon: completedIcon, progressIcon: progressIcon, label: label, description: description, withIcon: withIcon, iconSize: iconSize, size: size, radius: radius, loading: loading, allowStepClick: allowStepClick, allowStepSelect: allowStepSelect, iconPosition: iconPosition, __staticSelector: __staticSelector, classNames: classNames, styles: styles, unstyled: unstyled, orientation: orientation, variant: variant } = _a, others = $19315f1bb650a4da$var$__objRest(_a, [
        "className",
        "step",
        "state",
        "color",
        "icon",
        "completedIcon",
        "progressIcon",
        "label",
        "description",
        "withIcon",
        "iconSize",
        "size",
        "radius",
        "loading",
        "allowStepClick",
        "allowStepSelect",
        "iconPosition",
        "__staticSelector",
        "classNames",
        "styles",
        "unstyled",
        "orientation",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $icTCe.default)({
        color: color,
        iconSize: iconSize,
        radius: radius,
        allowStepClick: allowStepClick,
        iconPosition: iconPosition,
        orientation: orientation
    }, {
        name: __staticSelector,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const _iconSize = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $19315f1bb650a4da$var$defaultIconSizes
    });
    const _icon = state === "stepCompleted" ? null : state === "stepProgress" ? progressIcon : icon;
    const dataAttributes = {
        "data-progress": state === "stepProgress" || void 0,
        "data-completed": state === "stepCompleted" || void 0
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $19315f1bb650a4da$var$__spreadValues($19315f1bb650a4da$var$__spreadValues({
        className: cx(classes.step, className),
        tabIndex: allowStepClick ? 0 : -1,
        ref: ref
    }, dataAttributes), others), withIcon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.stepWrapper
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $19315f1bb650a4da$var$__spreadValues({
        className: classes.stepIcon
    }, dataAttributes), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1RCXp.Transition), {
        mounted: state === "stepCompleted",
        transition: "pop",
        duration: 200
    }, (transitionStyles)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: classes.stepCompletedIcon,
            style: transitionStyles
        }, loading ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4P91H.Loader), {
            color: "#fff",
            size: _iconSize,
            className: classes.stepLoader
        }) : $19315f1bb650a4da$var$getStepFragment(completedIcon, step) || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2XzIE.CheckboxIcon), {
            indeterminate: false,
            width: _iconSize,
            height: _iconSize
        }))), state !== "stepCompleted" ? loading ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4P91H.Loader), {
        size: _iconSize,
        color: color
    }) : $19315f1bb650a4da$var$getStepFragment(_icon || icon, step) : null), orientation === "vertical" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: cx(classes.verticalSeparator, {
            [classes.verticalSeparatorActive]: state === "stepCompleted"
        })
    })), (label || description) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.stepBody
    }, label && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        className: classes.stepLabel
    }, $19315f1bb650a4da$var$getStepFragment(label, step)), description && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), {
        className: classes.stepDescription,
        color: "dimmed"
    }, $19315f1bb650a4da$var$getStepFragment(description, step))));
});
$19315f1bb650a4da$export$fd55ce593607084a.displayName = "@mantine/core/Step";

});
parcelRegister("icTCe", function(module, exports) {

$parcel$export(module.exports, "iconSizes", () => $d4147d1b040685df$export$1b7d9e64225dde90);
$parcel$export(module.exports, "default", () => $d4147d1b040685df$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $3mzq6 = parcelRequire("3mzq6");
var $2jkdX = parcelRequire("2jkdX");
var $d4147d1b040685df$var$__defProp = Object.defineProperty;
var $d4147d1b040685df$var$__defProps = Object.defineProperties;
var $d4147d1b040685df$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d4147d1b040685df$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d4147d1b040685df$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d4147d1b040685df$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d4147d1b040685df$var$__defNormalProp = (obj, key, value)=>key in obj ? $d4147d1b040685df$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d4147d1b040685df$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d4147d1b040685df$var$__hasOwnProp.call(b, prop)) $d4147d1b040685df$var$__defNormalProp(a, prop, b[prop]);
    if ($d4147d1b040685df$var$__getOwnPropSymbols) {
        for (var prop of $d4147d1b040685df$var$__getOwnPropSymbols(b))if ($d4147d1b040685df$var$__propIsEnum.call(b, prop)) $d4147d1b040685df$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d4147d1b040685df$var$__spreadProps = (a, b)=>$d4147d1b040685df$var$__defProps(a, $d4147d1b040685df$var$__getOwnPropDescs(b));
const $d4147d1b040685df$export$1b7d9e64225dde90 = {
    xs: (0, $2jkdX.rem)(34),
    sm: (0, $2jkdX.rem)(36),
    md: (0, $2jkdX.rem)(42),
    lg: (0, $2jkdX.rem)(48),
    xl: (0, $2jkdX.rem)(52)
};
var $d4147d1b040685df$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, iconSize: iconSize, radius: radius, allowStepClick: allowStepClick, iconPosition: iconPosition, orientation: orientation }, { size: size })=>{
    const _iconSize = iconSize ? (0, $2jkdX.rem)(iconSize) : (0, $d8Ix8.getSize)({
        size: size,
        sizes: $d4147d1b040685df$export$1b7d9e64225dde90
    });
    const iconMargin = size === "xl" || size === "lg" ? theme.spacing.md : theme.spacing.sm;
    const _radius = theme.fn.radius(radius);
    const colors = theme.fn.variant({
        variant: "filled",
        color: color || theme.primaryColor,
        primaryFallback: false
    });
    const separatorDistanceFromIcon = `calc(${theme.spacing.xs} / 2)`;
    const verticalOrientationStyles = {
        step: {
            justifyContent: "flex-start",
            minHeight: `calc(${_iconSize} + ${theme.spacing.xl} + ${separatorDistanceFromIcon})`,
            marginTop: separatorDistanceFromIcon,
            overflow: "hidden",
            "&:first-of-type": {
                marginTop: 0
            },
            [`&:last-of-type .${(0, $3mzq6.getStylesRef)("verticalSeparator")}`]: {
                display: "none"
            }
        }
    };
    return {
        stepLoader: {},
        step: $d4147d1b040685df$var$__spreadValues({
            display: "flex",
            flexDirection: iconPosition === "left" ? "row" : "row-reverse",
            cursor: allowStepClick ? "pointer" : "default"
        }, orientation === "vertical" ? verticalOrientationStyles.step : {
            alignItems: "center"
        }),
        stepWrapper: {
            position: "relative"
        },
        verticalSeparator: {
            top: `calc(${_iconSize} + ${separatorDistanceFromIcon})`,
            left: `calc(${_iconSize} / 2)`,
            height: "100vh",
            position: "absolute",
            borderLeft: `${(0, $2jkdX.rem)(2)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]}`,
            ref: (0, $3mzq6.getStylesRef)("verticalSeparator")
        },
        verticalSeparatorActive: {
            borderColor: theme.fn.variant({
                variant: "filled",
                color: color
            }).background
        },
        stepIcon: {
            boxSizing: "border-box",
            height: _iconSize,
            width: _iconSize,
            minWidth: _iconSize,
            borderRadius: _radius,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1],
            border: `${(0, $2jkdX.rem)(2)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]}`,
            transition: "background-color 150ms ease, border-color 150ms ease",
            position: "relative",
            fontWeight: 700,
            color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7],
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            "&[data-progress]": {
                borderColor: colors.background
            },
            "&[data-completed]": {
                backgroundColor: colors.background,
                borderColor: colors.background,
                color: theme.white
            }
        },
        stepCompletedIcon: $d4147d1b040685df$var$__spreadProps($d4147d1b040685df$var$__spreadValues({}, theme.fn.cover()), {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.white
        }),
        stepBody: $d4147d1b040685df$var$__spreadValues({
            display: "flex",
            flexDirection: "column",
            marginLeft: iconPosition === "left" ? iconMargin : void 0,
            marginRight: iconPosition === "right" ? iconMargin : void 0
        }, orientation === "vertical" ? {
            marginTop: `calc(${iconSize} / 4)`
        } : null),
        stepLabel: {
            textAlign: iconPosition,
            fontWeight: 500,
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            lineHeight: 1
        },
        stepDescription: {
            textAlign: iconPosition,
            marginTop: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 3)`,
            marginBottom: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 3)`,
            fontSize: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            })} - ${(0, $2jkdX.rem)(2)})`,
            lineHeight: 1
        }
    };
});
var $d4147d1b040685df$export$2e2bcd8739ae039 = $d4147d1b040685df$var$useStyles;

});


parcelRegister("kDH1x", function(module, exports) {

$parcel$export(module.exports, "StepCompleted", () => $f068d2cf0dd3f219$export$c1c4128561dd23b7);
function $f068d2cf0dd3f219$export$c1c4128561dd23b7(props) {
    return null;
}
$f068d2cf0dd3f219$export$c1c4128561dd23b7.displayName = "@mantine/core/StepCompleted";

});

parcelRegister("d7rc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d10630cc624712$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $2vpKc = parcelRequire("2vpKc");
var $d8Ix8 = parcelRequire("d8Ix8");

var $icTCe = parcelRequire("icTCe");
var $98d10630cc624712$var$__defProp = Object.defineProperty;
var $98d10630cc624712$var$__defProps = Object.defineProperties;
var $98d10630cc624712$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $98d10630cc624712$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $98d10630cc624712$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $98d10630cc624712$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $98d10630cc624712$var$__defNormalProp = (obj, key, value)=>key in obj ? $98d10630cc624712$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $98d10630cc624712$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($98d10630cc624712$var$__hasOwnProp.call(b, prop)) $98d10630cc624712$var$__defNormalProp(a, prop, b[prop]);
    if ($98d10630cc624712$var$__getOwnPropSymbols) {
        for (var prop of $98d10630cc624712$var$__getOwnPropSymbols(b))if ($98d10630cc624712$var$__propIsEnum.call(b, prop)) $98d10630cc624712$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $98d10630cc624712$var$__spreadProps = (a, b)=>$98d10630cc624712$var$__defProps(a, $98d10630cc624712$var$__getOwnPropDescs(b));
var $98d10630cc624712$var$useStyles = (0, $cQG1Y.createStyles)((theme, { contentPadding: contentPadding, color: color, orientation: orientation, iconPosition: iconPosition, iconSize: iconSize, breakpoint: breakpoint }, { size: size })=>{
    const shouldBeResponsive = typeof breakpoint !== "undefined";
    const breakpointValue = (0, $2vpKc.getBreakpointValue)((0, $d8Ix8.getSize)({
        size: breakpoint,
        sizes: theme.breakpoints
    }));
    const separatorOffset = typeof iconSize !== "undefined" ? `calc(${(0, $2jkdX.rem)(iconSize)} / 2 - ${(0, $2jkdX.rem)(1)})` : `calc(${(0, $d8Ix8.getSize)({
        size: size,
        sizes: (0, $icTCe.iconSizes)
    })} / 2 - ${(0, $2jkdX.rem)(1)})`;
    const verticalOrientationStyles = {
        steps: {
            flexDirection: "column",
            alignItems: iconPosition === "left" ? "flex-start" : "flex-end"
        },
        separator: {
            width: (0, $2jkdX.rem)(2),
            minHeight: theme.spacing.xl,
            marginLeft: iconPosition === "left" ? separatorOffset : 0,
            marginRight: iconPosition === "right" ? separatorOffset : 0,
            marginTop: `calc(${theme.spacing.xs} / 2)`,
            marginBottom: `calc(${theme.spacing.xs} - ${(0, $2jkdX.rem)(2)})`
        }
    };
    const responsiveStyles = {
        steps: {
            [`@media (max-width: ${(0, $2jkdX.em)(breakpointValue - 1)})`]: verticalOrientationStyles.steps
        },
        separator: {
            [`@media (max-width: ${(0, $2jkdX.em)(breakpointValue - 1)})`]: verticalOrientationStyles.separator
        }
    };
    return {
        root: {},
        steps: $98d10630cc624712$var$__spreadValues($98d10630cc624712$var$__spreadValues({
            display: "flex",
            boxSizing: "border-box",
            alignItems: "center"
        }, orientation === "vertical" ? verticalOrientationStyles.steps : null), shouldBeResponsive ? responsiveStyles.steps : null),
        separator: $98d10630cc624712$var$__spreadValues($98d10630cc624712$var$__spreadValues({
            boxSizing: "border-box",
            transition: "background-color 150ms ease",
            flex: 1,
            height: (0, $2jkdX.rem)(2),
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
            marginLeft: theme.spacing.md,
            marginRight: theme.spacing.md
        }, orientation === "vertical" ? verticalOrientationStyles.separator : null), shouldBeResponsive ? responsiveStyles.separator : null),
        separatorActive: {
            backgroundColor: theme.fn.variant({
                variant: "filled",
                color: color || theme.primaryColor,
                primaryFallback: false
            }).background
        },
        content: $98d10630cc624712$var$__spreadProps($98d10630cc624712$var$__spreadValues({}, theme.fn.fontStyles()), {
            paddingTop: (0, $d8Ix8.getSize)({
                size: contentPadding,
                sizes: theme.spacing
            })
        })
    };
});
var $98d10630cc624712$export$2e2bcd8739ae039 = $98d10630cc624712$var$useStyles;

});


parcelRegister("foYg9", function(module, exports) {

$parcel$export(module.exports, "Switch", () => $b367d7313d9922fe$export$b5d5cf8927ab7262);

var $acw62 = parcelRequire("acw62");

var $8nBd8 = parcelRequire("8nBd8");
var $ke4gU = parcelRequire("ke4gU");

var $64A2P = parcelRequire("64A2P");

var $ggzOJ = parcelRequire("ggzOJ");

var $3qNP9 = parcelRequire("3qNP9");

var $1kzTp = parcelRequire("1kzTp");

var $aEkmw = parcelRequire("aEkmw");

var $im7xW = parcelRequire("im7xW");
var $b367d7313d9922fe$var$__defProp = Object.defineProperty;
var $b367d7313d9922fe$var$__defProps = Object.defineProperties;
var $b367d7313d9922fe$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b367d7313d9922fe$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b367d7313d9922fe$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b367d7313d9922fe$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b367d7313d9922fe$var$__defNormalProp = (obj, key, value)=>key in obj ? $b367d7313d9922fe$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b367d7313d9922fe$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b367d7313d9922fe$var$__hasOwnProp.call(b, prop)) $b367d7313d9922fe$var$__defNormalProp(a, prop, b[prop]);
    if ($b367d7313d9922fe$var$__getOwnPropSymbols) {
        for (var prop of $b367d7313d9922fe$var$__getOwnPropSymbols(b))if ($b367d7313d9922fe$var$__propIsEnum.call(b, prop)) $b367d7313d9922fe$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b367d7313d9922fe$var$__spreadProps = (a, b)=>$b367d7313d9922fe$var$__defProps(a, $b367d7313d9922fe$var$__getOwnPropDescs(b));
var $b367d7313d9922fe$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b367d7313d9922fe$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b367d7313d9922fe$var$__getOwnPropSymbols) {
        for (var prop of $b367d7313d9922fe$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b367d7313d9922fe$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b367d7313d9922fe$var$defaultProps = {
    offLabel: "",
    onLabel: "",
    size: "sm",
    radius: "xl",
    error: false
};
const $b367d7313d9922fe$export$b5d5cf8927ab7262 = (0, $acw62.forwardRef)((props, ref)=>{
    var _b;
    const _a = (0, $64A2P.useComponentDefaultProps)("Switch", $b367d7313d9922fe$var$defaultProps, props), { className: className, color: color, label: label, offLabel: offLabel, onLabel: onLabel, id: id, style: style, size: size, radius: radius, wrapperProps: wrapperProps, children: children, unstyled: unstyled, styles: styles, classNames: classNames, thumbIcon: thumbIcon, sx: sx, checked: checked, defaultChecked: defaultChecked, onChange: onChange, labelPosition: labelPosition, description: description, error: error, disabled: disabled, variant: variant } = _a, others = $b367d7313d9922fe$var$__objRest(_a, [
        "className",
        "color",
        "label",
        "offLabel",
        "onLabel",
        "id",
        "style",
        "size",
        "radius",
        "wrapperProps",
        "children",
        "unstyled",
        "styles",
        "classNames",
        "thumbIcon",
        "sx",
        "checked",
        "defaultChecked",
        "onChange",
        "labelPosition",
        "description",
        "error",
        "disabled",
        "variant"
    ]);
    const ctx = (0, $3qNP9.useSwitchGroupContext)();
    const _size = (ctx == null ? void 0 : ctx.size) || size;
    const { classes: classes, cx: cx } = (0, $1kzTp.default)({
        color: color,
        radius: radius,
        labelPosition: labelPosition,
        error: !!error
    }, {
        name: "Switch",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        size: _size,
        variant: variant
    });
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const uuid = (0, $8nBd8.useId)(id);
    const contextProps = ctx ? {
        checked: ctx.value.includes(rest.value),
        onChange: ctx.onChange
    } : {};
    const [_checked, handleChange] = (0, $ke4gU.useUncontrolled)({
        value: (_b = contextProps.checked) != null ? _b : checked,
        defaultValue: defaultChecked,
        finalValue: false
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $im7xW.InlineInput), $b367d7313d9922fe$var$__spreadValues($b367d7313d9922fe$var$__spreadValues({
        className: cx(className, classes.root),
        sx: sx,
        style: style,
        id: uuid,
        size: (ctx == null ? void 0 : ctx.size) || size,
        labelPosition: labelPosition,
        label: label,
        description: description,
        error: error,
        disabled: disabled,
        bodyElement: "label",
        labelElement: "span",
        __staticSelector: "Switch",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        "data-checked": contextProps.checked || void 0,
        variant: variant
    }, systemStyles), wrapperProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $b367d7313d9922fe$var$__spreadProps($b367d7313d9922fe$var$__spreadValues({}, rest), {
        disabled: disabled,
        checked: _checked,
        onChange: (event)=>{
            ctx ? contextProps.onChange(event) : onChange == null || onChange(event);
            handleChange(event.currentTarget.checked);
        },
        id: uuid,
        ref: ref,
        type: "checkbox",
        role: "switch",
        className: classes.input
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.track,
        "aria-hidden": true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.thumb
    }, thumbIcon), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.trackLabel
    }, _checked ? onLabel : offLabel)));
});
$b367d7313d9922fe$export$b5d5cf8927ab7262.displayName = "@mantine/core/Switch";
$b367d7313d9922fe$export$b5d5cf8927ab7262.Group = (0, $ggzOJ.SwitchGroup);

});
parcelRegister("ggzOJ", function(module, exports) {

$parcel$export(module.exports, "SwitchGroup", () => $bd79ec88cb153373$export$1b8cf0fbf52a628d);

var $acw62 = parcelRequire("acw62");

var $ke4gU = parcelRequire("ke4gU");

var $64A2P = parcelRequire("64A2P");

var $3qNP9 = parcelRequire("3qNP9");

var $gw63X = parcelRequire("gw63X");
var $bd79ec88cb153373$var$__defProp = Object.defineProperty;
var $bd79ec88cb153373$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $bd79ec88cb153373$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $bd79ec88cb153373$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $bd79ec88cb153373$var$__defNormalProp = (obj, key, value)=>key in obj ? $bd79ec88cb153373$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $bd79ec88cb153373$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($bd79ec88cb153373$var$__hasOwnProp.call(b, prop)) $bd79ec88cb153373$var$__defNormalProp(a, prop, b[prop]);
    if ($bd79ec88cb153373$var$__getOwnPropSymbols) {
        for (var prop of $bd79ec88cb153373$var$__getOwnPropSymbols(b))if ($bd79ec88cb153373$var$__propIsEnum.call(b, prop)) $bd79ec88cb153373$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $bd79ec88cb153373$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($bd79ec88cb153373$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $bd79ec88cb153373$var$__getOwnPropSymbols) {
        for (var prop of $bd79ec88cb153373$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $bd79ec88cb153373$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $bd79ec88cb153373$var$defaultProps = {
    size: "sm"
};
const $bd79ec88cb153373$export$1b8cf0fbf52a628d = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("SwitchGroup", $bd79ec88cb153373$var$defaultProps, props), { children: children, value: value, defaultValue: defaultValue, onChange: onChange, size: size, wrapperProps: wrapperProps } = _a, others = $bd79ec88cb153373$var$__objRest(_a, [
        "children",
        "value",
        "defaultValue",
        "onChange",
        "size",
        "wrapperProps"
    ]);
    const [_value, setValue] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: [],
        onChange: onChange
    });
    const handleChange = (event)=>{
        const itemValue = event.currentTarget.value;
        setValue(_value.includes(itemValue) ? _value.filter((item)=>item !== itemValue) : [
            ..._value,
            itemValue
        ]);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3qNP9.SwitchGroupProvider), {
        value: {
            value: _value,
            onChange: handleChange,
            size: size
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $bd79ec88cb153373$var$__spreadValues($bd79ec88cb153373$var$__spreadValues({
        labelElement: "div",
        size: size,
        __staticSelector: "SwitchGroup",
        ref: ref
    }, wrapperProps), others), children));
});
$bd79ec88cb153373$export$1b8cf0fbf52a628d.displayName = "@mantine/core/SwitchGroup";

});
parcelRegister("3qNP9", function(module, exports) {

$parcel$export(module.exports, "SwitchGroupProvider", () => $27fa72d73a5b3a35$export$2c6e08bb6d2feb06);
$parcel$export(module.exports, "useSwitchGroupContext", () => $27fa72d73a5b3a35$export$5b570bc753d49a61);

var $acw62 = parcelRequire("acw62");
const $27fa72d73a5b3a35$var$SwitchGroupContext = (0, $acw62.createContext)(null);
const $27fa72d73a5b3a35$export$2c6e08bb6d2feb06 = $27fa72d73a5b3a35$var$SwitchGroupContext.Provider;
const $27fa72d73a5b3a35$export$5b570bc753d49a61 = ()=>(0, $acw62.useContext)($27fa72d73a5b3a35$var$SwitchGroupContext);

});


parcelRegister("1kzTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f838042508aacc5$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $0f838042508aacc5$var$__defProp = Object.defineProperty;
var $0f838042508aacc5$var$__defProps = Object.defineProperties;
var $0f838042508aacc5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0f838042508aacc5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0f838042508aacc5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0f838042508aacc5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0f838042508aacc5$var$__defNormalProp = (obj, key, value)=>key in obj ? $0f838042508aacc5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0f838042508aacc5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0f838042508aacc5$var$__hasOwnProp.call(b, prop)) $0f838042508aacc5$var$__defNormalProp(a, prop, b[prop]);
    if ($0f838042508aacc5$var$__getOwnPropSymbols) {
        for (var prop of $0f838042508aacc5$var$__getOwnPropSymbols(b))if ($0f838042508aacc5$var$__propIsEnum.call(b, prop)) $0f838042508aacc5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0f838042508aacc5$var$__spreadProps = (a, b)=>$0f838042508aacc5$var$__defProps(a, $0f838042508aacc5$var$__getOwnPropDescs(b));
const $0f838042508aacc5$var$switchHeight = {
    xs: (0, $2jkdX.rem)(16),
    sm: (0, $2jkdX.rem)(20),
    md: (0, $2jkdX.rem)(24),
    lg: (0, $2jkdX.rem)(30),
    xl: (0, $2jkdX.rem)(36)
};
const $0f838042508aacc5$var$switchWidth = {
    xs: (0, $2jkdX.rem)(32),
    sm: (0, $2jkdX.rem)(38),
    md: (0, $2jkdX.rem)(46),
    lg: (0, $2jkdX.rem)(56),
    xl: (0, $2jkdX.rem)(72)
};
const $0f838042508aacc5$var$handleSizes = {
    xs: (0, $2jkdX.rem)(12),
    sm: (0, $2jkdX.rem)(14),
    md: (0, $2jkdX.rem)(18),
    lg: (0, $2jkdX.rem)(22),
    xl: (0, $2jkdX.rem)(28)
};
const $0f838042508aacc5$var$labelFontSizes = {
    xs: (0, $2jkdX.rem)(5),
    sm: (0, $2jkdX.rem)(6),
    md: (0, $2jkdX.rem)(7),
    lg: (0, $2jkdX.rem)(9),
    xl: (0, $2jkdX.rem)(11)
};
const $0f838042508aacc5$var$trackLabelPaddings = {
    xs: (0, $2jkdX.rem)(4),
    sm: (0, $2jkdX.rem)(5),
    md: (0, $2jkdX.rem)(6),
    lg: (0, $2jkdX.rem)(8),
    xl: (0, $2jkdX.rem)(10)
};
var $0f838042508aacc5$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, color: color, labelPosition: labelPosition, error: error }, { size: size })=>{
    const handleSize = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $0f838042508aacc5$var$handleSizes
    });
    const borderRadius = (0, $d8Ix8.getSize)({
        size: radius,
        sizes: theme.radius
    });
    const colors = theme.fn.variant({
        variant: "filled",
        color: color
    });
    const trackWidth = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $0f838042508aacc5$var$switchWidth
    });
    const trackPadding = (0, $2jkdX.rem)(size === "xs" ? 1 : 2);
    const errorColor = theme.fn.variant({
        variant: "filled",
        color: "red"
    }).background;
    return {
        root: {
            position: "relative"
        },
        input: {
            height: 0,
            width: 0,
            overflow: "hidden",
            whiteSpace: "nowrap",
            padding: 0,
            WebkitClipPath: "inset(50%)",
            clipPath: "inset(50%)",
            position: "absolute"
        },
        track: $0f838042508aacc5$var$__spreadProps($0f838042508aacc5$var$__spreadValues({}, theme.fn.focusStyles("input:focus + &")), {
            cursor: theme.cursorType,
            overflow: "hidden",
            WebkitTapHighlightColor: "transparent",
            position: "relative",
            borderRadius: borderRadius,
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[2],
            border: `${(0, $2jkdX.rem)(1)} solid ${error ? errorColor : theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`,
            height: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $0f838042508aacc5$var$switchHeight
            }),
            minWidth: trackWidth,
            margin: 0,
            transitionProperty: "background-color, border-color",
            transitionTimingFunction: theme.transitionTimingFunction,
            transitionDuration: "150ms",
            boxSizing: "border-box",
            appearance: "none",
            display: "flex",
            alignItems: "center",
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $0f838042508aacc5$var$labelFontSizes
            }),
            fontWeight: 600,
            order: labelPosition === "left" ? 2 : 1,
            userSelect: "none",
            zIndex: 0,
            lineHeight: 0,
            color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[6],
            transition: `color 150ms ${theme.transitionTimingFunction}`,
            "input:checked + &": {
                backgroundColor: colors.background,
                borderColor: colors.background,
                color: theme.white,
                transition: `color 150ms ${theme.transitionTimingFunction}`
            },
            "input:disabled + &": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
                borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
                cursor: "not-allowed",
                pointerEvents: "none"
            }
        }),
        thumb: {
            position: "absolute",
            zIndex: 1,
            borderRadius: borderRadius,
            boxSizing: "border-box",
            display: "flex",
            backgroundColor: theme.white,
            height: handleSize,
            width: handleSize,
            border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.white : theme.colors.gray[3]}`,
            left: trackPadding,
            transition: `left 150ms ${theme.transitionTimingFunction}`,
            "& > *": {
                margin: "auto"
            },
            "@media (prefers-reduced-motion)": {
                transitionDuration: theme.respectReducedMotion ? "0ms" : ""
            },
            "input:checked + * > &": {
                left: `calc(100% - ${handleSize} - ${trackPadding})`,
                borderColor: theme.white
            },
            "input:disabled + * > &": {
                borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[0]
            }
        },
        trackLabel: {
            height: "100%",
            display: "grid",
            placeContent: "center",
            minWidth: `calc(${trackWidth} - ${handleSize})`,
            paddingInline: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $0f838042508aacc5$var$trackLabelPaddings
            }),
            marginLeft: `calc(${handleSize} + ${trackPadding})`,
            transition: `margin 150ms ${theme.transitionTimingFunction}`,
            "input:checked + * > &": {
                marginLeft: 0,
                marginRight: `calc(${handleSize} + ${trackPadding})`
            }
        }
    };
});
var $0f838042508aacc5$export$2e2bcd8739ae039 = $0f838042508aacc5$var$useStyles;

});


parcelRegister("fbXO1", function(module, exports) {

$parcel$export(module.exports, "Table", () => $b0f64646aadb86a6$export$54ec01a60f47d33d);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $6ZPdr = parcelRequire("6ZPdr");

var $hiiR1 = parcelRequire("hiiR1");
var $b0f64646aadb86a6$var$__defProp = Object.defineProperty;
var $b0f64646aadb86a6$var$__defProps = Object.defineProperties;
var $b0f64646aadb86a6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b0f64646aadb86a6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b0f64646aadb86a6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b0f64646aadb86a6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b0f64646aadb86a6$var$__defNormalProp = (obj, key, value)=>key in obj ? $b0f64646aadb86a6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b0f64646aadb86a6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b0f64646aadb86a6$var$__hasOwnProp.call(b, prop)) $b0f64646aadb86a6$var$__defNormalProp(a, prop, b[prop]);
    if ($b0f64646aadb86a6$var$__getOwnPropSymbols) {
        for (var prop of $b0f64646aadb86a6$var$__getOwnPropSymbols(b))if ($b0f64646aadb86a6$var$__propIsEnum.call(b, prop)) $b0f64646aadb86a6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b0f64646aadb86a6$var$__spreadProps = (a, b)=>$b0f64646aadb86a6$var$__defProps(a, $b0f64646aadb86a6$var$__getOwnPropDescs(b));
var $b0f64646aadb86a6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b0f64646aadb86a6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b0f64646aadb86a6$var$__getOwnPropSymbols) {
        for (var prop of $b0f64646aadb86a6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b0f64646aadb86a6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $b0f64646aadb86a6$var$defaultProps = {
    striped: false,
    highlightOnHover: false,
    captionSide: "top",
    horizontalSpacing: "xs",
    fontSize: "sm",
    verticalSpacing: 7,
    withBorder: false,
    withColumnBorders: false
};
const $b0f64646aadb86a6$export$54ec01a60f47d33d = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Table", $b0f64646aadb86a6$var$defaultProps, props), { className: className, children: children, striped: striped, highlightOnHover: highlightOnHover, captionSide: captionSide, horizontalSpacing: horizontalSpacing, verticalSpacing: verticalSpacing, fontSize: fontSize, unstyled: unstyled, withBorder: withBorder, withColumnBorders: withColumnBorders, variant: variant } = _a, others = $b0f64646aadb86a6$var$__objRest(_a, [
        "className",
        "children",
        "striped",
        "highlightOnHover",
        "captionSide",
        "horizontalSpacing",
        "verticalSpacing",
        "fontSize",
        "unstyled",
        "withBorder",
        "withColumnBorders",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $6ZPdr.default)({
        captionSide: captionSide,
        verticalSpacing: verticalSpacing,
        horizontalSpacing: horizontalSpacing,
        fontSize: fontSize,
        withBorder: withBorder,
        withColumnBorders: withColumnBorders
    }, {
        unstyled: unstyled,
        name: "Table",
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $b0f64646aadb86a6$var$__spreadProps($b0f64646aadb86a6$var$__spreadValues({}, others), {
        component: "table",
        ref: ref,
        className: cx(classes.root, className),
        "data-striped": striped || void 0,
        "data-hover": highlightOnHover || void 0
    }), children);
});
$b0f64646aadb86a6$export$54ec01a60f47d33d.displayName = "@mantine/core/Table";

});
parcelRegister("6ZPdr", function(module, exports) {

$parcel$export(module.exports, "default", () => $51802af3799bc3d9$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $51802af3799bc3d9$var$__defProp = Object.defineProperty;
var $51802af3799bc3d9$var$__defProps = Object.defineProperties;
var $51802af3799bc3d9$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $51802af3799bc3d9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $51802af3799bc3d9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $51802af3799bc3d9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $51802af3799bc3d9$var$__defNormalProp = (obj, key, value)=>key in obj ? $51802af3799bc3d9$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $51802af3799bc3d9$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($51802af3799bc3d9$var$__hasOwnProp.call(b, prop)) $51802af3799bc3d9$var$__defNormalProp(a, prop, b[prop]);
    if ($51802af3799bc3d9$var$__getOwnPropSymbols) {
        for (var prop of $51802af3799bc3d9$var$__getOwnPropSymbols(b))if ($51802af3799bc3d9$var$__propIsEnum.call(b, prop)) $51802af3799bc3d9$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $51802af3799bc3d9$var$__spreadProps = (a, b)=>$51802af3799bc3d9$var$__defProps(a, $51802af3799bc3d9$var$__getOwnPropDescs(b));
var $51802af3799bc3d9$var$useStyles = (0, $cQG1Y.createStyles)((theme, { captionSide: captionSide, horizontalSpacing: horizontalSpacing, verticalSpacing: verticalSpacing, fontSize: fontSize, withBorder: withBorder, withColumnBorders: withColumnBorders })=>{
    const border = `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`;
    return {
        root: $51802af3799bc3d9$var$__spreadProps($51802af3799bc3d9$var$__spreadValues({}, theme.fn.fontStyles()), {
            width: "100%",
            borderCollapse: "collapse",
            captionSide: captionSide,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
            lineHeight: theme.lineHeight,
            border: withBorder ? border : void 0,
            "& > caption": {
                marginTop: captionSide === "top" ? 0 : theme.spacing.xs,
                marginBottom: captionSide === "bottom" ? 0 : theme.spacing.xs,
                fontSize: theme.fontSizes.sm,
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6]
            },
            "& > thead > tr > th, & > tfoot > tr > th, & > tbody > tr > th": {
                textAlign: "left",
                fontWeight: "bold",
                color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
                fontSize: (0, $d8Ix8.getSize)({
                    size: fontSize,
                    sizes: theme.fontSizes
                }),
                padding: `${(0, $d8Ix8.getSize)({
                    size: verticalSpacing,
                    sizes: theme.spacing
                })} ${(0, $d8Ix8.getSize)({
                    size: horizontalSpacing,
                    sizes: theme.spacing
                })}`
            },
            "& > thead > tr > th": {
                borderBottom: border
            },
            "& > tfoot > tr > th, & > tbody > tr > th": {
                borderTop: border
            },
            "& > tbody > tr > td": {
                padding: `${(0, $d8Ix8.getSize)({
                    size: verticalSpacing,
                    sizes: theme.spacing
                })} ${(0, $d8Ix8.getSize)({
                    size: horizontalSpacing,
                    sizes: theme.spacing
                })}`,
                borderTop: border,
                fontSize: (0, $d8Ix8.getSize)({
                    size: fontSize,
                    sizes: theme.fontSizes
                })
            },
            "& > tbody > tr:first-of-type > td, & > tbody > tr:first-of-type > th": {
                borderTop: "none"
            },
            "& > thead > tr > th, & > tbody > tr > td": {
                borderRight: withColumnBorders ? border : "none",
                "&:last-of-type": {
                    borderRight: "none",
                    borderLeft: withColumnBorders ? border : "none"
                }
            },
            "& > tbody > tr > th": {
                borderRight: withColumnBorders ? border : "none"
            },
            "&[data-striped] > tbody > tr:nth-of-type(odd)": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
            },
            "&[data-hover] > tbody > tr": theme.fn.hover({
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[1]
            })
        })
    };
});
var $51802af3799bc3d9$export$2e2bcd8739ae039 = $51802af3799bc3d9$var$useStyles;

});


parcelRegister("hUms8", function(module, exports) {

$parcel$export(module.exports, "Tabs", () => $d099154c683f97e2$export$b2539bed5023c21c);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $9gcRm = parcelRequire("9gcRm");

var $8N0dG = parcelRequire("8N0dG");

var $5woXG = parcelRequire("5woXG");

var $c64rN = parcelRequire("c64rN");

var $3xPdu = parcelRequire("3xPdu");

var $hiiR1 = parcelRequire("hiiR1");
var $d099154c683f97e2$var$__defProp = Object.defineProperty;
var $d099154c683f97e2$var$__defProps = Object.defineProperties;
var $d099154c683f97e2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d099154c683f97e2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d099154c683f97e2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d099154c683f97e2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d099154c683f97e2$var$__defNormalProp = (obj, key, value)=>key in obj ? $d099154c683f97e2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d099154c683f97e2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d099154c683f97e2$var$__hasOwnProp.call(b, prop)) $d099154c683f97e2$var$__defNormalProp(a, prop, b[prop]);
    if ($d099154c683f97e2$var$__getOwnPropSymbols) {
        for (var prop of $d099154c683f97e2$var$__getOwnPropSymbols(b))if ($d099154c683f97e2$var$__propIsEnum.call(b, prop)) $d099154c683f97e2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d099154c683f97e2$var$__spreadProps = (a, b)=>$d099154c683f97e2$var$__defProps(a, $d099154c683f97e2$var$__getOwnPropDescs(b));
var $d099154c683f97e2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d099154c683f97e2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d099154c683f97e2$var$__getOwnPropSymbols) {
        for (var prop of $d099154c683f97e2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d099154c683f97e2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $d099154c683f97e2$var$defaultProps = {
    orientation: "horizontal",
    loop: true,
    activateTabWithKeyboard: true,
    allowTabDeactivation: false,
    unstyled: false,
    inverted: false,
    variant: "default",
    placement: "left"
};
const $d099154c683f97e2$export$b2539bed5023c21c = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Tabs", $d099154c683f97e2$var$defaultProps, props), { defaultValue: defaultValue, value: value, orientation: orientation, loop: loop, activateTabWithKeyboard: activateTabWithKeyboard, allowTabDeactivation: allowTabDeactivation, children: children, id: id, onTabChange: onTabChange, variant: variant, color: color, className: className, unstyled: unstyled, classNames: classNames, styles: styles, radius: radius, inverted: inverted, keepMounted: keepMounted, placement: placement } = _a, others = $d099154c683f97e2$var$__objRest(_a, [
        "defaultValue",
        "value",
        "orientation",
        "loop",
        "activateTabWithKeyboard",
        "allowTabDeactivation",
        "children",
        "id",
        "onTabChange",
        "variant",
        "color",
        "className",
        "unstyled",
        "classNames",
        "styles",
        "radius",
        "inverted",
        "keepMounted",
        "placement"
    ]);
    const { classes: classes, cx: cx } = (0, $3xPdu.default)({
        orientation: orientation,
        color: color,
        radius: radius,
        inverted: inverted,
        placement: placement
    }, {
        unstyled: unstyled,
        name: "Tabs",
        classNames: classNames,
        styles: styles,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c64rN.TabsProvider), {
        activateTabWithKeyboard: activateTabWithKeyboard,
        defaultValue: defaultValue,
        orientation: orientation,
        onTabChange: onTabChange,
        value: value,
        id: id,
        loop: loop,
        allowTabDeactivation: allowTabDeactivation,
        color: color,
        variant: variant,
        radius: radius,
        inverted: inverted,
        keepMounted: keepMounted,
        placement: placement,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $d099154c683f97e2$var$__spreadProps($d099154c683f97e2$var$__spreadValues({}, others), {
        className: cx(classes.root, className),
        id: id,
        ref: ref
    }), children));
});
$d099154c683f97e2$export$b2539bed5023c21c.List = (0, $9gcRm.TabsList);
$d099154c683f97e2$export$b2539bed5023c21c.Tab = (0, $5woXG.Tab);
$d099154c683f97e2$export$b2539bed5023c21c.Panel = (0, $8N0dG.TabsPanel);
$d099154c683f97e2$export$b2539bed5023c21c.displayName = "@mantine/core/Tabs";

});
parcelRegister("9gcRm", function(module, exports) {

$parcel$export(module.exports, "TabsList", () => $6bdf9559f6975b2b$export$9712d22edc0d78c1);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $lCupo = parcelRequire("lCupo");

var $lfogI = parcelRequire("lfogI");

var $hiiR1 = parcelRequire("hiiR1");
var $6bdf9559f6975b2b$var$__defProp = Object.defineProperty;
var $6bdf9559f6975b2b$var$__defProps = Object.defineProperties;
var $6bdf9559f6975b2b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $6bdf9559f6975b2b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $6bdf9559f6975b2b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6bdf9559f6975b2b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $6bdf9559f6975b2b$var$__defNormalProp = (obj, key, value)=>key in obj ? $6bdf9559f6975b2b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $6bdf9559f6975b2b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($6bdf9559f6975b2b$var$__hasOwnProp.call(b, prop)) $6bdf9559f6975b2b$var$__defNormalProp(a, prop, b[prop]);
    if ($6bdf9559f6975b2b$var$__getOwnPropSymbols) {
        for (var prop of $6bdf9559f6975b2b$var$__getOwnPropSymbols(b))if ($6bdf9559f6975b2b$var$__propIsEnum.call(b, prop)) $6bdf9559f6975b2b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $6bdf9559f6975b2b$var$__spreadProps = (a, b)=>$6bdf9559f6975b2b$var$__defProps(a, $6bdf9559f6975b2b$var$__getOwnPropDescs(b));
var $6bdf9559f6975b2b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($6bdf9559f6975b2b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $6bdf9559f6975b2b$var$__getOwnPropSymbols) {
        for (var prop of $6bdf9559f6975b2b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $6bdf9559f6975b2b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $6bdf9559f6975b2b$var$defaultProps = {
    grow: false,
    position: "left"
};
const $6bdf9559f6975b2b$export$9712d22edc0d78c1 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("TabsList", $6bdf9559f6975b2b$var$defaultProps, props), { children: children, className: className, grow: grow, position: position } = _a, others = $6bdf9559f6975b2b$var$__objRest(_a, [
        "children",
        "className",
        "grow",
        "position"
    ]);
    const { orientation: orientation, variant: variant, color: color, radius: radius, inverted: inverted, placement: placement, classNames: classNames, styles: styles, unstyled: unstyled } = (0, $lCupo.useTabsContext)();
    const { classes: classes, cx: cx } = (0, $lfogI.default)({
        orientation: orientation,
        grow: grow,
        color: color,
        position: position,
        radius: radius,
        inverted: inverted,
        placement: placement
    }, {
        name: "Tabs",
        unstyled: unstyled,
        classNames: classNames,
        styles: styles,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $6bdf9559f6975b2b$var$__spreadProps($6bdf9559f6975b2b$var$__spreadValues({}, others), {
        className: cx(classes.tabsList, className),
        ref: ref,
        role: "tablist",
        "aria-orientation": orientation
    }), children);
});
$6bdf9559f6975b2b$export$9712d22edc0d78c1.displayName = "@mantine/core/TabsList";

});
parcelRegister("lCupo", function(module, exports) {

$parcel$export(module.exports, "TabsContextProvider", () => $fbd4bc11e52ba9d1$export$4e8dfaf499804552);
$parcel$export(module.exports, "useTabsContext", () => $fbd4bc11e52ba9d1$export$5c3d36c3adf0ba92);

var $jIWSq = parcelRequire("jIWSq");

var $6qtoW = parcelRequire("6qtoW");
const [$fbd4bc11e52ba9d1$export$4e8dfaf499804552, $fbd4bc11e52ba9d1$export$5c3d36c3adf0ba92] = (0, $jIWSq.createSafeContext)((0, $6qtoW.TABS_ERRORS).context);

});
parcelRegister("6qtoW", function(module, exports) {

$parcel$export(module.exports, "TABS_ERRORS", () => $4adbfa41a88cb230$export$8e45eb43401e6f15);
const $4adbfa41a88cb230$export$8e45eb43401e6f15 = {
    context: "Tabs component was not found in the tree",
    value: "Tabs.Tab or Tabs.Panel component was rendered with invalid value or without value"
};

});


parcelRegister("lfogI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f77dd2ee654f87ba$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");

var $9vT0L = parcelRequire("9vT0L");
var $f77dd2ee654f87ba$var$__defProp = Object.defineProperty;
var $f77dd2ee654f87ba$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f77dd2ee654f87ba$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f77dd2ee654f87ba$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f77dd2ee654f87ba$var$__defNormalProp = (obj, key, value)=>key in obj ? $f77dd2ee654f87ba$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f77dd2ee654f87ba$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f77dd2ee654f87ba$var$__hasOwnProp.call(b, prop)) $f77dd2ee654f87ba$var$__defNormalProp(a, prop, b[prop]);
    if ($f77dd2ee654f87ba$var$__getOwnPropSymbols) {
        for (var prop of $f77dd2ee654f87ba$var$__getOwnPropSymbols(b))if ($f77dd2ee654f87ba$var$__propIsEnum.call(b, prop)) $f77dd2ee654f87ba$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $f77dd2ee654f87ba$var$getVariantStyles({ orientation: orientation, inverted: inverted, placement: placement }, theme, variant) {
    const vertical = orientation === "vertical";
    if (variant === "default") return {
        [vertical ? placement === "left" ? "borderRight" : "borderLeft" : inverted ? "borderTop" : "borderBottom"]: `${(0, $2jkdX.rem)(2)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`
    };
    if (variant === "outline") return {
        [vertical ? placement === "left" ? "borderRight" : "borderLeft" : inverted ? "borderTop" : "borderBottom"]: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`
    };
    if (variant === "pills") return {
        gap: `calc(${theme.spacing.sm} / 2)`
    };
    return {};
}
var $f77dd2ee654f87ba$var$useStyles = (0, $cQG1Y.createStyles)((theme, params, { variant: variant })=>{
    const vertical = params.orientation === "vertical";
    return {
        tabsList: $f77dd2ee654f87ba$var$__spreadValues({
            display: "flex",
            flexWrap: "wrap",
            flexDirection: vertical ? "column" : "row",
            justifyContent: (0, $9vT0L.GROUP_POSITIONS)[params.position],
            '& [role="tab"]': {
                flex: params.grow ? 1 : void 0
            }
        }, $f77dd2ee654f87ba$var$getVariantStyles(params, theme, variant))
    };
});
var $f77dd2ee654f87ba$export$2e2bcd8739ae039 = $f77dd2ee654f87ba$var$useStyles;

});


parcelRegister("8N0dG", function(module, exports) {

$parcel$export(module.exports, "TabsPanel", () => $666311f8ba09849b$export$9128fd9f25f0e0ae);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $g71zw = parcelRequire("g71zw");

var $lCupo = parcelRequire("lCupo");

var $95SPp = parcelRequire("95SPp");

var $hiiR1 = parcelRequire("hiiR1");
var $666311f8ba09849b$var$__defProp = Object.defineProperty;
var $666311f8ba09849b$var$__defProps = Object.defineProperties;
var $666311f8ba09849b$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $666311f8ba09849b$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $666311f8ba09849b$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $666311f8ba09849b$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $666311f8ba09849b$var$__defNormalProp = (obj, key, value)=>key in obj ? $666311f8ba09849b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $666311f8ba09849b$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($666311f8ba09849b$var$__hasOwnProp.call(b, prop)) $666311f8ba09849b$var$__defNormalProp(a, prop, b[prop]);
    if ($666311f8ba09849b$var$__getOwnPropSymbols) {
        for (var prop of $666311f8ba09849b$var$__getOwnPropSymbols(b))if ($666311f8ba09849b$var$__propIsEnum.call(b, prop)) $666311f8ba09849b$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $666311f8ba09849b$var$__spreadProps = (a, b)=>$666311f8ba09849b$var$__defProps(a, $666311f8ba09849b$var$__getOwnPropDescs(b));
var $666311f8ba09849b$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($666311f8ba09849b$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $666311f8ba09849b$var$__getOwnPropSymbols) {
        for (var prop of $666311f8ba09849b$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $666311f8ba09849b$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $666311f8ba09849b$var$defaultProps = {};
const $666311f8ba09849b$export$9128fd9f25f0e0ae = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("TabsPanel", $666311f8ba09849b$var$defaultProps, props), { value: value, children: children, sx: sx, className: className } = _a, others = $666311f8ba09849b$var$__objRest(_a, [
        "value",
        "children",
        "sx",
        "className"
    ]);
    const ctx = (0, $lCupo.useTabsContext)();
    const { classes: classes, cx: cx } = (0, $95SPp.default)({
        orientation: ctx.orientation,
        color: ctx.color,
        radius: ctx.radius,
        inverted: ctx.inverted,
        placement: ctx.placement
    }, {
        name: "Tabs",
        unstyled: ctx.unstyled,
        classNames: ctx.classNames,
        styles: ctx.styles,
        variant: ctx.variant
    });
    const panelId = ctx.getPanelId(value);
    const active = ctx.value === value;
    const content = ctx.keepMounted ? children : active ? children : null;
    (0, $acw62.useEffect)(()=>{
        ctx.setMountedPanelIds((prev)=>[
                ...prev,
                panelId
            ]);
        return ctx.setMountedPanelIds((prev)=>prev.filter((id)=>id !== panelId));
    }, [
        panelId
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $666311f8ba09849b$var$__spreadProps($666311f8ba09849b$var$__spreadValues({}, others), {
        ref: ref,
        sx: [
            {
                display: !active ? "none" : void 0
            },
            ...(0, $g71zw.packSx)(sx)
        ],
        className: cx(classes.panel, className),
        role: "tabpanel",
        id: panelId,
        "aria-labelledby": ctx.getTabId(value)
    }), content);
});
$666311f8ba09849b$export$9128fd9f25f0e0ae.displayName = "@mantine/core/TabsPanel";

});
parcelRegister("95SPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $69ef1c6701b18566$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $69ef1c6701b18566$var$useStyles = (0, $cQG1Y.createStyles)((_theme, { orientation: orientation })=>({
        panel: {
            flex: orientation === "vertical" ? 1 : void 0
        }
    }));
var $69ef1c6701b18566$export$2e2bcd8739ae039 = $69ef1c6701b18566$var$useStyles;

});


parcelRegister("5woXG", function(module, exports) {

$parcel$export(module.exports, "Tab", () => $40534dc304c40d6f$export$3e41faf802a29e71);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $j7bHu = parcelRequire("j7bHu");

var $lCupo = parcelRequire("lCupo");

var $hgJ5o = parcelRequire("hgJ5o");

var $5etRf = parcelRequire("5etRf");
var $40534dc304c40d6f$var$__defProp = Object.defineProperty;
var $40534dc304c40d6f$var$__defProps = Object.defineProperties;
var $40534dc304c40d6f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $40534dc304c40d6f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $40534dc304c40d6f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $40534dc304c40d6f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $40534dc304c40d6f$var$__defNormalProp = (obj, key, value)=>key in obj ? $40534dc304c40d6f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $40534dc304c40d6f$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($40534dc304c40d6f$var$__hasOwnProp.call(b, prop)) $40534dc304c40d6f$var$__defNormalProp(a, prop, b[prop]);
    if ($40534dc304c40d6f$var$__getOwnPropSymbols) {
        for (var prop of $40534dc304c40d6f$var$__getOwnPropSymbols(b))if ($40534dc304c40d6f$var$__propIsEnum.call(b, prop)) $40534dc304c40d6f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $40534dc304c40d6f$var$__spreadProps = (a, b)=>$40534dc304c40d6f$var$__defProps(a, $40534dc304c40d6f$var$__getOwnPropDescs(b));
var $40534dc304c40d6f$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($40534dc304c40d6f$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $40534dc304c40d6f$var$__getOwnPropSymbols) {
        for (var prop of $40534dc304c40d6f$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $40534dc304c40d6f$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $40534dc304c40d6f$var$defaultProps = {};
const $40534dc304c40d6f$export$3e41faf802a29e71 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("TabsTab", $40534dc304c40d6f$var$defaultProps, props), { value: value, children: children, onKeyDown: onKeyDown, onClick: onClick, className: className, icon: icon, rightSection: rightSection, color: color } = _a, others = $40534dc304c40d6f$var$__objRest(_a, [
        "value",
        "children",
        "onKeyDown",
        "onClick",
        "className",
        "icon",
        "rightSection",
        "color"
    ]);
    const ctx = (0, $lCupo.useTabsContext)();
    const hasIcon = !!icon;
    const hasRightSection = !!rightSection;
    const { theme: theme, classes: classes, cx: cx } = (0, $hgJ5o.default)({
        withIcon: hasIcon || hasRightSection && !children,
        withRightSection: hasRightSection || hasIcon && !children,
        orientation: ctx.orientation,
        color: color || ctx.color,
        radius: ctx.radius,
        inverted: ctx.inverted,
        placement: ctx.placement
    }, {
        name: "Tabs",
        unstyled: ctx.unstyled,
        classNames: ctx.classNames,
        styles: ctx.styles,
        variant: ctx.variant
    });
    const isActive = value === ctx.value;
    const panelId = ctx.getPanelId(value);
    const ariaControls = ctx.mountedPanelIds.includes(value) ? panelId : void 0;
    const activateTab = (event)=>{
        ctx.onTabChange(ctx.allowTabDeactivation ? value === ctx.value ? null : value : value);
        onClick == null || onClick(event);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $40534dc304c40d6f$var$__spreadProps($40534dc304c40d6f$var$__spreadValues({}, others), {
        unstyled: ctx.unstyled,
        className: cx(classes.tab, className),
        "data-active": isActive || void 0,
        ref: ref,
        type: "button",
        role: "tab",
        id: ctx.getTabId(value),
        "aria-selected": isActive,
        tabIndex: isActive || ctx.value === null ? 0 : -1,
        "aria-controls": ariaControls,
        onClick: activateTab,
        onKeyDown: (0, $j7bHu.createScopedKeydownHandler)({
            siblingSelector: '[role="tab"]',
            parentSelector: '[role="tablist"]',
            activateOnFocus: ctx.activateTabWithKeyboard,
            loop: ctx.loop,
            dir: theme.dir,
            orientation: ctx.orientation,
            onKeyDown: onKeyDown
        })
    }), icon && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.tabIcon
    }, icon), children && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.tabLabel
    }, children), rightSection && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: classes.tabRightSection
    }, rightSection));
});
$40534dc304c40d6f$export$3e41faf802a29e71.displayName = "@mantine/core/Tab";

});
parcelRegister("hgJ5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $c926e76d25a8f07a$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $c926e76d25a8f07a$var$__defProp = Object.defineProperty;
var $c926e76d25a8f07a$var$__defProps = Object.defineProperties;
var $c926e76d25a8f07a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c926e76d25a8f07a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c926e76d25a8f07a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c926e76d25a8f07a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c926e76d25a8f07a$var$__defNormalProp = (obj, key, value)=>key in obj ? $c926e76d25a8f07a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c926e76d25a8f07a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c926e76d25a8f07a$var$__hasOwnProp.call(b, prop)) $c926e76d25a8f07a$var$__defNormalProp(a, prop, b[prop]);
    if ($c926e76d25a8f07a$var$__getOwnPropSymbols) {
        for (var prop of $c926e76d25a8f07a$var$__getOwnPropSymbols(b))if ($c926e76d25a8f07a$var$__propIsEnum.call(b, prop)) $c926e76d25a8f07a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c926e76d25a8f07a$var$__spreadProps = (a, b)=>$c926e76d25a8f07a$var$__defProps(a, $c926e76d25a8f07a$var$__getOwnPropDescs(b));
function $c926e76d25a8f07a$var$getVariantStyles(theme, { orientation: orientation, color: color, radius: radius, inverted: inverted, placement: placement }, variant) {
    const vertical = orientation === "vertical";
    const filledScheme = theme.fn.variant({
        color: color,
        variant: "filled"
    });
    const radiusValue = (0, $2jkdX.rem)(theme.fn.radius(radius));
    const borderRadius = orientation === "vertical" ? placement === "left" ? `${radiusValue} 0 0 ${radiusValue}` : ` 0 ${radiusValue} ${radiusValue} 0` : inverted ? `0 0 ${radiusValue} ${radiusValue}` : `${radiusValue} ${radiusValue} 0 0`;
    if (variant === "default") return $c926e76d25a8f07a$var$__spreadProps($c926e76d25a8f07a$var$__spreadValues({
        [vertical ? placement === "left" ? "borderRight" : "borderLeft" : inverted ? "borderTop" : "borderBottom"]: `${(0, $2jkdX.rem)(2)} solid transparent`,
        [vertical ? placement === "left" ? "marginRight" : "marginLeft" : inverted ? "marginTop" : "marginBottom"]: (0, $2jkdX.rem)(-2),
        borderRadius: borderRadius
    }, theme.fn.hover({
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0],
        borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
    })), {
        "&[data-active]": $c926e76d25a8f07a$var$__spreadValues({
            borderColor: filledScheme.background,
            color: theme.colorScheme === "dark" ? theme.white : theme.black
        }, theme.fn.hover({
            borderColor: filledScheme.background
        }))
    });
    if (variant === "outline") return {
        borderRadius: borderRadius,
        border: `${(0, $2jkdX.rem)(1)} solid transparent`,
        [vertical ? placement === "left" ? "borderRight" : "borderLeft" : inverted ? "borderTop" : "borderBottom"]: "none",
        "&[data-active]": {
            borderColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
            "&::before": {
                content: '""',
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
                position: "absolute",
                bottom: vertical ? 0 : inverted ? "unset" : (0, $2jkdX.rem)(-1),
                top: vertical ? 0 : inverted ? (0, $2jkdX.rem)(-1) : "unset",
                [vertical ? "width" : "height"]: (0, $2jkdX.rem)(1),
                right: vertical ? placement === "left" ? (0, $2jkdX.rem)(-1) : "unset" : 0,
                left: vertical ? placement === "left" ? "unset" : (0, $2jkdX.rem)(-1) : 0
            }
        }
    };
    if (variant === "pills") return $c926e76d25a8f07a$var$__spreadProps($c926e76d25a8f07a$var$__spreadValues({
        borderRadius: theme.fn.radius(radius)
    }, theme.fn.hover({
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
    })), {
        "&[data-active]": $c926e76d25a8f07a$var$__spreadValues({
            backgroundColor: filledScheme.background,
            color: theme.white
        }, theme.fn.hover({
            backgroundColor: filledScheme.background
        }))
    });
    return {};
}
var $c926e76d25a8f07a$var$useStyles = (0, $cQG1Y.createStyles)((theme, params, { variant: variant })=>({
        tabLabel: {},
        tab: $c926e76d25a8f07a$var$__spreadValues({
            position: "relative",
            padding: `${theme.spacing.xs} ${theme.spacing.md}`,
            paddingLeft: params.withIcon ? theme.spacing.xs : void 0,
            paddingRight: params.withRightSection ? theme.spacing.xs : void 0,
            fontSize: theme.fontSizes.sm,
            whiteSpace: "nowrap",
            zIndex: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: params.orientation === "horizontal" ? "center" : void 0,
            lineHeight: 1,
            "&:disabled": $c926e76d25a8f07a$var$__spreadValues({
                opacity: 0.5,
                cursor: "not-allowed"
            }, theme.fn.hover({
                backgroundColor: "transparent"
            })),
            "&:focus": {
                zIndex: 1
            }
        }, $c926e76d25a8f07a$var$getVariantStyles(theme, params, variant)),
        tabRightSection: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:not(:only-child)": {
                marginLeft: (0, $2jkdX.rem)(7)
            }
        },
        tabIcon: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "&:not(:only-child)": {
                marginRight: (0, $2jkdX.rem)(7)
            }
        }
    }));
var $c926e76d25a8f07a$export$2e2bcd8739ae039 = $c926e76d25a8f07a$var$useStyles;

});


parcelRegister("c64rN", function(module, exports) {

$parcel$export(module.exports, "TabsProvider", () => $8ce97eb525260e01$export$aea4e5437b3b752e);

var $acw62 = parcelRequire("acw62");

var $b8Evx = parcelRequire("b8Evx");

var $8nBd8 = parcelRequire("8nBd8");
var $ke4gU = parcelRequire("ke4gU");

var $lCupo = parcelRequire("lCupo");

var $6qtoW = parcelRequire("6qtoW");
function $8ce97eb525260e01$export$aea4e5437b3b752e({ defaultValue: defaultValue, value: value, onTabChange: onTabChange, orientation: orientation, children: children, loop: loop, id: id, activateTabWithKeyboard: activateTabWithKeyboard, allowTabDeactivation: allowTabDeactivation, variant: variant, color: color, radius: radius, inverted: inverted, placement: placement, keepMounted: keepMounted = true, classNames: classNames, styles: styles, unstyled: unstyled }) {
    const uid = (0, $8nBd8.useId)(id);
    const [mountedPanelIds, setMountedPanelIds] = (0, $acw62.useState)([]);
    const [_value, onChange] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onTabChange
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lCupo.TabsContextProvider), {
        value: {
            placement: placement,
            value: _value,
            orientation: orientation,
            id: uid,
            loop: loop,
            activateTabWithKeyboard: activateTabWithKeyboard,
            getTabId: (0, $b8Evx.getSafeId)(`${uid}-tab`, (0, $6qtoW.TABS_ERRORS).value),
            getPanelId: (0, $b8Evx.getSafeId)(`${uid}-panel`, (0, $6qtoW.TABS_ERRORS).value),
            onTabChange: onChange,
            setMountedPanelIds: setMountedPanelIds,
            mountedPanelIds: mountedPanelIds,
            allowTabDeactivation: allowTabDeactivation,
            variant: variant,
            color: color,
            radius: radius,
            inverted: inverted,
            keepMounted: keepMounted,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled
        }
    }, children);
}
$8ce97eb525260e01$export$aea4e5437b3b752e.displayName = "@mantine/core/TabsProvider";

});

parcelRegister("3xPdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $294c2ebb09418a1f$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $294c2ebb09418a1f$var$useStyles = (0, $cQG1Y.createStyles)((_theme, { orientation: orientation, placement: placement })=>({
        root: {
            display: orientation === "vertical" ? "flex" : void 0,
            flexDirection: placement === "right" ? "row-reverse" : "row"
        }
    }));
var $294c2ebb09418a1f$export$2e2bcd8739ae039 = $294c2ebb09418a1f$var$useStyles;

});


parcelRegister("dSMvY", function(module, exports) {

$parcel$export(module.exports, "Textarea", () => $a1b5f3849344e8e8$export$379139ebc1c2b235);

var $acw62 = parcelRequire("acw62");

var $c7dmf = parcelRequire("c7dmf");

var $8nBd8 = parcelRequire("8nBd8");

var $64A2P = parcelRequire("64A2P");

var $aKg1z = parcelRequire("aKg1z");

var $aEkmw = parcelRequire("aEkmw");

var $gw63X = parcelRequire("gw63X");
var $a1b5f3849344e8e8$var$__defProp = Object.defineProperty;
var $a1b5f3849344e8e8$var$__defProps = Object.defineProperties;
var $a1b5f3849344e8e8$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a1b5f3849344e8e8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a1b5f3849344e8e8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a1b5f3849344e8e8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a1b5f3849344e8e8$var$__defNormalProp = (obj, key, value)=>key in obj ? $a1b5f3849344e8e8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a1b5f3849344e8e8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a1b5f3849344e8e8$var$__hasOwnProp.call(b, prop)) $a1b5f3849344e8e8$var$__defNormalProp(a, prop, b[prop]);
    if ($a1b5f3849344e8e8$var$__getOwnPropSymbols) {
        for (var prop of $a1b5f3849344e8e8$var$__getOwnPropSymbols(b))if ($a1b5f3849344e8e8$var$__propIsEnum.call(b, prop)) $a1b5f3849344e8e8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a1b5f3849344e8e8$var$__spreadProps = (a, b)=>$a1b5f3849344e8e8$var$__defProps(a, $a1b5f3849344e8e8$var$__getOwnPropDescs(b));
var $a1b5f3849344e8e8$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a1b5f3849344e8e8$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a1b5f3849344e8e8$var$__getOwnPropSymbols) {
        for (var prop of $a1b5f3849344e8e8$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a1b5f3849344e8e8$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a1b5f3849344e8e8$var$defaultProps = {
    autosize: false,
    size: "sm",
    __staticSelector: "Textarea"
};
const $a1b5f3849344e8e8$export$379139ebc1c2b235 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Textarea", $a1b5f3849344e8e8$var$defaultProps, props), { autosize: autosize, maxRows: maxRows, minRows: minRows, label: label, error: error, description: description, id: id, className: className, required: required, style: style, wrapperProps: wrapperProps, classNames: classNames, styles: styles, size: size, __staticSelector: __staticSelector, sx: sx, errorProps: errorProps, descriptionProps: descriptionProps, labelProps: labelProps, inputWrapperOrder: inputWrapperOrder, inputContainer: inputContainer, unstyled: unstyled, withAsterisk: withAsterisk, variant: variant } = _a, others = $a1b5f3849344e8e8$var$__objRest(_a, [
        "autosize",
        "maxRows",
        "minRows",
        "label",
        "error",
        "description",
        "id",
        "className",
        "required",
        "style",
        "wrapperProps",
        "classNames",
        "styles",
        "size",
        "__staticSelector",
        "sx",
        "errorProps",
        "descriptionProps",
        "labelProps",
        "inputWrapperOrder",
        "inputContainer",
        "unstyled",
        "withAsterisk",
        "variant"
    ]);
    const uuid = (0, $8nBd8.useId)(id);
    const { classes: classes, cx: cx } = (0, $aKg1z.default)();
    const { systemStyles: systemStyles, rest: rest } = (0, $aEkmw.extractSystemStyles)(others);
    const sharedProps = $a1b5f3849344e8e8$var$__spreadValues({
        required: required,
        ref: ref,
        error: error,
        id: uuid,
        classNames: $a1b5f3849344e8e8$var$__spreadProps($a1b5f3849344e8e8$var$__spreadValues({}, classNames), {
            input: cx(classes.input, classNames == null ? void 0 : classNames.input)
        }),
        styles: styles,
        __staticSelector: __staticSelector,
        size: size,
        multiline: true,
        unstyled: unstyled,
        variant: variant
    }, rest);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $a1b5f3849344e8e8$var$__spreadValues($a1b5f3849344e8e8$var$__spreadValues({
        label: label,
        error: error,
        id: uuid,
        description: description,
        required: required,
        style: style,
        className: className,
        classNames: classNames,
        styles: styles,
        size: size,
        __staticSelector: __staticSelector,
        sx: sx,
        errorProps: errorProps,
        labelProps: labelProps,
        descriptionProps: descriptionProps,
        inputContainer: inputContainer,
        inputWrapperOrder: inputWrapperOrder,
        unstyled: unstyled,
        withAsterisk: withAsterisk,
        variant: variant
    }, systemStyles), wrapperProps), autosize ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), $a1b5f3849344e8e8$var$__spreadProps($a1b5f3849344e8e8$var$__spreadValues({}, sharedProps), {
        component: (0, $c7dmf.default),
        maxRows: maxRows,
        minRows: minRows
    })) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), $a1b5f3849344e8e8$var$__spreadProps($a1b5f3849344e8e8$var$__spreadValues({}, sharedProps), {
        component: "textarea",
        rows: minRows
    })));
});
$a1b5f3849344e8e8$export$379139ebc1c2b235.displayName = "@mantine/core/Textarea";

});
parcelRegister("c7dmf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d208011843bf7ea$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $4RFf4 = parcelRequire("4RFf4");

var $aaas5 = parcelRequire("aaas5");
var $8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE = {
    'min-height': '0',
    'max-height': 'none',
    height: '0',
    visibility: 'hidden',
    overflow: 'hidden',
    position: 'absolute',
    'z-index': '-1000',
    top: '0',
    right: '0'
};
var $8d208011843bf7ea$var$forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys($8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, $8d208011843bf7ea$var$HIDDEN_TEXTAREA_STYLE[key], 'important');
    });
};
//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259
var $8d208011843bf7ea$var$hiddenTextarea = null;
var $8d208011843bf7ea$var$getHeight = function getHeight(node, sizingData) {
    var height = node.scrollHeight;
    if (sizingData.sizingStyle.boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
     // remove padding, since height = content
    return height - sizingData.paddingSize;
};
function $8d208011843bf7ea$var$calculateNodeHeight(sizingData, value, minRows, maxRows) {
    if (minRows === void 0) minRows = 1;
    if (maxRows === void 0) maxRows = Infinity;
    if (!$8d208011843bf7ea$var$hiddenTextarea) {
        $8d208011843bf7ea$var$hiddenTextarea = document.createElement('textarea');
        $8d208011843bf7ea$var$hiddenTextarea.setAttribute('tabindex', '-1');
        $8d208011843bf7ea$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        $8d208011843bf7ea$var$forceHiddenStyles($8d208011843bf7ea$var$hiddenTextarea);
    }
    if ($8d208011843bf7ea$var$hiddenTextarea.parentNode === null) document.body.appendChild($8d208011843bf7ea$var$hiddenTextarea);
    var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
    var boxSizing = sizingStyle.boxSizing;
    Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        $8d208011843bf7ea$var$hiddenTextarea.style[key] = sizingStyle[key];
    });
    $8d208011843bf7ea$var$forceHiddenStyles($8d208011843bf7ea$var$hiddenTextarea);
    $8d208011843bf7ea$var$hiddenTextarea.value = value;
    var height = $8d208011843bf7ea$var$getHeight($8d208011843bf7ea$var$hiddenTextarea, sizingData); // measure height of a textarea with a single row
    $8d208011843bf7ea$var$hiddenTextarea.value = 'x';
    var rowHeight = $8d208011843bf7ea$var$hiddenTextarea.scrollHeight - paddingSize;
    var minHeight = rowHeight * minRows;
    if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
    height = Math.max(minHeight, height);
    var maxHeight = rowHeight * maxRows;
    if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
    return [
        height,
        rowHeight
    ];
}
var $8d208011843bf7ea$var$noop = function noop() {};
var $8d208011843bf7ea$var$pick = function pick(props, obj) {
    return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
var $8d208011843bf7ea$var$SIZING_STYLE = [
    'borderBottomWidth',
    'borderLeftWidth',
    'borderRightWidth',
    'borderTopWidth',
    'boxSizing',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'letterSpacing',
    'lineHeight',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'tabSize',
    'textIndent',
    'textRendering',
    'textTransform',
    'width',
    'wordBreak'
];
var $8d208011843bf7ea$var$isIE = !!document.documentElement.currentStyle;
var $8d208011843bf7ea$var$getSizingData = function getSizingData(node) {
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = $8d208011843bf7ea$var$pick($8d208011843bf7ea$var$SIZING_STYLE, style);
    var boxSizing = sizingStyle.boxSizing; // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === '') return null;
     // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if ($8d208011843bf7ea$var$isIE && boxSizing === 'border-box') sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
    var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
    var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize
    };
};
var $8d208011843bf7ea$var$useWindowResizeListener = function useWindowResizeListener(listener) {
    var latestListener = (0, $4RFf4.default)(listener);
    (0, $acw62.useLayoutEffect)(function() {
        var handler = function handler(event) {
            latestListener.current(event);
        };
        window.addEventListener('resize', handler);
        return function() {
            window.removeEventListener('resize', handler);
        };
    }, []);
};
var $8d208011843bf7ea$var$TextareaAutosize = function TextareaAutosize(_ref, userRef) {
    var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? $8d208011843bf7ea$var$noop : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? $8d208011843bf7ea$var$noop : _ref$onHeightChange, props = (0, $1En50.default)(_ref, [
        "cacheMeasurements",
        "maxRows",
        "minRows",
        "onChange",
        "onHeightChange"
    ]);
    var isControlled = props.value !== undefined;
    var libRef = (0, $acw62.useRef)(null);
    var ref = (0, $aaas5.default)(libRef, userRef);
    var heightRef = (0, $acw62.useRef)(0);
    var measurementsCacheRef = (0, $acw62.useRef)();
    var resizeTextarea = function resizeTextarea() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : $8d208011843bf7ea$var$getSizingData(node);
        if (!nodeSizingData) return;
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = $8d208011843bf7ea$var$calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
            heightRef.current = height;
            node.style.setProperty('height', height + "px", 'important');
            onHeightChange(height, {
                rowHeight: rowHeight
            });
        }
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) resizeTextarea();
        onChange(event);
    };
    (0, $acw62.useLayoutEffect)(resizeTextarea);
    $8d208011843bf7ea$var$useWindowResizeListener(resizeTextarea);
    return /*#__PURE__*/ (0, $acw62.createElement)("textarea", (0, $8nd05.default)({}, props, {
        onChange: handleChange,
        ref: ref
    }));
};
var $8d208011843bf7ea$var$index = /* #__PURE__ */ (0, $acw62.forwardRef)($8d208011843bf7ea$var$TextareaAutosize);
var $8d208011843bf7ea$export$2e2bcd8739ae039 = $8d208011843bf7ea$var$index;

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("4RFf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $38ac1a7b92ec1912$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $jLbqB = parcelRequire("jLbqB");
var $38ac1a7b92ec1912$export$2e2bcd8739ae039 = function useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    (0, $jLbqB.default)(function() {
        ref.current = value;
    });
    return ref;
};

});
parcelRegister("jLbqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62b4578a0a2b358$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $e62b4578a0a2b358$export$2e2bcd8739ae039 = (0, $acw62.useLayoutEffect);

});


parcelRegister("aaas5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7662f217721ef745$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
// basically Exclude<React.ClassAttributes<T>["ref"], string>
var $7662f217721ef745$var$updateRef = function updateRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    ref.current = value;
};
var $7662f217721ef745$export$2e2bcd8739ae039 = function useComposedRef(libRef, userRef) {
    var prevUserRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) $7662f217721ef745$var$updateRef(prevUserRef.current, null);
        prevUserRef.current = userRef;
        if (!userRef) return;
        $7662f217721ef745$var$updateRef(userRef, instance);
    }, [
        userRef
    ]);
};

});


parcelRegister("aKg1z", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2aa15732624c3a$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $7d2aa15732624c3a$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        input: {
            paddingTop: theme.spacing.xs,
            paddingBottom: theme.spacing.xs
        }
    }));
var $7d2aa15732624c3a$export$2e2bcd8739ae039 = $7d2aa15732624c3a$var$useStyles;

});


parcelRegister("1Wgks", function(module, exports) {

$parcel$export(module.exports, "ThemeIcon", () => $1697dfd547878486$export$e905b311491f0211);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $c9Sue = parcelRequire("c9Sue");

var $hiiR1 = parcelRequire("hiiR1");
var $1697dfd547878486$var$__defProp = Object.defineProperty;
var $1697dfd547878486$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1697dfd547878486$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1697dfd547878486$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1697dfd547878486$var$__defNormalProp = (obj, key, value)=>key in obj ? $1697dfd547878486$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1697dfd547878486$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1697dfd547878486$var$__hasOwnProp.call(b, prop)) $1697dfd547878486$var$__defNormalProp(a, prop, b[prop]);
    if ($1697dfd547878486$var$__getOwnPropSymbols) {
        for (var prop of $1697dfd547878486$var$__getOwnPropSymbols(b))if ($1697dfd547878486$var$__propIsEnum.call(b, prop)) $1697dfd547878486$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1697dfd547878486$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1697dfd547878486$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1697dfd547878486$var$__getOwnPropSymbols) {
        for (var prop of $1697dfd547878486$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1697dfd547878486$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $1697dfd547878486$var$defaultProps = {
    size: "md",
    variant: "filled"
};
const $1697dfd547878486$export$e905b311491f0211 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("ThemeIcon", $1697dfd547878486$var$defaultProps, props), { className: className, size: size, radius: radius, variant: variant, color: color, children: children, gradient: gradient, unstyled: unstyled } = _a, others = $1697dfd547878486$var$__objRest(_a, [
        "className",
        "size",
        "radius",
        "variant",
        "color",
        "children",
        "gradient",
        "unstyled"
    ]);
    const { classes: classes, cx: cx } = (0, $c9Sue.default)({
        variant: variant,
        radius: radius,
        color: color,
        gradient: gradient
    }, {
        name: "ThemeIcon",
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $1697dfd547878486$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), children);
});
$1697dfd547878486$export$e905b311491f0211.displayName = "@mantine/core/ThemeIcon";

});
parcelRegister("c9Sue", function(module, exports) {

$parcel$export(module.exports, "default", () => $8da097313d265794$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $8da097313d265794$var$__defProp = Object.defineProperty;
var $8da097313d265794$var$__defProps = Object.defineProperties;
var $8da097313d265794$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8da097313d265794$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8da097313d265794$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8da097313d265794$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8da097313d265794$var$__defNormalProp = (obj, key, value)=>key in obj ? $8da097313d265794$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8da097313d265794$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8da097313d265794$var$__hasOwnProp.call(b, prop)) $8da097313d265794$var$__defNormalProp(a, prop, b[prop]);
    if ($8da097313d265794$var$__getOwnPropSymbols) {
        for (var prop of $8da097313d265794$var$__getOwnPropSymbols(b))if ($8da097313d265794$var$__propIsEnum.call(b, prop)) $8da097313d265794$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8da097313d265794$var$__spreadProps = (a, b)=>$8da097313d265794$var$__defProps(a, $8da097313d265794$var$__getOwnPropDescs(b));
const $8da097313d265794$var$sizes = {
    xs: (0, $2jkdX.rem)(16),
    sm: (0, $2jkdX.rem)(20),
    md: (0, $2jkdX.rem)(26),
    lg: (0, $2jkdX.rem)(32),
    xl: (0, $2jkdX.rem)(40)
};
const $8da097313d265794$var$THEME_ICON_VARIANTS = [
    "filled",
    "light",
    "gradient",
    "outline",
    "default"
];
function $8da097313d265794$var$getVariantStyles({ theme: theme, variant: variant, color: color, gradient: gradient }) {
    if (!$8da097313d265794$var$THEME_ICON_VARIANTS.includes(variant)) return null;
    const colors = theme.fn.variant({
        variant: variant,
        color: color || theme.primaryColor,
        gradient: gradient,
        primaryFallback: false
    });
    return {
        backgroundColor: colors.background,
        color: colors.color,
        backgroundImage: variant === "gradient" ? colors.background : void 0,
        border: `${(0, $2jkdX.rem)(variant === "gradient" ? 0 : 1)} solid ${colors.border}`
    };
}
var $8da097313d265794$var$useStyles = (0, $cQG1Y.createStyles)((theme, { color: color, radius: radius, gradient: gradient }, { variant: variant, size: size })=>{
    const iconSize = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $8da097313d265794$var$sizes
    });
    return {
        root: $8da097313d265794$var$__spreadValues($8da097313d265794$var$__spreadProps($8da097313d265794$var$__spreadValues({}, theme.fn.fontStyles()), {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            width: iconSize,
            height: iconSize,
            minWidth: iconSize,
            minHeight: iconSize,
            borderRadius: theme.fn.radius(radius)
        }), $8da097313d265794$var$getVariantStyles({
            theme: theme,
            variant: variant,
            gradient: gradient,
            color: color
        }))
    };
});
var $8da097313d265794$export$2e2bcd8739ae039 = $8da097313d265794$var$useStyles;

});


parcelRegister("ew26C", function(module, exports) {

$parcel$export(module.exports, "Title", () => $a915affe2ddace8d$export$f99233281efd08a0);

var $acw62 = parcelRequire("acw62");

var $64A2P = parcelRequire("64A2P");

var $6o3Pz = parcelRequire("6o3Pz");

var $cjohz = parcelRequire("cjohz");
var $a915affe2ddace8d$var$__defProp = Object.defineProperty;
var $a915affe2ddace8d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a915affe2ddace8d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a915affe2ddace8d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a915affe2ddace8d$var$__defNormalProp = (obj, key, value)=>key in obj ? $a915affe2ddace8d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a915affe2ddace8d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a915affe2ddace8d$var$__hasOwnProp.call(b, prop)) $a915affe2ddace8d$var$__defNormalProp(a, prop, b[prop]);
    if ($a915affe2ddace8d$var$__getOwnPropSymbols) {
        for (var prop of $a915affe2ddace8d$var$__getOwnPropSymbols(b))if ($a915affe2ddace8d$var$__propIsEnum.call(b, prop)) $a915affe2ddace8d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a915affe2ddace8d$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($a915affe2ddace8d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $a915affe2ddace8d$var$__getOwnPropSymbols) {
        for (var prop of $a915affe2ddace8d$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $a915affe2ddace8d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $a915affe2ddace8d$var$defaultProps = {
    order: 1
};
const $a915affe2ddace8d$export$f99233281efd08a0 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Title", $a915affe2ddace8d$var$defaultProps, props), { className: className, order: order, children: children, unstyled: unstyled, size: size, weight: weight, inline: inline, variant: variant } = _a, others = $a915affe2ddace8d$var$__objRest(_a, [
        "className",
        "order",
        "children",
        "unstyled",
        "size",
        "weight",
        "inline",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $6o3Pz.default)({
        element: `h${order}`,
        weight: weight,
        inline: inline
    }, {
        name: "Title",
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    if (![
        1,
        2,
        3,
        4,
        5,
        6
    ].includes(order)) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cjohz.Text), $a915affe2ddace8d$var$__spreadValues({
        variant: variant,
        component: `h${order}`,
        ref: ref,
        className: cx(classes.root, className)
    }, others), children);
});
$a915affe2ddace8d$export$f99233281efd08a0.displayName = "@mantine/core/Title";

});
parcelRegister("6o3Pz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a67f4b39458c478$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $4a67f4b39458c478$var$__defProp = Object.defineProperty;
var $4a67f4b39458c478$var$__defProps = Object.defineProperties;
var $4a67f4b39458c478$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4a67f4b39458c478$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4a67f4b39458c478$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4a67f4b39458c478$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4a67f4b39458c478$var$__defNormalProp = (obj, key, value)=>key in obj ? $4a67f4b39458c478$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4a67f4b39458c478$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4a67f4b39458c478$var$__hasOwnProp.call(b, prop)) $4a67f4b39458c478$var$__defNormalProp(a, prop, b[prop]);
    if ($4a67f4b39458c478$var$__getOwnPropSymbols) {
        for (var prop of $4a67f4b39458c478$var$__getOwnPropSymbols(b))if ($4a67f4b39458c478$var$__propIsEnum.call(b, prop)) $4a67f4b39458c478$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4a67f4b39458c478$var$__spreadProps = (a, b)=>$4a67f4b39458c478$var$__defProps(a, $4a67f4b39458c478$var$__getOwnPropDescs(b));
function $4a67f4b39458c478$var$getFontSize(size, element, theme) {
    if (typeof size !== "undefined") return size in theme.headings.sizes ? theme.headings.sizes[size].fontSize : (0, $2jkdX.rem)(size);
    return theme.headings.sizes[element].fontSize;
}
function $4a67f4b39458c478$var$getLineHeight(size, element, theme) {
    if (typeof size !== "undefined" && size in theme.headings.sizes) return theme.headings.sizes[size].lineHeight;
    return theme.headings.sizes[element].lineHeight;
}
var $4a67f4b39458c478$var$useStyles = (0, $cQG1Y.createStyles)((theme, { element: element, weight: weight, inline: inline }, { size: size })=>({
        root: $4a67f4b39458c478$var$__spreadProps($4a67f4b39458c478$var$__spreadValues({}, theme.fn.fontStyles()), {
            fontFamily: theme.headings.fontFamily,
            fontWeight: weight || theme.headings.sizes[element].fontWeight || theme.headings.fontWeight,
            fontSize: $4a67f4b39458c478$var$getFontSize(size, element, theme),
            lineHeight: inline ? 1 : $4a67f4b39458c478$var$getLineHeight(size, element, theme),
            margin: 0
        })
    }));
var $4a67f4b39458c478$export$2e2bcd8739ae039 = $4a67f4b39458c478$var$useStyles;

});


parcelRegister("1Eb18", function(module, exports) {

$parcel$export(module.exports, "hasLength", () => $133212b3e6fed70b$export$2c49e87647b3ca1b);
function $133212b3e6fed70b$var$isLengthValid(payload, value) {
    if (typeof payload === "number") return value.length === payload;
    const { max: max, min: min } = payload;
    let valid = true;
    if (typeof max === "number" && value.length > max) valid = false;
    if (typeof min === "number" && value.length < min) valid = false;
    return valid;
}
function $133212b3e6fed70b$export$2c49e87647b3ca1b(payload, error) {
    const _error = error || true;
    return (value)=>{
        if (typeof value === "string") return $133212b3e6fed70b$var$isLengthValid(payload, value.trim()) ? null : _error;
        if (typeof value === "object" && value !== null && "length" in value) return $133212b3e6fed70b$var$isLengthValid(payload, value) ? null : _error;
        return _error;
    };
}

});

parcelRegister("76pRr", function(module, exports) {

$parcel$export(module.exports, "isInRange", () => $52bd275e995143b7$export$6dabbcb26357acf4);
function $52bd275e995143b7$export$6dabbcb26357acf4({ min: min, max: max }, error) {
    const _error = error || true;
    return (value)=>{
        if (typeof value !== "number") return _error;
        let valid = true;
        if (typeof min === "number" && value < min) valid = false;
        if (typeof max === "number" && value > max) valid = false;
        return valid ? null : _error;
    };
}

});

parcelRegister("aKTxt", function(module, exports) {

$parcel$export(module.exports, "isNotEmpty", () => $7d49482607597f8b$export$a079a83b07f794bf);
function $7d49482607597f8b$export$a079a83b07f794bf(error) {
    const _error = error || true;
    return (value)=>{
        if (typeof value === "string") return value.trim().length > 0 ? null : _error;
        if (Array.isArray(value)) return value.length > 0 ? null : _error;
        if (value === null || value === void 0) return _error;
        if (value === false) return _error;
        return null;
    };
}

});

parcelRegister("loxEI", function(module, exports) {

$parcel$export(module.exports, "matches", () => $f935f22f90f46fb2$export$de994efd351b291c);
function $f935f22f90f46fb2$export$de994efd351b291c(regexp, error) {
    const _error = error || true;
    return (value)=>{
        if (typeof value !== "string") return _error;
        return regexp.test(value) ? null : _error;
    };
}

});

parcelRegister("8Qw8Z", function(module, exports) {

$parcel$export(module.exports, "matchesField", () => $670c1d2a8a036dd3$export$e217030ebc7027af);
function $670c1d2a8a036dd3$export$e217030ebc7027af(field, error) {
    const _error = error || true;
    return (value, values)=>{
        if (!values || !(field in values)) return _error;
        return value === values[field] ? null : _error;
    };
}

});

parcelRegister("ajdIG", function(module, exports) {

$parcel$export(module.exports, "useForm", () => $7816522e6538fc0c$export$87c0cf8eb5a167e0);

var $acw62 = parcelRequire("acw62");

var $7hFx0 = parcelRequire("7hFx0");

var $7hXgD = parcelRequire("7hXgD");

var $6PkQa = parcelRequire("6PkQa");

var $faDVo = parcelRequire("faDVo");

var $dNPCm = parcelRequire("dNPCm");

var $2bBXN = parcelRequire("2bBXN");

var $e5Llg = parcelRequire("e5Llg");

var $b1TVh = parcelRequire("b1TVh");

var $lLIFP = parcelRequire("lLIFP");

var $3hLCg = parcelRequire("3hLCg");

var $8MCSU = parcelRequire("8MCSU");

var $ibpMz = parcelRequire("ibpMz");

var $9x4CV = parcelRequire("9x4CV");

var $bz6rW = parcelRequire("bz6rW");

var $l3GFc = parcelRequire("l3GFc");
var $7816522e6538fc0c$var$__defProp = Object.defineProperty;
var $7816522e6538fc0c$var$__defProps = Object.defineProperties;
var $7816522e6538fc0c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $7816522e6538fc0c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $7816522e6538fc0c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $7816522e6538fc0c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $7816522e6538fc0c$var$__defNormalProp = (obj, key, value)=>key in obj ? $7816522e6538fc0c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7816522e6538fc0c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($7816522e6538fc0c$var$__hasOwnProp.call(b, prop)) $7816522e6538fc0c$var$__defNormalProp(a, prop, b[prop]);
    if ($7816522e6538fc0c$var$__getOwnPropSymbols) {
        for (var prop of $7816522e6538fc0c$var$__getOwnPropSymbols(b))if ($7816522e6538fc0c$var$__propIsEnum.call(b, prop)) $7816522e6538fc0c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $7816522e6538fc0c$var$__spreadProps = (a, b)=>$7816522e6538fc0c$var$__defProps(a, $7816522e6538fc0c$var$__getOwnPropDescs(b));
function $7816522e6538fc0c$export$87c0cf8eb5a167e0({ initialValues: initialValues = {}, initialErrors: initialErrors = {}, initialDirty: initialDirty = {}, initialTouched: initialTouched = {}, clearInputErrorOnChange: clearInputErrorOnChange = true, validateInputOnChange: validateInputOnChange = false, validateInputOnBlur: validateInputOnBlur = false, transformValues: transformValues = (values)=>values, validate: rules } = {}) {
    const [touched, setTouched] = (0, $acw62.useState)(initialTouched);
    const [dirty, setDirty] = (0, $acw62.useState)(initialDirty);
    const [values, _setValues] = (0, $acw62.useState)(initialValues);
    const [errors, _setErrors] = (0, $acw62.useState)((0, $7hXgD.filterErrors)(initialErrors));
    const valuesSnapshot = (0, $acw62.useRef)(initialValues);
    const setValuesSnapshot = (_values)=>{
        valuesSnapshot.current = _values;
    };
    const resetTouched = (0, $acw62.useCallback)(()=>setTouched({}), []);
    const resetDirty = (_values)=>{
        const newSnapshot = _values ? $7816522e6538fc0c$var$__spreadValues($7816522e6538fc0c$var$__spreadValues({}, values), _values) : values;
        setValuesSnapshot(newSnapshot);
        setDirty({});
    };
    const setErrors = (0, $acw62.useCallback)((errs)=>_setErrors((current)=>(0, $7hXgD.filterErrors)(typeof errs === "function" ? errs(current) : errs)), []);
    const clearErrors = (0, $acw62.useCallback)(()=>_setErrors({}), []);
    const reset = (0, $acw62.useCallback)(()=>{
        _setValues(initialValues);
        clearErrors();
        setValuesSnapshot(initialValues);
        setDirty({});
        resetTouched();
    }, []);
    const setFieldError = (0, $acw62.useCallback)((path, error)=>setErrors((current)=>$7816522e6538fc0c$var$__spreadProps($7816522e6538fc0c$var$__spreadValues({}, current), {
                [path]: error
            })), []);
    const clearFieldError = (0, $acw62.useCallback)((path)=>setErrors((current)=>{
            if (typeof path !== "string") return current;
            const clone = $7816522e6538fc0c$var$__spreadValues({}, current);
            delete clone[path];
            return clone;
        }), []);
    const clearFieldDirty = (0, $acw62.useCallback)((path)=>setDirty((current)=>{
            if (typeof path !== "string") return current;
            const result = (0, $6PkQa.clearListState)(path, current);
            delete result[path];
            return result;
        }), []);
    const setFieldValue = (0, $acw62.useCallback)((path, value)=>{
        const shouldValidate = (0, $faDVo.shouldValidateOnChange)(path, validateInputOnChange);
        clearFieldDirty(path);
        setTouched((currentTouched)=>$7816522e6538fc0c$var$__spreadProps($7816522e6538fc0c$var$__spreadValues({}, currentTouched), {
                [path]: true
            }));
        _setValues((current)=>{
            const result = (0, $dNPCm.setPath)(path, value, current);
            if (shouldValidate) {
                const validationResults = (0, $2bBXN.validateFieldValue)(path, rules, result);
                validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
            }
            return result;
        });
        !shouldValidate && clearInputErrorOnChange && setFieldError(path, null);
    }, []);
    const setValues = (0, $acw62.useCallback)((payload)=>{
        _setValues((currentValues)=>{
            const valuesPartial = typeof payload === "function" ? payload(currentValues) : payload;
            return $7816522e6538fc0c$var$__spreadValues($7816522e6538fc0c$var$__spreadValues({}, currentValues), valuesPartial);
        });
        clearInputErrorOnChange && clearErrors();
    }, []);
    const reorderListItem = (0, $acw62.useCallback)((path, payload)=>{
        clearFieldDirty(path);
        _setValues((current)=>(0, $e5Llg.reorderPath)(path, payload, current));
        _setErrors((errs)=>(0, $b1TVh.reorderErrors)(path, payload, errs));
    }, []);
    const removeListItem = (0, $acw62.useCallback)((path, index)=>{
        clearFieldDirty(path);
        _setValues((current)=>(0, $lLIFP.removePath)(path, index, current));
        _setErrors((errs)=>(0, $3hLCg.changeErrorIndices)(path, index, errs, -1));
    }, []);
    const insertListItem = (0, $acw62.useCallback)((path, item, index)=>{
        clearFieldDirty(path);
        _setValues((current)=>(0, $8MCSU.insertPath)(path, item, index, current));
        _setErrors((errs)=>(0, $3hLCg.changeErrorIndices)(path, index, errs, 1));
    }, []);
    const validate = (0, $acw62.useCallback)(()=>{
        const results = (0, $ibpMz.validateValues)(rules, values);
        _setErrors(results.errors);
        return results;
    }, [
        values,
        rules
    ]);
    const validateField = (0, $acw62.useCallback)((path)=>{
        const results = (0, $2bBXN.validateFieldValue)(path, rules, values);
        results.hasError ? setFieldError(path, results.error) : clearFieldError(path);
        return results;
    }, [
        values,
        rules
    ]);
    const getInputProps = (path, { type: type = "input", withError: withError = true, withFocus: withFocus = true } = {})=>{
        const onChange = (0, $l3GFc.getInputOnChange)((value)=>setFieldValue(path, value));
        const payload = {
            onChange: onChange
        };
        if (withError) payload.error = errors[path];
        if (type === "checkbox") payload.checked = (0, $bz6rW.getPath)(path, values);
        else payload.value = (0, $bz6rW.getPath)(path, values);
        if (withFocus) {
            payload.onFocus = ()=>setTouched((current)=>$7816522e6538fc0c$var$__spreadProps($7816522e6538fc0c$var$__spreadValues({}, current), {
                        [path]: true
                    }));
            payload.onBlur = ()=>{
                if ((0, $faDVo.shouldValidateOnChange)(path, validateInputOnBlur)) {
                    const validationResults = (0, $2bBXN.validateFieldValue)(path, rules, values);
                    validationResults.hasError ? setFieldError(path, validationResults.error) : clearFieldError(path);
                }
            };
        }
        return payload;
    };
    const onSubmit = (handleSubmit, handleValidationFailure)=>(event)=>{
            event == null || event.preventDefault();
            const results = validate();
            if (results.hasErrors) handleValidationFailure == null || handleValidationFailure(results.errors, values, event);
            else handleSubmit == null || handleSubmit(transformValues(values), event);
        };
    const getTransformedValues = (input)=>transformValues(input || values);
    const onReset = (0, $acw62.useCallback)((event)=>{
        event.preventDefault();
        reset();
    }, []);
    const isDirty = (path)=>{
        if (path) {
            const overriddenValue = (0, $bz6rW.getPath)(path, dirty);
            if (typeof overriddenValue === "boolean") return overriddenValue;
            const sliceOfValues = (0, $bz6rW.getPath)(path, values);
            const sliceOfInitialValues = (0, $bz6rW.getPath)(path, valuesSnapshot.current);
            return !(0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(sliceOfValues, sliceOfInitialValues);
        }
        const isOverridden = Object.keys(dirty).length > 0;
        if (isOverridden) return (0, $9x4CV.getStatus)(dirty);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($7hFx0)))(values, valuesSnapshot.current);
    };
    const isTouched = (0, $acw62.useCallback)((path)=>(0, $9x4CV.getStatus)(touched, path), [
        touched
    ]);
    const isValid = (0, $acw62.useCallback)((path)=>path ? !(0, $2bBXN.validateFieldValue)(path, rules, values).hasError : !(0, $ibpMz.validateValues)(rules, values).hasErrors, [
        values,
        rules
    ]);
    return {
        values: values,
        errors: errors,
        setValues: setValues,
        setErrors: setErrors,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        clearFieldError: clearFieldError,
        clearErrors: clearErrors,
        reset: reset,
        validate: validate,
        validateField: validateField,
        reorderListItem: reorderListItem,
        removeListItem: removeListItem,
        insertListItem: insertListItem,
        getInputProps: getInputProps,
        onSubmit: onSubmit,
        onReset: onReset,
        isDirty: isDirty,
        isTouched: isTouched,
        setTouched: setTouched,
        setDirty: setDirty,
        resetTouched: resetTouched,
        resetDirty: resetDirty,
        isValid: isValid,
        getTransformedValues: getTransformedValues
    };
}

});
parcelRegister("7hFx0", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("7hXgD", function(module, exports) {

$parcel$export(module.exports, "filterErrors", () => $54e8183525bb3a12$export$50c01357805887bf);
function $54e8183525bb3a12$export$50c01357805887bf(errors) {
    if (errors === null || typeof errors !== "object") return {};
    return Object.keys(errors).reduce((acc, key)=>{
        const errorValue = errors[key];
        if (errorValue !== void 0 && errorValue !== null && errorValue !== false) acc[key] = errorValue;
        return acc;
    }, {});
}

});

parcelRegister("6PkQa", function(module, exports) {

$parcel$export(module.exports, "clearListState", () => $4f87abf848548cb5$export$dcb7f82c6790c936);
var $4f87abf848548cb5$var$__defProp = Object.defineProperty;
var $4f87abf848548cb5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4f87abf848548cb5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4f87abf848548cb5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4f87abf848548cb5$var$__defNormalProp = (obj, key, value)=>key in obj ? $4f87abf848548cb5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4f87abf848548cb5$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4f87abf848548cb5$var$__hasOwnProp.call(b, prop)) $4f87abf848548cb5$var$__defNormalProp(a, prop, b[prop]);
    if ($4f87abf848548cb5$var$__getOwnPropSymbols) {
        for (var prop of $4f87abf848548cb5$var$__getOwnPropSymbols(b))if ($4f87abf848548cb5$var$__propIsEnum.call(b, prop)) $4f87abf848548cb5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $4f87abf848548cb5$export$dcb7f82c6790c936(field, state) {
    if (state === null || typeof state !== "object") return {};
    const clone = $4f87abf848548cb5$var$__spreadValues({}, state);
    Object.keys(state).forEach((errorKey)=>{
        if (errorKey.includes(`${String(field)}.`)) delete clone[errorKey];
    });
    return clone;
}

});

parcelRegister("faDVo", function(module, exports) {

$parcel$export(module.exports, "shouldValidateOnChange", () => $b0b6c26859c8657c$export$34266bfc4c1c4a91);

var $5hRGd = parcelRequire("5hRGd");
function $b0b6c26859c8657c$export$34266bfc4c1c4a91(path, validateInputOnChange) {
    if (!validateInputOnChange) return false;
    if (typeof validateInputOnChange === "boolean") return validateInputOnChange;
    if (Array.isArray(validateInputOnChange)) return validateInputOnChange.includes(path.replace(/[.][0-9]/g, `.${(0, $5hRGd.FORM_INDEX)}`));
    return false;
}

});
parcelRegister("5hRGd", function(module, exports) {

$parcel$export(module.exports, "FORM_INDEX", () => $3d982df9d614455f$export$e078f86f56537ccb);
const $3d982df9d614455f$export$e078f86f56537ccb = "__MANTINE_FORM_INDEX__";

});


parcelRegister("dNPCm", function(module, exports) {

$parcel$export(module.exports, "setPath", () => $a0c7e42e530c24f5$export$1518ffc4a8ff94f2);

var $jE0ic = parcelRequire("jE0ic");

var $bW9tK = parcelRequire("bW9tK");
function $a0c7e42e530c24f5$export$1518ffc4a8ff94f2(path, value, values) {
    const splittedPath = (0, $bW9tK.getSplittedPath)(path);
    if (splittedPath.length === 0) return values;
    const cloned = (0, $jE0ic.klona)(values);
    if (splittedPath.length === 1) {
        cloned[splittedPath[0]] = value;
        return cloned;
    }
    let val = cloned[splittedPath[0]];
    for(let i = 1; i < splittedPath.length - 1; i += 1){
        if (val === void 0) return cloned;
        val = val[splittedPath[i]];
    }
    val[splittedPath[splittedPath.length - 1]] = value;
    return cloned;
}

});
parcelRegister("jE0ic", function(module, exports) {

$parcel$export(module.exports, "klona", () => $e4d1fad0e696172b$export$a963eb2bdf550004, (v) => $e4d1fad0e696172b$export$a963eb2bdf550004 = v);
var $e4d1fad0e696172b$export$a963eb2bdf550004;
function $e4d1fad0e696172b$var$set(obj, key, val) {
    if (typeof val.value === 'object') val.value = $e4d1fad0e696172b$var$klona(val.value);
    if (!val.enumerable || val.get || val.set || !val.configurable || !val.writable || key === '__proto__') Object.defineProperty(obj, key, val);
    else obj[key] = val.value;
}
function $e4d1fad0e696172b$var$klona(x) {
    if (typeof x !== 'object') return x;
    var i = 0, k, list, tmp, str = Object.prototype.toString.call(x);
    if (str === '[object Object]') tmp = Object.create(x.__proto__ || null);
    else if (str === '[object Array]') tmp = Array(x.length);
    else if (str === '[object Set]') {
        tmp = new Set;
        x.forEach(function(val) {
            tmp.add($e4d1fad0e696172b$var$klona(val));
        });
    } else if (str === '[object Map]') {
        tmp = new Map;
        x.forEach(function(val, key) {
            tmp.set($e4d1fad0e696172b$var$klona(key), $e4d1fad0e696172b$var$klona(val));
        });
    } else if (str === '[object Date]') tmp = new Date(+x);
    else if (str === '[object RegExp]') tmp = new RegExp(x.source, x.flags);
    else if (str === '[object DataView]') tmp = new x.constructor($e4d1fad0e696172b$var$klona(x.buffer));
    else if (str === '[object ArrayBuffer]') tmp = x.slice(0);
    else if (str.slice(-6) === 'Array]') // ArrayBuffer.isView(x)
    // ~> `new` bcuz `Buffer.slice` => ref
    tmp = new x.constructor(x);
    if (tmp) {
        for(list = Object.getOwnPropertySymbols(x); i < list.length; i++)$e4d1fad0e696172b$var$set(tmp, list[i], Object.getOwnPropertyDescriptor(x, list[i]));
        for(i = 0, list = Object.getOwnPropertyNames(x); i < list.length; i++){
            if (Object.hasOwnProperty.call(tmp, k = list[i]) && tmp[k] === x[k]) continue;
            $e4d1fad0e696172b$var$set(tmp, k, Object.getOwnPropertyDescriptor(x, k));
        }
    }
    return tmp || x;
}
$e4d1fad0e696172b$export$a963eb2bdf550004 = $e4d1fad0e696172b$var$klona;

});

parcelRegister("bW9tK", function(module, exports) {

$parcel$export(module.exports, "getSplittedPath", () => $8b0c76cdac1fc808$export$adb32d9701ab5642);
function $8b0c76cdac1fc808$export$adb32d9701ab5642(path) {
    if (typeof path !== "string") return [];
    return path.split(".");
}

});


parcelRegister("2bBXN", function(module, exports) {

$parcel$export(module.exports, "validateFieldValue", () => $197a0e964895164c$export$ffdb9de87c39ed82);

var $ibpMz = parcelRequire("ibpMz");
function $197a0e964895164c$export$ffdb9de87c39ed82(path, rules, values) {
    if (typeof path !== "string") return {
        hasError: false,
        error: null
    };
    const results = (0, $ibpMz.validateValues)(rules, values);
    const pathInError = Object.keys(results.errors).find((errorKey)=>path.split(".").every((pathPart, i)=>pathPart === errorKey.split(".")[i]));
    return {
        hasError: !!pathInError,
        error: pathInError ? results.errors[pathInError] : null
    };
}

});
parcelRegister("ibpMz", function(module, exports) {

$parcel$export(module.exports, "validateValues", () => $d3cd40e77bdc9fca$export$2d64a4bedfb714a9);

var $7hXgD = parcelRequire("7hXgD");

var $bz6rW = parcelRequire("bz6rW");
function $d3cd40e77bdc9fca$var$getValidationResults(errors) {
    const filteredErrors = (0, $7hXgD.filterErrors)(errors);
    return {
        hasErrors: Object.keys(filteredErrors).length > 0,
        errors: filteredErrors
    };
}
function $d3cd40e77bdc9fca$var$validateRulesRecord(rules, values, path = "", errors = {}) {
    if (typeof rules !== "object" || rules === null) return errors;
    return Object.keys(rules).reduce((acc, ruleKey)=>{
        const rule = rules[ruleKey];
        const rulePath = `${path === "" ? "" : `${path}.`}${ruleKey}`;
        const value = (0, $bz6rW.getPath)(rulePath, values);
        let arrayValidation = false;
        if (typeof rule === "function") acc[rulePath] = rule(value, values, rulePath);
        if (typeof rule === "object" && Array.isArray(value)) {
            arrayValidation = true;
            value.forEach((_item, index)=>$d3cd40e77bdc9fca$var$validateRulesRecord(rule, values, `${rulePath}.${index}`, acc));
        }
        if (typeof rule === "object" && typeof value === "object" && value !== null) {
            if (!arrayValidation) $d3cd40e77bdc9fca$var$validateRulesRecord(rule, values, rulePath, acc);
        }
        return acc;
    }, errors);
}
function $d3cd40e77bdc9fca$export$2d64a4bedfb714a9(validate, values) {
    if (typeof validate === "function") return $d3cd40e77bdc9fca$var$getValidationResults(validate(values));
    return $d3cd40e77bdc9fca$var$getValidationResults($d3cd40e77bdc9fca$var$validateRulesRecord(validate, values));
}

});
parcelRegister("bz6rW", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $86b7f759cfa2497c$export$2aa3fd96c49a84a8);

var $bW9tK = parcelRequire("bW9tK");
function $86b7f759cfa2497c$export$2aa3fd96c49a84a8(path, values) {
    const splittedPath = (0, $bW9tK.getSplittedPath)(path);
    if (splittedPath.length === 0 || typeof values !== "object" || values === null) return void 0;
    let value = values[splittedPath[0]];
    for(let i = 1; i < splittedPath.length; i += 1){
        if (value === void 0) break;
        value = value[splittedPath[i]];
    }
    return value;
}

});



parcelRegister("e5Llg", function(module, exports) {

$parcel$export(module.exports, "reorderPath", () => $a4264170ed9a8063$export$f20b96e0c356d4c0);

var $bz6rW = parcelRequire("bz6rW");

var $dNPCm = parcelRequire("dNPCm");
function $a4264170ed9a8063$export$f20b96e0c356d4c0(path, { from: from, to: to }, values) {
    const currentValue = (0, $bz6rW.getPath)(path, values);
    if (!Array.isArray(currentValue)) return values;
    const cloned = [
        ...currentValue
    ];
    const item = currentValue[from];
    cloned.splice(from, 1);
    cloned.splice(to, 0, item);
    return (0, $dNPCm.setPath)(path, cloned, values);
}

});

parcelRegister("b1TVh", function(module, exports) {

$parcel$export(module.exports, "reorderErrors", () => $807b2ad051e5703a$export$4c6f820938a962f6);
var $807b2ad051e5703a$var$__defProp = Object.defineProperty;
var $807b2ad051e5703a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $807b2ad051e5703a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $807b2ad051e5703a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $807b2ad051e5703a$var$__defNormalProp = (obj, key, value)=>key in obj ? $807b2ad051e5703a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $807b2ad051e5703a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($807b2ad051e5703a$var$__hasOwnProp.call(b, prop)) $807b2ad051e5703a$var$__defNormalProp(a, prop, b[prop]);
    if ($807b2ad051e5703a$var$__getOwnPropSymbols) {
        for (var prop of $807b2ad051e5703a$var$__getOwnPropSymbols(b))if ($807b2ad051e5703a$var$__propIsEnum.call(b, prop)) $807b2ad051e5703a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $807b2ad051e5703a$export$4c6f820938a962f6(path, { from: from, to: to }, errors) {
    const oldKeyStart = `${path}.${from}`;
    const newKeyStart = `${path}.${to}`;
    const clone = $807b2ad051e5703a$var$__spreadValues({}, errors);
    Object.keys(errors).every((key)=>{
        let oldKey;
        let newKey;
        if (key.startsWith(oldKeyStart)) {
            oldKey = key;
            newKey = key.replace(oldKeyStart, newKeyStart);
        }
        if (key.startsWith(newKeyStart)) {
            oldKey = key.replace(newKeyStart, oldKeyStart);
            newKey = key;
        }
        if (oldKey && newKey) {
            const value1 = clone[oldKey];
            const value2 = clone[newKey];
            value2 === void 0 ? delete clone[oldKey] : clone[oldKey] = value2;
            value1 === void 0 ? delete clone[newKey] : clone[newKey] = value1;
            return false;
        }
        return true;
    });
    return clone;
}

});

parcelRegister("lLIFP", function(module, exports) {

$parcel$export(module.exports, "removePath", () => $fd90a405f26d779b$export$5c4e774b0e27d36b);

var $bz6rW = parcelRequire("bz6rW");

var $dNPCm = parcelRequire("dNPCm");
function $fd90a405f26d779b$export$5c4e774b0e27d36b(path, index, values) {
    const currentValue = (0, $bz6rW.getPath)(path, values);
    if (!Array.isArray(currentValue)) return values;
    return (0, $dNPCm.setPath)(path, currentValue.filter((_, itemIndex)=>itemIndex !== index), values);
}

});

parcelRegister("3hLCg", function(module, exports) {

$parcel$export(module.exports, "changeErrorIndices", () => $2647e53b023d0662$export$ba2d26425e4eb134);

var $6PkQa = parcelRequire("6PkQa");
var $2647e53b023d0662$var$__defProp = Object.defineProperty;
var $2647e53b023d0662$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2647e53b023d0662$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2647e53b023d0662$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2647e53b023d0662$var$__defNormalProp = (obj, key, value)=>key in obj ? $2647e53b023d0662$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2647e53b023d0662$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2647e53b023d0662$var$__hasOwnProp.call(b, prop)) $2647e53b023d0662$var$__defNormalProp(a, prop, b[prop]);
    if ($2647e53b023d0662$var$__getOwnPropSymbols) {
        for (var prop of $2647e53b023d0662$var$__getOwnPropSymbols(b))if ($2647e53b023d0662$var$__propIsEnum.call(b, prop)) $2647e53b023d0662$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
function $2647e53b023d0662$var$getIndexFromKeyAfterPath(key, path) {
    const split = key.substring(path.length + 1).split(".")[0];
    return parseInt(split, 10);
}
function $2647e53b023d0662$export$ba2d26425e4eb134(path, index, errors, change) {
    if (index === void 0) return errors;
    const pathString = `${String(path)}`;
    let clearedErrors = errors;
    if (change === -1) clearedErrors = (0, $6PkQa.clearListState)(`${pathString}.${index}`, clearedErrors);
    const cloned = $2647e53b023d0662$var$__spreadValues({}, clearedErrors);
    const changedKeys = new Set();
    Object.entries(clearedErrors).filter(([key])=>{
        if (!key.startsWith(`${pathString}.`)) return false;
        const currIndex = $2647e53b023d0662$var$getIndexFromKeyAfterPath(key, pathString);
        if (Number.isNaN(currIndex)) return false;
        return currIndex >= index;
    }).forEach(([key, value])=>{
        const currIndex = $2647e53b023d0662$var$getIndexFromKeyAfterPath(key, pathString);
        const newKey = key.replace(`${pathString}.${currIndex}`, `${pathString}.${currIndex + change}`);
        cloned[newKey] = value;
        changedKeys.add(newKey);
        if (!changedKeys.has(key)) delete cloned[key];
    });
    return cloned;
}

});

parcelRegister("8MCSU", function(module, exports) {

$parcel$export(module.exports, "insertPath", () => $6650f813b4ed4225$export$b3bad8010921a684);

var $bz6rW = parcelRequire("bz6rW");

var $dNPCm = parcelRequire("dNPCm");
function $6650f813b4ed4225$export$b3bad8010921a684(path, value, index, values) {
    const currentValue = (0, $bz6rW.getPath)(path, values);
    if (!Array.isArray(currentValue)) return values;
    const cloned = [
        ...currentValue
    ];
    cloned.splice(typeof index === "number" ? index : cloned.length, 0, value);
    return (0, $dNPCm.setPath)(path, cloned, values);
}

});

parcelRegister("9x4CV", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6f0ac8e49f988cb4$export$b70265791d2079d4);
function $6f0ac8e49f988cb4$export$b70265791d2079d4(status, path) {
    const paths = Object.keys(status);
    if (typeof path === "string") {
        const nestedPaths = paths.filter((statusPath)=>statusPath.startsWith(`${path}.`));
        return status[path] || nestedPaths.some((statusPath)=>status[statusPath]) || false;
    }
    return paths.some((statusPath)=>status[statusPath]);
}

});

parcelRegister("l3GFc", function(module, exports) {

$parcel$export(module.exports, "getInputOnChange", () => $f54af8dc4fd32a2d$export$6b61e0ca48e4cc51);
function $f54af8dc4fd32a2d$export$6b61e0ca48e4cc51(setValue) {
    return (val)=>{
        if (!val) setValue(val);
        else if (typeof val === "function") setValue(val);
        else if (typeof val === "object" && "nativeEvent" in val) {
            const { currentTarget: currentTarget } = val;
            if (currentTarget instanceof HTMLInputElement) {
                if (currentTarget.type === "checkbox") setValue(currentTarget.checked);
                else setValue(currentTarget.value);
            } else if (currentTarget instanceof HTMLTextAreaElement || currentTarget instanceof HTMLSelectElement) setValue(currentTarget.value);
        } else setValue(val);
    };
}

});


parcelRegister("j4US1", function(module, exports) {
/*! ExcelJS 19-10-2023 */ !function(e) {
    module.exports = e();
}(function() {
    return (function e(t, r, n) {
        function i(o, a) {
            if (!r[o]) {
                if (!t[o]) {
                    var l = undefined;
                    if (!a && l) return l(o, !0);
                    if (s) return s(o, !0);
                    var c = new Error("Cannot find module '" + o + "'");
                    throw c.code = "MODULE_NOT_FOUND", c;
                }
                var u = r[o] = {
                    exports: {}
                };
                t[o][0].call(u.exports, function(e) {
                    return i(t[o][1][e] || e);
                }, u, u.exports, e, t, r, n);
            }
            return r[o].exports;
        }
        for(var s = undefined, o = 0; o < n.length; o++)i(n[o]);
        return i;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                const n = e("fs"), i = e("fast-csv"), s = e("dayjs/plugin/customParseFormat"), o = e("dayjs/plugin/utc"), a = e("dayjs").extend(s).extend(o), l = e("../utils/stream-buf"), { fs: { exists: c } } = e("../utils/utils"), u = {
                    true: !0,
                    false: !1,
                    "#N/A": {
                        error: "#N/A"
                    },
                    "#REF!": {
                        error: "#REF!"
                    },
                    "#NAME?": {
                        error: "#NAME?"
                    },
                    "#DIV/0!": {
                        error: "#DIV/0!"
                    },
                    "#NULL!": {
                        error: "#NULL!"
                    },
                    "#VALUE!": {
                        error: "#VALUE!"
                    },
                    "#NUM!": {
                        error: "#NUM!"
                    }
                };
                t.exports = class {
                    constructor(e){
                        this.workbook = e, this.worksheet = null;
                    }
                    async readFile(e, t) {
                        if (t = t || {}, !await c(e)) throw new Error("File not found: " + e);
                        const r = n.createReadStream(e), i = await this.read(r, t);
                        return r.close(), i;
                    }
                    read(e, t) {
                        return t = t || {}, new Promise((r, n)=>{
                            const s = this.workbook.addWorksheet(t.sheetName), o = t.dateFormats || [
                                "YYYY-MM-DD[T]HH:mm:ssZ",
                                "YYYY-MM-DD[T]HH:mm:ss",
                                "MM-DD-YYYY",
                                "YYYY-MM-DD"
                            ], l = t.map || function(e) {
                                if ("" === e) return null;
                                const t = Number(e);
                                if (!Number.isNaN(t) && t !== 1 / 0) return t;
                                const r = o.reduce((t, r)=>{
                                    if (t) return t;
                                    const n = a(e, r, !0);
                                    return n.isValid() ? n : null;
                                }, null);
                                if (r) return new Date(r.valueOf());
                                const n = u[e];
                                return void 0 !== n ? n : e;
                            }, c = i.parse(t.parserOptions).on("data", (e)=>{
                                s.addRow(e.map(l));
                            }).on("end", ()=>{
                                c.emit("worksheet", s);
                            });
                            c.on("worksheet", r).on("error", n), e.pipe(c);
                        });
                    }
                    createInputStream() {
                        throw new Error("`CSV#createInputStream` is deprecated. You should use `CSV#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                    }
                    write(e, t) {
                        return new Promise((r, n)=>{
                            t = t || {};
                            const s = this.workbook.getWorksheet(t.sheetName || t.sheetId), o = i.format(t.formatterOptions);
                            e.on("finish", ()=>{
                                r();
                            }), o.on("error", n), o.pipe(e);
                            const { dateFormat: l, dateUTC: c } = t, u = t.map || ((e)=>{
                                if (e) {
                                    if (e.text || e.hyperlink) return e.hyperlink || e.text || "";
                                    if (e.formula || e.result) return e.result || "";
                                    if (e instanceof Date) return l ? c ? a.utc(e).format(l) : a(e).format(l) : c ? a.utc(e).format() : a(e).format();
                                    if (e.error) return e.error;
                                    if ("object" == typeof e) return JSON.stringify(e);
                                }
                                return e;
                            }), h = void 0 === t.includeEmptyRows || t.includeEmptyRows;
                            let f = 1;
                            s && s.eachRow((e, t)=>{
                                if (h) for(; f++ < t - 1;)o.write([]);
                                const { values: r } = e;
                                r.shift(), o.write(r.map(u)), f = t;
                            }), o.end();
                        });
                    }
                    writeFile(e, t) {
                        const r = {
                            encoding: (t = t || {}).encoding || "utf8"
                        }, i = n.createWriteStream(e, r);
                        return this.write(i, t);
                    }
                    async writeBuffer(e) {
                        const t = new l;
                        return await this.write(t, e), t.read();
                    }
                };
            },
            {
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                dayjs: 391,
                "dayjs/plugin/customParseFormat": 392,
                "dayjs/plugin/utc": 393,
                "fast-csv": 424,
                fs: 216
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t){
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                        if (this.worksheet = e, t) {
                            if ("string" == typeof t) {
                                const e = n.decodeAddress(t);
                                this.nativeCol = e.col + r, this.nativeColOff = 0, this.nativeRow = e.row + r, this.nativeRowOff = 0;
                            } else void 0 !== t.nativeCol ? (this.nativeCol = t.nativeCol || 0, this.nativeColOff = t.nativeColOff || 0, this.nativeRow = t.nativeRow || 0, this.nativeRowOff = t.nativeRowOff || 0) : void 0 !== t.col ? (this.col = t.col + r, this.row = t.row + r) : (this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0);
                        } else this.nativeCol = 0, this.nativeColOff = 0, this.nativeRow = 0, this.nativeRowOff = 0;
                    }
                    static asInstance(e) {
                        return e instanceof i || null == e ? e : new i(e);
                    }
                    get col() {
                        return this.nativeCol + Math.min(this.colWidth - 1, this.nativeColOff) / this.colWidth;
                    }
                    set col(e) {
                        this.nativeCol = Math.floor(e), this.nativeColOff = Math.floor((e - this.nativeCol) * this.colWidth);
                    }
                    get row() {
                        return this.nativeRow + Math.min(this.rowHeight - 1, this.nativeRowOff) / this.rowHeight;
                    }
                    set row(e) {
                        this.nativeRow = Math.floor(e), this.nativeRowOff = Math.floor((e - this.nativeRow) * this.rowHeight);
                    }
                    get colWidth() {
                        return this.worksheet && this.worksheet.getColumn(this.nativeCol + 1) && this.worksheet.getColumn(this.nativeCol + 1).isCustomWidth ? Math.floor(1e4 * this.worksheet.getColumn(this.nativeCol + 1).width) : 64e4;
                    }
                    get rowHeight() {
                        return this.worksheet && this.worksheet.getRow(this.nativeRow + 1) && this.worksheet.getRow(this.nativeRow + 1).height ? Math.floor(1e4 * this.worksheet.getRow(this.nativeRow + 1).height) : 18e4;
                    }
                    get model() {
                        return {
                            nativeCol: this.nativeCol,
                            nativeColOff: this.nativeColOff,
                            nativeRow: this.nativeRow,
                            nativeRowOff: this.nativeRowOff
                        };
                    }
                    set model(e) {
                        this.nativeCol = e.nativeCol, this.nativeColOff = e.nativeColOff, this.nativeRow = e.nativeRow, this.nativeRowOff = e.nativeRowOff;
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("../utils/under-dash"), s = e("./enums"), { slideFormula: o } = e("../utils/shared-formula"), a = e("./note");
                class l {
                    constructor(e, t, r){
                        if (!e || !t) throw new Error("A Cell needs a Row");
                        this._row = e, this._column = t, n.validateAddress(r), this._address = r, this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(e.style, t.style, {}), this._mergeCount = 0;
                    }
                    get worksheet() {
                        return this._row.worksheet;
                    }
                    get workbook() {
                        return this._row.worksheet.workbook;
                    }
                    destroy() {
                        delete this.style, delete this._value, delete this._row, delete this._column, delete this._address;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this.style.numFmt = e;
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this.style.font = e;
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this.style.alignment = e;
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this.style.border = e;
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this.style.fill = e;
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this.style.protection = e;
                    }
                    _mergeStyle(e, t, r) {
                        const n = e && e.numFmt || t && t.numFmt;
                        n && (r.numFmt = n);
                        const i = e && e.font || t && t.font;
                        i && (r.font = i);
                        const s = e && e.alignment || t && t.alignment;
                        s && (r.alignment = s);
                        const o = e && e.border || t && t.border;
                        o && (r.border = o);
                        const a = e && e.fill || t && t.fill;
                        a && (r.fill = a);
                        const l = e && e.protection || t && t.protection;
                        return l && (r.protection = l), r;
                    }
                    get address() {
                        return this._address;
                    }
                    get row() {
                        return this._row.number;
                    }
                    get col() {
                        return this._column.number;
                    }
                    get $col$row() {
                        return `$${this._column.letter}$${this.row}`;
                    }
                    get type() {
                        return this._value.type;
                    }
                    get effectiveType() {
                        return this._value.effectiveType;
                    }
                    toCsvString() {
                        return this._value.toCsvString();
                    }
                    addMergeRef() {
                        this._mergeCount++;
                    }
                    releaseMergeRef() {
                        this._mergeCount--;
                    }
                    get isMerged() {
                        return this._mergeCount > 0 || this.type === l.Types.Merge;
                    }
                    merge(e, t) {
                        this._value.release(), this._value = c.create(l.Types.Merge, this, e), t || (this.style = e.style);
                    }
                    unmerge() {
                        this.type === l.Types.Merge && (this._value.release(), this._value = c.create(l.Types.Null, this), this.style = this._mergeStyle(this._row.style, this._column.style, {}));
                    }
                    isMergedTo(e) {
                        return this._value.type === l.Types.Merge && this._value.isMergedTo(e);
                    }
                    get master() {
                        return this.type === l.Types.Merge ? this._value.master : this;
                    }
                    get isHyperlink() {
                        return this._value.type === l.Types.Hyperlink;
                    }
                    get hyperlink() {
                        return this._value.hyperlink;
                    }
                    get value() {
                        return this._value.value;
                    }
                    set value(e) {
                        this.type !== l.Types.Merge ? (this._value.release(), this._value = c.create(c.getType(e), this, e)) : this._value.master.value = e;
                    }
                    get note() {
                        return this._comment && this._comment.note;
                    }
                    set note(e) {
                        this._comment = new a(e);
                    }
                    get text() {
                        return this._value.toString();
                    }
                    get html() {
                        return i.escapeHtml(this.text);
                    }
                    toString() {
                        return this.text;
                    }
                    _upgradeToHyperlink(e) {
                        this.type === l.Types.String && (this._value = c.create(l.Types.Hyperlink, this, {
                            text: this._value.value,
                            hyperlink: e
                        }));
                    }
                    get formula() {
                        return this._value.formula;
                    }
                    get result() {
                        return this._value.result;
                    }
                    get formulaType() {
                        return this._value.formulaType;
                    }
                    get fullAddress() {
                        const { worksheet: e } = this._row;
                        return {
                            sheetName: e.name,
                            address: this.address,
                            row: this.row,
                            col: this.col
                        };
                    }
                    get name() {
                        return this.names[0];
                    }
                    set name(e) {
                        this.names = [
                            e
                        ];
                    }
                    get names() {
                        return this.workbook.definedNames.getNamesEx(this.fullAddress);
                    }
                    set names(e) {
                        const { definedNames: t } = this.workbook;
                        t.removeAllNames(this.fullAddress), e.forEach((e)=>{
                            t.addEx(this.fullAddress, e);
                        });
                    }
                    addName(e) {
                        this.workbook.definedNames.addEx(this.fullAddress, e);
                    }
                    removeName(e) {
                        this.workbook.definedNames.removeEx(this.fullAddress, e);
                    }
                    removeAllNames() {
                        this.workbook.definedNames.removeAllNames(this.fullAddress);
                    }
                    get _dataValidations() {
                        return this.worksheet.dataValidations;
                    }
                    get dataValidation() {
                        return this._dataValidations.find(this.address);
                    }
                    set dataValidation(e) {
                        this._dataValidations.add(this.address, e);
                    }
                    get model() {
                        const { model: e } = this._value;
                        return e.style = this.style, this._comment && (e.comment = this._comment.model), e;
                    }
                    set model(e) {
                        if (this._value.release(), this._value = c.create(e.type, this), this._value.model = e, e.comment) switch(e.comment.type){
                            case "note":
                                this._comment = a.fromModel(e.comment);
                        }
                        e.style ? this.style = e.style : this.style = {};
                    }
                }
                l.Types = s.ValueType;
                const c = {
                    getType: (e)=>null == e ? l.Types.Null : e instanceof String || "string" == typeof e ? l.Types.String : "number" == typeof e ? l.Types.Number : "boolean" == typeof e ? l.Types.Boolean : e instanceof Date ? l.Types.Date : e.text && e.hyperlink ? l.Types.Hyperlink : e.formula || e.sharedFormula ? l.Types.Formula : e.richText ? l.Types.RichText : e.sharedString ? l.Types.SharedString : e.error ? l.Types.Error : l.Types.JSON,
                    types: [
                        {
                            t: l.Types.Null,
                            f: class {
                                constructor(e){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Null
                                    };
                                }
                                get value() {
                                    return null;
                                }
                                set value(e) {}
                                get type() {
                                    return l.Types.Null;
                                }
                                get effectiveType() {
                                    return l.Types.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {}
                                toString() {
                                    return "";
                                }
                            }
                        },
                        {
                            t: l.Types.Number,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Number,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Number;
                                }
                                get effectiveType() {
                                    return l.Types.Number;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.String,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.model.value.replace(/"/g, '""')}"`;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.Date,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Date,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Date;
                                }
                                get effectiveType() {
                                    return l.Types.Date;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toISOString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Hyperlink,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Hyperlink,
                                        text: t ? t.text : void 0,
                                        hyperlink: t ? t.hyperlink : void 0
                                    }, t && t.tooltip && (this.model.tooltip = t.tooltip);
                                }
                                get value() {
                                    const e = {
                                        text: this.model.text,
                                        hyperlink: this.model.hyperlink
                                    };
                                    return this.model.tooltip && (e.tooltip = this.model.tooltip), e;
                                }
                                set value(e) {
                                    this.model = {
                                        text: e.text,
                                        hyperlink: e.hyperlink
                                    }, e.tooltip && (this.model.tooltip = e.tooltip);
                                }
                                get text() {
                                    return this.model.text;
                                }
                                set text(e) {
                                    this.model.text = e;
                                }
                                get hyperlink() {
                                    return this.model.hyperlink;
                                }
                                set hyperlink(e) {
                                    this.model.hyperlink = e;
                                }
                                get type() {
                                    return l.Types.Hyperlink;
                                }
                                get effectiveType() {
                                    return l.Types.Hyperlink;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.hyperlink;
                                }
                                release() {}
                                toString() {
                                    return this.model.text;
                                }
                            }
                        },
                        {
                            t: l.Types.Formula,
                            f: class {
                                constructor(e, t){
                                    this.cell = e, this.model = {
                                        address: e.address,
                                        type: l.Types.Formula,
                                        shareType: t ? t.shareType : void 0,
                                        ref: t ? t.ref : void 0,
                                        formula: t ? t.formula : void 0,
                                        sharedFormula: t ? t.sharedFormula : void 0,
                                        result: t ? t.result : void 0
                                    };
                                }
                                _copyModel(e) {
                                    const t = {}, r = (r)=>{
                                        const n = e[r];
                                        n && (t[r] = n);
                                    };
                                    return r("formula"), r("result"), r("ref"), r("shareType"), r("sharedFormula"), t;
                                }
                                get value() {
                                    return this._copyModel(this.model);
                                }
                                set value(e) {
                                    this.model = this._copyModel(e);
                                }
                                validate(e) {
                                    switch(c.getType(e)){
                                        case l.Types.Null:
                                        case l.Types.String:
                                        case l.Types.Number:
                                        case l.Types.Date:
                                            break;
                                        case l.Types.Hyperlink:
                                        case l.Types.Formula:
                                        default:
                                            throw new Error("Cannot process that type of result value");
                                    }
                                }
                                get dependencies() {
                                    return {
                                        ranges: this.formula.match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g),
                                        cells: this.formula.replace(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}:[A-Z]{1,3}\d{1,4}/g, "").match(/([a-zA-Z0-9]+!)?[A-Z]{1,3}\d{1,4}/g)
                                    };
                                }
                                get formula() {
                                    return this.model.formula || this._getTranslatedFormula();
                                }
                                set formula(e) {
                                    this.model.formula = e;
                                }
                                get formulaType() {
                                    return this.model.formula ? s.FormulaType.Master : this.model.sharedFormula ? s.FormulaType.Shared : s.FormulaType.None;
                                }
                                get result() {
                                    return this.model.result;
                                }
                                set result(e) {
                                    this.model.result = e;
                                }
                                get type() {
                                    return l.Types.Formula;
                                }
                                get effectiveType() {
                                    const e = this.model.result;
                                    return null == e ? s.ValueType.Null : e instanceof String || "string" == typeof e ? s.ValueType.String : "number" == typeof e ? s.ValueType.Number : e instanceof Date ? s.ValueType.Date : e.text && e.hyperlink ? s.ValueType.Hyperlink : e.formula ? s.ValueType.Formula : s.ValueType.Null;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                _getTranslatedFormula() {
                                    if (!this._translatedFormula && this.model.sharedFormula) {
                                        const { worksheet: e } = this.cell, t = e.findCell(this.model.sharedFormula);
                                        this._translatedFormula = t && o(t.formula, t.address, this.model.address);
                                    }
                                    return this._translatedFormula;
                                }
                                toCsvString() {
                                    return "" + (this.model.result || "");
                                }
                                release() {}
                                toString() {
                                    return this.model.result ? this.model.result.toString() : "";
                                }
                            }
                        },
                        {
                            t: l.Types.Merge,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Merge,
                                        master: t ? t.address : void 0
                                    }, this._master = t, t && t.addMergeRef();
                                }
                                get value() {
                                    return this._master.value;
                                }
                                set value(e) {
                                    e instanceof l ? (this._master && this._master.releaseMergeRef(), e.addMergeRef(), this._master = e) : this._master.value = e;
                                }
                                isMergedTo(e) {
                                    return e === this._master;
                                }
                                get master() {
                                    return this._master;
                                }
                                get type() {
                                    return l.Types.Merge;
                                }
                                get effectiveType() {
                                    return this._master.effectiveType;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return "";
                                }
                                release() {
                                    this._master.releaseMergeRef();
                                }
                                toString() {
                                    return this.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.JSON,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: JSON.stringify(t),
                                        rawValue: t
                                    };
                                }
                                get value() {
                                    return this.model.rawValue;
                                }
                                set value(e) {
                                    this.model.rawValue = e, this.model.value = JSON.stringify(e);
                                }
                                get type() {
                                    return l.Types.String;
                                }
                                get effectiveType() {
                                    return l.Types.String;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value;
                                }
                                release() {}
                                toString() {
                                    return this.model.value;
                                }
                            }
                        },
                        {
                            t: l.Types.SharedString,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.SharedString,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.SharedString;
                                }
                                get effectiveType() {
                                    return l.Types.SharedString;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.RichText,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.String,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                toString() {
                                    return this.model.value.richText.map((e)=>e.text).join("");
                                }
                                get type() {
                                    return l.Types.RichText;
                                }
                                get effectiveType() {
                                    return l.Types.RichText;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return `"${this.text.replace(/"/g, '""')}"`;
                                }
                                release() {}
                            }
                        },
                        {
                            t: l.Types.Boolean,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Boolean,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Boolean;
                                }
                                get effectiveType() {
                                    return l.Types.Boolean;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.model.value ? 1 : 0;
                                }
                                release() {}
                                toString() {
                                    return this.model.value.toString();
                                }
                            }
                        },
                        {
                            t: l.Types.Error,
                            f: class {
                                constructor(e, t){
                                    this.model = {
                                        address: e.address,
                                        type: l.Types.Error,
                                        value: t
                                    };
                                }
                                get value() {
                                    return this.model.value;
                                }
                                set value(e) {
                                    this.model.value = e;
                                }
                                get type() {
                                    return l.Types.Error;
                                }
                                get effectiveType() {
                                    return l.Types.Error;
                                }
                                get address() {
                                    return this.model.address;
                                }
                                set address(e) {
                                    this.model.address = e;
                                }
                                toCsvString() {
                                    return this.toString();
                                }
                                release() {}
                                toString() {
                                    return this.model.value.error.toString();
                                }
                            }
                        }
                    ].reduce((e, t)=>(e[t.t] = t.f, e), []),
                    create (e, t, r) {
                        const n = this.types[e];
                        if (!n) throw new Error("Could not create Value of type " + e);
                        return new n(t, r);
                    }
                };
                t.exports = l;
            },
            {
                "../utils/col-cache": 19,
                "../utils/shared-formula": 23,
                "../utils/under-dash": 26,
                "./enums": 7,
                "./note": 9
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache");
                class o {
                    constructor(e, t, r){
                        this._worksheet = e, this._number = t, !1 !== r && (this.defn = r);
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    get letter() {
                        return s.n2l(this._number);
                    }
                    get isCustomWidth() {
                        return void 0 !== this.width && 9 !== this.width;
                    }
                    get defn() {
                        return {
                            header: this._header,
                            key: this.key,
                            width: this.width,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel
                        };
                    }
                    set defn(e) {
                        e ? (this.key = e.key, this.width = void 0 !== e.width ? e.width : 9, this.outlineLevel = e.outlineLevel, e.style ? this.style = e.style : this.style = {}, this.header = e.header, this._hidden = !!e.hidden) : (delete this._header, delete this._key, delete this.width, this.style = {}, this.outlineLevel = 0);
                    }
                    get headers() {
                        return this._header && this._header instanceof Array ? this._header : [
                            this._header
                        ];
                    }
                    get header() {
                        return this._header;
                    }
                    set header(e) {
                        void 0 !== e ? (this._header = e, this.headers.forEach((e, t)=>{
                            this._worksheet.getCell(t + 1, this.number).value = e;
                        })) : this._header = void 0;
                    }
                    get key() {
                        return this._key;
                    }
                    set key(e) {
                        (this._key && this._worksheet.getColumnKey(this._key)) === this && this._worksheet.deleteColumnKey(this._key), this._key = e, e && this._worksheet.setColumnKey(this._key, this);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelCol);
                    }
                    toString() {
                        return JSON.stringify({
                            key: this.key,
                            width: this.width,
                            headers: this.headers.length ? this.headers : void 0
                        });
                    }
                    equivalentTo(e) {
                        return this.width === e.width && this.hidden === e.hidden && this.outlineLevel === e.outlineLevel && n.isEqual(this.style, e.style);
                    }
                    get isDefault() {
                        if (this.isCustomWidth) return !1;
                        if (this.hidden) return !1;
                        if (this.outlineLevel) return !1;
                        const e = this.style;
                        return !e || !(e.font || e.numFmt || e.alignment || e.border || e.fill || e.protection);
                    }
                    get headerCount() {
                        return this.headers.length;
                    }
                    eachCell(e, t) {
                        const r = this.number;
                        t || (t = e, e = null), this._worksheet.eachRow(e, (e, n)=>{
                            t(e.getCell(r), n);
                        });
                    }
                    get values() {
                        const e = [];
                        return this.eachCell((t, r)=>{
                            t && t.type !== i.ValueType.Null && (e[r] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (!e) return;
                        const t = this.number;
                        let r = 0;
                        e.hasOwnProperty("0") && (r = 1), e.forEach((e, n)=>{
                            this._worksheet.getCell(n + r, t).value = e;
                        });
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this.eachCell((r)=>{
                            r[e] = t;
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    static toModel(e) {
                        const t = [];
                        let r = null;
                        return e && e.forEach((e, n)=>{
                            e.isDefault ? r && (r = null) : r && e.equivalentTo(r) ? r.max = n + 1 : (r = {
                                min: n + 1,
                                max: n + 1,
                                width: void 0 !== e.width ? e.width : 9,
                                style: e.style,
                                isCustomWidth: e.isCustomWidth,
                                hidden: e.hidden,
                                outlineLevel: e.outlineLevel,
                                collapsed: e.collapsed
                            }, t.push(r));
                        }), t.length ? t : void 0;
                    }
                    static fromModel(e, t) {
                        const r = [];
                        let n = 1, i = 0;
                        for(t = (t = t || []).sort(function(e, t) {
                            return e.min - t.min;
                        }); i < t.length;){
                            const s = t[i++];
                            for(; n < s.min;)r.push(new o(e, n++));
                            for(; n <= s.max;)r.push(new o(e, n++, s));
                        }
                        return r.length ? r : null;
                    }
                }
                t.exports = o;
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./enums": 7
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                t.exports = class {
                    constructor(e){
                        this.model = e || {};
                    }
                    add(e, t) {
                        return this.model[e] = t;
                    }
                    find(e) {
                        return this.model[e];
                    }
                    remove(e) {
                        this.model[e] = void 0;
                    }
                };
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("../utils/cell-matrix"), o = e("./range"), a = /[$](\w+)[$](\d+)(:[$](\w+)[$](\d+))?/;
                t.exports = class {
                    constructor(){
                        this.matrixMap = {};
                    }
                    getMatrix(e) {
                        return this.matrixMap[e] || (this.matrixMap[e] = new s);
                    }
                    add(e, t) {
                        const r = i.decodeEx(e);
                        this.addEx(r, t);
                    }
                    addEx(e, t) {
                        const r = this.getMatrix(t);
                        if (e.top) for(let t = e.left; t <= e.right; t++)for(let n = e.top; n <= e.bottom; n++){
                            const s = {
                                sheetName: e.sheetName,
                                address: i.n2l(t) + n,
                                row: n,
                                col: t
                            };
                            r.addCellEx(s);
                        }
                        else r.addCellEx(e);
                    }
                    remove(e, t) {
                        const r = i.decodeEx(e);
                        this.removeEx(r, t);
                    }
                    removeEx(e, t) {
                        this.getMatrix(t).removeCellEx(e);
                    }
                    removeAllNames(e) {
                        n.each(this.matrixMap, (t)=>{
                            t.removeCellEx(e);
                        });
                    }
                    forEach(e) {
                        n.each(this.matrixMap, (t, r)=>{
                            t.forEach((t)=>{
                                e(r, t);
                            });
                        });
                    }
                    getNames(e) {
                        return this.getNamesEx(i.decodeEx(e));
                    }
                    getNamesEx(e) {
                        return n.map(this.matrixMap, (t, r)=>t.findCellEx(e) && r).filter(Boolean);
                    }
                    _explore(e, t) {
                        t.mark = !1;
                        const { sheetName: r } = t, n = new o(t.row, t.col, t.row, t.col, r);
                        let i, s;
                        function a(i, s) {
                            const o = e.findCellAt(r, i, t.col);
                            return !(!o || !o.mark) && (n[s] = i, o.mark = !1, !0);
                        }
                        for(s = t.row - 1; a(s, "top"); s--);
                        for(s = t.row + 1; a(s, "bottom"); s++);
                        function l(t, i) {
                            const o = [];
                            for(s = n.top; s <= n.bottom; s++){
                                const n = e.findCellAt(r, s, t);
                                if (!n || !n.mark) return !1;
                                o.push(n);
                            }
                            n[i] = t;
                            for(let e = 0; e < o.length; e++)o[e].mark = !1;
                            return !0;
                        }
                        for(i = t.col - 1; l(i, "left"); i--);
                        for(i = t.col + 1; l(i, "right"); i++);
                        return n;
                    }
                    getRanges(e, t) {
                        if (!(t = t || this.matrixMap[e])) return {
                            name: e,
                            ranges: []
                        };
                        t.forEach((e)=>{
                            e.mark = !0;
                        });
                        return {
                            name: e,
                            ranges: t.map((e)=>e.mark && this._explore(t, e)).filter(Boolean).map((e)=>e.$shortRange)
                        };
                    }
                    normaliseMatrix(e, t) {
                        e.forEachInSheet(t, (e, t, r)=>{
                            e && (e.row === t && e.col === r || (e.row = t, e.col = r, e.address = i.n2l(r) + t));
                        });
                    }
                    spliceRows(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceRows(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    spliceColumns(e, t, r, i) {
                        n.each(this.matrixMap, (n)=>{
                            n.spliceColumns(e, t, r, i), this.normaliseMatrix(n, e);
                        });
                    }
                    get model() {
                        return n.map(this.matrixMap, (e, t)=>this.getRanges(t, e)).filter((e)=>e.ranges.length);
                    }
                    set model(e) {
                        const t = this.matrixMap = {};
                        e.forEach((e)=>{
                            const r = t[e.name] = new s;
                            e.ranges.forEach((e)=>{
                                a.test(e.split("!").pop() || "") && r.addCell(e);
                            });
                        });
                    }
                };
            },
            {
                "../utils/cell-matrix": 18,
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./range": 10
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    ValueType: {
                        Null: 0,
                        Merge: 1,
                        Number: 2,
                        String: 3,
                        Date: 4,
                        Hyperlink: 5,
                        Formula: 6,
                        SharedString: 7,
                        RichText: 8,
                        Boolean: 9,
                        Error: 10
                    },
                    FormulaType: {
                        None: 0,
                        Master: 1,
                        Shared: 2
                    },
                    RelationshipType: {
                        None: 0,
                        OfficeDocument: 1,
                        Worksheet: 2,
                        CalcChain: 3,
                        SharedStrings: 4,
                        Styles: 5,
                        Theme: 6,
                        Hyperlink: 7
                    },
                    DocumentType: {
                        Xlsx: 1
                    },
                    ReadingOrder: {
                        LeftToRight: 1,
                        RightToLeft: 2
                    },
                    ErrorValue: {
                        NotApplicable: "#N/A",
                        Ref: "#REF!",
                        Name: "#NAME?",
                        DivZero: "#DIV/0!",
                        Null: "#NULL!",
                        Value: "#VALUE!",
                        Num: "#NUM!"
                    }
                };
            },
            {}
        ],
        8: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache"), i = e("./anchor");
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, this.model = t;
                    }
                    get model() {
                        switch(this.type){
                            case "background":
                                return {
                                    type: this.type,
                                    imageId: this.imageId
                                };
                            case "image":
                                return {
                                    type: this.type,
                                    imageId: this.imageId,
                                    hyperlinks: this.range.hyperlinks,
                                    range: {
                                        tl: this.range.tl.model,
                                        br: this.range.br && this.range.br.model,
                                        ext: this.range.ext,
                                        editAs: this.range.editAs
                                    }
                                };
                            default:
                                throw new Error("Invalid Image Type");
                        }
                    }
                    set model(e) {
                        let { type: t, imageId: r, range: s, hyperlinks: o } = e;
                        if (this.type = t, this.imageId = r, "image" === t) {
                            if ("string" == typeof s) {
                                const e = n.decode(s);
                                this.range = {
                                    tl: new i(this.worksheet, {
                                        col: e.left,
                                        row: e.top
                                    }, -1),
                                    br: new i(this.worksheet, {
                                        col: e.right,
                                        row: e.bottom
                                    }, 0),
                                    editAs: "oneCell"
                                };
                            } else this.range = {
                                tl: new i(this.worksheet, s.tl, 0),
                                br: s.br && new i(this.worksheet, s.br, 0),
                                ext: s.ext,
                                editAs: s.editAs,
                                hyperlinks: o || s.hyperlinks
                            };
                        }
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "./anchor": 2
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash");
                class i {
                    constructor(e){
                        this.note = e;
                    }
                    get model() {
                        let e = null;
                        switch(typeof this.note){
                            case "string":
                                e = {
                                    type: "note",
                                    note: {
                                        texts: [
                                            {
                                                text: this.note
                                            }
                                        ]
                                    }
                                };
                                break;
                            default:
                                e = {
                                    type: "note",
                                    note: this.note
                                };
                        }
                        return n.deepMerge({}, i.DEFAULT_CONFIGS, e);
                    }
                    set model(e) {
                        const { note: t } = e, { texts: r } = t;
                        1 === r.length && 1 === Object.keys(r[0]).length ? this.note = r[0].text : this.note = t;
                    }
                    static fromModel(e) {
                        const t = new i;
                        return t.model = e, t;
                    }
                }
                i.DEFAULT_CONFIGS = {
                    note: {
                        margins: {
                            insetmode: "auto",
                            inset: [
                                .13,
                                .13,
                                .25,
                                .25
                            ]
                        },
                        protection: {
                            locked: "True",
                            lockText: "True"
                        },
                        editAs: "absolute"
                    }
                }, t.exports = i;
            },
            {
                "../utils/under-dash": 26
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(){
                        this.decode(arguments);
                    }
                    setTLBR(e, t, r, i, s) {
                        if (arguments.length < 4) {
                            const i = n.decodeAddress(e), o = n.decodeAddress(t);
                            this.model = {
                                top: Math.min(i.row, o.row),
                                left: Math.min(i.col, o.col),
                                bottom: Math.max(i.row, o.row),
                                right: Math.max(i.col, o.col),
                                sheetName: r
                            }, this.setTLBR(i.row, i.col, o.row, o.col, s);
                        } else this.model = {
                            top: Math.min(e, r),
                            left: Math.min(t, i),
                            bottom: Math.max(e, r),
                            right: Math.max(t, i),
                            sheetName: s
                        };
                    }
                    decode(e) {
                        switch(e.length){
                            case 5:
                                this.setTLBR(e[0], e[1], e[2], e[3], e[4]);
                                break;
                            case 4:
                                this.setTLBR(e[0], e[1], e[2], e[3]);
                                break;
                            case 3:
                                this.setTLBR(e[0], e[1], e[2]);
                                break;
                            case 2:
                                this.setTLBR(e[0], e[1]);
                                break;
                            case 1:
                                {
                                    const t = e[0];
                                    if (t instanceof i) this.model = {
                                        top: t.model.top,
                                        left: t.model.left,
                                        bottom: t.model.bottom,
                                        right: t.model.right,
                                        sheetName: t.sheetName
                                    };
                                    else if (t instanceof Array) this.decode(t);
                                    else if (t.top && t.left && t.bottom && t.right) this.model = {
                                        top: t.top,
                                        left: t.left,
                                        bottom: t.bottom,
                                        right: t.right,
                                        sheetName: t.sheetName
                                    };
                                    else {
                                        const e = n.decodeEx(t);
                                        e.top ? this.model = {
                                            top: e.top,
                                            left: e.left,
                                            bottom: e.bottom,
                                            right: e.right,
                                            sheetName: e.sheetName
                                        } : this.model = {
                                            top: e.row,
                                            left: e.col,
                                            bottom: e.row,
                                            right: e.col,
                                            sheetName: e.sheetName
                                        };
                                    }
                                    break;
                                }
                            case 0:
                                this.model = {
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0
                                };
                                break;
                            default:
                                throw new Error("Invalid number of arguments to _getDimensions() - " + e.length);
                        }
                    }
                    get top() {
                        return this.model.top || 1;
                    }
                    set top(e) {
                        this.model.top = e;
                    }
                    get left() {
                        return this.model.left || 1;
                    }
                    set left(e) {
                        this.model.left = e;
                    }
                    get bottom() {
                        return this.model.bottom || 1;
                    }
                    set bottom(e) {
                        this.model.bottom = e;
                    }
                    get right() {
                        return this.model.right || 1;
                    }
                    set right(e) {
                        this.model.right = e;
                    }
                    get sheetName() {
                        return this.model.sheetName;
                    }
                    set sheetName(e) {
                        this.model.sheetName = e;
                    }
                    get _serialisedSheetName() {
                        const { sheetName: e } = this.model;
                        return e ? /^[a-zA-Z0-9]*$/.test(e) ? e + "!" : `'${e}'!` : "";
                    }
                    expand(e, t, r, n) {
                        (!this.model.top || e < this.top) && (this.top = e), (!this.model.left || t < this.left) && (this.left = t), (!this.model.bottom || r > this.bottom) && (this.bottom = r), (!this.model.right || n > this.right) && (this.right = n);
                    }
                    expandRow(e) {
                        if (e) {
                            const { dimensions: t, number: r } = e;
                            t && this.expand(r, t.min, r, t.max);
                        }
                    }
                    expandToAddress(e) {
                        const t = n.decodeEx(e);
                        this.expand(t.row, t.col, t.row, t.col);
                    }
                    get tl() {
                        return n.n2l(this.left) + this.top;
                    }
                    get $t$l() {
                        return `$${n.n2l(this.left)}$${this.top}`;
                    }
                    get br() {
                        return n.n2l(this.right) + this.bottom;
                    }
                    get $b$r() {
                        return `$${n.n2l(this.right)}$${this.bottom}`;
                    }
                    get range() {
                        return `${this._serialisedSheetName + this.tl}:${this.br}`;
                    }
                    get $range() {
                        return `${this._serialisedSheetName + this.$t$l}:${this.$b$r}`;
                    }
                    get shortRange() {
                        return this.count > 1 ? this.range : this._serialisedSheetName + this.tl;
                    }
                    get $shortRange() {
                        return this.count > 1 ? this.$range : this._serialisedSheetName + this.$t$l;
                    }
                    get count() {
                        return (1 + this.bottom - this.top) * (1 + this.right - this.left);
                    }
                    toString() {
                        return this.range;
                    }
                    intersects(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && !(e.bottom < this.top) && !(e.top > this.bottom) && !(e.right < this.left) && !(e.left > this.right);
                    }
                    contains(e) {
                        const t = n.decodeEx(e);
                        return this.containsEx(t);
                    }
                    containsEx(e) {
                        return (!e.sheetName || !this.sheetName || e.sheetName === this.sheetName) && e.row >= this.top && e.row <= this.bottom && e.col >= this.left && e.col <= this.right;
                    }
                    forEachAddress(e) {
                        for(let t = this.left; t <= this.right; t++)for(let r = this.top; r <= this.bottom; r++)e(n.encodeAddress(r, t), r, t);
                    }
                }
                t.exports = i;
            },
            {
                "../utils/col-cache": 19
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("./enums"), s = e("../utils/col-cache"), o = e("./cell");
                t.exports = class {
                    constructor(e, t){
                        this._worksheet = e, this._number = t, this._cells = [], this.style = {}, this.outlineLevel = 0;
                    }
                    get number() {
                        return this._number;
                    }
                    get worksheet() {
                        return this._worksheet;
                    }
                    commit() {
                        this._worksheet._commitRow(this);
                    }
                    destroy() {
                        delete this._worksheet, delete this._cells, delete this.style;
                    }
                    findCell(e) {
                        return this._cells[e - 1];
                    }
                    getCellEx(e) {
                        let t = this._cells[e.col - 1];
                        if (!t) {
                            const r = this._worksheet.getColumn(e.col);
                            t = new o(this, r, e.address), this._cells[e.col - 1] = t;
                        }
                        return t;
                    }
                    getCell(e) {
                        if ("string" == typeof e) {
                            const t = this._worksheet.getColumnKey(e);
                            e = t ? t.number : s.l2n(e);
                        }
                        return this._cells[e - 1] || this.getCellEx({
                            address: s.encodeAddress(this._number, e),
                            row: this._number,
                            col: e
                        });
                    }
                    splice(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length - t, a = this._cells.length;
                        let l, c, u;
                        if (o < 0) for(l = e + i.length; l <= a; l++)u = this._cells[l - 1], c = this._cells[l - o - 1], c ? (u = this.getCell(l), u.value = c.value, u.style = c.style, u._comment = c._comment) : u && (u.value = null, u.style = {}, u._comment = void 0);
                        else if (o > 0) for(l = a; l >= r; l--)c = this._cells[l - 1], c ? (u = this.getCell(l + o), u.value = c.value, u.style = c.style, u._comment = c._comment) : this._cells[l + o - 1] = void 0;
                        for(l = 0; l < i.length; l++)u = this.getCell(e + l), u.value = i[l], u.style = {}, u._comment = void 0;
                    }
                    eachCell(e, t) {
                        if (t || (t = e, e = null), e && e.includeEmpty) {
                            const e = this._cells.length;
                            for(let r = 1; r <= e; r++)t(this.getCell(r), r);
                        } else this._cells.forEach((e, r)=>{
                            e && e.type !== i.ValueType.Null && t(e, r + 1);
                        });
                    }
                    addPageBreak(e, t) {
                        const r = this._worksheet, n = Math.max(0, e - 1) || 0, i = Math.max(0, t - 1) || 16838, s = {
                            id: this._number,
                            max: i,
                            man: 1
                        };
                        n && (s.min = n), r.rowBreaks.push(s);
                    }
                    get values() {
                        const e = [];
                        return this._cells.forEach((t)=>{
                            t && t.type !== i.ValueType.Null && (e[t.col] = t.value);
                        }), e;
                    }
                    set values(e) {
                        if (this._cells = [], e) {
                            if (e instanceof Array) {
                                let t = 0;
                                e.hasOwnProperty("0") && (t = 1), e.forEach((e, r)=>{
                                    void 0 !== e && (this.getCellEx({
                                        address: s.encodeAddress(this._number, r + t),
                                        row: this._number,
                                        col: r + t
                                    }).value = e);
                                });
                            } else this._worksheet.eachColumnKey((t, r)=>{
                                void 0 !== e[r] && (this.getCellEx({
                                    address: s.encodeAddress(this._number, t.number),
                                    row: this._number,
                                    col: t.number
                                }).value = e[r]);
                            });
                        } else ;
                    }
                    get hasValues() {
                        return n.some(this._cells, (e)=>e && e.type !== i.ValueType.Null);
                    }
                    get cellCount() {
                        return this._cells.length;
                    }
                    get actualCellCount() {
                        let e = 0;
                        return this.eachCell(()=>{
                            e++;
                        }), e;
                    }
                    get dimensions() {
                        let e = 0, t = 0;
                        return this._cells.forEach((r)=>{
                            r && r.type !== i.ValueType.Null && ((!e || e > r.col) && (e = r.col), t < r.col && (t = r.col));
                        }), e > 0 ? {
                            min: e,
                            max: t
                        } : null;
                    }
                    _applyStyle(e, t) {
                        return this.style[e] = t, this._cells.forEach((r)=>{
                            r && (r[e] = t);
                        }), t;
                    }
                    get numFmt() {
                        return this.style.numFmt;
                    }
                    set numFmt(e) {
                        this._applyStyle("numFmt", e);
                    }
                    get font() {
                        return this.style.font;
                    }
                    set font(e) {
                        this._applyStyle("font", e);
                    }
                    get alignment() {
                        return this.style.alignment;
                    }
                    set alignment(e) {
                        this._applyStyle("alignment", e);
                    }
                    get protection() {
                        return this.style.protection;
                    }
                    set protection(e) {
                        this._applyStyle("protection", e);
                    }
                    get border() {
                        return this.style.border;
                    }
                    set border(e) {
                        this._applyStyle("border", e);
                    }
                    get fill() {
                        return this.style.fill;
                    }
                    set fill(e) {
                        this._applyStyle("fill", e);
                    }
                    get hidden() {
                        return !!this._hidden;
                    }
                    set hidden(e) {
                        this._hidden = e;
                    }
                    get outlineLevel() {
                        return this._outlineLevel || 0;
                    }
                    set outlineLevel(e) {
                        this._outlineLevel = e;
                    }
                    get collapsed() {
                        return !!(this._outlineLevel && this._outlineLevel >= this._worksheet.properties.outlineLevelRow);
                    }
                    get model() {
                        const e = [];
                        let t = 0, r = 0;
                        return this._cells.forEach((n)=>{
                            if (n) {
                                const i = n.model;
                                i && ((!t || t > n.col) && (t = n.col), r < n.col && (r = n.col), e.push(i));
                            }
                        }), this.height || e.length ? {
                            cells: e,
                            number: this.number,
                            min: t,
                            max: r,
                            height: this.height,
                            style: this.style,
                            hidden: this.hidden,
                            outlineLevel: this.outlineLevel,
                            collapsed: this.collapsed
                        } : null;
                    }
                    set model(e) {
                        if (e.number !== this._number) throw new Error("Invalid row number in model");
                        let t;
                        this._cells = [], e.cells.forEach((e)=>{
                            switch(e.type){
                                case o.Types.Merge:
                                    break;
                                default:
                                    {
                                        let r;
                                        if (e.address) r = s.decodeAddress(e.address);
                                        else if (t) {
                                            const { row: e } = t, n = t.col + 1;
                                            r = {
                                                row: e,
                                                col: n,
                                                address: s.encodeAddress(e, n),
                                                $col$row: `$${s.n2l(n)}$${e}`
                                            };
                                        }
                                        t = r;
                                        this.getCellEx(r).model = e;
                                        break;
                                    }
                            }
                        }), e.height ? this.height = e.height : delete this.height, this.hidden = e.hidden, this.outlineLevel = e.outlineLevel || 0, this.style = e.style && JSON.parse(JSON.stringify(e.style)) || {};
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/under-dash": 26,
                "./cell": 3,
                "./enums": 7
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/col-cache");
                class i {
                    constructor(e, t, r){
                        this.table = e, this.column = t, this.index = r;
                    }
                    _set(e, t) {
                        this.table.cacheState(), this.column[e] = t;
                    }
                    get name() {
                        return this.column.name;
                    }
                    set name(e) {
                        this._set("name", e);
                    }
                    get filterButton() {
                        return this.column.filterButton;
                    }
                    set filterButton(e) {
                        this.column.filterButton = e;
                    }
                    get style() {
                        return this.column.style;
                    }
                    set style(e) {
                        this.column.style = e;
                    }
                    get totalsRowLabel() {
                        return this.column.totalsRowLabel;
                    }
                    set totalsRowLabel(e) {
                        this._set("totalsRowLabel", e);
                    }
                    get totalsRowFunction() {
                        return this.column.totalsRowFunction;
                    }
                    set totalsRowFunction(e) {
                        this._set("totalsRowFunction", e);
                    }
                    get totalsRowResult() {
                        return this.column.totalsRowResult;
                    }
                    set totalsRowResult(e) {
                        this._set("totalsRowResult", e);
                    }
                    get totalsRowFormula() {
                        return this.column.totalsRowFormula;
                    }
                    set totalsRowFormula(e) {
                        this._set("totalsRowFormula", e);
                    }
                }
                t.exports = class {
                    constructor(e, t){
                        this.worksheet = e, t && (this.table = t, this.validate(), this.store());
                    }
                    getFormula(e) {
                        switch(e.totalsRowFunction){
                            case "none":
                                return null;
                            case "average":
                                return `SUBTOTAL(101,${this.table.name}[${e.name}])`;
                            case "countNums":
                                return `SUBTOTAL(102,${this.table.name}[${e.name}])`;
                            case "count":
                                return `SUBTOTAL(103,${this.table.name}[${e.name}])`;
                            case "max":
                                return `SUBTOTAL(104,${this.table.name}[${e.name}])`;
                            case "min":
                                return `SUBTOTAL(105,${this.table.name}[${e.name}])`;
                            case "stdDev":
                                return `SUBTOTAL(106,${this.table.name}[${e.name}])`;
                            case "var":
                                return `SUBTOTAL(107,${this.table.name}[${e.name}])`;
                            case "sum":
                                return `SUBTOTAL(109,${this.table.name}[${e.name}])`;
                            case "custom":
                                return e.totalsRowFormula;
                            default:
                                throw new Error("Invalid Totals Row Function: " + e.totalsRowFunction);
                        }
                    }
                    get width() {
                        return this.table.columns.length;
                    }
                    get height() {
                        return this.table.rows.length;
                    }
                    get filterHeight() {
                        return this.height + (this.table.headerRow ? 1 : 0);
                    }
                    get tableHeight() {
                        return this.filterHeight + (this.table.totalsRow ? 1 : 0);
                    }
                    validate() {
                        const { table: e } = this, t = (e, t, r)=>{
                            void 0 === e[t] && (e[t] = r);
                        };
                        t(e, "headerRow", !0), t(e, "totalsRow", !1), t(e, "style", {}), t(e.style, "theme", "TableStyleMedium2"), t(e.style, "showFirstColumn", !1), t(e.style, "showLastColumn", !1), t(e.style, "showRowStripes", !1), t(e.style, "showColumnStripes", !1);
                        const r = (e, t)=>{
                            if (!e) throw new Error(t);
                        };
                        r(e.ref, "Table must have ref"), r(e.columns, "Table must have column definitions"), r(e.rows, "Table must have row definitions"), e.tl = n.decodeAddress(e.ref);
                        const { row: i, col: s } = e.tl;
                        r(i > 0, "Table must be on valid row"), r(s > 0, "Table must be on valid col");
                        const { width: o, filterHeight: a, tableHeight: l } = this;
                        e.autoFilterRef = n.encode(i, s, i + a - 1, s + o - 1), e.tableRef = n.encode(i, s, i + l - 1, s + o - 1), e.columns.forEach((e, n)=>{
                            r(e.name, `Column ${n} must have a name`), 0 === n ? t(e, "totalsRowLabel", "Total") : (t(e, "totalsRowFunction", "none"), e.totalsRowFormula = this.getFormula(e));
                        });
                    }
                    store() {
                        const e = (e, t)=>{
                            t && Object.keys(t).forEach((r)=>{
                                e[r] = t[r];
                            });
                        }, { worksheet: t, table: r } = this, { row: n, col: i } = r.tl;
                        let s = 0;
                        if (r.headerRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const { style: n, name: s } = t, a = o.getCell(i + r);
                                a.value = s, e(a, n);
                            });
                        }
                        if (r.rows.forEach((o)=>{
                            const a = t.getRow(n + s++);
                            o.forEach((t, n)=>{
                                const s = a.getCell(i + n);
                                s.value = t, e(s, r.columns[n].style);
                            });
                        }), r.totalsRow) {
                            const o = t.getRow(n + s++);
                            r.columns.forEach((t, r)=>{
                                const n = o.getCell(i + r);
                                if (0 === r) n.value = t.totalsRowLabel;
                                else {
                                    const e = this.getFormula(t);
                                    n.value = e ? {
                                        formula: t.totalsRowFormula,
                                        result: t.totalsRowResult
                                    } : null;
                                }
                                e(n, t.style);
                            });
                        }
                    }
                    load(e) {
                        const { table: t } = this, { row: r, col: n } = t.tl;
                        let i = 0;
                        if (t.headerRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                s.getCell(n + t).value = e.name;
                            });
                        }
                        if (t.rows.forEach((t)=>{
                            const s = e.getRow(r + i++);
                            t.forEach((e, t)=>{
                                s.getCell(n + t).value = e;
                            });
                        }), t.totalsRow) {
                            const s = e.getRow(r + i++);
                            t.columns.forEach((e, t)=>{
                                const r = s.getCell(n + t);
                                if (0 === t) r.value = e.totalsRowLabel;
                                else this.getFormula(e) && (r.value = {
                                    formula: e.totalsRowFormula,
                                    result: e.totalsRowResult
                                });
                            });
                        }
                    }
                    get model() {
                        return this.table;
                    }
                    set model(e) {
                        this.table = e;
                    }
                    cacheState() {
                        this._cache || (this._cache = {
                            ref: this.ref,
                            width: this.width,
                            tableHeight: this.tableHeight
                        });
                    }
                    commit() {
                        if (!this._cache) return;
                        this.validate();
                        const e = n.decodeAddress(this._cache.ref);
                        if (this.ref !== this._cache.ref) for(let t = 0; t < this._cache.tableHeight; t++){
                            const r = this.worksheet.getRow(e.row + t);
                            for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                        }
                        else {
                            for(let t = this.tableHeight; t < this._cache.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = 0; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                            for(let t = 0; t < this.tableHeight; t++){
                                const r = this.worksheet.getRow(e.row + t);
                                for(let t = this.width; t < this._cache.width; t++)r.getCell(e.col + t).value = null;
                            }
                        }
                        this.store();
                    }
                    addRow(e, t) {
                        this.cacheState(), void 0 === t ? this.table.rows.push(e) : this.table.rows.splice(t, 0, e);
                    }
                    removeRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.rows.splice(e, t);
                    }
                    getColumn(e) {
                        const t = this.table.columns[e];
                        return new i(this, t, e);
                    }
                    addColumn(e, t, r) {
                        this.cacheState(), void 0 === r ? (this.table.columns.push(e), this.table.rows.forEach((e, r)=>{
                            e.push(t[r]);
                        })) : (this.table.columns.splice(r, 0, e), this.table.rows.forEach((e, n)=>{
                            e.splice(r, 0, t[n]);
                        }));
                    }
                    removeColumns(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                        this.cacheState(), this.table.columns.splice(e, t), this.table.rows.forEach((r)=>{
                            r.splice(e, t);
                        });
                    }
                    _assign(e, t, r) {
                        this.cacheState(), e[t] = r;
                    }
                    get ref() {
                        return this.table.ref;
                    }
                    set ref(e) {
                        this._assign(this.table, "ref", e);
                    }
                    get name() {
                        return this.table.name;
                    }
                    set name(e) {
                        this.table.name = e;
                    }
                    get displayName() {
                        return this.table.displyName || this.table.name;
                    }
                    set displayNamename(e) {
                        this.table.displayName = e;
                    }
                    get headerRow() {
                        return this.table.headerRow;
                    }
                    set headerRow(e) {
                        this._assign(this.table, "headerRow", e);
                    }
                    get totalsRow() {
                        return this.table.totalsRow;
                    }
                    set totalsRow(e) {
                        this._assign(this.table, "totalsRow", e);
                    }
                    get theme() {
                        return this.table.style.name;
                    }
                    set theme(e) {
                        this.table.style.name = e;
                    }
                    get showFirstColumn() {
                        return this.table.style.showFirstColumn;
                    }
                    set showFirstColumn(e) {
                        this.table.style.showFirstColumn = e;
                    }
                    get showLastColumn() {
                        return this.table.style.showLastColumn;
                    }
                    set showLastColumn(e) {
                        this.table.style.showLastColumn = e;
                    }
                    get showRowStripes() {
                        return this.table.style.showRowStripes;
                    }
                    set showRowStripes(e) {
                        this.table.style.showRowStripes = e;
                    }
                    get showColumnStripes() {
                        return this.table.style.showColumnStripes;
                    }
                    set showColumnStripes(e) {
                        this.table.style.showColumnStripes = e;
                    }
                };
            },
            {
                "../utils/col-cache": 19
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                const n = e("./worksheet"), i = e("./defined-names"), s = e("../xlsx/xlsx"), o = e("../csv/csv");
                t.exports = class {
                    constructor(){
                        this.category = "", this.company = "", this.created = new Date, this.description = "", this.keywords = "", this.manager = "", this.modified = this.created, this.properties = {}, this.calcProperties = {}, this._worksheets = [], this.subject = "", this.title = "", this.views = [], this.media = [], this._definedNames = new i;
                    }
                    get xlsx() {
                        return this._xlsx || (this._xlsx = new s(this)), this._xlsx;
                    }
                    get csv() {
                        return this._csv || (this._csv = new o(this)), this._csv;
                    }
                    get nextId() {
                        for(let e = 1; e < this._worksheets.length; e++)if (!this._worksheets[e]) return e;
                        return this._worksheets.length || 1;
                    }
                    addWorksheet(e, t) {
                        const r = this.nextId;
                        t && ("string" == typeof t ? (console.trace('tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { argb: "rbg value" } }'), t = {
                            properties: {
                                tabColor: {
                                    argb: t
                                }
                            }
                        }) : (t.argb || t.theme || t.indexed) && (console.trace("tabColor argument is now deprecated. Please use workbook.addWorksheet(name, {properties: { tabColor: { ... } }"), t = {
                            properties: {
                                tabColor: t
                            }
                        }));
                        const i = this._worksheets.reduce((e, t)=>(t && t.orderNo) > e ? t.orderNo : e, 0), s = Object.assign({}, t, {
                            id: r,
                            name: e,
                            orderNo: i + 1,
                            workbook: this
                        }), o = new n(s);
                        return this._worksheets[r] = o, o;
                    }
                    removeWorksheetEx(e) {
                        delete this._worksheets[e.id];
                    }
                    removeWorksheet(e) {
                        const t = this.getWorksheet(e);
                        t && t.destroy();
                    }
                    getWorksheet(e) {
                        return void 0 === e ? this._worksheets.find(Boolean) : "number" == typeof e ? this._worksheets[e] : "string" == typeof e ? this._worksheets.find((t)=>t && t.name === e) : void 0;
                    }
                    get worksheets() {
                        return this._worksheets.slice(1).sort((e, t)=>e.orderNo - t.orderNo).filter(Boolean);
                    }
                    eachSheet(e) {
                        this.worksheets.forEach((t)=>{
                            e(t, t.id);
                        });
                    }
                    get definedNames() {
                        return this._definedNames;
                    }
                    clearThemes() {
                        this._themes = void 0;
                    }
                    addImage(e) {
                        const t = this.media.length;
                        return this.media.push(Object.assign({}, e, {
                            type: "image"
                        })), t;
                    }
                    getImage(e) {
                        return this.media[e];
                    }
                    get model() {
                        return {
                            creator: this.creator || "Unknown",
                            lastModifiedBy: this.lastModifiedBy || "Unknown",
                            lastPrinted: this.lastPrinted,
                            created: this.created,
                            modified: this.modified,
                            properties: this.properties,
                            worksheets: this.worksheets.map((e)=>e.model),
                            sheets: this.worksheets.map((e)=>e.model).filter(Boolean),
                            definedNames: this._definedNames.model,
                            views: this.views,
                            company: this.company,
                            manager: this.manager,
                            title: this.title,
                            subject: this.subject,
                            keywords: this.keywords,
                            category: this.category,
                            description: this.description,
                            language: this.language,
                            revision: this.revision,
                            contentStatus: this.contentStatus,
                            themes: this._themes,
                            media: this.media,
                            calcProperties: this.calcProperties
                        };
                    }
                    set model(e) {
                        this.creator = e.creator, this.lastModifiedBy = e.lastModifiedBy, this.lastPrinted = e.lastPrinted, this.created = e.created, this.modified = e.modified, this.company = e.company, this.manager = e.manager, this.title = e.title, this.subject = e.subject, this.keywords = e.keywords, this.category = e.category, this.description = e.description, this.language = e.language, this.revision = e.revision, this.contentStatus = e.contentStatus, this.properties = e.properties, this.calcProperties = e.calcProperties, this._worksheets = [], e.worksheets.forEach((t)=>{
                            const { id: r, name: i, state: s } = t, o = e.sheets && e.sheets.findIndex((e)=>e.id === r);
                            (this._worksheets[r] = new n({
                                id: r,
                                name: i,
                                orderNo: o,
                                state: s,
                                workbook: this
                            })).model = t;
                        }), this._definedNames.model = e.definedNames, this.views = e.views, this._themes = e.themes, this.media = e.media || [];
                    }
                };
            },
            {
                "../csv/csv": 1,
                "../xlsx/xlsx": 144,
                "./defined-names": 6,
                "./worksheet": 14
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                const n = e("../utils/under-dash"), i = e("../utils/col-cache"), s = e("./range"), o = e("./row"), a = e("./column"), l = e("./enums"), c = e("./image"), u = e("./table"), h = e("./data-validations"), f = e("../utils/encryptor"), { copyStyle: d } = e("../utils/copy-style");
                t.exports = class {
                    constructor(e){
                        e = e || {}, this._workbook = e.workbook, this.id = e.id, this.orderNo = e.orderNo, this.name = e.name, this.state = e.state || "visible", this._rows = [], this._columns = null, this._keys = {}, this._merges = {}, this.rowBreaks = [], this.properties = Object.assign({}, {
                            defaultRowHeight: 15,
                            dyDescent: 55,
                            outlineLevelCol: 0,
                            outlineLevelRow: 0
                        }, e.properties), this.pageSetup = Object.assign({}, {
                            margins: {
                                left: .7,
                                right: .7,
                                top: .75,
                                bottom: .75,
                                header: .3,
                                footer: .3
                            },
                            orientation: "portrait",
                            horizontalDpi: 4294967295,
                            verticalDpi: 4294967295,
                            fitToPage: !(!e.pageSetup || !e.pageSetup.fitToWidth && !e.pageSetup.fitToHeight || e.pageSetup.scale),
                            pageOrder: "downThenOver",
                            blackAndWhite: !1,
                            draft: !1,
                            cellComments: "None",
                            errors: "displayed",
                            scale: 100,
                            fitToWidth: 1,
                            fitToHeight: 1,
                            paperSize: void 0,
                            showRowColHeaders: !1,
                            showGridLines: !1,
                            firstPageNumber: void 0,
                            horizontalCentered: !1,
                            verticalCentered: !1,
                            rowBreaks: null,
                            colBreaks: null
                        }, e.pageSetup), this.headerFooter = Object.assign({}, {
                            differentFirst: !1,
                            differentOddEven: !1,
                            oddHeader: null,
                            oddFooter: null,
                            evenHeader: null,
                            evenFooter: null,
                            firstHeader: null,
                            firstFooter: null
                        }, e.headerFooter), this.dataValidations = new h, this.views = e.views || [], this.autoFilter = e.autoFilter || null, this._media = [], this.sheetProtection = null, this.tables = {}, this.conditionalFormattings = [];
                    }
                    get name() {
                        return this._name;
                    }
                    set name(e) {
                        if (void 0 === e && (e = "sheet" + this.id), this._name !== e) {
                            if ("string" != typeof e) throw new Error("The name has to be a string.");
                            if ("" === e) throw new Error("The name can't be empty.");
                            if ("History" === e) throw new Error('The name "History" is protected. Please use a different name.');
                            if (/[*?:/\\[\]]/.test(e)) throw new Error(`Worksheet name ${e} cannot include any of the following characters: * ? : \\ / [ ]`);
                            if (/(^')|('$)/.test(e)) throw new Error("The first or last character of worksheet name cannot be a single quotation mark: " + e);
                            if (e && e.length > 31 && (console.warn(`Worksheet name ${e} exceeds 31 chars. This will be truncated`), e = e.substring(0, 31)), this._workbook._worksheets.find((t)=>t && t.name.toLowerCase() === e.toLowerCase())) throw new Error("Worksheet name already exists: " + e);
                            this._name = e;
                        }
                    }
                    get workbook() {
                        return this._workbook;
                    }
                    destroy() {
                        this._workbook.removeWorksheetEx(this);
                    }
                    get dimensions() {
                        const e = new s;
                        return this._rows.forEach((t)=>{
                            if (t) {
                                const r = t.dimensions;
                                r && e.expand(t.number, r.min, t.number, r.max);
                            }
                        }), e;
                    }
                    get columns() {
                        return this._columns;
                    }
                    set columns(e) {
                        this._headerRowCount = e.reduce((e, t)=>{
                            const r = (t.header ? 1 : t.headers && t.headers.length) || 0;
                            return Math.max(e, r);
                        }, 0);
                        let t = 1;
                        const r = this._columns = [];
                        e.forEach((e)=>{
                            const n = new a(this, t++, !1);
                            r.push(n), n.defn = e;
                        });
                    }
                    getColumnKey(e) {
                        return this._keys[e];
                    }
                    setColumnKey(e, t) {
                        this._keys[e] = t;
                    }
                    deleteColumnKey(e) {
                        delete this._keys[e];
                    }
                    eachColumnKey(e) {
                        n.each(this._keys, e);
                    }
                    getColumn(e) {
                        if ("string" == typeof e) {
                            const t = this._keys[e];
                            if (t) return t;
                            e = i.l2n(e);
                        }
                        if (this._columns || (this._columns = []), e > this._columns.length) {
                            let t = this._columns.length + 1;
                            for(; t <= e;)this._columns.push(new a(this, t++));
                        }
                        return this._columns[e - 1];
                    }
                    spliceColumns(e, t) {
                        const r = this._rows.length;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        if (i.length > 0) for(let n = 0; n < r; n++){
                            const r = [
                                e,
                                t
                            ];
                            i.forEach((e)=>{
                                r.push(e[n] || null);
                            });
                            const s = this.getRow(n + 1);
                            s.splice.apply(s, r);
                        }
                        else this._rows.forEach((r)=>{
                            r && r.splice(e, t);
                        });
                        const o = i.length - t, a = e + t, l = this._columns.length;
                        if (o < 0) for(let t = e + i.length; t <= l; t++)this.getColumn(t).defn = this.getColumn(t - o).defn;
                        else if (o > 0) for(let e = l; e >= a; e--)this.getColumn(e + o).defn = this.getColumn(e).defn;
                        for(let t = e; t < e + i.length; t++)this.getColumn(t).defn = null;
                        this.workbook.definedNames.spliceColumns(this.name, e, t, i.length);
                    }
                    get lastColumn() {
                        return this.getColumn(this.columnCount);
                    }
                    get columnCount() {
                        let e = 0;
                        return this.eachRow((t)=>{
                            e = Math.max(e, t.cellCount);
                        }), e;
                    }
                    get actualColumnCount() {
                        const e = [];
                        let t = 0;
                        return this.eachRow((r)=>{
                            r.eachCell((r)=>{
                                let { col: n } = r;
                                e[n] || (e[n] = !0, t++);
                            });
                        }), t;
                    }
                    _commitRow() {}
                    get _lastRowNumber() {
                        const e = this._rows;
                        let t = e.length;
                        for(; t > 0 && void 0 === e[t - 1];)t--;
                        return t;
                    }
                    get _nextRow() {
                        return this._lastRowNumber + 1;
                    }
                    get lastRow() {
                        if (this._rows.length) return this._rows[this._rows.length - 1];
                    }
                    findRow(e) {
                        return this._rows[e - 1];
                    }
                    findRows(e, t) {
                        return this._rows.slice(e - 1, e - 1 + t);
                    }
                    get rowCount() {
                        return this._lastRowNumber;
                    }
                    get actualRowCount() {
                        let e = 0;
                        return this.eachRow(()=>{
                            e++;
                        }), e;
                    }
                    getRow(e) {
                        let t = this._rows[e - 1];
                        return t || (t = this._rows[e - 1] = new o(this, e)), t;
                    }
                    getRows(e, t) {
                        if (t < 1) return;
                        const r = [];
                        for(let n = e; n < e + t; n++)r.push(this.getRow(n));
                        return r;
                    }
                    addRow(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = this._nextRow, n = this.getRow(r);
                        return n.values = e, this._setStyleOption(r, "i" === t[0] ? t : "n"), n;
                    }
                    addRows(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        const r = [];
                        return e.forEach((e)=>{
                            r.push(this.addRow(e, t));
                        }), r;
                    }
                    insertRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        return this.spliceRows(e, 0, t), this._setStyleOption(e, r), this.getRow(e);
                    }
                    insertRows(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "n";
                        if (this.spliceRows(e, 0, ...t), "n" !== r) for(let n = 0; n < t.length; n++)"o" === r[0] && void 0 !== this.findRow(t.length + e + n) ? this._copyStyle(t.length + e + n, e + n, "+" === r[1]) : "i" === r[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e + n, "+" === r[1]);
                        return this.getRows(e, t.length);
                    }
                    _setStyleOption(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "n";
                        "o" === t[0] && void 0 !== this.findRow(e + 1) ? this._copyStyle(e + 1, e, "+" === t[1]) : "i" === t[0] && void 0 !== this.findRow(e - 1) && this._copyStyle(e - 1, e, "+" === t[1]);
                    }
                    _copyStyle(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this.getRow(e), i = this.getRow(t);
                        i.style = d(n.style), n.eachCell({
                            includeEmpty: r
                        }, (e, t)=>{
                            i.getCell(t).style = d(e.style);
                        }), i.height = n.height;
                    }
                    duplicateRow(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const n = this._rows[e - 1], i = new Array(t).fill(n.values);
                        this.spliceRows(e + 1, r ? 0 : t, ...i);
                        for(let r = 0; r < t; r++){
                            const t = this._rows[e + r];
                            t.style = n.style, t.height = n.height, n.eachCell({
                                includeEmpty: !0
                            }, (e, r)=>{
                                t.getCell(r).style = e.style;
                            });
                        }
                    }
                    spliceRows(e, t) {
                        const r = e + t;
                        for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), s = 2; s < n; s++)i[s - 2] = arguments[s];
                        const o = i.length, a = o - t, l = this._rows.length;
                        let c, u;
                        if (a < 0) for(e === l && (this._rows[l - 1] = void 0), c = r; c <= l; c++)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                e.getCell(r).style = t.style;
                            }), this._rows[c - 1] = void 0;
                        } else this._rows[c + a - 1] = void 0;
                        else if (a > 0) for(c = l; c >= r; c--)if (u = this._rows[c - 1], u) {
                            const e = this.getRow(c + a);
                            e.values = u.values, e.style = u.style, e.height = u.height, u.eachCell({
                                includeEmpty: !0
                            }, (t, r)=>{
                                if (e.getCell(r).style = t.style, "MergeValue" === t._value.constructor.name) {
                                    const e = this.getRow(t._row._number + o).getCell(r), n = t._value._master, i = this.getRow(n._row._number + o).getCell(n._column._number);
                                    e.merge(i);
                                }
                            });
                        } else this._rows[c + a - 1] = void 0;
                        for(c = 0; c < o; c++){
                            const t = this.getRow(e + c);
                            t.style = {}, t.values = i[c];
                        }
                        this.workbook.definedNames.spliceRows(this.name, e, t, o);
                    }
                    eachRow(e, t) {
                        if (t || (t = e, e = void 0), e && e.includeEmpty) {
                            const e = this._rows.length;
                            for(let r = 1; r <= e; r++)t(this.getRow(r), r);
                        } else this._rows.forEach((e)=>{
                            e && e.hasValues && t(e, e.number);
                        });
                    }
                    getSheetValues() {
                        const e = [];
                        return this._rows.forEach((t)=>{
                            t && (e[t.number] = t.values);
                        }), e;
                    }
                    findCell(e, t) {
                        const r = i.getAddress(e, t), n = this._rows[r.row - 1];
                        return n ? n.findCell(r.col) : void 0;
                    }
                    getCell(e, t) {
                        const r = i.getAddress(e, t);
                        return this.getRow(r.row).getCellEx(r);
                    }
                    mergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n);
                    }
                    mergeCellsWithoutStyle() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        this._mergeCellsInternal(n, !0);
                    }
                    _mergeCellsInternal(e, t) {
                        n.each(this._merges, (t)=>{
                            if (t.intersects(e)) throw new Error("Cannot merge already merged cells");
                        });
                        const r = this.getCell(e.top, e.left);
                        for(let n = e.top; n <= e.bottom; n++)for(let i = e.left; i <= e.right; i++)(n > e.top || i > e.left) && this.getCell(n, i).merge(r, t);
                        this._merges[r.address] = e;
                    }
                    _unMergeMaster(e) {
                        const t = this._merges[e.address];
                        if (t) {
                            for(let e = t.top; e <= t.bottom; e++)for(let r = t.left; r <= t.right; r++)this.getCell(e, r).unmerge();
                            delete this._merges[e.address];
                        }
                    }
                    get hasMerges() {
                        return n.some(this._merges, Boolean);
                    }
                    unMergeCells() {
                        for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                        const n = new s(t);
                        for(let e = n.top; e <= n.bottom; e++)for(let t = n.left; t <= n.right; t++){
                            const r = this.findCell(e, t);
                            r && (r.type === l.ValueType.Merge ? this._unMergeMaster(r.master) : this._merges[r.address] && this._unMergeMaster(r));
                        }
                    }
                    fillFormula(e, t, r) {
                        let n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "shared";
                        const s = i.decode(e), { top: o, left: a, bottom: l, right: c } = s, u = c - a + 1, h = i.encodeAddress(o, a), f = "shared" === n;
                        let d;
                        d = "function" == typeof r ? r : Array.isArray(r) ? Array.isArray(r[0]) ? (e, t)=>r[e - o][t - a] : (e, t)=>r[(e - o) * u + (t - a)] : ()=>{};
                        let p = !0;
                        for(let r = o; r <= l; r++)for(let i = a; i <= c; i++)p ? (this.getCell(r, i).value = {
                            shareType: n,
                            formula: t,
                            ref: e,
                            result: d(r, i)
                        }, p = !1) : this.getCell(r, i).value = f ? {
                            sharedFormula: h,
                            result: d(r, i)
                        } : d(r, i);
                    }
                    addImage(e, t) {
                        const r = {
                            type: "image",
                            imageId: e,
                            range: t
                        };
                        this._media.push(new c(this, r));
                    }
                    getImages() {
                        return this._media.filter((e)=>"image" === e.type);
                    }
                    addBackgroundImage(e) {
                        const t = {
                            type: "background",
                            imageId: e
                        };
                        this._media.push(new c(this, t));
                    }
                    getBackgroundImageId() {
                        const e = this._media.find((e)=>"background" === e.type);
                        return e && e.imageId;
                    }
                    protect(e, t) {
                        return new Promise((r)=>{
                            this.sheetProtection = {
                                sheet: !0
                            }, t && "spinCount" in t && (t.spinCount = Number.isFinite(t.spinCount) ? Math.round(Math.max(0, t.spinCount)) : 1e5), e && (this.sheetProtection.algorithmName = "SHA-512", this.sheetProtection.saltValue = f.randomBytes(16).toString("base64"), this.sheetProtection.spinCount = t && "spinCount" in t ? t.spinCount : 1e5, this.sheetProtection.hashValue = f.convertPasswordToHash(e, "SHA512", this.sheetProtection.saltValue, this.sheetProtection.spinCount)), t && (this.sheetProtection = Object.assign(this.sheetProtection, t), !e && "spinCount" in t && delete this.sheetProtection.spinCount), r();
                        });
                    }
                    unprotect() {
                        this.sheetProtection = null;
                    }
                    addTable(e) {
                        const t = new u(this, e);
                        return this.tables[e.name] = t, t;
                    }
                    getTable(e) {
                        return this.tables[e];
                    }
                    removeTable(e) {
                        delete this.tables[e];
                    }
                    getTables() {
                        return Object.values(this.tables);
                    }
                    addConditionalFormatting(e) {
                        this.conditionalFormattings.push(e);
                    }
                    removeConditionalFormatting(e) {
                        "number" == typeof e ? this.conditionalFormattings.splice(e, 1) : this.conditionalFormattings = e instanceof Function ? this.conditionalFormattings.filter(e) : [];
                    }
                    get tabColor() {
                        return console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor;
                    }
                    set tabColor(e) {
                        console.trace("worksheet.tabColor property is now deprecated. Please use worksheet.properties.tabColor"), this.properties.tabColor = e;
                    }
                    get model() {
                        const e = {
                            id: this.id,
                            name: this.name,
                            dataValidations: this.dataValidations.model,
                            properties: this.properties,
                            state: this.state,
                            pageSetup: this.pageSetup,
                            headerFooter: this.headerFooter,
                            rowBreaks: this.rowBreaks,
                            views: this.views,
                            autoFilter: this.autoFilter,
                            media: this._media.map((e)=>e.model),
                            sheetProtection: this.sheetProtection,
                            tables: Object.values(this.tables).map((e)=>e.model),
                            conditionalFormattings: this.conditionalFormattings
                        };
                        e.cols = a.toModel(this.columns);
                        const t = e.rows = [], r = e.dimensions = new s;
                        return this._rows.forEach((e)=>{
                            const n = e && e.model;
                            n && (r.expand(n.number, n.min, n.number, n.max), t.push(n));
                        }), e.merges = [], n.each(this._merges, (t)=>{
                            e.merges.push(t.range);
                        }), e;
                    }
                    _parseRows(e) {
                        this._rows = [], e.rows.forEach((e)=>{
                            const t = new o(this, e.number);
                            this._rows[t.number - 1] = t, t.model = e;
                        });
                    }
                    _parseMergeCells(e) {
                        n.each(e.mergeCells, (e)=>{
                            this.mergeCellsWithoutStyle(e);
                        });
                    }
                    set model(e) {
                        this.name = e.name, this._columns = a.fromModel(this, e.cols), this._parseRows(e), this._parseMergeCells(e), this.dataValidations = new h(e.dataValidations), this.properties = e.properties, this.pageSetup = e.pageSetup, this.headerFooter = e.headerFooter, this.views = e.views, this.autoFilter = e.autoFilter, this._media = e.media.map((e)=>new c(this, e)), this.sheetProtection = e.sheetProtection, this.tables = e.tables.reduce((e, t)=>{
                            const r = new u;
                            return r.model = t, e[t.name] = r, e;
                        }, {}), this.conditionalFormattings = e.conditionalFormattings;
                    }
                };
            },
            {
                "../utils/col-cache": 19,
                "../utils/copy-style": 20,
                "../utils/encryptor": 21,
                "../utils/under-dash": 26,
                "./column": 4,
                "./data-validations": 5,
                "./enums": 7,
                "./image": 8,
                "./range": 10,
                "./row": 11,
                "./table": 12
            }
        ],
        15: [
            function(e, t, r) {
                "use strict";
                e("core-js/modules/es.promise"), e("core-js/modules/es.promise.finally"), e("core-js/modules/es.object.assign"), e("core-js/modules/es.object.keys"), e("core-js/modules/es.object.values"), e("core-js/modules/es.symbol"), e("core-js/modules/es.symbol.async-iterator"), e("core-js/modules/es.array.iterator"), e("core-js/modules/es.array.includes"), e("core-js/modules/es.array.find-index"), e("core-js/modules/es.array.find"), e("core-js/modules/es.string.from-code-point"), e("core-js/modules/es.string.includes"), e("core-js/modules/es.number.is-nan"), e("regenerator-runtime/runtime");
                const n = {
                    Workbook: e("./doc/workbook")
                }, i = e("./doc/enums");
                Object.keys(i).forEach((e)=>{
                    n[e] = i[e];
                }), t.exports = n;
            },
            {
                "./doc/enums": 7,
                "./doc/workbook": 13,
                "core-js/modules/es.array.find": 359,
                "core-js/modules/es.array.find-index": 358,
                "core-js/modules/es.array.includes": 360,
                "core-js/modules/es.array.iterator": 361,
                "core-js/modules/es.number.is-nan": 363,
                "core-js/modules/es.object.assign": 364,
                "core-js/modules/es.object.keys": 366,
                "core-js/modules/es.object.values": 367,
                "core-js/modules/es.promise": 372,
                "core-js/modules/es.promise.finally": 371,
                "core-js/modules/es.string.from-code-point": 376,
                "core-js/modules/es.string.includes": 377,
                "core-js/modules/es.symbol": 381,
                "core-js/modules/es.symbol.async-iterator": 378,
                "regenerator-runtime/runtime": 492
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                r.bufferToString = function(e) {
                    return "string" == typeof e ? e : n ? n.decode(e) : e.toString();
                };
            },
            {}
        ],
        17: [
            function(e, t, r) {
                "use strict";
                const n = "undefined" == typeof TextEncoder ? null : new TextEncoder("utf-8"), { Buffer: i } = e("buffer");
                r.stringToBuffer = function(e) {
                    return "string" != typeof e ? e : n ? i.from(n.encode(e).buffer) : i.from(e);
                };
            },
            {
                buffer: 220
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./col-cache");
                t.exports = class {
                    constructor(e){
                        this.template = e, this.sheets = {};
                    }
                    addCell(e) {
                        this.addCellEx(i.decodeEx(e));
                    }
                    getCell(e) {
                        return this.findCellEx(i.decodeEx(e), !0);
                    }
                    findCell(e) {
                        return this.findCellEx(i.decodeEx(e), !1);
                    }
                    findCellAt(e, t, r) {
                        const n = this.sheets[e], i = n && n[t];
                        return i && i[r];
                    }
                    addCellEx(e) {
                        if (e.top) for(let t = e.top; t <= e.bottom; t++)for(let r = e.left; r <= e.right; r++)this.getCellAt(e.sheetName, t, r);
                        else this.findCellEx(e, !0);
                    }
                    getCellEx(e) {
                        return this.findCellEx(e, !0);
                    }
                    findCellEx(e, t) {
                        const r = this.findSheet(e, t), n = this.findSheetRow(r, e, t);
                        return this.findRowCell(n, e, t);
                    }
                    getCellAt(e, t, r) {
                        const n = this.sheets[e] || (this.sheets[e] = []), s = n[t] || (n[t] = []);
                        return s[r] || (s[r] = {
                            sheetName: e,
                            address: i.n2l(r) + t,
                            row: t,
                            col: r
                        });
                    }
                    removeCellEx(e) {
                        const t = this.findSheet(e);
                        if (!t) return;
                        const r = this.findSheetRow(t, e);
                        r && delete r[e.col];
                    }
                    forEachInSheet(e, t) {
                        const r = this.sheets[e];
                        r && r.forEach((e, r)=>{
                            e && e.forEach((e, n)=>{
                                e && t(e, r, n);
                            });
                        });
                    }
                    forEach(e) {
                        n.each(this.sheets, (t, r)=>{
                            this.forEachInSheet(r, e);
                        });
                    }
                    map(e) {
                        const t = [];
                        return this.forEach((r)=>{
                            t.push(e(r));
                        }), t;
                    }
                    findSheet(e, t) {
                        const r = e.sheetName;
                        return this.sheets[r] ? this.sheets[r] : t ? this.sheets[r] = [] : void 0;
                    }
                    findSheetRow(e, t, r) {
                        const { row: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = [] : void 0;
                    }
                    findRowCell(e, t, r) {
                        const { col: n } = t;
                        return e && e[n] ? e[n] : r ? e[n] = this.template ? Object.assign(t, JSON.parse(JSON.stringify(this.template))) : t : void 0;
                    }
                    spliceRows(e, t, r, n) {
                        const i = this.sheets[e];
                        if (i) {
                            const e = [];
                            for(let t = 0; t < n; t++)e.push([]);
                            i.splice(t, r, ...e);
                        }
                    }
                    spliceColumns(e, t, r, i) {
                        const s = this.sheets[e];
                        if (s) {
                            const e = [];
                            for(let t = 0; t < i; t++)e.push(null);
                            n.each(s, (n)=>{
                                n.splice(t, r, ...e);
                            });
                        }
                    }
                };
            },
            {
                "./col-cache": 19,
                "./under-dash": 26
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                const n = /^[A-Z]+\d+$/, i = {
                    _dictionary: [
                        "A",
                        "B",
                        "C",
                        "D",
                        "E",
                        "F",
                        "G",
                        "H",
                        "I",
                        "J",
                        "K",
                        "L",
                        "M",
                        "N",
                        "O",
                        "P",
                        "Q",
                        "R",
                        "S",
                        "T",
                        "U",
                        "V",
                        "W",
                        "X",
                        "Y",
                        "Z"
                    ],
                    _l2nFill: 0,
                    _l2n: {},
                    _n2l: [],
                    _level: (e)=>e <= 26 ? 1 : e <= 676 ? 2 : 3,
                    _fill (e) {
                        let t, r, n, i, s, o = 1;
                        if (e >= 4) throw new Error("Out of bounds. Excel supports columns from 1 to 16384");
                        if (this._l2nFill < 1 && e >= 1) {
                            for(; o <= 26;)t = this._dictionary[o - 1], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 1;
                        }
                        if (this._l2nFill < 2 && e >= 2) {
                            for(o = 27; o <= 702;)r = o - 27, n = r % 26, i = Math.floor(r / 26), t = this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 2;
                        }
                        if (this._l2nFill < 3 && e >= 3) {
                            for(o = 703; o <= 16384;)r = o - 703, n = r % 26, i = Math.floor(r / 26) % 26, s = Math.floor(r / 676), t = this._dictionary[s] + this._dictionary[i] + this._dictionary[n], this._n2l[o] = t, this._l2n[t] = o, o++;
                            this._l2nFill = 3;
                        }
                    },
                    l2n (e) {
                        if (this._l2n[e] || this._fill(e.length), !this._l2n[e]) throw new Error("Out of bounds. Invalid column letter: " + e);
                        return this._l2n[e];
                    },
                    n2l (e) {
                        if (e < 1 || e > 16384) throw new Error(e + " is out of bounds. Excel supports columns from 1 to 16384");
                        return this._n2l[e] || this._fill(this._level(e)), this._n2l[e];
                    },
                    _hash: {},
                    validateAddress (e) {
                        if (!n.test(e)) throw new Error("Invalid Address: " + e);
                        return !0;
                    },
                    decodeAddress (e) {
                        const t = e.length < 5 && this._hash[e];
                        if (t) return t;
                        let r = !1, n = "", i = 0, s = !1, o = "", a = 0;
                        for(let t, l = 0; l < e.length; l++)if (t = e.charCodeAt(l), !s && t >= 65 && t <= 90) r = !0, n += e[l], i = 26 * i + t - 64;
                        else if (t >= 48 && t <= 57) s = !0, o += e[l], a = 10 * a + t - 48;
                        else if (s && r && 36 !== t) break;
                        if (r) {
                            if (i > 16384) throw new Error("Out of bounds. Invalid column letter: " + n);
                        } else i = void 0;
                        s || (a = void 0);
                        const l = {
                            address: e = n + o,
                            col: i,
                            row: a,
                            $col$row: `$${n}$${o}`
                        };
                        return i <= 100 && a <= 100 && (this._hash[e] = l, this._hash[l.$col$row] = l), l;
                    },
                    getAddress (e, t) {
                        if (t) {
                            const r = this.n2l(t) + e;
                            return this.decodeAddress(r);
                        }
                        return this.decodeAddress(e);
                    },
                    decode (e) {
                        const t = e.split(":");
                        if (2 === t.length) {
                            const e = this.decodeAddress(t[0]), r = this.decodeAddress(t[1]), n = {
                                top: Math.min(e.row, r.row),
                                left: Math.min(e.col, r.col),
                                bottom: Math.max(e.row, r.row),
                                right: Math.max(e.col, r.col)
                            };
                            return n.tl = this.n2l(n.left) + n.top, n.br = this.n2l(n.right) + n.bottom, n.dimensions = `${n.tl}:${n.br}`, n;
                        }
                        return this.decodeAddress(e);
                    },
                    decodeEx (e) {
                        const t = e.match(/(?:(?:(?:'((?:[^']|'')*)')|([^'^ !]*))!)?(.*)/), r = t[1] || t[2], n = t[3], i = n.split(":");
                        if (i.length > 1) {
                            let e = this.decodeAddress(i[0]), t = this.decodeAddress(i[1]);
                            const n = Math.min(e.row, t.row), s = Math.min(e.col, t.col), o = Math.max(e.row, t.row), a = Math.max(e.col, t.col);
                            return e = this.n2l(s) + n, t = this.n2l(a) + o, {
                                top: n,
                                left: s,
                                bottom: o,
                                right: a,
                                sheetName: r,
                                tl: {
                                    address: e,
                                    col: s,
                                    row: n,
                                    $col$row: `$${this.n2l(s)}$${n}`,
                                    sheetName: r
                                },
                                br: {
                                    address: t,
                                    col: a,
                                    row: o,
                                    $col$row: `$${this.n2l(a)}$${o}`,
                                    sheetName: r
                                },
                                dimensions: `${e}:${t}`
                            };
                        }
                        if (n.startsWith("#")) return r ? {
                            sheetName: r,
                            error: n
                        } : {
                            error: n
                        };
                        const s = this.decodeAddress(n);
                        return r ? {
                            sheetName: r,
                            ...s
                        } : s;
                    },
                    encodeAddress: (e, t)=>i.n2l(t) + e,
                    encode () {
                        switch(arguments.length){
                            case 2:
                                return i.encodeAddress(arguments[0], arguments[1]);
                            case 4:
                                return `${i.encodeAddress(arguments[0], arguments[1])}:${i.encodeAddress(arguments[2], arguments[3])}`;
                            default:
                                throw new Error("Can only encode with 2 or 4 arguments");
                        }
                    },
                    inRange (e, t) {
                        const [r, n, , i, s] = e, [o, a] = t;
                        return o >= r && o <= i && a >= n && a <= s;
                    }
                };
                t.exports = i;
            },
            {}
        ],
        20: [
            function(e, t, r) {
                "use strict";
                const n = (e, t)=>({
                        ...e,
                        ...t.reduce((t, r)=>(e[r] && (t[r] = {
                                ...e[r]
                            }), t), {})
                    }), i = function(e, t, r) {
                    let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
                    e[r] && (t[r] = n(e[r], i));
                };
                r.copyStyle = (e)=>{
                    if (!e) return e;
                    if (t = e, 0 === Object.keys(t).length) return {};
                    var t;
                    const r = {
                        ...e
                    };
                    return i(e, r, "font", [
                        "color"
                    ]), i(e, r, "alignment"), i(e, r, "protection"), e.border && (i(e, r, "border"), i(e.border, r.border, "top", [
                        "color"
                    ]), i(e.border, r.border, "left", [
                        "color"
                    ]), i(e.border, r.border, "bottom", [
                        "color"
                    ]), i(e.border, r.border, "right", [
                        "color"
                    ]), i(e.border, r.border, "diagonal", [
                        "color"
                    ])), e.fill && (i(e, r, "fill", [
                        "fgColor",
                        "bgColor",
                        "center"
                    ]), e.fill.stops && (r.fill.stops = e.fill.stops.map((e)=>n(e, [
                            "color"
                        ])))), r;
                };
            },
            {}
        ],
        21: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("crypto"), i = {
                            hash (e) {
                                const t = n.createHash(e);
                                for(var i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)s[o - 1] = arguments[o];
                                return t.update(r.concat(s)), t.digest();
                            },
                            convertPasswordToHash (e, t, i, s) {
                                t = t.toLowerCase();
                                if (n.getHashes().indexOf(t) < 0) throw new Error(`Hash algorithm '${t}' not supported!`);
                                const o = r.from(e, "utf16le");
                                let a = this.hash(t, r.from(i, "base64"), o);
                                for(let e = 0; e < s; e++){
                                    const n = r.alloc(4);
                                    n.writeUInt32LE(e, 0), a = this.hash(t, a, n);
                                }
                                return a.toString("base64");
                            },
                            randomBytes: (e)=>n.randomBytes(e)
                        };
                        t.exports = i;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                crypto: 390
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                const { SaxesParser: n } = e("saxes"), { PassThrough: i } = e("readable-stream"), { bufferToString: s } = e("./browser-buffer-decode");
                t.exports = async function*(e) {
                    e.pipe && !e[Symbol.asyncIterator] && (e = e.pipe(new i));
                    const t = new n;
                    let r;
                    t.on("error", (e)=>{
                        r = e;
                    });
                    let o = [];
                    t.on("opentag", (e)=>o.push({
                            eventType: "opentag",
                            value: e
                        })), t.on("text", (e)=>o.push({
                            eventType: "text",
                            value: e
                        })), t.on("closetag", (e)=>o.push({
                            eventType: "closetag",
                            value: e
                        }));
                    for await (const n of e){
                        if (t.write(s(n)), r) throw r;
                        yield o, o = [];
                    }
                };
            },
            {
                "./browser-buffer-decode": 16,
                "readable-stream": 491,
                saxes: 496
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                const n = e("./col-cache"), i = /(([a-z_\-0-9]*)!)?([a-z0-9_$]{2,})([(])?/gi, s = /^([$])?([a-z]+)([$])?([1-9][0-9]*)$/i;
                t.exports = {
                    slideFormula: function(e, t, r) {
                        const o = n.decode(t), a = n.decode(r);
                        return e.replace(i, (e, t, r, i, l)=>{
                            if (l) return e;
                            const c = s.exec(i);
                            if (c) {
                                const r = c[1], i = c[2].toUpperCase(), s = c[3], l = c[4];
                                if (i.length > 3 || 3 === i.length && i > "XFD") return e;
                                let u = n.l2n(i), h = parseInt(l, 10);
                                r || (u += a.col - o.col), s || (h += a.row - o.row);
                                return (t || "") + (r || "") + n.n2l(u) + (s || "") + h;
                            }
                            return e;
                        });
                    }
                };
            },
            {
                "./col-cache": 19
            }
        ],
        24: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("readable-stream"), s = e("./utils"), o = e("./string-buf");
                        class a {
                            constructor(e, t){
                                this._data = e, this._encoding = t;
                            }
                            get length() {
                                return this.toBuffer().length;
                            }
                            copy(e, t, r, n) {
                                return this.toBuffer().copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = n.from(this._data, this._encoding)), this._buffer;
                            }
                        }
                        class l {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                return this._data._buf.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data.toBuffer();
                            }
                        }
                        class c {
                            constructor(e){
                                this._data = e;
                            }
                            get length() {
                                return this._data.length;
                            }
                            copy(e, t, r, n) {
                                this._data.copy(e, t, r, n);
                            }
                            toBuffer() {
                                return this._data;
                            }
                        }
                        class u {
                            constructor(e){
                                this.size = e, this.buffer = n.alloc(e), this.iRead = 0, this.iWrite = 0;
                            }
                            toBuffer() {
                                if (0 === this.iRead && this.iWrite === this.size) return this.buffer;
                                const e = n.alloc(this.iWrite - this.iRead);
                                return this.buffer.copy(e, 0, this.iRead, this.iWrite), e;
                            }
                            get length() {
                                return this.iWrite - this.iRead;
                            }
                            get eod() {
                                return this.iRead === this.iWrite;
                            }
                            get full() {
                                return this.iWrite === this.size;
                            }
                            read(e) {
                                let t;
                                return 0 === e ? null : void 0 === e || e >= this.length ? (t = this.toBuffer(), this.iRead = this.iWrite, t) : (t = n.alloc(e), this.buffer.copy(t, 0, this.iRead, e), this.iRead += e, t);
                            }
                            write(e, t, r) {
                                const n = Math.min(r, this.size - this.iWrite);
                                return e.copy(this.buffer, this.iWrite, t, t + n), this.iWrite += n, n;
                            }
                        }
                        const h = function(e) {
                            e = e || {}, this.bufSize = e.bufSize || 1048576, this.buffers = [], this.batch = e.batch || !1, this.corked = !1, this.inPos = 0, this.outPos = 0, this.pipes = [], this.paused = !1, this.encoding = null;
                        };
                        s.inherits(h, i.Duplex, {
                            toBuffer () {
                                switch(this.buffers.length){
                                    case 0:
                                        return null;
                                    case 1:
                                        return this.buffers[0].toBuffer();
                                    default:
                                        return n.concat(this.buffers.map((e)=>e.toBuffer()));
                                }
                            },
                            _getWritableBuffer () {
                                if (this.buffers.length) {
                                    const e = this.buffers[this.buffers.length - 1];
                                    if (!e.full) return e;
                                }
                                const e = new u(this.bufSize);
                                return this.buffers.push(e), e;
                            },
                            async _pipe (e) {
                                await Promise.all(this.pipes.map(function(t) {
                                    return new Promise((r)=>{
                                        t.write(e.toBuffer(), ()=>{
                                            r();
                                        });
                                    });
                                }));
                            },
                            _writeToBuffers (e) {
                                let t = 0;
                                const r = e.length;
                                for(; t < r;)t += this._getWritableBuffer().write(e, t, r - t);
                            },
                            async write (e, t, i) {
                                let u;
                                if (t instanceof Function && (i = t, t = "utf8"), i = i || s.nop, e instanceof o) u = new l(e);
                                else if (e instanceof n) u = new c(e);
                                else {
                                    if (!("string" == typeof e || e instanceof String || e instanceof ArrayBuffer)) throw new Error("Chunk must be one of type String, Buffer or StringBuf.");
                                    u = new a(e, t);
                                }
                                if (this.pipes.length) {
                                    if (this.batch) for(this._writeToBuffers(u); !this.corked && this.buffers.length > 1;)this._pipe(this.buffers.shift());
                                    else this.corked ? (this._writeToBuffers(u), r.nextTick(i)) : (await this._pipe(u), i());
                                } else this.paused || this.emit("data", u.toBuffer()), this._writeToBuffers(u), this.emit("readable");
                                return !0;
                            },
                            cork () {
                                this.corked = !0;
                            },
                            _flush () {
                                if (this.pipes.length) for(; this.buffers.length;)this._pipe(this.buffers.shift());
                            },
                            uncork () {
                                this.corked = !1, this._flush();
                            },
                            end (e, t, r) {
                                const n = (e)=>{
                                    e ? r(e) : (this._flush(), this.pipes.forEach((e)=>{
                                        e.end();
                                    }), this.emit("finish"));
                                };
                                e ? this.write(e, t, n) : n();
                            },
                            read (e) {
                                let t;
                                if (e) {
                                    for(t = []; e && this.buffers.length && !this.buffers[0].eod;){
                                        const r = this.buffers[0], n = r.read(e);
                                        e -= n.length, t.push(n), r.eod && r.full && this.buffers.shift();
                                    }
                                    return n.concat(t);
                                }
                                return t = this.buffers.map((e)=>e.toBuffer()).filter(Boolean), this.buffers = [], n.concat(t);
                            },
                            setEncoding (e) {
                                this.encoding = e;
                            },
                            pause () {
                                this.paused = !0;
                            },
                            resume () {
                                this.paused = !1;
                            },
                            isPaused () {
                                return !!this.paused;
                            },
                            pipe (e) {
                                this.pipes.push(e), !this.paused && this.buffers.length && this.end();
                            },
                            unpipe (e) {
                                this.pipes = this.pipes.filter((t)=>t !== e);
                            },
                            unshift () {
                                throw new Error("Not Implemented");
                            },
                            wrap () {
                                throw new Error("Not Implemented");
                            }
                        }), t.exports = h;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "./string-buf": 25,
                "./utils": 27,
                _process: 467,
                buffer: 220,
                "readable-stream": 491
            }
        ],
        25: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = class {
                            constructor(t){
                                this._buf = e.alloc(t && t.size || 16384), this._encoding = t && t.encoding || "utf8", this._inPos = 0, this._buffer = void 0;
                            }
                            get length() {
                                return this._inPos;
                            }
                            get capacity() {
                                return this._buf.length;
                            }
                            get buffer() {
                                return this._buf;
                            }
                            toBuffer() {
                                return this._buffer || (this._buffer = e.alloc(this.length), this._buf.copy(this._buffer, 0, 0, this.length)), this._buffer;
                            }
                            reset(e) {
                                e = e || 0, this._buffer = void 0, this._inPos = e;
                            }
                            _grow(t) {
                                let r = 2 * this._buf.length;
                                for(; r < t;)r *= 2;
                                const n = e.alloc(r);
                                this._buf.copy(n, 0), this._buf = n;
                            }
                            addText(e) {
                                this._buffer = void 0;
                                let t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                for(; t >= this._buf.length - 4;)this._grow(this._inPos + e.length), t = this._inPos + this._buf.write(e, this._inPos, this._encoding);
                                this._inPos = t;
                            }
                            addStringBuf(e) {
                                e.length && (this._buffer = void 0, this.length + e.length > this.capacity && this._grow(this.length + e.length), e._buf.copy(this._buf, this._inPos, 0, e.length), this._inPos += e.length);
                            }
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                const { toString: n } = Object.prototype, i = /["&<>]/, s = {
                    each: function(e, t) {
                        e && (Array.isArray(e) ? e.forEach(t) : Object.keys(e).forEach((r)=>{
                            t(e[r], r);
                        }));
                    },
                    some: function(e, t) {
                        return !!e && (Array.isArray(e) ? e.some(t) : Object.keys(e).some((r)=>t(e[r], r)));
                    },
                    every: function(e, t) {
                        return !e || (Array.isArray(e) ? e.every(t) : Object.keys(e).every((r)=>t(e[r], r)));
                    },
                    map: function(e, t) {
                        return e ? Array.isArray(e) ? e.map(t) : Object.keys(e).map((r)=>t(e[r], r)) : [];
                    },
                    keyBy: (e, t)=>e.reduce((e, r)=>(e[r[t]] = r, e), {}),
                    isEqual: function(e, t) {
                        const r = typeof e, n = typeof t, i = Array.isArray(e), o = Array.isArray(t);
                        let a;
                        if (r !== n) return !1;
                        switch(typeof e){
                            case "object":
                                if (i || o) return !(!i || !o) && e.length === t.length && e.every((e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                                if (null === e || null === t) return e === t;
                                if (a = Object.keys(e), Object.keys(t).length !== a.length) return !1;
                                for (const e of a)if (!t.hasOwnProperty(e)) return !1;
                                return s.every(e, (e, r)=>{
                                    const n = t[r];
                                    return s.isEqual(e, n);
                                });
                            default:
                                return e === t;
                        }
                    },
                    escapeHtml (e) {
                        const t = i.exec(e);
                        if (!t) return e;
                        let r = "", n = "", s = 0, o = t.index;
                        for(; o < e.length; o++){
                            switch(e.charAt(o)){
                                case '"':
                                    n = "&quot;";
                                    break;
                                case "&":
                                    n = "&amp;";
                                    break;
                                case "'":
                                    n = "&apos;";
                                    break;
                                case "<":
                                    n = "&lt;";
                                    break;
                                case ">":
                                    n = "&gt;";
                                    break;
                                default:
                                    continue;
                            }
                            s !== o && (r += e.substring(s, o)), s = o + 1, r += n;
                        }
                        return s !== o ? r + e.substring(s, o) : r;
                    },
                    strcmp: (e, t)=>e < t ? -1 : e > t ? 1 : 0,
                    isUndefined: (e)=>"[object Undefined]" === n.call(e),
                    isObject: (e)=>"[object Object]" === n.call(e),
                    deepMerge () {
                        const e = arguments[0] || {}, { length: t } = arguments;
                        let r, n, i;
                        function o(t, o) {
                            r = e[o], i = Array.isArray(t), s.isObject(t) || i ? (i ? (i = !1, n = r && Array.isArray(r) ? r : []) : n = r && s.isObject(r) ? r : {}, e[o] = s.deepMerge(n, t)) : s.isUndefined(t) || (e[o] = t);
                        }
                        for(let e = 0; e < t; e++)s.each(arguments[e], o);
                        return e;
                    }
                };
                t.exports = s;
            },
            {}
        ],
        27: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = /[<>&'"\x7F\x00-\x08\x0B-\x0C\x0E-\x1F]/, o = {
                            nop () {},
                            promiseImmediate: (e)=>new Promise((t)=>{
                                    r.setImmediate ? n(()=>{
                                        t(e);
                                    }) : setTimeout(()=>{
                                        t(e);
                                    }, 1);
                                }),
                            inherits: function(e, t, r, n) {
                                e.super_ = t, n || (n = r, r = null), r && Object.keys(r).forEach((t)=>{
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                                const i = {
                                    constructor: {
                                        value: e,
                                        enumerable: !1,
                                        writable: !1,
                                        configurable: !0
                                    }
                                };
                                n && Object.keys(n).forEach((e)=>{
                                    i[e] = Object.getOwnPropertyDescriptor(n, e);
                                }), e.prototype = Object.create(t.prototype, i);
                            },
                            dateToExcel: (e, t)=>25569 + e.getTime() / 864e5 - (t ? 1462 : 0),
                            excelToDate (e, t) {
                                const r = Math.round(24 * (e - 25569 + (t ? 1462 : 0)) * 3600000);
                                return new Date(r);
                            },
                            parsePath (e) {
                                const t = e.lastIndexOf("/");
                                return {
                                    path: e.substring(0, t),
                                    name: e.substring(t + 1)
                                };
                            },
                            getRelsPath (e) {
                                const t = o.parsePath(e);
                                return `${t.path}/_rels/${t.name}.rels`;
                            },
                            xmlEncode (e) {
                                const t = s.exec(e);
                                if (!t) return e;
                                let r = "", n = "", i = 0, o = t.index;
                                for(; o < e.length; o++){
                                    const t = e.charCodeAt(o);
                                    switch(t){
                                        case 34:
                                            n = "&quot;";
                                            break;
                                        case 38:
                                            n = "&amp;";
                                            break;
                                        case 39:
                                            n = "&apos;";
                                            break;
                                        case 60:
                                            n = "&lt;";
                                            break;
                                        case 62:
                                            n = "&gt;";
                                            break;
                                        case 127:
                                            n = "";
                                            break;
                                        default:
                                            if (t <= 31 && (t <= 8 || t >= 11 && 13 !== t)) {
                                                n = "";
                                                break;
                                            }
                                            continue;
                                    }
                                    i !== o && (r += e.substring(i, o)), i = o + 1, n && (r += n);
                                }
                                return i !== o ? r + e.substring(i, o) : r;
                            },
                            xmlDecode: (e)=>e.replace(/&([a-z]*);/g, (e)=>{
                                    switch(e){
                                        case "&lt;":
                                            return "<";
                                        case "&gt;":
                                            return ">";
                                        case "&amp;":
                                            return "&";
                                        case "&apos;":
                                            return "'";
                                        case "&quot;":
                                            return '"';
                                        default:
                                            return e;
                                    }
                                }),
                            validInt (e) {
                                const t = parseInt(e, 10);
                                return Number.isNaN(t) ? 0 : t;
                            },
                            isDateFmt (e) {
                                if (!e) return !1;
                                return null !== (e = (e = e.replace(/\[[^\]]*]/g, "")).replace(/"[^"]*"/g, "")).match(/[ymdhMsb]+/);
                            },
                            fs: {
                                exists: (e)=>new Promise((t)=>{
                                        i.access(e, i.constants.F_OK, (e)=>{
                                            t(!e);
                                        });
                                    })
                            },
                            toIsoDateString: (e)=>e.toIsoString().subsstr(0, 10),
                            parseBoolean: (e)=>!0 === e || "true" === e || 1 === e || "1" === e
                        };
                        t.exports = o;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                fs: 216,
                timers: 523
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                const n = e("./under-dash"), i = e("./utils");
                function s(e, t, r) {
                    e.push(` ${t}="${i.xmlEncode(r.toString())}"`);
                }
                function o(e, t) {
                    if (t) {
                        const r = [];
                        n.each(t, (e, t)=>{
                            void 0 !== e && s(r, t, e);
                        }), e.push(r.join(""));
                    }
                }
                class a {
                    constructor(){
                        this._xml = [], this._stack = [], this._rollbacks = [];
                    }
                    get tos() {
                        return this._stack.length ? this._stack[this._stack.length - 1] : void 0;
                    }
                    get cursor() {
                        return this._xml.length;
                    }
                    openXml(e) {
                        const t = this._xml;
                        t.push("<?xml"), o(t, e), t.push("?>\n");
                    }
                    openNode(e, t) {
                        const r = this.tos, n = this._xml;
                        r && this.open && n.push(">"), this._stack.push(e), n.push("<"), n.push(e), o(n, t), this.leaf = !0, this.open = !0;
                    }
                    addAttribute(e, t) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        void 0 !== t && s(this._xml, e, t);
                    }
                    addAttributes(e) {
                        if (!this.open) throw new Error("Cannot write attributes to node if it is not open");
                        o(this._xml, e);
                    }
                    writeText(e) {
                        const t = this._xml;
                        this.open && (t.push(">"), this.open = !1), this.leaf = !1, t.push(i.xmlEncode(e.toString()));
                    }
                    writeXml(e) {
                        this.open && (this._xml.push(">"), this.open = !1), this.leaf = !1, this._xml.push(e);
                    }
                    closeNode() {
                        const e = this._stack.pop(), t = this._xml;
                        this.leaf ? t.push("/>") : (t.push("</"), t.push(e), t.push(">")), this.open = !1, this.leaf = !1;
                    }
                    leafNode(e, t, r) {
                        this.openNode(e, t), void 0 !== r && this.writeText(r), this.closeNode();
                    }
                    closeAll() {
                        for(; this._stack.length;)this.closeNode();
                    }
                    addRollback() {
                        return this._rollbacks.push({
                            xml: this._xml.length,
                            stack: this._stack.length,
                            leaf: this.leaf,
                            open: this.open
                        }), this.cursor;
                    }
                    commit() {
                        this._rollbacks.pop();
                    }
                    rollback() {
                        const e = this._rollbacks.pop();
                        this._xml.length > e.xml && this._xml.splice(e.xml, this._xml.length - e.xml), this._stack.length > e.stack && this._stack.splice(e.stack, this._stack.length - e.stack), this.leaf = e.leaf, this.open = e.open;
                    }
                    get xml() {
                        return this.closeAll(), this._xml.join("");
                    }
                }
                a.StdDocAttributes = {
                    version: "1.0",
                    encoding: "UTF-8",
                    standalone: "yes"
                }, t.exports = a;
            },
            {
                "./under-dash": 26,
                "./utils": 27
            }
        ],
        29: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        const n = e("events"), i = e("jszip"), s = e("./stream-buf"), { stringToBuffer: o } = e("./browser-buffer-encode");
                        class a extends n.EventEmitter {
                            constructor(e){
                                super(), this.options = Object.assign({
                                    type: "nodebuffer",
                                    compression: "DEFLATE"
                                }, e), this.zip = new i, this.stream = new s;
                            }
                            append(e, t) {
                                t.hasOwnProperty("base64") && t.base64 ? this.zip.file(t.name, e, {
                                    base64: !0
                                }) : (r.browser && "string" == typeof e && (e = o(e)), this.zip.file(t.name, e));
                            }
                            async finalize() {
                                const e = await this.zip.generateAsync(this.options);
                                this.stream.end(e), this.emit("finish");
                            }
                            read(e) {
                                return this.stream.read(e);
                            }
                            setEncoding(e) {
                                return this.stream.setEncoding(e);
                            }
                            pause() {
                                return this.stream.pause();
                            }
                            resume() {
                                return this.stream.resume();
                            }
                            isPaused() {
                                return this.stream.isPaused();
                            }
                            pipe(e, t) {
                                return this.stream.pipe(e, t);
                            }
                            unpipe(e) {
                                return this.stream.unpipe(e);
                            }
                            unshift(e) {
                                return this.stream.unshift(e);
                            }
                            wrap(e) {
                                return this.stream.wrap(e);
                            }
                        }
                        t.exports = {
                            ZipWriter: a
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./browser-buffer-encode": 17,
                "./stream-buf": 24,
                _process: 467,
                events: 422,
                jszip: 441
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    0: {
                        f: "General"
                    },
                    1: {
                        f: "0"
                    },
                    2: {
                        f: "0.00"
                    },
                    3: {
                        f: "#,##0"
                    },
                    4: {
                        f: "#,##0.00"
                    },
                    9: {
                        f: "0%"
                    },
                    10: {
                        f: "0.00%"
                    },
                    11: {
                        f: "0.00E+00"
                    },
                    12: {
                        f: "# ?/?"
                    },
                    13: {
                        f: "# ??/??"
                    },
                    14: {
                        f: "mm-dd-yy"
                    },
                    15: {
                        f: "d-mmm-yy"
                    },
                    16: {
                        f: "d-mmm"
                    },
                    17: {
                        f: "mmm-yy"
                    },
                    18: {
                        f: "h:mm AM/PM"
                    },
                    19: {
                        f: "h:mm:ss AM/PM"
                    },
                    20: {
                        f: "h:mm"
                    },
                    21: {
                        f: "h:mm:ss"
                    },
                    22: {
                        f: 'm/d/yy "h":mm'
                    },
                    27: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    28: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    29: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    30: {
                        "zh-tw": "m/d/yy ",
                        "zh-cn": "m-d-yy",
                        "ja-jp": "m/d/yy",
                        "ko-kr": "mm-dd-yy"
                    },
                    31: {
                        "zh-tw": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": 'yyyy"\ub144" mm"\uc6d4" dd"\uc77c"'
                    },
                    32: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"',
                        "ja-jp": 'h"\u6642"mm"\u5206"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84"'
                    },
                    33: {
                        "zh-tw": 'hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'h"\u6642"mm"\u5206"ss"\u79d2"',
                        "ko-kr": 'h"\uc2dc" mm"\ubd84" ss"\ucd08"'
                    },
                    34: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    35: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    36: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    37: {
                        f: "#,##0 ;(#,##0)"
                    },
                    38: {
                        f: "#,##0 ;[Red](#,##0)"
                    },
                    39: {
                        f: "#,##0.00 ;(#,##0.00)"
                    },
                    40: {
                        f: "#,##0.00 ;[Red](#,##0.00)"
                    },
                    45: {
                        f: "mm:ss"
                    },
                    46: {
                        f: "[h]:mm:ss"
                    },
                    47: {
                        f: "mmss.0"
                    },
                    48: {
                        f: "##0.0E+0"
                    },
                    49: {
                        f: "@"
                    },
                    50: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    51: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    52: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    53: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    54: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    55: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"',
                        "ja-jp": 'yyyy"\u5e74"m"\u6708"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    56: {
                        "zh-tw": '\u4e0a\u5348/\u4e0b\u5348 hh"\u6642"mm"\u5206"ss"\u79d2"',
                        "zh-cn": '\u4e0a\u5348/\u4e0b\u5348 h"\u65f6"mm"\u5206"ss"\u79d2"',
                        "ja-jp": 'm"\u6708"d"\u65e5"',
                        "ko-kr": "yyyy-mm-dd"
                    },
                    57: {
                        "zh-tw": "[$-404]e/m/d",
                        "zh-cn": 'yyyy"\u5e74"m"\u6708"',
                        "ja-jp": "[$-411]ge.m.d",
                        "ko-kr": 'yyyy"\u5e74" mm"\u6708" dd"\u65e5"'
                    },
                    58: {
                        "zh-tw": '[$-404]e"\u5e74"m"\u6708"d"\u65e5"',
                        "zh-cn": 'm"\u6708"d"\u65e5"',
                        "ja-jp": '[$-411]ggge"\u5e74"m"\u6708"d"\u65e5"',
                        "ko-kr": "mm-dd"
                    },
                    59: {
                        "th-th": "t0"
                    },
                    60: {
                        "th-th": "t0.00"
                    },
                    61: {
                        "th-th": "t#,##0"
                    },
                    62: {
                        "th-th": "t#,##0.00"
                    },
                    67: {
                        "th-th": "t0%"
                    },
                    68: {
                        "th-th": "t0.00%"
                    },
                    69: {
                        "th-th": "t# ?/?"
                    },
                    70: {
                        "th-th": "t# ??/??"
                    },
                    81: {
                        "th-th": "d/m/bb"
                    }
                };
            },
            {}
        ],
        31: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    OfficeDocument: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                    Worksheet: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
                    CalcChain: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain",
                    SharedStrings: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
                    Styles: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
                    Theme: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
                    Hyperlink: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
                    Image: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                    CoreProperties: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
                    ExtenderProperties: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
                    Comments: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
                    VmlDrawing: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
                    Table: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table"
                };
            },
            {}
        ],
        32: [
            function(e, t, r) {
                "use strict";
                const n = e("../../utils/parse-sax"), i = e("../../utils/xml-stream");
                class s {
                    prepare() {}
                    render() {}
                    parseOpen(e) {}
                    parseText(e) {}
                    parseClose(e) {}
                    reconcile(e, t) {}
                    reset() {
                        this.model = null, this.map && Object.values(this.map).forEach((e)=>{
                            e instanceof s ? e.reset() : e.xform && e.xform.reset();
                        });
                    }
                    mergeModel(e) {
                        this.model = Object.assign(this.model || {}, e);
                    }
                    async parse(e) {
                        for await (const t of e)for (const { eventType: e, value: r } of t)if ("opentag" === e) this.parseOpen(r);
                        else if ("text" === e) this.parseText(r);
                        else if ("closetag" === e && !this.parseClose(r.name)) return this.model;
                        return this.model;
                    }
                    async parseStream(e) {
                        return this.parse(n(e));
                    }
                    get xml() {
                        return this.toXml(this.model);
                    }
                    toXml(e) {
                        const t = new i;
                        return this.render(t, e), t.xml;
                    }
                    static toAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e.toString();
                    }
                    static toStringAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toStringValue(e, t) {
                        return void 0 === e ? t : e;
                    }
                    static toBoolAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if (void 0 === e) {
                            if (r) return t;
                        } else if (r || e !== t) return e ? "1" : "0";
                    }
                    static toBoolValue(e, t) {
                        return void 0 === e ? t : "1" === e;
                    }
                    static toIntAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toIntValue(e, t) {
                        return void 0 === e ? t : parseInt(e, 10);
                    }
                    static toFloatAttribute(e, t) {
                        let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        return s.toAttribute(e, t, r);
                    }
                    static toFloatValue(e, t) {
                        return void 0 === e ? t : parseFloat(e);
                    }
                }
                t.exports = s;
            },
            {
                "../../utils/parse-sax": 22,
                "../../utils/xml-stream": 28
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/col-cache");
                function s(e) {
                    try {
                        return i.decodeEx(e), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function o(e) {
                    const t = [];
                    let r = !1, n = "";
                    return e.split(",").forEach((e)=>{
                        if (!e) return;
                        const i = (e.match(/'/g) || []).length;
                        if (!i) return void (r ? n += e + "," : s(e) && t.push(e));
                        const o = i % 2 == 0;
                        !r && o && s(e) ? t.push(e) : r && !o ? (r = !1, s(n + e) && t.push(n + e), n = "") : (r = !0, n += e + ",");
                    }), t;
                }
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("definedName", {
                            name: t.name,
                            localSheetId: t.localSheetId
                        }), e.writeText(t.ranges.join(",")), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "definedName":
                                return this._parsedName = e.attributes.name, this._parsedLocalSheetId = e.attributes.localSheetId, this._parsedText = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._parsedText.push(e);
                    }
                    parseClose() {
                        return this.model = {
                            name: this._parsedName,
                            ranges: o(this._parsedText.join(""))
                        }, void 0 !== this._parsedLocalSheetId && (this.model.localSheetId = parseInt(this._parsedLocalSheetId, 10)), !1;
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    render(e, t) {
                        e.leafNode("sheet", {
                            sheetId: t.id,
                            name: t.name,
                            state: t.state,
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        return "sheet" === e.name && (this.model = {
                            name: n.xmlDecode(e.attributes.name),
                            id: parseInt(e.attributes.sheetId, 10),
                            state: e.attributes.state,
                            rId: e.attributes["r:id"]
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("calcPr", {
                            calcId: 171027,
                            fullCalcOnLoad: t.fullCalcOnLoad ? 1 : void 0
                        });
                    }
                    parseOpen(e) {
                        return "calcPr" === e.name && (this.model = {}, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        36: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("workbookPr", {
                            date1904: t.date1904 ? 1 : void 0,
                            defaultThemeVersion: 164011,
                            filterPrivacy: 1
                        });
                    }
                    parseOpen(e) {
                        return "workbookPr" === e.name && (this.model = {
                            date1904: "1" === e.attributes.date1904
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        37: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        const r = {
                            xWindow: t.x || 0,
                            yWindow: t.y || 0,
                            windowWidth: t.width || 12e3,
                            windowHeight: t.height || 24e3,
                            firstSheet: t.firstSheet,
                            activeTab: t.activeTab
                        };
                        t.visibility && "visible" !== t.visibility && (r.visibility = t.visibility), e.leafNode("workbookView", r);
                    }
                    parseOpen(e) {
                        if ("workbookView" === e.name) {
                            const t = this.model = {}, r = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = r : n;
                                void 0 !== i && (t[e] = i);
                            }, n = function(e, r, n) {
                                const i = void 0 !== r ? t[e] = parseInt(r, 10) : n;
                                void 0 !== i && (t[e] = i);
                            };
                            return n("x", e.attributes.xWindow, 0), n("y", e.attributes.yWindow, 0), n("width", e.attributes.windowWidth, 25e3), n("height", e.attributes.windowHeight, 1e4), r("visibility", e.attributes.visibility, "visible"), n("activeTab", e.attributes.activeTab, void 0), n("firstSheet", e.attributes.firstSheet, void 0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../base-xform"), a = e("../static-xform"), l = e("../list-xform"), c = e("./defined-name-xform"), u = e("./sheet-xform"), h = e("./workbook-view-xform"), f = e("./workbook-properties-xform"), d = e("./workbook-calc-properties-xform");
                class p extends o {
                    constructor(){
                        super(), this.map = {
                            fileVersion: p.STATIC_XFORMS.fileVersion,
                            workbookPr: new f,
                            bookViews: new l({
                                tag: "bookViews",
                                count: !1,
                                childXform: new h
                            }),
                            sheets: new l({
                                tag: "sheets",
                                count: !1,
                                childXform: new u
                            }),
                            definedNames: new l({
                                tag: "definedNames",
                                count: !1,
                                childXform: new c
                            }),
                            calcPr: new d
                        };
                    }
                    prepare(e) {
                        e.sheets = e.worksheets;
                        const t = [];
                        let r = 0;
                        e.sheets.forEach((e)=>{
                            if (e.pageSetup && e.pageSetup.printArea && e.pageSetup.printArea.split("&&").forEach((n)=>{
                                const i = n.split(":"), s = {
                                    name: "_xlnm.Print_Area",
                                    ranges: [
                                        `'${e.name}'!$${i[0]}:$${i[1]}`
                                    ],
                                    localSheetId: r
                                };
                                t.push(s);
                            }), e.pageSetup && (e.pageSetup.printTitlesRow || e.pageSetup.printTitlesColumn)) {
                                const n = [];
                                if (e.pageSetup.printTitlesColumn) {
                                    const t = e.pageSetup.printTitlesColumn.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                if (e.pageSetup.printTitlesRow) {
                                    const t = e.pageSetup.printTitlesRow.split(":");
                                    n.push(`'${e.name}'!$${t[0]}:$${t[1]}`);
                                }
                                const i = {
                                    name: "_xlnm.Print_Titles",
                                    ranges: n,
                                    localSheetId: r
                                };
                                t.push(i);
                            }
                            r++;
                        }), t.length && (e.definedNames = e.definedNames.concat(t)), (e.media || []).forEach((e, t)=>{
                            e.name = e.type + (t + 1);
                        });
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("workbook", p.WORKBOOK_ATTRIBUTES), this.map.fileVersion.render(e), this.map.workbookPr.render(e, t.properties), this.map.bookViews.render(e, t.views), this.map.sheets.render(e, t.sheets), this.map.definedNames.render(e, t.definedNames), this.map.calcPr.render(e, t.calcProperties), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "workbook":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "workbook":
                                return this.model = {
                                    sheets: this.map.sheets.model,
                                    properties: this.map.workbookPr.model || {},
                                    views: this.map.bookViews.model,
                                    calcProperties: {}
                                }, this.map.definedNames.model && (this.model.definedNames = this.map.definedNames.model), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e) {
                        const t = (e.workbookRels || []).reduce((e, t)=>(e[t.Id] = t, e), {}), r = [];
                        let s, o = 0;
                        (e.sheets || []).forEach((n)=>{
                            const i = t[n.rId];
                            i && (s = e.worksheetHash["xl/" + i.Target.replace(/^(\s|\/xl\/)+/, "")], s && (s.name = n.name, s.id = n.id, s.state = n.state, r[o++] = s));
                        });
                        const a = [];
                        n.each(e.definedNames, (e)=>{
                            if ("_xlnm.Print_Area" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = i.decodeEx(e.ranges[0]);
                                    s.pageSetup.printArea = s.pageSetup.printArea ? `${s.pageSetup.printArea}&&${t.dimensions}` : t.dimensions;
                                }
                            } else if ("_xlnm.Print_Titles" === e.name) {
                                if (s = r[e.localSheetId], s) {
                                    s.pageSetup || (s.pageSetup = {});
                                    const t = e.ranges.join(","), r = /\$/g, n = /\$\d+:\$\d+/, i = t.match(n);
                                    if (i && i.length) {
                                        const e = i[0];
                                        s.pageSetup.printTitlesRow = e.replace(r, "");
                                    }
                                    const o = /\$[A-Z]+:\$[A-Z]+/, a = t.match(o);
                                    if (a && a.length) {
                                        const e = a[0];
                                        s.pageSetup.printTitlesColumn = e.replace(r, "");
                                    }
                                }
                            } else a.push(e);
                        }), e.definedNames = a, e.media.forEach((e, t)=>{
                            e.index = t;
                        });
                    }
                }
                p.WORKBOOK_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x15",
                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                }, p.STATIC_XFORMS = {
                    fileVersion: new a({
                        tag: "fileVersion",
                        $: {
                            appName: "xl",
                            lastEdited: 5,
                            lowestEdited: 5,
                            rupBuild: 9303
                        }
                    })
                }, t.exports = p;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./defined-name-xform": 33,
                "./sheet-xform": 34,
                "./workbook-calc-properties-xform": 35,
                "./workbook-properties-xform": 36,
                "./workbook-view-xform": 37
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                const n = e("../strings/rich-text-xform"), i = e("../../../utils/utils"), s = e("../base-xform"), o = t.exports = function(e) {
                    this.model = e;
                };
                i.inherits(o, s, {
                    get tag () {
                        return "r";
                    },
                    get richTextXform () {
                        return this._richTextXform || (this._richTextXform = new n), this._richTextXform;
                    },
                    render (e, t) {
                        t = t || this.model, e.openNode("comment", {
                            ref: t.ref,
                            authorId: 0
                        }), e.openNode("text"), t && t.note && t.note.texts && t.note.texts.forEach((t)=>{
                            this.richTextXform.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "comment":
                                return this.model = {
                                    type: "note",
                                    note: {
                                        texts: []
                                    },
                                    ...e.attributes
                                }, !0;
                            case "r":
                                return this.parser = this.richTextXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "comment":
                                return !1;
                            case "r":
                                return this.model.note.texts.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../../../utils/utils"), s = e("../base-xform"), o = e("./comment-xform"), a = t.exports = function() {
                    this.map = {
                        comment: new o
                    };
                };
                i.inherits(a, s, {
                    COMMENTS_ATTRIBUTES: {
                        xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                    }
                }, {
                    render (e, t) {
                        t = t || this.model, e.openXml(n.StdDocAttributes), e.openNode("comments", a.COMMENTS_ATTRIBUTES), e.openNode("authors"), e.leafNode("author", null, "Author"), e.closeNode(), e.openNode("commentList"), t.comments.forEach((t)=>{
                            this.map.comment.render(e, t);
                        }), e.closeNode(), e.closeNode();
                    },
                    parseOpen (e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "commentList":
                                return this.model = {
                                    comments: []
                                }, !0;
                            case "comment":
                                return this.parser = this.map.comment, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    },
                    parseText (e) {
                        this.parser && this.parser.parseText(e);
                    },
                    parseClose (e) {
                        switch(e){
                            case "commentList":
                                return !1;
                            case "comment":
                                return this.model.comments.push(this.parser.model), this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                });
            },
            {
                "../../../utils/utils": 27,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./comment-xform": 39
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t, r) {
                        (t === r[2] || "x:SizeWithCells" === this.tag && t === r[1]) && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {}, this.model[this.tag] = !0, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        42: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    get tag() {
                        return this._model && this._model.tag;
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x:Anchor";
                    }
                    getAnchorRect(e) {
                        const t = Math.floor(e.left), r = Math.floor(68 * (e.left - t)), n = Math.floor(e.top), i = Math.floor(18 * (e.top - n)), s = Math.floor(e.right), o = Math.floor(68 * (e.right - s)), a = Math.floor(e.bottom);
                        return [
                            t,
                            r,
                            n,
                            i,
                            s,
                            o,
                            a,
                            Math.floor(18 * (e.bottom - a))
                        ];
                    }
                    getDefaultRect(e) {
                        const t = e.col, r = Math.max(e.row - 2, 0);
                        return [
                            t,
                            6,
                            r,
                            14,
                            t + 2,
                            2,
                            r + 4,
                            16
                        ];
                    }
                    render(e, t) {
                        const r = t.anchor ? this.getAnchorRect(t.anchor) : this.getDefaultRect(t.refAddress);
                        e.leafNode("x:Anchor", null, r.join(", "));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.text = "", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.text = e;
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        44: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-anchor-xform"), s = e("./style/vml-protection-xform"), o = e("./style/vml-position-xform"), a = [
                    "twoCells",
                    "oneCells",
                    "absolute"
                ];
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x:Anchor": new i,
                            "x:Locked": new s({
                                tag: "x:Locked"
                            }),
                            "x:LockText": new s({
                                tag: "x:LockText"
                            }),
                            "x:SizeWithCells": new o({
                                tag: "x:SizeWithCells"
                            }),
                            "x:MoveWithCells": new o({
                                tag: "x:MoveWithCells"
                            })
                        };
                    }
                    get tag() {
                        return "x:ClientData";
                    }
                    render(e, t) {
                        const { protection: r, editAs: n } = t.note;
                        e.openNode(this.tag, {
                            ObjectType: "Note"
                        }), this.map["x:MoveWithCells"].render(e, n, a), this.map["x:SizeWithCells"].render(e, n, a), this.map["x:Anchor"].render(e, t), this.map["x:Locked"].render(e, r.locked), e.leafNode("x:AutoFill", null, "False"), this.map["x:LockText"].render(e, r.lockText), e.leafNode("x:Row", null, t.refAddress.row - 1), e.leafNode("x:Column", null, t.refAddress.col - 1), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchor: [],
                                    protection: {},
                                    editAs: ""
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.normalizeModel(), !1;
                            default:
                                return !0;
                        }
                    }
                    normalizeModel() {
                        const e = Object.assign({}, this.map["x:MoveWithCells"].model, this.map["x:SizeWithCells"].model), t = Object.keys(e).length;
                        this.model.editAs = a[t], this.model.anchor = this.map["x:Anchor"].text, this.model.protection.locked = this.map["x:Locked"].text, this.model.protection.lockText = this.map["x:LockText"].text;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./style/vml-position-xform": 41,
                "./style/vml-protection-xform": 42,
                "./vml-anchor-xform": 43
            }
        ],
        45: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./vml-shape-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "v:shape": new s
                        };
                    }
                    get tag() {
                        return "xml";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, o.DRAWING_ATTRIBUTES), e.openNode("o:shapelayout", {
                            "v:ext": "edit"
                        }), e.leafNode("o:idmap", {
                            "v:ext": "edit",
                            data: 1
                        }), e.closeNode(), e.openNode("v:shapetype", {
                            id: "_x0000_t202",
                            coordsize: "21600,21600",
                            "o:spt": 202,
                            path: "m,l,21600r21600,l21600,xe"
                        }), e.leafNode("v:stroke", {
                            joinstyle: "miter"
                        }), e.leafNode("v:path", {
                            gradientshapeok: "t",
                            "o:connecttype": "rect"
                        }), e.closeNode(), t.comments.forEach((t, r)=>{
                            this.map["v:shape"].render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    comments: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.comments.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                o.DRAWING_ATTRIBUTES = {
                    "xmlns:v": "urn:schemas-microsoft-com:vml",
                    "xmlns:o": "urn:schemas-microsoft-com:office:office",
                    "xmlns:x": "urn:schemas-microsoft-com:office:excel"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./vml-shape-xform": 46
            }
        ],
        46: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./vml-textbox-xform"), s = e("./vml-client-data-xform");
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            "v:textbox": new i,
                            "x:ClientData": new s
                        };
                    }
                    get tag() {
                        return "v:shape";
                    }
                    render(e, t, r) {
                        e.openNode("v:shape", o.V_SHAPE_ATTRIBUTES(t, r)), e.leafNode("v:fill", {
                            color2: "infoBackground [80]"
                        }), e.leafNode("v:shadow", {
                            color: "none [81]",
                            obscured: "t"
                        }), e.leafNode("v:path", {
                            "o:connecttype": "none"
                        }), this.map["v:textbox"].render(e, t), this.map["x:ClientData"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    margins: {
                                        insetmode: e.attributes["o:insetmode"]
                                    },
                                    anchor: "",
                                    editAs: "",
                                    protection: {}
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.margins.inset = this.map["v:textbox"].model && this.map["v:textbox"].model.inset, this.model.protection = this.map["x:ClientData"].model && this.map["x:ClientData"].model.protection, this.model.anchor = this.map["x:ClientData"].model && this.map["x:ClientData"].model.anchor, this.model.editAs = this.map["x:ClientData"].model && this.map["x:ClientData"].model.editAs, !1;
                            default:
                                return !0;
                        }
                    }
                }
                o.V_SHAPE_ATTRIBUTES = (e, t)=>({
                        id: "_x0000_s" + (1025 + t),
                        type: "#_x0000_t202",
                        style: "position:absolute; margin-left:105.3pt;margin-top:10.5pt;width:97.8pt;height:59.1pt;z-index:1;visibility:hidden",
                        fillcolor: "infoBackground [80]",
                        strokecolor: "none [81]",
                        "o:insetmode": e.note.margins && e.note.margins.insetmode
                    }), t.exports = o;
            },
            {
                "../base-xform": 32,
                "./vml-client-data-xform": 44,
                "./vml-textbox-xform": 47
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "v:textbox";
                    }
                    conversionUnit(e, t, r) {
                        return `${parseFloat(e) * t.toFixed(2)}${r}`;
                    }
                    reverseConversionUnit(e) {
                        return (e || "").split(",").map((e)=>Number(parseFloat(this.conversionUnit(parseFloat(e), .1, "")).toFixed(2)));
                    }
                    render(e, t) {
                        const r = {
                            style: "mso-direction-alt:auto"
                        };
                        if (t && t.note) {
                            let { inset: e } = t.note && t.note.margins;
                            Array.isArray(e) && (e = e.map((e)=>this.conversionUnit(e, 10, "mm")).join(",")), e && (r.inset = e);
                        }
                        e.openNode("v:textbox", r), e.leafNode("div", {
                            style: "text-align:left"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    inset: this.reverseConversionUnit(e.attributes.inset)
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        48: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    createNewModel(e) {
                        return {};
                    }
                    parseOpen(e) {
                        return this.parser = this.parser || this.map[e.name], this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag && (this.model = this.createNewModel(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.onParserClose(e, this.parser), this.parser = void 0), !0) : e !== this.tag;
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        49: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("HeadingPairs"), e.openNode("vt:vector", {
                            size: 2,
                            baseType: "variant"
                        }), e.openNode("vt:variant"), e.leafNode("vt:lpstr", void 0, "Worksheets"), e.closeNode(), e.openNode("vt:variant"), e.leafNode("vt:i4", void 0, t.length), e.closeNode(), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "HeadingPairs" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "HeadingPairs" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.openNode("TitlesOfParts"), e.openNode("vt:vector", {
                            size: t.length,
                            baseType: "lpstr"
                        }), t.forEach((t)=>{
                            e.leafNode("vt:lpstr", void 0, t.name);
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        return "TitlesOfParts" === e.name;
                    }
                    parseText() {}
                    parseClose(e) {
                        return "TitlesOfParts" !== e;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/string-xform"), o = e("./app-heading-pairs-xform"), a = e("./app-titles-of-parts-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            Company: new s({
                                tag: "Company"
                            }),
                            Manager: new s({
                                tag: "Manager"
                            }),
                            HeadingPairs: new o,
                            TitleOfParts: new a
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Properties", l.PROPERTY_ATTRIBUTES), e.leafNode("Application", void 0, "Microsoft Excel"), e.leafNode("DocSecurity", void 0, "0"), e.leafNode("ScaleCrop", void 0, "false"), this.map.HeadingPairs.render(e, t.worksheets), this.map.TitleOfParts.render(e, t.worksheets), this.map.Company.render(e, t.company || ""), this.map.Manager.render(e, t.manager), e.leafNode("LinksUpToDate", void 0, "false"), e.leafNode("SharedDoc", void 0, "false"), e.leafNode("HyperlinksChanged", void 0, "false"), e.leafNode("AppVersion", void 0, "16.0300"), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Properties":
                                return !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "Properties":
                                return this.model = {
                                    worksheets: this.map.TitleOfParts.model,
                                    company: this.map.Company.model,
                                    manager: this.map.Manager.model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3,6}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
                    "xmlns:vt": "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/string-xform": 119,
                "./app-heading-pairs-xform": 49,
                "./app-titles-of-parts-xform": 50
            }
        ],
        52: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform");
                class s extends i {
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("Types", s.PROPERTY_ATTRIBUTES);
                        const r = {};
                        (t.media || []).forEach((t)=>{
                            if ("image" === t.type) {
                                const n = t.extension;
                                r[n] || (r[n] = !0, e.leafNode("Default", {
                                    Extension: n,
                                    ContentType: "image/" + n
                                }));
                            }
                        }), e.leafNode("Default", {
                            Extension: "rels",
                            ContentType: "application/vnd.openxmlformats-package.relationships+xml"
                        }), e.leafNode("Default", {
                            Extension: "xml",
                            ContentType: "application/xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/workbook.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
                        }), t.worksheets.forEach((t)=>{
                            const r = `/xl/worksheets/sheet${t.id}.xml`;
                            e.leafNode("Override", {
                                PartName: r,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"
                            });
                        }), e.leafNode("Override", {
                            PartName: "/xl/theme/theme1.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.theme+xml"
                        }), e.leafNode("Override", {
                            PartName: "/xl/styles.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"
                        });
                        t.sharedStrings && t.sharedStrings.count && e.leafNode("Override", {
                            PartName: "/xl/sharedStrings.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"
                        }), t.tables && t.tables.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: "/xl/tables/" + t.target,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml"
                            });
                        }), t.drawings && t.drawings.forEach((t)=>{
                            e.leafNode("Override", {
                                PartName: `/xl/drawings/${t.name}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml"
                            });
                        }), t.commentRefs && (e.leafNode("Default", {
                            Extension: "vml",
                            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
                        }), t.commentRefs.forEach((t)=>{
                            let { commentName: r } = t;
                            e.leafNode("Override", {
                                PartName: `/xl/${r}.xml`,
                                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"
                            });
                        })), e.leafNode("Override", {
                            PartName: "/docProps/core.xml",
                            ContentType: "application/vnd.openxmlformats-package.core-properties+xml"
                        }), e.leafNode("Override", {
                            PartName: "/docProps/app.xml",
                            ContentType: "application/vnd.openxmlformats-officedocument.extended-properties+xml"
                        }), e.closeNode();
                    }
                    parseOpen() {
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                s.PROPERTY_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }, t.exports = s;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../simple/date-xform"), o = e("../simple/string-xform"), a = e("../simple/integer-xform");
                class l extends i {
                    constructor(){
                        super(), this.map = {
                            "dc:creator": new o({
                                tag: "dc:creator"
                            }),
                            "dc:title": new o({
                                tag: "dc:title"
                            }),
                            "dc:subject": new o({
                                tag: "dc:subject"
                            }),
                            "dc:description": new o({
                                tag: "dc:description"
                            }),
                            "dc:identifier": new o({
                                tag: "dc:identifier"
                            }),
                            "dc:language": new o({
                                tag: "dc:language"
                            }),
                            "cp:keywords": new o({
                                tag: "cp:keywords"
                            }),
                            "cp:category": new o({
                                tag: "cp:category"
                            }),
                            "cp:lastModifiedBy": new o({
                                tag: "cp:lastModifiedBy"
                            }),
                            "cp:lastPrinted": new s({
                                tag: "cp:lastPrinted",
                                format: l.DateFormat
                            }),
                            "cp:revision": new a({
                                tag: "cp:revision"
                            }),
                            "cp:version": new o({
                                tag: "cp:version"
                            }),
                            "cp:contentStatus": new o({
                                tag: "cp:contentStatus"
                            }),
                            "cp:contentType": new o({
                                tag: "cp:contentType"
                            }),
                            "dcterms:created": new s({
                                tag: "dcterms:created",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            }),
                            "dcterms:modified": new s({
                                tag: "dcterms:modified",
                                attrs: l.DateAttrs,
                                format: l.DateFormat
                            })
                        };
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode("cp:coreProperties", l.CORE_PROPERTY_ATTRIBUTES), this.map["dc:creator"].render(e, t.creator), this.map["dc:title"].render(e, t.title), this.map["dc:subject"].render(e, t.subject), this.map["dc:description"].render(e, t.description), this.map["dc:identifier"].render(e, t.identifier), this.map["dc:language"].render(e, t.language), this.map["cp:keywords"].render(e, t.keywords), this.map["cp:category"].render(e, t.category), this.map["cp:lastModifiedBy"].render(e, t.lastModifiedBy), this.map["cp:lastPrinted"].render(e, t.lastPrinted), this.map["cp:revision"].render(e, t.revision), this.map["cp:version"].render(e, t.version), this.map["cp:contentStatus"].render(e, t.contentStatus), this.map["cp:contentType"].render(e, t.contentType), this.map["dcterms:created"].render(e, t.created), this.map["dcterms:modified"].render(e, t.modified), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "cp:coreProperties":
                            case "coreProperties":
                                return this.model = {
                                    creator: this.map["dc:creator"].model,
                                    title: this.map["dc:title"].model,
                                    subject: this.map["dc:subject"].model,
                                    description: this.map["dc:description"].model,
                                    identifier: this.map["dc:identifier"].model,
                                    language: this.map["dc:language"].model,
                                    keywords: this.map["cp:keywords"].model,
                                    category: this.map["cp:category"].model,
                                    lastModifiedBy: this.map["cp:lastModifiedBy"].model,
                                    lastPrinted: this.map["cp:lastPrinted"].model,
                                    revision: this.map["cp:revision"].model,
                                    contentStatus: this.map["cp:contentStatus"].model,
                                    contentType: this.map["cp:contentType"].model,
                                    created: this.map["dcterms:created"].model,
                                    modified: this.map["dcterms:modified"].model
                                }, !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                l.DateFormat = function(e) {
                    return e.toISOString().replace(/[.]\d{3}/, "");
                }, l.DateAttrs = {
                    "xsi:type": "dcterms:W3CDTF"
                }, l.CORE_PROPERTY_ATTRIBUTES = {
                    "xmlns:cp": "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
                    "xmlns:dcterms": "http://purl.org/dc/terms/",
                    "xmlns:dcmitype": "http://purl.org/dc/dcmitype/",
                    "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance"
                }, t.exports = l;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../simple/date-xform": 117,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119
            }
        ],
        54: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    render(e, t) {
                        e.leafNode("Relationship", t);
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "Relationship":
                                return this.model = e.attributes, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        55: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./relationship-xform");
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            Relationship: new s
                        };
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("Relationships", o.RELATIONSHIPS_ATTRIBUTES), t.forEach((t)=>{
                            this.map.Relationship.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "Relationships":
                                return this.model = [], !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parser.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case "Relationships":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                }
                o.RELATIONSHIPS_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }, t.exports = o;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./relationship-xform": 54
            }
        ],
        56: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    range: {
                                        editAs: e.attributes.editAs || "oneCell"
                                    }
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    reconcilePicture(e, t) {
                        if (e && e.rId) {
                            const r = t.rels[e.rId].Target.match(/.*\/media\/(.+[.][a-zA-Z]{3,4})/);
                            if (r) {
                                const e = r[1], n = t.mediaIndex[e];
                                return t.media[n];
                            }
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        57: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./blip-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:blip": new i
                        };
                    }
                    get tag() {
                        return "xdr:blipFill";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["a:blip"].render(e, t), e.openNode("a:stretch"), e.leafNode("a:fillRect"), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:blip"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./blip-xform": 58
            }
        ],
        58: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:blip";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:embed": t.rId,
                            cstate: "print"
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:embed"]
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        59: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xdr:cNvPicPr";
                    }
                    render(e) {
                        e.openNode(this.tag), e.leafNode("a:picLocks", {
                            noChangeAspect: "1"
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        60: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./hlink-click-xform"), s = e("./ext-lst-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "a:hlinkClick": new i,
                            "a:extLst": new s
                        };
                    }
                    get tag() {
                        return "xdr:cNvPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            id: t.index,
                            name: "Picture " + t.index
                        }), this.map["a:hlinkClick"].render(e, t), this.map["a:extLst"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["a:hlinkClick"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./ext-lst-xform": 63,
                "./hlink-click-xform": 65
            }
        ],
        61: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../simple/integer-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {
                            "xdr:col": new i({
                                tag: "xdr:col",
                                zero: !0
                            }),
                            "xdr:colOff": new i({
                                tag: "xdr:colOff",
                                zero: !0
                            }),
                            "xdr:row": new i({
                                tag: "xdr:row",
                                zero: !0
                            }),
                            "xdr:rowOff": new i({
                                tag: "xdr:rowOff",
                                zero: !0
                            })
                        };
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:col"].render(e, t.nativeCol), this.map["xdr:colOff"].render(e, t.nativeColOff), this.map["xdr:row"].render(e, t.nativeRow), this.map["xdr:rowOff"].render(e, t.nativeRowOff), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = {
                                    nativeCol: this.map["xdr:col"].model,
                                    nativeColOff: this.map["xdr:colOff"].model,
                                    nativeRow: this.map["xdr:row"].model,
                                    nativeRowOff: this.map["xdr:rowOff"].model
                                }, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../simple/integer-xform": 118
            }
        ],
        62: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("./two-cell-anchor-xform"), a = e("./one-cell-anchor-xform");
                class l extends s {
                    constructor(){
                        super(), this.map = {
                            "xdr:twoCellAnchor": new o,
                            "xdr:oneCellAnchor": new a
                        };
                    }
                    prepare(e) {
                        e.anchors.forEach((e, t)=>{
                            e.anchorType = function(e) {
                                return ("string" == typeof e.range ? n.decode(e.range) : e.range).br ? "xdr:twoCellAnchor" : "xdr:oneCellAnchor";
                            }(e);
                            this.map[e.anchorType].prepare(e, {
                                index: t
                            });
                        });
                    }
                    get tag() {
                        return "xdr:wsDr";
                    }
                    render(e, t) {
                        e.openXml(i.StdDocAttributes), e.openNode(this.tag, l.DRAWING_ATTRIBUTES), t.anchors.forEach((t)=>{
                            this.map[t.anchorType].render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset(), this.model = {
                                    anchors: []
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.anchors.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.anchors.forEach((e)=>{
                            e.br ? this.map["xdr:twoCellAnchor"].reconcile(e, t) : this.map["xdr:oneCellAnchor"].reconcile(e, t);
                        });
                    }
                }
                l.DRAWING_ATTRIBUTES = {
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing",
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main"
                }, t.exports = l;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./one-cell-anchor-xform": 67,
                "./two-cell-anchor-xform": 70
            }
        ],
        63: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:extLst";
                    }
                    render(e) {
                        e.openNode(this.tag), e.openNode("a:ext", {
                            uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                        }), e.leafNode("a16:creationId", {
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main",
                            id: "{00000000-0008-0000-0000-000002000000}"
                        }), e.closeNode(), e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        64: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.map = {};
                    }
                    render(e, t) {
                        e.openNode(this.tag);
                        const r = Math.floor(9525 * t.width), n = Math.floor(9525 * t.height);
                        e.addAttribute("cx", r), e.addAttribute("cy", n), e.closeNode();
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            width: parseInt(e.attributes.cx || "0", 10) / 9525,
                            height: parseInt(e.attributes.cy || "0", 10) / 9525
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        65: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "a:hlinkClick";
                    }
                    render(e, t) {
                        t.hyperlinks && t.hyperlinks.rId && e.leafNode(this.tag, {
                            "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                            "r:id": t.hyperlinks.rId,
                            tooltip: t.hyperlinks.tooltip
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    hyperlinks: {
                                        rId: e.attributes["r:id"],
                                        tooltip: e.attributes.tooltip
                                    }
                                }, !0;
                            default:
                                return !0;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        66: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./c-nv-pr-xform"), s = e("./c-nv-pic-pr-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:cNvPr": new i,
                            "xdr:cNvPicPr": new s
                        };
                    }
                    get tag() {
                        return "xdr:nvPicPr";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:cNvPr"].render(e, t), this.map["xdr:cNvPicPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model = this.map["xdr:cNvPr"].model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./c-nv-pic-pr-xform": 59,
                "./c-nv-pr-xform": 60
            }
        ],
        67: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./ext-xform"), a = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:ext": new o({
                                tag: "xdr:ext"
                            }),
                            "xdr:pic": new a,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:oneCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:ext"].render(e, t.range.ext), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.ext = this.map["xdr:ext"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./ext-xform": 64,
                "./pic-xform": 68
            }
        ],
        68: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../static-xform"), s = e("./blip-fill-xform"), o = e("./nv-pic-pr-xform"), a = e("./sp-pr");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:nvPicPr": new o,
                            "xdr:blipFill": new s,
                            "xdr:spPr": new i(a)
                        };
                    }
                    get tag() {
                        return "xdr:pic";
                    }
                    prepare(e, t) {
                        e.index = t.index + 1;
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map["xdr:nvPicPr"].render(e, t), this.map["xdr:blipFill"].render(e, t), this.map["xdr:spPr"].render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                this.reset();
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.mergeModel(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../static-xform": 120,
                "./blip-fill-xform": 57,
                "./nv-pic-pr-xform": 66,
                "./sp-pr": 69
            }
        ],
        69: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    tag: "xdr:spPr",
                    c: [
                        {
                            tag: "a:xfrm",
                            c: [
                                {
                                    tag: "a:off",
                                    $: {
                                        x: "0",
                                        y: "0"
                                    }
                                },
                                {
                                    tag: "a:ext",
                                    $: {
                                        cx: "0",
                                        cy: "0"
                                    }
                                }
                            ]
                        },
                        {
                            tag: "a:prstGeom",
                            $: {
                                prst: "rect"
                            },
                            c: [
                                {
                                    tag: "a:avLst"
                                }
                            ]
                        }
                    ]
                };
            },
            {}
        ],
        70: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-cell-anchor-xform"), i = e("../static-xform"), s = e("./cell-position-xform"), o = e("./pic-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xdr:from": new s({
                                tag: "xdr:from"
                            }),
                            "xdr:to": new s({
                                tag: "xdr:to"
                            }),
                            "xdr:pic": new o,
                            "xdr:clientData": new i({
                                tag: "xdr:clientData"
                            })
                        };
                    }
                    get tag() {
                        return "xdr:twoCellAnchor";
                    }
                    prepare(e, t) {
                        this.map["xdr:pic"].prepare(e.picture, t);
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            editAs: t.range.editAs || "oneCell"
                        }), this.map["xdr:from"].render(e, t.range.tl), this.map["xdr:to"].render(e, t.range.br), this.map["xdr:pic"].render(e, t.picture), this.map["xdr:clientData"].render(e, {}), e.closeNode();
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.range.tl = this.map["xdr:from"].model, this.model.range.br = this.map["xdr:to"].model, this.model.picture = this.map["xdr:pic"].model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.medium = this.reconcilePicture(e.picture, t);
                    }
                };
            },
            {
                "../static-xform": 120,
                "./base-cell-anchor-xform": 56,
                "./cell-position-xform": 61,
                "./pic-xform": 68
            }
        ],
        71: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.always = !!e.always, this.count = e.count, this.empty = e.empty, this.$count = e.$count || "count", this.$ = e.$, this.childXform = e.childXform, this.maxItems = e.maxItems;
                    }
                    prepare(e, t) {
                        const { childXform: r } = this;
                        e && e.forEach((e, n)=>{
                            t.index = n, r.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        if (this.always || t && t.length) {
                            e.openNode(this.tag, this.$), this.count && e.addAttribute(this.$count, t && t.length || 0);
                            const { childXform: r } = this;
                            (t || []).forEach((t, n)=>{
                                r.render(e, t, n);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = [], !0;
                            default:
                                return !!this.childXform.parseOpen(e) && (this.parser = this.childXform, !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e) && (this.model.push(this.parser.model), this.parser = void 0, this.maxItems && this.model.length > this.maxItems)) throw new Error(`Max ${this.childXform.tag} count (${this.maxItems}) exceeded`);
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        if (e) {
                            const { childXform: r } = this;
                            e.forEach((e)=>{
                                r.reconcile(e, t);
                            });
                        }
                    }
                };
            },
            {
                "./base-xform": 32
            }
        ],
        72: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "autoFilter";
                    }
                    render(e, t) {
                        if (t) {
                            if ("string" == typeof t) e.leafNode("autoFilter", {
                                ref: t
                            });
                            else {
                                const r = function(e) {
                                    return "string" == typeof e ? e : n.getAddress(e.row, e.column).address;
                                }, i = r(t.from), s = r(t.to);
                                i && s && e.leafNode("autoFilter", {
                                    ref: `${i}:${s}`
                                });
                            }
                        }
                    }
                    parseOpen(e) {
                        "autoFilter" === e.name && (this.model = e.attributes.ref);
                    }
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        73: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform"), s = e("../../../doc/range"), o = e("../../../doc/enums"), a = e("../strings/rich-text-xform");
                function l(e) {
                    if (null == e) return o.ValueType.Null;
                    if (e instanceof String || "string" == typeof e) return o.ValueType.String;
                    if ("number" == typeof e) return o.ValueType.Number;
                    if ("boolean" == typeof e) return o.ValueType.Boolean;
                    if (e instanceof Date) return o.ValueType.Date;
                    if (e.text && e.hyperlink) return o.ValueType.Hyperlink;
                    if (e.formula) return o.ValueType.Formula;
                    if (e.error) return o.ValueType.Error;
                    throw new Error("I could not understand type of value");
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.richTextXForm = new a;
                    }
                    get tag() {
                        return "c";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {}, function(e) {
                            switch(e.type){
                                case o.ValueType.Formula:
                                    return l(e.result);
                                default:
                                    return e.type;
                            }
                        }(e));
                        switch(r && (e.styleId = r), e.comment && t.comments.push({
                            ...e.comment,
                            ref: e.address
                        }), e.type){
                            case o.ValueType.String:
                            case o.ValueType.RichText:
                                t.sharedStrings && (e.ssId = t.sharedStrings.add(e.value));
                                break;
                            case o.ValueType.Date:
                                t.date1904 && (e.date1904 = !0);
                                break;
                            case o.ValueType.Hyperlink:
                                t.sharedStrings && void 0 !== e.text && null !== e.text && (e.ssId = t.sharedStrings.add(e.text)), t.hyperlinks.push({
                                    address: e.address,
                                    target: e.hyperlink,
                                    tooltip: e.tooltip
                                });
                                break;
                            case o.ValueType.Merge:
                                t.merges.add(e);
                                break;
                            case o.ValueType.Formula:
                                if (t.date1904 && (e.date1904 = !0), "shared" === e.shareType && (e.si = t.siFormulae++), e.formula) t.formulae[e.address] = e;
                                else if (e.sharedFormula) {
                                    const r = t.formulae[e.sharedFormula];
                                    if (!r) throw new Error("Shared Formula master must exist above and or left of clone for cell " + e.address);
                                    void 0 === r.si ? (r.shareType = "shared", r.si = t.siFormulae++, r.range = new s(r.address, e.address)) : r.range && r.range.expandToAddress(e.address), e.si = r.si;
                                }
                        }
                    }
                    renderFormula(e, t) {
                        let r = null;
                        switch(t.shareType){
                            case "shared":
                                r = {
                                    t: "shared",
                                    ref: t.ref || t.range.range,
                                    si: t.si
                                };
                                break;
                            case "array":
                                r = {
                                    t: "array",
                                    ref: t.ref
                                };
                                break;
                            default:
                                void 0 !== t.si && (r = {
                                    t: "shared",
                                    si: t.si
                                });
                        }
                        switch(l(t.result)){
                            case o.ValueType.Null:
                                e.leafNode("f", r, t.formula);
                                break;
                            case o.ValueType.String:
                                e.addAttribute("t", "str"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Number:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result);
                                break;
                            case o.ValueType.Boolean:
                                e.addAttribute("t", "b"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result ? 1 : 0);
                                break;
                            case o.ValueType.Error:
                                e.addAttribute("t", "e"), e.leafNode("f", r, t.formula), e.leafNode("v", null, t.result.error);
                                break;
                            case o.ValueType.Date:
                                e.leafNode("f", r, t.formula), e.leafNode("v", null, n.dateToExcel(t.result, t.date1904));
                                break;
                            default:
                                throw new Error("I could not understand type of value");
                        }
                    }
                    render(e, t) {
                        if (t.type !== o.ValueType.Null || t.styleId) {
                            switch(e.openNode("c"), e.addAttribute("r", t.address), t.styleId && e.addAttribute("s", t.styleId), t.type){
                                case o.ValueType.Null:
                                    break;
                                case o.ValueType.Number:
                                    e.leafNode("v", null, t.value);
                                    break;
                                case o.ValueType.Boolean:
                                    e.addAttribute("t", "b"), e.leafNode("v", null, t.value ? "1" : "0");
                                    break;
                                case o.ValueType.Error:
                                    e.addAttribute("t", "e"), e.leafNode("v", null, t.value.error);
                                    break;
                                case o.ValueType.String:
                                case o.ValueType.RichText:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : t.value && t.value.richText ? (e.addAttribute("t", "inlineStr"), e.openNode("is"), t.value.richText.forEach((t)=>{
                                        this.richTextXForm.render(e, t);
                                    }), e.closeNode("is")) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.value));
                                    break;
                                case o.ValueType.Date:
                                    e.leafNode("v", null, n.dateToExcel(t.value, t.date1904));
                                    break;
                                case o.ValueType.Hyperlink:
                                    void 0 !== t.ssId ? (e.addAttribute("t", "s"), e.leafNode("v", null, t.ssId)) : (e.addAttribute("t", "str"), e.leafNode("v", null, t.text));
                                    break;
                                case o.ValueType.Formula:
                                    this.renderFormula(e, t);
                                    break;
                                case o.ValueType.Merge:
                            }
                            e.closeNode();
                        }
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "c":
                                return this.model = {
                                    address: e.attributes.r
                                }, this.t = e.attributes.t, e.attributes.s && (this.model.styleId = parseInt(e.attributes.s, 10)), !0;
                            case "f":
                                return this.currentNode = "f", this.model.si = e.attributes.si, this.model.shareType = e.attributes.t, this.model.ref = e.attributes.ref, !0;
                            case "v":
                                return this.currentNode = "v", !0;
                            case "t":
                                return this.currentNode = "t", !0;
                            case "r":
                                return this.parser = this.richTextXForm, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        if (this.parser) this.parser.parseText(e);
                        else switch(this.currentNode){
                            case "f":
                                this.model.formula = this.model.formula ? this.model.formula + e : e;
                                break;
                            case "v":
                            case "t":
                                this.model.value && this.model.value.richText ? this.model.value.richText.text = this.model.value.richText.text ? this.model.value.richText.text + e : e : this.model.value = this.model.value ? this.model.value + e : e;
                        }
                    }
                    parseClose(e) {
                        switch(e){
                            case "c":
                                {
                                    const { model: e } = this;
                                    if (e.formula || e.shareType) e.type = o.ValueType.Formula, e.value && ("str" === this.t ? e.result = n.xmlDecode(e.value) : "b" === this.t ? e.result = 0 !== parseInt(e.value, 10) : "e" === this.t ? e.result = {
                                        error: e.value
                                    } : e.result = parseFloat(e.value), e.value = void 0);
                                    else if (void 0 !== e.value) switch(this.t){
                                        case "s":
                                            e.type = o.ValueType.String, e.value = parseInt(e.value, 10);
                                            break;
                                        case "str":
                                            e.type = o.ValueType.String, e.value = n.xmlDecode(e.value);
                                            break;
                                        case "inlineStr":
                                            e.type = o.ValueType.String;
                                            break;
                                        case "b":
                                            e.type = o.ValueType.Boolean, e.value = 0 !== parseInt(e.value, 10);
                                            break;
                                        case "e":
                                            e.type = o.ValueType.Error, e.value = {
                                                error: e.value
                                            };
                                            break;
                                        default:
                                            e.type = o.ValueType.Number, e.value = parseFloat(e.value);
                                    }
                                    else e.styleId ? e.type = o.ValueType.Null : e.type = o.ValueType.Merge;
                                    return !1;
                                }
                            case "f":
                            case "v":
                            case "is":
                                return this.currentNode = void 0, !0;
                            case "t":
                                return this.parser ? (this.parser.parseClose(e), !0) : (this.currentNode = void 0, !0);
                            case "r":
                                return this.model.value = this.model.value || {}, this.model.value.richText = this.model.value.richText || [], this.model.value.richText.push(this.parser.model), this.parser = void 0, this.currentNode = void 0, !0;
                            default:
                                return !!this.parser && (this.parser.parseClose(e), !0);
                        }
                    }
                    reconcile(e, t) {
                        const r = e.styleId && t.styles && t.styles.getStyleModel(e.styleId);
                        switch(r && (e.style = r), void 0 !== e.styleId && (e.styleId = void 0), e.type){
                            case o.ValueType.String:
                                "number" == typeof e.value && t.sharedStrings && (e.value = t.sharedStrings.getString(e.value)), e.value.richText && (e.type = o.ValueType.RichText);
                                break;
                            case o.ValueType.Number:
                                r && n.isDateFmt(r.numFmt) && (e.type = o.ValueType.Date, e.value = n.excelToDate(e.value, t.date1904));
                                break;
                            case o.ValueType.Formula:
                                void 0 !== e.result && r && n.isDateFmt(r.numFmt) && (e.result = n.excelToDate(e.result, t.date1904)), "shared" === e.shareType && (e.ref ? t.formulae[e.si] = e.address : (e.sharedFormula = t.formulae[e.si], delete e.shareType), delete e.si);
                        }
                        const i = t.hyperlinkMap[e.address];
                        i && (e.type === o.ValueType.Formula ? (e.text = e.result, e.result = void 0) : (e.text = e.value, e.value = void 0), e.type = o.ValueType.Hyperlink, e.hyperlink = i);
                        const s = t.commentsMap && t.commentsMap[e.address];
                        s && (e.comment = s);
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "../strings/rich-text-xform": 122
            }
        ],
        74: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "x14:cfIcon";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            iconSet: t.iconSet,
                            iconId: t.iconId
                        });
                    }
                    parseOpen(e) {
                        let { attributes: t } = e;
                        this.model = {
                            iconSet: t.iconSet,
                            iconId: n.toIntValue(t.iconId)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        75: [
            function(e, t, r) {
                "use strict";
                const { v4: n } = e("uuid"), i = e("../../base-xform"), s = e("../../composite-xform"), o = e("./databar-ext-xform"), a = e("./icon-set-ext-xform"), l = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                };
                class c extends s {
                    constructor(){
                        super(), this.map = {
                            "x14:dataBar": this.databarXform = new o,
                            "x14:iconSet": this.iconSetXform = new a
                        };
                    }
                    get tag() {
                        return "x14:cfRule";
                    }
                    static isExt(e) {
                        return "dataBar" === e.type ? o.isExt(e) : !("iconSet" !== e.type || !e.custom && !l[e.iconSet]);
                    }
                    prepare(e) {
                        c.isExt(e) && (e.x14Id = `{${n()}}`.toUpperCase());
                    }
                    render(e, t) {
                        if (c.isExt(t)) switch(t.type){
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                        }
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            id: t.x14Id
                        }), this.databarXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority,
                            id: t.x14Id || `{${n()}}`
                        }), this.iconSetXform.render(e, t), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            type: t.type,
                            x14Id: t.id,
                            priority: i.toIntValue(t.priority)
                        };
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                }
                t.exports = c;
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./databar-ext-xform": 79,
                "./icon-set-ext-xform": 81,
                uuid: 528
            }
        ],
        76: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./f-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:f": this.fExtXform = new i
                        };
                    }
                    get tag() {
                        return "x14:cfvo";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            type: t.type
                        }), void 0 !== t.value && this.fExtXform.render(e, t.value), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            type: e.attributes.type
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:f":
                                this.model.value = t.model ? parseFloat(t.model) : 0;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./f-ext-xform": 80
            }
        ],
        77: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./sqref-ext-xform"), s = e("./cf-rule-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "xm:sqref": this.sqRef = new i,
                            "x14:cfRule": this.cfRule = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormatting";
                    }
                    prepare(e, t) {
                        e.rules.forEach((e)=>{
                            this.cfRule.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        t.rules.some(s.isExt) && (e.openNode(this.tag, {
                            "xmlns:xm": "http://schemas.microsoft.com/office/excel/2006/main"
                        }), t.rules.filter(s.isExt).forEach((t)=>this.cfRule.render(e, t)), this.sqRef.render(e, t.ref), e.closeNode());
                    }
                    createNewModel() {
                        return {
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "xm:sqref":
                                this.model.ref = t.model;
                                break;
                            case "x14:cfRule":
                                this.model.rules.push(t.model);
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./sqref-ext-xform": 82
            }
        ],
        78: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-ext-xform"), s = e("./conditional-formatting-ext-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormatting": this.cfXform = new s
                        };
                    }
                    get tag() {
                        return "x14:conditionalFormattings";
                    }
                    hasContent(e) {
                        return void 0 === e.hasExtContent && (e.hasExtContent = e.some((e)=>e.rules.some(i.isExt))), e.hasExtContent;
                    }
                    prepare(e, t) {
                        e.forEach((e)=>{
                            this.cfXform.prepare(e, t);
                        });
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode(this.tag), t.forEach((t)=>this.cfXform.render(e, t)), e.closeNode());
                    }
                    createNewModel() {
                        return [];
                    }
                    onParserClose(e, t) {
                        this.model.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-ext-xform": 75,
                "./conditional-formatting-ext-xform": 77
            }
        ],
        79: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../style/color-xform"), o = e("./cfvo-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new o,
                            "x14:borderColor": this.borderColorXform = new s("x14:borderColor"),
                            "x14:negativeBorderColor": this.negativeBorderColorXform = new s("x14:negativeBorderColor"),
                            "x14:negativeFillColor": this.negativeFillColorXform = new s("x14:negativeFillColor"),
                            "x14:axisColor": this.axisColorXform = new s("x14:axisColor")
                        };
                    }
                    static isExt(e) {
                        return !e.gradient;
                    }
                    get tag() {
                        return "x14:dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            minLength: n.toIntAttribute(t.minLength, 0, !0),
                            maxLength: n.toIntAttribute(t.maxLength, 100, !0),
                            border: n.toBoolAttribute(t.border, !1),
                            gradient: n.toBoolAttribute(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolAttribute(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolAttribute(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toAttribute(t.axisPosition, "auto"),
                            direction: n.toAttribute(t.direction, "leftToRight")
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.borderColorXform.render(e, t.borderColor), this.negativeBorderColorXform.render(e, t.negativeBorderColor), this.negativeFillColorXform.render(e, t.negativeFillColor), this.axisColorXform.render(e, t.axisColor), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            minLength: n.toIntValue(t.minLength, 0),
                            maxLength: n.toIntValue(t.maxLength, 100),
                            border: n.toBoolValue(t.border, !1),
                            gradient: n.toBoolValue(t.gradient, !0),
                            negativeBarColorSameAsPositive: n.toBoolValue(t.negativeBarColorSameAsPositive, !0),
                            negativeBarBorderColorSameAsPositive: n.toBoolValue(t.negativeBarBorderColorSameAsPositive, !0),
                            axisPosition: n.toStringValue(t.axisPosition, "auto"),
                            direction: n.toStringValue(t.direction, "leftToRight")
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-ext-xform": 76
            }
        ],
        80: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:f";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        81: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-ext-xform"), o = e("./cf-icon-ext-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:cfvo": this.cfvoXform = new s,
                            "x14:cfIcon": this.cfIconXform = new o
                        };
                    }
                    get tag() {
                        return "x14:iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0),
                            custom: n.toBoolAttribute(t.icons, !1)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.icons && t.icons.forEach((t, r)=>{
                            t.iconId = r, this.cfIconXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            cfvo: [],
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse, !1),
                            showValue: n.toBoolValue(t.showValue, !0)
                        };
                    }
                    onParserClose(e, t) {
                        const [, r] = e.split(":");
                        switch(r){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "cfIcon":
                                this.model.icons || (this.model.icons = []), this.model.icons.push(t.model);
                                break;
                            default:
                                this.model[r] = t.model;
                        }
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cf-icon-ext-xform": 74,
                "./cfvo-ext-xform": 76
            }
        ],
        82: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "xm:sqref";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        83: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("../../../../doc/range"), o = e("./databar-xform"), a = e("./ext-lst-ref-xform"), l = e("./formula-xform"), c = e("./color-scale-xform"), u = e("./icon-set-xform"), h = {
                    "3Triangles": !0,
                    "3Stars": !0,
                    "5Boxes": !0
                }, f = (e)=>{
                    const { type: t, operator: r } = e;
                    switch(t){
                        case "containsText":
                        case "containsBlanks":
                        case "notContainsBlanks":
                        case "containsErrors":
                        case "notContainsErrors":
                            return {
                                type: "containsText",
                                operator: t
                            };
                        default:
                            return {
                                type: t,
                                operator: r
                            };
                    }
                };
                class d extends i {
                    constructor(){
                        super(), this.map = {
                            dataBar: this.databarXform = new o,
                            extLst: this.extLstRefXform = new a,
                            formula: this.formulaXform = new l,
                            colorScale: this.colorScaleXform = new c,
                            iconSet: this.iconSetXform = new u
                        };
                    }
                    get tag() {
                        return "cfRule";
                    }
                    static isPrimitive(e) {
                        return "iconSet" !== e.type || !e.custom && !h[e.iconSet];
                    }
                    render(e, t) {
                        switch(t.type){
                            case "expression":
                                this.renderExpression(e, t);
                                break;
                            case "cellIs":
                                this.renderCellIs(e, t);
                                break;
                            case "top10":
                                this.renderTop10(e, t);
                                break;
                            case "aboveAverage":
                                this.renderAboveAverage(e, t);
                                break;
                            case "dataBar":
                                this.renderDataBar(e, t);
                                break;
                            case "colorScale":
                                this.renderColorScale(e, t);
                                break;
                            case "iconSet":
                                this.renderIconSet(e, t);
                                break;
                            case "containsText":
                                this.renderText(e, t);
                                break;
                            case "timePeriod":
                                this.renderTimePeriod(e, t);
                        }
                    }
                    renderExpression(e, t) {
                        e.openNode(this.tag, {
                            type: "expression",
                            dxfId: t.dxfId,
                            priority: t.priority
                        }), this.formulaXform.render(e, t.formulae[0]), e.closeNode();
                    }
                    renderCellIs(e, t) {
                        e.openNode(this.tag, {
                            type: "cellIs",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: t.operator
                        }), t.formulae.forEach((t)=>{
                            this.formulaXform.render(e, t);
                        }), e.closeNode();
                    }
                    renderTop10(e, t) {
                        e.leafNode(this.tag, {
                            type: "top10",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            percent: n.toBoolAttribute(t.percent, !1),
                            bottom: n.toBoolAttribute(t.bottom, !1),
                            rank: n.toIntValue(t.rank, 10, !0)
                        });
                    }
                    renderAboveAverage(e, t) {
                        e.leafNode(this.tag, {
                            type: "aboveAverage",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            aboveAverage: n.toBoolAttribute(t.aboveAverage, !0)
                        });
                    }
                    renderDataBar(e, t) {
                        e.openNode(this.tag, {
                            type: "dataBar",
                            priority: t.priority
                        }), this.databarXform.render(e, t), this.extLstRefXform.render(e, t), e.closeNode();
                    }
                    renderColorScale(e, t) {
                        e.openNode(this.tag, {
                            type: "colorScale",
                            priority: t.priority
                        }), this.colorScaleXform.render(e, t), e.closeNode();
                    }
                    renderIconSet(e, t) {
                        d.isPrimitive(t) && (e.openNode(this.tag, {
                            type: "iconSet",
                            priority: t.priority
                        }), this.iconSetXform.render(e, t), e.closeNode());
                    }
                    renderText(e, t) {
                        e.openNode(this.tag, {
                            type: t.operator,
                            dxfId: t.dxfId,
                            priority: t.priority,
                            operator: n.toStringAttribute(t.operator, "containsText")
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.operator){
                                case "containsText":
                                    return `NOT(ISERROR(SEARCH("${e.text}",${r})))`;
                                case "containsBlanks":
                                    return `LEN(TRIM(${r}))=0`;
                                case "notContainsBlanks":
                                    return `LEN(TRIM(${r}))>0`;
                                case "containsErrors":
                                    return `ISERROR(${r})`;
                                case "notContainsErrors":
                                    return `NOT(ISERROR(${r}))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    renderTimePeriod(e, t) {
                        e.openNode(this.tag, {
                            type: "timePeriod",
                            dxfId: t.dxfId,
                            priority: t.priority,
                            timePeriod: t.timePeriod
                        });
                        const r = ((e)=>{
                            if (e.formulae && e.formulae[0]) return e.formulae[0];
                            const t = new s(e.ref), { tl: r } = t;
                            switch(e.timePeriod){
                                case "thisWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)<=WEEKDAY(TODAY())-1,ROUNDDOWN(${r},0)-TODAY()<=7-WEEKDAY(TODAY()))`;
                                case "lastWeek":
                                    return `AND(TODAY()-ROUNDDOWN(${r},0)>=(WEEKDAY(TODAY())),TODAY()-ROUNDDOWN(${r},0)<(WEEKDAY(TODAY())+7))`;
                                case "nextWeek":
                                    return `AND(ROUNDDOWN(${r},0)-TODAY()>(7-WEEKDAY(TODAY())),ROUNDDOWN(${r},0)-TODAY()<(15-WEEKDAY(TODAY())))`;
                                case "yesterday":
                                    return `FLOOR(${r},1)=TODAY()-1`;
                                case "today":
                                    return `FLOOR(${r},1)=TODAY()`;
                                case "tomorrow":
                                    return `FLOOR(${r},1)=TODAY()+1`;
                                case "last7Days":
                                    return `AND(TODAY()-FLOOR(${r},1)<=6,FLOOR(${r},1)<=TODAY())`;
                                case "lastMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0-1)),YEAR(${r})=YEAR(EDATE(TODAY(),0-1)))`;
                                case "thisMonth":
                                    return `AND(MONTH(${r})=MONTH(TODAY()),YEAR(${r})=YEAR(TODAY()))`;
                                case "nextMonth":
                                    return `AND(MONTH(${r})=MONTH(EDATE(TODAY(),0+1)),YEAR(${r})=YEAR(EDATE(TODAY(),0+1)))`;
                                default:
                                    return;
                            }
                        })(t);
                        r && this.formulaXform.render(e, r), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ...f(t),
                            dxfId: n.toIntValue(t.dxfId),
                            priority: n.toIntValue(t.priority),
                            timePeriod: t.timePeriod,
                            percent: n.toBoolValue(t.percent),
                            bottom: n.toBoolValue(t.bottom),
                            rank: n.toIntValue(t.rank),
                            aboveAverage: n.toBoolValue(t.aboveAverage)
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "dataBar":
                            case "extLst":
                            case "colorScale":
                            case "iconSet":
                                Object.assign(this.model, t.model);
                                break;
                            case "formula":
                                this.model.formulae = this.model.formulae || [], this.model.formulae.push(t.model);
                        }
                    }
                }
                t.exports = d;
            },
            {
                "../../../../doc/range": 10,
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./color-scale-xform": 85,
                "./databar-xform": 88,
                "./ext-lst-ref-xform": 89,
                "./formula-xform": 90,
                "./icon-set-xform": 91
            }
        ],
        84: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "cfvo";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            type: t.type,
                            val: t.value
                        });
                    }
                    parseOpen(e) {
                        this.model = {
                            type: e.attributes.type,
                            value: n.toFloatValue(e.attributes.val)
                        };
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        85: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "colorScale";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), t.color.forEach((t)=>{
                            this.colorXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        return {
                            cfvo: [],
                            color: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        86: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("./cf-rule-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfRule: new i
                        };
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    render(e, t) {
                        t.rules.some(i.isPrimitive) && (e.openNode(this.tag, {
                            sqref: t.ref
                        }), t.rules.forEach((r)=>{
                            i.isPrimitive(r) && (r.ref = t.ref, this.map.cfRule.render(e, r));
                        }), e.closeNode());
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            ref: t.sqref,
                            rules: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model.rules.push(t.model);
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "./cf-rule-xform": 83
            }
        ],
        87: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("./conditional-formatting-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.cfXform = new i;
                    }
                    get tag() {
                        return "conditionalFormatting";
                    }
                    reset() {
                        this.model = [];
                    }
                    prepare(e, t) {
                        let r = e.reduce((e, t)=>Math.max(e, ...t.rules.map((e)=>e.priority || 0)), 1);
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                e.priority || (e.priority = r++), e.style && (e.dxfId = t.styles.addDxfStyle(e.style));
                            });
                        });
                    }
                    render(e, t) {
                        t.forEach((t)=>{
                            this.cfXform.render(e, t);
                        });
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "conditionalFormatting":
                                return this.parser = this.cfXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (!!this.parser.parseClose(e) || (this.model.push(this.parser.model), this.parser = void 0, !1));
                    }
                    reconcile(e, t) {
                        e.forEach((e)=>{
                            e.rules.forEach((e)=>{
                                void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId), delete e.dxfId);
                            });
                        });
                    }
                };
            },
            {
                "../../base-xform": 32,
                "./conditional-formatting-xform": 86
            }
        ],
        88: [
            function(e, t, r) {
                "use strict";
                const n = e("../../composite-xform"), i = e("../../style/color-xform"), s = e("./cfvo-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s,
                            color: this.colorXform = new i
                        };
                    }
                    get tag() {
                        return "dataBar";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), this.colorXform.render(e, t.color), e.closeNode();
                    }
                    createNewModel() {
                        return {
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        switch(e){
                            case "cfvo":
                                this.model.cfvo.push(t.model);
                                break;
                            case "color":
                                this.model.color = t.model;
                        }
                    }
                };
            },
            {
                "../../composite-xform": 48,
                "../../style/color-xform": 128,
                "./cfvo-xform": 84
            }
        ],
        89: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform");
                class s extends n {
                    get tag() {
                        return "x14:id";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                }
                class o extends i {
                    constructor(){
                        super(), this.map = {
                            "x14:id": this.idXform = new s
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            uri: "{B025F937-C7B1-47D3-B67F-A62EFF666E3E}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.idXform.render(e, t.x14Id), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model.x14Id = t.model;
                    }
                }
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            ext: new o
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    render(e, t) {
                        e.openNode(this.tag), this.map.ext.render(e, t), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48
            }
        ],
        90: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "formula";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, null, t);
                    }
                    parseOpen() {
                        this.model = "";
                    }
                    parseText(e) {
                        this.model += e;
                    }
                    parseClose(e) {
                        return e !== this.tag;
                    }
                };
            },
            {
                "../../base-xform": 32
            }
        ],
        91: [
            function(e, t, r) {
                "use strict";
                const n = e("../../base-xform"), i = e("../../composite-xform"), s = e("./cfvo-xform");
                t.exports = class extends i {
                    constructor(){
                        super(), this.map = {
                            cfvo: this.cfvoXform = new s
                        };
                    }
                    get tag() {
                        return "iconSet";
                    }
                    render(e, t) {
                        e.openNode(this.tag, {
                            iconSet: n.toStringAttribute(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolAttribute(t.reverse, !1),
                            showValue: n.toBoolAttribute(t.showValue, !0)
                        }), t.cfvo.forEach((t)=>{
                            this.cfvoXform.render(e, t);
                        }), e.closeNode();
                    }
                    createNewModel(e) {
                        let { attributes: t } = e;
                        return {
                            iconSet: n.toStringValue(t.iconSet, "3TrafficLights"),
                            reverse: n.toBoolValue(t.reverse),
                            showValue: n.toBoolValue(t.showValue),
                            cfvo: []
                        };
                    }
                    onParserClose(e, t) {
                        this.model[e].push(t.model);
                    }
                };
            },
            {
                "../../base-xform": 32,
                "../../composite-xform": 48,
                "./cfvo-xform": 84
            }
        ],
        92: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/utils"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "col";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style || {});
                        r && (e.styleId = r);
                    }
                    render(e, t) {
                        e.openNode("col"), e.addAttribute("min", t.min), e.addAttribute("max", t.max), t.width && e.addAttribute("width", t.width), t.styleId && e.addAttribute("style", t.styleId), t.hidden && e.addAttribute("hidden", "1"), t.bestFit && e.addAttribute("bestFit", "1"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1"), e.addAttribute("customWidth", "1"), e.closeNode();
                    }
                    parseOpen(e) {
                        if ("col" === e.name) {
                            const t = this.model = {
                                min: parseInt(e.attributes.min || "0", 10),
                                max: parseInt(e.attributes.max || "0", 10),
                                width: void 0 === e.attributes.width ? void 0 : parseFloat(e.attributes.width || "0")
                            };
                            return e.attributes.style && (t.styleId = parseInt(e.attributes.style, 10)), n.parseBoolean(e.attributes.hidden) && (t.hidden = !0), n.parseBoolean(e.attributes.bestFit) && (t.bestFit = !0), e.attributes.outlineLevel && (t.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), n.parseBoolean(e.attributes.collapsed) && (t.collapsed = !0), !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    reconcile(e, t) {
                        e.styleId && (e.style = t.styles.getStyleModel(e.styleId));
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        93: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/utils"), s = e("../../../utils/col-cache"), o = e("../base-xform"), a = e("../../../doc/range");
                function l(e, t, r, n) {
                    const i = t[r];
                    void 0 !== i ? e[r] = i : void 0 !== n && (e[r] = n);
                }
                function c(e, t, r, n) {
                    const s = t[r];
                    void 0 !== s ? e[r] = i.parseBoolean(s) : void 0 !== n && (e[r] = n);
                }
                t.exports = class extends o {
                    get tag() {
                        return "dataValidations";
                    }
                    render(e, t) {
                        const r = function(e) {
                            const t = n.map(e, (e, t)=>({
                                    address: t,
                                    dataValidation: e,
                                    marked: !1
                                })).sort((e, t)=>n.strcmp(e.address, t.address)), r = n.keyBy(t, "address"), i = (t, r, i)=>{
                                for(let o = 0; o < r; o++){
                                    const r = s.encodeAddress(t.row + o, i);
                                    if (!e[r] || !n.isEqual(e[t.address], e[r])) return !1;
                                }
                                return !0;
                            };
                            return t.map((t)=>{
                                if (!t.marked) {
                                    const o = s.decodeEx(t.address);
                                    if (o.dimensions) return r[o.dimensions].marked = !0, {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                    let a = 1, l = s.encodeAddress(o.row + a, o.col);
                                    for(; e[l] && n.isEqual(t.dataValidation, e[l]);)a++, l = s.encodeAddress(o.row + a, o.col);
                                    let c = 1;
                                    for(; i(o, a, o.col + c);)c++;
                                    for(let e = 0; e < a; e++)for(let t = 0; t < c; t++)l = s.encodeAddress(o.row + e, o.col + t), r[l].marked = !0;
                                    if (a > 1 || c > 1) {
                                        const e = o.row + (a - 1), r = o.col + (c - 1);
                                        return {
                                            ...t.dataValidation,
                                            sqref: `${t.address}:${s.encodeAddress(e, r)}`
                                        };
                                    }
                                    return {
                                        ...t.dataValidation,
                                        sqref: t.address
                                    };
                                }
                                return null;
                            }).filter(Boolean);
                        }(t);
                        r.length && (e.openNode("dataValidations", {
                            count: r.length
                        }), r.forEach((t)=>{
                            e.openNode("dataValidation"), "any" !== t.type && (e.addAttribute("type", t.type), t.operator && "list" !== t.type && "between" !== t.operator && e.addAttribute("operator", t.operator), t.allowBlank && e.addAttribute("allowBlank", "1")), t.showInputMessage && e.addAttribute("showInputMessage", "1"), t.promptTitle && e.addAttribute("promptTitle", t.promptTitle), t.prompt && e.addAttribute("prompt", t.prompt), t.showErrorMessage && e.addAttribute("showErrorMessage", "1"), t.errorStyle && e.addAttribute("errorStyle", t.errorStyle), t.errorTitle && e.addAttribute("errorTitle", t.errorTitle), t.error && e.addAttribute("error", t.error), e.addAttribute("sqref", t.sqref), (t.formulae || []).forEach((r, n)=>{
                                e.openNode("formula" + (n + 1)), "date" === t.type ? e.writeText(i.dateToExcel(new Date(r))) : e.writeText(r), e.closeNode();
                            }), e.closeNode();
                        }), e.closeNode());
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "dataValidations":
                                return this.model = {}, !0;
                            case "dataValidation":
                                {
                                    this._address = e.attributes.sqref;
                                    const t = {
                                        type: e.attributes.type || "any",
                                        formulae: []
                                    };
                                    switch(e.attributes.type && c(t, e.attributes, "allowBlank"), c(t, e.attributes, "showInputMessage"), c(t, e.attributes, "showErrorMessage"), t.type){
                                        case "any":
                                        case "list":
                                        case "custom":
                                            break;
                                        default:
                                            l(t, e.attributes, "operator", "between");
                                    }
                                    return l(t, e.attributes, "promptTitle"), l(t, e.attributes, "prompt"), l(t, e.attributes, "errorStyle"), l(t, e.attributes, "errorTitle"), l(t, e.attributes, "error"), this._dataValidation = t, !0;
                                }
                            case "formula1":
                            case "formula2":
                                return this._formula = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._formula && this._formula.push(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "dataValidations":
                                return !1;
                            case "dataValidation":
                                this._dataValidation.formulae && this._dataValidation.formulae.length || (delete this._dataValidation.formulae, delete this._dataValidation.operator);
                                return (this._address.split(/\s+/g) || []).forEach((e)=>{
                                    if (e.includes(":")) new a(e).forEachAddress((e)=>{
                                        this.model[e] = this._dataValidation;
                                    });
                                    else this.model[e] = this._dataValidation;
                                }), !0;
                            case "formula1":
                            case "formula2":
                                {
                                    let e = this._formula.join("");
                                    switch(this._dataValidation.type){
                                        case "whole":
                                        case "textLength":
                                            e = parseInt(e, 10);
                                            break;
                                        case "decimal":
                                            e = parseFloat(e);
                                            break;
                                        case "date":
                                            e = i.excelToDate(parseFloat(e));
                                    }
                                    return this._dataValidation.formulae.push(e), this._formula = void 0, !0;
                                }
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        94: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "dimension";
                    }
                    render(e, t) {
                        t && e.leafNode("dimension", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "dimension" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        95: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "drawing";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        96: [
            function(e, t, r) {
                "use strict";
                const n = e("../composite-xform"), i = e("./cf-ext/conditional-formattings-ext-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            "x14:conditionalFormattings": this.conditionalFormattings = new i
                        };
                    }
                    get tag() {
                        return "ext";
                    }
                    hasContent(e) {
                        return this.conditionalFormattings.hasContent(e.conditionalFormattings);
                    }
                    prepare(e, t) {
                        this.conditionalFormattings.prepare(e.conditionalFormattings, t);
                    }
                    render(e, t) {
                        e.openNode("ext", {
                            uri: "{78C0D931-6437-407d-A8EE-F0AAD7539E65}",
                            "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                        }), this.conditionalFormattings.render(e, t.conditionalFormattings), e.closeNode();
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        this.model[e] = t.model;
                    }
                }
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            ext: this.ext = new s
                        };
                    }
                    get tag() {
                        return "extLst";
                    }
                    prepare(e, t) {
                        this.ext.prepare(e, t);
                    }
                    hasContent(e) {
                        return this.ext.hasContent(e);
                    }
                    render(e, t) {
                        this.hasContent(t) && (e.openNode("extLst"), this.ext.render(e, t), e.closeNode());
                    }
                    createNewModel() {
                        return {};
                    }
                    onParserClose(e, t) {
                        Object.assign(this.model, t.model);
                    }
                };
            },
            {
                "../composite-xform": 48,
                "./cf-ext/conditional-formattings-ext-xform": 78
            }
        ],
        97: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "headerFooter";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback();
                            let r = !1;
                            e.openNode("headerFooter"), t.differentFirst && (e.addAttribute("differentFirst", "1"), r = !0), t.differentOddEven && (e.addAttribute("differentOddEven", "1"), r = !0), t.oddHeader && "string" == typeof t.oddHeader && (e.leafNode("oddHeader", null, t.oddHeader), r = !0), t.oddFooter && "string" == typeof t.oddFooter && (e.leafNode("oddFooter", null, t.oddFooter), r = !0), t.evenHeader && "string" == typeof t.evenHeader && (e.leafNode("evenHeader", null, t.evenHeader), r = !0), t.evenFooter && "string" == typeof t.evenFooter && (e.leafNode("evenFooter", null, t.evenFooter), r = !0), t.firstHeader && "string" == typeof t.firstHeader && (e.leafNode("firstHeader", null, t.firstHeader), r = !0), t.firstFooter && "string" == typeof t.firstFooter && (e.leafNode("firstFooter", null, t.firstFooter), r = !0), r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "headerFooter":
                                return this.model = {}, e.attributes.differentFirst && (this.model.differentFirst = 1 === parseInt(e.attributes.differentFirst, 0)), e.attributes.differentOddEven && (this.model.differentOddEven = 1 === parseInt(e.attributes.differentOddEven, 0)), !0;
                            case "oddHeader":
                                return this.currentNode = "oddHeader", !0;
                            case "oddFooter":
                                return this.currentNode = "oddFooter", !0;
                            case "evenHeader":
                                return this.currentNode = "evenHeader", !0;
                            case "evenFooter":
                                return this.currentNode = "evenFooter", !0;
                            case "firstHeader":
                                return this.currentNode = "firstHeader", !0;
                            case "firstFooter":
                                return this.currentNode = "firstFooter", !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        switch(this.currentNode){
                            case "oddHeader":
                                this.model.oddHeader = e;
                                break;
                            case "oddFooter":
                                this.model.oddFooter = e;
                                break;
                            case "evenHeader":
                                this.model.evenHeader = e;
                                break;
                            case "evenFooter":
                                this.model.evenFooter = e;
                                break;
                            case "firstHeader":
                                this.model.firstHeader = e;
                                break;
                            case "firstFooter":
                                this.model.firstFooter = e;
                        }
                    }
                    parseClose() {
                        switch(this.currentNode){
                            case "oddHeader":
                            case "oddFooter":
                            case "evenHeader":
                            case "evenFooter":
                            case "firstHeader":
                            case "firstFooter":
                                return this.currentNode = void 0, !0;
                            default:
                                return !1;
                        }
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        98: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "hyperlink";
                    }
                    render(e, t) {
                        this.isInternalLink(t) ? e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip,
                            location: t.target
                        }) : e.leafNode("hyperlink", {
                            ref: t.address,
                            "r:id": t.rId,
                            tooltip: t.tooltip
                        });
                    }
                    parseOpen(e) {
                        return "hyperlink" === e.name && (this.model = {
                            address: e.attributes.ref,
                            rId: e.attributes["r:id"],
                            tooltip: e.attributes.tooltip
                        }, e.attributes.location && (this.model.target = e.attributes.location), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                    isInternalLink(e) {
                        return e.target && /^[^!]+![a-zA-Z]+[\d]+$/.test(e.target);
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        99: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "mergeCell";
                    }
                    render(e, t) {
                        e.leafNode("mergeCell", {
                            ref: t
                        });
                    }
                    parseOpen(e) {
                        return "mergeCell" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        100: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../doc/range"), s = e("../../../utils/col-cache"), o = e("../../../doc/enums");
                t.exports = class {
                    constructor(){
                        this.merges = {};
                    }
                    add(e) {
                        if (this.merges[e.master]) this.merges[e.master].expandToAddress(e.address);
                        else {
                            const t = `${e.master}:${e.address}`;
                            this.merges[e.master] = new i(t);
                        }
                    }
                    get mergeCells() {
                        return n.map(this.merges, (e)=>e.range);
                    }
                    reconcile(e, t) {
                        n.each(e, (e)=>{
                            const r = s.decode(e);
                            for(let e = r.top; e <= r.bottom; e++){
                                const n = t[e - 1];
                                for(let t = r.left; t <= r.right; t++){
                                    const i = n.cells[t - 1];
                                    i ? i.type === o.ValueType.Merge && (i.master = r.tl) : n.cells[t] = {
                                        type: o.ValueType.Null,
                                        address: s.encodeAddress(e, t)
                                    };
                                }
                            }
                        });
                    }
                    getMasterAddress(e) {
                        const t = this.hash[e];
                        return t && t.tl;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../doc/range": 10,
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26
            }
        ],
        101: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = (e)=>void 0 !== e;
                t.exports = class extends n {
                    get tag() {
                        return "outlinePr";
                    }
                    render(e, t) {
                        return !(!t || !i(t.summaryBelow) && !i(t.summaryRight)) && (e.leafNode(this.tag, {
                            summaryBelow: i(t.summaryBelow) ? Number(t.summaryBelow) : void 0,
                            summaryRight: i(t.summaryRight) ? Number(t.summaryRight) : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            summaryBelow: i(e.attributes.summaryBelow) ? Boolean(Number(e.attributes.summaryBelow)) : void 0,
                            summaryRight: i(e.attributes.summaryRight) ? Boolean(Number(e.attributes.summaryRight)) : void 0
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        102: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "brk";
                    }
                    render(e, t) {
                        e.leafNode("brk", t);
                    }
                    parseOpen(e) {
                        return "brk" === e.name && (this.model = e.attributes.ref, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        103: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "pageMargins";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                left: t.left,
                                right: t.right,
                                top: t.top,
                                bottom: t.bottom,
                                header: t.header,
                                footer: t.footer
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    left: parseFloat(e.attributes.left || .7),
                                    right: parseFloat(e.attributes.right || .7),
                                    top: parseFloat(e.attributes.top || .75),
                                    bottom: parseFloat(e.attributes.bottom || .75),
                                    header: parseFloat(e.attributes.header || .3),
                                    footer: parseFloat(e.attributes.footer || .3)
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        104: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "pageSetUpPr";
                    }
                    render(e, t) {
                        return !(!t || !t.fitToPage) && (e.leafNode(this.tag, {
                            fitToPage: t.fitToPage ? "1" : void 0
                        }), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            fitToPage: "1" === e.attributes.fitToPage
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        105: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                function o(e) {
                    switch(e){
                        case "overThenDown":
                            return e;
                        default:
                            return;
                    }
                }
                function a(e) {
                    switch(e){
                        case "atEnd":
                        case "asDisplyed":
                            return e;
                        default:
                            return;
                    }
                }
                function l(e) {
                    switch(e){
                        case "dash":
                        case "blank":
                        case "NA":
                            return e;
                        default:
                            return;
                    }
                }
                t.exports = class extends i {
                    get tag() {
                        return "pageSetup";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                paperSize: t.paperSize,
                                orientation: t.orientation,
                                horizontalDpi: t.horizontalDpi,
                                verticalDpi: t.verticalDpi,
                                pageOrder: o(t.pageOrder),
                                blackAndWhite: s(t.blackAndWhite),
                                draft: s(t.draft),
                                cellComments: a(t.cellComments),
                                errors: l(t.errors),
                                scale: t.scale,
                                fitToWidth: t.fitToWidth,
                                fitToHeight: t.fitToHeight,
                                firstPageNumber: t.firstPageNumber,
                                useFirstPageNumber: s(t.firstPageNumber),
                                usePrinterDefaults: s(t.usePrinterDefaults),
                                copies: t.copies
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    paperSize: (t = e.attributes.paperSize, void 0 !== t ? parseInt(t, 10) : void 0),
                                    orientation: e.attributes.orientation || "portrait",
                                    horizontalDpi: parseInt(e.attributes.horizontalDpi || "4294967295", 10),
                                    verticalDpi: parseInt(e.attributes.verticalDpi || "4294967295", 10),
                                    pageOrder: e.attributes.pageOrder || "downThenOver",
                                    blackAndWhite: "1" === e.attributes.blackAndWhite,
                                    draft: "1" === e.attributes.draft,
                                    cellComments: e.attributes.cellComments || "None",
                                    errors: e.attributes.errors || "displayed",
                                    scale: parseInt(e.attributes.scale || "100", 10),
                                    fitToWidth: parseInt(e.attributes.fitToWidth || "1", 10),
                                    fitToHeight: parseInt(e.attributes.fitToHeight || "1", 10),
                                    firstPageNumber: parseInt(e.attributes.firstPageNumber || "1", 10),
                                    useFirstPageNumber: "1" === e.attributes.useFirstPageNumber,
                                    usePrinterDefaults: "1" === e.attributes.usePrinterDefaults,
                                    copies: parseInt(e.attributes.copies || "1", 10)
                                }, !0;
                            default:
                                return !1;
                        }
                        var t;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        106: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "picture";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        107: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e) {
                    return e ? "1" : void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "printOptions";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                headings: s(t.showRowColHeaders),
                                gridLines: s(t.showGridLines),
                                horizontalCentered: s(t.horizontalCentered),
                                verticalCentered: s(t.verticalCentered)
                            };
                            n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    showRowColHeaders: "1" === e.attributes.headings,
                                    showGridLines: "1" === e.attributes.gridLines,
                                    horizontalCentered: "1" === e.attributes.horizontalCentered,
                                    verticalCentered: "1" === e.attributes.verticalCentered
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        108: [
            function(e, t, r) {
                "use strict";
                const n = e("./page-breaks-xform"), i = e("../list-xform");
                t.exports = class extends i {
                    constructor(){
                        super({
                            tag: "rowBreaks",
                            count: !0,
                            childXform: new n
                        });
                    }
                    render(e, t) {
                        if (t && t.length) {
                            e.openNode(this.tag, this.$), this.count && (e.addAttribute(this.$count, t.length), e.addAttribute("manualBreakCount", t.length));
                            const { childXform: r } = this;
                            t.forEach((t)=>{
                                r.render(e, t);
                            }), e.closeNode();
                        } else this.empty && e.leafNode(this.tag);
                    }
                };
            },
            {
                "../list-xform": 71,
                "./page-breaks-xform": 102
            }
        ],
        109: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./cell-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.maxItems = e && e.maxItems, this.map = {
                            c: new s
                        };
                    }
                    get tag() {
                        return "row";
                    }
                    prepare(e, t) {
                        const r = t.styles.addStyleModel(e.style);
                        r && (e.styleId = r);
                        const n = this.map.c;
                        e.cells.forEach((e)=>{
                            n.prepare(e, t);
                        });
                    }
                    render(e, t, r) {
                        e.openNode("row"), e.addAttribute("r", t.number), t.height && (e.addAttribute("ht", t.height), e.addAttribute("customHeight", "1")), t.hidden && e.addAttribute("hidden", "1"), t.min > 0 && t.max > 0 && t.min <= t.max && e.addAttribute("spans", `${t.min}:${t.max}`), t.styleId && (e.addAttribute("s", t.styleId), e.addAttribute("customFormat", "1")), e.addAttribute("x14ac:dyDescent", "0.25"), t.outlineLevel && e.addAttribute("outlineLevel", t.outlineLevel), t.collapsed && e.addAttribute("collapsed", "1");
                        const n = this.map.c;
                        t.cells.forEach((t)=>{
                            n.render(e, t, r);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if ("row" === e.name) {
                            this.numRowsSeen += 1;
                            const t = e.attributes.spans ? e.attributes.spans.split(":").map((e)=>parseInt(e, 10)) : [
                                void 0,
                                void 0
                            ], r = this.model = {
                                number: parseInt(e.attributes.r, 10),
                                min: t[0],
                                max: t[1],
                                cells: []
                            };
                            return e.attributes.s && (r.styleId = parseInt(e.attributes.s, 10)), i.parseBoolean(e.attributes.hidden) && (r.hidden = !0), i.parseBoolean(e.attributes.bestFit) && (r.bestFit = !0), e.attributes.ht && (r.height = parseFloat(e.attributes.ht)), e.attributes.outlineLevel && (r.outlineLevel = parseInt(e.attributes.outlineLevel, 10)), i.parseBoolean(e.attributes.collapsed) && (r.collapsed = !0), !0;
                        }
                        return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                if (this.model.cells.push(this.parser.model), this.maxItems && this.model.cells.length > this.maxItems) throw new Error(`Max column count (${this.maxItems}) exceeded`);
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        return !1;
                    }
                    reconcile(e, t) {
                        e.style = e.styleId ? t.styles.getStyleModel(e.styleId) : {}, void 0 !== e.styleId && (e.styleId = void 0);
                        const r = this.map.c;
                        e.cells.forEach((e)=>{
                            r.reconcile(e, t);
                        });
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./cell-xform": 73
            }
        ],
        110: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                t.exports = class extends i {
                    get tag() {
                        return "sheetFormatPr";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                defaultRowHeight: t.defaultRowHeight,
                                outlineLevelRow: t.outlineLevelRow,
                                outlineLevelCol: t.outlineLevelCol,
                                "x14ac:dyDescent": t.dyDescent
                            };
                            t.defaultColWidth && (r.defaultColWidth = t.defaultColWidth), t.defaultRowHeight && 15 === t.defaultRowHeight || (r.customHeight = "1"), n.some(r, (e)=>void 0 !== e) && e.leafNode("sheetFormatPr", r);
                        }
                    }
                    parseOpen(e) {
                        return "sheetFormatPr" === e.name && (this.model = {
                            defaultRowHeight: parseFloat(e.attributes.defaultRowHeight || "0"),
                            dyDescent: parseFloat(e.attributes["x14ac:dyDescent"] || "0"),
                            outlineLevelRow: parseInt(e.attributes.outlineLevelRow || "0", 10),
                            outlineLevelCol: parseInt(e.attributes.outlineLevelCol || "0", 10)
                        }, e.attributes.defaultColWidth && (this.model.defaultColWidth = parseFloat(e.attributes.defaultColWidth)), !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        111: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../style/color-xform"), s = e("./page-setup-properties-xform"), o = e("./outline-properties-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            tabColor: new i("tabColor"),
                            pageSetUpPr: new s,
                            outlinePr: new o
                        };
                    }
                    get tag() {
                        return "sheetPr";
                    }
                    render(e, t) {
                        if (t) {
                            e.addRollback(), e.openNode("sheetPr");
                            let r = !1;
                            r = this.map.tabColor.render(e, t.tabColor) || r, r = this.map.pageSetUpPr.render(e, t.pageSetup) || r, r = this.map.outlinePr.render(e, t.outlineProperties) || r, r ? (e.closeNode(), e.commit()) : e.rollback();
                        }
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : e.name === this.tag ? (this.reset(), !0) : !!this.map[e.name] && (this.parser = this.map[e.name], this.parser.parseOpen(e), !0);
                    }
                    parseText(e) {
                        return !!this.parser && (this.parser.parseText(e), !0);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (this.map.tabColor.model || this.map.pageSetUpPr.model || this.map.outlinePr.model ? (this.model = {}, this.map.tabColor.model && (this.model.tabColor = this.map.tabColor.model), this.map.pageSetUpPr.model && (this.model.pageSetup = this.map.pageSetUpPr.model), this.map.outlinePr.model && (this.model.outlineProperties = this.map.outlinePr.model)) : this.model = null, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "../style/color-xform": 128,
                "./outline-properties-xform": 101,
                "./page-setup-properties-xform": 104
            }
        ],
        112: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../base-xform");
                function s(e, t) {
                    return e ? t : void 0;
                }
                function o(e, t) {
                    return e === t || void 0;
                }
                t.exports = class extends i {
                    get tag() {
                        return "sheetProtection";
                    }
                    render(e, t) {
                        if (t) {
                            const r = {
                                sheet: s(t.sheet, "1"),
                                selectLockedCells: !1 === t.selectLockedCells ? "1" : void 0,
                                selectUnlockedCells: !1 === t.selectUnlockedCells ? "1" : void 0,
                                formatCells: s(t.formatCells, "0"),
                                formatColumns: s(t.formatColumns, "0"),
                                formatRows: s(t.formatRows, "0"),
                                insertColumns: s(t.insertColumns, "0"),
                                insertRows: s(t.insertRows, "0"),
                                insertHyperlinks: s(t.insertHyperlinks, "0"),
                                deleteColumns: s(t.deleteColumns, "0"),
                                deleteRows: s(t.deleteRows, "0"),
                                sort: s(t.sort, "0"),
                                autoFilter: s(t.autoFilter, "0"),
                                pivotTables: s(t.pivotTables, "0")
                            };
                            t.sheet && (r.algorithmName = t.algorithmName, r.hashValue = t.hashValue, r.saltValue = t.saltValue, r.spinCount = t.spinCount, r.objects = s(!1 === t.objects, "1"), r.scenarios = s(!1 === t.scenarios, "1")), n.some(r, (e)=>void 0 !== e) && e.leafNode(this.tag, r);
                        }
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    sheet: o(e.attributes.sheet, "1"),
                                    objects: "1" !== e.attributes.objects && void 0,
                                    scenarios: "1" !== e.attributes.scenarios && void 0,
                                    selectLockedCells: "1" !== e.attributes.selectLockedCells && void 0,
                                    selectUnlockedCells: "1" !== e.attributes.selectUnlockedCells && void 0,
                                    formatCells: o(e.attributes.formatCells, "0"),
                                    formatColumns: o(e.attributes.formatColumns, "0"),
                                    formatRows: o(e.attributes.formatRows, "0"),
                                    insertColumns: o(e.attributes.insertColumns, "0"),
                                    insertRows: o(e.attributes.insertRows, "0"),
                                    insertHyperlinks: o(e.attributes.insertHyperlinks, "0"),
                                    deleteColumns: o(e.attributes.deleteColumns, "0"),
                                    deleteRows: o(e.attributes.deleteRows, "0"),
                                    sort: o(e.attributes.sort, "0"),
                                    autoFilter: o(e.attributes.autoFilter, "0"),
                                    pivotTables: o(e.attributes.pivotTables, "0")
                                }, e.attributes.algorithmName && (this.model.algorithmName = e.attributes.algorithmName, this.model.hashValue = e.attributes.hashValue, this.model.saltValue = e.attributes.saltValue, this.model.spinCount = parseInt(e.attributes.spinCount, 10)), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32
            }
        ],
        113: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/col-cache"), i = e("../base-xform"), s = {
                    frozen: "frozen",
                    frozenSplit: "frozen",
                    split: "split"
                };
                t.exports = class extends i {
                    get tag() {
                        return "sheetView";
                    }
                    prepare(e) {
                        switch(e.state){
                            case "frozen":
                            case "split":
                                break;
                            default:
                                e.state = "normal";
                        }
                    }
                    render(e, t) {
                        e.openNode("sheetView", {
                            workbookViewId: t.workbookViewId || 0
                        });
                        const r = function(t, r, n) {
                            n && e.addAttribute(t, r);
                        };
                        let i, s, o, a;
                        switch(r("rightToLeft", "1", !0 === t.rightToLeft), r("tabSelected", "1", t.tabSelected), r("showRuler", "0", !1 === t.showRuler), r("showRowColHeaders", "0", !1 === t.showRowColHeaders), r("showGridLines", "0", !1 === t.showGridLines), r("zoomScale", t.zoomScale, t.zoomScale), r("zoomScaleNormal", t.zoomScaleNormal, t.zoomScaleNormal), r("view", t.style, t.style), t.state){
                            case "frozen":
                                s = t.xSplit || 0, o = t.ySplit || 0, i = t.topLeftCell || n.getAddress(o + 1, s + 1).address, a = (t.xSplit && t.ySplit ? "bottomRight" : t.xSplit && "topRight") || "bottomLeft", e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: i,
                                    activePane: a,
                                    state: "frozen"
                                }), e.leafNode("selection", {
                                    pane: a,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "split":
                                "topLeft" === t.activePane && (t.activePane = void 0), e.leafNode("pane", {
                                    xSplit: t.xSplit || void 0,
                                    ySplit: t.ySplit || void 0,
                                    topLeftCell: t.topLeftCell,
                                    activePane: t.activePane
                                }), e.leafNode("selection", {
                                    pane: t.activePane,
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                                break;
                            case "normal":
                                t.activeCell && e.leafNode("selection", {
                                    activeCell: t.activeCell,
                                    sqref: t.activeCell
                                });
                        }
                        e.closeNode();
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "sheetView":
                                return this.sheetView = {
                                    workbookViewId: parseInt(e.attributes.workbookViewId, 10),
                                    rightToLeft: "1" === e.attributes.rightToLeft,
                                    tabSelected: "1" === e.attributes.tabSelected,
                                    showRuler: !("0" === e.attributes.showRuler),
                                    showRowColHeaders: !("0" === e.attributes.showRowColHeaders),
                                    showGridLines: !("0" === e.attributes.showGridLines),
                                    zoomScale: parseInt(e.attributes.zoomScale || "100", 10),
                                    zoomScaleNormal: parseInt(e.attributes.zoomScaleNormal || "100", 10),
                                    style: e.attributes.view
                                }, this.pane = void 0, this.selections = {}, !0;
                            case "pane":
                                return this.pane = {
                                    xSplit: parseInt(e.attributes.xSplit || "0", 10),
                                    ySplit: parseInt(e.attributes.ySplit || "0", 10),
                                    topLeftCell: e.attributes.topLeftCell,
                                    activePane: e.attributes.activePane || "topLeft",
                                    state: e.attributes.state
                                }, !0;
                            case "selection":
                                {
                                    const t = e.attributes.pane || "topLeft";
                                    return this.selections[t] = {
                                        pane: t,
                                        activeCell: e.attributes.activeCell
                                    }, !0;
                                }
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        let t, r;
                        switch(e){
                            case "sheetView":
                                return this.sheetView && this.pane ? (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: s[this.pane.state] || "split",
                                    xSplit: this.pane.xSplit,
                                    ySplit: this.pane.ySplit,
                                    topLeftCell: this.pane.topLeftCell,
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, "split" === this.model.state && (t.activePane = this.pane.activePane), r = this.selections[this.pane.activePane], r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)) : (t = this.model = {
                                    workbookViewId: this.sheetView.workbookViewId,
                                    rightToLeft: this.sheetView.rightToLeft,
                                    state: "normal",
                                    showRuler: this.sheetView.showRuler,
                                    showRowColHeaders: this.sheetView.showRowColHeaders,
                                    showGridLines: this.sheetView.showGridLines,
                                    zoomScale: this.sheetView.zoomScale,
                                    zoomScaleNormal: this.sheetView.zoomScaleNormal
                                }, r = this.selections.topLeft, r && r.activeCell && (t.activeCell = r.activeCell), this.sheetView.style && (t.style = this.sheetView.style)), !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile() {}
                };
            },
            {
                "../../../utils/col-cache": 19,
                "../base-xform": 32
            }
        ],
        114: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tablePart";
                    }
                    render(e, t) {
                        t && e.leafNode(this.tag, {
                            "r:id": t.rId
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    rId: e.attributes["r:id"]
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        115: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../../utils/col-cache"), s = e("../../../utils/xml-stream"), o = e("../../rel-type"), a = e("./merges"), l = e("../base-xform"), c = e("../list-xform"), u = e("./row-xform"), h = e("./col-xform"), f = e("./dimension-xform"), d = e("./hyperlink-xform"), p = e("./merge-cell-xform"), m = e("./data-validations-xform"), b = e("./sheet-properties-xform"), g = e("./sheet-format-properties-xform"), y = e("./sheet-view-xform"), v = e("./sheet-protection-xform"), w = e("./page-margins-xform"), _ = e("./page-setup-xform"), x = e("./print-options-xform"), k = e("./auto-filter-xform"), S = e("./picture-xform"), M = e("./drawing-xform"), C = e("./table-part-xform"), T = e("./row-breaks-xform"), E = e("./header-footer-xform"), A = e("./cf/conditional-formattings-xform"), R = e("./ext-lst-xform"), O = (e, t)=>{
                    if (!t || !t.length) return e;
                    if (!e || !e.length) return t;
                    const r = {}, n = {};
                    return e.forEach((e)=>{
                        r[e.ref] = e, e.rules.forEach((e)=>{
                            const { x14Id: t } = e;
                            t && (n[t] = e);
                        });
                    }), t.forEach((t)=>{
                        t.rules.forEach((i)=>{
                            const s = n[i.x14Id];
                            s ? ((e, t)=>{
                                Object.keys(t).forEach((r)=>{
                                    const n = e[r], i = t[r];
                                    void 0 === n && void 0 !== i && (e[r] = i);
                                });
                            })(s, i) : r[t.ref] ? r[t.ref].rules.push(i) : e.push({
                                ref: t.ref,
                                rules: [
                                    i
                                ]
                            });
                        });
                    }), e;
                };
                class j extends l {
                    constructor(e){
                        super();
                        const { maxRows: t, maxCols: r, ignoreNodes: n } = e || {};
                        this.ignoreNodes = n || [], this.map = {
                            sheetPr: new b,
                            dimension: new f,
                            sheetViews: new c({
                                tag: "sheetViews",
                                count: !1,
                                childXform: new y
                            }),
                            sheetFormatPr: new g,
                            cols: new c({
                                tag: "cols",
                                count: !1,
                                childXform: new h
                            }),
                            sheetData: new c({
                                tag: "sheetData",
                                count: !1,
                                empty: !0,
                                childXform: new u({
                                    maxItems: r
                                }),
                                maxItems: t
                            }),
                            autoFilter: new k,
                            mergeCells: new c({
                                tag: "mergeCells",
                                count: !0,
                                childXform: new p
                            }),
                            rowBreaks: new T,
                            hyperlinks: new c({
                                tag: "hyperlinks",
                                count: !1,
                                childXform: new d
                            }),
                            pageMargins: new w,
                            dataValidations: new m,
                            pageSetup: new _,
                            headerFooter: new E,
                            printOptions: new x,
                            picture: new S,
                            drawing: new M,
                            sheetProtection: new v,
                            tableParts: new c({
                                tag: "tableParts",
                                count: !0,
                                childXform: new C
                            }),
                            conditionalFormatting: new A,
                            extLst: new R
                        };
                    }
                    prepare(e, t) {
                        t.merges = new a, e.hyperlinks = t.hyperlinks = [], e.comments = t.comments = [], t.formulae = {}, t.siFormulae = 0, this.map.cols.prepare(e.cols, t), this.map.sheetData.prepare(e.rows, t), this.map.conditionalFormatting.prepare(e.conditionalFormattings, t), e.mergeCells = t.merges.mergeCells;
                        const r = e.rels = [];
                        function n(e) {
                            return "rId" + (e.length + 1);
                        }
                        if (e.hyperlinks.forEach((e)=>{
                            const t = n(r);
                            e.rId = t, r.push({
                                Id: t,
                                Type: o.Hyperlink,
                                Target: e.target,
                                TargetMode: "External"
                            });
                        }), e.comments.length > 0) {
                            const s = {
                                Id: n(r),
                                Type: o.Comments,
                                Target: `../comments${e.id}.xml`
                            };
                            r.push(s);
                            const a = {
                                Id: n(r),
                                Type: o.VmlDrawing,
                                Target: `../drawings/vmlDrawing${e.id}.vml`
                            };
                            r.push(a), e.comments.forEach((e)=>{
                                e.refAddress = i.decodeAddress(e.ref);
                            }), t.commentRefs.push({
                                commentName: "comments" + e.id,
                                vmlDrawing: "vmlDrawing" + e.id
                            });
                        }
                        const s = [];
                        let l;
                        e.media.forEach((i)=>{
                            if ("background" === i.type) {
                                const s = n(r);
                                l = t.media[i.imageId], r.push({
                                    Id: s,
                                    Type: o.Image,
                                    Target: `../media/${l.name}.${l.extension}`
                                }), e.background = {
                                    rId: s
                                }, e.image = t.media[i.imageId];
                            } else if ("image" === i.type) {
                                let { drawing: a } = e;
                                l = t.media[i.imageId], a || (a = e.drawing = {
                                    rId: n(r),
                                    name: "drawing" + ++t.drawingsCount,
                                    anchors: [],
                                    rels: []
                                }, t.drawings.push(a), r.push({
                                    Id: a.rId,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
                                    Target: `../drawings/${a.name}.xml`
                                }));
                                let c = this.preImageId === i.imageId ? s[i.imageId] : s[a.rels.length];
                                c || (c = n(a.rels), s[a.rels.length] = c, a.rels.push({
                                    Id: c,
                                    Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                                    Target: `../media/${l.name}.${l.extension}`
                                }));
                                const u = {
                                    picture: {
                                        rId: c
                                    },
                                    range: i.range
                                };
                                if (i.hyperlinks && i.hyperlinks.hyperlink) {
                                    const e = n(a.rels);
                                    s[a.rels.length] = e, u.picture.hyperlinks = {
                                        tooltip: i.hyperlinks.tooltip,
                                        rId: e
                                    }, a.rels.push({
                                        Id: e,
                                        Type: o.Hyperlink,
                                        Target: i.hyperlinks.hyperlink,
                                        TargetMode: "External"
                                    });
                                }
                                this.preImageId = i.imageId, a.anchors.push(u);
                            }
                        }), e.tables.forEach((e)=>{
                            const i = n(r);
                            e.rId = i, r.push({
                                Id: i,
                                Type: o.Table,
                                Target: "../tables/" + e.target
                            }), e.columns.forEach((e)=>{
                                const { style: r } = e;
                                r && (e.dxfId = t.styles.addDxfStyle(r));
                            });
                        }), this.map.extLst.prepare(e, t);
                    }
                    render(e, t) {
                        e.openXml(s.StdDocAttributes), e.openNode("worksheet", j.WORKSHEET_ATTRIBUTES);
                        const r = t.properties ? {
                            defaultRowHeight: t.properties.defaultRowHeight,
                            dyDescent: t.properties.dyDescent,
                            outlineLevelCol: t.properties.outlineLevelCol,
                            outlineLevelRow: t.properties.outlineLevelRow
                        } : void 0;
                        t.properties && t.properties.defaultColWidth && (r.defaultColWidth = t.properties.defaultColWidth);
                        const n = {
                            outlineProperties: t.properties && t.properties.outlineProperties,
                            tabColor: t.properties && t.properties.tabColor,
                            pageSetup: t.pageSetup && t.pageSetup.fitToPage ? {
                                fitToPage: t.pageSetup.fitToPage
                            } : void 0
                        }, i = t.pageSetup && t.pageSetup.margins, a = {
                            showRowColHeaders: t.pageSetup && t.pageSetup.showRowColHeaders,
                            showGridLines: t.pageSetup && t.pageSetup.showGridLines,
                            horizontalCentered: t.pageSetup && t.pageSetup.horizontalCentered,
                            verticalCentered: t.pageSetup && t.pageSetup.verticalCentered
                        }, l = t.sheetProtection;
                        this.map.sheetPr.render(e, n), this.map.dimension.render(e, t.dimensions), this.map.sheetViews.render(e, t.views), this.map.sheetFormatPr.render(e, r), this.map.cols.render(e, t.cols), this.map.sheetData.render(e, t.rows), this.map.sheetProtection.render(e, l), this.map.autoFilter.render(e, t.autoFilter), this.map.mergeCells.render(e, t.mergeCells), this.map.conditionalFormatting.render(e, t.conditionalFormattings), this.map.dataValidations.render(e, t.dataValidations), this.map.hyperlinks.render(e, t.hyperlinks), this.map.printOptions.render(e, a), this.map.pageMargins.render(e, i), this.map.pageSetup.render(e, t.pageSetup), this.map.headerFooter.render(e, t.headerFooter), this.map.rowBreaks.render(e, t.rowBreaks), this.map.drawing.render(e, t.drawing), this.map.picture.render(e, t.background), this.map.tableParts.render(e, t.tables), this.map.extLst.render(e, t), t.rels && t.rels.forEach((t)=>{
                            t.Type === o.VmlDrawing && e.leafNode("legacyDrawing", {
                                "r:id": t.Id
                            });
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        return this.parser ? (this.parser.parseOpen(e), !0) : "worksheet" === e.name ? (n.each(this.map, (e)=>{
                            e.reset();
                        }), !0) : (this.map[e.name] && !this.ignoreNodes.includes(e.name) && (this.parser = this.map[e.name], this.parser.parseOpen(e)), !0);
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "worksheet":
                                {
                                    const e = this.map.sheetFormatPr.model || {};
                                    this.map.sheetPr.model && this.map.sheetPr.model.tabColor && (e.tabColor = this.map.sheetPr.model.tabColor), this.map.sheetPr.model && this.map.sheetPr.model.outlineProperties && (e.outlineProperties = this.map.sheetPr.model.outlineProperties);
                                    const t = {
                                        fitToPage: this.map.sheetPr.model && this.map.sheetPr.model.pageSetup && this.map.sheetPr.model.pageSetup.fitToPage || !1,
                                        margins: this.map.pageMargins.model
                                    }, r = Object.assign(t, this.map.pageSetup.model, this.map.printOptions.model), n = O(this.map.conditionalFormatting.model, this.map.extLst.model && this.map.extLst.model["x14:conditionalFormattings"]);
                                    return this.model = {
                                        dimensions: this.map.dimension.model,
                                        cols: this.map.cols.model,
                                        rows: this.map.sheetData.model,
                                        mergeCells: this.map.mergeCells.model,
                                        hyperlinks: this.map.hyperlinks.model,
                                        dataValidations: this.map.dataValidations.model,
                                        properties: e,
                                        views: this.map.sheetViews.model,
                                        pageSetup: r,
                                        headerFooter: this.map.headerFooter.model,
                                        background: this.map.picture.model,
                                        drawing: this.map.drawing.model,
                                        tables: this.map.tableParts.model,
                                        conditionalFormattings: n
                                    }, this.map.autoFilter.model && (this.model.autoFilter = this.map.autoFilter.model), this.map.sheetProtection.model && (this.model.sheetProtection = this.map.sheetProtection.model), !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        const r = (e.relationships || []).reduce((r, n)=>{
                            if (r[n.Id] = n, n.Type === o.Comments && (e.comments = t.comments[n.Target].comments), n.Type === o.VmlDrawing && e.comments && e.comments.length) {
                                const r = t.vmlDrawings[n.Target].comments;
                                e.comments.forEach((e, t)=>{
                                    e.note = Object.assign({}, e.note, r[t]);
                                });
                            }
                            return r;
                        }, {});
                        if (t.commentsMap = (e.comments || []).reduce((e, t)=>(t.ref && (e[t.ref] = t), e), {}), t.hyperlinkMap = (e.hyperlinks || []).reduce((e, t)=>(t.rId && (e[t.address] = r[t.rId].Target), e), {}), t.formulae = {}, e.rows = e.rows && e.rows.filter(Boolean) || [], e.rows.forEach((e)=>{
                            e.cells = e.cells && e.cells.filter(Boolean) || [];
                        }), this.map.cols.reconcile(e.cols, t), this.map.sheetData.reconcile(e.rows, t), this.map.conditionalFormatting.reconcile(e.conditionalFormattings, t), e.media = [], e.drawing) {
                            const n = r[e.drawing.rId].Target.match(/\/drawings\/([a-zA-Z0-9]+)[.][a-zA-Z]{3,4}$/);
                            if (n) {
                                const r = n[1];
                                t.drawings[r].anchors.forEach((t)=>{
                                    if (t.medium) {
                                        const r = {
                                            type: "image",
                                            imageId: t.medium.index,
                                            range: t.range,
                                            hyperlinks: t.picture.hyperlinks
                                        };
                                        e.media.push(r);
                                    }
                                });
                            }
                        }
                        const n = e.background && r[e.background.rId];
                        if (n) {
                            const r = n.Target.split("/media/")[1], i = t.mediaIndex && t.mediaIndex[r];
                            void 0 !== i && e.media.push({
                                type: "background",
                                imageId: i
                            });
                        }
                        e.tables = (e.tables || []).map((e)=>{
                            const n = r[e.rId];
                            return t.tables[n.Target];
                        }), delete e.relationships, delete e.hyperlinks, delete e.comments;
                    }
                }
                j.WORKSHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac"
                }, t.exports = j;
            },
            {
                "../../../utils/col-cache": 19,
                "../../../utils/under-dash": 26,
                "../../../utils/xml-stream": 28,
                "../../rel-type": 31,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 72,
                "./cf/conditional-formattings-xform": 87,
                "./col-xform": 92,
                "./data-validations-xform": 93,
                "./dimension-xform": 94,
                "./drawing-xform": 95,
                "./ext-lst-xform": 96,
                "./header-footer-xform": 97,
                "./hyperlink-xform": 98,
                "./merge-cell-xform": 99,
                "./merges": 100,
                "./page-margins-xform": 103,
                "./page-setup-xform": 105,
                "./picture-xform": 106,
                "./print-options-xform": 107,
                "./row-breaks-xform": 108,
                "./row-xform": 109,
                "./sheet-format-properties-xform": 110,
                "./sheet-properties-xform": 111,
                "./sheet-protection-xform": 112,
                "./sheet-view-xform": 113,
                "./table-part-xform": 114
            }
        ],
        116: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr;
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.model = !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        117: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this._format = e.format || function(e) {
                            try {
                                return Number.isNaN(e.getTime()) ? "" : e.toISOString();
                            } catch (e) {
                                return "";
                            }
                        }, this._parse = e.parse || function(e) {
                            return new Date(e);
                        };
                    }
                    render(e, t) {
                        t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, this._format(t)) : e.writeText(this._format(t)), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = this._parse(e.attributes[this.attr]) : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this._parse(this.text.join(""))), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        118: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs, this.zero = e.zero;
                    }
                    render(e, t) {
                        (t || this.zero) && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.attr ? this.model = parseInt(e.attributes[this.attr], 10) : this.text = [], !0);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = parseInt(this.text.join("") || 0, 10)), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        119: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.tag = e.tag, this.attr = e.attr, this.attrs = e.attrs;
                    }
                    render(e, t) {
                        void 0 !== t && (e.openNode(this.tag), this.attrs && e.addAttributes(this.attrs), this.attr ? e.addAttribute(this.attr, t) : e.writeText(t), e.closeNode());
                    }
                    parseOpen(e) {
                        e.name === this.tag && (this.attr ? this.model = e.attributes[this.attr] : this.text = []);
                    }
                    parseText(e) {
                        this.attr || this.text.push(e);
                    }
                    parseClose() {
                        return this.attr || (this.model = this.text.join("")), !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        120: [
            function(e, t, r) {
                "use strict";
                const n = e("./base-xform"), i = e("../../utils/xml-stream");
                t.exports = class extends n {
                    constructor(e){
                        super(), this._model = e;
                    }
                    render(e) {
                        if (!this._xml) {
                            const e = new i;
                            !function e(t, r) {
                                t.openNode(r.tag, r.$), r.c && r.c.forEach((r)=>{
                                    e(t, r);
                                }), r.t && t.writeText(r.t), t.closeNode();
                            }(e, this._model), this._xml = e.xml;
                        }
                        e.writeXml(this._xml);
                    }
                    parseOpen() {
                        return !0;
                    }
                    parseText() {}
                    parseClose(e) {
                        switch(e){
                            case this._model.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../../utils/xml-stream": 28,
                "./base-xform": 32
            }
        ],
        121: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("../base-xform");
                t.exports = class extends s {
                    constructor(){
                        super(), this.map = {
                            r: new i,
                            t: new n
                        };
                    }
                    get tag() {
                        return "rPh";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag, {
                            sb: t.sb || 0,
                            eb: t.eb || 0
                        }), t && t.hasOwnProperty("richText") && t.richText) {
                            const { r: r } = this.map;
                            t.richText.forEach((t)=>{
                                r.render(e, t);
                            });
                        } else t && this.map.t.render(e, t.text);
                        e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {
                            sb: parseInt(e.attributes.sb, 10),
                            eb: parseInt(e.attributes.eb, 10)
                        }, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model.text = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        122: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("../style/font-xform"), s = e("../base-xform");
                class o extends s {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "r";
                    }
                    get textXform() {
                        return this._textXform || (this._textXform = new n);
                    }
                    get fontXform() {
                        return this._fontXform || (this._fontXform = new i(o.FONT_OPTIONS));
                    }
                    render(e, t) {
                        t = t || this.model, e.openNode("r"), t.font && this.fontXform.render(e, t.font), this.textXform.render(e, t.text), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "r":
                                return this.model = {}, !0;
                            case "t":
                                return this.parser = this.textXform, this.parser.parseOpen(e), !0;
                            case "rPr":
                                return this.parser = this.fontXform, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        switch(e){
                            case "r":
                                return !1;
                            case "t":
                                return this.model.text = this.parser.model, this.parser = void 0, !0;
                            case "rPr":
                                return this.model.font = this.parser.model, this.parser = void 0, !0;
                            default:
                                return this.parser && this.parser.parseClose(e), !0;
                        }
                    }
                }
                o.FONT_OPTIONS = {
                    tagName: "rPr",
                    fontNameTag: "rFont"
                }, t.exports = o;
            },
            {
                "../base-xform": 32,
                "../style/font-xform": 131,
                "./text-xform": 125
            }
        ],
        123: [
            function(e, t, r) {
                "use strict";
                const n = e("./text-xform"), i = e("./rich-text-xform"), s = e("./phonetic-text-xform"), o = e("../base-xform");
                t.exports = class extends o {
                    constructor(e){
                        super(), this.model = e, this.map = {
                            r: new i,
                            t: new n,
                            rPh: new s
                        };
                    }
                    get tag() {
                        return "si";
                    }
                    render(e, t) {
                        e.openNode(this.tag), t && t.hasOwnProperty("richText") && t.richText ? t.richText.length ? t.richText.forEach((t)=>{
                            this.map.r.render(e, t);
                        }) : this.map.t.render(e, "") : null != t && this.map.t.render(e, t), e.closeNode();
                    }
                    parseOpen(e) {
                        const { name: t } = e;
                        return this.parser ? (this.parser.parseOpen(e), !0) : t === this.tag ? (this.model = {}, !0) : (this.parser = this.map[t], !!this.parser && (this.parser.parseOpen(e), !0));
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) {
                            if (!this.parser.parseClose(e)) {
                                switch(e){
                                    case "r":
                                        {
                                            let e = this.model.richText;
                                            e || (e = this.model.richText = []), e.push(this.parser.model);
                                            break;
                                        }
                                    case "t":
                                        this.model = this.parser.model;
                                }
                                this.parser = void 0;
                            }
                            return !0;
                        }
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./phonetic-text-xform": 121,
                "./rich-text-xform": 122,
                "./text-xform": 125
            }
        ],
        124: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("./shared-string-xform");
                t.exports = class extends i {
                    constructor(e){
                        super(), this.model = e || {
                            values: [],
                            count: 0
                        }, this.hash = Object.create(null), this.rich = Object.create(null);
                    }
                    get sharedStringXform() {
                        return this._sharedStringXform || (this._sharedStringXform = new s);
                    }
                    get values() {
                        return this.model.values;
                    }
                    get uniqueCount() {
                        return this.model.values.length;
                    }
                    get count() {
                        return this.model.count;
                    }
                    getString(e) {
                        return this.model.values[e];
                    }
                    add(e) {
                        return e.richText ? this.addRichText(e) : this.addText(e);
                    }
                    addText(e) {
                        let t = this.hash[e];
                        return void 0 === t && (t = this.hash[e] = this.model.values.length, this.model.values.push(e)), this.model.count++, t;
                    }
                    addRichText(e) {
                        const t = this.sharedStringXform.toXml(e);
                        let r = this.rich[t];
                        return void 0 === r && (r = this.rich[t] = this.model.values.length, this.model.values.push(e)), this.model.count++, r;
                    }
                    render(e, t) {
                        t = t || this._values, e.openXml(n.StdDocAttributes), e.openNode("sst", {
                            xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                            count: t.count,
                            uniqueCount: t.values.length
                        });
                        const r = this.sharedStringXform;
                        t.values.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "sst":
                                return !0;
                            case "si":
                                return this.parser = this.sharedStringXform, this.parser.parseOpen(e), !0;
                            default:
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.values.push(this.parser.model), this.model.count++, this.parser = void 0), !0;
                        switch(e){
                            case "sst":
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "./shared-string-xform": 123
            }
        ],
        125: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "t";
                    }
                    render(e, t) {
                        e.openNode("t"), /^\s|\n|\s$/.test(t) && e.addAttribute("xml:space", "preserve"), e.writeText(t), e.closeNode();
                    }
                    get model() {
                        return this._text.join("").replace(/_x([0-9A-F]{4})_/g, (e, t)=>String.fromCharCode(parseInt(t, 16)));
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "t":
                                return this._text = [], !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this._text.push(e);
                    }
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        126: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/utils"), s = e("../base-xform"), o = {
                    horizontalValues: [
                        "left",
                        "center",
                        "right",
                        "fill",
                        "centerContinuous",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    horizontal (e) {
                        return this.horizontalValues[e] ? e : void 0;
                    },
                    verticalValues: [
                        "top",
                        "middle",
                        "bottom",
                        "distributed",
                        "justify"
                    ].reduce((e, t)=>(e[t] = !0, e), {}),
                    vertical (e) {
                        return "middle" === e ? "center" : this.verticalValues[e] ? e : void 0;
                    },
                    wrapText: (e)=>!!e || void 0,
                    shrinkToFit: (e)=>!!e || void 0,
                    textRotation (e) {
                        switch(e){
                            case "vertical":
                                return e;
                            default:
                                return (e = i.validInt(e)) >= -90 && e <= 90 ? e : void 0;
                        }
                    },
                    indent: (e)=>(e = i.validInt(e), Math.max(0, e)),
                    readingOrder (e) {
                        switch(e){
                            case "ltr":
                                return n.ReadingOrder.LeftToRight;
                            case "rtl":
                                return n.ReadingOrder.RightToLeft;
                            default:
                                return;
                        }
                    }
                }, a = {
                    toXml (e) {
                        if (e = o.textRotation(e)) {
                            if ("vertical" === e) return 255;
                            const t = Math.round(e);
                            if (t >= 0 && t <= 90) return t;
                            if (t < 0 && t >= -90) return 90 - t;
                        }
                    },
                    toModel (e) {
                        const t = i.validInt(e);
                        if (void 0 !== t) {
                            if (255 === t) return "vertical";
                            if (t >= 0 && t <= 90) return t;
                            if (t > 90 && t <= 180) return 90 - t;
                        }
                    }
                };
                t.exports = class extends s {
                    get tag() {
                        return "alignment";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("alignment");
                        let r = !1;
                        function n(t, n) {
                            n && (e.addAttribute(t, n), r = !0);
                        }
                        n("horizontal", o.horizontal(t.horizontal)), n("vertical", o.vertical(t.vertical)), n("wrapText", !!o.wrapText(t.wrapText) && "1"), n("shrinkToFit", !!o.shrinkToFit(t.shrinkToFit) && "1"), n("indent", o.indent(t.indent)), n("textRotation", a.toXml(t.textRotation)), n("readingOrder", o.readingOrder(t.readingOrder)), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {};
                        let r = !1;
                        function n(e, n, i) {
                            e && (t[n] = i, r = !0);
                        }
                        n(e.attributes.horizontal, "horizontal", e.attributes.horizontal), n(e.attributes.vertical, "vertical", "center" === e.attributes.vertical ? "middle" : e.attributes.vertical), n(e.attributes.wrapText, "wrapText", i.parseBoolean(e.attributes.wrapText)), n(e.attributes.shrinkToFit, "shrinkToFit", i.parseBoolean(e.attributes.shrinkToFit)), n(e.attributes.indent, "indent", parseInt(e.attributes.indent, 10)), n(e.attributes.textRotation, "textRotation", a.toModel(e.attributes.textRotation)), n(e.attributes.readingOrder, "readingOrder", "2" === e.attributes.readingOrder ? "rtl" : "ltr"), this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/utils": 27,
                "../base-xform": 32
            }
        ],
        127: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../../../utils/utils"), s = e("./color-xform");
                class o extends n {
                    constructor(e){
                        super(), this.name = e, this.map = {
                            color: new s
                        };
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t, r) {
                        const n = t && t.color || r || this.defaultColor;
                        e.openNode(this.name), t && t.style && (e.addAttribute("style", t.style), n && this.map.color.render(e, n)), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.name:
                                {
                                    const { style: t } = e.attributes;
                                    return this.model = t ? {
                                        style: t
                                    } : void 0, !0;
                                }
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : (e === this.name && this.map.color.model && (this.model || (this.model = {}), this.model.color = this.map.color.model), !1);
                    }
                    validStyle(e) {
                        return o.validStyleValues[e];
                    }
                }
                o.validStyleValues = [
                    "thin",
                    "dashed",
                    "dotted",
                    "dashDot",
                    "hair",
                    "dashDotDot",
                    "slantDashDot",
                    "mediumDashed",
                    "mediumDashDotDot",
                    "mediumDashDot",
                    "medium",
                    "double",
                    "thick"
                ].reduce((e, t)=>(e[t] = !0, e), {});
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            top: new o("top"),
                            left: new o("left"),
                            bottom: new o("bottom"),
                            right: new o("right"),
                            diagonal: new o("diagonal")
                        };
                    }
                    render(e, t) {
                        const { color: r } = t;
                        function n(n, i) {
                            n && !n.color && t.color && (n = {
                                ...n,
                                color: t.color
                            }), i.render(e, n, r);
                        }
                        e.openNode("border"), t.diagonal && t.diagonal.style && (t.diagonal.up && e.addAttribute("diagonalUp", "1"), t.diagonal.down && e.addAttribute("diagonalDown", "1")), n(t.left, this.map.left), n(t.right, this.map.right), n(t.top, this.map.top), n(t.bottom, this.map.bottom), n(t.diagonal, this.map.diagonal), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "border":
                                return this.reset(), this.diagonalUp = i.parseBoolean(e.attributes.diagonalUp), this.diagonalDown = i.parseBoolean(e.attributes.diagonalDown), !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        if ("border" === e) {
                            const e = this.model = {}, t = function(t, r, n) {
                                r && (n && Object.assign(r, n), e[t] = r);
                            };
                            t("left", this.map.left.model), t("right", this.map.right.model), t("top", this.map.top.model), t("bottom", this.map.bottom.model), t("diagonal", this.map.diagonal.model, {
                                up: this.diagonalUp,
                                down: this.diagonalDown
                            });
                        }
                        return !1;
                    }
                };
            },
            {
                "../../../utils/utils": 27,
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        128: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.name = e || "color";
                    }
                    get tag() {
                        return this.name;
                    }
                    render(e, t) {
                        return !!t && (e.openNode(this.name), t.argb ? e.addAttribute("rgb", t.argb) : void 0 !== t.theme ? (e.addAttribute("theme", t.theme), void 0 !== t.tint && e.addAttribute("tint", t.tint)) : void 0 !== t.indexed ? e.addAttribute("indexed", t.indexed) : e.addAttribute("auto", "1"), e.closeNode(), !0);
                    }
                    parseOpen(e) {
                        return e.name === this.name && (e.attributes.rgb ? this.model = {
                            argb: e.attributes.rgb
                        } : e.attributes.theme ? (this.model = {
                            theme: parseInt(e.attributes.theme, 10)
                        }, e.attributes.tint && (this.model.tint = parseFloat(e.attributes.tint))) : e.attributes.indexed ? this.model = {
                            indexed: parseInt(e.attributes.indexed, 10)
                        } : this.model = void 0, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        129: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./border-xform"), o = e("./fill-xform"), a = e("./font-xform"), l = e("./numfmt-xform"), c = e("./protection-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            alignment: new i,
                            border: new s,
                            fill: new o,
                            font: new a,
                            numFmt: new l,
                            protection: new c
                        };
                    }
                    get tag() {
                        return "dxf";
                    }
                    render(e, t) {
                        if (e.openNode(this.tag), t.font && this.map.font.render(e, t.font), t.numFmt && t.numFmtId) {
                            const r = {
                                id: t.numFmtId,
                                formatCode: t.numFmt
                            };
                            this.map.numFmt.render(e, r);
                        }
                        t.fill && this.map.fill.render(e, t.fill), t.alignment && this.map.alignment.render(e, t.alignment), t.border && this.map.border.render(e, t.border), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.reset(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.parser = void 0), !0) : e !== this.tag || (this.model = {
                            alignment: this.map.alignment.model,
                            border: this.map.border.model,
                            fill: this.map.fill.model,
                            font: this.map.font.model,
                            numFmt: this.map.numFmt.model,
                            protection: this.map.protection.model
                        }, !1);
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./border-xform": 127,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./protection-xform": 133
            }
        ],
        130: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./color-xform");
                class s extends n {
                    constructor(){
                        super(), this.map = {
                            color: new i
                        };
                    }
                    get tag() {
                        return "stop";
                    }
                    render(e, t) {
                        e.openNode("stop"), e.addAttribute("position", t.position), this.map.color.render(e, t.color), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "stop":
                                return this.model = {
                                    position: parseFloat(e.attributes.position)
                                }, !0;
                            case "color":
                                return this.parser = this.map.color, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.color = this.parser.model, this.parser = void 0), !0);
                    }
                }
                class o extends n {
                    constructor(){
                        super(), this.map = {
                            fgColor: new i("fgColor"),
                            bgColor: new i("bgColor")
                        };
                    }
                    get name() {
                        return "pattern";
                    }
                    get tag() {
                        return "patternFill";
                    }
                    render(e, t) {
                        e.openNode("patternFill"), e.addAttribute("patternType", t.pattern), t.fgColor && this.map.fgColor.render(e, t.fgColor), t.bgColor && this.map.bgColor.render(e, t.bgColor), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "patternFill":
                                return this.model = {
                                    type: "pattern",
                                    pattern: e.attributes.patternType
                                }, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.parser.model && (this.model[e] = this.parser.model), this.parser = void 0), !0);
                    }
                }
                class a extends n {
                    constructor(){
                        super(), this.map = {
                            stop: new s
                        };
                    }
                    get name() {
                        return "gradient";
                    }
                    get tag() {
                        return "gradientFill";
                    }
                    render(e, t) {
                        switch(e.openNode("gradientFill"), t.gradient){
                            case "angle":
                                e.addAttribute("degree", t.degree);
                                break;
                            case "path":
                                e.addAttribute("type", "path"), t.center.left && (e.addAttribute("left", t.center.left), void 0 === t.center.right && e.addAttribute("right", t.center.left)), t.center.right && e.addAttribute("right", t.center.right), t.center.top && (e.addAttribute("top", t.center.top), void 0 === t.center.bottom && e.addAttribute("bottom", t.center.top)), t.center.bottom && e.addAttribute("bottom", t.center.bottom);
                        }
                        const r = this.map.stop;
                        t.stops.forEach((t)=>{
                            r.render(e, t);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "gradientFill":
                                {
                                    const t = this.model = {
                                        stops: []
                                    };
                                    return e.attributes.degree ? (t.gradient = "angle", t.degree = parseInt(e.attributes.degree, 10)) : "path" === e.attributes.type && (t.gradient = "path", t.center = {
                                        left: e.attributes.left ? parseFloat(e.attributes.left) : 0,
                                        top: e.attributes.top ? parseFloat(e.attributes.top) : 0
                                    }, e.attributes.right !== e.attributes.left && (t.center.right = e.attributes.right ? parseFloat(e.attributes.right) : 0), e.attributes.bottom !== e.attributes.top && (t.center.bottom = e.attributes.bottom ? parseFloat(e.attributes.bottom) : 0)), !0;
                                }
                            case "stop":
                                return this.parser = this.map.stop, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model.stops.push(this.parser.model), this.parser = void 0), !0);
                    }
                }
                class l extends n {
                    constructor(){
                        super(), this.map = {
                            patternFill: new o,
                            gradientFill: new a
                        };
                    }
                    get tag() {
                        return "fill";
                    }
                    render(e, t) {
                        switch(e.addRollback(), e.openNode("fill"), t.type){
                            case "pattern":
                                this.map.patternFill.render(e, t);
                                break;
                            case "gradient":
                                this.map.gradientFill.render(e, t);
                                break;
                            default:
                                return void e.rollback();
                        }
                        e.closeNode(), e.commit();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "fill":
                                return this.model = {}, !0;
                            default:
                                return this.parser = this.map[e.name], !!this.parser && (this.parser.parseOpen(e), !0);
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return !!this.parser && (this.parser.parseClose(e) || (this.model = this.parser.model, this.model.type = this.parser.name, this.parser = void 0), !0);
                    }
                    validStyle(e) {
                        return l.validPatternValues[e];
                    }
                }
                l.validPatternValues = [
                    "none",
                    "solid",
                    "darkVertical",
                    "darkGray",
                    "mediumGray",
                    "lightGray",
                    "gray125",
                    "gray0625",
                    "darkHorizontal",
                    "darkVertical",
                    "darkDown",
                    "darkUp",
                    "darkGrid",
                    "darkTrellis",
                    "lightHorizontal",
                    "lightVertical",
                    "lightDown",
                    "lightUp",
                    "lightGrid",
                    "lightTrellis",
                    "lightGrid"
                ].reduce((e, t)=>(e[t] = !0, e), {}), l.StopXform = s, l.PatternFillXform = o, l.GradientFillXform = a, t.exports = l;
            },
            {
                "../base-xform": 32,
                "./color-xform": 128
            }
        ],
        131: [
            function(e, t, r) {
                "use strict";
                const n = e("./color-xform"), i = e("../simple/boolean-xform"), s = e("../simple/integer-xform"), o = e("../simple/string-xform"), a = e("./underline-xform"), l = e("../../../utils/under-dash"), c = e("../base-xform");
                class u extends c {
                    constructor(e){
                        super(), this.options = e || u.OPTIONS, this.map = {
                            b: {
                                prop: "bold",
                                xform: new i({
                                    tag: "b",
                                    attr: "val"
                                })
                            },
                            i: {
                                prop: "italic",
                                xform: new i({
                                    tag: "i",
                                    attr: "val"
                                })
                            },
                            u: {
                                prop: "underline",
                                xform: new a
                            },
                            charset: {
                                prop: "charset",
                                xform: new s({
                                    tag: "charset",
                                    attr: "val"
                                })
                            },
                            color: {
                                prop: "color",
                                xform: new n
                            },
                            condense: {
                                prop: "condense",
                                xform: new i({
                                    tag: "condense",
                                    attr: "val"
                                })
                            },
                            extend: {
                                prop: "extend",
                                xform: new i({
                                    tag: "extend",
                                    attr: "val"
                                })
                            },
                            family: {
                                prop: "family",
                                xform: new s({
                                    tag: "family",
                                    attr: "val"
                                })
                            },
                            outline: {
                                prop: "outline",
                                xform: new i({
                                    tag: "outline",
                                    attr: "val"
                                })
                            },
                            vertAlign: {
                                prop: "vertAlign",
                                xform: new o({
                                    tag: "vertAlign",
                                    attr: "val"
                                })
                            },
                            scheme: {
                                prop: "scheme",
                                xform: new o({
                                    tag: "scheme",
                                    attr: "val"
                                })
                            },
                            shadow: {
                                prop: "shadow",
                                xform: new i({
                                    tag: "shadow",
                                    attr: "val"
                                })
                            },
                            strike: {
                                prop: "strike",
                                xform: new i({
                                    tag: "strike",
                                    attr: "val"
                                })
                            },
                            sz: {
                                prop: "size",
                                xform: new s({
                                    tag: "sz",
                                    attr: "val"
                                })
                            }
                        }, this.map[this.options.fontNameTag] = {
                            prop: "name",
                            xform: new o({
                                tag: this.options.fontNameTag,
                                attr: "val"
                            })
                        };
                    }
                    get tag() {
                        return this.options.tagName;
                    }
                    render(e, t) {
                        const { map: r } = this;
                        e.openNode(this.options.tagName), l.each(this.map, (n, i)=>{
                            r[i].xform.render(e, t[n.prop]);
                        }), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        if (this.map[e.name]) return this.parser = this.map[e.name].xform, this.parser.parseOpen(e);
                        switch(e.name){
                            case this.options.tagName:
                                return this.model = {}, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser && !this.parser.parseClose(e)) {
                            const t = this.map[e];
                            return this.parser.model && (this.model[t.prop] = this.parser.model), this.parser = void 0, !0;
                        }
                        switch(e){
                            case this.options.tagName:
                                return !1;
                            default:
                                return !0;
                        }
                    }
                }
                u.OPTIONS = {
                    tagName: "font",
                    fontNameTag: "name"
                }, t.exports = u;
            },
            {
                "../../../utils/under-dash": 26,
                "../base-xform": 32,
                "../simple/boolean-xform": 116,
                "../simple/integer-xform": 118,
                "../simple/string-xform": 119,
                "./color-xform": 128,
                "./underline-xform": 136
            }
        ],
        132: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/under-dash"), i = e("../../defaultnumformats"), s = e("../base-xform");
                const o = function() {
                    const e = {};
                    return n.each(i, (t, r)=>{
                        t.f && (e[t.f] = parseInt(r, 10));
                    }), e;
                }();
                class a extends s {
                    constructor(e, t){
                        super(), this.id = e, this.formatCode = t;
                    }
                    get tag() {
                        return "numFmt";
                    }
                    render(e, t) {
                        e.leafNode("numFmt", {
                            numFmtId: t.id,
                            formatCode: t.formatCode
                        });
                    }
                    parseOpen(e) {
                        switch(e.name){
                            case "numFmt":
                                return this.model = {
                                    id: parseInt(e.attributes.numFmtId, 10),
                                    formatCode: e.attributes.formatCode.replace(/[\\](.)/g, "$1")
                                }, !0;
                            default:
                                return !1;
                        }
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                a.getDefaultFmtId = function(e) {
                    return o[e];
                }, a.getDefaultFmtCode = function(e) {
                    return i[e] && i[e].f;
                }, t.exports = a;
            },
            {
                "../../../utils/under-dash": 26,
                "../../defaultnumformats": 30,
                "../base-xform": 32
            }
        ],
        133: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = {
                    boolean: (e, t)=>void 0 === e ? t : e
                };
                t.exports = class extends n {
                    get tag() {
                        return "protection";
                    }
                    render(e, t) {
                        e.addRollback(), e.openNode("protection");
                        let r = !1;
                        function n(t, n) {
                            void 0 !== n && (e.addAttribute(t, n), r = !0);
                        }
                        n("locked", i.boolean(t.locked, !0) ? void 0 : "0"), n("hidden", i.boolean(t.hidden, !1) ? "1" : void 0), e.closeNode(), r ? e.commit() : e.rollback();
                    }
                    parseOpen(e) {
                        const t = {
                            locked: !("0" === e.attributes.locked),
                            hidden: "1" === e.attributes.hidden
                        }, r = !t.locked || t.hidden;
                        this.model = r ? t : null;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        134: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./alignment-xform"), s = e("./protection-xform");
                t.exports = class extends n {
                    constructor(e){
                        super(), this.xfId = !(!e || !e.xfId), this.map = {
                            alignment: new i,
                            protection: new s
                        };
                    }
                    get tag() {
                        return "xf";
                    }
                    render(e, t) {
                        e.openNode("xf", {
                            numFmtId: t.numFmtId || 0,
                            fontId: t.fontId || 0,
                            fillId: t.fillId || 0,
                            borderId: t.borderId || 0
                        }), this.xfId && e.addAttribute("xfId", t.xfId || 0), t.numFmtId && e.addAttribute("applyNumberFormat", "1"), t.fontId && e.addAttribute("applyFont", "1"), t.fillId && e.addAttribute("applyFill", "1"), t.borderId && e.addAttribute("applyBorder", "1"), t.alignment && e.addAttribute("applyAlignment", "1"), t.protection && e.addAttribute("applyProtection", "1"), t.alignment && this.map.alignment.render(e, t.alignment), t.protection && this.map.protection.render(e, t.protection), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "xf":
                                return this.model = {
                                    numFmtId: parseInt(e.attributes.numFmtId, 10),
                                    fontId: parseInt(e.attributes.fontId, 10),
                                    fillId: parseInt(e.attributes.fillId, 10),
                                    borderId: parseInt(e.attributes.borderId, 10)
                                }, this.xfId && (this.model.xfId = parseInt(e.attributes.xfId, 10)), !0;
                            case "alignment":
                                return this.parser = this.map.alignment, this.parser.parseOpen(e), !0;
                            case "protection":
                                return this.parser = this.map.protection, this.parser.parseOpen(e), !0;
                            default:
                                return !1;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        return this.parser ? (this.parser.parseClose(e) || (this.map.protection === this.parser ? this.model.protection = this.parser.model : this.model.alignment = this.parser.model, this.parser = void 0), !0) : "xf" !== e;
                    }
                };
            },
            {
                "../base-xform": 32,
                "./alignment-xform": 126,
                "./protection-xform": 133
            }
        ],
        135: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../doc/enums"), i = e("../../../utils/xml-stream"), s = e("../base-xform"), o = e("../static-xform"), a = e("../list-xform"), l = e("./font-xform"), c = e("./fill-xform"), u = e("./border-xform"), h = e("./numfmt-xform"), f = e("./style-xform"), d = e("./dxf-xform");
                class p extends s {
                    constructor(e){
                        super(), this.map = {
                            numFmts: new a({
                                tag: "numFmts",
                                count: !0,
                                childXform: new h
                            }),
                            fonts: new a({
                                tag: "fonts",
                                count: !0,
                                childXform: new l,
                                $: {
                                    "x14ac:knownFonts": 1
                                }
                            }),
                            fills: new a({
                                tag: "fills",
                                count: !0,
                                childXform: new c
                            }),
                            borders: new a({
                                tag: "borders",
                                count: !0,
                                childXform: new u
                            }),
                            cellStyleXfs: new a({
                                tag: "cellStyleXfs",
                                count: !0,
                                childXform: new f
                            }),
                            cellXfs: new a({
                                tag: "cellXfs",
                                count: !0,
                                childXform: new f({
                                    xfId: !0
                                })
                            }),
                            dxfs: new a({
                                tag: "dxfs",
                                always: !0,
                                count: !0,
                                childXform: new d
                            }),
                            numFmt: new h,
                            font: new l,
                            fill: new c,
                            border: new u,
                            style: new f({
                                xfId: !0
                            }),
                            cellStyles: p.STATIC_XFORMS.cellStyles,
                            tableStyles: p.STATIC_XFORMS.tableStyles,
                            extLst: p.STATIC_XFORMS.extLst
                        }, e && this.init();
                    }
                    initIndex() {
                        this.index = {
                            style: {},
                            numFmt: {},
                            numFmtNextId: 164,
                            font: {},
                            border: {},
                            fill: {}
                        };
                    }
                    init() {
                        this.model = {
                            styles: [],
                            numFmts: [],
                            fonts: [],
                            borders: [],
                            fills: [],
                            dxfs: []
                        }, this.initIndex(), this._addBorder({}), this._addStyle({
                            numFmtId: 0,
                            fontId: 0,
                            fillId: 0,
                            borderId: 0,
                            xfId: 0
                        }), this._addFill({
                            type: "pattern",
                            pattern: "none"
                        }), this._addFill({
                            type: "pattern",
                            pattern: "gray125"
                        }), this.weakMap = new WeakMap;
                    }
                    render(e, t) {
                        t = t || this.model, e.openXml(i.StdDocAttributes), e.openNode("styleSheet", p.STYLESHEET_ATTRIBUTES), this.index ? (t.numFmts && t.numFmts.length && (e.openNode("numFmts", {
                            count: t.numFmts.length
                        }), t.numFmts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()), t.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), e.openNode("fonts", {
                            count: t.fonts.length,
                            "x14ac:knownFonts": 1
                        }), t.fonts.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("fills", {
                            count: t.fills.length
                        }), t.fills.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), e.openNode("borders", {
                            count: t.borders.length
                        }), t.borders.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode(), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), e.openNode("cellXfs", {
                            count: t.styles.length
                        }), t.styles.forEach((t)=>{
                            e.writeXml(t);
                        }), e.closeNode()) : (this.map.numFmts.render(e, t.numFmts), this.map.fonts.render(e, t.fonts), this.map.fills.render(e, t.fills), this.map.borders.render(e, t.borders), this.map.cellStyleXfs.render(e, [
                            {
                                numFmtId: 0,
                                fontId: 0,
                                fillId: 0,
                                borderId: 0,
                                xfId: 0
                            }
                        ]), this.map.cellXfs.render(e, t.styles)), p.STATIC_XFORMS.cellStyles.render(e), this.map.dxfs.render(e, t.dxfs), p.STATIC_XFORMS.tableStyles.render(e), p.STATIC_XFORMS.extLst.render(e), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case "styleSheet":
                                return this.initIndex(), !0;
                            default:
                                return this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e), !0;
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case "styleSheet":
                                {
                                    this.model = {};
                                    const e = (e, t)=>{
                                        t.model && t.model.length && (this.model[e] = t.model);
                                    };
                                    if (e("numFmts", this.map.numFmts), e("fonts", this.map.fonts), e("fills", this.map.fills), e("borders", this.map.borders), e("styles", this.map.cellXfs), e("dxfs", this.map.dxfs), this.index = {
                                        model: [],
                                        numFmt: []
                                    }, this.model.numFmts) {
                                        const e = this.index.numFmt;
                                        this.model.numFmts.forEach((t)=>{
                                            e[t.id] = t.formatCode;
                                        });
                                    }
                                    return !1;
                                }
                            default:
                                return !0;
                        }
                    }
                    addStyleModel(e, t) {
                        if (!e) return 0;
                        if (this.model.fonts.length || this._addFont({
                            size: 11,
                            color: {
                                theme: 1
                            },
                            name: "Calibri",
                            family: 2,
                            scheme: "minor"
                        }), this.weakMap && this.weakMap.has(e)) return this.weakMap.get(e);
                        const r = {};
                        if (t = t || n.ValueType.Number, e.numFmt) r.numFmtId = this._addNumFmtStr(e.numFmt);
                        else switch(t){
                            case n.ValueType.Number:
                                r.numFmtId = this._addNumFmtStr("General");
                                break;
                            case n.ValueType.Date:
                                r.numFmtId = this._addNumFmtStr("mm-dd-yy");
                        }
                        e.font && (r.fontId = this._addFont(e.font)), e.border && (r.borderId = this._addBorder(e.border)), e.fill && (r.fillId = this._addFill(e.fill)), e.alignment && (r.alignment = e.alignment), e.protection && (r.protection = e.protection);
                        const i = this._addStyle(r);
                        return this.weakMap && this.weakMap.set(e, i), i;
                    }
                    getStyleModel(e) {
                        const t = this.model.styles[e];
                        if (!t) return null;
                        let r = this.index.model[e];
                        if (r) return r;
                        if (r = this.index.model[e] = {}, t.numFmtId) {
                            const e = this.index.numFmt[t.numFmtId] || h.getDefaultFmtCode(t.numFmtId);
                            e && (r.numFmt = e);
                        }
                        function n(e, t, n) {
                            if (n || 0 === n) {
                                const i = t[n];
                                i && (r[e] = i);
                            }
                        }
                        return n("font", this.model.fonts, t.fontId), n("border", this.model.borders, t.borderId), n("fill", this.model.fills, t.fillId), t.alignment && (r.alignment = t.alignment), t.protection && (r.protection = t.protection), r;
                    }
                    addDxfStyle(e) {
                        return e.numFmt && (e.numFmtId = this._addNumFmtStr(e.numFmt)), this.model.dxfs.push(e), this.model.dxfs.length - 1;
                    }
                    getDxfStyle(e) {
                        return this.model.dxfs[e];
                    }
                    _addStyle(e) {
                        const t = this.map.style.toXml(e);
                        let r = this.index.style[t];
                        return void 0 === r && (r = this.index.style[t] = this.model.styles.length, this.model.styles.push(t)), r;
                    }
                    _addNumFmtStr(e) {
                        let t = h.getDefaultFmtId(e);
                        if (void 0 !== t) return t;
                        if (t = this.index.numFmt[e], void 0 !== t) return t;
                        t = this.index.numFmt[e] = 164 + this.model.numFmts.length;
                        const r = this.map.numFmt.toXml({
                            id: t,
                            formatCode: e
                        });
                        return this.model.numFmts.push(r), t;
                    }
                    _addFont(e) {
                        const t = this.map.font.toXml(e);
                        let r = this.index.font[t];
                        return void 0 === r && (r = this.index.font[t] = this.model.fonts.length, this.model.fonts.push(t)), r;
                    }
                    _addBorder(e) {
                        const t = this.map.border.toXml(e);
                        let r = this.index.border[t];
                        return void 0 === r && (r = this.index.border[t] = this.model.borders.length, this.model.borders.push(t)), r;
                    }
                    _addFill(e) {
                        const t = this.map.fill.toXml(e);
                        let r = this.index.fill[t];
                        return void 0 === r && (r = this.index.fill[t] = this.model.fills.length, this.model.fills.push(t)), r;
                    }
                }
                p.STYLESHEET_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "x14ac x16r2",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main"
                }, p.STATIC_XFORMS = {
                    cellStyles: new o({
                        tag: "cellStyles",
                        $: {
                            count: 1
                        },
                        c: [
                            {
                                tag: "cellStyle",
                                $: {
                                    name: "Normal",
                                    xfId: 0,
                                    builtinId: 0
                                }
                            }
                        ]
                    }),
                    dxfs: new o({
                        tag: "dxfs",
                        $: {
                            count: 0
                        }
                    }),
                    tableStyles: new o({
                        tag: "tableStyles",
                        $: {
                            count: 0,
                            defaultTableStyle: "TableStyleMedium2",
                            defaultPivotStyle: "PivotStyleLight16"
                        }
                    }),
                    extLst: new o({
                        tag: "extLst",
                        c: [
                            {
                                tag: "ext",
                                $: {
                                    uri: "{EB79DEF2-80B8-43e5-95BD-54CBDDF9020C}",
                                    "xmlns:x14": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/main"
                                },
                                c: [
                                    {
                                        tag: "x14:slicerStyles",
                                        $: {
                                            defaultSlicerStyle: "SlicerStyleLight1"
                                        }
                                    }
                                ]
                            },
                            {
                                tag: "ext",
                                $: {
                                    uri: "{9260A510-F301-46a8-8635-F512D64BE5F5}",
                                    "xmlns:x15": "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main"
                                },
                                c: [
                                    {
                                        tag: "x15:timelineStyles",
                                        $: {
                                            defaultTimelineStyle: "TimeSlicerStyleLight1"
                                        }
                                    }
                                ]
                            }
                        ]
                    })
                };
                p.Mock = class extends p {
                    constructor(){
                        super(), this.model = {
                            styles: [
                                {
                                    numFmtId: 0,
                                    fontId: 0,
                                    fillId: 0,
                                    borderId: 0,
                                    xfId: 0
                                }
                            ],
                            numFmts: [],
                            fonts: [
                                {
                                    size: 11,
                                    color: {
                                        theme: 1
                                    },
                                    name: "Calibri",
                                    family: 2,
                                    scheme: "minor"
                                }
                            ],
                            borders: [
                                {}
                            ],
                            fills: [
                                {
                                    type: "pattern",
                                    pattern: "none"
                                },
                                {
                                    type: "pattern",
                                    pattern: "gray125"
                                }
                            ]
                        };
                    }
                    parseStream(e) {
                        return e.autodrain(), Promise.resolve();
                    }
                    addStyleModel(e, t) {
                        switch(t){
                            case n.ValueType.Date:
                                return this.dateStyleId;
                            default:
                                return 0;
                        }
                    }
                    get dateStyleId() {
                        if (!this._dateStyleId) {
                            const e = {
                                numFmtId: h.getDefaultFmtId("mm-dd-yy")
                            };
                            this._dateStyleId = this.model.styles.length, this.model.styles.push(e);
                        }
                        return this._dateStyleId;
                    }
                    getStyleModel() {
                        return {};
                    }
                }, t.exports = p;
            },
            {
                "../../../doc/enums": 7,
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "../static-xform": 120,
                "./border-xform": 127,
                "./dxf-xform": 129,
                "./fill-xform": 130,
                "./font-xform": 131,
                "./numfmt-xform": 132,
                "./style-xform": 134
            }
        ],
        136: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                class i extends n {
                    constructor(e){
                        super(), this.model = e;
                    }
                    get tag() {
                        return "u";
                    }
                    render(e, t) {
                        if (!0 === (t = t || this.model)) e.leafNode("u");
                        else {
                            const r = i.Attributes[t];
                            r && e.leafNode("u", r);
                        }
                    }
                    parseOpen(e) {
                        "u" === e.name && (this.model = e.attributes.val || !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                }
                i.Attributes = {
                    single: {},
                    double: {
                        val: "double"
                    },
                    singleAccounting: {
                        val: "singleAccounting"
                    },
                    doubleAccounting: {
                        val: "doubleAccounting"
                    }
                }, t.exports = i;
            },
            {
                "../base-xform": 32
            }
        ],
        137: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("./filter-column-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            filterColumn: new i
                        };
                    }
                    get tag() {
                        return "autoFilter";
                    }
                    prepare(e) {
                        e.columns.forEach((e, t)=>{
                            this.map.filterColumn.prepare(e, {
                                index: t
                            });
                        });
                    }
                    render(e, t) {
                        return e.openNode(this.tag, {
                            ref: t.autoFilterRef
                        }), t.columns.forEach((t)=>{
                            this.map.filterColumn.render(e, t);
                        }), e.closeNode(), !0;
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    autoFilterRef: e.attributes.ref,
                                    columns: []
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.model.columns.push(this.parser.model), this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return !1;
                            default:
                                throw new Error("Unexpected xml node in parseClose: " + e);
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "./filter-column-xform": 139
            }
        ],
        138: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "customFilter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val,
                            operator: t.operator
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val,
                            operator: e.attributes.operator
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        139: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform"), i = e("../list-xform"), s = e("./custom-filter-xform"), o = e("./filter-xform");
                t.exports = class extends n {
                    constructor(){
                        super(), this.map = {
                            customFilters: new i({
                                tag: "customFilters",
                                count: !1,
                                empty: !0,
                                childXform: new s
                            }),
                            filters: new i({
                                tag: "filters",
                                count: !1,
                                empty: !0,
                                childXform: new o
                            })
                        };
                    }
                    get tag() {
                        return "filterColumn";
                    }
                    prepare(e, t) {
                        e.colId = t.index.toString();
                    }
                    render(e, t) {
                        return t.customFilters ? (e.openNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), this.map.customFilters.render(e, t.customFilters), e.closeNode(), !0) : (e.leafNode(this.tag, {
                            colId: t.colId,
                            hiddenButton: t.filterButton ? "0" : "1"
                        }), !0);
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { attributes: t } = e;
                        switch(e.name){
                            case this.tag:
                                return this.model = {
                                    filterButton: "0" === t.hiddenButton
                                }, !0;
                            default:
                                if (this.parser = this.map[e.name], this.parser) return this.parseOpen(e), !0;
                                throw new Error("Unexpected xml node in parseOpen: " + JSON.stringify(e));
                        }
                    }
                    parseText() {}
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.customFilters = this.map.customFilters.model, !1;
                            default:
                                return !0;
                        }
                    }
                };
            },
            {
                "../base-xform": 32,
                "../list-xform": 71,
                "./custom-filter-xform": 138,
                "./filter-xform": 140
            }
        ],
        140: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "filter";
                    }
                    render(e, t) {
                        e.leafNode(this.tag, {
                            val: t.val
                        });
                    }
                    parseOpen(e) {
                        return e.name === this.tag && (this.model = {
                            val: e.attributes.val
                        }, !0);
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        141: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableColumn";
                    }
                    prepare(e, t) {
                        e.id = t.index + 1;
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            id: t.id.toString(),
                            name: t.name,
                            totalsRowLabel: t.totalsRowLabel,
                            totalsRowFunction: t.totalsRowFunction,
                            dxfId: t.dxfId
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                name: t.name,
                                totalsRowLabel: t.totalsRowLabel,
                                totalsRowFunction: t.totalsRowFunction,
                                dxfId: t.dxfId
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        142: [
            function(e, t, r) {
                "use strict";
                const n = e("../base-xform");
                t.exports = class extends n {
                    get tag() {
                        return "tableStyleInfo";
                    }
                    render(e, t) {
                        return e.leafNode(this.tag, {
                            name: t.theme ? t.theme : void 0,
                            showFirstColumn: t.showFirstColumn ? "1" : "0",
                            showLastColumn: t.showLastColumn ? "1" : "0",
                            showRowStripes: t.showRowStripes ? "1" : "0",
                            showColumnStripes: t.showColumnStripes ? "1" : "0"
                        }), !0;
                    }
                    parseOpen(e) {
                        if (e.name === this.tag) {
                            const { attributes: t } = e;
                            return this.model = {
                                theme: t.name ? t.name : null,
                                showFirstColumn: "1" === t.showFirstColumn,
                                showLastColumn: "1" === t.showLastColumn,
                                showRowStripes: "1" === t.showRowStripes,
                                showColumnStripes: "1" === t.showColumnStripes
                            }, !0;
                        }
                        return !1;
                    }
                    parseText() {}
                    parseClose() {
                        return !1;
                    }
                };
            },
            {
                "../base-xform": 32
            }
        ],
        143: [
            function(e, t, r) {
                "use strict";
                const n = e("../../../utils/xml-stream"), i = e("../base-xform"), s = e("../list-xform"), o = e("./auto-filter-xform"), a = e("./table-column-xform"), l = e("./table-style-info-xform");
                class c extends i {
                    constructor(){
                        super(), this.map = {
                            autoFilter: new o,
                            tableColumns: new s({
                                tag: "tableColumns",
                                count: !0,
                                empty: !0,
                                childXform: new a
                            }),
                            tableStyleInfo: new l
                        };
                    }
                    prepare(e, t) {
                        this.map.autoFilter.prepare(e), this.map.tableColumns.prepare(e.columns, t);
                    }
                    get tag() {
                        return "table";
                    }
                    render(e, t) {
                        e.openXml(n.StdDocAttributes), e.openNode(this.tag, {
                            ...c.TABLE_ATTRIBUTES,
                            id: t.id,
                            name: t.name,
                            displayName: t.displayName || t.name,
                            ref: t.tableRef,
                            totalsRowCount: t.totalsRow ? "1" : void 0,
                            totalsRowShown: t.totalsRow ? void 0 : "1",
                            headerRowCount: t.headerRow ? "1" : "0"
                        }), this.map.autoFilter.render(e, t), this.map.tableColumns.render(e, t.columns), this.map.tableStyleInfo.render(e, t.style), e.closeNode();
                    }
                    parseOpen(e) {
                        if (this.parser) return this.parser.parseOpen(e), !0;
                        const { name: t, attributes: r } = e;
                        switch(t){
                            case this.tag:
                                this.reset(), this.model = {
                                    name: r.name,
                                    displayName: r.displayName || r.name,
                                    tableRef: r.ref,
                                    totalsRow: "1" === r.totalsRowCount,
                                    headerRow: "1" === r.headerRowCount
                                };
                                break;
                            default:
                                this.parser = this.map[e.name], this.parser && this.parser.parseOpen(e);
                        }
                        return !0;
                    }
                    parseText(e) {
                        this.parser && this.parser.parseText(e);
                    }
                    parseClose(e) {
                        if (this.parser) return this.parser.parseClose(e) || (this.parser = void 0), !0;
                        switch(e){
                            case this.tag:
                                return this.model.columns = this.map.tableColumns.model, this.map.autoFilter.model && (this.model.autoFilterRef = this.map.autoFilter.model.autoFilterRef, this.map.autoFilter.model.columns.forEach((e, t)=>{
                                    this.model.columns[t].filterButton = e.filterButton;
                                })), this.model.style = this.map.tableStyleInfo.model, !1;
                            default:
                                return !0;
                        }
                    }
                    reconcile(e, t) {
                        e.columns.forEach((e)=>{
                            void 0 !== e.dxfId && (e.style = t.styles.getDxfStyle(e.dxfId));
                        });
                    }
                }
                c.TABLE_ATTRIBUTES = {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3"
                }, t.exports = c;
            },
            {
                "../../../utils/xml-stream": 28,
                "../base-xform": 32,
                "../list-xform": 71,
                "./auto-filter-xform": 137,
                "./table-column-xform": 141,
                "./table-style-info-xform": 142
            }
        ],
        144: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        const i = e("fs"), s = e("jszip"), { PassThrough: o } = e("readable-stream"), a = e("../utils/zip-stream"), l = e("../utils/stream-buf"), c = e("../utils/utils"), u = e("../utils/xml-stream"), { bufferToString: h } = e("../utils/browser-buffer-decode"), f = e("./xform/style/styles-xform"), d = e("./xform/core/core-xform"), p = e("./xform/strings/shared-strings-xform"), m = e("./xform/core/relationships-xform"), b = e("./xform/core/content-types-xform"), g = e("./xform/core/app-xform"), y = e("./xform/book/workbook-xform"), v = e("./xform/sheet/worksheet-xform"), w = e("./xform/drawing/drawing-xform"), _ = e("./xform/table/table-xform"), x = e("./xform/comment/comments-xform"), k = e("./xform/comment/vml-notes-xform"), S = e("./xml/theme1");
                        class M {
                            constructor(e){
                                this.workbook = e;
                            }
                            async readFile(e, t) {
                                if (!await c.fs.exists(e)) throw new Error("File not found: " + e);
                                const r = i.createReadStream(e);
                                try {
                                    const e = await this.read(r, t);
                                    return r.close(), e;
                                } catch (e) {
                                    throw r.close(), e;
                                }
                            }
                            parseRels(e) {
                                return (new m).parseStream(e);
                            }
                            parseWorkbook(e) {
                                return (new y).parseStream(e);
                            }
                            parseSharedStrings(e) {
                                return (new p).parseStream(e);
                            }
                            reconcile(e, t) {
                                const r = new y, n = new v(t), i = new w, s = new _;
                                r.reconcile(e);
                                const o = {
                                    media: e.media,
                                    mediaIndex: e.mediaIndex
                                };
                                Object.keys(e.drawings).forEach((t)=>{
                                    const r = e.drawings[t], n = e.drawingRels[t];
                                    n && (o.rels = n.reduce((e, t)=>(e[t.Id] = t, e), {}), (r.anchors || []).forEach((e)=>{
                                        const t = e.picture && e.picture.hyperlinks;
                                        t && o.rels[t.rId] && (t.hyperlink = o.rels[t.rId].Target, delete t.rId);
                                    }), i.reconcile(r, o));
                                });
                                const a = {
                                    styles: e.styles
                                };
                                Object.values(e.tables).forEach((e)=>{
                                    s.reconcile(e, a);
                                });
                                const l = {
                                    styles: e.styles,
                                    sharedStrings: e.sharedStrings,
                                    media: e.media,
                                    mediaIndex: e.mediaIndex,
                                    date1904: e.properties && e.properties.date1904,
                                    drawings: e.drawings,
                                    comments: e.comments,
                                    tables: e.tables,
                                    vmlDrawings: e.vmlDrawings
                                };
                                e.worksheets.forEach((t)=>{
                                    t.relationships = e.worksheetRels[t.sheetNo], n.reconcile(t, l);
                                }), delete e.worksheetHash, delete e.worksheetRels, delete e.globalRels, delete e.sharedStrings, delete e.workbookRels, delete e.sheetDefs, delete e.styles, delete e.mediaIndex, delete e.drawings, delete e.drawingRels, delete e.vmlDrawings;
                            }
                            async _processWorksheetEntry(e, t, r, n, i) {
                                const s = new v(n), o = await s.parseStream(e);
                                o.sheetNo = r, t.worksheetHash[i] = o, t.worksheets.push(o);
                            }
                            async _processCommentEntry(e, t, r) {
                                const n = new x, i = await n.parseStream(e);
                                t.comments[`../${r}.xml`] = i;
                            }
                            async _processTableEntry(e, t, r) {
                                const n = new _, i = await n.parseStream(e);
                                t.tables[`../tables/${r}.xml`] = i;
                            }
                            async _processWorksheetRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.worksheetRels[r] = i;
                            }
                            async _processMediaEntry(e, t, r) {
                                const n = r.lastIndexOf(".");
                                if (n >= 1) {
                                    const i = r.substr(n + 1), s = r.substr(0, n);
                                    await new Promise((n, o)=>{
                                        const a = new l;
                                        a.on("finish", ()=>{
                                            t.mediaIndex[r] = t.media.length, t.mediaIndex[s] = t.media.length;
                                            const e = {
                                                type: "image",
                                                name: s,
                                                extension: i,
                                                buffer: a.toBuffer()
                                            };
                                            t.media.push(e), n();
                                        }), e.on("error", (e)=>{
                                            o(e);
                                        }), e.pipe(a);
                                    });
                                }
                            }
                            async _processDrawingEntry(e, t, r) {
                                const n = new w, i = await n.parseStream(e);
                                t.drawings[r] = i;
                            }
                            async _processDrawingRelsEntry(e, t, r) {
                                const n = new m, i = await n.parseStream(e);
                                t.drawingRels[r] = i;
                            }
                            async _processVmlDrawingEntry(e, t, r) {
                                const n = new k, i = await n.parseStream(e);
                                t.vmlDrawings[`../drawings/${r}.vml`] = i;
                            }
                            async _processThemeEntry(e, t, r) {
                                await new Promise((n, i)=>{
                                    const s = new l;
                                    e.on("error", i), s.on("error", i), s.on("finish", ()=>{
                                        t.themes[r] = s.read().toString(), n();
                                    }), e.pipe(s);
                                });
                            }
                            createInputStream() {
                                throw new Error("`XLSX#createInputStream` is deprecated. You should use `XLSX#read` instead. This method will be removed in version 5.0. Please follow upgrade instruction: https://github.com/exceljs/exceljs/blob/master/UPGRADE-4.0.md");
                            }
                            async read(e, t) {
                                !e[Symbol.asyncIterator] && e.pipe && (e = e.pipe(new o));
                                const r = [];
                                for await (const t of e)r.push(t);
                                return this.load(n.concat(r), t);
                            }
                            async load(e, t) {
                                let i;
                                i = t && t.base64 ? n.from(e.toString(), "base64") : e;
                                const a = {
                                    worksheets: [],
                                    worksheetHash: {},
                                    worksheetRels: [],
                                    themes: {},
                                    media: [],
                                    mediaIndex: {},
                                    drawings: {},
                                    drawingRels: {},
                                    comments: {},
                                    tables: {},
                                    vmlDrawings: {}
                                }, l = await s.loadAsync(i);
                                for (const e of Object.values(l.files))if (!e.dir) {
                                    let n, i = e.name;
                                    if ("/" === i[0] && (i = i.substr(1)), i.match(/xl\/media\//) || i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/)) n = new o, n.write(await e.async("nodebuffer"));
                                    else {
                                        let t;
                                        n = new o({
                                            writableObjectMode: !0,
                                            readableObjectMode: !0
                                        }), t = r.browser ? h(await e.async("nodebuffer")) : await e.async("string");
                                        const i = 16384;
                                        for(let e = 0; e < t.length; e += i)n.write(t.substring(e, e + i));
                                    }
                                    switch(n.end(), i){
                                        case "_rels/.rels":
                                            a.globalRels = await this.parseRels(n);
                                            break;
                                        case "xl/workbook.xml":
                                            {
                                                const e = await this.parseWorkbook(n);
                                                a.sheets = e.sheets, a.definedNames = e.definedNames, a.views = e.views, a.properties = e.properties, a.calcProperties = e.calcProperties;
                                                break;
                                            }
                                        case "xl/_rels/workbook.xml.rels":
                                            a.workbookRels = await this.parseRels(n);
                                            break;
                                        case "xl/sharedStrings.xml":
                                            a.sharedStrings = new p, await a.sharedStrings.parseStream(n);
                                            break;
                                        case "xl/styles.xml":
                                            a.styles = new f, await a.styles.parseStream(n);
                                            break;
                                        case "docProps/app.xml":
                                            {
                                                const e = new g, t = await e.parseStream(n);
                                                a.company = t.company, a.manager = t.manager;
                                                break;
                                            }
                                        case "docProps/core.xml":
                                            {
                                                const e = new d, t = await e.parseStream(n);
                                                Object.assign(a, t);
                                                break;
                                            }
                                        default:
                                            {
                                                let e = i.match(/xl\/worksheets\/sheet(\d+)[.]xml/);
                                                if (e) {
                                                    await this._processWorksheetEntry(n, a, e[1], t, i);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/worksheets\/_rels\/sheet(\d+)[.]xml.rels/), e) {
                                                    await this._processWorksheetRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/theme\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processThemeEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/media\/([a-zA-Z0-9]+[.][a-zA-Z0-9]{3,4})$/), e) {
                                                    await this._processMediaEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/([a-zA-Z0-9]+)[.]xml/), e) {
                                                    await this._processDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/(comments\d+)[.]xml/), e) {
                                                    await this._processCommentEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/tables\/(table\d+)[.]xml/), e) {
                                                    await this._processTableEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/_rels\/([a-zA-Z0-9]+)[.]xml[.]rels/), e) {
                                                    await this._processDrawingRelsEntry(n, a, e[1]);
                                                    break;
                                                }
                                                if (e = i.match(/xl\/drawings\/(vmlDrawing\d+)[.]vml/), e) {
                                                    await this._processVmlDrawingEntry(n, a, e[1]);
                                                    break;
                                                }
                                            }
                                    }
                                }
                                return this.reconcile(a, t), this.workbook.model = a, this.workbook;
                            }
                            async addMedia(e, t) {
                                await Promise.all(t.media.map(async (t)=>{
                                    if ("image" === t.type) {
                                        const r = `xl/media/${t.name}.${t.extension}`;
                                        if (t.filename) {
                                            const n = await function(e, t) {
                                                return new Promise((r, n)=>{
                                                    i.readFile(e, t, (e, t)=>{
                                                        e ? n(e) : r(t);
                                                    });
                                                });
                                            }(t.filename);
                                            return e.append(n, {
                                                name: r
                                            });
                                        }
                                        if (t.buffer) return e.append(t.buffer, {
                                            name: r
                                        });
                                        if (t.base64) {
                                            const n = t.base64, i = n.substring(n.indexOf(",") + 1);
                                            return e.append(i, {
                                                name: r,
                                                base64: !0
                                            });
                                        }
                                    }
                                    throw new Error("Unsupported media");
                                }));
                            }
                            addDrawings(e, t) {
                                const r = new w, n = new m;
                                t.worksheets.forEach((t)=>{
                                    const { drawing: i } = t;
                                    if (i) {
                                        r.prepare(i, {});
                                        let t = r.toXml(i);
                                        e.append(t, {
                                            name: `xl/drawings/${i.name}.xml`
                                        }), t = n.toXml(i.rels), e.append(t, {
                                            name: `xl/drawings/_rels/${i.name}.xml.rels`
                                        });
                                    }
                                });
                            }
                            addTables(e, t) {
                                const r = new _;
                                t.worksheets.forEach((t)=>{
                                    const { tables: n } = t;
                                    n.forEach((t)=>{
                                        r.prepare(t, {});
                                        const n = r.toXml(t);
                                        e.append(n, {
                                            name: "xl/tables/" + t.target
                                        });
                                    });
                                });
                            }
                            async addContentTypes(e, t) {
                                const r = (new b).toXml(t);
                                e.append(r, {
                                    name: "[Content_Types].xml"
                                });
                            }
                            async addApp(e, t) {
                                const r = (new g).toXml(t);
                                e.append(r, {
                                    name: "docProps/app.xml"
                                });
                            }
                            async addCore(e, t) {
                                const r = new d;
                                e.append(r.toXml(t), {
                                    name: "docProps/core.xml"
                                });
                            }
                            async addThemes(e, t) {
                                const r = t.themes || {
                                    theme1: S
                                };
                                Object.keys(r).forEach((t)=>{
                                    const n = r[t], i = `xl/theme/${t}.xml`;
                                    e.append(n, {
                                        name: i
                                    });
                                });
                            }
                            async addOfficeRels(e) {
                                const t = (new m).toXml([
                                    {
                                        Id: "rId1",
                                        Type: M.RelType.OfficeDocument,
                                        Target: "xl/workbook.xml"
                                    },
                                    {
                                        Id: "rId2",
                                        Type: M.RelType.CoreProperties,
                                        Target: "docProps/core.xml"
                                    },
                                    {
                                        Id: "rId3",
                                        Type: M.RelType.ExtenderProperties,
                                        Target: "docProps/app.xml"
                                    }
                                ]);
                                e.append(t, {
                                    name: "_rels/.rels"
                                });
                            }
                            async addWorkbookRels(e, t) {
                                let r = 1;
                                const n = [
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Styles,
                                        Target: "styles.xml"
                                    },
                                    {
                                        Id: "rId" + r++,
                                        Type: M.RelType.Theme,
                                        Target: "theme/theme1.xml"
                                    }
                                ];
                                t.sharedStrings.count && n.push({
                                    Id: "rId" + r++,
                                    Type: M.RelType.SharedStrings,
                                    Target: "sharedStrings.xml"
                                }), t.worksheets.forEach((e)=>{
                                    e.rId = "rId" + r++, n.push({
                                        Id: e.rId,
                                        Type: M.RelType.Worksheet,
                                        Target: `worksheets/sheet${e.id}.xml`
                                    });
                                });
                                const i = (new m).toXml(n);
                                e.append(i, {
                                    name: "xl/_rels/workbook.xml.rels"
                                });
                            }
                            async addSharedStrings(e, t) {
                                t.sharedStrings && t.sharedStrings.count && e.append(t.sharedStrings.xml, {
                                    name: "xl/sharedStrings.xml"
                                });
                            }
                            async addStyles(e, t) {
                                const { xml: r } = t.styles;
                                r && e.append(r, {
                                    name: "xl/styles.xml"
                                });
                            }
                            async addWorkbook(e, t) {
                                const r = new y;
                                e.append(r.toXml(t), {
                                    name: "xl/workbook.xml"
                                });
                            }
                            async addWorksheets(e, t) {
                                const r = new v, n = new m, i = new x, s = new k;
                                t.worksheets.forEach((t)=>{
                                    let o = new u;
                                    r.render(o, t), e.append(o.xml, {
                                        name: `xl/worksheets/sheet${t.id}.xml`
                                    }), t.rels && t.rels.length && (o = new u, n.render(o, t.rels), e.append(o.xml, {
                                        name: `xl/worksheets/_rels/sheet${t.id}.xml.rels`
                                    })), t.comments.length > 0 && (o = new u, i.render(o, t), e.append(o.xml, {
                                        name: `xl/comments${t.id}.xml`
                                    }), o = new u, s.render(o, t), e.append(o.xml, {
                                        name: `xl/drawings/vmlDrawing${t.id}.vml`
                                    }));
                                });
                            }
                            _finalize(e) {
                                return new Promise((t, r)=>{
                                    e.on("finish", ()=>{
                                        t(this);
                                    }), e.on("error", r), e.finalize();
                                });
                            }
                            prepareModel(e, t) {
                                e.creator = e.creator || "ExcelJS", e.lastModifiedBy = e.lastModifiedBy || "ExcelJS", e.created = e.created || new Date, e.modified = e.modified || new Date, e.useSharedStrings = void 0 === t.useSharedStrings || t.useSharedStrings, e.useStyles = void 0 === t.useStyles || t.useStyles, e.sharedStrings = new p, e.styles = e.useStyles ? new f(!0) : new f.Mock;
                                const r = new y, n = new v;
                                r.prepare(e);
                                const i = {
                                    sharedStrings: e.sharedStrings,
                                    styles: e.styles,
                                    date1904: e.properties.date1904,
                                    drawingsCount: 0,
                                    media: e.media
                                };
                                i.drawings = e.drawings = [], i.commentRefs = e.commentRefs = [];
                                let s = 0;
                                e.tables = [], e.worksheets.forEach((t)=>{
                                    t.tables.forEach((t)=>{
                                        s++, t.target = `table${s}.xml`, t.id = s, e.tables.push(t);
                                    }), n.prepare(t, i);
                                });
                            }
                            async write(e, t) {
                                t = t || {};
                                const { model: r } = this.workbook, n = new a.ZipWriter(t.zip);
                                return n.pipe(e), this.prepareModel(r, t), await this.addContentTypes(n, r), await this.addOfficeRels(n, r), await this.addWorkbookRels(n, r), await this.addWorksheets(n, r), await this.addSharedStrings(n, r), await this.addDrawings(n, r), await this.addTables(n, r), await Promise.all([
                                    this.addThemes(n, r),
                                    this.addStyles(n, r)
                                ]), await this.addMedia(n, r), await Promise.all([
                                    this.addApp(n, r),
                                    this.addCore(n, r)
                                ]), await this.addWorkbook(n, r), this._finalize(n);
                            }
                            writeFile(e, t) {
                                const r = i.createWriteStream(e);
                                return new Promise((e, n)=>{
                                    r.on("finish", ()=>{
                                        e();
                                    }), r.on("error", (e)=>{
                                        n(e);
                                    }), this.write(r, t).then(()=>{
                                        r.end();
                                    }).catch((e)=>{
                                        n(e);
                                    });
                                });
                            }
                            async writeBuffer(e) {
                                const t = new l;
                                return await this.write(t, e), t.read();
                            }
                        }
                        M.RelType = e("./rel-type"), t.exports = M;
                    }).call(this);
                }).call(this, e("_process"), e("buffer").Buffer);
            },
            {
                "../utils/browser-buffer-decode": 16,
                "../utils/stream-buf": 24,
                "../utils/utils": 27,
                "../utils/xml-stream": 28,
                "../utils/zip-stream": 29,
                "./rel-type": 31,
                "./xform/book/workbook-xform": 38,
                "./xform/comment/comments-xform": 40,
                "./xform/comment/vml-notes-xform": 45,
                "./xform/core/app-xform": 51,
                "./xform/core/content-types-xform": 52,
                "./xform/core/core-xform": 53,
                "./xform/core/relationships-xform": 55,
                "./xform/drawing/drawing-xform": 62,
                "./xform/sheet/worksheet-xform": 115,
                "./xform/strings/shared-strings-xform": 124,
                "./xform/style/styles-xform": 135,
                "./xform/table/table-xform": 143,
                "./xml/theme1": 145,
                _process: 467,
                buffer: 220,
                fs: 216,
                jszip: 441,
                "readable-stream": 491
            }
        ],
        145: [
            function(e, t, r) {
                "use strict";
                t.exports = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"> <a:themeElements> <a:clrScheme name="Office"> <a:dk1> <a:sysClr val="windowText" lastClr="000000"/> </a:dk1> <a:lt1> <a:sysClr val="window" lastClr="FFFFFF"/> </a:lt1> <a:dk2> <a:srgbClr val="1F497D"/> </a:dk2> <a:lt2> <a:srgbClr val="EEECE1"/> </a:lt2> <a:accent1> <a:srgbClr val="4F81BD"/> </a:accent1> <a:accent2> <a:srgbClr val="C0504D"/> </a:accent2> <a:accent3> <a:srgbClr val="9BBB59"/> </a:accent3> <a:accent4> <a:srgbClr val="8064A2"/> </a:accent4> <a:accent5> <a:srgbClr val="4BACC6"/> </a:accent5> <a:accent6> <a:srgbClr val="F79646"/> </a:accent6> <a:hlink> <a:srgbClr val="0000FF"/> </a:hlink> <a:folHlink> <a:srgbClr val="800080"/> </a:folHlink> </a:clrScheme> <a:fontScheme name="Office"> <a:majorFont> <a:latin typeface="Cambria"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Times New Roman"/> <a:font script="Hebr" typeface="Times New Roman"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="MoolBoran"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Times New Roman"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:majorFont> <a:minorFont> <a:latin typeface="Calibri"/> <a:ea typeface=""/> <a:cs typeface=""/> <a:font script="Jpan" typeface="\uff2d\uff33 \uff30\u30b4\u30b7\u30c3\u30af"/> <a:font script="Hang" typeface="\ub9d1\uc740 \uace0\ub515"/> <a:font script="Hans" typeface="\u5b8b\u4f53"/> <a:font script="Hant" typeface="\u65b0\u7d30\u660e\u9ad4"/> <a:font script="Arab" typeface="Arial"/> <a:font script="Hebr" typeface="Arial"/> <a:font script="Thai" typeface="Tahoma"/> <a:font script="Ethi" typeface="Nyala"/> <a:font script="Beng" typeface="Vrinda"/> <a:font script="Gujr" typeface="Shruti"/> <a:font script="Khmr" typeface="DaunPenh"/> <a:font script="Knda" typeface="Tunga"/> <a:font script="Guru" typeface="Raavi"/> <a:font script="Cans" typeface="Euphemia"/> <a:font script="Cher" typeface="Plantagenet Cherokee"/> <a:font script="Yiii" typeface="Microsoft Yi Baiti"/> <a:font script="Tibt" typeface="Microsoft Himalaya"/> <a:font script="Thaa" typeface="MV Boli"/> <a:font script="Deva" typeface="Mangal"/> <a:font script="Telu" typeface="Gautami"/> <a:font script="Taml" typeface="Latha"/> <a:font script="Syrc" typeface="Estrangelo Edessa"/> <a:font script="Orya" typeface="Kalinga"/> <a:font script="Mlym" typeface="Kartika"/> <a:font script="Laoo" typeface="DokChampa"/> <a:font script="Sinh" typeface="Iskoola Pota"/> <a:font script="Mong" typeface="Mongolian Baiti"/> <a:font script="Viet" typeface="Arial"/> <a:font script="Uigh" typeface="Microsoft Uighur"/> <a:font script="Geor" typeface="Sylfaen"/> </a:minorFont> </a:fontScheme> <a:fmtScheme name="Office"> <a:fillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="35000"> <a:schemeClr val="phClr"> <a:tint val="37000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="15000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="1"/> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="100000"/> <a:shade val="100000"/> <a:satMod val="130000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:tint val="50000"/> <a:shade val="100000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:lin ang="16200000" scaled="0"/> </a:gradFill> </a:fillStyleLst> <a:lnStyleLst> <a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"> <a:shade val="95000"/> <a:satMod val="105000"/> </a:schemeClr> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> <a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:prstDash val="solid"/> </a:ln> </a:lnStyleLst> <a:effectStyleLst> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="38000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> </a:effectStyle> <a:effectStyle> <a:effectLst> <a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"> <a:srgbClr val="000000"> <a:alpha val="35000"/> </a:srgbClr> </a:outerShdw> </a:effectLst> <a:scene3d> <a:camera prst="orthographicFront"> <a:rot lat="0" lon="0" rev="0"/> </a:camera> <a:lightRig rig="threePt" dir="t"> <a:rot lat="0" lon="0" rev="1200000"/> </a:lightRig> </a:scene3d> <a:sp3d> <a:bevelT w="63500" h="25400"/> </a:sp3d> </a:effectStyle> </a:effectStyleLst> <a:bgFillStyleLst> <a:solidFill> <a:schemeClr val="phClr"/> </a:solidFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="40000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="40000"> <a:schemeClr val="phClr"> <a:tint val="45000"/> <a:shade val="99000"/> <a:satMod val="350000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="20000"/> <a:satMod val="255000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="-80000" r="50000" b="180000"/> </a:path> </a:gradFill> <a:gradFill rotWithShape="1"> <a:gsLst> <a:gs pos="0"> <a:schemeClr val="phClr"> <a:tint val="80000"/> <a:satMod val="300000"/> </a:schemeClr> </a:gs> <a:gs pos="100000"> <a:schemeClr val="phClr"> <a:shade val="30000"/> <a:satMod val="200000"/> </a:schemeClr> </a:gs> </a:gsLst> <a:path path="circle"> <a:fillToRect l="50000" t="50000" r="50000" b="50000"/> </a:path> </a:gradFill> </a:bgFillStyleLst> </a:fmtScheme> </a:themeElements> <a:objectDefaults> <a:spDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="1"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="3"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="2"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="lt1"/> </a:fontRef> </a:style> </a:spDef> <a:lnDef> <a:spPr/> <a:bodyPr/> <a:lstStyle/> <a:style> <a:lnRef idx="2"> <a:schemeClr val="accent1"/> </a:lnRef> <a:fillRef idx="0"> <a:schemeClr val="accent1"/> </a:fillRef> <a:effectRef idx="1"> <a:schemeClr val="accent1"/> </a:effectRef> <a:fontRef idx="minor"> <a:schemeClr val="tx1"/> </a:fontRef> </a:style> </a:lnDef> </a:objectDefaults> <a:extraClrSchemeLst/> </a:theme>';
            },
            {}
        ],
        146: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvFormatterStream = void 0;
                        const n = e("stream"), i = e("./formatter");
                        class s extends n.Transform {
                            constructor(e){
                                super({
                                    writableObjectMode: e.objectMode
                                }), this.hasWrittenBOM = !1, this.formatterOptions = e, this.rowFormatter = new i.RowFormatter(e), this.hasWrittenBOM = !e.writeBOM;
                            }
                            transform(e) {
                                return this.rowFormatter.rowTransform = e, this;
                            }
                            _transform(e, r, n) {
                                let i = !1;
                                try {
                                    this.hasWrittenBOM || (this.push(this.formatterOptions.BOM), this.hasWrittenBOM = !0), this.rowFormatter.format(e, (e, r)=>e ? (i = !0, n(e)) : (r && r.forEach((e)=>{
                                            this.push(t.from(e, "utf8"));
                                        }), i = !0, n()));
                                } catch (e) {
                                    if (i) throw e;
                                    n(e);
                                }
                            }
                            _flush(e) {
                                this.rowFormatter.finish((r, n)=>r ? e(r) : (n && n.forEach((e)=>{
                                        this.push(t.from(e, "utf8"));
                                    }), e()));
                            }
                        }
                        r.CsvFormatterStream = s;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./formatter": 150,
                buffer: 220,
                stream: 505
            }
        ],
        147: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FormatterOptions = void 0;
                r.FormatterOptions = class {
                    constructor(){
                        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        var t;
                        this.objectMode = !0, this.delimiter = ",", this.rowDelimiter = "\n", this.quote = '"', this.escape = this.quote, this.quoteColumns = !1, this.quoteHeaders = this.quoteColumns, this.headers = null, this.includeEndRowDelimiter = !1, this.writeBOM = !1, this.BOM = "\ufeff", this.alwaysWriteHeaders = !1, Object.assign(this, e || {}), void 0 === (null == e ? void 0 : e.quoteHeaders) && (this.quoteHeaders = this.quoteColumns), !0 === (null == e ? void 0 : e.quote) ? this.quote = '"' : !1 === (null == e ? void 0 : e.quote) && (this.quote = ""), "string" != typeof (null == e ? void 0 : e.escape) && (this.escape = this.quote), this.shouldWriteHeaders = !!this.headers && (null === (t = e.writeHeaders) || void 0 === t || t), this.headers = Array.isArray(this.headers) ? this.headers : null, this.escapedQuote = `${this.escape}${this.quote}`;
                    }
                };
            },
            {}
        ],
        148: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = void 0;
                const i = n(e("lodash.isboolean")), s = n(e("lodash.isnil")), o = n(e("lodash.escaperegexp"));
                r.FieldFormatter = class {
                    constructor(e){
                        this._headers = null, this.formatterOptions = e, null !== e.headers && (this.headers = e.headers), this.REPLACE_REGEXP = new RegExp(e.quote, "g");
                        const t = `[${e.delimiter}${o.default(e.rowDelimiter)}|\r|\n]`;
                        this.ESCAPE_REGEXP = new RegExp(t);
                    }
                    set headers(e) {
                        this._headers = e;
                    }
                    shouldQuote(e, t) {
                        const r = t ? this.formatterOptions.quoteHeaders : this.formatterOptions.quoteColumns;
                        return i.default(r) ? r : Array.isArray(r) ? r[e] : null !== this._headers && r[this._headers[e]];
                    }
                    format(e, t, r) {
                        const n = ("" + (s.default(e) ? "" : e)).replace(/\0/g, ""), { formatterOptions: i } = this;
                        if ("" !== i.quote) {
                            if (-1 !== n.indexOf(i.quote)) return this.quoteField(n.replace(this.REPLACE_REGEXP, i.escapedQuote));
                        }
                        return -1 !== n.search(this.ESCAPE_REGEXP) || this.shouldQuote(t, r) ? this.quoteField(n) : n;
                    }
                    quoteField(e) {
                        const { quote: t } = this.formatterOptions;
                        return `${t}${e}${t}`;
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isboolean": 444,
                "lodash.isnil": 447
            }
        ],
        149: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowFormatter = void 0;
                const i = n(e("lodash.isfunction")), s = n(e("lodash.isequal")), o = e("./FieldFormatter"), a = e("../types");
                class l {
                    constructor(e){
                        this.rowCount = 0, this.formatterOptions = e, this.fieldFormatter = new o.FieldFormatter(e), this.headers = e.headers, this.shouldWriteHeaders = e.shouldWriteHeaders, this.hasWrittenHeaders = !1, null !== this.headers && (this.fieldFormatter.headers = this.headers), e.transform && (this.rowTransform = e.transform);
                    }
                    static isRowHashArray(e) {
                        return !!Array.isArray(e) && Array.isArray(e[0]) && 2 === e[0].length;
                    }
                    static isRowArray(e) {
                        return Array.isArray(e) && !this.isRowHashArray(e);
                    }
                    static gatherHeaders(e) {
                        return l.isRowHashArray(e) ? e.map((e)=>e[0]) : Array.isArray(e) ? e : Object.keys(e);
                    }
                    static createTransform(e) {
                        return a.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : (t, r)=>{
                            e(t, r);
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = l.createTransform(e);
                    }
                    format(e, t) {
                        this.callTransformer(e, (r, n)=>{
                            if (r) return t(r);
                            if (!e) return t(null);
                            const i = [];
                            if (n) {
                                const { shouldFormatColumns: e, headers: t } = this.checkHeaders(n);
                                if (this.shouldWriteHeaders && t && !this.hasWrittenHeaders && (i.push(this.formatColumns(t, !0)), this.hasWrittenHeaders = !0), e) {
                                    const e = this.gatherColumns(n);
                                    i.push(this.formatColumns(e, !1));
                                }
                            }
                            return t(null, i);
                        });
                    }
                    finish(e) {
                        const t = [];
                        if (this.formatterOptions.alwaysWriteHeaders && 0 === this.rowCount) {
                            if (!this.headers) return e(new Error("`alwaysWriteHeaders` option is set to true but `headers` option not provided."));
                            t.push(this.formatColumns(this.headers, !0));
                        }
                        return this.formatterOptions.includeEndRowDelimiter && t.push(this.formatterOptions.rowDelimiter), e(null, t);
                    }
                    checkHeaders(e) {
                        if (this.headers) return {
                            shouldFormatColumns: !0,
                            headers: this.headers
                        };
                        const t = l.gatherHeaders(e);
                        return this.headers = t, this.fieldFormatter.headers = t, this.shouldWriteHeaders ? {
                            shouldFormatColumns: !s.default(t, e),
                            headers: t
                        } : {
                            shouldFormatColumns: !0,
                            headers: null
                        };
                    }
                    gatherColumns(e) {
                        if (null === this.headers) throw new Error("Headers is currently null");
                        return Array.isArray(e) ? l.isRowHashArray(e) ? this.headers.map((t, r)=>{
                            const n = e[r];
                            return n ? n[1] : "";
                        }) : l.isRowArray(e) && !this.shouldWriteHeaders ? e : this.headers.map((t, r)=>e[r]) : this.headers.map((t)=>e[t]);
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    formatColumns(e, t) {
                        const r = e.map((e, r)=>this.fieldFormatter.format(e, r, t)).join(this.formatterOptions.delimiter), { rowCount: n } = this;
                        return this.rowCount += 1, n ? [
                            this.formatterOptions.rowDelimiter,
                            r
                        ].join("") : r;
                    }
                }
                r.RowFormatter = l;
            },
            {
                "../types": 152,
                "./FieldFormatter": 148,
                "lodash.isequal": 445,
                "lodash.isfunction": 446
            }
        ],
        150: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.FieldFormatter = r.RowFormatter = void 0;
                var n = e("./RowFormatter");
                Object.defineProperty(r, "RowFormatter", {
                    enumerable: !0,
                    get: function() {
                        return n.RowFormatter;
                    }
                });
                var i = e("./FieldFormatter");
                Object.defineProperty(r, "FieldFormatter", {
                    enumerable: !0,
                    get: function() {
                        return i.FieldFormatter;
                    }
                });
            },
            {
                "./FieldFormatter": 148,
                "./RowFormatter": 149
            }
        ],
        151: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = Object.create ? function(e, t, r, n) {
                            void 0 === n && (n = r), Object.defineProperty(e, n, {
                                enumerable: !0,
                                get: function() {
                                    return t[r];
                                }
                            });
                        } : function(e, t, r, n) {
                            void 0 === n && (n = r), e[n] = t[r];
                        }, i = Object.create ? function(e, t) {
                            Object.defineProperty(e, "default", {
                                enumerable: !0,
                                value: t
                            });
                        } : function(e, t) {
                            e.default = t;
                        }, s = function(e) {
                            if (e && e.__esModule) return e;
                            var t = {};
                            if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                            return i(t, e), t;
                        }, o = function(e, t) {
                            for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                        };
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = r.FormatterOptions = r.CsvFormatterStream = void 0;
                        const a = e("util"), l = e("stream"), c = s(e("fs")), u = e("./FormatterOptions"), h = e("./CsvFormatterStream");
                        o(e("./types"), r);
                        var f = e("./CsvFormatterStream");
                        Object.defineProperty(r, "CsvFormatterStream", {
                            enumerable: !0,
                            get: function() {
                                return f.CsvFormatterStream;
                            }
                        });
                        var d = e("./FormatterOptions");
                        Object.defineProperty(r, "FormatterOptions", {
                            enumerable: !0,
                            get: function() {
                                return d.FormatterOptions;
                            }
                        }), r.format = (e)=>new h.CsvFormatterStream(new u.FormatterOptions(e)), r.write = (e, t)=>{
                            const n = r.format(t), i = a.promisify((e, t)=>{
                                n.write(e, void 0, t);
                            });
                            return e.reduce((e, t)=>e.then(()=>i(t)), Promise.resolve()).then(()=>n.end()).catch((e)=>{
                                n.emit("error", e);
                            }), n;
                        }, r.writeToStream = (e, t, n)=>r.write(t, n).pipe(e), r.writeToBuffer = function(e) {
                            let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                            const i = [], s = new l.Writable({
                                write (e, t, r) {
                                    i.push(e), r();
                                }
                            });
                            return new Promise((o, a)=>{
                                s.on("error", a).on("finish", ()=>o(t.concat(i))), r.write(e, n).pipe(s);
                            });
                        }, r.writeToString = (e, t)=>r.writeToBuffer(e, t).then((e)=>e.toString()), r.writeToPath = (e, t, n)=>{
                            const i = c.createWriteStream(e, {
                                encoding: "utf8"
                            });
                            return r.write(t, n).pipe(i);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./CsvFormatterStream": 146,
                "./FormatterOptions": 147,
                "./types": 152,
                buffer: 220,
                fs: 216,
                stream: 505,
                util: 527
            }
        ],
        152: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length;
            },
            {}
        ],
        153: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        Object.defineProperty(r, "__esModule", {
                            value: !0
                        }), r.CsvParserStream = void 0;
                        const n = e("string_decoder"), i = e("stream"), s = e("./transforms"), o = e("./parser");
                        class a extends i.Transform {
                            constructor(e){
                                super({
                                    objectMode: e.objectMode
                                }), this.lines = "", this.rowCount = 0, this.parsedRowCount = 0, this.parsedLineCount = 0, this.endEmitted = !1, this.headersEmitted = !1, this.parserOptions = e, this.parser = new o.Parser(e), this.headerTransformer = new s.HeaderTransformer(e), this.decoder = new n.StringDecoder(e.encoding), this.rowTransformerValidator = new s.RowTransformerValidator;
                            }
                            get hasHitRowLimit() {
                                return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
                            }
                            get shouldEmitRows() {
                                return this.parsedRowCount > this.parserOptions.skipRows;
                            }
                            get shouldSkipLine() {
                                return this.parsedLineCount <= this.parserOptions.skipLines;
                            }
                            transform(e) {
                                return this.rowTransformerValidator.rowTransform = e, this;
                            }
                            validate(e) {
                                return this.rowTransformerValidator.rowValidator = e, this;
                            }
                            emit(e) {
                                if ("end" === e) return this.endEmitted || (this.endEmitted = !0, super.emit("end", this.rowCount)), !1;
                                for(var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)r[n - 1] = arguments[n];
                                return super.emit(e, ...r);
                            }
                            _transform(e, t, r) {
                                if (this.hasHitRowLimit) return r();
                                const n = a.wrapDoneCallback(r);
                                try {
                                    const { lines: t } = this, r = t + this.decoder.write(e), i = this.parse(r, !0);
                                    return this.processRows(i, n);
                                } catch (e) {
                                    return n(e);
                                }
                            }
                            _flush(e) {
                                const t = a.wrapDoneCallback(e);
                                if (this.hasHitRowLimit) return t();
                                try {
                                    const e = this.lines + this.decoder.end(), r = this.parse(e, !1);
                                    return this.processRows(r, t);
                                } catch (e) {
                                    return t(e);
                                }
                            }
                            parse(e, t) {
                                if (!e) return [];
                                const { line: r, rows: n } = this.parser.parse(e, t);
                                return this.lines = r, n;
                            }
                            processRows(e, r) {
                                const n = e.length, i = (s)=>{
                                    const o = (e)=>e ? r(e) : s % 100 != 0 ? i(s + 1) : void t(()=>i(s + 1));
                                    if (this.checkAndEmitHeaders(), s >= n || this.hasHitRowLimit) return r();
                                    if (this.parsedLineCount += 1, this.shouldSkipLine) return o();
                                    const a = e[s];
                                    this.rowCount += 1, this.parsedRowCount += 1;
                                    const l = this.rowCount;
                                    return this.transformRow(a, (e, t)=>{
                                        if (e) return this.rowCount -= 1, o(e);
                                        if (!t) return o(new Error("expected transform result"));
                                        if (t.isValid) {
                                            if (t.row) return this.pushRow(t.row, o);
                                        } else this.emit("data-invalid", t.row, l, t.reason);
                                        return o();
                                    });
                                };
                                i(0);
                            }
                            transformRow(e, t) {
                                try {
                                    this.headerTransformer.transform(e, (r, n)=>r ? t(r) : n ? n.isValid ? n.row ? this.shouldEmitRows ? this.rowTransformerValidator.transformAndValidate(n.row, t) : this.skipRow(t) : (this.rowCount -= 1, this.parsedRowCount -= 1, t(null, {
                                            row: null,
                                            isValid: !0
                                        })) : this.shouldEmitRows ? t(null, {
                                            isValid: !1,
                                            row: e
                                        }) : this.skipRow(t) : t(new Error("Expected result from header transform")));
                                } catch (e) {
                                    t(e);
                                }
                            }
                            checkAndEmitHeaders() {
                                !this.headersEmitted && this.headerTransformer.headers && (this.headersEmitted = !0, this.emit("headers", this.headerTransformer.headers));
                            }
                            skipRow(e) {
                                return this.rowCount -= 1, e(null, {
                                    row: null,
                                    isValid: !0
                                });
                            }
                            pushRow(e, t) {
                                try {
                                    this.parserOptions.objectMode ? this.push(e) : this.push(JSON.stringify(e)), t();
                                } catch (e) {
                                    t(e);
                                }
                            }
                            static wrapDoneCallback(e) {
                                let t = !1;
                                return function(r) {
                                    if (r) {
                                        if (t) throw r;
                                        return t = !0, void e(r);
                                    }
                                    for(var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)i[s - 1] = arguments[s];
                                    e(...i);
                                };
                            }
                        }
                        r.CsvParserStream = a;
                    }).call(this);
                }).call(this, e("timers").setImmediate);
            },
            {
                "./parser": 165,
                "./transforms": 168,
                stream: 505,
                string_decoder: 218,
                timers: 523
            }
        ],
        154: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ParserOptions = void 0;
                const i = n(e("lodash.escaperegexp")), s = n(e("lodash.isnil"));
                r.ParserOptions = class {
                    constructor(e){
                        var t;
                        if (this.objectMode = !0, this.delimiter = ",", this.ignoreEmpty = !1, this.quote = '"', this.escape = null, this.escapeChar = this.quote, this.comment = null, this.supportsComments = !1, this.ltrim = !1, this.rtrim = !1, this.trim = !1, this.headers = null, this.renameHeaders = !1, this.strictColumnHandling = !1, this.discardUnmappedColumns = !1, this.carriageReturn = "\r", this.encoding = "utf8", this.limitRows = !1, this.maxRows = 0, this.skipLines = 0, this.skipRows = 0, Object.assign(this, e || {}), this.delimiter.length > 1) throw new Error("delimiter option must be one character long");
                        this.escapedDelimiter = i.default(this.delimiter), this.escapeChar = null !== (t = this.escape) && void 0 !== t ? t : this.quote, this.supportsComments = !s.default(this.comment), this.NEXT_TOKEN_REGEXP = new RegExp(`([^\\s]|\\r\\n|\\n|\\r|${this.escapedDelimiter})`), this.maxRows > 0 && (this.limitRows = !0);
                    }
                };
            },
            {
                "lodash.escaperegexp": 442,
                "lodash.isnil": 447
            }
        ],
        155: [
            function(e, t, r) {
                "use strict";
                var n = Object.create ? function(e, t, r, n) {
                    void 0 === n && (n = r), Object.defineProperty(e, n, {
                        enumerable: !0,
                        get: function() {
                            return t[r];
                        }
                    });
                } : function(e, t, r, n) {
                    void 0 === n && (n = r), e[n] = t[r];
                }, i = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                }, s = function(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for(var r in e)"default" !== r && Object.prototype.hasOwnProperty.call(e, r) && n(t, e, r);
                    return i(t, e), t;
                }, o = function(e, t) {
                    for(var r in e)"default" === r || Object.prototype.hasOwnProperty.call(t, r) || n(t, e, r);
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.parseString = r.parseFile = r.parseStream = r.parse = r.ParserOptions = r.CsvParserStream = void 0;
                const a = s(e("fs")), l = e("stream"), c = e("./ParserOptions"), u = e("./CsvParserStream");
                o(e("./types"), r);
                var h = e("./CsvParserStream");
                Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return h.CsvParserStream;
                    }
                });
                var f = e("./ParserOptions");
                Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return f.ParserOptions;
                    }
                }), r.parse = (e)=>new u.CsvParserStream(new c.ParserOptions(e)), r.parseStream = (e, t)=>e.pipe(new u.CsvParserStream(new c.ParserOptions(t))), r.parseFile = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    return a.createReadStream(e).pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                }, r.parseString = (e, t)=>{
                    const r = new l.Readable;
                    return r.push(e), r.push(null), r.pipe(new u.CsvParserStream(new c.ParserOptions(t)));
                };
            },
            {
                "./CsvParserStream": 153,
                "./ParserOptions": 154,
                "./types": 169,
                fs: 216,
                stream: 505
            }
        ],
        156: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Parser = void 0;
                const n = e("./Scanner"), i = e("./RowParser"), s = e("./Token");
                class o {
                    constructor(e){
                        this.parserOptions = e, this.rowParser = new i.RowParser(this.parserOptions);
                    }
                    static removeBOM(e) {
                        return e && 65279 === e.charCodeAt(0) ? e.slice(1) : e;
                    }
                    parse(e, t) {
                        const r = new n.Scanner({
                            line: o.removeBOM(e),
                            parserOptions: this.parserOptions,
                            hasMoreData: t
                        });
                        return this.parserOptions.supportsComments ? this.parseWithComments(r) : this.parseWithoutComments(r);
                    }
                    parseWithoutComments(e) {
                        const t = [];
                        let r = !0;
                        for(; r;)r = this.parseRow(e, t);
                        return {
                            line: e.line,
                            rows: t
                        };
                    }
                    parseWithComments(e) {
                        const { parserOptions: t } = this, r = [];
                        for(let n = e.nextCharacterToken; null !== n; n = e.nextCharacterToken)if (s.Token.isTokenComment(n, t)) {
                            if (null === e.advancePastLine()) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            if (!e.hasMoreCharacters) return {
                                line: e.lineFromCursor,
                                rows: r
                            };
                            e.truncateToCursor();
                        } else if (!this.parseRow(e, r)) break;
                        return {
                            line: e.line,
                            rows: r
                        };
                    }
                    parseRow(e, t) {
                        if (!e.nextNonSpaceToken) return !1;
                        const r = this.rowParser.parse(e);
                        return null !== r && (this.parserOptions.ignoreEmpty && i.RowParser.isEmptyRow(r) || t.push(r), !0);
                    }
                }
                r.Parser = o;
            },
            {
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159
            }
        ],
        157: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowParser = void 0;
                const n = e("./column"), i = e("./Token");
                r.RowParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnParser = new n.ColumnParser(e);
                    }
                    static isEmptyRow(e) {
                        return "" === e.join("").replace(/\s+/g, "");
                    }
                    parse(e) {
                        const { parserOptions: t } = this, { hasMoreData: r } = e, n = e, s = [];
                        let o = this.getStartToken(n, s);
                        for(; o;){
                            if (i.Token.isTokenRowDelimiter(o)) return n.advancePastToken(o), !n.hasMoreCharacters && i.Token.isTokenCarriageReturn(o, t) && r ? null : (n.truncateToCursor(), s);
                            if (!this.shouldSkipColumnParse(n, o, s)) {
                                const e = this.columnParser.parse(n);
                                if (null === e) return null;
                                s.push(e);
                            }
                            o = n.nextNonSpaceToken;
                        }
                        return r ? null : (n.truncateToCursor(), s);
                    }
                    getStartToken(e, t) {
                        const r = e.nextNonSpaceToken;
                        return null !== r && i.Token.isTokenDelimiter(r, this.parserOptions) ? (t.push(""), e.nextNonSpaceToken) : r;
                    }
                    shouldSkipColumnParse(e, t, r) {
                        const { parserOptions: n } = this;
                        if (i.Token.isTokenDelimiter(t, n)) {
                            e.advancePastToken(t);
                            const s = e.nextCharacterToken;
                            if (!e.hasMoreCharacters || null !== s && i.Token.isTokenRowDelimiter(s)) return r.push(""), !0;
                            if (null !== s && i.Token.isTokenDelimiter(s, n)) return r.push(""), !0;
                        }
                        return !1;
                    }
                };
            },
            {
                "./Token": 159,
                "./column": 164
            }
        ],
        158: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Scanner = void 0;
                const n = e("./Token"), i = /((?:\r\n)|\n|\r)/;
                r.Scanner = class {
                    constructor(e){
                        this.cursor = 0, this.line = e.line, this.lineLength = this.line.length, this.parserOptions = e.parserOptions, this.hasMoreData = e.hasMoreData, this.cursor = e.cursor || 0;
                    }
                    get hasMoreCharacters() {
                        return this.lineLength > this.cursor;
                    }
                    get nextNonSpaceToken() {
                        const { lineFromCursor: e } = this, t = this.parserOptions.NEXT_TOKEN_REGEXP;
                        if (-1 === e.search(t)) return null;
                        const r = t.exec(e);
                        if (null == r) return null;
                        const i = r[1], s = this.cursor + (r.index || 0);
                        return new n.Token({
                            token: i,
                            startCursor: s,
                            endCursor: s + i.length - 1
                        });
                    }
                    get nextCharacterToken() {
                        const { cursor: e, lineLength: t } = this;
                        return t <= e ? null : new n.Token({
                            token: this.line[e],
                            startCursor: e,
                            endCursor: e
                        });
                    }
                    get lineFromCursor() {
                        return this.line.substr(this.cursor);
                    }
                    advancePastLine() {
                        const e = i.exec(this.lineFromCursor);
                        return e ? (this.cursor += (e.index || 0) + e[0].length, this) : this.hasMoreData ? null : (this.cursor = this.lineLength, this);
                    }
                    advanceTo(e) {
                        return this.cursor = e, this;
                    }
                    advanceToToken(e) {
                        return this.cursor = e.startCursor, this;
                    }
                    advancePastToken(e) {
                        return this.cursor = e.endCursor + 1, this;
                    }
                    truncateToCursor() {
                        return this.line = this.lineFromCursor, this.lineLength = this.line.length, this.cursor = 0, this;
                    }
                };
            },
            {
                "./Token": 159
            }
        ],
        159: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.Token = void 0;
                r.Token = class {
                    constructor(e){
                        this.token = e.token, this.startCursor = e.startCursor, this.endCursor = e.endCursor;
                    }
                    static isTokenRowDelimiter(e) {
                        const t = e.token;
                        return "\r" === t || "\n" === t || "\r\n" === t;
                    }
                    static isTokenCarriageReturn(e, t) {
                        return e.token === t.carriageReturn;
                    }
                    static isTokenComment(e, t) {
                        return t.supportsComments && !!e && e.token === t.comment;
                    }
                    static isTokenEscapeCharacter(e, t) {
                        return e.token === t.escapeChar;
                    }
                    static isTokenQuote(e, t) {
                        return e.token === t.quote;
                    }
                    static isTokenDelimiter(e, t) {
                        return e.token === t.delimiter;
                    }
                };
            },
            {}
        ],
        160: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = void 0;
                r.ColumnFormatter = class {
                    constructor(e){
                        e.trim ? this.format = (e)=>e.trim() : e.ltrim ? this.format = (e)=>e.trimLeft() : e.rtrim ? this.format = (e)=>e.trimRight() : this.format = (e)=>e;
                    }
                };
            },
            {}
        ],
        161: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnParser = void 0;
                const n = e("./NonQuotedColumnParser"), i = e("./QuotedColumnParser"), s = e("../Token");
                r.ColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.quotedColumnParser = new i.QuotedColumnParser(e), this.nonQuotedColumnParser = new n.NonQuotedColumnParser(e);
                    }
                    parse(e) {
                        const { nextNonSpaceToken: t } = e;
                        return null !== t && s.Token.isTokenQuote(t, this.parserOptions) ? (e.advanceToToken(t), this.quotedColumnParser.parse(e)) : this.nonQuotedColumnParser.parse(e);
                    }
                };
            },
            {
                "../Token": 159,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        162: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NonQuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.NonQuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const { parserOptions: t } = this, r = [];
                        let n = e.nextCharacterToken;
                        for(; n && !i.Token.isTokenDelimiter(n, t) && !i.Token.isTokenRowDelimiter(n); n = e.nextCharacterToken)r.push(n.token), e.advancePastToken(n);
                        return this.columnFormatter.format(r.join(""));
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        163: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = void 0;
                const n = e("./ColumnFormatter"), i = e("../Token");
                r.QuotedColumnParser = class {
                    constructor(e){
                        this.parserOptions = e, this.columnFormatter = new n.ColumnFormatter(e);
                    }
                    parse(e) {
                        if (!e.hasMoreCharacters) return null;
                        const t = e.cursor, { foundClosingQuote: r, col: n } = this.gatherDataBetweenQuotes(e);
                        if (!r) {
                            if (e.advanceTo(t), !e.hasMoreData) throw new Error(`Parse Error: missing closing: '${this.parserOptions.quote || ""}' in line: at '${e.lineFromCursor.replace(/[\r\n]/g, "\\n'")}'`);
                            return null;
                        }
                        return this.checkForMalformedColumn(e), n;
                    }
                    gatherDataBetweenQuotes(e) {
                        const { parserOptions: t } = this;
                        let r = !1, n = !1;
                        const s = [];
                        let o = e.nextCharacterToken;
                        for(; !n && null !== o; o = e.nextCharacterToken){
                            const a = i.Token.isTokenQuote(o, t);
                            if (!r && a) r = !0;
                            else if (r) {
                                if (i.Token.isTokenEscapeCharacter(o, t)) {
                                    e.advancePastToken(o);
                                    const r = e.nextCharacterToken;
                                    null !== r && (i.Token.isTokenQuote(r, t) || i.Token.isTokenEscapeCharacter(r, t)) ? (s.push(r.token), o = r) : a ? n = !0 : s.push(o.token);
                                } else a ? n = !0 : s.push(o.token);
                            }
                            e.advancePastToken(o);
                        }
                        return {
                            col: this.columnFormatter.format(s.join("")),
                            foundClosingQuote: n
                        };
                    }
                    checkForMalformedColumn(e) {
                        const { parserOptions: t } = this, { nextNonSpaceToken: r } = e;
                        if (r) {
                            const n = i.Token.isTokenDelimiter(r, t), s = i.Token.isTokenRowDelimiter(r);
                            if (!n && !s) {
                                const n = e.lineFromCursor.substr(0, 10).replace(/[\r\n]/g, "\\n'");
                                throw new Error(`Parse Error: expected: '${t.escapedDelimiter}' OR new line got: '${r.token}'. at '${n}`);
                            }
                            e.advanceToToken(r);
                        } else e.hasMoreData || e.advancePastLine();
                    }
                };
            },
            {
                "../Token": 159,
                "./ColumnFormatter": 160
            }
        ],
        164: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.ColumnFormatter = r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = void 0;
                var n = e("./ColumnParser");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return n.ColumnParser;
                    }
                });
                var i = e("./NonQuotedColumnParser");
                Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return i.NonQuotedColumnParser;
                    }
                });
                var s = e("./QuotedColumnParser");
                Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return s.QuotedColumnParser;
                    }
                });
                var o = e("./ColumnFormatter");
                Object.defineProperty(r, "ColumnFormatter", {
                    enumerable: !0,
                    get: function() {
                        return o.ColumnFormatter;
                    }
                });
            },
            {
                "./ColumnFormatter": 160,
                "./ColumnParser": 161,
                "./NonQuotedColumnParser": 162,
                "./QuotedColumnParser": 163
            }
        ],
        165: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.QuotedColumnParser = r.NonQuotedColumnParser = r.ColumnParser = r.Token = r.Scanner = r.RowParser = r.Parser = void 0;
                var n = e("./Parser");
                Object.defineProperty(r, "Parser", {
                    enumerable: !0,
                    get: function() {
                        return n.Parser;
                    }
                });
                var i = e("./RowParser");
                Object.defineProperty(r, "RowParser", {
                    enumerable: !0,
                    get: function() {
                        return i.RowParser;
                    }
                });
                var s = e("./Scanner");
                Object.defineProperty(r, "Scanner", {
                    enumerable: !0,
                    get: function() {
                        return s.Scanner;
                    }
                });
                var o = e("./Token");
                Object.defineProperty(r, "Token", {
                    enumerable: !0,
                    get: function() {
                        return o.Token;
                    }
                });
                var a = e("./column");
                Object.defineProperty(r, "ColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.ColumnParser;
                    }
                }), Object.defineProperty(r, "NonQuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.NonQuotedColumnParser;
                    }
                }), Object.defineProperty(r, "QuotedColumnParser", {
                    enumerable: !0,
                    get: function() {
                        return a.QuotedColumnParser;
                    }
                });
            },
            {
                "./Parser": 156,
                "./RowParser": 157,
                "./Scanner": 158,
                "./Token": 159,
                "./column": 164
            }
        ],
        166: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = void 0;
                const i = n(e("lodash.isundefined")), s = n(e("lodash.isfunction")), o = n(e("lodash.uniq")), a = n(e("lodash.groupby"));
                r.HeaderTransformer = class {
                    constructor(e){
                        this.headers = null, this.receivedHeaders = !1, this.shouldUseFirstRow = !1, this.processedFirstRow = !1, this.headersLength = 0, this.parserOptions = e, !0 === e.headers ? this.shouldUseFirstRow = !0 : Array.isArray(e.headers) ? this.setHeaders(e.headers) : s.default(e.headers) && (this.headersTransform = e.headers);
                    }
                    transform(e, t) {
                        return this.shouldMapRow(e) ? t(null, this.processRow(e)) : t(null, {
                            row: null,
                            isValid: !0
                        });
                    }
                    shouldMapRow(e) {
                        const { parserOptions: t } = this;
                        if (!this.headersTransform && t.renameHeaders && !this.processedFirstRow) {
                            if (!this.receivedHeaders) throw new Error("Error renaming headers: new headers must be provided in an array");
                            return this.processedFirstRow = !0, !1;
                        }
                        if (!this.receivedHeaders && Array.isArray(e)) {
                            if (this.headersTransform) this.setHeaders(this.headersTransform(e));
                            else {
                                if (!this.shouldUseFirstRow) return !0;
                                this.setHeaders(e);
                            }
                            return !1;
                        }
                        return !0;
                    }
                    processRow(e) {
                        if (!this.headers) return {
                            row: e,
                            isValid: !0
                        };
                        const { parserOptions: t } = this;
                        if (!t.discardUnmappedColumns && e.length > this.headersLength) {
                            if (!t.strictColumnHandling) throw new Error(`Unexpected Error: column header mismatch expected: ${this.headersLength} columns got: ${e.length}`);
                            return {
                                row: e,
                                isValid: !1,
                                reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                            };
                        }
                        return t.strictColumnHandling && e.length < this.headersLength ? {
                            row: e,
                            isValid: !1,
                            reason: `Column header mismatch expected: ${this.headersLength} columns got: ${e.length}`
                        } : {
                            row: this.mapHeaders(e),
                            isValid: !0
                        };
                    }
                    mapHeaders(e) {
                        const t = {}, { headers: r, headersLength: n } = this;
                        for(let s = 0; s < n; s += 1){
                            const n = r[s];
                            if (!i.default(n)) {
                                const r = e[s];
                                i.default(r) ? t[n] = "" : t[n] = r;
                            }
                        }
                        return t;
                    }
                    setHeaders(e) {
                        var t;
                        const r = e.filter((e)=>!!e);
                        if (o.default(r).length !== r.length) {
                            const e = a.default(r), t = Object.keys(e).filter((t)=>e[t].length > 1);
                            throw new Error("Duplicate headers found " + JSON.stringify(t));
                        }
                        this.headers = e, this.receivedHeaders = !0, this.headersLength = (null === (t = this.headers) || void 0 === t ? void 0 : t.length) || 0;
                    }
                };
            },
            {
                "lodash.groupby": 443,
                "lodash.isfunction": 446,
                "lodash.isundefined": 448,
                "lodash.uniq": 449
            }
        ],
        167: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                };
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.RowTransformerValidator = void 0;
                const i = n(e("lodash.isfunction")), s = e("../types");
                class o {
                    constructor(){
                        this._rowTransform = null, this._rowValidator = null;
                    }
                    static createTransform(e) {
                        return s.isSyncTransform(e) ? (t, r)=>{
                            let n = null;
                            try {
                                n = e(t);
                            } catch (e) {
                                return r(e);
                            }
                            return r(null, n);
                        } : e;
                    }
                    static createValidator(e) {
                        return s.isSyncValidate(e) ? (t, r)=>{
                            r(null, {
                                row: t,
                                isValid: e(t)
                            });
                        } : (t, r)=>{
                            e(t, (e, n, i)=>e ? r(e) : r(null, n ? {
                                    row: t,
                                    isValid: n,
                                    reason: i
                                } : {
                                    row: t,
                                    isValid: !1,
                                    reason: i
                                }));
                        };
                    }
                    set rowTransform(e) {
                        if (!i.default(e)) throw new TypeError("The transform should be a function");
                        this._rowTransform = o.createTransform(e);
                    }
                    set rowValidator(e) {
                        if (!i.default(e)) throw new TypeError("The validate should be a function");
                        this._rowValidator = o.createValidator(e);
                    }
                    transformAndValidate(e, t) {
                        return this.callTransformer(e, (e, r)=>e ? t(e) : r ? this.callValidator(r, (e, n)=>e ? t(e) : n && !n.isValid ? t(null, {
                                    row: r,
                                    isValid: !1,
                                    reason: n.reason
                                }) : t(null, {
                                    row: r,
                                    isValid: !0
                                })) : t(null, {
                                row: null,
                                isValid: !0
                            }));
                    }
                    callTransformer(e, t) {
                        return this._rowTransform ? this._rowTransform(e, t) : t(null, e);
                    }
                    callValidator(e, t) {
                        return this._rowValidator ? this._rowValidator(e, t) : t(null, {
                            row: e,
                            isValid: !0
                        });
                    }
                }
                r.RowTransformerValidator = o;
            },
            {
                "../types": 169,
                "lodash.isfunction": 446
            }
        ],
        168: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.HeaderTransformer = r.RowTransformerValidator = void 0;
                var n = e("./RowTransformerValidator");
                Object.defineProperty(r, "RowTransformerValidator", {
                    enumerable: !0,
                    get: function() {
                        return n.RowTransformerValidator;
                    }
                });
                var i = e("./HeaderTransformer");
                Object.defineProperty(r, "HeaderTransformer", {
                    enumerable: !0,
                    get: function() {
                        return i.HeaderTransformer;
                    }
                });
            },
            {
                "./HeaderTransformer": 166,
                "./RowTransformerValidator": 167
            }
        ],
        169: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.isSyncValidate = r.isSyncTransform = void 0, r.isSyncTransform = (e)=>1 === e.length, r.isSyncValidate = (e)=>1 === e.length;
            },
            {}
        ],
        170: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.bignum = e("bn.js"), n.define = e("./asn1/api").define, n.base = e("./asn1/base"), n.constants = e("./asn1/constants"), n.decoders = e("./asn1/decoders"), n.encoders = e("./asn1/encoders");
            },
            {
                "./asn1/api": 171,
                "./asn1/base": 173,
                "./asn1/constants": 177,
                "./asn1/decoders": 179,
                "./asn1/encoders": 182,
                "bn.js": 184
            }
        ],
        171: [
            function(e, t, r) {
                "use strict";
                const n = e("./encoders"), i = e("./decoders"), s = e("inherits");
                function o(e, t) {
                    this.name = e, this.body = t, this.decoders = {}, this.encoders = {};
                }
                r.define = function(e, t) {
                    return new o(e, t);
                }, o.prototype._createNamed = function(e) {
                    const t = this.name;
                    function r(e) {
                        this._initNamed(e, t);
                    }
                    return s(r, e), r.prototype._initNamed = function(t, r) {
                        e.call(this, t, r);
                    }, new r(this);
                }, o.prototype._getDecoder = function(e) {
                    return e = e || "der", this.decoders.hasOwnProperty(e) || (this.decoders[e] = this._createNamed(i[e])), this.decoders[e];
                }, o.prototype.decode = function(e, t, r) {
                    return this._getDecoder(t).decode(e, r);
                }, o.prototype._getEncoder = function(e) {
                    return e = e || "der", this.encoders.hasOwnProperty(e) || (this.encoders[e] = this._createNamed(n[e])), this.encoders[e];
                }, o.prototype.encode = function(e, t, r) {
                    return this._getEncoder(t).encode(e, r);
                };
            },
            {
                "./decoders": 179,
                "./encoders": 182,
                inherits: 440
            }
        ],
        172: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("../base/reporter").Reporter, s = e("safer-buffer").Buffer;
                function o(e, t) {
                    i.call(this, t), s.isBuffer(e) ? (this.base = e, this.offset = 0, this.length = e.length) : this.error("Input not Buffer");
                }
                function a(e, t) {
                    if (Array.isArray(e)) this.length = 0, this.value = e.map(function(e) {
                        return a.isEncoderBuffer(e) || (e = new a(e, t)), this.length += e.length, e;
                    }, this);
                    else if ("number" == typeof e) {
                        if (!(0 <= e && e <= 255)) return t.error("non-byte EncoderBuffer value");
                        this.value = e, this.length = 1;
                    } else if ("string" == typeof e) this.value = e, this.length = s.byteLength(e);
                    else {
                        if (!s.isBuffer(e)) return t.error("Unsupported type: " + typeof e);
                        this.value = e, this.length = e.length;
                    }
                }
                n(o, i), r.DecoderBuffer = o, o.isDecoderBuffer = function(e) {
                    if (e instanceof o) return !0;
                    return "object" == typeof e && s.isBuffer(e.base) && "DecoderBuffer" === e.constructor.name && "number" == typeof e.offset && "number" == typeof e.length && "function" == typeof e.save && "function" == typeof e.restore && "function" == typeof e.isEmpty && "function" == typeof e.readUInt8 && "function" == typeof e.skip && "function" == typeof e.raw;
                }, o.prototype.save = function() {
                    return {
                        offset: this.offset,
                        reporter: i.prototype.save.call(this)
                    };
                }, o.prototype.restore = function(e) {
                    const t = new o(this.base);
                    return t.offset = e.offset, t.length = this.offset, this.offset = e.offset, i.prototype.restore.call(this, e.reporter), t;
                }, o.prototype.isEmpty = function() {
                    return this.offset === this.length;
                }, o.prototype.readUInt8 = function(e) {
                    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(e || "DecoderBuffer overrun");
                }, o.prototype.skip = function(e, t) {
                    if (!(this.offset + e <= this.length)) return this.error(t || "DecoderBuffer overrun");
                    const r = new o(this.base);
                    return r._reporterState = this._reporterState, r.offset = this.offset, r.length = this.offset + e, this.offset += e, r;
                }, o.prototype.raw = function(e) {
                    return this.base.slice(e ? e.offset : this.offset, this.length);
                }, r.EncoderBuffer = a, a.isEncoderBuffer = function(e) {
                    if (e instanceof a) return !0;
                    return "object" == typeof e && "EncoderBuffer" === e.constructor.name && "number" == typeof e.length && "function" == typeof e.join;
                }, a.prototype.join = function(e, t) {
                    return e || (e = s.alloc(this.length)), t || (t = 0), 0 === this.length || (Array.isArray(this.value) ? this.value.forEach(function(r) {
                        r.join(e, t), t += r.length;
                    }) : ("number" == typeof this.value ? e[t] = this.value : "string" == typeof this.value ? e.write(this.value, t) : s.isBuffer(this.value) && this.value.copy(e, t), t += this.length)), e;
                };
            },
            {
                "../base/reporter": 175,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        173: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.Reporter = e("./reporter").Reporter, n.DecoderBuffer = e("./buffer").DecoderBuffer, n.EncoderBuffer = e("./buffer").EncoderBuffer, n.Node = e("./node");
            },
            {
                "./buffer": 172,
                "./node": 174,
                "./reporter": 175
            }
        ],
        174: [
            function(e, t, r) {
                "use strict";
                const n = e("../base/reporter").Reporter, i = e("../base/buffer").EncoderBuffer, s = e("../base/buffer").DecoderBuffer, o = e("minimalistic-assert"), a = [
                    "seq",
                    "seqof",
                    "set",
                    "setof",
                    "objid",
                    "bool",
                    "gentime",
                    "utctime",
                    "null_",
                    "enum",
                    "int",
                    "objDesc",
                    "bitstr",
                    "bmpstr",
                    "charstr",
                    "genstr",
                    "graphstr",
                    "ia5str",
                    "iso646str",
                    "numstr",
                    "octstr",
                    "printstr",
                    "t61str",
                    "unistr",
                    "utf8str",
                    "videostr"
                ], l = [
                    "key",
                    "obj",
                    "use",
                    "optional",
                    "explicit",
                    "implicit",
                    "def",
                    "choice",
                    "any",
                    "contains"
                ].concat(a);
                function c(e, t, r) {
                    const n = {};
                    this._baseState = n, n.name = r, n.enc = e, n.parent = t || null, n.children = null, n.tag = null, n.args = null, n.reverseArgs = null, n.choice = null, n.optional = !1, n.any = !1, n.obj = !1, n.use = null, n.useDecoder = null, n.key = null, n.default = null, n.explicit = null, n.implicit = null, n.contains = null, n.parent || (n.children = [], this._wrap());
                }
                t.exports = c;
                const u = [
                    "enc",
                    "parent",
                    "children",
                    "tag",
                    "args",
                    "reverseArgs",
                    "choice",
                    "optional",
                    "any",
                    "obj",
                    "use",
                    "alteredUse",
                    "key",
                    "default",
                    "explicit",
                    "implicit",
                    "contains"
                ];
                c.prototype.clone = function() {
                    const e = this._baseState, t = {};
                    u.forEach(function(r) {
                        t[r] = e[r];
                    });
                    const r = new this.constructor(t.parent);
                    return r._baseState = t, r;
                }, c.prototype._wrap = function() {
                    const e = this._baseState;
                    l.forEach(function(t) {
                        this[t] = function() {
                            const r = new this.constructor(this);
                            return e.children.push(r), r[t].apply(r, arguments);
                        };
                    }, this);
                }, c.prototype._init = function(e) {
                    const t = this._baseState;
                    o(null === t.parent), e.call(this), t.children = t.children.filter(function(e) {
                        return e._baseState.parent === this;
                    }, this), o.equal(t.children.length, 1, "Root node can have only one child");
                }, c.prototype._useArgs = function(e) {
                    const t = this._baseState, r = e.filter(function(e) {
                        return e instanceof this.constructor;
                    }, this);
                    e = e.filter(function(e) {
                        return !(e instanceof this.constructor);
                    }, this), 0 !== r.length && (o(null === t.children), t.children = r, r.forEach(function(e) {
                        e._baseState.parent = this;
                    }, this)), 0 !== e.length && (o(null === t.args), t.args = e, t.reverseArgs = e.map(function(e) {
                        if ("object" != typeof e || e.constructor !== Object) return e;
                        const t = {};
                        return Object.keys(e).forEach(function(r) {
                            r == (0 | r) && (r |= 0);
                            const n = e[r];
                            t[n] = r;
                        }), t;
                    }));
                }, [
                    "_peekTag",
                    "_decodeTag",
                    "_use",
                    "_decodeStr",
                    "_decodeObjid",
                    "_decodeTime",
                    "_decodeNull",
                    "_decodeInt",
                    "_decodeBool",
                    "_decodeList",
                    "_encodeComposite",
                    "_encodeStr",
                    "_encodeObjid",
                    "_encodeTime",
                    "_encodeNull",
                    "_encodeInt",
                    "_encodeBool"
                ].forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState;
                        throw new Error(e + " not implemented for encoding: " + t.enc);
                    };
                }), a.forEach(function(e) {
                    c.prototype[e] = function() {
                        const t = this._baseState, r = Array.prototype.slice.call(arguments);
                        return o(null === t.tag), t.tag = e, this._useArgs(r), this;
                    };
                }), c.prototype.use = function(e) {
                    o(e);
                    const t = this._baseState;
                    return o(null === t.use), t.use = e, this;
                }, c.prototype.optional = function() {
                    return this._baseState.optional = !0, this;
                }, c.prototype.def = function(e) {
                    const t = this._baseState;
                    return o(null === t.default), t.default = e, t.optional = !0, this;
                }, c.prototype.explicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.explicit = e, this;
                }, c.prototype.implicit = function(e) {
                    const t = this._baseState;
                    return o(null === t.explicit && null === t.implicit), t.implicit = e, this;
                }, c.prototype.obj = function() {
                    const e = this._baseState, t = Array.prototype.slice.call(arguments);
                    return e.obj = !0, 0 !== t.length && this._useArgs(t), this;
                }, c.prototype.key = function(e) {
                    const t = this._baseState;
                    return o(null === t.key), t.key = e, this;
                }, c.prototype.any = function() {
                    return this._baseState.any = !0, this;
                }, c.prototype.choice = function(e) {
                    const t = this._baseState;
                    return o(null === t.choice), t.choice = e, this._useArgs(Object.keys(e).map(function(t) {
                        return e[t];
                    })), this;
                }, c.prototype.contains = function(e) {
                    const t = this._baseState;
                    return o(null === t.use), t.contains = e, this;
                }, c.prototype._decode = function(e, t) {
                    const r = this._baseState;
                    if (null === r.parent) return e.wrapResult(r.children[0]._decode(e, t));
                    let n, i = r.default, o = !0, a = null;
                    if (null !== r.key && (a = e.enterKey(r.key)), r.optional) {
                        let n = null;
                        if (null !== r.explicit ? n = r.explicit : null !== r.implicit ? n = r.implicit : null !== r.tag && (n = r.tag), null !== n || r.any) {
                            if (o = this._peekTag(e, n, r.any), e.isError(o)) return o;
                        } else {
                            const n = e.save();
                            try {
                                null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t), o = !0;
                            } catch (e) {
                                o = !1;
                            }
                            e.restore(n);
                        }
                    }
                    if (r.obj && o && (n = e.enterObject()), o) {
                        if (null !== r.explicit) {
                            const t = this._decodeTag(e, r.explicit);
                            if (e.isError(t)) return t;
                            e = t;
                        }
                        const n = e.offset;
                        if (null === r.use && null === r.choice) {
                            let t;
                            r.any && (t = e.save());
                            const n = this._decodeTag(e, null !== r.implicit ? r.implicit : r.tag, r.any);
                            if (e.isError(n)) return n;
                            r.any ? i = e.raw(t) : e = n;
                        }
                        if (t && t.track && null !== r.tag && t.track(e.path(), n, e.length, "tagged"), t && t.track && null !== r.tag && t.track(e.path(), e.offset, e.length, "content"), r.any || (i = null === r.choice ? this._decodeGeneric(r.tag, e, t) : this._decodeChoice(e, t)), e.isError(i)) return i;
                        if (r.any || null !== r.choice || null === r.children || r.children.forEach(function(r) {
                            r._decode(e, t);
                        }), r.contains && ("octstr" === r.tag || "bitstr" === r.tag)) {
                            const n = new s(i);
                            i = this._getUse(r.contains, e._reporterState.obj)._decode(n, t);
                        }
                    }
                    return r.obj && o && (i = e.leaveObject(n)), null === r.key || null === i && !0 !== o ? null !== a && e.exitKey(a) : e.leaveKey(a, r.key, i), i;
                }, c.prototype._decodeGeneric = function(e, t, r) {
                    const n = this._baseState;
                    return "seq" === e || "set" === e ? null : "seqof" === e || "setof" === e ? this._decodeList(t, e, n.args[0], r) : /str$/.test(e) ? this._decodeStr(t, e, r) : "objid" === e && n.args ? this._decodeObjid(t, n.args[0], n.args[1], r) : "objid" === e ? this._decodeObjid(t, null, null, r) : "gentime" === e || "utctime" === e ? this._decodeTime(t, e, r) : "null_" === e ? this._decodeNull(t, r) : "bool" === e ? this._decodeBool(t, r) : "objDesc" === e ? this._decodeStr(t, e, r) : "int" === e || "enum" === e ? this._decodeInt(t, n.args && n.args[0], r) : null !== n.use ? this._getUse(n.use, t._reporterState.obj)._decode(t, r) : t.error("unknown tag: " + e);
                }, c.prototype._getUse = function(e, t) {
                    const r = this._baseState;
                    return r.useDecoder = this._use(e, t), o(null === r.useDecoder._baseState.parent), r.useDecoder = r.useDecoder._baseState.children[0], r.implicit !== r.useDecoder._baseState.implicit && (r.useDecoder = r.useDecoder.clone(), r.useDecoder._baseState.implicit = r.implicit), r.useDecoder;
                }, c.prototype._decodeChoice = function(e, t) {
                    const r = this._baseState;
                    let n = null, i = !1;
                    return Object.keys(r.choice).some(function(s) {
                        const o = e.save(), a = r.choice[s];
                        try {
                            const r = a._decode(e, t);
                            if (e.isError(r)) return !1;
                            n = {
                                type: s,
                                value: r
                            }, i = !0;
                        } catch (t) {
                            return e.restore(o), !1;
                        }
                        return !0;
                    }, this), i ? n : e.error("Choice not matched");
                }, c.prototype._createEncoderBuffer = function(e) {
                    return new i(e, this.reporter);
                }, c.prototype._encode = function(e, t, r) {
                    const n = this._baseState;
                    if (null !== n.default && n.default === e) return;
                    const i = this._encodeValue(e, t, r);
                    return void 0 === i || this._skipDefault(i, t, r) ? void 0 : i;
                }, c.prototype._encodeValue = function(e, t, r) {
                    const i = this._baseState;
                    if (null === i.parent) return i.children[0]._encode(e, t || new n);
                    let s = null;
                    if (this.reporter = t, i.optional && void 0 === e) {
                        if (null === i.default) return;
                        e = i.default;
                    }
                    let o = null, a = !1;
                    if (i.any) s = this._createEncoderBuffer(e);
                    else if (i.choice) s = this._encodeChoice(e, t);
                    else if (i.contains) o = this._getUse(i.contains, r)._encode(e, t), a = !0;
                    else if (i.children) o = i.children.map(function(r) {
                        if ("null_" === r._baseState.tag) return r._encode(null, t, e);
                        if (null === r._baseState.key) return t.error("Child should have a key");
                        const n = t.enterKey(r._baseState.key);
                        if ("object" != typeof e) return t.error("Child expected, but input is not object");
                        const i = r._encode(e[r._baseState.key], t, e);
                        return t.leaveKey(n), i;
                    }, this).filter(function(e) {
                        return e;
                    }), o = this._createEncoderBuffer(o);
                    else if ("seqof" === i.tag || "setof" === i.tag) {
                        if (!i.args || 1 !== i.args.length) return t.error("Too many args for : " + i.tag);
                        if (!Array.isArray(e)) return t.error("seqof/setof, but data is not Array");
                        const r = this.clone();
                        r._baseState.implicit = null, o = this._createEncoderBuffer(e.map(function(r) {
                            const n = this._baseState;
                            return this._getUse(n.args[0], e)._encode(r, t);
                        }, r));
                    } else null !== i.use ? s = this._getUse(i.use, r)._encode(e, t) : (o = this._encodePrimitive(i.tag, e), a = !0);
                    if (!i.any && null === i.choice) {
                        const e = null !== i.implicit ? i.implicit : i.tag, r = null === i.implicit ? "universal" : "context";
                        null === e ? null === i.use && t.error("Tag could be omitted only for .use()") : null === i.use && (s = this._encodeComposite(e, a, r, o));
                    }
                    return null !== i.explicit && (s = this._encodeComposite(i.explicit, !1, "context", s)), s;
                }, c.prototype._encodeChoice = function(e, t) {
                    const r = this._baseState, n = r.choice[e.type];
                    return n || o(!1, e.type + " not found in " + JSON.stringify(Object.keys(r.choice))), n._encode(e.value, t);
                }, c.prototype._encodePrimitive = function(e, t) {
                    const r = this._baseState;
                    if (/str$/.test(e)) return this._encodeStr(t, e);
                    if ("objid" === e && r.args) return this._encodeObjid(t, r.reverseArgs[0], r.args[1]);
                    if ("objid" === e) return this._encodeObjid(t, null, null);
                    if ("gentime" === e || "utctime" === e) return this._encodeTime(t, e);
                    if ("null_" === e) return this._encodeNull();
                    if ("int" === e || "enum" === e) return this._encodeInt(t, r.args && r.reverseArgs[0]);
                    if ("bool" === e) return this._encodeBool(t);
                    if ("objDesc" === e) return this._encodeStr(t, e);
                    throw new Error("Unsupported tag: " + e);
                }, c.prototype._isNumstr = function(e) {
                    return /^[0-9 ]*$/.test(e);
                }, c.prototype._isPrintstr = function(e) {
                    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e);
                };
            },
            {
                "../base/buffer": 172,
                "../base/reporter": 175,
                "minimalistic-assert": 453
            }
        ],
        175: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits");
                function i(e) {
                    this._reporterState = {
                        obj: null,
                        path: [],
                        options: e || {},
                        errors: []
                    };
                }
                function s(e, t) {
                    this.path = e, this.rethrow(t);
                }
                r.Reporter = i, i.prototype.isError = function(e) {
                    return e instanceof s;
                }, i.prototype.save = function() {
                    const e = this._reporterState;
                    return {
                        obj: e.obj,
                        pathLen: e.path.length
                    };
                }, i.prototype.restore = function(e) {
                    const t = this._reporterState;
                    t.obj = e.obj, t.path = t.path.slice(0, e.pathLen);
                }, i.prototype.enterKey = function(e) {
                    return this._reporterState.path.push(e);
                }, i.prototype.exitKey = function(e) {
                    const t = this._reporterState;
                    t.path = t.path.slice(0, e - 1);
                }, i.prototype.leaveKey = function(e, t, r) {
                    const n = this._reporterState;
                    this.exitKey(e), null !== n.obj && (n.obj[t] = r);
                }, i.prototype.path = function() {
                    return this._reporterState.path.join("/");
                }, i.prototype.enterObject = function() {
                    const e = this._reporterState, t = e.obj;
                    return e.obj = {}, t;
                }, i.prototype.leaveObject = function(e) {
                    const t = this._reporterState, r = t.obj;
                    return t.obj = e, r;
                }, i.prototype.error = function(e) {
                    let t;
                    const r = this._reporterState, n = e instanceof s;
                    if (t = n ? e : new s(r.path.map(function(e) {
                        return "[" + JSON.stringify(e) + "]";
                    }).join(""), e.message || e, e.stack), !r.options.partial) throw t;
                    return n || r.errors.push(t), t;
                }, i.prototype.wrapResult = function(e) {
                    const t = this._reporterState;
                    return t.options.partial ? {
                        result: this.isError(e) ? null : e,
                        errors: t.errors
                    } : e;
                }, n(s, Error), s.prototype.rethrow = function(e) {
                    if (this.message = e + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, s), !this.stack) try {
                        throw new Error(this.message);
                    } catch (e) {
                        this.stack = e.stack;
                    }
                    return this;
                };
            },
            {
                inherits: 440
            }
        ],
        176: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }
                r.tagClass = {
                    0: "universal",
                    1: "application",
                    2: "context",
                    3: "private"
                }, r.tagClassByName = n(r.tagClass), r.tag = {
                    0: "end",
                    1: "bool",
                    2: "int",
                    3: "bitstr",
                    4: "octstr",
                    5: "null_",
                    6: "objid",
                    7: "objDesc",
                    8: "external",
                    9: "real",
                    10: "enum",
                    11: "embed",
                    12: "utf8str",
                    13: "relativeOid",
                    16: "seq",
                    17: "set",
                    18: "numstr",
                    19: "printstr",
                    20: "t61str",
                    21: "videostr",
                    22: "ia5str",
                    23: "utctime",
                    24: "gentime",
                    25: "graphstr",
                    26: "iso646str",
                    27: "genstr",
                    28: "unistr",
                    29: "charstr",
                    30: "bmpstr"
                }, r.tagByName = n(r.tag);
            },
            {}
        ],
        177: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n._reverse = function(e) {
                    const t = {};
                    return Object.keys(e).forEach(function(r) {
                        (0 | r) == r && (r |= 0);
                        const n = e[r];
                        t[n] = r;
                    }), t;
                }, n.der = e("./der");
            },
            {
                "./der": 176
            }
        ],
        178: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("bn.js"), s = e("../base/buffer").DecoderBuffer, o = e("../base/node"), a = e("../constants/der");
                function l(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new c, this.tree._init(e.body);
                }
                function c(e) {
                    o.call(this, "der", e);
                }
                function u(e, t) {
                    let r = e.readUInt8(t);
                    if (e.isError(r)) return r;
                    const n = a.tagClass[r >> 6], i = 0 == (32 & r);
                    if (31 == (31 & r)) {
                        let n = r;
                        for(r = 0; 128 == (128 & n);){
                            if (n = e.readUInt8(t), e.isError(n)) return n;
                            r <<= 7, r |= 127 & n;
                        }
                    } else r &= 31;
                    return {
                        cls: n,
                        primitive: i,
                        tag: r,
                        tagStr: a.tag[r]
                    };
                }
                function h(e, t, r) {
                    let n = e.readUInt8(r);
                    if (e.isError(n)) return n;
                    if (!t && 128 === n) return null;
                    if (0 == (128 & n)) return n;
                    const i = 127 & n;
                    if (i > 4) return e.error("length octect is too long");
                    n = 0;
                    for(let t = 0; t < i; t++){
                        n <<= 8;
                        const t = e.readUInt8(r);
                        if (e.isError(t)) return t;
                        n |= t;
                    }
                    return n;
                }
                t.exports = l, l.prototype.decode = function(e, t) {
                    return s.isDecoderBuffer(e) || (e = new s(e, t)), this.tree._decode(e, t);
                }, n(c, o), c.prototype._peekTag = function(e, t, r) {
                    if (e.isEmpty()) return !1;
                    const n = e.save(), i = u(e, 'Failed to peek tag: "' + t + '"');
                    return e.isError(i) ? i : (e.restore(n), i.tag === t || i.tagStr === t || i.tagStr + "of" === t || r);
                }, c.prototype._decodeTag = function(e, t, r) {
                    const n = u(e, 'Failed to decode tag of "' + t + '"');
                    if (e.isError(n)) return n;
                    let i = h(e, n.primitive, 'Failed to get length of "' + t + '"');
                    if (e.isError(i)) return i;
                    if (!r && n.tag !== t && n.tagStr !== t && n.tagStr + "of" !== t) return e.error('Failed to match tag: "' + t + '"');
                    if (n.primitive || null !== i) return e.skip(i, 'Failed to match body of: "' + t + '"');
                    const s = e.save(), o = this._skipUntilEnd(e, 'Failed to skip indefinite length body: "' + this.tag + '"');
                    return e.isError(o) ? o : (i = e.offset - s.offset, e.restore(s), e.skip(i, 'Failed to match body of: "' + t + '"'));
                }, c.prototype._skipUntilEnd = function(e, t) {
                    for(;;){
                        const r = u(e, t);
                        if (e.isError(r)) return r;
                        const n = h(e, r.primitive, t);
                        if (e.isError(n)) return n;
                        let i;
                        if (i = r.primitive || null !== n ? e.skip(n) : this._skipUntilEnd(e, t), e.isError(i)) return i;
                        if ("end" === r.tagStr) break;
                    }
                }, c.prototype._decodeList = function(e, t, r, n) {
                    const i = [];
                    for(; !e.isEmpty();){
                        const t = this._peekTag(e, "end");
                        if (e.isError(t)) return t;
                        const s = r.decode(e, "der", n);
                        if (e.isError(s) && t) break;
                        i.push(s);
                    }
                    return i;
                }, c.prototype._decodeStr = function(e, t) {
                    if ("bitstr" === t) {
                        const t = e.readUInt8();
                        return e.isError(t) ? t : {
                            unused: t,
                            data: e.raw()
                        };
                    }
                    if ("bmpstr" === t) {
                        const t = e.raw();
                        if (t.length % 2 == 1) return e.error("Decoding of string type: bmpstr length mismatch");
                        let r = "";
                        for(let e = 0; e < t.length / 2; e++)r += String.fromCharCode(t.readUInt16BE(2 * e));
                        return r;
                    }
                    if ("numstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isNumstr(t) ? t : e.error("Decoding of string type: numstr unsupported characters");
                    }
                    if ("octstr" === t) return e.raw();
                    if ("objDesc" === t) return e.raw();
                    if ("printstr" === t) {
                        const t = e.raw().toString("ascii");
                        return this._isPrintstr(t) ? t : e.error("Decoding of string type: printstr unsupported characters");
                    }
                    return /str$/.test(t) ? e.raw().toString() : e.error("Decoding of string type: " + t + " unsupported");
                }, c.prototype._decodeObjid = function(e, t, r) {
                    let n;
                    const i = [];
                    let s = 0, o = 0;
                    for(; !e.isEmpty();)o = e.readUInt8(), s <<= 7, s |= 127 & o, 0 == (128 & o) && (i.push(s), s = 0);
                    128 & o && i.push(s);
                    const a = i[0] / 40 | 0, l = i[0] % 40;
                    if (n = r ? i : [
                        a,
                        l
                    ].concat(i.slice(1)), t) {
                        let e = t[n.join(" ")];
                        void 0 === e && (e = t[n.join(".")]), void 0 !== e && (n = e);
                    }
                    return n;
                }, c.prototype._decodeTime = function(e, t) {
                    const r = e.raw().toString();
                    let n, i, s, o, a, l;
                    if ("gentime" === t) n = 0 | r.slice(0, 4), i = 0 | r.slice(4, 6), s = 0 | r.slice(6, 8), o = 0 | r.slice(8, 10), a = 0 | r.slice(10, 12), l = 0 | r.slice(12, 14);
                    else {
                        if ("utctime" !== t) return e.error("Decoding " + t + " time is not supported yet");
                        n = 0 | r.slice(0, 2), i = 0 | r.slice(2, 4), s = 0 | r.slice(4, 6), o = 0 | r.slice(6, 8), a = 0 | r.slice(8, 10), l = 0 | r.slice(10, 12), n = n < 70 ? 2e3 + n : 1900 + n;
                    }
                    return Date.UTC(n, i - 1, s, o, a, l, 0);
                }, c.prototype._decodeNull = function() {
                    return null;
                }, c.prototype._decodeBool = function(e) {
                    const t = e.readUInt8();
                    return e.isError(t) ? t : 0 !== t;
                }, c.prototype._decodeInt = function(e, t) {
                    const r = e.raw();
                    let n = new i(r);
                    return t && (n = t[n.toString(10)] || n), n;
                }, c.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getDecoder("der").tree;
                };
            },
            {
                "../base/buffer": 172,
                "../base/node": 174,
                "../constants/der": 176,
                "bn.js": 184,
                inherits: 440
            }
        ],
        179: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 178,
                "./pem": 180
            }
        ],
        180: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("./der");
                function o(e) {
                    s.call(this, e), this.enc = "pem";
                }
                n(o, s), t.exports = o, o.prototype.decode = function(e, t) {
                    const r = e.toString().split(/[\r\n]+/g), n = t.label.toUpperCase(), o = /^-----(BEGIN|END) ([^-]+)-----$/;
                    let a = -1, l = -1;
                    for(let e = 0; e < r.length; e++){
                        const t = r[e].match(o);
                        if (null !== t && t[2] === n) {
                            if (-1 !== a) {
                                if ("END" !== t[1]) break;
                                l = e;
                                break;
                            }
                            if ("BEGIN" !== t[1]) break;
                            a = e;
                        }
                    }
                    if (-1 === a || -1 === l) throw new Error("PEM section not found for: " + n);
                    const c = r.slice(a + 1, l).join("");
                    c.replace(/[^a-z0-9+/=]+/gi, "");
                    const u = i.from(c, "base64");
                    return s.prototype.decode.call(this, u, t);
                };
            },
            {
                "./der": 178,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        181: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("safer-buffer").Buffer, s = e("../base/node"), o = e("../constants/der");
                function a(e) {
                    this.enc = "der", this.name = e.name, this.entity = e, this.tree = new l, this.tree._init(e.body);
                }
                function l(e) {
                    s.call(this, "der", e);
                }
                function c(e) {
                    return e < 10 ? "0" + e : e;
                }
                t.exports = a, a.prototype.encode = function(e, t) {
                    return this.tree._encode(e, t).join();
                }, n(l, s), l.prototype._encodeComposite = function(e, t, r, n) {
                    const s = function(e, t, r, n) {
                        let i;
                        "seqof" === e ? e = "seq" : "setof" === e && (e = "set");
                        if (o.tagByName.hasOwnProperty(e)) i = o.tagByName[e];
                        else {
                            if ("number" != typeof e || (0 | e) !== e) return n.error("Unknown tag: " + e);
                            i = e;
                        }
                        if (i >= 31) return n.error("Multi-octet tag encoding unsupported");
                        t || (i |= 32);
                        return i |= o.tagClassByName[r || "universal"] << 6, i;
                    }(e, t, r, this.reporter);
                    if (n.length < 128) {
                        const e = i.alloc(2);
                        return e[0] = s, e[1] = n.length, this._createEncoderBuffer([
                            e,
                            n
                        ]);
                    }
                    let a = 1;
                    for(let e = n.length; e >= 256; e >>= 8)a++;
                    const l = i.alloc(2 + a);
                    l[0] = s, l[1] = 128 | a;
                    for(let e = 1 + a, t = n.length; t > 0; e--, t >>= 8)l[e] = 255 & t;
                    return this._createEncoderBuffer([
                        l,
                        n
                    ]);
                }, l.prototype._encodeStr = function(e, t) {
                    if ("bitstr" === t) return this._createEncoderBuffer([
                        0 | e.unused,
                        e.data
                    ]);
                    if ("bmpstr" === t) {
                        const t = i.alloc(2 * e.length);
                        for(let r = 0; r < e.length; r++)t.writeUInt16BE(e.charCodeAt(r), 2 * r);
                        return this._createEncoderBuffer(t);
                    }
                    return "numstr" === t ? this._isNumstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : "printstr" === t ? this._isPrintstr(e) ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(t) || "objDesc" === t ? this._createEncoderBuffer(e) : this.reporter.error("Encoding of string type: " + t + " unsupported");
                }, l.prototype._encodeObjid = function(e, t, r) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("string objid given, but no values map found");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("objid not found in values map");
                        e = t[e].split(/[\s.]+/g);
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    } else if (Array.isArray(e)) {
                        e = e.slice();
                        for(let t = 0; t < e.length; t++)e[t] |= 0;
                    }
                    if (!Array.isArray(e)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(e));
                    if (!r) {
                        if (e[1] >= 40) return this.reporter.error("Second objid identifier OOB");
                        e.splice(0, 2, 40 * e[0] + e[1]);
                    }
                    let n = 0;
                    for(let t = 0; t < e.length; t++){
                        let r = e[t];
                        for(n++; r >= 128; r >>= 7)n++;
                    }
                    const s = i.alloc(n);
                    let o = s.length - 1;
                    for(let t = e.length - 1; t >= 0; t--){
                        let r = e[t];
                        for(s[o--] = 127 & r; (r >>= 7) > 0;)s[o--] = 128 | 127 & r;
                    }
                    return this._createEncoderBuffer(s);
                }, l.prototype._encodeTime = function(e, t) {
                    let r;
                    const n = new Date(e);
                    return "gentime" === t ? r = [
                        c(n.getUTCFullYear()),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : "utctime" === t ? r = [
                        c(n.getUTCFullYear() % 100),
                        c(n.getUTCMonth() + 1),
                        c(n.getUTCDate()),
                        c(n.getUTCHours()),
                        c(n.getUTCMinutes()),
                        c(n.getUTCSeconds()),
                        "Z"
                    ].join("") : this.reporter.error("Encoding " + t + " time is not supported yet"), this._encodeStr(r, "octstr");
                }, l.prototype._encodeNull = function() {
                    return this._createEncoderBuffer("");
                }, l.prototype._encodeInt = function(e, t) {
                    if ("string" == typeof e) {
                        if (!t) return this.reporter.error("String int or enum given, but no values map");
                        if (!t.hasOwnProperty(e)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(e));
                        e = t[e];
                    }
                    if ("number" != typeof e && !i.isBuffer(e)) {
                        const t = e.toArray();
                        !e.sign && 128 & t[0] && t.unshift(0), e = i.from(t);
                    }
                    if (i.isBuffer(e)) {
                        let t = e.length;
                        0 === e.length && t++;
                        const r = i.alloc(t);
                        return e.copy(r), 0 === e.length && (r[0] = 0), this._createEncoderBuffer(r);
                    }
                    if (e < 128) return this._createEncoderBuffer(e);
                    if (e < 256) return this._createEncoderBuffer([
                        0,
                        e
                    ]);
                    let r = 1;
                    for(let t = e; t >= 256; t >>= 8)r++;
                    const n = new Array(r);
                    for(let t = n.length - 1; t >= 0; t--)n[t] = 255 & e, e >>= 8;
                    return 128 & n[0] && n.unshift(0), this._createEncoderBuffer(i.from(n));
                }, l.prototype._encodeBool = function(e) {
                    return this._createEncoderBuffer(e ? 255 : 0);
                }, l.prototype._use = function(e, t) {
                    return "function" == typeof e && (e = e(t)), e._getEncoder("der").tree;
                }, l.prototype._skipDefault = function(e, t, r) {
                    const n = this._baseState;
                    let i;
                    if (null === n.default) return !1;
                    const s = e.join();
                    if (void 0 === n.defaultBuffer && (n.defaultBuffer = this._encodeValue(n.default, t, r).join()), s.length !== n.defaultBuffer.length) return !1;
                    for(i = 0; i < s.length; i++)if (s[i] !== n.defaultBuffer[i]) return !1;
                    return !0;
                };
            },
            {
                "../base/node": 174,
                "../constants/der": 176,
                inherits: 440,
                "safer-buffer": 495
            }
        ],
        182: [
            function(e, t, r) {
                "use strict";
                const n = r;
                n.der = e("./der"), n.pem = e("./pem");
            },
            {
                "./der": 181,
                "./pem": 183
            }
        ],
        183: [
            function(e, t, r) {
                "use strict";
                const n = e("inherits"), i = e("./der");
                function s(e) {
                    i.call(this, e), this.enc = "pem";
                }
                n(s, i), t.exports = s, s.prototype.encode = function(e, t) {
                    const r = i.prototype.encode.call(this, e).toString("base64"), n = [
                        "-----BEGIN " + t.label + "-----"
                    ];
                    for(let e = 0; e < r.length; e += 64)n.push(r.slice(e, e + 64));
                    return n.push("-----END " + t.label + "-----"), n.join("\n");
                };
            },
            {
                "./der": 181,
                inherits: 440
            }
        ],
        184: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : r - 48 & 15;
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, n) {
                        for(var i = 0, s = Math.min(e.length, r), o = t; o < s; o++){
                            var a = e.charCodeAt(o) - 48;
                            i *= n, i += a >= 49 ? a - 49 + 10 : a >= 17 ? a - 17 + 10 : a;
                        }
                        return i;
                    }
                    s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this.strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this.strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this.strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype.strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, s.prototype.inspect = function() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    };
                    var u = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], h = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], f = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    function d(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r.strip();
                    }
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                r = 0 !== (s = a >>> 24 - i & 16777215) || o !== this.length - 1 ? u[6 - l.length] + l + r : l + r, (i += 2) >= 26 && (i -= 26, o--);
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = h[e], d = f[e];
                            r = "";
                            var p = this.clone();
                            for(p.negative = 0; !p.isZero();){
                                var m = p.modn(d).toString(e);
                                r = (p = p.idivn(d)).isZero() ? m + r : u[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16);
                    }, s.prototype.toBuffer = function(e, t) {
                        return n(void 0 !== o), this.toArrayLike(o, e, t);
                    }, s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    }, s.prototype.toArrayLike = function(e, t, r) {
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0"), this.strip();
                        var o, a, l = "le" === t, c = new e(s), u = this.clone();
                        if (l) {
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[a] = o;
                            for(; a < s; a++)c[a] = 0;
                        } else {
                            for(a = 0; a < s - i; a++)c[a] = 0;
                            for(a = 0; !u.isZero(); a++)o = u.andln(255), u.iushrn(8), c[s - a - 1] = o;
                        }
                        return c;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this.strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this.strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this.strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this.strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this.strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this.strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var p = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function m(e, t, r) {
                        return (new b).mulp(e, t, r);
                    }
                    function b(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (p = d), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? p(this, e, t) : r < 63 ? d(this, e, t) : r < 1024 ? function(e, t, r) {
                            r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                            for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                                var o = i;
                                i = 0;
                                for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                    var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                    a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                                }
                                r.words[s] = a, n = o, o = i;
                            }
                            return 0 !== n ? r.words[s] = n : r.length--, r.strip();
                        }(this, e, t) : m(this, e, t);
                    }, b.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, b.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, b.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, b.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, b.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, b.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, b.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, b.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, b.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, b.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r.strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), m(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        n("number" == typeof e), n(e < 67108864);
                        for(var t = 0, r = 0; r < this.length; r++){
                            var i = (0 | this.words[r]) * e, s = (67108863 & i) + (67108863 & t);
                            t >>= 26, t += i / 67108864 | 0, t += s >>> 26, this.words[r] = 67108863 & s;
                        }
                        return 0 !== t && (this.words[r] = t, this.length++), this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = (e.words[n] & 1 << i) >>> i;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this.strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this.strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this.strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) < e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this.strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this.strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this.strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a.strip(), n.strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modn = function(e) {
                        n(e <= 67108863);
                        for(var t = 67108864 % e, r = 0, i = this.length - 1; i >= 0; i--)r = (t * r + (0 | this.words[i])) % e;
                        return r;
                    }, s.prototype.idivn = function(e) {
                        n(e <= 67108863);
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var i = (0 | this.words[r]) + 67108864 * t;
                            this.words[r] = i / e | 0, t = i % e;
                        }
                        return this.strip();
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this.strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new k(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var g = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function y(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function v() {
                        y.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function w() {
                        y.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function _() {
                        y.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function x() {
                        y.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function k(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function S(e) {
                        k.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    y.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, y.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, y.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, y.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(v, y), v.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, v.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(w, y), i(_, y), i(x, y), x.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (g[e]) return g[e];
                        var t;
                        if ("k256" === e) t = new v;
                        else if ("p224" === e) t = new w;
                        else if ("p192" === e) t = new _;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new x;
                        }
                        return g[e] = t, t;
                    }, k.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, k.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, k.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : e.umod(this.m)._forceRed(this);
                    }, k.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, k.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, k.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, k.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, k.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, k.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, k.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, k.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, k.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, k.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, k.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, k.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, k.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, k.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, k.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new S(e);
                    }, i(S, k), S.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, S.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, S.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, S.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, S.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        185: [
            function(e, t, r) {
                "use strict";
                r.byteLength = function(e) {
                    var t = c(e), r = t[0], n = t[1];
                    return 3 * (r + n) / 4 - n;
                }, r.toByteArray = function(e) {
                    var t, r, n = c(e), o = n[0], a = n[1], l = new s(function(e, t, r) {
                        return 3 * (t + r) / 4 - r;
                    }(0, o, a)), u = 0, h = a > 0 ? o - 4 : o;
                    for(r = 0; r < h; r += 4)t = i[e.charCodeAt(r)] << 18 | i[e.charCodeAt(r + 1)] << 12 | i[e.charCodeAt(r + 2)] << 6 | i[e.charCodeAt(r + 3)], l[u++] = t >> 16 & 255, l[u++] = t >> 8 & 255, l[u++] = 255 & t;
                    2 === a && (t = i[e.charCodeAt(r)] << 2 | i[e.charCodeAt(r + 1)] >> 4, l[u++] = 255 & t);
                    1 === a && (t = i[e.charCodeAt(r)] << 10 | i[e.charCodeAt(r + 1)] << 4 | i[e.charCodeAt(r + 2)] >> 2, l[u++] = t >> 8 & 255, l[u++] = 255 & t);
                    return l;
                }, r.fromByteArray = function(e) {
                    for(var t, r = e.length, i = r % 3, s = [], o = 0, a = r - i; o < a; o += 16383)s.push(u(e, o, o + 16383 > a ? a : o + 16383));
                    1 === i ? (t = e[r - 1], s.push(n[t >> 2] + n[t << 4 & 63] + "==")) : 2 === i && (t = (e[r - 2] << 8) + e[r - 1], s.push(n[t >> 10] + n[t >> 4 & 63] + n[t << 2 & 63] + "="));
                    return s.join("");
                };
                for(var n = [], i = [], s = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, l = o.length; a < l; ++a)n[a] = o[a], i[o.charCodeAt(a)] = a;
                function c(e) {
                    var t = e.length;
                    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                    var r = e.indexOf("=");
                    return -1 === r && (r = t), [
                        r,
                        r === t ? 0 : 4 - r % 4
                    ];
                }
                function u(e, t, r) {
                    for(var i, s, o = [], a = t; a < r; a += 3)i = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(n[(s = i) >> 18 & 63] + n[s >> 12 & 63] + n[s >> 6 & 63] + n[63 & s]);
                    return o.join("");
                }
                i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
            },
            {}
        ],
        186: [
            function(e, t, r) {
                "use strict";
                !function(t, r) {
                    function n(e, t) {
                        if (!e) throw new Error(t || "Assertion failed");
                    }
                    function i(e, t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                    function s(e, t, r) {
                        if (s.isBN(e)) return e;
                        this.negative = 0, this.words = null, this.length = 0, this.red = null, null !== e && ("le" !== t && "be" !== t || (r = t, t = 10), this._init(e || 0, t || 10, r || "be"));
                    }
                    var o;
                    "object" == typeof t ? t.exports = s : (void 0).BN = s, s.BN = s, s.wordSize = 26;
                    try {
                        o = "undefined" != typeof window && void 0 !== window.Buffer ? window.Buffer : e("buffer").Buffer;
                    } catch (e) {}
                    function a(e, t) {
                        var r = e.charCodeAt(t);
                        return r >= 48 && r <= 57 ? r - 48 : r >= 65 && r <= 70 ? r - 55 : r >= 97 && r <= 102 ? r - 87 : void n(!1, "Invalid character in " + e);
                    }
                    function l(e, t, r) {
                        var n = a(e, r);
                        return r - 1 >= t && (n |= a(e, r - 1) << 4), n;
                    }
                    function c(e, t, r, i) {
                        for(var s = 0, o = 0, a = Math.min(e.length, r), l = t; l < a; l++){
                            var c = e.charCodeAt(l) - 48;
                            s *= i, o = c >= 49 ? c - 49 + 10 : c >= 17 ? c - 17 + 10 : c, n(c >= 0 && o < i, "Invalid character"), s += o;
                        }
                        return s;
                    }
                    function u(e, t) {
                        e.words = t.words, e.length = t.length, e.negative = t.negative, e.red = t.red;
                    }
                    if (s.isBN = function(e) {
                        return e instanceof s || null !== e && "object" == typeof e && e.constructor.wordSize === s.wordSize && Array.isArray(e.words);
                    }, s.max = function(e, t) {
                        return e.cmp(t) > 0 ? e : t;
                    }, s.min = function(e, t) {
                        return e.cmp(t) < 0 ? e : t;
                    }, s.prototype._init = function(e, t, r) {
                        if ("number" == typeof e) return this._initNumber(e, t, r);
                        if ("object" == typeof e) return this._initArray(e, t, r);
                        "hex" === t && (t = 16), n(t === (0 | t) && t >= 2 && t <= 36);
                        var i = 0;
                        "-" === (e = e.toString().replace(/\s+/g, ""))[0] && (i++, this.negative = 1), i < e.length && (16 === t ? this._parseHex(e, i, r) : (this._parseBase(e, t, i), "le" === r && this._initArray(this.toArray(), t, r)));
                    }, s.prototype._initNumber = function(e, t, r) {
                        e < 0 && (this.negative = 1, e = -e), e < 67108864 ? (this.words = [
                            67108863 & e
                        ], this.length = 1) : e < 4503599627370496 ? (this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863
                        ], this.length = 2) : (n(e < 9007199254740992), this.words = [
                            67108863 & e,
                            e / 67108864 & 67108863,
                            1
                        ], this.length = 3), "le" === r && this._initArray(this.toArray(), t, r);
                    }, s.prototype._initArray = function(e, t, r) {
                        if (n("number" == typeof e.length), e.length <= 0) return this.words = [
                            0
                        ], this.length = 1, this;
                        this.length = Math.ceil(e.length / 3), this.words = new Array(this.length);
                        for(var i = 0; i < this.length; i++)this.words[i] = 0;
                        var s, o, a = 0;
                        if ("be" === r) for(i = e.length - 1, s = 0; i >= 0; i -= 3)o = e[i] | e[i - 1] << 8 | e[i - 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        else if ("le" === r) for(i = 0, s = 0; i < e.length; i += 3)o = e[i] | e[i + 1] << 8 | e[i + 2] << 16, this.words[s] |= o << a & 67108863, this.words[s + 1] = o >>> 26 - a & 67108863, (a += 24) >= 26 && (a -= 26, s++);
                        return this._strip();
                    }, s.prototype._parseHex = function(e, t, r) {
                        this.length = Math.ceil((e.length - t) / 6), this.words = new Array(this.length);
                        for(var n = 0; n < this.length; n++)this.words[n] = 0;
                        var i, s = 0, o = 0;
                        if ("be" === r) for(n = e.length - 1; n >= t; n -= 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        else for(n = (e.length - t) % 2 == 0 ? t + 1 : t; n < e.length; n += 2)i = l(e, t, n) << s, this.words[o] |= 67108863 & i, s >= 18 ? (s -= 18, o += 1, this.words[o] |= i >>> 26) : s += 8;
                        this._strip();
                    }, s.prototype._parseBase = function(e, t, r) {
                        this.words = [
                            0
                        ], this.length = 1;
                        for(var n = 0, i = 1; i <= 67108863; i *= t)n++;
                        n--, i = i / t | 0;
                        for(var s = e.length - r, o = s % n, a = Math.min(s, s - o) + r, l = 0, u = r; u < a; u += n)l = c(e, u, u + n, t), this.imuln(i), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        if (0 !== o) {
                            var h = 1;
                            for(l = c(e, u, e.length, t), u = 0; u < o; u++)h *= t;
                            this.imuln(h), this.words[0] + l < 67108864 ? this.words[0] += l : this._iaddn(l);
                        }
                        this._strip();
                    }, s.prototype.copy = function(e) {
                        e.words = new Array(this.length);
                        for(var t = 0; t < this.length; t++)e.words[t] = this.words[t];
                        e.length = this.length, e.negative = this.negative, e.red = this.red;
                    }, s.prototype._move = function(e) {
                        u(e, this);
                    }, s.prototype.clone = function() {
                        var e = new s(null);
                        return this.copy(e), e;
                    }, s.prototype._expand = function(e) {
                        for(; this.length < e;)this.words[this.length++] = 0;
                        return this;
                    }, s.prototype._strip = function() {
                        for(; this.length > 1 && 0 === this.words[this.length - 1];)this.length--;
                        return this._normSign();
                    }, s.prototype._normSign = function() {
                        return 1 === this.length && 0 === this.words[0] && (this.negative = 0), this;
                    }, "undefined" != typeof Symbol && "function" == typeof Symbol.for) try {
                        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = h;
                    } catch (e) {
                        s.prototype.inspect = h;
                    }
                    else s.prototype.inspect = h;
                    function h() {
                        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                    }
                    var f = [
                        "",
                        "0",
                        "00",
                        "000",
                        "0000",
                        "00000",
                        "000000",
                        "0000000",
                        "00000000",
                        "000000000",
                        "0000000000",
                        "00000000000",
                        "000000000000",
                        "0000000000000",
                        "00000000000000",
                        "000000000000000",
                        "0000000000000000",
                        "00000000000000000",
                        "000000000000000000",
                        "0000000000000000000",
                        "00000000000000000000",
                        "000000000000000000000",
                        "0000000000000000000000",
                        "00000000000000000000000",
                        "000000000000000000000000",
                        "0000000000000000000000000"
                    ], d = [
                        0,
                        0,
                        25,
                        16,
                        12,
                        11,
                        10,
                        9,
                        8,
                        8,
                        7,
                        7,
                        7,
                        7,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5,
                        5
                    ], p = [
                        0,
                        0,
                        33554432,
                        43046721,
                        16777216,
                        48828125,
                        60466176,
                        40353607,
                        16777216,
                        43046721,
                        1e7,
                        19487171,
                        35831808,
                        62748517,
                        7529536,
                        11390625,
                        16777216,
                        24137569,
                        34012224,
                        47045881,
                        64e6,
                        4084101,
                        5153632,
                        6436343,
                        7962624,
                        9765625,
                        11881376,
                        14348907,
                        17210368,
                        20511149,
                        243e5,
                        28629151,
                        33554432,
                        39135393,
                        45435424,
                        52521875,
                        60466176
                    ];
                    s.prototype.toString = function(e, t) {
                        var r;
                        if (t = 0 | t || 1, 16 === (e = e || 10) || "hex" === e) {
                            r = "";
                            for(var i = 0, s = 0, o = 0; o < this.length; o++){
                                var a = this.words[o], l = (16777215 & (a << i | s)).toString(16);
                                s = a >>> 24 - i & 16777215, (i += 2) >= 26 && (i -= 26, o--), r = 0 !== s || o !== this.length - 1 ? f[6 - l.length] + l + r : l + r;
                            }
                            for(0 !== s && (r = s.toString(16) + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        if (e === (0 | e) && e >= 2 && e <= 36) {
                            var c = d[e], u = p[e];
                            r = "";
                            var h = this.clone();
                            for(h.negative = 0; !h.isZero();){
                                var m = h.modrn(u).toString(e);
                                r = (h = h.idivn(u)).isZero() ? m + r : f[c - m.length] + m + r;
                            }
                            for(this.isZero() && (r = "0" + r); r.length % t != 0;)r = "0" + r;
                            return 0 !== this.negative && (r = "-" + r), r;
                        }
                        n(!1, "Base should be between 2 and 36");
                    }, s.prototype.toNumber = function() {
                        var e = this.words[0];
                        return 2 === this.length ? e += 67108864 * this.words[1] : 3 === this.length && 1 === this.words[2] ? e += 4503599627370496 + 67108864 * this.words[1] : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), 0 !== this.negative ? -e : e;
                    }, s.prototype.toJSON = function() {
                        return this.toString(16, 2);
                    }, o && (s.prototype.toBuffer = function(e, t) {
                        return this.toArrayLike(o, e, t);
                    }), s.prototype.toArray = function(e, t) {
                        return this.toArrayLike(Array, e, t);
                    };
                    function m(e, t, r) {
                        r.negative = t.negative ^ e.negative;
                        var n = e.length + t.length | 0;
                        r.length = n, n = n - 1 | 0;
                        var i = 0 | e.words[0], s = 0 | t.words[0], o = i * s, a = 67108863 & o, l = o / 67108864 | 0;
                        r.words[0] = a;
                        for(var c = 1; c < n; c++){
                            for(var u = l >>> 26, h = 67108863 & l, f = Math.min(c, t.length - 1), d = Math.max(0, c - e.length + 1); d <= f; d++){
                                var p = c - d | 0;
                                u += (o = (i = 0 | e.words[p]) * (s = 0 | t.words[d]) + h) / 67108864 | 0, h = 67108863 & o;
                            }
                            r.words[c] = 0 | h, l = 0 | u;
                        }
                        return 0 !== l ? r.words[c] = 0 | l : r.length--, r._strip();
                    }
                    s.prototype.toArrayLike = function(e, t, r) {
                        this._strip();
                        var i = this.byteLength(), s = r || Math.max(1, i);
                        n(i <= s, "byte array longer than desired length"), n(s > 0, "Requested array length <= 0");
                        var o = function(e, t) {
                            return e.allocUnsafe ? e.allocUnsafe(t) : new e(t);
                        }(e, s);
                        return this["_toArrayLike" + ("le" === t ? "LE" : "BE")](o, i), o;
                    }, s.prototype._toArrayLikeLE = function(e, t) {
                        for(var r = 0, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r++] = 255 & o, r < e.length && (e[r++] = o >> 8 & 255), r < e.length && (e[r++] = o >> 16 & 255), 6 === s ? (r < e.length && (e[r++] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r < e.length) for(e[r++] = n; r < e.length;)e[r++] = 0;
                    }, s.prototype._toArrayLikeBE = function(e, t) {
                        for(var r = e.length - 1, n = 0, i = 0, s = 0; i < this.length; i++){
                            var o = this.words[i] << s | n;
                            e[r--] = 255 & o, r >= 0 && (e[r--] = o >> 8 & 255), r >= 0 && (e[r--] = o >> 16 & 255), 6 === s ? (r >= 0 && (e[r--] = o >> 24 & 255), n = 0, s = 0) : (n = o >>> 24, s += 2);
                        }
                        if (r >= 0) for(e[r--] = n; r >= 0;)e[r--] = 0;
                    }, Math.clz32 ? s.prototype._countBits = function(e) {
                        return 32 - Math.clz32(e);
                    } : s.prototype._countBits = function(e) {
                        var t = e, r = 0;
                        return t >= 4096 && (r += 13, t >>>= 13), t >= 64 && (r += 7, t >>>= 7), t >= 8 && (r += 4, t >>>= 4), t >= 2 && (r += 2, t >>>= 2), r + t;
                    }, s.prototype._zeroBits = function(e) {
                        if (0 === e) return 26;
                        var t = e, r = 0;
                        return 0 == (8191 & t) && (r += 13, t >>>= 13), 0 == (127 & t) && (r += 7, t >>>= 7), 0 == (15 & t) && (r += 4, t >>>= 4), 0 == (3 & t) && (r += 2, t >>>= 2), 0 == (1 & t) && r++, r;
                    }, s.prototype.bitLength = function() {
                        var e = this.words[this.length - 1], t = this._countBits(e);
                        return 26 * (this.length - 1) + t;
                    }, s.prototype.zeroBits = function() {
                        if (this.isZero()) return 0;
                        for(var e = 0, t = 0; t < this.length; t++){
                            var r = this._zeroBits(this.words[t]);
                            if (e += r, 26 !== r) break;
                        }
                        return e;
                    }, s.prototype.byteLength = function() {
                        return Math.ceil(this.bitLength() / 8);
                    }, s.prototype.toTwos = function(e) {
                        return 0 !== this.negative ? this.abs().inotn(e).iaddn(1) : this.clone();
                    }, s.prototype.fromTwos = function(e) {
                        return this.testn(e - 1) ? this.notn(e).iaddn(1).ineg() : this.clone();
                    }, s.prototype.isNeg = function() {
                        return 0 !== this.negative;
                    }, s.prototype.neg = function() {
                        return this.clone().ineg();
                    }, s.prototype.ineg = function() {
                        return this.isZero() || (this.negative ^= 1), this;
                    }, s.prototype.iuor = function(e) {
                        for(; this.length < e.length;)this.words[this.length++] = 0;
                        for(var t = 0; t < e.length; t++)this.words[t] = this.words[t] | e.words[t];
                        return this._strip();
                    }, s.prototype.ior = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuor(e);
                    }, s.prototype.or = function(e) {
                        return this.length > e.length ? this.clone().ior(e) : e.clone().ior(this);
                    }, s.prototype.uor = function(e) {
                        return this.length > e.length ? this.clone().iuor(e) : e.clone().iuor(this);
                    }, s.prototype.iuand = function(e) {
                        var t;
                        t = this.length > e.length ? e : this;
                        for(var r = 0; r < t.length; r++)this.words[r] = this.words[r] & e.words[r];
                        return this.length = t.length, this._strip();
                    }, s.prototype.iand = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuand(e);
                    }, s.prototype.and = function(e) {
                        return this.length > e.length ? this.clone().iand(e) : e.clone().iand(this);
                    }, s.prototype.uand = function(e) {
                        return this.length > e.length ? this.clone().iuand(e) : e.clone().iuand(this);
                    }, s.prototype.iuxor = function(e) {
                        var t, r;
                        this.length > e.length ? (t = this, r = e) : (t = e, r = this);
                        for(var n = 0; n < r.length; n++)this.words[n] = t.words[n] ^ r.words[n];
                        if (this !== t) for(; n < t.length; n++)this.words[n] = t.words[n];
                        return this.length = t.length, this._strip();
                    }, s.prototype.ixor = function(e) {
                        return n(0 == (this.negative | e.negative)), this.iuxor(e);
                    }, s.prototype.xor = function(e) {
                        return this.length > e.length ? this.clone().ixor(e) : e.clone().ixor(this);
                    }, s.prototype.uxor = function(e) {
                        return this.length > e.length ? this.clone().iuxor(e) : e.clone().iuxor(this);
                    }, s.prototype.inotn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = 0 | Math.ceil(e / 26), r = e % 26;
                        this._expand(t), r > 0 && t--;
                        for(var i = 0; i < t; i++)this.words[i] = 67108863 & ~this.words[i];
                        return r > 0 && (this.words[i] = ~this.words[i] & 67108863 >> 26 - r), this._strip();
                    }, s.prototype.notn = function(e) {
                        return this.clone().inotn(e);
                    }, s.prototype.setn = function(e, t) {
                        n("number" == typeof e && e >= 0);
                        var r = e / 26 | 0, i = e % 26;
                        return this._expand(r + 1), this.words[r] = t ? this.words[r] | 1 << i : this.words[r] & ~(1 << i), this._strip();
                    }, s.prototype.iadd = function(e) {
                        var t, r, n;
                        if (0 !== this.negative && 0 === e.negative) return this.negative = 0, t = this.isub(e), this.negative ^= 1, this._normSign();
                        if (0 === this.negative && 0 !== e.negative) return e.negative = 0, t = this.isub(e), e.negative = 1, t._normSign();
                        this.length > e.length ? (r = this, n = e) : (r = e, n = this);
                        for(var i = 0, s = 0; s < n.length; s++)t = (0 | r.words[s]) + (0 | n.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        for(; 0 !== i && s < r.length; s++)t = (0 | r.words[s]) + i, this.words[s] = 67108863 & t, i = t >>> 26;
                        if (this.length = r.length, 0 !== i) this.words[this.length] = i, this.length++;
                        else if (r !== this) for(; s < r.length; s++)this.words[s] = r.words[s];
                        return this;
                    }, s.prototype.add = function(e) {
                        var t;
                        return 0 !== e.negative && 0 === this.negative ? (e.negative = 0, t = this.sub(e), e.negative ^= 1, t) : 0 === e.negative && 0 !== this.negative ? (this.negative = 0, t = e.sub(this), this.negative = 1, t) : this.length > e.length ? this.clone().iadd(e) : e.clone().iadd(this);
                    }, s.prototype.isub = function(e) {
                        if (0 !== e.negative) {
                            e.negative = 0;
                            var t = this.iadd(e);
                            return e.negative = 1, t._normSign();
                        }
                        if (0 !== this.negative) return this.negative = 0, this.iadd(e), this.negative = 1, this._normSign();
                        var r, n, i = this.cmp(e);
                        if (0 === i) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                        i > 0 ? (r = this, n = e) : (r = e, n = this);
                        for(var s = 0, o = 0; o < n.length; o++)s = (t = (0 | r.words[o]) - (0 | n.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        for(; 0 !== s && o < r.length; o++)s = (t = (0 | r.words[o]) + s) >> 26, this.words[o] = 67108863 & t;
                        if (0 === s && o < r.length && r !== this) for(; o < r.length; o++)this.words[o] = r.words[o];
                        return this.length = Math.max(this.length, o), r !== this && (this.negative = 1), this._strip();
                    }, s.prototype.sub = function(e) {
                        return this.clone().isub(e);
                    };
                    var b = function(e, t, r) {
                        var n, i, s, o = e.words, a = t.words, l = r.words, c = 0, u = 0 | o[0], h = 8191 & u, f = u >>> 13, d = 0 | o[1], p = 8191 & d, m = d >>> 13, b = 0 | o[2], g = 8191 & b, y = b >>> 13, v = 0 | o[3], w = 8191 & v, _ = v >>> 13, x = 0 | o[4], k = 8191 & x, S = x >>> 13, M = 0 | o[5], C = 8191 & M, T = M >>> 13, E = 0 | o[6], A = 8191 & E, R = E >>> 13, O = 0 | o[7], j = 8191 & O, I = O >>> 13, N = 0 | o[8], P = 8191 & N, B = N >>> 13, D = 0 | o[9], F = 8191 & D, L = D >>> 13, z = 0 | a[0], U = 8191 & z, $ = z >>> 13, H = 0 | a[1], V = 8191 & H, q = H >>> 13, W = 0 | a[2], X = 8191 & W, K = W >>> 13, Y = 0 | a[3], Z = 8191 & Y, G = Y >>> 13, J = 0 | a[4], Q = 8191 & J, ee = J >>> 13, te = 0 | a[5], re = 8191 & te, ne = te >>> 13, ie = 0 | a[6], se = 8191 & ie, oe = ie >>> 13, ae = 0 | a[7], le = 8191 & ae, ce = ae >>> 13, ue = 0 | a[8], he = 8191 & ue, fe = ue >>> 13, de = 0 | a[9], pe = 8191 & de, me = de >>> 13;
                        r.negative = e.negative ^ t.negative, r.length = 19;
                        var be = (c + (n = Math.imul(h, U)) | 0) + ((8191 & (i = (i = Math.imul(h, $)) + Math.imul(f, U) | 0)) << 13) | 0;
                        c = ((s = Math.imul(f, $)) + (i >>> 13) | 0) + (be >>> 26) | 0, be &= 67108863, n = Math.imul(p, U), i = (i = Math.imul(p, $)) + Math.imul(m, U) | 0, s = Math.imul(m, $);
                        var ge = (c + (n = n + Math.imul(h, V) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, q) | 0) + Math.imul(f, V) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, q) | 0) + (i >>> 13) | 0) + (ge >>> 26) | 0, ge &= 67108863, n = Math.imul(g, U), i = (i = Math.imul(g, $)) + Math.imul(y, U) | 0, s = Math.imul(y, $), n = n + Math.imul(p, V) | 0, i = (i = i + Math.imul(p, q) | 0) + Math.imul(m, V) | 0, s = s + Math.imul(m, q) | 0;
                        var ye = (c + (n = n + Math.imul(h, X) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, K) | 0) + Math.imul(f, X) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, K) | 0) + (i >>> 13) | 0) + (ye >>> 26) | 0, ye &= 67108863, n = Math.imul(w, U), i = (i = Math.imul(w, $)) + Math.imul(_, U) | 0, s = Math.imul(_, $), n = n + Math.imul(g, V) | 0, i = (i = i + Math.imul(g, q) | 0) + Math.imul(y, V) | 0, s = s + Math.imul(y, q) | 0, n = n + Math.imul(p, X) | 0, i = (i = i + Math.imul(p, K) | 0) + Math.imul(m, X) | 0, s = s + Math.imul(m, K) | 0;
                        var ve = (c + (n = n + Math.imul(h, Z) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, G) | 0) + Math.imul(f, Z) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, G) | 0) + (i >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, n = Math.imul(k, U), i = (i = Math.imul(k, $)) + Math.imul(S, U) | 0, s = Math.imul(S, $), n = n + Math.imul(w, V) | 0, i = (i = i + Math.imul(w, q) | 0) + Math.imul(_, V) | 0, s = s + Math.imul(_, q) | 0, n = n + Math.imul(g, X) | 0, i = (i = i + Math.imul(g, K) | 0) + Math.imul(y, X) | 0, s = s + Math.imul(y, K) | 0, n = n + Math.imul(p, Z) | 0, i = (i = i + Math.imul(p, G) | 0) + Math.imul(m, Z) | 0, s = s + Math.imul(m, G) | 0;
                        var we = (c + (n = n + Math.imul(h, Q) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ee) | 0) + Math.imul(f, Q) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ee) | 0) + (i >>> 13) | 0) + (we >>> 26) | 0, we &= 67108863, n = Math.imul(C, U), i = (i = Math.imul(C, $)) + Math.imul(T, U) | 0, s = Math.imul(T, $), n = n + Math.imul(k, V) | 0, i = (i = i + Math.imul(k, q) | 0) + Math.imul(S, V) | 0, s = s + Math.imul(S, q) | 0, n = n + Math.imul(w, X) | 0, i = (i = i + Math.imul(w, K) | 0) + Math.imul(_, X) | 0, s = s + Math.imul(_, K) | 0, n = n + Math.imul(g, Z) | 0, i = (i = i + Math.imul(g, G) | 0) + Math.imul(y, Z) | 0, s = s + Math.imul(y, G) | 0, n = n + Math.imul(p, Q) | 0, i = (i = i + Math.imul(p, ee) | 0) + Math.imul(m, Q) | 0, s = s + Math.imul(m, ee) | 0;
                        var _e = (c + (n = n + Math.imul(h, re) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ne) | 0) + Math.imul(f, re) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ne) | 0) + (i >>> 13) | 0) + (_e >>> 26) | 0, _e &= 67108863, n = Math.imul(A, U), i = (i = Math.imul(A, $)) + Math.imul(R, U) | 0, s = Math.imul(R, $), n = n + Math.imul(C, V) | 0, i = (i = i + Math.imul(C, q) | 0) + Math.imul(T, V) | 0, s = s + Math.imul(T, q) | 0, n = n + Math.imul(k, X) | 0, i = (i = i + Math.imul(k, K) | 0) + Math.imul(S, X) | 0, s = s + Math.imul(S, K) | 0, n = n + Math.imul(w, Z) | 0, i = (i = i + Math.imul(w, G) | 0) + Math.imul(_, Z) | 0, s = s + Math.imul(_, G) | 0, n = n + Math.imul(g, Q) | 0, i = (i = i + Math.imul(g, ee) | 0) + Math.imul(y, Q) | 0, s = s + Math.imul(y, ee) | 0, n = n + Math.imul(p, re) | 0, i = (i = i + Math.imul(p, ne) | 0) + Math.imul(m, re) | 0, s = s + Math.imul(m, ne) | 0;
                        var xe = (c + (n = n + Math.imul(h, se) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, oe) | 0) + Math.imul(f, se) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, oe) | 0) + (i >>> 13) | 0) + (xe >>> 26) | 0, xe &= 67108863, n = Math.imul(j, U), i = (i = Math.imul(j, $)) + Math.imul(I, U) | 0, s = Math.imul(I, $), n = n + Math.imul(A, V) | 0, i = (i = i + Math.imul(A, q) | 0) + Math.imul(R, V) | 0, s = s + Math.imul(R, q) | 0, n = n + Math.imul(C, X) | 0, i = (i = i + Math.imul(C, K) | 0) + Math.imul(T, X) | 0, s = s + Math.imul(T, K) | 0, n = n + Math.imul(k, Z) | 0, i = (i = i + Math.imul(k, G) | 0) + Math.imul(S, Z) | 0, s = s + Math.imul(S, G) | 0, n = n + Math.imul(w, Q) | 0, i = (i = i + Math.imul(w, ee) | 0) + Math.imul(_, Q) | 0, s = s + Math.imul(_, ee) | 0, n = n + Math.imul(g, re) | 0, i = (i = i + Math.imul(g, ne) | 0) + Math.imul(y, re) | 0, s = s + Math.imul(y, ne) | 0, n = n + Math.imul(p, se) | 0, i = (i = i + Math.imul(p, oe) | 0) + Math.imul(m, se) | 0, s = s + Math.imul(m, oe) | 0;
                        var ke = (c + (n = n + Math.imul(h, le) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, ce) | 0) + Math.imul(f, le) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, ce) | 0) + (i >>> 13) | 0) + (ke >>> 26) | 0, ke &= 67108863, n = Math.imul(P, U), i = (i = Math.imul(P, $)) + Math.imul(B, U) | 0, s = Math.imul(B, $), n = n + Math.imul(j, V) | 0, i = (i = i + Math.imul(j, q) | 0) + Math.imul(I, V) | 0, s = s + Math.imul(I, q) | 0, n = n + Math.imul(A, X) | 0, i = (i = i + Math.imul(A, K) | 0) + Math.imul(R, X) | 0, s = s + Math.imul(R, K) | 0, n = n + Math.imul(C, Z) | 0, i = (i = i + Math.imul(C, G) | 0) + Math.imul(T, Z) | 0, s = s + Math.imul(T, G) | 0, n = n + Math.imul(k, Q) | 0, i = (i = i + Math.imul(k, ee) | 0) + Math.imul(S, Q) | 0, s = s + Math.imul(S, ee) | 0, n = n + Math.imul(w, re) | 0, i = (i = i + Math.imul(w, ne) | 0) + Math.imul(_, re) | 0, s = s + Math.imul(_, ne) | 0, n = n + Math.imul(g, se) | 0, i = (i = i + Math.imul(g, oe) | 0) + Math.imul(y, se) | 0, s = s + Math.imul(y, oe) | 0, n = n + Math.imul(p, le) | 0, i = (i = i + Math.imul(p, ce) | 0) + Math.imul(m, le) | 0, s = s + Math.imul(m, ce) | 0;
                        var Se = (c + (n = n + Math.imul(h, he) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, fe) | 0) + Math.imul(f, he) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, fe) | 0) + (i >>> 13) | 0) + (Se >>> 26) | 0, Se &= 67108863, n = Math.imul(F, U), i = (i = Math.imul(F, $)) + Math.imul(L, U) | 0, s = Math.imul(L, $), n = n + Math.imul(P, V) | 0, i = (i = i + Math.imul(P, q) | 0) + Math.imul(B, V) | 0, s = s + Math.imul(B, q) | 0, n = n + Math.imul(j, X) | 0, i = (i = i + Math.imul(j, K) | 0) + Math.imul(I, X) | 0, s = s + Math.imul(I, K) | 0, n = n + Math.imul(A, Z) | 0, i = (i = i + Math.imul(A, G) | 0) + Math.imul(R, Z) | 0, s = s + Math.imul(R, G) | 0, n = n + Math.imul(C, Q) | 0, i = (i = i + Math.imul(C, ee) | 0) + Math.imul(T, Q) | 0, s = s + Math.imul(T, ee) | 0, n = n + Math.imul(k, re) | 0, i = (i = i + Math.imul(k, ne) | 0) + Math.imul(S, re) | 0, s = s + Math.imul(S, ne) | 0, n = n + Math.imul(w, se) | 0, i = (i = i + Math.imul(w, oe) | 0) + Math.imul(_, se) | 0, s = s + Math.imul(_, oe) | 0, n = n + Math.imul(g, le) | 0, i = (i = i + Math.imul(g, ce) | 0) + Math.imul(y, le) | 0, s = s + Math.imul(y, ce) | 0, n = n + Math.imul(p, he) | 0, i = (i = i + Math.imul(p, fe) | 0) + Math.imul(m, he) | 0, s = s + Math.imul(m, fe) | 0;
                        var Me = (c + (n = n + Math.imul(h, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(h, me) | 0) + Math.imul(f, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(f, me) | 0) + (i >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, n = Math.imul(F, V), i = (i = Math.imul(F, q)) + Math.imul(L, V) | 0, s = Math.imul(L, q), n = n + Math.imul(P, X) | 0, i = (i = i + Math.imul(P, K) | 0) + Math.imul(B, X) | 0, s = s + Math.imul(B, K) | 0, n = n + Math.imul(j, Z) | 0, i = (i = i + Math.imul(j, G) | 0) + Math.imul(I, Z) | 0, s = s + Math.imul(I, G) | 0, n = n + Math.imul(A, Q) | 0, i = (i = i + Math.imul(A, ee) | 0) + Math.imul(R, Q) | 0, s = s + Math.imul(R, ee) | 0, n = n + Math.imul(C, re) | 0, i = (i = i + Math.imul(C, ne) | 0) + Math.imul(T, re) | 0, s = s + Math.imul(T, ne) | 0, n = n + Math.imul(k, se) | 0, i = (i = i + Math.imul(k, oe) | 0) + Math.imul(S, se) | 0, s = s + Math.imul(S, oe) | 0, n = n + Math.imul(w, le) | 0, i = (i = i + Math.imul(w, ce) | 0) + Math.imul(_, le) | 0, s = s + Math.imul(_, ce) | 0, n = n + Math.imul(g, he) | 0, i = (i = i + Math.imul(g, fe) | 0) + Math.imul(y, he) | 0, s = s + Math.imul(y, fe) | 0;
                        var Ce = (c + (n = n + Math.imul(p, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(p, me) | 0) + Math.imul(m, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(m, me) | 0) + (i >>> 13) | 0) + (Ce >>> 26) | 0, Ce &= 67108863, n = Math.imul(F, X), i = (i = Math.imul(F, K)) + Math.imul(L, X) | 0, s = Math.imul(L, K), n = n + Math.imul(P, Z) | 0, i = (i = i + Math.imul(P, G) | 0) + Math.imul(B, Z) | 0, s = s + Math.imul(B, G) | 0, n = n + Math.imul(j, Q) | 0, i = (i = i + Math.imul(j, ee) | 0) + Math.imul(I, Q) | 0, s = s + Math.imul(I, ee) | 0, n = n + Math.imul(A, re) | 0, i = (i = i + Math.imul(A, ne) | 0) + Math.imul(R, re) | 0, s = s + Math.imul(R, ne) | 0, n = n + Math.imul(C, se) | 0, i = (i = i + Math.imul(C, oe) | 0) + Math.imul(T, se) | 0, s = s + Math.imul(T, oe) | 0, n = n + Math.imul(k, le) | 0, i = (i = i + Math.imul(k, ce) | 0) + Math.imul(S, le) | 0, s = s + Math.imul(S, ce) | 0, n = n + Math.imul(w, he) | 0, i = (i = i + Math.imul(w, fe) | 0) + Math.imul(_, he) | 0, s = s + Math.imul(_, fe) | 0;
                        var Te = (c + (n = n + Math.imul(g, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(g, me) | 0) + Math.imul(y, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(y, me) | 0) + (i >>> 13) | 0) + (Te >>> 26) | 0, Te &= 67108863, n = Math.imul(F, Z), i = (i = Math.imul(F, G)) + Math.imul(L, Z) | 0, s = Math.imul(L, G), n = n + Math.imul(P, Q) | 0, i = (i = i + Math.imul(P, ee) | 0) + Math.imul(B, Q) | 0, s = s + Math.imul(B, ee) | 0, n = n + Math.imul(j, re) | 0, i = (i = i + Math.imul(j, ne) | 0) + Math.imul(I, re) | 0, s = s + Math.imul(I, ne) | 0, n = n + Math.imul(A, se) | 0, i = (i = i + Math.imul(A, oe) | 0) + Math.imul(R, se) | 0, s = s + Math.imul(R, oe) | 0, n = n + Math.imul(C, le) | 0, i = (i = i + Math.imul(C, ce) | 0) + Math.imul(T, le) | 0, s = s + Math.imul(T, ce) | 0, n = n + Math.imul(k, he) | 0, i = (i = i + Math.imul(k, fe) | 0) + Math.imul(S, he) | 0, s = s + Math.imul(S, fe) | 0;
                        var Ee = (c + (n = n + Math.imul(w, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(w, me) | 0) + Math.imul(_, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(_, me) | 0) + (i >>> 13) | 0) + (Ee >>> 26) | 0, Ee &= 67108863, n = Math.imul(F, Q), i = (i = Math.imul(F, ee)) + Math.imul(L, Q) | 0, s = Math.imul(L, ee), n = n + Math.imul(P, re) | 0, i = (i = i + Math.imul(P, ne) | 0) + Math.imul(B, re) | 0, s = s + Math.imul(B, ne) | 0, n = n + Math.imul(j, se) | 0, i = (i = i + Math.imul(j, oe) | 0) + Math.imul(I, se) | 0, s = s + Math.imul(I, oe) | 0, n = n + Math.imul(A, le) | 0, i = (i = i + Math.imul(A, ce) | 0) + Math.imul(R, le) | 0, s = s + Math.imul(R, ce) | 0, n = n + Math.imul(C, he) | 0, i = (i = i + Math.imul(C, fe) | 0) + Math.imul(T, he) | 0, s = s + Math.imul(T, fe) | 0;
                        var Ae = (c + (n = n + Math.imul(k, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(k, me) | 0) + Math.imul(S, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(S, me) | 0) + (i >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, n = Math.imul(F, re), i = (i = Math.imul(F, ne)) + Math.imul(L, re) | 0, s = Math.imul(L, ne), n = n + Math.imul(P, se) | 0, i = (i = i + Math.imul(P, oe) | 0) + Math.imul(B, se) | 0, s = s + Math.imul(B, oe) | 0, n = n + Math.imul(j, le) | 0, i = (i = i + Math.imul(j, ce) | 0) + Math.imul(I, le) | 0, s = s + Math.imul(I, ce) | 0, n = n + Math.imul(A, he) | 0, i = (i = i + Math.imul(A, fe) | 0) + Math.imul(R, he) | 0, s = s + Math.imul(R, fe) | 0;
                        var Re = (c + (n = n + Math.imul(C, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(C, me) | 0) + Math.imul(T, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(T, me) | 0) + (i >>> 13) | 0) + (Re >>> 26) | 0, Re &= 67108863, n = Math.imul(F, se), i = (i = Math.imul(F, oe)) + Math.imul(L, se) | 0, s = Math.imul(L, oe), n = n + Math.imul(P, le) | 0, i = (i = i + Math.imul(P, ce) | 0) + Math.imul(B, le) | 0, s = s + Math.imul(B, ce) | 0, n = n + Math.imul(j, he) | 0, i = (i = i + Math.imul(j, fe) | 0) + Math.imul(I, he) | 0, s = s + Math.imul(I, fe) | 0;
                        var Oe = (c + (n = n + Math.imul(A, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(A, me) | 0) + Math.imul(R, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(R, me) | 0) + (i >>> 13) | 0) + (Oe >>> 26) | 0, Oe &= 67108863, n = Math.imul(F, le), i = (i = Math.imul(F, ce)) + Math.imul(L, le) | 0, s = Math.imul(L, ce), n = n + Math.imul(P, he) | 0, i = (i = i + Math.imul(P, fe) | 0) + Math.imul(B, he) | 0, s = s + Math.imul(B, fe) | 0;
                        var je = (c + (n = n + Math.imul(j, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(j, me) | 0) + Math.imul(I, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(I, me) | 0) + (i >>> 13) | 0) + (je >>> 26) | 0, je &= 67108863, n = Math.imul(F, he), i = (i = Math.imul(F, fe)) + Math.imul(L, he) | 0, s = Math.imul(L, fe);
                        var Ie = (c + (n = n + Math.imul(P, pe) | 0) | 0) + ((8191 & (i = (i = i + Math.imul(P, me) | 0) + Math.imul(B, pe) | 0)) << 13) | 0;
                        c = ((s = s + Math.imul(B, me) | 0) + (i >>> 13) | 0) + (Ie >>> 26) | 0, Ie &= 67108863;
                        var Ne = (c + (n = Math.imul(F, pe)) | 0) + ((8191 & (i = (i = Math.imul(F, me)) + Math.imul(L, pe) | 0)) << 13) | 0;
                        return c = ((s = Math.imul(L, me)) + (i >>> 13) | 0) + (Ne >>> 26) | 0, Ne &= 67108863, l[0] = be, l[1] = ge, l[2] = ye, l[3] = ve, l[4] = we, l[5] = _e, l[6] = xe, l[7] = ke, l[8] = Se, l[9] = Me, l[10] = Ce, l[11] = Te, l[12] = Ee, l[13] = Ae, l[14] = Re, l[15] = Oe, l[16] = je, l[17] = Ie, l[18] = Ne, 0 !== c && (l[19] = c, r.length++), r;
                    };
                    function g(e, t, r) {
                        r.negative = t.negative ^ e.negative, r.length = e.length + t.length;
                        for(var n = 0, i = 0, s = 0; s < r.length - 1; s++){
                            var o = i;
                            i = 0;
                            for(var a = 67108863 & n, l = Math.min(s, t.length - 1), c = Math.max(0, s - e.length + 1); c <= l; c++){
                                var u = s - c, h = (0 | e.words[u]) * (0 | t.words[c]), f = 67108863 & h;
                                a = 67108863 & (f = f + a | 0), i += (o = (o = o + (h / 67108864 | 0) | 0) + (f >>> 26) | 0) >>> 26, o &= 67108863;
                            }
                            r.words[s] = a, n = o, o = i;
                        }
                        return 0 !== n ? r.words[s] = n : r.length--, r._strip();
                    }
                    function y(e, t, r) {
                        return g(e, t, r);
                    }
                    function v(e, t) {
                        this.x = e, this.y = t;
                    }
                    Math.imul || (b = m), s.prototype.mulTo = function(e, t) {
                        var r = this.length + e.length;
                        return 10 === this.length && 10 === e.length ? b(this, e, t) : r < 63 ? m(this, e, t) : r < 1024 ? g(this, e, t) : y(this, e, t);
                    }, v.prototype.makeRBT = function(e) {
                        for(var t = new Array(e), r = s.prototype._countBits(e) - 1, n = 0; n < e; n++)t[n] = this.revBin(n, r, e);
                        return t;
                    }, v.prototype.revBin = function(e, t, r) {
                        if (0 === e || e === r - 1) return e;
                        for(var n = 0, i = 0; i < t; i++)n |= (1 & e) << t - i - 1, e >>= 1;
                        return n;
                    }, v.prototype.permute = function(e, t, r, n, i, s) {
                        for(var o = 0; o < s; o++)n[o] = t[e[o]], i[o] = r[e[o]];
                    }, v.prototype.transform = function(e, t, r, n, i, s) {
                        this.permute(s, e, t, r, n, i);
                        for(var o = 1; o < i; o <<= 1)for(var a = o << 1, l = Math.cos(2 * Math.PI / a), c = Math.sin(2 * Math.PI / a), u = 0; u < i; u += a)for(var h = l, f = c, d = 0; d < o; d++){
                            var p = r[u + d], m = n[u + d], b = r[u + d + o], g = n[u + d + o], y = h * b - f * g;
                            g = h * g + f * b, b = y, r[u + d] = p + b, n[u + d] = m + g, r[u + d + o] = p - b, n[u + d + o] = m - g, d !== a && (y = l * h - c * f, f = l * f + c * h, h = y);
                        }
                    }, v.prototype.guessLen13b = function(e, t) {
                        var r = 1 | Math.max(t, e), n = 1 & r, i = 0;
                        for(r = r / 2 | 0; r; r >>>= 1)i++;
                        return 1 << i + 1 + n;
                    }, v.prototype.conjugate = function(e, t, r) {
                        if (!(r <= 1)) for(var n = 0; n < r / 2; n++){
                            var i = e[n];
                            e[n] = e[r - n - 1], e[r - n - 1] = i, i = t[n], t[n] = -t[r - n - 1], t[r - n - 1] = -i;
                        }
                    }, v.prototype.normalize13b = function(e, t) {
                        for(var r = 0, n = 0; n < t / 2; n++){
                            var i = 8192 * Math.round(e[2 * n + 1] / t) + Math.round(e[2 * n] / t) + r;
                            e[n] = 67108863 & i, r = i < 67108864 ? 0 : i / 67108864 | 0;
                        }
                        return e;
                    }, v.prototype.convert13b = function(e, t, r, i) {
                        for(var s = 0, o = 0; o < t; o++)s += 0 | e[o], r[2 * o] = 8191 & s, s >>>= 13, r[2 * o + 1] = 8191 & s, s >>>= 13;
                        for(o = 2 * t; o < i; ++o)r[o] = 0;
                        n(0 === s), n(0 == (-8192 & s));
                    }, v.prototype.stub = function(e) {
                        for(var t = new Array(e), r = 0; r < e; r++)t[r] = 0;
                        return t;
                    }, v.prototype.mulp = function(e, t, r) {
                        var n = 2 * this.guessLen13b(e.length, t.length), i = this.makeRBT(n), s = this.stub(n), o = new Array(n), a = new Array(n), l = new Array(n), c = new Array(n), u = new Array(n), h = new Array(n), f = r.words;
                        f.length = n, this.convert13b(e.words, e.length, o, n), this.convert13b(t.words, t.length, c, n), this.transform(o, s, a, l, n, i), this.transform(c, s, u, h, n, i);
                        for(var d = 0; d < n; d++){
                            var p = a[d] * u[d] - l[d] * h[d];
                            l[d] = a[d] * h[d] + l[d] * u[d], a[d] = p;
                        }
                        return this.conjugate(a, l, n), this.transform(a, l, f, s, n, i), this.conjugate(f, s, n), this.normalize13b(f, n), r.negative = e.negative ^ t.negative, r.length = e.length + t.length, r._strip();
                    }, s.prototype.mul = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), this.mulTo(e, t);
                    }, s.prototype.mulf = function(e) {
                        var t = new s(null);
                        return t.words = new Array(this.length + e.length), y(this, e, t);
                    }, s.prototype.imul = function(e) {
                        return this.clone().mulTo(e, this);
                    }, s.prototype.imuln = function(e) {
                        var t = e < 0;
                        t && (e = -e), n("number" == typeof e), n(e < 67108864);
                        for(var r = 0, i = 0; i < this.length; i++){
                            var s = (0 | this.words[i]) * e, o = (67108863 & s) + (67108863 & r);
                            r >>= 26, r += s / 67108864 | 0, r += o >>> 26, this.words[i] = 67108863 & o;
                        }
                        return 0 !== r && (this.words[i] = r, this.length++), t ? this.ineg() : this;
                    }, s.prototype.muln = function(e) {
                        return this.clone().imuln(e);
                    }, s.prototype.sqr = function() {
                        return this.mul(this);
                    }, s.prototype.isqr = function() {
                        return this.imul(this.clone());
                    }, s.prototype.pow = function(e) {
                        var t = function(e) {
                            for(var t = new Array(e.bitLength()), r = 0; r < t.length; r++){
                                var n = r / 26 | 0, i = r % 26;
                                t[r] = e.words[n] >>> i & 1;
                            }
                            return t;
                        }(e);
                        if (0 === t.length) return new s(1);
                        for(var r = this, n = 0; n < t.length && 0 === t[n]; n++, r = r.sqr());
                        if (++n < t.length) for(var i = r.sqr(); n < t.length; n++, i = i.sqr())0 !== t[n] && (r = r.mul(i));
                        return r;
                    }, s.prototype.iushln = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t, r = e % 26, i = (e - r) / 26, s = 67108863 >>> 26 - r << 26 - r;
                        if (0 !== r) {
                            var o = 0;
                            for(t = 0; t < this.length; t++){
                                var a = this.words[t] & s, l = (0 | this.words[t]) - a << r;
                                this.words[t] = l | o, o = a >>> 26 - r;
                            }
                            o && (this.words[t] = o, this.length++);
                        }
                        if (0 !== i) {
                            for(t = this.length - 1; t >= 0; t--)this.words[t + i] = this.words[t];
                            for(t = 0; t < i; t++)this.words[t] = 0;
                            this.length += i;
                        }
                        return this._strip();
                    }, s.prototype.ishln = function(e) {
                        return n(0 === this.negative), this.iushln(e);
                    }, s.prototype.iushrn = function(e, t, r) {
                        var i;
                        n("number" == typeof e && e >= 0), i = t ? (t - t % 26) / 26 : 0;
                        var s = e % 26, o = Math.min((e - s) / 26, this.length), a = 67108863 ^ 67108863 >>> s << s, l = r;
                        if (i -= o, i = Math.max(0, i), l) {
                            for(var c = 0; c < o; c++)l.words[c] = this.words[c];
                            l.length = o;
                        }
                        if (0 === o) ;
                        else if (this.length > o) for(this.length -= o, c = 0; c < this.length; c++)this.words[c] = this.words[c + o];
                        else this.words[0] = 0, this.length = 1;
                        var u = 0;
                        for(c = this.length - 1; c >= 0 && (0 !== u || c >= i); c--){
                            var h = 0 | this.words[c];
                            this.words[c] = u << 26 - s | h >>> s, u = h & a;
                        }
                        return l && 0 !== u && (l.words[l.length++] = u), 0 === this.length && (this.words[0] = 0, this.length = 1), this._strip();
                    }, s.prototype.ishrn = function(e, t, r) {
                        return n(0 === this.negative), this.iushrn(e, t, r);
                    }, s.prototype.shln = function(e) {
                        return this.clone().ishln(e);
                    }, s.prototype.ushln = function(e) {
                        return this.clone().iushln(e);
                    }, s.prototype.shrn = function(e) {
                        return this.clone().ishrn(e);
                    }, s.prototype.ushrn = function(e) {
                        return this.clone().iushrn(e);
                    }, s.prototype.testn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        return !(this.length <= r) && !!(this.words[r] & i);
                    }, s.prototype.imaskn = function(e) {
                        n("number" == typeof e && e >= 0);
                        var t = e % 26, r = (e - t) / 26;
                        if (n(0 === this.negative, "imaskn works only with positive numbers"), this.length <= r) return this;
                        if (0 !== t && r++, this.length = Math.min(r, this.length), 0 !== t) {
                            var i = 67108863 ^ 67108863 >>> t << t;
                            this.words[this.length - 1] &= i;
                        }
                        return this._strip();
                    }, s.prototype.maskn = function(e) {
                        return this.clone().imaskn(e);
                    }, s.prototype.iaddn = function(e) {
                        return n("number" == typeof e), n(e < 67108864), e < 0 ? this.isubn(-e) : 0 !== this.negative ? 1 === this.length && (0 | this.words[0]) <= e ? (this.words[0] = e - (0 | this.words[0]), this.negative = 0, this) : (this.negative = 0, this.isubn(e), this.negative = 1, this) : this._iaddn(e);
                    }, s.prototype._iaddn = function(e) {
                        this.words[0] += e;
                        for(var t = 0; t < this.length && this.words[t] >= 67108864; t++)this.words[t] -= 67108864, t === this.length - 1 ? this.words[t + 1] = 1 : this.words[t + 1]++;
                        return this.length = Math.max(this.length, t + 1), this;
                    }, s.prototype.isubn = function(e) {
                        if (n("number" == typeof e), n(e < 67108864), e < 0) return this.iaddn(-e);
                        if (0 !== this.negative) return this.negative = 0, this.iaddn(e), this.negative = 1, this;
                        if (this.words[0] -= e, 1 === this.length && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                        else for(var t = 0; t < this.length && this.words[t] < 0; t++)this.words[t] += 67108864, this.words[t + 1] -= 1;
                        return this._strip();
                    }, s.prototype.addn = function(e) {
                        return this.clone().iaddn(e);
                    }, s.prototype.subn = function(e) {
                        return this.clone().isubn(e);
                    }, s.prototype.iabs = function() {
                        return this.negative = 0, this;
                    }, s.prototype.abs = function() {
                        return this.clone().iabs();
                    }, s.prototype._ishlnsubmul = function(e, t, r) {
                        var i, s, o = e.length + r;
                        this._expand(o);
                        var a = 0;
                        for(i = 0; i < e.length; i++){
                            s = (0 | this.words[i + r]) + a;
                            var l = (0 | e.words[i]) * t;
                            a = ((s -= 67108863 & l) >> 26) - (l / 67108864 | 0), this.words[i + r] = 67108863 & s;
                        }
                        for(; i < this.length - r; i++)a = (s = (0 | this.words[i + r]) + a) >> 26, this.words[i + r] = 67108863 & s;
                        if (0 === a) return this._strip();
                        for(n(-1 === a), a = 0, i = 0; i < this.length; i++)a = (s = -(0 | this.words[i]) + a) >> 26, this.words[i] = 67108863 & s;
                        return this.negative = 1, this._strip();
                    }, s.prototype._wordDiv = function(e, t) {
                        var r = (this.length, e.length), n = this.clone(), i = e, o = 0 | i.words[i.length - 1];
                        0 !== (r = 26 - this._countBits(o)) && (i = i.ushln(r), n.iushln(r), o = 0 | i.words[i.length - 1]);
                        var a, l = n.length - i.length;
                        if ("mod" !== t) {
                            (a = new s(null)).length = l + 1, a.words = new Array(a.length);
                            for(var c = 0; c < a.length; c++)a.words[c] = 0;
                        }
                        var u = n.clone()._ishlnsubmul(i, 1, l);
                        0 === u.negative && (n = u, a && (a.words[l] = 1));
                        for(var h = l - 1; h >= 0; h--){
                            var f = 67108864 * (0 | n.words[i.length + h]) + (0 | n.words[i.length + h - 1]);
                            for(f = Math.min(f / o | 0, 67108863), n._ishlnsubmul(i, f, h); 0 !== n.negative;)f--, n.negative = 0, n._ishlnsubmul(i, 1, h), n.isZero() || (n.negative ^= 1);
                            a && (a.words[h] = f);
                        }
                        return a && a._strip(), n._strip(), "div" !== t && 0 !== r && n.iushrn(r), {
                            div: a || null,
                            mod: n
                        };
                    }, s.prototype.divmod = function(e, t, r) {
                        var i, o, a;
                        return n(!e.isZero()), this.isZero() ? {
                            div: new s(0),
                            mod: new s(0)
                        } : 0 !== this.negative && 0 === e.negative ? (a = this.neg().divmod(e, t), "mod" !== t && (i = a.div.neg()), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.iadd(e)), {
                            div: i,
                            mod: o
                        }) : 0 === this.negative && 0 !== e.negative ? (a = this.divmod(e.neg(), t), "mod" !== t && (i = a.div.neg()), {
                            div: i,
                            mod: a.mod
                        }) : 0 != (this.negative & e.negative) ? (a = this.neg().divmod(e.neg(), t), "div" !== t && (o = a.mod.neg(), r && 0 !== o.negative && o.isub(e)), {
                            div: a.div,
                            mod: o
                        }) : e.length > this.length || this.cmp(e) < 0 ? {
                            div: new s(0),
                            mod: this
                        } : 1 === e.length ? "div" === t ? {
                            div: this.divn(e.words[0]),
                            mod: null
                        } : "mod" === t ? {
                            div: null,
                            mod: new s(this.modrn(e.words[0]))
                        } : {
                            div: this.divn(e.words[0]),
                            mod: new s(this.modrn(e.words[0]))
                        } : this._wordDiv(e, t);
                    }, s.prototype.div = function(e) {
                        return this.divmod(e, "div", !1).div;
                    }, s.prototype.mod = function(e) {
                        return this.divmod(e, "mod", !1).mod;
                    }, s.prototype.umod = function(e) {
                        return this.divmod(e, "mod", !0).mod;
                    }, s.prototype.divRound = function(e) {
                        var t = this.divmod(e);
                        if (t.mod.isZero()) return t.div;
                        var r = 0 !== t.div.negative ? t.mod.isub(e) : t.mod, n = e.ushrn(1), i = e.andln(1), s = r.cmp(n);
                        return s < 0 || 1 === i && 0 === s ? t.div : 0 !== t.div.negative ? t.div.isubn(1) : t.div.iaddn(1);
                    }, s.prototype.modrn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 67108864 % e, i = 0, s = this.length - 1; s >= 0; s--)i = (r * i + (0 | this.words[s])) % e;
                        return t ? -i : i;
                    }, s.prototype.modn = function(e) {
                        return this.modrn(e);
                    }, s.prototype.idivn = function(e) {
                        var t = e < 0;
                        t && (e = -e), n(e <= 67108863);
                        for(var r = 0, i = this.length - 1; i >= 0; i--){
                            var s = (0 | this.words[i]) + 67108864 * r;
                            this.words[i] = s / e | 0, r = s % e;
                        }
                        return this._strip(), t ? this.ineg() : this;
                    }, s.prototype.divn = function(e) {
                        return this.clone().idivn(e);
                    }, s.prototype.egcd = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i = new s(1), o = new s(0), a = new s(0), l = new s(1), c = 0; t.isEven() && r.isEven();)t.iushrn(1), r.iushrn(1), ++c;
                        for(var u = r.clone(), h = t.clone(); !t.isZero();){
                            for(var f = 0, d = 1; 0 == (t.words[0] & d) && f < 26; ++f, d <<= 1);
                            if (f > 0) for(t.iushrn(f); f-- > 0;)(i.isOdd() || o.isOdd()) && (i.iadd(u), o.isub(h)), i.iushrn(1), o.iushrn(1);
                            for(var p = 0, m = 1; 0 == (r.words[0] & m) && p < 26; ++p, m <<= 1);
                            if (p > 0) for(r.iushrn(p); p-- > 0;)(a.isOdd() || l.isOdd()) && (a.iadd(u), l.isub(h)), a.iushrn(1), l.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), i.isub(a), o.isub(l)) : (r.isub(t), a.isub(i), l.isub(o));
                        }
                        return {
                            a: a,
                            b: l,
                            gcd: r.iushln(c)
                        };
                    }, s.prototype._invmp = function(e) {
                        n(0 === e.negative), n(!e.isZero());
                        var t = this, r = e.clone();
                        t = 0 !== t.negative ? t.umod(e) : t.clone();
                        for(var i, o = new s(1), a = new s(0), l = r.clone(); t.cmpn(1) > 0 && r.cmpn(1) > 0;){
                            for(var c = 0, u = 1; 0 == (t.words[0] & u) && c < 26; ++c, u <<= 1);
                            if (c > 0) for(t.iushrn(c); c-- > 0;)o.isOdd() && o.iadd(l), o.iushrn(1);
                            for(var h = 0, f = 1; 0 == (r.words[0] & f) && h < 26; ++h, f <<= 1);
                            if (h > 0) for(r.iushrn(h); h-- > 0;)a.isOdd() && a.iadd(l), a.iushrn(1);
                            t.cmp(r) >= 0 ? (t.isub(r), o.isub(a)) : (r.isub(t), a.isub(o));
                        }
                        return (i = 0 === t.cmpn(1) ? o : a).cmpn(0) < 0 && i.iadd(e), i;
                    }, s.prototype.gcd = function(e) {
                        if (this.isZero()) return e.abs();
                        if (e.isZero()) return this.abs();
                        var t = this.clone(), r = e.clone();
                        t.negative = 0, r.negative = 0;
                        for(var n = 0; t.isEven() && r.isEven(); n++)t.iushrn(1), r.iushrn(1);
                        for(;;){
                            for(; t.isEven();)t.iushrn(1);
                            for(; r.isEven();)r.iushrn(1);
                            var i = t.cmp(r);
                            if (i < 0) {
                                var s = t;
                                t = r, r = s;
                            } else if (0 === i || 0 === r.cmpn(1)) break;
                            t.isub(r);
                        }
                        return r.iushln(n);
                    }, s.prototype.invm = function(e) {
                        return this.egcd(e).a.umod(e);
                    }, s.prototype.isEven = function() {
                        return 0 == (1 & this.words[0]);
                    }, s.prototype.isOdd = function() {
                        return 1 == (1 & this.words[0]);
                    }, s.prototype.andln = function(e) {
                        return this.words[0] & e;
                    }, s.prototype.bincn = function(e) {
                        n("number" == typeof e);
                        var t = e % 26, r = (e - t) / 26, i = 1 << t;
                        if (this.length <= r) return this._expand(r + 1), this.words[r] |= i, this;
                        for(var s = i, o = r; 0 !== s && o < this.length; o++){
                            var a = 0 | this.words[o];
                            s = (a += s) >>> 26, a &= 67108863, this.words[o] = a;
                        }
                        return 0 !== s && (this.words[o] = s, this.length++), this;
                    }, s.prototype.isZero = function() {
                        return 1 === this.length && 0 === this.words[0];
                    }, s.prototype.cmpn = function(e) {
                        var t, r = e < 0;
                        if (0 !== this.negative && !r) return -1;
                        if (0 === this.negative && r) return 1;
                        if (this._strip(), this.length > 1) t = 1;
                        else {
                            r && (e = -e), n(e <= 67108863, "Number is too big");
                            var i = 0 | this.words[0];
                            t = i === e ? 0 : i < e ? -1 : 1;
                        }
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.cmp = function(e) {
                        if (0 !== this.negative && 0 === e.negative) return -1;
                        if (0 === this.negative && 0 !== e.negative) return 1;
                        var t = this.ucmp(e);
                        return 0 !== this.negative ? 0 | -t : t;
                    }, s.prototype.ucmp = function(e) {
                        if (this.length > e.length) return 1;
                        if (this.length < e.length) return -1;
                        for(var t = 0, r = this.length - 1; r >= 0; r--){
                            var n = 0 | this.words[r], i = 0 | e.words[r];
                            if (n !== i) {
                                n < i ? t = -1 : n > i && (t = 1);
                                break;
                            }
                        }
                        return t;
                    }, s.prototype.gtn = function(e) {
                        return 1 === this.cmpn(e);
                    }, s.prototype.gt = function(e) {
                        return 1 === this.cmp(e);
                    }, s.prototype.gten = function(e) {
                        return this.cmpn(e) >= 0;
                    }, s.prototype.gte = function(e) {
                        return this.cmp(e) >= 0;
                    }, s.prototype.ltn = function(e) {
                        return -1 === this.cmpn(e);
                    }, s.prototype.lt = function(e) {
                        return -1 === this.cmp(e);
                    }, s.prototype.lten = function(e) {
                        return this.cmpn(e) <= 0;
                    }, s.prototype.lte = function(e) {
                        return this.cmp(e) <= 0;
                    }, s.prototype.eqn = function(e) {
                        return 0 === this.cmpn(e);
                    }, s.prototype.eq = function(e) {
                        return 0 === this.cmp(e);
                    }, s.red = function(e) {
                        return new C(e);
                    }, s.prototype.toRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), n(0 === this.negative, "red works only with positives"), e.convertTo(this)._forceRed(e);
                    }, s.prototype.fromRed = function() {
                        return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                    }, s.prototype._forceRed = function(e) {
                        return this.red = e, this;
                    }, s.prototype.forceRed = function(e) {
                        return n(!this.red, "Already a number in reduction context"), this._forceRed(e);
                    }, s.prototype.redAdd = function(e) {
                        return n(this.red, "redAdd works only with red numbers"), this.red.add(this, e);
                    }, s.prototype.redIAdd = function(e) {
                        return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, e);
                    }, s.prototype.redSub = function(e) {
                        return n(this.red, "redSub works only with red numbers"), this.red.sub(this, e);
                    }, s.prototype.redISub = function(e) {
                        return n(this.red, "redISub works only with red numbers"), this.red.isub(this, e);
                    }, s.prototype.redShl = function(e) {
                        return n(this.red, "redShl works only with red numbers"), this.red.shl(this, e);
                    }, s.prototype.redMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.mul(this, e);
                    }, s.prototype.redIMul = function(e) {
                        return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, e), this.red.imul(this, e);
                    }, s.prototype.redSqr = function() {
                        return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                    }, s.prototype.redISqr = function() {
                        return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                    }, s.prototype.redSqrt = function() {
                        return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                    }, s.prototype.redInvm = function() {
                        return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                    }, s.prototype.redNeg = function() {
                        return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                    }, s.prototype.redPow = function(e) {
                        return n(this.red && !e.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, e);
                    };
                    var w = {
                        k256: null,
                        p224: null,
                        p192: null,
                        p25519: null
                    };
                    function _(e, t) {
                        this.name = e, this.p = new s(t, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                    }
                    function x() {
                        _.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                    }
                    function k() {
                        _.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                    }
                    function S() {
                        _.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                    }
                    function M() {
                        _.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                    }
                    function C(e) {
                        if ("string" == typeof e) {
                            var t = s._prime(e);
                            this.m = t.p, this.prime = t;
                        } else n(e.gtn(1), "modulus must be greater than 1"), this.m = e, this.prime = null;
                    }
                    function T(e) {
                        C.call(this, e), this.shift = this.m.bitLength(), this.shift % 26 != 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                    }
                    _.prototype._tmp = function() {
                        var e = new s(null);
                        return e.words = new Array(Math.ceil(this.n / 13)), e;
                    }, _.prototype.ireduce = function(e) {
                        var t, r = e;
                        do this.split(r, this.tmp), t = (r = (r = this.imulK(r)).iadd(this.tmp)).bitLength();
                        while (t > this.n);
                        var n = t < this.n ? -1 : r.ucmp(this.p);
                        return 0 === n ? (r.words[0] = 0, r.length = 1) : n > 0 ? r.isub(this.p) : void 0 !== r.strip ? r.strip() : r._strip(), r;
                    }, _.prototype.split = function(e, t) {
                        e.iushrn(this.n, 0, t);
                    }, _.prototype.imulK = function(e) {
                        return e.imul(this.k);
                    }, i(x, _), x.prototype.split = function(e, t) {
                        for(var r = Math.min(e.length, 9), n = 0; n < r; n++)t.words[n] = e.words[n];
                        if (t.length = r, e.length <= 9) return e.words[0] = 0, void (e.length = 1);
                        var i = e.words[9];
                        for(t.words[t.length++] = 4194303 & i, n = 10; n < e.length; n++){
                            var s = 0 | e.words[n];
                            e.words[n - 10] = (4194303 & s) << 4 | i >>> 22, i = s;
                        }
                        i >>>= 22, e.words[n - 10] = i, 0 === i && e.length > 10 ? e.length -= 10 : e.length -= 9;
                    }, x.prototype.imulK = function(e) {
                        e.words[e.length] = 0, e.words[e.length + 1] = 0, e.length += 2;
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 0 | e.words[r];
                            t += 977 * n, e.words[r] = 67108863 & t, t = 64 * n + (t / 67108864 | 0);
                        }
                        return 0 === e.words[e.length - 1] && (e.length--, 0 === e.words[e.length - 1] && e.length--), e;
                    }, i(k, _), i(S, _), i(M, _), M.prototype.imulK = function(e) {
                        for(var t = 0, r = 0; r < e.length; r++){
                            var n = 19 * (0 | e.words[r]) + t, i = 67108863 & n;
                            n >>>= 26, e.words[r] = i, t = n;
                        }
                        return 0 !== t && (e.words[e.length++] = t), e;
                    }, s._prime = function(e) {
                        if (w[e]) return w[e];
                        var t;
                        if ("k256" === e) t = new x;
                        else if ("p224" === e) t = new k;
                        else if ("p192" === e) t = new S;
                        else {
                            if ("p25519" !== e) throw new Error("Unknown prime " + e);
                            t = new M;
                        }
                        return w[e] = t, t;
                    }, C.prototype._verify1 = function(e) {
                        n(0 === e.negative, "red works only with positives"), n(e.red, "red works only with red numbers");
                    }, C.prototype._verify2 = function(e, t) {
                        n(0 == (e.negative | t.negative), "red works only with positives"), n(e.red && e.red === t.red, "red works only with red numbers");
                    }, C.prototype.imod = function(e) {
                        return this.prime ? this.prime.ireduce(e)._forceRed(this) : (u(e, e.umod(this.m)._forceRed(this)), e);
                    }, C.prototype.neg = function(e) {
                        return e.isZero() ? e.clone() : this.m.sub(e)._forceRed(this);
                    }, C.prototype.add = function(e, t) {
                        this._verify2(e, t);
                        var r = e.add(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r._forceRed(this);
                    }, C.prototype.iadd = function(e, t) {
                        this._verify2(e, t);
                        var r = e.iadd(t);
                        return r.cmp(this.m) >= 0 && r.isub(this.m), r;
                    }, C.prototype.sub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.sub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r._forceRed(this);
                    }, C.prototype.isub = function(e, t) {
                        this._verify2(e, t);
                        var r = e.isub(t);
                        return r.cmpn(0) < 0 && r.iadd(this.m), r;
                    }, C.prototype.shl = function(e, t) {
                        return this._verify1(e), this.imod(e.ushln(t));
                    }, C.prototype.imul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.imul(t));
                    }, C.prototype.mul = function(e, t) {
                        return this._verify2(e, t), this.imod(e.mul(t));
                    }, C.prototype.isqr = function(e) {
                        return this.imul(e, e.clone());
                    }, C.prototype.sqr = function(e) {
                        return this.mul(e, e);
                    }, C.prototype.sqrt = function(e) {
                        if (e.isZero()) return e.clone();
                        var t = this.m.andln(3);
                        if (n(t % 2 == 1), 3 === t) {
                            var r = this.m.add(new s(1)).iushrn(2);
                            return this.pow(e, r);
                        }
                        for(var i = this.m.subn(1), o = 0; !i.isZero() && 0 === i.andln(1);)o++, i.iushrn(1);
                        n(!i.isZero());
                        var a = new s(1).toRed(this), l = a.redNeg(), c = this.m.subn(1).iushrn(1), u = this.m.bitLength();
                        for(u = new s(2 * u * u).toRed(this); 0 !== this.pow(u, c).cmp(l);)u.redIAdd(l);
                        for(var h = this.pow(u, i), f = this.pow(e, i.addn(1).iushrn(1)), d = this.pow(e, i), p = o; 0 !== d.cmp(a);){
                            for(var m = d, b = 0; 0 !== m.cmp(a); b++)m = m.redSqr();
                            n(b < p);
                            var g = this.pow(h, new s(1).iushln(p - b - 1));
                            f = f.redMul(g), h = g.redSqr(), d = d.redMul(h), p = b;
                        }
                        return f;
                    }, C.prototype.invm = function(e) {
                        var t = e._invmp(this.m);
                        return 0 !== t.negative ? (t.negative = 0, this.imod(t).redNeg()) : this.imod(t);
                    }, C.prototype.pow = function(e, t) {
                        if (t.isZero()) return new s(1).toRed(this);
                        if (0 === t.cmpn(1)) return e.clone();
                        var r = new Array(16);
                        r[0] = new s(1).toRed(this), r[1] = e;
                        for(var n = 2; n < r.length; n++)r[n] = this.mul(r[n - 1], e);
                        var i = r[0], o = 0, a = 0, l = t.bitLength() % 26;
                        for(0 === l && (l = 26), n = t.length - 1; n >= 0; n--){
                            for(var c = t.words[n], u = l - 1; u >= 0; u--){
                                var h = c >> u & 1;
                                i !== r[0] && (i = this.sqr(i)), 0 !== h || 0 !== o ? (o <<= 1, o |= h, (4 === ++a || 0 === n && 0 === u) && (i = this.mul(i, r[o]), a = 0, o = 0)) : a = 0;
                            }
                            l = 26;
                        }
                        return i;
                    }, C.prototype.convertTo = function(e) {
                        var t = e.umod(this.m);
                        return t === e ? t.clone() : t;
                    }, C.prototype.convertFrom = function(e) {
                        var t = e.clone();
                        return t.red = null, t;
                    }, s.mont = function(e) {
                        return new T(e);
                    }, i(T, C), T.prototype.convertTo = function(e) {
                        return this.imod(e.ushln(this.shift));
                    }, T.prototype.convertFrom = function(e) {
                        var t = this.imod(e.mul(this.rinv));
                        return t.red = null, t;
                    }, T.prototype.imul = function(e, t) {
                        if (e.isZero() || t.isZero()) return e.words[0] = 0, e.length = 1, e;
                        var r = e.imul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), s = i;
                        return i.cmp(this.m) >= 0 ? s = i.isub(this.m) : i.cmpn(0) < 0 && (s = i.iadd(this.m)), s._forceRed(this);
                    }, T.prototype.mul = function(e, t) {
                        if (e.isZero() || t.isZero()) return new s(0)._forceRed(this);
                        var r = e.mul(t), n = r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), i = r.isub(n).iushrn(this.shift), o = i;
                        return i.cmp(this.m) >= 0 ? o = i.isub(this.m) : i.cmpn(0) < 0 && (o = i.iadd(this.m)), o._forceRed(this);
                    }, T.prototype.invm = function(e) {
                        return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this);
                    };
                }(void 0 === t || t);
            },
            {
                buffer: 188
            }
        ],
        187: [
            function(e, t, r) {
                "use strict";
                var n;
                function i(e) {
                    this.rand = e;
                }
                if (t.exports = function(e) {
                    return n || (n = new i(null)), n.generate(e);
                }, t.exports.Rand = i, i.prototype.generate = function(e) {
                    return this._rand(e);
                }, i.prototype._rand = function(e) {
                    if (this.rand.getBytes) return this.rand.getBytes(e);
                    for(var t = new Uint8Array(e), r = 0; r < t.length; r++)t[r] = this.rand.getByte();
                    return t;
                }, "object" == typeof self) self.crypto && self.crypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.crypto.getRandomValues(t), t;
                } : self.msCrypto && self.msCrypto.getRandomValues ? i.prototype._rand = function(e) {
                    var t = new Uint8Array(e);
                    return self.msCrypto.getRandomValues(t), t;
                } : "object" == typeof window && (i.prototype._rand = function() {
                    throw new Error("Not implemented yet");
                });
                else try {
                    var s = e("crypto");
                    if ("function" != typeof s.randomBytes) throw new Error("Not supported");
                    i.prototype._rand = function(e) {
                        return s.randomBytes(e);
                    };
                } catch (e) {}
            },
            {
                crypto: 188
            }
        ],
        188: [
            function(e, t, r) {},
            {}
        ],
        189: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e) {
                    n.isBuffer(e) || (e = n.from(e));
                    for(var t = e.length / 4 | 0, r = new Array(t), i = 0; i < t; i++)r[i] = e.readUInt32BE(4 * i);
                    return r;
                }
                function s(e) {
                    for(; 0 < e.length; e++)e[0] = 0;
                }
                function o(e, t, r, n, i) {
                    for(var s, o, a, l, c = r[0], u = r[1], h = r[2], f = r[3], d = e[0] ^ t[0], p = e[1] ^ t[1], m = e[2] ^ t[2], b = e[3] ^ t[3], g = 4, y = 1; y < i; y++)s = c[d >>> 24] ^ u[p >>> 16 & 255] ^ h[m >>> 8 & 255] ^ f[255 & b] ^ t[g++], o = c[p >>> 24] ^ u[m >>> 16 & 255] ^ h[b >>> 8 & 255] ^ f[255 & d] ^ t[g++], a = c[m >>> 24] ^ u[b >>> 16 & 255] ^ h[d >>> 8 & 255] ^ f[255 & p] ^ t[g++], l = c[b >>> 24] ^ u[d >>> 16 & 255] ^ h[p >>> 8 & 255] ^ f[255 & m] ^ t[g++], d = s, p = o, m = a, b = l;
                    return s = (n[d >>> 24] << 24 | n[p >>> 16 & 255] << 16 | n[m >>> 8 & 255] << 8 | n[255 & b]) ^ t[g++], o = (n[p >>> 24] << 24 | n[m >>> 16 & 255] << 16 | n[b >>> 8 & 255] << 8 | n[255 & d]) ^ t[g++], a = (n[m >>> 24] << 24 | n[b >>> 16 & 255] << 16 | n[d >>> 8 & 255] << 8 | n[255 & p]) ^ t[g++], l = (n[b >>> 24] << 24 | n[d >>> 16 & 255] << 16 | n[p >>> 8 & 255] << 8 | n[255 & m]) ^ t[g++], [
                        s >>>= 0,
                        o >>>= 0,
                        a >>>= 0,
                        l >>>= 0
                    ];
                }
                var a = [
                    0,
                    1,
                    2,
                    4,
                    8,
                    16,
                    32,
                    64,
                    128,
                    27,
                    54
                ], l = function() {
                    for(var e = new Array(256), t = 0; t < 256; t++)e[t] = t < 128 ? t << 1 : t << 1 ^ 283;
                    for(var r = [], n = [], i = [
                        [],
                        [],
                        [],
                        []
                    ], s = [
                        [],
                        [],
                        [],
                        []
                    ], o = 0, a = 0, l = 0; l < 256; ++l){
                        var c = a ^ a << 1 ^ a << 2 ^ a << 3 ^ a << 4;
                        c = c >>> 8 ^ 255 & c ^ 99, r[o] = c, n[c] = o;
                        var u = e[o], h = e[u], f = e[h], d = 257 * e[c] ^ 16843008 * c;
                        i[0][o] = d << 24 | d >>> 8, i[1][o] = d << 16 | d >>> 16, i[2][o] = d << 8 | d >>> 24, i[3][o] = d, d = 16843009 * f ^ 65537 * h ^ 257 * u ^ 16843008 * o, s[0][c] = d << 24 | d >>> 8, s[1][c] = d << 16 | d >>> 16, s[2][c] = d << 8 | d >>> 24, s[3][c] = d, 0 === o ? o = a = 1 : (o = u ^ e[e[e[f ^ u]]], a ^= e[e[a]]);
                    }
                    return {
                        SBOX: r,
                        INV_SBOX: n,
                        SUB_MIX: i,
                        INV_SUB_MIX: s
                    };
                }();
                function c(e) {
                    this._key = i(e), this._reset();
                }
                c.blockSize = 16, c.keySize = 32, c.prototype.blockSize = c.blockSize, c.prototype.keySize = c.keySize, c.prototype._reset = function() {
                    for(var e = this._key, t = e.length, r = t + 6, n = 4 * (r + 1), i = [], s = 0; s < t; s++)i[s] = e[s];
                    for(s = t; s < n; s++){
                        var o = i[s - 1];
                        s % t == 0 ? (o = o << 8 | o >>> 24, o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o], o ^= a[s / t | 0] << 24) : t > 6 && s % t == 4 && (o = l.SBOX[o >>> 24] << 24 | l.SBOX[o >>> 16 & 255] << 16 | l.SBOX[o >>> 8 & 255] << 8 | l.SBOX[255 & o]), i[s] = i[s - t] ^ o;
                    }
                    for(var c = [], u = 0; u < n; u++){
                        var h = n - u, f = i[h - (u % 4 ? 0 : 4)];
                        c[u] = u < 4 || h <= 4 ? f : l.INV_SUB_MIX[0][l.SBOX[f >>> 24]] ^ l.INV_SUB_MIX[1][l.SBOX[f >>> 16 & 255]] ^ l.INV_SUB_MIX[2][l.SBOX[f >>> 8 & 255]] ^ l.INV_SUB_MIX[3][l.SBOX[255 & f]];
                    }
                    this._nRounds = r, this._keySchedule = i, this._invKeySchedule = c;
                }, c.prototype.encryptBlockRaw = function(e) {
                    return o(e = i(e), this._keySchedule, l.SUB_MIX, l.SBOX, this._nRounds);
                }, c.prototype.encryptBlock = function(e) {
                    var t = this.encryptBlockRaw(e), r = n.allocUnsafe(16);
                    return r.writeUInt32BE(t[0], 0), r.writeUInt32BE(t[1], 4), r.writeUInt32BE(t[2], 8), r.writeUInt32BE(t[3], 12), r;
                }, c.prototype.decryptBlock = function(e) {
                    var t = (e = i(e))[1];
                    e[1] = e[3], e[3] = t;
                    var r = o(e, this._invKeySchedule, l.INV_SUB_MIX, l.INV_SBOX, this._nRounds), s = n.allocUnsafe(16);
                    return s.writeUInt32BE(r[0], 0), s.writeUInt32BE(r[3], 4), s.writeUInt32BE(r[2], 8), s.writeUInt32BE(r[1], 12), s;
                }, c.prototype.scrub = function() {
                    s(this._keySchedule), s(this._invKeySchedule), s(this._key);
                }, t.exports.AES = c;
            },
            {
                "safe-buffer": 494
            }
        ],
        190: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = e("inherits"), a = e("./ghash"), l = e("buffer-xor"), c = e("./incr32");
                function u(e, t, r, o) {
                    s.call(this);
                    var l = i.alloc(4, 0);
                    this._cipher = new n.AES(t);
                    var u = this._cipher.encryptBlock(l);
                    this._ghash = new a(u), r = function(e, t, r) {
                        if (12 === t.length) return e._finID = i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                1
                            ])
                        ]), i.concat([
                            t,
                            i.from([
                                0,
                                0,
                                0,
                                2
                            ])
                        ]);
                        var n = new a(r), s = t.length, o = s % 16;
                        n.update(t), o && (o = 16 - o, n.update(i.alloc(o, 0))), n.update(i.alloc(8, 0));
                        var l = 8 * s, u = i.alloc(8);
                        u.writeUIntBE(l, 0, 8), n.update(u), e._finID = n.state;
                        var h = i.from(e._finID);
                        return c(h), h;
                    }(this, r, u), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._alen = 0, this._len = 0, this._mode = e, this._authTag = null, this._called = !1;
                }
                o(u, s), u.prototype._update = function(e) {
                    if (!this._called && this._alen) {
                        var t = 16 - this._alen % 16;
                        t < 16 && (t = i.alloc(t, 0), this._ghash.update(t));
                    }
                    this._called = !0;
                    var r = this._mode.encrypt(this, e);
                    return this._decrypt ? this._ghash.update(e) : this._ghash.update(r), this._len += e.length, r;
                }, u.prototype._final = function() {
                    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
                    var e = l(this._ghash.final(8 * this._alen, 8 * this._len), this._cipher.encryptBlock(this._finID));
                    if (this._decrypt && function(e, t) {
                        var r = 0;
                        e.length !== t.length && r++;
                        for(var n = Math.min(e.length, t.length), i = 0; i < n; ++i)r += e[i] ^ t[i];
                        return r;
                    }(e, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
                    this._authTag = e, this._cipher.scrub();
                }, u.prototype.getAuthTag = function() {
                    if (this._decrypt || !i.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
                    return this._authTag;
                }, u.prototype.setAuthTag = function(e) {
                    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
                    this._authTag = e;
                }, u.prototype.setAAD = function(e) {
                    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
                    this._ghash.update(e), this._alen += e.length;
                }, t.exports = u;
            },
            {
                "./aes": 189,
                "./ghash": 194,
                "./incr32": 195,
                "buffer-xor": 219,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        191: [
            function(e, t, r) {
                "use strict";
                var n = e("./encrypter"), i = e("./decrypter"), s = e("./modes/list.json");
                r.createCipher = r.Cipher = n.createCipher, r.createCipheriv = r.Cipheriv = n.createCipheriv, r.createDecipher = r.Decipher = i.createDecipher, r.createDecipheriv = r.Decipheriv = i.createDecipheriv, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(s);
                };
            },
            {
                "./decrypter": 192,
                "./encrypter": 193,
                "./modes/list.json": 203
            }
        ],
        192: [
            function(e, t, r) {
                "use strict";
                var n = e("./authCipher"), i = e("safe-buffer").Buffer, s = e("./modes"), o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new h, this._last = void 0, this._cipher = new l.AES(t), this._prev = i.from(r), this._mode = e, this._autopadding = !0;
                }
                function h() {
                    this.cache = i.allocUnsafe(0);
                }
                function f(e, t, r) {
                    var a = s[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof r && (r = i.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    if ("string" == typeof t && (t = i.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    return "stream" === a.type ? new o(a.module, t, r, !0) : "auth" === a.type ? new n(a.module, t, r, !0) : new u(a.module, t, r);
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get(this._autopadding);)r = this._mode.decrypt(this, t), n.push(r);
                    return i.concat(n);
                }, u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return function(e) {
                        var t = e[15];
                        if (t < 1 || t > 16) throw new Error("unable to decrypt data");
                        var r = -1;
                        for(; ++r < t;)if (e[r + (16 - t)] !== t) throw new Error("unable to decrypt data");
                        if (16 === t) return;
                        return e.slice(0, 16 - t);
                    }(this._mode.decrypt(this, e));
                    if (e) throw new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, h.prototype.add = function(e) {
                    this.cache = i.concat([
                        this.cache,
                        e
                    ]);
                }, h.prototype.get = function(e) {
                    var t;
                    if (e) {
                        if (this.cache.length > 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    } else if (this.cache.length >= 16) return t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), t;
                    return null;
                }, h.prototype.flush = function() {
                    if (this.cache.length) return this.cache;
                }, r.createDecipher = function(e, t) {
                    var r = s[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var n = c(t, !1, r.key, r.iv);
                    return f(e, n.key, n.iv);
                }, r.createDecipheriv = f;
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        193: [
            function(e, t, r) {
                "use strict";
                var n = e("./modes"), i = e("./authCipher"), s = e("safe-buffer").Buffer, o = e("./streamCipher"), a = e("cipher-base"), l = e("./aes"), c = e("evp_bytestokey");
                function u(e, t, r) {
                    a.call(this), this._cache = new f, this._cipher = new l.AES(t), this._prev = s.from(r), this._mode = e, this._autopadding = !0;
                }
                e("inherits")(u, a), u.prototype._update = function(e) {
                    var t, r;
                    this._cache.add(e);
                    for(var n = []; t = this._cache.get();)r = this._mode.encrypt(this, t), n.push(r);
                    return s.concat(n);
                };
                var h = s.alloc(16, 16);
                function f() {
                    this.cache = s.allocUnsafe(0);
                }
                function d(e, t, r) {
                    var a = n[e.toLowerCase()];
                    if (!a) throw new TypeError("invalid suite type");
                    if ("string" == typeof t && (t = s.from(t)), t.length !== a.key / 8) throw new TypeError("invalid key length " + t.length);
                    if ("string" == typeof r && (r = s.from(r)), "GCM" !== a.mode && r.length !== a.iv) throw new TypeError("invalid iv length " + r.length);
                    return "stream" === a.type ? new o(a.module, t, r) : "auth" === a.type ? new i(a.module, t, r) : new u(a.module, t, r);
                }
                u.prototype._final = function() {
                    var e = this._cache.flush();
                    if (this._autopadding) return e = this._mode.encrypt(this, e), this._cipher.scrub(), e;
                    if (!e.equals(h)) throw this._cipher.scrub(), new Error("data not multiple of block length");
                }, u.prototype.setAutoPadding = function(e) {
                    return this._autopadding = !!e, this;
                }, f.prototype.add = function(e) {
                    this.cache = s.concat([
                        this.cache,
                        e
                    ]);
                }, f.prototype.get = function() {
                    if (this.cache.length > 15) {
                        var e = this.cache.slice(0, 16);
                        return this.cache = this.cache.slice(16), e;
                    }
                    return null;
                }, f.prototype.flush = function() {
                    for(var e = 16 - this.cache.length, t = s.allocUnsafe(e), r = -1; ++r < e;)t.writeUInt8(e, r);
                    return s.concat([
                        this.cache,
                        t
                    ]);
                }, r.createCipheriv = d, r.createCipher = function(e, t) {
                    var r = n[e.toLowerCase()];
                    if (!r) throw new TypeError("invalid suite type");
                    var i = c(t, !1, r.key, r.iv);
                    return d(e, i.key, i.iv);
                };
            },
            {
                "./aes": 189,
                "./authCipher": 190,
                "./modes": 202,
                "./streamCipher": 205,
                "cipher-base": 221,
                evp_bytestokey: 423,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        194: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.alloc(16, 0);
                function s(e) {
                    var t = n.allocUnsafe(16);
                    return t.writeUInt32BE(e[0] >>> 0, 0), t.writeUInt32BE(e[1] >>> 0, 4), t.writeUInt32BE(e[2] >>> 0, 8), t.writeUInt32BE(e[3] >>> 0, 12), t;
                }
                function o(e) {
                    this.h = e, this.state = n.alloc(16, 0), this.cache = n.allocUnsafe(0);
                }
                o.prototype.ghash = function(e) {
                    for(var t = -1; ++t < e.length;)this.state[t] ^= e[t];
                    this._multiply();
                }, o.prototype._multiply = function() {
                    for(var e, t, r, n = [
                        (e = this.h).readUInt32BE(0),
                        e.readUInt32BE(4),
                        e.readUInt32BE(8),
                        e.readUInt32BE(12)
                    ], i = [
                        0,
                        0,
                        0,
                        0
                    ], o = -1; ++o < 128;){
                        for(0 != (this.state[~~(o / 8)] & 1 << 7 - o % 8) && (i[0] ^= n[0], i[1] ^= n[1], i[2] ^= n[2], i[3] ^= n[3]), r = 0 != (1 & n[3]), t = 3; t > 0; t--)n[t] = n[t] >>> 1 | (1 & n[t - 1]) << 31;
                        n[0] = n[0] >>> 1, r && (n[0] = n[0] ^ -520093696);
                    }
                    this.state = s(i);
                }, o.prototype.update = function(e) {
                    var t;
                    for(this.cache = n.concat([
                        this.cache,
                        e
                    ]); this.cache.length >= 16;)t = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(t);
                }, o.prototype.final = function(e, t) {
                    return this.cache.length && this.ghash(n.concat([
                        this.cache,
                        i
                    ], 16)), this.ghash(s([
                        0,
                        e,
                        0,
                        t
                    ])), this.state;
                }, t.exports = o;
            },
            {
                "safe-buffer": 494
            }
        ],
        195: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    for(var t, r = e.length; r--;){
                        if (255 !== (t = e.readUInt8(r))) {
                            t++, e.writeUInt8(t, r);
                            break;
                        }
                        e.writeUInt8(0, r);
                    }
                };
            },
            {}
        ],
        196: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor");
                r.encrypt = function(e, t) {
                    var r = n(t, e._prev);
                    return e._prev = e._cipher.encryptBlock(r), e._prev;
                }, r.decrypt = function(e, t) {
                    var r = e._prev;
                    e._prev = t;
                    var i = e._cipher.decryptBlock(t);
                    return n(i, r);
                };
            },
            {
                "buffer-xor": 219
            }
        ],
        197: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("buffer-xor");
                function s(e, t, r) {
                    var s = t.length, o = i(t, e._cache);
                    return e._cache = e._cache.slice(s), e._prev = n.concat([
                        e._prev,
                        r ? t : o
                    ]), o;
                }
                r.encrypt = function(e, t, r) {
                    for(var i, o = n.allocUnsafe(0); t.length;){
                        if (0 === e._cache.length && (e._cache = e._cipher.encryptBlock(e._prev), e._prev = n.allocUnsafe(0)), !(e._cache.length <= t.length)) {
                            o = n.concat([
                                o,
                                s(e, t, r)
                            ]);
                            break;
                        }
                        i = e._cache.length, o = n.concat([
                            o,
                            s(e, t.slice(0, i), r)
                        ]), t = t.slice(i);
                    }
                    return o;
                };
            },
            {
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        198: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    for(var n, i, o = -1, a = 0; ++o < 8;)n = t & 1 << 7 - o ? 128 : 0, a += (128 & (i = e._cipher.encryptBlock(e._prev)[0] ^ n)) >> o % 8, e._prev = s(e._prev, r ? n : i);
                    return a;
                }
                function s(e, t) {
                    var r = e.length, i = -1, s = n.allocUnsafe(e.length);
                    for(e = n.concat([
                        e,
                        n.from([
                            t
                        ])
                    ]); ++i < r;)s[i] = e[i] << 1 | e[i + 1] >> 7;
                    return s;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        199: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t, r) {
                    var i = e._cipher.encryptBlock(e._prev)[0] ^ t;
                    return e._prev = n.concat([
                        e._prev.slice(1),
                        n.from([
                            r ? t : i
                        ])
                    ]), i;
                }
                r.encrypt = function(e, t, r) {
                    for(var s = t.length, o = n.allocUnsafe(s), a = -1; ++a < s;)o[a] = i(e, t[a], r);
                    return o;
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        200: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer-xor"), i = e("safe-buffer").Buffer, s = e("../incr32");
                function o(e) {
                    var t = e._cipher.encryptBlockRaw(e._prev);
                    return s(e._prev), t;
                }
                r.encrypt = function(e, t) {
                    var r = Math.ceil(t.length / 16), s = e._cache.length;
                    e._cache = i.concat([
                        e._cache,
                        i.allocUnsafe(16 * r)
                    ]);
                    for(var a = 0; a < r; a++){
                        var l = o(e), c = s + 16 * a;
                        e._cache.writeUInt32BE(l[0], c + 0), e._cache.writeUInt32BE(l[1], c + 4), e._cache.writeUInt32BE(l[2], c + 8), e._cache.writeUInt32BE(l[3], c + 12);
                    }
                    var u = e._cache.slice(0, t.length);
                    return e._cache = e._cache.slice(t.length), n(t, u);
                };
            },
            {
                "../incr32": 195,
                "buffer-xor": 219,
                "safe-buffer": 494
            }
        ],
        201: [
            function(e, t, r) {
                "use strict";
                r.encrypt = function(e, t) {
                    return e._cipher.encryptBlock(t);
                }, r.decrypt = function(e, t) {
                    return e._cipher.decryptBlock(t);
                };
            },
            {}
        ],
        202: [
            function(e, t, r) {
                "use strict";
                var n = {
                    ECB: e("./ecb"),
                    CBC: e("./cbc"),
                    CFB: e("./cfb"),
                    CFB8: e("./cfb8"),
                    CFB1: e("./cfb1"),
                    OFB: e("./ofb"),
                    CTR: e("./ctr"),
                    GCM: e("./ctr")
                }, i = e("./list.json");
                for(var s in i)i[s].module = n[i[s].mode];
                t.exports = i;
            },
            {
                "./cbc": 196,
                "./cfb": 197,
                "./cfb1": 198,
                "./cfb8": 199,
                "./ctr": 200,
                "./ecb": 201,
                "./list.json": 203,
                "./ofb": 204
            }
        ],
        203: [
            function(e, t, r) {
                t.exports = {
                    "aes-128-ecb": {
                        cipher: "AES",
                        key: 128,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-192-ecb": {
                        cipher: "AES",
                        key: 192,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-256-ecb": {
                        cipher: "AES",
                        key: 256,
                        iv: 0,
                        mode: "ECB",
                        type: "block"
                    },
                    "aes-128-cbc": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-192-cbc": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-256-cbc": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes128: {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes192: {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    aes256: {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CBC",
                        type: "block"
                    },
                    "aes-128-cfb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-192-cfb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-256-cfb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB",
                        type: "stream"
                    },
                    "aes-128-cfb8": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-192-cfb8": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-256-cfb8": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB8",
                        type: "stream"
                    },
                    "aes-128-cfb1": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-192-cfb1": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-256-cfb1": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CFB1",
                        type: "stream"
                    },
                    "aes-128-ofb": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-192-ofb": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-256-ofb": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "OFB",
                        type: "stream"
                    },
                    "aes-128-ctr": {
                        cipher: "AES",
                        key: 128,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-192-ctr": {
                        cipher: "AES",
                        key: 192,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-256-ctr": {
                        cipher: "AES",
                        key: 256,
                        iv: 16,
                        mode: "CTR",
                        type: "stream"
                    },
                    "aes-128-gcm": {
                        cipher: "AES",
                        key: 128,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-192-gcm": {
                        cipher: "AES",
                        key: 192,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    },
                    "aes-256-gcm": {
                        cipher: "AES",
                        key: 256,
                        iv: 12,
                        mode: "GCM",
                        type: "auth"
                    }
                };
            },
            {}
        ],
        204: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("buffer-xor");
                        function i(e) {
                            return e._prev = e._cipher.encryptBlock(e._prev), e._prev;
                        }
                        r.encrypt = function(e, r) {
                            for(; e._cache.length < r.length;)e._cache = t.concat([
                                e._cache,
                                i(e)
                            ]);
                            var s = e._cache.slice(0, r.length);
                            return e._cache = e._cache.slice(r.length), n(r, s);
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220,
                "buffer-xor": 219
            }
        ],
        205: [
            function(e, t, r) {
                "use strict";
                var n = e("./aes"), i = e("safe-buffer").Buffer, s = e("cipher-base");
                function o(e, t, r, o) {
                    s.call(this), this._cipher = new n.AES(t), this._prev = i.from(r), this._cache = i.allocUnsafe(0), this._secCache = i.allocUnsafe(0), this._decrypt = o, this._mode = e;
                }
                e("inherits")(o, s), o.prototype._update = function(e) {
                    return this._mode.encrypt(this, e, this._decrypt);
                }, o.prototype._final = function() {
                    this._cipher.scrub();
                }, t.exports = o;
            },
            {
                "./aes": 189,
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        206: [
            function(e, t, r) {
                "use strict";
                var n = e("browserify-des"), i = e("browserify-aes/browser"), s = e("browserify-aes/modes"), o = e("browserify-des/modes"), a = e("evp_bytestokey");
                function l(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createCipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e
                    });
                    throw new TypeError("invalid suite type");
                }
                function c(e, t, r) {
                    if (e = e.toLowerCase(), s[e]) return i.createDecipheriv(e, t, r);
                    if (o[e]) return new n({
                        key: t,
                        iv: r,
                        mode: e,
                        decrypt: !0
                    });
                    throw new TypeError("invalid suite type");
                }
                r.createCipher = r.Cipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return l(e, i.key, i.iv);
                }, r.createCipheriv = r.Cipheriv = l, r.createDecipher = r.Decipher = function(e, t) {
                    var r, n;
                    if (e = e.toLowerCase(), s[e]) r = s[e].key, n = s[e].iv;
                    else {
                        if (!o[e]) throw new TypeError("invalid suite type");
                        r = 8 * o[e].key, n = o[e].iv;
                    }
                    var i = a(t, !1, r, n);
                    return c(e, i.key, i.iv);
                }, r.createDecipheriv = r.Decipheriv = c, r.listCiphers = r.getCiphers = function() {
                    return Object.keys(o).concat(i.getCiphers());
                };
            },
            {
                "browserify-aes/browser": 191,
                "browserify-aes/modes": 202,
                "browserify-des": 207,
                "browserify-des/modes": 208,
                evp_bytestokey: 423
            }
        ],
        207: [
            function(e, t, r) {
                "use strict";
                var n = e("cipher-base"), i = e("des.js"), s = e("inherits"), o = e("safe-buffer").Buffer, a = {
                    "des-ede3-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede3": i.EDE,
                    "des-ede-cbc": i.CBC.instantiate(i.EDE),
                    "des-ede": i.EDE,
                    "des-cbc": i.CBC.instantiate(i.DES),
                    "des-ecb": i.DES
                };
                function l(e) {
                    n.call(this);
                    var t, r = e.mode.toLowerCase(), i = a[r];
                    t = e.decrypt ? "decrypt" : "encrypt";
                    var s = e.key;
                    o.isBuffer(s) || (s = o.from(s)), "des-ede" !== r && "des-ede-cbc" !== r || (s = o.concat([
                        s,
                        s.slice(0, 8)
                    ]));
                    var l = e.iv;
                    o.isBuffer(l) || (l = o.from(l)), this._des = i.create({
                        key: s,
                        iv: l,
                        type: t
                    });
                }
                a.des = a["des-cbc"], a.des3 = a["des-ede3-cbc"], t.exports = l, s(l, n), l.prototype._update = function(e) {
                    return o.from(this._des.update(e));
                }, l.prototype._final = function() {
                    return o.from(this._des.final());
                };
            },
            {
                "cipher-base": 221,
                "des.js": 394,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        208: [
            function(e, t, r) {
                "use strict";
                r["des-ecb"] = {
                    key: 8,
                    iv: 0
                }, r["des-cbc"] = r.des = {
                    key: 8,
                    iv: 8
                }, r["des-ede3-cbc"] = r.des3 = {
                    key: 24,
                    iv: 8
                }, r["des-ede3"] = {
                    key: 24,
                    iv: 0
                }, r["des-ede-cbc"] = {
                    key: 16,
                    iv: 8
                }, r["des-ede"] = {
                    key: 16,
                    iv: 0
                };
            },
            {}
        ],
        209: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = e("randombytes");
                        function s(e) {
                            var t, r = e.modulus.byteLength();
                            do t = new n(i(r));
                            while (t.cmp(e.modulus) >= 0 || !t.umod(e.prime1) || !t.umod(e.prime2));
                            return t;
                        }
                        function o(e, t) {
                            var i = function(e) {
                                var t = s(e);
                                return {
                                    blinder: t.toRed(n.mont(e.modulus)).redPow(new n(e.publicExponent)).fromRed(),
                                    unblinder: t.invm(e.modulus)
                                };
                            }(t), o = t.modulus.byteLength(), a = new n(e).mul(i.blinder).umod(t.modulus), l = a.toRed(n.mont(t.prime1)), c = a.toRed(n.mont(t.prime2)), u = t.coefficient, h = t.prime1, f = t.prime2, d = l.redPow(t.exponent1).fromRed(), p = c.redPow(t.exponent2).fromRed(), m = d.isub(p).imul(u).umod(h).imul(f);
                            return p.iadd(m).imul(i.unblinder).umod(t.modulus).toArrayLike(r, "be", o);
                        }
                        o.getr = s, t.exports = o;
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 186,
                buffer: 220,
                randombytes: 475
            }
        ],
        210: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./browser/algorithms.json");
            },
            {
                "./browser/algorithms.json": 211
            }
        ],
        211: [
            function(e, t, r) {
                t.exports = {
                    sha224WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    "RSA-SHA224": {
                        sign: "ecdsa/rsa",
                        hash: "sha224",
                        id: "302d300d06096086480165030402040500041c"
                    },
                    sha256WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    "RSA-SHA256": {
                        sign: "ecdsa/rsa",
                        hash: "sha256",
                        id: "3031300d060960864801650304020105000420"
                    },
                    sha384WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    "RSA-SHA384": {
                        sign: "ecdsa/rsa",
                        hash: "sha384",
                        id: "3041300d060960864801650304020205000430"
                    },
                    sha512WithRSAEncryption: {
                        sign: "rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA512": {
                        sign: "ecdsa/rsa",
                        hash: "sha512",
                        id: "3051300d060960864801650304020305000440"
                    },
                    "RSA-SHA1": {
                        sign: "rsa",
                        hash: "sha1",
                        id: "3021300906052b0e03021a05000414"
                    },
                    "ecdsa-with-SHA1": {
                        sign: "ecdsa",
                        hash: "sha1",
                        id: ""
                    },
                    sha256: {
                        sign: "ecdsa",
                        hash: "sha256",
                        id: ""
                    },
                    sha224: {
                        sign: "ecdsa",
                        hash: "sha224",
                        id: ""
                    },
                    sha384: {
                        sign: "ecdsa",
                        hash: "sha384",
                        id: ""
                    },
                    sha512: {
                        sign: "ecdsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-SHA1": {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    DSA: {
                        sign: "dsa",
                        hash: "sha1",
                        id: ""
                    },
                    "DSA-WITH-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-SHA224": {
                        sign: "dsa",
                        hash: "sha224",
                        id: ""
                    },
                    "DSA-WITH-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-SHA256": {
                        sign: "dsa",
                        hash: "sha256",
                        id: ""
                    },
                    "DSA-WITH-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-SHA384": {
                        sign: "dsa",
                        hash: "sha384",
                        id: ""
                    },
                    "DSA-WITH-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-SHA512": {
                        sign: "dsa",
                        hash: "sha512",
                        id: ""
                    },
                    "DSA-RIPEMD160": {
                        sign: "dsa",
                        hash: "rmd160",
                        id: ""
                    },
                    ripemd160WithRSA: {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    "RSA-RIPEMD160": {
                        sign: "rsa",
                        hash: "rmd160",
                        id: "3021300906052b2403020105000414"
                    },
                    md5WithRSAEncryption: {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    },
                    "RSA-MD5": {
                        sign: "rsa",
                        hash: "md5",
                        id: "3020300c06082a864886f70d020505000410"
                    }
                };
            },
            {}
        ],
        212: [
            function(e, t, r) {
                t.exports = {
                    "1.3.132.0.10": "secp256k1",
                    "1.3.132.0.33": "p224",
                    "1.2.840.10045.3.1.1": "p192",
                    "1.2.840.10045.3.1.7": "p256",
                    "1.3.132.0.34": "p384",
                    "1.3.132.0.35": "p521"
                };
            },
            {}
        ],
        213: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hash"), s = e("readable-stream"), o = e("inherits"), a = e("./sign"), l = e("./verify"), c = e("./algorithms.json");
                function u(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hashType = t.hash, this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function h(e) {
                    s.Writable.call(this);
                    var t = c[e];
                    if (!t) throw new Error("Unknown message digest");
                    this._hash = i(t.hash), this._tag = t.id, this._signType = t.sign;
                }
                function f(e) {
                    return new u(e);
                }
                function d(e) {
                    return new h(e);
                }
                Object.keys(c).forEach(function(e) {
                    c[e].id = n.from(c[e].id, "hex"), c[e.toLowerCase()] = c[e];
                }), o(u, s.Writable), u.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, u.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, u.prototype.sign = function(e, t) {
                    this.end();
                    var r = this._hash.digest(), n = a(r, e, this._hashType, this._signType, this._tag);
                    return t ? n.toString(t) : n;
                }, o(h, s.Writable), h.prototype._write = function(e, t, r) {
                    this._hash.update(e), r();
                }, h.prototype.update = function(e, t) {
                    return "string" == typeof e && (e = n.from(e, t)), this._hash.update(e), this;
                }, h.prototype.verify = function(e, t, r) {
                    "string" == typeof t && (t = n.from(t, r)), this.end();
                    var i = this._hash.digest();
                    return l(t, i, e, this._signType, this._tag);
                }, t.exports = {
                    Sign: f,
                    Verify: d,
                    createSign: f,
                    createVerify: d
                };
            },
            {
                "./algorithms.json": 211,
                "./sign": 214,
                "./verify": 215,
                "create-hash": 386,
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        214: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("create-hmac"), s = e("browserify-rsa"), o = e("elliptic").ec, a = e("bn.js"), l = e("parse-asn1"), c = e("./curves.json");
                function u(e, t, r, s) {
                    if ((e = n.from(e.toArray())).length < t.byteLength()) {
                        var o = n.alloc(t.byteLength() - e.length);
                        e = n.concat([
                            o,
                            e
                        ]);
                    }
                    var a = r.length, l = function(e, t) {
                        e = (e = h(e, t)).mod(t);
                        var r = n.from(e.toArray());
                        if (r.length < t.byteLength()) {
                            var i = n.alloc(t.byteLength() - r.length);
                            r = n.concat([
                                i,
                                r
                            ]);
                        }
                        return r;
                    }(r, t), c = n.alloc(a);
                    c.fill(1);
                    var u = n.alloc(a);
                    return u = i(s, u).update(c).update(n.from([
                        0
                    ])).update(e).update(l).digest(), c = i(s, u).update(c).digest(), {
                        k: u = i(s, u).update(c).update(n.from([
                            1
                        ])).update(e).update(l).digest(),
                        v: c = i(s, u).update(c).digest()
                    };
                }
                function h(e, t) {
                    var r = new a(e), n = (e.length << 3) - t.bitLength();
                    return n > 0 && r.ishrn(n), r;
                }
                function f(e, t, r) {
                    var s, o;
                    do {
                        for(s = n.alloc(0); 8 * s.length < e.bitLength();)t.v = i(r, t.k).update(t.v).digest(), s = n.concat([
                            s,
                            t.v
                        ]);
                        o = h(s, e), t.k = i(r, t.k).update(t.v).update(n.from([
                            0
                        ])).digest(), t.v = i(r, t.k).update(t.v).digest();
                    }while (-1 !== o.cmp(e));
                    return o;
                }
                function d(e, t, r, n) {
                    return e.toRed(a.mont(r)).redPow(t).fromRed().mod(n);
                }
                t.exports = function(e, t, r, i, p) {
                    var m = l(t);
                    if (m.curve) {
                        if ("ecdsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                        return function(e, t) {
                            var r = c[t.curve.join(".")];
                            if (!r) throw new Error("unknown curve " + t.curve.join("."));
                            var i = new o(r).keyFromPrivate(t.privateKey).sign(e);
                            return n.from(i.toDER());
                        }(e, m);
                    }
                    if ("dsa" === m.type) {
                        if ("dsa" !== i) throw new Error("wrong private key type");
                        return function(e, t, r) {
                            var i, s = t.params.priv_key, o = t.params.p, l = t.params.q, c = t.params.g, p = new a(0), m = h(e, l).mod(l), b = !1, g = u(s, l, e, r);
                            for(; !1 === b;)i = f(l, g, r), p = d(c, i, o, l), 0 === (b = i.invm(l).imul(m.add(s.mul(p))).mod(l)).cmpn(0) && (b = !1, p = new a(0));
                            return function(e, t) {
                                e = e.toArray(), t = t.toArray(), 128 & e[0] && (e = [
                                    0
                                ].concat(e));
                                128 & t[0] && (t = [
                                    0
                                ].concat(t));
                                var r = [
                                    48,
                                    e.length + t.length + 4,
                                    2,
                                    e.length
                                ];
                                return r = r.concat(e, [
                                    2,
                                    t.length
                                ], t), n.from(r);
                            }(p, b);
                        }(e, m, r);
                    }
                    if ("rsa" !== i && "ecdsa/rsa" !== i) throw new Error("wrong private key type");
                    e = n.concat([
                        p,
                        e
                    ]);
                    for(var b = m.modulus.byteLength(), g = [
                        0,
                        1
                    ]; e.length + g.length + 1 < b;)g.push(255);
                    g.push(0);
                    for(var y = -1; ++y < e.length;)g.push(e[y]);
                    return s(g, m);
                }, t.exports.getKey = u, t.exports.makeKey = f;
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                "browserify-rsa": 209,
                "create-hmac": 388,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        215: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("bn.js"), s = e("elliptic").ec, o = e("parse-asn1"), a = e("./curves.json");
                function l(e, t) {
                    if (e.cmpn(0) <= 0) throw new Error("invalid sig");
                    if (e.cmp(t) >= t) throw new Error("invalid sig");
                }
                t.exports = function(e, t, r, c, u) {
                    var h = o(r);
                    if ("ec" === h.type) {
                        if ("ecdsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = a[r.data.algorithm.curve.join(".")];
                            if (!n) throw new Error("unknown curve " + r.data.algorithm.curve.join("."));
                            var i = new s(n), o = r.data.subjectPrivateKey.data;
                            return i.verify(t, e, o);
                        }(e, t, h);
                    }
                    if ("dsa" === h.type) {
                        if ("dsa" !== c) throw new Error("wrong public key type");
                        return function(e, t, r) {
                            var n = r.data.p, s = r.data.q, a = r.data.g, c = r.data.pub_key, u = o.signature.decode(e, "der"), h = u.s, f = u.r;
                            l(h, s), l(f, s);
                            var d = i.mont(n), p = h.invm(s);
                            return 0 === a.toRed(d).redPow(new i(t).mul(p).mod(s)).fromRed().mul(c.toRed(d).redPow(f.mul(p).mod(s)).fromRed()).mod(n).mod(s).cmp(f);
                        }(e, t, h);
                    }
                    if ("rsa" !== c && "ecdsa/rsa" !== c) throw new Error("wrong public key type");
                    t = n.concat([
                        u,
                        t
                    ]);
                    for(var f = h.modulus.byteLength(), d = [
                        1
                    ], p = 0; t.length + d.length + 2 < f;)d.push(255), p++;
                    d.push(0);
                    for(var m = -1; ++m < t.length;)d.push(t[m]);
                    d = n.from(d);
                    var b = i.mont(h.modulus);
                    e = (e = new i(e).toRed(b)).redPow(new i(h.publicExponent)), e = n.from(e.fromRed().toArray());
                    var g = p < 8 ? 1 : 0;
                    for(f = Math.min(e.length, d.length), e.length !== d.length && (g = 1), m = -1; ++m < f;)g |= e[m] ^ d[m];
                    return 0 === g;
                };
            },
            {
                "./curves.json": 212,
                "bn.js": 186,
                elliptic: 405,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        216: [
            function(e, t, r) {},
            {}
        ],
        217: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        218: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = n.isEncoding || function(e) {
                    switch((e = "" + e) && e.toLowerCase()){
                        case "hex":
                        case "utf8":
                        case "utf-8":
                        case "ascii":
                        case "binary":
                        case "base64":
                        case "ucs2":
                        case "ucs-2":
                        case "utf16le":
                        case "utf-16le":
                        case "raw":
                            return !0;
                        default:
                            return !1;
                    }
                };
                function s(e) {
                    var t;
                    switch(this.encoding = function(e) {
                        var t = function(e) {
                            if (!e) return "utf8";
                            for(var t;;)switch(e){
                                case "utf8":
                                case "utf-8":
                                    return "utf8";
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return "utf16le";
                                case "latin1":
                                case "binary":
                                    return "latin1";
                                case "base64":
                                case "ascii":
                                case "hex":
                                    return e;
                                default:
                                    if (t) return;
                                    e = ("" + e).toLowerCase(), t = !0;
                            }
                        }(e);
                        if ("string" != typeof t && (n.isEncoding === i || !i(e))) throw new Error("Unknown encoding: " + e);
                        return t || e;
                    }(e), this.encoding){
                        case "utf16le":
                            this.text = l, this.end = c, t = 4;
                            break;
                        case "utf8":
                            this.fillLast = a, t = 4;
                            break;
                        case "base64":
                            this.text = u, this.end = h, t = 3;
                            break;
                        default:
                            return this.write = f, void (this.end = d);
                    }
                    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(t);
                }
                function o(e) {
                    return e <= 127 ? 0 : e >> 5 == 6 ? 2 : e >> 4 == 14 ? 3 : e >> 3 == 30 ? 4 : e >> 6 == 2 ? -1 : -2;
                }
                function a(e) {
                    var t = this.lastTotal - this.lastNeed, r = function(e, t, r) {
                        if (128 != (192 & t[0])) return e.lastNeed = 0, "\ufffd";
                        if (e.lastNeed > 1 && t.length > 1) {
                            if (128 != (192 & t[1])) return e.lastNeed = 1, "\ufffd";
                            if (e.lastNeed > 2 && t.length > 2 && 128 != (192 & t[2])) return e.lastNeed = 2, "\ufffd";
                        }
                    }(this, e);
                    return void 0 !== r ? r : this.lastNeed <= e.length ? (e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (e.copy(this.lastChar, t, 0, e.length), void (this.lastNeed -= e.length));
                }
                function l(e, t) {
                    if ((e.length - t) % 2 == 0) {
                        var r = e.toString("utf16le", t);
                        if (r) {
                            var n = r.charCodeAt(r.length - 1);
                            if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                        }
                        return r;
                    }
                    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
                }
                function c(e) {
                    var t = e && e.length ? this.write(e) : "";
                    if (this.lastNeed) {
                        var r = this.lastTotal - this.lastNeed;
                        return t + this.lastChar.toString("utf16le", 0, r);
                    }
                    return t;
                }
                function u(e, t) {
                    var r = (e.length - t) % 3;
                    return 0 === r ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
                }
                function h(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
                }
                function f(e) {
                    return e.toString(this.encoding);
                }
                function d(e) {
                    return e && e.length ? this.write(e) : "";
                }
                r.StringDecoder = s, s.prototype.write = function(e) {
                    if (0 === e.length) return "";
                    var t, r;
                    if (this.lastNeed) {
                        if (void 0 === (t = this.fillLast(e))) return "";
                        r = this.lastNeed, this.lastNeed = 0;
                    } else r = 0;
                    return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
                }, s.prototype.end = function(e) {
                    var t = e && e.length ? this.write(e) : "";
                    return this.lastNeed ? t + "\ufffd" : t;
                }, s.prototype.text = function(e, t) {
                    var r = function(e, t, r) {
                        var n = t.length - 1;
                        if (n < r) return 0;
                        var i = o(t[n]);
                        if (i >= 0) return i > 0 && (e.lastNeed = i - 1), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (e.lastNeed = i - 2), i;
                        if (--n < r || -2 === i) return 0;
                        if ((i = o(t[n])) >= 0) return i > 0 && (2 === i ? i = 0 : e.lastNeed = i - 3), i;
                        return 0;
                    }(this, e, t);
                    if (!this.lastNeed) return e.toString("utf8", t);
                    this.lastTotal = r;
                    var n = e.length - (r - this.lastNeed);
                    return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
                }, s.prototype.fillLast = function(e) {
                    if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                    e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
                };
            },
            {
                "safe-buffer": 217
            }
        ],
        219: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        t.exports = function(t, r) {
                            for(var n = Math.min(t.length, r.length), i = new e(n), s = 0; s < n; ++s)i[s] = t[s] ^ r[s];
                            return i;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                buffer: 220
            }
        ],
        220: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ "use strict";
                        var t = e("base64-js"), n = e("ieee754");
                        r.Buffer = s, r.SlowBuffer = function(e) {
                            +e != e && (e = 0);
                            return s.alloc(+e);
                        }, r.INSPECT_MAX_BYTES = 50;
                        function i(e) {
                            if (e > 2147483647) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var t = new Uint8Array(e);
                            return t.__proto__ = s.prototype, t;
                        }
                        function s(e, t, r) {
                            if ("number" == typeof e) {
                                if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
                                return l(e);
                            }
                            return o(e, t, r);
                        }
                        function o(e, t, r) {
                            if ("string" == typeof e) return function(e, t) {
                                "string" == typeof t && "" !== t || (t = "utf8");
                                if (!s.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                                var r = 0 | h(e, t), n = i(r), o = n.write(e, t);
                                o !== r && (n = n.slice(0, o));
                                return n;
                            }(e, t);
                            if (ArrayBuffer.isView(e)) return c(e);
                            if (null == e) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            if (F(e, ArrayBuffer) || e && F(e.buffer, ArrayBuffer)) return function(e, t, r) {
                                if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                                if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                                var n;
                                n = void 0 === t && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, t) : new Uint8Array(e, t, r);
                                return n.__proto__ = s.prototype, n;
                            }(e, t, r);
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var n = e.valueOf && e.valueOf();
                            if (null != n && n !== e) return s.from(n, t, r);
                            var o = function(e) {
                                if (s.isBuffer(e)) {
                                    var t = 0 | u(e.length), r = i(t);
                                    return 0 === r.length || e.copy(r, 0, 0, t), r;
                                }
                                if (void 0 !== e.length) return "number" != typeof e.length || L(e.length) ? i(0) : c(e);
                                if ("Buffer" === e.type && Array.isArray(e.data)) return c(e.data);
                            }(e);
                            if (o) return o;
                            if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return s.from(e[Symbol.toPrimitive]("string"), t, r);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                        }
                        function a(e) {
                            if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
                            if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                        }
                        function l(e) {
                            return a(e), i(e < 0 ? 0 : 0 | u(e));
                        }
                        function c(e) {
                            for(var t = e.length < 0 ? 0 : 0 | u(e.length), r = i(t), n = 0; n < t; n += 1)r[n] = 255 & e[n];
                            return r;
                        }
                        function u(e) {
                            if (e >= 2147483647) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647..toString(16) + " bytes");
                            return 0 | e;
                        }
                        function h(e, t) {
                            if (s.isBuffer(e)) return e.length;
                            if (ArrayBuffer.isView(e) || F(e, ArrayBuffer)) return e.byteLength;
                            if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                            var r = e.length, n = arguments.length > 2 && !0 === arguments[2];
                            if (!n && 0 === r) return 0;
                            for(var i = !1;;)switch(t){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return r;
                                case "utf8":
                                case "utf-8":
                                    return P(e).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return 2 * r;
                                case "hex":
                                    return r >>> 1;
                                case "base64":
                                    return B(e).length;
                                default:
                                    if (i) return n ? -1 : P(e).length;
                                    t = ("" + t).toLowerCase(), i = !0;
                            }
                        }
                        function f(e, t, r) {
                            var n = !1;
                            if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
                            if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
                            if ((r >>>= 0) <= (t >>>= 0)) return "";
                            for(e || (e = "utf8");;)switch(e){
                                case "hex":
                                    return C(this, t, r);
                                case "utf8":
                                case "utf-8":
                                    return k(this, t, r);
                                case "ascii":
                                    return S(this, t, r);
                                case "latin1":
                                case "binary":
                                    return M(this, t, r);
                                case "base64":
                                    return x(this, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return T(this, t, r);
                                default:
                                    if (n) throw new TypeError("Unknown encoding: " + e);
                                    e = (e + "").toLowerCase(), n = !0;
                            }
                        }
                        function d(e, t, r) {
                            var n = e[t];
                            e[t] = e[r], e[r] = n;
                        }
                        function p(e, t, r, n, i) {
                            if (0 === e.length) return -1;
                            if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), L(r = +r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                                if (i) return -1;
                                r = e.length - 1;
                            } else if (r < 0) {
                                if (!i) return -1;
                                r = 0;
                            }
                            if ("string" == typeof t && (t = s.from(t, n)), s.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, r, n, i);
                            if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : m(e, [
                                t
                            ], r, n, i);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function m(e, t, r, n, i) {
                            var s, o = 1, a = e.length, l = t.length;
                            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
                                if (e.length < 2 || t.length < 2) return -1;
                                o = 2, a /= 2, l /= 2, r /= 2;
                            }
                            function c(e, t) {
                                return 1 === o ? e[t] : e.readUInt16BE(t * o);
                            }
                            if (i) {
                                var u = -1;
                                for(s = r; s < a; s++)if (c(e, s) === c(t, -1 === u ? 0 : s - u)) {
                                    if (-1 === u && (u = s), s - u + 1 === l) return u * o;
                                } else -1 !== u && (s -= s - u), u = -1;
                            } else for(r + l > a && (r = a - l), s = r; s >= 0; s--){
                                for(var h = !0, f = 0; f < l; f++)if (c(e, s + f) !== c(t, f)) {
                                    h = !1;
                                    break;
                                }
                                if (h) return s;
                            }
                            return -1;
                        }
                        function b(e, t, r, n) {
                            r = Number(r) || 0;
                            var i = e.length - r;
                            n ? (n = Number(n)) > i && (n = i) : n = i;
                            var s = t.length;
                            n > s / 2 && (n = s / 2);
                            for(var o = 0; o < n; ++o){
                                var a = parseInt(t.substr(2 * o, 2), 16);
                                if (L(a)) return o;
                                e[r + o] = a;
                            }
                            return o;
                        }
                        function g(e, t, r, n) {
                            return D(P(t, e.length - r), e, r, n);
                        }
                        function y(e, t, r, n) {
                            return D(function(e) {
                                for(var t = [], r = 0; r < e.length; ++r)t.push(255 & e.charCodeAt(r));
                                return t;
                            }(t), e, r, n);
                        }
                        function v(e, t, r, n) {
                            return y(e, t, r, n);
                        }
                        function w(e, t, r, n) {
                            return D(B(t), e, r, n);
                        }
                        function _(e, t, r, n) {
                            return D(function(e, t) {
                                for(var r, n, i, s = [], o = 0; o < e.length && !((t -= 2) < 0); ++o)r = e.charCodeAt(o), n = r >> 8, i = r % 256, s.push(i), s.push(n);
                                return s;
                            }(t, e.length - r), e, r, n);
                        }
                        function x(e, r, n) {
                            return 0 === r && n === e.length ? t.fromByteArray(e) : t.fromByteArray(e.slice(r, n));
                        }
                        function k(e, t, r) {
                            r = Math.min(e.length, r);
                            for(var n = [], i = t; i < r;){
                                var s, o, a, l, c = e[i], u = null, h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
                                if (i + h <= r) switch(h){
                                    case 1:
                                        c < 128 && (u = c);
                                        break;
                                    case 2:
                                        128 == (192 & (s = e[i + 1])) && (l = (31 & c) << 6 | 63 & s) > 127 && (u = l);
                                        break;
                                    case 3:
                                        s = e[i + 1], o = e[i + 2], 128 == (192 & s) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & s) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (u = l);
                                        break;
                                    case 4:
                                        s = e[i + 1], o = e[i + 2], a = e[i + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & c) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) > 65535 && l < 1114112 && (u = l);
                                }
                                null === u ? (u = 65533, h = 1) : u > 65535 && (u -= 65536, n.push(u >>> 10 & 1023 | 55296), u = 56320 | 1023 & u), n.push(u), i += h;
                            }
                            return function(e) {
                                var t = e.length;
                                if (t <= 4096) return String.fromCharCode.apply(String, e);
                                var r = "", n = 0;
                                for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += 4096));
                                return r;
                            }(n);
                        }
                        r.kMaxLength = 2147483647, s.TYPED_ARRAY_SUPPORT = function() {
                            try {
                                var e = new Uint8Array(1);
                                return e.__proto__ = {
                                    __proto__: Uint8Array.prototype,
                                    foo: function() {
                                        return 42;
                                    }
                                }, 42 === e.foo();
                            } catch (e) {
                                return !1;
                            }
                        }(), s.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(s.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.buffer;
                            }
                        }), Object.defineProperty(s.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                if (s.isBuffer(this)) return this.byteOffset;
                            }
                        }), "undefined" != typeof Symbol && null != Symbol.species && s[Symbol.species] === s && Object.defineProperty(s, Symbol.species, {
                            value: null,
                            configurable: !0,
                            enumerable: !1,
                            writable: !1
                        }), s.poolSize = 8192, s.from = function(e, t, r) {
                            return o(e, t, r);
                        }, s.prototype.__proto__ = Uint8Array.prototype, s.__proto__ = Uint8Array, s.alloc = function(e, t, r) {
                            return function(e, t, r) {
                                return a(e), e <= 0 ? i(e) : void 0 !== t ? "string" == typeof r ? i(e).fill(t, r) : i(e).fill(t) : i(e);
                            }(e, t, r);
                        }, s.allocUnsafe = function(e) {
                            return l(e);
                        }, s.allocUnsafeSlow = function(e) {
                            return l(e);
                        }, s.isBuffer = function(e) {
                            return null != e && !0 === e._isBuffer && e !== s.prototype;
                        }, s.compare = function(e, t) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), F(t, Uint8Array) && (t = s.from(t, t.offset, t.byteLength)), !s.isBuffer(e) || !s.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (e === t) return 0;
                            for(var r = e.length, n = t.length, i = 0, o = Math.min(r, n); i < o; ++i)if (e[i] !== t[i]) {
                                r = e[i], n = t[i];
                                break;
                            }
                            return r < n ? -1 : n < r ? 1 : 0;
                        }, s.isEncoding = function(e) {
                            switch(String(e).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, s.concat = function(e, t) {
                            if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (0 === e.length) return s.alloc(0);
                            var r;
                            if (void 0 === t) for(t = 0, r = 0; r < e.length; ++r)t += e[r].length;
                            var n = s.allocUnsafe(t), i = 0;
                            for(r = 0; r < e.length; ++r){
                                var o = e[r];
                                if (F(o, Uint8Array) && (o = s.from(o)), !s.isBuffer(o)) throw new TypeError('"list" argument must be an Array of Buffers');
                                o.copy(n, i), i += o.length;
                            }
                            return n;
                        }, s.byteLength = h, s.prototype._isBuffer = !0, s.prototype.swap16 = function() {
                            var e = this.length;
                            if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var t = 0; t < e; t += 2)d(this, t, t + 1);
                            return this;
                        }, s.prototype.swap32 = function() {
                            var e = this.length;
                            if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var t = 0; t < e; t += 4)d(this, t, t + 3), d(this, t + 1, t + 2);
                            return this;
                        }, s.prototype.swap64 = function() {
                            var e = this.length;
                            if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var t = 0; t < e; t += 8)d(this, t, t + 7), d(this, t + 1, t + 6), d(this, t + 2, t + 5), d(this, t + 3, t + 4);
                            return this;
                        }, s.prototype.toString = function() {
                            var e = this.length;
                            return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : f.apply(this, arguments);
                        }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(e) {
                            if (!s.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
                            return this === e || 0 === s.compare(this, e);
                        }, s.prototype.inspect = function() {
                            var e = "", t = r.INSPECT_MAX_BYTES;
                            return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
                        }, s.prototype.compare = function(e, t, r, n, i) {
                            if (F(e, Uint8Array) && (e = s.from(e, e.offset, e.byteLength)), !s.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
                            if (void 0 === t && (t = 0), void 0 === r && (r = e ? e.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), t < 0 || r > e.length || n < 0 || i > this.length) throw new RangeError("out of range index");
                            if (n >= i && t >= r) return 0;
                            if (n >= i) return -1;
                            if (t >= r) return 1;
                            if (this === e) return 0;
                            for(var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (t >>>= 0), l = Math.min(o, a), c = this.slice(n, i), u = e.slice(t, r), h = 0; h < l; ++h)if (c[h] !== u[h]) {
                                o = c[h], a = u[h];
                                break;
                            }
                            return o < a ? -1 : a < o ? 1 : 0;
                        }, s.prototype.includes = function(e, t, r) {
                            return -1 !== this.indexOf(e, t, r);
                        }, s.prototype.indexOf = function(e, t, r) {
                            return p(this, e, t, r, !0);
                        }, s.prototype.lastIndexOf = function(e, t, r) {
                            return p(this, e, t, r, !1);
                        }, s.prototype.write = function(e, t, r, n) {
                            if (void 0 === t) n = "utf8", r = this.length, t = 0;
                            else if (void 0 === r && "string" == typeof t) n = t, r = this.length, t = 0;
                            else {
                                if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                                t >>>= 0, isFinite(r) ? (r >>>= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
                            }
                            var i = this.length - t;
                            if ((void 0 === r || r > i) && (r = i), e.length > 0 && (r < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            n || (n = "utf8");
                            for(var s = !1;;)switch(n){
                                case "hex":
                                    return b(this, e, t, r);
                                case "utf8":
                                case "utf-8":
                                    return g(this, e, t, r);
                                case "ascii":
                                    return y(this, e, t, r);
                                case "latin1":
                                case "binary":
                                    return v(this, e, t, r);
                                case "base64":
                                    return w(this, e, t, r);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return _(this, e, t, r);
                                default:
                                    if (s) throw new TypeError("Unknown encoding: " + n);
                                    n = ("" + n).toLowerCase(), s = !0;
                            }
                        }, s.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function S(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(127 & e[i]);
                            return n;
                        }
                        function M(e, t, r) {
                            var n = "";
                            r = Math.min(e.length, r);
                            for(var i = t; i < r; ++i)n += String.fromCharCode(e[i]);
                            return n;
                        }
                        function C(e, t, r) {
                            var n = e.length;
                            (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                            for(var i = "", s = t; s < r; ++s)i += N(e[s]);
                            return i;
                        }
                        function T(e, t, r) {
                            for(var n = e.slice(t, r), i = "", s = 0; s < n.length; s += 2)i += String.fromCharCode(n[s] + 256 * n[s + 1]);
                            return i;
                        }
                        function E(e, t, r) {
                            if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
                            if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
                        }
                        function A(e, t, r, n, i, o) {
                            if (!s.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (t > i || t < o) throw new RangeError('"value" argument is out of bounds');
                            if (r + n > e.length) throw new RangeError("Index out of range");
                        }
                        function R(e, t, r, n, i, s) {
                            if (r + n > e.length) throw new RangeError("Index out of range");
                            if (r < 0) throw new RangeError("Index out of range");
                        }
                        function O(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 4), n.write(e, t, r, i, 23, 4), r + 4;
                        }
                        function j(e, t, r, i, s) {
                            return t = +t, r >>>= 0, s || R(e, 0, r, 8), n.write(e, t, r, i, 52, 8), r + 8;
                        }
                        s.prototype.slice = function(e, t) {
                            var r = this.length;
                            (e = ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), (t = void 0 === t ? r : ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), t < e && (t = e);
                            var n = this.subarray(e, t);
                            return n.__proto__ = s.prototype, n;
                        }, s.prototype.readUIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n;
                        }, s.prototype.readUIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e + --t], i = 1; t > 0 && (i *= 256);)n += this[e + --t] * i;
                            return n;
                        }, s.prototype.readUInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), this[e];
                        }, s.prototype.readUInt16LE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] | this[e + 1] << 8;
                        }, s.prototype.readUInt16BE = function(e, t) {
                            return e >>>= 0, t || E(e, 2, this.length), this[e] << 8 | this[e + 1];
                        }, s.prototype.readUInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
                        }, s.prototype.readUInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
                        }, s.prototype.readIntLE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = this[e], i = 1, s = 0; ++s < t && (i *= 256);)n += this[e + s] * i;
                            return n >= (i *= 128) && (n -= Math.pow(2, 8 * t)), n;
                        }, s.prototype.readIntBE = function(e, t, r) {
                            e >>>= 0, t >>>= 0, r || E(e, t, this.length);
                            for(var n = t, i = 1, s = this[e + --n]; n > 0 && (i *= 256);)s += this[e + --n] * i;
                            return s >= (i *= 128) && (s -= Math.pow(2, 8 * t)), s;
                        }, s.prototype.readInt8 = function(e, t) {
                            return e >>>= 0, t || E(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
                        }, s.prototype.readInt16LE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e] | this[e + 1] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt16BE = function(e, t) {
                            e >>>= 0, t || E(e, 2, this.length);
                            var r = this[e + 1] | this[e] << 8;
                            return 32768 & r ? 4294901760 | r : r;
                        }, s.prototype.readInt32LE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
                        }, s.prototype.readInt32BE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
                        }, s.prototype.readFloatLE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !0, 23, 4);
                        }, s.prototype.readFloatBE = function(e, t) {
                            return e >>>= 0, t || E(e, 4, this.length), n.read(this, e, !1, 23, 4);
                        }, s.prototype.readDoubleLE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !0, 52, 8);
                        }, s.prototype.readDoubleBE = function(e, t) {
                            return e >>>= 0, t || E(e, 8, this.length), n.read(this, e, !1, 52, 8);
                        }, s.prototype.writeUIntLE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = 1, s = 0;
                            for(this[t] = 255 & e; ++s < r && (i *= 256);)this[t + s] = e / i & 255;
                            return t + r;
                        }, s.prototype.writeUIntBE = function(e, t, r, n) {
                            (e = +e, t >>>= 0, r >>>= 0, n) || A(this, e, t, r, Math.pow(2, 8 * r) - 1, 0);
                            var i = r - 1, s = 1;
                            for(this[t + i] = 255 & e; --i >= 0 && (s *= 256);)this[t + i] = e / s & 255;
                            return t + r;
                        }, s.prototype.writeUInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeUInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeUInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeUInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
                        }, s.prototype.writeUInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeIntLE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = 0, o = 1, a = 0;
                            for(this[t] = 255 & e; ++s < r && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s - 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeIntBE = function(e, t, r, n) {
                            if (e = +e, t >>>= 0, !n) {
                                var i = Math.pow(2, 8 * r - 1);
                                A(this, e, t, r, i - 1, -i);
                            }
                            var s = r - 1, o = 1, a = 0;
                            for(this[t + s] = 255 & e; --s >= 0 && (o *= 256);)e < 0 && 0 === a && 0 !== this[t + s + 1] && (a = 1), this[t + s] = (e / o >> 0) - a & 255;
                            return t + r;
                        }, s.prototype.writeInt8 = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
                        }, s.prototype.writeInt16LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
                        }, s.prototype.writeInt16BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
                        }, s.prototype.writeInt32LE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
                        }, s.prototype.writeInt32BE = function(e, t, r) {
                            return e = +e, t >>>= 0, r || A(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
                        }, s.prototype.writeFloatLE = function(e, t, r) {
                            return O(this, e, t, !0, r);
                        }, s.prototype.writeFloatBE = function(e, t, r) {
                            return O(this, e, t, !1, r);
                        }, s.prototype.writeDoubleLE = function(e, t, r) {
                            return j(this, e, t, !0, r);
                        }, s.prototype.writeDoubleBE = function(e, t, r) {
                            return j(this, e, t, !1, r);
                        }, s.prototype.copy = function(e, t, r, n) {
                            if (!s.isBuffer(e)) throw new TypeError("argument should be a Buffer");
                            if (r || (r = 0), n || 0 === n || (n = this.length), t >= e.length && (t = e.length), t || (t = 0), n > 0 && n < r && (n = r), n === r) return 0;
                            if (0 === e.length || 0 === this.length) return 0;
                            if (t < 0) throw new RangeError("targetStart out of bounds");
                            if (r < 0 || r >= this.length) throw new RangeError("Index out of range");
                            if (n < 0) throw new RangeError("sourceEnd out of bounds");
                            n > this.length && (n = this.length), e.length - t < n - r && (n = e.length - t + r);
                            var i = n - r;
                            if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, r, n);
                            else if (this === e && r < t && t < n) for(var o = i - 1; o >= 0; --o)e[o + t] = this[o + r];
                            else Uint8Array.prototype.set.call(e, this.subarray(r, n), t);
                            return i;
                        }, s.prototype.fill = function(e, t, r, n) {
                            if ("string" == typeof e) {
                                if ("string" == typeof t ? (n = t, t = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
                                if ("string" == typeof n && !s.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
                                if (1 === e.length) {
                                    var i = e.charCodeAt(0);
                                    ("utf8" === n && i < 128 || "latin1" === n) && (e = i);
                                }
                            } else "number" == typeof e && (e &= 255);
                            if (t < 0 || this.length < t || this.length < r) throw new RangeError("Out of range index");
                            if (r <= t) return this;
                            var o;
                            if (t >>>= 0, r = void 0 === r ? this.length : r >>> 0, e || (e = 0), "number" == typeof e) for(o = t; o < r; ++o)this[o] = e;
                            else {
                                var a = s.isBuffer(e) ? e : s.from(e, n), l = a.length;
                                if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
                                for(o = 0; o < r - t; ++o)this[o + t] = a[o % l];
                            }
                            return this;
                        };
                        var I = /[^+/0-9A-Za-z-_]/g;
                        function N(e) {
                            return e < 16 ? "0" + e.toString(16) : e.toString(16);
                        }
                        function P(e, t) {
                            var r;
                            t = t || 1 / 0;
                            for(var n = e.length, i = null, s = [], o = 0; o < n; ++o){
                                if ((r = e.charCodeAt(o)) > 55295 && r < 57344) {
                                    if (!i) {
                                        if (r > 56319) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        if (o + 1 === n) {
                                            (t -= 3) > -1 && s.push(239, 191, 189);
                                            continue;
                                        }
                                        i = r;
                                        continue;
                                    }
                                    if (r < 56320) {
                                        (t -= 3) > -1 && s.push(239, 191, 189), i = r;
                                        continue;
                                    }
                                    r = 65536 + (i - 55296 << 10 | r - 56320);
                                } else i && (t -= 3) > -1 && s.push(239, 191, 189);
                                if (i = null, r < 128) {
                                    if ((t -= 1) < 0) break;
                                    s.push(r);
                                } else if (r < 2048) {
                                    if ((t -= 2) < 0) break;
                                    s.push(r >> 6 | 192, 63 & r | 128);
                                } else if (r < 65536) {
                                    if ((t -= 3) < 0) break;
                                    s.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
                                } else {
                                    if (!(r < 1114112)) throw new Error("Invalid code point");
                                    if ((t -= 4) < 0) break;
                                    s.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
                                }
                            }
                            return s;
                        }
                        function B(e) {
                            return t.toByteArray(function(e) {
                                if ((e = (e = e.split("=")[0]).trim().replace(I, "")).length < 2) return "";
                                for(; e.length % 4 != 0;)e += "=";
                                return e;
                            }(e));
                        }
                        function D(e, t, r, n) {
                            for(var i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)t[i + r] = e[i];
                            return i;
                        }
                        function F(e, t) {
                            return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
                        }
                        function L(e) {
                            return e != e;
                        }
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "base64-js": 185,
                buffer: 220,
                ieee754: 439
            }
        ],
        221: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("stream").Transform, s = e("string_decoder").StringDecoder;
                function o(e) {
                    i.call(this), this.hashMode = "string" == typeof e, this.hashMode ? this[e] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
                }
                e("inherits")(o, i), o.prototype.update = function(e, t, r) {
                    "string" == typeof e && (e = n.from(e, t));
                    var i = this._update(e);
                    return this.hashMode ? this : (r && (i = this._toString(i, r)), i);
                }, o.prototype.setAutoPadding = function() {}, o.prototype.getAuthTag = function() {
                    throw new Error("trying to get auth tag in unsupported state");
                }, o.prototype.setAuthTag = function() {
                    throw new Error("trying to set auth tag in unsupported state");
                }, o.prototype.setAAD = function() {
                    throw new Error("trying to set aad in unsupported state");
                }, o.prototype._transform = function(e, t, r) {
                    var n;
                    try {
                        this.hashMode ? this._update(e) : this.push(this._update(e));
                    } catch (e) {
                        n = e;
                    } finally{
                        r(n);
                    }
                }, o.prototype._flush = function(e) {
                    var t;
                    try {
                        this.push(this.__final());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, o.prototype._finalOrDigest = function(e) {
                    var t = this.__final() || n.alloc(0);
                    return e && (t = this._toString(t, e, !0)), t;
                }, o.prototype._toString = function(e, t, r) {
                    if (this._decoder || (this._decoder = new s(t), this._encoding = t), this._encoding !== t) throw new Error("can't switch encodings");
                    var n = this._decoder.write(e);
                    return r && (n += this._decoder.end()), n;
                }, t.exports = o;
            },
            {
                inherits: 440,
                "safe-buffer": 494,
                stream: 505,
                string_decoder: 218
            }
        ],
        222: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a function");
                };
            },
            {
                "../internals/is-callable": 285,
                "../internals/try-to-string": 349
            }
        ],
        223: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-constructor"), i = e("../internals/try-to-string"), s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not a constructor");
                };
            },
            {
                "../internals/is-constructor": 286,
                "../internals/try-to-string": 349
            }
        ],
        224: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = String, s = TypeError;
                t.exports = function(e) {
                    if ("object" == typeof e || n(e)) return e;
                    throw new s("Can't set " + i(e) + " as a prototype");
                };
            },
            {
                "../internals/is-callable": 285
            }
        ],
        225: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/object-create"), s = e("../internals/object-define-property").f, o = n("unscopables"), a = Array.prototype;
                void 0 === a[o] && s(a, o, {
                    configurable: !0,
                    value: i(null)
                }), t.exports = function(e) {
                    a[o][e] = !0;
                };
            },
            {
                "../internals/object-create": 306,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        226: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-is-prototype-of"), i = TypeError;
                t.exports = function(e, t) {
                    if (n(t, e)) return e;
                    throw new i("Incorrect invocation");
                };
            },
            {
                "../internals/object-is-prototype-of": 314
            }
        ],
        227: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = String, s = TypeError;
                t.exports = function(e) {
                    if (n(e)) return e;
                    throw new s(i(e) + " is not an object");
                };
            },
            {
                "../internals/is-object": 289
            }
        ],
        228: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/to-absolute-index"), s = e("../internals/length-of-array-like"), o = function(e) {
                    return function(t, r, o) {
                        var a, l = n(t), c = s(l), u = i(o, c);
                        if (e && r != r) {
                            for(; c > u;)if ((a = l[u++]) != a) return !0;
                        } else for(; c > u; u++)if ((e || u in l) && l[u] === r) return e || u || 0;
                        return !e && -1;
                    };
                };
                t.exports = {
                    includes: o(!0),
                    indexOf: o(!1)
                };
            },
            {
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340,
                "../internals/to-indexed-object": 341
            }
        ],
        229: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-uncurry-this"), s = e("../internals/indexed-object"), o = e("../internals/to-object"), a = e("../internals/length-of-array-like"), l = e("../internals/array-species-create"), c = i([].push), u = function(e) {
                    var t = 1 === e, r = 2 === e, i = 3 === e, u = 4 === e, h = 6 === e, f = 7 === e, d = 5 === e || h;
                    return function(p, m, b, g) {
                        for(var y, v, w = o(p), _ = s(w), x = n(m, b), k = a(_), S = 0, M = g || l, C = t ? M(p, k) : r || f ? M(p, 0) : void 0; k > S; S++)if ((d || S in _) && (v = x(y = _[S], S, w), e)) {
                            if (t) C[S] = v;
                            else if (v) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return y;
                                case 6:
                                    return S;
                                case 2:
                                    c(C, y);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(C, y);
                            }
                        }
                        return h ? -1 : i || u ? u : C;
                    };
                };
                t.exports = {
                    forEach: u(0),
                    map: u(1),
                    filter: u(2),
                    some: u(3),
                    every: u(4),
                    find: u(5),
                    findIndex: u(6),
                    filterReject: u(7)
                };
            },
            {
                "../internals/array-species-create": 233,
                "../internals/function-bind-context": 262,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/length-of-array-like": 299,
                "../internals/to-object": 344
            }
        ],
        230: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-absolute-index"), i = e("../internals/length-of-array-like"), s = e("../internals/create-property"), o = Array, a = Math.max;
                t.exports = function(e, t, r) {
                    for(var l = i(e), c = n(t, l), u = n(void 0 === r ? l : r, l), h = o(a(u - c, 0)), f = 0; c < u; c++, f++)s(h, f, e[c]);
                    return h.length = f, h;
                };
            },
            {
                "../internals/create-property": 243,
                "../internals/length-of-array-like": 299,
                "../internals/to-absolute-index": 340
            }
        ],
        231: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n([].slice);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        232: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-array"), i = e("../internals/is-constructor"), s = e("../internals/is-object"), o = e("../internals/well-known-symbol")("species"), a = Array;
                t.exports = function(e) {
                    var t;
                    return n(e) && (t = e.constructor, (i(t) && (t === a || n(t.prototype)) || s(t) && null === (t = t[o])) && (t = void 0)), void 0 === t ? a : t;
                };
            },
            {
                "../internals/is-array": 284,
                "../internals/is-constructor": 286,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        233: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/array-species-constructor");
                t.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            {
                "../internals/array-species-constructor": 232
            }
        ],
        234: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("iterator"), i = !1;
                try {
                    var s = 0, o = {
                        next: function() {
                            return {
                                done: !!s++
                            };
                        },
                        return: function() {
                            i = !0;
                        }
                    };
                    o[n] = function() {
                        return this;
                    }, Array.from(o, function() {
                        throw 2;
                    });
                } catch (e) {}
                t.exports = function(e, t) {
                    try {
                        if (!t && !i) return !1;
                    } catch (e) {
                        return !1;
                    }
                    var r = !1;
                    try {
                        var s = {};
                        s[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: r = !0
                                    };
                                }
                            };
                        }, e(s);
                    } catch (e) {}
                    return r;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        235: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = n({}.toString), s = n("".slice);
                t.exports = function(e) {
                    return s(i(e), 8, -1);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        236: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-string-tag-support"), i = e("../internals/is-callable"), s = e("../internals/classof-raw"), o = e("../internals/well-known-symbol")("toStringTag"), a = Object, l = "Arguments" === s(function() {
                    return arguments;
                }());
                t.exports = n ? s : function(e) {
                    var t, r, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (r = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = a(e), o)) ? r : l ? s(t) : "Object" === (n = s(t)) && i(t.callee) ? "Arguments" : n;
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-callable": 285,
                "../internals/to-string-tag-support": 347,
                "../internals/well-known-symbol": 357
            }
        ],
        237: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/own-keys"), s = e("../internals/object-get-own-property-descriptor"), o = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    for(var a = i(t), l = o.f, c = s.f, u = 0; u < a.length; u++){
                        var h = a[u];
                        n(e, h) || r && n(r, h) || l(e, h, c(t, h));
                    }
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/own-keys": 321
            }
        ],
        238: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t = /./;
                    try {
                        "/./"[e](t);
                    } catch (r) {
                        try {
                            return t[n] = !1, "/./"[e](t);
                        } catch (e) {}
                    }
                    return !1;
                };
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        239: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        240: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            {}
        ],
        241: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = n ? function(e, t, r) {
                    return i.f(e, t, s(1, r));
                } : function(e, t, r) {
                    return e[t] = r, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308
            }
        ],
        242: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            {}
        ],
        243: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-property-key"), i = e("../internals/object-define-property"), s = e("../internals/create-property-descriptor");
                t.exports = function(e, t, r) {
                    var o = n(t);
                    o in e ? i.f(e, o, s(0, r)) : e[o] = r;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/object-define-property": 308,
                "../internals/to-property-key": 346
            }
        ],
        244: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/make-built-in"), i = e("../internals/object-define-property");
                t.exports = function(e, t, r) {
                    return r.get && n(r.get, t, {
                        getter: !0
                    }), r.set && n(r.set, t, {
                        setter: !0
                    }), i.f(e, t, r);
                };
            },
            {
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        245: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/object-define-property"), s = e("../internals/make-built-in"), o = e("../internals/define-global-property");
                t.exports = function(e, t, r, a) {
                    a || (a = {});
                    var l = a.enumerable, c = void 0 !== a.name ? a.name : t;
                    if (n(r) && s(r, c, a), a.global) l ? e[t] = r : o(t, r);
                    else {
                        try {
                            a.unsafe ? e[t] && (l = !0) : delete e[t];
                        } catch (e) {}
                        l ? e[t] = r : i.f(e, t, {
                            value: r,
                            enumerable: !1,
                            configurable: !a.nonConfigurable,
                            writable: !a.nonWritable
                        });
                    }
                    return e;
                };
            },
            {
                "../internals/define-global-property": 246,
                "../internals/is-callable": 285,
                "../internals/make-built-in": 300,
                "../internals/object-define-property": 308
            }
        ],
        246: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = Object.defineProperty;
                t.exports = function(e, t) {
                    try {
                        i(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (r) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            {
                "../internals/global": 274
            }
        ],
        247: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    return 7 !== Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        248: [
            function(e, t, r) {
                "use strict";
                var n = "object" == typeof document && document.all, i = void 0 === n && void 0 !== n;
                t.exports = {
                    all: n,
                    IS_HTMLDDA: i
                };
            },
            {}
        ],
        249: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-object"), s = n.document, o = i(s) && i(s.createElement);
                t.exports = function(e) {
                    return o ? s.createElement(e) : {};
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-object": 289
            }
        ],
        250: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-is-deno"), i = e("../internals/engine-is-node");
                t.exports = !n && !i && "object" == typeof window && "object" == typeof document;
            },
            {
                "../internals/engine-is-deno": 251,
                "../internals/engine-is-node": 254
            }
        ],
        251: [
            function(e, t, r) {
                "use strict";
                t.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
            },
            {}
        ],
        252: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /ipad|iphone|ipod/i.test(n) && "undefined" != typeof Pebble;
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        253: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        254: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/classof-raw");
                t.exports = "process" === i(n.process);
            },
            {
                "../internals/classof-raw": 235,
                "../internals/global": 274
            }
        ],
        255: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-user-agent");
                t.exports = /web0s(?!.*chrome)/i.test(n);
            },
            {
                "../internals/engine-user-agent": 256
            }
        ],
        256: [
            function(e, t, r) {
                "use strict";
                t.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            {}
        ],
        257: [
            function(e, t, r) {
                "use strict";
                var n, i, s = e("../internals/global"), o = e("../internals/engine-user-agent"), a = s.process, l = s.Deno, c = a && a.versions || l && l.version, u = c && c.v8;
                u && (i = (n = u.split("."))[0] > 0 && n[0] < 4 ? 1 : +(n[0] + n[1])), !i && o && (!(n = o.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = o.match(/Chrome\/(\d+)/)) && (i = +n[1]), t.exports = i;
            },
            {
                "../internals/engine-user-agent": 256,
                "../internals/global": 274
            }
        ],
        258: [
            function(e, t, r) {
                "use strict";
                t.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            {}
        ],
        259: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/object-get-own-property-descriptor").f, s = e("../internals/create-non-enumerable-property"), o = e("../internals/define-built-in"), a = e("../internals/define-global-property"), l = e("../internals/copy-constructor-properties"), c = e("../internals/is-forced");
                t.exports = function(e, t) {
                    var r, u, h, f, d, p = e.target, m = e.global, b = e.stat;
                    if (r = m ? n : b ? n[p] || a(p, {}) : (n[p] || {}).prototype) for(u in t){
                        if (f = t[u], h = e.dontCallGetSet ? (d = i(r, u)) && d.value : r[u], !c(m ? u : p + (b ? "." : "#") + u, e.forced) && void 0 !== h) {
                            if (typeof f == typeof h) continue;
                            l(f, h);
                        }
                        (e.sham || h && h.sham) && s(f, "sham", !0), o(r, u, f, e);
                    }
                };
            },
            {
                "../internals/copy-constructor-properties": 237,
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/define-global-property": 246,
                "../internals/global": 274,
                "../internals/is-forced": 287,
                "../internals/object-get-own-property-descriptor": 309
            }
        ],
        260: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            {}
        ],
        261: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.apply, o = i.call;
                t.exports = "object" == typeof Reflect && Reflect.apply || (n ? o.bind(s) : function() {
                    return o.apply(s, arguments);
                });
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        262: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-clause"), i = e("../internals/a-callable"), s = e("../internals/function-bind-native"), o = n(n.bind);
                t.exports = function(e, t) {
                    return i(e), void 0 === t ? e : s ? o(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-bind-native": 263,
                "../internals/function-uncurry-this-clause": 267
            }
        ],
        263: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails");
                t.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            {
                "../internals/fails": 260
            }
        ],
        264: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype.call;
                t.exports = n ? i.bind(i) : function() {
                    return i.apply(i, arguments);
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        265: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/has-own-property"), s = Function.prototype, o = n && Object.getOwnPropertyDescriptor, a = i(s, "name"), l = a && "something" === (function() {}).name, c = a && (!n || n && o(s, "name").configurable);
                t.exports = {
                    EXISTS: a,
                    PROPER: l,
                    CONFIGURABLE: c
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/has-own-property": 275
            }
        ],
        266: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/a-callable");
                t.exports = function(e, t, r) {
                    try {
                        return n(i(Object.getOwnPropertyDescriptor(e, t)[r]));
                    } catch (e) {}
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/function-uncurry-this": 268
            }
        ],
        267: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/function-uncurry-this");
                t.exports = function(e) {
                    if ("Function" === n(e)) return i(e);
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268
            }
        ],
        268: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-native"), i = Function.prototype, s = i.call, o = n && i.bind.bind(s, s);
                t.exports = n ? o : function(e) {
                    return function() {
                        return s.apply(e, arguments);
                    };
                };
            },
            {
                "../internals/function-bind-native": 263
            }
        ],
        269: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = function(e) {
                    return i(e) ? e : void 0;
                };
                t.exports = function(e, t) {
                    return arguments.length < 2 ? s(n[e]) : n[e] && n[e][t];
                };
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        270: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = e("../internals/get-method"), s = e("../internals/is-null-or-undefined"), o = e("../internals/iterators"), a = e("../internals/well-known-symbol")("iterator");
                t.exports = function(e) {
                    if (!s(e)) return i(e, a) || i(e, "@@iterator") || o[n(e)];
                };
            },
            {
                "../internals/classof": 236,
                "../internals/get-method": 273,
                "../internals/is-null-or-undefined": 288,
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        271: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/a-callable"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/get-iterator-method"), l = TypeError;
                t.exports = function(e, t) {
                    var r = arguments.length < 2 ? a(e) : t;
                    if (i(r)) return s(n(r, e));
                    throw new l(o(e) + " is not iterable");
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-iterator-method": 270,
                "../internals/try-to-string": 349
            }
        ],
        272: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-array"), s = e("../internals/is-callable"), o = e("../internals/classof-raw"), a = e("../internals/to-string"), l = n([].push);
                t.exports = function(e) {
                    if (s(e)) return e;
                    if (i(e)) {
                        for(var t = e.length, r = [], n = 0; n < t; n++){
                            var c = e[n];
                            "string" == typeof c ? l(r, c) : "number" != typeof c && "Number" !== o(c) && "String" !== o(c) || l(r, a(c));
                        }
                        var u = r.length, h = !0;
                        return function(e, t) {
                            if (h) return h = !1, t;
                            if (i(this)) return t;
                            for(var n = 0; n < u; n++)if (r[n] === e) return t;
                        };
                    }
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/function-uncurry-this": 268,
                "../internals/is-array": 284,
                "../internals/is-callable": 285,
                "../internals/to-string": 348
            }
        ],
        273: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = e("../internals/is-null-or-undefined");
                t.exports = function(e, t) {
                    var r = e[t];
                    return i(r) ? void 0 : n(r);
                };
            },
            {
                "../internals/a-callable": 222,
                "../internals/is-null-or-undefined": 288
            }
        ],
        274: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = function(e) {
                            return e && e.Math === Math && e;
                        };
                        t.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof e && e) || function() {
                            return this;
                        }() || this || Function("return this")();
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        275: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/to-object"), s = n({}.hasOwnProperty);
                t.exports = Object.hasOwn || function(e, t) {
                    return s(i(e), t);
                };
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/to-object": 344
            }
        ],
        276: [
            function(e, t, r) {
                "use strict";
                t.exports = {};
            },
            {}
        ],
        277: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    try {
                        1 === arguments.length ? console.error(e) : console.error(e, t);
                    } catch (e) {}
                };
            },
            {}
        ],
        278: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in");
                t.exports = n("document", "documentElement");
            },
            {
                "../internals/get-built-in": 269
            }
        ],
        279: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/document-create-element");
                t.exports = !n && !i(function() {
                    return 7 !== Object.defineProperty(s("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/document-create-element": 249,
                "../internals/fails": 260
            }
        ],
        280: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/classof-raw"), o = Object, a = n("".split);
                t.exports = i(function() {
                    return !o("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" === s(e) ? a(e, "") : o(e);
                } : o;
            },
            {
                "../internals/classof-raw": 235,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268
            }
        ],
        281: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/is-callable"), s = e("../internals/shared-store"), o = n(Function.toString);
                i(s.inspectSource) || (s.inspectSource = function(e) {
                    return o(e);
                }), t.exports = s.inspectSource;
            },
            {
                "../internals/function-uncurry-this": 268,
                "../internals/is-callable": 285,
                "../internals/shared-store": 333
            }
        ],
        282: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/weak-map-basic-detection"), a = e("../internals/global"), l = e("../internals/is-object"), c = e("../internals/create-non-enumerable-property"), u = e("../internals/has-own-property"), h = e("../internals/shared-store"), f = e("../internals/shared-key"), d = e("../internals/hidden-keys"), p = a.TypeError, m = a.WeakMap;
                if (o || h.state) {
                    var b = h.state || (h.state = new m);
                    b.get = b.get, b.has = b.has, b.set = b.set, n = function(e, t) {
                        if (b.has(e)) throw new p("Object already initialized");
                        return t.facade = e, b.set(e, t), t;
                    }, i = function(e) {
                        return b.get(e) || {};
                    }, s = function(e) {
                        return b.has(e);
                    };
                } else {
                    var g = f("state");
                    d[g] = !0, n = function(e, t) {
                        if (u(e, g)) throw new p("Object already initialized");
                        return t.facade = e, c(e, g, t), t;
                    }, i = function(e) {
                        return u(e, g) ? e[g] : {};
                    }, s = function(e) {
                        return u(e, g);
                    };
                }
                t.exports = {
                    set: n,
                    get: i,
                    has: s,
                    enforce: function(e) {
                        return s(e) ? i(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var r;
                            if (!l(t) || (r = i(t)).type !== e) throw new p("Incompatible receiver, " + e + " required");
                            return r;
                        };
                    }
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/is-object": 289,
                "../internals/shared-key": 332,
                "../internals/shared-store": 333,
                "../internals/weak-map-basic-detection": 354
            }
        ],
        283: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol"), i = e("../internals/iterators"), s = n("iterator"), o = Array.prototype;
                t.exports = function(e) {
                    return void 0 !== e && (i.Array === e || o[s] === e);
                };
            },
            {
                "../internals/iterators": 298,
                "../internals/well-known-symbol": 357
            }
        ],
        284: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw");
                t.exports = Array.isArray || function(e) {
                    return "Array" === n(e);
                };
            },
            {
                "../internals/classof-raw": 235
            }
        ],
        285: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/document-all"), i = n.all;
                t.exports = n.IS_HTMLDDA ? function(e) {
                    return "function" == typeof e || e === i;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            {
                "../internals/document-all": 248
            }
        ],
        286: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/classof"), a = e("../internals/get-built-in"), l = e("../internals/inspect-source"), c = function() {}, u = [], h = a("Reflect", "construct"), f = /^\s*(?:class|function)\b/, d = n(f.exec), p = !f.test(c), m = function(e) {
                    if (!s(e)) return !1;
                    try {
                        return h(c, u, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, b = function(e) {
                    if (!s(e)) return !1;
                    switch(o(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return p || !!d(f, l(e));
                    } catch (e) {
                        return !0;
                    }
                };
                b.sham = !0, t.exports = !h || i(function() {
                    var e;
                    return m(m.call) || !m(Object) || !m(function() {
                        e = !0;
                    }) || e;
                }) ? b : m;
            },
            {
                "../internals/classof": 236,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285
            }
        ],
        287: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/fails"), i = e("../internals/is-callable"), s = /#|\.prototype\./, o = function(e, t) {
                    var r = l[a(e)];
                    return r === u || r !== c && (i(t) ? n(t) : !!t);
                }, a = o.normalize = function(e) {
                    return String(e).replace(s, ".").toLowerCase();
                }, l = o.data = {}, c = o.NATIVE = "N", u = o.POLYFILL = "P";
                t.exports = o;
            },
            {
                "../internals/fails": 260,
                "../internals/is-callable": 285
            }
        ],
        288: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        289: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-callable"), i = e("../internals/document-all"), s = i.all;
                t.exports = i.IS_HTMLDDA ? function(e) {
                    return "object" == typeof e ? null !== e : n(e) || e === s;
                } : function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            {
                "../internals/document-all": 248,
                "../internals/is-callable": 285
            }
        ],
        290: [
            function(e, t, r) {
                "use strict";
                t.exports = !1;
            },
            {}
        ],
        291: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-object"), i = e("../internals/classof-raw"), s = e("../internals/well-known-symbol")("match");
                t.exports = function(e) {
                    var t;
                    return n(e) && (void 0 !== (t = e[s]) ? !!t : "RegExp" === i(e));
                };
            },
            {
                "../internals/classof-raw": 235,
                "../internals/is-object": 289,
                "../internals/well-known-symbol": 357
            }
        ],
        292: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/is-callable"), s = e("../internals/object-is-prototype-of"), o = e("../internals/use-symbol-as-uid"), a = Object;
                t.exports = o ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return i(t) && s(t.prototype, a(e));
                };
            },
            {
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/object-is-prototype-of": 314,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        293: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-bind-context"), i = e("../internals/function-call"), s = e("../internals/an-object"), o = e("../internals/try-to-string"), a = e("../internals/is-array-iterator-method"), l = e("../internals/length-of-array-like"), c = e("../internals/object-is-prototype-of"), u = e("../internals/get-iterator"), h = e("../internals/get-iterator-method"), f = e("../internals/iterator-close"), d = TypeError, p = function(e, t) {
                    this.stopped = e, this.result = t;
                }, m = p.prototype;
                t.exports = function(e, t, r) {
                    var b, g, y, v, w, _, x, k = r && r.that, S = !(!r || !r.AS_ENTRIES), M = !(!r || !r.IS_RECORD), C = !(!r || !r.IS_ITERATOR), T = !(!r || !r.INTERRUPTED), E = n(t, k), A = function(e) {
                        return b && f(b, "normal", e), new p(!0, e);
                    }, R = function(e) {
                        return S ? (s(e), T ? E(e[0], e[1], A) : E(e[0], e[1])) : T ? E(e, A) : E(e);
                    };
                    if (M) b = e.iterator;
                    else if (C) b = e;
                    else {
                        if (!(g = h(e))) throw new d(o(e) + " is not iterable");
                        if (a(g)) {
                            for(y = 0, v = l(e); v > y; y++)if ((w = R(e[y])) && c(m, w)) return w;
                            return new p(!1);
                        }
                        b = u(e, g);
                    }
                    for(_ = M ? e.next : b.next; !(x = i(_, b)).done;){
                        try {
                            w = R(x.value);
                        } catch (e) {
                            f(b, "throw", e);
                        }
                        if ("object" == typeof w && w && c(m, w)) return w;
                    }
                    return new p(!1);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-bind-context": 262,
                "../internals/function-call": 264,
                "../internals/get-iterator": 271,
                "../internals/get-iterator-method": 270,
                "../internals/is-array-iterator-method": 283,
                "../internals/iterator-close": 294,
                "../internals/length-of-array-like": 299,
                "../internals/object-is-prototype-of": 314,
                "../internals/try-to-string": 349
            }
        ],
        294: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/an-object"), s = e("../internals/get-method");
                t.exports = function(e, t, r) {
                    var o, a;
                    i(e);
                    try {
                        if (!(o = s(e, "return"))) {
                            if ("throw" === t) throw r;
                            return r;
                        }
                        o = n(o, e);
                    } catch (e) {
                        a = !0, o = e;
                    }
                    if ("throw" === t) throw r;
                    if (a) throw o;
                    return i(o), r;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-call": 264,
                "../internals/get-method": 273
            }
        ],
        295: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/iterators-core").IteratorPrototype, i = e("../internals/object-create"), s = e("../internals/create-property-descriptor"), o = e("../internals/set-to-string-tag"), a = e("../internals/iterators"), l = function() {
                    return this;
                };
                t.exports = function(e, t, r, c) {
                    var u = t + " Iterator";
                    return e.prototype = i(n, {
                        next: s(+!c, r)
                    }), o(e, u, !1, !0), a[u] = l, e;
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-create": 306,
                "../internals/set-to-string-tag": 331
            }
        ],
        296: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/is-pure"), o = e("../internals/function-name"), a = e("../internals/is-callable"), l = e("../internals/iterator-create-constructor"), c = e("../internals/object-get-prototype-of"), u = e("../internals/object-set-prototype-of"), h = e("../internals/set-to-string-tag"), f = e("../internals/create-non-enumerable-property"), d = e("../internals/define-built-in"), p = e("../internals/well-known-symbol"), m = e("../internals/iterators"), b = e("../internals/iterators-core"), g = o.PROPER, y = o.CONFIGURABLE, v = b.IteratorPrototype, w = b.BUGGY_SAFARI_ITERATORS, _ = p("iterator"), x = function() {
                    return this;
                };
                t.exports = function(e, t, r, o, p, b, k) {
                    l(r, t, o);
                    var S, M, C, T = function(e) {
                        if (e === p && j) return j;
                        if (!w && e && e in R) return R[e];
                        switch(e){
                            case "keys":
                            case "values":
                            case "entries":
                                return function() {
                                    return new r(this, e);
                                };
                        }
                        return function() {
                            return new r(this);
                        };
                    }, E = t + " Iterator", A = !1, R = e.prototype, O = R[_] || R["@@iterator"] || p && R[p], j = !w && O || T(p), I = "Array" === t && R.entries || O;
                    if (I && (S = c(I.call(new e))) !== Object.prototype && S.next && (s || c(S) === v || (u ? u(S, v) : a(S[_]) || d(S, _, x)), h(S, E, !0, !0), s && (m[E] = x)), g && "values" === p && O && "values" !== O.name && (!s && y ? f(R, "name", "values") : (A = !0, j = function() {
                        return i(O, this);
                    })), p) {
                        if (M = {
                            values: T("values"),
                            keys: b ? j : T("keys"),
                            entries: T("entries")
                        }, k) for(C in M)(w || A || !(C in R)) && d(R, C, M[C]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: w || A
                        }, M);
                    }
                    return s && !k || R[_] === j || d(R, _, j, {
                        name: p
                    }), m[t] = j, M;
                };
            },
            {
                "../internals/create-non-enumerable-property": 241,
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/function-name": 265,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/iterator-create-constructor": 295,
                "../internals/iterators": 298,
                "../internals/iterators-core": 297,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-set-prototype-of": 318,
                "../internals/set-to-string-tag": 331,
                "../internals/well-known-symbol": 357
            }
        ],
        297: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/fails"), a = e("../internals/is-callable"), l = e("../internals/is-object"), c = e("../internals/object-create"), u = e("../internals/object-get-prototype-of"), h = e("../internals/define-built-in"), f = e("../internals/well-known-symbol"), d = e("../internals/is-pure"), p = f("iterator"), m = !1;
                [].keys && ("next" in (s = [].keys()) ? (i = u(u(s))) !== Object.prototype && (n = i) : m = !0), !l(n) || o(function() {
                    var e = {};
                    return n[p].call(e) !== e;
                }) ? n = {} : d && (n = c(n)), a(n[p]) || h(n, p, function() {
                    return this;
                }), t.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: m
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/fails": 260,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-get-prototype-of": 313,
                "../internals/well-known-symbol": 357
            }
        ],
        298: [
            function(e, t, r) {
                arguments[4][276][0].apply(r, arguments);
            },
            {
                dup: 276
            }
        ],
        299: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-length");
                t.exports = function(e) {
                    return n(e.length);
                };
            },
            {
                "../internals/to-length": 343
            }
        ],
        300: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/fails"), s = e("../internals/is-callable"), o = e("../internals/has-own-property"), a = e("../internals/descriptors"), l = e("../internals/function-name").CONFIGURABLE, c = e("../internals/inspect-source"), u = e("../internals/internal-state"), h = u.enforce, f = u.get, d = String, p = Object.defineProperty, m = n("".slice), b = n("".replace), g = n([].join), y = a && !i(function() {
                    return 8 !== p(function() {}, "length", {
                        value: 8
                    }).length;
                }), v = String(String).split("String"), w = t.exports = function(e, t, r) {
                    "Symbol(" === m(d(t), 0, 7) && (t = "[" + b(d(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), r && r.getter && (t = "get " + t), r && r.setter && (t = "set " + t), (!o(e, "name") || l && e.name !== t) && (a ? p(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), y && r && o(r, "arity") && e.length !== r.arity && p(e, "length", {
                        value: r.arity
                    });
                    try {
                        r && o(r, "constructor") && r.constructor ? a && p(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = h(e);
                    return o(n, "source") || (n.source = g(v, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = w(function() {
                    return s(this) && f(this).source || c(this);
                }, "toString");
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-name": 265,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/inspect-source": 281,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285
            }
        ],
        301: [
            function(e, t, r) {
                "use strict";
                var n = Math.ceil, i = Math.floor;
                t.exports = Math.trunc || function(e) {
                    var t = +e;
                    return (t > 0 ? i : n)(t);
                };
            },
            {}
        ],
        302: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a, l = e("../internals/global"), c = e("../internals/function-bind-context"), u = e("../internals/object-get-own-property-descriptor").f, h = e("../internals/task").set, f = e("../internals/queue"), d = e("../internals/engine-is-ios"), p = e("../internals/engine-is-ios-pebble"), m = e("../internals/engine-is-webos-webkit"), b = e("../internals/engine-is-node"), g = l.MutationObserver || l.WebKitMutationObserver, y = l.document, v = l.process, w = l.Promise, _ = u(l, "queueMicrotask"), x = _ && _.value;
                if (!x) {
                    var k = new f, S = function() {
                        var e, t;
                        for(b && (e = v.domain) && e.exit(); t = k.get();)try {
                            t();
                        } catch (e) {
                            throw k.head && n(), e;
                        }
                        e && e.enter();
                    };
                    d || b || m || !g || !y ? !p && w && w.resolve ? ((o = w.resolve(void 0)).constructor = w, a = c(o.then, o), n = function() {
                        a(S);
                    }) : b ? n = function() {
                        v.nextTick(S);
                    } : (h = c(h, l), n = function() {
                        h(S);
                    }) : (i = !0, s = y.createTextNode(""), new g(S).observe(s, {
                        characterData: !0
                    }), n = function() {
                        s.data = i = !i;
                    }), x = function(e) {
                        k.head || n(), k.add(e);
                    };
                }
                t.exports = x;
            },
            {
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-ios-pebble": 252,
                "../internals/engine-is-node": 254,
                "../internals/engine-is-webos-webkit": 255,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/queue": 328,
                "../internals/task": 339
            }
        ],
        303: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/a-callable"), i = TypeError, s = function(e) {
                    var t, r;
                    this.promise = new e(function(e, n) {
                        if (void 0 !== t || void 0 !== r) throw new i("Bad Promise constructor");
                        t = e, r = n;
                    }), this.resolve = n(t), this.reject = n(r);
                };
                t.exports.f = function(e) {
                    return new s(e);
                };
            },
            {
                "../internals/a-callable": 222
            }
        ],
        304: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-regexp"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("The method doesn't accept regular expressions");
                    return e;
                };
            },
            {
                "../internals/is-regexp": 291
            }
        ],
        305: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-uncurry-this"), s = e("../internals/function-call"), o = e("../internals/fails"), a = e("../internals/object-keys"), l = e("../internals/object-get-own-property-symbols"), c = e("../internals/object-property-is-enumerable"), u = e("../internals/to-object"), h = e("../internals/indexed-object"), f = Object.assign, d = Object.defineProperty, p = i([].concat);
                t.exports = !f || o(function() {
                    if (n && 1 !== f({
                        b: 1
                    }, f(d({}, "a", {
                        enumerable: !0,
                        get: function() {
                            d(this, "b", {
                                value: 3,
                                enumerable: !1
                            });
                        }
                    }), {
                        b: 2
                    })).b) return !0;
                    var e = {}, t = {}, r = Symbol("assign detection");
                    return e[r] = 7, "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        t[e] = e;
                    }), 7 !== f({}, e)[r] || "abcdefghijklmnopqrst" !== a(f({}, t)).join("");
                }) ? function(e, t) {
                    for(var r = u(e), i = arguments.length, o = 1, f = l.f, d = c.f; i > o;)for(var m, b = h(arguments[o++]), g = f ? p(a(b), f(b)) : a(b), y = g.length, v = 0; y > v;)m = g[v++], n && !s(d, b, m) || (r[m] = b[m]);
                    return r;
                } : f;
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/indexed-object": 280,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-object": 344
            }
        ],
        306: [
            function(e, t, r) {
                "use strict";
                var n, i = e("../internals/an-object"), s = e("../internals/object-define-properties"), o = e("../internals/enum-bug-keys"), a = e("../internals/hidden-keys"), l = e("../internals/html"), c = e("../internals/document-create-element"), u = e("../internals/shared-key"), h = u("IE_PROTO"), f = function() {}, d = function(e) {
                    return "<script>" + e + "<\/script>";
                }, p = function(e) {
                    e.write(d("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, m = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    m = "undefined" != typeof document ? document.domain && n ? p(n) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(d("document.F=Object")), e.close(), e.F) : p(n);
                    for(var r = o.length; r--;)delete m.prototype[o[r]];
                    return m();
                };
                a[h] = !0, t.exports = Object.create || function(e, t) {
                    var r;
                    return null !== e ? (f.prototype = i(e), r = new f, f.prototype = null, r[h] = e) : r = m(), void 0 === t ? r : s.f(r, t);
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/document-create-element": 249,
                "../internals/enum-bug-keys": 258,
                "../internals/hidden-keys": 276,
                "../internals/html": 278,
                "../internals/object-define-properties": 307,
                "../internals/shared-key": 332
            }
        ],
        307: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/v8-prototype-define-bug"), s = e("../internals/object-define-property"), o = e("../internals/an-object"), a = e("../internals/to-indexed-object"), l = e("../internals/object-keys");
                r.f = n && !i ? Object.defineProperties : function(e, t) {
                    o(e);
                    for(var r, n = a(t), i = l(t), c = i.length, u = 0; c > u;)s.f(e, r = i[u++], n[r]);
                    return e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/object-define-property": 308,
                "../internals/object-keys": 316,
                "../internals/to-indexed-object": 341,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        308: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/ie8-dom-define"), s = e("../internals/v8-prototype-define-bug"), o = e("../internals/an-object"), a = e("../internals/to-property-key"), l = TypeError, c = Object.defineProperty, u = Object.getOwnPropertyDescriptor;
                r.f = n ? s ? function(e, t, r) {
                    if (o(e), t = a(t), o(r), "function" == typeof e && "prototype" === t && "value" in r && "writable" in r && !r.writable) {
                        var n = u(e, t);
                        n && n.writable && (e[t] = r.value, r = {
                            configurable: "configurable" in r ? r.configurable : n.configurable,
                            enumerable: "enumerable" in r ? r.enumerable : n.enumerable,
                            writable: !1
                        });
                    }
                    return c(e, t, r);
                } : c : function(e, t, r) {
                    if (o(e), t = a(t), o(r), i) try {
                        return c(e, t, r);
                    } catch (e) {}
                    if ("get" in r || "set" in r) throw new l("Accessors not supported");
                    return "value" in r && (e[t] = r.value), e;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/descriptors": 247,
                "../internals/ie8-dom-define": 279,
                "../internals/to-property-key": 346,
                "../internals/v8-prototype-define-bug": 352
            }
        ],
        309: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/function-call"), s = e("../internals/object-property-is-enumerable"), o = e("../internals/create-property-descriptor"), a = e("../internals/to-indexed-object"), l = e("../internals/to-property-key"), c = e("../internals/has-own-property"), u = e("../internals/ie8-dom-define"), h = Object.getOwnPropertyDescriptor;
                r.f = n ? h : function(e, t) {
                    if (e = a(e), t = l(t), u) try {
                        return h(e, t);
                    } catch (e) {}
                    if (c(e, t)) return o(!i(s.f, e, t), e[t]);
                };
            },
            {
                "../internals/create-property-descriptor": 242,
                "../internals/descriptors": 247,
                "../internals/function-call": 264,
                "../internals/has-own-property": 275,
                "../internals/ie8-dom-define": 279,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346
            }
        ],
        310: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof-raw"), i = e("../internals/to-indexed-object"), s = e("../internals/object-get-own-property-names").f, o = e("../internals/array-slice-simple"), a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                t.exports.f = function(e) {
                    return a && "Window" === n(e) ? function(e) {
                        try {
                            return s(e);
                        } catch (e) {
                            return o(a);
                        }
                    }(e) : s(i(e));
                };
            },
            {
                "../internals/array-slice-simple": 230,
                "../internals/classof-raw": 235,
                "../internals/object-get-own-property-names": 311,
                "../internals/to-indexed-object": 341
            }
        ],
        311: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys").concat("length", "prototype");
                r.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        312: [
            function(e, t, r) {
                "use strict";
                r.f = Object.getOwnPropertySymbols;
            },
            {}
        ],
        313: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/has-own-property"), i = e("../internals/is-callable"), s = e("../internals/to-object"), o = e("../internals/shared-key"), a = e("../internals/correct-prototype-getter"), l = o("IE_PROTO"), c = Object, u = c.prototype;
                t.exports = a ? c.getPrototypeOf : function(e) {
                    var t = s(e);
                    if (n(t, l)) return t[l];
                    var r = t.constructor;
                    return i(r) && t instanceof r ? r.prototype : t instanceof c ? u : null;
                };
            },
            {
                "../internals/correct-prototype-getter": 239,
                "../internals/has-own-property": 275,
                "../internals/is-callable": 285,
                "../internals/shared-key": 332,
                "../internals/to-object": 344
            }
        ],
        314: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this");
                t.exports = n({}.isPrototypeOf);
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        315: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = e("../internals/has-own-property"), s = e("../internals/to-indexed-object"), o = e("../internals/array-includes").indexOf, a = e("../internals/hidden-keys"), l = n([].push);
                t.exports = function(e, t) {
                    var r, n = s(e), c = 0, u = [];
                    for(r in n)!i(a, r) && i(n, r) && l(u, r);
                    for(; t.length > c;)i(n, r = t[c++]) && (~o(u, r) || l(u, r));
                    return u;
                };
            },
            {
                "../internals/array-includes": 228,
                "../internals/function-uncurry-this": 268,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/to-indexed-object": 341
            }
        ],
        316: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-keys-internal"), i = e("../internals/enum-bug-keys");
                t.exports = Object.keys || function(e) {
                    return n(e, i);
                };
            },
            {
                "../internals/enum-bug-keys": 258,
                "../internals/object-keys-internal": 315
            }
        ],
        317: [
            function(e, t, r) {
                "use strict";
                var n = {}.propertyIsEnumerable, i = Object.getOwnPropertyDescriptor, s = i && !n.call({
                    1: 2
                }, 1);
                r.f = s ? function(e) {
                    var t = i(this, e);
                    return !!t && t.enumerable;
                } : n;
            },
            {}
        ],
        318: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this-accessor"), i = e("../internals/an-object"), s = e("../internals/a-possible-prototype");
                t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, r = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(r, []), t = r instanceof Array;
                    } catch (e) {}
                    return function(r, n) {
                        return i(r), s(n), t ? e(r, n) : r.__proto__ = n, r;
                    };
                }() : void 0);
            },
            {
                "../internals/a-possible-prototype": 224,
                "../internals/an-object": 227,
                "../internals/function-uncurry-this-accessor": 266
            }
        ],
        319: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails"), s = e("../internals/function-uncurry-this"), o = e("../internals/object-get-prototype-of"), a = e("../internals/object-keys"), l = e("../internals/to-indexed-object"), c = s(e("../internals/object-property-is-enumerable").f), u = s([].push), h = n && i(function() {
                    var e = Object.create(null);
                    return e[2] = 2, !c(e, 2);
                }), f = function(e) {
                    return function(t) {
                        for(var r, i = l(t), s = a(i), f = h && null === o(i), d = s.length, p = 0, m = []; d > p;)r = s[p++], n && !(f ? r in i : c(i, r)) || u(m, e ? [
                            r,
                            i[r]
                        ] : i[r]);
                        return m;
                    };
                };
                t.exports = {
                    entries: f(!0),
                    values: f(!1)
                };
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260,
                "../internals/function-uncurry-this": 268,
                "../internals/object-get-prototype-of": 313,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/to-indexed-object": 341
            }
        ],
        320: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-callable"), s = e("../internals/is-object"), o = TypeError;
                t.exports = function(e, t) {
                    var r, a;
                    if ("string" === t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    if (i(r = e.valueOf) && !s(a = n(r, e))) return a;
                    if ("string" !== t && i(r = e.toString) && !s(a = n(r, e))) return a;
                    throw new o("Can't convert object to primitive value");
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/is-callable": 285,
                "../internals/is-object": 289
            }
        ],
        321: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/function-uncurry-this"), s = e("../internals/object-get-own-property-names"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/an-object"), l = i([].concat);
                t.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = s.f(a(e)), r = o.f;
                    return r ? l(t, r(e)) : t;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-symbols": 312
            }
        ],
        322: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n;
            },
            {
                "../internals/global": 274
            }
        ],
        323: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    try {
                        return {
                            error: !1,
                            value: e()
                        };
                    } catch (e) {
                        return {
                            error: !0,
                            value: e
                        };
                    }
                };
            },
            {}
        ],
        324: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/promise-native-constructor"), s = e("../internals/is-callable"), o = e("../internals/is-forced"), a = e("../internals/inspect-source"), l = e("../internals/well-known-symbol"), c = e("../internals/engine-is-browser"), u = e("../internals/engine-is-deno"), h = e("../internals/is-pure"), f = e("../internals/engine-v8-version"), d = i && i.prototype, p = l("species"), m = !1, b = s(n.PromiseRejectionEvent), g = o("Promise", function() {
                    var e = a(i), t = e !== String(i);
                    if (!t && 66 === f) return !0;
                    if (h && (!d.catch || !d.finally)) return !0;
                    if (!f || f < 51 || !/native code/.test(e)) {
                        var r = new i(function(e) {
                            e(1);
                        }), n = function(e) {
                            e(function() {}, function() {});
                        };
                        if ((r.constructor = {})[p] = n, !(m = r.then(function() {}) instanceof n)) return !0;
                    }
                    return !t && (c || u) && !b;
                });
                t.exports = {
                    CONSTRUCTOR: g,
                    REJECTION_EVENT: b,
                    SUBCLASSING: m
                };
            },
            {
                "../internals/engine-is-browser": 250,
                "../internals/engine-is-deno": 251,
                "../internals/engine-v8-version": 257,
                "../internals/global": 274,
                "../internals/inspect-source": 281,
                "../internals/is-callable": 285,
                "../internals/is-forced": 287,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/well-known-symbol": 357
            }
        ],
        325: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global");
                t.exports = n.Promise;
            },
            {
                "../internals/global": 274
            }
        ],
        326: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/is-object"), s = e("../internals/new-promise-capability");
                t.exports = function(e, t) {
                    if (n(e), i(t) && t.constructor === e) return t;
                    var r = s.f(e);
                    return (0, r.resolve)(t), r.promise;
                };
            },
            {
                "../internals/an-object": 227,
                "../internals/is-object": 289,
                "../internals/new-promise-capability": 303
            }
        ],
        327: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/promise-native-constructor"), i = e("../internals/check-correctness-of-iteration"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR;
                t.exports = s || !i(function(e) {
                    n.all(e).then(void 0, function() {});
                });
            },
            {
                "../internals/check-correctness-of-iteration": 234,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        328: [
            function(e, t, r) {
                "use strict";
                var n = function() {
                    this.head = null, this.tail = null;
                };
                n.prototype = {
                    add: function(e) {
                        var t = {
                            item: e,
                            next: null
                        }, r = this.tail;
                        r ? r.next = t : this.head = t, this.tail = t;
                    },
                    get: function() {
                        var e = this.head;
                        if (e) return null === (this.head = e.next) && (this.tail = null), e.item;
                    }
                }, t.exports = n;
            },
            {}
        ],
        329: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-null-or-undefined"), i = TypeError;
                t.exports = function(e) {
                    if (n(e)) throw new i("Can't call method on " + e);
                    return e;
                };
            },
            {
                "../internals/is-null-or-undefined": 288
            }
        ],
        330: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/get-built-in"), i = e("../internals/define-built-in-accessor"), s = e("../internals/well-known-symbol"), o = e("../internals/descriptors"), a = s("species");
                t.exports = function(e) {
                    var t = n(e);
                    o && t && !t[a] && i(t, a, {
                        configurable: !0,
                        get: function() {
                            return this;
                        }
                    });
                };
            },
            {
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        331: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/object-define-property").f, i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol")("toStringTag");
                t.exports = function(e, t, r) {
                    e && !r && (e = e.prototype), e && !i(e, s) && n(e, s, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/well-known-symbol": 357
            }
        ],
        332: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/shared"), i = e("../internals/uid"), s = n("keys");
                t.exports = function(e) {
                    return s[e] || (s[e] = i(e));
                };
            },
            {
                "../internals/shared": 334,
                "../internals/uid": 350
            }
        ],
        333: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/define-global-property"), s = n["__core-js_shared__"] || i("__core-js_shared__", {});
                t.exports = s;
            },
            {
                "../internals/define-global-property": 246,
                "../internals/global": 274
            }
        ],
        334: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/is-pure"), i = e("../internals/shared-store");
                (t.exports = function(e, t) {
                    return i[e] || (i[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.33.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.33.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            {
                "../internals/is-pure": 290,
                "../internals/shared-store": 333
            }
        ],
        335: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/an-object"), i = e("../internals/a-constructor"), s = e("../internals/is-null-or-undefined"), o = e("../internals/well-known-symbol")("species");
                t.exports = function(e, t) {
                    var r, a = n(e).constructor;
                    return void 0 === a || s(r = n(a)[o]) ? t : i(r);
                };
            },
            {
                "../internals/a-constructor": 223,
                "../internals/an-object": 227,
                "../internals/is-null-or-undefined": 288,
                "../internals/well-known-symbol": 357
            }
        ],
        336: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/engine-v8-version"), i = e("../internals/fails"), s = e("../internals/global").String;
                t.exports = !!Object.getOwnPropertySymbols && !i(function() {
                    var e = Symbol("symbol detection");
                    return !s(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
                });
            },
            {
                "../internals/engine-v8-version": 257,
                "../internals/fails": 260,
                "../internals/global": 274
            }
        ],
        337: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/get-built-in"), s = e("../internals/well-known-symbol"), o = e("../internals/define-built-in");
                t.exports = function() {
                    var e = i("Symbol"), t = e && e.prototype, r = t && t.valueOf, a = s("toPrimitive");
                    t && !t[a] && o(t, a, function(e) {
                        return n(r, this);
                    }, {
                        arity: 1
                    });
                };
            },
            {
                "../internals/define-built-in": 245,
                "../internals/function-call": 264,
                "../internals/get-built-in": 269,
                "../internals/well-known-symbol": 357
            }
        ],
        338: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !!Symbol.for && !!Symbol.keyFor;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        339: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o, a = e("../internals/global"), l = e("../internals/function-apply"), c = e("../internals/function-bind-context"), u = e("../internals/is-callable"), h = e("../internals/has-own-property"), f = e("../internals/fails"), d = e("../internals/html"), p = e("../internals/array-slice"), m = e("../internals/document-create-element"), b = e("../internals/validate-arguments-length"), g = e("../internals/engine-is-ios"), y = e("../internals/engine-is-node"), v = a.setImmediate, w = a.clearImmediate, _ = a.process, x = a.Dispatch, k = a.Function, S = a.MessageChannel, M = a.String, C = 0, T = {};
                f(function() {
                    n = a.location;
                });
                var E = function(e) {
                    if (h(T, e)) {
                        var t = T[e];
                        delete T[e], t();
                    }
                }, A = function(e) {
                    return function() {
                        E(e);
                    };
                }, R = function(e) {
                    E(e.data);
                }, O = function(e) {
                    a.postMessage(M(e), n.protocol + "//" + n.host);
                };
                v && w || (v = function(e) {
                    b(arguments.length, 1);
                    var t = u(e) ? e : k(e), r = p(arguments, 1);
                    return T[++C] = function() {
                        l(t, void 0, r);
                    }, i(C), C;
                }, w = function(e) {
                    delete T[e];
                }, y ? i = function(e) {
                    _.nextTick(A(e));
                } : x && x.now ? i = function(e) {
                    x.now(A(e));
                } : S && !g ? (o = (s = new S).port2, s.port1.onmessage = R, i = c(o.postMessage, o)) : a.addEventListener && u(a.postMessage) && !a.importScripts && n && "file:" !== n.protocol && !f(O) ? (i = O, a.addEventListener("message", R, !1)) : i = "onreadystatechange" in m("script") ? function(e) {
                    d.appendChild(m("script")).onreadystatechange = function() {
                        d.removeChild(this), E(e);
                    };
                } : function(e) {
                    setTimeout(A(e), 0);
                }), t.exports = {
                    set: v,
                    clear: w
                };
            },
            {
                "../internals/array-slice": 231,
                "../internals/document-create-element": 249,
                "../internals/engine-is-ios": 253,
                "../internals/engine-is-node": 254,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-bind-context": 262,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/html": 278,
                "../internals/is-callable": 285,
                "../internals/validate-arguments-length": 353
            }
        ],
        340: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.max, s = Math.min;
                t.exports = function(e, t) {
                    var r = n(e);
                    return r < 0 ? i(r + t, 0) : s(r, t);
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        341: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/indexed-object"), i = e("../internals/require-object-coercible");
                t.exports = function(e) {
                    return n(i(e));
                };
            },
            {
                "../internals/indexed-object": 280,
                "../internals/require-object-coercible": 329
            }
        ],
        342: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/math-trunc");
                t.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            {
                "../internals/math-trunc": 301
            }
        ],
        343: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-integer-or-infinity"), i = Math.min;
                t.exports = function(e) {
                    return e > 0 ? i(n(e), 9007199254740991) : 0;
                };
            },
            {
                "../internals/to-integer-or-infinity": 342
            }
        ],
        344: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/require-object-coercible"), i = Object;
                t.exports = function(e) {
                    return i(n(e));
                };
            },
            {
                "../internals/require-object-coercible": 329
            }
        ],
        345: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-call"), i = e("../internals/is-object"), s = e("../internals/is-symbol"), o = e("../internals/get-method"), a = e("../internals/ordinary-to-primitive"), l = e("../internals/well-known-symbol"), c = TypeError, u = l("toPrimitive");
                t.exports = function(e, t) {
                    if (!i(e) || s(e)) return e;
                    var r, l = o(e, u);
                    if (l) {
                        if (void 0 === t && (t = "default"), r = n(l, e, t), !i(r) || s(r)) return r;
                        throw new c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), a(e, t);
                };
            },
            {
                "../internals/function-call": 264,
                "../internals/get-method": 273,
                "../internals/is-object": 289,
                "../internals/is-symbol": 292,
                "../internals/ordinary-to-primitive": 320,
                "../internals/well-known-symbol": 357
            }
        ],
        346: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-primitive"), i = e("../internals/is-symbol");
                t.exports = function(e) {
                    var t = n(e, "string");
                    return i(t) ? t : t + "";
                };
            },
            {
                "../internals/is-symbol": 292,
                "../internals/to-primitive": 345
            }
        ],
        347: [
            function(e, t, r) {
                "use strict";
                var n = {};
                n[e("../internals/well-known-symbol")("toStringTag")] = "z", t.exports = "[object z]" === String(n);
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        348: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/classof"), i = String;
                t.exports = function(e) {
                    if ("Symbol" === n(e)) throw new TypeError("Cannot convert a Symbol value to a string");
                    return i(e);
                };
            },
            {
                "../internals/classof": 236
            }
        ],
        349: [
            function(e, t, r) {
                "use strict";
                var n = String;
                t.exports = function(e) {
                    try {
                        return n(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            {}
        ],
        350: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/function-uncurry-this"), i = 0, s = Math.random(), o = n(1..toString);
                t.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + o(++i + s, 36);
                };
            },
            {
                "../internals/function-uncurry-this": 268
            }
        ],
        351: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/symbol-constructor-detection");
                t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            {
                "../internals/symbol-constructor-detection": 336
            }
        ],
        352: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/descriptors"), i = e("../internals/fails");
                t.exports = n && i(function() {
                    return 42 !== Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            {
                "../internals/descriptors": 247,
                "../internals/fails": 260
            }
        ],
        353: [
            function(e, t, r) {
                "use strict";
                var n = TypeError;
                t.exports = function(e, t) {
                    if (e < t) throw new n("Not enough arguments");
                    return e;
                };
            },
            {}
        ],
        354: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/is-callable"), s = n.WeakMap;
                t.exports = i(s) && /native code/.test(String(s));
            },
            {
                "../internals/global": 274,
                "../internals/is-callable": 285
            }
        ],
        355: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/path"), i = e("../internals/has-own-property"), s = e("../internals/well-known-symbol-wrapped"), o = e("../internals/object-define-property").f;
                t.exports = function(e) {
                    var t = n.Symbol || (n.Symbol = {});
                    i(t, e) || o(t, e, {
                        value: s.f(e)
                    });
                };
            },
            {
                "../internals/has-own-property": 275,
                "../internals/object-define-property": 308,
                "../internals/path": 322,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        356: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/well-known-symbol");
                r.f = n;
            },
            {
                "../internals/well-known-symbol": 357
            }
        ],
        357: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/global"), i = e("../internals/shared"), s = e("../internals/has-own-property"), o = e("../internals/uid"), a = e("../internals/symbol-constructor-detection"), l = e("../internals/use-symbol-as-uid"), c = n.Symbol, u = i("wks"), h = l ? c.for || c : c && c.withoutSetter || o;
                t.exports = function(e) {
                    return s(u, e) || (u[e] = a && s(c, e) ? c[e] : h("Symbol." + e)), u[e];
                };
            },
            {
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-constructor-detection": 336,
                "../internals/uid": 350,
                "../internals/use-symbol-as-uid": 351
            }
        ],
        358: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").findIndex, s = e("../internals/add-to-unscopables"), o = !0;
                "findIndex" in [] && Array(1).findIndex(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    findIndex: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("findIndex");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        359: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-iteration").find, s = e("../internals/add-to-unscopables"), o = !0;
                "find" in [] && Array(1).find(function() {
                    o = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: o
                }, {
                    find: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), s("find");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-iteration": 229,
                "../internals/export": 259
            }
        ],
        360: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/array-includes").includes, s = e("../internals/fails"), o = e("../internals/add-to-unscopables");
                n({
                    target: "Array",
                    proto: !0,
                    forced: s(function() {
                        return !Array(1).includes();
                    })
                }, {
                    includes: function(e) {
                        return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), o("includes");
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/array-includes": 228,
                "../internals/export": 259,
                "../internals/fails": 260
            }
        ],
        361: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/to-indexed-object"), i = e("../internals/add-to-unscopables"), s = e("../internals/iterators"), o = e("../internals/internal-state"), a = e("../internals/object-define-property").f, l = e("../internals/iterator-define"), c = e("../internals/create-iter-result-object"), u = e("../internals/is-pure"), h = e("../internals/descriptors"), f = o.set, d = o.getterFor("Array Iterator");
                t.exports = l(Array, "Array", function(e, t) {
                    f(this, {
                        type: "Array Iterator",
                        target: n(e),
                        index: 0,
                        kind: t
                    });
                }, function() {
                    var e = d(this), t = e.target, r = e.kind, n = e.index++;
                    if (!t || n >= t.length) return e.target = void 0, c(void 0, !0);
                    switch(r){
                        case "keys":
                            return c(n, !1);
                        case "values":
                            return c(t[n], !1);
                    }
                    return c([
                        n,
                        t[n]
                    ], !1);
                }, "values");
                var p = s.Arguments = s.Array;
                if (i("keys"), i("values"), i("entries"), !u && h && "values" !== p.name) try {
                    a(p, "name", {
                        value: "values"
                    });
                } catch (e) {}
            },
            {
                "../internals/add-to-unscopables": 225,
                "../internals/create-iter-result-object": 240,
                "../internals/descriptors": 247,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/iterator-define": 296,
                "../internals/iterators": 298,
                "../internals/object-define-property": 308,
                "../internals/to-indexed-object": 341
            }
        ],
        362: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/function-apply"), o = e("../internals/function-call"), a = e("../internals/function-uncurry-this"), l = e("../internals/fails"), c = e("../internals/is-callable"), u = e("../internals/is-symbol"), h = e("../internals/array-slice"), f = e("../internals/get-json-replacer-function"), d = e("../internals/symbol-constructor-detection"), p = String, m = i("JSON", "stringify"), b = a(/./.exec), g = a("".charAt), y = a("".charCodeAt), v = a("".replace), w = a(1..toString), _ = /[\uD800-\uDFFF]/g, x = /^[\uD800-\uDBFF]$/, k = /^[\uDC00-\uDFFF]$/, S = !d || l(function() {
                    var e = i("Symbol")("stringify detection");
                    return "[null]" !== m([
                        e
                    ]) || "{}" !== m({
                        a: e
                    }) || "{}" !== m(Object(e));
                }), M = l(function() {
                    return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
                }), C = function(e, t) {
                    var r = h(arguments), n = f(t);
                    if (c(n) || void 0 !== e && !u(e)) return r[1] = function(e, t) {
                        if (c(n) && (t = o(n, this, p(e), t)), !u(t)) return t;
                    }, s(m, null, r);
                }, T = function(e, t, r) {
                    var n = g(r, t - 1), i = g(r, t + 1);
                    return b(x, e) && !b(k, i) || b(k, e) && !b(x, n) ? "\\u" + w(y(e, 0), 16) : e;
                };
                m && n({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: S || M
                }, {
                    stringify: function(e, t, r) {
                        var n = h(arguments), i = s(S ? C : m, null, n);
                        return M && "string" == typeof i ? v(i, _, T) : i;
                    }
                });
            },
            {
                "../internals/array-slice": 231,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-apply": 261,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/get-built-in": 269,
                "../internals/get-json-replacer-function": 272,
                "../internals/is-callable": 285,
                "../internals/is-symbol": 292,
                "../internals/symbol-constructor-detection": 336
            }
        ],
        363: [
            function(e, t, r) {
                "use strict";
                e("../internals/export")({
                    target: "Number",
                    stat: !0
                }, {
                    isNaN: function(e) {
                        return e != e;
                    }
                });
            },
            {
                "../internals/export": 259
            }
        ],
        364: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-assign");
                n({
                    target: "Object",
                    stat: !0,
                    arity: 2,
                    forced: Object.assign !== i
                }, {
                    assign: i
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-assign": 305
            }
        ],
        365: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/symbol-constructor-detection"), s = e("../internals/fails"), o = e("../internals/object-get-own-property-symbols"), a = e("../internals/to-object");
                n({
                    target: "Object",
                    stat: !0,
                    forced: !i || s(function() {
                        o.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        var t = o.f;
                        return t ? t(a(e)) : [];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/symbol-constructor-detection": 336,
                "../internals/to-object": 344
            }
        ],
        366: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/to-object"), s = e("../internals/object-keys");
                n({
                    target: "Object",
                    stat: !0,
                    forced: e("../internals/fails")(function() {
                        s(1);
                    })
                }, {
                    keys: function(e) {
                        return s(i(e));
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/object-keys": 316,
                "../internals/to-object": 344
            }
        ],
        367: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/object-to-array").values;
                n({
                    target: "Object",
                    stat: !0
                }, {
                    values: function(e) {
                        return i(e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/object-to-array": 319
            }
        ],
        368: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    all: function(e) {
                        var t = this, r = o.f(t), n = r.resolve, c = r.reject, u = a(function() {
                            var r = s(t.resolve), o = [], a = 0, u = 1;
                            l(e, function(e) {
                                var s = a++, l = !1;
                                u++, i(r, t, e).then(function(e) {
                                    l || (l = !0, o[s] = e, --u || n(o));
                                }, c);
                            }), --u || n(o);
                        });
                        return u.error && c(u.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        369: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-constructor-detection").CONSTRUCTOR, o = e("../internals/promise-native-constructor"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/define-built-in"), u = o && o.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    forced: s,
                    real: !0
                }, {
                    catch: function(e) {
                        return this.then(void 0, e);
                    }
                }), !i && l(o)) {
                    var h = a("Promise").prototype.catch;
                    u.catch !== h && c(u, "catch", h, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325
            }
        ],
        370: [
            function(e, t, r) {
                "use strict";
                var n, i, s, o = e("../internals/export"), a = e("../internals/is-pure"), l = e("../internals/engine-is-node"), c = e("../internals/global"), u = e("../internals/function-call"), h = e("../internals/define-built-in"), f = e("../internals/object-set-prototype-of"), d = e("../internals/set-to-string-tag"), p = e("../internals/set-species"), m = e("../internals/a-callable"), b = e("../internals/is-callable"), g = e("../internals/is-object"), y = e("../internals/an-instance"), v = e("../internals/species-constructor"), w = e("../internals/task").set, _ = e("../internals/microtask"), x = e("../internals/host-report-errors"), k = e("../internals/perform"), S = e("../internals/queue"), M = e("../internals/internal-state"), C = e("../internals/promise-native-constructor"), T = e("../internals/promise-constructor-detection"), E = e("../internals/new-promise-capability"), A = T.CONSTRUCTOR, R = T.REJECTION_EVENT, O = T.SUBCLASSING, j = M.getterFor("Promise"), I = M.set, N = C && C.prototype, P = C, B = N, D = c.TypeError, F = c.document, L = c.process, z = E.f, U = z, $ = !!(F && F.createEvent && c.dispatchEvent), H = function(e) {
                    var t;
                    return !(!g(e) || !b(t = e.then)) && t;
                }, V = function(e, t) {
                    var r, n, i, s = t.value, o = 1 === t.state, a = o ? e.ok : e.fail, l = e.resolve, c = e.reject, h = e.domain;
                    try {
                        a ? (o || (2 === t.rejection && Y(t), t.rejection = 1), !0 === a ? r = s : (h && h.enter(), r = a(s), h && (h.exit(), i = !0)), r === e.promise ? c(new D("Promise-chain cycle")) : (n = H(r)) ? u(n, r, l, c) : l(r)) : c(s);
                    } catch (e) {
                        h && !i && h.exit(), c(e);
                    }
                }, q = function(e, t) {
                    e.notified || (e.notified = !0, _(function() {
                        for(var r, n = e.reactions; r = n.get();)V(r, e);
                        e.notified = !1, t && !e.rejection && X(e);
                    }));
                }, W = function(e, t, r) {
                    var n, i;
                    $ ? ((n = F.createEvent("Event")).promise = t, n.reason = r, n.initEvent(e, !1, !0), c.dispatchEvent(n)) : n = {
                        promise: t,
                        reason: r
                    }, !R && (i = c["on" + e]) ? i(n) : "unhandledrejection" === e && x("Unhandled promise rejection", r);
                }, X = function(e) {
                    u(w, c, function() {
                        var t, r = e.facade, n = e.value;
                        if (K(e) && (t = k(function() {
                            l ? L.emit("unhandledRejection", n, r) : W("unhandledrejection", r, n);
                        }), e.rejection = l || K(e) ? 2 : 1, t.error)) throw t.value;
                    });
                }, K = function(e) {
                    return 1 !== e.rejection && !e.parent;
                }, Y = function(e) {
                    u(w, c, function() {
                        var t = e.facade;
                        l ? L.emit("rejectionHandled", t) : W("rejectionhandled", t, e.value);
                    });
                }, Z = function(e, t, r) {
                    return function(n) {
                        e(t, n, r);
                    };
                }, G = function(e, t, r) {
                    e.done || (e.done = !0, r && (e = r), e.value = t, e.state = 2, q(e, !0));
                }, J = function(e, t, r) {
                    if (!e.done) {
                        e.done = !0, r && (e = r);
                        try {
                            if (e.facade === t) throw new D("Promise can't be resolved itself");
                            var n = H(t);
                            n ? _(function() {
                                var r = {
                                    done: !1
                                };
                                try {
                                    u(n, t, Z(J, r, e), Z(G, r, e));
                                } catch (t) {
                                    G(r, t, e);
                                }
                            }) : (e.value = t, e.state = 1, q(e, !1));
                        } catch (t) {
                            G({
                                done: !1
                            }, t, e);
                        }
                    }
                };
                if (A && (B = (P = function(e) {
                    y(this, B), m(e), u(n, this);
                    var t = j(this);
                    try {
                        e(Z(J, t), Z(G, t));
                    } catch (e) {
                        G(t, e);
                    }
                }).prototype, (n = function(e) {
                    I(this, {
                        type: "Promise",
                        done: !1,
                        notified: !1,
                        parent: !1,
                        reactions: new S,
                        rejection: !1,
                        state: 0,
                        value: void 0
                    });
                }).prototype = h(B, "then", function(e, t) {
                    var r = j(this), n = z(v(this, P));
                    return r.parent = !0, n.ok = !b(e) || e, n.fail = b(t) && t, n.domain = l ? L.domain : void 0, 0 === r.state ? r.reactions.add(n) : _(function() {
                        V(n, r);
                    }), n.promise;
                }), i = function() {
                    var e = new n, t = j(e);
                    this.promise = e, this.resolve = Z(J, t), this.reject = Z(G, t);
                }, E.f = z = function(e) {
                    return e === P || void 0 === e ? new i(e) : U(e);
                }, !a && b(C) && N !== Object.prototype)) {
                    s = N.then, O || h(N, "then", function(e, t) {
                        var r = this;
                        return new P(function(e, t) {
                            u(s, r, e, t);
                        }).then(e, t);
                    }, {
                        unsafe: !0
                    });
                    try {
                        delete N.constructor;
                    } catch (e) {}
                    f && f(N, B);
                }
                o({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: A
                }, {
                    Promise: P
                }), d(P, "Promise", !1, !0), p("Promise");
            },
            {
                "../internals/a-callable": 222,
                "../internals/an-instance": 226,
                "../internals/define-built-in": 245,
                "../internals/engine-is-node": 254,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/global": 274,
                "../internals/host-report-errors": 277,
                "../internals/internal-state": 282,
                "../internals/is-callable": 285,
                "../internals/is-object": 289,
                "../internals/is-pure": 290,
                "../internals/microtask": 302,
                "../internals/new-promise-capability": 303,
                "../internals/object-set-prototype-of": 318,
                "../internals/perform": 323,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/queue": 328,
                "../internals/set-species": 330,
                "../internals/set-to-string-tag": 331,
                "../internals/species-constructor": 335,
                "../internals/task": 339
            }
        ],
        371: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/is-pure"), s = e("../internals/promise-native-constructor"), o = e("../internals/fails"), a = e("../internals/get-built-in"), l = e("../internals/is-callable"), c = e("../internals/species-constructor"), u = e("../internals/promise-resolve"), h = e("../internals/define-built-in"), f = s && s.prototype;
                if (n({
                    target: "Promise",
                    proto: !0,
                    real: !0,
                    forced: !!s && o(function() {
                        f.finally.call({
                            then: function() {}
                        }, function() {});
                    })
                }, {
                    finally: function(e) {
                        var t = c(this, a("Promise")), r = l(e);
                        return this.then(r ? function(r) {
                            return u(t, e()).then(function() {
                                return r;
                            });
                        } : e, r ? function(r) {
                            return u(t, e()).then(function() {
                                throw r;
                            });
                        } : e);
                    }
                }), !i && l(s)) {
                    var d = a("Promise").prototype.finally;
                    f.finally !== d && h(f, "finally", d, {
                        unsafe: !0
                    });
                }
            },
            {
                "../internals/define-built-in": 245,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/get-built-in": 269,
                "../internals/is-callable": 285,
                "../internals/is-pure": 290,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326,
                "../internals/species-constructor": 335
            }
        ],
        372: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.promise.constructor"), e("../modules/es.promise.all"), e("../modules/es.promise.catch"), e("../modules/es.promise.race"), e("../modules/es.promise.reject"), e("../modules/es.promise.resolve");
            },
            {
                "../modules/es.promise.all": 368,
                "../modules/es.promise.catch": 369,
                "../modules/es.promise.constructor": 370,
                "../modules/es.promise.race": 373,
                "../modules/es.promise.reject": 374,
                "../modules/es.promise.resolve": 375
            }
        ],
        373: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/a-callable"), o = e("../internals/new-promise-capability"), a = e("../internals/perform"), l = e("../internals/iterate");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-statics-incorrect-iteration")
                }, {
                    race: function(e) {
                        var t = this, r = o.f(t), n = r.reject, c = a(function() {
                            var o = s(t.resolve);
                            l(e, function(e) {
                                i(o, t, e).then(r.resolve, n);
                            });
                        });
                        return c.error && n(c.value), r.promise;
                    }
                });
            },
            {
                "../internals/a-callable": 222,
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/iterate": 293,
                "../internals/new-promise-capability": 303,
                "../internals/perform": 323,
                "../internals/promise-statics-incorrect-iteration": 327
            }
        ],
        374: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-call"), s = e("../internals/new-promise-capability");
                n({
                    target: "Promise",
                    stat: !0,
                    forced: e("../internals/promise-constructor-detection").CONSTRUCTOR
                }, {
                    reject: function(e) {
                        var t = s.f(this);
                        return i(t.reject, void 0, e), t.promise;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-call": 264,
                "../internals/new-promise-capability": 303,
                "../internals/promise-constructor-detection": 324
            }
        ],
        375: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/is-pure"), o = e("../internals/promise-native-constructor"), a = e("../internals/promise-constructor-detection").CONSTRUCTOR, l = e("../internals/promise-resolve"), c = i("Promise"), u = s && !a;
                n({
                    target: "Promise",
                    stat: !0,
                    forced: s || a
                }, {
                    resolve: function(e) {
                        return l(u && this === c ? o : this, e);
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/is-pure": 290,
                "../internals/promise-constructor-detection": 324,
                "../internals/promise-native-constructor": 325,
                "../internals/promise-resolve": 326
            }
        ],
        376: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/to-absolute-index"), o = RangeError, a = String.fromCharCode, l = String.fromCodePoint, c = i([].join);
                n({
                    target: "String",
                    stat: !0,
                    arity: 1,
                    forced: !!l && 1 !== l.length
                }, {
                    fromCodePoint: function(e) {
                        for(var t, r = [], n = arguments.length, i = 0; n > i;){
                            if (t = +arguments[i++], s(t, 1114111) !== t) throw new o(t + " is not a valid code point");
                            r[i] = t < 65536 ? a(t) : a(55296 + ((t -= 65536) >> 10), t % 1024 + 56320);
                        }
                        return c(r, "");
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/to-absolute-index": 340
            }
        ],
        377: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/function-uncurry-this"), s = e("../internals/not-a-regexp"), o = e("../internals/require-object-coercible"), a = e("../internals/to-string"), l = e("../internals/correct-is-regexp-logic"), c = i("".indexOf);
                n({
                    target: "String",
                    proto: !0,
                    forced: !l("includes")
                }, {
                    includes: function(e) {
                        return !!~c(a(o(this)), a(s(e)), arguments.length > 1 ? arguments[1] : void 0);
                    }
                });
            },
            {
                "../internals/correct-is-regexp-logic": 238,
                "../internals/export": 259,
                "../internals/function-uncurry-this": 268,
                "../internals/not-a-regexp": 304,
                "../internals/require-object-coercible": 329,
                "../internals/to-string": 348
            }
        ],
        378: [
            function(e, t, r) {
                "use strict";
                e("../internals/well-known-symbol-define")("asyncIterator");
            },
            {
                "../internals/well-known-symbol-define": 355
            }
        ],
        379: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/global"), s = e("../internals/function-call"), o = e("../internals/function-uncurry-this"), a = e("../internals/is-pure"), l = e("../internals/descriptors"), c = e("../internals/symbol-constructor-detection"), u = e("../internals/fails"), h = e("../internals/has-own-property"), f = e("../internals/object-is-prototype-of"), d = e("../internals/an-object"), p = e("../internals/to-indexed-object"), m = e("../internals/to-property-key"), b = e("../internals/to-string"), g = e("../internals/create-property-descriptor"), y = e("../internals/object-create"), v = e("../internals/object-keys"), w = e("../internals/object-get-own-property-names"), _ = e("../internals/object-get-own-property-names-external"), x = e("../internals/object-get-own-property-symbols"), k = e("../internals/object-get-own-property-descriptor"), S = e("../internals/object-define-property"), M = e("../internals/object-define-properties"), C = e("../internals/object-property-is-enumerable"), T = e("../internals/define-built-in"), E = e("../internals/define-built-in-accessor"), A = e("../internals/shared"), R = e("../internals/shared-key"), O = e("../internals/hidden-keys"), j = e("../internals/uid"), I = e("../internals/well-known-symbol"), N = e("../internals/well-known-symbol-wrapped"), P = e("../internals/well-known-symbol-define"), B = e("../internals/symbol-define-to-primitive"), D = e("../internals/set-to-string-tag"), F = e("../internals/internal-state"), L = e("../internals/array-iteration").forEach, z = R("hidden"), U = F.set, $ = F.getterFor("Symbol"), H = Object.prototype, V = i.Symbol, q = V && V.prototype, W = i.RangeError, X = i.TypeError, K = i.QObject, Y = k.f, Z = S.f, G = _.f, J = C.f, Q = o([].push), ee = A("symbols"), te = A("op-symbols"), re = A("wks"), ne = !K || !K.prototype || !K.prototype.findChild, ie = function(e, t, r) {
                    var n = Y(H, t);
                    n && delete H[t], Z(e, t, r), n && e !== H && Z(H, t, n);
                }, se = l && u(function() {
                    return 7 !== y(Z({}, "a", {
                        get: function() {
                            return Z(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? ie : Z, oe = function(e, t) {
                    var r = ee[e] = y(q);
                    return U(r, {
                        type: "Symbol",
                        tag: e,
                        description: t
                    }), l || (r.description = t), r;
                }, ae = function(e, t, r) {
                    e === H && ae(te, t, r), d(e);
                    var n = m(t);
                    return d(r), h(ee, n) ? (r.enumerable ? (h(e, z) && e[z][n] && (e[z][n] = !1), r = y(r, {
                        enumerable: g(0, !1)
                    })) : (h(e, z) || Z(e, z, g(1, {})), e[z][n] = !0), se(e, n, r)) : Z(e, n, r);
                }, le = function(e, t) {
                    d(e);
                    var r = p(t), n = v(r).concat(fe(r));
                    return L(n, function(t) {
                        l && !s(ce, r, t) || ae(e, t, r[t]);
                    }), e;
                }, ce = function(e) {
                    var t = m(e), r = s(J, this, t);
                    return !(this === H && h(ee, t) && !h(te, t)) && (!(r || !h(this, t) || !h(ee, t) || h(this, z) && this[z][t]) || r);
                }, ue = function(e, t) {
                    var r = p(e), n = m(t);
                    if (r !== H || !h(ee, n) || h(te, n)) {
                        var i = Y(r, n);
                        return !i || !h(ee, n) || h(r, z) && r[z][n] || (i.enumerable = !0), i;
                    }
                }, he = function(e) {
                    var t = G(p(e)), r = [];
                    return L(t, function(e) {
                        h(ee, e) || h(O, e) || Q(r, e);
                    }), r;
                }, fe = function(e) {
                    var t = e === H, r = G(t ? te : p(e)), n = [];
                    return L(r, function(e) {
                        !h(ee, e) || t && !h(H, e) || Q(n, ee[e]);
                    }), n;
                };
                c || (T(q = (V = function() {
                    if (f(q, this)) throw new X("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? b(arguments[0]) : void 0, t = j(e), r = function(e) {
                        this === H && s(r, te, e), h(this, z) && h(this[z], t) && (this[z][t] = !1);
                        var n = g(1, e);
                        try {
                            se(this, t, n);
                        } catch (e) {
                            if (!(e instanceof W)) throw e;
                            ie(this, t, n);
                        }
                    };
                    return l && ne && se(H, t, {
                        configurable: !0,
                        set: r
                    }), oe(t, e);
                }).prototype, "toString", function() {
                    return $(this).tag;
                }), T(V, "withoutSetter", function(e) {
                    return oe(j(e), e);
                }), C.f = ce, S.f = ae, M.f = le, k.f = ue, w.f = _.f = he, x.f = fe, N.f = function(e) {
                    return oe(I(e), e);
                }, l && (E(q, "description", {
                    configurable: !0,
                    get: function() {
                        return $(this).description;
                    }
                }), a || T(H, "propertyIsEnumerable", ce, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !c,
                    sham: !c
                }, {
                    Symbol: V
                }), L(v(re), function(e) {
                    P(e);
                }), n({
                    target: "Symbol",
                    stat: !0,
                    forced: !c
                }, {
                    useSetter: function() {
                        ne = !0;
                    },
                    useSimple: function() {
                        ne = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c,
                    sham: !l
                }, {
                    create: function(e, t) {
                        return void 0 === t ? y(e) : le(y(e), t);
                    },
                    defineProperty: ae,
                    defineProperties: le,
                    getOwnPropertyDescriptor: ue
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c
                }, {
                    getOwnPropertyNames: he
                }), B(), D(V, "Symbol"), O[z] = !0;
            },
            {
                "../internals/an-object": 227,
                "../internals/array-iteration": 229,
                "../internals/create-property-descriptor": 242,
                "../internals/define-built-in": 245,
                "../internals/define-built-in-accessor": 244,
                "../internals/descriptors": 247,
                "../internals/export": 259,
                "../internals/fails": 260,
                "../internals/function-call": 264,
                "../internals/function-uncurry-this": 268,
                "../internals/global": 274,
                "../internals/has-own-property": 275,
                "../internals/hidden-keys": 276,
                "../internals/internal-state": 282,
                "../internals/is-pure": 290,
                "../internals/object-create": 306,
                "../internals/object-define-properties": 307,
                "../internals/object-define-property": 308,
                "../internals/object-get-own-property-descriptor": 309,
                "../internals/object-get-own-property-names": 311,
                "../internals/object-get-own-property-names-external": 310,
                "../internals/object-get-own-property-symbols": 312,
                "../internals/object-is-prototype-of": 314,
                "../internals/object-keys": 316,
                "../internals/object-property-is-enumerable": 317,
                "../internals/set-to-string-tag": 331,
                "../internals/shared": 334,
                "../internals/shared-key": 332,
                "../internals/symbol-constructor-detection": 336,
                "../internals/symbol-define-to-primitive": 337,
                "../internals/to-indexed-object": 341,
                "../internals/to-property-key": 346,
                "../internals/to-string": 348,
                "../internals/uid": 350,
                "../internals/well-known-symbol": 357,
                "../internals/well-known-symbol-define": 355,
                "../internals/well-known-symbol-wrapped": 356
            }
        ],
        380: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/get-built-in"), s = e("../internals/has-own-property"), o = e("../internals/to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("string-to-symbol-registry"), u = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    for: function(e) {
                        var t = o(e);
                        if (s(c, t)) return c[t];
                        var r = i("Symbol")(t);
                        return c[t] = r, u[r] = t, r;
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/get-built-in": 269,
                "../internals/has-own-property": 275,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/to-string": 348
            }
        ],
        381: [
            function(e, t, r) {
                "use strict";
                e("../modules/es.symbol.constructor"), e("../modules/es.symbol.for"), e("../modules/es.symbol.key-for"), e("../modules/es.json.stringify"), e("../modules/es.object.get-own-property-symbols");
            },
            {
                "../modules/es.json.stringify": 362,
                "../modules/es.object.get-own-property-symbols": 365,
                "../modules/es.symbol.constructor": 379,
                "../modules/es.symbol.for": 380,
                "../modules/es.symbol.key-for": 382
            }
        ],
        382: [
            function(e, t, r) {
                "use strict";
                var n = e("../internals/export"), i = e("../internals/has-own-property"), s = e("../internals/is-symbol"), o = e("../internals/try-to-string"), a = e("../internals/shared"), l = e("../internals/symbol-registry-detection"), c = a("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    keyFor: function(e) {
                        if (!s(e)) throw new TypeError(o(e) + " is not a symbol");
                        if (i(c, e)) return c[e];
                    }
                });
            },
            {
                "../internals/export": 259,
                "../internals/has-own-property": 275,
                "../internals/is-symbol": 292,
                "../internals/shared": 334,
                "../internals/symbol-registry-detection": 338,
                "../internals/try-to-string": 349
            }
        ],
        383: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return Object.prototype.toString.call(e);
                }
                r.isArray = function(e) {
                    return Array.isArray ? Array.isArray(e) : "[object Array]" === n(e);
                }, r.isBoolean = function(e) {
                    return "boolean" == typeof e;
                }, r.isNull = function(e) {
                    return null === e;
                }, r.isNullOrUndefined = function(e) {
                    return null == e;
                }, r.isNumber = function(e) {
                    return "number" == typeof e;
                }, r.isString = function(e) {
                    return "string" == typeof e;
                }, r.isSymbol = function(e) {
                    return "symbol" == typeof e;
                }, r.isUndefined = function(e) {
                    return void 0 === e;
                }, r.isRegExp = function(e) {
                    return "[object RegExp]" === n(e);
                }, r.isObject = function(e) {
                    return "object" == typeof e && null !== e;
                }, r.isDate = function(e) {
                    return "[object Date]" === n(e);
                }, r.isError = function(e) {
                    return "[object Error]" === n(e) || e instanceof Error;
                }, r.isFunction = function(e) {
                    return "function" == typeof e;
                }, r.isPrimitive = function(e) {
                    return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                }, r.isBuffer = e("buffer").Buffer.isBuffer;
            },
            {
                buffer: 220
            }
        ],
        384: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("elliptic"), i = e("bn.js");
                        t.exports = function(e) {
                            return new o(e);
                        };
                        var s = {
                            secp256k1: {
                                name: "secp256k1",
                                byteLength: 32
                            },
                            secp224r1: {
                                name: "p224",
                                byteLength: 28
                            },
                            prime256v1: {
                                name: "p256",
                                byteLength: 32
                            },
                            prime192v1: {
                                name: "p192",
                                byteLength: 24
                            },
                            ed25519: {
                                name: "ed25519",
                                byteLength: 32
                            },
                            secp384r1: {
                                name: "p384",
                                byteLength: 48
                            },
                            secp521r1: {
                                name: "p521",
                                byteLength: 66
                            }
                        };
                        function o(e) {
                            this.curveType = s[e], this.curveType || (this.curveType = {
                                name: e
                            }), this.curve = new n.ec(this.curveType.name), this.keys = void 0;
                        }
                        function a(e, t, n) {
                            Array.isArray(e) || (e = e.toArray());
                            var i = new r(e);
                            if (n && i.length < n) {
                                var s = new r(n - i.length);
                                s.fill(0), i = r.concat([
                                    s,
                                    i
                                ]);
                            }
                            return t ? i.toString(t) : i;
                        }
                        s.p224 = s.secp224r1, s.p256 = s.secp256r1 = s.prime256v1, s.p192 = s.secp192r1 = s.prime192v1, s.p384 = s.secp384r1, s.p521 = s.secp521r1, o.prototype.generateKeys = function(e, t) {
                            return this.keys = this.curve.genKeyPair(), this.getPublicKey(e, t);
                        }, o.prototype.computeSecret = function(e, t, n) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), a(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(), n, this.curveType.byteLength);
                        }, o.prototype.getPublicKey = function(e, t) {
                            var r = this.keys.getPublic("compressed" === t, !0);
                            return "hybrid" === t && (r[r.length - 1] % 2 ? r[0] = 7 : r[0] = 6), a(r, e);
                        }, o.prototype.getPrivateKey = function(e) {
                            return a(this.keys.getPrivate(), e);
                        }, o.prototype.setPublicKey = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.keys._importPublic(e), this;
                        }, o.prototype.setPrivateKey = function(e, t) {
                            t = t || "utf8", r.isBuffer(e) || (e = new r(e, t));
                            var n = new i(e);
                            return n = n.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(n), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "bn.js": 385,
                buffer: 220,
                elliptic: 405
            }
        ],
        385: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        386: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("md5.js"), s = e("ripemd160"), o = e("sha.js"), a = e("cipher-base");
                function l(e) {
                    a.call(this, "digest"), this._hash = e;
                }
                n(l, a), l.prototype._update = function(e) {
                    this._hash.update(e);
                }, l.prototype._final = function() {
                    return this._hash.digest();
                }, t.exports = function(e) {
                    return "md5" === (e = e.toLowerCase()) ? new i : "rmd160" === e || "ripemd160" === e ? new s : new l(o(e));
                };
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "md5.js": 450,
                ripemd160: 493,
                "sha.js": 498
            }
        ],
        387: [
            function(e, t, r) {
                "use strict";
                var n = e("md5.js");
                t.exports = function(e) {
                    return (new n).update(e).digest();
                };
            },
            {
                "md5.js": 450
            }
        ],
        388: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./legacy"), s = e("cipher-base"), o = e("safe-buffer").Buffer, a = e("create-hash/md5"), l = e("ripemd160"), c = e("sha.js"), u = o.alloc(128);
                function h(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = o.from(t));
                    var r = "sha512" === e || "sha384" === e ? 128 : 64;
                    (this._alg = e, this._key = t, t.length > r) ? t = ("rmd160" === e ? new l : c(e)).update(t).digest() : t.length < r && (t = o.concat([
                        t,
                        u
                    ], r));
                    for(var n = this._ipad = o.allocUnsafe(r), i = this._opad = o.allocUnsafe(r), a = 0; a < r; a++)n[a] = 54 ^ t[a], i[a] = 92 ^ t[a];
                    this._hash = "rmd160" === e ? new l : c(e), this._hash.update(n);
                }
                n(h, s), h.prototype._update = function(e) {
                    this._hash.update(e);
                }, h.prototype._final = function() {
                    var e = this._hash.digest();
                    return ("rmd160" === this._alg ? new l : c(this._alg)).update(this._opad).update(e).digest();
                }, t.exports = function(e, t) {
                    return "rmd160" === (e = e.toLowerCase()) || "ripemd160" === e ? new h("rmd160", t) : "md5" === e ? new i(a, t) : new h(e, t);
                };
            },
            {
                "./legacy": 389,
                "cipher-base": 221,
                "create-hash/md5": 387,
                inherits: 440,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        389: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("safe-buffer").Buffer, s = e("cipher-base"), o = i.alloc(128);
                function a(e, t) {
                    s.call(this, "digest"), "string" == typeof t && (t = i.from(t)), this._alg = e, this._key = t, t.length > 64 ? t = e(t) : t.length < 64 && (t = i.concat([
                        t,
                        o
                    ], 64));
                    for(var r = this._ipad = i.allocUnsafe(64), n = this._opad = i.allocUnsafe(64), a = 0; a < 64; a++)r[a] = 54 ^ t[a], n[a] = 92 ^ t[a];
                    this._hash = [
                        r
                    ];
                }
                n(a, s), a.prototype._update = function(e) {
                    this._hash.push(e);
                }, a.prototype._final = function() {
                    var e = this._alg(i.concat(this._hash));
                    return this._alg(i.concat([
                        this._opad,
                        e
                    ]));
                }, t.exports = a;
            },
            {
                "cipher-base": 221,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        390: [
            function(e, t, r) {
                "use strict";
                r.randomBytes = r.rng = r.pseudoRandomBytes = r.prng = e("randombytes"), r.createHash = r.Hash = e("create-hash"), r.createHmac = r.Hmac = e("create-hmac");
                var n = e("browserify-sign/algos"), i = Object.keys(n), s = [
                    "sha1",
                    "sha224",
                    "sha256",
                    "sha384",
                    "sha512",
                    "md5",
                    "rmd160"
                ].concat(i);
                r.getHashes = function() {
                    return s;
                };
                var o = e("pbkdf2");
                r.pbkdf2 = o.pbkdf2, r.pbkdf2Sync = o.pbkdf2Sync;
                var a = e("browserify-cipher");
                r.Cipher = a.Cipher, r.createCipher = a.createCipher, r.Cipheriv = a.Cipheriv, r.createCipheriv = a.createCipheriv, r.Decipher = a.Decipher, r.createDecipher = a.createDecipher, r.Decipheriv = a.Decipheriv, r.createDecipheriv = a.createDecipheriv, r.getCiphers = a.getCiphers, r.listCiphers = a.listCiphers;
                var l = e("diffie-hellman");
                r.DiffieHellmanGroup = l.DiffieHellmanGroup, r.createDiffieHellmanGroup = l.createDiffieHellmanGroup, r.getDiffieHellman = l.getDiffieHellman, r.createDiffieHellman = l.createDiffieHellman, r.DiffieHellman = l.DiffieHellman;
                var c = e("browserify-sign");
                r.createSign = c.createSign, r.Sign = c.Sign, r.createVerify = c.createVerify, r.Verify = c.Verify, r.createECDH = e("create-ecdh");
                var u = e("public-encrypt");
                r.publicEncrypt = u.publicEncrypt, r.privateEncrypt = u.privateEncrypt, r.publicDecrypt = u.publicDecrypt, r.privateDecrypt = u.privateDecrypt;
                var h = e("randomfill");
                r.randomFill = h.randomFill, r.randomFillSync = h.randomFillSync, r.createCredentials = function() {
                    throw new Error([
                        "sorry, createCredentials is not implemented yet",
                        "we accept pull requests",
                        "https://github.com/crypto-browserify/crypto-browserify"
                    ].join("\n"));
                }, r.constants = {
                    DH_CHECK_P_NOT_SAFE_PRIME: 2,
                    DH_CHECK_P_NOT_PRIME: 1,
                    DH_UNABLE_TO_CHECK_GENERATOR: 4,
                    DH_NOT_SUITABLE_GENERATOR: 8,
                    NPN_ENABLED: 1,
                    ALPN_ENABLED: 1,
                    RSA_PKCS1_PADDING: 1,
                    RSA_SSLV23_PADDING: 2,
                    RSA_NO_PADDING: 3,
                    RSA_PKCS1_OAEP_PADDING: 4,
                    RSA_X931_PADDING: 5,
                    RSA_PKCS1_PSS_PADDING: 6,
                    POINT_CONVERSION_COMPRESSED: 2,
                    POINT_CONVERSION_UNCOMPRESSED: 4,
                    POINT_CONVERSION_HYBRID: 6
                };
            },
            {
                "browserify-cipher": 206,
                "browserify-sign": 213,
                "browserify-sign/algos": 210,
                "create-ecdh": 384,
                "create-hash": 386,
                "create-hmac": 388,
                "diffie-hellman": 400,
                pbkdf2: 460,
                "public-encrypt": 468,
                randombytes: 475,
                randomfill: 476
            }
        ],
        391: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs = n();
                }(void 0, function() {
                    var e = 6e4, t = 36e5, r = "millisecond", n = "second", i = "minute", s = "hour", o = "day", a = "week", l = "month", c = "quarter", u = "year", h = "date", f = "Invalid Date", d = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, m = {
                        name: "en",
                        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
                        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
                        ordinal: function(e) {
                            var t = [
                                "th",
                                "st",
                                "nd",
                                "rd"
                            ], r = e % 100;
                            return "[" + e + (t[(r - 20) % 10] || t[r] || t[0]) + "]";
                        }
                    }, b = function(e, t, r) {
                        var n = String(e);
                        return !n || n.length >= t ? e : "" + Array(t + 1 - n.length).join(r) + e;
                    }, g = {
                        s: b,
                        z: function(e) {
                            var t = -e.utcOffset(), r = Math.abs(t), n = Math.floor(r / 60), i = r % 60;
                            return (t <= 0 ? "+" : "-") + b(n, 2, "0") + ":" + b(i, 2, "0");
                        },
                        m: function e(t, r) {
                            if (t.date() < r.date()) return -e(r, t);
                            var n = 12 * (r.year() - t.year()) + (r.month() - t.month()), i = t.clone().add(n, l), s = r - i < 0, o = t.clone().add(n + (s ? -1 : 1), l);
                            return +(-(n + (r - i) / (s ? i - o : o - i)) || 0);
                        },
                        a: function(e) {
                            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
                        },
                        p: function(e) {
                            return ({
                                M: l,
                                y: u,
                                w: a,
                                d: o,
                                D: h,
                                h: s,
                                m: i,
                                s: n,
                                ms: r,
                                Q: c
                            })[e] || String(e || "").toLowerCase().replace(/s$/, "");
                        },
                        u: function(e) {
                            return void 0 === e;
                        }
                    }, y = "en", v = {};
                    v[y] = m;
                    var w = "$isDayjsObject", _ = function(e) {
                        return e instanceof M || !(!e || !e[w]);
                    }, x = function e(t, r, n) {
                        var i;
                        if (!t) return y;
                        if ("string" == typeof t) {
                            var s = t.toLowerCase();
                            v[s] && (i = s), r && (v[s] = r, i = s);
                            var o = t.split("-");
                            if (!i && o.length > 1) return e(o[0]);
                        } else {
                            var a = t.name;
                            v[a] = t, i = a;
                        }
                        return !n && i && (y = i), i || !n && y;
                    }, k = function(e, t) {
                        if (_(e)) return e.clone();
                        var r = "object" == typeof t ? t : {};
                        return r.date = e, r.args = arguments, new M(r);
                    }, S = g;
                    S.l = x, S.i = _, S.w = function(e, t) {
                        return k(e, {
                            locale: t.$L,
                            utc: t.$u,
                            x: t.$x,
                            $offset: t.$offset
                        });
                    };
                    var M = function() {
                        function m(e) {
                            this.$L = x(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[w] = !0;
                        }
                        var b = m.prototype;
                        return b.parse = function(e) {
                            this.$d = function(e) {
                                var t = e.date, r = e.utc;
                                if (null === t) return new Date(NaN);
                                if (S.u(t)) return new Date;
                                if (t instanceof Date) return new Date(t);
                                if ("string" == typeof t && !/Z$/i.test(t)) {
                                    var n = t.match(d);
                                    if (n) {
                                        var i = n[2] - 1 || 0, s = (n[7] || "0").substring(0, 3);
                                        return r ? new Date(Date.UTC(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s)) : new Date(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, s);
                                    }
                                }
                                return new Date(t);
                            }(e), this.init();
                        }, b.init = function() {
                            var e = this.$d;
                            this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
                        }, b.$utils = function() {
                            return S;
                        }, b.isValid = function() {
                            return !(this.$d.toString() === f);
                        }, b.isSame = function(e, t) {
                            var r = k(e);
                            return this.startOf(t) <= r && r <= this.endOf(t);
                        }, b.isAfter = function(e, t) {
                            return k(e) < this.startOf(t);
                        }, b.isBefore = function(e, t) {
                            return this.endOf(t) < k(e);
                        }, b.$g = function(e, t, r) {
                            return S.u(e) ? this[t] : this.set(r, e);
                        }, b.unix = function() {
                            return Math.floor(this.valueOf() / 1e3);
                        }, b.valueOf = function() {
                            return this.$d.getTime();
                        }, b.startOf = function(e, t) {
                            var r = this, c = !!S.u(t) || t, f = S.p(e), d = function(e, t) {
                                var n = S.w(r.$u ? Date.UTC(r.$y, t, e) : new Date(r.$y, t, e), r);
                                return c ? n : n.endOf(o);
                            }, p = function(e, t) {
                                return S.w(r.toDate()[e].apply(r.toDate("s"), (c ? [
                                    0,
                                    0,
                                    0,
                                    0
                                ] : [
                                    23,
                                    59,
                                    59,
                                    999
                                ]).slice(t)), r);
                            }, m = this.$W, b = this.$M, g = this.$D, y = "set" + (this.$u ? "UTC" : "");
                            switch(f){
                                case u:
                                    return c ? d(1, 0) : d(31, 11);
                                case l:
                                    return c ? d(1, b) : d(0, b + 1);
                                case a:
                                    var v = this.$locale().weekStart || 0, w = (m < v ? m + 7 : m) - v;
                                    return d(c ? g - w : g + (6 - w), b);
                                case o:
                                case h:
                                    return p(y + "Hours", 0);
                                case s:
                                    return p(y + "Minutes", 1);
                                case i:
                                    return p(y + "Seconds", 2);
                                case n:
                                    return p(y + "Milliseconds", 3);
                                default:
                                    return this.clone();
                            }
                        }, b.endOf = function(e) {
                            return this.startOf(e, !1);
                        }, b.$set = function(e, t) {
                            var a, c = S.p(e), f = "set" + (this.$u ? "UTC" : ""), d = (a = {}, a[o] = f + "Date", a[h] = f + "Date", a[l] = f + "Month", a[u] = f + "FullYear", a[s] = f + "Hours", a[i] = f + "Minutes", a[n] = f + "Seconds", a[r] = f + "Milliseconds", a)[c], p = c === o ? this.$D + (t - this.$W) : t;
                            if (c === l || c === u) {
                                var m = this.clone().set(h, 1);
                                m.$d[d](p), m.init(), this.$d = m.set(h, Math.min(this.$D, m.daysInMonth())).$d;
                            } else d && this.$d[d](p);
                            return this.init(), this;
                        }, b.set = function(e, t) {
                            return this.clone().$set(e, t);
                        }, b.get = function(e) {
                            return this[S.p(e)]();
                        }, b.add = function(r, c) {
                            var h, f = this;
                            r = Number(r);
                            var d = S.p(c), p = function(e) {
                                var t = k(f);
                                return S.w(t.date(t.date() + Math.round(e * r)), f);
                            };
                            if (d === l) return this.set(l, this.$M + r);
                            if (d === u) return this.set(u, this.$y + r);
                            if (d === o) return p(1);
                            if (d === a) return p(7);
                            var m = (h = {}, h[i] = e, h[s] = t, h[n] = 1e3, h)[d] || 1, b = this.$d.getTime() + r * m;
                            return S.w(b, this);
                        }, b.subtract = function(e, t) {
                            return this.add(-1 * e, t);
                        }, b.format = function(e) {
                            var t = this, r = this.$locale();
                            if (!this.isValid()) return r.invalidDate || f;
                            var n = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), s = this.$H, o = this.$m, a = this.$M, l = r.weekdays, c = r.months, u = r.meridiem, h = function(e, r, i, s) {
                                return e && (e[r] || e(t, n)) || i[r].slice(0, s);
                            }, d = function(e) {
                                return S.s(s % 12 || 12, e, "0");
                            }, m = u || function(e, t, r) {
                                var n = e < 12 ? "AM" : "PM";
                                return r ? n.toLowerCase() : n;
                            };
                            return n.replace(p, function(e, n) {
                                return n || function(e) {
                                    switch(e){
                                        case "YY":
                                            return String(t.$y).slice(-2);
                                        case "YYYY":
                                            return S.s(t.$y, 4, "0");
                                        case "M":
                                            return a + 1;
                                        case "MM":
                                            return S.s(a + 1, 2, "0");
                                        case "MMM":
                                            return h(r.monthsShort, a, c, 3);
                                        case "MMMM":
                                            return h(c, a);
                                        case "D":
                                            return t.$D;
                                        case "DD":
                                            return S.s(t.$D, 2, "0");
                                        case "d":
                                            return String(t.$W);
                                        case "dd":
                                            return h(r.weekdaysMin, t.$W, l, 2);
                                        case "ddd":
                                            return h(r.weekdaysShort, t.$W, l, 3);
                                        case "dddd":
                                            return l[t.$W];
                                        case "H":
                                            return String(s);
                                        case "HH":
                                            return S.s(s, 2, "0");
                                        case "h":
                                            return d(1);
                                        case "hh":
                                            return d(2);
                                        case "a":
                                            return m(s, o, !0);
                                        case "A":
                                            return m(s, o, !1);
                                        case "m":
                                            return String(o);
                                        case "mm":
                                            return S.s(o, 2, "0");
                                        case "s":
                                            return String(t.$s);
                                        case "ss":
                                            return S.s(t.$s, 2, "0");
                                        case "SSS":
                                            return S.s(t.$ms, 3, "0");
                                        case "Z":
                                            return i;
                                    }
                                    return null;
                                }(e) || i.replace(":", "");
                            });
                        }, b.utcOffset = function() {
                            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
                        }, b.diff = function(r, h, f) {
                            var d, p = this, m = S.p(h), b = k(r), g = (b.utcOffset() - this.utcOffset()) * e, y = this - b, v = function() {
                                return S.m(p, b);
                            };
                            switch(m){
                                case u:
                                    d = v() / 12;
                                    break;
                                case l:
                                    d = v();
                                    break;
                                case c:
                                    d = v() / 3;
                                    break;
                                case a:
                                    d = (y - g) / 6048e5;
                                    break;
                                case o:
                                    d = (y - g) / 864e5;
                                    break;
                                case s:
                                    d = y / t;
                                    break;
                                case i:
                                    d = y / e;
                                    break;
                                case n:
                                    d = y / 1e3;
                                    break;
                                default:
                                    d = y;
                            }
                            return f ? d : S.a(d);
                        }, b.daysInMonth = function() {
                            return this.endOf(l).$D;
                        }, b.$locale = function() {
                            return v[this.$L];
                        }, b.locale = function(e, t) {
                            if (!e) return this.$L;
                            var r = this.clone(), n = x(e, t, !0);
                            return n && (r.$L = n), r;
                        }, b.clone = function() {
                            return S.w(this.$d, this);
                        }, b.toDate = function() {
                            return new Date(this.valueOf());
                        }, b.toJSON = function() {
                            return this.isValid() ? this.toISOString() : null;
                        }, b.toISOString = function() {
                            return this.$d.toISOString();
                        }, b.toString = function() {
                            return this.$d.toUTCString();
                        }, m;
                    }(), C = M.prototype;
                    return k.prototype = C, [
                        [
                            "$ms",
                            r
                        ],
                        [
                            "$s",
                            n
                        ],
                        [
                            "$m",
                            i
                        ],
                        [
                            "$H",
                            s
                        ],
                        [
                            "$W",
                            o
                        ],
                        [
                            "$M",
                            l
                        ],
                        [
                            "$y",
                            u
                        ],
                        [
                            "$D",
                            h
                        ]
                    ].forEach(function(e) {
                        C[e[1]] = function(t) {
                            return this.$g(t, e[0], e[1]);
                        };
                    }), k.extend = function(e, t) {
                        return e.$i || (e(t, M, k), e.$i = !0), k;
                    }, k.locale = x, k.isDayjs = _, k.unix = function(e) {
                        return k(1e3 * e);
                    }, k.en = v[y], k.Ls = v, k.p = {}, k;
                });
            },
            {}
        ],
        392: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_customParseFormat = n();
                }(void 0, function() {
                    var e = {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, r = /\d\d/, n = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, s = {}, o = function(e) {
                        return (e = +e) + (e > 68 ? 1900 : 2e3);
                    }, a = function(e) {
                        return function(t) {
                            this[e] = +t;
                        };
                    }, l = [
                        /[+-]\d\d:?(\d\d)?|Z/,
                        function(e) {
                            (this.zone || (this.zone = {})).offset = function(e) {
                                if (!e) return 0;
                                if ("Z" === e) return 0;
                                var t = e.match(/([+-]|\d\d)/g), r = 60 * t[1] + (+t[2] || 0);
                                return 0 === r ? 0 : "+" === t[0] ? -r : r;
                            }(e);
                        }
                    ], c = function(e) {
                        var t = s[e];
                        return t && (t.indexOf ? t : t.s.concat(t.f));
                    }, u = function(e, t) {
                        var r, n = s.meridiem;
                        if (n) {
                            for(var i = 1; i <= 24; i += 1)if (e.indexOf(n(i, 0, t)) > -1) {
                                r = i > 12;
                                break;
                            }
                        } else r = e === (t ? "pm" : "PM");
                        return r;
                    }, h = {
                        A: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !1);
                            }
                        ],
                        a: [
                            i,
                            function(e) {
                                this.afternoon = u(e, !0);
                            }
                        ],
                        S: [
                            /\d/,
                            function(e) {
                                this.milliseconds = 100 * +e;
                            }
                        ],
                        SS: [
                            r,
                            function(e) {
                                this.milliseconds = 10 * +e;
                            }
                        ],
                        SSS: [
                            /\d{3}/,
                            function(e) {
                                this.milliseconds = +e;
                            }
                        ],
                        s: [
                            n,
                            a("seconds")
                        ],
                        ss: [
                            n,
                            a("seconds")
                        ],
                        m: [
                            n,
                            a("minutes")
                        ],
                        mm: [
                            n,
                            a("minutes")
                        ],
                        H: [
                            n,
                            a("hours")
                        ],
                        h: [
                            n,
                            a("hours")
                        ],
                        HH: [
                            n,
                            a("hours")
                        ],
                        hh: [
                            n,
                            a("hours")
                        ],
                        D: [
                            n,
                            a("day")
                        ],
                        DD: [
                            r,
                            a("day")
                        ],
                        Do: [
                            i,
                            function(e) {
                                var t = s.ordinal, r = e.match(/\d+/);
                                if (this.day = r[0], t) for(var n = 1; n <= 31; n += 1)t(n).replace(/\[|\]/g, "") === e && (this.day = n);
                            }
                        ],
                        M: [
                            n,
                            a("month")
                        ],
                        MM: [
                            r,
                            a("month")
                        ],
                        MMM: [
                            i,
                            function(e) {
                                var t = c("months"), r = (c("monthsShort") || t.map(function(e) {
                                    return e.slice(0, 3);
                                })).indexOf(e) + 1;
                                if (r < 1) throw new Error;
                                this.month = r % 12 || r;
                            }
                        ],
                        MMMM: [
                            i,
                            function(e) {
                                var t = c("months").indexOf(e) + 1;
                                if (t < 1) throw new Error;
                                this.month = t % 12 || t;
                            }
                        ],
                        Y: [
                            /[+-]?\d+/,
                            a("year")
                        ],
                        YY: [
                            r,
                            function(e) {
                                this.year = o(e);
                            }
                        ],
                        YYYY: [
                            /\d{4}/,
                            a("year")
                        ],
                        Z: l,
                        ZZ: l
                    };
                    function f(r) {
                        var n, i;
                        n = r, i = s && s.formats;
                        for(var o = (r = n.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, r, n) {
                            var s = n && n.toUpperCase();
                            return r || i[n] || e[n] || i[s].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, r) {
                                return t || r.slice(1);
                            });
                        })).match(t), a = o.length, l = 0; l < a; l += 1){
                            var c = o[l], u = h[c], f = u && u[0], d = u && u[1];
                            o[l] = d ? {
                                regex: f,
                                parser: d
                            } : c.replace(/^\[|\]$/g, "");
                        }
                        return function(e) {
                            for(var t = {}, r = 0, n = 0; r < a; r += 1){
                                var i = o[r];
                                if ("string" == typeof i) n += i.length;
                                else {
                                    var s = i.regex, l = i.parser, c = e.slice(n), u = s.exec(c)[0];
                                    l.call(t, u), e = e.replace(u, "");
                                }
                            }
                            return function(e) {
                                var t = e.afternoon;
                                if (void 0 !== t) {
                                    var r = e.hours;
                                    t ? r < 12 && (e.hours += 12) : 12 === r && (e.hours = 0), delete e.afternoon;
                                }
                            }(t), t;
                        };
                    }
                    return function(e, t, r) {
                        r.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
                        var n = t.prototype, i = n.parse;
                        n.parse = function(e) {
                            var t = e.date, n = e.utc, o = e.args;
                            this.$u = n;
                            var a = o[1];
                            if ("string" == typeof a) {
                                var l = !0 === o[2], c = !0 === o[3], u = l || c, h = o[2];
                                c && (h = o[2]), s = this.$locale(), !l && h && (s = r.Ls[h]), this.$d = function(e, t, r) {
                                    try {
                                        if ([
                                            "x",
                                            "X"
                                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                                        var n = f(t)(e), i = n.year, s = n.month, o = n.day, a = n.hours, l = n.minutes, c = n.seconds, u = n.milliseconds, h = n.zone, d = new Date, p = o || (i || s ? 1 : d.getDate()), m = i || d.getFullYear(), b = 0;
                                        i && !s || (b = s > 0 ? s - 1 : d.getMonth());
                                        var g = a || 0, y = l || 0, v = c || 0, w = u || 0;
                                        return h ? new Date(Date.UTC(m, b, p, g, y, v, w + 60 * h.offset * 1e3)) : r ? new Date(Date.UTC(m, b, p, g, y, v, w)) : new Date(m, b, p, g, y, v, w);
                                    } catch (e) {
                                        return new Date("");
                                    }
                                }(t, a, n), this.init(), h && !0 !== h && (this.$L = this.locale(h).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
                            } else if (a instanceof Array) for(var d = a.length, p = 1; p <= d; p += 1){
                                o[1] = a[p - 1];
                                var m = r.apply(this, o);
                                if (m.isValid()) {
                                    this.$d = m.$d, this.$L = m.$L, this.init();
                                    break;
                                }
                                p === d && (this.$d = new Date(""));
                            }
                            else i.call(this, e);
                        };
                    };
                });
            },
            {}
        ],
        393: [
            function(e, t, r) {
                "use strict";
                !function(e, n) {
                    "object" == typeof r && void 0 !== t ? t.exports = n() : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_plugin_utc = n();
                }(void 0, function() {
                    var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
                    return function(n, i, s) {
                        var o = i.prototype;
                        s.utc = function(e) {
                            var t = {
                                date: e,
                                utc: !0,
                                args: arguments
                            };
                            return new i(t);
                        }, o.utc = function(t) {
                            var r = s(this.toDate(), {
                                locale: this.$L,
                                utc: !0
                            });
                            return t ? r.add(this.utcOffset(), e) : r;
                        }, o.local = function() {
                            return s(this.toDate(), {
                                locale: this.$L,
                                utc: !1
                            });
                        };
                        var a = o.parse;
                        o.parse = function(e) {
                            e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), a.call(this, e);
                        };
                        var l = o.init;
                        o.init = function() {
                            if (this.$u) {
                                var e = this.$d;
                                this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
                            } else l.call(this);
                        };
                        var c = o.utcOffset;
                        o.utcOffset = function(n, i) {
                            var s = this.$utils().u;
                            if (s(n)) return this.$u ? 0 : s(this.$offset) ? c.call(this) : this.$offset;
                            if ("string" == typeof n && null === (n = function(e) {
                                void 0 === e && (e = "");
                                var n = e.match(t);
                                if (!n) return null;
                                var i = ("" + n[0]).match(r) || [
                                    "-",
                                    0,
                                    0
                                ], s = i[0], o = 60 * +i[1] + +i[2];
                                return 0 === o ? 0 : "+" === s ? o : -o;
                            }(n))) return this;
                            var o = Math.abs(n) <= 16 ? 60 * n : n, a = this;
                            if (i) return a.$offset = o, a.$u = 0 === n, a;
                            if (0 !== n) {
                                var l = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                                (a = this.local().add(o + l, e)).$offset = o, a.$x.$localOffset = l;
                            } else a = this.utc();
                            return a;
                        };
                        var u = o.format;
                        o.format = function(e) {
                            var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
                            return u.call(this, t);
                        }, o.valueOf = function() {
                            var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
                            return this.$d.valueOf() - 6e4 * e;
                        }, o.isUTC = function() {
                            return !!this.$u;
                        }, o.toISOString = function() {
                            return this.toDate().toISOString();
                        }, o.toString = function() {
                            return this.toDate().toUTCString();
                        };
                        var h = o.toDate;
                        o.toDate = function(e) {
                            return "s" === e && this.$offset ? s(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
                        };
                        var f = o.diff;
                        o.diff = function(e, t, r) {
                            if (e && this.$u === e.$u) return f.call(this, e, t, r);
                            var n = this.local(), i = s(e).local();
                            return f.call(n, i, t, r);
                        };
                    };
                });
            },
            {}
        ],
        394: [
            function(e, t, r) {
                "use strict";
                r.utils = e("./des/utils"), r.Cipher = e("./des/cipher"), r.DES = e("./des/des"), r.CBC = e("./des/cbc"), r.EDE = e("./des/ede");
            },
            {
                "./des/cbc": 395,
                "./des/cipher": 396,
                "./des/des": 397,
                "./des/ede": 398,
                "./des/utils": 399
            }
        ],
        395: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = {};
                function o(e) {
                    n.equal(e.length, 8, "Invalid IV length"), this.iv = new Array(8);
                    for(var t = 0; t < this.iv.length; t++)this.iv[t] = e[t];
                }
                r.instantiate = function(e) {
                    function t(t) {
                        e.call(this, t), this._cbcInit();
                    }
                    i(t, e);
                    for(var r = Object.keys(s), n = 0; n < r.length; n++){
                        var o = r[n];
                        t.prototype[o] = s[o];
                    }
                    return t.create = function(e) {
                        return new t(e);
                    }, t;
                }, s._cbcInit = function() {
                    var e = new o(this.options.iv);
                    this._cbcState = e;
                }, s._update = function(e, t, r, n) {
                    var i = this._cbcState, s = this.constructor.super_.prototype, o = i.iv;
                    if ("encrypt" === this.type) {
                        for(var a = 0; a < this.blockSize; a++)o[a] ^= e[t + a];
                        s._update.call(this, o, 0, r, n);
                        for(a = 0; a < this.blockSize; a++)o[a] = r[n + a];
                    } else {
                        s._update.call(this, e, t, r, n);
                        for(a = 0; a < this.blockSize; a++)r[n + a] ^= o[a];
                        for(a = 0; a < this.blockSize; a++)o[a] = e[t + a];
                    }
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        396: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert");
                function i(e) {
                    this.options = e, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = !1 !== e.padding;
                }
                t.exports = i, i.prototype._init = function() {}, i.prototype.update = function(e) {
                    return 0 === e.length ? [] : "decrypt" === this.type ? this._updateDecrypt(e) : this._updateEncrypt(e);
                }, i.prototype._buffer = function(e, t) {
                    for(var r = Math.min(this.buffer.length - this.bufferOff, e.length - t), n = 0; n < r; n++)this.buffer[this.bufferOff + n] = e[t + n];
                    return this.bufferOff += r, r;
                }, i.prototype._flushBuffer = function(e, t) {
                    return this._update(this.buffer, 0, e, t), this.bufferOff = 0, this.blockSize;
                }, i.prototype._updateEncrypt = function(e) {
                    var t = 0, r = 0, n = (this.bufferOff + e.length) / this.blockSize | 0, i = new Array(n * this.blockSize);
                    0 !== this.bufferOff && (t += this._buffer(e, t), this.bufferOff === this.buffer.length && (r += this._flushBuffer(i, r)));
                    for(var s = e.length - (e.length - t) % this.blockSize; t < s; t += this.blockSize)this._update(e, t, i, r), r += this.blockSize;
                    for(; t < e.length; t++, this.bufferOff++)this.buffer[this.bufferOff] = e[t];
                    return i;
                }, i.prototype._updateDecrypt = function(e) {
                    for(var t = 0, r = 0, n = Math.ceil((this.bufferOff + e.length) / this.blockSize) - 1, i = new Array(n * this.blockSize); n > 0; n--)t += this._buffer(e, t), r += this._flushBuffer(i, r);
                    return t += this._buffer(e, t), i;
                }, i.prototype.final = function(e) {
                    var t, r;
                    return e && (t = this.update(e)), r = "encrypt" === this.type ? this._finalEncrypt() : this._finalDecrypt(), t ? t.concat(r) : r;
                }, i.prototype._pad = function(e, t) {
                    if (0 === t) return !1;
                    for(; t < e.length;)e[t++] = 0;
                    return !0;
                }, i.prototype._finalEncrypt = function() {
                    if (!this._pad(this.buffer, this.bufferOff)) return [];
                    var e = new Array(this.blockSize);
                    return this._update(this.buffer, 0, e, 0), e;
                }, i.prototype._unpad = function(e) {
                    return e;
                }, i.prototype._finalDecrypt = function() {
                    n.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
                    var e = new Array(this.blockSize);
                    return this._flushBuffer(e, 0), this._unpad(e);
                };
            },
            {
                "minimalistic-assert": 453
            }
        ],
        397: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./utils"), o = e("./cipher");
                function a() {
                    this.tmp = new Array(2), this.keys = null;
                }
                function l(e) {
                    o.call(this, e);
                    var t = new a;
                    this._desState = t, this.deriveKeys(t, e.key);
                }
                i(l, o), t.exports = l, l.create = function(e) {
                    return new l(e);
                };
                var c = [
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2,
                    1
                ];
                l.prototype.deriveKeys = function(e, t) {
                    e.keys = new Array(32), n.equal(t.length, this.blockSize, "Invalid key length");
                    var r = s.readUInt32BE(t, 0), i = s.readUInt32BE(t, 4);
                    s.pc1(r, i, e.tmp, 0), r = e.tmp[0], i = e.tmp[1];
                    for(var o = 0; o < e.keys.length; o += 2){
                        var a = c[o >>> 1];
                        r = s.r28shl(r, a), i = s.r28shl(i, a), s.pc2(r, i, e.keys, o);
                    }
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._desState, o = s.readUInt32BE(e, t), a = s.readUInt32BE(e, t + 4);
                    s.ip(o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], "encrypt" === this.type ? this._encrypt(i, o, a, i.tmp, 0) : this._decrypt(i, o, a, i.tmp, 0), o = i.tmp[0], a = i.tmp[1], s.writeUInt32BE(r, o, n), s.writeUInt32BE(r, a, n + 4);
                }, l.prototype._pad = function(e, t) {
                    if (!1 === this.padding) return !1;
                    for(var r = e.length - t, n = t; n < e.length; n++)e[n] = r;
                    return !0;
                }, l.prototype._unpad = function(e) {
                    if (!1 === this.padding) return e;
                    for(var t = e[e.length - 1], r = e.length - t; r < e.length; r++)n.equal(e[r], t);
                    return e.slice(0, e.length - t);
                }, l.prototype._encrypt = function(e, t, r, n, i) {
                    for(var o = t, a = r, l = 0; l < e.keys.length; l += 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(a, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = a;
                        a = (o ^ s.permute(h)) >>> 0, o = f;
                    }
                    s.rip(a, o, n, i);
                }, l.prototype._decrypt = function(e, t, r, n, i) {
                    for(var o = r, a = t, l = e.keys.length - 2; l >= 0; l -= 2){
                        var c = e.keys[l], u = e.keys[l + 1];
                        s.expand(o, e.tmp, 0), c ^= e.tmp[0], u ^= e.tmp[1];
                        var h = s.substitute(c, u), f = o;
                        o = (a ^ s.permute(h)) >>> 0, a = f;
                    }
                    s.rip(o, a, n, i);
                };
            },
            {
                "./cipher": 396,
                "./utils": 399,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        398: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits"), s = e("./cipher"), o = e("./des");
                function a(e, t) {
                    n.equal(t.length, 24, "Invalid key length");
                    var r = t.slice(0, 8), i = t.slice(8, 16), s = t.slice(16, 24);
                    this.ciphers = "encrypt" === e ? [
                        o.create({
                            type: "encrypt",
                            key: r
                        }),
                        o.create({
                            type: "decrypt",
                            key: i
                        }),
                        o.create({
                            type: "encrypt",
                            key: s
                        })
                    ] : [
                        o.create({
                            type: "decrypt",
                            key: s
                        }),
                        o.create({
                            type: "encrypt",
                            key: i
                        }),
                        o.create({
                            type: "decrypt",
                            key: r
                        })
                    ];
                }
                function l(e) {
                    s.call(this, e);
                    var t = new a(this.type, this.options.key);
                    this._edeState = t;
                }
                i(l, s), t.exports = l, l.create = function(e) {
                    return new l(e);
                }, l.prototype._update = function(e, t, r, n) {
                    var i = this._edeState;
                    i.ciphers[0]._update(e, t, r, n), i.ciphers[1]._update(r, n, r, n), i.ciphers[2]._update(r, n, r, n);
                }, l.prototype._pad = o.prototype._pad, l.prototype._unpad = o.prototype._unpad;
            },
            {
                "./cipher": 396,
                "./des": 397,
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        399: [
            function(e, t, r) {
                "use strict";
                r.readUInt32BE = function(e, t) {
                    return (e[0 + t] << 24 | e[1 + t] << 16 | e[2 + t] << 8 | e[3 + t]) >>> 0;
                }, r.writeUInt32BE = function(e, t, r) {
                    e[0 + r] = t >>> 24, e[1 + r] = t >>> 16 & 255, e[2 + r] = t >>> 8 & 255, e[3 + r] = 255 & t;
                }, r.ip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 6; o >= 0; o -= 2){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >>> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >>> a + o & 1;
                    }
                    for(o = 6; o >= 0; o -= 2){
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= t >>> a + o & 1;
                        for(a = 1; a <= 25; a += 8)s <<= 1, s |= e >>> a + o & 1;
                    }
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.rip = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 0; o < 4; o++)for(var a = 24; a >= 0; a -= 8)i <<= 1, i |= t >>> a + o & 1, i <<= 1, i |= e >>> a + o & 1;
                    for(o = 4; o < 8; o++)for(a = 24; a >= 0; a -= 8)s <<= 1, s |= t >>> a + o & 1, s <<= 1, s |= e >>> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.pc1 = function(e, t, r, n) {
                    for(var i = 0, s = 0, o = 7; o >= 5; o--){
                        for(var a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)i <<= 1, i |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)i <<= 1, i |= t >> a + o & 1;
                    for(o = 1; o <= 3; o++){
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= t >> a + o & 1;
                        for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    }
                    for(a = 0; a <= 24; a += 8)s <<= 1, s |= e >> a + o & 1;
                    r[n + 0] = i >>> 0, r[n + 1] = s >>> 0;
                }, r.r28shl = function(e, t) {
                    return e << t & 268435455 | e >>> 28 - t;
                };
                var n = [
                    14,
                    11,
                    17,
                    4,
                    27,
                    23,
                    25,
                    0,
                    13,
                    22,
                    7,
                    18,
                    5,
                    9,
                    16,
                    24,
                    2,
                    20,
                    12,
                    21,
                    1,
                    8,
                    15,
                    26,
                    15,
                    4,
                    25,
                    19,
                    9,
                    1,
                    26,
                    16,
                    5,
                    11,
                    23,
                    8,
                    12,
                    7,
                    17,
                    0,
                    22,
                    3,
                    10,
                    14,
                    6,
                    20,
                    27,
                    24
                ];
                r.pc2 = function(e, t, r, i) {
                    for(var s = 0, o = 0, a = n.length >>> 1, l = 0; l < a; l++)s <<= 1, s |= e >>> n[l] & 1;
                    for(l = a; l < n.length; l++)o <<= 1, o |= t >>> n[l] & 1;
                    r[i + 0] = s >>> 0, r[i + 1] = o >>> 0;
                }, r.expand = function(e, t, r) {
                    var n = 0, i = 0;
                    n = (1 & e) << 5 | e >>> 27;
                    for(var s = 23; s >= 15; s -= 4)n <<= 6, n |= e >>> s & 63;
                    for(s = 11; s >= 3; s -= 4)i |= e >>> s & 63, i <<= 6;
                    i |= (31 & e) << 1 | e >>> 31, t[r + 0] = n >>> 0, t[r + 1] = i >>> 0;
                };
                var i = [
                    14,
                    0,
                    4,
                    15,
                    13,
                    7,
                    1,
                    4,
                    2,
                    14,
                    15,
                    2,
                    11,
                    13,
                    8,
                    1,
                    3,
                    10,
                    10,
                    6,
                    6,
                    12,
                    12,
                    11,
                    5,
                    9,
                    9,
                    5,
                    0,
                    3,
                    7,
                    8,
                    4,
                    15,
                    1,
                    12,
                    14,
                    8,
                    8,
                    2,
                    13,
                    4,
                    6,
                    9,
                    2,
                    1,
                    11,
                    7,
                    15,
                    5,
                    12,
                    11,
                    9,
                    3,
                    7,
                    14,
                    3,
                    10,
                    10,
                    0,
                    5,
                    6,
                    0,
                    13,
                    15,
                    3,
                    1,
                    13,
                    8,
                    4,
                    14,
                    7,
                    6,
                    15,
                    11,
                    2,
                    3,
                    8,
                    4,
                    14,
                    9,
                    12,
                    7,
                    0,
                    2,
                    1,
                    13,
                    10,
                    12,
                    6,
                    0,
                    9,
                    5,
                    11,
                    10,
                    5,
                    0,
                    13,
                    14,
                    8,
                    7,
                    10,
                    11,
                    1,
                    10,
                    3,
                    4,
                    15,
                    13,
                    4,
                    1,
                    2,
                    5,
                    11,
                    8,
                    6,
                    12,
                    7,
                    6,
                    12,
                    9,
                    0,
                    3,
                    5,
                    2,
                    14,
                    15,
                    9,
                    10,
                    13,
                    0,
                    7,
                    9,
                    0,
                    14,
                    9,
                    6,
                    3,
                    3,
                    4,
                    15,
                    6,
                    5,
                    10,
                    1,
                    2,
                    13,
                    8,
                    12,
                    5,
                    7,
                    14,
                    11,
                    12,
                    4,
                    11,
                    2,
                    15,
                    8,
                    1,
                    13,
                    1,
                    6,
                    10,
                    4,
                    13,
                    9,
                    0,
                    8,
                    6,
                    15,
                    9,
                    3,
                    8,
                    0,
                    7,
                    11,
                    4,
                    1,
                    15,
                    2,
                    14,
                    12,
                    3,
                    5,
                    11,
                    10,
                    5,
                    14,
                    2,
                    7,
                    12,
                    7,
                    13,
                    13,
                    8,
                    14,
                    11,
                    3,
                    5,
                    0,
                    6,
                    6,
                    15,
                    9,
                    0,
                    10,
                    3,
                    1,
                    4,
                    2,
                    7,
                    8,
                    2,
                    5,
                    12,
                    11,
                    1,
                    12,
                    10,
                    4,
                    14,
                    15,
                    9,
                    10,
                    3,
                    6,
                    15,
                    9,
                    0,
                    0,
                    6,
                    12,
                    10,
                    11,
                    1,
                    7,
                    13,
                    13,
                    8,
                    15,
                    9,
                    1,
                    4,
                    3,
                    5,
                    14,
                    11,
                    5,
                    12,
                    2,
                    7,
                    8,
                    2,
                    4,
                    14,
                    2,
                    14,
                    12,
                    11,
                    4,
                    2,
                    1,
                    12,
                    7,
                    4,
                    10,
                    7,
                    11,
                    13,
                    6,
                    1,
                    8,
                    5,
                    5,
                    0,
                    3,
                    15,
                    15,
                    10,
                    13,
                    3,
                    0,
                    9,
                    14,
                    8,
                    9,
                    6,
                    4,
                    11,
                    2,
                    8,
                    1,
                    12,
                    11,
                    7,
                    10,
                    1,
                    13,
                    14,
                    7,
                    2,
                    8,
                    13,
                    15,
                    6,
                    9,
                    15,
                    12,
                    0,
                    5,
                    9,
                    6,
                    10,
                    3,
                    4,
                    0,
                    5,
                    14,
                    3,
                    12,
                    10,
                    1,
                    15,
                    10,
                    4,
                    15,
                    2,
                    9,
                    7,
                    2,
                    12,
                    6,
                    9,
                    8,
                    5,
                    0,
                    6,
                    13,
                    1,
                    3,
                    13,
                    4,
                    14,
                    14,
                    0,
                    7,
                    11,
                    5,
                    3,
                    11,
                    8,
                    9,
                    4,
                    14,
                    3,
                    15,
                    2,
                    5,
                    12,
                    2,
                    9,
                    8,
                    5,
                    12,
                    15,
                    3,
                    10,
                    7,
                    11,
                    0,
                    14,
                    4,
                    1,
                    10,
                    7,
                    1,
                    6,
                    13,
                    0,
                    11,
                    8,
                    6,
                    13,
                    4,
                    13,
                    11,
                    0,
                    2,
                    11,
                    14,
                    7,
                    15,
                    4,
                    0,
                    9,
                    8,
                    1,
                    13,
                    10,
                    3,
                    14,
                    12,
                    3,
                    9,
                    5,
                    7,
                    12,
                    5,
                    2,
                    10,
                    15,
                    6,
                    8,
                    1,
                    6,
                    1,
                    6,
                    4,
                    11,
                    11,
                    13,
                    13,
                    8,
                    12,
                    1,
                    3,
                    4,
                    7,
                    10,
                    14,
                    7,
                    10,
                    9,
                    15,
                    5,
                    6,
                    0,
                    8,
                    15,
                    0,
                    14,
                    5,
                    2,
                    9,
                    3,
                    2,
                    12,
                    13,
                    1,
                    2,
                    15,
                    8,
                    13,
                    4,
                    8,
                    6,
                    10,
                    15,
                    3,
                    11,
                    7,
                    1,
                    4,
                    10,
                    12,
                    9,
                    5,
                    3,
                    6,
                    14,
                    11,
                    5,
                    0,
                    0,
                    14,
                    12,
                    9,
                    7,
                    2,
                    7,
                    2,
                    11,
                    1,
                    4,
                    14,
                    1,
                    7,
                    9,
                    4,
                    12,
                    10,
                    14,
                    8,
                    2,
                    13,
                    0,
                    15,
                    6,
                    12,
                    10,
                    9,
                    13,
                    0,
                    15,
                    3,
                    3,
                    5,
                    5,
                    6,
                    8,
                    11
                ];
                r.substitute = function(e, t) {
                    for(var r = 0, n = 0; n < 4; n++)r <<= 4, r |= i[64 * n + (e >>> 18 - 6 * n & 63)];
                    for(n = 0; n < 4; n++)r <<= 4, r |= i[256 + 64 * n + (t >>> 18 - 6 * n & 63)];
                    return r >>> 0;
                };
                var s = [
                    16,
                    25,
                    12,
                    11,
                    3,
                    20,
                    4,
                    15,
                    31,
                    17,
                    9,
                    6,
                    27,
                    14,
                    1,
                    22,
                    30,
                    24,
                    8,
                    18,
                    0,
                    5,
                    29,
                    23,
                    13,
                    19,
                    2,
                    26,
                    10,
                    21,
                    28,
                    7
                ];
                r.permute = function(e) {
                    for(var t = 0, r = 0; r < s.length; r++)t <<= 1, t |= e >>> s[r] & 1;
                    return t >>> 0;
                }, r.padSplit = function(e, t, r) {
                    for(var n = e.toString(2); n.length < t;)n = "0" + n;
                    for(var i = [], s = 0; s < t; s += r)i.push(n.slice(s, s + r));
                    return i.join(" ");
                };
            },
            {}
        ],
        400: [
            function(e, t, r) {
                (function(t) {
                    (function() {
                        "use strict";
                        var n = e("./lib/generatePrime"), i = e("./lib/primes.json"), s = e("./lib/dh");
                        var o = {
                            binary: !0,
                            hex: !0,
                            base64: !0
                        };
                        r.DiffieHellmanGroup = r.createDiffieHellmanGroup = r.getDiffieHellman = function(e) {
                            var r = new t(i[e].prime, "hex"), n = new t(i[e].gen, "hex");
                            return new s(r, n);
                        }, r.createDiffieHellman = r.DiffieHellman = function e(r, i, a, l) {
                            return t.isBuffer(i) || void 0 === o[i] ? e(r, "binary", i, a) : (i = i || "binary", l = l || "binary", a = a || new t([
                                2
                            ]), t.isBuffer(a) || (a = new t(a, l)), "number" == typeof r ? new s(n(r, a), a, !0) : (t.isBuffer(r) || (r = new t(r, i)), new s(r, a, !0)));
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./lib/dh": 401,
                "./lib/generatePrime": 402,
                "./lib/primes.json": 403,
                buffer: 220
            }
        ],
        401: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = e("bn.js"), i = new (e("miller-rabin")), s = new n(24), o = new n(11), a = new n(10), l = new n(3), c = new n(7), u = e("./generatePrime"), h = e("randombytes");
                        function f(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._pub = new n(e), this;
                        }
                        function d(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this._priv = new n(e), this;
                        }
                        t.exports = m;
                        var p = {};
                        function m(e, t, r) {
                            this.setGenerator(t), this.__prime = new n(e), this._prime = n.mont(this.__prime), this._primeLen = e.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, r ? (this.setPublicKey = f, this.setPrivateKey = d) : this._primeCode = 8;
                        }
                        function b(e, t) {
                            var n = new r(e.toArray());
                            return t ? n.toString(t) : n;
                        }
                        Object.defineProperty(m.prototype, "verifyError", {
                            enumerable: !0,
                            get: function() {
                                return "number" != typeof this._primeCode && (this._primeCode = function(e, t) {
                                    var r = t.toString("hex"), n = [
                                        r,
                                        e.toString(16)
                                    ].join("_");
                                    if (n in p) return p[n];
                                    var h, f = 0;
                                    if (e.isEven() || !u.simpleSieve || !u.fermatTest(e) || !i.test(e)) return f += 1, f += "02" === r || "05" === r ? 8 : 4, p[n] = f, f;
                                    switch(i.test(e.shrn(1)) || (f += 2), r){
                                        case "02":
                                            e.mod(s).cmp(o) && (f += 8);
                                            break;
                                        case "05":
                                            (h = e.mod(a)).cmp(l) && h.cmp(c) && (f += 8);
                                            break;
                                        default:
                                            f += 4;
                                    }
                                    return p[n] = f, f;
                                }(this.__prime, this.__gen)), this._primeCode;
                            }
                        }), m.prototype.generateKeys = function() {
                            return this._priv || (this._priv = new n(h(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
                        }, m.prototype.computeSecret = function(e) {
                            var t = (e = (e = new n(e)).toRed(this._prime)).redPow(this._priv).fromRed(), i = new r(t.toArray()), s = this.getPrime();
                            if (i.length < s.length) {
                                var o = new r(s.length - i.length);
                                o.fill(0), i = r.concat([
                                    o,
                                    i
                                ]);
                            }
                            return i;
                        }, m.prototype.getPublicKey = function(e) {
                            return b(this._pub, e);
                        }, m.prototype.getPrivateKey = function(e) {
                            return b(this._priv, e);
                        }, m.prototype.getPrime = function(e) {
                            return b(this.__prime, e);
                        }, m.prototype.getGenerator = function(e) {
                            return b(this._gen, e);
                        }, m.prototype.setGenerator = function(e, t) {
                            return t = t || "utf8", r.isBuffer(e) || (e = new r(e, t)), this.__gen = e, this._gen = new n(e), this;
                        };
                    }).call(this);
                }).call(this, e("buffer").Buffer);
            },
            {
                "./generatePrime": 402,
                "bn.js": 404,
                buffer: 220,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        402: [
            function(e, t, r) {
                "use strict";
                var n = e("randombytes");
                t.exports = y, y.simpleSieve = b, y.fermatTest = g;
                var i = e("bn.js"), s = new i(24), o = new (e("miller-rabin")), a = new i(1), l = new i(2), c = new i(5), u = (new i(16), new i(8), new i(10)), h = new i(3), f = (new i(7), new i(11)), d = new i(4), p = (new i(12), null);
                function m() {
                    if (null !== p) return p;
                    var e = [];
                    e[0] = 2;
                    for(var t = 1, r = 3; r < 1048576; r += 2){
                        for(var n = Math.ceil(Math.sqrt(r)), i = 0; i < t && e[i] <= n && r % e[i] != 0; i++);
                        t !== i && e[i] <= n || (e[t++] = r);
                    }
                    return p = e, e;
                }
                function b(e) {
                    for(var t = m(), r = 0; r < t.length; r++)if (0 === e.modn(t[r])) return 0 === e.cmpn(t[r]);
                    return !0;
                }
                function g(e) {
                    var t = i.mont(e);
                    return 0 === l.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1);
                }
                function y(e, t) {
                    if (e < 16) return new i(2 === t || 5 === t ? [
                        140,
                        123
                    ] : [
                        140,
                        39
                    ]);
                    var r, p;
                    for(t = new i(t);;){
                        for(r = new i(n(Math.ceil(e / 8))); r.bitLength() > e;)r.ishrn(1);
                        if (r.isEven() && r.iadd(a), r.testn(1) || r.iadd(l), t.cmp(l)) {
                            if (!t.cmp(c)) for(; r.mod(u).cmp(h);)r.iadd(d);
                        } else for(; r.mod(s).cmp(f);)r.iadd(d);
                        if (b(p = r.shrn(1)) && b(r) && g(p) && g(r) && o.test(p) && o.test(r)) return r;
                    }
                }
            },
            {
                "bn.js": 404,
                "miller-rabin": 451,
                randombytes: 475
            }
        ],
        403: [
            function(e, t, r) {
                t.exports = {
                    modp1: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
                    },
                    modp2: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
                    },
                    modp5: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
                    },
                    modp14: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
                    },
                    modp15: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
                    },
                    modp16: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
                    },
                    modp17: {
                        gen: "02",
                        prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
                    },
                    modp18: {
                        gen: "02",
                        prime: "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"
                    }
                };
            },
            {}
        ],
        404: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        405: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.version = e("../package.json").version, n.utils = e("./elliptic/utils"), n.rand = e("brorand"), n.curve = e("./elliptic/curve"), n.curves = e("./elliptic/curves"), n.ec = e("./elliptic/ec"), n.eddsa = e("./elliptic/eddsa");
            },
            {
                "../package.json": 421,
                "./elliptic/curve": 408,
                "./elliptic/curves": 411,
                "./elliptic/ec": 412,
                "./elliptic/eddsa": 415,
                "./elliptic/utils": 419,
                brorand: 187
            }
        ],
        406: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.getNAF, o = i.getJSF, a = i.assert;
                function l(e, t) {
                    this.type = e, this.p = new n(t.p, 16), this.red = t.prime ? n.red(t.prime) : n.mont(this.p), this.zero = new n(0).toRed(this.red), this.one = new n(1).toRed(this.red), this.two = new n(2).toRed(this.red), this.n = t.n && new n(t.n, 16), this.g = t.g && this.pointFromJSON(t.g, t.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
                    var r = this.n && this.p.div(this.n);
                    !r || r.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
                }
                function c(e, t) {
                    this.curve = e, this.type = t, this.precomputed = null;
                }
                t.exports = l, l.prototype.point = function() {
                    throw new Error("Not implemented");
                }, l.prototype.validate = function() {
                    throw new Error("Not implemented");
                }, l.prototype._fixedNafMul = function(e, t) {
                    a(e.precomputed);
                    var r = e._getDoubles(), n = s(t, 1, this._bitLength), i = (1 << r.step + 1) - (r.step % 2 == 0 ? 2 : 1);
                    i /= 3;
                    var o, l, c = [];
                    for(o = 0; o < n.length; o += r.step){
                        l = 0;
                        for(var u = o + r.step - 1; u >= o; u--)l = (l << 1) + n[u];
                        c.push(l);
                    }
                    for(var h = this.jpoint(null, null, null), f = this.jpoint(null, null, null), d = i; d > 0; d--){
                        for(o = 0; o < c.length; o++)(l = c[o]) === d ? f = f.mixedAdd(r.points[o]) : l === -d && (f = f.mixedAdd(r.points[o].neg()));
                        h = h.add(f);
                    }
                    return h.toP();
                }, l.prototype._wnafMul = function(e, t) {
                    var r = 4, n = e._getNAFPoints(r);
                    r = n.wnd;
                    for(var i = n.points, o = s(t, r, this._bitLength), l = this.jpoint(null, null, null), c = o.length - 1; c >= 0; c--){
                        for(var u = 0; c >= 0 && 0 === o[c]; c--)u++;
                        if (c >= 0 && u++, l = l.dblp(u), c < 0) break;
                        var h = o[c];
                        a(0 !== h), l = "affine" === e.type ? h > 0 ? l.mixedAdd(i[h - 1 >> 1]) : l.mixedAdd(i[-h - 1 >> 1].neg()) : h > 0 ? l.add(i[h - 1 >> 1]) : l.add(i[-h - 1 >> 1].neg());
                    }
                    return "affine" === e.type ? l.toP() : l;
                }, l.prototype._wnafMulAdd = function(e, t, r, n, i) {
                    var a, l, c, u = this._wnafT1, h = this._wnafT2, f = this._wnafT3, d = 0;
                    for(a = 0; a < n; a++){
                        var p = (c = t[a])._getNAFPoints(e);
                        u[a] = p.wnd, h[a] = p.points;
                    }
                    for(a = n - 1; a >= 1; a -= 2){
                        var m = a - 1, b = a;
                        if (1 === u[m] && 1 === u[b]) {
                            var g = [
                                t[m],
                                null,
                                null,
                                t[b]
                            ];
                            0 === t[m].y.cmp(t[b].y) ? (g[1] = t[m].add(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg())) : 0 === t[m].y.cmp(t[b].y.redNeg()) ? (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].add(t[b].neg())) : (g[1] = t[m].toJ().mixedAdd(t[b]), g[2] = t[m].toJ().mixedAdd(t[b].neg()));
                            var y = [
                                -3,
                                -1,
                                -5,
                                -7,
                                0,
                                7,
                                5,
                                1,
                                3
                            ], v = o(r[m], r[b]);
                            for(d = Math.max(v[0].length, d), f[m] = new Array(d), f[b] = new Array(d), l = 0; l < d; l++){
                                var w = 0 | v[0][l], _ = 0 | v[1][l];
                                f[m][l] = y[3 * (w + 1) + (_ + 1)], f[b][l] = 0, h[m] = g;
                            }
                        } else f[m] = s(r[m], u[m], this._bitLength), f[b] = s(r[b], u[b], this._bitLength), d = Math.max(f[m].length, d), d = Math.max(f[b].length, d);
                    }
                    var x = this.jpoint(null, null, null), k = this._wnafT4;
                    for(a = d; a >= 0; a--){
                        for(var S = 0; a >= 0;){
                            var M = !0;
                            for(l = 0; l < n; l++)k[l] = 0 | f[l][a], 0 !== k[l] && (M = !1);
                            if (!M) break;
                            S++, a--;
                        }
                        if (a >= 0 && S++, x = x.dblp(S), a < 0) break;
                        for(l = 0; l < n; l++){
                            var C = k[l];
                            0 !== C && (C > 0 ? c = h[l][C - 1 >> 1] : C < 0 && (c = h[l][-C - 1 >> 1].neg()), x = "affine" === c.type ? x.mixedAdd(c) : x.add(c));
                        }
                    }
                    for(a = 0; a < n; a++)h[a] = null;
                    return i ? x : x.toP();
                }, l.BasePoint = c, c.prototype.eq = function() {
                    throw new Error("Not implemented");
                }, c.prototype.validate = function() {
                    return this.curve.validate(this);
                }, l.prototype.decodePoint = function(e, t) {
                    e = i.toArray(e, t);
                    var r = this.p.byteLength();
                    if ((4 === e[0] || 6 === e[0] || 7 === e[0]) && e.length - 1 == 2 * r) return 6 === e[0] ? a(e[e.length - 1] % 2 == 0) : 7 === e[0] && a(e[e.length - 1] % 2 == 1), this.point(e.slice(1, 1 + r), e.slice(1 + r, 1 + 2 * r));
                    if ((2 === e[0] || 3 === e[0]) && e.length - 1 === r) return this.pointFromX(e.slice(1, 1 + r), 3 === e[0]);
                    throw new Error("Unknown point format");
                }, c.prototype.encodeCompressed = function(e) {
                    return this.encode(e, !0);
                }, c.prototype._encode = function(e) {
                    var t = this.curve.p.byteLength(), r = this.getX().toArray("be", t);
                    return e ? [
                        this.getY().isEven() ? 2 : 3
                    ].concat(r) : [
                        4
                    ].concat(r, this.getY().toArray("be", t));
                }, c.prototype.encode = function(e, t) {
                    return i.encode(this._encode(t), e);
                }, c.prototype.precompute = function(e) {
                    if (this.precomputed) return this;
                    var t = {
                        doubles: null,
                        naf: null,
                        beta: null
                    };
                    return t.naf = this._getNAFPoints(8), t.doubles = this._getDoubles(4, e), t.beta = this._getBeta(), this.precomputed = t, this;
                }, c.prototype._hasDoubles = function(e) {
                    if (!this.precomputed) return !1;
                    var t = this.precomputed.doubles;
                    return !!t && t.points.length >= Math.ceil((e.bitLength() + 1) / t.step);
                }, c.prototype._getDoubles = function(e, t) {
                    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
                    for(var r = [
                        this
                    ], n = this, i = 0; i < t; i += e){
                        for(var s = 0; s < e; s++)n = n.dbl();
                        r.push(n);
                    }
                    return {
                        step: e,
                        points: r
                    };
                }, c.prototype._getNAFPoints = function(e) {
                    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
                    for(var t = [
                        this
                    ], r = (1 << e) - 1, n = 1 === r ? null : this.dbl(), i = 1; i < r; i++)t[i] = t[i - 1].add(n);
                    return {
                        wnd: e,
                        points: t
                    };
                }, c.prototype._getBeta = function() {
                    return null;
                }, c.prototype.dblp = function(e) {
                    for(var t = this, r = 0; r < e; r++)t = t.dbl();
                    return t;
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        407: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    this.twisted = 1 != (0 | e.a), this.mOneA = this.twisted && -1 == (0 | e.a), this.extended = this.mOneA, o.call(this, "edwards", e), this.a = new i(e.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new i(e.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new i(e.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), a(!this.twisted || 0 === this.c.fromRed().cmpn(1)), this.oneC = 1 == (0 | e.c);
                }
                function c(e, t, r, n, s) {
                    o.BasePoint.call(this, e, "projective"), null === t && null === r && null === n ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = n ? new i(n, 16) : this.curve.one, this.t = s && new i(s, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
                }
                s(l, o), t.exports = l, l.prototype._mulA = function(e) {
                    return this.mOneA ? e.redNeg() : this.a.redMul(e);
                }, l.prototype._mulC = function(e) {
                    return this.oneC ? e : this.c.redMul(e);
                }, l.prototype.jpoint = function(e, t, r, n) {
                    return this.point(e, t, r, n);
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = this.c2.redSub(this.a.redMul(r)), s = this.one.redSub(this.c2.redMul(this.d).redMul(r)), o = n.redMul(s.redInvm()), a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    var l = a.fromRed().isOdd();
                    return (t && !l || !t && l) && (a = a.redNeg()), this.point(e, a);
                }, l.prototype.pointFromY = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr(), n = r.redSub(this.c2), s = r.redMul(this.d).redMul(this.c2).redSub(this.a), o = n.redMul(s.redInvm());
                    if (0 === o.cmp(this.zero)) {
                        if (t) throw new Error("invalid point");
                        return this.point(this.zero, e);
                    }
                    var a = o.redSqrt();
                    if (0 !== a.redSqr().redSub(o).cmp(this.zero)) throw new Error("invalid point");
                    return a.fromRed().isOdd() !== t && (a = a.redNeg()), this.point(a, e);
                }, l.prototype.validate = function(e) {
                    if (e.isInfinity()) return !0;
                    e.normalize();
                    var t = e.x.redSqr(), r = e.y.redSqr(), n = t.redMul(this.a).redAdd(r), i = this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));
                    return 0 === n.cmp(i);
                }, s(c, o.BasePoint), l.prototype.pointFromJSON = function(e) {
                    return c.fromJSON(this, e);
                }, l.prototype.point = function(e, t, r, n) {
                    return new c(this, e, t, r, n);
                }, c.fromJSON = function(e, t) {
                    return new c(e, t[0], t[1], t[2]);
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return 0 === this.x.cmpn(0) && (0 === this.y.cmp(this.z) || this.zOne && 0 === this.y.cmp(this.curve.c));
                }, c.prototype._extDbl = function() {
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr();
                    r = r.redIAdd(r);
                    var n = this.curve._mulA(e), i = this.x.redAdd(this.y).redSqr().redISub(e).redISub(t), s = n.redAdd(t), o = s.redSub(r), a = n.redSub(t), l = i.redMul(o), c = s.redMul(a), u = i.redMul(a), h = o.redMul(s);
                    return this.curve.point(l, c, h, u);
                }, c.prototype._projDbl = function() {
                    var e, t, r, n, i, s, o = this.x.redAdd(this.y).redSqr(), a = this.x.redSqr(), l = this.y.redSqr();
                    if (this.curve.twisted) {
                        var c = (n = this.curve._mulA(a)).redAdd(l);
                        this.zOne ? (e = o.redSub(a).redSub(l).redMul(c.redSub(this.curve.two)), t = c.redMul(n.redSub(l)), r = c.redSqr().redSub(c).redSub(c)) : (i = this.z.redSqr(), s = c.redSub(i).redISub(i), e = o.redSub(a).redISub(l).redMul(s), t = c.redMul(n.redSub(l)), r = c.redMul(s));
                    } else n = a.redAdd(l), i = this.curve._mulC(this.z).redSqr(), s = n.redSub(i).redSub(i), e = this.curve._mulC(o.redISub(n)).redMul(s), t = this.curve._mulC(n).redMul(a.redISub(l)), r = n.redMul(s);
                    return this.curve.point(e, t, r);
                }, c.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
                }, c.prototype._extAdd = function(e) {
                    var t = this.y.redSub(this.x).redMul(e.y.redSub(e.x)), r = this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)), n = this.t.redMul(this.curve.dd).redMul(e.t), i = this.z.redMul(e.z.redAdd(e.z)), s = r.redSub(t), o = i.redSub(n), a = i.redAdd(n), l = r.redAdd(t), c = s.redMul(o), u = a.redMul(l), h = s.redMul(l), f = o.redMul(a);
                    return this.curve.point(c, u, f, h);
                }, c.prototype._projAdd = function(e) {
                    var t, r, n = this.z.redMul(e.z), i = n.redSqr(), s = this.x.redMul(e.x), o = this.y.redMul(e.y), a = this.curve.d.redMul(s).redMul(o), l = i.redSub(a), c = i.redAdd(a), u = this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(s).redISub(o), h = n.redMul(l).redMul(u);
                    return this.curve.twisted ? (t = n.redMul(c).redMul(o.redSub(this.curve._mulA(s))), r = l.redMul(c)) : (t = n.redMul(c).redMul(o.redSub(s)), r = this.curve._mulC(l).redMul(c)), this.curve.point(h, t, r);
                }, c.prototype.add = function(e) {
                    return this.isInfinity() ? e : e.isInfinity() ? this : this.curve.extended ? this._extAdd(e) : this._projAdd(e);
                }, c.prototype.mul = function(e) {
                    return this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !1);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    return this.curve._wnafMulAdd(1, [
                        this,
                        t
                    ], [
                        e,
                        r
                    ], 2, !0);
                }, c.prototype.normalize = function() {
                    if (this.zOne) return this;
                    var e = this.z.redInvm();
                    return this.x = this.x.redMul(e), this.y = this.y.redMul(e), this.t && (this.t = this.t.redMul(e)), this.z = this.curve.one, this.zOne = !0, this;
                }, c.prototype.neg = function() {
                    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
                }, c.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.normalize(), this.y.fromRed();
                }, c.prototype.eq = function(e) {
                    return this === e || 0 === this.getX().cmp(e.getX()) && 0 === this.getY().cmp(e.getY());
                }, c.prototype.eqXToP = function(e) {
                    var t = e.toRed(this.curve.red).redMul(this.z);
                    if (0 === this.x.cmp(t)) return !0;
                    for(var r = e.clone(), n = this.curve.redN.redMul(this.z);;){
                        if (r.iadd(this.curve.n), r.cmp(this.curve.p) >= 0) return !1;
                        if (t.redIAdd(n), 0 === this.x.cmp(t)) return !0;
                    }
                }, c.prototype.toP = c.prototype.normalize, c.prototype.mixedAdd = c.prototype.add;
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        408: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.base = e("./base"), n.short = e("./short"), n.mont = e("./mont"), n.edwards = e("./edwards");
            },
            {
                "./base": 406,
                "./edwards": 407,
                "./mont": 409,
                "./short": 410
            }
        ],
        409: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("inherits"), s = e("./base"), o = e("../utils");
                function a(e) {
                    s.call(this, "mont", e), this.a = new n(e.a, 16).toRed(this.red), this.b = new n(e.b, 16).toRed(this.red), this.i4 = new n(4).toRed(this.red).redInvm(), this.two = new n(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
                }
                function l(e, t, r) {
                    s.BasePoint.call(this, e, "projective"), null === t && null === r ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new n(t, 16), this.z = new n(r, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
                }
                i(a, s), t.exports = a, a.prototype.validate = function(e) {
                    var t = e.normalize().x, r = t.redSqr(), n = r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);
                    return 0 === n.redSqrt().redSqr().cmp(n);
                }, i(l, s.BasePoint), a.prototype.decodePoint = function(e, t) {
                    return this.point(o.toArray(e, t), 1);
                }, a.prototype.point = function(e, t) {
                    return new l(this, e, t);
                }, a.prototype.pointFromJSON = function(e) {
                    return l.fromJSON(this, e);
                }, l.prototype.precompute = function() {}, l.prototype._encode = function() {
                    return this.getX().toArray("be", this.curve.p.byteLength());
                }, l.fromJSON = function(e, t) {
                    return new l(e, t[0], t[1] || e.one);
                }, l.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
                }, l.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                }, l.prototype.dbl = function() {
                    var e = this.x.redAdd(this.z).redSqr(), t = this.x.redSub(this.z).redSqr(), r = e.redSub(t), n = e.redMul(t), i = r.redMul(t.redAdd(this.curve.a24.redMul(r)));
                    return this.curve.point(n, i);
                }, l.prototype.add = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.diffAdd = function(e, t) {
                    var r = this.x.redAdd(this.z), n = this.x.redSub(this.z), i = e.x.redAdd(e.z), s = e.x.redSub(e.z).redMul(r), o = i.redMul(n), a = t.z.redMul(s.redAdd(o).redSqr()), l = t.x.redMul(s.redISub(o).redSqr());
                    return this.curve.point(a, l);
                }, l.prototype.mul = function(e) {
                    for(var t = e.clone(), r = this, n = this.curve.point(null, null), i = []; 0 !== t.cmpn(0); t.iushrn(1))i.push(t.andln(1));
                    for(var s = i.length - 1; s >= 0; s--)0 === i[s] ? (r = r.diffAdd(n, this), n = n.dbl()) : (n = r.diffAdd(n, this), r = r.dbl());
                    return n;
                }, l.prototype.mulAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.jumlAdd = function() {
                    throw new Error("Not supported on Montgomery curve");
                }, l.prototype.eq = function(e) {
                    return 0 === this.getX().cmp(e.getX());
                }, l.prototype.normalize = function() {
                    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
                }, l.prototype.getX = function() {
                    return this.normalize(), this.x.fromRed();
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        410: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("bn.js"), s = e("inherits"), o = e("./base"), a = n.assert;
                function l(e) {
                    o.call(this, "short", e), this.a = new i(e.a, 16).toRed(this.red), this.b = new i(e.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = 0 === this.a.fromRed().cmpn(0), this.threeA = 0 === this.a.fromRed().sub(this.p).cmpn(-3), this.endo = this._getEndomorphism(e), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
                }
                function c(e, t, r, n) {
                    o.BasePoint.call(this, e, "affine"), null === t && null === r ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new i(t, 16), this.y = new i(r, 16), n && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
                }
                function u(e, t, r, n) {
                    o.BasePoint.call(this, e, "jacobian"), null === t && null === r && null === n ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new i(0)) : (this.x = new i(t, 16), this.y = new i(r, 16), this.z = new i(n, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
                }
                s(l, o), t.exports = l, l.prototype._getEndomorphism = function(e) {
                    if (this.zeroA && this.g && this.n && 1 === this.p.modn(3)) {
                        var t, r;
                        if (e.beta) t = new i(e.beta, 16).toRed(this.red);
                        else {
                            var n = this._getEndoRoots(this.p);
                            t = (t = n[0].cmp(n[1]) < 0 ? n[0] : n[1]).toRed(this.red);
                        }
                        if (e.lambda) r = new i(e.lambda, 16);
                        else {
                            var s = this._getEndoRoots(this.n);
                            0 === this.g.mul(s[0]).x.cmp(this.g.x.redMul(t)) ? r = s[0] : (r = s[1], a(0 === this.g.mul(r).x.cmp(this.g.x.redMul(t))));
                        }
                        return {
                            beta: t,
                            lambda: r,
                            basis: e.basis ? e.basis.map(function(e) {
                                return {
                                    a: new i(e.a, 16),
                                    b: new i(e.b, 16)
                                };
                            }) : this._getEndoBasis(r)
                        };
                    }
                }, l.prototype._getEndoRoots = function(e) {
                    var t = e === this.p ? this.red : i.mont(e), r = new i(2).toRed(t).redInvm(), n = r.redNeg(), s = new i(3).toRed(t).redNeg().redSqrt().redMul(r);
                    return [
                        n.redAdd(s).fromRed(),
                        n.redSub(s).fromRed()
                    ];
                }, l.prototype._getEndoBasis = function(e) {
                    for(var t, r, n, s, o, a, l, c, u, h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), f = e, d = this.n.clone(), p = new i(1), m = new i(0), b = new i(0), g = new i(1), y = 0; 0 !== f.cmpn(0);){
                        var v = d.div(f);
                        c = d.sub(v.mul(f)), u = b.sub(v.mul(p));
                        var w = g.sub(v.mul(m));
                        if (!n && c.cmp(h) < 0) t = l.neg(), r = p, n = c.neg(), s = u;
                        else if (n && 2 == ++y) break;
                        l = c, d = f, f = c, b = p, p = u, g = m, m = w;
                    }
                    o = c.neg(), a = u;
                    var _ = n.sqr().add(s.sqr());
                    return o.sqr().add(a.sqr()).cmp(_) >= 0 && (o = t, a = r), n.negative && (n = n.neg(), s = s.neg()), o.negative && (o = o.neg(), a = a.neg()), [
                        {
                            a: n,
                            b: s
                        },
                        {
                            a: o,
                            b: a
                        }
                    ];
                }, l.prototype._endoSplit = function(e) {
                    var t = this.endo.basis, r = t[0], n = t[1], i = n.b.mul(e).divRound(this.n), s = r.b.neg().mul(e).divRound(this.n), o = i.mul(r.a), a = s.mul(n.a), l = i.mul(r.b), c = s.mul(n.b);
                    return {
                        k1: e.sub(o).sub(a),
                        k2: l.add(c).neg()
                    };
                }, l.prototype.pointFromX = function(e, t) {
                    (e = new i(e, 16)).red || (e = e.toRed(this.red));
                    var r = e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b), n = r.redSqrt();
                    if (0 !== n.redSqr().redSub(r).cmp(this.zero)) throw new Error("invalid point");
                    var s = n.fromRed().isOdd();
                    return (t && !s || !t && s) && (n = n.redNeg()), this.point(e, n);
                }, l.prototype.validate = function(e) {
                    if (e.inf) return !0;
                    var t = e.x, r = e.y, n = this.a.redMul(t), i = t.redSqr().redMul(t).redIAdd(n).redIAdd(this.b);
                    return 0 === r.redSqr().redISub(i).cmpn(0);
                }, l.prototype._endoWnafMulAdd = function(e, t, r) {
                    for(var n = this._endoWnafT1, i = this._endoWnafT2, s = 0; s < e.length; s++){
                        var o = this._endoSplit(t[s]), a = e[s], l = a._getBeta();
                        o.k1.negative && (o.k1.ineg(), a = a.neg(!0)), o.k2.negative && (o.k2.ineg(), l = l.neg(!0)), n[2 * s] = a, n[2 * s + 1] = l, i[2 * s] = o.k1, i[2 * s + 1] = o.k2;
                    }
                    for(var c = this._wnafMulAdd(1, n, i, 2 * s, r), u = 0; u < 2 * s; u++)n[u] = null, i[u] = null;
                    return c;
                }, s(c, o.BasePoint), l.prototype.point = function(e, t, r) {
                    return new c(this, e, t, r);
                }, l.prototype.pointFromJSON = function(e, t) {
                    return c.fromJSON(this, e, t);
                }, c.prototype._getBeta = function() {
                    if (this.curve.endo) {
                        var e = this.precomputed;
                        if (e && e.beta) return e.beta;
                        var t = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
                        if (e) {
                            var r = this.curve, n = function(e) {
                                return r.point(e.x.redMul(r.endo.beta), e.y);
                            };
                            e.beta = t, t.precomputed = {
                                beta: null,
                                naf: e.naf && {
                                    wnd: e.naf.wnd,
                                    points: e.naf.points.map(n)
                                },
                                doubles: e.doubles && {
                                    step: e.doubles.step,
                                    points: e.doubles.points.map(n)
                                }
                            };
                        }
                        return t;
                    }
                }, c.prototype.toJSON = function() {
                    return this.precomputed ? [
                        this.x,
                        this.y,
                        this.precomputed && {
                            doubles: this.precomputed.doubles && {
                                step: this.precomputed.doubles.step,
                                points: this.precomputed.doubles.points.slice(1)
                            },
                            naf: this.precomputed.naf && {
                                wnd: this.precomputed.naf.wnd,
                                points: this.precomputed.naf.points.slice(1)
                            }
                        }
                    ] : [
                        this.x,
                        this.y
                    ];
                }, c.fromJSON = function(e, t, r) {
                    "string" == typeof t && (t = JSON.parse(t));
                    var n = e.point(t[0], t[1], r);
                    if (!t[2]) return n;
                    function i(t) {
                        return e.point(t[0], t[1], r);
                    }
                    var s = t[2];
                    return n.precomputed = {
                        beta: null,
                        doubles: s.doubles && {
                            step: s.doubles.step,
                            points: [
                                n
                            ].concat(s.doubles.points.map(i))
                        },
                        naf: s.naf && {
                            wnd: s.naf.wnd,
                            points: [
                                n
                            ].concat(s.naf.points.map(i))
                        }
                    }, n;
                }, c.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
                }, c.prototype.isInfinity = function() {
                    return this.inf;
                }, c.prototype.add = function(e) {
                    if (this.inf) return e;
                    if (e.inf) return this;
                    if (this.eq(e)) return this.dbl();
                    if (this.neg().eq(e)) return this.curve.point(null, null);
                    if (0 === this.x.cmp(e.x)) return this.curve.point(null, null);
                    var t = this.y.redSub(e.y);
                    0 !== t.cmpn(0) && (t = t.redMul(this.x.redSub(e.x).redInvm()));
                    var r = t.redSqr().redISub(this.x).redISub(e.x), n = t.redMul(this.x.redSub(r)).redISub(this.y);
                    return this.curve.point(r, n);
                }, c.prototype.dbl = function() {
                    if (this.inf) return this;
                    var e = this.y.redAdd(this.y);
                    if (0 === e.cmpn(0)) return this.curve.point(null, null);
                    var t = this.curve.a, r = this.x.redSqr(), n = e.redInvm(), i = r.redAdd(r).redIAdd(r).redIAdd(t).redMul(n), s = i.redSqr().redISub(this.x.redAdd(this.x)), o = i.redMul(this.x.redSub(s)).redISub(this.y);
                    return this.curve.point(s, o);
                }, c.prototype.getX = function() {
                    return this.x.fromRed();
                }, c.prototype.getY = function() {
                    return this.y.fromRed();
                }, c.prototype.mul = function(e) {
                    return e = new i(e, 16), this.isInfinity() ? this : this._hasDoubles(e) ? this.curve._fixedNafMul(this, e) : this.curve.endo ? this.curve._endoWnafMulAdd([
                        this
                    ], [
                        e
                    ]) : this.curve._wnafMul(this, e);
                }, c.prototype.mulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i) : this.curve._wnafMulAdd(1, n, i, 2);
                }, c.prototype.jmulAdd = function(e, t, r) {
                    var n = [
                        this,
                        t
                    ], i = [
                        e,
                        r
                    ];
                    return this.curve.endo ? this.curve._endoWnafMulAdd(n, i, !0) : this.curve._wnafMulAdd(1, n, i, 2, !0);
                }, c.prototype.eq = function(e) {
                    return this === e || this.inf === e.inf && (this.inf || 0 === this.x.cmp(e.x) && 0 === this.y.cmp(e.y));
                }, c.prototype.neg = function(e) {
                    if (this.inf) return this;
                    var t = this.curve.point(this.x, this.y.redNeg());
                    if (e && this.precomputed) {
                        var r = this.precomputed, n = function(e) {
                            return e.neg();
                        };
                        t.precomputed = {
                            naf: r.naf && {
                                wnd: r.naf.wnd,
                                points: r.naf.points.map(n)
                            },
                            doubles: r.doubles && {
                                step: r.doubles.step,
                                points: r.doubles.points.map(n)
                            }
                        };
                    }
                    return t;
                }, c.prototype.toJ = function() {
                    return this.inf ? this.curve.jpoint(null, null, null) : this.curve.jpoint(this.x, this.y, this.curve.one);
                }, s(u, o.BasePoint), l.prototype.jpoint = function(e, t, r) {
                    return new u(this, e, t, r);
                }, u.prototype.toP = function() {
                    if (this.isInfinity()) return this.curve.point(null, null);
                    var e = this.z.redInvm(), t = e.redSqr(), r = this.x.redMul(t), n = this.y.redMul(t).redMul(e);
                    return this.curve.point(r, n);
                }, u.prototype.neg = function() {
                    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
                }, u.prototype.add = function(e) {
                    if (this.isInfinity()) return e;
                    if (e.isInfinity()) return this;
                    var t = e.z.redSqr(), r = this.z.redSqr(), n = this.x.redMul(t), i = e.x.redMul(r), s = this.y.redMul(t.redMul(e.z)), o = e.y.redMul(r.redMul(this.z)), a = n.redSub(i), l = s.redSub(o);
                    if (0 === a.cmpn(0)) return 0 !== l.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var c = a.redSqr(), u = c.redMul(a), h = n.redMul(c), f = l.redSqr().redIAdd(u).redISub(h).redISub(h), d = l.redMul(h.redISub(f)).redISub(s.redMul(u)), p = this.z.redMul(e.z).redMul(a);
                    return this.curve.jpoint(f, d, p);
                }, u.prototype.mixedAdd = function(e) {
                    if (this.isInfinity()) return e.toJ();
                    if (e.isInfinity()) return this;
                    var t = this.z.redSqr(), r = this.x, n = e.x.redMul(t), i = this.y, s = e.y.redMul(t).redMul(this.z), o = r.redSub(n), a = i.redSub(s);
                    if (0 === o.cmpn(0)) return 0 !== a.cmpn(0) ? this.curve.jpoint(null, null, null) : this.dbl();
                    var l = o.redSqr(), c = l.redMul(o), u = r.redMul(l), h = a.redSqr().redIAdd(c).redISub(u).redISub(u), f = a.redMul(u.redISub(h)).redISub(i.redMul(c)), d = this.z.redMul(o);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.dblp = function(e) {
                    if (0 === e) return this;
                    if (this.isInfinity()) return this;
                    if (!e) return this.dbl();
                    var t;
                    if (this.curve.zeroA || this.curve.threeA) {
                        var r = this;
                        for(t = 0; t < e; t++)r = r.dbl();
                        return r;
                    }
                    var n = this.curve.a, i = this.curve.tinv, s = this.x, o = this.y, a = this.z, l = a.redSqr().redSqr(), c = o.redAdd(o);
                    for(t = 0; t < e; t++){
                        var u = s.redSqr(), h = c.redSqr(), f = h.redSqr(), d = u.redAdd(u).redIAdd(u).redIAdd(n.redMul(l)), p = s.redMul(h), m = d.redSqr().redISub(p.redAdd(p)), b = p.redISub(m), g = d.redMul(b);
                        g = g.redIAdd(g).redISub(f);
                        var y = c.redMul(a);
                        t + 1 < e && (l = l.redMul(f)), s = m, a = y, c = g;
                    }
                    return this.curve.jpoint(s, c.redMul(i), a);
                }, u.prototype.dbl = function() {
                    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
                }, u.prototype._zeroDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n), l = a.redSqr().redISub(o).redISub(o), c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), e = l, t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.x.redSqr(), h = this.y.redSqr(), f = h.redSqr(), d = this.x.redAdd(h).redSqr().redISub(u).redISub(f);
                        d = d.redIAdd(d);
                        var p = u.redAdd(u).redIAdd(u), m = p.redSqr(), b = f.redIAdd(f);
                        b = (b = b.redIAdd(b)).redIAdd(b), e = m.redISub(d).redISub(d), t = p.redMul(d.redISub(e)).redISub(b), r = (r = this.y.redMul(this.z)).redIAdd(r);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._threeDbl = function() {
                    var e, t, r;
                    if (this.zOne) {
                        var n = this.x.redSqr(), i = this.y.redSqr(), s = i.redSqr(), o = this.x.redAdd(i).redSqr().redISub(n).redISub(s);
                        o = o.redIAdd(o);
                        var a = n.redAdd(n).redIAdd(n).redIAdd(this.curve.a), l = a.redSqr().redISub(o).redISub(o);
                        e = l;
                        var c = s.redIAdd(s);
                        c = (c = c.redIAdd(c)).redIAdd(c), t = a.redMul(o.redISub(l)).redISub(c), r = this.y.redAdd(this.y);
                    } else {
                        var u = this.z.redSqr(), h = this.y.redSqr(), f = this.x.redMul(h), d = this.x.redSub(u).redMul(this.x.redAdd(u));
                        d = d.redAdd(d).redIAdd(d);
                        var p = f.redIAdd(f), m = (p = p.redIAdd(p)).redAdd(p);
                        e = d.redSqr().redISub(m), r = this.y.redAdd(this.z).redSqr().redISub(h).redISub(u);
                        var b = h.redSqr();
                        b = (b = (b = b.redIAdd(b)).redIAdd(b)).redIAdd(b), t = d.redMul(p.redISub(e)).redISub(b);
                    }
                    return this.curve.jpoint(e, t, r);
                }, u.prototype._dbl = function() {
                    var e = this.curve.a, t = this.x, r = this.y, n = this.z, i = n.redSqr().redSqr(), s = t.redSqr(), o = r.redSqr(), a = s.redAdd(s).redIAdd(s).redIAdd(e.redMul(i)), l = t.redAdd(t), c = (l = l.redIAdd(l)).redMul(o), u = a.redSqr().redISub(c.redAdd(c)), h = c.redISub(u), f = o.redSqr();
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = a.redMul(h).redISub(f), p = r.redAdd(r).redMul(n);
                    return this.curve.jpoint(u, d, p);
                }, u.prototype.trpl = function() {
                    if (!this.curve.zeroA) return this.dbl().add(this);
                    var e = this.x.redSqr(), t = this.y.redSqr(), r = this.z.redSqr(), n = t.redSqr(), i = e.redAdd(e).redIAdd(e), s = i.redSqr(), o = this.x.redAdd(t).redSqr().redISub(e).redISub(n), a = (o = (o = (o = o.redIAdd(o)).redAdd(o).redIAdd(o)).redISub(s)).redSqr(), l = n.redIAdd(n);
                    l = (l = (l = l.redIAdd(l)).redIAdd(l)).redIAdd(l);
                    var c = i.redIAdd(o).redSqr().redISub(s).redISub(a).redISub(l), u = t.redMul(c);
                    u = (u = u.redIAdd(u)).redIAdd(u);
                    var h = this.x.redMul(a).redISub(u);
                    h = (h = h.redIAdd(h)).redIAdd(h);
                    var f = this.y.redMul(c.redMul(l.redISub(c)).redISub(o.redMul(a)));
                    f = (f = (f = f.redIAdd(f)).redIAdd(f)).redIAdd(f);
                    var d = this.z.redAdd(o).redSqr().redISub(r).redISub(a);
                    return this.curve.jpoint(h, f, d);
                }, u.prototype.mul = function(e, t) {
                    return e = new i(e, t), this.curve._wnafMul(this, e);
                }, u.prototype.eq = function(e) {
                    if ("affine" === e.type) return this.eq(e.toJ());
                    if (this === e) return !0;
                    var t = this.z.redSqr(), r = e.z.redSqr();
                    if (0 !== this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)) return !1;
                    var n = t.redMul(this.z), i = r.redMul(e.z);
                    return 0 === this.y.redMul(i).redISub(e.y.redMul(n)).cmpn(0);
                }, u.prototype.eqXToP = function(e) {
                    var t = this.z.redSqr(), r = e.toRed(this.curve.red).redMul(t);
                    if (0 === this.x.cmp(r)) return !0;
                    for(var n = e.clone(), i = this.curve.redN.redMul(t);;){
                        if (n.iadd(this.curve.n), n.cmp(this.curve.p) >= 0) return !1;
                        if (r.redIAdd(i), 0 === this.x.cmp(r)) return !0;
                    }
                }, u.prototype.inspect = function() {
                    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
                }, u.prototype.isInfinity = function() {
                    return 0 === this.z.cmpn(0);
                };
            },
            {
                "../utils": 419,
                "./base": 406,
                "bn.js": 420,
                inherits: 440
            }
        ],
        411: [
            function(e, t, r) {
                "use strict";
                var n, i = r, s = e("hash.js"), o = e("./curve"), a = e("./utils").assert;
                function l(e) {
                    "short" === e.type ? this.curve = new o.short(e) : "edwards" === e.type ? this.curve = new o.edwards(e) : this.curve = new o.mont(e), this.g = this.curve.g, this.n = this.curve.n, this.hash = e.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
                }
                function c(e, t) {
                    Object.defineProperty(i, e, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var r = new l(t);
                            return Object.defineProperty(i, e, {
                                configurable: !0,
                                enumerable: !0,
                                value: r
                            }), r;
                        }
                    });
                }
                i.PresetCurve = l, c("p192", {
                    type: "short",
                    prime: "p192",
                    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
                    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
                    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
                        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
                    ]
                }), c("p224", {
                    type: "short",
                    prime: "p224",
                    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
                    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
                    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
                    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
                        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
                    ]
                }), c("p256", {
                    type: "short",
                    prime: null,
                    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
                    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
                    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
                    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
                        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
                    ]
                }), c("p384", {
                    type: "short",
                    prime: null,
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
                    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
                    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
                    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
                    hash: s.sha384,
                    gRed: !1,
                    g: [
                        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
                        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
                    ]
                }), c("p521", {
                    type: "short",
                    prime: null,
                    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
                    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
                    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
                    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
                    hash: s.sha512,
                    gRed: !1,
                    g: [
                        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
                        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
                    ]
                }), c("curve25519", {
                    type: "mont",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "76d06",
                    b: "1",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "9"
                    ]
                }), c("ed25519", {
                    type: "edwards",
                    prime: "p25519",
                    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
                    a: "-1",
                    c: "1",
                    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
                    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
                    hash: s.sha256,
                    gRed: !1,
                    g: [
                        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
                        "6666666666666666666666666666666666666666666666666666666666666658"
                    ]
                });
                try {
                    n = e("./precomputed/secp256k1");
                } catch (e) {
                    n = void 0;
                }
                c("secp256k1", {
                    type: "short",
                    prime: "k256",
                    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
                    a: "0",
                    b: "7",
                    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
                    h: "1",
                    hash: s.sha256,
                    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
                    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
                    basis: [
                        {
                            a: "3086d221a7d46bcde86c90e49284eb15",
                            b: "-e4437ed6010e88286f547fa90abfe4c3"
                        },
                        {
                            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                            b: "3086d221a7d46bcde86c90e49284eb15"
                        }
                    ],
                    gRed: !1,
                    g: [
                        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
                        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
                        n
                    ]
                });
            },
            {
                "./curve": 408,
                "./precomputed/secp256k1": 418,
                "./utils": 419,
                "hash.js": 426
            }
        ],
        412: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("hmac-drbg"), s = e("../utils"), o = e("../curves"), a = e("brorand"), l = s.assert, c = e("./key"), u = e("./signature");
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    "string" == typeof e && (l(Object.prototype.hasOwnProperty.call(o, e), "Unknown curve " + e), e = o[e]), e instanceof o.PresetCurve && (e = {
                        curve: e
                    }), this.curve = e.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = e.curve.g, this.g.precompute(e.curve.n.bitLength() + 1), this.hash = e.hash || e.curve.hash;
                }
                t.exports = h, h.prototype.keyPair = function(e) {
                    return new c(this, e);
                }, h.prototype.keyFromPrivate = function(e, t) {
                    return c.fromPrivate(this, e, t);
                }, h.prototype.keyFromPublic = function(e, t) {
                    return c.fromPublic(this, e, t);
                }, h.prototype.genKeyPair = function(e) {
                    e || (e = {});
                    for(var t = new i({
                        hash: this.hash,
                        pers: e.pers,
                        persEnc: e.persEnc || "utf8",
                        entropy: e.entropy || a(this.hash.hmacStrength),
                        entropyEnc: e.entropy && e.entropyEnc || "utf8",
                        nonce: this.n.toArray()
                    }), r = this.n.byteLength(), s = this.n.sub(new n(2));;){
                        var o = new n(t.generate(r));
                        if (!(o.cmp(s) > 0)) return o.iaddn(1), this.keyFromPrivate(o);
                    }
                }, h.prototype._truncateToN = function(e, t) {
                    var r = 8 * e.byteLength() - this.n.bitLength();
                    return r > 0 && (e = e.ushrn(r)), !t && e.cmp(this.n) >= 0 ? e.sub(this.n) : e;
                }, h.prototype.sign = function(e, t, r, s) {
                    "object" == typeof r && (s = r, r = null), s || (s = {}), t = this.keyFromPrivate(t, r), e = this._truncateToN(new n(e, 16));
                    for(var o = this.n.byteLength(), a = t.getPrivate().toArray("be", o), l = e.toArray("be", o), c = new i({
                        hash: this.hash,
                        entropy: a,
                        nonce: l,
                        pers: s.pers,
                        persEnc: s.persEnc || "utf8"
                    }), h = this.n.sub(new n(1)), f = 0;; f++){
                        var d = s.k ? s.k(f) : new n(c.generate(this.n.byteLength()));
                        if (!((d = this._truncateToN(d, !0)).cmpn(1) <= 0 || d.cmp(h) >= 0)) {
                            var p = this.g.mul(d);
                            if (!p.isInfinity()) {
                                var m = p.getX(), b = m.umod(this.n);
                                if (0 !== b.cmpn(0)) {
                                    var g = d.invm(this.n).mul(b.mul(t.getPrivate()).iadd(e));
                                    if (0 !== (g = g.umod(this.n)).cmpn(0)) {
                                        var y = (p.getY().isOdd() ? 1 : 0) | (0 !== m.cmp(b) ? 2 : 0);
                                        return s.canonical && g.cmp(this.nh) > 0 && (g = this.n.sub(g), y ^= 1), new u({
                                            r: b,
                                            s: g,
                                            recoveryParam: y
                                        });
                                    }
                                }
                            }
                        }
                    }
                }, h.prototype.verify = function(e, t, r, i) {
                    e = this._truncateToN(new n(e, 16)), r = this.keyFromPublic(r, i);
                    var s = (t = new u(t, "hex")).r, o = t.s;
                    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return !1;
                    if (o.cmpn(1) < 0 || o.cmp(this.n) >= 0) return !1;
                    var a, l = o.invm(this.n), c = l.mul(e).umod(this.n), h = l.mul(s).umod(this.n);
                    return this.curve._maxwellTrick ? !(a = this.g.jmulAdd(c, r.getPublic(), h)).isInfinity() && a.eqXToP(s) : !(a = this.g.mulAdd(c, r.getPublic(), h)).isInfinity() && 0 === a.getX().umod(this.n).cmp(s);
                }, h.prototype.recoverPubKey = function(e, t, r, i) {
                    l((3 & r) === r, "The recovery param is more than two bits"), t = new u(t, i);
                    var s = this.n, o = new n(e), a = t.r, c = t.s, h = 1 & r, f = r >> 1;
                    if (a.cmp(this.curve.p.umod(this.curve.n)) >= 0 && f) throw new Error("Unable to find sencond key candinate");
                    a = f ? this.curve.pointFromX(a.add(this.curve.n), h) : this.curve.pointFromX(a, h);
                    var d = t.r.invm(s), p = s.sub(o).mul(d).umod(s), m = c.mul(d).umod(s);
                    return this.g.mulAdd(p, a, m);
                }, h.prototype.getKeyRecoveryParam = function(e, t, r, n) {
                    if (null !== (t = new u(t, n)).recoveryParam) return t.recoveryParam;
                    for(var i = 0; i < 4; i++){
                        var s;
                        try {
                            s = this.recoverPubKey(e, t, i);
                        } catch (e) {
                            continue;
                        }
                        if (s.eq(r)) return i;
                    }
                    throw new Error("Unable to find valid recovery factor");
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 413,
                "./signature": 414,
                "bn.js": 420,
                brorand: 187,
                "hmac-drbg": 438
            }
        ],
        413: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils").assert;
                function s(e, t) {
                    this.ec = e, this.priv = null, this.pub = null, t.priv && this._importPrivate(t.priv, t.privEnc), t.pub && this._importPublic(t.pub, t.pubEnc);
                }
                t.exports = s, s.fromPublic = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        pub: t,
                        pubEnc: r
                    });
                }, s.fromPrivate = function(e, t, r) {
                    return t instanceof s ? t : new s(e, {
                        priv: t,
                        privEnc: r
                    });
                }, s.prototype.validate = function() {
                    var e = this.getPublic();
                    return e.isInfinity() ? {
                        result: !1,
                        reason: "Invalid public key"
                    } : e.validate() ? e.mul(this.ec.curve.n).isInfinity() ? {
                        result: !0,
                        reason: null
                    } : {
                        result: !1,
                        reason: "Public key * N != O"
                    } : {
                        result: !1,
                        reason: "Public key is not a point"
                    };
                }, s.prototype.getPublic = function(e, t) {
                    return "string" == typeof e && (t = e, e = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), t ? this.pub.encode(t, e) : this.pub;
                }, s.prototype.getPrivate = function(e) {
                    return "hex" === e ? this.priv.toString(16, 2) : this.priv;
                }, s.prototype._importPrivate = function(e, t) {
                    this.priv = new n(e, t || 16), this.priv = this.priv.umod(this.ec.curve.n);
                }, s.prototype._importPublic = function(e, t) {
                    if (e.x || e.y) return "mont" === this.ec.curve.type ? i(e.x, "Need x coordinate") : "short" !== this.ec.curve.type && "edwards" !== this.ec.curve.type || i(e.x && e.y, "Need both x and y coordinate"), void (this.pub = this.ec.curve.point(e.x, e.y));
                    this.pub = this.ec.curve.decodePoint(e, t);
                }, s.prototype.derive = function(e) {
                    return e.validate() || i(e.validate(), "public point not validated"), e.mul(this.priv).getX();
                }, s.prototype.sign = function(e, t, r) {
                    return this.ec.sign(e, this, t, r);
                }, s.prototype.verify = function(e, t) {
                    return this.ec.verify(e, t, this);
                }, s.prototype.inspect = function() {
                    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        414: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert;
                function o(e, t) {
                    if (e instanceof o) return e;
                    this._importDER(e, t) || (s(e.r && e.s, "Signature without r or s"), this.r = new n(e.r, 16), this.s = new n(e.s, 16), void 0 === e.recoveryParam ? this.recoveryParam = null : this.recoveryParam = e.recoveryParam);
                }
                function a() {
                    this.place = 0;
                }
                function l(e, t) {
                    var r = e[t.place++];
                    if (!(128 & r)) return r;
                    var n = 15 & r;
                    if (0 === n || n > 4) return !1;
                    for(var i = 0, s = 0, o = t.place; s < n; s++, o++)i <<= 8, i |= e[o], i >>>= 0;
                    return !(i <= 127) && (t.place = o, i);
                }
                function c(e) {
                    for(var t = 0, r = e.length - 1; !e[t] && !(128 & e[t + 1]) && t < r;)t++;
                    return 0 === t ? e : e.slice(t);
                }
                function u(e, t) {
                    if (t < 128) e.push(t);
                    else {
                        var r = 1 + (Math.log(t) / Math.LN2 >>> 3);
                        for(e.push(128 | r); --r;)e.push(t >>> (r << 3) & 255);
                        e.push(t);
                    }
                }
                t.exports = o, o.prototype._importDER = function(e, t) {
                    e = i.toArray(e, t);
                    var r = new a;
                    if (48 !== e[r.place++]) return !1;
                    var s = l(e, r);
                    if (!1 === s) return !1;
                    if (s + r.place !== e.length) return !1;
                    if (2 !== e[r.place++]) return !1;
                    var o = l(e, r);
                    if (!1 === o) return !1;
                    var c = e.slice(r.place, o + r.place);
                    if (r.place += o, 2 !== e[r.place++]) return !1;
                    var u = l(e, r);
                    if (!1 === u) return !1;
                    if (e.length !== u + r.place) return !1;
                    var h = e.slice(r.place, u + r.place);
                    if (0 === c[0]) {
                        if (!(128 & c[1])) return !1;
                        c = c.slice(1);
                    }
                    if (0 === h[0]) {
                        if (!(128 & h[1])) return !1;
                        h = h.slice(1);
                    }
                    return this.r = new n(c), this.s = new n(h), this.recoveryParam = null, !0;
                }, o.prototype.toDER = function(e) {
                    var t = this.r.toArray(), r = this.s.toArray();
                    for(128 & t[0] && (t = [
                        0
                    ].concat(t)), 128 & r[0] && (r = [
                        0
                    ].concat(r)), t = c(t), r = c(r); !(r[0] || 128 & r[1]);)r = r.slice(1);
                    var n = [
                        2
                    ];
                    u(n, t.length), (n = n.concat(t)).push(2), u(n, r.length);
                    var s = n.concat(r), o = [
                        48
                    ];
                    return u(o, s.length), o = o.concat(s), i.encode(o, e);
                };
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        415: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("../curves"), s = e("../utils"), o = s.assert, a = s.parseBytes, l = e("./key"), c = e("./signature");
                function u(e) {
                    if (o("ed25519" === e, "only tested with ed25519 so far"), !(this instanceof u)) return new u(e);
                    e = i[e].curve, this.curve = e, this.g = e.g, this.g.precompute(e.n.bitLength() + 1), this.pointClass = e.point().constructor, this.encodingLength = Math.ceil(e.n.bitLength() / 8), this.hash = n.sha512;
                }
                t.exports = u, u.prototype.sign = function(e, t) {
                    e = a(e);
                    var r = this.keyFromSecret(t), n = this.hashInt(r.messagePrefix(), e), i = this.g.mul(n), s = this.encodePoint(i), o = this.hashInt(s, r.pubBytes(), e).mul(r.priv()), l = n.add(o).umod(this.curve.n);
                    return this.makeSignature({
                        R: i,
                        S: l,
                        Rencoded: s
                    });
                }, u.prototype.verify = function(e, t, r) {
                    e = a(e), t = this.makeSignature(t);
                    var n = this.keyFromPublic(r), i = this.hashInt(t.Rencoded(), n.pubBytes(), e), s = this.g.mul(t.S());
                    return t.R().add(n.pub().mul(i)).eq(s);
                }, u.prototype.hashInt = function() {
                    for(var e = this.hash(), t = 0; t < arguments.length; t++)e.update(arguments[t]);
                    return s.intFromLE(e.digest()).umod(this.curve.n);
                }, u.prototype.keyFromPublic = function(e) {
                    return l.fromPublic(this, e);
                }, u.prototype.keyFromSecret = function(e) {
                    return l.fromSecret(this, e);
                }, u.prototype.makeSignature = function(e) {
                    return e instanceof c ? e : new c(this, e);
                }, u.prototype.encodePoint = function(e) {
                    var t = e.getY().toArray("le", this.encodingLength);
                    return t[this.encodingLength - 1] |= e.getX().isOdd() ? 128 : 0, t;
                }, u.prototype.decodePoint = function(e) {
                    var t = (e = s.parseBytes(e)).length - 1, r = e.slice(0, t).concat(-129 & e[t]), n = 0 != (128 & e[t]), i = s.intFromLE(r);
                    return this.curve.pointFromY(i, n);
                }, u.prototype.encodeInt = function(e) {
                    return e.toArray("le", this.encodingLength);
                }, u.prototype.decodeInt = function(e) {
                    return s.intFromLE(e);
                }, u.prototype.isPoint = function(e) {
                    return e instanceof this.pointClass;
                };
            },
            {
                "../curves": 411,
                "../utils": 419,
                "./key": 416,
                "./signature": 417,
                "hash.js": 426
            }
        ],
        416: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = n.assert, s = n.parseBytes, o = n.cachedProperty;
                function a(e, t) {
                    this.eddsa = e, this._secret = s(t.secret), e.isPoint(t.pub) ? this._pub = t.pub : this._pubBytes = s(t.pub);
                }
                a.fromPublic = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        pub: t
                    });
                }, a.fromSecret = function(e, t) {
                    return t instanceof a ? t : new a(e, {
                        secret: t
                    });
                }, a.prototype.secret = function() {
                    return this._secret;
                }, o(a, "pubBytes", function() {
                    return this.eddsa.encodePoint(this.pub());
                }), o(a, "pub", function() {
                    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
                }), o(a, "privBytes", function() {
                    var e = this.eddsa, t = this.hash(), r = e.encodingLength - 1, n = t.slice(0, e.encodingLength);
                    return n[0] &= 248, n[r] &= 127, n[r] |= 64, n;
                }), o(a, "priv", function() {
                    return this.eddsa.decodeInt(this.privBytes());
                }), o(a, "hash", function() {
                    return this.eddsa.hash().update(this.secret()).digest();
                }), o(a, "messagePrefix", function() {
                    return this.hash().slice(this.eddsa.encodingLength);
                }), a.prototype.sign = function(e) {
                    return i(this._secret, "KeyPair can only verify"), this.eddsa.sign(e, this);
                }, a.prototype.verify = function(e, t) {
                    return this.eddsa.verify(e, t, this);
                }, a.prototype.getSecret = function(e) {
                    return i(this._secret, "KeyPair is public only"), n.encode(this.secret(), e);
                }, a.prototype.getPublic = function(e) {
                    return n.encode(this.pubBytes(), e);
                }, t.exports = a;
            },
            {
                "../utils": 419
            }
        ],
        417: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("../utils"), s = i.assert, o = i.cachedProperty, a = i.parseBytes;
                function l(e, t) {
                    this.eddsa = e, "object" != typeof t && (t = a(t)), Array.isArray(t) && (t = {
                        R: t.slice(0, e.encodingLength),
                        S: t.slice(e.encodingLength)
                    }), s(t.R && t.S, "Signature without R or S"), e.isPoint(t.R) && (this._R = t.R), t.S instanceof n && (this._S = t.S), this._Rencoded = Array.isArray(t.R) ? t.R : t.Rencoded, this._Sencoded = Array.isArray(t.S) ? t.S : t.Sencoded;
                }
                o(l, "S", function() {
                    return this.eddsa.decodeInt(this.Sencoded());
                }), o(l, "R", function() {
                    return this.eddsa.decodePoint(this.Rencoded());
                }), o(l, "Rencoded", function() {
                    return this.eddsa.encodePoint(this.R());
                }), o(l, "Sencoded", function() {
                    return this.eddsa.encodeInt(this.S());
                }), l.prototype.toBytes = function() {
                    return this.Rencoded().concat(this.Sencoded());
                }, l.prototype.toHex = function() {
                    return i.encode(this.toBytes(), "hex").toUpperCase();
                }, t.exports = l;
            },
            {
                "../utils": 419,
                "bn.js": 420
            }
        ],
        418: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    doubles: {
                        step: 4,
                        points: [
                            [
                                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
                            ],
                            [
                                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
                            ],
                            [
                                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
                            ],
                            [
                                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
                            ],
                            [
                                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
                            ],
                            [
                                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
                            ],
                            [
                                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
                            ],
                            [
                                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
                            ],
                            [
                                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
                            ],
                            [
                                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
                            ],
                            [
                                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
                            ],
                            [
                                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
                            ],
                            [
                                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
                            ],
                            [
                                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
                            ],
                            [
                                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
                            ],
                            [
                                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
                            ],
                            [
                                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
                            ],
                            [
                                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
                            ],
                            [
                                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
                            ],
                            [
                                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
                            ],
                            [
                                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
                            ],
                            [
                                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
                            ],
                            [
                                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
                            ],
                            [
                                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
                            ],
                            [
                                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
                            ],
                            [
                                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
                            ],
                            [
                                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
                            ],
                            [
                                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
                            ],
                            [
                                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
                            ],
                            [
                                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
                            ],
                            [
                                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
                            ],
                            [
                                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
                            ],
                            [
                                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
                            ],
                            [
                                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
                            ],
                            [
                                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
                            ],
                            [
                                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
                            ],
                            [
                                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
                            ],
                            [
                                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
                            ],
                            [
                                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
                            ],
                            [
                                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
                            ],
                            [
                                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
                            ],
                            [
                                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
                            ],
                            [
                                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
                            ],
                            [
                                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
                            ],
                            [
                                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
                            ],
                            [
                                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
                            ],
                            [
                                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
                            ],
                            [
                                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
                            ],
                            [
                                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
                            ],
                            [
                                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
                            ],
                            [
                                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
                            ],
                            [
                                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
                            ],
                            [
                                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
                            ],
                            [
                                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
                            ],
                            [
                                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
                            ],
                            [
                                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
                            ],
                            [
                                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
                            ],
                            [
                                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
                            ],
                            [
                                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
                            ],
                            [
                                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
                            ],
                            [
                                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
                            ],
                            [
                                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
                            ],
                            [
                                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
                            ],
                            [
                                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
                            ],
                            [
                                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
                            ]
                        ]
                    },
                    naf: {
                        wnd: 7,
                        points: [
                            [
                                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
                            ],
                            [
                                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
                            ],
                            [
                                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
                            ],
                            [
                                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
                            ],
                            [
                                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
                            ],
                            [
                                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
                            ],
                            [
                                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
                            ],
                            [
                                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
                            ],
                            [
                                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
                            ],
                            [
                                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
                            ],
                            [
                                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
                            ],
                            [
                                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
                            ],
                            [
                                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
                            ],
                            [
                                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
                            ],
                            [
                                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
                            ],
                            [
                                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
                            ],
                            [
                                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
                            ],
                            [
                                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
                            ],
                            [
                                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
                            ],
                            [
                                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
                            ],
                            [
                                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
                            ],
                            [
                                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
                            ],
                            [
                                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
                            ],
                            [
                                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
                            ],
                            [
                                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
                            ],
                            [
                                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
                            ],
                            [
                                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
                            ],
                            [
                                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
                            ],
                            [
                                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
                            ],
                            [
                                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
                            ],
                            [
                                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
                            ],
                            [
                                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
                            ],
                            [
                                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
                            ],
                            [
                                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
                            ],
                            [
                                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
                            ],
                            [
                                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
                            ],
                            [
                                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
                            ],
                            [
                                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
                            ],
                            [
                                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
                            ],
                            [
                                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
                            ],
                            [
                                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
                            ],
                            [
                                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
                            ],
                            [
                                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
                            ],
                            [
                                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
                            ],
                            [
                                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
                            ],
                            [
                                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
                            ],
                            [
                                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
                            ],
                            [
                                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
                            ],
                            [
                                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
                            ],
                            [
                                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
                            ],
                            [
                                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
                            ],
                            [
                                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
                            ],
                            [
                                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
                            ],
                            [
                                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
                            ],
                            [
                                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
                            ],
                            [
                                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
                            ],
                            [
                                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
                            ],
                            [
                                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
                            ],
                            [
                                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
                            ],
                            [
                                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
                            ],
                            [
                                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
                            ],
                            [
                                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
                            ],
                            [
                                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
                            ],
                            [
                                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
                            ],
                            [
                                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
                            ],
                            [
                                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
                            ],
                            [
                                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
                            ],
                            [
                                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
                            ],
                            [
                                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
                            ],
                            [
                                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
                            ],
                            [
                                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
                            ],
                            [
                                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
                            ],
                            [
                                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
                            ],
                            [
                                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
                            ],
                            [
                                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
                            ],
                            [
                                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
                            ],
                            [
                                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
                            ],
                            [
                                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
                            ],
                            [
                                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
                            ],
                            [
                                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
                            ],
                            [
                                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
                            ],
                            [
                                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
                            ],
                            [
                                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
                            ],
                            [
                                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
                            ],
                            [
                                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
                            ],
                            [
                                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
                            ],
                            [
                                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
                            ],
                            [
                                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
                            ],
                            [
                                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
                            ],
                            [
                                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
                            ],
                            [
                                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
                            ],
                            [
                                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
                            ],
                            [
                                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
                            ],
                            [
                                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
                            ],
                            [
                                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
                            ],
                            [
                                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
                            ],
                            [
                                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
                            ],
                            [
                                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
                            ],
                            [
                                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
                            ],
                            [
                                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
                            ],
                            [
                                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
                            ],
                            [
                                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
                            ],
                            [
                                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
                            ],
                            [
                                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
                            ],
                            [
                                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
                            ],
                            [
                                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
                            ],
                            [
                                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
                            ],
                            [
                                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
                            ],
                            [
                                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
                            ],
                            [
                                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
                            ],
                            [
                                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
                            ],
                            [
                                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
                            ],
                            [
                                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
                            ],
                            [
                                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
                            ],
                            [
                                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
                            ],
                            [
                                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
                            ],
                            [
                                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
                            ],
                            [
                                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
                            ],
                            [
                                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
                            ],
                            [
                                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
                            ],
                            [
                                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
                            ],
                            [
                                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
                            ],
                            [
                                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
                            ],
                            [
                                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
                            ],
                            [
                                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
                            ],
                            [
                                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
                            ],
                            [
                                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
                            ]
                        ]
                    }
                };
            },
            {}
        ],
        419: [
            function(e, t, r) {
                "use strict";
                var n = r, i = e("bn.js"), s = e("minimalistic-assert"), o = e("minimalistic-crypto-utils");
                n.assert = s, n.toArray = o.toArray, n.zero2 = o.zero2, n.toHex = o.toHex, n.encode = o.encode, n.getNAF = function(e, t, r) {
                    var n = new Array(Math.max(e.bitLength(), r) + 1);
                    n.fill(0);
                    for(var i = 1 << t + 1, s = e.clone(), o = 0; o < n.length; o++){
                        var a, l = s.andln(i - 1);
                        s.isOdd() ? (a = l > (i >> 1) - 1 ? (i >> 1) - l : l, s.isubn(a)) : a = 0, n[o] = a, s.iushrn(1);
                    }
                    return n;
                }, n.getJSF = function(e, t) {
                    var r = [
                        [],
                        []
                    ];
                    e = e.clone(), t = t.clone();
                    for(var n, i = 0, s = 0; e.cmpn(-i) > 0 || t.cmpn(-s) > 0;){
                        var o, a, l = e.andln(3) + i & 3, c = t.andln(3) + s & 3;
                        3 === l && (l = -1), 3 === c && (c = -1), o = 0 == (1 & l) ? 0 : 3 !== (n = e.andln(7) + i & 7) && 5 !== n || 2 !== c ? l : -l, r[0].push(o), a = 0 == (1 & c) ? 0 : 3 !== (n = t.andln(7) + s & 7) && 5 !== n || 2 !== l ? c : -c, r[1].push(a), 2 * i === o + 1 && (i = 1 - i), 2 * s === a + 1 && (s = 1 - s), e.iushrn(1), t.iushrn(1);
                    }
                    return r;
                }, n.cachedProperty = function(e, t, r) {
                    var n = "_" + t;
                    e.prototype[t] = function() {
                        return void 0 !== this[n] ? this[n] : this[n] = r.call(this);
                    };
                }, n.parseBytes = function(e) {
                    return "string" == typeof e ? n.toArray(e, "hex") : e;
                }, n.intFromLE = function(e) {
                    return new i(e, "hex", "le");
                };
            },
            {
                "bn.js": 420,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        420: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        421: [
            function(e, t, r) {
                t.exports = {
                    name: "elliptic",
                    version: "6.5.4",
                    description: "EC cryptography",
                    main: "lib/elliptic.js",
                    files: [
                        "lib"
                    ],
                    scripts: {
                        lint: "eslint lib test",
                        "lint:fix": "npm run lint -- --fix",
                        unit: "istanbul test _mocha --reporter=spec test/index.js",
                        test: "npm run lint && npm run unit",
                        version: "grunt dist && git add dist/"
                    },
                    repository: {
                        type: "git",
                        url: "git@github.com:indutny/elliptic"
                    },
                    keywords: [
                        "EC",
                        "Elliptic",
                        "curve",
                        "Cryptography"
                    ],
                    author: "Fedor Indutny <fedor@indutny.com>",
                    license: "MIT",
                    bugs: {
                        url: "https://github.com/indutny/elliptic/issues"
                    },
                    homepage: "https://github.com/indutny/elliptic",
                    devDependencies: {
                        brfs: "^2.0.2",
                        coveralls: "^3.1.0",
                        eslint: "^7.6.0",
                        grunt: "^1.2.1",
                        "grunt-browserify": "^5.3.0",
                        "grunt-cli": "^1.3.2",
                        "grunt-contrib-connect": "^3.0.0",
                        "grunt-contrib-copy": "^1.0.0",
                        "grunt-contrib-uglify": "^5.0.0",
                        "grunt-mocha-istanbul": "^5.0.2",
                        "grunt-saucelabs": "^9.0.1",
                        istanbul: "^0.4.5",
                        mocha: "^8.0.1"
                    },
                    dependencies: {
                        "bn.js": "^4.11.9",
                        brorand: "^1.1.0",
                        "hash.js": "^1.0.0",
                        "hmac-drbg": "^1.0.1",
                        inherits: "^2.0.4",
                        "minimalistic-assert": "^1.0.1",
                        "minimalistic-crypto-utils": "^1.0.1"
                    }
                };
            },
            {}
        ],
        422: [
            function(e, t, r) {
                "use strict";
                var n = Object.create || function(e) {
                    var t = function() {};
                    return t.prototype = e, new t;
                }, i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.push(r);
                    return r;
                }, s = Function.prototype.bind || function(e) {
                    var t = this;
                    return function() {
                        return t.apply(e, arguments);
                    };
                };
                function o() {
                    this._events && Object.prototype.hasOwnProperty.call(this, "_events") || (this._events = n(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
                }
                t.exports = o, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._maxListeners = void 0;
                var a, l = 10;
                try {
                    var c = {};
                    Object.defineProperty && Object.defineProperty(c, "x", {
                        value: 0
                    }), a = 0 === c.x;
                } catch (e) {
                    a = !1;
                }
                function u(e) {
                    return void 0 === e._maxListeners ? o.defaultMaxListeners : e._maxListeners;
                }
                function h(e, t, r) {
                    if (t) e.call(r);
                    else for(var n = e.length, i = _(e, n), s = 0; s < n; ++s)i[s].call(r);
                }
                function f(e, t, r, n) {
                    if (t) e.call(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].call(r, n);
                }
                function d(e, t, r, n, i) {
                    if (t) e.call(r, n, i);
                    else for(var s = e.length, o = _(e, s), a = 0; a < s; ++a)o[a].call(r, n, i);
                }
                function p(e, t, r, n, i, s) {
                    if (t) e.call(r, n, i, s);
                    else for(var o = e.length, a = _(e, o), l = 0; l < o; ++l)a[l].call(r, n, i, s);
                }
                function m(e, t, r, n) {
                    if (t) e.apply(r, n);
                    else for(var i = e.length, s = _(e, i), o = 0; o < i; ++o)s[o].apply(r, n);
                }
                function b(e, t, r, i) {
                    var s, o, a;
                    if ("function" != typeof r) throw new TypeError('"listener" argument must be a function');
                    if ((o = e._events) ? (o.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), o = e._events), a = o[t]) : (o = e._events = n(null), e._eventsCount = 0), a) {
                        if ("function" == typeof a ? a = o[t] = i ? [
                            r,
                            a
                        ] : [
                            a,
                            r
                        ] : i ? a.unshift(r) : a.push(r), !a.warned && (s = u(e)) && s > 0 && a.length > s) {
                            a.warned = !0;
                            var l = new Error("Possible EventEmitter memory leak detected. " + a.length + ' "' + String(t) + '" listeners added. Use emitter.setMaxListeners() to increase limit.');
                            l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, "object" == typeof console && console.warn && console.warn("%s: %s", l.name, l.message);
                        }
                    } else a = o[t] = r, ++e._eventsCount;
                    return e;
                }
                function g() {
                    if (!this.fired) switch(this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length){
                        case 0:
                            return this.listener.call(this.target);
                        case 1:
                            return this.listener.call(this.target, arguments[0]);
                        case 2:
                            return this.listener.call(this.target, arguments[0], arguments[1]);
                        case 3:
                            return this.listener.call(this.target, arguments[0], arguments[1], arguments[2]);
                        default:
                            for(var e = new Array(arguments.length), t = 0; t < e.length; ++t)e[t] = arguments[t];
                            this.listener.apply(this.target, e);
                    }
                }
                function y(e, t, r) {
                    var n = {
                        fired: !1,
                        wrapFn: void 0,
                        target: e,
                        type: t,
                        listener: r
                    }, i = s.call(g, n);
                    return i.listener = r, n.wrapFn = i, i;
                }
                function v(e, t, r) {
                    var n = e._events;
                    if (!n) return [];
                    var i = n[t];
                    return i ? "function" == typeof i ? r ? [
                        i.listener || i
                    ] : [
                        i
                    ] : r ? function(e) {
                        for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                        return t;
                    }(i) : _(i, i.length) : [];
                }
                function w(e) {
                    var t = this._events;
                    if (t) {
                        var r = t[e];
                        if ("function" == typeof r) return 1;
                        if (r) return r.length;
                    }
                    return 0;
                }
                function _(e, t) {
                    for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                    return r;
                }
                a ? Object.defineProperty(o, "defaultMaxListeners", {
                    enumerable: !0,
                    get: function() {
                        return l;
                    },
                    set: function(e) {
                        if ("number" != typeof e || e < 0 || e != e) throw new TypeError('"defaultMaxListeners" must be a positive number');
                        l = e;
                    }
                }) : o.defaultMaxListeners = l, o.prototype.setMaxListeners = function(e) {
                    if ("number" != typeof e || e < 0 || isNaN(e)) throw new TypeError('"n" argument must be a positive number');
                    return this._maxListeners = e, this;
                }, o.prototype.getMaxListeners = function() {
                    return u(this);
                }, o.prototype.emit = function(e) {
                    var t, r, n, i, s, o, a = "error" === e;
                    if (o = this._events) a = a && null == o.error;
                    else if (!a) return !1;
                    if (a) {
                        if (arguments.length > 1 && (t = arguments[1]), t instanceof Error) throw t;
                        var l = new Error('Unhandled "error" event. (' + t + ")");
                        throw l.context = t, l;
                    }
                    if (!(r = o[e])) return !1;
                    var c = "function" == typeof r;
                    switch(n = arguments.length){
                        case 1:
                            h(r, c, this);
                            break;
                        case 2:
                            f(r, c, this, arguments[1]);
                            break;
                        case 3:
                            d(r, c, this, arguments[1], arguments[2]);
                            break;
                        case 4:
                            p(r, c, this, arguments[1], arguments[2], arguments[3]);
                            break;
                        default:
                            for(i = new Array(n - 1), s = 1; s < n; s++)i[s - 1] = arguments[s];
                            m(r, c, this, i);
                    }
                    return !0;
                }, o.prototype.addListener = function(e, t) {
                    return b(this, e, t, !1);
                }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(e, t) {
                    return b(this, e, t, !0);
                }, o.prototype.once = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.on(e, y(this, e, t)), this;
                }, o.prototype.prependOnceListener = function(e, t) {
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    return this.prependListener(e, y(this, e, t)), this;
                }, o.prototype.removeListener = function(e, t) {
                    var r, i, s, o, a;
                    if ("function" != typeof t) throw new TypeError('"listener" argument must be a function');
                    if (!(i = this._events)) return this;
                    if (!(r = i[e])) return this;
                    if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = n(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, r.listener || t));
                    else if ("function" != typeof r) {
                        for(s = -1, o = r.length - 1; o >= 0; o--)if (r[o] === t || r[o].listener === t) {
                            a = r[o].listener, s = o;
                            break;
                        }
                        if (s < 0) return this;
                        0 === s ? r.shift() : function(e, t) {
                            for(var r = t, n = r + 1, i = e.length; n < i; r += 1, n += 1)e[r] = e[n];
                            e.pop();
                        }(r, s), 1 === r.length && (i[e] = r[0]), i.removeListener && this.emit("removeListener", e, a || t);
                    }
                    return this;
                }, o.prototype.removeAllListeners = function(e) {
                    var t, r, s;
                    if (!(r = this._events)) return this;
                    if (!r.removeListener) return 0 === arguments.length ? (this._events = n(null), this._eventsCount = 0) : r[e] && (0 == --this._eventsCount ? this._events = n(null) : delete r[e]), this;
                    if (0 === arguments.length) {
                        var o, a = i(r);
                        for(s = 0; s < a.length; ++s)"removeListener" !== (o = a[s]) && this.removeAllListeners(o);
                        return this.removeAllListeners("removeListener"), this._events = n(null), this._eventsCount = 0, this;
                    }
                    if ("function" == typeof (t = r[e])) this.removeListener(e, t);
                    else if (t) for(s = t.length - 1; s >= 0; s--)this.removeListener(e, t[s]);
                    return this;
                }, o.prototype.listeners = function(e) {
                    return v(this, e, !0);
                }, o.prototype.rawListeners = function(e) {
                    return v(this, e, !1);
                }, o.listenerCount = function(e, t) {
                    return "function" == typeof e.listenerCount ? e.listenerCount(t) : w.call(e, t);
                }, o.prototype.listenerCount = w, o.prototype.eventNames = function() {
                    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
                };
            },
            {}
        ],
        423: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("md5.js");
                t.exports = function(e, t, r, s) {
                    if (n.isBuffer(e) || (e = n.from(e, "binary")), t && (n.isBuffer(t) || (t = n.from(t, "binary")), 8 !== t.length)) throw new RangeError("salt should be Buffer with 8 byte length");
                    for(var o = r / 8, a = n.alloc(o), l = n.alloc(s || 0), c = n.alloc(0); o > 0 || s > 0;){
                        var u = new i;
                        u.update(c), u.update(e), t && u.update(t), c = u.digest();
                        var h = 0;
                        if (o > 0) {
                            var f = a.length - o;
                            h = Math.min(o, c.length), c.copy(a, f, 0, h), o -= h;
                        }
                        if (h < c.length && s > 0) {
                            var d = l.length - s, p = Math.min(s, c.length - h);
                            c.copy(l, d, h, h + p), s -= p;
                        }
                    }
                    return c.fill(0), {
                        key: a,
                        iv: l
                    };
                };
            },
            {
                "md5.js": 450,
                "safe-buffer": 494
            }
        ],
        424: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CsvParserStream = r.ParserOptions = r.parseFile = r.parseStream = r.parseString = r.parse = r.FormatterOptions = r.CsvFormatterStream = r.writeToPath = r.writeToString = r.writeToBuffer = r.writeToStream = r.write = r.format = void 0;
                var n = e("@fast-csv/format");
                Object.defineProperty(r, "format", {
                    enumerable: !0,
                    get: function() {
                        return n.format;
                    }
                }), Object.defineProperty(r, "write", {
                    enumerable: !0,
                    get: function() {
                        return n.write;
                    }
                }), Object.defineProperty(r, "writeToStream", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToStream;
                    }
                }), Object.defineProperty(r, "writeToBuffer", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToBuffer;
                    }
                }), Object.defineProperty(r, "writeToString", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToString;
                    }
                }), Object.defineProperty(r, "writeToPath", {
                    enumerable: !0,
                    get: function() {
                        return n.writeToPath;
                    }
                }), Object.defineProperty(r, "CsvFormatterStream", {
                    enumerable: !0,
                    get: function() {
                        return n.CsvFormatterStream;
                    }
                }), Object.defineProperty(r, "FormatterOptions", {
                    enumerable: !0,
                    get: function() {
                        return n.FormatterOptions;
                    }
                });
                var i = e("@fast-csv/parse");
                Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return i.parse;
                    }
                }), Object.defineProperty(r, "parseString", {
                    enumerable: !0,
                    get: function() {
                        return i.parseString;
                    }
                }), Object.defineProperty(r, "parseStream", {
                    enumerable: !0,
                    get: function() {
                        return i.parseStream;
                    }
                }), Object.defineProperty(r, "parseFile", {
                    enumerable: !0,
                    get: function() {
                        return i.parseFile;
                    }
                }), Object.defineProperty(r, "ParserOptions", {
                    enumerable: !0,
                    get: function() {
                        return i.ParserOptions;
                    }
                }), Object.defineProperty(r, "CsvParserStream", {
                    enumerable: !0,
                    get: function() {
                        return i.CsvParserStream;
                    }
                });
            },
            {
                "@fast-csv/format": 151,
                "@fast-csv/parse": 155
            }
        ],
        425: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("readable-stream").Transform;
                function s(e) {
                    i.call(this), this._block = n.allocUnsafe(e), this._blockSize = e, this._blockOffset = 0, this._length = [
                        0,
                        0,
                        0,
                        0
                    ], this._finalized = !1;
                }
                e("inherits")(s, i), s.prototype._transform = function(e, t, r) {
                    var n = null;
                    try {
                        this.update(e, t);
                    } catch (e) {
                        n = e;
                    }
                    r(n);
                }, s.prototype._flush = function(e) {
                    var t = null;
                    try {
                        this.push(this.digest());
                    } catch (e) {
                        t = e;
                    }
                    e(t);
                }, s.prototype.update = function(e, t) {
                    if (function(e, t) {
                        if (!n.isBuffer(e) && "string" != typeof e) throw new TypeError(t + " must be a string or a buffer");
                    }(e, "Data"), this._finalized) throw new Error("Digest already called");
                    n.isBuffer(e) || (e = n.from(e, t));
                    for(var r = this._block, i = 0; this._blockOffset + e.length - i >= this._blockSize;){
                        for(var s = this._blockOffset; s < this._blockSize;)r[s++] = e[i++];
                        this._update(), this._blockOffset = 0;
                    }
                    for(; i < e.length;)r[this._blockOffset++] = e[i++];
                    for(var o = 0, a = 8 * e.length; a > 0; ++o)this._length[o] += a, (a = this._length[o] / 4294967296 | 0) > 0 && (this._length[o] -= 4294967296 * a);
                    return this;
                }, s.prototype._update = function() {
                    throw new Error("_update is not implemented");
                }, s.prototype.digest = function(e) {
                    if (this._finalized) throw new Error("Digest already called");
                    this._finalized = !0;
                    var t = this._digest();
                    void 0 !== e && (t = t.toString(e)), this._block.fill(0), this._blockOffset = 0;
                    for(var r = 0; r < 4; ++r)this._length[r] = 0;
                    return t;
                }, s.prototype._digest = function() {
                    throw new Error("_digest is not implemented");
                }, t.exports = s;
            },
            {
                inherits: 440,
                "readable-stream": 491,
                "safe-buffer": 494
            }
        ],
        426: [
            function(e, t, r) {
                "use strict";
                var n = r;
                n.utils = e("./hash/utils"), n.common = e("./hash/common"), n.sha = e("./hash/sha"), n.ripemd = e("./hash/ripemd"), n.hmac = e("./hash/hmac"), n.sha1 = n.sha.sha1, n.sha256 = n.sha.sha256, n.sha224 = n.sha.sha224, n.sha384 = n.sha.sha384, n.sha512 = n.sha.sha512, n.ripemd160 = n.ripemd.ripemd160;
            },
            {
                "./hash/common": 427,
                "./hash/hmac": 428,
                "./hash/ripemd": 429,
                "./hash/sha": 430,
                "./hash/utils": 437
            }
        ],
        427: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s() {
                    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
                }
                r.BlockHash = s, s.prototype.update = function(e, t) {
                    if (e = n.toArray(e, t), this.pending ? this.pending = this.pending.concat(e) : this.pending = e, this.pendingTotal += e.length, this.pending.length >= this._delta8) {
                        var r = (e = this.pending).length % this._delta8;
                        this.pending = e.slice(e.length - r, e.length), 0 === this.pending.length && (this.pending = null), e = n.join32(e, 0, e.length - r, this.endian);
                        for(var i = 0; i < e.length; i += this._delta32)this._update(e, i, i + this._delta32);
                    }
                    return this;
                }, s.prototype.digest = function(e) {
                    return this.update(this._pad()), i(null === this.pending), this._digest(e);
                }, s.prototype._pad = function() {
                    var e = this.pendingTotal, t = this._delta8, r = t - (e + this.padLength) % t, n = new Array(r + this.padLength);
                    n[0] = 128;
                    for(var i = 1; i < r; i++)n[i] = 0;
                    if (e <<= 3, "big" === this.endian) {
                        for(var s = 8; s < this.padLength; s++)n[i++] = 0;
                        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = e >>> 24 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 8 & 255, n[i++] = 255 & e;
                    } else for(n[i++] = 255 & e, n[i++] = e >>> 8 & 255, n[i++] = e >>> 16 & 255, n[i++] = e >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, s = 8; s < this.padLength; s++)n[i++] = 0;
                    return n;
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        428: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("minimalistic-assert");
                function s(e, t, r) {
                    if (!(this instanceof s)) return new s(e, t, r);
                    this.Hash = e, this.blockSize = e.blockSize / 8, this.outSize = e.outSize / 8, this.inner = null, this.outer = null, this._init(n.toArray(t, r));
                }
                t.exports = s, s.prototype._init = function(e) {
                    e.length > this.blockSize && (e = (new this.Hash).update(e).digest()), i(e.length <= this.blockSize);
                    for(var t = e.length; t < this.blockSize; t++)e.push(0);
                    for(t = 0; t < e.length; t++)e[t] ^= 54;
                    for(this.inner = (new this.Hash).update(e), t = 0; t < e.length; t++)e[t] ^= 106;
                    this.outer = (new this.Hash).update(e);
                }, s.prototype.update = function(e, t) {
                    return this.inner.update(e, t), this;
                }, s.prototype.digest = function(e) {
                    return this.outer.update(this.inner.digest()), this.outer.digest(e);
                };
            },
            {
                "./utils": 437,
                "minimalistic-assert": 453
            }
        ],
        429: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils"), i = e("./common"), s = n.rotl32, o = n.sum32, a = n.sum32_3, l = n.sum32_4, c = i.BlockHash;
                function u() {
                    if (!(this instanceof u)) return new u;
                    c.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.endian = "little";
                }
                function h(e, t, r, n) {
                    return e <= 15 ? t ^ r ^ n : e <= 31 ? t & r | ~t & n : e <= 47 ? (t | ~r) ^ n : e <= 63 ? t & n | r & ~n : t ^ (r | ~n);
                }
                function f(e) {
                    return e <= 15 ? 0 : e <= 31 ? 1518500249 : e <= 47 ? 1859775393 : e <= 63 ? 2400959708 : 2840853838;
                }
                function d(e) {
                    return e <= 15 ? 1352829926 : e <= 31 ? 1548603684 : e <= 47 ? 1836072691 : e <= 63 ? 2053994217 : 0;
                }
                n.inherits(u, c), r.ripemd160 = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 192, u.padLength = 64, u.prototype._update = function(e, t) {
                    for(var r = this.h[0], n = this.h[1], i = this.h[2], c = this.h[3], u = this.h[4], y = r, v = n, w = i, _ = c, x = u, k = 0; k < 80; k++){
                        var S = o(s(l(r, h(k, n, i, c), e[p[k] + t], f(k)), b[k]), u);
                        r = u, u = c, c = s(i, 10), i = n, n = S, S = o(s(l(y, h(79 - k, v, w, _), e[m[k] + t], d(k)), g[k]), x), y = x, x = _, _ = s(w, 10), w = v, v = S;
                    }
                    S = a(this.h[1], i, _), this.h[1] = a(this.h[2], c, x), this.h[2] = a(this.h[3], u, y), this.h[3] = a(this.h[4], r, v), this.h[4] = a(this.h[0], n, w), this.h[0] = S;
                }, u.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "little") : n.split32(this.h, "little");
                };
                var p = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], m = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], b = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], g = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ];
            },
            {
                "./common": 427,
                "./utils": 437
            }
        ],
        430: [
            function(e, t, r) {
                "use strict";
                r.sha1 = e("./sha/1"), r.sha224 = e("./sha/224"), r.sha256 = e("./sha/256"), r.sha384 = e("./sha/384"), r.sha512 = e("./sha/512");
            },
            {
                "./sha/1": 431,
                "./sha/224": 432,
                "./sha/256": 433,
                "./sha/384": 434,
                "./sha/512": 435
            }
        ],
        431: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = n.rotl32, a = n.sum32, l = n.sum32_5, c = s.ft_1, u = i.BlockHash, h = [
                    1518500249,
                    1859775393,
                    2400959708,
                    3395469782
                ];
                function f() {
                    if (!(this instanceof f)) return new f;
                    u.call(this), this.h = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ], this.W = new Array(80);
                }
                n.inherits(f, u), t.exports = f, f.blockSize = 512, f.outSize = 160, f.hmacStrength = 80, f.padLength = 64, f.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = o(r[n - 3] ^ r[n - 8] ^ r[n - 14] ^ r[n - 16], 1);
                    var i = this.h[0], s = this.h[1], u = this.h[2], f = this.h[3], d = this.h[4];
                    for(n = 0; n < r.length; n++){
                        var p = ~~(n / 20), m = l(o(i, 5), c(p, s, u, f), d, r[n], h[p]);
                        d = f, f = u, u = o(s, 30), s = i, i = m;
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], u), this.h[3] = a(this.h[3], f), this.h[4] = a(this.h[4], d);
                }, f.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436
            }
        ],
        432: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./256");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3238371032,
                        914150663,
                        812702999,
                        4144912697,
                        4290775857,
                        1750603025,
                        1694076839,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 512, s.outSize = 224, s.hmacStrength = 192, s.padLength = 64, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 7), "big") : n.split32(this.h.slice(0, 7), "big");
                };
            },
            {
                "../utils": 437,
                "./256": 433
            }
        ],
        433: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("./common"), o = e("minimalistic-assert"), a = n.sum32, l = n.sum32_4, c = n.sum32_5, u = s.ch32, h = s.maj32, f = s.s0_256, d = s.s1_256, p = s.g0_256, m = s.g1_256, b = i.BlockHash, g = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ];
                function y() {
                    if (!(this instanceof y)) return new y;
                    b.call(this), this.h = [
                        1779033703,
                        3144134277,
                        1013904242,
                        2773480762,
                        1359893119,
                        2600822924,
                        528734635,
                        1541459225
                    ], this.k = g, this.W = new Array(64);
                }
                n.inherits(y, b), t.exports = y, y.blockSize = 512, y.outSize = 256, y.hmacStrength = 192, y.padLength = 64, y.prototype._update = function(e, t) {
                    for(var r = this.W, n = 0; n < 16; n++)r[n] = e[t + n];
                    for(; n < r.length; n++)r[n] = l(m(r[n - 2]), r[n - 7], p(r[n - 15]), r[n - 16]);
                    var i = this.h[0], s = this.h[1], b = this.h[2], g = this.h[3], y = this.h[4], v = this.h[5], w = this.h[6], _ = this.h[7];
                    for(o(this.k.length === r.length), n = 0; n < r.length; n++){
                        var x = c(_, d(y), u(y, v, w), this.k[n], r[n]), k = a(f(i), h(i, s, b));
                        _ = w, w = v, v = y, y = a(g, x), g = b, b = s, s = i, i = a(x, k);
                    }
                    this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], s), this.h[2] = a(this.h[2], b), this.h[3] = a(this.h[3], g), this.h[4] = a(this.h[4], y), this.h[5] = a(this.h[5], v), this.h[6] = a(this.h[6], w), this.h[7] = a(this.h[7], _);
                }, y.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "./common": 436,
                "minimalistic-assert": 453
            }
        ],
        434: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./512");
                function s() {
                    if (!(this instanceof s)) return new s;
                    i.call(this), this.h = [
                        3418070365,
                        3238371032,
                        1654270250,
                        914150663,
                        2438529370,
                        812702999,
                        355462360,
                        4144912697,
                        1731405415,
                        4290775857,
                        2394180231,
                        1750603025,
                        3675008525,
                        1694076839,
                        1203062813,
                        3204075428
                    ];
                }
                n.inherits(s, i), t.exports = s, s.blockSize = 1024, s.outSize = 384, s.hmacStrength = 192, s.padLength = 128, s.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h.slice(0, 12), "big") : n.split32(this.h.slice(0, 12), "big");
                };
            },
            {
                "../utils": 437,
                "./512": 435
            }
        ],
        435: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../common"), s = e("minimalistic-assert"), o = n.rotr64_hi, a = n.rotr64_lo, l = n.shr64_hi, c = n.shr64_lo, u = n.sum64, h = n.sum64_hi, f = n.sum64_lo, d = n.sum64_4_hi, p = n.sum64_4_lo, m = n.sum64_5_hi, b = n.sum64_5_lo, g = i.BlockHash, y = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ];
                function v() {
                    if (!(this instanceof v)) return new v;
                    g.call(this), this.h = [
                        1779033703,
                        4089235720,
                        3144134277,
                        2227873595,
                        1013904242,
                        4271175723,
                        2773480762,
                        1595750129,
                        1359893119,
                        2917565137,
                        2600822924,
                        725511199,
                        528734635,
                        4215389547,
                        1541459225,
                        327033209
                    ], this.k = y, this.W = new Array(160);
                }
                function w(e, t, r, n, i) {
                    var s = e & r ^ ~e & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function _(e, t, r, n, i, s) {
                    var o = t & n ^ ~t & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function x(e, t, r, n, i) {
                    var s = e & r ^ e & i ^ r & i;
                    return s < 0 && (s += 4294967296), s;
                }
                function k(e, t, r, n, i, s) {
                    var o = t & n ^ t & s ^ n & s;
                    return o < 0 && (o += 4294967296), o;
                }
                function S(e, t) {
                    var r = o(e, t, 28) ^ o(t, e, 2) ^ o(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function M(e, t) {
                    var r = a(e, t, 28) ^ a(t, e, 2) ^ a(t, e, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function C(e, t) {
                    var r = o(e, t, 14) ^ o(e, t, 18) ^ o(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function T(e, t) {
                    var r = a(e, t, 14) ^ a(e, t, 18) ^ a(t, e, 9);
                    return r < 0 && (r += 4294967296), r;
                }
                function E(e, t) {
                    var r = o(e, t, 1) ^ o(e, t, 8) ^ l(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function A(e, t) {
                    var r = a(e, t, 1) ^ a(e, t, 8) ^ c(e, t, 7);
                    return r < 0 && (r += 4294967296), r;
                }
                function R(e, t) {
                    var r = o(e, t, 19) ^ o(t, e, 29) ^ l(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                function O(e, t) {
                    var r = a(e, t, 19) ^ a(t, e, 29) ^ c(e, t, 6);
                    return r < 0 && (r += 4294967296), r;
                }
                n.inherits(v, g), t.exports = v, v.blockSize = 1024, v.outSize = 512, v.hmacStrength = 192, v.padLength = 128, v.prototype._prepareBlock = function(e, t) {
                    for(var r = this.W, n = 0; n < 32; n++)r[n] = e[t + n];
                    for(; n < r.length; n += 2){
                        var i = R(r[n - 4], r[n - 3]), s = O(r[n - 4], r[n - 3]), o = r[n - 14], a = r[n - 13], l = E(r[n - 30], r[n - 29]), c = A(r[n - 30], r[n - 29]), u = r[n - 32], h = r[n - 31];
                        r[n] = d(i, s, o, a, l, c, u, h), r[n + 1] = p(i, s, o, a, l, c, u, h);
                    }
                }, v.prototype._update = function(e, t) {
                    this._prepareBlock(e, t);
                    var r = this.W, n = this.h[0], i = this.h[1], o = this.h[2], a = this.h[3], l = this.h[4], c = this.h[5], d = this.h[6], p = this.h[7], g = this.h[8], y = this.h[9], v = this.h[10], E = this.h[11], A = this.h[12], R = this.h[13], O = this.h[14], j = this.h[15];
                    s(this.k.length === r.length);
                    for(var I = 0; I < r.length; I += 2){
                        var N = O, P = j, B = C(g, y), D = T(g, y), F = w(g, y, v, E, A), L = _(g, y, v, E, A, R), z = this.k[I], U = this.k[I + 1], $ = r[I], H = r[I + 1], V = m(N, P, B, D, F, L, z, U, $, H), q = b(N, P, B, D, F, L, z, U, $, H);
                        N = S(n, i), P = M(n, i), B = x(n, i, o, a, l), D = k(n, i, o, a, l, c);
                        var W = h(N, P, B, D), X = f(N, P, B, D);
                        O = A, j = R, A = v, R = E, v = g, E = y, g = h(d, p, V, q), y = f(p, p, V, q), d = l, p = c, l = o, c = a, o = n, a = i, n = h(V, q, W, X), i = f(V, q, W, X);
                    }
                    u(this.h, 0, n, i), u(this.h, 2, o, a), u(this.h, 4, l, c), u(this.h, 6, d, p), u(this.h, 8, g, y), u(this.h, 10, v, E), u(this.h, 12, A, R), u(this.h, 14, O, j);
                }, v.prototype._digest = function(e) {
                    return "hex" === e ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
                };
            },
            {
                "../common": 427,
                "../utils": 437,
                "minimalistic-assert": 453
            }
        ],
        436: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils").rotr32;
                function i(e, t, r) {
                    return e & t ^ ~e & r;
                }
                function s(e, t, r) {
                    return e & t ^ e & r ^ t & r;
                }
                function o(e, t, r) {
                    return e ^ t ^ r;
                }
                r.ft_1 = function(e, t, r, n) {
                    return 0 === e ? i(t, r, n) : 1 === e || 3 === e ? o(t, r, n) : 2 === e ? s(t, r, n) : void 0;
                }, r.ch32 = i, r.maj32 = s, r.p32 = o, r.s0_256 = function(e) {
                    return n(e, 2) ^ n(e, 13) ^ n(e, 22);
                }, r.s1_256 = function(e) {
                    return n(e, 6) ^ n(e, 11) ^ n(e, 25);
                }, r.g0_256 = function(e) {
                    return n(e, 7) ^ n(e, 18) ^ e >>> 3;
                }, r.g1_256 = function(e) {
                    return n(e, 17) ^ n(e, 19) ^ e >>> 10;
                };
            },
            {
                "../utils": 437
            }
        ],
        437: [
            function(e, t, r) {
                "use strict";
                var n = e("minimalistic-assert"), i = e("inherits");
                function s(e, t) {
                    return 55296 == (64512 & e.charCodeAt(t)) && !(t < 0 || t + 1 >= e.length) && 56320 == (64512 & e.charCodeAt(t + 1));
                }
                function o(e) {
                    return (e >>> 24 | e >>> 8 & 65280 | e << 8 & 16711680 | (255 & e) << 24) >>> 0;
                }
                function a(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function l(e) {
                    return 7 === e.length ? "0" + e : 6 === e.length ? "00" + e : 5 === e.length ? "000" + e : 4 === e.length ? "0000" + e : 3 === e.length ? "00000" + e : 2 === e.length ? "000000" + e : 1 === e.length ? "0000000" + e : e;
                }
                r.inherits = i, r.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" == typeof e) {
                        if (t) {
                            if ("hex" === t) for((e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e), i = 0; i < e.length; i += 2)r.push(parseInt(e[i] + e[i + 1], 16));
                        } else for(var n = 0, i = 0; i < e.length; i++){
                            var o = e.charCodeAt(i);
                            o < 128 ? r[n++] = o : o < 2048 ? (r[n++] = o >> 6 | 192, r[n++] = 63 & o | 128) : s(e, i) ? (o = 65536 + ((1023 & o) << 10) + (1023 & e.charCodeAt(++i)), r[n++] = o >> 18 | 240, r[n++] = o >> 12 & 63 | 128, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128) : (r[n++] = o >> 12 | 224, r[n++] = o >> 6 & 63 | 128, r[n++] = 63 & o | 128);
                        }
                    } else for(i = 0; i < e.length; i++)r[i] = 0 | e[i];
                    return r;
                }, r.toHex = function(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += a(e[r].toString(16));
                    return t;
                }, r.htonl = o, r.toHex32 = function(e, t) {
                    for(var r = "", n = 0; n < e.length; n++){
                        var i = e[n];
                        "little" === t && (i = o(i)), r += l(i.toString(16));
                    }
                    return r;
                }, r.zero2 = a, r.zero8 = l, r.join32 = function(e, t, r, i) {
                    var s = r - t;
                    n(s % 4 == 0);
                    for(var o = new Array(s / 4), a = 0, l = t; a < o.length; a++, l += 4){
                        var c;
                        c = "big" === i ? e[l] << 24 | e[l + 1] << 16 | e[l + 2] << 8 | e[l + 3] : e[l + 3] << 24 | e[l + 2] << 16 | e[l + 1] << 8 | e[l], o[a] = c >>> 0;
                    }
                    return o;
                }, r.split32 = function(e, t) {
                    for(var r = new Array(4 * e.length), n = 0, i = 0; n < e.length; n++, i += 4){
                        var s = e[n];
                        "big" === t ? (r[i] = s >>> 24, r[i + 1] = s >>> 16 & 255, r[i + 2] = s >>> 8 & 255, r[i + 3] = 255 & s) : (r[i + 3] = s >>> 24, r[i + 2] = s >>> 16 & 255, r[i + 1] = s >>> 8 & 255, r[i] = 255 & s);
                    }
                    return r;
                }, r.rotr32 = function(e, t) {
                    return e >>> t | e << 32 - t;
                }, r.rotl32 = function(e, t) {
                    return e << t | e >>> 32 - t;
                }, r.sum32 = function(e, t) {
                    return e + t >>> 0;
                }, r.sum32_3 = function(e, t, r) {
                    return e + t + r >>> 0;
                }, r.sum32_4 = function(e, t, r, n) {
                    return e + t + r + n >>> 0;
                }, r.sum32_5 = function(e, t, r, n, i) {
                    return e + t + r + n + i >>> 0;
                }, r.sum64 = function(e, t, r, n) {
                    var i = e[t], s = n + e[t + 1] >>> 0, o = (s < n ? 1 : 0) + r + i;
                    e[t] = o >>> 0, e[t + 1] = s;
                }, r.sum64_hi = function(e, t, r, n) {
                    return (t + n >>> 0 < t ? 1 : 0) + e + r >>> 0;
                }, r.sum64_lo = function(e, t, r, n) {
                    return t + n >>> 0;
                }, r.sum64_4_hi = function(e, t, r, n, i, s, o, a) {
                    var l = 0, c = t;
                    return l += (c = c + n >>> 0) < t ? 1 : 0, l += (c = c + s >>> 0) < s ? 1 : 0, e + r + i + o + (l += (c = c + a >>> 0) < a ? 1 : 0) >>> 0;
                }, r.sum64_4_lo = function(e, t, r, n, i, s, o, a) {
                    return t + n + s + a >>> 0;
                }, r.sum64_5_hi = function(e, t, r, n, i, s, o, a, l, c) {
                    var u = 0, h = t;
                    return u += (h = h + n >>> 0) < t ? 1 : 0, u += (h = h + s >>> 0) < s ? 1 : 0, u += (h = h + a >>> 0) < a ? 1 : 0, e + r + i + o + l + (u += (h = h + c >>> 0) < c ? 1 : 0) >>> 0;
                }, r.sum64_5_lo = function(e, t, r, n, i, s, o, a, l, c) {
                    return t + n + s + a + c >>> 0;
                }, r.rotr64_hi = function(e, t, r) {
                    return (t << 32 - r | e >>> r) >>> 0;
                }, r.rotr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                }, r.shr64_hi = function(e, t, r) {
                    return e >>> r;
                }, r.shr64_lo = function(e, t, r) {
                    return (e << 32 - r | t >>> r) >>> 0;
                };
            },
            {
                inherits: 440,
                "minimalistic-assert": 453
            }
        ],
        438: [
            function(e, t, r) {
                "use strict";
                var n = e("hash.js"), i = e("minimalistic-crypto-utils"), s = e("minimalistic-assert");
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    this.hash = e.hash, this.predResist = !!e.predResist, this.outLen = this.hash.outSize, this.minEntropy = e.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
                    var t = i.toArray(e.entropy, e.entropyEnc || "hex"), r = i.toArray(e.nonce, e.nonceEnc || "hex"), n = i.toArray(e.pers, e.persEnc || "hex");
                    s(t.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._init(t, r, n);
                }
                t.exports = o, o.prototype._init = function(e, t, r) {
                    var n = e.concat(t).concat(r);
                    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
                    for(var i = 0; i < this.V.length; i++)this.K[i] = 0, this.V[i] = 1;
                    this._update(n), this._reseed = 1, this.reseedInterval = 281474976710656;
                }, o.prototype._hmac = function() {
                    return new n.hmac(this.hash, this.K);
                }, o.prototype._update = function(e) {
                    var t = this._hmac().update(this.V).update([
                        0
                    ]);
                    e && (t = t.update(e)), this.K = t.digest(), this.V = this._hmac().update(this.V).digest(), e && (this.K = this._hmac().update(this.V).update([
                        1
                    ]).update(e).digest(), this.V = this._hmac().update(this.V).digest());
                }, o.prototype.reseed = function(e, t, r, n) {
                    "string" != typeof t && (n = r, r = t, t = null), e = i.toArray(e, t), r = i.toArray(r, n), s(e.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits"), this._update(e.concat(r || [])), this._reseed = 1;
                }, o.prototype.generate = function(e, t, r, n) {
                    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
                    "string" != typeof t && (n = r, r = t, t = null), r && (r = i.toArray(r, n || "hex"), this._update(r));
                    for(var s = []; s.length < e;)this.V = this._hmac().update(this.V).digest(), s = s.concat(this.V);
                    var o = s.slice(0, e);
                    return this._update(r), this._reseed++, i.encode(o, t);
                };
            },
            {
                "hash.js": 426,
                "minimalistic-assert": 453,
                "minimalistic-crypto-utils": 454
            }
        ],
        439: [
            function(e, t, r) {
                "use strict";
                /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ r.read = function(e, t, r, n, i) {
                    var s, o, a = 8 * i - n - 1, l = (1 << a) - 1, c = l >> 1, u = -7, h = r ? i - 1 : 0, f = r ? -1 : 1, d = e[t + h];
                    for(h += f, s = d & (1 << -u) - 1, d >>= -u, u += a; u > 0; s = 256 * s + e[t + h], h += f, u -= 8);
                    for(o = s & (1 << -u) - 1, s >>= -u, u += n; u > 0; o = 256 * o + e[t + h], h += f, u -= 8);
                    if (0 === s) s = 1 - c;
                    else {
                        if (s === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
                        o += Math.pow(2, n), s -= c;
                    }
                    return (d ? -1 : 1) * o * Math.pow(2, s - n);
                }, r.write = function(e, t, r, n, i, s) {
                    var o, a, l, c = 8 * s - i - 1, u = (1 << c) - 1, h = u >> 1, f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : s - 1, p = n ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                    for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + h >= 1 ? f / l : f * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= u ? (a = 0, o = u) : o + h >= 1 ? (a = (t * l - 1) * Math.pow(2, i), o += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + d] = 255 & a, d += p, a /= 256, i -= 8);
                    for(o = o << i | a, c += i; c > 0; e[r + d] = 255 & o, d += p, o /= 256, c -= 8);
                    e[r + d - p] |= 128 * m;
                };
            },
            {}
        ],
        440: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    t && (e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }));
                } : t.exports = function(e, t) {
                    if (t) {
                        e.super_ = t;
                        var r = function() {};
                        r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                    }
                };
            },
            {}
        ],
        441: [
            function(e, t, r) {
                (function(n, i, s, o, a, l, c, u) {
                    (function() {
                        "use strict";
                        /*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ !function(e) {
                            "object" == typeof r && void 0 !== t ? t.exports = e() : ("undefined" != typeof window ? window : void 0 !== i ? i : "undefined" != typeof self ? self : this).JSZip = e();
                        }(function() {
                            return (function t(r, n, i) {
                                function s(a, l) {
                                    if (!n[a]) {
                                        if (!r[a]) {
                                            var c = "function" == typeof e && e;
                                            if (!l && c) return c(a, !0);
                                            if (o) return o(a, !0);
                                            var u = new Error("Cannot find module '" + a + "'");
                                            throw u.code = "MODULE_NOT_FOUND", u;
                                        }
                                        var h = n[a] = {
                                            exports: {}
                                        };
                                        r[a][0].call(h.exports, function(e) {
                                            return s(r[a][1][e] || e);
                                        }, h, h.exports, t, r, n, i);
                                    }
                                    return n[a].exports;
                                }
                                for(var o = "function" == typeof e && e, a = 0; a < i.length; a++)s(i[a]);
                                return s;
                            })({
                                1: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./support"), s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                                        r.encode = function(e) {
                                            for(var t, r, i, o, a, l, c, u = [], h = 0, f = e.length, d = f, p = "string" !== n.getTypeOf(e); h < e.length;)d = f - h, i = p ? (t = e[h++], r = h < f ? e[h++] : 0, h < f ? e[h++] : 0) : (t = e.charCodeAt(h++), r = h < f ? e.charCodeAt(h++) : 0, h < f ? e.charCodeAt(h++) : 0), o = t >> 2, a = (3 & t) << 4 | r >> 4, l = 1 < d ? (15 & r) << 2 | i >> 6 : 64, c = 2 < d ? 63 & i : 64, u.push(s.charAt(o) + s.charAt(a) + s.charAt(l) + s.charAt(c));
                                            return u.join("");
                                        }, r.decode = function(e) {
                                            var t, r, n, o, a, l, c = 0, u = 0, h = "data:";
                                            if (e.substr(0, h.length) === h) throw new Error("Invalid base64 input, it looks like a data url.");
                                            var f, d = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                                            if (e.charAt(e.length - 1) === s.charAt(64) && d--, e.charAt(e.length - 2) === s.charAt(64) && d--, d % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                                            for(f = i.uint8array ? new Uint8Array(0 | d) : new Array(0 | d); c < e.length;)t = s.indexOf(e.charAt(c++)) << 2 | (o = s.indexOf(e.charAt(c++))) >> 4, r = (15 & o) << 4 | (a = s.indexOf(e.charAt(c++))) >> 2, n = (3 & a) << 6 | (l = s.indexOf(e.charAt(c++))), f[u++] = t, 64 !== a && (f[u++] = r), 64 !== l && (f[u++] = n);
                                            return f;
                                        };
                                    },
                                    {
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                2: [
                                    function(e, t, r) {
                                        var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), o = e("./stream/DataLengthProbe");
                                        function a(e, t, r, n, i) {
                                            this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                                        }
                                        a.prototype = {
                                            getContentWorker: function() {
                                                var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new o("data_length")), t = this;
                                                return e.on("end", function() {
                                                    if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                                                }), e;
                                            },
                                            getCompressedWorker: function() {
                                                return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                                            }
                                        }, a.createWorkerFrom = function(e, t, r) {
                                            return e.pipe(new s).pipe(new o("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new o("compressedSize")).withStreamInfo("compression", t);
                                        }, t.exports = a;
                                    },
                                    {
                                        "./external": 6,
                                        "./stream/Crc32Probe": 25,
                                        "./stream/DataLengthProbe": 26,
                                        "./stream/DataWorker": 27
                                    }
                                ],
                                3: [
                                    function(e, t, r) {
                                        var n = e("./stream/GenericWorker");
                                        r.STORE = {
                                            magic: "\0\0",
                                            compressWorker: function() {
                                                return new n("STORE compression");
                                            },
                                            uncompressWorker: function() {
                                                return new n("STORE decompression");
                                            }
                                        }, r.DEFLATE = e("./flate");
                                    },
                                    {
                                        "./flate": 7,
                                        "./stream/GenericWorker": 28
                                    }
                                ],
                                4: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t) {
                                            return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : function(e, t, r, n) {
                                                var s = i, o = 0 + r;
                                                e ^= -1;
                                                for(var a = 0; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t.charCodeAt(a))];
                                                return -1 ^ e;
                                            }(0 | t, e, e.length) : 0;
                                        };
                                    },
                                    {
                                        "./utils": 32
                                    }
                                ],
                                5: [
                                    function(e, t, r) {
                                        r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
                                    },
                                    {}
                                ],
                                6: [
                                    function(e, t, r) {
                                        var n;
                                        n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                                            Promise: n
                                        };
                                    },
                                    {
                                        lie: 37
                                    }
                                ],
                                7: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), o = e("./stream/GenericWorker"), a = n ? "uint8array" : "array";
                                        function l(e, t) {
                                            o.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                                        }
                                        r.magic = "\b\0", s.inherits(l, o), l.prototype.processChunk = function(e) {
                                            this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(a, e.data), !1);
                                        }, l.prototype.flush = function() {
                                            o.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                                        }, l.prototype.cleanUp = function() {
                                            o.prototype.cleanUp.call(this), this._pako = null;
                                        }, l.prototype._createPako = function() {
                                            this._pako = new i[this._pakoAction]({
                                                raw: !0,
                                                level: this._pakoOptions.level || -1
                                            });
                                            var e = this;
                                            this._pako.onData = function(t) {
                                                e.push({
                                                    data: t,
                                                    meta: e.meta
                                                });
                                            };
                                        }, r.compressWorker = function(e) {
                                            return new l("Deflate", e);
                                        }, r.uncompressWorker = function() {
                                            return new l("Inflate", {});
                                        };
                                    },
                                    {
                                        "./stream/GenericWorker": 28,
                                        "./utils": 32,
                                        pako: 38
                                    }
                                ],
                                8: [
                                    function(e, t, r) {
                                        function n(e, t) {
                                            var r, n = "";
                                            for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                                            return n;
                                        }
                                        function i(e, t, r, i, o, u) {
                                            var h, f, d = e.file, p = e.compression, m = u !== a.utf8encode, b = s.transformTo("string", u(d.name)), g = s.transformTo("string", a.utf8encode(d.name)), y = d.comment, v = s.transformTo("string", u(y)), w = s.transformTo("string", a.utf8encode(y)), _ = g.length !== d.name.length, x = w.length !== y.length, k = "", S = "", M = "", C = d.dir, T = d.date, E = {
                                                crc32: 0,
                                                compressedSize: 0,
                                                uncompressedSize: 0
                                            };
                                            t && !r || (E.crc32 = e.crc32, E.compressedSize = e.compressedSize, E.uncompressedSize = e.uncompressedSize);
                                            var A = 0;
                                            t && (A |= 8), m || !_ && !x || (A |= 2048);
                                            var R = 0, O = 0;
                                            C && (R |= 16), "UNIX" === o ? (O = 798, R |= function(e, t) {
                                                var r = e;
                                                return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                                            }(d.unixPermissions, C)) : (O = 20, R |= function(e) {
                                                return 63 & (e || 0);
                                            }(d.dosPermissions)), h = T.getUTCHours(), h <<= 6, h |= T.getUTCMinutes(), h <<= 5, h |= T.getUTCSeconds() / 2, f = T.getUTCFullYear() - 1980, f <<= 4, f |= T.getUTCMonth() + 1, f <<= 5, f |= T.getUTCDate(), _ && (S = n(1, 1) + n(l(b), 4) + g, k += "up" + n(S.length, 2) + S), x && (M = n(1, 1) + n(l(v), 4) + w, k += "uc" + n(M.length, 2) + M);
                                            var j = "";
                                            return j += "\n\0", j += n(A, 2), j += p.magic, j += n(h, 2), j += n(f, 2), j += n(E.crc32, 4), j += n(E.compressedSize, 4), j += n(E.uncompressedSize, 4), j += n(b.length, 2), j += n(k.length, 2), {
                                                fileRecord: c.LOCAL_FILE_HEADER + j + b + k,
                                                dirRecord: c.CENTRAL_FILE_HEADER + n(O, 2) + j + n(v.length, 2) + "\0\0\0\0" + n(R, 4) + n(i, 4) + b + k + v
                                            };
                                        }
                                        var s = e("../utils"), o = e("../stream/GenericWorker"), a = e("../utf8"), l = e("../crc32"), c = e("../signature");
                                        function u(e, t, r, n) {
                                            o.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                                        }
                                        s.inherits(u, o), u.prototype.push = function(e) {
                                            var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                                            this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, o.prototype.push.call(this, {
                                                data: e.data,
                                                meta: {
                                                    currentFile: this.currentFile,
                                                    percent: r ? (t + 100 * (r - n - 1)) / r : 100
                                                }
                                            }));
                                        }, u.prototype.openedSource = function(e) {
                                            this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                                            var t = this.streamFiles && !e.file.dir;
                                            if (t) {
                                                var r = i(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                                this.push({
                                                    data: r.fileRecord,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            } else this.accumulate = !0;
                                        }, u.prototype.closedSource = function(e) {
                                            this.accumulate = !1;
                                            var t = this.streamFiles && !e.file.dir, r = i(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                                            if (this.dirRecords.push(r.dirRecord), t) this.push({
                                                data: function(e) {
                                                    return c.DATA_DESCRIPTOR + n(e.crc32, 4) + n(e.compressedSize, 4) + n(e.uncompressedSize, 4);
                                                }(e),
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            else for(this.push({
                                                data: r.fileRecord,
                                                meta: {
                                                    percent: 0
                                                }
                                            }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                                            this.currentFile = null;
                                        }, u.prototype.flush = function() {
                                            for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                                                data: this.dirRecords[t],
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                            var r = this.bytesWritten - e, i = function(e, t, r, i, o) {
                                                var a = s.transformTo("string", o(i));
                                                return c.CENTRAL_DIRECTORY_END + "\0\0\0\0" + n(e, 2) + n(e, 2) + n(t, 4) + n(r, 4) + n(a.length, 2) + a;
                                            }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                                            this.push({
                                                data: i,
                                                meta: {
                                                    percent: 100
                                                }
                                            });
                                        }, u.prototype.prepareNextSource = function() {
                                            this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                                        }, u.prototype.registerPrevious = function(e) {
                                            this._sources.push(e);
                                            var t = this;
                                            return e.on("data", function(e) {
                                                t.processChunk(e);
                                            }), e.on("end", function() {
                                                t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                                            }), e.on("error", function(e) {
                                                t.error(e);
                                            }), this;
                                        }, u.prototype.resume = function() {
                                            return !!o.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                                        }, u.prototype.error = function(e) {
                                            var t = this._sources;
                                            if (!o.prototype.error.call(this, e)) return !1;
                                            for(var r = 0; r < t.length; r++)try {
                                                t[r].error(e);
                                            } catch (e) {}
                                            return !0;
                                        }, u.prototype.lock = function() {
                                            o.prototype.lock.call(this);
                                            for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                                        }, t.exports = u;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../signature": 23,
                                        "../stream/GenericWorker": 28,
                                        "../utf8": 31,
                                        "../utils": 32
                                    }
                                ],
                                9: [
                                    function(e, t, r) {
                                        var n = e("../compressions"), i = e("./ZipFileWorker");
                                        r.generateWorker = function(e, t, r) {
                                            var s = new i(t.streamFiles, r, t.platform, t.encodeFileName), o = 0;
                                            try {
                                                e.forEach(function(e, r) {
                                                    o++;
                                                    var i = function(e, t) {
                                                        var r = e || t, i = n[r];
                                                        if (!i) throw new Error(r + " is not a valid compression method !");
                                                        return i;
                                                    }(r.options.compression, t.compression), a = r.options.compressionOptions || t.compressionOptions || {}, l = r.dir, c = r.date;
                                                    r._compressWorker(i, a).withStreamInfo("file", {
                                                        name: e,
                                                        dir: l,
                                                        date: c,
                                                        comment: r.comment || "",
                                                        unixPermissions: r.unixPermissions,
                                                        dosPermissions: r.dosPermissions
                                                    }).pipe(s);
                                                }), s.entriesCount = o;
                                            } catch (e) {
                                                s.error(e);
                                            }
                                            return s;
                                        };
                                    },
                                    {
                                        "../compressions": 3,
                                        "./ZipFileWorker": 8
                                    }
                                ],
                                10: [
                                    function(e, t, r) {
                                        function n() {
                                            if (!(this instanceof n)) return new n;
                                            if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                                            this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                                                var e = new n;
                                                for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                                                return e;
                                            };
                                        }
                                        (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                                            return (new n).loadAsync(e, t);
                                        }, n.external = e("./external"), t.exports = n;
                                    },
                                    {
                                        "./defaults": 5,
                                        "./external": 6,
                                        "./load": 11,
                                        "./object": 15,
                                        "./support": 30
                                    }
                                ],
                                11: [
                                    function(e, t, r) {
                                        var n = e("./utils"), i = e("./external"), s = e("./utf8"), o = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                                        function c(e) {
                                            return new i.Promise(function(t, r) {
                                                var n = e.decompressed.getContentWorker().pipe(new a);
                                                n.on("error", function(e) {
                                                    r(e);
                                                }).on("end", function() {
                                                    n.streamInfo.crc32 !== e.decompressed.crc32 ? r(new Error("Corrupted zip : CRC32 mismatch")) : t();
                                                }).resume();
                                            });
                                        }
                                        t.exports = function(e, t) {
                                            var r = this;
                                            return t = n.extend(t || {}, {
                                                base64: !1,
                                                checkCRC32: !1,
                                                optimizedBinaryString: !1,
                                                createFolders: !1,
                                                decodeFileName: s.utf8decode
                                            }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : n.prepareContent("the loaded zip file", e, !0, t.optimizedBinaryString, t.base64).then(function(e) {
                                                var r = new o(t);
                                                return r.load(e), r;
                                            }).then(function(e) {
                                                var r = [
                                                    i.Promise.resolve(e)
                                                ], n = e.files;
                                                if (t.checkCRC32) for(var s = 0; s < n.length; s++)r.push(c(n[s]));
                                                return i.Promise.all(r);
                                            }).then(function(e) {
                                                for(var i = e.shift(), s = i.files, o = 0; o < s.length; o++){
                                                    var a = s[o], l = a.fileNameStr, c = n.resolve(a.fileNameStr);
                                                    r.file(c, a.decompressed, {
                                                        binary: !0,
                                                        optimizedBinaryString: !0,
                                                        date: a.date,
                                                        dir: a.dir,
                                                        comment: a.fileCommentStr.length ? a.fileCommentStr : null,
                                                        unixPermissions: a.unixPermissions,
                                                        dosPermissions: a.dosPermissions,
                                                        createFolders: t.createFolders
                                                    }), a.dir || (r.file(c).unsafeOriginalName = l);
                                                }
                                                return i.zipComment.length && (r.comment = i.zipComment), r;
                                            });
                                        };
                                    },
                                    {
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./stream/Crc32Probe": 25,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipEntries": 33
                                    }
                                ],
                                12: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../stream/GenericWorker");
                                        function s(e, t) {
                                            i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                                        }
                                        n.inherits(s, i), s.prototype._bindStream = function(e) {
                                            var t = this;
                                            (this._stream = e).pause(), e.on("data", function(e) {
                                                t.push({
                                                    data: e,
                                                    meta: {
                                                        percent: 0
                                                    }
                                                });
                                            }).on("error", function(e) {
                                                t.isPaused ? this.generatedError = e : t.error(e);
                                            }).on("end", function() {
                                                t.isPaused ? t._upstreamEnded = !0 : t.end();
                                            });
                                        }, s.prototype.pause = function() {
                                            return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../stream/GenericWorker": 28,
                                        "../utils": 32
                                    }
                                ],
                                13: [
                                    function(e, t, r) {
                                        var n = e("readable-stream").Readable;
                                        function i(e, t, r) {
                                            n.call(this, t), this._helper = e;
                                            var i = this;
                                            e.on("data", function(e, t) {
                                                i.push(e) || i._helper.pause(), r && r(t);
                                            }).on("error", function(e) {
                                                i.emit("error", e);
                                            }).on("end", function() {
                                                i.push(null);
                                            });
                                        }
                                        e("../utils").inherits(i, n), i.prototype._read = function() {
                                            this._helper.resume();
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "readable-stream": 16
                                    }
                                ],
                                14: [
                                    function(e, t, r) {
                                        t.exports = {
                                            isNode: void 0 !== s,
                                            newBufferFrom: function(e, t) {
                                                if (s.from && s.from !== Uint8Array.from) return s.from(e, t);
                                                if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                                                return new s(e, t);
                                            },
                                            allocBuffer: function(e) {
                                                if (s.alloc) return s.alloc(e);
                                                var t = new s(e);
                                                return t.fill(0), t;
                                            },
                                            isBuffer: function(e) {
                                                return s.isBuffer(e);
                                            },
                                            isStream: function(e) {
                                                return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                                            }
                                        };
                                    },
                                    {}
                                ],
                                15: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            var n, i = s.getTypeOf(t), a = s.extend(r || {}, l);
                                            a.date = a.date || new Date, null !== a.compression && (a.compression = a.compression.toUpperCase()), "string" == typeof a.unixPermissions && (a.unixPermissions = parseInt(a.unixPermissions, 8)), a.unixPermissions && 16384 & a.unixPermissions && (a.dir = !0), a.dosPermissions && 16 & a.dosPermissions && (a.dir = !0), a.dir && (e = m(e)), a.createFolders && (n = p(e)) && b.call(this, n, !0);
                                            var h = "string" === i && !1 === a.binary && !1 === a.base64;
                                            r && void 0 !== r.binary || (a.binary = !h), (t instanceof c && 0 === t.uncompressedSize || a.dir || !t || 0 === t.length) && (a.base64 = !1, a.binary = !0, t = "", a.compression = "STORE", i = "string");
                                            var g;
                                            g = t instanceof c || t instanceof o ? t : f.isNode && f.isStream(t) ? new d(e, t) : s.prepareContent(e, t, a.binary, a.optimizedBinaryString, a.base64);
                                            var y = new u(e, g, a);
                                            this.files[e] = y;
                                        }
                                        var i = e("./utf8"), s = e("./utils"), o = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), l = e("./defaults"), c = e("./compressedObject"), u = e("./zipObject"), h = e("./generate"), f = e("./nodejsUtils"), d = e("./nodejs/NodejsStreamInputAdapter"), p = function(e) {
                                            "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                                            var t = e.lastIndexOf("/");
                                            return 0 < t ? e.substring(0, t) : "";
                                        }, m = function(e) {
                                            return "/" !== e.slice(-1) && (e += "/"), e;
                                        }, b = function(e, t) {
                                            return t = void 0 !== t ? t : l.createFolders, e = m(e), this.files[e] || n.call(this, e, null, {
                                                dir: !0,
                                                createFolders: t
                                            }), this.files[e];
                                        };
                                        function g(e) {
                                            return "[object RegExp]" === Object.prototype.toString.call(e);
                                        }
                                        var y = {
                                            load: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            forEach: function(e) {
                                                var t, r, n;
                                                for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                                            },
                                            filter: function(e) {
                                                var t = [];
                                                return this.forEach(function(r, n) {
                                                    e(r, n) && t.push(n);
                                                }), t;
                                            },
                                            file: function(e, t, r) {
                                                if (1 !== arguments.length) return e = this.root + e, n.call(this, e, t, r), this;
                                                if (g(e)) {
                                                    var i = e;
                                                    return this.filter(function(e, t) {
                                                        return !t.dir && i.test(e);
                                                    });
                                                }
                                                var s = this.files[this.root + e];
                                                return s && !s.dir ? s : null;
                                            },
                                            folder: function(e) {
                                                if (!e) return this;
                                                if (g(e)) return this.filter(function(t, r) {
                                                    return r.dir && e.test(t);
                                                });
                                                var t = this.root + e, r = b.call(this, t), n = this.clone();
                                                return n.root = r.name, n;
                                            },
                                            remove: function(e) {
                                                e = this.root + e;
                                                var t = this.files[e];
                                                if (t || ("/" !== e.slice(-1) && (e += "/"), t = this.files[e]), t && !t.dir) delete this.files[e];
                                                else for(var r = this.filter(function(t, r) {
                                                    return r.name.slice(0, e.length) === e;
                                                }), n = 0; n < r.length; n++)delete this.files[r[n].name];
                                                return this;
                                            },
                                            generate: function() {
                                                throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                            },
                                            generateInternalStream: function(e) {
                                                var t, r = {};
                                                try {
                                                    if ((r = s.extend(e || {}, {
                                                        streamFiles: !1,
                                                        compression: "STORE",
                                                        compressionOptions: null,
                                                        type: "",
                                                        platform: "DOS",
                                                        comment: null,
                                                        mimeType: "application/zip",
                                                        encodeFileName: i.utf8encode
                                                    })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                                                    s.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                                                    var n = r.comment || this.comment || "";
                                                    t = h.generateWorker(this, r, n);
                                                } catch (e) {
                                                    (t = new o("error")).error(e);
                                                }
                                                return new a(t, r.type || "string", r.mimeType);
                                            },
                                            generateAsync: function(e, t) {
                                                return this.generateInternalStream(e).accumulate(t);
                                            },
                                            generateNodeStream: function(e, t) {
                                                return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                                            }
                                        };
                                        t.exports = y;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./defaults": 5,
                                        "./generate": 9,
                                        "./nodejs/NodejsStreamInputAdapter": 12,
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31,
                                        "./utils": 32,
                                        "./zipObject": 35
                                    }
                                ],
                                16: [
                                    function(e, t, r) {
                                        t.exports = e("stream");
                                    },
                                    {
                                        stream: void 0
                                    }
                                ],
                                17: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                            for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data[this.zero + e];
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                                            return -1;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                                            return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                                        }, i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return [];
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                18: [
                                    function(e, t, r) {
                                        var n = e("../utils");
                                        function i(e) {
                                            this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                                        }
                                        i.prototype = {
                                            checkOffset: function(e) {
                                                this.checkIndex(this.index + e);
                                            },
                                            checkIndex: function(e) {
                                                if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                                            },
                                            setIndex: function(e) {
                                                this.checkIndex(e), this.index = e;
                                            },
                                            skip: function(e) {
                                                this.setIndex(this.index + e);
                                            },
                                            byteAt: function() {},
                                            readInt: function(e) {
                                                var t, r = 0;
                                                for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                                                return this.index += e, r;
                                            },
                                            readString: function(e) {
                                                return n.transformTo("string", this.readData(e));
                                            },
                                            readData: function() {},
                                            lastIndexOfSignature: function() {},
                                            readAndCheckSignature: function() {},
                                            readDate: function() {
                                                var e = this.readInt(4);
                                                return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                                            }
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32
                                    }
                                ],
                                19: [
                                    function(e, t, r) {
                                        var n = e("./Uint8ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                20: [
                                    function(e, t, r) {
                                        var n = e("./DataReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                                            return this.data.charCodeAt(this.zero + e);
                                        }, i.prototype.lastIndexOfSignature = function(e) {
                                            return this.data.lastIndexOf(e) - this.zero;
                                        }, i.prototype.readAndCheckSignature = function(e) {
                                            return e === this.readData(4);
                                        }, i.prototype.readData = function(e) {
                                            this.checkOffset(e);
                                            var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./DataReader": 18
                                    }
                                ],
                                21: [
                                    function(e, t, r) {
                                        var n = e("./ArrayReader");
                                        function i(e) {
                                            n.call(this, e);
                                        }
                                        e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                                            if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                                            var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                                            return this.index += e, t;
                                        }, t.exports = i;
                                    },
                                    {
                                        "../utils": 32,
                                        "./ArrayReader": 17
                                    }
                                ],
                                22: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), o = e("./StringReader"), a = e("./NodeBufferReader"), l = e("./Uint8ArrayReader");
                                        t.exports = function(e) {
                                            var t = n.getTypeOf(e);
                                            return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new a(e) : i.uint8array ? new l(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new o(e);
                                        };
                                    },
                                    {
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ArrayReader": 17,
                                        "./NodeBufferReader": 19,
                                        "./StringReader": 20,
                                        "./Uint8ArrayReader": 21
                                    }
                                ],
                                23: [
                                    function(e, t, r) {
                                        r.LOCAL_FILE_HEADER = "PK\x03\x04", r.CENTRAL_FILE_HEADER = "PK\x01\x02", r.CENTRAL_DIRECTORY_END = "PK\x05\x06", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07", r.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06", r.DATA_DESCRIPTOR = "PK\x07\b";
                                    },
                                    {}
                                ],
                                24: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../utils");
                                        function s(e) {
                                            n.call(this, "ConvertWorker to " + e), this.destType = e;
                                        }
                                        i.inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.push({
                                                data: i.transformTo(this.destType, e.data),
                                                meta: e.meta
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                25: [
                                    function(e, t, r) {
                                        var n = e("./GenericWorker"), i = e("../crc32");
                                        function s() {
                                            n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                                        }
                                        e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                                            this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../crc32": 4,
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                26: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                                        }
                                        n.inherits(s, i), s.prototype.processChunk = function(e) {
                                            if (e) {
                                                var t = this.streamInfo[this.propName] || 0;
                                                this.streamInfo[this.propName] = t + e.data.length;
                                            }
                                            i.prototype.processChunk.call(this, e);
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                27: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./GenericWorker");
                                        function s(e) {
                                            i.call(this, "DataWorker");
                                            var t = this;
                                            this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                                                t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                                            }, function(e) {
                                                t.error(e);
                                            });
                                        }
                                        n.inherits(s, i), s.prototype.cleanUp = function() {
                                            i.prototype.cleanUp.call(this), this.data = null;
                                        }, s.prototype.resume = function() {
                                            return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                                        }, s.prototype._tickAndRepeat = function() {
                                            this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                                        }, s.prototype._tick = function() {
                                            if (this.isPaused || this.isFinished) return !1;
                                            var e = null, t = Math.min(this.max, this.index + 16384);
                                            if (this.index >= this.max) return this.end();
                                            switch(this.type){
                                                case "string":
                                                    e = this.data.substring(this.index, t);
                                                    break;
                                                case "uint8array":
                                                    e = this.data.subarray(this.index, t);
                                                    break;
                                                case "array":
                                                case "nodebuffer":
                                                    e = this.data.slice(this.index, t);
                                            }
                                            return this.index = t, this.push({
                                                data: e,
                                                meta: {
                                                    percent: this.max ? this.index / this.max * 100 : 0
                                                }
                                            });
                                        }, t.exports = s;
                                    },
                                    {
                                        "../utils": 32,
                                        "./GenericWorker": 28
                                    }
                                ],
                                28: [
                                    function(e, t, r) {
                                        function n(e) {
                                            this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                                                data: [],
                                                end: [],
                                                error: []
                                            }, this.previous = null;
                                        }
                                        n.prototype = {
                                            push: function(e) {
                                                this.emit("data", e);
                                            },
                                            end: function() {
                                                if (this.isFinished) return !1;
                                                this.flush();
                                                try {
                                                    this.emit("end"), this.cleanUp(), this.isFinished = !0;
                                                } catch (e) {
                                                    this.emit("error", e);
                                                }
                                                return !0;
                                            },
                                            error: function(e) {
                                                return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                                            },
                                            on: function(e, t) {
                                                return this._listeners[e].push(t), this;
                                            },
                                            cleanUp: function() {
                                                this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                                            },
                                            emit: function(e, t) {
                                                if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                                            },
                                            pipe: function(e) {
                                                return e.registerPrevious(this);
                                            },
                                            registerPrevious: function(e) {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                                                var t = this;
                                                return e.on("data", function(e) {
                                                    t.processChunk(e);
                                                }), e.on("end", function() {
                                                    t.end();
                                                }), e.on("error", function(e) {
                                                    t.error(e);
                                                }), this;
                                            },
                                            pause: function() {
                                                return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                                            },
                                            resume: function() {
                                                if (!this.isPaused || this.isFinished) return !1;
                                                var e = this.isPaused = !1;
                                                return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                                            },
                                            flush: function() {},
                                            processChunk: function(e) {
                                                this.push(e);
                                            },
                                            withStreamInfo: function(e, t) {
                                                return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                                            },
                                            mergeStreamInfo: function() {
                                                for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                                            },
                                            lock: function() {
                                                if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                                                this.isLocked = !0, this.previous && this.previous.lock();
                                            },
                                            toString: function() {
                                                var e = "Worker " + this.name;
                                                return this.previous ? this.previous + " -> " + e : e;
                                            }
                                        }, t.exports = n;
                                    },
                                    {}
                                ],
                                29: [
                                    function(e, t, r) {
                                        var n = e("../utils"), i = e("./ConvertWorker"), o = e("./GenericWorker"), a = e("../base64"), l = e("../support"), c = e("../external"), u = null;
                                        if (l.nodestream) try {
                                            u = e("../nodejs/NodejsStreamOutputAdapter");
                                        } catch (e) {}
                                        function h(e, t, r) {
                                            var s = t;
                                            switch(t){
                                                case "blob":
                                                case "arraybuffer":
                                                    s = "uint8array";
                                                    break;
                                                case "base64":
                                                    s = "string";
                                            }
                                            try {
                                                this._internalType = s, this._outputType = t, this._mimeType = r, n.checkSupport(s), this._worker = e.pipe(new i(s)), e.lock();
                                            } catch (e) {
                                                this._worker = new o("error"), this._worker.error(e);
                                            }
                                        }
                                        h.prototype = {
                                            accumulate: function(e) {
                                                return function(e, t) {
                                                    return new c.Promise(function(r, i) {
                                                        var o = [], l = e._internalType, c = e._outputType, u = e._mimeType;
                                                        e.on("data", function(e, r) {
                                                            o.push(e), t && t(r);
                                                        }).on("error", function(e) {
                                                            o = [], i(e);
                                                        }).on("end", function() {
                                                            try {
                                                                var e = function(e, t, r) {
                                                                    switch(e){
                                                                        case "blob":
                                                                            return n.newBlob(n.transformTo("arraybuffer", t), r);
                                                                        case "base64":
                                                                            return a.encode(t);
                                                                        default:
                                                                            return n.transformTo(e, t);
                                                                    }
                                                                }(c, function(e, t) {
                                                                    var r, n = 0, i = null, o = 0;
                                                                    for(r = 0; r < t.length; r++)o += t[r].length;
                                                                    switch(e){
                                                                        case "string":
                                                                            return t.join("");
                                                                        case "array":
                                                                            return Array.prototype.concat.apply([], t);
                                                                        case "uint8array":
                                                                            for(i = new Uint8Array(o), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                                                            return i;
                                                                        case "nodebuffer":
                                                                            return s.concat(t);
                                                                        default:
                                                                            throw new Error("concat : unsupported type '" + e + "'");
                                                                    }
                                                                }(l, o), u);
                                                                r(e);
                                                            } catch (e) {
                                                                i(e);
                                                            }
                                                            o = [];
                                                        }).resume();
                                                    });
                                                }(this, e);
                                            },
                                            on: function(e, t) {
                                                var r = this;
                                                return "data" === e ? this._worker.on(e, function(e) {
                                                    t.call(r, e.data, e.meta);
                                                }) : this._worker.on(e, function() {
                                                    n.delay(t, arguments, r);
                                                }), this;
                                            },
                                            resume: function() {
                                                return n.delay(this._worker.resume, [], this._worker), this;
                                            },
                                            pause: function() {
                                                return this._worker.pause(), this;
                                            },
                                            toNodejsStream: function(e) {
                                                if (n.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                                                return new u(this, {
                                                    objectMode: "nodebuffer" !== this._outputType
                                                }, e);
                                            }
                                        }, t.exports = h;
                                    },
                                    {
                                        "../base64": 1,
                                        "../external": 6,
                                        "../nodejs/NodejsStreamOutputAdapter": 13,
                                        "../support": 30,
                                        "../utils": 32,
                                        "./ConvertWorker": 24,
                                        "./GenericWorker": 28
                                    }
                                ],
                                30: [
                                    function(e, t, r) {
                                        if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = void 0 !== s, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                                        else {
                                            var n = new ArrayBuffer(0);
                                            try {
                                                r.blob = 0 === new Blob([
                                                    n
                                                ], {
                                                    type: "application/zip"
                                                }).size;
                                            } catch (e) {
                                                try {
                                                    var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                                                } catch (e) {
                                                    r.blob = !1;
                                                }
                                            }
                                        }
                                        try {
                                            r.nodestream = !!e("readable-stream").Readable;
                                        } catch (e) {
                                            r.nodestream = !1;
                                        }
                                    },
                                    {
                                        "readable-stream": 16
                                    }
                                ],
                                31: [
                                    function(e, t, r) {
                                        for(var n = e("./utils"), i = e("./support"), s = e("./nodejsUtils"), o = e("./stream/GenericWorker"), a = new Array(256), l = 0; l < 256; l++)a[l] = 252 <= l ? 6 : 248 <= l ? 5 : 240 <= l ? 4 : 224 <= l ? 3 : 192 <= l ? 2 : 1;
                                        function c() {
                                            o.call(this, "utf-8 decode"), this.leftOver = null;
                                        }
                                        function u() {
                                            o.call(this, "utf-8 encode");
                                        }
                                        a[254] = a[254] = 1, r.utf8encode = function(e) {
                                            return i.nodebuffer ? s.newBufferFrom(e, "utf-8") : function(e) {
                                                var t, r, n, s, o, a = e.length, l = 0;
                                                for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                                for(t = i.uint8array ? new Uint8Array(l) : new Array(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (n = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                                return t;
                                            }(e);
                                        }, r.utf8decode = function(e) {
                                            return i.nodebuffer ? n.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                                                var t, r, i, s, o = e.length, l = new Array(2 * o);
                                                for(t = r = 0; t < o;)if ((i = e[t++]) < 128) l[r++] = i;
                                                else if (4 < (s = a[i])) l[r++] = 65533, t += s - 1;
                                                else {
                                                    for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && t < o;)i = i << 6 | 63 & e[t++], s--;
                                                    1 < s ? l[r++] = 65533 : i < 65536 ? l[r++] = i : (i -= 65536, l[r++] = 55296 | i >> 10 & 1023, l[r++] = 56320 | 1023 & i);
                                                }
                                                return l.length !== r && (l.subarray ? l = l.subarray(0, r) : l.length = r), n.applyFromCharCode(l);
                                            }(e = n.transformTo(i.uint8array ? "uint8array" : "array", e));
                                        }, n.inherits(c, o), c.prototype.processChunk = function(e) {
                                            var t = n.transformTo(i.uint8array ? "uint8array" : "array", e.data);
                                            if (this.leftOver && this.leftOver.length) {
                                                if (i.uint8array) {
                                                    var s = t;
                                                    (t = new Uint8Array(s.length + this.leftOver.length)).set(this.leftOver, 0), t.set(s, this.leftOver.length);
                                                } else t = this.leftOver.concat(t);
                                                this.leftOver = null;
                                            }
                                            var o = function(e, t) {
                                                var r;
                                                for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                                return r < 0 || 0 === r ? t : r + a[e[r]] > t ? r : t;
                                            }(t), l = t;
                                            o !== t.length && (i.uint8array ? (l = t.subarray(0, o), this.leftOver = t.subarray(o, t.length)) : (l = t.slice(0, o), this.leftOver = t.slice(o, t.length))), this.push({
                                                data: r.utf8decode(l),
                                                meta: e.meta
                                            });
                                        }, c.prototype.flush = function() {
                                            this.leftOver && this.leftOver.length && (this.push({
                                                data: r.utf8decode(this.leftOver),
                                                meta: {}
                                            }), this.leftOver = null);
                                        }, r.Utf8DecodeWorker = c, n.inherits(u, o), u.prototype.processChunk = function(e) {
                                            this.push({
                                                data: r.utf8encode(e.data),
                                                meta: e.meta
                                            });
                                        }, r.Utf8EncodeWorker = u;
                                    },
                                    {
                                        "./nodejsUtils": 14,
                                        "./stream/GenericWorker": 28,
                                        "./support": 30,
                                        "./utils": 32
                                    }
                                ],
                                32: [
                                    function(e, t, r) {
                                        var n = e("./support"), i = e("./base64"), s = e("./nodejsUtils"), o = e("./external");
                                        function a(e) {
                                            return e;
                                        }
                                        function l(e, t) {
                                            for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                                            return t;
                                        }
                                        e("setimmediate"), r.newBlob = function(e, t) {
                                            r.checkSupport("blob");
                                            try {
                                                return new Blob([
                                                    e
                                                ], {
                                                    type: t
                                                });
                                            } catch (r) {
                                                try {
                                                    var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                                                    return n.append(e), n.getBlob(t);
                                                } catch (e) {
                                                    throw new Error("Bug : can't construct the Blob.");
                                                }
                                            }
                                        };
                                        var c = {
                                            stringifyByChunk: function(e, t, r) {
                                                var n = [], i = 0, s = e.length;
                                                if (s <= r) return String.fromCharCode.apply(null, e);
                                                for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                                                return n.join("");
                                            },
                                            stringifyByChar: function(e) {
                                                for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                                                return t;
                                            },
                                            applyCanBeUsed: {
                                                uint8array: function() {
                                                    try {
                                                        return n.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }(),
                                                nodebuffer: function() {
                                                    try {
                                                        return n.nodebuffer && 1 === String.fromCharCode.apply(null, s.allocBuffer(1)).length;
                                                    } catch (e) {
                                                        return !1;
                                                    }
                                                }()
                                            }
                                        };
                                        function h(e) {
                                            var t = 65536, n = r.getTypeOf(e), i = !0;
                                            if ("uint8array" === n ? i = c.applyCanBeUsed.uint8array : "nodebuffer" === n && (i = c.applyCanBeUsed.nodebuffer), i) for(; 1 < t;)try {
                                                return c.stringifyByChunk(e, n, t);
                                            } catch (e) {
                                                t = Math.floor(t / 2);
                                            }
                                            return c.stringifyByChar(e);
                                        }
                                        function f(e, t) {
                                            for(var r = 0; r < e.length; r++)t[r] = e[r];
                                            return t;
                                        }
                                        r.applyFromCharCode = h;
                                        var d = {};
                                        d.string = {
                                            string: a,
                                            array: function(e) {
                                                return l(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.string.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return l(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: function(e) {
                                                return l(e, s.allocBuffer(e.length));
                                            }
                                        }, d.array = {
                                            string: h,
                                            array: a,
                                            arraybuffer: function(e) {
                                                return new Uint8Array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.arraybuffer = {
                                            string: function(e) {
                                                return h(new Uint8Array(e));
                                            },
                                            array: function(e) {
                                                return f(new Uint8Array(e), new Array(e.byteLength));
                                            },
                                            arraybuffer: a,
                                            uint8array: function(e) {
                                                return new Uint8Array(e);
                                            },
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(new Uint8Array(e));
                                            }
                                        }, d.uint8array = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return e.buffer;
                                            },
                                            uint8array: a,
                                            nodebuffer: function(e) {
                                                return s.newBufferFrom(e);
                                            }
                                        }, d.nodebuffer = {
                                            string: h,
                                            array: function(e) {
                                                return f(e, new Array(e.length));
                                            },
                                            arraybuffer: function(e) {
                                                return d.nodebuffer.uint8array(e).buffer;
                                            },
                                            uint8array: function(e) {
                                                return f(e, new Uint8Array(e.length));
                                            },
                                            nodebuffer: a
                                        }, r.transformTo = function(e, t) {
                                            if (t = t || "", !e) return t;
                                            r.checkSupport(e);
                                            var n = r.getTypeOf(t);
                                            return d[n][e](t);
                                        }, r.resolve = function(e) {
                                            for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                                                var i = t[n];
                                                "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                                            }
                                            return r.join("/");
                                        }, r.getTypeOf = function(e) {
                                            return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : n.nodebuffer && s.isBuffer(e) ? "nodebuffer" : n.uint8array && e instanceof Uint8Array ? "uint8array" : n.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                                        }, r.checkSupport = function(e) {
                                            if (!n[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                                        }, r.MAX_VALUE_16BITS = 65535, r.MAX_VALUE_32BITS = -1, r.pretty = function(e) {
                                            var t, r, n = "";
                                            for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                                            return n;
                                        }, r.delay = function(e, t, r) {
                                            u(function() {
                                                e.apply(r || null, t || []);
                                            });
                                        }, r.inherits = function(e, t) {
                                            function r() {}
                                            r.prototype = t.prototype, e.prototype = new r;
                                        }, r.extend = function() {
                                            var e, t, r = {};
                                            for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                                            return r;
                                        }, r.prepareContent = function(e, t, s, a, c) {
                                            return o.Promise.resolve(t).then(function(e) {
                                                return n.blob && (e instanceof Blob || -1 !== [
                                                    "[object File]",
                                                    "[object Blob]"
                                                ].indexOf(Object.prototype.toString.call(e))) && "undefined" != typeof FileReader ? new o.Promise(function(t, r) {
                                                    var n = new FileReader;
                                                    n.onload = function(e) {
                                                        t(e.target.result);
                                                    }, n.onerror = function(e) {
                                                        r(e.target.error);
                                                    }, n.readAsArrayBuffer(e);
                                                }) : e;
                                            }).then(function(t) {
                                                var u = r.getTypeOf(t);
                                                return u ? ("arraybuffer" === u ? t = r.transformTo("uint8array", t) : "string" === u && (c ? t = i.decode(t) : s && !0 !== a && (t = function(e) {
                                                    return l(e, n.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                                                }(t))), t) : o.Promise.reject(new Error("Can't read the data of '" + e + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                                            });
                                        };
                                    },
                                    {
                                        "./base64": 1,
                                        "./external": 6,
                                        "./nodejsUtils": 14,
                                        "./support": 30,
                                        setimmediate: 54
                                    }
                                ],
                                33: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), o = e("./zipEntry"), a = e("./support");
                                        function l(e) {
                                            this.files = [], this.loadOptions = e;
                                        }
                                        l.prototype = {
                                            checkSignature: function(e) {
                                                if (!this.reader.readAndCheckSignature(e)) {
                                                    this.reader.index -= 4;
                                                    var t = this.reader.readString(4);
                                                    throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                                                }
                                            },
                                            isSignature: function(e, t) {
                                                var r = this.reader.index;
                                                this.reader.setIndex(e);
                                                var n = this.reader.readString(4) === t;
                                                return this.reader.setIndex(r), n;
                                            },
                                            readBlockEndOfCentral: function() {
                                                this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                                                var e = this.reader.readData(this.zipCommentLength), t = a.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                                                this.zipComment = this.loadOptions.decodeFileName(r);
                                            },
                                            readBlockZip64EndOfCentral: function() {
                                                this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                                                for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                                                    id: e,
                                                    length: t,
                                                    value: r
                                                };
                                            },
                                            readBlockZip64EndOfCentralLocator: function() {
                                                if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                                            },
                                            readLocalFiles: function() {
                                                var e, t;
                                                for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                                            },
                                            readCentralDir: function() {
                                                var e;
                                                for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new o({
                                                    zip64: this.zip64
                                                }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                                                if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                                            },
                                            readEndOfCentral: function() {
                                                var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                                                if (e < 0) throw this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Corrupted zip: can't find end of central directory") : new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
                                                this.reader.setIndex(e);
                                                var t = e;
                                                if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                                                    if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                                                    if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                                                    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                                                }
                                                var r = this.centralDirOffset + this.centralDirSize;
                                                this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                                                var n = t - r;
                                                if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                                                else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                                            },
                                            prepareReader: function(e) {
                                                this.reader = n(e);
                                            },
                                            load: function(e) {
                                                this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                                            }
                                        }, t.exports = l;
                                    },
                                    {
                                        "./reader/readerFor": 22,
                                        "./signature": 23,
                                        "./support": 30,
                                        "./utils": 32,
                                        "./zipEntry": 34
                                    }
                                ],
                                34: [
                                    function(e, t, r) {
                                        var n = e("./reader/readerFor"), i = e("./utils"), s = e("./compressedObject"), o = e("./crc32"), a = e("./utf8"), l = e("./compressions"), c = e("./support");
                                        function u(e, t) {
                                            this.options = e, this.loadOptions = t;
                                        }
                                        u.prototype = {
                                            isEncrypted: function() {
                                                return 1 == (1 & this.bitFlag);
                                            },
                                            useUTF8: function() {
                                                return 2048 == (2048 & this.bitFlag);
                                            },
                                            readLocalPart: function(e) {
                                                var t, r;
                                                if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                                                if (null === (t = function(e) {
                                                    for(var t in l)if (Object.prototype.hasOwnProperty.call(l, t) && l[t].magic === e) return l[t];
                                                    return null;
                                                }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + i.pretty(this.compressionMethod) + " unknown (inner file : " + i.transformTo("string", this.fileName) + ")");
                                                this.decompressed = new s(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                                            },
                                            readCentralPart: function(e) {
                                                this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                                                var t = e.readInt(2);
                                                if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                                                e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                                            },
                                            processAttributes: function() {
                                                this.unixPermissions = null, this.dosPermissions = null;
                                                var e = this.versionMadeBy >> 8;
                                                this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                                            },
                                            parseZIP64ExtraField: function() {
                                                if (this.extraFields[1]) {
                                                    var e = n(this.extraFields[1].value);
                                                    this.uncompressedSize === i.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === i.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === i.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === i.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                                                }
                                            },
                                            readExtraFields: function(e) {
                                                var t, r, n, i = e.index + this.extraFieldsLength;
                                                for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                                                    id: t,
                                                    length: r,
                                                    value: n
                                                };
                                                e.setIndex(i);
                                            },
                                            handleUTF8: function() {
                                                var e = c.uint8array ? "uint8array" : "array";
                                                if (this.useUTF8()) this.fileNameStr = a.utf8decode(this.fileName), this.fileCommentStr = a.utf8decode(this.fileComment);
                                                else {
                                                    var t = this.findExtraFieldUnicodePath();
                                                    if (null !== t) this.fileNameStr = t;
                                                    else {
                                                        var r = i.transformTo(e, this.fileName);
                                                        this.fileNameStr = this.loadOptions.decodeFileName(r);
                                                    }
                                                    var n = this.findExtraFieldUnicodeComment();
                                                    if (null !== n) this.fileCommentStr = n;
                                                    else {
                                                        var s = i.transformTo(e, this.fileComment);
                                                        this.fileCommentStr = this.loadOptions.decodeFileName(s);
                                                    }
                                                }
                                            },
                                            findExtraFieldUnicodePath: function() {
                                                var e = this.extraFields[28789];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileName) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            },
                                            findExtraFieldUnicodeComment: function() {
                                                var e = this.extraFields[25461];
                                                if (e) {
                                                    var t = n(e.value);
                                                    return 1 !== t.readInt(1) || o(this.fileComment) !== t.readInt(4) ? null : a.utf8decode(t.readData(e.length - 5));
                                                }
                                                return null;
                                            }
                                        }, t.exports = u;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./compressions": 3,
                                        "./crc32": 4,
                                        "./reader/readerFor": 22,
                                        "./support": 30,
                                        "./utf8": 31,
                                        "./utils": 32
                                    }
                                ],
                                35: [
                                    function(e, t, r) {
                                        function n(e, t, r) {
                                            this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                                                compression: r.compression,
                                                compressionOptions: r.compressionOptions
                                            };
                                        }
                                        var i = e("./stream/StreamHelper"), s = e("./stream/DataWorker"), o = e("./utf8"), a = e("./compressedObject"), l = e("./stream/GenericWorker");
                                        n.prototype = {
                                            internalStream: function(e) {
                                                var t = null, r = "string";
                                                try {
                                                    if (!e) throw new Error("No output type specified.");
                                                    var n = "string" === (r = e.toLowerCase()) || "text" === r;
                                                    "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                                                    var s = !this._dataBinary;
                                                    s && !n && (t = t.pipe(new o.Utf8EncodeWorker)), !s && n && (t = t.pipe(new o.Utf8DecodeWorker));
                                                } catch (e) {
                                                    (t = new l("error")).error(e);
                                                }
                                                return new i(t, r, "");
                                            },
                                            async: function(e, t) {
                                                return this.internalStream(e).accumulate(t);
                                            },
                                            nodeStream: function(e, t) {
                                                return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                                            },
                                            _compressWorker: function(e, t) {
                                                if (this._data instanceof a && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                                                var r = this._decompressWorker();
                                                return this._dataBinary || (r = r.pipe(new o.Utf8EncodeWorker)), a.createWorkerFrom(r, e, t);
                                            },
                                            _decompressWorker: function() {
                                                return this._data instanceof a ? this._data.getContentWorker() : this._data instanceof l ? this._data : new s(this._data);
                                            }
                                        };
                                        for(var c = [
                                            "asText",
                                            "asBinary",
                                            "asNodeBuffer",
                                            "asUint8Array",
                                            "asArrayBuffer"
                                        ], u = function() {
                                            throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                                        }, h = 0; h < c.length; h++)n.prototype[c[h]] = u;
                                        t.exports = n;
                                    },
                                    {
                                        "./compressedObject": 2,
                                        "./stream/DataWorker": 27,
                                        "./stream/GenericWorker": 28,
                                        "./stream/StreamHelper": 29,
                                        "./utf8": 31
                                    }
                                ],
                                36: [
                                    function(e, t, r) {
                                        (function(e) {
                                            var r, n, i = e.MutationObserver || e.WebKitMutationObserver;
                                            if (i) {
                                                var s = 0, o = new i(u), a = e.document.createTextNode("");
                                                o.observe(a, {
                                                    characterData: !0
                                                }), r = function() {
                                                    a.data = s = ++s % 2;
                                                };
                                            } else if (e.setImmediate || void 0 === e.MessageChannel) r = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function() {
                                                var t = e.document.createElement("script");
                                                t.onreadystatechange = function() {
                                                    u(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null;
                                                }, e.document.documentElement.appendChild(t);
                                            } : function() {
                                                setTimeout(u, 0);
                                            };
                                            else {
                                                var l = new e.MessageChannel;
                                                l.port1.onmessage = u, r = function() {
                                                    l.port2.postMessage(0);
                                                };
                                            }
                                            var c = [];
                                            function u() {
                                                var e, t;
                                                n = !0;
                                                for(var r = c.length; r;){
                                                    for(t = c, c = [], e = -1; ++e < r;)t[e]();
                                                    r = c.length;
                                                }
                                                n = !1;
                                            }
                                            t.exports = function(e) {
                                                1 !== c.push(e) || n || r();
                                            };
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ],
                                37: [
                                    function(e, t, r) {
                                        var n = e("immediate");
                                        function i() {}
                                        var s = {}, o = [
                                            "REJECTED"
                                        ], a = [
                                            "FULFILLED"
                                        ], l = [
                                            "PENDING"
                                        ];
                                        function c(e) {
                                            if ("function" != typeof e) throw new TypeError("resolver must be a function");
                                            this.state = l, this.queue = [], this.outcome = void 0, e !== i && d(this, e);
                                        }
                                        function u(e, t, r) {
                                            this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                                        }
                                        function h(e, t, r) {
                                            n(function() {
                                                var n;
                                                try {
                                                    n = t(r);
                                                } catch (n) {
                                                    return s.reject(e, n);
                                                }
                                                n === e ? s.reject(e, new TypeError("Cannot resolve promise with itself")) : s.resolve(e, n);
                                            });
                                        }
                                        function f(e) {
                                            var t = e && e.then;
                                            if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                                                t.apply(e, arguments);
                                            };
                                        }
                                        function d(e, t) {
                                            var r = !1;
                                            function n(t) {
                                                r || (r = !0, s.reject(e, t));
                                            }
                                            function i(t) {
                                                r || (r = !0, s.resolve(e, t));
                                            }
                                            var o = p(function() {
                                                t(i, n);
                                            });
                                            "error" === o.status && n(o.value);
                                        }
                                        function p(e, t) {
                                            var r = {};
                                            try {
                                                r.value = e(t), r.status = "success";
                                            } catch (e) {
                                                r.status = "error", r.value = e;
                                            }
                                            return r;
                                        }
                                        (t.exports = c).prototype.finally = function(e) {
                                            if ("function" != typeof e) return this;
                                            var t = this.constructor;
                                            return this.then(function(r) {
                                                return t.resolve(e()).then(function() {
                                                    return r;
                                                });
                                            }, function(r) {
                                                return t.resolve(e()).then(function() {
                                                    throw r;
                                                });
                                            });
                                        }, c.prototype.catch = function(e) {
                                            return this.then(null, e);
                                        }, c.prototype.then = function(e, t) {
                                            if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === o) return this;
                                            var r = new this.constructor(i);
                                            return this.state !== l ? h(r, this.state === a ? e : t, this.outcome) : this.queue.push(new u(r, e, t)), r;
                                        }, u.prototype.callFulfilled = function(e) {
                                            s.resolve(this.promise, e);
                                        }, u.prototype.otherCallFulfilled = function(e) {
                                            h(this.promise, this.onFulfilled, e);
                                        }, u.prototype.callRejected = function(e) {
                                            s.reject(this.promise, e);
                                        }, u.prototype.otherCallRejected = function(e) {
                                            h(this.promise, this.onRejected, e);
                                        }, s.resolve = function(e, t) {
                                            var r = p(f, t);
                                            if ("error" === r.status) return s.reject(e, r.value);
                                            var n = r.value;
                                            if (n) d(e, n);
                                            else {
                                                e.state = a, e.outcome = t;
                                                for(var i = -1, o = e.queue.length; ++i < o;)e.queue[i].callFulfilled(t);
                                            }
                                            return e;
                                        }, s.reject = function(e, t) {
                                            e.state = o, e.outcome = t;
                                            for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                                            return e;
                                        }, c.resolve = function(e) {
                                            return e instanceof this ? e : s.resolve(new this(i), e);
                                        }, c.reject = function(e) {
                                            var t = new this(i);
                                            return s.reject(t, e);
                                        }, c.all = function(e) {
                                            var t = this;
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var r = e.length, n = !1;
                                            if (!r) return this.resolve([]);
                                            for(var o = new Array(r), a = 0, l = -1, c = new this(i); ++l < r;)u(e[l], l);
                                            return c;
                                            function u(e, i) {
                                                t.resolve(e).then(function(e) {
                                                    o[i] = e, ++a !== r || n || (n = !0, s.resolve(c, o));
                                                }, function(e) {
                                                    n || (n = !0, s.reject(c, e));
                                                });
                                            }
                                        }, c.race = function(e) {
                                            if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                                            var t = e.length, r = !1;
                                            if (!t) return this.resolve([]);
                                            for(var n, o = -1, a = new this(i); ++o < t;)n = e[o], this.resolve(n).then(function(e) {
                                                r || (r = !0, s.resolve(a, e));
                                            }, function(e) {
                                                r || (r = !0, s.reject(a, e));
                                            });
                                            return a;
                                        };
                                    },
                                    {
                                        immediate: 36
                                    }
                                ],
                                38: [
                                    function(e, t, r) {
                                        var n = {};
                                        (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
                                    },
                                    {
                                        "./lib/deflate": 39,
                                        "./lib/inflate": 40,
                                        "./lib/utils/common": 41,
                                        "./lib/zlib/constants": 44
                                    }
                                ],
                                39: [
                                    function(e, t, r) {
                                        var n = e("./zlib/deflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/messages"), a = e("./zlib/zstream"), l = Object.prototype.toString;
                                        function c(e) {
                                            if (!(this instanceof c)) return new c(e);
                                            this.options = i.assign({
                                                level: -1,
                                                method: 8,
                                                chunkSize: 16384,
                                                windowBits: 15,
                                                memLevel: 8,
                                                strategy: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new a, this.strm.avail_out = 0;
                                            var r = n.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                                            if (0 !== r) throw new Error(o[r]);
                                            if (t.header && n.deflateSetHeader(this.strm, t.header), t.dictionary) {
                                                var u;
                                                if (u = "string" == typeof t.dictionary ? s.string2buf(t.dictionary) : "[object ArrayBuffer]" === l.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, 0 !== (r = n.deflateSetDictionary(this.strm, u))) throw new Error(o[r]);
                                                this._dict_set = !0;
                                            }
                                        }
                                        function u(e, t) {
                                            var r = new c(t);
                                            if (r.push(e, !0), r.err) throw r.msg || o[r.err];
                                            return r.result;
                                        }
                                        c.prototype.push = function(e, t) {
                                            var r, o, a = this.strm, c = this.options.chunkSize;
                                            if (this.ended) return !1;
                                            o = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? a.input = s.string2buf(e) : "[object ArrayBuffer]" === l.call(e) ? a.input = new Uint8Array(e) : a.input = e, a.next_in = 0, a.avail_in = a.input.length;
                                            do {
                                                if (0 === a.avail_out && (a.output = new i.Buf8(c), a.next_out = 0, a.avail_out = c), 1 !== (r = n.deflate(a, o)) && 0 !== r) return this.onEnd(r), this.ended = !0, false;
                                                0 !== a.avail_out && (0 !== a.avail_in || 4 !== o && 2 !== o) || ("string" === this.options.to ? this.onData(s.buf2binstring(i.shrinkBuf(a.output, a.next_out))) : this.onData(i.shrinkBuf(a.output, a.next_out)));
                                            }while ((0 < a.avail_in || 0 === a.avail_out) && 1 !== r);
                                            return 4 === o ? (r = n.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, 0 === r) : 2 !== o || (this.onEnd(0), a.avail_out = 0, true);
                                        }, c.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, c.prototype.onEnd = function(e) {
                                            0 === e && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Deflate = c, r.deflate = u, r.deflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, u(e, t);
                                        }, r.gzip = function(e, t) {
                                            return (t = t || {}).gzip = !0, u(e, t);
                                        };
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/deflate": 46,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                40: [
                                    function(e, t, r) {
                                        var n = e("./zlib/inflate"), i = e("./utils/common"), s = e("./utils/strings"), o = e("./zlib/constants"), a = e("./zlib/messages"), l = e("./zlib/zstream"), c = e("./zlib/gzheader"), u = Object.prototype.toString;
                                        function h(e) {
                                            if (!(this instanceof h)) return new h(e);
                                            this.options = i.assign({
                                                chunkSize: 16384,
                                                windowBits: 0,
                                                to: ""
                                            }, e || {});
                                            var t = this.options;
                                            t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new l, this.strm.avail_out = 0;
                                            var r = n.inflateInit2(this.strm, t.windowBits);
                                            if (r !== o.Z_OK) throw new Error(a[r]);
                                            this.header = new c, n.inflateGetHeader(this.strm, this.header);
                                        }
                                        function f(e, t) {
                                            var r = new h(t);
                                            if (r.push(e, !0), r.err) throw r.msg || a[r.err];
                                            return r.result;
                                        }
                                        h.prototype.push = function(e, t) {
                                            var r, a, l, c, h, f, d = this.strm, p = this.options.chunkSize, m = this.options.dictionary, b = !1;
                                            if (this.ended) return !1;
                                            a = t === ~~t ? t : !0 === t ? o.Z_FINISH : o.Z_NO_FLUSH, "string" == typeof e ? d.input = s.binstring2buf(e) : "[object ArrayBuffer]" === u.call(e) ? d.input = new Uint8Array(e) : d.input = e, d.next_in = 0, d.avail_in = d.input.length;
                                            do {
                                                if (0 === d.avail_out && (d.output = new i.Buf8(p), d.next_out = 0, d.avail_out = p), (r = n.inflate(d, o.Z_NO_FLUSH)) === o.Z_NEED_DICT && m && (f = "string" == typeof m ? s.string2buf(m) : "[object ArrayBuffer]" === u.call(m) ? new Uint8Array(m) : m, r = n.inflateSetDictionary(this.strm, f)), r === o.Z_BUF_ERROR && !0 === b && (r = o.Z_OK, b = !1), r !== o.Z_STREAM_END && r !== o.Z_OK) return this.onEnd(r), this.ended = !0, false;
                                                d.next_out && (0 !== d.avail_out && r !== o.Z_STREAM_END && (0 !== d.avail_in || a !== o.Z_FINISH && a !== o.Z_SYNC_FLUSH) || ("string" === this.options.to ? (l = s.utf8border(d.output, d.next_out), c = d.next_out - l, h = s.buf2string(d.output, l), d.next_out = c, d.avail_out = p - c, c && i.arraySet(d.output, d.output, l, c, 0), this.onData(h)) : this.onData(i.shrinkBuf(d.output, d.next_out)))), 0 === d.avail_in && 0 === d.avail_out && (b = !0);
                                            }while ((0 < d.avail_in || 0 === d.avail_out) && r !== o.Z_STREAM_END);
                                            return r === o.Z_STREAM_END && (a = o.Z_FINISH), a === o.Z_FINISH ? (r = n.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === o.Z_OK) : a !== o.Z_SYNC_FLUSH || (this.onEnd(o.Z_OK), d.avail_out = 0, true);
                                        }, h.prototype.onData = function(e) {
                                            this.chunks.push(e);
                                        }, h.prototype.onEnd = function(e) {
                                            e === o.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = i.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                                        }, r.Inflate = h, r.inflate = f, r.inflateRaw = function(e, t) {
                                            return (t = t || {}).raw = !0, f(e, t);
                                        }, r.ungzip = f;
                                    },
                                    {
                                        "./utils/common": 41,
                                        "./utils/strings": 42,
                                        "./zlib/constants": 44,
                                        "./zlib/gzheader": 47,
                                        "./zlib/inflate": 49,
                                        "./zlib/messages": 51,
                                        "./zlib/zstream": 53
                                    }
                                ],
                                41: [
                                    function(e, t, r) {
                                        var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                                        r.assign = function(e) {
                                            for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                                                var r = t.shift();
                                                if (r) {
                                                    if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                                                    for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                                                }
                                            }
                                            return e;
                                        }, r.shrinkBuf = function(e, t) {
                                            return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                                        };
                                        var i = {
                                            arraySet: function(e, t, r, n, i) {
                                                if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                                                else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                var t, r, n, i, s, o;
                                                for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                                                for(o = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], o.set(s, i), i += s.length;
                                                return o;
                                            }
                                        }, s = {
                                            arraySet: function(e, t, r, n, i) {
                                                for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                                            },
                                            flattenChunks: function(e) {
                                                return [].concat.apply([], e);
                                            }
                                        };
                                        r.setTyped = function(e) {
                                            e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                                        }, r.setTyped(n);
                                    },
                                    {}
                                ],
                                42: [
                                    function(e, t, r) {
                                        var n = e("./common"), i = !0, s = !0;
                                        try {
                                            String.fromCharCode.apply(null, [
                                                0
                                            ]);
                                        } catch (e) {
                                            i = !1;
                                        }
                                        try {
                                            String.fromCharCode.apply(null, new Uint8Array(1));
                                        } catch (e) {
                                            s = !1;
                                        }
                                        for(var o = new n.Buf8(256), a = 0; a < 256; a++)o[a] = 252 <= a ? 6 : 248 <= a ? 5 : 240 <= a ? 4 : 224 <= a ? 3 : 192 <= a ? 2 : 1;
                                        function l(e, t) {
                                            if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, n.shrinkBuf(e, t));
                                            for(var r = "", o = 0; o < t; o++)r += String.fromCharCode(e[o]);
                                            return r;
                                        }
                                        o[254] = o[254] = 1, r.string2buf = function(e) {
                                            var t, r, i, s, o, a = e.length, l = 0;
                                            for(s = 0; s < a; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), l += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                                            for(t = new n.Buf8(l), s = o = 0; o < l; s++)55296 == (64512 & (r = e.charCodeAt(s))) && s + 1 < a && 56320 == (64512 & (i = e.charCodeAt(s + 1))) && (r = 65536 + (r - 55296 << 10) + (i - 56320), s++), r < 128 ? t[o++] = r : (r < 2048 ? t[o++] = 192 | r >>> 6 : (r < 65536 ? t[o++] = 224 | r >>> 12 : (t[o++] = 240 | r >>> 18, t[o++] = 128 | r >>> 12 & 63), t[o++] = 128 | r >>> 6 & 63), t[o++] = 128 | 63 & r);
                                            return t;
                                        }, r.buf2binstring = function(e) {
                                            return l(e, e.length);
                                        }, r.binstring2buf = function(e) {
                                            for(var t = new n.Buf8(e.length), r = 0, i = t.length; r < i; r++)t[r] = e.charCodeAt(r);
                                            return t;
                                        }, r.buf2string = function(e, t) {
                                            var r, n, i, s, a = t || e.length, c = new Array(2 * a);
                                            for(r = n = 0; r < a;)if ((i = e[r++]) < 128) c[n++] = i;
                                            else if (4 < (s = o[i])) c[n++] = 65533, r += s - 1;
                                            else {
                                                for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                                                1 < s ? c[n++] = 65533 : i < 65536 ? c[n++] = i : (i -= 65536, c[n++] = 55296 | i >> 10 & 1023, c[n++] = 56320 | 1023 & i);
                                            }
                                            return l(c, n);
                                        }, r.utf8border = function(e, t) {
                                            var r;
                                            for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                                            return r < 0 || 0 === r ? t : r + o[e[r]] > t ? r : t;
                                        };
                                    },
                                    {
                                        "./common": 41
                                    }
                                ],
                                43: [
                                    function(e, t, r) {
                                        t.exports = function(e, t, r, n) {
                                            for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, o = 0; 0 !== r;){
                                                for(r -= o = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --o;);
                                                i %= 65521, s %= 65521;
                                            }
                                            return i | s << 16 | 0;
                                        };
                                    },
                                    {}
                                ],
                                44: [
                                    function(e, t, r) {
                                        t.exports = {
                                            Z_NO_FLUSH: 0,
                                            Z_PARTIAL_FLUSH: 1,
                                            Z_SYNC_FLUSH: 2,
                                            Z_FULL_FLUSH: 3,
                                            Z_FINISH: 4,
                                            Z_BLOCK: 5,
                                            Z_TREES: 6,
                                            Z_OK: 0,
                                            Z_STREAM_END: 1,
                                            Z_NEED_DICT: 2,
                                            Z_ERRNO: -1,
                                            Z_STREAM_ERROR: -2,
                                            Z_DATA_ERROR: -3,
                                            Z_BUF_ERROR: -5,
                                            Z_NO_COMPRESSION: 0,
                                            Z_BEST_SPEED: 1,
                                            Z_BEST_COMPRESSION: 9,
                                            Z_DEFAULT_COMPRESSION: -1,
                                            Z_FILTERED: 1,
                                            Z_HUFFMAN_ONLY: 2,
                                            Z_RLE: 3,
                                            Z_FIXED: 4,
                                            Z_DEFAULT_STRATEGY: 0,
                                            Z_BINARY: 0,
                                            Z_TEXT: 1,
                                            Z_UNKNOWN: 2,
                                            Z_DEFLATED: 8
                                        };
                                    },
                                    {}
                                ],
                                45: [
                                    function(e, t, r) {
                                        var n = function() {
                                            for(var e, t = [], r = 0; r < 256; r++){
                                                e = r;
                                                for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                                                t[r] = e;
                                            }
                                            return t;
                                        }();
                                        t.exports = function(e, t, r, i) {
                                            var s = n, o = i + r;
                                            e ^= -1;
                                            for(var a = i; a < o; a++)e = e >>> 8 ^ s[255 & (e ^ t[a])];
                                            return -1 ^ e;
                                        };
                                    },
                                    {}
                                ],
                                46: [
                                    function(e, t, r) {
                                        var n, i = e("../utils/common"), s = e("./trees"), o = e("./adler32"), a = e("./crc32"), l = e("./messages"), c = -2, u = 258, h = 262, f = 113;
                                        function d(e, t) {
                                            return e.msg = l[t], t;
                                        }
                                        function p(e) {
                                            return (e << 1) - (4 < e ? 9 : 0);
                                        }
                                        function m(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        function b(e) {
                                            var t = e.state, r = t.pending;
                                            r > e.avail_out && (r = e.avail_out), 0 !== r && (i.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                                        }
                                        function g(e, t) {
                                            s._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, b(e.strm);
                                        }
                                        function y(e, t) {
                                            e.pending_buf[e.pending++] = t;
                                        }
                                        function v(e, t) {
                                            e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                                        }
                                        function w(e, t) {
                                            var r, n, i = e.max_chain_length, s = e.strstart, o = e.prev_length, a = e.nice_match, l = e.strstart > e.w_size - h ? e.strstart - (e.w_size - h) : 0, c = e.window, f = e.w_mask, d = e.prev, p = e.strstart + u, m = c[s + o - 1], b = c[s + o];
                                            e.prev_length >= e.good_match && (i >>= 2), a > e.lookahead && (a = e.lookahead);
                                            do if (c[(r = t) + o] === b && c[r + o - 1] === m && c[r] === c[s] && c[++r] === c[s + 1]) {
                                                s += 2, r++;
                                                do ;
                                                while (c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && c[++s] === c[++r] && s < p);
                                                if (n = u - (p - s), s = p - u, o < n) {
                                                    if (e.match_start = t, a <= (o = n)) break;
                                                    m = c[s + o - 1], b = c[s + o];
                                                }
                                            }
                                            while ((t = d[t & f]) > l && 0 != --i);
                                            return o <= e.lookahead ? o : e.lookahead;
                                        }
                                        function _(e) {
                                            var t, r, n, s, l, c, u, f, d, p, m = e.w_size;
                                            do {
                                                if (s = e.window_size - e.lookahead - e.strstart, e.strstart >= m + (m - h)) {
                                                    for(i.arraySet(e.window, e.window, m, m, 0), e.match_start -= m, e.strstart -= m, e.block_start -= m, t = r = e.hash_size; n = e.head[--t], e.head[t] = m <= n ? n - m : 0, --r;);
                                                    for(t = r = m; n = e.prev[--t], e.prev[t] = m <= n ? n - m : 0, --r;);
                                                    s += m;
                                                }
                                                if (0 === e.strm.avail_in) break;
                                                if (c = e.strm, u = e.window, f = e.strstart + e.lookahead, p = void 0, (d = s) < (p = c.avail_in) && (p = d), r = 0 === p ? 0 : (c.avail_in -= p, i.arraySet(u, c.input, c.next_in, p, f), 1 === c.state.wrap ? c.adler = o(c.adler, u, p, f) : 2 === c.state.wrap && (c.adler = a(c.adler, u, p, f)), c.next_in += p, c.total_in += p, p), e.lookahead += r, e.lookahead + e.insert >= 3) for(l = e.strstart - e.insert, e.ins_h = e.window[l], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[l + 3 - 1]) & e.hash_mask, e.prev[l & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = l, l++, e.insert--, !(e.lookahead + e.insert < 3)););
                                            }while (e.lookahead < h && 0 !== e.strm.avail_in);
                                        }
                                        function x(e, t) {
                                            for(var r, n;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r)), e.match_length >= 3) {
                                                    if (n = s._tr_tally(e, e.strstart - e.match_start, e.match_length - 3), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= 3) {
                                                        for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                                        e.strstart++;
                                                    } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                                                } else n = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                                                if (n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                            }
                                            return e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function k(e, t) {
                                            for(var r, n, i;;){
                                                if (e.lookahead < h) {
                                                    if (_(e), e.lookahead < h && 0 === t) return 1;
                                                    if (0 === e.lookahead) break;
                                                }
                                                if (r = 0, e.lookahead >= 3 && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = 2, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - h && (e.match_length = w(e, r), e.match_length <= 5 && (1 === e.strategy || 3 === e.match_length && 4096 < e.strstart - e.match_start) && (e.match_length = 2)), e.prev_length >= 3 && e.match_length <= e.prev_length) {
                                                    for(i = e.strstart + e.lookahead - 3, n = s._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - 3), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 3 - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                                                    if (e.match_available = 0, e.match_length = 2, e.strstart++, n && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                } else if (e.match_available) {
                                                    if ((n = s._tr_tally(e, 0, e.window[e.strstart - 1])) && g(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return 1;
                                                } else e.match_available = 1, e.strstart++, e.lookahead--;
                                            }
                                            return e.match_available && (n = s._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < 2 ? e.strstart : 2, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                        }
                                        function S(e, t, r, n, i) {
                                            this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                                        }
                                        function M() {
                                            this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = 8, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new i.Buf16(1146), this.dyn_dtree = new i.Buf16(122), this.bl_tree = new i.Buf16(78), m(this.dyn_ltree), m(this.dyn_dtree), m(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new i.Buf16(16), this.heap = new i.Buf16(573), m(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new i.Buf16(573), m(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                                        }
                                        function C(e) {
                                            var t;
                                            return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = 2, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? 42 : f, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = 0, s._tr_init(t), 0) : d(e, c);
                                        }
                                        function T(e) {
                                            var t = C(e);
                                            return 0 === t && function(e) {
                                                e.window_size = 2 * e.w_size, m(e.head), e.max_lazy_match = n[e.level].max_lazy, e.good_match = n[e.level].good_length, e.nice_match = n[e.level].nice_length, e.max_chain_length = n[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = 2, e.match_available = 0, e.ins_h = 0;
                                            }(e.state), t;
                                        }
                                        function E(e, t, r, n, s, o) {
                                            if (!e) return c;
                                            var a = 1;
                                            if (-1 === t && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), s < 1 || 9 < s || 8 !== r || n < 8 || 15 < n || t < 0 || 9 < t || o < 0 || 4 < o) return d(e, c);
                                            8 === n && (n = 9);
                                            var l = new M;
                                            return (e.state = l).strm = e, l.wrap = a, l.gzhead = null, l.w_bits = n, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = s + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + 3 - 1) / 3), l.window = new i.Buf8(2 * l.w_size), l.head = new i.Buf16(l.hash_size), l.prev = new i.Buf16(l.w_size), l.lit_bufsize = 1 << s + 6, l.pending_buf_size = 4 * l.lit_bufsize, l.pending_buf = new i.Buf8(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = o, l.method = r, T(e);
                                        }
                                        n = [
                                            new S(0, 0, 0, 0, function(e, t) {
                                                var r = 65535;
                                                for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                                                    if (e.lookahead <= 1) {
                                                        if (_(e), 0 === e.lookahead && 0 === t) return 1;
                                                        if (0 === e.lookahead) break;
                                                    }
                                                    e.strstart += e.lookahead, e.lookahead = 0;
                                                    var n = e.block_start + r;
                                                    if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    if (e.strstart - e.block_start >= e.w_size - h && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                }
                                                return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : (e.strstart > e.block_start && (g(e, !1), e.strm.avail_out), 1);
                                            }),
                                            new S(4, 4, 8, 4, x),
                                            new S(4, 5, 16, 8, x),
                                            new S(4, 6, 32, 32, x),
                                            new S(4, 4, 16, 16, k),
                                            new S(8, 16, 32, 32, k),
                                            new S(8, 16, 128, 128, k),
                                            new S(8, 32, 128, 256, k),
                                            new S(32, 128, 258, 1024, k),
                                            new S(32, 258, 258, 4096, k)
                                        ], r.deflateInit = function(e, t) {
                                            return E(e, t, 8, 15, 8, 0);
                                        }, r.deflateInit2 = E, r.deflateReset = T, r.deflateResetKeep = C, r.deflateSetHeader = function(e, t) {
                                            return e && e.state ? 2 !== e.state.wrap ? c : (e.state.gzhead = t, 0) : c;
                                        }, r.deflate = function(e, t) {
                                            var r, i, o, l;
                                            if (!e || !e.state || 5 < t || t < 0) return e ? d(e, c) : c;
                                            if (i = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === i.status && 4 !== t) return d(e, 0 === e.avail_out ? -5 : c);
                                            if (i.strm = e, r = i.last_flush, i.last_flush = t, 42 === i.status) {
                                                if (2 === i.wrap) e.adler = 0, y(i, 31), y(i, 139), y(i, 8), i.gzhead ? (y(i, (i.gzhead.text ? 1 : 0) + (i.gzhead.hcrc ? 2 : 0) + (i.gzhead.extra ? 4 : 0) + (i.gzhead.name ? 8 : 0) + (i.gzhead.comment ? 16 : 0)), y(i, 255 & i.gzhead.time), y(i, i.gzhead.time >> 8 & 255), y(i, i.gzhead.time >> 16 & 255), y(i, i.gzhead.time >> 24 & 255), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 255 & i.gzhead.os), i.gzhead.extra && i.gzhead.extra.length && (y(i, 255 & i.gzhead.extra.length), y(i, i.gzhead.extra.length >> 8 & 255)), i.gzhead.hcrc && (e.adler = a(e.adler, i.pending_buf, i.pending, 0)), i.gzindex = 0, i.status = 69) : (y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 0), y(i, 9 === i.level ? 2 : 2 <= i.strategy || i.level < 2 ? 4 : 0), y(i, 3), i.status = f);
                                                else {
                                                    var h = 8 + (i.w_bits - 8 << 4) << 8;
                                                    h |= (2 <= i.strategy || i.level < 2 ? 0 : i.level < 6 ? 1 : 6 === i.level ? 2 : 3) << 6, 0 !== i.strstart && (h |= 32), h += 31 - h % 31, i.status = f, v(i, h), 0 !== i.strstart && (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), e.adler = 1;
                                                }
                                            }
                                            if (69 === i.status) {
                                                if (i.gzhead.extra) {
                                                    for(o = i.pending; i.gzindex < (65535 & i.gzhead.extra.length) && (i.pending !== i.pending_buf_size || (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending !== i.pending_buf_size));)y(i, 255 & i.gzhead.extra[i.gzindex]), i.gzindex++;
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), i.gzindex === i.gzhead.extra.length && (i.gzindex = 0, i.status = 73);
                                                } else i.status = 73;
                                            }
                                            if (73 === i.status) {
                                                if (i.gzhead.name) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.name.length ? 255 & i.gzhead.name.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.gzindex = 0, i.status = 91);
                                                } else i.status = 91;
                                            }
                                            if (91 === i.status) {
                                                if (i.gzhead.comment) {
                                                    o = i.pending;
                                                    do {
                                                        if (i.pending === i.pending_buf_size && (i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), b(e), o = i.pending, i.pending === i.pending_buf_size)) {
                                                            l = 1;
                                                            break;
                                                        }
                                                        l = i.gzindex < i.gzhead.comment.length ? 255 & i.gzhead.comment.charCodeAt(i.gzindex++) : 0, y(i, l);
                                                    }while (0 !== l);
                                                    i.gzhead.hcrc && i.pending > o && (e.adler = a(e.adler, i.pending_buf, i.pending - o, o)), 0 === l && (i.status = 103);
                                                } else i.status = 103;
                                            }
                                            if (103 === i.status && (i.gzhead.hcrc ? (i.pending + 2 > i.pending_buf_size && b(e), i.pending + 2 <= i.pending_buf_size && (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), e.adler = 0, i.status = f)) : i.status = f), 0 !== i.pending) {
                                                if (b(e), 0 === e.avail_out) return i.last_flush = -1, 0;
                                            } else if (0 === e.avail_in && p(t) <= p(r) && 4 !== t) return d(e, -5);
                                            if (666 === i.status && 0 !== e.avail_in) return d(e, -5);
                                            if (0 !== e.avail_in || 0 !== i.lookahead || 0 !== t && 666 !== i.status) {
                                                var w = 2 === i.strategy ? function(e, t) {
                                                    for(var r;;){
                                                        if (0 === e.lookahead && (_(e), 0 === e.lookahead)) {
                                                            if (0 === t) return 1;
                                                            break;
                                                        }
                                                        if (e.match_length = 0, r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : 3 === i.strategy ? function(e, t) {
                                                    for(var r, n, i, o, a = e.window;;){
                                                        if (e.lookahead <= u) {
                                                            if (_(e), e.lookahead <= u && 0 === t) return 1;
                                                            if (0 === e.lookahead) break;
                                                        }
                                                        if (e.match_length = 0, e.lookahead >= 3 && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                                            o = e.strstart + u;
                                                            do ;
                                                            while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < o);
                                                            e.match_length = u - (o - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                                        }
                                                        if (e.match_length >= 3 ? (r = s._tr_tally(e, 1, e.match_length - 3), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = s._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (g(e, !1), 0 === e.strm.avail_out)) return 1;
                                                    }
                                                    return e.insert = 0, 4 === t ? (g(e, !0), 0 === e.strm.avail_out ? 3 : 4) : e.last_lit && (g(e, !1), 0 === e.strm.avail_out) ? 1 : 2;
                                                }(i, t) : n[i.level].func(i, t);
                                                if (3 !== w && 4 !== w || (i.status = 666), 1 === w || 3 === w) return 0 === e.avail_out && (i.last_flush = -1), 0;
                                                if (2 === w && (1 === t ? s._tr_align(i) : 5 !== t && (s._tr_stored_block(i, 0, 0, !1), 3 === t && (m(i.head), 0 === i.lookahead && (i.strstart = 0, i.block_start = 0, i.insert = 0))), b(e), 0 === e.avail_out)) return i.last_flush = -1, 0;
                                            }
                                            return 4 !== t ? 0 : i.wrap <= 0 ? 1 : (2 === i.wrap ? (y(i, 255 & e.adler), y(i, e.adler >> 8 & 255), y(i, e.adler >> 16 & 255), y(i, e.adler >> 24 & 255), y(i, 255 & e.total_in), y(i, e.total_in >> 8 & 255), y(i, e.total_in >> 16 & 255), y(i, e.total_in >> 24 & 255)) : (v(i, e.adler >>> 16), v(i, 65535 & e.adler)), b(e), 0 < i.wrap && (i.wrap = -i.wrap), 0 !== i.pending ? 0 : 1);
                                        }, r.deflateEnd = function(e) {
                                            var t;
                                            return e && e.state ? 42 !== (t = e.state.status) && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== f && 666 !== t ? d(e, c) : (e.state = null, t === f ? d(e, -3) : 0) : c;
                                        }, r.deflateSetDictionary = function(e, t) {
                                            var r, n, s, a, l, u, h, f, d = t.length;
                                            if (!e || !e.state) return c;
                                            if (2 === (a = (r = e.state).wrap) || 1 === a && 42 !== r.status || r.lookahead) return c;
                                            for(1 === a && (e.adler = o(e.adler, t, d, 0)), r.wrap = 0, d >= r.w_size && (0 === a && (m(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), f = new i.Buf8(r.w_size), i.arraySet(f, t, d - r.w_size, r.w_size, 0), t = f, d = r.w_size), l = e.avail_in, u = e.next_in, h = e.input, e.avail_in = d, e.next_in = 0, e.input = t, _(r); r.lookahead >= 3;){
                                                for(n = r.strstart, s = r.lookahead - 2; r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + 3 - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --s;);
                                                r.strstart = n, r.lookahead = 2, _(r);
                                            }
                                            return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = 2, r.match_available = 0, e.next_in = u, e.input = h, e.avail_in = l, r.wrap = a, 0;
                                        }, r.deflateInfo = "pako deflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./messages": 51,
                                        "./trees": 52
                                    }
                                ],
                                47: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                                        };
                                    },
                                    {}
                                ],
                                48: [
                                    function(e, t, r) {
                                        t.exports = function(e, t) {
                                            var r, n, i, s, o, a, l, c, u, h, f, d, p, m, b, g, y, v, w, _, x, k, S, M, C;
                                            r = e.state, n = e.next_in, M = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, o = s - (t - e.avail_out), a = s + (e.avail_out - 257), l = r.dmax, c = r.wsize, u = r.whave, h = r.wnext, f = r.window, d = r.hold, p = r.bits, m = r.lencode, b = r.distcode, g = (1 << r.lenbits) - 1, y = (1 << r.distbits) - 1;
                                            e: do {
                                                p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = m[d & g];
                                                t: for(;;){
                                                    if (d >>>= w = v >>> 24, p -= w, 0 == (w = v >>> 16 & 255)) C[s++] = 65535 & v;
                                                    else {
                                                        if (!(16 & w)) {
                                                            if (0 == (64 & w)) {
                                                                v = m[(65535 & v) + (d & (1 << w) - 1)];
                                                                continue t;
                                                            }
                                                            if (32 & w) {
                                                                r.mode = 12;
                                                                break e;
                                                            }
                                                            e.msg = "invalid literal/length code", r.mode = 30;
                                                            break e;
                                                        }
                                                        _ = 65535 & v, (w &= 15) && (p < w && (d += M[n++] << p, p += 8), _ += d & (1 << w) - 1, d >>>= w, p -= w), p < 15 && (d += M[n++] << p, p += 8, d += M[n++] << p, p += 8), v = b[d & y];
                                                        r: for(;;){
                                                            if (d >>>= w = v >>> 24, p -= w, !(16 & (w = v >>> 16 & 255))) {
                                                                if (0 == (64 & w)) {
                                                                    v = b[(65535 & v) + (d & (1 << w) - 1)];
                                                                    continue r;
                                                                }
                                                                e.msg = "invalid distance code", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (x = 65535 & v, p < (w &= 15) && (d += M[n++] << p, (p += 8) < w && (d += M[n++] << p, p += 8)), l < (x += d & (1 << w) - 1)) {
                                                                e.msg = "invalid distance too far back", r.mode = 30;
                                                                break e;
                                                            }
                                                            if (d >>>= w, p -= w, (w = s - o) < x) {
                                                                if (u < (w = x - w) && r.sane) {
                                                                    e.msg = "invalid distance too far back", r.mode = 30;
                                                                    break e;
                                                                }
                                                                if (S = f, (k = 0) === h) {
                                                                    if (k += c - w, w < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        k = s - x, S = C;
                                                                    }
                                                                } else if (h < w) {
                                                                    if (k += c + h - w, (w -= h) < _) {
                                                                        for(_ -= w; C[s++] = f[k++], --w;);
                                                                        if (k = 0, h < _) {
                                                                            for(_ -= w = h; C[s++] = f[k++], --w;);
                                                                            k = s - x, S = C;
                                                                        }
                                                                    }
                                                                } else if (k += h - w, w < _) {
                                                                    for(_ -= w; C[s++] = f[k++], --w;);
                                                                    k = s - x, S = C;
                                                                }
                                                                for(; 2 < _;)C[s++] = S[k++], C[s++] = S[k++], C[s++] = S[k++], _ -= 3;
                                                                _ && (C[s++] = S[k++], 1 < _ && (C[s++] = S[k++]));
                                                            } else {
                                                                for(k = s - x; C[s++] = C[k++], C[s++] = C[k++], C[s++] = C[k++], 2 < (_ -= 3););
                                                                _ && (C[s++] = C[k++], 1 < _ && (C[s++] = C[k++]));
                                                            }
                                                            break;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }while (n < i && s < a);
                                            n -= _ = p >> 3, d &= (1 << (p -= _ << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < a ? a - s + 257 : 257 - (s - a), r.hold = d, r.bits = p;
                                        };
                                    },
                                    {}
                                ],
                                49: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = e("./adler32"), s = e("./crc32"), o = e("./inffast"), a = e("./inftrees"), l = -2;
                                        function c(e) {
                                            return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                                        }
                                        function u() {
                                            this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new n.Buf16(320), this.work = new n.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                                        }
                                        function h(e) {
                                            var t;
                                            return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = 1, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new n.Buf32(852), t.distcode = t.distdyn = new n.Buf32(592), t.sane = 1, t.back = -1, 0) : l;
                                        }
                                        function f(e) {
                                            var t;
                                            return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, h(e)) : l;
                                        }
                                        function d(e, t) {
                                            var r, n;
                                            return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? l : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, f(e))) : l;
                                        }
                                        function p(e, t) {
                                            var r, n;
                                            return e ? (n = new u, (e.state = n).window = null, 0 !== (r = d(e, t)) && (e.state = null), r) : l;
                                        }
                                        var m, b, g = !0;
                                        function y(e) {
                                            if (g) {
                                                var t;
                                                for(m = new n.Buf32(512), b = new n.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                                                for(; t < 256;)e.lens[t++] = 9;
                                                for(; t < 280;)e.lens[t++] = 7;
                                                for(; t < 288;)e.lens[t++] = 8;
                                                for(a(1, e.lens, 0, 288, m, 0, e.work, {
                                                    bits: 9
                                                }), t = 0; t < 32;)e.lens[t++] = 5;
                                                a(2, e.lens, 0, 32, b, 0, e.work, {
                                                    bits: 5
                                                }), g = !1;
                                            }
                                            e.lencode = m, e.lenbits = 9, e.distcode = b, e.distbits = 5;
                                        }
                                        function v(e, t, r, i) {
                                            var s, o = e.state;
                                            return null === o.window && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new n.Buf8(o.wsize)), i >= o.wsize ? (n.arraySet(o.window, t, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (i < (s = o.wsize - o.wnext) && (s = i), n.arraySet(o.window, t, r - i, s, o.wnext), (i -= s) ? (n.arraySet(o.window, t, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += s, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += s))), 0;
                                        }
                                        r.inflateReset = f, r.inflateReset2 = d, r.inflateResetKeep = h, r.inflateInit = function(e) {
                                            return p(e, 15);
                                        }, r.inflateInit2 = p, r.inflate = function(e, t) {
                                            var r, u, h, f, d, p, m, b, g, w, _, x, k, S, M, C, T, E, A, R, O, j, I, N, P = 0, B = new n.Buf8(4), D = [
                                                16,
                                                17,
                                                18,
                                                0,
                                                8,
                                                7,
                                                9,
                                                6,
                                                10,
                                                5,
                                                11,
                                                4,
                                                12,
                                                3,
                                                13,
                                                2,
                                                14,
                                                1,
                                                15
                                            ];
                                            if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return l;
                                            12 === (r = e.state).mode && (r.mode = 13), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, w = p, _ = m, j = 0;
                                            e: for(;;)switch(r.mode){
                                                case 1:
                                                    if (0 === r.wrap) {
                                                        r.mode = 13;
                                                        break;
                                                    }
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (2 & r.wrap && 35615 === b) {
                                                        B[r.check = 0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0), g = b = 0, r.mode = 2;
                                                        break;
                                                    }
                                                    if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & b) << 8) + (b >> 8)) % 31) {
                                                        e.msg = "incorrect header check", r.mode = 30;
                                                        break;
                                                    }
                                                    if (8 != (15 & b)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (g -= 4, O = 8 + (15 & (b >>>= 4)), 0 === r.wbits) r.wbits = O;
                                                    else if (O > r.wbits) {
                                                        e.msg = "invalid window size", r.mode = 30;
                                                        break;
                                                    }
                                                    r.dmax = 1 << O, e.adler = r.check = 1, r.mode = 512 & b ? 10 : 12, g = b = 0;
                                                    break;
                                                case 2:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.flags = b, 8 != (255 & r.flags)) {
                                                        e.msg = "unknown compression method", r.mode = 30;
                                                        break;
                                                    }
                                                    if (57344 & r.flags) {
                                                        e.msg = "unknown header flags set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.head && (r.head.text = b >> 8 & 1), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 3;
                                                case 3:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.time = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, B[2] = b >>> 16 & 255, B[3] = b >>> 24 & 255, r.check = s(r.check, B, 4, 0)), g = b = 0, r.mode = 4;
                                                case 4:
                                                    for(; g < 16;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    r.head && (r.head.xflags = 255 & b, r.head.os = b >> 8), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0, r.mode = 5;
                                                case 5:
                                                    if (1024 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length = b, r.head && (r.head.extra_len = b), 512 & r.flags && (B[0] = 255 & b, B[1] = b >>> 8 & 255, r.check = s(r.check, B, 2, 0)), g = b = 0;
                                                    } else r.head && (r.head.extra = null);
                                                    r.mode = 6;
                                                case 6:
                                                    if (1024 & r.flags && (p < (x = r.length) && (x = p), x && (r.head && (O = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), n.arraySet(r.head.extra, u, f, x, O)), 512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, r.length -= x), r.length)) break e;
                                                    r.length = 0, r.mode = 7;
                                                case 7:
                                                    if (2048 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.name += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.name = null);
                                                    r.length = 0, r.mode = 8;
                                                case 8:
                                                    if (4096 & r.flags) {
                                                        if (0 === p) break e;
                                                        for(x = 0; O = u[f + x++], r.head && O && r.length < 65536 && (r.head.comment += String.fromCharCode(O)), O && x < p;);
                                                        if (512 & r.flags && (r.check = s(r.check, u, x, f)), p -= x, f += x, O) break e;
                                                    } else r.head && (r.head.comment = null);
                                                    r.mode = 9;
                                                case 9:
                                                    if (512 & r.flags) {
                                                        for(; g < 16;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (65535 & r.check)) {
                                                            e.msg = "header crc mismatch", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                                                    break;
                                                case 10:
                                                    for(; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    e.adler = r.check = c(b), g = b = 0, r.mode = 11;
                                                case 11:
                                                    if (0 === r.havedict) return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, 2;
                                                    e.adler = r.check = 1, r.mode = 12;
                                                case 12:
                                                    if (5 === t || 6 === t) break e;
                                                case 13:
                                                    if (r.last) {
                                                        b >>>= 7 & g, g -= 7 & g, r.mode = 27;
                                                        break;
                                                    }
                                                    for(; g < 3;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    switch(r.last = 1 & b, g -= 1, 3 & (b >>>= 1)){
                                                        case 0:
                                                            r.mode = 14;
                                                            break;
                                                        case 1:
                                                            if (y(r), r.mode = 20, 6 !== t) break;
                                                            b >>>= 2, g -= 2;
                                                            break e;
                                                        case 2:
                                                            r.mode = 17;
                                                            break;
                                                        case 3:
                                                            e.msg = "invalid block type", r.mode = 30;
                                                    }
                                                    b >>>= 2, g -= 2;
                                                    break;
                                                case 14:
                                                    for(b >>>= 7 & g, g -= 7 & g; g < 32;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if ((65535 & b) != (b >>> 16 ^ 65535)) {
                                                        e.msg = "invalid stored block lengths", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.length = 65535 & b, g = b = 0, r.mode = 15, 6 === t) break e;
                                                case 15:
                                                    r.mode = 16;
                                                case 16:
                                                    if (x = r.length) {
                                                        if (p < x && (x = p), m < x && (x = m), 0 === x) break e;
                                                        n.arraySet(h, u, f, x, d), p -= x, f += x, m -= x, d += x, r.length -= x;
                                                        break;
                                                    }
                                                    r.mode = 12;
                                                    break;
                                                case 17:
                                                    for(; g < 14;){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (r.nlen = 257 + (31 & b), b >>>= 5, g -= 5, r.ndist = 1 + (31 & b), b >>>= 5, g -= 5, r.ncode = 4 + (15 & b), b >>>= 4, g -= 4, 286 < r.nlen || 30 < r.ndist) {
                                                        e.msg = "too many length or distance symbols", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 18;
                                                case 18:
                                                    for(; r.have < r.ncode;){
                                                        for(; g < 3;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.lens[D[r.have++]] = 7 & b, b >>>= 3, g -= 3;
                                                    }
                                                    for(; r.have < 19;)r.lens[D[r.have++]] = 0;
                                                    if (r.lencode = r.lendyn, r.lenbits = 7, I = {
                                                        bits: r.lenbits
                                                    }, j = a(0, r.lens, 0, 19, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid code lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    r.have = 0, r.mode = 19;
                                                case 19:
                                                    for(; r.have < r.nlen + r.ndist;){
                                                        for(; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (T < 16) b >>>= M, g -= M, r.lens[r.have++] = T;
                                                        else {
                                                            if (16 === T) {
                                                                for(N = M + 2; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                if (b >>>= M, g -= M, 0 === r.have) {
                                                                    e.msg = "invalid bit length repeat", r.mode = 30;
                                                                    break;
                                                                }
                                                                O = r.lens[r.have - 1], x = 3 + (3 & b), b >>>= 2, g -= 2;
                                                            } else if (17 === T) {
                                                                for(N = M + 3; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 3 + (7 & (b >>>= M)), b >>>= 3, g -= 3;
                                                            } else {
                                                                for(N = M + 7; g < N;){
                                                                    if (0 === p) break e;
                                                                    p--, b += u[f++] << g, g += 8;
                                                                }
                                                                g -= M, O = 0, x = 11 + (127 & (b >>>= M)), b >>>= 7, g -= 7;
                                                            }
                                                            if (r.have + x > r.nlen + r.ndist) {
                                                                e.msg = "invalid bit length repeat", r.mode = 30;
                                                                break;
                                                            }
                                                            for(; x--;)r.lens[r.have++] = O;
                                                        }
                                                    }
                                                    if (30 === r.mode) break;
                                                    if (0 === r.lens[256]) {
                                                        e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.lenbits = 9, I = {
                                                        bits: r.lenbits
                                                    }, j = a(1, r.lens, 0, r.nlen, r.lencode, 0, r.work, I), r.lenbits = I.bits, j) {
                                                        e.msg = "invalid literal/lengths set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.distbits = 6, r.distcode = r.distdyn, I = {
                                                        bits: r.distbits
                                                    }, j = a(2, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, I), r.distbits = I.bits, j) {
                                                        e.msg = "invalid distances set", r.mode = 30;
                                                        break;
                                                    }
                                                    if (r.mode = 20, 6 === t) break e;
                                                case 20:
                                                    r.mode = 21;
                                                case 21:
                                                    if (6 <= p && 258 <= m) {
                                                        e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, o(e, _), d = e.next_out, h = e.output, m = e.avail_out, f = e.next_in, u = e.input, p = e.avail_in, b = r.hold, g = r.bits, 12 === r.mode && (r.back = -1);
                                                        break;
                                                    }
                                                    for(r.back = 0; C = (P = r.lencode[b & (1 << r.lenbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (C && 0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.lencode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, r.length = T, 0 === C) {
                                                        r.mode = 26;
                                                        break;
                                                    }
                                                    if (32 & C) {
                                                        r.back = -1, r.mode = 12;
                                                        break;
                                                    }
                                                    if (64 & C) {
                                                        e.msg = "invalid literal/length code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.extra = 15 & C, r.mode = 22;
                                                case 22:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.length += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    r.was = r.length, r.mode = 23;
                                                case 23:
                                                    for(; C = (P = r.distcode[b & (1 << r.distbits) - 1]) >>> 16 & 255, T = 65535 & P, !((M = P >>> 24) <= g);){
                                                        if (0 === p) break e;
                                                        p--, b += u[f++] << g, g += 8;
                                                    }
                                                    if (0 == (240 & C)) {
                                                        for(E = M, A = C, R = T; C = (P = r.distcode[R + ((b & (1 << E + A) - 1) >> E)]) >>> 16 & 255, T = 65535 & P, !(E + (M = P >>> 24) <= g);){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        b >>>= E, g -= E, r.back += E;
                                                    }
                                                    if (b >>>= M, g -= M, r.back += M, 64 & C) {
                                                        e.msg = "invalid distance code", r.mode = 30;
                                                        break;
                                                    }
                                                    r.offset = T, r.extra = 15 & C, r.mode = 24;
                                                case 24:
                                                    if (r.extra) {
                                                        for(N = r.extra; g < N;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        r.offset += b & (1 << r.extra) - 1, b >>>= r.extra, g -= r.extra, r.back += r.extra;
                                                    }
                                                    if (r.offset > r.dmax) {
                                                        e.msg = "invalid distance too far back", r.mode = 30;
                                                        break;
                                                    }
                                                    r.mode = 25;
                                                case 25:
                                                    if (0 === m) break e;
                                                    if (x = _ - m, r.offset > x) {
                                                        if ((x = r.offset - x) > r.whave && r.sane) {
                                                            e.msg = "invalid distance too far back", r.mode = 30;
                                                            break;
                                                        }
                                                        k = x > r.wnext ? (x -= r.wnext, r.wsize - x) : r.wnext - x, x > r.length && (x = r.length), S = r.window;
                                                    } else S = h, k = d - r.offset, x = r.length;
                                                    for(m < x && (x = m), m -= x, r.length -= x; h[d++] = S[k++], --x;);
                                                    0 === r.length && (r.mode = 21);
                                                    break;
                                                case 26:
                                                    if (0 === m) break e;
                                                    h[d++] = r.length, m--, r.mode = 21;
                                                    break;
                                                case 27:
                                                    if (r.wrap) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b |= u[f++] << g, g += 8;
                                                        }
                                                        if (_ -= m, e.total_out += _, r.total += _, _ && (e.adler = r.check = r.flags ? s(r.check, h, _, d - _) : i(r.check, h, _, d - _)), _ = m, (r.flags ? b : c(b)) !== r.check) {
                                                            e.msg = "incorrect data check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 28;
                                                case 28:
                                                    if (r.wrap && r.flags) {
                                                        for(; g < 32;){
                                                            if (0 === p) break e;
                                                            p--, b += u[f++] << g, g += 8;
                                                        }
                                                        if (b !== (4294967295 & r.total)) {
                                                            e.msg = "incorrect length check", r.mode = 30;
                                                            break;
                                                        }
                                                        g = b = 0;
                                                    }
                                                    r.mode = 29;
                                                case 29:
                                                    j = 1;
                                                    break e;
                                                case 30:
                                                    j = -3;
                                                    break e;
                                                case 31:
                                                    return -4;
                                                case 32:
                                                default:
                                                    return l;
                                            }
                                            return e.next_out = d, e.avail_out = m, e.next_in = f, e.avail_in = p, r.hold = b, r.bits = g, (r.wsize || _ !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && v(e, e.output, e.next_out, _ - e.avail_out) ? (r.mode = 31, -4) : (w -= e.avail_in, _ -= e.avail_out, e.total_in += w, e.total_out += _, r.total += _, r.wrap && _ && (e.adler = r.check = r.flags ? s(r.check, h, _, e.next_out - _) : i(r.check, h, _, e.next_out - _)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == w && 0 === _ || 4 === t) && 0 === j && (j = -5), j);
                                        }, r.inflateEnd = function(e) {
                                            if (!e || !e.state) return l;
                                            var t = e.state;
                                            return t.window && (t.window = null), e.state = null, 0;
                                        }, r.inflateGetHeader = function(e, t) {
                                            var r;
                                            return e && e.state ? 0 == (2 & (r = e.state).wrap) ? l : ((r.head = t).done = !1, 0) : l;
                                        }, r.inflateSetDictionary = function(e, t) {
                                            var r, n = t.length;
                                            return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? l : 11 === r.mode && i(1, t, n, 0) !== r.check ? -3 : v(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, 0) : l;
                                        }, r.inflateInfo = "pako inflate (from Nodeca project)";
                                    },
                                    {
                                        "../utils/common": 41,
                                        "./adler32": 43,
                                        "./crc32": 45,
                                        "./inffast": 48,
                                        "./inftrees": 50
                                    }
                                ],
                                50: [
                                    function(e, t, r) {
                                        var n = e("../utils/common"), i = [
                                            3,
                                            4,
                                            5,
                                            6,
                                            7,
                                            8,
                                            9,
                                            10,
                                            11,
                                            13,
                                            15,
                                            17,
                                            19,
                                            23,
                                            27,
                                            31,
                                            35,
                                            43,
                                            51,
                                            59,
                                            67,
                                            83,
                                            99,
                                            115,
                                            131,
                                            163,
                                            195,
                                            227,
                                            258,
                                            0,
                                            0
                                        ], s = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            17,
                                            17,
                                            18,
                                            18,
                                            18,
                                            18,
                                            19,
                                            19,
                                            19,
                                            19,
                                            20,
                                            20,
                                            20,
                                            20,
                                            21,
                                            21,
                                            21,
                                            21,
                                            16,
                                            72,
                                            78
                                        ], o = [
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            7,
                                            9,
                                            13,
                                            17,
                                            25,
                                            33,
                                            49,
                                            65,
                                            97,
                                            129,
                                            193,
                                            257,
                                            385,
                                            513,
                                            769,
                                            1025,
                                            1537,
                                            2049,
                                            3073,
                                            4097,
                                            6145,
                                            8193,
                                            12289,
                                            16385,
                                            24577,
                                            0,
                                            0
                                        ], a = [
                                            16,
                                            16,
                                            16,
                                            16,
                                            17,
                                            17,
                                            18,
                                            18,
                                            19,
                                            19,
                                            20,
                                            20,
                                            21,
                                            21,
                                            22,
                                            22,
                                            23,
                                            23,
                                            24,
                                            24,
                                            25,
                                            25,
                                            26,
                                            26,
                                            27,
                                            27,
                                            28,
                                            28,
                                            29,
                                            29,
                                            64,
                                            64
                                        ];
                                        t.exports = function(e, t, r, l, c, u, h, f) {
                                            var d, p, m, b, g, y, v, w, _, x = f.bits, k = 0, S = 0, M = 0, C = 0, T = 0, E = 0, A = 0, R = 0, O = 0, j = 0, I = null, N = 0, P = new n.Buf16(16), B = new n.Buf16(16), D = null, F = 0;
                                            for(k = 0; k <= 15; k++)P[k] = 0;
                                            for(S = 0; S < l; S++)P[t[r + S]]++;
                                            for(T = x, C = 15; 1 <= C && 0 === P[C]; C--);
                                            if (C < T && (T = C), 0 === C) return c[u++] = 20971520, c[u++] = 20971520, f.bits = 1, 0;
                                            for(M = 1; M < C && 0 === P[M]; M++);
                                            for(T < M && (T = M), k = R = 1; k <= 15; k++)if (R <<= 1, (R -= P[k]) < 0) return -1;
                                            if (0 < R && (0 === e || 1 !== C)) return -1;
                                            for(B[1] = 0, k = 1; k < 15; k++)B[k + 1] = B[k] + P[k];
                                            for(S = 0; S < l; S++)0 !== t[r + S] && (h[B[t[r + S]]++] = S);
                                            if (y = 0 === e ? (I = D = h, 19) : 1 === e ? (I = i, N -= 257, D = s, F -= 257, 256) : (I = o, D = a, -1), k = M, g = u, A = S = j = 0, m = -1, b = (O = 1 << (E = T)) - 1, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                            for(;;){
                                                for(v = k - A, _ = h[S] < y ? (w = 0, h[S]) : h[S] > y ? (w = D[F + h[S]], I[N + h[S]]) : (w = 96, 0), d = 1 << k - A, M = p = 1 << E; c[g + (j >> A) + (p -= d)] = v << 24 | w << 16 | _ | 0, 0 !== p;);
                                                for(d = 1 << k - 1; j & d;)d >>= 1;
                                                if (0 !== d ? (j &= d - 1, j += d) : j = 0, S++, 0 == --P[k]) {
                                                    if (k === C) break;
                                                    k = t[r + h[S]];
                                                }
                                                if (T < k && (j & b) !== m) {
                                                    for(0 === A && (A = T), g += M, R = 1 << (E = k - A); E + A < C && !((R -= P[E + A]) <= 0);)E++, R <<= 1;
                                                    if (O += 1 << E, 1 === e && 852 < O || 2 === e && 592 < O) return 1;
                                                    c[m = j & b] = T << 24 | E << 16 | g - u | 0;
                                                }
                                            }
                                            return 0 !== j && (c[g + j] = k - A << 24 | 4194304), f.bits = T, 0;
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                51: [
                                    function(e, t, r) {
                                        t.exports = {
                                            2: "need dictionary",
                                            1: "stream end",
                                            0: "",
                                            "-1": "file error",
                                            "-2": "stream error",
                                            "-3": "data error",
                                            "-4": "insufficient memory",
                                            "-5": "buffer error",
                                            "-6": "incompatible version"
                                        };
                                    },
                                    {}
                                ],
                                52: [
                                    function(e, t, r) {
                                        var n = e("../utils/common");
                                        function i(e) {
                                            for(var t = e.length; 0 <= --t;)e[t] = 0;
                                        }
                                        var s = 256, o = 286, a = 30, l = 15, c = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            1,
                                            1,
                                            2,
                                            2,
                                            2,
                                            2,
                                            3,
                                            3,
                                            3,
                                            3,
                                            4,
                                            4,
                                            4,
                                            4,
                                            5,
                                            5,
                                            5,
                                            5,
                                            0
                                        ], u = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            1,
                                            1,
                                            2,
                                            2,
                                            3,
                                            3,
                                            4,
                                            4,
                                            5,
                                            5,
                                            6,
                                            6,
                                            7,
                                            7,
                                            8,
                                            8,
                                            9,
                                            9,
                                            10,
                                            10,
                                            11,
                                            11,
                                            12,
                                            12,
                                            13,
                                            13
                                        ], h = [
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            0,
                                            2,
                                            3,
                                            7
                                        ], f = [
                                            16,
                                            17,
                                            18,
                                            0,
                                            8,
                                            7,
                                            9,
                                            6,
                                            10,
                                            5,
                                            11,
                                            4,
                                            12,
                                            3,
                                            13,
                                            2,
                                            14,
                                            1,
                                            15
                                        ], d = new Array(576);
                                        i(d);
                                        var p = new Array(60);
                                        i(p);
                                        var m = new Array(512);
                                        i(m);
                                        var b = new Array(256);
                                        i(b);
                                        var g = new Array(29);
                                        i(g);
                                        var y, v, w, _ = new Array(a);
                                        function x(e, t, r, n, i) {
                                            this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                                        }
                                        function k(e, t) {
                                            this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                                        }
                                        function S(e) {
                                            return e < 256 ? m[e] : m[256 + (e >>> 7)];
                                        }
                                        function M(e, t) {
                                            e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                                        }
                                        function C(e, t, r) {
                                            e.bi_valid > 16 - r ? (e.bi_buf |= t << e.bi_valid & 65535, M(e, e.bi_buf), e.bi_buf = t >> 16 - e.bi_valid, e.bi_valid += r - 16) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                                        }
                                        function T(e, t, r) {
                                            C(e, r[2 * t], r[2 * t + 1]);
                                        }
                                        function E(e, t) {
                                            for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                                            return r >>> 1;
                                        }
                                        function A(e, t, r) {
                                            var n, i, s = new Array(16), o = 0;
                                            for(n = 1; n <= l; n++)s[n] = o = o + r[n - 1] << 1;
                                            for(i = 0; i <= t; i++){
                                                var a = e[2 * i + 1];
                                                0 !== a && (e[2 * i] = E(s[a]++, a));
                                            }
                                        }
                                        function R(e) {
                                            var t;
                                            for(t = 0; t < o; t++)e.dyn_ltree[2 * t] = 0;
                                            for(t = 0; t < a; t++)e.dyn_dtree[2 * t] = 0;
                                            for(t = 0; t < 19; t++)e.bl_tree[2 * t] = 0;
                                            e.dyn_ltree[512] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                                        }
                                        function O(e) {
                                            8 < e.bi_valid ? M(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                                        }
                                        function j(e, t, r, n) {
                                            var i = 2 * t, s = 2 * r;
                                            return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                                        }
                                        function I(e, t, r) {
                                            for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && j(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !j(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                                            e.heap[r] = n;
                                        }
                                        function N(e, t, r) {
                                            var n, i, o, a, l = 0;
                                            if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * l] << 8 | e.pending_buf[e.d_buf + 2 * l + 1], i = e.pending_buf[e.l_buf + l], l++, 0 === n ? T(e, i, t) : (T(e, (o = b[i]) + s + 1, t), 0 !== (a = c[o]) && C(e, i -= g[o], a), T(e, o = S(--n), r), 0 !== (a = u[o]) && C(e, n -= _[o], a)), l < e.last_lit;);
                                            T(e, 256, t);
                                        }
                                        function P(e, t) {
                                            var r, n, i, s = t.dyn_tree, o = t.stat_desc.static_tree, a = t.stat_desc.has_stree, c = t.stat_desc.elems, u = -1;
                                            for(e.heap_len = 0, e.heap_max = 573, r = 0; r < c; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                                            for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, a && (e.static_len -= o[2 * i + 1]);
                                            for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)I(e, s, r);
                                            for(i = c; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], I(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, I(e, s, 1), 2 <= e.heap_len;);
                                            e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                                                var r, n, i, s, o, a, c = t.dyn_tree, u = t.max_code, h = t.stat_desc.static_tree, f = t.stat_desc.has_stree, d = t.stat_desc.extra_bits, p = t.stat_desc.extra_base, m = t.stat_desc.max_length, b = 0;
                                                for(s = 0; s <= l; s++)e.bl_count[s] = 0;
                                                for(c[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < 573; r++)m < (s = c[2 * c[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = m, b++), c[2 * n + 1] = s, u < n || (e.bl_count[s]++, o = 0, p <= n && (o = d[n - p]), a = c[2 * n], e.opt_len += a * (s + o), f && (e.static_len += a * (h[2 * n + 1] + o)));
                                                if (0 !== b) {
                                                    do {
                                                        for(s = m - 1; 0 === e.bl_count[s];)s--;
                                                        e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[m]--, b -= 2;
                                                    }while (0 < b);
                                                    for(s = m; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (c[2 * i + 1] !== s && (e.opt_len += (s - c[2 * i + 1]) * c[2 * i], c[2 * i + 1] = s), n--);
                                                }
                                            }(e, t), A(s, u, e.bl_count);
                                        }
                                        function B(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = o, o = t[2 * (n + 1) + 1], ++a < l && i === o || (a < c ? e.bl_tree[2 * i] += a : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[32]++) : a <= 10 ? e.bl_tree[34]++ : e.bl_tree[36]++, s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4));
                                        }
                                        function D(e, t, r) {
                                            var n, i, s = -1, o = t[1], a = 0, l = 7, c = 4;
                                            for(0 === o && (l = 138, c = 3), n = 0; n <= r; n++)if (i = o, o = t[2 * (n + 1) + 1], !(++a < l && i === o)) {
                                                if (a < c) for(; T(e, i, e.bl_tree), 0 != --a;);
                                                else 0 !== i ? (i !== s && (T(e, i, e.bl_tree), a--), T(e, 16, e.bl_tree), C(e, a - 3, 2)) : a <= 10 ? (T(e, 17, e.bl_tree), C(e, a - 3, 3)) : (T(e, 18, e.bl_tree), C(e, a - 11, 7));
                                                s = i, c = (a = 0) === o ? (l = 138, 3) : i === o ? (l = 6, 3) : (l = 7, 4);
                                            }
                                        }
                                        i(_);
                                        var F = !1;
                                        function L(e, t, r, i) {
                                            C(e, 0 + (i ? 1 : 0), 3), function(e, t, r, i) {
                                                O(e), M(e, r), M(e, ~r), n.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                                            }(e, t, r);
                                        }
                                        r._tr_init = function(e) {
                                            F || (function() {
                                                var e, t, r, n, i, s = new Array(16);
                                                for(n = r = 0; n < 28; n++)for(g[n] = r, e = 0; e < 1 << c[n]; e++)b[r++] = n;
                                                for(b[r - 1] = n, n = i = 0; n < 16; n++)for(_[n] = i, e = 0; e < 1 << u[n]; e++)m[i++] = n;
                                                for(i >>= 7; n < a; n++)for(_[n] = i << 7, e = 0; e < 1 << u[n] - 7; e++)m[256 + i++] = n;
                                                for(t = 0; t <= l; t++)s[t] = 0;
                                                for(e = 0; e <= 143;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(; e <= 255;)d[2 * e + 1] = 9, e++, s[9]++;
                                                for(; e <= 279;)d[2 * e + 1] = 7, e++, s[7]++;
                                                for(; e <= 287;)d[2 * e + 1] = 8, e++, s[8]++;
                                                for(A(d, 287, s), e = 0; e < a; e++)p[2 * e + 1] = 5, p[2 * e] = E(e, 5);
                                                y = new x(d, c, 257, o, l), v = new x(p, u, 0, a, l), w = new x(new Array(0), h, 0, 19, 7);
                                            }(), F = !0), e.l_desc = new k(e.dyn_ltree, y), e.d_desc = new k(e.dyn_dtree, v), e.bl_desc = new k(e.bl_tree, w), e.bi_buf = 0, e.bi_valid = 0, R(e);
                                        }, r._tr_stored_block = L, r._tr_flush_block = function(e, t, r, n) {
                                            var i, o, a = 0;
                                            0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                                                var t, r = 4093624447;
                                                for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return 0;
                                                if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return 1;
                                                for(t = 32; t < s; t++)if (0 !== e.dyn_ltree[2 * t]) return 1;
                                                return 0;
                                            }(e)), P(e, e.l_desc), P(e, e.d_desc), a = function(e) {
                                                var t;
                                                for(B(e, e.dyn_ltree, e.l_desc.max_code), B(e, e.dyn_dtree, e.d_desc.max_code), P(e, e.bl_desc), t = 18; 3 <= t && 0 === e.bl_tree[2 * f[t] + 1]; t--);
                                                return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                                            }(e), i = e.opt_len + 3 + 7 >>> 3, (o = e.static_len + 3 + 7 >>> 3) <= i && (i = o)) : i = o = r + 5, r + 4 <= i && -1 !== t ? L(e, t, r, n) : 4 === e.strategy || o === i ? (C(e, 2 + (n ? 1 : 0), 3), N(e, d, p)) : (C(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                                                var i;
                                                for(C(e, t - 257, 5), C(e, r - 1, 5), C(e, n - 4, 4), i = 0; i < n; i++)C(e, e.bl_tree[2 * f[i] + 1], 3);
                                                D(e, e.dyn_ltree, t - 1), D(e, e.dyn_dtree, r - 1);
                                            }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), N(e, e.dyn_ltree, e.dyn_dtree)), R(e), n && O(e);
                                        }, r._tr_tally = function(e, t, r) {
                                            return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (b[r] + s + 1)]++, e.dyn_dtree[2 * S(t)]++), e.last_lit === e.lit_bufsize - 1;
                                        }, r._tr_align = function(e) {
                                            C(e, 2, 3), T(e, 256, d), function(e) {
                                                16 === e.bi_valid ? (M(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                                            }(e);
                                        };
                                    },
                                    {
                                        "../utils/common": 41
                                    }
                                ],
                                53: [
                                    function(e, t, r) {
                                        t.exports = function() {
                                            this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                                        };
                                    },
                                    {}
                                ],
                                54: [
                                    function(e, t, r) {
                                        (function(e) {
                                            !function(e, t) {
                                                if (!e.setImmediate) {
                                                    var r, i, s, o, a = 1, l = {}, c = !1, u = e.document, h = Object.getPrototypeOf && Object.getPrototypeOf(e);
                                                    h = h && h.setTimeout ? h : e, r = "[object process]" === ({}).toString.call(e.process) ? function(e) {
                                                        n.nextTick(function() {
                                                            d(e);
                                                        });
                                                    } : function() {
                                                        if (e.postMessage && !e.importScripts) {
                                                            var t = !0, r = e.onmessage;
                                                            return e.onmessage = function() {
                                                                t = !1;
                                                            }, e.postMessage("", "*"), e.onmessage = r, t;
                                                        }
                                                    }() ? (o = "setImmediate$" + Math.random() + "$", e.addEventListener ? e.addEventListener("message", p, !1) : e.attachEvent("onmessage", p), function(t) {
                                                        e.postMessage(o + t, "*");
                                                    }) : e.MessageChannel ? ((s = new MessageChannel).port1.onmessage = function(e) {
                                                        d(e.data);
                                                    }, function(e) {
                                                        s.port2.postMessage(e);
                                                    }) : u && "onreadystatechange" in u.createElement("script") ? (i = u.documentElement, function(e) {
                                                        var t = u.createElement("script");
                                                        t.onreadystatechange = function() {
                                                            d(e), t.onreadystatechange = null, i.removeChild(t), t = null;
                                                        }, i.appendChild(t);
                                                    }) : function(e) {
                                                        setTimeout(d, 0, e);
                                                    }, h.setImmediate = function(e) {
                                                        "function" != typeof e && (e = new Function("" + e));
                                                        for(var t = new Array(arguments.length - 1), n = 0; n < t.length; n++)t[n] = arguments[n + 1];
                                                        var i = {
                                                            callback: e,
                                                            args: t
                                                        };
                                                        return l[a] = i, r(a), a++;
                                                    }, h.clearImmediate = f;
                                                }
                                                function f(e) {
                                                    delete l[e];
                                                }
                                                function d(e) {
                                                    if (c) setTimeout(d, 0, e);
                                                    else {
                                                        var t = l[e];
                                                        if (t) {
                                                            c = !0;
                                                            try {
                                                                !function(e) {
                                                                    var t = e.callback, r = e.args;
                                                                    switch(r.length){
                                                                        case 0:
                                                                            t();
                                                                            break;
                                                                        case 1:
                                                                            t(r[0]);
                                                                            break;
                                                                        case 2:
                                                                            t(r[0], r[1]);
                                                                            break;
                                                                        case 3:
                                                                            t(r[0], r[1], r[2]);
                                                                            break;
                                                                        default:
                                                                            t.apply(void 0, r);
                                                                    }
                                                                }(t);
                                                            } finally{
                                                                f(e), c = !1;
                                                            }
                                                        }
                                                    }
                                                }
                                                function p(t) {
                                                    t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(o) && d(+t.data.slice(o.length));
                                                }
                                            }("undefined" == typeof self ? void 0 === e ? this : e : self);
                                        }).call(this, void 0 !== i ? i : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                                    },
                                    {}
                                ]
                            }, {}, [
                                10
                            ])(10);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], e("timers").setImmediate);
            },
            {
                _process: 467,
                buffer: 220,
                timers: 523
            }
        ],
        442: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /[\\^$.*+?()[\]{}|]/g, n = RegExp(r.source), i = "object" == typeof e && e && e.Object === Object && e, s = "object" == typeof self && self && self.Object === Object && self, o = i || s || Function("return this")(), a = Object.prototype.toString, l = o.Symbol, c = l ? l.prototype : void 0, u = c ? c.toString : void 0;
                        function h(e) {
                            if ("string" == typeof e) return e;
                            if (function(e) {
                                return "symbol" == typeof e || function(e) {
                                    return !!e && "object" == typeof e;
                                }(e) && "[object Symbol]" == a.call(e);
                            }(e)) return u ? u.call(e) : "";
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        t.exports = function(e) {
                            var t;
                            return (e = null == (t = e) ? "" : h(t)) && n.test(e) ? e.replace(r, "\\$&") : e;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        443: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, l = /^\w*$/, c = /^\./, u = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, h = /\\(\\)?/g, f = /^\[object .+?Constructor\]$/, d = /^(?:0|[1-9]\d*)$/, p = {};
                        p["[object Float32Array]"] = p["[object Float64Array]"] = p["[object Int8Array]"] = p["[object Int16Array]"] = p["[object Int32Array]"] = p["[object Uint8Array]"] = p["[object Uint8ClampedArray]"] = p["[object Uint16Array]"] = p["[object Uint32Array]"] = !0, p[n] = p["[object Array]"] = p["[object ArrayBuffer]"] = p["[object Boolean]"] = p["[object DataView]"] = p["[object Date]"] = p["[object Error]"] = p["[object Function]"] = p[i] = p["[object Number]"] = p[s] = p["[object RegExp]"] = p[o] = p["[object String]"] = p["[object WeakMap]"] = !1;
                        var m = "object" == typeof e && e && e.Object === Object && e, b = "object" == typeof self && self && self.Object === Object && self, g = m || b || Function("return this")(), y = "object" == typeof r && r && !r.nodeType && r, v = y && "object" == typeof t && t && !t.nodeType && t, w = v && v.exports === y && m.process, _ = function() {
                            try {
                                return w && w.binding("util");
                            } catch (e) {}
                        }(), x = _ && _.isTypedArray;
                        function k(e, t, r, n) {
                            for(var i = -1, s = e ? e.length : 0; ++i < s;){
                                var o = e[i];
                                t(n, o, r(o), e);
                            }
                            return n;
                        }
                        function S(e, t) {
                            for(var r = -1, n = e ? e.length : 0; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function M(e) {
                            var t = !1;
                            if (null != e && "function" != typeof e.toString) try {
                                t = !!(e + "");
                            } catch (e) {}
                            return t;
                        }
                        function C(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function T(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var E, A, R, O = Array.prototype, j = Function.prototype, I = Object.prototype, N = g["__core-js_shared__"], P = (E = /[^.]+$/.exec(N && N.keys && N.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "", B = j.toString, D = I.hasOwnProperty, F = I.toString, L = RegExp("^" + B.call(D).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), z = g.Symbol, U = g.Uint8Array, $ = I.propertyIsEnumerable, H = O.splice, V = (A = Object.keys, R = Object, function(e) {
                            return A(R(e));
                        }), q = Ce(g, "DataView"), W = Ce(g, "Map"), X = Ce(g, "Promise"), K = Ce(g, "Set"), Y = Ce(g, "WeakMap"), Z = Ce(Object, "create"), G = Ne(q), J = Ne(W), Q = Ne(X), ee = Ne(K), te = Ne(Y), re = z ? z.prototype : void 0, ne = re ? re.valueOf : void 0, ie = re ? re.toString : void 0;
                        function se(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function oe(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ae(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function le(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new ae; ++t < r;)this.add(e[t]);
                        }
                        function ce(e) {
                            this.__data__ = new oe(e);
                        }
                        function ue(e, t) {
                            var r = Ue(e) || ze(e) ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], n = r.length, i = !!n;
                            for(var s in e)!t && !D.call(e, s) || i && ("length" == s || Ee(s, n)) || r.push(s);
                            return r;
                        }
                        function he(e, t) {
                            for(var r = e.length; r--;)if (Le(e[r][0], t)) return r;
                            return -1;
                        }
                        function fe(e, t, r, n) {
                            return me(e, function(e, i, s) {
                                t(n, e, r(e), s);
                            }), n;
                        }
                        se.prototype.clear = function() {
                            this.__data__ = Z ? Z(null) : {};
                        }, se.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, se.prototype.get = function(e) {
                            var t = this.__data__;
                            if (Z) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return D.call(t, e) ? t[e] : void 0;
                        }, se.prototype.has = function(e) {
                            var t = this.__data__;
                            return Z ? void 0 !== t[e] : D.call(t, e);
                        }, se.prototype.set = function(e, t) {
                            return this.__data__[e] = Z && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, oe.prototype.clear = function() {
                            this.__data__ = [];
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : H.call(t, r, 1), !0);
                        }, oe.prototype.get = function(e) {
                            var t = this.__data__, r = he(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, oe.prototype.has = function(e) {
                            return he(this.__data__, e) > -1;
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__, n = he(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, ae.prototype.clear = function() {
                            this.__data__ = {
                                hash: new se,
                                map: new (W || oe),
                                string: new se
                            };
                        }, ae.prototype.delete = function(e) {
                            return Me(this, e).delete(e);
                        }, ae.prototype.get = function(e) {
                            return Me(this, e).get(e);
                        }, ae.prototype.has = function(e) {
                            return Me(this, e).has(e);
                        }, ae.prototype.set = function(e, t) {
                            return Me(this, e).set(e, t), this;
                        }, le.prototype.add = le.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, le.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.clear = function() {
                            this.__data__ = new oe;
                        }, ce.prototype.delete = function(e) {
                            return this.__data__.delete(e);
                        }, ce.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, ce.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, ce.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof oe) {
                                var n = r.__data__;
                                if (!W || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this;
                                r = this.__data__ = new ae(n);
                            }
                            return r.set(e, t), this;
                        };
                        var de, pe, me = (de = function(e, t) {
                            return e && be(e, t, Ye);
                        }, function(e, t) {
                            if (null == e) return e;
                            if (!$e(e)) return de(e, t);
                            for(var r = e.length, n = pe ? r : -1, i = Object(e); (pe ? n-- : ++n < r) && !1 !== t(i[n], n, i););
                            return e;
                        }), be = function(e) {
                            return function(t, r, n) {
                                for(var i = -1, s = Object(t), o = n(t), a = o.length; a--;){
                                    var l = o[e ? a : ++i];
                                    if (!1 === r(s[l], l, s)) break;
                                }
                                return t;
                            };
                        }();
                        function ge(e, t) {
                            for(var r = 0, n = (t = Ae(t, e) ? [
                                t
                            ] : ke(t)).length; null != e && r < n;)e = e[Ie(t[r++])];
                            return r && r == n ? e : void 0;
                        }
                        function ye(e, t) {
                            return null != e && t in Object(e);
                        }
                        function ve(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !qe(e) && !We(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Ue(e), h = Ue(t), f = "[object Array]", d = "[object Array]";
                                u || (f = (f = Te(e)) == n ? s : f);
                                h || (d = (d = Te(t)) == n ? s : d);
                                var p = f == s && !M(e), m = d == s && !M(t), b = f == d;
                                if (b && !p) return c || (c = new ce), u || Ke(e) ? Se(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !n(new U(e), new U(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return Le(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = C;
                                        case o:
                                            var u = 2 & a;
                                            if (c || (c = T), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            a |= 1, l.set(e, t);
                                            var f = Se(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (ne) return ne.call(e) == ne.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(2 & l)) {
                                    var g = p && D.call(e, "__wrapped__"), y = m && D.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, w = y ? t.value() : t;
                                        return c || (c = new ce), r(v, w, a, l, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new ce), function(e, t, r, n, i, s) {
                                    var o = 2 & i, a = Ye(e), l = a.length, c = Ye(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : D.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || r(m, b, n, i, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, ve, r, a, l));
                        }
                        function we(e) {
                            return !(!qe(e) || function(e) {
                                return !!P && P in e;
                            }(e)) && (He(e) || M(e) ? L : f).test(Ne(e));
                        }
                        function _e(e) {
                            var t, r;
                            return "function" == typeof e ? e : null == e ? Ze : "object" == typeof e ? Ue(e) ? function(e, t) {
                                if (Ae(e) && Re(t)) return Oe(Ie(e), t);
                                return function(r) {
                                    var n = function(e, t, r) {
                                        var n = null == e ? void 0 : ge(e, t);
                                        return void 0 === n ? r : n;
                                    }(r, e);
                                    return void 0 === n && n === t ? function(e, t) {
                                        return null != e && function(e, t, r) {
                                            t = Ae(t, e) ? [
                                                t
                                            ] : ke(t);
                                            var n, i = -1, s = t.length;
                                            for(; ++i < s;){
                                                var o = Ie(t[i]);
                                                if (!(n = null != e && r(e, o))) break;
                                                e = e[o];
                                            }
                                            if (n) return n;
                                            return !!(s = e ? e.length : 0) && Ve(s) && Ee(o, s) && (Ue(e) || ze(e));
                                        }(e, t, ye);
                                    }(r, e) : ve(t, n, void 0, 3);
                                };
                            }(e[0], e[1]) : function(e) {
                                var t = function(e) {
                                    var t = Ye(e), r = t.length;
                                    for(; r--;){
                                        var n = t[r], i = e[n];
                                        t[r] = [
                                            n,
                                            i,
                                            Re(i)
                                        ];
                                    }
                                    return t;
                                }(e);
                                if (1 == t.length && t[0][2]) return Oe(t[0][0], t[0][1]);
                                return function(r) {
                                    return r === e || function(e, t, r, n) {
                                        var i = r.length, s = i, o = !n;
                                        if (null == e) return !s;
                                        for(e = Object(e); i--;){
                                            var a = r[i];
                                            if (o && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
                                        }
                                        for(; ++i < s;){
                                            var l = (a = r[i])[0], c = e[l], u = a[1];
                                            if (o && a[2]) {
                                                if (void 0 === c && !(l in e)) return !1;
                                            } else {
                                                var h = new ce;
                                                if (n) var f = n(c, u, l, e, t, h);
                                                if (!(void 0 === f ? ve(u, c, n, 3, h) : f)) return !1;
                                            }
                                        }
                                        return !0;
                                    }(r, e, t);
                                };
                            }(e) : Ae(t = e) ? (r = Ie(t), function(e) {
                                return null == e ? void 0 : e[r];
                            }) : function(e) {
                                return function(t) {
                                    return ge(t, e);
                                };
                            }(t);
                        }
                        function xe(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || I, t !== n) return V(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))D.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function ke(e) {
                            return Ue(e) ? e : je(e);
                        }
                        function Se(e, t, r, n, i, s) {
                            var o = 2 & i, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 1 & i ? new le : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!S(t, function(e, t) {
                                        if (!f.has(t) && (d === e || r(d, e, n, i, s))) return f.add(t);
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !r(d, p, n, i, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function Me(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function Ce(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return we(r) ? r : void 0;
                        }
                        var Te = function(e) {
                            return F.call(e);
                        };
                        function Ee(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || d.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function Ae(e, t) {
                            if (Ue(e)) return !1;
                            var r = typeof e;
                            return !("number" != r && "symbol" != r && "boolean" != r && null != e && !Xe(e)) || l.test(e) || !a.test(e) || null != t && e in Object(t);
                        }
                        function Re(e) {
                            return e == e && !qe(e);
                        }
                        function Oe(e, t) {
                            return function(r) {
                                return null != r && r[e] === t && (void 0 !== t || e in Object(r));
                            };
                        }
                        (q && "[object DataView]" != Te(new q(new ArrayBuffer(1))) || W && Te(new W) != i || X && "[object Promise]" != Te(X.resolve()) || K && Te(new K) != o || Y && "[object WeakMap]" != Te(new Y)) && (Te = function(e) {
                            var t = F.call(e), r = t == s ? e.constructor : void 0, n = r ? Ne(r) : void 0;
                            if (n) switch(n){
                                case G:
                                    return "[object DataView]";
                                case J:
                                    return i;
                                case Q:
                                    return "[object Promise]";
                                case ee:
                                    return o;
                                case te:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var je = Fe(function(e) {
                            var t;
                            e = null == (t = e) ? "" : function(e) {
                                if ("string" == typeof e) return e;
                                if (Xe(e)) return ie ? ie.call(e) : "";
                                var t = e + "";
                                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                            }(t);
                            var r = [];
                            return c.test(e) && r.push(""), e.replace(u, function(e, t, n, i) {
                                r.push(n ? i.replace(h, "$1") : t || e);
                            }), r;
                        });
                        function Ie(e) {
                            if ("string" == typeof e || Xe(e)) return e;
                            var t = e + "";
                            return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
                        }
                        function Ne(e) {
                            if (null != e) {
                                try {
                                    return B.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        var Pe, Be, De = (Pe = function(e, t, r) {
                            D.call(e, r) ? e[r].push(t) : e[r] = [
                                t
                            ];
                        }, function(e, t) {
                            var r = Ue(e) ? k : fe, n = Be ? Be() : {};
                            return r(e, Pe, _e(t), n);
                        });
                        function Fe(e, t) {
                            if ("function" != typeof e || t && "function" != typeof t) throw new TypeError("Expected a function");
                            var r = function() {
                                var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
                                if (s.has(i)) return s.get(i);
                                var o = e.apply(this, n);
                                return r.cache = s.set(i, o), o;
                            };
                            return r.cache = new (Fe.Cache || ae), r;
                        }
                        function Le(e, t) {
                            return e === t || e != e && t != t;
                        }
                        function ze(e) {
                            return function(e) {
                                return We(e) && $e(e);
                            }(e) && D.call(e, "callee") && (!$.call(e, "callee") || F.call(e) == n);
                        }
                        Fe.Cache = ae;
                        var Ue = Array.isArray;
                        function $e(e) {
                            return null != e && Ve(e.length) && !He(e);
                        }
                        function He(e) {
                            var t = qe(e) ? F.call(e) : "";
                            return "[object Function]" == t || "[object GeneratorFunction]" == t;
                        }
                        function Ve(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function qe(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        function We(e) {
                            return !!e && "object" == typeof e;
                        }
                        function Xe(e) {
                            return "symbol" == typeof e || We(e) && "[object Symbol]" == F.call(e);
                        }
                        var Ke = x ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(x) : function(e) {
                            return We(e) && Ve(e.length) && !!p[F.call(e)];
                        };
                        function Ye(e) {
                            return $e(e) ? ue(e) : xe(e);
                        }
                        function Ze(e) {
                            return e;
                        }
                        t.exports = De;
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        444: [
            function(e, t, r) {
                "use strict";
                var n = Object.prototype.toString;
                t.exports = function(e) {
                    return !0 === e || !1 === e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Boolean]" == n.call(e);
                };
            },
            {}
        ],
        445: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var n = "[object Arguments]", i = "[object Map]", s = "[object Object]", o = "[object Set]", a = /^\[object .+?Constructor\]$/, l = /^(?:0|[1-9]\d*)$/, c = {};
                        c["[object Float32Array]"] = c["[object Float64Array]"] = c["[object Int8Array]"] = c["[object Int16Array]"] = c["[object Int32Array]"] = c["[object Uint8Array]"] = c["[object Uint8ClampedArray]"] = c["[object Uint16Array]"] = c["[object Uint32Array]"] = !0, c[n] = c["[object Array]"] = c["[object ArrayBuffer]"] = c["[object Boolean]"] = c["[object DataView]"] = c["[object Date]"] = c["[object Error]"] = c["[object Function]"] = c[i] = c["[object Number]"] = c[s] = c["[object RegExp]"] = c[o] = c["[object String]"] = c["[object WeakMap]"] = !1;
                        var u = "object" == typeof e && e && e.Object === Object && e, h = "object" == typeof self && self && self.Object === Object && self, f = u || h || Function("return this")(), d = "object" == typeof r && r && !r.nodeType && r, p = d && "object" == typeof t && t && !t.nodeType && t, m = p && p.exports === d, b = m && u.process, g = function() {
                            try {
                                return b && b.binding && b.binding("util");
                            } catch (e) {}
                        }(), y = g && g.isTypedArray;
                        function v(e, t) {
                            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
                            return !1;
                        }
                        function w(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e, n) {
                                r[++t] = [
                                    n,
                                    e
                                ];
                            }), r;
                        }
                        function _(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var x, k, S, M = Array.prototype, C = Function.prototype, T = Object.prototype, E = f["__core-js_shared__"], A = C.toString, R = T.hasOwnProperty, O = (x = /[^.]+$/.exec(E && E.keys && E.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x : "", j = T.toString, I = RegExp("^" + A.call(R).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), N = m ? f.Buffer : void 0, P = f.Symbol, B = f.Uint8Array, D = T.propertyIsEnumerable, F = M.splice, L = P ? P.toStringTag : void 0, z = Object.getOwnPropertySymbols, U = N ? N.isBuffer : void 0, $ = (k = Object.keys, S = Object, function(e) {
                            return k(S(e));
                        }), H = ge(f, "DataView"), V = ge(f, "Map"), q = ge(f, "Promise"), W = ge(f, "Set"), X = ge(f, "WeakMap"), K = ge(Object, "create"), Y = _e(H), Z = _e(V), G = _e(q), J = _e(W), Q = _e(X), ee = P ? P.prototype : void 0, te = ee ? ee.valueOf : void 0;
                        function re(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ne(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function ie(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function se(e) {
                            var t = -1, r = null == e ? 0 : e.length;
                            for(this.__data__ = new ie; ++t < r;)this.add(e[t]);
                        }
                        function oe(e) {
                            var t = this.__data__ = new ne(e);
                            this.size = t.size;
                        }
                        function ae(e, t) {
                            var r = Se(e), n = !r && ke(e), i = !r && !n && Me(e), s = !r && !n && !i && Re(e), o = r || n || i || s, a = o ? function(e, t) {
                                for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
                                return n;
                            }(e.length, String) : [], l = a.length;
                            for(var c in e)!t && !R.call(e, c) || o && ("length" == c || i && ("offset" == c || "parent" == c) || s && ("buffer" == c || "byteLength" == c || "byteOffset" == c) || we(c, l)) || a.push(c);
                            return a;
                        }
                        function le(e, t) {
                            for(var r = e.length; r--;)if (xe(e[r][0], t)) return r;
                            return -1;
                        }
                        function ce(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : L && L in Object(e) ? function(e) {
                                var t = R.call(e, L), r = e[L];
                                try {
                                    e[L] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = j.call(e);
                                n && (t ? e[L] = r : delete e[L]);
                                return i;
                            }(e) : function(e) {
                                return j.call(e);
                            }(e);
                        }
                        function ue(e) {
                            return Ae(e) && ce(e) == n;
                        }
                        function he(e, t, r, a, l) {
                            return e === t || (null == e || null == t || !Ae(e) && !Ae(t) ? e != e && t != t : function(e, t, r, a, l, c) {
                                var u = Se(e), h = Se(t), f = u ? "[object Array]" : ve(e), d = h ? "[object Array]" : ve(t), p = (f = f == n ? s : f) == s, m = (d = d == n ? s : d) == s, b = f == d;
                                if (b && Me(e)) {
                                    if (!Me(t)) return !1;
                                    u = !0, p = !1;
                                }
                                if (b && !p) return c || (c = new oe), u || Re(e) ? pe(e, t, r, a, l, c) : function(e, t, r, n, s, a, l) {
                                    switch(r){
                                        case "[object DataView]":
                                            if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                            e = e.buffer, t = t.buffer;
                                        case "[object ArrayBuffer]":
                                            return !(e.byteLength != t.byteLength || !a(new B(e), new B(t)));
                                        case "[object Boolean]":
                                        case "[object Date]":
                                        case "[object Number]":
                                            return xe(+e, +t);
                                        case "[object Error]":
                                            return e.name == t.name && e.message == t.message;
                                        case "[object RegExp]":
                                        case "[object String]":
                                            return e == t + "";
                                        case i:
                                            var c = w;
                                        case o:
                                            var u = 1 & n;
                                            if (c || (c = _), e.size != t.size && !u) return !1;
                                            var h = l.get(e);
                                            if (h) return h == t;
                                            n |= 2, l.set(e, t);
                                            var f = pe(c(e), c(t), n, s, a, l);
                                            return l.delete(e), f;
                                        case "[object Symbol]":
                                            if (te) return te.call(e) == te.call(t);
                                    }
                                    return !1;
                                }(e, t, f, r, a, l, c);
                                if (!(1 & r)) {
                                    var g = p && R.call(e, "__wrapped__"), y = m && R.call(t, "__wrapped__");
                                    if (g || y) {
                                        var v = g ? e.value() : e, x = y ? t.value() : t;
                                        return c || (c = new oe), l(v, x, r, a, c);
                                    }
                                }
                                if (!b) return !1;
                                return c || (c = new oe), function(e, t, r, n, i, s) {
                                    var o = 1 & r, a = me(e), l = a.length, c = me(t).length;
                                    if (l != c && !o) return !1;
                                    var u = l;
                                    for(; u--;){
                                        var h = a[u];
                                        if (!(o ? h in t : R.call(t, h))) return !1;
                                    }
                                    var f = s.get(e);
                                    if (f && s.get(t)) return f == t;
                                    var d = !0;
                                    s.set(e, t), s.set(t, e);
                                    var p = o;
                                    for(; ++u < l;){
                                        h = a[u];
                                        var m = e[h], b = t[h];
                                        if (n) var g = o ? n(b, m, h, t, e, s) : n(m, b, h, e, t, s);
                                        if (!(void 0 === g ? m === b || i(m, b, r, n, s) : g)) {
                                            d = !1;
                                            break;
                                        }
                                        p || (p = "constructor" == h);
                                    }
                                    if (d && !p) {
                                        var y = e.constructor, v = t.constructor;
                                        y == v || !("constructor" in e) || !("constructor" in t) || "function" == typeof y && y instanceof y && "function" == typeof v && v instanceof v || (d = !1);
                                    }
                                    return s.delete(e), s.delete(t), d;
                                }(e, t, r, a, l, c);
                            }(e, t, r, a, he, l));
                        }
                        function fe(e) {
                            return !(!Ee(e) || function(e) {
                                return !!O && O in e;
                            }(e)) && (Ce(e) ? I : a).test(_e(e));
                        }
                        function de(e) {
                            if (r = (t = e) && t.constructor, n = "function" == typeof r && r.prototype || T, t !== n) return $(e);
                            var t, r, n, i = [];
                            for(var s in Object(e))R.call(e, s) && "constructor" != s && i.push(s);
                            return i;
                        }
                        function pe(e, t, r, n, i, s) {
                            var o = 1 & r, a = e.length, l = t.length;
                            if (a != l && !(o && l > a)) return !1;
                            var c = s.get(e);
                            if (c && s.get(t)) return c == t;
                            var u = -1, h = !0, f = 2 & r ? new se : void 0;
                            for(s.set(e, t), s.set(t, e); ++u < a;){
                                var d = e[u], p = t[u];
                                if (n) var m = o ? n(p, d, u, t, e, s) : n(d, p, u, e, t, s);
                                if (void 0 !== m) {
                                    if (m) continue;
                                    h = !1;
                                    break;
                                }
                                if (f) {
                                    if (!v(t, function(e, t) {
                                        if (o = t, !f.has(o) && (d === e || i(d, e, r, n, s))) return f.push(t);
                                        var o;
                                    })) {
                                        h = !1;
                                        break;
                                    }
                                } else if (d !== p && !i(d, p, r, n, s)) {
                                    h = !1;
                                    break;
                                }
                            }
                            return s.delete(e), s.delete(t), h;
                        }
                        function me(e) {
                            return function(e, t, r) {
                                var n = t(e);
                                return Se(e) ? n : function(e, t) {
                                    for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
                                    return e;
                                }(n, r(e));
                            }(e, Oe, ye);
                        }
                        function be(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function ge(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return fe(r) ? r : void 0;
                        }
                        re.prototype.clear = function() {
                            this.__data__ = K ? K(null) : {}, this.size = 0;
                        }, re.prototype.delete = function(e) {
                            var t = this.has(e) && delete this.__data__[e];
                            return this.size -= t ? 1 : 0, t;
                        }, re.prototype.get = function(e) {
                            var t = this.__data__;
                            if (K) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return R.call(t, e) ? t[e] : void 0;
                        }, re.prototype.has = function(e) {
                            var t = this.__data__;
                            return K ? void 0 !== t[e] : R.call(t, e);
                        }, re.prototype.set = function(e, t) {
                            var r = this.__data__;
                            return this.size += this.has(e) ? 0 : 1, r[e] = K && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, ne.prototype.clear = function() {
                            this.__data__ = [], this.size = 0;
                        }, ne.prototype.delete = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : F.call(t, r, 1), --this.size, !0);
                        }, ne.prototype.get = function(e) {
                            var t = this.__data__, r = le(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, ne.prototype.has = function(e) {
                            return le(this.__data__, e) > -1;
                        }, ne.prototype.set = function(e, t) {
                            var r = this.__data__, n = le(r, e);
                            return n < 0 ? (++this.size, r.push([
                                e,
                                t
                            ])) : r[n][1] = t, this;
                        }, ie.prototype.clear = function() {
                            this.size = 0, this.__data__ = {
                                hash: new re,
                                map: new (V || ne),
                                string: new re
                            };
                        }, ie.prototype.delete = function(e) {
                            var t = be(this, e).delete(e);
                            return this.size -= t ? 1 : 0, t;
                        }, ie.prototype.get = function(e) {
                            return be(this, e).get(e);
                        }, ie.prototype.has = function(e) {
                            return be(this, e).has(e);
                        }, ie.prototype.set = function(e, t) {
                            var r = be(this, e), n = r.size;
                            return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
                        }, se.prototype.add = se.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, se.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.clear = function() {
                            this.__data__ = new ne, this.size = 0;
                        }, oe.prototype.delete = function(e) {
                            var t = this.__data__, r = t.delete(e);
                            return this.size = t.size, r;
                        }, oe.prototype.get = function(e) {
                            return this.__data__.get(e);
                        }, oe.prototype.has = function(e) {
                            return this.__data__.has(e);
                        }, oe.prototype.set = function(e, t) {
                            var r = this.__data__;
                            if (r instanceof ne) {
                                var n = r.__data__;
                                if (!V || n.length < 199) return n.push([
                                    e,
                                    t
                                ]), this.size = ++r.size, this;
                                r = this.__data__ = new ie(n);
                            }
                            return r.set(e, t), this.size = r.size, this;
                        };
                        var ye = z ? function(e) {
                            return null == e ? [] : (e = Object(e), function(e, t) {
                                for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
                                    var o = e[r];
                                    t(o, r, e) && (s[i++] = o);
                                }
                                return s;
                            }(z(e), function(t) {
                                return D.call(e, t);
                            }));
                        } : function() {
                            return [];
                        }, ve = ce;
                        function we(e, t) {
                            return !!(t = null == t ? 9007199254740991 : t) && ("number" == typeof e || l.test(e)) && e > -1 && e % 1 == 0 && e < t;
                        }
                        function _e(e) {
                            if (null != e) {
                                try {
                                    return A.call(e);
                                } catch (e) {}
                                try {
                                    return e + "";
                                } catch (e) {}
                            }
                            return "";
                        }
                        function xe(e, t) {
                            return e === t || e != e && t != t;
                        }
                        (H && "[object DataView]" != ve(new H(new ArrayBuffer(1))) || V && ve(new V) != i || q && "[object Promise]" != ve(q.resolve()) || W && ve(new W) != o || X && "[object WeakMap]" != ve(new X)) && (ve = function(e) {
                            var t = ce(e), r = t == s ? e.constructor : void 0, n = r ? _e(r) : "";
                            if (n) switch(n){
                                case Y:
                                    return "[object DataView]";
                                case Z:
                                    return i;
                                case G:
                                    return "[object Promise]";
                                case J:
                                    return o;
                                case Q:
                                    return "[object WeakMap]";
                            }
                            return t;
                        });
                        var ke = ue(function() {
                            return arguments;
                        }()) ? ue : function(e) {
                            return Ae(e) && R.call(e, "callee") && !D.call(e, "callee");
                        }, Se = Array.isArray;
                        var Me = U || function() {
                            return !1;
                        };
                        function Ce(e) {
                            if (!Ee(e)) return !1;
                            var t = ce(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        }
                        function Te(e) {
                            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
                        }
                        function Ee(e) {
                            var t = typeof e;
                            return null != e && ("object" == t || "function" == t);
                        }
                        function Ae(e) {
                            return null != e && "object" == typeof e;
                        }
                        var Re = y ? function(e) {
                            return function(t) {
                                return e(t);
                            };
                        }(y) : function(e) {
                            return Ae(e) && Te(e.length) && !!c[ce(e)];
                        };
                        function Oe(e) {
                            var t;
                            return null != (t = e) && Te(t.length) && !Ce(t) ? ae(e) : de(e);
                        }
                        t.exports = function(e, t) {
                            return he(e, t);
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        446: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = "object" == typeof e && e && e.Object === Object && e, n = "object" == typeof self && self && self.Object === Object && self, i = r || n || Function("return this")(), s = Object.prototype, o = s.hasOwnProperty, a = s.toString, l = i.Symbol, c = l ? l.toStringTag : void 0;
                        function u(e) {
                            return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : c && c in Object(e) ? function(e) {
                                var t = o.call(e, c), r = e[c];
                                try {
                                    e[c] = void 0;
                                    var n = !0;
                                } catch (e) {}
                                var i = a.call(e);
                                n && (t ? e[c] = r : delete e[c]);
                                return i;
                            }(e) : function(e) {
                                return a.call(e);
                            }(e);
                        }
                        t.exports = function(e) {
                            if (!function(e) {
                                var t = typeof e;
                                return null != e && ("object" == t || "function" == t);
                            }(e)) return !1;
                            var t = u(e);
                            return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        447: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return null == e;
                };
            },
            {}
        ],
        448: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return void 0 === e;
                };
            },
            {}
        ],
        449: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        var r = /^\[object .+?Constructor\]$/, n = "object" == typeof e && e && e.Object === Object && e, i = "object" == typeof self && self && self.Object === Object && self, s = n || i || Function("return this")();
                        function o(e, t) {
                            return !!(e ? e.length : 0) && function(e, t, r) {
                                if (t != t) return function(e, t, r, n) {
                                    var i = e.length, s = r + (n ? 1 : -1);
                                    for(; n ? s-- : ++s < i;)if (t(e[s], s, e)) return s;
                                    return -1;
                                }(e, l, r);
                                var n = r - 1, i = e.length;
                                for(; ++n < i;)if (e[n] === t) return n;
                                return -1;
                            }(e, t, 0) > -1;
                        }
                        function a(e, t, r) {
                            for(var n = -1, i = e ? e.length : 0; ++n < i;)if (r(t, e[n])) return !0;
                            return !1;
                        }
                        function l(e) {
                            return e != e;
                        }
                        function c(e, t) {
                            return e.has(t);
                        }
                        function u(e) {
                            var t = -1, r = Array(e.size);
                            return e.forEach(function(e) {
                                r[++t] = e;
                            }), r;
                        }
                        var h, f = Array.prototype, d = Function.prototype, p = Object.prototype, m = s["__core-js_shared__"], b = (h = /[^.]+$/.exec(m && m.keys && m.keys.IE_PROTO || "")) ? "Symbol(src)_1." + h : "", g = d.toString, y = p.hasOwnProperty, v = p.toString, w = RegExp("^" + g.call(y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), _ = f.splice, x = I(s, "Map"), k = I(s, "Set"), S = I(Object, "create");
                        function M(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function C(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function T(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.clear(); ++t < r;){
                                var n = e[t];
                                this.set(n[0], n[1]);
                            }
                        }
                        function E(e) {
                            var t = -1, r = e ? e.length : 0;
                            for(this.__data__ = new T; ++t < r;)this.add(e[t]);
                        }
                        function A(e, t) {
                            for(var r, n, i = e.length; i--;)if ((r = e[i][0]) === (n = t) || r != r && n != n) return i;
                            return -1;
                        }
                        function R(e) {
                            var t;
                            return !(!N(e) || (t = e, b && b in t)) && ((function(e) {
                                var t = N(e) ? v.call(e) : "";
                                return "[object Function]" == t || "[object GeneratorFunction]" == t;
                            })(e) || function(e) {
                                var t = !1;
                                if (null != e && "function" != typeof e.toString) try {
                                    t = !!(e + "");
                                } catch (e) {}
                                return t;
                            }(e) ? w : r).test(function(e) {
                                if (null != e) {
                                    try {
                                        return g.call(e);
                                    } catch (e) {}
                                    try {
                                        return e + "";
                                    } catch (e) {}
                                }
                                return "";
                            }(e));
                        }
                        M.prototype.clear = function() {
                            this.__data__ = S ? S(null) : {};
                        }, M.prototype.delete = function(e) {
                            return this.has(e) && delete this.__data__[e];
                        }, M.prototype.get = function(e) {
                            var t = this.__data__;
                            if (S) {
                                var r = t[e];
                                return "__lodash_hash_undefined__" === r ? void 0 : r;
                            }
                            return y.call(t, e) ? t[e] : void 0;
                        }, M.prototype.has = function(e) {
                            var t = this.__data__;
                            return S ? void 0 !== t[e] : y.call(t, e);
                        }, M.prototype.set = function(e, t) {
                            return this.__data__[e] = S && void 0 === t ? "__lodash_hash_undefined__" : t, this;
                        }, C.prototype.clear = function() {
                            this.__data__ = [];
                        }, C.prototype.delete = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return !(r < 0) && (r == t.length - 1 ? t.pop() : _.call(t, r, 1), !0);
                        }, C.prototype.get = function(e) {
                            var t = this.__data__, r = A(t, e);
                            return r < 0 ? void 0 : t[r][1];
                        }, C.prototype.has = function(e) {
                            return A(this.__data__, e) > -1;
                        }, C.prototype.set = function(e, t) {
                            var r = this.__data__, n = A(r, e);
                            return n < 0 ? r.push([
                                e,
                                t
                            ]) : r[n][1] = t, this;
                        }, T.prototype.clear = function() {
                            this.__data__ = {
                                hash: new M,
                                map: new (x || C),
                                string: new M
                            };
                        }, T.prototype.delete = function(e) {
                            return j(this, e).delete(e);
                        }, T.prototype.get = function(e) {
                            return j(this, e).get(e);
                        }, T.prototype.has = function(e) {
                            return j(this, e).has(e);
                        }, T.prototype.set = function(e, t) {
                            return j(this, e).set(e, t), this;
                        }, E.prototype.add = E.prototype.push = function(e) {
                            return this.__data__.set(e, "__lodash_hash_undefined__"), this;
                        }, E.prototype.has = function(e) {
                            return this.__data__.has(e);
                        };
                        var O = k && 1 / u(new k([
                            ,
                            -0
                        ]))[1] == 1 / 0 ? function(e) {
                            return new k(e);
                        } : function() {};
                        function j(e, t) {
                            var r, n, i = e.__data__;
                            return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
                        }
                        function I(e, t) {
                            var r = function(e, t) {
                                return null == e ? void 0 : e[t];
                            }(e, t);
                            return R(r) ? r : void 0;
                        }
                        function N(e) {
                            var t = typeof e;
                            return !!e && ("object" == t || "function" == t);
                        }
                        t.exports = function(e) {
                            return e && e.length ? function(e, t, r) {
                                var n = -1, i = o, s = e.length, l = !0, h = [], f = h;
                                if (r) l = !1, i = a;
                                else if (s >= 200) {
                                    var d = t ? null : O(e);
                                    if (d) return u(d);
                                    l = !1, i = c, f = new E;
                                } else f = t ? [] : h;
                                e: for(; ++n < s;){
                                    var p = e[n], m = t ? t(p) : p;
                                    if (p = r || 0 !== p ? p : 0, l && m == m) {
                                        for(var b = f.length; b--;)if (f[b] === m) continue e;
                                        t && f.push(m), h.push(p);
                                    } else i(f, m, r) || (f !== h && f.push(m), h.push(p));
                                }
                                return h;
                            }(e) : [];
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        450: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("hash-base"), s = e("safe-buffer").Buffer, o = new Array(16);
                function a() {
                    i.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
                }
                function l(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function c(e, t, r, n, i, s, o) {
                    return l(e + (t & r | ~t & n) + i + s | 0, o) + t | 0;
                }
                function u(e, t, r, n, i, s, o) {
                    return l(e + (t & n | r & ~n) + i + s | 0, o) + t | 0;
                }
                function h(e, t, r, n, i, s, o) {
                    return l(e + (t ^ r ^ n) + i + s | 0, o) + t | 0;
                }
                function f(e, t, r, n, i, s, o) {
                    return l(e + (r ^ (t | ~n)) + i + s | 0, o) + t | 0;
                }
                n(a, i), a.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    var r = this._a, n = this._b, i = this._c, s = this._d;
                    r = c(r, n, i, s, e[0], 3614090360, 7), s = c(s, r, n, i, e[1], 3905402710, 12), i = c(i, s, r, n, e[2], 606105819, 17), n = c(n, i, s, r, e[3], 3250441966, 22), r = c(r, n, i, s, e[4], 4118548399, 7), s = c(s, r, n, i, e[5], 1200080426, 12), i = c(i, s, r, n, e[6], 2821735955, 17), n = c(n, i, s, r, e[7], 4249261313, 22), r = c(r, n, i, s, e[8], 1770035416, 7), s = c(s, r, n, i, e[9], 2336552879, 12), i = c(i, s, r, n, e[10], 4294925233, 17), n = c(n, i, s, r, e[11], 2304563134, 22), r = c(r, n, i, s, e[12], 1804603682, 7), s = c(s, r, n, i, e[13], 4254626195, 12), i = c(i, s, r, n, e[14], 2792965006, 17), r = u(r, n = c(n, i, s, r, e[15], 1236535329, 22), i, s, e[1], 4129170786, 5), s = u(s, r, n, i, e[6], 3225465664, 9), i = u(i, s, r, n, e[11], 643717713, 14), n = u(n, i, s, r, e[0], 3921069994, 20), r = u(r, n, i, s, e[5], 3593408605, 5), s = u(s, r, n, i, e[10], 38016083, 9), i = u(i, s, r, n, e[15], 3634488961, 14), n = u(n, i, s, r, e[4], 3889429448, 20), r = u(r, n, i, s, e[9], 568446438, 5), s = u(s, r, n, i, e[14], 3275163606, 9), i = u(i, s, r, n, e[3], 4107603335, 14), n = u(n, i, s, r, e[8], 1163531501, 20), r = u(r, n, i, s, e[13], 2850285829, 5), s = u(s, r, n, i, e[2], 4243563512, 9), i = u(i, s, r, n, e[7], 1735328473, 14), r = h(r, n = u(n, i, s, r, e[12], 2368359562, 20), i, s, e[5], 4294588738, 4), s = h(s, r, n, i, e[8], 2272392833, 11), i = h(i, s, r, n, e[11], 1839030562, 16), n = h(n, i, s, r, e[14], 4259657740, 23), r = h(r, n, i, s, e[1], 2763975236, 4), s = h(s, r, n, i, e[4], 1272893353, 11), i = h(i, s, r, n, e[7], 4139469664, 16), n = h(n, i, s, r, e[10], 3200236656, 23), r = h(r, n, i, s, e[13], 681279174, 4), s = h(s, r, n, i, e[0], 3936430074, 11), i = h(i, s, r, n, e[3], 3572445317, 16), n = h(n, i, s, r, e[6], 76029189, 23), r = h(r, n, i, s, e[9], 3654602809, 4), s = h(s, r, n, i, e[12], 3873151461, 11), i = h(i, s, r, n, e[15], 530742520, 16), r = f(r, n = h(n, i, s, r, e[2], 3299628645, 23), i, s, e[0], 4096336452, 6), s = f(s, r, n, i, e[7], 1126891415, 10), i = f(i, s, r, n, e[14], 2878612391, 15), n = f(n, i, s, r, e[5], 4237533241, 21), r = f(r, n, i, s, e[12], 1700485571, 6), s = f(s, r, n, i, e[3], 2399980690, 10), i = f(i, s, r, n, e[10], 4293915773, 15), n = f(n, i, s, r, e[1], 2240044497, 21), r = f(r, n, i, s, e[8], 1873313359, 6), s = f(s, r, n, i, e[15], 4264355552, 10), i = f(i, s, r, n, e[6], 2734768916, 15), n = f(n, i, s, r, e[13], 1309151649, 21), r = f(r, n, i, s, e[4], 4149444226, 6), s = f(s, r, n, i, e[11], 3174756917, 10), i = f(i, s, r, n, e[2], 718787259, 15), n = f(n, i, s, r, e[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + s | 0;
                }, a.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = s.allocUnsafe(16);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e;
                }, t.exports = a;
            },
            {
                "hash-base": 425,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        451: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("brorand");
                function s(e) {
                    this.rand = e || new i.Rand;
                }
                t.exports = s, s.create = function(e) {
                    return new s(e);
                }, s.prototype._randbelow = function(e) {
                    var t = e.bitLength(), r = Math.ceil(t / 8);
                    do var i = new n(this.rand.generate(r));
                    while (i.cmp(e) >= 0);
                    return i;
                }, s.prototype._randrange = function(e, t) {
                    var r = t.sub(e);
                    return e.add(this._randbelow(r));
                }, s.prototype.test = function(e, t, r) {
                    var i = e.bitLength(), s = n.mont(e), o = new n(1).toRed(s);
                    t || (t = Math.max(1, i / 48 | 0));
                    for(var a = e.subn(1), l = 0; !a.testn(l); l++);
                    for(var c = e.shrn(l), u = a.toRed(s); t > 0; t--){
                        var h = this._randrange(new n(2), a);
                        r && r(h);
                        var f = h.toRed(s).redPow(c);
                        if (0 !== f.cmp(o) && 0 !== f.cmp(u)) {
                            for(var d = 1; d < l; d++){
                                if (0 === (f = f.redSqr()).cmp(o)) return !1;
                                if (0 === f.cmp(u)) break;
                            }
                            if (d === l) return !1;
                        }
                    }
                    return !0;
                }, s.prototype.getDivisor = function(e, t) {
                    var r = e.bitLength(), i = n.mont(e), s = new n(1).toRed(i);
                    t || (t = Math.max(1, r / 48 | 0));
                    for(var o = e.subn(1), a = 0; !o.testn(a); a++);
                    for(var l = e.shrn(a), c = o.toRed(i); t > 0; t--){
                        var u = this._randrange(new n(2), o), h = e.gcd(u);
                        if (0 !== h.cmpn(1)) return h;
                        var f = u.toRed(i).redPow(l);
                        if (0 !== f.cmp(s) && 0 !== f.cmp(c)) {
                            for(var d = 1; d < a; d++){
                                if (0 === (f = f.redSqr()).cmp(s)) return f.fromRed().subn(1).gcd(e);
                                if (0 === f.cmp(c)) break;
                            }
                            if (d === a) return (f = f.redSqr()).fromRed().subn(1).gcd(e);
                        }
                    }
                    return !1;
                };
            },
            {
                "bn.js": 452,
                brorand: 187
            }
        ],
        452: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        453: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    if (!e) throw new Error(t || "Assertion failed");
                }
                t.exports = n, n.equal = function(e, t, r) {
                    if (e != t) throw new Error(r || "Assertion failed: " + e + " != " + t);
                };
            },
            {}
        ],
        454: [
            function(e, t, r) {
                "use strict";
                var n = r;
                function i(e) {
                    return 1 === e.length ? "0" + e : e;
                }
                function s(e) {
                    for(var t = "", r = 0; r < e.length; r++)t += i(e[r].toString(16));
                    return t;
                }
                n.toArray = function(e, t) {
                    if (Array.isArray(e)) return e.slice();
                    if (!e) return [];
                    var r = [];
                    if ("string" != typeof e) {
                        for(var n = 0; n < e.length; n++)r[n] = 0 | e[n];
                        return r;
                    }
                    if ("hex" === t) {
                        (e = e.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (e = "0" + e);
                        for(n = 0; n < e.length; n += 2)r.push(parseInt(e[n] + e[n + 1], 16));
                    } else for(n = 0; n < e.length; n++){
                        var i = e.charCodeAt(n), s = i >> 8, o = 255 & i;
                        s ? r.push(s, o) : r.push(o);
                    }
                    return r;
                }, n.zero2 = i, n.toHex = s, n.encode = function(e, t) {
                    return "hex" === t ? s(e) : e;
                };
            },
            {}
        ],
        455: [
            function(e, t, r) {
                t.exports = {
                    "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
                    "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
                    "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
                    "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
                    "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
                    "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
                    "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
                    "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
                    "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
                    "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
                    "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
                    "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
                };
            },
            {}
        ],
        456: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js");
                r.certificate = e("./certificate");
                var i = n.define("RSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
                });
                r.RSAPrivateKey = i;
                var s = n.define("RSAPublicKey", function() {
                    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
                });
                r.RSAPublicKey = s;
                var o = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(a), this.key("subjectPublicKey").bitstr());
                });
                r.PublicKey = o;
                var a = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
                }), l = n.define("PrivateKeyInfo", function() {
                    this.seq().obj(this.key("version").int(), this.key("algorithm").use(a), this.key("subjectPrivateKey").octstr());
                });
                r.PrivateKey = l;
                var c = n.define("EncryptedPrivateKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
                });
                r.EncryptedPrivateKey = c;
                var u = n.define("DSAPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
                });
                r.DSAPrivateKey = u, r.DSAparam = n.define("DSAparam", function() {
                    this.int();
                });
                var h = n.define("ECPrivateKey", function() {
                    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use(f), this.key("publicKey").optional().explicit(1).bitstr());
                });
                r.ECPrivateKey = h;
                var f = n.define("ECParameters", function() {
                    this.choice({
                        namedCurve: this.objid()
                    });
                });
                r.signature = n.define("signature", function() {
                    this.seq().obj(this.key("r").int(), this.key("s").int());
                });
            },
            {
                "./certificate": 457,
                "asn1.js": 170
            }
        ],
        457: [
            function(e, t, r) {
                "use strict";
                var n = e("asn1.js"), i = n.define("Time", function() {
                    this.choice({
                        utcTime: this.utctime(),
                        generalTime: this.gentime()
                    });
                }), s = n.define("AttributeTypeValue", function() {
                    this.seq().obj(this.key("type").objid(), this.key("value").any());
                }), o = n.define("AlgorithmIdentifier", function() {
                    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
                }), a = n.define("SubjectPublicKeyInfo", function() {
                    this.seq().obj(this.key("algorithm").use(o), this.key("subjectPublicKey").bitstr());
                }), l = n.define("RelativeDistinguishedName", function() {
                    this.setof(s);
                }), c = n.define("RDNSequence", function() {
                    this.seqof(l);
                }), u = n.define("Name", function() {
                    this.choice({
                        rdnSequence: this.use(c)
                    });
                }), h = n.define("Validity", function() {
                    this.seq().obj(this.key("notBefore").use(i), this.key("notAfter").use(i));
                }), f = n.define("Extension", function() {
                    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(!1), this.key("extnValue").octstr());
                }), d = n.define("TBSCertificate", function() {
                    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use(o), this.key("issuer").use(u), this.key("validity").use(h), this.key("subject").use(u), this.key("subjectPublicKeyInfo").use(a), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof(f).optional());
                }), p = n.define("X509Certificate", function() {
                    this.seq().obj(this.key("tbsCertificate").use(d), this.key("signatureAlgorithm").use(o), this.key("signatureValue").bitstr());
                });
                t.exports = p;
            },
            {
                "asn1.js": 170
            }
        ],
        458: [
            function(e, t, r) {
                "use strict";
                var n = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, i = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, s = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, o = e("evp_bytestokey"), a = e("browserify-aes"), l = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    var r, c = e.toString(), u = c.match(n);
                    if (u) {
                        var h = "aes" + u[1], f = l.from(u[2], "hex"), d = l.from(u[3].replace(/[\r\n]/g, ""), "base64"), p = o(t, f.slice(0, 8), parseInt(u[1], 10)).key, m = [], b = a.createDecipheriv(h, p, f);
                        m.push(b.update(d)), m.push(b.final()), r = l.concat(m);
                    } else {
                        var g = c.match(s);
                        r = l.from(g[2].replace(/[\r\n]/g, ""), "base64");
                    }
                    return {
                        tag: c.match(i)[1],
                        data: r
                    };
                };
            },
            {
                "browserify-aes": 191,
                evp_bytestokey: 423,
                "safe-buffer": 494
            }
        ],
        459: [
            function(e, t, r) {
                "use strict";
                var n = e("./asn1"), i = e("./aesid.json"), s = e("./fixProc"), o = e("browserify-aes"), a = e("pbkdf2"), l = e("safe-buffer").Buffer;
                function c(e) {
                    var t;
                    "object" != typeof e || l.isBuffer(e) || (t = e.passphrase, e = e.key), "string" == typeof e && (e = l.from(e));
                    var r, c, u = s(e, t), h = u.tag, f = u.data;
                    switch(h){
                        case "CERTIFICATE":
                            c = n.certificate.decode(f, "der").tbsCertificate.subjectPublicKeyInfo;
                        case "PUBLIC KEY":
                            switch(c || (c = n.PublicKey.decode(f, "der")), r = c.algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPublicKey.decode(c.subjectPublicKey.data, "der");
                                case "1.2.840.10045.2.1":
                                    return c.subjectPrivateKey = c.subjectPublicKey, {
                                        type: "ec",
                                        data: c
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.pub_key = n.DSAparam.decode(c.subjectPublicKey.data, "der"), {
                                        type: "dsa",
                                        data: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "ENCRYPTED PRIVATE KEY":
                            f = function(e, t) {
                                var r = e.algorithm.decrypt.kde.kdeparams.salt, n = parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), s = i[e.algorithm.decrypt.cipher.algo.join(".")], c = e.algorithm.decrypt.cipher.iv, u = e.subjectPrivateKey, h = parseInt(s.split("-")[1], 10) / 8, f = a.pbkdf2Sync(t, r, n, h, "sha1"), d = o.createDecipheriv(s, f, c), p = [];
                                return p.push(d.update(u)), p.push(d.final()), l.concat(p);
                            }(f = n.EncryptedPrivateKey.decode(f, "der"), t);
                        case "PRIVATE KEY":
                            switch(r = (c = n.PrivateKey.decode(f, "der")).algorithm.algorithm.join(".")){
                                case "1.2.840.113549.1.1.1":
                                    return n.RSAPrivateKey.decode(c.subjectPrivateKey, "der");
                                case "1.2.840.10045.2.1":
                                    return {
                                        curve: c.algorithm.curve,
                                        privateKey: n.ECPrivateKey.decode(c.subjectPrivateKey, "der").privateKey
                                    };
                                case "1.2.840.10040.4.1":
                                    return c.algorithm.params.priv_key = n.DSAparam.decode(c.subjectPrivateKey, "der"), {
                                        type: "dsa",
                                        params: c.algorithm.params
                                    };
                                default:
                                    throw new Error("unknown key id " + r);
                            }
                        case "RSA PUBLIC KEY":
                            return n.RSAPublicKey.decode(f, "der");
                        case "RSA PRIVATE KEY":
                            return n.RSAPrivateKey.decode(f, "der");
                        case "DSA PRIVATE KEY":
                            return {
                                type: "dsa",
                                params: n.DSAPrivateKey.decode(f, "der")
                            };
                        case "EC PRIVATE KEY":
                            return {
                                curve: (f = n.ECPrivateKey.decode(f, "der")).parameters.value,
                                privateKey: f.privateKey
                            };
                        default:
                            throw new Error("unknown key type " + h);
                    }
                }
                t.exports = c, c.signature = n.signature;
            },
            {
                "./aesid.json": 455,
                "./asn1": 456,
                "./fixProc": 458,
                "browserify-aes": 191,
                pbkdf2: 460,
                "safe-buffer": 494
            }
        ],
        460: [
            function(e, t, r) {
                "use strict";
                r.pbkdf2 = e("./lib/async"), r.pbkdf2Sync = e("./lib/sync");
            },
            {
                "./lib/async": 461,
                "./lib/sync": 464
            }
        ],
        461: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i, s = e("safe-buffer").Buffer, o = e("./precondition"), a = e("./default-encoding"), l = e("./sync"), c = e("./to-buffer"), u = r.crypto && r.crypto.subtle, h = {
                            sha: "SHA-1",
                            "sha-1": "SHA-1",
                            sha1: "SHA-1",
                            sha256: "SHA-256",
                            "sha-256": "SHA-256",
                            sha384: "SHA-384",
                            "sha-384": "SHA-384",
                            "sha-512": "SHA-512",
                            sha512: "SHA-512"
                        }, f = [];
                        function d() {
                            return i || (i = r.process && r.process.nextTick ? r.process.nextTick : r.queueMicrotask ? r.queueMicrotask : r.setImmediate ? r.setImmediate : r.setTimeout);
                        }
                        function p(e, t, r, n, i) {
                            return u.importKey("raw", e, {
                                name: "PBKDF2"
                            }, !1, [
                                "deriveBits"
                            ]).then(function(e) {
                                return u.deriveBits({
                                    name: "PBKDF2",
                                    salt: t,
                                    iterations: r,
                                    hash: {
                                        name: i
                                    }
                                }, e, n << 3);
                            }).then(function(e) {
                                return s.from(e);
                            });
                        }
                        t.exports = function(e, t, i, m, b, g) {
                            "function" == typeof b && (g = b, b = void 0);
                            var y = h[(b = b || "sha1").toLowerCase()];
                            if (y && "function" == typeof r.Promise) {
                                if (o(i, m), e = c(e, a, "Password"), t = c(t, a, "Salt"), "function" != typeof g) throw new Error("No callback provided to pbkdf2");
                                !function(e, t) {
                                    e.then(function(e) {
                                        d()(function() {
                                            t(null, e);
                                        });
                                    }, function(e) {
                                        d()(function() {
                                            t(e);
                                        });
                                    });
                                }((function(e) {
                                    if (r.process && !r.process.browser) return Promise.resolve(!1);
                                    if (!u || !u.importKey || !u.deriveBits) return Promise.resolve(!1);
                                    if (void 0 !== f[e]) return f[e];
                                    var t = p(n = n || s.alloc(8), n, 10, 128, e).then(function() {
                                        return !0;
                                    }).catch(function() {
                                        return !1;
                                    });
                                    return f[e] = t, t;
                                })(y).then(function(r) {
                                    return r ? p(e, t, i, m, y) : l(e, t, i, m, b);
                                }), g);
                            } else d()(function() {
                                var r;
                                try {
                                    r = l(e, t, i, m, b);
                                } catch (e) {
                                    return g(e);
                                }
                                g(null, r);
                            });
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./sync": 464,
                "./to-buffer": 465,
                "safe-buffer": 494
            }
        ],
        462: [
            function(e, t, r) {
                (function(e, r) {
                    (function() {
                        "use strict";
                        var n;
                        if (r.process && r.process.browser) n = "utf-8";
                        else if (r.process && r.process.version) n = parseInt(e.version.split(".")[0].slice(1), 10) >= 6 ? "utf-8" : "binary";
                        else n = "utf-8";
                        t.exports = n;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467
            }
        ],
        463: [
            function(e, t, r) {
                "use strict";
                var n = Math.pow(2, 30) - 1;
                t.exports = function(e, t) {
                    if ("number" != typeof e) throw new TypeError("Iterations not a number");
                    if (e < 0) throw new TypeError("Bad iterations");
                    if ("number" != typeof t) throw new TypeError("Key length not a number");
                    if (t < 0 || t > n || t != t) throw new TypeError("Bad key length");
                };
            },
            {}
        ],
        464: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash/md5"), i = e("ripemd160"), s = e("sha.js"), o = e("safe-buffer").Buffer, a = e("./precondition"), l = e("./default-encoding"), c = e("./to-buffer"), u = o.alloc(128), h = {
                    md5: 16,
                    sha1: 20,
                    sha224: 28,
                    sha256: 32,
                    sha384: 48,
                    sha512: 64,
                    rmd160: 20,
                    ripemd160: 20
                };
                function f(e, t, r) {
                    var a = function(e) {
                        function t(t) {
                            return s(e).update(t).digest();
                        }
                        return "rmd160" === e || "ripemd160" === e ? function(e) {
                            return (new i).update(e).digest();
                        } : "md5" === e ? n : t;
                    }(e), l = "sha512" === e || "sha384" === e ? 128 : 64;
                    t.length > l ? t = a(t) : t.length < l && (t = o.concat([
                        t,
                        u
                    ], l));
                    for(var c = o.allocUnsafe(l + h[e]), f = o.allocUnsafe(l + h[e]), d = 0; d < l; d++)c[d] = 54 ^ t[d], f[d] = 92 ^ t[d];
                    var p = o.allocUnsafe(l + r + 4);
                    c.copy(p, 0, 0, l), this.ipad1 = p, this.ipad2 = c, this.opad = f, this.alg = e, this.blocksize = l, this.hash = a, this.size = h[e];
                }
                f.prototype.run = function(e, t) {
                    return e.copy(t, this.blocksize), this.hash(t).copy(this.opad, this.blocksize), this.hash(this.opad);
                }, t.exports = function(e, t, r, n, i) {
                    a(r, n);
                    var s = new f(i = i || "sha1", e = c(e, l, "Password"), (t = c(t, l, "Salt")).length), u = o.allocUnsafe(n), d = o.allocUnsafe(t.length + 4);
                    t.copy(d, 0, 0, t.length);
                    for(var p = 0, m = h[i], b = Math.ceil(n / m), g = 1; g <= b; g++){
                        d.writeUInt32BE(g, t.length);
                        for(var y = s.run(d, s.ipad1), v = y, w = 1; w < r; w++){
                            v = s.run(v, s.ipad2);
                            for(var _ = 0; _ < m; _++)y[_] ^= v[_];
                        }
                        y.copy(u, p), p += m;
                    }
                    return u;
                };
            },
            {
                "./default-encoding": 462,
                "./precondition": 463,
                "./to-buffer": 465,
                "create-hash/md5": 387,
                ripemd160: 493,
                "safe-buffer": 494,
                "sha.js": 498
            }
        ],
        465: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    if (n.isBuffer(e)) return e;
                    if ("string" == typeof e) return n.from(e, t);
                    if (ArrayBuffer.isView(e)) return n.from(e.buffer);
                    throw new TypeError(r + " must be a string, a Buffer, a typed array or a DataView");
                };
            },
            {
                "safe-buffer": 494
            }
        ],
        466: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
                            nextTick: function(t, r, n, i) {
                                if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
                                var s, o, a = arguments.length;
                                switch(a){
                                    case 0:
                                    case 1:
                                        return e.nextTick(t);
                                    case 2:
                                        return e.nextTick(function() {
                                            t.call(null, r);
                                        });
                                    case 3:
                                        return e.nextTick(function() {
                                            t.call(null, r, n);
                                        });
                                    case 4:
                                        return e.nextTick(function() {
                                            t.call(null, r, n, i);
                                        });
                                    default:
                                        for(s = new Array(a - 1), o = 0; o < s.length;)s[o++] = arguments[o];
                                        return e.nextTick(function() {
                                            t.apply(null, s);
                                        });
                                }
                            }
                        } : t.exports = e;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        467: [
            function(e, t, r) {
                "use strict";
                var n, i, s = t.exports = {};
                function o() {
                    throw new Error("setTimeout has not been defined");
                }
                function a() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(e) {
                    if (n === setTimeout) return setTimeout(e, 0);
                    if ((n === o || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                    try {
                        return n(e, 0);
                    } catch (t) {
                        try {
                            return n.call(null, e, 0);
                        } catch (t) {
                            return n.call(this, e, 0);
                        }
                    }
                }
                !function() {
                    try {
                        n = "function" == typeof setTimeout ? setTimeout : o;
                    } catch (e) {
                        n = o;
                    }
                    try {
                        i = "function" == typeof clearTimeout ? clearTimeout : a;
                    } catch (e) {
                        i = a;
                    }
                }();
                var c, u = [], h = !1, f = -1;
                function d() {
                    h && c && (h = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
                }
                function p() {
                    if (!h) {
                        var e = l(d);
                        h = !0;
                        for(var t = u.length; t;){
                            for(c = u, u = []; ++f < t;)c && c[f].run();
                            f = -1, t = u.length;
                        }
                        c = null, h = !1, function(e) {
                            if (i === clearTimeout) return clearTimeout(e);
                            if ((i === a || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                            try {
                                i(e);
                            } catch (t) {
                                try {
                                    return i.call(null, e);
                                } catch (t) {
                                    return i.call(this, e);
                                }
                            }
                        }(e);
                    }
                }
                function m(e, t) {
                    this.fun = e, this.array = t;
                }
                function b() {}
                s.nextTick = function(e) {
                    var t = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var r = 1; r < arguments.length; r++)t[r - 1] = arguments[r];
                    u.push(new m(e, t)), 1 !== u.length || h || l(p);
                }, m.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = b, s.addListener = b, s.once = b, s.off = b, s.removeListener = b, s.removeAllListeners = b, s.emit = b, s.prependListener = b, s.prependOnceListener = b, s.listeners = function(e) {
                    return [];
                }, s.binding = function(e) {
                    throw new Error("process.binding is not supported");
                }, s.cwd = function() {
                    return "/";
                }, s.chdir = function(e) {
                    throw new Error("process.chdir is not supported");
                }, s.umask = function() {
                    return 0;
                };
            },
            {}
        ],
        468: [
            function(e, t, r) {
                "use strict";
                r.publicEncrypt = e("./publicEncrypt"), r.privateDecrypt = e("./privateDecrypt"), r.privateEncrypt = function(e, t) {
                    return r.publicEncrypt(e, t, !0);
                }, r.publicDecrypt = function(e, t) {
                    return r.privateDecrypt(e, t, !0);
                };
            },
            {
                "./privateDecrypt": 471,
                "./publicEncrypt": 472
            }
        ],
        469: [
            function(e, t, r) {
                "use strict";
                var n = e("create-hash"), i = e("safe-buffer").Buffer;
                function s(e) {
                    var t = i.allocUnsafe(4);
                    return t.writeUInt32BE(e, 0), t;
                }
                t.exports = function(e, t) {
                    for(var r, o = i.alloc(0), a = 0; o.length < t;)r = s(a++), o = i.concat([
                        o,
                        n("sha1").update(e).update(r).digest()
                    ]);
                    return o.slice(0, t);
                };
            },
            {
                "create-hash": 386,
                "safe-buffer": 494
            }
        ],
        470: [
            function(e, t, r) {
                arguments[4][184][0].apply(r, arguments);
            },
            {
                buffer: 188,
                dup: 184
            }
        ],
        471: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("./mgf"), s = e("./xor"), o = e("bn.js"), a = e("browserify-rsa"), l = e("create-hash"), c = e("./withPublic"), u = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var h;
                    h = e.padding ? e.padding : r ? 1 : 4;
                    var f, d = n(e), p = d.modulus.byteLength();
                    if (t.length > p || new o(t).cmp(d.modulus) >= 0) throw new Error("decryption error");
                    f = r ? c(new o(t), d) : a(t, d);
                    var m = u.alloc(p - f.length);
                    if (f = u.concat([
                        m,
                        f
                    ], p), 4 === h) return function(e, t) {
                        var r = e.modulus.byteLength(), n = l("sha1").update(u.alloc(0)).digest(), o = n.length;
                        if (0 !== t[0]) throw new Error("decryption error");
                        var a = t.slice(1, o + 1), c = t.slice(o + 1), h = s(a, i(c, o)), f = s(c, i(h, r - o - 1));
                        if (function(e, t) {
                            e = u.from(e), t = u.from(t);
                            var r = 0, n = e.length;
                            e.length !== t.length && (r++, n = Math.min(e.length, t.length));
                            var i = -1;
                            for(; ++i < n;)r += e[i] ^ t[i];
                            return r;
                        }(n, f.slice(0, o))) throw new Error("decryption error");
                        var d = o;
                        for(; 0 === f[d];)d++;
                        if (1 !== f[d++]) throw new Error("decryption error");
                        return f.slice(d);
                    }(d, f);
                    if (1 === h) return function(e, t, r) {
                        var n = t.slice(0, 2), i = 2, s = 0;
                        for(; 0 !== t[i++];)if (i >= t.length) {
                            s++;
                            break;
                        }
                        var o = t.slice(2, i - 1);
                        ("0002" !== n.toString("hex") && !r || "0001" !== n.toString("hex") && r) && s++;
                        o.length < 8 && s++;
                        if (s) throw new Error("decryption error");
                        return t.slice(i);
                    }(0, f, r);
                    if (3 === h) return f;
                    throw new Error("unknown padding");
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                "safe-buffer": 494
            }
        ],
        472: [
            function(e, t, r) {
                "use strict";
                var n = e("parse-asn1"), i = e("randombytes"), s = e("create-hash"), o = e("./mgf"), a = e("./xor"), l = e("bn.js"), c = e("./withPublic"), u = e("browserify-rsa"), h = e("safe-buffer").Buffer;
                t.exports = function(e, t, r) {
                    var f;
                    f = e.padding ? e.padding : r ? 1 : 4;
                    var d, p = n(e);
                    if (4 === f) d = function(e, t) {
                        var r = e.modulus.byteLength(), n = t.length, c = s("sha1").update(h.alloc(0)).digest(), u = c.length, f = 2 * u;
                        if (n > r - f - 2) throw new Error("message too long");
                        var d = h.alloc(r - n - f - 2), p = r - u - 1, m = i(u), b = a(h.concat([
                            c,
                            d,
                            h.alloc(1, 1),
                            t
                        ], p), o(m, p)), g = a(m, o(b, u));
                        return new l(h.concat([
                            h.alloc(1),
                            g,
                            b
                        ], r));
                    }(p, t);
                    else if (1 === f) d = function(e, t, r) {
                        var n, s = t.length, o = e.modulus.byteLength();
                        if (s > o - 11) throw new Error("message too long");
                        n = r ? h.alloc(o - s - 3, 255) : function(e) {
                            var t, r = h.allocUnsafe(e), n = 0, s = i(2 * e), o = 0;
                            for(; n < e;)o === s.length && (s = i(2 * e), o = 0), (t = s[o++]) && (r[n++] = t);
                            return r;
                        }(o - s - 3);
                        return new l(h.concat([
                            h.from([
                                0,
                                r ? 1 : 2
                            ]),
                            n,
                            h.alloc(1),
                            t
                        ], o));
                    }(p, t, r);
                    else {
                        if (3 !== f) throw new Error("unknown padding");
                        if ((d = new l(t)).cmp(p.modulus) >= 0) throw new Error("data too long for modulus");
                    }
                    return r ? u(d, p) : c(d, p);
                };
            },
            {
                "./mgf": 469,
                "./withPublic": 473,
                "./xor": 474,
                "bn.js": 470,
                "browserify-rsa": 209,
                "create-hash": 386,
                "parse-asn1": 459,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        473: [
            function(e, t, r) {
                "use strict";
                var n = e("bn.js"), i = e("safe-buffer").Buffer;
                t.exports = function(e, t) {
                    return i.from(e.toRed(n.mont(t.modulus)).redPow(new n(t.publicExponent)).fromRed().toArray());
                };
            },
            {
                "bn.js": 470,
                "safe-buffer": 494
            }
        ],
        474: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    for(var r = e.length, n = -1; ++n < r;)e[n] ^= t[n];
                    return e;
                };
            },
            {}
        ],
        475: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("safe-buffer").Buffer, s = n.crypto || n.msCrypto;
                        s && s.getRandomValues ? t.exports = function(e, t) {
                            if (e > 4294967295) throw new RangeError("requested too many random bytes");
                            var n = i.allocUnsafe(e);
                            if (e > 0) {
                                if (e > 65536) for(var o = 0; o < e; o += 65536)s.getRandomValues(n.slice(o, o + 65536));
                                else s.getRandomValues(n);
                            }
                            if ("function" == typeof t) return r.nextTick(function() {
                                t(null, n);
                            });
                            return n;
                        } : t.exports = function() {
                            throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                "safe-buffer": 494
            }
        ],
        476: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        function i() {
                            throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
                        }
                        var s = e("safe-buffer"), o = e("randombytes"), a = s.Buffer, l = s.kMaxLength, c = n.crypto || n.msCrypto, u = Math.pow(2, 32) - 1;
                        function h(e, t) {
                            if ("number" != typeof e || e != e) throw new TypeError("offset must be a number");
                            if (e > u || e < 0) throw new TypeError("offset must be a uint32");
                            if (e > l || e > t) throw new RangeError("offset out of range");
                        }
                        function f(e, t, r) {
                            if ("number" != typeof e || e != e) throw new TypeError("size must be a number");
                            if (e > u || e < 0) throw new TypeError("size must be a uint32");
                            if (e + t > r || e > l) throw new RangeError("buffer too small");
                        }
                        function d(e, r, n, i) {
                            if (t.browser) {
                                var s = e.buffer, a = new Uint8Array(s, r, n);
                                return c.getRandomValues(a), i ? void t.nextTick(function() {
                                    i(null, e);
                                }) : e;
                            }
                            if (!i) return o(n).copy(e, r), e;
                            o(n, function(t, n) {
                                if (t) return i(t);
                                n.copy(e, r), i(null, e);
                            });
                        }
                        c && c.getRandomValues || !t.browser ? (r.randomFill = function(e, t, r, i) {
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            if ("function" == typeof t) i = t, t = 0, r = e.length;
                            else if ("function" == typeof r) i = r, r = e.length - t;
                            else if ("function" != typeof i) throw new TypeError('"cb" argument must be a function');
                            return h(t, e.length), f(r, t, e.length), d(e, t, r, i);
                        }, r.randomFillSync = function(e, t, r) {
                            void 0 === t && (t = 0);
                            if (!(a.isBuffer(e) || e instanceof n.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
                            h(t, e.length), void 0 === r && (r = e.length - t);
                            return f(r, t, e.length), d(e, t, r);
                        }) : (r.randomFill = i, r.randomFillSync = i);
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                _process: 467,
                randombytes: 475,
                "safe-buffer": 494
            }
        ],
        477: [
            function(e, t, r) {
                "use strict";
                var n = {};
                function i(e, t, r) {
                    r || (r = Error);
                    var i = function(e) {
                        var r, n;
                        function i(r, n, i) {
                            return e.call(this, function(e, r, n) {
                                return "string" == typeof t ? t : t(e, r, n);
                            }(r, n, i)) || this;
                        }
                        return n = e, (r = i).prototype = Object.create(n.prototype), r.prototype.constructor = r, r.__proto__ = n, i;
                    }(r);
                    i.prototype.name = r.name, i.prototype.code = e, n[e] = i;
                }
                function s(e, t) {
                    if (Array.isArray(e)) {
                        var r = e.length;
                        return e = e.map(function(e) {
                            return String(e);
                        }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : 2 === r ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                    }
                    return "of ".concat(t, " ").concat(String(e));
                }
                i("ERR_INVALID_OPT_VALUE", function(e, t) {
                    return 'The value "' + t + '" is invalid for option "' + e + '"';
                }, TypeError), i("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                    var n, i, o, a;
                    if ("string" == typeof t && (i = "not ", t.substr(!o || o < 0 ? 0 : +o, i.length) === i) ? (n = "must not be", t = t.replace(/^not /, "")) : n = "must be", function(e, t, r) {
                        return (void 0 === r || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
                    }(e, " argument")) a = "The ".concat(e, " ").concat(n, " ").concat(s(t, "type"));
                    else {
                        var l = function(e, t, r) {
                            return "number" != typeof r && (r = 0), !(r + t.length > e.length) && -1 !== e.indexOf(t, r);
                        }(e, ".") ? "property" : "argument";
                        a = 'The "'.concat(e, '" ').concat(l, " ").concat(n, " ").concat(s(t, "type"));
                    }
                    return a += ". Received type ".concat(typeof r);
                }, TypeError), i("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), i("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                    return "The " + e + " method is not implemented";
                }), i("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), i("ERR_STREAM_DESTROYED", function(e) {
                    return "Cannot call " + e + " after a stream was destroyed";
                }), i("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), i("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), i("ERR_STREAM_WRITE_AFTER_END", "write after end"), i("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), i("ERR_UNKNOWN_ENCODING", function(e) {
                    return "Unknown encoding: " + e;
                }, TypeError), i("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), t.exports.codes = n;
            },
            {}
        ],
        478: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n = Object.keys || function(e) {
                            var t = [];
                            for(var r in e)t.push(r);
                            return t;
                        };
                        t.exports = c;
                        var i = e("./_stream_readable"), s = e("./_stream_writable");
                        e("inherits")(c, i);
                        for(var o = n(s.prototype), a = 0; a < o.length; a++){
                            var l = o[a];
                            c.prototype[l] || (c.prototype[l] = s.prototype[l]);
                        }
                        function c(e) {
                            if (!(this instanceof c)) return new c(e);
                            i.call(this, e), s.call(this, e), this.allowHalfOpen = !0, e && (!1 === e.readable && (this.readable = !1), !1 === e.writable && (this.writable = !1), !1 === e.allowHalfOpen && (this.allowHalfOpen = !1, this.once("end", u)));
                        }
                        function u() {
                            this._writableState.ended || r.nextTick(h, this);
                        }
                        function h(e) {
                            e.end();
                        }
                        Object.defineProperty(c.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), Object.defineProperty(c.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(c.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(c.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                            },
                            set: function(e) {
                                void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                            }
                        });
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./_stream_readable": 480,
                "./_stream_writable": 482,
                _process: 467,
                inherits: 440
            }
        ],
        479: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("./_stream_transform");
                function i(e) {
                    if (!(this instanceof i)) return new i(e);
                    n.call(this, e);
                }
                e("inherits")(i, n), i.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 481,
                inherits: 440
            }
        ],
        480: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i;
                        t.exports = M, M.ReadableState = S;
                        e("events").EventEmitter;
                        var s = function(e, t) {
                            return e.listeners(t).length;
                        }, o = e("./internal/streams/stream"), a = e("buffer").Buffer, l = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var c, u = e("util");
                        c = u && u.debuglog ? u.debuglog("stream") : function() {};
                        var h, f, d, p = e("./internal/streams/buffer_list"), m = e("./internal/streams/destroy"), b = e("./internal/streams/state").getHighWaterMark, g = e("../errors").codes, y = g.ERR_INVALID_ARG_TYPE, v = g.ERR_STREAM_PUSH_AFTER_EOF, w = g.ERR_METHOD_NOT_IMPLEMENTED, _ = g.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
                        e("inherits")(M, o);
                        var x = m.errorOrDestroy, k = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function S(t, r, n) {
                            i = i || e("./_stream_duplex"), t = t || {}, "boolean" != typeof n && (n = r instanceof i), this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode), this.highWaterMark = b(this, t, "readableHighWaterMark", n), this.buffer = new p, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (h || (h = e("string_decoder/").StringDecoder), this.decoder = new h(t.encoding), this.encoding = t.encoding);
                        }
                        function M(t) {
                            if (i = i || e("./_stream_duplex"), !(this instanceof M)) return new M(t);
                            var r = this instanceof i;
                            this._readableState = new S(t, this, r), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), o.call(this);
                        }
                        function C(e, t, r, n, i) {
                            c("readableAddChunk", t);
                            var s, o = e._readableState;
                            if (null === t) o.reading = !1, function(e, t) {
                                if (c("onEofChunk"), t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, t.sync ? A(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, R(e)));
                            }(e, o);
                            else if (i || (s = function(e, t) {
                                var r;
                                n = t, a.isBuffer(n) || n instanceof l || "string" == typeof t || void 0 === t || e.objectMode || (r = new y("chunk", [
                                    "string",
                                    "Buffer",
                                    "Uint8Array"
                                ], t));
                                var n;
                                return r;
                            }(o, t)), s) x(e, s);
                            else if (o.objectMode || t && t.length > 0) {
                                if ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === a.prototype || (t = function(e) {
                                    return a.from(e);
                                }(t)), n) o.endEmitted ? x(e, new _) : T(e, o, t, !0);
                                else if (o.ended) x(e, new v);
                                else {
                                    if (o.destroyed) return !1;
                                    o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? T(e, o, t, !1) : O(e, o)) : T(e, o, t, !1);
                                }
                            } else n || (o.reading = !1, O(e, o));
                            return !o.ended && (o.length < o.highWaterMark || 0 === o.length);
                        }
                        function T(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && A(e)), O(e, t);
                        }
                        Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), M.prototype.destroy = m.destroy, M.prototype._undestroy = m.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        }, M.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = a.from(e, t), t = ""), r = !0), C(this, e, t, !1, r);
                        }, M.prototype.unshift = function(e) {
                            return C(this, e, null, !0, !1);
                        }, M.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, M.prototype.setEncoding = function(t) {
                            h || (h = e("string_decoder/").StringDecoder);
                            var r = new h(t);
                            this._readableState.decoder = r, this._readableState.encoding = this._readableState.decoder.encoding;
                            for(var n = this._readableState.buffer.head, i = ""; null !== n;)i += r.write(n.data), n = n.next;
                            return this._readableState.buffer.clear(), "" !== i && this._readableState.buffer.push(i), this._readableState.length = i.length, this;
                        };
                        function E(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 1073741824 ? e = 1073741824 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function A(e) {
                            var t = e._readableState;
                            c("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (c("emitReadable", t.flowing), t.emittedReadable = !0, r.nextTick(R, e));
                        }
                        function R(e) {
                            var t = e._readableState;
                            c("emitReadable_", t.destroyed, t.length, t.ended), t.destroyed || !t.length && !t.ended || (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, B(e);
                        }
                        function O(e, t) {
                            t.readingMore || (t.readingMore = !0, r.nextTick(j, e, t));
                        }
                        function j(e, t) {
                            for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && 0 === t.length);){
                                var r = t.length;
                                if (c("maybeReadMore read 0"), e.read(0), r === t.length) break;
                            }
                            t.readingMore = !1;
                        }
                        function I(e) {
                            var t = e._readableState;
                            t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
                        }
                        function N(e) {
                            c("readable nexttick read 0"), e.read(0);
                        }
                        function P(e, t) {
                            c("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), B(e), t.flowing && !t.reading && e.read(0);
                        }
                        function B(e) {
                            var t = e._readableState;
                            for(c("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function D(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r);
                        }
                        function F(e) {
                            var t = e._readableState;
                            c("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, r.nextTick(L, t, e));
                        }
                        function L(e, t) {
                            if (c("endReadableNT", e.endEmitted, e.length), !e.endEmitted && 0 === e.length && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                                var r = t._writableState;
                                (!r || r.autoDestroy && r.finished) && t.destroy();
                            }
                        }
                        function z(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        M.prototype.read = function(e) {
                            c("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && ((0 !== t.highWaterMark ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return c("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? F(this) : A(this), null;
                            if (0 === (e = E(e, t)) && t.ended) return 0 === t.length && F(this), null;
                            var n, i = t.needReadable;
                            return c("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && c("length less than watermark", i = !0), t.ended || t.reading ? c("reading or ended", i = !1) : i && (c("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = E(r, t))), null === (n = e > 0 ? D(e, t) : null) ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && F(this)), null !== n && this.emit("data", n), n;
                        }, M.prototype._read = function(e) {
                            x(this, new w("_read()"));
                        }, M.prototype.pipe = function(e, t) {
                            var n = this, i = this._readableState;
                            switch(i.pipesCount){
                                case 0:
                                    i.pipes = e;
                                    break;
                                case 1:
                                    i.pipes = [
                                        i.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    i.pipes.push(e);
                            }
                            i.pipesCount += 1, c("pipe count=%d opts=%j", i.pipesCount, t);
                            var o = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? l : b;
                            function a(t, r) {
                                c("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, c("cleanup"), e.removeListener("close", p), e.removeListener("finish", m), e.removeListener("drain", u), e.removeListener("error", d), e.removeListener("unpipe", a), n.removeListener("end", l), n.removeListener("end", b), n.removeListener("data", f), h = !0, !i.awaitDrain || e._writableState && !e._writableState.needDrain || u());
                            }
                            function l() {
                                c("onend"), e.end();
                            }
                            i.endEmitted ? r.nextTick(o) : n.once("end", o), e.on("unpipe", a);
                            var u = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    c("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && s(e, "data") && (t.flowing = !0, B(e));
                                };
                            }(n);
                            e.on("drain", u);
                            var h = !1;
                            function f(t) {
                                c("ondata");
                                var r = e.write(t);
                                c("dest.write", r), !1 === r && ((1 === i.pipesCount && i.pipes === e || i.pipesCount > 1 && -1 !== z(i.pipes, e)) && !h && (c("false write response, pause", i.awaitDrain), i.awaitDrain++), n.pause());
                            }
                            function d(t) {
                                c("onerror", t), b(), e.removeListener("error", d), 0 === s(e, "error") && x(e, t);
                            }
                            function p() {
                                e.removeListener("finish", m), b();
                            }
                            function m() {
                                c("onfinish"), e.removeListener("close", p), b();
                            }
                            function b() {
                                c("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", f), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", d), e.once("close", p), e.once("finish", m), e.emit("pipe", n), i.flowing || (c("pipe resume"), n.resume()), e;
                        }, M.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = z(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, M.prototype.on = function(e, t) {
                            var n = o.prototype.on.call(this, e, t), i = this._readableState;
                            return "data" === e ? (i.readableListening = this.listenerCount("readable") > 0, !1 !== i.flowing && this.resume()) : "readable" === e && (i.endEmitted || i.readableListening || (i.readableListening = i.needReadable = !0, i.flowing = !1, i.emittedReadable = !1, c("on readable", i.length, i.reading), i.length ? A(this) : i.reading || r.nextTick(N, this))), n;
                        }, M.prototype.addListener = M.prototype.on, M.prototype.removeListener = function(e, t) {
                            var n = o.prototype.removeListener.call(this, e, t);
                            return "readable" === e && r.nextTick(I, this), n;
                        }, M.prototype.removeAllListeners = function(e) {
                            var t = o.prototype.removeAllListeners.apply(this, arguments);
                            return "readable" !== e && void 0 !== e || r.nextTick(I, this), t;
                        }, M.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (c("resume"), e.flowing = !e.readableListening, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, r.nextTick(P, e, t));
                            }(this, e)), e.paused = !1, this;
                        }, M.prototype.pause = function() {
                            return c("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (c("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
                        }, M.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (c("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (c("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < k.length; s++)e.on(k[s], this.emit.bind(this, k[s]));
                            return this._read = function(t) {
                                c("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, "function" == typeof Symbol && (M.prototype[Symbol.asyncIterator] = function() {
                            return void 0 === f && (f = e("./internal/streams/async_iterator")), f(this);
                        }), Object.defineProperty(M.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), Object.defineProperty(M.prototype, "readableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState && this._readableState.buffer;
                            }
                        }), Object.defineProperty(M.prototype, "readableFlowing", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.flowing;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.flowing = e);
                            }
                        }), M._fromList = D, Object.defineProperty(M.prototype, "readableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.length;
                            }
                        }), "function" == typeof Symbol && (M.from = function(t, r) {
                            return void 0 === d && (d = e("./internal/streams/from")), d(M, t, r);
                        });
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/async_iterator": 483,
                "./internal/streams/buffer_list": 484,
                "./internal/streams/destroy": 485,
                "./internal/streams/from": 487,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                events: 422,
                inherits: 440,
                "string_decoder/": 522,
                util: 188
            }
        ],
        481: [
            function(e, t, r) {
                "use strict";
                t.exports = u;
                var n = e("../errors").codes, i = n.ERR_METHOD_NOT_IMPLEMENTED, s = n.ERR_MULTIPLE_CALLBACK, o = n.ERR_TRANSFORM_ALREADY_TRANSFORMING, a = n.ERR_TRANSFORM_WITH_LENGTH_0, l = e("./_stream_duplex");
                function c(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (null === n) return this.emit("error", new s);
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function u(e) {
                    if (!(this instanceof u)) return new u(e);
                    l.call(this, e), this._transformState = {
                        afterTransform: c.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", h);
                }
                function h() {
                    var e = this;
                    "function" != typeof this._flush || this._readableState.destroyed ? f(this, null, null) : this._flush(function(t, r) {
                        f(e, t, r);
                    });
                }
                function f(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new a;
                    if (e._transformState.transforming) throw new o;
                    return e.push(null);
                }
                e("inherits")(u, l), u.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, l.prototype.push.call(this, e, t);
                }, u.prototype._transform = function(e, t, r) {
                    r(new i("_transform()"));
                }, u.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, u.prototype._read = function(e) {
                    var t = this._transformState;
                    null === t.writechunk || t.transforming ? t.needTransform = !0 : (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform));
                }, u.prototype._destroy = function(e, t) {
                    l.prototype._destroy.call(this, e, function(e) {
                        t(e);
                    });
                };
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                inherits: 440
            }
        ],
        482: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        function i(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        var s;
                        t.exports = M, M.WritableState = S;
                        var o = {
                            deprecate: e("util-deprecate")
                        }, a = e("./internal/streams/stream"), l = e("buffer").Buffer, c = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var u, h = e("./internal/streams/destroy"), f = e("./internal/streams/state").getHighWaterMark, d = e("../errors").codes, p = d.ERR_INVALID_ARG_TYPE, m = d.ERR_METHOD_NOT_IMPLEMENTED, b = d.ERR_MULTIPLE_CALLBACK, g = d.ERR_STREAM_CANNOT_PIPE, y = d.ERR_STREAM_DESTROYED, v = d.ERR_STREAM_NULL_VALUES, w = d.ERR_STREAM_WRITE_AFTER_END, _ = d.ERR_UNKNOWN_ENCODING, x = h.errorOrDestroy;
                        function k() {}
                        function S(t, n, o) {
                            s = s || e("./_stream_duplex"), t = t || {}, "boolean" != typeof o && (o = n instanceof s), this.objectMode = !!t.objectMode, o && (this.objectMode = this.objectMode || !!t.writableObjectMode), this.highWaterMark = f(this, t, "writableHighWaterMark", o), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var a = !1 === t.decodeStrings;
                            this.decodeStrings = !a, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var n = e._writableState, i = n.sync, s = n.writecb;
                                    if ("function" != typeof s) throw new b;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(n), t) !function(e, t, n, i, s) {
                                        --t.pendingcb, n ? (r.nextTick(s, i), r.nextTick(O, e, t), e._writableState.errorEmitted = !0, x(e, i)) : (s(i), e._writableState.errorEmitted = !0, x(e, i), O(e, t));
                                    }(e, n, i, t, s);
                                    else {
                                        var o = A(n) || e.destroyed;
                                        o || n.corked || n.bufferProcessing || !n.bufferedRequest || E(e, n), i ? r.nextTick(T, e, n, o, s) : T(e, n, o, s);
                                    }
                                }(n, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = !1 !== t.emitClose, this.autoDestroy = !!t.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new i(this);
                        }
                        function M(t) {
                            var r = this instanceof (s = s || e("./_stream_duplex"));
                            if (!r && !u.call(M, this)) return new M(t);
                            this._writableState = new S(t, this, r), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), a.call(this);
                        }
                        function C(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new y("write")) : r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function T(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), O(e, t);
                        }
                        function E(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, s = new Array(n), o = t.corkedRequestsFree;
                                o.entry = r;
                                for(var a = 0, l = !0; r;)s[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                s.allBuffers = l, C(e, t, !0, t.length, s, "", o.finish), t.pendingcb++, t.lastBufferedRequest = null, o.next ? (t.corkedRequestsFree = o.next, o.next = null) : t.corkedRequestsFree = new i(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (C(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function A(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function R(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && x(e, r), t.prefinished = !0, e.emit("prefinish"), O(e, t);
                            });
                        }
                        function O(e, t) {
                            var n = A(t);
                            if (n && (function(e, t) {
                                t.prefinished || t.finalCalled || ("function" != typeof e._final || t.destroyed ? (t.prefinished = !0, e.emit("prefinish")) : (t.pendingcb++, t.finalCalled = !0, r.nextTick(R, e, t)));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                                var i = e._readableState;
                                (!i || i.autoDestroy && i.endEmitted) && e.destroy();
                            }
                            return n;
                        }
                        e("inherits")(M, a), S.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(S.prototype, "buffer", {
                                    get: o.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (u = Function.prototype[Symbol.hasInstance], Object.defineProperty(M, Symbol.hasInstance, {
                            value: function(e) {
                                return !!u.call(this, e) || this === M && e && e._writableState instanceof S;
                            }
                        })) : u = function(e) {
                            return e instanceof this;
                        }, M.prototype.pipe = function() {
                            x(this, new g);
                        }, M.prototype.write = function(e, t, n) {
                            var i, s = this._writableState, o = !1, a = !s.objectMode && (i = e, l.isBuffer(i) || i instanceof c);
                            return a && !l.isBuffer(e) && (e = function(e) {
                                return l.from(e);
                            }(e)), "function" == typeof t && (n = t, t = null), a ? t = "buffer" : t || (t = s.defaultEncoding), "function" != typeof n && (n = k), s.ending ? function(e, t) {
                                var n = new w;
                                x(e, n), r.nextTick(t, n);
                            }(this, n) : (a || function(e, t, n, i) {
                                var s;
                                return null === n ? s = new v : "string" == typeof n || t.objectMode || (s = new p("chunk", [
                                    "string",
                                    "Buffer"
                                ], n)), !s || (x(e, s), r.nextTick(i, s), !1);
                            }(this, s, e, n)) && (s.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = l.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var c = t.length < t.highWaterMark;
                                c || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var u = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else C(e, t, !1, a, n, i, s);
                                return c;
                            }(this, s, a, e, t, n)), o;
                        }, M.prototype.cork = function() {
                            this._writableState.corked++;
                        }, M.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || E(this, e));
                        }, M.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new _(e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(M.prototype, "writableBuffer", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState && this._writableState.getBuffer();
                            }
                        }), Object.defineProperty(M.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), M.prototype._write = function(e, t, r) {
                            r(new m("_write()"));
                        }, M.prototype._writev = null, M.prototype.end = function(e, t, n) {
                            var i = this._writableState;
                            return "function" == typeof e ? (n = e, e = null, t = null) : "function" == typeof t && (n = t, t = null), null != e && this.write(e, t), i.corked && (i.corked = 1, this.uncork()), i.ending || function(e, t, n) {
                                t.ending = !0, O(e, t), n && (t.finished ? r.nextTick(n) : e.once("finish", n));
                                t.ended = !0, e.writable = !1;
                            }(this, i, n), this;
                        }, Object.defineProperty(M.prototype, "writableLength", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.length;
                            }
                        }), Object.defineProperty(M.prototype, "destroyed", {
                            enumerable: !1,
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), M.prototype.destroy = h.destroy, M.prototype._undestroy = h.undestroy, M.prototype._destroy = function(e, t) {
                            t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "../errors": 477,
                "./_stream_duplex": 478,
                "./internal/streams/destroy": 485,
                "./internal/streams/state": 489,
                "./internal/streams/stream": 490,
                _process: 467,
                buffer: 220,
                inherits: 440,
                "util-deprecate": 524
            }
        ],
        483: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n;
                        function i(e, t, r) {
                            return (t = function(e) {
                                var t = function(e, t) {
                                    if ("object" != typeof e || null === e) return e;
                                    var r = e[Symbol.toPrimitive];
                                    if (void 0 !== r) {
                                        var n = r.call(e, t || "default");
                                        if ("object" != typeof n) return n;
                                        throw new TypeError("@@toPrimitive must return a primitive value.");
                                    }
                                    return ("string" === t ? String : Number)(e);
                                }(e, "string");
                                return "symbol" == typeof t ? t : String(t);
                            }(t)) in e ? Object.defineProperty(e, t, {
                                value: r,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : e[t] = r, e;
                        }
                        var s = e("./end-of-stream"), o = Symbol("lastResolve"), a = Symbol("lastReject"), l = Symbol("error"), c = Symbol("ended"), u = Symbol("lastPromise"), h = Symbol("handlePromise"), f = Symbol("stream");
                        function d(e, t) {
                            return {
                                value: e,
                                done: t
                            };
                        }
                        function p(e) {
                            var t = e[o];
                            if (null !== t) {
                                var r = e[f].read();
                                null !== r && (e[u] = null, e[o] = null, e[a] = null, t(d(r, !1)));
                            }
                        }
                        function m(e) {
                            r.nextTick(p, e);
                        }
                        var b = Object.getPrototypeOf(function() {}), g = Object.setPrototypeOf((i(n = {
                            get stream () {
                                return this[f];
                            },
                            next: function() {
                                var e = this, t = this[l];
                                if (null !== t) return Promise.reject(t);
                                if (this[c]) return Promise.resolve(d(void 0, !0));
                                if (this[f].destroyed) return new Promise(function(t, n) {
                                    r.nextTick(function() {
                                        e[l] ? n(e[l]) : t(d(void 0, !0));
                                    });
                                });
                                var n, i = this[u];
                                if (i) n = new Promise(function(e, t) {
                                    return function(r, n) {
                                        e.then(function() {
                                            t[c] ? r(d(void 0, !0)) : t[h](r, n);
                                        }, n);
                                    };
                                }(i, this));
                                else {
                                    var s = this[f].read();
                                    if (null !== s) return Promise.resolve(d(s, !1));
                                    n = new Promise(this[h]);
                                }
                                return this[u] = n, n;
                            }
                        }, Symbol.asyncIterator, function() {
                            return this;
                        }), i(n, "return", function() {
                            var e = this;
                            return new Promise(function(t, r) {
                                e[f].destroy(null, function(e) {
                                    e ? r(e) : t(d(void 0, !0));
                                });
                            });
                        }), n), b);
                        t.exports = function(e) {
                            var t, r = Object.create(g, (i(t = {}, f, {
                                value: e,
                                writable: !0
                            }), i(t, o, {
                                value: null,
                                writable: !0
                            }), i(t, a, {
                                value: null,
                                writable: !0
                            }), i(t, l, {
                                value: null,
                                writable: !0
                            }), i(t, c, {
                                value: e._readableState.endEmitted,
                                writable: !0
                            }), i(t, h, {
                                value: function(e, t) {
                                    var n = r[f].read();
                                    n ? (r[u] = null, r[o] = null, r[a] = null, e(d(n, !1))) : (r[o] = e, r[a] = t);
                                },
                                writable: !0
                            }), t));
                            return r[u] = null, s(e, function(e) {
                                if (e && "ERR_STREAM_PREMATURE_CLOSE" !== e.code) {
                                    var t = r[a];
                                    return null !== t && (r[u] = null, r[o] = null, r[a] = null, t(e)), void (r[l] = e);
                                }
                                var n = r[o];
                                null !== n && (r[u] = null, r[o] = null, r[a] = null, n(d(void 0, !0))), r[c] = !0;
                            }), e.on("readable", m.bind(null, r)), r;
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                "./end-of-stream": 486,
                _process: 467
            }
        ],
        484: [
            function(e, t, r) {
                "use strict";
                function n(e, t) {
                    var r = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        t && (n = n.filter(function(t) {
                            return Object.getOwnPropertyDescriptor(e, t).enumerable;
                        })), r.push.apply(r, n);
                    }
                    return r;
                }
                function i(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? n(Object(r), !0).forEach(function(t) {
                            s(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : n(Object(r)).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }
                function s(e, t, r) {
                    return (t = a(t)) in e ? Object.defineProperty(e, t, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = r, e;
                }
                function o(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a(n.key), n);
                    }
                }
                function a(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }
                var l = e("buffer").Buffer, c = e("util").inspect, u = c && c.custom || "inspect";
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    var t, r, n;
                    return t = e, r = [
                        {
                            key: "push",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: null
                                };
                                this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                            }
                        },
                        {
                            key: "unshift",
                            value: function(e) {
                                var t = {
                                    data: e,
                                    next: this.head
                                };
                                0 === this.length && (this.tail = t), this.head = t, ++this.length;
                            }
                        },
                        {
                            key: "shift",
                            value: function() {
                                if (0 !== this.length) {
                                    var e = this.head.data;
                                    return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                                }
                            }
                        },
                        {
                            key: "clear",
                            value: function() {
                                this.head = this.tail = null, this.length = 0;
                            }
                        },
                        {
                            key: "join",
                            value: function(e) {
                                if (0 === this.length) return "";
                                for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                                return r;
                            }
                        },
                        {
                            key: "concat",
                            value: function(e) {
                                if (0 === this.length) return l.alloc(0);
                                for(var t, r, n, i = l.allocUnsafe(e >>> 0), s = this.head, o = 0; s;)t = s.data, r = i, n = o, l.prototype.copy.call(t, r, n), o += s.data.length, s = s.next;
                                return i;
                            }
                        },
                        {
                            key: "consume",
                            value: function(e, t) {
                                var r;
                                return e < this.head.data.length ? (r = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : r = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), r;
                            }
                        },
                        {
                            key: "first",
                            value: function() {
                                return this.head.data;
                            }
                        },
                        {
                            key: "_getString",
                            value: function(e) {
                                var t = this.head, r = 1, n = t.data;
                                for(e -= n.length; t = t.next;){
                                    var i = t.data, s = e > i.length ? i.length : e;
                                    if (s === i.length ? n += i : n += i.slice(0, e), 0 == (e -= s)) {
                                        s === i.length ? (++r, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(s));
                                        break;
                                    }
                                    ++r;
                                }
                                return this.length -= r, n;
                            }
                        },
                        {
                            key: "_getBuffer",
                            value: function(e) {
                                var t = l.allocUnsafe(e), r = this.head, n = 1;
                                for(r.data.copy(t), e -= r.data.length; r = r.next;){
                                    var i = r.data, s = e > i.length ? i.length : e;
                                    if (i.copy(t, t.length - e, 0, s), 0 == (e -= s)) {
                                        s === i.length ? (++n, r.next ? this.head = r.next : this.head = this.tail = null) : (this.head = r, r.data = i.slice(s));
                                        break;
                                    }
                                    ++n;
                                }
                                return this.length -= n, t;
                            }
                        },
                        {
                            key: u,
                            value: function(e, t) {
                                return c(this, i(i({}, t), {}, {
                                    depth: 0,
                                    customInspect: !1
                                }));
                            }
                        }
                    ], o(t.prototype, r), n && o(t, n), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }();
            },
            {
                buffer: 220,
                util: 188
            }
        ],
        485: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(e, t) {
                            i(e, t), n(e);
                        }
                        function n(e) {
                            e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
                        }
                        function i(e, t) {
                            e.emit("error", t);
                        }
                        t.exports = {
                            destroy: function(t, s) {
                                var o = this, a = this._readableState && this._readableState.destroyed, l = this._writableState && this._writableState.destroyed;
                                return a || l ? (s ? s(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, e.nextTick(i, this, t)) : e.nextTick(i, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(t) {
                                    !s && t ? o._writableState ? o._writableState.errorEmitted ? e.nextTick(n, o) : (o._writableState.errorEmitted = !0, e.nextTick(r, o, t)) : e.nextTick(r, o, t) : s ? (e.nextTick(n, o), s(t)) : e.nextTick(n, o);
                                }), this);
                            },
                            undestroy: function() {
                                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                            },
                            errorOrDestroy: function(e, t) {
                                var r = e._readableState, n = e._writableState;
                                r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
                            }
                        };
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467
            }
        ],
        486: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
                function i() {}
                t.exports = function e(t, r, s) {
                    if ("function" == typeof r) return e(t, null, r);
                    r || (r = {}), s = function(e) {
                        var t = !1;
                        return function() {
                            if (!t) {
                                t = !0;
                                for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                                e.apply(this, n);
                            }
                        };
                    }(s || i);
                    var o = r.readable || !1 !== r.readable && t.readable, a = r.writable || !1 !== r.writable && t.writable, l = function() {
                        t.writable || u();
                    }, c = t._writableState && t._writableState.finished, u = function() {
                        a = !1, c = !0, o || s.call(t);
                    }, h = t._readableState && t._readableState.endEmitted, f = function() {
                        o = !1, h = !0, a || s.call(t);
                    }, d = function(e) {
                        s.call(t, e);
                    }, p = function() {
                        var e;
                        return o && !h ? (t._readableState && t._readableState.ended || (e = new n), s.call(t, e)) : a && !c ? (t._writableState && t._writableState.ended || (e = new n), s.call(t, e)) : void 0;
                    }, m = function() {
                        t.req.on("finish", u);
                    };
                    return !function(e) {
                        return e.setHeader && "function" == typeof e.abort;
                    }(t) ? a && !t._writableState && (t.on("end", l), t.on("close", l)) : (t.on("complete", u), t.on("abort", p), t.req ? m() : t.on("request", m)), t.on("end", f), t.on("finish", u), !1 !== r.error && t.on("error", d), t.on("close", p), function() {
                        t.removeListener("complete", u), t.removeListener("abort", p), t.removeListener("request", m), t.req && t.req.removeListener("finish", u), t.removeListener("end", l), t.removeListener("close", l), t.removeListener("finish", u), t.removeListener("end", f), t.removeListener("error", d), t.removeListener("close", p);
                    };
                };
            },
            {
                "../../../errors": 477
            }
        ],
        487: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    throw new Error("Readable.from is not available in the browser");
                };
            },
            {}
        ],
        488: [
            function(e, t, r) {
                "use strict";
                var n;
                var i = e("../../../errors").codes, s = i.ERR_MISSING_ARGS, o = i.ERR_STREAM_DESTROYED;
                function a(e) {
                    if (e) throw e;
                }
                function l(t, r, i, s) {
                    s = function(e) {
                        var t = !1;
                        return function() {
                            t || (t = !0, e.apply(void 0, arguments));
                        };
                    }(s);
                    var a = !1;
                    t.on("close", function() {
                        a = !0;
                    }), void 0 === n && (n = e("./end-of-stream")), n(t, {
                        readable: r,
                        writable: i
                    }, function(e) {
                        if (e) return s(e);
                        a = !0, s();
                    });
                    var l = !1;
                    return function(e) {
                        if (!a && !l) return l = !0, function(e) {
                            return e.setHeader && "function" == typeof e.abort;
                        }(t) ? t.abort() : "function" == typeof t.destroy ? t.destroy() : void s(e || new o("pipe"));
                    };
                }
                function c(e) {
                    e();
                }
                function u(e, t) {
                    return e.pipe(t);
                }
                function h(e) {
                    return e.length ? "function" != typeof e[e.length - 1] ? a : e.pop() : a;
                }
                t.exports = function() {
                    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                    var n, i = h(t);
                    if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new s("streams");
                    var o = t.map(function(e, r) {
                        var s = r < t.length - 1;
                        return l(e, s, r > 0, function(e) {
                            n || (n = e), e && o.forEach(c), s || (o.forEach(c), i(n));
                        });
                    });
                    return t.reduce(u);
                };
            },
            {
                "../../../errors": 477,
                "./end-of-stream": 486
            }
        ],
        489: [
            function(e, t, r) {
                "use strict";
                var n = e("../../../errors").codes.ERR_INVALID_OPT_VALUE;
                t.exports = {
                    getHighWaterMark: function(e, t, r, i) {
                        var s = function(e, t, r) {
                            return null != e.highWaterMark ? e.highWaterMark : t ? e[r] : null;
                        }(t, i, r);
                        if (null != s) {
                            if (!isFinite(s) || Math.floor(s) !== s || s < 0) throw new n(i ? r : "highWaterMark", s);
                            return Math.floor(s);
                        }
                        return e.objectMode ? 16 : 16384;
                    }
                };
            },
            {
                "../../../errors": 477
            }
        ],
        490: [
            function(e, t, r) {
                "use strict";
                t.exports = e("events").EventEmitter;
            },
            {
                events: 422
            }
        ],
        491: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js"), r.finished = e("./lib/internal/streams/end-of-stream.js"), r.pipeline = e("./lib/internal/streams/pipeline.js");
            },
            {
                "./lib/_stream_duplex.js": 478,
                "./lib/_stream_passthrough.js": 479,
                "./lib/_stream_readable.js": 480,
                "./lib/_stream_transform.js": 481,
                "./lib/_stream_writable.js": 482,
                "./lib/internal/streams/end-of-stream.js": 486,
                "./lib/internal/streams/pipeline.js": 488
            }
        ],
        492: [
            function(e, t, r) {
                "use strict";
                var n = function(e) {
                    var t = Object.prototype, r = t.hasOwnProperty, n = Object.defineProperty || function(e, t, r) {
                        e[t] = r.value;
                    }, i = "function" == typeof Symbol ? Symbol : {}, s = i.iterator || "@@iterator", o = i.asyncIterator || "@@asyncIterator", a = i.toStringTag || "@@toStringTag";
                    function l(e, t, r) {
                        return Object.defineProperty(e, t, {
                            value: r,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), e[t];
                    }
                    try {
                        l({}, "");
                    } catch (e) {
                        l = function(e, t, r) {
                            return e[t] = r;
                        };
                    }
                    function c(e, t, r, i) {
                        var s = t && t.prototype instanceof f ? t : f, o = Object.create(s.prototype), a = new M(i || []);
                        return n(o, "_invoke", {
                            value: _(e, r, a)
                        }), o;
                    }
                    function u(e, t, r) {
                        try {
                            return {
                                type: "normal",
                                arg: e.call(t, r)
                            };
                        } catch (e) {
                            return {
                                type: "throw",
                                arg: e
                            };
                        }
                    }
                    e.wrap = c;
                    var h = {};
                    function f() {}
                    function d() {}
                    function p() {}
                    var m = {};
                    l(m, s, function() {
                        return this;
                    });
                    var b = Object.getPrototypeOf, g = b && b(b(C([])));
                    g && g !== t && r.call(g, s) && (m = g);
                    var y = p.prototype = f.prototype = Object.create(m);
                    function v(e) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            l(e, t, function(e) {
                                return this._invoke(t, e);
                            });
                        });
                    }
                    function w(e, t) {
                        var i;
                        n(this, "_invoke", {
                            value: function(n, s) {
                                function o() {
                                    return new t(function(i, o) {
                                        !function n(i, s, o, a) {
                                            var l = u(e[i], e, s);
                                            if ("throw" !== l.type) {
                                                var c = l.arg, h = c.value;
                                                return h && "object" == typeof h && r.call(h, "__await") ? t.resolve(h.__await).then(function(e) {
                                                    n("next", e, o, a);
                                                }, function(e) {
                                                    n("throw", e, o, a);
                                                }) : t.resolve(h).then(function(e) {
                                                    c.value = e, o(c);
                                                }, function(e) {
                                                    return n("throw", e, o, a);
                                                });
                                            }
                                            a(l.arg);
                                        }(n, s, i, o);
                                    });
                                }
                                return i = i ? i.then(o, o) : o();
                            }
                        });
                    }
                    function _(e, t, r) {
                        var n = "suspendedStart";
                        return function(i, s) {
                            if ("executing" === n) throw new Error("Generator is already running");
                            if ("completed" === n) {
                                if ("throw" === i) throw s;
                                return T();
                            }
                            for(r.method = i, r.arg = s;;){
                                var o = r.delegate;
                                if (o) {
                                    var a = x(o, r);
                                    if (a) {
                                        if (a === h) continue;
                                        return a;
                                    }
                                }
                                if ("next" === r.method) r.sent = r._sent = r.arg;
                                else if ("throw" === r.method) {
                                    if ("suspendedStart" === n) throw n = "completed", r.arg;
                                    r.dispatchException(r.arg);
                                } else "return" === r.method && r.abrupt("return", r.arg);
                                n = "executing";
                                var l = u(e, t, r);
                                if ("normal" === l.type) {
                                    if (n = r.done ? "completed" : "suspendedYield", l.arg === h) continue;
                                    return {
                                        value: l.arg,
                                        done: r.done
                                    };
                                }
                                "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
                            }
                        };
                    }
                    function x(e, t) {
                        var r = t.method, n = e.iterator[r];
                        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), h;
                        var i = u(n, e.iterator, t.arg);
                        if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, h;
                        var s = i.arg;
                        return s ? s.done ? (t[e.resultName] = s.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : s : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
                    }
                    function k(e) {
                        var t = {
                            tryLoc: e[0]
                        };
                        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
                    }
                    function S(e) {
                        var t = e.completion || {};
                        t.type = "normal", delete t.arg, e.completion = t;
                    }
                    function M(e) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], e.forEach(k, this), this.reset(!0);
                    }
                    function C(e) {
                        if (e) {
                            var t = e[s];
                            if (t) return t.call(e);
                            if ("function" == typeof e.next) return e;
                            if (!isNaN(e.length)) {
                                var n = -1, i = function t() {
                                    for(; ++n < e.length;)if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
                                    return t.value = void 0, t.done = !0, t;
                                };
                                return i.next = i;
                            }
                        }
                        return {
                            next: T
                        };
                    }
                    function T() {
                        return {
                            value: void 0,
                            done: !0
                        };
                    }
                    return d.prototype = p, n(y, "constructor", {
                        value: p,
                        configurable: !0
                    }), n(p, "constructor", {
                        value: d,
                        configurable: !0
                    }), d.displayName = l(p, a, "GeneratorFunction"), e.isGeneratorFunction = function(e) {
                        var t = "function" == typeof e && e.constructor;
                        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
                    }, e.mark = function(e) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(e, p) : (e.__proto__ = p, l(e, a, "GeneratorFunction")), e.prototype = Object.create(y), e;
                    }, e.awrap = function(e) {
                        return {
                            __await: e
                        };
                    }, v(w.prototype), l(w.prototype, o, function() {
                        return this;
                    }), e.AsyncIterator = w, e.async = function(t, r, n, i, s) {
                        void 0 === s && (s = Promise);
                        var o = new w(c(t, r, n, i), s);
                        return e.isGeneratorFunction(r) ? o : o.next().then(function(e) {
                            return e.done ? e.value : o.next();
                        });
                    }, v(y), l(y, a, "Generator"), l(y, s, function() {
                        return this;
                    }), l(y, "toString", function() {
                        return "[object Generator]";
                    }), e.keys = function(e) {
                        var t = Object(e), r = [];
                        for(var n in t)r.push(n);
                        return r.reverse(), function e() {
                            for(; r.length;){
                                var n = r.pop();
                                if (n in t) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, e.values = C, M.prototype = {
                        constructor: M,
                        reset: function(e) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(S), !e) for(var t in this)"t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
                        },
                        stop: function() {
                            this.done = !0;
                            var e = this.tryEntries[0].completion;
                            if ("throw" === e.type) throw e.arg;
                            return this.rval;
                        },
                        dispatchException: function(e) {
                            if (this.done) throw e;
                            var t = this;
                            function n(r, n) {
                                return o.type = "throw", o.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
                            }
                            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                                var s = this.tryEntries[i], o = s.completion;
                                if ("root" === s.tryLoc) return n("end");
                                if (s.tryLoc <= this.prev) {
                                    var a = r.call(s, "catchLoc"), l = r.call(s, "finallyLoc");
                                    if (a && l) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    } else if (a) {
                                        if (this.prev < s.catchLoc) return n(s.catchLoc, !0);
                                    } else {
                                        if (!l) throw new Error("try statement without catch or finally");
                                        if (this.prev < s.finallyLoc) return n(s.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(e, t) {
                            for(var n = this.tryEntries.length - 1; n >= 0; --n){
                                var i = this.tryEntries[n];
                                if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                    var s = i;
                                    break;
                                }
                            }
                            s && ("break" === e || "continue" === e) && s.tryLoc <= t && t <= s.finallyLoc && (s = null);
                            var o = s ? s.completion : {};
                            return o.type = e, o.arg = t, s ? (this.method = "next", this.next = s.finallyLoc, h) : this.complete(o);
                        },
                        complete: function(e, t) {
                            if ("throw" === e.type) throw e.arg;
                            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
                        },
                        finish: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), S(r), h;
                            }
                        },
                        catch: function(e) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var r = this.tryEntries[t];
                                if (r.tryLoc === e) {
                                    var n = r.completion;
                                    if ("throw" === n.type) {
                                        var i = n.arg;
                                        S(r);
                                    }
                                    return i;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(e, t, r) {
                            return this.delegate = {
                                iterator: C(e),
                                resultName: t,
                                nextLoc: r
                            }, "next" === this.method && (this.arg = void 0), h;
                        }
                    }, e;
                }("object" == typeof t ? t.exports : {});
                try {
                    regeneratorRuntime = n;
                } catch (e) {
                    "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
                }
            },
            {}
        ],
        493: [
            function(e, t, r) {
                "use strict";
                var n = e("buffer").Buffer, i = e("inherits"), s = e("hash-base"), o = new Array(16), a = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ], l = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ], c = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ], u = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ], h = [
                    0,
                    1518500249,
                    1859775393,
                    2400959708,
                    2840853838
                ], f = [
                    1352829926,
                    1548603684,
                    1836072691,
                    2053994217,
                    0
                ];
                function d() {
                    s.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
                }
                function p(e, t) {
                    return e << t | e >>> 32 - t;
                }
                function m(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ r ^ n) + s + o | 0, a) + i | 0;
                }
                function b(e, t, r, n, i, s, o, a) {
                    return p(e + (t & r | ~t & n) + s + o | 0, a) + i | 0;
                }
                function g(e, t, r, n, i, s, o, a) {
                    return p(e + ((t | ~r) ^ n) + s + o | 0, a) + i | 0;
                }
                function y(e, t, r, n, i, s, o, a) {
                    return p(e + (t & n | r & ~n) + s + o | 0, a) + i | 0;
                }
                function v(e, t, r, n, i, s, o, a) {
                    return p(e + (t ^ (r | ~n)) + s + o | 0, a) + i | 0;
                }
                i(d, s), d.prototype._update = function() {
                    for(var e = o, t = 0; t < 16; ++t)e[t] = this._block.readInt32LE(4 * t);
                    for(var r = 0 | this._a, n = 0 | this._b, i = 0 | this._c, s = 0 | this._d, d = 0 | this._e, w = 0 | this._a, _ = 0 | this._b, x = 0 | this._c, k = 0 | this._d, S = 0 | this._e, M = 0; M < 80; M += 1){
                        var C, T;
                        M < 16 ? (C = m(r, n, i, s, d, e[a[M]], h[0], c[M]), T = v(w, _, x, k, S, e[l[M]], f[0], u[M])) : M < 32 ? (C = b(r, n, i, s, d, e[a[M]], h[1], c[M]), T = y(w, _, x, k, S, e[l[M]], f[1], u[M])) : M < 48 ? (C = g(r, n, i, s, d, e[a[M]], h[2], c[M]), T = g(w, _, x, k, S, e[l[M]], f[2], u[M])) : M < 64 ? (C = y(r, n, i, s, d, e[a[M]], h[3], c[M]), T = b(w, _, x, k, S, e[l[M]], f[3], u[M])) : (C = v(r, n, i, s, d, e[a[M]], h[4], c[M]), T = m(w, _, x, k, S, e[l[M]], f[4], u[M])), r = d, d = s, s = p(i, 10), i = n, n = C, w = S, S = k, k = p(x, 10), x = _, _ = T;
                    }
                    var E = this._b + i + k | 0;
                    this._b = this._c + s + S | 0, this._c = this._d + d + w | 0, this._d = this._e + r + _ | 0, this._e = this._a + n + x | 0, this._a = E;
                }, d.prototype._digest = function() {
                    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
                    var e = n.alloc ? n.alloc(20) : new n(20);
                    return e.writeInt32LE(this._a, 0), e.writeInt32LE(this._b, 4), e.writeInt32LE(this._c, 8), e.writeInt32LE(this._d, 12), e.writeInt32LE(this._e, 16), e;
                }, t.exports = d;
            },
            {
                buffer: 220,
                "hash-base": 425,
                inherits: 440
            }
        ],
        494: [
            function(e, t, r) {
                "use strict";
                /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ var n = e("buffer"), i = n.Buffer;
                function s(e, t) {
                    for(var r in e)t[r] = e[r];
                }
                function o(e, t, r) {
                    return i(e, t, r);
                }
                i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (s(n, r), r.Buffer = o), o.prototype = Object.create(i.prototype), s(i, o), o.from = function(e, t, r) {
                    if ("number" == typeof e) throw new TypeError("Argument must not be a number");
                    return i(e, t, r);
                }, o.alloc = function(e, t, r) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    var n = i(e);
                    return void 0 !== t ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                }, o.allocUnsafe = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return i(e);
                }, o.allocUnsafeSlow = function(e) {
                    if ("number" != typeof e) throw new TypeError("Argument must be a number");
                    return n.SlowBuffer(e);
                };
            },
            {
                buffer: 220
            }
        ],
        495: [
            function(e, t, r) {
                (function(r) {
                    (function() {
                        "use strict";
                        var n, i = e("buffer"), s = i.Buffer, o = {};
                        for(n in i)i.hasOwnProperty(n) && "SlowBuffer" !== n && "Buffer" !== n && (o[n] = i[n]);
                        var a = o.Buffer = {};
                        for(n in s)s.hasOwnProperty(n) && "allocUnsafe" !== n && "allocUnsafeSlow" !== n && (a[n] = s[n]);
                        if (o.Buffer.prototype = s.prototype, a.from && a.from !== Uint8Array.from || (a.from = function(e, t, r) {
                            if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof e);
                            if (e && void 0 === e.length) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                            return s(e, t, r);
                        }), a.alloc || (a.alloc = function(e, t, r) {
                            if ("number" != typeof e) throw new TypeError('The "size" argument must be of type number. Received type ' + typeof e);
                            if (e < 0 || e >= 2 * 1073741824) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                            var n = s(e);
                            return t && 0 !== t.length ? "string" == typeof r ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
                        }), !o.kStringMaxLength) try {
                            o.kStringMaxLength = r.binding("buffer").kStringMaxLength;
                        } catch (e) {}
                        o.constants || (o.constants = {
                            MAX_LENGTH: o.kMaxLength
                        }, o.kStringMaxLength && (o.constants.MAX_STRING_LENGTH = o.kStringMaxLength)), t.exports = o;
                    }).call(this);
                }).call(this, e("_process"));
            },
            {
                _process: 467,
                buffer: 220
            }
        ],
        496: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                });
                const n = e("xmlchars/xml/1.0/ed5"), i = e("xmlchars/xml/1.1/ed2"), s = e("xmlchars/xmlns/1.0/ed3");
                var o = n.isS, a = n.isChar, l = n.isNameStartChar, c = n.isNameChar, u = n.S_LIST, h = n.NAME_RE, f = i.isChar, d = s.isNCNameStartChar, p = s.isNCNameChar, m = s.NC_NAME_RE;
                const b = "http://www.w3.org/XML/1998/namespace", g = "http://www.w3.org/2000/xmlns/", y = {
                    __proto__: null,
                    xml: b,
                    xmlns: g
                }, v = {
                    __proto__: null,
                    amp: "&",
                    gt: ">",
                    lt: "<",
                    quot: '"',
                    apos: "'"
                }, w = (e)=>34 === e || 39 === e, _ = [
                    34,
                    39
                ], x = [
                    ..._,
                    91,
                    62
                ], k = [
                    ..._,
                    60,
                    93
                ], S = [
                    61,
                    63,
                    ...u
                ], M = [
                    ...u,
                    62,
                    38,
                    60
                ];
                function C(e, t, r) {
                    switch(t){
                        case "xml":
                            r !== b && e.fail(`xml prefix must be bound to ${b}.`);
                            break;
                        case "xmlns":
                            r !== g && e.fail(`xmlns prefix must be bound to ${g}.`);
                    }
                    switch(r){
                        case g:
                            e.fail("" === t ? `the default namespace may not be set to ${r}.` : `may not assign a prefix (even "xmlns") to the URI ${g}.`);
                            break;
                        case b:
                            switch(t){
                                case "xml":
                                    break;
                                case "":
                                    e.fail(`the default namespace may not be set to ${r}.`);
                                    break;
                                default:
                                    e.fail("may not assign the xml namespace to another prefix.");
                            }
                    }
                }
                const T = (e)=>m.test(e), E = (e)=>h.test(e);
                r.EVENTS = [
                    "xmldecl",
                    "text",
                    "processinginstruction",
                    "doctype",
                    "comment",
                    "opentagstart",
                    "attribute",
                    "opentag",
                    "closetag",
                    "cdata",
                    "error",
                    "end",
                    "ready"
                ];
                const A = {
                    xmldecl: "xmldeclHandler",
                    text: "textHandler",
                    processinginstruction: "piHandler",
                    doctype: "doctypeHandler",
                    comment: "commentHandler",
                    opentagstart: "openTagStartHandler",
                    attribute: "attributeHandler",
                    opentag: "openTagHandler",
                    closetag: "closeTagHandler",
                    cdata: "cdataHandler",
                    error: "errorHandler",
                    end: "endHandler",
                    ready: "readyHandler"
                };
                r.SaxesParser = class {
                    constructor(e){
                        this.opt = null != e ? e : {}, this.fragmentOpt = !!this.opt.fragment;
                        const t = this.xmlnsOpt = !!this.opt.xmlns;
                        if (this.trackPosition = !1 !== this.opt.position, this.fileName = this.opt.fileName, t) {
                            this.nameStartCheck = d, this.nameCheck = p, this.isName = T, this.processAttribs = this.processAttribsNS, this.pushAttrib = this.pushAttribNS, this.ns = Object.assign({
                                __proto__: null
                            }, y);
                            const e = this.opt.additionalNamespaces;
                            null != e && (!function(e, t) {
                                for (const r of Object.keys(t))C(e, r, t[r]);
                            }(this, e), Object.assign(this.ns, e));
                        } else this.nameStartCheck = l, this.nameCheck = c, this.isName = E, this.processAttribs = this.processAttribsPlain, this.pushAttrib = this.pushAttribPlain;
                        this.stateTable = [
                            this.sBegin,
                            this.sBeginWhitespace,
                            this.sDoctype,
                            this.sDoctypeQuote,
                            this.sDTD,
                            this.sDTDQuoted,
                            this.sDTDOpenWaka,
                            this.sDTDOpenWakaBang,
                            this.sDTDComment,
                            this.sDTDCommentEnding,
                            this.sDTDCommentEnded,
                            this.sDTDPI,
                            this.sDTDPIEnding,
                            this.sText,
                            this.sEntity,
                            this.sOpenWaka,
                            this.sOpenWakaBang,
                            this.sComment,
                            this.sCommentEnding,
                            this.sCommentEnded,
                            this.sCData,
                            this.sCDataEnding,
                            this.sCDataEnding2,
                            this.sPIFirstChar,
                            this.sPIRest,
                            this.sPIBody,
                            this.sPIEnding,
                            this.sXMLDeclNameStart,
                            this.sXMLDeclName,
                            this.sXMLDeclEq,
                            this.sXMLDeclValueStart,
                            this.sXMLDeclValue,
                            this.sXMLDeclSeparator,
                            this.sXMLDeclEnding,
                            this.sOpenTag,
                            this.sOpenTagSlash,
                            this.sAttrib,
                            this.sAttribName,
                            this.sAttribNameSawWhite,
                            this.sAttribValue,
                            this.sAttribValueQuoted,
                            this.sAttribValueClosed,
                            this.sAttribValueUnquoted,
                            this.sCloseTag,
                            this.sCloseTagSawWhite
                        ], this._init();
                    }
                    get closed() {
                        return this._closed;
                    }
                    _init() {
                        var e;
                        this.openWakaBang = "", this.text = "", this.name = "", this.piTarget = "", this.entity = "", this.q = null, this.tags = [], this.tag = null, this.topNS = null, this.chunk = "", this.chunkPosition = 0, this.i = 0, this.prevI = 0, this.carriedFromPrevious = void 0, this.forbiddenState = 0, this.attribList = [];
                        const { fragmentOpt: t } = this;
                        this.state = t ? 13 : 0, this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = t, this.xmlDeclPossible = !t, this.xmlDeclExpects = [
                            "version"
                        ], this.entityReturnState = void 0;
                        let { defaultXMLVersion: r } = this.opt;
                        if (void 0 === r) {
                            if (!0 === this.opt.forceXMLVersion) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
                            r = "1.0";
                        }
                        this.setXMLVersion(r), this.positionAtNewLine = 0, this.doctype = !1, this._closed = !1, this.xmlDecl = {
                            version: void 0,
                            encoding: void 0,
                            standalone: void 0
                        }, this.line = 1, this.column = 0, this.ENTITIES = Object.create(v), null === (e = this.readyHandler) || void 0 === e || e.call(this);
                    }
                    get position() {
                        return this.chunkPosition + this.i;
                    }
                    get columnIndex() {
                        return this.position - this.positionAtNewLine;
                    }
                    on(e, t) {
                        this[A[e]] = t;
                    }
                    off(e) {
                        this[A[e]] = void 0;
                    }
                    makeError(e) {
                        var t;
                        let r = null !== (t = this.fileName) && void 0 !== t ? t : "";
                        return this.trackPosition && (r.length > 0 && (r += ":"), r += `${this.line}:${this.column}`), r.length > 0 && (r += ": "), new Error(r + e);
                    }
                    fail(e) {
                        const t = this.makeError(e), r = this.errorHandler;
                        if (void 0 === r) throw t;
                        return r(t), this;
                    }
                    write(e) {
                        if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
                        let t = !1;
                        null === e ? (t = !0, e = "") : "object" == typeof e && (e = e.toString()), void 0 !== this.carriedFromPrevious && (e = `${this.carriedFromPrevious}${e}`, this.carriedFromPrevious = void 0);
                        let r = e.length;
                        const n = e.charCodeAt(r - 1);
                        !t && (13 === n || n >= 55296 && n <= 56319) && (this.carriedFromPrevious = e[r - 1], r--, e = e.slice(0, r));
                        const { stateTable: i } = this;
                        for(this.chunk = e, this.i = 0; this.i < r;)i[this.state].call(this);
                        return this.chunkPosition += r, t ? this.end() : this;
                    }
                    close() {
                        return this.write(null);
                    }
                    getCode10() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r >= 32 || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    return 10 === e.charCodeAt(t + 1) && (this.i = t + 2), this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCode11() {
                        const { chunk: e, i: t } = this;
                        if (this.prevI = t, this.i = t + 1, t >= e.length) return -1;
                        const r = e.charCodeAt(t);
                        if (this.column++, r < 55296) {
                            if (r > 31 && r < 127 || r > 159 && 8232 !== r || 9 === r) return r;
                            switch(r){
                                case 10:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, 10;
                                case 13:
                                    {
                                        const r = e.charCodeAt(t + 1);
                                        10 !== r && 133 !== r || (this.i = t + 2);
                                    }
                                case 133:
                                case 8232:
                                    return this.line++, this.column = 0, this.positionAtNewLine = this.position, -2;
                                default:
                                    return this.fail("disallowed character."), r;
                            }
                        }
                        if (r > 56319) return r >= 57344 && r <= 65533 || this.fail("disallowed character."), r;
                        const n = 65536 + 1024 * (r - 55296) + (e.charCodeAt(t + 1) - 56320);
                        return this.i = t + 2, n > 1114111 && this.fail("disallowed character."), n;
                    }
                    getCodeNorm() {
                        const e = this.getCode();
                        return -2 === e ? 10 : e;
                    }
                    unget() {
                        this.i = this.prevI, this.column--;
                    }
                    captureTo(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            const n = this.getCode(), i = -2 === n, s = i ? 10 : n;
                            if (-1 === s || e.includes(s)) return this.text += r.slice(t, this.prevI), s;
                            i && (this.text += r.slice(t, this.prevI) + "\n", t = this.i);
                        }
                    }
                    captureToChar(e) {
                        let { i: t } = this;
                        const { chunk: r } = this;
                        for(;;){
                            let n = this.getCode();
                            switch(n){
                                case -2:
                                    this.text += r.slice(t, this.prevI) + "\n", t = this.i, n = 10;
                                    break;
                                case -1:
                                    return this.text += r.slice(t), !1;
                            }
                            if (n === e) return this.text += r.slice(t, this.prevI), !0;
                        }
                    }
                    captureNameChars() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCode();
                            if (-1 === r) return this.name += e.slice(t), -1;
                            if (!c(r)) return this.name += e.slice(t, this.prevI), -2 === r ? 10 : r;
                        }
                    }
                    skipSpaces() {
                        for(;;){
                            const e = this.getCodeNorm();
                            if (-1 === e || !o(e)) return e;
                        }
                    }
                    setXMLVersion(e) {
                        this.currentXMLVersion = e, "1.0" === e ? (this.isChar = a, this.getCode = this.getCode10) : (this.isChar = f, this.getCode = this.getCode11);
                    }
                    sBegin() {
                        65279 === this.chunk.charCodeAt(0) && (this.i++, this.column++), this.state = 1;
                    }
                    sBeginWhitespace() {
                        const e = this.i, t = this.skipSpaces();
                        switch(this.prevI !== e && (this.xmlDeclPossible = !1), t){
                            case 60:
                                if (this.state = 15, 0 !== this.text.length) throw new Error("no-empty text at start");
                                break;
                            case -1:
                                break;
                            default:
                                this.unget(), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sDoctype() {
                        var e;
                        const t = this.captureTo(x);
                        switch(t){
                            case 62:
                                null === (e = this.doctypeHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13, this.doctype = !0;
                                break;
                            case -1:
                                break;
                            default:
                                this.text += String.fromCodePoint(t), 91 === t ? this.state = 4 : w(t) && (this.state = 3, this.q = t);
                        }
                    }
                    sDoctypeQuote() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.q = null, this.state = 2);
                    }
                    sDTD() {
                        const e = this.captureTo(k);
                        -1 !== e && (this.text += String.fromCodePoint(e), 93 === e ? this.state = 2 : 60 === e ? this.state = 6 : w(e) && (this.state = 5, this.q = e));
                    }
                    sDTDQuoted() {
                        const e = this.q;
                        this.captureToChar(e) && (this.text += String.fromCodePoint(e), this.state = 4, this.q = null);
                    }
                    sDTDOpenWaka() {
                        const e = this.getCodeNorm();
                        switch(this.text += String.fromCodePoint(e), e){
                            case 33:
                                this.state = 7, this.openWakaBang = "";
                                break;
                            case 63:
                                this.state = 11;
                                break;
                            default:
                                this.state = 4;
                        }
                    }
                    sDTDOpenWakaBang() {
                        const e = String.fromCodePoint(this.getCodeNorm()), t = this.openWakaBang += e;
                        this.text += e, "-" !== t && (this.state = "--" === t ? 8 : 4, this.openWakaBang = "");
                    }
                    sDTDComment() {
                        this.captureToChar(45) && (this.text += "-", this.state = 9);
                    }
                    sDTDCommentEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), this.state = 45 === e ? 10 : 8;
                    }
                    sDTDCommentEnded() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e ? this.state = 4 : (this.fail("malformed comment."), this.state = 8);
                    }
                    sDTDPI() {
                        this.captureToChar(63) && (this.text += "?", this.state = 12);
                    }
                    sDTDPIEnding() {
                        const e = this.getCodeNorm();
                        this.text += String.fromCodePoint(e), 62 === e && (this.state = 4);
                    }
                    sText() {
                        0 !== this.tags.length ? this.handleTextInRoot() : this.handleTextOutsideRoot();
                    }
                    sEntity() {
                        let { i: e } = this;
                        const { chunk: t } = this;
                        e: for(;;)switch(this.getCode()){
                            case -2:
                                this.entity += t.slice(e, this.prevI) + "\n", e = this.i;
                                break;
                            case 59:
                                {
                                    const { entityReturnState: r } = this, n = this.entity + t.slice(e, this.prevI);
                                    let i;
                                    this.state = r, "" === n ? (this.fail("empty entity name."), i = "&;") : (i = this.parseEntity(n), this.entity = ""), 13 === r && void 0 === this.textHandler || (this.text += i);
                                    break e;
                                }
                            case -1:
                                this.entity += t.slice(e);
                                break e;
                        }
                    }
                    sOpenWaka() {
                        const e = this.getCode();
                        if (l(e)) this.state = 34, this.unget(), this.xmlDeclPossible = !1;
                        else switch(e){
                            case 47:
                                this.state = 43, this.xmlDeclPossible = !1;
                                break;
                            case 33:
                                this.state = 16, this.openWakaBang = "", this.xmlDeclPossible = !1;
                                break;
                            case 63:
                                this.state = 23;
                                break;
                            default:
                                this.fail("disallowed character in tag name"), this.state = 13, this.xmlDeclPossible = !1;
                        }
                    }
                    sOpenWakaBang() {
                        switch(this.openWakaBang += String.fromCodePoint(this.getCodeNorm()), this.openWakaBang){
                            case "[CDATA[":
                                this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0), this.state = 20, this.openWakaBang = "";
                                break;
                            case "--":
                                this.state = 17, this.openWakaBang = "";
                                break;
                            case "DOCTYPE":
                                this.state = 2, (this.doctype || this.sawRoot) && this.fail("inappropriately located doctype declaration."), this.openWakaBang = "";
                                break;
                            default:
                                this.openWakaBang.length >= 7 && this.fail("incorrect syntax.");
                        }
                    }
                    sComment() {
                        this.captureToChar(45) && (this.state = 18);
                    }
                    sCommentEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        45 === t ? (this.state = 19, null === (e = this.commentHandler) || void 0 === e || e.call(this, this.text), this.text = "") : (this.text += "-" + String.fromCodePoint(t), this.state = 17);
                    }
                    sCommentEnded() {
                        const e = this.getCodeNorm();
                        62 !== e ? (this.fail("malformed comment."), this.text += "--" + String.fromCodePoint(e), this.state = 17) : this.state = 13;
                    }
                    sCData() {
                        this.captureToChar(93) && (this.state = 21);
                    }
                    sCDataEnding() {
                        const e = this.getCodeNorm();
                        93 === e ? this.state = 22 : (this.text += "]" + String.fromCodePoint(e), this.state = 20);
                    }
                    sCDataEnding2() {
                        var e;
                        const t = this.getCodeNorm();
                        switch(t){
                            case 62:
                                null === (e = this.cdataHandler) || void 0 === e || e.call(this, this.text), this.text = "", this.state = 13;
                                break;
                            case 93:
                                this.text += "]";
                                break;
                            default:
                                this.text += "]]" + String.fromCodePoint(t), this.state = 20;
                        }
                    }
                    sPIFirstChar() {
                        const e = this.getCodeNorm();
                        this.nameStartCheck(e) ? (this.piTarget += String.fromCodePoint(e), this.state = 24) : 63 === e || o(e) ? (this.fail("processing instruction without a target."), this.state = 63 === e ? 26 : 25) : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(e), this.state = 24);
                    }
                    sPIRest() {
                        const { chunk: e, i: t } = this;
                        for(;;){
                            const r = this.getCodeNorm();
                            if (-1 === r) return void (this.piTarget += e.slice(t));
                            if (!this.nameCheck(r)) {
                                this.piTarget += e.slice(t, this.prevI);
                                const n = 63 === r;
                                n || o(r) ? "xml" === this.piTarget ? (this.xmlDeclPossible || this.fail("an XML declaration must be at the start of the document."), this.state = n ? 33 : 27) : this.state = n ? 26 : 25 : (this.fail("disallowed character in processing instruction name."), this.piTarget += String.fromCodePoint(r));
                                break;
                            }
                        }
                    }
                    sPIBody() {
                        if (0 === this.text.length) {
                            const e = this.getCodeNorm();
                            63 === e ? this.state = 26 : o(e) || (this.text = String.fromCodePoint(e));
                        } else this.captureToChar(63) && (this.state = 26);
                    }
                    sPIEnding() {
                        var e;
                        const t = this.getCodeNorm();
                        if (62 === t) {
                            const { piTarget: t } = this;
                            "xml" === t.toLowerCase() && this.fail("the XML declaration must appear at the start of the document."), null === (e = this.piHandler) || void 0 === e || e.call(this, {
                                target: t,
                                body: this.text
                            }), this.piTarget = this.text = "", this.state = 13;
                        } else 63 === t ? this.text += "?" : (this.text += "?" + String.fromCodePoint(t), this.state = 25);
                        this.xmlDeclPossible = !1;
                    }
                    sXMLDeclNameStart() {
                        const e = this.skipSpaces();
                        63 !== e ? -1 !== e && (this.state = 28, this.name = String.fromCodePoint(e)) : this.state = 33;
                    }
                    sXMLDeclName() {
                        const e = this.captureTo(S);
                        if (63 === e) return this.state = 33, this.name += this.text, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (o(e) || 61 === e) {
                            if (this.name += this.text, this.text = "", !this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
                                case 0:
                                    this.fail("did not expect any more name/value pairs.");
                                    break;
                                case 1:
                                    this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
                                    break;
                                default:
                                    this.fail("expected one of " + this.xmlDeclExpects.join(", "));
                            }
                            this.state = 61 === e ? 30 : 29;
                        }
                    }
                    sXMLDeclEq() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (61 !== e && this.fail("value required."), this.state = 30);
                    }
                    sXMLDeclValueStart() {
                        const e = this.getCodeNorm();
                        if (63 === e) return this.state = 33, void this.fail("XML declaration is incomplete.");
                        o(e) || (w(e) ? this.q = e : (this.fail("value must be quoted."), this.q = 32), this.state = 31);
                    }
                    sXMLDeclValue() {
                        const e = this.captureTo([
                            this.q,
                            63
                        ]);
                        if (63 === e) return this.state = 33, this.text = "", void this.fail("XML declaration is incomplete.");
                        if (-1 === e) return;
                        const t = this.text;
                        switch(this.text = "", this.name){
                            case "version":
                                {
                                    this.xmlDeclExpects = [
                                        "encoding",
                                        "standalone"
                                    ];
                                    const e = t;
                                    this.xmlDecl.version = e, /^1\.[0-9]+$/.test(e) ? this.opt.forceXMLVersion || this.setXMLVersion(e) : this.fail("version number must match /^1\\.[0-9]+$/.");
                                    break;
                                }
                            case "encoding":
                                /^[A-Za-z][A-Za-z0-9._-]*$/.test(t) || this.fail("encoding value must match /^[A-Za-z0-9][A-Za-z0-9._-]*$/."), this.xmlDeclExpects = [
                                    "standalone"
                                ], this.xmlDecl.encoding = t;
                                break;
                            case "standalone":
                                "yes" !== t && "no" !== t && this.fail('standalone value must match "yes" or "no".'), this.xmlDeclExpects = [], this.xmlDecl.standalone = t;
                        }
                        this.name = "", this.state = 32;
                    }
                    sXMLDeclSeparator() {
                        const e = this.getCodeNorm();
                        63 !== e ? (o(e) || (this.fail("whitespace required."), this.unget()), this.state = 27) : this.state = 33;
                    }
                    sXMLDeclEnding() {
                        var e;
                        62 === this.getCodeNorm() ? ("xml" !== this.piTarget ? this.fail("processing instructions are not allowed before root.") : "version" !== this.name && this.xmlDeclExpects.includes("version") && this.fail("XML declaration must contain a version."), null === (e = this.xmldeclHandler) || void 0 === e || e.call(this, this.xmlDecl), this.name = "", this.piTarget = this.text = "", this.state = 13) : this.fail("The character ? is disallowed anywhere in XML declarations."), this.xmlDeclPossible = !1;
                    }
                    sOpenTag() {
                        var e;
                        const t = this.captureNameChars();
                        if (-1 === t) return;
                        const r = this.tag = {
                            name: this.name,
                            attributes: Object.create(null)
                        };
                        switch(this.name = "", this.xmlnsOpt && (this.topNS = r.ns = Object.create(null)), null === (e = this.openTagStartHandler) || void 0 === e || e.call(this, r), this.sawRoot = !0, !this.fragmentOpt && this.closedRoot && this.fail("documents may contain only one root."), t){
                            case 62:
                                this.openTag();
                                break;
                            case 47:
                                this.state = 35;
                                break;
                            default:
                                o(t) || this.fail("disallowed character in tag name."), this.state = 36;
                        }
                    }
                    sOpenTagSlash() {
                        62 === this.getCode() ? this.openSelfClosingTag() : (this.fail("forward-slash in opening tag not followed by >."), this.state = 36);
                    }
                    sAttrib() {
                        const e = this.skipSpaces();
                        -1 !== e && (l(e) ? (this.unget(), this.state = 37) : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : this.fail("disallowed character in attribute name."));
                    }
                    sAttribName() {
                        const e = this.captureNameChars();
                        61 === e ? this.state = 39 : o(e) ? this.state = 38 : 62 === e ? (this.fail("attribute without value."), this.pushAttrib(this.name, this.name), this.name = this.text = "", this.openTag()) : -1 !== e && this.fail("disallowed character in attribute name.");
                    }
                    sAttribNameSawWhite() {
                        const e = this.skipSpaces();
                        switch(e){
                            case -1:
                                return;
                            case 61:
                                this.state = 39;
                                break;
                            default:
                                this.fail("attribute without value."), this.text = "", this.name = "", 62 === e ? this.openTag() : l(e) ? (this.unget(), this.state = 37) : (this.fail("disallowed character in attribute name."), this.state = 36);
                        }
                    }
                    sAttribValue() {
                        const e = this.getCodeNorm();
                        w(e) ? (this.q = e, this.state = 40) : o(e) || (this.fail("unquoted attribute value."), this.state = 42, this.unget());
                    }
                    sAttribValueQuoted() {
                        const { q: e, chunk: t } = this;
                        let { i: r } = this;
                        for(;;)switch(this.getCode()){
                            case e:
                                return this.pushAttrib(this.name, this.text + t.slice(r, this.prevI)), this.name = this.text = "", this.q = null, void (this.state = 41);
                            case 38:
                                return this.text += t.slice(r, this.prevI), this.state = 14, void (this.entityReturnState = 40);
                            case 10:
                            case -2:
                            case 9:
                                this.text += t.slice(r, this.prevI) + " ", r = this.i;
                                break;
                            case 60:
                                return this.text += t.slice(r, this.prevI), void this.fail("disallowed character.");
                            case -1:
                                return void (this.text += t.slice(r));
                        }
                    }
                    sAttribValueClosed() {
                        const e = this.getCodeNorm();
                        o(e) ? this.state = 36 : 62 === e ? this.openTag() : 47 === e ? this.state = 35 : l(e) ? (this.fail("no whitespace between attributes."), this.unget(), this.state = 37) : this.fail("disallowed character in attribute name.");
                    }
                    sAttribValueUnquoted() {
                        const e = this.captureTo(M);
                        switch(e){
                            case 38:
                                this.state = 14, this.entityReturnState = 42;
                                break;
                            case 60:
                                this.fail("disallowed character.");
                                break;
                            case -1:
                                break;
                            default:
                                this.text.includes("]]>") && this.fail('the string "]]>" is disallowed in char data.'), this.pushAttrib(this.name, this.text), this.name = this.text = "", 62 === e ? this.openTag() : this.state = 36;
                        }
                    }
                    sCloseTag() {
                        const e = this.captureNameChars();
                        62 === e ? this.closeTag() : o(e) ? this.state = 44 : -1 !== e && this.fail("disallowed character in closing tag.");
                    }
                    sCloseTagSawWhite() {
                        switch(this.skipSpaces()){
                            case 62:
                                this.closeTag();
                                break;
                            case -1:
                                break;
                            default:
                                this.fail("disallowed character in closing tag.");
                        }
                    }
                    handleTextInRoot() {
                        let { i: e, forbiddenState: t } = this;
                        const { chunk: r, textHandler: n } = this;
                        e: for(;;)switch(this.getCode()){
                            case 60:
                                if (this.state = 15, void 0 !== n) {
                                    const { text: t } = this, i = r.slice(e, this.prevI);
                                    0 !== t.length ? (n(t + i), this.text = "") : 0 !== i.length && n(i);
                                }
                                t = 0;
                                break e;
                            case 38:
                                this.state = 14, this.entityReturnState = 13, void 0 !== n && (this.text += r.slice(e, this.prevI)), t = 0;
                                break e;
                            case 93:
                                switch(t){
                                    case 0:
                                        t = 1;
                                        break;
                                    case 1:
                                        t = 2;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new Error("impossible state");
                                }
                                break;
                            case 62:
                                2 === t && this.fail('the string "]]>" is disallowed in char data.'), t = 0;
                                break;
                            case -2:
                                void 0 !== n && (this.text += r.slice(e, this.prevI) + "\n"), e = this.i, t = 0;
                                break;
                            case -1:
                                void 0 !== n && (this.text += r.slice(e));
                                break e;
                            default:
                                t = 0;
                        }
                        this.forbiddenState = t;
                    }
                    handleTextOutsideRoot() {
                        let { i: e } = this;
                        const { chunk: t, textHandler: r } = this;
                        let n = !1;
                        e: for(;;){
                            const i = this.getCode();
                            switch(i){
                                case 60:
                                    if (this.state = 15, void 0 !== r) {
                                        const { text: n } = this, i = t.slice(e, this.prevI);
                                        0 !== n.length ? (r(n + i), this.text = "") : 0 !== i.length && r(i);
                                    }
                                    break e;
                                case 38:
                                    this.state = 14, this.entityReturnState = 13, void 0 !== r && (this.text += t.slice(e, this.prevI)), n = !0;
                                    break e;
                                case -2:
                                    void 0 !== r && (this.text += t.slice(e, this.prevI) + "\n"), e = this.i;
                                    break;
                                case -1:
                                    void 0 !== r && (this.text += t.slice(e));
                                    break e;
                                default:
                                    o(i) || (n = !0);
                            }
                        }
                        n && (this.sawRoot || this.reportedTextBeforeRoot || (this.fail("text data outside of root node."), this.reportedTextBeforeRoot = !0), this.closedRoot && !this.reportedTextAfterRoot && (this.fail("text data outside of root node."), this.reportedTextAfterRoot = !0));
                    }
                    pushAttribNS(e, t) {
                        var r;
                        const { prefix: n, local: i } = this.qname(e), s = {
                            name: e,
                            prefix: n,
                            local: i,
                            value: t
                        };
                        if (this.attribList.push(s), null === (r = this.attributeHandler) || void 0 === r || r.call(this, s), "xmlns" === n) {
                            const e = t.trim();
                            "1.0" === this.currentXMLVersion && "" === e && this.fail("invalid attempt to undefine prefix in XML 1.0"), this.topNS[i] = e, C(this, i, e);
                        } else if ("xmlns" === e) {
                            const e = t.trim();
                            this.topNS[""] = e, C(this, "", e);
                        }
                    }
                    pushAttribPlain(e, t) {
                        var r;
                        const n = {
                            name: e,
                            value: t
                        };
                        this.attribList.push(n), null === (r = this.attributeHandler) || void 0 === r || r.call(this, n);
                    }
                    end() {
                        var e, t;
                        this.sawRoot || this.fail("document must contain a root element.");
                        const { tags: r } = this;
                        for(; r.length > 0;){
                            const e = r.pop();
                            this.fail("unclosed tag: " + e.name);
                        }
                        0 !== this.state && 13 !== this.state && this.fail("unexpected end.");
                        const { text: n } = this;
                        return 0 !== n.length && (null === (e = this.textHandler) || void 0 === e || e.call(this, n), this.text = ""), this._closed = !0, null === (t = this.endHandler) || void 0 === t || t.call(this), this._init(), this;
                    }
                    resolve(e) {
                        var t, r;
                        let n = this.topNS[e];
                        if (void 0 !== n) return n;
                        const { tags: i } = this;
                        for(let t = i.length - 1; t >= 0; t--)if (n = i[t].ns[e], void 0 !== n) return n;
                        return n = this.ns[e], void 0 !== n ? n : null === (r = (t = this.opt).resolvePrefix) || void 0 === r ? void 0 : r.call(t, e);
                    }
                    qname(e) {
                        const t = e.indexOf(":");
                        if (-1 === t) return {
                            prefix: "",
                            local: e
                        };
                        const r = e.slice(t + 1), n = e.slice(0, t);
                        return ("" === n || "" === r || r.includes(":")) && this.fail(`malformed name: ${e}.`), {
                            prefix: n,
                            local: r
                        };
                    }
                    processAttribsNS() {
                        var e;
                        const { attribList: t } = this, r = this.tag;
                        {
                            const { prefix: t, local: n } = this.qname(r.name);
                            r.prefix = t, r.local = n;
                            const i = r.uri = null !== (e = this.resolve(t)) && void 0 !== e ? e : "";
                            "" !== t && ("xmlns" === t && this.fail('tags may not have "xmlns" as prefix.'), "" === i && (this.fail(`unbound namespace prefix: ${JSON.stringify(t)}.`), r.uri = t));
                        }
                        if (0 === t.length) return;
                        const { attributes: n } = r, i = new Set;
                        for (const e of t){
                            const { name: t, prefix: r, local: s } = e;
                            let o, a;
                            "" === r ? (o = "xmlns" === t ? g : "", a = t) : (o = this.resolve(r), void 0 === o && (this.fail(`unbound namespace prefix: ${JSON.stringify(r)}.`), o = r), a = `{${o}}${s}`), i.has(a) && this.fail(`duplicate attribute: ${a}.`), i.add(a), e.uri = o, n[t] = e;
                        }
                        this.attribList = [];
                    }
                    processAttribsPlain() {
                        const { attribList: e } = this, t = this.tag.attributes;
                        for (const { name: r, value: n } of e)void 0 !== t[r] && this.fail(`duplicate attribute: ${r}.`), t[r] = n;
                        this.attribList = [];
                    }
                    openTag() {
                        var e;
                        this.processAttribs();
                        const { tags: t } = this, r = this.tag;
                        r.isSelfClosing = !1, null === (e = this.openTagHandler) || void 0 === e || e.call(this, r), t.push(r), this.state = 13, this.name = "";
                    }
                    openSelfClosingTag() {
                        var e, t, r;
                        this.processAttribs();
                        const { tags: n } = this, i = this.tag;
                        i.isSelfClosing = !0, null === (e = this.openTagHandler) || void 0 === e || e.call(this, i), null === (t = this.closeTagHandler) || void 0 === t || t.call(this, i);
                        null === (this.tag = null !== (r = n[n.length - 1]) && void 0 !== r ? r : null) && (this.closedRoot = !0), this.state = 13, this.name = "";
                    }
                    closeTag() {
                        const { tags: e, name: t } = this;
                        if (this.state = 13, this.name = "", "" === t) return this.fail("weird empty close tag."), void (this.text += "</>");
                        const r = this.closeTagHandler;
                        let n = e.length;
                        for(; n-- > 0;){
                            const n = this.tag = e.pop();
                            if (this.topNS = n.ns, null == r || r(n), n.name === t) break;
                            this.fail("unexpected close tag.");
                        }
                        0 === n ? this.closedRoot = !0 : n < 0 && (this.fail(`unmatched closing tag: ${t}.`), this.text += `</${t}>`);
                    }
                    parseEntity(e) {
                        if ("#" !== e[0]) {
                            const t = this.ENTITIES[e];
                            return void 0 !== t ? t : (this.fail(this.isName(e) ? "undefined entity." : "disallowed character in entity name."), `&${e};`);
                        }
                        let t = NaN;
                        return "x" === e[1] && /^#x[0-9a-f]+$/i.test(e) ? t = parseInt(e.slice(2), 16) : /^#[0-9]+$/.test(e) && (t = parseInt(e.slice(1), 10)), this.isChar(t) ? String.fromCodePoint(t) : (this.fail("malformed character entity."), `&${e};`);
                    }
                };
            },
            {
                "xmlchars/xml/1.0/ed5": 543,
                "xmlchars/xml/1.1/ed2": 544,
                "xmlchars/xmlns/1.0/ed3": 545
            }
        ],
        497: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer;
                function i(e, t) {
                    this._block = n.alloc(e), this._finalSize = t, this._blockSize = e, this._len = 0;
                }
                i.prototype.update = function(e, t) {
                    "string" == typeof e && (t = t || "utf8", e = n.from(e, t));
                    for(var r = this._block, i = this._blockSize, s = e.length, o = this._len, a = 0; a < s;){
                        for(var l = o % i, c = Math.min(s - a, i - l), u = 0; u < c; u++)r[l + u] = e[a + u];
                        a += c, (o += c) % i == 0 && this._update(r);
                    }
                    return this._len += s, this;
                }, i.prototype.digest = function(e) {
                    var t = this._len % this._blockSize;
                    this._block[t] = 128, this._block.fill(0, t + 1), t >= this._finalSize && (this._update(this._block), this._block.fill(0));
                    var r = 8 * this._len;
                    if (r <= 4294967295) this._block.writeUInt32BE(r, this._blockSize - 4);
                    else {
                        var n = (4294967295 & r) >>> 0, i = (r - n) / 4294967296;
                        this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
                    }
                    this._update(this._block);
                    var s = this._hash();
                    return e ? s.toString(e) : s;
                }, i.prototype._update = function() {
                    throw new Error("_update must be implemented by subclass");
                }, t.exports = i;
            },
            {
                "safe-buffer": 494
            }
        ],
        498: [
            function(e, t, r) {
                "use strict";
                var n = t.exports = function(e) {
                    e = e.toLowerCase();
                    var t = n[e];
                    if (!t) throw new Error(e + " is not supported (we accept pull requests)");
                    return new t;
                };
                n.sha = e("./sha"), n.sha1 = e("./sha1"), n.sha224 = e("./sha224"), n.sha256 = e("./sha256"), n.sha384 = e("./sha384"), n.sha512 = e("./sha512");
            },
            {
                "./sha": 499,
                "./sha1": 500,
                "./sha224": 501,
                "./sha256": 502,
                "./sha384": 503,
                "./sha512": 504
            }
        ],
        499: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 30 | e >>> 2;
                }
                function u(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, h = 0; h < 16; ++h)r[h] = e.readInt32BE(4 * h);
                    for(; h < 80; ++h)r[h] = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16];
                    for(var f = 0; f < 80; ++f){
                        var d = ~~(f / 20), p = 0 | ((t = n) << 5 | t >>> 27) + u(d, i, s, a) + l + r[f] + o[d];
                        l = a, a = s, s = c(i), i = n, n = p;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        500: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1518500249,
                    1859775393,
                    -1894007588,
                    -899497514
                ], a = new Array(80);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e) {
                    return e << 5 | e >>> 27;
                }
                function u(e) {
                    return e << 30 | e >>> 2;
                }
                function h(e, t, r, n) {
                    return 0 === e ? t & r | ~t & n : 2 === e ? t & r | t & n | r & n : t ^ r ^ n;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, f = 0; f < 16; ++f)r[f] = e.readInt32BE(4 * f);
                    for(; f < 80; ++f)r[f] = (t = r[f - 3] ^ r[f - 8] ^ r[f - 14] ^ r[f - 16]) << 1 | t >>> 31;
                    for(var d = 0; d < 80; ++d){
                        var p = ~~(d / 20), m = c(n) + h(p, i, s, a) + l + r[d] + o[p] | 0;
                        l = a, a = s, s = u(i), i = n, n = m;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(20);
                    return e.writeInt32BE(0 | this._a, 0), e.writeInt32BE(0 | this._b, 4), e.writeInt32BE(0 | this._c, 8), e.writeInt32BE(0 | this._d, 12), e.writeInt32BE(0 | this._e, 16), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        501: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha256"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(64);
                function l() {
                    this.init(), this._w = a, s.call(this, 64, 56);
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(28);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha256": 502,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        502: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    1899447441,
                    3049323471,
                    3921009573,
                    961987163,
                    1508970993,
                    2453635748,
                    2870763221,
                    3624381080,
                    310598401,
                    607225278,
                    1426881987,
                    1925078388,
                    2162078206,
                    2614888103,
                    3248222580,
                    3835390401,
                    4022224774,
                    264347078,
                    604807628,
                    770255983,
                    1249150122,
                    1555081692,
                    1996064986,
                    2554220882,
                    2821834349,
                    2952996808,
                    3210313671,
                    3336571891,
                    3584528711,
                    113926993,
                    338241895,
                    666307205,
                    773529912,
                    1294757372,
                    1396182291,
                    1695183700,
                    1986661051,
                    2177026350,
                    2456956037,
                    2730485921,
                    2820302411,
                    3259730800,
                    3345764771,
                    3516065817,
                    3600352804,
                    4094571909,
                    275423344,
                    430227734,
                    506948616,
                    659060556,
                    883997877,
                    958139571,
                    1322822218,
                    1537002063,
                    1747873779,
                    1955562222,
                    2024104815,
                    2227730452,
                    2361852424,
                    2428436474,
                    2756734187,
                    3204031479,
                    3329325298
                ], a = new Array(64);
                function l() {
                    this.init(), this._w = a, i.call(this, 64, 56);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e) {
                    return (e >>> 2 | e << 30) ^ (e >>> 13 | e << 19) ^ (e >>> 22 | e << 10);
                }
                function f(e) {
                    return (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                }
                function d(e) {
                    return (e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3;
                }
                n(l, i), l.prototype.init = function() {
                    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
                }, l.prototype._update = function(e) {
                    for(var t, r = this._w, n = 0 | this._a, i = 0 | this._b, s = 0 | this._c, a = 0 | this._d, l = 0 | this._e, p = 0 | this._f, m = 0 | this._g, b = 0 | this._h, g = 0; g < 16; ++g)r[g] = e.readInt32BE(4 * g);
                    for(; g < 64; ++g)r[g] = 0 | (((t = r[g - 2]) >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10) + r[g - 7] + d(r[g - 15]) + r[g - 16];
                    for(var y = 0; y < 64; ++y){
                        var v = b + f(l) + c(l, p, m) + o[y] + r[y] | 0, w = h(n) + u(n, i, s) | 0;
                        b = m, m = p, p = l, l = a + v | 0, a = s, s = i, i = n, n = v + w | 0;
                    }
                    this._a = n + this._a | 0, this._b = i + this._b | 0, this._c = s + this._c | 0, this._d = a + this._d | 0, this._e = l + this._e | 0, this._f = p + this._f | 0, this._g = m + this._g | 0, this._h = b + this._h | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(32);
                    return e.writeInt32BE(this._a, 0), e.writeInt32BE(this._b, 4), e.writeInt32BE(this._c, 8), e.writeInt32BE(this._d, 12), e.writeInt32BE(this._e, 16), e.writeInt32BE(this._f, 20), e.writeInt32BE(this._g, 24), e.writeInt32BE(this._h, 28), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        503: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./sha512"), s = e("./hash"), o = e("safe-buffer").Buffer, a = new Array(160);
                function l() {
                    this.init(), this._w = a, s.call(this, 128, 112);
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
                }, l.prototype._hash = function() {
                    var e = o.allocUnsafe(48);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                "./sha512": 504,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        504: [
            function(e, t, r) {
                "use strict";
                var n = e("inherits"), i = e("./hash"), s = e("safe-buffer").Buffer, o = [
                    1116352408,
                    3609767458,
                    1899447441,
                    602891725,
                    3049323471,
                    3964484399,
                    3921009573,
                    2173295548,
                    961987163,
                    4081628472,
                    1508970993,
                    3053834265,
                    2453635748,
                    2937671579,
                    2870763221,
                    3664609560,
                    3624381080,
                    2734883394,
                    310598401,
                    1164996542,
                    607225278,
                    1323610764,
                    1426881987,
                    3590304994,
                    1925078388,
                    4068182383,
                    2162078206,
                    991336113,
                    2614888103,
                    633803317,
                    3248222580,
                    3479774868,
                    3835390401,
                    2666613458,
                    4022224774,
                    944711139,
                    264347078,
                    2341262773,
                    604807628,
                    2007800933,
                    770255983,
                    1495990901,
                    1249150122,
                    1856431235,
                    1555081692,
                    3175218132,
                    1996064986,
                    2198950837,
                    2554220882,
                    3999719339,
                    2821834349,
                    766784016,
                    2952996808,
                    2566594879,
                    3210313671,
                    3203337956,
                    3336571891,
                    1034457026,
                    3584528711,
                    2466948901,
                    113926993,
                    3758326383,
                    338241895,
                    168717936,
                    666307205,
                    1188179964,
                    773529912,
                    1546045734,
                    1294757372,
                    1522805485,
                    1396182291,
                    2643833823,
                    1695183700,
                    2343527390,
                    1986661051,
                    1014477480,
                    2177026350,
                    1206759142,
                    2456956037,
                    344077627,
                    2730485921,
                    1290863460,
                    2820302411,
                    3158454273,
                    3259730800,
                    3505952657,
                    3345764771,
                    106217008,
                    3516065817,
                    3606008344,
                    3600352804,
                    1432725776,
                    4094571909,
                    1467031594,
                    275423344,
                    851169720,
                    430227734,
                    3100823752,
                    506948616,
                    1363258195,
                    659060556,
                    3750685593,
                    883997877,
                    3785050280,
                    958139571,
                    3318307427,
                    1322822218,
                    3812723403,
                    1537002063,
                    2003034995,
                    1747873779,
                    3602036899,
                    1955562222,
                    1575990012,
                    2024104815,
                    1125592928,
                    2227730452,
                    2716904306,
                    2361852424,
                    442776044,
                    2428436474,
                    593698344,
                    2756734187,
                    3733110249,
                    3204031479,
                    2999351573,
                    3329325298,
                    3815920427,
                    3391569614,
                    3928383900,
                    3515267271,
                    566280711,
                    3940187606,
                    3454069534,
                    4118630271,
                    4000239992,
                    116418474,
                    1914138554,
                    174292421,
                    2731055270,
                    289380356,
                    3203993006,
                    460393269,
                    320620315,
                    685471733,
                    587496836,
                    852142971,
                    1086792851,
                    1017036298,
                    365543100,
                    1126000580,
                    2618297676,
                    1288033470,
                    3409855158,
                    1501505948,
                    4234509866,
                    1607167915,
                    987167468,
                    1816402316,
                    1246189591
                ], a = new Array(160);
                function l() {
                    this.init(), this._w = a, i.call(this, 128, 112);
                }
                function c(e, t, r) {
                    return r ^ e & (t ^ r);
                }
                function u(e, t, r) {
                    return e & t | r & (e | t);
                }
                function h(e, t) {
                    return (e >>> 28 | t << 4) ^ (t >>> 2 | e << 30) ^ (t >>> 7 | e << 25);
                }
                function f(e, t) {
                    return (e >>> 14 | t << 18) ^ (e >>> 18 | t << 14) ^ (t >>> 9 | e << 23);
                }
                function d(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ e >>> 7;
                }
                function p(e, t) {
                    return (e >>> 1 | t << 31) ^ (e >>> 8 | t << 24) ^ (e >>> 7 | t << 25);
                }
                function m(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ e >>> 6;
                }
                function b(e, t) {
                    return (e >>> 19 | t << 13) ^ (t >>> 29 | e << 3) ^ (e >>> 6 | t << 26);
                }
                function g(e, t) {
                    return e >>> 0 < t >>> 0 ? 1 : 0;
                }
                n(l, i), l.prototype.init = function() {
                    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
                }, l.prototype._update = function(e) {
                    for(var t = this._w, r = 0 | this._ah, n = 0 | this._bh, i = 0 | this._ch, s = 0 | this._dh, a = 0 | this._eh, l = 0 | this._fh, y = 0 | this._gh, v = 0 | this._hh, w = 0 | this._al, _ = 0 | this._bl, x = 0 | this._cl, k = 0 | this._dl, S = 0 | this._el, M = 0 | this._fl, C = 0 | this._gl, T = 0 | this._hl, E = 0; E < 32; E += 2)t[E] = e.readInt32BE(4 * E), t[E + 1] = e.readInt32BE(4 * E + 4);
                    for(; E < 160; E += 2){
                        var A = t[E - 30], R = t[E - 30 + 1], O = d(A, R), j = p(R, A), I = m(A = t[E - 4], R = t[E - 4 + 1]), N = b(R, A), P = t[E - 14], B = t[E - 14 + 1], D = t[E - 32], F = t[E - 32 + 1], L = j + B | 0, z = O + P + g(L, j) | 0;
                        z = (z = z + I + g(L = L + N | 0, N) | 0) + D + g(L = L + F | 0, F) | 0, t[E] = z, t[E + 1] = L;
                    }
                    for(var U = 0; U < 160; U += 2){
                        z = t[U], L = t[U + 1];
                        var $ = u(r, n, i), H = u(w, _, x), V = h(r, w), q = h(w, r), W = f(a, S), X = f(S, a), K = o[U], Y = o[U + 1], Z = c(a, l, y), G = c(S, M, C), J = T + X | 0, Q = v + W + g(J, T) | 0;
                        Q = (Q = (Q = Q + Z + g(J = J + G | 0, G) | 0) + K + g(J = J + Y | 0, Y) | 0) + z + g(J = J + L | 0, L) | 0;
                        var ee = q + H | 0, te = V + $ + g(ee, q) | 0;
                        v = y, T = C, y = l, C = M, l = a, M = S, a = s + Q + g(S = k + J | 0, k) | 0, s = i, k = x, i = n, x = _, n = r, _ = w, r = Q + te + g(w = J + ee | 0, J) | 0;
                    }
                    this._al = this._al + w | 0, this._bl = this._bl + _ | 0, this._cl = this._cl + x | 0, this._dl = this._dl + k | 0, this._el = this._el + S | 0, this._fl = this._fl + M | 0, this._gl = this._gl + C | 0, this._hl = this._hl + T | 0, this._ah = this._ah + r + g(this._al, w) | 0, this._bh = this._bh + n + g(this._bl, _) | 0, this._ch = this._ch + i + g(this._cl, x) | 0, this._dh = this._dh + s + g(this._dl, k) | 0, this._eh = this._eh + a + g(this._el, S) | 0, this._fh = this._fh + l + g(this._fl, M) | 0, this._gh = this._gh + y + g(this._gl, C) | 0, this._hh = this._hh + v + g(this._hl, T) | 0;
                }, l.prototype._hash = function() {
                    var e = s.allocUnsafe(64);
                    function t(t, r, n) {
                        e.writeInt32BE(t, n), e.writeInt32BE(r, n + 4);
                    }
                    return t(this._ah, this._al, 0), t(this._bh, this._bl, 8), t(this._ch, this._cl, 16), t(this._dh, this._dl, 24), t(this._eh, this._el, 32), t(this._fh, this._fl, 40), t(this._gh, this._gl, 48), t(this._hh, this._hl, 56), e;
                }, t.exports = l;
            },
            {
                "./hash": 497,
                inherits: 440,
                "safe-buffer": 494
            }
        ],
        505: [
            function(e, t, r) {
                "use strict";
                t.exports = i;
                var n = e("events").EventEmitter;
                function i() {
                    n.call(this);
                }
                e("inherits")(i, n), i.Readable = e("readable-stream/readable.js"), i.Writable = e("readable-stream/writable.js"), i.Duplex = e("readable-stream/duplex.js"), i.Transform = e("readable-stream/transform.js"), i.PassThrough = e("readable-stream/passthrough.js"), i.Stream = i, i.prototype.pipe = function(e, t) {
                    var r = this;
                    function i(t) {
                        e.writable && !1 === e.write(t) && r.pause && r.pause();
                    }
                    function s() {
                        r.readable && r.resume && r.resume();
                    }
                    r.on("data", i), e.on("drain", s), e._isStdio || t && !1 === t.end || (r.on("end", a), r.on("close", l));
                    var o = !1;
                    function a() {
                        o || (o = !0, e.end());
                    }
                    function l() {
                        o || (o = !0, "function" == typeof e.destroy && e.destroy());
                    }
                    function c(e) {
                        if (u(), 0 === n.listenerCount(this, "error")) throw e;
                    }
                    function u() {
                        r.removeListener("data", i), e.removeListener("drain", s), r.removeListener("end", a), r.removeListener("close", l), r.removeListener("error", c), e.removeListener("error", c), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
                    }
                    return r.on("error", c), e.on("error", c), r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
                };
            },
            {
                events: 422,
                inherits: 440,
                "readable-stream/duplex.js": 507,
                "readable-stream/passthrough.js": 516,
                "readable-stream/readable.js": 517,
                "readable-stream/transform.js": 518,
                "readable-stream/writable.js": 519
            }
        ],
        506: [
            function(e, t, r) {
                "use strict";
                var n = {}.toString;
                t.exports = Array.isArray || function(e) {
                    return "[object Array]" == n.call(e);
                };
            },
            {}
        ],
        507: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_duplex.js");
            },
            {
                "./lib/_stream_duplex.js": 508
            }
        ],
        508: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args"), i = Object.keys || function(e) {
                    var t = [];
                    for(var r in e)t.push(r);
                    return t;
                };
                t.exports = h;
                var s = Object.create(e("core-util-is"));
                s.inherits = e("inherits");
                var o = e("./_stream_readable"), a = e("./_stream_writable");
                s.inherits(h, o);
                for(var l = i(a.prototype), c = 0; c < l.length; c++){
                    var u = l[c];
                    h.prototype[u] || (h.prototype[u] = a.prototype[u]);
                }
                function h(e) {
                    if (!(this instanceof h)) return new h(e);
                    o.call(this, e), a.call(this, e), e && !1 === e.readable && (this.readable = !1), e && !1 === e.writable && (this.writable = !1), this.allowHalfOpen = !0, e && !1 === e.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", f);
                }
                function f() {
                    this.allowHalfOpen || this._writableState.ended || n.nextTick(d, this);
                }
                function d(e) {
                    e.end();
                }
                Object.defineProperty(h.prototype, "writableHighWaterMark", {
                    enumerable: !1,
                    get: function() {
                        return this._writableState.highWaterMark;
                    }
                }), Object.defineProperty(h.prototype, "destroyed", {
                    get: function() {
                        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
                    },
                    set: function(e) {
                        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = e, this._writableState.destroyed = e);
                    }
                }), h.prototype._destroy = function(e, t) {
                    this.push(null), this.end(), n.nextTick(t, e);
                };
            },
            {
                "./_stream_readable": 510,
                "./_stream_writable": 512,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466
            }
        ],
        509: [
            function(e, t, r) {
                "use strict";
                t.exports = s;
                var n = e("./_stream_transform"), i = Object.create(e("core-util-is"));
                function s(e) {
                    if (!(this instanceof s)) return new s(e);
                    n.call(this, e);
                }
                i.inherits = e("inherits"), i.inherits(s, n), s.prototype._transform = function(e, t, r) {
                    r(null, e);
                };
            },
            {
                "./_stream_transform": 511,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        510: [
            function(e, t, r) {
                (function(r, n) {
                    (function() {
                        "use strict";
                        var i = e("process-nextick-args");
                        t.exports = v;
                        var s, o = e("isarray");
                        v.ReadableState = y;
                        e("events").EventEmitter;
                        var a = function(e, t) {
                            return e.listeners(t).length;
                        }, l = e("./internal/streams/stream"), c = e("safe-buffer").Buffer, u = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var h = Object.create(e("core-util-is"));
                        h.inherits = e("inherits");
                        var f = e("util"), d = void 0;
                        d = f && f.debuglog ? f.debuglog("stream") : function() {};
                        var p, m = e("./internal/streams/BufferList"), b = e("./internal/streams/destroy");
                        h.inherits(v, l);
                        var g = [
                            "error",
                            "close",
                            "destroy",
                            "pause",
                            "resume"
                        ];
                        function y(t, r) {
                            t = t || {};
                            var n = r instanceof (s = s || e("./_stream_duplex"));
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
                            var i = t.highWaterMark, o = t.readableHighWaterMark, a = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (o || 0 === o) ? o : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (p || (p = e("string_decoder/").StringDecoder), this.decoder = new p(t.encoding), this.encoding = t.encoding);
                        }
                        function v(t) {
                            if (s = s || e("./_stream_duplex"), !(this instanceof v)) return new v(t);
                            this._readableState = new y(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), l.call(this);
                        }
                        function w(e, t, r, n, i) {
                            var s, o = e._readableState;
                            null === t ? (o.reading = !1, function(e, t) {
                                if (t.ended) return;
                                if (t.decoder) {
                                    var r = t.decoder.end();
                                    r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                                }
                                t.ended = !0, k(e);
                            }(e, o)) : (i || (s = function(e, t) {
                                var r;
                                n = t, c.isBuffer(n) || n instanceof u || "string" == typeof t || void 0 === t || e.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
                                var n;
                                return r;
                            }(o, t)), s ? e.emit("error", s) : o.objectMode || t && t.length > 0 ? ("string" == typeof t || o.objectMode || Object.getPrototypeOf(t) === c.prototype || (t = function(e) {
                                return c.from(e);
                            }(t)), n ? o.endEmitted ? e.emit("error", new Error("stream.unshift() after end event")) : _(e, o, t, !0) : o.ended ? e.emit("error", new Error("stream.push() after EOF")) : (o.reading = !1, o.decoder && !r ? (t = o.decoder.write(t), o.objectMode || 0 !== t.length ? _(e, o, t, !1) : M(e, o)) : _(e, o, t, !1))) : n || (o.reading = !1));
                            return function(e) {
                                return !e.ended && (e.needReadable || e.length < e.highWaterMark || 0 === e.length);
                            }(o);
                        }
                        function _(e, t, r, n) {
                            t.flowing && 0 === t.length && !t.sync ? (e.emit("data", r), e.read(0)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && k(e)), M(e, t);
                        }
                        Object.defineProperty(v.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._readableState && this._readableState.destroyed;
                            },
                            set: function(e) {
                                this._readableState && (this._readableState.destroyed = e);
                            }
                        }), v.prototype.destroy = b.destroy, v.prototype._undestroy = b.undestroy, v.prototype._destroy = function(e, t) {
                            this.push(null), t(e);
                        }, v.prototype.push = function(e, t) {
                            var r, n = this._readableState;
                            return n.objectMode ? r = !0 : "string" == typeof e && ((t = t || n.defaultEncoding) !== n.encoding && (e = c.from(e, t), t = ""), r = !0), w(this, e, t, !1, r);
                        }, v.prototype.unshift = function(e) {
                            return w(this, e, null, !0, !1);
                        }, v.prototype.isPaused = function() {
                            return !1 === this._readableState.flowing;
                        }, v.prototype.setEncoding = function(t) {
                            return p || (p = e("string_decoder/").StringDecoder), this._readableState.decoder = new p(t), this._readableState.encoding = t, this;
                        };
                        function x(e, t) {
                            return e <= 0 || 0 === t.length && t.ended ? 0 : t.objectMode ? 1 : e != e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = function(e) {
                                return e >= 8388608 ? e = 8388608 : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
                            }(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
                        }
                        function k(e) {
                            var t = e._readableState;
                            t.needReadable = !1, t.emittedReadable || (d("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? i.nextTick(S, e) : S(e));
                        }
                        function S(e) {
                            d("emit readable"), e.emit("readable"), A(e);
                        }
                        function M(e, t) {
                            t.readingMore || (t.readingMore = !0, i.nextTick(C, e, t));
                        }
                        function C(e, t) {
                            for(var r = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (d("maybeReadMore read 0"), e.read(0), r !== t.length);)r = t.length;
                            t.readingMore = !1;
                        }
                        function T(e) {
                            d("readable nexttick read 0"), e.read(0);
                        }
                        function E(e, t) {
                            t.reading || (d("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), A(e), t.flowing && !t.reading && e.read(0);
                        }
                        function A(e) {
                            var t = e._readableState;
                            for(d("flow", t.flowing); t.flowing && null !== e.read(););
                        }
                        function R(e, t) {
                            var r;
                            return 0 === t.length ? null : (t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (r = t.decoder ? t.buffer.join("") : 1 === t.buffer.length ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : r = function(e, t, r) {
                                var n;
                                e < t.head.data.length ? (n = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : n = e === t.head.data.length ? t.shift() : r ? function(e, t) {
                                    var r = t.head, n = 1, i = r.data;
                                    e -= i.length;
                                    for(; r = r.next;){
                                        var s = r.data, o = e > s.length ? s.length : e;
                                        if (o === s.length ? i += s : i += s.slice(0, e), 0 === (e -= o)) {
                                            o === s.length ? (++n, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = s.slice(o));
                                            break;
                                        }
                                        ++n;
                                    }
                                    return t.length -= n, i;
                                }(e, t) : function(e, t) {
                                    var r = c.allocUnsafe(e), n = t.head, i = 1;
                                    n.data.copy(r), e -= n.data.length;
                                    for(; n = n.next;){
                                        var s = n.data, o = e > s.length ? s.length : e;
                                        if (s.copy(r, r.length - e, 0, o), 0 === (e -= o)) {
                                            o === s.length ? (++i, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = s.slice(o));
                                            break;
                                        }
                                        ++i;
                                    }
                                    return t.length -= i, r;
                                }(e, t);
                                return n;
                            }(e, t.buffer, t.decoder), r);
                        }
                        function O(e) {
                            var t = e._readableState;
                            if (t.length > 0) throw new Error('"endReadable()" called on non-empty stream');
                            t.endEmitted || (t.ended = !0, i.nextTick(j, t, e));
                        }
                        function j(e, t) {
                            e.endEmitted || 0 !== e.length || (e.endEmitted = !0, t.readable = !1, t.emit("end"));
                        }
                        function I(e, t) {
                            for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                            return -1;
                        }
                        v.prototype.read = function(e) {
                            d("read", e), e = parseInt(e, 10);
                            var t = this._readableState, r = e;
                            if (0 !== e && (t.emittedReadable = !1), 0 === e && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return d("read: emitReadable", t.length, t.ended), 0 === t.length && t.ended ? O(this) : k(this), null;
                            if (0 === (e = x(e, t)) && t.ended) return 0 === t.length && O(this), null;
                            var n, i = t.needReadable;
                            return d("need readable", i), (0 === t.length || t.length - e < t.highWaterMark) && d("length less than watermark", i = !0), t.ended || t.reading ? d("reading or ended", i = !1) : i && (d("do read"), t.reading = !0, t.sync = !0, 0 === t.length && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = x(r, t))), null === (n = e > 0 ? R(e, t) : null) ? (t.needReadable = !0, e = 0) : t.length -= e, 0 === t.length && (t.ended || (t.needReadable = !0), r !== e && t.ended && O(this)), null !== n && this.emit("data", n), n;
                        }, v.prototype._read = function(e) {
                            this.emit("error", new Error("_read() is not implemented"));
                        }, v.prototype.pipe = function(e, t) {
                            var n = this, s = this._readableState;
                            switch(s.pipesCount){
                                case 0:
                                    s.pipes = e;
                                    break;
                                case 1:
                                    s.pipes = [
                                        s.pipes,
                                        e
                                    ];
                                    break;
                                default:
                                    s.pipes.push(e);
                            }
                            s.pipesCount += 1, d("pipe count=%d opts=%j", s.pipesCount, t);
                            var l = (!t || !1 !== t.end) && e !== r.stdout && e !== r.stderr ? u : v;
                            function c(t, r) {
                                d("onunpipe"), t === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, d("cleanup"), e.removeListener("close", g), e.removeListener("finish", y), e.removeListener("drain", h), e.removeListener("error", b), e.removeListener("unpipe", c), n.removeListener("end", u), n.removeListener("end", v), n.removeListener("data", m), f = !0, !s.awaitDrain || e._writableState && !e._writableState.needDrain || h());
                            }
                            function u() {
                                d("onend"), e.end();
                            }
                            s.endEmitted ? i.nextTick(l) : n.once("end", l), e.on("unpipe", c);
                            var h = function(e) {
                                return function() {
                                    var t = e._readableState;
                                    d("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, 0 === t.awaitDrain && a(e, "data") && (t.flowing = !0, A(e));
                                };
                            }(n);
                            e.on("drain", h);
                            var f = !1;
                            var p = !1;
                            function m(t) {
                                d("ondata"), p = !1, !1 !== e.write(t) || p || ((1 === s.pipesCount && s.pipes === e || s.pipesCount > 1 && -1 !== I(s.pipes, e)) && !f && (d("false write response, pause", s.awaitDrain), s.awaitDrain++, p = !0), n.pause());
                            }
                            function b(t) {
                                d("onerror", t), v(), e.removeListener("error", b), 0 === a(e, "error") && e.emit("error", t);
                            }
                            function g() {
                                e.removeListener("finish", y), v();
                            }
                            function y() {
                                d("onfinish"), e.removeListener("close", g), v();
                            }
                            function v() {
                                d("unpipe"), n.unpipe(e);
                            }
                            return n.on("data", m), function(e, t, r) {
                                if ("function" == typeof e.prependListener) return e.prependListener(t, r);
                                e._events && e._events[t] ? o(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                                    r,
                                    e._events[t]
                                ] : e.on(t, r);
                            }(e, "error", b), e.once("close", g), e.once("finish", y), e.emit("pipe", n), s.flowing || (d("pipe resume"), n.resume()), e;
                        }, v.prototype.unpipe = function(e) {
                            var t = this._readableState, r = {
                                hasUnpiped: !1
                            };
                            if (0 === t.pipesCount) return this;
                            if (1 === t.pipesCount) return e && e !== t.pipes || (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r)), this;
                            if (!e) {
                                var n = t.pipes, i = t.pipesCount;
                                t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                                for(var s = 0; s < i; s++)n[s].emit("unpipe", this, {
                                    hasUnpiped: !1
                                });
                                return this;
                            }
                            var o = I(t.pipes, e);
                            return -1 === o || (t.pipes.splice(o, 1), t.pipesCount -= 1, 1 === t.pipesCount && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r)), this;
                        }, v.prototype.on = function(e, t) {
                            var r = l.prototype.on.call(this, e, t);
                            if ("data" === e) !1 !== this._readableState.flowing && this.resume();
                            else if ("readable" === e) {
                                var n = this._readableState;
                                n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && k(this) : i.nextTick(T, this));
                            }
                            return r;
                        }, v.prototype.addListener = v.prototype.on, v.prototype.resume = function() {
                            var e = this._readableState;
                            return e.flowing || (d("resume"), e.flowing = !0, function(e, t) {
                                t.resumeScheduled || (t.resumeScheduled = !0, i.nextTick(E, e, t));
                            }(this, e)), this;
                        }, v.prototype.pause = function() {
                            return d("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (d("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
                        }, v.prototype.wrap = function(e) {
                            var t = this, r = this._readableState, n = !1;
                            for(var i in e.on("end", function() {
                                if (d("wrapped end"), r.decoder && !r.ended) {
                                    var e = r.decoder.end();
                                    e && e.length && t.push(e);
                                }
                                t.push(null);
                            }), e.on("data", function(i) {
                                (d("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (t.push(i) || (n = !0, e.pause()));
                            }), e)void 0 === this[i] && "function" == typeof e[i] && (this[i] = function(t) {
                                return function() {
                                    return e[t].apply(e, arguments);
                                };
                            }(i));
                            for(var s = 0; s < g.length; s++)e.on(g[s], this.emit.bind(this, g[s]));
                            return this._read = function(t) {
                                d("wrapped _read", t), n && (n = !1, e.resume());
                            }, this;
                        }, Object.defineProperty(v.prototype, "readableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._readableState.highWaterMark;
                            }
                        }), v._fromList = R;
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/BufferList": 513,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                events: 422,
                inherits: 440,
                isarray: 506,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                "string_decoder/": 521,
                util: 188
            }
        ],
        511: [
            function(e, t, r) {
                "use strict";
                t.exports = o;
                var n = e("./_stream_duplex"), i = Object.create(e("core-util-is"));
                function s(e, t) {
                    var r = this._transformState;
                    r.transforming = !1;
                    var n = r.writecb;
                    if (!n) return this.emit("error", new Error("write callback called multiple times"));
                    r.writechunk = null, r.writecb = null, null != t && this.push(t), n(e);
                    var i = this._readableState;
                    i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
                function o(e) {
                    if (!(this instanceof o)) return new o(e);
                    n.call(this, e), this._transformState = {
                        afterTransform: s.bind(this),
                        needTransform: !1,
                        transforming: !1,
                        writecb: null,
                        writechunk: null,
                        writeencoding: null
                    }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && ("function" == typeof e.transform && (this._transform = e.transform), "function" == typeof e.flush && (this._flush = e.flush)), this.on("prefinish", a);
                }
                function a() {
                    var e = this;
                    "function" == typeof this._flush ? this._flush(function(t, r) {
                        l(e, t, r);
                    }) : l(this, null, null);
                }
                function l(e, t, r) {
                    if (t) return e.emit("error", t);
                    if (null != r && e.push(r), e._writableState.length) throw new Error("Calling transform done when ws.length != 0");
                    if (e._transformState.transforming) throw new Error("Calling transform done when still transforming");
                    return e.push(null);
                }
                i.inherits = e("inherits"), i.inherits(o, n), o.prototype.push = function(e, t) {
                    return this._transformState.needTransform = !1, n.prototype.push.call(this, e, t);
                }, o.prototype._transform = function(e, t, r) {
                    throw new Error("_transform() is not implemented");
                }, o.prototype._write = function(e, t, r) {
                    var n = this._transformState;
                    if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                        var i = this._readableState;
                        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                    }
                }, o.prototype._read = function(e) {
                    var t = this._transformState;
                    null !== t.writechunk && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
                }, o.prototype._destroy = function(e, t) {
                    var r = this;
                    n.prototype._destroy.call(this, e, function(e) {
                        t(e), r.emit("close");
                    });
                };
            },
            {
                "./_stream_duplex": 508,
                "core-util-is": 383,
                inherits: 440
            }
        ],
        512: [
            function(e, t, r) {
                (function(r, n, i) {
                    (function() {
                        "use strict";
                        var s = e("process-nextick-args");
                        function o(e) {
                            var t = this;
                            this.next = null, this.entry = null, this.finish = function() {
                                !function(e, t, r) {
                                    var n = e.entry;
                                    e.entry = null;
                                    for(; n;){
                                        var i = n.callback;
                                        t.pendingcb--, i(r), n = n.next;
                                    }
                                    t.corkedRequestsFree.next = e;
                                }(t, e);
                            };
                        }
                        t.exports = y;
                        var a, l = !r.browser && [
                            "v0.10",
                            "v0.9."
                        ].indexOf(r.version.slice(0, 5)) > -1 ? i : s.nextTick;
                        y.WritableState = g;
                        var c = Object.create(e("core-util-is"));
                        c.inherits = e("inherits");
                        var u = {
                            deprecate: e("util-deprecate")
                        }, h = e("./internal/streams/stream"), f = e("safe-buffer").Buffer, d = (void 0 !== n ? n : "undefined" != typeof window ? window : "undefined" != typeof self ? self : {}).Uint8Array || function() {};
                        var p, m = e("./internal/streams/destroy");
                        function b() {}
                        function g(t, r) {
                            a = a || e("./_stream_duplex"), t = t || {};
                            var n = r instanceof a;
                            this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
                            var i = t.highWaterMark, c = t.writableHighWaterMark, u = this.objectMode ? 16 : 16384;
                            this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : u, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                            var h = !1 === t.decodeStrings;
                            this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
                                !function(e, t) {
                                    var r = e._writableState, n = r.sync, i = r.writecb;
                                    if (function(e) {
                                        e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
                                    }(r), t) !function(e, t, r, n, i) {
                                        --t.pendingcb, r ? (s.nextTick(i, n), s.nextTick(S, e, t), e._writableState.errorEmitted = !0, e.emit("error", n)) : (i(n), e._writableState.errorEmitted = !0, e.emit("error", n), S(e, t));
                                    }(e, r, n, t, i);
                                    else {
                                        var o = x(r);
                                        o || r.corked || r.bufferProcessing || !r.bufferedRequest || _(e, r), n ? l(w, e, r, o, i) : w(e, r, o, i);
                                    }
                                }(r, e);
                            }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new o(this);
                        }
                        function y(t) {
                            if (a = a || e("./_stream_duplex"), !(p.call(y, this) || this instanceof a)) return new y(t);
                            this._writableState = new g(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this);
                        }
                        function v(e, t, r, n, i, s, o) {
                            t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, r ? e._writev(i, t.onwrite) : e._write(i, s, t.onwrite), t.sync = !1;
                        }
                        function w(e, t, r, n) {
                            r || function(e, t) {
                                0 === t.length && t.needDrain && (t.needDrain = !1, e.emit("drain"));
                            }(e, t), t.pendingcb--, n(), S(e, t);
                        }
                        function _(e, t) {
                            t.bufferProcessing = !0;
                            var r = t.bufferedRequest;
                            if (e._writev && r && r.next) {
                                var n = t.bufferedRequestCount, i = new Array(n), s = t.corkedRequestsFree;
                                s.entry = r;
                                for(var a = 0, l = !0; r;)i[a] = r, r.isBuf || (l = !1), r = r.next, a += 1;
                                i.allBuffers = l, v(e, t, !0, t.length, i, "", s.finish), t.pendingcb++, t.lastBufferedRequest = null, s.next ? (t.corkedRequestsFree = s.next, s.next = null) : t.corkedRequestsFree = new o(t), t.bufferedRequestCount = 0;
                            } else {
                                for(; r;){
                                    var c = r.chunk, u = r.encoding, h = r.callback;
                                    if (v(e, t, !1, t.objectMode ? 1 : c.length, c, u, h), r = r.next, t.bufferedRequestCount--, t.writing) break;
                                }
                                null === r && (t.lastBufferedRequest = null);
                            }
                            t.bufferedRequest = r, t.bufferProcessing = !1;
                        }
                        function x(e) {
                            return e.ending && 0 === e.length && null === e.bufferedRequest && !e.finished && !e.writing;
                        }
                        function k(e, t) {
                            e._final(function(r) {
                                t.pendingcb--, r && e.emit("error", r), t.prefinished = !0, e.emit("prefinish"), S(e, t);
                            });
                        }
                        function S(e, t) {
                            var r = x(t);
                            return r && (!function(e, t) {
                                t.prefinished || t.finalCalled || ("function" == typeof e._final ? (t.pendingcb++, t.finalCalled = !0, s.nextTick(k, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
                            }(e, t), 0 === t.pendingcb && (t.finished = !0, e.emit("finish"))), r;
                        }
                        c.inherits(y, h), g.prototype.getBuffer = function() {
                            for(var e = this.bufferedRequest, t = []; e;)t.push(e), e = e.next;
                            return t;
                        }, function() {
                            try {
                                Object.defineProperty(g.prototype, "buffer", {
                                    get: u.deprecate(function() {
                                        return this.getBuffer();
                                    }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                                });
                            } catch (e) {}
                        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (p = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
                            value: function(e) {
                                return !!p.call(this, e) || this === y && e && e._writableState instanceof g;
                            }
                        })) : p = function(e) {
                            return e instanceof this;
                        }, y.prototype.pipe = function() {
                            this.emit("error", new Error("Cannot pipe, not readable"));
                        }, y.prototype.write = function(e, t, r) {
                            var n, i = this._writableState, o = !1, a = !i.objectMode && (n = e, f.isBuffer(n) || n instanceof d);
                            return a && !f.isBuffer(e) && (e = function(e) {
                                return f.from(e);
                            }(e)), "function" == typeof t && (r = t, t = null), a ? t = "buffer" : t || (t = i.defaultEncoding), "function" != typeof r && (r = b), i.ended ? function(e, t) {
                                var r = new Error("write after end");
                                e.emit("error", r), s.nextTick(t, r);
                            }(this, r) : (a || function(e, t, r, n) {
                                var i = !0, o = !1;
                                return null === r ? o = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || t.objectMode || (o = new TypeError("Invalid non-string/buffer chunk")), o && (e.emit("error", o), s.nextTick(n, o), i = !1), i;
                            }(this, i, e, r)) && (i.pendingcb++, o = function(e, t, r, n, i, s) {
                                if (!r) {
                                    var o = function(e, t, r) {
                                        e.objectMode || !1 === e.decodeStrings || "string" != typeof t || (t = f.from(t, r));
                                        return t;
                                    }(t, n, i);
                                    n !== o && (r = !0, i = "buffer", n = o);
                                }
                                var a = t.objectMode ? 1 : n.length;
                                t.length += a;
                                var l = t.length < t.highWaterMark;
                                l || (t.needDrain = !0);
                                if (t.writing || t.corked) {
                                    var c = t.lastBufferedRequest;
                                    t.lastBufferedRequest = {
                                        chunk: n,
                                        encoding: i,
                                        isBuf: r,
                                        callback: s,
                                        next: null
                                    }, c ? c.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                                } else v(e, t, !1, a, n, i, s);
                                return l;
                            }(this, i, a, e, t, r)), o;
                        }, y.prototype.cork = function() {
                            this._writableState.corked++;
                        }, y.prototype.uncork = function() {
                            var e = this._writableState;
                            e.corked && (e.corked--, e.writing || e.corked || e.bufferProcessing || !e.bufferedRequest || _(this, e));
                        }, y.prototype.setDefaultEncoding = function(e) {
                            if ("string" == typeof e && (e = e.toLowerCase()), !([
                                "hex",
                                "utf8",
                                "utf-8",
                                "ascii",
                                "binary",
                                "base64",
                                "ucs2",
                                "ucs-2",
                                "utf16le",
                                "utf-16le",
                                "raw"
                            ].indexOf((e + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + e);
                            return this._writableState.defaultEncoding = e, this;
                        }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
                            enumerable: !1,
                            get: function() {
                                return this._writableState.highWaterMark;
                            }
                        }), y.prototype._write = function(e, t, r) {
                            r(new Error("_write() is not implemented"));
                        }, y.prototype._writev = null, y.prototype.end = function(e, t, r) {
                            var n = this._writableState;
                            "function" == typeof e ? (r = e, e = null, t = null) : "function" == typeof t && (r = t, t = null), null != e && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || function(e, t, r) {
                                t.ending = !0, S(e, t), r && (t.finished ? s.nextTick(r) : e.once("finish", r));
                                t.ended = !0, e.writable = !1;
                            }(this, n, r);
                        }, Object.defineProperty(y.prototype, "destroyed", {
                            get: function() {
                                return void 0 !== this._writableState && this._writableState.destroyed;
                            },
                            set: function(e) {
                                this._writableState && (this._writableState.destroyed = e);
                            }
                        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function(e, t) {
                            this.end(), t(e);
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e("timers").setImmediate);
            },
            {
                "./_stream_duplex": 508,
                "./internal/streams/destroy": 514,
                "./internal/streams/stream": 515,
                _process: 467,
                "core-util-is": 383,
                inherits: 440,
                "process-nextick-args": 466,
                "safe-buffer": 520,
                timers: 523,
                "util-deprecate": 524
            }
        ],
        513: [
            function(e, t, r) {
                "use strict";
                var n = e("safe-buffer").Buffer, i = e("util");
                t.exports = function() {
                    function e() {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.head = null, this.tail = null, this.length = 0;
                    }
                    return e.prototype.push = function(e) {
                        var t = {
                            data: e,
                            next: null
                        };
                        this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
                    }, e.prototype.unshift = function(e) {
                        var t = {
                            data: e,
                            next: this.head
                        };
                        0 === this.length && (this.tail = t), this.head = t, ++this.length;
                    }, e.prototype.shift = function() {
                        if (0 !== this.length) {
                            var e = this.head.data;
                            return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
                        }
                    }, e.prototype.clear = function() {
                        this.head = this.tail = null, this.length = 0;
                    }, e.prototype.join = function(e) {
                        if (0 === this.length) return "";
                        for(var t = this.head, r = "" + t.data; t = t.next;)r += e + t.data;
                        return r;
                    }, e.prototype.concat = function(e) {
                        if (0 === this.length) return n.alloc(0);
                        for(var t, r, i, s = n.allocUnsafe(e >>> 0), o = this.head, a = 0; o;)t = o.data, r = s, i = a, t.copy(r, i), a += o.data.length, o = o.next;
                        return s;
                    }, e;
                }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() {
                    var e = i.inspect({
                        length: this.length
                    });
                    return this.constructor.name + " " + e;
                });
            },
            {
                "safe-buffer": 520,
                util: 188
            }
        ],
        514: [
            function(e, t, r) {
                "use strict";
                var n = e("process-nextick-args");
                function i(e, t) {
                    e.emit("error", t);
                }
                t.exports = {
                    destroy: function(e, t) {
                        var r = this, s = this._readableState && this._readableState.destroyed, o = this._writableState && this._writableState.destroyed;
                        return s || o ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, n.nextTick(i, this, e)) : n.nextTick(i, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
                            !t && e ? r._writableState ? r._writableState.errorEmitted || (r._writableState.errorEmitted = !0, n.nextTick(i, r, e)) : n.nextTick(i, r, e) : t && t(e);
                        }), this);
                    },
                    undestroy: function() {
                        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
                    }
                };
            },
            {
                "process-nextick-args": 466
            }
        ],
        515: [
            function(e, t, r) {
                arguments[4][490][0].apply(r, arguments);
            },
            {
                dup: 490,
                events: 422
            }
        ],
        516: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").PassThrough;
            },
            {
                "./readable": 517
            }
        ],
        517: [
            function(e, t, r) {
                "use strict";
                (r = t.exports = e("./lib/_stream_readable.js")).Stream = r, r.Readable = r, r.Writable = e("./lib/_stream_writable.js"), r.Duplex = e("./lib/_stream_duplex.js"), r.Transform = e("./lib/_stream_transform.js"), r.PassThrough = e("./lib/_stream_passthrough.js");
            },
            {
                "./lib/_stream_duplex.js": 508,
                "./lib/_stream_passthrough.js": 509,
                "./lib/_stream_readable.js": 510,
                "./lib/_stream_transform.js": 511,
                "./lib/_stream_writable.js": 512
            }
        ],
        518: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./readable").Transform;
            },
            {
                "./readable": 517
            }
        ],
        519: [
            function(e, t, r) {
                "use strict";
                t.exports = e("./lib/_stream_writable.js");
            },
            {
                "./lib/_stream_writable.js": 512
            }
        ],
        520: [
            function(e, t, r) {
                arguments[4][217][0].apply(r, arguments);
            },
            {
                buffer: 220,
                dup: 217
            }
        ],
        521: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 520
            }
        ],
        522: [
            function(e, t, r) {
                arguments[4][218][0].apply(r, arguments);
            },
            {
                dup: 218,
                "safe-buffer": 494
            }
        ],
        523: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = e("process/browser.js").nextTick, s = Function.prototype.apply, o = Array.prototype.slice, a = {}, l = 0;
                        function c(e, t) {
                            this._id = e, this._clearFn = t;
                        }
                        r.setTimeout = function() {
                            return new c(s.call(setTimeout, window, arguments), clearTimeout);
                        }, r.setInterval = function() {
                            return new c(s.call(setInterval, window, arguments), clearInterval);
                        }, r.clearTimeout = r.clearInterval = function(e) {
                            e.close();
                        }, c.prototype.unref = c.prototype.ref = function() {}, c.prototype.close = function() {
                            this._clearFn.call(window, this._id);
                        }, r.enroll = function(e, t) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
                        }, r.unenroll = function(e) {
                            clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
                        }, r._unrefActive = r.active = function(e) {
                            clearTimeout(e._idleTimeoutId);
                            var t = e._idleTimeout;
                            t >= 0 && (e._idleTimeoutId = setTimeout(function() {
                                e._onTimeout && e._onTimeout();
                            }, t));
                        }, r.setImmediate = "function" == typeof t ? t : function(e) {
                            var t = l++, n = !(arguments.length < 2) && o.call(arguments, 1);
                            return a[t] = !0, i(function() {
                                a[t] && (n ? e.apply(null, n) : e.call(null), r.clearImmediate(t));
                            }), t;
                        }, r.clearImmediate = "function" == typeof n ? n : function(e) {
                            delete a[e];
                        };
                    }).call(this);
                }).call(this, e("timers").setImmediate, e("timers").clearImmediate);
            },
            {
                "process/browser.js": 467,
                timers: 523
            }
        ],
        524: [
            function(e, t, r) {
                (function(e) {
                    (function() {
                        "use strict";
                        function r(t) {
                            try {
                                if (!e.localStorage) return !1;
                            } catch (e) {
                                return !1;
                            }
                            var r = e.localStorage[t];
                            return null != r && "true" === String(r).toLowerCase();
                        }
                        t.exports = function(e, t) {
                            if (r("noDeprecation")) return e;
                            var n = !1;
                            return function() {
                                if (!n) {
                                    if (r("throwDeprecation")) throw new Error(t);
                                    r("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                    }).call(this);
                }).call(this, "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        525: [
            function(e, t, r) {
                "use strict";
                "function" == typeof Object.create ? t.exports = function(e, t) {
                    e.super_ = t, e.prototype = Object.create(t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    });
                } : t.exports = function(e, t) {
                    e.super_ = t;
                    var r = function() {};
                    r.prototype = t.prototype, e.prototype = new r, e.prototype.constructor = e;
                };
            },
            {}
        ],
        526: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e) {
                    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
                };
            },
            {}
        ],
        527: [
            function(e, t, r) {
                (function(t, n) {
                    (function() {
                        "use strict";
                        var i = /%[sdj%]/g;
                        r.format = function(e) {
                            if (!g(e)) {
                                for(var t = [], r = 0; r < arguments.length; r++)t.push(a(arguments[r]));
                                return t.join(" ");
                            }
                            r = 1;
                            for(var n = arguments, s = n.length, o = String(e).replace(i, function(e) {
                                if ("%%" === e) return "%";
                                if (r >= s) return e;
                                switch(e){
                                    case "%s":
                                        return String(n[r++]);
                                    case "%d":
                                        return Number(n[r++]);
                                    case "%j":
                                        try {
                                            return JSON.stringify(n[r++]);
                                        } catch (e) {
                                            return "[Circular]";
                                        }
                                    default:
                                        return e;
                                }
                            }), l = n[r]; r < s; l = n[++r])m(l) || !w(l) ? o += " " + l : o += " " + a(l);
                            return o;
                        }, r.deprecate = function(e, i) {
                            if (y(n.process)) return function() {
                                return r.deprecate(e, i).apply(this, arguments);
                            };
                            if (!0 === t.noDeprecation) return e;
                            var s = !1;
                            return function() {
                                if (!s) {
                                    if (t.throwDeprecation) throw new Error(i);
                                    t.traceDeprecation ? console.trace(i) : console.error(i), s = !0;
                                }
                                return e.apply(this, arguments);
                            };
                        };
                        var s, o = {};
                        function a(e, t) {
                            var n = {
                                seen: [],
                                stylize: c
                            };
                            return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), p(t) ? n.showHidden = t : t && r._extend(n, t), y(n.showHidden) && (n.showHidden = !1), y(n.depth) && (n.depth = 2), y(n.colors) && (n.colors = !1), y(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = l), u(n, e, n.depth);
                        }
                        function l(e, t) {
                            var r = a.styles[t];
                            return r ? "\x1b[" + a.colors[r][0] + "m" + e + "\x1b[" + a.colors[r][1] + "m" : e;
                        }
                        function c(e, t) {
                            return e;
                        }
                        function u(e, t, n) {
                            if (e.customInspect && t && k(t.inspect) && t.inspect !== r.inspect && (!t.constructor || t.constructor.prototype !== t)) {
                                var i = t.inspect(n, e);
                                return g(i) || (i = u(e, i, n)), i;
                            }
                            var s = function(e, t) {
                                if (y(t)) return e.stylize("undefined", "undefined");
                                if (g(t)) {
                                    var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                                    return e.stylize(r, "string");
                                }
                                if (b(t)) return e.stylize("" + t, "number");
                                if (p(t)) return e.stylize("" + t, "boolean");
                                if (m(t)) return e.stylize("null", "null");
                            }(e, t);
                            if (s) return s;
                            var o = Object.keys(t), a = function(e) {
                                var t = {};
                                return e.forEach(function(e, r) {
                                    t[e] = !0;
                                }), t;
                            }(o);
                            if (e.showHidden && (o = Object.getOwnPropertyNames(t)), x(t) && (o.indexOf("message") >= 0 || o.indexOf("description") >= 0)) return h(t);
                            if (0 === o.length) {
                                if (k(t)) {
                                    var l = t.name ? ": " + t.name : "";
                                    return e.stylize("[Function" + l + "]", "special");
                                }
                                if (v(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                                if (_(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                                if (x(t)) return h(t);
                            }
                            var c, w = "", S = !1, M = [
                                "{",
                                "}"
                            ];
                            (d(t) && (S = !0, M = [
                                "[",
                                "]"
                            ]), k(t)) && (w = " [Function" + (t.name ? ": " + t.name : "") + "]");
                            return v(t) && (w = " " + RegExp.prototype.toString.call(t)), _(t) && (w = " " + Date.prototype.toUTCString.call(t)), x(t) && (w = " " + h(t)), 0 !== o.length || S && 0 != t.length ? n < 0 ? v(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(t), c = S ? function(e, t, r, n, i) {
                                for(var s = [], o = 0, a = t.length; o < a; ++o)E(t, String(o)) ? s.push(f(e, t, r, n, String(o), !0)) : s.push("");
                                return i.forEach(function(i) {
                                    i.match(/^\d+$/) || s.push(f(e, t, r, n, i, !0));
                                }), s;
                            }(e, t, n, a, o) : o.map(function(r) {
                                return f(e, t, n, a, r, S);
                            }), e.seen.pop(), function(e, t, r) {
                                if (e.reduce(function(e, t) {
                                    return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
                                }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
                                return r[0] + t + " " + e.join(", ") + " " + r[1];
                            }(c, w, M)) : M[0] + w + M[1];
                        }
                        function h(e) {
                            return "[" + Error.prototype.toString.call(e) + "]";
                        }
                        function f(e, t, r, n, i, s) {
                            var o, a, l;
                            if ((l = Object.getOwnPropertyDescriptor(t, i) || {
                                value: t[i]
                            }).get ? a = l.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : l.set && (a = e.stylize("[Setter]", "special")), E(n, i) || (o = "[" + i + "]"), a || (e.seen.indexOf(l.value) < 0 ? (a = m(r) ? u(e, l.value, null) : u(e, l.value, r - 1)).indexOf("\n") > -1 && (a = s ? a.split("\n").map(function(e) {
                                return "  " + e;
                            }).join("\n").substr(2) : "\n" + a.split("\n").map(function(e) {
                                return "   " + e;
                            }).join("\n")) : a = e.stylize("[Circular]", "special")), y(o)) {
                                if (s && i.match(/^\d+$/)) return a;
                                (o = JSON.stringify("" + i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
                            }
                            return o + ": " + a;
                        }
                        function d(e) {
                            return Array.isArray(e);
                        }
                        function p(e) {
                            return "boolean" == typeof e;
                        }
                        function m(e) {
                            return null === e;
                        }
                        function b(e) {
                            return "number" == typeof e;
                        }
                        function g(e) {
                            return "string" == typeof e;
                        }
                        function y(e) {
                            return void 0 === e;
                        }
                        function v(e) {
                            return w(e) && "[object RegExp]" === S(e);
                        }
                        function w(e) {
                            return "object" == typeof e && null !== e;
                        }
                        function _(e) {
                            return w(e) && "[object Date]" === S(e);
                        }
                        function x(e) {
                            return w(e) && ("[object Error]" === S(e) || e instanceof Error);
                        }
                        function k(e) {
                            return "function" == typeof e;
                        }
                        function S(e) {
                            return Object.prototype.toString.call(e);
                        }
                        function M(e) {
                            return e < 10 ? "0" + e.toString(10) : e.toString(10);
                        }
                        r.debuglog = function(e) {
                            if (y(s) && (s = t.env.NODE_DEBUG || ""), e = e.toUpperCase(), !o[e]) {
                                if (new RegExp("\\b" + e + "\\b", "i").test(s)) {
                                    var n = t.pid;
                                    o[e] = function() {
                                        var t = r.format.apply(r, arguments);
                                        console.error("%s %d: %s", e, n, t);
                                    };
                                } else o[e] = function() {};
                            }
                            return o[e];
                        }, r.inspect = a, a.colors = {
                            bold: [
                                1,
                                22
                            ],
                            italic: [
                                3,
                                23
                            ],
                            underline: [
                                4,
                                24
                            ],
                            inverse: [
                                7,
                                27
                            ],
                            white: [
                                37,
                                39
                            ],
                            grey: [
                                90,
                                39
                            ],
                            black: [
                                30,
                                39
                            ],
                            blue: [
                                34,
                                39
                            ],
                            cyan: [
                                36,
                                39
                            ],
                            green: [
                                32,
                                39
                            ],
                            magenta: [
                                35,
                                39
                            ],
                            red: [
                                31,
                                39
                            ],
                            yellow: [
                                33,
                                39
                            ]
                        }, a.styles = {
                            special: "cyan",
                            number: "yellow",
                            boolean: "yellow",
                            undefined: "grey",
                            null: "bold",
                            string: "green",
                            date: "magenta",
                            regexp: "red"
                        }, r.isArray = d, r.isBoolean = p, r.isNull = m, r.isNullOrUndefined = function(e) {
                            return null == e;
                        }, r.isNumber = b, r.isString = g, r.isSymbol = function(e) {
                            return "symbol" == typeof e;
                        }, r.isUndefined = y, r.isRegExp = v, r.isObject = w, r.isDate = _, r.isError = x, r.isFunction = k, r.isPrimitive = function(e) {
                            return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
                        }, r.isBuffer = e("./support/isBuffer");
                        var C = [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ];
                        function T() {
                            var e = new Date, t = [
                                M(e.getHours()),
                                M(e.getMinutes()),
                                M(e.getSeconds())
                            ].join(":");
                            return [
                                e.getDate(),
                                C[e.getMonth()],
                                t
                            ].join(" ");
                        }
                        function E(e, t) {
                            return Object.prototype.hasOwnProperty.call(e, t);
                        }
                        r.log = function() {
                            console.log("%s - %s", T(), r.format.apply(r, arguments));
                        }, r.inherits = e("inherits"), r._extend = function(e, t) {
                            if (!t || !w(t)) return e;
                            for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                            return e;
                        };
                    }).call(this);
                }).call(this, e("_process"), "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {
                "./support/isBuffer": 526,
                _process: 467,
                inherits: 525
            }
        ],
        528: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), Object.defineProperty(r, "v1", {
                    enumerable: !0,
                    get: function() {
                        return n.default;
                    }
                }), Object.defineProperty(r, "v3", {
                    enumerable: !0,
                    get: function() {
                        return i.default;
                    }
                }), Object.defineProperty(r, "v4", {
                    enumerable: !0,
                    get: function() {
                        return s.default;
                    }
                }), Object.defineProperty(r, "v5", {
                    enumerable: !0,
                    get: function() {
                        return o.default;
                    }
                }), Object.defineProperty(r, "NIL", {
                    enumerable: !0,
                    get: function() {
                        return a.default;
                    }
                }), Object.defineProperty(r, "version", {
                    enumerable: !0,
                    get: function() {
                        return l.default;
                    }
                }), Object.defineProperty(r, "validate", {
                    enumerable: !0,
                    get: function() {
                        return c.default;
                    }
                }), Object.defineProperty(r, "stringify", {
                    enumerable: !0,
                    get: function() {
                        return u.default;
                    }
                }), Object.defineProperty(r, "parse", {
                    enumerable: !0,
                    get: function() {
                        return h.default;
                    }
                });
                var n = f(e("./v1.js")), i = f(e("./v3.js")), s = f(e("./v4.js")), o = f(e("./v5.js")), a = f(e("./nil.js")), l = f(e("./version.js")), c = f(e("./validate.js")), u = f(e("./stringify.js")), h = f(e("./parse.js"));
                function f(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            {
                "./nil.js": 530,
                "./parse.js": 531,
                "./stringify.js": 535,
                "./v1.js": 536,
                "./v3.js": 537,
                "./v4.js": 539,
                "./v5.js": 540,
                "./validate.js": 541,
                "./version.js": 542
            }
        ],
        529: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    return 14 + (e + 64 >>> 9 << 4) + 1;
                }
                function i(e, t) {
                    const r = (65535 & e) + (65535 & t);
                    return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
                }
                function s(e, t, r, n, s, o) {
                    var a, l;
                    return i((a = i(i(t, e), i(n, o))) << (l = s) | a >>> 32 - l, r);
                }
                function o(e, t, r, n, i, o, a) {
                    return s(t & r | ~t & n, e, t, i, o, a);
                }
                function a(e, t, r, n, i, o, a) {
                    return s(t & n | r & ~n, e, t, i, o, a);
                }
                function l(e, t, r, n, i, o, a) {
                    return s(t ^ r ^ n, e, t, i, o, a);
                }
                function c(e, t, r, n, i, o, a) {
                    return s(r ^ (t | ~n), e, t, i, o, a);
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var u = function(e) {
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = new Uint8Array(t.length);
                        for(let r = 0; r < t.length; ++r)e[r] = t.charCodeAt(r);
                    }
                    return function(e) {
                        const t = [], r = 32 * e.length;
                        for(let n = 0; n < r; n += 8){
                            const r = e[n >> 5] >>> n % 32 & 255, i = parseInt("0123456789abcdef".charAt(r >>> 4 & 15) + "0123456789abcdef".charAt(15 & r), 16);
                            t.push(i);
                        }
                        return t;
                    }(function(e, t) {
                        e[t >> 5] |= 128 << t % 32, e[n(t) - 1] = t;
                        let r = 1732584193, s = -271733879, u = -1732584194, h = 271733878;
                        for(let t = 0; t < e.length; t += 16){
                            const n = r, f = s, d = u, p = h;
                            r = o(r, s, u, h, e[t], 7, -680876936), h = o(h, r, s, u, e[t + 1], 12, -389564586), u = o(u, h, r, s, e[t + 2], 17, 606105819), s = o(s, u, h, r, e[t + 3], 22, -1044525330), r = o(r, s, u, h, e[t + 4], 7, -176418897), h = o(h, r, s, u, e[t + 5], 12, 1200080426), u = o(u, h, r, s, e[t + 6], 17, -1473231341), s = o(s, u, h, r, e[t + 7], 22, -45705983), r = o(r, s, u, h, e[t + 8], 7, 1770035416), h = o(h, r, s, u, e[t + 9], 12, -1958414417), u = o(u, h, r, s, e[t + 10], 17, -42063), s = o(s, u, h, r, e[t + 11], 22, -1990404162), r = o(r, s, u, h, e[t + 12], 7, 1804603682), h = o(h, r, s, u, e[t + 13], 12, -40341101), u = o(u, h, r, s, e[t + 14], 17, -1502002290), s = o(s, u, h, r, e[t + 15], 22, 1236535329), r = a(r, s, u, h, e[t + 1], 5, -165796510), h = a(h, r, s, u, e[t + 6], 9, -1069501632), u = a(u, h, r, s, e[t + 11], 14, 643717713), s = a(s, u, h, r, e[t], 20, -373897302), r = a(r, s, u, h, e[t + 5], 5, -701558691), h = a(h, r, s, u, e[t + 10], 9, 38016083), u = a(u, h, r, s, e[t + 15], 14, -660478335), s = a(s, u, h, r, e[t + 4], 20, -405537848), r = a(r, s, u, h, e[t + 9], 5, 568446438), h = a(h, r, s, u, e[t + 14], 9, -1019803690), u = a(u, h, r, s, e[t + 3], 14, -187363961), s = a(s, u, h, r, e[t + 8], 20, 1163531501), r = a(r, s, u, h, e[t + 13], 5, -1444681467), h = a(h, r, s, u, e[t + 2], 9, -51403784), u = a(u, h, r, s, e[t + 7], 14, 1735328473), s = a(s, u, h, r, e[t + 12], 20, -1926607734), r = l(r, s, u, h, e[t + 5], 4, -378558), h = l(h, r, s, u, e[t + 8], 11, -2022574463), u = l(u, h, r, s, e[t + 11], 16, 1839030562), s = l(s, u, h, r, e[t + 14], 23, -35309556), r = l(r, s, u, h, e[t + 1], 4, -1530992060), h = l(h, r, s, u, e[t + 4], 11, 1272893353), u = l(u, h, r, s, e[t + 7], 16, -155497632), s = l(s, u, h, r, e[t + 10], 23, -1094730640), r = l(r, s, u, h, e[t + 13], 4, 681279174), h = l(h, r, s, u, e[t], 11, -358537222), u = l(u, h, r, s, e[t + 3], 16, -722521979), s = l(s, u, h, r, e[t + 6], 23, 76029189), r = l(r, s, u, h, e[t + 9], 4, -640364487), h = l(h, r, s, u, e[t + 12], 11, -421815835), u = l(u, h, r, s, e[t + 15], 16, 530742520), s = l(s, u, h, r, e[t + 2], 23, -995338651), r = c(r, s, u, h, e[t], 6, -198630844), h = c(h, r, s, u, e[t + 7], 10, 1126891415), u = c(u, h, r, s, e[t + 14], 15, -1416354905), s = c(s, u, h, r, e[t + 5], 21, -57434055), r = c(r, s, u, h, e[t + 12], 6, 1700485571), h = c(h, r, s, u, e[t + 3], 10, -1894986606), u = c(u, h, r, s, e[t + 10], 15, -1051523), s = c(s, u, h, r, e[t + 1], 21, -2054922799), r = c(r, s, u, h, e[t + 8], 6, 1873313359), h = c(h, r, s, u, e[t + 15], 10, -30611744), u = c(u, h, r, s, e[t + 6], 15, -1560198380), s = c(s, u, h, r, e[t + 13], 21, 1309151649), r = c(r, s, u, h, e[t + 4], 6, -145523070), h = c(h, r, s, u, e[t + 11], 10, -1120210379), u = c(u, h, r, s, e[t + 2], 15, 718787259), s = c(s, u, h, r, e[t + 9], 21, -343485551), r = i(r, n), s = i(s, f), u = i(u, d), h = i(h, p);
                        }
                        return [
                            r,
                            s,
                            u,
                            h
                        ];
                    }(function(e) {
                        if (0 === e.length) return [];
                        const t = 8 * e.length, r = new Uint32Array(n(t));
                        for(let n = 0; n < t; n += 8)r[n >> 5] |= (255 & e[n / 8]) << n % 32;
                        return r;
                    }(e), 8 * e.length));
                };
                r.default = u;
            },
            {}
        ],
        530: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = "00000000-0000-0000-0000-000000000000";
            },
            {}
        ],
        531: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    let t;
                    const r = new Uint8Array(16);
                    return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        532: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                r.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
            },
            {}
        ],
        533: [
            function(e, t, r) {
                "use strict";
                let n;
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function() {
                    if (!n && (n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto), !n)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return n(i);
                };
                const i = new Uint8Array(16);
            },
            {}
        ],
        534: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r, n) {
                    switch(e){
                        case 0:
                            return t & r ^ ~t & n;
                        case 1:
                            return t ^ r ^ n;
                        case 2:
                            return t & r ^ t & n ^ r & n;
                        case 3:
                            return t ^ r ^ n;
                    }
                }
                function i(e, t) {
                    return e << t | e >>> 32 - t;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var s = function(e) {
                    const t = [
                        1518500249,
                        1859775393,
                        2400959708,
                        3395469782
                    ], r = [
                        1732584193,
                        4023233417,
                        2562383102,
                        271733878,
                        3285377520
                    ];
                    if ("string" == typeof e) {
                        const t = unescape(encodeURIComponent(e));
                        e = [];
                        for(let r = 0; r < t.length; ++r)e.push(t.charCodeAt(r));
                    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
                    e.push(128);
                    const s = e.length / 4 + 2, o = Math.ceil(s / 16), a = new Array(o);
                    for(let t = 0; t < o; ++t){
                        const r = new Uint32Array(16);
                        for(let n = 0; n < 16; ++n)r[n] = e[64 * t + 4 * n] << 24 | e[64 * t + 4 * n + 1] << 16 | e[64 * t + 4 * n + 2] << 8 | e[64 * t + 4 * n + 3];
                        a[t] = r;
                    }
                    a[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = 8 * (e.length - 1) & 4294967295;
                    for(let e = 0; e < o; ++e){
                        const s = new Uint32Array(80);
                        for(let t = 0; t < 16; ++t)s[t] = a[e][t];
                        for(let e = 16; e < 80; ++e)s[e] = i(s[e - 3] ^ s[e - 8] ^ s[e - 14] ^ s[e - 16], 1);
                        let o = r[0], l = r[1], c = r[2], u = r[3], h = r[4];
                        for(let e = 0; e < 80; ++e){
                            const r = Math.floor(e / 20), a = i(o, 5) + n(r, l, c, u) + h + t[r] + s[e] >>> 0;
                            h = u, u = c, c = i(l, 30) >>> 0, l = o, o = a;
                        }
                        r[0] = r[0] + o >>> 0, r[1] = r[1] + l >>> 0, r[2] = r[2] + c >>> 0, r[3] = r[3] + u >>> 0, r[4] = r[4] + h >>> 0;
                    }
                    return [
                        r[0] >> 24 & 255,
                        r[0] >> 16 & 255,
                        r[0] >> 8 & 255,
                        255 & r[0],
                        r[1] >> 24 & 255,
                        r[1] >> 16 & 255,
                        r[1] >> 8 & 255,
                        255 & r[1],
                        r[2] >> 24 & 255,
                        r[2] >> 16 & 255,
                        r[2] >> 8 & 255,
                        255 & r[2],
                        r[3] >> 24 & 255,
                        r[3] >> 16 & 255,
                        r[3] >> 8 & 255,
                        255 & r[3],
                        r[4] >> 24 & 255,
                        r[4] >> 16 & 255,
                        r[4] >> 8 & 255,
                        255 & r[4]
                    ];
                };
                r.default = s;
            },
            {}
        ],
        535: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                const s = [];
                for(let e = 0; e < 256; ++e)s.push((e + 256).toString(16).substr(1));
                var o = function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const r = (s[e[t + 0]] + s[e[t + 1]] + s[e[t + 2]] + s[e[t + 3]] + "-" + s[e[t + 4]] + s[e[t + 5]] + "-" + s[e[t + 6]] + s[e[t + 7]] + "-" + s[e[t + 8]] + s[e[t + 9]] + "-" + s[e[t + 10]] + s[e[t + 11]] + s[e[t + 12]] + s[e[t + 13]] + s[e[t + 14]] + s[e[t + 15]]).toLowerCase();
                    if (!(0, i.default)(r)) throw TypeError("Stringified UUID is invalid");
                    return r;
                };
                r.default = o;
            },
            {
                "./validate.js": 541
            }
        ],
        536: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                let o, a, l = 0, c = 0;
                var u = function(e, t, r) {
                    let s = t && r || 0;
                    const u = t || new Array(16);
                    let h = (e = e || {}).node || o, f = void 0 !== e.clockseq ? e.clockseq : a;
                    if (null == h || null == f) {
                        const t = e.random || (e.rng || n.default)();
                        null == h && (h = o = [
                            1 | t[0],
                            t[1],
                            t[2],
                            t[3],
                            t[4],
                            t[5]
                        ]), null == f && (f = a = 16383 & (t[6] << 8 | t[7]));
                    }
                    let d = void 0 !== e.msecs ? e.msecs : Date.now(), p = void 0 !== e.nsecs ? e.nsecs : c + 1;
                    const m = d - l + (p - c) / 1e4;
                    if (m < 0 && void 0 === e.clockseq && (f = f + 1 & 16383), (m < 0 || d > l) && void 0 === e.nsecs && (p = 0), p >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                    l = d, c = p, a = f, d += 122192928e5;
                    const b = (1e4 * (268435455 & d) + p) % 4294967296;
                    u[s++] = b >>> 24 & 255, u[s++] = b >>> 16 & 255, u[s++] = b >>> 8 & 255, u[s++] = 255 & b;
                    const g = d / 4294967296 * 1e4 & 268435455;
                    u[s++] = g >>> 8 & 255, u[s++] = 255 & g, u[s++] = g >>> 24 & 15 | 16, u[s++] = g >>> 16 & 255, u[s++] = f >>> 8 | 128, u[s++] = 255 & f;
                    for(let e = 0; e < 6; ++e)u[s + e] = h[e];
                    return t || (0, i.default)(u);
                };
                r.default = u;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        537: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./md5.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v3", 48, i.default);
                r.default = o;
            },
            {
                "./md5.js": 529,
                "./v35.js": 538
            }
        ],
        538: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = function(e, t, r) {
                    function s(e, s, o, a) {
                        if ("string" == typeof e && (e = function(e) {
                            e = unescape(encodeURIComponent(e));
                            const t = [];
                            for(let r = 0; r < e.length; ++r)t.push(e.charCodeAt(r));
                            return t;
                        }(e)), "string" == typeof s && (s = (0, i.default)(s)), 16 !== s.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                        let l = new Uint8Array(16 + e.length);
                        if (l.set(s), l.set(e, s.length), l = r(l), l[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, o) {
                            a = a || 0;
                            for(let e = 0; e < 16; ++e)o[a + e] = l[e];
                            return o;
                        }
                        return (0, n.default)(l);
                    }
                    try {
                        s.name = e;
                    } catch (e) {}
                    return s.DNS = o, s.URL = a, s;
                }, r.URL = r.DNS = void 0;
                var n = s(e("./stringify.js")), i = s(e("./parse.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                const o = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
                r.DNS = o;
                const a = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
                r.URL = a;
            },
            {
                "./parse.js": 531,
                "./stringify.js": 535
            }
        ],
        539: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./rng.js")), i = s(e("./stringify.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = function(e, t, r) {
                    const s = (e = e || {}).random || (e.rng || n.default)();
                    if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t) {
                        r = r || 0;
                        for(let e = 0; e < 16; ++e)t[r + e] = s[e];
                        return t;
                    }
                    return (0, i.default)(s);
                };
                r.default = o;
            },
            {
                "./rng.js": 533,
                "./stringify.js": 535
            }
        ],
        540: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n = s(e("./v35.js")), i = s(e("./sha1.js"));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var o = (0, n.default)("v5", 80, i.default);
                r.default = o;
            },
            {
                "./sha1.js": 534,
                "./v35.js": 538
            }
        ],
        541: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./regex.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    return "string" == typeof e && i.default.test(e);
                };
                r.default = s;
            },
            {
                "./regex.js": 532
            }
        ],
        542: [
            function(e, t, r) {
                "use strict";
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.default = void 0;
                var n, i = (n = e("./validate.js")) && n.__esModule ? n : {
                    default: n
                };
                var s = function(e) {
                    if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
                    return parseInt(e.substr(14, 1), 16);
                };
                r.default = s;
            },
            {
                "./validate.js": 541
            }
        ],
        543: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\t\n\r -\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 32 && e <= 55295 || 10 === e || 13 === e || 9 === e || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        544: [
            function(e, t, r) {
                "use strict";
                /**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.CHAR = "\x01-\ud7ff\ue000-\ufffd\ud800\udc00-\udbff\udfff", r.RESTRICTED_CHAR = "\x01-\b\v\f\x0e-\x1f\x7f-\x84\x86-\x9f", r.S = " \t\r\n", r.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NAME_CHAR = "-" + r.NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.CHAR_RE = new RegExp("^[" + r.CHAR + "]$", "u"), r.RESTRICTED_CHAR_RE = new RegExp("^[" + r.RESTRICTED_CHAR + "]$", "u"), r.S_RE = new RegExp("^[" + r.S + "]+$", "u"), r.NAME_START_CHAR_RE = new RegExp("^[" + r.NAME_START_CHAR + "]$", "u"), r.NAME_CHAR_RE = new RegExp("^[" + r.NAME_CHAR + "]$", "u"), r.NAME_RE = new RegExp("^[" + r.NAME_START_CHAR + "][" + r.NAME_CHAR + "]*$", "u"), r.NMTOKEN_RE = new RegExp("^[" + r.NAME_CHAR + "]+$", "u");
                function n(e) {
                    return e >= 65 && e <= 90 || e >= 97 && e <= 122 || 58 === e || 95 === e || 8204 === e || 8205 === e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                r.S_LIST = [
                    32,
                    10,
                    13,
                    9
                ], r.isChar = function(e) {
                    return e >= 1 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isRestrictedChar = function(e) {
                    return e >= 1 && e <= 8 || 11 === e || 12 === e || e >= 14 && e <= 31 || e >= 127 && e <= 132 || e >= 134 && e <= 159;
                }, r.isCharAndNotRestricted = function(e) {
                    return 9 === e || 10 === e || 13 === e || e > 31 && e < 127 || 133 === e || e > 159 && e <= 55295 || e >= 57344 && e <= 65533 || e >= 65536 && e <= 1114111;
                }, r.isS = function(e) {
                    return 32 === e || 10 === e || 13 === e || 9 === e;
                }, r.isNameStartChar = n, r.isNameChar = function(e) {
                    return n(e) || e >= 48 && e <= 57 || 45 === e || 46 === e || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ],
        545: [
            function(e, t, r) {
                "use strict";
                /**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ function n(e) {
                    return e >= 65 && e <= 90 || 95 === e || e >= 97 && e <= 122 || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 767 || e >= 880 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039;
                }
                Object.defineProperty(r, "__esModule", {
                    value: !0
                }), r.NC_NAME_START_CHAR = "A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c-\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd\ud800\udc00-\udb7f\udfff", r.NC_NAME_CHAR = "-" + r.NC_NAME_START_CHAR + ".0-9\xb7\u0300-\u036f\u203f-\u2040", r.NC_NAME_START_CHAR_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "]$", "u"), r.NC_NAME_CHAR_RE = new RegExp("^[" + r.NC_NAME_CHAR + "]$", "u"), r.NC_NAME_RE = new RegExp("^[" + r.NC_NAME_START_CHAR + "][" + r.NC_NAME_CHAR + "]*$", "u"), r.isNCNameStartChar = n, r.isNCNameChar = function(e) {
                    return n(e) || 45 === e || 46 === e || e >= 48 && e <= 57 || 183 === e || e >= 768 && e <= 879 || e >= 8255 && e <= 8256;
                };
            },
            {}
        ]
    }, {}, [
        15
    ])(15);
});

});

parcelRegister("fIMaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $69cce3d6f3058919$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $69cce3d6f3058919$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 8v4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 16h.01",
            "key": "svg-2"
        }
    ]
];
const $69cce3d6f3058919$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "alert-circle", "AlertCircle", $69cce3d6f3058919$export$3efd853dbb351e94);

});
parcelRegister("eednQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $181aa196ec8b5be7$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");

var $5VxIE = parcelRequire("5VxIE");
const $181aa196ec8b5be7$export$2e2bcd8739ae039 = (type, iconName, iconNamePascal, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, stroke: stroke = 2, title: title, className: className, children: children, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
            ref: ref,
            ...(0, $5VxIE.default)[type],
            width: size,
            height: size,
            className: [
                `tabler-icon`,
                `tabler-icon-${iconName}`,
                className
            ].join(" "),
            ...type === "filled" ? {
                fill: color
            } : {
                strokeWidth: stroke,
                stroke: color
            },
            ...rest
        }, [
            title && (0, $acw62.createElement)("title", {
                key: "svg-title"
            }, title),
            ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
            ...Array.isArray(children) ? children : [
                children
            ]
        ]));
    Component.displayName = `${iconNamePascal}`;
    return Component;
};

});
parcelRegister("5VxIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d743109e593438$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $d8d743109e593438$export$2e2bcd8739ae039 = {
    outline: {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    },
    filled: {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "currentColor",
        stroke: "none"
    }
};

});



parcelRegister("34B0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $037771e2cea16f79$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $037771e2cea16f79$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 9v4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 16h.01",
            "key": "svg-2"
        }
    ]
];
const $037771e2cea16f79$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "alert-triangle", "AlertTriangle", $037771e2cea16f79$export$3efd853dbb351e94);

});

parcelRegister("dV30q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0482e975bf988fc4$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $0482e975bf988fc4$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 12l14 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M5 12l6 6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M5 12l6 -6",
            "key": "svg-2"
        }
    ]
];
const $0482e975bf988fc4$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "arrow-left", "ArrowLeft", $0482e975bf988fc4$export$3efd853dbb351e94);

});

parcelRegister("bb5Hu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3af54422f6c64eb1$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $3af54422f6c64eb1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 12l14 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M13 18l6 -6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M13 6l6 6",
            "key": "svg-2"
        }
    ]
];
const $3af54422f6c64eb1$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "arrow-right", "ArrowRight", $3af54422f6c64eb1$export$3efd853dbb351e94);

});

parcelRegister("hlpmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff423d02ff4e5e9$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $9ff423d02ff4e5e9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M16 4l4 0l0 4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M14 10l6 -6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M8 20l-4 0l0 -4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 20l6 -6",
            "key": "svg-3"
        }
    ]
];
const $9ff423d02ff4e5e9$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "arrows-diagonal", "ArrowsDiagonal", $9ff423d02ff4e5e9$export$3efd853dbb351e94);

});

parcelRegister("g3BkA", function(module, exports) {

$parcel$export(module.exports, "default", () => $eed5ae25de153dc8$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $eed5ae25de153dc8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M18 10h-4v-4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M20 4l-6 6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M6 14h4v4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M10 14l-6 6",
            "key": "svg-3"
        }
    ]
];
const $eed5ae25de153dc8$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "arrows-diagonal-minimize-2", "ArrowsDiagonalMinimize2", $eed5ae25de153dc8$export$3efd853dbb351e94);

});

parcelRegister("dQNuR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a30375ccccc1a5ae$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $a30375ccccc1a5ae$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28",
            "key": "svg-1"
        }
    ]
];
const $a30375ccccc1a5ae$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "at", "At", $a30375ccccc1a5ae$export$3efd853dbb351e94);

});

parcelRegister("7xsss", function(module, exports) {

$parcel$export(module.exports, "default", () => $35915e243454ebbf$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $35915e243454ebbf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2",
            "key": "svg-1"
        }
    ]
];
const $35915e243454ebbf$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "box-multiple", "BoxMultiple", $35915e243454ebbf$export$3efd853dbb351e94);

});

parcelRegister("iwBxo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f17b636d6fcd969e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $f17b636d6fcd969e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1",
            "key": "svg-1"
        }
    ]
];
const $f17b636d6fcd969e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "brand-whatsapp", "BrandWhatsapp", $f17b636d6fcd969e$export$3efd853dbb351e94);

});

parcelRegister("gxhlI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5d14c08e227c3d3$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $a5d14c08e227c3d3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 5l0 -2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M17 7l1.4 -1.4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19 12l2 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M17 17l1.4 1.4",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M12 19l0 2",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M7 17l-1.4 1.4",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M6 12l-2 0",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M7 7l-1.4 -1.4",
            "key": "svg-8"
        }
    ]
];
const $a5d14c08e227c3d3$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "brightness-up", "BrightnessUp", $a5d14c08e227c3d3$export$3efd853dbb351e94);

});

parcelRegister("gsgdS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d962ad3ca4120acd$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $d962ad3ca4120acd$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16 3v4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M8 3v4",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M4 11h16",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M11 15h1",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M12 15v3",
            "key": "svg-5"
        }
    ]
];
const $d962ad3ca4120acd$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "calendar", "Calendar", $d962ad3ca4120acd$export$3efd853dbb351e94);

});

parcelRegister("3US3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a9488e46dc26332$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $4a9488e46dc26332$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 12l5 5l10 -10",
            "key": "svg-0"
        }
    ]
];
const $4a9488e46dc26332$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "check", "Check", $4a9488e46dc26332$export$3efd853dbb351e94);

});

parcelRegister("4Rwq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b71840fd031867d$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $4b71840fd031867d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 12l2 2l4 -4",
            "key": "svg-1"
        }
    ]
];
const $4b71840fd031867d$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "circle-check", "CircleCheck", $4b71840fd031867d$export$3efd853dbb351e94);

});

parcelRegister("1MBwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b14045860394729c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $b14045860394729c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
            "key": "svg-0"
        }
    ]
];
const $b14045860394729c$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "circle-check-filled", "CircleCheckFilled", $b14045860394729c$export$3efd853dbb351e94);

});

parcelRegister("iHvby", function(module, exports) {

$parcel$export(module.exports, "default", () => $d03715c5b037c0a8$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $d03715c5b037c0a8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M8.56 20.31a9 9 0 0 0 3.44 .69",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M9 12l2 2l4 -4",
            "key": "svg-8"
        }
    ]
];
const $d03715c5b037c0a8$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "circle-dashed-check", "CircleDashedCheck", $d03715c5b037c0a8$export$3efd853dbb351e94);

});

parcelRegister("9WB3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $422ea4b6bed9c731$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $422ea4b6bed9c731$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M10 10l2 -2v8",
            "key": "svg-1"
        }
    ]
];
const $422ea4b6bed9c731$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "circle-number-1", "CircleNumber1", $422ea4b6bed9c731$export$3efd853dbb351e94);

});

parcelRegister("70jvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b7b25551e2bd881$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $0b7b25551e2bd881$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3",
            "key": "svg-1"
        }
    ]
];
const $0b7b25551e2bd881$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "circle-number-2", "CircleNumber2", $0b7b25551e2bd881$export$3efd853dbb351e94);

});

parcelRegister("dRw7S", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bbcd40711da5851$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $3bbcd40711da5851$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M10 10l4 4m0 -4l-4 4",
            "key": "svg-1"
        }
    ]
];
const $3bbcd40711da5851$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "circle-x", "CircleX", $3bbcd40711da5851$export$3efd853dbb351e94);

});

parcelRegister("bPGo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b15ba6d9698402f6$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $b15ba6d9698402f6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 7v5l3 3",
            "key": "svg-1"
        }
    ]
];
const $b15ba6d9698402f6$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "clock", "Clock", $b15ba6d9698402f6$export$3efd853dbb351e94);

});

parcelRegister("aUMvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $589fff77c3b7a17c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $589fff77c3b7a17c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 15l3 -3l3 3",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 12l0 9",
            "key": "svg-2"
        }
    ]
];
const $589fff77c3b7a17c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "cloud-upload", "CloudUpload", $589fff77c3b7a17c$export$3efd853dbb351e94);

});

parcelRegister("jKnNH", function(module, exports) {

$parcel$export(module.exports, "default", () => $10e21d0411f05439$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $10e21d0411f05439$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M13.58 13.79c.27 .68 .42 1.43 .42 2.21c0 1.77 -.77 3.37 -2 4.46a5.93 5.93 0 0 1 -4 1.54c-3.31 0 -6 -2.69 -6 -6c0 -2.76 1.88 -5.1 4.42 -5.79",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M17.58 10.21c2.54 .69 4.42 3.03 4.42 5.79c0 3.31 -2.69 6 -6 6a5.93 5.93 0 0 1 -4 -1.54",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 8m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0",
            "key": "svg-2"
        }
    ]
];
const $10e21d0411f05439$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "color-filter", "ColorFilter", $10e21d0411f05439$export$3efd853dbb351e94);

});

parcelRegister("ho6bO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f6554b5714315af$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $9f6554b5714315af$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M11 7l6 6",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z",
            "key": "svg-1"
        }
    ]
];
const $9f6554b5714315af$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "color-picker", "ColorPicker", $9f6554b5714315af$export$3efd853dbb351e94);

});

parcelRegister("3s7Bt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e8b0e2c39987915$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $9e8b0e2c39987915$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 17a5 5 0 0 0 0 -10v10",
            "key": "svg-1"
        }
    ]
];
const $9e8b0e2c39987915$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "contrast", "Contrast", $9e8b0e2c39987915$export$3efd853dbb351e94);

});

parcelRegister("8mEM1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9e41480ab872646$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e9e41480ab872646$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1",
            "key": "svg-1"
        }
    ]
];
const $e9e41480ab872646$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "copy", "Copy", $e9e41480ab872646$export$3efd853dbb351e94);

});

parcelRegister("hi1Sd", function(module, exports) {

$parcel$export(module.exports, "default", () => $89d18c8a448881bf$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $89d18c8a448881bf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 5v10a1 1 0 0 0 1 1h10",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M5 8h10a1 1 0 0 1 1 1v10",
            "key": "svg-1"
        }
    ]
];
const $89d18c8a448881bf$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "crop", "Crop", $89d18c8a448881bf$export$3efd853dbb351e94);

});

parcelRegister("vjSkT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd69e2438ce7563c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $dd69e2438ce7563c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M7 11l5 5l5 -5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 4l0 12",
            "key": "svg-2"
        }
    ]
];
const $dd69e2438ce7563c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "download", "Download", $dd69e2438ce7563c$export$3efd853dbb351e94);

});

parcelRegister("gzKDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e54ed591be49059$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $4e54ed591be49059$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M13.905 2.923l.098 .135l4.92 7.306a7.566 7.566 0 0 1 1.043 3.167l.024 .326c.007 .047 .01 .094 .01 .143l-.002 .06c.056 2.3 -.944 4.582 -2.87 6.14c-2.969 2.402 -7.286 2.402 -10.255 0c-1.904 -1.54 -2.904 -3.787 -2.865 -6.071a1.052 1.052 0 0 1 .013 -.333a7.66 7.66 0 0 1 .913 -3.176l.172 -.302l4.893 -7.26c.185 -.275 .426 -.509 .709 -.686c1.055 -.66 2.446 -.413 3.197 .55zm-2.06 1.107l-.077 .038l-.041 .03l-.037 .036l-.033 .042l-4.863 7.214a5.607 5.607 0 0 0 -.651 1.61h11.723a5.444 5.444 0 0 0 -.49 -1.313l-.141 -.251l-4.891 -7.261a.428 .428 0 0 0 -.5 -.145z",
            "key": "svg-0"
        }
    ]
];
const $4e54ed591be49059$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "droplet-half-2-filled", "DropletHalf2Filled", $4e54ed591be49059$export$3efd853dbb351e94);

});

parcelRegister("jni2H", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06cbbc181c2e81a$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e06cbbc181c2e81a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6",
            "key": "svg-1"
        }
    ]
];
const $e06cbbc181c2e81a$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "eye", "Eye", $e06cbbc181c2e81a$export$3efd853dbb351e94);

});

parcelRegister("iVS9b", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f1e74cfec9c1c6b$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $0f1e74cfec9c1c6b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 15.5v1.5",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 21v1.5",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M22.032 17.25l-1.299 .75",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M17.27 20l-1.3 .75",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M15.97 17.25l1.3 .75",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M20.733 20l1.3 .75",
            "key": "svg-8"
        }
    ]
];
const $0f1e74cfec9c1c6b$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "eye-cog", "EyeCog", $0f1e74cfec9c1c6b$export$3efd853dbb351e94);

});

parcelRegister("cYYbE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca71fa4fbce218de$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $ca71fa4fbce218de$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10.585 10.587a2 2 0 0 0 2.829 2.828",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M3 3l18 18",
            "key": "svg-2"
        }
    ]
];
const $ca71fa4fbce218de$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "eye-off", "EyeOff", $ca71fa4fbce218de$export$3efd853dbb351e94);

});

parcelRegister("1bItm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f75ab09cbb91ff8$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $2f75ab09cbb91ff8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M14 3v4a1 1 0 0 0 1 1h4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M17 18h2",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M20 15h-3v6",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z",
            "key": "svg-5"
        }
    ]
];
const $2f75ab09cbb91ff8$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "file-type-pdf", "FileTypePdf", $2f75ab09cbb91ff8$export$3efd853dbb351e94);

});

parcelRegister("frYZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $83d466f6bda1596d$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $83d466f6bda1596d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z",
            "key": "svg-0"
        }
    ]
];
const $83d466f6bda1596d$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "filter", "Filter", $83d466f6bda1596d$export$3efd853dbb351e94);

});

parcelRegister("cvMwO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c35f3d42f51a287$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $5c35f3d42f51a287$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 4h12v2.172a2 2 0 0 1 -.586 1.414l-3.914 3.914m-.5 3.5v4l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 3l18 18",
            "key": "svg-1"
        }
    ]
];
const $5c35f3d42f51a287$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "filter-off", "FilterOff", $5c35f3d42f51a287$export$3efd853dbb351e94);

});

parcelRegister("1a7g8", function(module, exports) {

$parcel$export(module.exports, "default", () => $af30a06ea73f1464$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $af30a06ea73f1464$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M5 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M19 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-8"
        }
    ]
];
const $af30a06ea73f1464$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "grid-dots", "GridDots", $af30a06ea73f1464$export$3efd853dbb351e94);

});

parcelRegister("kytQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5138880b1d7b4d$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $0b5138880b1d7b4d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 17l0 .01",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4",
            "key": "svg-2"
        }
    ]
];
const $0b5138880b1d7b4d$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "help", "Help", $0b5138880b1d7b4d$export$3efd853dbb351e94);

});

parcelRegister("hMS14", function(module, exports) {

$parcel$export(module.exports, "default", () => $f832183a6234cc8b$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $f832183a6234cc8b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 17v.01",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 13.5a1.5 1.5 0 0 1 .394 -1.1m2.106 -1.9a2.6 2.6 0 0 0 -3.347 -3.361",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M3 3l18 18",
            "key": "svg-3"
        }
    ]
];
const $f832183a6234cc8b$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "help-off", "HelpOff", $f832183a6234cc8b$export$3efd853dbb351e94);

});

parcelRegister("bLAHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $610cfdb0f66ea693$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $610cfdb0f66ea693$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 8l2 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M15 12l2 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M7 16l10 0",
            "key": "svg-4"
        }
    ]
];
const $610cfdb0f66ea693$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "id", "Id", $610cfdb0f66ea693$export$3efd853dbb351e94);

});

parcelRegister("1YbUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $63afdcdd8d7e733c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $63afdcdd8d7e733c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M12 9h.01",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M11 12h1v4h1",
            "key": "svg-2"
        }
    ]
];
const $63afdcdd8d7e733c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "info-circle", "InfoCircle", $63afdcdd8d7e733c$export$3efd853dbb351e94);

});

parcelRegister("6HZkq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee21a0d6b570b06a$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $ee21a0d6b570b06a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3.5 5.5l1.5 1.5l2.5 -2.5",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3.5 11.5l1.5 1.5l2.5 -2.5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M3.5 17.5l1.5 1.5l2.5 -2.5",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M11 6l9 0",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M11 12l9 0",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M11 18l9 0",
            "key": "svg-5"
        }
    ]
];
const $ee21a0d6b570b06a$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "list-check", "ListCheck", $ee21a0d6b570b06a$export$3efd853dbb351e94);

});

parcelRegister("anH21", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad6154bd3fb278a$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $8ad6154bd3fb278a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 7l9 6l9 -6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 19l2 2l4 -4",
            "key": "svg-2"
        }
    ]
];
const $8ad6154bd3fb278a$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "mail-check", "MailCheck", $8ad6154bd3fb278a$export$3efd853dbb351e94);

});

parcelRegister("gt7Cd", function(module, exports) {

$parcel$export(module.exports, "default", () => $094776ded673fec1$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $094776ded673fec1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 7l9 6l9 -6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 15.5v1.5",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M19.001 21v1.5",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M22.032 17.25l-1.299 .75",
            "key": "svg-5"
        }
    ],
    [
        "path",
        {
            "d": "M17.27 20l-1.3 .75",
            "key": "svg-6"
        }
    ],
    [
        "path",
        {
            "d": "M15.97 17.25l1.3 .75",
            "key": "svg-7"
        }
    ],
    [
        "path",
        {
            "d": "M20.733 20l1.3 .75",
            "key": "svg-8"
        }
    ]
];
const $094776ded673fec1$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "mail-cog", "MailCog", $094776ded673fec1$export$3efd853dbb351e94);

});

parcelRegister("8YQDN", function(module, exports) {

$parcel$export(module.exports, "default", () => $29da31371ab5b569$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $29da31371ab5b569$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 4v13",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 7v13",
            "key": "svg-2"
        }
    ]
];
const $29da31371ab5b569$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "map", "Map", $29da31371ab5b569$export$3efd853dbb351e94);

});

parcelRegister("eae64", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc8b43918fc714c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $ddc8b43918fc714c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z",
            "key": "svg-1"
        }
    ]
];
const $ddc8b43918fc714c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "map-pin", "MapPin", $ddc8b43918fc714c$export$3efd853dbb351e94);

});

parcelRegister("jBKnG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0901e946d62636e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $f0901e946d62636e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M13.5 6.5l4 4",
            "key": "svg-1"
        }
    ]
];
const $f0901e946d62636e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "pencil", "Pencil", $f0901e946d62636e$export$3efd853dbb351e94);

});

parcelRegister("jGUpw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b017b246bbc30$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $fc7b017b246bbc30$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2c-8.072 -.49 -14.51 -6.928 -15 -15a2 2 0 0 1 2 -2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M15 5h6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M18.5 7.5l2.5 -2.5l-2.5 -2.5",
            "key": "svg-2"
        }
    ]
];
const $fc7b017b246bbc30$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "phone-outgoing", "PhoneOutgoing", $fc7b017b246bbc30$export$3efd853dbb351e94);

});

parcelRegister("bfsRj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3fd79dc88216e9c$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $f3fd79dc88216e9c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M15 8h.01",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3",
            "key": "svg-3"
        }
    ]
];
const $f3fd79dc88216e9c$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "photo", "Photo", $f3fd79dc88216e9c$export$3efd853dbb351e94);

});

parcelRegister("e2M7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd44a156c4598cd$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $6fd44a156c4598cd$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M20 4v5h-5",
            "key": "svg-1"
        }
    ]
];
const $6fd44a156c4598cd$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "reload", "Reload", $6fd44a156c4598cd$export$3efd853dbb351e94);

});

parcelRegister("grSkg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42daeb45c058fbf$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $f42daeb45c058fbf$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3.06 13a9 9 0 1 0 .49 -4.087",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 4.001v5h5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0",
            "key": "svg-2"
        }
    ]
];
const $f42daeb45c058fbf$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "restore", "Restore", $f42daeb45c058fbf$export$3efd853dbb351e94);

});

parcelRegister("li55Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $9658ab2aa0ee629d$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $9658ab2aa0ee629d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M21 21l-6 -6",
            "key": "svg-1"
        }
    ]
];
const $9658ab2aa0ee629d$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "search", "Search", $9658ab2aa0ee629d$export$3efd853dbb351e94);

});

parcelRegister("ab9C8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cea9df16c03700e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $7cea9df16c03700e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M8 9l4 -4l4 4",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M16 15l-4 4l-4 -4",
            "key": "svg-1"
        }
    ]
];
const $7cea9df16c03700e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "selector", "Selector", $7cea9df16c03700e$export$3efd853dbb351e94);

});

parcelRegister("g12Xg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab03bfc40efd047e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $ab03bfc40efd047e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12.578 20.905c-.88 .299 -1.983 -.109 -2.253 -1.222a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.574 .14 .96 .5 1.16 .937",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M14.99 12.256a3 3 0 1 0 -2.33 2.671",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M19 18v.01",
            "key": "svg-3"
        }
    ]
];
const $ab03bfc40efd047e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "settings-pin", "SettingsPin", $ab03bfc40efd047e$export$3efd853dbb351e94);

});

parcelRegister("1rkHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5097c41dbfe6b62b$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $5097c41dbfe6b62b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M9 12l2 2l4 -4",
            "key": "svg-1"
        }
    ]
];
const $5097c41dbfe6b62b$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "square-check", "SquareCheck", $5097c41dbfe6b62b$export$3efd853dbb351e94);

});

parcelRegister("3an6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $97464e8d5e42ee4d$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $97464e8d5e42ee4d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.626 7.293a1 1 0 0 0 -1.414 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
            "key": "svg-0"
        }
    ]
];
const $97464e8d5e42ee4d$export$2e2bcd8739ae039 = (0, $eednQ.default)("filled", "square-check-filled", "SquareCheckFilled", $97464e8d5e42ee4d$export$3efd853dbb351e94);

});

parcelRegister("eyDPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c36da6f0852bd445$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $c36da6f0852bd445$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 7l16 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M10 11l0 6",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M14 11l0 6",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3",
            "key": "svg-4"
        }
    ]
];
const $c36da6f0852bd445$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "trash", "Trash", $c36da6f0852bd445$export$3efd853dbb351e94);

});

parcelRegister("9Q2Ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $75163d918a4751c9$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $75163d918a4751c9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M7 9l5 -5l5 5",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M12 4l0 12",
            "key": "svg-2"
        }
    ]
];
const $75163d918a4751c9$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "upload", "Upload", $75163d918a4751c9$export$3efd853dbb351e94);

});

parcelRegister("22CZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb62a0a284d0c35d$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $cb62a0a284d0c35d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M16 3.13a4 4 0 0 1 0 7.75",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M21 21v-2a4 4 0 0 0 -3 -3.85",
            "key": "svg-3"
        }
    ]
];
const $cb62a0a284d0c35d$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "users", "Users", $cb62a0a284d0c35d$export$3efd853dbb351e94);

});

parcelRegister("54kyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $736f2a65dc9901ed$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $736f2a65dc9901ed$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M17 10h2a2 2 0 0 1 2 2v1",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
            "key": "svg-4"
        }
    ],
    [
        "path",
        {
            "d": "M3 13v-1a2 2 0 0 1 2 -2h2",
            "key": "svg-5"
        }
    ]
];
const $736f2a65dc9901ed$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "users-group", "UsersGroup", $736f2a65dc9901ed$export$3efd853dbb351e94);

});

parcelRegister("lLqe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fefabedc0f2ae4e$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $1fefabedc0f2ae4e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3.6 9h16.8",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M3.6 15h16.8",
            "key": "svg-2"
        }
    ],
    [
        "path",
        {
            "d": "M11.5 3a17 17 0 0 0 0 18",
            "key": "svg-3"
        }
    ],
    [
        "path",
        {
            "d": "M12.5 3a17 17 0 0 1 0 18",
            "key": "svg-4"
        }
    ]
];
const $1fefabedc0f2ae4e$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "world", "World", $1fefabedc0f2ae4e$export$3efd853dbb351e94);

});

parcelRegister("gv5JH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8920a99eb651813$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $d8920a99eb651813$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M18 6l-12 12",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M6 6l12 12",
            "key": "svg-1"
        }
    ]
];
const $d8920a99eb651813$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "x", "X", $d8920a99eb651813$export$3efd853dbb351e94);

});

parcelRegister("cqdgS", function(module, exports) {

$parcel$export(module.exports, "useClipboard", () => $90b235201a4fdd8f$export$2314ca2a3e892862);

var $acw62 = parcelRequire("acw62");
function $90b235201a4fdd8f$export$2314ca2a3e892862({ timeout: timeout = 2e3 } = {}) {
    const [error, setError] = (0, $acw62.useState)(null);
    const [copied, setCopied] = (0, $acw62.useState)(false);
    const [copyTimeout, setCopyTimeout] = (0, $acw62.useState)(null);
    const handleCopyResult = (value)=>{
        clearTimeout(copyTimeout);
        setCopyTimeout(setTimeout(()=>setCopied(false), timeout));
        setCopied(value);
    };
    const copy = (valueToCopy)=>{
        if ("clipboard" in navigator) navigator.clipboard.writeText(valueToCopy).then(()=>handleCopyResult(true)).catch((err)=>setError(err));
        else setError(new Error("useClipboard: navigator.clipboard is not supported"));
    };
    const reset = ()=>{
        setCopied(false);
        setError(null);
        clearTimeout(copyTimeout);
    };
    return {
        copy: copy,
        reset: reset,
        error: error,
        copied: copied
    };
}

});

parcelRegister("1YFpC", function(module, exports) {

$parcel$export(module.exports, "useDebouncedState", () => $170b84a5c3a1053d$export$16cf030511f87c6b);

var $acw62 = parcelRequire("acw62");
function $170b84a5c3a1053d$export$16cf030511f87c6b(defaultValue, wait, options = {
    leading: false
}) {
    const [value, setValue] = (0, $acw62.useState)(defaultValue);
    const timeoutRef = (0, $acw62.useRef)(null);
    const leadingRef = (0, $acw62.useRef)(true);
    const clearTimeout = ()=>window.clearTimeout(timeoutRef.current);
    (0, $acw62.useEffect)(()=>clearTimeout, []);
    const debouncedSetValue = (newValue)=>{
        clearTimeout();
        if (leadingRef.current && options.leading) setValue(newValue);
        else timeoutRef.current = window.setTimeout(()=>{
            leadingRef.current = true;
            setValue(newValue);
        }, wait);
        leadingRef.current = false;
    };
    return [
        value,
        debouncedSetValue
    ];
}

});

parcelRegister("eJ0gu", function(module, exports) {

$parcel$export(module.exports, "useViewportSize", () => $ab857940a9760ee4$export$d699905dd57c73ca);

var $acw62 = parcelRequire("acw62");

var $dmiju = parcelRequire("dmiju");
const $ab857940a9760ee4$var$eventListerOptions = {
    passive: true
};
function $ab857940a9760ee4$export$d699905dd57c73ca() {
    const [windowSize, setWindowSize] = (0, $acw62.useState)({
        width: 0,
        height: 0
    });
    const setSize = (0, $acw62.useCallback)(()=>{
        setWindowSize({
            width: window.innerWidth || 0,
            height: window.innerHeight || 0
        });
    }, []);
    (0, $dmiju.useWindowEvent)("resize", setSize, $ab857940a9760ee4$var$eventListerOptions);
    (0, $dmiju.useWindowEvent)("orientationchange", setSize, $ab857940a9760ee4$var$eventListerOptions);
    (0, $acw62.useEffect)(setSize, []);
    return windowSize;
}

});

parcelRegister("eM8d1", function(module, exports) {

$parcel$export(module.exports, "Prism", () => $02c6a4d0b45f984c$export$dc7257ffb0972f87);

var $hUms8 = parcelRequire("hUms8");

var $bi1pq = parcelRequire("bi1pq");

var $iN6fJ = parcelRequire("iN6fJ");
const $02c6a4d0b45f984c$export$dc7257ffb0972f87 = (0, $iN6fJ.Prism);
$02c6a4d0b45f984c$export$dc7257ffb0972f87.Tabs = (0, $bi1pq.PrismTabs);
$02c6a4d0b45f984c$export$dc7257ffb0972f87.Tab = (0, $hUms8.Tabs).Tab;
$02c6a4d0b45f984c$export$dc7257ffb0972f87.TabsList = (0, $hUms8.Tabs).List;
$02c6a4d0b45f984c$export$dc7257ffb0972f87.Panel = (0, $bi1pq.PrismPanel);

});
parcelRegister("bi1pq", function(module, exports) {

$parcel$export(module.exports, "PrismTabs", () => $838277f1aa6ea840$export$ce7c8f15ea9a4146);
$parcel$export(module.exports, "PrismPanel", () => $838277f1aa6ea840$export$37e1f970de18d1e4);

var $acw62 = parcelRequire("acw62");

var $hUms8 = parcelRequire("hUms8");

var $iN6fJ = parcelRequire("iN6fJ");

var $uShn9 = parcelRequire("uShn9");
var $838277f1aa6ea840$var$__defProp = Object.defineProperty;
var $838277f1aa6ea840$var$__defProps = Object.defineProperties;
var $838277f1aa6ea840$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $838277f1aa6ea840$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $838277f1aa6ea840$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $838277f1aa6ea840$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $838277f1aa6ea840$var$__defNormalProp = (obj, key, value)=>key in obj ? $838277f1aa6ea840$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $838277f1aa6ea840$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($838277f1aa6ea840$var$__hasOwnProp.call(b, prop)) $838277f1aa6ea840$var$__defNormalProp(a, prop, b[prop]);
    if ($838277f1aa6ea840$var$__getOwnPropSymbols) {
        for (var prop of $838277f1aa6ea840$var$__getOwnPropSymbols(b))if ($838277f1aa6ea840$var$__propIsEnum.call(b, prop)) $838277f1aa6ea840$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $838277f1aa6ea840$var$__spreadProps = (a, b)=>$838277f1aa6ea840$var$__defProps(a, $838277f1aa6ea840$var$__getOwnPropDescs(b));
var $838277f1aa6ea840$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($838277f1aa6ea840$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $838277f1aa6ea840$var$__getOwnPropSymbols) {
        for (var prop of $838277f1aa6ea840$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $838277f1aa6ea840$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $838277f1aa6ea840$export$ce7c8f15ea9a4146(props) {
    const { classes: classes } = (0, $uShn9.default)({
        radius: props.radius
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hUms8.Tabs), $838277f1aa6ea840$var$__spreadProps($838277f1aa6ea840$var$__spreadValues({}, props), {
        variant: "outline",
        classNames: {
            tab: classes.tab
        },
        translate: "no"
    }));
}
function $838277f1aa6ea840$export$37e1f970de18d1e4(_a) {
    var _b = _a, { language: language, children: children, radius: radius, noCopy: noCopy, copyLabel: copyLabel, copiedLabel: copiedLabel, withLineNumbers: withLineNumbers, highlightLines: highlightLines, scrollAreaComponent: scrollAreaComponent, trim: trim, getPrismTheme: getPrismTheme, colorScheme: colorScheme, variant: variant } = _b, others = $838277f1aa6ea840$var$__objRest(_b, [
        "language",
        "children",
        "radius",
        "noCopy",
        "copyLabel",
        "copiedLabel",
        "withLineNumbers",
        "highlightLines",
        "scrollAreaComponent",
        "trim",
        "getPrismTheme",
        "colorScheme",
        "variant"
    ]);
    const { classes: classes } = (0, $uShn9.default)({
        radius: radius
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hUms8.Tabs).Panel, $838277f1aa6ea840$var$__spreadValues({}, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iN6fJ.Prism), {
        language: language,
        classNames: {
            root: classes.prism,
            code: classes.code
        },
        radius: radius,
        noCopy: noCopy,
        copyLabel: copyLabel,
        copiedLabel: copiedLabel,
        withLineNumbers: withLineNumbers,
        highlightLines: highlightLines,
        scrollAreaComponent: scrollAreaComponent,
        trim: trim,
        getPrismTheme: getPrismTheme,
        colorScheme: colorScheme,
        variant: variant
    }, children));
}

});
parcelRegister("iN6fJ", function(module, exports) {

$parcel$export(module.exports, "Prism", () => $dae1a74864bd786e$export$dc7257ffb0972f87);

var $acw62 = parcelRequire("acw62");

var $1s0up = parcelRequire("1s0up");

var $crMIh = parcelRequire("crMIh");
var $hiiR1 = parcelRequire("hiiR1");
var $5Eq0L = parcelRequire("5Eq0L");
var $60Ffz = parcelRequire("60Ffz");
var $64A2P = parcelRequire("64A2P");

var $cqdgS = parcelRequire("cqdgS");

var $4OdfS = parcelRequire("4OdfS");

var $hsLTx = parcelRequire("hsLTx");

var $lK1gV = parcelRequire("lK1gV");
var $dae1a74864bd786e$var$__defProp = Object.defineProperty;
var $dae1a74864bd786e$var$__defProps = Object.defineProperties;
var $dae1a74864bd786e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $dae1a74864bd786e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $dae1a74864bd786e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $dae1a74864bd786e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $dae1a74864bd786e$var$__defNormalProp = (obj, key, value)=>key in obj ? $dae1a74864bd786e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $dae1a74864bd786e$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($dae1a74864bd786e$var$__hasOwnProp.call(b, prop)) $dae1a74864bd786e$var$__defNormalProp(a, prop, b[prop]);
    if ($dae1a74864bd786e$var$__getOwnPropSymbols) {
        for (var prop of $dae1a74864bd786e$var$__getOwnPropSymbols(b))if ($dae1a74864bd786e$var$__propIsEnum.call(b, prop)) $dae1a74864bd786e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $dae1a74864bd786e$var$__spreadProps = (a, b)=>$dae1a74864bd786e$var$__defProps(a, $dae1a74864bd786e$var$__getOwnPropDescs(b));
var $dae1a74864bd786e$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($dae1a74864bd786e$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $dae1a74864bd786e$var$__getOwnPropSymbols) {
        for (var prop of $dae1a74864bd786e$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $dae1a74864bd786e$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $dae1a74864bd786e$var$prismDefaultProps = {
    noCopy: false,
    copyLabel: "Copy code",
    copiedLabel: "Copied",
    withLineNumbers: false,
    trim: true,
    highlightLines: {},
    scrollAreaComponent: (0, $5Eq0L.ScrollArea),
    getPrismTheme: (0, $hsLTx.getPrismTheme)
};
const $dae1a74864bd786e$export$dc7257ffb0972f87 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Prism", $dae1a74864bd786e$var$prismDefaultProps, props), { className: className, children: children, language: language, noCopy: noCopy, classNames: classNames, styles: styles, copyLabel: copyLabel, copiedLabel: copiedLabel, withLineNumbers: withLineNumbers, highlightLines: highlightLines, scrollAreaComponent: ScrollAreaComponent, colorScheme: colorScheme, trim: trim, unstyled: unstyled, radius: radius, getPrismTheme: getPrismTheme, variant: variant } = _a, others = $dae1a74864bd786e$var$__objRest(_a, [
        "className",
        "children",
        "language",
        "noCopy",
        "classNames",
        "styles",
        "copyLabel",
        "copiedLabel",
        "withLineNumbers",
        "highlightLines",
        "scrollAreaComponent",
        "colorScheme",
        "trim",
        "unstyled",
        "radius",
        "getPrismTheme",
        "variant"
    ]);
    const code = trim && typeof children === "string" ? children.trim() : children;
    const maxLineSize = code.split("\n").length.toString().length;
    const theme = (0, $64A2P.useMantineTheme)();
    const clipboard = (0, $cqdgS.useClipboard)();
    const _colorScheme = colorScheme || theme.colorScheme;
    const { classes: classes, cx: cx } = (0, $lK1gV.default)({
        colorScheme: _colorScheme,
        native: ScrollAreaComponent !== (0, $5Eq0L.ScrollArea),
        maxLineSize: maxLineSize,
        radius: radius
    }, {
        name: "Prism",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $dae1a74864bd786e$var$__spreadProps($dae1a74864bd786e$var$__spreadValues({
        className: cx(classes.root, className),
        ref: ref
    }, others), {
        translate: "no"
    }), !noCopy && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $60Ffz.Tooltip), {
        label: clipboard.copied ? copiedLabel : copyLabel,
        position: "left",
        withArrow: true,
        arrowSize: 6,
        offset: 6,
        color: clipboard.copied ? "teal" : void 0,
        unstyled: unstyled
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $crMIh.ActionIcon), {
        className: classes.copy,
        "aria-label": clipboard.copied ? copiedLabel : copyLabel,
        onClick: ()=>clipboard.copy(code),
        unstyled: unstyled
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4OdfS.CopyIcon), {
        copied: clipboard.copied
    }))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1s0up.default), $dae1a74864bd786e$var$__spreadProps($dae1a74864bd786e$var$__spreadValues({}, (0, $1s0up.defaultProps)), {
        theme: getPrismTheme(theme, _colorScheme),
        code: code,
        language: language
    }), ({ className: inheritedClassName, style: inheritedStyle, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ScrollAreaComponent, {
            className: classes.scrollArea,
            dir: "ltr"
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", {
            className: cx(classes.code, inheritedClassName),
            style: inheritedStyle,
            dir: "ltr"
        }, tokens.map((line, index)=>{
            var _a2, _b, _c, _d;
            if (index === tokens.length - 1 && line.length === 1 && line[0].content === "\n") return null;
            const lineNumber = index + 1;
            const lineProps = getLineProps({
                line: line,
                key: index
            });
            const shouldHighlight = lineNumber in highlightLines;
            const lineColor = _colorScheme === "dark" ? theme.fn.rgba(theme.fn.themeColor((_a2 = highlightLines[lineNumber]) == null ? void 0 : _a2.color, 9), 0.25) : theme.fn.themeColor((_b = highlightLines[lineNumber]) == null ? void 0 : _b.color, 0);
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $dae1a74864bd786e$var$__spreadProps($dae1a74864bd786e$var$__spreadValues({}, lineProps), {
                className: cx(classes.line, lineProps.className),
                style: $dae1a74864bd786e$var$__spreadValues({}, shouldHighlight ? {
                    backgroundColor: lineColor
                } : null)
            }), withLineNumbers && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: classes.lineNumber,
                style: {
                    color: shouldHighlight ? theme.fn.themeColor((_c = highlightLines[lineNumber]) == null ? void 0 : _c.color, _colorScheme === "dark" ? 5 : 8) : void 0
                }
            }, ((_d = highlightLines[lineNumber]) == null ? void 0 : _d.label) || lineNumber), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: classes.lineContent
            }, line.map((token, key)=>{
                var _a3, _b2;
                const tokenProps = getTokenProps({
                    token: token,
                    key: key
                });
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $dae1a74864bd786e$var$__spreadProps($dae1a74864bd786e$var$__spreadValues({}, tokenProps), {
                    style: $dae1a74864bd786e$var$__spreadProps($dae1a74864bd786e$var$__spreadValues({}, tokenProps.style), {
                        color: shouldHighlight ? theme.fn.themeColor((_a3 = highlightLines[lineNumber]) == null ? void 0 : _a3.color, _colorScheme === "dark" ? 5 : 8) : (_b2 = tokenProps == null ? void 0 : tokenProps.style) == null ? void 0 : _b2.color
                    })
                }));
            })));
        }).filter(Boolean)))));
});
$dae1a74864bd786e$export$dc7257ffb0972f87.displayName = "@mantine/prism/Prism";

});
parcelRegister("1s0up", function(module, exports) {

$parcel$export(module.exports, "defaultProps", () => $10e8c925670af39c$export$9c21a3269931e1e6);
$parcel$export(module.exports, "default", () => $10e8c925670af39c$export$2e2bcd8739ae039);

var $eUOxI = parcelRequire("eUOxI");

var $iKJLP = parcelRequire("iKJLP");

var $acw62 = parcelRequire("acw62");
var $10e8c925670af39c$export$9c21a3269931e1e6 = {
    // $FlowFixMe
    Prism: (0, $eUOxI.default),
    theme: (0, $iKJLP.default)
};
function $10e8c925670af39c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $10e8c925670af39c$var$_extends() {
    $10e8c925670af39c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $10e8c925670af39c$var$_extends.apply(this, arguments);
}
var $10e8c925670af39c$var$newlineRe = /\r\n|\r|\n/; // Empty lines need to contain a single empty token, denoted with { empty: true }
var $10e8c925670af39c$var$normalizeEmptyLines = function(line) {
    if (line.length === 0) line.push({
        types: [
            "plain"
        ],
        content: "\n",
        empty: true
    });
    else if (line.length === 1 && line[0].content === "") {
        line[0].content = "\n";
        line[0].empty = true;
    }
};
var $10e8c925670af39c$var$appendTypes = function(types, add) {
    var typesSize = types.length;
    if (typesSize > 0 && types[typesSize - 1] === add) return types;
    return types.concat(add);
}; // Takes an array of Prism's tokens and groups them by line, turning plain
// strings into tokens as well. Tokens can become recursive in some cases,
// which means that their types are concatenated. Plain-string tokens however
// are always of type "plain".
// This is not recursive to avoid exceeding the call-stack limit, since it's unclear
// how nested Prism's tokens can become
var $10e8c925670af39c$var$normalizeTokens = function(tokens) {
    var typeArrStack = [
        []
    ];
    var tokenArrStack = [
        tokens
    ];
    var tokenArrIndexStack = [
        0
    ];
    var tokenArrSizeStack = [
        tokens.length
    ];
    var i = 0;
    var stackIndex = 0;
    var currentLine = [];
    var acc = [
        currentLine
    ];
    while(stackIndex > -1){
        while((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]){
            var content = void 0;
            var types = typeArrStack[stackIndex];
            var tokenArr = tokenArrStack[stackIndex];
            var token = tokenArr[i]; // Determine content and append type to types if necessary
            if (typeof token === "string") {
                types = stackIndex > 0 ? types : [
                    "plain"
                ];
                content = token;
            } else {
                types = $10e8c925670af39c$var$appendTypes(types, token.type);
                if (token.alias) types = $10e8c925670af39c$var$appendTypes(types, token.alias);
                content = token.content;
            } // If token.content is an array, increase the stack depth and repeat this while-loop
            if (typeof content !== "string") {
                stackIndex++;
                typeArrStack.push(types);
                tokenArrStack.push(content);
                tokenArrIndexStack.push(0);
                tokenArrSizeStack.push(content.length);
                continue;
            } // Split by newlines
            var splitByNewlines = content.split($10e8c925670af39c$var$newlineRe);
            var newlineCount = splitByNewlines.length;
            currentLine.push({
                types: types,
                content: splitByNewlines[0]
            }); // Create a new line for each string on a new line
            for(var i$1 = 1; i$1 < newlineCount; i$1++){
                $10e8c925670af39c$var$normalizeEmptyLines(currentLine);
                acc.push(currentLine = []);
                currentLine.push({
                    types: types,
                    content: splitByNewlines[i$1]
                });
            }
        } // Decreate the stack depth
        stackIndex--;
        typeArrStack.pop();
        tokenArrStack.pop();
        tokenArrIndexStack.pop();
        tokenArrSizeStack.pop();
    }
    $10e8c925670af39c$var$normalizeEmptyLines(currentLine);
    return acc;
};
var $10e8c925670af39c$var$themeToDict = function(theme, language) {
    var plain = theme.plain; // $FlowFixMe
    var base = Object.create(null);
    var themeDict = theme.styles.reduce(function(acc, themeEntry) {
        var languages = themeEntry.languages;
        var style = themeEntry.style;
        if (languages && !languages.includes(language)) return acc;
        themeEntry.types.forEach(function(type) {
            // $FlowFixMe
            var accStyle = $10e8c925670af39c$var$_extends({}, acc[type], style);
            acc[type] = accStyle;
        });
        return acc;
    }, base); // $FlowFixMe
    themeDict.root = plain; // $FlowFixMe
    themeDict.plain = $10e8c925670af39c$var$_extends({}, plain, {
        backgroundColor: null
    });
    return themeDict;
};
function $10e8c925670af39c$var$objectWithoutProperties(obj, exclude) {
    var target = {};
    for(var k in obj)if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
    return target;
}
var $10e8c925670af39c$var$Highlight = /*@__PURE__*/ function(Component) {
    function Highlight() {
        var this$1 = this;
        var args = [], len = arguments.length;
        while(len--)args[len] = arguments[len];
        Component.apply(this, args);
        $10e8c925670af39c$var$_defineProperty(this, "getThemeDict", function(props) {
            if (this$1.themeDict !== undefined && props.theme === this$1.prevTheme && props.language === this$1.prevLanguage) return this$1.themeDict;
            this$1.prevTheme = props.theme;
            this$1.prevLanguage = props.language;
            var themeDict = props.theme ? $10e8c925670af39c$var$themeToDict(props.theme, props.language) : undefined;
            return this$1.themeDict = themeDict;
        });
        $10e8c925670af39c$var$_defineProperty(this, "getLineProps", function(ref) {
            var key = ref.key;
            var className = ref.className;
            var style = ref.style;
            var rest$1 = $10e8c925670af39c$var$objectWithoutProperties(ref, [
                "key",
                "className",
                "style",
                "line"
            ]);
            var rest = rest$1;
            var output = $10e8c925670af39c$var$_extends({}, rest, {
                className: "token-line",
                style: undefined,
                key: undefined
            });
            var themeDict = this$1.getThemeDict(this$1.props);
            if (themeDict !== undefined) output.style = themeDict.plain;
            if (style !== undefined) output.style = output.style !== undefined ? $10e8c925670af39c$var$_extends({}, output.style, style) : style;
            if (key !== undefined) output.key = key;
            if (className) output.className += " " + className;
            return output;
        });
        $10e8c925670af39c$var$_defineProperty(this, "getStyleForToken", function(ref) {
            var types = ref.types;
            var empty = ref.empty;
            var typesSize = types.length;
            var themeDict = this$1.getThemeDict(this$1.props);
            if (themeDict === undefined) return undefined;
            else if (typesSize === 1 && types[0] === "plain") return empty ? {
                display: "inline-block"
            } : undefined;
            else if (typesSize === 1 && !empty) return themeDict[types[0]];
            var baseStyle = empty ? {
                display: "inline-block"
            } : {}; // $FlowFixMe
            var typeStyles = types.map(function(type) {
                return themeDict[type];
            });
            return Object.assign.apply(Object, [
                baseStyle
            ].concat(typeStyles));
        });
        $10e8c925670af39c$var$_defineProperty(this, "getTokenProps", function(ref) {
            var key = ref.key;
            var className = ref.className;
            var style = ref.style;
            var token = ref.token;
            var rest$1 = $10e8c925670af39c$var$objectWithoutProperties(ref, [
                "key",
                "className",
                "style",
                "token"
            ]);
            var rest = rest$1;
            var output = $10e8c925670af39c$var$_extends({}, rest, {
                className: "token " + token.types.join(" "),
                children: token.content,
                style: this$1.getStyleForToken(token),
                key: undefined
            });
            if (style !== undefined) output.style = output.style !== undefined ? $10e8c925670af39c$var$_extends({}, output.style, style) : style;
            if (key !== undefined) output.key = key;
            if (className) output.className += " " + className;
            return output;
        });
        $10e8c925670af39c$var$_defineProperty(this, "tokenize", function(Prism, code, grammar, language) {
            var env = {
                code: code,
                grammar: grammar,
                language: language,
                tokens: []
            };
            Prism.hooks.run("before-tokenize", env);
            var tokens = env.tokens = Prism.tokenize(env.code, env.grammar, env.language);
            Prism.hooks.run("after-tokenize", env);
            return tokens;
        });
    }
    if (Component) Highlight.__proto__ = Component;
    Highlight.prototype = Object.create(Component && Component.prototype);
    Highlight.prototype.constructor = Highlight;
    Highlight.prototype.render = function render() {
        var ref = this.props;
        var Prism = ref.Prism;
        var language = ref.language;
        var code = ref.code;
        var children = ref.children;
        var themeDict = this.getThemeDict(this.props);
        var grammar = Prism.languages[language];
        var mixedTokens = grammar !== undefined ? this.tokenize(Prism, code, grammar, language) : [
            code
        ];
        var tokens = $10e8c925670af39c$var$normalizeTokens(mixedTokens);
        return children({
            tokens: tokens,
            className: "prism-code language-" + language,
            style: themeDict !== undefined ? themeDict.root : {},
            getLineProps: this.getLineProps,
            getTokenProps: this.getTokenProps
        });
    };
    return Highlight;
}((0, $acw62.Component));
var $10e8c925670af39c$export$2e2bcd8739ae039 = $10e8c925670af39c$var$Highlight;

});
parcelRegister("eUOxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $adbd806745390bd1$export$2e2bcd8739ae039);
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ /**
 * prism-react-renderer:
 * This file has been modified to remove:
 * - globals and window dependency
 * - worker support
 * - highlightAll and other element dependent methods
 * - _.hooks helpers
 * - UMD/node-specific hacks
 * It has also been run through prettier
 */ var $adbd806745390bd1$var$Prism = function() {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    return _;
}();
var $adbd806745390bd1$var$prism = $adbd806745390bd1$var$Prism;
$adbd806745390bd1$var$Prism.default = $adbd806745390bd1$var$Prism;
/* This content is auto-generated to include some prismjs language components: */ /* "prismjs/components/prism-markup" */ $adbd806745390bd1$var$prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        /"|'/
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$adbd806745390bd1$var$prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = $adbd806745390bd1$var$prism.languages.markup['entity'];
$adbd806745390bd1$var$prism.languages.markup['doctype'].inside['internal-subset'].inside = $adbd806745390bd1$var$prism.languages.markup; // Plugin to make entity title show the real entity, idea by Roman Komarov
$adbd806745390bd1$var$prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty($adbd806745390bd1$var$prism.languages.markup.tag, 'addInlined', {
    /**
   * Adds an inlined language to markup.
   *
   * An example of an inlined language is CSS with `<style>` tags.
   *
   * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addInlined('style', 'css');
   */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $adbd806745390bd1$var$prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: $adbd806745390bd1$var$prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $adbd806745390bd1$var$prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty($adbd806745390bd1$var$prism.languages.markup.tag, 'addAttribute', {
    /**
   * Adds an pattern to highlight languages embedded in HTML attributes.
   *
   * An example of an inlined language is CSS with `style` attributes.
   *
   * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addAttribute('style', 'css');
   */ value: function(attrName, lang) {
        $adbd806745390bd1$var$prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: $adbd806745390bd1$var$prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$adbd806745390bd1$var$prism.languages.html = $adbd806745390bd1$var$prism.languages.markup;
$adbd806745390bd1$var$prism.languages.mathml = $adbd806745390bd1$var$prism.languages.markup;
$adbd806745390bd1$var$prism.languages.svg = $adbd806745390bd1$var$prism.languages.markup;
$adbd806745390bd1$var$prism.languages.xml = $adbd806745390bd1$var$prism.languages.extend('markup', {});
$adbd806745390bd1$var$prism.languages.ssml = $adbd806745390bd1$var$prism.languages.xml;
$adbd806745390bd1$var$prism.languages.atom = $adbd806745390bd1$var$prism.languages.xml;
$adbd806745390bd1$var$prism.languages.rss = $adbd806745390bd1$var$prism.languages.xml;
/* "prismjs/components/prism-bash" */ (function(Prism) {
    // $ set | grep '^[A-Z][^[:space:]]*=' | cut -d= -f1 | tr '\n' '|'
    // + LC_ALL, RANDOM, REPLY, SECONDS.
    // + make sure PS1..4 are here as they are not always set,
    // - some useless things.
    var envVars = '\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b';
    var commandAfterHeredoc = {
        pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
        lookbehind: true,
        alias: 'punctuation',
        // this looks reasonably well in all themes
        inside: null // see below
    };
    var insideString = {
        'bash': commandAfterHeredoc,
        'environment': {
            pattern: RegExp('\\$' + envVars),
            alias: 'constant'
        },
        'variable': [
            {
                pattern: /\$?\(\([\s\S]+?\)\)/,
                greedy: true,
                inside: {
                    // If there is a $ sign at the beginning highlight $(( and )) as variable
                    'variable': [
                        {
                            pattern: /(^\$\(\([\s\S]+)\)\)/,
                            lookbehind: true
                        },
                        /^\$\(\(/
                    ],
                    'number': /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                    // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
                    'operator': /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                    // If there is no $ sign at the beginning highlight (( and )) as punctuation
                    'punctuation': /\(\(?|\)\)?|,|;/
                }
            },
            {
                pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                greedy: true,
                inside: {
                    'variable': /^\$\(|^`|\)$|`$/
                }
            },
            {
                pattern: /\$\{[^}]+\}/,
                greedy: true,
                inside: {
                    'operator': /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                    'punctuation': /[\[\]]/,
                    'environment': {
                        pattern: RegExp('(\\{)' + envVars),
                        lookbehind: true,
                        alias: 'constant'
                    }
                }
            },
            /\$(?:\w+|[#?*!@$])/
        ],
        // Escape sequences from echo and printf's manuals, and escaped quotes.
        'entity': /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
    };
    Prism.languages.bash = {
        'shebang': {
            pattern: /^#!\s*\/.*/,
            alias: 'important'
        },
        'comment': {
            pattern: /(^|[^"{\\$])#.*/,
            lookbehind: true
        },
        'function-name': [
            // b) foo() {
            // c) function foo() {
            // but not “foo {”
            {
                // a) and c)
                pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                lookbehind: true,
                alias: 'function'
            },
            {
                // b)
                pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                alias: 'function'
            }
        ],
        // Highlight variable names as variables in for and select beginnings.
        'for-or-select': {
            pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
            alias: 'variable',
            lookbehind: true
        },
        // Highlight variable names as variables in the left-hand part
        // of assignments (“=” and “+=”).
        'assign-left': {
            pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
            inside: {
                'environment': {
                    pattern: RegExp('(^|[\\s;|&]|[<>]\\()' + envVars),
                    lookbehind: true,
                    alias: 'constant'
                }
            },
            alias: 'variable',
            lookbehind: true
        },
        'string': [
            {
                pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                lookbehind: true,
                greedy: true,
                inside: insideString
            },
            // → No expansion (so no “inside”).
            {
                pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                lookbehind: true,
                greedy: true,
                inside: {
                    'bash': commandAfterHeredoc
                }
            },
            {
                // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
                pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                lookbehind: true,
                greedy: true,
                inside: insideString
            },
            {
                // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
                pattern: /(^|[^$\\])'[^']*'/,
                lookbehind: true,
                greedy: true
            },
            {
                // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
                pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                greedy: true,
                inside: {
                    'entity': insideString.entity
                }
            }
        ],
        'environment': {
            pattern: RegExp('\\$?' + envVars),
            alias: 'constant'
        },
        'variable': insideString.variable,
        'function': {
            pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
            lookbehind: true
        },
        'keyword': {
            pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
            lookbehind: true
        },
        // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        'builtin': {
            pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
            lookbehind: true,
            // Alias added to make those easier to distinguish from strings.
            alias: 'class-name'
        },
        'boolean': {
            pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
            lookbehind: true
        },
        'file-descriptor': {
            pattern: /\B&\d\b/,
            alias: 'important'
        },
        'operator': {
            // Lots of redirections here, but not just that.
            pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
            inside: {
                'file-descriptor': {
                    pattern: /^\d/,
                    alias: 'important'
                }
            }
        },
        'punctuation': /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
        'number': {
            pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
            lookbehind: true
        }
    };
    commandAfterHeredoc.inside = Prism.languages.bash;
    /* Patterns in command substitution. */ var toBeCopied = [
        'comment',
        'function-name',
        'for-or-select',
        'assign-left',
        'string',
        'environment',
        'function',
        'keyword',
        'builtin',
        'boolean',
        'file-descriptor',
        'operator',
        'punctuation',
        'number'
    ];
    var inside = insideString.variable[1].inside;
    for(var i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism.languages.bash[toBeCopied[i]];
    Prism.languages.shell = Prism.languages.bash;
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-clike" */ $adbd806745390bd1$var$prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* "prismjs/components/prism-c" */ $adbd806745390bd1$var$prism.languages.c = $adbd806745390bd1$var$prism.languages.extend('clike', {
    'comment': {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    'string': {
        // https://en.cppreference.com/w/c/language/string_literal
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    'keyword': /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    'function': /\b[a-z_]\w*(?=\s*\()/i,
    'number': /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    'operator': />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
});
$adbd806745390bd1$var$prism.languages.insertBefore('c', 'string', {
    'char': {
        // https://en.cppreference.com/w/c/language/character_constant
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
});
$adbd806745390bd1$var$prism.languages.insertBefore('c', 'string', {
    'macro': {
        // allow for multiline macro definitions
        // spaces after the # character compile fine with gcc
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: 'property',
        inside: {
            'string': [
                {
                    // highlight the path of the include statement as a string
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                $adbd806745390bd1$var$prism.languages.c['string']
            ],
            'char': $adbd806745390bd1$var$prism.languages.c['char'],
            'comment': $adbd806745390bd1$var$prism.languages.c['comment'],
            'macro-name': [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: 'function'
                }
            ],
            // highlight macro directives as keywords
            'directive': {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: 'keyword'
            },
            'directive-hash': /^#/,
            'punctuation': /##|\\(?=[\r\n])/,
            'expression': {
                pattern: /\S[\s\S]*/,
                inside: $adbd806745390bd1$var$prism.languages.c
            }
        }
    }
});
$adbd806745390bd1$var$prism.languages.insertBefore('c', 'function', {
    // highlight predefined macros as constants
    'constant': /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
});
delete $adbd806745390bd1$var$prism.languages.c['boolean'];
/* "prismjs/components/prism-cpp" */ (function(Prism) {
    var keyword = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/;
    var modName = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return keyword.source;
    });
    Prism.languages.cpp = Prism.languages.extend('c', {
        'class-name': [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return keyword.source;
                })),
                lookbehind: true
            },
            //   void foo::bar() const {}
            // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
            // it starts with an uppercase letter. This approximation should give decent results.
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            //   Foo::~Foo() {}
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            // parameters, so it can't be a namespace (until C++ adds generic namespaces).
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        'keyword': keyword,
        'number': {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        'operator': />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        'boolean': /\b(?:false|true)\b/
    });
    Prism.languages.insertBefore('cpp', 'string', {
        'module': {
            // https://en.cppreference.com/w/cpp/language/modules
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + '(?:' + // header-name
            /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + '|' + // module name or partition or both
            /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return modName;
            }) + ')'),
            lookbehind: true,
            greedy: true,
            inside: {
                'string': /^[<"][\s\S]+/,
                'operator': /:/,
                'punctuation': /\./
            }
        },
        'raw-string': {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: 'string',
            greedy: true
        }
    });
    Prism.languages.insertBefore('cpp', 'keyword', {
        'generic-function': {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                'function': /^\w+/,
                'generic': {
                    pattern: /<[\s\S]+/,
                    alias: 'class-name',
                    inside: Prism.languages.cpp
                }
            }
        }
    });
    Prism.languages.insertBefore('cpp', 'operator', {
        'double-colon': {
            pattern: /::/,
            alias: 'punctuation'
        }
    });
    Prism.languages.insertBefore('cpp', 'class-name', {
        // the base clause is an optional list of parent classes
        // https://en.cppreference.com/w/cpp/language/class
        'base-clause': {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: Prism.languages.extend('cpp', {})
        }
    });
    Prism.languages.insertBefore('inside', 'double-colon', {
        // All untokenized words that are not namespaces should be class names
        'class-name': /\b[a-z_]\w*\b(?!\s*::)/i
    }, Prism.languages.cpp['base-clause']);
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-css" */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                } // See rest below
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-css-extras" */ (function(Prism) {
    var string = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/;
    var selectorInside;
    Prism.languages.css.selector = {
        pattern: Prism.languages.css.selector.pattern,
        lookbehind: true,
        inside: selectorInside = {
            'pseudo-element': /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
            'pseudo-class': /:[-\w]+/,
            'class': /\.[-\w]+/,
            'id': /#[-\w]+/,
            'attribute': {
                pattern: RegExp('\\[(?:[^[\\]"\']|' + string.source + ')*\\]'),
                greedy: true,
                inside: {
                    'punctuation': /^\[|\]$/,
                    'case-sensitivity': {
                        pattern: /(\s)[si]$/i,
                        lookbehind: true,
                        alias: 'keyword'
                    },
                    'namespace': {
                        pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                        lookbehind: true,
                        inside: {
                            'punctuation': /\|$/
                        }
                    },
                    'attr-name': {
                        pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                        lookbehind: true
                    },
                    'attr-value': [
                        string,
                        {
                            pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                            lookbehind: true
                        }
                    ],
                    'operator': /[|~*^$]?=/
                }
            },
            'n-th': [
                {
                    pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                    lookbehind: true,
                    inside: {
                        'number': /[\dn]+/,
                        'operator': /[+-]/
                    }
                },
                {
                    pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                    lookbehind: true
                }
            ],
            'combinator': />|\+|~|\|\|/,
            // the `tag` token has been existed and removed.
            // because we can't find a perfect tokenize to match it.
            // if you want to add it, please read https://github.com/PrismJS/prism/pull/2373 first.
            'punctuation': /[(),]/
        }
    };
    Prism.languages.css['atrule'].inside['selector-function-argument'].inside = selectorInside;
    Prism.languages.insertBefore('css', 'property', {
        'variable': {
            pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
            lookbehind: true
        }
    });
    var unit = {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: true
    }; // 123 -123 .123 -.123 12.3 -12.3
    var number = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: true
    };
    Prism.languages.insertBefore('css', 'function', {
        'operator': {
            pattern: /(\s)[+\-*\/](?=\s)/,
            lookbehind: true
        },
        // CAREFUL!
        // Previewers and Inline color use hexcode and color.
        'hexcode': {
            pattern: /\B#[\da-f]{3,8}\b/i,
            alias: 'color'
        },
        'color': [
            {
                pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                inside: {
                    'unit': unit,
                    'number': number,
                    'function': /[\w-]+(?=\()/,
                    'punctuation': /[(),]/
                }
            }
        ],
        // it's important that there is no boundary assertion after the hex digits
        'entity': /\\[\da-f]{1,8}/i,
        'unit': unit,
        'number': number
    });
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-javascript" */ $adbd806745390bd1$var$prism.languages.javascript = $adbd806745390bd1$var$prism.languages.extend('clike', {
    'class-name': [
        $adbd806745390bd1$var$prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$adbd806745390bd1$var$prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$adbd806745390bd1$var$prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: $adbd806745390bd1$var$prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $adbd806745390bd1$var$prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $adbd806745390bd1$var$prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $adbd806745390bd1$var$prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $adbd806745390bd1$var$prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$adbd806745390bd1$var$prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $adbd806745390bd1$var$prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
$adbd806745390bd1$var$prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if ($adbd806745390bd1$var$prism.languages.markup) {
    $adbd806745390bd1$var$prism.languages.markup.tag.addInlined('script', 'javascript'); // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $adbd806745390bd1$var$prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
$adbd806745390bd1$var$prism.languages.js = $adbd806745390bd1$var$prism.languages.javascript;
/* "prismjs/components/prism-coffeescript" */ (function(Prism) {
    // Ignore comments starting with { to privilege string interpolation highlighting
    var comment = /#(?!\{).+/;
    var interpolation = {
        pattern: /#\{[^}]+\}/,
        alias: 'variable'
    };
    Prism.languages.coffeescript = Prism.languages.extend('javascript', {
        'comment': comment,
        'string': [
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                greedy: true
            },
            {
                // Strings are multiline
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: true,
                inside: {
                    'interpolation': interpolation
                }
            }
        ],
        'keyword': /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        'class-member': {
            pattern: /@(?!\d)\w+/,
            alias: 'variable'
        }
    });
    Prism.languages.insertBefore('coffeescript', 'comment', {
        'multiline-comment': {
            pattern: /###[\s\S]+?###/,
            alias: 'comment'
        },
        // Block regexp can contain comments and interpolation
        'block-regex': {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: 'regex',
            inside: {
                'comment': comment,
                'interpolation': interpolation
            }
        }
    });
    Prism.languages.insertBefore('coffeescript', 'string', {
        'inline-javascript': {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            inside: {
                'delimiter': {
                    pattern: /^`|`$/,
                    alias: 'punctuation'
                },
                'script': {
                    pattern: /[\s\S]+/,
                    alias: 'language-javascript',
                    inside: Prism.languages.javascript
                }
            }
        },
        // Block strings
        'multiline-string': [
            {
                pattern: /'''[\s\S]*?'''/,
                greedy: true,
                alias: 'string'
            },
            {
                pattern: /"""[\s\S]*?"""/,
                greedy: true,
                alias: 'string',
                inside: {
                    interpolation: interpolation
                }
            }
        ]
    });
    Prism.languages.insertBefore('coffeescript', 'keyword', {
        // Object property
        'property': /(?!\d)\w+(?=\s*:(?!:))/
    });
    delete Prism.languages.coffeescript['template-string'];
    Prism.languages.coffee = Prism.languages.coffeescript;
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-yaml" */ (function(Prism) {
    // https://yaml.org/spec/1.2/spec.html#c-ns-anchor-property
    // https://yaml.org/spec/1.2/spec.html#c-ns-alias-node
    var anchorOrAlias = /[*&][^\s[\]{},]+/; // https://yaml.org/spec/1.2/spec.html#c-ns-tag-property
    var tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/; // https://yaml.org/spec/1.2/spec.html#c-ns-properties(n,c)
    var properties = '(?:' + tag.source + '(?:[ \t]+' + anchorOrAlias.source + ')?|' + anchorOrAlias.source + '(?:[ \t]+' + tag.source + ')?)'; // https://yaml.org/spec/1.2/spec.html#ns-plain(n,c)
    // This is a simplified version that doesn't support "#" and multiline keys
    // All these long scarry character classes are simplified versions of YAML's characters
    var plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    });
    var string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    /**
   *
   * @param {string} value
   * @param {string} [flags]
   * @returns {RegExp}
   */ function createValuePattern(value, flags) {
        flags = (flags || '').replace(/m/g, '') + 'm'; // add m flag
        var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
            return properties;
        }).replace(/<<value>>/g, function() {
            return value;
        });
        return RegExp(pattern, flags);
    }
    Prism.languages.yaml = {
        'scalar': {
            pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                return properties;
            })),
            lookbehind: true,
            alias: 'string'
        },
        'comment': /#.*/,
        'key': {
            pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                return properties;
            }).replace(/<<key>>/g, function() {
                return '(?:' + plainKey + '|' + string + ')';
            })),
            lookbehind: true,
            greedy: true,
            alias: 'atrule'
        },
        'directive': {
            pattern: /(^[ \t]*)%.+/m,
            lookbehind: true,
            alias: 'important'
        },
        'datetime': {
            pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
            lookbehind: true,
            alias: 'number'
        },
        'boolean': {
            pattern: createValuePattern(/false|true/.source, 'i'),
            lookbehind: true,
            alias: 'important'
        },
        'null': {
            pattern: createValuePattern(/null|~/.source, 'i'),
            lookbehind: true,
            alias: 'important'
        },
        'string': {
            pattern: createValuePattern(string),
            lookbehind: true,
            greedy: true
        },
        'number': {
            pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, 'i'),
            lookbehind: true
        },
        'tag': tag,
        'important': anchorOrAlias,
        'punctuation': /---|[:[\]{}\-,|>?]|\.\.\./
    };
    Prism.languages.yml = Prism.languages.yaml;
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-markdown" */ (function(Prism) {
    // Allow only one line break
    var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    /**
   * This function is intended for the creation of the bold or italic pattern.
   *
   * This also adds a lookbehind group to the given pattern to ensure that the pattern is not backslash-escaped.
   *
   * _Note:_ Keep in mind that this adds a capturing group.
   *
   * @param {string} pattern
   * @returns {RegExp}
   */ function createInline(pattern) {
        pattern = pattern.replace(/<inner>/g, function() {
            return inner;
        });
        return RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + '(?:' + pattern + ')');
    }
    var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source;
    var tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return tableCell;
    });
    var tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
    Prism.languages.markdown = Prism.languages.extend('markup', {});
    Prism.languages.insertBefore('markdown', 'prolog', {
        'front-matter-block': {
            pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
            lookbehind: true,
            greedy: true,
            inside: {
                'punctuation': /^---|---$/,
                'front-matter': {
                    pattern: /\S+(?:\s+\S+)*/,
                    alias: [
                        'yaml',
                        'language-yaml'
                    ],
                    inside: Prism.languages.yaml
                }
            }
        },
        'blockquote': {
            // > ...
            pattern: /^>(?:[\t ]*>)*/m,
            alias: 'punctuation'
        },
        'table': {
            pattern: RegExp('^' + tableRow + tableLine + '(?:' + tableRow + ')*', 'm'),
            inside: {
                'table-data-rows': {
                    pattern: RegExp('^(' + tableRow + tableLine + ')(?:' + tableRow + ')*$'),
                    lookbehind: true,
                    inside: {
                        'table-data': {
                            pattern: RegExp(tableCell),
                            inside: Prism.languages.markdown
                        },
                        'punctuation': /\|/
                    }
                },
                'table-line': {
                    pattern: RegExp('^(' + tableRow + ')' + tableLine + '$'),
                    lookbehind: true,
                    inside: {
                        'punctuation': /\||:?-{3,}:?/
                    }
                },
                'table-header-row': {
                    pattern: RegExp('^' + tableRow + '$'),
                    inside: {
                        'table-header': {
                            pattern: RegExp(tableCell),
                            alias: 'important',
                            inside: Prism.languages.markdown
                        },
                        'punctuation': /\|/
                    }
                }
            }
        },
        'code': [
            {
                // Prefixed by 4 spaces or 1 tab and preceded by an empty line
                pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                lookbehind: true,
                alias: 'keyword'
            },
            {
                // ```optional language
                // code block
                // ```
                pattern: /^```[\s\S]*?^```$/m,
                greedy: true,
                inside: {
                    'code-block': {
                        pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                        lookbehind: true
                    },
                    'code-language': {
                        pattern: /^(```).+/,
                        lookbehind: true
                    },
                    'punctuation': /```/
                }
            }
        ],
        'title': [
            {
                // title 1
                // =======
                // title 2
                // -------
                pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                alias: 'important',
                inside: {
                    punctuation: /==+$|--+$/
                }
            },
            {
                // # title 1
                // ###### title 6
                pattern: /(^\s*)#.+/m,
                lookbehind: true,
                alias: 'important',
                inside: {
                    punctuation: /^#+|#+$/
                }
            }
        ],
        'hr': {
            // ***
            // ---
            // * * *
            // -----------
            pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
            lookbehind: true,
            alias: 'punctuation'
        },
        'list': {
            // * item
            // + item
            // - item
            // 1. item
            pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
            lookbehind: true,
            alias: 'punctuation'
        },
        'url-reference': {
            // [id]: http://example.com "Optional title"
            // [id]: http://example.com 'Optional title'
            // [id]: http://example.com (Optional title)
            // [id]: <http://example.com> "Optional title"
            pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
            inside: {
                'variable': {
                    pattern: /^(!?\[)[^\]]+/,
                    lookbehind: true
                },
                'string': /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                'punctuation': /^[\[\]!:]|[<>]/
            },
            alias: 'url'
        },
        'bold': {
            // **strong**
            // __strong__
            // allow one nested instance of italic text using the same delimiter
            pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'content': {
                    pattern: /(^..)[\s\S]+(?=..$)/,
                    lookbehind: true,
                    inside: {} // see below
                },
                'punctuation': /\*\*|__/
            }
        },
        'italic': {
            // *em*
            // _em_
            // allow one nested instance of bold text using the same delimiter
            pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'content': {
                    pattern: /(^.)[\s\S]+(?=.$)/,
                    lookbehind: true,
                    inside: {} // see below
                },
                'punctuation': /[*_]/
            }
        },
        'strike': {
            // ~~strike through~~
            // ~strike~
            // eslint-disable-next-line regexp/strict
            pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'content': {
                    pattern: /(^~~?)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: {} // see below
                },
                'punctuation': /~~?/
            }
        },
        'code-snippet': {
            // `code`
            // ``code``
            pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
            lookbehind: true,
            greedy: true,
            alias: [
                'code',
                'keyword'
            ]
        },
        'url': {
            // [example](http://example.com "Optional title")
            // [example][id]
            // [example] [id]
            pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                'operator': /^!/,
                'content': {
                    pattern: /(^\[)[^\]]+(?=\])/,
                    lookbehind: true,
                    inside: {} // see below
                },
                'variable': {
                    pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                    lookbehind: true
                },
                'url': {
                    pattern: /(^\]\()[^\s)]+/,
                    lookbehind: true
                },
                'string': {
                    pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                    lookbehind: true
                }
            }
        }
    });
    [
        'url',
        'bold',
        'italic',
        'strike'
    ].forEach(function(token) {
        [
            'url',
            'bold',
            'italic',
            'strike',
            'code-snippet'
        ].forEach(function(inside) {
            if (token !== inside) Prism.languages.markdown[token].inside.content.inside[inside] = Prism.languages.markdown[inside];
        });
    });
    Prism.hooks.add('after-tokenize', function(env) {
        if (env.language !== 'markdown' && env.language !== 'md') return;
        function walkTokens(tokens) {
            if (!tokens || typeof tokens === 'string') return;
            for(var i = 0, l = tokens.length; i < l; i++){
                var token = tokens[i];
                if (token.type !== 'code') {
                    walkTokens(token.content);
                    continue;
                }
                /*
         * Add the correct `language-xxxx` class to this code block. Keep in mind that the `code-language` token
         * is optional. But the grammar is defined so that there is only one case we have to handle:
         *
         * token.content = [
         *     <span class="punctuation">```</span>,
         *     <span class="code-language">xxxx</span>,
         *     '\n', // exactly one new lines (\r or \n or \r\n)
         *     <span class="code-block">...</span>,
         *     '\n', // exactly one new lines again
         *     <span class="punctuation">```</span>
         * ];
         */ var codeLang = token.content[1];
                var codeBlock = token.content[3];
                if (codeLang && codeBlock && codeLang.type === 'code-language' && codeBlock.type === 'code-block' && typeof codeLang.content === 'string') {
                    // this might be a language that Prism does not support
                    // do some replacements to support C++, C#, and F#
                    var lang = codeLang.content.replace(/\b#/g, 'sharp').replace(/\b\+\+/g, 'pp'); // only use the first word
                    lang = (/[a-z][\w-]*/i.exec(lang) || [
                        ''
                    ])[0].toLowerCase();
                    var alias = 'language-' + lang; // add alias
                    if (!codeBlock.alias) codeBlock.alias = [
                        alias
                    ];
                    else if (typeof codeBlock.alias === 'string') codeBlock.alias = [
                        codeBlock.alias,
                        alias
                    ];
                    else codeBlock.alias.push(alias);
                }
            }
        }
        walkTokens(env.tokens);
    });
    Prism.hooks.add('wrap', function(env) {
        if (env.type !== 'code-block') return;
        var codeLang = '';
        for(var i = 0, l = env.classes.length; i < l; i++){
            var cls = env.classes[i];
            var match = /language-(.+)/.exec(cls);
            if (match) {
                codeLang = match[1];
                break;
            }
        }
        var grammar = Prism.languages[codeLang];
        if (!grammar) {
            if (codeLang && codeLang !== 'none' && Prism.plugins.autoloader) {
                var id = 'md-' + new Date().valueOf() + '-' + Math.floor(Math.random() * 1e16);
                env.attributes['id'] = id;
                Prism.plugins.autoloader.loadLanguages(codeLang, function() {
                    var ele = document.getElementById(id);
                    if (ele) ele.innerHTML = Prism.highlight(ele.textContent, Prism.languages[codeLang], codeLang);
                });
            }
        } else env.content = Prism.highlight(textContent(env.content), grammar, codeLang);
    });
    var tagPattern = RegExp(Prism.languages.markup.tag.pattern.source, 'gi');
    /**
   * A list of known entity names.
   *
   * This will always be incomplete to save space. The current list is the one used by lowdash's unescape function.
   *
   * @see {@link https://github.com/lodash/lodash/blob/2da024c3b4f9947a48517639de7560457cd4ec6c/unescape.js#L2}
   */ var KNOWN_ENTITY_NAMES = {
        'amp': '&',
        'lt': '<',
        'gt': '>',
        'quot': '"'
    }; // IE 11 doesn't support `String.fromCodePoint`
    var fromCodePoint = String.fromCodePoint || String.fromCharCode;
    /**
   * Returns the text content of a given HTML source code string.
   *
   * @param {string} html
   * @returns {string}
   */ function textContent(html) {
        // remove all tags
        var text = html.replace(tagPattern, ''); // decode known entities
        text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
            code = code.toLowerCase();
            if (code[0] === '#') {
                var value;
                if (code[1] === 'x') value = parseInt(code.slice(2), 16);
                else value = Number(code.slice(1));
                return fromCodePoint(value);
            } else {
                var known = KNOWN_ENTITY_NAMES[code];
                if (known) return known;
                 // unable to decode
                return m;
            }
        });
        return text;
    }
    Prism.languages.md = Prism.languages.markdown;
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-graphql" */ $adbd806745390bd1$var$prism.languages.graphql = {
    'comment': /#.*/,
    'description': {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: true,
        alias: 'string',
        inside: {
            'language-markdown': {
                pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                lookbehind: true,
                inside: $adbd806745390bd1$var$prism.languages.markdown
            }
        }
    },
    'string': {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: true
    },
    'number': /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    'boolean': /\b(?:false|true)\b/,
    'variable': /\$[a-z_]\w*/i,
    'directive': {
        pattern: /@[a-z_]\w*/i,
        alias: 'function'
    },
    'attr-name': {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: true
    },
    'atom-input': {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: 'class-name'
    },
    'scalar': /\b(?:Boolean|Float|ID|Int|String)\b/,
    'constant': /\b[A-Z][A-Z_\d]*\b/,
    'class-name': {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: true
    },
    'fragment': {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: 'function'
    },
    'definition-mutation': {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: 'function'
    },
    'definition-query': {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: 'function'
    },
    'keyword': /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    'operator': /[!=|&]|\.{3}/,
    'property-query': /\w+(?=\s*\()/,
    'object': /\w+(?=\s*\{)/,
    'punctuation': /[!(){}\[\]:=,]/,
    'property': /\w+/
};
$adbd806745390bd1$var$prism.hooks.add('after-tokenize', function afterTokenizeGraphql(env) {
    if (env.language !== 'graphql') return;
    /**
   * get the graphql token stream that we want to customize
   *
   * @typedef {InstanceType<import("./prism-core")["Token"]>} Token
   * @type {Token[]}
   */ var validTokens = env.tokens.filter(function(token) {
        return typeof token !== 'string' && token.type !== 'comment' && token.type !== 'scalar';
    });
    var currentIndex = 0;
    /**
   * Returns whether the token relative to the current index has the given type.
   *
   * @param {number} offset
   * @returns {Token | undefined}
   */ function getToken(offset) {
        return validTokens[currentIndex + offset];
    }
    /**
   * Returns whether the token relative to the current index has the given type.
   *
   * @param {readonly string[]} types
   * @param {number} [offset=0]
   * @returns {boolean}
   */ function isTokenType(types, offset) {
        offset = offset || 0;
        for(var i = 0; i < types.length; i++){
            var token = getToken(i + offset);
            if (!token || token.type !== types[i]) return false;
        }
        return true;
    }
    /**
   * Returns the index of the closing bracket to an opening bracket.
   *
   * It is assumed that `token[currentIndex - 1]` is an opening bracket.
   *
   * If no closing bracket could be found, `-1` will be returned.
   *
   * @param {RegExp} open
   * @param {RegExp} close
   * @returns {number}
   */ function findClosingBracket(open, close) {
        var stackHeight = 1;
        for(var i = currentIndex; i < validTokens.length; i++){
            var token = validTokens[i];
            var content = token.content;
            if (token.type === 'punctuation' && typeof content === 'string') {
                if (open.test(content)) stackHeight++;
                else if (close.test(content)) {
                    stackHeight--;
                    if (stackHeight === 0) return i;
                }
            }
        }
        return -1;
    }
    /**
   * Adds an alias to the given token.
   *
   * @param {Token} token
   * @param {string} alias
   * @returns {void}
   */ function addAlias(token, alias) {
        var aliases = token.alias;
        if (!aliases) token.alias = aliases = [];
        else if (!Array.isArray(aliases)) token.alias = aliases = [
            aliases
        ];
        aliases.push(alias);
    }
    for(; currentIndex < validTokens.length;){
        var startToken = validTokens[currentIndex++]; // add special aliases for mutation tokens
        if (startToken.type === 'keyword' && startToken.content === 'mutation') {
            // any array of the names of all input variables (if any)
            var inputVariables = [];
            if (isTokenType([
                'definition-mutation',
                'punctuation'
            ]) && getToken(1).content === '(') {
                // definition
                currentIndex += 2; // skip 'definition-mutation' and 'punctuation'
                var definitionEnd = findClosingBracket(/^\($/, /^\)$/);
                if (definitionEnd === -1) continue;
                 // find all input variables
                for(; currentIndex < definitionEnd; currentIndex++){
                    var t = getToken(0);
                    if (t.type === 'variable') {
                        addAlias(t, 'variable-input');
                        inputVariables.push(t.content);
                    }
                }
                currentIndex = definitionEnd + 1;
            }
            if (isTokenType([
                'punctuation',
                'property-query'
            ]) && getToken(0).content === '{') {
                currentIndex++; // skip opening bracket
                addAlias(getToken(0), 'property-mutation');
                if (inputVariables.length > 0) {
                    var mutationEnd = findClosingBracket(/^\{$/, /^\}$/);
                    if (mutationEnd === -1) continue;
                     // give references to input variables a special alias
                    for(var i = currentIndex; i < mutationEnd; i++){
                        var varToken = validTokens[i];
                        if (varToken.type === 'variable' && inputVariables.indexOf(varToken.content) >= 0) addAlias(varToken, 'variable-input');
                    }
                }
            }
        }
    }
});
/* "prismjs/components/prism-sql" */ $adbd806745390bd1$var$prism.languages.sql = {
    'comment': {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    'variable': [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    'string': {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    'identifier': {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            'punctuation': /^`|`$/
        }
    },
    'function': /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    // Should we highlight user defined functions too?
    'keyword': /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    'boolean': /\b(?:FALSE|NULL|TRUE)\b/i,
    'number': /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    'operator': /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    'punctuation': /[;[\]()`,.]/
};
/* "prismjs/components/prism-js-templates" */ (function(Prism) {
    var templateString = Prism.languages.javascript['template-string']; // see the pattern in prism-javascript.js
    var templateLiteralPattern = templateString.pattern.source;
    var interpolationObject = templateString.inside['interpolation'];
    var interpolationPunctuationObject = interpolationObject.inside['interpolation-punctuation'];
    var interpolationPattern = interpolationObject.pattern.source;
    /**
   * Creates a new pattern to match a template string with a special tag.
   *
   * This will return `undefined` if there is no grammar with the given language id.
   *
   * @param {string} language The language id of the embedded language. E.g. `markdown`.
   * @param {string} tag The regex pattern to match the tag.
   * @returns {object | undefined}
   * @example
   * createTemplate('css', /\bcss/.source);
   */ function createTemplate(language, tag) {
        if (!Prism.languages[language]) return undefined;
        return {
            pattern: RegExp('((?:' + tag + ')\\s*)' + templateLiteralPattern),
            lookbehind: true,
            greedy: true,
            inside: {
                'template-punctuation': {
                    pattern: /^`|`$/,
                    alias: 'string'
                },
                'embedded-code': {
                    pattern: /[\s\S]+/,
                    alias: language
                }
            }
        };
    }
    Prism.languages.javascript['template-string'] = [
        //   css`a { color: #25F; }`
        // styled-components:
        //   styled.h1`color: red;`
        createTemplate('css', /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
        // div.innerHTML = `<p></p>`
        createTemplate('html', /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        createTemplate('svg', /\bsvg/.source),
        createTemplate('markdown', /\b(?:markdown|md)/.source),
        createTemplate('graphql', /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
        createTemplate('sql', /\bsql/.source),
        templateString
    ].filter(Boolean);
    /**
   * Returns a specific placeholder literal for the given language.
   *
   * @param {number} counter
   * @param {string} language
   * @returns {string}
   */ function getPlaceholder(counter, language) {
        return '___' + language.toUpperCase() + '_' + counter + '___';
    }
    /**
   * Returns the tokens of `Prism.tokenize` but also runs the `before-tokenize` and `after-tokenize` hooks.
   *
   * @param {string} code
   * @param {any} grammar
   * @param {string} language
   * @returns {(string|Token)[]}
   */ function tokenizeWithHooks(code, grammar, language) {
        var env = {
            code: code,
            grammar: grammar,
            language: language
        };
        Prism.hooks.run('before-tokenize', env);
        env.tokens = Prism.tokenize(env.code, env.grammar);
        Prism.hooks.run('after-tokenize', env);
        return env.tokens;
    }
    /**
   * Returns the token of the given JavaScript interpolation expression.
   *
   * @param {string} expression The code of the expression. E.g. `"${42}"`
   * @returns {Token}
   */ function tokenizeInterpolationExpression(expression) {
        var tempGrammar = {};
        tempGrammar['interpolation-punctuation'] = interpolationPunctuationObject;
        /** @type {Array} */ var tokens = Prism.tokenize(expression, tempGrammar);
        if (tokens.length === 3) {
            /**
       * The token array will look like this
       * [
       *     ["interpolation-punctuation", "${"]
       *     "..." // JavaScript expression of the interpolation
       *     ["interpolation-punctuation", "}"]
       * ]
       */ var args = [
                1,
                1
            ];
            args.push.apply(args, tokenizeWithHooks(tokens[1], Prism.languages.javascript, 'javascript'));
            tokens.splice.apply(tokens, args);
        }
        return new Prism.Token('interpolation', tokens, interpolationObject.alias, expression);
    }
    /**
   * Tokenizes the given code with support for JavaScript interpolation expressions mixed in.
   *
   * This function has 3 phases:
   *
   * 1. Replace all JavaScript interpolation expression with a placeholder.
   *    The placeholder will have the syntax of a identify of the target language.
   * 2. Tokenize the code with placeholders.
   * 3. Tokenize the interpolation expressions and re-insert them into the tokenize code.
   *    The insertion only works if a placeholder hasn't been "ripped apart" meaning that the placeholder has been
   *    tokenized as two tokens by the grammar of the embedded language.
   *
   * @param {string} code
   * @param {object} grammar
   * @param {string} language
   * @returns {Token}
   */ function tokenizeEmbedded(code, grammar, language) {
        // 1. First filter out all interpolations
        // because they might be escaped, we need a lookbehind, so we use Prism
        /** @type {(Token|string)[]} */ var _tokens = Prism.tokenize(code, {
            'interpolation': {
                pattern: RegExp(interpolationPattern),
                lookbehind: true
            }
        }); // replace all interpolations with a placeholder which is not in the code already
        var placeholderCounter = 0;
        /** @type {Object<string, string>} */ var placeholderMap = {};
        var embeddedCode = _tokens.map(function(token) {
            if (typeof token === 'string') return token;
            else {
                var interpolationExpression = token.content;
                var placeholder;
                while(code.indexOf(placeholder = getPlaceholder(placeholderCounter++, language)) !== -1);
                placeholderMap[placeholder] = interpolationExpression;
                return placeholder;
            }
        }).join(''); // 2. Tokenize the embedded code
        var embeddedTokens = tokenizeWithHooks(embeddedCode, grammar, language); // 3. Re-insert the interpolation
        var placeholders = Object.keys(placeholderMap);
        placeholderCounter = 0;
        /**
     *
     * @param {(Token|string)[]} tokens
     * @returns {void}
     */ function walkTokens(tokens) {
            for(var i = 0; i < tokens.length; i++){
                if (placeholderCounter >= placeholders.length) return;
                var token = tokens[i];
                if (typeof token === 'string' || typeof token.content === 'string') {
                    var placeholder = placeholders[placeholderCounter];
                    var s = typeof token === 'string' ? token : /** @type {string} */ token.content;
                    var index = s.indexOf(placeholder);
                    if (index !== -1) {
                        ++placeholderCounter;
                        var before = s.substring(0, index);
                        var middle = tokenizeInterpolationExpression(placeholderMap[placeholder]);
                        var after = s.substring(index + placeholder.length);
                        var replacement = [];
                        if (before) replacement.push(before);
                        replacement.push(middle);
                        if (after) {
                            var afterTokens = [
                                after
                            ];
                            walkTokens(afterTokens);
                            replacement.push.apply(replacement, afterTokens);
                        }
                        if (typeof token === 'string') {
                            tokens.splice.apply(tokens, [
                                i,
                                1
                            ].concat(replacement));
                            i += replacement.length - 1;
                        } else token.content = replacement;
                    }
                } else {
                    var content = token.content;
                    if (Array.isArray(content)) walkTokens(content);
                    else walkTokens([
                        content
                    ]);
                }
            }
        }
        walkTokens(embeddedTokens);
        return new Prism.Token(language, embeddedTokens, 'language-' + language, code);
    }
    /**
   * The languages for which JS templating will handle tagged template literals.
   *
   * JS templating isn't active for only JavaScript but also related languages like TypeScript, JSX, and TSX.
   */ var supportedLanguages = {
        'javascript': true,
        'js': true,
        'typescript': true,
        'ts': true,
        'jsx': true,
        'tsx': true
    };
    Prism.hooks.add('after-tokenize', function(env) {
        if (!(env.language in supportedLanguages)) return;
        /**
     * Finds and tokenizes all template strings with an embedded languages.
     *
     * @param {(Token | string)[]} tokens
     * @returns {void}
     */ function findTemplateStrings(tokens) {
            for(var i = 0, l = tokens.length; i < l; i++){
                var token = tokens[i];
                if (typeof token === 'string') continue;
                var content = token.content;
                if (!Array.isArray(content)) {
                    if (typeof content !== 'string') findTemplateStrings([
                        content
                    ]);
                    continue;
                }
                if (token.type === 'template-string') {
                    /**
           * A JavaScript template-string token will look like this:
           *
           * ["template-string", [
           *     ["template-punctuation", "`"],
           *     (
           *         An array of "string" and "interpolation" tokens. This is the simple string case.
           *         or
           *         ["embedded-code", "..."] This is the token containing the embedded code.
           *                                  It also has an alias which is the language of the embedded code.
           *     ),
           *     ["template-punctuation", "`"]
           * ]]
           */ var embedded = content[1];
                    if (content.length === 3 && typeof embedded !== 'string' && embedded.type === 'embedded-code') {
                        // get string content
                        var code = stringContent(embedded);
                        var alias = embedded.alias;
                        var language = Array.isArray(alias) ? alias[0] : alias;
                        var grammar = Prism.languages[language];
                        if (!grammar) continue;
                        content[1] = tokenizeEmbedded(code, grammar, language);
                    }
                } else findTemplateStrings(content);
            }
        }
        findTemplateStrings(env.tokens);
    });
    /**
   * Returns the string content of a token or token stream.
   *
   * @param {string | Token | (string | Token)[]} value
   * @returns {string}
   */ function stringContent(value) {
        if (typeof value === 'string') return value;
        else if (Array.isArray(value)) return value.map(stringContent).join('');
        else return stringContent(value.content);
    }
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-typescript" */ (function(Prism) {
    Prism.languages.typescript = Prism.languages.extend('javascript', {
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        'builtin': /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }); // The keywords TypeScript adds to JavaScript
    Prism.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/); // doesn't work with TS because TS is too complex
    delete Prism.languages.typescript['parameter'];
    delete Prism.languages.typescript['literal-property']; // a version of typescript specifically for highlighting types
    var typeInside = Prism.languages.extend('typescript', {});
    delete typeInside['class-name'];
    Prism.languages.typescript['class-name'].inside = typeInside;
    Prism.languages.insertBefore('typescript', 'function', {
        'decorator': {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                'at': {
                    pattern: /^@/,
                    alias: 'operator'
                },
                'function': /^[\s\S]+/
            }
        },
        'generic-function': {
            // e.g. foo<T extends "bar" | "baz">( ...
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                'generic': {
                    pattern: /<[\s\S]+/,
                    // everything after the first <
                    alias: 'class-name',
                    inside: typeInside
                }
            }
        }
    });
    Prism.languages.ts = Prism.languages.typescript;
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-js-extras" */ (function(Prism) {
    Prism.languages.insertBefore('javascript', 'function-variable', {
        'method-variable': {
            pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function-variable'].pattern.source),
            lookbehind: true,
            alias: [
                'function-variable',
                'method',
                'function',
                'property-access'
            ]
        }
    });
    Prism.languages.insertBefore('javascript', 'function', {
        'method': {
            pattern: RegExp('(\\.\\s*)' + Prism.languages.javascript['function'].source),
            lookbehind: true,
            alias: [
                'function',
                'property-access'
            ]
        }
    });
    Prism.languages.insertBefore('javascript', 'constant', {
        'known-class-name': [
            {
                // standard built-ins
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
                pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                alias: 'class-name'
            },
            {
                // errors
                pattern: /\b(?:[A-Z]\w*)Error\b/,
                alias: 'class-name'
            }
        ]
    });
    /**
   * Replaces the `<ID>` placeholder in the given pattern with a pattern for general JS identifiers.
   *
   * @param {string} source
   * @param {string} [flags]
   * @returns {RegExp}
   */ function withId(source, flags) {
        return RegExp(source.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }), flags);
    }
    Prism.languages.insertBefore('javascript', 'keyword', {
        'imports': {
            // https://tc39.es/ecma262/#sec-imports
            pattern: withId(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        'exports': {
            // https://tc39.es/ecma262/#sec-exports
            pattern: withId(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    });
    Prism.languages.javascript['keyword'].unshift({
        pattern: /\b(?:as|default|export|from|import)\b/,
        alias: 'module'
    }, {
        pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
        alias: 'control-flow'
    }, {
        pattern: /\bnull\b/,
        alias: [
            'null',
            'nil'
        ]
    }, {
        pattern: /\bundefined\b/,
        alias: 'nil'
    });
    Prism.languages.insertBefore('javascript', 'operator', {
        'spread': {
            pattern: /\.{3}/,
            alias: 'operator'
        },
        'arrow': {
            pattern: /=>/,
            alias: 'operator'
        }
    });
    Prism.languages.insertBefore('javascript', 'punctuation', {
        'property-access': {
            pattern: withId(/(\.\s*)#?<ID>/.source),
            lookbehind: true
        },
        'maybe-class-name': {
            pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
            lookbehind: true
        },
        'dom': {
            // this contains only a few commonly used DOM variables
            pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
            alias: 'variable'
        },
        'console': {
            pattern: /\bconsole(?=\s*\.)/,
            alias: 'class-name'
        }
    }); // add 'maybe-class-name' to tokens which might be a class name
    var maybeClassNameTokens = [
        'function',
        'function-variable',
        'method',
        'method-variable',
        'property-access'
    ];
    for(var i = 0; i < maybeClassNameTokens.length; i++){
        var token = maybeClassNameTokens[i];
        var value = Prism.languages.javascript[token]; // convert regex to object
        if (Prism.util.type(value) === 'RegExp') value = Prism.languages.javascript[token] = {
            pattern: value
        };
         // keep in mind that we don't support arrays
        var inside = value.inside || {};
        value.inside = inside;
        inside['maybe-class-name'] = /^[A-Z][\s\S]*/;
    }
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-jsx" */ (function(Prism) {
    var javascript = Prism.util.clone(Prism.languages.javascript);
    var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
    var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
    var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    /**
   * @param {string} source
   * @param {string} [flags]
   */ function re(source, flags) {
        source = source.replace(/<S>/g, function() {
            return space;
        }).replace(/<BRACES>/g, function() {
            return braces;
        }).replace(/<SPREAD>/g, function() {
            return spread;
        });
        return RegExp(source, flags);
    }
    spread = re(spread).source;
    Prism.languages.jsx = Prism.languages.extend('markup', javascript);
    Prism.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
    Prism.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
    Prism.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
    Prism.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
    Prism.languages.jsx.tag.inside['comment'] = javascript['comment'];
    Prism.languages.insertBefore('inside', 'attr-name', {
        'spread': {
            pattern: re(/<SPREAD>/.source),
            inside: Prism.languages.jsx
        }
    }, Prism.languages.jsx.tag);
    Prism.languages.insertBefore('inside', 'special-attr', {
        'script': {
            // Allow for two levels of nesting
            pattern: re(/=<BRACES>/.source),
            alias: 'language-javascript',
            inside: {
                'script-punctuation': {
                    pattern: /^=(?=\{)/,
                    alias: 'punctuation'
                },
                rest: Prism.languages.jsx
            }
        }
    }, Prism.languages.jsx.tag); // The following will handle plain text inside tags
    var stringifyToken = function(token) {
        if (!token) return '';
        if (typeof token === 'string') return token;
        if (typeof token.content === 'string') return token.content;
        return token.content.map(stringifyToken).join('');
    };
    var walkTokens = function(tokens) {
        var openedTags = [];
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            var notTagNorBrace = false;
            if (typeof token !== 'string') {
                if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                    // We found a tag, now find its kind
                    if (token.content[0].content[0].content === '</') // Closing tag
                    {
                        if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                        openedTags.pop();
                    } else {
                        if (token.content[token.content.length - 1].content === '/>') ;
                        else // Opening tag
                        openedTags.push({
                            tagName: stringifyToken(token.content[0].content[1]),
                            openedBraces: 0
                        });
                    }
                } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces++;
                else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces--;
                else notTagNorBrace = true;
            }
            if (notTagNorBrace || typeof token === 'string') {
                if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                    // Here we are inside a tag, and not inside a JSX context.
                    // That's plain text: drop any tokens matched.
                    var plainText = stringifyToken(token); // And merge text with adjacent text
                    if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                        plainText += stringifyToken(tokens[i + 1]);
                        tokens.splice(i + 1, 1);
                    }
                    if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                        plainText = stringifyToken(tokens[i - 1]) + plainText;
                        tokens.splice(i - 1, 1);
                        i--;
                    }
                    tokens[i] = new Prism.Token('plain-text', plainText, null, plainText);
                }
            }
            if (token.content && typeof token.content !== 'string') walkTokens(token.content);
        }
    };
    Prism.hooks.add('after-tokenize', function(env) {
        if (env.language !== 'jsx' && env.language !== 'tsx') return;
        walkTokens(env.tokens);
    });
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-diff" */ (function(Prism) {
    Prism.languages.diff = {
        'coord': [
            /^(?:\*{3}|-{3}|\+{3}).*$/m,
            /^@@.*@@$/m,
            /^\d.*$/m
        ] // deleted, inserted, unchanged, diff
    };
    /**
   * A map from the name of a block to its line prefix.
   *
   * @type {Object<string, string>}
   */ var PREFIXES = {
        'deleted-sign': '-',
        'deleted-arrow': '<',
        'inserted-sign': '+',
        'inserted-arrow': '>',
        'unchanged': ' ',
        'diff': '!'
    }; // add a token for each prefix
    Object.keys(PREFIXES).forEach(function(name) {
        var prefix = PREFIXES[name];
        var alias = [];
        if (!/^\w+$/.test(name)) // "deleted-sign" -> "deleted"
        alias.push(/\w+/.exec(name)[0]);
        if (name === 'diff') alias.push('bold');
        Prism.languages.diff[name] = {
            pattern: RegExp('^(?:[' + prefix + '].*(?:\r\n?|\n|(?![\\s\\S])))+', 'm'),
            alias: alias,
            inside: {
                'line': {
                    pattern: /(.)(?=[\s\S]).*(?:\r\n?|\n)?/,
                    lookbehind: true
                },
                'prefix': {
                    pattern: /[\s\S]/,
                    alias: /\w+/.exec(name)[0]
                }
            }
        };
    }); // make prefixes available to Diff plugin
    Object.defineProperty(Prism.languages.diff, 'PREFIXES', {
        value: PREFIXES
    });
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-git" */ $adbd806745390bd1$var$prism.languages.git = {
    /*
   * A simple one line comment like in a git status command
   * For instance:
   * $ git status
   * # On branch infinite-scroll
   * # Your branch and 'origin/sharedBranches/frontendTeam/infinite-scroll' have diverged,
   * # and have 1 and 2 different commits each, respectively.
   * nothing to commit (working directory clean)
   */ 'comment': /^#.*/m,
    /*
   * Regexp to match the changed lines in a git diff output. Check the example below.
   */ 'deleted': /^[-–].*/m,
    'inserted': /^\+.*/m,
    /*
   * a string (double and simple quote)
   */ 'string': /("|')(?:\\.|(?!\1)[^\\\r\n])*\1/,
    /*
   * a git command. It starts with a random prompt finishing by a $, then "git" then some other parameters
   * For instance:
   * $ git add file.txt
   */ 'command': {
        pattern: /^.*\$ git .*$/m,
        inside: {
            /*
       * A git command can contain a parameter starting by a single or a double dash followed by a string
       * For instance:
       * $ git diff --cached
       * $ git log -p
       */ 'parameter': /\s--?\w+/
        }
    },
    /*
   * Coordinates displayed in a git diff command
   * For instance:
   * $ git diff
   * diff --git file.txt file.txt
   * index 6214953..1d54a52 100644
   * --- file.txt
   * +++ file.txt
   * @@ -1 +1,2 @@
   * -Here's my tetx file
   * +Here's my text file
   * +And this is the second line
   */ 'coord': /^@@.*@@$/m,
    /*
   * Match a "commit [SHA1]" line in a git log output.
   * For instance:
   * $ git log
   * commit a11a14ef7e26f2ca62d4b35eac455ce636d0dc09
   * Author: lgiraudel
   * Date:   Mon Feb 17 11:18:34 2014 +0100
   *
   *     Add of a new line
   */ 'commit-sha1': /^commit \w{40}$/m
};
/* "prismjs/components/prism-go" */ $adbd806745390bd1$var$prism.languages.go = $adbd806745390bd1$var$prism.languages.extend('clike', {
    'string': {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    'keyword': /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    'boolean': /\b(?:_|false|iota|nil|true)\b/,
    'number': [
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    'operator': /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    'builtin': /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
});
$adbd806745390bd1$var$prism.languages.insertBefore('go', 'string', {
    'char': {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
});
delete $adbd806745390bd1$var$prism.languages.go['class-name'];
/* "prismjs/components/prism-markup-templating" */ (function(Prism) {
    /**
   * Returns the placeholder for the given language id and index.
   *
   * @param {string} language
   * @param {string|number} index
   * @returns {string}
   */ function getPlaceholder(language, index) {
        return '___' + language.toUpperCase() + index + '___';
    }
    Object.defineProperties(Prism.languages['markup-templating'] = {}, {
        buildPlaceholders: {
            /**
       * Tokenize all inline templating expressions matching `placeholderPattern`.
       *
       * If `replaceFilter` is provided, only matches of `placeholderPattern` for which `replaceFilter` returns
       * `true` will be replaced.
       *
       * @param {object} env The environment of the `before-tokenize` hook.
       * @param {string} language The language id.
       * @param {RegExp} placeholderPattern The matches of this pattern will be replaced by placeholders.
       * @param {(match: string) => boolean} [replaceFilter]
       */ value: function(env, language, placeholderPattern, replaceFilter) {
                if (env.language !== language) return;
                var tokenStack = env.tokenStack = [];
                env.code = env.code.replace(placeholderPattern, function(match) {
                    if (typeof replaceFilter === 'function' && !replaceFilter(match)) return match;
                    var i = tokenStack.length;
                    var placeholder; // Check for existing strings
                    while(env.code.indexOf(placeholder = getPlaceholder(language, i)) !== -1)++i;
                     // Create a sparse array
                    tokenStack[i] = match;
                    return placeholder;
                }); // Switch the grammar to markup
                env.grammar = Prism.languages.markup;
            }
        },
        tokenizePlaceholders: {
            /**
       * Replace placeholders with proper tokens after tokenizing.
       *
       * @param {object} env The environment of the `after-tokenize` hook.
       * @param {string} language The language id.
       */ value: function(env, language) {
                if (env.language !== language || !env.tokenStack) return;
                 // Switch the grammar back
                env.grammar = Prism.languages[language];
                var j = 0;
                var keys = Object.keys(env.tokenStack);
                function walkTokens(tokens) {
                    for(var i = 0; i < tokens.length; i++){
                        // all placeholders are replaced already
                        if (j >= keys.length) break;
                        var token = tokens[i];
                        if (typeof token === 'string' || token.content && typeof token.content === 'string') {
                            var k = keys[j];
                            var t = env.tokenStack[k];
                            var s = typeof token === 'string' ? token : token.content;
                            var placeholder = getPlaceholder(language, k);
                            var index = s.indexOf(placeholder);
                            if (index > -1) {
                                ++j;
                                var before = s.substring(0, index);
                                var middle = new Prism.Token(language, Prism.tokenize(t, env.grammar), 'language-' + language, t);
                                var after = s.substring(index + placeholder.length);
                                var replacement = [];
                                if (before) replacement.push.apply(replacement, walkTokens([
                                    before
                                ]));
                                replacement.push(middle);
                                if (after) replacement.push.apply(replacement, walkTokens([
                                    after
                                ]));
                                if (typeof token === 'string') tokens.splice.apply(tokens, [
                                    i,
                                    1
                                ].concat(replacement));
                                else token.content = replacement;
                            }
                        } else if (token.content) walkTokens(token.content);
                    }
                    return tokens;
                }
                walkTokens(env.tokens);
            }
        }
    });
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-handlebars" */ (function(Prism) {
    Prism.languages.handlebars = {
        'comment': /\{\{![\s\S]*?\}\}/,
        'delimiter': {
            pattern: /^\{\{\{?|\}\}\}?$/,
            alias: 'punctuation'
        },
        'string': /(["'])(?:\\.|(?!\1)[^\\\r\n])*\1/,
        'number': /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee][+-]?\d+)?/,
        'boolean': /\b(?:false|true)\b/,
        'block': {
            pattern: /^(\s*(?:~\s*)?)[#\/]\S+?(?=\s*(?:~\s*)?$|\s)/,
            lookbehind: true,
            alias: 'keyword'
        },
        'brackets': {
            pattern: /\[[^\]]+\]/,
            inside: {
                punctuation: /\[|\]/,
                variable: /[\s\S]+/
            }
        },
        'punctuation': /[!"#%&':()*+,.\/;<=>@\[\\\]^`{|}~]/,
        'variable': /[^!"#%&'()*+,\/;<=>@\[\\\]^`{|}~\s]+/
    };
    Prism.hooks.add('before-tokenize', function(env) {
        var handlebarsPattern = /\{\{\{[\s\S]+?\}\}\}|\{\{[\s\S]+?\}\}/g;
        Prism.languages['markup-templating'].buildPlaceholders(env, 'handlebars', handlebarsPattern);
    });
    Prism.hooks.add('after-tokenize', function(env) {
        Prism.languages['markup-templating'].tokenizePlaceholders(env, 'handlebars');
    });
    Prism.languages.hbs = Prism.languages.handlebars;
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-json" */ // https://www.json.org/json-en.html
$adbd806745390bd1$var$prism.languages.json = {
    'property': {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: true,
        greedy: true
    },
    'string': {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: true,
        greedy: true
    },
    'comment': {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    'number': /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    'punctuation': /[{}[\],]/,
    'operator': /:/,
    'boolean': /\b(?:false|true)\b/,
    'null': {
        pattern: /\bnull\b/,
        alias: 'keyword'
    }
};
$adbd806745390bd1$var$prism.languages.webmanifest = $adbd806745390bd1$var$prism.languages.json;
/* "prismjs/components/prism-less" */ /* FIXME :
 :extend() is not handled specifically : its highlighting is buggy.
 Mixin usage must be inside a ruleset to be highlighted.
 At-rules (e.g. import) containing interpolations are buggy.
 Detached rulesets are highlighted as at-rules.
 A comment before a mixin usage prevents the latter to be properly highlighted.
 */ $adbd806745390bd1$var$prism.languages.less = $adbd806745390bd1$var$prism.languages.extend('css', {
    'comment': [
        /\/\*[\s\S]*?\*\//,
        {
            pattern: /(^|[^\\])\/\/.*/,
            lookbehind: true
        }
    ],
    'atrule': {
        pattern: /@[\w-](?:\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};\s]|\s+(?!\s))*?(?=\s*\{)/,
        inside: {
            'punctuation': /[:()]/
        }
    },
    // selectors and mixins are considered the same
    'selector': {
        pattern: /(?:@\{[\w-]+\}|[^{};\s@])(?:@\{[\w-]+\}|\((?:[^(){}]|\([^(){}]*\))*\)|[^(){};@\s]|\s+(?!\s))*?(?=\s*\{)/,
        inside: {
            // mixin parameters
            'variable': /@+[\w-]+/
        }
    },
    'property': /(?:@\{[\w-]+\}|[\w-])+(?:\+_?)?(?=\s*:)/,
    'operator': /[+\-*\/]/
});
$adbd806745390bd1$var$prism.languages.insertBefore('less', 'property', {
    'variable': [
        {
            pattern: /@[\w-]+\s*:/,
            inside: {
                'punctuation': /:/
            }
        },
        /@@?[\w-]+/
    ],
    'mixin-usage': {
        pattern: /([{;]\s*)[.#](?!\d)[\w-].*?(?=[(;])/,
        lookbehind: true,
        alias: 'function'
    }
});
/* "prismjs/components/prism-makefile" */ $adbd806745390bd1$var$prism.languages.makefile = {
    'comment': {
        pattern: /(^|[^\\])#(?:\\(?:\r\n|[\s\S])|[^\\\r\n])*/,
        lookbehind: true
    },
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'builtin-target': {
        pattern: /\.[A-Z][^:#=\s]+(?=\s*:(?!=))/,
        alias: 'builtin'
    },
    'target': {
        pattern: /^(?:[^:=\s]|[ \t]+(?![\s:]))+(?=\s*:(?!=))/m,
        alias: 'symbol',
        inside: {
            'variable': /\$+(?:(?!\$)[^(){}:#=\s]+|(?=[({]))/
        }
    },
    'variable': /\$+(?:(?!\$)[^(){}:#=\s]+|\([@*%<^+?][DF]\)|(?=[({]))/,
    // Directives
    'keyword': /-include\b|\b(?:define|else|endef|endif|export|ifn?def|ifn?eq|include|override|private|sinclude|undefine|unexport|vpath)\b/,
    'function': {
        pattern: /(\()(?:abspath|addsuffix|and|basename|call|dir|error|eval|file|filter(?:-out)?|findstring|firstword|flavor|foreach|guile|if|info|join|lastword|load|notdir|or|origin|patsubst|realpath|shell|sort|strip|subst|suffix|value|warning|wildcard|word(?:list|s)?)(?=[ \t])/,
        lookbehind: true
    },
    'operator': /(?:::|[?:+!])?=|[|@]/,
    'punctuation': /[:;(){}]/
};
/* "prismjs/components/prism-objectivec" */ $adbd806745390bd1$var$prism.languages.objectivec = $adbd806745390bd1$var$prism.languages.extend('c', {
    'string': {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    'keyword': /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    'operator': /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
});
delete $adbd806745390bd1$var$prism.languages.objectivec['class-name'];
$adbd806745390bd1$var$prism.languages.objc = $adbd806745390bd1$var$prism.languages.objectivec;
/* "prismjs/components/prism-ocaml" */ // https://ocaml.org/manual/lex.html
$adbd806745390bd1$var$prism.languages.ocaml = {
    'comment': {
        pattern: /\(\*[\s\S]*?\*\)/,
        greedy: true
    },
    'char': {
        pattern: /'(?:[^\\\r\n']|\\(?:.|[ox]?[0-9a-f]{1,3}))'/i,
        greedy: true
    },
    'string': [
        {
            pattern: /"(?:\\(?:[\s\S]|\r\n)|[^\\\r\n"])*"/,
            greedy: true
        },
        {
            pattern: /\{([a-z_]*)\|[\s\S]*?\|\1\}/,
            greedy: true
        }
    ],
    'number': [
        /\b(?:0b[01][01_]*|0o[0-7][0-7_]*)\b/i,
        /\b0x[a-f0-9][a-f0-9_]*(?:\.[a-f0-9_]*)?(?:p[+-]?\d[\d_]*)?(?!\w)/i,
        /\b\d[\d_]*(?:\.[\d_]*)?(?:e[+-]?\d[\d_]*)?(?!\w)/i
    ],
    'directive': {
        pattern: /\B#\w+/,
        alias: 'property'
    },
    'label': {
        pattern: /\B~\w+/,
        alias: 'property'
    },
    'type-variable': {
        pattern: /\B'\w+/,
        alias: 'function'
    },
    'variant': {
        pattern: /`\w+/,
        alias: 'symbol'
    },
    // For the list of keywords and operators,
    // see: http://caml.inria.fr/pub/docs/manual-ocaml/lex.html#sec84
    'keyword': /\b(?:as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|match|method|module|mutable|new|nonrec|object|of|open|private|rec|sig|struct|then|to|try|type|val|value|virtual|when|where|while|with)\b/,
    'boolean': /\b(?:false|true)\b/,
    'operator-like-punctuation': {
        pattern: /\[[<>|]|[>|]\]|\{<|>\}/,
        alias: 'punctuation'
    },
    // Custom operators are allowed
    'operator': /\.[.~]|:[=>]|[=<>@^|&+\-*\/$%!?~][!$%&*+\-.\/:<=>?@^|~]*|\b(?:and|asr|land|lor|lsl|lsr|lxor|mod|or)\b/,
    'punctuation': /;;|::|[(){}\[\].,:;#]|\b_\b/
};
/* "prismjs/components/prism-python" */ $adbd806745390bd1$var$prism.languages.python = {
    'comment': {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    'string-interpolation': {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            'interpolation': {
                // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    'format-spec': {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    'conversion-option': {
                        pattern: /![sra](?=[:}]$)/,
                        alias: 'punctuation'
                    },
                    rest: null
                }
            },
            'string': /[\s\S]+/
        }
    },
    'triple-quoted-string': {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: 'string'
    },
    'string': {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    'function': {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    'class-name': {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    'decorator': {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            'annotation',
            'punctuation'
        ],
        inside: {
            'punctuation': /\./
        }
    },
    'keyword': /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    'builtin': /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    'boolean': /\b(?:False|None|True)\b/,
    'number': /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    'operator': /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    'punctuation': /[{}[\];(),.:]/
};
$adbd806745390bd1$var$prism.languages.python['string-interpolation'].inside['interpolation'].inside.rest = $adbd806745390bd1$var$prism.languages.python;
$adbd806745390bd1$var$prism.languages.py = $adbd806745390bd1$var$prism.languages.python;
/* "prismjs/components/prism-reason" */ $adbd806745390bd1$var$prism.languages.reason = $adbd806745390bd1$var$prism.languages.extend('clike', {
    'string': {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: true
    },
    // 'class-name' must be matched *after* 'constructor' defined below
    'class-name': /\b[A-Z]\w*/,
    'keyword': /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    'operator': /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
});
$adbd806745390bd1$var$prism.languages.insertBefore('reason', 'class-name', {
    'char': {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: true
    },
    // Negative look-ahead prevents from matching things like String.capitalize
    'constructor': /\b[A-Z]\w*\b(?!\s*\.)/,
    'label': {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: 'symbol'
    }
}); // We can't match functions property, so let's not even try.
delete $adbd806745390bd1$var$prism.languages.reason.function;
/* "prismjs/components/prism-sass" */ (function(Prism) {
    Prism.languages.sass = Prism.languages.extend('css', {
        // Sass comments don't need to be closed, only indented
        'comment': {
            pattern: /^([ \t]*)\/[\/*].*(?:(?:\r?\n|\r)\1[ \t].+)*/m,
            lookbehind: true,
            greedy: true
        }
    });
    Prism.languages.insertBefore('sass', 'atrule', {
        // We want to consume the whole line
        'atrule-line': {
            // Includes support for = and + shortcuts
            pattern: /^(?:[ \t]*)[@+=].+/m,
            greedy: true,
            inside: {
                'atrule': /(?:@[\w-]+|[+=])/
            }
        }
    });
    delete Prism.languages.sass.atrule;
    var variable = /\$[-\w]+|#\{\$[-\w]+\}/;
    var operator = [
        /[+*\/%]|[=!]=|<=?|>=?|\b(?:and|not|or)\b/,
        {
            pattern: /(\s)-(?=\s)/,
            lookbehind: true
        }
    ];
    Prism.languages.insertBefore('sass', 'property', {
        // We want to consume the whole line
        'variable-line': {
            pattern: /^[ \t]*\$.+/m,
            greedy: true,
            inside: {
                'punctuation': /:/,
                'variable': variable,
                'operator': operator
            }
        },
        // We want to consume the whole line
        'property-line': {
            pattern: /^[ \t]*(?:[^:\s]+ *:.*|:[^:\s].*)/m,
            greedy: true,
            inside: {
                'property': [
                    /[^:\s]+(?=\s*:)/,
                    {
                        pattern: /(:)[^:\s]+/,
                        lookbehind: true
                    }
                ],
                'punctuation': /:/,
                'variable': variable,
                'operator': operator,
                'important': Prism.languages.sass.important
            }
        }
    });
    delete Prism.languages.sass.property;
    delete Prism.languages.sass.important; // Now that whole lines for other patterns are consumed,
    // what's left should be selectors
    Prism.languages.insertBefore('sass', 'punctuation', {
        'selector': {
            pattern: /^([ \t]*)\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*(?:,(?:\r?\n|\r)\1[ \t]+\S(?:,[^,\r\n]+|[^,\r\n]*)(?:,[^,\r\n]+)*)*/m,
            lookbehind: true,
            greedy: true
        }
    });
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-scss" */ $adbd806745390bd1$var$prism.languages.scss = $adbd806745390bd1$var$prism.languages.extend('css', {
    'comment': {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
        lookbehind: true
    },
    'atrule': {
        pattern: /@[\w-](?:\([^()]+\)|[^()\s]|\s+(?!\s))*?(?=\s+[{;])/,
        inside: {
            'rule': /@[\w-]+/ // See rest below
        }
    },
    // url, compassified
    'url': /(?:[-a-z]+-)?url(?=\()/i,
    // CSS selector regex is not appropriate for Sass
    // since there can be lot more things (var, @ directive, nesting..)
    // a selector must start at the end of a property or after a brace (end of other rules or nesting)
    // it can contain some characters that aren't used for defining rules or end of selector, & (parent selector), or interpolated variable
    // the end of a selector is found when there is no rules in it ( {} or {\s}) or if there is a property (because an interpolated var
    // can "pass" as a selector- e.g: proper#{$erty})
    // this one was hard to do, so please be careful if you edit this one :)
    'selector': {
        // Initial look-ahead is used to prevent matching of blank selectors
        pattern: /(?=\S)[^@;{}()]?(?:[^@;{}()\s]|\s+(?!\s)|#\{\$[-\w]+\})+(?=\s*\{(?:\}|\s|[^}][^:{}]*[:{][^}]))/,
        inside: {
            'parent': {
                pattern: /&/,
                alias: 'important'
            },
            'placeholder': /%[-\w]+/,
            'variable': /\$[-\w]+|#\{\$[-\w]+\}/
        }
    },
    'property': {
        pattern: /(?:[-\w]|\$[-\w]|#\{\$[-\w]+\})+(?=\s*:)/,
        inside: {
            'variable': /\$[-\w]+|#\{\$[-\w]+\}/
        }
    }
});
$adbd806745390bd1$var$prism.languages.insertBefore('scss', 'atrule', {
    'keyword': [
        /@(?:content|debug|each|else(?: if)?|extend|for|forward|function|if|import|include|mixin|return|use|warn|while)\b/i,
        {
            pattern: /( )(?:from|through)(?= )/,
            lookbehind: true
        }
    ]
});
$adbd806745390bd1$var$prism.languages.insertBefore('scss', 'important', {
    // var and interpolated vars
    'variable': /\$[-\w]+|#\{\$[-\w]+\}/
});
$adbd806745390bd1$var$prism.languages.insertBefore('scss', 'function', {
    'module-modifier': {
        pattern: /\b(?:as|hide|show|with)\b/i,
        alias: 'keyword'
    },
    'placeholder': {
        pattern: /%[-\w]+/,
        alias: 'selector'
    },
    'statement': {
        pattern: /\B!(?:default|optional)\b/i,
        alias: 'keyword'
    },
    'boolean': /\b(?:false|true)\b/,
    'null': {
        pattern: /\bnull\b/,
        alias: 'keyword'
    },
    'operator': {
        pattern: /(\s)(?:[-+*\/%]|[=!]=|<=?|>=?|and|not|or)(?=\s)/,
        lookbehind: true
    }
});
$adbd806745390bd1$var$prism.languages.scss['atrule'].inside.rest = $adbd806745390bd1$var$prism.languages.scss;
/* "prismjs/components/prism-stylus" */ (function(Prism) {
    var unit = {
        pattern: /(\b\d+)(?:%|[a-z]+)/,
        lookbehind: true
    }; // 123 -123 .123 -.123 12.3 -12.3
    var number = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: true
    };
    var inside = {
        'comment': {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true
        },
        'url': {
            pattern: /\burl\((["']?).*?\1\)/i,
            greedy: true
        },
        'string': {
            pattern: /("|')(?:(?!\1)[^\\\r\n]|\\(?:\r\n|[\s\S]))*\1/,
            greedy: true
        },
        'interpolation': null,
        // See below
        'func': null,
        // See below
        'important': /\B!(?:important|optional)\b/i,
        'keyword': {
            pattern: /(^|\s+)(?:(?:else|for|if|return|unless)(?=\s|$)|@[\w-]+)/,
            lookbehind: true
        },
        'hexcode': /#[\da-f]{3,6}/i,
        'color': [
            /\b(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)\b/i,
            {
                pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                inside: {
                    'unit': unit,
                    'number': number,
                    'function': /[\w-]+(?=\()/,
                    'punctuation': /[(),]/
                }
            }
        ],
        'entity': /\\[\da-f]{1,8}/i,
        'unit': unit,
        'boolean': /\b(?:false|true)\b/,
        'operator': [
            // accepted in property names.
            /~|[+!\/%<>?=]=?|[-:]=|\*[*=]?|\.{2,3}|&&|\|\||\B-\B|\b(?:and|in|is(?: a| defined| not|nt)?|not|or)\b/
        ],
        'number': number,
        'punctuation': /[{}()\[\];:,]/
    };
    inside['interpolation'] = {
        pattern: /\{[^\r\n}:]+\}/,
        alias: 'variable',
        inside: {
            'delimiter': {
                pattern: /^\{|\}$/,
                alias: 'punctuation'
            },
            rest: inside
        }
    };
    inside['func'] = {
        pattern: /[\w-]+\([^)]*\).*/,
        inside: {
            'function': /^[^(]+/,
            rest: inside
        }
    };
    Prism.languages.stylus = {
        'atrule-declaration': {
            pattern: /(^[ \t]*)@.+/m,
            lookbehind: true,
            inside: {
                'atrule': /^@[\w-]+/,
                rest: inside
            }
        },
        'variable-declaration': {
            pattern: /(^[ \t]*)[\w$-]+\s*.?=[ \t]*(?:\{[^{}]*\}|\S.*|$)/m,
            lookbehind: true,
            inside: {
                'variable': /^\S+/,
                rest: inside
            }
        },
        'statement': {
            pattern: /(^[ \t]*)(?:else|for|if|return|unless)[ \t].+/m,
            lookbehind: true,
            inside: {
                'keyword': /^\S+/,
                rest: inside
            }
        },
        // A property/value pair cannot end with a comma or a brace
        // It cannot have indented content unless it ended with a semicolon
        'property-declaration': {
            pattern: /((?:^|\{)([ \t]*))(?:[\w-]|\{[^}\r\n]+\})+(?:\s*:\s*|[ \t]+)(?!\s)[^{\r\n]*(?:;|[^{\r\n,]$(?!(?:\r?\n|\r)(?:\{|\2[ \t])))/m,
            lookbehind: true,
            inside: {
                'property': {
                    pattern: /^[^\s:]+/,
                    inside: {
                        'interpolation': inside.interpolation
                    }
                },
                rest: inside
            }
        },
        // A selector can contain parentheses only as part of a pseudo-element
        // It can span multiple lines.
        // It must end with a comma or an accolade or have indented content.
        'selector': {
            pattern: /(^[ \t]*)(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)(?:(?:\r?\n|\r)(?:\1(?:(?=\S)(?:[^{}\r\n:()]|::?[\w-]+(?:\([^)\r\n]*\)|(?![\w-]))|\{[^}\r\n]+\})+)))*(?:,$|\{|(?=(?:\r?\n|\r)(?:\{|\1[ \t])))/m,
            lookbehind: true,
            inside: {
                'interpolation': inside.interpolation,
                'comment': inside.comment,
                'punctuation': /[{},]/
            }
        },
        'func': inside.func,
        'string': inside.string,
        'comment': {
            pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|\/\/.*)/,
            lookbehind: true,
            greedy: true
        },
        'interpolation': inside.interpolation,
        'punctuation': /[{}()\[\];:.]/
    };
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-tsx" */ (function(Prism) {
    var typescript = Prism.util.clone(Prism.languages.typescript);
    Prism.languages.tsx = Prism.languages.extend('jsx', typescript); // doesn't work with TS because TS is too complex
    delete Prism.languages.tsx['parameter'];
    delete Prism.languages.tsx['literal-property']; // This will prevent collisions between TSX tags and TS generic types.
    // Idea by https://github.com/karlhorky
    // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
    var tag = Prism.languages.tsx.tag;
    tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
    tag.lookbehind = true;
})($adbd806745390bd1$var$prism);
/* "prismjs/components/prism-wasm" */ $adbd806745390bd1$var$prism.languages.wasm = {
    'comment': [
        /\(;[\s\S]*?;\)/,
        {
            pattern: /;;.*/,
            greedy: true
        }
    ],
    'string': {
        pattern: /"(?:\\[\s\S]|[^"\\])*"/,
        greedy: true
    },
    'keyword': [
        {
            pattern: /\b(?:align|offset)=/,
            inside: {
                'operator': /=/
            }
        },
        {
            pattern: /\b(?:(?:f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|neg?|nearest|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|sqrt|store(?:8|16|32)?|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))?|memory\.(?:grow|size))\b/,
            inside: {
                'punctuation': /\./
            }
        },
        /\b(?:anyfunc|block|br(?:_if|_table)?|call(?:_indirect)?|data|drop|elem|else|end|export|func|get_(?:global|local)|global|if|import|local|loop|memory|module|mut|nop|offset|param|result|return|select|set_(?:global|local)|start|table|tee_local|then|type|unreachable)\b/
    ],
    'variable': /\$[\w!#$%&'*+\-./:<=>?@\\^`|~]+/,
    'number': /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/,
    'punctuation': /[()]/
};
var $adbd806745390bd1$export$2e2bcd8739ae039 = $adbd806745390bd1$var$prism;

});

parcelRegister("iKJLP", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7006edf2c96e6a$export$2e2bcd8739ae039);
// Duotone Dark
// Author: Simurai, adapted from DuoTone themes for Atom (http://simurai.com/projects/2016/01/01/duotone-themes)
// Conversion: Bram de Haan (http://atelierbram.github.io/Base2Tone-prism/output/prism/prism-base2tone-evening-dark.css)
// Generated with Base16 Builder (https://github.com/base16-builder/base16-builder)
var $da7006edf2c96e6a$var$theme = {
    plain: {
        backgroundColor: "#2a2734",
        color: "#9a86fd"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#6c6783"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#e09142"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#9a86fd"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#eeebff"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#c4b9fe"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule",
                "placeholder",
                "variable"
            ],
            style: {
                color: "#ffcc99"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#c4b9fe"
            }
        }
    ]
};
var $da7006edf2c96e6a$export$2e2bcd8739ae039 = $da7006edf2c96e6a$var$theme;

});


parcelRegister("4OdfS", function(module, exports) {

$parcel$export(module.exports, "CopyIcon", () => $38061d1baa418286$export$51b6cd98f8778f0d);

var $acw62 = parcelRequire("acw62");
function $38061d1baa418286$export$51b6cd98f8778f0d({ copied: copied }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            width: "1rem",
            height: "1rem"
        }
    }, copied ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM11 2V2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.33579 3 4 2.66421 4 2.25V2H3.5C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V2.5C12 2.22386 11.7761 2 11.5 2H11Z",
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
}
$38061d1baa418286$export$51b6cd98f8778f0d.displayName = "@mantine/prism/CopyIcon";

});

parcelRegister("hsLTx", function(module, exports) {

$parcel$export(module.exports, "getPrismTheme", () => $0347e810f8f75c5c$export$9c3bfff9cdc679b9);
const $0347e810f8f75c5c$export$55ce6f3a06c59543 = (theme)=>({
        plain: {
            color: theme.colors.gray[4],
            backgroundColor: theme.colors.dark[8]
        },
        styles: [
            {
                types: [
                    "comment"
                ],
                style: {
                    color: theme.colors.gray[6]
                }
            },
            {
                types: [
                    "string",
                    "inserted",
                    "selector",
                    "atrule"
                ],
                style: {
                    color: theme.colors.teal[4]
                }
            },
            {
                types: [
                    "number"
                ],
                style: {
                    color: theme.colors.blue[4]
                }
            },
            {
                types: [
                    "builtin",
                    "char",
                    "constant",
                    "function"
                ],
                style: {
                    color: theme.colors.orange[5]
                }
            },
            {
                types: [
                    "punctuation"
                ],
                style: {
                    color: theme.colors.gray[5]
                }
            },
            {
                types: [
                    "variable"
                ],
                style: {
                    color: theme.colors.gray[5]
                }
            },
            {
                types: [
                    "class-name",
                    "attr-name"
                ],
                style: {
                    color: theme.colors.yellow[5]
                }
            },
            {
                types: [
                    "tag",
                    "deleted"
                ],
                style: {
                    color: theme.colors.red[6]
                }
            },
            {
                types: [
                    "operator"
                ],
                style: {
                    color: theme.colors.gray[5]
                }
            },
            {
                types: [
                    "boolean"
                ],
                style: {
                    color: theme.colors.red[6]
                }
            },
            {
                types: [
                    "keyword"
                ],
                style: {
                    color: theme.colors.indigo[3]
                }
            },
            {
                types: [
                    "doctype"
                ],
                style: {
                    color: theme.colors.gray[5]
                }
            },
            {
                types: [
                    "url"
                ],
                style: {
                    color: theme.colors.gray[5]
                }
            }
        ]
    });
const $0347e810f8f75c5c$export$a43af521ac8c3202 = (theme)=>({
        plain: {
            color: theme.colors.gray[9],
            backgroundColor: theme.fn.rgba(theme.colors.gray[0], 0.65)
        },
        styles: [
            {
                types: [
                    "comment"
                ],
                style: {
                    color: theme.colors.gray[6]
                }
            },
            {
                types: [
                    "string",
                    "inserted"
                ],
                style: {
                    color: theme.colors.indigo[9]
                }
            },
            {
                types: [
                    "number"
                ],
                style: {
                    color: theme.colors.blue[7]
                }
            },
            {
                types: [
                    "builtin",
                    "char",
                    "constant",
                    "function",
                    "selector",
                    "atrule"
                ],
                style: {
                    color: theme.colors.lime[9]
                }
            },
            {
                types: [
                    "punctuation"
                ],
                style: {
                    color: theme.colors.gray[7]
                }
            },
            {
                types: [
                    "variable"
                ],
                style: {
                    color: theme.colors.violet[9]
                }
            },
            {
                types: [
                    "attr-name"
                ],
                style: {
                    color: theme.colors.green[9]
                }
            },
            {
                types: [
                    "class-name"
                ],
                style: {
                    color: theme.colors.red[9]
                }
            },
            {
                types: [
                    "tag",
                    "deleted"
                ],
                style: {
                    color: theme.colors.violet[9]
                }
            },
            {
                types: [
                    "operator"
                ],
                style: {
                    color: theme.colors.red[9]
                }
            },
            {
                types: [
                    "boolean"
                ],
                style: {
                    color: theme.colors.red[9]
                }
            },
            {
                types: [
                    "keyword"
                ],
                style: {
                    color: theme.colors.red[9]
                }
            },
            {
                types: [
                    "doctype"
                ],
                style: {
                    color: theme.colors.gray[7]
                }
            },
            {
                types: [
                    "url"
                ],
                style: {
                    color: theme.colors.gray[7]
                }
            }
        ]
    });
const $0347e810f8f75c5c$export$9c3bfff9cdc679b9 = (theme, colorScheme)=>colorScheme === "dark" ? $0347e810f8f75c5c$export$55ce6f3a06c59543(theme) : $0347e810f8f75c5c$export$a43af521ac8c3202(theme);

});

parcelRegister("lK1gV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3ee16cb8f1b7de$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $fd3ee16cb8f1b7de$var$useStyles = (0, $cQG1Y.createStyles)((theme, { colorScheme: colorScheme, native: native, maxLineSize: maxLineSize, radius: radius })=>({
        scrollArea: {},
        root: {
            position: "relative"
        },
        code: {
            boxSizing: "border-box",
            position: "relative",
            fontFamily: theme.fontFamilyMonospace,
            lineHeight: 1.7,
            fontSize: (0, $2jkdX.rem)(13),
            overflowX: native ? "auto" : void 0,
            borderRadius: theme.fn.radius(radius),
            padding: `${theme.spacing.sm} 0`,
            "&.mantine-Prism-code": {
                marginTop: 0,
                marginBottom: 0
            }
        },
        copy: {
            position: "absolute",
            top: theme.spacing.xs,
            right: theme.dir === "ltr" ? theme.spacing.xs : "unset",
            left: theme.dir === "rtl" ? theme.spacing.xs : "unset",
            zIndex: 2,
            "&, &:hover": {
                backgroundColor: colorScheme === "dark" ? theme.colors.dark[8] : theme.colors.gray[0]
            }
        },
        line: {
            display: "flex",
            width: "100%",
            padding: `0 ${theme.spacing.md}`
        },
        lineNumber: {
            color: colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4],
            textAlign: "right",
            width: `calc(8 * ${(0, $2jkdX.rem)(maxLineSize)})`,
            marginRight: theme.dir === "ltr" ? theme.spacing.xs : void 0,
            marginLeft: theme.dir === "rtl" ? theme.spacing.xs : void 0,
            userSelect: "none"
        },
        lineContent: {
            width: "100%"
        }
    }));
var $fd3ee16cb8f1b7de$export$2e2bcd8739ae039 = $fd3ee16cb8f1b7de$var$useStyles;

});


parcelRegister("uShn9", function(module, exports) {

$parcel$export(module.exports, "default", () => $05cce82cb7a55e98$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $05cce82cb7a55e98$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius })=>({
        tab: {
            paddingLeft: theme.spacing.sm,
            paddingRight: theme.spacing.sm,
            height: (0, $2jkdX.rem)(34),
            border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[3]}`,
            borderBottom: 0,
            fontSize: theme.fontSizes.sm,
            color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[7],
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            borderRadius: 0,
            "&:first-of-type": {
                borderTopLeftRadius: theme.radius.sm
            },
            "&:not(:first-of-type)": {
                borderLeft: 0
            },
            "&:last-of-type": {
                borderTopRightRadius: theme.radius.sm
            },
            "&:hover": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[0]
            },
            "&[data-active]": {
                color: theme.colorScheme === "dark" ? theme.white : theme.black,
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[8] : theme.fn.rgba(theme.colors.gray[0], 0.65),
                "&::before": {
                    backgroundColor: "transparent"
                }
            }
        },
        prism: {
            borderRadius: theme.fn.radius(radius),
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            border: `${(0, $2jkdX.rem)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]}`,
            borderTop: 0,
            overflow: "hidden"
        },
        code: {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            border: 0
        }
    }));
var $05cce82cb7a55e98$export$2e2bcd8739ae039 = $05cce82cb7a55e98$var$useStyles;

});



parcelRegister("2cTph", function(module, exports) {

$parcel$export(module.exports, "Calendar", () => $19b7ae6700bcdce2$export$e1aef45b828286de);

var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $ke4gU = parcelRequire("ke4gU");

var $fDdt2 = parcelRequire("fDdt2");

var $5V8BA = parcelRequire("5V8BA");

var $8DdJX = parcelRequire("8DdJX");

var $ltV4Q = parcelRequire("ltV4Q");

var $4DmD7 = parcelRequire("4DmD7");
var $19b7ae6700bcdce2$var$__defProp = Object.defineProperty;
var $19b7ae6700bcdce2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $19b7ae6700bcdce2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $19b7ae6700bcdce2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $19b7ae6700bcdce2$var$__defNormalProp = (obj, key, value)=>key in obj ? $19b7ae6700bcdce2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $19b7ae6700bcdce2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($19b7ae6700bcdce2$var$__hasOwnProp.call(b, prop)) $19b7ae6700bcdce2$var$__defNormalProp(a, prop, b[prop]);
    if ($19b7ae6700bcdce2$var$__getOwnPropSymbols) {
        for (var prop of $19b7ae6700bcdce2$var$__getOwnPropSymbols(b))if ($19b7ae6700bcdce2$var$__propIsEnum.call(b, prop)) $19b7ae6700bcdce2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $19b7ae6700bcdce2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($19b7ae6700bcdce2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $19b7ae6700bcdce2$var$__getOwnPropSymbols) {
        for (var prop of $19b7ae6700bcdce2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $19b7ae6700bcdce2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $19b7ae6700bcdce2$var$defaultProps = {
    maxLevel: "decade",
    minLevel: "month",
    __updateDateOnYearSelect: true,
    __updateDateOnMonthSelect: true
};
const $19b7ae6700bcdce2$export$e1aef45b828286de = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Calendar", $19b7ae6700bcdce2$var$defaultProps, props), { maxLevel: maxLevel, minLevel: minLevel, defaultLevel: defaultLevel, level: level, onLevelChange: onLevelChange, date: date, defaultDate: defaultDate, onDateChange: onDateChange, numberOfColumns: numberOfColumns, columnsToScroll: columnsToScroll, ariaLabels: ariaLabels, onYearSelect: onYearSelect, onMonthSelect: onMonthSelect, onYearMouseEnter: onYearMouseEnter, onMonthMouseEnter: onMonthMouseEnter, __updateDateOnYearSelect: __updateDateOnYearSelect, __updateDateOnMonthSelect: __updateDateOnMonthSelect, firstDayOfWeek: firstDayOfWeek, weekdayFormat: weekdayFormat, weekendDays: weekendDays, getDayProps: getDayProps, excludeDate: excludeDate, renderDay: renderDay, hideOutsideDates: hideOutsideDates, hideWeekdays: hideWeekdays, getDayAriaLabel: getDayAriaLabel, monthLabelFormat: monthLabelFormat, nextIcon: nextIcon, previousIcon: previousIcon, __onDayClick: __onDayClick, __onDayMouseEnter: __onDayMouseEnter, withCellSpacing: withCellSpacing, monthsListFormat: monthsListFormat, getMonthControlProps: getMonthControlProps, yearLabelFormat: yearLabelFormat, yearsListFormat: yearsListFormat, getYearControlProps: getYearControlProps, decadeLabelFormat: decadeLabelFormat, minDate: minDate, maxDate: maxDate, locale: locale, className: className, classNames: classNames, styles: styles, __staticSelector: __staticSelector, unstyled: unstyled, variant: variant, size: size, __preventFocus: __preventFocus, __stopPropagation: __stopPropagation, onNextDecade: onNextDecade, onPreviousDecade: onPreviousDecade, onNextYear: onNextYear, onPreviousYear: onPreviousYear, onNextMonth: onNextMonth, onPreviousMonth: onPreviousMonth, static: isStatic } = _a, others = $19b7ae6700bcdce2$var$__objRest(_a, [
        "maxLevel",
        "minLevel",
        "defaultLevel",
        "level",
        "onLevelChange",
        "date",
        "defaultDate",
        "onDateChange",
        "numberOfColumns",
        "columnsToScroll",
        "ariaLabels",
        "onYearSelect",
        "onMonthSelect",
        "onYearMouseEnter",
        "onMonthMouseEnter",
        "__updateDateOnYearSelect",
        "__updateDateOnMonthSelect",
        "firstDayOfWeek",
        "weekdayFormat",
        "weekendDays",
        "getDayProps",
        "excludeDate",
        "renderDay",
        "hideOutsideDates",
        "hideWeekdays",
        "getDayAriaLabel",
        "monthLabelFormat",
        "nextIcon",
        "previousIcon",
        "__onDayClick",
        "__onDayMouseEnter",
        "withCellSpacing",
        "monthsListFormat",
        "getMonthControlProps",
        "yearLabelFormat",
        "yearsListFormat",
        "getYearControlProps",
        "decadeLabelFormat",
        "minDate",
        "maxDate",
        "locale",
        "className",
        "classNames",
        "styles",
        "__staticSelector",
        "unstyled",
        "variant",
        "size",
        "__preventFocus",
        "__stopPropagation",
        "onNextDecade",
        "onPreviousDecade",
        "onNextYear",
        "onPreviousYear",
        "onNextMonth",
        "onPreviousMonth",
        "static"
    ]);
    const { classes: classes, cx: cx } = (0, $5V8BA.default)(null, {
        name: [
            "Calendar",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const [_level, setLevel] = (0, $ke4gU.useUncontrolled)({
        value: level ? (0, $fDdt2.clampLevel)(level, minLevel, maxLevel) : void 0,
        defaultValue: defaultLevel ? (0, $fDdt2.clampLevel)(defaultLevel, minLevel, maxLevel) : void 0,
        finalValue: (0, $fDdt2.clampLevel)(void 0, minLevel, maxLevel),
        onChange: onLevelChange
    });
    const [_date, setDate] = (0, $ke4gU.useUncontrolled)({
        value: date,
        defaultValue: defaultDate,
        finalValue: null,
        onChange: onDateChange
    });
    const stylesApiProps = {
        __staticSelector: __staticSelector || "Calendar",
        styles: styles,
        classNames: classNames,
        unstyled: unstyled,
        variant: variant,
        size: size
    };
    const _columnsToScroll = columnsToScroll || numberOfColumns || 1;
    const currentDate = _date || new Date();
    const handleNextMonth = ()=>{
        const nextDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(currentDate).add(_columnsToScroll, "month").toDate();
        onNextMonth == null || onNextMonth(nextDate);
        setDate(nextDate);
    };
    const handlePreviousMonth = ()=>{
        const nextDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(currentDate).subtract(_columnsToScroll, "month").toDate();
        onPreviousMonth == null || onPreviousMonth(nextDate);
        setDate(nextDate);
    };
    const handleNextYear = ()=>{
        const nextDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(currentDate).add(_columnsToScroll, "year").toDate();
        onNextYear == null || onNextYear(nextDate);
        setDate(nextDate);
    };
    const handlePreviousYear = ()=>{
        const nextDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(currentDate).subtract(_columnsToScroll, "year").toDate();
        onPreviousYear == null || onPreviousYear(nextDate);
        setDate(nextDate);
    };
    const handleNextDecade = ()=>{
        const nextDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(currentDate).add(10 * _columnsToScroll, "year").toDate();
        onNextDecade == null || onNextDecade(nextDate);
        setDate(nextDate);
    };
    const handlePreviousDecade = ()=>{
        const nextDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(currentDate).subtract(10 * _columnsToScroll, "year").toDate();
        onPreviousDecade == null || onPreviousDecade(nextDate);
        setDate(nextDate);
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $19b7ae6700bcdce2$var$__spreadValues({
        className: cx(classes.calendar, className),
        ref: ref
    }, others), _level === "month" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8DdJX.MonthLevelGroup), $19b7ae6700bcdce2$var$__spreadValues({
        month: currentDate,
        minDate: minDate,
        maxDate: maxDate,
        firstDayOfWeek: firstDayOfWeek,
        weekdayFormat: weekdayFormat,
        weekendDays: weekendDays,
        getDayProps: getDayProps,
        excludeDate: excludeDate,
        renderDay: renderDay,
        hideOutsideDates: hideOutsideDates,
        hideWeekdays: hideWeekdays,
        getDayAriaLabel: getDayAriaLabel,
        onNext: handleNextMonth,
        onPrevious: handlePreviousMonth,
        hasNextLevel: maxLevel !== "month",
        onLevelClick: ()=>setLevel("year"),
        numberOfColumns: numberOfColumns,
        locale: locale,
        levelControlAriaLabel: ariaLabels == null ? void 0 : ariaLabels.monthLevelControl,
        nextLabel: ariaLabels == null ? void 0 : ariaLabels.nextMonth,
        nextIcon: nextIcon,
        previousLabel: ariaLabels == null ? void 0 : ariaLabels.previousMonth,
        previousIcon: previousIcon,
        monthLabelFormat: monthLabelFormat,
        __onDayClick: __onDayClick,
        __onDayMouseEnter: __onDayMouseEnter,
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        static: isStatic,
        withCellSpacing: withCellSpacing
    }, stylesApiProps)), _level === "year" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ltV4Q.YearLevelGroup), $19b7ae6700bcdce2$var$__spreadValues({
        year: currentDate,
        numberOfColumns: numberOfColumns,
        minDate: minDate,
        maxDate: maxDate,
        monthsListFormat: monthsListFormat,
        getMonthControlProps: getMonthControlProps,
        locale: locale,
        onNext: handleNextYear,
        onPrevious: handlePreviousYear,
        hasNextLevel: maxLevel !== "month" && maxLevel !== "year",
        onLevelClick: ()=>setLevel("decade"),
        levelControlAriaLabel: ariaLabels == null ? void 0 : ariaLabels.yearLevelControl,
        nextLabel: ariaLabels == null ? void 0 : ariaLabels.nextYear,
        nextIcon: nextIcon,
        previousLabel: ariaLabels == null ? void 0 : ariaLabels.previousYear,
        previousIcon: previousIcon,
        yearLabelFormat: yearLabelFormat,
        __onControlMouseEnter: onMonthMouseEnter,
        __onControlClick: (_event, payload)=>{
            __updateDateOnMonthSelect && setDate(payload);
            setLevel((0, $fDdt2.clampLevel)("month", minLevel, maxLevel));
            onMonthSelect == null || onMonthSelect(payload);
        },
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        withCellSpacing: withCellSpacing
    }, stylesApiProps)), _level === "decade" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4DmD7.DecadeLevelGroup), $19b7ae6700bcdce2$var$__spreadValues({
        decade: currentDate,
        minDate: minDate,
        maxDate: maxDate,
        yearsListFormat: yearsListFormat,
        getYearControlProps: getYearControlProps,
        locale: locale,
        onNext: handleNextDecade,
        onPrevious: handlePreviousDecade,
        numberOfColumns: numberOfColumns,
        nextLabel: ariaLabels == null ? void 0 : ariaLabels.nextDecade,
        nextIcon: nextIcon,
        previousLabel: ariaLabels == null ? void 0 : ariaLabels.previousDecade,
        previousIcon: previousIcon,
        decadeLabelFormat: decadeLabelFormat,
        __onControlMouseEnter: onYearMouseEnter,
        __onControlClick: (_event, payload)=>{
            __updateDateOnYearSelect && setDate(payload);
            setLevel((0, $fDdt2.clampLevel)("year", minLevel, maxLevel));
            onYearSelect == null || onYearSelect(payload);
        },
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        withCellSpacing: withCellSpacing
    }, stylesApiProps)));
});
$19b7ae6700bcdce2$export$e1aef45b828286de.displayName = "@mantine/dates/Calendar";

});
parcelRegister("fDdt2", function(module, exports) {

$parcel$export(module.exports, "clampLevel", () => $b614f1df54c23d18$export$9d42fa127b87c088);

var $cVOeO = parcelRequire("cVOeO");
function $b614f1df54c23d18$var$levelToNumber(level, fallback) {
    if (!level) return fallback;
    return level === "month" ? 0 : level === "year" ? 1 : 2;
}
function $b614f1df54c23d18$var$levelNumberToLevel(levelNumber) {
    return levelNumber === 0 ? "month" : levelNumber === 1 ? "year" : "decade";
}
function $b614f1df54c23d18$export$9d42fa127b87c088(level, minLevel, maxLevel) {
    return $b614f1df54c23d18$var$levelNumberToLevel((0, $cVOeO.clamp)($b614f1df54c23d18$var$levelToNumber(level, 0), $b614f1df54c23d18$var$levelToNumber(minLevel, 0), $b614f1df54c23d18$var$levelToNumber(maxLevel, 2)));
}

});

parcelRegister("5V8BA", function(module, exports) {

$parcel$export(module.exports, "default", () => $44f8f36c6faec8e5$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $44f8f36c6faec8e5$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        calendar: {}
    }));
var $44f8f36c6faec8e5$export$2e2bcd8739ae039 = $44f8f36c6faec8e5$var$useStyles;

});

parcelRegister("8DdJX", function(module, exports) {

$parcel$export(module.exports, "MonthLevelGroup", () => $648c9fc4a343d362$export$6e15ec8fa84131f4);

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $gngdn = parcelRequire("gngdn");

var $kKnVf = parcelRequire("kKnVf");

var $lcv1D = parcelRequire("lcv1D");

var $iYtL2 = parcelRequire("iYtL2");
var $648c9fc4a343d362$var$__defProp = Object.defineProperty;
var $648c9fc4a343d362$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $648c9fc4a343d362$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $648c9fc4a343d362$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $648c9fc4a343d362$var$__defNormalProp = (obj, key, value)=>key in obj ? $648c9fc4a343d362$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $648c9fc4a343d362$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($648c9fc4a343d362$var$__hasOwnProp.call(b, prop)) $648c9fc4a343d362$var$__defNormalProp(a, prop, b[prop]);
    if ($648c9fc4a343d362$var$__getOwnPropSymbols) {
        for (var prop of $648c9fc4a343d362$var$__getOwnPropSymbols(b))if ($648c9fc4a343d362$var$__propIsEnum.call(b, prop)) $648c9fc4a343d362$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $648c9fc4a343d362$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($648c9fc4a343d362$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $648c9fc4a343d362$var$__getOwnPropSymbols) {
        for (var prop of $648c9fc4a343d362$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $648c9fc4a343d362$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $648c9fc4a343d362$var$defaultProps = {
    numberOfColumns: 1
};
const $648c9fc4a343d362$export$6e15ec8fa84131f4 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("MonthLevelGroup", $648c9fc4a343d362$var$defaultProps, props), { month: month, locale: locale, firstDayOfWeek: firstDayOfWeek, weekdayFormat: weekdayFormat, weekendDays: weekendDays, getDayProps: getDayProps, excludeDate: excludeDate, minDate: minDate, maxDate: maxDate, renderDay: renderDay, hideOutsideDates: hideOutsideDates, hideWeekdays: hideWeekdays, getDayAriaLabel: getDayAriaLabel, __onDayClick: __onDayClick, __onDayMouseEnter: __onDayMouseEnter, withCellSpacing: withCellSpacing, __preventFocus: __preventFocus, nextIcon: nextIcon, previousIcon: previousIcon, nextLabel: nextLabel, previousLabel: previousLabel, onNext: onNext, onPrevious: onPrevious, onLevelClick: onLevelClick, nextDisabled: nextDisabled, previousDisabled: previousDisabled, hasNextLevel: hasNextLevel, className: className, classNames: classNames, styles: styles, unstyled: unstyled, numberOfColumns: numberOfColumns, levelControlAriaLabel: levelControlAriaLabel, monthLabelFormat: monthLabelFormat, __staticSelector: __staticSelector, __stopPropagation: __stopPropagation, size: size, variant: variant, static: isStatic } = _a, others = $648c9fc4a343d362$var$__objRest(_a, [
        "month",
        "locale",
        "firstDayOfWeek",
        "weekdayFormat",
        "weekendDays",
        "getDayProps",
        "excludeDate",
        "minDate",
        "maxDate",
        "renderDay",
        "hideOutsideDates",
        "hideWeekdays",
        "getDayAriaLabel",
        "__onDayClick",
        "__onDayMouseEnter",
        "withCellSpacing",
        "__preventFocus",
        "nextIcon",
        "previousIcon",
        "nextLabel",
        "previousLabel",
        "onNext",
        "onPrevious",
        "onLevelClick",
        "nextDisabled",
        "previousDisabled",
        "hasNextLevel",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "numberOfColumns",
        "levelControlAriaLabel",
        "monthLabelFormat",
        "__staticSelector",
        "__stopPropagation",
        "size",
        "variant",
        "static"
    ]);
    const { classes: classes, cx: cx } = (0, $kKnVf.default)(null, {
        name: [
            "MonthLevelGroup",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const daysRefs = (0, $acw62.useRef)([]);
    const months = Array(numberOfColumns).fill(0).map((_, monthIndex)=>{
        const currentMonth = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(month).add(monthIndex, "months").toDate();
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lcv1D.MonthLevel), {
            key: monthIndex,
            month: currentMonth,
            withNext: monthIndex === numberOfColumns - 1,
            withPrevious: monthIndex === 0,
            monthLabelFormat: monthLabelFormat,
            __stopPropagation: __stopPropagation,
            __onDayClick: __onDayClick,
            __onDayMouseEnter: __onDayMouseEnter,
            __onDayKeyDown: (event, payload)=>(0, $iYtL2.handleControlKeyDown)({
                    levelIndex: monthIndex,
                    rowIndex: payload.rowIndex,
                    cellIndex: payload.cellIndex,
                    event: event,
                    controlsRef: daysRefs
                }),
            __getDayRef: (rowIndex, cellIndex, node)=>{
                if (!Array.isArray(daysRefs.current[monthIndex])) daysRefs.current[monthIndex] = [];
                if (!Array.isArray(daysRefs.current[monthIndex][rowIndex])) daysRefs.current[monthIndex][rowIndex] = [];
                daysRefs.current[monthIndex][rowIndex][cellIndex] = node;
            },
            levelControlAriaLabel: typeof levelControlAriaLabel === "function" ? levelControlAriaLabel(currentMonth) : levelControlAriaLabel,
            locale: locale,
            firstDayOfWeek: firstDayOfWeek,
            weekdayFormat: weekdayFormat,
            weekendDays: weekendDays,
            getDayProps: getDayProps,
            excludeDate: excludeDate,
            minDate: minDate,
            maxDate: maxDate,
            renderDay: renderDay,
            hideOutsideDates: hideOutsideDates,
            hideWeekdays: hideWeekdays,
            getDayAriaLabel: getDayAriaLabel,
            __preventFocus: __preventFocus,
            nextIcon: nextIcon,
            previousIcon: previousIcon,
            nextLabel: nextLabel,
            previousLabel: previousLabel,
            onNext: onNext,
            onPrevious: onPrevious,
            onLevelClick: onLevelClick,
            nextDisabled: nextDisabled,
            previousDisabled: previousDisabled,
            hasNextLevel: hasNextLevel,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            __staticSelector: __staticSelector || "MonthLevelGroup",
            size: size,
            variant: variant,
            static: isStatic,
            withCellSpacing: withCellSpacing
        });
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $648c9fc4a343d362$var$__spreadValues({
        className: cx(classes.monthLevelGroup, className),
        ref: ref
    }, others), months);
});
$648c9fc4a343d362$export$6e15ec8fa84131f4.displayName = "@mantine/dates/MonthLevelGroup";

});
parcelRegister("kKnVf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1aaa8fde918b89e$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $f1aaa8fde918b89e$var$useStyles = (0, $cQG1Y.createStyles)((theme, _, { size: size })=>({
        monthLevelGroup: {
            display: "flex",
            "& [data-month-level]:not(:last-of-type)": {
                marginRight: (0, $d8Ix8.getSize)({
                    size: size,
                    sizes: theme.spacing
                })
            }
        }
    }));
var $f1aaa8fde918b89e$export$2e2bcd8739ae039 = $f1aaa8fde918b89e$var$useStyles;

});

parcelRegister("lcv1D", function(module, exports) {

$parcel$export(module.exports, "MonthLevel", () => $f6f2c8f46ff3dc86$export$b5b2370aca3ee120);

var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $avHue = parcelRequire("avHue");

var $6YkAK = parcelRequire("6YkAK");

var $keeN6 = parcelRequire("keeN6");

var $adCIO = parcelRequire("adCIO");
var $f6f2c8f46ff3dc86$var$__defProp = Object.defineProperty;
var $f6f2c8f46ff3dc86$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $f6f2c8f46ff3dc86$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $f6f2c8f46ff3dc86$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $f6f2c8f46ff3dc86$var$__defNormalProp = (obj, key, value)=>key in obj ? $f6f2c8f46ff3dc86$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $f6f2c8f46ff3dc86$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($f6f2c8f46ff3dc86$var$__hasOwnProp.call(b, prop)) $f6f2c8f46ff3dc86$var$__defNormalProp(a, prop, b[prop]);
    if ($f6f2c8f46ff3dc86$var$__getOwnPropSymbols) {
        for (var prop of $f6f2c8f46ff3dc86$var$__getOwnPropSymbols(b))if ($f6f2c8f46ff3dc86$var$__propIsEnum.call(b, prop)) $f6f2c8f46ff3dc86$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $f6f2c8f46ff3dc86$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($f6f2c8f46ff3dc86$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $f6f2c8f46ff3dc86$var$__getOwnPropSymbols) {
        for (var prop of $f6f2c8f46ff3dc86$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $f6f2c8f46ff3dc86$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $f6f2c8f46ff3dc86$var$defaultProps = {
    monthLabelFormat: "MMMM YYYY"
};
const $f6f2c8f46ff3dc86$export$b5b2370aca3ee120 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("MonthLevel", $f6f2c8f46ff3dc86$var$defaultProps, props), { month: month, locale: locale, firstDayOfWeek: firstDayOfWeek, weekdayFormat: weekdayFormat, weekendDays: weekendDays, getDayProps: getDayProps, excludeDate: excludeDate, minDate: minDate, maxDate: maxDate, renderDay: renderDay, hideOutsideDates: hideOutsideDates, hideWeekdays: hideWeekdays, getDayAriaLabel: getDayAriaLabel, __getDayRef: __getDayRef, __onDayKeyDown: __onDayKeyDown, __onDayClick: __onDayClick, __onDayMouseEnter: __onDayMouseEnter, withCellSpacing: withCellSpacing, __preventFocus: __preventFocus, __stopPropagation: __stopPropagation, nextIcon: nextIcon, previousIcon: previousIcon, nextLabel: nextLabel, previousLabel: previousLabel, onNext: onNext, onPrevious: onPrevious, onLevelClick: onLevelClick, nextDisabled: nextDisabled, previousDisabled: previousDisabled, hasNextLevel: hasNextLevel, levelControlAriaLabel: levelControlAriaLabel, withNext: withNext, withPrevious: withPrevious, className: className, monthLabelFormat: monthLabelFormat, classNames: classNames, styles: styles, unstyled: unstyled, __staticSelector: __staticSelector, size: size, variant: variant, static: isStatic } = _a, others = $f6f2c8f46ff3dc86$var$__objRest(_a, [
        "month",
        "locale",
        "firstDayOfWeek",
        "weekdayFormat",
        "weekendDays",
        "getDayProps",
        "excludeDate",
        "minDate",
        "maxDate",
        "renderDay",
        "hideOutsideDates",
        "hideWeekdays",
        "getDayAriaLabel",
        "__getDayRef",
        "__onDayKeyDown",
        "__onDayClick",
        "__onDayMouseEnter",
        "withCellSpacing",
        "__preventFocus",
        "__stopPropagation",
        "nextIcon",
        "previousIcon",
        "nextLabel",
        "previousLabel",
        "onNext",
        "onPrevious",
        "onLevelClick",
        "nextDisabled",
        "previousDisabled",
        "hasNextLevel",
        "levelControlAriaLabel",
        "withNext",
        "withPrevious",
        "className",
        "monthLabelFormat",
        "classNames",
        "styles",
        "unstyled",
        "__staticSelector",
        "size",
        "variant",
        "static"
    ]);
    const { classes: classes, cx: cx } = (0, $avHue.default)(null, {
        name: [
            "MonthLevel",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const ctx = (0, $6YkAK.useDatesContext)();
    const stylesApiProps = {
        __staticSelector: __staticSelector || "MonthLevel",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    };
    const _nextDisabled = typeof nextDisabled === "boolean" ? nextDisabled : maxDate ? !(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(month).endOf("month").isBefore(maxDate) : false;
    const _previousDisabled = typeof previousDisabled === "boolean" ? previousDisabled : minDate ? !(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(month).startOf("month").isAfter(minDate) : false;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $f6f2c8f46ff3dc86$var$__spreadValues({
        className: cx(classes.monthLevel, className),
        "data-month-level": true,
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $keeN6.CalendarHeader), $f6f2c8f46ff3dc86$var$__spreadValues({
        label: typeof monthLabelFormat === "function" ? monthLabelFormat(month) : (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(month).locale(locale || ctx.locale).format(monthLabelFormat),
        className: classes.calendarHeader,
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        nextIcon: nextIcon,
        previousIcon: previousIcon,
        nextLabel: nextLabel,
        previousLabel: previousLabel,
        onNext: onNext,
        onPrevious: onPrevious,
        onLevelClick: onLevelClick,
        nextDisabled: _nextDisabled,
        previousDisabled: _previousDisabled,
        hasNextLevel: hasNextLevel,
        levelControlAriaLabel: levelControlAriaLabel,
        withNext: withNext,
        withPrevious: withPrevious
    }, stylesApiProps)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $adCIO.Month), $f6f2c8f46ff3dc86$var$__spreadValues({
        month: month,
        locale: locale,
        firstDayOfWeek: firstDayOfWeek,
        weekdayFormat: weekdayFormat,
        weekendDays: weekendDays,
        getDayProps: getDayProps,
        excludeDate: excludeDate,
        minDate: minDate,
        maxDate: maxDate,
        renderDay: renderDay,
        hideOutsideDates: hideOutsideDates,
        hideWeekdays: hideWeekdays,
        getDayAriaLabel: getDayAriaLabel,
        __getDayRef: __getDayRef,
        __onDayKeyDown: __onDayKeyDown,
        __onDayClick: __onDayClick,
        __onDayMouseEnter: __onDayMouseEnter,
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        static: isStatic,
        withCellSpacing: withCellSpacing
    }, stylesApiProps)));
});
$f6f2c8f46ff3dc86$export$b5b2370aca3ee120.displayName = "@mantine/dates/MonthLevel";

});
parcelRegister("avHue", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6e88263f89fb5b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $7a6e88263f89fb5b$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        monthLevel: {},
        calendarHeader: {
            marginBottom: theme.spacing.xs
        }
    }));
var $7a6e88263f89fb5b$export$2e2bcd8739ae039 = $7a6e88263f89fb5b$var$useStyles;

});

parcelRegister("6YkAK", function(module, exports) {

$parcel$export(module.exports, "useDatesContext", () => $513851bfbd827c35$export$2c268f202a81de5b);

var $acw62 = parcelRequire("acw62");

var $cnNDs = parcelRequire("cnNDs");
var $513851bfbd827c35$var$__defProp = Object.defineProperty;
var $513851bfbd827c35$var$__defProps = Object.defineProperties;
var $513851bfbd827c35$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $513851bfbd827c35$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $513851bfbd827c35$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $513851bfbd827c35$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $513851bfbd827c35$var$__defNormalProp = (obj, key, value)=>key in obj ? $513851bfbd827c35$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $513851bfbd827c35$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($513851bfbd827c35$var$__hasOwnProp.call(b, prop)) $513851bfbd827c35$var$__defNormalProp(a, prop, b[prop]);
    if ($513851bfbd827c35$var$__getOwnPropSymbols) {
        for (var prop of $513851bfbd827c35$var$__getOwnPropSymbols(b))if ($513851bfbd827c35$var$__propIsEnum.call(b, prop)) $513851bfbd827c35$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $513851bfbd827c35$var$__spreadProps = (a, b)=>$513851bfbd827c35$var$__defProps(a, $513851bfbd827c35$var$__getOwnPropDescs(b));
function $513851bfbd827c35$export$2c268f202a81de5b() {
    const ctx = (0, $acw62.useContext)((0, $cnNDs.DatesProviderContext));
    const getLocale = (0, $acw62.useCallback)((input)=>input || ctx.locale, [
        ctx.locale
    ]);
    const getFirstDayOfWeek = (0, $acw62.useCallback)((input)=>typeof input === "number" ? input : ctx.firstDayOfWeek, [
        ctx.firstDayOfWeek
    ]);
    const getWeekendDays = (0, $acw62.useCallback)((input)=>Array.isArray(input) ? input : ctx.weekendDays, [
        ctx.weekendDays
    ]);
    const getLabelSeparator = (0, $acw62.useCallback)((input)=>typeof input === "string" ? input : ctx.labelSeparator, [
        ctx.labelSeparator
    ]);
    return $513851bfbd827c35$var$__spreadProps($513851bfbd827c35$var$__spreadValues({}, ctx), {
        getLocale: getLocale,
        getFirstDayOfWeek: getFirstDayOfWeek,
        getWeekendDays: getWeekendDays,
        getLabelSeparator: getLabelSeparator
    });
}

});

parcelRegister("keeN6", function(module, exports) {

$parcel$export(module.exports, "CalendarHeader", () => $eba0969bab4773e7$export$9c75275274db0b56);

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $5etRf = parcelRequire("5etRf");
var $64A2P = parcelRequire("64A2P");

var $9ZL00 = parcelRequire("9ZL00");

var $jRce2 = parcelRequire("jRce2");
var $eba0969bab4773e7$var$__defProp = Object.defineProperty;
var $eba0969bab4773e7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $eba0969bab4773e7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $eba0969bab4773e7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $eba0969bab4773e7$var$__defNormalProp = (obj, key, value)=>key in obj ? $eba0969bab4773e7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $eba0969bab4773e7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($eba0969bab4773e7$var$__hasOwnProp.call(b, prop)) $eba0969bab4773e7$var$__defNormalProp(a, prop, b[prop]);
    if ($eba0969bab4773e7$var$__getOwnPropSymbols) {
        for (var prop of $eba0969bab4773e7$var$__getOwnPropSymbols(b))if ($eba0969bab4773e7$var$__propIsEnum.call(b, prop)) $eba0969bab4773e7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $eba0969bab4773e7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($eba0969bab4773e7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $eba0969bab4773e7$var$__getOwnPropSymbols) {
        for (var prop of $eba0969bab4773e7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $eba0969bab4773e7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $eba0969bab4773e7$var$defaultProps = {
    nextDisabled: false,
    previousDisabled: false,
    hasNextLevel: true,
    withNext: true,
    withPrevious: true,
    size: "sm"
};
const $eba0969bab4773e7$export$9c75275274db0b56 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("CalendarHeader", $eba0969bab4773e7$var$defaultProps, props), { className: className, nextIcon: nextIcon, previousIcon: previousIcon, nextLabel: nextLabel, previousLabel: previousLabel, onNext: onNext, onPrevious: onPrevious, onLevelClick: onLevelClick, label: label, classNames: classNames, styles: styles, unstyled: unstyled, nextDisabled: nextDisabled, previousDisabled: previousDisabled, hasNextLevel: hasNextLevel, levelControlAriaLabel: levelControlAriaLabel, withNext: withNext, withPrevious: withPrevious, __staticSelector: __staticSelector, __preventFocus: __preventFocus, __stopPropagation: __stopPropagation, size: size, variant: variant } = _a, others = $eba0969bab4773e7$var$__objRest(_a, [
        "className",
        "nextIcon",
        "previousIcon",
        "nextLabel",
        "previousLabel",
        "onNext",
        "onPrevious",
        "onLevelClick",
        "label",
        "classNames",
        "styles",
        "unstyled",
        "nextDisabled",
        "previousDisabled",
        "hasNextLevel",
        "levelControlAriaLabel",
        "withNext",
        "withPrevious",
        "__staticSelector",
        "__preventFocus",
        "__stopPropagation",
        "size",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $jRce2.default)(null, {
        name: [
            "CalendarHeader",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        size: size,
        variant: variant
    });
    const preventFocus = __preventFocus ? (event)=>event.preventDefault() : void 0;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $eba0969bab4773e7$var$__spreadValues({
        className: cx(classes.calendarHeader, className),
        ref: ref
    }, others), withPrevious && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), {
        className: classes.calendarHeaderControl,
        "data-previous": true,
        "aria-label": previousLabel,
        onClick: onPrevious,
        unstyled: unstyled,
        onMouseDown: preventFocus,
        disabled: previousDisabled,
        "data-disabled": previousDisabled || void 0,
        tabIndex: __preventFocus ? -1 : 0,
        "data-mantine-stop-propagation": __stopPropagation || void 0
    }, previousIcon || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ZL00.Chevron), {
        className: classes.calendarHeaderControlIcon,
        direction: "previous",
        "data-previous": true
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), {
        component: hasNextLevel ? "button" : "div",
        className: classes.calendarHeaderLevel,
        onClick: hasNextLevel ? onLevelClick : void 0,
        unstyled: unstyled,
        onMouseDown: hasNextLevel ? preventFocus : void 0,
        disabled: !hasNextLevel,
        "data-static": !hasNextLevel || void 0,
        "aria-label": levelControlAriaLabel,
        tabIndex: __preventFocus || !hasNextLevel ? -1 : 0,
        "data-mantine-stop-propagation": __stopPropagation || void 0
    }, label), withNext && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), {
        className: classes.calendarHeaderControl,
        "data-next": true,
        "aria-label": nextLabel,
        onClick: onNext,
        unstyled: unstyled,
        onMouseDown: preventFocus,
        disabled: nextDisabled,
        "data-disabled": nextDisabled || void 0,
        tabIndex: __preventFocus ? -1 : 0,
        "data-mantine-stop-propagation": __stopPropagation || void 0
    }, nextIcon || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9ZL00.Chevron), {
        className: classes.calendarHeaderControlIcon,
        direction: "next",
        "data-next": true
    })));
});
$eba0969bab4773e7$export$9c75275274db0b56.displayName = "@mantine/dates/CalendarHeader";

});
parcelRegister("9ZL00", function(module, exports) {

$parcel$export(module.exports, "Chevron", () => $746e449de2030da0$export$65be7b63f510f362);

var $acw62 = parcelRequire("acw62");

var $1cBiA = parcelRequire("1cBiA");
var $64A2P = parcelRequire("64A2P");
var $746e449de2030da0$var$__defProp = Object.defineProperty;
var $746e449de2030da0$var$__defProps = Object.defineProperties;
var $746e449de2030da0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $746e449de2030da0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $746e449de2030da0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $746e449de2030da0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $746e449de2030da0$var$__defNormalProp = (obj, key, value)=>key in obj ? $746e449de2030da0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $746e449de2030da0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($746e449de2030da0$var$__hasOwnProp.call(b, prop)) $746e449de2030da0$var$__defNormalProp(a, prop, b[prop]);
    if ($746e449de2030da0$var$__getOwnPropSymbols) {
        for (var prop of $746e449de2030da0$var$__getOwnPropSymbols(b))if ($746e449de2030da0$var$__propIsEnum.call(b, prop)) $746e449de2030da0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $746e449de2030da0$var$__spreadProps = (a, b)=>$746e449de2030da0$var$__defProps(a, $746e449de2030da0$var$__getOwnPropDescs(b));
var $746e449de2030da0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($746e449de2030da0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $746e449de2030da0$var$__getOwnPropSymbols) {
        for (var prop of $746e449de2030da0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $746e449de2030da0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $746e449de2030da0$export$65be7b63f510f362(_a) {
    var _b = _a, { direction: direction, style: style } = _b, others = $746e449de2030da0$var$__objRest(_b, [
        "direction",
        "style"
    ]);
    const theme = (0, $64A2P.useMantineTheme)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1cBiA.ChevronIcon), $746e449de2030da0$var$__spreadProps($746e449de2030da0$var$__spreadValues({}, others), {
        style: $746e449de2030da0$var$__spreadProps($746e449de2030da0$var$__spreadValues({}, style), {
            transform: direction === "next" && theme.dir === "ltr" || direction === "previous" && theme.dir === "rtl" ? "rotate(270deg)" : "rotate(90deg)"
        })
    }));
}
$746e449de2030da0$export$65be7b63f510f362.displayName = "@mantine/dates/Chevron";

});

parcelRegister("jRce2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74c73401ec66c3c$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");

var $jicY7 = parcelRequire("jicY7");
var $e74c73401ec66c3c$var$__defProp = Object.defineProperty;
var $e74c73401ec66c3c$var$__defProps = Object.defineProperties;
var $e74c73401ec66c3c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e74c73401ec66c3c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e74c73401ec66c3c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e74c73401ec66c3c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e74c73401ec66c3c$var$__defNormalProp = (obj, key, value)=>key in obj ? $e74c73401ec66c3c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e74c73401ec66c3c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e74c73401ec66c3c$var$__hasOwnProp.call(b, prop)) $e74c73401ec66c3c$var$__defNormalProp(a, prop, b[prop]);
    if ($e74c73401ec66c3c$var$__getOwnPropSymbols) {
        for (var prop of $e74c73401ec66c3c$var$__getOwnPropSymbols(b))if ($e74c73401ec66c3c$var$__propIsEnum.call(b, prop)) $e74c73401ec66c3c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e74c73401ec66c3c$var$__spreadProps = (a, b)=>$e74c73401ec66c3c$var$__defProps(a, $e74c73401ec66c3c$var$__getOwnPropDescs(b));
var $e74c73401ec66c3c$var$useStyles = (0, $cQG1Y.createStyles)((theme, _, { size: size })=>{
    const controlSize = (0, $d8Ix8.getSize)({
        size: size,
        sizes: $jicY7.sizes
    });
    return {
        calendarHeaderControlIcon: {},
        calendarHeader: {
            display: "flex",
            maxWidth: `calc(${controlSize} * 7 + ${(0, $2jkdX.rem)(7)})`
        },
        calendarHeaderControl: $e74c73401ec66c3c$var$__spreadProps($e74c73401ec66c3c$var$__spreadValues({
            width: controlSize,
            height: controlSize,
            borderRadius: theme.fn.radius(),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none"
        }, theme.fn.hover({
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
        })), {
            "&:active": theme.activeStyles,
            "&[data-disabled]": $e74c73401ec66c3c$var$__spreadProps($e74c73401ec66c3c$var$__spreadValues({
                opacity: 0.2,
                cursor: "not-allowed"
            }, theme.fn.hover({
                backgroundColor: "transparent"
            })), {
                "&:active": {
                    transform: "none"
                }
            })
        }),
        calendarHeaderLevel: $e74c73401ec66c3c$var$__spreadProps($e74c73401ec66c3c$var$__spreadValues({
            height: controlSize,
            borderRadius: theme.fn.radius(),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none",
            flex: 1,
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            fontWeight: 500,
            textTransform: "capitalize"
        }, theme.fn.hover({
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
        })), {
            "&:active": theme.activeStyles,
            "&[data-static]": $e74c73401ec66c3c$var$__spreadProps($e74c73401ec66c3c$var$__spreadValues({
                cursor: "default",
                userSelect: "unset"
            }, theme.fn.hover({
                backgroundColor: "transparent"
            })), {
                "&:active": {
                    transform: "none"
                }
            })
        })
    };
});
var $e74c73401ec66c3c$export$2e2bcd8739ae039 = $e74c73401ec66c3c$var$useStyles;

});
parcelRegister("jicY7", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $e0b9c20cd387d4d2$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "default", () => $e0b9c20cd387d4d2$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $e0b9c20cd387d4d2$var$__defProp = Object.defineProperty;
var $e0b9c20cd387d4d2$var$__defProps = Object.defineProperties;
var $e0b9c20cd387d4d2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $e0b9c20cd387d4d2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $e0b9c20cd387d4d2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $e0b9c20cd387d4d2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $e0b9c20cd387d4d2$var$__defNormalProp = (obj, key, value)=>key in obj ? $e0b9c20cd387d4d2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $e0b9c20cd387d4d2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($e0b9c20cd387d4d2$var$__hasOwnProp.call(b, prop)) $e0b9c20cd387d4d2$var$__defNormalProp(a, prop, b[prop]);
    if ($e0b9c20cd387d4d2$var$__getOwnPropSymbols) {
        for (var prop of $e0b9c20cd387d4d2$var$__getOwnPropSymbols(b))if ($e0b9c20cd387d4d2$var$__propIsEnum.call(b, prop)) $e0b9c20cd387d4d2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $e0b9c20cd387d4d2$var$__spreadProps = (a, b)=>$e0b9c20cd387d4d2$var$__defProps(a, $e0b9c20cd387d4d2$var$__getOwnPropDescs(b));
const $e0b9c20cd387d4d2$export$c647cb0ee6e282fe = {
    xs: (0, $2jkdX.rem)(30),
    sm: (0, $2jkdX.rem)(36),
    md: (0, $2jkdX.rem)(42),
    lg: (0, $2jkdX.rem)(48),
    xl: (0, $2jkdX.rem)(54)
};
var $e0b9c20cd387d4d2$var$useStyles = (0, $cQG1Y.createStyles)((theme, { radius: radius, isStatic: isStatic }, { size: size })=>{
    const colors = theme.fn.variant({
        variant: "filled"
    });
    const lightColors = theme.fn.variant({
        variant: "light"
    });
    return {
        day: $e0b9c20cd387d4d2$var$__spreadProps($e0b9c20cd387d4d2$var$__spreadValues({
            width: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $e0b9c20cd387d4d2$export$c647cb0ee6e282fe
            }),
            height: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $e0b9c20cd387d4d2$export$c647cb0ee6e282fe
            }),
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: isStatic ? void 0 : "none",
            cursor: isStatic ? "default" : "pointer",
            borderRadius: theme.fn.radius(radius)
        }, isStatic ? null : theme.fn.hover({
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
        })), {
            "&:active": isStatic ? void 0 : theme.activeStyles,
            "&[data-disabled]": $e0b9c20cd387d4d2$var$__spreadProps($e0b9c20cd387d4d2$var$__spreadValues({
                color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4],
                cursor: "not-allowed"
            }, theme.fn.hover({
                backgroundColor: "transparent"
            })), {
                "&:active": {
                    transform: "none"
                }
            }),
            "&[data-weekend]": {
                color: theme.colors.red[theme.fn.primaryShade()]
            },
            "&[data-outside]": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4]
            },
            "&[data-in-range]": $e0b9c20cd387d4d2$var$__spreadValues({
                backgroundColor: lightColors.background,
                borderRadius: 0
            }, isStatic ? null : theme.fn.hover({
                backgroundColor: lightColors.hover
            })),
            "&[data-first-in-range]": {
                borderTopLeftRadius: theme.radius.sm,
                borderBottomLeftRadius: theme.radius.sm
            },
            "&[data-last-in-range]": {
                borderTopRightRadius: theme.radius.sm,
                borderBottomRightRadius: theme.radius.sm
            },
            "&[data-selected]": $e0b9c20cd387d4d2$var$__spreadValues({
                color: colors.color,
                backgroundColor: colors.background
            }, isStatic ? null : theme.fn.hover({
                backgroundColor: colors.hover
            })),
            "&[data-hidden]": {
                display: "none"
            }
        })
    };
});
var $e0b9c20cd387d4d2$export$2e2bcd8739ae039 = $e0b9c20cd387d4d2$var$useStyles;

});



parcelRegister("adCIO", function(module, exports) {

$parcel$export(module.exports, "Month", () => $770927980c408bec$export$951c8378cdfec6e6);

var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $4CxxE = parcelRequire("4CxxE");

var $eFx7B = parcelRequire("eFx7B");

var $3YUzW = parcelRequire("3YUzW");

var $1pUTj = parcelRequire("1pUTj");

var $hQmFT = parcelRequire("hQmFT");

var $df8sf = parcelRequire("df8sf");

var $6YkAK = parcelRequire("6YkAK");

var $2hAja = parcelRequire("2hAja");

var $h4pN3 = parcelRequire("h4pN3");
var $770927980c408bec$var$__defProp = Object.defineProperty;
var $770927980c408bec$var$__defProps = Object.defineProperties;
var $770927980c408bec$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $770927980c408bec$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $770927980c408bec$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $770927980c408bec$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $770927980c408bec$var$__defNormalProp = (obj, key, value)=>key in obj ? $770927980c408bec$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $770927980c408bec$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($770927980c408bec$var$__hasOwnProp.call(b, prop)) $770927980c408bec$var$__defNormalProp(a, prop, b[prop]);
    if ($770927980c408bec$var$__getOwnPropSymbols) {
        for (var prop of $770927980c408bec$var$__getOwnPropSymbols(b))if ($770927980c408bec$var$__propIsEnum.call(b, prop)) $770927980c408bec$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $770927980c408bec$var$__spreadProps = (a, b)=>$770927980c408bec$var$__defProps(a, $770927980c408bec$var$__getOwnPropDescs(b));
var $770927980c408bec$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($770927980c408bec$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $770927980c408bec$var$__getOwnPropSymbols) {
        for (var prop of $770927980c408bec$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $770927980c408bec$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $770927980c408bec$var$defaultProps = {
    size: "sm",
    withCellSpacing: true
};
const $770927980c408bec$export$951c8378cdfec6e6 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Month", $770927980c408bec$var$defaultProps, props), { className: className, classNames: classNames, styles: styles, unstyled: unstyled, __staticSelector: __staticSelector, locale: locale, firstDayOfWeek: firstDayOfWeek, weekdayFormat: weekdayFormat, month: month, weekendDays: weekendDays, getDayProps: getDayProps, excludeDate: excludeDate, minDate: minDate, maxDate: maxDate, renderDay: renderDay, hideOutsideDates: hideOutsideDates, hideWeekdays: hideWeekdays, getDayAriaLabel: getDayAriaLabel, static: isStatic, __getDayRef: __getDayRef, __onDayKeyDown: __onDayKeyDown, __onDayClick: __onDayClick, __onDayMouseEnter: __onDayMouseEnter, __preventFocus: __preventFocus, __stopPropagation: __stopPropagation, withCellSpacing: withCellSpacing, size: size, variant: variant } = _a, others = $770927980c408bec$var$__objRest(_a, [
        "className",
        "classNames",
        "styles",
        "unstyled",
        "__staticSelector",
        "locale",
        "firstDayOfWeek",
        "weekdayFormat",
        "month",
        "weekendDays",
        "getDayProps",
        "excludeDate",
        "minDate",
        "maxDate",
        "renderDay",
        "hideOutsideDates",
        "hideWeekdays",
        "getDayAriaLabel",
        "static",
        "__getDayRef",
        "__onDayKeyDown",
        "__onDayClick",
        "__onDayMouseEnter",
        "__preventFocus",
        "__stopPropagation",
        "withCellSpacing",
        "size",
        "variant"
    ]);
    const ctx = (0, $6YkAK.useDatesContext)();
    const { classes: classes, cx: cx } = (0, $hQmFT.default)(null, {
        name: [
            "Month",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const stylesApiProps = {
        __staticSelector: __staticSelector || "Month",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    };
    const dates = (0, $4CxxE.getMonthDays)(month, ctx.getFirstDayOfWeek(firstDayOfWeek));
    const dateInTabOrder = (0, $df8sf.getDateInTabOrder)(dates, minDate, maxDate, getDayProps, excludeDate, hideOutsideDates, month);
    const rows = dates.map((row, rowIndex)=>{
        const cells = row.map((date, cellIndex)=>{
            const outside = !(0, $eFx7B.isSameMonth)(date, month);
            const ariaLabel = (getDayAriaLabel == null ? void 0 : getDayAriaLabel(date)) || (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).locale(locale || ctx.locale).format("D MMMM YYYY");
            const dayProps = getDayProps == null ? void 0 : getDayProps(date);
            const isDateInTabOrder = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).isSame(dateInTabOrder, "date");
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: date.toString(),
                className: classes.monthCell,
                "data-with-spacing": withCellSpacing || void 0
            }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2hAja.Day), $770927980c408bec$var$__spreadProps($770927980c408bec$var$__spreadValues($770927980c408bec$var$__spreadProps($770927980c408bec$var$__spreadValues({}, stylesApiProps), {
                "data-mantine-stop-propagation": __stopPropagation || void 0,
                renderDay: renderDay,
                date: date,
                weekend: ctx.getWeekendDays(weekendDays).includes(date.getDay()),
                outside: outside,
                hidden: hideOutsideDates ? outside : false,
                "aria-label": ariaLabel,
                static: isStatic,
                disabled: (excludeDate == null ? void 0 : excludeDate(date)) || !(0, $3YUzW.isBeforeMaxDate)(date, maxDate) || !(0, $1pUTj.isAfterMinDate)(date, minDate),
                ref: (node)=>__getDayRef == null ? void 0 : __getDayRef(rowIndex, cellIndex, node)
            }), dayProps), {
                onKeyDown: (event)=>{
                    var _a2;
                    (_a2 = dayProps == null ? void 0 : dayProps.onKeyDown) == null || _a2.call(dayProps, event);
                    __onDayKeyDown == null || __onDayKeyDown(event, {
                        rowIndex: rowIndex,
                        cellIndex: cellIndex,
                        date: date
                    });
                },
                onMouseEnter: (event)=>{
                    var _a2;
                    (_a2 = dayProps == null ? void 0 : dayProps.onMouseEnter) == null || _a2.call(dayProps, event);
                    __onDayMouseEnter == null || __onDayMouseEnter(event, date);
                },
                onClick: (event)=>{
                    var _a2;
                    (_a2 = dayProps == null ? void 0 : dayProps.onClick) == null || _a2.call(dayProps, event);
                    __onDayClick == null || __onDayClick(event, date);
                },
                onMouseDown: (event)=>{
                    var _a2;
                    (_a2 = dayProps == null ? void 0 : dayProps.onMouseDown) == null || _a2.call(dayProps, event);
                    __preventFocus && event.preventDefault();
                },
                tabIndex: __preventFocus || !isDateInTabOrder ? -1 : 0
            })));
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowIndex,
            className: classes.monthRow
        }, cells);
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $770927980c408bec$var$__spreadValues({
        component: "table",
        className: cx(classes.month, className),
        ref: ref
    }, others), !hideWeekdays && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("thead", {
        className: classes.monthThead
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $h4pN3.WeekdaysRow), $770927980c408bec$var$__spreadProps($770927980c408bec$var$__spreadValues({}, stylesApiProps), {
        locale: locale,
        firstDayOfWeek: firstDayOfWeek,
        weekdayFormat: weekdayFormat
    }))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", {
        className: classes.monthTbody
    }, rows));
});
$770927980c408bec$export$951c8378cdfec6e6.displayName = "@mantine/dates/Month";

});
parcelRegister("4CxxE", function(module, exports) {

$parcel$export(module.exports, "getMonthDays", () => $35d4bab699e53eea$export$214c174a056fc56f);

var $h32Gn = parcelRequire("h32Gn");

var $euABd = parcelRequire("euABd");
function $35d4bab699e53eea$export$214c174a056fc56f(month, firstDayOfWeek = 1) {
    const currentMonth = month.getMonth();
    const startOfMonth = new Date(month.getFullYear(), currentMonth, 1);
    const endOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
    const endDate = (0, $euABd.getEndOfWeek)(endOfMonth, firstDayOfWeek);
    const date = (0, $h32Gn.getStartOfWeek)(startOfMonth, firstDayOfWeek);
    const weeks = [];
    while(date <= endDate){
        const days = [];
        for(let i = 0; i < 7; i += 1){
            days.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }
        weeks.push(days);
    }
    return weeks;
}

});
parcelRegister("h32Gn", function(module, exports) {

$parcel$export(module.exports, "getStartOfWeek", () => $c694cc2ecb2bf042$export$548348775833e7f8);
function $c694cc2ecb2bf042$export$548348775833e7f8(date, firstDayOfWeek = 1) {
    const value = new Date(date);
    while(value.getDay() !== firstDayOfWeek)value.setDate(value.getDate() - 1);
    return value;
}

});

parcelRegister("euABd", function(module, exports) {

$parcel$export(module.exports, "getEndOfWeek", () => $a8d041e6a4ee8dd5$export$82940377b1d9aa33);
function $a8d041e6a4ee8dd5$export$82940377b1d9aa33(date, firstDayOfWeek = 1) {
    const value = new Date(date);
    const lastDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;
    while(value.getDay() !== lastDayOfWeek)value.setDate(value.getDate() + 1);
    return value;
}

});


parcelRegister("eFx7B", function(module, exports) {

$parcel$export(module.exports, "isSameMonth", () => $aade96448cd175e6$export$a18c89cbd24170ff);
function $aade96448cd175e6$export$a18c89cbd24170ff(date, comparison) {
    return date.getFullYear() === comparison.getFullYear() && date.getMonth() === comparison.getMonth();
}

});

parcelRegister("3YUzW", function(module, exports) {

$parcel$export(module.exports, "isBeforeMaxDate", () => $2e62dd0b739aa3e1$export$79cfb0ceb8971d10);

var $gngdn = parcelRequire("gngdn");
function $2e62dd0b739aa3e1$export$79cfb0ceb8971d10(date, maxDate) {
    return maxDate instanceof Date ? (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).isBefore((0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(maxDate).add(1, "day"), "day") : true;
}

});

parcelRegister("1pUTj", function(module, exports) {

$parcel$export(module.exports, "isAfterMinDate", () => $108441a113d09245$export$f24e848e2d8040ae);

var $gngdn = parcelRequire("gngdn");
function $108441a113d09245$export$f24e848e2d8040ae(date, minDate) {
    return minDate instanceof Date ? (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).isAfter((0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(minDate).subtract(1, "day"), "day") : true;
}

});

parcelRegister("hQmFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd8e1bda7b322fb$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $cfd8e1bda7b322fb$var$__defProp = Object.defineProperty;
var $cfd8e1bda7b322fb$var$__defProps = Object.defineProperties;
var $cfd8e1bda7b322fb$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cfd8e1bda7b322fb$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cfd8e1bda7b322fb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cfd8e1bda7b322fb$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cfd8e1bda7b322fb$var$__defNormalProp = (obj, key, value)=>key in obj ? $cfd8e1bda7b322fb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cfd8e1bda7b322fb$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cfd8e1bda7b322fb$var$__hasOwnProp.call(b, prop)) $cfd8e1bda7b322fb$var$__defNormalProp(a, prop, b[prop]);
    if ($cfd8e1bda7b322fb$var$__getOwnPropSymbols) {
        for (var prop of $cfd8e1bda7b322fb$var$__getOwnPropSymbols(b))if ($cfd8e1bda7b322fb$var$__propIsEnum.call(b, prop)) $cfd8e1bda7b322fb$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cfd8e1bda7b322fb$var$__spreadProps = (a, b)=>$cfd8e1bda7b322fb$var$__defProps(a, $cfd8e1bda7b322fb$var$__getOwnPropDescs(b));
var $cfd8e1bda7b322fb$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        monthThead: {},
        monthRow: {},
        monthTbody: {},
        monthCell: {
            padding: 0,
            "&[data-with-spacing]": {
                padding: (0, $2jkdX.rem)(0.5)
            }
        },
        month: $cfd8e1bda7b322fb$var$__spreadProps($cfd8e1bda7b322fb$var$__spreadValues({}, theme.fn.fontStyles()), {
            borderCollapse: "collapse",
            tableLayout: "fixed",
            "& *": {
                boxSizing: "border-box"
            }
        })
    }));
var $cfd8e1bda7b322fb$export$2e2bcd8739ae039 = $cfd8e1bda7b322fb$var$useStyles;

});

parcelRegister("df8sf", function(module, exports) {

$parcel$export(module.exports, "getDateInTabOrder", () => $9a433bfd6567a9c0$export$93462258dd2f82e6);

var $gngdn = parcelRequire("gngdn");

var $1pUTj = parcelRequire("1pUTj");

var $3YUzW = parcelRequire("3YUzW");

var $eFx7B = parcelRequire("eFx7B");
function $9a433bfd6567a9c0$export$93462258dd2f82e6(dates, minDate, maxDate, getDateControlProps, excludeDate, hideOutsideDates, month) {
    const enabledDates = dates.flat().filter((date)=>{
        var _a;
        return (0, $3YUzW.isBeforeMaxDate)(date, maxDate) && (0, $1pUTj.isAfterMinDate)(date, minDate) && !(excludeDate == null ? void 0 : excludeDate(date)) && !((_a = getDateControlProps == null ? void 0 : getDateControlProps(date)) == null ? void 0 : _a.disabled) && (!hideOutsideDates || (0, $eFx7B.isSameMonth)(date, month));
    });
    const selectedDate = enabledDates.find((date)=>{
        var _a;
        return (_a = getDateControlProps == null ? void 0 : getDateControlProps(date)) == null ? void 0 : _a.selected;
    });
    if (selectedDate) return selectedDate;
    const currentDate = enabledDates.find((date)=>(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))().isSame(date, "date"));
    if (currentDate) return currentDate;
    return enabledDates[0];
}

});

parcelRegister("2hAja", function(module, exports) {

$parcel$export(module.exports, "Day", () => $1a995558ea24a8e7$export$7a9a31a911eb9a20);

var $acw62 = parcelRequire("acw62");

var $5etRf = parcelRequire("5etRf");
var $64A2P = parcelRequire("64A2P");

var $gngdn = parcelRequire("gngdn");

var $jicY7 = parcelRequire("jicY7");
var $1a995558ea24a8e7$var$__defProp = Object.defineProperty;
var $1a995558ea24a8e7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1a995558ea24a8e7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1a995558ea24a8e7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1a995558ea24a8e7$var$__defNormalProp = (obj, key, value)=>key in obj ? $1a995558ea24a8e7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1a995558ea24a8e7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1a995558ea24a8e7$var$__hasOwnProp.call(b, prop)) $1a995558ea24a8e7$var$__defNormalProp(a, prop, b[prop]);
    if ($1a995558ea24a8e7$var$__getOwnPropSymbols) {
        for (var prop of $1a995558ea24a8e7$var$__getOwnPropSymbols(b))if ($1a995558ea24a8e7$var$__propIsEnum.call(b, prop)) $1a995558ea24a8e7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1a995558ea24a8e7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1a995558ea24a8e7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1a995558ea24a8e7$var$__getOwnPropSymbols) {
        for (var prop of $1a995558ea24a8e7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1a995558ea24a8e7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $1a995558ea24a8e7$var$defaultProps = {
    tabIndex: 0,
    size: "sm"
};
const $1a995558ea24a8e7$export$7a9a31a911eb9a20 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("Day", $1a995558ea24a8e7$var$defaultProps, props), { className: className, date: date, radius: radius, disabled: disabled, styles: styles, classNames: classNames, unstyled: unstyled, __staticSelector: __staticSelector, weekend: weekend, outside: outside, selected: selected, renderDay: renderDay, inRange: inRange, firstInRange: firstInRange, lastInRange: lastInRange, hidden: hidden, static: isStatic, variant: variant, size: size } = _a, others = $1a995558ea24a8e7$var$__objRest(_a, [
        "className",
        "date",
        "radius",
        "disabled",
        "styles",
        "classNames",
        "unstyled",
        "__staticSelector",
        "weekend",
        "outside",
        "selected",
        "renderDay",
        "inRange",
        "firstInRange",
        "lastInRange",
        "hidden",
        "static",
        "variant",
        "size"
    ]);
    const { classes: classes, cx: cx } = (0, $jicY7.default)({
        radius: radius,
        isStatic: isStatic
    }, {
        name: [
            "Day",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $1a995558ea24a8e7$var$__spreadValues({
        component: isStatic ? "div" : "button",
        ref: ref,
        className: cx(classes.day, className),
        disabled: disabled,
        "data-today": (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).isSame(new Date(), "day") || void 0,
        "data-hidden": hidden || void 0,
        "data-disabled": disabled || void 0,
        "data-weekend": !disabled && !outside && weekend || void 0,
        "data-outside": !disabled && outside || void 0,
        "data-selected": !disabled && selected || void 0,
        "data-in-range": inRange && !disabled || void 0,
        "data-first-in-range": firstInRange && !disabled || void 0,
        "data-last-in-range": lastInRange && !disabled || void 0,
        unstyled: unstyled
    }, others), (renderDay == null ? void 0 : renderDay(date)) || date.getDate());
});
$1a995558ea24a8e7$export$7a9a31a911eb9a20.displayName = "@mantine/dates/Day";

});

parcelRegister("h4pN3", function(module, exports) {

$parcel$export(module.exports, "WeekdaysRow", () => $0335035e0932ebb7$export$c2e6fbf5372301ec);

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $goHBI = parcelRequire("goHBI");

var $3V1sN = parcelRequire("3V1sN");

var $6YkAK = parcelRequire("6YkAK");
var $0335035e0932ebb7$var$__defProp = Object.defineProperty;
var $0335035e0932ebb7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0335035e0932ebb7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0335035e0932ebb7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0335035e0932ebb7$var$__defNormalProp = (obj, key, value)=>key in obj ? $0335035e0932ebb7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0335035e0932ebb7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0335035e0932ebb7$var$__hasOwnProp.call(b, prop)) $0335035e0932ebb7$var$__defNormalProp(a, prop, b[prop]);
    if ($0335035e0932ebb7$var$__getOwnPropSymbols) {
        for (var prop of $0335035e0932ebb7$var$__getOwnPropSymbols(b))if ($0335035e0932ebb7$var$__propIsEnum.call(b, prop)) $0335035e0932ebb7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0335035e0932ebb7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0335035e0932ebb7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0335035e0932ebb7$var$__getOwnPropSymbols) {
        for (var prop of $0335035e0932ebb7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0335035e0932ebb7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $0335035e0932ebb7$var$defaultProps = {
    weekdayFormat: "dd",
    cellComponent: "th",
    size: "sm"
};
const $0335035e0932ebb7$export$c2e6fbf5372301ec = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("WeekdaysRow", $0335035e0932ebb7$var$defaultProps, props), { className: className, locale: locale, firstDayOfWeek: firstDayOfWeek, weekdayFormat: weekdayFormat, cellComponent: CellComponent, __staticSelector: __staticSelector, classNames: classNames, styles: styles, unstyled: unstyled, variant: variant, size: size } = _a, others = $0335035e0932ebb7$var$__objRest(_a, [
        "className",
        "locale",
        "firstDayOfWeek",
        "weekdayFormat",
        "cellComponent",
        "__staticSelector",
        "classNames",
        "styles",
        "unstyled",
        "variant",
        "size"
    ]);
    const ctx = (0, $6YkAK.useDatesContext)();
    const { classes: classes, cx: cx } = (0, $3V1sN.default)(null, {
        name: [
            "WeekdaysRow",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const weekdays = (0, $goHBI.getWeekdayNames)({
        locale: ctx.getLocale(locale),
        format: weekdayFormat,
        firstDayOfWeek: ctx.getFirstDayOfWeek(firstDayOfWeek)
    }).map((weekday, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellComponent, {
            key: index,
            className: classes.weekday
        }, weekday));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $0335035e0932ebb7$var$__spreadValues({
        component: "tr",
        ref: ref,
        className: cx(classes.weekdaysRow, className)
    }, others), weekdays);
});
$0335035e0932ebb7$export$c2e6fbf5372301ec.displayName = "@mantine/dates/WeekdaysRow";

});
parcelRegister("goHBI", function(module, exports) {

$parcel$export(module.exports, "getWeekdayNames", () => $bf00b6c15f7fb28f$export$bd4a8430f86abf7b);

var $gngdn = parcelRequire("gngdn");
function $bf00b6c15f7fb28f$export$bd4a8430f86abf7b({ locale: locale, format: format = "dd", firstDayOfWeek: firstDayOfWeek = 1 }) {
    const baseDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))().day(firstDayOfWeek);
    const labels = [];
    for(let i = 0; i < 7; i += 1)if (typeof format === "string") labels.push((0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(baseDate).add(i, "days").locale(locale).format(format));
    else labels.push(format((0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(baseDate).add(i, "days").toDate()));
    return labels;
}

});

parcelRegister("3V1sN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da7d49938cb3f9a$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2da7d49938cb3f9a$var$useStyles = (0, $cQG1Y.createStyles)((theme, _, { size: size })=>({
        weekdaysRow: {},
        weekday: {
            color: theme.colorScheme === "dark" ? theme.colors.dark[1] : theme.colors.gray[5],
            fontWeight: 400,
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            textTransform: "capitalize",
            paddingBottom: `calc(${(0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.spacing
            })} / 2)`
        }
    }));
var $2da7d49938cb3f9a$export$2e2bcd8739ae039 = $2da7d49938cb3f9a$var$useStyles;

});




parcelRegister("iYtL2", function(module, exports) {

$parcel$export(module.exports, "handleControlKeyDown", () => $dd04e9d2b111281a$export$4d3f89223a947c68);
function $dd04e9d2b111281a$var$getNextIndex({ direction: direction, levelIndex: levelIndex, rowIndex: rowIndex, cellIndex: cellIndex, size: size }) {
    switch(direction){
        case "up":
            if (levelIndex === 0 && rowIndex === 0) return null;
            if (rowIndex === 0) return {
                levelIndex: levelIndex - 1,
                rowIndex: cellIndex <= size[levelIndex - 1][size[levelIndex - 1].length - 1] - 1 ? size[levelIndex - 1].length - 1 : size[levelIndex - 1].length - 2,
                cellIndex: cellIndex
            };
            return {
                levelIndex: levelIndex,
                rowIndex: rowIndex - 1,
                cellIndex: cellIndex
            };
        case "down":
            if (rowIndex === size[levelIndex].length - 1) return {
                levelIndex: levelIndex + 1,
                rowIndex: 0,
                cellIndex: cellIndex
            };
            if (rowIndex === size[levelIndex].length - 2 && cellIndex >= size[levelIndex][size[levelIndex].length - 1]) return {
                levelIndex: levelIndex + 1,
                rowIndex: 0,
                cellIndex: cellIndex
            };
            return {
                levelIndex: levelIndex,
                rowIndex: rowIndex + 1,
                cellIndex: cellIndex
            };
        case "left":
            if (levelIndex === 0 && rowIndex === 0 && cellIndex === 0) return null;
            if (rowIndex === 0 && cellIndex === 0) return {
                levelIndex: levelIndex - 1,
                rowIndex: size[levelIndex - 1].length - 1,
                cellIndex: size[levelIndex - 1][size[levelIndex - 1].length - 1] - 1
            };
            if (cellIndex === 0) return {
                levelIndex: levelIndex,
                rowIndex: rowIndex - 1,
                cellIndex: size[levelIndex][rowIndex - 1] - 1
            };
            return {
                levelIndex: levelIndex,
                rowIndex: rowIndex,
                cellIndex: cellIndex - 1
            };
        case "right":
            if (rowIndex === size[levelIndex].length - 1 && cellIndex === size[levelIndex][rowIndex] - 1) return {
                levelIndex: levelIndex + 1,
                rowIndex: 0,
                cellIndex: 0
            };
            if (cellIndex === size[levelIndex][rowIndex] - 1) return {
                levelIndex: levelIndex,
                rowIndex: rowIndex + 1,
                cellIndex: 0
            };
            return {
                levelIndex: levelIndex,
                rowIndex: rowIndex,
                cellIndex: cellIndex + 1
            };
        default:
            return {
                levelIndex: levelIndex,
                rowIndex: rowIndex,
                cellIndex: cellIndex
            };
    }
}
function $dd04e9d2b111281a$var$focusOnNextFocusableControl({ controlsRef: controlsRef, direction: direction, levelIndex: levelIndex, rowIndex: rowIndex, cellIndex: cellIndex, size: size }) {
    var _a, _b;
    const nextIndex = $dd04e9d2b111281a$var$getNextIndex({
        direction: direction,
        size: size,
        rowIndex: rowIndex,
        cellIndex: cellIndex,
        levelIndex: levelIndex
    });
    if (!nextIndex) return;
    const controlToFocus = (_b = (_a = controlsRef.current[nextIndex.levelIndex]) == null ? void 0 : _a[nextIndex.rowIndex]) == null ? void 0 : _b[nextIndex.cellIndex];
    if (!controlToFocus) return;
    if (controlToFocus.disabled || controlToFocus.getAttribute("data-hidden") || controlToFocus.getAttribute("data-outside")) $dd04e9d2b111281a$var$focusOnNextFocusableControl({
        controlsRef: controlsRef,
        direction: direction,
        levelIndex: nextIndex.levelIndex,
        cellIndex: nextIndex.cellIndex,
        rowIndex: nextIndex.rowIndex,
        size: size
    });
    else controlToFocus.focus();
}
function $dd04e9d2b111281a$var$getDirection(key) {
    switch(key){
        case "ArrowDown":
            return "down";
        case "ArrowUp":
            return "up";
        case "ArrowRight":
            return "right";
        case "ArrowLeft":
            return "left";
        default:
            return null;
    }
}
function $dd04e9d2b111281a$var$getControlsSize(controlsRef) {
    return controlsRef.current.map((column)=>column.map((row)=>row.length));
}
function $dd04e9d2b111281a$export$4d3f89223a947c68({ controlsRef: controlsRef, levelIndex: levelIndex, rowIndex: rowIndex, cellIndex: cellIndex, event: event }) {
    const direction = $dd04e9d2b111281a$var$getDirection(event.key);
    if (direction) {
        event.preventDefault();
        const size = $dd04e9d2b111281a$var$getControlsSize(controlsRef);
        $dd04e9d2b111281a$var$focusOnNextFocusableControl({
            controlsRef: controlsRef,
            direction: direction,
            levelIndex: levelIndex,
            rowIndex: rowIndex,
            cellIndex: cellIndex,
            size: size
        });
    }
}

});


parcelRegister("ltV4Q", function(module, exports) {

$parcel$export(module.exports, "YearLevelGroup", () => $fa3894b675536b75$export$3d8ed637b3db59cb);

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $gngdn = parcelRequire("gngdn");

var $fyIkY = parcelRequire("fyIkY");

var $igIes = parcelRequire("igIes");

var $iYtL2 = parcelRequire("iYtL2");
var $fa3894b675536b75$var$__defProp = Object.defineProperty;
var $fa3894b675536b75$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $fa3894b675536b75$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fa3894b675536b75$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $fa3894b675536b75$var$__defNormalProp = (obj, key, value)=>key in obj ? $fa3894b675536b75$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fa3894b675536b75$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($fa3894b675536b75$var$__hasOwnProp.call(b, prop)) $fa3894b675536b75$var$__defNormalProp(a, prop, b[prop]);
    if ($fa3894b675536b75$var$__getOwnPropSymbols) {
        for (var prop of $fa3894b675536b75$var$__getOwnPropSymbols(b))if ($fa3894b675536b75$var$__propIsEnum.call(b, prop)) $fa3894b675536b75$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $fa3894b675536b75$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($fa3894b675536b75$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $fa3894b675536b75$var$__getOwnPropSymbols) {
        for (var prop of $fa3894b675536b75$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $fa3894b675536b75$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $fa3894b675536b75$var$defaultProps = {
    numberOfColumns: 1,
    size: "sm"
};
const $fa3894b675536b75$export$3d8ed637b3db59cb = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("YearLevelGroup", $fa3894b675536b75$var$defaultProps, props), { year: year, locale: locale, minDate: minDate, maxDate: maxDate, monthsListFormat: monthsListFormat, getMonthControlProps: getMonthControlProps, __onControlClick: __onControlClick, __onControlMouseEnter: __onControlMouseEnter, withCellSpacing: withCellSpacing, __preventFocus: __preventFocus, nextIcon: nextIcon, previousIcon: previousIcon, nextLabel: nextLabel, previousLabel: previousLabel, onNext: onNext, onPrevious: onPrevious, onLevelClick: onLevelClick, nextDisabled: nextDisabled, previousDisabled: previousDisabled, hasNextLevel: hasNextLevel, className: className, classNames: classNames, styles: styles, unstyled: unstyled, __staticSelector: __staticSelector, __stopPropagation: __stopPropagation, numberOfColumns: numberOfColumns, levelControlAriaLabel: levelControlAriaLabel, yearLabelFormat: yearLabelFormat, variant: variant, size: size } = _a, others = $fa3894b675536b75$var$__objRest(_a, [
        "year",
        "locale",
        "minDate",
        "maxDate",
        "monthsListFormat",
        "getMonthControlProps",
        "__onControlClick",
        "__onControlMouseEnter",
        "withCellSpacing",
        "__preventFocus",
        "nextIcon",
        "previousIcon",
        "nextLabel",
        "previousLabel",
        "onNext",
        "onPrevious",
        "onLevelClick",
        "nextDisabled",
        "previousDisabled",
        "hasNextLevel",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "__staticSelector",
        "__stopPropagation",
        "numberOfColumns",
        "levelControlAriaLabel",
        "yearLabelFormat",
        "variant",
        "size"
    ]);
    const { classes: classes, cx: cx } = (0, $fyIkY.default)(null, {
        name: [
            "YearLevelGroup",
            __staticSelector
        ],
        styles: styles,
        classNames: classNames,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const controlsRef = (0, $acw62.useRef)([]);
    const years = Array(numberOfColumns).fill(0).map((_, yearIndex)=>{
        const currentYear = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).add(yearIndex, "years").toDate();
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $igIes.YearLevel), {
            key: yearIndex,
            variant: variant,
            size: size,
            monthsListFormat: monthsListFormat,
            year: currentYear,
            withNext: yearIndex === numberOfColumns - 1,
            withPrevious: yearIndex === 0,
            yearLabelFormat: yearLabelFormat,
            __stopPropagation: __stopPropagation,
            __onControlClick: __onControlClick,
            __onControlMouseEnter: __onControlMouseEnter,
            __onControlKeyDown: (event, payload)=>(0, $iYtL2.handleControlKeyDown)({
                    levelIndex: yearIndex,
                    rowIndex: payload.rowIndex,
                    cellIndex: payload.cellIndex,
                    event: event,
                    controlsRef: controlsRef
                }),
            __getControlRef: (rowIndex, cellIndex, node)=>{
                if (!Array.isArray(controlsRef.current[yearIndex])) controlsRef.current[yearIndex] = [];
                if (!Array.isArray(controlsRef.current[yearIndex][rowIndex])) controlsRef.current[yearIndex][rowIndex] = [];
                controlsRef.current[yearIndex][rowIndex][cellIndex] = node;
            },
            levelControlAriaLabel: typeof levelControlAriaLabel === "function" ? levelControlAriaLabel(currentYear) : levelControlAriaLabel,
            locale: locale,
            minDate: minDate,
            maxDate: maxDate,
            __preventFocus: __preventFocus,
            nextIcon: nextIcon,
            previousIcon: previousIcon,
            nextLabel: nextLabel,
            previousLabel: previousLabel,
            onNext: onNext,
            onPrevious: onPrevious,
            onLevelClick: onLevelClick,
            nextDisabled: nextDisabled,
            previousDisabled: previousDisabled,
            hasNextLevel: hasNextLevel,
            getMonthControlProps: getMonthControlProps,
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            __staticSelector: __staticSelector || "YearLevelGroup",
            withCellSpacing: withCellSpacing
        });
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $fa3894b675536b75$var$__spreadValues({
        className: cx(classes.yearLevelGroup, className),
        ref: ref
    }, others), years);
});
$fa3894b675536b75$export$3d8ed637b3db59cb.displayName = "@mantine/dates/YearLevelGroup";

});
parcelRegister("fyIkY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53c6c7531d5900b$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $b53c6c7531d5900b$var$useStyles = (0, $cQG1Y.createStyles)((theme, _, { size: size })=>({
        yearLevelGroup: {
            display: "flex",
            "& [data-year-level]:not(:last-of-type)": {
                marginRight: (0, $d8Ix8.getSize)({
                    size: size,
                    sizes: theme.spacing
                })
            }
        }
    }));
var $b53c6c7531d5900b$export$2e2bcd8739ae039 = $b53c6c7531d5900b$var$useStyles;

});

parcelRegister("igIes", function(module, exports) {

$parcel$export(module.exports, "YearLevel", () => $d4cc0838eeeb5e71$export$c38159270e59c17d);

var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $geNhT = parcelRequire("geNhT");

var $6YkAK = parcelRequire("6YkAK");

var $keeN6 = parcelRequire("keeN6");

var $hNVVB = parcelRequire("hNVVB");
var $d4cc0838eeeb5e71$var$__defProp = Object.defineProperty;
var $d4cc0838eeeb5e71$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d4cc0838eeeb5e71$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d4cc0838eeeb5e71$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d4cc0838eeeb5e71$var$__defNormalProp = (obj, key, value)=>key in obj ? $d4cc0838eeeb5e71$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d4cc0838eeeb5e71$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d4cc0838eeeb5e71$var$__hasOwnProp.call(b, prop)) $d4cc0838eeeb5e71$var$__defNormalProp(a, prop, b[prop]);
    if ($d4cc0838eeeb5e71$var$__getOwnPropSymbols) {
        for (var prop of $d4cc0838eeeb5e71$var$__getOwnPropSymbols(b))if ($d4cc0838eeeb5e71$var$__propIsEnum.call(b, prop)) $d4cc0838eeeb5e71$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d4cc0838eeeb5e71$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d4cc0838eeeb5e71$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d4cc0838eeeb5e71$var$__getOwnPropSymbols) {
        for (var prop of $d4cc0838eeeb5e71$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d4cc0838eeeb5e71$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $d4cc0838eeeb5e71$var$defaultProps = {
    yearLabelFormat: "YYYY",
    size: "sm"
};
const $d4cc0838eeeb5e71$export$c38159270e59c17d = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("YearLevel", $d4cc0838eeeb5e71$var$defaultProps, props), { year: year, locale: locale, minDate: minDate, maxDate: maxDate, monthsListFormat: monthsListFormat, getMonthControlProps: getMonthControlProps, __getControlRef: __getControlRef, __onControlKeyDown: __onControlKeyDown, __onControlClick: __onControlClick, __onControlMouseEnter: __onControlMouseEnter, withCellSpacing: withCellSpacing, __preventFocus: __preventFocus, nextIcon: nextIcon, previousIcon: previousIcon, nextLabel: nextLabel, previousLabel: previousLabel, onNext: onNext, onPrevious: onPrevious, onLevelClick: onLevelClick, nextDisabled: nextDisabled, previousDisabled: previousDisabled, hasNextLevel: hasNextLevel, levelControlAriaLabel: levelControlAriaLabel, withNext: withNext, withPrevious: withPrevious, className: className, yearLabelFormat: yearLabelFormat, classNames: classNames, styles: styles, unstyled: unstyled, __staticSelector: __staticSelector, __stopPropagation: __stopPropagation, size: size, variant: variant } = _a, others = $d4cc0838eeeb5e71$var$__objRest(_a, [
        "year",
        "locale",
        "minDate",
        "maxDate",
        "monthsListFormat",
        "getMonthControlProps",
        "__getControlRef",
        "__onControlKeyDown",
        "__onControlClick",
        "__onControlMouseEnter",
        "withCellSpacing",
        "__preventFocus",
        "nextIcon",
        "previousIcon",
        "nextLabel",
        "previousLabel",
        "onNext",
        "onPrevious",
        "onLevelClick",
        "nextDisabled",
        "previousDisabled",
        "hasNextLevel",
        "levelControlAriaLabel",
        "withNext",
        "withPrevious",
        "className",
        "yearLabelFormat",
        "classNames",
        "styles",
        "unstyled",
        "__staticSelector",
        "__stopPropagation",
        "size",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $geNhT.default)(null, {
        name: [
            "YearLevel",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        size: size,
        variant: variant
    });
    const ctx = (0, $6YkAK.useDatesContext)();
    const stylesApiProps = {
        __staticSelector: __staticSelector || "YearLevel",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        size: size,
        variant: variant
    };
    const _nextDisabled = typeof nextDisabled === "boolean" ? nextDisabled : maxDate ? !(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).endOf("year").isBefore(maxDate) : false;
    const _previousDisabled = typeof previousDisabled === "boolean" ? previousDisabled : minDate ? !(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).startOf("year").isAfter(minDate) : false;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $d4cc0838eeeb5e71$var$__spreadValues({
        className: cx(classes.yearLevel, className),
        "data-year-level": true,
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $keeN6.CalendarHeader), $d4cc0838eeeb5e71$var$__spreadValues({
        label: typeof yearLabelFormat === "function" ? yearLabelFormat(year) : (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).locale(locale || ctx.locale).format(yearLabelFormat),
        className: classes.calendarHeader,
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        nextIcon: nextIcon,
        previousIcon: previousIcon,
        nextLabel: nextLabel,
        previousLabel: previousLabel,
        onNext: onNext,
        onPrevious: onPrevious,
        onLevelClick: onLevelClick,
        nextDisabled: _nextDisabled,
        previousDisabled: _previousDisabled,
        hasNextLevel: hasNextLevel,
        levelControlAriaLabel: levelControlAriaLabel,
        withNext: withNext,
        withPrevious: withPrevious
    }, stylesApiProps)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hNVVB.MonthsList), $d4cc0838eeeb5e71$var$__spreadValues({
        year: year,
        locale: locale,
        minDate: minDate,
        maxDate: maxDate,
        monthsListFormat: monthsListFormat,
        getMonthControlProps: getMonthControlProps,
        __getControlRef: __getControlRef,
        __onControlKeyDown: __onControlKeyDown,
        __onControlClick: __onControlClick,
        __onControlMouseEnter: __onControlMouseEnter,
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        withCellSpacing: withCellSpacing
    }, stylesApiProps)));
});
$d4cc0838eeeb5e71$export$c38159270e59c17d.displayName = "@mantine/dates/YearLevel";

});
parcelRegister("geNhT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd242fa12b3afff1$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $bd242fa12b3afff1$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        yearLevel: {},
        calendarHeader: {
            marginBottom: theme.spacing.xs
        }
    }));
var $bd242fa12b3afff1$export$2e2bcd8739ae039 = $bd242fa12b3afff1$var$useStyles;

});

parcelRegister("hNVVB", function(module, exports) {

$parcel$export(module.exports, "MonthsList", () => $cf63f29176b09757$export$c6340ef08205af0b);

var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $d4Tjy = parcelRequire("d4Tjy");

var $KIV0z = parcelRequire("KIV0z");

var $gcSlq = parcelRequire("gcSlq");

var $b60rR = parcelRequire("b60rR");

var $6YkAK = parcelRequire("6YkAK");

var $4CiMA = parcelRequire("4CiMA");
var $cf63f29176b09757$var$__defProp = Object.defineProperty;
var $cf63f29176b09757$var$__defProps = Object.defineProperties;
var $cf63f29176b09757$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $cf63f29176b09757$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $cf63f29176b09757$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $cf63f29176b09757$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $cf63f29176b09757$var$__defNormalProp = (obj, key, value)=>key in obj ? $cf63f29176b09757$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cf63f29176b09757$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($cf63f29176b09757$var$__hasOwnProp.call(b, prop)) $cf63f29176b09757$var$__defNormalProp(a, prop, b[prop]);
    if ($cf63f29176b09757$var$__getOwnPropSymbols) {
        for (var prop of $cf63f29176b09757$var$__getOwnPropSymbols(b))if ($cf63f29176b09757$var$__propIsEnum.call(b, prop)) $cf63f29176b09757$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $cf63f29176b09757$var$__spreadProps = (a, b)=>$cf63f29176b09757$var$__defProps(a, $cf63f29176b09757$var$__getOwnPropDescs(b));
var $cf63f29176b09757$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($cf63f29176b09757$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $cf63f29176b09757$var$__getOwnPropSymbols) {
        for (var prop of $cf63f29176b09757$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $cf63f29176b09757$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $cf63f29176b09757$var$defaultProps = {
    monthsListFormat: "MMM",
    size: "sm",
    withCellSpacing: true
};
const $cf63f29176b09757$export$c6340ef08205af0b = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("MonthsList", $cf63f29176b09757$var$defaultProps, props), { year: year, className: className, monthsListFormat: monthsListFormat, locale: locale, minDate: minDate, maxDate: maxDate, getMonthControlProps: getMonthControlProps, classNames: classNames, styles: styles, unstyled: unstyled, __staticSelector: __staticSelector, __getControlRef: __getControlRef, __onControlKeyDown: __onControlKeyDown, __onControlClick: __onControlClick, __onControlMouseEnter: __onControlMouseEnter, __preventFocus: __preventFocus, size: size, variant: variant, __stopPropagation: __stopPropagation, withCellSpacing: withCellSpacing } = _a, others = $cf63f29176b09757$var$__objRest(_a, [
        "year",
        "className",
        "monthsListFormat",
        "locale",
        "minDate",
        "maxDate",
        "getMonthControlProps",
        "classNames",
        "styles",
        "unstyled",
        "__staticSelector",
        "__getControlRef",
        "__onControlKeyDown",
        "__onControlClick",
        "__onControlMouseEnter",
        "__preventFocus",
        "size",
        "variant",
        "__stopPropagation",
        "withCellSpacing"
    ]);
    const { classes: classes, cx: cx } = (0, $gcSlq.default)(null, {
        name: [
            "MonthsList",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const ctx = (0, $6YkAK.useDatesContext)();
    const months = (0, $d4Tjy.getMonthsData)(year);
    const monthInTabOrder = (0, $b60rR.getMonthInTabOrder)(months, minDate, maxDate, getMonthControlProps);
    const rows = months.map((monthsRow, rowIndex)=>{
        const cells = monthsRow.map((month, cellIndex)=>{
            const controlProps = getMonthControlProps == null ? void 0 : getMonthControlProps(month);
            const isMonthInTabOrder = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(month).isSame(monthInTabOrder, "month");
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: cellIndex,
                className: classes.monthsListCell,
                "data-with-spacing": withCellSpacing || void 0
            }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CiMA.PickerControl), $cf63f29176b09757$var$__spreadProps($cf63f29176b09757$var$__spreadValues({
                variant: variant,
                size: size,
                classNames: classNames,
                styles: styles,
                unstyled: unstyled,
                __staticSelector: __staticSelector || "MonthsList",
                "data-mantine-stop-propagation": __stopPropagation || void 0,
                disabled: (0, $KIV0z.isMonthDisabled)(month, minDate, maxDate),
                ref: (node)=>__getControlRef == null ? void 0 : __getControlRef(rowIndex, cellIndex, node)
            }, controlProps), {
                onKeyDown: (event)=>{
                    var _a2;
                    (_a2 = controlProps == null ? void 0 : controlProps.onKeyDown) == null || _a2.call(controlProps, event);
                    __onControlKeyDown == null || __onControlKeyDown(event, {
                        rowIndex: rowIndex,
                        cellIndex: cellIndex,
                        date: month
                    });
                },
                onClick: (event)=>{
                    var _a2;
                    (_a2 = controlProps == null ? void 0 : controlProps.onClick) == null || _a2.call(controlProps, event);
                    __onControlClick == null || __onControlClick(event, month);
                },
                onMouseEnter: (event)=>{
                    var _a2;
                    (_a2 = controlProps == null ? void 0 : controlProps.onMouseEnter) == null || _a2.call(controlProps, event);
                    __onControlMouseEnter == null || __onControlMouseEnter(event, month);
                },
                onMouseDown: (event)=>{
                    var _a2;
                    (_a2 = controlProps == null ? void 0 : controlProps.onMouseDown) == null || _a2.call(controlProps, event);
                    __preventFocus && event.preventDefault();
                },
                tabIndex: __preventFocus || !isMonthInTabOrder ? -1 : 0
            }), (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(month).locale(ctx.getLocale(locale)).format(monthsListFormat)));
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowIndex,
            className: classes.monthsListRow
        }, cells);
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $cf63f29176b09757$var$__spreadValues({
        component: "table",
        ref: ref,
        className: cx(classes.monthsList, className)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows));
});
$cf63f29176b09757$export$c6340ef08205af0b.displayName = "@mantine/dates/MonthsList";

});
parcelRegister("d4Tjy", function(module, exports) {

$parcel$export(module.exports, "getMonthsData", () => $98568e5fd0719feb$export$538ab50844cb79d7);

var $gngdn = parcelRequire("gngdn");
function $98568e5fd0719feb$export$538ab50844cb79d7(year) {
    const startOfYear = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).startOf("year").toDate();
    const results = [
        [],
        [],
        [],
        []
    ];
    let currentMonthIndex = 0;
    for(let i = 0; i < 4; i += 1)for(let j = 0; j < 3; j += 1){
        results[i].push((0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(startOfYear).add(currentMonthIndex, "months").toDate());
        currentMonthIndex += 1;
    }
    return results;
}

});

parcelRegister("KIV0z", function(module, exports) {

$parcel$export(module.exports, "isMonthDisabled", () => $08c723de46359e54$export$86afddd56cb33dc3);

var $gngdn = parcelRequire("gngdn");
function $08c723de46359e54$export$86afddd56cb33dc3(month, minDate, maxDate) {
    if (!minDate && !maxDate) return false;
    if (minDate && (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(month).isBefore(minDate, "month")) return true;
    if (maxDate && (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(month).isAfter(maxDate, "month")) return true;
    return false;
}

});

parcelRegister("gcSlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc7ec05d6cc5c0c$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $bcc7ec05d6cc5c0c$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        monthsList: {
            borderCollapse: "collapse",
            borderWidth: 0,
            cursor: "pointer"
        },
        monthsListCell: {
            padding: 0,
            "&[data-with-spacing]": {
                padding: (0, $2jkdX.rem)(0.5)
            }
        },
        monthsListRow: {}
    }));
var $bcc7ec05d6cc5c0c$export$2e2bcd8739ae039 = $bcc7ec05d6cc5c0c$var$useStyles;

});

parcelRegister("b60rR", function(module, exports) {

$parcel$export(module.exports, "getMonthInTabOrder", () => $81409a485707ea32$export$e4dedfe731d5cfdf);

var $gngdn = parcelRequire("gngdn");

var $KIV0z = parcelRequire("KIV0z");
function $81409a485707ea32$export$e4dedfe731d5cfdf(months, minDate, maxDate, getMonthControlProps) {
    const enabledMonths = months.flat().filter((month)=>{
        var _a;
        return !(0, $KIV0z.isMonthDisabled)(month, minDate, maxDate) && !((_a = getMonthControlProps == null ? void 0 : getMonthControlProps(month)) == null ? void 0 : _a.disabled);
    });
    const selectedMonth = enabledMonths.find((month)=>{
        var _a;
        return (_a = getMonthControlProps == null ? void 0 : getMonthControlProps(month)) == null ? void 0 : _a.selected;
    });
    if (selectedMonth) return selectedMonth;
    const currentMonth = enabledMonths.find((month)=>(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))().isSame(month, "month"));
    if (currentMonth) return currentMonth;
    return enabledMonths[0];
}

});

parcelRegister("4CiMA", function(module, exports) {

$parcel$export(module.exports, "PickerControl", () => $35c947df18664655$export$e587c41f8a2e48c5);

var $acw62 = parcelRequire("acw62");

var $5etRf = parcelRequire("5etRf");
var $64A2P = parcelRequire("64A2P");

var $dW8Ij = parcelRequire("dW8Ij");
var $35c947df18664655$var$__defProp = Object.defineProperty;
var $35c947df18664655$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $35c947df18664655$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $35c947df18664655$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $35c947df18664655$var$__defNormalProp = (obj, key, value)=>key in obj ? $35c947df18664655$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $35c947df18664655$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($35c947df18664655$var$__hasOwnProp.call(b, prop)) $35c947df18664655$var$__defNormalProp(a, prop, b[prop]);
    if ($35c947df18664655$var$__getOwnPropSymbols) {
        for (var prop of $35c947df18664655$var$__getOwnPropSymbols(b))if ($35c947df18664655$var$__propIsEnum.call(b, prop)) $35c947df18664655$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $35c947df18664655$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($35c947df18664655$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $35c947df18664655$var$__getOwnPropSymbols) {
        for (var prop of $35c947df18664655$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $35c947df18664655$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $35c947df18664655$var$defaultProps = {
    size: "sm"
};
const $35c947df18664655$export$e587c41f8a2e48c5 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("PickerControl", $35c947df18664655$var$defaultProps, props), { className: className, children: children, disabled: disabled, selected: selected, classNames: classNames, styles: styles, unstyled: unstyled, firstInRange: firstInRange, lastInRange: lastInRange, inRange: inRange, __staticSelector: __staticSelector, size: size, variant: variant } = _a, others = $35c947df18664655$var$__objRest(_a, [
        "className",
        "children",
        "disabled",
        "selected",
        "classNames",
        "styles",
        "unstyled",
        "firstInRange",
        "lastInRange",
        "inRange",
        "__staticSelector",
        "size",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $dW8Ij.default)(null, {
        name: [
            "PickerControl",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5etRf.UnstyledButton), $35c947df18664655$var$__spreadValues({
        className: cx(classes.pickerControl, className),
        ref: ref,
        unstyled: unstyled,
        "data-picker-control": true,
        "data-selected": selected && !disabled || void 0,
        "data-disabled": disabled || void 0,
        "data-in-range": inRange && !disabled && !selected || void 0,
        "data-first-in-range": firstInRange && !disabled || void 0,
        "data-last-in-range": lastInRange && !disabled || void 0,
        disabled: disabled
    }, others), children);
});
$35c947df18664655$export$e587c41f8a2e48c5.displayName = "@mantine/dates/PickerControl";

});
parcelRegister("dW8Ij", function(module, exports) {

$parcel$export(module.exports, "default", () => $a257737d2d633b18$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");

var $jicY7 = parcelRequire("jicY7");
var $a257737d2d633b18$var$__defProp = Object.defineProperty;
var $a257737d2d633b18$var$__defProps = Object.defineProperties;
var $a257737d2d633b18$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $a257737d2d633b18$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $a257737d2d633b18$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $a257737d2d633b18$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $a257737d2d633b18$var$__defNormalProp = (obj, key, value)=>key in obj ? $a257737d2d633b18$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $a257737d2d633b18$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($a257737d2d633b18$var$__hasOwnProp.call(b, prop)) $a257737d2d633b18$var$__defNormalProp(a, prop, b[prop]);
    if ($a257737d2d633b18$var$__getOwnPropSymbols) {
        for (var prop of $a257737d2d633b18$var$__getOwnPropSymbols(b))if ($a257737d2d633b18$var$__propIsEnum.call(b, prop)) $a257737d2d633b18$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $a257737d2d633b18$var$__spreadProps = (a, b)=>$a257737d2d633b18$var$__defProps(a, $a257737d2d633b18$var$__getOwnPropDescs(b));
var $a257737d2d633b18$var$useStyles = (0, $cQG1Y.createStyles)((theme, _, { size: size })=>{
    const colors = theme.fn.variant({
        variant: "filled"
    });
    const lightColors = theme.fn.variant({
        variant: "light"
    });
    return {
        pickerControl: $a257737d2d633b18$var$__spreadProps($a257737d2d633b18$var$__spreadValues({
            fontSize: (0, $d8Ix8.getSize)({
                size: size,
                sizes: theme.fontSizes
            }),
            height: (0, $d8Ix8.getSize)({
                size: size,
                sizes: $jicY7.sizes
            }),
            width: `calc((${(0, $d8Ix8.getSize)({
                size: size,
                sizes: $jicY7.sizes
            })} * 7) / 3 + ${(0, $2jkdX.rem)(1.5)})`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            userSelect: "none",
            borderRadius: theme.fn.radius()
        }, theme.fn.hover({
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
        })), {
            "&:active": theme.activeStyles,
            "&[data-in-range]": $a257737d2d633b18$var$__spreadValues({
                backgroundColor: lightColors.background,
                borderRadius: 0
            }, theme.fn.hover({
                backgroundColor: lightColors.hover
            })),
            "&[data-first-in-range]": {
                borderRadius: 0,
                borderTopLeftRadius: theme.radius.sm,
                borderBottomLeftRadius: theme.radius.sm
            },
            "&[data-last-in-range]": {
                borderRadius: 0,
                borderTopRightRadius: theme.radius.sm,
                borderBottomRightRadius: theme.radius.sm
            },
            "&[data-last-in-range][data-first-in-range]": {
                borderRadius: theme.radius.sm
            },
            "&[data-selected]": $a257737d2d633b18$var$__spreadValues({
                color: colors.color,
                backgroundColor: colors.background
            }, theme.fn.hover({
                backgroundColor: colors.hover
            })),
            "&[data-disabled]": $a257737d2d633b18$var$__spreadProps($a257737d2d633b18$var$__spreadValues({
                color: theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[4],
                cursor: "not-allowed"
            }, theme.fn.hover({
                backgroundColor: "transparent"
            })), {
                "&:active": {
                    transform: "none"
                }
            })
        })
    };
});
var $a257737d2d633b18$export$2e2bcd8739ae039 = $a257737d2d633b18$var$useStyles;

});





parcelRegister("4DmD7", function(module, exports) {

$parcel$export(module.exports, "DecadeLevelGroup", () => $35fc5bc67db7a479$export$79692df759866778);

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $gngdn = parcelRequire("gngdn");

var $iGItt = parcelRequire("iGItt");

var $7H3Ts = parcelRequire("7H3Ts");

var $iYtL2 = parcelRequire("iYtL2");
var $35fc5bc67db7a479$var$__defProp = Object.defineProperty;
var $35fc5bc67db7a479$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $35fc5bc67db7a479$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $35fc5bc67db7a479$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $35fc5bc67db7a479$var$__defNormalProp = (obj, key, value)=>key in obj ? $35fc5bc67db7a479$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $35fc5bc67db7a479$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($35fc5bc67db7a479$var$__hasOwnProp.call(b, prop)) $35fc5bc67db7a479$var$__defNormalProp(a, prop, b[prop]);
    if ($35fc5bc67db7a479$var$__getOwnPropSymbols) {
        for (var prop of $35fc5bc67db7a479$var$__getOwnPropSymbols(b))if ($35fc5bc67db7a479$var$__propIsEnum.call(b, prop)) $35fc5bc67db7a479$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $35fc5bc67db7a479$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($35fc5bc67db7a479$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $35fc5bc67db7a479$var$__getOwnPropSymbols) {
        for (var prop of $35fc5bc67db7a479$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $35fc5bc67db7a479$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $35fc5bc67db7a479$var$defaultProps = {
    numberOfColumns: 1
};
const $35fc5bc67db7a479$export$79692df759866778 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("DecadeLevelGroup", $35fc5bc67db7a479$var$defaultProps, props), { decade: decade, locale: locale, minDate: minDate, maxDate: maxDate, yearsListFormat: yearsListFormat, getYearControlProps: getYearControlProps, __onControlClick: __onControlClick, __onControlMouseEnter: __onControlMouseEnter, withCellSpacing: withCellSpacing, __preventFocus: __preventFocus, nextIcon: nextIcon, previousIcon: previousIcon, nextLabel: nextLabel, previousLabel: previousLabel, onNext: onNext, onPrevious: onPrevious, nextDisabled: nextDisabled, previousDisabled: previousDisabled, className: className, classNames: classNames, styles: styles, unstyled: unstyled, __staticSelector: __staticSelector, __stopPropagation: __stopPropagation, numberOfColumns: numberOfColumns, levelControlAriaLabel: levelControlAriaLabel, decadeLabelFormat: decadeLabelFormat, variant: variant, size: size } = _a, others = $35fc5bc67db7a479$var$__objRest(_a, [
        "decade",
        "locale",
        "minDate",
        "maxDate",
        "yearsListFormat",
        "getYearControlProps",
        "__onControlClick",
        "__onControlMouseEnter",
        "withCellSpacing",
        "__preventFocus",
        "nextIcon",
        "previousIcon",
        "nextLabel",
        "previousLabel",
        "onNext",
        "onPrevious",
        "nextDisabled",
        "previousDisabled",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "__staticSelector",
        "__stopPropagation",
        "numberOfColumns",
        "levelControlAriaLabel",
        "decadeLabelFormat",
        "variant",
        "size"
    ]);
    const { classes: classes, cx: cx } = (0, $iGItt.default)(null, {
        name: [
            "DecadeLevelGroup",
            __staticSelector
        ],
        styles: styles,
        classNames: classNames,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const controlsRef = (0, $acw62.useRef)([]);
    const decades = Array(numberOfColumns).fill(0).map((_, decadeIndex)=>{
        const currentDecade = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(decade).add(decadeIndex * 10, "years").toDate();
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7H3Ts.DecadeLevel), {
            key: decadeIndex,
            variant: variant,
            size: size,
            yearsListFormat: yearsListFormat,
            decade: currentDecade,
            withNext: decadeIndex === numberOfColumns - 1,
            withPrevious: decadeIndex === 0,
            decadeLabelFormat: decadeLabelFormat,
            __onControlClick: __onControlClick,
            __onControlMouseEnter: __onControlMouseEnter,
            __onControlKeyDown: (event, payload)=>(0, $iYtL2.handleControlKeyDown)({
                    levelIndex: decadeIndex,
                    rowIndex: payload.rowIndex,
                    cellIndex: payload.cellIndex,
                    event: event,
                    controlsRef: controlsRef
                }),
            __getControlRef: (rowIndex, cellIndex, node)=>{
                if (!Array.isArray(controlsRef.current[decadeIndex])) controlsRef.current[decadeIndex] = [];
                if (!Array.isArray(controlsRef.current[decadeIndex][rowIndex])) controlsRef.current[decadeIndex][rowIndex] = [];
                controlsRef.current[decadeIndex][rowIndex][cellIndex] = node;
            },
            levelControlAriaLabel: typeof levelControlAriaLabel === "function" ? levelControlAriaLabel(currentDecade) : levelControlAriaLabel,
            locale: locale,
            minDate: minDate,
            maxDate: maxDate,
            __preventFocus: __preventFocus,
            __stopPropagation: __stopPropagation,
            nextIcon: nextIcon,
            previousIcon: previousIcon,
            nextLabel: nextLabel,
            previousLabel: previousLabel,
            onNext: onNext,
            onPrevious: onPrevious,
            nextDisabled: nextDisabled,
            previousDisabled: previousDisabled,
            getYearControlProps: getYearControlProps,
            __staticSelector: __staticSelector || "DecadeLevelGroup",
            classNames: classNames,
            styles: styles,
            unstyled: unstyled,
            withCellSpacing: withCellSpacing
        });
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $35fc5bc67db7a479$var$__spreadValues({
        className: cx(classes.decadeLevelGroup, className),
        ref: ref
    }, others), decades);
});
$35fc5bc67db7a479$export$79692df759866778.displayName = "@mantine/dates/DecadeLevelGroup";

});
parcelRegister("iGItt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9aea5f194eb9928$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d9aea5f194eb9928$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        decadeLevelGroup: {
            display: "flex",
            gap: theme.spacing.md
        }
    }));
var $d9aea5f194eb9928$export$2e2bcd8739ae039 = $d9aea5f194eb9928$var$useStyles;

});

parcelRegister("7H3Ts", function(module, exports) {

$parcel$export(module.exports, "DecadeLevel", () => $599f91bc1afb7999$export$c3d7e8de9c2e2c81);

var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $hB8fP = parcelRequire("hB8fP");

var $1hcXW = parcelRequire("1hcXW");

var $6YkAK = parcelRequire("6YkAK");

var $keeN6 = parcelRequire("keeN6");

var $guRXk = parcelRequire("guRXk");
var $599f91bc1afb7999$var$__defProp = Object.defineProperty;
var $599f91bc1afb7999$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $599f91bc1afb7999$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $599f91bc1afb7999$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $599f91bc1afb7999$var$__defNormalProp = (obj, key, value)=>key in obj ? $599f91bc1afb7999$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $599f91bc1afb7999$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($599f91bc1afb7999$var$__hasOwnProp.call(b, prop)) $599f91bc1afb7999$var$__defNormalProp(a, prop, b[prop]);
    if ($599f91bc1afb7999$var$__getOwnPropSymbols) {
        for (var prop of $599f91bc1afb7999$var$__getOwnPropSymbols(b))if ($599f91bc1afb7999$var$__propIsEnum.call(b, prop)) $599f91bc1afb7999$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $599f91bc1afb7999$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($599f91bc1afb7999$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $599f91bc1afb7999$var$__getOwnPropSymbols) {
        for (var prop of $599f91bc1afb7999$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $599f91bc1afb7999$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $599f91bc1afb7999$var$defaultProps = {
    decadeLabelFormat: "YYYY"
};
const $599f91bc1afb7999$export$c3d7e8de9c2e2c81 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("DecadeLevel", $599f91bc1afb7999$var$defaultProps, props), { decade: decade, locale: locale, minDate: minDate, maxDate: maxDate, yearsListFormat: yearsListFormat, getYearControlProps: getYearControlProps, __getControlRef: __getControlRef, __onControlKeyDown: __onControlKeyDown, __onControlClick: __onControlClick, __onControlMouseEnter: __onControlMouseEnter, withCellSpacing: withCellSpacing, __preventFocus: __preventFocus, nextIcon: nextIcon, previousIcon: previousIcon, nextLabel: nextLabel, previousLabel: previousLabel, onNext: onNext, onPrevious: onPrevious, nextDisabled: nextDisabled, previousDisabled: previousDisabled, levelControlAriaLabel: levelControlAriaLabel, withNext: withNext, withPrevious: withPrevious, className: className, decadeLabelFormat: decadeLabelFormat, classNames: classNames, styles: styles, unstyled: unstyled, __staticSelector: __staticSelector, __stopPropagation: __stopPropagation, variant: variant, size: size } = _a, others = $599f91bc1afb7999$var$__objRest(_a, [
        "decade",
        "locale",
        "minDate",
        "maxDate",
        "yearsListFormat",
        "getYearControlProps",
        "__getControlRef",
        "__onControlKeyDown",
        "__onControlClick",
        "__onControlMouseEnter",
        "withCellSpacing",
        "__preventFocus",
        "nextIcon",
        "previousIcon",
        "nextLabel",
        "previousLabel",
        "onNext",
        "onPrevious",
        "nextDisabled",
        "previousDisabled",
        "levelControlAriaLabel",
        "withNext",
        "withPrevious",
        "className",
        "decadeLabelFormat",
        "classNames",
        "styles",
        "unstyled",
        "__staticSelector",
        "__stopPropagation",
        "variant",
        "size"
    ]);
    const { classes: classes, cx: cx } = (0, $1hcXW.default)(null, {
        name: [
            "DecadeLevel",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const ctx = (0, $6YkAK.useDatesContext)();
    const [startOfDecade, endOfDecade] = (0, $hB8fP.getDecadeRange)(decade);
    const stylesApiProps = {
        __staticSelector: __staticSelector || "DecadeLevel",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    };
    const _nextDisabled = typeof nextDisabled === "boolean" ? nextDisabled : maxDate ? !(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(endOfDecade).endOf("year").isBefore(maxDate) : false;
    const _previousDisabled = typeof previousDisabled === "boolean" ? previousDisabled : minDate ? !(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(startOfDecade).startOf("year").isAfter(minDate) : false;
    const formatDecade = (date, format)=>(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).locale(locale || ctx.locale).format(format);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $599f91bc1afb7999$var$__spreadValues({
        className: cx(classes.decadeLevel, className),
        "data-decade-level": true,
        ref: ref
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $keeN6.CalendarHeader), $599f91bc1afb7999$var$__spreadValues({
        label: typeof decadeLabelFormat === "function" ? decadeLabelFormat(startOfDecade, endOfDecade) : `${formatDecade(startOfDecade, decadeLabelFormat)} \u2013 ${formatDecade(endOfDecade, decadeLabelFormat)}`,
        className: classes.calendarHeader,
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        nextIcon: nextIcon,
        previousIcon: previousIcon,
        nextLabel: nextLabel,
        previousLabel: previousLabel,
        onNext: onNext,
        onPrevious: onPrevious,
        nextDisabled: _nextDisabled,
        previousDisabled: _previousDisabled,
        hasNextLevel: false,
        levelControlAriaLabel: levelControlAriaLabel,
        withNext: withNext,
        withPrevious: withPrevious
    }, stylesApiProps)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $guRXk.YearsList), $599f91bc1afb7999$var$__spreadValues({
        decade: decade,
        locale: locale,
        minDate: minDate,
        maxDate: maxDate,
        yearsListFormat: yearsListFormat,
        getYearControlProps: getYearControlProps,
        __getControlRef: __getControlRef,
        __onControlKeyDown: __onControlKeyDown,
        __onControlClick: __onControlClick,
        __onControlMouseEnter: __onControlMouseEnter,
        __preventFocus: __preventFocus,
        __stopPropagation: __stopPropagation,
        withCellSpacing: withCellSpacing
    }, stylesApiProps)));
});
$599f91bc1afb7999$export$c3d7e8de9c2e2c81.displayName = "@mantine/dates/DecadeLevel";

});
parcelRegister("hB8fP", function(module, exports) {

$parcel$export(module.exports, "getDecadeRange", () => $ccfc4b7ed3ba3a6b$export$35cef0a1278b17e1);

var $dfwI3 = parcelRequire("dfwI3");
function $ccfc4b7ed3ba3a6b$export$35cef0a1278b17e1(decade) {
    const years = (0, $dfwI3.getYearsData)(decade);
    return [
        years[0][0],
        years[3][0]
    ];
}

});
parcelRegister("dfwI3", function(module, exports) {

$parcel$export(module.exports, "getYearsData", () => $9a560c8526c49c65$export$82db5d9a0ed02293);
function $9a560c8526c49c65$export$82db5d9a0ed02293(decade) {
    const year = decade.getFullYear();
    const rounded = year - year % 10;
    let currentYearIndex = 0;
    const results = [
        [],
        [],
        [],
        []
    ];
    for(let i = 0; i < 4; i += 1){
        const max = i === 3 ? 1 : 3;
        for(let j = 0; j < max; j += 1){
            results[i].push(new Date(rounded + currentYearIndex, 0));
            currentYearIndex += 1;
        }
    }
    return results;
}

});


parcelRegister("1hcXW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee16fb3f58feedd$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $0ee16fb3f58feedd$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        decadeLevel: {},
        calendarHeader: {
            marginBottom: theme.spacing.xs
        }
    }));
var $0ee16fb3f58feedd$export$2e2bcd8739ae039 = $0ee16fb3f58feedd$var$useStyles;

});

parcelRegister("guRXk", function(module, exports) {

$parcel$export(module.exports, "YearsList", () => $c0294d36dc6353f4$export$902a21df899bfa9d);

var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $64A2P = parcelRequire("64A2P");

var $dfwI3 = parcelRequire("dfwI3");

var $i6yGZ = parcelRequire("i6yGZ");

var $7oNMB = parcelRequire("7oNMB");

var $kno2Q = parcelRequire("kno2Q");

var $6YkAK = parcelRequire("6YkAK");

var $4CiMA = parcelRequire("4CiMA");
var $c0294d36dc6353f4$var$__defProp = Object.defineProperty;
var $c0294d36dc6353f4$var$__defProps = Object.defineProperties;
var $c0294d36dc6353f4$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c0294d36dc6353f4$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c0294d36dc6353f4$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c0294d36dc6353f4$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c0294d36dc6353f4$var$__defNormalProp = (obj, key, value)=>key in obj ? $c0294d36dc6353f4$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c0294d36dc6353f4$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c0294d36dc6353f4$var$__hasOwnProp.call(b, prop)) $c0294d36dc6353f4$var$__defNormalProp(a, prop, b[prop]);
    if ($c0294d36dc6353f4$var$__getOwnPropSymbols) {
        for (var prop of $c0294d36dc6353f4$var$__getOwnPropSymbols(b))if ($c0294d36dc6353f4$var$__propIsEnum.call(b, prop)) $c0294d36dc6353f4$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c0294d36dc6353f4$var$__spreadProps = (a, b)=>$c0294d36dc6353f4$var$__defProps(a, $c0294d36dc6353f4$var$__getOwnPropDescs(b));
var $c0294d36dc6353f4$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($c0294d36dc6353f4$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $c0294d36dc6353f4$var$__getOwnPropSymbols) {
        for (var prop of $c0294d36dc6353f4$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $c0294d36dc6353f4$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $c0294d36dc6353f4$var$defaultProps = {
    yearsListFormat: "YYYY",
    size: "sm",
    withCellSpacing: true
};
const $c0294d36dc6353f4$export$902a21df899bfa9d = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("YearsList", $c0294d36dc6353f4$var$defaultProps, props), { decade: decade, className: className, yearsListFormat: yearsListFormat, locale: locale, minDate: minDate, maxDate: maxDate, getYearControlProps: getYearControlProps, classNames: classNames, styles: styles, unstyled: unstyled, __staticSelector: __staticSelector, __getControlRef: __getControlRef, __onControlKeyDown: __onControlKeyDown, __onControlClick: __onControlClick, __onControlMouseEnter: __onControlMouseEnter, __preventFocus: __preventFocus, __stopPropagation: __stopPropagation, size: size, variant: variant, withCellSpacing: withCellSpacing } = _a, others = $c0294d36dc6353f4$var$__objRest(_a, [
        "decade",
        "className",
        "yearsListFormat",
        "locale",
        "minDate",
        "maxDate",
        "getYearControlProps",
        "classNames",
        "styles",
        "unstyled",
        "__staticSelector",
        "__getControlRef",
        "__onControlKeyDown",
        "__onControlClick",
        "__onControlMouseEnter",
        "__preventFocus",
        "__stopPropagation",
        "size",
        "variant",
        "withCellSpacing"
    ]);
    const { classes: classes, cx: cx } = (0, $7oNMB.default)(null, {
        name: [
            "YearsList",
            __staticSelector
        ],
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    const ctx = (0, $6YkAK.useDatesContext)();
    const years = (0, $dfwI3.getYearsData)(decade);
    const yearInTabOrder = (0, $kno2Q.getYearInTabOrder)(years, minDate, maxDate, getYearControlProps);
    const rows = years.map((yearsRow, rowIndex)=>{
        const cells = yearsRow.map((year, cellIndex)=>{
            const controlProps = getYearControlProps == null ? void 0 : getYearControlProps(year);
            const isYearInTabOrder = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).isSame(yearInTabOrder, "year");
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("td", {
                key: cellIndex,
                className: classes.yearsListCell,
                "data-with-spacing": withCellSpacing || void 0
            }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4CiMA.PickerControl), $c0294d36dc6353f4$var$__spreadProps($c0294d36dc6353f4$var$__spreadValues({
                size: size,
                variant: variant,
                classNames: classNames,
                styles: styles,
                unstyled: unstyled,
                __staticSelector: __staticSelector || "YearsList",
                "data-mantine-stop-propagation": __stopPropagation || void 0,
                disabled: (0, $i6yGZ.isYearDisabled)(year, minDate, maxDate),
                ref: (node)=>__getControlRef == null ? void 0 : __getControlRef(rowIndex, cellIndex, node)
            }, controlProps), {
                onKeyDown: (event)=>{
                    var _a2;
                    (_a2 = controlProps == null ? void 0 : controlProps.onKeyDown) == null || _a2.call(controlProps, event);
                    __onControlKeyDown == null || __onControlKeyDown(event, {
                        rowIndex: rowIndex,
                        cellIndex: cellIndex,
                        date: year
                    });
                },
                onClick: (event)=>{
                    var _a2;
                    (_a2 = controlProps == null ? void 0 : controlProps.onClick) == null || _a2.call(controlProps, event);
                    __onControlClick == null || __onControlClick(event, year);
                },
                onMouseEnter: (event)=>{
                    var _a2;
                    (_a2 = controlProps == null ? void 0 : controlProps.onMouseEnter) == null || _a2.call(controlProps, event);
                    __onControlMouseEnter == null || __onControlMouseEnter(event, year);
                },
                onMouseDown: (event)=>{
                    var _a2;
                    (_a2 = controlProps == null ? void 0 : controlProps.onMouseDown) == null || _a2.call(controlProps, event);
                    __preventFocus && event.preventDefault();
                },
                tabIndex: __preventFocus || !isYearInTabOrder ? -1 : 0
            }), (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).locale(ctx.getLocale(locale)).format(yearsListFormat)));
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tr", {
            key: rowIndex,
            className: classes.yearsListRow
        }, cells);
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $c0294d36dc6353f4$var$__spreadValues({
        component: "table",
        ref: ref,
        className: cx(classes.yearsList, className)
    }, others), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("tbody", null, rows));
});
$c0294d36dc6353f4$export$902a21df899bfa9d.displayName = "@mantine/dates/YearsList";

});
parcelRegister("i6yGZ", function(module, exports) {

$parcel$export(module.exports, "isYearDisabled", () => $d2e3b2b868e47347$export$a18b058c7a2120c7);

var $gngdn = parcelRequire("gngdn");
function $d2e3b2b868e47347$export$a18b058c7a2120c7(year, minDate, maxDate) {
    if (!minDate && !maxDate) return false;
    if (minDate && (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).isBefore(minDate, "year")) return true;
    if (maxDate && (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(year).isAfter(maxDate, "year")) return true;
    return false;
}

});

parcelRegister("7oNMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $56316426ac123711$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $56316426ac123711$var$useStyles = (0, $cQG1Y.createStyles)(()=>({
        yearsList: {
            borderCollapse: "collapse",
            borderWidth: 0
        },
        yearsListCell: {
            padding: 0,
            "&[data-with-spacing]": {
                padding: (0, $2jkdX.rem)(0.5)
            }
        },
        yearsListRow: {}
    }));
var $56316426ac123711$export$2e2bcd8739ae039 = $56316426ac123711$var$useStyles;

});

parcelRegister("kno2Q", function(module, exports) {

$parcel$export(module.exports, "getYearInTabOrder", () => $ed589b6ffabab196$export$c9cbba444b0b81f1);

var $gngdn = parcelRequire("gngdn");

var $i6yGZ = parcelRequire("i6yGZ");
function $ed589b6ffabab196$export$c9cbba444b0b81f1(years, minDate, maxDate, getYearControlProps) {
    const enabledYears = years.flat().filter((year)=>{
        var _a;
        return !(0, $i6yGZ.isYearDisabled)(year, minDate, maxDate) && !((_a = getYearControlProps == null ? void 0 : getYearControlProps(year)) == null ? void 0 : _a.disabled);
    });
    const selectedYear = enabledYears.find((year)=>{
        var _a;
        return (_a = getYearControlProps == null ? void 0 : getYearControlProps(year)) == null ? void 0 : _a.selected;
    });
    if (selectedYear) return selectedYear;
    const currentYear = enabledYears.find((year)=>(0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))().isSame(year, "year"));
    if (currentYear) return currentYear;
    return enabledYears[0];
}

});





parcelRegister("eW7ob", function(module, exports) {

$parcel$export(module.exports, "DateInput", () => $adfc36cd0d70a585$export$7edc06cf1783b30f);

var $gngdn = parcelRequire("gngdn");

var $acw62 = parcelRequire("acw62");

var $lUJd1 = parcelRequire("lUJd1");
var $gw63X = parcelRequire("gw63X");
var $6gwXS = parcelRequire("6gwXS");
var $hEdEV = parcelRequire("hEdEV");

var $2qf6h = parcelRequire("2qf6h");
var $ke4gU = parcelRequire("ke4gU");

var $j4ihY = parcelRequire("j4ihY");

var $fpNZe = parcelRequire("fpNZe");

var $7xfkA = parcelRequire("7xfkA");

var $6YkAK = parcelRequire("6YkAK");

var $2cTph = parcelRequire("2cTph");

var $a8D11 = parcelRequire("a8D11");

var $b9XfF = parcelRequire("b9XfF");
var $adfc36cd0d70a585$var$__defProp = Object.defineProperty;
var $adfc36cd0d70a585$var$__defProps = Object.defineProperties;
var $adfc36cd0d70a585$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $adfc36cd0d70a585$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $adfc36cd0d70a585$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $adfc36cd0d70a585$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $adfc36cd0d70a585$var$__defNormalProp = (obj, key, value)=>key in obj ? $adfc36cd0d70a585$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $adfc36cd0d70a585$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($adfc36cd0d70a585$var$__hasOwnProp.call(b, prop)) $adfc36cd0d70a585$var$__defNormalProp(a, prop, b[prop]);
    if ($adfc36cd0d70a585$var$__getOwnPropSymbols) {
        for (var prop of $adfc36cd0d70a585$var$__getOwnPropSymbols(b))if ($adfc36cd0d70a585$var$__propIsEnum.call(b, prop)) $adfc36cd0d70a585$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $adfc36cd0d70a585$var$__spreadProps = (a, b)=>$adfc36cd0d70a585$var$__defProps(a, $adfc36cd0d70a585$var$__getOwnPropDescs(b));
var $adfc36cd0d70a585$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($adfc36cd0d70a585$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $adfc36cd0d70a585$var$__getOwnPropSymbols) {
        for (var prop of $adfc36cd0d70a585$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $adfc36cd0d70a585$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $adfc36cd0d70a585$var$defaultProps = {
    valueFormat: "MMMM D, YYYY",
    fixOnBlur: true,
    preserveTime: true,
    size: "sm"
};
const $adfc36cd0d70a585$export$7edc06cf1783b30f = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $hEdEV.useInputProps)("DateInput", $adfc36cd0d70a585$var$defaultProps, props), { inputProps: inputProps, wrapperProps: wrapperProps, value: value, defaultValue: defaultValue, onChange: onChange, clearable: clearable, clearButtonProps: clearButtonProps, popoverProps: popoverProps, getDayProps: getDayProps, locale: locale, valueFormat: valueFormat, dateParser: dateParser, minDate: minDate, maxDate: maxDate, fixOnBlur: fixOnBlur, onFocus: onFocus, onBlur: onBlur, onClick: onClick, readOnly: readOnly, name: name, form: form, rightSection: rightSection, unstyled: unstyled, classNames: classNames, styles: styles, allowDeselect: allowDeselect, preserveTime: preserveTime, date: date, defaultDate: defaultDate, onDateChange: onDateChange } = _a, rest = $adfc36cd0d70a585$var$__objRest(_a, [
        "inputProps",
        "wrapperProps",
        "value",
        "defaultValue",
        "onChange",
        "clearable",
        "clearButtonProps",
        "popoverProps",
        "getDayProps",
        "locale",
        "valueFormat",
        "dateParser",
        "minDate",
        "maxDate",
        "fixOnBlur",
        "onFocus",
        "onBlur",
        "onClick",
        "readOnly",
        "name",
        "form",
        "rightSection",
        "unstyled",
        "classNames",
        "styles",
        "allowDeselect",
        "preserveTime",
        "date",
        "defaultDate",
        "onDateChange"
    ]);
    const { calendarProps: calendarProps, others: others } = (0, $7xfkA.pickCalendarProps)(rest);
    const ctx = (0, $6YkAK.useDatesContext)();
    const defaultDateParser = (val)=>{
        const parsedDate = (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(val, valueFormat, ctx.getLocale(locale)).toDate();
        return Number.isNaN(parsedDate.getTime()) ? (0, $fpNZe.dateStringParser)(val) : parsedDate;
    };
    const _dateParser = dateParser || defaultDateParser;
    const _allowDeselect = allowDeselect !== void 0 ? allowDeselect : clearable;
    const formatValue = (val)=>val ? (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(val).locale(ctx.getLocale(locale)).format(valueFormat) : "";
    const [_value, setValue, controlled] = (0, $ke4gU.useUncontrolled)({
        value: value,
        defaultValue: defaultValue,
        finalValue: null,
        onChange: onChange
    });
    const [_date, setDate] = (0, $ke4gU.useUncontrolled)({
        value: date,
        defaultValue: defaultValue || defaultDate,
        finalValue: null,
        onChange: onDateChange
    });
    (0, $acw62.useEffect)(()=>{
        if (controlled) setDate(value);
    }, [
        controlled,
        value
    ]);
    const [inputValue, setInputValue] = (0, $acw62.useState)(formatValue(_value));
    (0, $acw62.useEffect)(()=>{
        setInputValue(formatValue(_value));
    }, [
        ctx.getLocale(locale)
    ]);
    const [dropdownOpened, setDropdownOpened] = (0, $acw62.useState)(false);
    const handleInputChange = (event)=>{
        const val = event.currentTarget.value;
        setInputValue(val);
        if (val.trim() === "" && clearable) setValue(null);
        else {
            const dateValue = _dateParser(val);
            if ((0, $j4ihY.isDateValid)({
                date: dateValue,
                minDate: minDate,
                maxDate: maxDate
            })) {
                setValue(dateValue);
                setDate(dateValue);
            }
        }
    };
    const handleInputBlur = (event)=>{
        onBlur == null || onBlur(event);
        setDropdownOpened(false);
        fixOnBlur && setInputValue(formatValue(_value));
    };
    const handleInputFocus = (event)=>{
        onFocus == null || onFocus(event);
        setDropdownOpened(true);
    };
    const handleInputClick = (event)=>{
        onClick == null || onClick(event);
        setDropdownOpened(true);
    };
    const _getDayProps = (day)=>$adfc36cd0d70a585$var$__spreadProps($adfc36cd0d70a585$var$__spreadValues({}, getDayProps == null ? void 0 : getDayProps(day)), {
            selected: (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(_value).isSame(day, "day"),
            onClick: ()=>{
                const valueWithTime = preserveTime ? (0, $b9XfF.assignTime)(_value, day) : day;
                const val = clearable && _allowDeselect ? (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(_value).isSame(day, "day") ? null : valueWithTime : valueWithTime;
                setValue(val);
                !controlled && setInputValue(formatValue(val));
                setDropdownOpened(false);
            }
        });
    const _rightSection = rightSection || (clearable && _value && !readOnly ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lUJd1.CloseButton), $adfc36cd0d70a585$var$__spreadValues({
        variant: "transparent",
        onMouseDown: (event)=>event.preventDefault(),
        tabIndex: -1,
        onClick: ()=>{
            setValue(null);
            !controlled && setInputValue("");
            setDropdownOpened(false);
        },
        unstyled: unstyled
    }, clearButtonProps)) : null);
    (0, $2qf6h.useDidUpdate)(()=>{
        value !== void 0 && !dropdownOpened && setInputValue(formatValue(value));
    }, [
        value
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input).Wrapper, $adfc36cd0d70a585$var$__spreadProps($adfc36cd0d70a585$var$__spreadValues({}, wrapperProps), {
        __staticSelector: "DateInput"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6gwXS.Popover), $adfc36cd0d70a585$var$__spreadValues({
        opened: dropdownOpened,
        trapFocus: false,
        position: "bottom-start",
        disabled: readOnly,
        withRoles: false
    }, popoverProps), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6gwXS.Popover).Target, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gw63X.Input), $adfc36cd0d70a585$var$__spreadProps($adfc36cd0d70a585$var$__spreadValues($adfc36cd0d70a585$var$__spreadValues({
        "data-dates-input": true,
        "data-read-only": readOnly || void 0,
        autoComplete: "off",
        ref: ref,
        value: inputValue,
        onChange: handleInputChange,
        onBlur: handleInputBlur,
        onFocus: handleInputFocus,
        onClick: handleInputClick,
        readOnly: readOnly,
        rightSection: _rightSection
    }, inputProps), others), {
        __staticSelector: "DateInput"
    }))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6gwXS.Popover).Dropdown, {
        onMouseDown: (event)=>event.preventDefault(),
        "data-dates-dropdown": true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2cTph.Calendar), $adfc36cd0d70a585$var$__spreadProps($adfc36cd0d70a585$var$__spreadValues({
        __staticSelector: "DateInput"
    }, calendarProps), {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        __preventFocus: true,
        minDate: minDate,
        maxDate: maxDate,
        locale: locale,
        getDayProps: _getDayProps,
        size: inputProps.size,
        date: _date,
        onDateChange: setDate
    }))))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a8D11.HiddenDatesInput), {
        name: name,
        form: form,
        value: _value,
        type: "default"
    }));
});
$adfc36cd0d70a585$export$7edc06cf1783b30f.displayName = "@mantine/dates/DateInput";

});
parcelRegister("j4ihY", function(module, exports) {

$parcel$export(module.exports, "isDateValid", () => $de1c93d811a0f7fb$export$2de9850507a2d6ef);

var $gngdn = parcelRequire("gngdn");
function $de1c93d811a0f7fb$export$2de9850507a2d6ef({ date: date, maxDate: maxDate, minDate: minDate }) {
    if (date == null) return false;
    if (Number.isNaN(date.getTime())) return false;
    if (maxDate && (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).isAfter(maxDate, "date")) return false;
    if (minDate && (0, (/*@__PURE__*/$parcel$interopDefault($gngdn)))(date).isBefore(minDate, "date")) return false;
    return true;
}

});

parcelRegister("fpNZe", function(module, exports) {

$parcel$export(module.exports, "dateStringParser", () => $b38ff71cf0fc924c$export$99dc75fcb02c2bd4);
function $b38ff71cf0fc924c$export$99dc75fcb02c2bd4(dateString) {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime()) || !dateString) return null;
    return date;
}

});

parcelRegister("7xfkA", function(module, exports) {

$parcel$export(module.exports, "pickCalendarProps", () => $57c781e57f7c39a9$export$207b7389022c7866);
var $57c781e57f7c39a9$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $57c781e57f7c39a9$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $57c781e57f7c39a9$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $57c781e57f7c39a9$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($57c781e57f7c39a9$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $57c781e57f7c39a9$var$__getOwnPropSymbols) {
        for (var prop of $57c781e57f7c39a9$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $57c781e57f7c39a9$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $57c781e57f7c39a9$export$207b7389022c7866(props) {
    const _a = props, { maxLevel: maxLevel, minLevel: minLevel, defaultLevel: defaultLevel, level: level, onLevelChange: onLevelChange, nextIcon: nextIcon, previousIcon: previousIcon, date: date, defaultDate: defaultDate, onDateChange: onDateChange, numberOfColumns: numberOfColumns, columnsToScroll: columnsToScroll, ariaLabels: ariaLabels, onYearSelect: onYearSelect, onMonthSelect: onMonthSelect, onYearMouseEnter: onYearMouseEnter, onMonthMouseEnter: onMonthMouseEnter, onNextMonth: onNextMonth, onPreviousMonth: onPreviousMonth, onNextYear: onNextYear, onPreviousYear: onPreviousYear, onNextDecade: onNextDecade, onPreviousDecade: onPreviousDecade, withCellSpacing: withCellSpacing, __updateDateOnYearSelect: __updateDateOnYearSelect, __updateDateOnMonthSelect: __updateDateOnMonthSelect, firstDayOfWeek: firstDayOfWeek, weekdayFormat: weekdayFormat, weekendDays: weekendDays, getDayProps: getDayProps, excludeDate: excludeDate, renderDay: renderDay, hideOutsideDates: hideOutsideDates, hideWeekdays: hideWeekdays, getDayAriaLabel: getDayAriaLabel, monthLabelFormat: monthLabelFormat, monthsListFormat: monthsListFormat, getMonthControlProps: getMonthControlProps, yearLabelFormat: yearLabelFormat, yearsListFormat: yearsListFormat, getYearControlProps: getYearControlProps, decadeLabelFormat: decadeLabelFormat, allowSingleDateInRange: allowSingleDateInRange, allowDeselect: allowDeselect, minDate: minDate, maxDate: maxDate, locale: locale } = _a, others = $57c781e57f7c39a9$var$__objRest(_a, [
        "maxLevel",
        "minLevel",
        "defaultLevel",
        "level",
        "onLevelChange",
        "nextIcon",
        "previousIcon",
        "date",
        "defaultDate",
        "onDateChange",
        "numberOfColumns",
        "columnsToScroll",
        "ariaLabels",
        "onYearSelect",
        "onMonthSelect",
        "onYearMouseEnter",
        "onMonthMouseEnter",
        "onNextMonth",
        "onPreviousMonth",
        "onNextYear",
        "onPreviousYear",
        "onNextDecade",
        "onPreviousDecade",
        "withCellSpacing",
        "__updateDateOnYearSelect",
        "__updateDateOnMonthSelect",
        "firstDayOfWeek",
        "weekdayFormat",
        "weekendDays",
        "getDayProps",
        "excludeDate",
        "renderDay",
        "hideOutsideDates",
        "hideWeekdays",
        "getDayAriaLabel",
        "monthLabelFormat",
        "monthsListFormat",
        "getMonthControlProps",
        "yearLabelFormat",
        "yearsListFormat",
        "getYearControlProps",
        "decadeLabelFormat",
        "allowSingleDateInRange",
        "allowDeselect",
        "minDate",
        "maxDate",
        "locale"
    ]);
    return {
        calendarProps: {
            maxLevel: maxLevel,
            minLevel: minLevel,
            defaultLevel: defaultLevel,
            level: level,
            onLevelChange: onLevelChange,
            nextIcon: nextIcon,
            previousIcon: previousIcon,
            date: date,
            defaultDate: defaultDate,
            onDateChange: onDateChange,
            numberOfColumns: numberOfColumns,
            columnsToScroll: columnsToScroll,
            ariaLabels: ariaLabels,
            onYearSelect: onYearSelect,
            onMonthSelect: onMonthSelect,
            onYearMouseEnter: onYearMouseEnter,
            onMonthMouseEnter: onMonthMouseEnter,
            onNextMonth: onNextMonth,
            onPreviousMonth: onPreviousMonth,
            onNextYear: onNextYear,
            onPreviousYear: onPreviousYear,
            onNextDecade: onNextDecade,
            onPreviousDecade: onPreviousDecade,
            withCellSpacing: withCellSpacing,
            __updateDateOnYearSelect: __updateDateOnYearSelect,
            __updateDateOnMonthSelect: __updateDateOnMonthSelect,
            firstDayOfWeek: firstDayOfWeek,
            weekdayFormat: weekdayFormat,
            weekendDays: weekendDays,
            getDayProps: getDayProps,
            excludeDate: excludeDate,
            renderDay: renderDay,
            hideOutsideDates: hideOutsideDates,
            hideWeekdays: hideWeekdays,
            getDayAriaLabel: getDayAriaLabel,
            monthLabelFormat: monthLabelFormat,
            monthsListFormat: monthsListFormat,
            getMonthControlProps: getMonthControlProps,
            yearLabelFormat: yearLabelFormat,
            yearsListFormat: yearsListFormat,
            getYearControlProps: getYearControlProps,
            decadeLabelFormat: decadeLabelFormat,
            allowSingleDateInRange: allowSingleDateInRange,
            allowDeselect: allowDeselect,
            minDate: minDate,
            maxDate: maxDate,
            locale: locale
        },
        others: others
    };
}

});

parcelRegister("a8D11", function(module, exports) {

$parcel$export(module.exports, "HiddenDatesInput", () => $7618ea650f17fb86$export$49d693a5d5703c68);

var $acw62 = parcelRequire("acw62");
function $7618ea650f17fb86$var$formatValue(value, type) {
    if (type === "range" && Array.isArray(value)) {
        const [startDate, endDate] = value;
        if (!startDate) return "";
        if (!endDate) return `${startDate.toISOString()} \u2013`;
        return `${startDate.toISOString()} \u2013 ${endDate.toISOString()}`;
    }
    if (type === "multiple" && Array.isArray(value)) return value.map((date)=>date.toISOString()).join(", ");
    if (!Array.isArray(value) && value) return value.toISOString();
    return "";
}
function $7618ea650f17fb86$export$49d693a5d5703c68({ value: value, type: type, name: name, form: form }) {
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "hidden",
        value: $7618ea650f17fb86$var$formatValue(value, type),
        name: name,
        form: form
    });
}
$7618ea650f17fb86$export$49d693a5d5703c68.displayName = "@mantine/dates/HiddenDatesInput";

});

parcelRegister("b9XfF", function(module, exports) {

$parcel$export(module.exports, "assignTime", () => $81fe7f22cdba6afd$export$fe3f3b30a310f4ea);
function $81fe7f22cdba6afd$export$fe3f3b30a310f4ea(originalDate, resultDate) {
    if (!originalDate || !resultDate) return resultDate;
    const hours = originalDate.getHours();
    const minutes = originalDate.getMinutes();
    const seconds = originalDate.getSeconds();
    const ms = originalDate.getMilliseconds();
    const result = new Date(resultDate);
    result.setHours(hours);
    result.setMinutes(minutes);
    result.setSeconds(seconds);
    result.setMilliseconds(ms);
    return result;
}

});


parcelRegister("bXiXt", function(module, exports) {

$parcel$export(module.exports, "TimeInput", () => $8b43e9187b7cde38$export$a1af6f79df847fac);

var $acw62 = parcelRequire("acw62");

var $8mycu = parcelRequire("8mycu");
var $64A2P = parcelRequire("64A2P");

var $8ZMet = parcelRequire("8ZMet");
var $8b43e9187b7cde38$var$__defProp = Object.defineProperty;
var $8b43e9187b7cde38$var$__defProps = Object.defineProperties;
var $8b43e9187b7cde38$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $8b43e9187b7cde38$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $8b43e9187b7cde38$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $8b43e9187b7cde38$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $8b43e9187b7cde38$var$__defNormalProp = (obj, key, value)=>key in obj ? $8b43e9187b7cde38$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8b43e9187b7cde38$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($8b43e9187b7cde38$var$__hasOwnProp.call(b, prop)) $8b43e9187b7cde38$var$__defNormalProp(a, prop, b[prop]);
    if ($8b43e9187b7cde38$var$__getOwnPropSymbols) {
        for (var prop of $8b43e9187b7cde38$var$__getOwnPropSymbols(b))if ($8b43e9187b7cde38$var$__propIsEnum.call(b, prop)) $8b43e9187b7cde38$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $8b43e9187b7cde38$var$__spreadProps = (a, b)=>$8b43e9187b7cde38$var$__defProps(a, $8b43e9187b7cde38$var$__getOwnPropDescs(b));
var $8b43e9187b7cde38$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($8b43e9187b7cde38$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $8b43e9187b7cde38$var$__getOwnPropSymbols) {
        for (var prop of $8b43e9187b7cde38$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $8b43e9187b7cde38$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $8b43e9187b7cde38$var$defaultProps = {};
const $8b43e9187b7cde38$export$a1af6f79df847fac = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("TimeInput", $8b43e9187b7cde38$var$defaultProps, props), { classNames: classNames, withSeconds: withSeconds, variant: variant, size: size, styles: styles, unstyled: unstyled } = _a, others = $8b43e9187b7cde38$var$__objRest(_a, [
        "classNames",
        "withSeconds",
        "variant",
        "size",
        "styles",
        "unstyled"
    ]);
    const { classes: classes, cx: cx } = (0, $8ZMet.default)(null, {
        name: "TimeInput",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8mycu.TextInput), $8b43e9187b7cde38$var$__spreadValues({
        type: "time",
        step: withSeconds ? 1 : 60,
        classNames: $8b43e9187b7cde38$var$__spreadProps($8b43e9187b7cde38$var$__spreadValues({}, classNames), {
            input: cx(classes.input, classNames == null ? void 0 : classNames.input)
        }),
        styles: styles,
        unstyled: unstyled,
        variant: variant,
        size: size,
        ref: ref,
        __staticSelector: "TimeInput"
    }, others));
});
$8b43e9187b7cde38$export$a1af6f79df847fac.displayName = "@mantine/dates/TimeInput";

});
parcelRegister("8ZMet", function(module, exports) {

$parcel$export(module.exports, "default", () => $68c96f2f0eb547d3$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $2jkdX = parcelRequire("2jkdX");
var $68c96f2f0eb547d3$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        input: {
            paddingTop: 0,
            paddingBottom: 0,
            appearance: "none",
            "&::-webkit-calendar-picker-indicator": {
                display: "none"
            },
            "&::-webkit-clear-button": {
                display: "none"
            },
            "&::-webkit-datetime-edit-hour-field, &::-webkit-datetime-edit-minute-field, &::-webkit-datetime-edit-second-field": {
                paddingTop: 0,
                maxHeight: (0, $2jkdX.rem)(30),
                display: "inline",
                "&:focus": {
                    backgroundColor: theme.fn.variant({
                        variant: "filled"
                    }).background,
                    color: theme.white
                }
            }
        }
    }));
var $68c96f2f0eb547d3$export$2e2bcd8739ae039 = $68c96f2f0eb547d3$var$useStyles;

});


parcelRegister("lHTSI", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("93PFP", function(module, exports) {

$parcel$export(module.exports, "Loader", () => $2611977388863fc8$export$3b0d6d7590275603);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $2611977388863fc8$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $2611977388863fc8$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $2611977388863fc8$var$fastDeepEqual;
var $2611977388863fc8$var$hasRequiredFastDeepEqual;
function $2611977388863fc8$var$requireFastDeepEqual() {
    if ($2611977388863fc8$var$hasRequiredFastDeepEqual) return $2611977388863fc8$var$fastDeepEqual;
    $2611977388863fc8$var$hasRequiredFastDeepEqual = 1;
    // do not edit .js files directly - edit src/index.jst
    $2611977388863fc8$var$fastDeepEqual = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (a.constructor !== b.constructor) return false;
            var length, i, keys;
            if (Array.isArray(a)) {
                length = a.length;
                if (length != b.length) return false;
                for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
                return true;
            }
            if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
            if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
            if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
            keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            for(i = length; i-- !== 0;){
                var key = keys[i];
                if (!equal(a[key], b[key])) return false;
            }
            return true;
        }
        // true if both NaN, false otherwise
        return a !== a && b !== b;
    };
    return $2611977388863fc8$var$fastDeepEqual;
}
var $2611977388863fc8$var$fastDeepEqualExports = $2611977388863fc8$var$requireFastDeepEqual();
var $2611977388863fc8$var$isEqual = /*@__PURE__*/ $2611977388863fc8$var$getDefaultExportFromCjs($2611977388863fc8$var$fastDeepEqualExports);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2611977388863fc8$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $2611977388863fc8$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($2611977388863fc8$export$406cfe323c8bb8e4 || ($2611977388863fc8$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $2611977388863fc8$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $2611977388863fc8$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $2611977388863fc8$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($2611977388863fc8$export$3b0d6d7590275603.instance) {
            if (!$2611977388863fc8$var$isEqual(this.options, $2611977388863fc8$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($2611977388863fc8$export$3b0d6d7590275603.instance.options)}`);
            return $2611977388863fc8$export$3b0d6d7590275603.instance;
        }
        $2611977388863fc8$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $2611977388863fc8$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $2611977388863fc8$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $2611977388863fc8$export$406cfe323c8bb8e4.LOADING;
        return $2611977388863fc8$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback&loading=async`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$2611977388863fc8$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.loading) // do nothing but wait
        return;
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            this.loading = true;
            this.setScript();
        }
    }
}

});

parcelRegister("2ESFG", function(module, exports) {

$parcel$export(module.exports, "MarkerClusterer", () => $b648e591a8dc57ca$export$58bd9bb9fcf3dd4f);

var $35Ktr = parcelRequire("35Ktr");

var $45AVh = parcelRequire("45AVh");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $b648e591a8dc57ca$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */ class $b648e591a8dc57ca$export$87c23728007fa1bd {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (Number.isFinite(marker.position.lat) && Number.isFinite(marker.position.lng)) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            // @ts-ignore
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b648e591a8dc57ca$export$57ed47926628b770 {
    constructor({ markers: markers, position: position }){
        this.markers = [];
        if (markers) this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers)bounds.extend($b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker));
        return bounds;
    }
    get position() {
        // @ts-ignore
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */ get count() {
        return this.markers.filter((m)=>$b648e591a8dc57ca$export$87c23728007fa1bd.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */ push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */ delete() {
        if (this.marker) {
            $b648e591a8dc57ca$export$87c23728007fa1bd.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A typescript assertion function used in cases where typescript has to be
 * convinced that the object in question can not be null.
 *
 * @param value
 * @param message
 */ function $b648e591a8dc57ca$var$assertNotNull(value, message = "assertion failed") {
    if (value === null || value === undefined) throw Error(message);
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ const $b648e591a8dc57ca$export$6dcea57a2b662207 = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    const bounds = map.getBounds();
    $b648e591a8dc57ca$var$assertNotNull(bounds);
    const extendedMapBounds = $b648e591a8dc57ca$export$57247bea612a5e84(bounds, mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains($b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker)));
};
/**
 * Extends bounds by a number of pixels in each direction
 */ const $b648e591a8dc57ca$export$57247bea612a5e84 = (bounds, projection, numPixels)=>{
    const { northEast: northEast, southWest: southWest } = $b648e591a8dc57ca$var$latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = $b648e591a8dc57ca$export$8cd793acb3b8e8e8({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return $b648e591a8dc57ca$export$21d7a872d22a0f92(extendedPixelBounds, projection);
};
/**
 * Gets the extended bounds as a bbox [westLng, southLat, eastLng, northLat]
 */ const $b648e591a8dc57ca$export$6341d7e267bda241 = (bounds, projection, pixels)=>{
    const extended = $b648e591a8dc57ca$export$57247bea612a5e84(bounds, projection, pixels);
    const ne = extended.getNorthEast();
    const sw = extended.getSouthWest();
    return [
        sw.lng(),
        sw.lat(),
        ne.lng(),
        ne.lat()
    ];
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ const $b648e591a8dc57ca$export$b59117efbc9c7af = (p1, p2)=>{
    const R = 6371; // Radius of the Earth in km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLon = (p2.lng - p1.lng) * Math.PI / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ const $b648e591a8dc57ca$var$latLngBoundsToPixelBounds = (bounds, projection)=>{
    const northEast = projection.fromLatLngToDivPixel(bounds.getNorthEast());
    const southWest = projection.fromLatLngToDivPixel(bounds.getSouthWest());
    $b648e591a8dc57ca$var$assertNotNull(northEast);
    $b648e591a8dc57ca$var$assertNotNull(southWest);
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ const $b648e591a8dc57ca$export$8cd793acb3b8e8e8 = ({ northEast: northEast, southWest: southWest }, numPixels)=>{
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ const $b648e591a8dc57ca$export$21d7a872d22a0f92 = ({ northEast: northEast, southWest: southWest }, projection)=>{
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class $b648e591a8dc57ca$export$1e1bee200f7e743e {
    constructor({ maxZoom: maxZoom = 16 }){
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ noop({ markers: markers }) {
        return $b648e591a8dc57ca$export$8793edee2d425525(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class $b648e591a8dc57ca$export$d8a438b9a55dba76 extends $b648e591a8dc57ca$export$1e1bee200f7e743e {
    constructor(_a){
        var { viewportPadding: viewportPadding = 60 } = _a, options = $b648e591a8dc57ca$var$__rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        const zoom = map.getZoom();
        $b648e591a8dc57ca$var$assertNotNull(zoom);
        if (zoom >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: $b648e591a8dc57ca$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
}
/**
 * @hidden
 */ const $b648e591a8dc57ca$export$8793edee2d425525 = (markers)=>{
    const clusters = markers.map((marker)=>new $b648e591a8dc57ca$export$57ed47926628b770({
            position: $b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class $b648e591a8dc57ca$export$dfa3b6d6f10e5cac extends $b648e591a8dc57ca$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxDistance: maxDistance = 40000, gridSize: gridSize = 40 } = _a, options = $b648e591a8dc57ca$var$__rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        const zoom = map.getZoom();
        $b648e591a8dc57ca$var$assertNotNull(zoom);
        const newState = {
            zoom: zoom
        };
        let changed = false;
        if (this.state.zoom >= this.maxZoom && newState.zoom >= this.maxZoom) ;
        else changed = !(0, $35Ktr.deepEqual)(this.state, newState);
        this.state = newState;
        if (zoom >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: changed
        };
        return {
            clusters: this.cluster({
                markers: $b648e591a8dc57ca$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    cluster({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for(let i = 0; i < this.clusters.length; i++){
            const candidate = this.clusters[i];
            $b648e591a8dc57ca$var$assertNotNull(candidate.bounds);
            const distance = $b648e591a8dc57ca$export$b59117efbc9c7af(candidate.bounds.getCenter().toJSON(), $b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster) {
            $b648e591a8dc57ca$var$assertNotNull(cluster.bounds);
            if ($b648e591a8dc57ca$export$57247bea612a5e84(cluster.bounds, projection, this.gridSize).contains($b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker))) cluster.push(marker);
            else {
                const cluster = new $b648e591a8dc57ca$export$57ed47926628b770({
                    markers: [
                        marker
                    ]
                });
                this.clusters.push(cluster);
            }
        } else {
            const cluster = new $b648e591a8dc57ca$export$57ed47926628b770({
                markers: [
                    marker
                ]
            });
            this.clusters.push(cluster);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class $b648e591a8dc57ca$export$f6cacfea2ccd84d3 extends $b648e591a8dc57ca$export$1e1bee200f7e743e {
    constructor(_a){
        var options = $b648e591a8dc57ca$var$__rest(_a, []);
        super(options);
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        return {
            clusters: this.cluster({
                markers: markers,
                map: map,
                mapCanvasProjection: mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $b648e591a8dc57ca$export$3c4c9430ac0fb1eb extends $b648e591a8dc57ca$export$1e1bee200f7e743e {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60 } = _a, options = $b648e591a8dc57ca$var$__rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom: maxZoom
        });
        this.markers = [];
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.superCluster = new (0, $45AVh.default)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
    }
    calculate(input) {
        let changed = false;
        let zoom = input.map.getZoom();
        $b648e591a8dc57ca$var$assertNotNull(zoom);
        zoom = Math.round(zoom);
        const state = {
            zoom: zoom
        };
        if (!(0, $35Ktr.deepEqual)(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !(0, $35Ktr.deepEqual)(this.state, state);
        }
        this.state = state;
        // when input is empty, return right away
        if (input.markers.length === 0) {
            this.clusters = [];
            return {
                clusters: this.clusters,
                changed: changed
            };
        }
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map }) {
        const zoom = map.getZoom();
        $b648e591a8dc57ca$var$assertNotNull(zoom);
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(zoom)).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $b648e591a8dc57ca$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $b648e591a8dc57ca$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $b648e591a8dc57ca$export$80a71135475bbaa7 extends $b648e591a8dc57ca$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60, viewportPadding: viewportPadding = 60 } = _a, options = $b648e591a8dc57ca$var$__rest(_a, [
            "maxZoom",
            "radius",
            "viewportPadding"
        ]);
        super({
            maxZoom: maxZoom,
            viewportPadding: viewportPadding
        });
        this.markers = [];
        this.clusters = [];
        this.superCluster = new (0, $45AVh.default)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
        this.state = {
            zoom: -1,
            view: [
                0,
                0,
                0,
                0
            ]
        };
    }
    calculate(input) {
        const state = this.getViewportState(input);
        let changed = !(0, $35Ktr.deepEqual)(this.state, state);
        if (!(0, $35Ktr.deepEqual)(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (changed) {
            this.clusters = this.cluster(input);
            this.state = state;
        }
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster(input) {
        /* recalculate new state because we can't use the cached version. */ const state = this.getViewportState(input);
        return this.superCluster.getClusters(state.view, state.zoom).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $b648e591a8dc57ca$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $b648e591a8dc57ca$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $b648e591a8dc57ca$export$87c23728007fa1bd.getPosition(marker)
        });
    }
    getViewportState(input) {
        const mapZoom = input.map.getZoom();
        const mapBounds = input.map.getBounds();
        $b648e591a8dc57ca$var$assertNotNull(mapZoom);
        $b648e591a8dc57ca$var$assertNotNull(mapBounds);
        return {
            zoom: Math.round(mapZoom),
            view: $b648e591a8dc57ca$export$6341d7e267bda241(mapBounds, input.mapCanvasProjection, this.viewportPadding)
        };
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class $b648e591a8dc57ca$export$2deda6e6beba3286 {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        const clusterMarkerCounts = clusters.map((a)=>a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class $b648e591a8dc57ca$export$7db59afbbd5bcace {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ render({ count: count, position: position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if ($b648e591a8dc57ca$export$87c23728007fa1bd.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const parser = new DOMParser();
            const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map: map,
                position: position,
                zIndex: zIndex,
                title: title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position: position,
            zIndex: zIndex,
            title: title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b648e591a8dc57ca$var$extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(let property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $b648e591a8dc57ca$var$OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        $b648e591a8dc57ca$var$extend($b648e591a8dc57ca$var$OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b648e591a8dc57ca$export$f87b0506a2cf0bc;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
    MarkerClustererEvents["GMP_CLICK"] = "gmp-click";
})($b648e591a8dc57ca$export$f87b0506a2cf0bc || ($b648e591a8dc57ca$export$f87b0506a2cf0bc = {}));
const $b648e591a8dc57ca$export$b434dc9855552644 = (_, cluster, map)=>{
    if (cluster.bounds) map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class $b648e591a8dc57ca$export$58bd9bb9fcf3dd4f extends $b648e591a8dc57ca$var$OverlayViewSafe {
    constructor({ map: map, markers: markers = [], algorithmOptions: algorithmOptions = {}, algorithm: algorithm = new $b648e591a8dc57ca$export$3c4c9430ac0fb1eb(algorithmOptions), renderer: renderer = new $b648e591a8dc57ca$export$7db59afbbd5bcace(), onClusterClick: onClusterClick = $b648e591a8dc57ca$export$b434dc9855552644 }){
        super();
        /** @see {@link MarkerClustererOptions.map} */ this.map = null;
        this.idleListener = null;
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        $b648e591a8dc57ca$export$87c23728007fa1bd.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
     * Recalculates and draws all the marker clusters.
     */ render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, $b648e591a8dc57ca$export$f87b0506a2cf0bc.CLUSTERING_BEGIN, this);
            const { clusters: clusters, changed: changed } = this.algorithm.calculate({
                markers: this.markers,
                map: map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters){
                    if (cluster.marker == null) continue;
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        $b648e591a8dc57ca$export$87c23728007fa1bd.setMap(cluster.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(cluster.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>$b648e591a8dc57ca$export$87c23728007fa1bd.setMap(marker, null)));
            }
            google.maps.event.trigger(this, $b648e591a8dc57ca$export$f87b0506a2cf0bc.CLUSTERING_END, this);
        }
    }
    onAdd() {
        const map = this.getMap();
        $b648e591a8dc57ca$var$assertNotNull(map);
        this.idleListener = map.addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        if (this.idleListener) google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>$b648e591a8dc57ca$export$87c23728007fa1bd.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new $b648e591a8dc57ca$export$2deda6e6beba3286(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>$b648e591a8dc57ca$export$87c23728007fa1bd.setMap(marker, null));
                if (this.onClusterClick) {
                    // legacy Marker uses 'click' events, whereas AdvancedMarkerElement uses 'gmp-click'
                    const markerClickEventName = $b648e591a8dc57ca$export$87c23728007fa1bd.isAdvancedMarker(cluster.marker) ? $b648e591a8dc57ca$export$f87b0506a2cf0bc.GMP_CLICK : $b648e591a8dc57ca$export$f87b0506a2cf0bc.CLUSTER_CLICK;
                    cluster.marker.addListener(markerClickEventName, /* istanbul ignore next */ (event)=>{
                        google.maps.event.trigger(this, $b648e591a8dc57ca$export$f87b0506a2cf0bc.CLUSTER_CLICK, cluster);
                        this.onClusterClick(event, cluster, map);
                    });
                }
            }
            $b648e591a8dc57ca$export$87c23728007fa1bd.setMap(cluster.marker, map);
        });
    }
}

});
parcelRegister("35Ktr", function(module, exports) {
(function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the `@@toStringTag` of the value, if it exists.
     */ function getShortTag(value) {
        return value != null ? value[Symbol.toStringTag] : undefined;
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = '__v';
    var PREACT_OWNER = '__o';
    var REACT_OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var ERROR_TAG = '[object Error]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var URL_TAG = '[object URL]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual, unknownTagComparators = _a.unknownTagComparators;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            if (unknownTagComparators) {
                var unknownTagComparator = unknownTagComparators[tag];
                if (!unknownTagComparator) {
                    var shortTag = getShortTag(a);
                    if (shortTag) unknownTagComparator = unknownTagComparators[shortTag];
                }
                // If the custom config has an unknown tag comparator that matches the captured tag or the
                // @@toStringTag, it is the source of truth for whether the values are equal.
                if (unknownTagComparator) return unknownTagComparator(a, b, state);
            }
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual,
            unknownTagComparators: undefined
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});

});

parcelRegister("45AVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fa4452876a3c712$export$2e2bcd8739ae039);

var $eKHgz = parcelRequire("eKHgz");
const $2fa4452876a3c712$var$defaultOptions = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
const $2fa4452876a3c712$var$fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
const $2fa4452876a3c712$var$OFFSET_ZOOM = 2;
const $2fa4452876a3c712$var$OFFSET_ID = 3;
const $2fa4452876a3c712$var$OFFSET_PARENT = 4;
const $2fa4452876a3c712$var$OFFSET_NUM = 5;
const $2fa4452876a3c712$var$OFFSET_PROP = 6;
class $2fa4452876a3c712$export$2e2bcd8739ae039 {
    constructor(options){
        this.options = Object.assign(Object.create($2fa4452876a3c712$var$defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    load(points) {
        const { log: log, minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (log) console.time('total time');
        const timerId = `prepare ${points.length} points`;
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];
        for(let i = 0; i < points.length; i++){
            const p = points[i];
            if (!p.geometry) continue;
            const [lng, lat] = p.geometry.coordinates;
            const x = $2fa4452876a3c712$var$fround($2fa4452876a3c712$var$lngX(lng));
            const y = $2fa4452876a3c712$var$fround($2fa4452876a3c712$var$latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(let z = maxZoom; z >= minZoom; z--){
            const now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log('z%d: %d clusters in %dms', z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd('total time');
        return this;
    }
    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            const westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range($2fa4452876a3c712$var$lngX(minLng), $2fa4452876a3c712$var$latY(maxLat), $2fa4452876a3c712$var$lngX(maxLng), $2fa4452876a3c712$var$latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids){
            const k = this.stride * id;
            clusters.push(data[k + $2fa4452876a3c712$var$OFFSET_NUM] > 1 ? $2fa4452876a3c712$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $2fa4452876a3c712$var$OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = 'No cluster with the specified id.';
        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids){
            const k = id * this.stride;
            if (data[k + $2fa4452876a3c712$var$OFFSET_PARENT] === clusterId) children.push(data[k + $2fa4452876a3c712$var$OFFSET_NUM] > 1 ? $2fa4452876a3c712$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $2fa4452876a3c712$var$OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const { extent: extent, radius: radius } = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;
        const tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);
        for (const child of children){
            const props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        const tree = new (0, $eKHgz.default)(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids){
            const k = i * this.stride;
            const isCluster = data[k + $2fa4452876a3c712$var$OFFSET_NUM] > 1;
            let tags, px, py;
            if (isCluster) {
                tags = $2fa4452876a3c712$var$getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + $2fa4452876a3c712$var$OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = $2fa4452876a3c712$var$lngX(lng);
                py = $2fa4452876a3c712$var$latY(lat);
            }
            const f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags: tags
            };
            // assign id
            let id;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + $2fa4452876a3c712$var$OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + $2fa4452876a3c712$var$OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        const { radius: radius, extent: extent, reduce: reduce, minPoints: minPoints } = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;
        // loop through each point
        for(let i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + $2fa4452876a3c712$var$OFFSET_ZOOM] <= zoom) continue;
            data[i + $2fa4452876a3c712$var$OFFSET_ZOOM] = zoom;
            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);
            const numPointsOrigin = data[i + $2fa4452876a3c712$var$OFFSET_NUM];
            let numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (const neighborId of neighborIds){
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $2fa4452876a3c712$var$OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;
                let clusterProperties;
                let clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    const numPoints2 = data[k + $2fa4452876a3c712$var$OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;
                    data[k + $2fa4452876a3c712$var$OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }
                data[i + $2fa4452876a3c712$var$OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                for(let j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $2fa4452876a3c712$var$OFFSET_ZOOM] = zoom;
                    for(let j = 0; j < stride; j++)nextData.push(data[k + j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + $2fa4452876a3c712$var$OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + $2fa4452876a3c712$var$OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + $2fa4452876a3c712$var$OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}
function $2fa4452876a3c712$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: 'Feature',
        id: data[i + $2fa4452876a3c712$var$OFFSET_ID],
        properties: $2fa4452876a3c712$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: 'Point',
            coordinates: [
                $2fa4452876a3c712$var$xLng(data[i]),
                $2fa4452876a3c712$var$yLat(data[i + 1])
            ]
        }
    };
}
function $2fa4452876a3c712$var$getClusterProperties(data, i, clusterProps) {
    const count = data[i + $2fa4452876a3c712$var$OFFSET_NUM];
    const abbrev = count >= 10000 ? `${Math.round(count / 1000)}k` : count >= 1000 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + $2fa4452876a3c712$var$OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $2fa4452876a3c712$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $2fa4452876a3c712$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $2fa4452876a3c712$var$latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $2fa4452876a3c712$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $2fa4452876a3c712$var$yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

});
parcelRegister("eKHgz", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd6ec586e6f8595$export$2e2bcd8739ae039);
const $abd6ec586e6f8595$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ const $abd6ec586e6f8595$var$VERSION = 1; // serialized format version
const $abd6ec586e6f8595$var$HEADER_SIZE = 8;
class $abd6ec586e6f8595$export$2e2bcd8739ae039 {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error('Data must be an instance of ArrayBuffer.');
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error('Data does not appear to be in a KDBush format.');
        const version = versionAndType >> 4;
        if (version !== $abd6ec586e6f8595$var$VERSION) throw new Error(`Got v${version} data when expected v${$abd6ec586e6f8595$var$VERSION}.`);
        const ArrayType = $abd6ec586e6f8595$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error('Unrecognized array type.');
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);
        return new $abd6ec586e6f8595$export$2e2bcd8739ae039(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */ constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data){
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = $abd6ec586e6f8595$var$ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $abd6ec586e6f8595$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $abd6ec586e6f8595$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer($abd6ec586e6f8595$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $abd6ec586e6f8595$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $abd6ec586e6f8595$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($abd6ec586e6f8595$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
     * Perform indexing of the added points.
     */ finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        // kd-sort both arrays for efficient search
        $abd6ec586e6f8595$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ within(qx, qy, r) {
        if (!this._finished) throw new Error('Data not yet indexed - call index.finish().');
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        const r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++)if ($abd6ec586e6f8595$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if ($abd6ec586e6f8595$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $abd6ec586e6f8595$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $abd6ec586e6f8595$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $abd6ec586e6f8595$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $abd6ec586e6f8595$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $abd6ec586e6f8595$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $abd6ec586e6f8595$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        const t = coords[2 * k + axis];
        let i = left;
        let j = right;
        $abd6ec586e6f8595$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $abd6ec586e6f8595$var$swapItem(ids, coords, left, right);
        while(i < j){
            $abd6ec586e6f8595$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $abd6ec586e6f8595$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $abd6ec586e6f8595$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $abd6ec586e6f8595$var$swapItem(ids, coords, i, j) {
    $abd6ec586e6f8595$var$swap(ids, i, j);
    $abd6ec586e6f8595$var$swap(coords, 2 * i, 2 * j);
    $abd6ec586e6f8595$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $abd6ec586e6f8595$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $abd6ec586e6f8595$var$sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}

});



parcelRegister("gbPMS", function(module, exports) {

$parcel$export(module.exports, "getBackgroundStyle", () => getBackgroundStyle);
$parcel$export(module.exports, "getPreviewStyle", () => getPreviewStyle);
$parcel$export(module.exports, "Cropper", () => Cropper);
$parcel$export(module.exports, "CropperPreview", () => CropperPreview);
$parcel$export(module.exports, "mergeRefs", () => mergeRefs);

var $7WQrb = parcelRequire("7WQrb");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
function getDirectionNames(hDirection, vDirection) {
    var camelCase, snakeCase;
    if (hDirection && vDirection) {
        camelCase = "" + hDirection + vDirection[0].toUpperCase() + vDirection.slice(1);
        snakeCase = hDirection + "-" + vDirection;
    } else {
        camelCase = hDirection || vDirection;
        snakeCase = hDirection || vDirection;
    }
    return {
        camelCase: camelCase,
        snakeCase: snakeCase
    };
}
function isBlob(url) {
    return /^blob:/.test(url);
}
function isDataUrl(url) {
    return /^data:/.test(url);
}
function isLocal(url) {
    return isBlob(url) || isDataUrl(url);
}
function isCrossOriginURL(url) {
    if (isLocal(url)) return false;
    var pageLocation = window.location;
    var URL_HOST_PATTERN = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/;
    var urlMatch = URL_HOST_PATTERN.exec(url) || [];
    var urlparts = {
        protocol: urlMatch[1] || '',
        host: urlMatch[2] || '',
        port: urlMatch[3] || ''
    };
    var defaultPort = function(protocol) {
        if (protocol === 'http') return 80;
        else return 433;
    };
    var portOf = function(location) {
        return location.port || defaultPort(location.protocol || pageLocation.protocol);
    };
    return !(!urlparts.protocol && !urlparts.host && !urlparts.port || Boolean(urlparts.protocol && urlparts.protocol == pageLocation.protocol && urlparts.host && urlparts.host == pageLocation.host && urlparts.host && portOf(urlparts) == portOf(pageLocation)));
}
function isArray(value) {
    return Array.isArray(value);
}
function isFunction(value) {
    return typeof value === 'function';
}
function isUndefined(obj) {
    return obj === undefined;
}
var isObject = function(term) {
    return term !== null && typeof term === 'object';
};
// TODO: add the typing
function getOptions(options, defaultScheme, falseScheme) {
    if (falseScheme === void 0) falseScheme = {};
    var result = {};
    if (isObject(options)) {
        Object.keys(defaultScheme).forEach(function(key) {
            if (isUndefined(options[key])) result[key] = defaultScheme[key];
            else if (isObject(defaultScheme[key])) {
                if (isObject(options[key])) result[key] = getOptions(options[key], defaultScheme[key], falseScheme[key]);
                else result[key] = options[key] ? defaultScheme[key] : falseScheme[key];
            } else if (defaultScheme[key] === true || defaultScheme[key] === false) result[key] = Boolean(options[key]);
            else result[key] = options[key];
        });
        return result;
    } else {
        if (options) return defaultScheme;
        else return falseScheme;
    }
}
function parseNumber(number) {
    var parsedNumber = Number(number);
    if (Number.isNaN(parsedNumber)) return number;
    else return parsedNumber;
}
function isBoolean(value) {
    return value === true || value === false;
}
function isNumber(value) {
    return typeof value === 'number';
}
function isString(value) {
    return typeof value === 'string';
}
function isNaN(value) {
    return value !== value;
}
function isNumeric(value) {
    return isNumber(value) && !isNaN(value) || isString(value) && !Number.isNaN(parseFloat(value)) && isFinite(parseFloat(value));
}
function distance(firstPoint, secondPoint) {
    return Math.sqrt(Math.pow(firstPoint.left - secondPoint.left, 2) + Math.pow(firstPoint.top - secondPoint.top, 2));
}
function isRoughlyEqual(a, b, tolerance) {
    if (tolerance === void 0) tolerance = 1e-3;
    return Math.abs(b - a) < tolerance;
}
function isGreater(a, b, tolerance) {
    return isRoughlyEqual(a, b, tolerance) ? false : a > b;
}
function isLower(a, b, tolerance) {
    return isRoughlyEqual(a, b, tolerance) ? false : a < b;
}
function isArrayBufferLike(value) {
    return value instanceof ArrayBuffer;
}
function getCloserAngle(reference, angle) {
    var turnsCount = Math.floor(reference / 360);
    var firstCandidate = turnsCount * 360 + angle;
    var secondCandidate = (turnsCount + 1) * 360 + angle;
    if (Math.abs(firstCandidate - reference) < Math.abs(secondCandidate - reference)) return firstCandidate;
    else return secondCandidate;
}
function sign(value) {
    var number = +value;
    if (number === 0 || isNaN(number)) return number;
    return number > 0 ? 1 : -1;
}
function promiseTimeout(timeout) {
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, timeout);
    });
}
// Not performant, small function to reduce the code amount
function deepClone(obj) {
    if (!isObject(obj)) return obj;
    var result = {};
    if (Array.isArray(obj)) result = obj.map(function(item) {
        return deepClone(item);
    });
    else Object.keys(obj).forEach(function(key) {
        return result[key] = deepClone(obj[key]);
    });
    return result;
}
function deepCompare(a, b, tolerance) {
    if (tolerance === void 0) tolerance = 1e-3;
    if (isNumber(a) && isNumber(b) && isRoughlyEqual(a, b, tolerance)) return true;
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length_1, i = void 0;
        if (Array.isArray(a)) {
            length_1 = a.length;
            if (length_1 != b.length) return false;
            for(i = length_1; i-- !== 0;)if (!deepCompare(a[i], b[i], tolerance)) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        var keys = Object.keys(a);
        length_1 = keys.length;
        if (length_1 !== Object.keys(b).length) return false;
        for(i = length_1; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length_1; i-- !== 0;){
            var key = keys[i];
            if (!deepCompare(a[key], b[key], tolerance)) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function isWheelEvent(event) {
    return 'deltaX' in event;
}
function isTouchEvent(event) {
    return 'touches' in event;
}
function isMouseEvent(event) {
    return 'buttons' in event;
}
function emptyCoordinates() {
    return {
        left: 0,
        top: 0,
        width: 0,
        height: 0
    };
}
function isCardinalDirection(value) {
    return value === 'west' || value === 'south' || value === 'north' || value === 'east';
}
function isOrdinalDirection(value) {
    return isCardinalDirection(value) || value === 'westNorth' || value === 'westSouth' || value === 'eastNorth' || value === 'eastSouth';
}
function debounce(callback, delay) {
    var timestamp;
    var timeout;
    function later() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var last = Date.now() - timestamp;
        var delayValue = isFunction(delay) ? delay() : delay || 0;
        if (last < delayValue && last >= 0) timeout = setTimeout(function() {
            return later.apply(void 0, args);
        }, delayValue - last);
        else callback.apply(void 0, args);
    }
    function result() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        timestamp = Date.now();
        timeout = setTimeout(function() {
            return later.apply(void 0, args);
        }, isFunction(delay) ? delay() : delay || 0);
    }
    result.clear = function() {
        clearTimeout(timeout);
    };
    return result;
}
var ALL_DIRECTIONS = [
    'left',
    'right',
    'top',
    'bottom'
];
var HORIZONTAL_DIRECTIONS$1 = [
    'left',
    'right'
];
var VERTICAL_DIRECTIONS$1 = [
    'top',
    'bottom'
];
function diff(firstObject, secondObject) {
    return {
        left: firstObject.left - secondObject.left,
        top: firstObject.top - secondObject.top
    };
}
function getCenter(object) {
    return {
        left: object.left + object.width / 2,
        top: object.top + object.height / 2
    };
}
function getOppositeSide(side) {
    return ({
        left: 'right',
        top: 'bottom',
        right: 'left',
        bottom: 'top'
    })[side];
}
function sizeDistance(a, b) {
    return Math.pow(a.width - b.width, 2) + Math.pow(a.height - b.height, 2);
}
function applyDirections(coordinates, directions) {
    return {
        left: coordinates.left - directions.left,
        top: coordinates.top - directions.top,
        width: coordinates.width + directions.left + directions.right,
        height: coordinates.height + directions.top + directions.bottom
    };
}
function inverseMove(directions) {
    return {
        left: -directions.left,
        top: -directions.top
    };
}
function applyMove(object, move) {
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, object), {
        left: object.left + move.left,
        top: object.top + move.top
    });
}
function coordinatesToPositionRestrictions(coordinates) {
    return {
        left: coordinates.left,
        top: coordinates.top,
        right: coordinates.left + coordinates.width,
        bottom: coordinates.top + coordinates.height
    };
}
function applyScale(object, factor, center, progress) {
    if (factor !== 1) {
        if ('left' in object || 'top' in object) {
            if (center) {
                var currentCenter = getCenter(object);
                return {
                    width: object.width * factor,
                    height: object.height * factor,
                    left: object.left + object.width * (1 - factor) / 2 + (center.left - currentCenter.left) * (progress || 1 - factor),
                    top: object.top + object.height * (1 - factor) / 2 + (center.top - currentCenter.top) * (progress || 1 - factor)
                };
            } else return {
                width: object.width * factor,
                height: object.height * factor,
                left: object.left + object.width * (1 - factor) / 2,
                top: object.top + object.height * (1 - factor) / 2
            };
        } else return {
            width: object.width * factor,
            height: object.height * factor
        };
    } else return object;
}
function ratio(object) {
    return object.width / object.height;
}
function maxScale(size, restrictions) {
    return Math.min(restrictions.maxWidth ? restrictions.maxWidth / size.width : Infinity, restrictions.maxHeight ? restrictions.maxHeight / size.height : Infinity);
}
function minScale(size, restrictions) {
    return Math.max(restrictions.minWidth ? restrictions.minWidth / size.width : 0, restrictions.minHeight ? restrictions.minHeight / size.height : 0);
}
function getBrokenRatio(currentAspectRatio, aspectRatio) {
    var ratioBroken;
    if (aspectRatio.minimum && isLower(currentAspectRatio, aspectRatio.minimum)) ratioBroken = aspectRatio.minimum;
    else if (aspectRatio.maximum && isGreater(currentAspectRatio, aspectRatio.maximum)) ratioBroken = aspectRatio.maximum;
    return ratioBroken;
}
function fitToSizeRestrictions(coordinates, sizeRestrictions) {
    var aspectRatio = ratio(coordinates);
    var scale = 1;
    if (sizeRestrictions.minWidth > 0 && sizeRestrictions.minHeight > 0) {
        if (aspectRatio > sizeRestrictions.minWidth / sizeRestrictions.minHeight) {
            if (coordinates.height < sizeRestrictions.minHeight) scale = sizeRestrictions.minHeight / coordinates.height;
        } else if (coordinates.width < sizeRestrictions.minWidth) scale = sizeRestrictions.minWidth / coordinates.width;
    } else if (sizeRestrictions.minWidth > 0) {
        if (coordinates.width < sizeRestrictions.minWidth) scale = sizeRestrictions.minWidth / coordinates.width;
    } else if (sizeRestrictions.minHeight > 0) {
        if (coordinates.height < sizeRestrictions.minHeight) scale = sizeRestrictions.minHeight / coordinates.height;
    }
    if (sizeRestrictions.maxWidth < Infinity && sizeRestrictions.maxHeight < Infinity) {
        if (aspectRatio > sizeRestrictions.maxWidth / sizeRestrictions.maxHeight) {
            if (coordinates.width > sizeRestrictions.maxWidth) scale = sizeRestrictions.maxWidth / coordinates.width;
        } else if (coordinates.height > sizeRestrictions.maxHeight) scale = sizeRestrictions.maxHeight / coordinates.height;
    } else if (sizeRestrictions.maxWidth < Infinity) {
        if (coordinates.width > sizeRestrictions.maxWidth) scale = sizeRestrictions.maxWidth / coordinates.width;
    } else if (sizeRestrictions.maxHeight < Infinity) {
        if (coordinates.height > sizeRestrictions.maxHeight) scale = sizeRestrictions.maxHeight / coordinates.height;
    }
    return scale;
}
function getIntersections(object, positionRestrictions) {
    var intersections = {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
    };
    ALL_DIRECTIONS.forEach(function(direction) {
        var areaLimit = positionRestrictions[direction];
        var objectLimit = coordinatesToPositionRestrictions(object)[direction];
        if (areaLimit !== undefined && objectLimit !== undefined) {
            if (direction === 'left' || direction === 'top') intersections[direction] = Math.max(0, areaLimit - objectLimit);
            else intersections[direction] = Math.max(0, objectLimit - areaLimit);
        } else intersections[direction] = 0;
    });
    return intersections;
}
function resizeToSizeRestrictions(coordinates, sizeRestrictions) {
    return applyScale(coordinates, fitToSizeRestrictions(coordinates, sizeRestrictions));
}
function rotateSize(size, angle) {
    var radians = angle * Math.PI / 180;
    return {
        width: Math.abs(size.width * Math.cos(radians)) + Math.abs(size.height * Math.sin(radians)),
        height: Math.abs(size.width * Math.sin(radians)) + Math.abs(size.height * Math.cos(radians))
    };
}
function rotatePoint(point, angle, anchor) {
    var radians = angle * Math.PI / 180;
    if (anchor) return {
        left: (point.left - anchor.left) * Math.cos(radians) - (point.top - anchor.top) * Math.sin(radians) + anchor.left,
        top: (point.left - anchor.left) * Math.sin(radians) + (point.top - anchor.top) * Math.cos(radians) + anchor.top
    };
    else return {
        left: point.left * Math.cos(radians) - point.top * Math.sin(radians),
        top: point.left * Math.sin(radians) + point.top * Math.cos(radians)
    };
}
function positionToSizeRestrictions(positionRestrictions) {
    return {
        minWidth: 0,
        minHeight: 0,
        maxWidth: positionRestrictions.right !== undefined && positionRestrictions.left !== undefined ? positionRestrictions.right - positionRestrictions.left : Infinity,
        maxHeight: positionRestrictions.bottom !== undefined && positionRestrictions.top !== undefined ? positionRestrictions.bottom - positionRestrictions.top : Infinity
    };
}
function mergePositionRestrictions(a, b) {
    var restrictions = {};
    ALL_DIRECTIONS.forEach(function(direction) {
        var firstDirection = a[direction];
        var secondDirection = b[direction];
        if (firstDirection !== undefined && secondDirection !== undefined) {
            if (direction === 'left' || direction === 'top') restrictions[direction] = Math.max(firstDirection, secondDirection);
            else restrictions[direction] = Math.min(firstDirection, secondDirection);
        } else if (secondDirection !== undefined) restrictions[direction] = secondDirection;
        else if (firstDirection !== undefined) restrictions[direction] = firstDirection;
    });
    return restrictions;
}
function fitToPositionRestrictions(coordinates, positionRestrictions) {
    var directions = {
        left: 0,
        top: 0
    };
    var intersection = getIntersections(coordinates, positionRestrictions);
    if (intersection.left && intersection.left > 0) directions.left = intersection.left;
    else if (intersection.right && intersection.right > 0) directions.left = -intersection.right;
    if (intersection.top && intersection.top > 0) directions.top = intersection.top;
    else if (intersection.bottom && intersection.bottom > 0) directions.top = -intersection.bottom;
    return directions;
}
function moveToPositionRestrictions(coordinates, positionRestrictions) {
    return applyMove(coordinates, fitToPositionRestrictions(coordinates, positionRestrictions));
}
function aspectRatioIntersection(main, subset) {
    if (!subset) return main;
    else if (!main) return subset;
    else return {
        minimum: Math.min(main.maximum, Math.max(main.minimum, subset.minimum)),
        maximum: Math.max(main.minimum, Math.min(main.maximum, subset.maximum))
    };
}
function createAspectRatio(aspectRatio) {
    if (aspectRatio === void 0) aspectRatio = {};
    if (isNumber(aspectRatio)) return {
        minimum: aspectRatio,
        maximum: aspectRatio
    };
    else return {
        minimum: isNumeric(aspectRatio.minimum) ? aspectRatio.minimum : 0,
        maximum: isNumeric(aspectRatio.maximum) ? aspectRatio.maximum : Infinity
    };
}
function getTransitionStyle(transitions) {
    return transitions ? transitions.timingFunction + " " + (transitions.active ? transitions.duration : 0) + "ms" : 'none';
}
function isConsistentSize(size, restrictions) {
    return (isUndefined(restrictions.maxWidth) || !isGreater(size.width, restrictions.maxWidth)) && (isUndefined(restrictions.maxHeight) || !isGreater(size.height, restrictions.maxHeight)) && (isUndefined(restrictions.minHeight) || !isLower(size.height, restrictions.minHeight)) && (isUndefined(restrictions.minWidth) || !isLower(size.width, restrictions.minWidth));
}
function isConsistentPosition(coordinates, restrictions) {
    return (isUndefined(restrictions.left) || !isLower(coordinates.left, restrictions.left)) && (isUndefined(restrictions.top) || !isLower(coordinates.top, restrictions.top)) && (isUndefined(restrictions.right) || !isGreater(coordinates.left + coordinates.width, restrictions.right)) && (isUndefined(restrictions.bottom) || !isGreater(coordinates.top + coordinates.height, restrictions.bottom));
}
function getCloserSize(candidates, reference, sizeRestrictions, aspectRatio) {
    var traverse = function(ignoreMinimum) {
        return candidates.reduce(function(minimum, size) {
            var _a = isFunction(sizeRestrictions) ? sizeRestrictions(size) : sizeRestrictions, maxHeight = _a.maxHeight, maxWidth = _a.maxWidth, minWidth = _a.minWidth, minHeight = _a.minHeight;
            var preparedAspectRatio = createAspectRatio(isFunction(aspectRatio) ? aspectRatio(size) : aspectRatio);
            var preparedSizeRestrictions = ignoreMinimum ? {
                maxWidth: maxWidth,
                maxHeight: maxHeight
            } : {
                maxWidth: maxWidth,
                maxHeight: maxHeight,
                minWidth: minWidth,
                minHeight: minHeight
            };
            if (isConsistentSize(size, preparedSizeRestrictions) && !getBrokenRatio(ratio(size), preparedAspectRatio) && size.width && size.height) return !minimum || isLower(sizeDistance(size, reference), sizeDistance(minimum, reference)) ? size : minimum;
            else return minimum;
        }, null);
    };
    return traverse() || traverse(true);
}
function isInitializedState(state) {
    return Boolean(state && state.visibleArea && state.coordinates);
}
function getAreaSizeRestrictions(state, settings) {
    return calculateAreaSizeRestrictions(state, settings);
}
function getAreaPositionRestrictions(state, settings) {
    return isFunction(settings.areaPositionRestrictions) ? settings.areaPositionRestrictions(state, settings) : settings.areaPositionRestrictions;
}
function getSizeRestrictions(state, settings) {
    return calculateSizeRestrictions(state, settings);
}
function getPositionRestrictions(state, settings) {
    return isFunction(settings.positionRestrictions) ? settings.positionRestrictions(state, settings) : settings.positionRestrictions;
}
function getCoefficient(state) {
    return state.visibleArea ? state.visibleArea.width / state.boundary.width : 0;
}
function getStencilCoordinates(state) {
    if (isInitializedState(state)) {
        var _a = state.coordinates, width = _a.width, height = _a.height, left = _a.left, top_1 = _a.top;
        var coefficient = getCoefficient(state);
        return {
            width: width / coefficient,
            height: height / coefficient,
            left: (left - state.visibleArea.left) / coefficient,
            top: (top_1 - state.visibleArea.top) / coefficient
        };
    } else return emptyCoordinates();
}
function getAspectRatio(state, settings) {
    return createAspectRatio(isFunction(settings.aspectRatio) ? settings.aspectRatio(state, settings) : settings.aspectRatio);
}
function getDefaultCoordinates(state, settings) {
    return isFunction(settings.defaultCoordinates) ? settings.defaultCoordinates(state, settings) : settings.defaultCoordinates;
}
function getDefaultVisibleArea(state, settings) {
    return isFunction(settings.defaultVisibleArea) ? settings.defaultVisibleArea(state, settings) : settings.defaultVisibleArea;
}
function getDefaultTransforms(state, settings) {
    var transforms = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, state.transforms), {
        flip: (0, $7WQrb.__assign)({}, state.transforms.flip)
    });
    if (settings.defaultTransforms) {
        var defaultTransforms = isFunction(settings.defaultTransforms) ? settings.defaultTransforms(state, settings) : settings.defaultTransforms;
        if (isNumber(defaultTransforms.rotate)) transforms.rotate = defaultTransforms.rotate;
        if (defaultTransforms.flip) {
            if (isBoolean(defaultTransforms.flip.horizontal)) transforms.flip.horizontal = defaultTransforms.flip.horizontal;
            if (isBoolean(defaultTransforms.flip.vertical)) transforms.flip.vertical = defaultTransforms.flip.vertical;
        }
    }
    return transforms;
}
function getTransformedImageSize(state) {
    if (state.imageSize && state.imageSize.width && state.imageSize.height) return rotateSize(state.imageSize, state.transforms.rotate);
    else return {
        width: 0,
        height: 0
    };
}
function getMinimumSize(state) {
    // The magic number is the approximation of the handler size
    // Temporary solution that should be improved in the future
    return state.coordinates ? Math.min(state.coordinates.width, state.coordinates.height, 20 * getCoefficient(state)) : 1;
}
function getRoundedCoordinates(state, settings) {
    if (isInitializedState(state)) {
        var sizeRestrictions = getSizeRestrictions(state, settings);
        var positionRestrictions = getPositionRestrictions(state, settings);
        var roundCoordinates = {
            width: Math.round(state.coordinates.width),
            height: Math.round(state.coordinates.height),
            left: Math.round(state.coordinates.left),
            top: Math.round(state.coordinates.top)
        };
        if (roundCoordinates.width > sizeRestrictions.maxWidth) roundCoordinates.width = Math.floor(state.coordinates.width);
        else if (roundCoordinates.width < sizeRestrictions.minWidth) roundCoordinates.width = Math.ceil(state.coordinates.width);
        if (roundCoordinates.height > sizeRestrictions.maxHeight) roundCoordinates.height = Math.floor(state.coordinates.height);
        else if (roundCoordinates.height < sizeRestrictions.minHeight) roundCoordinates.height = Math.ceil(state.coordinates.height);
        return moveToPositionRestrictions(roundCoordinates, positionRestrictions);
    } else return null;
}
function isConsistentState(state, settings) {
    if (isInitializedState(state)) return !getBrokenRatio(ratio(state.coordinates), getAspectRatio(state, settings)) && isConsistentSize(state.visibleArea, getAreaSizeRestrictions(state, settings)) && isConsistentSize(state.coordinates, getSizeRestrictions(state, settings)) && isConsistentPosition(state.visibleArea, getAreaPositionRestrictions(state, settings)) && isConsistentPosition(state.coordinates, getPositionRestrictions(state, settings));
    else return true;
}
function reconcileSizeRestrictions(sizeRestrictions) {
    var restrictions = (0, $7WQrb.__assign)({}, sizeRestrictions);
    // Process the border cases when minimum height / width larger than maximum height / width
    if (restrictions.minWidth > restrictions.maxWidth) restrictions.minWidth = restrictions.maxWidth;
    if (restrictions.minHeight > restrictions.maxHeight) restrictions.minHeight = restrictions.maxHeight;
    return restrictions;
}
function mergeSizeRestrictions(a, b) {
    var first = a;
    var second = (0, $7WQrb.__assign)({
        minWidth: 0,
        minHeight: 0,
        maxWidth: Infinity,
        maxHeight: Infinity
    }, b);
    return reconcileSizeRestrictions({
        maxHeight: Math.min(first.maxHeight, second.maxHeight),
        minHeight: Math.max(first.minHeight, second.minHeight),
        maxWidth: Math.min(first.maxWidth, second.maxWidth),
        minWidth: Math.max(first.minWidth, second.minWidth)
    });
}
function calculateSizeRestrictions(state, settings) {
    var sizeRestrictions = isFunction(settings.sizeRestrictions) ? settings.sizeRestrictions(state, settings) : settings.sizeRestrictions;
    var positionRestrictions = getPositionRestrictions(state, settings);
    // User can forget to set some of restrictions, so we should initialize them by default values
    var restrictions = {
        minWidth: isNumeric(sizeRestrictions.minWidth) ? parseNumber(sizeRestrictions.minWidth) : 0,
        minHeight: isNumeric(sizeRestrictions.minHeight) ? parseNumber(sizeRestrictions.minHeight) : 0,
        maxWidth: isNumeric(sizeRestrictions.maxWidth) ? parseNumber(sizeRestrictions.maxWidth) : Infinity,
        maxHeight: isNumeric(sizeRestrictions.maxHeight) ? parseNumber(sizeRestrictions.maxHeight) : Infinity
    };
    // The situation, when stencil can't be positioned in cropper due to positionRestrictions should be avoided
    if (positionRestrictions.left !== undefined && positionRestrictions.right !== undefined) restrictions.maxWidth = Math.min(restrictions.maxWidth, positionRestrictions.right - positionRestrictions.left);
    if (positionRestrictions.bottom !== undefined && positionRestrictions.top !== undefined) restrictions.maxHeight = Math.min(restrictions.maxHeight, positionRestrictions.bottom - positionRestrictions.top);
    return reconcileSizeRestrictions(restrictions);
}
function calculateAreaSizeRestrictions(state, settings) {
    var sizeRestrictions = isFunction(settings.areaSizeRestrictions) ? settings.areaSizeRestrictions(state, settings) : settings.areaSizeRestrictions;
    if (sizeRestrictions.maxWidth < Infinity && sizeRestrictions.maxHeight < Infinity) {
        if (ratio(state.boundary) > sizeRestrictions.maxWidth / sizeRestrictions.maxHeight) sizeRestrictions.maxHeight = sizeRestrictions.maxWidth / ratio(state.boundary);
        else sizeRestrictions.maxWidth = sizeRestrictions.maxHeight * ratio(state.boundary);
    }
    return reconcileSizeRestrictions(sizeRestrictions);
}
function copyState(state) {
    return deepClone(state);
}
var ImageRestriction;
(function(ImageRestriction) {
    ImageRestriction["fillArea"] = "fillArea";
    ImageRestriction["fitArea"] = "fitArea";
    ImageRestriction["stencil"] = "stencil";
    ImageRestriction["none"] = "none";
})(ImageRestriction || (ImageRestriction = {}));
var Priority;
(function(Priority) {
    Priority["coordinates"] = "coordinates";
    Priority["visibleArea"] = "visibleArea";
})(Priority || (Priority = {}));
// Limitations:
// 1. Assume that maximum width and height always larger than minimum width and height
// 2. Assume that aspectRatio.minimum < aspectRatio.maximum
// If you break this limitations function could return null!
function approximateSize(params) {
    var width = params.width, height = params.height;
    var sizeRestrictions = params.sizeRestrictions || {
        minWidth: 0,
        minHeight: 0,
        maxWidth: Infinity,
        maxHeight: Infinity
    };
    var aspectRatio = createAspectRatio(params.aspectRatio);
    var coordinates = {
        width: Math.max(sizeRestrictions.minWidth, Math.min(sizeRestrictions.maxWidth, width)),
        height: Math.max(sizeRestrictions.minHeight, Math.min(sizeRestrictions.maxHeight, height))
    };
    var candidates = [
        coordinates
    ];
    if (aspectRatio) [
        aspectRatio.minimum,
        aspectRatio.maximum
    ].forEach(function(ratio) {
        if (ratio) candidates.push({
            width: coordinates.width,
            height: coordinates.width / ratio
        }, {
            width: coordinates.height * ratio,
            height: coordinates.height
        });
    });
    // Resize the candidates as much as possible to prevent breaking minimum size
    candidates = candidates.map(function(candidate) {
        return resizeToSizeRestrictions(candidate, sizeRestrictions);
    });
    // TODO: fix the type of return value
    return getCloserSize(candidates, {
        width: width,
        height: height
    }, sizeRestrictions, aspectRatio);
}
function fitVisibleArea(state, settings) {
    var result = copyState(state);
    if (state.visibleArea) {
        var areaSizeRestrictions = getAreaSizeRestrictions(state, settings);
        // Fit the visible area to its size restrictions and boundary aspect ratio:
        result.visibleArea = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, state.visibleArea), approximateSize({
            width: state.visibleArea.width,
            height: state.visibleArea.height,
            aspectRatio: {
                minimum: ratio(result.boundary),
                maximum: ratio(result.boundary)
            },
            sizeRestrictions: areaSizeRestrictions
        }));
        // Return the visible area to previous center
        result.visibleArea = applyMove(result.visibleArea, diff(getCenter(state.visibleArea), getCenter(result.visibleArea)));
        // Fit the visible area to positions restrictions
        result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
    }
    return result;
}
function moveCoordinatesAlgorithm(coordinates, directions, positionRestrictions) {
    var movedCoordinates = applyMove(coordinates, directions);
    return positionRestrictions ? moveToPositionRestrictions(movedCoordinates, positionRestrictions) : movedCoordinates;
}
var SetCoordinatesMode;
(function(SetCoordinatesMode) {
    SetCoordinatesMode["limit"] = "limit";
    SetCoordinatesMode["zoom"] = "zoom";
    SetCoordinatesMode["unsafe"] = "unsafe";
})(SetCoordinatesMode || (SetCoordinatesMode = {}));
function setCoordinates(state, settings, transform, // If you set mode to `false`, the coordinates can leave the visible area
mode) {
    if (mode === void 0) mode = true;
    var currentMode = mode === false ? SetCoordinatesMode.unsafe : mode === true ? SetCoordinatesMode.zoom : mode;
    var aspectRatio = getAspectRatio(state, settings);
    var sizeRestrictions = getSizeRestrictions(state, settings);
    if (state.visibleArea && currentMode === SetCoordinatesMode.limit) sizeRestrictions = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, sizeRestrictions), {
        minWidth: Math.min(state.visibleArea.width, sizeRestrictions.minWidth),
        minHeight: Math.min(state.visibleArea.height, sizeRestrictions.minHeight),
        maxWidth: Math.min(state.visibleArea.width, sizeRestrictions.maxWidth),
        maxHeight: Math.min(state.visibleArea.height, sizeRestrictions.maxHeight)
    });
    var positionRestrictions = getPositionRestrictions(state, settings);
    if (state.visibleArea && currentMode === SetCoordinatesMode.limit) positionRestrictions = mergePositionRestrictions(positionRestrictions, coordinatesToPositionRestrictions(state.visibleArea));
    var move = function(prevCoordinates, newCoordinates) {
        return moveCoordinatesAlgorithm(prevCoordinates, {
            left: newCoordinates.left - (prevCoordinates.left || 0),
            top: newCoordinates.top - (prevCoordinates.top || 0)
        }, positionRestrictions);
    };
    var resize = function(prevCoordinates, newCoordinates) {
        var coordinates = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, prevCoordinates), approximateSize({
            width: newCoordinates.width,
            height: newCoordinates.height,
            sizeRestrictions: sizeRestrictions,
            aspectRatio: aspectRatio
        })), {
            left: 0,
            top: 0
        });
        return move(coordinates, {
            left: prevCoordinates.left || 0,
            top: prevCoordinates.top || 0
        });
    };
    var coordinates = state.coordinates ? (0, $7WQrb.__assign)({}, state.coordinates) : emptyCoordinates();
    var transforms = Array.isArray(transform) ? transform : [
        transform
    ];
    transforms.forEach(function(transform) {
        var changes;
        if (typeof transform === 'function') changes = transform((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, state), {
            coordinates: coordinates
        }), settings);
        else changes = transform;
        if (changes) {
            if (!isUndefined(changes.width) || !isUndefined(changes.height)) coordinates = resize(coordinates, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, coordinates), changes));
            if (!isUndefined(changes.left) || !isUndefined(changes.top)) coordinates = move(coordinates, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, coordinates), changes));
        }
    });
    var result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, copyState(state)), {
        coordinates: coordinates
    });
    if (result.visibleArea && currentMode === SetCoordinatesMode.zoom) {
        var widthIntersections = Math.max(0, result.coordinates.width - result.visibleArea.width);
        var heightIntersections = Math.max(0, result.coordinates.height - result.visibleArea.height);
        var areaSizeRestrictions = getAreaSizeRestrictions(state, settings);
        var scale = widthIntersections > heightIntersections ? result.coordinates.width / result.visibleArea.width : result.coordinates.height / result.visibleArea.height;
        if (scale > 1) result.visibleArea = applyScale(result.visibleArea, Math.min(scale, maxScale(result.visibleArea, areaSizeRestrictions)));
        result.visibleArea = applyMove(result.visibleArea, inverseMove(fitToPositionRestrictions(result.coordinates, coordinatesToPositionRestrictions(result.visibleArea))));
        return fitVisibleArea(result, settings);
    } else return result;
}
function fitCoordinates(state, settings) {
    if (state.coordinates) {
        var result = copyState(state);
        var aspectRatio = getAspectRatio(state, settings);
        var sizeRestrictions = getSizeRestrictions(state, settings);
        // Fit the size of coordinates to existing size restrictions and visible area
        result.coordinates = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, state.coordinates), approximateSize({
            width: state.coordinates.width,
            height: state.coordinates.height,
            aspectRatio: aspectRatio,
            sizeRestrictions: state.visibleArea ? {
                maxWidth: Math.min(state.visibleArea.width, sizeRestrictions.maxWidth),
                maxHeight: Math.min(state.visibleArea.height, sizeRestrictions.maxHeight),
                minHeight: Math.min(state.visibleArea.height, sizeRestrictions.minHeight),
                minWidth: Math.min(state.visibleArea.width, sizeRestrictions.minWidth)
            } : sizeRestrictions
        }));
        // Return the coordinates to the previous center
        result.coordinates = applyMove(result.coordinates, diff(getCenter(state.coordinates), getCenter(result.coordinates)));
        // Fit the coordinates to position restrictions and visible area
        result.coordinates = moveToPositionRestrictions(result.coordinates, state.visibleArea ? mergePositionRestrictions(coordinatesToPositionRestrictions(state.visibleArea), getPositionRestrictions(result, settings)) : getPositionRestrictions(result, settings));
        return result;
    }
    return state;
}
function setVisibleArea(state, settings, visibleArea, // If you set safe to `false`, the coordinates will be able to leave the visible area
safe) {
    if (safe === void 0) safe = true;
    var result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, copyState(state)), {
        visibleArea: visibleArea
    });
    // There is no possibility to break visible area limitations.
    result = fitVisibleArea(result, settings);
    if (safe) result = fitCoordinates(result, settings);
    return result;
}
function createState(options, settings) {
    var _a, _b, _c, _d, _e;
    var boundary = options.boundary, image = options.image;
    var state = {
        boundary: {
            width: boundary.width,
            height: boundary.height
        },
        imageSize: {
            width: image.width,
            height: image.height
        },
        transforms: {
            rotate: ((_a = image.transforms) === null || _a === void 0 ? void 0 : _a.rotate) || 0,
            flip: {
                horizontal: ((_c = (_b = image.transforms) === null || _b === void 0 ? void 0 : _b.flip) === null || _c === void 0 ? void 0 : _c.horizontal) || false,
                vertical: ((_e = (_d = image.transforms) === null || _d === void 0 ? void 0 : _d.flip) === null || _e === void 0 ? void 0 : _e.vertical) || false
            }
        },
        visibleArea: null,
        coordinates: null
    };
    if (settings.defaultTransforms) state.transforms = getDefaultTransforms(state, settings);
    if (settings.priority === Priority.visibleArea) {
        state = setVisibleArea(state, settings, getDefaultVisibleArea(state, settings), false);
        state = setCoordinates(state, settings, getDefaultCoordinates(state, settings), SetCoordinatesMode.limit);
    } else {
        state = setCoordinates(state, settings, getDefaultCoordinates(state, settings), SetCoordinatesMode.unsafe);
        state = setVisibleArea(state, settings, getDefaultVisibleArea(state, settings), true);
    }
    return state;
}
function moveCoordinates(state, settings, directions) {
    if (isInitializedState(state)) {
        var result = copyState(state);
        result.coordinates = applyMove(result.coordinates, directions);
        result.coordinates = moveToPositionRestrictions(result.coordinates, mergePositionRestrictions(coordinatesToPositionRestrictions(result.visibleArea), getPositionRestrictions(result, settings)));
        return result;
    }
    return state;
}
function fitDirections(_a) {
    var coordinates = _a.coordinates, directions = _a.directions, positionRestrictions = _a.positionRestrictions, sizeRestrictions = _a.sizeRestrictions, preserveRatio = _a.preserveRatio, allowedDirections = _a.allowedDirections, _b = _a.compensate, compensate = _b === void 0 ? true : _b;
    var fittedDirections = (0, $7WQrb.__assign)({}, directions);
    var currentWidth = applyDirections(coordinates, fittedDirections).width;
    var currentHeight = applyDirections(coordinates, fittedDirections).height;
    // Prevent strange resizes when the width or height of stencil becomes smaller than 0
    if (currentWidth < 0) {
        if (fittedDirections.left < 0 && fittedDirections.right < 0) {
            fittedDirections.left = -(coordinates.width - sizeRestrictions.minWidth) / (fittedDirections.left / fittedDirections.right);
            fittedDirections.right = -(coordinates.width - sizeRestrictions.minWidth) / (fittedDirections.right / fittedDirections.left);
        } else if (fittedDirections.left < 0) fittedDirections.left = -(coordinates.width - sizeRestrictions.minWidth);
        else if (fittedDirections.right < 0) fittedDirections.right = -(coordinates.width - sizeRestrictions.minWidth);
    }
    if (currentHeight < 0) {
        if (fittedDirections.top < 0 && fittedDirections.bottom < 0) {
            fittedDirections.top = -(coordinates.height - sizeRestrictions.minHeight) / (fittedDirections.top / fittedDirections.bottom);
            fittedDirections.bottom = -(coordinates.height - sizeRestrictions.minHeight) / (fittedDirections.bottom / fittedDirections.top);
        } else if (fittedDirections.top < 0) fittedDirections.top = -(coordinates.height - sizeRestrictions.minHeight);
        else if (fittedDirections.bottom < 0) fittedDirections.bottom = -(coordinates.height - sizeRestrictions.minHeight);
    }
    // Prevent breaking limits
    var breaks = getIntersections(applyDirections(coordinates, fittedDirections), positionRestrictions);
    var canBeCompensated = ALL_DIRECTIONS.every(function(direction) {
        return !isGreater(breaks[getOppositeSide(direction)], 0) || allowedDirections[direction];
    });
    if (compensate && canBeCompensated) {
        if (breaks.left && breaks.left > 0 && breaks.right === 0) {
            fittedDirections.right += breaks.left;
            fittedDirections.left -= breaks.left;
        } else if (breaks.right && breaks.right > 0 && breaks.left === 0) {
            fittedDirections.left += breaks.right;
            fittedDirections.right -= breaks.right;
        }
        if (breaks.top && breaks.top > 0 && breaks.bottom === 0) {
            fittedDirections.bottom += breaks.top;
            fittedDirections.top -= breaks.top;
        } else if (breaks.bottom && breaks.bottom > 0 && breaks.top === 0) {
            fittedDirections.top += breaks.bottom;
            fittedDirections.bottom -= breaks.bottom;
        }
        breaks = getIntersections(applyDirections(coordinates, fittedDirections), positionRestrictions);
    }
    var maxResize = {
        width: Infinity,
        height: Infinity,
        left: Infinity,
        right: Infinity,
        top: Infinity,
        bottom: Infinity
    };
    ALL_DIRECTIONS.forEach(function(direction) {
        var intersection = breaks[direction];
        if (intersection && fittedDirections[direction]) maxResize[direction] = Math.max(0, 1 - intersection / fittedDirections[direction]);
    });
    if (preserveRatio) {
        var multiplier_1 = Math.min.apply(Math, ALL_DIRECTIONS.map(function(direction) {
            return maxResize[direction];
        }));
        if (multiplier_1 !== Infinity) ALL_DIRECTIONS.forEach(function(direction) {
            fittedDirections[direction] *= multiplier_1;
        });
    } else ALL_DIRECTIONS.forEach(function(direction) {
        if (maxResize[direction] !== Infinity) fittedDirections[direction] *= maxResize[direction];
    });
    currentWidth = applyDirections(coordinates, fittedDirections).width;
    currentHeight = applyDirections(coordinates, fittedDirections).height;
    if (fittedDirections.right + fittedDirections.left) {
        if (currentWidth > sizeRestrictions.maxWidth) maxResize.width = (sizeRestrictions.maxWidth - coordinates.width) / (fittedDirections.right + fittedDirections.left);
        else if (currentWidth < sizeRestrictions.minWidth) maxResize.width = (sizeRestrictions.minWidth - coordinates.width) / (fittedDirections.right + fittedDirections.left);
    }
    if (fittedDirections.bottom + fittedDirections.top) {
        if (currentHeight > sizeRestrictions.maxHeight) maxResize.height = (sizeRestrictions.maxHeight - coordinates.height) / (fittedDirections.bottom + fittedDirections.top);
        else if (currentHeight < sizeRestrictions.minHeight) maxResize.height = (sizeRestrictions.minHeight - coordinates.height) / (fittedDirections.bottom + fittedDirections.top);
    }
    if (preserveRatio) {
        var multiplier_2 = Math.min(maxResize.width, maxResize.height);
        if (multiplier_2 !== Infinity) ALL_DIRECTIONS.forEach(function(direction) {
            fittedDirections[direction] *= multiplier_2;
        });
    } else {
        if (maxResize.width !== Infinity) HORIZONTAL_DIRECTIONS$1.forEach(function(direction) {
            fittedDirections[direction] *= maxResize.width;
        });
        if (maxResize.height !== Infinity) VERTICAL_DIRECTIONS$1.forEach(function(direction) {
            fittedDirections[direction] *= maxResize.height;
        });
    }
    return fittedDirections;
}
function distributeOverlap(overlap, first, second) {
    if (isRoughlyEqual(first + second, 0)) return overlap / 2;
    else if (isRoughlyEqual(first, 0)) return 0;
    else if (isRoughlyEqual(second, 0)) return overlap;
    else return overlap * Math.abs(first / (first + second));
}
function resizeCoordinatesAlgorithm(coordinates, directions, options, limitations) {
    var aspectRatio = limitations.aspectRatio, positionRestrictions = limitations.positionRestrictions, sizeRestrictions = limitations.sizeRestrictions;
    var actualCoordinates = (0, $7WQrb.__assign)({}, coordinates);
    directions = (0, $7WQrb.__assign)({}, directions);
    var allowedDirections = options.allowedDirections || {
        left: true,
        right: true,
        bottom: true,
        top: true
    };
    // It's possible that coordinates can be smaller than minimum width or minimum height. In this case
    // corresponding resize should be blocked
    if (coordinates.width < sizeRestrictions.minWidth) {
        directions.left = 0;
        directions.right = 0;
    }
    if (coordinates.height < sizeRestrictions.minHeight) {
        directions.top = 0;
        directions.bottom = 0;
    }
    ALL_DIRECTIONS.forEach(function(direction) {
        if (!allowedDirections[direction]) directions[direction] = 0;
    });
    // 1. First step: determine the safe and desired area
    directions = fitDirections({
        coordinates: actualCoordinates,
        directions: directions,
        sizeRestrictions: sizeRestrictions,
        positionRestrictions: positionRestrictions,
        allowedDirections: allowedDirections
    });
    // 2. Second step: fix desired box to correspondent to aspect ratio
    var currentWidth = applyDirections(actualCoordinates, directions).width;
    var currentHeight = applyDirections(actualCoordinates, directions).height;
    // Checks ratio:
    var ratioBroken = options.preserveAspectRatio ? ratio(actualCoordinates) : getBrokenRatio(currentWidth / currentHeight, aspectRatio);
    if (ratioBroken) {
        var respectDirection = options.respectDirection;
        if (respectDirection !== 'width' && respectDirection !== 'height') {
            if (actualCoordinates.width >= actualCoordinates.height || ratioBroken === 1) respectDirection = 'width';
            else respectDirection = 'height';
        }
        if (respectDirection === 'width') {
            var overlapHeight = currentWidth / ratioBroken - actualCoordinates.height;
            if (allowedDirections.top && allowedDirections.bottom) {
                var top_1 = directions.top, bottom = directions.bottom;
                directions.bottom = distributeOverlap(overlapHeight, bottom, top_1);
                directions.top = distributeOverlap(overlapHeight, top_1, bottom);
            } else if (allowedDirections.bottom) directions.bottom = overlapHeight;
            else if (allowedDirections.top) directions.top = overlapHeight;
            else if (allowedDirections.right) directions.right = 0;
            else if (allowedDirections.left) directions.left = 0;
        } else if (respectDirection === 'height') {
            var overlapWidth = actualCoordinates.width - currentHeight * ratioBroken;
            if (allowedDirections.left && allowedDirections.right) {
                var left = directions.left, right = directions.right;
                directions.left = -distributeOverlap(overlapWidth, left, right);
                directions.right = -distributeOverlap(overlapWidth, right, left);
            } else if (allowedDirections.left) directions.left = -overlapWidth;
            else if (allowedDirections.right) directions.right = -overlapWidth;
            else if (allowedDirections.top) directions.top = 0;
            else if (allowedDirections.bottom) directions.bottom = 0;
        }
        // 3. Third step: check if desired box with correct aspect ratios break some limits and fit to this conditions
        directions = fitDirections({
            directions: directions,
            coordinates: actualCoordinates,
            sizeRestrictions: sizeRestrictions,
            positionRestrictions: positionRestrictions,
            preserveRatio: true,
            compensate: options.compensate,
            allowedDirections: allowedDirections
        });
    }
    // 4. Check if ratio broken (temporary):
    currentWidth = applyDirections(actualCoordinates, directions).width;
    currentHeight = applyDirections(actualCoordinates, directions).height;
    ratioBroken = options.preserveAspectRatio ? ratio(actualCoordinates) : getBrokenRatio(currentWidth / currentHeight, aspectRatio);
    if (ratioBroken && isGreater(Math.abs(ratioBroken - currentWidth / currentHeight), 0)) ALL_DIRECTIONS.forEach(function(direction) {
        directions[direction] = 0;
    });
    return moveCoordinatesAlgorithm({
        width: coordinates.width + directions.right + directions.left,
        height: coordinates.height + directions.top + directions.bottom,
        left: coordinates.left,
        top: coordinates.top
    }, {
        left: -directions.left,
        top: -directions.top
    }, positionRestrictions);
}
function anchorToMassPoint(coordinates, anchor) {
    var plainAnchor = anchor.toLowerCase();
    return {
        left: coordinates.left + coordinates.width * (plainAnchor.indexOf('west') !== -1 ? 1 : plainAnchor.indexOf('east') !== -1 ? 0 : 0.5),
        top: coordinates.top + coordinates.height * (plainAnchor.indexOf('north') !== -1 ? 1 : plainAnchor.indexOf('south') !== -1 ? 0 : 0.5)
    };
}
function anchorToAllowedDirections(anchor) {
    var plainAnchor = anchor.toLowerCase();
    return {
        left: plainAnchor.indexOf('east') === -1,
        top: plainAnchor.indexOf('south') === -1,
        right: plainAnchor.indexOf('west') === -1,
        bottom: plainAnchor.indexOf('north') === -1
    };
}
function anchorMoveToResizeDirections(anchor, directions) {
    var plainAnchor = anchor.toLowerCase();
    var normalizedDirections = {
        left: plainAnchor.indexOf('west') === -1 ? directions.left : -directions.left,
        top: -directions.top,
        right: directions.left,
        bottom: directions.top
    };
    if ([
        'north',
        'south',
        'center'
    ].every(function(el) {
        return plainAnchor.indexOf(el) === -1;
    })) {
        normalizedDirections.top = 0;
        normalizedDirections.bottom = 0;
    }
    if ([
        'west',
        'east',
        'center'
    ].every(function(el) {
        return plainAnchor.indexOf(el) === -1;
    })) {
        normalizedDirections.left = 0;
        normalizedDirections.right = 0;
    }
    var allowedDirections = anchorToAllowedDirections(anchor);
    ALL_DIRECTIONS.forEach(function(direction) {
        if (!allowedDirections[direction]) normalizedDirections[direction] = 0;
    });
    return normalizedDirections;
}
function anchoredResizeCoordinatesAlgorithm(coordinates, anchor, directions, options, limitations) {
    var reference = options.reference;
    var resizeDirections = anchorMoveToResizeDirections(anchor, directions);
    var allowedDirections = anchorToAllowedDirections(anchor);
    var result = resizeCoordinatesAlgorithm(coordinates, resizeDirections, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
        allowedDirections: allowedDirections
    }), limitations);
    if (reference) // Move the result to anchor
    result = applyMove(result, diff(anchorToMassPoint(reference, anchor), anchorToMassPoint(result, anchor)));
    return moveToPositionRestrictions(result, limitations.positionRestrictions);
}
function resizeCoordinates(state, settings, anchor, directions, options) {
    var minimumSize = getMinimumSize(state);
    var sizeRestrictions = getSizeRestrictions(state, settings);
    return isInitializedState(state) ? (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, copyState(state)), {
        coordinates: anchoredResizeCoordinatesAlgorithm(state.coordinates, anchor, directions, options, {
            positionRestrictions: mergePositionRestrictions(getPositionRestrictions(state, settings), coordinatesToPositionRestrictions(state.visibleArea)),
            sizeRestrictions: {
                maxWidth: Math.min(sizeRestrictions.maxWidth, state.visibleArea.width),
                maxHeight: Math.min(sizeRestrictions.maxHeight, state.visibleArea.height),
                minWidth: Math.max(Math.min(sizeRestrictions.minWidth, state.visibleArea.width), minimumSize),
                minHeight: Math.max(Math.min(sizeRestrictions.minHeight, state.visibleArea.height), minimumSize)
            },
            aspectRatio: getAspectRatio(state, settings)
        })
    }) : state;
}
function setBoundary(state, settings, boundary) {
    var result = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, copyState(state)), {
        boundary: boundary
    });
    if (result.visibleArea && result.coordinates && state.visibleArea) {
        // Scale visible area size to fit new boundary:
        result.visibleArea.height = result.visibleArea.width / ratio(boundary);
        result.visibleArea.top += (state.visibleArea.height - result.visibleArea.height) / 2;
        // Scale visible area to prevent overlap coordinates (and its minimum size)
        var sizeRestrictions = getSizeRestrictions(result, settings);
        if (Math.max(sizeRestrictions.minHeight, result.coordinates.height) - result.visibleArea.height > 0 || Math.max(sizeRestrictions.minWidth, result.coordinates.width) - result.visibleArea.width > 0) result.visibleArea = applyScale(result.visibleArea, Math.max(Math.max(sizeRestrictions.minHeight, result.coordinates.height) / result.visibleArea.height, Math.max(sizeRestrictions.minWidth, result.coordinates.width) / result.visibleArea.width));
        // Scale visible area to prevent overlap area restrictions
        result.visibleArea = resizeToSizeRestrictions(result.visibleArea, getAreaSizeRestrictions(result, settings));
        // Move visible are to prevent moving of the coordinates:
        var move = inverseMove(fitToPositionRestrictions(result.coordinates, coordinatesToPositionRestrictions(result.visibleArea)));
        if (result.visibleArea.width < result.coordinates.width) move.left = 0;
        if (result.visibleArea.height < result.coordinates.height) move.top = 0;
        result.visibleArea = applyMove(result.visibleArea, move);
        // Move visible area to prevent overlap the area restrictions
        result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
        result = fitCoordinates(result, settings);
    }
    return result;
}
function rotateImageAlgorithm(state, settings, rotate) {
    if (isInitializedState(state)) {
        var result = copyState(state);
        var angle = isNumber(rotate) ? rotate : rotate.angle;
        var imageCenter = rotatePoint(getCenter((0, $7WQrb.__assign)({
            left: 0,
            top: 0
        }, getTransformedImageSize(state))), angle);
        result.transforms.rotate += angle;
        result.coordinates = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, approximateSize({
            sizeRestrictions: getSizeRestrictions(result, settings),
            aspectRatio: getAspectRatio(result, settings),
            width: result.coordinates.width,
            height: result.coordinates.height
        })), rotatePoint(getCenter(result.coordinates), angle));
        var center = !isNumber(rotate) && rotate.center ? rotate.center : getCenter(state.coordinates);
        var shift = diff(getCenter(state.coordinates), rotatePoint(getCenter(state.coordinates), angle, center));
        var imageSize = getTransformedImageSize(result);
        result.coordinates.left -= imageCenter.left - imageSize.width / 2 + result.coordinates.width / 2 - shift.left;
        result.coordinates.top -= imageCenter.top - imageSize.height / 2 + result.coordinates.height / 2 - shift.top;
        // Check that visible area doesn't break the area restrictions:
        result.visibleArea = resizeToSizeRestrictions(result.visibleArea, mergeSizeRestrictions(getAreaSizeRestrictions(result, settings), {
            minWidth: result.coordinates.width,
            minHeight: result.coordinates.height
        }));
        result.coordinates = moveToPositionRestrictions(result.coordinates, getPositionRestrictions(result, settings));
        result.visibleArea = applyMove(result.visibleArea, diff(getCenter(result.coordinates), getCenter(state.coordinates)));
        result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
        return result;
    }
    return state;
}
function flipImageAlgorithm(state, settings, horizontal, vertical) {
    if (isInitializedState(state)) {
        var result = copyState(state);
        var rotate = state.transforms.rotate;
        var imageSize = getTransformedImageSize(state);
        var changed = {
            horizontal: horizontal,
            vertical: vertical
        };
        if (changed.horizontal || changed.vertical) {
            var imageCenter = rotatePoint({
                left: imageSize.width / 2,
                top: imageSize.height / 2
            }, -rotate);
            var oldCenter = rotatePoint(getCenter(result.coordinates), -rotate);
            var newCenter = rotatePoint({
                left: changed.horizontal ? imageCenter.left - (oldCenter.left - imageCenter.left) : oldCenter.left,
                top: changed.vertical ? imageCenter.top - (oldCenter.top - imageCenter.top) : oldCenter.top
            }, rotate);
            result.coordinates = applyMove(result.coordinates, diff(newCenter, getCenter(result.coordinates)));
            oldCenter = rotatePoint(getCenter(result.visibleArea), -rotate);
            newCenter = rotatePoint({
                left: changed.horizontal ? imageCenter.left - (oldCenter.left - imageCenter.left) : oldCenter.left,
                top: changed.vertical ? imageCenter.top - (oldCenter.top - imageCenter.top) : oldCenter.top
            }, rotate);
            result.visibleArea = applyMove(result.visibleArea, diff(newCenter, getCenter(result.visibleArea)));
            result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
        }
        if (changed.horizontal) result.transforms.flip.horizontal = !state.transforms.flip.horizontal;
        if (changed.vertical) result.transforms.flip.vertical = !state.transforms.flip.vertical;
        return result;
    }
    return state;
}
function transformImageAlgorithm(state, settings, transform) {
    var _a;
    var _b = transform.scale, scale = _b === void 0 ? 1 : _b, _c = transform.move, move = _c === void 0 ? {} : _c;
    if (isInitializedState(state)) {
        var result = copyState(state);
        // It's reversed because zooming in the image is actually zooming out visible area
        var scaleFactor = 1 / (isNumber(scale) ? scale : scale.factor);
        var scaleCenter = !isNumber(scale) ? scale.center : undefined;
        var isAllowedScale = !isRoughlyEqual(scaleFactor, 1);
        var areaScale = 1;
        var stencilScale = 1;
        result.visibleArea = applyMove(result.visibleArea, {
            left: move.left || 0,
            top: move.top || 0
        });
        var sizeRestrictions = getSizeRestrictions(result, settings);
        var positionRestrictions = getPositionRestrictions(result, settings);
        var areaSizeRestrictions = getAreaSizeRestrictions(result, settings);
        var scaleRestrictions = {
            stencil: {
                minimum: Math.max(sizeRestrictions.minWidth ? sizeRestrictions.minWidth / result.coordinates.width : 0, sizeRestrictions.minHeight ? sizeRestrictions.minHeight / result.coordinates.height : 0),
                maximum: Math.min(sizeRestrictions.maxWidth ? sizeRestrictions.maxWidth / result.coordinates.width : Infinity, sizeRestrictions.maxHeight ? sizeRestrictions.maxHeight / result.coordinates.height : Infinity, maxScale(result.coordinates, positionToSizeRestrictions(positionRestrictions)))
            },
            area: {
                maximum: maxScale(result.visibleArea, areaSizeRestrictions),
                minimum: minScale(result.visibleArea, areaSizeRestrictions)
            }
        };
        // If there is scaling then begin scale
        if (scaleFactor && isAllowedScale) {
            // Determine scale factor
            if (scaleFactor < 1) {
                stencilScale = Math.max(scaleFactor, Math.max(scaleRestrictions.area.minimum, scaleRestrictions.stencil.minimum));
                if (stencilScale > 1) stencilScale = 1;
            } else if (scaleFactor > 1) {
                stencilScale = Math.min(scaleFactor, Math.min(scaleRestrictions.area.maximum, scaleRestrictions.stencil.maximum));
                if (stencilScale < 1) stencilScale = 1;
            }
        }
        if (stencilScale) // Resize stencil with area as much as possible
        result.visibleArea = applyScale(result.visibleArea, stencilScale, scaleCenter);
        var relativeCoordinates = {
            left: state.coordinates.left - state.visibleArea.left,
            right: state.visibleArea.width + state.visibleArea.left - (state.coordinates.width + state.coordinates.left),
            top: state.coordinates.top - state.visibleArea.top,
            bottom: state.visibleArea.height + state.visibleArea.top - (state.coordinates.height + state.coordinates.top)
        };
        // Move the area to fit to the coordinates limits:
        result.visibleArea = moveToPositionRestrictions(result.visibleArea, {
            left: positionRestrictions.left !== undefined ? positionRestrictions.left - relativeCoordinates.left * stencilScale : undefined,
            top: positionRestrictions.top !== undefined ? positionRestrictions.top - relativeCoordinates.top * stencilScale : undefined,
            bottom: positionRestrictions.bottom !== undefined ? positionRestrictions.bottom + relativeCoordinates.bottom * stencilScale : undefined,
            right: positionRestrictions.right !== undefined ? positionRestrictions.right + relativeCoordinates.right * stencilScale : undefined
        });
        // But the more important to fit are to the area restrictions, so we should fit it to that restrictions:
        result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
        // Set the same coordinates of stencil inside visible area
        result.coordinates.width = result.coordinates.width * stencilScale;
        result.coordinates.height = result.coordinates.height * stencilScale;
        result.coordinates.left = result.visibleArea.left + relativeCoordinates.left * stencilScale;
        result.coordinates.top = result.visibleArea.top + relativeCoordinates.top * stencilScale;
        // Move the coordinates to prevent the intersection with visible area and position restrictions
        result.coordinates = moveToPositionRestrictions(result.coordinates, mergePositionRestrictions(coordinatesToPositionRestrictions(result.visibleArea), positionRestrictions));
        // Resize only area if stencil can't be resized and stencil resize is disabled
        if (isAllowedScale && scaleFactor && ((_a = settings.transformImage) === null || _a === void 0 ? void 0 : _a.adjustStencil)) {
            if (scaleFactor > 1) areaScale = Math.min(scaleRestrictions.area.maximum, scaleFactor) / stencilScale;
            else if (scaleFactor < 1) areaScale = Math.max(result.coordinates.height / result.visibleArea.height, result.coordinates.width / result.visibleArea.width, scaleFactor / stencilScale);
            if (areaScale !== 1) {
                result.visibleArea = applyScale(result.visibleArea, areaScale, scaleFactor > 1 ? scaleCenter : getCenter(result.coordinates));
                // Move to prevent the breaking of the area restrictions:
                result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
                // Move to prevent the intersection with coordinates:
                result.visibleArea = applyMove(result.visibleArea, inverseMove(fitToPositionRestrictions(result.coordinates, coordinatesToPositionRestrictions(result.visibleArea))));
            }
        }
        return result;
    }
    return state;
}
function transformImage(state, settings, transform) {
    if (transform.rotate) state = rotateImageAlgorithm(state, settings, transform.rotate);
    if (transform.flip) state = flipImageAlgorithm(state, settings, transform.flip.horizontal, transform.flip.vertical);
    if (transform.move || transform.scale) state = transformImageAlgorithm(state, settings, transform);
    return state;
}
function reconcileState(state, settings) {
    if (isInitializedState(state)) {
        var result = copyState(state);
        var aspectRatio = getAspectRatio(state, settings);
        var sizeRestrictions = getSizeRestrictions(state, settings);
        var areaSizeRestrictions = getAreaSizeRestrictions(state, settings);
        // Fit the size of coordinates to existing size restrictions and visible area
        var brokenRatio = getBrokenRatio(ratio(state.coordinates), aspectRatio);
        var desiredSize = brokenRatio ? {
            height: state.coordinates.height,
            width: state.coordinates.height * brokenRatio
        } : state.coordinates;
        result.coordinates = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, result.coordinates), approximateSize({
            width: desiredSize.width,
            height: desiredSize.height,
            aspectRatio: aspectRatio,
            sizeRestrictions: mergeSizeRestrictions(areaSizeRestrictions, sizeRestrictions)
        }));
        // Return the coordinates to the previous center
        result.coordinates = applyMove(result.coordinates, diff(getCenter(state.coordinates), getCenter(result.coordinates)));
        var scaleModifier = Math.max(result.coordinates.width / result.visibleArea.width, result.coordinates.height / result.visibleArea.height, 1);
        // Fit the visible area to its size restrictions and boundary aspect ratio:
        result.visibleArea = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, state.visibleArea), approximateSize({
            width: state.visibleArea.width * scaleModifier,
            height: state.visibleArea.height * scaleModifier,
            aspectRatio: {
                minimum: ratio(result.boundary),
                maximum: ratio(result.boundary)
            },
            sizeRestrictions: areaSizeRestrictions
        }));
        // Return the visible area to previous center
        result.visibleArea = applyMove(result.visibleArea, diff(getCenter(state.visibleArea), getCenter(result.visibleArea)));
        // Fit the visible area to positions restrictions
        result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
        // Fit the coordinates to position restrictions and visible area
        result.coordinates = moveToPositionRestrictions(result.coordinates, mergePositionRestrictions(coordinatesToPositionRestrictions(result.visibleArea), getPositionRestrictions(result, settings)));
        return result;
    }
    return state;
}
function normalizeResizeDirections(state, directions) {
    var coefficient = getCoefficient(state);
    return {
        left: isNumber(directions.left) ? directions.left * coefficient : 0,
        top: isNumber(directions.top) ? directions.top * coefficient : 0,
        right: isNumber(directions.right) ? directions.right * coefficient : 0,
        bottom: isNumber(directions.bottom) ? directions.bottom * coefficient : 0
    };
}
function normalizeCenter(state, center) {
    var coefficient = getCoefficient(state);
    if (state.visibleArea) return {
        left: center.left * coefficient + state.visibleArea.left,
        top: center.top * coefficient + state.visibleArea.top
    };
    return center;
}
function normalizeFlip(state, flip) {
    if (state) {
        var normalizedAngle = Math.abs(state.transforms.rotate % 180);
        if (normalizedAngle <= 45 || normalizedAngle >= 135) return flip;
        else return {
            horizontal: flip.vertical,
            vertical: flip.horizontal
        };
    }
    return flip;
}
function fillMoveDirections(directions) {
    return {
        left: isNumber(directions.left) ? directions.left : 0,
        top: isNumber(directions.top) ? directions.top : 0
    };
}
function fillResizeDirections(directions) {
    return {
        left: isNumber(directions.left) ? directions.left : 0,
        top: isNumber(directions.top) ? directions.top : 0,
        right: isNumber(directions.right) ? directions.right : 0,
        bottom: isNumber(directions.bottom) ? directions.bottom : 0
    };
}
function normalizeMoveDirections(state, directions) {
    var coefficient = getCoefficient(state);
    return {
        left: isNumber(directions.left) ? directions.left * coefficient : 0,
        top: isNumber(directions.top) ? directions.top * coefficient : 0
    };
}
function normalizeImageTransform(state, transform) {
    if (transform.scale) transform.scale = {
        factor: isNumber(transform.scale) ? transform.scale : transform.scale.factor,
        center: !isNumber(transform.scale) && transform.scale.center ? normalizeCenter(state, transform.scale.center) : undefined
    };
    if (transform.rotate) transform.rotate = {
        angle: isNumber(transform.rotate) ? transform.rotate : transform.rotate.angle,
        center: !isNumber(transform.rotate) && transform.rotate.center ? normalizeCenter(state, transform.rotate.center) : undefined
    };
    if (transform.move) transform.move = normalizeMoveDirections(state, transform.move);
    return transform;
}
function calculateGeometricProperties(touches, container) {
    var _a = container.getBoundingClientRect(), left = _a.left, top = _a.top;
    var centerMass = {
        left: 0,
        top: 0
    };
    var spread = 0;
    touches.forEach(function(touch) {
        centerMass.left += (touch.clientX - left) / touches.length;
        centerMass.top += (touch.clientY - top) / touches.length;
    });
    touches.forEach(function(touch) {
        spread += distance({
            left: centerMass.left,
            top: centerMass.top
        }, {
            left: touch.clientX - left,
            top: touch.clientY - top
        });
    });
    return {
        centerMass: centerMass,
        spread: spread,
        count: touches.length
    };
}
function touchesToImageTransform(touches, previousTouches, container, options) {
    if (options === void 0) options = {};
    var move, scale, rotate;
    if (previousTouches.length === 1 && touches.length === 1) {
        if (options.move) move = {
            left: previousTouches[0].clientX - touches[0].clientX,
            top: previousTouches[0].clientY - touches[0].clientY
        };
    } else if (touches.length > 1) {
        var previousProperties = calculateGeometricProperties(previousTouches, container);
        var properties = calculateGeometricProperties(touches, container);
        if (options.rotate && previousTouches.length === 2 && touches.length === 2) {
            var diffs = {
                left: [
                    touches[0].clientX - touches[1].clientX,
                    previousTouches[0].clientX - previousTouches[1].clientX
                ],
                top: [
                    touches[0].clientY - touches[1].clientY,
                    previousTouches[0].clientY - previousTouches[1].clientY
                ]
            };
            var y = diffs.left[0] * diffs.top[1] - diffs.left[1] * diffs.top[0];
            var x = diffs.left[0] * diffs.left[1] + diffs.top[0] * diffs.top[1];
            if (!isRoughlyEqual(x, 0) && !isRoughlyEqual(y, 0)) {
                var radians = Math.atan2(y, x);
                var angle = -(radians * 180) / Math.PI;
                rotate = {
                    center: properties.centerMass,
                    angle: angle
                };
            }
        }
        if (options.move) move = {
            left: previousProperties.centerMass.left - properties.centerMass.left,
            top: previousProperties.centerMass.top - properties.centerMass.top
        };
        if (options.scale) scale = {
            factor: properties.spread / previousProperties.spread,
            center: properties.centerMass
        };
    }
    return {
        move: move,
        scale: scale,
        rotate: rotate
    };
}
function wheelEventToImageTransform(event, container, ratio) {
    if (ratio === void 0) ratio = 0.1;
    var _a = container.getBoundingClientRect(), left = _a.left, top = _a.top;
    var factor = 1 - ratio * sign(event.deltaY || event.detail || event.wheelDelta);
    var center = {
        left: event.clientX - left,
        top: event.clientY - top
    };
    return {
        scale: {
            factor: factor,
            center: center
        }
    };
}
function hasInteractions(interactions) {
    return interactions.moveCoordinates || interactions.resizeCoordinates || interactions.transformImage.move || interactions.transformImage.rotate || interactions.transformImage.flip || interactions.transformImage.scale;
}
function getEmptyInteractions() {
    return {
        moveCoordinates: false,
        resizeCoordinates: false,
        transformImage: {
            rotate: false,
            move: false,
            scale: false,
            flip: false
        }
    };
}
function isEqualState(a, b) {
    return deepCompare(a, b);
}
function defaultPositionRestrictions(state, settings) {
    var imageSize = getTransformedImageSize(state);
    var limits = {};
    if (settings.imageRestriction && settings.imageRestriction !== 'none') limits = {
        left: 0,
        top: 0,
        right: imageSize.width,
        bottom: imageSize.height
    };
    return limits;
}
function defaultVisibleArea(state, settings) {
    var coordinates = state.coordinates, boundary = state.boundary;
    var imageSize = getTransformedImageSize(state);
    var boundaryRatio = ratio(boundary);
    if (coordinates) {
        // Visible area will try to fit reference:
        var reference = {
            height: Math.max(coordinates.height, imageSize.height),
            width: Math.max(coordinates.width, imageSize.width)
        };
        var visibleArea = {
            left: 0,
            top: 0,
            width: ratio(reference) > boundaryRatio ? reference.width : reference.height * boundaryRatio,
            height: ratio(reference) > boundaryRatio ? reference.width / boundaryRatio : reference.height
        };
        // Visible area should correspond its restrictions:
        visibleArea = resizeToSizeRestrictions(visibleArea, getAreaSizeRestrictions(state, settings));
        // Visible area will try to center stencil:
        visibleArea.left = coordinates.left + coordinates.width / 2 - visibleArea.width / 2;
        visibleArea.top = coordinates.top + coordinates.height / 2 - visibleArea.height / 2;
        // TODO: Controversial behavior:
        // If the coordinates are beyond image visible area will be allowed to be beyond image alike:
        var coordinatesIntersection = getIntersections(coordinates, coordinatesToPositionRestrictions((0, $7WQrb.__assign)({
            left: 0,
            top: 0
        }, imageSize)));
        var restrictions = {};
        if (!coordinatesIntersection.left && !coordinatesIntersection.right && visibleArea.width <= imageSize.width) {
            restrictions.left = 0;
            restrictions.right = imageSize.width;
        }
        if (!coordinatesIntersection.top && !coordinatesIntersection.bottom && visibleArea.height <= imageSize.height) {
            restrictions.top = 0;
            restrictions.bottom = imageSize.height;
        }
        return moveToPositionRestrictions(visibleArea, restrictions);
    } else {
        var imageRatio = ratio(imageSize);
        var areaProperties = {
            height: imageRatio < boundaryRatio ? imageSize.height : imageSize.width / boundaryRatio,
            width: imageRatio < boundaryRatio ? imageSize.height * boundaryRatio : imageSize.width
        };
        return {
            left: imageSize.width / 2 - areaProperties.width / 2,
            top: imageSize.height / 2 - areaProperties.height / 2,
            width: areaProperties.width,
            height: areaProperties.height
        };
    }
}
function defaultSize$1(state, settings) {
    var imageSize = state.imageSize, visibleArea = state.visibleArea;
    var sizeRestrictions = getSizeRestrictions(state, settings);
    var aspectRatio = getAspectRatio(state, settings);
    var area;
    if (visibleArea) area = visibleArea;
    else {
        var sizeRestrictions_1 = positionToSizeRestrictions(getPositionRestrictions(state, settings));
        area = {
            width: Math.max(sizeRestrictions_1.minWidth, Math.min(sizeRestrictions_1.maxWidth, imageSize.width)),
            height: Math.max(sizeRestrictions_1.minHeight, Math.min(sizeRestrictions_1.maxHeight, imageSize.height))
        };
    }
    var optimalRatio = Math.min(aspectRatio.maximum || Infinity, Math.max(aspectRatio.minimum || 0, ratio(area)));
    var size = area.width < area.height ? {
        width: area.width * 0.8,
        height: area.width * 0.8 / optimalRatio
    } : {
        height: area.height * 0.8,
        width: area.height * 0.8 * optimalRatio
    };
    return approximateSize((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, size), {
        aspectRatio: aspectRatio,
        sizeRestrictions: sizeRestrictions
    }));
}
function retrieveSizeRestrictions(settings) {
    return {
        minWidth: isNumeric(settings.minWidth) ? parseNumber(settings.minWidth) : 0,
        minHeight: isNumeric(settings.minHeight) ? parseNumber(settings.minHeight) : 0,
        maxWidth: isNumeric(settings.maxWidth) ? parseNumber(settings.maxWidth) : Infinity,
        maxHeight: isNumeric(settings.maxHeight) ? parseNumber(settings.maxHeight) : Infinity
    };
}
function pixelsRestrictions(state, settings) {
    return retrieveSizeRestrictions(settings);
}
function defaultPosition(state) {
    var visibleArea = state.visibleArea, coordinates = state.coordinates;
    var area = visibleArea || getTransformedImageSize(state);
    return {
        left: (visibleArea ? visibleArea.left : 0) + area.width / 2 - (coordinates ? coordinates.width / 2 : 0),
        top: (visibleArea ? visibleArea.top : 0) + area.height / 2 - (coordinates ? coordinates.height / 2 : 0)
    };
}
function defaultAreaPositionRestrictions(state, settings) {
    var visibleArea = state.visibleArea, boundary = state.boundary;
    var imageRestriction = settings.imageRestriction;
    var imageSize = getTransformedImageSize(state);
    var restrictions = {};
    if (imageRestriction === ImageRestriction.fillArea) restrictions = {
        left: 0,
        top: 0,
        right: imageSize.width,
        bottom: imageSize.height
    };
    else if (imageRestriction === ImageRestriction.fitArea) {
        if (ratio(boundary) > ratio(imageSize)) {
            restrictions = {
                top: 0,
                bottom: imageSize.height
            };
            if (visibleArea) {
                if (visibleArea.width > imageSize.width) {
                    restrictions.left = -(visibleArea.width - imageSize.width) / 2;
                    restrictions.right = imageSize.width - restrictions.left;
                } else {
                    restrictions.left = 0;
                    restrictions.right = imageSize.width;
                }
            }
        } else {
            restrictions = {
                left: 0,
                right: imageSize.width
            };
            if (visibleArea) {
                if (visibleArea.height > imageSize.height) {
                    restrictions.top = -(visibleArea.height - imageSize.height) / 2;
                    restrictions.bottom = imageSize.height - restrictions.top;
                } else {
                    restrictions.top = 0;
                    restrictions.bottom = imageSize.height;
                }
            }
        }
    }
    return restrictions;
}
function defaultAreaSizeRestrictions(state, settings) {
    var boundary = state.boundary;
    var imageRestriction = settings.imageRestriction;
    var imageSize = getTransformedImageSize(state);
    var restrictions = {
        minWidth: 0,
        minHeight: 0,
        maxWidth: Infinity,
        maxHeight: Infinity
    };
    if (imageRestriction === ImageRestriction.fillArea) {
        restrictions.maxWidth = imageSize.width;
        restrictions.maxHeight = imageSize.height;
    } else if (imageRestriction === ImageRestriction.fitArea) {
        if (ratio(boundary) > ratio(imageSize)) {
            restrictions.maxHeight = imageSize.height;
            restrictions.maxWidth = imageSize.height * ratio(boundary);
        } else {
            restrictions.maxWidth = imageSize.width;
            restrictions.maxHeight = imageSize.width / ratio(boundary);
        }
    }
    return restrictions;
}
function fitBoundary(boundary, size) {
    var areaHeight = boundary.clientHeight;
    var areaWidth = boundary.clientWidth;
    var currentHeight = areaHeight;
    var currentWidth = size.width * areaHeight / size.height;
    if (currentWidth > areaWidth) {
        currentWidth = areaWidth;
        currentHeight = size.height * areaWidth / size.width;
    }
    return {
        width: currentWidth,
        height: currentHeight
    };
}
function fillBoundary(boundary) {
    var _a = boundary.getBoundingClientRect(), width = _a.width, height = _a.height;
    return {
        width: width,
        height: height
    };
}
function defaultStencilConstraints(rawSettings, stencilProps) {
    if (!rawSettings.aspectRatio) return {
        aspectRatio: createAspectRatio(isFunction(stencilProps.aspectRatio) ? stencilProps.aspectRatio() : stencilProps.aspectRatio)
    };
    return {};
}
function withDefaultSizeRestrictions(sizeRestrictions) {
    return function(state, basicSettings) {
        var value = isFunction(sizeRestrictions) ? sizeRestrictions(state, basicSettings) : sizeRestrictions;
        return mergeSizeRestrictions(pixelsRestrictions(state, basicSettings), value);
    };
}
function withDefaultPositionRestrictions(positionRestrictions) {
    return function(state, basicSettings) {
        var value = isFunction(positionRestrictions) ? positionRestrictions(state, basicSettings) : positionRestrictions;
        return mergePositionRestrictions(defaultPositionRestrictions(state, basicSettings), value);
    };
}
function withDefaultAreaPositionRestrictions(areaPositionRestrictions) {
    return function(state, basicSettings) {
        var value = isFunction(areaPositionRestrictions) ? areaPositionRestrictions(state, basicSettings) : areaPositionRestrictions;
        return mergePositionRestrictions(defaultAreaPositionRestrictions(state, basicSettings), value);
    };
}
function withDefaultAreaSizeRestrictions(areaSizeRestrictions) {
    return function(state, basicSettings) {
        var value = isFunction(areaSizeRestrictions) ? areaSizeRestrictions(state, basicSettings) : areaSizeRestrictions;
        return mergeSizeRestrictions(defaultAreaSizeRestrictions(state, basicSettings), value);
    };
}
function createDefaultSettings(params) {
    return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, params), {
        sizeRestrictions: function(state, basicSettings) {
            var restrictions;
            if (params.sizeRestrictions) restrictions = isFunction(params.sizeRestrictions) ? params.sizeRestrictions(state, basicSettings) : params.sizeRestrictions;
            else restrictions = pixelsRestrictions(state, basicSettings);
            return restrictions;
        },
        areaPositionRestrictions: function(state, basicSettings) {
            if (params.areaPositionRestrictions) return isFunction(params.areaPositionRestrictions) ? params.areaPositionRestrictions(state, basicSettings) : params.areaPositionRestrictions;
            else return defaultAreaPositionRestrictions(state, basicSettings);
        },
        areaSizeRestrictions: function(state, basicSettings) {
            if (params.areaSizeRestrictions) return isFunction(params.areaSizeRestrictions) ? params.areaSizeRestrictions(state, basicSettings) : params.areaSizeRestrictions;
            else return defaultAreaSizeRestrictions(state, basicSettings);
        },
        positionRestrictions: function(state, basicSettings) {
            if (params.positionRestrictions) return isFunction(params.positionRestrictions) ? params.positionRestrictions(state, basicSettings) : params.positionRestrictions;
            else return defaultPositionRestrictions(state, basicSettings);
        },
        defaultCoordinates: function(state, basicSettings) {
            if (params.defaultCoordinates) return isFunction(params.defaultCoordinates) ? params.defaultCoordinates(state, basicSettings) : params.defaultCoordinates;
            else {
                var defaultSizeAlgorithm = params.defaultSize;
                if (!defaultSizeAlgorithm) defaultSizeAlgorithm = defaultSize$1;
                var size = isFunction(defaultSizeAlgorithm) ? defaultSizeAlgorithm(state, basicSettings) : defaultSizeAlgorithm;
                var defaultPositionAlgorithm_1 = params.defaultPosition || defaultPosition;
                return [
                    size,
                    function(state) {
                        return (0, $7WQrb.__assign)({}, isFunction(defaultPositionAlgorithm_1) ? defaultPositionAlgorithm_1(state, basicSettings) : defaultPositionAlgorithm_1);
                    }
                ];
            }
        },
        defaultVisibleArea: function(state, basicSettings) {
            if (params.defaultVisibleArea) return isFunction(params.defaultVisibleArea) ? params.defaultVisibleArea(state, basicSettings) : params.defaultVisibleArea;
            else return defaultVisibleArea(state, basicSettings);
        },
        aspectRatio: function(state, basicSettings) {
            return createAspectRatio(isFunction(params.aspectRatio) ? params.aspectRatio(state, basicSettings) : params.aspectRatio);
        }
    });
}
function runCallback(callback, getInstance) {
    if (callback && getInstance) {
        var instance = getInstance();
        if (instance) callback(instance);
    }
}
function runCallbacks(callbacks, getInstance) {
    callbacks.forEach(function(callback) {
        runCallback(callback, getInstance);
    });
}
var AbstractCropperInstance = /** @class */ function() {
    function AbstractCropperInstance() {
        var _this = this;
        this.getTransitions = function() {
            var data = _this.getData();
            var transitions = _this.getProps().transitions;
            return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, getOptions(transitions, {
                timingFunction: 'ease-in-out',
                duration: 350
            })), {
                active: data.transitions
            });
        };
        this.getInteractions = function() {
            var interactions = _this.getData().interactions;
            return deepClone(interactions);
        };
        this.hasInteractions = function() {
            var interactions = _this.getData().interactions;
            return hasInteractions(interactions);
        };
        this.startTransitions = function() {
            var _a = _this.getProps(), onTransitionsStart = _a.onTransitionsStart, onUpdate = _a.onUpdate, getInstance = _a.getInstance;
            var _b = _this.getData(), transitions = _b.transitions, data = (0, $7WQrb.__rest)(_b, [
                "transitions"
            ]);
            _this.setData((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, data), {
                transitions: true
            }));
            if (!transitions) runCallbacks([
                onTransitionsStart,
                onUpdate
            ], getInstance);
            _this.endTransitions();
        };
        this.endTransitions = debounce(function() {
            var _a = _this.getProps(), onTransitionsEnd = _a.onTransitionsEnd, onUpdate = _a.onUpdate, getInstance = _a.getInstance;
            _this.setData((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, _this.getData()), {
                transitions: false
            }));
            runCallbacks([
                onTransitionsEnd,
                onUpdate
            ], getInstance);
        }, function() {
            return _this.getTransitions().duration;
        });
        this.applyPostProcess = function(action, state) {
            var _a = _this.getProps(), settings = _a.settings, postProcess = _a.postProcess;
            var name = action.name, _b = action.interaction, interaction = _b === void 0 ? false : _b, _c = action.transitions, transitions = _c === void 0 ? false : _c, _d = action.immediately, immediately = _d === void 0 ? false : _d;
            var preparedAction = {
                name: name,
                interaction: interaction,
                transitions: transitions,
                immediately: immediately
            };
            if (isArray(postProcess)) return postProcess.reduce(function(processedState, p) {
                return p(processedState, settings, preparedAction);
            }, state);
            else if (isFunction(postProcess)) return postProcess(state, settings, preparedAction);
            else return state;
        };
        this.updateState = function(modifier, options, callbacks) {
            if (options === void 0) options = {};
            if (callbacks === void 0) callbacks = [];
            var _a = options.transitions, transitions = _a === void 0 ? false : _a;
            var _b = _this.getProps(), onTransitionsStart = _b.onTransitionsStart, getInstance = _b.getInstance, onChange = _b.onChange, onUpdate = _b.onUpdate, settings = _b.settings;
            var previousData = _this.getData();
            var state = isFunction(modifier) ? modifier(previousData.state, settings) : modifier;
            var tolerance = state ? 1e-3 * getCoefficient(state) : 1e-3;
            var somethingChanged = !deepCompare(previousData.state, state, tolerance);
            var affectTransitionProperties = [
                'coordinates',
                'boundary',
                'visibleArea',
                'imageSize',
                'transforms'
            ].some(function(property) {
                var _a;
                return !deepCompare((_a = previousData.state) === null || _a === void 0 ? void 0 : _a[property], state === null || state === void 0 ? void 0 : state[property], tolerance);
            });
            var currentData = previousData;
            if (somethingChanged) {
                if (transitions && affectTransitionProperties) _this.endTransitions();
                currentData = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, currentData), {
                    state: copyState(state),
                    transitions: transitions && affectTransitionProperties
                });
                _this.setData(currentData);
                runCallback(onChange, getInstance);
            }
            if (currentData.transitions && !previousData.transitions) runCallback(onTransitionsStart, getInstance);
            runCallbacks((0, $7WQrb.__spreadArrays)(callbacks, [
                onUpdate
            ]), getInstance);
        };
        this.setInteractions = function(interactions) {
            var _a = _this.getProps(), onInteractionStart = _a.onInteractionStart, onInteractionEnd = _a.onInteractionEnd, getInstance = _a.getInstance;
            var previousInteractions = _this.getInteractions();
            var currentInteractions = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, previousInteractions), interactions);
            if (!deepCompare(previousInteractions, currentInteractions)) _this.setData((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, _this.getData()), {
                interactions: currentInteractions
            }));
            if (hasInteractions(previousInteractions) !== hasInteractions(currentInteractions)) {
                if (!hasInteractions(previousInteractions)) runCallback(onInteractionStart, getInstance);
                else {
                    var state_1 = _this.getData().state;
                    _this.updateState(function() {
                        return state_1 && _this.applyPostProcess({
                            name: 'interactionEnd',
                            immediately: true,
                            transitions: true
                        }, state_1);
                    }, {
                        transitions: true
                    }, [
                        onInteractionEnd
                    ]);
                }
            }
        };
        this.resetState = function(boundary, image) {
            _this.updateState(_this.createDefaultState(boundary, image));
        };
        this.clear = function() {
            _this.updateState(null);
        };
        this.reconcileState = function(options) {
            if (options === void 0) options = {};
            var _a = _this.getProps(), reconcileStateAlgorithm = _a.reconcileStateAlgorithm, settings = _a.settings;
            var state = _this.getData().state;
            var _b = options.transitions, transitions = _b === void 0 ? false : _b;
            if (state && !isConsistentState(state, settings)) {
                var reconciledState = (reconcileStateAlgorithm || reconcileState)(state, settings);
                reconciledState = _this.applyPostProcess({
                    name: 'reconcileState',
                    immediately: true,
                    transitions: transitions
                }, reconciledState);
                _this.updateState(reconciledState, {
                    transitions: transitions
                });
            }
        };
        this.transformImage = function(transform, options) {
            if (options === void 0) options = {};
            var _a = options.transitions, transitions = _a === void 0 ? true : _a, _b = options.interaction, interaction = _b === void 0 ? true : _b, _c = options.immediately, immediately = _c === void 0 ? false : _c, _d = options.normalize, normalize = _d === void 0 ? true : _d;
            var _e = _this.getProps(), transformImageAlgorithm = _e.transformImageAlgorithm, onTransformImage = _e.onTransformImage, onTransformImageEnd = _e.onTransformImageEnd, settings = _e.settings;
            var state = _this.getData().state;
            var callbacks = [];
            if (state) {
                if (normalize) transform = normalizeImageTransform(state, transform);
                var result = _this.applyPostProcess({
                    name: 'transformImage',
                    transitions: transitions,
                    immediately: immediately
                }, (transformImageAlgorithm || transformImage)(state, settings, transform));
                callbacks.push(onTransformImage);
                if (interaction) _this.setInteractions({
                    transformImage: {
                        rotate: !isUndefined(transform.rotate),
                        flip: !isUndefined(transform.flip),
                        scale: !isUndefined(transform.scale),
                        move: !isUndefined(transform.move)
                    }
                });
                else {
                    result = _this.applyPostProcess({
                        name: 'transformImageEnd',
                        transitions: transitions,
                        immediately: true
                    }, result);
                    callbacks.push(onTransformImageEnd);
                }
                _this.updateState(result, {
                    transitions: immediately && transitions
                }, callbacks);
            }
        };
        this.transformImageEnd = function(options) {
            if (options === void 0) options = {};
            var _a = options.immediately, immediately = _a === void 0 ? true : _a, _b = options.transitions, transitions = _b === void 0 ? true : _b;
            var state = _this.getData().state;
            var onTransformImageEnd = _this.getProps().onTransformImageEnd;
            _this.updateState(function() {
                return state && _this.applyPostProcess({
                    name: 'transformImageEnd',
                    immediately: immediately,
                    transitions: transitions
                }, state);
            }, {
                transitions: transitions
            }, [
                onTransformImageEnd
            ]);
            _this.setInteractions({
                transformImage: {
                    rotate: false,
                    flip: false,
                    scale: false,
                    move: false
                }
            });
        };
        this.zoomImage = function(scale, options) {
            if (options === void 0) options = {};
            var _a = options.interaction, interaction = _a === void 0 ? false : _a, _b = options.immediately, immediately = _b === void 0 ? true : _b, _c = options.transitions, transitions = _c === void 0 ? true : _c, _d = options.normalize, normalize = _d === void 0 ? false : _d;
            _this.transformImage({
                scale: scale
            }, {
                interaction: interaction,
                immediately: immediately,
                transitions: transitions,
                normalize: normalize
            });
        };
        this.moveImage = function(left, top, options) {
            if (options === void 0) options = {};
            var _a = options.interaction, interaction = _a === void 0 ? false : _a, _b = options.immediately, immediately = _b === void 0 ? true : _b, _c = options.transitions, transitions = _c === void 0 ? true : _c, _d = options.normalize, normalize = _d === void 0 ? false : _d;
            _this.transformImage({
                move: {
                    left: left,
                    top: top
                }
            }, {
                interaction: interaction,
                immediately: immediately,
                transitions: transitions,
                normalize: normalize
            });
        };
        this.flipImage = function(horizontal, vertical, options) {
            if (options === void 0) options = {};
            var _a = options.interaction, interaction = _a === void 0 ? false : _a, _b = options.immediately, immediately = _b === void 0 ? true : _b, _c = options.transitions, transitions = _c === void 0 ? true : _c, _d = options.normalize, normalize = _d === void 0 ? true : _d;
            var state = _this.getState();
            var flip = {
                horizontal: horizontal,
                vertical: vertical
            };
            _this.transformImage({
                flip: state && normalize ? normalizeFlip(state, flip) : flip
            }, {
                interaction: interaction,
                immediately: immediately,
                transitions: transitions
            });
        };
        this.rotateImage = function(rotate, options) {
            if (options === void 0) options = {};
            var _a = options.interaction, interaction = _a === void 0 ? false : _a, _b = options.immediately, immediately = _b === void 0 ? true : _b, _c = options.transitions, transitions = _c === void 0 ? true : _c, _d = options.normalize, normalize = _d === void 0 ? false : _d;
            _this.transformImage({
                rotate: rotate
            }, {
                interaction: interaction,
                immediately: immediately,
                transitions: transitions,
                normalize: normalize
            });
        };
        this.reset = function(boundary, image) {
            _this.resetState(boundary, image);
        };
        this.setState = function(modifier, options) {
            if (options === void 0) options = {};
            var settings = _this.getSettings();
            var state = _this.getData().state;
            var _a = options.transitions, transitions = _a === void 0 ? true : _a, _b = options.immediately, immediately = _b === void 0 ? false : _b, _c = options.interaction, interaction = _c === void 0 ? false : _c, _d = options.postprocess, postprocess = _d === void 0 ? false : _d;
            var newState = modifier && (isFunction(modifier) ? modifier(state, settings) : (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, state), modifier));
            _this.updateState(function() {
                return postprocess ? newState && _this.applyPostProcess({
                    name: 'setState',
                    immediately: immediately,
                    transitions: transitions,
                    interaction: interaction
                }, newState) : newState;
            }, {
                transitions: transitions
            });
        };
        this.setCoordinates = function(transforms, options) {
            if (options === void 0) options = {};
            var state = _this.getData().state;
            var _a = _this.getProps(), setCoordinatesAlgorithm = _a.setCoordinatesAlgorithm, settings = _a.settings;
            var _b = options.transitions, transitions = _b === void 0 ? true : _b, _c = options.immediately, immediately = _c === void 0 ? true : _c;
            _this.updateState(function() {
                return state && _this.applyPostProcess({
                    name: 'setCoordinates',
                    immediately: immediately,
                    transitions: transitions
                }, (setCoordinatesAlgorithm || setCoordinates)(state, settings, transforms, SetCoordinatesMode.zoom));
            }, {
                transitions: transitions
            });
        };
        this.setVisibleArea = function(visibleArea, options) {
            if (options === void 0) options = {};
            var _a = options.transitions, transitions = _a === void 0 ? true : _a, _b = options.immediately, immediately = _b === void 0 ? true : _b;
            var state = _this.getData().state;
            var _c = _this.getProps(), setVisibleAreaAlgorithm = _c.setVisibleAreaAlgorithm, settings = _c.settings;
            _this.updateState(function() {
                return state && _this.applyPostProcess({
                    name: 'setVisibleArea',
                    immediately: immediately,
                    transitions: transitions
                }, (setVisibleAreaAlgorithm || setVisibleArea)(state, settings, visibleArea));
            }, {
                transitions: transitions
            });
        };
        this.setBoundary = function(boundary, options) {
            if (options === void 0) options = {};
            var state = _this.getData().state;
            var _a = _this.getProps(), setBoundaryAlgorithm = _a.setBoundaryAlgorithm, settings = _a.settings;
            var _b = options.transitions, transitions = _b === void 0 ? false : _b, _c = options.immediately, immediately = _c === void 0 ? true : _c;
            if (boundary) _this.updateState(function() {
                return state && _this.applyPostProcess({
                    name: 'setBoundary',
                    immediately: immediately,
                    transitions: transitions
                }, (setBoundaryAlgorithm || setBoundary)(state, settings, boundary));
            });
            else _this.updateState(null);
        };
        this.moveCoordinates = function(directions, options) {
            if (options === void 0) options = {};
            var data = _this.getData();
            var _a = _this.getProps(), moveCoordinatesAlgorithm = _a.moveCoordinatesAlgorithm, onMove = _a.onMove, onMoveEnd = _a.onMoveEnd, settings = _a.settings;
            var _b = options.interaction, interaction = _b === void 0 ? true : _b, _c = options.transitions, transitions = _c === void 0 ? false : _c, _d = options.immediately, immediately = _d === void 0 ? false : _d, _e = options.normalize, normalize = _e === void 0 ? true : _e;
            var callbacks = [];
            if (!data.transitions && data.state) {
                var normalizedDirections = normalize ? normalizeMoveDirections(data.state, directions) : fillMoveDirections(directions);
                var result = _this.applyPostProcess({
                    name: 'moveCoordinates',
                    interaction: interaction,
                    immediately: immediately,
                    transitions: transitions
                }, (moveCoordinatesAlgorithm || moveCoordinates)(data.state, settings, normalizedDirections));
                callbacks.push(onMove);
                if (interaction) _this.setInteractions({
                    moveCoordinates: true
                });
                else {
                    result = _this.applyPostProcess({
                        name: 'moveCoordinatesEnd',
                        interaction: interaction,
                        immediately: immediately,
                        transitions: transitions
                    }, result);
                    callbacks.push(onMoveEnd);
                }
                _this.updateState(result, {
                    transitions: immediately && transitions
                }, callbacks);
            }
        };
        this.moveCoordinatesEnd = function(options) {
            if (options === void 0) options = {};
            var state = _this.getData().state;
            var onMoveEnd = _this.getProps().onMoveEnd;
            var _a = options.transitions, transitions = _a === void 0 ? true : _a, _b = options.immediately, immediately = _b === void 0 ? false : _b;
            _this.updateState(function() {
                return state && _this.applyPostProcess({
                    name: 'moveCoordinatesEnd',
                    transitions: transitions,
                    immediately: immediately
                }, state);
            }, {
                transitions: transitions
            }, [
                onMoveEnd
            ]);
            _this.setInteractions({
                moveCoordinates: false
            });
        };
        this.resizeCoordinates = function(anchor, directions, parameters, options) {
            if (options === void 0) options = {};
            var state = _this.getData().state;
            var _a = _this.getProps(), resizeCoordinatesAlgorithm = _a.resizeCoordinatesAlgorithm, onResize = _a.onResize, onResizeEnd = _a.onResizeEnd, settings = _a.settings;
            var _b = options.interaction, interaction = _b === void 0 ? true : _b, _c = options.transitions, transitions = _c === void 0 ? false : _c, _d = options.immediately, immediately = _d === void 0 ? false : _d, _e = options.normalize, normalize = _e === void 0 ? true : _e;
            var transitionsOptions = _this.getTransitions();
            if (!transitionsOptions.active && state) {
                var callbacks = [];
                var normalizedDirections = normalize ? normalizeResizeDirections(state, directions) : fillResizeDirections(directions);
                var result = _this.applyPostProcess({
                    name: 'resizeCoordinates',
                    interaction: interaction,
                    immediately: immediately,
                    transitions: transitions
                }, (resizeCoordinatesAlgorithm || resizeCoordinates)(state, settings, anchor, normalizedDirections, isObject(parameters) ? parameters : {}));
                callbacks.push(onResize);
                if (interaction) _this.setInteractions({
                    resizeCoordinates: true
                });
                else {
                    result = _this.applyPostProcess({
                        name: 'resizeCoordinatesEnd',
                        interaction: interaction,
                        immediately: immediately,
                        transitions: transitions
                    }, result);
                    callbacks.push(onResizeEnd);
                }
                _this.updateState(result, {
                    transitions: immediately && transitions
                }, callbacks);
            }
        };
        this.resizeCoordinatesEnd = function(options) {
            if (options === void 0) options = {};
            var onResizeEnd = _this.getProps().onResizeEnd;
            var state = _this.getData().state;
            var _a = options.transitions, transitions = _a === void 0 ? true : _a, _b = options.immediately, immediately = _b === void 0 ? false : _b;
            _this.updateState(function() {
                return state && _this.applyPostProcess({
                    name: 'resizeCoordinatesEnd',
                    transitions: transitions,
                    immediately: immediately
                }, state);
            }, {
                transitions: transitions
            }, [
                onResizeEnd
            ]);
            _this.setInteractions({
                resizeCoordinates: false
            });
        };
        this.getStencilCoordinates = function() {
            var state = _this.getData().state;
            return getStencilCoordinates(state);
        };
        this.getCoordinates = function(options) {
            if (options === void 0) options = {};
            var state = _this.getData().state;
            var settings = _this.getProps().settings;
            if (state && state.coordinates) {
                var _a = options.round, round = _a === void 0 ? true : _a;
                if (round) return getRoundedCoordinates(state, settings);
                else return (0, $7WQrb.__assign)({}, state.coordinates);
            } else return null;
        };
        this.getVisibleArea = function() {
            var state = _this.getData().state;
            if (state === null || state === void 0 ? void 0 : state.visibleArea) return (0, $7WQrb.__assign)({}, state.visibleArea);
            else return null;
        };
        this.getSettings = function() {
            var settings = _this.getProps().settings;
            return (0, $7WQrb.__assign)({}, settings);
        };
        this.getState = function() {
            var state = _this.getData().state;
            return copyState(state);
        };
        this.getTransforms = function() {
            var state = _this.getData().state;
            return state ? deepClone(state.transforms) : {
                rotate: 0,
                flip: {
                    horizontal: false,
                    vertical: false
                }
            };
        };
        this.createDefaultState = function(boundary, image) {
            var _a = _this.getProps(), createStateAlgorithm = _a.createStateAlgorithm, settings = _a.settings;
            return _this.applyPostProcess({
                name: 'createState',
                immediately: true,
                transitions: false
            }, (createStateAlgorithm || createState)({
                image: image,
                boundary: boundary
            }, settings));
        };
        this.isConsistent = function() {
            var state = _this.getData().state;
            var settings = _this.getProps().settings;
            return state ? isConsistentState(state, settings) : true;
        };
    }
    return AbstractCropperInstance;
}();
var timingFunctions = {
    linear: function(t) {
        return t;
    },
    'ease-in': function(t) {
        return Math.pow(t, 1.675);
    },
    'ease-out': function(t) {
        return 1 - Math.pow(1 - t, 1.675);
    },
    'ease-in-out': function(t) {
        return 0.5 * (Math.sin((t - 0.5) * Math.PI) + 1);
    }
};
var Animation = /** @class */ function() {
    function Animation() {
        this.active = false;
    }
    Animation.prototype.start = function(animation) {
        var _a;
        this.onStart = animation.onStart;
        this.onProgress = animation.onProgress;
        this.onStop = animation.onStop;
        if (!this.active) (_a = this.onStart) === null || _a === void 0 || _a.call(this);
        if (this.id) window.cancelAnimationFrame(this.id);
        this.startTime = performance.now();
        this.timingFunction = animation.timingFunction;
        this.endTime = this.startTime + animation.duration;
        this.active = true;
        this.animate();
    };
    Animation.prototype.animate = function() {
        var _this = this;
        if (this.startTime && this.endTime) {
            var timingFunction = timingFunctions[this.timingFunction];
            if (!timingFunction) timingFunction = timingFunctions['ease-out'];
            var percent = 1 - (this.endTime - performance.now()) / (this.endTime - this.startTime);
            var progress = Math.min(1, timingFunction(percent));
            if (this.onProgress) this.onProgress(progress);
            if (percent < 1) this.id = window.requestAnimationFrame(function() {
                return _this.animate();
            });
            else this.stop();
        } else this.stop();
    };
    Animation.prototype.stop = function() {
        this.active = false;
        if (this.id) window.cancelAnimationFrame(this.id);
        if (this.onStop) this.onStop();
    };
    return Animation;
}();
function prepareSource(canvas, image, _a) {
    var rotate = _a.rotate, flip = _a.flip;
    var originalSize = {
        width: 'naturalWidth' in image ? image.naturalWidth : image.width,
        height: 'naturalHeight' in image ? image.naturalHeight : image.height
    };
    var transformedSize = rotateSize(originalSize, rotate);
    var ctx = canvas.getContext('2d');
    canvas.height = transformedSize.height;
    canvas.width = transformedSize.width;
    if (ctx) {
        ctx.save();
        // Rotation:
        var canvasCenter = rotatePoint(getCenter((0, $7WQrb.__assign)({
            left: 0,
            top: 0
        }, originalSize)), rotate);
        ctx.translate(-(canvasCenter.left - transformedSize.width / 2), -(canvasCenter.top - transformedSize.height / 2));
        ctx.rotate(rotate * Math.PI / 180);
        // Reflection;
        ctx.translate(flip.horizontal ? originalSize.width : 0, flip.vertical ? originalSize.height : 0);
        ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
        ctx.drawImage(image, 0, 0, originalSize.width, originalSize.height);
        ctx.restore();
    }
    return canvas;
}
function updateCanvas(canvas, source, coordinates, resultSize, options) {
    canvas.width = resultSize ? resultSize.width : coordinates.width;
    canvas.height = resultSize ? resultSize.height : coordinates.height;
    var ctx = canvas.getContext('2d');
    if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (options) {
            if (options.imageSmoothingEnabled) ctx.imageSmoothingEnabled = options.imageSmoothingEnabled;
            if (options.imageSmoothingQuality) ctx.imageSmoothingQuality = options.imageSmoothingQuality;
            if (options.fillColor) {
                ctx.fillStyle = options.fillColor;
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.save();
            }
        }
        var offsetX = coordinates.left < 0 ? -coordinates.left : 0;
        var offsetY = coordinates.top < 0 ? -coordinates.top : 0;
        ctx.drawImage(source, coordinates.left + offsetX, coordinates.top + offsetY, coordinates.width, coordinates.height, offsetX, offsetY, canvas.width, canvas.height);
    }
    return canvas;
}
function drawCroppedArea(state, image, resultCanvas, spareCanvas, options) {
    if (isInitializedState(state)) {
        var transforms = state.transforms, coordinates = state.coordinates;
        var imageTransformed = transforms.rotate !== 0 || transforms.flip.horizontal || transforms.flip.vertical;
        var source = imageTransformed ? prepareSource(spareCanvas, image, transforms) : image;
        var params = (0, $7WQrb.__assign)({
            minWidth: 0,
            minHeight: 0,
            maxWidth: Infinity,
            maxHeight: Infinity,
            maxArea: Infinity,
            imageSmoothingEnabled: true,
            imageSmoothingQuality: 'high',
            fillColor: 'transparent'
        }, options);
        var firstNumeric = function(array) {
            return array.find(function(el) {
                return isNumeric(el);
            });
        };
        var size = approximateSize({
            sizeRestrictions: {
                minWidth: firstNumeric([
                    params.width,
                    params.minWidth
                ]) || 0,
                minHeight: firstNumeric([
                    params.height,
                    params.minHeight
                ]) || 0,
                maxWidth: firstNumeric([
                    params.width,
                    params.maxWidth
                ]) || Infinity,
                maxHeight: firstNumeric([
                    params.height,
                    params.maxHeight
                ]) || Infinity
            },
            width: coordinates.width,
            height: coordinates.height,
            aspectRatio: {
                minimum: coordinates.width / coordinates.height,
                maximum: coordinates.width / coordinates.height
            }
        });
        if (params.maxArea && size.width * size.height > params.maxArea) {
            var scale = Math.sqrt(params.maxArea / (size.width * size.height));
            size = {
                width: Math.round(scale * size.width),
                height: Math.round(scale * size.height)
            };
        }
        return updateCanvas(resultCanvas, source, coordinates, size, params);
    } else return null;
}
function stretchCropperBoundary(boundary, stretcher, size) {
    // Reset stretcher
    stretcher.style.width = "0px";
    stretcher.style.height = "0px";
    // Try to fit the size by width:
    stretcher.style.width = Math.max(boundary.clientWidth, size.width) + "px";
    // After that try to fit the size by height and resulted width:
    var ratio = size.width / size.height;
    stretcher.style.height = Math.max(boundary.clientHeight, stretcher.clientWidth / ratio) + "px";
    stretcher.style.width = stretcher.clientHeight * ratio + "px";
}
function stretchPreviewBoundary(boundary, stretcher, size) {
    // Reset stretcher
    stretcher.style.width = "0px";
    stretcher.style.height = "0px";
    // Try to fit the size by width:
    stretcher.style.width = Math.max(boundary.getBoundingClientRect().width, size.width) + "px";
    // After that try to fit the size by height and resulted width:
    var ratio = size.width / size.height;
    stretcher.style.height = Math.max(boundary.getBoundingClientRect().height, stretcher.getBoundingClientRect().width / ratio) + "px";
    stretcher.style.width = stretcher.getBoundingClientRect().height * ratio + "px";
    if (stretcher.clientWidth / stretcher.clientHeight > boundary.clientWidth / boundary.clientHeight) {
        if (stretcher.clientWidth > boundary.clientWidth) {
            stretcher.style.width = boundary.clientWidth + "px";
            stretcher.style.height = boundary.clientWidth / ratio + "px";
        }
    } else if (stretcher.clientHeight > boundary.clientHeight) {
        stretcher.style.height = boundary.clientHeight + "px";
        stretcher.style.width = boundary.clientHeight * ratio + "px";
    }
}
var XHR_DONE = 4;
function base64ToArrayBuffer(base64) {
    base64 = base64.replace(/^data:([^;]+);base64,/gim, '');
    var binary = atob(base64);
    var len = binary.length;
    var buffer = new ArrayBuffer(len);
    var view = new Uint8Array(buffer);
    for(var i = 0; i < len; i++)view[i] = binary.charCodeAt(i);
    return buffer;
}
function objectURLToBlob(url, callback) {
    var http = new XMLHttpRequest();
    http.open('GET', url, true);
    http.responseType = 'blob';
    http.onload = function() {
        if (this.status == 200 || this.status === 0) callback(this.response);
    };
    http.send();
}
function getTransforms(orientation) {
    var result = {
        flip: {
            horizontal: false,
            vertical: false
        },
        rotate: 0
    };
    if (orientation) switch(orientation){
        case 2:
            result.flip.horizontal = true;
            break;
        case 3:
            result.rotate = -180;
            break;
        case 4:
            result.flip.vertical = true;
            break;
        case 5:
            result.rotate = 90;
            result.flip.vertical = true;
            break;
        case 6:
            result.rotate = 90;
            break;
        case 7:
            result.rotate = 90;
            result.flip.horizontal = true;
            break;
        case 8:
            result.rotate = -90;
            break;
    }
    return result;
}
function getImageData(img) {
    return new Promise(function(resolve, reject) {
        try {
            if (img) {
                if (/^data:/i.test(img)) // Data URL
                resolve(base64ToArrayBuffer(img));
                else if (/^blob:/i.test(img)) {
                    // Blob
                    var fileReader_1 = new FileReader();
                    fileReader_1.onload = function(e) {
                        var _a;
                        resolve((_a = e.target) === null || _a === void 0 ? void 0 : _a.result);
                    };
                    objectURLToBlob(img, function(blob) {
                        fileReader_1.readAsArrayBuffer(blob);
                    });
                } else {
                    // Simple URL
                    var http_1 = new XMLHttpRequest();
                    http_1.onreadystatechange = function() {
                        if (http_1.readyState !== XHR_DONE) return;
                        if (http_1.status === 200 || http_1.status === 0) resolve(http_1.response);
                        else reject('Warning: could not load an image to parse its orientation');
                    };
                    http_1.onprogress = function() {
                        // Abort the request directly if it not a JPEG image for better performance
                        if (http_1.getResponseHeader('content-type') !== 'image/jpeg') http_1.abort();
                    };
                    http_1.withCredentials = false;
                    http_1.open('GET', img, true);
                    http_1.responseType = 'arraybuffer';
                    http_1.send(null);
                }
            } else reject('Error: the image is empty');
        } catch (e) {
            reject(e);
        }
    });
}
function getStyleTransforms(transforms) {
    var _a = transforms.rotate, rotate = _a === void 0 ? 0 : _a, _b = transforms.flip, flip = _b === void 0 ? {
        horizontal: false,
        vertical: false
    } : _b, _c = transforms.scale, scale = _c === void 0 ? 1 : _c;
    return " rotate(" + rotate + "deg) scaleX(" + scale * (flip.horizontal ? -1 : 1) + ") scaleY(" + scale * (flip.vertical ? -1 : 1) + ")";
}
function getStringFromCharCode(dataView, start, length) {
    var str = '';
    var i;
    for(i = start, length += start; i < length; i++)str += String.fromCharCode(dataView.getUint8(i));
    return str;
}
function resetAndGetOrientation(arrayBuffer) {
    try {
        var dataView = new DataView(arrayBuffer);
        var orientation_1;
        var exifIDCode = void 0;
        var tiffOffset = void 0;
        var littleEndian = void 0;
        var app1Start = void 0;
        var ifdStart = void 0;
        // Only handle JPEG image (start by 0xFFD8)
        if (dataView.getUint8(0) === 0xff && dataView.getUint8(1) === 0xd8) {
            var length_1 = dataView.byteLength;
            var offset = 2;
            while(offset + 1 < length_1){
                if (dataView.getUint8(offset) === 0xff && dataView.getUint8(offset + 1) === 0xe1) {
                    app1Start = offset;
                    break;
                }
                offset++;
            }
        }
        if (app1Start) {
            exifIDCode = app1Start + 4;
            tiffOffset = app1Start + 10;
            if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
                var endianness = dataView.getUint16(tiffOffset);
                littleEndian = endianness === 0x4949;
                if (littleEndian || endianness === 0x4d4d /* bigEndian */ ) {
                    if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002a) {
                        var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                        if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                    }
                }
            }
        }
        if (ifdStart) {
            var length_2 = dataView.getUint16(ifdStart, littleEndian);
            for(var i = 0; i < length_2; i++){
                var offset = ifdStart + i * 12 + 2;
                if (dataView.getUint16(offset, littleEndian) === 0x0112 /* Orientation */ ) {
                    // 8 is the offset of the current tag's value
                    offset += 8;
                    // Get the original orientation value
                    orientation_1 = dataView.getUint16(offset, littleEndian);
                    // Override the orientation with its default value
                    dataView.setUint16(offset, 1, littleEndian);
                    break;
                }
            }
        }
        return orientation_1;
    } catch (error) {
        return null;
    }
}
function arrayBufferToDataURL(arrayBuffer) {
    var chunks = [];
    // Chunk Typed Array for better performance
    var chunkSize = 8192;
    var uint8 = new Uint8Array(arrayBuffer);
    while(uint8.length > 0){
        var value = uint8.subarray(0, chunkSize);
        chunks.push(String.fromCharCode.apply(null, Array.from ? Array.from(value) : value.slice()));
        uint8 = uint8.subarray(chunkSize);
    }
    return "data:image/jpeg;base64," + btoa(chunks.join(''));
}
function getImage(_a) {
    var src = _a.src, _b = _a.arrayBuffer, arrayBuffer = _b === void 0 ? null : _b, _c = _a.orientation, orientation = _c === void 0 ? null : _c;
    var options = {
        src: src,
        arrayBuffer: arrayBuffer,
        revoke: false,
        transforms: {
            flip: {
                horizontal: false,
                vertical: false
            },
            rotate: 0
        }
    };
    if (arrayBuffer && orientation && orientation > 1) {
        if (isBlob(src) || !isLocal(src)) {
            options.src = URL.createObjectURL(new Blob([
                arrayBuffer
            ]));
            options.revoke = true;
        } else options.src = arrayBufferToDataURL(arrayBuffer);
    } else options.src = src;
    if (orientation) options.transforms = getTransforms(orientation);
    return options;
}
function parseImage(src, settings) {
    if (settings === void 0) settings = {};
    var checkOrientation = settings.checkOrientation, parse = settings.parse;
    return new Promise(function(resolve) {
        if (checkOrientation || parse) getImageData(src).then(function(data) {
            var orientation = resetAndGetOrientation(data);
            resolve(getImage(data ? {
                src: src,
                arrayBuffer: data,
                orientation: orientation
            } : {
                src: src,
                arrayBuffer: null,
                orientation: null
            }));
        }).catch(function(error) {
            console.warn(error);
            resolve(getImage({
                src: src
            }));
        });
        else resolve(getImage({
            src: src
        }));
    });
}
function createImage(src, settings) {
    if (settings === void 0) settings = {};
    return new Promise(function(resolve, reject) {
        var image = document.createElement('img');
        if (settings.crossOrigin) image.crossOrigin = settings.crossOrigin !== true ? settings.crossOrigin : 'anonymous';
        image.src = src;
        image.style.visibility = 'hidden';
        image.style.position = 'fixed';
        document.body.appendChild(image);
        if (image.complete) {
            resolve(image);
            document.body.removeChild(image);
        } else {
            image.addEventListener('load', function() {
                resolve(image);
                document.body.removeChild(image);
            });
            image.addEventListener('error', function() {
                reject(null);
                document.body.removeChild(image);
            });
        }
    });
}
function loadImage(src, settings) {
    if (settings === void 0) settings = {};
    return parseImage(src, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, settings), {
        crossOrigin: isCrossOriginURL(src) && settings.crossOrigin
    })).then(function(options) {
        return new Promise(function(resolve, reject) {
            createImage(options.src, settings).then(function(image) {
                resolve((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
                    width: image.naturalWidth,
                    height: image.naturalHeight
                }));
            }).catch(function() {
                reject(null);
            });
        });
    });
}
function getImageStyle(image, state, area, coefficient, transitions) {
    if (transitions === void 0) transitions = null;
    var optimalImageSize = image.width > image.height ? {
        width: Math.min(512, image.width),
        height: Math.min(512, image.width) / (image.width / image.height)
    } : {
        height: Math.min(512, image.height),
        width: Math.min(512, image.height) * (image.width / image.height)
    };
    var actualImageSize = getTransformedImageSize(state);
    var imageTransforms = {
        rotate: state.transforms.rotate,
        flip: {
            horizontal: state.transforms.flip.horizontal,
            vertical: state.transforms.flip.vertical
        },
        translateX: area.left / coefficient,
        translateY: area.top / coefficient,
        scale: 1 / coefficient
    };
    var compensations = {
        rotate: {
            left: (optimalImageSize.width - actualImageSize.width) / (2 * coefficient),
            top: (optimalImageSize.height - actualImageSize.height) / (2 * coefficient)
        },
        scale: {
            left: (1 - 1 / coefficient) * optimalImageSize.width / 2,
            top: (1 - 1 / coefficient) * optimalImageSize.height / 2
        }
    };
    var transforms = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, imageTransforms), {
        scale: imageTransforms.scale * (image.width / optimalImageSize.width)
    });
    var result = {
        width: optimalImageSize.width + "px",
        height: optimalImageSize.height + "px",
        left: '0px',
        top: '0px',
        transition: 'none',
        transform: "translate3d(" + (-compensations.rotate.left - compensations.scale.left - imageTransforms.translateX) + "px, " + (-compensations.rotate.top - compensations.scale.top - imageTransforms.translateY) + "px, 0px)" + getStyleTransforms(transforms),
        willChange: 'none'
    };
    if (transitions && transitions.active) {
        result.willChange = 'transform';
        result.transition = transitions.duration + "ms " + transitions.timingFunction;
    }
    return result;
}
function getBackgroundStyle(image, state, transitions) {
    if (transitions === void 0) transitions = null;
    if (image && state && state.visibleArea) return getImageStyle(image, state, state.visibleArea, getCoefficient(state), transitions);
    else return {};
}
function getPreviewStyle(image, state, size, transitions) {
    if (transitions === void 0) transitions = null;
    if (image && state && state.visibleArea && state.coordinates) return getImageStyle(image, state, state.coordinates, ratio(state.coordinates) > ratio(size) ? state.coordinates.width / size.width : state.coordinates.height / size.height, transitions);
    else return {};
}
function hybridStencilAutoZoomAlgorithm(state, settings) {
    if (isInitializedState(state)) {
        var result = copyState(state);
        // Checks that coordinates has the same ratio that coordinates:
        var stencil = {
            width: 0,
            height: 0
        };
        if (ratio(result.boundary) > ratio(result.coordinates)) {
            stencil.height = result.boundary.height * 0.8;
            stencil.width = stencil.height * ratio(result.coordinates);
        } else {
            stencil.width = result.boundary.width * 0.8;
            stencil.height = stencil.width * ratio(result.coordinates);
        }
        // First of all try to resize visible area as much as possible:
        result.visibleArea = applyScale(result.visibleArea, result.coordinates.width * result.boundary.width / (result.visibleArea.width * stencil.width));
        // Check that visible area doesn't break the area restrictions:
        var scale = fitToSizeRestrictions(result.visibleArea, getAreaSizeRestrictions(result, settings));
        result.visibleArea = applyScale(result.visibleArea, scale);
        if (scale !== 1) {
            stencil.height /= scale;
            stencil.width /= scale;
        }
        result.visibleArea = applyMove(result.visibleArea, diff(getCenter(result.coordinates), getCenter(result.visibleArea)));
        // Center stencil in visible area:
        result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
        result.coordinates = moveToPositionRestrictions(result.coordinates, mergePositionRestrictions(coordinatesToPositionRestrictions(result.visibleArea), getPositionRestrictions(result, settings)));
        return result;
    }
    return state;
}
function hybridStencilAutoZoom(state, settings, action) {
    if (action.immediately) return hybridStencilAutoZoomAlgorithm(state, settings);
    return state;
}
function deprecationWarning(text) {}
function useDeprecationWarning() {
    var fired = (0, $acw62.useRef)([]);
    return function(message) {
        if (fired.current.indexOf(message) === -1) {
            deprecationWarning(message);
            fired.current.push(message);
        }
    };
}
function createCropper(render) {
    return (0, $acw62.forwardRef)(render);
}
function useFirstMountState() {
    var isFirst = (0, $acw62.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
var useUpdateEffect = function(effect, deps) {
    var isFirstMount = useFirstMountState();
    (0, $acw62.useEffect)(function() {
        if (!isFirstMount) return effect();
    }, deps);
};
function useStateWithCallback(initialState) {
    var _a = (0, $7WQrb.__read)((0, $acw62.useState)(initialState), 2), state = _a[0], setState = _a[1];
    var _b = (0, $7WQrb.__read)((0, $acw62.useState)(null), 2), callback = _b[0], setCallback = _b[1];
    var previousState = (0, $acw62.useRef)(initialState);
    useUpdateEffect(function() {
        if (callback) callback(state, previousState.current);
    }, [
        callback
    ]);
    return [
        state,
        function(value, callback) {
            previousState.current = state;
            setState(value);
            setCallback(function() {
                return callback;
            });
        }
    ];
}
var CropperInstance = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(CropperInstance, _super);
    function CropperInstance(props, onChange) {
        var _this = _super.call(this) || this;
        _this.props = props;
        _this.notify = onChange;
        _this.data = {
            state: null,
            transitions: false,
            interactions: getEmptyInteractions()
        };
        return _this;
    }
    CropperInstance.prototype.getProps = function() {
        return this.props();
    };
    CropperInstance.prototype.setData = function(data) {
        this.data = data;
        this.notify();
    };
    CropperInstance.prototype.getData = function() {
        return this.data;
    };
    return CropperInstance;
}(AbstractCropperInstance);
function useForceRerender() {
    var _a = (0, $7WQrb.__read)((0, $acw62.useState)({}), 2);
    _a[0];
    var setTick = _a[1];
    return function() {
        setTick({});
    };
}
function usePersistentFunction(props) {
    var propsRef = (0, $acw62.useRef)(props);
    propsRef.current = props;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return propsRef.current.apply(propsRef, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(args), false));
    };
}
function useCropperInstance(props) {
    var rerender = useForceRerender();
    var getProps = usePersistentFunction(function() {
        var _a = props(), settings = _a.settings, parameters = (0, $7WQrb.__rest)(_a, [
            "settings"
        ]);
        var extendedSettings = (0, $7WQrb.__assign)({
            imageRestriction: ImageRestriction.fitArea,
            transformImage: {
                adjustStencil: true
            }
        }, settings);
        var extendedParameters = (0, $7WQrb.__assign)({
            transitions: true
        }, parameters);
        return (0, $7WQrb.__assign)({
            settings: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, extendedSettings), createDefaultSettings(extendedSettings))
        }, extendedParameters);
    });
    var cropper = (0, $acw62.useRef)(new CropperInstance(getProps, rerender));
    return cropper.current;
}
function useCropperImage(options) {
    var src = options.src, onLoadingStart = options.onLoadingStart, onLoadingEnd = options.onLoadingEnd, onError = options.onError, onLoad = options.onLoad, crossOrigin = options.crossOrigin, checkOrientation = options.checkOrientation, canvas = options.canvas, unloadTime = options.unloadTime;
    var _a = (0, $7WQrb.__read)((0, $acw62.useState)(false), 2), loading = _a[0], setLoading = _a[1];
    var _b = (0, $7WQrb.__read)((0, $acw62.useState)(false), 2), loaded = _b[0], setLoaded = _b[1];
    var _c = (0, $7WQrb.__read)((0, $acw62.useState)(null), 2), image = _c[0], setImage = _c[1];
    var currentSrc = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(function() {
        if (currentSrc.current !== src) {
            currentSrc.current = src || null;
            setLoaded(false);
            if (src) {
                setLoading(true);
                onLoadingStart === null || onLoadingStart === void 0 || onLoadingStart();
                var promises = [
                    loadImage(src, {
                        crossOrigin: isUndefined(crossOrigin) ? canvas : crossOrigin,
                        checkOrientation: checkOrientation
                    })
                ];
                if (loaded && unloadTime) promises.push(promiseTimeout(unloadTime));
                Promise.all(promises).then(function(responses) {
                    var _a = (0, $7WQrb.__read)(responses, 1), image = _a[0];
                    if (currentSrc.current === src) {
                        setImage(image);
                        onLoad === null || onLoad === void 0 || onLoad(image);
                    }
                }).catch(function() {
                    if (currentSrc.current === src) onError === null || onError === void 0 || onError();
                }).finally(function() {
                    if (currentSrc.current === src) {
                        onLoadingEnd === null || onLoadingEnd === void 0 || onLoadingEnd();
                        setLoading(false);
                    }
                });
            } else if (unloadTime) promiseTimeout(unloadTime).then(function() {
                if (currentSrc.current === src) setImage(null);
            });
            else setImage(null);
        }
    }, [
        src
    ]);
    (0, $acw62.useEffect)(function() {
        if (image) setLoaded(true);
    }, [
        image
    ]);
    return {
        isLoading: function() {
            return loading;
        },
        isLoaded: function() {
            return loaded;
        },
        getImage: function() {
            return image;
        },
        setImage: setImage
    };
}
var useWindowResize = function(callback) {
    var callbackRef = (0, $acw62.useRef)(callback);
    var internalCallback = function() {
        if (callbackRef.current) callbackRef.current();
    };
    (0, $acw62.useEffect)(function() {
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $acw62.useEffect)(function() {
        window.addEventListener('resize', internalCallback);
        window.addEventListener('orientationchange', internalCallback);
        return function() {
            window.removeEventListener('resize', internalCallback);
            window.removeEventListener('orientationchange', internalCallback);
        };
    }, []);
};
function useCropperAutoReconcile(cropper, enabled) {
    if (enabled === void 0) enabled = true;
    var _a = (0, $7WQrb.__read)((0, $acw62.useState)(enabled), 2), active = _a[0], setActive = _a[1];
    (0, $acw62.useLayoutEffect)(function() {
        if (active && !cropper.hasInteractions()) cropper.reconcileState();
    });
    return {
        pause: function() {
            setActive(false);
        },
        resume: function() {
            setActive(true);
        }
    };
}
function useAbstractCropper(props) {
    var _this = this;
    var _a = props(), src = _a.src, onReady = _a.onReady, onError = _a.onError, onUpdate = _a.onUpdate, _b = _a.canvas, canvas = _b === void 0 ? true : _b, _c = _a.unloadTime, unloadTime = _c === void 0 ? 500 : _c, _d = _a.crossOrigin, crossOrigin = _d === void 0 ? true : _d, _e = _a.checkOrientation, checkOrientation = _e === void 0 ? true : _e, _f = _a.autoReconcileState, autoReconcileState = _f === void 0 ? true : _f;
    var imageRef = (0, $acw62.useRef)(null);
    var boundaryRef = (0, $acw62.useRef)(null);
    var canvasRef = (0, $acw62.useRef)(null);
    var cropperRef = (0, $acw62.useRef)(null);
    var _g = (0, $7WQrb.__read)(useStateWithCallback(null), 2), currentImage = _g[0], setCurrentImage = _g[1];
    var cropper = useCropperInstance(function() {
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, props()), {
            getInstance: function() {
                return cropperRef.current;
            }
        });
    });
    var cropperImage = useCropperImage({
        src: src,
        crossOrigin: crossOrigin,
        checkOrientation: checkOrientation,
        unloadTime: unloadTime,
        canvas: canvas,
        onLoad: function() {
            if (cropperRef.current) onReady === null || onReady === void 0 || onReady(cropperRef.current);
        },
        onError: function() {
            if (cropperRef.current) onError === null || onError === void 0 || onError(cropperRef.current);
        }
    });
    var autoReconcile = useCropperAutoReconcile(cropper, autoReconcileState);
    var resetCropper = function() {
        return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
            var image_1, boundary_1;
            var _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!boundaryRef.current) return [
                            3 /*break*/ ,
                            2
                        ];
                        autoReconcile.pause();
                        image_1 = cropperImage.getImage();
                        return [
                            4 /*yield*/ ,
                            (_a = boundaryRef.current) === null || _a === void 0 ? void 0 : _a.stretchTo(image_1)
                        ];
                    case 1:
                        boundary_1 = _b.sent();
                        setCurrentImage(image_1, function() {
                            if (boundary_1 && image_1) cropper.reset(boundary_1, image_1);
                            else cropper.clear();
                        });
                        autoReconcile.resume();
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var refreshCropper = function() {
        return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
            var image, boundary, state;
            var _a;
            return (0, $7WQrb.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!boundaryRef.current) return [
                            3 /*break*/ ,
                            2
                        ];
                        autoReconcile.pause();
                        image = cropperImage.getImage();
                        return [
                            4 /*yield*/ ,
                            (_a = boundaryRef.current) === null || _a === void 0 ? void 0 : _a.stretchTo(image)
                        ];
                    case 1:
                        boundary = _b.sent();
                        if (boundary && image) {
                            state = cropper.getState();
                            if (state) {
                                if (boundary.width !== state.boundary.width || boundary.height !== state.boundary.height) {
                                    cropper.setBoundary(boundary);
                                    // It's important because, probably, after the boundary reset
                                    // the cropper can meet some restrictions that were broken before
                                    cropper.reconcileState();
                                }
                            } else cropper.reset(boundary, image);
                        } else cropper.clear();
                        autoReconcile.resume();
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var cropperInterface = {
        reset: function() {
            return resetCropper();
        },
        refresh: function() {
            return refreshCropper();
        },
        setImage: function(image) {
            return setCurrentImage(image);
        },
        reconcileState: cropper.reconcileState,
        moveCoordinates: cropper.moveCoordinates,
        moveCoordinatesEnd: cropper.moveCoordinatesEnd,
        resizeCoordinates: cropper.resizeCoordinates,
        clear: cropper.clear,
        resizeCoordinatesEnd: cropper.resizeCoordinatesEnd,
        moveImage: cropper.moveImage,
        flipImage: cropper.flipImage,
        zoomImage: cropper.zoomImage,
        rotateImage: cropper.rotateImage,
        transformImage: cropper.transformImage,
        transformImageEnd: cropper.transformImageEnd,
        setCoordinates: cropper.setCoordinates,
        setVisibleArea: cropper.setVisibleArea,
        startTransitions: cropper.startTransitions,
        setState: cropper.setState,
        hasInteractions: cropper.hasInteractions,
        getStencilCoordinates: cropper.getStencilCoordinates,
        getCoordinates: cropper.getCoordinates,
        getVisibleArea: cropper.getVisibleArea,
        getTransforms: cropper.getTransforms,
        getTransitions: cropper.getTransitions,
        getInteractions: cropper.getInteractions,
        getSettings: cropper.getSettings,
        getState: cropper.getState,
        getDefaultState: function() {
            var state = cropper.getState();
            var image = cropperImage.getImage();
            if (state && image) return cropper.createDefaultState(state.boundary, image);
            else return null;
        },
        getCanvas: function(options) {
            var state = cropper.getState();
            if (imageRef.current && canvasRef.current && state) return canvasRef.current.draw(state, imageRef.current, options);
            else return null;
        },
        getImage: function() {
            return currentImage ? (0, $7WQrb.__assign)({}, currentImage) : null;
        },
        isLoading: cropperImage.isLoading,
        isLoaded: cropperImage.isLoaded
    };
    useWindowResize(function() {
        refreshCropper();
    });
    useUpdateEffect(function() {
        resetCropper();
    }, [
        cropperImage.getImage()
    ]);
    useUpdateEffect(function() {
        if (cropperRef.current) onUpdate === null || onUpdate === void 0 || onUpdate(cropperRef.current);
    }, [
        cropperImage.isLoaded(),
        cropperImage.isLoading()
    ]);
    (0, $acw62.useImperativeHandle)(cropperRef, function() {
        return cropperInterface;
    });
    return {
        cropper: cropperInterface,
        refs: {
            image: imageRef,
            boundary: boundaryRef,
            canvas: canvasRef
        },
        image: currentImage
    };
}
var StretchableBoundary = (0, $acw62.forwardRef)(function(_a, ref) {
    var className = _a.className, style = _a.style, stretcherClassName = _a.stretcherClassName, contentClassName = _a.contentClassName, _b = _a.stretchAlgorithm, stretchAlgorithm = _b === void 0 ? stretchCropperBoundary : _b, _c = _a.sizeAlgorithm, sizeAlgorithm = _c === void 0 ? fillBoundary : _c, children = _a.children;
    var stretcherRef = (0, $acw62.useRef)(null);
    var boundaryRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            reset: function() {
                var stretcher = stretcherRef.current;
                if (stretcher) {
                    stretcher.style.height = '';
                    stretcher.style.width = '';
                }
            },
            stretchTo: function(size) {
                var stretcher = stretcherRef.current;
                var boundary = boundaryRef.current;
                if ((size === null || size === void 0 ? void 0 : size.width) && (size === null || size === void 0 ? void 0 : size.height) && stretcher && boundary) {
                    stretchAlgorithm(boundary, stretcher, size);
                    var result = sizeAlgorithm(boundary, size);
                    return Promise.resolve(result.width && result.height ? result : null);
                } else {
                    if (stretcher) {
                        stretcher.style.height = '';
                        stretcher.style.width = '';
                    }
                    return Promise.resolve(null);
                }
            }
        };
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: boundaryRef,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-boundary', className)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: stretcherRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))([
            'advanced-cropper-boundary__stretcher',
            stretcherClassName
        ])
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))([
            'advanced-cropper-boundary__content',
            contentClassName
        ])
    }, children));
});
StretchableBoundary.displayName = 'StretchableBoundary';
var CropperFade = function(_a) {
    var visible = _a.visible, className = _a.className, style = _a.style, children = _a.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, 'advanced-cropper-fade', Boolean(visible) && 'advanced-cropper-fade--visible')
    }, children);
};
var CropperWrapper = function(_a) {
    var cropper = _a.cropper, children = _a.children, className = _a.className, style = _a.style;
    var state = cropper ? cropper.getState() : null;
    var loaded = cropper ? cropper.isLoaded() : false;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, 'advanced-cropper-wrapper'),
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CropperFade, {
        visible: state && loaded,
        className: 'advanced-cropper-wrapper__fade'
    }, children));
};
function preventDefault(e) {
    e.preventDefault();
}
var CropperBackgroundImage = (0, $acw62.forwardRef)(function(_a, ref) {
    var className = _a.className, style = _a.style, cropper = _a.cropper, _b = _a.crossOrigin, crossOrigin = _b === void 0 ? true : _b;
    var state = cropper.getState();
    var transitions = cropper.getTransitions();
    var image = cropper.getImage();
    var transformStyles = image && state ? getBackgroundStyle(image, state, transitions) : {};
    var src = image ? image.src : undefined;
    return src ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        key: src,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-background-image', className),
        src: src,
        crossOrigin: crossOrigin === true ? 'anonymous' : crossOrigin || undefined,
        style: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, transformStyles), style),
        onMouseDown: preventDefault
    }) : null;
});
CropperBackgroundImage.displayName = 'CropperBackgroundImage';
var CropperCanvas = (0, $acw62.forwardRef)(function(_, ref) {
    var canvasRef = (0, $acw62.useRef)(null);
    var spareCanvasRef = (0, $acw62.useRef)(null);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            draw: function(state, image, options) {
                if (options === void 0) options = {};
                if (image && canvasRef.current && spareCanvasRef.current) return drawCroppedArea(state, image, canvasRef.current, spareCanvasRef.current, options);
                else return null;
            }
        };
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", {
        className: "advanced-cropper-canvas",
        ref: canvasRef
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("canvas", {
        className: "advanced-cropper-canvas",
        ref: spareCanvasRef
    }));
});
CropperCanvas.displayName = 'CropperCanvas';
var DraggableElement = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(DraggableElement, _super);
    function DraggableElement(props) {
        var _this = _super.call(this, props) || this;
        _this.processMove = function(e, newTouches) {
            var _a;
            var container = _this.container.current;
            if (container && _this.touches.length) {
                var _b = container.getBoundingClientRect(), left = _b.left, top_1 = _b.top;
                if (_this.touches.length === 1 && newTouches.length === 1) {
                    if (_this.props.onMove) {
                        var movingToAnchor = {
                            left: Math.abs(newTouches[0].clientX - _this.anchor.left - left) < Math.abs(_this.touches[0].clientX - _this.anchor.left - left),
                            top: Math.abs(newTouches[0].clientY - _this.anchor.top - top_1) < Math.abs(_this.touches[0].clientY - _this.anchor.top - top_1)
                        };
                        var direction = {
                            left: 0,
                            top: 0
                        };
                        if (!_this.props.useAnchor || !movingToAnchor.left) direction.left = newTouches[0].clientX - _this.touches[0].clientX;
                        if (!_this.props.useAnchor || !movingToAnchor.top) direction.top = newTouches[0].clientY - _this.touches[0].clientY;
                        (_a = _this.props) === null || _a === void 0 || _a.onMove(direction, e);
                        _this.touches = (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(newTouches), false);
                    }
                }
            }
        };
        _this.processEnd = function() {
            var _a = _this.props, onMoveEnd = _a.onMoveEnd, onLeave = _a.onLeave;
            if (!_this.props.disabled && _this.touches.length) onMoveEnd === null || onMoveEnd === void 0 || onMoveEnd();
            if (_this.hovered) {
                onLeave === null || onLeave === void 0 || onLeave();
                _this.hovered = false;
            }
            _this.touches = [];
        };
        _this.initAnchor = function(touch) {
            var container = _this.container.current;
            if (container) {
                var _a = container.getBoundingClientRect(), left = _a.left, top_2 = _a.top;
                _this.anchor = {
                    left: touch.clientX - left,
                    top: touch.clientY - top_2
                };
            }
        };
        _this.onMouseOver = function() {
            var _a = _this.props, onEnter = _a.onEnter, disabled = _a.disabled;
            if (!_this.hovered && !disabled) {
                _this.hovered = true;
                onEnter === null || onEnter === void 0 || onEnter();
            }
        };
        _this.onMouseLeave = function() {
            var onLeave = _this.props.onLeave;
            if (_this.hovered && !_this.touches.length) {
                _this.hovered = false;
                onLeave === null || onLeave === void 0 || onLeave();
            }
        };
        _this.onTouchStart = function(e) {
            var _a = _this.props, onEnter = _a.onEnter, onMoveStart = _a.onMoveStart, disabled = _a.disabled;
            if (e.cancelable) {
                _this.touches = Array.from(e.touches);
                var shouldStartMove = !disabled && e.touches.length === 1;
                if (shouldStartMove) {
                    _this.touches = Array.from(e.touches);
                    onMoveStart === null || onMoveStart === void 0 || onMoveStart();
                }
                if (!_this.hovered && !disabled) {
                    _this.hovered = true;
                    onEnter === null || onEnter === void 0 || onEnter();
                }
                if (_this.started || shouldStartMove) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }
        };
        _this.onTouchEnd = function() {
            _this.started = false;
            _this.processEnd();
        };
        _this.onTouchMove = function(e) {
            if (_this.touches.length >= 1) {
                if (_this.started) {
                    _this.processMove(e, Array.from(e.touches));
                    e.preventDefault();
                    e.stopPropagation();
                } else if (distance({
                    left: _this.touches[0].clientX,
                    top: _this.touches[0].clientY
                }, {
                    left: e.touches[0].clientX,
                    top: e.touches[0].clientY
                }) > (_this.props.activationDistance || 0)) {
                    _this.initAnchor({
                        clientX: e.touches[0].clientX,
                        clientY: e.touches[0].clientY
                    });
                    _this.started = true;
                }
            }
        };
        _this.onMouseDown = function(e) {
            var _a = _this.props, onMoveStart = _a.onMoveStart, disabled = _a.disabled;
            if (!disabled && e.button === 0) {
                var touch = {
                    clientX: e.clientX,
                    clientY: e.clientY
                };
                _this.touches = [
                    touch
                ];
                _this.initAnchor(touch);
                e.stopPropagation();
                onMoveStart === null || onMoveStart === void 0 || onMoveStart();
            }
        };
        _this.onMouseMove = function(e) {
            if (!_this.props.disabled && _this.touches.length) {
                _this.processMove(e, [
                    {
                        clientX: e.clientX,
                        clientY: e.clientY
                    }
                ]);
                if (e.preventDefault && e.cancelable) e.preventDefault();
                e.stopPropagation();
            }
        };
        _this.onMouseUp = function() {
            _this.processEnd();
        };
        _this.touches = [];
        _this.hovered = false;
        _this.started = false;
        _this.anchor = {
            left: 0,
            top: 0
        };
        _this.container = (0, $acw62.createRef)();
        return _this;
    }
    DraggableElement.prototype.componentWillUnmount = function() {
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('touchmove', this.onTouchMove);
        window.removeEventListener('touchend', this.onTouchEnd);
        var container = this.container.current;
        if (container) {
            container.removeEventListener('touchstart', this.onTouchStart);
            container.removeEventListener('mousedown', this.onMouseDown);
        }
    };
    DraggableElement.prototype.componentDidMount = function() {
        window.addEventListener('mouseup', this.onMouseUp, {
            passive: false
        });
        window.addEventListener('mousemove', this.onMouseMove, {
            passive: false
        });
        window.addEventListener('touchmove', this.onTouchMove, {
            passive: false
        });
        window.addEventListener('touchend', this.onTouchEnd, {
            passive: false
        });
        var container = this.container.current;
        if (container) {
            // Add event listeners here due to https://github.com/facebook/react/issues/9809#issuecomment-414072263
            container.addEventListener('touchstart', this.onTouchStart, {
                passive: false
            });
            container.addEventListener('mousedown', this.onMouseDown, {
                passive: false
            });
        }
    };
    DraggableElement.prototype.componentDidUpdate = function(prevProps) {
        if (this.props.disabled && !prevProps.disabled) this.touches = [];
    };
    DraggableElement.prototype.render = function() {
        var _a = this.props, children = _a.children, className = _a.className;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-draggable-element', className),
            ref: this.container,
            onMouseOver: this.onMouseOver,
            onMouseLeave: this.onMouseLeave
        }, children);
    };
    DraggableElement.defaultProps = {
        disabled: false,
        activationDistance: 30,
        useAnchor: true,
        rerender: true
    };
    return DraggableElement;
}((0, $acw62.Component));
var LineWrapper = function(_a) {
    var position = _a.position, className = _a.className, disabled = _a.disabled, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onLeave = _a.onLeave, onEnter = _a.onEnter, children = _a.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DraggableElement, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))([
            'advanced-cropper-line-wrapper',
            position && "advanced-cropper-line-wrapper--".concat(position),
            disabled && "advanced-cropper-line-wrapper--disabled",
            className
        ]),
        disabled: disabled,
        onMove: onDrag,
        onMoveEnd: onDragEnd,
        onLeave: onLeave,
        onEnter: onEnter,
        activationDistance: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))([
            'advanced-cropper-line-wrapper__content',
            position && "advanced-cropper-line-wrapper__content--".concat(position)
        ])
    }, children));
};
var SimpleLine = function(_a) {
    var _b, _c;
    var position = _a.position, hoverClassName = _a.hoverClassName, wrapperClassName = _a.wrapperClassName, defaultClassName = _a.defaultClassName, disabled = _a.disabled, onMove = _a.onMove, onMoveEnd = _a.onMoveEnd;
    var _d = (0, $7WQrb.__read)((0, $acw62.useState)(false), 2), hover = _d[0], setHover = _d[1];
    var onEnter = function() {
        setHover(true);
    };
    var onLeave = function() {
        setHover(false);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LineWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-simple-line-wrapper', wrapperClassName, (_b = {}, _b["advanced-cropper-simple-line-wrapper--".concat(position)] = !!position, _b)),
        position: position,
        disabled: disabled,
        onDrag: onMove,
        onDragEnd: onMoveEnd,
        onLeave: onLeave,
        onEnter: onEnter
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-simple-line', hover && 'advanced-cropper-simple-line--hover', defaultClassName, hover && hoverClassName, (_c = {}, _c["advanced-cropper-simple-line--".concat(position)] = !!position, _c))
    }));
};
var HandlerWrapper = function(_a) {
    var horizontalPosition = _a.horizontalPosition, verticalPosition = _a.verticalPosition, className = _a.className, disabled = _a.disabled, onDrag = _a.onDrag, onDragEnd = _a.onDragEnd, onLeave = _a.onLeave, onEnter = _a.onEnter, children = _a.children, style = _a.style;
    var position = horizontalPosition || verticalPosition ? getDirectionNames(horizontalPosition, verticalPosition).snakeCase : null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, 'advanced-cropper-handler-wrapper', position && "advanced-cropper-handler-wrapper--".concat(position), disabled && 'advanced-cropper-handler-wrapper--disabled')
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DraggableElement, {
        className: 'advanced-cropper-handler-wrapper__draggable',
        disabled: disabled,
        onMove: onDrag,
        onMoveEnd: onDragEnd,
        onLeave: onLeave,
        onEnter: onEnter,
        activationDistance: 0
    }, children));
};
var SimpleHandler = function(_a) {
    var _b;
    var verticalPosition = _a.verticalPosition, horizontalPosition = _a.horizontalPosition, hoverClassName = _a.hoverClassName, wrapperClassName = _a.wrapperClassName, defaultClassName = _a.defaultClassName, wrapperStyle = _a.wrapperStyle, disabled = _a.disabled, onMove = _a.onMove, onMoveEnd = _a.onMoveEnd;
    var _c = (0, $7WQrb.__read)((0, $acw62.useState)(false), 2), hover = _c[0], setHover = _c[1];
    var onEnter = function() {
        setHover(true);
    };
    var onLeave = function() {
        setHover(false);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(HandlerWrapper, {
        style: wrapperStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-simple-handler-wrapper', wrapperClassName, verticalPosition && "advanced-cropper-simple-handler-wrapper--".concat(verticalPosition), horizontalPosition && "advanced-cropper-simple-handler-wrapper--".concat(horizontalPosition), horizontalPosition && verticalPosition && "advanced-cropper-simple-handler-wrapper--".concat(horizontalPosition, "-").concat(verticalPosition), hover && 'advanced-cropper-simple-handler-wrapper--hover'),
        verticalPosition: verticalPosition,
        horizontalPosition: horizontalPosition,
        disabled: disabled,
        onDrag: onMove,
        onDragEnd: onMoveEnd,
        onLeave: onLeave,
        onEnter: onEnter
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-simple-handler', hover && 'advanced-cropper-simple-handler--hover', defaultClassName, hover && hoverClassName, (_b = {}, _b["advanced-cropper-simple-handler--".concat(verticalPosition)] = !!verticalPosition, _b["advanced-cropper-simple-handler--".concat(horizontalPosition)] = !!horizontalPosition, _b["advanced-cropper-simple-handler--".concat(horizontalPosition, "-").concat(verticalPosition)] = horizontalPosition && verticalPosition, _b))
    }));
};
var HORIZONTAL_DIRECTIONS = [
    'east',
    'west',
    null
];
var VERTICAL_DIRECTIONS = [
    'south',
    'north',
    null
];
var BoundingBox = function(_a) {
    var style = _a.style, className = _a.className, children = _a.children, onResize = _a.onResize, onResizeEnd = _a.onResizeEnd, _b = _a.handlerComponent, handlerComponent = _b === void 0 ? SimpleHandler : _b, _c = _a.handlers, handlers = _c === void 0 ? {
        eastNorth: true,
        north: true,
        westNorth: true,
        west: true,
        westSouth: true,
        south: true,
        eastSouth: true,
        east: true
    } : _c, _d = _a.handlerClassNames, handlerClassNames = _d === void 0 ? {} : _d, _e = _a.handlerWrapperClassNames, handlerWrapperClassNames = _e === void 0 ? {} : _e, _f = _a.lines, lines = _f === void 0 ? {
        west: true,
        north: true,
        east: true,
        south: true
    } : _f, _g = _a.lineComponent, lineComponent = _g === void 0 ? SimpleLine : _g, _h = _a.lineClassNames, lineClassNames = _h === void 0 ? {} : _h, _j = _a.lineWrapperClassNames, lineWrapperClassNames = _j === void 0 ? {} : _j, _k = _a.disabled, disabled = _k === void 0 ? false : _k, _l = _a.reference, reference = _l === void 0 ? null : _l;
    var _m = (0, $7WQrb.__read)((0, $acw62.useState)(null), 2), lastReference = _m[0], setLastReference = _m[1];
    var points = (0, $acw62.useMemo)(function() {
        var result = [];
        HORIZONTAL_DIRECTIONS.forEach(function(hDirection) {
            VERTICAL_DIRECTIONS.forEach(function(vDirection) {
                if (hDirection !== vDirection) {
                    var _a = getDirectionNames(hDirection, vDirection), snakeCase = _a.snakeCase, camelCase = _a.camelCase;
                    if (snakeCase && camelCase) result.push({
                        name: camelCase,
                        className: snakeCase,
                        verticalPosition: vDirection,
                        horizontalPosition: hDirection
                    });
                }
            });
        });
        return result;
    }, []);
    var lineNodes = (0, $acw62.useMemo)(function() {
        var result = [];
        points.forEach(function(point) {
            if (isCardinalDirection(point.name) && (isObject(lines) ? lines[point.name] : lines)) result.push({
                name: point.name,
                component: lineComponent,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(lineClassNames.default, lineClassNames[point.name], disabled && lineClassNames.disabled),
                wrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("advanced-cropper-bounding-box__line", "advanced-cropper-bounding-box__line--".concat(point.name), lineWrapperClassNames.default, lineWrapperClassNames[point.name], disabled && lineWrapperClassNames.disabled),
                hoverClassName: lineClassNames.hover,
                verticalPosition: point.verticalPosition,
                horizontalPosition: point.horizontalPosition,
                disabled: disabled
            });
        });
        return result;
    }, [
        points,
        lines,
        lineComponent,
        lineClassNames,
        lineWrapperClassNames,
        disabled
    ]);
    var handlerNodes = (0, $acw62.useMemo)(function() {
        var result = [];
        points.forEach(function(point) {
            if (isObject(handlers) ? handlers[point.name] : handlers) result.push({
                name: point.name,
                component: handlerComponent,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(handlerClassNames.default, handlerClassNames[point.name]),
                containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("advanced-cropper-bounding-box__handler-wrapper", "advanced-cropper-bounding-box__handler-wrapper--".concat(point.className)),
                wrapperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("advanced-cropper-bounding-box__handler", "advanced-cropper-bounding-box__handler--".concat(point.className), handlerWrapperClassNames.default, handlerWrapperClassNames[point.name]),
                hoverClassName: handlerClassNames.hover,
                verticalPosition: point.verticalPosition,
                horizontalPosition: point.horizontalPosition,
                disabled: disabled
            });
        });
        return result;
    }, [
        points,
        handlers,
        handlerComponent,
        handlerClassNames,
        handlerWrapperClassNames,
        disabled
    ]);
    var onHandlerMove = function(horizontalPosition, verticalPosition) {
        return function(_a, nativeEvent) {
            var left = _a.left, top = _a.top;
            var directions = {
                left: left,
                top: top
            };
            var respectDirection;
            if (!verticalPosition && horizontalPosition) respectDirection = 'width';
            else if (verticalPosition && !horizontalPosition) respectDirection = 'height';
            if (!disabled) {
                if (onResize) {
                    var anchor = getDirectionNames(horizontalPosition, verticalPosition).camelCase;
                    if (anchor) onResize(anchor, directions, {
                        reference: lastReference || reference,
                        preserveAspectRatio: nativeEvent && nativeEvent.shiftKey,
                        respectDirection: respectDirection,
                        compensate: true
                    });
                }
                if (!lastReference) setLastReference(reference);
            }
        };
    };
    var onHandlerMoveEnd = function() {
        onResizeEnd === null || onResizeEnd === void 0 || onResizeEnd();
        setLastReference(null);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-bounding-box', className),
        style: style
    }, children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, lineNodes.map(function(line) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(line.component, {
            key: line.name,
            defaultClassName: line.className,
            hoverClassName: line.hoverClassName,
            wrapperClassName: line.wrapperClassName,
            position: line.name,
            disabled: line.disabled,
            onMove: onHandlerMove(line.horizontalPosition, line.verticalPosition),
            onMoveEnd: onHandlerMoveEnd
        });
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, handlerNodes.map(function(handler) {
        var handlerElement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(handler.component, {
            defaultClassName: handler.className,
            hoverClassName: handler.hoverClassName,
            wrapperClassName: handler.wrapperClassName,
            horizontalPosition: handler.horizontalPosition,
            verticalPosition: handler.verticalPosition,
            disabled: handler.disabled,
            onMove: onHandlerMove(handler.horizontalPosition, handler.verticalPosition),
            onMoveEnd: onHandlerMoveEnd
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: handler.name,
            className: handler.containerClassName
        }, handlerElement);
    })));
};
var StencilOverlay = function(_a) {
    var className = _a.className, children = _a.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-stencil-overlay', className)
    }, children);
};
function useTransition(transitions) {
    if (transitions === void 0) transitions = null;
    var animation = (0, $acw62.useRef)(new Animation());
    var _a = (0, $7WQrb.__read)((0, $acw62.useState)(false), 2), active = _a[0], setActive = _a[1];
    return [
        function(callback) {
            if (transitions && transitions.active) animation.current.start((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, transitions), {
                onStart: function() {
                    setActive(true);
                },
                onProgress: function(progress) {
                    callback(progress);
                },
                onStop: function() {
                    setActive(false);
                }
            }));
            else if (!animation.current.active) callback(1);
        },
        active
    ];
}
var ArtificialTransition = function(_a) {
    var className = _a.className, transitions = _a.transitions, children = _a.children, values = (0, $7WQrb.__rest)(_a, [
        "className",
        "transitions",
        "children"
    ]);
    var root = (0, $acw62.useRef)(null);
    var transitionValues = (0, $acw62.useRef)(values);
    var _b = (0, $7WQrb.__read)((0, $acw62.useState)(values), 2), rememberedValues = _b[0], setRememberedValues = _b[1];
    var _c = (0, $7WQrb.__read)(useTransition(transitions), 2), runTransitions = _c[0], transitionsActive = _c[1];
    (0, $acw62.useLayoutEffect)(function() {
        if (!deepCompare(rememberedValues, values)) {
            setRememberedValues(values);
            var startValues_1 = transitionsActive ? (0, $7WQrb.__assign)({}, transitionValues.current) : rememberedValues;
            runTransitions(function(progress) {
                var properties = [
                    'left',
                    'top',
                    'height',
                    'width'
                ];
                properties.forEach(function(property) {
                    var desiredValue = values[property];
                    var startValue = startValues_1[property];
                    transitionValues.current[property] = isNumber(startValue) && isNumber(desiredValue) ? startValue + (desiredValue - startValue) * progress : desiredValue;
                });
                if (root.current) {
                    root.current.style.width = "".concat(transitionValues.current.width, "px");
                    root.current.style.height = "".concat(transitionValues.current.height, "px");
                    root.current.style.transform = "translate3d(".concat(transitionValues.current.left, "px, ").concat(transitionValues.current.top, "px, 0px)");
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        rememberedValues,
        transitionsActive,
        values.width,
        values.height,
        values.top,
        values.left
    ]);
    var currentValues = transitionsActive ? transitionValues.current : values;
    var rootStyle = {
        left: 0,
        top: 0,
        width: "".concat(currentValues.width, "px"),
        height: "".concat(currentValues.height, "px"),
        transform: "translate3d(".concat(currentValues.left, "px, ").concat(currentValues.top, "px, 0px)")
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: root,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-artificial-transition', className),
        style: rootStyle
    }, children);
};
var StencilWrapper = function(_a) {
    var className = _a.className, transitions = _a.transitions, width = _a.width, height = _a.height, left = _a.left, top = _a.top, children = _a.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ArtificialTransition, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-stencil-wrapper', className),
        transitions: transitions,
        width: width,
        height: height,
        top: top,
        left: left
    }, children);
};
var StencilGrid = function(_a) {
    var _b = _a.columns, columns = _b === void 0 ? 3 : _b, _c = _a.rows, rows = _c === void 0 ? 3 : _c, _d = _a.visible, visible = _d === void 0 ? false : _d, className = _a.className;
    var nodes = [];
    var _e = (0, $7WQrb.__read)((0, $acw62.useState)(columns), 2), currentColumns = _e[0], setCurrentColumns = _e[1];
    var _f = (0, $7WQrb.__read)((0, $acw62.useState)(rows), 2), currentRows = _f[0], setCurrentRows = _f[1];
    useUpdateEffect(function() {
        if (visible) {
            setCurrentRows(rows);
            setCurrentColumns(columns);
        }
    }, [
        visible,
        columns,
        rows
    ]);
    for(var i = 0; i < currentRows; i++){
        var cells = [];
        for(var j = 0; j < currentColumns; j++)cells.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: j,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-stencil-grid__cell', i === 0 && 'advanced-cropper-stencil-grid__cell--top', i === currentRows - 1 && 'advanced-cropper-stencil-grid__cell--bottom', j === 0 && 'advanced-cropper-stencil-grid__cell--left', j === currentColumns - 1 && 'advanced-cropper-stencil-grid__cell--right')
        }));
        nodes.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            className: 'advanced-cropper-stencil-grid__row'
        }, cells));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-stencil-grid', visible && 'advanced-cropper-stencil-grid--visible', className)
    }, nodes);
};
var RectangleStencil = (0, $acw62.forwardRef)(function(_a, ref) {
    var cropper = _a.cropper, coordinates = _a.coordinates, aspectRatio = _a.aspectRatio, minAspectRatio = _a.minAspectRatio, maxAspectRatio = _a.maxAspectRatio, _b = _a.handlerComponent, handlerComponent = _b === void 0 ? SimpleHandler : _b, _c = _a.handlers, handlers = _c === void 0 ? {
        eastNorth: true,
        north: true,
        westNorth: true,
        west: true,
        westSouth: true,
        south: true,
        eastSouth: true,
        east: true
    } : _c, _d = _a.handlerClassNames, handlerClassNames = _d === void 0 ? {} : _d, _e = _a.handlerWrapperClassNames, handlerWrapperClassNames = _e === void 0 ? {} : _e, _f = _a.lines, lines = _f === void 0 ? {
        west: true,
        north: true,
        east: true,
        south: true
    } : _f, _g = _a.lineComponent, lineComponent = _g === void 0 ? SimpleLine : _g, _h = _a.lineClassNames, lineClassNames = _h === void 0 ? {} : _h, _j = _a.lineWrapperClassNames, lineWrapperClassNames = _j === void 0 ? {} : _j, _k = _a.resizable, resizable = _k === void 0 ? true : _k, _l = _a.movable, movable = _l === void 0 ? true : _l, grid = _a.grid, gridClassName = _a.gridClassName, className = _a.className, movingClassName = _a.movingClassName, resizingClassName = _a.resizingClassName, previewClassName = _a.previewClassName, boundingBoxClassName = _a.boundingBoxClassName, overlayClassName = _a.overlayClassName, draggableAreaClassName = _a.draggableAreaClassName;
    var state = cropper.getState();
    var transitions = cropper.getTransitions();
    var interactions = cropper.getInteractions();
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            aspectRatio: createAspectRatio(aspectRatio || {
                minimum: minAspectRatio,
                maximum: maxAspectRatio
            })
        };
    });
    var onMove = function(directions) {
        if (cropper && movable) cropper.moveCoordinates(directions);
    };
    var onMoveEnd = function() {
        if (cropper) cropper.moveCoordinatesEnd();
    };
    var onResize = function(anchor, directions, options) {
        if (cropper && resizable) cropper.resizeCoordinates(anchor, directions, options);
    };
    var onResizeEnd = function() {
        if (cropper) cropper.resizeCoordinatesEnd();
    };
    var _m = coordinates ? isFunction(coordinates) ? coordinates(state) : coordinates : getStencilCoordinates(state), width = _m.width, height = _m.height, left = _m.left, top = _m.top;
    return state && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StencilWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-rectangle-stencil', className, interactions.moveCoordinates && movingClassName, interactions.resizeCoordinates && resizingClassName, {
            'advanced-cropper-rectangle-stencil--movable': movable,
            'advanced-cropper-rectangle-stencil--moving': interactions.moveCoordinates,
            'advanced-cropper-rectangle-stencil--resizable': resizable,
            'advanced-cropper-rectangle-stencil--resizing': interactions.resizeCoordinates
        }),
        width: width,
        height: height,
        left: left,
        top: top,
        transitions: transitions
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BoundingBox, {
        reference: state.coordinates,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(boundingBoxClassName, 'advanced-cropper-rectangle-stencil__bounding-box'),
        handlers: handlers,
        handlerComponent: handlerComponent,
        handlerClassNames: handlerClassNames,
        handlerWrapperClassNames: handlerWrapperClassNames,
        lines: lines,
        lineComponent: lineComponent,
        lineClassNames: lineClassNames,
        lineWrapperClassNames: lineWrapperClassNames,
        onResize: onResize,
        onResizeEnd: onResizeEnd,
        disabled: !resizable
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DraggableElement, {
        disabled: !movable,
        onMove: onMove,
        onMoveEnd: onMoveEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-rectangle-stencil__draggable-area', draggableAreaClassName)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StencilOverlay, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-rectangle-stencil__overlay', overlayClassName)
    }, grid && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StencilGrid, {
        visible: cropper.hasInteractions(),
        columns: interactions.transformImage.rotate ? 9 : 3,
        rows: interactions.transformImage.rotate ? 9 : 3,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-rectangle-stencil__grid', gridClassName)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-rectangle-stencil__preview', previewClassName)
    })))));
});
RectangleStencil.displayName = 'RectangleStencil';
function useRotateImageOptions(rotateImage) {
    return (0, $acw62.useMemo)(function() {
        return getOptions(rotateImage, {
            touch: true
        }, {
            touch: false
        });
    }, [
        rotateImage
    ]);
}
function useScaleImageOptions(scaleImage) {
    return (0, $acw62.useMemo)(function() {
        return getOptions(scaleImage, {
            touch: true,
            wheel: {
                ratio: 0.1
            }
        }, {
            touch: false,
            wheel: false
        });
    }, [
        scaleImage
    ]);
}
function useMoveImageOptions(moveImage) {
    return (0, $acw62.useMemo)(function() {
        return getOptions(moveImage, {
            touch: true,
            mouse: true
        }, {
            touch: false,
            mouse: false
        });
    }, [
        moveImage
    ]);
}
var TransformableImageEvent = /** @class */ function() {
    function TransformableImageEvent(_a) {
        var active = _a.active;
        this.active = active;
        this.defaultPrevented = false;
    }
    TransformableImageEvent.prototype.preventDefault = function() {
        this.defaultPrevented = true;
    };
    return TransformableImageEvent;
}();
var TransformableImage = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(TransformableImage, _super);
    function TransformableImage(props) {
        var _this = _super.call(this, props) || this;
        _this.processMove = function(newTouches) {
            var _a = _this.props, onTransform = _a.onTransform, touchScale = _a.touchScale, touchMove = _a.touchMove, touchRotate = _a.touchRotate;
            var container = _this.container.current;
            if (container && onTransform) {
                onTransform(touchesToImageTransform(newTouches, _this.touches, container, {
                    scale: touchScale,
                    rotate: touchRotate,
                    move: touchMove
                }));
                _this.touches = newTouches;
            }
        };
        _this.processEnd = function() {
            var onTransformEnd = _this.props.onTransformEnd;
            if (_this.transforming) {
                _this.transforming = false;
                if (onTransformEnd) onTransformEnd();
            }
        };
        _this.processStart = function() {
            _this.transforming = true;
            _this.debouncedProcessEnd.clear();
        };
        _this.processEvent = function(nativeEvent) {
            var _a = _this.props, onEvent = _a.onEvent, disabled = _a.disabled;
            var transformEvent = new TransformableImageEvent({
                active: _this.transforming
            });
            if (onEvent) onEvent(transformEvent, nativeEvent);
            else {
                nativeEvent.preventDefault();
                nativeEvent.stopPropagation();
            }
            return !disabled && !transformEvent.defaultPrevented;
        };
        _this.onWheel = function(event) {
            var _a = _this.props, onTransform = _a.onTransform, wheelScale = _a.wheelScale;
            var container = _this.container.current;
            if (wheelScale) {
                if (_this.processEvent(event)) {
                    _this.processStart();
                    if (onTransform && container) onTransform(wheelEventToImageTransform(event, container, wheelScale === true ? 0.1 : wheelScale.ratio));
                    if (!_this.touches.length) _this.debouncedProcessEnd();
                }
            }
        };
        _this.onTouchStart = function(event) {
            var _a = _this.props, touchMove = _a.touchMove, touchScale = _a.touchScale, touchRotate = _a.touchRotate;
            if (event.cancelable && (touchMove || (touchScale || touchRotate) && event.touches.length > 1)) {
                if (_this.processEvent(event)) {
                    var container = _this.container.current;
                    if (container) {
                        var _b = container.getBoundingClientRect(), left_1 = _b.left, top_1 = _b.top, bottom_1 = _b.bottom, right_1 = _b.right;
                        _this.touches = Array.from(event.touches).filter(function(touch) {
                            return touch.clientX > left_1 && touch.clientX < right_1 && touch.clientY > top_1 && touch.clientY < bottom_1;
                        });
                    }
                }
            }
        };
        _this.onTouchEnd = function(event) {
            if (event.touches.length === 0) {
                _this.touches = [];
                _this.processEnd();
            }
        };
        _this.onTouchMove = function(event) {
            if (_this.touches.length) {
                var touches = (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(event.touches), false).filter(function(touch) {
                    return !touch.identifier || _this.touches.find(function(anotherTouch) {
                        return anotherTouch.identifier === touch.identifier;
                    });
                });
                if (_this.processEvent(event)) {
                    _this.processMove(touches);
                    _this.processStart();
                }
            }
        };
        _this.onMouseDown = function(event) {
            var mouseMove = _this.props.mouseMove;
            if (mouseMove && 'buttons' in event && event.buttons === 1) {
                if (_this.processEvent(event)) {
                    var touch = {
                        clientX: event.clientX,
                        clientY: event.clientY
                    };
                    _this.touches = [
                        touch
                    ];
                    _this.processStart();
                }
            }
        };
        _this.onMouseMove = function(event) {
            if (_this.touches.length) {
                if (_this.processEvent(event)) _this.processMove([
                    {
                        clientX: event.clientX,
                        clientY: event.clientY
                    }
                ]);
            }
        };
        _this.onMouseUp = function() {
            _this.touches = [];
            _this.processEnd();
        };
        _this.transforming = false;
        _this.touches = [];
        _this.anchor = {
            left: 0,
            top: 0
        };
        _this.container = (0, $acw62.createRef)();
        _this.debouncedProcessEnd = debounce(_this.processEnd, props.timeout);
        return _this;
    }
    TransformableImage.prototype.shouldComponentUpdate = function() {
        return true;
    };
    TransformableImage.prototype.componentWillUnmount = function() {
        window.removeEventListener('mouseup', this.onMouseUp);
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('touchmove', this.onTouchMove);
        window.removeEventListener('touchend', this.onTouchEnd);
        var container = this.container.current;
        if (container) {
            container.removeEventListener('touchstart', this.onTouchStart);
            container.removeEventListener('mousedown', this.onMouseDown);
            container.removeEventListener('wheel', this.onWheel);
        }
    };
    TransformableImage.prototype.componentDidMount = function() {
        window.addEventListener('mouseup', this.onMouseUp, {
            passive: false
        });
        window.addEventListener('mousemove', this.onMouseMove, {
            passive: false
        });
        window.addEventListener('touchmove', this.onTouchMove, {
            passive: false
        });
        window.addEventListener('touchend', this.onTouchEnd, {
            passive: false
        });
        var container = this.container.current;
        if (container) {
            // Add event listeners here due to https://github.com/facebook/react/issues/9809#issuecomment-414072263
            container.addEventListener('touchstart', this.onTouchStart, {
                passive: false
            });
            container.addEventListener('mousedown', this.onMouseDown, {
                passive: false
            });
            container.addEventListener('wheel', this.onWheel, {
                passive: false
            });
        }
    };
    TransformableImage.prototype.render = function() {
        var _a = this.props, className = _a.className, children = _a.children, style = _a.style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: className,
            style: style,
            ref: this.container
        }, children);
    };
    TransformableImage.defaultProps = {
        touchMove: true,
        mouseMove: true,
        touchScale: true,
        touchRotate: false,
        wheelScale: true,
        timeout: 500
    };
    return TransformableImage;
}((0, $acw62.Component));
var CropperBackgroundWrapper = function(_a) {
    var _b = _a.scaleImage, scaleImage = _b === void 0 ? true : _b, _c = _a.moveImage, moveImage = _c === void 0 ? true : _c, _d = _a.rotateImage, rotateImage = _d === void 0 ? false : _d, children = _a.children, className = _a.className, style = _a.style, cropper = _a.cropper, timeout = _a.timeout;
    var transitions = cropper.getTransitions();
    var rotateImageOptions = useRotateImageOptions(rotateImage);
    var scaleImageOptions = useScaleImageOptions(scaleImage);
    var moveImageOptions = useMoveImageOptions(moveImage);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TransformableImage, {
        className: className,
        style: style,
        onTransform: cropper.transformImage,
        onTransformEnd: cropper.transformImageEnd,
        touchMove: moveImageOptions.touch,
        mouseMove: moveImageOptions.mouse,
        touchScale: scaleImageOptions.touch,
        wheelScale: scaleImageOptions.wheel,
        touchRotate: rotateImageOptions.touch,
        disabled: transitions.active,
        timeout: timeout
    }, children);
};
var AbstractCropperComponent = function(props, ref) {
    var style = props.style, className = props.className, _a = props.stencilComponent, stencilComponent = _a === void 0 ? RectangleStencil : _a, _b = props.stencilConstraints, stencilConstraints = _b === void 0 ? defaultStencilConstraints : _b, _c = props.stencilProps, stencilProps = _c === void 0 ? {} : _c, _d = props.wrapperComponent, wrapperComponent = _d === void 0 ? CropperWrapper : _d, _e = props.wrapperProps, wrapperProps = _e === void 0 ? {} : _e, _f = props.backgroundComponent, backgroundComponent = _f === void 0 ? CropperBackgroundImage : _f, _g = props.backgroundProps, backgroundProps = _g === void 0 ? {} : _g, backgroundClassName = props.backgroundClassName, _h = props.backgroundWrapperComponent, backgroundWrapperComponent = _h === void 0 ? CropperBackgroundWrapper : _h, _j = props.backgroundWrapperProps, backgroundWrapperProps = _j === void 0 ? {} : _j, _k = props.boundaryComponent, boundaryComponent = _k === void 0 ? StretchableBoundary : _k, boundaryProps = props.boundaryProps, boundaryClassName = props.boundaryClassName, _l = props.canvas, canvas = _l === void 0 ? true : _l, _m = props.crossOrigin, crossOrigin = _m === void 0 ? true : _m, settings = props.settings, parameters = (0, $7WQrb.__rest)(props, [
        "style",
        "className",
        "stencilComponent",
        "stencilConstraints",
        "stencilProps",
        "wrapperComponent",
        "wrapperProps",
        "backgroundComponent",
        "backgroundProps",
        "backgroundClassName",
        "backgroundWrapperComponent",
        "backgroundWrapperProps",
        "boundaryComponent",
        "boundaryProps",
        "boundaryClassName",
        "canvas",
        "crossOrigin",
        "settings"
    ]);
    var stencilRef = (0, $acw62.useRef)(null);
    var _o = useAbstractCropper(function() {
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, parameters), {
            crossOrigin: crossOrigin,
            stencilProps: stencilProps,
            canvas: canvas,
            settings: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, settings), stencilConstraints(settings, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, stencilProps), stencilRef.current)))
        });
    }), cropper = _o.cropper, image = _o.image, refs = _o.refs;
    var StencilComponent = stencilComponent;
    var WrapperComponent = wrapperComponent;
    var BackgroundWrapperComponent = backgroundWrapperComponent;
    var BackgroundComponent = backgroundComponent;
    var BoundaryComponent = boundaryComponent;
    (0, $acw62.useImperativeHandle)(ref, function() {
        return cropper;
    });
    var deprecatedWrapperProps = {
        loading: cropper.isLoading(),
        loaded: cropper.isLoaded()
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrapperComponent, (0, $7WQrb.__assign)({}, wrapperProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper', className),
        cropper: cropper,
        style: style
    }, deprecatedWrapperProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BoundaryComponent, (0, $7WQrb.__assign)({}, boundaryProps, {
        ref: refs.boundary,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper__boundary', boundaryClassName)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BackgroundWrapperComponent, (0, $7WQrb.__assign)({}, backgroundWrapperProps, {
        cropper: cropper,
        className: 'advanced-cropper__background-wrapper'
    }), cropper.getState() && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BackgroundComponent, (0, $7WQrb.__assign)({}, backgroundProps, {
        ref: refs.image,
        crossOrigin: crossOrigin,
        cropper: cropper,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper__background', backgroundClassName)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StencilComponent, (0, $7WQrb.__assign)({}, stencilProps, {
        ref: stencilRef,
        cropper: cropper,
        image: image
    }))), canvas && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CropperCanvas, {
        ref: refs.canvas
    })));
};
var AbstractCropper = createCropper(AbstractCropperComponent);
var defaultSettings = [
    'transformImage',
    'moveCoordinates',
    'resizeCoordinates',
    'defaultCoordinates',
    'defaultVisibleArea',
    'areaPositionRestrictions',
    'areaSizeRestrictions',
    'sizeRestrictions',
    'positionRestrictions',
    'aspectRatio',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'defaultSize',
    'defaultPosition',
    'defaultTransforms',
    'imageRestriction',
    'priority'
];
function useAbstractCropperProps(props, settings) {
    if (settings === void 0) settings = defaultSettings;
    var result = {
        settings: {},
        props: {}
    };
    Object.keys(props).forEach(function(key) {
        if (settings.some(function(setting) {
            return setting === key;
        })) result.settings[key] = props[key];
        else result.props[key] = props[key];
    });
    return result;
}
function fixedStencilConstraints(rawSettings, stencilOptions) {
    var defaultConstraints = defaultStencilConstraints({}, stencilOptions);
    return {
        stencilSize: function(state, settings) {
            var previousSize = isFunction(rawSettings.stencilSize) ? rawSettings.stencilSize(state, settings) : rawSettings.stencilSize;
            return approximateSize((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, previousSize), {
                aspectRatio: aspectRatioIntersection(defaultConstraints.aspectRatio, createAspectRatio(ratio(previousSize)))
            }));
        }
    };
}
function getStencilSize(state, settings) {
    var boundary = state.boundary;
    var size = isFunction(settings.stencilSize) ? settings.stencilSize(state, settings) : settings.stencilSize;
    if (size.width > boundary.width || size.height > boundary.height) size = approximateSize({
        sizeRestrictions: {
            maxWidth: boundary.width,
            maxHeight: boundary.height,
            minWidth: 0,
            minHeight: 0
        },
        width: size.width,
        height: size.height,
        aspectRatio: {
            minimum: ratio(size),
            maximum: ratio(size)
        }
    });
    return size;
}
function sizeRestrictions(state, settings) {
    var stencilSize = getStencilSize(state, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, settings), {
        stencilSize: settings.stencilSize
    }));
    var areaRestrictions = getAreaSizeRestrictions(state, settings);
    return {
        maxWidth: areaRestrictions.maxWidth * stencilSize.width / state.boundary.width,
        maxHeight: areaRestrictions.maxHeight * stencilSize.height / state.boundary.height,
        minWidth: 0,
        minHeight: 0
    };
}
function defaultSize(state, settings) {
    var imageSize = state.imageSize, visibleArea = state.visibleArea, boundary = state.boundary;
    var sizeRestrictions = getSizeRestrictions(state, settings);
    var aspectRatio = getAspectRatio(state, settings);
    var stencilSize = isFunction(settings.stencilSize) ? settings.stencilSize(state, settings) : settings.stencilSize;
    var area = visibleArea || imageSize;
    var height, width;
    if (ratio(area) > ratio(boundary)) {
        height = stencilSize.height * area.height / boundary.height;
        width = height * ratio(stencilSize);
    } else {
        width = stencilSize.width * area.width / boundary.width;
        height = width / ratio(stencilSize);
    }
    return approximateSize({
        width: width,
        height: height,
        aspectRatio: aspectRatio,
        sizeRestrictions: sizeRestrictions
    });
}
function aspectRatio(state, settings) {
    var value = ratio(getStencilSize(state, settings));
    return {
        minimum: value,
        maximum: value
    };
}
function fixedStencilAlgorithm(state, settings) {
    if (isInitializedState(state)) {
        var result = copyState(state);
        var stencil = getStencilSize(state, settings);
        // First of all try to resize visible area as much as possible:
        result.visibleArea = applyScale(result.visibleArea, result.coordinates.width * result.boundary.width / (result.visibleArea.width * stencil.width));
        // Check that visible area doesn't break the area restrictions:
        var scale = fitToSizeRestrictions(result.visibleArea, getAreaSizeRestrictions(result, settings));
        if (scale !== 1) {
            result.visibleArea = applyScale(result.visibleArea, scale);
            result.coordinates = applyScale(result.coordinates, scale);
        }
        result.visibleArea = applyMove(result.visibleArea, diff(getCenter(result.coordinates), getCenter(result.visibleArea)));
        // Center stencil in visible area:
        result.visibleArea = moveToPositionRestrictions(result.visibleArea, getAreaPositionRestrictions(result, settings));
        result.coordinates = moveToPositionRestrictions(result.coordinates, mergePositionRestrictions(coordinatesToPositionRestrictions(result.visibleArea), getAreaPositionRestrictions(result, settings)));
        return result;
    }
    return state;
}
function fixedStencil(state, settings, action) {
    if (action && action.immediately) return fixedStencilAlgorithm(state, settings);
    return state;
}
var FixedCropper = (0, $acw62.forwardRef)(function(props, ref) {
    var cropperProps = useAbstractCropperProps(props, (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(defaultSettings), false), [
        'stencilSize'
    ], false));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AbstractCropper, (0, $7WQrb.__assign)({
        postProcess: fixedStencil,
        stencilConstraints: fixedStencilConstraints
    }, cropperProps.props, {
        settings: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
            defaultSize: defaultSize,
            aspectRatio: aspectRatio,
            sizeRestrictions: withDefaultSizeRestrictions(sizeRestrictions)
        }, cropperProps.settings), {
            transformImage: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, cropperProps.settings.transformImage), {
                adjustStencil: false
            })
        }),
        ref: ref
    }));
});
FixedCropper.displayName = 'FixedCropper';
var Cropper = (0, $acw62.forwardRef)(function(props, ref) {
    var cropperProps = useAbstractCropperProps(props);
    var intrinsicProps = cropperProps.props;
    // Process the deprecated properties
    var _a = cropperProps.settings, stencilSize = _a.stencilSize, autoZoom = _a.autoZoom, actualSettings = (0, $7WQrb.__rest)(_a, [
        "stencilSize",
        "autoZoom"
    ]);
    var deprecationWarning = useDeprecationWarning();
    if (!isUndefined(autoZoom)) {
        if (intrinsicProps.postProcess || stencilSize) deprecationWarning("prop 'autoZoom' is deprecated now and will be removed, use 'postProcess' prop to pass your auto zoom function.");
        else {
            deprecationWarning("prop 'autoZoom' is deprecated now and will be removed, use 'postProcess' prop to pass your auto zoom function. The 'postProcess' automatically set to 'hybridAutoZoom'");
            intrinsicProps.postProcess = hybridStencilAutoZoom;
        }
    }
    if (!isUndefined(stencilSize)) {
        deprecationWarning("prop 'stencilSize' is deprecated for <Cropper/> component now and will be removed, use <FixedCropper/> component instead.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FixedCropper, (0, $7WQrb.__assign)({
            ref: ref,
            stencilSize: stencilSize
        }, actualSettings, intrinsicProps));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AbstractCropper, (0, $7WQrb.__assign)({}, intrinsicProps, {
        ref: ref,
        settings: actualSettings
    }));
});
Cropper.displayName = 'CropperComponent';
var CircleStencil = (0, $acw62.forwardRef)(function(_a, ref) {
    var cropper = _a.cropper, coordinates = _a.coordinates, _b = _a.handlerComponent, handlerComponent = _b === void 0 ? SimpleHandler : _b, _c = _a.handlers, handlers = _c === void 0 ? {
        eastNorth: true,
        westNorth: true,
        westSouth: true,
        eastSouth: true
    } : _c, _d = _a.handlerClassNames, handlerClassNames = _d === void 0 ? {} : _d, _e = _a.handlerWrapperClassNames, handlerWrapperClassNames = _e === void 0 ? {} : _e, _f = _a.lines, lines = _f === void 0 ? {
        west: true,
        north: true,
        east: true,
        south: true
    } : _f, _g = _a.lineComponent, lineComponent = _g === void 0 ? SimpleLine : _g, _h = _a.lineClassNames, lineClassNames = _h === void 0 ? {} : _h, _j = _a.lineWrapperClassNames, lineWrapperClassNames = _j === void 0 ? {} : _j, _k = _a.resizable, resizable = _k === void 0 ? true : _k, _l = _a.movable, movable = _l === void 0 ? true : _l, grid = _a.grid, gridClassName = _a.gridClassName, className = _a.className, movingClassName = _a.movingClassName, resizingClassName = _a.resizingClassName, previewClassName = _a.previewClassName, boundingBoxClassName = _a.boundingBoxClassName, overlayClassName = _a.overlayClassName, draggableAreaClassName = _a.draggableAreaClassName;
    var state = cropper.getState();
    var transitions = cropper.getTransitions();
    var interactions = cropper.getInteractions();
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            aspectRatio: 1,
            boundingBox: 'circle'
        };
    });
    var onMove = function(directions) {
        if (cropper && movable) cropper.moveCoordinates(directions);
    };
    var onMoveEnd = function() {
        if (cropper) cropper.moveCoordinatesEnd();
    };
    var onResize = function(anchor, directions, options) {
        if (cropper && resizable) cropper.resizeCoordinates(anchor, directions, options);
    };
    var onResizeEnd = function() {
        if (cropper) cropper.resizeCoordinatesEnd();
    };
    var _m = coordinates ? isFunction(coordinates) ? coordinates(state) : coordinates : getStencilCoordinates(state), width = _m.width, height = _m.height, left = _m.left, top = _m.top;
    return state && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StencilWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-circle-stencil', className, interactions.moveCoordinates && movingClassName, interactions.resizeCoordinates && resizingClassName, {
            'advanced-cropper-circle-stencil--movable': movable,
            'advanced-cropper-circle-stencil--moving': interactions.moveCoordinates,
            'advanced-cropper-circle-stencil--resizable': resizable,
            'advanced-cropper-circle-stencil--resizing': interactions.resizeCoordinates
        }),
        width: width,
        height: height,
        left: left,
        top: top,
        transitions: transitions
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BoundingBox, {
        reference: state.coordinates,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(boundingBoxClassName, 'advanced-cropper-circle-stencil__bounding-box'),
        handlers: handlers,
        handlerComponent: handlerComponent,
        handlerClassNames: handlerClassNames,
        handlerWrapperClassNames: handlerWrapperClassNames,
        lines: lines,
        lineComponent: lineComponent,
        lineClassNames: lineClassNames,
        lineWrapperClassNames: lineWrapperClassNames,
        onResize: onResize,
        onResizeEnd: onResizeEnd,
        disabled: !resizable
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DraggableElement, {
        disabled: !movable,
        onMove: onMove,
        onMoveEnd: onMoveEnd,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-circle-stencil__draggable-area', draggableAreaClassName)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StencilOverlay, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-circle-stencil__overlay', overlayClassName)
    }, grid && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StencilGrid, {
        visible: cropper.hasInteractions(),
        columns: interactions.transformImage.rotate ? 9 : 3,
        rows: interactions.transformImage.rotate ? 9 : 3,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-circle-stencil__grid', gridClassName)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-circle-stencil__preview', previewClassName)
    })))));
});
CircleStencil.displayName = 'CircleStencil';
var CropperSource = (0, $acw62.forwardRef)(function(_a, ref) {
    var src = _a.src, _b = _a.crossOrigin, crossOrigin = _b === void 0 ? true : _b, props = (0, $7WQrb.__rest)(_a, [
        "src",
        "crossOrigin"
    ]);
    return src ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", (0, $7WQrb.__assign)({
        key: src,
        ref: ref,
        src: src,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-source'),
        crossOrigin: crossOrigin === true ? 'anonymous' : crossOrigin || undefined
    }, props)) : null;
});
CropperSource.displayName = 'CropperSource';
var CropperPreviewWrapper = function(_a) {
    var children = _a.children, cropper = _a.cropper, className = _a.className, style = _a.style;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, 'cropper-preview-wrapper'),
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CropperFade, {
        visible: cropper === null || cropper === void 0 ? void 0 : cropper.isLoaded(),
        className: 'cropper-preview-wrapper__fade'
    }, children));
};
var CropperPreviewBackground = function(_a) {
    var className = _a.className, cropper = _a.cropper, _b = _a.crossOrigin, crossOrigin = _b === void 0 ? true : _b, size = _a.size, style = _a.style;
    var state = cropper.getState();
    var transitions = cropper.getTransitions();
    var image = cropper.getImage();
    var transformStyles = size && image && (state === null || state === void 0 ? void 0 : state.coordinates) ? getPreviewStyle(image, state, size, transitions) : {};
    var src = image ? image.src : undefined;
    return src ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        key: src,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-background-image', className),
        src: src,
        crossOrigin: crossOrigin === true ? 'anonymous' : crossOrigin || undefined,
        style: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, transformStyles), style),
        onMouseDown: preventDefault
    }) : null;
};
var CropperPreview = (0, $acw62.forwardRef)(function(_a, ref) {
    var _b, _c, _d, _e;
    var className = _a.className, contentClassName = _a.contentClassName, _f = _a.state, state = _f === void 0 ? null : _f, _g = _a.image, image = _g === void 0 ? null : _g, _h = _a.transitions, transitions = _h === void 0 ? null : _h, _j = _a.backgroundComponent, backgroundComponent = _j === void 0 ? CropperPreviewBackground : _j, backgroundProps = _a.backgroundProps, backgroundClassName = _a.backgroundClassName, _k = _a.boundaryComponent, boundaryComponent = _k === void 0 ? StretchableBoundary : _k, boundaryProps = _a.boundaryProps, boundaryClassName = _a.boundaryClassName, _l = _a.wrapperComponent, wrapperComponent = _l === void 0 ? CropperPreviewWrapper : _l, wrapperProps = _a.wrapperProps, _m = _a.loaded, loaded = _m === void 0 ? true : _m, _o = _a.loading, loading = _o === void 0 ? false : _o, style = _a.style, cropper = _a.cropper;
    var rerender = useForceRerender();
    var boundaryRef = (0, $acw62.useRef)(null);
    var instance = cropper || {
        current: {
            getState: function() {
                return state;
            },
            getTransitions: function() {
                return transitions;
            },
            getImage: function() {
                return image;
            },
            isLoaded: function() {
                return loaded;
            },
            isLoading: function() {
                return loading;
            }
        }
    };
    var _p = (0, $7WQrb.__read)((0, $acw62.useState)(null), 2), size = _p[0], setSize = _p[1];
    var coordinates = (_c = (_b = instance.current) === null || _b === void 0 ? void 0 : _b.getState()) === null || _c === void 0 ? void 0 : _c.coordinates;
    var src = (_e = (_d = instance.current) === null || _d === void 0 ? void 0 : _d.getImage()) === null || _e === void 0 ? void 0 : _e.src;
    var contentStyle = size ? {
        width: "".concat(size.width, "px"),
        height: "".concat(size.height, "px")
    } : {};
    var refresh = function() {
        if (boundaryRef.current && coordinates) boundaryRef.current.stretchTo(coordinates).then(function(size) {
            if (size && coordinates) {
                if (isGreater(ratio(coordinates), ratio(size))) setSize({
                    width: size.width,
                    height: size.width / ratio(coordinates)
                });
                else setSize({
                    width: size.height * ratio(coordinates),
                    height: size.height
                });
            } else setSize(null);
        });
        rerender();
    };
    useWindowResize(refresh);
    (0, $acw62.useLayoutEffect)(refresh, [
        coordinates === null || coordinates === void 0 ? void 0 : coordinates.height,
        coordinates === null || coordinates === void 0 ? void 0 : coordinates.width
    ]);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            refresh: rerender
        };
    });
    var WrapperComponent = wrapperComponent;
    var BackgroundComponent = backgroundComponent;
    var BoundaryComponent = boundaryComponent;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrapperComponent, (0, $7WQrb.__assign)({}, wrapperProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, 'advanced-cropper-preview'),
        cropper: instance.current,
        style: style
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BoundaryComponent, (0, $7WQrb.__assign)({
        ref: boundaryRef,
        stretchAlgorithm: stretchPreviewBoundary
    }, boundaryProps, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))('advanced-cropper-preview__boundary', boundaryClassName)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(contentClassName, 'advanced-cropper-preview__content'),
        style: contentStyle
    }, instance.current && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BackgroundComponent, (0, $7WQrb.__assign)({}, backgroundProps, {
        cropper: instance.current,
        size: size,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(backgroundClassName, 'advanced-cropper-preview__image', src && 'advanced-cropper-preview__image--visible')
    })))));
});
function mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}

});
parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});


parcelRegister("lF6Ws", function(module, exports) {

$parcel$export(module.exports, "Dropzone", () => $fc52cfce411e6eba$export$47d4850b9fdf5af1);

var $kwqWA = parcelRequire("kwqWA");

var $lsUFT = parcelRequire("lsUFT");

var $kVo2K = parcelRequire("kVo2K");
(0, $lsUFT.Dropzone).FullScreen = (0, $kwqWA.DropzoneFullScreen);
const $fc52cfce411e6eba$export$47d4850b9fdf5af1 = (0, $lsUFT.Dropzone);

});
parcelRegister("kwqWA", function(module, exports) {

$parcel$export(module.exports, "DropzoneFullScreen", () => $ef0bb24cdc7ae062$export$d51616564992d87e);

var $acw62 = parcelRequire("acw62");

var $hiiR1 = parcelRequire("hiiR1");
var $iu1L3 = parcelRequire("iu1L3");
var $hZi38 = parcelRequire("hZi38");
var $64A2P = parcelRequire("64A2P");

var $6X2G0 = parcelRequire("6X2G0");

var $lsUFT = parcelRequire("lsUFT");

var $bBp1d = parcelRequire("bBp1d");
var $ef0bb24cdc7ae062$var$__defProp = Object.defineProperty;
var $ef0bb24cdc7ae062$var$__defProps = Object.defineProperties;
var $ef0bb24cdc7ae062$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $ef0bb24cdc7ae062$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $ef0bb24cdc7ae062$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ef0bb24cdc7ae062$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $ef0bb24cdc7ae062$var$__defNormalProp = (obj, key, value)=>key in obj ? $ef0bb24cdc7ae062$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $ef0bb24cdc7ae062$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($ef0bb24cdc7ae062$var$__hasOwnProp.call(b, prop)) $ef0bb24cdc7ae062$var$__defNormalProp(a, prop, b[prop]);
    if ($ef0bb24cdc7ae062$var$__getOwnPropSymbols) {
        for (var prop of $ef0bb24cdc7ae062$var$__getOwnPropSymbols(b))if ($ef0bb24cdc7ae062$var$__propIsEnum.call(b, prop)) $ef0bb24cdc7ae062$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $ef0bb24cdc7ae062$var$__spreadProps = (a, b)=>$ef0bb24cdc7ae062$var$__defProps(a, $ef0bb24cdc7ae062$var$__getOwnPropDescs(b));
var $ef0bb24cdc7ae062$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($ef0bb24cdc7ae062$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $ef0bb24cdc7ae062$var$__getOwnPropSymbols) {
        for (var prop of $ef0bb24cdc7ae062$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $ef0bb24cdc7ae062$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $ef0bb24cdc7ae062$var$fullScreenDefaultProps = {
    padding: "md",
    loading: false,
    multiple: true,
    maxSize: Infinity,
    autoFocus: false,
    activateOnClick: true,
    activateOnDrag: true,
    dragEventsBubbling: true,
    activateOnKeyboard: true,
    active: true,
    zIndex: (0, $iu1L3.getDefaultZIndex)("max"),
    withinPortal: true
};
function $ef0bb24cdc7ae062$export$d51616564992d87e(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("DropzoneFullScreen", $ef0bb24cdc7ae062$var$fullScreenDefaultProps, props), { classNames: classNames, styles: styles, sx: sx, className: className, style: style, unstyled: unstyled, active: active, onDrop: onDrop, onReject: onReject, zIndex: zIndex, withinPortal: withinPortal, portalProps: portalProps } = _a, others = $ef0bb24cdc7ae062$var$__objRest(_a, [
        "classNames",
        "styles",
        "sx",
        "className",
        "style",
        "unstyled",
        "active",
        "onDrop",
        "onReject",
        "zIndex",
        "withinPortal",
        "portalProps"
    ]);
    const [counter, setCounter] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(0);
    const [visible, { open: open, close: close }] = (0, $6X2G0.useDisclosure)(false);
    const { classes: classes, cx: cx } = (0, $bBp1d.default)(null, {
        name: "DropzoneFullScreen",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
    });
    const handleDragEnter = (event)=>{
        if (event.dataTransfer.types.includes("Files")) {
            setCounter((prev)=>prev + 1);
            open();
        }
    };
    const handleDragLeave = ()=>{
        setCounter((prev)=>prev - 1);
    };
    (0, $acw62.useEffect)(()=>{
        counter === 0 && close();
    }, [
        counter
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!active) return void 0;
        document.addEventListener("dragenter", handleDragEnter, false);
        document.addEventListener("dragleave", handleDragLeave, false);
        return ()=>{
            document.removeEventListener("dragenter", handleDragEnter, false);
            document.removeEventListener("dragleave", handleDragLeave, false);
        };
    }, [
        active
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hZi38.OptionalPortal), $ef0bb24cdc7ae062$var$__spreadProps($ef0bb24cdc7ae062$var$__spreadValues({}, portalProps), {
        withinPortal: withinPortal
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), {
        className: cx(classes.wrapper, className),
        sx: sx,
        style: $ef0bb24cdc7ae062$var$__spreadProps($ef0bb24cdc7ae062$var$__spreadValues({}, style), {
            opacity: visible ? 1 : 0,
            pointerEvents: visible ? "all" : "none",
            zIndex: zIndex
        })
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lsUFT._Dropzone), $ef0bb24cdc7ae062$var$__spreadProps($ef0bb24cdc7ae062$var$__spreadValues({}, others), {
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        className: classes.dropzone,
        onDrop: (files)=>{
            onDrop == null || onDrop(files);
            close();
        },
        onReject: (files)=>{
            onReject == null || onReject(files);
            close();
        }
    }))));
}
$ef0bb24cdc7ae062$export$d51616564992d87e.displayName = "@mantine/dropzone/DropzoneFullScreen";

});
parcelRegister("lsUFT", function(module, exports) {

$parcel$export(module.exports, "_Dropzone", () => $fa082ceb26aa01d0$export$424a121ae939e79d);
$parcel$export(module.exports, "Dropzone", () => $fa082ceb26aa01d0$export$47d4850b9fdf5af1);

var $acw62 = parcelRequire("acw62");

var $dVEPf = parcelRequire("dVEPf");

var $hiiR1 = parcelRequire("hiiR1");
var $bL3Lu = parcelRequire("bL3Lu");
var $64A2P = parcelRequire("64A2P");

var $69QHb = parcelRequire("69QHb");

var $lRfNl = parcelRequire("lRfNl");

var $eL3TN = parcelRequire("eL3TN");

var $fcrD3 = parcelRequire("fcrD3");
var $fa082ceb26aa01d0$var$__defProp = Object.defineProperty;
var $fa082ceb26aa01d0$var$__defProps = Object.defineProperties;
var $fa082ceb26aa01d0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $fa082ceb26aa01d0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $fa082ceb26aa01d0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fa082ceb26aa01d0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $fa082ceb26aa01d0$var$__defNormalProp = (obj, key, value)=>key in obj ? $fa082ceb26aa01d0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fa082ceb26aa01d0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($fa082ceb26aa01d0$var$__hasOwnProp.call(b, prop)) $fa082ceb26aa01d0$var$__defNormalProp(a, prop, b[prop]);
    if ($fa082ceb26aa01d0$var$__getOwnPropSymbols) {
        for (var prop of $fa082ceb26aa01d0$var$__getOwnPropSymbols(b))if ($fa082ceb26aa01d0$var$__propIsEnum.call(b, prop)) $fa082ceb26aa01d0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $fa082ceb26aa01d0$var$__spreadProps = (a, b)=>$fa082ceb26aa01d0$var$__defProps(a, $fa082ceb26aa01d0$var$__getOwnPropDescs(b));
var $fa082ceb26aa01d0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($fa082ceb26aa01d0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $fa082ceb26aa01d0$var$__getOwnPropSymbols) {
        for (var prop of $fa082ceb26aa01d0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $fa082ceb26aa01d0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $fa082ceb26aa01d0$export$9c21a3269931e1e6 = {
    padding: "md",
    loading: false,
    multiple: true,
    maxSize: Infinity,
    autoFocus: false,
    activateOnClick: true,
    activateOnDrag: true,
    dragEventsBubbling: true,
    activateOnKeyboard: true,
    useFsAccessApi: true
};
function $fa082ceb26aa01d0$export$424a121ae939e79d(props) {
    const _a = (0, $64A2P.useComponentDefaultProps)("Dropzone", $fa082ceb26aa01d0$export$9c21a3269931e1e6, props), { className: className, padding: padding, radius: radius, disabled: disabled, classNames: classNames, styles: styles, loading: loading, multiple: multiple, maxSize: maxSize, accept: accept, children: children, onDropAny: onDropAny, onDrop: onDrop, onReject: onReject, openRef: openRef, name: name, unstyled: unstyled, maxFiles: maxFiles, autoFocus: autoFocus, activateOnClick: activateOnClick, activateOnDrag: activateOnDrag, dragEventsBubbling: dragEventsBubbling, activateOnKeyboard: activateOnKeyboard, onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDragOver: onDragOver, onFileDialogCancel: onFileDialogCancel, onFileDialogOpen: onFileDialogOpen, preventDropOnDocument: preventDropOnDocument, useFsAccessApi: useFsAccessApi, getFilesFromEvent: getFilesFromEvent, validator: validator, variant: variant } = _a, others = $fa082ceb26aa01d0$var$__objRest(_a, [
        "className",
        "padding",
        "radius",
        "disabled",
        "classNames",
        "styles",
        "loading",
        "multiple",
        "maxSize",
        "accept",
        "children",
        "onDropAny",
        "onDrop",
        "onReject",
        "openRef",
        "name",
        "unstyled",
        "maxFiles",
        "autoFocus",
        "activateOnClick",
        "activateOnDrag",
        "dragEventsBubbling",
        "activateOnKeyboard",
        "onDragEnter",
        "onDragLeave",
        "onDragOver",
        "onFileDialogCancel",
        "onFileDialogOpen",
        "preventDropOnDocument",
        "useFsAccessApi",
        "getFilesFromEvent",
        "validator",
        "variant"
    ]);
    const { classes: classes, cx: cx } = (0, $fcrD3.default)({
        radius: radius,
        padding: padding
    }, {
        name: "Dropzone",
        classNames: classNames,
        styles: styles,
        unstyled: unstyled,
        variant: variant
    });
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragAccept: isDragAccept, isDragReject: isDragReject, open: open } = (0, $dVEPf.useDropzone)($fa082ceb26aa01d0$var$__spreadValues({
        onDrop: onDropAny,
        onDropAccepted: onDrop,
        onDropRejected: onReject,
        disabled: disabled || loading,
        accept: Array.isArray(accept) ? accept.reduce((r, key)=>$fa082ceb26aa01d0$var$__spreadProps($fa082ceb26aa01d0$var$__spreadValues({}, r), {
                [key]: []
            }), {}) : accept,
        multiple: multiple,
        maxSize: maxSize,
        maxFiles: maxFiles,
        autoFocus: autoFocus,
        noClick: !activateOnClick,
        noDrag: !activateOnDrag,
        noDragEventsBubbling: !dragEventsBubbling,
        noKeyboard: !activateOnKeyboard,
        onDragEnter: onDragEnter,
        onDragLeave: onDragLeave,
        onDragOver: onDragOver,
        onFileDialogCancel: onFileDialogCancel,
        onFileDialogOpen: onFileDialogOpen,
        preventDropOnDocument: preventDropOnDocument,
        useFsAccessApi: useFsAccessApi,
        validator: validator
    }, getFilesFromEvent ? {
        getFilesFromEvent: getFilesFromEvent
    } : null));
    (0, $69QHb.assignRef)(openRef, open);
    const isIdle = !isDragAccept && !isDragReject;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lRfNl.DropzoneProvider), {
        value: {
            accept: isDragAccept,
            reject: isDragReject,
            idle: isIdle
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $fa082ceb26aa01d0$var$__spreadProps($fa082ceb26aa01d0$var$__spreadValues($fa082ceb26aa01d0$var$__spreadValues({}, others), getRootProps()), {
        "data-accept": isDragAccept || void 0,
        "data-reject": isDragReject || void 0,
        "data-idle": isIdle || void 0,
        "data-loading": loading || void 0,
        className: cx(classes.root, className)
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bL3Lu.LoadingOverlay), {
        visible: loading,
        radius: radius,
        unstyled: unstyled
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", $fa082ceb26aa01d0$var$__spreadProps($fa082ceb26aa01d0$var$__spreadValues({}, getInputProps()), {
        name: name
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.inner
    }, children)));
}
$fa082ceb26aa01d0$export$424a121ae939e79d.displayName = "@mantine/dropzone/Dropzone";
$fa082ceb26aa01d0$export$424a121ae939e79d.Accept = (0, $eL3TN.DropzoneAccept);
$fa082ceb26aa01d0$export$424a121ae939e79d.Reject = (0, $eL3TN.DropzoneReject);
$fa082ceb26aa01d0$export$424a121ae939e79d.Idle = (0, $eL3TN.DropzoneIdle);
const $fa082ceb26aa01d0$export$47d4850b9fdf5af1 = $fa082ceb26aa01d0$export$424a121ae939e79d;

});
parcelRegister("dVEPf", function(module, exports) {

$parcel$export(module.exports, "useDropzone", () => $a24044586ed82795$export$cd49c0ecc5be9f36);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("jEG6N");
var $axu4I = parcelRequire("axu4I");

var $eEukq = parcelRequire("eEukq");

var $a24044586ed82795$var$_excluded = [
    "children"
], $a24044586ed82795$var$_excluded2 = [
    "open"
], $a24044586ed82795$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $a24044586ed82795$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $a24044586ed82795$var$_toConsumableArray(arr) {
    return $a24044586ed82795$var$_arrayWithoutHoles(arr) || $a24044586ed82795$var$_iterableToArray(arr) || $a24044586ed82795$var$_unsupportedIterableToArray(arr) || $a24044586ed82795$var$_nonIterableSpread();
}
function $a24044586ed82795$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a24044586ed82795$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a24044586ed82795$var$_arrayLikeToArray(arr);
}
function $a24044586ed82795$var$_slicedToArray(arr, i) {
    return $a24044586ed82795$var$_arrayWithHoles(arr) || $a24044586ed82795$var$_iterableToArrayLimit(arr, i) || $a24044586ed82795$var$_unsupportedIterableToArray(arr, i) || $a24044586ed82795$var$_nonIterableRest();
}
function $a24044586ed82795$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a24044586ed82795$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a24044586ed82795$var$_arrayLikeToArray(o, minLen);
}
function $a24044586ed82795$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a24044586ed82795$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a24044586ed82795$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a24044586ed82795$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a24044586ed82795$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a24044586ed82795$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a24044586ed82795$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a24044586ed82795$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a24044586ed82795$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a24044586ed82795$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a24044586ed82795$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $a24044586ed82795$var$Dropzone = /*#__PURE__*/ (0, $acw62.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $a24044586ed82795$var$_objectWithoutProperties(_ref, $a24044586ed82795$var$_excluded);
    var _useDropzone = $a24044586ed82795$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $a24044586ed82795$var$_objectWithoutProperties(_useDropzone, $a24044586ed82795$var$_excluded2);
    (0, $acw62.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $acw62.Fragment), null, children($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$a24044586ed82795$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $a24044586ed82795$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $axu4I.fromEvent),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$a24044586ed82795$var$Dropzone.defaultProps = $a24044586ed82795$var$defaultProps;
$a24044586ed82795$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $a24044586ed82795$export$2e2bcd8739ae039 = $a24044586ed82795$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $a24044586ed82795$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $a24044586ed82795$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $acw62.useMemo)(function() {
        return (0, $eEukq.acceptPropAsAcceptAttr)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $acw62.useMemo)(function() {
        return (0, $eEukq.pickerOptionsFromAccept)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $a24044586ed82795$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $acw62.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $a24044586ed82795$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $acw62.useRef)(null);
    var inputRef = (0, $acw62.useRef)(null);
    var _useReducer = (0, $acw62.useReducer)($a24044586ed82795$var$reducer, $a24044586ed82795$var$initialState), _useReducer2 = $a24044586ed82795$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $acw62.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $eEukq.canUseFileSystemAccessAPI)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $acw62.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $acw62.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $acw62.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $eEukq.onDocumentDragOver), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $eEukq.onDocumentDragOver));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $acw62.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $acw62.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($a24044586ed82795$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $eEukq.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $eEukq.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $eEukq.allFilesAccepted)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $eEukq.isEvtWithFiles)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $eEukq.isEvtWithFiles)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $acw62.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $eEukq.fileAccepted)(file, acceptAttr), _fileAccepted2 = $a24044586ed82795$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $eEukq.fileMatchSize)(file, minSize, maxSize), _fileMatchSize2 = $a24044586ed82795$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $eEukq.TOO_MANY_FILES_REJECTION)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $acw62.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $eEukq.isEvtWithFiles)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $eEukq.isPropagationStopped)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $acw62.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $eEukq.isAbort)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $eEukq.isSecurityError)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $acw62.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $acw62.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $acw62.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $eEukq.isIeOrEdge)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref2, $a24044586ed82795$var$_excluded3);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $eEukq.composeEventHandlers)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $eEukq.composeEventHandlers)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $eEukq.composeEventHandlers)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $eEukq.composeEventHandlers)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $acw62.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $acw62.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $a24044586ed82795$var$_objectWithoutProperties(_ref3, $a24044586ed82795$var$_excluded4);
            var inputProps = $a24044586ed82795$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $eEukq.composeEventHandlers)(onChange, onDropCb)),
                onClick: composeHandler((0, $eEukq.composeEventHandlers)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $a24044586ed82795$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $a24044586ed82795$var$_objectSpread($a24044586ed82795$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $a24044586ed82795$var$_objectSpread({}, $a24044586ed82795$var$initialState);
        default:
            return state;
    }
}
function $a24044586ed82795$var$noop() {}

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("jEG6N", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => (parcelRequire("axu4I")).fromEvent);

var $axu4I = parcelRequire("axu4I");

});
parcelRegister("axu4I", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $7ac450b547cb7da9$export$a36e16046ae8f1bb);

var $7WQrb = parcelRequire("7WQrb");

var $iMrFh = parcelRequire("iMrFh");
var $7ac450b547cb7da9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
function $7ac450b547cb7da9$export$a36e16046ae8f1bb(evt) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        return (0, $7WQrb.__generator)(this, function(_a) {
            if ($7ac450b547cb7da9$var$isObject(evt) && $7ac450b547cb7da9$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($7ac450b547cb7da9$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return 'getFile' in item && typeof item.getFile === 'function';
            })) return [
                2 /*return*/ ,
                $7ac450b547cb7da9$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $7ac450b547cb7da9$var$isDataTransfer(value) {
    return $7ac450b547cb7da9$var$isObject(value);
}
function $7ac450b547cb7da9$var$isChangeEvt(value) {
    return $7ac450b547cb7da9$var$isObject(value) && $7ac450b547cb7da9$var$isObject(value.target);
}
function $7ac450b547cb7da9$var$isObject(v) {
    return typeof v === 'object' && v !== null;
}
function $7ac450b547cb7da9$var$getInputFiles(evt) {
    return $7ac450b547cb7da9$var$fromList(evt.target.files).map(function(file) {
        return (0, $iMrFh.toFileWithPath)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $7ac450b547cb7da9$var$getFsHandleFiles(handles) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        var files;
        return (0, $7WQrb.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $iMrFh.toFileWithPath)(file);
                        })
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$getDataTransferFiles(dt, type) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        var items, files;
        return (0, $7WQrb.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $7ac450b547cb7da9$var$fromList(dt.items).filter(function(item) {
                        return item.kind === 'file';
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($7ac450b547cb7da9$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $7ac450b547cb7da9$var$noIgnoredFiles($7ac450b547cb7da9$var$fromList(dt.files).map(function(file) {
                            return (0, $iMrFh.toFileWithPath)(file);
                        }))
                    ];
            }
        });
    });
}
function $7ac450b547cb7da9$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $7ac450b547cb7da9$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $7ac450b547cb7da9$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $7ac450b547cb7da9$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') return $7ac450b547cb7da9$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $7ac450b547cb7da9$var$fromDirEntry(entry);
    return $7ac450b547cb7da9$var$fromDataTransferItem(item);
}
function $7ac450b547cb7da9$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(acc), false), (0, $7WQrb.__read)(Array.isArray(files) ? $7ac450b547cb7da9$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $7ac450b547cb7da9$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $iMrFh.toFileWithPath)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $7ac450b547cb7da9$var$fromEntry(entry) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        return (0, $7WQrb.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $7ac450b547cb7da9$var$fromDirEntry(entry) : $7ac450b547cb7da9$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $7ac450b547cb7da9$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $7WQrb.__awaiter)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $7WQrb.__generator)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($7ac450b547cb7da9$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $7ac450b547cb7da9$var$fromFileEntry(entry) {
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function() {
        return (0, $7WQrb.__generator)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $iMrFh.toFileWithPath)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}

});
parcelRegister("iMrFh", function(module, exports) {

$parcel$export(module.exports, "toFileWithPath", () => $dac22b55eb23ffcc$export$8cc09085015f0dc7);
var $dac22b55eb23ffcc$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        'aac',
        'audio/aac'
    ],
    [
        'abw',
        'application/x-abiword'
    ],
    [
        'arc',
        'application/x-freearc'
    ],
    [
        'avif',
        'image/avif'
    ],
    [
        'avi',
        'video/x-msvideo'
    ],
    [
        'azw',
        'application/vnd.amazon.ebook'
    ],
    [
        'bin',
        'application/octet-stream'
    ],
    [
        'bmp',
        'image/bmp'
    ],
    [
        'bz',
        'application/x-bzip'
    ],
    [
        'bz2',
        'application/x-bzip2'
    ],
    [
        'cda',
        'application/x-cdf'
    ],
    [
        'csh',
        'application/x-csh'
    ],
    [
        'css',
        'text/css'
    ],
    [
        'csv',
        'text/csv'
    ],
    [
        'doc',
        'application/msword'
    ],
    [
        'docx',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ],
    [
        'eot',
        'application/vnd.ms-fontobject'
    ],
    [
        'epub',
        'application/epub+zip'
    ],
    [
        'gz',
        'application/gzip'
    ],
    [
        'gif',
        'image/gif'
    ],
    [
        'heic',
        'image/heic'
    ],
    [
        'heif',
        'image/heif'
    ],
    [
        'htm',
        'text/html'
    ],
    [
        'html',
        'text/html'
    ],
    [
        'ico',
        'image/vnd.microsoft.icon'
    ],
    [
        'ics',
        'text/calendar'
    ],
    [
        'jar',
        'application/java-archive'
    ],
    [
        'jpeg',
        'image/jpeg'
    ],
    [
        'jpg',
        'image/jpeg'
    ],
    [
        'js',
        'text/javascript'
    ],
    [
        'json',
        'application/json'
    ],
    [
        'jsonld',
        'application/ld+json'
    ],
    [
        'mid',
        'audio/midi'
    ],
    [
        'midi',
        'audio/midi'
    ],
    [
        'mjs',
        'text/javascript'
    ],
    [
        'mp3',
        'audio/mpeg'
    ],
    [
        'mp4',
        'video/mp4'
    ],
    [
        'mpeg',
        'video/mpeg'
    ],
    [
        'mpkg',
        'application/vnd.apple.installer+xml'
    ],
    [
        'odp',
        'application/vnd.oasis.opendocument.presentation'
    ],
    [
        'ods',
        'application/vnd.oasis.opendocument.spreadsheet'
    ],
    [
        'odt',
        'application/vnd.oasis.opendocument.text'
    ],
    [
        'oga',
        'audio/ogg'
    ],
    [
        'ogv',
        'video/ogg'
    ],
    [
        'ogx',
        'application/ogg'
    ],
    [
        'opus',
        'audio/opus'
    ],
    [
        'otf',
        'font/otf'
    ],
    [
        'png',
        'image/png'
    ],
    [
        'pdf',
        'application/pdf'
    ],
    [
        'php',
        'application/x-httpd-php'
    ],
    [
        'ppt',
        'application/vnd.ms-powerpoint'
    ],
    [
        'pptx',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ],
    [
        'rar',
        'application/vnd.rar'
    ],
    [
        'rtf',
        'application/rtf'
    ],
    [
        'sh',
        'application/x-sh'
    ],
    [
        'svg',
        'image/svg+xml'
    ],
    [
        'swf',
        'application/x-shockwave-flash'
    ],
    [
        'tar',
        'application/x-tar'
    ],
    [
        'tif',
        'image/tiff'
    ],
    [
        'tiff',
        'image/tiff'
    ],
    [
        'ts',
        'video/mp2t'
    ],
    [
        'ttf',
        'font/ttf'
    ],
    [
        'txt',
        'text/plain'
    ],
    [
        'vsd',
        'application/vnd.visio'
    ],
    [
        'wav',
        'audio/wav'
    ],
    [
        'weba',
        'audio/webm'
    ],
    [
        'webm',
        'video/webm'
    ],
    [
        'webp',
        'image/webp'
    ],
    [
        'woff',
        'font/woff'
    ],
    [
        'woff2',
        'font/woff2'
    ],
    [
        'xhtml',
        'application/xhtml+xml'
    ],
    [
        'xls',
        'application/vnd.ms-excel'
    ],
    [
        'xlsx',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ],
    [
        'xml',
        'application/xml'
    ],
    [
        'xul',
        'application/vnd.mozilla.xul+xml'
    ],
    [
        'zip',
        'application/zip'
    ],
    [
        '7z',
        'application/x-7z-compressed'
    ],
    // Others
    [
        'mkv',
        'video/x-matroska'
    ],
    [
        'mov',
        'video/quicktime'
    ],
    [
        'msg',
        'application/vnd.ms-outlook'
    ]
]);
function $dac22b55eb23ffcc$export$8cc09085015f0dc7(file, path) {
    var f = $dac22b55eb23ffcc$var$withMimeType(file);
    if (typeof f.path !== 'string') {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string' ? path : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $dac22b55eb23ffcc$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.').pop().toLowerCase();
        var type = $dac22b55eb23ffcc$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, 'type', {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}

});



parcelRegister("eEukq", function(module, exports) {

$parcel$export(module.exports, "TOO_MANY_FILES_REJECTION", () => $aaac53b849ab07d4$export$1e1e1b6120329fe);
$parcel$export(module.exports, "fileAccepted", () => $aaac53b849ab07d4$export$b511db3632effe58);
$parcel$export(module.exports, "fileMatchSize", () => $aaac53b849ab07d4$export$860631d45ba43fd9);
$parcel$export(module.exports, "allFilesAccepted", () => $aaac53b849ab07d4$export$6a0bb4322c81a197);
$parcel$export(module.exports, "isPropagationStopped", () => $aaac53b849ab07d4$export$8d6d6472146de265);
$parcel$export(module.exports, "isEvtWithFiles", () => $aaac53b849ab07d4$export$52f1fc875a1e5986);
$parcel$export(module.exports, "onDocumentDragOver", () => $aaac53b849ab07d4$export$2ead263d6635cecc);
$parcel$export(module.exports, "isIeOrEdge", () => $aaac53b849ab07d4$export$d3498e653911f962);
$parcel$export(module.exports, "composeEventHandlers", () => $aaac53b849ab07d4$export$b9ecd428b558ff10);
$parcel$export(module.exports, "canUseFileSystemAccessAPI", () => $aaac53b849ab07d4$export$858af2af50e1eaf8);
$parcel$export(module.exports, "pickerOptionsFromAccept", () => $aaac53b849ab07d4$export$8ce4bd13c494743e);
$parcel$export(module.exports, "acceptPropAsAcceptAttr", () => $aaac53b849ab07d4$export$1278288bcefb97b9);
$parcel$export(module.exports, "isAbort", () => $aaac53b849ab07d4$export$72580c77a176a18f);
$parcel$export(module.exports, "isSecurityError", () => $aaac53b849ab07d4$export$c4f82d4432e209a9);

var $0dzo3 = parcelRequire("0dzo3");
function $aaac53b849ab07d4$var$_toConsumableArray(arr) {
    return $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) || $aaac53b849ab07d4$var$_iterableToArray(arr) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr) || $aaac53b849ab07d4$var$_nonIterableSpread();
}
function $aaac53b849ab07d4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aaac53b849ab07d4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aaac53b849ab07d4$var$_arrayLikeToArray(arr);
}
function $aaac53b849ab07d4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aaac53b849ab07d4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $aaac53b849ab07d4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $aaac53b849ab07d4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $aaac53b849ab07d4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aaac53b849ab07d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aaac53b849ab07d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aaac53b849ab07d4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aaac53b849ab07d4$var$_typeof(obj);
}
function $aaac53b849ab07d4$var$_slicedToArray(arr, i) {
    return $aaac53b849ab07d4$var$_arrayWithHoles(arr) || $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) || $aaac53b849ab07d4$var$_unsupportedIterableToArray(arr, i) || $aaac53b849ab07d4$var$_nonIterableRest();
}
function $aaac53b849ab07d4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aaac53b849ab07d4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aaac53b849ab07d4$var$_arrayLikeToArray(o, minLen);
}
function $aaac53b849ab07d4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $aaac53b849ab07d4$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $aaac53b849ab07d4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $aaac53b849ab07d4$export$d2c35cc369247232 = "file-invalid-type";
var $aaac53b849ab07d4$export$d7bd1185abe1e87c = "file-too-large";
var $aaac53b849ab07d4$export$8bd5ec6ed990dc9 = "file-too-small";
var $aaac53b849ab07d4$export$3271ef1d2dd155f9 = "too-many-files";
var $aaac53b849ab07d4$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $aaac53b849ab07d4$export$d2c35cc369247232,
    FileTooLarge: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
    FileTooSmall: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
    TooManyFiles: $aaac53b849ab07d4$export$3271ef1d2dd155f9
}; // File Errors
var $aaac53b849ab07d4$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $aaac53b849ab07d4$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $aaac53b849ab07d4$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $aaac53b849ab07d4$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $aaac53b849ab07d4$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $aaac53b849ab07d4$export$1e1e1b6120329fe = {
    code: $aaac53b849ab07d4$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $aaac53b849ab07d4$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $0dzo3.default)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $aaac53b849ab07d4$export$bc0bbda045f09b5a(accept)
    ];
}
function $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($aaac53b849ab07d4$var$isDefined(file.size)) {
        if ($aaac53b849ab07d4$var$isDefined(minSize) && $aaac53b849ab07d4$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($aaac53b849ab07d4$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $aaac53b849ab07d4$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($aaac53b849ab07d4$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $aaac53b849ab07d4$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $aaac53b849ab07d4$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $aaac53b849ab07d4$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $aaac53b849ab07d4$export$b511db3632effe58(file, accept), _fileAccepted2 = $aaac53b849ab07d4$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $aaac53b849ab07d4$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $aaac53b849ab07d4$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $aaac53b849ab07d4$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $aaac53b849ab07d4$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $aaac53b849ab07d4$export$f9006bf02b243736(item) {
    return $aaac53b849ab07d4$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $aaac53b849ab07d4$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $aaac53b849ab07d4$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $aaac53b849ab07d4$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $aaac53b849ab07d4$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $aaac53b849ab07d4$var$isIe(userAgent) || $aaac53b849ab07d4$var$isEdge(userAgent);
}
function $aaac53b849ab07d4$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$aaac53b849ab07d4$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $aaac53b849ab07d4$export$8d6d6472146de265(event);
        });
    };
}
function $aaac53b849ab07d4$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $aaac53b849ab07d4$export$8ce4bd13c494743e(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $aaac53b849ab07d4$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$aaac53b849ab07d4$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($aaac53b849ab07d4$export$42c2be5a6d408120)) {
                console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $aaac53b849ab07d4$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $aaac53b849ab07d4$var$_objectSpread($aaac53b849ab07d4$var$_objectSpread({}, agg), {}, $aaac53b849ab07d4$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $aaac53b849ab07d4$export$1278288bcefb97b9(accept) {
    if ($aaac53b849ab07d4$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $aaac53b849ab07d4$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($aaac53b849ab07d4$var$_toConsumableArray(a), [
            mimeType
        ], $aaac53b849ab07d4$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) || $aaac53b849ab07d4$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $aaac53b849ab07d4$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $aaac53b849ab07d4$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $aaac53b849ab07d4$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $aaac53b849ab07d4$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 

});
parcelRegister("0dzo3", function(module, exports) {

$parcel$export(module.exports, "default", () => $000a86df99a95c54$export$2e2bcd8739ae039, (v) => $000a86df99a95c54$export$2e2bcd8739ae039 = v);
var $000a86df99a95c54$export$1e511d4a378977f5;
var $000a86df99a95c54$export$2e2bcd8739ae039;
"use strict";
$000a86df99a95c54$export$1e511d4a378977f5 = true;
$000a86df99a95c54$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
        if (acceptedFilesArray.length === 0) return true;
        var fileName = file.name || '';
        var mimeType = (file.type || '').toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, '');
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === '.') return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith('/*')) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, '');
            return mimeType === validType;
        });
    }
    return true;
};

});



parcelRegister("bL3Lu", function(module, exports) {

$parcel$export(module.exports, "LoadingOverlay", () => $88f70124a06a06f6$export$3fb99980b01d36b1);

var $acw62 = parcelRequire("acw62");

var $iu1L3 = parcelRequire("iu1L3");
var $64A2P = parcelRequire("64A2P");

var $9NdKe = parcelRequire("9NdKe");

var $1RCXp = parcelRequire("1RCXp");

var $hiiR1 = parcelRequire("hiiR1");

var $4P91H = parcelRequire("4P91H");

var $hgiQh = parcelRequire("hgiQh");
var $88f70124a06a06f6$var$__defProp = Object.defineProperty;
var $88f70124a06a06f6$var$__defProps = Object.defineProperties;
var $88f70124a06a06f6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $88f70124a06a06f6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $88f70124a06a06f6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $88f70124a06a06f6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $88f70124a06a06f6$var$__defNormalProp = (obj, key, value)=>key in obj ? $88f70124a06a06f6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $88f70124a06a06f6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($88f70124a06a06f6$var$__hasOwnProp.call(b, prop)) $88f70124a06a06f6$var$__defNormalProp(a, prop, b[prop]);
    if ($88f70124a06a06f6$var$__getOwnPropSymbols) {
        for (var prop of $88f70124a06a06f6$var$__getOwnPropSymbols(b))if ($88f70124a06a06f6$var$__propIsEnum.call(b, prop)) $88f70124a06a06f6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $88f70124a06a06f6$var$__spreadProps = (a, b)=>$88f70124a06a06f6$var$__defProps(a, $88f70124a06a06f6$var$__getOwnPropDescs(b));
var $88f70124a06a06f6$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($88f70124a06a06f6$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $88f70124a06a06f6$var$__getOwnPropSymbols) {
        for (var prop of $88f70124a06a06f6$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $88f70124a06a06f6$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
const $88f70124a06a06f6$var$defaultProps = {
    overlayOpacity: 0.75,
    transitionDuration: 0,
    radius: 0,
    zIndex: (0, $iu1L3.getDefaultZIndex)("overlay")
};
const $88f70124a06a06f6$export$3fb99980b01d36b1 = (0, $acw62.forwardRef)((props, ref)=>{
    const _a = (0, $64A2P.useComponentDefaultProps)("LoadingOverlay", $88f70124a06a06f6$var$defaultProps, props), { className: className, visible: visible, loaderProps: loaderProps, overlayOpacity: overlayOpacity, overlayColor: overlayColor, transitionDuration: transitionDuration, exitTransitionDuration: exitTransitionDuration, zIndex: zIndex, style: style, loader: loader, radius: radius, overlayBlur: overlayBlur, unstyled: unstyled, variant: variant, keepMounted: keepMounted } = _a, others = $88f70124a06a06f6$var$__objRest(_a, [
        "className",
        "visible",
        "loaderProps",
        "overlayOpacity",
        "overlayColor",
        "transitionDuration",
        "exitTransitionDuration",
        "zIndex",
        "style",
        "loader",
        "radius",
        "overlayBlur",
        "unstyled",
        "variant",
        "keepMounted"
    ]);
    const { classes: classes, cx: cx, theme: theme } = (0, $9NdKe.default)(null, {
        name: "LoadingOverlay",
        unstyled: unstyled,
        variant: variant
    });
    const _zIndex = `calc(${zIndex} + 1)`;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1RCXp.Transition), {
        keepMounted: keepMounted,
        duration: transitionDuration,
        exitDuration: exitTransitionDuration,
        mounted: visible,
        transition: "fade"
    }, (transitionStyles)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hiiR1.Box), $88f70124a06a06f6$var$__spreadValues({
            className: cx(classes.root, className),
            style: $88f70124a06a06f6$var$__spreadProps($88f70124a06a06f6$var$__spreadValues($88f70124a06a06f6$var$__spreadValues({}, transitionStyles), style), {
                zIndex: zIndex
            }),
            ref: ref
        }, others), loader ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            style: {
                zIndex: _zIndex
            }
        }, loader) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4P91H.Loader), $88f70124a06a06f6$var$__spreadValues({
            style: {
                zIndex: _zIndex
            }
        }, loaderProps)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hgiQh.Overlay), {
            opacity: overlayOpacity,
            zIndex: zIndex,
            radius: radius,
            blur: overlayBlur,
            unstyled: unstyled,
            color: overlayColor || (theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.white)
        })));
});
$88f70124a06a06f6$export$3fb99980b01d36b1.displayName = "@mantine/core/LoadingOverlay";

});
parcelRegister("9NdKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $72135a14c186051a$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $72135a14c186051a$var$__defProp = Object.defineProperty;
var $72135a14c186051a$var$__defProps = Object.defineProperties;
var $72135a14c186051a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $72135a14c186051a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $72135a14c186051a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $72135a14c186051a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $72135a14c186051a$var$__defNormalProp = (obj, key, value)=>key in obj ? $72135a14c186051a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $72135a14c186051a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($72135a14c186051a$var$__hasOwnProp.call(b, prop)) $72135a14c186051a$var$__defNormalProp(a, prop, b[prop]);
    if ($72135a14c186051a$var$__getOwnPropSymbols) {
        for (var prop of $72135a14c186051a$var$__getOwnPropSymbols(b))if ($72135a14c186051a$var$__propIsEnum.call(b, prop)) $72135a14c186051a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $72135a14c186051a$var$__spreadProps = (a, b)=>$72135a14c186051a$var$__defProps(a, $72135a14c186051a$var$__getOwnPropDescs(b));
var $72135a14c186051a$var$useStyles = (0, $cQG1Y.createStyles)((theme)=>({
        root: $72135a14c186051a$var$__spreadProps($72135a14c186051a$var$__spreadValues({}, theme.fn.cover()), {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden"
        })
    }));
var $72135a14c186051a$export$2e2bcd8739ae039 = $72135a14c186051a$var$useStyles;

});


parcelRegister("lRfNl", function(module, exports) {

$parcel$export(module.exports, "DropzoneProvider", () => $fe9accc40d210d8f$export$561aa80206f7f051);
$parcel$export(module.exports, "useDropzoneContext", () => $fe9accc40d210d8f$export$20947e11def173e4);

var $jIWSq = parcelRequire("jIWSq");
const [$fe9accc40d210d8f$export$561aa80206f7f051, $fe9accc40d210d8f$export$20947e11def173e4] = (0, $jIWSq.createSafeContext)("Dropzone component was not found in tree");

});

parcelRegister("eL3TN", function(module, exports) {

$parcel$export(module.exports, "DropzoneAccept", () => $abe87ab833fb0265$export$53f482688ae8b673);
$parcel$export(module.exports, "DropzoneReject", () => $abe87ab833fb0265$export$f0ddf5e95017b2b5);
$parcel$export(module.exports, "DropzoneIdle", () => $abe87ab833fb0265$export$4023578ef0d3ae1f);

var $acw62 = parcelRequire("acw62");

var $9gJ4P = parcelRequire("9gJ4P");

var $cOXe5 = parcelRequire("cOXe5");

var $64A2P = parcelRequire("64A2P");

var $lRfNl = parcelRequire("lRfNl");
var $abe87ab833fb0265$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $abe87ab833fb0265$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $abe87ab833fb0265$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $abe87ab833fb0265$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($abe87ab833fb0265$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $abe87ab833fb0265$var$__getOwnPropSymbols) {
        for (var prop of $abe87ab833fb0265$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $abe87ab833fb0265$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
function $abe87ab833fb0265$var$createDropzoneStatus(status) {
    const Component = (props)=>{
        const _a = (0, $64A2P.useComponentDefaultProps)(`Dropzone${(0, $9gJ4P.upperFirst)(status)}`, {}, props), { children: children } = _a, others = $abe87ab833fb0265$var$__objRest(_a, [
            "children"
        ]);
        const ctx = (0, $lRfNl.useDropzoneContext)();
        const _children = (0, $cOXe5.isElement)(children) ? children : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, children);
        if (ctx[status]) return (0, $acw62.cloneElement)(_children, others);
        return null;
    };
    Component.displayName = `@mantine/dropzone/${(0, $9gJ4P.upperFirst)(status)}`;
    return Component;
}
const $abe87ab833fb0265$export$53f482688ae8b673 = $abe87ab833fb0265$var$createDropzoneStatus("accept");
const $abe87ab833fb0265$export$f0ddf5e95017b2b5 = $abe87ab833fb0265$var$createDropzoneStatus("reject");
const $abe87ab833fb0265$export$4023578ef0d3ae1f = $abe87ab833fb0265$var$createDropzoneStatus("idle");

});
parcelRegister("9gJ4P", function(module, exports) {

$parcel$export(module.exports, "upperFirst", () => $6bf89307695c1382$export$3061f22cd819074d);
function $6bf89307695c1382$export$3061f22cd819074d(value) {
    return typeof value !== "string" ? "" : value.charAt(0).toUpperCase() + value.slice(1);
}

});


parcelRegister("fcrD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10d6882ffbd8b7c$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $d8Ix8 = parcelRequire("d8Ix8");
var $2jkdX = parcelRequire("2jkdX");
var $b10d6882ffbd8b7c$var$__defProp = Object.defineProperty;
var $b10d6882ffbd8b7c$var$__defProps = Object.defineProperties;
var $b10d6882ffbd8b7c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b10d6882ffbd8b7c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b10d6882ffbd8b7c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b10d6882ffbd8b7c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b10d6882ffbd8b7c$var$__defNormalProp = (obj, key, value)=>key in obj ? $b10d6882ffbd8b7c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b10d6882ffbd8b7c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b10d6882ffbd8b7c$var$__hasOwnProp.call(b, prop)) $b10d6882ffbd8b7c$var$__defNormalProp(a, prop, b[prop]);
    if ($b10d6882ffbd8b7c$var$__getOwnPropSymbols) {
        for (var prop of $b10d6882ffbd8b7c$var$__getOwnPropSymbols(b))if ($b10d6882ffbd8b7c$var$__propIsEnum.call(b, prop)) $b10d6882ffbd8b7c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b10d6882ffbd8b7c$var$__spreadProps = (a, b)=>$b10d6882ffbd8b7c$var$__defProps(a, $b10d6882ffbd8b7c$var$__getOwnPropDescs(b));
var $b10d6882ffbd8b7c$var$useStyles = (0, $cQG1Y.createStyles)((theme, { padding: padding, radius: radius })=>{
    const rejected = theme.fn.variant({
        color: "red",
        variant: "light"
    });
    const accepted = theme.fn.variant({
        color: theme.primaryColor,
        variant: "light"
    });
    return {
        root: $b10d6882ffbd8b7c$var$__spreadProps($b10d6882ffbd8b7c$var$__spreadValues($b10d6882ffbd8b7c$var$__spreadValues({}, theme.fn.fontStyles()), theme.fn.focusStyles()), {
            boxSizing: "border-box",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            border: `${(0, $2jkdX.rem)(2)} dashed ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
            padding: (0, $d8Ix8.getSize)({
                size: padding,
                sizes: theme.spacing
            }),
            borderRadius: theme.fn.radius(radius),
            cursor: "pointer",
            userSelect: "none",
            transition: "background-color 150ms ease",
            position: "relative",
            "&:hover": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
            },
            "&[data-loading]": {
                cursor: "default",
                "&:hover": {
                    backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
                }
            },
            "&[data-accept]": {
                backgroundColor: theme.colorScheme === "dark" ? accepted.background : theme.colors[theme.primaryColor][0],
                borderColor: theme.colorScheme === "dark" ? accepted.border : theme.colors[theme.primaryColor][4],
                "&:hover": {
                    backgroundColor: theme.colorScheme === "dark" ? accepted.background : theme.colors[theme.primaryColor][0]
                }
            },
            "&[data-reject]": {
                backgroundColor: theme.colorScheme === "dark" ? rejected.background : theme.colors.red[0],
                borderColor: theme.colorScheme === "dark" ? rejected.border : theme.colors.red[4],
                "&:hover": {
                    backgroundColor: theme.colorScheme === "dark" ? rejected.background : theme.colors.red[0]
                }
            }
        }),
        inner: {
            pointerEvents: "none",
            userSelect: "none"
        }
    };
});
var $b10d6882ffbd8b7c$export$2e2bcd8739ae039 = $b10d6882ffbd8b7c$var$useStyles;

});


parcelRegister("bBp1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $87268e9b2c3942b6$export$2e2bcd8739ae039);

var $cQG1Y = parcelRequire("cQG1Y");
var $87268e9b2c3942b6$var$__defProp = Object.defineProperty;
var $87268e9b2c3942b6$var$__defProps = Object.defineProperties;
var $87268e9b2c3942b6$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $87268e9b2c3942b6$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $87268e9b2c3942b6$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $87268e9b2c3942b6$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $87268e9b2c3942b6$var$__defNormalProp = (obj, key, value)=>key in obj ? $87268e9b2c3942b6$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $87268e9b2c3942b6$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($87268e9b2c3942b6$var$__hasOwnProp.call(b, prop)) $87268e9b2c3942b6$var$__defNormalProp(a, prop, b[prop]);
    if ($87268e9b2c3942b6$var$__getOwnPropSymbols) {
        for (var prop of $87268e9b2c3942b6$var$__getOwnPropSymbols(b))if ($87268e9b2c3942b6$var$__propIsEnum.call(b, prop)) $87268e9b2c3942b6$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $87268e9b2c3942b6$var$__spreadProps = (a, b)=>$87268e9b2c3942b6$var$__defProps(a, $87268e9b2c3942b6$var$__getOwnPropDescs(b));
var $87268e9b2c3942b6$var$useFullScreenStyles = (0, $cQG1Y.createStyles)((theme)=>({
        wrapper: $87268e9b2c3942b6$var$__spreadProps($87268e9b2c3942b6$var$__spreadValues({}, theme.fn.cover(0)), {
            position: "fixed",
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
            display: "flex",
            padding: theme.spacing.xs,
            transition: "opacity 100ms ease"
        }),
        dropzone: {
            flex: 1
        }
    }));
var $87268e9b2c3942b6$export$2e2bcd8739ae039 = $87268e9b2c3942b6$var$useFullScreenStyles;

});


parcelRegister("kVo2K", function(module, exports) {

$parcel$export(module.exports, "IMAGE_MIME_TYPE", () => $f3bbc80878264519$export$d67ec39b13705479);
const $f3bbc80878264519$export$edfb5d7e4280f611 = {
    png: "image/png",
    gif: "image/gif",
    jpeg: "image/jpeg",
    svg: "image/svg+xml",
    webp: "image/webp",
    avif: "image/avif",
    mp4: "video/mp4",
    zip: "application/zip",
    csv: "text/csv",
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    exe: "application/vnd.microsoft.portable-executable"
};
const $f3bbc80878264519$export$d67ec39b13705479 = [
    $f3bbc80878264519$export$edfb5d7e4280f611.png,
    $f3bbc80878264519$export$edfb5d7e4280f611.gif,
    $f3bbc80878264519$export$edfb5d7e4280f611.jpeg,
    $f3bbc80878264519$export$edfb5d7e4280f611.svg,
    $f3bbc80878264519$export$edfb5d7e4280f611.webp,
    $f3bbc80878264519$export$edfb5d7e4280f611.avif
];
const $f3bbc80878264519$export$b5783e25faaa1733 = [
    $f3bbc80878264519$export$edfb5d7e4280f611.pdf
];
const $f3bbc80878264519$export$395c8f86611da596 = [
    $f3bbc80878264519$export$edfb5d7e4280f611.doc,
    $f3bbc80878264519$export$edfb5d7e4280f611.docx
];
const $f3bbc80878264519$export$aef34762790ac242 = [
    $f3bbc80878264519$export$edfb5d7e4280f611.xls,
    $f3bbc80878264519$export$edfb5d7e4280f611.xlsx
];
const $f3bbc80878264519$export$b80ddf784a3c1273 = [
    $f3bbc80878264519$export$edfb5d7e4280f611.ppt,
    $f3bbc80878264519$export$edfb5d7e4280f611.pptx
];
const $f3bbc80878264519$export$60eea9cb938535aa = [
    $f3bbc80878264519$export$edfb5d7e4280f611.exe
];

});


parcelRegister("ehweP", function(module, exports) {
'use strict';

var $4uCqb = parcelRequire("4uCqb");


module.exports = new $4uCqb((parcelRequire("2XWkz")), (parcelRequire("lMmGq")));

});
parcelRegister("4uCqb", function(module, exports) {
'use strict';
/**
 * @param typeMap [Object] Map of MIME type -> Array[extensions]
 * @param ...
 */ function $3457c470d238f95b$var$Mime() {
    this._types = Object.create(null);
    this._extensions = Object.create(null);
    for(let i = 0; i < arguments.length; i++)this.define(arguments[i]);
    this.define = this.define.bind(this);
    this.getType = this.getType.bind(this);
    this.getExtension = this.getExtension.bind(this);
}
/**
 * Define mimetype -> extension mappings.  Each key is a mime-type that maps
 * to an array of extensions associated with the type.  The first extension is
 * used as the default extension for the type.
 *
 * e.g. mime.define({'audio/ogg', ['oga', 'ogg', 'spx']});
 *
 * If a type declares an extension that has already been defined, an error will
 * be thrown.  To suppress this error and force the extension to be associated
 * with the new type, pass `force`=true.  Alternatively, you may prefix the
 * extension with "*" to map the type to extension, without mapping the
 * extension to the type.
 *
 * e.g. mime.define({'audio/wav', ['wav']}, {'audio/x-wav', ['*wav']});
 *
 *
 * @param map (Object) type definitions
 * @param force (Boolean) if true, force overriding of existing definitions
 */ $3457c470d238f95b$var$Mime.prototype.define = function(typeMap, force) {
    for(let type in typeMap){
        let extensions = typeMap[type].map(function(t) {
            return t.toLowerCase();
        });
        type = type.toLowerCase();
        for(let i = 0; i < extensions.length; i++){
            const ext = extensions[i];
            // '*' prefix = not the preferred type for this extension.  So fixup the
            // extension, and skip it.
            if (ext[0] === '*') continue;
            if (!force && ext in this._types) throw new Error('Attempt to change mapping for "' + ext + '" extension from "' + this._types[ext] + '" to "' + type + '". Pass `force=true` to allow this, otherwise remove "' + ext + '" from the list of extensions for "' + type + '".');
            this._types[ext] = type;
        }
        // Use first extension as default
        if (force || !this._extensions[type]) {
            const ext = extensions[0];
            this._extensions[type] = ext[0] !== '*' ? ext : ext.substr(1);
        }
    }
};
/**
 * Lookup a mime type based on extension
 */ $3457c470d238f95b$var$Mime.prototype.getType = function(path) {
    path = String(path);
    let last = path.replace(/^.*[/\\]/, '').toLowerCase();
    let ext = last.replace(/^.*\./, '').toLowerCase();
    let hasPath = last.length < path.length;
    let hasDot = ext.length < last.length - 1;
    return (hasDot || !hasPath) && this._types[ext] || null;
};
/**
 * Return file extension associated with a mime type
 */ $3457c470d238f95b$var$Mime.prototype.getExtension = function(type) {
    type = /^\s*([^;\s]*)/.test(type) && RegExp.$1;
    return type && this._extensions[type.toLowerCase()] || null;
};
module.exports = $3457c470d238f95b$var$Mime;

});

parcelRegister("2XWkz", function(module, exports) {
module.exports = {
    "application/andrew-inset": [
        "ez"
    ],
    "application/applixware": [
        "aw"
    ],
    "application/atom+xml": [
        "atom"
    ],
    "application/atomcat+xml": [
        "atomcat"
    ],
    "application/atomdeleted+xml": [
        "atomdeleted"
    ],
    "application/atomsvc+xml": [
        "atomsvc"
    ],
    "application/atsc-dwd+xml": [
        "dwd"
    ],
    "application/atsc-held+xml": [
        "held"
    ],
    "application/atsc-rsat+xml": [
        "rsat"
    ],
    "application/bdoc": [
        "bdoc"
    ],
    "application/calendar+xml": [
        "xcs"
    ],
    "application/ccxml+xml": [
        "ccxml"
    ],
    "application/cdfx+xml": [
        "cdfx"
    ],
    "application/cdmi-capability": [
        "cdmia"
    ],
    "application/cdmi-container": [
        "cdmic"
    ],
    "application/cdmi-domain": [
        "cdmid"
    ],
    "application/cdmi-object": [
        "cdmio"
    ],
    "application/cdmi-queue": [
        "cdmiq"
    ],
    "application/cu-seeme": [
        "cu"
    ],
    "application/dash+xml": [
        "mpd"
    ],
    "application/davmount+xml": [
        "davmount"
    ],
    "application/docbook+xml": [
        "dbk"
    ],
    "application/dssc+der": [
        "dssc"
    ],
    "application/dssc+xml": [
        "xdssc"
    ],
    "application/ecmascript": [
        "es",
        "ecma"
    ],
    "application/emma+xml": [
        "emma"
    ],
    "application/emotionml+xml": [
        "emotionml"
    ],
    "application/epub+zip": [
        "epub"
    ],
    "application/exi": [
        "exi"
    ],
    "application/express": [
        "exp"
    ],
    "application/fdt+xml": [
        "fdt"
    ],
    "application/font-tdpfr": [
        "pfr"
    ],
    "application/geo+json": [
        "geojson"
    ],
    "application/gml+xml": [
        "gml"
    ],
    "application/gpx+xml": [
        "gpx"
    ],
    "application/gxf": [
        "gxf"
    ],
    "application/gzip": [
        "gz"
    ],
    "application/hjson": [
        "hjson"
    ],
    "application/hyperstudio": [
        "stk"
    ],
    "application/inkml+xml": [
        "ink",
        "inkml"
    ],
    "application/ipfix": [
        "ipfix"
    ],
    "application/its+xml": [
        "its"
    ],
    "application/java-archive": [
        "jar",
        "war",
        "ear"
    ],
    "application/java-serialized-object": [
        "ser"
    ],
    "application/java-vm": [
        "class"
    ],
    "application/javascript": [
        "js",
        "mjs"
    ],
    "application/json": [
        "json",
        "map"
    ],
    "application/json5": [
        "json5"
    ],
    "application/jsonml+json": [
        "jsonml"
    ],
    "application/ld+json": [
        "jsonld"
    ],
    "application/lgr+xml": [
        "lgr"
    ],
    "application/lost+xml": [
        "lostxml"
    ],
    "application/mac-binhex40": [
        "hqx"
    ],
    "application/mac-compactpro": [
        "cpt"
    ],
    "application/mads+xml": [
        "mads"
    ],
    "application/manifest+json": [
        "webmanifest"
    ],
    "application/marc": [
        "mrc"
    ],
    "application/marcxml+xml": [
        "mrcx"
    ],
    "application/mathematica": [
        "ma",
        "nb",
        "mb"
    ],
    "application/mathml+xml": [
        "mathml"
    ],
    "application/mbox": [
        "mbox"
    ],
    "application/mediaservercontrol+xml": [
        "mscml"
    ],
    "application/metalink+xml": [
        "metalink"
    ],
    "application/metalink4+xml": [
        "meta4"
    ],
    "application/mets+xml": [
        "mets"
    ],
    "application/mmt-aei+xml": [
        "maei"
    ],
    "application/mmt-usd+xml": [
        "musd"
    ],
    "application/mods+xml": [
        "mods"
    ],
    "application/mp21": [
        "m21",
        "mp21"
    ],
    "application/mp4": [
        "mp4s",
        "m4p"
    ],
    "application/msword": [
        "doc",
        "dot"
    ],
    "application/mxf": [
        "mxf"
    ],
    "application/n-quads": [
        "nq"
    ],
    "application/n-triples": [
        "nt"
    ],
    "application/node": [
        "cjs"
    ],
    "application/octet-stream": [
        "bin",
        "dms",
        "lrf",
        "mar",
        "so",
        "dist",
        "distz",
        "pkg",
        "bpk",
        "dump",
        "elc",
        "deploy",
        "exe",
        "dll",
        "deb",
        "dmg",
        "iso",
        "img",
        "msi",
        "msp",
        "msm",
        "buffer"
    ],
    "application/oda": [
        "oda"
    ],
    "application/oebps-package+xml": [
        "opf"
    ],
    "application/ogg": [
        "ogx"
    ],
    "application/omdoc+xml": [
        "omdoc"
    ],
    "application/onenote": [
        "onetoc",
        "onetoc2",
        "onetmp",
        "onepkg"
    ],
    "application/oxps": [
        "oxps"
    ],
    "application/p2p-overlay+xml": [
        "relo"
    ],
    "application/patch-ops-error+xml": [
        "xer"
    ],
    "application/pdf": [
        "pdf"
    ],
    "application/pgp-encrypted": [
        "pgp"
    ],
    "application/pgp-signature": [
        "asc",
        "sig"
    ],
    "application/pics-rules": [
        "prf"
    ],
    "application/pkcs10": [
        "p10"
    ],
    "application/pkcs7-mime": [
        "p7m",
        "p7c"
    ],
    "application/pkcs7-signature": [
        "p7s"
    ],
    "application/pkcs8": [
        "p8"
    ],
    "application/pkix-attr-cert": [
        "ac"
    ],
    "application/pkix-cert": [
        "cer"
    ],
    "application/pkix-crl": [
        "crl"
    ],
    "application/pkix-pkipath": [
        "pkipath"
    ],
    "application/pkixcmp": [
        "pki"
    ],
    "application/pls+xml": [
        "pls"
    ],
    "application/postscript": [
        "ai",
        "eps",
        "ps"
    ],
    "application/provenance+xml": [
        "provx"
    ],
    "application/pskc+xml": [
        "pskcxml"
    ],
    "application/raml+yaml": [
        "raml"
    ],
    "application/rdf+xml": [
        "rdf",
        "owl"
    ],
    "application/reginfo+xml": [
        "rif"
    ],
    "application/relax-ng-compact-syntax": [
        "rnc"
    ],
    "application/resource-lists+xml": [
        "rl"
    ],
    "application/resource-lists-diff+xml": [
        "rld"
    ],
    "application/rls-services+xml": [
        "rs"
    ],
    "application/route-apd+xml": [
        "rapd"
    ],
    "application/route-s-tsid+xml": [
        "sls"
    ],
    "application/route-usd+xml": [
        "rusd"
    ],
    "application/rpki-ghostbusters": [
        "gbr"
    ],
    "application/rpki-manifest": [
        "mft"
    ],
    "application/rpki-roa": [
        "roa"
    ],
    "application/rsd+xml": [
        "rsd"
    ],
    "application/rss+xml": [
        "rss"
    ],
    "application/rtf": [
        "rtf"
    ],
    "application/sbml+xml": [
        "sbml"
    ],
    "application/scvp-cv-request": [
        "scq"
    ],
    "application/scvp-cv-response": [
        "scs"
    ],
    "application/scvp-vp-request": [
        "spq"
    ],
    "application/scvp-vp-response": [
        "spp"
    ],
    "application/sdp": [
        "sdp"
    ],
    "application/senml+xml": [
        "senmlx"
    ],
    "application/sensml+xml": [
        "sensmlx"
    ],
    "application/set-payment-initiation": [
        "setpay"
    ],
    "application/set-registration-initiation": [
        "setreg"
    ],
    "application/shf+xml": [
        "shf"
    ],
    "application/sieve": [
        "siv",
        "sieve"
    ],
    "application/smil+xml": [
        "smi",
        "smil"
    ],
    "application/sparql-query": [
        "rq"
    ],
    "application/sparql-results+xml": [
        "srx"
    ],
    "application/srgs": [
        "gram"
    ],
    "application/srgs+xml": [
        "grxml"
    ],
    "application/sru+xml": [
        "sru"
    ],
    "application/ssdl+xml": [
        "ssdl"
    ],
    "application/ssml+xml": [
        "ssml"
    ],
    "application/swid+xml": [
        "swidtag"
    ],
    "application/tei+xml": [
        "tei",
        "teicorpus"
    ],
    "application/thraud+xml": [
        "tfi"
    ],
    "application/timestamped-data": [
        "tsd"
    ],
    "application/toml": [
        "toml"
    ],
    "application/trig": [
        "trig"
    ],
    "application/ttml+xml": [
        "ttml"
    ],
    "application/ubjson": [
        "ubj"
    ],
    "application/urc-ressheet+xml": [
        "rsheet"
    ],
    "application/urc-targetdesc+xml": [
        "td"
    ],
    "application/voicexml+xml": [
        "vxml"
    ],
    "application/wasm": [
        "wasm"
    ],
    "application/widget": [
        "wgt"
    ],
    "application/winhlp": [
        "hlp"
    ],
    "application/wsdl+xml": [
        "wsdl"
    ],
    "application/wspolicy+xml": [
        "wspolicy"
    ],
    "application/xaml+xml": [
        "xaml"
    ],
    "application/xcap-att+xml": [
        "xav"
    ],
    "application/xcap-caps+xml": [
        "xca"
    ],
    "application/xcap-diff+xml": [
        "xdf"
    ],
    "application/xcap-el+xml": [
        "xel"
    ],
    "application/xcap-ns+xml": [
        "xns"
    ],
    "application/xenc+xml": [
        "xenc"
    ],
    "application/xhtml+xml": [
        "xhtml",
        "xht"
    ],
    "application/xliff+xml": [
        "xlf"
    ],
    "application/xml": [
        "xml",
        "xsl",
        "xsd",
        "rng"
    ],
    "application/xml-dtd": [
        "dtd"
    ],
    "application/xop+xml": [
        "xop"
    ],
    "application/xproc+xml": [
        "xpl"
    ],
    "application/xslt+xml": [
        "*xsl",
        "xslt"
    ],
    "application/xspf+xml": [
        "xspf"
    ],
    "application/xv+xml": [
        "mxml",
        "xhvml",
        "xvml",
        "xvm"
    ],
    "application/yang": [
        "yang"
    ],
    "application/yin+xml": [
        "yin"
    ],
    "application/zip": [
        "zip"
    ],
    "audio/3gpp": [
        "*3gpp"
    ],
    "audio/adpcm": [
        "adp"
    ],
    "audio/amr": [
        "amr"
    ],
    "audio/basic": [
        "au",
        "snd"
    ],
    "audio/midi": [
        "mid",
        "midi",
        "kar",
        "rmi"
    ],
    "audio/mobile-xmf": [
        "mxmf"
    ],
    "audio/mp3": [
        "*mp3"
    ],
    "audio/mp4": [
        "m4a",
        "mp4a"
    ],
    "audio/mpeg": [
        "mpga",
        "mp2",
        "mp2a",
        "mp3",
        "m2a",
        "m3a"
    ],
    "audio/ogg": [
        "oga",
        "ogg",
        "spx",
        "opus"
    ],
    "audio/s3m": [
        "s3m"
    ],
    "audio/silk": [
        "sil"
    ],
    "audio/wav": [
        "wav"
    ],
    "audio/wave": [
        "*wav"
    ],
    "audio/webm": [
        "weba"
    ],
    "audio/xm": [
        "xm"
    ],
    "font/collection": [
        "ttc"
    ],
    "font/otf": [
        "otf"
    ],
    "font/ttf": [
        "ttf"
    ],
    "font/woff": [
        "woff"
    ],
    "font/woff2": [
        "woff2"
    ],
    "image/aces": [
        "exr"
    ],
    "image/apng": [
        "apng"
    ],
    "image/avif": [
        "avif"
    ],
    "image/bmp": [
        "bmp"
    ],
    "image/cgm": [
        "cgm"
    ],
    "image/dicom-rle": [
        "drle"
    ],
    "image/emf": [
        "emf"
    ],
    "image/fits": [
        "fits"
    ],
    "image/g3fax": [
        "g3"
    ],
    "image/gif": [
        "gif"
    ],
    "image/heic": [
        "heic"
    ],
    "image/heic-sequence": [
        "heics"
    ],
    "image/heif": [
        "heif"
    ],
    "image/heif-sequence": [
        "heifs"
    ],
    "image/hej2k": [
        "hej2"
    ],
    "image/hsj2": [
        "hsj2"
    ],
    "image/ief": [
        "ief"
    ],
    "image/jls": [
        "jls"
    ],
    "image/jp2": [
        "jp2",
        "jpg2"
    ],
    "image/jpeg": [
        "jpeg",
        "jpg",
        "jpe"
    ],
    "image/jph": [
        "jph"
    ],
    "image/jphc": [
        "jhc"
    ],
    "image/jpm": [
        "jpm"
    ],
    "image/jpx": [
        "jpx",
        "jpf"
    ],
    "image/jxr": [
        "jxr"
    ],
    "image/jxra": [
        "jxra"
    ],
    "image/jxrs": [
        "jxrs"
    ],
    "image/jxs": [
        "jxs"
    ],
    "image/jxsc": [
        "jxsc"
    ],
    "image/jxsi": [
        "jxsi"
    ],
    "image/jxss": [
        "jxss"
    ],
    "image/ktx": [
        "ktx"
    ],
    "image/ktx2": [
        "ktx2"
    ],
    "image/png": [
        "png"
    ],
    "image/sgi": [
        "sgi"
    ],
    "image/svg+xml": [
        "svg",
        "svgz"
    ],
    "image/t38": [
        "t38"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/tiff-fx": [
        "tfx"
    ],
    "image/webp": [
        "webp"
    ],
    "image/wmf": [
        "wmf"
    ],
    "message/disposition-notification": [
        "disposition-notification"
    ],
    "message/global": [
        "u8msg"
    ],
    "message/global-delivery-status": [
        "u8dsn"
    ],
    "message/global-disposition-notification": [
        "u8mdn"
    ],
    "message/global-headers": [
        "u8hdr"
    ],
    "message/rfc822": [
        "eml",
        "mime"
    ],
    "model/3mf": [
        "3mf"
    ],
    "model/gltf+json": [
        "gltf"
    ],
    "model/gltf-binary": [
        "glb"
    ],
    "model/iges": [
        "igs",
        "iges"
    ],
    "model/mesh": [
        "msh",
        "mesh",
        "silo"
    ],
    "model/mtl": [
        "mtl"
    ],
    "model/obj": [
        "obj"
    ],
    "model/step+xml": [
        "stpx"
    ],
    "model/step+zip": [
        "stpz"
    ],
    "model/step-xml+zip": [
        "stpxz"
    ],
    "model/stl": [
        "stl"
    ],
    "model/vrml": [
        "wrl",
        "vrml"
    ],
    "model/x3d+binary": [
        "*x3db",
        "x3dbz"
    ],
    "model/x3d+fastinfoset": [
        "x3db"
    ],
    "model/x3d+vrml": [
        "*x3dv",
        "x3dvz"
    ],
    "model/x3d+xml": [
        "x3d",
        "x3dz"
    ],
    "model/x3d-vrml": [
        "x3dv"
    ],
    "text/cache-manifest": [
        "appcache",
        "manifest"
    ],
    "text/calendar": [
        "ics",
        "ifb"
    ],
    "text/coffeescript": [
        "coffee",
        "litcoffee"
    ],
    "text/css": [
        "css"
    ],
    "text/csv": [
        "csv"
    ],
    "text/html": [
        "html",
        "htm",
        "shtml"
    ],
    "text/jade": [
        "jade"
    ],
    "text/jsx": [
        "jsx"
    ],
    "text/less": [
        "less"
    ],
    "text/markdown": [
        "markdown",
        "md"
    ],
    "text/mathml": [
        "mml"
    ],
    "text/mdx": [
        "mdx"
    ],
    "text/n3": [
        "n3"
    ],
    "text/plain": [
        "txt",
        "text",
        "conf",
        "def",
        "list",
        "log",
        "in",
        "ini"
    ],
    "text/richtext": [
        "rtx"
    ],
    "text/rtf": [
        "*rtf"
    ],
    "text/sgml": [
        "sgml",
        "sgm"
    ],
    "text/shex": [
        "shex"
    ],
    "text/slim": [
        "slim",
        "slm"
    ],
    "text/spdx": [
        "spdx"
    ],
    "text/stylus": [
        "stylus",
        "styl"
    ],
    "text/tab-separated-values": [
        "tsv"
    ],
    "text/troff": [
        "t",
        "tr",
        "roff",
        "man",
        "me",
        "ms"
    ],
    "text/turtle": [
        "ttl"
    ],
    "text/uri-list": [
        "uri",
        "uris",
        "urls"
    ],
    "text/vcard": [
        "vcard"
    ],
    "text/vtt": [
        "vtt"
    ],
    "text/xml": [
        "*xml"
    ],
    "text/yaml": [
        "yaml",
        "yml"
    ],
    "video/3gpp": [
        "3gp",
        "3gpp"
    ],
    "video/3gpp2": [
        "3g2"
    ],
    "video/h261": [
        "h261"
    ],
    "video/h263": [
        "h263"
    ],
    "video/h264": [
        "h264"
    ],
    "video/iso.segment": [
        "m4s"
    ],
    "video/jpeg": [
        "jpgv"
    ],
    "video/jpm": [
        "*jpm",
        "jpgm"
    ],
    "video/mj2": [
        "mj2",
        "mjp2"
    ],
    "video/mp2t": [
        "ts"
    ],
    "video/mp4": [
        "mp4",
        "mp4v",
        "mpg4"
    ],
    "video/mpeg": [
        "mpeg",
        "mpg",
        "mpe",
        "m1v",
        "m2v"
    ],
    "video/ogg": [
        "ogv"
    ],
    "video/quicktime": [
        "qt",
        "mov"
    ],
    "video/webm": [
        "webm"
    ]
};

});

parcelRegister("lMmGq", function(module, exports) {
module.exports = {
    "application/prs.cww": [
        "cww"
    ],
    "application/vnd.1000minds.decision-model+xml": [
        "1km"
    ],
    "application/vnd.3gpp.pic-bw-large": [
        "plb"
    ],
    "application/vnd.3gpp.pic-bw-small": [
        "psb"
    ],
    "application/vnd.3gpp.pic-bw-var": [
        "pvb"
    ],
    "application/vnd.3gpp2.tcap": [
        "tcap"
    ],
    "application/vnd.3m.post-it-notes": [
        "pwn"
    ],
    "application/vnd.accpac.simply.aso": [
        "aso"
    ],
    "application/vnd.accpac.simply.imp": [
        "imp"
    ],
    "application/vnd.acucobol": [
        "acu"
    ],
    "application/vnd.acucorp": [
        "atc",
        "acutc"
    ],
    "application/vnd.adobe.air-application-installer-package+zip": [
        "air"
    ],
    "application/vnd.adobe.formscentral.fcdt": [
        "fcdt"
    ],
    "application/vnd.adobe.fxp": [
        "fxp",
        "fxpl"
    ],
    "application/vnd.adobe.xdp+xml": [
        "xdp"
    ],
    "application/vnd.adobe.xfdf": [
        "xfdf"
    ],
    "application/vnd.ahead.space": [
        "ahead"
    ],
    "application/vnd.airzip.filesecure.azf": [
        "azf"
    ],
    "application/vnd.airzip.filesecure.azs": [
        "azs"
    ],
    "application/vnd.amazon.ebook": [
        "azw"
    ],
    "application/vnd.americandynamics.acc": [
        "acc"
    ],
    "application/vnd.amiga.ami": [
        "ami"
    ],
    "application/vnd.android.package-archive": [
        "apk"
    ],
    "application/vnd.anser-web-certificate-issue-initiation": [
        "cii"
    ],
    "application/vnd.anser-web-funds-transfer-initiation": [
        "fti"
    ],
    "application/vnd.antix.game-component": [
        "atx"
    ],
    "application/vnd.apple.installer+xml": [
        "mpkg"
    ],
    "application/vnd.apple.keynote": [
        "key"
    ],
    "application/vnd.apple.mpegurl": [
        "m3u8"
    ],
    "application/vnd.apple.numbers": [
        "numbers"
    ],
    "application/vnd.apple.pages": [
        "pages"
    ],
    "application/vnd.apple.pkpass": [
        "pkpass"
    ],
    "application/vnd.aristanetworks.swi": [
        "swi"
    ],
    "application/vnd.astraea-software.iota": [
        "iota"
    ],
    "application/vnd.audiograph": [
        "aep"
    ],
    "application/vnd.balsamiq.bmml+xml": [
        "bmml"
    ],
    "application/vnd.blueice.multipass": [
        "mpm"
    ],
    "application/vnd.bmi": [
        "bmi"
    ],
    "application/vnd.businessobjects": [
        "rep"
    ],
    "application/vnd.chemdraw+xml": [
        "cdxml"
    ],
    "application/vnd.chipnuts.karaoke-mmd": [
        "mmd"
    ],
    "application/vnd.cinderella": [
        "cdy"
    ],
    "application/vnd.citationstyles.style+xml": [
        "csl"
    ],
    "application/vnd.claymore": [
        "cla"
    ],
    "application/vnd.cloanto.rp9": [
        "rp9"
    ],
    "application/vnd.clonk.c4group": [
        "c4g",
        "c4d",
        "c4f",
        "c4p",
        "c4u"
    ],
    "application/vnd.cluetrust.cartomobile-config": [
        "c11amc"
    ],
    "application/vnd.cluetrust.cartomobile-config-pkg": [
        "c11amz"
    ],
    "application/vnd.commonspace": [
        "csp"
    ],
    "application/vnd.contact.cmsg": [
        "cdbcmsg"
    ],
    "application/vnd.cosmocaller": [
        "cmc"
    ],
    "application/vnd.crick.clicker": [
        "clkx"
    ],
    "application/vnd.crick.clicker.keyboard": [
        "clkk"
    ],
    "application/vnd.crick.clicker.palette": [
        "clkp"
    ],
    "application/vnd.crick.clicker.template": [
        "clkt"
    ],
    "application/vnd.crick.clicker.wordbank": [
        "clkw"
    ],
    "application/vnd.criticaltools.wbs+xml": [
        "wbs"
    ],
    "application/vnd.ctc-posml": [
        "pml"
    ],
    "application/vnd.cups-ppd": [
        "ppd"
    ],
    "application/vnd.curl.car": [
        "car"
    ],
    "application/vnd.curl.pcurl": [
        "pcurl"
    ],
    "application/vnd.dart": [
        "dart"
    ],
    "application/vnd.data-vision.rdz": [
        "rdz"
    ],
    "application/vnd.dbf": [
        "dbf"
    ],
    "application/vnd.dece.data": [
        "uvf",
        "uvvf",
        "uvd",
        "uvvd"
    ],
    "application/vnd.dece.ttml+xml": [
        "uvt",
        "uvvt"
    ],
    "application/vnd.dece.unspecified": [
        "uvx",
        "uvvx"
    ],
    "application/vnd.dece.zip": [
        "uvz",
        "uvvz"
    ],
    "application/vnd.denovo.fcselayout-link": [
        "fe_launch"
    ],
    "application/vnd.dna": [
        "dna"
    ],
    "application/vnd.dolby.mlp": [
        "mlp"
    ],
    "application/vnd.dpgraph": [
        "dpg"
    ],
    "application/vnd.dreamfactory": [
        "dfac"
    ],
    "application/vnd.ds-keypoint": [
        "kpxx"
    ],
    "application/vnd.dvb.ait": [
        "ait"
    ],
    "application/vnd.dvb.service": [
        "svc"
    ],
    "application/vnd.dynageo": [
        "geo"
    ],
    "application/vnd.ecowin.chart": [
        "mag"
    ],
    "application/vnd.enliven": [
        "nml"
    ],
    "application/vnd.epson.esf": [
        "esf"
    ],
    "application/vnd.epson.msf": [
        "msf"
    ],
    "application/vnd.epson.quickanime": [
        "qam"
    ],
    "application/vnd.epson.salt": [
        "slt"
    ],
    "application/vnd.epson.ssf": [
        "ssf"
    ],
    "application/vnd.eszigno3+xml": [
        "es3",
        "et3"
    ],
    "application/vnd.ezpix-album": [
        "ez2"
    ],
    "application/vnd.ezpix-package": [
        "ez3"
    ],
    "application/vnd.fdf": [
        "fdf"
    ],
    "application/vnd.fdsn.mseed": [
        "mseed"
    ],
    "application/vnd.fdsn.seed": [
        "seed",
        "dataless"
    ],
    "application/vnd.flographit": [
        "gph"
    ],
    "application/vnd.fluxtime.clip": [
        "ftc"
    ],
    "application/vnd.framemaker": [
        "fm",
        "frame",
        "maker",
        "book"
    ],
    "application/vnd.frogans.fnc": [
        "fnc"
    ],
    "application/vnd.frogans.ltf": [
        "ltf"
    ],
    "application/vnd.fsc.weblaunch": [
        "fsc"
    ],
    "application/vnd.fujitsu.oasys": [
        "oas"
    ],
    "application/vnd.fujitsu.oasys2": [
        "oa2"
    ],
    "application/vnd.fujitsu.oasys3": [
        "oa3"
    ],
    "application/vnd.fujitsu.oasysgp": [
        "fg5"
    ],
    "application/vnd.fujitsu.oasysprs": [
        "bh2"
    ],
    "application/vnd.fujixerox.ddd": [
        "ddd"
    ],
    "application/vnd.fujixerox.docuworks": [
        "xdw"
    ],
    "application/vnd.fujixerox.docuworks.binder": [
        "xbd"
    ],
    "application/vnd.fuzzysheet": [
        "fzs"
    ],
    "application/vnd.genomatix.tuxedo": [
        "txd"
    ],
    "application/vnd.geogebra.file": [
        "ggb"
    ],
    "application/vnd.geogebra.tool": [
        "ggt"
    ],
    "application/vnd.geometry-explorer": [
        "gex",
        "gre"
    ],
    "application/vnd.geonext": [
        "gxt"
    ],
    "application/vnd.geoplan": [
        "g2w"
    ],
    "application/vnd.geospace": [
        "g3w"
    ],
    "application/vnd.gmx": [
        "gmx"
    ],
    "application/vnd.google-apps.document": [
        "gdoc"
    ],
    "application/vnd.google-apps.presentation": [
        "gslides"
    ],
    "application/vnd.google-apps.spreadsheet": [
        "gsheet"
    ],
    "application/vnd.google-earth.kml+xml": [
        "kml"
    ],
    "application/vnd.google-earth.kmz": [
        "kmz"
    ],
    "application/vnd.grafeq": [
        "gqf",
        "gqs"
    ],
    "application/vnd.groove-account": [
        "gac"
    ],
    "application/vnd.groove-help": [
        "ghf"
    ],
    "application/vnd.groove-identity-message": [
        "gim"
    ],
    "application/vnd.groove-injector": [
        "grv"
    ],
    "application/vnd.groove-tool-message": [
        "gtm"
    ],
    "application/vnd.groove-tool-template": [
        "tpl"
    ],
    "application/vnd.groove-vcard": [
        "vcg"
    ],
    "application/vnd.hal+xml": [
        "hal"
    ],
    "application/vnd.handheld-entertainment+xml": [
        "zmm"
    ],
    "application/vnd.hbci": [
        "hbci"
    ],
    "application/vnd.hhe.lesson-player": [
        "les"
    ],
    "application/vnd.hp-hpgl": [
        "hpgl"
    ],
    "application/vnd.hp-hpid": [
        "hpid"
    ],
    "application/vnd.hp-hps": [
        "hps"
    ],
    "application/vnd.hp-jlyt": [
        "jlt"
    ],
    "application/vnd.hp-pcl": [
        "pcl"
    ],
    "application/vnd.hp-pclxl": [
        "pclxl"
    ],
    "application/vnd.hydrostatix.sof-data": [
        "sfd-hdstx"
    ],
    "application/vnd.ibm.minipay": [
        "mpy"
    ],
    "application/vnd.ibm.modcap": [
        "afp",
        "listafp",
        "list3820"
    ],
    "application/vnd.ibm.rights-management": [
        "irm"
    ],
    "application/vnd.ibm.secure-container": [
        "sc"
    ],
    "application/vnd.iccprofile": [
        "icc",
        "icm"
    ],
    "application/vnd.igloader": [
        "igl"
    ],
    "application/vnd.immervision-ivp": [
        "ivp"
    ],
    "application/vnd.immervision-ivu": [
        "ivu"
    ],
    "application/vnd.insors.igm": [
        "igm"
    ],
    "application/vnd.intercon.formnet": [
        "xpw",
        "xpx"
    ],
    "application/vnd.intergeo": [
        "i2g"
    ],
    "application/vnd.intu.qbo": [
        "qbo"
    ],
    "application/vnd.intu.qfx": [
        "qfx"
    ],
    "application/vnd.ipunplugged.rcprofile": [
        "rcprofile"
    ],
    "application/vnd.irepository.package+xml": [
        "irp"
    ],
    "application/vnd.is-xpr": [
        "xpr"
    ],
    "application/vnd.isac.fcs": [
        "fcs"
    ],
    "application/vnd.jam": [
        "jam"
    ],
    "application/vnd.jcp.javame.midlet-rms": [
        "rms"
    ],
    "application/vnd.jisp": [
        "jisp"
    ],
    "application/vnd.joost.joda-archive": [
        "joda"
    ],
    "application/vnd.kahootz": [
        "ktz",
        "ktr"
    ],
    "application/vnd.kde.karbon": [
        "karbon"
    ],
    "application/vnd.kde.kchart": [
        "chrt"
    ],
    "application/vnd.kde.kformula": [
        "kfo"
    ],
    "application/vnd.kde.kivio": [
        "flw"
    ],
    "application/vnd.kde.kontour": [
        "kon"
    ],
    "application/vnd.kde.kpresenter": [
        "kpr",
        "kpt"
    ],
    "application/vnd.kde.kspread": [
        "ksp"
    ],
    "application/vnd.kde.kword": [
        "kwd",
        "kwt"
    ],
    "application/vnd.kenameaapp": [
        "htke"
    ],
    "application/vnd.kidspiration": [
        "kia"
    ],
    "application/vnd.kinar": [
        "kne",
        "knp"
    ],
    "application/vnd.koan": [
        "skp",
        "skd",
        "skt",
        "skm"
    ],
    "application/vnd.kodak-descriptor": [
        "sse"
    ],
    "application/vnd.las.las+xml": [
        "lasxml"
    ],
    "application/vnd.llamagraphics.life-balance.desktop": [
        "lbd"
    ],
    "application/vnd.llamagraphics.life-balance.exchange+xml": [
        "lbe"
    ],
    "application/vnd.lotus-1-2-3": [
        "123"
    ],
    "application/vnd.lotus-approach": [
        "apr"
    ],
    "application/vnd.lotus-freelance": [
        "pre"
    ],
    "application/vnd.lotus-notes": [
        "nsf"
    ],
    "application/vnd.lotus-organizer": [
        "org"
    ],
    "application/vnd.lotus-screencam": [
        "scm"
    ],
    "application/vnd.lotus-wordpro": [
        "lwp"
    ],
    "application/vnd.macports.portpkg": [
        "portpkg"
    ],
    "application/vnd.mapbox-vector-tile": [
        "mvt"
    ],
    "application/vnd.mcd": [
        "mcd"
    ],
    "application/vnd.medcalcdata": [
        "mc1"
    ],
    "application/vnd.mediastation.cdkey": [
        "cdkey"
    ],
    "application/vnd.mfer": [
        "mwf"
    ],
    "application/vnd.mfmp": [
        "mfm"
    ],
    "application/vnd.micrografx.flo": [
        "flo"
    ],
    "application/vnd.micrografx.igx": [
        "igx"
    ],
    "application/vnd.mif": [
        "mif"
    ],
    "application/vnd.mobius.daf": [
        "daf"
    ],
    "application/vnd.mobius.dis": [
        "dis"
    ],
    "application/vnd.mobius.mbk": [
        "mbk"
    ],
    "application/vnd.mobius.mqy": [
        "mqy"
    ],
    "application/vnd.mobius.msl": [
        "msl"
    ],
    "application/vnd.mobius.plc": [
        "plc"
    ],
    "application/vnd.mobius.txf": [
        "txf"
    ],
    "application/vnd.mophun.application": [
        "mpn"
    ],
    "application/vnd.mophun.certificate": [
        "mpc"
    ],
    "application/vnd.mozilla.xul+xml": [
        "xul"
    ],
    "application/vnd.ms-artgalry": [
        "cil"
    ],
    "application/vnd.ms-cab-compressed": [
        "cab"
    ],
    "application/vnd.ms-excel": [
        "xls",
        "xlm",
        "xla",
        "xlc",
        "xlt",
        "xlw"
    ],
    "application/vnd.ms-excel.addin.macroenabled.12": [
        "xlam"
    ],
    "application/vnd.ms-excel.sheet.binary.macroenabled.12": [
        "xlsb"
    ],
    "application/vnd.ms-excel.sheet.macroenabled.12": [
        "xlsm"
    ],
    "application/vnd.ms-excel.template.macroenabled.12": [
        "xltm"
    ],
    "application/vnd.ms-fontobject": [
        "eot"
    ],
    "application/vnd.ms-htmlhelp": [
        "chm"
    ],
    "application/vnd.ms-ims": [
        "ims"
    ],
    "application/vnd.ms-lrm": [
        "lrm"
    ],
    "application/vnd.ms-officetheme": [
        "thmx"
    ],
    "application/vnd.ms-outlook": [
        "msg"
    ],
    "application/vnd.ms-pki.seccat": [
        "cat"
    ],
    "application/vnd.ms-pki.stl": [
        "*stl"
    ],
    "application/vnd.ms-powerpoint": [
        "ppt",
        "pps",
        "pot"
    ],
    "application/vnd.ms-powerpoint.addin.macroenabled.12": [
        "ppam"
    ],
    "application/vnd.ms-powerpoint.presentation.macroenabled.12": [
        "pptm"
    ],
    "application/vnd.ms-powerpoint.slide.macroenabled.12": [
        "sldm"
    ],
    "application/vnd.ms-powerpoint.slideshow.macroenabled.12": [
        "ppsm"
    ],
    "application/vnd.ms-powerpoint.template.macroenabled.12": [
        "potm"
    ],
    "application/vnd.ms-project": [
        "mpp",
        "mpt"
    ],
    "application/vnd.ms-word.document.macroenabled.12": [
        "docm"
    ],
    "application/vnd.ms-word.template.macroenabled.12": [
        "dotm"
    ],
    "application/vnd.ms-works": [
        "wps",
        "wks",
        "wcm",
        "wdb"
    ],
    "application/vnd.ms-wpl": [
        "wpl"
    ],
    "application/vnd.ms-xpsdocument": [
        "xps"
    ],
    "application/vnd.mseq": [
        "mseq"
    ],
    "application/vnd.musician": [
        "mus"
    ],
    "application/vnd.muvee.style": [
        "msty"
    ],
    "application/vnd.mynfc": [
        "taglet"
    ],
    "application/vnd.neurolanguage.nlu": [
        "nlu"
    ],
    "application/vnd.nitf": [
        "ntf",
        "nitf"
    ],
    "application/vnd.noblenet-directory": [
        "nnd"
    ],
    "application/vnd.noblenet-sealer": [
        "nns"
    ],
    "application/vnd.noblenet-web": [
        "nnw"
    ],
    "application/vnd.nokia.n-gage.ac+xml": [
        "*ac"
    ],
    "application/vnd.nokia.n-gage.data": [
        "ngdat"
    ],
    "application/vnd.nokia.n-gage.symbian.install": [
        "n-gage"
    ],
    "application/vnd.nokia.radio-preset": [
        "rpst"
    ],
    "application/vnd.nokia.radio-presets": [
        "rpss"
    ],
    "application/vnd.novadigm.edm": [
        "edm"
    ],
    "application/vnd.novadigm.edx": [
        "edx"
    ],
    "application/vnd.novadigm.ext": [
        "ext"
    ],
    "application/vnd.oasis.opendocument.chart": [
        "odc"
    ],
    "application/vnd.oasis.opendocument.chart-template": [
        "otc"
    ],
    "application/vnd.oasis.opendocument.database": [
        "odb"
    ],
    "application/vnd.oasis.opendocument.formula": [
        "odf"
    ],
    "application/vnd.oasis.opendocument.formula-template": [
        "odft"
    ],
    "application/vnd.oasis.opendocument.graphics": [
        "odg"
    ],
    "application/vnd.oasis.opendocument.graphics-template": [
        "otg"
    ],
    "application/vnd.oasis.opendocument.image": [
        "odi"
    ],
    "application/vnd.oasis.opendocument.image-template": [
        "oti"
    ],
    "application/vnd.oasis.opendocument.presentation": [
        "odp"
    ],
    "application/vnd.oasis.opendocument.presentation-template": [
        "otp"
    ],
    "application/vnd.oasis.opendocument.spreadsheet": [
        "ods"
    ],
    "application/vnd.oasis.opendocument.spreadsheet-template": [
        "ots"
    ],
    "application/vnd.oasis.opendocument.text": [
        "odt"
    ],
    "application/vnd.oasis.opendocument.text-master": [
        "odm"
    ],
    "application/vnd.oasis.opendocument.text-template": [
        "ott"
    ],
    "application/vnd.oasis.opendocument.text-web": [
        "oth"
    ],
    "application/vnd.olpc-sugar": [
        "xo"
    ],
    "application/vnd.oma.dd2+xml": [
        "dd2"
    ],
    "application/vnd.openblox.game+xml": [
        "obgx"
    ],
    "application/vnd.openofficeorg.extension": [
        "oxt"
    ],
    "application/vnd.openstreetmap.data+xml": [
        "osm"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
        "pptx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slide": [
        "sldx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow": [
        "ppsx"
    ],
    "application/vnd.openxmlformats-officedocument.presentationml.template": [
        "potx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        "xlsx"
    ],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
        "xltx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
        "docx"
    ],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.template": [
        "dotx"
    ],
    "application/vnd.osgeo.mapguide.package": [
        "mgp"
    ],
    "application/vnd.osgi.dp": [
        "dp"
    ],
    "application/vnd.osgi.subsystem": [
        "esa"
    ],
    "application/vnd.palm": [
        "pdb",
        "pqa",
        "oprc"
    ],
    "application/vnd.pawaafile": [
        "paw"
    ],
    "application/vnd.pg.format": [
        "str"
    ],
    "application/vnd.pg.osasli": [
        "ei6"
    ],
    "application/vnd.picsel": [
        "efif"
    ],
    "application/vnd.pmi.widget": [
        "wg"
    ],
    "application/vnd.pocketlearn": [
        "plf"
    ],
    "application/vnd.powerbuilder6": [
        "pbd"
    ],
    "application/vnd.previewsystems.box": [
        "box"
    ],
    "application/vnd.proteus.magazine": [
        "mgz"
    ],
    "application/vnd.publishare-delta-tree": [
        "qps"
    ],
    "application/vnd.pvi.ptid1": [
        "ptid"
    ],
    "application/vnd.quark.quarkxpress": [
        "qxd",
        "qxt",
        "qwd",
        "qwt",
        "qxl",
        "qxb"
    ],
    "application/vnd.rar": [
        "rar"
    ],
    "application/vnd.realvnc.bed": [
        "bed"
    ],
    "application/vnd.recordare.musicxml": [
        "mxl"
    ],
    "application/vnd.recordare.musicxml+xml": [
        "musicxml"
    ],
    "application/vnd.rig.cryptonote": [
        "cryptonote"
    ],
    "application/vnd.rim.cod": [
        "cod"
    ],
    "application/vnd.rn-realmedia": [
        "rm"
    ],
    "application/vnd.rn-realmedia-vbr": [
        "rmvb"
    ],
    "application/vnd.route66.link66+xml": [
        "link66"
    ],
    "application/vnd.sailingtracker.track": [
        "st"
    ],
    "application/vnd.seemail": [
        "see"
    ],
    "application/vnd.sema": [
        "sema"
    ],
    "application/vnd.semd": [
        "semd"
    ],
    "application/vnd.semf": [
        "semf"
    ],
    "application/vnd.shana.informed.formdata": [
        "ifm"
    ],
    "application/vnd.shana.informed.formtemplate": [
        "itp"
    ],
    "application/vnd.shana.informed.interchange": [
        "iif"
    ],
    "application/vnd.shana.informed.package": [
        "ipk"
    ],
    "application/vnd.simtech-mindmapper": [
        "twd",
        "twds"
    ],
    "application/vnd.smaf": [
        "mmf"
    ],
    "application/vnd.smart.teacher": [
        "teacher"
    ],
    "application/vnd.software602.filler.form+xml": [
        "fo"
    ],
    "application/vnd.solent.sdkm+xml": [
        "sdkm",
        "sdkd"
    ],
    "application/vnd.spotfire.dxp": [
        "dxp"
    ],
    "application/vnd.spotfire.sfs": [
        "sfs"
    ],
    "application/vnd.stardivision.calc": [
        "sdc"
    ],
    "application/vnd.stardivision.draw": [
        "sda"
    ],
    "application/vnd.stardivision.impress": [
        "sdd"
    ],
    "application/vnd.stardivision.math": [
        "smf"
    ],
    "application/vnd.stardivision.writer": [
        "sdw",
        "vor"
    ],
    "application/vnd.stardivision.writer-global": [
        "sgl"
    ],
    "application/vnd.stepmania.package": [
        "smzip"
    ],
    "application/vnd.stepmania.stepchart": [
        "sm"
    ],
    "application/vnd.sun.wadl+xml": [
        "wadl"
    ],
    "application/vnd.sun.xml.calc": [
        "sxc"
    ],
    "application/vnd.sun.xml.calc.template": [
        "stc"
    ],
    "application/vnd.sun.xml.draw": [
        "sxd"
    ],
    "application/vnd.sun.xml.draw.template": [
        "std"
    ],
    "application/vnd.sun.xml.impress": [
        "sxi"
    ],
    "application/vnd.sun.xml.impress.template": [
        "sti"
    ],
    "application/vnd.sun.xml.math": [
        "sxm"
    ],
    "application/vnd.sun.xml.writer": [
        "sxw"
    ],
    "application/vnd.sun.xml.writer.global": [
        "sxg"
    ],
    "application/vnd.sun.xml.writer.template": [
        "stw"
    ],
    "application/vnd.sus-calendar": [
        "sus",
        "susp"
    ],
    "application/vnd.svd": [
        "svd"
    ],
    "application/vnd.symbian.install": [
        "sis",
        "sisx"
    ],
    "application/vnd.syncml+xml": [
        "xsm"
    ],
    "application/vnd.syncml.dm+wbxml": [
        "bdm"
    ],
    "application/vnd.syncml.dm+xml": [
        "xdm"
    ],
    "application/vnd.syncml.dmddf+xml": [
        "ddf"
    ],
    "application/vnd.tao.intent-module-archive": [
        "tao"
    ],
    "application/vnd.tcpdump.pcap": [
        "pcap",
        "cap",
        "dmp"
    ],
    "application/vnd.tmobile-livetv": [
        "tmo"
    ],
    "application/vnd.trid.tpt": [
        "tpt"
    ],
    "application/vnd.triscape.mxs": [
        "mxs"
    ],
    "application/vnd.trueapp": [
        "tra"
    ],
    "application/vnd.ufdl": [
        "ufd",
        "ufdl"
    ],
    "application/vnd.uiq.theme": [
        "utz"
    ],
    "application/vnd.umajin": [
        "umj"
    ],
    "application/vnd.unity": [
        "unityweb"
    ],
    "application/vnd.uoml+xml": [
        "uoml"
    ],
    "application/vnd.vcx": [
        "vcx"
    ],
    "application/vnd.visio": [
        "vsd",
        "vst",
        "vss",
        "vsw"
    ],
    "application/vnd.visionary": [
        "vis"
    ],
    "application/vnd.vsf": [
        "vsf"
    ],
    "application/vnd.wap.wbxml": [
        "wbxml"
    ],
    "application/vnd.wap.wmlc": [
        "wmlc"
    ],
    "application/vnd.wap.wmlscriptc": [
        "wmlsc"
    ],
    "application/vnd.webturbo": [
        "wtb"
    ],
    "application/vnd.wolfram.player": [
        "nbp"
    ],
    "application/vnd.wordperfect": [
        "wpd"
    ],
    "application/vnd.wqd": [
        "wqd"
    ],
    "application/vnd.wt.stf": [
        "stf"
    ],
    "application/vnd.xara": [
        "xar"
    ],
    "application/vnd.xfdl": [
        "xfdl"
    ],
    "application/vnd.yamaha.hv-dic": [
        "hvd"
    ],
    "application/vnd.yamaha.hv-script": [
        "hvs"
    ],
    "application/vnd.yamaha.hv-voice": [
        "hvp"
    ],
    "application/vnd.yamaha.openscoreformat": [
        "osf"
    ],
    "application/vnd.yamaha.openscoreformat.osfpvg+xml": [
        "osfpvg"
    ],
    "application/vnd.yamaha.smaf-audio": [
        "saf"
    ],
    "application/vnd.yamaha.smaf-phrase": [
        "spf"
    ],
    "application/vnd.yellowriver-custom-menu": [
        "cmp"
    ],
    "application/vnd.zul": [
        "zir",
        "zirz"
    ],
    "application/vnd.zzazz.deck+xml": [
        "zaz"
    ],
    "application/x-7z-compressed": [
        "7z"
    ],
    "application/x-abiword": [
        "abw"
    ],
    "application/x-ace-compressed": [
        "ace"
    ],
    "application/x-apple-diskimage": [
        "*dmg"
    ],
    "application/x-arj": [
        "arj"
    ],
    "application/x-authorware-bin": [
        "aab",
        "x32",
        "u32",
        "vox"
    ],
    "application/x-authorware-map": [
        "aam"
    ],
    "application/x-authorware-seg": [
        "aas"
    ],
    "application/x-bcpio": [
        "bcpio"
    ],
    "application/x-bdoc": [
        "*bdoc"
    ],
    "application/x-bittorrent": [
        "torrent"
    ],
    "application/x-blorb": [
        "blb",
        "blorb"
    ],
    "application/x-bzip": [
        "bz"
    ],
    "application/x-bzip2": [
        "bz2",
        "boz"
    ],
    "application/x-cbr": [
        "cbr",
        "cba",
        "cbt",
        "cbz",
        "cb7"
    ],
    "application/x-cdlink": [
        "vcd"
    ],
    "application/x-cfs-compressed": [
        "cfs"
    ],
    "application/x-chat": [
        "chat"
    ],
    "application/x-chess-pgn": [
        "pgn"
    ],
    "application/x-chrome-extension": [
        "crx"
    ],
    "application/x-cocoa": [
        "cco"
    ],
    "application/x-conference": [
        "nsc"
    ],
    "application/x-cpio": [
        "cpio"
    ],
    "application/x-csh": [
        "csh"
    ],
    "application/x-debian-package": [
        "*deb",
        "udeb"
    ],
    "application/x-dgc-compressed": [
        "dgc"
    ],
    "application/x-director": [
        "dir",
        "dcr",
        "dxr",
        "cst",
        "cct",
        "cxt",
        "w3d",
        "fgd",
        "swa"
    ],
    "application/x-doom": [
        "wad"
    ],
    "application/x-dtbncx+xml": [
        "ncx"
    ],
    "application/x-dtbook+xml": [
        "dtb"
    ],
    "application/x-dtbresource+xml": [
        "res"
    ],
    "application/x-dvi": [
        "dvi"
    ],
    "application/x-envoy": [
        "evy"
    ],
    "application/x-eva": [
        "eva"
    ],
    "application/x-font-bdf": [
        "bdf"
    ],
    "application/x-font-ghostscript": [
        "gsf"
    ],
    "application/x-font-linux-psf": [
        "psf"
    ],
    "application/x-font-pcf": [
        "pcf"
    ],
    "application/x-font-snf": [
        "snf"
    ],
    "application/x-font-type1": [
        "pfa",
        "pfb",
        "pfm",
        "afm"
    ],
    "application/x-freearc": [
        "arc"
    ],
    "application/x-futuresplash": [
        "spl"
    ],
    "application/x-gca-compressed": [
        "gca"
    ],
    "application/x-glulx": [
        "ulx"
    ],
    "application/x-gnumeric": [
        "gnumeric"
    ],
    "application/x-gramps-xml": [
        "gramps"
    ],
    "application/x-gtar": [
        "gtar"
    ],
    "application/x-hdf": [
        "hdf"
    ],
    "application/x-httpd-php": [
        "php"
    ],
    "application/x-install-instructions": [
        "install"
    ],
    "application/x-iso9660-image": [
        "*iso"
    ],
    "application/x-iwork-keynote-sffkey": [
        "*key"
    ],
    "application/x-iwork-numbers-sffnumbers": [
        "*numbers"
    ],
    "application/x-iwork-pages-sffpages": [
        "*pages"
    ],
    "application/x-java-archive-diff": [
        "jardiff"
    ],
    "application/x-java-jnlp-file": [
        "jnlp"
    ],
    "application/x-keepass2": [
        "kdbx"
    ],
    "application/x-latex": [
        "latex"
    ],
    "application/x-lua-bytecode": [
        "luac"
    ],
    "application/x-lzh-compressed": [
        "lzh",
        "lha"
    ],
    "application/x-makeself": [
        "run"
    ],
    "application/x-mie": [
        "mie"
    ],
    "application/x-mobipocket-ebook": [
        "prc",
        "mobi"
    ],
    "application/x-ms-application": [
        "application"
    ],
    "application/x-ms-shortcut": [
        "lnk"
    ],
    "application/x-ms-wmd": [
        "wmd"
    ],
    "application/x-ms-wmz": [
        "wmz"
    ],
    "application/x-ms-xbap": [
        "xbap"
    ],
    "application/x-msaccess": [
        "mdb"
    ],
    "application/x-msbinder": [
        "obd"
    ],
    "application/x-mscardfile": [
        "crd"
    ],
    "application/x-msclip": [
        "clp"
    ],
    "application/x-msdos-program": [
        "*exe"
    ],
    "application/x-msdownload": [
        "*exe",
        "*dll",
        "com",
        "bat",
        "*msi"
    ],
    "application/x-msmediaview": [
        "mvb",
        "m13",
        "m14"
    ],
    "application/x-msmetafile": [
        "*wmf",
        "*wmz",
        "*emf",
        "emz"
    ],
    "application/x-msmoney": [
        "mny"
    ],
    "application/x-mspublisher": [
        "pub"
    ],
    "application/x-msschedule": [
        "scd"
    ],
    "application/x-msterminal": [
        "trm"
    ],
    "application/x-mswrite": [
        "wri"
    ],
    "application/x-netcdf": [
        "nc",
        "cdf"
    ],
    "application/x-ns-proxy-autoconfig": [
        "pac"
    ],
    "application/x-nzb": [
        "nzb"
    ],
    "application/x-perl": [
        "pl",
        "pm"
    ],
    "application/x-pilot": [
        "*prc",
        "*pdb"
    ],
    "application/x-pkcs12": [
        "p12",
        "pfx"
    ],
    "application/x-pkcs7-certificates": [
        "p7b",
        "spc"
    ],
    "application/x-pkcs7-certreqresp": [
        "p7r"
    ],
    "application/x-rar-compressed": [
        "*rar"
    ],
    "application/x-redhat-package-manager": [
        "rpm"
    ],
    "application/x-research-info-systems": [
        "ris"
    ],
    "application/x-sea": [
        "sea"
    ],
    "application/x-sh": [
        "sh"
    ],
    "application/x-shar": [
        "shar"
    ],
    "application/x-shockwave-flash": [
        "swf"
    ],
    "application/x-silverlight-app": [
        "xap"
    ],
    "application/x-sql": [
        "sql"
    ],
    "application/x-stuffit": [
        "sit"
    ],
    "application/x-stuffitx": [
        "sitx"
    ],
    "application/x-subrip": [
        "srt"
    ],
    "application/x-sv4cpio": [
        "sv4cpio"
    ],
    "application/x-sv4crc": [
        "sv4crc"
    ],
    "application/x-t3vm-image": [
        "t3"
    ],
    "application/x-tads": [
        "gam"
    ],
    "application/x-tar": [
        "tar"
    ],
    "application/x-tcl": [
        "tcl",
        "tk"
    ],
    "application/x-tex": [
        "tex"
    ],
    "application/x-tex-tfm": [
        "tfm"
    ],
    "application/x-texinfo": [
        "texinfo",
        "texi"
    ],
    "application/x-tgif": [
        "*obj"
    ],
    "application/x-ustar": [
        "ustar"
    ],
    "application/x-virtualbox-hdd": [
        "hdd"
    ],
    "application/x-virtualbox-ova": [
        "ova"
    ],
    "application/x-virtualbox-ovf": [
        "ovf"
    ],
    "application/x-virtualbox-vbox": [
        "vbox"
    ],
    "application/x-virtualbox-vbox-extpack": [
        "vbox-extpack"
    ],
    "application/x-virtualbox-vdi": [
        "vdi"
    ],
    "application/x-virtualbox-vhd": [
        "vhd"
    ],
    "application/x-virtualbox-vmdk": [
        "vmdk"
    ],
    "application/x-wais-source": [
        "src"
    ],
    "application/x-web-app-manifest+json": [
        "webapp"
    ],
    "application/x-x509-ca-cert": [
        "der",
        "crt",
        "pem"
    ],
    "application/x-xfig": [
        "fig"
    ],
    "application/x-xliff+xml": [
        "*xlf"
    ],
    "application/x-xpinstall": [
        "xpi"
    ],
    "application/x-xz": [
        "xz"
    ],
    "application/x-zmachine": [
        "z1",
        "z2",
        "z3",
        "z4",
        "z5",
        "z6",
        "z7",
        "z8"
    ],
    "audio/vnd.dece.audio": [
        "uva",
        "uvva"
    ],
    "audio/vnd.digital-winds": [
        "eol"
    ],
    "audio/vnd.dra": [
        "dra"
    ],
    "audio/vnd.dts": [
        "dts"
    ],
    "audio/vnd.dts.hd": [
        "dtshd"
    ],
    "audio/vnd.lucent.voice": [
        "lvp"
    ],
    "audio/vnd.ms-playready.media.pya": [
        "pya"
    ],
    "audio/vnd.nuera.ecelp4800": [
        "ecelp4800"
    ],
    "audio/vnd.nuera.ecelp7470": [
        "ecelp7470"
    ],
    "audio/vnd.nuera.ecelp9600": [
        "ecelp9600"
    ],
    "audio/vnd.rip": [
        "rip"
    ],
    "audio/x-aac": [
        "aac"
    ],
    "audio/x-aiff": [
        "aif",
        "aiff",
        "aifc"
    ],
    "audio/x-caf": [
        "caf"
    ],
    "audio/x-flac": [
        "flac"
    ],
    "audio/x-m4a": [
        "*m4a"
    ],
    "audio/x-matroska": [
        "mka"
    ],
    "audio/x-mpegurl": [
        "m3u"
    ],
    "audio/x-ms-wax": [
        "wax"
    ],
    "audio/x-ms-wma": [
        "wma"
    ],
    "audio/x-pn-realaudio": [
        "ram",
        "ra"
    ],
    "audio/x-pn-realaudio-plugin": [
        "rmp"
    ],
    "audio/x-realaudio": [
        "*ra"
    ],
    "audio/x-wav": [
        "*wav"
    ],
    "chemical/x-cdx": [
        "cdx"
    ],
    "chemical/x-cif": [
        "cif"
    ],
    "chemical/x-cmdf": [
        "cmdf"
    ],
    "chemical/x-cml": [
        "cml"
    ],
    "chemical/x-csml": [
        "csml"
    ],
    "chemical/x-xyz": [
        "xyz"
    ],
    "image/prs.btif": [
        "btif"
    ],
    "image/prs.pti": [
        "pti"
    ],
    "image/vnd.adobe.photoshop": [
        "psd"
    ],
    "image/vnd.airzip.accelerator.azv": [
        "azv"
    ],
    "image/vnd.dece.graphic": [
        "uvi",
        "uvvi",
        "uvg",
        "uvvg"
    ],
    "image/vnd.djvu": [
        "djvu",
        "djv"
    ],
    "image/vnd.dvb.subtitle": [
        "*sub"
    ],
    "image/vnd.dwg": [
        "dwg"
    ],
    "image/vnd.dxf": [
        "dxf"
    ],
    "image/vnd.fastbidsheet": [
        "fbs"
    ],
    "image/vnd.fpx": [
        "fpx"
    ],
    "image/vnd.fst": [
        "fst"
    ],
    "image/vnd.fujixerox.edmics-mmr": [
        "mmr"
    ],
    "image/vnd.fujixerox.edmics-rlc": [
        "rlc"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/vnd.ms-dds": [
        "dds"
    ],
    "image/vnd.ms-modi": [
        "mdi"
    ],
    "image/vnd.ms-photo": [
        "wdp"
    ],
    "image/vnd.net-fpx": [
        "npx"
    ],
    "image/vnd.pco.b16": [
        "b16"
    ],
    "image/vnd.tencent.tap": [
        "tap"
    ],
    "image/vnd.valve.source.texture": [
        "vtf"
    ],
    "image/vnd.wap.wbmp": [
        "wbmp"
    ],
    "image/vnd.xiff": [
        "xif"
    ],
    "image/vnd.zbrush.pcx": [
        "pcx"
    ],
    "image/x-3ds": [
        "3ds"
    ],
    "image/x-cmu-raster": [
        "ras"
    ],
    "image/x-cmx": [
        "cmx"
    ],
    "image/x-freehand": [
        "fh",
        "fhc",
        "fh4",
        "fh5",
        "fh7"
    ],
    "image/x-icon": [
        "*ico"
    ],
    "image/x-jng": [
        "jng"
    ],
    "image/x-mrsid-image": [
        "sid"
    ],
    "image/x-ms-bmp": [
        "*bmp"
    ],
    "image/x-pcx": [
        "*pcx"
    ],
    "image/x-pict": [
        "pic",
        "pct"
    ],
    "image/x-portable-anymap": [
        "pnm"
    ],
    "image/x-portable-bitmap": [
        "pbm"
    ],
    "image/x-portable-graymap": [
        "pgm"
    ],
    "image/x-portable-pixmap": [
        "ppm"
    ],
    "image/x-rgb": [
        "rgb"
    ],
    "image/x-tga": [
        "tga"
    ],
    "image/x-xbitmap": [
        "xbm"
    ],
    "image/x-xpixmap": [
        "xpm"
    ],
    "image/x-xwindowdump": [
        "xwd"
    ],
    "message/vnd.wfa.wsc": [
        "wsc"
    ],
    "model/vnd.collada+xml": [
        "dae"
    ],
    "model/vnd.dwf": [
        "dwf"
    ],
    "model/vnd.gdl": [
        "gdl"
    ],
    "model/vnd.gtw": [
        "gtw"
    ],
    "model/vnd.mts": [
        "mts"
    ],
    "model/vnd.opengex": [
        "ogex"
    ],
    "model/vnd.parasolid.transmit.binary": [
        "x_b"
    ],
    "model/vnd.parasolid.transmit.text": [
        "x_t"
    ],
    "model/vnd.sap.vds": [
        "vds"
    ],
    "model/vnd.usdz+zip": [
        "usdz"
    ],
    "model/vnd.valve.source.compiled-map": [
        "bsp"
    ],
    "model/vnd.vtu": [
        "vtu"
    ],
    "text/prs.lines.tag": [
        "dsc"
    ],
    "text/vnd.curl": [
        "curl"
    ],
    "text/vnd.curl.dcurl": [
        "dcurl"
    ],
    "text/vnd.curl.mcurl": [
        "mcurl"
    ],
    "text/vnd.curl.scurl": [
        "scurl"
    ],
    "text/vnd.dvb.subtitle": [
        "sub"
    ],
    "text/vnd.fly": [
        "fly"
    ],
    "text/vnd.fmi.flexstor": [
        "flx"
    ],
    "text/vnd.graphviz": [
        "gv"
    ],
    "text/vnd.in3d.3dml": [
        "3dml"
    ],
    "text/vnd.in3d.spot": [
        "spot"
    ],
    "text/vnd.sun.j2me.app-descriptor": [
        "jad"
    ],
    "text/vnd.wap.wml": [
        "wml"
    ],
    "text/vnd.wap.wmlscript": [
        "wmls"
    ],
    "text/x-asm": [
        "s",
        "asm"
    ],
    "text/x-c": [
        "c",
        "cc",
        "cxx",
        "cpp",
        "h",
        "hh",
        "dic"
    ],
    "text/x-component": [
        "htc"
    ],
    "text/x-fortran": [
        "f",
        "for",
        "f77",
        "f90"
    ],
    "text/x-handlebars-template": [
        "hbs"
    ],
    "text/x-java-source": [
        "java"
    ],
    "text/x-lua": [
        "lua"
    ],
    "text/x-markdown": [
        "mkd"
    ],
    "text/x-nfo": [
        "nfo"
    ],
    "text/x-opml": [
        "opml"
    ],
    "text/x-org": [
        "*org"
    ],
    "text/x-pascal": [
        "p",
        "pas"
    ],
    "text/x-processing": [
        "pde"
    ],
    "text/x-sass": [
        "sass"
    ],
    "text/x-scss": [
        "scss"
    ],
    "text/x-setext": [
        "etx"
    ],
    "text/x-sfv": [
        "sfv"
    ],
    "text/x-suse-ymp": [
        "ymp"
    ],
    "text/x-uuencode": [
        "uu"
    ],
    "text/x-vcalendar": [
        "vcs"
    ],
    "text/x-vcard": [
        "vcf"
    ],
    "video/vnd.dece.hd": [
        "uvh",
        "uvvh"
    ],
    "video/vnd.dece.mobile": [
        "uvm",
        "uvvm"
    ],
    "video/vnd.dece.pd": [
        "uvp",
        "uvvp"
    ],
    "video/vnd.dece.sd": [
        "uvs",
        "uvvs"
    ],
    "video/vnd.dece.video": [
        "uvv",
        "uvvv"
    ],
    "video/vnd.dvb.file": [
        "dvb"
    ],
    "video/vnd.fvt": [
        "fvt"
    ],
    "video/vnd.mpegurl": [
        "mxu",
        "m4u"
    ],
    "video/vnd.ms-playready.media.pyv": [
        "pyv"
    ],
    "video/vnd.uvvu.mp4": [
        "uvu",
        "uvvu"
    ],
    "video/vnd.vivo": [
        "viv"
    ],
    "video/x-f4v": [
        "f4v"
    ],
    "video/x-fli": [
        "fli"
    ],
    "video/x-flv": [
        "flv"
    ],
    "video/x-m4v": [
        "m4v"
    ],
    "video/x-matroska": [
        "mkv",
        "mk3d",
        "mks"
    ],
    "video/x-mng": [
        "mng"
    ],
    "video/x-ms-asf": [
        "asf",
        "asx"
    ],
    "video/x-ms-vob": [
        "vob"
    ],
    "video/x-ms-wm": [
        "wm"
    ],
    "video/x-ms-wmv": [
        "wmv"
    ],
    "video/x-ms-wmx": [
        "wmx"
    ],
    "video/x-ms-wvx": [
        "wvx"
    ],
    "video/x-msvideo": [
        "avi"
    ],
    "video/x-sgi-movie": [
        "movie"
    ],
    "video/x-smv": [
        "smv"
    ],
    "x-conference/x-cooltalk": [
        "ice"
    ]
};

});



parcelRegister("kONlL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b09432efd1eb5b$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $e9b09432efd1eb5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2",
            "key": "svg-1"
        }
    ],
    [
        "path",
        {
            "d": "M19 11h2m-1 -1v2",
            "key": "svg-2"
        }
    ]
];
const $e9b09432efd1eb5b$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "moon-stars", "MoonStars", $e9b09432efd1eb5b$export$3efd853dbb351e94);

});

parcelRegister("5U9YU", function(module, exports) {

$parcel$export(module.exports, "default", () => $2db197f11526e254$export$2e2bcd8739ae039);
/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $eednQ = parcelRequire("eednQ");
const $2db197f11526e254$export$3efd853dbb351e94 = [
    [
        "path",
        {
            "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
            "key": "svg-0"
        }
    ],
    [
        "path",
        {
            "d": "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7",
            "key": "svg-1"
        }
    ]
];
const $2db197f11526e254$export$2e2bcd8739ae039 = (0, $eednQ.default)("outline", "sun", "Sun", $2db197f11526e254$export$3efd853dbb351e94);

});

parcelRegister("7AVya", function(module, exports) {

$parcel$export(module.exports, "Logo", () => $13585a0278340f6b$export$e6ff31bff12b7ff4);

var $ayMG0 = parcelRequire("ayMG0");

var $64A2P = parcelRequire("64A2P");
function $13585a0278340f6b$export$e6ff31bff12b7ff4() {
    const theme = (0, $64A2P.useMantineTheme)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 118.3 64.3",
        xmlSpace: "preserve",
        style: {
            filter: theme.colorScheme === 'dark' ? 'drop-shadow(-2px 2px 3px rgba(255, 255, 255, 0.5))' : 'drop-shadow(-2px 2px 3px rgba(0, 0, 0, 0.5))'
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: `.st0{fill:#F19D20;} .st1{display:none;} .st2{display:inline;} .st3{opacity:0.3;}`
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                id: "Layer_1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                id: "Layer_2"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                id: "Layer_3",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                                    className: "st0",
                                    points: "69.9,59 81,29.2 72,5.6 60.7,34.7"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                                    className: "st0",
                                    points: "26,5.6 3.9,62.2 22.6,62.2 34.9,29.3"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                                    className: "st0",
                                    points: "59.2,38.4 45.5,2.1 27.4,2.1 50.2,62.2 68.3,62.2 68.3,62.2 59.3,38.4"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("polygon", {
                                    className: "st0",
                                    points: "91.5,2.1 73.5,2.1 96.3,62.2 114.3,62.2"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("g", {
                id: "Layer_4",
                className: "st1"
            })
        ]
    });
}

});

parcelRegister("3OncY", function(module, exports) {

$parcel$export(module.exports, "API_URL", () => $9d936a2aecb96285$export$923ea8233b386e99);
$parcel$export(module.exports, "APP_ID", () => $9d936a2aecb96285$export$d76071d5de2774fc);
$parcel$export(module.exports, "GOOGLE_MAPS_API_KEY", () => $9d936a2aecb96285$export$d4214b4977c811ed);
/* eslint-disable @typescript-eslint/no-explicit-any */ // MicroMconfig is defined in local.js, used in index.HTML. this allows to be changed after compiled
const $9d936a2aecb96285$var$origin = window.location.origin;
const $9d936a2aecb96285$var$isLocalhost = $9d936a2aecb96285$var$origin.startsWith('http://localhost') || $9d936a2aecb96285$var$origin.startsWith('https://localhost');
const $9d936a2aecb96285$var$config = $9d936a2aecb96285$var$isLocalhost ? window.MicroMconfig.localhost : window.MicroMconfig.production;
const $9d936a2aecb96285$export$923ea8233b386e99 = `${$9d936a2aecb96285$var$config.ORIGIN}${$9d936a2aecb96285$var$config.API_PREFIX}`;
const $9d936a2aecb96285$export$d76071d5de2774fc = $9d936a2aecb96285$var$config.APP_ID;
const $9d936a2aecb96285$export$d4214b4977c811ed = $9d936a2aecb96285$var$config.GOOGLE_MAPS_API_KEY;

});

parcelRegister("a99Vi", function(module, exports) {

$parcel$export(module.exports, "Translate", () => $113918be25718027$export$9db2ba50894db2b9);

var $49qEn = parcelRequire("49qEn");
function $113918be25718027$export$9db2ba50894db2b9() {
    const dgLabels = {
        addLabel: "Agregar",
        editLabel: "Editar",
        deleteLabel: "Eliminar",
        viewLabel: "Ver",
        rowsReturnedLabel: "Cantidad de filas:",
        selectedRowsLabel: "filas seleccionadas.",
        limitLabel: "L\xedmite",
        rowsLabel: "filas",
        unlimitedLabel: "Ilimitado",
        AreYouSureLabel: "Est\xe1 seguro?",
        YouMustSelectOneOrMoreRecordsToExecuteAction: "Debe seleccionar uno o m\xe1s registros para ejecutar la acci\xf3n",
        closeLabel: "Cerrar",
        recordsLabel: "registros",
        warningLabel: "Advertencia",
        YouMustSelectOneOrMoreRecordsToDelete: "Debe seleccionar uno o m\xe1s registros a eliminar",
        YouWillDeleteLabel: "Usted va a eliminar",
        YouMustSelect: "Debe seleccionar",
        YouMustSelectAtLeast: "Debe seleccionar al menos",
        YouMustSelectBetween: "Debe seleccionar entre",
        YouMustSelectMaximum: "Debe seleccionar un m\xe1ximo de",
        recordLabel: "registro"
    };
    (0, $49qEn.DataGridDefaultProps).labels = dgLabels;
    (0, $49qEn.DataGridToolbarDefaultProps).searchPlaceholder = "Ingrese el texto a buscar";
    (0, $49qEn.DataGridToolbarDefaultProps).refreshTooltip = "Refrescar";
    (0, $49qEn.DataGridToolbarDefaultProps).exportTooltip = "Exportar Excel";
    (0, $49qEn.DataGridToolbarDefaultProps).selectRowsTooltip = "Seleccionar \xedtems";
    (0, $49qEn.DataGridToolbarDefaultProps).importTooltip = "Importar datos de archivo CSV";
    (0, $49qEn.LoginDefaultProps).forgotLabel = "Olvid\xf3 su contrase\xf1a?";
    (0, $49qEn.LoginDefaultProps).loginErrorMessage = "Usuario o contrase\xf1a inv\xe1lidos";
    (0, $49qEn.LoginDefaultProps).passwordLabel = "Clave";
    (0, $49qEn.LoginDefaultProps).passwordPlaceholder = "Su contrase\xf1a";
    (0, $49qEn.LoginDefaultProps).rememberLabel = "Recordarme";
    (0, $49qEn.LoginDefaultProps).signInButtonLabel = "Iniciar sesi\xf3n";
    (0, $49qEn.LoginDefaultProps).userLabel = "Usuario";
    (0, $49qEn.LoginDefaultProps).userPlaceholder = "Nombre de usuario";
    (0, $49qEn.LoginDefaultProps).confirmRecoveryEmailTitle = "Email de recuperaci\xf3n";
    (0, $49qEn.LoginModalDefaultProps).title = "Iniciar sesi\xf3n";
    (0, $49qEn.EntityFormDefaultProps).CancelText = "Cancelar";
    (0, $49qEn.EntityFormDefaultProps).OKText = "Guardar";
    (0, $49qEn.EntityFormDefaultProps).CloseText = "Cerrar";
    (0, $49qEn.EntityFormDefaultProps).invalidFieldsLabel = "Algunos campos tienen valores inv\xe1lidos. Por favor revise el formulario";
    (0, $49qEn.ConfirmAndExecutePanelDefaultProps).cancelButtonText = "Cancelar";
    (0, $49qEn.UseFieldConfigurationDefaultProps).requiredMessage = "Dato requerido";
    (0, $49qEn.MicromUsersFormDefaultProps).disabledFalseLabel = "El usuario est\xe1 habilitado";
    (0, $49qEn.MicromUsersFormDefaultProps).disabledTrueLabel = "El usuario est\xe1 DESHABILITADO";
    (0, $49qEn.MicromUsersFormDefaultProps).lockedRemainingLabel = "El usuario est\xe1 bloqueado. Se desbloquear\xe1 autom\xe1ticamente en";
    (0, $49qEn.MicromUsersFormDefaultProps).userEnabledLabel = "Habilitado";
    (0, $49qEn.MicromUsersFormDefaultProps).userDisabledLabel = "DESHABILITADO";
    (0, $49qEn.MicromUsersFormDefaultProps).logonAttemptsStatusDescription = "El usuario registra intentos fallidos de inicio de sesi\xf3n";
    (0, $49qEn.MicromUsersFormDefaultProps).logonAttemptsStatusTitle = "Intentos de incio de sesi\xf3n fallidos";
    (0, $49qEn.MicromUsersFormDefaultProps).minutesLabel = "minutos";
    (0, $49qEn.MicromUsersFormDefaultProps).willUnlockInNextLogonLabel = "El per\xedodo de bloqueo autom\xe1tico ha finalizado. El usuario ser\xe1 desbloqueado en el pr\xf3ximo inicio de sesi\xf3n.";
    (0, $49qEn.MicromUsersFormDefaultProps).lockedTitleLabel = "El usuario est\xe1 bloqueado";
    (0, $49qEn.LookupSelectDefaultProps).editLabel = "Editar";
    (0, $49qEn.LookupSelectDefaultProps).requiredLabel = "Debe seleccionar un valor de la lista";
    (0, $49qEn.LookupDefaultProps).requiredLabel = "Debe seleccionar un valor de la lista";
    (0, $49qEn.UseLookupFormDefaultProps).selectLabel = "Seleccionar";
    (0, $49qEn.LookupFormDefaultProps).okLabel = "Seleccionar";
    (0, $49qEn.LookupFormDefaultProps).cancelLabel = "Cancelar";
    (0, $49qEn.LookupFormDefaultProps).helpMessage = "Seleccione un valor de la lista o ingrese un valor para buscar";
    (0, $49qEn.LookupDefaultProps).requiredLabel = "Debe seleccionar un valor de la lista";
    (0, $49qEn.CUITFieldDefaultProps).invalidMessage = "El CUIT/CUIL ingresado no es v\xe1lido";
    (0, $49qEn.EmailFieldDefaultProps).invalidMessage = "El Email ingresado no es v\xe1lido";
    (0, $49qEn.PhoneFieldDefaultProps).invalidMessage = "El n\xfamero telef\xf3nico ingresado no es v\xe1lido";
    (0, $49qEn.UrlFieldDefaultProps).invalidMessage = "La URL ingresada no es v\xe1lida";
    (0, $49qEn.FilesUploadFormDefaultProps).okLabel = "Finalizar";
    (0, $49qEn.FilesUploadFormDefaultProps).helpMessage = "Seleccione los archivos que desea adjuntar";
    (0, $49qEn.FileUploaderDefaultProps).AttachUpToText = "Adjuntar hasta";
    (0, $49qEn.FileUploaderDefaultProps).EachFileShouldNotExceedText = "Cada archivo no debe exceder";
    (0, $49qEn.FileUploaderDefaultProps).FilesText = "archivos";
    (0, $49qEn.FileUploaderDefaultProps).UploadText = "Arrastre archivos aqu\xed o haga clic para seleccionar";
    (0, $49qEn.FileUploaderDefaultProps).cancelLabel = "Cancelar";
    (0, $49qEn.MenuDefaultProps).searchLabel = "Buscar";
    (0, $49qEn.MenuPanelDefaultProps).searchLabel = "Buscar";
    (0, $49qEn.DataViewDefaultProps).labels = {
        ...dgLabels,
        resultLimitLabel: "Los resultados est\xe1n limitados a %s registros. Utilice un criterio de b\xfasqueda para reducir la cantidad de registros devueltos.",
        fetchingDataLabel: "Obteniendo datos...",
        loadMoreLabel: "Mostrar m\xe1s",
        noRecordsFoundLabel: "No se encontraron registros"
    };
    (0, $49qEn.DateInputFieldDefaultProps).valueFormat = "DD/MM/YYYY";
    (0, $49qEn.DateInputFieldDefaultProps).locale = "es";
    (0, $49qEn.DataMapDefaultDataGridProps).labels = {
        ...dgLabels
    };
    (0, $49qEn.DataMapDefaultProps).labels.mapTabLabel = "Mapa";
    (0, $49qEn.MicromUsersGroupsFormDefaultProps).groupTabLabel = "Perfil";
    (0, $49qEn.MicromUsersGroupsFormDefaultProps).menusTabLabel = "Permisos de men\xfa";
    (0, $49qEn.MicromUsersGroupsFormDefaultProps).membersTabLabel = "Miembros";
    (0, $49qEn.MicromUsersGroupsMenusEntityDefaultProps).title = "Permisos";
    (0, $49qEn.MicromUsersGroupsMenusEntityDefaultProps).helpText = "Acceso configurado a los menues del sistema";
    (0, $49qEn.MicromUsersGroupsMenusEnableMenusLabels).buttonLabel = "Permitir acceso";
    (0, $49qEn.MicromUsersGroupsMenusEnableMenusLabels).allowAccessToSelectedMenuItems = "Permitir acceso a los \xedtems seleccionados";
    (0, $49qEn.MicromUsersGroupsMenusEnableMenusLabels).areYouSure = "Est\xe1 permitiendo el acceso a los \xedtems de men\xfa seleccioandos. \xbfEst\xe1 seguro?";
    (0, $49qEn.MicromUsersGroupsMenusEnableMenusLabels).title = "Habilitar acceso";
    (0, $49qEn.MicromUsersGroupsMenusDisableMenusLabels).buttonLabel = "Denegar acceso";
    (0, $49qEn.MicromUsersGroupsMenusDisableMenusLabels).denyAccessToSelectedMenuItems = "Denegar acceso a los \xedtems seleccionados";
    (0, $49qEn.MicromUsersGroupsMenusDisableMenusLabels).areYouSure = "Est\xe1 denegando el acceso a los \xedtems de men\xfa seleccioandos. \xbfEst\xe1 seguro?";
    (0, $49qEn.MicromUsersGroupsMenusDisableMenusLabels).title = "Denegar acceso";
    (0, $49qEn.MicromUsersGroupsMenusColumnsOverridesLabelsDefaultProps).granted = "Permitido";
    (0, $49qEn.MicromUsersGroupsMenusColumnsOverridesLabelsDefaultProps).denied = "Denegado";
    (0, $49qEn.ImportEntityDataFormDefaultProps).importInfoLabel = "Importar un archivo CSV con datos para";
    (0, $49qEn.ImportEntityDataFormDefaultProps).csvInstructionsLabel = "El archivo CSV debe contener una cabecera con los nombres de columna indicados en 'Nombre de Columna':";
    (0, $49qEn.ImportEntityDataFormDefaultProps).columnHeaderLabel = "Nombre de columna";
    (0, $49qEn.ImportEntityDataFormDefaultProps).dataNameLabel = "Corresponde a";
    (0, $49qEn.ImportEntityDataFormDefaultProps).contentLabel = "Contenido";
    (0, $49qEn.ImportEntityDataFormDefaultProps).dataTypeLabel = "Tipo de dato";
    (0, $49qEn.ImportEntityDataFormDefaultProps).errorReadingFileLabel = "Error al leer el archivo";
    (0, $49qEn.ImportEntityDataFormDefaultProps).emptyCSVFileLabel = "El archivo CSV est\xe1 vac\xedo";
    (0, $49qEn.ImportEntityDataFormDefaultProps).missingColumnsLabel = "Columnas faltantes:";
    (0, $49qEn.ImportEntityDataFormDefaultProps).dateFormatLabel = "* Las fechas deben tener el formato AAAA-MM-DD";
    (0, $49qEn.ImportEntityDataFormDefaultProps).numberFormatLabel = "* Los n\xfameros con decimales deben usar '.' como separador";
    (0, $49qEn.ImportEntityDataFormDefaultProps).downloadSampleLabel = "Descargar un CSV de muestra";
    (0, $49qEn.ImportEntityDataFormDefaultProps).importButtonLabel = "Importar";
    (0, $49qEn.ImportEntityDataFormDefaultProps).importHelpAndInstructionsLabel = "Ayuda e Instrucciones";
    (0, $49qEn.ImportEntityDataFormDefaultProps).recordsImportedSusccessfullyLabel = "Registros importados con \xe9xito";
    (0, $49qEn.ImportEntityDataFormDefaultProps).recordsNotImportedDueToErrorsLabel = "Registros no importados debido a errores";
    (0, $49qEn.ImportEntityDataFormDefaultProps).importTheCSVFileLabel = "Importe el archivo CSV haciendo click o arrastrando el archivo, luego haga clic en";
    (0, $49qEn.ImportEntityDataFormDefaultProps).importedFileLabel = "Archivo importado:";
    (0, $49qEn.ImportEntityDataLabels).Title = "Importar datos";
    (0, $49qEn.ImportEntityDataLabels).HelpText = "Importar un archivo .CSV con datos para esta entidad";
    (0, $49qEn.EmailServiceConfigurationFormDefaultProps).recoveryTABLabel = "Recuperaci\xf3n de contrase\xf1a";
    (0, $49qEn.EmailServiceConfigurationFormDefaultProps).settingsTABLabel = "Configuraci\xf3n de email";
    (0, $49qEn.EmailServiceConfigurationFormDefaultProps).setDefaultMessageButtonLabel = "Establecer mensaje por defecto";
    (0, $49qEn.RecoverPasswordDefaultProps).changedSuccessfullyMessage = "La contrase\xf1a ha sido cambiada exitosamente";
    (0, $49qEn.RecoverPasswordDefaultProps).changeErrorMessage = "Error al cambiar la contrase\xf1a";
    (0, $49qEn.RecoverPasswordDefaultProps).changePasswordLabel = "Cambiar contrase\xf1a";
    (0, $49qEn.RecoverPasswordDefaultProps).passwordLabel = "Nueva contrase\xf1a";
    (0, $49qEn.RecoverPasswordDefaultProps).signInButtonLabel = "Iniciar sesi\xf3n";
    (0, $49qEn.RecoverPasswordDefaultProps).userLabel = "Usuario";
    (0, $49qEn.RecoverPasswordDefaultProps).userPlaceholder = "Nombre de usuario";
    (0, $49qEn.RecoverPasswordDefaultProps).passwordPlaceholder = "Su nueva contrase\xf1a";
    (0, $49qEn.RecoverPasswordEmailDefaultProps).emailSendErrorMessage = "Error al enviar el email";
    (0, $49qEn.RecoverPasswordEmailDefaultProps).emailSentSuccessfullyMessage = "Email enviado exitosamente";
    (0, $49qEn.RecoverPasswordEmailDefaultProps).goBackToHomePageLabel = "Volver a la p\xe1gina de inicio";
    (0, $49qEn.RecoverPasswordEmailDefaultProps).sendRecoveryEmailLabel = "Enviar email de recuperaci\xf3n";
    (0, $49qEn.RecoverPasswordEmailDefaultProps).userLabel = "Usuario";
    (0, $49qEn.RecoverPasswordEmailDefaultProps).userPlaceholder = "Nombre de usuario";
    (0, $49qEn.AlertSuccessDefaultProps).title = "\xc9xito";
}

});


//# sourceMappingURL=html.00bc7041.js.map
